var a7 = Object.defineProperty;
var BR = (i) => {
  throw TypeError(i);
};
var o7 = (i, t, e) => t in i ? a7(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e;
var S = (i, t, e) => o7(i, typeof t != "symbol" ? t + "" : t, e), Tx = (i, t, e) => t.has(i) || BR("Cannot " + e);
var w = (i, t, e) => (Tx(i, t, "read from private field"), e ? e.call(i) : t.get(i)), pt = (i, t, e) => t.has(i) ? BR("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(i) : t.set(i, e), rt = (i, t, e, n) => (Tx(i, t, "write to private field"), n ? n.call(i, e) : t.set(i, e), e), ft = (i, t, e) => (Tx(i, t, "access private method"), e);
var Ks = (i, t, e, n) => ({
  set _(s) {
    rt(i, t, s, e);
  },
  get _() {
    return w(i, t, n);
  }
});
import { vec3 as I, mat3 as gi, mat4 as ut, glMatrix as l7, quat as ps, vec4 as zn, vec2 as Fi } from "gl-matrix";
import { createApp as c7, customRef as u7, onUnmounted as wg, defineComponent as Ne, toRefs as Vo, ref as Lt, watch as gn, onMounted as xn, computed as te, createElementBlock as Ot, openBlock as Mt, createCommentVNode as Qt, normalizeStyle as xe, renderSlot as Jh, useCssVars as x0, withDirectives as as, createBlock as le, unref as K, withCtx as oe, createElementVNode as kt, toDisplayString as pe, vShow as Ss, createVNode as Pt, withModifiers as o0, Fragment as Me, renderList as Xn, createTextVNode as Ws, h as wG, onBeforeMount as d7, getCurrentInstance as l0, reactive as Oh, nextTick as dg, normalizeClass as Rn, inject as gr, shallowRef as gb, Text as h7, onBeforeUnmount as yr, createSlots as p7, mergeModels as rl, useModel as zr, toRaw as ge, resolveDynamicComponent as m7, mergeProps as HM, resolveComponent as tr, isRef as b7, watchEffect as nW, vModelText as f7, toRef as g7, markRaw as y7, provide as i3, resolveDirective as Z7, withKeys as T7 } from "vue";
import { AssetPluginConfiguration as M7, useResizeObserver as s3, useMouseDrag as Ga, MIcon as Vb, useAssets as jl, MUButton as ye, MUInput as r3, MUDropdown as Fd, useOnClickOutside as N7, MContainer as Te, MContainerRow as hg, MSlider as zo, MFSwitch as W7, translation as Kl, devLogger as nn, useServerApi as PX, isMeshFileFormat as p0, MChooseFolderButton as G7, MUploadFileButton as a3, MUploadDropArea as w7, convertFileSizeToMb as x7, MContainerGrow as S7, getStringBeforeFirstSlash as L7, labelAlreadyExists as V7, getKeyPrefix as KR, parseGenericObjectsToTree3 as X7, countLabelOccurrences as I7, ImageList as C7, MDialogConfirmButtonRedesign as JX, MDialogCancelButtonRedesign as WT, isIOSDevice as o3, MUErrorModal as Y7, MUSelectModal as HR, extractSuffixes as v7, useNavbar as R7, ButtonEnum as K0, AppLanguage as Bn, useModals as D7, InjectPlugin as O7, TVersionTypes as _R, meshFormatsArray as z7, formatDateToLocale as $y, formatTimeToLocale as FS, NotificationType as c0, replaceSuffixInURL as E7, queryClient as k7, MDialogFooter as F7, useAuth as j7, isUserWeblinkReadOnlyOperator as U7, WeblinkUploadInvalidComponent as P7, info as J7 } from "@xlabmedical/medic-web-framework";
import qg from "primevue/button";
import xG from "primevue/contextmenu";
import A7 from "primevue/tooltip";
import l3 from "primevue/config";
import B7 from "primevue/tree";
import { v4 as nl } from "uuid";
import { ResponseStatusEnum as QR, NotificationChannelType as K7 } from "@xlabmedical/medic-api";
import Ku from "primevue/select";
import { useDialog as AX } from "primevue/usedialog";
import { useThrottleFn as $R } from "@vueuse/core";
import H7 from "primevue/dataview";
function Us(i, t) {
  for (var e = 0; e < t.length; e++) {
    const n = t[e];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const s in n)
        if (s !== "default" && !(s in i)) {
          const r = Object.getOwnPropertyDescriptor(n, s);
          r && Object.defineProperty(i, s, r.get ? r : {
            enumerable: !0,
            get: () => n[s]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }));
}
function _7(i) {
  return i === !0 || i === 1 || typeof i == "string" && ["true", "1"].includes(i.trim().toLowerCase());
}
function c3(i, t) {
  return _7(t) ? -Math.abs(i) : i;
}
function jS(i, t) {
  return c3(i.dHexagon, !t || i.cylinderShape) / 2;
}
var Q7 = Object.defineProperty, u3 = (i) => {
  throw TypeError(i);
}, $7 = (i, t, e) => t in i ? Q7(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e, hr = (i, t, e) => $7(i, typeof t != "symbol" ? t + "" : t, e), d3 = (i, t, e) => t.has(i) || u3("Cannot " + e), J = (i, t, e) => (d3(i, t, "read from private field"), e ? e.call(i) : t.get(i)), Fe = (i, t, e) => t.has(i) ? u3("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(i) : t.set(i, e), qn = (i, t, e, n) => (d3(i, t, "write to private field"), t.set(i, e), e), D1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function q7(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
function t8(i) {
  if (i.__esModule) return i;
  var t = i.default;
  if (typeof t == "function") {
    var e = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    e.prototype = t.prototype;
  } else e = {};
  return Object.defineProperty(e, "__esModule", { value: !0 }), Object.keys(i).forEach(function(n) {
    var s = Object.getOwnPropertyDescriptor(i, n);
    Object.defineProperty(e, n, s.get ? s : {
      enumerable: !0,
      get: function() {
        return i[n];
      }
    });
  }), e;
}
var h3 = { exports: {} };
const e8 = {}, n8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: e8
}, Symbol.toStringTag, { value: "Module" })), ty = /* @__PURE__ */ t8(n8);
(function(i, t) {
  var e, n, s, r = (() => {
    var l, c = typeof document < "u" ? (l = document.currentScript) == null ? void 0 : l.src : void 0;
    return async function(u = {}) {
      var d, h, p, m = u, b = typeof window == "object", y = typeof WorkerGlobalScope < "u", Z = typeof process == "object" && ((d = process.versions) == null ? void 0 : d.node) && process.type != "renderer", g = y && ((h = self.name) == null ? void 0 : h.startsWith("em-pthread"));
      if (Z) {
        var f = ty;
        D1.Worker = f.Worker, g = (y = !f.Uf) && f.workerData == "em-pthread";
      }
      var T = "./this.program", M = (G, L) => {
        throw L;
      };
      typeof __filename < "u" ? c = __filename : y && (c = self.location.href);
      var N = "", W, x;
      if (Z) {
        var V = ty;
        N = __dirname + "/", x = (G) => (G = A(G) ? new URL(G) : G, V.readFileSync(G)), W = async (G) => (G = A(G) ? new URL(G) : G, V.readFileSync(G, void 0)), 1 < process.argv.length && (T = process.argv[1].replace(/\\/g, "/")), process.argv.slice(2), M = (G, L) => {
          throw process.exitCode = G, L;
        };
      } else if (b || y) {
        try {
          N = new URL(".", c).href;
        } catch {
        }
        Z || (y && (x = (G) => {
          var L = new XMLHttpRequest();
          return L.open("GET", G, !1), L.responseType = "arraybuffer", L.send(null), new Uint8Array(L.response);
        }), W = async (G) => {
          if (A(G)) return new Promise((v, O) => {
            var U = new XMLHttpRequest();
            U.open("GET", G, !0), U.responseType = "arraybuffer", U.onload = () => {
              U.status == 200 || U.status == 0 && U.response ? v(U.response) : O(U.status);
            }, U.onerror = O, U.send(null);
          });
          var L = await fetch(G, { credentials: "same-origin" });
          if (L.ok) return L.arrayBuffer();
          throw Error(L.status + " : " + L.url);
        });
      }
      var X = console.log.bind(console), C = console.error.bind(console);
      if (Z) {
        var R = ty, z = (G) => typeof G == "object" ? R.inspect(G) : G;
        X = (...G) => V.writeSync(1, G.map(z).join(" ") + `
`), C = (...G) => V.writeSync(2, G.map(z).join(" ") + `
`);
      }
      var F = X, P = C, j, H, B = !1, $, A = (G) => G.startsWith("file://");
      function E() {
        Zt.buffer != Gt.buffer && mt();
      }
      var ct, at;
      if (Z && g) {
        var dt = f.parentPort;
        dt.on("message", (G) => {
          var L;
          return (L = D1.onmessage) == null ? void 0 : L.call(D1, { data: G });
        }), Object.assign(globalThis, { self: D1, postMessage: (G) => dt.postMessage(G) }), process.on("uncaughtException", (G) => {
          postMessage({ fa: "uncaughtException", error: G }), process.exit(1);
        });
      }
      var gt;
      if (g) {
        var Wt = !1;
        self.onunhandledrejection = (L) => {
          throw L.reason || L;
        };
        async function G(L) {
          try {
            var v = L.data, O = v.fa;
            if (O === "load") {
              let U = [];
              self.onmessage = (Y) => U.push(Y), gt = () => {
                postMessage({ fa: "loaded" });
                for (let Y of U) G(Y);
                self.onmessage = G;
              };
              for (const Y of v.ce) (!m[Y] || m[Y].proxy) && (m[Y] = (...k) => {
                postMessage({ fa: "callHandler", be: Y, args: k });
              }, Y == "print" && (F = m[Y]), Y == "printErr" && (P = m[Y]));
              Zt = v.Ze, mt(), H = v.$e, yt(), C1();
            } else if (O === "run") {
              E4(v.$), gx(v.$, 0, 0, 1, 0, 0), rn(), Fw(v.$), Wt || (OR(), Wt = !0);
              try {
                await k4(
                  v.Se,
                  v.gb
                );
              } catch (U) {
                if (U != "unwind") throw U;
              }
            } else v.target !== "setimmediate" && (O === "checkMailbox" ? Wt && y1() : O && (P(`worker: received unknown command ${O}`), P(v)));
          } catch (U) {
            throw ER(), U;
          }
        }
        self.onmessage = G;
      }
      var Zt, Gt, Tt, Q, D, q, nt, et, ot, it, ht, lt = !1;
      function mt() {
        var G = Zt.buffer;
        Gt = new Int8Array(G), Q = new Int16Array(G), m.HEAPU8 = Tt = new Uint8Array(G), D = new Uint16Array(G), q = new Int32Array(G), nt = new Uint32Array(G), et = new Float32Array(G), ot = new Float64Array(G), it = new BigInt64Array(G), ht = new BigUint64Array(G);
      }
      function wt() {
        lt = !0, g ? gt() : (m.noFSInit || It.Ob || It.Ia(), Zs.root = It.B(Zs, {}, null), Jl.__wasm_call_ctors(), It.Gc = !1);
      }
      function Xt(G) {
        var L;
        throw (L = m.onAbort) == null || L.call(m, G), G = "Aborted(" + G + ")", P(G), B = !0, G += ". Build with -sASSERTIONS for more info.", lt && UR(), G = new WebAssembly.RuntimeError(G), at == null || at(G), G;
      }
      var At;
      async function he(G) {
        if (!j) try {
          var L = await W(G);
          return new Uint8Array(L);
        } catch {
        }
        if (G == At && j) G = new Uint8Array(j);
        else if (x) G = x(G);
        else throw "both async and sync fetching of the wasm failed";
        return G;
      }
      async function ue(G, L) {
        try {
          var v = await he(G);
          return await WebAssembly.instantiate(v, L);
        } catch (O) {
          P(`failed to asynchronously prepare wasm: ${O}`), Xt(O);
        }
      }
      async function Dt(G) {
        var L = At;
        if (!j && !A(L) && !Z) try {
          var v = fetch(L, { credentials: "same-origin" });
          return await WebAssembly.instantiateStreaming(v, G);
        } catch (O) {
          P(`wasm streaming compile failed: ${O}`), P("falling back to ArrayBuffer instantiation");
        }
        return ue(L, G);
      }
      function ee() {
        if (B0 = {
          HaveOffsetConverter: s7,
          __assert_fail: F4,
          __call_sighandler: j4,
          __pthread_create_js: MY,
          __syscall_chdir: vY,
          __syscall_chmod: RY,
          __syscall_dup: DY,
          __syscall_dup3: OY,
          __syscall_faccessat: zY,
          __syscall_fchdir: EY,
          __syscall_fchmod: kY,
          __syscall_fchmodat2: FY,
          __syscall_fchown32: jY,
          __syscall_fchownat: UY,
          __syscall_fcntl64: PY,
          __syscall_fstat64: JY,
          __syscall_ftruncate64: AY,
          __syscall_getcwd: BY,
          __syscall_getdents64: KY,
          __syscall_ioctl: HY,
          __syscall_lstat64: _Y,
          __syscall_mkdirat: QY,
          __syscall_mknodat: $Y,
          __syscall_newfstatat: qY,
          __syscall_openat: tv,
          __syscall_pipe: ev,
          __syscall_poll: nv,
          __syscall_readlinkat: iv,
          __syscall_renameat: sv,
          __syscall_rmdir: rv,
          __syscall_stat64: av,
          __syscall_symlinkat: ov,
          __syscall_truncate64: lv,
          __syscall_unlinkat: cv,
          __syscall_utimensat: dv,
          _abort_js: q4,
          _embind_create_inheriting_constructor: nH,
          _embind_finalize_value_array: iH,
          _embind_register_bigint: rH,
          _embind_register_bool: aH,
          _embind_register_class: fH,
          _embind_register_class_class_function: gH,
          _embind_register_class_class_property: yH,
          _embind_register_class_constructor: ZH,
          _embind_register_class_function: TH,
          _embind_register_class_property: MH,
          _embind_register_emval: NH,
          _embind_register_enum: GH,
          _embind_register_enum_value: wH,
          _embind_register_float: SH,
          _embind_register_function: LH,
          _embind_register_integer: VH,
          _embind_register_memory_view: XH,
          _embind_register_optional: CH,
          _embind_register_smart_ptr: YH,
          _embind_register_std_string: vH,
          _embind_register_std_wstring: FH,
          _embind_register_value_array: jH,
          _embind_register_value_array_element: UH,
          _embind_register_void: PH,
          _emscripten_init_main_thread_js: JH,
          _emscripten_log_formatted: AH,
          _emscripten_notify_mailbox_postmessage: BH,
          _emscripten_receive_on_main_thread_js: KH,
          _emscripten_runtime_keepalive_clear: HH,
          _emscripten_thread_cleanup: _H,
          _emscripten_thread_mailbox_await: Fw,
          _emscripten_thread_set_strongref: QH,
          _emval_create_invoker: n_,
          _emval_decref: kw,
          _emval_equals: i_,
          _emval_get_global: s_,
          _emval_get_module_property: r_,
          _emval_get_property: a_,
          _emval_incref: o_,
          _emval_instanceof: l_,
          _emval_invoke: Gv,
          _emval_invoke_i64: Gv,
          _emval_is_number: c_,
          _emval_is_string: u_,
          _emval_new_array: d_,
          _emval_new_cstring: h_,
          _emval_new_object: p_,
          _emval_run_destructors: m_,
          _emval_set_property: b_,
          _emval_typeof: f_,
          _gmtime_js: g_,
          _localtime_js: y_,
          _mktime_js: Z_,
          _mmap_js: Lv,
          _munmap_js: Vv,
          _tzset_js: T_,
          clock_time_get: W_,
          emscripten_asm_const_int: G_,
          emscripten_async_call: x_,
          emscripten_check_blocking_allowed: S_,
          emscripten_console_trace: L_,
          emscripten_date_now: N_,
          emscripten_err: V_,
          emscripten_errn: X_,
          emscripten_exit_with_live_runtime: I_,
          emscripten_force_exit: zv,
          emscripten_get_element_css_size: kv,
          emscripten_get_heap_max: C_,
          emscripten_get_now: M_,
          emscripten_idb_async_delete: z_,
          emscripten_idb_async_exists: E_,
          emscripten_idb_async_load: k_,
          emscripten_idb_async_store: F_,
          emscripten_is_webgl_context_lost: K_,
          emscripten_num_logical_cores: H_,
          emscripten_pause_main_loop: __,
          emscripten_pc_get_function: V1,
          emscripten_performance_now: $_,
          emscripten_resize_heap: q_,
          emscripten_resume_main_loop: tQ,
          emscripten_set_focus_callback_on_thread: Bv,
          emscripten_set_keydown_callback_on_thread: Hv,
          emscripten_set_keyup_callback_on_thread: _v,
          emscripten_set_main_loop_arg: nQ,
          emscripten_set_mousedown_callback_on_thread: Qv,
          emscripten_set_mousemove_callback_on_thread: $v,
          emscripten_set_mouseup_callback_on_thread: qv,
          emscripten_set_resize_callback_on_thread: tR,
          emscripten_set_touchcancel_callback_on_thread: eR,
          emscripten_set_touchend_callback_on_thread: nR,
          emscripten_set_touchmove_callback_on_thread: iR,
          emscripten_set_touchstart_callback_on_thread: sR,
          emscripten_set_wheel_callback_on_thread: rR,
          emscripten_sleep: aR,
          emscripten_stack_snapshot: Q_,
          emscripten_stack_unwind_buffer: rQ,
          emscripten_unwind_to_js_event_loop: aQ,
          emscripten_webgl_create_context: lQ,
          emscripten_webgl_destroy_context: cQ,
          emscripten_webgl_make_context_current: uQ,
          environ_get: lR,
          environ_sizes_get: cR,
          exit: je,
          fd_close: uR,
          fd_fdstat_get: dR,
          fd_read: hR,
          fd_seek: pR,
          fd_sync: sx,
          fd_write: mR,
          glActiveTexture: rx,
          glBindTexture: dQ,
          glBlendFunc: hQ,
          glClear: pQ,
          glClearColor: mQ,
          glClearDepth: bQ,
          glClearStencil: fQ,
          glColorMask: gQ,
          glCompressedTexImage2D: yQ,
          glCompressedTexSubImage2D: ZQ,
          glCopyTexImage2D: TQ,
          glCullFace: MQ,
          glDeleteTextures: NQ,
          glDepthFunc: WQ,
          glDepthMask: GQ,
          glDisable: Kg,
          glDrawArrays: wQ,
          glDrawBuffer: xQ,
          glDrawElements: SQ,
          glEnable: Hg,
          glFinish: LQ,
          glFlush: VQ,
          glGenTextures: XQ,
          glGenerateMipmap: IQ,
          glGetBooleanv: ox,
          glGetError: CQ,
          glGetFloatv: lx,
          glGetIntegerv: _g,
          glGetString: cx,
          glIsEnabled: bR,
          glLineWidth: vQ,
          glPixelStorei: RQ,
          glPointSize: DQ,
          glReadBuffer: OQ,
          glReadPixels: zQ,
          glScissor: EQ,
          glStencilFunc: kQ,
          glStencilMask: FQ,
          glStencilOp: jQ,
          glTexImage2D: UQ,
          glTexParameterf: PQ,
          glTexParameterfv: JQ,
          glTexParameteri: AQ,
          glTexSubImage2D: BQ,
          glViewport: KQ,
          memory: Zt,
          proc_exit: Ge,
          random_get: HQ
        }, !B0.Bd) {
          B0.Bd = !0;
          var G = B0, L = /^(invoke_.*|__asyncjs__.*)$/;
          for (let [v, O] of Object.entries(G)) typeof O == "function" && (O.Hc || L.test(v)) && (G[v] = O = new WebAssembly.Suspending(O));
        }
        return { env: B0, wasi_snapshot_preview1: B0 };
      }
      async function yt() {
        function G(O, U) {
          O = Jl = O.exports;
          var Y = /^(main|__main_argc_argv)$/;
          I1 = /* @__PURE__ */ new Set();
          var k = {};
          for (let [_, st] of Object.entries(O)) typeof st == "function" ? (Y.test(_) && (I1.add(st), st = WebAssembly.promising(st)), k[_] = _Q(st)) : k[_] = st;
          return Jl = k, Jl = r7(), Ls.push(Jl._emscripten_tls_init), gY = Jl.__indirect_function_table, H = U, U = Jl, DR = U.__getTypeName, OR = U._embind_initialize_bindings, $g = U.pthread_self, m.__ZdaPv = U._ZdaPv, m.__ZdlPvm = U._ZdlPvm, m.__Znam = U._Znam, m.__Znwm = U._Znwm, As = U.malloc, ll = U.free, m.__ZdlPv = U._ZdlPv, m.__ZdaPvm = U._ZdaPvm, m.__ZnwmSt11align_val_t = U._ZnwmSt11align_val_t, m._emscripten_builtin_free = U.emscripten_builtin_free, zR = U.emscripten_builtin_memalign, bp = U._emscripten_run_callback_on_thread, m._emscripten_builtin_malloc = U.emscripten_builtin_malloc, m.___libc_free = U.__libc_free, m.___libc_malloc = U.__libc_malloc, gx = U._emscripten_thread_init, ER = U._emscripten_thread_crashed, kR = U._emscripten_run_js_on_main_thread, FR = U._emscripten_thread_free_data, yx = U._emscripten_thread_exit, m._strndup = U.strndup, jR = U._emscripten_check_mailbox, m.__ZnamSt11align_val_t = U._ZnamSt11align_val_t, m.___libc_calloc = U.__libc_calloc, m.___libc_realloc = U.__libc_realloc, m._emscripten_builtin_calloc = U.emscripten_builtin_calloc, m._emscripten_builtin_realloc = U.emscripten_builtin_realloc, m._malloc_size = U.malloc_size, m._malloc_usable_size = U.malloc_usable_size, m._reallocf = U.reallocf, UR = U.__trap, PR = U.emscripten_stack_set_limits, Zx = U._emscripten_stack_restore, JR = U._emscripten_stack_alloc, AR = U.emscripten_stack_get_current, Jl;
        }
        var L = ee();
        if (m.instantiateWasm) return new Promise((O) => {
          m.instantiateWasm(L, (U, Y) => {
            O(G(U, Y));
          });
        });
        if (g) {
          var v = new WebAssembly.Instance(H, ee());
          return G(v, H);
        }
        return At ?? (At = m.locateFile ? m.locateFile("WCE.0.4.85.2fd80a1cce37.wasm", N) : N + "WCE.0.4.85.2fd80a1cce37.wasm"), (function(O) {
          return G(O.instance, O.module);
        })(await Dt(L));
      }
      class fe {
        constructor(L) {
          hr(this, "name", "ExitStatus"), this.message = `Program terminated with exit(${L})`, this.status = L;
        }
      }
      var Xe = (G) => {
        G.terminate(), G.onmessage = () => {
        };
      }, Se = (G) => {
        for (; 0 < G.length; ) G.shift()(m);
      }, Vt = [], Rt = 0, $t = null, zt = () => {
        var G;
        if (Rt--, (G = m.monitorRunDependencies) == null || G.call(m, Rt), Rt == 0 && $t) {
          var L = $t;
          $t = null, L();
        }
      }, Bt = () => {
        var G;
        Rt++, (G = m.monitorRunDependencies) == null || G.call(m, Rt);
      }, Kt = (G) => {
        we.length == 0 && (e1(), Fr(we[0]));
        var L = we.pop();
        if (!L) return 6;
        ln.push(L), ys[G.$] = L, L.$ = G.$;
        var v = { fa: "run", Se: G.Re, gb: G.gb, $: G.$ };
        return Z && L.unref(), L.postMessage(v, G.qd), 0;
      }, ne = 0, ae = (G, L, ...v) => {
        for (var O = 2 * v.length, U = AR(), Y = JR(8 * O), k = Y / 8, _ = 0; _ < v.length; _++) {
          var st = v[_];
          typeof st == "bigint" ? ((E(), it)[k + 2 * _] = 1n, (E(), it)[k + 2 * _ + 1] = st) : ((E(), it)[k + 2 * _] = 0n, (E(), ot)[k + 2 * _ + 1] = st);
        }
        return G = kR(G, 0, O, Y, L), Zx(U), G;
      };
      function Ge(G) {
        var L;
        if (g) return ae(0, 1, G);
        if ($ = G, !(cp || 0 < ne)) {
          for (var v of ln) Xe(v);
          for (v of we) Xe(v);
          we = [], ln = [], ys = {}, (L = m.onExit) == null || L.call(m, G), B = !0;
        }
        M(G, new fe(G));
      }
      function He(G) {
        if (g) return ae(1, 0, G);
        je(G);
      }
      var je = (G) => {
        if ($ = G, g) throw He(G), "unwind";
        Ge(G);
      }, we = [], ln = [], Ls = [], ys = {};
      function re() {
        for (var G = 2 * navigator.hardwareConcurrency + 1; G--; ) e1();
        Vt.push(async () => {
          var L = Og();
          Bt(), await L, zt();
        });
      }
      var be = (G) => {
        var L = G.$;
        delete ys[L], we.push(G), ln.splice(ln.indexOf(G), 1), G.$ = 0, FR(L);
      };
      function rn() {
        Ls.forEach((G) => G());
      }
      var Fr = (G) => new Promise((L) => {
        G.onmessage = (Y) => {
          var k = Y.data;
          if (Y = k.fa, k.wb && k.wb != $g()) {
            var _ = ys[k.wb];
            _ ? _.postMessage(k, k.qd) : P(`Internal error! Worker sent a message "${Y}" to target pthread ${k.wb}, but that thread no longer exists!`);
          } else Y === "checkMailbox" ? y1() : Y === "spawnThread" ? Kt(k) : Y === "cleanupThread" ? Kc(() => {
            be(ys[k.We]);
          }) : Y === "loaded" ? (G.loaded = !0, Z && !G.$ && G.unref(), L(G)) : k.target === "setimmediate" ? G.postMessage(k) : Y === "uncaughtException" ? G.onerror(k.error) : Y === "callHandler" ? m[k.be](...k.args) : Y && P(`worker sent an unknown command ${Y}`);
        }, G.onerror = (Y) => {
          throw P(`worker sent an error! ${Y.filename}:${Y.lineno}: ${Y.message}`), Y;
        }, Z && (G.on("message", (Y) => G.onmessage({ data: Y })), G.on("error", (Y) => G.onerror(Y)));
        var v = [], O = ["onExit", "onAbort", "print", "printErr"], U;
        for (U of O) m.propertyIsEnumerable(U) && v.push(U);
        G.postMessage({ fa: "load", ce: v, Ze: Zt, $e: H });
      });
      async function Og() {
        if (!g) return Promise.all(we.map(Fr));
      }
      function e1() {
        var G = c;
        m.mainScriptUrlOrBlob && (G = m.mainScriptUrlOrBlob, typeof G != "string" && (G = URL.createObjectURL(G))), G = new Worker(G, { workerData: "em-pthread", name: "em-pthread" }), we.push(G);
      }
      var Zw, fY = [];
      function E4(G) {
        var L = Number((E(), ht)[(G + 88) / 8]);
        G = Number((E(), ht)[(G + 96) / 8]), PR(L, L - G), Zx(L);
      }
      var Tw = [], gY, Vs = (G) => {
        G = Number(G);
        var L = Tw[G];
        return L || (Tw[G] = L = gY.get(BigInt(G)), I1 != null && I1.has(L) && (Tw[G] = L = WebAssembly.promising(L))), L;
      }, k4 = async (G, L) => {
        cp = ne = 0, L = ((v) => WebAssembly.promising(Vs(G)).call(null, BigInt(v)))(L), L = await L, (function(v) {
          cp || 0 < ne ? $ = v : yx(v);
        })(L);
      }, cp = !0, xt = (G) => -9007199254740992 > G || 9007199254740992 < G ? NaN : Number(G), yY = typeof TextDecoder < "u" ? new TextDecoder() : void 0, ZY = (G, L, v, O) => {
        if (v = L + v, O) return v;
        for (; G[L] && !(L >= v); ) ++L;
        return L;
      }, R0 = (G, L = 0, v, O) => {
        if (v = ZY(G, L, v, O), 16 < v - L && G.buffer && yY) return yY.decode(G.buffer instanceof ArrayBuffer ? G.subarray(L, v) : G.slice(L, v));
        for (O = ""; L < v; ) {
          var U = G[L++];
          if (U & 128) {
            var Y = G[L++] & 63;
            if ((U & 224) == 192) O += String.fromCharCode((U & 31) << 6 | Y);
            else {
              var k = G[L++] & 63;
              U = (U & 240) == 224 ? (U & 15) << 12 | Y << 6 | k : (U & 7) << 18 | Y << 12 | k << 6 | G[L++] & 63, 65536 > U ? O += String.fromCharCode(U) : (U -= 65536, O += String.fromCharCode(55296 | U >> 10, 56320 | U & 1023));
            }
          } else O += String.fromCharCode(U);
        }
        return O;
      }, Sn = (G, L, v) => G ? R0((E(), Tt), G, L, v) : "";
      function F4(G, L, v, O) {
        return G = xt(G), L = xt(L), O = xt(O), Xt(`Assertion failed: ${Sn(G)}, at: ` + [L ? Sn(L) : "unknown filename", v, O ? Sn(O) : "unknown function"]);
      }
      function j4(G, L) {
        return G = xt(G), Vs(G)(L);
      }
      function TY(G, L, v, O) {
        return g ? ae(2, 1, G, L, v, O) : MY(G, L, v, O);
      }
      function MY(G, L, v, O) {
        if (G = xt(G), L = xt(L), v = xt(v), O = xt(O), typeof SharedArrayBuffer > "u") return 6;
        var U = [];
        return g && U.length === 0 ? TY(G, L, v, O) : (G = { Re: v, $: G, gb: O, qd: U }, g ? (G.fa = "spawnThread", postMessage(G, U), 0) : Kt(G));
      }
      var di = { Ja: (G) => G.charAt(0) === "/", Qe: (G) => /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/.exec(G).slice(1), Xc: (G, L) => {
        for (var v = 0, O = G.length - 1; 0 <= O; O--) {
          var U = G[O];
          U === "." ? G.splice(O, 1) : U === ".." ? (G.splice(O, 1), v++) : v && (G.splice(O, 1), v--);
        }
        if (L) for (; v; v--) G.unshift("..");
        return G;
      }, normalize: (G) => {
        var L = di.Ja(G), v = G.slice(-1) === "/";
        return (G = di.Xc(G.split("/").filter((O) => !!O), !L).join("/")) || L || (G = "."), G && v && (G += "/"), (L ? "/" : "") + G;
      }, dirname: (G) => {
        var L = di.Qe(G);
        return G = L[0], L = L[1], !G && !L ? "." : (L && (L = L.slice(0, -1)), G + L);
      }, basename: (G) => G && G.match(/([^\/]+|\/)\/*$/)[1], join: (...G) => di.normalize(G.join("/")), Ka: (G, L) => di.normalize(G + "/" + L) }, U4 = () => (G) => G.set(crypto.getRandomValues(new Uint8Array(G.byteLength))), Mw = (G) => {
        (Mw = U4())(G);
      }, n1 = (...G) => {
        for (var L = "", v = !1, O = G.length - 1; -1 <= O && !v; O--) {
          if (v = 0 <= O ? G[O] : It.cwd(), typeof v != "string") throw new TypeError("Arguments to path.resolve must be strings");
          if (!v) return "";
          L = v + "/" + L, v = di.Ja(v);
        }
        return L = di.Xc(L.split("/").filter((U) => !!U), !v).join("/"), (v ? "/" : "") + L || ".";
      }, NY = (G, L) => {
        function v(k) {
          for (var _ = 0; _ < k.length && k[_] === ""; _++) ;
          for (var st = k.length - 1; 0 <= st && k[st] === ""; st--) ;
          return _ > st ? [] : k.slice(_, st - _ + 1);
        }
        G = n1(G).slice(1), L = n1(L).slice(1), G = v(G.split("/")), L = v(L.split("/"));
        for (var O = Math.min(G.length, L.length), U = O, Y = 0; Y < O; Y++) if (G[Y] !== L[Y]) {
          U = Y;
          break;
        }
        for (O = [], Y = U; Y < G.length; Y++) O.push("..");
        return O = O.concat(L.slice(U)), O.join("/");
      }, Nw = [], D0 = (G) => {
        for (var L = 0, v = 0; v < G.length; ++v) {
          var O = G.charCodeAt(v);
          127 >= O ? L++ : 2047 >= O ? L += 2 : 55296 <= O && 57343 >= O ? (L += 4, ++v) : L += 3;
        }
        return L;
      }, WY = (G, L, v, O) => {
        if (!(0 < O)) return 0;
        var U = v;
        O = v + O - 1;
        for (var Y = 0; Y < G.length; ++Y) {
          var k = G.codePointAt(Y);
          if (127 >= k) {
            if (v >= O) break;
            L[v++] = k;
          } else if (2047 >= k) {
            if (v + 1 >= O) break;
            L[v++] = 192 | k >> 6, L[v++] = 128 | k & 63;
          } else if (65535 >= k) {
            if (v + 2 >= O) break;
            L[v++] = 224 | k >> 12, L[v++] = 128 | k >> 6 & 63, L[v++] = 128 | k & 63;
          } else {
            if (v + 3 >= O) break;
            L[v++] = 240 | k >> 18, L[v++] = 128 | k >> 12 & 63, L[v++] = 128 | k >> 6 & 63, L[v++] = 128 | k & 63, Y++;
          }
        }
        return L[v] = 0, v - U;
      }, Ww = (G) => {
        var L = Array(D0(G) + 1);
        return G = WY(G, L, 0, L.length), L.length = G, L;
      }, GY = [];
      function wY(G, L) {
        GY[G] = { input: [], output: [], na: L }, xw(G, P4);
      }
      var P4 = { open(G) {
        var L = GY[G.node.rdev];
        if (!L) throw new It.g(43);
        G.tty = L, G.seekable = !1;
      }, close(G) {
        G.tty.na.fsync(G.tty);
      }, fsync(G) {
        G.tty.na.fsync(G.tty);
      }, read(G, L, v, O) {
        if (!G.tty || !G.tty.na.Ec) throw new It.g(60);
        for (var U = 0, Y = 0; Y < O; Y++) {
          try {
            var k = G.tty.na.Ec(G.tty);
          } catch {
            throw new It.g(29);
          }
          if (k === void 0 && U === 0) throw new It.g(6);
          if (k == null) break;
          U++, L[v + Y] = k;
        }
        return U && (G.node.atime = Date.now()), U;
      }, write(G, L, v, O) {
        if (!G.tty || !G.tty.na.$b) throw new It.g(60);
        try {
          for (var U = 0; U < O; U++) G.tty.na.$b(
            G.tty,
            L[v + U]
          );
        } catch {
          throw new It.g(29);
        }
        return O && (G.node.mtime = G.node.ctime = Date.now()), U;
      } }, J4 = { Ec() {
        t: {
          if (!Nw.length) {
            var G = null;
            if (Z) {
              var L = Buffer.alloc(256), v = 0, O = process.stdin.fd;
              try {
                v = V.readSync(O, L, 0, 256);
              } catch (U) {
                if (U.toString().includes("EOF")) v = 0;
                else throw U;
              }
              0 < v && (G = L.slice(0, v).toString("utf-8"));
            } else typeof window < "u" && typeof window.prompt == "function" && (G = window.prompt("Input: "), G !== null && (G += `
`));
            if (!G) {
              G = null;
              break t;
            }
            Nw = Ww(G);
          }
          G = Nw.shift();
        }
        return G;
      }, $b(G, L) {
        L === null || L === 10 ? (F(R0(G.output)), G.output = []) : L != 0 && G.output.push(L);
      }, fsync(G) {
        var L;
        0 < ((L = G.output) == null ? void 0 : L.length) && (F(R0(G.output)), G.output = []);
      }, pe() {
        return { hf: 25856, kf: 5, gf: 191, jf: 35387, ff: [3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] };
      }, qe() {
        return 0;
      }, re() {
        return [24, 80];
      } }, A4 = { $b(G, L) {
        L === null || L === 10 ? (P(R0(G.output)), G.output = []) : L != 0 && G.output.push(L);
      }, fsync(G) {
        var L;
        0 < ((L = G.output) == null ? void 0 : L.length) && (P(R0(G.output)), G.output = []);
      } }, xY = (G) => {
        G = 65536 * Math.ceil(G / 65536);
        var L = zR(65536, G);
        return L && (E(), Tt).fill(0, L, L + G), L;
      }, mn = { ka: null, B() {
        return mn.createNode(null, "/", 16895, 0);
      }, createNode(G, L, v, O) {
        if ((v & 61440) === 24576 || It.isFIFO(v)) throw new It.g(63);
        return mn.ka || (mn.ka = { dir: { node: { W: mn.j.W, da: mn.j.da, lookup: mn.j.lookup, ia: mn.j.ia, rename: mn.j.rename, unlink: mn.j.unlink, rmdir: mn.j.rmdir, readdir: mn.j.readdir, symlink: mn.j.symlink }, stream: { M: mn.i.M } }, file: { node: { W: mn.j.W, da: mn.j.da }, stream: { M: mn.i.M, read: mn.i.read, write: mn.i.write, za: mn.i.za, La: mn.i.La } }, link: { node: { W: mn.j.W, da: mn.j.da, readlink: mn.j.readlink }, stream: {} }, uc: { node: { W: mn.j.W, da: mn.j.da }, stream: It.Ed } }), v = It.createNode(G, L, v, O), nr(v.mode) ? (v.j = mn.ka.dir.node, v.i = mn.ka.dir.stream, v.o = {}) : It.isFile(v.mode) ? (v.j = mn.ka.file.node, v.i = mn.ka.file.stream, v.I = 0, v.o = null) : (v.mode & 61440) === 40960 ? (v.j = mn.ka.link.node, v.i = mn.ka.link.stream) : (v.mode & 61440) === 8192 && (v.j = mn.ka.uc.node, v.i = mn.ka.uc.stream), v.atime = v.mtime = v.ctime = Date.now(), G && (G.o[L] = v, G.atime = G.mtime = G.ctime = v.atime), v;
      }, Mf(G) {
        return G.o ? G.o.subarray ? G.o.subarray(0, G.I) : new Uint8Array(G.o) : new Uint8Array(0);
      }, j: {
        W(G) {
          var L = {};
          return L.dev = (G.mode & 61440) === 8192 ? G.id : 1, L.ino = G.id, L.mode = G.mode, L.nlink = 1, L.uid = 0, L.gid = 0, L.rdev = G.rdev, nr(G.mode) ? L.size = 4096 : It.isFile(G.mode) ? L.size = G.I : L.size = (G.mode & 61440) === 40960 ? G.link.length : 0, L.atime = new Date(G.atime), L.mtime = new Date(G.mtime), L.ctime = new Date(G.ctime), L.blksize = 4096, L.blocks = Math.ceil(L.size / L.blksize), L;
        },
        da(G, L) {
          for (var v of ["mode", "atime", "mtime", "ctime"]) L[v] != null && (G[v] = L[v]);
          L.size !== void 0 && (L = L.size, G.I != L && (L == 0 ? (G.o = null, G.I = 0) : (v = G.o, G.o = new Uint8Array(L), v && G.o.set(v.subarray(0, Math.min(
            L,
            G.I
          ))), G.I = L)));
        },
        lookup() {
          throw mn.Cb || (mn.Cb = new It.g(44), mn.Cb.stack = "<generic error, no stack>"), mn.Cb;
        },
        ia(G, L, v, O) {
          return mn.createNode(G, L, v, O);
        },
        rename(G, L, v) {
          try {
            var O = Ul(L, v);
          } catch {
          }
          if (O) {
            if (nr(G.mode)) for (var U in O.o) throw new It.g(55);
            zg(O);
          }
          delete G.parent.o[G.name], L.o[v] = G, G.name = v, L.ctime = L.mtime = G.parent.ctime = G.parent.mtime = Date.now();
        },
        unlink(G, L) {
          delete G.o[L], G.ctime = G.mtime = Date.now();
        },
        rmdir(G, L) {
          var v = Ul(G, L), O;
          for (O in v.o) throw new It.g(55);
          delete G.o[L], G.ctime = G.mtime = Date.now();
        },
        readdir(G) {
          return [".", "..", ...Object.keys(G.o)];
        },
        symlink(G, L, v) {
          return G = mn.createNode(G, L, 41471, 0), G.link = v, G;
        },
        readlink(G) {
          if ((G.mode & 61440) !== 40960) throw new It.g(28);
          return G.link;
        }
      }, i: { read(G, L, v, O, U) {
        var Y = G.node.o;
        if (U >= G.node.I) return 0;
        if (G = Math.min(G.node.I - U, O), 8 < G && Y.subarray) L.set(Y.subarray(U, U + G), v);
        else for (O = 0; O < G; O++) L[v + O] = Y[U + O];
        return G;
      }, write(G, L, v, O, U, Y) {
        if (L.buffer === (E(), Gt).buffer && (Y = !1), !O) return 0;
        if (G = G.node, G.mtime = G.ctime = Date.now(), L.subarray && (!G.o || G.o.subarray)) {
          if (Y) return G.o = L.subarray(v, v + O), G.I = O;
          if (G.I === 0 && U === 0) return G.o = L.slice(v, v + O), G.I = O;
          if (U + O <= G.I) return G.o.set(L.subarray(v, v + O), U), O;
        }
        Y = U + O;
        var k = G.o ? G.o.length : 0;
        if (k >= Y || (Y = Math.max(Y, k * (1048576 > k ? 2 : 1.125) >>> 0), k != 0 && (Y = Math.max(Y, 256)), k = G.o, G.o = new Uint8Array(Y), 0 < G.I && G.o.set(k.subarray(0, G.I), 0)), G.o.subarray && L.subarray) G.o.set(L.subarray(v, v + O), U);
        else for (Y = 0; Y < O; Y++) G.o[U + Y] = L[v + Y];
        return G.I = Math.max(G.I, U + O), O;
      }, M(G, L, v) {
        if (v === 1 ? L += G.position : v === 2 && It.isFile(G.node.mode) && (L += G.node.I), 0 > L) throw new It.g(28);
        return L;
      }, za(G, L, v, O, U) {
        if (!It.isFile(G.node.mode)) throw new It.g(43);
        if (G = G.node.o, U & 2 || !G || G.buffer !== (E(), Gt).buffer) {
          if (O = !0, U = xY(L), !U) throw new It.g(48);
          G && ((0 < v || v + L < G.length) && (G = G.subarray ? G.subarray(v, v + L) : Array.prototype.slice.call(G, v, v + L)), (E(), Gt).set(G, U));
        } else O = !1, U = G.byteOffset;
        return { u: U, qc: O };
      }, La(G, L, v, O) {
        return mn.i.write(G, L, 0, O, v, !1), 0;
      } } }, Gw = (G, L) => {
        var v = 0;
        return G && (v |= 365), L && (v |= 146), v;
      }, B4 = async (G) => (G = await W(G), new Uint8Array(G)), i1 = [], K4 = async (G, L) => {
        typeof qQ < "u" && $Q();
        for (var v of i1) if (v.canHandle(L)) return v.handle(G, L);
        return G;
      }, ww = async (G, L, v, O, U, Y, k, _) => {
        var st = L ? n1(di.Ka(G, L)) : G;
        Bt();
        try {
          var bt = v;
          typeof v == "string" && (bt = await B4(v)), bt = await K4(bt, st), _ == null || _(), Y || SY(G, L, bt, O, U, k);
        } finally {
          zt();
        }
      };
      function xw(G, L) {
        It.yc[G] = { i: L };
      }
      function nr(G) {
        return (G & 61440) === 16384;
      }
      function Ul(G, L) {
        var v = nr(G.mode) ? (v = Td(G, "x")) ? v : G.j.lookup ? 0 : 2 : 54;
        if (v) throw new It.g(v);
        for (v = It.ja[Sw(G.id, L)]; v; v = v.Aa) {
          var O = v.name;
          if (v.parent.id === G.id && O === L) return v;
        }
        return It.lookup(G, L);
      }
      function zg(G) {
        var L = Sw(G.parent.id, G.name);
        if (It.ja[L] === G) It.ja[L] = G.Aa;
        else for (L = It.ja[L]; L; ) {
          if (L.Aa === G) {
            L.Aa = G.Aa;
            break;
          }
          L = L.Aa;
        }
      }
      function SY(G, L, v, O, U, Y) {
        var k = L;
        if (G && (G = typeof G == "string" ? G : O0(G), k = L ? di.Ka(G, L) : G), G = Gw(O, U), k = It.create(k, G), v) {
          if (typeof v == "string") {
            for (L = Array(v.length), O = 0, U = v.length; O < U; ++O) L[O] = v.charCodeAt(O);
            v = L;
          }
          It.chmod(k, G | 146), L = It.open(k, 577), It.write(L, v, 0, v.length, 0, Y), It.close(L), It.chmod(k, G);
        }
      }
      function ts(G, L = {}) {
        if (!G) throw new It.g(44);
        L.jb ?? (L.jb = !0), di.Ja(G) || (G = It.cwd() + "/" + G);
        var v = 0;
        t: for (; 40 > v; v++) {
          G = G.split("/").filter((_) => !!_);
          for (var O = It.root, U = "/", Y = 0; Y < G.length; Y++) {
            var k = Y === G.length - 1;
            if (k && L.parent) break;
            if (G[Y] !== ".") if (G[Y] === "..") if (U = di.dirname(U), It.Qb(O)) {
              G = U + "/" + G.slice(Y + 1).join("/"), v--;
              continue t;
            } else O = O.parent;
            else {
              U = di.Ka(U, G[Y]);
              try {
                O = Ul(O, G[Y]);
              } catch (_) {
                if ((_ == null ? void 0 : _.l) === 44 && k && L.ze) return { path: U };
                throw _;
              }
              if (!O.Z || k && !L.jb || (O = O.Z.root), (O.mode & 61440) === 40960 && (!k || L.V)) {
                if (!O.j.readlink) throw new It.g(52);
                O = O.j.readlink(O), di.Ja(O) || (O = di.dirname(U) + "/" + O), G = O + "/" + G.slice(Y + 1).join("/");
                continue t;
              }
            }
          }
          return { path: U, node: O };
        }
        throw new It.g(32);
      }
      function O0(G) {
        for (var L; ; ) {
          if (It.Qb(G)) return G = G.B.Wc, L ? G[G.length - 1] !== "/" ? `${G}/${L}` : G + L : G;
          L = L ? `${G.name}/${L}` : G.name, G = G.parent;
        }
      }
      function Sw(G, L) {
        for (var v = 0, O = 0; O < L.length; O++) v = (v << 5) - v + L.charCodeAt(O) | 0;
        return (G + v >>> 0) % It.ja.length;
      }
      function LY(G) {
        var L = Sw(G.parent.id, G.name);
        G.Aa = It.ja[L], It.ja[L] = G;
      }
      function VY(G) {
        var L = ["r", "w", "rw"][G & 3];
        return G & 512 && (L += "w"), L;
      }
      function Td(G, L) {
        if (It.Gc) return 0;
        if (!L.includes("r") || G.mode & 292) {
          if (L.includes("w") && !(G.mode & 146) || L.includes("x") && !(G.mode & 73)) return 2;
        } else return 2;
        return 0;
      }
      function Lw(G, L) {
        if (!nr(G.mode)) return 54;
        try {
          return Ul(G, L), 20;
        } catch {
        }
        return Td(G, "wx");
      }
      function s1(G, L, v) {
        try {
          var O = Ul(G, L);
        } catch (U) {
          return U.l;
        }
        if (G = Td(G, "wx")) return G;
        if (v) {
          if (!nr(O.mode)) return 54;
          if (It.Qb(O) || O0(O) === It.cwd()) return 10;
        } else if (nr(O.mode)) return 31;
        return 0;
      }
      function Eg(G, L) {
        if (!G) throw new It.g(L);
        return G;
      }
      function Xs(G) {
        if (G = It.Lb(G), !G) throw new It.g(8);
        return G;
      }
      function r1(G, L = -1) {
        if (G = Object.assign(new It.wd(), G), L == -1) t: {
          for (L = 0; L <= It.nc; L++) if (!It.streams[L]) break t;
          throw new It.g(33);
        }
        return G.fd = L, It.streams[L] = G;
      }
      function Vw(G, L = -1) {
        var v, O;
        return G = r1(G, L), (O = (v = G.i) == null ? void 0 : v.Pd) == null || O.call(v, G), G;
      }
      function a1(G, L, v) {
        var O = G == null ? void 0 : G.i.da;
        G = O ? G : L, O ?? (O = L.j.da), Eg(O, 63), O(G, v);
      }
      function XY(G) {
        var L = [];
        for (G = [G]; G.length; ) {
          var v = G.pop();
          L.push(v), G.push(...v.ab);
        }
        return L;
      }
      function IY(G) {
        var L = { ef: 4096, Gf: 4096, blocks: 1e6, df: 5e5, cf: 5e5, files: It.Zb, Df: It.Zb - 1, Hf: 42, flags: 2, ig: 255 };
        return G.j.ld && Object.assign(L, G.j.ld(G.B.Ce.root)), L;
      }
      function o1(G, L, v) {
        return typeof v > "u" && (v = L, L = 438), It.ia(G, L | 8192, v);
      }
      function CY(G, L, v, O) {
        a1(G, L, { mode: v & 4095 | L.mode & -4096, ctime: Date.now(), zc: O });
      }
      function YY(G, L, v) {
        if (nr(L.mode)) throw new It.g(31);
        if (!It.isFile(L.mode)) throw new It.g(28);
        var O = Td(L, "w");
        if (O) throw new It.g(O);
        a1(G, L, { size: v, timestamp: Date.now() });
      }
      function H4(G, L) {
        for (G = typeof G == "string" ? G : O0(G), L = L.split("/").reverse(); L.length; ) {
          var v = L.pop();
          if (v) {
            var O = di.Ka(G, v);
            try {
              It.mkdir(O);
            } catch (U) {
              if (U.l != 20) throw U;
            }
            G = O;
          }
        }
        return O;
      }
      function _4(G, L, v, O) {
        return G = di.Ka(typeof G == "string" ? G : O0(G), L), It.create(G, Gw(v, O));
      }
      function Xw(G) {
        if (!(G.se || G.te || G.link || G.o)) if (typeof XMLHttpRequest < "u") Xt("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
        else try {
          G.o = x(G.url);
        } catch {
          throw new It.g(29);
        }
      }
      function Q4(G, L, v, O, U) {
        function Y(vt, _t, ie, St, Et) {
          if (vt = vt.node.o, Et >= vt.length) return 0;
          if (St = Math.min(vt.length - Et, St), vt.slice) for (var Ut = 0; Ut < St; Ut++) _t[ie + Ut] = vt[Et + Ut];
          else for (Ut = 0; Ut < St; Ut++) _t[ie + Ut] = vt.get(Et + Ut);
          return St;
        }
        class k {
          constructor() {
            hr(this, "Sb", !1), hr(this, "hb", []), hr(this, "Ya"), hr(this, "pc", 0), hr(this, "oc", 0);
          }
          get(_t) {
            if (!(_t > this.length - 1 || 0 > _t)) {
              var ie = _t % this.chunkSize;
              return this.Ya(_t / this.chunkSize | 0)[ie];
            }
          }
          Ke(_t) {
            this.Ya = _t;
          }
          tc() {
            var _t = new XMLHttpRequest();
            _t.open("HEAD", v, !1), _t.send(null), 200 <= _t.status && 300 > _t.status || _t.status === 304 || Xt("Couldn't load " + v + ". Status: " + _t.status);
            var ie = Number(_t.getResponseHeader("Content-length")), St, Et = (St = _t.getResponseHeader("Accept-Ranges")) && St === "bytes";
            _t = (St = _t.getResponseHeader("Content-Encoding")) && St === "gzip";
            var Ut = 1048576;
            Et || (Ut = ie);
            var ce = this;
            ce.Ke((de) => {
              var Oe = de * Ut, hn = (de + 1) * Ut - 1;
              if (hn = Math.min(hn, ie - 1), typeof ce.hb[de] > "u") {
                var pi = ce.hb;
                Oe > hn && Xt("invalid range (" + Oe + ", " + hn + ") or no bytes requested!"), hn > ie - 1 && Xt("only " + ie + " bytes available! programmer error!");
                var $n = new XMLHttpRequest();
                $n.open("GET", v, !1), ie !== Ut && $n.setRequestHeader("Range", "bytes=" + Oe + "-" + hn), $n.responseType = "arraybuffer", $n.overrideMimeType && $n.overrideMimeType("text/plain; charset=x-user-defined"), $n.send(null), 200 <= $n.status && 300 > $n.status || $n.status === 304 || Xt("Couldn't load " + v + ". Status: " + $n.status), Oe = $n.response !== void 0 ? new Uint8Array($n.response || []) : Ww($n.responseText || ""), pi[de] = Oe;
              }
              return typeof ce.hb[de] > "u" && Xt("doXHR failed!"), ce.hb[de];
            }), (_t || !ie) && (Ut = ie = 1, Ut = ie = this.Ya(0).length, F("LazyFiles on gzip forces download of the whole file when length is accessed")), this.pc = ie, this.oc = Ut, this.Sb = !0;
          }
          get length() {
            return this.Sb || this.tc(), this.pc;
          }
          get chunkSize() {
            return this.Sb || this.tc(), this.oc;
          }
        }
        if (typeof XMLHttpRequest < "u") {
          y || Xt("Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc");
          var _ = new k(), st = void 0;
        } else st = v, _ = void 0;
        var bt = _4(G, L, O, U);
        _ ? bt.o = _ : st && (bt.o = null, bt.url = st), Object.defineProperties(bt, { I: { get: function() {
          return this.o.length;
        } } });
        var Ct = {};
        return Object.keys(bt.i).forEach((vt) => {
          var _t = bt.i[vt];
          Ct[vt] = (...ie) => (Xw(bt), _t(...ie));
        }), Ct.read = (vt, _t, ie, St, Et) => (Xw(bt), Y(vt, _t, ie, St, Et)), Ct.za = (vt, _t, ie) => {
          Xw(bt);
          var St = xY(_t);
          if (!St) throw new It.g(48);
          return Y(vt, (E(), Gt), St, _t, ie), { u: St, qc: !0 };
        }, bt.i = Ct, bt;
      }
      var It = { root: null, ab: [], yc: {}, streams: [], Zb: 1, ja: null, wc: "/", Ob: !1, Gc: !0, Sd: null, ub: 0, ed: {}, g: class {
        constructor(G) {
          hr(this, "name", "ErrnoError"), this.l = G;
        }
      }, wd: class {
        constructor() {
          hr(this, "tb", {}), hr(this, "node", null);
        }
        get object() {
          return this.node;
        }
        set object(G) {
          this.node = G;
        }
        get flags() {
          return this.tb.flags;
        }
        set flags(G) {
          this.tb.flags = G;
        }
        get position() {
          return this.tb.position;
        }
        set position(G) {
          this.tb.position = G;
        }
      }, vd: class {
        constructor(G, L, v, O) {
          hr(this, "j", {}), hr(this, "i", {}), hr(this, "rb", 365), hr(this, "zb", 146), hr(this, "Z", null), G || (G = this), this.parent = G, this.B = G.B, this.id = It.Zb++, this.name = L, this.mode = v, this.rdev = O, this.atime = this.mtime = this.ctime = Date.now();
        }
        get read() {
          return (this.mode & this.rb) === this.rb;
        }
        set read(G) {
          G ? this.mode |= this.rb : this.mode &= ~this.rb;
        }
        get write() {
          return (this.mode & this.zb) === this.zb;
        }
        set write(G) {
          G ? this.mode |= this.zb : this.mode &= ~this.zb;
        }
        get te() {
          return nr(this.mode);
        }
        get se() {
          return (this.mode & 61440) === 8192;
        }
      }, createNode(G, L, v, O) {
        return G = new It.vd(G, L, v, O), LY(G), G;
      }, Qb(G) {
        return G === G.parent;
      }, isFile(G) {
        return (G & 61440) === 32768;
      }, isFIFO(G) {
        return (G & 61440) === 4096;
      }, isSocket(G) {
        return (G & 49152) === 49152;
      }, nc: 4096, Lb: (G) => It.streams[G], Ed: { open(G) {
        var L, v;
        G.i = It.Wd(G.node.rdev).i, (v = (L = G.i).open) == null || v.call(L, G);
      }, M() {
        throw new It.g(70);
      } }, Xb: (G) => G >> 8, eg: (G) => G & 255, ya: (G, L) => G << 8 | L, Wd: (G) => It.yc[G], vb(G, L) {
        function v(k) {
          return It.ub--, L(k);
        }
        function O(k) {
          if (k) {
            if (!O.Qd) return O.Qd = !0, v(k);
          } else ++Y >= U.length && v(null);
        }
        typeof G == "function" && (L = G, G = !1), It.ub++, 1 < It.ub && P(`warning: ${It.ub} FS.syncfs operations in flight at once, probably just doing extra work`);
        var U = XY(It.root.B), Y = 0;
        U.forEach((k) => {
          if (!k.type.vb) return O(null);
          k.type.vb(
            k,
            G,
            O
          );
        });
      }, B(G, L, v) {
        var O = v === "/";
        if (O && It.root) throw new It.g(10);
        if (!O && v) {
          var U = ts(v, { jb: !1 });
          if (v = U.path, U = U.node, U.Z) throw new It.g(10);
          if (!nr(U.mode)) throw new It.g(54);
        }
        return L = { type: G, Ce: L, Wc: v, ab: [] }, G = G.B(L), G.B = L, L.root = G, O ? It.root = G : U && (U.Z = L, U.B && U.B.ab.push(L)), G;
      }, Fg(G) {
        if (G = ts(G, { jb: !1 }), !G.node.Z) throw new It.g(28);
        G = G.node;
        var L = G.Z, v = XY(L);
        Object.keys(It.ja).forEach((O) => {
          for (O = It.ja[O]; O; ) {
            var U = O.Aa;
            v.includes(O.B) && zg(O), O = U;
          }
        }), G.Z = null, G.B.ab.splice(G.B.ab.indexOf(L), 1);
      }, lookup(G, L) {
        return G.j.lookup(
          G,
          L
        );
      }, ia(G, L, v) {
        var O = ts(G, { parent: !0 }).node;
        if (G = di.basename(G), !G) throw new It.g(28);
        if (G === "." || G === "..") throw new It.g(20);
        var U = Lw(O, G);
        if (U) throw new It.g(U);
        if (!O.j.ia) throw new It.g(63);
        return O.j.ia(O, G, L, v);
      }, ld(G) {
        return IY(ts(G, { V: !0 }).node);
      }, yg(G) {
        return IY(G.node);
      }, create(G, L = 438) {
        return It.ia(G, L & 4095 | 32768, 0);
      }, mkdir(G, L = 511) {
        return It.ia(G, L & 1023 | 16384, 0);
      }, gg(G, L) {
        var v = G.split("/"), O = "", U;
        for (U of v) if (U) {
          (O || di.Ja(G)) && (O += "/"), O += U;
          try {
            It.mkdir(O, L);
          } catch (Y) {
            if (Y.l != 20) throw Y;
          }
        }
      }, symlink(G, L) {
        if (!n1(G)) throw new It.g(44);
        var v = ts(L, { parent: !0 }).node;
        if (!v) throw new It.g(44);
        L = di.basename(L);
        var O = Lw(v, L);
        if (O) throw new It.g(O);
        if (!v.j.symlink) throw new It.g(63);
        return v.j.symlink(v, L, G);
      }, rename(G, L) {
        var v = di.dirname(G), O = di.dirname(L), U = di.basename(G), Y = di.basename(L), k = ts(G, { parent: !0 }), _ = k.node;
        if (k = ts(L, { parent: !0 }), k = k.node, !_ || !k) throw new It.g(44);
        if (_.B !== k.B) throw new It.g(75);
        var st = Ul(_, U);
        if (G = NY(G, O), G.charAt(0) !== ".") throw new It.g(28);
        if (G = NY(L, v), G.charAt(0) !== ".") throw new It.g(55);
        try {
          var bt = Ul(k, Y);
        } catch {
        }
        if (st !== bt) {
          if (L = nr(st.mode), U = s1(_, U, L)) throw new It.g(U);
          if (U = bt ? s1(k, Y, L) : Lw(k, Y)) throw new It.g(U);
          if (!_.j.rename) throw new It.g(63);
          if (st.Z || bt && bt.Z) throw new It.g(10);
          if (k !== _ && (U = Td(_, "w"))) throw new It.g(U);
          zg(st);
          try {
            _.j.rename(st, k, Y), st.parent = k;
          } catch (Ct) {
            throw Ct;
          } finally {
            LY(st);
          }
        }
      }, rmdir(G) {
        var L = ts(G, { parent: !0 }).node;
        G = di.basename(G);
        var v = Ul(L, G), O = s1(L, G, !0);
        if (O) throw new It.g(O);
        if (!L.j.rmdir) throw new It.g(63);
        if (v.Z) throw new It.g(10);
        L.j.rmdir(L, G), zg(v);
      }, readdir(G) {
        return G = ts(G, { V: !0 }).node, Eg(
          G.j.readdir,
          54
        )(G);
      }, unlink(G) {
        var L = ts(G, { parent: !0 }).node;
        if (!L) throw new It.g(44);
        G = di.basename(G);
        var v = Ul(L, G), O = s1(L, G, !1);
        if (O) throw new It.g(O);
        if (!L.j.unlink) throw new It.g(63);
        if (v.Z) throw new It.g(10);
        L.j.unlink(L, G), zg(v);
      }, readlink(G) {
        if (G = ts(G).node, !G) throw new It.g(44);
        if (!G.j.readlink) throw new It.g(28);
        return G.j.readlink(G);
      }, stat(G, L) {
        return G = ts(G, { V: !L }).node, Eg(G.j.W, 63)(G);
      }, fstat(G) {
        var L = Xs(G);
        G = L.node;
        var v = L.i.W;
        return L = v ? L : G, v ?? (v = G.j.W), Eg(v, 63), v(L);
      }, lstat(G) {
        return It.stat(G, !0);
      }, chmod(G, L, v) {
        G = typeof G == "string" ? ts(G, { V: !v }).node : G, CY(null, G, L, v);
      }, lchmod(G, L) {
        It.chmod(G, L, !0);
      }, fchmod(G, L) {
        G = Xs(G), CY(G, G.node, L, !1);
      }, chown(G, L, v, O) {
        G = typeof G == "string" ? ts(G, { V: !O }).node : G, a1(null, G, { timestamp: Date.now(), zc: O });
      }, lchown(G, L, v) {
        It.chown(G, L, v, !0);
      }, fchown(G) {
        G = Xs(G), a1(G, G.node, { timestamp: Date.now(), zc: !1 });
      }, truncate(G, L) {
        if (0 > L) throw new It.g(28);
        G = typeof G == "string" ? ts(G, { V: !0 }).node : G, YY(null, G, L);
      }, open(G, L, v = 438) {
        if (G === "") throw new It.g(44);
        if (typeof L == "string") {
          var O = {
            r: 0,
            "r+": 2,
            w: 577,
            "w+": 578,
            a: 1089,
            "a+": 1090
          }[L];
          if (typeof O > "u") throw Error(`Unknown file open mode: ${L}`);
          L = O;
        }
        if (v = L & 64 ? v & 4095 | 32768 : 0, typeof G == "object") O = G;
        else {
          var U = G.endsWith("/");
          G = ts(G, { V: !(L & 131072), ze: !0 }), O = G.node, G = G.path;
        }
        var Y = !1;
        if (L & 64) if (O) {
          if (L & 128) throw new It.g(20);
        } else {
          if (U) throw new It.g(31);
          O = It.ia(G, v | 511, 0), Y = !0;
        }
        if (!O) throw new It.g(44);
        if ((O.mode & 61440) === 8192 && (L &= -513), L & 65536 && !nr(O.mode)) throw new It.g(54);
        if (!Y && (U = O ? (O.mode & 61440) === 40960 ? 32 : nr(O.mode) && (VY(L) !== "r" || L & 576) ? 31 : Td(O, VY(L)) : 44)) throw new It.g(U);
        return L & 512 && !Y && It.truncate(O, 0), L &= -131713, U = r1({ node: O, path: O0(O), flags: L, seekable: !0, position: 0, i: O.i, Ye: [], error: !1 }), U.i.open && U.i.open(U), Y && It.chmod(O, v & 511), !m.logReadFiles || L & 1 || G in It.ed || (It.ed[G] = 1), U;
      }, close(G) {
        if (G.fd === null) throw new It.g(8);
        G.xa && (G.xa = null);
        try {
          G.i.close && G.i.close(G);
        } catch (L) {
          throw L;
        } finally {
          It.streams[G.fd] = null;
        }
        G.fd = null;
      }, M(G, L, v) {
        if (G.fd === null) throw new It.g(8);
        if (!G.seekable || !G.i.M) throw new It.g(70);
        if (v != 0 && v != 1 && v != 2) throw new It.g(28);
        return G.position = G.i.M(G, L, v), G.Ye = [], G.position;
      }, read(G, L, v, O, U) {
        if (0 > O || 0 > U) throw new It.g(28);
        if (G.fd === null) throw new It.g(8);
        if ((G.flags & 2097155) === 1) throw new It.g(8);
        if (nr(G.node.mode)) throw new It.g(31);
        if (!G.i.read) throw new It.g(28);
        var Y = typeof U < "u";
        if (!Y) U = G.position;
        else if (!G.seekable) throw new It.g(70);
        return L = G.i.read(G, L, v, O, U), Y || (G.position += L), L;
      }, write(G, L, v, O, U, Y) {
        if (0 > O || 0 > U) throw new It.g(28);
        if (G.fd === null) throw new It.g(8);
        if ((G.flags & 2097155) === 0) throw new It.g(8);
        if (nr(G.node.mode)) throw new It.g(31);
        if (!G.i.write) throw new It.g(28);
        G.seekable && G.flags & 1024 && It.M(G, 0, 2);
        var k = typeof U < "u";
        if (!k) U = G.position;
        else if (!G.seekable) throw new It.g(70);
        return L = G.i.write(G, L, v, O, U, Y), k || (G.position += L), L;
      }, za(G, L, v, O, U) {
        if ((O & 2) !== 0 && (U & 2) === 0 && (G.flags & 2097155) !== 2) throw new It.g(2);
        if ((G.flags & 2097155) === 1) throw new It.g(2);
        if (!G.i.za) throw new It.g(43);
        if (!L) throw new It.g(28);
        return G.i.za(G, L, v, O, U);
      }, La(G, L, v, O, U) {
        return G.i.La ? G.i.La(G, L, v, O, U) : 0;
      }, kb(G, L, v) {
        if (!G.i.kb) throw new It.g(59);
        return G.i.kb(
          G,
          L,
          v
        );
      }, readFile(G, L = {}) {
        L.flags = L.flags || 0, L.encoding = L.encoding || "binary", L.encoding !== "utf8" && L.encoding !== "binary" && Xt(`Invalid encoding type "${L.encoding}"`);
        var v = It.open(G, L.flags);
        G = It.stat(G).size;
        var O = new Uint8Array(G);
        return It.read(v, O, 0, G, 0), L.encoding === "utf8" && (O = R0(O)), It.close(v), O;
      }, writeFile(G, L, v = {}) {
        v.flags = v.flags || 577, G = It.open(G, v.flags, v.mode), typeof L == "string" && (L = new Uint8Array(Ww(L))), ArrayBuffer.isView(L) ? It.write(G, L, 0, L.byteLength, void 0, v.mf) : Xt("Unsupported data type"), It.close(G);
      }, cwd: () => It.wc, chdir(G) {
        if (G = ts(G, { V: !0 }), G.node === null) throw new It.g(44);
        if (!nr(G.node.mode)) throw new It.g(54);
        var L = Td(G.node, "x");
        if (L) throw new It.g(L);
        It.wc = G.path;
      }, Ia(G, L, v) {
        It.Ob = !0, G ?? (G = m.stdin), L ?? (L = m.stdout), v ?? (v = m.stderr), G ? It.ra("/dev", "stdin", G) : It.symlink("/dev/tty", "/dev/stdin"), L ? It.ra("/dev", "stdout", null, L) : It.symlink("/dev/tty", "/dev/stdout"), v ? It.ra("/dev", "stderr", null, v) : It.symlink("/dev/tty1", "/dev/stderr"), It.open("/dev/stdin", 0), It.open("/dev/stdout", 1), It.open("/dev/stderr", 1);
      }, qg() {
        It.Ob = !1;
        for (var G of It.streams) G && It.close(G);
      }, Ef(G, L) {
        try {
          var v = ts(G, { V: !L });
          G = v.path;
        } catch {
        }
        var O = !1, U = null;
        try {
          v = ts(G, { parent: !0 }), di.basename(G), v = ts(G, { V: !L }), O = !0, U = v.node;
        } catch {
        }
        return O ? U : null;
      }, ra(G, L, v, O) {
        G = di.Ka(typeof G == "string" ? G : O0(G), L), L = Gw(!!v, !!O);
        var U;
        return (U = It.ra).Xb ?? (U.Xb = 64), U = It.ya(It.ra.Xb++, 0), xw(U, { open(Y) {
          Y.seekable = !1;
        }, close() {
          var Y;
          (Y = O == null ? void 0 : O.buffer) != null && Y.length && O(10);
        }, read(Y, k, _, st) {
          for (var bt = 0, Ct = 0; Ct < st; Ct++) {
            try {
              var vt = v();
            } catch {
              throw new It.g(29);
            }
            if (vt === void 0 && bt === 0) throw new It.g(6);
            if (vt == null) break;
            bt++, k[_ + Ct] = vt;
          }
          return bt && (Y.node.atime = Date.now()), bt;
        }, write(Y, k, _, st) {
          for (var bt = 0; bt < st; bt++) try {
            O(k[_ + bt]);
          } catch {
            throw new It.g(29);
          }
          return st && (Y.node.mtime = Y.node.ctime = Date.now()), bt;
        } }), o1(G, L, U);
      } }, $4 = 5;
      function Aa(G, L, v) {
        if (di.Ja(L)) return L;
        if (G = G === -100 ? It.cwd() : Xs(G).path, L.length == 0) {
          if (!v) throw new It.g(44);
          return G;
        }
        return G + "/" + L;
      }
      function l1(G, L) {
        (E(), nt)[G / 4] = L.dev, (E(), nt)[(G + 4) / 4] = L.mode, (E(), ht)[(G + 8) / 8] = BigInt(L.nlink), (E(), nt)[(G + 16) / 4] = L.uid, (E(), nt)[(G + 20) / 4] = L.gid, (E(), nt)[(G + 24) / 4] = L.rdev, (E(), it)[(G + 32) / 8] = BigInt(L.size), (E(), q)[(G + 40) / 4] = 4096, (E(), q)[(G + 44) / 4] = L.blocks;
        var v = L.atime.getTime(), O = L.mtime.getTime(), U = L.ctime.getTime();
        return (E(), it)[(G + 48) / 8] = BigInt(Math.floor(v / 1e3)), (E(), ht)[(G + 56) / 8] = BigInt(v % 1e3 * 1e6), (E(), it)[(G + 64) / 8] = BigInt(Math.floor(O / 1e3)), (E(), ht)[(G + 72) / 8] = BigInt(O % 1e3 * 1e6), (E(), it)[(G + 80) / 8] = BigInt(Math.floor(U / 1e3)), (E(), ht)[(G + 88) / 8] = BigInt(U % 1e3 * 1e6), (E(), it)[(G + 96) / 8] = BigInt(L.ino), 0;
      }
      var up = void 0;
      function vY(G) {
        if (g) return ae(3, 1, G);
        G = xt(G);
        try {
          return G = Sn(G), It.chdir(G), 0;
        } catch (L) {
          if (typeof It > "u" || L.name !== "ErrnoError") throw L;
          return -L.l;
        }
      }
      function RY(G, L) {
        if (g) return ae(4, 1, G, L);
        G = xt(G);
        try {
          return G = Sn(G), It.chmod(G, L), 0;
        } catch (v) {
          if (typeof It > "u" || v.name !== "ErrnoError") throw v;
          return -v.l;
        }
      }
      function DY(G) {
        if (g) return ae(5, 1, G);
        try {
          var L = Xs(G);
          return Vw(L).fd;
        } catch (v) {
          if (typeof It > "u" || v.name !== "ErrnoError") throw v;
          return -v.l;
        }
      }
      function OY(G, L, v) {
        if (g) return ae(6, 1, G, L, v);
        try {
          var O = Xs(G);
          if (O.fd === L) return -28;
          if (0 > L || L >= It.nc) return -8;
          var U = It.Lb(L);
          return U && It.close(U), Vw(O, L).fd;
        } catch (Y) {
          if (typeof It > "u" || Y.name !== "ErrnoError") throw Y;
          return -Y.l;
        }
      }
      function zY(G, L, v, O) {
        if (g) return ae(7, 1, G, L, v, O);
        L = xt(L);
        try {
          if (L = Sn(L), L = Aa(G, L), v & -8) return -28;
          var U = ts(L, { V: !0 }).node;
          return U ? (G = "", v & 4 && (G += "r"), v & 2 && (G += "w"), v & 1 && (G += "x"), G && Td(U, G) ? -2 : 0) : -44;
        } catch (Y) {
          if (typeof It > "u" || Y.name !== "ErrnoError") throw Y;
          return -Y.l;
        }
      }
      function EY(G) {
        if (g) return ae(8, 1, G);
        try {
          var L = Xs(G);
          return It.chdir(L.path), 0;
        } catch (v) {
          if (typeof It > "u" || v.name !== "ErrnoError") throw v;
          return -v.l;
        }
      }
      function kY(G, L) {
        if (g) return ae(9, 1, G, L);
        try {
          return It.fchmod(G, L), 0;
        } catch (v) {
          if (typeof It > "u" || v.name !== "ErrnoError") throw v;
          return -v.l;
        }
      }
      function FY(G, L, v, O) {
        if (g) return ae(10, 1, G, L, v, O);
        L = xt(L);
        try {
          return O &= 256, L = Sn(L), L = Aa(G, L), It.chmod(L, v, O), 0;
        } catch (U) {
          if (typeof It > "u" || U.name !== "ErrnoError") throw U;
          return -U.l;
        }
      }
      function jY(G, L, v) {
        if (g) return ae(11, 1, G, L, v);
        try {
          return It.fchown(G, L, v), 0;
        } catch (O) {
          if (typeof It > "u" || O.name !== "ErrnoError") throw O;
          return -O.l;
        }
      }
      function UY(G, L, v, O, U) {
        if (g) return ae(12, 1, G, L, v, O, U);
        L = xt(L);
        try {
          return L = Sn(L), U &= 256, L = Aa(G, L), (U ? It.lchown : It.chown)(L, v, O), 0;
        } catch (Y) {
          if (typeof It > "u" || Y.name !== "ErrnoError") throw Y;
          return -Y.l;
        }
      }
      var z0 = () => {
        var G = Number((E(), ht)[up / 8]);
        return up += 8, G;
      }, Iw = () => {
        var G = (E(), q)[+up / 4];
        return up += 4, G;
      };
      function PY(G, L, v) {
        if (g) return ae(13, 1, G, L, v);
        up = v = xt(v);
        try {
          var O = Xs(G);
          switch (L) {
            case 0:
              var U = Iw();
              if (0 > U) break;
              for (; It.streams[U]; ) U++;
              return Vw(O, U).fd;
            case 1:
            case 2:
              return 0;
            case 3:
              return O.flags;
            case 4:
              return U = Iw(), O.flags |= U, 0;
            case 5:
              return U = z0(), (E(), Q)[(U + 0) / 2] = 2, 0;
            case 6:
            case 7:
              return 0;
          }
          return -28;
        } catch (Y) {
          if (typeof It > "u" || Y.name !== "ErrnoError") throw Y;
          return -Y.l;
        }
      }
      function JY(G, L) {
        if (g) return ae(14, 1, G, L);
        L = xt(L);
        try {
          return l1(L, It.fstat(G));
        } catch (v) {
          if (typeof It > "u" || v.name !== "ErrnoError") throw v;
          return -v.l;
        }
      }
      function AY(G, L) {
        if (g) return ae(15, 1, G, L);
        L = xt(L);
        try {
          if (isNaN(L)) return -61;
          var v = Xs(G);
          if (0 > L || (v.flags & 2097155) === 0) throw new It.g(28);
          return YY(v, v.node, L), 0;
        } catch (O) {
          if (typeof It > "u" || O.name !== "ErrnoError") throw O;
          return -O.l;
        }
      }
      var jr = (G, L, v) => WY(G, (E(), Tt), L, v);
      function BY(G, L) {
        if (g) return ae(16, 1, G, L);
        G = xt(G), L = xt(L);
        try {
          if (L === 0) return -28;
          var v = It.cwd(), O = D0(v) + 1;
          return L < O ? -68 : (jr(v, G, L), O);
        } catch (U) {
          if (typeof It > "u" || U.name !== "ErrnoError") throw U;
          return -U.l;
        }
      }
      function KY(G, L, v) {
        if (g) return ae(17, 1, G, L, v);
        L = xt(L), v = xt(v);
        try {
          var O = Xs(G);
          O.xa || (O.xa = It.readdir(O.path)), G = 0;
          var U = It.M(O, 0, 1), Y = Math.floor(U / 280), k = Math.min(O.xa.length, Y + Math.floor(v / 280));
          for (v = Y; v < k; v++) {
            var _ = O.xa[v];
            if (_ === ".")
              var st = O.node.id, bt = 4;
            else if (_ === "..") st = ts(O.path, { parent: !0 }).node.id, bt = 4;
            else {
              try {
                var Ct = Ul(O.node, _);
              } catch (vt) {
                if ((vt == null ? void 0 : vt.l) === 28) continue;
                throw vt;
              }
              st = Ct.id, bt = (Ct.mode & 61440) === 8192 ? 2 : nr(Ct.mode) ? 4 : (Ct.mode & 61440) === 40960 ? 10 : 8;
            }
            (E(), it)[(L + G) / 8] = BigInt(st), (E(), it)[(L + G + 8) / 8] = BigInt(280 * (v + 1)), (E(), Q)[(L + G + 16) / 2] = 280, (E(), Gt)[L + G + 18] = bt, jr(_, L + G + 19, 256), G += 280;
          }
          return It.M(O, 280 * v, 0), G;
        } catch (vt) {
          if (typeof It > "u" || vt.name !== "ErrnoError") throw vt;
          return -vt.l;
        }
      }
      function HY(G, L, v) {
        if (g) return ae(18, 1, G, L, v);
        up = v = xt(v);
        try {
          var O = Xs(G);
          switch (L) {
            case 21509:
              return O.tty ? 0 : -59;
            case 21505:
              if (!O.tty) return -59;
              if (O.tty.na.pe) {
                G = [3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                var U = z0();
                (E(), q)[U / 4] = 25856, (E(), q)[(U + 4) / 4] = 5, (E(), q)[(U + 8) / 4] = 191, (E(), q)[(U + 12) / 4] = 35387;
                for (var Y = 0; 32 > Y; Y++) (E(), Gt)[U + Y + 17] = G[Y] || 0;
              }
              return 0;
            case 21510:
            case 21511:
            case 21512:
              return O.tty ? 0 : -59;
            case 21506:
            case 21507:
            case 21508:
              if (!O.tty) return -59;
              if (O.tty.na.qe) for (U = z0(), E(), E(), E(), E(), G = [], Y = 0; 32 > Y; Y++) G.push((E(), Gt)[U + Y + 17]);
              return 0;
            case 21519:
              return O.tty ? (U = z0(), (E(), q)[U / 4] = 0) : -59;
            case 21520:
              return O.tty ? -28 : -59;
            case 21537:
            case 21531:
              return U = z0(), It.kb(O, L, U);
            case 21523:
              return O.tty ? (O.tty.na.re && (Y = [24, 80], U = z0(), (E(), Q)[U / 2] = Y[0], (E(), Q)[(U + 2) / 2] = Y[1]), 0) : -59;
            case 21524:
              return O.tty ? 0 : -59;
            case 21515:
              return O.tty ? 0 : -59;
            default:
              return -28;
          }
        } catch (k) {
          if (typeof It > "u" || k.name !== "ErrnoError") throw k;
          return -k.l;
        }
      }
      function _Y(G, L) {
        if (g) return ae(19, 1, G, L);
        G = xt(G), L = xt(L);
        try {
          return G = Sn(G), l1(L, It.lstat(G));
        } catch (v) {
          if (typeof It > "u" || v.name !== "ErrnoError") throw v;
          return -v.l;
        }
      }
      function QY(G, L, v) {
        if (g) return ae(20, 1, G, L, v);
        L = xt(L);
        try {
          return L = Sn(L), L = Aa(G, L), It.mkdir(L, v, 0), 0;
        } catch (O) {
          if (typeof It > "u" || O.name !== "ErrnoError") throw O;
          return -O.l;
        }
      }
      function $Y(G, L, v, O) {
        if (g) return ae(21, 1, G, L, v, O);
        L = xt(L);
        try {
          switch (L = Sn(L), L = Aa(G, L), v & 61440) {
            case 32768:
            case 8192:
            case 24576:
            case 4096:
            case 49152:
              break;
            default:
              return -28;
          }
          return It.ia(L, v, O), 0;
        } catch (U) {
          if (typeof It > "u" || U.name !== "ErrnoError") throw U;
          return -U.l;
        }
      }
      function qY(G, L, v, O) {
        if (g) return ae(22, 1, G, L, v, O);
        L = xt(L), v = xt(v);
        try {
          L = Sn(L);
          var U = O & 256;
          return L = Aa(G, L, O & 4096), l1(v, U ? It.lstat(L) : It.stat(L));
        } catch (Y) {
          if (typeof It > "u" || Y.name !== "ErrnoError") throw Y;
          return -Y.l;
        }
      }
      function tv(G, L, v, O) {
        if (g) return ae(23, 1, G, L, v, O);
        L = xt(L), up = O = xt(O);
        try {
          L = Sn(L), L = Aa(G, L);
          var U = O ? Iw() : 0;
          return It.open(L, v, U).fd;
        } catch (Y) {
          if (typeof It > "u" || Y.name !== "ErrnoError") throw Y;
          return -Y.l;
        }
      }
      var Zs = { ea: 8192, B() {
        return It.createNode(null, "/", 16895, 0);
      }, i: { W(G) {
        G = G.node;
        var L = G.pipe.timestamp;
        return { dev: 14, ino: G.id, mode: 4480, nlink: 1, uid: 0, gid: 0, rdev: 0, size: 0, atime: L, mtime: L, ctime: L, blksize: 4096, blocks: 0 };
      }, $c(G) {
        var L = G.node.pipe;
        if ((G.flags & 2097155) === 1) return 260;
        for (var v of L.L) if (0 < v.offset - v.ba) return 65;
        return 0;
      }, Pd(G) {
        G.node.pipe.bc++;
      }, kb() {
        return 28;
      }, fsync() {
        return 28;
      }, read(G, L, v, O) {
        G = G.node.pipe;
        var U = 0, Y;
        for (Y of G.L) U += Y.offset - Y.ba;
        if (L = L.subarray(v, v + O), 0 >= O) return 0;
        if (U == 0) throw new It.g(6);
        v = O = Math.min(U, O), U = 0;
        for (Y of G.L) {
          var k = Y.offset - Y.ba;
          if (O <= k) {
            var _ = Y.buffer.subarray(Y.ba, Y.offset);
            O < k ? (_ = _.subarray(0, O), Y.ba += O) : U++, L.set(_);
            break;
          } else _ = Y.buffer.subarray(Y.ba, Y.offset), L.set(_), L = L.subarray(_.byteLength), O -= _.byteLength, U++;
        }
        return U && U == G.L.length && (U--, G.L[U].offset = 0, G.L[U].ba = 0), G.L.splice(0, U), v;
      }, write(G, L, v, O) {
        if (G = G.node.pipe, L = L.subarray(v, v + O), v = L.byteLength, 0 >= v) return 0;
        G.L.length == 0 ? (O = { buffer: new Uint8Array(Zs.ea), offset: 0, ba: 0 }, G.L.push(O)) : O = G.L[G.L.length - 1];
        var U = Zs.ea - O.offset;
        if (U >= v) return O.buffer.set(L, O.offset), O.offset += v, v;
        0 < U && (O.buffer.set(L.subarray(0, U), O.offset), O.offset += U, L = L.subarray(U, L.byteLength)), O = L.byteLength / Zs.ea | 0, U = L.byteLength % Zs.ea;
        for (var Y = 0; Y < O; Y++) {
          var k = { buffer: new Uint8Array(Zs.ea), offset: Zs.ea, ba: 0 };
          G.L.push(k), k.buffer.set(L.subarray(0, Zs.ea)), L = L.subarray(Zs.ea, L.byteLength);
        }
        return 0 < U && (k = { buffer: new Uint8Array(Zs.ea), offset: L.byteLength, ba: 0 }, G.L.push(k), k.buffer.set(L)), v;
      }, close(G) {
        G = G.node.pipe, G.bc--, G.bc === 0 && (G.L = null);
      } }, bb() {
        return Zs.bb.current || (Zs.bb.current = 0), "pipe[" + Zs.bb.current++ + "]";
      } };
      function ev(G) {
        if (g) return ae(24, 1, G);
        G = xt(G);
        try {
          if (G == 0) throw new It.g(21);
          var L = { L: [], bc: 2, timestamp: /* @__PURE__ */ new Date() };
          L.L.push({ buffer: new Uint8Array(Zs.ea), offset: 0, ba: 0 });
          var v = Zs.bb(), O = Zs.bb(), U = It.createNode(Zs.root, v, 4096, 0), Y = It.createNode(Zs.root, O, 4096, 0);
          U.pipe = L, Y.pipe = L;
          var k = r1({ path: v, node: U, flags: 0, seekable: !1, i: Zs.i });
          U.stream = k;
          var _ = r1({ path: O, node: Y, flags: 1, seekable: !1, i: Zs.i });
          Y.stream = _;
          var st = k.fd, bt = _.fd;
          return (E(), q)[G / 4] = st, (E(), q)[(G + 4) / 4] = bt, 0;
        } catch (Ct) {
          if (typeof It > "u" || Ct.name !== "ErrnoError") throw Ct;
          return -Ct.l;
        }
      }
      function nv(G, L, v) {
        if (g) return ae(25, 1, G, L, v);
        G = xt(G);
        try {
          for (var O = v = 0; O < L; O++) {
            var U = G + 8 * O, Y = (E(), q)[U / 4], k = (E(), Q)[(U + 4) / 2], _ = 32, st = It.Lb(Y);
            st && (_ = $4, st.i.$c && (_ = st.i.$c(st, -1))), (_ &= k | 24) && v++, (E(), Q)[(U + 6) / 2] = _;
          }
          return v;
        } catch (bt) {
          if (typeof It > "u" || bt.name !== "ErrnoError") throw bt;
          return -bt.l;
        }
      }
      function iv(G, L, v, O) {
        if (g) return ae(26, 1, G, L, v, O);
        L = xt(L), v = xt(v), O = xt(O);
        try {
          if (L = Sn(L), L = Aa(G, L), 0 >= O) return -28;
          var U = It.readlink(L), Y = Math.min(O, D0(U)), k = (E(), Gt)[v + Y];
          return jr(U, v, O + 1), (E(), Gt)[v + Y] = k, Y;
        } catch (_) {
          if (typeof It > "u" || _.name !== "ErrnoError") throw _;
          return -_.l;
        }
      }
      function sv(G, L, v, O) {
        if (g) return ae(27, 1, G, L, v, O);
        L = xt(L), O = xt(O);
        try {
          return L = Sn(L), O = Sn(O), L = Aa(G, L), O = Aa(v, O), It.rename(L, O), 0;
        } catch (U) {
          if (typeof It > "u" || U.name !== "ErrnoError") throw U;
          return -U.l;
        }
      }
      function rv(G) {
        if (g) return ae(28, 1, G);
        G = xt(G);
        try {
          return G = Sn(G), It.rmdir(G), 0;
        } catch (L) {
          if (typeof It > "u" || L.name !== "ErrnoError") throw L;
          return -L.l;
        }
      }
      function av(G, L) {
        if (g) return ae(29, 1, G, L);
        G = xt(G), L = xt(L);
        try {
          return G = Sn(G), l1(L, It.stat(G));
        } catch (v) {
          if (typeof It > "u" || v.name !== "ErrnoError") throw v;
          return -v.l;
        }
      }
      function ov(G, L, v) {
        if (g) return ae(30, 1, G, L, v);
        G = xt(G), v = xt(v);
        try {
          return G = Sn(G), v = Sn(v), v = Aa(L, v), It.symlink(G, v), 0;
        } catch (O) {
          if (typeof It > "u" || O.name !== "ErrnoError") throw O;
          return -O.l;
        }
      }
      function lv(G, L) {
        if (g) return ae(31, 1, G, L);
        G = xt(G), L = xt(L);
        try {
          return isNaN(L) ? -61 : (G = Sn(G), It.truncate(G, L), 0);
        } catch (v) {
          if (typeof It > "u" || v.name !== "ErrnoError") throw v;
          return -v.l;
        }
      }
      function cv(G, L, v) {
        if (g) return ae(32, 1, G, L, v);
        L = xt(L);
        try {
          if (L = Sn(L), L = Aa(G, L), v) if (v === 512) It.rmdir(L);
          else return -28;
          else It.unlink(L);
          return 0;
        } catch (O) {
          if (typeof It > "u" || O.name !== "ErrnoError") throw O;
          return -O.l;
        }
      }
      var uv = (G) => (E(), nt)[G / 4] + 4294967296 * (E(), q)[(G + 4) / 4];
      function dv(G, L, v, O) {
        if (g) return ae(33, 1, G, L, v, O);
        L = xt(L), v = xt(v);
        try {
          L = Sn(L), L = Aa(G, L, !0);
          var U = Date.now();
          if (v) {
            var Y = uv(v), k = (E(), q)[(v + 8) / 4], _ = k == 1073741823 ? U : k == 1073741822 ? null : 1e3 * Y + k / 1e6;
            v += 16, Y = uv(v), k = (E(), q)[(v + 8) / 4];
            var st = k == 1073741823 ? U : k == 1073741822 ? null : 1e3 * Y + k / 1e6;
          } else st = _ = U;
          if ((st ?? _) !== null) {
            G = _;
            var bt = ts(L, { V: !0 }).node;
            Eg(bt.j.da, 63)(bt, { atime: G, mtime: st });
          }
          return 0;
        } catch (Ct) {
          if (typeof It > "u" || Ct.name !== "ErrnoError") throw Ct;
          return -Ct.l;
        }
      }
      var q4 = () => Xt(""), kg = (G, L) => Object.defineProperty(L, "name", { value: G }), hv = [], dp = [0, 1, , 1, null, 1, !0, 1, !1, 1], dn = class extends Error {
        constructor(G) {
          super(G), this.name = "BindingError";
        }
      }, tH = (G) => {
        throw new dn(G);
      }, Ur = (G) => {
        if (!G) throw new dn(`Cannot use deleted val. handle = ${G}`);
        return dp[G];
      }, Yo = (G) => {
        switch (G) {
          case void 0:
            return 2;
          case null:
            return 4;
          case !0:
            return 6;
          case !1:
            return 8;
          default:
            const L = hv.pop() || dp.length;
            return dp[L] = G, dp[L + 1] = 1, L;
        }
      };
      class eH extends Error {
      }
      var os = (G) => {
        for (var L = ""; ; ) {
          var v = (E(), Tt)[G++];
          if (!v) return L;
          L += String.fromCharCode(v);
        }
      }, Fg = {}, Cw = (G, L) => {
        if (L === void 0) throw new dn("ptr should not be undefined");
        for (; G.K; ) L = G.eb(L), G = G.K;
        return L;
      }, hp = {}, pv = (G) => {
        G = DR(G);
        var L = os(G);
        return ll(G), L;
      }, Yw = (G, L) => {
        var v = hp[G];
        if (v === void 0) throw G = `${L} has unknown type ${pv(G)}`, new dn(G);
        return v;
      }, c1 = () => {
      }, vw = !1, E0 = (G) => typeof FinalizationRegistry > "u" ? (E0 = (L) => L, G) : (vw = new FinalizationRegistry((L) => {
        L = L.h, --L.count.value, L.count.value === 0 && (L.N ? L.X.la(L.N) : L.D.m.la(L.u));
      }), E0 = (L) => {
        var v = L.h;
        return v.N && vw.register(L, { h: v }, L), L;
      }, c1 = (L) => {
        vw.unregister(L);
      }, E0(G));
      function nH(G, L, v) {
        G = xt(G), L = xt(L), v = xt(v);
        var O = (() => {
          G = os(G), L = Yw(L, "wrapper"), v = Ur(v);
          var U = L.m, Y = U.ha, k = U.K.ha, _ = U.K.constructor, st = kg(G, function(...bt) {
            U.K.cd.forEach((function(Ct) {
              if (this[Ct] === k[Ct]) throw new eH(`Pure virtual function ${Ct} must be implemented in JavaScript`);
            }).bind(this)), Object.defineProperty(this, "__parent", { value: Y }), this.__construct(...bt);
          });
          return Y.__construct = function(...bt) {
            if (this === Y) throw new dn("Pass correct 'this' to __construct");
            bt = _.implement(this, ...bt), c1(bt);
            var Ct = bt.h;
            if (bt.notifyOnDestruction(), Ct.Na = !0, Object.defineProperties(this, { h: { value: Ct } }), E0(this), bt = Ct.u, bt = Cw(U, bt), Fg.hasOwnProperty(bt)) throw new dn(`Tried to register registered instance: ${bt}`);
            Fg[bt] = this;
          }, Y.__destruct = function() {
            if (this === Y) throw new dn("Pass correct 'this' to __destruct");
            c1(this);
            var bt = this.h.u;
            if (bt = Cw(U, bt), Fg.hasOwnProperty(bt)) delete Fg[bt];
            else throw new dn(`Tried to unregister unregistered instance: ${bt}`);
          }, st.prototype = Object.create(Y), Object.assign(st.prototype, v), Yo(st);
        })();
        return BigInt(O);
      }
      var u1 = {}, jg = (G) => {
        for (; G.length; ) {
          var L = G.pop();
          G.pop()(L);
        }
      };
      function Ug(G) {
        return this.v(Number((E(), ht)[G / 8]));
      }
      var k0 = {}, d1 = {}, h1 = class extends Error {
        constructor(G) {
          super(G), this.name = "InternalError";
        }
      }, Va = (G, L, v) => {
        function O(_) {
          if (_ = v(_), _.length !== G.length) throw new h1("Mismatched type converter count");
          for (var st = 0; st < G.length; ++st) vo(G[st], _[st]);
        }
        G.forEach((_) => d1[_] = L);
        var U = Array(L.length), Y = [], k = 0;
        L.forEach((_, st) => {
          hp.hasOwnProperty(_) ? U[st] = hp[_] : (Y.push(_), k0.hasOwnProperty(_) || (k0[_] = []), k0[_].push(() => {
            U[st] = hp[_], ++k, k === Y.length && O(U);
          }));
        }), Y.length === 0 && O(U);
      };
      function iH(G) {
        G = xt(G);
        var L = u1[G];
        delete u1[G];
        var v = L.elements, O = v.length, U = v.map((_) => _.ae).concat(v.map((_) => _.Ne)), Y = L.ac, k = L.la;
        Va([G], U, (_) => (v.forEach((st, bt) => {
          var Ct = _[bt], vt = st.Ya, _t = st.$d, ie = _[bt + O], St = st.Me, Et = st.Oe;
          st.read = (Ut) => Ct.v(vt(_t, Ut)), st.write = (Ut, ce) => {
            var de = [];
            St(Et, Ut, ie.J(de, ce)), jg(de);
          };
        }), [{ name: L.name, v: (st) => {
          for (var bt = Array(O), Ct = 0; Ct < O; ++Ct) bt[Ct] = v[Ct].read(st);
          return k(st), bt;
        }, J: (st, bt) => {
          if (O !== bt.length) throw new TypeError(`Incorrect number of tuple elements for ${L.name}: expected=${O}, actual=${bt.length}`);
          for (var Ct = Y(), vt = 0; vt < O; ++vt) v[vt].write(Ct, bt[vt]);
          return st !== null && st.push(k, Ct), Ct;
        }, aa: Ug, U: k }]));
      }
      function sH(G, L, v = {}) {
        var O = L.name;
        if (!G) throw new dn(`type "${O}" must have a positive integer typeid pointer`);
        if (hp.hasOwnProperty(G)) {
          if (v.le) return;
          throw new dn(`Cannot register type '${O}' twice`);
        }
        hp[G] = L, delete d1[G], k0.hasOwnProperty(G) && (L = k0[G], delete k0[G], L.forEach((U) => U()));
      }
      function vo(G, L, v = {}) {
        return sH(G, L, v);
      }
      var mv = (G, L, v) => {
        switch (L) {
          case 1:
            return v ? (O) => (E(), Gt)[O] : (O) => (E(), Tt)[O];
          case 2:
            return v ? (O) => (E(), Q)[O / 2] : (O) => (E(), D)[O / 2];
          case 4:
            return v ? (O) => (E(), q)[O / 4] : (O) => (E(), nt)[O / 4];
          case 8:
            return v ? (O) => (E(), it)[O / 8] : (O) => (E(), ht)[O / 8];
          default:
            throw new TypeError(`invalid integer width (${L}): ${G}`);
        }
      };
      function rH(G, L, v, O, U) {
        G = xt(G), L = xt(L), v = xt(v), L = os(L), O = O === 0n;
        let Y = (k) => k;
        if (O) {
          const k = 8 * v;
          Y = (_) => typeof _ == "number" ? _ >>> 0 : BigInt.asUintN(k, _), U = Y(U);
        }
        vo(G, { name: L, v: Y, J: (k, _) => (typeof _ == "number" && (_ = BigInt(_)), _), aa: mv(L, v, !O), U: null });
      }
      function aH(G, L, v, O) {
        G = xt(G), L = xt(L), L = os(L), vo(G, { name: L, v: function(U) {
          return !!U;
        }, J: function(U, Y) {
          return Y ? v : O;
        }, aa: function(U) {
          return this.v((E(), Tt)[U]);
        }, U: null });
      }
      var Rw = (G) => {
        throw new dn(G.h.D.m.name + " instance already deleted");
      };
      function p1() {
      }
      var bv = {}, Dw = (G, L, v) => {
        if (G[L].H === void 0) {
          var O = G[L];
          G[L] = function(...U) {
            if (!G[L].H.hasOwnProperty(U.length)) throw new dn(`Function '${v}' called with an invalid number of arguments (${U.length}) - expects one of (${G[L].H})!`);
            return G[L].H[U.length].apply(this, U);
          }, G[L].H = [], G[L].H[O.va] = O;
        }
      }, Ow = (G, L, v) => {
        if (m.hasOwnProperty(G)) {
          if (v === void 0 || m[G].H !== void 0 && m[G].H[v] !== void 0) throw new dn(`Cannot register public name '${G}' twice`);
          if (Dw(m, G, G), m[G].H.hasOwnProperty(v)) throw new dn(`Cannot register multiple overloads of a function with the same number of arguments (${v})!`);
          m[G].H[v] = L;
        } else m[G] = L, m[G].va = v;
      }, oH = (G) => {
        G = G.replace(/[^a-zA-Z0-9_]/g, "$");
        var L = G.charCodeAt(0);
        return 48 <= L && 57 >= L ? `_${G}` : G;
      };
      function lH(G, L, v, O, U, Y, k, _) {
        this.name = G, this.constructor = L, this.ha = v, this.la = O, this.K = U, this.Vd = Y, this.eb = k, this.Od = _, this.cd = [];
      }
      var m1 = (G, L, v) => {
        for (; L !== v; ) {
          if (!L.eb) throw new dn(`Expected null or instance of ${v.name}, got an instance of ${L.name}`);
          G = L.eb(G), L = L.K;
        }
        return G;
      }, zw = (G) => {
        if (G === null) return "null";
        var L = typeof G;
        return L === "object" || L === "array" || L === "function" ? G.toString() : "" + G;
      };
      function cH(G, L) {
        if (L === null) {
          if (this.Pb) throw new dn(`null is not a valid ${this.name}`);
          return 0;
        }
        if (!L.h) throw new dn(`Cannot pass "${zw(L)}" as a ${this.name}`);
        if (!L.h.u) throw new dn(`Cannot pass deleted object as a pointer of type ${this.name}`);
        return m1(L.h.u, L.h.D.m, this.m);
      }
      function uH(G, L) {
        if (L === null) {
          if (this.Pb) throw new dn(`null is not a valid ${this.name}`);
          if (this.mb) {
            var v = this.ac();
            return G !== null && G.push(this.la, v), v;
          }
          return 0;
        }
        if (!L || !L.h) throw new dn(`Cannot pass "${zw(L)}" as a ${this.name}`);
        if (!L.h.u) throw new dn(`Cannot pass deleted object as a pointer of type ${this.name}`);
        if (!this.lb && L.h.D.lb) throw new dn(`Cannot convert argument of type ${L.h.X ? L.h.X.name : L.h.D.name} to parameter type ${this.name}`);
        if (v = m1(L.h.u, L.h.D.m, this.m), this.mb) {
          if (L.h.N === void 0) throw new dn("Passing raw pointer to smart pointer is illegal");
          switch (this.Pe) {
            case 0:
              if (L.h.X === this) v = L.h.N;
              else throw new dn(`Cannot convert argument of type ${L.h.X ? L.h.X.name : L.h.D.name} to parameter type ${this.name}`);
              break;
            case 1:
              v = L.h.N;
              break;
            case 2:
              if (L.h.X === this) v = L.h.N;
              else {
                var O = L.clone();
                v = this.Ge(v, Yo(() => O.delete())), G !== null && G.push(this.la, v);
              }
              break;
            default:
              throw new dn("Unsupporting sharing policy");
          }
        }
        return v;
      }
      function dH(G, L) {
        if (L === null) {
          if (this.Pb) throw new dn(`null is not a valid ${this.name}`);
          return 0;
        }
        if (!L.h) throw new dn(`Cannot pass "${zw(L)}" as a ${this.name}`);
        if (!L.h.u) throw new dn(`Cannot pass deleted object as a pointer of type ${this.name}`);
        if (L.h.D.lb) throw new dn(`Cannot convert argument of type ${L.h.D.name} to parameter type ${this.name}`);
        return m1(L.h.u, L.h.D.m, this.m);
      }
      var fv = (G, L, v) => L === v ? G : v.K === void 0 ? null : (G = fv(G, L, v.K), G === null ? null : v.Od(G)), hH = (G, L) => (L = Cw(G, L), Fg[L]), b1 = (G, L) => {
        if (!L.D || !L.u) throw new h1("makeClassHandle requires ptr and ptrType");
        if (!!L.X != !!L.N) throw new h1("Both smartPtrType and smartPtr must be specified");
        return L.count = { value: 1 }, E0(Object.create(G, { h: { value: L, writable: !0 } }));
      };
      function Pg(G, L, v, O, U, Y, k, _, st, bt, Ct) {
        this.name = G, this.m = L, this.Pb = v, this.lb = O, this.mb = U, this.De = Y, this.Pe = k, this.dd = _, this.ac = st, this.Ge = bt, this.la = Ct, U || L.K !== void 0 ? this.J = uH : (this.J = O ? cH : dH, this.U = null);
      }
      var gv = (G, L, v) => {
        if (!m.hasOwnProperty(G)) throw new h1("Replacing nonexistent public symbol");
        m[G].H !== void 0 && v !== void 0 ? m[G].H[v] = L : (m[G] = L, m[G].va = v);
      }, pH = (G, L, v = [], O = !1) => {
        function U(k) {
          return G[0] == "p" ? Number(k) : k;
        }
        for (var Y = 1; Y < G.length; ++Y) G[Y] == "p" && (v[Y - 1] = BigInt(v[Y - 1]));
        return L = Vs(L), O && (L = WebAssembly.promising(L)), v = L(...v), O ? v.then(U) : U(v);
      }, mH = (G, L, v = !1) => (...O) => pH(G, L, O, v), Is = (G, L, v = !1) => {
        if (G = os(G), G.includes("p")) v = mH(G, L, v);
        else {
          var O = Vs(L);
          v && (O = WebAssembly.promising(O)), v = O;
        }
        if (typeof v != "function") throw new dn(`unknown function pointer with signature ${G}: ${L}`);
        return v;
      };
      class bH extends Error {
      }
      var Bc = (G, L) => {
        function v(Y) {
          U[Y] || hp[Y] || (d1[Y] ? d1[Y].forEach(v) : (O.push(Y), U[Y] = !0));
        }
        var O = [], U = {};
        throw L.forEach(v), new bH(`${G}: ` + O.map(pv).join([", "]));
      };
      function fH(G, L, v, O, U, Y, k, _, st, bt, Ct, vt, _t) {
        G = xt(G), L = xt(L), v = xt(v), O = xt(O), U = xt(U), Y = xt(Y), k = xt(k), _ = xt(_), st = xt(st), bt = xt(bt), Ct = xt(Ct), vt = xt(vt), _t = xt(_t), Ct = os(Ct), Y = Is(U, Y), _ && (_ = Is(k, _)), bt && (bt = Is(st, bt)), _t = Is(vt, _t);
        var ie = oH(Ct);
        Ow(ie, function() {
          Bc(`Cannot construct ${Ct} due to unbound types`, [O]);
        }), Va([G, L, v], O ? [O] : [], (St) => {
          if (St = St[0], O)
            var Et = St.m, Ut = Et.ha;
          else Ut = p1.prototype;
          St = kg(Ct, function(...hn) {
            if (Object.getPrototypeOf(this) !== ce) throw new dn(`Use 'new' to construct ${Ct}`);
            if (de.wa === void 0) throw new dn(`${Ct} has no accessible constructor`);
            var pi = de.wa[hn.length];
            if (pi === void 0) throw new dn(`Tried to invoke ctor of ${Ct} with invalid number of parameters (${hn.length}) - expected (${Object.keys(de.wa).toString()}) parameters instead!`);
            return pi.apply(this, hn);
          });
          var ce = Object.create(Ut, { constructor: { value: St } });
          St.prototype = ce;
          var de = new lH(Ct, St, ce, _t, Et, Y, _, bt);
          if (de.K) {
            var Oe;
            (Oe = de.K).fb ?? (Oe.fb = []), de.K.fb.push(de);
          }
          return Et = new Pg(Ct, de, !0, !1, !1), Oe = new Pg(Ct + "*", de, !1, !1, !1), Ut = new Pg(Ct + " const*", de, !1, !0, !1), bv[G] = { pointerType: Oe, Kd: Ut }, gv(ie, St), [Et, Oe, Ut];
        });
      }
      function yv(G) {
        for (var L = 1; L < G.length; ++L) if (G[L] !== null && G[L].U === void 0) return !0;
        return !1;
      }
      function f1(G, L, v, O, U, Y) {
        var k = L.length;
        if (2 > k) throw new dn("argTypes array size mismatch! Must at least get return value and 'this' types!");
        var _ = L[1] !== null && v !== null, st = yv(L);
        v = !L[0].Jc;
        var bt = L[0], Ct = L[1];
        for (O = [G, tH, O, U, jg, bt.v.bind(bt), Ct == null ? void 0 : Ct.J.bind(Ct)], U = 2; U < k; ++U) bt = L[U], O.push(bt.J.bind(bt));
        if (!st) for (U = _ ? 1 : 2; U < L.length; ++U) L[U].U !== null && O.push(L[U].U);
        st = yv(L);
        var vt = L.length - 2;
        for (bt = [], U = ["fn"], _ && U.push("thisWired"), k = 0; k < vt; ++k) bt.push(`arg${k}`), U.push(`arg${k}Wired`);
        bt = bt.join(","), U = U.join(","), bt = `return function (${bt}) {
`, st && (bt += `var destructors = [];
`);
        var _t = st ? "destructors" : "null";
        for (Ct = "humanName throwBindingError invoker fn runDestructors fromRetWire toClassParamWire".split(" "), _ && (bt += `var thisWired = toClassParamWire(${_t}, this);
`), k = 0; k < vt; ++k) {
          var ie = `toArg${k}Wire`;
          bt += `var arg${k}Wired = ${ie}(${_t}, arg${k});
`, Ct.push(ie);
        }
        if (vt = v ? "rv" : "", bt = bt + ((v || Y ? "var rv = " : "") + `invoker(${U});
`) + `function onDone(${vt}) {
`, st) bt += `runDestructors(destructors);
`;
        else for (k = _ ? 1 : 2; k < L.length; ++k) _ = k === 1 ? "thisWired" : "arg" + (k - 2) + "Wired", L[k].U !== null && (bt += `${_}_dtor(${_});
`, Ct.push(`${_}_dtor`));
        return v && (bt += `var ret = fromRetWire(rv);
return ret;
`), bt = bt + `}
return ` + ((Y ? "rv.then(onDone)" : `onDone(${vt})`) + `;}
`), L = new Function(Ct, bt)(...O), kg(G, L);
      }
      var g1 = (G, L) => {
        for (var v = [], O = 0; O < G; O++) v.push(Number((E(), ht)[(L + 8 * O) / 8]));
        return v;
      }, Ew = (G) => {
        G = G.trim();
        const L = G.indexOf("(");
        return L === -1 ? G : G.slice(0, L);
      };
      function gH(G, L, v, O, U, Y, k, _) {
        G = xt(G), L = xt(L), O = xt(O), U = xt(U), Y = xt(Y), k = xt(k);
        var st = g1(v, O);
        L = os(L), L = Ew(L), Y = Is(U, Y, _), Va([], [G], (bt) => {
          function Ct() {
            Bc(`Cannot call ${vt} due to unbound types`, st);
          }
          bt = bt[0];
          var vt = `${bt.name}.${L}`;
          L.startsWith("@@") && (L = Symbol[L.substring(2)]);
          var _t = bt.m.constructor;
          return _t[L] === void 0 ? (Ct.va = v - 1, _t[L] = Ct) : (Dw(_t, L, vt), _t[L].H[v - 1] = Ct), Va([], st, (ie) => {
            if (ie = [ie[0], null].concat(ie.slice(1)), ie = f1(vt, ie, null, Y, k, _), _t[L].H === void 0 ? (ie.va = v - 1, _t[L] = ie) : _t[L].H[v - 1] = ie, bt.m.fb) for (const St of bt.m.fb) St.constructor.hasOwnProperty(L) || (St.constructor[L] = ie);
            return [];
          }), [];
        });
      }
      function yH(G, L, v, O, U, Y, k, _) {
        G = xt(G), L = xt(L), v = xt(v), O = xt(O), U = xt(U), Y = xt(Y), k = xt(k), _ = xt(_), L = os(L), Y = Is(U, Y), Va([], [G], (st) => {
          st = st[0];
          var bt = `${st.name}.${L}`, Ct = { get() {
            Bc(`Cannot access ${bt} due to unbound types`, [v]);
          }, enumerable: !0, configurable: !0 };
          return Ct.set = _ ? () => {
            Bc(`Cannot access ${bt} due to unbound types`, [v]);
          } : () => {
            throw new dn(`${bt} is a read-only property`);
          }, Object.defineProperty(st.m.constructor, L, Ct), Va([], [v], (vt) => {
            vt = vt[0];
            var _t = { get() {
              return vt.v(Y(O));
            }, enumerable: !0 };
            return _ && (_ = Is(k, _), _t.set = (ie) => {
              var St = [];
              _(O, vt.J(
                St,
                ie
              )), jg(St);
            }), Object.defineProperty(st.m.constructor, L, _t), [];
          }), [];
        });
      }
      function ZH(G, L, v, O, U, Y) {
        G = xt(G), v = xt(v), O = xt(O), U = xt(U), Y = xt(Y);
        var k = g1(L, v);
        U = Is(O, U), Va([], [G], (_) => {
          _ = _[0];
          var st = `constructor ${_.name}`;
          if (_.m.wa === void 0 && (_.m.wa = []), _.m.wa[L - 1] !== void 0) throw new dn(`Cannot register multiple constructors with identical number of parameters (${L - 1}) for class '${_.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
          return _.m.wa[L - 1] = () => {
            Bc(`Cannot construct ${_.name} due to unbound types`, k);
          }, Va([], k, (bt) => (bt.splice(
            1,
            0,
            null
          ), _.m.wa[L - 1] = f1(st, bt, null, U, Y), [])), [];
        });
      }
      function TH(G, L, v, O, U, Y, k, _, st) {
        G = xt(G), L = xt(L), O = xt(O), U = xt(U), Y = xt(Y), k = xt(k);
        var bt = g1(v, O);
        L = os(L), L = Ew(L), Y = Is(U, Y, st), Va([], [G], (Ct) => {
          function vt() {
            Bc(`Cannot call ${_t} due to unbound types`, bt);
          }
          Ct = Ct[0];
          var _t = `${Ct.name}.${L}`;
          L.startsWith("@@") && (L = Symbol[L.substring(2)]), _ && Ct.m.cd.push(L);
          var ie = Ct.m.ha, St = ie[L];
          return St === void 0 || St.H === void 0 && St.className !== Ct.name && St.va === v - 2 ? (vt.va = v - 2, vt.className = Ct.name, ie[L] = vt) : (Dw(ie, L, _t), ie[L].H[v - 2] = vt), Va([], bt, (Et) => (Et = f1(_t, Et, Ct, Y, k, st), ie[L].H === void 0 ? (Et.va = v - 2, ie[L] = Et) : ie[L].H[v - 2] = Et, [])), [];
        });
      }
      var Zv = (G, L, v) => {
        if (!(G instanceof Object)) throw new dn(`${v} with invalid "this": ${G}`);
        if (!(G instanceof L.m.constructor)) throw new dn(`${v} incompatible with "this" of type ${G.constructor.name}`);
        if (!G.h.u) throw new dn(`cannot call emscripten binding method ${v} on deleted object`);
        return m1(G.h.u, G.h.D.m, L.m);
      };
      function MH(G, L, v, O, U, Y, k, _, st, bt) {
        G = xt(G), L = xt(L), v = xt(v), O = xt(O), U = xt(U), Y = xt(Y), k = xt(k), _ = xt(_), st = xt(st), bt = xt(bt), L = os(L), U = Is(O, U), Va([], [G], (Ct) => {
          Ct = Ct[0];
          var vt = `${Ct.name}.${L}`, _t = { get() {
            Bc(`Cannot access ${vt} due to unbound types`, [v, k]);
          }, enumerable: !0, configurable: !0 };
          return _t.set = st ? () => Bc(`Cannot access ${vt} due to unbound types`, [v, k]) : () => {
            throw new dn(vt + " is a read-only property");
          }, Object.defineProperty(Ct.m.ha, L, _t), Va([], st ? [v, k] : [v], (ie) => {
            var St = ie[0], Et = { get() {
              var ce = Zv(this, Ct, vt + " getter");
              return St.v(U(Y, ce));
            }, enumerable: !0 };
            if (st) {
              st = Is(_, st);
              var Ut = ie[1];
              Et.set = function(ce) {
                var de = Zv(this, Ct, vt + " setter"), Oe = [];
                st(bt, de, Ut.J(Oe, ce)), jg(Oe);
              };
            }
            return Object.defineProperty(Ct.m.ha, L, Et), [];
          }), [];
        });
      }
      function kw(G) {
        G = xt(G), 9 < G && --dp[G + 1] === 0 && (dp[G] = void 0, hv.push(G));
      }
      var Tv = { name: "emscripten::val", v: (G) => {
        var L = Ur(G);
        return kw(G), L;
      }, J: (G, L) => Yo(L), aa: Ug, U: null };
      function NH(G) {
        return G = xt(G), vo(G, Tv);
      }
      var WH = (G, L, v) => {
        switch (L) {
          case 1:
            return v ? function(O) {
              return this.v((E(), Gt)[O]);
            } : function(O) {
              return this.v((E(), Tt)[O]);
            };
          case 2:
            return v ? function(O) {
              return this.v((E(), Q)[O / 2]);
            } : function(O) {
              return this.v((E(), D)[O / 2]);
            };
          case 4:
            return v ? function(O) {
              return this.v((E(), q)[O / 4]);
            } : function(O) {
              return this.v((E(), nt)[O / 4]);
            };
          default:
            throw new TypeError(`invalid integer width (${L}): ${G}`);
        }
      };
      function GH(G, L, v, O) {
        function U() {
        }
        G = xt(G), L = xt(L), v = xt(v), L = os(L), U.values = {}, vo(G, { name: L, constructor: U, v: function(Y) {
          return this.constructor.values[Y];
        }, J: (Y, k) => k.value, aa: WH(L, v, O), U: null }), Ow(L, U);
      }
      function wH(G, L, v) {
        G = xt(G), L = xt(L);
        var O = Yw(G, "enum");
        L = os(L), G = O.constructor, O = Object.create(O.constructor.prototype, { value: { value: v }, constructor: { value: kg(`${O.name}_${L}`, function() {
        }) } }), G.values[v] = O, G[L] = O;
      }
      var xH = (G, L) => {
        switch (L) {
          case 4:
            return function(v) {
              return this.v((E(), et)[v / 4]);
            };
          case 8:
            return function(v) {
              return this.v((E(), ot)[v / 8]);
            };
          default:
            throw new TypeError(`invalid float width (${L}): ${G}`);
        }
      };
      function SH(G, L, v) {
        G = xt(G), L = xt(L), v = xt(v), L = os(L), vo(G, { name: L, v: (O) => O, J: (O, U) => U, aa: xH(L, v), U: null });
      }
      function LH(G, L, v, O, U, Y, k) {
        G = xt(G), v = xt(v), O = xt(O), U = xt(U), Y = xt(Y);
        var _ = g1(L, v);
        G = os(G), G = Ew(G), U = Is(O, U, k), Ow(G, function() {
          Bc(`Cannot call ${G} due to unbound types`, _);
        }, L - 1), Va([], _, (st) => (st = [st[0], null].concat(st.slice(1)), gv(G, f1(G, st, null, U, Y, k), L - 1), []));
      }
      function VH(G, L, v, O, U) {
        G = xt(G), L = xt(L), v = xt(v), L = os(L);
        let Y = (_) => _;
        if (O === 0) {
          var k = 32 - 8 * v;
          Y = (_) => _ << k >>> k, U = Y(U);
        }
        vo(G, { name: L, v: Y, J: (_, st) => st, aa: mv(L, v, O !== 0), U: null });
      }
      function XH(G, L, v) {
        function O(Y) {
          var k = Number((E(), ht)[Y / 8]);
          return Y = Number((E(), ht)[(Y + 8) / 8]), new U((E(), Gt).buffer, Y, k);
        }
        G = xt(G), v = xt(v);
        var U = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array, BigInt64Array, BigUint64Array][L];
        v = os(v), vo(G, { name: v, v: O, aa: O }, { le: !0 });
      }
      var IH = Object.assign({ optional: !0 }, Tv);
      function CH(G) {
        G = xt(G), vo(G, IH);
      }
      function YH(G, L, v, O, U, Y, k, _, st, bt, Ct, vt) {
        G = xt(G), L = xt(L), v = xt(v), U = xt(U), Y = xt(Y), k = xt(k), _ = xt(_), st = xt(st), bt = xt(bt), Ct = xt(Ct), vt = xt(vt), v = os(v), Y = Is(U, Y), _ = Is(k, _), bt = Is(st, bt), vt = Is(Ct, vt), Va([G], [L], (_t) => (_t = _t[0], [new Pg(v, _t.m, !1, !1, !0, _t, O, Y, _, bt, vt)]));
      }
      function vH(G, L) {
        G = xt(G), L = xt(L), L = os(L), vo(G, { name: L, v(v) {
          var O = Number((E(), ht)[v / 8]);
          return O = Sn(v + 8, O, !0), ll(v), O;
        }, J(v, O) {
          O instanceof ArrayBuffer && (O = new Uint8Array(O));
          var U = typeof O == "string";
          if (!(U || ArrayBuffer.isView(O) && O.BYTES_PER_ELEMENT == 1)) throw new dn("Cannot pass non-string to std::string");
          var Y = U ? D0(O) : O.length, k = As(8 + Y + 1), _ = k + 8;
          return (E(), ht)[k / 8] = BigInt(Y), U ? jr(O, _, Y + 1) : (E(), Tt).set(O, _), v !== null && v.push(ll, k), k;
        }, aa: Ug, U(v) {
          ll(v);
        } });
      }
      var Mv = typeof TextDecoder < "u" ? new TextDecoder("utf-16le") : void 0, RH = (G, L, v) => {
        if (G /= 2, L = ZY((E(), D), G, L / 2, v), 16 < L - G && Mv) return Mv.decode((E(), D).buffer instanceof ArrayBuffer ? (E(), D).subarray(G, L) : (E(), D).slice(G, L));
        for (v = ""; G < L; ++G) {
          var O = (E(), D)[G];
          v += String.fromCharCode(O);
        }
        return v;
      }, DH = (G, L, v) => {
        if (v ?? (v = 2147483647), 2 > v) return 0;
        v -= 2;
        var O = L;
        v = v < 2 * G.length ? v / 2 : G.length;
        for (var U = 0; U < v; ++U) {
          var Y = G.charCodeAt(U);
          (E(), Q)[L / 2] = Y, L += 2;
        }
        return (E(), Q)[L / 2] = 0, L - O;
      }, OH = (G) => 2 * G.length, zH = (G, L, v) => {
        var O = "";
        G /= 4;
        for (var U = 0; !(U >= L / 4); U++) {
          var Y = (E(), nt)[G + U];
          if (!Y && !v) break;
          O += String.fromCodePoint(Y);
        }
        return O;
      }, EH = (G, L, v) => {
        if (v ?? (v = 2147483647), 4 > v) return 0;
        var O = L;
        v = O + v - 4;
        for (var U = 0; U < G.length; ++U) {
          var Y = G.codePointAt(U);
          if (65535 < Y && U++, (E(), q)[L / 4] = Y, L += 4, L + 4 > v) break;
        }
        return (E(), q)[L / 4] = 0, L - O;
      }, kH = (G) => {
        for (var L = 0, v = 0; v < G.length; ++v) 65535 < G.codePointAt(v) && v++, L += 4;
        return L;
      };
      function FH(G, L, v) {
        if (G = xt(G), L = xt(L), v = xt(v), v = os(v), L === 2)
          var O = RH, U = DH, Y = OH;
        else O = zH, U = EH, Y = kH;
        vo(G, { name: v, v: (k) => {
          var _ = Number((E(), ht)[k / 8]);
          return _ = O(k + 8, _ * L, !0), ll(k), _;
        }, J: (k, _) => {
          if (typeof _ != "string") throw new dn(`Cannot pass non-string to C++ string type ${v}`);
          var st = Y(_), bt = As(8 + st + L);
          return (E(), ht)[bt / 8] = BigInt(st / L), U(_, bt + 8, st + L), k !== null && k.push(ll, bt), bt;
        }, aa: Ug, U(k) {
          ll(k);
        } });
      }
      function jH(G, L, v, O, U, Y) {
        G = xt(G), L = xt(L), v = xt(v), O = xt(O), U = xt(U), Y = xt(Y), u1[G] = { name: os(L), ac: Is(v, O), la: Is(U, Y), elements: [] };
      }
      function UH(G, L, v, O, U, Y, k, _, st) {
        G = xt(G), L = xt(L), v = xt(v), O = xt(O), U = xt(U), Y = xt(Y), k = xt(k), _ = xt(_), st = xt(st), u1[G].elements.push({ ae: L, Ya: Is(v, O), $d: U, Ne: Y, Me: Is(k, _), Oe: st });
      }
      function PH(G, L) {
        G = xt(G), L = xt(L), L = os(L), vo(G, { Jc: !0, name: L, v: () => {
        }, J: () => {
        } });
      }
      function JH(G) {
        G = xt(G), gx(G, !y, 1, !b, 33554432, !1), rn();
      }
      function AH(G, L) {
        if (L = xt(L), L = Sn(L), G & 24) {
          var v = L = L.replace(/\s+$/, "");
          L = 0 < L.length ? `
` : "";
          var O = Error().stack.toString(), U = O.split(`
`);
          O = "";
          var Y = RegExp("\\s*(.*?)@(.*?):([0-9]+):([0-9]+)"), k = RegExp("\\s*at (.*?) \\((.*):(.*):(.*)\\)"), _;
          for (_ of U) {
            var st = k.exec(_);
            if ((st == null ? void 0 : st.length) == 5) {
              U = st[1];
              var bt = st[2], Ct = st[3];
              st = st[4];
            } else if (st = Y.exec(_), 4 <= (st == null ? void 0 : st.length)) U = st[1], bt = st[2], Ct = st[3], st = st[4] | 0;
            else {
              O += _ + `
`;
              continue;
            }
            U == "_emscripten_log" || U == "_emscripten_get_callstack" ? O = "" : G & 24 && (G & 64 && (bt = bt.substring(bt.replace(
              /\\/g,
              "/"
            ).lastIndexOf("/") + 1)), O += `    at ${U} (${bt}:${Ct}:${st})
`);
          }
          O = O.replace(/\s+$/, ""), L = v + (L + O);
        }
        G & 1 ? G & 4 ? console.error(L) : G & 2 ? console.warn(L) : G & 512 ? console.info(L) : G & 256 ? console.debug(L) : console.log(L) : G & 6 ? P(L) : F(L);
      }
      var Nv = () => {
        if (!(cp || 0 < ne)) try {
          g ? $g() && yx($) : je($);
        } catch (G) {
          G instanceof fe || G == "unwind" || M(1, G);
        }
      }, Kc = (G) => {
        if (!B) try {
          G(), Nv();
        } catch (L) {
          L instanceof fe || L == "unwind" || M(1, L);
        }
      };
      function Fw(G) {
        G = xt(G), typeof Atomics.waitAsync == "function" && (Atomics.waitAsync((E(), q), G / 4, G).value.then(y1), G += 228, Atomics.store((E(), q), G / 4, 1));
      }
      var y1 = () => Kc(() => {
        var G = $g();
        G && (Fw(G), jR());
      });
      function BH(G, L) {
        G = xt(G), L = xt(L), G == L ? setTimeout(y1) : g ? postMessage({ wb: G, fa: "checkMailbox" }) : (G = ys[G]) && G.postMessage({ fa: "checkMailbox" });
      }
      var Z1 = [];
      function KH(G, L, v, O, U) {
        L = xt(L), v = xt(v), U = xt(U), O /= 2, Z1.length = O, U /= 8;
        for (var Y = 0; Y < O; Y++) (E(), it)[U + 2 * Y] ? Z1[Y] = (E(), it)[U + 2 * Y + 1] : Z1[Y] = (E(), ot)[U + 2 * Y + 1];
        return G = L ? RR[L] : i7[G], Zw = v, v = G(...Z1), Zw = 0, typeof v == "bigint" && (v = xt(v)), v;
      }
      var HH = () => {
        cp = !1, ne = 0;
      };
      function _H(G) {
        G = xt(G), g ? postMessage({ fa: "cleanupThread", We: G }) : be(ys[G]);
      }
      function QH(G) {
        G = xt(G), Z && ys[G].ref();
      }
      var jw = [], $H = (G) => {
        var L = jw.length;
        return jw.push(G), L;
      }, qH = (G, L) => {
        for (var v = Array(G), O = 0; O < G; ++O) v[O] = Yw(Number((E(), ht)[(L + 8 * O) / 8]), `parameter ${O}`);
        return v;
      }, t_ = (G, L, v) => {
        var O = [];
        return G = G(O, v), O.length && ((E(), ht)[L / 8] = BigInt(Yo(O))), G;
      }, e_ = {}, T1 = (G) => {
        var L = e_[G];
        return L === void 0 ? os(G) : L;
      };
      function n_(G, L, v) {
        L = xt(L);
        var O = (() => {
          var [U, ...Y] = qH(G, L), k = U.J.bind(U), _ = Y.map((Ct) => Ct.aa.bind(Ct));
          G--;
          var st = { toValue: Ur };
          switch (_ = _.map((Ct, vt) => {
            var _t = `argFromPtr${vt}`;
            return st[_t] = Ct, `${_t}(args${vt ? "+" + 16 * vt : ""})`;
          }), v) {
            case 0:
              var bt = "toValue(handle)";
              break;
            case 2:
              bt = "new (toValue(handle))";
              break;
            case 3:
              bt = "";
              break;
            case 1:
              st.getStringOrSymbol = T1, bt = "toValue(handle)[getStringOrSymbol(methodName)]";
          }
          return bt += `(${_})`, U.Jc || (st.toReturnWire = k, st.emval_returnValue = t_, bt = `return emval_returnValue(toReturnWire, destructorsRef, ${bt})`), bt = `return function (handle, methodName, destructorsRef, args) {
  ${bt}
  }`, k = new Function(Object.keys(st), bt)(...Object.values(st)), bt = `methodCaller<(${Y.map((Ct) => Ct.name)}) => ${U.name}>`, $H(kg(bt, k));
        })();
        return BigInt(O);
      }
      function i_(G, L) {
        return G = xt(G), L = xt(L), G = Ur(G), L = Ur(L), G == L;
      }
      var Wv = globalThis;
      function s_(G) {
        return G = xt(G), G ? (G = T1(G), G = Yo(Wv[G])) : G = Yo(Wv), BigInt(G);
      }
      function r_(G) {
        return G = xt(G), G = T1(G), G = Yo(m[G]), BigInt(G);
      }
      function a_(G, L) {
        return G = xt(G), L = xt(L), G = Ur(G), L = Ur(L), G = Yo(G[L]), BigInt(G);
      }
      function o_(G) {
        G = xt(G), 9 < G && (dp[G + 1] += 1);
      }
      function l_(G, L) {
        return G = xt(G), L = xt(L), G = Ur(G), L = Ur(L), G instanceof L;
      }
      function Gv(G, L, v, O, U) {
        return G = xt(G), L = xt(L), v = xt(v), O = xt(O), U = xt(U), jw[G](L, v, O, U);
      }
      function c_(G) {
        return G = xt(G), G = Ur(G), typeof G == "number";
      }
      function u_(G) {
        return G = xt(G), G = Ur(G), typeof G == "string";
      }
      var d_ = () => BigInt(Yo([])), h_ = (G) => (G = xt(G), BigInt(Yo(T1(G)))), p_ = () => BigInt(Yo({}));
      function m_(G) {
        G = xt(G);
        var L = Ur(G);
        jg(L), kw(G);
      }
      function b_(G, L, v) {
        G = xt(G), L = xt(L), v = xt(v), G = Ur(G), L = Ur(L), v = Ur(v), G[L] = v;
      }
      function f_(G) {
        return G = xt(G), G = Ur(G), G = Yo(typeof G), BigInt(G);
      }
      function g_(G, L) {
        G = xt(G), L = xt(L), G = new Date(1e3 * G), (E(), q)[L / 4] = G.getUTCSeconds(), (E(), q)[(L + 4) / 4] = G.getUTCMinutes(), (E(), q)[(L + 8) / 4] = G.getUTCHours(), (E(), q)[(L + 12) / 4] = G.getUTCDate(), (E(), q)[(L + 16) / 4] = G.getUTCMonth(), (E(), q)[(L + 20) / 4] = G.getUTCFullYear() - 1900, (E(), q)[(L + 24) / 4] = G.getUTCDay(), G = (G.getTime() - Date.UTC(G.getUTCFullYear(), 0, 1, 0, 0, 0, 0)) / 864e5 | 0, (E(), q)[(L + 28) / 4] = G;
      }
      var wv = (G) => G % 4 === 0 && (G % 100 !== 0 || G % 400 === 0), xv = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335], Sv = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
      function y_(G, L) {
        G = xt(G), L = xt(L), G = new Date(1e3 * G), (E(), q)[L / 4] = G.getSeconds(), (E(), q)[(L + 4) / 4] = G.getMinutes(), (E(), q)[(L + 8) / 4] = G.getHours(), (E(), q)[(L + 12) / 4] = G.getDate(), (E(), q)[(L + 16) / 4] = G.getMonth(), (E(), q)[(L + 20) / 4] = G.getFullYear() - 1900, (E(), q)[(L + 24) / 4] = G.getDay();
        var v = (wv(G.getFullYear()) ? xv : Sv)[G.getMonth()] + G.getDate() - 1 | 0;
        (E(), q)[(L + 28) / 4] = v, (E(), it)[(L + 40) / 8] = BigInt(-(60 * G.getTimezoneOffset())), v = new Date(G.getFullYear(), 6, 1).getTimezoneOffset();
        var O = new Date(G.getFullYear(), 0, 1).getTimezoneOffset();
        G = (v != O && G.getTimezoneOffset() == Math.min(O, v)) | 0, (E(), q)[(L + 32) / 4] = G;
      }
      function Z_(G) {
        G = xt(G);
        var L = new Date((E(), q)[(G + 20) / 4] + 1900, (E(), q)[(G + 16) / 4], (E(), q)[(G + 12) / 4], (E(), q)[(G + 8) / 4], (E(), q)[(G + 4) / 4], (E(), q)[G / 4], 0), v = (E(), q)[(G + 32) / 4], O = L.getTimezoneOffset(), U = new Date(L.getFullYear(), 6, 1).getTimezoneOffset(), Y = new Date(L.getFullYear(), 0, 1).getTimezoneOffset(), k = Math.min(Y, U);
        return 0 > v ? (E(), q)[(G + 32) / 4] = +(U != Y && k == O) : 0 < v != (k == O) && (U = Math.max(Y, U), L.setTime(L.getTime() + 6e4 * ((0 < v ? k : U) - O))), (E(), q)[(G + 24) / 4] = L.getDay(), v = (wv(L.getFullYear()) ? xv : Sv)[L.getMonth()] + L.getDate() - 1 | 0, (E(), q)[(G + 28) / 4] = v, (E(), q)[G / 4] = L.getSeconds(), (E(), q)[(G + 4) / 4] = L.getMinutes(), (E(), q)[(G + 8) / 4] = L.getHours(), (E(), q)[(G + 12) / 4] = L.getDate(), (E(), q)[(G + 16) / 4] = L.getMonth(), (E(), q)[(G + 20) / 4] = L.getYear(), G = L.getTime(), BigInt(isNaN(G) ? -1 : G / 1e3);
      }
      function Lv(G, L, v, O, U, Y, k) {
        if (g) return ae(34, 1, G, L, v, O, U, Y, k);
        G = xt(G), U = xt(U), Y = xt(Y), k = xt(k);
        try {
          var _ = Xs(O), st = It.za(_, G, U, L, v), bt = st.u;
          return (E(), q)[Y / 4] = st.qc, (E(), ht)[k / 8] = BigInt(bt), 0;
        } catch (Ct) {
          if (typeof It > "u" || Ct.name !== "ErrnoError") throw Ct;
          return -Ct.l;
        }
      }
      function Vv(G, L, v, O, U, Y) {
        if (g) return ae(35, 1, G, L, v, O, U, Y);
        G = xt(G), L = xt(L), Y = xt(Y);
        try {
          var k = Xs(U);
          if (v & 2) {
            if (!It.isFile(k.node.mode)) throw new It.g(43);
            if (!(O & 2)) {
              var _ = (E(), Tt).slice(G, G + L);
              It.La(k, _, Y, L, O);
            }
          }
        } catch (st) {
          if (typeof It > "u" || st.name !== "ErrnoError") throw st;
          return -st.l;
        }
      }
      function T_(G, L, v, O) {
        G = xt(G), L = xt(L), v = xt(v), O = xt(O);
        var U = (/* @__PURE__ */ new Date()).getFullYear(), Y = new Date(U, 0, 1).getTimezoneOffset();
        U = new Date(U, 6, 1).getTimezoneOffset();
        var k = Math.max(Y, U);
        (E(), ht)[G / 8] = BigInt(60 * k), (E(), q)[L / 4] = +(Y != U), L = (_) => {
          var st = Math.abs(_);
          return `UTC${0 <= _ ? "-" : "+"}${String(Math.floor(st / 60)).padStart(2, "0")}${String(st % 60).padStart(2, "0")}`;
        }, G = L(Y), L = L(U), U < Y ? (jr(G, v, 17), jr(L, O, 17)) : (jr(G, O, 17), jr(L, v, 17));
      }
      var M_ = () => performance.timeOrigin + performance.now(), N_ = () => Date.now();
      function W_(G, L, v) {
        return v = xt(v), 0 <= G && 3 >= G ? (G === 0 ? G = Date.now() : G = performance.timeOrigin + performance.now(), G = Math.round(1e6 * G), (E(), it)[v / 8] = BigInt(G), 0) : 28;
      }
      var Uw = [];
      function G_(G, L, v) {
        G = xt(G), L = xt(L), v = xt(v), Uw.length = 0;
        for (var O; O = (E(), Tt)[L++]; ) {
          var U = O != 105;
          v += U && v % 8 ? 4 : 0, Uw.push(O == 112 ? Number((E(), ht)[v / 8]) : O == 106 ? (E(), it)[v / 8] : O == 105 ? (E(), q)[v / 4] : (E(), ot)[v / 8]), v += U ? 8 : 4;
        }
        return RR[G](...Uw);
      }
      var Pw = (G, L) => (ne += 1, setTimeout(() => {
        --ne, Kc(G);
      }, L)), Jw = (G, L) => {
        if (W1 = G, G1 = L, N1) {
          if (Aw || (ne += 1, Aw = !0), G == 0) Md = function() {
            setTimeout(Ag, Math.max(0, Ov + L - (performance.timeOrigin + performance.now())) | 0);
          };
          else if (G == 1) Md = function() {
            Hw(Ag);
          };
          else if (G == 2) {
            if (typeof w1 > "u") if (typeof setImmediate > "u") {
              var v = [];
              addEventListener("message", (O) => {
                (O.data === "setimmediate" || O.data.target === "setimmediate") && (O.stopPropagation(), v.shift()());
              }, !0), w1 = (O) => {
                v.push(O), y ? (m.setImmediates ?? (m.setImmediates = []), m.setImmediates.push(O), postMessage({ target: "setimmediate" })) : postMessage("setimmediate", "*");
              };
            } else w1 = setImmediate;
            Md = function() {
              w1(Ag);
            };
          }
        }
      }, Xv = (G, L, v, O, U) => {
        function Y() {
          return k < M1 ? (--ne, Nv(), !1) : !0;
        }
        N1 = G, Iv = O;
        var k = M1;
        if (Aw = !1, Ag = function() {
          if (!B) {
            if (0 < Cv.length) {
              var _ = Cv.shift();
              _.Jf(_.gb);
              var st, bt;
              m.setStatus && (_ = m.statusMessage || "Please wait...", st = 0, bt = Dv.Af ?? 0, st ? st < bt ? m.setStatus("{message} ({expected - remaining}/{expected})") : m.setStatus(_) : m.setStatus("")), Y() && setTimeout(Ag, 0);
            } else if (Y()) if (Bw = Bw + 1 | 0, W1 == 1 && 1 < G1 && Bw % G1 != 0) Md();
            else {
              W1 == 0 && (Ov = performance.timeOrigin + performance.now());
              t: if (!B) {
                for (_ of Kw) if (_() === !1) break t;
                Kc(G);
                for (st of Yv) st();
              }
              Y() && Md();
            }
          }
        }, U || (0 < L ? Jw(0, 1e3 / L) : Jw(1, 1), Md()), v) throw "unwind";
      }, Aw = !1, Md = null, M1 = 0, N1 = null, Iv = 0, W1 = 0, G1 = 0, Bw = 0, Cv = [], Kw = [], Yv = [];
      function vv() {
        Md = null, M1++;
      }
      function Rv() {
        M1++;
        var G = W1, L = G1, v = N1;
        N1 = null, Xv(v, 0, !1, Iv, !0), Jw(G, L), Md();
      }
      var Jg = 0;
      function Hw(G) {
        if (typeof requestAnimationFrame == "function") requestAnimationFrame(G);
        else {
          var L = Date.now();
          if (Jg === 0) Jg = L + 16.666666666666668;
          else for (; L + 2 >= Jg; ) Jg += 16.666666666666668;
          setTimeout(G, Math.max(Jg - L, 0));
        }
      }
      var Dv = {}, Ov, Ag, w1, w_ = (G) => {
        ne += 1, Hw(() => {
          --ne, Kc(G);
        });
      };
      function x_(G, L, v) {
        G = xt(G), L = xt(L);
        var O = () => {
          var U = L;
          return Vs(G).call(null, BigInt(U));
        };
        0 <= v || Z ? Pw(O, v) : w_(O);
      }
      var S_ = () => {
      };
      function L_(G) {
        G = xt(G), console.trace(Sn(G));
      }
      function V_(G) {
        return G = xt(G), P(Sn(G));
      }
      function X_(G, L) {
        return G = xt(G), L = xt(L), P(Sn(G, L));
      }
      var I_ = () => {
        throw ne += 1, "unwind";
      };
      function zv(G) {
        if (g) return ae(36, 1, G);
        cp = !1, ne = 0, je(G);
      }
      var Ev = [0, typeof document < "u" ? document : 0, typeof window < "u" ? window : 0], Nd = (G) => (G = 2 < G ? Sn(G) : G, Ev[G] || (typeof document < "u" ? document.querySelector(G) : null)), _w = (G) => 0 > Ev.indexOf(G) ? G.getBoundingClientRect() : { left: 0, top: 0 };
      function kv(G, L, v) {
        return g ? ae(37, 1, G, L, v) : (G = xt(G), L = xt(L), v = xt(v), G = Nd(G), G ? (G = _w(G), (E(), ot)[L / 8] = G.width, (E(), ot)[v / 8] = G.height, 0) : -4);
      }
      var C_ = () => BigInt(8589934592), Fv = {};
      function Y_(G, L) {
        var v = Fv[G];
        if (v) L(null, v);
        else {
          try {
            var O = indexedDB.open(G, 22);
          } catch (U) {
            L(U);
            return;
          }
          O.onupgradeneeded = (U) => {
            var Y = U.target.result;
            U = U.target.transaction, Y.objectStoreNames.contains("FILE_DATA") ? U.objectStore("FILE_DATA") : Y.createObjectStore("FILE_DATA");
          }, O.onsuccess = () => {
            v = O.result, Fv[G] = v, L(null, v);
          }, O.onerror = function(U) {
            L(U.target.error || "unknown error"), U.preventDefault();
          };
        }
      }
      function x1(G, L, v) {
        Y_(G, (O, U) => {
          if (O) return v(O);
          O = U.transaction(["FILE_DATA"], L), O.onerror = (Y) => {
            v(Y.target.error || "unknown error"), Y.preventDefault();
          }, O = O.objectStore("FILE_DATA"), v(null, O);
        });
      }
      function v_(G, L, v) {
        x1(G, "readonly", (O, U) => {
          if (O) return v(O);
          O = U.get(L), O.onsuccess = (Y) => (Y = Y.target.result) ? v(null, Y) : v(`file ${L} not found`), O.onerror = v;
        });
      }
      function R_(G, L, v, O) {
        x1(G, "readwrite", (U, Y) => {
          if (U) return O(U);
          U = Y.put(v, L), U.onsuccess = () => O(), U.onerror = O;
        });
      }
      function D_(G, L, v) {
        x1(G, "readwrite", (O, U) => {
          if (O) return v(O);
          O = U.delete(L), O.onsuccess = () => v(), O.onerror = v;
        });
      }
      function O_(G, L, v) {
        x1(G, "readonly", (O, U) => {
          if (O) return v(O);
          O = U.count(L), O.onsuccess = (Y) => v(null, 0 < Y.target.result), O.onerror = v;
        });
      }
      function z_(G, L, v, O, U) {
        G = xt(G), L = xt(L), v = xt(v), O = xt(O), U = xt(U), ne += 1, D_(Sn(G), Sn(L), (Y) => {
          --ne, Kc(() => {
            Y ? U && ((k) => Vs(U).call(null, BigInt(k)))(v) : O && ((k) => Vs(O).call(null, BigInt(k)))(v);
          });
        });
      }
      function E_(G, L, v, O, U) {
        G = xt(G), L = xt(L), v = xt(v), O = xt(O), U = xt(U), ne += 1, O_(Sn(G), Sn(L), (Y, k) => {
          --ne, Kc(() => {
            Y ? U && ((_) => Vs(U).call(null, BigInt(_)))(v) : O && ((_, st) => Vs(O).call(null, BigInt(_), st))(v, k);
          });
        });
      }
      function k_(G, L, v, O, U) {
        G = xt(G), L = xt(L), v = xt(v), O = xt(O), U = xt(U), ne += 1, v_(Sn(G), Sn(L), (Y, k) => {
          --ne, Kc(() => {
            if (Y) U && ((st) => Vs(U).call(null, BigInt(st)))(v);
            else {
              var _ = As(k.length);
              (E(), Tt).set(k, _), ((st, bt, Ct) => Vs(O).call(null, BigInt(st), BigInt(bt), Ct))(v, _, k.length), ll(_);
            }
          });
        });
      }
      function F_(G, L, v, O, U, Y, k) {
        G = xt(G), L = xt(L), v = xt(v), U = xt(U), Y = xt(Y), k = xt(k), ne += 1, R_(Sn(G), Sn(L), new Uint8Array((E(), Tt).subarray(v, v + O)), (_) => {
          --ne, Kc(() => {
            _ ? k && ((st) => Vs(k).call(null, BigInt(st)))(U) : Y && ((st) => Vs(Y).call(null, BigInt(st)))(U);
          });
        });
      }
      var Ht, j_ = (G) => {
        var L = G.getExtension("ANGLE_instanced_arrays");
        L && (G.vertexAttribDivisor = (v, O) => L.vertexAttribDivisorANGLE(v, O), G.drawArraysInstanced = (v, O, U, Y) => L.drawArraysInstancedANGLE(v, O, U, Y), G.drawElementsInstanced = (v, O, U, Y, k) => L.drawElementsInstancedANGLE(v, O, U, Y, k));
      }, U_ = (G) => {
        var L = G.getExtension("OES_vertex_array_object");
        L && (G.createVertexArray = () => L.createVertexArrayOES(), G.deleteVertexArray = (v) => L.deleteVertexArrayOES(v), G.bindVertexArray = (v) => L.bindVertexArrayOES(v), G.isVertexArray = (v) => L.isVertexArrayOES(v));
      }, P_ = (G) => {
        var L = G.getExtension("WEBGL_draw_buffers");
        L && (G.drawBuffers = (v, O) => L.drawBuffersWEBGL(v, O));
      }, Qw = (G) => {
        var L = "ANGLE_instanced_arrays EXT_blend_minmax EXT_disjoint_timer_query EXT_frag_depth EXT_shader_texture_lod EXT_sRGB OES_element_index_uint OES_fbo_render_mipmap OES_standard_derivatives OES_texture_float OES_texture_half_float OES_texture_half_float_linear OES_vertex_array_object WEBGL_color_buffer_float WEBGL_depth_texture WEBGL_draw_buffers EXT_clip_control EXT_color_buffer_half_float EXT_depth_clamp EXT_float_blend EXT_polygon_offset_clamp EXT_texture_compression_bptc EXT_texture_compression_rgtc EXT_texture_filter_anisotropic KHR_parallel_shader_compile OES_texture_float_linear WEBGL_blend_func_extended WEBGL_compressed_texture_astc WEBGL_compressed_texture_etc WEBGL_compressed_texture_etc1 WEBGL_compressed_texture_s3tc WEBGL_compressed_texture_s3tc_srgb WEBGL_debug_renderer_info WEBGL_debug_shaders WEBGL_lose_context WEBGL_multi_draw WEBGL_polygon_mode".split(" ");
        return (G.getSupportedExtensions() || []).filter((v) => L.includes(v));
      }, J_ = 1, A_ = [], S1 = [], Pl = {}, jv = [1, 1, 2, 2, 4, 4, 4, 2, 3, 4, 8], Bg = {}, $w = 4, Uv = 0, Pv = [], B_ = (G) => {
        if (G || (G = hi), !G.me) {
          G.me = !0;
          var L = G.Ca;
          G.Gd = L.getExtension("WEBGL_compressed_texture_s3tc"), G.Cd = L.getExtension("EXT_texture_filter_anisotropic"), L.hg = L.getExtension("WEBGL_multi_draw"), L.Cf = L.getExtension("EXT_polygon_offset_clamp"), L.Bf = L.getExtension("EXT_clip_control"), L.Kg = L.getExtension("WEBGL_polygon_mode"), j_(L), U_(L), P_(L), L.yf = L.getExtension("EXT_disjoint_timer_query"), Qw(L).forEach((v) => {
            v.includes("lose_context") || v.includes("debug") || L.getExtension(v);
          });
        }
      }, ls, hi;
      function K_(G) {
        return G = xt(G), !Pl[G] || Pl[G].Ca.isContextLost();
      }
      var H_ = () => Z ? ty.cpus().length : navigator.hardwareConcurrency, __ = () => vv(), pp = {}, F0 = (G) => {
        var L = D0(G) + 1, v = As(L);
        return v && jr(G, v, L), v;
      }, L1 = (G) => {
        var L;
        return (L = /\bwasm-function\[\d+\]:(0x[0-9a-f]+)/.exec(G)) ? +L[1] : (L = /:(\d+):\d+(?:\)|$)/.exec(G)) ? 2147483648 | +L[1] : 0;
      }, Jv = (G) => {
        for (var L of G) (G = L1(L)) && (pp[G] = L);
      };
      function Q_() {
        var G = Error().stack.toString().split(`
`);
        return G[0] == "Error" && G.shift(), Jv(G), pp.Nc = L1(G[3]), pp.ue = G, BigInt(pp.Nc);
      }
      function V1(G) {
        G = xt(G);
        var L = (() => {
          var v = pp[G];
          if (!v) return 0;
          var O;
          if (O = /^\s+at .*\.wasm\.(.*) \(.*\)$/.exec(v)) v = O[1];
          else if (O = /^\s+at (.*) \(.*\)$/.exec(v)) v = O[1];
          else if (O = /^(.+?)@/.exec(v)) v = O[1];
          else return 0;
          return ll(V1.hd ?? 0), V1.hd = F0(v), V1.hd;
        })();
        return BigInt(L);
      }
      var $_ = () => performance.now();
      function q_(G) {
        G = xt(G);
        var L = (E(), Tt).length;
        if (G <= L || 8589934592 < G) return !1;
        for (var v = 1; 4 >= v; v *= 2) {
          var O = L * (1 + 0.2 / v);
          O = Math.min(O, G + 100663296);
          t: {
            O = (Math.min(8589934592, 65536 * Math.ceil(Math.max(G, O) / 65536)) - Zt.buffer.byteLength + 65535) / 65536 | 0;
            try {
              Zt.grow(BigInt(O)), mt();
              var U = 1;
              break t;
            } catch {
            }
            U = void 0;
          }
          if (U) return !0;
        }
        return !1;
      }
      var tQ = () => Rv();
      function qw(G) {
        var L = cn.Y[G];
        L.target.removeEventListener(L.ga, L.Bc, L.Ba), cn.Y.splice(G, 1);
      }
      function Av() {
        if (navigator.userActivation ? navigator.userActivation.isActive : cn.Nb && cn.Md.Ab) {
          var G = cn.sa;
          cn.sa = [];
          for (var L of G) L.ec(...L.sc);
        }
      }
      function j0(G) {
        if (!G.target) return -4;
        if (G.Fa) G.Bc = function(v) {
          ++cn.Nb, cn.Md = G, Av(), G.Ha(v), Av(), --cn.Nb;
        }, G.target.addEventListener(G.ga, G.Bc, G.Ba), cn.Y.push(G);
        else for (var L = 0; L < cn.Y.length; ++L) cn.Y[L].target == G.target && cn.Y[L].ga == G.ga && qw(L--);
        return 0;
      }
      function U0(G) {
        switch (G) {
          case 1:
            return 0;
          case 2:
            return Zw;
          default:
            return G;
        }
      }
      var cn = { bf: 0, Kf: 0, Rb: 0, qb: 0, mc: 0, kc: 0, Eb: 0, wf: 0, kg: 0, vf: 0, If: 0, mg: 0, Jg: 0, ic: 0, dg(G, L, v) {
        (E(), Gt).set((E(), Gt).subarray(L, L + v), G);
      }, rg() {
        for (; cn.Y.length; ) qw(cn.Y.length - 1);
        cn.sa = [];
      }, Nb: 0, sa: [], tf(G, L, v) {
        function O(Y, k) {
          if (Y.length != k.length) return !1;
          for (var _ in Y) if (Y[_] != k[_]) return !1;
          return !0;
        }
        for (var U of cn.sa) if (U.ec == G && O(U.sc, v)) return;
        cn.sa.push({ ec: G, ad: L, sc: v }), cn.sa.sort((Y, k) => Y.ad < k.ad);
      }, sg(G) {
        cn.sa = cn.sa.filter((L) => L.ec != G);
      }, Y: [], Ie: (G, L) => {
        for (var v = 0; v < cn.Y.length; ++v) cn.Y[v].target != G || L && L != cn.Y[v].ga || qw(v--);
      }, fullscreenEnabled() {
        return document.fullscreenEnabled;
      } }, eQ = (G, L, v, O, U) => (U = U0(U), cn.Eb || (cn.Eb = As(256)), G = { target: Nd(G), ga: "focus", Fa: O, Ha: (Y = event) => {
        var k = (k = Y.target) ? k == window ? "#window" : k == screen ? "#screen" : (k == null ? void 0 : k.nodeName) || "" : "", _ = Y.target.id ? Y.target.id : "", st = U ? As(256) : cn.Eb;
        jr(k, st + 0, 128), jr(_, st + 128, 128), U ? bp(U, O, 13, st, L) : Vs(O).call(null, 13, BigInt(st), BigInt(L)) && Y.preventDefault();
      }, Ba: v }, j0(G));
      function Bv(G, L, v, O, U) {
        return g ? ae(38, 1, G, L, v, O, U) : (G = xt(G), L = xt(L), O = xt(O), U = xt(U), eQ(G, L, v, O, U));
      }
      var Kv = (G, L, v, O, U, Y, k) => (k = U0(k), cn.Rb || (cn.Rb = As(160)), G = { target: Nd(G), ga: Y, Fa: O, Ha: (_) => {
        var st = k ? As(160) : cn.Rb;
        (E(), ot)[st / 8] = _.timeStamp;
        var bt = st / 4;
        (E(), q)[bt + 2] = _.location, (E(), Gt)[st + 12] = _.ctrlKey, (E(), Gt)[st + 13] = _.shiftKey, (E(), Gt)[st + 14] = _.altKey, (E(), Gt)[st + 15] = _.metaKey, (E(), Gt)[st + 16] = _.repeat, (E(), q)[bt + 5] = _.charCode, (E(), q)[bt + 6] = _.keyCode, (E(), q)[bt + 7] = _.which, jr(_.key || "", st + 32, 32), jr(_.code || "", st + 64, 32), jr(_.char || "", st + 96, 32), jr(_.locale || "", st + 128, 32), k ? bp(k, O, U, st, L) : Vs(O).call(null, U, BigInt(st), BigInt(L)) && _.preventDefault();
      }, Ba: v }, j0(G));
      function Hv(G, L, v, O, U) {
        return g ? ae(39, 1, G, L, v, O, U) : (G = xt(G), L = xt(L), O = xt(O), U = xt(U), Kv(G, L, v, O, 2, "keydown", U));
      }
      function _v(G, L, v, O, U) {
        return g ? ae(40, 1, G, L, v, O, U) : (G = xt(G), L = xt(L), O = xt(O), U = xt(U), Kv(G, L, v, O, 3, "keyup", U));
      }
      function nQ(G, L, v, O) {
        G = xt(G), L = xt(L), Xv(() => {
          var U = L;
          return Vs(G).call(null, BigInt(U));
        }, v, O, L);
      }
      var tx = (G, L, v) => {
        (E(), ot)[G / 8] = L.timeStamp;
        var O = G / 4;
        (E(), q)[O + 2] = L.screenX, (E(), q)[O + 3] = L.screenY, (E(), q)[O + 4] = L.clientX, (E(), q)[O + 5] = L.clientY, (E(), Gt)[G + 24] = L.ctrlKey, (E(), Gt)[G + 25] = L.shiftKey, (E(), Gt)[G + 26] = L.altKey, (E(), Gt)[G + 27] = L.metaKey, (E(), Q)[2 * O + 14] = L.button, (E(), Q)[2 * O + 15] = L.buttons, (E(), q)[O + 8] = L.movementX, (E(), q)[O + 9] = L.movementY, G = _w(v), (E(), q)[O + 10] = L.clientX - (G.left | 0), (E(), q)[O + 11] = L.clientY - (G.top | 0);
      }, ex = (G, L, v, O, U, Y, k) => (k = U0(k), cn.qb || (cn.qb = As(64)), G = Nd(G), j0({ target: G, Ab: Y != "mousemove" && Y != "mouseenter" && Y != "mouseleave", ga: Y, Fa: O, Ha: (_ = event) => {
        if (tx(cn.qb, _, G), k) {
          var st = As(64);
          tx(st, _, G), bp(k, O, U, st, L);
        } else st = cn.qb, Vs(O).call(null, U, BigInt(st), BigInt(L)) && _.preventDefault();
      }, Ba: v }));
      function Qv(G, L, v, O, U) {
        return g ? ae(41, 1, G, L, v, O, U) : (G = xt(G), L = xt(L), O = xt(O), U = xt(U), ex(G, L, v, O, 5, "mousedown", U));
      }
      function $v(G, L, v, O, U) {
        return g ? ae(42, 1, G, L, v, O, U) : (G = xt(G), L = xt(L), O = xt(O), U = xt(U), ex(G, L, v, O, 8, "mousemove", U));
      }
      function qv(G, L, v, O, U) {
        return g ? ae(43, 1, G, L, v, O, U) : (G = xt(G), L = xt(L), O = xt(O), U = xt(U), ex(G, L, v, O, 6, "mouseup", U));
      }
      var iQ = (G, L, v, O, U) => (U = U0(U), cn.kc || (cn.kc = As(36)), G = Nd(G), j0({
        target: G,
        ga: "resize",
        Fa: O,
        Ha: (Y = event) => {
          if (Y.target == G) {
            var k = document.body;
            if (k) {
              var _ = U ? As(36) : cn.kc;
              (E(), q)[_ / 4] = 0, (E(), q)[(_ + 4) / 4] = k.clientWidth, (E(), q)[(_ + 8) / 4] = k.clientHeight, (E(), q)[(_ + 12) / 4] = innerWidth, (E(), q)[(_ + 16) / 4] = innerHeight, (E(), q)[(_ + 20) / 4] = outerWidth, (E(), q)[(_ + 24) / 4] = outerHeight, (E(), q)[(_ + 28) / 4] = pageXOffset | 0, (E(), q)[(_ + 32) / 4] = pageYOffset | 0, U ? bp(U, O, 10, _, L) : Vs(O).call(null, 10, BigInt(_), BigInt(L)) && Y.preventDefault();
            }
          }
        },
        Ba: v
      }));
      function tR(G, L, v, O, U) {
        return g ? ae(44, 1, G, L, v, O, U) : (G = xt(G), L = xt(L), O = xt(O), U = xt(U), iQ(G, L, v, O, U));
      }
      var X1 = (G, L, v, O, U, Y, k) => (k = U0(k), cn.ic || (cn.ic = As(1552)), G = Nd(G), j0({ target: G, Ab: Y == "touchstart" || Y == "touchend", ga: Y, Fa: O, Ha: (_) => {
        var st = {}, bt = _.touches;
        for (var Ct of bt) Ct.Ic = Ct.Yc = 0, st[Ct.identifier] = Ct;
        for (var vt of _.changedTouches) vt.Ic = 1, st[vt.identifier] = vt;
        for (var _t of _.targetTouches) st[_t.identifier].Yc = 1;
        bt = k ? As(1552) : cn.ic, (E(), ot)[bt / 8] = _.timeStamp, (E(), Gt)[bt + 12] = _.ctrlKey, (E(), Gt)[bt + 13] = _.shiftKey, (E(), Gt)[bt + 14] = _.altKey, (E(), Gt)[bt + 15] = _.metaKey, Ct = bt + 16, vt = _w(G), _t = 0;
        for (let ie of Object.values(st)) if (st = Ct / 4, (E(), q)[st + 0] = ie.identifier, (E(), q)[st + 1] = ie.screenX, (E(), q)[st + 2] = ie.screenY, (E(), q)[st + 3] = ie.clientX, (E(), q)[st + 4] = ie.clientY, (E(), q)[st + 5] = ie.pageX, (E(), q)[st + 6] = ie.pageY, (E(), Gt)[Ct + 28] = ie.Ic, (E(), Gt)[Ct + 29] = ie.Yc, (E(), q)[st + 8] = ie.clientX - (vt.left | 0), (E(), q)[st + 9] = ie.clientY - (vt.top | 0), Ct += 48, 31 < ++_t) break;
        (E(), q)[(bt + 8) / 4] = _t, k ? bp(k, O, U, bt, L) : Vs(O).call(null, U, BigInt(bt), BigInt(L)) && _.preventDefault();
      }, Ba: v }));
      function eR(G, L, v, O, U) {
        return g ? ae(45, 1, G, L, v, O, U) : (G = xt(G), L = xt(L), O = xt(O), U = xt(U), X1(G, L, v, O, 25, "touchcancel", U));
      }
      function nR(G, L, v, O, U) {
        return g ? ae(46, 1, G, L, v, O, U) : (G = xt(G), L = xt(L), O = xt(O), U = xt(U), X1(G, L, v, O, 23, "touchend", U));
      }
      function iR(G, L, v, O, U) {
        return g ? ae(47, 1, G, L, v, O, U) : (G = xt(G), L = xt(L), O = xt(O), U = xt(U), X1(G, L, v, O, 24, "touchmove", U));
      }
      function sR(G, L, v, O, U) {
        return g ? ae(48, 1, G, L, v, O, U) : (G = xt(G), L = xt(L), O = xt(O), U = xt(U), X1(G, L, v, O, 22, "touchstart", U));
      }
      var sQ = (G, L, v, O, U) => (U = U0(U), cn.mc || (cn.mc = As(96)), j0({ target: G, Ab: !0, ga: "wheel", Fa: O, Ha: (Y = event) => {
        var k = U ? As(96) : cn.mc;
        tx(k, Y, G), (E(), ot)[(k + 64) / 8] = Y.deltaX, (E(), ot)[(k + 72) / 8] = Y.deltaY, (E(), ot)[(k + 80) / 8] = Y.deltaZ, (E(), q)[(k + 88) / 4] = Y.deltaMode, U ? bp(U, O, 9, k, L) : Vs(O).call(null, 9, BigInt(k), BigInt(L)) && Y.preventDefault();
      }, Ba: v }));
      function rR(G, L, v, O, U) {
        return g ? ae(49, 1, G, L, v, O, U) : (G = xt(G), L = xt(L), O = xt(O), U = xt(U), (G = Nd(G)) ? typeof G.onwheel < "u" ? sQ(G, L, v, O, U) : -1 : -4);
      }
      var aR = (G) => fR((L) => Pw(L, G));
      aR.Hc = !0;
      function rQ(G, L, v) {
        if (G = xt(G), L = xt(L), pp.Nc == G) var O = pp.ue;
        else O = Error().stack.toString().split(`
`), O[0] == "Error" && O.shift(), Jv(O);
        for (var U = 3; O[U] && L1(O[U]) != G; ) ++U;
        for (G = 0; G < v && O[G + U]; ++G) (E(), q)[(L + 4 * G) / 4] = L1(O[G + U]);
        return G;
      }
      var aQ = () => {
        throw "unwind";
      }, oQ = ["default", "low-power", "high-performance"];
      function lQ(G, L) {
        G = xt(G), L = xt(L);
        var v = L / 4, O = (E(), q)[v + 2];
        return L = { alpha: !!(E(), Gt)[L + 0], depth: !!(E(), Gt)[L + 1], stencil: !!(E(), Gt)[L + 2], antialias: !!(E(), Gt)[L + 3], premultipliedAlpha: !!(E(), Gt)[L + 4], preserveDrawingBuffer: !!(E(), Gt)[L + 5], powerPreference: oQ[O], failIfMajorPerformanceCaveat: !!(E(), Gt)[L + 12], ve: (E(), q)[v + 4], fg: (E(), q)[v + 5], Ac: (E(), Gt)[L + 24], Rd: (E(), Gt)[L + 25], og: (E(), q)[v + 7], tg: (E(), Gt)[L + 32] }, G = Nd(G), !G || L.Rd ? L = 0 : (G = G.getContext("webgl", L)) ? (v = As(16), (E(), ht)[(v + 8) / 8] = BigInt($g()), O = {
          handle: v,
          attributes: L,
          version: L.ve,
          Ca: G
        }, G.canvas && (G.canvas.xd = O), Pl[v] = O, (typeof L.Ac > "u" || L.Ac) && B_(O), L = v) : L = 0, BigInt(L);
      }
      function cQ(G) {
        var L;
        G = xt(G), hi == G && (hi = 0), hi === Pl[G] && (hi = null), typeof cn == "object" && cn.Ie(Pl[G].Ca.canvas), (L = Pl[G]) != null && L.Ca.canvas && (Pl[G].Ca.canvas.xd = void 0), ll(Pl[G].handle), Pl[G] = null;
      }
      function uQ(G) {
        return G = xt(G), hi = Pl[G], m.ctx = Ht = hi == null ? void 0 : hi.Ca, !G || Ht ? 0 : -5;
      }
      var nx = {}, oR = () => {
        if (!ix) {
          var G = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: (typeof navigator == "object" && navigator.language || "C").replace("-", "_") + ".UTF-8", _: T || "./this.program" }, L;
          for (L in nx) nx[L] === void 0 ? delete G[L] : G[L] = nx[L];
          var v = [];
          for (L in G) v.push(`${L}=${G[L]}`);
          ix = v;
        }
        return ix;
      }, ix;
      function lR(G, L) {
        if (g) return ae(50, 1, G, L);
        G = xt(G), L = xt(L);
        var v = 0, O = 0, U;
        for (U of oR()) {
          var Y = L + v;
          (E(), ht)[(G + O) / 8] = BigInt(Y), v += jr(U, Y, 1 / 0) + 1, O += 8;
        }
        return 0;
      }
      function cR(G, L) {
        if (g) return ae(51, 1, G, L);
        G = xt(G), L = xt(L);
        var v = oR();
        (E(), ht)[G / 8] = BigInt(v.length), G = 0;
        for (var O of v) G += D0(O) + 1;
        return (E(), ht)[L / 8] = BigInt(G), 0;
      }
      function uR(G) {
        if (g) return ae(52, 1, G);
        try {
          var L = Xs(G);
          return It.close(L), 0;
        } catch (v) {
          if (typeof It > "u" || v.name !== "ErrnoError") throw v;
          return v.l;
        }
      }
      function dR(G, L) {
        if (g) return ae(53, 1, G, L);
        L = xt(L);
        try {
          var v = Xs(G), O = v.tty ? 2 : nr(v.mode) ? 3 : (v.mode & 61440) === 40960 ? 7 : 4;
          return (E(), Gt)[L] = O, (E(), Q)[(L + 2) / 2] = 0, (E(), it)[(L + 8) / 8] = BigInt(0), (E(), it)[(L + 16) / 8] = BigInt(0), 0;
        } catch (U) {
          if (typeof It > "u" || U.name !== "ErrnoError") throw U;
          return U.l;
        }
      }
      function hR(G, L, v, O) {
        if (g) return ae(54, 1, G, L, v, O);
        L = xt(L), v = xt(v), O = xt(O);
        try {
          t: {
            var U = Xs(G);
            G = L;
            for (var Y, k = L = 0; k < v; k++) {
              var _ = Number((E(), ht)[G / 8]), st = Number((E(), ht)[(G + 8) / 8]);
              G += 16;
              var bt = It.read(U, (E(), Gt), _, st, Y);
              if (0 > bt) {
                var Ct = -1;
                break t;
              }
              if (L += bt, bt < st) break;
              typeof Y < "u" && (Y += bt);
            }
            Ct = L;
          }
          return (E(), ht)[O / 8] = BigInt(Ct), 0;
        } catch (vt) {
          if (typeof It > "u" || vt.name !== "ErrnoError") throw vt;
          return vt.l;
        }
      }
      function pR(G, L, v, O) {
        if (g) return ae(55, 1, G, L, v, O);
        L = xt(L), O = xt(O);
        try {
          if (isNaN(L)) return 61;
          var U = Xs(G);
          return It.M(U, L, v), (E(), it)[O / 8] = BigInt(U.position), U.xa && L === 0 && v === 0 && (U.xa = null), 0;
        } catch (Y) {
          if (typeof It > "u" || Y.name !== "ErrnoError") throw Y;
          return Y.l;
        }
      }
      function sx(G) {
        if (g) return ae(56, 1, G);
        try {
          var L = Xs(G);
          return fR((v) => {
            var O = L.node.B;
            O.type.vb ? O.type.vb(O, !1, (U) => {
              v(U ? 29 : 0);
            }) : v(0);
          });
        } catch (v) {
          if (typeof It > "u" || v.name !== "ErrnoError") throw v;
          return v.l;
        }
      }
      sx.Hc = !0;
      function mR(G, L, v, O) {
        if (g) return ae(57, 1, G, L, v, O);
        L = xt(L), v = xt(v), O = xt(O);
        try {
          t: {
            var U = Xs(G);
            G = L;
            for (var Y, k = L = 0; k < v; k++) {
              var _ = Number((E(), ht)[G / 8]), st = Number((E(), ht)[(G + 8) / 8]);
              G += 16;
              var bt = It.write(U, (E(), Gt), _, st, Y);
              if (0 > bt) {
                var Ct = -1;
                break t;
              }
              if (L += bt, bt < st) break;
              typeof Y < "u" && (Y += bt);
            }
            Ct = L;
          }
          return (E(), ht)[O / 8] = BigInt(Ct), 0;
        } catch (vt) {
          if (typeof It > "u" || vt.name !== "ErrnoError") throw vt;
          return vt.l;
        }
      }
      var rx = (G) => Ht.activeTexture(G), dQ = (G, L) => {
        Ht.bindTexture(G, S1[L]);
      }, hQ = (G, L) => Ht.blendFunc(G, L), pQ = (G) => Ht.clear(G), mQ = (G, L, v, O) => Ht.clearColor(G, L, v, O), bQ = (G) => Ht.clearDepth(G), fQ = (G) => Ht.clearStencil(G), gQ = (G, L, v, O) => {
        Ht.colorMask(!!G, !!L, !!v, !!O);
      };
      function yQ(G, L, v, O, U, Y, k, _) {
        _ = xt(_), Ht.compressedTexImage2D(G, L, v, O, U, Y, (E(), Tt).subarray(_, _ + k));
      }
      function ZQ(G, L, v, O, U, Y, k, _, st) {
        st = xt(st), Ht.compressedTexSubImage2D(G, L, v, O, U, Y, k, (E(), Tt).subarray(st, st + _));
      }
      var TQ = (G, L, v, O, U, Y, k, _) => Ht.copyTexImage2D(G, L, v, O, U, Y, k, _), MQ = (G) => Ht.cullFace(G);
      function NQ(G, L) {
        L = xt(L);
        for (var v = 0; v < G; v++) {
          var O = (E(), q)[(L + 4 * v) / 4], U = S1[O];
          U && (Ht.deleteTexture(U), U.name = 0, S1[O] = null);
        }
      }
      var WQ = (G) => Ht.depthFunc(G), GQ = (G) => {
        Ht.depthMask(!!G);
      }, Kg = (G) => Ht.disable(G), wQ = (G, L, v) => {
        6 >= G ? Ht.drawArrays(G, L, v) : (ZR(v), Jt.mode = G, Ht.ma || (Jt.yb = (E(), et).subarray(Jt.Pa / 4, (Jt.Pa + (L + v) * Jt.stride) / 4), Jt.Ga = L, Jt.Za = L + v), Jt.flush(null, L), Jt.mode = -1);
      }, xQ = () => {
        Xt("glDrawBuffer: TODO");
      };
      function SQ(G, L, v, O, U, Y) {
        O = xt(O), 6 >= G && Ht.vc ? Ht.drawElements(G, L, v, O) : (ZR(L), Jt.mode = G, Ht.ma || (Jt.Ga = Y ? U : (E(), Gt).length, Jt.Za = Y ? Y + 1 : 0, U = Jt.Pa, Y ? (Y = Jt.Pa + (Y + 1) * Jt.stride, Jt.yb = (E(), et).subarray(U / 4, Y / 4)) : Jt.yb = (E(), et).subarray(U / 4)), Jt.flush(L, 0, O), Jt.mode = -1);
      }
      var Hg = (G) => Ht.enable(G), LQ = () => Ht.finish(), VQ = () => Ht.flush();
      function XQ(G, L) {
        L = xt(L);
        for (var v = S1, O = 0; O < G; O++) {
          var U = Ht.createTexture(), Y;
          if (Y = U) {
            Y = v;
            for (var k = J_++, _ = Y.length; _ < k; _++) Y[_] = null;
            Y = k;
          }
          U ? (U.name = Y, v[Y] = U) : ls || (ls = 1282), (E(), q)[(L + 4 * O) / 4] = Y;
        }
      }
      var IQ = (G) => Ht.generateMipmap(G), ax = (G, L, v) => {
        if (L) {
          var O = void 0;
          switch (G) {
            case 36346:
              O = 1;
              break;
            case 36344:
              v != 0 && v != 1 && (ls || (ls = 1280));
              return;
            case 36345:
              O = 0;
              break;
            case 34466:
              var U = Ht.getParameter(34467);
              O = U ? U.length : 0;
          }
          if (O === void 0) switch (U = Ht.getParameter(G), typeof U) {
            case "number":
              O = U;
              break;
            case "boolean":
              O = U ? 1 : 0;
              break;
            case "string":
              ls || (ls = 1280);
              return;
            case "object":
              if (U === null) switch (G) {
                case 34964:
                case 35725:
                case 34965:
                case 36006:
                case 36007:
                case 32873:
                case 34229:
                case 34068:
                  O = 0;
                  break;
                default:
                  ls || (ls = 1280);
                  return;
              }
              else {
                if (U instanceof Float32Array || U instanceof Uint32Array || U instanceof Int32Array || U instanceof Array) {
                  for (G = 0; G < U.length; ++G) switch (v) {
                    case 0:
                      (E(), q)[(L + 4 * G) / 4] = U[G];
                      break;
                    case 2:
                      (E(), et)[(L + 4 * G) / 4] = U[G];
                      break;
                    case 4:
                      (E(), Gt)[L + G] = U[G] ? 1 : 0;
                  }
                  return;
                }
                try {
                  O = U.name | 0;
                } catch (Y) {
                  ls || (ls = 1280), P(`GL_INVALID_ENUM in glGet${v}v: Unknown object returned from WebGL getParameter(${G})! (error: ${Y})`);
                  return;
                }
              }
              break;
            default:
              ls || (ls = 1280), P(`GL_INVALID_ENUM in glGet${v}v: Native code calling glGet${v}v(${G}) and it returns ${U} of type ${typeof U}!`);
              return;
          }
          switch (v) {
            case 1:
              v = O, (E(), nt)[L / 4] = v, G = (E(), nt)[L / 4], (E(), nt)[(L + 4) / 4] = (v - G) / 4294967296;
              break;
            case 0:
              (E(), q)[L / 4] = O;
              break;
            case 2:
              (E(), et)[L / 4] = O;
              break;
            case 4:
              (E(), Gt)[L] = O ? 1 : 0;
          }
        } else ls || (ls = 1281);
      };
      function ox(G, L) {
        return L = xt(L), ax(G, L, 4);
      }
      var CQ = () => {
        var G = Ht.getError() || ls;
        return ls = 0, G;
      };
      function lx(G, L) {
        return L = xt(L), ax(G, L, 2);
      }
      function _g(G, L) {
        return L = xt(L), ax(G, L, 0);
      }
      var YQ = () => {
        var G = Qw(Ht);
        return G = G.concat(G.map((L) => "GL_" + L));
      };
      function cx(G) {
        var L = Bg[G];
        if (!L) {
          switch (G) {
            case 7939:
              L = F0(YQ().join(" "));
              break;
            case 7936:
            case 7937:
            case 37445:
            case 37446:
              (L = Ht.getParameter(G)) || ls || (ls = 1280), L = L ? F0(L) : 0;
              break;
            case 7938:
              L = F0(`OpenGL ES 2.0 (${Ht.getParameter(7938)})`);
              break;
            case 35724:
              L = Ht.getParameter(35724);
              var v = L.match(/^WebGL GLSL ES ([0-9]\.[0-9][0-9]?)(?:$| .*)/);
              v !== null && (v[1].length == 3 && (v[1] += "0"), L = `OpenGL ES GLSL ES ${v[1]} (${L})`), L = F0(L);
              break;
            default:
              ls || (ls = 1280);
          }
          Bg[G] = L;
        }
        return BigInt(L);
      }
      var bR = (G) => Ht.isEnabled(G), vQ = (G) => Ht.lineWidth(G), RQ = (G, L) => {
        G == 3317 ? $w = L : G == 3314 && (Uv = L), Ht.pixelStorei(G, L);
      }, DQ = (G) => {
        YR = G;
      }, OQ = () => {
        Xt("glReadBuffer: TODO");
      }, ux = (G, L, v, O, U) => (G -= 5120, G = G == 1 ? (E(), Tt) : G == 4 ? (E(), q) : G == 6 ? (E(), et) : G == 5 || G == 28922 ? (E(), nt) : (E(), D), G.subarray(U / G.BYTES_PER_ELEMENT, (U + O * ((Uv || v) * ({ 5: 3, 6: 4, 8: 2, 29502: 3, 29504: 4 }[L - 6402] || 1) * G.BYTES_PER_ELEMENT + $w - 1 & -$w)) / G.BYTES_PER_ELEMENT));
      function zQ(G, L, v, O, U, Y, k) {
        k = xt(k), (k = ux(Y, U, v, O, k)) ? Ht.readPixels(G, L, v, O, U, Y, k) : ls || (ls = 1280);
      }
      var EQ = (G, L, v, O) => Ht.scissor(G, L, v, O), kQ = (G, L, v) => Ht.stencilFunc(G, L, v), FQ = (G) => Ht.stencilMask(G), jQ = (G, L, v) => Ht.stencilOp(G, L, v);
      function UQ(G, L, v, O, U, Y, k, _, st) {
        st = (st = xt(st)) ? ux(_, k, O, U, st) : null, Ht.texImage2D(G, L, v, O, U, Y, k, _, st);
      }
      var PQ = (G, L, v) => Ht.texParameterf(G, L, v);
      function JQ(G, L, v) {
        v = xt(v), v = (E(), et)[v / 4], Ht.texParameterf(G, L, v);
      }
      var AQ = (G, L, v) => Ht.texParameteri(G, L, v);
      function BQ(G, L, v, O, U, Y, k, _, st) {
        st = (st = xt(st)) ? ux(_, k, U, Y, st) : null, Ht.texSubImage2D(G, L, v, O, U, Y, k, _, st);
      }
      var KQ = (G, L, v, O) => Ht.viewport(G, L, v, O);
      function HQ(G, L) {
        G = xt(G), L = xt(L);
        try {
          return Mw((E(), Tt).subarray(G, G + L)), 0;
        } catch (v) {
          if (typeof It > "u" || v.name !== "ErrnoError") throw v;
          return v.l;
        }
      }
      var P0 = (G) => (0 > G && (G = 18446744073709551616n + BigInt(G)), "0x" + G.toString(16).padStart(16, "0"));
      function _Q(G) {
        return (...L) => G(...L);
      }
      var I1 = null, QQ = async (G) => {
        ne += 1;
        try {
          return await G();
        } finally {
          --ne;
        }
      }, fR = (G) => QQ(() => new Promise(G)), gR = !1;
      function $Q() {
        function G() {
          gR = document.pointerLockElement === m.canvas;
        }
        if (!yR) {
          yR = !0, i1.push({ canHandle: function(v) {
            return !m.noImageDecoding && /\.(jpg|jpeg|png|bmp|webp)$/i.test(v);
          }, handle: async function(v, O) {
            var U = new Blob([v], { type: dx(O) });
            U.size !== v.length && (U = new Blob([new Uint8Array(v).buffer], { type: dx(O) }));
            var Y = URL.createObjectURL(U);
            return new Promise((k, _) => {
              var st = new Image();
              st.onload = () => {
                var bt = document.createElement("canvas");
                bt.width = st.width, bt.height = st.height, bt.getContext("2d").drawImage(
                  st,
                  0,
                  0
                ), URL.revokeObjectURL(Y), k(v);
              }, st.onerror = () => {
                P(`Image ${Y} could not be decoded`), _();
              }, st.src = Y;
            });
          } }), i1.push({ canHandle: function(v) {
            return !m.noAudioDecoding && v.slice(-4) in { ".ogg": 1, ".wav": 1, ".mp3": 1 };
          }, handle: async function(v, O) {
            return new Promise((U) => {
              function Y() {
                k || (k = !0, U(v));
              }
              var k = !1, _ = new Blob([v], { type: dx(O) });
              _ = URL.createObjectURL(_);
              var st = new Audio();
              st.addEventListener("canplaythrough", () => Y(), !1), st.onerror = function() {
                if (!k) {
                  P(`warning: browser could not fully decode audio ${O}, trying slower base64 approach`);
                  for (var bt = "data:audio/x-" + O.slice(-3) + ";base64,", Ct = "", vt = 0, _t = 0, ie = 0; ie < v.length; ie++) for (vt = vt << 8 | v[ie], _t += 8; 6 <= _t; ) {
                    var St = vt >> _t - 6 & 63;
                    _t -= 6, Ct += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[St];
                  }
                  _t == 2 ? (Ct += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[(vt & 3) << 4], Ct += "==") : _t == 4 && (Ct += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[(vt & 15) << 2], Ct += "="), st.src = bt + Ct, Y();
                }
              }, st.src = _, Pw(() => {
                Y();
              }, 1e4);
            });
          } });
          var L = m.canvas;
          L && (document.addEventListener(
            "pointerlockchange",
            G,
            !1
          ), m.elementPointerLock && L.addEventListener("click", (v) => {
            !gR && m.canvas.requestPointerLock && (m.canvas.requestPointerLock(), v.preventDefault());
          }, !1));
        }
      }
      function dx(G) {
        return { jpg: "image/jpeg", jpeg: "image/jpeg", png: "image/png", bmp: "image/bmp", ogg: "audio/ogg", wav: "audio/wav", mp3: "audio/mpeg" }[G.slice(G.lastIndexOf(".") + 1)];
      }
      var qQ = {}, yR;
      function ZR(G) {
        if (Jt.Yb) {
          Jt.Yb = !1;
          for (var L = Number.MAX_SAFE_INTEGER, v = 0, O = Number.MAX_SAFE_INTEGER, U = 0, Y = Jt.Pc, k = Y.length = 0; k < 3 + Jt.Da; k++) if (Jt.ta[k]) {
            var _ = Jt.O[k];
            Y.push(_), L = Math.min(L, _.Ma), _.Oa = _.size * jv[_.type - 5120], v += _.Oa, O = Math.min(O, _.stride), U = Math.max(U, _.stride);
          }
          if (O != U || U < v) {
            Jt.gd || (Jt.gd = As(2097152)), L = Jt.gd, v = 0;
            for (_ of Y) O = _.Oa, O % 4 != 0 && (O += 4 - O % 4), _.offset = v, v += O;
            for (_ of Y) {
              if (Y = Math.max(_.Oa, _.stride), (Y & 3) == 0 && (_.Oa & 3) == 0) for (O = 0; O < G; O++) for (U = 0; U < _.Oa; U += 4) k = (E(), q)[(_.Ma + (O * Y + U)) / 4], (E(), q)[(L + _.offset + (v * O + U)) / 4] = k;
              else for (O = 0; O < G; O++) for (U = 0; U < _.Oa; U++) (E(), Gt)[L + _.offset + v * O + U] = (E(), Gt)[_.Ma + O * Y + U];
              _.Ma = L + _.offset;
            }
            Jt.stride = v, Jt.Pa = L;
          } else {
            Jt.Pa = Ht.ma ? 0 : L;
            for (_ of Y) _.offset = _.Ma - Jt.Pa;
            Jt.stride = Math.max(U, v);
          }
        }
        Jt.ud = Jt.stride * G / 4;
      }
      function t7() {
        for (var G = !1, L = 0; L < Jt.Da; L++) Jt.ta[Jt.TEXTURE0 + L] && (G = !0);
        return new function() {
          this.Ia = function() {
            var v = null;
            if (ol) switch (mx) {
              case 2049:
                var O = `  float fog = exp(-u_fogDensity * u_fogDensity * ecDistance * ecDistance); 
`;
                break;
              case 9729:
                O = `  float fog = (u_fogEnd - ecDistance) * u_fogScale; 
`;
                break;
              default:
                O = `  float fog = exp(-u_fogDensity * ecDistance); 
`;
            }
            Jt.oa.Le("u_texUnit", "v_texCoord", "v_color", v);
            var U = Jt.oa.Ud("gl_FragColor", 2), Y = "", k = "", _ = "", st = "";
            this.xb = Jt.oa.Zd();
            for (var bt of this.xb) Y += "attribute vec4 a_texCoord" + bt + `;
`, k += "varying vec4 v_texCoord" + bt + `;
`, _ += "uniform sampler2D u_texUnit" + bt + `;
`, st += "  v_texCoord" + bt + " = a_texCoord" + bt + `;
`;
            var Ct = null;
            ol && (Ct = `  v_fogFragCoord = abs(ecPosition.z);
`);
            var vt = null, _t = null;
            Jt.mode == Ht.POINTS && (vt = `uniform float u_pointSize;
`, _t = `  gl_PointSize = u_pointSize;
`);
            var ie = "", St = "";
            bt = v = "";
            for (var Et = 0; Et < J0; Et++) mp[Et] && (ie += "uniform vec4 u_clipPlaneEquation" + Et + ";", ie += "varying float v_clipDistance" + Et + ";", St += "  v_clipDistance" + Et + " = dot(ecPosition, u_clipPlaneEquation" + Et + ");", v += "varying float v_clipDistance" + Et + ";", bt += "  if (v_clipDistance" + Et + " < 0.0) discard;");
            var Ut = Et = "";
            if (Hc) {
              Et += "attribute vec3 a_normal;uniform mat3 u_normalMatrix;uniform vec4 u_lightModelAmbient;uniform vec4 u_materialAmbient;uniform vec4 u_materialDiffuse;uniform vec4 u_materialSpecular;uniform float u_materialShininess;uniform vec4 u_materialEmission;", Ut += "  vec3 ecNormal = normalize(u_normalMatrix * a_normal);  v_color.w = u_materialDiffuse.w;  v_color.xyz = u_materialEmission.xyz;  v_color.xyz += u_lightModelAmbient.xyz * u_materialAmbient.xyz;";
              for (var ce = 0; ce < Qg; ce++) Wd[ce] && (Et += "uniform vec4 u_lightAmbient" + ce + ";", Et += "uniform vec4 u_lightDiffuse" + ce + ";", Et += "uniform vec4 u_lightSpecular" + ce + ";", Et += "uniform vec4 u_lightPosition" + ce + ";", Ut += "  {", Ut += "    vec3 lightDirection = normalize(u_lightPosition" + ce + ").xyz;", Ut += "    vec3 halfVector = normalize(lightDirection + vec3(0,0,1));", Ut += "    vec3 ambient = u_lightAmbient" + ce + ".xyz * u_materialAmbient.xyz;", Ut += "    float diffuseI = max(dot(ecNormal, lightDirection), 0.0);", Ut += "    float specularI = max(dot(ecNormal, halfVector), 0.0);", Ut += "    vec3 diffuse = diffuseI * u_lightDiffuse" + ce + ".xyz * u_materialDiffuse.xyz;", Ut += "    specularI = (diffuseI > 0.0 && specularI > 0.0) ? exp(u_materialShininess * log(specularI)) : 0.0;", Ut += "    vec3 specular = specularI * u_lightSpecular" + ce + ".xyz * u_materialSpecular.xyz;", Ut += "    v_color.xyz += ambient + diffuse + specular;", Ut += "  }");
              Ut += "  v_color = clamp(v_color, 0.0, 1.0);";
            }
            if (Y = [`attribute vec4 a_position;
attribute vec4 a_color;
varying vec4 v_color;`, Y, k, ol ? "varying float v_fogFragCoord;" : null, `uniform mat4 u_modelView;
uniform mat4 u_projection;`, vt, ie, Et, `void main()
{
  vec4 ecPosition = u_modelView * a_position;
  gl_Position = u_projection * ecPosition;
  v_color = a_color;`, st, Ct, _t, St, Ut, `}
`].join(`
`).replace(/\n\n+/g, `
`), this.lc = Ht.createShader(Ht.VERTEX_SHADER), Ht.shaderSource(this.lc, Y), Ht.compileShader(this.lc), Y = null, ol && (Y = [
              `
varying float v_fogFragCoord; 
uniform vec4 u_fogColor;      
uniform float u_fogEnd;       
uniform float u_fogScale;     
uniform float u_fogDensity;   
float ffog(in float ecDistance) { `,
              O,
              `  fog = clamp(fog, 0.0, 1.0); 
  return fog;                 
}
`
            ].join(`
`)), O = null, ol && (O = `gl_FragColor = vec4(mix(u_fogColor.rgb, gl_FragColor.rgb, ffog(v_fogFragCoord)), gl_FragColor.a);
`), Ct = st = "", Gd) switch (st = "uniform float u_alphaTestRef;", bx) {
              case 512:
                Ct = "discard;";
                break;
              case 513:
                Ct = "if (!(gl_FragColor.a < u_alphaTestRef)) { discard; }";
                break;
              case 514:
                Ct = "if (!(gl_FragColor.a == u_alphaTestRef)) { discard; }";
                break;
              case 515:
                Ct = "if (!(gl_FragColor.a <= u_alphaTestRef)) { discard; }";
                break;
              case 516:
                Ct = "if (!(gl_FragColor.a > u_alphaTestRef)) { discard; }";
                break;
              case 517:
                Ct = "if (!(gl_FragColor.a != u_alphaTestRef)) { discard; }";
                break;
              case 518:
                Ct = "if (!(gl_FragColor.a >= u_alphaTestRef)) { discard; }";
                break;
              case 519:
                Ct = "";
            }
            for (U = ["precision mediump float;", k, _, "varying vec4 v_color;", Y, v, st, `void main()
{`, bt, U, O, Ct, `}
`].join(`
`).replace(/\n\n+/g, `
`), this.Jb = Ht.createShader(Ht.FRAGMENT_SHADER), Ht.shaderSource(this.Jb, U), Ht.compileShader(this.Jb), this.s = Ht.createProgram(), Ht.attachShader(
              this.s,
              this.lc
            ), Ht.attachShader(this.s, this.Jb), Ht.bindAttribLocation(this.s, Jt.ua, "a_position"), Ht.bindAttribLocation(this.s, Jt.COLOR, "a_color"), Ht.bindAttribLocation(this.s, Jt.Ea, "a_normal"), k = Ht.getParameter(Ht.MAX_VERTEX_ATTRIBS), U = 0; U < Jt.Da && Jt.TEXTURE0 + U < k; U++) Ht.bindAttribLocation(this.s, Jt.TEXTURE0 + U, "a_texCoord" + U), Ht.bindAttribLocation(this.s, Jt.TEXTURE0 + U, "a_texCoord" + U);
            for (Ht.linkProgram(this.s), this.nd = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], this.Ve = [], U = 0; U < Jt.Da; U++) this.Ve[U] = Jt.ta[Jt.TEXTURE0 + U] ? Ht.getAttribLocation(
              this.s,
              "a_texCoord" + U
            ) : -1;
            for (this.Fd = Ht.getAttribLocation(this.s, "a_color"), k = Ht.getParameter(Ht.CURRENT_PROGRAM), Ht.useProgram(this.s), U = 0; U < this.xb.length; U++) _ = this.xb[U], Ht.uniform1i(Ht.getUniformLocation(this.s, "u_texUnit" + _), _);
            for (Ht.vertexAttrib4fv(this.Fd, [1, 1, 1, 1]), Ht.useProgram(k), this.hc = [], U = 0; U < Jt.Da; U++) this.hc[U] = Ht.getUniformLocation(this.s, `u_textureMatrix${U}`);
            for (this.Ae = Ht.getAttribLocation(this.s, "a_normal"), this.Vc = Ht.getUniformLocation(this.s, "u_modelView"), this.bd = Ht.getUniformLocation(
              this.s,
              "u_projection"
            ), this.Be = Ht.getUniformLocation(this.s, "u_normalMatrix"), this.he = G, this.ge = Jt.ta[Jt.Ea] && 0 < Jt.O[Jt.Ea].size && 0 <= this.Ae, this.Fb = Ht.getUniformLocation(this.s, "u_fogColor"), this.Hb = Ht.getUniformLocation(this.s, "u_fogEnd"), this.Ib = Ht.getUniformLocation(this.s, "u_fogScale"), this.Gb = Ht.getUniformLocation(this.s, "u_fogDensity"), this.ee = !!(this.Fb || this.Hb || this.Ib || this.Gb), this.Zc = Ht.getUniformLocation(this.s, "u_pointSize"), this.Mb = !1, this.ib = [], Et = 0; Et < J0; Et++) this.ib[Et] = Ht.getUniformLocation(
              this.s,
              `u_clipPlaneEquation${Et}`
            ), this.Mb = this.Mb || this.ib[Et];
            for (this.fe = Hc, this.Oc = Ht.getUniformLocation(this.s, "u_lightModelAmbient"), this.Qc = Ht.getUniformLocation(this.s, "u_materialAmbient"), this.Rc = Ht.getUniformLocation(this.s, "u_materialDiffuse"), this.Uc = Ht.getUniformLocation(this.s, "u_materialSpecular"), this.Tc = Ht.getUniformLocation(this.s, "u_materialShininess"), this.Sc = Ht.getUniformLocation(this.s, "u_materialEmission"), this.Tb = [], this.Ub = [], this.Wb = [], this.Vb = [], ce = 0; ce < Qg; ce++) this.Tb[ce] = Ht.getUniformLocation(
              this.s,
              `u_lightAmbient${ce}`
            ), this.Ub[ce] = Ht.getUniformLocation(this.s, `u_lightDiffuse${ce}`), this.Wb[ce] = Ht.getUniformLocation(this.s, `u_lightSpecular${ce}`), this.Vb[ce] = Ht.getUniformLocation(this.s, `u_lightPosition${ce}`);
            this.de = Gd, this.rc = Ht.getUniformLocation(this.s, "u_alphaTestRef");
          }, this.Ee = function() {
            if (Ht.ma) var v = Ht.ma;
            else {
              var O = Jt.Ga * Jt.stride, U = Jt.Za * Jt.stride;
              v = 32 - Math.clz32(U === 0 ? 0 : U - 1);
              var Y = hi.md[v], k = hi.cb[v];
              hi.cb[v] = hi.cb[v] + 1 & 63;
              var _ = Y[k];
              _ ? v = _ : (_ = Ht.getParameter(34964), Y[k] = Ht.createBuffer(), Ht.bindBuffer(
                34962,
                Y[k]
              ), Ht.bufferData(34962, 1 << v, 35048), Ht.bindBuffer(34962, _), v = Y[k]);
            }
            if (Ht.ma || (v != Jt.Mc && (Ht.bindBuffer(Ht.ARRAY_BUFFER, v), Jt.Mc = v), Ht.bufferSubData(Ht.ARRAY_BUFFER, O, Jt.yb.subarray(O >> 2, U >> 2))), Jt.Db != this.s && (Ht.useProgram(this.s), Jt.Db = this.s), this.Vc && this.we != Jt.$a[0] && (this.we = Jt.$a[0], Ht.uniformMatrix4fv(this.Vc, !1, Jt.matrix[0]), Wd && (O = Jt.pb.ob.create(Jt.matrix[0]), Jt.pb.ob.inverse(O), Jt.pb.ob.rd(O), Ht.uniformMatrix3fv(this.Be, !1, Jt.pb.ob.od(O)))), this.bd && this.Fe != Jt.$a[1] && (this.Fe = Jt.$a[1], Ht.uniformMatrix4fv(
              this.bd,
              !1,
              Jt.matrix[1]
            )), O = Jt.O, U = O[Jt.ua], Ht.ma || (Ht.vertexAttribPointer(Jt.ua, U.size, U.type, !1, Jt.stride, U.offset), this.ge && (U = O[Jt.Ea], Ht.vertexAttribPointer(Jt.Ea, U.size, U.type, !0, Jt.stride, U.offset))), this.he) for (U = 0; U < Jt.Da; U++) Ht.ma || (v = Jt.TEXTURE0 + U, Y = O[v], Y.size ? Ht.vertexAttribPointer(v, Y.size, Y.type, !1, Jt.stride, Y.offset) : Ht.vertexAttrib4f(v, 0, 0, 0, 1)), v = 2 + U, this.hc[U] && this.nd[v] != Jt.$a[v] && (this.nd[v] = Jt.$a[v], Ht.uniformMatrix4fv(this.hc[U], !1, Jt.matrix[v]));
            if (Jt.ta[Jt.COLOR] && (O = O[Jt.COLOR], Ht.ma || Ht.vertexAttribPointer(
              Jt.COLOR,
              O.size,
              O.type,
              !0,
              Jt.stride,
              O.offset
            )), this.ee && (this.Fb && Ht.uniform4fv(this.Fb, px), this.Hb && Ht.uniform1f(this.Hb, hx), this.Ib && Ht.uniform1f(this.Ib, 1 / (hx - TR)), this.Gb && Ht.uniform1f(this.Gb, MR)), this.Mb) for (O = 0; O < J0; O++) this.ib[O] && Ht.uniform4fv(this.ib[O], NR[O]);
            if (this.fe) for (this.Oc && Ht.uniform4fv(this.Oc, A0), this.Qc && Ht.uniform4fv(this.Qc, WR), this.Rc && Ht.uniform4fv(this.Rc, GR), this.Uc && Ht.uniform4fv(this.Uc, wR), this.Tc && Ht.uniform1f(this.Tc, xR[0]), this.Sc && Ht.uniform4fv(this.Sc, SR), O = 0; O < Qg; O++) this.Tb[O] && Ht.uniform4fv(this.Tb[O], LR[O]), this.Ub[O] && Ht.uniform4fv(this.Ub[O], VR[O]), this.Wb[O] && Ht.uniform4fv(this.Wb[O], XR[O]), this.Vb[O] && Ht.uniform4fv(this.Vb[O], IR[O]);
            this.de && this.rc && Ht.uniform1f(this.rc, CR), Jt.mode == Ht.POINTS && this.Zc && Ht.uniform1f(this.Zc, YR);
          }, this.Ia();
        }();
      }
      function e7() {
        if (Jt.A) return Jt.A;
        var G = Jt.Pc, L = Jt.Je.Yd().reset(), v = 0, O;
        for (O of G) v |= 1 << O.name;
        if (L.next(v), v = 0, ol) switch (mx) {
          case 2049:
            v = 1;
            break;
          case 9729:
            v = 2;
            break;
          default:
            v = 3;
        }
        for (v |= 0, G = 0; G < J0; G++) v = v << 1 | mp[G];
        for (v = v << 1 | Hc, G = 0; G < Qg; G++) v = v << 1 | (Hc ? Wd[G] : 0);
        return v = v << 3 | (Gd ? bx - 512 : 7), v = v << 1 | (Jt.mode == Ht.POINTS ? 1 : 0), L.next(v), Jt.oa.jc(L), v = L.get(), v ? Jt.A = v : (v = t7(), Jt.A = v, L.set(v), v);
      }
      var Jt = { yd: null, jd: () => {
        function G() {
          var v = [];
          this.oe = function(Y, k) {
            this.contains(Y | 0) || v.push([Y, k]);
          };
          var O;
          this.contains = function(Y) {
            for (O = 0; O < v.length; ++O) if (v[O][0] === Y) return !0;
            return !1;
          };
          var U;
          this.get = function(Y) {
            for (U = 0; U < v.length; ++U) if (v[U][0] === Y) return v[U][1];
          };
        }
        function L() {
          function v() {
            var k = new G();
            this.Dd = function(_) {
              return k.contains(_ | 0) || k.oe(_ | 0, new v()), k.get(_ | 0);
            }, this.value = void 0, this.get = function() {
              return this.value;
            }, this.set = function(_) {
              this.value = _;
            };
          }
          function O(k) {
            var _;
            this.reset = function() {
              return _ = k, this;
            }, this.reset(), this.next = function(st) {
              return _ = _.Dd(st), this;
            }, this.get = function() {
              return _.get();
            }, this.set = function(st) {
              _.set(st);
            };
          }
          var U, Y;
          this.Ld = function() {
            return new O(U);
          }, this.clear = function() {
            U = new v(), Y = this.Ld();
          }, this.clear(), this.Yd = function() {
            return Y.reset(), Y;
          };
        }
        return { create: () => new L() };
      }, oa: null, kd: () => {
        function G(St) {
          Xt("[TexEnvJIT] ABORT: No support: " + St);
        }
        function L(St) {
          Xt("[TexEnvJIT] ABORT: Sanity failure: " + St);
        }
        function v(St) {
          var Et = vt[St].Dc();
          switch (Et) {
            case 3552:
              Et = "texture2D";
              break;
            case 3553:
              Et = "texture2D";
              break;
            case 32879:
              return G("No support for 3D textures.");
            case 34067:
              Et = "textureCube";
              break;
            default:
              return L(`Unknown texType: ${P0(Et)}`);
          }
          var Ut = st + St;
          return Ct != null && (Ut = `(${Ct}${St} * ${Ut})`), `${Et}(${_}${St}, ${Ut}.xy)`;
        }
        function O(St, Et, Ut, ce, de) {
          switch (ce) {
            case 5890:
              St = v(St);
              break;
            case 34166:
              St = Et;
              break;
            case 34167:
              St = bt;
              break;
            case 34168:
              St = Ut;
              break;
            default:
              return G("Unsupported combiner src: " + P0(ce));
          }
          switch (de) {
            case 768:
              de = St + ".rgb";
              break;
            case 769:
              de = "(vec3(1.0) - " + St + ".rgb)";
              break;
            case 770:
              de = St + ".a";
              break;
            case 771:
              de = "(1.0 - " + St + ".a)";
              break;
            default:
              return G("Unsupported combiner op: " + P0(de));
          }
          return de;
        }
        function U(St) {
          return St == Math.round(St) ? St + ".0" : St;
        }
        function Y() {
          this.Qa = this.Sa = this.mode = 8448, this.pa = this.qa = 1, this.G = [0, 0, 0, 0], this.T = [5890, 34168, 34166], this.S = [5890, 34168, 34166], this.P = [768, 768, 770], this.R = [770, 770, 770], this.sd = { 7681: 0, 8448: 1, 260: 2, 3042: 3, 8449: 4, 34160: 5, 34023: 3, 34165: 4, 5890: 0, 34166: 1, 34167: 2, 34168: 3, 768: 0, 769: 1, 770: 2, 771: 3 }, this.nb = -1, this.Lc = this.Kc = 0, this.Hd = function() {
            var St = this.sd, Et = 1638400 * St[this.mode];
            return Et += 327680 * St[this.Sa], Et += 65536 * St[this.Qa], Et += 16384 * (this.qa - 1), Et += 4096 * (this.pa - 1), Et += 1024 * St[this.T[0]], Et += 256 * St[this.T[1]], Et += 64 * St[this.T[2]], Et += 16 * St[this.S[0]], Et += 4 * St[this.S[1]], Et += St[this.S[2]];
          }, this.Id = function() {
            var St = this.sd, Et = 4096 * St[this.P[0]];
            return Et += 1024 * St[this.P[1]], Et += 256 * St[this.P[2]], Et += 16 * St[this.R[0]], Et += 4 * St[this.R[1]], Et += St[this.R[2]];
          }, this.Jd = function() {
            return 16777216 * this.G[0] + 65536 * this.G[1] + 256 * this.G[2] + 1 + this.G[3];
          }, this.He = function() {
            this.nb = this.Hd(), this.Kc = this.Id(), this.Lc = this.Jd();
          }, this.C = function() {
            this.nb = -1, Jt.A = null;
          };
        }
        function k() {
          this.env = new Y(), this.Xa = this.Wa = this.Va = this.Ua = !1, this.F = 0, this.jc = function(St) {
            this.F ? (this.env.nb == -1 && this.env.He(), St.next(this.F | this.env.nb << 4), St.next(this.env.Kc), St.next(this.env.Lc)) : St.next(0);
          };
        }
        var _ = "uTexUnit", st = "vTexCoord", bt = "vPrimColor", Ct = "uTexMatrix", vt = null, _t = 0, ie = [];
        return k.prototype.enabled = function() {
          return this.F;
        }, k.prototype.Kb = function(St, Et, Ut) {
          if (!this.enabled()) return ["vec4 " + St + " = " + Et + ";"];
          St = this.env.Kb(St, Et, Ut).join(`
`), Et = "";
          for (var ce = /(texture.*?\(.*?\))/g, de = 0, Oe; Oe = ce.exec(St); ) {
            var hn = Oe[1];
            St.slice(Oe.index + 1).indexOf(hn) != -1 && (ce = "tej_env" + Ut + "_texload" + de++, Et += "vec4 " + ce + " = " + hn + `;

`, St = St.split(hn).join(ce), ce = /(texture.*\(.*\))/g);
          }
          return [Et + St];
        }, k.prototype.Dc = function() {
          return this.Xa ? 34067 : this.Wa ? 32879 : this.Va ? 3553 : this.Ua ? 3552 : 0;
        }, Y.prototype.Kb = function(St, Et, Ut) {
          switch (this.mode) {
            case 7681:
              return ["vec4 " + St + " = " + v(Ut) + ";"];
            case 260:
              var ce = "tej_env" + Ut + "_", de = ce + "tex", Oe = ce + "color";
              return ce += "alpha", ["vec4 " + de + " = " + v(Ut) + ";", "vec3 " + Oe + " = " + Et + ".rgb + " + de + ".rgb;", "float " + ce + " = " + Et + ".a * " + de + ".a;", "vec4 " + St + " = vec4(" + Oe + ", " + ce + ");"];
            case 8448:
              return St = ["vec4 " + St, " = ", Et, " * ", v(Ut), ";"], [St.join("")];
            case 8449:
              return ce = "tej_env" + Ut + "_", de = ce + "tex", Oe = ce + "color", ce += "alpha", ["vec4 " + de + " = " + v(Ut) + ";", ["vec3 " + Oe + " = ", Et + ".rgb * (1.0 - " + de + ".a)", " + ", de + ".rgb * " + de + ".a", ";"].join(""), "float " + ce + " = " + Et + ".a;", "vec4 " + St + " = vec4(" + Oe + ", " + ce + ");"];
            case 3042:
              return ce = "tej_env" + Ut + "_", de = ce + "tex", Oe = ce + "color", ce += "alpha", ["vec4 " + de + " = " + v(Ut) + ";", ["vec3 " + Oe + " = ", Et + ".rgb * (1.0 - " + de + ".rgb)", " + ", bt + ".rgb * " + de + ".rgb", ";"].join(""), "float " + ce + " = " + de + ".a;", "vec4 " + St + " = vec4(" + Oe + ", " + ce + ");"];
            case 34160:
              return ce = "tej_env" + Ut + "_", Oe = ce + "color", ce += "alpha", de = this.Cc(!0, Oe, Et, Ut, this.Sa, this.T, this.P), Et = this.Cc(!1, ce, Et, Ut, this.Qa, this.S, this.R), Oe = this.qa == 1 ? Oe : Oe + " * " + U(this.qa), ce = this.pa == 1 ? ce : ce + " * " + U(this.pa), St = ["vec4 " + St, " = vec4(", Oe, ", ", ce, ");"].join(""), [].concat(de, Et, [St]);
          }
          return G("Unsupported TexEnv mode: " + P0(this.mode));
        }, Y.prototype.Cc = function(St, Et, Ut, ce, de, Oe, hn) {
          switch (de) {
            case 7681:
              var pi = 1;
              break;
            case 8448:
            case 260:
            case 34023:
              pi = 2;
              break;
            case 34165:
              pi = 3;
              break;
            default:
              return G("Unsupported combiner: " + P0(de));
          }
          var $n = ["vec4(", U(this.G[0]), ", ", U(this.G[1]), ", ", U(this.G[2]), ", ", U(this.G[3]), ")"].join(""), Cs = 1 <= pi ? O(ce, $n, Ut, Oe[0], hn[0]) : null, Bs = 2 <= pi ? O(ce, $n, Ut, Oe[1], hn[1]) : null;
          switch (Ut = 3 <= pi ? O(ce, $n, Ut, Oe[2], hn[2]) : null, St = St ? "vec3" : "float", de) {
            case 7681:
              Et = [`${St} ${Et} = ${Cs};`];
              break;
            case 8448:
              Et = [`${St} ${Et} = ${Cs} * ${Bs};`];
              break;
            case 260:
              Et = [`${St} ${Et} = ${Cs} + ${Bs};`];
              break;
            case 34023:
              Et = [`${St} ${Et} = ${Cs} - ${Bs};`];
              break;
            case 34165:
              ce = `${`tej_env${ce}_`}colorSrc2`;
              t: {
                switch (de = this.P[2], de) {
                  case 768:
                  case 769:
                    de = "vec3";
                    break t;
                  case 770:
                  case 771:
                    de = "float";
                    break t;
                }
                de = G("Unsupported combiner op: " + P0(de));
              }
              Et = [`${de} ${ce} = ${Ut};`, `${St} ${Et} = ${Cs} * ${ce} + ${Bs} * (1.0 - ${ce});`];
              break;
            default:
              return L("Unmatched TexEnv.colorCombiner?");
          }
          return Et;
        }, {
          Ia: (St, Et) => {
            var Ut = 0;
            for (Et ? Ut = Et : St && (Ut = St.getParameter(St.MAX_TEXTURE_IMAGE_UNITS)), vt = [], St = 0; St < Ut; St++) vt.push(new k());
          },
          Le: (St, Et, Ut, ce) => {
            _ = St, st = Et, bt = Ut, Ct = ce;
          },
          Ud: (St, Et = 0) => {
            ie.length = 0;
            for (var Ut = [], ce = bt, de = 0; de < vt.length; de++) if (vt[de].enabled()) {
              ie.push(de);
              var Oe = "tej_env" + de + "_result";
              ce = vt[de].Kb(Oe, ce, de), Ut = Ut.concat(ce, [""]), ce = Oe;
            }
            for (Ut.push(St + " = " + ce + ";"), St = "", de = 0; de < Et; de++) St += " ";
            return St + Ut.join(`
` + St);
          },
          Zd: () => ie,
          Lf: () => _t,
          jc: (St) => {
            for (var Et of vt) Et.jc(St);
          },
          Nf: (St) => vt[St].Dc(),
          ie: (St) => {
            _t = St - 33984;
          },
          ke: (St) => {
            var Et = vt[_t];
            switch (St) {
              case 3552:
                Et.Ua || (Jt.A = null, Et.Ua = !0, Et.F |= 1);
                break;
              case 3553:
                Et.Va || (Jt.A = null, Et.Va = !0, Et.F |= 2);
                break;
              case 32879:
                Et.Wa || (Jt.A = null, Et.Wa = !0, Et.F |= 4);
                break;
              case 34067:
                Et.Xa || (Jt.A = null, Et.Xa = !0, Et.F |= 8);
            }
          },
          je: (St) => {
            var Et = vt[_t];
            switch (St) {
              case 3552:
                Et.Ua && (Jt.A = null, Et.Ua = !1, Et.F &= -2);
                break;
              case 3553:
                Et.Va && (Jt.A = null, Et.Va = !1, Et.F &= -3);
                break;
              case 32879:
                Et.Wa && (Jt.A = null, Et.Wa = !1, Et.F &= -5);
                break;
              case 34067:
                Et.Xa && (Jt.A = null, Et.Xa = !1, Et.F &= -9);
            }
          },
          Qf(St, Et, Ut) {
            if (St == 8960) switch (St = vt[_t].env, Et) {
              case 34163:
                St.qa != Ut && (St.C(), St.qa = Ut);
                break;
              case 3356:
                St.pa != Ut && (St.C(), St.pa = Ut);
                break;
              default:
                P("WARNING: Unhandled `pname` in call to `glTexEnvf`.");
            }
          },
          Sf(St, Et, Ut) {
            if (St == 8960) switch (St = vt[_t].env, Et) {
              case 8704:
                St.mode != Ut && (St.C(), St.mode = Ut);
                break;
              case 34161:
                St.Sa != Ut && (St.C(), St.Sa = Ut);
                break;
              case 34162:
                St.Qa != Ut && (St.C(), St.Qa = Ut);
                break;
              case 34176:
                St.T[0] != Ut && (St.C(), St.T[0] = Ut);
                break;
              case 34177:
                St.T[1] != Ut && (St.C(), St.T[1] = Ut);
                break;
              case 34178:
                St.T[2] != Ut && (St.C(), St.T[2] = Ut);
                break;
              case 34184:
                St.S[0] != Ut && (St.C(), St.S[0] = Ut);
                break;
              case 34185:
                St.S[1] != Ut && (St.C(), St.S[1] = Ut);
                break;
              case 34186:
                St.S[2] != Ut && (St.C(), St.S[2] = Ut);
                break;
              case 34192:
                St.P[0] != Ut && (St.C(), St.P[0] = Ut);
                break;
              case 34193:
                St.P[1] != Ut && (St.C(), St.P[1] = Ut);
                break;
              case 34194:
                St.P[2] != Ut && (St.C(), St.P[2] = Ut);
                break;
              case 34200:
                St.R[0] != Ut && (St.C(), St.R[0] = Ut);
                break;
              case 34201:
                St.R[1] != Ut && (St.C(), St.R[1] = Ut);
                break;
              case 34202:
                St.R[2] != Ut && (St.C(), St.R[2] = Ut);
                break;
              case 34163:
                St.qa != Ut && (St.C(), St.qa = Ut);
                break;
              case 3356:
                St.pa != Ut && (St.C(), St.pa = Ut);
                break;
              default:
                P("WARNING: Unhandled `pname` in call to `glTexEnvi`.");
            }
          },
          Rf(St, Et, Ut) {
            if (St == 8960) switch (St = vt[_t].env, Et) {
              case 8705:
                for (Et = 0; 4 > Et; Et++) {
                  var ce = (E(), et)[(Ut + 4 * Et) / 4];
                  St.G[Et] != ce && (St.C(), St.G[Et] = ce);
                }
                break;
              default:
                P("WARNING: Unhandled `pname` in call to `glTexEnvfv`.");
            }
          },
          Pf(St, Et, Ut) {
            if (St == 8960) switch (St = vt[_t].env, Et) {
              case 8704:
                (E(), q)[Ut / 4] = St.mode;
                break;
              case 8705:
                (E(), q)[Ut / 4] = Math.max(Math.min(255 * St.G[0], 255, -255)), (E(), q)[(Ut + 1) / 4] = Math.max(Math.min(255 * St.G[1], 255, -255)), (E(), q)[(Ut + 2) / 4] = Math.max(Math.min(255 * St.G[2], 255, -255)), (E(), q)[(Ut + 3) / 4] = Math.max(Math.min(255 * St.G[3], 255, -255));
                break;
              case 34161:
                (E(), q)[Ut / 4] = St.Sa;
                break;
              case 34162:
                (E(), q)[Ut / 4] = St.Qa;
                break;
              case 34176:
                (E(), q)[Ut / 4] = St.T[0];
                break;
              case 34177:
                (E(), q)[Ut / 4] = St.T[1];
                break;
              case 34178:
                (E(), q)[Ut / 4] = St.T[2];
                break;
              case 34184:
                (E(), q)[Ut / 4] = St.S[0];
                break;
              case 34185:
                (E(), q)[Ut / 4] = St.S[1];
                break;
              case 34186:
                (E(), q)[Ut / 4] = St.S[2];
                break;
              case 34192:
                (E(), q)[Ut / 4] = St.P[0];
                break;
              case 34193:
                (E(), q)[Ut / 4] = St.P[1];
                break;
              case 34194:
                (E(), q)[Ut / 4] = St.P[2];
                break;
              case 34200:
                (E(), q)[Ut / 4] = St.R[0];
                break;
              case 34201:
                (E(), q)[Ut / 4] = St.R[1];
                break;
              case 34202:
                (E(), q)[Ut / 4] = St.R[2];
                break;
              case 34163:
                (E(), q)[Ut / 4] = St.qa;
                break;
              case 3356:
                (E(), q)[Ut / 4] = St.pa;
                break;
              default:
                P("WARNING: Unhandled `pname` in call to `glGetTexEnvi`.");
            }
          },
          Of: (St, Et, Ut) => {
            if (St == 8960) switch (St = vt[_t].env, Et) {
              case 8705:
                (E(), et)[Ut / 4] = St.G[0], (E(), et)[(Ut + 4) / 4] = St.G[1], (E(), et)[(Ut + 8) / 4] = St.G[2], (E(), et)[(Ut + 12) / 4] = St.G[3];
            }
          }
        };
      }, yb: null, Ig: null, Ag: null, Tf: null, ud: 0, mode: -1, Je: null, sb: [], cc: 0, Xf: null, Mc: null, Wf: null, Yf: -1, matrix: [], cg: [], Bb: 0, Bg: null, bg: !1, td: !1, ua: 0, Ea: 1, COLOR: 2, TEXTURE0: 3, Ad: -1, Da: -1, pd: 0, ta: [0, 0], O: [], Pc: [], A: null, Yb: !1, Ra: 0, nf: null, xb: [], Db: null, af(G, L, v) {
        if (Jt.sb[G]) Jt.sb[G]++;
        else {
          Jt.sb[G] = 1, Jt.ta[G] = !0;
          var O = Jt.cc, U = Jt.O[G];
          if (U) U.name = G, U.size = L, U.type = v, U.stride = 0, U.Ma = O, U.offset = 0;
          else for (U = 0; U <= G; U++) {
            let Y, k;
            (Y = Jt.O)[k = U] || (Y[k] = { name: G, size: L, type: v, stride: 0, Ma: O, offset: 0 });
          }
          Jt.Yb = !0, Jt.cc += L * jv[v - 5120], Pv[G] || (Pv[G] = !0, Ht.enableVertexAttribArray(G));
        }
      }, xf() {
        for (var G = 0; G < Jt.Ad; G++) Jt.sb[G] && (Jt.ta[G] = !1);
      }, ne: !1, Ia() {
        P("WARNING: using emscripten GL immediate mode emulation. This is very limited in what it supports"), Jt.ne = !0;
      }, flush(G, L = 0, v = 0) {
        var O = e7(), U = 4 * Jt.ud / Jt.stride;
        if (U) {
          var Y = !1, k = 0;
          if (G) {
            if (k = G, !Ht.ma && Jt.Ga > Jt.Za) for (var _ = 0; _ < G; _++) {
              var st = (E(), D)[(v + 2 * _) / 2];
              Jt.Ga = Math.min(Jt.Ga, st), Jt.Za = Math.max(Jt.Za, st + 1);
            }
            Ht.vc || (Y = G << 1, Y = 32 - Math.clz32(Y === 0 ? 0 : Y - 1), (_ = hi.fc[Y]) ? Y = _ : (_ = Ht.getParameter(34965), hi.fc[Y] = Ht.createBuffer(), Ht.bindBuffer(34963, hi.fc[Y]), Ht.bufferData(34963, 1 << Y, 35048), Ht.bindBuffer(34963, _), Y = hi.fc[Y]), Ht.bindBuffer(Ht.ELEMENT_ARRAY_BUFFER, Y), Ht.bufferSubData(Ht.ELEMENT_ARRAY_BUFFER, 0, (E(), D).subarray(v / 2, (v + (G << 1)) / 2)), v = 0, Y = !0);
          } else 6 < Jt.mode && (Jt.mode != 7 && Xt("unsupported immediate mode " + Jt.mode), v = 3 * Jt.Ga, k = U / 4 * 6, Ht.bindBuffer(Ht.ELEMENT_ARRAY_BUFFER, hi.Cg), Y = !0, Jt.mode = Ht.TRIANGLES);
          O.Ee(), k ? Ht.drawElements(
            Jt.mode,
            k,
            Ht.UNSIGNED_SHORT,
            v
          ) : Ht.drawArrays(Jt.mode, L, U), Y && Ht.bindBuffer(Ht.ELEMENT_ARRAY_BUFFER, A_[Ht.vc] || null);
        }
      } };
      Jt.pb = (() => {
        var G = {}, L = {}, v = {}, O = {}, U = Float32Array;
        return G.create = function(Y) {
          var k = new U(3);
          return Y ? (k[0] = Y[0], k[1] = Y[1], k[2] = Y[2]) : k[0] = k[1] = k[2] = 0, k;
        }, G.set = function(Y, k) {
          return k[0] = Y[0], k[1] = Y[1], k[2] = Y[2], k;
        }, G.add = function(Y, k, _) {
          return !_ || Y === _ ? (Y[0] += k[0], Y[1] += k[1], Y[2] += k[2], Y) : (_[0] = Y[0] + k[0], _[1] = Y[1] + k[1], _[2] = Y[2] + k[2], _);
        }, G.zg = function(Y, k, _) {
          return !_ || Y === _ ? (Y[0] -= k[0], Y[1] -= k[1], Y[2] -= k[2], Y) : (_[0] = Y[0] - k[0], _[1] = Y[1] - k[1], _[2] = Y[2] - k[2], _);
        }, G.multiply = function(Y, k, _) {
          return !_ || Y === _ ? (Y[0] *= k[0], Y[1] *= k[1], Y[2] *= k[2], Y) : (_[0] = Y[0] * k[0], _[1] = Y[1] * k[1], _[2] = Y[2] * k[2], _);
        }, G.jg = function(Y, k) {
          return k || (k = Y), k[0] = -Y[0], k[1] = -Y[1], k[2] = -Y[2], k;
        }, G.scale = function(Y, k, _) {
          return !_ || Y === _ ? (Y[0] *= k, Y[1] *= k, Y[2] *= k, Y) : (_[0] = Y[0] * k, _[1] = Y[1] * k, _[2] = Y[2] * k, _);
        }, G.normalize = function(Y, k) {
          k || (k = Y);
          var _ = Y[0], st = Y[1];
          Y = Y[2];
          var bt = Math.sqrt(_ * _ + st * st + Y * Y);
          return bt ? bt === 1 ? (k[0] = _, k[1] = st, k[2] = Y, k) : (bt = 1 / bt, k[0] = _ * bt, k[1] = st * bt, k[2] = Y * bt, k) : (k[0] = 0, k[1] = 0, k[2] = 0, k);
        }, G.sf = function(Y, k, _) {
          _ || (_ = Y);
          var st = Y[0], bt = Y[1];
          Y = Y[2];
          var Ct = k[0], vt = k[1];
          return k = k[2], _[0] = bt * k - Y * vt, _[1] = Y * Ct - st * k, _[2] = st * vt - bt * Ct, _;
        }, G.length = function(Y) {
          var k = Y[0], _ = Y[1];
          return Y = Y[2], Math.sqrt(k * k + _ * _ + Y * Y);
        }, G.Nd = function(Y, k) {
          return Y[0] * k[0] + Y[1] * k[1] + Y[2] * k[2];
        }, G.direction = function(Y, k, _) {
          _ || (_ = Y);
          var st = Y[0] - k[0], bt = Y[1] - k[1];
          return Y = Y[2] - k[2], k = Math.sqrt(st * st + bt * bt + Y * Y), k ? (k = 1 / k, _[0] = st * k, _[1] = bt * k, _[2] = Y * k, _) : (_[0] = 0, _[1] = 0, _[2] = 0, _);
        }, G.Zf = function(Y, k, _, st) {
          return st || (st = Y), st[0] = Y[0] + _ * (k[0] - Y[0]), st[1] = Y[1] + _ * (k[1] - Y[1]), st[2] = Y[2] + _ * (k[2] - Y[2]), st;
        }, G.zf = function(Y, k) {
          var _ = k[0] - Y[0], st = k[1] - Y[1];
          return Y = k[2] - Y[2], Math.sqrt(_ * _ + st * st + Y * Y);
        }, G.Gg = function(Y, k, _, st, bt) {
          bt || (bt = Y);
          var Ct = v.create(), vt = new U(4);
          return vt[0] = 2 * (Y[0] - st[0]) / st[2] - 1, vt[1] = 2 * (Y[1] - st[1]) / st[3] - 1, vt[2] = 2 * Y[2] - 1, vt[3] = 1, v.multiply(_, k, Ct), !v.inverse(Ct) || (v.ye(Ct, vt), vt[3] === 0) ? null : (bt[0] = vt[0] / vt[3], bt[1] = vt[1] / vt[3], bt[2] = vt[2] / vt[3], bt);
        }, G.dc = function(Y) {
          return "[" + Y[0] + ", " + Y[1] + ", " + Y[2] + "]";
        }, L.create = function(Y) {
          var k = new U(9);
          return Y && (k[0] = Y[0], k[1] = Y[1], k[2] = Y[2], k[3] = Y[3], k[4] = Y[4], k[5] = Y[5], k[6] = Y[6], k[7] = Y[7], k[8] = Y[8]), k;
        }, L.set = function(Y, k) {
          return k[0] = Y[0], k[1] = Y[1], k[2] = Y[2], k[3] = Y[3], k[4] = Y[4], k[5] = Y[5], k[6] = Y[6], k[7] = Y[7], k[8] = Y[8], k;
        }, L.Fc = function(Y) {
          return Y || (Y = L.create()), Y[0] = 1, Y[1] = 0, Y[2] = 0, Y[3] = 0, Y[4] = 1, Y[5] = 0, Y[6] = 0, Y[7] = 0, Y[8] = 1, Y;
        }, L.rd = function(Y) {
          var k = Y[1], _ = Y[2], st = Y[5];
          Y[1] = Y[3], Y[2] = Y[6], Y[3] = k, Y[5] = Y[7], Y[6] = _, Y[7] = st;
        }, L.Xe = function(Y, k) {
          return k || (k = v.create()), k[15] = 1, k[14] = 0, k[13] = 0, k[12] = 0, k[11] = 0, k[10] = Y[8], k[9] = Y[7], k[8] = Y[6], k[7] = 0, k[6] = Y[5], k[5] = Y[4], k[4] = Y[3], k[3] = 0, k[2] = Y[2], k[1] = Y[1], k[0] = Y[0], k;
        }, L.dc = function(Y) {
          return "[" + Y[0] + ", " + Y[1] + ", " + Y[2] + ", " + Y[3] + ", " + Y[4] + ", " + Y[5] + ", " + Y[6] + ", " + Y[7] + ", " + Y[8] + "]";
        }, v.create = function(Y) {
          var k = new U(16);
          return Y && (k[0] = Y[0], k[1] = Y[1], k[2] = Y[2], k[3] = Y[3], k[4] = Y[4], k[5] = Y[5], k[6] = Y[6], k[7] = Y[7], k[8] = Y[8], k[9] = Y[9], k[10] = Y[10], k[11] = Y[11], k[12] = Y[12], k[13] = Y[13], k[14] = Y[14], k[15] = Y[15]), k;
        }, v.set = function(Y, k) {
          return k[0] = Y[0], k[1] = Y[1], k[2] = Y[2], k[3] = Y[3], k[4] = Y[4], k[5] = Y[5], k[6] = Y[6], k[7] = Y[7], k[8] = Y[8], k[9] = Y[9], k[10] = Y[10], k[11] = Y[11], k[12] = Y[12], k[13] = Y[13], k[14] = Y[14], k[15] = Y[15], k;
        }, v.Fc = function(Y) {
          return Y || (Y = v.create()), Y[0] = 1, Y[1] = 0, Y[2] = 0, Y[3] = 0, Y[4] = 0, Y[5] = 1, Y[6] = 0, Y[7] = 0, Y[8] = 0, Y[9] = 0, Y[10] = 1, Y[11] = 0, Y[12] = 0, Y[13] = 0, Y[14] = 0, Y[15] = 1, Y;
        }, v.rd = function(Y) {
          var k = Y[1], _ = Y[2], st = Y[3], bt = Y[6], Ct = Y[7], vt = Y[11];
          Y[1] = Y[4], Y[2] = Y[8], Y[3] = Y[12], Y[4] = k, Y[6] = Y[9], Y[7] = Y[13], Y[8] = _, Y[9] = bt, Y[11] = Y[14], Y[12] = st, Y[13] = Ct, Y[14] = vt;
        }, v.uf = function(Y) {
          var k = Y[0], _ = Y[1], st = Y[2], bt = Y[3], Ct = Y[4], vt = Y[5], _t = Y[6], ie = Y[7], St = Y[8], Et = Y[9], Ut = Y[10], ce = Y[11], de = Y[12], Oe = Y[13], hn = Y[14];
          return Y = Y[15], de * Et * _t * bt - St * Oe * _t * bt - de * vt * Ut * bt + Ct * Oe * Ut * bt + St * vt * hn * bt - Ct * Et * hn * bt - de * Et * st * ie + St * Oe * st * ie + de * _ * Ut * ie - k * Oe * Ut * ie - St * _ * hn * ie + k * Et * hn * ie + de * vt * st * ce - Ct * Oe * st * ce - de * _ * _t * ce + k * Oe * _t * ce + Ct * _ * hn * ce - k * vt * hn * ce - St * vt * st * Y + Ct * Et * st * Y + St * _ * _t * Y - k * Et * _t * Y - Ct * _ * Ut * Y + k * vt * Ut * Y;
        }, v.inverse = function(Y, k) {
          k || (k = Y);
          var _ = Y[0], st = Y[1], bt = Y[2], Ct = Y[3], vt = Y[4], _t = Y[5], ie = Y[6], St = Y[7], Et = Y[8], Ut = Y[9], ce = Y[10], de = Y[11], Oe = Y[12], hn = Y[13], pi = Y[14];
          Y = Y[15];
          var $n = _ * _t - st * vt, Cs = _ * ie - bt * vt, Bs = _ * St - Ct * vt, oa = st * ie - bt * _t, la = st * St - Ct * _t, ca = bt * St - Ct * ie, ua = Et * hn - Ut * Oe, da = Et * pi - ce * Oe, ha = Et * Y - de * Oe, pa = Ut * pi - ce * hn, Al = Ut * Y - de * hn, Bl = ce * Y - de * pi, Ji = $n * Bl - Cs * Al + Bs * pa + oa * ha - la * da + ca * ua;
          return Ji ? (Ji = 1 / Ji, k[0] = (_t * Bl - ie * Al + St * pa) * Ji, k[1] = (-st * Bl + bt * Al - Ct * pa) * Ji, k[2] = (hn * ca - pi * la + Y * oa) * Ji, k[3] = (-Ut * ca + ce * la - de * oa) * Ji, k[4] = (-vt * Bl + ie * ha - St * da) * Ji, k[5] = (_ * Bl - bt * ha + Ct * da) * Ji, k[6] = (-Oe * ca + pi * Bs - Y * Cs) * Ji, k[7] = (Et * ca - ce * Bs + de * Cs) * Ji, k[8] = (vt * Al - _t * ha + St * ua) * Ji, k[9] = (-_ * Al + st * ha - Ct * ua) * Ji, k[10] = (Oe * la - hn * Bs + Y * $n) * Ji, k[11] = (-Et * la + Ut * Bs - de * $n) * Ji, k[12] = (-vt * pa + _t * da - ie * ua) * Ji, k[13] = (_ * pa - st * da + bt * ua) * Ji, k[14] = (-Oe * oa + hn * Cs - pi * $n) * Ji, k[15] = (Et * oa - Ut * Cs + ce * $n) * Ji, k) : null;
        }, v.Eg = function(Y, k) {
          return k || (k = v.create()), k[0] = Y[0], k[1] = Y[1], k[2] = Y[2], k[3] = Y[3], k[4] = Y[4], k[5] = Y[5], k[6] = Y[6], k[7] = Y[7], k[8] = Y[8], k[9] = Y[9], k[10] = Y[10], k[11] = Y[11], k[12] = 0, k[13] = 0, k[14] = 0, k[15] = 1, k;
        }, v.od = function(Y) {
          var k;
          return k || (k = L.create()), k[0] = Y[0], k[1] = Y[1], k[2] = Y[2], k[3] = Y[4], k[4] = Y[5], k[5] = Y[6], k[6] = Y[8], k[7] = Y[9], k[8] = Y[10], k;
        }, v.Dg = function(Y, k) {
          var _ = Y[0], st = Y[1], bt = Y[2], Ct = Y[4], vt = Y[5], _t = Y[6], ie = Y[8], St = Y[9];
          Y = Y[10];
          var Et = Y * vt - _t * St, Ut = -Y * Ct + _t * ie, ce = St * Ct - vt * ie, de = _ * Et + st * Ut + bt * ce;
          return de ? (de = 1 / de, k || (k = L.create()), k[0] = Et * de, k[1] = (-Y * st + bt * St) * de, k[2] = (_t * st - bt * vt) * de, k[3] = Ut * de, k[4] = (Y * _ - bt * ie) * de, k[5] = (-_t * _ + bt * Ct) * de, k[6] = ce * de, k[7] = (-St * _ + st * ie) * de, k[8] = (vt * _ - st * Ct) * de, k) : null;
        }, v.multiply = function(Y, k, _) {
          _ || (_ = Y);
          var st = Y[0], bt = Y[1], Ct = Y[2], vt = Y[3], _t = Y[4], ie = Y[5], St = Y[6], Et = Y[7], Ut = Y[8], ce = Y[9], de = Y[10], Oe = Y[11], hn = Y[12], pi = Y[13], $n = Y[14];
          Y = Y[15];
          var Cs = k[0], Bs = k[1], oa = k[2], la = k[3], ca = k[4], ua = k[5], da = k[6], ha = k[7], pa = k[8], Al = k[9], Bl = k[10], Ji = k[11], Y1 = k[12], v1 = k[13], R1 = k[14];
          return k = k[15], _[0] = Cs * st + Bs * _t + oa * Ut + la * hn, _[1] = Cs * bt + Bs * ie + oa * ce + la * pi, _[2] = Cs * Ct + Bs * St + oa * de + la * $n, _[3] = Cs * vt + Bs * Et + oa * Oe + la * Y, _[4] = ca * st + ua * _t + da * Ut + ha * hn, _[5] = ca * bt + ua * ie + da * ce + ha * pi, _[6] = ca * Ct + ua * St + da * de + ha * $n, _[7] = ca * vt + ua * Et + da * Oe + ha * Y, _[8] = pa * st + Al * _t + Bl * Ut + Ji * hn, _[9] = pa * bt + Al * ie + Bl * ce + Ji * pi, _[10] = pa * Ct + Al * St + Bl * de + Ji * $n, _[11] = pa * vt + Al * Et + Bl * Oe + Ji * Y, _[12] = Y1 * st + v1 * _t + R1 * Ut + k * hn, _[13] = Y1 * bt + v1 * ie + R1 * ce + k * pi, _[14] = Y1 * Ct + v1 * St + R1 * de + k * $n, _[15] = Y1 * vt + v1 * Et + R1 * Oe + k * Y, _;
        }, v.xe = function(Y, k, _) {
          _ || (_ = k);
          var st = k[0], bt = k[1];
          return k = k[2], _[0] = Y[0] * st + Y[4] * bt + Y[8] * k + Y[12], _[1] = Y[1] * st + Y[5] * bt + Y[9] * k + Y[13], _[2] = Y[2] * st + Y[6] * bt + Y[10] * k + Y[14], _;
        }, v.ye = function(Y, k) {
          var _;
          _ || (_ = k);
          var st = k[0], bt = k[1], Ct = k[2];
          k = k[3], _[0] = Y[0] * st + Y[4] * bt + Y[8] * Ct + Y[12] * k, _[1] = Y[1] * st + Y[5] * bt + Y[9] * Ct + Y[13] * k, _[2] = Y[2] * st + Y[6] * bt + Y[10] * Ct + Y[14] * k, _[3] = Y[3] * st + Y[7] * bt + Y[11] * Ct + Y[15] * k;
        }, v.translate = function(Y, k, _) {
          var st = k[0], bt = k[1];
          if (k = k[2], !_ || Y === _) return Y[12] = Y[0] * st + Y[4] * bt + Y[8] * k + Y[12], Y[13] = Y[1] * st + Y[5] * bt + Y[9] * k + Y[13], Y[14] = Y[2] * st + Y[6] * bt + Y[10] * k + Y[14], Y[15] = Y[3] * st + Y[7] * bt + Y[11] * k + Y[15], Y;
          var Ct = Y[0], vt = Y[1], _t = Y[2], ie = Y[3], St = Y[4], Et = Y[5], Ut = Y[6], ce = Y[7], de = Y[8], Oe = Y[9], hn = Y[10], pi = Y[11];
          return _[0] = Ct, _[1] = vt, _[2] = _t, _[3] = ie, _[4] = St, _[5] = Et, _[6] = Ut, _[7] = ce, _[8] = de, _[9] = Oe, _[10] = hn, _[11] = pi, _[12] = Ct * st + St * bt + de * k + Y[12], _[13] = vt * st + Et * bt + Oe * k + Y[13], _[14] = _t * st + Ut * bt + hn * k + Y[14], _[15] = ie * st + ce * bt + pi * k + Y[15], _;
        }, v.scale = function(Y, k, _) {
          var st = k[0], bt = k[1];
          return k = k[2], !_ || Y === _ ? (Y[0] *= st, Y[1] *= st, Y[2] *= st, Y[3] *= st, Y[4] *= bt, Y[5] *= bt, Y[6] *= bt, Y[7] *= bt, Y[8] *= k, Y[9] *= k, Y[10] *= k, Y[11] *= k, Y) : (_[0] = Y[0] * st, _[1] = Y[1] * st, _[2] = Y[2] * st, _[3] = Y[3] * st, _[4] = Y[4] * bt, _[5] = Y[5] * bt, _[6] = Y[6] * bt, _[7] = Y[7] * bt, _[8] = Y[8] * k, _[9] = Y[9] * k, _[10] = Y[10] * k, _[11] = Y[11] * k, _[12] = Y[12], _[13] = Y[13], _[14] = Y[14], _[15] = Y[15], _);
        }, v.rotate = function(Y, k, _, st) {
          var bt = _[0], Ct = _[1];
          _ = _[2];
          var vt = Math.sqrt(bt * bt + Ct * Ct + _ * _);
          if (!vt) return null;
          vt !== 1 && (vt = 1 / vt, bt *= vt, Ct *= vt, _ *= vt);
          var _t = Math.sin(k), ie = Math.cos(k), St = 1 - ie;
          k = Y[0], vt = Y[1];
          var Et = Y[2], Ut = Y[3], ce = Y[4], de = Y[5], Oe = Y[6], hn = Y[7], pi = Y[8], $n = Y[9], Cs = Y[10], Bs = Y[11], oa = bt * bt * St + ie, la = Ct * bt * St + _ * _t, ca = _ * bt * St - Ct * _t, ua = bt * Ct * St - _ * _t, da = Ct * Ct * St + ie, ha = _ * Ct * St + bt * _t, pa = bt * _ * St + Ct * _t;
          return bt = Ct * _ * St - bt * _t, Ct = _ * _ * St + ie, st ? Y !== st && (st[12] = Y[12], st[13] = Y[13], st[14] = Y[14], st[15] = Y[15]) : st = Y, st[0] = k * oa + ce * la + pi * ca, st[1] = vt * oa + de * la + $n * ca, st[2] = Et * oa + Oe * la + Cs * ca, st[3] = Ut * oa + hn * la + Bs * ca, st[4] = k * ua + ce * da + pi * ha, st[5] = vt * ua + de * da + $n * ha, st[6] = Et * ua + Oe * da + Cs * ha, st[7] = Ut * ua + hn * da + Bs * ha, st[8] = k * pa + ce * bt + pi * Ct, st[9] = vt * pa + de * bt + $n * Ct, st[10] = Et * pa + Oe * bt + Cs * Ct, st[11] = Ut * pa + hn * bt + Bs * Ct, st;
        }, v.ug = function(Y, k, _) {
          var st = Math.sin(k);
          k = Math.cos(k);
          var bt = Y[4], Ct = Y[5], vt = Y[6], _t = Y[7], ie = Y[8], St = Y[9], Et = Y[10], Ut = Y[11];
          return _ ? Y !== _ && (_[0] = Y[0], _[1] = Y[1], _[2] = Y[2], _[3] = Y[3], _[12] = Y[12], _[13] = Y[13], _[14] = Y[14], _[15] = Y[15]) : _ = Y, _[4] = bt * k + ie * st, _[5] = Ct * k + St * st, _[6] = vt * k + Et * st, _[7] = _t * k + Ut * st, _[8] = bt * -st + ie * k, _[9] = Ct * -st + St * k, _[10] = vt * -st + Et * k, _[11] = _t * -st + Ut * k, _;
        }, v.vg = function(Y, k, _) {
          var st = Math.sin(k);
          k = Math.cos(k);
          var bt = Y[0], Ct = Y[1], vt = Y[2], _t = Y[3], ie = Y[8], St = Y[9], Et = Y[10], Ut = Y[11];
          return _ ? Y !== _ && (_[4] = Y[4], _[5] = Y[5], _[6] = Y[6], _[7] = Y[7], _[12] = Y[12], _[13] = Y[13], _[14] = Y[14], _[15] = Y[15]) : _ = Y, _[0] = bt * k + ie * -st, _[1] = Ct * k + St * -st, _[2] = vt * k + Et * -st, _[3] = _t * k + Ut * -st, _[8] = bt * st + ie * k, _[9] = Ct * st + St * k, _[10] = vt * st + Et * k, _[11] = _t * st + Ut * k, _;
        }, v.wg = function(Y, k, _) {
          var st = Math.sin(k);
          k = Math.cos(k);
          var bt = Y[0], Ct = Y[1], vt = Y[2], _t = Y[3], ie = Y[4], St = Y[5], Et = Y[6], Ut = Y[7];
          return _ ? Y !== _ && (_[8] = Y[8], _[9] = Y[9], _[10] = Y[10], _[11] = Y[11], _[12] = Y[12], _[13] = Y[13], _[14] = Y[14], _[15] = Y[15]) : _ = Y, _[0] = bt * k + ie * st, _[1] = Ct * k + St * st, _[2] = vt * k + Et * st, _[3] = _t * k + Ut * st, _[4] = bt * -st + ie * k, _[5] = Ct * -st + St * k, _[6] = vt * -st + Et * k, _[7] = _t * -st + Ut * k, _;
        }, v.Td = function(Y, k, _, st, bt, Ct, vt) {
          vt || (vt = v.create());
          var _t = k - Y, ie = st - _, St = Ct - bt;
          return vt[0] = 2 * bt / _t, vt[1] = 0, vt[2] = 0, vt[3] = 0, vt[4] = 0, vt[5] = 2 * bt / ie, vt[6] = 0, vt[7] = 0, vt[8] = (k + Y) / _t, vt[9] = (st + _) / ie, vt[10] = -(Ct + bt) / St, vt[11] = -1, vt[12] = 0, vt[13] = 0, vt[14] = -(Ct * bt * 2) / St, vt[15] = 0, vt;
        }, v.perspective = function(Y, k, _, st, bt) {
          return Y = _ * Math.tan(Y * Math.PI / 360), k *= Y, v.Td(-k, k, -Y, Y, _, st, bt);
        }, v.lg = function(Y, k, _, st, bt, Ct, vt) {
          vt || (vt = v.create());
          var _t = k - Y, ie = st - _, St = Ct - bt;
          return vt[0] = 2 / _t, vt[1] = 0, vt[2] = 0, vt[3] = 0, vt[4] = 0, vt[5] = 2 / ie, vt[6] = 0, vt[7] = 0, vt[8] = 0, vt[9] = 0, vt[10] = -2 / St, vt[11] = 0, vt[12] = -(Y + k) / _t, vt[13] = -(st + _) / ie, vt[14] = -(Ct + bt) / St, vt[15] = 1, vt;
        }, v.$f = function(Y, k, _, st) {
          st || (st = v.create());
          var bt = Y[0], Ct = Y[1];
          Y = Y[2];
          var vt = _[0], _t = _[1], ie = _[2], St = k[0];
          _ = k[1];
          var Et = k[2];
          if (bt === St && Ct === _ && Y === Et) return v.Fc(st);
          k = bt - St, _ = Ct - _, St = Y - Et;
          var Ut = 1 / Math.sqrt(k * k + _ * _ + St * St);
          k *= Ut, _ *= Ut, St *= Ut, Et = _t * St - ie * _, ie = ie * k - vt * St, vt = vt * _ - _t * k, (Ut = Math.sqrt(Et * Et + ie * ie + vt * vt)) ? (Ut = 1 / Ut, Et *= Ut, ie *= Ut, vt *= Ut) : vt = ie = Et = 0, _t = _ * vt - St * ie;
          var ce = St * Et - k * vt, de = k * ie - _ * Et;
          return (Ut = Math.sqrt(_t * _t + ce * ce + de * de)) ? (Ut = 1 / Ut, _t *= Ut, ce *= Ut, de *= Ut) : de = ce = _t = 0, st[0] = Et, st[1] = _t, st[2] = k, st[3] = 0, st[4] = ie, st[5] = ce, st[6] = _, st[7] = 0, st[8] = vt, st[9] = de, st[10] = St, st[11] = 0, st[12] = -(Et * bt + ie * Ct + vt * Y), st[13] = -(_t * bt + ce * Ct + de * Y), st[14] = -(k * bt + _ * Ct + St * Y), st[15] = 1, st;
        }, v.Ff = function(Y, k, _) {
          _ || (_ = v.create());
          var st = Y[0], bt = Y[1], Ct = Y[2], vt = Y[3], _t = st + st, ie = bt + bt, St = Ct + Ct;
          Y = st * _t;
          var Et = st * ie;
          st *= St;
          var Ut = bt * ie;
          return bt *= St, Ct *= St, _t *= vt, ie *= vt, vt *= St, _[0] = 1 - (Ut + Ct), _[1] = Et + vt, _[2] = st - ie, _[3] = 0, _[4] = Et - vt, _[5] = 1 - (Y + Ct), _[6] = bt + _t, _[7] = 0, _[8] = st + ie, _[9] = bt - _t, _[10] = 1 - (Y + Ut), _[11] = 0, _[12] = k[0], _[13] = k[1], _[14] = k[2], _[15] = 1, _;
        }, v.dc = function(Y) {
          return "[" + Y[0] + ", " + Y[1] + ", " + Y[2] + ", " + Y[3] + ", " + Y[4] + ", " + Y[5] + ", " + Y[6] + ", " + Y[7] + ", " + Y[8] + ", " + Y[9] + ", " + Y[10] + ", " + Y[11] + ", " + Y[12] + ", " + Y[13] + ", " + Y[14] + ", " + Y[15] + "]";
        }, O.create = function(Y) {
          var k = new U(4);
          return Y && (k[0] = Y[0], k[1] = Y[1], k[2] = Y[2], k[3] = Y[3]), k;
        }, O.set = function(Y, k) {
          return k[0] = Y[0], k[1] = Y[1], k[2] = Y[2], k[3] = Y[3], k;
        }, O.lf = function(Y, k) {
          var _ = Y[0], st = Y[1], bt = Y[2];
          return !k || Y === k ? (Y[3] = -Math.sqrt(Math.abs(1 - _ * _ - st * st - bt * bt)), Y) : (k[0] = _, k[1] = st, k[2] = bt, k[3] = -Math.sqrt(Math.abs(1 - _ * _ - st * st - bt * bt)), k);
        }, O.Nd = function(Y, k) {
          return Y[0] * k[0] + Y[1] * k[1] + Y[2] * k[2] + Y[3] * k[3];
        }, O.inverse = function(Y, k) {
          var _ = Y[0], st = Y[1], bt = Y[2], Ct = Y[3];
          return _ = (_ = _ * _ + st * st + bt * bt + Ct * Ct) ? 1 / _ : 0, !k || Y === k ? (Y[0] *= -_, Y[1] *= -_, Y[2] *= -_, Y[3] *= _, Y) : (k[0] = -Y[0] * _, k[1] = -Y[1] * _, k[2] = -Y[2] * _, k[3] = Y[3] * _, k);
        }, O.pf = function(Y, k) {
          return !k || Y === k ? (Y[0] *= -1, Y[1] *= -1, Y[2] *= -1, Y) : (k[0] = -Y[0], k[1] = -Y[1], k[2] = -Y[2], k[3] = Y[3], k);
        }, O.length = function(Y) {
          var k = Y[0], _ = Y[1], st = Y[2];
          return Y = Y[3], Math.sqrt(k * k + _ * _ + st * st + Y * Y);
        }, O.normalize = function(Y, k) {
          k || (k = Y);
          var _ = Y[0], st = Y[1], bt = Y[2];
          Y = Y[3];
          var Ct = Math.sqrt(_ * _ + st * st + bt * bt + Y * Y);
          return Ct === 0 ? (k[0] = 0, k[1] = 0, k[2] = 0, k[3] = 0, k) : (Ct = 1 / Ct, k[0] = _ * Ct, k[1] = st * Ct, k[2] = bt * Ct, k[3] = Y * Ct, k);
        }, O.add = function(Y, k, _) {
          return !_ || Y === _ ? (Y[0] += k[0], Y[1] += k[1], Y[2] += k[2], Y[3] += k[3], Y) : (_[0] = Y[0] + k[0], _[1] = Y[1] + k[1], _[2] = Y[2] + k[2], _[3] = Y[3] + k[3], _);
        }, O.multiply = function(Y, k, _) {
          _ || (_ = Y);
          var st = Y[0], bt = Y[1], Ct = Y[2];
          Y = Y[3];
          var vt = k[0], _t = k[1], ie = k[2];
          return k = k[3], _[0] = st * k + Y * vt + bt * ie - Ct * _t, _[1] = bt * k + Y * _t + Ct * vt - st * ie, _[2] = Ct * k + Y * ie + st * _t - bt * vt, _[3] = Y * k - st * vt - bt * _t - Ct * ie, _;
        }, O.xe = function(Y, k, _) {
          _ || (_ = k);
          var st = k[0], bt = k[1], Ct = k[2];
          k = Y[0];
          var vt = Y[1], _t = Y[2];
          Y = Y[3];
          var ie = Y * st + vt * Ct - _t * bt, St = Y * bt + _t * st - k * Ct, Et = Y * Ct + k * bt - vt * st;
          return st = -k * st - vt * bt - _t * Ct, _[0] = ie * Y + st * -k + St * -_t - Et * -vt, _[1] = St * Y + st * -vt + Et * -k - ie * -_t, _[2] = Et * Y + st * -_t + ie * -vt - St * -k, _;
        }, O.scale = function(Y, k, _) {
          return !_ || Y === _ ? (Y[0] *= k, Y[1] *= k, Y[2] *= k, Y[3] *= k, Y) : (_[0] = Y[0] * k, _[1] = Y[1] * k, _[2] = Y[2] * k, _[3] = Y[3] * k, _);
        }, O.od = function(Y) {
          var k;
          k || (k = L.create());
          var _ = Y[0], st = Y[1], bt = Y[2], Ct = Y[3], vt = _ + _, _t = st + st, ie = bt + bt;
          Y = _ * vt;
          var St = _ * _t;
          _ *= ie;
          var Et = st * _t;
          return st *= ie, bt *= ie, vt *= Ct, _t *= Ct, Ct *= ie, k[0] = 1 - (Et + bt), k[1] = St + Ct, k[2] = _ - _t, k[3] = St - Ct, k[4] = 1 - (Y + bt), k[5] = st + vt, k[6] = _ + _t, k[7] = st - vt, k[8] = 1 - (Y + Et), k;
        }, O.Xe = function(Y, k) {
          k || (k = v.create());
          var _ = Y[0], st = Y[1], bt = Y[2], Ct = Y[3], vt = _ + _, _t = st + st, ie = bt + bt;
          Y = _ * vt;
          var St = _ * _t;
          _ *= ie;
          var Et = st * _t;
          return st *= ie, bt *= ie, vt *= Ct, _t *= Ct, Ct *= ie, k[0] = 1 - (Et + bt), k[1] = St + Ct, k[2] = _ - _t, k[3] = 0, k[4] = St - Ct, k[5] = 1 - (Y + bt), k[6] = st + vt, k[7] = 0, k[8] = _ + _t, k[9] = st - vt, k[10] = 1 - (Y + Et), k[11] = 0, k[12] = 0, k[13] = 0, k[14] = 0, k[15] = 1, k;
        }, O.xg = function(Y, k, _, st) {
          st || (st = Y);
          var bt = Y[0] * k[0] + Y[1] * k[1] + Y[2] * k[2] + Y[3] * k[3];
          if (1 <= Math.abs(bt)) return st !== Y && (st[0] = Y[0], st[1] = Y[1], st[2] = Y[2], st[3] = Y[3]), st;
          var Ct = Math.acos(bt), vt = Math.sqrt(1 - bt * bt);
          return 1e-3 > Math.abs(vt) ? (st[0] = 0.5 * Y[0] + 0.5 * k[0], st[1] = 0.5 * Y[1] + 0.5 * k[1], st[2] = 0.5 * Y[2] + 0.5 * k[2], st[3] = 0.5 * Y[3] + 0.5 * k[3], st) : (bt = Math.sin((1 - _) * Ct) / vt, _ = Math.sin(_ * Ct) / vt, st[0] = Y[0] * bt + k[0] * _, st[1] = Y[1] * bt + k[1] * _, st[2] = Y[2] * bt + k[2] * _, st[3] = Y[3] * bt + k[3] * _, st);
        }, O.dc = function(Y) {
          return "[" + Y[0] + ", " + Y[1] + ", " + Y[2] + ", " + Y[3] + "]";
        }, { Hg: G, ag: L, ob: v, pg: O };
      })();
      var TR = 0, hx = 1, MR = 1, px = null, mx = 2048, ol = !1, J0 = 6, mp = [!1, !1, !1, !1, !1, !1], NR = [], Hc = !1, A0 = null, WR = null, GR = null, wR = null, xR = null, SR = null, Qg = 8, Wd = [!1, !1, !1, !1, !1, !1, !1, !1], LR = [], VR = [], XR = [], IR = [], Gd = !1, bx = 519, CR = 0, YR = 1, fx = !1;
      function vR() {
        if (!fx) {
          fx = !0, px = new Float32Array(4);
          for (var G = 0; G < J0; G++) NR[G] = new Float32Array(4);
          for (A0 = new Float32Array([0.2, 0.2, 0.2, 1]), WR = new Float32Array([0.2, 0.2, 0.2, 1]), GR = new Float32Array([0.8, 0.8, 0.8, 1]), wR = new Float32Array([0, 0, 0, 1]), xR = new Float32Array([0]), SR = new Float32Array([0, 0, 0, 1]), G = 0; G < Qg; G++) LR[G] = new Float32Array([0, 0, 0, 1]), VR[G] = G ? new Float32Array([0, 0, 0, 1]) : new Float32Array([1, 1, 1, 1]), XR[G] = G ? new Float32Array([0, 0, 0, 1]) : new Float32Array([1, 1, 1, 1]), IR[G] = new Float32Array([0, 0, 1, 0]);
          P("WARNING: using emscripten GL emulation. This is a collection of limited workarounds, do not expect it to work.");
          var L = { 2884: 1, 3042: 1, 3024: 1, 2960: 1, 2929: 1, 3089: 1, 32823: 1, 32926: 1, 32928: 1 }, v = Hg;
          Hg = (st) => {
            st == 2912 ? ol != 1 && (Jt.A = null, ol = !0) : 12288 <= st && 12294 > st ? (st -= 12288, mp[st] != 1 && (Jt.A = null, mp[st] = !0)) : 16384 <= st && 16392 > st ? (st -= 16384, Wd[st] != 1 && (Jt.A = null, Wd[st] = !0)) : st == 2896 ? Hc != 1 && (Jt.A = null, Hc = !0) : st == 3008 ? Gd != 1 && (Jt.A = null, Gd = !0) : st != 3553 && st in L && v(st);
          };
          var O = Kg;
          Kg = (st) => {
            st == 2912 ? ol != 0 && (Jt.A = null, ol = !1) : 12288 <= st && 12294 > st ? (st -= 12288, mp[st] != 0 && (Jt.A = null, mp[st] = !1)) : 16384 <= st && 16392 > st ? (st -= 16384, Wd[st] != 0 && (Jt.A = null, Wd[st] = !1)) : st == 2896 ? Hc != 0 && (Jt.A = null, Hc = !1) : st == 3008 ? Gd != 0 && (Jt.A = null, Gd = !1) : st != 3553 && st in L && O(st);
          }, bR = (st) => st == 2912 ? ol ? 1 : 0 : 12288 <= st && 12294 > st ? mp[st - 12288] ? 1 : 0 : 16384 <= st && 16392 > st ? Wd[st - 16384] ? 1 : 0 : st == 2896 ? Hc ? 1 : 0 : st == 3008 ? Gd ? 1 : 0 : st in L ? Ht.isEnabled(st) : 0;
          var U = ox;
          ox = (st, bt) => {
            var Ct = null;
            switch (st) {
              case 3553:
              case 32888:
                Ct = Jt.TEXTURE0 + Jt.Ra;
                break;
              case 32884:
                Ct = Jt.ua;
                break;
              case 32885:
                Ct = Jt.Ea;
                break;
              case 32886:
                Ct = Jt.COLOR;
            }
            Ct !== null ? (bt = Number(bt), st = Jt.ta[Ct], (E(), Gt)[bt] = st === !0 ? 1 : 0) : U(st, bt);
          };
          var Y = _g;
          _g = (st, bt) => {
            switch (bt = Number(bt), st) {
              case 34018:
                st = Ht.MAX_TEXTURE_IMAGE_UNITS;
                break;
              case 35658:
                st = Ht.getParameter(Ht.MAX_VERTEX_UNIFORM_VECTORS), (E(), q)[bt / 4] = 4 * st;
                return;
              case 35657:
                st = Ht.getParameter(Ht.MAX_FRAGMENT_UNIFORM_VECTORS), (E(), q)[bt / 4] = 4 * st;
                return;
              case 35659:
                st = Ht.getParameter(Ht.MAX_VARYING_VECTORS), (E(), q)[bt / 4] = 4 * st;
                return;
              case 34929:
                st = Ht.MAX_COMBINED_TEXTURE_IMAGE_UNITS;
                break;
              case 32890:
                st = Jt.O[Jt.ua], (E(), q)[bt / 4] = st ? st.size : 0;
                return;
              case 32891:
                st = Jt.O[Jt.ua], (E(), q)[bt / 4] = st ? st.type : 0;
                return;
              case 32892:
                st = Jt.O[Jt.ua], (E(), q)[bt / 4] = st ? st.stride : 0;
                return;
              case 32897:
                st = Jt.O[Jt.COLOR], (E(), q)[bt / 4] = st ? st.size : 0;
                return;
              case 32898:
                st = Jt.O[Jt.COLOR], (E(), q)[bt / 4] = st ? st.type : 0;
                return;
              case 32899:
                st = Jt.O[Jt.COLOR], (E(), q)[bt / 4] = st ? st.stride : 0;
                return;
              case 32904:
                st = Jt.O[Jt.TEXTURE0 + Jt.Ra], (E(), q)[bt / 4] = st ? st.size : 0;
                return;
              case 32905:
                st = Jt.O[Jt.TEXTURE0 + Jt.Ra], (E(), q)[bt / 4] = st ? st.type : 0;
                return;
              case 32906:
                st = Jt.O[Jt.TEXTURE0 + Jt.Ra], (E(), q)[bt / 4] = st ? st.stride : 0;
                return;
              case 3378:
                (E(), q)[bt / 4] = J0;
                return;
              case 2976:
                (E(), q)[bt / 4] = Jt.Bb + 5888;
                return;
              case 3009:
                (E(), q)[bt / 4] = bx;
                return;
            }
            Y(st, bt);
          };
          var k = cx;
          cx = (st) => {
            if (Bg[st]) return Bg[st];
            switch (st) {
              case 7939:
                var bt = F0(Qw(Ht).join(" ") + " GL_EXT_texture_env_combine GL_ARB_texture_env_crossbar GL_ATI_texture_env_combine3 GL_NV_texture_env_combine4 GL_EXT_texture_env_dot3 GL_ARB_multitexture GL_ARB_vertex_buffer_object GL_EXT_framebuffer_object GL_ARB_vertex_program GL_ARB_fragment_program GL_ARB_shading_language_100 GL_ARB_shader_objects GL_ARB_vertex_shader GL_ARB_fragment_shader GL_ARB_texture_cube_map GL_EXT_draw_range_elements" + (hi.Gd ? " GL_ARB_texture_compression GL_EXT_texture_compression_s3tc" : "") + (hi.Cd ? " GL_EXT_texture_filter_anisotropic" : ""));
                return Bg[st] = BigInt(bt);
            }
            return k(st);
          };
          var _ = lx;
          lx = (st, bt) => {
            bt = Number(bt), st == 2982 ? (E(), et).set(Jt.matrix[0], bt / 4) : st == 2983 ? (E(), et).set(Jt.matrix[1], bt / 4) : st == 2984 ? (E(), et).set(Jt.matrix[2 + Jt.Ra], bt / 4) : st == 2918 ? (E(), et).set(px, bt / 4) : st == 2915 ? (E(), et)[bt / 4] = TR : st == 2916 ? (E(), et)[bt / 4] = hx : st == 2914 ? (E(), et)[bt / 4] = MR : st == 2917 ? (E(), et)[bt / 4] = mx : st == 2899 ? ((E(), et)[bt / 4] = A0[0], (E(), et)[(bt + 4) / 4] = A0[1], (E(), et)[(bt + 8) / 4] = A0[2], (E(), et)[(bt + 12) / 4] = A0[3]) : st == 3010 ? (E(), et)[bt / 4] = CR : _(st, bt);
          };
        }
      }
      g || re(), It.rf = (G, L, v, O, U, Y, k, _, st, bt) => {
        ww(G, L, v, O, U, _, st, bt).then(Y).catch(k);
      }, It.ng = ww, It.ja = Array(4096), It.B(mn, {}, "/"), It.mkdir("/tmp"), It.mkdir("/home"), It.mkdir("/home/web_user"), (function() {
        It.mkdir("/dev"), xw(It.ya(1, 3), { read: () => 0, write: (O, U, Y, k) => k, M: () => 0 }), o1("/dev/null", It.ya(1, 3)), wY(It.ya(5, 0), J4), wY(It.ya(6, 0), A4), o1("/dev/tty", It.ya(5, 0)), o1("/dev/tty1", It.ya(6, 0));
        var G = new Uint8Array(1024), L = 0, v = () => (L === 0 && (Mw(G), L = G.byteLength), G[--L]);
        It.ra("/dev", "random", v), It.ra("/dev", "urandom", v), It.mkdir("/dev/shm"), It.mkdir("/dev/shm/tmp");
      })(), (function() {
        It.mkdir("/proc");
        var G = It.mkdir("/proc/self");
        It.mkdir("/proc/self/fd"), It.B({ B() {
          var L = It.createNode(G, "fd", 16895, 73);
          return L.i = { M: mn.i.M }, L.j = { lookup(v, O) {
            v = +O;
            var U = Xs(v);
            return v = { parent: null, B: { Wc: "fake" }, j: { readlink: () => U.path }, id: v + 1 }, v.parent = v;
          }, readdir() {
            return Array.from(It.streams.entries()).filter(([, v]) => v).map(([v]) => v.toString());
          } }, L;
        } }, {}, "/proc/self/fd");
      })(), It.Sd = { MEMFS: mn }, (() => {
        let G = p1.prototype;
        Object.assign(G, { isAliasOf: function(v) {
          if (!(this instanceof p1 && v instanceof p1)) return !1;
          var O = this.h.D.m, U = this.h.u;
          v.h = v.h;
          var Y = v.h.D.m;
          for (v = v.h.u; O.K; ) U = O.eb(U), O = O.K;
          for (; Y.K; ) v = Y.eb(v), Y = Y.K;
          return O === Y && U === v;
        }, clone: function() {
          if (this.h.u || Rw(this), this.h.Na) return this.h.count.value += 1, this;
          var v = E0, O = Object, U = O.create, Y = Object.getPrototypeOf(this), k = this.h;
          return v = v(U.call(O, Y, { h: { value: { count: k.count, Ta: k.Ta, Na: k.Na, u: k.u, D: k.D, N: k.N, X: k.X } } })), v.h.count.value += 1, v.h.Ta = !1, v;
        }, delete() {
          if (this.h.u || Rw(this), this.h.Ta && !this.h.Na) throw new dn("Object already scheduled for deletion");
          c1(this);
          var v = this.h;
          --v.count.value, v.count.value === 0 && (v.N ? v.X.la(v.N) : v.D.m.la(v.u)), this.h.Na || (this.h.N = void 0, this.h.u = void 0);
        }, isDeleted: function() {
          return !this.h.u;
        }, deleteLater: function() {
          if (this.h.u || Rw(this), this.h.Ta && !this.h.Na) throw new dn("Object already scheduled for deletion");
          return this.h.Ta = !0, this;
        } });
        const L = Symbol.dispose;
        L && (G[L] = G.delete);
      })(), Object.assign(Pg.prototype, { Xd(G) {
        return this.dd && (G = this.dd(G)), G;
      }, xc(G) {
        var L;
        (L = this.la) == null || L.call(this, G);
      }, aa: Ug, v: function(G) {
        function L() {
          return this.mb ? b1(this.m.ha, { D: this.De, u: v, X: this, N: G }) : b1(this.m.ha, { D: this, u: G });
        }
        G = xt(G);
        var v = this.Xd(G);
        if (!v) return this.xc(G), null;
        var O = hH(this.m, v);
        if (O !== void 0)
          return O.h.count.value === 0 ? (O.h.u = v, O.h.N = G, O.clone()) : (O = O.clone(), this.xc(G), O);
        if (O = this.m.Vd(v), O = bv[O], !O) return L.call(this);
        O = this.lb ? O.Kd : O.pointerType;
        var U = fv(v, this.m, O.m);
        return U === null ? L.call(this) : this.mb ? b1(O.m.ha, { D: O, u: U, X: this, N: G }) : b1(O.m.ha, { D: O, u: U });
      } }), m.requestAnimationFrame = Hw, m.pauseMainLoop = vv, m.resumeMainLoop = Rv, m.preMainLoop && Kw.push(m.preMainLoop), m.postMainLoop && Yv.push(m.postMainLoop);
      var n7 = () => {
        if (hi) {
          var G = hi.md;
          for (hi.md = hi.Ue, hi.Ue = G, G = hi.cb, hi.cb = hi.Te, hi.Te = G, G = 0; 21 >= G; ++G) hi.cb[G] = 0;
        }
      };
      if (typeof Dv < "u" && Kw.push(n7), vR(), Jt.yd = Jt.jd(), Jt.jd = null, Jt.oa = Jt.kd(), Jt.kd = null, (function() {
        fx || vR();
        var G = rx;
        rx = (U) => {
          Jt.oa.ie(U), G(U);
        };
        var L = Hg;
        Hg = (U) => {
          Jt.oa.ke(U), L(U);
        };
        var v = Kg;
        Kg = (U) => {
          Jt.oa.je(U), v(U);
        };
        var O = _g;
        _g = (U, Y) => {
          switch (U) {
            case 35725:
              if (Ht.getParameter(Ht.CURRENT_PROGRAM) == Jt.Db) {
                (E(), q)[Y / 4] = 0;
                return;
              }
          }
          O(U, Y);
        };
      })(), g || (Zt = m.wasmMemory ? m.wasmMemory : new WebAssembly.Memory({ initial: BigInt((m.INITIAL_MEMORY || 134217728) / 65536), maximum: BigInt(131072), shared: !0, address: "i64" }), mt()), m.noExitRuntime && (cp = m.noExitRuntime), m.preloadPlugins && (i1 = m.preloadPlugins), m.print && (F = m.print), m.printErr && (P = m.printErr), m.wasmBinary && (j = m.wasmBinary), m.thisProgram && (T = m.thisProgram), m.preInit) for (typeof m.preInit == "function" && (m.preInit = [m.preInit]); 0 < m.preInit.length; ) m.preInit.shift()();
      m.wasmMemory = Zt, m.ERRNO_CODES = {
        EPERM: 63,
        ENOENT: 44,
        ESRCH: 71,
        EINTR: 27,
        EIO: 29,
        ENXIO: 60,
        E2BIG: 1,
        ENOEXEC: 45,
        EBADF: 8,
        ECHILD: 12,
        EAGAIN: 6,
        EWOULDBLOCK: 6,
        ENOMEM: 48,
        EACCES: 2,
        EFAULT: 21,
        ENOTBLK: 105,
        EBUSY: 10,
        EEXIST: 20,
        EXDEV: 75,
        ENODEV: 43,
        ENOTDIR: 54,
        EISDIR: 31,
        EINVAL: 28,
        ENFILE: 41,
        EMFILE: 33,
        ENOTTY: 59,
        ETXTBSY: 74,
        EFBIG: 22,
        ENOSPC: 51,
        ESPIPE: 70,
        EROFS: 69,
        EMLINK: 34,
        EPIPE: 64,
        EDOM: 18,
        ERANGE: 68,
        ENOMSG: 49,
        EIDRM: 24,
        ECHRNG: 106,
        EL2NSYNC: 156,
        EL3HLT: 107,
        EL3RST: 108,
        ELNRNG: 109,
        EUNATCH: 110,
        ENOCSI: 111,
        EL2HLT: 112,
        EDEADLK: 16,
        ENOLCK: 46,
        EBADE: 113,
        EBADR: 114,
        EXFULL: 115,
        ENOANO: 104,
        EBADRQC: 103,
        EBADSLT: 102,
        EDEADLOCK: 16,
        EBFONT: 101,
        ENOSTR: 100,
        ENODATA: 116,
        ETIME: 117,
        ENOSR: 118,
        ENONET: 119,
        ENOPKG: 120,
        EREMOTE: 121,
        ENOLINK: 47,
        EADV: 122,
        ESRMNT: 123,
        ECOMM: 124,
        EPROTO: 65,
        EMULTIHOP: 36,
        EDOTDOT: 125,
        EBADMSG: 9,
        ENOTUNIQ: 126,
        EBADFD: 127,
        EREMCHG: 128,
        ELIBACC: 129,
        ELIBBAD: 130,
        ELIBSCN: 131,
        ELIBMAX: 132,
        ELIBEXEC: 133,
        ENOSYS: 52,
        ENOTEMPTY: 55,
        ENAMETOOLONG: 37,
        ELOOP: 32,
        EOPNOTSUPP: 138,
        EPFNOSUPPORT: 139,
        ECONNRESET: 15,
        ENOBUFS: 42,
        EAFNOSUPPORT: 5,
        EPROTOTYPE: 67,
        ENOTSOCK: 57,
        ENOPROTOOPT: 50,
        ESHUTDOWN: 140,
        ECONNREFUSED: 14,
        EADDRINUSE: 3,
        ECONNABORTED: 13,
        ENETUNREACH: 40,
        ENETDOWN: 38,
        ETIMEDOUT: 73,
        EHOSTDOWN: 142,
        EHOSTUNREACH: 23,
        EINPROGRESS: 26,
        EALREADY: 7,
        EDESTADDRREQ: 17,
        EMSGSIZE: 35,
        EPROTONOSUPPORT: 66,
        ESOCKTNOSUPPORT: 137,
        EADDRNOTAVAIL: 4,
        ENETRESET: 39,
        EISCONN: 30,
        ENOTCONN: 53,
        ETOOMANYREFS: 141,
        EUSERS: 136,
        EDQUOT: 19,
        ESTALE: 72,
        ENOTSUP: 138,
        ENOMEDIUM: 148,
        EILSEQ: 25,
        EOVERFLOW: 61,
        ECANCELED: 11,
        ENOTRECOVERABLE: 56,
        EOWNERDEAD: 62,
        ESTRPIPE: 135
      }, m.addRunDependency = Bt, m.removeRunDependency = zt, m.PATH = di, m.FS_preloadFile = ww, m.FS_unlink = (...G) => It.unlink(...G), m.FS_createPath = (...G) => H4(...G), m.FS_createDevice = (...G) => It.ra(...G), m.FS = It, m.FS_createDataFile = (...G) => SY(...G), m.FS_createLazyFile = (...G) => Q4(...G);
      var i7 = [Ge, He, TY, vY, RY, DY, OY, zY, EY, kY, FY, jY, UY, PY, JY, AY, BY, KY, HY, _Y, QY, $Y, qY, tv, ev, nv, iv, sv, rv, av, ov, lv, cv, dv, Lv, Vv, zv, kv, Bv, Hv, _v, Qv, $v, qv, tR, eR, nR, iR, sR, rR, lR, cR, uR, dR, hR, pR, sx, mR], RR = {
        21839952: (G, L, v, O, U) => {
          if (typeof m > "u" || !m.zd) return 1;
          if (G = Sn(G >>> 0), G.startsWith("./") && (G = G.substring(2)), G = m.zd.get(G), !G) return 2;
          if (L >>>= 0, v >>>= 0, O >>>= 0, L + v > G.byteLength) return 3;
          try {
            const Y = G.subarray(L, L + v);
            switch (U) {
              case 0:
                (E(), Tt).set(Y, O);
                break;
              case 1:
                m.Vf(O, Y);
                break;
              default:
                return 4;
            }
            return 0;
          } catch {
            return 4;
          }
        },
        21840635: () => typeof wasmOffsetConverter < "u"
      };
      function s7() {
        return typeof wasmOffsetConverter < "u";
      }
      var DR, OR, $g, As, ll, zR, bp, gx, ER, kR, FR, yx, jR, UR, PR, Zx, JR, AR, B0;
      function r7() {
        var G = Jl;
        G = Object.assign({}, G);
        var L = (Y) => (k) => Number(Y(BigInt(k))), v = (Y) => () => Number(Y()), O = (Y) => (k) => Y(BigInt(k)), U = (Y) => (k, _) => Number(Y(BigInt(k), BigInt(_)));
        return G.__getTypeName = L(G.__getTypeName), G.pthread_self = v(G.pthread_self), G.malloc = L(G.malloc), G.free = O(G.free), G.realloc = U(G.realloc), G.calloc = U(G.calloc), G.emscripten_builtin_free = /* @__PURE__ */ ((Y) => (k) => Y(BigInt(k)))(G.emscripten_builtin_free), G.emscripten_builtin_memalign = U(G.emscripten_builtin_memalign), G._emscripten_run_callback_on_thread = /* @__PURE__ */ ((Y) => (k, _, st, bt, Ct) => Y(BigInt(k), BigInt(_), st, BigInt(bt), BigInt(Ct)))(G._emscripten_run_callback_on_thread), G.emscripten_builtin_malloc = L(G.emscripten_builtin_malloc), G._emscripten_thread_init = /* @__PURE__ */ ((Y) => (k, _, st, bt, Ct, vt) => Y(BigInt(k), _, st, bt, Ct, vt))(G._emscripten_thread_init), G._emscripten_run_js_on_main_thread = /* @__PURE__ */ ((Y) => (k, _, st, bt, Ct) => Y(k, BigInt(_), st, BigInt(bt), Ct))(G._emscripten_run_js_on_main_thread), G._emscripten_thread_free_data = O(G._emscripten_thread_free_data), G._emscripten_thread_exit = O(G._emscripten_thread_exit), G.emscripten_builtin_calloc = U(G.emscripten_builtin_calloc), G.emscripten_stack_set_limits = /* @__PURE__ */ ((Y) => (k, _) => Y(BigInt(k), BigInt(_)))(G.emscripten_stack_set_limits), G._emscripten_stack_restore = O(G._emscripten_stack_restore), G._emscripten_stack_alloc = L(G._emscripten_stack_alloc), G.emscripten_stack_get_current = v(G.emscripten_stack_get_current), G;
      }
      function C1() {
        async function G() {
          var L;
          if (m.calledRun = !0, !B && (wt(), ct == null || ct(m), (L = m.onRuntimeInitialized) == null || L.call(m), !g)) {
            if (m.postRun) for (typeof m.postRun == "function" && (m.postRun = [m.postRun]); m.postRun.length; ) {
              var v = m.postRun.shift();
              fY.push(v);
            }
            Se(fY);
          }
        }
        if (0 < Rt) $t = C1;
        else if (g) ct == null || ct(m), wt();
        else {
          if (m.preRun) for (typeof m.preRun == "function" && (m.preRun = [m.preRun]); m.preRun.length; ) Vt.push(m.preRun.shift());
          Se(Vt), 0 < Rt ? $t = C1 : m.setStatus ? (m.setStatus("Running..."), setTimeout(() => {
            setTimeout(() => m.setStatus(""), 1), G();
          }, 1)) : G();
        }
      }
      var Jl;
      return g || (Jl = await yt(), C1()), p = lt ? m : new Promise((G, L) => {
        ct = G, at = L;
      }), p;
    };
  })();
  i.exports = r, i.exports.default = r;
  var a = (n = (e = globalThis.self) == null ? void 0 : e.name) == null ? void 0 : n.startsWith("em-pthread"), o = typeof process == "object" && ((s = process.versions) == null ? void 0 : s.node) && process.type != "renderer";
  o && (a = ty.workerData === "em-pthread"), a && r();
})(h3);
var i8 = h3.exports;
const s8 = /* @__PURE__ */ q7(i8);
let ti = 0;
class p3 {
  constructor(t) {
    hr(this, "m"), this.m = t;
  }
  flushPendingDeletes() {
    return this.m.flushPendingDeletes();
  }
  get xReslicer() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.xReslicer());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      ReinitializeInputImage() {
        return J(this, t).ReinitializeInputImage();
      }
      updateFilterModeThickness(r, a, o) {
        return J(this, t).updateFilterModeThickness(r, a, o);
      }
      updateMatrix(r) {
        return J(this, t).updateMatrix(r);
      }
      GetSliceView() {
        return J(this, t).GetSliceView();
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get TCPRReslicer() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.TCPRReslicer());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      ReinitializeInputImage() {
        return J(this, t).ReinitializeInputImage();
      }
      SetInputPoints(r, a, o) {
        return J(this, t).SetInputPoints(r, a, o);
      }
      GetOutputImage() {
        return J(this, t).GetOutputImage();
      }
      GetSplinePoints() {
        return J(this, t).GetSplinePoints();
      }
      GetSplineNormals() {
        return J(this, t).GetSplineNormals();
      }
      GetSplineTangents() {
        return J(this, t).GetSplineTangents();
      }
      GetSplineBinormals() {
        return J(this, t).GetSplineBinormals();
      }
      GetOutputImageSpacing() {
        return J(this, t).GetOutputImageSpacing();
      }
      GetOutputImageDim() {
        return J(this, t).GetOutputImageDim();
      }
      GetmmCPR() {
        return J(this, t).GetmmCPR();
      }
      Getmmy() {
        return J(this, t).Getmmy();
      }
      GetSplineLength() {
        return J(this, t).GetSplineLength();
      }
      SetInput() {
        return J(this, t).SetInput();
      }
      InitSource(r) {
        return J(this, t).InitSource(r);
      }
      InitSpline(r) {
        return J(this, t).InitSpline(r);
      }
      GetCPRHeight() {
        return J(this, t).GetCPRHeight();
      }
      SetCPRHeight(r) {
        return J(this, t).SetCPRHeight(r);
      }
      SetCPRThickness(r) {
        return J(this, t).SetCPRThickness(r);
      }
      SetCPRFilterMode(r) {
        return J(this, t).SetCPRFilterMode(r);
      }
      PerformCPR() {
        return J(this, t).PerformCPR();
      }
      CalculateSpline() {
        return J(this, t).CalculateSpline();
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get xCrossSection() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.xCrossSection());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      get CPRSpacingX() {
        return J(this, t).CPRSpacingX;
      }
      set CPRSpacingX(r) {
        J(this, t).CPRSpacingX = r;
      }
      get CPRHeight() {
        return J(this, t).CPRHeight;
      }
      set CPRHeight(r) {
        J(this, t).CPRHeight = r;
      }
      update(r, a, o) {
        return J(this, t).update(r, a, o);
      }
      updateCPR(r, a, o, l, c) {
        return J(this, t).updateCPR(r, a, o, l, c);
      }
      initializeMeshById(r, a) {
        return J(this, t).initializeMeshById(r, a);
      }
      getOutputPoints() {
        return J(this, t).getOutputPoints();
      }
      getOutputPolys() {
        return J(this, t).getOutputPolys();
      }
      getOutputLines() {
        return J(this, t).getOutputLines();
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get xSleeveBuilder() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.xSleeveBuilder());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      get pointsView() {
        return J(this, t).pointsView;
      }
      set pointsView(r) {
        J(this, t).pointsView = r;
      }
      get polysView() {
        return J(this, t).polysView;
      }
      set polysView(r) {
        J(this, t).polysView = r;
      }
      SetRadius(r, a) {
        return J(this, t).SetRadius(r, a);
      }
      GetRadius1() {
        return J(this, t).GetRadius1();
      }
      GetRadius2() {
        return J(this, t).GetRadius2();
      }
      SetHeight(r) {
        return J(this, t).SetHeight(r);
      }
      GetHeight() {
        return J(this, t).GetHeight();
      }
      CreateVTKObjects(r, a, o) {
        return J(this, t).CreateVTKObjects(r, a, o);
      }
      DeleteVTKObjects() {
        return J(this, t).DeleteVTKObjects();
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get xMatchingTool() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.xMatchingTool());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      SetCount(r) {
        return J(this, t).SetCount(r);
      }
      SetDICOMPointsArray(r) {
        return J(this, t).SetDICOMPointsArray(r);
      }
      SetSTLPointsArray(r) {
        return J(this, t).SetSTLPointsArray(r);
      }
      SetWidthLevel(r, a) {
        return J(this, t).SetWidthLevel(r, a);
      }
      SetSurrounding(r) {
        return J(this, t).SetSurrounding(r);
      }
      GetDelta() {
        return J(this, t).GetDelta();
      }
      SetMatchingActorUserMatrix(r) {
        return J(this, t).SetMatchingActorUserMatrix(r);
      }
      SetOriginalActorUserMatrix(r) {
        return J(this, t).SetOriginalActorUserMatrix(r);
      }
      SetTargetActorUserMatrix(r) {
        return J(this, t).SetTargetActorUserMatrix(r);
      }
      SetResultActorUserMatrix(r) {
        return J(this, t).SetResultActorUserMatrix(r);
      }
      GetTransformMatrix() {
        return J(this, t).GetTransformMatrix();
      }
      GetBestFitTransformMatrix() {
        return J(this, t).GetBestFitTransformMatrix();
      }
      GetAutomaticTransformMatrix() {
        return J(this, t).GetAutomaticTransformMatrix();
      }
      GetSTLonSTLTransformMatrix() {
        return J(this, t).GetSTLonSTLTransformMatrix();
      }
      GetSTLonSTLByPointsTransformMatrix() {
        return J(this, t).GetSTLonSTLByPointsTransformMatrix();
      }
      prepareSTLonSTL(r, a) {
        return J(this, t).prepareSTLonSTL(r, a);
      }
      RegisterSTLonSTLAutomatic() {
        return J(this, t).RegisterSTLonSTLAutomatic();
      }
      RegisterSTLonSTLByPoints() {
        return J(this, t).RegisterSTLonSTLByPoints();
      }
      prepareSTL(r) {
        return J(this, t).prepareSTL(r);
      }
      updateSTL() {
        return J(this, t).updateSTL();
      }
      updateMatrix() {
        return J(this, t).updateMatrix();
      }
      RegisterSTL() {
        return J(this, t).RegisterSTL();
      }
      RegisterSTLBestFit() {
        return J(this, t).RegisterSTLBestFit();
      }
      RegisterSTLAutomatic() {
        return J(this, t).RegisterSTLAutomatic();
      }
      deleteData() {
        return J(this, t).deleteData();
      }
      async RegisterSTLonSTLAutomaticAsync() {
        return new Promise((r, a) => {
          const o = (l) => {
            r(l);
          };
          J(this, t).RegisterSTLonSTLAutomaticAsyncWrapper(o);
        });
      }
      async RegisterSTLonSTLByPointsAsync() {
        return new Promise((r, a) => {
          const o = (l) => {
            r(l);
          };
          J(this, t).RegisterSTLonSTLByPointsAsyncWrapper(o);
        });
      }
      async updateSTLAsync() {
        return new Promise((r, a) => {
          const o = (l) => {
            r(l);
          };
          J(this, t).updateSTLAsyncWrapper(o);
        });
      }
      async RegisterSTLBestFitAsync() {
        return new Promise((r, a) => {
          const o = (l) => {
            r(l);
          };
          J(this, t).RegisterSTLBestFitAsyncWrapper(o);
        });
      }
      async RegisterSTLAutomaticAsync() {
        return new Promise((r, a) => {
          const o = (l) => {
            r(l);
          };
          J(this, t).RegisterSTLAutomaticAsyncWrapper(o);
        });
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get xWasmStlObject() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor(r, a, o, l) {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.xWasmStlObject(r, a, o, l));
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      get hasCollisionZone() {
        return J(this, t).hasCollisionZone;
      }
      set hasCollisionZone(r) {
        J(this, t).hasCollisionZone = r;
      }
      get collisionZoneFlag() {
        return J(this, t).collisionZoneFlag;
      }
      set collisionZoneFlag(r) {
        J(this, t).collisionZoneFlag = r;
      }
      get isNerve() {
        return J(this, t).isNerve;
      }
      set isNerve(r) {
        J(this, t).isNerve = r;
      }
      get VolumeCalculationFlag() {
        return J(this, t).VolumeCalculationFlag;
      }
      set VolumeCalculationFlag(r) {
        J(this, t).VolumeCalculationFlag = r;
      }
      Initialize() {
        return J(this, t).Initialize();
      }
      GetType() {
        return J(this, t).GetType();
      }
      GetTypeInt() {
        return J(this, t).GetTypeInt();
      }
      GetId() {
        return J(this, t).GetId();
      }
      GetUserMatrix() {
        return J(this, t).GetUserMatrix();
      }
      SetUserMatrix(r) {
        return J(this, t).SetUserMatrix(r);
      }
      GetmIntersection() {
        return J(this, t).GetmIntersection();
      }
      ReadMeshFromFile(r, a, o, l) {
        return J(this, t).ReadMeshFromFile(r, a, o, l);
      }
      ReadStlFromFile(r, a, o) {
        return J(this, t).ReadStlFromFile(r, a, o);
      }
      ReadPolyDataFromFile(r, a, o, l) {
        return J(this, t).ReadPolyDataFromFile(r, a, o, l);
      }
      MoveObjectToWasm(r, a, o, l, c, u, d, h) {
        return J(this, t).MoveObjectToWasm(r, a, o, l, c, u, d, h);
      }
      CopyUint8ArrayToWasm(r, a, o, l, c, u) {
        return J(this, t).CopyUint8ArrayToWasm(r, a, o, l, c, u);
      }
      CopyUint16ArrayToWasm(r, a, o, l, c, u) {
        return J(this, t).CopyUint16ArrayToWasm(r, a, o, l, c, u);
      }
      CopyFloat32ArrayToWasm(r, a, o, l, c, u) {
        return J(this, t).CopyFloat32ArrayToWasm(r, a, o, l, c, u);
      }
      PrepareForVectorsCopyToWasm(r, a, o, l, c, u, d, h, p, m, b, y) {
        return J(this, t).PrepareForVectorsCopyToWasm(r, a, o, l, c, u, d, h, p, m, b, y);
      }
      AssignPointDataArrays() {
        return J(this, t).AssignPointDataArrays();
      }
      AssignCellDataArrays() {
        return J(this, t).AssignCellDataArrays();
      }
      PrepareSpanForArrayWithName(r, a) {
        return J(this, t).PrepareSpanForArrayWithName(r, a);
      }
      LoadTextureImage(r) {
        return J(this, t).LoadTextureImage(r);
      }
      MoveTextureImageToWasm(r, a, o, l) {
        return J(this, t).MoveTextureImageToWasm(r, a, o, l);
      }
      HasTextureImageData() {
        return J(this, t).HasTextureImageData();
      }
      HasValidTexture() {
        return J(this, t).HasValidTexture();
      }
      GetTextureImageDataView() {
        return J(this, t).GetTextureImageDataView();
      }
      LoadFromCADVolumeLabel(r) {
        return J(this, t).LoadFromCADVolumeLabel(r);
      }
      SetCADToothInfoOrderNumber(r) {
        return J(this, t).SetCADToothInfoOrderNumber(r);
      }
      GetCADToothInfoOrderNumber() {
        return J(this, t).GetCADToothInfoOrderNumber();
      }
      SetCADToothInfoType(r) {
        return J(this, t).SetCADToothInfoType(r);
      }
      GetCADToothInfoType() {
        return J(this, t).GetCADToothInfoType();
      }
      SetCADCorrespondenceId(r) {
        return J(this, t).SetCADCorrespondenceId(r);
      }
      GetCADCorrespondenceId() {
        return J(this, t).GetCADCorrespondenceId();
      }
      SetCADReconstructionTypeId(r) {
        return J(this, t).SetCADReconstructionTypeId(r);
      }
      GetCADReconstructionTypeId() {
        return J(this, t).GetCADReconstructionTypeId();
      }
      SetGenerateTexts(r) {
        return J(this, t).SetGenerateTexts(r);
      }
      GetGenerateTexts() {
        return J(this, t).GetGenerateTexts();
      }
      SetSleeveIndexes(r) {
        return J(this, t).SetSleeveIndexes(r);
      }
      GetSleeveIndexes() {
        return J(this, t).GetSleeveIndexes();
      }
      InitTCoords() {
        return J(this, t).InitTCoords();
      }
      getOutputFloat32Array() {
        return J(this, t).getOutputFloat32Array();
      }
      getOutputUint8Array() {
        return J(this, t).getOutputUint8Array();
      }
      getOutputUint16Array() {
        return J(this, t).getOutputUint16Array();
      }
      GetPolyDataView() {
        return J(this, t).GetPolyDataView();
      }
      GetPolyDataViewCZ() {
        return J(this, t).GetPolyDataViewCZ();
      }
      UpdateMatrixFromArray() {
        return J(this, t).UpdateMatrixFromArray();
      }
      CollisionDetection(r) {
        return J(this, t).CollisionDetection(r);
      }
      ConstructImplantCollisionZone(r, a, o) {
        return J(this, t).ConstructImplantCollisionZone(r, a, o);
      }
      UpdateImplantCollisionZone(r, a, o) {
        return J(this, t).UpdateImplantCollisionZone(r, a, o);
      }
      CalculateObjectVolume() {
        return J(this, t).CalculateObjectVolume();
      }
      GetPoints() {
        return J(this, t).GetPoints();
      }
      GetPolys() {
        return J(this, t).GetPolys();
      }
      GetNumberOfDataArrays(r) {
        return J(this, t).GetNumberOfDataArrays(r);
      }
      GetDataArrayByIdx(r, a) {
        return J(this, t).GetDataArrayByIdx(r, a);
      }
      SetToothSelected(r) {
        return J(this, t).SetToothSelected(r);
      }
      GetToothSelected() {
        return J(this, t).GetToothSelected();
      }
      SetMeshModified(r) {
        return J(this, t).SetMeshModified(r);
      }
      GetMeshModified() {
        return J(this, t).GetMeshModified();
      }
      InitializeTexture(r, a) {
        return J(this, t).InitializeTexture(r, a);
      }
      InitializeFreeFormTool(r) {
        return J(this, t).InitializeFreeFormTool(r);
      }
      AllocateFreeFormTool() {
        return J(this, t).AllocateFreeFormTool();
      }
      SetMaxEdgeLength(r) {
        return J(this, t).SetMaxEdgeLength(r);
      }
      CursorOnly(r, a, o) {
        return J(this, t).CursorOnly(r, a, o);
      }
      Cursor() {
        return J(this, t).Cursor();
      }
      SimpleCursor(r, a) {
        return J(this, t).SimpleCursor(r, a);
      }
      GetFreeformCursorPoints() {
        return J(this, t).GetFreeformCursorPoints();
      }
      GetFreeformCursorLines() {
        return J(this, t).GetFreeformCursorLines();
      }
      LocalLaplacianSmooth(r, a, o, l, c, u, d, h, p, m) {
        return J(this, t).LocalLaplacianSmooth(r, a, o, l, c, u, d, h, p, m);
      }
      LocalAddRemoveMaterial(r, a, o, l, c, u) {
        return J(this, t).LocalAddRemoveMaterial(r, a, o, l, c, u);
      }
      LocalHarmonicDeformation(r, a, o) {
        return J(this, t).LocalHarmonicDeformation(r, a, o);
      }
      LocalScrape(r, a, o) {
        return J(this, t).LocalScrape(r, a, o);
      }
      UpdateFreeFormToolMode() {
        return J(this, t).UpdateFreeFormToolMode();
      }
      FindClosestPointIndex(r, a, o) {
        return J(this, t).FindClosestPointIndex(r, a, o);
      }
      FindClosestPointIndexRay(r, a) {
        return J(this, t).FindClosestPointIndexRay(r, a);
      }
      CleanMesh() {
        return J(this, t).CleanMesh();
      }
      ComputeNormals() {
        return J(this, t).ComputeNormals();
      }
      UpdatePointLocator() {
        return J(this, t).UpdatePointLocator();
      }
      UpdateFaceLocator() {
        return J(this, t).UpdateFaceLocator();
      }
      UpdatePointFacesConnectivity() {
        return J(this, t).UpdatePointFacesConnectivity();
      }
      SetMeshSplitting(r) {
        return J(this, t).SetMeshSplitting(r);
      }
      GetMeshSplitting() {
        return J(this, t).GetMeshSplitting();
      }
      SetGuideTop(r) {
        return J(this, t).SetGuideTop(r);
      }
      SetGuideDirection(r) {
        return J(this, t).SetGuideDirection(r);
      }
      SetGuideBiDirection(r) {
        return J(this, t).SetGuideBiDirection(r);
      }
      SetGuideDiameter(r) {
        return J(this, t).SetGuideDiameter(r);
      }
      SetGuideHeight(r) {
        return J(this, t).SetGuideHeight(r);
      }
      SetGuidePin(r) {
        return J(this, t).SetGuidePin(r);
      }
      UpdateMeshBySrcId(r) {
        return J(this, t).UpdateMeshBySrcId(r);
      }
      CalculateMinimalSleeveDistance(r, a, o, l, c, u, d) {
        return J(this, t).CalculateMinimalSleeveDistance(r, a, o, l, c, u, d);
      }
      SetName(r) {
        return J(this, t).SetName(r);
      }
      GetNameString() {
        return J(this, t).GetNameString();
      }
      GetDisplayTextString() {
        return J(this, t).GetDisplayTextString();
      }
      GetColor() {
        return J(this, t).GetColor();
      }
      SetColor(r, a, o, l) {
        return J(this, t).SetColor(r, a, o, l);
      }
      SetDisplayText(r) {
        return J(this, t).SetDisplayText(r);
      }
      SetVisibility(r) {
        return J(this, t).SetVisibility(r);
      }
      GetVisibility() {
        return J(this, t).GetVisibility();
      }
      SetGlossy(r) {
        return J(this, t).SetGlossy(r);
      }
      GetGlossy() {
        return J(this, t).GetGlossy();
      }
      GetViewMode() {
        return J(this, t).GetViewMode();
      }
      SetOpacity(r) {
        return J(this, t).SetOpacity(r);
      }
      GetOpacity() {
        return J(this, t).GetOpacity();
      }
      SetImplantStandardInfoString(r) {
        return J(this, t).SetImplantStandardInfoString(r);
      }
      SetAbutmentAngle(r) {
        return J(this, t).SetAbutmentAngle(r);
      }
      SetSleeveManufacturerName(r) {
        return J(this, t).SetSleeveManufacturerName(r);
      }
      SetSleeveModelName(r) {
        return J(this, t).SetSleeveModelName(r);
      }
      SetSleeveCustomSupport(r) {
        return J(this, t).SetSleeveCustomSupport(r);
      }
      SetSleeveConnectionSides(r) {
        return J(this, t).SetSleeveConnectionSides(r);
      }
      SetAbutmentById(r) {
        return J(this, t).SetAbutmentById(r);
      }
      SetScanAbutmentById(r) {
        return J(this, t).SetScanAbutmentById(r);
      }
      SetSecondaryAbutmentById(r) {
        return J(this, t).SetSecondaryAbutmentById(r);
      }
      SetSecondaryScanAbutmentById(r) {
        return J(this, t).SetSecondaryScanAbutmentById(r);
      }
      SetSleeveById(r) {
        return J(this, t).SetSleeveById(r);
      }
      SetModelObjById(r, a) {
        return J(this, t).SetModelObjById(r, a);
      }
      ClearModelObj(r) {
        return J(this, t).ClearModelObj(r);
      }
      SetIsParametricObject(r) {
        return J(this, t).SetIsParametricObject(r);
      }
      SetModelBaseRadius(r) {
        return J(this, t).SetModelBaseRadius(r);
      }
      SetModelSupportRadius(r) {
        return J(this, t).SetModelSupportRadius(r);
      }
      SetModelBaseLength(r) {
        return J(this, t).SetModelBaseLength(r);
      }
      SetModelSupportLength(r) {
        return J(this, t).SetModelSupportLength(r);
      }
      ExportToSTLFile(r, a, o) {
        return J(this, t).ExportToSTLFile(r, a, o);
      }
      ExportToPLYFile(r, a, o) {
        return J(this, t).ExportToPLYFile(r, a, o);
      }
      ExportToOBJFile(r, a, o) {
        return J(this, t).ExportToOBJFile(r, a, o);
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get WasmStlUndoObject() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor(r) {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.WasmStlUndoObject(r));
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      OnRedo() {
        return J(this, t).OnRedo();
      }
      OnUndo() {
        return J(this, t).OnUndo();
      }
      GetMemory() {
        return J(this, t).GetMemory();
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get xWasmVolumeObject() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor(r, a, o, l) {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.xWasmVolumeObject(r, a, o, l));
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      get mpSettingsVolumeBrushAddRemoveStrength() {
        return J(this, t).mpSettingsVolumeBrushAddRemoveStrength;
      }
      set mpSettingsVolumeBrushAddRemoveStrength(r) {
        J(this, t).mpSettingsVolumeBrushAddRemoveStrength = r;
      }
      get VolumeCalculationFlag() {
        return J(this, t).VolumeCalculationFlag;
      }
      set VolumeCalculationFlag(r) {
        J(this, t).VolumeCalculationFlag = r;
      }
      SetImageDataFromFile(r) {
        return J(this, t).SetImageDataFromFile(r);
      }
      UpdateVolume(r) {
        return J(this, t).UpdateVolume(r);
      }
      UpdateMatrixFromArray() {
        return J(this, t).UpdateMatrixFromArray();
      }
      ReconstructVolume() {
        return J(this, t).ReconstructVolume();
      }
      Reconstruct() {
        return J(this, t).Reconstruct();
      }
      Get3DCursorPolyData(r, a) {
        return J(this, t).Get3DCursorPolyData(r, a);
      }
      GetCursorPolyDataView() {
        return J(this, t).GetCursorPolyDataView();
      }
      GetPolyDataView() {
        return J(this, t).GetPolyDataView();
      }
      GetImageDataView() {
        return J(this, t).GetImageDataView();
      }
      GetUserMatrix() {
        return J(this, t).GetUserMatrix();
      }
      SetUserMatrix(r) {
        return J(this, t).SetUserMatrix(r);
      }
      OnUndo(r, a) {
        return J(this, t).OnUndo(r, a);
      }
      LocalExtent(r, a, o) {
        return J(this, t).LocalExtent(r, a, o);
      }
      LocalSmooth(r, a, o) {
        return J(this, t).LocalSmooth(r, a, o);
      }
      LocalAdd(r, a, o) {
        return J(this, t).LocalAdd(r, a, o);
      }
      LocalRemove(r, a, o) {
        return J(this, t).LocalRemove(r, a, o);
      }
      LocalFill(r, a, o) {
        return J(this, t).LocalFill(r, a, o);
      }
      LocalPaint(r, a, o) {
        return J(this, t).LocalPaint(r, a, o);
      }
      LocalErase(r, a, o) {
        return J(this, t).LocalErase(r, a, o);
      }
      LocalScrape(r, a, o, l, c) {
        return J(this, t).LocalScrape(r, a, o, l, c);
      }
      LocalPaint2d(r, a, o, l) {
        return J(this, t).LocalPaint2d(r, a, o, l);
      }
      LocalErase2d(r, a, o, l) {
        return J(this, t).LocalErase2d(r, a, o, l);
      }
      LocalThreshold2D(r, a, o, l, c) {
        return J(this, t).LocalThreshold2D(r, a, o, l, c);
      }
      GetEnableVolumeMask() {
        return J(this, t).GetEnableVolumeMask();
      }
      SetEnableVolumeMask(r) {
        return J(this, t).SetEnableVolumeMask(r);
      }
      ApplyVolumeMask() {
        return J(this, t).ApplyVolumeMask();
      }
      InitializeBrushPreview() {
        return J(this, t).InitializeBrushPreview();
      }
      FillBrushPreview(r, a, o, l, c) {
        return J(this, t).FillBrushPreview(r, a, o, l, c);
      }
      GetPreviewSlice() {
        return J(this, t).GetPreviewSlice();
      }
      GetNumberOfDataArrays(r) {
        return J(this, t).GetNumberOfDataArrays(r);
      }
      GetDataArrayByIdx(r, a) {
        return J(this, t).GetDataArrayByIdx(r, a);
      }
      GetType() {
        return J(this, t).GetType();
      }
      GetTypeInt() {
        return J(this, t).GetTypeInt();
      }
      GetMaxilla() {
        return J(this, t).GetMaxilla();
      }
      SetMaxilla(r) {
        return J(this, t).SetMaxilla(r);
      }
      ReconstructLastExtent() {
        return J(this, t).ReconstructLastExtent();
      }
      CalculateObjectVolume() {
        return J(this, t).CalculateObjectVolume();
      }
      SetObtainedByThreshold(r) {
        return J(this, t).SetObtainedByThreshold(r);
      }
      GetObtainedByThreshold() {
        return J(this, t).GetObtainedByThreshold();
      }
      UpdateThickness(r, a) {
        return J(this, t).UpdateThickness(r, a);
      }
      CreateSelectedMesh() {
        return J(this, t).CreateSelectedMesh();
      }
      ReleaseSelectedMesh() {
        return J(this, t).ReleaseSelectedMesh();
      }
      SetName(r) {
        return J(this, t).SetName(r);
      }
      SetColor(r, a, o, l) {
        return J(this, t).SetColor(r, a, o, l);
      }
      SetDisplayText(r) {
        return J(this, t).SetDisplayText(r);
      }
      SetVisibility(r) {
        return J(this, t).SetVisibility(r);
      }
      SetGlossy(r) {
        return J(this, t).SetGlossy(r);
      }
      GetGlossy() {
        return J(this, t).GetGlossy();
      }
      GetNameString() {
        return J(this, t).GetNameString();
      }
      GetDisplayTextString() {
        return J(this, t).GetDisplayTextString();
      }
      GetColor() {
        return J(this, t).GetColor();
      }
      GetOpacity() {
        return J(this, t).GetOpacity();
      }
      GetVisibility() {
        return J(this, t).GetVisibility();
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get WasmVolumeUndoObject() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor(r, a) {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.WasmVolumeUndoObject(r, a));
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      OnRedo() {
        return J(this, t).OnRedo();
      }
      OnUndo() {
        return J(this, t).OnUndo();
      }
      GetMemory() {
        return J(this, t).GetMemory();
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get xWasmDocumentJS() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.xWasmDocumentJS());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      SetImageData(r, a, o, l) {
        return J(this, t).SetImageData(r, a, o, l);
      }
      GetImageDataView() {
        return J(this, t).GetImageDataView();
      }
      GetNumberOfDebugFiles() {
        return J(this, t).GetNumberOfDebugFiles();
      }
      GetDebugFileNameAtIndex(r) {
        return J(this, t).GetDebugFileNameAtIndex(r);
      }
      ClearDebugFiles() {
        return J(this, t).ClearDebugFiles();
      }
      InitializeQT() {
        return J(this, t).InitializeQT();
      }
      InitializeTranslator(r) {
        return J(this, t).InitializeTranslator(r);
      }
      SetActive(r) {
        return J(this, t).SetActive(r);
      }
      WaitForParallelExecutor() {
        return J(this, t).WaitForParallelExecutor();
      }
      InitializeMainForm(r, a, o, l, c, u, d) {
        return J(this, t).InitializeMainForm(r, a, o, l, c, u, d);
      }
      GetVersionType() {
        return J(this, t).GetVersionType();
      }
      GetLicenseType() {
        return J(this, t).GetLicenseType();
      }
      ExtractZip(r, a) {
        return J(this, t).ExtractZip(r, a);
      }
      ValidateTeethLibraryMetadata(r, a) {
        return J(this, t).ValidateTeethLibraryMetadata(r, a);
      }
      LoadTeethLibrary(r) {
        return J(this, t).LoadTeethLibrary(r);
      }
      HasTeethLibrary(r) {
        return J(this, t).HasTeethLibrary(r);
      }
      HasCADTeethLibrary(r, a) {
        return J(this, t).HasCADTeethLibrary(r, a);
      }
      RemoveCADTeethLibrary(r, a) {
        return J(this, t).RemoveCADTeethLibrary(r, a);
      }
      WaitForReadySignal() {
        return J(this, t).WaitForReadySignal();
      }
      TestFunction() {
        return J(this, t).TestFunction();
      }
      async InitializeQTAsync() {
        return new Promise((r, a) => {
          const o = (l) => {
            r(l);
          };
          J(this, t).InitializeQTAsyncWrapper(o);
        });
      }
      async TestFunctionAsync() {
        return new Promise((r, a) => {
          const o = (l) => {
            r(l);
          };
          J(this, t).TestFunctionAsyncWrapper(o);
        });
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get xFileUtilsWasm() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.xFileUtilsWasm());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      ImageDataLoad(r) {
        return J(this, t).ImageDataLoad(r);
      }
      NIFTIWrite(r, a, o) {
        return J(this, t).NIFTIWrite(r, a, o);
      }
      STLWrite(r, a) {
        return J(this, t).STLWrite(r, a);
      }
      XMLWrite(r, a) {
        return J(this, t).XMLWrite(r, a);
      }
      GetImageDataView() {
        return J(this, t).GetImageDataView();
      }
      PolyDataLoadWrapper(r, a, o) {
        return J(this, t).PolyDataLoadWrapper(r, a, o);
      }
      PolyDataLoadBufferWrapper(r, a, o, l) {
        return J(this, t).PolyDataLoadBufferWrapper(r, a, o, l);
      }
      LoadSTLFromStreamDataWrapper(r, a) {
        return J(this, t).LoadSTLFromStreamDataWrapper(r, a);
      }
      ImportMeshLabelFromFileWrapper(r, a, o) {
        return J(this, t).ImportMeshLabelFromFileWrapper(r, a, o);
      }
      ImportMeshLabelForm2DImageWrapper(r, a, o) {
        return J(this, t).ImportMeshLabelForm2DImageWrapper(r, a, o);
      }
      GetSTLBufferForSaveByObjectId(r, a, o) {
        return J(this, t).GetSTLBufferForSaveByObjectId(r, a, o);
      }
      GetBuffer() {
        return J(this, t).GetBuffer();
      }
      IsTextureWritten() {
        return J(this, t).IsTextureWritten();
      }
      static get mItkFactoryRegistered() {
        return s.xFileUtilsWasm.mItkFactoryRegistered;
      }
      static set mItkFactoryRegistered(r) {
        s.xFileUtilsWasm.mItkFactoryRegistered = r;
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get ErrorType() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.ErrorType());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      GetInitialized() {
        return J(this, t).GetInitialized();
      }
      GetMessage() {
        return J(this, t).GetMessage();
      }
      GetLabel() {
        return J(this, t).GetLabel();
      }
      GetShowCancel() {
        return J(this, t).GetShowCancel();
      }
      GetYesNo() {
        return J(this, t).GetYesNo();
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get TMainFormWasm() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.TMainFormWasm());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      get can_create_cd() {
        return J(this, t).can_create_cd;
      }
      set can_create_cd(r) {
        J(this, t).can_create_cd = r;
      }
      get can_export_stl() {
        return J(this, t).can_export_stl;
      }
      set can_export_stl(r) {
        J(this, t).can_export_stl = r;
      }
      get itaka_version() {
        return J(this, t).itaka_version;
      }
      set itaka_version(r) {
        J(this, t).itaka_version = r;
      }
      get can_use_tmj_diagnosis() {
        return J(this, t).can_use_tmj_diagnosis;
      }
      set can_use_tmj_diagnosis(r) {
        J(this, t).can_use_tmj_diagnosis = r;
      }
      get exports_available() {
        return J(this, t).exports_available;
      }
      set exports_available(r) {
        J(this, t).exports_available = r;
      }
      get subscription_date_expired() {
        return J(this, t).subscription_date_expired;
      }
      set subscription_date_expired(r) {
        J(this, t).subscription_date_expired = r;
      }
      get mShadingMode() {
        return J(this, t).mShadingMode;
      }
      set mShadingMode(r) {
        J(this, t).mShadingMode = r;
      }
      get mWindow() {
        return J(this, t).mWindow;
      }
      set mWindow(r) {
        J(this, t).mWindow = r;
      }
      get mLevel() {
        return J(this, t).mLevel;
      }
      set mLevel(r) {
        J(this, t).mLevel = r;
      }
      get mHeight() {
        return J(this, t).mHeight;
      }
      set mHeight(r) {
        J(this, t).mHeight = r;
      }
      get mIsMaxilla() {
        return J(this, t).mIsMaxilla;
      }
      set mIsMaxilla(r) {
        J(this, t).mIsMaxilla = r;
      }
      InitializeINI() {
        return J(this, t).InitializeINI();
      }
      InitLayout() {
        return J(this, t).InitLayout();
      }
      SetMouseModeOn3D(r) {
        return J(this, t).SetMouseModeOn3D(r);
      }
      SetProjectName(r) {
        return J(this, t).SetProjectName(r);
      }
      ResizeEvent() {
        return J(this, t).ResizeEvent();
      }
      ProcessDispatchTasks() {
        return J(this, t).ProcessDispatchTasks();
      }
      ClearDispatchTasks() {
        return J(this, t).ClearDispatchTasks();
      }
      ExitCAD() {
        return J(this, t).ExitCAD();
      }
      TabChanged(r) {
        return J(this, t).TabChanged(r);
      }
      showSTLMatchingWizard() {
        return J(this, t).showSTLMatchingWizard();
      }
      showSTLEditWizard(r) {
        return J(this, t).showSTLEditWizard(r);
      }
      showBooleanWizard() {
        return J(this, t).showBooleanWizard();
      }
      showSTLLibraryPreviewWizard() {
        return J(this, t).showSTLLibraryPreviewWizard();
      }
      showSTLLibraryAlignmentWizard() {
        return J(this, t).showSTLLibraryAlignmentWizard();
      }
      setEditObject(r) {
        return J(this, t).setEditObject(r);
      }
      GetLayoutType() {
        return J(this, t).GetLayoutType();
      }
      Set3DOrientation(r) {
        return J(this, t).Set3DOrientation(r);
      }
      AddImplantObject(r, a, o, l, c, u, d, h) {
        return J(this, t).AddImplantObject(r, a, o, l, c, u, d, h);
      }
      AddPrimaryAbutmentObject(r, a, o, l, c, u, d, h, p) {
        return J(this, t).AddPrimaryAbutmentObject(r, a, o, l, c, u, d, h, p);
      }
      AddPrimaryScanAbutmentObject(r, a, o, l, c, u, d) {
        return J(this, t).AddPrimaryScanAbutmentObject(r, a, o, l, c, u, d);
      }
      AddImplantAnalogueObject(r, a, o, l, c, u, d) {
        return J(this, t).AddImplantAnalogueObject(r, a, o, l, c, u, d);
      }
      AddSecondaryAbutmentObject(r, a, o, l, c, u) {
        return J(this, t).AddSecondaryAbutmentObject(r, a, o, l, c, u);
      }
      AddSecondaryScanAbutmentObject(r, a, o, l, c, u) {
        return J(this, t).AddSecondaryScanAbutmentObject(r, a, o, l, c, u);
      }
      RemoveImplantObject() {
        return J(this, t).RemoveImplantObject();
      }
      RemovePrimaryAbutmentObject() {
        return J(this, t).RemovePrimaryAbutmentObject();
      }
      RemovePrimaryScanAbutmentObject() {
        return J(this, t).RemovePrimaryScanAbutmentObject();
      }
      RemoveImplantAnalogueObject() {
        return J(this, t).RemoveImplantAnalogueObject();
      }
      RemoveSecondaryAbutmentObject() {
        return J(this, t).RemoveSecondaryAbutmentObject();
      }
      RemoveSecondaryScanAbutmentObject() {
        return J(this, t).RemoveSecondaryScanAbutmentObject();
      }
      AddModelParametricFromJson(r) {
        return J(this, t).AddModelParametricFromJson(r);
      }
      AddModelStlFromJson(r, a) {
        return J(this, t).AddModelStlFromJson(r, a);
      }
      AddSleeveParametricFromJson(r) {
        return J(this, t).AddSleeveParametricFromJson(r);
      }
      AddSleeveStlFromJson(r, a) {
        return J(this, t).AddSleeveStlFromJson(r, a);
      }
      AddSleeveStlWithNegativeFromJson(r, a, o) {
        return J(this, t).AddSleeveStlWithNegativeFromJson(r, a, o);
      }
      SleeveNeedsBottomAlignment() {
        return J(this, t).SleeveNeedsBottomAlignment();
      }
      AlignSleeveBottom() {
        return J(this, t).AlignSleeveBottom();
      }
      RemoveModelObject() {
        return J(this, t).RemoveModelObject();
      }
      RemoveSleeveObjects() {
        return J(this, t).RemoveSleeveObjects();
      }
      SetCurrendtWizard(r) {
        return J(this, t).SetCurrendtWizard(r);
      }
      GetCurrendtWizard() {
        return J(this, t).GetCurrendtWizard();
      }
      ShowReconstructionWizardOnTab() {
        return J(this, t).ShowReconstructionWizardOnTab();
      }
      SetGUIEventHandler(r) {
        return J(this, t).SetGUIEventHandler(r);
      }
      SetTabWidgetHandler(r) {
        return J(this, t).SetTabWidgetHandler(r);
      }
      SetContextMenuFactory(r) {
        return J(this, t).SetContextMenuFactory(r);
      }
      SetJSLambda(r, a) {
        return J(this, t).SetJSLambda(r, a);
      }
      ClearJSLambda(r) {
        return J(this, t).ClearJSLambda(r);
      }
      FreeFormButtonClicked(r) {
        return J(this, t).FreeFormButtonClicked(r);
      }
      PrevClicked() {
        return J(this, t).PrevClicked();
      }
      NextClicked() {
        return J(this, t).NextClicked();
      }
      CloseClicked() {
        return J(this, t).CloseClicked();
      }
      SetLayout(r) {
        return J(this, t).SetLayout(r);
      }
      GetLayout() {
        return J(this, t).GetLayout();
      }
      ConstructAddReconstructionObject() {
        return J(this, t).ConstructAddReconstructionObject();
      }
      DeleteAddReconstructionObject() {
        return J(this, t).DeleteAddReconstructionObject();
      }
      GetAddReconstructionObject() {
        return J(this, t).GetAddReconstructionObject();
      }
      SetDisableGUIRetrieve(r) {
        return J(this, t).SetDisableGUIRetrieve(r);
      }
      GetDisableGUIRetrieve() {
        return J(this, t).GetDisableGUIRetrieve();
      }
      RetrieveCurrentWizardGUI() {
        return J(this, t).RetrieveCurrentWizardGUI();
      }
      LoadTestImageData() {
        return J(this, t).LoadTestImageData();
      }
      AppendMeshLabelToDocument(r, a, o, l) {
        return J(this, t).AppendMeshLabelToDocument(r, a, o, l);
      }
      AddSTLObject(r) {
        return J(this, t).AddSTLObject(r);
      }
      PrepareTeethListAndGetSize(r) {
        return J(this, t).PrepareTeethListAndGetSize(r);
      }
      GetToothPosition(r) {
        return J(this, t).GetToothPosition(r);
      }
      GetToothName(r) {
        return J(this, t).GetToothName(r);
      }
      AssignMeshFromTooth(r, a, o, l) {
        return J(this, t).AssignMeshFromTooth(r, a, o, l);
      }
      GetMergedTeethList() {
        return J(this, t).GetMergedTeethList();
      }
      GetReferencePlanesList() {
        return J(this, t).GetReferencePlanesList();
      }
      AssignMergedTeeth(r, a) {
        return J(this, t).AssignMergedTeeth(r, a);
      }
      AssignReferencePlane(r, a) {
        return J(this, t).AssignReferencePlane(r, a);
      }
      GetTopToolbar() {
        return J(this, t).GetTopToolbar();
      }
      UpdateUndoInformation() {
        return J(this, t).UpdateUndoInformation();
      }
      Undo() {
        return J(this, t).Undo();
      }
      Redo() {
        return J(this, t).Redo();
      }
      TestFunction() {
        return J(this, t).TestFunction();
      }
      SetAsyncJobRunningFlag(r) {
        return J(this, t).SetAsyncJobRunningFlag(r);
      }
      GetRefinementWidget() {
        return J(this, t).GetRefinementWidget();
      }
      GetErrorWidget() {
        return J(this, t).GetErrorWidget();
      }
      GetAnalyzeThicknessWidget() {
        return J(this, t).GetAnalyzeThicknessWidget();
      }
      GetArticulatorLibraryWidget() {
        return J(this, t).GetArticulatorLibraryWidget();
      }
      GetMovementMarkerLibraryWidget() {
        return J(this, t).GetMovementMarkerLibraryWidget();
      }
      GetTeethLibraryWidget() {
        return J(this, t).GetTeethLibraryWidget();
      }
      GetSelectActiveReconstructionWidget() {
        return J(this, t).GetSelectActiveReconstructionWidget();
      }
      GetReconstructionReviewWidget() {
        return J(this, t).GetReconstructionReviewWidget();
      }
      UpdatePrimaryAbutmentAngle(r) {
        return J(this, t).UpdatePrimaryAbutmentAngle(r);
      }
      UpdatePrimaryAbutmentRotZ(r) {
        return J(this, t).UpdatePrimaryAbutmentRotZ(r);
      }
      UpdateConnectorHeight(r, a) {
        return J(this, t).UpdateConnectorHeight(r, a);
      }
      ObjectTypeExists(r) {
        return J(this, t).ObjectTypeExists(r);
      }
      GetObjectSTLByType(r) {
        return J(this, t).GetObjectSTLByType(r);
      }
      GetObjectGUIDByType(r) {
        return J(this, t).GetObjectGUIDByType(r);
      }
      GetObjectConnectorHeightByType(r) {
        return J(this, t).GetObjectConnectorHeightByType(r);
      }
      GetObjectAngleByType(r) {
        return J(this, t).GetObjectAngleByType(r);
      }
      GetObjectRotZByType(r) {
        return J(this, t).GetObjectRotZByType(r);
      }
      GetObjectColorByType(r) {
        return J(this, t).GetObjectColorByType(r);
      }
      SetCPRCurve(r, a, o, l, c, u) {
        return J(this, t).SetCPRCurve(r, a, o, l, c, u);
      }
      PrepareVolumeProperties(r, a, o, l, c) {
        return J(this, t).PrepareVolumeProperties(r, a, o, l, c);
      }
      GetWasmObjectListItems() {
        return J(this, t).GetWasmObjectListItems();
      }
      WasmObjectListItemClicked(r, a) {
        return J(this, t).WasmObjectListItemClicked(r, a);
      }
      WasmObjectListContextMenuClicked(r) {
        return J(this, t).WasmObjectListContextMenuClicked(r);
      }
      WasmScalarBarSetScalarBarScale(r) {
        return J(this, t).WasmScalarBarSetScalarBarScale(r);
      }
      WasmScalarBarHeaderButtonClicked(r) {
        return J(this, t).WasmScalarBarHeaderButtonClicked(r);
      }
      WasmScalarBarContactsButtonClicked(r) {
        return J(this, t).WasmScalarBarContactsButtonClicked(r);
      }
      async ProcessDispatchTasksAsync() {
        return new Promise((r, a) => {
          const o = (l) => {
            r(l);
          };
          J(this, t).ProcessDispatchTasksAsyncWrapper(o);
        });
      }
      async ClearDispatchTasksAsync() {
        return new Promise((r, a) => {
          const o = (l) => {
            r(l);
          };
          J(this, t).ClearDispatchTasksAsyncWrapper(o);
        });
      }
      async ExitCADAsync() {
        return new Promise((r, a) => {
          const o = (l) => {
            r(l);
          };
          J(this, t).ExitCADAsyncWrapper(o);
        });
      }
      async TabChangedAsync(r) {
        return new Promise((a, o) => {
          const l = (c) => {
            a(c);
          };
          J(this, t).TabChangedAsyncWrapper(r, l);
        });
      }
      async showSTLMatchingWizardAsync() {
        return new Promise((r, a) => {
          const o = (l) => {
            r(l);
          };
          J(this, t).showSTLMatchingWizardAsyncWrapper(o);
        });
      }
      async showSTLEditWizardAsync(r) {
        return new Promise((a, o) => {
          const l = (c) => {
            a(c);
          };
          J(this, t).showSTLEditWizardAsyncWrapper(r, l);
        });
      }
      async showBooleanWizardAsync() {
        return new Promise((r, a) => {
          const o = (l) => {
            r(l);
          };
          J(this, t).showBooleanWizardAsyncWrapper(o);
        });
      }
      async showSTLLibraryPreviewWizardAsync() {
        return new Promise((r, a) => {
          const o = (l) => {
            r(l);
          };
          J(this, t).showSTLLibraryPreviewWizardAsyncWrapper(o);
        });
      }
      async showSTLLibraryAlignmentWizardAsync() {
        return new Promise((r, a) => {
          const o = (l) => {
            r(l);
          };
          J(this, t).showSTLLibraryAlignmentWizardAsyncWrapper(o);
        });
      }
      async setEditObjectAsync(r) {
        return new Promise((a, o) => {
          const l = (c) => {
            a(c);
          };
          J(this, t).setEditObjectAsyncWrapper(r, l);
        });
      }
      async FreeFormButtonClickedAsync(r) {
        return new Promise((a, o) => {
          const l = (c) => {
            a(c);
          };
          J(this, t).FreeFormButtonClickedAsyncWrapper(r, l);
        });
      }
      async PrevClickedAsync() {
        return new Promise((r, a) => {
          const o = (l) => {
            r(l);
          };
          J(this, t).PrevClickedAsyncWrapper(o);
        });
      }
      async NextClickedAsync() {
        return new Promise((r, a) => {
          const o = (l) => {
            r(l);
          };
          J(this, t).NextClickedAsyncWrapper(o);
        });
      }
      async CloseClickedAsync() {
        return new Promise((r, a) => {
          const o = (l) => {
            r(l);
          };
          J(this, t).CloseClickedAsyncWrapper(o);
        });
      }
      async SetLayoutAsync(r) {
        return new Promise((a, o) => {
          const l = (c) => {
            a(c);
          };
          J(this, t).SetLayoutAsyncWrapper(r, l);
        });
      }
      async TestFunctionAsync() {
        return new Promise((r, a) => {
          const o = (l) => {
            r(l);
          };
          J(this, t).TestFunctionAsyncWrapper(o);
        });
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get xAddReconstructionWasm() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.xAddReconstructionWasm());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      PrepareDialog(r, a) {
        return J(this, t).PrepareDialog(r, a);
      }
      GetTeethLibraryString() {
        return J(this, t).GetTeethLibraryString();
      }
      GetTeethList() {
        return J(this, t).GetTeethList();
      }
      GetObjectsList(r) {
        return J(this, t).GetObjectsList(r);
      }
      GetObjectOptions(r) {
        return J(this, t).GetObjectOptions(r);
      }
      GetSelectedObject(r) {
        return J(this, t).GetSelectedObject(r);
      }
      GetSelectedObjectId(r) {
        return J(this, t).GetSelectedObjectId(r);
      }
      GetGenericSelectedObject(r) {
        return J(this, t).GetGenericSelectedObject(r);
      }
      GetGenericSelectedObjectIds(r) {
        return J(this, t).GetGenericSelectedObjectIds(r);
      }
      SelectedSelectionChanged(r, a, o) {
        return J(this, t).SelectedSelectionChanged(r, a, o);
      }
      SelectedSelectionChangedById(r, a, o) {
        return J(this, t).SelectedSelectionChangedById(r, a, o);
      }
      SelectedGenericSelectionChanged(r, a, o) {
        return J(this, t).SelectedGenericSelectionChanged(r, a, o);
      }
      SelectedGenericSelectionChangedByIds(r, a, o) {
        return J(this, t).SelectedGenericSelectionChangedByIds(r, a, o);
      }
      SetTeethList(r) {
        return J(this, t).SetTeethList(r);
      }
      SetSelectedLibrary(r, a) {
        return J(this, t).SetSelectedLibrary(r, a);
      }
      SetModeWorkflowName(r, a, o) {
        return J(this, t).SetModeWorkflowName(r, a, o);
      }
      ValidateAndAddReconstruction() {
        return J(this, t).ValidateAndAddReconstruction();
      }
      ValidateAndAddReconstruction2() {
        return J(this, t).ValidateAndAddReconstruction2();
      }
      GetImages(r) {
        return J(this, t).GetImages(r);
      }
      FillTeeth() {
        return J(this, t).FillTeeth();
      }
      FillImages() {
        return J(this, t).FillImages();
      }
      FillAntagonist(r) {
        return J(this, t).FillAntagonist(r);
      }
      FillModel(r) {
        return J(this, t).FillModel(r);
      }
      FillGingiva(r) {
        return J(this, t).FillGingiva(r);
      }
      FillGingivaAntagonist(r) {
        return J(this, t).FillGingivaAntagonist(r);
      }
      FillWaxup(r) {
        return J(this, t).FillWaxup(r);
      }
      FillWaxupAntagonist(r) {
        return J(this, t).FillWaxupAntagonist(r);
      }
      FillMarker(r) {
        return J(this, t).FillMarker(r);
      }
      FillMarkerAntagonist(r) {
        return J(this, t).FillMarkerAntagonist(r);
      }
      FillDenture(r) {
        return J(this, t).FillDenture(r);
      }
      FillDentureAntagonist(r) {
        return J(this, t).FillDentureAntagonist(r);
      }
      FillMovementMarker(r) {
        return J(this, t).FillMovementMarker(r);
      }
      FillFaceScan(r) {
        return J(this, t).FillFaceScan(r);
      }
      FillGeneric(r, a) {
        return J(this, t).FillGeneric(r, a);
      }
      FillType(r) {
        return J(this, t).FillType(r);
      }
      SetSelected2DImage(r, a) {
        return J(this, t).SetSelected2DImage(r, a);
      }
      FillReconstruction() {
        return J(this, t).FillReconstruction();
      }
      FillAntagonistReconstruction() {
        return J(this, t).FillAntagonistReconstruction();
      }
      UpdateVisibility() {
        return J(this, t).UpdateVisibility();
      }
      static GetValidReconstructionName(r) {
        return s.xAddReconstructionWasm.GetValidReconstructionName(r);
      }
      static ValidateProductionCenterMaterial(r, a, o) {
        return s.xAddReconstructionWasm.ValidateProductionCenterMaterial(r, a, o);
      }
      static FileFromSubtype(r) {
        return s.xAddReconstructionWasm.FileFromSubtype(r);
      }
      static FileFromType(r) {
        return s.xAddReconstructionWasm.FileFromType(r);
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get TGroupObjectWasm() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.TGroupObjectWasm());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      get mDisableToggleVisibility() {
        return J(this, t).mDisableToggleVisibility;
      }
      set mDisableToggleVisibility(r) {
        J(this, t).mDisableToggleVisibility = r;
      }
      get mRemoveActionVisibleOverride() {
        return J(this, t).mRemoveActionVisibleOverride;
      }
      set mRemoveActionVisibleOverride(r) {
        J(this, t).mRemoveActionVisibleOverride = r;
      }
      get mRemoveObjectsOverride() {
        return J(this, t).mRemoveObjectsOverride;
      }
      set mRemoveObjectsOverride(r) {
        J(this, t).mRemoveObjectsOverride = r;
      }
      get mRenameActionHiddenOverride() {
        return J(this, t).mRenameActionHiddenOverride;
      }
      set mRenameActionHiddenOverride(r) {
        J(this, t).mRenameActionHiddenOverride = r;
      }
      GetGroup() {
        return J(this, t).GetGroup();
      }
      GetId() {
        return J(this, t).GetId();
      }
      GetLabel() {
        return J(this, t).GetLabel();
      }
      GetState() {
        return J(this, t).GetState();
      }
      SetState(r) {
        return J(this, t).SetState(r);
      }
      SetObjectsGroup(r) {
        return J(this, t).SetObjectsGroup(r);
      }
      GetObjectsGroup() {
        return J(this, t).GetObjectsGroup();
      }
      GetObjectsName() {
        return J(this, t).GetObjectsName();
      }
      SetVisualObject(r) {
        return J(this, t).SetVisualObject(r);
      }
      GetVisualObject() {
        return J(this, t).GetVisualObject();
      }
      SetMeasure(r) {
        return J(this, t).SetMeasure(r);
      }
      SetMeasures(r) {
        return J(this, t).SetMeasures(r);
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get TTopToolbarCAD() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.TTopToolbarCAD());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      resetView() {
        return J(this, t).resetView();
      }
      clearAllMeasurements() {
        return J(this, t).clearAllMeasurements();
      }
      clearAllExcept() {
        return J(this, t).clearAllExcept();
      }
      openAnnotation() {
        return J(this, t).openAnnotation();
      }
      openAnnotationProxyA(r) {
        return J(this, t).openAnnotationProxyA(r);
      }
      openLandmark() {
        return J(this, t).openLandmark();
      }
      openLandmarkProxyA(r) {
        return J(this, t).openLandmarkProxyA(r);
      }
      openPoly() {
        return J(this, t).openPoly();
      }
      openAngle() {
        return J(this, t).openAngle();
      }
      openRuler() {
        return J(this, t).openRuler();
      }
      openPlane() {
        return J(this, t).openPlane();
      }
      openSphere() {
        return J(this, t).openSphere();
      }
      openTetrahedron() {
        return J(this, t).openTetrahedron();
      }
      toggleContrast(r) {
        return J(this, t).toggleContrast(r);
      }
      toggleInfo(r) {
        return J(this, t).toggleInfo(r);
      }
      async openAnnotationAsync() {
        return new Promise((r, a) => {
          const o = (l) => {
            r(l);
          };
          J(this, t).openAnnotationAsyncWrapper(o);
        });
      }
      async openLandmarkAsync() {
        return new Promise((r, a) => {
          const o = (l) => {
            r(l);
          };
          J(this, t).openLandmarkAsyncWrapper(o);
        });
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get xProjectLoaderUtil() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.xProjectLoaderUtil());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      InitializeCADProjectLoading(r, a, o) {
        return J(this, t).InitializeCADProjectLoading(r, a, o);
      }
      FinalizeCADProjectLoading() {
        return J(this, t).FinalizeCADProjectLoading();
      }
      InitializeCADProjectSaving(r, a, o) {
        return J(this, t).InitializeCADProjectSaving(r, a, o);
      }
      AddBoneSegmentationVisualObjectsForSave(r) {
        return J(this, t).AddBoneSegmentationVisualObjectsForSave(r);
      }
      AddToothSegmentationVisualObjectsForSave(r) {
        return J(this, t).AddToothSegmentationVisualObjectsForSave(r);
      }
      FinalizeCADProjectSaving() {
        return J(this, t).FinalizeCADProjectSaving();
      }
      GetNumberOfCADVolumeLabels() {
        return J(this, t).GetNumberOfCADVolumeLabels();
      }
      GetNumberOfCADMeshLabels() {
        return J(this, t).GetNumberOfCADMeshLabels();
      }
      AssignVolumeById(r, a) {
        return J(this, t).AssignVolumeById(r, a);
      }
      AssignMeshById(r, a) {
        return J(this, t).AssignMeshById(r, a);
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get WebInputTextHandler() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.WebInputTextHandler());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      get mText() {
        return J(this, t).mText;
      }
      set mText(r) {
        J(this, t).mText = r;
      }
      get mAccepted() {
        return J(this, t).mAccepted;
      }
      set mAccepted(r) {
        J(this, t).mAccepted = r;
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get WebAddReconstructionDialogHandler() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.WebAddReconstructionDialogHandler());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get TGuideVTK() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor(r, a, o, l, c, u, d, h, p, m, b, y, Z, g) {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.TGuideVTK(r, a, o, l, c, u, d, h, p, m, b, y, Z, g));
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      get pointsView() {
        return J(this, t).pointsView;
      }
      set pointsView(r) {
        J(this, t).pointsView = r;
      }
      get polysView() {
        return J(this, t).polysView;
      }
      set polysView(r) {
        J(this, t).polysView = r;
      }
      GetHeight() {
        return J(this, t).GetHeight();
      }
      CalculateFreeFormGeometry(r) {
        return J(this, t).CalculateFreeFormGeometry(r);
      }
      CreateVTKObjects(r, a, o, l, c, u, d, h, p, m, b, y, Z, g) {
        return J(this, t).CreateVTKObjects(r, a, o, l, c, u, d, h, p, m, b, y, Z, g);
      }
      DeleteVTKObjects() {
        return J(this, t).DeleteVTKObjects();
      }
      GetGuideTop() {
        return J(this, t).GetGuideTop();
      }
      GetGuideNormal() {
        return J(this, t).GetGuideNormal();
      }
      GetGuideBiNormal() {
        return J(this, t).GetGuideBiNormal();
      }
      GetGuideHeight() {
        return J(this, t).GetGuideHeight();
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get TModelToolVTK() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor(r, a, o, l, c, u, d, h, p, m, b, y, Z) {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.TModelToolVTK(r, a, o, l, c, u, d, h, p, m, b, y, Z));
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      get pointsView() {
        return J(this, t).pointsView;
      }
      set pointsView(r) {
        J(this, t).pointsView = r;
      }
      get polysView() {
        return J(this, t).polysView;
      }
      set polysView(r) {
        J(this, t).polysView = r;
      }
      GetHeight() {
        return J(this, t).GetHeight();
      }
      CreateVTKObjects(r, a, o, l, c, u, d, h, p, m, b, y, Z) {
        return J(this, t).CreateVTKObjects(r, a, o, l, c, u, d, h, p, m, b, y, Z);
      }
      DeleteVTKObjects() {
        return J(this, t).DeleteVTKObjects();
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get xLoadDicom() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.xLoadDicom());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      PrepareForDataUpload() {
        return J(this, t).PrepareForDataUpload();
      }
      AddToFiles(r, a) {
        return J(this, t).AddToFiles(r, a);
      }
      PicEditCall() {
        return J(this, t).PicEditCall();
      }
      GetImageDataView() {
        return J(this, t).GetImageDataView();
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get xDicomPreviewGenerator() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.xDicomPreviewGenerator());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      GetDICOMSlicePreview(r, a) {
        return J(this, t).GetDICOMSlicePreview(r, a);
      }
      GetTagFromDicomPath(r, a, o) {
        return J(this, t).GetTagFromDicomPath(r, a, o);
      }
      GetVolumeMetadataJson(r) {
        return J(this, t).GetVolumeMetadataJson(r);
      }
      GetDateTagFromDicomPath(r, a, o) {
        return J(this, t).GetDateTagFromDicomPath(r, a, o);
      }
      GetPreviewBuffer() {
        return J(this, t).GetPreviewBuffer();
      }
      GetSize() {
        return J(this, t).GetSize();
      }
      GetBase64String() {
        return J(this, t).GetBase64String();
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get PolyDataJSView() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.PolyDataJSView());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      get mInitialized() {
        return J(this, t).mInitialized;
      }
      set mInitialized(r) {
        J(this, t).mInitialized = r;
      }
      AssignFromPolyData(r, a) {
        return J(this, t).AssignFromPolyData(r, a);
      }
      ResetSpans() {
        return J(this, t).ResetSpans();
      }
      GetPoints() {
        return J(this, t).GetPoints();
      }
      GetPolys() {
        return J(this, t).GetPolys();
      }
      GetLines() {
        return J(this, t).GetLines();
      }
      GetVerts() {
        return J(this, t).GetVerts();
      }
      GetStrips() {
        return J(this, t).GetStrips();
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get ImageDataJSView() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.ImageDataJSView());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      get mInterpolate() {
        return J(this, t).mInterpolate;
      }
      set mInterpolate(r) {
        J(this, t).mInterpolate = r;
      }
      get mRepeat() {
        return J(this, t).mRepeat;
      }
      set mRepeat(r) {
        J(this, t).mRepeat = r;
      }
      get mBlendingMode() {
        return J(this, t).mBlendingMode;
      }
      set mBlendingMode(r) {
        J(this, t).mBlendingMode = r;
      }
      AssignFromImageData(r) {
        return J(this, t).AssignFromImageData(r);
      }
      ResetSpans() {
        return J(this, t).ResetSpans();
      }
      GetNumberOfComponents() {
        return J(this, t).GetNumberOfComponents();
      }
      GetDType() {
        return J(this, t).GetDType();
      }
      GetScalarsShort() {
        return J(this, t).GetScalarsShort();
      }
      GetScalarsFloat() {
        return J(this, t).GetScalarsFloat();
      }
      GetScalarsDouble() {
        return J(this, t).GetScalarsDouble();
      }
      GetScalarsUChar() {
        return J(this, t).GetScalarsUChar();
      }
      GetScalarsUShort() {
        return J(this, t).GetScalarsUShort();
      }
      GetScalarsInt() {
        return J(this, t).GetScalarsInt();
      }
      GetDimensions() {
        return J(this, t).GetDimensions();
      }
      GetSpacing() {
        return J(this, t).GetSpacing();
      }
      GetOrigin() {
        return J(this, t).GetOrigin();
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get DataArrayJSView() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.DataArrayJSView());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      AssignFromPolyDataByIdx(r, a, o) {
        return J(this, t).AssignFromPolyDataByIdx(r, a, o);
      }
      ResetSpans() {
        return J(this, t).ResetSpans();
      }
      GetDType() {
        return J(this, t).GetDType();
      }
      GetDataShort() {
        return J(this, t).GetDataShort();
      }
      GetDataFloat() {
        return J(this, t).GetDataFloat();
      }
      GetDataDouble() {
        return J(this, t).GetDataDouble();
      }
      GetDataUShort() {
        return J(this, t).GetDataUShort();
      }
      GetDataChar() {
        return J(this, t).GetDataChar();
      }
      GetDataInt() {
        return J(this, t).GetDataInt();
      }
      GetNumberOfComponents() {
        return J(this, t).GetNumberOfComponents();
      }
      GetDataType() {
        return J(this, t).GetDataType();
      }
      GetAttrType() {
        return J(this, t).GetAttrType();
      }
      GetName() {
        return J(this, t).GetName();
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get LookupTableJSView() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.LookupTableJSView());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      get mNumberOfNodes() {
        return J(this, t).mNumberOfNodes;
      }
      set mNumberOfNodes(r) {
        J(this, t).mNumberOfNodes = r;
      }
      get mHSVWrap() {
        return J(this, t).mHSVWrap;
      }
      set mHSVWrap(r) {
        J(this, t).mHSVWrap = r;
      }
      get mAlpha() {
        return J(this, t).mAlpha;
      }
      set mAlpha(r) {
        J(this, t).mAlpha = r;
      }
      get mUseBelowRangeColor() {
        return J(this, t).mUseBelowRangeColor;
      }
      set mUseBelowRangeColor(r) {
        J(this, t).mUseBelowRangeColor = r;
      }
      get mUseAboveRangeColor() {
        return J(this, t).mUseAboveRangeColor;
      }
      set mUseAboveRangeColor(r) {
        J(this, t).mUseAboveRangeColor = r;
      }
      get mColorSpace() {
        return J(this, t).mColorSpace;
      }
      set mColorSpace(r) {
        J(this, t).mColorSpace = r;
      }
      get mScale() {
        return J(this, t).mScale;
      }
      set mScale(r) {
        J(this, t).mScale = r;
      }
      get mNumberOfNodesOpacity() {
        return J(this, t).mNumberOfNodesOpacity;
      }
      set mNumberOfNodesOpacity(r) {
        J(this, t).mNumberOfNodesOpacity = r;
      }
      AssignFromLookupTable(r) {
        return J(this, t).AssignFromLookupTable(r);
      }
      AssignFromOpacityFunction(r) {
        return J(this, t).AssignFromOpacityFunction(r);
      }
      ResetSpans() {
        return J(this, t).ResetSpans();
      }
      GetAnnotations() {
        return J(this, t).GetAnnotations();
      }
      GetXRGBPointsFlatVector() {
        return J(this, t).GetXRGBPointsFlatVector();
      }
      GetAlphaPointsFlatVector() {
        return J(this, t).GetAlphaPointsFlatVector();
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get PolydataImporter() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.PolydataImporter());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      GetPolyDataView() {
        return J(this, t).GetPolyDataView();
      }
      GetNumberOfDataArrays(r) {
        return J(this, t).GetNumberOfDataArrays(r);
      }
      GetDataArrayByIdx(r, a) {
        return J(this, t).GetDataArrayByIdx(r, a);
      }
      GetImageDataView() {
        return J(this, t).GetImageDataView();
      }
      GetVisibility() {
        return J(this, t).GetVisibility();
      }
      GetMatrix() {
        return J(this, t).GetMatrix();
      }
      GetId() {
        return J(this, t).GetId();
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get debuggingTest() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.debuggingTest());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      Function1() {
        return J(this, t).Function1();
      }
      Function2() {
        return J(this, t).Function2();
      }
      Function3(r, a) {
        return J(this, t).Function3(r, a);
      }
      Function4(r, a) {
        return J(this, t).Function4(r, a);
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get memoryCleanningTest() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.memoryCleanningTest());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      Function1() {
        return J(this, t).Function1();
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get memoryGrowthTest() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.memoryGrowthTest());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      InitData(r, a) {
        return J(this, t).InitData(r, a);
      }
      GetDataView() {
        return J(this, t).GetDataView();
      }
      GetDataPtr() {
        return J(this, t).GetDataPtr();
      }
      GetDataSize() {
        return J(this, t).GetDataSize();
      }
      GetValue(r) {
        return J(this, t).GetValue(r);
      }
      SetValue(r, a) {
        return J(this, t).SetValue(r, a);
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
  get xMLBooleanTest() {
    var t, e, n;
    const s = this.m;
    return n = class {
      constructor() {
        Fe(this, t), Fe(this, e, ti++), qn(this, t, new s.xMLBooleanTest());
      }
      // emscripten method
      // delete the c++ object
      delete() {
        J(this, t).delete();
      }
      // emscripten method
      // schedule deletion of the c++ object
      deleteLater() {
        J(this, t).deleteLater();
      }
      // emscripten method
      // clone the c++ object handle
      // clones are reference counted, so delete() has to be called on every clone
      clone() {
        return J(this, t).clone();
      }
      // emscripten method
      // check if the instance has been deleted
      isDeleted() {
        return J(this, t).isDeleted();
      }
      // emscripten method
      isAliasOf(r) {
        return J(this, t).isAliasOf(r);
      }
      SetImageDataFromFile(r, a) {
        return J(this, t).SetImageDataFromFile(r, a);
      }
      BooleanTest() {
        return J(this, t).BooleanTest();
      }
      GetMesh1View() {
        return J(this, t).GetMesh1View();
      }
      GetMesh2View() {
        return J(this, t).GetMesh2View();
      }
      GetOutputMeshView() {
        return J(this, t).GetOutputMeshView();
      }
    }, t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), n;
  }
}
var Xa = /* @__PURE__ */ ((i) => (i[i._MPR = 0] = "_MPR", i[i._MIP = 1] = "_MIP", i[i._RAYSUM = 2] = "_RAYSUM", i[i._MINMIP = 3] = "_MINMIP", i[i._SCOUT = 4] = "_SCOUT", i[i._CAPTURE_3D = 5] = "_CAPTURE_3D", i[i._CAPTURE_MIP = 6] = "_CAPTURE_MIP", i[i._CUSTOM_FILTER_0 = 7] = "_CUSTOM_FILTER_0", i[i._CUSTOM_FILTER_1 = 8] = "_CUSTOM_FILTER_1", i[i._CUSTOM_FILTER_2 = 9] = "_CUSTOM_FILTER_2", i[i._CUSTOM_FILTER_3 = 10] = "_CUSTOM_FILTER_3", i))(Xa || {}), m3 = /* @__PURE__ */ ((i) => (i[i.FILTER_ALL_PATIENTS = 0] = "FILTER_ALL_PATIENTS", i[i.FILTER_MY_PATIENTS = 1] = "FILTER_MY_PATIENTS", i[i.FILTER_SHARED_PATIENTS = 2] = "FILTER_SHARED_PATIENTS", i))(m3 || {}), b3 = /* @__PURE__ */ ((i) => (i[i.RIGHT = 0] = "RIGHT", i[i.BOTTOM = 1] = "BOTTOM", i[i.UPPER = 2] = "UPPER", i[i.LEFT = 3] = "LEFT", i[i.LOWERRIGHT = 4] = "LOWERRIGHT", i[i.LOWERLEFT = 5] = "LOWERLEFT", i[i.UPPERRIGHT = 6] = "UPPERRIGHT", i[i.UPPERLEFT = 7] = "UPPERLEFT", i[i.ARROW = 8] = "ARROW", i))(b3 || {}), f3 = /* @__PURE__ */ ((i) => (i[i._AXIAL = 0] = "_AXIAL", i[i._CORONAL = 1] = "_CORONAL", i[i._SAGITTAL = 2] = "_SAGITTAL", i[i._3D = 3] = "_3D", i[i._CPR = 4] = "_CPR", i[i._CROSS_SECTION = 5] = "_CROSS_SECTION", i[i._TANGENT = 6] = "_TANGENT", i[i._STL_SURFACE = 7] = "_STL_SURFACE", i[i._PREVIEW_3D = 8] = "_PREVIEW_3D", i))(f3 || {}), g3 = /* @__PURE__ */ ((i) => (i[i._NONE = 0] = "_NONE", i[i._ANNOTATION = 1] = "_ANNOTATION", i[i._DISTANCE = 2] = "_DISTANCE", i[i._ANGLE = 3] = "_ANGLE", i[i._POLYGON = 4] = "_POLYGON", i[i._CURSOR_CROSS = 5] = "_CURSOR_CROSS", i[i._CONTRAST_CONTROL = 6] = "_CONTRAST_CONTROL", i[i._NERVE = 7] = "_NERVE", i[i._IMPLANT = 8] = "_IMPLANT", i[i._CPR_CURVE = 9] = "_CPR_CURVE", i[i._DENTAL_CONTROL = 10] = "_DENTAL_CONTROL", i[i._CLIPPING_PLANES = 11] = "_CLIPPING_PLANES", i[i._FLY_CAMERA = 12] = "_FLY_CAMERA", i[i._THINSLAB = 13] = "_THINSLAB", i[i._MIP_INDICATOR = 14] = "_MIP_INDICATOR", i[i._CPR_MIP_INDICATOR = 15] = "_CPR_MIP_INDICATOR", i[i._CROSS_INDICATOR = 16] = "_CROSS_INDICATOR", i[i._CPR_CROSS_INDICATOR = 17] = "_CPR_CROSS_INDICATOR", i[i._CPR_SHAPE_INDICATOR = 18] = "_CPR_SHAPE_INDICATOR", i[i._SCULPTING = 19] = "_SCULPTING", i[i._CURVE = 20] = "_CURVE", i[i._WIZARD_CONTROL = 21] = "_WIZARD_CONTROL", i[i._NERVE_LEFT = 22] = "_NERVE_LEFT", i[i._NERVE_RIGHT = 23] = "_NERVE_RIGHT", i[i._CPR_CUSTOM = 24] = "_CPR_CUSTOM", i[i._CPR_DENTAL = 25] = "_CPR_DENTAL", i[i._CPR_AIRWAY = 26] = "_CPR_AIRWAY", i[i._TOOTH_MARKER = 27] = "_TOOTH_MARKER", i[i._TMJ_CURSOR_CROSS = 28] = "_TMJ_CURSOR_CROSS", i[i._STL_TEETH_MODEL = 29] = "_STL_TEETH_MODEL", i[i._STL_PROSTHESIS = 30] = "_STL_PROSTHESIS", i[i._PIN = 31] = "_PIN", i[i._STL_TOOTH = 32] = "_STL_TOOTH", i[i._STL_OBJECT = 33] = "_STL_OBJECT", i[i._THINSLAB_CPR = 34] = "_THINSLAB_CPR", i[i.OBJECT3D_SELECTION = 35] = "OBJECT3D_SELECTION", i[i._EXPORT_CROSS_INDICATOR = 36] = "_EXPORT_CROSS_INDICATOR", i[i._SPHERE_INDICATOR = 37] = "_SPHERE_INDICATOR", i[i._ABUTMENT = 38] = "_ABUTMENT", i[i._MARKER = 39] = "_MARKER", i[i._SLEEVE = 40] = "_SLEEVE", i[i._COLLISION_ZONE = 41] = "_COLLISION_ZONE", i[i._MAXILLA = 42] = "_MAXILLA", i[i._MANDIBLA = 43] = "_MANDIBLA", i[i._SECONDARY_ABUTMENT = 44] = "_SECONDARY_ABUTMENT", i[i._SECONDARY_SCAN_ABUTMENT = 45] = "_SECONDARY_SCAN_ABUTMENT", i[i._IMPLANT_ANALOG = 46] = "_IMPLANT_ANALOG", i[i._PRIMARY_SCAN_ABUTMENT = 47] = "_PRIMARY_SCAN_ABUTMENT", i[i._PREVIEW = 48] = "_PREVIEW", i[i._ANALOG_EXTRUSION = 49] = "_ANALOG_EXTRUSION", i[i._MERGED_CROWN_ROOT = 50] = "_MERGED_CROWN_ROOT", i[i._REFERENCE_PLANE = 51] = "_REFERENCE_PLANE", i))(g3 || {}), y3 = /* @__PURE__ */ ((i) => (i[i.NONE = 0] = "NONE", i[i.NAME_ASC = 1] = "NAME_ASC", i[i.NAME_DESC = 2] = "NAME_DESC", i[i.DATE_OF_BIRTH_ASC = 3] = "DATE_OF_BIRTH_ASC", i[i.DATE_OF_BIRTH_DESC = 4] = "DATE_OF_BIRTH_DESC", i[i.LAST_MODIFIED_ASC = 5] = "LAST_MODIFIED_ASC", i[i.LAST_MODIFIED_DESC = 6] = "LAST_MODIFIED_DESC", i[i.STATUS_ASC = 7] = "STATUS_ASC", i[i.STATUS_DESC = 8] = "STATUS_DESC", i))(y3 || {}), Z3 = /* @__PURE__ */ ((i) => (i[i.SM_NOT_CHECKED = 0] = "SM_NOT_CHECKED", i[i.SM_VALID = 1] = "SM_VALID", i[i.SM_OFFLINE = 2] = "SM_OFFLINE", i[i.SM_EXPIRED = 3] = "SM_EXPIRED", i))(Z3 || {}), Mr = /* @__PURE__ */ ((i) => (i[i.eT_VIEW_PROP = 0] = "eT_VIEW_PROP", i[i.eT_ACTOR = 1] = "eT_ACTOR", i[i.eT_ACTOR2D = 2] = "eT_ACTOR2D", i[i.eT_VOLUME = 3] = "eT_VOLUME", i[i.eT_IMAGE_SLICE = 4] = "eT_IMAGE_SLICE", i[i.eT_TEXT_ACTOR = 5] = "eT_TEXT_ACTOR", i[i.eT_LINE_ACTOR = 6] = "eT_LINE_ACTOR", i[i.eT_POLY_DATA_SOURCE_ACTOR = 7] = "eT_POLY_DATA_SOURCE_ACTOR", i[i.eT_IMAGE2D_ACTOR = 8] = "eT_IMAGE2D_ACTOR", i[i.eT_SPHERE_MAPPER_ACTOR = 9] = "eT_SPHERE_MAPPER_ACTOR", i[i.eT_GLYPH_MAPPER_ACTOR = 10] = "eT_GLYPH_MAPPER_ACTOR", i[i.eT_MULTY_GLYPH_MAPPER_ACTOR = 11] = "eT_MULTY_GLYPH_MAPPER_ACTOR", i[i.eT_GLYPH2D_MAPPER_ACTOR = 12] = "eT_GLYPH2D_MAPPER_ACTOR", i[i.eT_SCALAR_BAR_ACTOR = 13] = "eT_SCALAR_BAR_ACTOR", i))(Mr || {}), _o = /* @__PURE__ */ ((i) => (i[i.eJSLT_RETIEVE_GUI = 0] = "eJSLT_RETIEVE_GUI", i[i.eJSLT_FREEFORM_GUI_UPDATE = 1] = "eJSLT_FREEFORM_GUI_UPDATE", i[i.eJSLT_LOAD_TEETH_FROM_CAD = 2] = "eJSLT_LOAD_TEETH_FROM_CAD", i[i.eJSLT_UPDATE_OBJECT_TREE_LIST = 3] = "eJSLT_UPDATE_OBJECT_TREE_LIST", i[i.eJSLT_UPDATE_CONTACTS_WIDGET = 4] = "eJSLT_UPDATE_CONTACTS_WIDGET", i[i.eJSLT_FINALIZE_CAD_WIZARD = 5] = "eJSLT_FINALIZE_CAD_WIZARD", i[i.eJSLT_DELETE_ITEM = 6] = "eJSLT_DELETE_ITEM", i[i.eJSLT_CREATE_ITEM = 7] = "eJSLT_CREATE_ITEM", i[i.eJSLT_SYNC_ITEM = 8] = "eJSLT_SYNC_ITEM", i[i.eJSLT_STL_EDITOR_OBJECT_STL_MODIFIED = 9] = "eJSLT_STL_EDITOR_OBJECT_STL_MODIFIED", i[i.eJSLT_STL_EDITOR_OBJECT_PROPERTY_MODIFIED = 10] = "eJSLT_STL_EDITOR_OBJECT_PROPERTY_MODIFIED", i[i.eJSLT_STL_EDITOR_CONNECTOR_HEIGHT_MODIFIED = 11] = "eJSLT_STL_EDITOR_CONNECTOR_HEIGHT_MODIFIED", i[i.eJSLT_DIALOG_STATIC_GUI_RETRIEVE = 12] = "eJSLT_DIALOG_STATIC_GUI_RETRIEVE", i))(_o || {}), Pe = /* @__PURE__ */ ((i) => (i[i.eOT_UNKNOWN = -1] = "eOT_UNKNOWN", i[i.eOT_MODEL = 0] = "eOT_MODEL", i[i.eOT_MODEL_ANTAGONIST = 1] = "eOT_MODEL_ANTAGONIST", i[i.eOT_CROWN = 2] = "eOT_CROWN", i[i.eOT_CROWN_BOTTOM = 3] = "eOT_CROWN_BOTTOM", i[i.eOT_MINIMAL_THICKNESS = 4] = "eOT_MINIMAL_THICKNESS", i[i.eOT_CROWN_MERGED = 5] = "eOT_CROWN_MERGED", i[i.eOT_CROWN_SHRINK = 6] = "eOT_CROWN_SHRINK", i[i.eOT_CROWN_SHRUNK = 7] = "eOT_CROWN_SHRUNK", i[i.eOT_BRIDGE_MERGED = 8] = "eOT_BRIDGE_MERGED", i[i.eOT_CROWN_PONTIC = 9] = "eOT_CROWN_PONTIC", i[i.eOT_CONNECTOR = 10] = "eOT_CONNECTOR", i[i.eOT_BRIDGE = 11] = "eOT_BRIDGE", i[i.eOT_WAXUP = 12] = "eOT_WAXUP", i[i.eOT_GENERIC = 13] = "eOT_GENERIC", i[i.eOT_MARKER = 14] = "eOT_MARKER", i[i.eOT_GINGIVA = 15] = "eOT_GINGIVA", i[i.eOT_ABUTMENT = 16] = "eOT_ABUTMENT", i[i.eOT_TIBASE = 17] = "eOT_TIBASE", i[i.eOT_SCREW = 18] = "eOT_SCREW", i[i.eOT_DENTURE = 19] = "eOT_DENTURE", i[i.eOT_DENTURE_BASE = 20] = "eOT_DENTURE_BASE", i[i.eOT_DENTURE_GINGIVA = 21] = "eOT_DENTURE_GINGIVA", i[i.eOT_IMPLANT = 22] = "eOT_IMPLANT", i[i.eOT_CROWN_CREATED = 23] = "eOT_CROWN_CREATED", i[i.eOT_ABUTMENT_CREATED = 24] = "eOT_ABUTMENT_CREATED", i[i.eOT_UNDERCUT = 25] = "eOT_UNDERCUT", i[i.eOT_UNDERCUT_TRAY = 26] = "eOT_UNDERCUT_TRAY", i[i.eOT_SURGICAL_GUIDE = 27] = "eOT_SURGICAL_GUIDE", i[i.eOT_TRAY = 28] = "eOT_TRAY", i[i.eOT_SURGICAL_GUIDE_CREATED = 29] = "eOT_SURGICAL_GUIDE_CREATED", i[i.eOT_PROSTHESIS = 30] = "eOT_PROSTHESIS", i[i.eOT_PROSTHESIS_SURGICAL_GUIDE = 31] = "eOT_PROSTHESIS_SURGICAL_GUIDE", i[i.eOT_PROSTHESIS_SURGICAL_GUIDE_CREATED = 32] = "eOT_PROSTHESIS_SURGICAL_GUIDE_CREATED", i[i.eOT_PIN = 33] = "eOT_PIN", i[i.eOT_PIN_SUPPORT = 34] = "eOT_PIN_SUPPORT", i[i.eOT_PIN_SLEEVE = 35] = "eOT_PIN_SLEEVE", i[i.eOT_PIN_ABUTMENT = 36] = "eOT_PIN_ABUTMENT", i[i.eOT_PIN_EXTRUSION_UPPER = 37] = "eOT_PIN_EXTRUSION_UPPER", i[i.eOT_PIN_EXTRUSION_LOWER = 38] = "eOT_PIN_EXTRUSION_LOWER", i[i.eOT_PIN_SECONDARY_SCAN_ABUTMENT = 39] = "eOT_PIN_SECONDARY_SCAN_ABUTMENT", i[i.eOT_PIN_SECONDARY_ABUTMENT = 40] = "eOT_PIN_SECONDARY_ABUTMENT", i[i.eOT_PIN_MODEL_ANALOG = 41] = "eOT_PIN_MODEL_ANALOG", i[i.eOT_PIN_SCAN_ABUTMENT = 42] = "eOT_PIN_SCAN_ABUTMENT", i[i.eOT_PIN_CENTER_LINE = 43] = "eOT_PIN_CENTER_LINE", i[i.eOT_TEXT = 44] = "eOT_TEXT", i[i.eOT_SEGMENTED_BONE = 45] = "eOT_SEGMENTED_BONE", i[i.eOT_SEGMENTED_TOOTH = 46] = "eOT_SEGMENTED_TOOTH", i[i.eOT_IP_MODEL = 47] = "eOT_IP_MODEL", i[i.eOT_IP_MODEL_ANTAGONIST = 48] = "eOT_IP_MODEL_ANTAGONIST", i[i.eOT_IP_WAXUP = 49] = "eOT_IP_WAXUP", i[i.eOT_IP_WAXUP_ANTAGONIST = 50] = "eOT_IP_WAXUP_ANTAGONIST", i[i.eOT_IP_IMPLANT = 51] = "eOT_IP_IMPLANT", i[i.eOT_IP_ABUTMENT = 52] = "eOT_IP_ABUTMENT", i[i.eOT_IP_SCAN_MARKER = 53] = "eOT_IP_SCAN_MARKER", i[i.eOT_PILLAR_PILLAR = 54] = "eOT_PILLAR_PILLAR", i[i.eOT_PILLAR_SLOT = 55] = "eOT_PILLAR_SLOT", i[i.eOT_BAR = 56] = "eOT_BAR", i[i.eOT_BLOCKOUT_MODEL = 57] = "eOT_BLOCKOUT_MODEL", i[i.eOT_BLOCKOUT_SURFACE = 58] = "eOT_BLOCKOUT_SURFACE", i[i.eOT_WAXUP_VOLUME = 59] = "eOT_WAXUP_VOLUME", i[i.eOT_WAXUP_RECONSTRUCTION = 60] = "eOT_WAXUP_RECONSTRUCTION", i[i.eOT_SPACER = 61] = "eOT_SPACER", i[i.eOT_EMERGENCY_PROFILE = 62] = "eOT_EMERGENCY_PROFILE", i[i.eOT_SCREW_ACCESS = 63] = "eOT_SCREW_ACCESS", i[i.eOT_IP_SECONDARY_ABUTMENT = 64] = "eOT_IP_SECONDARY_ABUTMENT", i[i.eOT_SUPPORT = 65] = "eOT_SUPPORT", i[i.eOT_SCAN_MARKER = 66] = "eOT_SCAN_MARKER", i[i.eOT_WAXUP_MERGED = 67] = "eOT_WAXUP_MERGED", i[i.eOT_ABUTMENT_SHRUNK = 68] = "eOT_ABUTMENT_SHRUNK", i[i.eOT_ABUTMENT_NOTCH = 69] = "eOT_ABUTMENT_NOTCH", i[i.eOT_IP_BOTTOM_EXTRUSION = 70] = "eOT_IP_BOTTOM_EXTRUSION", i[i.eOT_IP_TOP_EXTRUSION = 71] = "eOT_IP_TOP_EXTRUSION", i[i.eOT_IP_PIN_EXTRUSION = 72] = "eOT_IP_PIN_EXTRUSION", i[i.eOT_IP_ANALOG_EXTRUSION = 73] = "eOT_IP_ANALOG_EXTRUSION", i[i.eOT_ABUTMENT_WAXUP = 74] = "eOT_ABUTMENT_WAXUP", i[i.eOT_IP_TEETH_WAXUP = 75] = "eOT_IP_TEETH_WAXUP", i[i.eOT_WAXUP_SHRINK = 76] = "eOT_WAXUP_SHRINK", i[i.eOT_PILLARS = 77] = "eOT_PILLARS", i[i.eOT_IP_SECONDARY_SCAN_ABUTMENT = 78] = "eOT_IP_SECONDARY_SCAN_ABUTMENT", i[i.eOT_IP_SCAN_ABUTMENT = 79] = "eOT_IP_SCAN_ABUTMENT", i[i.eOT_DENTURE_MODEL = 80] = "eOT_DENTURE_MODEL", i[i.eOT_CROWN_REDUCED = 81] = "eOT_CROWN_REDUCED", i[i.eOT_BAR_ATTACHMENT = 82] = "eOT_BAR_ATTACHMENT", i[i.eOT_BAR_MERGED = 83] = "eOT_BAR_MERGED", i[i.eOT_SPACERS = 84] = "eOT_SPACERS", i[i.eOT_DENTAL_CURVE = 85] = "eOT_DENTAL_CURVE", i[i.eOT_CAVITY_BOTTOM = 86] = "eOT_CAVITY_BOTTOM", i[i.eOT_BONE_GRAFT = 87] = "eOT_BONE_GRAFT", i[i.eOT_LOCATOR = 88] = "eOT_LOCATOR", i[i.eOT_RETENTION = 89] = "eOT_RETENTION", i[i.eOT_RETENTION_SUPPORT = 90] = "eOT_RETENTION_SUPPORT", i[i.eOT_CAP = 91] = "eOT_CAP", i[i.eOT_CAP_SUPPORT = 92] = "eOT_CAP_SUPPORT", i[i.eOT_FACE_SCAN = 93] = "eOT_FACE_SCAN", i[i.eOT_PROTECTION_TOROID = 94] = "eOT_PROTECTION_TOROID", i[i.eOT_SEGMENTED_CROWN = 95] = "eOT_SEGMENTED_CROWN", i[i.eOT_IP_SLEEVE = 96] = "eOT_IP_SLEEVE", i[i.eOT_IP_MODEL_ANALOG = 97] = "eOT_IP_MODEL_ANALOG", i[i.eOT_IP_NERVE = 98] = "eOT_IP_NERVE", i[i.eOT_INTERFACE = 99] = "eOT_INTERFACE", i[i.eOT_SCREW_SEAT = 100] = "eOT_SCREW_SEAT", i[i.eOT_PARAMETRIC_SCREW_SEAT = 101] = "eOT_PARAMETRIC_SCREW_SEAT", i[i.eOT_TOOTH = 102] = "eOT_TOOTH", i[i.eOT_REGISTRATION_SOURCE = 103] = "eOT_REGISTRATION_SOURCE", i[i.eOT_OVERPRESS_BRIDGE_MERGED = 104] = "eOT_OVERPRESS_BRIDGE_MERGED", i[i.eOT_OVERPRESS_WAXUP_MERGED = 105] = "eOT_OVERPRESS_WAXUP_MERGED", i[i.eOT_THIMBLE = 106] = "eOT_THIMBLE", i[i.eOT_THIMBLE_MERGED = 107] = "eOT_THIMBLE_MERGED", i[i.eOT_SCREW_ACCESS_PROTECTION = 108] = "eOT_SCREW_ACCESS_PROTECTION", i[i.eOT_MERGED_CROWN_ROOT = 109] = "eOT_MERGED_CROWN_ROOT", i[i.eOT_ANGLE_MEASURE = 110] = "eOT_ANGLE_MEASURE", i[i.eOT_ANNOTATION_MEASURE = 111] = "eOT_ANNOTATION_MEASURE", i[i.eOT_DISTANCE_MEASURE = 112] = "eOT_DISTANCE_MEASURE", i[i.eOT_POLYGON_MEASURE = 113] = "eOT_POLYGON_MEASURE", i[i.eOT_UNDERCUT_CREATED = 114] = "eOT_UNDERCUT_CREATED", i[i.eOT_UNDERCUT_TRAY_CREATED = 115] = "eOT_UNDERCUT_TRAY_CREATED", i[i.eOT_BLOCKOUT_MODEL_MINIMAL_THICKNESS = 117] = "eOT_BLOCKOUT_MODEL_MINIMAL_THICKNESS", i[i.eOT_GINGIVA_MINIMAL_THICKNESS = 118] = "eOT_GINGIVA_MINIMAL_THICKNESS", i[i.eOT_WAXUP_SHRUNK = 119] = "eOT_WAXUP_SHRUNK", i[i.eOT_WAXUP_BOTTOM = 120] = "eOT_WAXUP_BOTTOM", i[i.eOT_WAXUP_MINIMAL_THICKNESS = 121] = "eOT_WAXUP_MINIMAL_THICKNESS", i[i.eOT_MODEL_WITH_ATTACHMENTS = 122] = "eOT_MODEL_WITH_ATTACHMENTS", i[i.eOT_STUMP_DIE = 123] = "eOT_STUMP_DIE", i[i.eOT_STUMP_DIE_REPLICA = 124] = "eOT_STUMP_DIE_REPLICA", i[i.eOT_ANALOG = 125] = "eOT_ANALOG", i[i.eOT_ANALOG_RETENTION = 126] = "eOT_ANALOG_RETENTION", i[i.eOT_TEXTURED_IMAGE = 127] = "eOT_TEXTURED_IMAGE", i[i.eOT_MODEL_ATTACHMENT = 128] = "eOT_MODEL_ATTACHMENT", i[i.eOT_ARTICULATOR_PLANE = 129] = "eOT_ARTICULATOR_PLANE", i[i.eOT_CNN_SEGMENTED_TOOTH = 130] = "eOT_CNN_SEGMENTED_TOOTH", i[i.eOT_GEOMETRIC_PRIMITIVE = 131] = "eOT_GEOMETRIC_PRIMITIVE", i[i.eOT_CUSTOM_BAR = 132] = "eOT_CUSTOM_BAR", i[i.eOT_TEXT_CREATED = 133] = "eOT_TEXT_CREATED", i[i.eOT_SLEEVE_INDEX_CREATED = 134] = "eOT_SLEEVE_INDEX_CREATED", i[i.eOT_LANDMARK_MEASURE = 140] = "eOT_LANDMARK_MEASURE", i[i.eOT_MOVEMENT_SCAN_MARKER = 141] = "eOT_MOVEMENT_SCAN_MARKER", i[i.eOT_MOVEMENT_MARKER = 142] = "eOT_MOVEMENT_MARKER", i[i.eOT_CONDYLE_LEFT_LANDMARK = 143] = "eOT_CONDYLE_LEFT_LANDMARK", i[i.eOT_CONDYLE_RIGHT_LANDMARK = 144] = "eOT_CONDYLE_RIGHT_LANDMARK", i[i.eOT_ORBITAL_LEFT_LANDMARK = 145] = "eOT_ORBITAL_LEFT_LANDMARK", i[i.eOT_ORBITAL_RIGHT_LANDMARK = 146] = "eOT_ORBITAL_RIGHT_LANDMARK", i[i.eOT_SN_A_LANDMARK = 147] = "eOT_SN_A_LANDMARK", i[i.eOT_BITE_SPLINT = 148] = "eOT_BITE_SPLINT", i[i.eOT_SCAN_MARKER_ANTAGONIST = 149] = "eOT_SCAN_MARKER_ANTAGONIST", i[i.eOT_GINGIVA_ANTAGONIST = 150] = "eOT_GINGIVA_ANTAGONIST", i[i.eOT_WAXUP_ANTAGONIST = 151] = "eOT_WAXUP_ANTAGONIST", i[i.eOT_MERGED_TEETH = 152] = "eOT_MERGED_TEETH", i[i.eOT_ATTACHMENT = 153] = "eOT_ATTACHMENT", i[i.eOT_HOUSING = 154] = "eOT_HOUSING", i[i.eOT_MATRIX = 155] = "eOT_MATRIX", i[i.eOT_UPPER_JAW = 156] = "eOT_UPPER_JAW", i[i.eOT_LOWER_JAW = 157] = "eOT_LOWER_JAW", i[i.eOT_UPPER_WAXUP = 158] = "eOT_UPPER_WAXUP", i[i.eOT_LOWER_WAXUP = 159] = "eOT_LOWER_WAXUP", i[i.eOT_UPPER_GINGIVA = 160] = "eOT_UPPER_GINGIVA", i[i.eOT_LOWER_GINGIVA = 161] = "eOT_LOWER_GINGIVA", i[i.eOT_UPPER_MARKER = 162] = "eOT_UPPER_MARKER", i[i.eOT_LOWER_MARKER = 163] = "eOT_LOWER_MARKER", i[i.eOT_WAXUP_SHRUNK_REDUCTION = 164] = "eOT_WAXUP_SHRUNK_REDUCTION", i[i.eOT_GENERATED_VOLUME = 165] = "eOT_GENERATED_VOLUME", i[i.eOT_CUSTOM_VOLUME_BAR = 166] = "eOT_CUSTOM_VOLUME_BAR", i[i.eOT_IP_UPPER_JAW = 167] = "eOT_IP_UPPER_JAW", i[i.eOT_IP_LOWER_JAW = 168] = "eOT_IP_LOWER_JAW", i[i.eOT_IP_UPPER_WAXUP = 169] = "eOT_IP_UPPER_WAXUP", i[i.eOT_IP_LOWER_WAXUP = 170] = "eOT_IP_LOWER_WAXUP", i[i.eOT_IP_UPPER_GINGIVA = 171] = "eOT_IP_UPPER_GINGIVA", i[i.eOT_IP_LOWER_GINGIVA = 172] = "eOT_IP_LOWER_GINGIVA", i[i.eOT_IP_UPPER_MARKER = 173] = "eOT_IP_UPPER_MARKER", i[i.eOT_IP_LOWER_MARKER = 174] = "eOT_IP_LOWER_MARKER", i[i.eOT_GINGIVA_SLOT = 175] = "eOT_GINGIVA_SLOT", i[i.eOT_LIBRARY_TOOTH = 176] = "eOT_LIBRARY_TOOTH", i[i.eOT_DENTURE_BASE_TOP = 177] = "eOT_DENTURE_BASE_TOP", i[i.eOT_DENTURE_BASE_BOTTOM = 178] = "eOT_DENTURE_BASE_BOTTOM", i[i.eOT_DENTURE_BASE_POCKETS = 179] = "eOT_DENTURE_BASE_POCKETS", i[i.eOT_DENTURE_BASE_CAPS = 180] = "eOT_DENTURE_BASE_CAPS", i[i.eOT_DETACHABLE_GINGIVA = 181] = "eOT_DETACHABLE_GINGIVA", i[i.eOT_DETACHABLE_GINGIVA_SLOT = 182] = "eOT_DETACHABLE_GINGIVA_SLOT", i[i.eOT_CONTOURING_VOLUME = 183] = "eOT_CONTOURING_VOLUME", i[i.eOT_TEXTURED_FRONT_IMAGE = 184] = "eOT_TEXTURED_FRONT_IMAGE", i[i.eOT_TEXTURED_TOP_IMAGE = 185] = "eOT_TEXTURED_TOP_IMAGE", i[i.eOT_TEXTURED_LEFT_IMAGE = 186] = "eOT_TEXTURED_LEFT_IMAGE", i[i.eOT_TEXTURED_RIGHT_IMAGE = 187] = "eOT_TEXTURED_RIGHT_IMAGE", i[i.eOT_IP_MOVEMENT_SCAN_MARKER = 188] = "eOT_IP_MOVEMENT_SCAN_MARKER", i[i.eOT_IP_FACE_SCAN = 189] = "eOT_IP_FACE_SCAN", i[i.eOT_IP_GENERIC = 190] = "eOT_IP_GENERIC", i[i.eOT_SMILE_DESIGN_HELPER_PRIMITIVE = 191] = "eOT_SMILE_DESIGN_HELPER_PRIMITIVE", i[i.eOT_PLANE_MEASURE = 192] = "eOT_PLANE_MEASURE", i[i.eOT_SPHERE_MEASURE = 193] = "eOT_SPHERE_MEASURE", i[i.eOT_TETRAHEDRON_MEASURE = 194] = "eOT_TETRAHEDRON_MEASURE", i[i.eOT_SURFACE_TO_VOLUME = 195] = "eOT_SURFACE_TO_VOLUME", i[i.eOT_ARTICULATOR_PART = 196] = "eOT_ARTICULATOR_PART", i[i.eOT_SEGMENTED_GINGIVA = 197] = "eOT_SEGMENTED_GINGIVA", i[i.eOT_GINGIVA_FIXATION = 198] = "eOT_GINGIVA_FIXATION", i[i.eOT_REFERENCE_PLANE = 199] = "eOT_REFERENCE_PLANE", i[i.eOT_IP_PIN = 200] = "eOT_IP_PIN", i[i.eOT_WAXUP_PROSTHESIS = 201] = "eOT_WAXUP_PROSTHESIS", i[i.eOT_BLOCKOUT_ANATOMY = 202] = "eOT_BLOCKOUT_ANATOMY", i[i.eOT_GUIDE = 203] = "eOT_GUIDE", i[i.eOT_PIN_GUIDE = 204] = "eOT_PIN_GUIDE", i[i.eOT_OSTEOTOMY_GUIDE = 205] = "eOT_OSTEOTOMY_GUIDE", i[i.eOT_PLATFORM = 206] = "eOT_PLATFORM", i[i.eOT_REDUCED_MODEL = 207] = "eOT_REDUCED_MODEL", i[i.eOT_CARRIER_GUIDE = 208] = "eOT_CARRIER_GUIDE", i[i.eOT_IMPLANT_AXIS = 209] = "eOT_IMPLANT_AXIS", i[i.eOT_ABUTMENT_AXIS = 210] = "eOT_ABUTMENT_AXIS", i[i.eOT_SLOTS = 211] = "eOT_SLOTS", i[i.eOT_LINE_MEASURE = 212] = "eOT_LINE_MEASURE", i[i.eOT_REFERENCE_LINE = 213] = "eOT_REFERENCE_LINE", i[i.eOT_SAFECUT_BASE_BONE = 214] = "eOT_SAFECUT_BASE_BONE", i[i.eOT_SAFECUT_GUIDE = 215] = "eOT_SAFECUT_GUIDE", i[i.eOT_RAPID_PROSTHESIS = 216] = "eOT_RAPID_PROSTHESIS", i[i.eOT_BONE_MODEL = 217] = "eOT_BONE_MODEL", i[i.eOT_BONE_PIECE = 218] = "eOT_BONE_PIECE", i[i.eOT_TOOTH_MODEL = 219] = "eOT_TOOTH_MODEL", i[i.eOT_SPLIT_BAR_WAXUP = 220] = "eOT_SPLIT_BAR_WAXUP", i[i.eOT_SPLIT_BAR_BOTTOM = 221] = "eOT_SPLIT_BAR_BOTTOM", i[i.eOT_SPLIT_BAR = 222] = "eOT_SPLIT_BAR", i[i.eOT_RAPID_PILLAR = 223] = "eOT_RAPID_PILLAR", i[i.eOT_BLOCKOUT_MODEL_OFFSET = 224] = "eOT_BLOCKOUT_MODEL_OFFSET", i[i.eOT_SCALLOP_GUIDE = 225] = "eOT_SCALLOP_GUIDE", i[i.eOT_PROSTHESIS_REINFORCEMENT_GUIDE = 226] = "eOT_PROSTHESIS_REINFORCEMENT_GUIDE", i[i.eOT_PROSTHESIS_REINFORCEMENT_OUTLINE = 227] = "eOT_PROSTHESIS_REINFORCEMENT_OUTLINE", i[i.eOT_LOWER_DENTURE_MODEL = 228] = "eOT_LOWER_DENTURE_MODEL", i[i.eOT_UPPER_DENTURE_MODEL = 229] = "eOT_UPPER_DENTURE_MODEL", i[i.eOT_IP_LOWER_DENTURE_MODEL = 230] = "eOT_IP_LOWER_DENTURE_MODEL", i[i.eOT_IP_UPPER_DENTURE_MODEL = 231] = "eOT_IP_UPPER_DENTURE_MODEL", i[i.eOT_DENTURE_ANTAGONIST = 232] = "eOT_DENTURE_ANTAGONIST", i[i.eOT_SLEEVE_INDEX = 233] = "eOT_SLEEVE_INDEX", i[i.eOT_BRG_PIN = 234] = "eOT_BRG_PIN", i[i.eOT_BRG_DOWEL_CENTER = 235] = "eOT_BRG_DOWEL_CENTER", i[i.eOT_BRG_DOWEL_OUTSIDE = 236] = "eOT_BRG_DOWEL_OUTSIDE", i[i.eOT_BONE_MODEL_ANATOMY = 237] = "eOT_BONE_MODEL_ANATOMY", i[i.eOT_ABUTMENT_INDEXES = 238] = "eOT_ABUTMENT_INDEXES", i[i.eOT_BONE_PROSTHESIS = 239] = "eOT_BONE_PROSTHESIS", i[i.eOT_SCAN_OVERVIEW = 240] = "eOT_SCAN_OVERVIEW", i[i.eOT_IP_SCAN_OVERVIEW = 241] = "eOT_IP_SCAN_OVERVIEW", i[i.eOT_BONE_GRID = 242] = "eOT_BONE_GRID", i[i.eOT_DENTURE_WALL = 243] = "eOT_DENTURE_WALL", i[i.eOT_ORTHOTIC_BITE = 244] = "eOT_ORTHOTIC_BITE", i[i.eOT_CROWN_CUT = 245] = "eOT_CROWN_CUT", i[i.eOT_PRIMARY_ABUTMENT = 246] = "eOT_PRIMARY_ABUTMENT", i[i.eOT_SECONDARY_ABUTMENT = 247] = "eOT_SECONDARY_ABUTMENT", i[i.eOT_PRIMARY_SCAN_ABUTMENT = 248] = "eOT_PRIMARY_SCAN_ABUTMENT", i[i.eOT_SECONDARY_SCAN_ABUTMENT = 249] = "eOT_SECONDARY_SCAN_ABUTMENT", i[i.eOT_IMPLANT_ANALOGUE = 250] = "eOT_IMPLANT_ANALOGUE", i[i.eOT_PREVIEW = 251] = "eOT_PREVIEW", i[i.eOT_IMPLANT_PREVIEW = 252] = "eOT_IMPLANT_PREVIEW", i[i.eOT_SLEEVE = 253] = "eOT_SLEEVE", i[i.eOT_SLEEVE_NEGATIVE = 254] = "eOT_SLEEVE_NEGATIVE", i))(Pe || {}), T3 = /* @__PURE__ */ ((i) => (i[i.eRD_NONE = -1] = "eRD_NONE", i[i.eRD_CROWN_BRIDGE = 0] = "eRD_CROWN_BRIDGE", i[i.eRD_DIGITAL_SMILE_DESIGN = 1] = "eRD_DIGITAL_SMILE_DESIGN", i[i.eRD_BAR = 2] = "eRD_BAR", i[i.eRD_PRE_OP = 3] = "eRD_PRE_OP", i[i.eRD_DENTURE = 4] = "eRD_DENTURE", i[i.eRD_IL_PROVISIONAL = 5] = "eRD_IL_PROVISIONAL", i[i.eRD_MODEL_BUILDER = 6] = "eRD_MODEL_BUILDER", i[i.eRD_MODEL_PRO = 7] = "eRD_MODEL_PRO", i[i.eRD_ORTHODONTIC_MODEL_BUILDER = 8] = "eRD_ORTHODONTIC_MODEL_BUILDER", i[i.eRD_SPLINTS = 9] = "eRD_SPLINTS", i[i.eRD_TMJ_DIAGNOSIS = 10] = "eRD_TMJ_DIAGNOSIS", i[i.eRD_INNOVA_IMPLANT_CHECK = 11] = "eRD_INNOVA_IMPLANT_CHECK", i[i.eRD_GUIDE = 12] = "eRD_GUIDE", i[i.eRD_ANALOGS_MODEL = 13] = "eRD_ANALOGS_MODEL", i[i.eRD_BONE_GRAFT = 14] = "eRD_BONE_GRAFT", i[i.eRD_BONE_GRID = 15] = "eRD_BONE_GRID", i[i.eRD_BONE_FROM_CT = 16] = "eRD_BONE_FROM_CT", i[i.eRD_TEETH_FROM_CT = 17] = "eRD_TEETH_FROM_CT", i[i.eRD_CROWNS_FROM_STL = 18] = "eRD_CROWNS_FROM_STL", i[i.eRD_ADVANCED_FEATURES = 19] = "eRD_ADVANCED_FEATURES", i))(T3 || {}), M3 = /* @__PURE__ */ ((i) => (i[i.eWF_NONE = -1] = "eWF_NONE", i[i.eWF_C_B_TEETH_LIBRARY = 0] = "eWF_C_B_TEETH_LIBRARY", i[i.eWF_C_B_WAXUP = 1] = "eWF_C_B_WAXUP", i[i.eWF_C_B_MANUAL_IMPLANT = 2] = "eWF_C_B_MANUAL_IMPLANT", i[i.eWF_C_B_MANUAL_IMPLANT_WAXUP = 3] = "eWF_C_B_MANUAL_IMPLANT_WAXUP", i[i.eWF_C_B_IMPLANT_LIBRARY = 4] = "eWF_C_B_IMPLANT_LIBRARY", i[i.eWF_C_B_IMPLANT_LIBRARY_WAXUP = 5] = "eWF_C_B_IMPLANT_LIBRARY_WAXUP", i[i.eWF_C_B_IMPLANT_LIBRARY_LOCATOR_WAXUP = 6] = "eWF_C_B_IMPLANT_LIBRARY_LOCATOR_WAXUP", i[i.eWF_C_B_IMPLANT_LIBRARY_IMPLANT_WAXUP = 7] = "eWF_C_B_IMPLANT_LIBRARY_IMPLANT_WAXUP", i[i.eWF_C_B_MOCKUP = 8] = "eWF_C_B_MOCKUP", i[i.eWF_C_B_DIGITAL_WAXUP = 9] = "eWF_C_B_DIGITAL_WAXUP", i[i.eWF_C_B_HYBRID = 10] = "eWF_C_B_HYBRID", i[i.eWF_C_B_HYBRID_WAXUP = 11] = "eWF_C_B_HYBRID_WAXUP", i[i.eWF_I_L_EGG_SHELL = 12] = "eWF_I_L_EGG_SHELL", i[i.eWF_I_L_EGG_SHELL_WAXUP = 13] = "eWF_I_L_EGG_SHELL_WAXUP", i[i.eWF_I_L_WAXUP = 14] = "eWF_I_L_WAXUP", i[i.eWF_BAR_MANUAL_IMPLANT = 15] = "eWF_BAR_MANUAL_IMPLANT", i[i.eWF_BAR_IMPLANT_LIBRARY = 16] = "eWF_BAR_IMPLANT_LIBRARY", i[i.eWF_I_O_TEETH_LIBRARY = 17] = "eWF_I_O_TEETH_LIBRARY", i[i.eWF_EGG_SHELL_PRE_OP = 18] = "eWF_EGG_SHELL_PRE_OP", i[i.eWF_THIMBLE_PRE_OP = 19] = "eWF_THIMBLE_PRE_OP", i[i.eWF_C_B_BELLAK_ABUTMENT = 20] = "eWF_C_B_BELLAK_ABUTMENT", i[i.eWF_SCANNED_STRUCTURE = 21] = "eWF_SCANNED_STRUCTURE", i[i.eWF_DENTURE_FROM_TEETH_LIBRARY = 22] = "eWF_DENTURE_FROM_TEETH_LIBRARY", i[i.eWF_DENTURE_FROM_COPY = 23] = "eWF_DENTURE_FROM_COPY", i[i.eWF_DENTURE_FROM_IMPORT = 24] = "eWF_DENTURE_FROM_IMPORT", i[i.eWF_INNOVA_I_C_FROM_DENTURE = 25] = "eWF_INNOVA_I_C_FROM_DENTURE", i[i.eWF_INNOVA_I_C_FROM_BRIDGE = 26] = "eWF_INNOVA_I_C_FROM_BRIDGE", i[i.eWF_INNOVA_I_C_COMPARE = 27] = "eWF_INNOVA_I_C_COMPARE", i[i.eWF_INNOVA_I_C_DIRECT = 28] = "eWF_INNOVA_I_C_DIRECT", i[i.eWF_TRY_IN_RX_GUIDE = 29] = "eWF_TRY_IN_RX_GUIDE", i[i.eWF_BITE_SPLINT = 30] = "eWF_BITE_SPLINT", i[i.eWF_ORTHOTIC_BITE = 31] = "eWF_ORTHOTIC_BITE", i[i.eWF_C_B_ENCODE_EVOLUTION = 32] = "eWF_C_B_ENCODE_EVOLUTION", i))(M3 || {}), N3 = /* @__PURE__ */ ((i) => (i[i.eNONE = -1] = "eNONE", i[i.eCREATE_WAXUP = 0] = "eCREATE_WAXUP", i[i.eTMJ_DIAGNOSIS = 1] = "eTMJ_DIAGNOSIS", i[i.eTRY_IN_RX_GUIDE = 2] = "eTRY_IN_RX_GUIDE", i[i.eDESIGN = 3] = "eDESIGN", i[i.eSEGMENTATION = 4] = "eSEGMENTATION", i))(N3 || {}), W3 = /* @__PURE__ */ ((i) => (i[i.eNONE = -1] = "eNONE", i[i.eSMILE_DESIGN = 0] = "eSMILE_DESIGN", i))(W3 || {}), Wn = /* @__PURE__ */ ((i) => (i[i.TOOL_NONE = 0] = "TOOL_NONE", i[i.TOOL_ADD = 1] = "TOOL_ADD", i[i.TOOL_REMOVE = 2] = "TOOL_REMOVE", i[i.TOOL_FILL = 3] = "TOOL_FILL", i[i.TOOL_SCRAPE = 4] = "TOOL_SCRAPE", i[i.TOOL_SMOOTH = 5] = "TOOL_SMOOTH", i[i.TOOL_RESHAPE = 6] = "TOOL_RESHAPE", i[i.TOOL_2D_PAINT = 7] = "TOOL_2D_PAINT", i[i.TOOL_2D_ERASE = 8] = "TOOL_2D_ERASE", i[i.TOOL_2D_BRUSH = 9] = "TOOL_2D_BRUSH", i[i.TOOL_CUT_BY_AREA = 10] = "TOOL_CUT_BY_AREA", i[i.TOOL_2D_DRAW = 11] = "TOOL_2D_DRAW", i))(Wn || {}), G3 = /* @__PURE__ */ ((i) => (i[i.eM_UNKNOWN = 0] = "eM_UNKNOWN", i[i.eM_SURGICAL_GUIDE = 1] = "eM_SURGICAL_GUIDE", i[i.eM_TRAY = 2] = "eM_TRAY", i[i.eM_RECONSTRUCTION = 3] = "eM_RECONSTRUCTION", i[i.eM_BONE_SEGMENTATION = 4] = "eM_BONE_SEGMENTATION", i[i.eM_TOOTH_SEGMENTATION = 5] = "eM_TOOTH_SEGMENTATION", i[i.eM_EDIT_STL = 6] = "eM_EDIT_STL", i[i.eM_MODEL = 7] = "eM_MODEL", i[i.eM_CROSS_SECTION = 8] = "eM_CROSS_SECTION", i[i.eM_EDIT_STL_ONLY = 9] = "eM_EDIT_STL_ONLY", i[i.eM_CROWN_SEGMENTATION = 10] = "eM_CROWN_SEGMENTATION", i[i.eM_STL_REGISTRATION = 11] = "eM_STL_REGISTRATION", i[i.eM_SANDBOX = 12] = "eM_SANDBOX", i[i.eM_EDIT_2D = 13] = "eM_EDIT_2D", i[i.eM_ARTICULATOR = 14] = "eM_ARTICULATOR", i[i.eM_MOVEMENT_MARKER = 15] = "eM_MOVEMENT_MARKER", i[i.eM_IP_SANDBOX_CONNECTORS = 16] = "eM_IP_SANDBOX_CONNECTORS", i[i.eM_SANDBOX_CONNECTORS = 17] = "eM_SANDBOX_CONNECTORS", i[i.eM_IP_SANDBOX_SPLITTING = 18] = "eM_IP_SANDBOX_SPLITTING", i[i.eM_SANDBOX_SPLITTING = 19] = "eM_SANDBOX_SPLITTING", i[i.eM_GEOMETRIC_PRIMITIVES = 20] = "eM_GEOMETRIC_PRIMITIVES", i[i.eM_CUSTOM_OBJECT = 21] = "eM_CUSTOM_OBJECT", i[i.eM_STL_MATCHING = 22] = "eM_STL_MATCHING", i[i.eM_IP_SMILE_DESIGN = 23] = "eM_IP_SMILE_DESIGN", i[i.eM_IP_TEETH_SETUP = 24] = "eM_IP_TEETH_SETUP", i[i.eM_PLUGINS = 25] = "eM_PLUGINS", i[i.eM_IP_ENCODE_DECODING = 26] = "eM_IP_ENCODE_DECODING", i[i.eM_CUSTOM_ORIENTATION = 27] = "eM_CUSTOM_ORIENTATION", i[i.eM_IP_TEETH_SETUP_DEMO = 28] = "eM_IP_TEETH_SETUP_DEMO", i[i.eM_BONE_GRAFT = 29] = "eM_BONE_GRAFT", i[i.eM_BONE_GRID = 30] = "eM_BONE_GRID", i[i.eM_IP_ENCODE_DECODING_ONLY = 31] = "eM_IP_ENCODE_DECODING_ONLY", i[i.eM_IP_TRY_IN_RX_GUIDE_ONLY = 32] = "eM_IP_TRY_IN_RX_GUIDE_ONLY", i[i.eM_STL_LIBRARY_EDITOR = 33] = "eM_STL_LIBRARY_EDITOR", i))(G3 || {}), w3 = /* @__PURE__ */ ((i) => (i[i.eIGNORE = 0] = "eIGNORE", i[i.eCHECK = 1] = "eCHECK", i[i.eDETECTED = 2] = "eDETECTED", i))(w3 || {}), US;
((i) => {
  ((t) => {
    t[t.e3DCF_SURGICAL_GUIDE = 0] = "e3DCF_SURGICAL_GUIDE", t[t.e3DCF_MODEL = 1] = "e3DCF_MODEL", t[t.e3DCF_STL_EDIT = 2] = "e3DCF_STL_EDIT", t[t.e3DCF_TEETH_SETUP = 3] = "e3DCF_TEETH_SETUP";
  })(i.TItem3DCollectionFilter || (i.TItem3DCollectionFilter = {}));
})(US || (US = {}));
var x3 = /* @__PURE__ */ ((i) => (i[i.eMODEL = 0] = "eMODEL", i[i.eANTAGONIST = 1] = "eANTAGONIST", i[i.eGINGIVA = 2] = "eGINGIVA", i[i.eGINGIVA_ANTAGONIST = 3] = "eGINGIVA_ANTAGONIST", i[i.eWAXUP = 4] = "eWAXUP", i[i.eWAXUP_ANTAGONIST = 5] = "eWAXUP_ANTAGONIST", i[i.eMARKER = 6] = "eMARKER", i[i.eMARKER_ANTAGONIST = 7] = "eMARKER_ANTAGONIST", i[i.eDENTURE = 8] = "eDENTURE", i[i.eDENTURE_ANTAGONIST = 9] = "eDENTURE_ANTAGONIST", i[i.eMOVEMENT_MARKER = 10] = "eMOVEMENT_MARKER", i[i.eFACE_SCAN = 11] = "eFACE_SCAN", i[i.eGENERIC_UPPER = 12] = "eGENERIC_UPPER", i[i.eGENERIC_LOWER = 13] = "eGENERIC_LOWER", i))(x3 || {});
const qR = 2e3;
function S3(i) {
  var t;
  const e = "worker sent an error!";
  let n = i;
  if (i.includes(e)) {
    const s = (t = i.match(/((?:Uncaught\s+)?(?:RuntimeError|RangeError|TypeError|ReferenceError|Error): .*)$/)) == null ? void 0 : t[1];
    n = `${e} ${s ?? "WASM worker error"}`;
  }
  return n.length > qR ? `${n.slice(0, qR)}...` : n;
}
class L3 {
  constructor(t = "") {
    hr(this, "mainScriptUrlOrBlob"), hr(this, "basePath"), this.basePath = t, this.mainScriptUrlOrBlob = this.locateFile("WCE.0.4.85.df30bafc148b.js");
  }
  normalizePath(t) {
    return t.replaceAll("//", "/");
  }
  onAbort(t) {
    alert("Oops! The app encountered an internal error and had to stop. Please refresh the page or contact the support. Error 0"), console.log(t);
  }
  onExit(t) {
    console.log("onExit code", t);
  }
  printErr(t) {
    const e = S3(t);
    if (t.includes("Aborted(OOM)")) {
      alert("The app ran out of memory and had to stop. Please use Google Chrome for best performance."), console.error(e), window.location.reload();
      return;
    } else t.includes("Terminating...") ? alert("Oops! The app encountered an internal error and had to stop. Please refresh the page or contact the support. Error 1") : t.includes("val accessed from wrong thread") ? alert("Oops! The app encountered an internal error and had to stop. Please refresh the page or contact the support. Error 2") : /memory access out of bounds/i.test(t) ? alert("Oops! The app encountered an internal error and had to stop. Please refresh the page or contact the support. Memory Error 3") : /Pthread .* sent an error/i.test(t) ? alert("Oops! The app encountered an internal error and had to stop. Please refresh the page or contact the support. Error 4") : t.includes("user callback triggered after runtime exited or application aborted. Ignoring") ? alert("Oops! The app encountered an internal error and had to stop. Please refresh the page or contact the support. Error 5") : t.includes("worker sent an error!") && alert("Oops! The app encountered an internal error and had to stop. Please refresh the page or contact the support. Error 6");
    console.error(e);
  }
  onRuntimeInitialized() {
    console.debug("WASM Runtime initialized");
  }
  print(t) {
    console.log(t);
  }
  locateFile(t) {
    return this.normalizePath(`${this.basePath}/${t}`);
  }
}
class V3 {
  constructor(t) {
    hr(this, "engineModule"), this.engineModule = s8(t);
  }
}
const r8 = "Release_wasm64", a8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FreeformToolType: Wn,
  IEngineGenerated: p3,
  TCADObjectType: Pe,
  TFilterMode: Xa,
  TFilterType: m3,
  TGradientDirection: b3,
  TImageType: f3,
  get TItem3DCollectionFilter() {
    return US;
  },
  TJSLambdaType: _o,
  TMode: G3,
  TObjectType: g3,
  TPropType: Mr,
  TReconstructionDesign: T3,
  TReconstructionPreSelectedMode: N3,
  TReconstructionPreSelectedWorkflow: W3,
  TReconstructionWorkflow: M3,
  TShowImportCheckNanWarning: w3,
  TSortType: y3,
  TSubscribtionMode: Z3,
  WASM_BUILD_TYPE: r8,
  WCEModule: L3,
  WCEngine: V3,
  eOType: x3,
  sanitizeWasmErrorMessage: S3
}, Symbol.toStringTag, { value: "Module" }));
class X3 {
  constructor(t) {
    S(this, "stlActor");
    S(this, "curveActors");
    S(this, "axisActors");
    S(this, "boundingBoxActor");
    S(this, "coordinateSystemActors");
    S(this, "model");
    this.stlActor = t.stlActor, this.curveActors = t.curveActors, this.axisActors = t.axisActors, this.boundingBoxActor = t.boundingBoxActor, this.coordinateSystemActors = t.coordinateSystemActors, this.model = t.model;
    const e = (n) => {
      const s = n.map((r) => r / 255);
      this.stlActor.getProperty().setColor(s);
    };
    this.model.visibility.subscribe((n) => {
      var s;
      this.stlActor.setVisibility(n), this.curveActors.forEach((r) => {
        r.setVisibility(n);
      }), this.axisActors.forEach((r) => {
        r.setVisibility(n);
      }), (s = this.boundingBoxActor) == null || s.setVisibility(n && this.model.boundingBoxVisibility.get()), this.coordinateSystemActors.forEach((r) => {
        r.setVisibility(n && this.model.coordinateSystemVisibility.get());
      });
    }), this.model.stlColor.subscribe(e), this.model.stlOpacity.subscribe((n) => {
      var s;
      this.stlActor.getProperty().setOpacity(n), this.curveActors.forEach((r) => {
        r.getProperty().setOpacity(n);
      }), this.axisActors.forEach((r) => {
        r.getProperty().setOpacity(n);
      }), (s = this.boundingBoxActor) == null || s.getProperty().setOpacity(n), this.coordinateSystemActors.forEach((r) => {
        r.getProperty().setOpacity(n);
      });
    }), this.model.boundingBoxVisibility.subscribe((n) => {
      var s;
      (s = this.boundingBoxActor) == null || s.setVisibility(this.model.visibility.get() && n);
    }), this.model.coordinateSystemVisibility.subscribe((n) => {
      this.coordinateSystemActors.forEach((s) => {
        s.setVisibility(this.model.visibility.get() && n);
      });
    });
  }
  getStlActor() {
    return this.stlActor;
  }
  getActors() {
    return [this.stlActor, ...this.curveActors, ...this.axisActors, this.boundingBoxActor, ...this.coordinateSystemActors].filter((t) => t !== null);
  }
}
var Mo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function qi(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
function Ps(i) {
  if (i.__esModule) return i;
  var t = i.default;
  if (typeof t == "function") {
    var e = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    e.prototype = t.prototype;
  } else e = {};
  return Object.defineProperty(e, "__esModule", { value: !0 }), Object.keys(i).forEach(function(n) {
    var s = Object.getOwnPropertyDescriptor(i, n);
    Object.defineProperty(e, n, s.get ? s : {
      enumerable: !0,
      get: function() {
        return i[n];
      }
    });
  }), e;
}
var o8 = function i(t, e) {
  if (t === e) return !0;
  if (t && e && typeof t == "object" && typeof e == "object") {
    if (t.constructor !== e.constructor) return !1;
    var n, s, r;
    if (Array.isArray(t)) {
      if (n = t.length, n != e.length) return !1;
      for (s = n; s-- !== 0; )
        if (!i(t[s], e[s])) return !1;
      return !0;
    }
    if (t.constructor === RegExp) return t.source === e.source && t.flags === e.flags;
    if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === e.valueOf();
    if (t.toString !== Object.prototype.toString) return t.toString() === e.toString();
    if (r = Object.keys(t), n = r.length, n !== Object.keys(e).length) return !1;
    for (s = n; s-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(e, r[s])) return !1;
    for (s = n; s-- !== 0; ) {
      var a = r[s];
      if (!i(t[a], e[a])) return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
};
const I3 = /* @__PURE__ */ qi(o8);
var tD = Object.prototype.toString, C3 = function(t) {
  var e = tD.call(t), n = e === "[object Arguments]";
  return n || (n = e !== "[object Array]" && t !== null && typeof t == "object" && typeof t.length == "number" && t.length >= 0 && tD.call(t.callee) === "[object Function]"), n;
};
const l8 = /* @__PURE__ */ qi(C3), c8 = /* @__PURE__ */ Us({
  __proto__: null,
  default: l8
}, [C3]), Y3 = /* @__PURE__ */ Ps(c8);
var Mx, eD;
function u8() {
  if (eD) return Mx;
  eD = 1;
  var i;
  if (!Object.keys) {
    var t = Object.prototype.hasOwnProperty, e = Object.prototype.toString, n = Y3, s = Object.prototype.propertyIsEnumerable, r = !s.call({ toString: null }, "toString"), a = s.call(function() {
    }, "prototype"), o = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], l = function(h) {
      var p = h.constructor;
      return p && p.prototype === h;
    }, c = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, u = (function() {
      if (typeof window > "u")
        return !1;
      for (var h in window)
        try {
          if (!c["$" + h] && t.call(window, h) && window[h] !== null && typeof window[h] == "object")
            try {
              l(window[h]);
            } catch {
              return !0;
            }
        } catch {
          return !0;
        }
      return !1;
    })(), d = function(h) {
      if (typeof window > "u" || !u)
        return l(h);
      try {
        return l(h);
      } catch {
        return !1;
      }
    };
    i = function(p) {
      var m = p !== null && typeof p == "object", b = e.call(p) === "[object Function]", y = n(p), Z = m && e.call(p) === "[object String]", g = [];
      if (!m && !b && !y)
        throw new TypeError("Object.keys called on a non-object");
      var f = a && b;
      if (Z && p.length > 0 && !t.call(p, 0))
        for (var T = 0; T < p.length; ++T)
          g.push(String(T));
      if (y && p.length > 0)
        for (var M = 0; M < p.length; ++M)
          g.push(String(M));
      else
        for (var N in p)
          !(f && N === "prototype") && t.call(p, N) && g.push(String(N));
      if (r)
        for (var W = d(p), x = 0; x < o.length; ++x)
          !(W && o[x] === "constructor") && t.call(p, o[x]) && g.push(o[x]);
      return g;
    };
  }
  return Mx = i, Mx;
}
var d8 = Array.prototype.slice, h8 = Y3, nD = Object.keys, _M = nD ? function(t) {
  return nD(t);
} : u8(), iD = Object.keys;
_M.shim = function() {
  if (Object.keys) {
    var t = (function() {
      var e = Object.keys(arguments);
      return e && e.length === arguments.length;
    })(1, 2);
    t || (Object.keys = function(n) {
      return h8(n) ? iD(d8.call(n)) : iD(n);
    });
  } else
    Object.keys = _M;
  return Object.keys || _M;
};
var v3 = _M;
const p8 = /* @__PURE__ */ qi(v3), m8 = /* @__PURE__ */ Us({
  __proto__: null,
  default: p8
}, [v3]), b8 = /* @__PURE__ */ Ps(m8);
var QM = Object.defineProperty || !1;
if (QM)
  try {
    QM({}, "a", { value: 1 });
  } catch {
    QM = !1;
  }
var R3 = QM;
const f8 = /* @__PURE__ */ qi(R3), g8 = /* @__PURE__ */ Us({
  __proto__: null,
  default: f8
}, [R3]), D3 = /* @__PURE__ */ Ps(g8);
var O3 = SyntaxError;
const y8 = /* @__PURE__ */ qi(O3), Z8 = /* @__PURE__ */ Us({
  __proto__: null,
  default: y8
}, [O3]), T8 = /* @__PURE__ */ Ps(Z8);
var z3 = TypeError;
const M8 = /* @__PURE__ */ qi(z3), N8 = /* @__PURE__ */ Us({
  __proto__: null,
  default: M8
}, [z3]), W8 = /* @__PURE__ */ Ps(N8);
var E3 = Object.getOwnPropertyDescriptor;
const G8 = /* @__PURE__ */ qi(E3), w8 = /* @__PURE__ */ Us({
  __proto__: null,
  default: G8
}, [E3]), x8 = /* @__PURE__ */ Ps(w8);
var $M = x8;
if ($M)
  try {
    $M([], "length");
  } catch {
    $M = null;
  }
var k3 = $M;
const S8 = /* @__PURE__ */ qi(k3), L8 = /* @__PURE__ */ Us({
  __proto__: null,
  default: S8
}, [k3]), V8 = /* @__PURE__ */ Ps(L8);
var sD = D3, X8 = T8, H0 = W8, rD = V8, F3 = function(t, e, n) {
  if (!t || typeof t != "object" && typeof t != "function")
    throw new H0("`obj` must be an object or a function`");
  if (typeof e != "string" && typeof e != "symbol")
    throw new H0("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new H0("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new H0("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new H0("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new H0("`loose`, if provided, must be a boolean");
  var s = arguments.length > 3 ? arguments[3] : null, r = arguments.length > 4 ? arguments[4] : null, a = arguments.length > 5 ? arguments[5] : null, o = arguments.length > 6 ? arguments[6] : !1, l = !!rD && rD(t, e);
  if (sD)
    sD(t, e, {
      configurable: a === null && l ? l.configurable : !a,
      enumerable: s === null && l ? l.enumerable : !s,
      value: n,
      writable: r === null && l ? l.writable : !r
    });
  else if (o || !s && !r && !a)
    t[e] = n;
  else
    throw new X8("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};
const I8 = /* @__PURE__ */ qi(F3), C8 = /* @__PURE__ */ Us({
  __proto__: null,
  default: I8
}, [F3]), Y8 = /* @__PURE__ */ Ps(C8);
var PS = D3, j3 = function() {
  return !!PS;
};
j3.hasArrayLengthDefineBug = function() {
  if (!PS)
    return null;
  try {
    return PS([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var U3 = j3;
const v8 = /* @__PURE__ */ qi(U3), R8 = /* @__PURE__ */ Us({
  __proto__: null,
  default: v8
}, [U3]), D8 = /* @__PURE__ */ Ps(R8);
var O8 = b8, z8 = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", E8 = Object.prototype.toString, k8 = Array.prototype.concat, aD = Y8, F8 = function(i) {
  return typeof i == "function" && E8.call(i) === "[object Function]";
}, P3 = D8(), j8 = function(i, t, e, n) {
  if (t in i) {
    if (n === !0) {
      if (i[t] === e)
        return;
    } else if (!F8(n) || !n())
      return;
  }
  P3 ? aD(i, t, e, !0) : aD(i, t, e);
}, J3 = function(i, t) {
  var e = arguments.length > 2 ? arguments[2] : {}, n = O8(t);
  z8 && (n = k8.call(n, Object.getOwnPropertySymbols(t)));
  for (var s = 0; s < n.length; s += 1)
    j8(i, n[s], t[n[s]], e[n[s]]);
};
J3.supportsDescriptors = !!P3;
var A3 = J3;
const U8 = /* @__PURE__ */ qi(A3), P8 = /* @__PURE__ */ Us({
  __proto__: null,
  default: U8
}, [A3]), B3 = /* @__PURE__ */ Ps(P8);
var qM = { exports: {} };
typeof self < "u" ? qM.exports = self : typeof window < "u" ? qM.exports = window : qM.exports = Function("return this")();
var K3 = qM.exports;
const J8 = /* @__PURE__ */ qi(K3), A8 = /* @__PURE__ */ Us({
  __proto__: null,
  default: J8
}, [K3]), H3 = /* @__PURE__ */ Ps(A8);
var B8 = H3, _3 = function() {
  return typeof Mo != "object" || !Mo || Mo.Math !== Math || Mo.Array !== Array ? B8 : Mo;
};
const K8 = /* @__PURE__ */ qi(_3), H8 = /* @__PURE__ */ Us({
  __proto__: null,
  default: K8
}, [_3]), Q3 = /* @__PURE__ */ Ps(H8);
var _8 = B3, Q8 = Q3, $3 = function() {
  var t = Q8();
  if (_8.supportsDescriptors) {
    var e = Object.getOwnPropertyDescriptor(t, "globalThis");
    (!e || e.configurable && (e.enumerable || !e.writable || globalThis !== t)) && Object.defineProperty(t, "globalThis", {
      configurable: !0,
      enumerable: !1,
      value: t,
      writable: !0
    });
  } else (typeof globalThis != "object" || globalThis !== t) && (t.globalThis = t);
  return t;
};
const $8 = /* @__PURE__ */ qi($3), q8 = /* @__PURE__ */ Us({
  __proto__: null,
  default: $8
}, [$3]), t6 = /* @__PURE__ */ Ps(q8);
var e6 = B3, n6 = H3, q3 = Q3, i6 = t6, s6 = q3(), tk = function() {
  return s6;
};
e6(tk, {
  getPolyfill: q3,
  implementation: n6,
  shim: i6
});
var r6 = tk;
const a6 = /* @__PURE__ */ qi(r6), Il = a6(), ek = {
  vtkObject: () => null
};
function Dl(i) {
  if (i == null || i.isA)
    return i;
  if (!i.vtkClass)
    return Il.console && Il.console.error && Il.console.error("Invalid VTK object"), null;
  const t = ek[i.vtkClass];
  if (!t)
    return Il.console && Il.console.error && Il.console.error(`No vtk class found for Object of type ${i.vtkClass}`), null;
  const e = {
    ...i
  };
  Object.keys(e).forEach((s) => {
    e[s] && typeof e[s] == "object" && e[s].vtkClass && (e[s] = Dl(e[s]));
  });
  const n = t(e);
  return n && n.modified && n.modified(), n;
}
function o6(i, t) {
  ek[i] = t;
}
Dl.register = o6;
class Nx extends Array {
  push() {
    for (let t = 0; t < arguments.length; t++)
      this.includes(arguments[t]) || super.push(arguments[t]);
    return this.length;
  }
}
let JS = 0;
const nk = Symbol("void");
function l6() {
  return JS;
}
const ik = {};
function Cp() {
}
const c6 = ["log", "debug", "info", "warn", "error", "time", "timeEnd", "group", "groupEnd"];
c6.forEach((i) => {
  ik[i] = Cp;
});
Il.console = console.hasOwnProperty("log") ? console : ik;
const Ah = {
  debug: Cp,
  // Don't print debug by default
  error: Il.console.error || Cp,
  info: Il.console.info || Cp,
  log: Il.console.log || Cp,
  warn: Il.console.warn || Cp
};
function sk(i, t) {
  Ah[i] && (Ah[i] = t || Cp);
}
function rk() {
  Ah.log(...arguments);
}
function ak() {
  Ah.info(...arguments);
}
function iW() {
  Ah.debug(...arguments);
}
function Zn() {
  Ah.error(...arguments);
}
function SG() {
  Ah.warn(...arguments);
}
const oD = {};
function ok(i) {
  oD[i] || (Ah.error(i), oD[i] = !0);
}
const sa = /* @__PURE__ */ Object.create(null);
sa.Float32Array = Float32Array;
sa.Float64Array = Float64Array;
sa.Uint8Array = Uint8Array;
sa.Int8Array = Int8Array;
sa.Uint16Array = Uint16Array;
sa.Int16Array = Int16Array;
sa.Uint32Array = Uint32Array;
sa.Int32Array = Int32Array;
sa.Uint8ClampedArray = Uint8ClampedArray;
try {
  sa.BigInt64Array = BigInt64Array, sa.BigUint64Array = BigUint64Array;
} catch {
}
function xg(i) {
  for (var t = arguments.length, e = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    e[n - 1] = arguments[n];
  return new (sa[i] || Float64Array)(...e);
}
function LG(i) {
  for (var t = arguments.length, e = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    e[n - 1] = arguments[n];
  return (sa[i] || Float64Array).from(...e);
}
function VG(i) {
  return i.charAt(0).toUpperCase() + i.slice(1);
}
function fs(i) {
  return VG(i[0] === "_" ? i.slice(1) : i);
}
function lk(i) {
  return i.charAt(0).toLowerCase() + i.slice(1);
}
function ck(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e3;
  const n = ["TB", "GB", "MB", "KB"];
  let s = Number(i), r = "B";
  for (; s > e; )
    s /= e, r = n.pop();
  return `${s.toFixed(t)} ${r}`;
}
function uk(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " ";
  const e = [];
  let n = i;
  for (; n > 1e3; )
    e.push(`000${n % 1e3}`.slice(-3)), n = Math.floor(n / 1e3);
  return n > 0 && e.push(n), e.reverse(), e.join(t);
}
function dk(i) {
  Object.keys(i).forEach((t) => {
    Array.isArray(i[t]) && (i[t] = [].concat(i[t]));
  });
}
function u6(i) {
  return Object.values(sa).some((t) => i instanceof t);
}
function d6(i, t) {
  if (i === t)
    return !0;
  if (Array.isArray(i) && Array.isArray(t)) {
    if (i.length !== t.length)
      return !1;
    for (let e = 0; e < i.length; e++)
      if (i[e] !== t[e])
        return !1;
    return !0;
  }
  return !1;
}
function h6(i, t) {
  return Object.keys(i).find((e) => i[e] === t);
}
function hk(i) {
  return i && i.isA ? i.getState() : i;
}
function BX(i) {
  setTimeout(i, 0);
}
function pk(i, t) {
  const e = performance.now();
  i.finally(() => {
    const n = performance.now() - e;
    t(n);
  });
}
function xi() {
  let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  dk(t);
  const e = [];
  if (Number.isInteger(t.mtime) || (t.mtime = ++JS), !("classHierarchy" in t))
    t.classHierarchy = new Nx("vtkObject");
  else if (!(t.classHierarchy instanceof Nx)) {
    const r = new Nx();
    for (let a = 0; a < t.classHierarchy.length; a++)
      r.push(t.classHierarchy[a]);
    t.classHierarchy = r;
  }
  function n(r) {
    e[r] = null;
  }
  function s(r) {
    function a() {
      n(r);
    }
    return Object.freeze({
      unsubscribe: a
    });
  }
  return i.isDeleted = () => !!t.deleted, i.modified = (r) => {
    if (t.deleted) {
      Zn("instance deleted - cannot call any method");
      return;
    }
    r && r < i.getMTime() || (t.mtime = ++JS, e.forEach((a) => a && a(i)));
  }, i.onModified = (r) => {
    if (t.deleted)
      return Zn("instance deleted - cannot call any method"), null;
    const a = e.length;
    return e.push(r), s(a);
  }, i.getMTime = () => t.mtime, i.isA = (r) => {
    let a = t.classHierarchy.length;
    for (; a--; )
      if (t.classHierarchy[a] === r)
        return !0;
    return !1;
  }, i.getClassName = function() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t.classHierarchy[t.classHierarchy.length - 1 - r];
  }, i.set = function() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, l = !1;
    return Object.keys(r).forEach((c) => {
      const u = o ? null : i[`set${VG(c)}`];
      u && Array.isArray(r[c]) && u.length > 1 ? l = u(...r[c]) || l : u ? l = u(r[c]) || l : (["mtime"].indexOf(c) === -1 && !a && SG(`Warning: Set value to model directly ${c}, ${r[c]}`), l = t[c] !== r[c] || l, t[c] = r[c]);
    }), l;
  }, i.get = function() {
    for (var r = arguments.length, a = new Array(r), o = 0; o < r; o++)
      a[o] = arguments[o];
    if (!a.length)
      return t;
    const l = {};
    return a.forEach((c) => {
      l[c] = t[c];
    }), l;
  }, i.getReferenceByName = (r) => t[r], i.delete = () => {
    Object.keys(t).forEach((r) => delete t[r]), e.forEach((r, a) => n(a)), t.deleted = !0;
  }, i.getState = () => {
    if (t.deleted)
      return null;
    const r = {
      ...t,
      vtkClass: i.getClassName()
    };
    Object.keys(r).forEach((o) => {
      r[o] === null || r[o] === void 0 || o[0] === "_" ? delete r[o] : r[o].isA ? r[o] = r[o].getState() : Array.isArray(r[o]) ? r[o] = r[o].map(hk) : u6(r[o]) && (r[o] = Array.from(r[o]));
    });
    const a = {};
    return Object.keys(r).sort().forEach((o) => {
      a[o] = r[o];
    }), a.mtime && delete a.mtime, a;
  }, i.shallowCopy = function(r) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (r.getClassName() !== i.getClassName())
      throw new Error(`Cannot ShallowCopy ${r.getClassName()} into ${i.getClassName()}`);
    const o = r.get(), l = Object.keys(t).sort();
    Object.keys(o).sort().forEach((u) => {
      const d = l.indexOf(u);
      d === -1 ? a && iW(`add ${u} in shallowCopy`) : l.splice(d, 1), t[u] = o[u];
    }), l.length && a && iW(`Untouched keys: ${l.join(", ")}`), i.modified();
  }, i.toJSON = function() {
    return i.getState();
  }, i;
}
const p6 = {
  object(i, t, e) {
    return function() {
      return {
        ...t[e.name]
      };
    };
  }
};
function Sa(i, t, e) {
  e.forEach((n) => {
    if (typeof n == "object") {
      const s = p6[n.type];
      s ? i[`get${fs(n.name)}`] = s(i, t, n) : i[`get${fs(n.name)}`] = () => t[n.name];
    } else
      i[`get${fs(n)}`] = () => t[n];
  });
}
const m6 = {
  enum(i, t, e) {
    const n = `_on${fs(e.name)}Changed`;
    return (s) => {
      var r;
      if (typeof s == "string") {
        if (e.enum[s] !== void 0)
          return t[e.name] !== e.enum[s] ? (t[e.name] = e.enum[s], i.modified(), !0) : !1;
        throw Zn(`Set Enum with invalid argument ${e}, ${s}`), new RangeError("Set Enum with invalid string argument");
      }
      if (typeof s == "number") {
        if (t[e.name] !== s) {
          if (Object.keys(e.enum).map((a) => e.enum[a]).indexOf(s) !== -1) {
            const a = t[e.name];
            return t[e.name] = s, (r = t[n]) == null || r.call(t, i, t, s, a), i.modified(), !0;
          }
          throw Zn(`Set Enum outside numeric range ${e}, ${s}`), new RangeError("Set Enum outside numeric range");
        }
        return !1;
      }
      throw Zn(`Set Enum with invalid argument (String/Number) ${e}, ${s}`), new TypeError("Set Enum with invalid argument (String/Number)");
    };
  },
  object(i, t, e) {
    const n = `_on${fs(e.name)}Changed`;
    return (s) => {
      var r;
      if (!I3(t[e.name], s)) {
        const a = t[e.name];
        return t[e.name] = s, (r = t[n]) == null || r.call(t, i, t, s, a), i.modified(), !0;
      }
      return !1;
    };
  }
};
function lD(i) {
  if (typeof i == "object") {
    const t = m6[i.type];
    if (t)
      return (e, n) => t(e, n, i);
    throw Zn(`No setter for field ${i}`), new TypeError("No setter for field");
  }
  return function(e, n) {
    const s = `_on${fs(i)}Changed`;
    return function(a) {
      var o;
      if (n.deleted)
        return Zn("instance deleted - cannot call any method"), !1;
      if (n[i] !== a) {
        const l = n[i.name];
        return n[i] = a, (o = n[s]) == null || o.call(n, e, n, a, l), e.modified(), !0;
      }
      return !1;
    };
  };
}
function GT(i, t, e) {
  e.forEach((n) => {
    typeof n == "object" ? i[`set${fs(n.name)}`] = lD(n)(i, t) : i[`set${fs(n)}`] = lD(n)(i, t);
  });
}
function gs(i, t, e) {
  Sa(i, t, e), GT(i, t, e);
}
function Sg(i, t, e) {
  e.forEach((n) => {
    i[`get${fs(n)}`] = () => t[n] ? Array.from(t[n]) : t[n], i[`get${fs(n)}ByReference`] = () => t[n];
  });
}
function KX(i, t, e, n) {
  let s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : void 0;
  e.forEach((r) => {
    if (t[r] && n && t[r].length !== n)
      throw new RangeError(`Invalid initial number of values for array (${r})`);
    const a = `_on${fs(r)}Changed`;
    i[`set${fs(r)}`] = function() {
      var p;
      if (t.deleted)
        return Zn("instance deleted - cannot call any method"), !1;
      for (var o = arguments.length, l = new Array(o), c = 0; c < o; c++)
        l[c] = arguments[c];
      let u = l, d, h = !1;
      if (u.length === 1 && (u[0] == null || u[0].length >= 0) && (u = u[0], h = !0), u == null)
        d = t[r] !== u;
      else {
        if (n && u.length !== n)
          if (u.length < n && s !== void 0)
            for (u = Array.from(u), h = !1; u.length < n; ) u.push(s);
          else
            throw new RangeError(`Invalid number of values for array setter (${r})`);
        d = t[r] == null || t[r].length !== u.length;
        for (let m = 0; !d && m < u.length; ++m)
          d = t[r][m] !== u[m];
        d && h && (u = Array.from(u));
      }
      if (d) {
        const m = t[r.name];
        t[r] = u, (p = t[a]) == null || p.call(t, i, t, u, m), i.modified();
      }
      return d;
    }, i[`set${fs(r)}From`] = (o) => {
      const l = t[r];
      o.forEach((c, u) => {
        l[u] = c;
      });
    };
  });
}
function HX(i, t, e, n) {
  let s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : void 0;
  Sg(i, t, e), KX(i, t, e, n, s);
}
function wT(i, t, e) {
  for (let n = 0; n < e.length; n++) {
    const s = e[n];
    t[s] !== void 0 && (t[`_${s}`] = t[s], delete t[s]);
  }
}
function _X(i, t, e, n) {
  t.inputData ? t.inputData = t.inputData.map(Dl) : t.inputData = [], t.inputConnection ? t.inputConnection = t.inputConnection.map(Dl) : t.inputConnection = [], t.output ? t.output = t.output.map(Dl) : t.output = [], t.inputArrayToProcess ? t.inputArrayToProcess = t.inputArrayToProcess.map(Dl) : t.inputArrayToProcess = [], t.numberOfInputs = e;
  function s(p) {
    let m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (t.deleted) {
      Zn("instance deleted - cannot call any method");
      return;
    }
    if (m >= t.numberOfInputs) {
      Zn(`algorithm ${i.getClassName()} only has ${t.numberOfInputs} input ports. To add more input ports, use addInputData()`);
      return;
    }
    (t.inputData[m] !== p || t.inputConnection[m]) && (t.inputData[m] = p, t.inputConnection[m] = null, i.modified && i.modified());
  }
  function r() {
    let p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t.inputConnection[p] && (t.inputData[p] = t.inputConnection[p]()), t.inputData[p];
  }
  function a(p) {
    let m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (t.deleted) {
      Zn("instance deleted - cannot call any method");
      return;
    }
    if (m >= t.numberOfInputs) {
      let b = `algorithm ${i.getClassName()} only has `;
      b += `${t.numberOfInputs}`, b += " input ports. To add more input ports, use addInputConnection()", Zn(b);
      return;
    }
    t.inputData[m] = null, t.inputConnection[m] = p;
  }
  function o() {
    let p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t.inputConnection[p];
  }
  function l() {
    let p = t.numberOfInputs;
    for (; p && !t.inputData[p - 1] && !t.inputConnection[p - 1]; )
      p--;
    return p === t.numberOfInputs && t.numberOfInputs++, p;
  }
  function c(p) {
    if (t.deleted) {
      Zn("instance deleted - cannot call any method");
      return;
    }
    a(p, l());
  }
  function u(p) {
    if (t.deleted) {
      Zn("instance deleted - cannot call any method");
      return;
    }
    s(p, l());
  }
  function d() {
    let p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t.deleted ? (Zn("instance deleted - cannot call any method"), null) : (i.shouldUpdate() && i.update(), t.output[p]);
  }
  i.shouldUpdate = () => {
    var y, Z;
    const p = i.getMTime();
    let m = 1 / 0, b = n;
    for (; b--; ) {
      if (!t.output[b] || t.output[b].isDeleted())
        return !0;
      const g = t.output[b].getMTime();
      if (g < p)
        return !0;
      g < m && (m = g);
    }
    for (b = t.numberOfInputs; b--; )
      if ((y = t.inputConnection[b]) != null && y.filter.shouldUpdate() || ((Z = i.getInputData(b)) == null ? void 0 : Z.getMTime()) > m)
        return !0;
    return !1;
  };
  function h() {
    let p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    const m = () => d(p);
    return m.filter = i, m;
  }
  if (t.numberOfInputs) {
    let p = t.numberOfInputs;
    for (; p--; )
      t.inputData.push(null), t.inputConnection.push(null);
    i.setInputData = s, i.setInputConnection = a, i.addInputData = u, i.addInputConnection = c, i.getInputData = r, i.getInputConnection = o;
  }
  n && (i.getOutputData = d, i.getOutputPort = h), i.update = () => {
    const p = [];
    if (t.numberOfInputs) {
      let m = 0;
      for (; m < t.numberOfInputs; )
        p[m] = i.getInputData(m), m++;
    }
    i.shouldUpdate() && i.requestData && i.requestData(p, t.output);
  }, i.getNumberOfInputPorts = () => t.numberOfInputs, i.getNumberOfOutputPorts = () => n || t.output.length, i.getInputArrayToProcess = (p) => {
    const m = t.inputArrayToProcess[p], b = t.inputData[p];
    return m && b ? b[`get${m.fieldAssociation}`]().getArray(m.arrayName) : null;
  }, i.setInputArrayToProcess = function(p, m, b) {
    let y = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "Scalars";
    for (; t.inputArrayToProcess.length < p; )
      t.inputArrayToProcess.push(null);
    t.inputArrayToProcess[p] = {
      arrayName: m,
      fieldAssociation: b,
      attributeType: y
    };
  };
}
const QX = Symbol("Event abort");
function mk(i, t, e) {
  const n = [], s = i.delete;
  let r = 1;
  function a(c) {
    for (let u = 0; u < n.length; ++u) {
      const [d] = n[u];
      if (d === c) {
        n.splice(u, 1);
        return;
      }
    }
  }
  function o(c) {
    function u() {
      a(c);
    }
    return Object.freeze({
      unsubscribe: u
    });
  }
  function l() {
    if (t.deleted) {
      Zn("instance deleted - cannot call any method");
      return;
    }
    const c = n.slice();
    for (let u = 0; u < c.length; ++u) {
      const [, d, h] = c[u];
      if (d) {
        if (h < 0)
          setTimeout(() => d.apply(i, arguments), 1 - h);
        else if (d.apply(i, arguments) === QX)
          break;
      }
    }
  }
  i[`invoke${fs(e)}`] = l, i[`on${fs(e)}`] = function(c) {
    let u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (!c.apply)
      return console.error(`Invalid callback for event ${e}`), null;
    if (t.deleted)
      return Zn("instance deleted - cannot call any method"), null;
    const d = r++;
    return n.push([d, c, u]), n.sort((h, p) => p[2] - h[2]), o(d);
  }, i.delete = () => {
    s(), n.forEach((c) => {
      let [u] = c;
      return a(u);
    });
  };
}
function In(i, t) {
  const e = function() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const s = {}, r = {};
    return i(r, s, n), Object.freeze(r);
  };
  return t && Dl.register(t, e), e;
}
function $X() {
  for (var i = arguments.length, t = new Array(i), e = 0; e < i; e++)
    t[e] = arguments[e];
  return function() {
    for (var n = arguments.length, s = new Array(n), r = 0; r < n; r++)
      s[r] = arguments[r];
    return t.filter((a) => !!a).map((a) => a(...s));
  };
}
function qX(i) {
  return i && i.isA && i.isA("vtkObject");
}
function sW(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
  if (qX(i)) {
    if (n.indexOf(i) >= 0)
      return e;
    n.push(i);
    const s = t(i);
    s !== void 0 && e.push(s);
    const r = i.get();
    Object.keys(r).forEach((a) => {
      const o = r[a];
      Array.isArray(o) ? o.forEach((l) => {
        sW(l, t, e, n);
      }) : sW(o, t, e, n);
    });
  }
  return e;
}
function bk(i, t, e) {
  var n = this;
  let s;
  const r = function() {
    for (var a = arguments.length, o = new Array(a), l = 0; l < a; l++)
      o[l] = arguments[l];
    const c = n, u = () => {
      s = null, e || i.apply(c, o);
    }, d = e && !s;
    clearTimeout(s), s = setTimeout(u, t), d && i.apply(c, o);
  };
  return r.cancel = () => clearTimeout(s), r;
}
function fk(i, t) {
  let e = !1, n = null;
  function s() {
    e = !1, n !== null && (r(...n), n = null);
  }
  function r() {
    for (var a = arguments.length, o = new Array(a), l = 0; l < a; l++)
      o[l] = arguments[l];
    if (e) {
      n = o;
      return;
    }
    e = !0, i(...o), setTimeout(s, t);
  }
  return r;
}
function tI(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  t.keystore = Object.assign(t.keystore || {}, e), i.setKey = (n, s) => {
    t.keystore[n] = s;
  }, i.getKey = (n) => t.keystore[n], i.getAllKeys = () => Object.keys(t.keystore), i.deleteKey = (n) => delete t.keystore[n], i.clearKeystore = () => i.getAllKeys().forEach((n) => delete t.keystore[n]);
}
let b6 = 1;
const O1 = "__root__";
function gk(i, t) {
  tI(i, t);
  const e = i.delete;
  t.proxyId = `${b6++}`, t.ui = JSON.parse(JSON.stringify(t.ui || [])), Sa(i, t, ["proxyId", "proxyGroup", "proxyName"]), gs(i, t, ["proxyManager"]);
  const n = {}, s = {};
  function r(c, u) {
    s[u] || (s[u] = []);
    const d = s[u];
    for (let h = 0; h < c.length; h++)
      d.push(c[h].name), n[c[h].name] = c[h], c[h].children && c[h].children.length && r(c[h].children, c[h].name);
  }
  r(t.ui, O1), i.updateUI = (c) => {
    t.ui = JSON.parse(JSON.stringify(c || [])), Object.keys(n).forEach((u) => delete n[u]), Object.keys(s).forEach((u) => delete s[u]), r(t.ui, O1), i.modified();
  };
  function a() {
    let c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : O1;
    return s[c];
  }
  i.updateProxyProperty = (c, u) => {
    const d = n[c];
    d ? Object.assign(d, u) : n[c] = {
      ...u
    };
  }, i.activate = () => {
    if (t.proxyManager) {
      const c = `setActive${fs(i.getProxyGroup().slice(0, -1))}`;
      t.proxyManager[c] && t.proxyManager[c](i);
    }
  }, t.propertyLinkSubscribers = {}, i.registerPropertyLinkForGC = (c, u) => {
    u in t.propertyLinkSubscribers || (t.propertyLinkSubscribers[u] = []), t.propertyLinkSubscribers[u].push(c);
  }, i.gcPropertyLinks = (c) => {
    const u = t.propertyLinkSubscribers[c] || [];
    for (; u.length; )
      u.pop().unbind(i);
  }, t.propertyLinkMap = {}, i.getPropertyLink = function(c) {
    let u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (t.propertyLinkMap[c])
      return t.propertyLinkMap[c];
    let d = null;
    const h = [];
    let p = 0, m = !1;
    function b(T) {
      let M = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      if (m)
        return null;
      const N = [];
      let W = null;
      for (p = h.length; p--; ) {
        const V = h[p];
        V.instance === T ? W = V : N.push(V);
      }
      if (!W)
        return null;
      const x = W.instance[`get${fs(W.propertyName)}`]();
      if (!d6(x, d) || M) {
        for (d = x, m = !0; N.length; ) {
          const V = N.pop();
          V.instance.set({
            [V.propertyName]: d
          });
        }
        m = !1;
      }
      return t.propertyLinkMap[c].persistent && (t.propertyLinkMap[c].value = x), x;
    }
    function y(T, M) {
      const N = [];
      for (p = h.length; p--; ) {
        const W = h[p];
        W.instance === T && (W.propertyName === M || M === void 0) && (W.subscription.unsubscribe(), N.push(p));
      }
      for (; N.length; )
        h.splice(N.pop(), 1);
    }
    function Z(T, M) {
      let N = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
      const W = T.onModified(b), x = h[0];
      return h.push({
        instance: T,
        propertyName: M,
        subscription: W
      }), N && (t.propertyLinkMap[c].persistent && t.propertyLinkMap[c].value !== void 0 ? T.set({
        [M]: t.propertyLinkMap[c].value
      }) : x && b(x.instance, !0)), {
        unsubscribe: () => y(T, M)
      };
    }
    function g() {
      for (; h.length; )
        h.pop().subscription.unsubscribe();
    }
    const f = {
      bind: Z,
      unbind: y,
      unsubscribe: g,
      persistent: u
    };
    return t.propertyLinkMap[c] = f, f;
  };
  function o() {
    let c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : O1;
    const u = [], d = t.proxyId, h = a(c) || [];
    for (let p = 0; p < h.length; p++) {
      const m = h[p], b = i[`get${fs(m)}`], y = b ? b() : void 0, Z = {
        id: d,
        name: m,
        value: y
      }, g = o(m);
      g.length && (Z.children = g), u.push(Z);
    }
    return u;
  }
  i.listPropertyNames = () => o().map((c) => c.name), i.getPropertyByName = (c) => o().find((u) => u.name === c), i.getPropertyDomainByName = (c) => (n[c] || {}).domain, i.getProxySection = () => ({
    id: t.proxyId,
    name: t.proxyGroup,
    ui: t.ui,
    properties: o()
  }), i.delete = () => {
    const c = Object.keys(t.propertyLinkMap);
    let u = c.length;
    for (; u--; )
      t.propertyLinkMap[c[u]].unsubscribe();
    Object.keys(t.propertyLinkSubscribers).forEach(i.gcPropertyLinks), e();
  }, i.getState = () => null;
  function l() {
    if (t.links)
      for (let c = 0; c < t.links.length; c++) {
        const {
          link: u,
          property: d,
          persistent: h,
          updateOnBind: p,
          type: m
        } = t.links[c];
        if (m === "application") {
          const b = t.proxyManager.getPropertyLink(u, h);
          i.registerPropertyLinkForGC(b, "application"), b.bind(i, d, p);
        }
      }
  }
  BX(l);
}
function yk(i, t, e) {
  const n = i.delete, s = [], r = Object.keys(e);
  let a = r.length;
  for (; a--; ) {
    const o = r[a], {
      modelKey: l,
      property: c,
      modified: u = !0
    } = e[o], d = fs(c), h = fs(o);
    i[`get${h}`] = t[l][`get${d}`], i[`set${h}`] = t[l][`set${d}`], u && s.push(t[l].onModified(i.modified));
  }
  i.delete = () => {
    for (; s.length; )
      s.pop().unsubscribe();
    n();
  };
}
function Zk(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  t.this = i;
  function s(o) {
    const l = Object.keys(o);
    let c = l.length;
    for (; c--; ) {
      const u = l[c];
      t[u].set(o[u]);
    }
  }
  const r = Object.keys(n);
  let a = r.length;
  for (; a--; ) {
    const o = r[a];
    t[o] = n[o];
    const l = e[o];
    i[`set${fs(o)}`] = (c) => {
      if (c !== t[o]) {
        t[o] = c;
        const u = l[c];
        s(u), i.modified();
      }
    };
  }
  r.length && Sa(i, t, r);
}
const cD = 10, uD = 40, dD = 800;
function Tk(i) {
  let t = 0, e = 0, n = 0, s = 0;
  return "detail" in i && (e = i.detail), "wheelDelta" in i && (e = -i.wheelDelta / 120), "wheelDeltaY" in i && (e = -i.wheelDeltaY / 120), "wheelDeltaX" in i && (t = -i.wheelDeltaX / 120), "axis" in i && i.axis === i.HORIZONTAL_AXIS && (t = e, e = 0), n = t * cD, s = e * cD, "deltaY" in i && (s = i.deltaY), "deltaX" in i && (n = i.deltaX), (n || s) && i.deltaMode && (i.deltaMode === 1 ? (n *= uD, s *= uD) : (n *= dD, s *= dD)), n && !t && (t = n < 1 ? -1 : 1), s && !e && (e = s < 1 ? -1 : 1), {
    spinX: t,
    spinY: e || t,
    pixelX: n,
    pixelY: s || n
  };
}
var tt = {
  algo: _X,
  capitalize: VG,
  chain: $X,
  debounce: bk,
  enumToString: h6,
  event: mk,
  EVENT_ABORT: QX,
  formatBytesToProperUnit: ck,
  formatNumbersWithThousandSeparator: uk,
  get: Sa,
  getArray: Sg,
  getCurrentGlobalMTime: l6,
  getStateArrayMapFunc: hk,
  isVtkObject: qX,
  keystore: tI,
  measurePromiseExecution: pk,
  moveToProtected: wT,
  newInstance: In,
  newTypedArray: xg,
  newTypedArrayFrom: LG,
  normalizeWheel: Tk,
  obj: xi,
  proxy: gk,
  proxyPropertyMapping: yk,
  proxyPropertyState: Zk,
  safeArrays: dk,
  set: GT,
  setArray: KX,
  setGet: gs,
  setGetArray: HX,
  setImmediate: BX,
  setLoggerFunction: sk,
  throttle: fk,
  traverseInstanceTree: sW,
  TYPED_ARRAYS: sa,
  // deprecated todo remove on breaking API revision
  uncapitalize: lk,
  VOID: nk,
  vtkDebugMacro: iW,
  vtkErrorMacro: Zn,
  vtkInfoMacro: ak,
  vtkLogMacro: rk,
  vtkOnceErrorMacro: ok,
  vtkWarningMacro: SG
}, kr = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  VOID: nk,
  setLoggerFunction: sk,
  vtkLogMacro: rk,
  vtkInfoMacro: ak,
  vtkDebugMacro: iW,
  vtkErrorMacro: Zn,
  vtkWarningMacro: SG,
  vtkOnceErrorMacro: ok,
  TYPED_ARRAYS: sa,
  newTypedArray: xg,
  newTypedArrayFrom: LG,
  capitalize: VG,
  _capitalize: fs,
  uncapitalize: lk,
  formatBytesToProperUnit: ck,
  formatNumbersWithThousandSeparator: uk,
  setImmediateVTK: BX,
  measurePromiseExecution: pk,
  obj: xi,
  get: Sa,
  set: GT,
  setGet: gs,
  getArray: Sg,
  setArray: KX,
  setGetArray: HX,
  moveToProtected: wT,
  algo: _X,
  EVENT_ABORT: QX,
  event: mk,
  newInstance: In,
  chain: $X,
  isVtkObject: qX,
  traverseInstanceTree: sW,
  debounce: bk,
  throttle: fk,
  keystore: tI,
  proxy: gk,
  proxyPropertyMapping: yk,
  proxyPropertyState: Zk,
  normalizeWheel: Tk,
  default: tt
}), eI = { exports: {} };
eI.exports;
(function(i) {
  (function(t, e, n) {
    function s(l) {
      var c = this, u = o();
      c.next = function() {
        var d = 2091639 * c.s0 + c.c * 23283064365386963e-26;
        return c.s0 = c.s1, c.s1 = c.s2, c.s2 = d - (c.c = d | 0);
      }, c.c = 1, c.s0 = u(" "), c.s1 = u(" "), c.s2 = u(" "), c.s0 -= u(l), c.s0 < 0 && (c.s0 += 1), c.s1 -= u(l), c.s1 < 0 && (c.s1 += 1), c.s2 -= u(l), c.s2 < 0 && (c.s2 += 1), u = null;
    }
    function r(l, c) {
      return c.c = l.c, c.s0 = l.s0, c.s1 = l.s1, c.s2 = l.s2, c;
    }
    function a(l, c) {
      var u = new s(l), d = c && c.state, h = u.next;
      return h.int32 = function() {
        return u.next() * 4294967296 | 0;
      }, h.double = function() {
        return h() + (h() * 2097152 | 0) * 11102230246251565e-32;
      }, h.quick = h, d && (typeof d == "object" && r(d, u), h.state = function() {
        return r(u, {});
      }), h;
    }
    function o() {
      var l = 4022871197, c = function(u) {
        u = String(u);
        for (var d = 0; d < u.length; d++) {
          l += u.charCodeAt(d);
          var h = 0.02519603282416938 * l;
          l = h >>> 0, h -= l, h *= l, l = h >>> 0, h -= l, l += h * 4294967296;
        }
        return (l >>> 0) * 23283064365386963e-26;
      };
      return c;
    }
    e && e.exports ? e.exports = a : this.alea = a;
  })(
    Mo,
    i
  );
})(eI);
var Mk = eI.exports;
const f6 = /* @__PURE__ */ qi(Mk), g6 = /* @__PURE__ */ Us({
  __proto__: null,
  default: f6
}, [Mk]), y6 = /* @__PURE__ */ Ps(g6);
var nI = { exports: {} };
nI.exports;
(function(i) {
  (function(t, e, n) {
    function s(o) {
      var l = this, c = "";
      l.x = 0, l.y = 0, l.z = 0, l.w = 0, l.next = function() {
        var d = l.x ^ l.x << 11;
        return l.x = l.y, l.y = l.z, l.z = l.w, l.w ^= l.w >>> 19 ^ d ^ d >>> 8;
      }, o === (o | 0) ? l.x = o : c += o;
      for (var u = 0; u < c.length + 64; u++)
        l.x ^= c.charCodeAt(u) | 0, l.next();
    }
    function r(o, l) {
      return l.x = o.x, l.y = o.y, l.z = o.z, l.w = o.w, l;
    }
    function a(o, l) {
      var c = new s(o), u = l && l.state, d = function() {
        return (c.next() >>> 0) / 4294967296;
      };
      return d.double = function() {
        do
          var h = c.next() >>> 11, p = (c.next() >>> 0) / 4294967296, m = (h + p) / (1 << 21);
        while (m === 0);
        return m;
      }, d.int32 = c.next, d.quick = d, u && (typeof u == "object" && r(u, c), d.state = function() {
        return r(c, {});
      }), d;
    }
    e && e.exports ? e.exports = a : this.xor128 = a;
  })(
    Mo,
    i
  );
})(nI);
var Nk = nI.exports;
const Z6 = /* @__PURE__ */ qi(Nk), T6 = /* @__PURE__ */ Us({
  __proto__: null,
  default: Z6
}, [Nk]), M6 = /* @__PURE__ */ Ps(T6);
var iI = { exports: {} };
iI.exports;
(function(i) {
  (function(t, e, n) {
    function s(o) {
      var l = this, c = "";
      l.next = function() {
        var d = l.x ^ l.x >>> 2;
        return l.x = l.y, l.y = l.z, l.z = l.w, l.w = l.v, (l.d = l.d + 362437 | 0) + (l.v = l.v ^ l.v << 4 ^ (d ^ d << 1)) | 0;
      }, l.x = 0, l.y = 0, l.z = 0, l.w = 0, l.v = 0, o === (o | 0) ? l.x = o : c += o;
      for (var u = 0; u < c.length + 64; u++)
        l.x ^= c.charCodeAt(u) | 0, u == c.length && (l.d = l.x << 10 ^ l.x >>> 4), l.next();
    }
    function r(o, l) {
      return l.x = o.x, l.y = o.y, l.z = o.z, l.w = o.w, l.v = o.v, l.d = o.d, l;
    }
    function a(o, l) {
      var c = new s(o), u = l && l.state, d = function() {
        return (c.next() >>> 0) / 4294967296;
      };
      return d.double = function() {
        do
          var h = c.next() >>> 11, p = (c.next() >>> 0) / 4294967296, m = (h + p) / (1 << 21);
        while (m === 0);
        return m;
      }, d.int32 = c.next, d.quick = d, u && (typeof u == "object" && r(u, c), d.state = function() {
        return r(c, {});
      }), d;
    }
    e && e.exports ? e.exports = a : this.xorwow = a;
  })(
    Mo,
    i
  );
})(iI);
var Wk = iI.exports;
const N6 = /* @__PURE__ */ qi(Wk), W6 = /* @__PURE__ */ Us({
  __proto__: null,
  default: N6
}, [Wk]), G6 = /* @__PURE__ */ Ps(W6);
var sI = { exports: {} };
sI.exports;
(function(i) {
  (function(t, e, n) {
    function s(o) {
      var l = this;
      l.next = function() {
        var u = l.x, d = l.i, h, p;
        return h = u[d], h ^= h >>> 7, p = h ^ h << 24, h = u[d + 1 & 7], p ^= h ^ h >>> 10, h = u[d + 3 & 7], p ^= h ^ h >>> 3, h = u[d + 4 & 7], p ^= h ^ h << 7, h = u[d + 7 & 7], h = h ^ h << 13, p ^= h ^ h << 9, u[d] = p, l.i = d + 1 & 7, p;
      };
      function c(u, d) {
        var h, p = [];
        if (d === (d | 0))
          p[0] = d;
        else
          for (d = "" + d, h = 0; h < d.length; ++h)
            p[h & 7] = p[h & 7] << 15 ^ d.charCodeAt(h) + p[h + 1 & 7] << 13;
        for (; p.length < 8; ) p.push(0);
        for (h = 0; h < 8 && p[h] === 0; ++h) ;
        for (h == 8 ? p[7] = -1 : p[h], u.x = p, u.i = 0, h = 256; h > 0; --h)
          u.next();
      }
      c(l, o);
    }
    function r(o, l) {
      return l.x = o.x.slice(), l.i = o.i, l;
    }
    function a(o, l) {
      o == null && (o = +/* @__PURE__ */ new Date());
      var c = new s(o), u = l && l.state, d = function() {
        return (c.next() >>> 0) / 4294967296;
      };
      return d.double = function() {
        do
          var h = c.next() >>> 11, p = (c.next() >>> 0) / 4294967296, m = (h + p) / (1 << 21);
        while (m === 0);
        return m;
      }, d.int32 = c.next, d.quick = d, u && (u.x && r(u, c), d.state = function() {
        return r(c, {});
      }), d;
    }
    e && e.exports ? e.exports = a : this.xorshift7 = a;
  })(
    Mo,
    i
  );
})(sI);
var Gk = sI.exports;
const w6 = /* @__PURE__ */ qi(Gk), x6 = /* @__PURE__ */ Us({
  __proto__: null,
  default: w6
}, [Gk]), S6 = /* @__PURE__ */ Ps(x6);
var rI = { exports: {} };
rI.exports;
(function(i) {
  (function(t, e, n) {
    function s(o) {
      var l = this;
      l.next = function() {
        var u = l.w, d = l.X, h = l.i, p, m;
        return l.w = u = u + 1640531527 | 0, m = d[h + 34 & 127], p = d[h = h + 1 & 127], m ^= m << 13, p ^= p << 17, m ^= m >>> 15, p ^= p >>> 12, m = d[h] = m ^ p, l.i = h, m + (u ^ u >>> 16) | 0;
      };
      function c(u, d) {
        var h, p, m, b, y, Z = [], g = 128;
        for (d === (d | 0) ? (p = d, d = null) : (d = d + "\0", p = 0, g = Math.max(g, d.length)), m = 0, b = -32; b < g; ++b)
          d && (p ^= d.charCodeAt((b + 32) % d.length)), b === 0 && (y = p), p ^= p << 10, p ^= p >>> 15, p ^= p << 4, p ^= p >>> 13, b >= 0 && (y = y + 1640531527 | 0, h = Z[b & 127] ^= p + y, m = h == 0 ? m + 1 : 0);
        for (m >= 128 && (Z[(d && d.length || 0) & 127] = -1), m = 127, b = 512; b > 0; --b)
          p = Z[m + 34 & 127], h = Z[m = m + 1 & 127], p ^= p << 13, h ^= h << 17, p ^= p >>> 15, h ^= h >>> 12, Z[m] = p ^ h;
        u.w = y, u.X = Z, u.i = m;
      }
      c(l, o);
    }
    function r(o, l) {
      return l.i = o.i, l.w = o.w, l.X = o.X.slice(), l;
    }
    function a(o, l) {
      o == null && (o = +/* @__PURE__ */ new Date());
      var c = new s(o), u = l && l.state, d = function() {
        return (c.next() >>> 0) / 4294967296;
      };
      return d.double = function() {
        do
          var h = c.next() >>> 11, p = (c.next() >>> 0) / 4294967296, m = (h + p) / (1 << 21);
        while (m === 0);
        return m;
      }, d.int32 = c.next, d.quick = d, u && (u.X && r(u, c), d.state = function() {
        return r(c, {});
      }), d;
    }
    e && e.exports ? e.exports = a : this.xor4096 = a;
  })(
    Mo,
    // window object or global
    i
  );
})(rI);
var wk = rI.exports;
const L6 = /* @__PURE__ */ qi(wk), V6 = /* @__PURE__ */ Us({
  __proto__: null,
  default: L6
}, [wk]), X6 = /* @__PURE__ */ Ps(V6);
var aI = { exports: {} };
aI.exports;
(function(i) {
  (function(t, e, n) {
    function s(o) {
      var l = this, c = "";
      l.next = function() {
        var d = l.b, h = l.c, p = l.d, m = l.a;
        return d = d << 25 ^ d >>> 7 ^ h, h = h - p | 0, p = p << 24 ^ p >>> 8 ^ m, m = m - d | 0, l.b = d = d << 20 ^ d >>> 12 ^ h, l.c = h = h - p | 0, l.d = p << 16 ^ h >>> 16 ^ m, l.a = m - d | 0;
      }, l.a = 0, l.b = 0, l.c = -1640531527, l.d = 1367130551, o === Math.floor(o) ? (l.a = o / 4294967296 | 0, l.b = o | 0) : c += o;
      for (var u = 0; u < c.length + 20; u++)
        l.b ^= c.charCodeAt(u) | 0, l.next();
    }
    function r(o, l) {
      return l.a = o.a, l.b = o.b, l.c = o.c, l.d = o.d, l;
    }
    function a(o, l) {
      var c = new s(o), u = l && l.state, d = function() {
        return (c.next() >>> 0) / 4294967296;
      };
      return d.double = function() {
        do
          var h = c.next() >>> 11, p = (c.next() >>> 0) / 4294967296, m = (h + p) / (1 << 21);
        while (m === 0);
        return m;
      }, d.int32 = c.next, d.quick = d, u && (typeof u == "object" && r(u, c), d.state = function() {
        return r(c, {});
      }), d;
    }
    e && e.exports ? e.exports = a : this.tychei = a;
  })(
    Mo,
    i
  );
})(aI);
var xk = aI.exports;
const I6 = /* @__PURE__ */ qi(xk), C6 = /* @__PURE__ */ Us({
  __proto__: null,
  default: I6
}, [xk]), Y6 = /* @__PURE__ */ Ps(C6);
var Sk = { exports: {} };
(function(i) {
  (function(t, e, n) {
    var s = 256, r = 6, a = 52, o = "random", l = n.pow(s, r), c = n.pow(2, a), u = c * 2, d = s - 1, h;
    function p(T, M, N) {
      var W = [];
      M = M == !0 ? { entropy: !0 } : M || {};
      var x = Z(y(
        M.entropy ? [T, f(e)] : T ?? g(),
        3
      ), W), V = new m(W), X = function() {
        for (var C = V.g(r), R = l, z = 0; C < c; )
          C = (C + z) * s, R *= s, z = V.g(1);
        for (; C >= u; )
          C /= 2, R /= 2, z >>>= 1;
        return (C + z) / R;
      };
      return X.int32 = function() {
        return V.g(4) | 0;
      }, X.quick = function() {
        return V.g(4) / 4294967296;
      }, X.double = X, Z(f(V.S), e), (M.pass || N || function(C, R, z, F) {
        return F && (F.S && b(F, V), C.state = function() {
          return b(V, {});
        }), z ? (n[o] = C, R) : C;
      })(
        X,
        x,
        "global" in M ? M.global : this == n,
        M.state
      );
    }
    function m(T) {
      var M, N = T.length, W = this, x = 0, V = W.i = W.j = 0, X = W.S = [];
      for (N || (T = [N++]); x < s; )
        X[x] = x++;
      for (x = 0; x < s; x++)
        X[x] = X[V = d & V + T[x % N] + (M = X[x])], X[V] = M;
      (W.g = function(C) {
        for (var R, z = 0, F = W.i, P = W.j, j = W.S; C--; )
          R = j[F = d & F + 1], z = z * s + j[d & (j[F] = j[P = d & P + R]) + (j[P] = R)];
        return W.i = F, W.j = P, z;
      })(s);
    }
    function b(T, M) {
      return M.i = T.i, M.j = T.j, M.S = T.S.slice(), M;
    }
    function y(T, M) {
      var N = [], W = typeof T, x;
      if (M && W == "object")
        for (x in T)
          try {
            N.push(y(T[x], M - 1));
          } catch {
          }
      return N.length ? N : W == "string" ? T : T + "\0";
    }
    function Z(T, M) {
      for (var N = T + "", W, x = 0; x < N.length; )
        M[d & x] = d & (W ^= M[d & x] * 19) + N.charCodeAt(x++);
      return f(M);
    }
    function g() {
      try {
        var T;
        return h && (T = h.randomBytes) ? T = T(s) : (T = new Uint8Array(s), (t.crypto || t.msCrypto).getRandomValues(T)), f(T);
      } catch {
        var M = t.navigator, N = M && M.plugins;
        return [+/* @__PURE__ */ new Date(), t, N, t.screen, f(e)];
      }
    }
    function f(T) {
      return String.fromCharCode.apply(0, T);
    }
    if (Z(n.random(), e), i.exports) {
      i.exports = p;
      try {
        h = require("crypto");
      } catch {
      }
    } else
      n["seed" + o] = p;
  })(
    // global: `self` in browsers (including strict mode and web workers),
    // otherwise `this` in Node and other environments
    typeof self < "u" ? self : Mo,
    [],
    // pool: entropy pool starts empty
    Math
    // math: package containing random, pow, and seedrandom
  );
})(Sk);
var Lk = Sk.exports;
const v6 = /* @__PURE__ */ qi(Lk), R6 = /* @__PURE__ */ Us({
  __proto__: null,
  default: v6
}, [Lk]), D6 = /* @__PURE__ */ Ps(R6);
var O6 = y6, z6 = M6, E6 = G6, k6 = S6, F6 = X6, j6 = Y6, S0 = D6;
S0.alea = O6;
S0.xor128 = z6;
S0.xorwow = E6;
S0.xorshift7 = k6;
S0.xor4096 = F6;
S0.tychei = j6;
var U6 = S0;
const P6 = /* @__PURE__ */ qi(U6), oI = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1], J6 = [1, 0, 0, 0, 1, 0, 0, 0, 1], XG = 1e-6, lI = 1e-12, {
  vtkErrorMacro: Vk,
  vtkWarningMacro: m0
} = tt;
let Xk = 0;
const hD = 20;
function xT(i) {
  return () => Vk(`vtkMath::${i} - NOT IMPLEMENTED`);
}
function qy(i, t, e, n) {
  let s;
  for (let r = 0; r < t; r++)
    s = i[e * t + r], i[e * t + r] = i[n * t + r], i[n * t + r] = s;
}
function fy(i, t, e, n) {
  let s;
  for (let r = 0; r < t; r++)
    s = i[r * t + e], i[r * t + e] = i[r * t + n], i[r * t + n] = s;
}
function Ri() {
  let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 3;
  const t = Array(i);
  for (let e = 0; e < i; ++e)
    t[e] = 0;
  return t;
}
const A6 = () => Math.PI;
function Qi(i) {
  return i / 180 * Math.PI;
}
function pg(i) {
  return i * 180 / Math.PI;
}
const {
  round: $u,
  floor: d2,
  ceil: B6,
  min: K6,
  max: H6
} = Math;
function _6(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, n = 1 / 0;
  for (let s = t, r = i.length; s < r; s += e)
    i[s] < n && (n = i[s]);
  return n;
}
function Q6(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, n = -1 / 0;
  for (let s = t, r = i.length; s < r; s += e)
    n < i[s] && (n = i[s]);
  return n;
}
function $6(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, n = 1 / 0, s = -1 / 0;
  for (let r = t, a = i.length; r < a; r += e)
    i[r] < n && (n = i[r]), s < i[r] && (s = i[r]);
  return [n, s];
}
const q6 = xT("ceilLog2"), t$ = xT("factorial");
function Qo(i) {
  let t = 1;
  for (; t < i; )
    t *= 2;
  return t;
}
function gy(i) {
  return i === Qo(i);
}
function e$(i, t) {
  let e = 1;
  for (let n = 1; n <= t; ++n)
    e *= (i - n + 1) / n;
  return Math.floor(e);
}
function n$(i, t) {
  if (i < t)
    return 0;
  const e = Ri(t);
  for (let n = 0; n < t; ++n)
    e[n] = n;
  return e;
}
function i$(i, t, e) {
  let n = 0;
  for (let s = t - 1; s >= 0; --s)
    if (e[s] < i - t + s) {
      let r = e[s] + 1;
      for (; s < t; )
        e[s++] = r++;
      n = 1;
      break;
    }
  return n;
}
function s$(i) {
  P6(`${i}`, {
    global: !0
  }), Xk = i;
}
function r$() {
  return Xk;
}
function a$() {
  let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
  const e = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1) - i;
  return i + e * Math.random();
}
const o$ = xT("gaussian");
function b0(i, t, e) {
  return e[0] = i[0] + t[0], e[1] = i[1] + t[1], e[2] = i[2] + t[2], e;
}
function fi(i, t, e) {
  return e[0] = i[0] - t[0], e[1] = i[1] - t[1], e[2] = i[2] - t[2], e;
}
function h2(i, t) {
  return i[0] *= t, i[1] *= t, i[2] *= t, i;
}
function Ik(i, t) {
  return i[0] *= t, i[1] *= t, i;
}
function AS(i, t, e, n) {
  return n[0] = i[0] + t[0] * e, n[1] = i[1] + t[1] * e, n[2] = i[2] + t[2] * e, n;
}
function l$(i, t, e, n) {
  return n[0] = i[0] + t[0] * e, n[1] = i[1] + t[1] * e, n;
}
function tn(i, t) {
  return i[0] * t[0] + i[1] * t[1] + i[2] * t[2];
}
function c$(i, t, e) {
  e[0] = i[0] * t[0], e[1] = i[0] * t[1], e[2] = i[0] * t[2], e[3] = i[1] * t[0], e[4] = i[1] * t[1], e[5] = i[1] * t[2], e[6] = i[2] * t[0], e[7] = i[2] * t[1], e[8] = i[2] * t[2];
}
function Wi(i, t, e) {
  const n = i[1] * t[2] - i[2] * t[1], s = i[2] * t[0] - i[0] * t[2], r = i[0] * t[1] - i[1] * t[0];
  return e[0] = n, e[1] = s, e[2] = r, e;
}
function Or(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
  switch (t) {
    case 1:
      return Math.abs(i);
    case 2:
      return Math.sqrt(i[0] * i[0] + i[1] * i[1]);
    case 3:
      return Math.sqrt(i[0] * i[0] + i[1] * i[1] + i[2] * i[2]);
    default: {
      let e = 0;
      for (let n = 0; n < t; n++)
        e += i[n] * i[n];
      return Math.sqrt(e);
    }
  }
}
function Fn(i) {
  const t = Or(i);
  return t !== 0 && (i[0] /= t, i[1] /= t, i[2] /= t), t;
}
function u$(i, t, e, n) {
  const s = i[0] * i[0], r = i[1] * i[1], a = i[2] * i[2], o = Math.sqrt(s + r + a);
  let l, c, u;
  s > r && s > a ? (l = 0, c = 1, u = 2) : r > a ? (l = 1, c = 2, u = 0) : (l = 2, c = 0, u = 1);
  const d = i[l] / o, h = i[c] / o, p = i[u] / o, m = Math.sqrt(d * d + p * p);
  if (n !== 0) {
    const b = Math.sin(n), y = Math.cos(n);
    t && (t[l] = (p * y - d * h * b) / m, t[c] = b * m, t[u] = (-(d * y) - h * p * b) / m), e && (e[l] = (-(p * b) - d * h * y) / m, e[c] = y * m, e[u] = (d * b - h * p * y) / m);
  } else
    t && (t[l] = p / m, t[c] = 0, t[u] = -d / m), e && (e[l] = -d * h / m, e[c] = m, e[u] = -h * p / m);
}
function BS(i, t, e) {
  const n = tn(t, t);
  if (n === 0)
    return e[0] = 0, e[1] = 0, e[2] = 0, !1;
  const s = tn(i, t) / n;
  for (let r = 0; r < 3; r++)
    e[r] = t[r];
  return h2(e, s), !0;
}
function KS(i, t) {
  return i[0] * t[0] + i[1] * t[1];
}
function d$(i, t, e) {
  const n = KS(t, t);
  if (n === 0)
    return e[0] = 0, e[1] = 0, !1;
  const s = KS(i, t) / n;
  for (let r = 0; r < 2; r++)
    e[r] = t[r];
  return Ik(e, s), !0;
}
function zs(i, t) {
  return (i[0] - t[0]) * (i[0] - t[0]) + (i[1] - t[1]) * (i[1] - t[1]) + (i[2] - t[2]) * (i[2] - t[2]);
}
function nd(i, t) {
  const e = [0, 0, 0];
  return Wi(i, t, e), Math.atan2(Or(e), tn(i, t));
}
function h$(i, t, e) {
  const n = Math.abs(i - e);
  return 1 / Math.sqrt(2 * Math.PI * t) * Math.exp(-(n ** 2) / (2 * t));
}
function p$(i, t, e) {
  const n = Math.abs(i - e);
  return Math.exp(-(n ** 2) / (2 * t));
}
function m$(i, t, e) {
  e[0] = i[0] * t[0], e[1] = i[0] * t[1], e[2] = i[1] * t[0], e[3] = i[1] * t[1];
}
function Ck(i) {
  return Math.sqrt(i[0] * i[0] + i[1] * i[1]);
}
function Yk(i) {
  const t = Ck(i);
  return t !== 0 && (i[0] /= t, i[1] /= t), t;
}
function is() {
  for (var i = arguments.length, t = new Array(i), e = 0; e < i; e++)
    t[e] = arguments[e];
  return t.length === 2 ? t[0][0] * t[1][1] - t[1][0] * t[0][1] : t.length === 4 ? t[0] * t[3] - t[1] * t[2] : Number.NaN;
}
function b$(i, t) {
  let e, n, s;
  const r = [0, 0, 0];
  for (let a = 0; a < 3; a++)
    s = Math.abs(i[a * 3]), (n = Math.abs(i[a * 3 + 1])) > s && (s = n), (n = Math.abs(i[a * 3 + 2])) > s && (s = n), r[a] = 1 / s;
  s = r[0] * Math.abs(i[0]), e = 0, (n = r[1] * Math.abs(i[3])) >= s && (s = n, e = 1), (n = r[2] * Math.abs(i[6])) >= s && (e = 2), e !== 0 && (qy(i, 3, e, 0), r[e] = r[0]), t[0] = e, i[3] /= i[0], i[6] /= i[0], i[4] -= i[3] * i[1], i[7] -= i[6] * i[1], s = r[1] * Math.abs(i[4]), e = 1, (n = r[2] * Math.abs(i[7])) >= s && (e = 2, qy(i, 3, 1, 2), r[2] = r[1]), t[1] = e, i[7] /= i[4], i[5] -= i[3] * i[2], i[8] -= i[6] * i[2] + i[7] * i[5], t[2] = 2;
}
function f$(i, t, e) {
  let n = e[t[0]];
  e[t[0]] = e[0], e[0] = n, n = e[t[1]], e[t[1]] = e[1], e[1] = n - i[3] * e[0], n = e[t[2]], e[t[2]] = e[2], e[2] = n - i[6] * e[0] - i[7] * e[1], e[2] /= i[8], e[1] = (e[1] - i[5] * e[2]) / i[4], e[0] = (e[0] - i[1] * e[1] - i[2] * e[2]) / i[0];
}
function g$(i, t, e) {
  const n = i[0], s = i[1], r = i[2], a = i[3], o = i[4], l = i[5], c = i[6], u = i[7], d = i[8], h = +is(o, u, l, d), p = -is(a, c, l, d), m = +is(a, c, o, u), b = -is(s, u, r, d), y = +is(n, c, r, d), Z = -is(n, c, s, u), g = +is(s, o, r, l), f = -is(n, a, r, l), T = +is(n, a, s, o), M = n * h + s * p + r * m, N = h * t[0] + b * t[1] + g * t[2], W = p * t[0] + y * t[1] + f * t[2], x = m * t[0] + Z * t[1] + T * t[2];
  e[0] = N / M, e[1] = W / M, e[2] = x / M;
}
function tN(i, t, e) {
  const n = i[0] * t[0] + i[1] * t[1] + i[2] * t[2], s = i[3] * t[0] + i[4] * t[1] + i[5] * t[2], r = i[6] * t[0] + i[7] * t[1] + i[8] * t[2];
  e[0] = n, e[1] = s, e[2] = r;
}
function HS(i, t, e) {
  const n = [...i], s = [...t];
  for (let r = 0; r < 3; r++)
    e[r] = n[0] * s[r] + n[1] * s[r + 3] + n[2] * s[r + 6], e[r + 3] = n[3] * s[r] + n[4] * s[r + 3] + n[5] * s[r + 6], e[r + 6] = n[6] * s[r] + n[7] * s[r + 3] + n[8] * s[r + 6];
}
function y$(i, t, e, n, s, r, a) {
  n !== s && Vk("Number of columns of A must match number of rows of B.");
  const o = [...i], l = [...t];
  for (let c = 0; c < e; c++)
    for (let u = 0; u < r; u++) {
      a[c * r + u] = 0;
      for (let d = 0; d < n; d++)
        a[c * r + u] += o[c * n + d] * l[u + r * d];
    }
}
function Xb(i, t) {
  let e;
  e = i[3], t[3] = i[1], t[1] = e, e = i[6], t[6] = i[2], t[2] = e, e = i[7], t[7] = i[5], t[5] = e, t[0] = i[0], t[4] = i[4], t[8] = i[8];
}
function Z$(i, t) {
  const e = i[0], n = i[1], s = i[2], r = i[3], a = i[4], o = i[5], l = i[6], c = i[7], u = i[8], d = +is(a, c, o, u), h = -is(r, l, o, u), p = +is(r, l, a, c), m = -is(n, c, s, u), b = +is(e, l, s, u), y = -is(e, l, n, c), Z = +is(n, a, s, o), g = -is(e, r, s, o), f = +is(e, r, n, a), T = e * d + n * h + s * p;
  T === 0 && m0("Matrix has 0 determinant"), t[0] = d / T, t[3] = h / T, t[6] = p / T, t[1] = m / T, t[4] = b / T, t[7] = y / T, t[2] = Z / T, t[5] = g / T, t[8] = f / T;
}
function IG(i) {
  return i[0] * i[4] * i[8] + i[3] * i[7] * i[2] + i[6] * i[1] * i[5] - i[0] * i[7] * i[5] - i[3] * i[1] * i[8] - i[6] * i[4] * i[2];
}
function vk(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : XG;
  if (i.length !== t.length)
    return !1;
  function n(s, r) {
    return Math.abs(s - t[r]) <= e;
  }
  return i.every(n);
}
const ST = vk;
function Rk(i) {
  for (let t = 0; t < 3; t++)
    i[t * 3] = i[t * 3 + 1] = i[t * 3 + 2] = 0, i[t * 3 + t] = 1;
}
function Dk(i, t) {
  for (let e = 0; e < i; e++) {
    for (let n = 0; n < i; n++)
      t[e * i + n] = 0;
    t[e * i + e] = 1;
  }
  return t;
}
function T$(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : XG;
  return ST(i, oI, t);
}
function Ok(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : XG;
  return ST(i, J6, t);
}
function zk(i, t) {
  const e = i[0] * i[0], n = i[0] * i[1], s = i[0] * i[2], r = i[0] * i[3], a = i[1] * i[1], o = i[2] * i[2], l = i[3] * i[3], c = i[1] * i[2], u = i[1] * i[3], d = i[2] * i[3], h = a + o + l;
  let p = 1 / (e + h);
  const m = (e - h) * p;
  p *= 2, t[0] = a * p + m, t[3] = (c + r) * p, t[6] = (u - s) * p, t[1] = (c - r) * p, t[4] = o * p + m, t[7] = (d + n) * p, t[2] = (u + s) * p, t[5] = (d - n) * p, t[8] = l * p + m;
}
function eN(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  if (!`${i}`.includes("e"))
    return +`${Math.round(`${i}e+${t}`)}e-${t}`;
  const e = `${i}`.split("e");
  let n = "";
  return +e[1] + t > 0 && (n = "+"), +`${Math.round(`${+e[0]}e${n}${+e[1] + t}`)}e-${t}`;
}
function _S(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [0, 0, 0], e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
  return t[0] = eN(i[0], e), t[1] = eN(i[1], e), t[2] = eN(i[2], e), t;
}
function LT(i, t, e, n) {
  let s, r, a, o, l, c, u, d, h, p, m, b, y, Z, g, f;
  const T = Ri(t), M = Ri(t), N = (x, V, X) => {
    Z = x[V], y = x[X], x[V] = Z - b * (y + Z * p), x[X] = y + b * (Z - y * p);
  };
  for (Dk(t, n), l = 0; l < t; l++)
    T[l] = e[l] = i[l + l * t], M[l] = 0;
  for (s = 0; s < hD; s++) {
    for (m = 0, l = 0; l < t - 1; l++)
      for (o = l + 1; o < t; o++)
        m += Math.abs(i[l * t + o]);
    if (m === 0)
      break;
    for (s < 3 ? u = 0.2 * m / (t * t) : u = 0, l = 0; l < t - 1; l++)
      for (o = l + 1; o < t; o++)
        if (Z = 100 * Math.abs(i[l * t + o]), s > 3 && Math.abs(e[l]) + Z === Math.abs(e[l]) && Math.abs(e[o]) + Z === Math.abs(e[o]))
          i[l * t + o] = 0;
        else if (Math.abs(i[l * t + o]) > u) {
          for (y = e[o] - e[l], Math.abs(y) + Z === Math.abs(y) ? h = i[l * t + o] / y : (d = 0.5 * y / i[l * t + o], h = 1 / (Math.abs(d) + Math.sqrt(1 + d * d)), d < 0 && (h = -h)), g = 1 / Math.sqrt(1 + h * h), b = h * g, p = b / (1 + g), y = h * i[l * t + o], M[l] -= y, M[o] += y, e[l] -= y, e[o] += y, i[l * t + o] = 0, r = 0; r <= l - 1; r++)
            N(i, r * t + l, r * t + o);
          for (r = l + 1; r <= o - 1; r++)
            N(i, l * t + r, r * t + o);
          for (r = o + 1; r < t; r++)
            N(i, l * t + r, o * t + r);
          for (r = 0; r < t; r++)
            N(n, r * t + l, r * t + o);
        }
    for (l = 0; l < t; l++)
      T[l] += M[l], e[l] = T[l], M[l] = 0;
  }
  if (s >= hD)
    return m0("vtkMath::Jacobi: Error extracting eigenfunctions"), 0;
  for (r = 0; r < t - 1; r++) {
    for (a = r, f = e[a], s = r + 1; s < t; s++)
      (e[s] >= f || Math.abs(e[s] - f) < lI) && (a = s, f = e[a]);
    a !== r && (e[a] = e[r], e[r] = f, fy(n, t, r, a));
  }
  const W = (t >> 1) + (t & 1);
  for (c = 0, s = 0; s < t * t; s++)
    n[s] >= 0 && c++;
  if (c < W)
    for (s = 0; s < t; s++)
      n[s * t + r] *= -1;
  return 1;
}
function Ek(i, t) {
  const e = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  e[0] = i[0] + i[4] + i[8], e[5] = i[0] - i[4] - i[8], e[10] = -i[0] + i[4] - i[8], e[15] = -i[0] - i[4] + i[8], e[1] = e[4] = i[7] - i[5], e[2] = e[8] = i[2] - i[6], e[3] = e[12] = i[3] - i[1], e[6] = e[9] = i[3] + i[1], e[7] = e[13] = i[2] + i[6], e[11] = e[14] = i[7] + i[5];
  const n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], s = [0, 0, 0, 0], r = [...e];
  LT(r, 4, s, n), t[0] = n[0], t[1] = n[4], t[2] = n[8], t[3] = n[12];
}
function M$(i, t, e) {
  const n = i[0] * t[0], s = i[0] * t[1], r = i[0] * t[2], a = i[0] * t[3], o = i[1] * t[0], l = i[1] * t[1], c = i[1] * t[2], u = i[1] * t[3], d = i[2] * t[0], h = i[2] * t[1], p = i[2] * t[2], m = i[2] * t[3], b = i[3] * t[0], y = i[3] * t[1], Z = i[3] * t[2], g = i[3] * t[3];
  e[0] = n - l - p - g, e[1] = s + o + m - Z, e[2] = r - u + d + y, e[3] = a + c - h + b;
}
function kk(i, t) {
  for (let h = 0; h < 9; h++)
    t[h] = i[h];
  const e = Ri(3), n = Ri(3);
  let s;
  for (let h = 0; h < 3; h++) {
    const p = Math.abs(t[h * 3]), m = Math.abs(t[h * 3 + 1]), b = Math.abs(t[h * 3 + 2]);
    s = m > p ? m : p, s = b > s ? b : s, e[h] = 1, s !== 0 && (e[h] /= s);
  }
  const r = Math.abs(t[0]) * e[0], a = Math.abs(t[3]) * e[1], o = Math.abs(t[6]) * e[2];
  n[0] = 0, s = r, a >= s && (s = a, n[0] = 1), o >= s && (n[0] = 2), n[0] !== 0 && (fy(t, 3, n[0], 0), e[n[0]] = e[0]);
  const l = Math.abs(t[4]) * e[1], c = Math.abs(t[7]) * e[2];
  n[1] = 1, s = l, c >= s && (n[1] = 2, fy(t, 3, 1, 2)), n[2] = 2;
  let u = 0;
  if (IG(t) < 0) {
    u = 1;
    for (let h = 0; h < 9; h++)
      t[h] = -t[h];
  }
  const d = Ri(4);
  if (Ek(t, d), zk(d, t), u)
    for (let h = 0; h < 9; h++)
      t[h] = -t[h];
  n[1] !== 1 && fy(t, 3, n[1], 1), n[0] !== 0 && fy(t, 3, n[0], 0);
}
function Fk(i, t, e) {
  let n, s, r, a, o, l;
  const c = [...i];
  if (LT(c, 3, t, e), t[0] === t[1] && t[0] === t[2]) {
    Rk(e);
    return;
  }
  for (Xb(e, e), n = 0; n < 3; n++)
    if (t[(n + 1) % 3] === t[(n + 2) % 3]) {
      for (l = Math.abs(e[n * 3]), a = 0, s = 1; s < 3; s++)
        l < (o = Math.abs(e[n * 3 + s])) && (l = o, a = s);
      a !== n && (o = t[a], t[a] = t[n], t[n] = o, qy(e, 3, n, a)), e[a * 3 + a] < 0 && (e[a * 3] = -e[a * 3], e[a * 3 + 1] = -e[a * 3 + 1], e[a * 3 + 2] = -e[a * 3 + 2]), s = (a + 1) % 3, r = (a + 2) % 3, e[s * 3] = 0, e[s * 3 + 1] = 0, e[s * 3 + 2] = 0, e[s * 3 + s] = 1;
      const u = Wi([e[a * 3], e[a * 3 + 1], e[a * 3 + 2]], [e[s * 3], e[s * 3 + 1], e[s * 3 + 2]], []);
      Fn(u);
      const d = Wi(u, [e[a * 3], e[a * 3 + 1], e[a * 3 + 2]], []);
      for (let h = 0; h < 3; h++)
        e[r * 3 + h] = u[h], e[s * 3 + h] = d[h];
      Xb(e, e);
      return;
    }
  for (l = Math.abs(e[0]), a = 0, n = 1; n < 3; n++)
    l < (o = Math.abs(e[n * 3])) && (l = o, a = n);
  if (a !== 0) {
    const u = t[a];
    t[a] = t[0], t[0] = u, qy(e, 3, a, 0);
  }
  if (Math.abs(e[4]) < Math.abs(e[7])) {
    const u = t[2];
    t[2] = t[1], t[1] = u, qy(e, 3, 1, 2);
  }
  for (n = 0; n < 2; n++)
    e[n * 3 + n] < 0 && (e[n * 3] = -e[n * 3], e[n * 3 + 1] = -e[n * 3 + 1], e[n * 3 + 2] = -e[n * 3 + 2]);
  IG(e) < 0 && (e[6] = -e[6], e[7] = -e[7], e[8] = -e[8]), Xb(e, e);
}
function N$(i, t, e, n) {
  let s;
  const r = [...i], a = IG(r);
  if (a < 0)
    for (s = 0; s < 9; s++)
      r[s] = -r[s];
  kk(r, t), Xb(r, r), HS(r, t, n), Fk(n, e, n), HS(t, n, t), Xb(n, n), a < 0 && (e[0] = -e[0], e[1] = -e[1], e[2] = -e[2]);
}
function cI(i, t, e) {
  let n, s, r, a, o = 0, l, c, u;
  const d = Ri(e);
  for (n = 0; n < e; n++) {
    for (a = 0, s = 0; s < e; s++)
      (u = Math.abs(i[n * e + s])) > a && (a = u);
    if (a === 0)
      return m0("Unable to factor linear system"), 0;
    d[n] = 1 / a;
  }
  for (s = 0; s < e; s++) {
    for (n = 0; n < s; n++) {
      for (l = i[n * e + s], r = 0; r < n; r++)
        l -= i[n * e + r] * i[r * e + s];
      i[n * e + s] = l;
    }
    for (a = 0, n = s; n < e; n++) {
      for (l = i[n * e + s], r = 0; r < s; r++)
        l -= i[n * e + r] * i[r * e + s];
      i[n * e + s] = l, (c = d[n] * Math.abs(l)) >= a && (a = c, o = n);
    }
    if (s !== o) {
      for (r = 0; r < e; r++)
        c = i[o * e + r], i[o * e + r] = i[s * e + r], i[s * e + r] = c;
      d[o] = d[s];
    }
    if (t[s] = o, Math.abs(i[s * e + s]) <= lI)
      return m0("Unable to factor linear system"), 0;
    if (s !== e - 1)
      for (c = 1 / i[s * e + s], n = s + 1; n < e; n++)
        i[n * e + s] *= c;
  }
  return 1;
}
function uI(i, t, e, n) {
  let s, r, a, o, l;
  for (a = -1, s = 0; s < n; s++) {
    if (o = t[s], l = e[o], e[o] = e[s], a >= 0)
      for (r = a; r <= s - 1; r++)
        l -= i[s * n + r] * e[r];
    else l !== 0 && (a = s);
    e[s] = l;
  }
  for (s = n - 1; s >= 0; s--) {
    for (l = e[s], r = s + 1; r < n; r++)
      l -= i[s * n + r] * e[r];
    e[s] = l / i[s * n + s];
  }
}
function jk(i, t, e) {
  if (e === 2) {
    const s = Ri(2), r = is(i[0], i[1], i[2], i[3]);
    return r === 0 ? 0 : (s[0] = (i[3] * t[0] - i[1] * t[1]) / r, s[1] = (-(i[2] * t[0]) + i[0] * t[1]) / r, t[0] = s[0], t[1] = s[1], 1);
  }
  if (e === 1)
    return i[0] === 0 ? 0 : (t[0] /= i[0], 1);
  const n = Ri(e);
  return cI(i, n, e) === 0 ? 0 : (uI(i, n, t, e), 1);
}
function Uk(i, t, e) {
  let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
  const r = n || Ri(e), a = s || Ri(e);
  if (cI(i, r, e) === 0)
    return null;
  for (let o = 0; o < e; o++) {
    for (let l = 0; l < e; l++)
      a[l] = 0;
    a[o] = 1, uI(i, r, a, e);
    for (let l = 0; l < e; l++)
      t[l * e + o] = a[l];
  }
  return t;
}
function W$(i, t) {
  let e = +Number.MAX_VALUE, n = -Number.MAX_VALUE;
  for (let s = 0; s < t; s++)
    for (let r = s; r < t; r++)
      Math.abs(i[s * t + r]) > n && (n = Math.abs(i[s * t + r]));
  for (let s = 0; s < t; s++)
    Math.abs(i[s * t + s]) < e && (e = Math.abs(i[s * t + s]));
  return e === 0 ? Number.MAX_VALUE : n / e;
}
function G$(i, t, e) {
  return LT(i, 3, t, e);
}
function QS(i, t, e, n) {
  if (i < e)
    return m0("Insufficient number of samples. Underdetermined."), 0;
  let s, r, a;
  const o = Ri(e * e), l = Ri(e), c = Ri(e * e);
  for (a = 0; a < i; a++)
    for (s = 0; s < e; s++)
      for (r = s; r < e; r++)
        o[s * e + r] += t[a * e + s] * t[a * e + r];
  for (s = 0; s < e; s++)
    for (r = 0; r < s; r++)
      o[s * e + r] = o[r * e + s];
  for (LT(o, e, l, c), s = 0; s < e; s++)
    n[s] = c[s * e + e - 1];
  return 1;
}
function w$(i, t, e, n, s, r) {
  let a = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : !0;
  if (i < e || i < s)
    return m0("Insufficient number of samples. Underdetermined."), 0;
  const o = Ri(s);
  let l = 1, c, u = 0, d, h, p, m = 0;
  if (a) {
    for (h = 0; h < s; h++)
      o[h] = 1;
    for (d = 0; d < i; d++)
      for (h = 0; h < s; h++)
        Math.abs(n[d * s + h]) > lI && (l = 0, o[h] = 0);
    if (l && s === 1)
      return m0("Detected homogeneous system (Y=0), calling SolveHomogeneousLeastSquares()"), QS(i, t, e, r);
    if (l)
      m = 1;
    else
      for (h = 0; h < s; h++)
        o[h] && (m = 1);
  }
  m && (c = Ri(e), u = QS(i, t, e, c));
  const b = Ri(e * e), y = Ri(e * e), Z = Ri(e * s);
  for (p = 0; p < i; p++)
    for (d = 0; d < e; d++) {
      for (h = d; h < e; h++)
        b[d * e + h] += t[p * e + d] * t[p * e + h];
      for (h = 0; h < s; h++)
        Z[d * s + h] += t[p * e + d] * n[p * s + h];
    }
  for (d = 0; d < e; d++)
    for (h = 0; h < d; h++)
      b[d * e + h] = b[h * e + d];
  const g = Uk(b, y, e);
  if (g)
    for (d = 0; d < e; d++)
      for (h = 0; h < s; h++)
        for (r[d * s + h] = 0, p = 0; p < e; p++)
          r[d * s + h] += y[d * e + p] * Z[p * s + h];
  if (m) {
    for (h = 0; h < s; h++)
      if (o[h])
        for (d = 0; d < e; d++)
          r[d * s + h] = c[d * s];
  }
  return m ? u && g : g;
}
function x$(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [0, 0.5, 1];
  switch (i.length) {
    case 3:
      return t[0] = parseInt(i[0], 16) * 17 / 255, t[1] = parseInt(i[1], 16) * 17 / 255, t[2] = parseInt(i[2], 16) * 17 / 255, t;
    case 4:
      return t[0] = parseInt(i[1], 16) * 17 / 255, t[1] = parseInt(i[2], 16) * 17 / 255, t[2] = parseInt(i[3], 16) * 17 / 255, t;
    case 6:
      return t[0] = parseInt(i.substr(0, 2), 16) / 255, t[1] = parseInt(i.substr(2, 2), 16) / 255, t[2] = parseInt(i.substr(4, 2), 16) / 255, t;
    case 7:
      return t[0] = parseInt(i.substr(1, 2), 16) / 255, t[1] = parseInt(i.substr(3, 2), 16) / 255, t[2] = parseInt(i.substr(5, 2), 16) / 255, t;
    case 9:
      return t[0] = parseInt(i.substr(1, 2), 16) / 255, t[1] = parseInt(i.substr(3, 2), 16) / 255, t[2] = parseInt(i.substr(5, 2), 16) / 255, t[3] = parseInt(i.substr(7, 2), 16) / 255, t;
    default:
      return t;
  }
}
function yy(i, t) {
  let e, n;
  const [s, r, a] = i, o = 1 / 3, l = 1 / 6, c = 2 / 3;
  let u = s, d = s;
  r > u ? u = r : r < d && (d = r), a > u ? u = a : a < d && (d = a);
  const h = u;
  h > 0 ? n = (u - d) / u : n = 0, n > 0 ? (s === u ? e = l * (r - a) / (u - d) : r === u ? e = o + l * (a - s) / (u - d) : e = c + l * (s - r) / (u - d), e < 0 && (e += 1)) : e = 0, t[0] = e, t[1] = n, t[2] = h;
}
function Yp(i, t) {
  const [e, n, s] = i, r = 1 / 3, a = 1 / 6, o = 2 / 3, l = 5 / 6;
  let c, u, d;
  e > a && e <= r ? (u = 1, c = (r - e) / a, d = 0) : e > r && e <= 0.5 ? (u = 1, d = (e - r) / a, c = 0) : e > 0.5 && e <= o ? (d = 1, u = (o - e) / a, c = 0) : e > o && e <= l ? (d = 1, c = (e - o) / a, u = 0) : e > l && e <= 1 ? (c = 1, d = (1 - e) / a, u = 0) : (c = 1, u = e / a, d = 0), c = n * c + (1 - n), u = n * u + (1 - n), d = n * d + (1 - n), c *= s, u *= s, d *= s, t[0] = c, t[1] = u, t[2] = d;
}
function Pk(i, t) {
  const [e, n, s] = i;
  let r = (e + 16) / 116, a = n / 500 + r, o = r - s / 200;
  r ** 3 > 8856e-6 ? r **= 3 : r = (r - 16 / 116) / 7.787, a ** 3 > 8856e-6 ? a **= 3 : a = (a - 16 / 116) / 7.787, o ** 3 > 8856e-6 ? o **= 3 : o = (o - 16 / 116) / 7.787;
  const l = 0.9505, c = 1, u = 1.089;
  t[0] = l * a, t[1] = c * r, t[2] = u * o;
}
function Jk(i, t) {
  const [e, n, s] = i, r = 0.9505, a = 1, o = 1.089;
  let l = e / r, c = n / a, u = s / o;
  l > 8856e-6 ? l **= 1 / 3 : l = 7.787 * l + 16 / 116, c > 8856e-6 ? c **= 1 / 3 : c = 7.787 * c + 16 / 116, u > 8856e-6 ? u **= 1 / 3 : u = 7.787 * u + 16 / 116, t[0] = 116 * c - 16, t[1] = 500 * (l - c), t[2] = 200 * (c - u);
}
function Ak(i, t) {
  const [e, n, s] = i;
  let r = e * 3.2406 + n * -1.5372 + s * -0.4986, a = e * -0.9689 + n * 1.8758 + s * 0.0415, o = e * 0.0557 + n * -0.204 + s * 1.057;
  r > 31308e-7 ? r = 1.055 * r ** (1 / 2.4) - 0.055 : r *= 12.92, a > 31308e-7 ? a = 1.055 * a ** (1 / 2.4) - 0.055 : a *= 12.92, o > 31308e-7 ? o = 1.055 * o ** (1 / 2.4) - 0.055 : o *= 12.92;
  let l = r;
  l < a && (l = a), l < o && (l = o), l > 1 && (r /= l, a /= l, o /= l), r < 0 && (r = 0), a < 0 && (a = 0), o < 0 && (o = 0), t[0] = r, t[1] = a, t[2] = o;
}
function Bk(i, t) {
  let [e, n, s] = i;
  e > 0.04045 ? e = ((e + 0.055) / 1.055) ** 2.4 : e /= 12.92, n > 0.04045 ? n = ((n + 0.055) / 1.055) ** 2.4 : n /= 12.92, s > 0.04045 ? s = ((s + 0.055) / 1.055) ** 2.4 : s /= 12.92, t[0] = e * 0.4124 + n * 0.3576 + s * 0.1805, t[1] = e * 0.2126 + n * 0.7152 + s * 0.0722, t[2] = e * 0.0193 + n * 0.1192 + s * 0.9505;
}
function kp(i, t) {
  const e = [0, 0, 0];
  Bk(i, e), Jk(e, t);
}
function rW(i, t) {
  const e = [0, 0, 0];
  Pk(i, e), Ak(e, t);
}
function Lg(i) {
  return i[0] = 1, i[1] = -1, i[2] = 1, i[3] = -1, i[4] = 1, i[5] = -1, i;
}
function nN(i) {
  return !(i[1] - i[0] < 0);
}
function S$(i, t, e) {
  return e[0] = Math.min(i[0], t[0]), e[1] = Math.max(i[0], t[0]), e[2] = Math.min(i[1], t[1]), e[3] = Math.max(i[1], t[1]), e[4] = Math.min(i[2], t[2]), e[5] = Math.max(i[2], t[2]), e;
}
function Ol(i, t, e) {
  return i < t ? t : i > e ? e : i;
}
function $S(i, t, e) {
  let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [0, 0, 0];
  return n[0] = Ol(i[0], t[0], e[0]), n[1] = Ol(i[1], t[1], e[1]), n[2] = Ol(i[2], t[2], e[2]), n;
}
function L$(i, t) {
  let e = 0;
  return t[0] !== t[1] && (i < t[0] ? e = t[0] : i > t[1] ? e = t[1] : e = i, e = (e - t[0]) / (t[1] - t[0])), e;
}
const V$ = xT("GetScalarTypeFittingRange"), X$ = xT("GetAdjustedScalarRange");
function I$(i, t) {
  if (!i || !t)
    return 0;
  for (let e = 0; e < 6; e += 2)
    if (i[e] < t[e] || i[e] > t[e + 1] || i[e + 1] < t[e] || i[e + 1] > t[e + 1])
      return 0;
  return 1;
}
function C$(i, t, e) {
  if (!i || !t)
    return 0;
  for (let n = 0; n < 6; n += 2)
    if (i[n] + e[n / 2] < t[n] || i[n] - e[n / 2] > t[n + 1] || i[n + 1] + e[n / 2] < t[n] || i[n + 1] - e[n / 2] > t[n + 1])
      return 0;
  return 1;
}
function Y$(i, t, e) {
  if (!i || !t || !e)
    return 0;
  for (let n = 0; n < 3; n++)
    if (i[n] + e[n] < t[2 * n] || i[n] - e[n] > t[2 * n + 1])
      return 0;
  return 1;
}
function v$(i, t, e, n) {
  const s = Ri(3), r = Ri(3), a = Ri(3), o = Ri(3), l = Ri(3), c = Ri(3);
  for (let T = 0; T < 3; ++T)
    s[T] = i[T] - t[T], r[T] = t[T] - e[T], a[T] = e[T] - i[T], o[T] = -s[T], l[T] = -r[T], c[T] = -a[T];
  const u = Or(o), d = Or(l), h = Or(a), p = Ri(3);
  Wi(s, r, p);
  const m = Or(p), b = u * d * h / (2 * m), y = 2 * m * m, Z = d * d * tn(s, c) / y, g = h * h * tn(o, r) / y, f = u * u * tn(a, l) / y;
  for (let T = 0; T < 3; ++T)
    n[T] = Z * i[T] + g * t[T] + f * e[T];
  return b;
}
const R$ = 1 / 0, D$ = -1 / 0, Kk = (i) => !Number.isFinite(i), {
  isFinite: O$,
  isNaN: qS
} = Number, aW = qS;
function ad() {
  return [].concat([
    Number.MAX_VALUE,
    -Number.MAX_VALUE,
    // X
    Number.MAX_VALUE,
    -Number.MAX_VALUE,
    // Y
    Number.MAX_VALUE,
    -Number.MAX_VALUE
    // Z
  ]);
}
function z$(i) {
  let t = -1, e = -1;
  for (let n = 0; n < i.length; n++) {
    const s = Math.abs(i[n]);
    s > t && (e = n, t = s);
  }
  return e;
}
function Hk(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
  const e = new Array(t), n = new Array(t);
  for (let r = 0; r < t; ++r)
    e[r] = r, n[r] = r;
  for (let r = t - 1; r > 0; r--) {
    let a = -1 / 0, o = 0, l = 0;
    for (let c = 0; c <= r; ++c) {
      const u = e[c];
      for (let d = 0; d <= r; ++d) {
        const h = n[d], p = Math.abs(i[u + t * h]);
        p > a && (a = p, o = c, l = d);
      }
    }
    [e[r], e[o]] = [e[o], e[r]], [n[r], n[l]] = [n[l], n[r]];
  }
  const s = new Array(t * t).fill(0);
  for (let r = 0; r < t; ++r) {
    const a = e[r] + t * n[r];
    s[a] = i[a] < 0 ? -1 : 1;
  }
  return s;
}
function _k(i) {
  const t = Math.floor(i * 255);
  return t > 15 ? t.toString(16) : `0${t.toString(16)}`;
}
function E$(i) {
  return `${arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "#"}${i.map(_k).join("")}`;
}
function z1(i) {
  return Math.round(i * 255);
}
function k$(i) {
  return i.length === 3 ? `rgb(${i.map(z1).join(", ")})` : `rgba(${z1(i[0] || 0)}, ${z1(i[1] || 0)}, ${z1(i[2] || 0)}, ${i[3] || 0})`;
}
var Hn = {
  Pi: A6,
  radiansFromDegrees: Qi,
  degreesFromRadians: pg,
  round: $u,
  floor: d2,
  ceil: B6,
  ceilLog2: q6,
  min: K6,
  max: H6,
  arrayMin: _6,
  arrayMax: Q6,
  arrayRange: $6,
  isPowerOfTwo: gy,
  nearestPowerOfTwo: Qo,
  factorial: t$,
  binomial: e$,
  beginCombination: n$,
  nextCombination: i$,
  randomSeed: s$,
  getSeed: r$,
  random: a$,
  gaussian: o$,
  add: b0,
  subtract: fi,
  multiplyScalar: h2,
  multiplyScalar2D: Ik,
  multiplyAccumulate: AS,
  multiplyAccumulate2D: l$,
  dot: tn,
  outer: c$,
  cross: Wi,
  norm: Or,
  normalize: Fn,
  perpendiculars: u$,
  projectVector: BS,
  projectVector2D: d$,
  distance2BetweenPoints: zs,
  angleBetweenVectors: nd,
  gaussianAmplitude: h$,
  gaussianWeight: p$,
  dot2D: KS,
  outer2D: m$,
  norm2D: Ck,
  normalize2D: Yk,
  determinant2x2: is,
  LUFactor3x3: b$,
  LUSolve3x3: f$,
  linearSolve3x3: g$,
  multiply3x3_vect3: tN,
  multiply3x3_mat3: HS,
  multiplyMatrix: y$,
  transpose3x3: Xb,
  invert3x3: Z$,
  identity3x3: Rk,
  identity: Dk,
  isIdentity: T$,
  isIdentity3x3: Ok,
  determinant3x3: IG,
  quaternionToMatrix3x3: zk,
  areEquals: vk,
  areMatricesEqual: ST,
  roundNumber: eN,
  roundVector: _S,
  matrix3x3ToQuaternion: Ek,
  multiplyQuaternion: M$,
  orthogonalize3x3: kk,
  diagonalize3x3: Fk,
  singularValueDecomposition3x3: N$,
  solveLinearSystem: jk,
  invertMatrix: Uk,
  luFactorLinearSystem: cI,
  luSolveLinearSystem: uI,
  estimateMatrixCondition: W$,
  jacobi: G$,
  jacobiN: LT,
  solveHomogeneousLeastSquares: QS,
  solveLeastSquares: w$,
  hex2float: x$,
  rgb2hsv: yy,
  hsv2rgb: Yp,
  lab2xyz: Pk,
  xyz2lab: Jk,
  xyz2rgb: Ak,
  rgb2xyz: Bk,
  rgb2lab: kp,
  lab2rgb: rW,
  uninitializeBounds: Lg,
  areBoundsInitialized: nN,
  computeBoundsFromPoints: S$,
  clampValue: Ol,
  clampVector: $S,
  clampAndNormalizeValue: L$,
  getScalarTypeFittingRange: V$,
  getAdjustedScalarRange: X$,
  extentIsWithinOtherExtent: I$,
  boundsIsWithinOtherBounds: C$,
  pointIsWithinBounds: Y$,
  solve3PointCircle: v$,
  inf: R$,
  negInf: D$,
  isInf: Kk,
  isNan: qS,
  isNaN: qS,
  isFinite: O$,
  // JS add-on
  createUninitializedBounds: ad,
  getMajorAxisIndex: z$,
  getSparseOrthogonalMatrix: Hk,
  floatToHex2: _k,
  floatRGB2HexCode: E$,
  float2CssRGBA: k$
};
const tL = 1e-6, Qk = "coincide", $k = "disjoint";
function F$(i, t, e) {
  return i[0] * (e[0] - t[0]) + i[1] * (e[1] - t[1]) + i[2] * (e[2] - t[2]);
}
function qk(i, t, e) {
  const n = e[0] * (i[0] - t[0]) + e[1] * (i[1] - t[1]) + e[2] * (i[2] - t[2]);
  return Math.abs(n);
}
function tF(i, t, e, n) {
  const s = [];
  fi(i, t, s);
  const r = tn(e, s);
  n[0] = i[0] - r * e[0], n[1] = i[1] - r * e[1], n[2] = i[2] - r * e[2];
}
function eF(i, t, e) {
  const n = tn(i, t);
  let s = tn(t, t);
  return s === 0 && (s = 1), e[0] = i[0] - n * t[0] / s, e[1] = i[1] - n * t[1] / s, e[2] = i[2] - n * t[2] / s, e;
}
function nF(i, t, e, n) {
  const s = [];
  fi(i, t, s);
  const r = tn(e, s), a = tn(e, e);
  a !== 0 ? (n[0] = i[0] - r * e[0] / a, n[1] = i[1] - r * e[1] / a, n[2] = i[2] - r * e[2] / a) : (n[0] = i[0], n[1] = i[1], n[2] = i[2]);
}
function iF(i, t, e, n) {
  const s = {
    intersection: !1,
    betweenPoints: !1,
    t: Number.MAX_VALUE,
    x: []
  }, r = [], a = [];
  fi(t, i, r), fi(e, i, a);
  const o = tn(n, a), l = tn(n, r);
  let c, u;
  return l < 0 ? c = -l : c = l, o < 0 ? u = -o * tL : u = o * tL, c <= u || (s.t = o / l, s.x[0] = i[0] + s.t * r[0], s.x[1] = i[1] + s.t * r[1], s.x[2] = i[2] + s.t * r[2], s.intersection = !0, s.betweenPoints = s.t >= 0 && s.t <= 1), s;
}
function sF(i, t, e, n) {
  const s = {
    intersection: !1,
    l0: [],
    l1: [],
    error: null
  }, r = [];
  Wi(t, n, r);
  const a = r.map((d) => Math.abs(d));
  if (a[0] + a[1] + a[2] < tL) {
    const d = [];
    return fi(i, e, d), tn(t, d) === 0 ? s.error = Qk : s.error = $k, s;
  }
  let o;
  a[0] > a[1] && a[0] > a[2] ? o = "x" : a[1] > a[2] ? o = "y" : o = "z";
  const l = [], c = -tn(t, i), u = -tn(n, e);
  switch (o) {
    case "x":
      l[0] = 0, l[1] = (u * t[2] - c * n[2]) / r[0], l[2] = (c * n[1] - u * t[1]) / r[0];
      break;
    case "y":
      l[0] = (c * n[2] - u * t[2]) / r[1], l[1] = 0, l[2] = (u * t[0] - c * n[0]) / r[1];
      break;
    case "z":
      l[0] = (u * t[1] - c * n[1]) / r[2], l[1] = (c * n[0] - u * t[0]) / r[2], l[2] = 0;
      break;
  }
  return s.l0 = l, b0(l, r, s.l1), s.intersection = !0, s;
}
const j$ = {
  evaluate: F$,
  distanceToPlane: qk,
  projectPoint: tF,
  projectVector: eF,
  generalizedProjectPoint: nF,
  intersectWithLine: iF,
  intersectWithPlane: sF,
  DISJOINT: $k,
  COINCIDE: Qk
};
function U$(i, t) {
  t.classHierarchy.push("vtkPlane"), i.distanceToPlane = (e) => qk(e, t.origin, t.normal), i.projectPoint = (e, n) => {
    tF(e, t.origin, t.normal, n);
  }, i.projectVector = (e, n) => eF(e, t.normal, n), i.push = (e) => {
    if (e !== 0)
      for (let n = 0; n < 3; n++)
        t.origin[n] += e * t.normal[n];
  }, i.generalizedProjectPoint = (e, n) => {
    nF(e, t.origin, t.normal, n);
  }, i.evaluateFunction = (e, n, s) => Array.isArray(e) ? t.normal[0] * (e[0] - t.origin[0]) + t.normal[1] * (e[1] - t.origin[1]) + t.normal[2] * (e[2] - t.origin[2]) : t.normal[0] * (e - t.origin[0]) + t.normal[1] * (n - t.origin[1]) + t.normal[2] * (s - t.origin[2]), i.evaluateGradient = (e) => [t.normal[0], t.normal[1], t.normal[2]], i.intersectWithLine = (e, n) => iF(e, n, t.origin, t.normal), i.intersectWithPlane = (e, n) => sF(e, n, t.origin, t.normal);
}
const P$ = {
  normal: [0, 0, 1],
  origin: [0, 0, 0]
};
function rF(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, P$, e), tt.obj(i, t), tt.setGetArray(i, t, ["normal", "origin"], 3), U$(i, t);
}
const J$ = tt.newInstance(rF, "vtkPlane");
var li = {
  newInstance: J$,
  extend: rF,
  ...j$
};
const CG = [
  Number.MAX_VALUE,
  -Number.MAX_VALUE,
  // X
  Number.MAX_VALUE,
  -Number.MAX_VALUE,
  // Y
  Number.MAX_VALUE,
  -Number.MAX_VALUE
  // Z
];
function aF(i, t) {
  return i[0] === t[0] && i[1] === t[1] && i[2] === t[2] && i[3] === t[3] && i[4] === t[4] && i[5] === t[5];
}
function od(i) {
  return (i == null ? void 0 : i.length) >= 6 && i[0] <= i[1] && i[2] <= i[3] && i[4] <= i[5];
}
function dI(i, t) {
  return i[0] = t[0], i[1] = t[1], i[2] = t[2], i[3] = t[3], i[4] = t[4], i[5] = t[5], i;
}
function hI(i) {
  return dI(i, CG);
}
function oW(i, t, e, n) {
  const [s, r, a, o, l, c] = i;
  return i[0] = s < t ? s : t, i[1] = r > t ? r : t, i[2] = a < e ? a : e, i[3] = o > e ? o : e, i[4] = l < n ? l : n, i[5] = c > n ? c : n, i;
}
function pI(i, t) {
  if (t.length === 0)
    return i;
  if (Array.isArray(t[0]))
    for (let e = 0; e < t.length; ++e)
      oW(i, ...t[e]);
  else
    for (let e = 0; e < t.length; e += 3)
      oW(i, ...t.slice(e, e + 3));
  return i;
}
function oF(i, t, e, n, s, r, a) {
  const [o, l, c, u, d, h] = i;
  return a === void 0 ? (i[0] = Math.min(t[0], o), i[1] = Math.max(t[1], l), i[2] = Math.min(t[2], c), i[3] = Math.max(t[3], u), i[4] = Math.min(t[4], d), i[5] = Math.max(t[5], h)) : (i[0] = Math.min(t, o), i[1] = Math.max(e, l), i[2] = Math.min(n, c), i[3] = Math.max(s, u), i[4] = Math.min(r, d), i[5] = Math.max(a, h)), i;
}
function lF(i, t, e, n) {
  const [s, r, a, o, l, c] = i;
  return i[0] = t, i[1] = t > r ? t : r, i[2] = e, i[3] = e > o ? e : o, i[4] = n, i[5] = n > c ? n : c, s !== t || a !== e || l !== n;
}
function cF(i, t, e, n) {
  const [s, r, a, o, l, c] = i;
  return i[0] = t < s ? t : s, i[1] = t, i[2] = e < a ? e : a, i[3] = e, i[4] = n < l ? n : l, i[5] = n, r !== t || o !== e || c !== n;
}
function uF(i, t) {
  return i[0] -= t, i[1] += t, i[2] -= t, i[3] += t, i[4] -= t, i[5] += t, i;
}
function mI(i, t, e, n) {
  return od(i) ? (t >= 0 ? (i[0] *= t, i[1] *= t) : (i[0] = t * i[1], i[1] = t * i[0]), e >= 0 ? (i[2] *= e, i[3] *= e) : (i[2] = e * i[3], i[3] = e * i[2]), n >= 0 ? (i[4] *= n, i[5] *= n) : (i[4] = n * i[5], i[5] = n * i[4]), !0) : !1;
}
function bI(i) {
  return [0.5 * (i[0] + i[1]), 0.5 * (i[2] + i[3]), 0.5 * (i[4] + i[5])];
}
function A$(i, t, e, n) {
  if (!od(i))
    return !1;
  const s = bI(i);
  return i[0] -= s[0], i[1] -= s[0], i[2] -= s[1], i[3] -= s[1], i[4] -= s[2], i[5] -= s[2], mI(i, t, e, n), i[0] += s[0], i[1] += s[0], i[2] += s[1], i[3] += s[1], i[4] += s[2], i[5] += s[2], !0;
}
function t2(i, t) {
  return i[t * 2 + 1] - i[t * 2];
}
function YG(i) {
  return [t2(i, 0), t2(i, 1), t2(i, 2)];
}
function dF(i) {
  return i.slice(0, 2);
}
function hF(i) {
  return i.slice(2, 4);
}
function pF(i) {
  return i.slice(4, 6);
}
function mF(i) {
  const t = YG(i);
  return t[0] > t[1] ? t[0] > t[2] ? t[0] : t[2] : t[1] > t[2] ? t[1] : t[2];
}
function bF(i) {
  if (od(i)) {
    const t = YG(i);
    return Math.sqrt(t[0] * t[0] + t[1] * t[1] + t[2] * t[2]);
  }
  return null;
}
function fI(i) {
  return [i[0], i[2], i[4]];
}
function gI(i) {
  return [i[1], i[3], i[5]];
}
function E1(i, t) {
  return i <= 0 && t >= 0 || i >= 0 && t <= 0;
}
function yI(i, t) {
  let e = 0;
  for (let n = 0; n < 2; n++)
    for (let s = 2; s < 4; s++)
      for (let r = 4; r < 6; r++)
        t[e++] = [i[n], i[s], i[r]];
  return t;
}
function fF(i, t, e) {
  return t[0] = i[0], t[1] = i[2], t[2] = i[4], e[0] = i[1], e[1] = i[3], e[2] = i[5], t;
}
function gF(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
  const n = yI(i, []);
  for (let s = 0; s < n.length; ++s)
    I.transformMat4(n[s], n[s], t);
  return hI(e), pI(e, n);
}
function yF(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return t[0] = 0.5 * (i[1] - i[0]), t[1] = 0.5 * (i[3] - i[2]), t[2] = 0.5 * (i[5] - i[4]), t;
}
function ZF(i, t, e, n) {
  const s = [].concat(CG), r = i.getData();
  for (let a = 0; a < r.length; a += 3) {
    const o = [r[a], r[a + 1], r[a + 2]], l = tn(o, t);
    s[0] = Math.min(l, s[0]), s[1] = Math.max(l, s[1]);
    const c = tn(o, e);
    s[2] = Math.min(c, s[2]), s[3] = Math.max(c, s[3]);
    const u = tn(o, n);
    s[4] = Math.min(u, s[4]), s[5] = Math.max(u, s[5]);
  }
  return s;
}
function TF(i, t, e, n, s) {
  let r = !0;
  const a = [];
  let o = 0;
  const l = [], c = [0, 0, 0], u = 0, d = 1, h = 2;
  for (let p = 0; p < 3; p++)
    t[p] < i[2 * p] ? (a[p] = d, c[p] = i[2 * p], r = !1) : t[p] > i[2 * p + 1] ? (a[p] = u, c[p] = i[2 * p + 1], r = !1) : a[p] = h;
  if (r)
    return n[0] = t[0], n[1] = t[1], n[2] = t[2], s[0] = 0, 1;
  for (let p = 0; p < 3; p++)
    a[p] !== h && e[p] !== 0 ? l[p] = (c[p] - t[p]) / e[p] : l[p] = -1;
  for (let p = 0; p < 3; p++)
    l[o] < l[p] && (o = p);
  if (l[o] > 1 || l[o] < 0)
    return 0;
  s[0] = l[o];
  for (let p = 0; p < 3; p++)
    if (o !== p) {
      if (n[p] = t[p] + l[o] * e[p], n[p] < i[2 * p] || n[p] > i[2 * p + 1])
        return 0;
    } else
      n[p] = c[p];
  return 1;
}
function MF(i, t, e) {
  const n = [];
  let s = 0, r = 1, a = 1;
  for (let o = 4; o <= 5; ++o) {
    n[2] = i[o];
    for (let l = 2; l <= 3; ++l) {
      n[1] = i[l];
      for (let c = 0; c <= 1; ++c)
        if (n[0] = i[c], s = li.evaluate(e, t, n), a && (r = s >= 0 ? 1 : -1, a = 0), s === 0 || r > 0 && s < 0 || r < 0 && s > 0)
          return 1;
    }
  }
  return 0;
}
function NF(i, t) {
  if (!(od(i) && od(t)))
    return !1;
  const e = [0, 0, 0, 0, 0, 0];
  let n;
  for (let s = 0; s < 3; s++)
    if (n = !1, t[s * 2] >= i[s * 2] && t[s * 2] <= i[s * 2 + 1] ? (n = !0, e[s * 2] = t[s * 2]) : i[s * 2] >= t[s * 2] && i[s * 2] <= t[s * 2 + 1] && (n = !0, e[s * 2] = i[s * 2]), t[s * 2 + 1] >= i[s * 2] && t[s * 2 + 1] <= i[s * 2 + 1] ? (n = !0, e[s * 2 + 1] = t[2 * s + 1]) : i[s * 2 + 1] >= t[s * 2] && i[s * 2 + 1] <= t[s * 2 + 1] && (n = !0, e[s * 2 + 1] = i[s * 2 + 1]), !n)
      return !1;
  return i[0] = e[0], i[1] = e[1], i[2] = e[2], i[3] = e[3], i[4] = e[4], i[5] = e[5], !0;
}
function lW(i, t) {
  if (!(od(i) && od(t)))
    return !1;
  for (let e = 0; e < 3; e++)
    if (!(t[e * 2] >= i[e * 2] && t[e * 2] <= i[e * 2 + 1]) && !(i[e * 2] >= t[e * 2] && i[e * 2] <= t[e * 2 + 1]) && !(t[e * 2 + 1] >= i[e * 2] && t[e * 2 + 1] <= i[e * 2 + 1]) && !(i[e * 2 + 1] >= t[e * 2] && i[e * 2 + 1] <= t[e * 2 + 1]))
      return !1;
  return !0;
}
function cW(i, t, e, n) {
  return !(t < i[0] || t > i[1] || e < i[2] || e > i[3] || n < i[4] || n > i[5]);
}
function B$(i, t) {
  return !(!lW(i, t) || !cW(i, ...fI(t)) || !cW(i, ...gI(t)));
}
function WF(i, t, e) {
  const n = [[0, 1, 2, 3, 4, 5, 6, 7], [0, 1, 4, 5, 2, 3, 6, 7], [0, 2, 4, 6, 1, 3, 5, 7]], s = [0, 0, 0, 0, 0, 0, 0, 0];
  let r = 0;
  for (let d = 0; d < 2; d++)
    for (let h = 2; h < 4; h++)
      for (let p = 4; p < 6; p++) {
        const m = [i[d], i[h], i[p]];
        s[r++] = li.evaluate(e, t, m);
      }
  let a = 2;
  for (; a-- && !(E1(s[n[a][0]], s[n[a][4]]) && E1(s[n[a][1]], s[n[a][5]]) && E1(s[n[a][2]], s[n[a][6]]) && E1(s[n[a][3]], s[n[a][7]])); )
    ;
  if (a < 0)
    return !1;
  const o = Math.sign(e[a]), l = Math.abs((i[a * 2 + 1] - i[a * 2]) * e[a]);
  let c = o > 0 ? 1 : 0;
  for (let d = 0; d < 4; d++) {
    if (l === 0)
      continue;
    const h = Math.abs(s[n[a][d]]) / l;
    o > 0 && h < c && (c = h), o < 0 && h > c && (c = h);
  }
  const u = (1 - c) * i[a * 2] + c * i[a * 2 + 1];
  return o > 0 ? i[a * 2] = u : i[a * 2 + 1] = u, !0;
}
class K$ {
  constructor(t) {
    this.bounds = t, this.bounds || (this.bounds = new Float64Array(CG));
  }
  getBounds() {
    return this.bounds;
  }
  equals(t) {
    return aF(this.bounds, t);
  }
  isValid() {
    return od(this.bounds);
  }
  setBounds(t) {
    return dI(this.bounds, t);
  }
  reset() {
    return hI(this.bounds);
  }
  addPoint() {
    for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
      e[n] = arguments[n];
    return oW(this.bounds, ...e);
  }
  addPoints(t) {
    return pI(this.bounds, t);
  }
  addBounds(t, e, n, s, r, a) {
    return oF(this.bounds, t, e, n, s, r, a);
  }
  setMinPoint(t, e, n) {
    return lF(this.bounds, t, e, n);
  }
  setMaxPoint(t, e, n) {
    return cF(this.bounds, t, e, n);
  }
  inflate(t) {
    return uF(this.bounds, t);
  }
  scale(t, e, n) {
    return mI(this.bounds, t, e, n);
  }
  getCenter() {
    return bI(this.bounds);
  }
  getLength(t) {
    return t2(this.bounds, t);
  }
  getLengths() {
    return YG(this.bounds);
  }
  getMaxLength() {
    return mF(this.bounds);
  }
  getDiagonalLength() {
    return bF(this.bounds);
  }
  getMinPoint() {
    return fI(this.bounds);
  }
  getMaxPoint() {
    return gI(this.bounds);
  }
  getXRange() {
    return dF(this.bounds);
  }
  getYRange() {
    return hF(this.bounds);
  }
  getZRange() {
    return pF(this.bounds);
  }
  getCorners(t) {
    return yI(this.bounds, t);
  }
  computeCornerPoints(t, e) {
    return fF(this.bounds, t, e);
  }
  computeLocalBounds(t, e, n) {
    return ZF(this.bounds, t, e, n);
  }
  transformBounds(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return gF(this.bounds, t, e);
  }
  computeScale3(t) {
    return yF(this.bounds, t);
  }
  cutWithPlane(t, e) {
    return WF(this.bounds, t, e);
  }
  intersectBox(t, e, n, s) {
    return TF(this.bounds, t, e, n, s);
  }
  intersectPlane(t, e) {
    return MF(this.bounds, t, e);
  }
  intersect(t) {
    return NF(this.bounds, t);
  }
  intersects(t) {
    return lW(this.bounds, t);
  }
  containsPoint(t, e, n) {
    return cW(this.bounds, t, e, n);
  }
  contains(t) {
    return lW(this.bounds, t);
  }
}
function H$(i) {
  const t = i && i.bounds;
  return new K$(t);
}
const _$ = {
  equals: aF,
  isValid: od,
  setBounds: dI,
  reset: hI,
  addPoint: oW,
  addPoints: pI,
  addBounds: oF,
  setMinPoint: lF,
  setMaxPoint: cF,
  inflate: uF,
  scale: mI,
  scaleAboutCenter: A$,
  getCenter: bI,
  getLength: t2,
  getLengths: YG,
  getMaxLength: mF,
  getDiagonalLength: bF,
  getMinPoint: fI,
  getMaxPoint: gI,
  getXRange: dF,
  getYRange: hF,
  getZRange: pF,
  getCorners: yI,
  computeCornerPoints: fF,
  computeLocalBounds: ZF,
  transformBounds: gF,
  computeScale3: yF,
  cutWithPlane: WF,
  intersectBox: TF,
  intersectPlane: MF,
  intersect: NF,
  intersects: lW,
  containsPoint: cW,
  contains: B$,
  INIT_BOUNDS: CG
};
var qe = {
  newInstance: H$,
  ..._$
};
const GF = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
}, Ke = {
  VOID: "",
  // not sure to know what that should be
  CHAR: "Int8Array",
  SIGNED_CHAR: "Int8Array",
  UNSIGNED_CHAR: "Uint8Array",
  UNSIGNED_CHAR_CLAMPED: "Uint8ClampedArray",
  // should be used for VTK.js internal purpose only
  SHORT: "Int16Array",
  UNSIGNED_SHORT: "Uint16Array",
  INT: "Int32Array",
  UNSIGNED_INT: "Uint32Array",
  FLOAT: "Float32Array",
  DOUBLE: "Float64Array"
}, Q$ = Ke.FLOAT;
var wF = {
  DefaultDataType: Q$,
  DataTypeByteSize: GF,
  VtkDataTypes: Ke
};
const {
  vtkErrorMacro: $$
} = kr, {
  DefaultDataType: q$
} = wF, tq = 1e-6;
function eL(i, t, e) {
  const n = i.length;
  let s = Number.MAX_VALUE, r = -Number.MAX_VALUE, a, o;
  for (o = t; o < n; o += e)
    if (!Number.isNaN(i[o])) {
      s = i[o], r = s;
      break;
    }
  for (; o < n; o += e)
    a = i[o], a < s ? s = a : a > r && (r = a);
  return {
    min: s,
    max: r
  };
}
function eq() {
  let i = Number.MAX_VALUE, t = -Number.MAX_VALUE, e = 0, n = 0;
  return {
    add(s) {
      i > s && (i = s), t < s && (t = s), e++, n += s;
    },
    get() {
      return {
        min: i,
        max: t,
        count: e,
        sum: n,
        mean: n / e
      };
    },
    getRange() {
      return {
        min: i,
        max: t
      };
    }
  };
}
function xF(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  if (t < 0 && e > 1) {
    const s = i.length / e, r = new Float64Array(s);
    for (let a = 0, o = 0; a < s; ++a) {
      for (let l = o + e; o < l; ++o)
        r[a] += i[o] * i[o];
      r[a] **= 0.5;
    }
    return eL(r, 0, 1);
  }
  return eL(i, t < 0 ? 0 : t, e);
}
function pD(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  const e = i || [];
  for (; e.length <= t; )
    e.push(null);
  return e;
}
function ZI(i) {
  return Object.prototype.toString.call(i).slice(8, -1);
}
function nq(i) {
  const t = i.getNumberOfComponents();
  let e = 0;
  const n = new Array(t);
  for (let s = 0; s < i.getNumberOfTuples(); ++s) {
    i.getTuple(s, n);
    const r = Or(n, t);
    r > e && (e = r);
  }
  return e;
}
const iq = {
  computeRange: xF,
  createRangeHelper: eq,
  fastComputeRange: eL,
  getDataType: ZI,
  getMaxNorm: nq
};
function sq(i, t) {
  t.classHierarchy.push("vtkDataArray");
  function e(n) {
    if (n < 0)
      return !1;
    const s = i.getNumberOfComponents(), r = t.values.length / (s > 0 ? s : 1);
    if (n === r)
      return !0;
    if (n > r) {
      const a = t.values;
      return t.values = xg(t.dataType, (n + r) * s), t.values.set(a), !0;
    }
    return t.size > n * s && (t.size = n * s, i.dataChange()), !0;
  }
  i.dataChange = () => {
    t.ranges = null, i.modified();
  }, i.resize = (n) => {
    e(n);
    const s = n * i.getNumberOfComponents();
    return t.size !== s ? (t.size = s, i.dataChange(), !0) : !1;
  }, i.initialize = () => {
    i.resize(0);
  }, i.getElementComponentSize = () => t.values.BYTES_PER_ELEMENT, i.getComponent = function(n) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return t.values[n * t.numberOfComponents + s];
  }, i.setComponent = (n, s, r) => {
    r !== t.values[n * t.numberOfComponents + s] && (t.values[n * t.numberOfComponents + s] = r, i.dataChange());
  }, i.getValue = (n) => {
    const s = n / t.numberOfComponents, r = n % t.numberOfComponents;
    return i.getComponent(s, r);
  }, i.setValue = (n, s) => {
    const r = n / t.numberOfComponents, a = n % t.numberOfComponents;
    i.setComponent(r, a, s);
  }, i.getData = () => t.size === t.values.length ? t.values : t.values.subarray(0, t.size), i.getRange = function() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : -1, s = n;
    s < 0 && (s = t.numberOfComponents === 1 ? 0 : t.numberOfComponents);
    let r = null;
    return t.ranges || (t.ranges = pD(t.ranges, t.numberOfComponents)), r = t.ranges[s], r ? (t.rangeTuple[0] = r.min, t.rangeTuple[1] = r.max, t.rangeTuple) : (r = xF(i.getData(), n, t.numberOfComponents), t.ranges[s] = r, t.rangeTuple[0] = r.min, t.rangeTuple[1] = r.max, t.rangeTuple);
  }, i.setRange = (n, s) => {
    t.ranges || (t.ranges = pD(t.ranges, t.numberOfComponents));
    const r = {
      min: n.min,
      max: n.max
    };
    return t.ranges[s] = r, t.rangeTuple[0] = r.min, t.rangeTuple[1] = r.max, t.rangeTuple;
  }, i.setTuple = (n, s) => {
    const r = n * t.numberOfComponents;
    for (let a = 0; a < t.numberOfComponents; a++)
      t.values[r + a] = s[a];
  }, i.setTuples = (n, s) => {
    let r = n * t.numberOfComponents;
    const a = Math.min(s.length, t.size - r);
    for (let o = 0; o < a; )
      t.values[r++] = s[o++];
  }, i.insertTuple = (n, s) => (t.size <= n * t.numberOfComponents && (t.size = (n + 1) * t.numberOfComponents, e(n + 1)), i.setTuple(n, s), n), i.insertTuples = (n, s) => {
    const r = n + s.length / t.numberOfComponents;
    return t.size < r * t.numberOfComponents && (t.size = r * t.numberOfComponents, e(r)), i.setTuples(n, s), r;
  }, i.insertNextTuple = (n) => {
    const s = t.size / t.numberOfComponents;
    return i.insertTuple(s, n);
  }, i.insertNextTuples = (n) => {
    const s = t.size / t.numberOfComponents;
    return i.insertTuples(s, n);
  }, i.findTuple = function(n) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : tq;
    for (let r = 0; r < t.size; r += t.numberOfComponents)
      if (Math.abs(n[0] - t.values[r]) <= s) {
        let a = !0;
        for (let o = 1; o < t.numberOfComponents; ++o)
          if (Math.abs(n[o] - t.values[r + o]) > s) {
            a = !1;
            break;
          }
        if (a)
          return r / t.numberOfComponents;
      }
    return -1;
  }, i.getTuple = function(n) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    const r = t.numberOfComponents || 1, a = n * r;
    switch (r) {
      case 4:
        s[3] = t.values[a + 3];
      // eslint-disable-next-line no-fallthrough
      case 3:
        s[2] = t.values[a + 2];
      // eslint-disable-next-line no-fallthrough
      case 2:
        s[1] = t.values[a + 1];
      // eslint-disable-next-line no-fallthrough
      case 1:
        s[0] = t.values[a];
        break;
      default:
        for (let o = r - 1; o >= 0; --o)
          s[o] = t.values[a + o];
    }
    return s;
  }, i.getTuples = (n, s) => {
    const r = (n ?? 0) * t.numberOfComponents, a = (s ?? i.getNumberOfTuples()) * t.numberOfComponents, o = i.getData().subarray(r, a);
    return o.length > 0 ? o : null;
  }, i.getTupleLocation = function() {
    return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1) * t.numberOfComponents;
  }, i.getNumberOfComponents = () => t.numberOfComponents, i.getNumberOfValues = () => t.size, i.getNumberOfTuples = () => t.size / t.numberOfComponents, i.getDataType = () => t.dataType, i.newClone = () => LF({
    empty: !0,
    name: t.name,
    dataType: t.dataType,
    numberOfComponents: t.numberOfComponents
  }), i.getName = () => (t.name || (i.modified(), t.name = `vtkDataArray${i.getMTime()}`), t.name), i.setData = (n, s) => {
    t.values = n, t.size = n.length, t.dataType = ZI(n), s && (t.numberOfComponents = s), t.size % t.numberOfComponents !== 0 && (t.numberOfComponents = 1), i.dataChange();
  }, i.getState = () => {
    if (t.deleted)
      return null;
    const n = {
      ...t,
      vtkClass: i.getClassName()
    };
    n.values = Array.from(n.values), delete n.buffer, Object.keys(n).forEach((r) => {
      n[r] || delete n[r];
    });
    const s = {};
    return Object.keys(n).sort().forEach((r) => {
      s[r] = n[r];
    }), s.mtime && delete s.mtime, s;
  }, i.deepCopy = (n) => {
    const s = i.getDataType(), r = t.values;
    i.shallowCopy(n), (r == null ? void 0 : r.length) >= n.getNumberOfValues() && s === n.getDataType() ? (r.set(n.getData()), t.values = r, i.dataChange()) : i.setData(n.getData().slice());
  }, i.interpolateTuple = (n, s, r, a, o, l) => {
    const c = t.numberOfComponents || 1;
    (c !== s.getNumberOfComponents() || c !== a.getNumberOfComponents()) && $$("numberOfComponents must match");
    const u = s.getTuple(r), d = a.getTuple(o), h = [];
    switch (h.length = c, c) {
      case 4:
        h[3] = u[3] + (d[3] - u[3]) * l;
      // eslint-disable-next-line no-fallthrough
      case 3:
        h[2] = u[2] + (d[2] - u[2]) * l;
      // eslint-disable-next-line no-fallthrough
      case 2:
        h[1] = u[1] + (d[1] - u[1]) * l;
      // eslint-disable-next-line no-fallthrough
      case 1:
        h[0] = u[0] + (d[0] - u[0]) * l;
        break;
      default:
        for (let p = 0; p < c; p++)
          h[p] = u[p] + (d[p] - u[p]) * l;
    }
    return i.insertTuple(n, h);
  };
}
const rq = {
  name: "",
  numberOfComponents: 1,
  dataType: q$,
  rangeTuple: [0, 0]
  // size: undefined,
  // values: null,
  // ranges: null,
};
function SF(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (Object.assign(t, rq, e), !t.empty && !t.values && !t.size)
    throw new TypeError("Cannot create vtkDataArray object without: size > 0, values");
  if (t.values ? Array.isArray(t.values) && (t.values = LG(t.dataType, t.values)) : t.values = xg(t.dataType, t.size), t.values && (t.size = t.size ?? t.values.length, t.dataType = ZI(t.values)), xi(i, t), GT(i, t, ["name", "numberOfComponents"]), t.size % t.numberOfComponents !== 0)
    throw new RangeError("model.size is not a multiple of model.numberOfComponents");
  sq(i, t);
}
const LF = In(SF, "vtkDataArray");
var We = {
  newInstance: LF,
  extend: SF,
  ...iq,
  ...wF
};
const {
  vtkErrorMacro: mD,
  vtkWarningMacro: aq
} = tt;
function oq(i, t) {
  t.classHierarchy.push("vtkFieldData");
  const e = i.getState;
  t.arrays && (t.arrays = t.arrays.map((n) => ({
    data: Dl(n.data)
  }))), i.initialize = () => {
    i.initializeFields(), i.copyAllOn(), i.clearFieldFlags();
  }, i.initializeFields = () => {
    t.arrays = [], t.copyFieldFlags = {}, i.modified();
  }, i.copyStructure = (n) => {
    i.initializeFields(), t.copyFieldFlags = n.getCopyFieldFlags().map((s) => s), t.arrays = n.arrays().map((s) => ({
      array: s
    }));
  }, i.getNumberOfArrays = () => t.arrays.length, i.getNumberOfActiveArrays = () => t.arrays.length, i.addArray = (n) => {
    const s = n.getName(), {
      array: r,
      index: a
    } = i.getArrayWithIndex(s);
    return r != null ? (t.arrays[a] = {
      data: n
    }, a) : (t.arrays = [].concat(t.arrays, {
      data: n
    }), t.arrays.length - 1);
  }, i.removeAllArrays = () => {
    t.arrays = [];
  }, i.removeArray = (n) => {
    const s = t.arrays.findIndex((r) => r.data.getName() === n);
    return i.removeArrayByIndex(s);
  }, i.removeArrayByIndex = (n) => n !== -1 && n < t.arrays.length ? (t.arrays.splice(n, 1), !0) : !1, i.getArrays = () => t.arrays.map((n) => n.data), i.getArray = (n) => typeof n == "number" ? i.getArrayByIndex(n) : i.getArrayByName(n), i.getArrayByName = (n) => t.arrays.reduce((s, r, a) => r.data.getName() === n ? r.data : s, null), i.getArrayWithIndex = (n) => {
    const s = t.arrays.findIndex((r) => r.data.getName() === n);
    return {
      array: s !== -1 ? t.arrays[s].data : null,
      index: s
    };
  }, i.getArrayByIndex = (n) => n >= 0 && n < t.arrays.length ? t.arrays[n].data : null, i.hasArray = (n) => i.getArrayWithIndex(n).index >= 0, i.getArrayName = (n) => {
    const s = t.arrays[n];
    return s ? s.data.getName() : "";
  }, i.getCopyFieldFlags = () => t.copyFieldFlags, i.getFlag = (n) => t.copyFieldFlags[n], i.passData = function(n) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
    n.getArrays().forEach((a) => {
      const o = i.getFlag(a.getName());
      if (o !== !1 && !(t.doCopyAllOff && o !== !0) && a) {
        let l = i.getArrayByName(a.getName());
        if (l)
          if (a.getNumberOfComponents() === l.getNumberOfComponents())
            if (s > -1 && s < a.getNumberOfTuples()) {
              const c = r > -1 ? r : s;
              l.insertTuple(c, a.getTuple(s));
            } else
              l.insertTuples(0, a.getTuples());
          else
            mD("Unhandled case in passData");
        else if (s < 0 || s > a.getNumberOfTuples())
          i.addArray(a), n.getAttributes(a).forEach((c) => {
            i.setAttribute(a, c);
          });
        else {
          const c = a.getNumberOfComponents();
          let u = a.getNumberOfValues();
          const d = r > -1 ? r : s;
          u <= d * c && (u = (d + 1) * c), l = We.newInstance({
            name: a.getName(),
            dataType: a.getDataType(),
            numberOfComponents: c,
            values: tt.newTypedArray(a.getDataType(), u),
            size: 0
          }), l.insertTuple(d, a.getTuple(s)), i.addArray(l), n.getAttributes(a).forEach((h) => {
            i.setAttribute(l, h);
          });
        }
      }
    });
  }, i.interpolateData = function(n) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : -1, o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0.5;
    n.getArrays().forEach((l) => {
      const c = i.getFlag(l.getName());
      if (c !== !1 && !(t.doCopyAllOff && c !== !0) && l) {
        let u = i.getArrayByName(l.getName());
        if (u)
          if (l.getNumberOfComponents() === u.getNumberOfComponents())
            if (s > -1 && s < l.getNumberOfTuples()) {
              const d = a > -1 ? a : s;
              u.interpolateTuple(d, l, s, l, r, o), aq("Unexpected case in interpolateData");
            } else
              u.insertTuples(l.getTuples());
          else
            mD("Unhandled case in interpolateData");
        else if (s < 0 || r < 0 || s > l.getNumberOfTuples())
          i.addArray(l), n.getAttributes(l).forEach((d) => {
            i.setAttribute(l, d);
          });
        else {
          const d = l.getNumberOfComponents();
          let h = l.getNumberOfValues();
          const p = a > -1 ? a : s;
          h <= p * d && (h = (p + 1) * d), u = We.newInstance({
            name: l.getName(),
            dataType: l.getDataType(),
            numberOfComponents: d,
            values: tt.newTypedArray(l.getDataType(), h),
            size: 0
          }), u.interpolateTuple(p, l, s, l, r, o), i.addArray(u), n.getAttributes(l).forEach((m) => {
            i.setAttribute(u, m);
          });
        }
      }
    });
  }, i.copyFieldOn = (n) => {
    t.copyFieldFlags[n] = !0;
  }, i.copyFieldOff = (n) => {
    t.copyFieldFlags[n] = !1;
  }, i.copyAllOn = () => {
    (!t.doCopyAllOn || t.doCopyAllOff) && (t.doCopyAllOn = !0, t.doCopyAllOff = !1, i.modified());
  }, i.copyAllOff = () => {
    (t.doCopyAllOn || !t.doCopyAllOff) && (t.doCopyAllOn = !1, t.doCopyAllOff = !0, i.modified());
  }, i.clearFieldFlags = () => {
    t.copyFieldFlags = {};
  }, i.deepCopy = (n) => {
    t.arrays = n.getArrays().map((s) => {
      const r = s.newClone();
      return r.deepCopy(s), {
        data: r
      };
    });
  }, i.copyFlags = (n) => n.getCopyFieldFlags().map((s) => s), i.reset = () => t.arrays.forEach((n) => n.data.reset()), i.getMTime = () => t.arrays.reduce((n, s) => s.data.getMTime() > n ? s.data.getMTime() : n, t.mtime), i.getNumberOfComponents = () => t.arrays.reduce((n, s) => n + s.data.getNumberOfComponents(), 0), i.getNumberOfTuples = () => t.arrays.length > 0 ? t.arrays[0].getNumberOfTuples() : 0, i.getState = () => {
    const n = e();
    return n && (n.arrays = t.arrays.map((s) => ({
      data: s.data.getState()
    }))), n;
  };
}
const lq = {
  arrays: [],
  copyFieldFlags: [],
  // fields not to copy
  doCopyAllOn: !0,
  doCopyAllOff: !1
};
function VF(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, lq, e), tt.obj(i, t), oq(i, t);
}
const cq = tt.newInstance(VF, "vtkFieldData");
var uq = {
  newInstance: cq,
  extend: VF
};
const dq = {
  SCALARS: 0,
  VECTORS: 1,
  NORMALS: 2,
  TCOORDS: 3,
  TENSORS: 4,
  GLOBALIDS: 5,
  PEDIGREEIDS: 6,
  EDGEFLAG: 7,
  NUM_ATTRIBUTES: 8
}, hq = {
  MAX: 0,
  EXACT: 1,
  NOLIMIT: 2
}, pq = {
  DUPLICATECELL: 1,
  // the cell is present on multiple processors
  HIGHCONNECTIVITYCELL: 2,
  // the cell has more neighbors than in a regular mesh
  LOWCONNECTIVITYCELL: 4,
  // the cell has less neighbors than in a regular mesh
  REFINEDCELL: 8,
  // other cells are present that refines it.
  EXTERIORCELL: 16,
  // the cell is on the exterior of the data set
  HIDDENCELL: 32
  // the cell is needed to maintain connectivity, but the data values should be ignored.
}, mq = {
  DUPLICATEPOINT: 1,
  // the cell is present on multiple processors
  HIDDENPOINT: 2
  // the point is needed to maintain connectivity, but the data values should be ignored.
}, bq = {
  COPYTUPLE: 0,
  INTERPOLATE: 1,
  PASSDATA: 2,
  ALLCOPY: 3
  // all of the above
}, fq = "vtkGhostType", uW = {
  DEFAULT: 0,
  // use the point type that does not truncate any data
  SINGLE: 1,
  // use Float32Array
  DOUBLE: 2
  // use Float64Array
};
var XF = {
  AttributeCopyOperations: bq,
  AttributeLimitTypes: hq,
  AttributeTypes: dq,
  CellGhostTypes: pq,
  DesiredOutputPrecision: uW,
  PointGhostTypes: mq,
  ghostArrayName: fq
};
const {
  AttributeTypes: wd,
  AttributeCopyOperations: fp
} = XF, {
  vtkWarningMacro: k1
} = tt;
function gq(i, t) {
  const e = ["Scalars", "Vectors", "Normals", "TCoords", "Tensors", "GlobalIds", "PedigreeIds"];
  function n(a) {
    let o = e.find((l) => wd[l.toUpperCase()] === a || typeof a != "number" && l.toLowerCase() === a.toLowerCase());
    return typeof o > "u" && (o = null), o;
  }
  t.classHierarchy.push("vtkDataSetAttributes");
  const s = {
    ...i
  };
  i.checkNumberOfComponents = (a) => !0, i.setAttribute = (a, o) => {
    const l = n(o);
    if (a && l.toUpperCase() === "PEDIGREEIDS" && !a.isA("vtkDataArray"))
      return k1(`Cannot set attribute ${l}. The attribute must be a vtkDataArray.`), -1;
    if (a && !i.checkNumberOfComponents(a, l))
      return k1(`Cannot set attribute ${l}. Incorrect number of components.`), -1;
    let c = t[`active${l}`];
    if (c >= 0 && c < t.arrays.length) {
      if (t.arrays[c] === a)
        return c;
      i.removeArrayByIndex(c);
    }
    return a ? (c = i.addArray(a), t[`active${l}`] = c) : t[`active${l}`] = -1, i.modified(), t[`active${l}`];
  }, i.getAttributes = (a) => e.filter((o) => i[`get${o}`]() === a), i.setActiveAttributeByName = (a, o) => i.setActiveAttributeByIndex(i.getArrayWithIndex(a).index, o), i.setActiveAttributeByIndex = (a, o) => {
    const l = n(o);
    if (a >= 0 && a < t.arrays.length) {
      if (l.toUpperCase() !== "PEDIGREEIDS") {
        const c = i.getArrayByIndex(a);
        if (!c.isA("vtkDataArray"))
          return k1(`Cannot set attribute ${l}. Only vtkDataArray subclasses can be set as active attributes.`), -1;
        if (!i.checkNumberOfComponents(c, l))
          return k1(`Cannot set attribute ${l}. Incorrect number of components.`), -1;
      }
      return t[`active${l}`] = a, i.modified(), a;
    }
    return a === -1 && (t[`active${l}`] = a, i.modified()), -1;
  }, i.getActiveAttribute = (a) => {
    const o = n(a);
    return i[`get${o}`]();
  }, i.removeAllArrays = () => {
    e.forEach((a) => {
      t[`active${a}`] = -1;
    }), s.removeAllArrays();
  }, i.removeArrayByIndex = (a) => (a !== -1 && e.forEach((o) => {
    a === t[`active${o}`] ? t[`active${o}`] = -1 : a < t[`active${o}`] && (t[`active${o}`] -= 1);
  }), s.removeArrayByIndex(a)), e.forEach((a) => {
    const o = `active${a}`;
    i[`get${a}`] = () => i.getArrayByIndex(t[o]), i[`set${a}`] = (l) => i.setAttribute(l, a), i[`setActive${a}`] = (l) => i.setActiveAttributeByIndex(i.getArrayWithIndex(l).index, a), i[`copy${a}Off`] = () => {
      const l = a.toUpperCase();
      t.copyAttributeFlags[fp.PASSDATA][wd[l]] = !1;
    }, i[`copy${a}On`] = () => {
      const l = a.toUpperCase();
      t.copyAttributeFlags[fp.PASSDATA][wd[l]] = !0;
    };
  }), i.initializeAttributeCopyFlags = () => {
    t.copyAttributeFlags = [], Object.keys(fp).filter((a) => a !== "ALLCOPY").forEach((a) => {
      t.copyAttributeFlags[fp[a]] = Object.keys(wd).filter((o) => o !== "NUM_ATTRIBUTES").reduce((o, l) => (o[wd[l]] = !0, o), []);
    }), t.copyAttributeFlags[fp.COPYTUPLE][wd.GLOBALIDS] = !1, t.copyAttributeFlags[fp.INTERPOLATE][wd.GLOBALIDS] = !1, t.copyAttributeFlags[fp.COPYTUPLE][wd.PEDIGREEIDS] = !1;
  }, i.initialize = tt.chain(i.initialize, i.initializeAttributeCopyFlags), t.dataArrays && Object.keys(t.dataArrays).length && Object.keys(t.dataArrays).forEach((a) => {
    !t.dataArrays[a].ref && t.dataArrays[a].type === "vtkDataArray" && i.addArray(We.newInstance(t.dataArrays[a]));
  });
  const r = i.shallowCopy;
  i.shallowCopy = (a, o) => {
    r(a, o), t.arrays = a.getArrays().map((l) => {
      const c = l.newClone();
      return c.shallowCopy(l, o), {
        data: c
      };
    });
  }, i.initializeAttributeCopyFlags();
}
const yq = {
  activeScalars: -1,
  activeVectors: -1,
  activeTensors: -1,
  activeNormals: -1,
  activeTCoords: -1,
  activeGlobalIds: -1,
  activePedigreeIds: -1
};
function IF(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, yq, e), uq.extend(i, t, e), tt.setGet(i, t, ["activeScalars", "activeNormals", "activeTCoords", "activeVectors", "activeTensors", "activeGlobalIds", "activePedigreeIds"]), t.arrays || (t.arrays = {}), gq(i, t);
}
const Zq = tt.newInstance(IF, "vtkDataSetAttributes");
var bD = {
  newInstance: Zq,
  extend: IF,
  ...XF
};
const Tq = {
  UNIFORM: 0,
  // data that does not vary over points/cells/etc.
  DATA_OBJECT_FIELD: 0,
  // to match VTK
  COORDINATE: 1,
  // data that specifies the location of each point
  POINT_DATA: 1,
  // to match VTK
  POINT: 2,
  // data defined at each point, but that does not specify the point location
  POINT_FIELD_DATA: 2,
  // to match VTK
  CELL: 3,
  // data defined at each cell, but that does not specify the cell
  CELL_FIELD_DATA: 3,
  // to match VTK
  VERTEX: 4,
  // data defined at each graph vertex, but that does not specify the graph vertex
  VERTEX_FIELD_DATA: 4,
  // to match VTK
  EDGE: 5,
  // data defined at each graph edge, but that does not specify the graph edge
  EDGE_FIELD_DATA: 5,
  // to match VTK
  ROW: 6,
  // data specifying a table row
  ROW_DATA: 6
  // to match VTK
}, f0 = {
  FIELD_ASSOCIATION_POINTS: 0,
  FIELD_ASSOCIATION_CELLS: 1,
  FIELD_ASSOCIATION_NONE: 2,
  FIELD_ASSOCIATION_POINTS_THEN_CELLS: 3,
  FIELD_ASSOCIATION_VERTICES: 4,
  FIELD_ASSOCIATION_EDGES: 5,
  FIELD_ASSOCIATION_ROWS: 6,
  NUMBER_OF_ASSOCIATIONS: 7
};
var Mq = {
  FieldDataTypes: Tq,
  FieldAssociations: f0
};
const nL = ["pointData", "cellData", "fieldData"];
function Nq(i, t) {
  t.classHierarchy.push("vtkDataSet"), nL.forEach((n) => {
    t[n] ? t[n] = Dl(t[n]) : t[n] = bD.newInstance();
  });
  const e = i.shallowCopy;
  i.shallowCopy = function(n) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    e(n, s), nL.forEach((r) => {
      t[r] = bD.newInstance(), t[r].shallowCopy(n.getReferenceByName(r));
    });
  };
}
const Wq = {
  // pointData: null,
  // cellData: null,
  // fieldData: null,
};
function CF(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Wq, e), tt.obj(i, t), tt.setGet(i, t, nL), Nq(i, t);
}
const Gq = tt.newInstance(CF, "vtkDataSet");
var Vg = {
  newInstance: Gq,
  extend: CF,
  ...Mq
};
const ml = {
  UNCHANGED: 0,
  SINGLE_POINT: 1,
  X_LINE: 2,
  Y_LINE: 3,
  Z_LINE: 4,
  XY_PLANE: 5,
  YZ_PLANE: 6,
  XZ_PLANE: 7,
  XYZ_GRID: 8,
  EMPTY: 9
};
var YF = {
  StructuredType: ml
};
const {
  StructuredType: _c
} = YF;
function wq(i) {
  let t = 0;
  for (let e = 0; e < 3; ++e)
    i[e * 2] < i[e * 2 + 1] && t++;
  return i[0] > i[1] || i[2] > i[3] || i[4] > i[5] ? _c.EMPTY : t === 3 ? _c.XYZ_GRID : t === 2 ? i[0] === i[1] ? _c.YZ_PLANE : i[2] === i[3] ? _c.XZ_PLANE : _c.XY_PLANE : t === 1 ? i[0] < i[1] ? _c.X_LINE : i[2] < i[3] ? _c.Y_LINE : _c.Z_LINE : _c.SINGLE_POINT;
}
var xq = {
  getDataDescriptionFromExtent: wq,
  ...YF
};
const {
  vtkErrorMacro: gp
} = tt;
function Sq(i, t) {
  t.classHierarchy.push("vtkImageData"), i.setExtent = function() {
    if (t.deleted)
      return gp("instance deleted - cannot call any method"), !1;
    for (var e = arguments.length, n = new Array(e), s = 0; s < e; s++)
      n[s] = arguments[s];
    const r = n.length === 1 ? n[0] : n;
    if (r.length !== 6)
      return !1;
    const a = t.extent.some((o, l) => o !== r[l]);
    return a && (t.extent = r.slice(), t.dataDescription = xq.getDataDescriptionFromExtent(t.extent), i.modified()), a;
  }, i.setDimensions = function() {
    let e, n, s;
    if (t.deleted) {
      gp("instance deleted - cannot call any method");
      return;
    }
    if (arguments.length === 1) {
      const r = arguments.length <= 0 ? void 0 : arguments[0];
      e = r[0], n = r[1], s = r[2];
    } else if (arguments.length === 3)
      e = arguments.length <= 0 ? void 0 : arguments[0], n = arguments.length <= 1 ? void 0 : arguments[1], s = arguments.length <= 2 ? void 0 : arguments[2];
    else {
      gp("Bad dimension specification");
      return;
    }
    i.setExtent(0, e - 1, 0, n - 1, 0, s - 1);
  }, i.getDimensions = () => [t.extent[1] - t.extent[0] + 1, t.extent[3] - t.extent[2] + 1, t.extent[5] - t.extent[4] + 1], i.getNumberOfCells = () => {
    const e = i.getDimensions();
    let n = 1;
    for (let s = 0; s < 3; s++) {
      if (e[s] === 0)
        return 0;
      e[s] > 1 && (n *= e[s] - 1);
    }
    return n;
  }, i.getNumberOfPoints = () => {
    const e = i.getDimensions();
    return e[0] * e[1] * e[2];
  }, i.getPoint = (e) => {
    const n = i.getDimensions();
    if (n[0] === 0 || n[1] === 0 || n[2] === 0)
      return gp("Requesting a point from an empty image."), null;
    const s = new Float64Array(3);
    switch (t.dataDescription) {
      case ml.EMPTY:
        return null;
      case ml.SINGLE_POINT:
        break;
      case ml.X_LINE:
        s[0] = e;
        break;
      case ml.Y_LINE:
        s[1] = e;
        break;
      case ml.Z_LINE:
        s[2] = e;
        break;
      case ml.XY_PLANE:
        s[0] = e % n[0], s[1] = e / n[0];
        break;
      case ml.YZ_PLANE:
        s[1] = e % n[1], s[2] = e / n[1];
        break;
      case ml.XZ_PLANE:
        s[0] = e % n[0], s[2] = e / n[0];
        break;
      case ml.XYZ_GRID:
        s[0] = e % n[0], s[1] = e / n[0] % n[1], s[2] = e / (n[0] * n[1]);
        break;
      default:
        gp("Invalid dataDescription");
        break;
    }
    const r = [0, 0, 0];
    return i.indexToWorld(s, r), r;
  }, i.getBounds = () => i.extentToBounds(i.getSpatialExtent()), i.extentToBounds = (e) => qe.transformBounds(e, t.indexToWorld), i.getSpatialExtent = () => qe.inflate([...t.extent], 0.5), i.computeTransforms = () => {
    ut.fromTranslation(t.indexToWorld, t.origin), t.indexToWorld[0] = t.direction[0], t.indexToWorld[1] = t.direction[1], t.indexToWorld[2] = t.direction[2], t.indexToWorld[4] = t.direction[3], t.indexToWorld[5] = t.direction[4], t.indexToWorld[6] = t.direction[5], t.indexToWorld[8] = t.direction[6], t.indexToWorld[9] = t.direction[7], t.indexToWorld[10] = t.direction[8], ut.scale(t.indexToWorld, t.indexToWorld, t.spacing), ut.invert(t.worldToIndex, t.indexToWorld);
  }, i.indexToWorld = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return I.transformMat4(n, e, t.indexToWorld), n;
  }, i.indexToWorldVec3 = i.indexToWorld, i.worldToIndex = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return I.transformMat4(n, e, t.worldToIndex), n;
  }, i.worldToIndexVec3 = i.worldToIndex, i.indexToWorldBounds = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return qe.transformBounds(e, t.indexToWorld, n);
  }, i.worldToIndexBounds = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return qe.transformBounds(e, t.worldToIndex, n);
  }, i.onModified(i.computeTransforms), i.computeTransforms(), i.getCenter = () => qe.getCenter(i.getBounds()), i.computeHistogram = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    const s = [0, 0, 0, 0, 0, 0];
    i.worldToIndexBounds(e, s);
    const r = [0, 0, 0], a = [0, 0, 0];
    qe.computeCornerPoints(s, r, a), _S(r, r), _S(a, a);
    const o = i.getDimensions();
    $S(r, [0, 0, 0], [o[0] - 1, o[1] - 1, o[2] - 1], r), $S(a, [0, 0, 0], [o[0] - 1, o[1] - 1, o[2] - 1], a);
    const l = o[0], c = o[0] * o[1], u = i.getPointData().getScalars().getData();
    let d = -1 / 0, h = 1 / 0, p = 0, m = 0, b = 0;
    for (let f = r[2]; f <= a[2]; f++)
      for (let T = r[1]; T <= a[1]; T++) {
        let M = r[0] + T * l + f * c;
        for (let N = r[0]; N <= a[0]; N++) {
          if (!n || n([N, T, f], s)) {
            const W = u[M];
            W > d && (d = W), W < h && (h = W), p += W * W, m += W, b += 1;
          }
          ++M;
        }
      }
    const y = b > 0 ? m / b : 0, Z = b ? Math.abs(p / b - y * y) : 0, g = Math.sqrt(Z);
    return {
      minimum: h,
      maximum: d,
      average: y,
      variance: Z,
      sigma: g,
      count: b
    };
  }, i.computeIncrements = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    const s = [];
    let r = n;
    for (let a = 0; a < 3; ++a)
      s[a] = r, r *= e[a * 2 + 1] - e[a * 2] + 1;
    return s;
  }, i.computeOffsetIndex = (e) => {
    let [n, s, r] = e;
    const a = i.getExtent(), o = i.getPointData().getScalars().getNumberOfComponents(), l = i.computeIncrements(a, o);
    return Math.floor((Math.round(n) - a[0]) * l[0] + (Math.round(s) - a[2]) * l[1] + (Math.round(r) - a[4]) * l[2]);
  }, i.getOffsetIndexFromWorld = (e) => {
    const n = i.getExtent(), s = i.worldToIndex(e);
    for (let r = 0; r < 3; ++r)
      if (s[r] < n[r * 2] || s[r] > n[r * 2 + 1])
        return gp(`GetScalarPointer: Pixel ${s} is not in memory. Current extent = ${n}`), NaN;
    return i.computeOffsetIndex(s);
  }, i.getScalarValueFromWorld = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    const s = i.getPointData().getScalars().getNumberOfComponents();
    if (n < 0 || n >= s)
      return gp(`GetScalarPointer: Scalar Component ${n} is not within bounds. Current Scalar numberOfComponents: ${s}`), NaN;
    const r = i.getOffsetIndexFromWorld(e);
    return Number.isNaN(r) ? r : i.getPointData().getScalars().getComponent(r, n);
  };
}
const Lq = {
  direction: null,
  // a mat3
  indexToWorld: null,
  // a mat4
  worldToIndex: null,
  // a mat4
  spacing: [1, 1, 1],
  origin: [0, 0, 0],
  extent: [0, -1, 0, -1, 0, -1],
  dataDescription: ml.EMPTY
};
function vF(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Lq, e), Vg.extend(i, t, e), t.direction ? Array.isArray(t.direction) && (t.direction = new Float64Array(t.direction.slice(0, 9))) : t.direction = gi.identity(new Float64Array(9)), t.indexToWorld = new Float64Array(16), t.worldToIndex = new Float64Array(16), tt.get(i, t, ["indexToWorld", "worldToIndex"]), tt.setGetArray(i, t, ["origin", "spacing"], 3), tt.setGetArray(i, t, ["direction"], 9), tt.getArray(i, t, ["extent"], 6), Sq(i, t);
}
const Vq = tt.newInstance(vF, "vtkImageData");
var xs = {
  newInstance: Vq,
  extend: vF
};
function Xq(i, t) {
  t.classHierarchy.push("vtkTexture"), i.imageLoaded = () => {
    t.image.removeEventListener("load", i.imageLoaded), t.imageLoaded = !0, i.modified();
  }, i.setJsImageData = (e) => {
    t.jsImageData !== e && (e !== null && (i.setInputData(null), i.setInputConnection(null), t.image = null, t.canvas = null), t.jsImageData = e, t.imageLoaded = !0, i.modified());
  }, i.setCanvas = (e) => {
    t.canvas !== e && (e !== null && (i.setInputData(null), i.setInputConnection(null), t.image = null, t.jsImageData = null), t.canvas = e, i.modified());
  }, i.setImage = (e) => {
    t.image !== e && (e !== null && (i.setInputData(null), i.setInputConnection(null), t.canvas = null, t.jsImageData = null), t.image = e, t.imageLoaded = !1, e.complete ? i.imageLoaded() : e.addEventListener("load", i.imageLoaded), i.modified());
  }, i.getDimensionality = () => {
    let e = 0, n = 0, s = 1;
    if (i.getInputData()) {
      const a = i.getInputData();
      e = a.getDimensions()[0], n = a.getDimensions()[1], s = a.getDimensions()[2];
    }
    return t.jsImageData && (e = t.jsImageData.width, n = t.jsImageData.height), t.canvas && (e = t.canvas.width, n = t.canvas.height), t.image && (e = t.image.width, n = t.image.height), (e > 1) + (n > 1) + (s > 1);
  }, i.getInputAsJsImageData = () => {
    if (!t.imageLoaded || i.getInputData()) return null;
    if (t.jsImageData)
      return t.jsImageData();
    if (t.canvas)
      return t.canvas.getContext("2d").getImageData(0, 0, t.canvas.width, t.canvas.height);
    if (t.image) {
      const e = document.createElement("canvas");
      e.width = t.image.width, e.height = t.image.height;
      const n = e.getContext("2d");
      return n.translate(0, e.height), n.scale(1, -1), n.drawImage(t.image, 0, 0, t.image.width, t.image.height), n.getImageData(0, 0, e.width, e.height);
    }
    return null;
  };
}
const Iq = (i, t, e, n) => {
  const s = [1, 2, 1], r = 4, a = s, o = r, l = i.length / (t * e);
  let c = t, u = e, d = i;
  const h = [d];
  for (let p = 0; p < n; p++) {
    const m = [...d];
    c /= 2, u /= 2, d = new Uint8ClampedArray(c * u * l);
    const b = l * c;
    let y = 0;
    for (let g = 0; g < d.length; g += l) {
      g % b === 0 && (y += 2 * l * c);
      for (let f = 0; f < l; f++) {
        let T = m[y + f];
        T += m[y + l + f], T += m[y - 2 * b + f], T += m[y - 2 * b + l + f], T /= 4, d[g + f] = T;
      }
      y += 2 * l;
    }
    let Z = [...d];
    for (let g = 0; g < d.length; g += l)
      for (let f = 0; f < l; f++) {
        let T = -(a.length - 1) / 2, M = o, N = 0;
        for (let W = 0; W < a.length; W++) {
          let x = g + f + T * l;
          const V = x % b - (g + f) % b;
          V > l && (x += b), V < -l && (x -= b), Z[x] ? N += Z[x] * a[W] : M -= a[W], T += 1;
        }
        d[g + f] = N / M;
      }
    Z = [...d];
    for (let g = 0; g < d.length; g += l)
      for (let f = 0; f < l; f++) {
        let T = -(a.length - 1) / 2, M = o, N = 0;
        for (let W = 0; W < a.length; W++) {
          const x = g + f + T * b;
          Z[x] ? N += Z[x] * a[W] : M -= a[W], T += 1;
        }
        d[g + f] = N / M;
      }
    h.push(d);
  }
  return h;
}, Cq = {
  image: null,
  canvas: null,
  jsImageData: null,
  imageLoaded: !1,
  repeat: !1,
  interpolate: !1,
  edgeClamp: !1,
  mipLevel: 0,
  resizable: !1
  // must be set at construction time if the texture can be resizable
};
function RF(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Cq, e), tt.obj(i, t), tt.algo(i, t, 6, 0), tt.get(i, t, ["canvas", "image", "jsImageData", "imageLoaded", "resizable"]), tt.setGet(i, t, ["repeat", "edgeClamp", "interpolate", "mipLevel"]), Xq(i, t);
}
const Yq = tt.newInstance(RF, "vtkTexture"), vq = {
  generateMipmaps: Iq
};
var vc = {
  newInstance: Yq,
  extend: RF,
  ...vq
};
const Rq = {
  MAGNITUDE: 0,
  COMPONENT: 1,
  RGBCOLORS: 2
}, iL = {
  LUMINANCE: 1,
  LUMINANCE_ALPHA: 2,
  RGB: 3,
  RGBA: 4
};
var TI = {
  VectorMode: Rq,
  ScalarMappingTarget: iL
};
const Dq = {
  DEFAULT: 0,
  MAP_SCALARS: 1,
  DIRECT_SCALARS: 2
}, DF = {
  DEFAULT: 0,
  USE_POINT_DATA: 1,
  USE_CELL_DATA: 2,
  USE_POINT_FIELD_DATA: 3,
  USE_CELL_FIELD_DATA: 4,
  USE_FIELD_DATA: 5
}, Oq = {
  BY_ID: 0,
  BY_NAME: 1
};
var vG = {
  ColorMode: Dq,
  GetArray: Oq,
  ScalarMode: DF
};
const {
  ScalarMappingTarget: fD,
  VectorMode: rc
} = TI, {
  VtkDataTypes: xd
} = We, {
  ColorMode: F1
} = vG, {
  vtkErrorMacro: gD
} = tt;
function zq(i) {
  return i;
}
function yD(i) {
  return Math.floor(i * 255 + 0.5);
}
function Eq(i, t) {
  t.classHierarchy.push("vtkScalarsToColors"), i.setVectorModeToMagnitude = () => i.setVectorMode(rc.MAGNITUDE), i.setVectorModeToComponent = () => i.setVectorMode(rc.COMPONENT), i.setVectorModeToRGBColors = () => i.setVectorMode(rc.RGBCOLORS), i.build = () => {
  }, i.isOpaque = () => !0, i.setAnnotations = (e, n) => {
    if (!(e && !n || !e && n)) {
      if (e && n && e.length !== n.length) {
        gD("Values and annotations do not have the same number of tuples so ignoring");
        return;
      }
      if (t.annotationArray = [], n && e) {
        const s = n.length;
        for (let r = 0; r < s; r++)
          t.annotationArray.push({
            value: e[r],
            annotation: String(n[r])
          });
      }
      i.updateAnnotatedValueMap(), i.modified();
    }
  }, i.setAnnotation = (e, n) => {
    let s = i.checkForAnnotatedValue(e), r = !1;
    return s >= 0 ? t.annotationArray[s].annotation !== n && (t.annotationArray[s].annotation = n, r = !0) : (t.annotationArray.push({
      value: e,
      annotation: n
    }), s = t.annotationArray.length - 1, r = !0), r && (i.updateAnnotatedValueMap(), i.modified()), s;
  }, i.getNumberOfAnnotatedValues = () => t.annotationArray.length, i.getAnnotatedValue = (e) => e < 0 || e >= t.annotationArray.length ? null : t.annotationArray[e].value, i.getAnnotation = (e) => t.annotationArray[e] === void 0 ? null : t.annotationArray[e].annotation, i.getAnnotatedValueIndex = (e) => t.annotationArray.length ? i.checkForAnnotatedValue(e) : -1, i.removeAnnotation = (e) => {
    const n = i.checkForAnnotatedValue(e), s = n >= 0;
    return s && (t.annotationArray.splice(n, 1), i.updateAnnotatedValueMap(), i.modified()), s;
  }, i.resetAnnotations = () => {
    t.annotationArray = [], t.annotatedValueMap = [], i.modified();
  }, i.getAnnotationColor = (e, n) => {
    if (t.indexedLookup) {
      const s = i.getAnnotatedValueIndex(e);
      i.getIndexedColor(s, n);
    } else
      i.getColor(parseFloat(e), n), n[3] = 1;
  }, i.checkForAnnotatedValue = (e) => i.getAnnotatedValueIndexInternal(e), i.getAnnotatedValueIndexInternal = (e) => {
    if (t.annotatedValueMap[e] !== void 0) {
      const n = t.annotationArray.length;
      return t.annotatedValueMap[e] % n;
    }
    return -1;
  }, i.getIndexedColor = (e, n) => {
    n[0] = 0, n[1] = 0, n[2] = 0, n[3] = 0;
  }, i.updateAnnotatedValueMap = () => {
    t.annotatedValueMap = [];
    const e = t.annotationArray.length;
    for (let n = 0; n < e; n++)
      t.annotatedValueMap[t.annotationArray[n].value] = n;
  }, i.mapScalars = (e, n, s) => {
    const r = e.getNumberOfComponents();
    let a = null;
    if (n === F1.DEFAULT && (e.getDataType() === xd.UNSIGNED_CHAR || e.getDataType() === xd.UNSIGNED_CHAR_CLAMPED) || n === F1.DIRECT_SCALARS && e)
      a = i.convertToRGBA(e, r, e.getNumberOfTuples());
    else {
      const o = {
        type: "vtkDataArray",
        name: "temp",
        numberOfComponents: 4,
        dataType: xd.UNSIGNED_CHAR
      }, l = tt.newTypedArray(o.dataType, 4 * e.getNumberOfTuples());
      o.values = l, o.size = l.length, a = We.newInstance(o);
      let c = s;
      c < 0 && r > 1 ? i.mapVectorsThroughTable(e, a, fD.RGBA, -1, -1) : (c < 0 && (c = 0), c >= r && (c = r - 1), i.mapScalarsThroughTable(e, a, fD.RGBA, c));
    }
    return a;
  }, i.mapVectorsToMagnitude = (e, n, s) => {
    const r = e.getNumberOfTuples(), a = e.getNumberOfComponents(), o = n.getData(), l = e.getData();
    for (let c = 0; c < r; c++) {
      let u = 0;
      for (let d = 0; d < s; d++)
        u += l[c * a + d] * l[c * a + d];
      o[c] = Math.sqrt(u);
    }
  }, i.mapVectorsThroughTable = (e, n, s, r, a) => {
    let o = i.getVectorMode(), l = a, c = r;
    const u = e.getNumberOfComponents();
    o === rc.COMPONENT ? (c === -1 && (c = i.getVectorComponent()), c < 0 && (c = 0), c >= u && (c = u - 1)) : (l === -1 && (l = i.getVectorSize()), l <= 0 ? (c = 0, l = u) : (c < 0 && (c = 0), c >= u && (c = u - 1), c + l > u && (l = u - c)), o === rc.MAGNITUDE && (u === 1 || l === 1) && (o = rc.COMPONENT));
    let d = 0;
    switch (c > 0 && (d = c), o) {
      case rc.COMPONENT: {
        i.mapScalarsThroughTable(e, n, s, d);
        break;
      }
      case rc.RGBCOLORS:
        break;
      // MAGNITUDE is considered default
      case rc.MAGNITUDE:
      default: {
        const h = We.newInstance({
          numberOfComponents: 1,
          values: new Float32Array(e.getNumberOfTuples())
        });
        i.mapVectorsToMagnitude(e, h, l), i.mapScalarsThroughTable(h, n, s, 0);
        break;
      }
    }
  }, i.luminanceToRGBA = (e, n, s, r) => {
    const a = r(s), o = n.getData(), l = e.getData(), c = o.length, u = 0, d = 1;
    let h = 0;
    for (let p = u; p < c; p += d) {
      const m = r(o[p]);
      l[h * 4] = m, l[h * 4 + 1] = m, l[h * 4 + 2] = m, l[h * 4 + 3] = a, h++;
    }
  }, i.luminanceAlphaToRGBA = (e, n, s, r) => {
    const a = n.getData(), o = e.getData(), l = a.length, c = 0, u = 2;
    let d = 0;
    for (let h = c; h < l; h += u) {
      const p = r(a[h]);
      o[d] = p, o[d + 1] = p, o[d + 2] = p, o[d + 3] = r(a[h + 1]) * s, d += 4;
    }
  }, i.rGBToRGBA = (e, n, s, r) => {
    const a = yD(s), o = n.getData(), l = e.getData(), c = o.length, u = 0, d = 3;
    let h = 0;
    for (let p = u; p < c; p += d)
      l[h * 4] = r(o[p]), l[h * 4 + 1] = r(o[p + 1]), l[h * 4 + 2] = r(o[p + 2]), l[h * 4 + 3] = a, h++;
  }, i.rGBAToRGBA = (e, n, s, r) => {
    const a = n.getData(), o = e.getData(), l = a.length, c = 0, u = 4;
    let d = 0;
    for (let h = c; h < l; h += u)
      o[d * 4] = r(a[h]), o[d * 4 + 1] = r(a[h + 1]), o[d * 4 + 2] = r(a[h + 2]), o[d * 4 + 3] = r(a[h + 3]) * s, d++;
  }, i.convertToRGBA = (e, n, s) => {
    let {
      alpha: r
    } = t;
    if (n === 4 && r >= 1 && e.getDataType() === xd.UNSIGNED_CHAR)
      return e;
    const a = We.newInstance({
      numberOfComponents: 4,
      empty: !0,
      size: 4 * s,
      dataType: xd.UNSIGNED_CHAR
    });
    if (s <= 0)
      return a;
    r = r > 0 ? r : 0, r = r < 1 ? r : 1;
    let o = zq;
    switch ((e.getDataType() === xd.FLOAT || e.getDataType() === xd.DOUBLE) && (o = yD), n) {
      case 1:
        i.luminanceToRGBA(a, e, r, o);
        break;
      case 2:
        i.luminanceAlphaToRGBA(a, e, o);
        break;
      case 3:
        i.rGBToRGBA(a, e, r, o);
        break;
      case 4:
        i.rGBAToRGBA(a, e, r, o);
        break;
      default:
        return gD("Cannot convert colors"), null;
    }
    return a;
  }, i.usingLogScale = () => !1, i.getNumberOfAvailableColors = () => 256 * 256 * 256, i.setRange = (e, n) => i.setMappingRange(e, n), i.getRange = () => i.getMappingRange(), i.areScalarsOpaque = (e, n, s) => {
    if (!e)
      return i.isOpaque();
    const r = e.getNumberOfComponents();
    return n === F1.DEFAULT && e.getDataType() === xd.UNSIGNED_CHAR || n === F1.DIRECT_SCALARS ? r === 3 || r === 1 ? t.alpha >= 1 : e.getRange(r - 1)[0] === 255 : !0;
  };
}
const kq = {
  alpha: 1,
  vectorComponent: 0,
  vectorSize: -1,
  vectorMode: rc.COMPONENT,
  mappingRange: null,
  annotationArray: null,
  annotatedValueMap: null,
  indexedLookup: !1
};
function OF(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, kq, e), tt.obj(i, t), t.mappingRange = [0, 255], t.annotationArray = [], t.annotatedValueMap = [], tt.setGet(i, t, ["vectorSize", "vectorComponent", "vectorMode", "alpha", "indexedLookup"]), tt.setArray(i, t, ["mappingRange"], 2), tt.getArray(i, t, ["mappingRange"]), Eq(i, t);
}
const Fq = tt.newInstance(OF, "vtkScalarsToColors");
var RG = {
  newInstance: Fq,
  extend: OF,
  ...TI
};
const jq = {
  RGB: 0,
  HSV: 1,
  LAB: 2,
  DIVERGING: 3
}, Uq = {
  LINEAR: 0,
  LOG10: 1
};
var zF = {
  ColorSpace: jq,
  Scale: Uq
};
const {
  ColorSpace: dl,
  Scale: EF
} = zF, {
  ScalarMappingTarget: j1
} = RG, {
  vtkDebugMacro: Pq,
  vtkErrorMacro: Qc,
  vtkWarningMacro: Jq
} = tt;
function ZD(i, t) {
  const e = i[0], n = i[1], s = i[2], r = Math.sqrt(e * e + n * n + s * s), a = r > 1e-3 ? Math.acos(e / r) : 0, o = a > 1e-3 ? Math.atan2(s, n) : 0;
  t[0] = r, t[1] = a, t[2] = o;
}
function Aq(i, t) {
  const e = i[0], n = i[1], s = i[2];
  t[0] = e * Math.cos(n), t[1] = e * Math.sin(n) * Math.cos(s), t[2] = e * Math.sin(n) * Math.sin(s);
}
function TD(i, t) {
  if (i[0] >= t - 0.1)
    return i[2];
  const e = i[1] * Math.sqrt(t * t - i[0] * i[0]) / (i[0] * Math.sin(i[1]));
  return i[2] > -0.3 * Math.PI ? i[2] + e : i[2] - e;
}
function Bq(i, t) {
  let e = i - t;
  for (e < 0 && (e = -e); e >= 2 * Math.PI; )
    e -= 2 * Math.PI;
  return e > Math.PI && (e = 2 * Math.PI - e), e;
}
function MD(i, t, e, n) {
  const s = [], r = [];
  kp(t, s), kp(e, r);
  const a = [], o = [];
  ZD(s, a), ZD(r, o);
  let l = i;
  if (a[1] > 0.05 && o[1] > 0.05 && Bq(a[2], o[2]) > 0.33 * Math.PI) {
    let d = Math.max(a[0], o[0]);
    d = Math.max(88, d), i < 0.5 ? (o[0] = d, o[1] = 0, o[2] = 0, l *= 2) : (a[0] = d, a[1] = 0, a[2] = 0, l = 2 * l - 1);
  }
  a[1] < 0.05 && o[1] > 0.05 ? a[2] = TD(o, a[0]) : o[1] < 0.05 && a[1] > 0.05 && (o[2] = TD(a, o[0]));
  const c = [];
  c[0] = (1 - l) * a[0] + l * o[0], c[1] = (1 - l) * a[1] + l * o[1], c[2] = (1 - l) * a[2] + l * o[2];
  const u = [];
  Aq(c, u), rW(u, n);
}
function Kq(i, t) {
  t.classHierarchy.push("vtkColorTransferFunction"), i.getSize = () => t.nodes.length, i.addRGBPoint = (e, n, s, r, a) => i.addRGBPointLong(e, n, s, r, a, 0.5, 0), i.addRGBPointLong = function(e, n, s, r, a) {
    let o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, l = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0.5, c = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 0;
    if (l < 0 || l > 1)
      return Qc("Midpoint outside range [0.0, 1.0]"), -1;
    if (c < 0 || c > 1)
      return Qc("Sharpness outside range [0.0, 1.0]"), -1;
    t.allowDuplicateScalars || i.removePoint(e);
    const u = {
      x: e,
      r: n,
      g: s,
      b: r,
      a: o,
      midpoint: l,
      sharpness: c
    };
    t.nodes.push(u), i.sortAndUpdateRange();
    let d = 0;
    for (; d < t.nodes.length && t.nodes[d].x !== e; d++)
      ;
    return d < t.nodes.length ? d : -1;
  }, i.addHSVPoint = (e, n, s, r) => i.addHSVPointLong(e, n, s, r, 0.5, 0), i.addHSVPointLong = function(e, n, s, r) {
    let a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0.5, o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
    const l = [];
    return Yp([n, s, r], l), i.addRGBPoint(e, l[0], l[1], l[2], l[3], a, o);
  }, i.setNodes = (e) => {
    if (t.nodes !== e) {
      const n = JSON.stringify(t.nodes);
      t.nodes = e;
      const s = JSON.stringify(t.nodes);
      if (i.sortAndUpdateRange() || n !== s)
        return i.modified(), !0;
    }
    return !1;
  }, i.sortAndUpdateRange = () => {
    const e = JSON.stringify(t.nodes);
    t.nodes.sort((r, a) => r.x - a.x);
    const n = JSON.stringify(t.nodes), s = i.updateRange();
    return !s && e !== n ? (i.modified(), !0) : s;
  }, i.updateRange = () => {
    const e = [2];
    e[0] = t.mappingRange[0], e[1] = t.mappingRange[1];
    const n = t.nodes.length;
    return n ? (t.mappingRange[0] = t.nodes[0].x, t.mappingRange[1] = t.nodes[n - 1].x) : (t.mappingRange[0] = 0, t.mappingRange[1] = 0), e[0] === t.mappingRange[0] && e[1] === t.mappingRange[1] ? !1 : (i.modified(), !0);
  }, i.removePoint = (e) => {
    let n = 0;
    for (; n < t.nodes.length && t.nodes[n].x !== e; n++)
      ;
    const s = n;
    if (n >= t.nodes.length)
      return -1;
    let r = !1;
    return t.nodes.splice(n, 1), (n === 0 || n === t.nodes.length) && (r = i.updateRange()), r || i.modified(), s;
  }, i.movePoint = (e, n) => {
    if (e !== n) {
      i.removePoint(n);
      for (let s = 0; s < t.nodes.length; s++)
        if (t.nodes[s].x === e) {
          t.nodes[s].x = n, i.sortAndUpdateRange();
          break;
        }
    }
  }, i.removeAllPoints = () => {
    t.nodes = [], i.sortAndUpdateRange();
  }, i.addRGBSegment = (e, n, s, r, a, o, l, c) => {
    i.sortAndUpdateRange();
    for (let u = 0; u < t.nodes.length; )
      t.nodes[u].x >= e && t.nodes[u].x <= a ? t.nodes.splice(u, 1) : u++;
    i.addRGBPointLong(e, n, s, r, 1, 0.5, 0), i.addRGBPointLong(a, o, l, c, 1, 0.5, 0), i.modified();
  }, i.addHSVSegment = (e, n, s, r, a, o, l, c) => {
    const u = [n, s, r], d = [o, l, c], h = [], p = [];
    Yp(u, h), Yp(d, p), i.addRGBSegment(e, h[0], h[1], h[2], a, p[0], p[1], p[2]);
  }, i.mapValue = (e) => {
    const n = [];
    return i.getColor(e, n), [Math.floor(255 * n[0] + 0.5), Math.floor(255 * n[1] + 0.5), Math.floor(255 * n[2] + 0.5), Math.floor(255 * n[3] + 0.5)];
  }, i.getColor = (e, n) => {
    if (t.indexedLookup) {
      const s = i.getSize(), r = i.getAnnotatedValueIndexInternal(e);
      if (r < 0 || s === 0) {
        const a = i.getNanColorByReference();
        n[0] = a[0], n[1] = a[1], n[2] = a[2], n[3] = 1;
      } else {
        const a = [];
        i.getNodeValue(r % s, a), n[0] = a[1], n[1] = a[2], n[2] = a[3], n[3] = a[4] !== void 0 ? a[4] : 1;
      }
      return;
    }
    i.getTable(e, e, 1, n);
  }, i.getRedValue = (e) => {
    const n = [];
    return i.getColor(e, n), n[0];
  }, i.getGreenValue = (e) => {
    const n = [];
    return i.getColor(e, n), n[1];
  }, i.getBlueValue = (e) => {
    const n = [];
    return i.getColor(e, n), n[2];
  }, i.getTable = (e, n, s, r) => {
    for (let X = 0; X < s; X++)
      r[X * 4 + 3] = 1;
    const a = Number(e), o = Number(n);
    if (aW(a) || aW(o)) {
      for (let X = 0; X < s; X++)
        r[X * 3 + 0] = t.nanColor[0], r[X * 3 + 1] = t.nanColor[1], r[X * 3 + 2] = t.nanColor[2], r[X * 3 + 3] = 1;
      return;
    }
    let l = 0;
    const c = t.nodes.length;
    let u = 0, d = 0, h = 0, p = 1;
    c !== 0 && (u = t.nodes[c - 1].r, d = t.nodes[c - 1].g, h = t.nodes[c - 1].b, p = t.nodes[c - 1].a || 1);
    let m = 0, b = 0, y = 0;
    const Z = [0, 0, 0, 1], g = [0, 0, 0, 1];
    let f = 0, T = 0;
    const M = [];
    let N = t.scale === EF.LOG10;
    N && (N = t.mappingRange[0] > 0);
    let W = 0, x = 0, V = 0;
    N && (W = Math.log10(a), x = Math.log10(o));
    for (let X = 0; X < s; X++) {
      const C = 3 * X;
      if (s > 1 ? N ? (V = W + X / (s - 1) * (x - W), m = 10 ** V) : m = a + X / (s - 1) * (o - a) : N ? (V = 0.5 * (W + x), m = 10 ** V) : m = 0.5 * (a + o), t.discretize) {
        const R = t.mappingRange;
        if (m >= R[0] && m <= R[1]) {
          const z = t.numberOfValues, F = R[1] - R[0];
          if (z <= 1)
            m = R[0] + F / 2;
          else {
            const P = (m - R[0]) / F, j = d2(z * P);
            m = R[0] + j / (z - 1) * F;
          }
        }
      }
      for (; l < c && m > t.nodes[l].x; )
        l++, l < c && (b = t.nodes[l - 1].x, y = t.nodes[l].x, N && (b = Math.log10(b), y = Math.log10(y)), Z[0] = t.nodes[l - 1].r, g[0] = t.nodes[l].r, Z[1] = t.nodes[l - 1].g, g[1] = t.nodes[l].g, Z[2] = t.nodes[l - 1].b, g[2] = t.nodes[l].b, Z[3] = t.nodes[l - 1].a, g[3] = t.nodes[l].a, f = t.nodes[l - 1].midpoint, T = t.nodes[l - 1].sharpness, f < 1e-5 && (f = 1e-5), f > 0.99999 && (f = 0.99999));
      if (m > t.mappingRange[1])
        r[C] = 0, r[C + 1] = 0, r[C + 2] = 0, r[C + 3] = 1, t.clamping && (i.getUseAboveRangeColor() ? (r[C] = t.aboveRangeColor[0], r[C + 1] = t.aboveRangeColor[1], r[C + 2] = t.aboveRangeColor[2], r[C + 3] = t.aboveRangeColor[3]) : (r[C] = u, r[C + 1] = d, r[C + 2] = h, r[C + 3] = p));
      else if (m < t.mappingRange[0] || Kk(m) && m < 0)
        r[C] = 0, r[C + 1] = 0, r[C + 2] = 0, r[C + 3] = 1, t.clamping && (i.getUseBelowRangeColor() ? (r[C] = t.belowRangeColor[0], r[C + 1] = t.belowRangeColor[1], r[C + 2] = t.belowRangeColor[2], r[C + 3] = t.belowRangeColor[3]) : c > 0 && (r[C] = t.nodes[0].r, r[C + 1] = t.nodes[0].g, r[C + 2] = t.nodes[0].b, r[C + 3] = t.nodes[0].a));
      else if (l === 0 && (Math.abs(m - a) < 1e-6 || t.discretize))
        c > 0 ? (r[C] = t.nodes[0].r, r[C + 1] = t.nodes[0].g, r[C + 2] = t.nodes[0].b, r[C + 3] = t.nodes[0].a) : (r[C] = 0, r[C + 1] = 0, r[C + 2] = 0, r[C + 3] = 1);
      else {
        let R = 0;
        if (N ? R = (V - b) / (y - b) : R = (m - b) / (y - b), R < f ? R = 0.5 * R / f : R = 0.5 + 0.5 * (R - f) / (1 - f), T > 0.99)
          if (R < 0.5) {
            r[C] = Z[0], r[C + 1] = Z[1], r[C + 2] = Z[2], r[C + 3] = Z[3];
            continue;
          } else {
            r[C] = g[0], r[C + 1] = g[1], r[C + 2] = g[2], r[C + 3] = g[3];
            continue;
          }
        if (T < 0.01) {
          if (t.colorSpace === dl.RGB)
            r[C] = (1 - R) * Z[0] + R * g[0], r[C + 1] = (1 - R) * Z[1] + R * g[1], r[C + 2] = (1 - R) * Z[2] + R * g[2], r[C + 3] = (1 - R) * Z[3] + R * g[3];
          else if (t.colorSpace === dl.HSV) {
            const E = [], ct = [];
            yy(Z, E), yy(g, ct), t.hSVWrap && (E[0] - ct[0] > 0.5 || ct[0] - E[0] > 0.5) && (E[0] > ct[0] ? E[0] -= 1 : ct[0] -= 1);
            const at = [];
            at[0] = (1 - R) * E[0] + R * ct[0], at[0] < 0 && (at[0] += 1), at[1] = (1 - R) * E[1] + R * ct[1], at[2] = (1 - R) * E[2] + R * ct[2], Yp(at, M), r[C] = M[0], r[C + 1] = M[1], r[C + 2] = M[2];
          } else if (t.colorSpace === dl.LAB) {
            const E = [], ct = [];
            kp(Z, E), kp(g, ct);
            const at = [];
            at[0] = (1 - R) * E[0] + R * ct[0], at[1] = (1 - R) * E[1] + R * ct[1], at[2] = (1 - R) * E[2] + R * ct[2], rW(at, M), r[C] = M[0], r[C + 1] = M[1], r[C + 2] = M[2];
          } else t.colorSpace === dl.DIVERGING ? (MD(R, Z, g, M), r[C] = M[0], r[C + 1] = M[1], r[C + 2] = M[2]) : Qc("ColorSpace set to invalid value.", t.colorSpace);
          continue;
        }
        R < 0.5 ? R = 0.5 * (R * 2) ** (1 + 10 * T) : R > 0.5 && (R = 1 - 0.5 * ((1 - R) * 2) ** (1 + 10 * T));
        const z = R * R, F = z * R, P = 2 * F - 3 * z + 1, j = -2 * F + 3 * z, H = F - 2 * z + R, B = F - z;
        let $, A;
        if (t.colorSpace === dl.RGB)
          for (let E = 0; E < 4; E++)
            $ = g[E] - Z[E], A = (1 - T) * $, r[C + E] = P * Z[E] + j * g[E] + H * A + B * A;
        else if (t.colorSpace === dl.HSV) {
          const E = [], ct = [];
          yy(Z, E), yy(g, ct), t.hSVWrap && (E[0] - ct[0] > 0.5 || ct[0] - E[0] > 0.5) && (E[0] > ct[0] ? E[0] -= 1 : ct[0] -= 1);
          const at = [];
          for (let dt = 0; dt < 3; dt++)
            $ = ct[dt] - E[dt], A = (1 - T) * $, at[dt] = P * E[dt] + j * ct[dt] + H * A + B * A, dt === 0 && at[dt] < 0 && (at[dt] += 1);
          Yp(at, M), r[C] = M[0], r[C + 1] = M[1], r[C + 2] = M[2];
        } else if (t.colorSpace === dl.LAB) {
          const E = [], ct = [];
          kp(Z, E), kp(g, ct);
          const at = [];
          for (let dt = 0; dt < 3; dt++)
            $ = ct[dt] - E[dt], A = (1 - T) * $, at[dt] = P * E[dt] + j * ct[dt] + H * A + B * A;
          rW(at, M), r[C] = M[0], r[C + 1] = M[1], r[C + 2] = M[2];
        } else t.colorSpace === dl.DIVERGING ? (MD(R, Z, g, M), r[C] = M[0], r[C + 1] = M[1], r[C + 2] = M[2]) : Qc("ColorSpace set to invalid value.");
        for (let E = 0; E < 4; E++)
          r[C + E] = r[C + E] < 0 ? 0 : r[C + E], r[C + E] = r[C + E] > 1 ? 1 : r[C + E];
      }
    }
  }, i.getUint8Table = function(e, n, s) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
    if (i.getMTime() <= t.buildTime && t.tableSize === s && t.tableWithAlpha !== r)
      return t.table;
    if (t.nodes.length === 0)
      return Qc("Attempting to lookup a value with no points in the function"), t.table;
    const a = r ? 4 : 3;
    (t.tableSize !== s || t.tableWithAlpha !== r) && (t.table = new Uint8Array(s * a), t.tableSize = s, t.tableWithAlpha = r);
    const o = [];
    i.getTable(e, n, s, o);
    for (let l = 0; l < s; l++)
      t.table[l * a + 0] = Math.floor(o[l * 4 + 0] * 255 + 0.5), t.table[l * a + 1] = Math.floor(o[l * 4 + 1] * 255 + 0.5), t.table[l * a + 2] = Math.floor(o[l * 4 + 2] * 255 + 0.5), r && (t.table[l * a + 3] = Math.floor(o[l * 4 + 3] * 255 + 0.5));
    return t.buildTime.modified(), t.table;
  }, i.buildFunctionFromArray = (e) => {
    i.removeAllPoints();
    const n = e.getNumberOfComponents();
    for (let s = 0; s < e.getNumberOfTuples(); s++)
      switch (n) {
        case 3: {
          t.nodes.push({
            x: s,
            r: e.getComponent(s, 0),
            g: e.getComponent(s, 1),
            b: e.getComponent(s, 2),
            a: 1,
            midpoint: 0.5,
            sharpness: 0
          });
          break;
        }
        case 4: {
          t.nodes.push({
            x: e.getComponent(s, 0),
            r: e.getComponent(s, 1),
            g: e.getComponent(s, 2),
            b: e.getComponent(s, 3),
            a: e.getComponent(s, 4),
            midpoint: 0.5,
            sharpness: 0
          });
          break;
        }
        case 5: {
          t.nodes.push({
            x: s,
            r: e.getComponent(s, 0),
            g: e.getComponent(s, 1),
            b: e.getComponent(s, 2),
            a: e.getComponent(s, 3),
            midpoint: e.getComponent(s, 4),
            sharpness: e.getComponent(s, 5)
          });
          break;
        }
        case 6: {
          t.nodes.push({
            x: e.getComponent(s, 0),
            r: e.getComponent(s, 1),
            g: e.getComponent(s, 2),
            b: e.getComponent(s, 3),
            a: 1,
            midpoint: e.getComponent(s, 4),
            sharpness: e.getComponent(s, 5)
          });
          break;
        }
      }
    i.sortAndUpdateRange();
  }, i.buildFunctionFromTable = (e, n, s, r) => {
    let a = 0;
    i.removeAllPoints(), s > 1 && (a = (n - e) / (s - 1));
    for (let o = 0; o < s; o++) {
      const l = {
        x: e + a * o,
        r: r[o * 3],
        g: r[o * 3 + 1],
        b: r[o * 3 + 2],
        a: 1,
        sharpness: 0,
        midpoint: 0.5
      };
      t.nodes.push(l);
    }
    i.sortAndUpdateRange();
  }, i.getNodeValue = (e, n) => e < 0 || e >= t.nodes.length ? (Qc("Index out of range!"), -1) : (n[0] = t.nodes[e].x, n[1] = t.nodes[e].r, n[2] = t.nodes[e].g, n[3] = t.nodes[e].b, n[4] = t.nodes[e].a, n[5] = t.nodes[e].midpoint, n[6] = t.nodes[e].sharpness, 1), i.setNodeValue = (e, n) => {
    if (e < 0 || e >= t.nodes.length)
      return Qc("Index out of range!"), -1;
    const s = t.nodes[e].x;
    return t.nodes[e].x = n[0], t.nodes[e].r = n[1], t.nodes[e].g = n[2], t.nodes[e].b = n[3], t.nodes[e].a = n[4], t.nodes[e].midpoint = n[5], t.nodes[e].sharpness = n[6], s !== n[0] ? i.sortAndUpdateRange() : i.modified(), 1;
  }, i.getNumberOfAvailableColors = () => t.indexedLookup && i.getSize() ? i.getSize() : t.tableSize ? t.tableSize : 16777216, i.getIndexedColor = (e, n) => {
    const s = i.getSize();
    if (s > 0 && e >= 0) {
      const a = [];
      i.getNodeValue(e % s, a);
      for (let o = 0; o < 3; ++o)
        n[o] = a[o + 1];
      return;
    }
    const r = i.getNanColorByReference();
    n[0] = r[0], n[1] = r[1], n[2] = r[2], n[3] = 1;
  }, i.fillFromDataPointer = (e, n) => {
    if (!(e <= 0 || !n)) {
      i.removeAllPoints();
      for (let s = 0; s < e; s++)
        i.addRGBPoint(n[s * 4], n[s * 4 + 1], n[s * 4 + 2], n[s * 4 + 3], 1);
    }
  }, i.setMappingRange = (e, n) => {
    const s = [e, n], r = i.getRange();
    if (r[1] === s[1] && r[0] === s[0])
      return;
    if (s[1] === s[0]) {
      Qc("attempt to set zero width color range");
      return;
    }
    const a = (s[1] - s[0]) / (r[1] - r[0]), o = s[0] - r[0] * a;
    for (let l = 0; l < t.nodes.length; ++l)
      t.nodes[l].x = t.nodes[l].x * a + o;
    t.mappingRange[0] = s[0], t.mappingRange[1] = s[1], i.modified();
  }, i.adjustRange = (e) => {
    const n = i.getRange(), s = [];
    n[0] < e[0] ? (i.getColor(e[0], s), i.addRGBPoint(e[0], s[0], s[1], s[2], s[3])) : (i.getColor(n[0], s), i.addRGBPoint(e[0], s[0], s[1], s[2], s[3])), n[1] > e[1] ? (i.getColor(e[1], s), i.addRGBPoint(e[1], s[0], s[1], s[2], s[3])) : (i.getColor(n[1], s), i.addRGBPoint(e[1], s[0], s[1], s[2], s[3])), i.sortAndUpdateRange();
    for (let r = 0; r < t.nodes.length; )
      t.nodes[r].x >= e[0] && t.nodes[r].x <= e[1] ? t.nodes.splice(r, 1) : ++r;
    return 1;
  }, i.estimateMinNumberOfSamples = (e, n) => {
    const s = i.findMinimumXDistance();
    return Math.ceil((n - e) / s);
  }, i.findMinimumXDistance = () => {
    if (t.nodes.length < 2)
      return -1;
    let e = Number.MAX_VALUE;
    for (let n = 0; n < t.nodes.length - 1; n++) {
      const s = t.nodes[n + 1].x - t.nodes[n].x;
      s < e && (e = s);
    }
    return e;
  }, i.mapScalarsThroughTable = (e, n, s, r) => {
    if (i.getSize() === 0) {
      Pq("Transfer Function Has No Points!");
      return;
    }
    t.indexedLookup ? i.mapDataIndexed(e, n, s, r) : i.mapData(e, n, s, r);
  }, i.mapData = (e, n, s, r) => {
    if (i.getSize() === 0) {
      Jq("Transfer Function Has No Points!");
      return;
    }
    Math.floor(i.getAlpha() * 255 + 0.5);
    const a = e.getNumberOfTuples(), o = e.getNumberOfComponents(), l = n.getData(), c = e.getData(), u = [];
    if (s === j1.RGBA)
      for (let d = 0; d < a; d++) {
        const h = c[d * o + r];
        i.getColor(h, u), l[d * 4] = Math.floor(u[0] * 255 + 0.5), l[d * 4 + 1] = Math.floor(u[1] * 255 + 0.5), l[d * 4 + 2] = Math.floor(u[2] * 255 + 0.5), l[d * 4 + 3] = Math.floor(u[3] * 255 + 0.5);
      }
    if (s === j1.RGB)
      for (let d = 0; d < a; d++) {
        const h = c[d * o + r];
        i.getColor(h, u), l[d * 3] = Math.floor(u[0] * 255 + 0.5), l[d * 3 + 1] = Math.floor(u[1] * 255 + 0.5), l[d * 3 + 2] = Math.floor(u[2] * 255 + 0.5);
      }
    if (s === j1.LUMINANCE)
      for (let d = 0; d < a; d++) {
        const h = c[d * o + r];
        i.getColor(h, u), l[d] = Math.floor(u[0] * 76.5 + u[1] * 150.45 + u[2] * 28.05 + 0.5);
      }
    if (s === j1.LUMINANCE_ALPHA)
      for (let d = 0; d < a; d++) {
        const h = c[d * o + r];
        i.getColor(h, u), l[d * 2] = Math.floor(u[0] * 76.5 + u[1] * 150.45 + u[2] * 28.05 + 0.5), l[d * 2 + 1] = Math.floor(u[3] * 255 + 0.5);
      }
  }, i.applyColorMap = (e) => {
    const n = JSON.stringify(t.colorSpace);
    e.ColorSpace && (t.colorSpace = dl[e.ColorSpace.toUpperCase()], t.colorSpace === void 0 && (Qc(`ColorSpace ${e.ColorSpace} not supported, using RGB instead`), t.colorSpace = dl.RGB));
    let s = n !== JSON.stringify(t.colorSpace);
    const r = s || JSON.stringify(t.nanColor);
    if (e.NanColor)
      for (t.nanColor = [].concat(e.NanColor); t.nanColor.length < 4; )
        t.nanColor.push(1);
    s = s || r !== JSON.stringify(t.nanColor);
    const a = s || JSON.stringify(t.nodes);
    if (e.RGBPoints) {
      const c = e.RGBPoints.length;
      t.nodes = [];
      const u = 0.5, d = 0;
      for (let h = 0; h < c; h += 4)
        t.nodes.push({
          x: e.RGBPoints[h],
          r: e.RGBPoints[h + 1],
          g: e.RGBPoints[h + 2],
          b: e.RGBPoints[h + 3],
          a: e.RGBPoints[h + 4],
          midpoint: u,
          sharpness: d
        });
    }
    const o = i.sortAndUpdateRange(), l = !o && (s || a !== JSON.stringify(t.nodes));
    return l && i.modified(), o || l;
  };
}
const Hq = {
  clamping: !0,
  colorSpace: dl.RGB,
  hSVWrap: !0,
  scale: EF.LINEAR,
  nanColor: null,
  belowRangeColor: null,
  aboveRangeColor: null,
  useAboveRangeColor: !1,
  useBelowRangeColor: !1,
  allowDuplicateScalars: !1,
  table: null,
  tableSize: 0,
  buildTime: null,
  nodes: null,
  discretize: !1,
  numberOfValues: 256
};
function kF(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Hq, e), RG.extend(i, t, e), t.table = [], t.nodes = [], t.nanColor = [0.5, 0, 0, 1], t.belowRangeColor = [0, 0, 0, 1], t.aboveRangeColor = [1, 1, 1, 1], t.buildTime = {}, tt.obj(t.buildTime), tt.get(i, t, ["buildTime", "mappingRange"]), tt.setGet(i, t, ["useAboveRangeColor", "useBelowRangeColor", "colorSpace", "discretize", "numberOfValues", "hSVWrap", "scale"]), tt.setArray(i, t, ["nanColor", "belowRangeColor", "aboveRangeColor"], 4), tt.getArray(i, t, ["nanColor", "belowRangeColor", "aboveRangeColor"]), Kq(i, t);
}
const _q = tt.newInstance(kF, "vtkColorTransferFunction");
var L0 = {
  newInstance: _q,
  extend: kF,
  ...zF
};
const {
  vtkErrorMacro: U1
} = tt;
function Qq(i, t) {
  t.classHierarchy.push("vtkPiecewiseFunction"), i.getSize = () => t.nodes.length, i.getType = () => {
    let e, n = 0, s = 0;
    t.nodes.length > 0 && (n = t.nodes[0].y);
    for (let r = 1; r < t.nodes.length; r++) {
      if (e = t.nodes[r].y, e !== n)
        if (e > n)
          switch (s) {
            case 0:
            case 1:
              s = 1;
              break;
            case 2:
            default:
              s = 3;
              break;
          }
        else
          switch (s) {
            case 0:
            case 2:
              s = 2;
              break;
            case 1:
            default:
              s = 3;
              break;
          }
      if (n = e, s === 3)
        break;
    }
    switch (s) {
      case 0:
        return "Constant";
      case 1:
        return "NonDecreasing";
      case 2:
        return "NonIncreasing";
      case 3:
      default:
        return "Varied";
    }
  }, i.getDataPointer = () => {
    const e = t.nodes.length;
    if (t.function = null, e > 0) {
      t.function = [];
      for (let n = 0; n < e; n++)
        t.function[2 * n] = t.nodes[n].x, t.function[2 * n + 1] = t.nodes[n].y;
    }
    return t.function;
  }, i.getFirstNonZeroValue = () => {
    if (t.nodes.length === 0)
      return 0;
    let e = 1, n = 0, s = 0;
    for (; s < t.nodes.length; s++)
      if (t.nodes[s].y !== 0) {
        e = 0;
        break;
      }
    return e ? n = Number.MAX_VALUE : s > 0 ? n = t.nodes[s - 1].x : t.clamping ? n = -Number.MAX_VALUE : n = t.nodes[0].x, n;
  }, i.getNodeValue = (e, n) => {
    const s = t.nodes.length;
    return e < 0 || e >= s ? (U1("Index out of range!"), -1) : (n[0] = t.nodes[e].x, n[1] = t.nodes[e].y, n[2] = t.nodes[e].midpoint, n[3] = t.nodes[e].sharpness, 1);
  }, i.setNodeValue = (e, n) => {
    const s = t.nodes.length;
    if (e < 0 || e >= s)
      return U1("Index out of range!"), -1;
    const r = t.nodes[e].x;
    return t.nodes[e].x = n[0], t.nodes[e].y = n[1], t.nodes[e].midpoint = n[2], t.nodes[e].sharpness = n[3], r !== n[0] ? i.sortAndUpdateRange() : i.modified(), 1;
  }, i.addPoint = (e, n) => i.addPointLong(e, n, 0.5, 0), i.addPointLong = (e, n, s, r) => {
    if (s < 0 || s > 1)
      return U1("Midpoint outside range [0.0, 1.0]"), -1;
    if (r < 0 || r > 1)
      return U1("Sharpness outside range [0.0, 1.0]"), -1;
    t.allowDuplicateScalars || i.removePoint(e);
    const a = {
      x: e,
      y: n,
      midpoint: s,
      sharpness: r
    };
    t.nodes.push(a), i.sortAndUpdateRange();
    let o;
    for (o = 0; o < t.nodes.length && t.nodes[o].x !== e; o++)
      ;
    return o < t.nodes.length ? o : -1;
  }, i.setNodes = (e) => {
    t.nodes !== e && (t.nodes = e, i.sortAndUpdateRange());
  }, i.sortAndUpdateRange = () => {
    t.nodes.sort((n, s) => n.x - s.x), i.updateRange() || i.modified();
  }, i.updateRange = () => {
    const e = t.range.slice(), n = t.nodes.length;
    return n ? (t.range[0] = t.nodes[0].x, t.range[1] = t.nodes[n - 1].x) : (t.range[0] = 0, t.range[1] = 0), e[0] === t.range[0] && e[1] === t.range[1] ? !1 : (i.modified(), !0);
  }, i.removePoint = (e) => {
    let n;
    for (n = 0; n < t.nodes.length && t.nodes[n].x !== e; n++)
      ;
    if (n >= t.nodes.length)
      return -1;
    const s = n;
    let r = !1;
    return t.nodes.splice(n, 1), (n === 0 || n === t.nodes.length) && (r = i.updateRange()), r || i.modified(), s;
  }, i.removeAllPoints = () => {
    t.nodes = [], i.sortAndUpdateRange();
  }, i.addSegment = (e, n, s, r) => {
    i.sortAndUpdateRange();
    for (let a = 0; a < t.nodes.length; )
      t.nodes[a].x >= e && t.nodes[a].x <= s ? t.nodes.splice(a, 1) : a++;
    i.addPoint(e, n, 0.5, 0), i.addPoint(s, r, 0.5, 0);
  }, i.getValue = (e) => {
    const n = [];
    return i.getTable(e, e, 1, n), n[0];
  }, i.adjustRange = (e) => {
    if (e.length < 2)
      return 0;
    const n = i.getRange();
    n[0] < e[0] ? i.addPoint(e[0], i.getValue(e[0])) : i.addPoint(e[0], i.getValue(n[0])), n[1] > e[1] ? i.addPoint(e[1], i.getValue(e[1])) : i.addPoint(e[1], i.getValue(n[1])), i.sortAndUpdateRange();
    for (let s = 0; s < t.nodes.length; )
      t.nodes[s].x >= e[0] && t.nodes[s].x <= e[1] ? t.nodes.splice(s, 1) : ++s;
    return i.sortAndUpdateRange(), 1;
  }, i.estimateMinNumberOfSamples = (e, n) => {
    const s = i.findMinimumXDistance();
    return Math.ceil((n - e) / s);
  }, i.findMinimumXDistance = () => {
    const e = t.nodes.length;
    if (e < 2)
      return -1;
    let n = t.nodes[1].x - t.nodes[0].x;
    for (let s = 0; s < e - 1; s++) {
      const r = t.nodes[s + 1].x - t.nodes[s].x;
      r < n && (n = r);
    }
    return n;
  }, i.getTable = function(e, n, s, r) {
    let a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, o, l = 0;
    const c = t.nodes.length;
    let u = 0;
    c !== 0 && (u = t.nodes[c - 1].y);
    let d = 0, h = 0, p = 0, m = 0, b = 0, y = 0, Z = 0;
    for (o = 0; o < s; o++) {
      const g = a * o;
      for (s > 1 ? d = e + o / (s - 1) * (n - e) : d = 0.5 * (e + n); l < c && d > t.nodes[l].x; )
        l++, l < c && (h = t.nodes[l - 1].x, p = t.nodes[l].x, m = t.nodes[l - 1].y, b = t.nodes[l].y, y = t.nodes[l - 1].midpoint, Z = t.nodes[l - 1].sharpness, y < 1e-5 && (y = 1e-5), y > 0.99999 && (y = 0.99999));
      if (l >= c)
        r[g] = t.clamping ? u : 0;
      else if (l === 0)
        r[g] = t.clamping ? t.nodes[0].y : 0;
      else {
        let f = (d - h) / (p - h);
        if (f < y ? f = 0.5 * f / y : f = 0.5 + 0.5 * (f - y) / (1 - y), Z > 0.99)
          if (f < 0.5) {
            r[g] = m;
            continue;
          } else {
            r[g] = b;
            continue;
          }
        if (Z < 0.01) {
          r[g] = (1 - f) * m + f * b;
          continue;
        }
        f < 0.5 ? f = 0.5 * (f * 2) ** (1 + 10 * Z) : f > 0.5 && (f = 1 - 0.5 * ((1 - f) * 2) ** (1 + 10 * Z));
        const T = f * f, M = T * f, N = 2 * M - 3 * T + 1, W = -2 * M + 3 * T, x = M - 2 * T + f, V = M - T, X = b - m, C = (1 - Z) * X;
        r[g] = N * m + W * b + x * C + V * C;
        const R = m < b ? m : b, z = m > b ? m : b;
        r[g] = r[g] < R ? R : r[g], r[g] = r[g] > z ? z : r[g];
      }
    }
  };
}
const $q = {
  // model.function = NULL;
  range: [0, 0],
  clamping: !0,
  allowDuplicateScalars: !1
};
function FF(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, $q, e), tt.obj(i, t), t.nodes = [], tt.setGet(i, t, ["allowDuplicateScalars", "clamping"]), tt.setArray(i, t, ["range"], 2), tt.getArray(i, t, ["range"]), Qq(i, t);
}
const qq = tt.newInstance(FF, "vtkPiecewiseFunction");
var Bh = {
  newInstance: qq,
  extend: FF
};
function MI(i) {
  return i.buffer.slice(i.byteOffset, i.byteOffset + i.byteLength);
}
function du(i, t, e, n, s, r) {
  const a = t.getPoints().getData(), o = t.getNumberOfLines(), l = P1(t.getPolys().getData()), c = P1(t.getVerts().getData()), u = P1(t.getLines().getData()), d = P1(t.getStrips().getData());
  if (i.MoveObjectToWasm(a, l, c, u, d, o, !!n, !!s), !r) {
    let h;
    n ? h = i.GetPolyDataViewCZ() : h = i.GetPolyDataView(), t.getPoints().setData(h.GetPoints()), t.getPolys().setData(h.GetPolys()), t.getVerts().setData(h.GetVerts()), t.getLines().setData(h.GetLines()), t.getStrips().setData(h.GetStrips()), h.GetVerts().length > 0 && console.warn("Check if correct - oVerts!!", h.GetVerts()), h.delete();
  }
  if (e) {
    let h = t.getPointData().getNumberOfArrays(), p = t.getPointData().getNormals() != null, m = "";
    p && (m = t.getPointData().getNormals().getName());
    let b = t.getPointData().getScalars() != null, y = "";
    b && (y = t.getPointData().getScalars().getName());
    let Z = t.getPointData().getTCoords() != null, g = "";
    Z && (g = t.getPointData().getTCoords().getName());
    let f = t.getPointData().getVectors() != null, T = "";
    f && (T = t.getPointData().getVectors().getName());
    let M = t.getPointData().getTensors() != null, N = "";
    M && (N = t.getPointData().getTensors().getName());
    let W = t.getPointData().getGlobalIds() != null, x = "";
    W && (x = t.getPointData().getGlobalIds().getName()), i.PrepareForVectorsCopyToWasm(p, m, b, y, Z, g, f, T, M, N, W, x);
    for (let V = 0; V < h; V++) {
      const X = t.getPointData().getArray(V);
      if (X) {
        const C = X.getDataType();
        C == "Uint8Array" ? (i.CopyUint8ArrayToWasm(
          X.getName(),
          X.getData(),
          X.getNumberOfTuples(),
          X.getNumberOfComponents(),
          X.getElementComponentSize(),
          !1
        ), i.PrepareSpanForArrayWithName(X.getName(), !1), X.setData(i.getOutputUint8Array())) : C == "Uint16Array" ? (i.CopyUint16ArrayToWasm(
          X.getName(),
          X.getData(),
          X.getNumberOfTuples(),
          X.getNumberOfComponents(),
          X.getElementComponentSize(),
          !1
        ), i.PrepareSpanForArrayWithName(X.getName(), !1), r || X.setData(i.getOutputUint16Array())) : C == "Float32Array" ? (i.CopyFloat32ArrayToWasm(
          X.getName(),
          X.getData(),
          X.getNumberOfTuples(),
          X.getNumberOfComponents(),
          X.getElementComponentSize(),
          !1
        ), i.PrepareSpanForArrayWithName(X.getName(), !1), r || X.setData(i.getOutputFloat32Array())) : console.error("dType copy not defined in wasm for vtkDataArray type", C);
      }
    }
    i.AssignPointDataArrays(), h = t.getCellData().getNumberOfArrays(), p = t.getCellData().getNormals() != null, m = "", p && (m = t.getCellData().getNormals().getName()), b = t.getCellData().getScalars() != null, y = "", b && (y = t.getCellData().getScalars().getName()), Z = t.getCellData().getTCoords() != null, g = "", Z && (g = t.getCellData().getTCoords().getName()), f = t.getCellData().getVectors() != null, T = "", f && (T = t.getCellData().getVectors().getName()), M = t.getCellData().getTensors() != null, N = "", M && (N = t.getCellData().getTensors().getName()), W = t.getCellData().getGlobalIds() != null, x = "", W && (x = t.getCellData().getGlobalIds().getName()), i.PrepareForVectorsCopyToWasm(p, m, b, y, Z, g, f, T, M, N, W, x);
    for (let V = 0; V < h; V++) {
      const X = t.getCellData().getArray(V);
      if (X) {
        const C = X.getDataType();
        C == "Uint8Array" ? (i.CopyUint8ArrayToWasm(
          X.getName(),
          X.getData(),
          X.getNumberOfTuples(),
          X.getNumberOfComponents(),
          X.getElementComponentSize(),
          !0
        ), i.PrepareSpanForArrayWithName(X.getName(), !0), X.setData(i.getOutputUint8Array())) : C == "Uint16Array" ? (i.CopyUint16ArrayToWasm(
          X.getName(),
          X.getData(),
          X.getNumberOfTuples(),
          X.getNumberOfComponents(),
          X.getElementComponentSize(),
          !0
        ), i.PrepareSpanForArrayWithName(X.getName(), !0), r || X.setData(i.getOutputUint16Array())) : C == "Float32Array" ? (i.CopyFloat32ArrayToWasm(
          X.getName(),
          X.getData(),
          X.getNumberOfTuples(),
          X.getNumberOfComponents(),
          X.getElementComponentSize(),
          !0
        ), i.PrepareSpanForArrayWithName(X.getName(), !0), r || X.setData(i.getOutputFloat32Array())) : console.error("dType copy not defined in wasm for vtkDataArray type", C);
      }
    }
    i.AssignCellDataArrays(), i.InitTCoords();
  }
  i.Initialize();
}
function cDt(i, t, e) {
  const n = i.GetImageDataView();
  Go(n, t, e), n.delete();
}
function uDt(i, t) {
  const e = xs.newInstance();
  return Go(i, e, t), e;
}
function Go(i, t, e) {
  const n = i.GetDimensions(), s = i.GetSpacing(), r = i.GetOrigin();
  let a;
  const o = i.GetDType();
  if (o != -1) {
    if (o == 3) {
      a = i.GetScalarsUChar();
      const l = We.newInstance({
        values: e ? a.slice() : a,
        numberOfComponents: i.GetNumberOfComponents()
        // dataType: VtkDataTypes.UNSIGNED_CHAR,
      });
      t.getPointData().setScalars(l);
    } else if (o == 4) {
      a = i.GetScalarsShort();
      const l = We.newInstance({
        values: e ? a.slice() : a,
        numberOfComponents: i.GetNumberOfComponents()
        // dataType: VtkDataTypes.SHORT,
      });
      t.getPointData().setScalars(l);
    } else if (o == 10) {
      a = i.GetScalarsFloat();
      const l = We.newInstance({
        values: e ? a.slice() : a,
        numberOfComponents: i.GetNumberOfComponents()
        // dataType: VtkDataTypes.FLOAT,
      });
      t.getPointData().setScalars(l);
    } else if (o == 11) {
      a = i.GetScalarsDouble();
      const l = We.newInstance({
        values: e ? a.slice() : a,
        numberOfComponents: i.GetNumberOfComponents()
        // dataType: VtkDataTypes.DOUBLE,
      });
      t.getPointData().setScalars(l);
    } else if (o == 5) {
      a = i.GetScalarsUShort();
      const l = We.newInstance({
        values: e ? a.slice() : a,
        numberOfComponents: i.GetNumberOfComponents()
        // dataType: VtkDataTypes.UNSIGNED_SHORT,
      });
      t.getPointData().setScalars(l);
    } else if (o == 6) {
      a = i.GetScalarsInt();
      const l = We.newInstance({
        values: e ? a.slice() : a,
        numberOfComponents: i.GetNumberOfComponents()
        // dataType: VtkDataTypes.INT,
      });
      t.getPointData().setScalars(l);
    } else
      console.error("Data Type not supported: ", o);
    t.setDimensions([n[0], n[1], n[2]]), t.setOrigin([r[0], r[1], r[2]]), t.setSpacing([s[0], s[1], isNaN(s[2]) ? 1 : s[2]]);
  }
}
function ND(i, t) {
  const e = i.GetDimensions(), n = i.GetSpacing(), s = i.GetOrigin();
  t.setDimensions([e[0], e[1], e[2]]), t.setOrigin([s[0], s[1], s[2]]), t.setSpacing([n[0], n[1], isNaN(n[2]) ? 1 : n[2]]);
  let r;
  const a = i.GetDType();
  a == 3 ? r = i.GetScalarsUChar() : a == 4 ? r = i.GetScalarsShort() : a == 10 ? r = i.GetScalarsFloat() : a == 11 ? r = i.GetScalarsDouble() : a == 5 ? r = i.GetScalarsUShort() : a == 6 ? r = i.GetScalarsInt() : console.error("Data Type not supported: ", a), r && (t.getPointData().getScalars().setData(r), t.modified()), i.delete();
}
function Cr(i, t, e, n) {
  const s = i.GetPolyDataView();
  WI(s, t, n), s.delete(), e && NI(i, t, n);
}
function NI(i, t, e) {
  t.getCellData().removeAllArrays();
  let n = !0, s = i.GetNumberOfDataArrays(n);
  for (let r = 0; r < s; r++) {
    const a = i.GetDataArrayByIdx(r, n);
    let o;
    const l = a.GetDataType();
    let c;
    if (l == 10)
      c = Ke.FLOAT, o = a.GetDataFloat();
    else if (l == 11)
      c = Ke.DOUBLE, o = a.GetDataDouble();
    else if (l == 3)
      c = Ke.UNSIGNED_CHAR, o = a.GetDataChar();
    else if (l == 4)
      c = Ke.SHORT, o = a.GetDataShort();
    else if (l == 5)
      c = Ke.UNSIGNED_SHORT, o = a.GetDataUShort();
    else if (l == 6)
      c = Ke.INT, o = a.GetDataInt();
    else {
      const p = a.GetName();
      console.log("Array name", p, "Not supported DataType: ", l);
      continue;
    }
    const u = a.GetName(), d = We.newInstance({
      values: e ? o.slice() : o,
      name: u,
      numberOfComponents: a.GetNumberOfComponents(),
      dataType: c
    });
    t.getCellData().addArray(d);
    let h = a.GetAttrType();
    h == -1 && (u == "Colors" ? h = 0 : u == "Texture2DCoordinates" && (h = 3)), h != -1 && t.getCellData().setActiveAttributeByIndex(r, h), a.delete();
  }
  t.getPointData().removeAllArrays(), n = !1, s = i.GetNumberOfDataArrays(n);
  for (let r = 0; r < s; r++) {
    const a = i.GetDataArrayByIdx(r, n);
    let o;
    const l = a.GetDataType();
    let c;
    if (l == 10)
      c = Ke.FLOAT, o = a.GetDataFloat();
    else if (l == 11)
      c = Ke.DOUBLE, o = a.GetDataDouble();
    else if (l == 3)
      c = Ke.UNSIGNED_CHAR, o = a.GetDataChar();
    else if (l == 4)
      c = Ke.SHORT, o = a.GetDataShort();
    else if (l == 5)
      c = Ke.UNSIGNED_SHORT, o = a.GetDataUShort();
    else if (l == 6)
      c = Ke.INT, o = a.GetDataInt();
    else {
      const p = a.GetName();
      console.log("Array name:", p, "Not supported DataType: ", l);
      continue;
    }
    const u = a.GetName(), d = We.newInstance({
      values: e ? o.slice() : o,
      name: u,
      numberOfComponents: a.GetNumberOfComponents(),
      dataType: c
    });
    t.getPointData().addArray(d);
    let h = a.GetAttrType();
    h == -1 && (u == "Colors" ? h = 0 : u == "Texture2DCoordinates" && (h = 3)), h != -1 && t.getPointData().setActiveAttributeByIndex(r, h), a.delete();
  }
}
function $o(i, t) {
  const e = ut.create();
  ut.copy(e, t), i.SetUserMatrix(e), i.UpdateMatrixFromArray();
}
function sL(i) {
  return i.GetUserMatrix();
}
async function dDt(i) {
  const t = i.getWasmDocumentInstance();
  if (t) {
    const e = t.GetNumberOfDebugFiles();
    console.log("Number of debug files:", e);
    for (let n = 0; n < e; n++)
      setTimeout(
        async () => {
          const s = t.GetDebugFileNameAtIndex(n);
          console.log("Name: ", s), await ttt(i, s);
        },
        n * 1e3
        // Delay download every 200ms
      );
  }
}
async function ttt(i, t) {
  const e = await i.getFS();
  try {
    const n = e.FS.readFile(t), s = document.createElement("a");
    document.body.appendChild(s);
    const r = new Blob([n]), a = window.URL.createObjectURL(r);
    s.href = a, s.download = t, s.click(), window.URL.revokeObjectURL(a);
  } catch (n) {
    console.log("Save failed: ", n);
  }
}
function WI(i, t, e) {
  !i.GetPoints() || !i.mInitialized || (i.GetPoints().length || (e = !0), t.getPoints().setData(e ? i.GetPoints().slice() : i.GetPoints()), t.getPolys().setData(e ? i.GetPolys().slice() : i.GetPolys()), t.getVerts().setData(e ? i.GetVerts().slice() : i.GetVerts()), t.getLines().setData(e ? i.GetLines().slice() : i.GetLines()), t.getStrips().setData(e ? i.GetStrips().slice() : i.GetStrips()), i.GetVerts().length > 0 && console.warn("Check if correct - oVerts!!", i.GetVerts()));
}
function VT(i, t, e) {
  const n = i.GetPolyDataView();
  WI(n, t, e), n.delete(), NI(i, t, e), t.modified();
}
function jF(i, t) {
  const e = vc.newInstance(), n = xs.newInstance(), s = i.GetTextureSourceView();
  return Go(s, n, t), e.setInterpolate(s.mInterpolate), e.setRepeat(s.mRepeat), e.setInputData(n), s.delete(), e;
}
function ett(i) {
  const t = [];
  for (let e = 0; e < i.getSize(); e++) {
    const n = [0, 0, 0, 0];
    i.getNodeValue(e, n), t.push(n[0]), t.push(n[1]), t.push(n[2]), t.push(n[3]);
  }
  return t;
}
function ntt(i) {
  const t = [];
  for (let e = 0; e < i.getSize(); e++) {
    const n = [0, 0];
    i.getNodeValue(e, n), t.push(n[0]), t.push(n[1]);
  }
  return t;
}
function UF(i, t, e) {
  const n = L0.newInstance();
  if (i.mNumberOfNodes) {
    const s = i.GetBelowRangeColor().slice();
    n.setBelowRangeColor(s[0], s[1], s[2], s[3]);
    const r = i.GetAboveRangeColor().slice();
    n.setAboveRangeColor(r[0], r[1], r[2], r[3]), n.setUseAboveRangeColor(i.mUseAboveRangeColor || i.mNumberOfNodesOpacity), n.setUseBelowRangeColor(i.mUseBelowRangeColor), n.setAlpha(i.mAlpha);
    const a = e ? i.GetXRGBPointsFlatVector().slice() : i.GetXRGBPointsFlatVector(), o = i.GetAlphaPointsFlatVector();
    for (let l = 0; l < i.mNumberOfNodes; l++) {
      let c = 1;
      i.mNumberOfNodesOpacity && (c = o[l * 4 + 1]), n.addRGBPoint(a[l * 4], a[l * 4 + 1], a[l * 4 + 2], a[l * 4 + 3], c);
    }
    if (n.setHSVWrap(i.mHSVWrap), n.setScale(i.mScale), n.applyColorMap(i.mColorSpace), t) t.setLookupTable(n);
    else return n;
  }
}
function itt(i, t, e) {
  const n = L0.newInstance();
  if (i.mNumberOfNodes) {
    const s = e ? i.GetXRGBPointsFlatVector().slice() : i.GetXRGBPointsFlatVector();
    for (let o = 0; o < i.mNumberOfNodes; o++)
      n.addRGBPoint(s[o * 4], s[o * 4 + 1], s[o * 4 + 2], s[o * 4 + 3], 1);
    const r = i.GetBelowRangeColor().slice();
    n.setBelowRangeColor(r[0], r[1], r[2], 1);
    const a = i.GetAboveRangeColor().slice();
    n.setAboveRangeColor(a[0], a[1], a[2], 1), n.setUseAboveRangeColor(i.mUseAboveRangeColor), n.setUseBelowRangeColor(i.mUseBelowRangeColor), n.setAlpha(i.mAlpha), n.setHSVWrap(i.mHSVWrap), n.setScale(i.mScale), n.applyColorMap(i.mColorSpace), t.getProperty().setRGBTransferFunction(0, n);
  }
}
function stt(i, t, e) {
  const n = Bh.newInstance();
  if (i.mNumberOfNodesOpacity) {
    const s = e ? i.GetAlphaPointsFlatVector().slice() : i.GetAlphaPointsFlatVector();
    for (let r = 0; r < i.mNumberOfNodesOpacity; r++)
      n.addPoint(s[r * 2], s[r * 2 + 1]);
    t.getProperty().setScalarOpacity(0, n);
  }
}
function P1(i) {
  if (i instanceof BigInt64Array) {
    if (i.length === 0)
      return new Uint32Array(0);
    const t = new Uint32Array(i.length);
    for (let e = 0; e < i.length; e++)
      t[e] = Number(i[e]);
    return t;
  }
  return i;
}
function PF(i) {
  return new TextDecoder("latin1").decode(i);
}
function rtt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
  const n = PF(i), s = t.exec(n);
  if (!s)
    return {
      text: n
    };
  const r = s.index + s[0].length, a = n.substring(0, r);
  let o = null;
  const l = e ? e.exec(n) : null;
  if (l) {
    const c = n.substr(l.index);
    o = {
      text: a + c,
      binaryBuffer: i.slice(r, l.index)
    };
  } else
    o = {
      text: a,
      binaryBuffer: i.slice(r)
    };
  return o;
}
var p2 = {
  arrayBufferToString: PF,
  extractBinary: rtt
};
const GI = {};
function JF(i) {
  return !!GI[i];
}
function att() {
  let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "http", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return GI[i](t);
}
function AF(i, t) {
  GI[i] = t;
}
var DG = {
  get: att,
  has: JF,
  registerType: AF
};
const ott = (i) => i, WD = 1e-6;
class BF {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    this.matrix = ut.identity(new Float64Array(16)), this.tmp = new Float64Array(3), this.angleConv = t ? l7.toRadian : ott;
  }
  rotateFromDirections(t, e) {
    const n = new Float64Array(3), s = new Float64Array(3), r = new Float64Array(16);
    I.set(n, t[0], t[1], t[2]), I.set(s, e[0], e[1], e[2]), I.normalize(n, n), I.normalize(s, s);
    const a = I.dot(n, s);
    return a >= 1 ? this : (I.cross(this.tmp, n, s), I.length(this.tmp) < WD && (I.cross(this.tmp, [1, 0, 0], t), I.length(this.tmp) < WD && I.cross(this.tmp, [0, 1, 0], t)), ut.fromRotation(r, Math.acos(a), this.tmp), ut.multiply(this.matrix, this.matrix, r), this);
  }
  rotate(t, e) {
    return I.set(this.tmp, ...e), I.normalize(this.tmp, this.tmp), ut.rotate(this.matrix, this.matrix, this.angleConv(t), this.tmp), this;
  }
  rotateX(t) {
    return ut.rotateX(this.matrix, this.matrix, this.angleConv(t)), this;
  }
  rotateY(t) {
    return ut.rotateY(this.matrix, this.matrix, this.angleConv(t)), this;
  }
  rotateZ(t) {
    return ut.rotateZ(this.matrix, this.matrix, this.angleConv(t)), this;
  }
  translate(t, e, n) {
    return I.set(this.tmp, t, e, n), ut.translate(this.matrix, this.matrix, this.tmp), this;
  }
  scale(t, e, n) {
    return I.set(this.tmp, t, e, n), ut.scale(this.matrix, this.matrix, this.tmp), this;
  }
  multiply(t) {
    return ut.multiply(this.matrix, this.matrix, t), this;
  }
  multiply3x3(t) {
    return ut.multiply(this.matrix, this.matrix, [t[0], t[1], t[2], 0, t[3], t[4], t[5], 0, t[6], t[7], t[8], 0, 0, 0, 0, 1]), this;
  }
  invert() {
    return ut.invert(this.matrix, this.matrix), this;
  }
  identity() {
    return ut.identity(this.matrix), this;
  }
  //-----------
  apply(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
    if (ST(oI, this.matrix))
      return this;
    const s = n === -1 ? t.length : e + n * 3;
    for (let r = e; r < s; r += 3)
      I.set(this.tmp, t[r], t[r + 1], t[r + 2]), I.transformMat4(this.tmp, this.tmp, this.matrix), t[r] = this.tmp[0], t[r + 1] = this.tmp[1], t[r + 2] = this.tmp[2];
    return this;
  }
  getMatrix() {
    return this.matrix;
  }
  setMatrix(t) {
    return t && t.length === 16 && ut.copy(this.matrix, t), this;
  }
}
function ltt() {
  return new BF(!0);
}
function ctt() {
  return new BF(!1);
}
var il = {
  buildFromDegree: ltt,
  buildFromRadian: ctt
};
function KF(i) {
  let t = 0;
  return i.filter((e, n) => n === t ? (t += e + 1, !0) : !1);
}
function HF(i) {
  let t = 0;
  for (let e = 0; e < i.length; )
    e += Number(i[e]) + 1, t++;
  return t;
}
const utt = {
  extractCellSizes: KF,
  getNumberOfCells: HF
};
function dtt(i, t) {
  t.classHierarchy.push("vtkCellArray");
  const e = {
    ...i
  };
  i.getNumberOfCells = (n) => (t.numberOfCells !== void 0 && !n || (t.cellSizes ? t.numberOfCells = t.cellSizes.length : t.numberOfCells = HF(i.getData())), t.numberOfCells), i.getCellSizes = (n) => (t.cellSizes !== void 0 && !n || (t.cellSizes = KF(i.getData())), t.cellSizes), i.resize = (n) => {
    const s = i.getNumberOfTuples();
    e.resize(n);
    const r = i.getNumberOfTuples();
    r < s && (r === 0 ? (t.numberOfCells = 0, t.cellSizes = []) : (t.numberOfCells = void 0, t.cellSizes = void 0));
  }, i.setData = (n) => {
    e.setData(n, 1), t.numberOfCells = void 0, t.cellSizes = void 0;
  }, i.getCell = (n) => {
    let s = n;
    const r = t.values[s++];
    return t.values.subarray(s, s + r);
  }, i.insertNextCell = (n) => {
    const s = i.getNumberOfCells();
    return i.insertNextTuples([n.length, ...n]), ++t.numberOfCells, t.cellSizes != null && t.cellSizes.push(n.length), s;
  };
}
function htt(i) {
  return {
    empty: !0,
    numberOfComponents: 1,
    dataType: Ke.UNSIGNED_INT,
    ...i
  };
}
function _F(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  We.extend(i, t, htt(e)), dtt(i, t);
}
const ptt = tt.newInstance(_F, "vtkCellArray");
var Ii = {
  newInstance: ptt,
  extend: _F,
  ...utt
};
const {
  vtkErrorMacro: mtt
} = tt, btt = [1, -1, 1, -1, 1, -1];
function ftt(i, t) {
  t.classHierarchy.push("vtkPoints"), i.getNumberOfPoints = i.getNumberOfTuples, i.setNumberOfPoints = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
    i.getNumberOfPoints() !== e && (t.size = e * n, t.values = tt.newTypedArray(t.dataType, t.size), i.setNumberOfComponents(n), i.modified());
  }, i.setPoint = function(e) {
    for (var n = arguments.length, s = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
      s[r - 1] = arguments[r];
    i.setTuple(e, s);
  }, i.getPoint = i.getTuple, i.findPoint = i.findTuple, i.insertNextPoint = (e, n, s) => i.insertNextTuple([e, n, s]), i.getBounds = () => {
    if (i.getNumberOfComponents() === 3) {
      const s = i.getRange(0);
      t.bounds[0] = s[0], t.bounds[1] = s[1];
      const r = i.getRange(1);
      t.bounds[2] = r[0], t.bounds[3] = r[1];
      const a = i.getRange(2);
      return t.bounds[4] = a[0], t.bounds[5] = a[1], t.bounds;
    }
    if (i.getNumberOfComponents() !== 2)
      return mtt(`getBounds called on an array with components of
        ${i.getNumberOfComponents()}`), btt;
    const e = i.getRange(0);
    t.bounds[0] = e[0], t.bounds[1] = e[1];
    const n = i.getRange(1);
    return t.bounds[2] = n[0], t.bounds[3] = n[1], t.bounds[4] = 0, t.bounds[5] = 0, t.bounds;
  }, i.computeBounds = i.getBounds, i.setNumberOfComponents(t.numberOfComponents < 2 ? 3 : t.numberOfComponents);
}
const gtt = {
  empty: !0,
  numberOfComponents: 3,
  dataType: Ke.FLOAT,
  bounds: [1, -1, 1, -1, 1, -1]
};
function QF(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, gtt, e), We.extend(i, t, e), ftt(i, t);
}
const ytt = tt.newInstance(QF, "vtkPoints");
var yi = {
  newInstance: ytt,
  extend: QF
};
function Ztt(i, t) {
  t.classHierarchy.push("vtkCell"), i.initialize = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (n) {
      t.pointsIds = n;
      let s = t.points.getData();
      s.length !== 3 * t.pointsIds.length && (s = tt.newTypedArray(e.getDataType(), 3 * t.pointsIds.length));
      const r = e.getData();
      t.pointsIds.forEach((a, o) => {
        let l = 3 * a, c = 3 * o;
        s[c] = r[l], s[++c] = r[++l], s[++c] = r[++l];
      }), t.points.setData(s);
    } else {
      t.points = e, t.pointsIds = new Array(e.getNumberOfPoints());
      for (let s = e.getNumberOfPoints() - 1; s >= 0; --s)
        t.pointsIds[s] = s;
    }
  }, i.getBounds = () => {
    const e = t.points.getNumberOfPoints(), n = [];
    if (e) {
      t.points.getPoint(0, n), t.bounds[0] = n[0], t.bounds[1] = n[0], t.bounds[2] = n[1], t.bounds[3] = n[1], t.bounds[4] = n[2], t.bounds[5] = n[2];
      for (let s = 1; s < e; s++)
        t.points.getPoint(s, n), t.bounds[0] = n[0] < t.bounds[0] ? n[0] : t.bounds[0], t.bounds[1] = n[0] > t.bounds[1] ? n[0] : t.bounds[1], t.bounds[2] = n[1] < t.bounds[2] ? n[1] : t.bounds[2], t.bounds[3] = n[1] > t.bounds[3] ? n[1] : t.bounds[3], t.bounds[4] = n[2] < t.bounds[4] ? n[2] : t.bounds[4], t.bounds[5] = n[2] > t.bounds[5] ? n[2] : t.bounds[5];
    } else
      Lg(t.bounds);
    return t.bounds;
  }, i.getLength2 = () => {
    i.getBounds();
    let e = 0, n = 0;
    for (let s = 0; s < 3; s++)
      n = t.bounds[2 * s + 1] - t.bounds[2 * s], e += n * n;
    return e;
  }, i.getParametricDistance = (e) => {
    let n, s = 0;
    for (let r = 0; r < 3; r++)
      e[r] < 0 ? n = -e[r] : e[r] > 1 ? n = e[r] - 1 : n = 0, n > s && (s = n);
    return s;
  }, i.getNumberOfPoints = () => t.points.getNumberOfPoints(), i.deepCopy = (e) => {
    e.initialize(t.points, t.pointsIds);
  }, i.getCellDimension = () => {
  }, i.intersectWithLine = (e, n, s, r, a, o, l) => {
  }, i.evaluatePosition = (e, n, s, r, a, o) => {
    tt.vtkErrorMacro("vtkCell.evaluatePosition is not implemented.");
  };
}
const Ttt = {
  bounds: [-1, -1, -1, -1, -1, -1],
  pointsIds: []
};
function $F(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Ttt, e), tt.obj(i, t), t.points || (t.points = yi.newInstance()), tt.get(i, t, ["points", "pointsIds"]), Ztt(i, t);
}
const Mtt = tt.newInstance($F, "vtkCell");
var mg = {
  newInstance: Mtt,
  extend: $F
};
function Ntt(i, t) {
  let e = t;
  for (t >= i.array.length && (e += i.array.length); e > i.array.length; ) i.array.push({
    ncells: 0,
    cells: null
  });
  i.array.length = e;
}
function Wtt(i, t) {
  t.classHierarchy.push("vtkCellLinks"), i.buildLinks = (e) => {
    const n = e.getPoints().getNumberOfPoints(), s = e.getNumberOfCells(), r = new Uint32Array(n);
    if (e.isA("vtkPolyData")) {
      for (let a = 0; a < s; ++a) {
        const {
          cellPointIds: o
        } = e.getCellPoints(a);
        o.forEach((l) => {
          i.incrementLinkCount(l);
        });
      }
      i.allocateLinks(n), t.maxId = n - 1;
      for (let a = 0; a < s; ++a) {
        const {
          cellPointIds: o
        } = e.getCellPoints(a);
        o.forEach((l) => {
          i.insertCellReference(l, r[l]++, a);
        });
      }
    } else {
      for (let a = 0; a < s; a++)
        mg.newInstance().getPointsIds().forEach((l) => {
          i.incrementLinkCount(l);
        });
      i.allocateLinks(n), t.maxId = n - 1;
      for (let a = 0; a < s; ++a)
        mg.newInstance().getPointsIds().forEach((l) => {
          i.insertCellReference(l, r[l]++, a);
        });
    }
  }, i.allocate = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e3;
    t.array = Array(e).fill().map(() => ({
      ncells: 0,
      cells: null
    })), t.extend = n, t.maxId = -1;
  }, i.initialize = () => {
    t.array = null;
  }, i.getLink = (e) => t.array[e], i.getNcells = (e) => t.array[e].ncells, i.getCells = (e) => t.array[e].cells, i.insertNextPoint = (e) => {
    t.array.push({
      ncells: e,
      cells: Array(e)
    }), ++t.maxId;
  }, i.insertNextCellReference = (e, n) => {
    t.array[e].cells[t.array[e].ncells++] = n;
  }, i.deletePoint = (e) => {
    t.array[e].ncells = 0, t.array[e].cells = null;
  }, i.removeCellReference = (e, n) => {
    t.array[n].cells = t.array[n].cells.filter((s) => s !== e), t.array[n].ncells = t.array[n].cells.length;
  }, i.addCellReference = (e, n) => {
    t.array[n].cells[t.array[n].ncells++] = e;
  }, i.resizeCellList = (e, n) => {
    t.array[e].cells.length = n;
  }, i.squeeze = () => {
    Ntt(t, t.maxId + 1);
  }, i.reset = () => {
    t.maxId = -1;
  }, i.deepCopy = (e) => {
    t.array = [...e.array], t.extend = e.extend, t.maxId = e.maxId;
  }, i.incrementLinkCount = (e) => {
    ++t.array[e].ncells;
  }, i.allocateLinks = (e) => {
    for (let n = 0; n < e; ++n)
      t.array[n].cells = new Array(t.array[n].ncells);
  }, i.insertCellReference = (e, n, s) => {
    t.array[e].cells[n] = s;
  };
}
const Gtt = {
  array: null,
  // pointer to data
  maxId: 0,
  // maximum index inserted thus far
  extend: 0
  // grow array by this point
};
function qF(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Gtt, e), tt.obj(i, t), Wtt(i, t);
}
const wtt = tt.newInstance(qF, "vtkCellLinks");
var xtt = {
  newInstance: wtt,
  extend: qF
};
const ei = {
  // Linear cells
  VTK_EMPTY_CELL: 0,
  VTK_VERTEX: 1,
  VTK_POLY_VERTEX: 2,
  VTK_LINE: 3,
  VTK_POLY_LINE: 4,
  VTK_TRIANGLE: 5,
  VTK_TRIANGLE_STRIP: 6,
  VTK_POLYGON: 7,
  VTK_QUAD: 9,
  // Quadratic, isoparametric cells
  VTK_QUADRATIC_EDGE: 21,
  // Special class of cells formed by convex group of points
  VTK_CONVEX_POINT_SET: 41,
  // Polyhedron cell (consisting of polygonal faces)
  VTK_POLYHEDRON: 42
}, rL = ["vtkEmptyCell", "vtkVertex", "vtkPolyVertex", "vtkLine", "vtkPolyLine", "vtkTriangle", "vtkTriangleStrip", "vtkPolygon", "vtkPixel", "vtkQuad", "vtkTetra", "vtkVoxel", "vtkHexahedron", "vtkWedge", "vtkPyramid", "vtkPentagonalPrism", "vtkHexagonalPrism", "UnknownClass", "UnknownClass", "UnknownClass", "UnknownClass", "vtkQuadraticEdge", "vtkQuadraticTriangle", "vtkQuadraticQuad", "vtkQuadraticTetra", "vtkQuadraticHexahedron", "vtkQuadraticWedge", "vtkQuadraticPyramid", "vtkBiQuadraticQuad", "vtkTriQuadraticHexahedron", "vtkQuadraticLinearQuad", "vtkQuadraticLinearWedge", "vtkBiQuadraticQuadraticWedge", "vtkBiQuadraticQuadraticHexahedron", "vtkBiQuadraticTriangle", "vtkCubicLine", "vtkQuadraticPolygon", "UnknownClass", "UnknownClass", "UnknownClass", "UnknownClass", "vtkConvexPointSet", "UnknownClass", "UnknownClass", "UnknownClass", "UnknownClass", "UnknownClass", "UnknownClass", "UnknownClass", "UnknownClass", "UnknownClass", "vtkParametricCurve", "vtkParametricSurface", "vtkParametricTriSurface", "vtkParametricQuadSurface", "vtkParametricTetraRegion", "vtkParametricHexRegion", "UnknownClass", "UnknownClass", "UnknownClass", "vtkHigherOrderEdge", "vtkHigherOrderTriangle", "vtkHigherOrderQuad", "vtkHigherOrderPolygon", "vtkHigherOrderTetrahedron", "vtkHigherOrderWedge", "vtkHigherOrderPyramid", "vtkHigherOrderHexahedron"];
function Stt(i) {
  return i < rL.length ? rL[i] : "UnknownClass";
}
function Ltt(i) {
  return rL.findIndex(i);
}
function Vtt(i) {
  return i < ei.VTK_QUADRATIC_EDGE || i === ei.VTK_CONVEX_POINT_SET || i === ei.VTK_POLYHEDRON;
}
function Xtt(i) {
  return i === ei.VTK_TRIANGLE_STRIP || i === ei.VTK_POLY_LINE || i === ei.VTK_POLY_VERTEX;
}
const Itt = {
  getClassNameFromTypeId: Stt,
  getTypeIdFromClassName: Ltt,
  isLinear: Vtt,
  hasSubCells: Xtt
};
function Ctt(i, t) {
  t.classHierarchy.push("vtkCellTypes"), i.allocate = function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 512, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e3;
    t.size = e > 0 ? e : 1, t.extend = n > 0 ? n : 1, t.maxId = -1, t.typeArray = new Uint8Array(e), t.locationArray = new Uint32Array(e);
  }, i.insertCell = (e, n, s) => {
    t.typeArray[e] = n, t.locationArray[e] = s, e > t.maxId && (t.maxId = e);
  }, i.insertNextCell = (e, n) => (i.insertCell(++t.maxId, e, n), t.maxId), i.setCellTypes = (e, n, s) => {
    t.size = e, t.typeArray = n, t.locationArray = s, t.maxId = e - 1;
  }, i.getCellLocation = (e) => t.locationArray[e], i.deleteCell = (e) => {
    t.typeArray[e] = ei.VTK_EMPTY_CELL;
  }, i.getNumberOfTypes = () => t.maxId + 1, i.isType = (e) => {
    const n = i.getNumberOfTypes();
    for (let s = 0; s < n; ++s)
      if (e === i.getCellType(s))
        return !0;
    return !1;
  }, i.insertNextType = (e) => i.insertNextCell(e, -1), i.getCellType = (e) => t.typeArray[e], i.reset = () => {
    t.maxId = -1;
  }, i.deepCopy = (e) => {
    i.allocate(e.getSize(), e.getExtend()), t.typeArray.set(e.getTypeArray()), t.locationArray.set(e.getLocationArray()), t.maxId = e.getMaxId();
  };
}
const Ytt = {
  // typeArray: null, // pointer to types array
  // locationArray: null;   // pointer to array of offsets
  size: 0,
  // allocated size of data
  maxId: -1,
  // maximum index inserted thus far
  extend: 1e3
  // grow array by this point
};
function t9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Ytt, e), tt.obj(i, t), tt.get(i, t, ["size", "maxId", "extend"]), tt.getArray(i, t, ["typeArray", "locationArray"]), Ctt(i, t);
}
const vtt = tt.newInstance(t9, "vtkCellTypes");
var aL = {
  newInstance: vtt,
  extend: t9,
  ...Itt
};
const e9 = {
  NO_INTERSECTION: 0,
  YES_INTERSECTION: 1,
  ON_LINE: 2
};
var n9 = {
  IntersectionState: e9
};
const {
  IntersectionState: iN
} = n9;
function yb(i, t, e) {
  let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  const s = {
    t: Number.MIN_VALUE,
    distance: 0
  }, r = [];
  let a;
  r[0] = e[0] - t[0], r[1] = e[1] - t[1], r[2] = e[2] - t[2];
  const o = r[0] * (i[0] - t[0]) + r[1] * (i[1] - t[1]) + r[2] * (i[2] - t[2]), l = tn(r, r);
  let c = 1e-5 * o;
  return l !== 0 && (s.t = o / l), c < 0 && (c = -c), -c < l && l < c || l <= 0 || s.t < 0 ? a = t : s.t > 1 ? a = e : (a = r, r[0] = t[0] + s.t * r[0], r[1] = t[1] + s.t * r[1], r[2] = t[2] + s.t * r[2]), n && (n[0] = a[0], n[1] = a[1], n[2] = a[2]), s.distance = zs(a, i), s;
}
function i9(i, t, e, n, s, r) {
  const a = [], o = [], l = [];
  s[0] = 0, r[0] = 0, fi(t, i, a), fi(n, e, o), fi(e, i, l);
  const c = [tn(a, a), -tn(a, o), -tn(a, o), tn(o, o)], u = [];
  if (u[0] = tn(a, l), u[1] = -tn(o, l), jk(c, u, 2) === 0) {
    let d = Number.MAX_VALUE;
    const h = [i, t, e, n], p = [e, e, i, i], m = [n, n, t, t];
    r[0], r[0], s[0], s[0], s[0], s[0], r[0], r[0];
    let b;
    for (let y = 0; y < 4; y++)
      b = yb(h[y], p[y], m[y]), b.distance < d && (d = b.distance);
    return iN.ON_LINE;
  }
  return s[0] = u[0], r[0] = u[1], s[0] >= 0 && s[0] <= 1 && r[0] >= 0 && r[0] <= 1 ? iN.YES_INTERSECTION : iN.NO_INTERSECTION;
}
const Rtt = {
  distanceToLine: yb,
  intersection: i9
};
function Dtt(i, t) {
  t.classHierarchy.push("vtkLine");
  function e(n) {
    return n >= 0 && n <= 1;
  }
  i.getCellDimension = () => 1, i.intersectWithLine = (n, s, r, a, o) => {
    const l = {
      intersect: 0,
      t: Number.MAX_VALUE,
      subId: 0,
      betweenPoints: null
    };
    o[1] = 0, o[2] = 0;
    const c = [], u = [], d = [];
    t.points.getPoint(0, u), t.points.getPoint(1, d);
    const h = [], p = [], m = i9(n, s, u, d, h, p);
    if (l.t = h[0], l.betweenPoints = e(l.t), o[0] = p[0], m === iN.YES_INTERSECTION) {
      for (let b = 0; b < 3; b++)
        a[b] = u[b] + o[0] * (d[b] - u[b]), c[b] = n[b] + l.t * (s[b] - n[b]);
      if (zs(a, c) <= r * r)
        return l.intersect = 1, l;
    } else {
      let b;
      if (l.t < 0)
        return b = yb(n, u, d, a), b.distance <= r * r && (l.t = 0, l.intersect = 1, l.betweenPoints = !0), l;
      if (l.t > 1)
        return b = yb(s, u, d, a), b.distance <= r * r && (l.t = 1, l.intersect = 1, l.betweenPoints = !0), l;
      if (o[0] < 0)
        return o[0] = 0, b = yb(u, n, s, a), l.t = b.t, b.distance <= r * r && (l.intersect = 1), l;
      if (o[0] > 1)
        return o[0] = 1, b = yb(d, n, s, a), l.t = b.t, b.distance <= r * r && (l.intersect = 1), l;
    }
    return l;
  }, i.evaluateLocation = (n, s, r) => {
    const a = [], o = [];
    t.points.getPoint(0, a), t.points.getPoint(1, o);
    for (let l = 0; l < 3; l++)
      s[l] = a[l] + n[0] * (o[l] - a[l]);
    r[0] = 1 - n[0], r[1] = n[0];
  }, i.evaluateOrientation = (n, s, r) => t.orientations ? (ps.slerp(s, t.orientations[0], t.orientations[1], n[0]), r[0] = 1 - n[0], r[1] = n[0], !0) : !1;
}
const Ott = {
  orientations: null
  // an array of two quat or null
};
function s9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Ott, e), mg.extend(i, t, e), tt.setGet(i, t, ["orientations"]), Dtt(i, t);
}
const ztt = tt.newInstance(s9, "vtkLine");
var Vr = {
  newInstance: ztt,
  extend: s9,
  ...Rtt,
  ...n9
};
function Ett(i, t) {
  t.classHierarchy.push("vtkPointSet"), t.points ? t.points = Dl(t.points) : t.points = yi.newInstance(), i.getNumberOfPoints = () => t.points.getNumberOfPoints(), i.getBounds = () => t.points.getBounds(), i.computeBounds = () => {
    i.getBounds();
  };
  const e = i.shallowCopy;
  i.shallowCopy = function(n) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    e(n, s), t.points = yi.newInstance(), t.points.shallowCopy(n.getPoints());
  };
}
const ktt = {
  // points: null,
};
function r9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, ktt, e), Vg.extend(i, t, e), tt.setGet(i, t, ["points"]), Ett(i, t);
}
const Ftt = tt.newInstance(r9, "vtkPointSet");
var jtt = {
  newInstance: Ftt,
  extend: r9
};
function wI(i, t, e, n) {
  const s = e[0] - t[0], r = e[1] - t[1], a = e[2] - t[2], o = i[0] - t[0], l = i[1] - t[1], c = i[2] - t[2];
  n[0] = r * c - a * l, n[1] = a * o - s * c, n[2] = s * l - r * o;
}
function dW(i, t, e, n) {
  wI(i, t, e, n);
  const s = Math.sqrt(n[0] * n[0] + n[1] * n[1] + n[2] * n[2]);
  s !== 0 && (n[0] /= s, n[1] /= s, n[2] /= s);
}
function Utt(i, t, e, n, s, r) {
  let a = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 1e-6, o = !1;
  const l = [], c = [], u = [], d = [], h = [];
  dW(i, t, e, d), dW(n, s, r, h);
  const p = -tn(d, i), m = -tn(h, n), b = [tn(h, i) + m, tn(h, t) + m, tn(h, e) + m];
  if (b[0] * b[1] > a && b[0] * b[2] > a)
    return {
      intersect: !1,
      coplanar: o,
      pt1: l,
      pt2: c,
      surfaceId: u
    };
  const y = [tn(d, n) + p, tn(d, s) + p, tn(d, r) + p];
  if (y[0] * y[1] > a && y[0] * y[2] > a)
    return {
      intersect: !1,
      coplanar: o,
      pt1: l,
      pt2: c,
      surfaceId: u
    };
  if (Math.abs(d[0] - h[0]) < 1e-9 && Math.abs(d[1] - h[1]) < 1e-9 && Math.abs(d[2] - h[2]) < 1e-9 && Math.abs(p - m) < 1e-9)
    return o = !0, {
      intersect: !1,
      coplanar: o,
      pt1: l,
      pt2: c,
      surfaceId: u
    };
  const Z = [i, t, e], g = [n, s, r], f = tn(d, h), T = (p - m * f) / (f * f - 1), M = (m - p * f) / (f * f - 1), N = [T * d[0] + M * h[0], T * d[1] + M * h[1], T * d[2] + M * h[2]], W = Wi(d, h, []);
  Fn(W);
  let x = 0, V = 0;
  const X = [], C = [];
  let R = 50, z = 50;
  for (let j = 0; j < 3; j++) {
    const H = j, B = (j + 1) % 3, $ = li.intersectWithLine(Z[H], Z[B], n, h);
    $.intersection && $.t > 0 - a && $.t < 1 + a && ($.t < 1 + a && $.t > 1 - a && (R = x), X[x++] = tn($.x, W) - tn(N, W));
    const A = li.intersectWithLine(g[H], g[B], i, d);
    A.intersection && A.t > 0 - a && A.t < 1 + a && (A.t < 1 + a && A.t > 1 - a && (z = V), C[V++] = tn(A.x, W) - tn(N, W));
  }
  if (x > 2) {
    x--;
    const j = X[2];
    X[2] = X[R], X[R] = j;
  }
  if (V > 2) {
    V--;
    const j = C[2];
    C[2] = C[z], C[z] = j;
  }
  if (x !== 2 || V !== 2)
    return {
      intersect: !1,
      coplanar: o,
      pt1: l,
      pt2: c,
      surfaceId: u
    };
  if (Number.isNaN(X[0]) || Number.isNaN(X[1]) || Number.isNaN(C[0]) || Number.isNaN(C[1]))
    return {
      intersect: !1,
      coplanar: o,
      pt1: l,
      pt2: c,
      surfaceId: u
    };
  if (X[0] > X[1]) {
    const j = X[1];
    X[1] = X[0], X[0] = j;
  }
  if (C[0] > C[1]) {
    const j = C[1];
    C[1] = C[0], C[0] = j;
  }
  let F, P;
  return X[1] < C[0] || C[1] < X[0] ? {
    intersect: !1,
    coplanar: o,
    pt1: l,
    pt2: c,
    surfaceId: u
  } : (X[0] < C[0] ? X[1] < C[1] ? (u[0] = 2, u[1] = 1, F = C[0], P = X[1]) : (u[0] = 2, u[1] = 2, F = C[0], P = C[1]) : X[1] < C[1] ? (u[0] = 1, u[1] = 1, F = X[0], P = X[1]) : (u[0] = 1, u[1] = 2, F = X[0], P = C[1]), AS(N, W, F, l), AS(N, W, P, c), {
    intersect: !0,
    coplanar: o,
    pt1: l,
    pt2: c,
    surfaceId: u
  });
}
const Ptt = {
  computeNormalDirection: wI,
  computeNormal: dW,
  intersectWithTriangle: Utt
};
function Jtt(i, t) {
  t.classHierarchy.push("vtkTriangle"), i.getCellDimension = () => 2, i.intersectWithLine = (e, n, s, r, a) => {
    const o = {
      subId: 0,
      t: Number.MAX_VALUE,
      intersect: 0,
      betweenPoints: !1
    };
    a[2] = 0;
    const l = [], c = s * s, u = [], d = [], h = [];
    t.points.getPoint(0, u), t.points.getPoint(1, d), t.points.getPoint(2, h);
    const p = [], m = [];
    if (dW(u, d, h, p), p[0] !== 0 || p[1] !== 0 || p[2] !== 0) {
      const f = li.intersectWithLine(e, n, u, p);
      if (o.betweenPoints = f.betweenPoints, o.t = f.t, r[0] = f.x[0], r[1] = f.x[1], r[2] = f.x[2], !f.intersection)
        return a[0] = 0, a[1] = 0, o.intersect = 0, o;
      const T = i.evaluatePosition(r, l, a, m);
      if (T.evaluation >= 0)
        return T.dist2 <= c ? (o.intersect = 1, o) : (o.intersect = T.evaluation, o);
    }
    const b = zs(u, d), y = zs(d, h), Z = zs(h, u);
    t.line || (t.line = Vr.newInstance()), b > y && b > Z ? (t.line.getPoints().setPoint(0, u), t.line.getPoints().setPoint(1, d)) : y > Z && y > b ? (t.line.getPoints().setPoint(0, d), t.line.getPoints().setPoint(1, h)) : (t.line.getPoints().setPoint(0, h), t.line.getPoints().setPoint(1, u));
    const g = t.line.intersectWithLine(e, n, s, r, a);
    if (o.betweenPoints = g.betweenPoints, o.t = g.t, g.intersect) {
      const f = [], T = [], M = [];
      for (let N = 0; N < 3; N++)
        f[N] = u[N] - h[N], T[N] = d[N] - h[N], M[N] = r[N] - h[N];
      return a[0] = tn(M, f) / Z, a[1] = tn(M, T) / y, o.intersect = 1, o;
    }
    return a[0] = 0, a[1] = 0, o.intersect = 0, o;
  }, i.evaluatePosition = (e, n, s, r) => {
    const a = {
      subId: 0,
      dist2: 0,
      evaluation: -1
    };
    let o, l;
    const c = [], u = [], d = [], h = [];
    let p;
    const m = [], b = [], y = [];
    let Z = 0, g = 0;
    const f = [];
    let T, M, N, W = [];
    const x = [], V = [], X = [];
    a.subId = 0, s[2] = 0, t.points.getPoint(1, c), t.points.getPoint(2, u), t.points.getPoint(0, d), wI(c, u, d, h), li.generalizedProjectPoint(e, c, h, X);
    let C = 0;
    for (o = 0; o < 3; o++)
      h[o] < 0 ? p = -h[o] : p = h[o], p > C && (C = p, g = o);
    for (l = 0, o = 0; o < 3; o++)
      o !== g && (f[l++] = o);
    for (o = 0; o < 2; o++)
      m[o] = X[f[o]] - d[f[o]], b[o] = c[f[o]] - d[f[o]], y[o] = u[f[o]] - d[f[o]];
    if (Z = is(b, y), Z === 0)
      return s[0] = 0, s[1] = 0, a.evaluation = -1, a;
    if (s[0] = is(m, y) / Z, s[1] = is(b, m) / Z, r[0] = 1 - (s[0] + s[1]), r[1] = s[0], r[2] = s[1], r[0] >= 0 && r[0] <= 1 && r[1] >= 0 && r[1] <= 1 && r[2] >= 0 && r[2] <= 1)
      n && (a.dist2 = zs(X, e), n[0] = X[0], n[1] = X[1], n[2] = X[2]), a.evaluation = 1;
    else {
      let R;
      if (n) {
        if (r[1] < 0 && r[2] < 0)
          for (T = zs(e, d), M = Vr.distanceToLine(e, c, d, R, x), N = Vr.distanceToLine(e, d, u, R, V), T < M ? (a.dist2 = T, W = d) : (a.dist2 = M, W = x), N < a.dist2 && (a.dist2 = N, W = V), o = 0; o < 3; o++)
            n[o] = W[o];
        else if (r[2] < 0 && r[0] < 0)
          for (T = zs(e, c), M = Vr.distanceToLine(e, c, d, R, x), N = Vr.distanceToLine(e, c, u, R, V), T < M ? (a.dist2 = T, W = c) : (a.dist2 = M, W = x), N < a.dist2 && (a.dist2 = N, W = V), o = 0; o < 3; o++)
            n[o] = W[o];
        else if (r[1] < 0 && r[0] < 0)
          for (T = zs(e, u), M = Vr.distanceToLine(e, u, d, R, x), N = Vr.distanceToLine(e, c, u, R, V), T < M ? (a.dist2 = T, W = u) : (a.dist2 = M, W = x), N < a.dist2 && (a.dist2 = N, W = V), o = 0; o < 3; o++)
            n[o] = W[o];
        else if (r[0] < 0) {
          const z = Vr.distanceToLine(e, c, u, n);
          a.dist2 = z.distance;
        } else if (r[1] < 0) {
          const z = Vr.distanceToLine(e, u, d, n);
          a.dist2 = z.distance;
        } else if (r[2] < 0) {
          const z = Vr.distanceToLine(e, c, d, n);
          a.dist2 = z.distance;
        }
      }
      a.evaluation = 0;
    }
    return a;
  }, i.evaluateLocation = (e, n, s) => {
    const r = [], a = [], o = [];
    t.points.getPoint(0, r), t.points.getPoint(1, a), t.points.getPoint(2, o);
    const l = 1 - e[0] - e[1];
    for (let c = 0; c < 3; c++)
      n[c] = r[c] * l + a[c] * e[0] + o[c] * e[1];
    s[0] = l, s[1] = e[0], s[2] = e[1];
  }, i.getParametricDistance = (e) => {
    let n, s = 0;
    const r = [];
    r[0] = e[0], r[1] = e[1], r[2] = 1 - e[0] - e[1];
    for (let a = 0; a < 3; a++)
      r[a] < 0 ? n = -r[a] : r[a] > 1 ? n = r[a] - 1 : n = 0, n > s && (s = n);
    return s;
  };
}
const Att = {};
function a9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Att, e), mg.extend(i, t, e), Jtt(i, t);
}
const Btt = tt.newInstance(a9, "vtkTriangle");
var xI = {
  newInstance: Btt,
  extend: a9,
  ...Ptt
};
const e2 = ["verts", "lines", "polys", "strips"], {
  vtkWarningMacro: GD
} = tt, Ktt = {
  [ei.VTK_LINE]: Vr,
  [ei.VTK_POLY_LINE]: Vr,
  [ei.VTK_TRIANGLE]: xI
};
function Htt(i, t) {
  t.classHierarchy.push("vtkPolyData");
  function e(s) {
    return s.replace(/(?:^\w|[A-Z]|\b\w)/g, (r) => r.toUpperCase()).replace(/\s+/g, "");
  }
  e2.forEach((s) => {
    i[`getNumberOf${e(s)}`] = () => t[s].getNumberOfCells(), t[s] ? t[s] = Dl(t[s]) : t[s] = Ii.newInstance();
  }), i.getNumberOfCells = () => e2.reduce((s, r) => s + t[r].getNumberOfCells(), 0);
  const n = i.shallowCopy;
  i.shallowCopy = function(s) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    n(s, r), e2.forEach((a) => {
      t[a] = Ii.newInstance(), t[a].shallowCopy(s.getReferenceByName(a));
    });
  }, i.buildCells = () => {
    const s = i.getNumberOfVerts(), r = i.getNumberOfLines(), a = i.getNumberOfPolys(), o = i.getNumberOfStrips(), l = s + r + a + o, c = new Uint8Array(l);
    let u = c;
    const d = new Uint32Array(l);
    let h = d;
    if (s) {
      let p = 0;
      t.verts.getCellSizes().forEach((m, b) => {
        h[b] = p, u[b] = m > 1 ? ei.VTK_POLY_VERTEX : ei.VTK_VERTEX, p += m + 1;
      }), h = h.subarray(s), u = u.subarray(s);
    }
    if (r) {
      let p = 0;
      t.lines.getCellSizes().forEach((m, b) => {
        h[b] = p, u[b] = m > 2 ? ei.VTK_POLY_LINE : ei.VTK_LINE, m === 1 && GD("Building VTK_LINE ", b, " with only one point, but VTK_LINE needs at least two points. Check the input."), p += m + 1;
      }), h = h.subarray(r), u = u.subarray(r);
    }
    if (a) {
      let p = 0;
      t.polys.getCellSizes().forEach((m, b) => {
        switch (h[b] = p, m) {
          case 3:
            u[b] = ei.VTK_TRIANGLE;
            break;
          case 4:
            u[b] = ei.VTK_QUAD;
            break;
          default:
            u[b] = ei.VTK_POLYGON;
            break;
        }
        m < 3 && GD("Building VTK_TRIANGLE ", b, " with less than three points, but VTK_TRIANGLE needs at least three points. Check the input."), p += m + 1;
      }), h += h.subarray(a), u += u.subarray(a);
    }
    if (o) {
      let p = 0;
      u.fill(ei.VTK_TRIANGLE_STRIP, 0, o), t.strips.getCellSizes().forEach((m, b) => {
        h[b] = p, p += m + 1;
      });
    }
    t.cells = aL.newInstance(), t.cells.setCellTypes(l, c, d);
  }, i.buildLinks = function() {
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    t.cells === void 0 && i.buildCells(), t.links = xtt.newInstance(), s > 0 ? t.links.allocate(s) : t.links.allocate(i.getPoints().getNumberOfPoints()), t.links.buildLinks(i);
  }, i.getCellType = (s) => t.cells.getCellType(s), i.getCellPoints = (s) => {
    const r = i.getCellType(s);
    let a = null;
    switch (r) {
      case ei.VTK_VERTEX:
      case ei.VTK_POLY_VERTEX:
        a = t.verts;
        break;
      case ei.VTK_LINE:
      case ei.VTK_POLY_LINE:
        a = t.lines;
        break;
      case ei.VTK_TRIANGLE:
      case ei.VTK_QUAD:
      case ei.VTK_POLYGON:
        a = t.polys;
        break;
      case ei.VTK_TRIANGLE_STRIP:
        a = t.strips;
        break;
      default:
        return a = null, {
          type: 0,
          cellPointIds: null
        };
    }
    const o = t.cells.getCellLocation(s), l = a.getCell(o);
    return {
      cellType: r,
      cellPointIds: l
    };
  }, i.getPointCells = (s) => t.links.getCells(s), i.getCellEdgeNeighbors = (s, r, a) => {
    const o = t.links.getLink(r), l = t.links.getLink(a);
    return o.cells.filter((c) => c !== s && l.cells.indexOf(c) !== -1);
  }, i.getCell = function(s) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    const a = i.getCellPoints(s), o = r || Ktt[a.cellType].newInstance();
    return o.initialize(i.getPoints(), a.cellPointIds), o;
  };
}
const _tt = {
  // verts: null,
  // lines: null,
  // polys: null,
  // strips: null,
  // cells: null,
  // links: null,
};
function o9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, _tt, e), jtt.extend(i, t, e), tt.get(i, t, ["cells", "links"]), tt.setGet(i, t, ["verts", "lines", "polys", "strips"]), Htt(i, t);
}
const Qtt = tt.newInstance(o9, "vtkPolyData");
var Ie = {
  newInstance: Qtt,
  extend: o9
};
function l9() {
  const i = new ArrayBuffer(4), t = new Uint8Array(i), e = new Uint32Array(i);
  return t[0] = 161, t[1] = 178, t[2] = 195, t[3] = 212, e[0] === 3569595041 ? "LittleEndian" : e[0] === 2712847316 ? "BigEndian" : null;
}
const $tt = l9();
function qtt(i, t) {
  if (t < 2)
    return;
  const e = new Int8Array(i), n = e.length, s = [];
  for (let r = 0; r < n; r += t) {
    for (let a = 0; a < t; a++)
      s.push(e[r + a]);
    for (let a = 0; a < t; a++)
      e[r + a] = s.pop();
  }
}
var Wx = {
  ENDIANNESS: $tt,
  getEndianness: l9,
  swapBytes: qtt
};
const {
  vtkErrorMacro: c9,
  vtkDebugMacro: tet
} = tt, SI = () => (c9("LiteHttpDataAccessHelper does not support compression. Need to register HttpDataAccessHelper instead."), Promise.reject(new Error("LiteHttpDataAccessHelper does not support compression. Need to register HttpDataAccessHelper instead.")));
let bg = 0;
function OG(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const n = new XMLHttpRequest();
  return n.open(i, t, !0), e.headers && Object.entries(e.headers).forEach((s) => {
    let [r, a] = s;
    return n.setRequestHeader(r, a);
  }), e.progressCallback && n.addEventListener("progress", e.progressCallback), n;
}
function eet(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new Promise((e, n) => {
    const s = OG("GET", i, t);
    s.onreadystatechange = (r) => {
      s.readyState === 4 && (s.status === 200 || s.status === 0 ? e(s.response) : n({
        xhr: s,
        e: r
      }));
    }, s.responseType = "arraybuffer", s.send();
  });
}
function net(i, t, e) {
  let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  return n && n.compression ? SI() : e.ref && !e.ref.pending ? new Promise((s, r) => {
    const a = [t, e.ref.basepath, e.ref.id].join("/"), o = OG("GET", a, n);
    o.onreadystatechange = (l) => {
      o.readyState === 1 && (e.ref.pending = !0, ++bg === 1 && (i != null && i.invokeBusy) && i.invokeBusy(!0)), o.readyState === 4 && (e.ref.pending = !1, o.status === 200 || o.status === 0 ? (e.buffer = o.response, e.ref.encode === "JSON" ? e.values = JSON.parse(e.buffer) : (Wx.ENDIANNESS !== e.ref.encode && Wx.ENDIANNESS && (tet(`Swap bytes of ${e.name}`), Wx.swapBytes(e.buffer, GF[e.dataType])), e.values = tt.newTypedArray(e.dataType, e.buffer)), e.values.length !== e.size && c9(`Error in FetchArray: ${e.name}, does not have the proper array size. Got ${e.values.length}, instead of ${e.size}`), delete e.ref, --bg === 0 && (i != null && i.invokeBusy) && i.invokeBusy(!1), i != null && i.modified && i.modified(), s(e)) : r({
        xhr: o,
        e: l
      }));
    }, o.responseType = e.dataType !== "string" ? "arraybuffer" : "text", o.send();
  }) : Promise.resolve(e);
}
function iet(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return e && e.compression ? SI() : new Promise((n, s) => {
    const r = OG("GET", t, e);
    r.onreadystatechange = (a) => {
      r.readyState === 1 && ++bg === 1 && i != null && i.invokeBusy && i.invokeBusy(!0), r.readyState === 4 && (--bg === 0 && (i != null && i.invokeBusy) && i.invokeBusy(!1), r.status === 200 || r.status === 0 ? n(JSON.parse(r.responseText)) : s({
        xhr: r,
        e: a
      }));
    }, r.responseType = "text", r.send();
  });
}
function set(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return e && e.compression ? SI() : new Promise((n, s) => {
    const r = OG("GET", t, e);
    r.onreadystatechange = (a) => {
      r.readyState === 1 && ++bg === 1 && i != null && i.invokeBusy && i.invokeBusy(!0), r.readyState === 4 && (--bg === 0 && (i != null && i.invokeBusy) && i.invokeBusy(!1), r.status === 200 || r.status === 0 ? n(r.responseText) : s({
        xhr: r,
        e: a
      }));
    }, r.responseType = "text", r.send();
  });
}
function ret(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return new Promise((n, s) => {
    const r = new Image();
    e.crossOrigin && (r.crossOrigin = e.crossOrigin), r.onload = () => n(r), r.onerror = s, r.src = t;
  });
}
const aet = {
  fetchArray: net,
  fetchJSON: iet,
  fetchText: set,
  fetchBinary: eet,
  // Only for HTTP
  fetchImage: ret
};
JF("http") || AF("http", (i) => aet);
const {
  vtkErrorMacro: Gx
} = tt;
function oet(i) {
  const e = i.split(" ").filter((s) => s.indexOf("=") > -1), n = {};
  for (let s = 0; s < e.length; ++s) {
    const a = e[s].split("=");
    a.length === 2 && (n[a[0]] = a[1]);
  }
  return n;
}
function wD(i, t) {
  for (let e = 0; e < i.length; e++)
    t.push(i[e]);
}
function cet(i, t, e, n, s) {
  const r = i[t];
  if (r === void 0)
    return -1;
  if (r.indexOf("endfacet") !== -1 || r.indexOf("facet") === -1)
    return t + 1;
  let a = 0, o = 2;
  const l = e.length / 3, c = r.split(/[ \t]+/).filter((u) => u).slice(-3).map(Number);
  for (wD(c, s); i[t + o].indexOf("vertex") !== -1; ) {
    const d = i[t + o].split(/[ \t]+/).filter((h) => h).slice(-3).map(Number);
    wD(d, e), a++, o++;
  }
  n.push(a);
  for (let u = 0; u < a; u++)
    n.push(l + u);
  for (; i[t + o] && i[t + o].indexOf("endfacet") !== -1; )
    o++;
  return t + o + 2;
}
function uet(i, t) {
  t.classHierarchy.push("vtkSTLReader"), t.dataAccessHelper || (t.dataAccessHelper = DG.get("http"));
  function e(n) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = s.compression !== void 0 ? s.compression : t.compression, a = s.progressCallback !== void 0 ? s.progressCallback : t.progressCallback;
    return s.binary ? t.dataAccessHelper.fetchBinary(n, {
      compression: r,
      progressCallback: a
    }) : t.dataAccessHelper.fetchText(i, n, {
      compression: r,
      progressCallback: a
    });
  }
  i.setUrl = function(n) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      binary: !0
    };
    t.url = n;
    const r = n.split("/");
    return r.pop(), t.baseURL = r.join("/"), i.loadData(s);
  }, i.loadData = function() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const s = e(t.url, n);
    return s.then(i.parse), s;
  }, i.parse = (n) => {
    typeof n == "string" ? i.parseAsText(n) : i.parseAsArrayBuffer(n);
  }, i.parseAsArrayBuffer = (n) => {
    if (!n)
      return;
    if (n !== t.parseData)
      i.modified();
    else
      return;
    t.parseData = n;
    let s = !1;
    if (s = 84 + new DataView(n, 0, 84).getUint32(80, !0) * 50 === n.byteLength, !s) {
      i.parseAsText(p2.arrayBufferToString(n));
      return;
    }
    const o = n.slice(0, 80), l = p2.arrayBufferToString(o), c = oet(l), u = new DataView(n, 84), d = (n.byteLength - 84) / 50, h = new Float32Array(d * 9), p = new Float32Array(d * 3), m = new Uint32Array(d * 4), b = new Uint16Array(d);
    let y = 0;
    for (let f = 0; f < d; f++) {
      const T = f * 50;
      p[f * 3 + 0] = u.getFloat32(T + 0, !0), p[f * 3 + 1] = u.getFloat32(T + 4, !0), p[f * 3 + 2] = u.getFloat32(T + 8, !0), h[f * 9 + 0] = u.getFloat32(T + 12, !0), h[f * 9 + 1] = u.getFloat32(T + 16, !0), h[f * 9 + 2] = u.getFloat32(T + 20, !0), h[f * 9 + 3] = u.getFloat32(T + 24, !0), h[f * 9 + 4] = u.getFloat32(T + 28, !0), h[f * 9 + 5] = u.getFloat32(T + 32, !0), h[f * 9 + 6] = u.getFloat32(T + 36, !0), h[f * 9 + 7] = u.getFloat32(T + 40, !0), h[f * 9 + 8] = u.getFloat32(T + 44, !0), m[y++] = 3, m[y++] = f * 3 + 0, m[y++] = f * 3 + 1, m[y++] = f * 3 + 2, b[f] = u.getUint16(T + 48, !0);
    }
    const Z = "SPACE";
    if (Z in c && c[Z] !== "LPS") {
      const f = c[Z], T = new Float32Array(16);
      switch (T[15] = 1, f[0]) {
        case "L":
          T[0] = 1;
          break;
        case "R":
          T[0] = -1;
          break;
        default:
          Gx(`Can not convert STL file from ${f} to LPS space: permutations not supported. Use itk.js STL reader instead.`);
          return;
      }
      switch (f[1]) {
        case "P":
          T[5] = 1;
          break;
        case "A":
          T[5] = -1;
          break;
        default:
          Gx(`Can not convert STL file from ${f} to LPS space: permutations not supported. Use itk.js STL reader instead.`);
          return;
      }
      switch (f[2]) {
        case "S":
          T[10] = 1;
          break;
        case "I":
          T[10] = -1;
          break;
        default:
          Gx(`Can not convert STL file from ${f} to LPS space: permutations not supported. Use itk.js STL reader instead.`);
          return;
      }
      il.buildFromDegree().setMatrix(T).apply(h).apply(p);
    }
    const g = Ie.newInstance();
    g.getPoints().setData(h, 3), g.getPolys().setData(m), g.getCellData().setScalars(We.newInstance({
      name: "Attribute",
      values: b
    })), g.getCellData().setNormals(We.newInstance({
      name: "Normals",
      values: p,
      numberOfComponents: 3
    })), t.output[0] = g;
  }, i.parseAsText = (n) => {
    if (!n)
      return;
    if (n !== t.parseData)
      i.modified();
    else
      return;
    t.parseData = n;
    const s = n.split(`
`);
    let r = 1;
    const a = [], o = [], l = [];
    for (; r !== -1; )
      r = cet(s, r, a, o, l);
    const c = Ie.newInstance();
    c.getPoints().setData(Float32Array.from(a), 3), c.getPolys().setData(Uint32Array.from(o)), c.getCellData().setNormals(We.newInstance({
      name: "Normals",
      values: Float32Array.from(l),
      numberOfComponents: 3
    })), t.output[0] = c;
  }, i.requestData = (n, s) => {
    i.parse(t.parseData);
  };
}
const det = {
  // baseURL: null,
  // dataAccessHelper: null,
  // url: null,
};
function u9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, det, e), tt.obj(i, t), tt.get(i, t, ["url", "baseURL"]), tt.setGet(i, t, ["dataAccessHelper"]), tt.algo(i, t, 0, 1), uet(i, t), t.compression || (t.compression = null), t.progressCallback || (t.progressCallback = null);
}
const het = tt.newInstance(u9, "vtkSTLReader");
var zG = {
  extend: u9,
  newInstance: het
};
const wx = {
  ASCII: "ascii",
  BINARY_LITTLE_ENDIAN: "binary_little_endian"
}, xD = {
  diffuse_red: "red",
  diffuse_green: "green",
  diffuse_blue: "blue"
}, d9 = {
  patternHeader: /ply([\s\S]*)end_header\r?\n/,
  patternBody: /end_header\s([\s\S]*)$/
};
function SD(i) {
  let t = "", e = 0;
  const n = d9.patternHeader.exec(i);
  n !== null && (t = n[1], e = n[0].length);
  const s = {
    comments: [],
    elements: [],
    headerLength: e
  }, r = t.split(`
`);
  let a, o, l;
  for (let c = 0; c < r.length; c++) {
    let u = r[c];
    if (u = u.trim(), u !== "") {
      let d;
      switch (l = u.split(/\s+/), o = l.shift(), u = l.join(" "), o) {
        case "format":
          s.format = l[0], s.version = l[1];
          break;
        case "comment":
          s.comments.push(u);
          break;
        case "element":
          a !== void 0 && s.elements.push(a), a = {}, a.name = l[0], a.count = parseInt(l[1], 10), a.properties = [];
          break;
        case "property":
          d = {
            type: l[0]
          }, d.type === "list" ? (d.name = l[3], d.countType = l[1], d.itemType = l[2]) : d.name = l[1], d.name in xD && (d.name = xD[d.name]), a.properties.push(d);
          break;
        case "obj_info":
          s.objInfo = u;
          break;
        default:
          console.warn("unhandled", o, l);
          break;
      }
    }
  }
  return a !== void 0 && s.elements.push(a), s;
}
function LD(i, t) {
  const e = t.find((b) => b.name === "vertex"), n = t.find((b) => b.name === "face");
  let s = 0, r = 0;
  e && (s = e.count), n && (r = n.count);
  const a = new Float32Array(s * 3), o = new Uint8Array(s * 3), l = new Float32Array(s * 2), c = new Float32Array(s * 3), u = i.colors.length > 0, d = i.uvs.length > 0, h = i.normals.length > 0, p = i.faceVertexUvs.length > 0;
  for (let b = 0; b < s; b++) {
    let y = b * 3 + 0, Z = b * 3 + 1;
    const g = b * 3 + 2;
    a[y] = i.vertices[y], a[Z] = i.vertices[Z], a[g] = i.vertices[g], u && (o[y] = i.colors[y], o[Z] = i.colors[Z], o[g] = i.colors[g]), d && (y = b * 2 + 0, Z = b * 2 + 1, l[y] = i.uvs[y], l[Z] = i.uvs[Z]), h && (c[y] = i.normals[y], c[Z] = i.normals[Z], c[g] = i.normals[g]);
  }
  if (!d && p) {
    let b = 0, y = 0;
    for (let Z = 0; Z < r; ++Z) {
      const g = i.indices[b++], f = i.faceVertexUvs[y++];
      if (f && g * 2 === f.length)
        for (let T = 0; T < g; ++T) {
          const M = i.indices[b++];
          l[M * 2 + 0] = f[T * 2 + 0], l[M * 2 + 1] = f[T * 2 + 1];
        }
      else
        b += g;
    }
  }
  const m = Ie.newInstance();
  if (m.getPoints().setData(a, 3), u && m.getPointData().setScalars(We.newInstance({
    numberOfComponents: 3,
    values: o,
    name: "Scalars"
  })), d || p) {
    const b = We.newInstance({
      numberOfComponents: 2,
      values: l,
      name: "TextureCoordinates"
    }), y = m.getPointData();
    y.addArray(b), y.setActiveTCoords(b.getName());
  }
  return h && m.getPointData().setNormals(We.newInstance({
    numberOfComponents: 3,
    name: "Normals",
    values: c
  })), m.getPolys().setData(Uint32Array.from(i.indices)), m;
}
function xx(i, t) {
  let e;
  switch (t) {
    case "char":
    case "uchar":
    case "short":
    case "ushort":
    case "int":
    case "uint":
    case "int8":
    case "uint8":
    case "int16":
    case "uint16":
    case "int32":
    case "uint32":
      e = parseInt(i, 10);
      break;
    case "float":
    case "double":
    case "float32":
    case "float64":
      e = parseFloat(i);
      break;
    default:
      console.log("Unsupported type");
      break;
  }
  return e;
}
function pet(i, t) {
  const e = t.split(/\s+/), n = {};
  for (let s = 0; s < i.length; s++)
    if (i[s].type === "list") {
      const r = [], a = xx(e.shift(), i[s].countType);
      for (let o = 0; o < a; o++)
        r.push(xx(e.shift(), i[s].itemType));
      n[i[s].name] = r;
    } else
      n[i[s].name] = xx(e.shift(), i[s].type);
  return n;
}
function VD(i, t, e) {
  if (t === "vertex")
    i.vertices.push(e.x, e.y, e.z), "nx" in e && "ny" in e && "nz" in e && i.normals.push(e.nx, e.ny, e.nz), "s" in e && "t" in e ? i.uvs.push(e.s, e.t) : "u" in e && "v" in e ? i.uvs.push(e.u, e.v) : "texture_u" in e && "texture_v" in e && i.uvs.push(e.texture_u, e.texture_v), "red" in e && "green" in e && "blue" in e && i.colors.push(e.red, e.green, e.blue);
  else if (t === "face") {
    const n = e.vertex_indices || e.vertex_index, s = e.texcoord;
    n && n.length > 0 && (i.indices.push(n.length), n.forEach((r, a) => {
      i.indices.push(r);
    })), i.faceVertexUvs.push(s);
  }
}
function Sx(i, t, e, n) {
  let s;
  switch (e) {
    case "int8":
    case "char":
      s = [i.getInt8(t), 1];
      break;
    case "uint8":
    case "uchar":
      s = [i.getUint8(t), 1];
      break;
    case "int16":
    case "short":
      s = [i.getInt16(t, n), 2];
      break;
    case "uint16":
    case "ushort":
      s = [i.getUint16(t, n), 2];
      break;
    case "int32":
    case "int":
      s = [i.getInt32(t, n), 4];
      break;
    case "uint32":
    case "uint":
      s = [i.getUint32(t, n), 4];
      break;
    case "float32":
    case "float":
      s = [i.getFloat32(t, n), 4];
      break;
    case "float64":
    case "double":
      s = [i.getFloat64(t, n), 8];
      break;
    default:
      console.log("Unsupported type");
      break;
  }
  return s;
}
function met(i, t, e, n) {
  const s = {};
  let r, a = 0;
  for (let o = 0; o < e.length; o++)
    if (e[o].type === "list") {
      const l = [];
      r = Sx(i, t + a, e[o].countType, n);
      const c = r[0];
      a += r[1];
      for (let u = 0; u < c; u++)
        r = Sx(i, t + a, e[o].itemType, n), l.push(r[0]), a += r[1];
      s[e[o].name] = l;
    } else
      r = Sx(i, t + a, e[o].type, n), s[e[o].name] = r[0], a += r[1];
  return [s, a];
}
function bet(i, t) {
  t.classHierarchy.push("vtkPLYReader"), t.dataAccessHelper || (t.dataAccessHelper = DG.get("http"));
  function e(n) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const {
      compression: r,
      progressCallback: a
    } = t;
    return s.binary ? t.dataAccessHelper.fetchBinary(n, {
      compression: r,
      progressCallback: a
    }) : t.dataAccessHelper.fetchText(i, n, {
      compression: r,
      progressCallback: a
    });
  }
  i.setUrl = function(n) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      binary: !0
    };
    t.url = n;
    const r = n.split("/");
    return r.pop(), t.baseURL = r.join("/"), t.compression = s.compression, i.loadData({
      progressCallback: s.progressCallback,
      binary: !!s.binary
    });
  }, i.loadData = function() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const s = e(t.url, n);
    return s.then(i.parse), s;
  }, i.parse = (n) => {
    typeof n == "string" ? i.parseAsText(n) : i.parseAsArrayBuffer(n);
  }, i.parseAsArrayBuffer = (n) => {
    if (!n)
      return;
    if (n !== t.parseData)
      i.modified();
    else
      return;
    const s = p2.arrayBufferToString(n), r = SD(s);
    if (!(r.format !== wx.ASCII)) {
      i.parseAsText(n);
      return;
    }
    t.parseData = n;
    const o = {
      indices: [],
      vertices: [],
      normals: [],
      uvs: [],
      faceVertexUvs: [],
      colors: []
    }, l = r.format === wx.BINARY_LITTLE_ENDIAN, c = n instanceof ArrayBuffer ? n : n.buffer, u = new DataView(c, r.headerLength);
    let d, h = 0;
    for (let m = 0; m < r.elements.length; m++)
      for (let b = 0; b < r.elements[m].count; b++) {
        d = met(u, h, r.elements[m].properties, l), h += d[1];
        const y = d[0];
        VD(o, r.elements[m].name, y);
      }
    const p = LD(o, r.elements);
    t.output[0] = p;
  }, i.parseAsText = (n) => {
    if (!n)
      return;
    if (n !== t.parseData)
      i.modified();
    else
      return;
    t.parseData = n;
    const s = p2.arrayBufferToString(n), r = SD(s);
    if (r.format !== wx.ASCII) {
      i.parseAsArrayBuffer(n);
      return;
    }
    const o = {
      indices: [],
      vertices: [],
      normals: [],
      uvs: [],
      faceVertexUvs: [],
      colors: []
    }, l = d9.patternBody.exec(s);
    let c = "";
    l !== null && (c = l[1]);
    const u = c.split(`
`);
    let d = 0, h = 0;
    for (let m = 0; m < u.length; m++) {
      let b = u[m];
      if (b = b.trim(), b !== "") {
        h >= r.elements[d].count && (d++, h = 0);
        const y = pet(r.elements[d].properties, b);
        VD(o, r.elements[d].name, y), h++;
      }
    }
    const p = LD(o, r.elements);
    t.output[0] = p;
  }, i.requestData = (n, s) => {
    i.parse(t.parseData);
  };
}
const fet = {
  // baseURL: null,
  // dataAccessHelper: null,
  // url: null,
};
function h9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, fet, e), tt.obj(i, t), tt.get(i, t, ["url", "baseURL"]), tt.setGet(i, t, ["dataAccessHelper"]), tt.algo(i, t, 0, 1), bet(i, t), t.compression || (t.compression = null), t.progressCallback || (t.progressCallback = null);
}
const get = tt.newInstance(h9, "vtkPLYReader");
var p9 = {
  extend: h9,
  newInstance: get
};
const Tn = {};
function Lx(i, t, e, n, s) {
  for (let r = 0; r < s; r++)
    e[n + r] = i[t + r];
}
function yet(i) {
  Tn.splitOn = i, Tn.pieces = [], Tn.v = [], Tn.vt = [], Tn.vn = [], Tn.f = [[]], Tn.size = 0;
}
function Zet(i) {
  const t = i.split("/").map((r) => Number(r)), e = t[0] - 1, n = t[1] ? t[1] - 1 : e, s = t[2] ? t[2] - 1 : e;
  return [e, n, s];
}
function Tet(i) {
  if (i[0] === "#")
    return;
  const t = i.split(/[ \t]+/);
  if (t[0] === Tn.splitOn)
    t.shift(), Tn.pieces.push(t.join(" ").trim()), Tn.f.push([]), Tn.size++;
  else if (t[0] === "v")
    Tn.v.push(Number(t[1])), Tn.v.push(Number(t[2])), Tn.v.push(Number(t[3]));
  else if (t[0] === "vt")
    Tn.vt.push(Number(t[1])), Tn.vt.push(Number(t[2]));
  else if (t[0] === "vn")
    Tn.vn.push(Number(t[1])), Tn.vn.push(Number(t[2])), Tn.vn.push(Number(t[3]));
  else if (t[0] === "f") {
    Tn.size === 0 && Tn.size++;
    const e = Tn.f[Tn.size - 1];
    t.shift();
    const n = t.filter((r) => r.length > 0 && r !== "\r"), s = n.length;
    e.push(s);
    for (let r = 0; r < s; r++)
      e.push(Zet(n[r]));
  }
}
function Met(i) {
  const t = !!Tn.vt.length, e = !!Tn.vn.length;
  if (i.splitMode) {
    i.numberOfOutputs = Tn.size;
    for (let n = 0; n < Tn.size; n++) {
      const s = Tn.f[n], r = s.length, a = Tn.v.length / 3, o = {};
      let l;
      if (i.trackDuplicates) {
        const y = [];
        let Z = 0;
        for (let f = 0; f < r; ) {
          const T = s[f++];
          for (let M = 0; M < T; M++) {
            const [N, W, x] = s[f++], V = `${N}/${W}/${x}`;
            o[V] === void 0 && (y[N] === void 0 ? y[N] = [V] : (y[N].push(V), ++Z), o[V] = N);
          }
        }
        l = new Uint16Array(a + Z);
        let g = 0;
        for (let f = 0; f < y.length; ++f) {
          const T = y[f] ? y[f].length : 0;
          l[f] = T > 1 ? a + g : f;
          for (let M = 1; M < T; ++M) {
            const N = a + g++;
            l[N] = f, o[y[f][M]] = N;
          }
        }
      }
      const c = {}, u = Ie.newInstance({
        name: Tn.pieces[n]
      }), d = [], h = [], p = [], m = [];
      let b = 0;
      for (; b < r; ) {
        const y = s[b];
        m.push(y);
        for (let Z = 0; Z < y; Z++) {
          const [g, f, T] = s[b + Z + 1], M = `${g}/${f}/${T}`;
          if (c[M] === void 0) {
            const N = i.trackDuplicates ? o[M] : d.length / 3;
            c[M] = N, Lx(Tn.v, g * 3, d, N * 3, 3), t && Lx(Tn.vt, f * 2, h, N * 2, 2), e && Lx(Tn.vn, T * 3, p, N * 3, 3);
          }
          m.push(c[M]);
        }
        b += y + 1;
      }
      if (u.getPoints().setData(Float32Array.from(d), 3), i.trackDuplicates) {
        const y = We.newInstance({
          name: "Duplicates",
          values: l
        });
        u.getPointData().addArray(y);
      }
      if (u.getPolys().setData(Uint32Array.from(m)), t) {
        const y = We.newInstance({
          numberOfComponents: 2,
          values: Float32Array.from(h),
          name: "TextureCoordinates"
        });
        u.getPointData().setTCoords(y);
      }
      if (e) {
        const y = We.newInstance({
          numberOfComponents: 3,
          values: Float32Array.from(p),
          name: "Normals"
        });
        u.getPointData().setNormals(y);
      }
      i.output[n] = u;
    }
  } else {
    i.numberOfOutputs = 1;
    const n = Ie.newInstance();
    if (n.getPoints().setData(Float32Array.from(Tn.v), 3), t && Tn.v.length / 3 === Tn.vt.length / 2) {
      const l = We.newInstance({
        numberOfComponents: 2,
        values: Float32Array.from(Tn.vt),
        name: "TextureCoordinates"
      });
      n.getPointData().setTCoords(l);
    }
    if (e && Tn.v.length === Tn.vn.length) {
      const l = We.newInstance({
        numberOfComponents: 3,
        values: Float32Array.from(Tn.vn),
        name: "Normals"
      });
      n.getPointData().setNormals(l);
    }
    const s = [], r = Tn.f[0], a = r.length;
    let o = 0;
    for (; o < a; ) {
      const l = r[o];
      s.push(l);
      for (let c = 0; c < l; c++) {
        const [u] = r[o + c + 1];
        s.push(u);
      }
      o += l + 1;
    }
    n.getPolys().setData(Uint32Array.from(s)), i.output[0] = n;
  }
}
function Net(i, t) {
  const e = [], n = i.getPointData().getArrayByName("Duplicates");
  if (n == null)
    return e;
  const s = n.getData(), r = Math.min(t, s[t]);
  e.push(r);
  let a = s[r];
  if (a !== r)
    for (; a < s.length && s[a] === r; )
      e.push(a++);
  return e;
}
const Wet = {
  getPointDuplicateIds: Net
};
function Get(i, t) {
  t.classHierarchy.push("vtkOBJReader"), t.dataAccessHelper || (t.dataAccessHelper = DG.get("http"));
  function e(n) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return t.dataAccessHelper.fetchText(i, n, s);
  }
  i.setUrl = function(n) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (n.indexOf(".obj") === -1 && !s.fullpath)
      t.baseURL = n, t.url = `${n}/index.obj`;
    else {
      t.url = n;
      const r = n.split("/");
      r.pop(), t.baseURL = r.join("/");
    }
    return i.loadData(s);
  }, i.loadData = function() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return e(t.url, n).then((s) => i.isDeleted() ? !1 : i.parseAsText(s));
  }, i.parseAsText = (n) => (n && (n !== t.parseData && i.modified(), t.parseData = n, t.numberOfOutputs = 0, yet(t.splitMode), n.split(`
`).forEach(Tet), Met(t)), !0), i.requestData = (n, s) => {
    i.parseAsText(t.parseData);
  }, i.isBusy = () => !!t.requestCount, i.getNumberOfOutputPorts = () => t.numberOfOutputs;
}
const wet = {
  numberOfOutputs: 1,
  requestCount: 0,
  splitMode: null,
  trackDuplicates: !1
  // baseURL: null,
  // dataAccessHelper: null,
  // url: null,
};
function m9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, wet, e), tt.obj(i, t), tt.get(i, t, ["url", "baseURL"]), tt.setGet(i, t, ["dataAccessHelper", "splitMode", "trackDuplicates"]), tt.algo(i, t, 0, 1), tt.event(i, t, "busy"), Get(i, t);
}
const xet = tt.newInstance(m9, "vtkOBJReader");
var Let = {
  newInstance: xet,
  extend: m9,
  ...Wet
};
function hDt(i) {
  const t = xs.newInstance();
  t.setDimensions([i.pDimX, i.pDimY, i.pDimZ]), t.setOrigin([i.pOriginX, i.pOriginY, i.pOriginZ]), t.setSpacing([i.pSpacingX, i.pSpacingY, i.pSpacingZ]);
  const e = MI(i.pDicomImage), n = new Int16Array(e), s = We.newInstance({
    size: n.length,
    values: n
  });
  return t.getPointData().setScalars(s), t;
}
function pDt(i, t) {
  const e = xs.newInstance();
  e.setDimensions(i.dim), e.setOrigin(i.offset), e.setSpacing(i.spacing);
  const n = new Int16Array(t), s = We.newInstance({
    size: n.length,
    values: n
  });
  return e.getPointData().setScalars(s), e;
}
function LI(i) {
  const t = MI(i);
  return Vet(t);
}
function Vet(i) {
  const t = zG.newInstance(), e = new ArrayBuffer(i.byteLength), n = new Int8Array(e);
  for (const [s, r] of new Int8Array(i).entries())
    n[s] = r;
  return t.parseAsArrayBuffer(e), t.update(), t;
}
function VI(i) {
  const t = MI(i);
  return Xet(t);
}
function Xet(i) {
  const t = p9.newInstance(), e = new ArrayBuffer(i.byteLength), n = new Int8Array(e);
  for (const [s, r] of new Int8Array(i).entries())
    n[s] = r;
  return t.parseAsArrayBuffer(e), t.update(), t;
}
function Lo(i, t) {
  if (t === "ply")
    return VI(i).getOutputData();
  if (t === "stl") {
    const e = LI(i);
    return e.getOutputData().getCellData().removeAllArrays(), e.getOutputData().getPointData().removeAllArrays(), e.getOutputData();
  } else
    throw new Error("createPolydataFromSTL: unknown mode");
}
async function EG(i) {
  const e = await ((s) => new Promise((r, a) => {
    const o = new FileReader();
    o.onload = (l) => {
      var c;
      return r((c = l.target) == null ? void 0 : c.result);
    }, o.onerror = (l) => a(l), o.readAsText(s);
  }))(i), n = Let.newInstance();
  return n.parseAsText(e), n;
}
const {
  vtkErrorMacro: Iet
} = tt, Cet = ["Build", "Render"];
function Yet(i, t) {
  t.classHierarchy.push("vtkViewNode"), i.build = (n) => {
  }, i.render = (n) => {
  }, i.traverse = (n) => {
    const s = n.getTraverseOperation(), r = i[s];
    if (r) {
      r(n);
      return;
    }
    i.apply(n, !0);
    for (let a = 0; a < t.children.length; a++)
      t.children[a].traverse(n);
    i.apply(n, !1);
  }, i.apply = (n, s) => {
    const r = i[n.getOperation()];
    r && r(s, n);
  }, i.getViewNodeFor = (n) => {
    if (t.renderable === n)
      return i;
    for (let s = 0; s < t.children.length; ++s) {
      const a = t.children[s].getViewNodeFor(n);
      if (a)
        return a;
    }
  }, i.getFirstAncestorOfType = (n) => t._parent ? t._parent.isA(n) ? t._parent : t._parent.getFirstAncestorOfType(n) : null, i.addMissingNode = (n) => {
    if (!n)
      return;
    const s = t._renderableChildMap.get(n);
    if (s !== void 0)
      s.setVisited(!0);
    else {
      const r = i.createViewNode(n);
      r && (r.setParent(i), r.setVisited(!0), t._renderableChildMap.set(n, r), t.children.push(r));
    }
  }, i.addMissingNodes = (n) => {
    if (!(!n || !n.length))
      for (let s = 0; s < n.length; ++s) {
        const r = n[s], a = t._renderableChildMap.get(r);
        if (a !== void 0)
          a.setVisited(!0);
        else {
          const o = i.createViewNode(r);
          o && (o.setParent(i), o.setVisited(!0), t._renderableChildMap.set(r, o), t.children.push(o));
        }
      }
  }, i.addMissingChildren = (n) => {
    if (!(!n || !n.length))
      for (let s = 0; s < n.length; ++s) {
        const r = n[s];
        t.children.indexOf(r) === -1 && (r.setParent(i), t.children.push(r)), r.setVisited(!0);
      }
  }, i.prepareNodes = () => {
    for (let n = 0; n < t.children.length; ++n)
      t.children[n].setVisited(!1);
  }, i.setVisited = (n) => {
    t.visited = n;
  }, i.removeUnusedNodes = () => {
    let n = 0;
    for (let s = 0; s < t.children.length; ++s) {
      const r = t.children[s];
      if (r.getVisited())
        t.children[n++] = r, r.setVisited(!1);
      else {
        const o = r.getRenderable();
        o && t._renderableChildMap.delete(o), r.delete();
      }
    }
    t.children.length = n;
  }, i.createViewNode = (n) => {
    if (!t.myFactory)
      return Iet("Cannot create view nodes without my own factory"), null;
    const s = t.myFactory.createNode(n);
    return s && s.setRenderable(n), s;
  };
  const e = i.delete;
  i.delete = () => {
    for (let n = 0; n < t.children.length; n++)
      t.children[n].delete();
    e();
  };
}
const vet = {
  // _parent: null,
  renderable: null,
  myFactory: null,
  children: [],
  visited: !1
};
function b9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, vet, e), tt.obj(i, t), tt.event(i, t, "event"), t._renderableChildMap = /* @__PURE__ */ new Map(), tt.get(i, t, ["visited"]), tt.setGet(i, t, ["_parent", "renderable", "myFactory"]), tt.getArray(i, t, ["children"]), tt.moveToProtected(i, t, ["parent"]), Yet(i, t);
}
const Ret = tt.newInstance(b9, "vtkViewNode");
var ui = {
  newInstance: Ret,
  extend: b9,
  PASS_TYPES: Cet
};
function Det(i, t) {
  t.overrides || (t.overrides = {}), t.classHierarchy.push("vtkViewNodeFactory"), i.createNode = (e) => {
    if (e.isDeleted())
      return null;
    let n = 0, s = e.getClassName(n++), r = !1;
    const a = Object.keys(t.overrides);
    for (; s && !r; )
      a.indexOf(s) !== -1 ? r = !0 : s = e.getClassName(n++);
    if (!r)
      return null;
    const o = t.overrides[s]();
    return o.setMyFactory(i), o;
  }, i.registerOverride = (e, n) => {
    t.overrides[e] = n;
  };
}
const Oet = {
  // overrides: {},
};
function f9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Oet, e), tt.obj(i, t), Det(i, t);
}
const zet = tt.newInstance(f9, "vtkViewNodeFactory");
var g9 = {
  newInstance: zet,
  extend: f9
};
const y9 = /* @__PURE__ */ Object.create(null);
function Js(i, t) {
  y9[i] = t;
}
function Eet(i, t) {
  t.classHierarchy.push("vtkOpenGLViewNodeFactory");
}
const ket = {};
function Z9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, ket, e), t.overrides = y9, g9.extend(i, t, e), Eet(i, t);
}
const Fet = tt.newInstance(Z9, "vtkOpenGLViewNodeFactory");
var jet = {
  newInstance: Fet,
  extend: Z9
};
function Uet(i, t) {
  t.classHierarchy.push("vtkOpenGLCamera"), i.buildPass = (e) => {
    e && (t._openGLRenderer = i.getFirstAncestorOfType("vtkOpenGLRenderer"), t._openGLRenderWindow = t._openGLRenderer.getParent(), t.context = t._openGLRenderWindow.getContext());
  }, i.opaquePass = (e) => {
    if (e) {
      const n = t._openGLRenderer.getTiledSizeAndOrigin();
      t.context.viewport(n.lowerLeftU, n.lowerLeftV, n.usize, n.vsize), t.context.scissor(n.lowerLeftU, n.lowerLeftV, n.usize, n.vsize);
    }
  }, i.translucentPass = i.opaquePass, i.zBufferPass = i.opaquePass, i.opaqueZBufferPass = i.opaquePass, i.volumePass = i.opaquePass, i.getKeyMatrices = (e) => {
    if (e !== t.lastRenderer || t._openGLRenderWindow.getMTime() > t.keyMatrixTime.getMTime() || i.getMTime() > t.keyMatrixTime.getMTime() || e.getMTime() > t.keyMatrixTime.getMTime() || t.renderable.getMTime() > t.keyMatrixTime.getMTime()) {
      ut.copy(t.keyMatrices.wcvc, t.renderable.getViewMatrix()), gi.fromMat4(t.keyMatrices.normalMatrix, t.keyMatrices.wcvc), gi.invert(t.keyMatrices.normalMatrix, t.keyMatrices.normalMatrix), ut.transpose(t.keyMatrices.wcvc, t.keyMatrices.wcvc);
      const n = t._openGLRenderer.getAspectRatio();
      ut.copy(t.keyMatrices.vcpc, t.renderable.getProjectionMatrix(n, -1, 1)), ut.transpose(t.keyMatrices.vcpc, t.keyMatrices.vcpc), ut.multiply(t.keyMatrices.wcpc, t.keyMatrices.vcpc, t.keyMatrices.wcvc), t.keyMatrixTime.modified(), t.lastRenderer = e;
    }
    return t.keyMatrices;
  };
}
const Pet = {
  context: null,
  lastRenderer: null,
  keyMatrixTime: null,
  keyMatrices: null
};
function Jet(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Pet, e), ui.extend(i, t, e), t.keyMatrixTime = {}, xi(t.keyMatrixTime), t.keyMatrices = {
    normalMatrix: new Float64Array(9),
    vcpc: new Float64Array(16),
    wcvc: new Float64Array(16),
    wcpc: new Float64Array(16)
  }, gs(i, t, ["context", "keyMatrixTime"]), Uet(i, t);
}
const Aet = In(Jet);
Js("vtkCamera", Aet);
const {
  vtkDebugMacro: Bet
} = kr;
function Ket(i, t) {
  t.classHierarchy.push("vtkOpenGLRenderer"), i.buildPass = (e) => {
    if (e) {
      if (!t.renderable)
        return;
      i.updateLights(), i.prepareNodes(), i.addMissingNode(t.renderable.getActiveCamera()), i.addMissingNodes(t.renderable.getViewPropsWithNestedProps()), i.removeUnusedNodes();
    }
  }, i.updateLights = () => {
    let e = 0;
    const n = t.renderable.getLightsByReference();
    for (let s = 0; s < n.length; ++s)
      n[s].getSwitch() > 0 && e++;
    return e || (Bet("No lights are on, creating one."), t.renderable.createLight()), e;
  }, i.zBufferPass = (e) => {
    if (e) {
      let n = 0;
      const s = t.context;
      t.renderable.getTransparent() || (t.context.clearColor(1, 0, 0, 1), n |= s.COLOR_BUFFER_BIT), t.renderable.getPreserveDepthBuffer() || (s.clearDepth(1), n |= s.DEPTH_BUFFER_BIT, t.context.depthMask(!0));
      const r = i.getTiledSizeAndOrigin();
      s.enable(s.SCISSOR_TEST), s.scissor(r.lowerLeftU, r.lowerLeftV, r.usize, r.vsize), s.viewport(r.lowerLeftU, r.lowerLeftV, r.usize, r.vsize), s.colorMask(!0, !0, !0, !0), n && s.clear(n), s.enable(s.DEPTH_TEST);
    }
  }, i.opaqueZBufferPass = (e) => i.zBufferPass(e), i.cameraPass = (e) => {
    e && i.clear();
  }, i.getAspectRatio = () => {
    const e = t._parent.getSizeByReference(), n = t.renderable.getViewportByReference();
    return e[0] * (n[2] - n[0]) / ((n[3] - n[1]) * e[1]);
  }, i.getTiledSizeAndOrigin = () => {
    const e = t.renderable.getViewportByReference(), n = [0, 0, 1, 1], s = e[0] - n[0], r = e[1] - n[1], a = t._parent.normalizedDisplayToDisplay(s, r), o = Math.round(a[0]), l = Math.round(a[1]), c = e[2] - n[0], u = e[3] - n[1], d = t._parent.normalizedDisplayToDisplay(c, u);
    let h = Math.round(d[0]) - o, p = Math.round(d[1]) - l;
    return h < 0 && (h = 0), p < 0 && (p = 0), {
      usize: h,
      vsize: p,
      lowerLeftU: o,
      lowerLeftV: l
    };
  }, i.clear = () => {
    let e = 0;
    const n = t.context;
    if (!t.renderable.getTransparent()) {
      const r = t.renderable.getBackgroundByReference();
      t.context.clearColor(r[0], r[1], r[2], r[3]), e |= n.COLOR_BUFFER_BIT;
    }
    t.renderable.getPreserveDepthBuffer() || (n.clearDepth(1), e |= n.DEPTH_BUFFER_BIT, t.context.depthMask(!0)), n.colorMask(!0, !0, !0, !0);
    const s = i.getTiledSizeAndOrigin();
    n.enable(n.SCISSOR_TEST), n.scissor(s.lowerLeftU, s.lowerLeftV, s.usize, s.vsize), n.viewport(s.lowerLeftU, s.lowerLeftV, s.usize, s.vsize), e && n.clear(e), n.enable(n.DEPTH_TEST);
  }, i.releaseGraphicsResources = () => {
    t.selector !== null && t.selector.releaseGraphicsResources(), t.renderable && t.renderable.getViewProps().forEach((e) => {
      e.modified();
    });
  }, i.setOpenGLRenderWindow = (e) => {
    t._openGLRenderWindow !== e && (i.releaseGraphicsResources(), t._openGLRenderWindow = e, t.context = null, e && (t.context = t._openGLRenderWindow.getContext()));
  };
}
const Het = {
  context: null,
  _openGLRenderWindow: null,
  selector: null
};
function _et(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Het, e), ui.extend(i, t, e), Sa(i, t, ["shaderCache"]), gs(i, t, ["selector"]), wT(i, t, ["openGLRenderWindow"]), Ket(i, t);
}
const Qet = In(_et, "vtkOpenGLRenderer");
Js("vtkRenderer", Qet);
function $et(i, t) {
  t.classHierarchy.push("vtkOpenGLActor"), i.buildPass = (e) => {
    if (e) {
      t._openGLRenderWindow = i.getFirstAncestorOfType("vtkOpenGLRenderWindow"), t._openGLRenderer = i.getFirstAncestorOfType("vtkOpenGLRenderer"), t.context = t._openGLRenderWindow.getContext(), i.prepareNodes(), i.addMissingNodes(t.renderable.getTextures()), i.addMissingNode(t.renderable.getMapper()), i.removeUnusedNodes(), t.ogltextures = null, t.activeTextures = null;
      for (let n = 0; n < t.children.length; n++) {
        const s = t.children[n];
        s.isA("vtkOpenGLTexture") ? (t.ogltextures || (t.ogltextures = []), t.ogltextures.push(s)) : t.oglmapper = s;
      }
    }
  }, i.traverseZBufferPass = (e) => {
    !t.renderable || !t.renderable.getNestedVisibility() || t._openGLRenderer.getSelector() && !t.renderable.getNestedPickable() || (i.apply(e, !0), t.oglmapper.traverse(e), i.apply(e, !1));
  }, i.traverseOpaqueZBufferPass = (e) => i.traverseOpaquePass(e), i.traverseOpaquePass = (e) => {
    !t.renderable || !t.renderable.getNestedVisibility() || !t.renderable.getIsOpaque() || t._openGLRenderer.getSelector() && !t.renderable.getNestedPickable() || (i.apply(e, !0), t.oglmapper.traverse(e), i.apply(e, !1));
  }, i.traverseTranslucentPass = (e) => {
    !t.renderable || !t.renderable.getNestedVisibility() || t.renderable.getIsOpaque() || t._openGLRenderer.getSelector() && !t.renderable.getNestedPickable() || (i.apply(e, !0), t.oglmapper.traverse(e), i.apply(e, !1));
  }, i.activateTextures = () => {
    if (t.ogltextures) {
      t.activeTextures = [];
      for (let e = 0; e < t.ogltextures.length; e++) {
        const n = t.ogltextures[e];
        n.render(), n.getHandle() && t.activeTextures.push(n);
      }
    }
  }, i.queryPass = (e, n) => {
    if (e) {
      if (!t.renderable || !t.renderable.getVisibility())
        return;
      t.renderable.getIsOpaque() ? n.incrementOpaqueActorCount() : n.incrementTranslucentActorCount();
    }
  }, i.zBufferPass = (e, n) => i.opaquePass(e, n), i.opaqueZBufferPass = (e, n) => i.opaquePass(e, n), i.opaquePass = (e, n) => {
    if (e)
      t.context.depthMask(!0), i.activateTextures();
    else if (t.activeTextures)
      for (let s = 0; s < t.activeTextures.length; s++)
        t.activeTextures[s].deactivate();
  }, i.translucentPass = (e, n) => {
    if (e)
      t.context.depthMask(!1), i.activateTextures();
    else if (t.activeTextures)
      for (let s = 0; s < t.activeTextures.length; s++)
        t.activeTextures[s].deactivate();
  }, i.getKeyMatrices = () => (t.renderable.getMTime() > t.keyMatrixTime.getMTime() && (t.renderable.computeMatrix(), ut.copy(t.keyMatrices.mcwc, t.renderable.getMatrix()), ut.transpose(t.keyMatrices.mcwc, t.keyMatrices.mcwc), t.renderable.getIsIdentity() ? gi.identity(t.keyMatrices.normalMatrix) : (gi.fromMat4(t.keyMatrices.normalMatrix, t.keyMatrices.mcwc), gi.invert(t.keyMatrices.normalMatrix, t.keyMatrices.normalMatrix), gi.transpose(t.keyMatrices.normalMatrix, t.keyMatrices.normalMatrix)), t.keyMatrixTime.modified()), t.keyMatrices);
}
const qet = {
  context: null,
  keyMatrixTime: null,
  keyMatrices: null,
  activeTextures: null
};
function tnt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, qet, e), ui.extend(i, t, e), t.keyMatrixTime = {}, xi(t.keyMatrixTime, {
    mtime: 0
  }), t.keyMatrices = {
    normalMatrix: gi.identity(new Float64Array(9)),
    mcwc: ut.identity(new Float64Array(16))
  }, gs(i, t, ["context"]), Sa(i, t, ["activeTextures"]), $et(i, t);
}
const ent = In(tnt);
Js("vtkActor", ent);
function nnt(i, t) {
  t.classHierarchy.push("vtkOpenGLActor2D"), i.buildPass = (e) => {
    if (e) {
      if (!t.renderable)
        return;
      t._openGLRenderWindow = i.getFirstAncestorOfType("vtkOpenGLRenderWindow"), t._openGLRenderer = i.getFirstAncestorOfType("vtkOpenGLRenderer"), t.context = t._openGLRenderWindow.getContext(), i.prepareNodes(), i.addMissingNodes(t.renderable.getTextures()), i.addMissingNode(t.renderable.getMapper()), i.removeUnusedNodes(), t.ogltextures = null, t.activeTextures = null;
      for (let n = 0; n < t.children.length; n++) {
        const s = t.children[n];
        s.isA("vtkOpenGLTexture") ? (t.ogltextures || (t.ogltextures = []), t.ogltextures.push(s)) : t.oglmapper = s;
      }
    }
  }, i.queryPass = (e, n) => {
    if (e) {
      if (!t.renderable || !t.renderable.getVisibility())
        return;
      n.incrementOverlayActorCount();
    }
  }, i.traverseOpaquePass = (e) => {
    !t.oglmapper || !t.renderable || !t.renderable.getNestedVisibility() || !t.renderable.getIsOpaque() || t._openGLRenderer.getSelector() && !t.renderable.getNestedPickable() || (i.apply(e, !0), t.oglmapper.traverse(e), i.apply(e, !1));
  }, i.traverseTranslucentPass = (e) => {
    !t.oglmapper || !t.renderable || !t.renderable.getNestedVisibility() || t.renderable.getIsOpaque() || t._openGLRenderer.getSelector() && !t.renderable.getNestedPickable() || (i.apply(e, !0), t.oglmapper.traverse(e), i.apply(e, !1));
  }, i.traverseOverlayPass = (e) => {
    !t.oglmapper || !t.renderable || !t.renderable.getNestedVisibility() || t._openGLRenderer.getSelector() && !t.renderable.getNestedPickable || (i.apply(e, !0), t.oglmapper.traverse(e), i.apply(e, !1));
  }, i.activateTextures = () => {
    if (t.ogltextures) {
      t.activeTextures = [];
      for (let e = 0; e < t.ogltextures.length; e++) {
        const n = t.ogltextures[e];
        n.render(), n.getHandle() && t.activeTextures.push(n);
      }
    }
  }, i.opaquePass = (e, n) => {
    if (e)
      t.context.depthMask(!0), i.activateTextures();
    else if (t.activeTextures)
      for (let s = 0; s < t.activeTextures.length; s++)
        t.activeTextures[s].deactivate();
  }, i.translucentPass = (e, n) => {
    if (e)
      t.context.depthMask(!1), i.activateTextures();
    else if (t.activeTextures)
      for (let s = 0; s < t.activeTextures.length; s++)
        t.activeTextures[s].deactivate();
  }, i.overlayPass = (e, n) => {
    if (e)
      t.context.depthMask(!0), i.activateTextures();
    else if (t.activeTextures)
      for (let s = 0; s < t.activeTextures.length; s++)
        t.activeTextures[s].deactivate();
  };
}
const int = {
  context: null,
  activeTextures: null
};
function snt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, int, e), ui.extend(i, t, e), gs(i, t, ["context"]), Sa(i, t, ["activeTextures"]), nnt(i, t);
}
const rnt = In(snt);
Js("vtkActor2D", rnt);
function sN(i, t) {
  return i == null || t == null ? NaN : i < t ? -1 : i > t ? 1 : i >= t ? 0 : NaN;
}
function ant(i, t) {
  return i == null || t == null ? NaN : t < i ? -1 : t > i ? 1 : t >= i ? 0 : NaN;
}
function T9(i) {
  let t, e, n;
  i.length !== 2 ? (t = sN, e = (o, l) => sN(i(o), l), n = (o, l) => i(o) - l) : (t = i === sN || i === ant ? i : ont, e = i, n = i);
  function s(o, l, c = 0, u = o.length) {
    if (c < u) {
      if (t(l, l) !== 0) return u;
      do {
        const d = c + u >>> 1;
        e(o[d], l) < 0 ? c = d + 1 : u = d;
      } while (c < u);
    }
    return c;
  }
  function r(o, l, c = 0, u = o.length) {
    if (c < u) {
      if (t(l, l) !== 0) return u;
      do {
        const d = c + u >>> 1;
        e(o[d], l) <= 0 ? c = d + 1 : u = d;
      } while (c < u);
    }
    return c;
  }
  function a(o, l, c = 0, u = o.length) {
    const d = s(o, l, c, u - 1);
    return d > c && n(o[d - 1], l) > -n(o[d], l) ? d - 1 : d;
  }
  return { left: s, center: a, right: r };
}
function ont() {
  return 0;
}
function lnt(i) {
  return i === null ? NaN : +i;
}
const cnt = T9(sN), unt = cnt.right;
T9(lnt).center;
const dnt = Math.sqrt(50), hnt = Math.sqrt(10), pnt = Math.sqrt(2);
function hW(i, t, e) {
  const n = (t - i) / Math.max(0, e), s = Math.floor(Math.log10(n)), r = n / Math.pow(10, s), a = r >= dnt ? 10 : r >= hnt ? 5 : r >= pnt ? 2 : 1;
  let o, l, c;
  return s < 0 ? (c = Math.pow(10, -s) / a, o = Math.round(i * c), l = Math.round(t * c), o / c < i && ++o, l / c > t && --l, c = -c) : (c = Math.pow(10, s) * a, o = Math.round(i / c), l = Math.round(t / c), o * c < i && ++o, l * c > t && --l), l < o && 0.5 <= e && e < 2 ? hW(i, t, e * 2) : [o, l, c];
}
function mnt(i, t, e) {
  if (t = +t, i = +i, e = +e, !(e > 0)) return [];
  if (i === t) return [i];
  const n = t < i, [s, r, a] = n ? hW(t, i, e) : hW(i, t, e);
  if (!(r >= s)) return [];
  const o = r - s + 1, l = new Array(o);
  if (n)
    if (a < 0) for (let c = 0; c < o; ++c) l[c] = (r - c) / -a;
    else for (let c = 0; c < o; ++c) l[c] = (r - c) * a;
  else if (a < 0) for (let c = 0; c < o; ++c) l[c] = (s + c) / -a;
  else for (let c = 0; c < o; ++c) l[c] = (s + c) * a;
  return l;
}
function oL(i, t, e) {
  return t = +t, i = +i, e = +e, hW(i, t, e)[2];
}
function bnt(i, t, e) {
  t = +t, i = +i, e = +e;
  const n = t < i, s = n ? oL(t, i, e) : oL(i, t, e);
  return (n ? -1 : 1) * (s < 0 ? 1 / -s : s);
}
function fnt(i, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(i);
      break;
    default:
      this.range(t).domain(i);
      break;
  }
  return this;
}
function XI(i, t, e) {
  i.prototype = t.prototype = e, e.constructor = i;
}
function M9(i, t) {
  var e = Object.create(i.prototype);
  for (var n in t) e[n] = t[n];
  return e;
}
function XT() {
}
var m2 = 0.7, pW = 1 / m2, Ib = "\\s*([+-]?\\d+)\\s*", b2 = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Ec = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", gnt = /^#([0-9a-f]{3,8})$/, ynt = new RegExp(`^rgb\\(${Ib},${Ib},${Ib}\\)$`), Znt = new RegExp(`^rgb\\(${Ec},${Ec},${Ec}\\)$`), Tnt = new RegExp(`^rgba\\(${Ib},${Ib},${Ib},${b2}\\)$`), Mnt = new RegExp(`^rgba\\(${Ec},${Ec},${Ec},${b2}\\)$`), Nnt = new RegExp(`^hsl\\(${b2},${Ec},${Ec}\\)$`), Wnt = new RegExp(`^hsla\\(${b2},${Ec},${Ec},${b2}\\)$`), XD = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
XI(XT, f2, {
  copy(i) {
    return Object.assign(new this.constructor(), this, i);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: ID,
  // Deprecated! Use color.formatHex.
  formatHex: ID,
  formatHex8: Gnt,
  formatHsl: wnt,
  formatRgb: CD,
  toString: CD
});
function ID() {
  return this.rgb().formatHex();
}
function Gnt() {
  return this.rgb().formatHex8();
}
function wnt() {
  return N9(this).formatHsl();
}
function CD() {
  return this.rgb().formatRgb();
}
function f2(i) {
  var t, e;
  return i = (i + "").trim().toLowerCase(), (t = gnt.exec(i)) ? (e = t[1].length, t = parseInt(t[1], 16), e === 6 ? YD(t) : e === 3 ? new ja(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : e === 8 ? J1(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : e === 4 ? J1(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = ynt.exec(i)) ? new ja(t[1], t[2], t[3], 1) : (t = Znt.exec(i)) ? new ja(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = Tnt.exec(i)) ? J1(t[1], t[2], t[3], t[4]) : (t = Mnt.exec(i)) ? J1(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = Nnt.exec(i)) ? DD(t[1], t[2] / 100, t[3] / 100, 1) : (t = Wnt.exec(i)) ? DD(t[1], t[2] / 100, t[3] / 100, t[4]) : XD.hasOwnProperty(i) ? YD(XD[i]) : i === "transparent" ? new ja(NaN, NaN, NaN, 0) : null;
}
function YD(i) {
  return new ja(i >> 16 & 255, i >> 8 & 255, i & 255, 1);
}
function J1(i, t, e, n) {
  return n <= 0 && (i = t = e = NaN), new ja(i, t, e, n);
}
function xnt(i) {
  return i instanceof XT || (i = f2(i)), i ? (i = i.rgb(), new ja(i.r, i.g, i.b, i.opacity)) : new ja();
}
function lL(i, t, e, n) {
  return arguments.length === 1 ? xnt(i) : new ja(i, t, e, n ?? 1);
}
function ja(i, t, e, n) {
  this.r = +i, this.g = +t, this.b = +e, this.opacity = +n;
}
XI(ja, lL, M9(XT, {
  brighter(i) {
    return i = i == null ? pW : Math.pow(pW, i), new ja(this.r * i, this.g * i, this.b * i, this.opacity);
  },
  darker(i) {
    return i = i == null ? m2 : Math.pow(m2, i), new ja(this.r * i, this.g * i, this.b * i, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new ja(u0(this.r), u0(this.g), u0(this.b), mW(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: vD,
  // Deprecated! Use color.formatHex.
  formatHex: vD,
  formatHex8: Snt,
  formatRgb: RD,
  toString: RD
}));
function vD() {
  return `#${Fp(this.r)}${Fp(this.g)}${Fp(this.b)}`;
}
function Snt() {
  return `#${Fp(this.r)}${Fp(this.g)}${Fp(this.b)}${Fp((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function RD() {
  const i = mW(this.opacity);
  return `${i === 1 ? "rgb(" : "rgba("}${u0(this.r)}, ${u0(this.g)}, ${u0(this.b)}${i === 1 ? ")" : `, ${i})`}`;
}
function mW(i) {
  return isNaN(i) ? 1 : Math.max(0, Math.min(1, i));
}
function u0(i) {
  return Math.max(0, Math.min(255, Math.round(i) || 0));
}
function Fp(i) {
  return i = u0(i), (i < 16 ? "0" : "") + i.toString(16);
}
function DD(i, t, e, n) {
  return n <= 0 ? i = t = e = NaN : e <= 0 || e >= 1 ? i = t = NaN : t <= 0 && (i = NaN), new Cl(i, t, e, n);
}
function N9(i) {
  if (i instanceof Cl) return new Cl(i.h, i.s, i.l, i.opacity);
  if (i instanceof XT || (i = f2(i)), !i) return new Cl();
  if (i instanceof Cl) return i;
  i = i.rgb();
  var t = i.r / 255, e = i.g / 255, n = i.b / 255, s = Math.min(t, e, n), r = Math.max(t, e, n), a = NaN, o = r - s, l = (r + s) / 2;
  return o ? (t === r ? a = (e - n) / o + (e < n) * 6 : e === r ? a = (n - t) / o + 2 : a = (t - e) / o + 4, o /= l < 0.5 ? r + s : 2 - r - s, a *= 60) : o = l > 0 && l < 1 ? 0 : a, new Cl(a, o, l, i.opacity);
}
function Lnt(i, t, e, n) {
  return arguments.length === 1 ? N9(i) : new Cl(i, t, e, n ?? 1);
}
function Cl(i, t, e, n) {
  this.h = +i, this.s = +t, this.l = +e, this.opacity = +n;
}
XI(Cl, Lnt, M9(XT, {
  brighter(i) {
    return i = i == null ? pW : Math.pow(pW, i), new Cl(this.h, this.s, this.l * i, this.opacity);
  },
  darker(i) {
    return i = i == null ? m2 : Math.pow(m2, i), new Cl(this.h, this.s, this.l * i, this.opacity);
  },
  rgb() {
    var i = this.h % 360 + (this.h < 0) * 360, t = isNaN(i) || isNaN(this.s) ? 0 : this.s, e = this.l, n = e + (e < 0.5 ? e : 1 - e) * t, s = 2 * e - n;
    return new ja(
      Vx(i >= 240 ? i - 240 : i + 120, s, n),
      Vx(i, s, n),
      Vx(i < 120 ? i + 240 : i - 120, s, n),
      this.opacity
    );
  },
  clamp() {
    return new Cl(OD(this.h), A1(this.s), A1(this.l), mW(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const i = mW(this.opacity);
    return `${i === 1 ? "hsl(" : "hsla("}${OD(this.h)}, ${A1(this.s) * 100}%, ${A1(this.l) * 100}%${i === 1 ? ")" : `, ${i})`}`;
  }
}));
function OD(i) {
  return i = (i || 0) % 360, i < 0 ? i + 360 : i;
}
function A1(i) {
  return Math.max(0, Math.min(1, i || 0));
}
function Vx(i, t, e) {
  return (i < 60 ? t + (e - t) * i / 60 : i < 180 ? e : i < 240 ? t + (e - t) * (240 - i) / 60 : t) * 255;
}
const II = (i) => () => i;
function Vnt(i, t) {
  return function(e) {
    return i + e * t;
  };
}
function Xnt(i, t, e) {
  return i = Math.pow(i, e), t = Math.pow(t, e) - i, e = 1 / e, function(n) {
    return Math.pow(i + n * t, e);
  };
}
function Int(i) {
  return (i = +i) == 1 ? W9 : function(t, e) {
    return e - t ? Xnt(t, e, i) : II(isNaN(t) ? e : t);
  };
}
function W9(i, t) {
  var e = t - i;
  return e ? Vnt(i, e) : II(isNaN(i) ? t : i);
}
const zD = (function i(t) {
  var e = Int(t);
  function n(s, r) {
    var a = e((s = lL(s)).r, (r = lL(r)).r), o = e(s.g, r.g), l = e(s.b, r.b), c = W9(s.opacity, r.opacity);
    return function(u) {
      return s.r = a(u), s.g = o(u), s.b = l(u), s.opacity = c(u), s + "";
    };
  }
  return n.gamma = i, n;
})(1);
function Cnt(i, t) {
  t || (t = []);
  var e = i ? Math.min(t.length, i.length) : 0, n = t.slice(), s;
  return function(r) {
    for (s = 0; s < e; ++s) n[s] = i[s] * (1 - r) + t[s] * r;
    return n;
  };
}
function Ynt(i) {
  return ArrayBuffer.isView(i) && !(i instanceof DataView);
}
function vnt(i, t) {
  var e = t ? t.length : 0, n = i ? Math.min(e, i.length) : 0, s = new Array(n), r = new Array(e), a;
  for (a = 0; a < n; ++a) s[a] = CI(i[a], t[a]);
  for (; a < e; ++a) r[a] = t[a];
  return function(o) {
    for (a = 0; a < n; ++a) r[a] = s[a](o);
    return r;
  };
}
function Rnt(i, t) {
  var e = /* @__PURE__ */ new Date();
  return i = +i, t = +t, function(n) {
    return e.setTime(i * (1 - n) + t * n), e;
  };
}
function bW(i, t) {
  return i = +i, t = +t, function(e) {
    return i * (1 - e) + t * e;
  };
}
function Dnt(i, t) {
  var e = {}, n = {}, s;
  (i === null || typeof i != "object") && (i = {}), (t === null || typeof t != "object") && (t = {});
  for (s in t)
    s in i ? e[s] = CI(i[s], t[s]) : n[s] = t[s];
  return function(r) {
    for (s in e) n[s] = e[s](r);
    return n;
  };
}
var cL = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Xx = new RegExp(cL.source, "g");
function Ont(i) {
  return function() {
    return i;
  };
}
function znt(i) {
  return function(t) {
    return i(t) + "";
  };
}
function Ent(i, t) {
  var e = cL.lastIndex = Xx.lastIndex = 0, n, s, r, a = -1, o = [], l = [];
  for (i = i + "", t = t + ""; (n = cL.exec(i)) && (s = Xx.exec(t)); )
    (r = s.index) > e && (r = t.slice(e, r), o[a] ? o[a] += r : o[++a] = r), (n = n[0]) === (s = s[0]) ? o[a] ? o[a] += s : o[++a] = s : (o[++a] = null, l.push({ i: a, x: bW(n, s) })), e = Xx.lastIndex;
  return e < t.length && (r = t.slice(e), o[a] ? o[a] += r : o[++a] = r), o.length < 2 ? l[0] ? znt(l[0].x) : Ont(t) : (t = l.length, function(c) {
    for (var u = 0, d; u < t; ++u) o[(d = l[u]).i] = d.x(c);
    return o.join("");
  });
}
function CI(i, t) {
  var e = typeof t, n;
  return t == null || e === "boolean" ? II(t) : (e === "number" ? bW : e === "string" ? (n = f2(t)) ? (t = n, zD) : Ent : t instanceof f2 ? zD : t instanceof Date ? Rnt : Ynt(t) ? Cnt : Array.isArray(t) ? vnt : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? Dnt : bW)(i, t);
}
function knt(i, t) {
  return i = +i, t = +t, function(e) {
    return Math.round(i * (1 - e) + t * e);
  };
}
function Fnt(i) {
  return function() {
    return i;
  };
}
function jnt(i) {
  return +i;
}
var ED = [0, 1];
function Zb(i) {
  return i;
}
function uL(i, t) {
  return (t -= i = +i) ? function(e) {
    return (e - i) / t;
  } : Fnt(isNaN(t) ? NaN : 0.5);
}
function Unt(i, t) {
  var e;
  return i > t && (e = i, i = t, t = e), function(n) {
    return Math.max(i, Math.min(t, n));
  };
}
function Pnt(i, t, e) {
  var n = i[0], s = i[1], r = t[0], a = t[1];
  return s < n ? (n = uL(s, n), r = e(a, r)) : (n = uL(n, s), r = e(r, a)), function(o) {
    return r(n(o));
  };
}
function Jnt(i, t, e) {
  var n = Math.min(i.length, t.length) - 1, s = new Array(n), r = new Array(n), a = -1;
  for (i[n] < i[0] && (i = i.slice().reverse(), t = t.slice().reverse()); ++a < n; )
    s[a] = uL(i[a], i[a + 1]), r[a] = e(t[a], t[a + 1]);
  return function(o) {
    var l = unt(i, o, 1, n) - 1;
    return r[l](s[l](o));
  };
}
function Ant(i, t) {
  return t.domain(i.domain()).range(i.range()).interpolate(i.interpolate()).clamp(i.clamp()).unknown(i.unknown());
}
function Bnt() {
  var i = ED, t = ED, e = CI, n, s, r, a = Zb, o, l, c;
  function u() {
    var h = Math.min(i.length, t.length);
    return a !== Zb && (a = Unt(i[0], i[h - 1])), o = h > 2 ? Jnt : Pnt, l = c = null, d;
  }
  function d(h) {
    return h == null || isNaN(h = +h) ? r : (l || (l = o(i.map(n), t, e)))(n(a(h)));
  }
  return d.invert = function(h) {
    return a(s((c || (c = o(t, i.map(n), bW)))(h)));
  }, d.domain = function(h) {
    return arguments.length ? (i = Array.from(h, jnt), u()) : i.slice();
  }, d.range = function(h) {
    return arguments.length ? (t = Array.from(h), u()) : t.slice();
  }, d.rangeRound = function(h) {
    return t = Array.from(h), e = knt, u();
  }, d.clamp = function(h) {
    return arguments.length ? (a = h ? !0 : Zb, u()) : a !== Zb;
  }, d.interpolate = function(h) {
    return arguments.length ? (e = h, u()) : e;
  }, d.unknown = function(h) {
    return arguments.length ? (r = h, d) : r;
  }, function(h, p) {
    return n = h, s = p, u();
  };
}
function Knt() {
  return Bnt()(Zb, Zb);
}
function Hnt(i) {
  return Math.abs(i = Math.round(i)) >= 1e21 ? i.toLocaleString("en").replace(/,/g, "") : i.toString(10);
}
function fW(i, t) {
  if ((e = (i = t ? i.toExponential(t - 1) : i.toExponential()).indexOf("e")) < 0) return null;
  var e, n = i.slice(0, e);
  return [
    n.length > 1 ? n[0] + n.slice(2) : n,
    +i.slice(e + 1)
  ];
}
function fg(i) {
  return i = fW(Math.abs(i)), i ? i[1] : NaN;
}
function _nt(i, t) {
  return function(e, n) {
    for (var s = e.length, r = [], a = 0, o = i[0], l = 0; s > 0 && o > 0 && (l + o + 1 > n && (o = Math.max(1, n - l)), r.push(e.substring(s -= o, s + o)), !((l += o + 1) > n)); )
      o = i[a = (a + 1) % i.length];
    return r.reverse().join(t);
  };
}
function Qnt(i) {
  return function(t) {
    return t.replace(/[0-9]/g, function(e) {
      return i[+e];
    });
  };
}
var $nt = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function gW(i) {
  if (!(t = $nt.exec(i))) throw new Error("invalid format: " + i);
  var t;
  return new YI({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
gW.prototype = YI.prototype;
function YI(i) {
  this.fill = i.fill === void 0 ? " " : i.fill + "", this.align = i.align === void 0 ? ">" : i.align + "", this.sign = i.sign === void 0 ? "-" : i.sign + "", this.symbol = i.symbol === void 0 ? "" : i.symbol + "", this.zero = !!i.zero, this.width = i.width === void 0 ? void 0 : +i.width, this.comma = !!i.comma, this.precision = i.precision === void 0 ? void 0 : +i.precision, this.trim = !!i.trim, this.type = i.type === void 0 ? "" : i.type + "";
}
YI.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function qnt(i) {
  t: for (var t = i.length, e = 1, n = -1, s; e < t; ++e)
    switch (i[e]) {
      case ".":
        n = s = e;
        break;
      case "0":
        n === 0 && (n = e), s = e;
        break;
      default:
        if (!+i[e]) break t;
        n > 0 && (n = 0);
        break;
    }
  return n > 0 ? i.slice(0, n) + i.slice(s + 1) : i;
}
var G9;
function tit(i, t) {
  var e = fW(i, t);
  if (!e) return i + "";
  var n = e[0], s = e[1], r = s - (G9 = Math.max(-8, Math.min(8, Math.floor(s / 3))) * 3) + 1, a = n.length;
  return r === a ? n : r > a ? n + new Array(r - a + 1).join("0") : r > 0 ? n.slice(0, r) + "." + n.slice(r) : "0." + new Array(1 - r).join("0") + fW(i, Math.max(0, t + r - 1))[0];
}
function kD(i, t) {
  var e = fW(i, t);
  if (!e) return i + "";
  var n = e[0], s = e[1];
  return s < 0 ? "0." + new Array(-s).join("0") + n : n.length > s + 1 ? n.slice(0, s + 1) + "." + n.slice(s + 1) : n + new Array(s - n.length + 2).join("0");
}
const FD = {
  "%": (i, t) => (i * 100).toFixed(t),
  b: (i) => Math.round(i).toString(2),
  c: (i) => i + "",
  d: Hnt,
  e: (i, t) => i.toExponential(t),
  f: (i, t) => i.toFixed(t),
  g: (i, t) => i.toPrecision(t),
  o: (i) => Math.round(i).toString(8),
  p: (i, t) => kD(i * 100, t),
  r: kD,
  s: tit,
  X: (i) => Math.round(i).toString(16).toUpperCase(),
  x: (i) => Math.round(i).toString(16)
};
function jD(i) {
  return i;
}
var UD = Array.prototype.map, PD = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function eit(i) {
  var t = i.grouping === void 0 || i.thousands === void 0 ? jD : _nt(UD.call(i.grouping, Number), i.thousands + ""), e = i.currency === void 0 ? "" : i.currency[0] + "", n = i.currency === void 0 ? "" : i.currency[1] + "", s = i.decimal === void 0 ? "." : i.decimal + "", r = i.numerals === void 0 ? jD : Qnt(UD.call(i.numerals, String)), a = i.percent === void 0 ? "%" : i.percent + "", o = i.minus === void 0 ? "−" : i.minus + "", l = i.nan === void 0 ? "NaN" : i.nan + "";
  function c(d) {
    d = gW(d);
    var h = d.fill, p = d.align, m = d.sign, b = d.symbol, y = d.zero, Z = d.width, g = d.comma, f = d.precision, T = d.trim, M = d.type;
    M === "n" ? (g = !0, M = "g") : FD[M] || (f === void 0 && (f = 12), T = !0, M = "g"), (y || h === "0" && p === "=") && (y = !0, h = "0", p = "=");
    var N = b === "$" ? e : b === "#" && /[boxX]/.test(M) ? "0" + M.toLowerCase() : "", W = b === "$" ? n : /[%p]/.test(M) ? a : "", x = FD[M], V = /[defgprs%]/.test(M);
    f = f === void 0 ? 6 : /[gprs]/.test(M) ? Math.max(1, Math.min(21, f)) : Math.max(0, Math.min(20, f));
    function X(C) {
      var R = N, z = W, F, P, j;
      if (M === "c")
        z = x(C) + z, C = "";
      else {
        C = +C;
        var H = C < 0 || 1 / C < 0;
        if (C = isNaN(C) ? l : x(Math.abs(C), f), T && (C = qnt(C)), H && +C == 0 && m !== "+" && (H = !1), R = (H ? m === "(" ? m : o : m === "-" || m === "(" ? "" : m) + R, z = (M === "s" ? PD[8 + G9 / 3] : "") + z + (H && m === "(" ? ")" : ""), V) {
          for (F = -1, P = C.length; ++F < P; )
            if (j = C.charCodeAt(F), 48 > j || j > 57) {
              z = (j === 46 ? s + C.slice(F + 1) : C.slice(F)) + z, C = C.slice(0, F);
              break;
            }
        }
      }
      g && !y && (C = t(C, 1 / 0));
      var B = R.length + C.length + z.length, $ = B < Z ? new Array(Z - B + 1).join(h) : "";
      switch (g && y && (C = t($ + C, $.length ? Z - z.length : 1 / 0), $ = ""), p) {
        case "<":
          C = R + C + z + $;
          break;
        case "=":
          C = R + $ + C + z;
          break;
        case "^":
          C = $.slice(0, B = $.length >> 1) + R + C + z + $.slice(B);
          break;
        default:
          C = $ + R + C + z;
          break;
      }
      return r(C);
    }
    return X.toString = function() {
      return d + "";
    }, X;
  }
  function u(d, h) {
    var p = c((d = gW(d), d.type = "f", d)), m = Math.max(-8, Math.min(8, Math.floor(fg(h) / 3))) * 3, b = Math.pow(10, -m), y = PD[8 + m / 3];
    return function(Z) {
      return p(b * Z) + y;
    };
  }
  return {
    format: c,
    formatPrefix: u
  };
}
var B1, w9, x9;
nit({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function nit(i) {
  return B1 = eit(i), w9 = B1.format, x9 = B1.formatPrefix, B1;
}
function iit(i) {
  return Math.max(0, -fg(Math.abs(i)));
}
function sit(i, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(fg(t) / 3))) * 3 - fg(Math.abs(i)));
}
function rit(i, t) {
  return i = Math.abs(i), t = Math.abs(t) - i, Math.max(0, fg(t) - fg(i)) + 1;
}
function ait(i, t, e, n) {
  var s = bnt(i, t, e), r;
  switch (n = gW(n ?? ",f"), n.type) {
    case "s": {
      var a = Math.max(Math.abs(i), Math.abs(t));
      return n.precision == null && !isNaN(r = sit(s, a)) && (n.precision = r), x9(n, a);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      n.precision == null && !isNaN(r = rit(s, Math.max(Math.abs(i), Math.abs(t)))) && (n.precision = r - (n.type === "e"));
      break;
    }
    case "f":
    case "%": {
      n.precision == null && !isNaN(r = iit(s)) && (n.precision = r - (n.type === "%") * 2);
      break;
    }
  }
  return w9(n);
}
function oit(i) {
  var t = i.domain;
  return i.ticks = function(e) {
    var n = t();
    return mnt(n[0], n[n.length - 1], e ?? 10);
  }, i.tickFormat = function(e, n) {
    var s = t();
    return ait(s[0], s[s.length - 1], e ?? 10, n);
  }, i.nice = function(e) {
    e == null && (e = 10);
    var n = t(), s = 0, r = n.length - 1, a = n[s], o = n[r], l, c, u = 10;
    for (o < a && (c = a, a = o, o = c, c = s, s = r, r = c); u-- > 0; ) {
      if (c = oL(a, o, e), c === l)
        return n[s] = a, n[r] = o, t(n);
      if (c > 0)
        a = Math.floor(a / c) * c, o = Math.ceil(o / c) * c;
      else if (c < 0)
        a = Math.ceil(a * c) / c, o = Math.floor(o * c) / c;
      else
        break;
      l = c;
    }
    return i;
  }, i;
}
function vI() {
  var i = Knt();
  return i.copy = function() {
    return Ant(i, vI());
  }, fnt.apply(i, arguments), oit(i);
}
const lit = {
  DISPLAY: 0,
  WORLD: 1
};
var S9 = {
  CoordinateSystem: lit
};
const {
  CoordinateSystem: dL
} = S9;
function JD(i) {
  return () => tt.vtkErrorMacro(`vtkProp::${i} - NOT IMPLEMENTED`);
}
function cit(i, t) {
  t.classHierarchy.push("vtkProp"), i.getMTime = () => {
    let e = t.mtime;
    for (let n = 0; n < t.textures.length; ++n) {
      const s = t.textures[n].getMTime();
      s > e && (e = s);
    }
    return e;
  }, i.processSelectorPixelBuffers = (e, n) => {
  }, i.getNestedProps = () => null, i.getActors = () => [], i.getActors2D = () => [], i.getVolumes = () => [], i.pick = JD("pick"), i.hasKey = JD("hasKey"), i.getNestedVisibility = () => t.visibility && (!t._parentProp || t._parentProp.getNestedVisibility()), i.getNestedPickable = () => t.pickable && (!t._parentProp || t._parentProp.getNestedPickable()), i.getNestedDragable = () => t.dragable && (!t._parentProp || t._parentProp.getNestedDragable()), i.getRedrawMTime = () => t.mtime, i.setEstimatedRenderTime = (e) => {
    t.estimatedRenderTime = e, t.savedEstimatedRenderTime = e;
  }, i.restoreEstimatedRenderTime = () => {
    t.estimatedRenderTime = t.savedEstimatedRenderTime;
  }, i.addEstimatedRenderTime = (e) => {
    t.estimatedRenderTime += e;
  }, i.setAllocatedRenderTime = (e) => {
    t.allocatedRenderTime = e, t.savedEstimatedRenderTime = t.estimatedRenderTime, t.estimatedRenderTime = 0;
  }, i.getSupportsSelection = () => !1, i.getTextures = () => t.textures, i.hasTexture = (e) => t.textures.indexOf(e) !== -1, i.addTexture = (e) => {
    e && !i.hasTexture(e) && (t.textures = t.textures.concat(e), i.modified());
  }, i.removeTexture = (e) => {
    const n = t.textures.filter((s) => s !== e);
    t.textures.length !== n.length && (t.textures = n, i.modified());
  }, i.removeAllTextures = () => {
    t.textures = [], i.modified();
  }, i.setCoordinateSystemToWorld = () => i.setCoordinateSystem(dL.WORLD), i.setCoordinateSystemToDisplay = () => i.setCoordinateSystem(dL.DISPLAY);
}
const uit = {
  // _parentProp: null,
  allocatedRenderTime: 10,
  coordinateSystem: dL.WORLD,
  dragable: !0,
  estimatedRenderTime: 0,
  paths: null,
  pickable: !0,
  renderTimeMultiplier: 1,
  savedEstimatedRenderTime: 0,
  textures: [],
  useBounds: !0,
  visibility: !0
};
function L9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, uit, e), tt.obj(i, t), tt.get(i, t, ["estimatedRenderTime", "allocatedRenderTime"]), tt.setGet(i, t, ["_parentProp", "coordinateSystem", "dragable", "pickable", "renderTimeMultiplier", "useBounds", "visibility"]), tt.moveToProtected(i, t, ["parentProp"]), cit(i, t);
}
const dit = tt.newInstance(L9, "vtkProp");
var np = {
  newInstance: dit,
  extend: L9,
  ...S9
};
const hit = 1e-6;
function pit(i, t) {
  t.classHierarchy.push("vtkProp3D"), i.addPosition = (n) => {
    t.position = t.position.map((s, r) => s + n[r]), i.modified();
  }, i.getOrientationWXYZ = () => {
    const n = ps.create();
    ut.getRotation(n, t.rotation);
    const s = new Float64Array(3), r = ps.getAxisAngle(s, n);
    return [pg(r), s[0], s[1], s[2]];
  }, i.getOrientationQuaternion = function() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return ut.getRotation(n, t.rotation);
  }, i.rotateX = (n) => {
    n !== 0 && (ut.rotateX(t.rotation, t.rotation, Qi(n)), i.modified());
  }, i.rotateY = (n) => {
    n !== 0 && (ut.rotateY(t.rotation, t.rotation, Qi(n)), i.modified());
  }, i.rotateZ = (n) => {
    n !== 0 && (ut.rotateZ(t.rotation, t.rotation, Qi(n)), i.modified());
  }, i.rotateWXYZ = (n, s, r, a) => {
    if (n === 0 || s === 0 && r === 0 && a === 0)
      return;
    const o = Qi(n), l = ps.create();
    ps.setAxisAngle(l, [s, r, a], o);
    const c = new Float64Array(16);
    ut.fromQuat(c, l), ut.multiply(t.rotation, t.rotation, c), i.modified();
  }, i.rotateQuaternion = (n) => {
    if (Math.abs(n[3]) >= 1 - hit)
      return;
    const s = ut.fromQuat(new Float64Array(16), n);
    ut.multiply(t.rotation, t.rotation, s), i.modified();
  }, i.setOrientation = (n, s, r) => n === t.orientation[0] && s === t.orientation[1] && r === t.orientation[2] ? !1 : (t.orientation = [n, s, r], ut.identity(t.rotation), i.rotateZ(r), i.rotateX(n), i.rotateY(s), i.modified(), !0), i.setUserMatrix = (n) => ST(t.userMatrix, n) ? !1 : (ut.copy(t.userMatrix, n), i.modified(), !0), i.getMatrix = () => (i.computeMatrix(), t.matrix), i.computeMatrix = () => {
    if (i.getMTime() > t.matrixMTime.getMTime()) {
      ut.identity(t.matrix), t.userMatrix && ut.multiply(t.matrix, t.matrix, t.userMatrix), ut.translate(t.matrix, t.matrix, t.origin), ut.translate(t.matrix, t.matrix, t.position), ut.multiply(t.matrix, t.matrix, t.rotation), ut.scale(t.matrix, t.matrix, t.scale), ut.translate(t.matrix, t.matrix, [-t.origin[0], -t.origin[1], -t.origin[2]]), ut.transpose(t.matrix, t.matrix), t.isIdentity = !0;
      for (let n = 0; n < 4; ++n)
        for (let s = 0; s < 4; ++s)
          (n === s ? 1 : 0) !== t.matrix[n + s * 4] && (t.isIdentity = !1);
      t.matrixMTime.modified();
    }
  }, i.getCenter = () => qe.getCenter(t.bounds), i.getLength = () => qe.getLength(t.bounds), i.getXRange = () => qe.getXRange(t.bounds), i.getYRange = () => qe.getYRange(t.bounds), i.getZRange = () => qe.getZRange(t.bounds), i.getUserMatrix = () => t.userMatrix;
  function e() {
    i.computeMatrix();
  }
  i.onModified(e);
}
const mit = {
  origin: [0, 0, 0],
  position: [0, 0, 0],
  orientation: [0, 0, 0],
  rotation: null,
  scale: [1, 1, 1],
  bounds: [1, -1, 1, -1, 1, -1],
  userMatrix: null,
  userMatrixMTime: null,
  cachedProp3D: null,
  isIdentity: !0,
  matrixMTime: null
};
function V9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, mit, e), np.extend(i, t, e), t.matrixMTime = {}, tt.obj(t.matrixMTime), tt.get(i, t, ["bounds", "isIdentity"]), tt.getArray(i, t, ["orientation"]), tt.setGetArray(i, t, ["origin", "position", "scale"], 3), t.matrix = ut.identity(new Float64Array(16)), t.rotation = ut.identity(new Float64Array(16)), t.userMatrix = ut.identity(new Float64Array(16)), t.transform = null, pit(i, t);
}
const bit = tt.newInstance(V9, "vtkProp3D");
var RI = {
  newInstance: bit,
  extend: V9
};
const X9 = {
  FLAT: 0,
  GOURAUD: 1,
  PHONG: 2
}, Vn = {
  POINTS: 0,
  WIREFRAME: 1,
  SURFACE: 2
}, fit = X9;
var I9 = {
  Shading: X9,
  Representation: Vn,
  Interpolation: fit
};
const {
  Representation: Zy,
  Interpolation: Ty
} = I9;
function AD(i) {
  return () => tt.vtkErrorMacro(`vtkProperty::${i} - NOT IMPLEMENTED`);
}
function git(i, t) {
  t.classHierarchy.push("vtkProperty"), i.setColor = (e, n, s) => {
    Array.isArray(e) ? (t.color[0] !== e[0] || t.color[1] !== e[1] || t.color[2] !== e[2]) && (t.color[0] = e[0], t.color[1] = e[1], t.color[2] = e[2], i.modified()) : (t.color[0] !== e || t.color[1] !== n || t.color[2] !== s) && (t.color[0] = e, t.color[1] = n, t.color[2] = s, i.modified()), i.setDiffuseColor(t.color), i.setAmbientColor(t.color), i.setSpecularColor(t.color);
  }, i.computeCompositeColor = AD("ComputeCompositeColor"), i.getColor = () => {
    let e = 0;
    t.ambient + t.diffuse + t.specular > 0 && (e = 1 / (t.ambient + t.diffuse + t.specular));
    for (let n = 0; n < 3; n++)
      t.color[n] = e * (t.ambient * t.ambientColor[n] + t.diffuse * t.diffuseColor[n] + t.specular * t.specularColor[n]);
    return [].concat(t.color);
  }, i.setSpecularPower = (e) => {
    const n = 1 / Math.max(1, e);
    (t.roughness !== n || t.specularPower !== e) && (t.specularPower = e, t.roughness = n, i.modified());
  }, i.addShaderVariable = AD("AddShaderVariable"), i.setInterpolationToFlat = () => i.setInterpolation(Ty.FLAT), i.setInterpolationToGouraud = () => i.setInterpolation(Ty.GOURAUD), i.setInterpolationToPhong = () => i.setInterpolation(Ty.PHONG), i.getInterpolationAsString = () => tt.enumToString(Ty, t.interpolation), i.setRepresentationToWireframe = () => i.setRepresentation(Zy.WIREFRAME), i.setRepresentationToSurface = () => i.setRepresentation(Zy.SURFACE), i.setRepresentationToPoints = () => i.setRepresentation(Zy.POINTS), i.getRepresentationAsString = () => tt.enumToString(Zy, t.representation);
}
const yit = {
  color: [1, 1, 1],
  ambientColor: [1, 1, 1],
  diffuseColor: [1, 1, 1],
  specularColor: [1, 1, 1],
  edgeColor: [0, 0, 0],
  ambient: 0,
  diffuse: 1,
  metallic: 0,
  roughness: 0.6,
  normalStrength: 1,
  emission: 1,
  baseIOR: 1.45,
  specular: 0,
  specularPower: 1,
  opacity: 1,
  interpolation: Ty.GOURAUD,
  representation: Zy.SURFACE,
  edgeVisibility: !1,
  backfaceCulling: !1,
  frontfaceCulling: !1,
  pointSize: 1,
  lineWidth: 1,
  lighting: !0,
  shading: !1,
  materialName: null
};
function C9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, yit, e), tt.obj(i, t), tt.setGet(i, t, ["lighting", "interpolation", "ambient", "diffuse", "metallic", "roughness", "normalStrength", "emission", "baseIOR", "specular", "specularPower", "opacity", "edgeVisibility", "lineWidth", "pointSize", "backfaceCulling", "frontfaceCulling", "representation", "diffuseTexture", "metallicTexture", "roughnessTexture", "normalTexture", "ambientOcclusionTexture", "emissionTexture"]), tt.setGetArray(i, t, ["ambientColor", "specularColor", "diffuseColor", "edgeColor"], 3), git(i, t);
}
const Zit = tt.newInstance(C9, "vtkProperty");
var V0 = {
  newInstance: Zit,
  extend: C9,
  ...I9
};
const {
  vtkDebugMacro: Tit
} = tt;
function Mit(i, t) {
  t.classHierarchy.push("vtkActor");
  const e = {
    ...i
  };
  i.getActors = () => [i], i.getIsOpaque = () => {
    if (t.forceOpaque)
      return !0;
    if (t.forceTranslucent)
      return !1;
    t.property || i.getProperty();
    let n = t.property.getOpacity() >= 1;
    return n = n && (!t.texture || !t.texture.isTranslucent()), n = n && (!t.mapper || t.mapper.getIsOpaque()), n;
  }, i.hasTranslucentPolygonalGeometry = () => t.mapper === null ? !1 : (t.property === null && i.setProperty(i.makeProperty()), !i.getIsOpaque()), i.makeProperty = V0.newInstance, i.getProperty = () => (t.property === null && (t.property = i.makeProperty()), t.property), i.getBounds = () => {
    if (t.mapper === null)
      return t.bounds;
    const n = t.mapper.getBounds();
    if (!n || n.length !== 6)
      return n;
    if (n[0] > n[1])
      return t.mapperBounds = n.concat(), t.bounds = [1, -1, 1, -1, 1, -1], t.boundsMTime.modified(), n;
    if (!t.mapperBounds || n[0] !== t.mapperBounds[0] || n[1] !== t.mapperBounds[1] || n[2] !== t.mapperBounds[2] || n[3] !== t.mapperBounds[3] || n[4] !== t.mapperBounds[4] || n[5] !== t.mapperBounds[5] || i.getMTime() > t.boundsMTime.getMTime()) {
      Tit("Recomputing bounds..."), t.mapperBounds = n.concat();
      const s = [];
      qe.getCorners(n, s), i.computeMatrix();
      const r = new Float64Array(16);
      ut.transpose(r, t.matrix), s.forEach((a) => I.transformMat4(a, a, r)), t.bounds[0] = t.bounds[2] = t.bounds[4] = Number.MAX_VALUE, t.bounds[1] = t.bounds[3] = t.bounds[5] = -Number.MAX_VALUE, t.bounds = t.bounds.map((a, o) => o % 2 === 0 ? s.reduce((l, c) => l > c[o / 2] ? c[o / 2] : l, a) : s.reduce((l, c) => l < c[(o - 1) / 2] ? c[(o - 1) / 2] : l, a)), t.boundsMTime.modified();
    }
    return t.bounds;
  }, i.getMTime = () => {
    let n = e.getMTime();
    if (t.property !== null) {
      const s = t.property.getMTime();
      n = s > n ? s : n;
    }
    if (t.backfaceProperty !== null) {
      const s = t.backfaceProperty.getMTime();
      n = s > n ? s : n;
    }
    return n;
  }, i.getRedrawMTime = () => {
    let n = t.mtime;
    if (t.mapper !== null) {
      let s = t.mapper.getMTime();
      n = s > n ? s : n, t.mapper.getInput() !== null && (t.mapper.getInputAlgorithm().update(), s = t.mapper.getInput().getMTime(), n = s > n ? s : n);
    }
    return n;
  }, i.getSupportsSelection = () => t.mapper ? t.mapper.getSupportsSelection() : !1, i.processSelectorPixelBuffers = (n, s) => {
    t.mapper && t.mapper.processSelectorPixelBuffers && t.mapper.processSelectorPixelBuffers(n, s);
  };
}
const Nit = {
  mapper: null,
  property: null,
  backfaceProperty: null,
  forceOpaque: !1,
  forceTranslucent: !1,
  bounds: [1, -1, 1, -1, 1, -1]
};
function Y9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Nit, e), RI.extend(i, t, e), t.boundsMTime = {}, tt.obj(t.boundsMTime), tt.set(i, t, ["property"]), tt.setGet(i, t, ["backfaceProperty", "forceOpaque", "forceTranslucent", "mapper"]), Mit(i, t);
}
const Wit = tt.newInstance(Y9, "vtkActor");
var Re = {
  newInstance: Wit,
  extend: Y9
};
function Git(i, t) {
  t.classHierarchy.push("vtkAbstractMapper"), i.update = () => {
    i.getInputData();
  }, i.addClippingPlane = (e) => e.isA("vtkPlane") ? t.clippingPlanes.includes(e) ? !1 : (t.clippingPlanes.push(e), i.modified(), !0) : !1, i.getNumberOfClippingPlanes = () => t.clippingPlanes.length, i.removeAllClippingPlanes = () => t.clippingPlanes.length === 0 ? !1 : (t.clippingPlanes.length = 0, i.modified(), !0), i.removeClippingPlane = (e) => {
    const n = t.clippingPlanes.indexOf(e);
    return n === -1 ? !1 : (t.clippingPlanes.splice(n, 1), i.modified(), !0);
  }, i.getClippingPlanes = () => t.clippingPlanes, i.setClippingPlanes = (e) => {
    if (e)
      if (!Array.isArray(e))
        i.addClippingPlane(e);
      else {
        const n = e.length;
        for (let s = 0; s < n && s < 6; s++)
          i.addClippingPlane(e[s]);
      }
  }, i.getClippingPlaneInDataCoords = (e, n, s) => {
    const r = t.clippingPlanes, a = e;
    if (r) {
      const o = r.length;
      if (n >= 0 && n < o) {
        const l = r[n], c = l.getNormal(), u = l.getOrigin(), d = c[0], h = c[1], p = c[2], m = -(d * u[0] + h * u[1] + p * u[2]);
        s[0] = d * a[0] + h * a[4] + p * a[8] + m * a[12], s[1] = d * a[1] + h * a[5] + p * a[9] + m * a[13], s[2] = d * a[2] + h * a[6] + p * a[10] + m * a[14], s[3] = d * a[3] + h * a[7] + p * a[11] + m * a[15];
        return;
      }
    }
    tt.vtkErrorMacro(`Clipping plane index ${n} is out of range.`);
  };
}
const wit = {
  clippingPlanes: []
};
function xit(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, wit, e), tt.obj(i, t), tt.algo(i, t, 1, 0), t.clippingPlanes || (t.clippingPlanes = []), Git(i, t);
}
var v9 = {
  extend: xit
};
function Sit(i, t) {
  i.getBounds = () => (tt.vtkErrorMacro("vtkAbstractMapper3D.getBounds - NOT IMPLEMENTED"), ad()), i.getCenter = () => {
    var n;
    const e = i.getBounds();
    return t.center = qe.isValid(e) ? qe.getCenter(e) : null, (n = t.center) == null ? void 0 : n.slice();
  }, i.getLength = () => {
    const e = i.getBounds();
    return qe.getDiagonalLength(e);
  };
}
const Lit = (i) => ({
  bounds: [...qe.INIT_BOUNDS],
  center: [0, 0, 0],
  viewSpecificProperties: {},
  ...i
});
function Vit(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Lit(e)), v9.extend(i, t, e), tt.setGet(i, t, ["viewSpecificProperties"]), Sit(i, t);
}
var DI = {
  extend: Vit
};
const {
  vtkErrorMacro: BD
} = tt, KD = 0, HD = 1, Ix = 2;
function Xit(i, t) {
  t.classHierarchy.push("vtkLookupTable"), i.isOpaque = () => {
    if (t.opaqueFlagBuildTime.getMTime() < i.getMTime()) {
      let e = !0;
      t.nanColor[3] < 1 && (e = 0), t.useBelowRangeColor && t.belowRangeColor[3] < 1 && (e = 0), t.useAboveRangeColor && t.aboveRangeColor[3] < 1 && (e = 0);
      for (let n = 3; n < t.table.length && e; n += 4)
        t.table[n] < 255 && (e = !1);
      t.opaqueFlag = e, t.opaqueFlagBuildTime.modified();
    }
    return t.opaqueFlag;
  }, i.usingLogScale = () => !1, i.getNumberOfAvailableColors = () => t.table.length / 4, i.linearIndexLookup = (e, n) => {
    let s = 0;
    const r = Number(e);
    return r < n.range[0] ? s = n.maxIndex + KD + 1.5 : r > n.range[1] ? s = n.maxIndex + HD + 1.5 : (s = (r + n.shift) * n.scale, s = s < n.maxIndex ? s : n.maxIndex), Math.floor(s);
  }, i.linearLookup = (e, n, s) => {
    let r = 0;
    aW(e) ? r = Math.floor(s.maxIndex + 1.5 + Ix) : r = i.linearIndexLookup(e, s);
    const a = 4 * r;
    return n.slice(a, a + 4);
  }, i.indexedLookupFunction = (e, n, s) => {
    let r = i.getAnnotatedValueIndexInternal(e);
    r === -1 && (r = t.numberOfColors + Ix);
    const a = 4 * r;
    return [n[a], n[a + 1], n[a + 2], n[a + 3]];
  }, i.lookupShiftAndScale = (e, n) => {
    n.shift = -e[0], n.scale = Number.MAX_VALUE, e[1] > e[0] && (n.scale = (n.maxIndex + 1) / (e[1] - e[0]));
  }, i.mapScalarsThroughTable = (e, n, s, r) => {
    let a = i.linearLookup;
    t.indexedLookup && (a = i.indexedLookupFunction);
    const o = i.getMappingRange(), l = {
      maxIndex: i.getNumberOfColors() - 1,
      range: o,
      shift: 0,
      scale: 0
    };
    i.lookupShiftAndScale(o, l);
    const c = i.getAlpha(), u = e.getNumberOfTuples(), d = e.getNumberOfComponents(), h = n.getData(), p = e.getData();
    if (c >= 1) {
      if (s === iL.RGBA)
        for (let m = 0; m < u; m++) {
          const b = a(p[m * d + r], t.table, l);
          h[m * 4] = b[0], h[m * 4 + 1] = b[1], h[m * 4 + 2] = b[2], h[m * 4 + 3] = b[3];
        }
    } else if (s === iL.RGBA)
      for (let m = 0; m < u; m++) {
        const b = a(p[m * d + r], t.table, l);
        h[m * 4] = b[0], h[m * 4 + 1] = b[1], h[m * 4 + 2] = b[2], h[m * 4 + 3] = Math.floor(b[3] * c + 0.5);
      }
  }, i.forceBuild = () => {
    let e = 0, n = 0, s = 0, r = 0;
    const a = t.numberOfColors - 1;
    a && (e = (t.hueRange[1] - t.hueRange[0]) / a, n = (t.saturationRange[1] - t.saturationRange[0]) / a, s = (t.valueRange[1] - t.valueRange[0]) / a, r = (t.alphaRange[1] - t.alphaRange[0]) / a), t.table.length = 4 * a + 16;
    const o = [], l = [];
    for (let c = 0; c <= a; c++)
      o[0] = t.hueRange[0] + c * e, o[1] = t.saturationRange[0] + c * n, o[2] = t.valueRange[0] + c * s, Yp(o, l), l[3] = t.alphaRange[0] + c * r, t.table[c * 4] = l[0] * 255 + 0.5, t.table[c * 4 + 1] = l[1] * 255 + 0.5, t.table[c * 4 + 2] = l[2] * 255 + 0.5, t.table[c * 4 + 3] = l[3] * 255 + 0.5;
    i.buildSpecialColors(), t.buildTime.modified();
  }, i.setTable = (e) => {
    if (Array.isArray(e)) {
      const s = e[0].length;
      t.numberOfColors = e.length;
      const r = 4 - s;
      let a = 0;
      for (let o = 0; o < t.numberOfColors; o++)
        t.table[o * 4] = 255, t.table[o * 4 + 1] = 255, t.table[o * 4 + 2] = 255, t.table[o * 4 + 3] = 255;
      for (let o = 0; o < e.length; o++) {
        const l = e[o];
        for (let c = 0; c < s; c++)
          t.table[a++] = l[c];
        a += r;
      }
      return i.buildSpecialColors(), t.insertTime.modified(), i.modified(), !0;
    }
    if (e.getNumberOfComponents() !== 4)
      return BD("Expected 4 components for RGBA colors"), !1;
    if (e.getDataType() !== Ke.UNSIGNED_CHAR)
      return BD("Expected unsigned char values for RGBA colors"), !1;
    t.numberOfColors = e.getNumberOfTuples();
    const n = e.getData();
    t.table.length = n.length;
    for (let s = 0; s < n.length; s++)
      t.table[s] = n[s];
    return i.buildSpecialColors(), t.insertTime.modified(), i.modified(), !0;
  }, i.buildSpecialColors = () => {
    const {
      numberOfColors: e
    } = t, n = t.table;
    let s = (e + KD) * 4;
    t.useBelowRangeColor || e === 0 ? (n[s] = t.belowRangeColor[0] * 255 + 0.5, n[s + 1] = t.belowRangeColor[1] * 255 + 0.5, n[s + 2] = t.belowRangeColor[2] * 255 + 0.5, n[s + 3] = t.belowRangeColor[3] * 255 + 0.5) : (n[s] = n[0], n[s + 1] = n[1], n[s + 2] = n[2], n[s + 3] = n[3]), s = (e + HD) * 4, t.useAboveRangeColor || e === 0 ? (n[s] = t.aboveRangeColor[0] * 255 + 0.5, n[s + 1] = t.aboveRangeColor[1] * 255 + 0.5, n[s + 2] = t.aboveRangeColor[2] * 255 + 0.5, n[s + 3] = t.aboveRangeColor[3] * 255 + 0.5) : (n[s] = n[4 * (e - 1) + 0], n[s + 1] = n[4 * (e - 1) + 1], n[s + 2] = n[4 * (e - 1) + 2], n[s + 3] = n[4 * (e - 1) + 3]), s = (e + Ix) * 4, n[s] = t.nanColor[0] * 255 + 0.5, n[s + 1] = t.nanColor[1] * 255 + 0.5, n[s + 2] = t.nanColor[2] * 255 + 0.5, n[s + 3] = t.nanColor[3] * 255 + 0.5;
  }, i.build = () => {
    (t.table.length < 1 || i.getMTime() > t.buildTime.getMTime() && t.insertTime.getMTime() <= t.buildTime.getMTime()) && i.forceBuild();
  }, t.table.length > 0 && (i.buildSpecialColors(), t.insertTime.modified());
}
const Iit = {
  numberOfColors: 256,
  // table: null,
  hueRange: [0, 0.66667],
  saturationRange: [1, 1],
  valueRange: [1, 1],
  alphaRange: [1, 1],
  nanColor: [0.5, 0, 0, 1],
  belowRangeColor: [0, 0, 0, 1],
  aboveRangeColor: [1, 1, 1, 1],
  useAboveRangeColor: !1,
  useBelowRangeColor: !1,
  alpha: 1
  // buildTime: null,
  // opaqueFlagBuildTime: null,
  // insertTime: null,
};
function R9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Iit, e), RG.extend(i, t, e), t.table || (t.table = []), t.buildTime = {}, tt.obj(t.buildTime), t.opaqueFlagBuildTime = {}, tt.obj(t.opaqueFlagBuildTime, {
    mtime: 0
  }), t.insertTime = {}, tt.obj(t.insertTime, {
    mtime: 0
  }), tt.get(i, t, ["buildTime"]), tt.setGet(i, t, ["numberOfColors", "useAboveRangeColor", "useBelowRangeColor"]), tt.setArray(i, t, ["alphaRange", "hueRange", "saturationRange", "valueRange"], 2), tt.setArray(i, t, ["nanColor", "belowRangeColor", "aboveRangeColor"], 4), tt.getArray(i, t, ["hueRange", "saturationRange", "valueRange", "alphaRange", "nanColor", "belowRangeColor", "aboveRangeColor"]), Xit(i, t);
}
const Cit = tt.newInstance(R9, "vtkLookupTable");
var My = {
  newInstance: Cit,
  extend: R9
};
let D9 = 1, OI = 0;
const Yit = ["VTK_RESOLVE_OFF", "VTK_RESOLVE_POLYGON_OFFSET"];
function vit() {
  return D9;
}
function Rit(i) {
  D9 = i;
}
function Dit() {
  return OI;
}
function kG() {
  OI = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
}
function Oit() {
  kG(0);
}
function zit() {
  kG(0);
}
function Eit() {
  kG(1);
}
function kit() {
  return Yit[OI];
}
var hL = {
  getResolveCoincidentTopologyAsString: kit,
  getResolveCoincidentTopologyPolygonOffsetFaces: vit,
  getResolveCoincidentTopology: Dit,
  setResolveCoincidentTopology: kG,
  setResolveCoincidentTopologyPolygonOffsetFaces: Rit,
  setResolveCoincidentTopologyToDefault: Oit,
  setResolveCoincidentTopologyToOff: zit,
  setResolveCoincidentTopologyToPolygonOffset: Eit
};
function O9(i, t, e) {
  e.forEach((n) => {
    i[`get${n.method}`] = () => t[n.key], i[`set${n.method}`] = (s, r) => {
      t[n.key] = {
        factor: s,
        offset: r
      };
    };
  });
}
const FG = ["Polygon", "Line", "Point"], Fit = {
  Polygon: {
    factor: 2,
    offset: 0
  },
  Line: {
    factor: 1,
    offset: -1
  },
  Point: {
    factor: 0,
    offset: -2
  }
}, vp = {};
O9(vp, Fit, FG.map((i) => ({
  key: i,
  method: `ResolveCoincidentTopology${i}OffsetParameters`
})));
function jit(i, t) {
  t.resolveCoincidentTopology === void 0 && (t.resolveCoincidentTopology = !1), tt.setGet(i, t, ["resolveCoincidentTopology"]), t.topologyOffset = {
    Polygon: {
      factor: 0,
      offset: 0
    },
    Line: {
      factor: 0,
      offset: 0
    },
    Point: {
      factor: 0,
      offset: 0
    }
  }, Object.keys(hL).forEach((e) => {
    i[e] = hL[e];
  }), Object.keys(vp).forEach((e) => {
    i[e] = vp[e];
  }), O9(i, t.topologyOffset, FG.map((e) => ({
    key: e,
    method: `RelativeCoincidentTopology${e}OffsetParameters`
  }))), i.getCoincidentTopologyPolygonOffsetParameters = () => {
    const e = vp.getResolveCoincidentTopologyPolygonOffsetParameters(), n = i.getRelativeCoincidentTopologyPolygonOffsetParameters();
    return {
      factor: e.factor + n.factor,
      offset: e.offset + n.offset
    };
  }, i.getCoincidentTopologyLineOffsetParameters = () => {
    const e = vp.getResolveCoincidentTopologyLineOffsetParameters(), n = i.getRelativeCoincidentTopologyLineOffsetParameters();
    return {
      factor: e.factor + n.factor,
      offset: e.offset + n.offset
    };
  }, i.getCoincidentTopologyPointOffsetParameter = () => {
    const e = vp.getResolveCoincidentTopologyPointOffsetParameters(), n = i.getRelativeCoincidentTopologyPointOffsetParameters();
    return {
      factor: e.factor + n.factor,
      offset: e.offset + n.offset
    };
  };
}
var jG = {
  implementCoincidentTopologyMethods: jit,
  staticOffsetAPI: vp,
  otherStaticMethods: hL,
  CATEGORIES: FG
};
const Es = {
  MIN_KNOWN_PASS: 0,
  ACTOR_PASS: 0,
  COMPOSITE_INDEX_PASS: 1,
  ID_LOW24: 2,
  ID_HIGH24: 3,
  MAX_KNOWN_PASS: 3
};
var z9 = {
  PassTypes: Es
};
const {
  FieldAssociations: _D
} = Vg, {
  staticOffsetAPI: Uit,
  otherStaticMethods: Pit
} = jG, {
  ColorMode: Cx,
  ScalarMode: yp,
  GetArray: Yx
} = vG, {
  VectorMode: Jit
} = TI, {
  VtkDataTypes: Ait
} = We;
function ey(i) {
  return () => tt.vtkErrorMacro(`vtkMapper::${i} - NOT IMPLEMENTED`);
}
function Bit(i, t) {
  t.classHierarchy.push("vtkMapper"), i.getBounds = () => {
    const e = i.getInputData();
    return e ? (t.static || i.update(), t.bounds = e.getBounds()) : t.bounds = ad(), t.bounds;
  }, i.setForceCompileOnly = (e) => {
    t.forceCompileOnly = e;
  }, i.setSelectionWebGLIdsToVTKIds = (e) => {
    t.selectionWebGLIdsToVTKIds = e;
  }, i.createDefaultLookupTable = () => {
    t.lookupTable = My.newInstance();
  }, i.getColorModeAsString = () => tt.enumToString(Cx, t.colorMode), i.setColorModeToDefault = () => i.setColorMode(0), i.setColorModeToMapScalars = () => i.setColorMode(1), i.setColorModeToDirectScalars = () => i.setColorMode(2), i.getScalarModeAsString = () => tt.enumToString(yp, t.scalarMode), i.setScalarModeToDefault = () => i.setScalarMode(0), i.setScalarModeToUsePointData = () => i.setScalarMode(1), i.setScalarModeToUseCellData = () => i.setScalarMode(2), i.setScalarModeToUsePointFieldData = () => i.setScalarMode(3), i.setScalarModeToUseCellFieldData = () => i.setScalarMode(4), i.setScalarModeToUseFieldData = () => i.setScalarMode(5), i.getAbstractScalars = (e, n, s, r, a) => {
    if (!e || !t.scalarVisibility)
      return {
        scalars: null,
        cellFLag: !1
      };
    let o = null, l = !1;
    if (n === yp.DEFAULT)
      o = e.getPointData().getScalars(), o || (o = e.getCellData().getScalars(), l = !0);
    else if (n === yp.USE_POINT_DATA)
      o = e.getPointData().getScalars();
    else if (n === yp.USE_CELL_DATA)
      o = e.getCellData().getScalars(), l = !0;
    else if (n === yp.USE_POINT_FIELD_DATA) {
      const c = e.getPointData();
      s === Yx.BY_ID ? o = c.getArrayByIndex(r) : o = c.getArrayByName(a);
    } else if (n === yp.USE_CELL_FIELD_DATA) {
      const c = e.getCellData();
      l = !0, s === Yx.BY_ID ? o = c.getArrayByIndex(r) : o = c.getArrayByName(a);
    } else if (n === yp.USE_FIELD_DATA) {
      const c = e.getFieldData();
      s === Yx.BY_ID ? o = c.getArrayByIndex(r) : o = c.getArrayByName(a);
    }
    return {
      scalars: o,
      cellFlag: l
    };
  }, i.mapScalars = (e, n) => {
    const s = i.getAbstractScalars(e, t.scalarMode, t.arrayAccessMode, t.arrayId, t.colorByArrayName).scalars;
    if (!s) {
      t.colorCoordinates = null, t.colorTextureMap = null, t.colorMapColors = null;
      return;
    }
    const r = `${i.getMTime()}${s.getMTime()}${n}`;
    if (t.colorBuildString !== r) {
      if (t.useLookupTableScalarRange || i.getLookupTable().setRange(t.scalarRange[0], t.scalarRange[1]), i.canUseTextureMapForColoring(e))
        i.mapScalarsToTexture(s, n);
      else {
        t.colorCoordinates = null, t.colorTextureMap = null;
        const a = i.getLookupTable();
        a && (a.build(), t.colorMapColors = a.mapScalars(s, t.colorMode, t.fieldDataTupleId));
      }
      t.colorBuildString = `${i.getMTime()}${s.getMTime()}${n}`;
    }
  }, i.scalarToTextureCoordinate = (e, n, s) => {
    let r = 0.5, a = 1;
    return aW(e) || (a = 0.49, r = (e - n) * s, r > 1e3 ? r = 1e3 : r < -1e3 && (r = -1e3)), {
      texCoordS: r,
      texCoordT: a
    };
  }, i.createColorTextureCoordinates = (e, n, s, r, a, o, l, c, u) => {
    const d = (o[1] - o[0]) / c, h = [];
    h[0] = o[0] - d, h[1] = o[1] + d;
    const p = 1 / (h[1] - h[0]), m = n.getData(), b = e.getData();
    let y = 0, Z = 0;
    if (a < 0 || a >= r)
      for (let g = 0; g < s; ++g) {
        let f = 0;
        for (let N = 0; N < r; ++N)
          f += b[y] * b[y], y++;
        let T = Math.sqrt(f);
        u && (T = My.applyLogScale(T, l, o));
        const M = i.scalarToTextureCoordinate(T, h[0], p);
        m[Z] = M.texCoordS, m[Z + 1] = M.texCoordT, Z += 2;
      }
    else {
      y += a;
      for (let g = 0; g < s; ++g) {
        let f = b[y];
        u && (f = My.applyLogScale(f, l, o));
        const T = i.scalarToTextureCoordinate(f, h[0], p);
        m[Z] = T.texCoordS, m[Z + 1] = T.texCoordT, Z += 2, y += r;
      }
    }
  }, i.mapScalarsToTexture = (e, n) => {
    const s = t.lookupTable.getRange(), r = t.lookupTable.usingLogScale();
    r && My.getLogRange(s, s);
    const a = t.lookupTable.getAlpha();
    if (t.colorMapColors = null, t.colorTextureMap == null || i.getMTime() > t.colorTextureMap.getMTime() || t.lookupTable.getMTime() > t.colorTextureMap.getMTime() || t.lookupTable.getAlpha() !== n) {
      t.lookupTable.setAlpha(n), t.colorTextureMap = null, t.lookupTable.build();
      let o = t.lookupTable.getNumberOfAvailableColors();
      o > 4094 && (o = 4094), o < 64 && (o = 64), o += 2;
      const l = (s[1] - s[0]) / (o - 2), c = new Float64Array(o * 2);
      for (let d = 0; d < o; ++d)
        c[d] = s[0] + d * l - l / 2, r && (c[d] = 10 ** c[d]);
      for (let d = 0; d < o; ++d)
        c[d + o] = NaN;
      t.colorTextureMap = xs.newInstance(), t.colorTextureMap.setExtent(0, o - 1, 0, 1, 0, 0);
      const u = We.newInstance({
        numberOfComponents: 1,
        values: c
      });
      t.colorTextureMap.getPointData().setScalars(t.lookupTable.mapScalars(u, t.colorMode, 0)), t.lookupTable.setAlpha(a);
    }
    if (!t.colorCoordinates || i.getMTime() > t.colorCoordinates.getMTime() || i.getInputData(0).getMTime() > t.colorCoordinates.getMTime() || t.lookupTable.getMTime() > t.colorCoordinates.getMTime()) {
      t.colorCoordinates = null;
      const o = e.getNumberOfComponents(), l = e.getNumberOfTuples();
      t.colorCoordinates = We.newInstance({
        numberOfComponents: 2,
        values: new Float32Array(l * 2)
      });
      let c = t.lookupTable.getVectorComponent();
      t.lookupTable.getVectorMode() === Jit.MAGNITUDE && e.getNumberOfComponents() > 1 && (c = -1), i.createColorTextureCoordinates(e, t.colorCoordinates, l, o, c, s, t.lookupTable.getRange(), t.colorTextureMap.getPointData().getScalars().getNumberOfTuples() / 2 - 2, r);
    }
  }, i.getIsOpaque = () => {
    const e = i.getInputData(), s = i.getAbstractScalars(e, t.scalarMode, t.arrayAccessMode, t.arrayId, t.colorByArrayName).scalars;
    if (!t.scalarVisibility || s == null)
      return !0;
    const r = i.getLookupTable();
    return r ? (r.build(), r.areScalarsOpaque(s, t.colorMode, -1)) : !0;
  }, i.canUseTextureMapForColoring = (e) => {
    if (!t.interpolateScalarsBeforeMapping || t.lookupTable && t.lookupTable.getIndexedLookup())
      return !1;
    const n = i.getAbstractScalars(e, t.scalarMode, t.arrayAccessMode, t.arrayId, t.colorByArrayName), s = n.scalars;
    return !(!s || n.cellFlag || t.colorMode === Cx.DEFAULT && s.getDataType() === Ait.UNSIGNED_CHAR || t.colorMode === Cx.DIRECT_SCALARS);
  }, i.clearColorArrays = () => {
    t.colorMapColors = null, t.colorCoordinates = null, t.colorTextureMap = null;
  }, i.getLookupTable = () => (t.lookupTable || i.createDefaultLookupTable(), t.lookupTable), i.getMTime = () => {
    let e = t.mtime;
    if (t.lookupTable !== null) {
      const n = t.lookupTable.getMTime();
      e = n > e ? n : e;
    }
    return e;
  }, i.getPrimitiveCount = () => {
    const e = i.getInputData();
    return {
      points: e.getPoints().getNumberOfValues() / 3,
      verts: e.getVerts().getNumberOfValues() - e.getVerts().getNumberOfCells(),
      lines: e.getLines().getNumberOfValues() - 2 * e.getLines().getNumberOfCells(),
      triangles: e.getPolys().getNumberOfValues() - 3 * e.getPolys().getNumberOfCells()
    };
  }, i.acquireInvertibleLookupTable = ey("AcquireInvertibleLookupTable"), i.valueToColor = ey("ValueToColor"), i.colorToValue = ey("ColorToValue"), i.useInvertibleColorFor = ey("UseInvertibleColorFor"), i.clearInvertibleColor = ey("ClearInvertibleColor"), i.processSelectorPixelBuffers = (e, n) => {
    if (!e || !t.selectionWebGLIdsToVTKIds || !t.populateSelectionSettings)
      return;
    const s = e.getRawPixelBuffer(Es.ID_LOW24), r = e.getRawPixelBuffer(Es.ID_HIGH24), a = e.getCurrentPass(), o = e.getFieldAssociation();
    let l = null;
    o === _D.FIELD_ASSOCIATION_POINTS ? l = t.selectionWebGLIdsToVTKIds.points : o === _D.FIELD_ASSOCIATION_CELLS && (l = t.selectionWebGLIdsToVTKIds.cells), l && n.forEach((c) => {
      if (a === Es.ID_LOW24) {
        let u = 0;
        r && (u += r[c], u *= 256), u += s[c + 2], u *= 256, u += s[c + 1], u *= 256, u += s[c];
        const d = l[u], h = e.getPixelBuffer(Es.ID_LOW24);
        h[c] = d & 255, h[c + 1] = (d & 65280) >> 8, h[c + 2] = (d & 16711680) >> 16;
      } else if (a === Es.ID_HIGH24 && r) {
        let u = 0;
        u += r[c], u *= 256, u += s[c], u *= 256, u += s[c + 1], u *= 256, u += s[c + 2];
        const d = l[u], h = e.getPixelBuffer(Es.ID_HIGH24);
        h[c] = (d & 4278190080) >> 24;
      }
    });
  };
}
const Kit = {
  colorMapColors: null,
  // Same as this->Colors
  static: !1,
  lookupTable: null,
  scalarVisibility: !0,
  scalarRange: [0, 1],
  useLookupTableScalarRange: !1,
  colorMode: 0,
  scalarMode: 0,
  arrayAccessMode: 1,
  // By_NAME
  renderTime: 0,
  colorByArrayName: null,
  fieldDataTupleId: -1,
  populateSelectionSettings: !0,
  selectionWebGLIdsToVTKIds: null,
  interpolateScalarsBeforeMapping: !1,
  colorCoordinates: null,
  colorTextureMap: null,
  forceCompileOnly: 0,
  useInvertibleColors: !1,
  invertibleScalars: null,
  customShaderAttributes: []
};
function E9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Kit, e), DI.extend(i, t, e), tt.get(i, t, ["colorCoordinates", "colorMapColors", "colorTextureMap", "selectionWebGLIdsToVTKIds"]), tt.setGet(i, t, [
    "colorByArrayName",
    "arrayAccessMode",
    "colorMode",
    "fieldDataTupleId",
    "interpolateScalarsBeforeMapping",
    "lookupTable",
    "populateSelectionSettings",
    "renderTime",
    "scalarMode",
    "scalarVisibility",
    "static",
    "useLookupTableScalarRange",
    "customShaderAttributes"
    // point data array names that will be transferred to the VBO
  ]), tt.setGetArray(i, t, ["scalarRange"], 2), jG.implementCoincidentTopologyMethods(i, t), Bit(i, t);
}
const Hit = tt.newInstance(E9, "vtkMapper");
var Ue = {
  newInstance: Hit,
  extend: E9,
  ...Uit,
  ...Pit,
  ...vG
};
const _it = [[-1, 0, 0], [1, 0, 0], [0, -1, 0], [0, 1, 0], [0, 0, -1], [0, 0, 1]], QD = [[8, 7, 11, 3], [9, 1, 10, 5], [4, 9, 0, 8], [2, 11, 6, 10], [0, 3, 2, 1], [4, 5, 6, 7]], K1 = [[0, 1], [1, 3], [2, 3], [0, 2], [4, 5], [5, 7], [6, 7], [4, 6], [0, 4], [1, 5], [3, 7], [2, 6]], $D = [0, 1, 0, 1, 0, 1, 0, 1, 2, 2, 2, 2], Ai = [[1, 2], [1, 2], [0, 2], [0, 2], [0, 1], [0, 1]], un = new Float64Array(3), H1 = new Float64Array(3), oi = new Float64Array(3), Rp = new Float64Array(3), Zp = new Float64Array(3), _1 = new Float64Array(3), vx = new Float64Array(16);
function Rx(i, t) {
  i.strokeStyle = t.strokeColor, i.lineWidth = t.strokeSize, i.fillStyle = t.fontColor, i.font = `${t.fontStyle} ${t.fontSize}px ${t.fontFamily}`;
}
function Qit(i, t) {
  t.classHierarchy.push("vtkCubeAxesActorHelper"), i.setRenderable = (e) => {
    t.renderable !== e && (t.renderable = e, t.tmActor.addTexture(t.renderable.getTmTexture()), t.tmActor.setProperty(e.getProperty()), t.tmActor.setParentProp(e), i.modified());
  }, i.createPolyDataForOneLabel = (e, n, s, r, a, o, l) => {
    const c = t.renderable.get_tmAtlas().get(e);
    if (!c)
      return;
    const u = t.renderable.getTextPolyData().getPoints().getData(), d = t.lastSize;
    un[0] = u[n * 3], un[1] = u[n * 3 + 1], un[2] = u[n * 3 + 2], I.transformMat4(oi, un, s), oi[0] += 0.1, I.transformMat4(H1, oi, r), I.subtract(Zp, H1, un), oi[0] -= 0.1, oi[1] += 0.1, I.transformMat4(H1, oi, r), I.subtract(_1, H1, un);
    for (let m = 0; m < 3; m++)
      Zp[m] /= 0.5 * 0.1 * d[0], _1[m] /= 0.5 * 0.1 * d[1];
    let h = l.ptIdx, p = l.cellIdx;
    un[0] = u[n * 3], un[1] = u[n * 3 + 1], un[2] = u[n * 3 + 2], a[0] < -0.5 ? I.scale(oi, Zp, a[0] * o - c.width) : a[0] > 0.5 ? I.scale(oi, Zp, a[0] * o) : I.scale(oi, Zp, a[0] * o - c.width / 2), I.add(un, un, oi), I.scale(oi, _1, a[1] * o - c.height / 2), I.add(un, un, oi), l.points[h * 3] = un[0], l.points[h * 3 + 1] = un[1], l.points[h * 3 + 2] = un[2], l.tcoords[h * 2] = c.tcoords[0], l.tcoords[h * 2 + 1] = c.tcoords[1], h++, I.scale(oi, Zp, c.width), I.add(un, un, oi), l.points[h * 3] = un[0], l.points[h * 3 + 1] = un[1], l.points[h * 3 + 2] = un[2], l.tcoords[h * 2] = c.tcoords[2], l.tcoords[h * 2 + 1] = c.tcoords[3], h++, I.scale(oi, _1, c.height), I.add(un, un, oi), l.points[h * 3] = un[0], l.points[h * 3 + 1] = un[1], l.points[h * 3 + 2] = un[2], l.tcoords[h * 2] = c.tcoords[4], l.tcoords[h * 2 + 1] = c.tcoords[5], h++, I.scale(oi, Zp, c.width), I.subtract(un, un, oi), l.points[h * 3] = un[0], l.points[h * 3 + 1] = un[1], l.points[h * 3 + 2] = un[2], l.tcoords[h * 2] = c.tcoords[6], l.tcoords[h * 2 + 1] = c.tcoords[7], h++, l.polys[p * 4] = 3, l.polys[p * 4 + 1] = h - 4, l.polys[p * 4 + 2] = h - 3, l.polys[p * 4 + 3] = h - 2, p++, l.polys[p * 4] = 3, l.polys[p * 4 + 1] = h - 4, l.polys[p * 4 + 2] = h - 2, l.polys[p * 4 + 3] = h - 1, l.ptIdx += 4, l.cellIdx += 2;
  }, i.updateTexturePolyData = () => {
    const e = t.camera.getCompositeProjectionMatrix(t.lastAspectRatio, -1, 1);
    ut.transpose(e, e);
    const n = t.renderable.getTextValues().length, s = n * 4, r = n * 2, a = new Float64Array(s * 3), o = new Uint16Array(r * 4), l = new Float32Array(s * 2);
    ut.invert(vx, e);
    const c = {
      ptIdx: 0,
      cellIdx: 0,
      polys: o,
      points: a,
      tcoords: l
    };
    let u = 0, d = 0, h = 0;
    const p = t.renderable.getTextPolyData().getPoints().getData(), m = t.renderable.getTextValues();
    for (; u < p.length / 3; ) {
      un[0] = p[u * 3], un[1] = p[u * 3 + 1], un[2] = p[u * 3 + 2], I.transformMat4(oi, un, e), un[0] = p[u * 3 + 3], un[1] = p[u * 3 + 4], un[2] = p[u * 3 + 5], I.transformMat4(Rp, un, e), I.subtract(oi, oi, Rp);
      const y = [oi[0], oi[1]];
      Yk(y), i.createPolyDataForOneLabel(m[d], u, e, vx, y, t.renderable.getAxisTitlePixelOffset(), c), u += 2, d++;
      for (let Z = 0; Z < t.renderable.getTickCounts()[h]; Z++)
        i.createPolyDataForOneLabel(m[d], u, e, vx, y, t.renderable.getTickLabelPixelOffset(), c), u++, d++;
      h++;
    }
    const b = We.newInstance({
      numberOfComponents: 2,
      values: l,
      name: "TextureCoordinates"
    });
    t.tmPolyData.getPointData().setTCoords(b), t.tmPolyData.getPoints().setData(a, 3), t.tmPolyData.getPoints().modified(), t.tmPolyData.getPolys().setData(o, 1), t.tmPolyData.getPolys().modified(), t.tmPolyData.modified();
  }, i.updateAPISpecificData = (e, n, s) => {
    (t.lastSize[0] !== e[0] || t.lastSize[1] !== e[1]) && (t.lastSize[0] = e[0], t.lastSize[1] = e[1], t.lastAspectRatio = e[0] / e[1], t.forceUpdate = !0), t.camera = n, i.updateTexturePolyData();
  };
}
const $it = tt.newInstance(function(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    renderable: null
  };
  Object.assign(t, {}, e), tt.obj(i, t), t.tmPolyData = Ie.newInstance(), t.tmMapper = Ue.newInstance(), t.tmMapper.setInputData(t.tmPolyData), t.tmActor = Re.newInstance({
    parentProp: i
  }), t.tmActor.setMapper(t.tmMapper), tt.setGet(i, t, ["renderable"]), tt.get(i, t, ["lastSize", "lastAspectRatio", "axisTextStyle", "tickTextStyle", "tmActor", "ticks"]), t.forceUpdate = !1, t.lastRedrawTime = {}, tt.obj(t.lastRedrawTime, {
    mtime: 0
  }), t.lastRebuildTime = {}, tt.obj(t.lastRebuildTime, {
    mtime: 0
  }), t.lastSize = [-1, -1], t.lastTickBounds = [], Qit(i, t);
}, "vtkCubeAxesActorHelper");
function qit(i, t) {
  t.classHierarchy.push("vtkCubeAxesActor"), i.setCamera = (n) => {
    t.camera !== n && (t.cameraModifiedSub && (t.cameraModifiedSub.unsubscribe(), t.cameraModifiedSub = null), t.camera = n, n && (t.cameraModifiedSub = n.onModified(i.update)), i.update(), i.modified());
  }, i.computeFacesToDraw = () => {
    const n = t.camera.getViewMatrix();
    ut.transpose(n, n);
    let s = !1;
    const r = qe.getDiagonalLength(t.dataBounds), a = Math.sin(t.faceVisibilityAngle * Math.PI / 180);
    for (let o = 0; o < 6; o++) {
      let l = !1;
      const c = Math.floor(o / 2), u = (c + 1) % 3, d = (c + 2) % 3;
      t.dataBounds[u * 2] !== t.dataBounds[u * 2 + 1] && t.dataBounds[d * 2] !== t.dataBounds[d * 2 + 1] && (un[c] = t.dataBounds[o] - 0.1 * r * _it[o][c], un[u] = 0.5 * (t.dataBounds[u * 2] + t.dataBounds[u * 2 + 1]), un[d] = 0.5 * (t.dataBounds[d * 2] + t.dataBounds[d * 2 + 1]), I.transformMat4(oi, un, n), un[c] = t.dataBounds[o], I.transformMat4(Rp, un, n), I.subtract(oi, Rp, oi), I.normalize(oi, oi), l = oi[2] > a, t.camera.getParallelProjection() || (I.normalize(Rp, Rp), l = I.dot(Rp, oi) > a)), l !== t.lastFacesToDraw[o] && (t.lastFacesToDraw[o] = l, s = !0);
    }
    return s;
  }, i.updatePolyData = (n, s, r) => {
    let a = 0, o = 0;
    a += 8;
    let l = 0;
    for (let p = 0; p < 12; p++)
      s[p] > 0 && l++;
    if (o += l, t.gridLines)
      for (let p = 0; p < 6; p++)
        n[p] && (a += r[Ai[p][0]].length * 2 + r[Ai[p][1]].length * 2, o += r[Ai[p][0]].length + r[Ai[p][1]].length);
    const c = new Float64Array(a * 3), u = new Uint32Array(o * 3);
    let d = 0, h = 0;
    for (let p = 0; p < 2; p++)
      for (let m = 0; m < 2; m++)
        for (let b = 0; b < 2; b++)
          c[d * 3] = t.dataBounds[b], c[d * 3 + 1] = t.dataBounds[2 + m], c[d * 3 + 2] = t.dataBounds[4 + p], d++;
    for (let p = 0; p < 12; p++)
      s[p] > 0 && (u[h * 3] = 2, u[h * 3 + 1] = K1[p][0], u[h * 3 + 2] = K1[p][1], h++);
    if (t.gridLines) {
      for (let p = 0; p < 6; p++)
        if (n[p]) {
          const m = Math.floor(p / 2);
          let b = r[Ai[p][0]];
          for (let y = 0; y < b.length; y++)
            c[d * 3 + m] = t.dataBounds[p], c[d * 3 + Ai[p][0]] = b[y], c[d * 3 + Ai[p][1]] = t.dataBounds[Ai[p][1] * 2], d++, c[d * 3 + m] = t.dataBounds[p], c[d * 3 + Ai[p][0]] = b[y], c[d * 3 + Ai[p][1]] = t.dataBounds[Ai[p][1] * 2 + 1], d++, u[h * 3] = 2, u[h * 3 + 1] = d - 2, u[h * 3 + 2] = d - 1, h++;
          b = r[Ai[p][1]];
          for (let y = 0; y < b.length; y++)
            c[d * 3 + m] = t.dataBounds[p], c[d * 3 + Ai[p][1]] = b[y], c[d * 3 + Ai[p][0]] = t.dataBounds[Ai[p][0] * 2], d++, c[d * 3 + m] = t.dataBounds[p], c[d * 3 + Ai[p][1]] = b[y], c[d * 3 + Ai[p][0]] = t.dataBounds[Ai[p][0] * 2 + 1], d++, u[h * 3] = 2, u[h * 3 + 1] = d - 2, u[h * 3 + 2] = d - 1, h++;
        }
    }
    t.polyData.getPoints().setData(c, 3), t.polyData.getPoints().modified(), t.polyData.getLines().setData(u, 1), t.polyData.getLines().modified(), t.polyData.modified();
  }, i.updateTextData = (n, s, r, a) => {
    let o = 0;
    for (let p = 0; p < 12; p++)
      s[p] === 1 && (o += 2, o += r[$D[p]].length);
    const l = t.polyData.getPoints().getData(), c = new Float64Array(o * 3);
    let u = 0, d = 0, h = 0;
    for (let p = 0; p < 6; p++)
      if (n[p])
        for (let m = 0; m < 4; m++) {
          const b = QD[p][m];
          if (s[b] === 1) {
            const y = $D[b], Z = K1[b][0] * 3, g = K1[b][1] * 3;
            c[u * 3] = 0.5 * (l[Z] + l[g]), c[u * 3 + 1] = 0.5 * (l[Z + 1] + l[g + 1]), c[u * 3 + 2] = 0.5 * (l[Z + 2] + l[g + 2]), u++;
            const f = Math.floor(p / 2);
            c[u * 3 + f] = t.dataBounds[p], c[u * 3 + Ai[p][0]] = 0.5 * (t.dataBounds[Ai[p][0] * 2] + t.dataBounds[Ai[p][0] * 2 + 1]), c[u * 3 + Ai[p][1]] = 0.5 * (t.dataBounds[Ai[p][1] * 2] + t.dataBounds[Ai[p][1] * 2 + 1]), u++, t.textValues[d] = t.axisLabels[y], d++;
            const T = (y + 1) % 3, M = (y + 2) % 3, N = r[y], W = a[y];
            t.tickCounts[h] = N.length;
            for (let x = 0; x < N.length; x++)
              c[u * 3 + y] = N[x], c[u * 3 + T] = l[Z + T], c[u * 3 + M] = l[Z + M], u++, t.textValues[d] = W[x], d++;
            h++;
          }
        }
    t.textPolyData.getPoints().setData(c, 3), t.textPolyData.modified();
  }, i.update = () => {
    if (!t.camera)
      return;
    const n = i.computeFacesToDraw(), s = t.lastFacesToDraw;
    let r = !1;
    for (let a = 0; a < 6; a++)
      t.dataBounds[a] !== t.lastTickBounds[a] && (r = !0, t.lastTickBounds[a] = t.dataBounds[a]);
    if (n || r || t.forceUpdate) {
      const a = new Array(12).fill(0);
      for (let c = 0; c < 6; c++)
        if (s[c])
          for (let u = 0; u < 4; u++)
            a[QD[c][u]]++;
      const o = [], l = [];
      for (let c = 0; c < 3; c++) {
        const u = vI().domain([t.dataBounds[c * 2], t.dataBounds[c * 2 + 1]]);
        o[c] = u.ticks(5);
        const d = u.tickFormat(5);
        l[c] = o[c].map(d);
      }
      i.updatePolyData(s, a, o), i.updateTextData(s, a, o, l), (r || t.forceUpdate) && i.updateTextureAtlas(l);
    }
    t.forceUpdate = !1;
  }, i.updateTextureAtlas = (n) => {
    t.tmContext.textBaseline = "bottom", t.tmContext.textAlign = "left", t._tmAtlas.clear();
    let s = 0, r = 1;
    for (let a = 0; a < 3; a++) {
      if (!t._tmAtlas.has(t.axisLabels[a])) {
        Rx(t.tmContext, t.axisTextStyle);
        const o = t.tmContext.measureText(t.axisLabels[a]), l = {
          height: o.actualBoundingBoxAscent + 2,
          startingHeight: r,
          width: o.width + 2,
          textStyle: t.axisTextStyle
        };
        t._tmAtlas.set(t.axisLabels[a], l), r += l.height, s < l.width && (s = l.width);
      }
      Rx(t.tmContext, t.tickTextStyle);
      for (let o = 0; o < n[a].length; o++)
        if (!t._tmAtlas.has(n[a][o])) {
          const l = t.tmContext.measureText(n[a][o]), c = {
            height: l.actualBoundingBoxAscent + 2,
            startingHeight: r,
            width: l.width + 2,
            textStyle: t.tickTextStyle
          };
          t._tmAtlas.set(n[a][o], c), r += c.height, s < c.width && (s = c.width);
        }
    }
    s = Qo(s), r = Qo(r), t._tmAtlas.forEach((a) => {
      a.tcoords = [0, (r - a.startingHeight - a.height) / r, a.width / s, (r - a.startingHeight - a.height) / r, a.width / s, (r - a.startingHeight) / r, 0, (r - a.startingHeight) / r];
    }), t.tmCanvas.width = s, t.tmCanvas.height = r, t.tmContext.textBaseline = "bottom", t.tmContext.textAlign = "left", t.tmContext.clearRect(0, 0, s, r), t._tmAtlas.forEach((a, o) => {
      Rx(t.tmContext, a.textStyle), t.tmContext.fillText(o, 1, a.startingHeight + a.height - 1);
    }), t.tmTexture.setCanvas(t.tmCanvas), t.tmTexture.modified();
  }, i.onModified(() => {
    t.forceUpdate = !0, i.update();
  }), i.setTickTextStyle = (n) => {
    t.tickTextStyle = {
      ...t.tickTextStyle,
      ...n
    }, i.modified();
  }, i.setAxisTextStyle = (n) => {
    t.axisTextStyle = {
      ...t.axisTextStyle,
      ...n
    }, i.modified();
  }, i.get_tmAtlas = () => t._tmAtlas, i.getBounds = () => (i.update(), qe.setBounds(t.bounds, t.gridActor.getBounds()), qe.scaleAboutCenter(t.bounds, t.boundsScaleFactor, t.boundsScaleFactor, t.boundsScaleFactor), t.bounds);
  const e = tt.chain(i.setProperty, t.gridActor.setProperty);
  i.setProperty = (n) => e(n)[0];
}
function tst(i) {
  return {
    boundsScaleFactor: 1.3,
    camera: null,
    dataBounds: [...qe.INIT_BOUNDS],
    faceVisibilityAngle: 8,
    gridLines: !0,
    axisLabels: null,
    axisTitlePixelOffset: 35,
    axisTextStyle: {
      fontColor: "white",
      fontStyle: "normal",
      fontSize: 18,
      fontFamily: "serif"
    },
    tickLabelPixelOffset: 12,
    tickTextStyle: {
      fontColor: "white",
      fontStyle: "normal",
      fontSize: 14,
      fontFamily: "serif"
    },
    ...i
  };
}
function k9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, tst(e)), Re.extend(i, t, e), t.lastFacesToDraw = [!1, !1, !1, !1, !1, !1], t.axisLabels = ["X-Axis", "Y-Axis", "Z-Axis"], t.tickCounts = [], t.textValues = [], t.lastTickBounds = [], t.tmCanvas = document.createElement("canvas"), t.tmContext = t.tmCanvas.getContext("2d"), t._tmAtlas = /* @__PURE__ */ new Map(), t.tmTexture = vc.newInstance(), t.tmTexture.setInterpolate(!1), i.getProperty().setDiffuse(0), i.getProperty().setAmbient(1), t.gridMapper = Ue.newInstance(), t.polyData = Ie.newInstance(), t.gridMapper.setInputData(t.polyData), t.gridActor = Re.newInstance(), t.gridActor.setMapper(t.gridMapper), t.gridActor.setProperty(i.getProperty()), t.gridActor.setParentProp(i), t.textPolyData = Ie.newInstance(), tt.setGet(i, t, ["axisTitlePixelOffset", "boundsScaleFactor", "faceVisibilityAngle", "gridLines", "tickLabelPixelOffset"]), tt.setGetArray(i, t, ["dataBounds"], 6), tt.setGetArray(i, t, ["axisLabels"], 3), tt.get(i, t, ["axisTextStyle", "tickTextStyle", "camera", "tmTexture", "textValues", "textPolyData", "tickCounts", "gridActor"]), qit(i, t);
}
const est = tt.newInstance(k9, "vtkCubeAxesActor");
var F9 = {
  newInstance: est,
  extend: k9,
  newCubeAxesActorHelper: $it
};
function nst(i, t) {
  t.classHierarchy.push("vtkOpenGLCubeAxesActor"), i.buildPass = (e) => {
    e && (t._openGLRenderer = i.getFirstAncestorOfType("vtkOpenGLRenderer"), t._openGLRenderWindow = t._openGLRenderer.getParent(), t.CubeAxesActorHelper.getRenderable() || t.CubeAxesActorHelper.setRenderable(t.renderable), i.prepareNodes(), i.addMissingNode(t.CubeAxesActorHelper.getTmActor()), i.addMissingNode(t.renderable.getGridActor()), i.removeUnusedNodes());
  }, i.opaquePass = (e, n) => {
    if (e) {
      const s = t._openGLRenderer ? t._openGLRenderer.getRenderable().getActiveCamera() : null, r = t._openGLRenderer.getTiledSizeAndOrigin();
      t.CubeAxesActorHelper.updateAPISpecificData([r.usize, r.vsize], s, t._openGLRenderWindow.getRenderable());
    }
  };
}
const ist = {};
function sst(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, ist, e), ui.extend(i, t, e), t.CubeAxesActorHelper = F9.newCubeAxesActorHelper(), nst(i, t);
}
const rst = In(sst, "vtkOpenGLCubeAxesActor");
Js("vtkCubeAxesActor", rst);
const id = {
  ARRAY_BUFFER: 0,
  ELEMENT_ARRAY_BUFFER: 1,
  TEXTURE_BUFFER: 2
};
var j9 = {
  ObjectType: id
};
const {
  ObjectType: rN
} = j9, ast = {};
function ost(i, t) {
  t.classHierarchy.push("vtkOpenGLBufferObject");
  function e(o) {
    switch (o) {
      case rN.ELEMENT_ARRAY_BUFFER:
        return t.context.ELEMENT_ARRAY_BUFFER;
      case rN.TEXTURE_BUFFER:
        if ("TEXTURE_BUFFER" in t.context)
          return t.context.TEXTURE_BUFFER;
      /* eslint-disable no-fallthrough */
      // Intentional fallthrough in case there is no TEXTURE_BUFFER in WebGL
      case rN.ARRAY_BUFFER:
      default:
        return t.context.ARRAY_BUFFER;
    }
  }
  let n = null, s = null, r = !0, a = "";
  i.getType = () => n, i.setType = (o) => {
    n = o;
  }, i.getHandle = () => s, i.isReady = () => r === !1, i.generateBuffer = (o) => {
    const l = e(o);
    return s === null && (s = t.context.createBuffer(), n = o), e(n) === l;
  }, i.upload = (o, l) => i.generateBuffer(l) ? (t.context.bindBuffer(e(n), s), t.context.bufferData(e(n), o, t.context.STATIC_DRAW), t.allocatedGPUMemoryInBytes = o.length * o.BYTES_PER_ELEMENT, r = !1, !0) : (a = "Trying to upload array buffer to incompatible buffer.", !1), i.bind = () => s ? (t.context.bindBuffer(e(n), s), !0) : !1, i.release = () => s ? (t.context.bindBuffer(e(n), null), !0) : !1, i.releaseGraphicsResources = () => {
    s !== null && (t.context.bindBuffer(e(n), null), t.context.deleteBuffer(s), s = null, t.allocatedGPUMemoryInBytes = 0);
  }, i.setOpenGLRenderWindow = (o) => {
    t._openGLRenderWindow !== o && (i.releaseGraphicsResources(), t._openGLRenderWindow = o, t.context = null, o && (t.context = t._openGLRenderWindow.getContext()));
  }, i.getError = () => a;
}
const lst = {
  objectType: rN.ARRAY_BUFFER,
  // _openGLRenderWindow: null,
  context: null,
  allocatedGPUMemoryInBytes: 0
};
function U9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, lst, e), tt.obj(i, t), tt.get(i, t, ["_openGLRenderWindow", "allocatedGPUMemoryInBytes"]), tt.moveToProtected(i, t, ["openGLRenderWindow"]), ost(i, t);
}
const cst = tt.newInstance(U9);
var Rc = {
  newInstance: cst,
  extend: U9,
  ...ast,
  ...j9
};
const {
  vtkErrorMacro: qD
} = tt;
function ust(i, t) {
  const e = new Float64Array(3);
  I.inverse(e, t);
  const n = new Float64Array(16);
  return ut.fromRotationTranslationScale(n, ps.create(), i, e), n;
}
function dst(i, t) {
  return i === null || t === null ? !1 : !(I.exactEquals(i, [0, 0, 0]) && I.exactEquals(t, [1, 1, 1]));
}
function hst(i, t) {
  t.classHierarchy.push("vtkOpenGLCellArrayBufferObject"), i.setType(id.ARRAY_BUFFER), i.createVBO = function(e, n, s, r) {
    let a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    return window.VTKJSWASM && window.VTKJSWASM.createVBO ? window.VTKJSWASM.createVBO(i, t, e, n, s, r, a) : i.createVBOJs(e, n, s, r, a);
  }, i.createVBOJs = function(e, n, s, r, a) {
    if (!e.getData() || !e.getData().length)
      return t.elementCount = 0, 0;
    t.blockSize = 3, t.vertexOffset = 0, t.normalOffset = 0, t.tCoordOffset = 0, t.tCoordComponents = 0, t.colorComponents = 0, t.colorOffset = 0, t.customData = [];
    const o = r.points.getData();
    let l = null, c = null, u = null;
    const d = r.colors ? r.colors.getNumberOfComponents() : 0, h = r.tcoords ? r.tcoords.getNumberOfComponents() : 0;
    r.normals && (t.normalOffset = 4 * t.blockSize, t.blockSize += 3, l = r.normals.getData()), r.customAttributes && r.customAttributes.forEach(($) => {
      $ && (t.customData.push({
        data: $.getData(),
        offset: 4 * t.blockSize,
        components: $.getNumberOfComponents(),
        name: $.getName()
      }), t.blockSize += $.getNumberOfComponents());
    }), r.tcoords && (t.tCoordOffset = 4 * t.blockSize, t.tCoordComponents = h, t.blockSize += h, c = r.tcoords.getData()), r.colors ? (t.colorComponents = r.colors.getNumberOfComponents(), t.colorOffset = 0, u = r.colors.getData(), t.colorBO || (t.colorBO = Rc.newInstance()), t.colorBO.setOpenGLRenderWindow(t._openGLRenderWindow)) : t.colorBO = null, t.stride = 4 * t.blockSize;
    let p = 0, m = 0, b = 0, y = 0, Z = 0, g = 0, f;
    const T = {
      // easy, every input point becomes an output point
      anythingToPoints($, A, E) {
        for (let ct = 0; ct < $; ++ct)
          f(Number(A[E + ct]));
      },
      linesToWireframe($, A, E) {
        for (let ct = 0; ct < $ - 1; ++ct)
          f(Number(A[E + ct])), f(Number(A[E + ct + 1]));
      },
      polysToWireframe($, A, E) {
        if ($ > 2)
          for (let ct = 0; ct < $; ++ct)
            f(Number(A[E + ct])), f(Number(A[E + (ct + 1) % $]));
      },
      stripsToWireframe($, A, E) {
        if ($ > 2) {
          for (let ct = 0; ct < $ - 1; ++ct)
            f(Number(A[E + ct])), f(Number(A[E + ct + 1]));
          for (let ct = 0; ct < $ - 2; ct++)
            f(Number(A[E + ct])), f(Number(A[E + ct + 2]));
        }
      },
      polysToSurface($, A, E) {
        for (let ct = 0; ct < $ - 2; ct++)
          f(Number(A[E + 0])), f(Number(A[E + ct + 1])), f(Number(A[E + ct + 2]));
      },
      stripsToSurface($, A, E) {
        for (let ct = 0; ct < $ - 2; ct++)
          f(Number(A[E + ct])), f(Number(A[E + ct + 1 + ct % 2])), f(Number(A[E + ct + 1 + (ct + 1) % 2]));
      }
    }, M = {
      // easy, every input point becomes an output point
      anythingToPoints($, A) {
        return $;
      },
      linesToWireframe($, A) {
        return $ > 1 ? ($ - 1) * 2 : 0;
      },
      polysToWireframe($, A) {
        return $ > 2 ? $ * 2 : 0;
      },
      stripsToWireframe($, A) {
        return $ > 2 ? $ * 4 - 6 : 0;
      },
      polysToSurface($, A) {
        return $ > 2 ? ($ - 2) * 3 : 0;
      },
      stripsToSurface($, A, E) {
        return $ > 2 ? ($ - 2) * 3 : 0;
      }
    };
    let N = null, W = null;
    s === Vn.POINTS || n === "verts" ? (N = T.anythingToPoints, W = M.anythingToPoints) : s === Vn.WIREFRAME || n === "lines" ? (N = T[`${n}ToWireframe`], W = M[`${n}ToWireframe`]) : (N = T[`${n}ToSurface`], W = M[`${n}ToSurface`]);
    const x = e.getData(), V = x.length;
    let X = 0;
    for (let $ = 0; $ < V; )
      X += W(Number(x[$]), x), $ += Number(x[$]) + 1;
    let C = null;
    const R = new Float32Array(X * t.blockSize);
    u && (C = new Uint8Array(X * 4));
    let z = 0, F = 0, P = 0, j = 0;
    for (let $ = 0; $ < 3; ++$) {
      const A = r.points.getRange($), E = A[1] - A[0];
      P += E * E;
      const ct = 0.5 * (A[1] + A[0]);
      j += ct * ct;
    }
    if (P > 0 && (Math.abs(j) / P > 1e6 || // If data is far from the origin relative to its size
    Math.abs(Math.log10(P)) > 3 || // If the size is huge when not far from the origin
    P === 0 && j > 1e6)) {
      const $ = new Float64Array(3), A = new Float64Array(3);
      for (let E = 0; E < 3; ++E) {
        const ct = r.points.getRange(E), at = ct[1] - ct[0];
        $[E] = 0.5 * (ct[1] + ct[0]), A[E] = at > 0 ? 1 / at : 1;
      }
      i.setCoordShiftAndScale($, A);
    } else t.coordShiftAndScaleEnabled === !0 && i.setCoordShiftAndScale(null, null);
    if (a)
      if (!a.points && !a.cells)
        a.points = new Int32Array(X), a.cells = new Int32Array(X);
      else {
        const $ = new Int32Array(X + a.points.length);
        $.set(a.points), a.points = $;
        const A = new Int32Array(X + a.cells.length);
        A.set(a.cells), a.cells = A;
      }
    let B = r.vertexOffset;
    f = function(A) {
      if (a && (a.points[B] = A, a.cells[B] = g + r.cellOffset), ++B, p = A * 3, t.coordShiftAndScaleEnabled ? (R[z++] = (o[p++] - t.coordShift[0]) * t.coordScale[0], R[z++] = (o[p++] - t.coordShift[1]) * t.coordScale[1], R[z++] = (o[p++] - t.coordShift[2]) * t.coordScale[2]) : (R[z++] = o[p++], R[z++] = o[p++], R[z++] = o[p++]), l !== null && (r.haveCellNormals ? m = (g + r.cellOffset) * 3 : m = A * 3, R[z++] = l[m++], R[z++] = l[m++], R[z++] = l[m++]), t.customData.forEach((E) => {
        Z = A * E.components;
        for (let ct = 0; ct < E.components; ++ct)
          R[z++] = E.data[Z++];
      }), c !== null) {
        b = A * h;
        for (let E = 0; E < h; ++E)
          R[z++] = c[b++];
      }
      u !== null && (r.haveCellScalars ? y = (g + r.cellOffset) * d : y = A * d, C[F++] = u[y++], C[F++] = u[y++], C[F++] = u[y++], C[F++] = d === 4 ? u[y++] : 255);
    };
    for (let $ = 0; $ < V; )
      N(Number(x[$]), x, $ + 1), $ += Number(x[$]) + 1, g++;
    return t.elementCount = X, i.upload(R, id.ARRAY_BUFFER), t.colorBO && (t.colorBOStride = 4, t.colorBO.upload(C, id.ARRAY_BUFFER)), g;
  }, i.setCoordShiftAndScale = (e, n) => {
    if (e !== null && (e.constructor !== Float64Array || e.length !== 3)) {
      qD("Wrong type for coordShift, expected vec3 or null");
      return;
    }
    if (n !== null && (n.constructor !== Float64Array || n.length !== 3)) {
      qD("Wrong type for coordScale, expected vec3 or null");
      return;
    }
    (t.coordShift === null || e === null || !I.equals(e, t.coordShift)) && (t.coordShift = e), (t.coordScale === null || n === null || !I.equals(n, t.coordScale)) && (t.coordScale = n), t.coordShiftAndScaleEnabled = dst(t.coordShift, t.coordScale), t.coordShiftAndScaleEnabled ? t.inverseShiftAndScaleMatrix = ust(t.coordShift, t.coordScale) : t.inverseShiftAndScaleMatrix = null;
  };
}
const pst = {
  elementCount: 0,
  stride: 0,
  colorBOStride: 0,
  vertexOffset: 0,
  normalOffset: 0,
  tCoordOffset: 0,
  tCoordComponents: 0,
  colorOffset: 0,
  colorComponents: 0,
  tcoordBO: null,
  customData: [],
  coordShift: null,
  coordScale: null,
  coordShiftAndScaleEnabled: !1,
  inverseShiftAndScaleMatrix: null
};
function P9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, pst, e), Rc.extend(i, t, e), tt.setGet(i, t, ["colorBO", "elementCount", "stride", "colorBOStride", "vertexOffset", "normalOffset", "tCoordOffset", "tCoordComponents", "colorOffset", "colorComponents", "customData"]), tt.get(i, t, ["coordShift", "coordScale", "coordShiftAndScaleEnabled", "inverseShiftAndScaleMatrix"]), hst(i, t);
}
const mst = tt.newInstance(P9);
var bst = {
  newInstance: mst,
  extend: P9
};
const {
  vtkErrorMacro: fst
} = tt;
function gst(i, t) {
  t.classHierarchy.push("vtkShader"), i.compile = () => {
    let e = t.context.VERTEX_SHADER;
    if (!t.source || !t.source.length || t.shaderType === "Unknown")
      return !1;
    switch (t.handle !== 0 && (t.context.deleteShader(t.handle), t.handle = 0), t.shaderType) {
      // case vtkShader::Geometry:
      //   type = GL_GEOMETRY_SHADER;
      //   break;
      case "Fragment":
        e = t.context.FRAGMENT_SHADER;
        break;
      case "Vertex":
      default:
        e = t.context.VERTEX_SHADER;
        break;
    }
    if (t.handle = t.context.createShader(e), t.context.shaderSource(t.handle, t.source), t.context.compileShader(t.handle), !t.context.getShaderParameter(t.handle, t.context.COMPILE_STATUS)) {
      const s = t.context.getShaderInfoLog(t.handle);
      return fst(`Error compiling shader '${t.source}': ${s}`), t.context.deleteShader(t.handle), t.handle = 0, !1;
    }
    return !0;
  }, i.cleanup = () => {
    t.shaderType === "Unknown" || t.handle === 0 || (t.context.deleteShader(t.handle), t.handle = 0, t.dirty = !0);
  };
}
const yst = {
  shaderType: "Unknown",
  source: "",
  error: "",
  handle: 0,
  dirty: !1,
  context: null
};
function J9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, yst, e), tt.obj(i, t), tt.setGet(i, t, ["shaderType", "source", "error", "handle", "context"]), gst(i, t);
}
const Zst = tt.newInstance(J9, "vtkShader");
var Dx = {
  newInstance: Zst,
  extend: J9
};
const {
  vtkErrorMacro: Hl
} = tt;
function Tst(i, t, e, n) {
  const s = typeof e == "string" ? e : e.join(`
`), r = n === !1 ? t : new RegExp(t, "g"), a = i.replace(r, s);
  return {
    // If the result is different than the input, we did perform a replacement
    replace: a !== s,
    result: a
  };
}
function Mst(i, t) {
  t.classHierarchy.push("vtkShaderProgram"), i.compileShader = () => t.vertexShader.compile() ? t.fragmentShader.compile() ? !i.attachShader(t.vertexShader) || !i.attachShader(t.fragmentShader) ? (Hl(t.error), 0) : i.link() ? (i.setCompiled(!0), 1) : (Hl(`Links failed: ${t.error}`), 0) : (Hl(t.fragmentShader.getSource().split(`
`).map((e, n) => `${n}: ${e}`).join(`
`)), Hl(t.fragmentShader.getError()), 0) : (Hl(t.vertexShader.getSource().split(`
`).map((e, n) => `${n}: ${e}`).join(`
`)), Hl(t.vertexShader.getError()), 0), i.cleanup = () => {
    t.shaderType === "Unknown" || t.handle === 0 || (i.release(), t.vertexShaderHandle !== 0 && (t.context.detachShader(t.handle, t.vertexShaderHandle), t.vertexShaderHandle = 0), t.fragmentShaderHandle !== 0 && (t.context.detachShader(t.handle, t.fragmentShaderHandle), t.fragmentShaderHandle = 0), t.context.deleteProgram(t.handle), t.handle = 0, i.setCompiled(!1));
  }, i.bind = () => !t.linked && !i.link() ? !1 : (t.context.useProgram(t.handle), i.setBound(!0), !0), i.isBound = () => !!t.bound, i.release = () => {
    t.context.useProgram(null), i.setBound(!1);
  }, i.setContext = (e) => {
    t.vertexShader.setContext(e), t.fragmentShader.setContext(e), t.geometryShader.setContext(e);
  }, i.link = () => {
    if (t.linked)
      return !0;
    if (t.handle === 0)
      return t.error = "Program has not been initialized, and/or does not have shaders.", !1;
    if (t.uniformLocs = {}, t.context.linkProgram(t.handle), !t.context.getProgramParameter(t.handle, t.context.LINK_STATUS)) {
      const n = t.context.getProgramInfoLog(t.handle);
      return Hl(`Error linking shader ${n}`), t.handle = 0, !1;
    }
    return i.setLinked(!0), t.attributeLocs = {}, !0;
  }, i.setUniformMatrix = (e, n) => {
    const s = i.findUniform(e);
    if (s === -1)
      return t.error = `Could not set uniform ${e} . No such uniform.`, !1;
    const r = new Float32Array(n);
    return t.context.uniformMatrix4fv(s, !1, r), !0;
  }, i.setUniformMatrix3x3 = (e, n) => {
    const s = i.findUniform(e);
    if (s === -1)
      return t.error = `Could not set uniform ${e} . No such uniform.`, !1;
    const r = new Float32Array(n);
    return t.context.uniformMatrix3fv(s, !1, r), !0;
  }, i.setUniformf = (e, n) => {
    const s = i.findUniform(e);
    return s === -1 ? (t.error = `Could not set uniform ${e} . No such uniform.`, !1) : (t.context.uniform1f(s, n), !0);
  }, i.setUniformfv = (e, n) => {
    const s = i.findUniform(e);
    return s === -1 ? (t.error = `Could not set uniform ${e} . No such uniform.`, !1) : (t.context.uniform1fv(s, n), !0);
  }, i.setUniformi = (e, n) => {
    const s = i.findUniform(e);
    return s === -1 ? (t.error = `Could not set uniform ${e} . No such uniform.`, !1) : (t.context.uniform1i(s, n), !0);
  }, i.setUniformiv = (e, n) => {
    const s = i.findUniform(e);
    return s === -1 ? (t.error = `Could not set uniform ${e} . No such uniform.`, !1) : (t.context.uniform1iv(s, n), !0);
  }, i.setUniform2f = (e, n, s) => {
    const r = i.findUniform(e);
    if (r === -1)
      return t.error = `Could not set uniform ${e} . No such uniform.`, !1;
    if (s === void 0)
      throw new RangeError("Invalid number of values for array");
    return t.context.uniform2f(r, n, s), !0;
  }, i.setUniform2fv = (e, n) => {
    const s = i.findUniform(e);
    return s === -1 ? (t.error = `Could not set uniform ${e} . No such uniform.`, !1) : (t.context.uniform2fv(s, n), !0);
  }, i.setUniform2i = (e, n, s) => {
    const r = i.findUniform(e);
    if (r === -1)
      return t.error = `Could not set uniform ${e} . No such uniform.`, !1;
    if (s === void 0)
      throw new RangeError("Invalid number of values for array");
    return t.context.uniform2i(r, n, s), !0;
  }, i.setUniform2iv = (e, n) => {
    const s = i.findUniform(e);
    return s === -1 ? (t.error = `Could not set uniform ${e} . No such uniform.`, !1) : (t.context.uniform2iv(s, n), !0);
  }, i.setUniform3f = (e, n, s, r) => {
    const a = i.findUniform(e);
    if (a === -1)
      return t.error = `Could not set uniform ${e} . No such uniform.`, !1;
    if (r === void 0)
      throw new RangeError("Invalid number of values for array");
    return t.context.uniform3f(a, n, s, r), !0;
  }, i.setUniform3fArray = (e, n) => {
    const s = i.findUniform(e);
    if (s === -1)
      return t.error = `Could not set uniform ${e} . No such uniform.`, !1;
    if (!Array.isArray(n) || n.length !== 3)
      throw new RangeError("Invalid number of values for array");
    return t.context.uniform3f(s, n[0], n[1], n[2]), !0;
  }, i.setUniform3fv = (e, n) => {
    const s = i.findUniform(e);
    return s === -1 ? (t.error = `Could not set uniform ${e} . No such uniform.`, !1) : (t.context.uniform3fv(s, n), !0);
  }, i.setUniform3i = function(e) {
    const n = i.findUniform(e);
    if (n === -1)
      return t.error = `Could not set uniform ${e} . No such uniform.`, !1;
    for (var s = arguments.length, r = new Array(s > 1 ? s - 1 : 0), a = 1; a < s; a++)
      r[a - 1] = arguments[a];
    let o = r;
    if (o.length === 1 && Array.isArray(o[0]) && (o = o[0]), o.length !== 3)
      throw new RangeError("Invalid number of values for array");
    return t.context.uniform3i(n, o[0], o[1], o[2]), !0;
  }, i.setUniform3iv = (e, n) => {
    const s = i.findUniform(e);
    return s === -1 ? (t.error = `Could not set uniform ${e} . No such uniform.`, !1) : (t.context.uniform3iv(s, n), !0);
  }, i.setUniform4f = function(e) {
    const n = i.findUniform(e);
    if (n === -1)
      return t.error = `Could not set uniform ${e} . No such uniform.`, !1;
    for (var s = arguments.length, r = new Array(s > 1 ? s - 1 : 0), a = 1; a < s; a++)
      r[a - 1] = arguments[a];
    let o = r;
    if (o.length === 1 && Array.isArray(o[0]) && (o = o[0]), o.length !== 4)
      throw new RangeError("Invalid number of values for array");
    return t.context.uniform4f(n, o[0], o[1], o[2], o[3]), !0;
  }, i.setUniform4fv = (e, n) => {
    const s = i.findUniform(e);
    return s === -1 ? (t.error = `Could not set uniform ${e} . No such uniform.`, !1) : (t.context.uniform4fv(s, n), !0);
  }, i.setUniform4i = function(e) {
    const n = i.findUniform(e);
    if (n === -1)
      return t.error = `Could not set uniform ${e} . No such uniform.`, !1;
    for (var s = arguments.length, r = new Array(s > 1 ? s - 1 : 0), a = 1; a < s; a++)
      r[a - 1] = arguments[a];
    let o = r;
    if (o.length === 1 && Array.isArray(o[0]) && (o = o[0]), o.length !== 4)
      throw new RangeError("Invalid number of values for array");
    return t.context.uniform4i(n, o[0], o[1], o[2], o[3]), !0;
  }, i.setUniform4iv = (e, n) => {
    const s = i.findUniform(e);
    return s === -1 ? (t.error = `Could not set uniform ${e} . No such uniform.`, !1) : (t.context.uniform4iv(s, n), !0);
  }, i.findUniform = (e) => {
    if (!e || !t.linked)
      return -1;
    let n = t.uniformLocs[e];
    return n !== void 0 ? n : (n = t.context.getUniformLocation(t.handle, e), n === null ? (t.error = `Uniform ${e} not found in current shader program.`, t.uniformLocs[e] = -1, -1) : (t.uniformLocs[e] = n, n));
  }, i.isUniformUsed = (e) => {
    if (!e)
      return !1;
    let n = t.uniformLocs[e];
    return n !== void 0 ? n !== null : t.linked ? (n = t.context.getUniformLocation(t.handle, e), t.uniformLocs[e] = n, n !== null) : (Hl("attempt to find uniform when the shader program is not linked"), !1);
  }, i.isAttributeUsed = (e) => {
    if (!e)
      return !1;
    if (e in t.attributeLocs)
      return !0;
    if (!t.linked)
      return Hl("attempt to find uniform when the shader program is not linked"), !1;
    const n = t.context.getAttribLocation(t.handle, e);
    return n === -1 ? !1 : (t.attributeLocs[e] = n, !0);
  }, i.attachShader = (e) => {
    if (e.getHandle() === 0)
      return t.error = "Shader object was not initialized, cannot attach it.", !1;
    if (e.getShaderType() === "Unknown")
      return t.error = "Shader object is of type Unknown and cannot be used.", !1;
    if (t.handle === 0) {
      const n = t.context.createProgram();
      if (n === 0)
        return t.error = "Could not create shader program.", !1;
      t.handle = n, t.linked = !1;
    }
    return e.getShaderType() === "Vertex" && (t.vertexShaderHandle !== 0 && t.context.detachShader(t.handle, t.vertexShaderHandle), t.vertexShaderHandle = e.getHandle()), e.getShaderType() === "Fragment" && (t.fragmentShaderHandle !== 0 && t.context.detachShader(t.handle, t.fragmentShaderHandle), t.fragmentShaderHandle = e.getHandle()), t.context.attachShader(t.handle, e.getHandle()), i.setLinked(!1), !0;
  }, i.detachShader = (e) => {
    if (e.getHandle() === 0)
      return t.error = "shader object was not initialized, cannot attach it.", !1;
    if (e.getShaderType() === "Unknown")
      return t.error = "Shader object is of type Unknown and cannot be used.", !1;
    switch (t.handle === 0 && (t.error = "This shader program has not been initialized yet."), e.getShaderType()) {
      case "Vertex":
        return t.vertexShaderHandle !== e.getHandle() ? (t.error = "The supplied shader was not attached to this program.", !1) : (t.context.detachShader(t.handle, e.getHandle()), t.vertexShaderHandle = 0, t.linked = !1, !0);
      case "Fragment":
        return t.fragmentShaderHandle !== e.getHandle() ? (t.error = "The supplied shader was not attached to this program.", !1) : (t.context.detachShader(t.handle, e.getHandle()), t.fragmentShaderHandle = 0, t.linked = !1, !0);
      default:
        return !1;
    }
  }, i.setContext = (e) => {
    t.context = e, t.vertexShader.setContext(e), t.fragmentShader.setContext(e), t.geometryShader.setContext(e);
  }, i.setLastCameraMTime = (e) => {
    t.lastCameraMTime = e;
  };
}
const Nst = {
  vertexShaderHandle: 0,
  fragmentShaderHandle: 0,
  geometryShaderHandle: 0,
  vertexShader: null,
  fragmentShader: null,
  geometryShader: null,
  linked: !1,
  bound: !1,
  compiled: !1,
  error: "",
  handle: 0,
  numberOfOutputs: 0,
  attributesLocs: null,
  uniformLocs: null,
  md5Hash: 0,
  context: null,
  lastCameraMTime: null
};
function A9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Nst, e), t.attributesLocs = {}, t.uniformLocs = {}, t.vertexShader = Dx.newInstance(), t.vertexShader.setShaderType("Vertex"), t.fragmentShader = Dx.newInstance(), t.fragmentShader.setShaderType("Fragment"), t.geometryShader = Dx.newInstance(), t.geometryShader.setShaderType("Geometry"), tt.obj(i, t), tt.get(i, t, ["lastCameraMTime"]), tt.setGet(i, t, ["error", "handle", "compiled", "bound", "md5Hash", "vertexShader", "fragmentShader", "geometryShader", "linked"]), Mst(i, t);
}
const Wst = tt.newInstance(A9, "vtkShaderProgram");
var Ft = {
  newInstance: Wst,
  extend: A9,
  substitute: Tst
};
function Gst(i, t) {
  t.classHierarchy.push("vtkOpenGLVertexArrayObject"), i.exposedMethod = () => {
  }, i.initialize = () => {
    t.instancingExtension = null, t._openGLRenderWindow.getWebgl2() || (t.instancingExtension = t.context.getExtension("ANGLE_instanced_arrays")), !t.forceEmulation && t._openGLRenderWindow && t._openGLRenderWindow.getWebgl2() ? (t.extension = null, t.supported = !0, t.handleVAO = t.context.createVertexArray()) : (t.extension = t.context.getExtension("OES_vertex_array_object"), !t.forceEmulation && t.extension ? (t.supported = !0, t.handleVAO = t.extension.createVertexArrayOES()) : t.supported = !1);
  }, i.isReady = () => (
    // We either probed and allocated a VAO, or are falling back as the current
    // hardware does not support VAOs.
    t.handleVAO !== 0 || t.supported === !1
  ), i.bind = () => {
    if (i.isReady() || i.initialize(), i.isReady() && t.supported)
      t.extension ? t.extension.bindVertexArrayOES(t.handleVAO) : t.context.bindVertexArray(t.handleVAO);
    else if (i.isReady()) {
      const e = t.context;
      for (let n = 0; n < t.buffers.length; ++n) {
        const s = t.buffers[n];
        t.context.bindBuffer(e.ARRAY_BUFFER, s.buffer);
        for (let r = 0; r < s.attributes.length; ++r) {
          const a = s.attributes[r], o = a.isMatrix ? a.size : 1;
          for (let l = 0; l < o; ++l)
            e.enableVertexAttribArray(a.index + l), e.vertexAttribPointer(a.index + l, a.size, a.type, a.normalize, a.stride, a.offset + a.stride * l / a.size), a.divisor > 0 && (t.instancingExtension ? t.instancingExtension.vertexAttribDivisorANGLE(a.index + l, 1) : e.vertexAttribDivisor(a.index + l, 1));
        }
      }
    }
  }, i.release = () => {
    if (i.isReady() && t.supported)
      t.extension ? t.extension.bindVertexArrayOES(null) : t.context.bindVertexArray(null);
    else if (i.isReady()) {
      const e = t.context;
      for (let n = 0; n < t.buffers.length; ++n) {
        const s = t.buffers[n];
        t.context.bindBuffer(e.ARRAY_BUFFER, s.buffer);
        for (let r = 0; r < s.attributes.length; ++r) {
          const a = s.attributes[r], o = a.isMatrix ? a.size : 1;
          for (let l = 0; l < o; ++l)
            e.enableVertexAttribArray(a.index + l), e.vertexAttribPointer(a.index + l, a.size, a.type, a.normalize, a.stride, a.offset + a.stride * l / a.size), a.divisor > 0 && (t.instancingExtension ? t.instancingExtension.vertexAttribDivisorANGLE(a.index + l, 0) : e.vertexAttribDivisor(a.index + l, 0)), e.disableVertexAttribArray(a.index + l);
        }
      }
    }
  }, i.shaderProgramChanged = () => {
    i.release(), t.handleVAO && (t.extension ? t.extension.deleteVertexArrayOES(t.handleVAO) : t.context.deleteVertexArray(t.handleVAO)), t.handleVAO = 0, t.handleProgram = 0;
  }, i.releaseGraphicsResources = () => {
    i.shaderProgramChanged(), t.handleVAO && (t.extension ? t.extension.deleteVertexArrayOES(t.handleVAO) : t.context.deleteVertexArray(t.handleVAO)), t.handleVAO = 0, t.supported = !0, t.handleProgram = 0;
  }, i.addAttributeArray = (e, n, s, r, a, o, l, c) => i.addAttributeArrayWithDivisor(e, n, s, r, a, o, l, c, 0, !1), i.addAttributeArrayWithDivisor = (e, n, s, r, a, o, l, c, u, d) => {
    if (!e || !e.isBound() || n.getHandle() === 0 || n.getType() !== id.ARRAY_BUFFER || (t.handleProgram === 0 && (t.handleProgram = e.getHandle()), i.isReady() || i.initialize(), !i.isReady() || t.handleProgram !== e.getHandle()))
      return !1;
    const h = t.context, p = {};
    if (p.name = s, p.index = h.getAttribLocation(t.handleProgram, s), p.offset = r, p.stride = a, p.type = o, p.size = l, p.normalize = c, p.isMatrix = d, p.divisor = u, p.Index === -1)
      return !1;
    if (n.bind(), h.enableVertexAttribArray(p.index), h.vertexAttribPointer(p.index, p.size, p.type, p.normalize, p.stride, p.offset), u > 0 && (t.instancingExtension ? t.instancingExtension.vertexAttribDivisorANGLE(p.index, 1) : h.vertexAttribDivisor(p.index, 1)), p.buffer = n.getHandle(), !t.supported) {
      let m = !1;
      for (let b = 0; b < t.buffers.length; ++b) {
        const y = t.buffers[b];
        if (y.buffer === p.buffer) {
          m = !0;
          let Z = !1;
          for (let g = 0; g < y.attributes.length; ++g)
            y.attributes[g].name === s && (Z = !0, y.attributes[g] = p);
          Z || y.attributes.push(p);
        }
      }
      m || t.buffers.push({
        buffer: p.buffer,
        attributes: [p]
      });
    }
    return !0;
  }, i.addAttributeMatrixWithDivisor = (e, n, s, r, a, o, l, c, u) => {
    const d = i.addAttributeArrayWithDivisor(e, n, s, r, a, o, l, c, u, !0);
    if (!d)
      return d;
    const h = t.context, p = h.getAttribLocation(t.handleProgram, s);
    for (let m = 1; m < l; m++)
      h.enableVertexAttribArray(p + m), h.vertexAttribPointer(p + m, l, o, c, a, r + a * m / l), u > 0 && (t.instancingExtension ? t.instancingExtension.vertexAttribDivisorANGLE(p + m, 1) : h.vertexAttribDivisor(p + m, 1));
    return !0;
  }, i.removeAttributeArray = (e) => {
    if (!i.isReady() || t.handleProgram === 0)
      return !1;
    if (!t.supported)
      for (let n = 0; n < t.buffers.length; ++n) {
        const s = t.buffers[n];
        for (let r = 0; r < s.attributes.length; ++r)
          if (s.attributes[r].name === e)
            return s.attributes.splice(r, 1), s.attributes.length || t.buffers.splice(n, 1), !0;
      }
    return !0;
  }, i.setOpenGLRenderWindow = (e) => {
    t._openGLRenderWindow !== e && (i.releaseGraphicsResources(), t._openGLRenderWindow = e, t.context = null, e && (t.context = t._openGLRenderWindow.getContext()));
  };
}
const wst = {
  forceEmulation: !1,
  handleVAO: 0,
  handleProgram: 0,
  supported: !0,
  buffers: null,
  context: null
  // _openGLRenderWindow: null,
};
function B9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, wst, e), t.buffers = [], tt.obj(i, t), tt.get(i, t, ["supported"]), tt.setGet(i, t, ["forceEmulation"]), Gst(i, t);
}
const xst = tt.newInstance(B9, "vtkOpenGLVertexArrayObject");
var zI = {
  newInstance: xst,
  extend: B9
};
const {
  vtkWarningMacro: Q1,
  vtkErrorMacro: Sst
} = tt, vd = {
  Start: 0,
  Points: 0,
  Lines: 1,
  Tris: 2,
  TriStrips: 3,
  TrisEdges: 4,
  TriStripsEdges: 5,
  End: 6
};
function Lst(i, t) {
  t.classHierarchy.push("vtkOpenGLHelper"), i.setOpenGLRenderWindow = (e) => {
    t.context = e.getContext(), t.program || (Q1("Missing OpenGL helper shader program before render window assignment; recreating shader program."), t.program = Ft.newInstance()), t.program.setContext(t.context), t.VAO.setOpenGLRenderWindow(e), t.CABO.setOpenGLRenderWindow(e);
  }, i.releaseGraphicsResources = (e) => {
    t.VAO.releaseGraphicsResources(), t.CABO.releaseGraphicsResources(), t.CABO.setElementCount(0);
  }, i.drawArrays = (e, n, s, r) => {
    if (t.CABO.getElementCount()) {
      const a = i.getOpenGLMode(s), o = i.haveWideLines(e, n), l = t.context, c = l.getParameter(l.DEPTH_WRITEMASK);
      if (t.pointPicking && l.depthMask(!1), a === l.LINES && o) {
        if (!i.updateShaders(e, n, r))
          return Q1("Skipping wide-line draw because mapper shader update failed."), t.pointPicking && l.depthMask(c), 0;
        l.drawArraysInstanced(a, 0, Number(t.CABO.getElementCount()), 2 * Math.ceil(n.getProperty().getLineWidth()));
      } else {
        if (l.lineWidth(n.getProperty().getLineWidth()), !i.updateShaders(e, n, r))
          return Q1("Skipping draw because mapper shader update failed."), l.lineWidth(1), t.pointPicking && l.depthMask(c), 0;
        l.drawArrays(a, 0, Number(t.CABO.getElementCount())), l.lineWidth(1);
      }
      const d = (a === l.POINTS ? 1 : 0) || (a === l.LINES ? 2 : 3);
      return t.pointPicking && l.depthMask(c), Number(t.CABO.getElementCount()) / d;
    }
    return 0;
  }, i.getOpenGLMode = (e) => {
    if (t.pointPicking)
      return t.context.POINTS;
    const n = t.primitiveType;
    return e === Vn.POINTS || n === vd.Points ? t.context.POINTS : e === Vn.WIREFRAME || n === vd.Lines || n === vd.TrisEdges || n === vd.TriStripsEdges ? t.context.LINES : t.context.TRIANGLES;
  }, i.haveWideLines = (e, n) => n.getProperty().getLineWidth() > 1 ? !(t.CABO.getOpenGLRenderWindow() && t.CABO.getOpenGLRenderWindow().getHardwareMaximumLineWidth() >= n.getProperty().getLineWidth()) : !1, i.getNeedToRebuildShaders = (e, n, s) => !!(s.getNeedToRebuildShaders(i, e, n) || !i.getProgram() || i.getProgram() === 0 || i.getShaderSourceTime().getMTime() < s.getMTime() || i.getShaderSourceTime().getMTime() < n.getMTime()), i.updateShaders = (e, n, s) => {
    if (i.getNeedToRebuildShaders(e, n, s)) {
      const r = {
        Vertex: null,
        Fragment: null,
        Geometry: null
      };
      s.buildShaders(r, e, n);
      const a = t.CABO.getOpenGLRenderWindow().getShaderCache().readyShaderProgramArray(r.Vertex, r.Fragment, r.Geometry);
      if (!a)
        return Sst("Error compiling mapper shader program."), i.setProgram(null), !1;
      a !== i.getProgram() && (i.setProgram(a), i.getVAO().releaseGraphicsResources()), i.getShaderSourceTime().modified();
    } else if (!t.CABO.getOpenGLRenderWindow().getShaderCache().readyShaderProgram(i.getProgram()))
      return Q1("Unable to bind existing mapper shader program; marking program for rebuild."), i.setProgram(null), !1;
    return i.getVAO().bind(), s.setMapperShaderParameters(i, e, n), s.setPropertyShaderParameters(i, e, n), s.setCameraShaderParameters(i, e, n), s.setLightingShaderParameters(i, e, n), s.invokeShaderCallbacks(i, e, n), !0;
  }, i.setMapperShaderParameters = (e, n, s) => {
    if (i.haveWideLines(e, n)) {
      i.getProgram().setUniform2f("viewportSize", s.usize, s.vsize);
      const r = parseFloat(n.getProperty().getLineWidth()), a = r / 2;
      i.getProgram().setUniformf("lineWidthStepSize", r / Math.ceil(r)), i.getProgram().setUniformf("halfLineWidth", a);
    }
    t.primitiveType === vd.Points || n.getProperty().getRepresentation() === Vn.POINTS ? i.getProgram().setUniformf("pointSize", n.getProperty().getPointSize()) : t.pointPicking && i.getProgram().setUniformf("pointSize", i.getPointPickingPrimitiveSize());
  }, i.replaceShaderPositionVC = (e, n, s) => {
    let r = e.Vertex;
    r = Ft.substitute(r, "//VTK::PositionVC::Dec", ["//VTK::PositionVC::Dec", "uniform float pointSize;"]).result, r = Ft.substitute(r, "//VTK::PositionVC::Impl", ["//VTK::PositionVC::Impl", "  gl_PointSize = pointSize;"], !1).result, i.getOpenGLMode(s.getProperty().getRepresentation()) === t.context.LINES && i.haveWideLines(n, s) && (r = Ft.substitute(r, "//VTK::PositionVC::Dec", ["//VTK::PositionVC::Dec", "uniform vec2 viewportSize;", "uniform float lineWidthStepSize;", "uniform float halfLineWidth;"]).result, r = Ft.substitute(r, "//VTK::PositionVC::Impl", ["//VTK::PositionVC::Impl", " if (halfLineWidth > 0.0)", "   {", "   float offset = float(gl_InstanceID / 2) * lineWidthStepSize - halfLineWidth;", "   vec4 tmpPos = gl_Position;", "   vec3 tmpPos2 = tmpPos.xyz / tmpPos.w;", "   tmpPos2.x = tmpPos2.x + 2.0 * mod(float(gl_InstanceID), 2.0) * offset / viewportSize[0];", "   tmpPos2.y = tmpPos2.y + 2.0 * mod(float(gl_InstanceID + 1), 2.0) * offset / viewportSize[1];", "   gl_Position = vec4(tmpPos2.xyz * tmpPos.w, tmpPos.w);", "   }"]).result), e.Vertex = r;
  }, i.getPointPickingPrimitiveSize = () => t.primitiveType === vd.Points ? 2 : t.primitiveType === vd.Lines ? 4 : 6, i.getAllocatedGPUMemoryInBytes = () => i.getCABO().getAllocatedGPUMemoryInBytes();
}
const Vst = {
  context: null,
  program: null,
  shaderSourceTime: null,
  VAO: null,
  attributeUpdateTime: null,
  CABO: null,
  primitiveType: 0,
  pointPicking: !1
};
function K9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Vst, e), tt.obj(i, t), t.shaderSourceTime = {}, tt.obj(t.shaderSourceTime), t.attributeUpdateTime = {}, tt.obj(t.attributeUpdateTime), tt.setGet(i, t, ["program", "shaderSourceTime", "VAO", "attributeUpdateTime", "CABO", "primitiveType", "pointPicking"]), t.program = Ft.newInstance(), t.VAO = zI.newInstance(), t.CABO = bst.newInstance(), Lst(i, t);
}
const Xst = tt.newInstance(K9);
var Jc = {
  newInstance: Xst,
  extend: K9,
  primTypes: vd
};
const g2 = {
  CLAMP_TO_EDGE: 0,
  REPEAT: 1,
  MIRRORED_REPEAT: 2
}, Qe = {
  NEAREST: 0,
  LINEAR: 1,
  NEAREST_MIPMAP_NEAREST: 2,
  NEAREST_MIPMAP_LINEAR: 3,
  LINEAR_MIPMAP_NEAREST: 4,
  LINEAR_MIPMAP_LINEAR: 5
};
var H9 = {
  Wrap: g2,
  Filter: Qe
};
const _9 = new Float32Array(1), Ist = new Int32Array(_9.buffer);
function Cst(i) {
  _9[0] = i;
  const t = Ist[0];
  let e = t >> 16 & 32768, n = t >> 12 & 2047;
  const s = t >> 23 & 255;
  return s < 103 ? e : s > 142 ? (e |= 31744, e |= (s === 255 ? 0 : 1) && t & 8388607, e) : s < 113 ? (n |= 2048, e |= (n >> 114 - s) + (n >> 113 - s & 1), e) : (e |= s - 112 << 10 | n >> 1, e += n & 1, e);
}
function Yst(i) {
  const t = (i & 32768) >> 15, e = (i & 31744) >> 10, n = i & 1023;
  return e === 0 ? (t ? -1 : 1) * 2 ** -14 * (n / 2 ** 10) : e === 31 ? n ? NaN : (t ? -1 : 1) * (1 / 0) : (t ? -1 : 1) * 2 ** (e - 15) * (1 + n / 2 ** 10);
}
var Dp = {
  fromHalf: Yst,
  toHalf: Cst
};
const {
  Wrap: hu,
  Filter: Nr
} = H9, {
  VtkDataTypes: jn
} = We, {
  vtkDebugMacro: Ox,
  vtkErrorMacro: _0,
  vtkWarningMacro: tO
} = kr, {
  toHalf: vst
} = Dp;
function Rst(i, t) {
  t.classHierarchy.push("vtkOpenGLTexture"), i.render = function() {
    let c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    if (c ? t._openGLRenderWindow = c : (t._openGLRenderer = i.getFirstAncestorOfType("vtkOpenGLRenderer"), t._openGLRenderWindow = t._openGLRenderer.getParent()), t.context = t._openGLRenderWindow.getContext(), t.renderable.getInterpolate() ? (t.generateMipmap ? i.setMinificationFilter(Nr.LINEAR_MIPMAP_LINEAR) : i.setMinificationFilter(Nr.LINEAR), i.setMagnificationFilter(Nr.LINEAR)) : (i.setMinificationFilter(Nr.NEAREST), i.setMagnificationFilter(Nr.NEAREST)), t.renderable.getRepeat() && (i.setWrapR(hu.REPEAT), i.setWrapS(hu.REPEAT), i.setWrapT(hu.REPEAT)), t.renderable.getInputData() && t.renderable.setImage(null), !t.handle || t.renderable.getMTime() > t.textureBuildTime.getMTime()) {
      if (t.renderable.getImage() !== null && (t.renderable.getInterpolate() && (t.generateMipmap = !0, i.setMinificationFilter(Nr.LINEAR_MIPMAP_LINEAR)), t.renderable.getImage() && t.renderable.getImageLoaded() && (i.create2DFromImage(t.renderable.getImage()), i.activate(), i.sendParameters(), t.textureBuildTime.modified())), t.renderable.getCanvas() !== null) {
        t.renderable.getInterpolate() && (t.generateMipmap = !0, i.setMinificationFilter(Nr.LINEAR_MIPMAP_LINEAR));
        const d = t.renderable.getCanvas();
        i.create2DFromRaw(d.width, d.height, 4, jn.UNSIGNED_CHAR, d, !0), i.activate(), i.sendParameters(), t.textureBuildTime.modified();
      }
      if (t.renderable.getJsImageData() !== null) {
        const d = t.renderable.getJsImageData();
        t.renderable.getInterpolate() && (t.generateMipmap = !0, i.setMinificationFilter(Nr.LINEAR_MIPMAP_LINEAR)), i.create2DFromRaw(d.width, d.height, 4, jn.UNSIGNED_CHAR, d.data, !0), i.activate(), i.sendParameters(), t.textureBuildTime.modified();
      }
      const u = t.renderable.getInputData(0);
      if (u && u.getPointData().getScalars()) {
        const d = u.getExtent(), h = u.getPointData().getScalars(), p = [];
        for (let m = 0; m < t.renderable.getNumberOfInputPorts(); ++m) {
          const b = t.renderable.getInputData(m), y = b ? b.getPointData().getScalars().getData() : null;
          y && p.push(y);
        }
        t.renderable.getInterpolate() && h.getNumberOfComponents() === 4 && (t.generateMipmap = !0, i.setMinificationFilter(Nr.LINEAR_MIPMAP_LINEAR)), p.length % 6 === 0 ? i.createCubeFromRaw(d[1] - d[0] + 1, d[3] - d[2] + 1, h.getNumberOfComponents(), h.getDataType(), p) : i.create2DFromRaw(d[1] - d[0] + 1, d[3] - d[2] + 1, h.getNumberOfComponents(), h.getDataType(), h.getData()), i.activate(), i.sendParameters(), t.textureBuildTime.modified();
      }
    }
    t.handle && i.activate();
  }, i.destroyTexture = () => {
    i.deactivate(), t.context && t.handle && t.context.deleteTexture(t.handle), t.handle = 0, t.numberOfDimensions = 0, t.target = 0, t.components = 0, t.width = 0, t.height = 0, t.depth = 0, i.resetFormatAndType();
  }, i.createTexture = () => {
    t.handle || (t.handle = t.context.createTexture(), t.target && (t.context.bindTexture(t.target, t.handle), t.context.texParameteri(t.target, t.context.TEXTURE_MIN_FILTER, i.getOpenGLFilterMode(t.minificationFilter)), t.context.texParameteri(t.target, t.context.TEXTURE_MAG_FILTER, i.getOpenGLFilterMode(t.magnificationFilter)), t.context.texParameteri(t.target, t.context.TEXTURE_WRAP_S, i.getOpenGLWrapMode(t.wrapS)), t.context.texParameteri(t.target, t.context.TEXTURE_WRAP_T, i.getOpenGLWrapMode(t.wrapT)), t._openGLRenderWindow.getWebgl2() && t.context.texParameteri(t.target, t.context.TEXTURE_WRAP_R, i.getOpenGLWrapMode(t.wrapR)), t.context.bindTexture(t.target, null)));
  }, i.getTextureUnit = () => t._openGLRenderWindow ? t._openGLRenderWindow.getTextureUnitForTexture(i) : -1, i.activate = () => {
    t._openGLRenderWindow.activateTexture(i), i.bind();
  }, i.deactivate = () => {
    t._openGLRenderWindow && t._openGLRenderWindow.deactivateTexture(i);
  }, i.releaseGraphicsResources = (c) => {
    c && t.handle && (c.activateTexture(i), c.deactivateTexture(i), t.context.deleteTexture(t.handle), t.handle = 0, t.numberOfDimensions = 0, t.target = 0, t.internalFormat = 0, t.format = 0, t.openGLDataType = 0, t.components = 0, t.width = 0, t.height = 0, t.depth = 0, t.allocatedGPUMemoryInBytes = 0), t.shaderProgram && (t.shaderProgram.releaseGraphicsResources(c), t.shaderProgram = null);
  }, i.bind = () => {
    t.context.bindTexture(t.target, t.handle), t.autoParameters && i.getMTime() > t.sendParametersTime.getMTime() && i.sendParameters();
  }, i.isBound = () => {
    let c = !1;
    if (t.context && t.handle) {
      let u = 0;
      switch (t.target) {
        case t.context.TEXTURE_2D:
          u = t.context.TEXTURE_BINDING_2D;
          break;
        default:
          tO("impossible case");
          break;
      }
      c = t.context.getIntegerv(u) === t.handle;
    }
    return c;
  }, i.sendParameters = () => {
    t.context.texParameteri(t.target, t.context.TEXTURE_WRAP_S, i.getOpenGLWrapMode(t.wrapS)), t.context.texParameteri(t.target, t.context.TEXTURE_WRAP_T, i.getOpenGLWrapMode(t.wrapT)), t._openGLRenderWindow.getWebgl2() && t.context.texParameteri(t.target, t.context.TEXTURE_WRAP_R, i.getOpenGLWrapMode(t.wrapR)), t.context.texParameteri(t.target, t.context.TEXTURE_MIN_FILTER, i.getOpenGLFilterMode(t.minificationFilter)), t.context.texParameteri(t.target, t.context.TEXTURE_MAG_FILTER, i.getOpenGLFilterMode(t.magnificationFilter)), t._openGLRenderWindow.getWebgl2() && (t.context.texParameteri(t.target, t.context.TEXTURE_BASE_LEVEL, t.baseLevel), t.context.texParameteri(t.target, t.context.TEXTURE_MAX_LEVEL, t.maxLevel)), t.sendParametersTime.modified();
  }, i.getInternalFormat = (c, u) => (t._forceInternalFormat || (t.internalFormat = i.getDefaultInternalFormat(c, u)), t.internalFormat || Ox(`Unable to find suitable internal format for T=${c} NC= ${u}`), [t.context.R32F, t.context.RG32F, t.context.RGB32F, t.context.RGBA32F].includes(t.internalFormat) && !t.context.getExtension("OES_texture_float_linear") && tO("Failed to load OES_texture_float_linear. Texture filtering is not available for *32F internal formats."), t.internalFormat), i.getDefaultInternalFormat = (c, u) => {
    let d = 0;
    return d = t._openGLRenderWindow.getDefaultTextureInternalFormat(c, u, t.oglNorm16Ext, t.useHalfFloat), d || (d || (Ox("Unsupported internal texture type!"), Ox(`Unable to find suitable internal format for T=${c} NC= ${u}`)), d);
  }, i.setInternalFormat = (c) => {
    t._forceInternalFormat = !0, c !== t.internalFormat && (t.internalFormat = c, i.modified());
  }, i.getFormat = (c, u) => (t.format = i.getDefaultFormat(c, u), t.format), i.getDefaultFormat = (c, u) => {
    if (t._openGLRenderWindow.getWebgl2())
      switch (u) {
        case 1:
          return t.context.RED;
        case 2:
          return t.context.RG;
        case 3:
          return t.context.RGB;
        case 4:
          return t.context.RGBA;
        default:
          return t.context.RGB;
      }
    else
      switch (u) {
        case 1:
          return t.context.LUMINANCE;
        case 2:
          return t.context.LUMINANCE_ALPHA;
        case 3:
          return t.context.RGB;
        case 4:
          return t.context.RGBA;
        default:
          return t.context.RGB;
      }
  }, i.resetFormatAndType = () => {
    t.format = 0, t.internalFormat = 0, t._forceInternalFormat = !1, t.openGLDataType = 0;
  }, i.getDefaultDataType = (c) => {
    if (t._openGLRenderWindow.getWebgl2())
      switch (c) {
        // case VtkDataTypes.SIGNED_CHAR:
        //   return model.context.BYTE;
        case jn.UNSIGNED_CHAR:
          return t.context.UNSIGNED_BYTE;
        // prefer norm16 since that is accurate compared to
        // half float which is not
        case (t.oglNorm16Ext && !t.useHalfFloat && jn.SHORT):
          return t.context.SHORT;
        case (t.oglNorm16Ext && !t.useHalfFloat && jn.UNSIGNED_SHORT):
          return t.context.UNSIGNED_SHORT;
        // use half float type
        case (t.useHalfFloat && jn.SHORT):
          return t.context.HALF_FLOAT;
        case (t.useHalfFloat && jn.UNSIGNED_SHORT):
          return t.context.HALF_FLOAT;
        // case VtkDataTypes.INT:
        //   return model.context.INT;
        // case VtkDataTypes.UNSIGNED_INT:
        //   return model.context.UNSIGNED_INT;
        case jn.FLOAT:
        case jn.VOID:
        // used for depth component textures.
        default:
          return t.context.FLOAT;
      }
    switch (c) {
      // case VtkDataTypes.SIGNED_CHAR:
      //   return model.context.BYTE;
      case jn.UNSIGNED_CHAR:
        return t.context.UNSIGNED_BYTE;
      // case VtkDataTypes.SHORT:
      //   return model.context.SHORT;
      // case VtkDataTypes.UNSIGNED_SHORT:
      //   return model.context.UNSIGNED_SHORT;
      // case VtkDataTypes.INT:
      //   return model.context.INT;
      // case VtkDataTypes.UNSIGNED_INT:
      //   return model.context.UNSIGNED_INT;
      case jn.FLOAT:
      case jn.VOID:
      // used for depth component textures.
      default:
        if (t.context.getExtension("OES_texture_float") && t.context.getExtension("OES_texture_float_linear"))
          return t.context.FLOAT;
        {
          const u = t.context.getExtension("OES_texture_half_float");
          if (u && t.context.getExtension("OES_texture_half_float_linear"))
            return u.HALF_FLOAT_OES;
        }
        return t.context.UNSIGNED_BYTE;
    }
  }, i.getOpenGLDataType = function(c) {
    let u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return (!t.openGLDataType || u) && (t.openGLDataType = i.getDefaultDataType(c)), t.openGLDataType;
  }, i.getShiftAndScale = () => {
    let c = 0, u = 1;
    switch (t.openGLDataType) {
      case t.context.BYTE:
        u = 127.5, c = u - 128;
        break;
      case t.context.UNSIGNED_BYTE:
        u = 255, c = 0;
        break;
      case t.context.SHORT:
        u = 32767.5, c = u - 32768;
        break;
      case t.context.UNSIGNED_SHORT:
        u = 65536, c = 0;
        break;
      case t.context.INT:
        u = 21474836475e-1, c = u - 2147483648;
        break;
      case t.context.UNSIGNED_INT:
        u = 4294967295, c = 0;
        break;
      case t.context.FLOAT:
    }
    return {
      shift: c,
      scale: u
    };
  }, i.getOpenGLFilterMode = (c) => {
    switch (c) {
      case Nr.NEAREST:
        return t.context.NEAREST;
      case Nr.LINEAR:
        return t.context.LINEAR;
      case Nr.NEAREST_MIPMAP_NEAREST:
        return t.context.NEAREST_MIPMAP_NEAREST;
      case Nr.NEAREST_MIPMAP_LINEAR:
        return t.context.NEAREST_MIPMAP_LINEAR;
      case Nr.LINEAR_MIPMAP_NEAREST:
        return t.context.LINEAR_MIPMAP_NEAREST;
      case Nr.LINEAR_MIPMAP_LINEAR:
        return t.context.LINEAR_MIPMAP_LINEAR;
      default:
        return t.context.NEAREST;
    }
  }, i.getOpenGLWrapMode = (c) => {
    switch (c) {
      case hu.CLAMP_TO_EDGE:
        return t.context.CLAMP_TO_EDGE;
      case hu.REPEAT:
        return t.context.REPEAT;
      case hu.MIRRORED_REPEAT:
        return t.context.MIRRORED_REPEAT;
      default:
        return t.context.CLAMP_TO_EDGE;
    }
  };
  function e(c, u) {
    let d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    const h = [];
    let p = t.width * t.height * t.components;
    if (d && (p *= t.depth), c !== jn.FLOAT && t.openGLDataType === t.context.FLOAT)
      for (let b = 0; b < u.length; b++)
        if (u[b]) {
          const y = u[b].length > p ? u[b].subarray(0, p) : u[b];
          h.push(new Float32Array(y));
        } else
          h.push(null);
    if (c !== jn.UNSIGNED_CHAR && t.openGLDataType === t.context.UNSIGNED_BYTE)
      for (let b = 0; b < u.length; b++)
        if (u[b]) {
          const y = u[b].length > p ? u[b].subarray(0, p) : u[b];
          h.push(new Uint8Array(y));
        } else
          h.push(null);
    let m = !1;
    if (t._openGLRenderWindow.getWebgl2())
      m = t.openGLDataType === t.context.HALF_FLOAT;
    else {
      const b = t.context.getExtension("OES_texture_half_float");
      m = b && t.openGLDataType === b.HALF_FLOAT_OES;
    }
    if (m)
      for (let b = 0; b < u.length; b++)
        if (u[b]) {
          const y = new Uint16Array(p), Z = u[b];
          for (let g = 0; g < p; g++)
            y[g] = vst(Z[g]);
          h.push(y);
        } else
          h.push(null);
    if (h.length === 0)
      for (let b = 0; b < u.length; b++)
        h.push(u[b]);
    return h;
  }
  function n(c) {
    if (t._openGLRenderWindow.getWebgl2())
      return c;
    const u = [], d = t.width, h = t.height, p = t.components;
    if (c && (!gy(d) || !gy(h))) {
      const m = t.context.getExtension("OES_texture_half_float"), b = Qo(d), y = Qo(h), Z = b * y * t.components;
      for (let g = 0; g < c.length; g++)
        if (c[g] !== null) {
          let f = null;
          const T = h / y, M = d / b;
          let N = !1;
          t.openGLDataType === t.context.FLOAT ? f = new Float32Array(Z) : m && t.openGLDataType === m.HALF_FLOAT_OES ? (f = new Uint16Array(Z), N = !0) : f = new Uint8Array(Z);
          for (let W = 0; W < y; W++) {
            const x = W * b * p, V = W * T;
            let X = Math.floor(V), C = Math.ceil(V);
            C >= h && (C = h - 1);
            const R = V - X, z = 1 - R;
            X = X * d * p, C = C * d * p;
            for (let F = 0; F < b; F++) {
              const P = F * p, j = F * M;
              let H = Math.floor(j), B = Math.ceil(j);
              B >= d && (B = d - 1);
              const $ = j - H;
              H *= p, B *= p;
              for (let A = 0; A < p; A++)
                N ? f[x + P + A] = Dp.toHalf(Dp.fromHalf(c[g][X + H + A]) * z * (1 - $) + Dp.fromHalf(c[g][X + B + A]) * z * $ + Dp.fromHalf(c[g][C + H + A]) * R * (1 - $) + Dp.fromHalf(c[g][C + B + A]) * R * $) : f[x + P + A] = c[g][X + H + A] * z * (1 - $) + c[g][X + B + A] * z * $ + c[g][C + H + A] * R * (1 - $) + c[g][C + B + A] * R * $;
            }
          }
          u.push(f), t.width = b, t.height = y;
        } else
          u.push(null);
    }
    if (u.length === 0)
      for (let m = 0; m < c.length; m++)
        u.push(c[m]);
    return u;
  }
  function s(c) {
    var u;
    return t._openGLRenderWindow ? t.resizable || (u = t.renderable) != null && u.getResizable() ? !1 : t._openGLRenderWindow.getWebgl2() ? !(t._openGLRenderWindow.getGLInformations().RENDERER.value.match(/WebKit/gi) && navigator.platform.match(/Mac/gi) && t.oglNorm16Ext && (c === jn.UNSIGNED_SHORT || c === jn.SHORT)) : !1 : !1;
  }
  i.create2DFromRaw = function(c, u, d, h, p) {
    let m = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1;
    if (i.getOpenGLDataType(h, !0), i.getInternalFormat(h, d), i.getFormat(h, d), !t.internalFormat || !t.format || !t.openGLDataType)
      return _0("Failed to determine texture parameters."), !1;
    t.target = t.context.TEXTURE_2D, t.components = d, t.width = c, t.height = u, t.depth = 1, t.numberOfDimensions = 2, t._openGLRenderWindow.activateTexture(i), i.createTexture(), i.bind();
    const y = e(h, [p]), Z = n(y);
    return t.context.pixelStorei(t.context.UNPACK_FLIP_Y_WEBGL, m), t.context.pixelStorei(t.context.UNPACK_ALIGNMENT, 1), s(h) ? (t.context.texStorage2D(t.target, 1, t.internalFormat, t.width, t.height), Z[0] != null && t.context.texSubImage2D(t.target, 0, 0, 0, t.width, t.height, t.format, t.openGLDataType, Z[0])) : t.context.texImage2D(t.target, 0, t.internalFormat, t.width, t.height, 0, t.format, t.openGLDataType, Z[0]), t.generateMipmap && t.context.generateMipmap(t.target), m && t.context.pixelStorei(t.context.UNPACK_FLIP_Y_WEBGL, !1), t.allocatedGPUMemoryInBytes = t.width * t.height * t.depth * d * t._openGLRenderWindow.getDefaultTextureByteSize(h, t.oglNorm16Ext, t.useHalfFloat), i.deactivate(), !0;
  }, i.createCubeFromRaw = (c, u, d, h, p) => {
    if (i.getOpenGLDataType(h), i.getInternalFormat(h, d), i.getFormat(h, d), !t.internalFormat || !t.format || !t.openGLDataType)
      return _0("Failed to determine texture parameters."), !1;
    t.target = t.context.TEXTURE_CUBE_MAP, t.components = d, t.width = c, t.height = u, t.depth = 1, t.numberOfDimensions = 2, t._openGLRenderWindow.activateTexture(i), t.maxLevel = p.length / 6 - 1, i.createTexture(), i.bind();
    const m = e(h, p), b = n(m), y = [];
    let Z = t.width, g = t.height;
    for (let f = 0; f < b.length; f++) {
      f % 6 === 0 && f !== 0 && (Z /= 2, g /= 2), y[f] = xg(h, g * Z * t.components);
      for (let T = 0; T < g; ++T) {
        const M = T * Z * t.components, N = (g - T - 1) * Z * t.components;
        y[f].set(b[f].slice(N, N + Z * t.components), M);
      }
    }
    t.context.pixelStorei(t.context.UNPACK_ALIGNMENT, 1), s(h) && t.context.texStorage2D(t.target, 6, t.internalFormat, t.width, t.height);
    for (let f = 0; f < 6; f++) {
      let T = 0, M = t.width, N = t.height;
      for (; M >= 1 && N >= 1; ) {
        let W = null;
        T <= t.maxLevel && (W = y[6 * T + f]), s(h) ? W != null && t.context.texSubImage2D(t.context.TEXTURE_CUBE_MAP_POSITIVE_X + f, T, 0, 0, M, N, t.format, t.openGLDataType, W) : t.context.texImage2D(t.context.TEXTURE_CUBE_MAP_POSITIVE_X + f, T, t.internalFormat, M, N, 0, t.format, t.openGLDataType, W), T++, M /= 2, N /= 2;
      }
    }
    return t.allocatedGPUMemoryInBytes = t.width * t.height * t.depth * d * t._openGLRenderWindow.getDefaultTextureByteSize(h, t.oglNorm16Ext, t.useHalfFloat), i.deactivate(), !0;
  }, i.createDepthFromRaw = (c, u, d, h) => (i.getOpenGLDataType(d), t.format = t.context.DEPTH_COMPONENT, t._openGLRenderWindow.getWebgl2() ? d === jn.FLOAT ? t.internalFormat = t.context.DEPTH_COMPONENT32F : t.internalFormat = t.context.DEPTH_COMPONENT16 : t.internalFormat = t.context.DEPTH_COMPONENT, !t.internalFormat || !t.format || !t.openGLDataType ? (_0("Failed to determine texture parameters."), !1) : (t.target = t.context.TEXTURE_2D, t.components = 1, t.width = c, t.height = u, t.depth = 1, t.numberOfDimensions = 2, t._openGLRenderWindow.activateTexture(i), i.createTexture(), i.bind(), t.context.pixelStorei(t.context.UNPACK_ALIGNMENT, 1), s(d) ? (t.context.texStorage2D(t.target, 1, t.internalFormat, t.width, t.height), h != null && t.context.texSubImage2D(t.target, 0, 0, 0, t.width, t.height, t.format, t.openGLDataType, h)) : t.context.texImage2D(t.target, 0, t.internalFormat, t.width, t.height, 0, t.format, t.openGLDataType, h), t.generateMipmap && t.context.generateMipmap(t.target), t.allocatedGPUMemoryInBytes = t.width * t.height * t.depth * t.components * t._openGLRenderWindow.getDefaultTextureByteSize(d, t.oglNorm16Ext, t.useHalfFloat), i.deactivate(), !0)), i.create2DFromImage = (c) => {
    if (i.getOpenGLDataType(jn.UNSIGNED_CHAR), i.getInternalFormat(jn.UNSIGNED_CHAR, 4), i.getFormat(jn.UNSIGNED_CHAR, 4), !t.internalFormat || !t.format || !t.openGLDataType)
      return _0("Failed to determine texture parameters."), !1;
    t.target = t.context.TEXTURE_2D, t.components = 4, t.depth = 1, t.numberOfDimensions = 2, t._openGLRenderWindow.activateTexture(i), i.createTexture(), i.bind(), t.context.pixelStorei(t.context.UNPACK_ALIGNMENT, 1);
    const u = !t._openGLRenderWindow.getWebgl2() && (!gy(c.width) || !gy(c.height)), d = document.createElement("canvas");
    d.width = u ? Qo(c.width) : c.width, d.height = u ? Qo(c.height) : c.height, t.width = d.width, t.height = d.height;
    const h = d.getContext("2d");
    h.translate(0, d.height), h.scale(1, -1), h.drawImage(c, 0, 0, c.width, c.height, 0, 0, d.width, d.height);
    const p = d;
    return s(jn.UNSIGNED_CHAR) ? (t.context.texStorage2D(t.target, 1, t.internalFormat, t.width, t.height), p != null && t.context.texSubImage2D(t.target, 0, 0, 0, t.width, t.height, t.format, t.openGLDataType, p)) : t.context.texImage2D(t.target, 0, t.internalFormat, t.width, t.height, 0, t.format, t.openGLDataType, p), t.generateMipmap && t.context.generateMipmap(t.target), t.allocatedGPUMemoryInBytes = t.width * t.height * t.depth * t.components * t._openGLRenderWindow.getDefaultTextureByteSize(jn.UNSIGNED_CHAR, t.oglNorm16Ext, t.useHalfFloat), i.deactivate(), !0;
  };
  function r(c, u, d) {
    const h = new Array(d), p = new Array(d);
    for (let m = 0; m < d; ++m)
      h[m] = c[m], p[m] = u[m] - c[m] || 1;
    return {
      scale: p,
      offset: h
    };
  }
  function a(c, u) {
    for (let d = 0; d < c.length; d++) {
      const h = c[d], p = u[d] + h;
      if (h < -2048 || h > 2048 || p < -2048 || p > 2048)
        return !1;
    }
    return !0;
  }
  function o(c, u, d, h) {
    i.getOpenGLDataType(c);
    let p = !1;
    if (t._openGLRenderWindow.getWebgl2())
      p = t.openGLDataType === t.context.HALF_FLOAT;
    else {
      const b = t.context.getExtension("OES_texture_half_float");
      p = b && t.openGLDataType === b.HALF_FLOAT_OES;
    }
    const m = p && (a(u, d) || h);
    t.useHalfFloat = m;
  }
  function l(c, u) {
    const d = c.getNumberOfComponents(), h = c.getDataType(), p = c.getData(), m = new Array(d), b = new Array(d);
    for (let Z = 0; Z < d; ++Z) {
      const [g, f] = c.getRange(Z);
      m[Z] = g, b[Z] = f;
    }
    const y = r(m, b, d);
    return o(h, y.offset, y.scale, u), t.useHalfFloat || i.getOpenGLDataType(h, !0), {
      numComps: d,
      dataType: h,
      data: p,
      scaleOffsets: y
    };
  }
  i.create2DFilterableFromRaw = function(c, u, d, h, p) {
    let m = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1;
    return i.create2DFilterableFromDataArray(c, u, We.newInstance({
      numberOfComponents: d,
      dataType: h,
      values: p
    }), m);
  }, i.create2DFilterableFromDataArray = function(c, u, d) {
    let h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
    const {
      numComps: p,
      dataType: m,
      data: b
    } = l(d, h);
    i.create2DFromRaw(c, u, p, m, b);
  }, i.create3DFromRaw = (c, u, d, h, p, m) => {
    if (i.getOpenGLDataType(p), i.getInternalFormat(p, h), i.getFormat(p, h), !t.internalFormat || !t.format || !t.openGLDataType)
      return _0("Failed to determine texture parameters."), !1;
    t.target = t.context.TEXTURE_3D, t.components = h, t.width = c, t.height = u, t.depth = d, t.numberOfDimensions = 3, t._openGLRenderWindow.activateTexture(i), i.createTexture(), i.bind();
    const Z = e(p, [m], !0), g = n(Z);
    return t.context.pixelStorei(t.context.UNPACK_ALIGNMENT, 1), s(p) ? (t.context.texStorage3D(t.target, 1, t.internalFormat, t.width, t.height, t.depth), g[0] != null && t.context.texSubImage3D(t.target, 0, 0, 0, 0, t.width, t.height, t.depth, t.format, t.openGLDataType, g[0])) : t.context.texImage3D(t.target, 0, t.internalFormat, t.width, t.height, t.depth, 0, t.format, t.openGLDataType, g[0]), t.generateMipmap && t.context.generateMipmap(t.target), t.allocatedGPUMemoryInBytes = t.width * t.height * t.depth * t.components * t._openGLRenderWindow.getDefaultTextureByteSize(p, t.oglNorm16Ext, t.useHalfFloat), i.deactivate(), !0;
  }, i.create3DFilterableFromRaw = function(c, u, d, h, p, m) {
    let b = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : !1;
    return i.create3DFilterableFromDataArray(c, u, d, We.newInstance({
      numberOfComponents: h,
      dataType: p,
      values: m
    }), b);
  }, i.create3DFilterableFromDataArray = function(c, u, d, h) {
    let p = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
    const {
      numComps: m,
      dataType: b,
      data: y,
      scaleOffsets: Z
    } = l(h, p), g = c * u * d, f = [], T = [];
    for (let A = 0; A < m; ++A)
      f[A] = 0, T[A] = 1;
    t.volumeInfo = {
      scale: T,
      offset: f,
      dataComputedScale: Z.scale,
      dataComputedOffset: Z.offset,
      width: c,
      height: u,
      depth: d
    };
    const M = structuredClone(Z);
    if (t._openGLRenderWindow.getWebgl2()) {
      if (t.oglNorm16Ext && !t.useHalfFloat && b === jn.SHORT) {
        for (let at = 0; at < m; ++at)
          t.volumeInfo.scale[at] = 32767;
        return i.create3DFromRaw(c, u, d, m, b, y);
      }
      if (t.oglNorm16Ext && !t.useHalfFloat && b === jn.UNSIGNED_SHORT) {
        for (let at = 0; at < m; ++at)
          t.volumeInfo.scale[at] = 65535;
        return i.create3DFromRaw(c, u, d, m, b, y);
      }
      if (b === jn.FLOAT || t.useHalfFloat && (b === jn.SHORT || b === jn.UNSIGNED_SHORT))
        return i.create3DFromRaw(c, u, d, m, b, y);
      if (b === jn.UNSIGNED_CHAR) {
        for (let at = 0; at < m; ++at)
          t.volumeInfo.scale[at] = 255;
        return i.create3DFromRaw(c, u, d, m, b, y);
      }
      const A = new Float32Array(g * m);
      t.volumeInfo.offset = M.offset, t.volumeInfo.scale = M.scale;
      let E = 0;
      const ct = M.scale.map((at) => 1 / at);
      for (let at = 0; at < g; at++)
        for (let dt = 0; dt < m; dt++)
          A[E] = (y[E] - M.offset[dt]) * ct[dt], E++;
      return i.create3DFromRaw(c, u, d, m, jn.FLOAT, A);
    }
    let N = (A, E, ct, at, dt) => {
      A[E] = ct;
    }, W = jn.UNSIGNED_CHAR;
    if (b === jn.UNSIGNED_CHAR)
      for (let A = 0; A < m; ++A)
        M.offset[A] = 0, M.scale[A] = 255;
    else t.context.getExtension("OES_texture_float") && t.context.getExtension("OES_texture_float_linear") ? (W = jn.FLOAT, N = (A, E, ct, at, dt) => {
      A[E] = (ct - at) / dt;
    }) : (W = jn.UNSIGNED_CHAR, N = (A, E, ct, at, dt) => {
      A[E] = 255 * (ct - at) / dt;
    });
    if (i.getOpenGLDataType(W), i.getInternalFormat(W, m), i.getFormat(W, m), !t.internalFormat || !t.format || !t.openGLDataType)
      return _0("Failed to determine texture parameters."), !1;
    t.target = t.context.TEXTURE_2D, t.components = m, t.depth = 1, t.numberOfDimensions = 2;
    let x = t.context.getParameter(t.context.MAX_TEXTURE_SIZE);
    x > 4096 && (W === jn.FLOAT || m >= 3) && (x = 4096);
    let V = 1, X = 1;
    g > x * x && (V = Math.ceil(Math.sqrt(g / (x * x))), X = V);
    let C = Math.sqrt(g) / V;
    C = Qo(C);
    const R = Math.floor(C * V / c), z = Math.ceil(d / R), F = Qo(u * z / X);
    t.width = C, t.height = F, t._openGLRenderWindow.activateTexture(i), i.createTexture(), i.bind(), t.volumeInfo.xreps = R, t.volumeInfo.yreps = z, t.volumeInfo.xstride = V, t.volumeInfo.ystride = X, t.volumeInfo.offset = M.offset, t.volumeInfo.scale = M.scale;
    let P;
    const j = C * F * m;
    W === jn.FLOAT ? P = new Float32Array(j) : P = new Uint8Array(j);
    let H = 0;
    const B = Math.floor(c / V), $ = Math.floor(u / X);
    for (let A = 0; A < z; A++) {
      const E = Math.min(R, d - A * R), ct = m * (t.width - E * Math.floor(c / V));
      for (let at = 0; at < $; at++) {
        for (let dt = 0; dt < E; dt++) {
          const gt = m * ((A * R + dt) * c * u + X * at * c);
          for (let Wt = 0; Wt < B; Wt++)
            for (let Zt = 0; Zt < m; Zt++)
              N(P, H, y[gt + V * Wt * m + Zt], M.offset[Zt], M.scale[Zt]), H++;
        }
        H += ct;
      }
    }
    return t.context.pixelStorei(t.context.UNPACK_ALIGNMENT, 1), s(W) ? (t.context.texStorage2D(t.target, 1, t.internalFormat, t.width, t.height), P != null && t.context.texSubImage2D(t.target, 0, 0, 0, t.width, t.height, t.format, t.openGLDataType, P)) : t.context.texImage2D(t.target, 0, t.internalFormat, t.width, t.height, 0, t.format, t.openGLDataType, P), i.deactivate(), !0;
  }, i.setOpenGLRenderWindow = (c) => {
    t._openGLRenderWindow !== c && (i.releaseGraphicsResources(), t._openGLRenderWindow = c, t.context = null, c && (t.context = t._openGLRenderWindow.getContext()));
  }, i.getMaximumTextureSize = (c) => c && c.isCurrent() ? c.getIntegerv(c.MAX_TEXTURE_SIZE) : -1;
}
const Dst = {
  _openGLRenderWindow: null,
  _forceInternalFormat: !1,
  context: null,
  handle: 0,
  sendParametersTime: null,
  textureBuildTime: null,
  numberOfDimensions: 0,
  target: 0,
  format: 0,
  openGLDataType: 0,
  components: 0,
  width: 0,
  height: 0,
  depth: 0,
  autoParameters: !0,
  wrapS: hu.CLAMP_TO_EDGE,
  wrapT: hu.CLAMP_TO_EDGE,
  wrapR: hu.CLAMP_TO_EDGE,
  minificationFilter: Nr.NEAREST,
  magnificationFilter: Nr.NEAREST,
  minLOD: -1e3,
  maxLOD: 1e3,
  baseLevel: 0,
  maxLevel: 1e3,
  generateMipmap: !1,
  // use half float by default, but it will get set
  // to false if the context does not support it or
  // the voxel intensity range is out of the accurate
  // range of half float
  useHalfFloat: !0,
  oglNorm16Ext: null,
  allocatedGPUMemoryInBytes: 0
};
function Q9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Dst, e), ui.extend(i, t, e), t.sendParametersTime = {}, xi(t.sendParametersTime, {
    mtime: 0
  }), t.textureBuildTime = {}, xi(t.textureBuildTime, {
    mtime: 0
  }), GT(i, t, ["format", "openGLDataType"]), gs(i, t, ["keyMatrixTime", "minificationFilter", "magnificationFilter", "wrapS", "wrapT", "wrapR", "generateMipmap", "oglNorm16Ext"]), Sa(i, t, ["width", "height", "volumeInfo", "components", "handle", "target", "allocatedGPUMemoryInBytes"]), wT(i, t, ["openGLRenderWindow"]), Rst(i, t);
}
const $9 = In(Q9, "vtkOpenGLTexture");
var bs = {
  newInstance: $9,
  extend: Q9,
  ...H9
};
Js("vtkTexture", $9);
var EI = `//VTK::System::Dec

/*=========================================================================

  Program:   Visualization Toolkit
  Module:    vtkPolyDataVS.glsl

  Copyright (c) Ken Martin, Will Schroeder, Bill Lorensen
  All rights reserved.
  See Copyright.txt or http://www.kitware.com/Copyright.htm for details.

     This software is distributed WITHOUT ANY WARRANTY; without even
     the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR
     PURPOSE.  See the above copyright notice for more information.

=========================================================================*/

attribute vec4 vertexMC;

// frag position in VC
//VTK::PositionVC::Dec

// optional normal declaration
//VTK::Normal::Dec

// extra lighting parameters
//VTK::Light::Dec

// Texture coordinates
//VTK::TCoord::Dec

// material property values
//VTK::Color::Dec

// clipping plane vars
//VTK::Clip::Dec

// camera and actor matrix values
//VTK::Camera::Dec

// Apple Bug
//VTK::PrimID::Dec

// picking support
//VTK::Picking::Dec

void main()
{
  //VTK::Color::Impl

  //VTK::Normal::Impl

  //VTK::TCoord::Impl

  //VTK::Clip::Impl

  //VTK::PrimID::Impl

  //VTK::PositionVC::Impl

  //VTK::Light::Impl

  //VTK::Picking::Impl
}
`, IT = `//VTK::System::Dec

/*=========================================================================

  Program:   Visualization Toolkit
  Module:    vtkPolyDataFS.glsl

  Copyright (c) Ken Martin, Will Schroeder, Bill Lorensen
  All rights reserved.
  See Copyright.txt or http://www.kitware.com/Copyright.htm for details.

     This software is distributed WITHOUT ANY WARRANTY; without even
     the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR
     PURPOSE.  See the above copyright notice for more information.

=========================================================================*/
// Template for the polydata mappers fragment shader

uniform int PrimitiveIDOffset;

// VC position of this fragment
//VTK::PositionVC::Dec

// optional color passed in from the vertex shader, vertexColor
//VTK::Color::Dec

// optional surface normal declaration
//VTK::Normal::Dec

// extra lighting parameters
//VTK::Light::Dec

// define vtkImageLabelOutlineOn
//VTK::ImageLabelOutlineOn

// Texture coordinates
//VTK::TCoord::Dec

// picking support
//VTK::Picking::Dec

// Depth Peeling Support
//VTK::DepthPeeling::Dec

// clipping plane vars
//VTK::Clip::Dec

// label outline 
//VTK::LabelOutline::Dec

// the output of this shader
//VTK::Output::Dec

// Apple Bug
//VTK::PrimID::Dec

// handle coincident offsets
//VTK::Coincident::Dec

//VTK::ZBuffer::Dec

//VTK::LabelOutlineHelperFunction

void main()
{
  // VC position of this fragment. This should not branch/return/discard.
  //VTK::PositionVC::Impl

  // Place any calls that require uniform flow (e.g. dFdx) here.
  //VTK::UniformFlow::Impl

  // Set gl_FragDepth here (gl_FragCoord.z by default)
  //VTK::Depth::Impl

  // Early depth peeling abort:
  //VTK::DepthPeeling::PreColor

  // Apple Bug
  //VTK::PrimID::Impl

  //VTK::Clip::Impl

  //VTK::Color::Impl

  // Generate the normal if we are not passed in one
  //VTK::Normal::Impl

  //VTK::TCoord::Impl

  //VTK::Light::Impl

  if (gl_FragData[0].a <= 0.0)
    {
    discard;
    }

  //VTK::DepthPeeling::Impl

  //VTK::Picking::Impl

  // handle coincident offsets
  //VTK::Coincident::Impl

  //VTK::ZBuffer::Impl

  //VTK::RenderPassFragmentShader::Impl
}
`;
function Ost(i, t) {
  i.replaceShaderCoincidentOffset = (e, n, s) => {
    const r = i.getCoincidentParameters(n, s);
    if (r && (r.factor !== 0 || r.offset !== 0)) {
      let a = e.Fragment;
      a = Ft.substitute(a, "//VTK::Coincident::Dec", ["uniform float cfactor;", "uniform float coffset;"]).result, t.context.getExtension("EXT_frag_depth") && (r.factor !== 0 ? (a = Ft.substitute(a, "//VTK::UniformFlow::Impl", ["float cscale = length(vec2(dFdx(gl_FragCoord.z),dFdy(gl_FragCoord.z)));", "//VTK::UniformFlow::Impl"], !1).result, a = Ft.substitute(a, "//VTK::Depth::Impl", "gl_FragDepthEXT = gl_FragCoord.z + cfactor*cscale + 0.000016*coffset;").result) : a = Ft.substitute(a, "//VTK::Depth::Impl", "gl_FragDepthEXT = gl_FragCoord.z + 0.000016*coffset;").result), t._openGLRenderWindow.getWebgl2() && (r.factor !== 0 ? (a = Ft.substitute(a, "//VTK::UniformFlow::Impl", ["float cscale = length(vec2(dFdx(gl_FragCoord.z),dFdy(gl_FragCoord.z)));", "//VTK::UniformFlow::Impl"], !1).result, a = Ft.substitute(a, "//VTK::Depth::Impl", "gl_FragDepth = gl_FragCoord.z + cfactor*cscale + 0.000016*coffset;").result) : a = Ft.substitute(a, "//VTK::Depth::Impl", "gl_FragDepth = gl_FragCoord.z + 0.000016*coffset;").result), e.Fragment = a;
    }
  };
}
function zst(i, t) {
  i.applyShaderReplacements = (e, n, s) => {
    let r = null;
    if (n && (r = n.ShaderReplacements), r)
      for (let a = 0; a < r.length; a++) {
        const o = r[a];
        if (s && o.replaceFirst || !s && !o.replaceFirst) {
          const l = o.shaderType, c = e[l], u = Ft.substitute(c, o.originalValue, o.replacementValue, o.replaceAll);
          e[l] = u.result;
        }
      }
  }, i.buildShaders = (e, n, s) => {
    i.getReplacedShaderTemplate(e, n, s), t.lastRenderPassShaderReplacement = t.currentRenderPass ? t.currentRenderPass.getShaderReplacement() : null, t.lastRenderPassShaderReplacement && t.lastRenderPassShaderReplacement(e);
    const r = t.renderable.getViewSpecificProperties().OpenGL;
    i.applyShaderReplacements(e, r, !0), i.replaceShaderValues(e, n, s), i.applyShaderReplacements(e, r);
  }, i.getReplacedShaderTemplate = (e, n, s) => {
    const r = t.renderable.getViewSpecificProperties().OpenGL;
    i.getShaderTemplate(e, n, s);
    let a = e.Vertex;
    if (r) {
      const c = r.VertexShaderCode;
      c !== void 0 && c !== "" && (a = c);
    }
    e.Vertex = a;
    let o = e.Fragment;
    if (r) {
      const c = r.FragmentShaderCode;
      c !== void 0 && c !== "" && (o = c);
    }
    e.Fragment = o;
    let l = e.Geometry;
    if (r) {
      const c = r.GeometryShaderCode;
      c !== void 0 && (l = c);
    }
    e.Geometry = l;
  };
}
var kc = {
  implementReplaceShaderCoincidentOffset: Ost,
  implementBuildShadersWithReplacements: zst
};
const {
  FieldAssociations: zx
} = Vg, {
  primTypes: Qs
} = Jc, {
  Representation: Q0,
  Shading: eO
} = V0, {
  ScalarMode: $1
} = Ue, {
  Filter: nO,
  Wrap: iO
} = bs, {
  vtkErrorMacro: Tp
} = kr, Est = {
  type: "StartEvent"
}, kst = {
  type: "EndEvent"
}, {
  CoordinateSystem: Fst
} = np;
function jst(i) {
  const t = i.getSelector();
  return t ? t.getCurrentPass() : Es.MIN_KNOWN_PASS - 1;
}
function Ust(i, t) {
  t.classHierarchy.push("vtkOpenGLPolyDataMapper"), i.buildPass = (n) => {
    n && (t.currentRenderPass = null, t.openGLActor = i.getFirstAncestorOfType("vtkOpenGLActor"), t._openGLRenderer = t.openGLActor.getFirstAncestorOfType("vtkOpenGLRenderer"), t._openGLRenderWindow = t._openGLRenderer.getParent(), t.openGLCamera = t._openGLRenderer.getViewNodeFor(t._openGLRenderer.getRenderable().getActiveCamera()));
  }, i.translucentPass = (n, s) => {
    n && (t.currentRenderPass = s, i.render());
  }, i.zBufferPass = (n) => {
    n && (t.haveSeenDepthRequest = !0, t.renderDepth = !0, i.render(), t.renderDepth = !1);
  }, i.opaqueZBufferPass = (n) => i.zBufferPass(n), i.opaquePass = (n) => {
    n && i.render();
  }, i.render = () => {
    const n = t._openGLRenderWindow.getContext();
    if (t.context !== n) {
      t.context = n;
      for (let a = Qs.Start; a < Qs.End; a++)
        t.primitives[a].setOpenGLRenderWindow(t._openGLRenderWindow);
    }
    const s = t.openGLActor.getRenderable(), r = t._openGLRenderer.getRenderable();
    i.renderPiece(r, s);
  }, i.getShaderTemplate = (n, s, r) => {
    n.Vertex = EI, n.Fragment = IT, n.Geometry = "";
  }, i.replaceShaderColor = (n, s, r) => {
    let a = n.Vertex, o = n.Geometry, l = n.Fragment;
    const c = t.lastBoundBO.getReferenceByName("lastLightComplexity");
    let u = ["uniform float ambient;", "uniform float diffuse;", "uniform float specular;", "uniform float opacityUniform; // the fragment opacity", "uniform vec3 ambientColorUniform;", "uniform vec3 diffuseColorUniform;"];
    c && (u = u.concat(["uniform vec3 specularColorUniform;", "uniform float specularPowerUniform;"]));
    let d = ["vec3 ambientColor;", "  vec3 diffuseColor;", "  float opacity;"];
    c && (d = d.concat(["  vec3 specularColor;", "  float specularPower;"])), d = d.concat(["  ambientColor = ambientColorUniform;", "  diffuseColor = diffuseColorUniform;", "  opacity = opacityUniform;"]), c && (d = d.concat(["  specularColor = specularColorUniform;", "  specularPower = specularPowerUniform;"])), t.lastBoundBO.getCABO().getColorComponents() !== 0 && !t.drawingEdges && (u = u.concat(["varying vec4 vertexColorVSOutput;"]), a = Ft.substitute(a, "//VTK::Color::Dec", ["attribute vec4 scalarColor;", "varying vec4 vertexColorVSOutput;"]).result, a = Ft.substitute(a, "//VTK::Color::Impl", ["vertexColorVSOutput =  scalarColor;"]).result, o = Ft.substitute(o, "//VTK::Color::Dec", ["in vec4 vertexColorVSOutput[];", "out vec4 vertexColorGSOutput;"]).result, o = Ft.substitute(o, "//VTK::Color::Impl", ["vertexColorGSOutput = vertexColorVSOutput[i];"]).result), t.lastBoundBO.getCABO().getColorComponents() !== 0 && !t.drawingEdges ? l = Ft.substitute(l, "//VTK::Color::Impl", d.concat(["  diffuseColor = vertexColorVSOutput.rgb;", "  ambientColor = vertexColorVSOutput.rgb;", "  opacity = opacity*vertexColorVSOutput.a;"])).result : t.renderable.getInterpolateScalarsBeforeMapping() && t.renderable.getColorCoordinates() && !t.drawingEdges ? l = Ft.substitute(l, "//VTK::Color::Impl", d.concat(["  vec4 texColor = texture2D(texture1, tcoordVCVSOutput.st);", "  diffuseColor = texColor.rgb;", "  ambientColor = texColor.rgb;", "  opacity = opacity*texColor.a;"])).result : (r.getBackfaceProperty() && !t.drawingEdges && (u = u.concat(["uniform float opacityUniformBF; // the fragment opacity", "uniform float ambientIntensityBF; // the material ambient", "uniform float diffuseIntensityBF; // the material diffuse", "uniform vec3 ambientColorUniformBF; // ambient material color", "uniform vec3 diffuseColorUniformBF; // diffuse material color"]), c ? (u = u.concat(["uniform float specularIntensityBF; // the material specular intensity", "uniform vec3 specularColorUniformBF; // intensity weighted color", "uniform float specularPowerUniformBF;"]), d = d.concat(["if (gl_FrontFacing == false) {", "  ambientColor = ambientIntensityBF * ambientColorUniformBF;", "  diffuseColor = diffuseIntensityBF * diffuseColorUniformBF;", "  specularColor = specularIntensityBF * specularColorUniformBF;", "  specularPower = specularPowerUniformBF;", "  opacity = opacityUniformBF; }"])) : d = d.concat(["if (gl_FrontFacing == false) {", "  ambientColor = ambientIntensityBF * ambientColorUniformBF;", "  diffuseColor = diffuseIntensityBF * diffuseColorUniformBF;", "  opacity = opacityUniformBF; }"])), t.haveCellScalars && !t.drawingEdges && (u = u.concat(["uniform samplerBuffer texture1;"])), l = Ft.substitute(l, "//VTK::Color::Impl", d).result), l = Ft.substitute(l, "//VTK::Color::Dec", u).result, n.Vertex = a, n.Geometry = o, n.Fragment = l;
  }, i.replaceShaderLight = (n, s, r) => {
    let a = n.Fragment;
    const o = "", l = t.lastBoundBO.getReferenceByName("lastLightComplexity"), c = t.lastBoundBO.getReferenceByName("lastLightCount");
    let u = [];
    switch (l) {
      case 0:
        a = Ft.substitute(a, "//VTK::Light::Impl", ["  gl_FragData[0] = vec4(ambientColor * ambient + diffuseColor * diffuse, opacity);", "  //VTK::Light::Impl"], !1).result;
        break;
      case 1:
        a = Ft.substitute(a, "//VTK::Light::Impl", ["  float df = max(0.0, normalVCVSOutput.z);", "  float sf = pow(df, specularPower);", "  vec3 diffuseL = df * diffuseColor;", "  vec3 specularL = sf * specularColor;", "  gl_FragData[0] = vec4(ambientColor * ambient + diffuseL * diffuse + specularL * specular, opacity);", "  //VTK::Light::Impl"], !1).result;
        break;
      case 2:
        for (let d = 0; d < c; ++d)
          u = u.concat([`uniform vec3 lightColor${d};`, `uniform vec3 lightDirectionVC${d}; // normalized`, `uniform vec3 lightHalfAngleVC${d}; // normalized`]);
        a = Ft.substitute(a, "//VTK::Light::Dec", u).result, u = ["vec3 diffuseL = vec3(0,0,0);", "  vec3 specularL = vec3(0,0,0);", "  float df;"];
        for (let d = 0; d < c; ++d)
          u = u.concat([`  df = max(0.0, dot(normalVCVSOutput, -lightDirectionVC${d}));`, `  diffuseL += ((df${o}) * lightColor${d});`, `  if (dot(normalVCVSOutput, lightDirectionVC${d}) < 0.0)`, "    {", `    float sf = sign(df)*pow(max(1e-5,
                                              dot(reflect(lightDirectionVC${d},normalVCVSOutput),
                                                  normalize(-vertexVC.xyz))),
                                         specularPower);`, `    specularL += (sf${o} * lightColor${d});`, "    }"]);
        u = u.concat(["  diffuseL = diffuseL * diffuseColor;", "  specularL = specularL * specularColor;", "  gl_FragData[0] = vec4(ambientColor * ambient + diffuseL * diffuse + specularL * specular, opacity);", "  //VTK::Light::Impl"]), a = Ft.substitute(a, "//VTK::Light::Impl", u, !1).result;
        break;
      case 3:
        for (let d = 0; d < c; ++d)
          u = u.concat([`uniform vec3 lightColor${d};`, `uniform vec3 lightDirectionVC${d}; // normalized`, `uniform vec3 lightHalfAngleVC${d}; // normalized`, `uniform vec3 lightPositionVC${d};`, `uniform vec3 lightAttenuation${d};`, `uniform float lightConeAngle${d};`, `uniform float lightExponent${d};`, `uniform int lightPositional${d};`]);
        a = Ft.substitute(a, "//VTK::Light::Dec", u).result, u = ["vec3 diffuseL = vec3(0,0,0);", "  vec3 specularL = vec3(0,0,0);", "  vec3 vertLightDirectionVC;", "  float attenuation;", "  float df;"];
        for (let d = 0; d < c; ++d)
          u = u.concat(["  attenuation = 1.0;", `  if (lightPositional${d} == 0)`, "    {", `      vertLightDirectionVC = lightDirectionVC${d};`, "    }", "  else", "    {", `    vertLightDirectionVC = vertexVC.xyz - lightPositionVC${d};`, "    float distanceVC = length(vertLightDirectionVC);", "    vertLightDirectionVC = normalize(vertLightDirectionVC);", "    attenuation = 1.0 /", `      (lightAttenuation${d}.x`, `       + lightAttenuation${d}.y * distanceVC`, `       + lightAttenuation${d}.z * distanceVC * distanceVC);`, "    // per OpenGL standard cone angle is 90 or less for a spot light", `    if (lightConeAngle${d} <= 90.0)`, "      {", `      float coneDot = dot(vertLightDirectionVC, lightDirectionVC${d});`, "      // if inside the cone", `      if (coneDot >= cos(radians(lightConeAngle${d})))`, "        {", `        attenuation = attenuation * pow(coneDot, lightExponent${d});`, "        }", "      else", "        {", "        attenuation = 0.0;", "        }", "      }", "    }", "    df = max(0.0, attenuation*dot(normalVCVSOutput, -vertLightDirectionVC));", `    diffuseL += ((df${o}) * lightColor${d});`, "    if (dot(normalVCVSOutput, vertLightDirectionVC) < 0.0)", "      {", `      float sf = sign(df)*attenuation*pow(max(1e-5,
                                                           dot(reflect(lightDirectionVC${d},
                                                                       normalVCVSOutput),
                                                               normalize(-vertexVC.xyz))),
                                                       specularPower);`, `    specularL += ((sf${o}) * lightColor${d});`, "    }"]);
        u = u.concat(["  diffuseL = diffuseL * diffuseColor;", "  specularL = specularL * specularColor;", "  gl_FragData[0] = vec4(ambientColor * ambient + diffuseL * diffuse + specularL * specular, opacity);", "  //VTK::Light::Impl"]), a = Ft.substitute(a, "//VTK::Light::Impl", u, !1).result;
        break;
      default:
        Tp("bad light complexity");
    }
    n.Fragment = a;
  }, i.replaceShaderNormal = (n, s, r) => {
    if (t.lastBoundBO.getReferenceByName("lastLightComplexity") > 0) {
      let o = n.Vertex, l = n.Geometry, c = n.Fragment;
      t.lastBoundBO.getCABO().getNormalOffset() ? (o = Ft.substitute(o, "//VTK::Normal::Dec", ["attribute vec3 normalMC;", "uniform mat3 normalMatrix;", "varying vec3 normalVCVSOutput;"]).result, o = Ft.substitute(o, "//VTK::Normal::Impl", ["normalVCVSOutput = normalMatrix * normalMC;"]).result, l = Ft.substitute(l, "//VTK::Normal::Dec", ["in vec3 normalVCVSOutput[];", "out vec3 normalVCGSOutput;"]).result, l = Ft.substitute(l, "//VTK::Normal::Impl", ["normalVCGSOutput = normalVCVSOutput[i];"]).result, c = Ft.substitute(c, "//VTK::Normal::Dec", ["varying vec3 normalVCVSOutput;"]).result, c = Ft.substitute(c, "//VTK::Normal::Impl", [
        "vec3 normalVCVSOutput = normalize(normalVCVSOutput);",
        //  if (!gl_FrontFacing) does not work in intel hd4000 mac
        //  if (int(gl_FrontFacing) == 0) does not work on mesa
        "  if (gl_FrontFacing == false) { normalVCVSOutput = -normalVCVSOutput; }"
      ]).result) : t.haveCellNormals ? (c = Ft.substitute(c, "//VTK::Normal::Dec", ["uniform mat3 normalMatrix;", "uniform samplerBuffer textureN;"]).result, c = Ft.substitute(c, "//VTK::Normal::Impl", ["vec3 normalVCVSOutput = normalize(normalMatrix *", "    texelFetchBuffer(textureN, gl_PrimitiveID + PrimitiveIDOffset).xyz);", "  if (gl_FrontFacing == false) { normalVCVSOutput = -normalVCVSOutput; }"]).result) : t.lastBoundBO.getOpenGLMode(r.getProperty().getRepresentation()) === t.context.LINES ? (c = Ft.substitute(
        c,
        "//VTK::UniformFlow::Impl",
        ["  vec3 fdx = dFdx(vertexVC.xyz);", "  vec3 fdy = dFdy(vertexVC.xyz);", "  //VTK::UniformFlow::Impl"]
        // For further replacements
      ).result, c = Ft.substitute(c, "//VTK::Normal::Impl", ["vec3 normalVCVSOutput;", "  if (abs(fdx.x) > 0.0)", "    { fdx = normalize(fdx); normalVCVSOutput = normalize(cross(vec3(fdx.y, -fdx.x, 0.0), fdx)); }", "  else { fdy = normalize(fdy); normalVCVSOutput = normalize(cross(vec3(fdy.y, -fdy.x, 0.0), fdy));}"]).result) : (c = Ft.substitute(c, "//VTK::Normal::Dec", ["uniform int cameraParallel;"]).result, c = Ft.substitute(
        c,
        "//VTK::UniformFlow::Impl",
        [
          // '  vec3 fdx = vec3(dFdx(vertexVC.x),dFdx(vertexVC.y),dFdx(vertexVC.z));',
          // '  vec3 fdy = vec3(dFdy(vertexVC.x),dFdy(vertexVC.y),dFdy(vertexVC.z));',
          "  vec3 fdx = dFdx(vertexVC.xyz);",
          "  vec3 fdy = dFdy(vertexVC.xyz);",
          "  //VTK::UniformFlow::Impl"
        ]
        // For further replacements
      ).result, c = Ft.substitute(c, "//VTK::Normal::Impl", [
        "  fdx = normalize(fdx);",
        "  fdy = normalize(fdy);",
        "  vec3 normalVCVSOutput = normalize(cross(fdx,fdy));",
        // the code below is faster, but does not work on some devices
        // 'vec3 normalVC = normalize(cross(dFdx(vertexVC.xyz), dFdy(vertexVC.xyz)));',
        "  if (cameraParallel == 1 && normalVCVSOutput.z < 0.0) { normalVCVSOutput = -1.0*normalVCVSOutput; }",
        "  if (cameraParallel == 0 && dot(normalVCVSOutput,vertexVC.xyz) > 0.0) { normalVCVSOutput = -1.0*normalVCVSOutput; }"
      ]).result), n.Vertex = o, n.Geometry = l, n.Fragment = c;
    }
  }, i.replaceShaderPositionVC = (n, s, r) => {
    t.lastBoundBO.replaceShaderPositionVC(n, s, r);
    let a = n.Vertex, o = n.Geometry, l = n.Fragment;
    t.lastBoundBO.getReferenceByName("lastLightComplexity") > 0 ? (a = Ft.substitute(a, "//VTK::PositionVC::Dec", ["varying vec4 vertexVCVSOutput;"]).result, a = Ft.substitute(a, "//VTK::PositionVC::Impl", ["vertexVCVSOutput = MCVCMatrix * vertexMC;", "  gl_Position = MCPCMatrix * vertexMC;"]).result, a = Ft.substitute(a, "//VTK::Camera::Dec", ["uniform mat4 MCPCMatrix;", "uniform mat4 MCVCMatrix;"]).result, o = Ft.substitute(o, "//VTK::PositionVC::Dec", ["in vec4 vertexVCVSOutput[];", "out vec4 vertexVCGSOutput;"]).result, o = Ft.substitute(o, "//VTK::PositionVC::Impl", ["vertexVCGSOutput = vertexVCVSOutput[i];"]).result, l = Ft.substitute(l, "//VTK::PositionVC::Dec", ["varying vec4 vertexVCVSOutput;"]).result, l = Ft.substitute(l, "//VTK::PositionVC::Impl", ["vec4 vertexVC = vertexVCVSOutput;"]).result) : (a = Ft.substitute(a, "//VTK::Camera::Dec", ["uniform mat4 MCPCMatrix;"]).result, a = Ft.substitute(a, "//VTK::PositionVC::Impl", ["  gl_Position = MCPCMatrix * vertexMC;"]).result), n.Vertex = a, n.Geometry = o, n.Fragment = l;
  }, i.replaceShaderTCoord = (n, s, r) => {
    if (t.lastBoundBO.getCABO().getTCoordOffset()) {
      let a = n.Vertex, o = n.Geometry, l = n.Fragment;
      if (t.drawingEdges)
        return;
      a = Ft.substitute(a, "//VTK::TCoord::Impl", "tcoordVCVSOutput = tcoordMC;").result;
      const c = t.openGLActor.getActiveTextures();
      let u = 2, d = 2;
      if (c && c.length > 0 && (u = c[0].getComponents(), c[0].getTarget() === t.context.TEXTURE_CUBE_MAP && (d = 3)), t.renderable.getColorTextureMap() && (u = t.renderable.getColorTextureMap().getPointData().getScalars().getNumberOfComponents(), d = 2), d === 2) {
        if (a = Ft.substitute(a, "//VTK::TCoord::Dec", "attribute vec2 tcoordMC; varying vec2 tcoordVCVSOutput;").result, o = Ft.substitute(o, "//VTK::TCoord::Dec", ["in vec2 tcoordVCVSOutput[];", "out vec2 tcoordVCGSOutput;"]).result, o = Ft.substitute(o, "//VTK::TCoord::Impl", "tcoordVCGSOutput = tcoordVCVSOutput[i];").result, l = Ft.substitute(l, "//VTK::TCoord::Dec", ["varying vec2 tcoordVCVSOutput;", "uniform sampler2D texture1;"]).result, c && c.length >= 1)
          switch (u) {
            case 1:
              l = Ft.substitute(l, "//VTK::TCoord::Impl", ["  vec4 tcolor = texture2D(texture1, tcoordVCVSOutput);", "  ambientColor = ambientColor*tcolor.r;", "  diffuseColor = diffuseColor*tcolor.r;"]).result;
              break;
            case 2:
              l = Ft.substitute(l, "//VTK::TCoord::Impl", ["  vec4 tcolor = texture2D(texture1, tcoordVCVSOutput);", "  ambientColor = ambientColor*tcolor.r;", "  diffuseColor = diffuseColor*tcolor.r;", "  opacity = opacity * tcolor.g;"]).result;
              break;
            default:
              l = Ft.substitute(l, "//VTK::TCoord::Impl", ["  vec4 tcolor = texture2D(texture1, tcoordVCVSOutput);", "  ambientColor = ambientColor*tcolor.rgb;", "  diffuseColor = diffuseColor*tcolor.rgb;", "  opacity = opacity * tcolor.a;"]).result;
          }
      } else
        switch (a = Ft.substitute(a, "//VTK::TCoord::Dec", "attribute vec3 tcoordMC; varying vec3 tcoordVCVSOutput;").result, o = Ft.substitute(o, "//VTK::TCoord::Dec", ["in vec3 tcoordVCVSOutput[];", "out vec3 tcoordVCGSOutput;"]).result, o = Ft.substitute(o, "//VTK::TCoord::Impl", "tcoordVCGSOutput = tcoordVCVSOutput[i];").result, l = Ft.substitute(l, "//VTK::TCoord::Dec", ["varying vec3 tcoordVCVSOutput;", "uniform samplerCube texture1;"]).result, u) {
          case 1:
            l = Ft.substitute(l, "//VTK::TCoord::Impl", ["  vec4 tcolor = textureCube(texture1, tcoordVCVSOutput);", "  ambientColor = ambientColor*tcolor.r;", "  diffuseColor = diffuseColor*tcolor.r;"]).result;
            break;
          case 2:
            l = Ft.substitute(l, "//VTK::TCoord::Impl", ["  vec4 tcolor = textureCube(texture1, tcoordVCVSOutput);", "  ambientColor = ambientColor*tcolor.r;", "  diffuseColor = diffuseColor*tcolor.r;", "  opacity = opacity * tcolor.g;"]).result;
            break;
          default:
            l = Ft.substitute(l, "//VTK::TCoord::Impl", ["  vec4 tcolor = textureCube(texture1, tcoordVCVSOutput);", "  ambientColor = ambientColor*tcolor.rgb;", "  diffuseColor = diffuseColor*tcolor.rgb;", "  opacity = opacity * tcolor.a;"]).result;
        }
      n.Vertex = a, n.Geometry = o, n.Fragment = l;
    }
  }, i.replaceShaderClip = (n, s, r) => {
    let a = n.Vertex, o = n.Fragment;
    if (t.renderable.getNumberOfClippingPlanes()) {
      const l = t.renderable.getNumberOfClippingPlanes();
      a = Ft.substitute(a, "//VTK::Clip::Dec", ["uniform int numClipPlanes;", `uniform vec4 clipPlanes[${l}];`, `varying float clipDistancesVSOutput[${l}];`]).result, a = Ft.substitute(a, "//VTK::Clip::Impl", [`for (int planeNum = 0; planeNum < ${l}; planeNum++)`, "    {", "    if (planeNum >= numClipPlanes)", "        {", "        break;", "        }", "    clipDistancesVSOutput[planeNum] = dot(clipPlanes[planeNum], vertexMC);", "    }"]).result, o = Ft.substitute(o, "//VTK::Clip::Dec", ["uniform int numClipPlanes;", `varying float clipDistancesVSOutput[${l}];`]).result, o = Ft.substitute(o, "//VTK::Clip::Impl", [`for (int planeNum = 0; planeNum < ${l}; planeNum++)`, "    {", "    if (planeNum >= numClipPlanes)", "        {", "        break;", "        }", "    if (clipDistancesVSOutput[planeNum] < 0.0) discard;", "    }"]).result;
    }
    n.Vertex = a, n.Fragment = o;
  }, i.getCoincidentParameters = (n, s) => {
    let r = {
      factor: 0,
      offset: 0
    };
    const a = s.getProperty();
    if (t.renderable.getResolveCoincidentTopology() || a.getEdgeVisibility() && a.getRepresentation() === Q0.SURFACE) {
      const l = t.lastBoundBO.getPrimitiveType();
      l === Qs.Points || a.getRepresentation() === Q0.POINTS ? r = t.renderable.getCoincidentTopologyPointOffsetParameter() : l === Qs.Lines || a.getRepresentation() === Q0.WIREFRAME ? r = t.renderable.getCoincidentTopologyLineOffsetParameters() : (l === Qs.Tris || l === Qs.TriStrips) && (r = t.renderable.getCoincidentTopologyPolygonOffsetParameters()), (l === Qs.TrisEdges || l === Qs.TriStripsEdges) && (r = t.renderable.getCoincidentTopologyPolygonOffsetParameters(), r.factor /= 2, r.offset /= 2);
    }
    const o = t._openGLRenderer.getSelector();
    return o && o.getFieldAssociation() === zx.FIELD_ASSOCIATION_POINTS && (r.offset -= 2), r;
  }, i.replaceShaderPicking = (n, s, r) => {
    let a = n.Fragment, o = n.Vertex;
    if (a = Ft.substitute(a, "//VTK::Picking::Dec", ["uniform int picking;", "//VTK::Picking::Dec"]).result, !!t._openGLRenderer.getSelector()) {
      switch ((t.lastSelectionState === Es.ID_LOW24 || t.lastSelectionState === Es.ID_HIGH24) && (o = Ft.substitute(o, "//VTK::Picking::Dec", [`flat out int vertexIDVSOutput;
`, `uniform int VertexIDOffset;
`]).result, o = Ft.substitute(o, "//VTK::Picking::Impl", `  vertexIDVSOutput = gl_VertexID + VertexIDOffset;
`).result, a = Ft.substitute(a, "//VTK::Picking::Dec", `flat in int vertexIDVSOutput;
`).result, a = Ft.substitute(a, "//VTK::Picking::Impl", ["  int idx = vertexIDVSOutput;", "//VTK::Picking::Impl"]).result), t.lastSelectionState) {
        case Es.ID_LOW24:
          a = Ft.substitute(a, "//VTK::Picking::Impl", "  gl_FragData[0] = vec4(float(idx%256)/255.0, float((idx/256)%256)/255.0, float((idx/65536)%256)/255.0, 1.0);").result;
          break;
        case Es.ID_HIGH24:
          a = Ft.substitute(a, "//VTK::Picking::Impl", "  gl_FragData[0] = vec4(float(idx)/255.0, 0.0, 0.0, 1.0);").result;
          break;
        default:
          a = Ft.substitute(a, "//VTK::Picking::Dec", "uniform vec3 mapperIndex;").result, a = Ft.substitute(a, "//VTK::Picking::Impl", "  gl_FragData[0] = picking != 0 ? vec4(mapperIndex,1.0) : gl_FragData[0];").result;
      }
      n.Fragment = a, n.Vertex = o;
    }
  }, i.replaceShaderValues = (n, s, r) => {
    if (i.replaceShaderColor(n, s, r), i.replaceShaderNormal(n, s, r), i.replaceShaderLight(n, s, r), i.replaceShaderTCoord(n, s, r), i.replaceShaderPicking(n, s, r), i.replaceShaderClip(n, s, r), i.replaceShaderCoincidentOffset(n, s, r), i.replaceShaderPositionVC(n, s, r), t.haveSeenDepthRequest) {
      let a = n.Fragment;
      a = Ft.substitute(a, "//VTK::ZBuffer::Dec", "uniform int depthRequest;").result, a = Ft.substitute(a, "//VTK::ZBuffer::Impl", ["if (depthRequest == 1) {", "float iz = floor(gl_FragCoord.z*65535.0 + 0.1);", "float rf = floor(iz/256.0)/255.0;", "float gf = mod(iz,256.0)/255.0;", "gl_FragData[0] = vec4(rf, gf, 0.0, 1.0); }"]).result, n.Fragment = a;
    }
  }, i.getNeedToRebuildShaders = (n, s, r) => {
    let a = 0, o = 0;
    const l = n.getPrimitiveType(), c = t.currentInput;
    let u = !1;
    const d = c.getPointData().getNormals(), h = c.getCellData().getNormals(), p = r.getProperty().getInterpolation() === eO.FLAT, m = r.getProperty().getRepresentation(), b = n.getOpenGLMode(m, l);
    if ((b === t.context.TRIANGLES || h && !d || !p && d || !p && b === t.context.LINES) && (u = !0), r.getProperty().getLighting() && u) {
      a = 0;
      const f = s.getLightsByReference();
      for (let T = 0; T < f.length; ++T) {
        const M = f[T];
        M.getSwitch() > 0 && (o++, a === 0 && (a = 1)), a === 1 && (o > 1 || M.getIntensity() !== 1 || !M.lightTypeIsHeadLight()) && (a = 2), a < 3 && M.getPositional() && (a = 3);
      }
    }
    let y = !1;
    const Z = t.lastBoundBO.getReferenceByName("lastLightComplexity"), g = t.lastBoundBO.getReferenceByName("lastLightCount");
    return (Z !== a || g !== o) && (t.lastBoundBO.set({
      lastLightComplexity: a
    }, !0), t.lastBoundBO.set({
      lastLightCount: o
    }, !0), y = !0), (!t.currentRenderPass && t.lastRenderPassShaderReplacement || t.currentRenderPass && t.currentRenderPass.getShaderReplacement() !== t.lastRenderPassShaderReplacement) && (y = !0), t.lastHaveSeenDepthRequest !== t.haveSeenDepthRequest || n.getShaderSourceTime().getMTime() < t.renderable.getMTime() || n.getShaderSourceTime().getMTime() < t.currentInput.getMTime() || n.getShaderSourceTime().getMTime() < t.selectionStateChanged.getMTime() || y ? (t.lastHaveSeenDepthRequest = t.haveSeenDepthRequest, !0) : !1;
  }, i.invokeShaderCallbacks = (n, s, r) => {
    const a = t.renderable.getViewSpecificProperties().ShadersCallbacks;
    a && a.forEach((o) => {
      o.callback(o.userData, n, s, r);
    });
  }, i.setMapperShaderParameters = (n, s, r) => {
    if (n.getProgram().isUniformUsed("PrimitiveIDOffset") && n.getProgram().setUniformi("PrimitiveIDOffset", t.primitiveIDOffset), n.getProgram().isUniformUsed("VertexIDOffset") && n.getProgram().setUniformi("VertexIDOffset", t.vertexIDOffset), n.getCABO().getElementCount() && (t.VBOBuildTime.getMTime() > n.getAttributeUpdateTime().getMTime() || n.getShaderSourceTime().getMTime() > n.getAttributeUpdateTime().getMTime())) {
      const l = t.lastBoundBO.getReferenceByName("lastLightComplexity");
      n.getProgram().isAttributeUsed("vertexMC") && (n.getVAO().addAttributeArray(n.getProgram(), n.getCABO(), "vertexMC", n.getCABO().getVertexOffset(), n.getCABO().getStride(), t.context.FLOAT, 3, !1) || Tp("Error setting vertexMC in shader VAO.")), n.getProgram().isAttributeUsed("normalMC") && n.getCABO().getNormalOffset() && l > 0 ? n.getVAO().addAttributeArray(n.getProgram(), n.getCABO(), "normalMC", n.getCABO().getNormalOffset(), n.getCABO().getStride(), t.context.FLOAT, 3, !1) || Tp("Error setting normalMC in shader VAO.") : n.getVAO().removeAttributeArray("normalMC"), t.renderable.getCustomShaderAttributes().forEach((c, u) => {
        n.getProgram().isAttributeUsed(`${c}MC`) && (n.getVAO().addAttributeArray(n.getProgram(), n.getCABO(), `${c}MC`, n.getCABO().getCustomData()[u].offset, n.getCABO().getStride(), t.context.FLOAT, n.getCABO().getCustomData()[u].components, !1) || Tp(`Error setting ${c}MC in shader VAO.`));
      }), n.getProgram().isAttributeUsed("tcoordMC") && n.getCABO().getTCoordOffset() ? n.getVAO().addAttributeArray(n.getProgram(), n.getCABO(), "tcoordMC", n.getCABO().getTCoordOffset(), n.getCABO().getStride(), t.context.FLOAT, n.getCABO().getTCoordComponents(), !1) || Tp("Error setting tcoordMC in shader VAO.") : n.getVAO().removeAttributeArray("tcoordMC"), n.getProgram().isAttributeUsed("scalarColor") && n.getCABO().getColorComponents() ? n.getVAO().addAttributeArray(n.getProgram(), n.getCABO().getColorBO(), "scalarColor", n.getCABO().getColorOffset(), n.getCABO().getColorBOStride(), t.context.UNSIGNED_BYTE, 4, !0) || Tp("Error setting scalarColor in shader VAO.") : n.getVAO().removeAttributeArray("scalarColor"), n.getAttributeUpdateTime().modified();
    }
    if (t.renderable.getNumberOfClippingPlanes()) {
      const l = t.renderable.getNumberOfClippingPlanes(), c = [], d = n.getCABO().getCoordShiftAndScaleEnabled() ? n.getCABO().getInverseShiftAndScaleMatrix() : null, h = d ? ut.copy(t.tmpMat4, r.getMatrix()) : r.getMatrix();
      d && (ut.transpose(h, h), ut.multiply(h, h, d), ut.transpose(h, h));
      for (let p = 0; p < l; p++) {
        const m = [];
        t.renderable.getClippingPlaneInDataCoords(h, p, m);
        for (let b = 0; b < 4; b++)
          c.push(m[b]);
      }
      n.getProgram().setUniformi("numClipPlanes", l), n.getProgram().setUniform4fv("clipPlanes", c);
    }
    t.internalColorTexture && n.getProgram().isUniformUsed("texture1") && n.getProgram().setUniformi("texture1", t.internalColorTexture.getTextureUnit());
    const a = t.openGLActor.getActiveTextures();
    if (a)
      for (let l = 0; l < a.length; ++l) {
        const u = a[l].getTextureUnit(), d = `texture${u + 1}`;
        n.getProgram().isUniformUsed(d) && n.getProgram().setUniformi(d, u);
      }
    if (t.haveSeenDepthRequest && n.getProgram().setUniformi("depthRequest", t.renderDepth ? 1 : 0), n.getProgram().isUniformUsed("coffset")) {
      const l = i.getCoincidentParameters(s, r);
      n.getProgram().setUniformf("coffset", l.offset), n.getProgram().isUniformUsed("cfactor") && n.getProgram().setUniformf("cfactor", l.factor);
    }
    n.setMapperShaderParameters(s, r, t._openGLRenderer.getTiledSizeAndOrigin());
    const o = t._openGLRenderer.getSelector();
    n.getProgram().setUniform3fArray("mapperIndex", o ? o.getPropColorValue() : [0, 0, 0]), n.getProgram().setUniformi("picking", o ? o.getCurrentPass() + 1 : 0);
  }, i.setLightingShaderParameters = (n, s, r) => {
    const a = t.lastBoundBO.getReferenceByName("lastLightComplexity");
    if (a < 2)
      return;
    const o = n.getProgram();
    let l = 0;
    const c = s.getLightsByReference();
    for (let h = 0; h < c.length; ++h) {
      const p = c[h];
      if (p.getSwitch() > 0) {
        const b = p.getColorByReference(), y = p.getIntensity();
        t.lightColor[0] = b[0] * y, t.lightColor[1] = b[1] * y, t.lightColor[2] = b[2] * y;
        const Z = p.getDirection(), g = s.getActiveCamera().getViewMatrix(), f = [...Z];
        p.lightTypeIsSceneLight() && (f[0] = g[0] * Z[0] + g[1] * Z[1] + g[2] * Z[2], f[1] = g[4] * Z[0] + g[5] * Z[1] + g[6] * Z[2], f[2] = g[8] * Z[0] + g[9] * Z[1] + g[10] * Z[2], Fn(f)), t.lightDirection[0] = f[0], t.lightDirection[1] = f[1], t.lightDirection[2] = f[2], Fn(t.lightDirection), o.setUniform3fArray(`lightColor${l}`, t.lightColor), o.setUniform3fArray(`lightDirectionVC${l}`, t.lightDirection), l++;
      }
    }
    if (a < 3)
      return;
    const d = s.getActiveCamera().getViewMatrix();
    ut.transpose(d, d), l = 0;
    for (let h = 0; h < c.length; ++h) {
      const p = c[h];
      if (p.getSwitch() > 0) {
        const b = p.getTransformedPosition(), y = new Float64Array(3);
        I.transformMat4(y, b, d), o.setUniform3fArray(`lightAttenuation${l}`, p.getAttenuationValuesByReference()), o.setUniformi(`lightPositional${l}`, p.getPositional()), o.setUniformf(`lightExponent${l}`, p.getExponent()), o.setUniformf(`lightConeAngle${l}`, p.getConeAngle()), o.setUniform3fArray(`lightPositionVC${l}`, [y[0], y[1], y[2]]), l++;
      }
    }
  };
  function e(n, s, r) {
    return s.identity(r), n.reduce((a, o, l) => l === 0 ? o ? s.copy(a, o) : s.identity(a) : o ? s.multiply(a, a, o) : a, r);
  }
  i.setCameraShaderParameters = (n, s, r) => {
    const a = n.getProgram(), o = t.openGLCamera.getKeyMatrices(s), l = s.getActiveCamera(), c = t.openGLCamera.getKeyMatrixTime().getMTime(), u = a.getLastCameraMTime(), h = n.getCABO().getCoordShiftAndScaleEnabled() ? n.getCABO().getInverseShiftAndScaleMatrix() : null, p = r.getIsIdentity(), m = p ? {
      mcwc: null,
      normalMatrix: null
    } : t.openGLActor.getKeyMatrices();
    if (r.getCoordinateSystem() === Fst.DISPLAY) {
      const b = t._openGLRenderer.getTiledSizeAndOrigin();
      ut.identity(t.tmpMat4), t.tmpMat4[0] = 2 / b.usize, t.tmpMat4[12] = -1, t.tmpMat4[5] = 2 / b.vsize, t.tmpMat4[13] = -1, ut.multiply(t.tmpMat4, t.tmpMat4, h), a.setUniformMatrix("MCPCMatrix", t.tmpMat4);
    } else
      a.setUniformMatrix("MCPCMatrix", e([o.wcpc, m.mcwc, h], ut, t.tmpMat4));
    a.isUniformUsed("MCVCMatrix") && a.setUniformMatrix("MCVCMatrix", e([o.wcvc, m.mcwc, h], ut, t.tmpMat4)), a.isUniformUsed("normalMatrix") && a.setUniformMatrix3x3("normalMatrix", e([o.normalMatrix, m.normalMatrix], gi, t.tmpMat3)), u !== c && (a.isUniformUsed("cameraParallel") && a.setUniformi("cameraParallel", l.getParallelProjection()), a.setLastCameraMTime(c)), p || a.setLastCameraMTime(0);
  }, i.setPropertyShaderParameters = (n, s, r) => {
    const a = n.getProgram();
    let o = r.getProperty(), l = o.getOpacity(), c = t.drawingEdges ? o.getEdgeColorByReference() : o.getAmbientColorByReference(), u = t.drawingEdges ? o.getEdgeColorByReference() : o.getDiffuseColorByReference(), d = t.drawingEdges ? 1 : o.getAmbient(), h = t.drawingEdges ? 0 : o.getDiffuse(), p = t.drawingEdges ? 0 : o.getSpecular();
    const m = o.getSpecularPower();
    a.setUniformf("opacityUniform", l), a.setUniform3fArray("ambientColorUniform", c), a.setUniform3fArray("diffuseColorUniform", u), a.setUniformf("ambient", d), a.setUniformf("diffuse", h);
    const b = t.lastBoundBO.getReferenceByName("lastLightComplexity");
    if (b < 1)
      return;
    let y = o.getSpecularColorByReference();
    if (a.setUniform3fArray("specularColorUniform", y), a.setUniformf("specularPowerUniform", m), a.setUniformf("specular", p), a.isUniformUsed("ambientIntensityBF")) {
      if (o = r.getBackfaceProperty(), l = o.getOpacity(), c = o.getAmbientColor(), d = o.getAmbient(), u = o.getDiffuseColor(), h = o.getDiffuse(), y = o.getSpecularColor(), p = o.getSpecular(), a.setUniformf("ambientIntensityBF", d), a.setUniformf("diffuseIntensityBF", h), a.setUniformf("opacityUniformBF", l), a.setUniform3fArray("ambientColorUniformBF", c), a.setUniform3fArray("diffuseColorUniformBF", u), b < 1)
        return;
      a.setUniformf("specularIntensityBF", p), a.setUniform3fArray("specularColorUniformBF", y), a.setUniformf("specularPowerUniformBF", m);
    }
  }, i.updateMaximumPointCellIds = (n, s) => {
    var o, l, c, u;
    const r = t._openGLRenderer.getSelector();
    if (!r)
      return;
    if ((l = (o = t.selectionWebGLIdsToVTKIds) == null ? void 0 : o.points) != null && l.length) {
      const d = t.selectionWebGLIdsToVTKIds.points.length;
      r.setMaximumPointId(d - 1);
    }
    if ((u = (c = t.selectionWebGLIdsToVTKIds) == null ? void 0 : c.cells) != null && u.length) {
      const d = t.selectionWebGLIdsToVTKIds.cells.length;
      r.setMaximumCellId(d - 1);
    }
    r.getFieldAssociation() === zx.FIELD_ASSOCIATION_POINTS && (t.pointPicking = !0);
  }, i.renderPieceStart = (n, s) => {
    t.primitiveIDOffset = 0, t.vertexIDOffset = 0;
    const r = jst(t._openGLRenderer);
    t.lastSelectionState !== r && (t.selectionStateChanged.modified(), t.lastSelectionState = r), t._openGLRenderer.getSelector() && t._openGLRenderer.getSelector().renderProp(s), i.updateBufferObjects(n, s), t.renderable.getColorTextureMap() && t.internalColorTexture.activate(), t.lastBoundBO = null;
  }, i.renderPieceDraw = (n, s) => {
    const r = s.getProperty().getRepresentation(), a = s.getProperty().getEdgeVisibility() && r === Q0.SURFACE, o = t._openGLRenderer.getSelector(), l = o && o.getFieldAssociation() === zx.FIELD_ASSOCIATION_POINTS && (t.lastSelectionState === Es.ID_LOW24 || t.lastSelectionState === Es.ID_HIGH24);
    for (let c = Qs.Start; c < Qs.End; c++)
      t.primitives[c].setPointPicking(l), t.primitives[c].getCABO().getElementCount() && (t.drawingEdges = a && (c === Qs.TrisEdges || c === Qs.TriStripsEdges), (!t.drawingEdges || !(t.renderDepth || t.lastSelectionState >= 0)) && (t.lastBoundBO = t.primitives[c], t.primitiveIDOffset += Number(t.primitives[c].drawArrays(n, s, r, i)), t.vertexIDOffset += Number(t.primitives[c].getCABO().getElementCount())));
  }, i.renderPieceFinish = (n, s) => {
    t.LastBoundBO && t.LastBoundBO.getVAO().release(), t.renderable.getColorTextureMap() && t.internalColorTexture.deactivate();
  }, i.renderPiece = (n, s) => {
    if (i.invokeEvent(Est), t.renderable.getStatic() || t.renderable.update(), t.currentInput = t.renderable.getInputData(), i.invokeEvent(kst), !t.currentInput) {
      Tp("No input!");
      return;
    }
    if (!t.currentInput.getPoints || !t.currentInput.getPoints().getNumberOfValues())
      return;
    const r = t.context, a = s.getProperty().getBackfaceCulling(), o = s.getProperty().getFrontfaceCulling();
    !a && !o ? t._openGLRenderWindow.disableCullFace() : o ? (t._openGLRenderWindow.enableCullFace(), r.cullFace(r.FRONT)) : (t._openGLRenderWindow.enableCullFace(), r.cullFace(r.BACK)), i.renderPieceStart(n, s), i.renderPieceDraw(n, s), i.renderPieceFinish(n, s);
  }, i.computeBounds = (n, s) => {
    if (!i.getInput()) {
      Lg(t.bounds);
      return;
    }
    t.bounds = i.getInput().getBounds();
  }, i.updateBufferObjects = (n, s) => {
    i.getNeedToRebuildBufferObjects(n, s) && i.buildBufferObjects(n, s);
  }, i.getNeedToRebuildBufferObjects = (n, s) => {
    const r = t.VBOBuildTime.getMTime();
    return r < i.getMTime() || r < t.renderable.getMTime() || r < s.getMTime() || r < t.currentInput.getMTime();
  }, i.buildBufferObjects = (n, s) => {
    const r = t.currentInput;
    if (r === null)
      return;
    t.renderable.mapScalars(r, 1);
    const a = t.renderable.getColorMapColors();
    t.haveCellScalars = !1;
    const o = t.renderable.getScalarMode();
    t.renderable.getScalarVisibility() && (o === $1.USE_CELL_DATA || o === $1.USE_CELL_FIELD_DATA || o === $1.USE_FIELD_DATA || !r.getPointData().getScalars()) && o !== $1.USE_POINT_FIELD_DATA && a && (t.haveCellScalars = !0);
    let l = s.getProperty().getInterpolation() !== eO.FLAT ? r.getPointData().getNormals() : null;
    l === null && r.getCellData().getNormals() && (t.haveCellNormals = !0, l = r.getCellData().getNormals());
    const c = s.getProperty().getRepresentation();
    let u = r.getPointData().getTCoords();
    if (t.openGLActor.getActiveTextures() || (u = null), t.renderable.getColorCoordinates()) {
      u = t.renderable.getColorCoordinates(), t.internalColorTexture || (t.internalColorTexture = bs.newInstance({
        resizable: !0
      }));
      const h = t.internalColorTexture;
      h.setMinificationFilter(nO.NEAREST), h.setMagnificationFilter(nO.NEAREST), h.setWrapS(iO.CLAMP_TO_EDGE), h.setWrapT(iO.CLAMP_TO_EDGE), h.setOpenGLRenderWindow(t._openGLRenderWindow);
      const p = t.renderable.getColorTextureMap(), m = p.getExtent(), b = p.getPointData().getScalars();
      h.create2DFromRaw(m[1] - m[0] + 1, m[3] - m[2] + 1, b.getNumberOfComponents(), b.getDataType(), b.getData()), h.activate(), h.sendParameters(), h.deactivate();
    }
    const d = `${r.getMTime()}A${c}B${r.getMTime()}C${l ? l.getMTime() : 1}D${a ? a.getMTime() : 1}E${s.getProperty().getEdgeVisibility()}F${u ? u.getMTime() : 1}`;
    if (t.VBOBuildString !== d) {
      const p = {
        points: r.getPoints(),
        normals: l,
        tcoords: u,
        colors: a,
        cellOffset: 0,
        vertexOffset: 0,
        // Used to keep track of vertex ids across primitives for selection
        haveCellScalars: t.haveCellScalars,
        haveCellNormals: t.haveCellNormals,
        customAttributes: t.renderable.getCustomShaderAttributes().map((y) => r.getPointData().getArrayByName(y))
      };
      t.renderable.getPopulateSelectionSettings() && (t.selectionWebGLIdsToVTKIds = {
        points: null,
        cells: null
      });
      const m = [{
        inRep: "verts",
        cells: r.getVerts()
      }, {
        inRep: "lines",
        cells: r.getLines()
      }, {
        inRep: "polys",
        cells: r.getPolys()
      }, {
        inRep: "strips",
        cells: r.getStrips()
      }, {
        inRep: "polys",
        cells: r.getPolys()
      }, {
        inRep: "strips",
        cells: r.getStrips()
      }], b = s.getProperty().getEdgeVisibility() && c === Q0.SURFACE;
      for (let y = Qs.Start; y < Qs.End; y++)
        y !== Qs.TrisEdges && y !== Qs.TriStripsEdges ? (p.cellOffset += Number(t.primitives[y].getCABO().createVBO(m[y].cells, m[y].inRep, c, p, t.selectionWebGLIdsToVTKIds)), p.vertexOffset += Number(t.primitives[y].getCABO().getElementCount())) : b ? t.primitives[y].getCABO().createVBO(m[y].cells, m[y].inRep, Q0.WIREFRAME, {
          ...p,
          tcoords: null,
          colors: null,
          haveCellScalars: !1,
          haveCellNormals: !1
        }) : t.primitives[y].releaseGraphicsResources();
      t.renderable.getPopulateSelectionSettings() && (t.renderable.setSelectionWebGLIdsToVTKIds(t.selectionWebGLIdsToVTKIds), i.updateMaximumPointCellIds()), t.VBOBuildTime.modified(), t.VBOBuildString = d;
    }
  }, i.getAllocatedGPUMemoryInBytes = () => {
    let n = 0;
    return t.primitives.forEach((s) => {
      n += s.getAllocatedGPUMemoryInBytes();
    }), n;
  };
}
const Pst = {
  context: null,
  VBOBuildTime: 0,
  VBOBuildString: null,
  primitives: null,
  primTypes: null,
  shaderRebuildString: null,
  tmpMat4: null,
  ambientColor: [],
  // used internally
  diffuseColor: [],
  // used internally
  specularColor: [],
  // used internally
  lightColor: [],
  // used internally
  lightDirection: [],
  // used internally
  lastHaveSeenDepthRequest: !1,
  haveSeenDepthRequest: !1,
  lastSelectionState: Es.MIN_KNOWN_PASS - 1,
  selectionStateChanged: null,
  selectionWebGLIdsToVTKIds: null,
  pointPicking: !1
};
function q9(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Pst, e), ui.extend(i, t, e), kc.implementReplaceShaderCoincidentOffset(i, t, e), kc.implementBuildShadersWithReplacements(i, t, e), t.primitives = [], t.primTypes = Qs, t.tmpMat3 = gi.identity(new Float64Array(9)), t.tmpMat4 = ut.identity(new Float64Array(16));
  for (let n = Qs.Start; n < Qs.End; n++)
    t.primitives[n] = Jc.newInstance(), t.primitives[n].setPrimitiveType(n), t.primitives[n].set({
      lastLightComplexity: 0,
      lastLightCount: 0,
      lastSelectionPass: !1
    }, !0);
  gs(i, t, ["context"]), t.VBOBuildTime = {}, xi(t.VBOBuildTime, {
    mtime: 0
  }), t.selectionStateChanged = {}, xi(t.selectionStateChanged, {
    mtime: 0
  }), Ust(i, t);
}
const tj = In(q9, "vtkOpenGLPolyDataMapper");
var kI = {
  newInstance: tj,
  extend: q9
};
Js("vtkMapper", tj);
const {
  ColorMode: Jst,
  ScalarMode: Mp,
  GetArray: Ex
} = vG;
function Ast(i, t) {
  t.classHierarchy.push("vtkMapper2D"), i.createDefaultLookupTable = () => {
    t.lookupTable = My.newInstance();
  }, i.getColorModeAsString = () => tt.enumToString(Jst, t.colorMode), i.setColorModeToDefault = () => i.setColorMode(0), i.setColorModeToMapScalars = () => i.setColorMode(1), i.setColorModeToDirectScalars = () => i.setColorMode(2), i.getScalarModeAsString = () => tt.enumToString(Mp, t.scalarMode), i.setScalarModeToDefault = () => i.setScalarMode(0), i.setScalarModeToUsePointData = () => i.setScalarMode(1), i.setScalarModeToUseCellData = () => i.setScalarMode(2), i.setScalarModeToUsePointFieldData = () => i.setScalarMode(3), i.setScalarModeToUseCellFieldData = () => i.setScalarMode(4), i.setScalarModeToUseFieldData = () => i.setScalarMode(5), i.getAbstractScalars = (e, n, s, r, a) => {
    if (!e || !t.scalarVisibility)
      return {
        scalars: null,
        cellFLag: !1
      };
    let o = null, l = !1;
    if (n === Mp.DEFAULT)
      o = e.getPointData().getScalars(), o || (o = e.getCellData().getScalars(), l = !0);
    else if (n === Mp.USE_POINT_DATA)
      o = e.getPointData().getScalars();
    else if (n === Mp.USE_CELL_DATA)
      o = e.getCellData().getScalars(), l = !0;
    else if (n === Mp.USE_POINT_FIELD_DATA) {
      const c = e.getPointData();
      s === Ex.BY_ID ? o = c.getArrayByIndex(r) : o = c.getArrayByName(a);
    } else if (n === Mp.USE_CELL_FIELD_DATA) {
      const c = e.getCellData();
      l = !0, s === Ex.BY_ID ? o = c.getArrayByIndex(r) : o = c.getArrayByName(a);
    } else if (n === Mp.USE_FIELD_DATA) {
      const c = e.getFieldData();
      s === Ex.BY_ID ? o = c.getArrayByIndex(r) : o = c.getArrayByName(a);
    }
    return {
      scalars: o,
      cellFlag: l
    };
  }, i.getLookupTable = () => (t.lookupTable || i.createDefaultLookupTable(), t.lookupTable), i.getMTime = () => {
    let e = t.mtime;
    if (t.lookupTable !== null) {
      const n = t.lookupTable.getMTime();
      e = n > e ? n : e;
    }
    return e;
  }, i.mapScalars = (e, n) => {
    const s = i.getAbstractScalars(e, t.scalarMode, t.arrayAccessMode, t.arrayId, t.colorByArrayName).scalars;
    if (!s) {
      t.colorMapColors = null;
      return;
    }
    const r = `${i.getMTime()}${s.getMTime()}${n}`;
    if (t.colorBuildString === r) return;
    t.useLookupTableScalarRange || i.getLookupTable().setRange(t.scalarRange[0], t.scalarRange[1]);
    const a = i.getLookupTable();
    a && (a.build(), t.colorMapColors = a.mapScalars(s, t.colorMode, t.fieldDataTupleId)), t.colorBuildString = `${i.getMTime()}${s.getMTime()}${n}`;
  }, i.getPrimitiveCount = () => {
    const e = i.getInputData();
    return {
      points: e.getPoints().getNumberOfValues() / 3,
      verts: e.getVerts().getNumberOfValues() - e.getVerts().getNumberOfCells(),
      lines: e.getLines().getNumberOfValues() - 2 * e.getLines().getNumberOfCells(),
      triangles: e.getPolys().getNumberOfValues() - 3 * e.getPolys().getNumberOfCells()
    };
  };
}
const Bst = {
  static: !1,
  lookupTable: null,
  scalarVisibility: !1,
  scalarRange: [0, 1],
  useLookupTableScalarRange: !1,
  colorMode: 0,
  scalarMode: 0,
  arrayAccessMode: 1,
  // By_NAME
  renderTime: 0,
  colorByArrayName: null,
  transformCoordinate: null,
  viewSpecificProperties: null,
  customShaderAttributes: []
};
function ej(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Bst, e), v9.extend(i, t, e), tt.get(i, t, ["colorMapColors"]), tt.setGet(i, t, [
    "arrayAccessMode",
    "colorByArrayName",
    "colorMode",
    "lookupTable",
    "renderTime",
    "scalarMode",
    "scalarVisibility",
    "static",
    "transformCoordinate",
    "useLookupTableScalarRange",
    "viewSpecificProperties",
    "customShaderAttributes"
    // point data array names that will be transferred to the VBO
  ]), tt.setGetArray(i, t, ["scalarRange"], 2), t.viewSpecificProperties || (t.viewSpecificProperties = {}), Ast(i, t);
}
const Kst = tt.newInstance(ej, "vtkMapper2D");
var aN = {
  newInstance: Kst,
  extend: ej
}, Hst = `//VTK::System::Dec

/*=========================================================================

  Program:   Visualization Toolkit
  Module:    vtkPolyData2DFS.glsl

  Copyright (c) Ken Martin, Will Schroeder, Bill Lorensen
  All rights reserved.
  See Copyright.txt or http://www.kitware.com/Copyright.htm for details.

     This software is distributed WITHOUT ANY WARRANTY; without even
     the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR
     PURPOSE.  See the above copyright notice for more information.

=========================================================================*/

uniform int PrimitiveIDOffset;

// Texture coordinates
//VTK::TCoord::Dec

// Scalar coloring
//VTK::Color::Dec

// Depth Peeling
//VTK::DepthPeeling::Dec

// picking support
//VTK::Picking::Dec

// the output of this shader
//VTK::Output::Dec

// Apple Bug
//VTK::PrimID::Dec

void main()
{
  // Apple Bug
  //VTK::PrimID::Impl

  //VTK::Color::Impl
  //VTK::TCoord::Impl

  //VTK::DepthPeeling::Impl
  //VTK::Picking::Impl

  if (gl_FragData[0].a <= 0.0)
    {
    discard;
    }
}
`, _st = `//VTK::System::Dec

/*=========================================================================

  Program:   Visualization Toolkit
  Module:    vtkPolyData2DVS.glsl

  Copyright (c) Ken Martin, Will Schroeder, Bill Lorensen
  All rights reserved.
  See Copyright.txt or http://www.kitware.com/Copyright.htm for details.

     This software is distributed WITHOUT ANY WARRANTY; without even
     the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR
     PURPOSE.  See the above copyright notice for more information.

=========================================================================*/

// all variables that represent positions or directions have a suffix
// indicating the coordinate system they are in. The possible values are
// MC - Model Coordinates
// WC - WC world coordinates
// VC - View Coordinates
// DC - Display Coordinates

in vec4 vertexWC;

// frag position in VC
//VTK::PositionVC::Dec

// material property values
//VTK::Color::Dec

// Texture coordinates
//VTK::TCoord::Dec

// Apple Bug
//VTK::PrimID::Dec

uniform mat4 WCVCMatrix;  // World to view matrix

void main()
{
  // Apple Bug
  //VTK::PrimID::Impl

  gl_Position = WCVCMatrix*vertexWC;

  //VTK::TCoord::Impl

  //VTK::Color::Impl

  //VTK::PositionVC::Impl
}
`;
const nj = {
  BACKGROUND: 0,
  FOREGROUND: 1
};
var ij = {
  DisplayLocation: nj
};
const {
  primTypes: fl
} = Jc, {
  ScalarMode: q1
} = aN, {
  vtkErrorMacro: tM
} = kr, Qst = {
  type: "StartEvent"
}, $st = {
  type: "EndEvent"
};
function qst(i, t) {
  t.classHierarchy.push("vtkOpenGLPolyDataMapper2D"), i.buildPass = (n) => {
    n && (t.openGLActor2D = i.getFirstAncestorOfType("vtkOpenGLActor2D"), t._openGLRenderer = t.openGLActor2D.getFirstAncestorOfType("vtkOpenGLRenderer"), t._openGLRenderWindow = t._openGLRenderer.getParent(), t.openGLCamera = t._openGLRenderer.getViewNodeFor(t._openGLRenderer.getRenderable().getActiveCamera()));
  }, i.overlayPass = (n) => {
    n && i.render();
  }, i.getShaderTemplate = (n, s, r) => {
    n.Vertex = _st, n.Fragment = Hst, n.Geometry = "";
  }, i.render = () => {
    const n = t._openGLRenderWindow.getContext();
    if (t.context !== n) {
      t.context = n;
      for (let a = fl.Start; a < fl.End; a++)
        t.primitives[a].setOpenGLRenderWindow(t._openGLRenderWindow);
    }
    const s = t.openGLActor2D.getRenderable(), r = t._openGLRenderer.getRenderable();
    i.renderPiece(r, s);
  }, i.renderPiece = (n, s) => {
    if (i.invokeEvent(Qst), t.renderable.getStatic() || t.renderable.update(), t.currentInput = t.renderable.getInputData(), i.invokeEvent($st), !t.currentInput) {
      tM("No input!");
      return;
    }
    !t.currentInput.getPoints || !t.currentInput.getPoints().getNumberOfValues() || (i.renderPieceStart(n, s), i.renderPieceDraw(n, s), i.renderPieceFinish(n, s));
  }, i.renderPieceStart = (n, s) => {
    if (t.primitiveIDOffset = 0, t._openGLRenderer.getSelector())
      switch (t._openGLRenderer.getSelector().getCurrentPass()) {
        default:
          t._openGLRenderer.getSelector().renderProp(s);
      }
    i.updateBufferObjects(n, s), t.lastBoundBO = null;
  }, i.getNeedToRebuildShaders = (n, s, r) => n.getShaderSourceTime().getMTime() < t.renderable.getMTime() || n.getShaderSourceTime().getMTime() < t.currentInput.getMTime(), i.updateBufferObjects = (n, s) => {
    i.getNeedToRebuildBufferObjects(n, s) && i.buildBufferObjects(n, s);
  }, i.getNeedToRebuildBufferObjects = (n, s) => {
    const r = t.VBOBuildTime.getMTime();
    return !!(r < i.getMTime() || r < t._openGLRenderWindow.getMTime() || r < t.renderable.getMTime() || r < s.getMTime() || r < t.currentInput.getMTime() || t.renderable.getTransformCoordinate() && r < n.getMTime());
  }, i.buildBufferObjects = (n, s) => {
    const r = t.currentInput;
    if (r === null)
      return;
    t.renderable.mapScalars(r, s.getProperty().getOpacity());
    const a = t.renderable.getColorMapColors();
    t.haveCellScalars = !1;
    const o = t.renderable.getScalarMode();
    t.renderable.getScalarVisibility() && (o === q1.USE_CELL_DATA || o === q1.USE_CELL_FIELD_DATA || o === q1.USE_FIELD_DATA || !r.getPointData().getScalars()) && o !== q1.USE_POINT_FIELD_DATA && a && (t.haveCellScalars = !0);
    const l = s.getProperty().getRepresentation();
    let c = r.getPointData().getTCoords();
    t.openGLActor2D.getActiveTextures() || (c = null);
    const u = t.renderable.getTransformCoordinate(), h = n.getRenderWindow().getViews()[0].getViewportSize(n), p = `${r.getMTime()}A${l}B${r.getMTime()}C${a ? a.getMTime() : 1}D${c ? c.getMTime() : 1}E${u ? n.getMTime() : 1}F${h}`;
    if (t.VBOBuildString !== p) {
      let m = r.getPoints();
      if (u) {
        const y = yi.newInstance(), Z = m.getNumberOfPoints();
        y.setNumberOfPoints(Z);
        const g = [];
        for (let f = 0; f < Z; ++f) {
          m.getPoint(f, g), u.setValue(g);
          const T = u.getComputedDoubleViewportValue(n);
          y.setPoint(f, T[0], T[1], 0);
        }
        m = y;
      }
      const b = {
        points: m,
        tcoords: c,
        colors: a,
        cellOffset: 0,
        haveCellScalars: t.haveCellSCalars,
        customAttributes: t.renderable.getCustomShaderAttributes().map((y) => r.getPointData().getArrayByName(y))
      };
      b.cellOffset += t.primitives[fl.Points].getCABO().createVBO(r.getVerts(), "verts", l, b), b.cellOffset += t.primitives[fl.Lines].getCABO().createVBO(r.getLines(), "lines", l, b), b.cellOffset += t.primitives[fl.Tris].getCABO().createVBO(r.getPolys(), "polys", l, b), b.cellOffset += t.primitives[fl.TriStrips].getCABO().createVBO(r.getStrips(), "strips", l, b), t.VBOBuildTime.modified(), t.VBOBuildString = p;
    }
  }, i.renderPieceDraw = (n, s) => {
    const r = s.getProperty().getRepresentation();
    t.context.depthMask(!0);
    for (let o = fl.Start; o < fl.End; o++)
      t.primitives[o].getCABO().getElementCount() && (t.lastBoundBO = t.primitives[o], t.primitiveIDOffset += t.primitives[o].drawArrays(n, s, r, i));
  }, i.renderPieceFinish = (n, s) => {
    t.lastBoundBO && t.lastBoundBO.getVAO().release();
  }, i.replaceShaderValues = (n, s, r) => {
    i.replaceShaderColor(n, s, r), i.replaceShaderTCoord(n, s, r), i.replaceShaderPicking(n, s, r), i.replaceShaderPositionVC(n, s, r);
  }, i.replaceShaderColor = (n, s, r) => {
    let a = n.Vertex, o = n.Geometry, l = n.Fragment;
    t.haveCellScalars && (l = Ft.substitute(l, "//VTK::Color::Dec", ["uniform samplerBuffer texture1;"]).result, l = Ft.substitute(l, "//VTK::Color::Impl", ["gl_FragData[0] = texelFetchBuffer(texture1, gl_PrimitiveID + PrimitiveIDOffset);"]).result), t.lastBoundBO.getCABO().getColorComponents() !== 0 ? (a = Ft.substitute(a, "//VTK::Color::Dec", ["in vec4 diffuseColor;", "out vec4 fcolorVSOutput;"]).result, a = Ft.substitute(a, "//VTK::Color::Impl", ["fcolorVSOutput = diffuseColor;"]).result, o = Ft.substitute(o, "//VTK::Color::Dec", [`in vec4 fcolorVSOutput[];
`, "out vec4 fcolorGSOutput;"]).result, o = Ft.substitute(o, "//VTK::Color::Impl", ["fcolorGSOutput = fcolorVSOutput[i];"]).result, l = Ft.substitute(l, "//VTK::Color::Dec", ["in vec4 fcolorVSOutput;"]).result, l = Ft.substitute(l, "//VTK::Color::Impl", ["gl_FragData[0] = fcolorVSOutput;"]).result) : (l = Ft.substitute(l, "//VTK::Color::Dec", ["uniform vec4 diffuseColor;"]).result, l = Ft.substitute(l, "//VTK::Color::Impl", ["gl_FragData[0] = diffuseColor;"]).result), n.Vertex = a, n.Geometry = o, n.Fragment = l;
  }, i.replaceShaderTCoord = (n, s, r) => {
    if (t.lastBoundBO.getCABO().getTCoordOffset()) {
      let a = n.Vertex, o = n.Geometry, l = n.Fragment;
      const c = t.lastBoundBO.getCABO().getTCoordComponents();
      c === 1 ? (a = Ft.substitute(a, "//VTK::TCoord::Dec", ["in float tcoordMC;", "out float tcoordVCVSOutput;"]).result, a = Ft.substitute(a, "//VTK::TCoord::Impl", ["tcoordVCVSOutput = tcoordMC;"]).result, o = Ft.substitute(o, "//VTK::TCoord::Dec", [`in float tcoordVCVSOutput[];
`, "out float tcoordVCGSOutput;"]).result, o = Ft.substitute(o, ["//VTK::TCoord::Impl", "tcoordVCGSOutput = tcoordVCVSOutput[i];"]).result, l = Ft.substitute(l, "//VTK::TCoord::Dec", ["in float tcoordVCVSOutput;", "uniform sampler2D texture1;"]).result, l = Ft.substitute(l, "//VTK::TCoord::Impl", ["gl_FragData[0] = gl_FragData[0]*texture2D(texture1, vec2(tcoordVCVSOutput,0));"]).result) : c === 2 && (a = Ft.substitute(a, "//VTK::TCoord::Dec", ["in vec2 tcoordMC;", "out vec2 tcoordVCVSOutput;"]).result, a = Ft.substitute(a, "//VTK::TCoord::Impl", ["tcoordVCVSOutput = tcoordMC;"]).result, o = Ft.substitute(o, "//VTK::TCoord::Dec", [`in vec2 tcoordVCVSOutput[];
`, "out vec2 tcoordVCGSOutput;"]).result, o = Ft.substitute(o, "//VTK::TCoord::Impl", ["tcoordVCGSOutput = tcoordVCVSOutput[i];"]).result, l = Ft.substitute(l, "//VTK::TCoord::Dec", ["in vec2 tcoordVCVSOutput;", "uniform sampler2D texture1;"]).result, l = Ft.substitute(l, "//VTK::TCoord::Impl", ["gl_FragData[0] = gl_FragData[0]*texture2D(texture1, tcoordVCVSOutput.st);"]).result), t.haveCellScalars && (o = Ft.substitute(o, "//VTK::PrimID::Impl", ["gl_PrimitiveID = gl_PrimitiveIDIn;"]).result), n.Vertex = a, n.Geometry = o, n.Fragment = l;
    }
  }, i.replaceShaderPicking = (n, s, r) => {
    let a = n.Fragment;
    a = Ft.substitute(a, "//VTK::Picking::Dec", ["uniform vec3 mapperIndex;", "uniform int picking;"]).result, a = Ft.substitute(a, "//VTK::Picking::Impl", "  gl_FragData[0] = picking != 0 ? vec4(mapperIndex,1.0) : gl_FragData[0];").result, n.Fragment = a;
  }, i.replaceShaderPositionVC = (n, s, r) => {
    t.lastBoundBO.replaceShaderPositionVC(n, s, r);
  }, i.invokeShaderCallbacks = (n, s, r) => {
    const a = t.renderable.getViewSpecificProperties().ShadersCallbacks;
    a && a.forEach((o) => {
      o.callback(o.userData, n, s, r);
    });
  }, i.setMapperShaderParameters = (n, s, r) => {
    if (n.getProgram().isUniformUsed("PrimitiveIDOffset") && n.getProgram().setUniformi("PrimitiveIDOffset", t.primitiveIDOffset), n.getProgram().isAttributeUsed("vertexWC") && (n.getVAO().addAttributeArray(n.getProgram(), n.getCABO(), "vertexWC", n.getCABO().getVertexOffset(), n.getCABO().getStride(), t.context.FLOAT, 3, !1) || tM("Error setting vertexWC in shader VAO.")), n.getCABO().getElementCount() && (t.VBOBuildTime.getMTime() > n.getAttributeUpdateTime().getMTime() || n.getShaderSourceTime().getMTime() > n.getAttributeUpdateTime().getMTime())) {
      t.renderable.getCustomShaderAttributes().forEach((l, c) => {
        n.getProgram().isAttributeUsed(`${l}MC`) && (n.getVAO().addAttributeArray(n.getProgram(), n.getCABO(), `${l}MC`, n.getCABO().getCustomData()[c].offset, n.getCABO().getStride(), t.context.FLOAT, n.getCABO().getCustomData()[c].components, !1) || tM(`Error setting ${l}MC in shader VAO.`));
      }), n.getProgram().isAttributeUsed("tcoordMC") && n.getCABO().getTCoordOffset() ? n.getVAO().addAttributeArray(n.getProgram(), n.getCABO(), "tcoordMC", n.getCABO().getTCoordOffset(), n.getCABO().getStride(), t.context.FLOAT, n.getCABO().getTCoordComponents(), !1) || tM("Error setting tcoordMC in shader VAO.") : n.getVAO().removeAttributeArray("tcoordMC"), t.internalColorTexture && n.getProgram().isUniformUsed("texture1") && n.getProgram().setUniformi("texture1", t.internalColorTexture.getTextureUnit());
      const a = t.openGLActor2D.getActiveTextures();
      if (a)
        for (let l = 0; l < a.length; ++l) {
          const u = a[l].getTextureUnit(), d = `texture${u + 1}`;
          n.getProgram().isUniformUsed(d) && n.getProgram().setUniformi(d, u);
        }
      n.setMapperShaderParameters(s, r, t._openGLRenderer.getTiledSizeAndOrigin());
      const o = t._openGLRenderer.getSelector();
      n.getProgram().setUniform3fArray("mapperIndex", o ? o.getPropColorValue() : [0, 0, 0]), n.getProgram().setUniformi("picking", o ? o.getCurrentPass() + 1 : 0);
    }
  }, i.setPropertyShaderParameters = (n, s, r) => {
    const a = t.renderable.getColorMapColors();
    if (!a || a.getNumberOfComponents() === 0) {
      const o = n.getProgram(), l = r.getProperty(), c = l.getOpacity(), u = l.getColor(), d = [u[0], u[1], u[2], c];
      o.setUniform4f("diffuseColor", d);
    }
  }, i.setLightingShaderParameters = (n, s, r) => {
  };
  function e(n, s, r) {
    return s.identity(r), n.reduce((a, o, l) => l === 0 ? o ? s.copy(a, o) : s.identity(a) : o ? s.multiply(a, a, o) : a, r);
  }
  i.setCameraShaderParameters = (n, s, r) => {
    const a = n.getProgram(), l = n.getCABO().getCoordShiftAndScaleEnabled() ? n.getCABO().getInverseShiftAndScaleMatrix() : null, u = s.getRenderWindow().getViews()[0].getViewportSize(s), d = s.getViewport(), h = r.getActualPositionCoordinate().getComputedDoubleViewportValue(s), p = [0, 0, 1, 1], m = [0, 0, 1, 1];
    if (m[0] = d[0] >= p[0] ? d[0] : p[0], m[1] = d[1] >= p[1] ? d[1] : p[1], m[2] = d[2] <= p[2] ? d[2] : p[2], m[3] = d[3] <= p[3] ? d[3] : p[3], m[0] >= m[2] || m[1] >= m[3])
      return;
    u[0] = $u(u[0] * (m[2] - m[0]) / (d[2] - d[0])), u[1] = $u(u[1] * (m[3] - m[1]) / (d[3] - d[1]));
    const b = t._openGLRenderer.getParent().getSize(), y = $u(h[0] - (m[0] - d[0]) * b[0]), Z = $u(h[1] - (m[1] - d[1]) * b[1]), g = -y;
    let f = -y + u[0];
    const T = -Z;
    let M = -Z + u[1];
    g === f && (f = g + 1), T === M && (M = T + 1);
    const N = ut.identity(new Float64Array(16));
    N[0] = 2 / (f - g), N[5] = 2 / (M - T), N[3] = -1 * (f + g) / (f - g), N[7] = -1 * (M + T) / (M - T), N[10] = 0, N[11] = r.getProperty().getDisplayLocation() === nj.FOREGROUND ? -1 : 1, N[15] = 1, ut.transpose(N, N), a.setUniformMatrix("WCVCMatrix", e([N, l], ut, t.tmpMat4));
  }, i.getAllocatedGPUMemoryInBytes = () => {
    let n = 0;
    return t.primitives.forEach((s) => {
      n += s.getAllocatedGPUMemoryInBytes();
    }), n;
  };
}
const trt = {
  context: null,
  VBOBuildTime: 0,
  VBOBuildString: null,
  primitives: null,
  primTypes: null,
  shaderRebuildString: null
};
function ert(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, trt, e), ui.extend(i, t, e), kc.implementReplaceShaderCoincidentOffset(i, t, e), kc.implementBuildShadersWithReplacements(i, t, e), t.primitives = [], t.primTypes = fl, t.tmpMat4 = ut.identity(new Float64Array(16));
  for (let n = fl.Start; n < fl.End; n++)
    t.primitives[n] = Jc.newInstance(), t.primitives[n].setPrimitiveType(n), t.primitives[n].set({
      lastLightComplexity: 0,
      lastLightCount: 0,
      lastSelectionPass: !1
    }, !0);
  gs(i, t, ["context"]), t.VBOBuildTime = {}, xi(t.VBOBuildTime, {
    mtime: 0
  }), qst(i, t);
}
const nrt = In(ert, "vtkOpenGLPolyDataMapper2D");
Js("vtkMapper2D", nrt);
const {
  VectorMode: irt
} = RG;
function kx(i, t) {
  i.strokeStyle = t.strokeColor, i.lineWidth = t.strokeSize, i.fillStyle = t.fontColor, i.font = `${t.fontStyle} ${t.fontSize}px ${t.fontFamily}`;
}
function sj(i, t) {
  return (e) => {
    const n = e.getLastSize(), s = (n[0] / 700) ** 0.8, r = (n[1] / 700) ** 0.8, a = Math.min(s, r), o = e.getAxisTextStyle(), l = e.getTickTextStyle();
    Object.assign(o, t.axisTextStyle), Object.assign(l, t.tickTextStyle), o.fontSize = Math.max(24 * a, 12), e.getLastAspectRatio() > 1 ? l.fontSize = Math.max(20 * a, 10) : l.fontSize = Math.max(16 * a, 10);
    const c = e.updateTextureAtlas();
    e.setTopTitle(!1);
    const u = e.getBoxSizeByReference();
    if (e.getLastAspectRatio() > 1)
      e.setTickLabelPixelOffset(0.3 * l.fontSize), c.titleWidth <= c.tickWidth + e.getTickLabelPixelOffset() + 0.8 * l.fontSize ? (e.setTopTitle(!0), e.setAxisTitlePixelOffset(0.2 * l.fontSize), u[0] = 2 * (c.tickWidth + e.getTickLabelPixelOffset() + 0.8 * l.fontSize) / n[0], e.setBoxPosition([0.98 - u[0], -0.92])) : (e.setAxisTitlePixelOffset(0.2 * l.fontSize), u[0] = 2 * (c.titleHeight + e.getAxisTitlePixelOffset() + c.tickWidth + e.getTickLabelPixelOffset() + 0.8 * l.fontSize) / n[0], e.setBoxPosition([0.99 - u[0], -0.92])), u[1] = Math.max(1.2, Math.min(1.84 / r, 1.84));
    else {
      e.setAxisTitlePixelOffset(1.2 * l.fontSize), e.setTickLabelPixelOffset(0.1 * l.fontSize);
      const d = (
        // total offset from top of bar (includes ticks)
        2 * (0.8 * l.fontSize + c.titleHeight + e.getAxisTitlePixelOffset()) / n[1]
      ), h = 2 * c.tickWidth / n[0];
      u[0] = Math.min(1.9, Math.max(1.4, 1.4 * h * (e.getTicks().length + 3))), u[1] = d, e.setBoxPosition([-0.5 * u[0], -0.97]);
    }
    e.recomputeBarSegments(c);
  };
}
function rj(i, t) {
  return (e) => {
    const n = e.getLastTickBounds(), s = vI().domain([n[0], n[1]]), r = s.ticks(5), a = s.tickFormat(5);
    e.setTicks(r), e.setTickStrings(r.map(a));
  };
}
function srt(i, t) {
  t.classHierarchy.push("vtkScalarBarActorHelper"), i.setRenderable = (s) => {
    t.renderable !== s && (t.renderable = s, t.barActor.setProperty(s.getProperty()), t.barActor.setParentProp(s), t.barActor.setCoordinateSystemToDisplay(), t.tmActor.setProperty(s.getProperty()), t.tmActor.setParentProp(s), t.tmActor.setCoordinateSystemToDisplay(), t.generateTicks = s.generateTicks, t.axisTextStyle = {
      ...s.getAxisTextStyle()
    }, t.tickTextStyle = {
      ...s.getTickTextStyle()
    }, i.modified());
  }, i.updateAPISpecificData = (s, r, a) => {
    (t.lastSize[0] !== s[0] || t.lastSize[1] !== s[1]) && (t.lastSize[0] = s[0], t.lastSize[1] = s[1], t.lastAspectRatio = s[0] / s[1], t.forceUpdate = !0);
    const o = t.renderable.getScalarsToColors();
    if (!(!o || !t.renderable.getVisibility()) && (t.barMapper.setLookupTable(o), t.camera = r, t.renderWindow = a, t.forceUpdate || Math.max(o.getMTime(), i.getMTime(), t.renderable.getMTime()) > t.lastRebuildTime.getMTime())) {
      const l = o.getMappingRange();
      if (t.lastTickBounds = [...l], t.renderable.getGenerateTicks()(i), t.renderable.getAutomated())
        t.renderable.getAutoLayout()(i);
      else {
        t.axisTextStyle = {
          ...t.renderable.getAxisTextStyle()
        }, t.tickTextStyle = {
          ...t.renderable.getTickTextStyle()
        }, t.barPosition = [...t.renderable.getBarPosition()], t.barSize = [...t.renderable.getBarSize()], t.boxPosition = [...t.renderable.getBoxPosition()], t.boxSize = [...t.renderable.getBoxSize()], t.axisTitlePixelOffset = t.renderable.getAxisTitlePixelOffset(), t.tickLabelPixelOffset = t.renderable.getTickLabelPixelOffset();
        const c = i.updateTextureAtlas();
        i.recomputeBarSegments(c);
      }
      i.updatePolyDataForLabels(), i.updatePolyDataForBarSegments(), t.lastRebuildTime.modified(), t.forceUpdate = !1;
    }
  }, i.updateTextureAtlas = () => {
    t.tmContext.textBaseline = "bottom", t.tmContext.textAlign = "left";
    const s = {}, r = /* @__PURE__ */ new Map();
    let a = 0, o = 1;
    kx(t.tmContext, t.axisTextStyle);
    let l = t.tmContext.measureText(t.renderable.getAxisLabel()), c = {
      height: l.actualBoundingBoxAscent + 2,
      startingHeight: o,
      width: l.width + 2,
      textStyle: t.axisTextStyle
    };
    r.set(t.renderable.getAxisLabel(), c), o += c.height, a = c.width, s.titleWidth = c.width, s.titleHeight = c.height, s.tickWidth = 0, s.tickHeight = 0, kx(t.tmContext, t.tickTextStyle);
    const u = [...i.getTickStrings(), "NaN", "Below", "Above"];
    for (let d = 0; d < u.length; d++)
      r.has(u[d]) || (l = t.tmContext.measureText(u[d]), c = {
        height: l.actualBoundingBoxAscent + 2,
        startingHeight: o,
        width: l.width + 2,
        textStyle: t.tickTextStyle
      }, r.set(u[d], c), o += c.height, a < c.width && (a = c.width), s.tickWidth < c.width && (s.tickWidth = c.width), s.tickHeight < c.height && (s.tickHeight = c.height));
    return a = Qo(a), o = Qo(o), r.forEach((d) => {
      d.tcoords = [0, (o - d.startingHeight - d.height) / o, d.width / a, (o - d.startingHeight - d.height) / o, d.width / a, (o - d.startingHeight) / o, 0, (o - d.startingHeight) / o];
    }), t.tmCanvas.width = a, t.tmCanvas.height = o, t.tmContext.textBaseline = "bottom", t.tmContext.textAlign = "left", t.tmContext.clearRect(0, 0, a, o), r.forEach((d, h) => {
      kx(t.tmContext, d.textStyle), t.tmContext.fillText(h, 1, d.startingHeight + d.height - 1);
    }), t.tmTexture.setCanvas(t.tmCanvas), t.tmTexture.modified(), t._tmAtlas = r, s;
  }, i.computeBarSize = (s) => {
    t.vertical = t.boxSize[1] > t.boxSize[0];
    const r = 2 * s.tickHeight / t.lastSize[1], a = [1, 1];
    if (t.vertical) {
      const o = 2 * (s.tickWidth + t.tickLabelPixelOffset) / t.lastSize[0];
      if (t.topTitle) {
        const l = 2 * (s.titleHeight + t.axisTitlePixelOffset) / t.lastSize[1];
        t.barSize[0] = t.boxSize[0] - o, t.barSize[1] = t.boxSize[1] - l;
      } else {
        const l = 2 * (s.titleHeight + t.axisTitlePixelOffset) / t.lastSize[0];
        t.barSize[0] = t.boxSize[0] - l - o, t.barSize[1] = t.boxSize[1];
      }
      t.barPosition[0] = t.boxPosition[0] + o, t.barPosition[1] = t.boxPosition[1], a[1] = r;
    } else {
      const o = (2 * s.tickWidth - 8) / t.lastSize[0], l = 2 * (s.titleHeight + t.axisTitlePixelOffset) / t.lastSize[1];
      t.barSize[0] = t.boxSize[0], t.barPosition[0] = t.boxPosition[0], t.barSize[1] = t.boxSize[1] - l, t.barPosition[1] = t.boxPosition[1], a[0] = o;
    }
    return a;
  }, i.recomputeBarSegments = (s) => {
    var h, p, m, b;
    const r = i.computeBarSize(s);
    t.barSegments = [];
    const a = [0, 0], o = t.vertical ? 1 : 0, l = t.vertical ? 0.01 : 0.02;
    function c(y, Z) {
      t.barSegments.push({
        corners: [[...a], [a[0] + r[0], a[1]], [a[0] + r[0], a[1] + r[1]], [a[0], a[1] + r[1]]],
        scalars: Z,
        title: y
      }), a[o] += r[o] + l;
    }
    t.renderable.getDrawNanAnnotation() && t.renderable.getScalarsToColors().getNanColor() && c("NaN", [NaN, NaN, NaN, NaN]), t.renderable.getDrawBelowRangeSwatch() && ((p = (h = t.renderable.getScalarsToColors()).getUseBelowRangeColor) != null && p.call(h)) && c("Below", [-0.1, -0.1, -0.1, -0.1]);
    const u = (b = (m = t.renderable.getScalarsToColors()).getUseAboveRangeColor) == null ? void 0 : b.call(m);
    a[o] += l;
    const d = r[o];
    r[o] = u ? 1 - 2 * l - r[o] - a[o] : 1 - l - a[o], c("ticks", t.vertical ? [0, 0, 0.995, 0.995] : [0, 0.995, 0.995, 0]), t.renderable.getDrawAboveRangeSwatch() && u && (r[o] = d, a[o] += l, c("Above", [1.1, 1.1, 1.1, 1.1]));
  };
  const e = new Float64Array(3);
  i.createPolyDataForOneLabel = (s, r, a, o, l, c) => {
    const u = t._tmAtlas.get(s);
    if (!u)
      return;
    let d = c.ptIdx, h = c.cellIdx;
    e[0] = (0.5 * r[0] + 0.5) * t.lastSize[0], e[1] = (0.5 * r[1] + 0.5) * t.lastSize[1], e[2] = r[2], e[0] += l[0], e[1] += l[1];
    const p = [], m = o === "vertical" ? [1, 0] : [0, 1];
    o === "vertical" ? (p[0] = u.width, p[1] = -u.height, a[0] === "middle" ? e[1] -= u.width / 2 : a[0] === "right" && (e[1] -= u.width), a[1] === "middle" ? e[0] += u.height / 2 : a[1] === "top" && (e[0] += u.height)) : (p[0] = u.width, p[1] = u.height, a[0] === "middle" ? e[0] -= u.width / 2 : a[0] === "right" && (e[0] -= u.width), a[1] === "middle" ? e[1] -= u.height / 2 : a[1] === "top" && (e[1] -= u.height)), c.points[d * 3] = e[0], c.points[d * 3 + 1] = e[1], c.points[d * 3 + 2] = e[2], c.tcoords[d * 2] = u.tcoords[0], c.tcoords[d * 2 + 1] = u.tcoords[1], d++, e[m[0]] += p[0], c.points[d * 3] = e[0], c.points[d * 3 + 1] = e[1], c.points[d * 3 + 2] = e[2], c.tcoords[d * 2] = u.tcoords[2], c.tcoords[d * 2 + 1] = u.tcoords[3], d++, e[m[1]] += p[1], c.points[d * 3] = e[0], c.points[d * 3 + 1] = e[1], c.points[d * 3 + 2] = e[2], c.tcoords[d * 2] = u.tcoords[4], c.tcoords[d * 2 + 1] = u.tcoords[5], d++, e[m[0]] -= p[0], c.points[d * 3] = e[0], c.points[d * 3 + 1] = e[1], c.points[d * 3 + 2] = e[2], c.tcoords[d * 2] = u.tcoords[6], c.tcoords[d * 2 + 1] = u.tcoords[7], d++, c.polys[h * 4] = 3, c.polys[h * 4 + 1] = d - 4, c.polys[h * 4 + 2] = d - 3, c.polys[h * 4 + 3] = d - 2, h++, c.polys[h * 4] = 3, c.polys[h * 4 + 1] = d - 4, c.polys[h * 4 + 2] = d - 2, c.polys[h * 4 + 3] = d - 1, c.ptIdx += 4, c.cellIdx += 2;
  };
  const n = new Float64Array(3);
  i.updatePolyDataForLabels = () => {
    const s = i.getTickStrings().length + t.barSegments.length, r = s * 4, a = s * 2, o = new Float64Array(r * 3), l = new Uint16Array(a * 4), c = new Float32Array(r * 2), u = {
      ptIdx: 0,
      cellIdx: 0,
      polys: l,
      points: o,
      tcoords: c
    }, d = t.vertical ? 0 : 1, h = t.vertical ? 1 : 0;
    n[2] = -0.99;
    const p = t.vertical ? ["right", "middle"] : ["middle", "bottom"];
    let m = [0, 1];
    const b = [0, 0];
    t.vertical ? (b[0] = -t.tickLabelPixelOffset, t.topTitle ? (n[0] = t.boxPosition[0] + 0.5 * t.boxSize[0], n[1] = t.barPosition[1] + t.barSize[1], i.createPolyDataForOneLabel(t.renderable.getAxisLabel(), n, ["middle", "bottom"], "horizontal", [0, t.axisTitlePixelOffset], u)) : (n[0] = t.barPosition[0] + t.barSize[0], n[1] = t.barPosition[1] + 0.5 * t.barSize[1], i.createPolyDataForOneLabel(t.renderable.getAxisLabel(), n, ["middle", "top"], "vertical", [t.axisTitlePixelOffset, 0], u)), m = [-1, 0]) : (b[1] = t.tickLabelPixelOffset, n[0] = t.barPosition[0] + 0.5 * t.barSize[0], n[1] = t.barPosition[1] + t.barSize[1], i.createPolyDataForOneLabel(t.renderable.getAxisLabel(), n, ["middle", "bottom"], "horizontal", [0, t.axisTitlePixelOffset], u)), n[d] = t.barPosition[d] + (0.5 * m[d] + 0.5) * t.barSize[d], n[h] = t.barPosition[h] + t.barSize[h] * 0.5;
    let y = null;
    for (let N = 0; N < t.barSegments.length; N++) {
      const W = t.barSegments[N];
      W.title === "ticks" ? y = W : (n[h] = t.barPosition[h] + 0.5 * t.barSize[h] * (W.corners[2][h] + W.corners[0][h]), i.createPolyDataForOneLabel(W.title, n, p, "horizontal", b, u));
    }
    const Z = t.barPosition[h] + t.barSize[h] * y.corners[0][h], g = t.barSize[h] * (y.corners[2][h] - y.corners[0][h]), f = i.getTicks(), T = i.getTickStrings();
    for (let N = 0; N < f.length; N++) {
      const W = (f[N] - t.lastTickBounds[0]) / (t.lastTickBounds[1] - t.lastTickBounds[0]);
      n[h] = Z + g * W, i.createPolyDataForOneLabel(T[N], n, p, "horizontal", b, u);
    }
    const M = We.newInstance({
      numberOfComponents: 2,
      values: c,
      name: "TextureCoordinates"
    });
    t.tmPolyData.getPointData().setTCoords(M), t.tmPolyData.getPoints().setData(o, 3), t.tmPolyData.getPoints().modified(), t.tmPolyData.getPolys().setData(l, 1), t.tmPolyData.getPolys().modified(), t.tmPolyData.modified();
  }, i.updatePolyDataForBarSegments = () => {
    var b, y;
    const s = t.renderable.getScalarsToColors();
    let r = 0;
    t.renderable.getDrawNanAnnotation() && s.getNanColor() && (r += 1), t.renderable.getDrawBelowRangeSwatch() && ((b = s.getUseBelowRangeColor) != null && b.call(s)) && (r += 1), t.renderable.getDrawAboveRangeSwatch() && ((y = s.getUseAboveRangeColor) != null && y.call(s)) && (r += 1);
    const a = 4 * (1 + r), o = a;
    let l = 1;
    s.getVectorMode() === irt.COMPONENT && (l = s.getVectorComponent() + 1);
    const c = new Float64Array(a * 3), u = new Uint16Array(o * 5), d = new Float32Array(a * l);
    let h = 0, p = 0;
    for (let Z = 0; Z < t.barSegments.length; Z++) {
      const g = t.barSegments[Z];
      for (let f = 0; f < 4; f++) {
        n[0] = t.barPosition[0] + g.corners[f][0] * t.barSize[0], n[1] = t.barPosition[1] + g.corners[f][1] * t.barSize[1], c[h * 3] = (0.5 * n[0] + 0.5) * t.lastSize[0], c[h * 3 + 1] = (0.5 * n[1] + 0.5) * t.lastSize[1], c[h * 3 + 2] = n[2];
        for (let T = 0; T < l; T++)
          d[h * l + T] = t.lastTickBounds[0] + g.scalars[f] * (t.lastTickBounds[1] - t.lastTickBounds[0]);
        h++;
      }
      u[p * 5] = 4, u[p * 5 + 1] = h - 4, u[p * 5 + 2] = h - 3, u[p * 5 + 3] = h - 2, u[p * 5 + 4] = h - 1, p++;
    }
    const m = We.newInstance({
      numberOfComponents: l,
      values: d,
      name: "Scalars"
    });
    t.polyData.getPointData().setScalars(m), t.polyData.getPoints().setData(c, 3), t.polyData.getPoints().modified(), t.polyData.getPolys().setData(u, 1), t.polyData.getPolys().modified(), t.polyData.modified();
  };
}
const rrt = tt.newInstance(function(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    renderable: null
  };
  Object.assign(t, {}, e), tt.obj(i, t), tt.setGet(i, t, ["axisTitlePixelOffset", "tickLabelPixelOffset", "renderable", "topTitle", "ticks", "tickStrings"]), tt.get(i, t, ["lastSize", "lastAspectRatio", "lastTickBounds", "axisTextStyle", "tickTextStyle", "barActor", "tmActor"]), tt.getArray(i, t, ["boxPosition", "boxSize"]), tt.setArray(i, t, ["boxPosition", "boxSize"], 2), t.forceUpdate = !1, t.lastRebuildTime = {}, tt.obj(t.lastRebuildTime, {
    mtime: 0
  }), t.lastSize = [-1, -1], t.tmCanvas = document.createElement("canvas"), t.tmContext = t.tmCanvas.getContext("2d"), t._tmAtlas = /* @__PURE__ */ new Map(), t.barMapper = Ue.newInstance(), t.barMapper.setInterpolateScalarsBeforeMapping(!0), t.barMapper.setUseLookupTableScalarRange(!0), t.polyData = Ie.newInstance(), t.barMapper.setInputData(t.polyData), t.barActor = Re.newInstance(), t.barActor.setMapper(t.barMapper), t.tmPolyData = Ie.newInstance(), t.tmMapper = Ue.newInstance(), t.tmMapper.setInputData(t.tmPolyData), t.tmTexture = vc.newInstance({
    resizable: !0
  }), t.tmTexture.setInterpolate(!1), t.tmActor = Re.newInstance({
    parentProp: i
  }), t.tmActor.setMapper(t.tmMapper), t.tmActor.addTexture(t.tmTexture), t.barPosition = [0, 0], t.barSize = [0, 0], t.boxPosition = [0.88, -0.92], t.boxSize = [0.1, 1.1], t.lastTickBounds = [], srt(i, t);
}, "vtkScalarBarActorHelper");
function art(i, t) {
  t.classHierarchy.push("vtkScalarBarActor"), i.setTickTextStyle = (e) => {
    t.tickTextStyle = {
      ...t.tickTextStyle,
      ...e
    }, i.modified();
  }, i.setAxisTextStyle = (e) => {
    t.axisTextStyle = {
      ...t.axisTextStyle,
      ...e
    }, i.modified();
  }, i.resetAutoLayoutToDefault = () => {
    i.setAutoLayout(sj(i, t));
  }, i.resetGenerateTicksToDefault = () => {
    i.setGenerateTicks(rj());
  };
}
function ort(i) {
  return {
    automated: !0,
    autoLayout: null,
    axisLabel: "Scalar Value",
    barPosition: [0, 0],
    barSize: [0, 0],
    boxPosition: [0.88, -0.92],
    boxSize: [0.1, 1.1],
    scalarToColors: null,
    axisTitlePixelOffset: 36,
    axisTextStyle: {
      fontColor: "white",
      fontStyle: "normal",
      fontSize: 18,
      fontFamily: "serif"
    },
    tickLabelPixelOffset: 14,
    tickTextStyle: {
      fontColor: "white",
      fontStyle: "normal",
      fontSize: 14,
      fontFamily: "serif"
    },
    generateTicks: null,
    drawNanAnnotation: !0,
    drawBelowRangeSwatch: !0,
    drawAboveRangeSwatch: !0,
    ...i
  };
}
function aj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, ort(e)), t.autoLayout || (t.autoLayout = sj(i, t)), t.generateTicks || (t.generateTicks = rj()), Re.extend(i, t, e), i.getProperty().setDiffuse(0), i.getProperty().setAmbient(1), tt.setGet(i, t, ["automated", "autoLayout", "axisTitlePixelOffset", "axisLabel", "scalarsToColors", "tickLabelPixelOffset", "generateTicks", "drawNanAnnotation", "drawBelowRangeSwatch", "drawAboveRangeSwatch"]), tt.get(i, t, ["axisTextStyle", "tickTextStyle"]), tt.getArray(i, t, ["barPosition", "barSize", "boxPosition", "boxSize"]), tt.setArray(i, t, ["barPosition", "barSize", "boxPosition", "boxSize"], 2), art(i, t);
}
const lrt = tt.newInstance(aj, "vtkScalarBarActor");
var FI = {
  newInstance: lrt,
  extend: aj,
  newScalarBarActorHelper: rrt
};
function crt(i, t) {
  t.classHierarchy.push("vtkOpenGLScalarBarActor"), i.buildPass = (e) => {
    e && (t._openGLRenderer = i.getFirstAncestorOfType("vtkOpenGLRenderer"), t._openGLRenderWindow = t._openGLRenderer.getParent(), t.scalarBarActorHelper.getRenderable() || t.scalarBarActorHelper.setRenderable(t.renderable), i.prepareNodes(), i.addMissingNode(t.scalarBarActorHelper.getBarActor()), i.addMissingNode(t.scalarBarActorHelper.getTmActor()), i.removeUnusedNodes());
  }, i.opaquePass = (e, n) => {
    if (e) {
      const s = t._openGLRenderer ? t._openGLRenderer.getRenderable().getActiveCamera() : null, r = t._openGLRenderer.getTiledSizeAndOrigin();
      t.scalarBarActorHelper.updateAPISpecificData([r.usize, r.vsize], s, t._openGLRenderWindow.getRenderable());
    }
  };
}
const urt = {};
function drt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, urt, e), ui.extend(i, t, e), t.scalarBarActorHelper = FI.newScalarBarActorHelper(), crt(i, t);
}
const hrt = In(drt, "vtkOpenGLScalarBarActor");
Js("vtkScalarBarActor", hrt);
const {
  vtkErrorMacro: sO
} = kr;
function prt(i, t) {
  t.classHierarchy.push("vtkOpenGLSkybox"), i.buildPass = (e) => {
    if (e) {
      t._openGLRenderer = i.getFirstAncestorOfType("vtkOpenGLRenderer"), t._openGLRenderWindow = t._openGLRenderer.getParent(), t.context = t._openGLRenderWindow.getContext(), t.tris.setOpenGLRenderWindow(t._openGLRenderWindow), t.openGLTexture.setOpenGLRenderWindow(t._openGLRenderWindow);
      const n = t._openGLRenderer.getRenderable();
      t.openGLCamera = t._openGLRenderer.getViewNodeFor(n.getActiveCamera());
    }
  }, i.queryPass = (e, n) => {
    if (e) {
      if (!t.renderable || !t.renderable.getVisibility())
        return;
      n.incrementOpaqueActorCount();
    }
  }, i.opaquePass = (e, n) => {
    if (e && !t._openGLRenderer.getSelector()) {
      i.updateBufferObjects(), t.context.depthMask(!0), t._openGLRenderWindow.getShaderCache().readyShaderProgram(t.tris.getProgram()), t.openGLTexture.render(t._openGLRenderWindow);
      const s = t.openGLTexture.getTextureUnit();
      t.tris.getProgram().setUniformi("sbtexture", s);
      const r = t._openGLRenderer.getRenderable(), a = t.openGLCamera.getKeyMatrices(r), o = new Float64Array(16);
      if (ut.invert(o, a.wcpc), t.tris.getProgram().setUniformMatrix("IMCPCMatrix", o), t.lastFormat === "box") {
        const l = r.getActiveCamera().getPosition();
        t.tris.getProgram().setUniform3f("camPos", l[0], l[1], l[2]);
      }
      t.tris.getVAO().bind(), t.context.drawArrays(t.context.TRIANGLES, 0, Number(t.tris.getCABO().getElementCount())), t.tris.getVAO().release(), t.openGLTexture.deactivate();
    }
  }, i.updateBufferObjects = () => {
    if (!t.tris.getCABO().getElementCount()) {
      const n = new Float32Array(12);
      for (let o = 0; o < 4; o++)
        n[o * 3] = o % 2 * 2 - 1, n[o * 3 + 1] = o > 1 ? 1 : -1, n[o * 3 + 2] = 1;
      const s = We.newInstance({
        numberOfComponents: 3,
        values: n
      });
      s.setName("points");
      const r = new Uint16Array(8);
      r[0] = 3, r[1] = 0, r[2] = 1, r[3] = 3, r[4] = 3, r[5] = 0, r[6] = 3, r[7] = 2;
      const a = We.newInstance({
        numberOfComponents: 1,
        values: r
      });
      t.tris.getCABO().createVBO(a, "polys", Vn.SURFACE, {
        points: s,
        cellOffset: 0
      });
    }
    t.renderable.getFormat() !== t.lastFormat && (t.lastFormat = t.renderable.getFormat(), t.lastFormat === "box" && t.tris.setProgram(t._openGLRenderWindow.getShaderCache().readyShaderProgramArray(`//VTK::System::Dec
             attribute vec3 vertexMC;
             uniform mat4 IMCPCMatrix;
             varying vec3 TexCoords;
             void main () {
              gl_Position = vec4(vertexMC.xyz, 1.0);
              vec4 wpos = IMCPCMatrix * gl_Position;
              TexCoords = wpos.xyz/wpos.w;
             }`, `//VTK::System::Dec
             //VTK::Output::Dec
             varying vec3 TexCoords;
             uniform samplerCube sbtexture;
             uniform vec3 camPos;
             void main () {
               // skybox looks from inside out
               // which means we have to adjust
               // our tcoords. Otherwise text would
               // be flipped
               vec3 tc = normalize(TexCoords - camPos);
               if (abs(tc.z) < max(abs(tc.x),abs(tc.y)))
               {
                 tc = vec3(1.0, 1.0, -1.0) * tc;
               }
               else
               {
                 tc = vec3(-1.0, 1.0, 1.0) * tc;
               }
               gl_FragData[0] = textureCube(sbtexture, tc);
             }`, "")), t.lastFormat === "background" && t.tris.setProgram(t._openGLRenderWindow.getShaderCache().readyShaderProgramArray(`//VTK::System::Dec
             attribute vec3 vertexMC;
             uniform mat4 IMCPCMatrix;
             varying vec2 TexCoords;
             void main () {
              gl_Position = vec4(vertexMC.xyz, 1.0);
              vec4 wpos = IMCPCMatrix * gl_Position;
              TexCoords = vec2(vertexMC.x, vertexMC.y)*0.5 + 0.5;
             }`, `//VTK::System::Dec
             //VTK::Output::Dec
             varying vec2 TexCoords;
             uniform sampler2D sbtexture;
             void main () {
               gl_FragData[0] = texture2D(sbtexture, TexCoords);
             }`, "")), t.tris.getShaderSourceTime().modified(), t.tris.getVAO().bind(), t.tris.getVAO().addAttributeArray(t.tris.getProgram(), t.tris.getCABO(), "vertexMC", t.tris.getCABO().getVertexOffset(), t.tris.getCABO().getStride(), t.context.FLOAT, 3, t.context.FALSE) || sO("Error setting vertexMC in shader VAO."));
    const e = t.renderable.getTextures();
    e.length || sO("vtkSkybox requires a texture map"), t.openGLTexture.getRenderable() !== e[0] && (t.openGLTexture.releaseGraphicsResources(t._openGLRenderWindow), t.openGLTexture.setRenderable(e[0]));
  };
}
const mrt = {
  context: null
};
function brt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, mrt, e), ui.extend(i, t, e), t.openGLTexture = bs.newInstance(), t.tris = Jc.newInstance(), t.keyMatrixTime = {}, xi(t.keyMatrixTime, {
    mtime: 0
  }), t.keyMatrices = {
    normalMatrix: gi.identity(new Float64Array(9)),
    mcwc: ut.identity(new Float64Array(16))
  }, gs(i, t, ["context"]), Sa(i, t, ["activeTextures"]), prt(i, t);
}
const frt = In(brt);
Js("vtkSkybox", frt);
const {
  vtkDebugMacro: grt
} = kr;
function yrt(i, t) {
  t.classHierarchy.push("vtkOpenGLPixelSpaceCallbackMapper"), i.opaquePass = (e, n) => {
    t._openGLRenderer = i.getFirstAncestorOfType("vtkOpenGLRenderer"), t._openGLRenderWindow = t._openGLRenderer.getParent();
    const s = t._openGLRenderer.getAspectRatio(), r = t._openGLRenderer ? t._openGLRenderer.getRenderable().getActiveCamera() : null, a = t._openGLRenderer.getTiledSizeAndOrigin();
    let o = null;
    if (t.renderable.getUseZValues()) {
      const l = n.getZBufferTexture(), c = Math.floor(l.getWidth()), u = Math.floor(l.getHeight()), d = t._openGLRenderWindow.getContext();
      l.bind();
      const h = n.getFramebuffer();
      h ? h.saveCurrentBindingsAndBuffers() : grt("No framebuffer to save/restore");
      const p = d.createFramebuffer();
      d.bindFramebuffer(d.FRAMEBUFFER, p), d.framebufferTexture2D(d.FRAMEBUFFER, d.COLOR_ATTACHMENT0, d.TEXTURE_2D, l.getHandle(), 0), d.checkFramebufferStatus(d.FRAMEBUFFER) === d.FRAMEBUFFER_COMPLETE && (o = new Uint8Array(c * u * 4), d.viewport(0, 0, c, u), d.readPixels(0, 0, c, u, d.RGBA, d.UNSIGNED_BYTE, o)), h && h.restorePreviousBindingsAndBuffers(), d.deleteFramebuffer(p);
    }
    t.renderable.invokeCallback(t.renderable.getInputData(), r, s, a, o);
  }, i.queryPass = (e, n) => {
    e && t.renderable.getUseZValues() && n.requestDepth();
  };
}
const Zrt = {};
function Trt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Zrt, e), ui.extend(i, t, e), yrt(i, t);
}
const Mrt = In(Trt, "vtkOpenGLPixelSpaceCallbackMapper");
Js("vtkPixelSpaceCallbackMapper", Mrt);
const oj = /* @__PURE__ */ Object.create(null);
function Xo(i, t) {
  oj[i] = t;
}
function Nrt(i, t) {
  t.classHierarchy.push("vtkWebGPUViewNodeFactory");
}
const Wrt = {};
function Grt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Wrt, e), t.overrides = oj, g9.extend(i, t, e), Nrt(i, t);
}
tt.newInstance(Grt, "vtkWebGPUViewNodeFactory");
function wrt(i, t) {
  t.classHierarchy.push("vtkWebGPUCamera"), i.getProjectionMatrix = (e, n, s, r) => {
    if (ut.identity(e), t.renderable.getParallelProjection()) {
      const a = t.renderable.getParallelScale(), o = a * n, l = a, c = (r[0] - 1) * o, u = (r[0] + 1) * o, d = (r[1] - 1) * l, h = (r[1] + 1) * l, p = 1 / (u - c), m = 1 / (h - d);
      e[0] = 2 * p, e[5] = 2 * m, e[10] = 1 / (s[1] - s[0]), e[12] = (u + c) * p, e[13] = (h + d) * m, e[14] = s[1] / (s[1] - s[0]);
    } else {
      const a = Math.tan(Math.PI * t.renderable.getViewAngle() / 360);
      let o, l;
      t.renderable.getUseHorizontalViewAngle() === !0 ? (o = s[0] * a, l = s[0] * a / n) : (o = s[0] * a * n, l = s[0] * a);
      const c = (r[0] - 1) * o, u = (r[0] + 1) * o, d = (r[1] - 1) * l, h = (r[1] + 1) * l;
      e[0] = 2 * s[0] / (u - c), e[5] = 2 * s[0] / (h - d), e[12] = (c + u) / (u - c), e[13] = (d + h) / (h - d), e[10] = 0, e[14] = s[0], e[11] = -1, e[15] = 0;
    }
  }, i.convertToOpenGLDepth = (e) => {
    if (t.renderable.getParallelProjection())
      return 1 - e;
    const n = t.renderable.getClippingRangeByReference();
    let s = -n[0] / e;
    return s = (n[0] + n[1]) / (n[1] - n[0]) + 2 * n[0] * n[1] / (s * (n[1] - n[0])), 0.5 * s + 0.5;
  }, i.getKeyMatrices = (e) => {
    const n = e.getRenderable(), s = e.getParent();
    if (Math.max(s.getMTime(), i.getMTime(), n.getMTime(), t.renderable.getMTime(), e.getStabilizedTime()) > t.keyMatrixTime.getMTime()) {
      const r = t.renderable.getViewMatrix();
      ut.copy(t.keyMatrices.normalMatrix, r), t.keyMatrices.normalMatrix[3] = 0, t.keyMatrices.normalMatrix[7] = 0, t.keyMatrices.normalMatrix[11] = 0, ut.invert(t.keyMatrices.normalMatrix, t.keyMatrices.normalMatrix), ut.transpose(t.keyMatrices.wcvc, r);
      const a = e.getStabilizedCenterByReference();
      ut.translate(t.keyMatrices.scvc, t.keyMatrices.wcvc, a);
      const o = e.getAspectRatio(), l = t.renderable.getClippingRangeByReference();
      i.getProjectionMatrix(t.keyMatrices.vcpc, o, l, t.renderable.getWindowCenterByReference()), ut.multiply(t.keyMatrices.scpc, t.keyMatrices.vcpc, t.keyMatrices.scvc), ut.invert(t.keyMatrices.pcsc, t.keyMatrices.scpc), t.keyMatrixTime.modified();
    }
    return t.keyMatrices;
  };
}
const xrt = {
  keyMatrixTime: null,
  keyMatrices: null
};
function Srt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, xrt, e), ui.extend(i, t, e), t.keyMatrixTime = {}, tt.obj(t.keyMatrixTime), t.keyMatrices = {
    normalMatrix: new Float64Array(16),
    vcpc: new Float64Array(16),
    pcsc: new Float64Array(16),
    wcvc: new Float64Array(16),
    scpc: new Float64Array(16),
    scvc: new Float64Array(16)
  }, tt.setGet(i, t, ["keyMatrixTime"]), wrt(i, t);
}
const Lrt = tt.newInstance(Srt);
Xo("vtkCamera", Lrt);
function Vrt(i, t) {
  t.classHierarchy.push("vtkWebGPUBindGroup"), i.setBindables = (e) => {
    if (t.bindables.length === e.length) {
      let n = !0;
      for (let s = 0; s < t.bindables.length; s++)
        t.bindables[s] !== e[s] && (n = !1);
      if (n)
        return;
    }
    t.bindables = e, i.modified();
  }, i.getBindGroupLayout = (e) => {
    const n = [];
    for (let s = 0; s < t.bindables.length; s++) {
      const r = t.bindables[s].getBindGroupLayoutEntry();
      r.binding = s, n.push(r);
    }
    return e.getBindGroupLayout({
      entries: n
    });
  }, i.getBindGroup = (e) => {
    let n = i.getMTime();
    for (let r = 0; r < t.bindables.length; r++) {
      const a = t.bindables[r].getBindGroupTime().getMTime();
      n = a > n ? a : n;
    }
    if (n < t.bindGroupTime.getMTime())
      return t.bindGroup;
    const s = [];
    for (let r = 0; r < t.bindables.length; r++) {
      const a = t.bindables[r].getBindGroupEntry();
      a.binding = r, s.push(a);
    }
    return t.bindGroup = e.getHandle().createBindGroup({
      layout: i.getBindGroupLayout(e),
      entries: s,
      label: t.label
    }), t.bindGroupTime.modified(), t.bindGroup;
  }, i.getShaderCode = (e) => {
    const n = [], s = e.getBindGroupLayoutCount(t.label);
    for (let r = 0; r < t.bindables.length; r++)
      n.push(t.bindables[r].getShaderCode(r, s));
    return n.join(`
`);
  };
}
const Xrt = {
  device: null,
  handle: null,
  label: null
};
function lj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Xrt, e), tt.obj(i, t), t.bindables = [], t.bindGroupTime = {}, tt.obj(t.bindGroupTime, {
    mtime: 0
  }), tt.get(i, t, ["bindGroupTime", "handle", "sizeInBytes", "usage"]), tt.setGet(i, t, ["label", "device", "arrayInformation"]), Vrt(i, t);
}
const Irt = tt.newInstance(lj);
var cj = {
  newInstance: Irt,
  extend: lj
};
function Crt(i, t) {
  t.classHierarchy.push("vtkWebGPUShaderModule"), i.initialize = (e, n) => {
    t.device = e, t.handle = t.device.getHandle().createShaderModule({
      code: n.getCode()
    });
  };
}
const Yrt = {
  device: null,
  handle: null
};
function uj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Yrt, e), tt.obj(i, t), tt.get(i, t, ["lastCameraMTime"]), tt.setGet(i, t, ["device", "handle"]), Crt(i, t);
}
const vrt = tt.newInstance(uj, "vtkWebGPUShaderModule");
var Rrt = {
  newInstance: vrt,
  extend: uj
};
function Drt(i, t, e) {
  let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
  const s = Array.isArray(e) ? e.join(`
`) : e;
  let r = !1;
  i.search(t) !== -1 && (r = !0);
  let a = "";
  n && (a = "g");
  const o = new RegExp(t, a), l = i.replace(o, s);
  return {
    replace: r,
    result: l
  };
}
function Ort(i, t) {
  t.classHierarchy.push("vtkWebGPUShaderCache"), i.getShaderModule = (e) => {
    const n = e.getType(), s = e.getHash(), r = t._shaderModules.keys();
    for (let o = 0; o < r.length; o++) {
      const l = r[o];
      if (l.getHash() === s && l.getType() === n)
        return t._shaderModules.get(l);
    }
    const a = Rrt.newInstance();
    return a.initialize(t.device, e), t._shaderModules.set(e, a), a;
  };
}
const zrt = {
  shaderModules: null,
  device: null,
  window: null
};
function dj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, zrt, e), t._shaderModules = /* @__PURE__ */ new Map(), tt.obj(i, t), tt.setGet(i, t, ["device", "window"]), Ort(i, t);
}
const Ert = tt.newInstance(dj, "vtkWebGPUShaderCache");
var kn = {
  newInstance: Ert,
  extend: dj,
  substitute: Drt
};
function krt(i, t) {
  t.classHierarchy.push("vtkWebGPUPipeline"), i.getShaderDescriptions = () => t.shaderDescriptions, i.initialize = (e, n) => {
    t.pipelineDescription = t.renderEncoder.getPipelineSettings(), t.pipelineDescription.primitive.topology = t.topology, t.pipelineDescription.vertex = t.vertexState, t.pipelineDescription.label = n;
    const s = [];
    for (let r = 0; r < t.layouts.length; r++)
      s.push(t.layouts[r].layout);
    t.pipelineLayout = e.getHandle().createPipelineLayout({
      bindGroupLayouts: s
    }), t.pipelineDescription.layout = t.pipelineLayout;
    for (let r = 0; r < t.shaderDescriptions.length; r++) {
      const a = t.shaderDescriptions[r], o = e.getShaderModule(a);
      a.getType() === "vertex" && (t.pipelineDescription.vertex.module = o.getHandle(), t.pipelineDescription.vertex.entryPoint = "main"), a.getType() === "fragment" && (t.pipelineDescription.fragment.module = o.getHandle(), t.pipelineDescription.fragment.entryPoint = "main");
    }
    t.handle = e.getHandle().createRenderPipeline(t.pipelineDescription);
  }, i.getShaderDescription = (e) => {
    for (let n = 0; n < t.shaderDescriptions.length; n++)
      if (t.shaderDescriptions[n].getType() === e) return t.shaderDescriptions[n];
    return null;
  }, i.addBindGroupLayout = (e) => {
    e && t.layouts.push({
      layout: e.getBindGroupLayout(t.device),
      label: e.getLabel()
    });
  }, i.getBindGroupLayout = (e) => t.layouts[e].layout, i.getBindGroupLayoutCount = (e) => {
    for (let n = 0; n < t.layouts.length; n++)
      if (t.layouts[n].label === e)
        return n;
    return 0;
  }, i.bindVertexInput = (e, n) => {
    n.bindBuffers(e);
  };
}
const Frt = {
  handle: null,
  layouts: null,
  renderEncoder: null,
  shaderDescriptions: null,
  vertexState: null,
  topology: null,
  pipelineDescription: null
};
function hj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Frt, e), xi(i, t), t.layouts = [], t.shaderDescriptions = [], Sa(i, t, ["handle", "pipelineDescription"]), gs(i, t, ["device", "renderEncoder", "topology", "vertexState"]), krt(i, t);
}
const jrt = In(hj, "vtkWebGPUPipeline");
var Urt = {
  newInstance: jrt,
  extend: hj
};
function Prt(i, t) {
  t.classHierarchy.push("vtkWebGPUShaderDescription"), i.hasOutput = (e) => t.outputNames.includes(e), i.addOutput = function(e, n) {
    let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0;
    t.outputTypes.push(e), t.outputNames.push(n), t.outputInterpolations.push(s);
  }, i.addBuiltinOutput = (e, n) => {
    t.builtinOutputTypes.push(e), t.builtinOutputNames.push(n);
  }, i.addBuiltinInput = (e, n) => {
    t.builtinInputTypes.push(e), t.builtinInputNames.push(n);
  }, i.replaceShaderCode = (e, n) => {
    const s = [];
    let r = [];
    if (n && s.push(n.getShaderCode()), e || t.builtinInputNames.length) {
      const a = [];
      if (a.push(`struct ${t.type}Input
{`), e) {
        const o = e.getOutputNamesByReference(), l = e.getOutputTypesByReference(), c = e.getOutputInterpolationsByReference();
        for (let u = 0; u < o.length; u++)
          c[u] !== void 0 ? a.push(`  @location(${u}) @interpolate(${c[u]}) ${o[u]} : ${l[u]},`) : a.push(`  @location(${u}) ${o[u]} : ${l[u]},`);
      }
      for (let o = 0; o < t.builtinInputNames.length; o++)
        a.push(`  ${t.builtinInputNames[o]} : ${t.builtinInputTypes[o]},`);
      a.length > 1 && (a.push("};"), r = a, s[s.length - 1] += ",", s.push(`input: ${t.type}Input`));
    }
    if (s.length && (t.code = kn.substitute(t.code, "//VTK::IOStructs::Input", s).result), t.outputNames.length + t.builtinOutputNames.length) {
      const a = [`struct ${t.type}Output
{`];
      for (let o = 0; o < t.outputNames.length; o++)
        t.outputInterpolations[o] !== void 0 ? a.push(`  @location(${o}) @interpolate(${t.outputInterpolations[o]}) ${t.outputNames[o]} : ${t.outputTypes[o]},`) : a.push(`  @location(${o}) ${t.outputNames[o]} : ${t.outputTypes[o]},`);
      for (let o = 0; o < t.builtinOutputNames.length; o++)
        a.push(`  ${t.builtinOutputNames[o]} : ${t.builtinOutputTypes[o]},`);
      a.push("};"), r = r.concat(a), t.code = kn.substitute(t.code, "//VTK::IOStructs::Output", [`-> ${t.type}Output`]).result;
    }
    t.code = kn.substitute(t.code, "//VTK::IOStructs::Dec", r).result;
  };
}
const Jrt = {
  type: null,
  // 'vertex' or 'fragment'
  hash: null,
  code: null,
  outputNames: null,
  outputTypes: null
};
function pj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Jrt, e), t.outputNames = [], t.outputTypes = [], t.outputInterpolations = [], t.builtinOutputNames = [], t.builtinOutputTypes = [], t.builtinInputNames = [], t.builtinInputTypes = [], tt.obj(i, t), tt.setGet(i, t, ["type", "hash", "code"]), tt.getArray(i, t, ["outputTypes", "outputNames", "outputInterpolations"]), Prt(i, t);
}
const Art = tt.newInstance(pj, "vtkWebGPUShaderDescription");
var rO = {
  newInstance: Art,
  extend: pj
};
const aO = {
  // 8-bit formats
  r8unorm: {
    numComponents: 1,
    nativeType: Uint8Array,
    stride: 1,
    elementSize: 1,
    sampleType: "float"
  },
  r8snorm: {
    numComponents: 1,
    nativeType: Int8Array,
    stride: 1,
    elementSize: 1,
    sampleType: "float"
  },
  r8uint: {
    numComponents: 1,
    nativeType: Uint8Array,
    stride: 1,
    elementSize: 1,
    sampleType: "uint"
  },
  r8sint: {
    numComponents: 1,
    nativeType: Int8Array,
    stride: 1,
    elementSize: 1,
    sampleType: "sint"
  },
  // 16-bit formats
  r16uint: {
    numComponents: 1,
    nativeType: Uint16Array,
    stride: 2,
    elementSize: 2,
    sampleType: "uint"
  },
  r16sint: {
    numComponents: 1,
    nativeType: Int16Array,
    stride: 2,
    elementSize: 2,
    sampleType: "sint"
  },
  r16float: {
    numComponents: 1,
    nativeType: Float32Array,
    stride: 2,
    elementSize: 2,
    sampleType: "float"
  },
  rg8unorm: {
    numComponents: 2,
    nativeType: Uint8Array,
    stride: 2,
    elementSize: 1,
    sampleType: "float"
  },
  rg8snorm: {
    numComponents: 2,
    nativeType: Int8Array,
    stride: 2,
    elementSize: 1,
    sampleType: "float"
  },
  rg8uint: {
    numComponents: 2,
    nativeType: Uint8Array,
    stride: 2,
    elementSize: 1,
    sampleType: "uint"
  },
  rg8sint: {
    numComponents: 2,
    nativeType: Int8Array,
    stride: 2,
    elementSize: 1,
    sampleType: "sint"
  },
  // 32-bit formats
  r32uint: {
    numComponents: 1,
    nativeType: Uint32Array,
    stride: 4,
    elementSize: 4,
    sampleType: "uint"
  },
  r32sint: {
    numComponents: 1,
    nativeType: Int32Array,
    stride: 4,
    elementSize: 4,
    sampleType: "sint"
  },
  r32float: {
    numComponents: 1,
    nativeType: Float32Array,
    stride: 4,
    elementSize: 4,
    sampleType: "unfilterable-float"
  },
  rg16uint: {
    numComponents: 2,
    nativeType: Uint16Array,
    stride: 4,
    elementSize: 2,
    sampleType: "uint"
  },
  rg16sint: {
    numComponents: 2,
    nativeType: Int16Array,
    stride: 4,
    elementSize: 2,
    sampleType: "sint"
  },
  rg16float: {
    numComponents: 2,
    nativeType: Float32Array,
    stride: 4,
    elementSize: 2,
    sampleType: "float"
  },
  rgba8unorm: {
    numComponents: 4,
    nativeType: Uint8Array,
    stride: 4,
    elementSize: 1,
    sampleType: "float"
  },
  "rgba8unorm-srgb": {
    numComponents: 4,
    nativeType: Uint8Array,
    stride: 4,
    elementSize: 1,
    sampleType: "float"
  },
  rgba8snorm: {
    numComponents: 4,
    nativeType: Int8Array,
    stride: 4,
    elementSize: 1,
    sampleType: "float"
  },
  rgba8uint: {
    numComponents: 4,
    nativeType: Uint8Array,
    stride: 4,
    elementSize: 1,
    sampleType: "uint"
  },
  rgba8sint: {
    numComponents: 4,
    nativeType: Int8Array,
    stride: 4,
    elementSize: 1,
    sampleType: "sint"
  },
  bgra8unorm: {
    numComponents: 4,
    nativeType: Uint8Array,
    stride: 4,
    elementSize: 1,
    sampleType: "float"
  },
  "bgra8unorm-srgb": {
    numComponents: 4,
    nativeType: Uint8Array,
    stride: 4,
    elementSize: 1,
    sampleType: "float"
  },
  // Packed 32-bit formats
  rgb9e5ufloat: {
    numComponents: 4,
    nativeType: Uint32Array,
    stride: 4,
    sampleType: "float"
  },
  rgb10a2unorm: {
    numComponents: 4,
    nativeType: Uint32Array,
    stride: 4,
    sampleType: "float"
  },
  rg11b10ufloat: {
    numComponents: 4,
    nativeType: Float32Array,
    stride: 4,
    sampleType: "float"
  },
  // 64-bit formats
  rg32uint: {
    numComponents: 2,
    nativeType: Uint32Array,
    stride: 8,
    elementSize: 4,
    sampleType: "uint"
  },
  rg32sint: {
    numComponents: 2,
    nativeType: Int32Array,
    stride: 8,
    elementSize: 4,
    sampleType: "sint"
  },
  rg32float: {
    numComponents: 2,
    nativeType: Float32Array,
    stride: 8,
    elementSize: 4,
    sampleType: "unfilterable-float"
  },
  rgba16uint: {
    numComponents: 4,
    nativeType: Uint16Array,
    stride: 8,
    elementSize: 2,
    sampleType: "uint"
  },
  rgba16sint: {
    numComponents: 4,
    nativeType: Int16Array,
    stride: 8,
    elementSize: 2,
    sampleType: "sint"
  },
  rgba16float: {
    numComponents: 4,
    nativeType: Float32Array,
    stride: 8,
    elementSize: 2,
    sampleType: "float"
  },
  // 128-bit formats
  rgba32uint: {
    numComponents: 4,
    nativeType: Uint32Array,
    stride: 16,
    elementSize: 4,
    sampleType: "uint"
  },
  rgba32sint: {
    numComponents: 4,
    nativeType: Int32Array,
    stride: 16,
    elementSize: 4,
    sampleType: "sint"
  },
  rgba32float: {
    numComponents: 4,
    nativeType: Float32Array,
    stride: 16,
    elementSize: 4,
    sampleType: "unfilterable-float"
  },
  // Depth and stencil formats
  stencil8: {
    numComponents: 1,
    nativeType: Uint8Array,
    stride: 1,
    elementSize: 1,
    sampleType: "uint"
  },
  depth16unorm: {
    numComponents: 1,
    nativeType: Uint16Array,
    stride: 2,
    elementSize: 2,
    sampleType: "depth"
  },
  depth24plus: {
    numComponents: 1,
    nativeType: Uint32Array,
    stride: 4,
    elementSize: 3,
    sampleType: "depth"
  },
  "depth24plus-stencil8": {
    numComponents: 2,
    nativeType: Uint32Array,
    stride: 4,
    sampleType: "mixed"
  },
  depth32float: {
    numComponents: 1,
    nativeType: Float32Array,
    stride: 4,
    elementSize: 4,
    sampleType: "depth"
  }
};
function Brt(i) {
  return !i || i.length < 6 ? 0 : i in aO ? aO[i] : (Zn(`unknown format ${i}`), null);
}
function Krt(i) {
  if (!i || i.length < 5) return 0;
  let t = 1;
  i[i.length - 2] === "x" && (t = Number(i[i.length - 1]));
  const e = t === 1 ? i.length - 1 : i.length - 3, n = Number(i[e]);
  if (Number.isNaN(n))
    return Zn(`unknown format ${i}`), 0;
  const s = 5 - n / 2;
  return t * s;
}
function Hrt(i) {
  if (!i || i.length < 5) return 0;
  let t = 1;
  return i[i.length - 2] === "x" && (t = Number(i[i.length - 1])), t;
}
function _rt(i) {
  if (!i || i.length < 5) return 0;
  let t;
  if (i[0] === "f")
    t = "Float";
  else if (i[0] === "s")
    t = "Int";
  else if (i[0] === "u")
    t = "Uint";
  else {
    Zn(`unknown format ${i}`);
    return;
  }
  const e = i.split("x")[0], n = Number(e[e.length - 1]);
  if (Number.isNaN(n)) {
    Zn(`unknown format ${i}`);
    return;
  }
  return t += 8 * (5 - n / 2), t += "Array", t;
}
function Qrt(i) {
  let t;
  if (i[0] === "f" || i[1] === "n")
    t = "f32";
  else if (i[0] === "s" && i[1] === "i")
    t = "i32";
  else if (i[0] === "u" && i[1] === "i")
    t = "u32";
  else {
    Zn(`unknown format ${i}`);
    return;
  }
  let e = 1;
  return i[i.length - 2] === "x" && (e = Number(i[i.length - 1])), e === 4 ? `vec4<${t}>` : e === 3 ? `vec3<${t}>` : e === 2 ? `vec2<${t}>` : t;
}
function $rt(i) {
  if (!i) return 0;
  let t = 1;
  return i.substring(0, 3) === "vec" ? t = Number(i[3]) : i.substring(0, 3) === "mat" && (t = i[3] * i[5]), t * 4;
}
function qrt(i) {
  if (i) {
    if (i.includes("f32")) return "Float32Array";
    if (i.includes("i32")) return "Int32Array";
    if (i.includes("u32")) return "Uint32Array";
    Zn(`unknown format ${i}`);
  }
}
var Rr = {
  getDetailsFromTextureFormat: Brt,
  getByteStrideFromBufferFormat: Krt,
  getNumberOfComponentsFromBufferFormat: Hrt,
  getNativeTypeFromBufferFormat: _rt,
  getShaderTypeFromBufferFormat: Qrt,
  getByteStrideFromShaderFormat: $rt,
  getNativeTypeFromShaderFormat: qrt
};
function tat(i, t) {
  if (i === t) return !0;
  if (i == null || t == null || i.length !== t.length) return !1;
  for (let e = 0; e < i.length; ++e)
    if (!t.includes(i[e])) return !1;
  return !0;
}
function eat(i, t) {
  t.classHierarchy.push("vtkWebGPUVertexInput"), i.addBuffer = function(e, n) {
    let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "vertex", r = n;
    Array.isArray(r) || (r = [r]);
    for (let a = 0; a < t.inputs.length; a++)
      if (tat(t.inputs[a].names, r)) {
        if (t.inputs[a].buffer === e)
          return;
        t.inputs[a].buffer = e;
        return;
      }
    t.inputs.push({
      buffer: e,
      stepMode: s,
      names: r
    }), t.inputs = t.inputs.sort((a, o) => a.names[0] < o.names[0] ? -1 : a.names[0] > o.names[0] ? 1 : 0);
  }, i.removeBufferIfPresent = (e) => {
    for (let n = 0; n < t.inputs.length; n++)
      t.inputs[n].names.includes(e) && t.inputs.splice(n, 1);
  }, i.getBuffer = (e) => {
    for (let n = 0; n < t.inputs.length; n++)
      if (t.inputs[n].names.includes(e))
        return t.inputs[n].buffer;
    return null;
  }, i.hasAttribute = (e) => {
    for (let n = 0; n < t.inputs.length; n++)
      if (t.inputs[n].names.includes(e))
        return !0;
    return !1;
  }, i.getAttributeTime = (e) => {
    for (let n = 0; n < t.inputs.length; n++)
      if (t.inputs[n].names.includes(e))
        return t.inputs[n].buffer.getSourceTime();
    return 0;
  }, i.getShaderCode = () => {
    let e = "", n = 0;
    for (let s = 0; s < t.inputs.length; s++)
      for (let r = 0; r < t.inputs[s].names.length; r++) {
        const a = t.inputs[s].buffer.getArrayInformation()[r], o = Rr.getShaderTypeFromBufferFormat(a.format);
        n > 0 && (e += `,
`), e = `${e}  @location(${n}) ${t.inputs[s].names[r]} : ${o}`, n++;
      }
    return e;
  }, i.getVertexInputInformation = () => {
    const e = {};
    if (t.inputs.length) {
      const n = [];
      let s = 0;
      for (let r = 0; r < t.inputs.length; r++) {
        const a = t.inputs[r].buffer, o = {
          arrayStride: a.getStrideInBytes(),
          stepMode: t.inputs[r].stepMode,
          attributes: []
        }, l = a.getArrayInformation();
        for (let c = 0; c < t.inputs[r].names.length; c++)
          o.attributes.push({
            shaderLocation: s,
            offset: l[c].offset,
            format: l[c].format
          }), s++;
        n.push(o);
      }
      e.buffers = n;
    }
    return e;
  }, i.bindBuffers = (e) => {
    for (let n = 0; n < t.inputs.length; n++)
      e.setVertexBuffer(n, t.inputs[n].buffer.getHandle());
    t.indexBuffer && e.setIndexBuffer(t.indexBuffer.getHandle(), t.indexBuffer.getArrayInformation()[0].format);
  }, i.getReady = () => {
  }, i.releaseGraphicsResources = () => {
    t.created && (t.inputs = [], t.bindingDescriptions = [], t.attributeDescriptions = []);
  };
}
const nat = {
  inputs: null,
  bindingDescriptions: !1,
  attributeDescriptions: null,
  indexBuffer: null
};
function mj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, nat, e), xi(i, t), t.bindingDescriptions = [], t.attributeDescriptions = [], t.inputs = [], gs(i, t, ["created", "device", "handle", "indexBuffer"]), eat(i, t);
}
const iat = In(mj, "vtkWebGPUVertexInput");
var sat = {
  newInstance: iat,
  extend: mj
};
const rat = `
//VTK::Renderer::Dec

//VTK::Color::Dec

//VTK::Normal::Dec

//VTK::TCoord::Dec

//VTK::Select::Dec

//VTK::Mapper::Dec

//VTK::IOStructs::Dec

@vertex
fn main(
//VTK::IOStructs::Input
)
//VTK::IOStructs::Output
{
  var output : vertexOutput;

  // var vertex: vec4<f32> = vertexBC;

  //VTK::Color::Impl

  //VTK::Normal::Impl

  //VTK::TCoord::Impl

  //VTK::Select::Impl

  //VTK::Position::Impl

  return output;
}
`, aat = `
//VTK::Renderer::Dec

//VTK::Color::Dec

//VTK::Normal::Dec

//VTK::TCoord::Dec

//VTK::Select::Dec

//VTK::RenderEncoder::Dec

//VTK::Mapper::Dec

//VTK::IOStructs::Dec

@fragment
fn main(
//VTK::IOStructs::Input
)
//VTK::IOStructs::Output
{
  var output : fragmentOutput;

  //VTK::Color::Impl

  //VTK::Normal::Impl

  //VTK::Light::Impl

  //VTK::TCoord::Impl

  //VTK::Select::Impl

  // var computedColor:vec4<f32> = vec4<f32>(1.0,0.5,0.5,1.0);

  //VTK::RenderEncoder::Impl
  return output;
}
`;
function oat(i, t) {
  t.classHierarchy.push("vtkWebGPUSimpleMapper"), i.generateShaderDescriptions = (e, n, s) => {
    const r = rO.newInstance({
      type: "vertex",
      hash: e,
      code: t.vertexShaderTemplate
    }), a = rO.newInstance({
      type: "fragment",
      hash: e,
      code: t.fragmentShaderTemplate
    }), o = n.getShaderDescriptions();
    o.push(r), o.push(a);
    const l = t.vertexShaderTemplate + t.fragmentShaderTemplate, c = new RegExp("//VTK::[^:]*::", "g"), d = l.match(c).filter((h, p, m) => m.indexOf(h) === p).map((h) => `replaceShader${h.substring(7, h.length - 2)}`);
    for (let h = 0; h < d.length; h++) {
      const p = d[h];
      p !== "replaceShaderIOStructs" && t.shaderReplacements.has(p) && t.shaderReplacements.get(p)(e, n, s);
    }
    i.replaceShaderIOStructs(e, n, s);
  }, i.replaceShaderIOStructs = (e, n, s) => {
    const r = n.getShaderDescription("vertex");
    r.replaceShaderCode(null, s), n.getShaderDescription("fragment").replaceShaderCode(r);
  }, i.replaceShaderRenderEncoder = (e, n, s) => {
    t.renderEncoder.replaceShaderCode(n);
  }, t.shaderReplacements.set("replaceShaderRenderEncoder", i.replaceShaderRenderEncoder), i.replaceShaderRenderer = (e, n, s) => {
    if (!t.WebGPURenderer)
      return;
    const r = t.WebGPURenderer.getBindGroup().getShaderCode(n), a = n.getShaderDescription("vertex");
    let o = a.getCode();
    o = kn.substitute(o, "//VTK::Renderer::Dec", [r]).result, a.setCode(o);
    const l = n.getShaderDescription("fragment");
    o = l.getCode(), o = kn.substitute(o, "//VTK::Renderer::Dec", [r]).result, l.setCode(o);
  }, t.shaderReplacements.set("replaceShaderRenderer", i.replaceShaderRenderer), i.replaceShaderMapper = (e, n, s) => {
    const r = t.bindGroup.getShaderCode(n), a = n.getShaderDescription("vertex");
    let o = a.getCode();
    o = kn.substitute(o, "//VTK::Mapper::Dec", [r]).result, a.setCode(o);
    const l = n.getShaderDescription("fragment");
    l.addBuiltinInput("bool", "@builtin(front_facing) frontFacing"), o = l.getCode(), o = kn.substitute(o, "//VTK::Mapper::Dec", [r]).result, l.setCode(o);
  }, t.shaderReplacements.set("replaceShaderMapper", i.replaceShaderMapper), i.replaceShaderPosition = (e, n, s) => {
    const r = n.getShaderDescription("vertex");
    r.addBuiltinOutput("vec4<f32>", "@builtin(position) Position");
    let a = r.getCode();
    a = kn.substitute(a, "//VTK::Position::Impl", ["    output.Position = rendererUBO.SCPCMatrix*vertexBC;"]).result, r.setCode(a);
  }, t.shaderReplacements.set("replaceShaderPosition", i.replaceShaderPosition), i.replaceShaderTCoord = (e, n, s) => {
    n.getShaderDescription("vertex").addOutput("vec2<f32>", "tcoordVS");
  }, t.shaderReplacements.set("replaceShaderTCoord", i.replaceShaderTCoord), i.addTextureView = (e) => {
    t.textureViews.includes(e) || t.textureViews.push(e);
  }, i.prepareToDraw = (e) => {
    t.renderEncoder = e, i.updateInput(), i.updateBuffers(), i.updateBindings(), i.updatePipeline();
  }, i.updateInput = () => {
  }, i.updateBuffers = () => {
  }, i.updateBindings = () => {
    t.bindGroup.setBindables(i.getBindables());
  }, i.computePipelineHash = () => {
  }, i.registerDrawCallback = (e) => {
    e.registerDrawCallback(t.pipeline, i.draw);
  }, i.prepareAndDraw = (e) => {
    i.prepareToDraw(e), e.setPipeline(t.pipeline), i.draw(e);
  }, i.draw = (e) => {
    const n = e.getBoundPipeline();
    e.activateBindGroup(t.bindGroup), t.WebGPURenderer && t.WebGPURenderer.bindUBO(e), n.bindVertexInput(e, t.vertexInput);
    const s = t.vertexInput.getIndexBuffer();
    s ? e.drawIndexed(s.getIndexCount(), t.numberOfInstances, 0, 0, 0) : e.draw(t.numberOfVertices, t.numberOfInstances, 0, 0);
  }, i.getBindables = () => {
    const e = [...t.additionalBindables];
    t.UBO && e.push(t.UBO), t.SSBO && e.push(t.SSBO);
    for (let n = 0; n < t.textureViews.length; n++) {
      e.push(t.textureViews[n]);
      const s = t.textureViews[n].getSampler();
      s && e.push(s);
    }
    return e;
  }, i.updatePipeline = () => {
    i.computePipelineHash(), t.pipeline = t.device.getPipeline(t.pipelineHash), t.pipeline || (t.pipeline = Urt.newInstance(), t.pipeline.setDevice(t.device), t.WebGPURenderer && t.pipeline.addBindGroupLayout(t.WebGPURenderer.getBindGroup()), t.pipeline.addBindGroupLayout(t.bindGroup), i.generateShaderDescriptions(t.pipelineHash, t.pipeline, t.vertexInput), t.pipeline.setTopology(t.topology), t.pipeline.setRenderEncoder(t.renderEncoder), t.pipeline.setVertexState(t.vertexInput.getVertexInputInformation()), t.device.createPipeline(t.pipelineHash, t.pipeline));
  };
}
const lat = {
  additionalBindables: void 0,
  bindGroup: null,
  device: null,
  fragmentShaderTemplate: null,
  numberOfInstances: 1,
  numberOfVertices: 0,
  pipelineHash: null,
  shaderReplacements: null,
  SSBO: null,
  textureViews: null,
  topology: "triangle-list",
  UBO: null,
  vertexShaderTemplate: null,
  WebGPURenderer: null
};
function bj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, lat, e), ui.extend(i, t, e), t.textureViews = [], t.vertexInput = sat.newInstance(), t.bindGroup = cj.newInstance({
    label: "mapperBG"
  }), t.additionalBindables = [], t.fragmentShaderTemplate = t.fragmentShaderTemplate || aat, t.vertexShaderTemplate = t.vertexShaderTemplate || rat, t.shaderReplacements = /* @__PURE__ */ new Map(), tt.get(i, t, ["pipeline", "vertexInput"]), tt.setGet(i, t, ["additionalBindables", "device", "fragmentShaderTemplate", "interpolate", "numberOfInstances", "numberOfVertices", "pipelineHash", "shaderReplacements", "SSBO", "textureViews", "topology", "UBO", "vertexShaderTemplate", "WebGPURenderer"]), oat(i, t);
}
const cat = tt.newInstance(bj, "vtkWebGPUSimpleMapper");
var fj = {
  newInstance: cat,
  extend: bj
};
function uat(i, t) {
  t.classHierarchy.push("vtkWebGPUFullScreenQuad"), i.replaceShaderPosition = (e, n, s) => {
    const r = n.getShaderDescription("vertex");
    r.addBuiltinOutput("vec4<f32>", "@builtin(position) Position"), r.addOutput("vec4<f32>", "vertexVC");
    let a = r.getCode();
    a = kn.substitute(a, "//VTK::Position::Impl", ["output.tcoordVS = vec2<f32>(vertexBC.x * 0.5 + 0.5, 1.0 - vertexBC.y * 0.5 - 0.5);", "output.Position = vec4<f32>(vertexBC, 1.0);", "output.vertexVC = vec4<f32>(vertexBC, 1);"]).result, r.setCode(a);
  }, t.shaderReplacements.set("replaceShaderPosition", i.replaceShaderPosition), i.updateBuffers = () => {
    const e = t.device.getBufferManager().getFullScreenQuadBuffer();
    t.vertexInput.addBuffer(e, ["vertexBC"]), t.numberOfVertices = 6;
  };
}
const dat = {};
function gj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, dat, e), fj.extend(i, t, e), uat(i, t);
}
const hat = tt.newInstance(gj, "vtkWebGPUFullScreenQuad");
var pL = {
  newInstance: hat,
  extend: gj
};
const pat = {
  Verts: 0,
  Lines: 1,
  Triangles: 2,
  Strips: 3,
  LinesFromStrips: 4,
  LinesFromTriangles: 5,
  Points: 6,
  UniformArray: 7,
  PointArray: 8,
  NormalsFromPoints: 9,
  Texture: 10,
  RawVertex: 11,
  Storage: 12,
  Index: 13
}, mat = {
  Start: 0,
  Points: 0,
  Lines: 1,
  Triangles: 2,
  TriangleStrips: 3,
  TriangleEdges: 4,
  TriangleStripEdges: 5,
  End: 6
};
var CT = {
  BufferUsage: pat,
  PrimitiveTypes: mat
};
const Fx = ["getMappedRange", "mapAsync", "unmap"];
function bat(i, t, e, n) {
  const s = n.byteLength, r = i.createBuffer({
    size: s,
    /* eslint-disable no-undef */
    usage: GPUBufferUsage.COPY_SRC,
    /* eslint-enable no-undef */
    mappedAtCreation: !0
  }), a = r.getMappedRange(0, s);
  new Uint8Array(a).set(new Uint8Array(n)), r.unmap();
  const o = i.createCommandEncoder();
  o.copyBufferToBuffer(r, 0, t, e, s);
  const l = o.finish();
  i.queue.submit([l]), r.destroy();
}
function fat(i, t) {
  t.classHierarchy.push("vtkWebGPUBuffer"), i.create = (e, n) => {
    t.handle = t.device.getHandle().createBuffer({
      size: e,
      usage: n,
      label: t.label
    }), t.sizeInBytes = e, t.usage = n;
  }, i.write = (e) => {
    bat(t.device.getHandle(), t.handle, 0, e.buffer);
  }, i.createAndWrite = (e, n) => {
    t.handle = t.device.getHandle().createBuffer({
      size: e.byteLength,
      usage: n,
      mappedAtCreation: !0,
      label: t.label
    }), t.sizeInBytes = e.byteLength, t.usage = n, new Uint8Array(t.handle.getMappedRange()).set(new Uint8Array(e.buffer)), t.handle.unmap();
  };
  for (let e = 0; e < Fx.length; e++)
    i[Fx[e]] = function() {
      return t.handle[Fx[e]](...arguments);
    };
}
const gat = {
  device: null,
  handle: null,
  sizeInBytes: 0,
  strideInBytes: 0,
  arrayInformation: null,
  usage: null,
  label: null,
  sourceTime: null
};
function yj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, gat, e), tt.obj(i, t), tt.get(i, t, ["handle", "sizeInBytes", "usage"]), tt.setGet(i, t, ["strideInBytes", "device", "arrayInformation", "label", "sourceTime"]), fat(i, t);
}
const yat = tt.newInstance(yj);
var mL = {
  newInstance: yat,
  extend: yj,
  ...CT
};
const {
  Representation: oO
} = V0, {
  PrimitiveTypes: Ed
} = CT;
class Zat {
  constructor() {
    this.keys = new Uint32Array(10), this.values = new Uint32Array(10), this.count = 0;
  }
  clear() {
    this.count = 0;
  }
  has(t) {
    for (let e = 0; e < this.count; e++)
      if (this.keys[e] === t)
        return !0;
  }
  get(t) {
    for (let e = 0; e < this.count; e++)
      if (this.keys[e] === t)
        return this.values[e];
  }
  set(t, e) {
    this.count < 9 && (this.keys[this.count] = t, this.values[this.count++] = e);
  }
}
function Tat(i) {
  switch (i) {
    case Ed.Points:
      return "points";
    case Ed.Lines:
      return "lines";
    case Ed.Triangles:
    case Ed.TriangleEdges:
      return "polys";
    case Ed.TriangleStripEdges:
    case Ed.TriangleStrips:
      return "strips";
    default:
      return "";
  }
}
function eM(i, t, e) {
  let n = i.pointIdToFlatId[t];
  return n < 0 && (n = i.flatId, i.pointIdToFlatId[t] = n, i.flatIdToPointId[i.flatId] = t, i.flatIdToCellId[i.flatId] = e, i.flatId++), n;
}
function Mat(i, t, e) {
  const n = i.length;
  for (let a = 0; a < n; a++) {
    let o = i[a];
    if (e.cellProvokedMap.has(o)) {
      e.ibo[e.iboId++] = e.cellProvokedMap.get(o);
      for (let l = a + 1; l < a + n; l++) {
        o = i[l % n];
        const c = eM(e, o, t);
        e.ibo[e.iboId++] = c;
      }
      return;
    }
  }
  for (let a = 0; a < n; a++) {
    let o = i[a];
    if (!e.provokedPointIds[o]) {
      let l = eM(e, o, t);
      e.provokedPointIds[o] = 1, e.cellProvokedMap.set(o, l), e.flatIdToCellId[l] = t, e.ibo[e.iboId++] = l;
      for (let c = a + 1; c < a + n; c++)
        o = i[c % n], l = eM(e, o, t), e.ibo[e.iboId++] = l;
      return;
    }
  }
  let s = i[0], r = e.flatId;
  e.cellProvokedMap.set(s, r), e.flatIdToPointId[e.flatId] = s, e.flatIdToCellId[e.flatId] = t, e.flatId++, e.ibo[e.iboId++] = r;
  for (let a = 1; a < n; a++)
    s = i[a], r = eM(e, s, t), e.ibo[e.iboId++] = r;
}
function Nat(i, t, e) {
  const n = i.length;
  e.iboSize += n;
  for (let s = 0; s < n; s++) {
    const r = i[s];
    if (e.cellProvokedMap.has(r))
      return;
  }
  for (let s = 0; s < n; s++) {
    const r = i[s];
    if (!e.provokedPointIds[r]) {
      e.provokedPointIds[r] = 1, e.cellProvokedMap.set(r, 1);
      return;
    }
  }
  e.cellProvokedMap.set(i[0], 1), e.extraPoints++;
}
let lu;
const lO = new Uint32Array(1), Ro = new Uint32Array(2), Sd = new Uint32Array(3), jx = {
  // easy, every input point becomes an output point
  anythingToPoints(i, t, e, n, s) {
    for (let r = 0; r < i; ++r)
      lO[0] = t[e + r], lu(lO, n, s);
  },
  linesToWireframe(i, t, e, n, s) {
    for (let r = 0; r < i - 1; ++r)
      Ro[0] = t[e + r], Ro[1] = t[e + r + 1], lu(Ro, n, s);
  },
  polysToWireframe(i, t, e, n, s) {
    if (i > 2)
      for (let r = 0; r < i; ++r)
        Ro[0] = t[e + r], Ro[1] = t[e + (r + 1) % i], lu(Ro, n, s);
  },
  stripsToWireframe(i, t, e, n, s) {
    if (i > 2) {
      for (let r = 0; r < i - 1; ++r)
        Ro[0] = t[e + r], Ro[1] = t[e + r + 1], lu(Ro, n, s);
      for (let r = 0; r < i - 2; r++)
        Ro[0] = t[e + r], Ro[1] = t[e + r + 2], lu(Ro, n, s);
    }
  },
  polysToSurface(i, t, e, n, s) {
    for (let r = 0; r < i - 2; r++)
      Sd[0] = t[e], Sd[1] = t[e + r + 1], Sd[2] = t[e + r + 2], lu(Sd, n, s);
  },
  stripsToSurface(i, t, e, n, s) {
    for (let r = 0; r < i - 2; r++)
      Sd[0] = t[e + r], Sd[1] = t[e + r + 1 + r % 2], Sd[2] = t[e + r + 1 + (r + 1) % 2], lu(Sd, n, s);
  }
};
function Wat(i, t) {
  t.classHierarchy.push("vtkWebGPUIndexBuffer"), i.buildIndexBuffer = (e) => {
    const n = e.cells, s = e.primitiveType, r = e.representation, a = e.cellOffset, o = n.getData(), l = o.length, c = Tat(s), u = e.numberOfPoints, d = {
      provokedPointIds: new Uint8Array(u),
      // size is good
      extraPoints: 0,
      iboSize: 0,
      flatId: 0,
      iboId: 0,
      cellProvokedMap: new Zat()
    };
    let h = null;
    r === oO.POINTS || s === Ed.Points ? h = jx.anythingToPoints : r === oO.WIREFRAME || s === Ed.Lines ? h = jx[`${c}ToWireframe`] : h = jx[`${c}ToSurface`], lu = Nat;
    let p = a || 0;
    for (let m = 0; m < l; )
      d.cellProvokedMap.clear(), h(o[m], o, m + 1, p, d), m += o[m] + 1, p++;
    u <= 65535 ? d.flatIdToPointId = new Uint16Array(u + d.extraPoints) : d.flatIdToPointId = new Uint32Array(u + d.extraPoints), u + d.extraPoints < 36863 ? d.pointIdToFlatId = new Int16Array(u) : d.pointIdToFlatId = new Int32Array(u), u + d.extraPoints <= 65535 ? (d.ibo = new Uint16Array(d.iboSize), e.format = "uint16") : (d.ibo = new Uint32Array(d.iboSize), e.format = "uint32"), p <= 65535 ? d.flatIdToCellId = new Uint16Array(u + d.extraPoints) : d.flatIdToCellId = new Uint32Array(u + d.extraPoints), d.pointIdToFlatId.fill(-1), d.provokedPointIds.fill(0), lu = Mat, p = a || 0;
    for (let m = 0; m < l; )
      d.cellProvokedMap.clear(), h(o[m], o, m + 1, p, d), m += o[m] + 1, p++;
    delete d.provokedPointIds, delete d.pointIdToFlatId, e.nativeArray = d.ibo, t.flatIdToPointId = d.flatIdToPointId, t.flatIdToCellId = d.flatIdToCellId, t.flatSize = d.flatId, t.indexCount = d.iboId;
  };
}
const Gat = {
  flatIdToPointId: null,
  flatIdToCellId: null,
  flatSize: 0,
  indexCount: 0
};
function Zj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Gat, e), mL.extend(i, t, e), tt.setGet(i, t, ["flatIdToPointId", "flatIdToCellId", "flatSize", "indexCount"]), Wat(i, t);
}
const wat = tt.newInstance(Zj);
var xat = {
  newInstance: wat,
  extend: Zj,
  ...CT
};
const {
  BufferUsage: Ld
} = CT, {
  vtkErrorMacro: Sat
} = kr, {
  VtkDataTypes: Np
} = We, Lat = {};
function Vat(i) {
  let t;
  switch (i.getDataType()) {
    case Np.UNSIGNED_CHAR:
      t = "uint8";
      break;
    case Np.FLOAT:
      t = "float32";
      break;
    case Np.UNSIGNED_INT:
      t = "uint32";
      break;
    case Np.INT:
      t = "sint32";
      break;
    case Np.DOUBLE:
      t = "float32";
      break;
    case Np.UNSIGNED_SHORT:
      t = "uint16";
      break;
    case Np.SHORT:
      t = "sin16";
      break;
    default:
      t = "float32";
      break;
  }
  switch (i.getNumberOfComponents()) {
    case 2:
      t += "x2";
      break;
    case 3:
      t.includes("32") || Sat(`unsupported x3 type for ${t}`), t += "x3";
      break;
    case 4:
      t += "x4";
      break;
  }
  return t;
}
function cO(i, t, e, n, s) {
  const r = {}, a = i.getFlatSize();
  if (!a)
    return r;
  let o = [0, 0, 0, 0];
  s.shift && (s.shift.length ? o = s.shift : o.fill(s.shift));
  let l = [1, 1, 1, 1];
  s.scale && (s.scale.length ? l = s.scale : l.fill(s.scale));
  const c = Object.prototype.hasOwnProperty.call(s, "packExtra") ? s.packExtra : !1;
  let u, d = 0;
  const h = e + (c ? 1 : 0), p = xg(n, a * h);
  let m = i.getFlatIdToPointId();
  s.cellData && (m = i.getFlatIdToCellId()), e === 1 ? u = function(y) {
    p[d++] = l[0] * t[y] + o[0];
  } : e === 2 ? u = function(y) {
    p[d++] = l[0] * t[y] + o[0], p[d++] = l[1] * t[y + 1] + o[1];
  } : e === 3 && !c ? u = function(y) {
    p[d++] = l[0] * t[y] + o[0], p[d++] = l[1] * t[y + 1] + o[1], p[d++] = l[2] * t[y + 2] + o[2];
  } : e === 3 && c ? u = function(y) {
    p[d++] = l[0] * t[y] + o[0], p[d++] = l[1] * t[y + 1] + o[1], p[d++] = l[2] * t[y + 2] + o[2], p[d++] = l[3] * 1 + o[3];
  } : e === 4 && (u = function(y) {
    p[d++] = l[0] * t[y] + o[0], p[d++] = l[1] * t[y + 1] + o[1], p[d++] = l[2] * t[y + 2] + o[2], p[d++] = l[3] * t[y + 3] + o[3];
  });
  for (let b = 0; b < a; b++) {
    const y = e * m[b];
    u(y);
  }
  return r.nativeArray = p, r;
}
function Xat(i, t, e, n) {
  const s = [i[n * 3] - i[e * 3], i[n * 3 + 1] - i[e * 3 + 1], i[n * 3 + 2] - i[e * 3 + 2]], r = [i[t * 3] - i[e * 3], i[t * 3 + 1] - i[e * 3 + 1], i[t * 3 + 2] - i[e * 3 + 2]], a = [];
  return Wi(s, r, a), Fn(a), a;
}
function Iat(i, t) {
  const e = t.getData(), n = i.getData();
  if (!n || !e)
    return null;
  const s = new Int8Array(i.getNumberOfCells() * 4), r = n.length;
  let a = 0;
  for (let o = 0; o < r; ) {
    const l = Xat(e, n[o + 1], n[o + 2], n[o + 3]);
    s[a++] = 127 * l[0], s[a++] = 127 * l[1], s[a++] = 127 * l[2], s[a++] = 127, o += n[o] + 1;
  }
  return s;
}
function Cat(i, t) {
  t.classHierarchy.push("vtkWebGPUBufferManager");
  function e(n) {
    n.dataArray && !n.nativeArray && (n.nativeArray = n.dataArray.getData());
    let s, r;
    if (n.usage === Ld.Index && (s = xat.newInstance({
      label: n.label
    }), s.setDevice(t.device), r = GPUBufferUsage.INDEX | GPUBufferUsage.COPY_DST, s.buildIndexBuffer(n), s.createAndWrite(n.nativeArray, r), s.setArrayInformation([{
      format: n.format
    }])), s || (s = mL.newInstance({
      label: n.label
    }), s.setDevice(t.device)), n.usage === Ld.UniformArray && (r = GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST, s.createAndWrite(n.nativeArray, r)), n.usage === Ld.Storage && (r = GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST, s.createAndWrite(n.nativeArray, r)), n.usage === Ld.Texture && (r = GPUBufferUsage.COPY_SRC, s.createAndWrite(n.nativeArray, r)), n.usage === Ld.PointArray) {
      r = GPUBufferUsage.VERTEX;
      const a = Rr.getNativeTypeFromBufferFormat(n.format), o = cO(n.indexBuffer, n.dataArray.getData(), n.dataArray.getNumberOfComponents(), a, {
        packExtra: n.packExtra,
        shift: n.shift,
        scale: n.scale,
        cellData: n.cellData,
        cellOffset: n.cellOffset
      });
      s.createAndWrite(o.nativeArray, r), s.setStrideInBytes(Rr.getByteStrideFromBufferFormat(n.format)), s.setArrayInformation([{
        offset: 0,
        format: n.format,
        interpolation: n.cellData ? "flat" : "perspective"
      }]);
    }
    if (n.usage === Ld.NormalsFromPoints) {
      r = GPUBufferUsage.VERTEX;
      const a = Rr.getNativeTypeFromBufferFormat(n.format), o = Iat(n.cells, n.dataArray), l = cO(n.indexBuffer, o, 4, a, {
        cellData: !0
      });
      s.createAndWrite(l.nativeArray, r), s.setStrideInBytes(Rr.getByteStrideFromBufferFormat(n.format)), s.setArrayInformation([{
        offset: 0,
        format: n.format,
        interpolation: "flat"
      }]);
    }
    return n.usage === Ld.RawVertex && (r = GPUBufferUsage.VERTEX, s.createAndWrite(n.nativeArray, r), s.setStrideInBytes(Rr.getByteStrideFromBufferFormat(n.format)), s.setArrayInformation([{
      offset: 0,
      format: n.format
    }])), s.setSourceTime(n.time), s;
  }
  i.hasBuffer = (n) => t.device.hasCachedObject(n), i.getBuffer = (n) => n.hash ? t.device.getCachedObject(n.hash, e, n) : e(n), i.getBufferForPointArray = (n, s) => {
    const r = Vat(n), a = {
      hash: `${n.getMTime()}I${s.getMTime()}${r}`,
      usage: Ld.PointArray,
      format: r,
      dataArray: n,
      indexBuffer: s
    };
    return i.getBuffer(a);
  }, i.getFullScreenQuadBuffer = () => {
    if (t.fullScreenQuadBuffer)
      return t.fullScreenQuadBuffer;
    t.fullScreenQuadBuffer = mL.newInstance(), t.fullScreenQuadBuffer.setDevice(t.device);
    const n = new Float32Array([-1, -1, 0, 1, -1, 0, 1, 1, 0, -1, -1, 0, 1, 1, 0, -1, 1, 0]);
    return t.fullScreenQuadBuffer.createAndWrite(n, GPUBufferUsage.VERTEX), t.fullScreenQuadBuffer.setStrideInBytes(12), t.fullScreenQuadBuffer.setArrayInformation([{
      offset: 0,
      format: "float32x3"
    }]), t.fullScreenQuadBuffer;
  };
}
const Yat = {
  device: null,
  fullScreenQuadBuffer: null
};
function vat(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Yat, e), xi(i, t), gs(i, t, ["device"]), Cat(i, t);
}
In(vat);
var Xg = {
  ...Lat,
  ...CT
};
const {
  BufferUsage: Rat
} = Xg, {
  vtkErrorMacro: $0
} = tt;
function Dat(i, t) {
  t.classHierarchy.push("vtkWebGPUStorageBuffer"), i.addEntry = (e, n) => {
    if (t._bufferEntryNames.has(e)) {
      $0(`entry named ${e} already exists`);
      return;
    }
    t._bufferEntryNames.set(e, t.bufferEntries.length);
    const s = Rr.getByteStrideFromShaderFormat(n);
    t.bufferEntries.push({
      name: e,
      type: n,
      sizeInBytes: s,
      offset: t.sizeInBytes,
      nativeType: Rr.getNativeTypeFromShaderFormat(n)
    }), t.sizeInBytes += s;
  }, i.send = (e) => {
    if (!t._buffer) {
      const n = {
        nativeArray: t.Float32Array,
        usage: Rat.Storage,
        label: t.label
      };
      t._buffer = e.getBufferManager().getBuffer(n), t.bindGroupTime.modified(), t._sendTime.modified();
      return;
    }
    e.getHandle().queue.writeBuffer(t._buffer.getHandle(), 0, t.arrayBuffer, 0, t.sizeInBytes * t.numberOfInstances), t._sendTime.modified();
  }, i.createView = (e) => {
    e in t || (t.arrayBuffer || (t.arrayBuffer = new ArrayBuffer(t.sizeInBytes * t.numberOfInstances)), t[e] = tt.newTypedArray(e, t.arrayBuffer));
  }, i.setValue = (e, n, s) => {
    const r = t._bufferEntryNames.get(e);
    if (r === void 0) {
      $0(`entry named ${e} not found in UBO`);
      return;
    }
    const a = t.bufferEntries[r];
    i.createView(a.nativeType);
    const o = t[a.nativeType];
    o[(a.offset + n * t.sizeInBytes) / o.BYTES_PER_ELEMENT] = s;
  }, i.setArray = (e, n, s) => {
    const r = t._bufferEntryNames.get(e);
    if (r === void 0) {
      $0(`entry named ${e} not found in UBO`);
      return;
    }
    const a = t.bufferEntries[r];
    i.createView(a.nativeType);
    const o = t[a.nativeType], l = (a.offset + n * t.sizeInBytes) / o.BYTES_PER_ELEMENT;
    for (let c = 0; c < s.length; c++)
      o[l + c] = s[c];
  }, i.setAllInstancesFromArray = (e, n) => {
    const s = t._bufferEntryNames.get(e);
    if (s === void 0) {
      $0(`entry named ${e} not found in UBO`);
      return;
    }
    const r = t.bufferEntries[s];
    i.createView(r.nativeType);
    const a = t[r.nativeType], o = n.length / t.numberOfInstances;
    for (let l = 0; l < t.numberOfInstances; l++) {
      const c = (r.offset + l * t.sizeInBytes) / a.BYTES_PER_ELEMENT;
      for (let u = 0; u < o; u++)
        a[c + u] = n[l * o + u];
    }
  }, i.setAllInstancesFromArrayColorToFloat = (e, n) => {
    const s = t._bufferEntryNames.get(e);
    if (s === void 0) {
      $0(`entry named ${e} not found in UBO`);
      return;
    }
    const r = t.bufferEntries[s];
    i.createView(r.nativeType);
    const a = t[r.nativeType], o = n.length / t.numberOfInstances;
    for (let l = 0; l < t.numberOfInstances; l++) {
      const c = (r.offset + l * t.sizeInBytes) / a.BYTES_PER_ELEMENT;
      for (let u = 0; u < o; u++)
        a[c + u] = n[l * o + u] / 255;
    }
  }, i.setAllInstancesFromArray3x3To4x4 = (e, n) => {
    const s = t._bufferEntryNames.get(e);
    if (s === void 0) {
      $0(`entry named ${e} not found in UBO`);
      return;
    }
    const r = t.bufferEntries[s];
    i.createView(r.nativeType);
    const a = t[r.nativeType], o = 9;
    for (let l = 0; l < t.numberOfInstances; l++) {
      const c = (r.offset + l * t.sizeInBytes) / a.BYTES_PER_ELEMENT;
      for (let u = 0; u < 3; u++)
        for (let d = 0; d < 3; d++)
          a[c + u * 4 + d] = n[l * o + u * 3 + d];
    }
  }, i.getSendTime = () => t._sendTime.getMTime(), i.getShaderCode = (e, n) => {
    const s = [`struct ${t.label}StructEntry
{`];
    for (let r = 0; r < t.bufferEntries.length; r++) {
      const a = t.bufferEntries[r];
      s.push(`  ${a.name}: ${a.type},`);
    }
    return s.push(`
};
struct ${t.label}Struct
{
  values: array<${t.label}StructEntry>,
};
@binding(${e}) @group(${n}) var<storage, read> ${t.label}: ${t.label}Struct;
`), s.join(`
`);
  }, i.getBindGroupEntry = () => ({
    resource: {
      buffer: t._buffer.getHandle()
    }
  }), i.clearData = () => {
    t.numberOfInstances = 0, t.sizeInBytes = 0, t.bufferEntries = [], t._bufferEntryNames = /* @__PURE__ */ new Map(), t._buffer = null, delete t.arrayBuffer, delete t.Float32Array;
  };
}
const Oat = {
  bufferEntries: null,
  bufferEntryNames: null,
  sizeInBytes: 0,
  label: null,
  numberOfInstances: 1
};
function Tj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Oat, e), tt.obj(i, t), t._bufferEntryNames = /* @__PURE__ */ new Map(), t.bufferEntries = [], t._sendTime = {}, tt.obj(t._sendTime, {
    mtime: 0
  }), t.bindGroupTime = {}, tt.obj(t.bindGroupTime, {
    mtime: 0
  }), t.bindGroupLayoutEntry = t.bindGroupLayoutEntry || {
    buffer: {
      type: "read-only-storage"
    }
  }, tt.get(i, t, ["bindGroupTime"]), tt.setGet(i, t, ["device", "bindGroupLayoutEntry", "label", "numberOfInstances", "sizeInBytes"]), Dat(i, t);
}
const zat = tt.newInstance(Tj, "vtkWebGPUStorageBuffer");
var Mj = {
  newInstance: zat,
  extend: Tj
};
const {
  BufferUsage: Eat
} = Xg, {
  vtkErrorMacro: Ux
} = tt;
function kat(i, t) {
  t.classHierarchy.push("vtkWebGPUUniformBuffer"), i.addEntry = (e, n) => {
    if (t._bufferEntryNames.has(e)) {
      Ux(`entry named ${e} already exists`);
      return;
    }
    t.sortDirty = !0, t._bufferEntryNames.set(e, t.bufferEntries.length), t.bufferEntries.push({
      name: e,
      type: n,
      sizeInBytes: Rr.getByteStrideFromShaderFormat(n),
      offset: -1,
      nativeType: Rr.getNativeTypeFromShaderFormat(n),
      packed: !1
    });
  }, i.sortBufferEntries = () => {
    if (!t.sortDirty)
      return;
    let e = 0;
    const n = [];
    let s = 4;
    for (let r = 0; r < t.bufferEntries.length; r++) {
      const a = t.bufferEntries[r];
      a.sizeInBytes % 16 === 0 && (s = Math.max(16, s)), a.sizeInBytes % 8 === 0 && (s = Math.max(8, s));
    }
    for (let r = 0; r < t.bufferEntries.length; r++) {
      const a = t.bufferEntries[r];
      a.packed === !1 && a.sizeInBytes % 16 === 0 && (a.packed = !0, a.offset = e, n.push(a), e += a.sizeInBytes);
    }
    for (let r = 0; r < t.bufferEntries.length; r++) {
      const a = t.bufferEntries[r];
      if (a.packed === !1 && a.sizeInBytes === 12)
        for (let o = 0; o < t.bufferEntries.length; o++) {
          const l = t.bufferEntries[o];
          if (l.packed === !1 && l.sizeInBytes === 4) {
            a.packed = !0, a.offset = e, n.push(a), e += a.sizeInBytes, l.packed = !0, l.offset = e, n.push(l), e += l.sizeInBytes;
            break;
          }
        }
    }
    for (let r = 0; r < t.bufferEntries.length; r++) {
      const a = t.bufferEntries[r];
      if (!a.packed && a.sizeInBytes % 8 === 0)
        for (let o = r + 1; o < t.bufferEntries.length; o++) {
          const l = t.bufferEntries[o];
          if (!l.packed && l.sizeInBytes % 8 === 0) {
            a.packed = !0, a.offset = e, n.push(a), e += a.sizeInBytes, l.packed = !0, l.offset = e, n.push(l), e += l.sizeInBytes;
            break;
          }
        }
    }
    for (let r = 0; r < t.bufferEntries.length; r++) {
      const a = t.bufferEntries[r];
      if (!a.packed && a.sizeInBytes % 8 === 0) {
        let o = !1;
        for (let l = 0; !o && l < t.bufferEntries.length; l++) {
          const c = t.bufferEntries[l];
          if (!c.packed && c.sizeInBytes === 4)
            for (let u = l + 1; u < t.bufferEntries.length; u++) {
              const d = t.bufferEntries[u];
              if (!d.packed && d.sizeInBytes === 4) {
                a.packed = !0, a.offset = e, n.push(a), e += a.sizeInBytes, c.packed = !0, c.offset = e, n.push(c), e += c.sizeInBytes, d.packed = !0, d.offset = e, n.push(d), e += d.sizeInBytes, o = !0;
                break;
              }
            }
        }
      }
    }
    for (let r = 0; r < t.bufferEntries.length; r++) {
      const a = t.bufferEntries[r];
      !a.packed && a.sizeInBytes > 4 && (a.packed = !0, a.offset = e, n.push(a), e += a.sizeInBytes);
    }
    for (let r = 0; r < t.bufferEntries.length; r++) {
      const a = t.bufferEntries[r];
      a.packed || (a.packed = !0, a.offset = e, n.push(a), e += a.sizeInBytes);
    }
    t.bufferEntries = n, t._bufferEntryNames.clear();
    for (let r = 0; r < t.bufferEntries.length; r++)
      t._bufferEntryNames.set(t.bufferEntries[r].name, r);
    t.sizeInBytes = e, t.sizeInBytes = s * Math.ceil(t.sizeInBytes / s), t.sortDirty = !1;
  }, i.sendIfNeeded = (e) => {
    if (!t.UBO) {
      const n = {
        nativeArray: t.Float32Array,
        usage: Eat.UniformArray,
        label: t.label
      };
      t.UBO = e.getBufferManager().getBuffer(n), t.bindGroupTime.modified(), t.sendDirty = !1;
    }
    t.sendDirty && (e.getHandle().queue.writeBuffer(t.UBO.getHandle(), 0, t.arrayBuffer, 0, t.sizeInBytes), t.sendDirty = !1), t.sendTime.modified();
  }, i.createView = (e) => {
    e in t || (t.arrayBuffer || (t.arrayBuffer = new ArrayBuffer(t.sizeInBytes)), t[e] = tt.newTypedArray(e, t.arrayBuffer));
  }, i.setValue = (e, n) => {
    i.sortBufferEntries();
    const s = t._bufferEntryNames.get(e);
    if (s === void 0) {
      Ux(`entry named ${e} not found in UBO`);
      return;
    }
    const r = t.bufferEntries[s];
    i.createView(r.nativeType);
    const a = t[r.nativeType];
    r.lastValue !== n && (a[r.offset / a.BYTES_PER_ELEMENT] = n, t.sendDirty = !0), r.lastValue = n;
  }, i.setArray = (e, n) => {
    i.sortBufferEntries();
    const s = t._bufferEntryNames.get(e);
    if (s === void 0) {
      Ux(`entry named ${e} not found in UBO`);
      return;
    }
    const r = t.bufferEntries[s];
    i.createView(r.nativeType);
    const a = t[r.nativeType];
    let o = !1;
    for (let l = 0; l < n.length; l++)
      (!r.lastValue || r.lastValue[l] !== n[l]) && (a[r.offset / a.BYTES_PER_ELEMENT + l] = n[l], o = !0);
    o && (t.sendDirty = !0, r.lastValue = [...n]);
  }, i.getBindGroupEntry = () => ({
    resource: {
      buffer: t.UBO.getHandle()
    }
  }), i.getSendTime = () => t.sendTime.getMTime(), i.getShaderCode = (e, n) => {
    i.sortBufferEntries();
    const s = [`struct ${t.label}Struct
{`];
    for (let r = 0; r < t.bufferEntries.length; r++) {
      const a = t.bufferEntries[r];
      s.push(`  ${a.name}: ${a.type},`);
    }
    return s.push(`};
@binding(${e}) @group(${n}) var<uniform> ${t.label}: ${t.label}Struct;`), s.join(`
`);
  };
}
const Fat = {
  bufferEntries: null,
  bufferEntryNames: null,
  sizeInBytes: 0,
  label: null,
  bindGroupLayoutEntry: null,
  bindGroupEntry: null
};
function Nj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Fat, e), tt.obj(i, t), t._bufferEntryNames = /* @__PURE__ */ new Map(), t.bufferEntries = [], t.bindGroupLayoutEntry = t.bindGroupLayoutEntry || {
    buffer: {
      type: "uniform"
    }
  }, t.sendTime = {}, tt.obj(t.sendTime, {
    mtime: 0
  }), t.bindGroupTime = {}, tt.obj(t.bindGroupTime, {
    mtime: 0
  }), t.sendDirty = !0, t.sortDirty = !0, tt.get(i, t, ["binding", "bindGroupTime"]), tt.setGet(i, t, ["bindGroupLayoutEntry", "device", "label", "sizeInBytes"]), kat(i, t);
}
const jat = tt.newInstance(Nj, "vtkWebGPUUniformBuffer");
var Cb = {
  newInstance: jat,
  extend: Nj
};
const {
  vtkDebugMacro: Uat
} = kr, uO = `
//VTK::Renderer::Dec

//VTK::Mapper::Dec

//VTK::TCoord::Dec

//VTK::RenderEncoder::Dec

//VTK::IOStructs::Dec

@fragment
fn main(
//VTK::IOStructs::Input
)
//VTK::IOStructs::Output
{
  var output: fragmentOutput;

  var computedColor: vec4<f32> = mapperUBO.BackgroundColor;

  //VTK::RenderEncoder::Impl
  return output;
}
`, Pat = `
fn vecToRectCoord(dir: vec3<f32>) -> vec2<f32> {
  var tau: f32 = 6.28318530718;
  var pi: f32 = 3.14159265359;
  var out: vec2<f32> = vec2<f32>(0.0);

  out.x = atan2(dir.z, dir.x) / tau;
  out.x += 0.5;

  var phix: f32 = length(vec2(dir.x, dir.z));
  out.y = atan2(dir.y, phix) / pi + 0.5;

  return out;
}

//VTK::Renderer::Dec

//VTK::Mapper::Dec

//VTK::TCoord::Dec

//VTK::RenderEncoder::Dec

//VTK::IOStructs::Dec

@fragment
fn main(
//VTK::IOStructs::Input
)
//VTK::IOStructs::Output
{
  var output: fragmentOutput;

  var tcoord: vec4<f32> = vec4<f32>(input.vertexVC.xy, -1, 1);
  var V: vec4<f32> = normalize(mapperUBO.FSQMatrix * tcoord); // vec2<f32>((input.tcoordVS.x - 0.5) * 2, -(input.tcoordVS.y - 0.5) * 2);
  // textureSampleLevel gets rid of some ugly artifacts
  var background = textureSampleLevel(EnvironmentTexture, EnvironmentTextureSampler, vecToRectCoord(V.xyz), 0.0);
  var computedColor: vec4<f32> = vec4<f32>(background.rgb, 1);

  //VTK::RenderEncoder::Impl
  return output;
}
`, nM = new Float64Array(16), dO = new Float64Array(16);
function Jat(i) {
  return i.getPositional() ? i.getConeAngle() >= 90 ? 0 : 2 : 1;
}
function Aat(i, t) {
  t.classHierarchy.push("vtkWebGPURenderer"), i.buildPass = (e) => {
    if (e) {
      if (!t.renderable)
        return;
      t.camera = t.renderable.getActiveCamera(), i.updateLights(), i.prepareNodes(), i.addMissingNode(t.camera), i.addMissingNodes(t.renderable.getViewPropsWithNestedProps()), i.removeUnusedNodes(), t.webgpuCamera = i.getViewNodeFor(t.camera), i.updateStabilizedMatrix();
    }
  }, i.updateStabilizedMatrix = () => {
    const e = t.camera.getClippingRange(), n = t.camera.getPositionByReference(), s = t.camera.getDirectionOfProjectionByReference(), r = [], a = [];
    I.scale(a, s, 0.5 * (e[0] + e[1])), I.add(r, n, a), I.sub(a, r, t.stabilizedCenter), I.len(a) / (e[1] - e[0]) > t.recenterThreshold && (t.stabilizedCenter = r, t.stabilizedTime.modified());
  }, i.updateLights = () => {
    let e = 0;
    const n = t.renderable.getLightsByReference();
    for (let s = 0; s < n.length; ++s)
      n[s].getSwitch() > 0 && e++;
    return e || (Uat("No lights are on, creating one."), t.renderable.createLight()), e;
  }, i.updateUBO = () => {
    var n;
    const e = t.UBO.getSendTime();
    if (t._parent.getMTime() > e || i.getMTime() > e || t.camera.getMTime() > e || t.renderable.getMTime() > e) {
      const s = t.webgpuCamera.getKeyMatrices(i);
      t.UBO.setArray("WCVCMatrix", s.wcvc), t.UBO.setArray("SCPCMatrix", s.scpc), t.UBO.setArray("PCSCMatrix", s.pcsc), t.UBO.setArray("SCVCMatrix", s.scvc), t.UBO.setArray("VCPCMatrix", s.vcpc), t.UBO.setArray("WCVCNormals", s.normalMatrix), t.UBO.setValue("LightCount", t.renderable.getLights().length), t.UBO.setValue("MaxEnvironmentMipLevel", (n = t.renderable.getEnvironmentTexture()) == null ? void 0 : n.getMipLevel()), t.UBO.setValue("BackgroundDiffuseStrength", t.renderable.getEnvironmentTextureDiffuseStrength()), t.UBO.setValue("BackgroundSpecularStrength", t.renderable.getEnvironmentTextureSpecularStrength());
      const r = i.getYInvertedTiledSizeAndOrigin();
      t.UBO.setArray("viewportSize", [r.usize, r.vsize]), t.UBO.setValue("cameraParallel", t.camera.getParallelProjection());
      const a = t._parent.getDevice();
      t.UBO.sendIfNeeded(a);
    }
  }, i.updateSSBO = () => {
    const e = t.renderable.getLights(), n = t.webgpuCamera.getKeyMatrices(i);
    let s = `${t.renderable.getMTime()}`;
    for (let r = 0; r < e.length; r++)
      s += e[r].getMTime();
    if (s !== t.lightTimeString) {
      const r = new Float32Array(e.length * 4), a = new Float32Array(e.length * 4), o = new Float32Array(e.length * 4), l = new Float32Array(e.length * 4);
      for (let u = 0; u < e.length; u++) {
        const d = u * 4, h = e[u].getPosition();
        I.transformMat4(h, h, n.wcvc), r[d] = h[0], r[d + 1] = h[1], r[d + 2] = h[2], r[d + 3] = 0, a[d] = -e[u].getDirection()[0], a[d + 1] = -e[u].getDirection()[1], a[d + 2] = -e[u].getDirection()[2], a[d + 3] = 0, o[d] = e[u].getColor()[0], o[d + 1] = e[u].getColor()[1], o[d + 2] = e[u].getColor()[2], o[d + 3] = e[u].getIntensity() * 5, l[d] = Jat(e[u]), l[d + 1] = Math.cos(Qi(e[u].getConeAngle())), l[d + 2] = Math.cos(Qi(e[u].getConeAngle() + e[u].getConeFalloff())), l[d + 3] = 0;
      }
      t.SSBO.clearData(), t.SSBO.setNumberOfInstances(e.length), t.SSBO.addEntry("LightPos", "vec4<f32>"), t.SSBO.addEntry("LightDir", "vec4<f32>"), t.SSBO.addEntry("LightColor", "vec4<f32>"), t.SSBO.addEntry("LightData", "vec4<f32>"), t.SSBO.setAllInstancesFromArray("LightPos", r), t.SSBO.setAllInstancesFromArray("LightDir", a), t.SSBO.setAllInstancesFromArray("LightColor", o), t.SSBO.setAllInstancesFromArray("LightData", l);
      const c = t._parent.getDevice();
      t.SSBO.send(c);
    }
    t.lightTimeString = s;
  }, i.scissorAndViewport = (e) => {
    const n = i.getYInvertedTiledSizeAndOrigin();
    e.getHandle().setViewport(n.lowerLeftU, n.lowerLeftV, n.usize, n.vsize, 0, 1), e.getHandle().setScissorRect(n.lowerLeftU, n.lowerLeftV, n.usize, n.vsize);
  }, i.bindUBO = (e) => {
    e.activateBindGroup(t.bindGroup);
  }, i.opaquePass = (e) => {
    e ? (t.renderEncoder.begin(t._parent.getCommandEncoder()), i.updateUBO(), i.updateSSBO()) : (i.scissorAndViewport(t.renderEncoder), i.clear(), t.renderEncoder.end());
  }, i.clear = () => {
    var r;
    if (t.renderable.getTransparent() || t.suppressClear)
      return;
    const e = t._parent.getDevice();
    if (!t.clearFSQ) {
      t.clearFSQ = pL.newInstance(), t.clearFSQ.setDevice(e), t.clearFSQ.setPipelineHash("clearfsq"), t.clearFSQ.setFragmentShaderTemplate(uO);
      const a = Cb.newInstance({
        label: "mapperUBO"
      });
      a.addEntry("FSQMatrix", "mat4x4<f32>"), a.addEntry("BackgroundColor", "vec4<f32>"), t.clearFSQ.setUBO(a), t.backgroundTex = t.renderable.getEnvironmentTexture();
    }
    if (t.clearFSQ.getPipelineHash() !== "clearfsqwithtexture" && t.renderable.getUseEnvironmentTextureAsBackground() && ((r = t.backgroundTex) != null && r.getImageLoaded())) {
      t.clearFSQ.setFragmentShaderTemplate(Pat);
      const a = Cb.newInstance({
        label: "mapperUBO"
      });
      a.addEntry("FSQMatrix", "mat4x4<f32>"), a.addEntry("BackgroundColor", "vec4<f32>"), t.clearFSQ.setUBO(a);
      const o = e.getTextureManager().getTextureForVTKTexture(t.backgroundTex);
      if (o.getReady()) {
        const l = o.createView("EnvironmentTexture");
        t.clearFSQ.setTextureViews([l]), t.backgroundTexLoaded = !0;
        const c = t.backgroundTex.getInterpolate() ? "linear" : "nearest";
        l.addSampler(e, {
          addressModeU: "repeat",
          addressModeV: "clamp-to-edge",
          addressModeW: "repeat",
          minFilter: c,
          magFilter: c,
          mipmapFilter: "linear"
        });
      }
      t.clearFSQ.setPipelineHash("clearfsqwithtexture");
    } else if (t.clearFSQ.getPipelineHash() === "clearfsqwithtexture" && !t.renderable.getUseEnvironmentTextureAsBackground()) {
      t.clearFSQ = pL.newInstance(), t.clearFSQ.setDevice(e), t.clearFSQ.setPipelineHash("clearfsq"), t.clearFSQ.setFragmentShaderTemplate(uO);
      const a = Cb.newInstance({
        label: "mapperUBO"
      });
      a.addEntry("FSQMatrix", "mat4x4<f32>"), a.addEntry("BackgroundColor", "vec4<f32>"), t.clearFSQ.setUBO(a);
    }
    const n = t.webgpuCamera.getKeyMatrices(i), s = t.renderable.getBackgroundByReference();
    t.clearFSQ.getUBO().setArray("BackgroundColor", s), ut.transpose(dO, n.normalMatrix), ut.mul(nM, n.scvc, n.pcsc), ut.mul(nM, dO, nM), t.clearFSQ.getUBO().setArray("FSQMatrix", nM), t.clearFSQ.getUBO().sendIfNeeded(e), t.clearFSQ.prepareAndDraw(t.renderEncoder);
  }, i.translucentPass = (e) => {
    e ? t.renderEncoder.begin(t._parent.getCommandEncoder()) : (i.scissorAndViewport(t.renderEncoder), t.renderEncoder.end());
  }, i.volumeDepthRangePass = (e) => {
    e ? t.renderEncoder.begin(t._parent.getCommandEncoder()) : (i.scissorAndViewport(t.renderEncoder), t.renderEncoder.end());
  }, i.getAspectRatio = () => {
    const e = t._parent.getSizeByReference(), n = t.renderable.getViewportByReference();
    return e[0] * (n[2] - n[0]) / ((n[3] - n[1]) * e[1]);
  }, i.convertToOpenGLDepth = (e) => t.webgpuCamera.convertToOpenGLDepth(e), i.getYInvertedTiledSizeAndOrigin = () => {
    const e = i.getTiledSizeAndOrigin(), n = t._parent.getSizeByReference();
    return e.lowerLeftV = n[1] - e.vsize - e.lowerLeftV, e;
  }, i.getTiledSizeAndOrigin = () => {
    const e = t.renderable.getViewportByReference(), n = [0, 0, 1, 1], s = e[0] - n[0], r = e[1] - n[1], a = t._parent.normalizedDisplayToDisplay(s, r), o = Math.round(a[0]), l = Math.round(a[1]), c = e[2] - n[0], u = e[3] - n[1], d = t._parent.normalizedDisplayToDisplay(c, u);
    let h = Math.round(d[0]) - o, p = Math.round(d[1]) - l;
    return h < 0 && (h = 0), p < 0 && (p = 0), {
      usize: h,
      vsize: p,
      lowerLeftU: o,
      lowerLeftV: l
    };
  }, i.getPropFromID = (e) => {
    for (let n = 0; n < t.children.length; n++)
      if ((t.children[n].getPropID ? t.children[n].getPropID() : -1) === e)
        return t.children[n];
    return null;
  }, i.getStabilizedTime = () => t.stabilizedTime.getMTime(), i.releaseGraphicsResources = () => {
    t.selector !== null && t.selector.releaseGraphicsResources();
  };
}
const Bat = {
  bindGroup: null,
  selector: null,
  renderEncoder: null,
  recenterThreshold: 20,
  suppressClear: !1,
  stabilizedCenter: [0, 0, 0]
};
function Kat(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Bat, e), ui.extend(i, t, e), t.UBO = Cb.newInstance({
    label: "rendererUBO"
  }), t.UBO.addEntry("WCVCMatrix", "mat4x4<f32>"), t.UBO.addEntry("SCPCMatrix", "mat4x4<f32>"), t.UBO.addEntry("PCSCMatrix", "mat4x4<f32>"), t.UBO.addEntry("SCVCMatrix", "mat4x4<f32>"), t.UBO.addEntry("VCPCMatrix", "mat4x4<f32>"), t.UBO.addEntry("WCVCNormals", "mat4x4<f32>"), t.UBO.addEntry("viewportSize", "vec2<f32>"), t.UBO.addEntry("LightCount", "i32"), t.UBO.addEntry("MaxEnvironmentMipLevel", "f32"), t.UBO.addEntry("BackgroundDiffuseStrength", "f32"), t.UBO.addEntry("BackgroundSpecularStrength", "f32"), t.UBO.addEntry("cameraParallel", "u32"), t.SSBO = Mj.newInstance({
    label: "rendererLightSSBO"
  }), t.lightTimeString = "", t.bindGroup = cj.newInstance({
    label: "rendererBG"
  }), t.bindGroup.setBindables([t.UBO, t.SSBO]), t.tmpMat4 = ut.identity(new Float64Array(16)), t.stabilizedTime = {}, xi(t.stabilizedTime, {
    mtime: 0
  }), Sa(i, t, ["bindGroup", "stabilizedTime"]), Sg(i, t, ["stabilizedCenter"]), gs(i, t, ["renderEncoder", "selector", "suppressClear", "UBO"]), Aat(i, t);
}
const Hat = In(Kat, "vtkWebGPURenderer");
Xo("vtkRenderer", Hat);
const {
  CoordinateSystem: hO
} = np;
function _at(i, t) {
  t.classHierarchy.push("vtkWebGPUActor"), i.buildPass = (e) => {
    e && (t.WebGPURenderer = i.getFirstAncestorOfType("vtkWebGPURenderer"), t.WebGPURenderWindow = t.WebGPURenderer.getFirstAncestorOfType("vtkWebGPURenderWindow"), t.propID === void 0 && (t.propID = t.WebGPURenderWindow.getUniquePropID()), i.prepareNodes(), i.addMissingNode(t.renderable.getMapper()), i.removeUnusedNodes());
  }, i.traverseOpaquePass = (e) => {
    !t.renderable || !t.renderable.getNestedVisibility() || !t.renderable.getIsOpaque() || t.WebGPURenderer.getSelector() && !t.renderable.getNestedPickable() || (i.apply(e, !0), t.children[0] && t.children[0].traverse(e), i.apply(e, !1));
  }, i.traverseTranslucentPass = (e) => {
    !t.renderable || !t.renderable.getNestedVisibility() || t.renderable.getIsOpaque() || t.WebGPURenderer.getSelector() && !t.renderable.getNestedPickable() || (i.apply(e, !0), t.children[0] && t.children[0].traverse(e), i.apply(e, !1));
  }, i.queryPass = (e, n) => {
    if (e) {
      if (!t.renderable || !t.renderable.getVisibility())
        return;
      t.renderable.getIsOpaque() ? n.incrementOpaqueActorCount() : n.incrementTranslucentActorCount();
    }
  }, i.getBufferShift = (e) => (i.getKeyMatrices(e), t.bufferShift), i.getKeyMatrices = (e) => {
    if (Math.max(t.renderable.getMTime(), e.getStabilizedTime()) > t.keyMatricesTime.getMTime()) {
      t.renderable.computeMatrix();
      const n = t.renderable.getMatrix();
      t.bufferShift[0] = n[3], t.bufferShift[1] = n[7], t.bufferShift[2] = n[11];
      const s = e.getStabilizedCenterByReference();
      t.renderable.getCoordinateSystem() === hO.WORLD && (t.bufferShift[0] -= s[0], t.bufferShift[1] -= s[1], t.bufferShift[2] -= s[2]), ut.transpose(t.keyMatrices.bcwc, n), t.renderable.getIsIdentity() ? ut.identity(t.keyMatrices.normalMatrix) : (ut.copy(t.keyMatrices.normalMatrix, t.keyMatrices.bcwc), t.keyMatrices.normalMatrix[3] = 0, t.keyMatrices.normalMatrix[7] = 0, t.keyMatrices.normalMatrix[11] = 0, ut.invert(t.keyMatrices.normalMatrix, t.keyMatrices.normalMatrix), ut.transpose(t.keyMatrices.normalMatrix, t.keyMatrices.normalMatrix)), ut.translate(t.keyMatrices.bcwc, t.keyMatrices.bcwc, [-t.bufferShift[0], -t.bufferShift[1], -t.bufferShift[2]]), t.renderable.getCoordinateSystem() === hO.WORLD ? ut.translate(t.keyMatrices.bcsc, t.keyMatrices.bcwc, [-s[0], -s[1], -s[2]]) : ut.copy(t.keyMatrices.bcsc, t.keyMatrices.bcwc), t.keyMatricesTime.modified();
    }
    return t.keyMatrices;
  };
}
const Qat = {
  keyMatricesTime: null,
  keyMatrices: null,
  propID: void 0,
  bufferShift: void 0
};
function $at(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Qat, e), ui.extend(i, t, e), t.keyMatricesTime = {}, tt.obj(t.keyMatricesTime, {
    mtime: 0
  }), t.keyMatrices = {
    normalMatrix: new Float64Array(16),
    bcwc: new Float64Array(16),
    bcsc: new Float64Array(16)
  }, tt.get(i, t, ["propID", "keyMatricesTime"]), t.bufferShift = [0, 0, 0, 0], _at(i, t);
}
const qat = tt.newInstance($at);
Xo("vtkActor", qat);
const {
  CoordinateSystem: pO
} = np;
function tot(i, t) {
  t.classHierarchy.push("vtkWebGPUActor2D"), i.buildPass = (e) => {
    e && (t.WebGPURenderer = i.getFirstAncestorOfType("vtkWebGPURenderer"), t.WebGPURenderWindow = t.WebGPURenderer.getFirstAncestorOfType("vtkWebGPURenderWindow"), t.propID === void 0 && (t.propID = t.WebGPURenderWindow.getUniquePropID()), i.prepareNodes(), i.addMissingNode(t.renderable.getMapper()), i.removeUnusedNodes());
  }, i.traverseOpaquePass = (e) => {
    !t.renderable || !t.renderable.getNestedVisibility() || !t.renderable.getIsOpaque() || t.WebGPURenderer.getSelector() && !t.renderable.getNestedPickable() || (i.apply(e, !0), t.children[0] && t.children[0].traverse(e), i.apply(e, !1));
  }, i.traverseTranslucentPass = (e) => {
    !t.renderable || !t.renderable.getNestedVisibility() || t.renderable.getIsOpaque() || t.WebGPURenderer.getSelector() && !t.renderable.getNestedPickable() || (i.apply(e, !0), t.children[0] && t.children[0].traverse(e), i.apply(e, !1));
  }, i.queryPass = (e, n) => {
    if (e) {
      if (!t.renderable || !t.renderable.getVisibility())
        return;
      t.renderable.getIsOpaque() ? n.incrementOpaqueActorCount() : n.incrementTranslucentActorCount();
    }
  }, i.getBufferShift = (e) => (i.getKeyMatrices(e), t.bufferShift), i.getKeyMatrices = (e) => {
    if (Math.max(t.renderable.getMTime(), e.getStabilizedTime()) > t.keyMatricesTime.getMTime()) {
      t.bufferShift[0] = 0, t.bufferShift[1] = 0, t.bufferShift[2] = 0;
      const n = e.getStabilizedCenterByReference();
      t.renderable.getCoordinateSystem() === pO.WORLD && (t.bufferShift[0] -= n[0], t.bufferShift[1] -= n[1], t.bufferShift[2] -= n[2]), ut.identity(t.keyMatrices.bcwc), ut.identity(t.keyMatrices.normalMatrix), ut.translate(t.keyMatrices.bcwc, t.keyMatrices.bcwc, [-t.bufferShift[0], -t.bufferShift[1], -t.bufferShift[2]]), t.renderable.getCoordinateSystem() === pO.WORLD ? ut.translate(t.keyMatrices.bcsc, t.keyMatrices.bcwc, [-n[0], -n[1], -n[2]]) : ut.copy(t.keyMatrices.bcsc, t.keyMatrices.bcwc), t.keyMatricesTime.modified();
    }
    return t.keyMatrices;
  };
}
const eot = {
  keyMatricesTime: null,
  keyMatrices: null,
  propID: void 0,
  bufferShift: void 0
};
function not(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, eot, e), ui.extend(i, t, e), t.keyMatricesTime = {}, tt.obj(t.keyMatricesTime, {
    mtime: 0
  }), t.keyMatrices = {
    normalMatrix: new Float64Array(16),
    bcwc: new Float64Array(16),
    bcsc: new Float64Array(16)
  }, tt.get(i, t, ["propID", "keyMatricesTime"]), t.bufferShift = [0, 0, 0, 0], tot(i, t);
}
const iot = tt.newInstance(not);
Xo("vtkActor2D", iot);
function sot(i, t) {
  t.classHierarchy.push("vtkWebGPUCubeAxesActor"), i.buildPass = (e) => {
    e && (t.WebGPURenderer = i.getFirstAncestorOfType("vtkWebGPURenderer"), t.WebGPURenderWindow = t.WebGPURenderer.getParent(), t.CubeAxesActorHelper.getRenderable() || t.CubeAxesActorHelper.setRenderable(t.renderable), i.prepareNodes(), i.addMissingNode(t.CubeAxesActorHelper.getTmActor()), i.addMissingNode(t.renderable.getGridActor()), i.removeUnusedNodes());
  }, i.opaquePass = (e, n) => {
    if (e) {
      const s = t.WebGPURenderer ? t.WebGPURenderer.getRenderable().getActiveCamera() : null, r = t.WebGPURenderer.getTiledSizeAndOrigin();
      t.CubeAxesActorHelper.updateAPISpecificData([r.usize, r.vsize], s, t.WebGPURenderWindow.getRenderable());
    }
  };
}
const rot = {};
function aot(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, rot, e), ui.extend(i, t, e), t.CubeAxesActorHelper = F9.newCubeAxesActorHelper(), sot(i, t);
}
const oot = In(aot, "vtkWebGPUCubeAxesActor");
Xo("vtkCubeAxesActor", oot);
const {
  DisplayLocation: bL
} = ij;
function lot(i, t) {
  t.classHierarchy.push("vtkProperty2D"), i.setDisplayLocationToBackground = () => i.setDisplayLocation(bL.BACKGROUND), i.setDisplayLocationToForeground = () => i.setDisplayLocation(bL.FOREGROUND), i.setRepresentationToWireframe = () => i.setRepresentation(Vn.WIREFRAME), i.setRepresentationToSurface = () => i.setRepresentation(Vn.SURFACE), i.setRepresentationToPoints = () => i.setRepresentation(Vn.POINTS), i.getRepresentationAsString = () => tt.enumToString(Vn, t.representation);
}
const cot = {
  color: [1, 1, 1],
  opacity: 1,
  pointSize: 1,
  lineWidth: 1,
  representation: Vn.SURFACE,
  displayLocation: bL.FOREGROUND
};
function uot(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, cot, e), tt.obj(i, t), tt.setGet(i, t, ["opacity", "lineWidth", "pointSize", "displayLocation", "representation"]), tt.setGetArray(i, t, ["color"], 3), lot(i, t);
}
const dot = tt.newInstance(uot, "vtkProperty2D");
var Wj = {
  newInstance: dot,
  ...ij
};
const {
  BufferUsage: ir,
  PrimitiveTypes: ma
} = Xg, {
  Representation: iM
} = V0, {
  ScalarMode: sM
} = Ue, {
  CoordinateSystem: hot
} = np, {
  DisplayLocation: pot
} = Wj, mot = `
//VTK::Renderer::Dec

//VTK::Color::Dec

//VTK::Normal::Dec

//VTK::TCoord::Dec

//VTK::Select::Dec

//VTK::Mapper::Dec

//VTK::IOStructs::Dec

@vertex
fn main(
//VTK::IOStructs::Input
)
//VTK::IOStructs::Output
{
  var output : vertexOutput;

  var vertex: vec4<f32> = vertexBC;

  //VTK::Color::Impl

  //VTK::Normal::Impl

  //VTK::TCoord::Impl

  //VTK::Select::Impl

  //VTK::Position::Impl

  return output;
}
`, bot = `
struct PBRData {
  diffuse: vec3<f32>,
  specular: vec3<f32>,
}

// Dot product with the max already in it
fn mdot(a: vec3<f32>, b: vec3<f32>) -> f32 {
  return max(0.0, dot(a, b));
}
// Dot product with a max in it that does not allow for negative values
// Physically based rendering is accurate as long as normals are accurate,
// however this is pretty often not the case. In order to prevent negative
// values from ruining light calculations and creating zones of zero light,
// this remapping is used, which smoothly clamps the dot product between
// zero and one while still maintaining a good amount of accuracy.
fn cdot(a: vec3<f32>, b: vec3<f32>) -> f32 {
  var d: f32 = max(0.0, dot(a, b));
  d = pow((d + 1.0) / 2.0, 2.6);
  return d;
}

// Lambertian diffuse model
fn lambertDiffuse(base: vec3<f32>, N: vec3<f32>, L: vec3<f32>) -> vec3<f32> {
  var pi: f32 = 3.14159265359; 
  var NdotL: f32 = mdot(N, L);
  NdotL = pow(NdotL, 1.5);
  return (base/pi)*NdotL;
}

// Yasuhiro Fujii improvement on the Oren-Nayar model
// https://mimosa-pudica.net/improved-oren-nayar.html
// p is surface color, o is roughness
fn fujiiOrenNayar(p: vec3<f32>, o: f32, N: vec3<f32>, L: vec3<f32>, V: vec3<f32>) -> vec3<f32> {
  var invpi: f32 = 0.31830988618; // 1/pi

  var o2 = o*o;
  var NdotL: f32 = mdot(N, L);
  NdotL = pow(NdotL, 1.5); // Less physically accurate, but hides the "seams" between lights better

  var NdotV: f32 = mdot(N, V);
  var LdotV: f32 = mdot(L, V);

  var s: f32 = LdotV - NdotL*NdotV;
  var t: f32 = mix(1.0, max(NdotL, NdotV), step(0.0, s)); // Mix with step is the equivalent of an if statement
  var A: vec3<f32> = 0.5*(o2 / (o2 + 0.33)) + 0.17*p*(o2 / (o2 + 0.13));
  A = invpi*(1 - A);
  var B: f32 = 0.45*(o2 / (o2 + 0.09));
  B = invpi*B;

  return p*NdotL*(A + B*(s/t));
}

// Fresnel portion of BRDF (IOR only, simplified)
fn schlickFresnelIOR(V: vec3<f32>, N: vec3<f32>, ior: f32, k: f32) -> f32 {
  var NdotV: f32 = mdot(V, N);
  var F0: f32 = (pow((ior - 1.0), 2.0) + k*k) / (pow((ior + 1.0), 2.0) + k*k); // This takes into account the roughness, which the other one does not
  return F0 + (1.0 - F0) * pow((1.0-NdotV), 5.0);
}

// Fresnel portion of BRDF (Color ior, better)
fn schlickFresnelRGB(V: vec3<f32>, N: vec3<f32>, F0: vec3<f32>) -> vec3<f32> {
  var NdotV: f32 = mdot(V, N);
  return F0 + (1.0 - F0) * pow((1-NdotV), 5.0);
}

// Normal portion of BRDF
// https://learnopengl.com/PBR/Theory
// Trowbridge-Reitz GGX functions: normal, halfway, roughness^2
fn trGGX(N: vec3<f32>, H: vec3<f32>, a: f32) -> f32 {
  var pi: f32 = 3.14159265359; 

  var a2: f32 = a*a;
  var NdotH = mdot(N, H);
  var NdotH2 = NdotH*NdotH;
  
  var denom: f32 = NdotH2 * (a2 - 1.0) + 1.0;

  return a2 / max((pi*denom*denom), 0.000001);
}

// A VERY bad approximation of anisotropy. Real anisotropic calculations require tangent and bitangent
fn anisotrophicTrGGX(N: vec3<f32>, H: vec3<f32>, O: vec3<f32>, s: f32, a: f32) -> f32 {
  var Op: vec3<f32> = (rendererUBO.WCVCNormals * vec4<f32>(normalize(O) * s, 0.)).xyz;

  var ggx1: f32 = trGGX(N + Op*s, H, a);
  var ggx2: f32 = trGGX(N - Op*s, H, a);
  return (0.5 * ggx1 + 0.5 * ggx2);
}

// Geometry portion of BRDF
fn schlickGGX(N: vec3<f32>, X: vec3<f32>, k: f32) -> f32 {
  var NdotX = cdot(N, X);
  return NdotX / max(0.000001, (NdotX*(1.0-k) + k));
}

fn smithSurfaceRoughness(N: vec3<f32>, V: vec3<f32>, L: vec3<f32>, k: f32) -> f32 {
  var ggx1: f32 = min(1.0, schlickGGX(N, V, k));
  var ggx2: f32 = min(1.0, schlickGGX(N, L, k));
  return ggx1*ggx2;
}

// BRDF Combination
fn cookTorrance(D: f32, F: f32, G: f32, N: vec3<f32>, V: vec3<f32>, L: vec3<f32>) -> f32 {
  var num: f32 = D*F*G;
  var denom: f32 = 4*cdot(V, N)*cdot(L, N);

  return num / max(denom, 0.000001);
}

// Different lighting calculations for different light sources
fn calcDirectionalLight(N: vec3<f32>, V: vec3<f32>, ior: f32, roughness: f32, metallic: f32, direction: vec3<f32>, color: vec3<f32>, base: vec3<f32>) -> PBRData {  
  var L: vec3<f32> = normalize(direction); // Light Vector
  var H: vec3<f32> = normalize(L + V); // Halfway Vector

  var alpha = roughness*roughness;
  var k: f32 = alpha*alpha / 2;

  var D: f32 = trGGX(N, H, alpha); // Distribution
  // var F: f32 = schlickFresnelIOR(V, N, ior, k); // Fresnel
  var G: f32 = smithSurfaceRoughness(N, V, L, k); // Geometry

  var brdf: f32 = cookTorrance(D, 1.0, G, N, V, L); // Fresnel term is replaced with 1 because it is added later
  var incoming: vec3<f32> = color;
  var angle: f32 = mdot(L, N);
  angle = pow(angle, 1.5);

  var specular: vec3<f32> = brdf*incoming*angle;
  // Oren-Nayar gives a clay-like effect when fully rough which some people may not want, so it might be better to give a separate
  // control property for the diffuse vs specular roughness
  var diffuse: vec3<f32> = incoming*fujiiOrenNayar(base, roughness, N, L, V); 
  // Stores the specular and diffuse separately to allow for finer post processing
  var out = PBRData(diffuse, specular);
  
  return out; // Returns angle along with color of light so the final color can be multiplied by angle as well (creates black areas)
}

// TODO: find some way to reduce the number of arguments going in here
fn calcPointLight(N: vec3<f32>, V: vec3<f32>, fragPos: vec3<f32>, ior: f32, roughness: f32, metallic: f32, position: vec3<f32>, color: vec3<f32>, base: vec3<f32>) -> PBRData {
  var L: vec3<f32> = normalize(position - fragPos); // Light Vector
  var H: vec3<f32> = normalize(L + V); // Halfway Vector
  var dist = distance(position, fragPos);

  var alpha = roughness*roughness;
  var k: f32 = alpha*alpha / 2.0; // could also be pow(alpha + 1.0, 2) / 8

  var D: f32 = trGGX(N, H, alpha); // Distribution
  // var F: f32 = schlickFresnelIOR(V, N, ior, k); // Fresnel
  var G: f32 = smithSurfaceRoughness(N, V, L, k); // Geometry

  var brdf: f32 = cookTorrance(D, 1.0, G, N, V, L);
  var incoming: vec3<f32> = color * (1.0 / (dist*dist));
  var angle: f32 = mdot(L, N);
  angle = pow(angle, 1.5); // Smoothing factor makes it less accurate, but reduces ugly "seams" bewteen light sources

  var specular: vec3<f32> = brdf*incoming*angle;
  var diffuse: vec3<f32> = incoming*fujiiOrenNayar(base, roughness, N, L, V);

  // Stores the specular and diffuse separately to allow for finer post processing
  // Could also be done (propably more properly) with a struct
  var out = PBRData(diffuse, specular);
  
  return out; // Returns angle along with color of light so the final color can be multiplied by angle as well (creates black areas)
}

// For a reason unknown to me, spheres dont seem to behave propperly with head-on spot lights
fn calcSpotLight(N: vec3<f32>, V: vec3<f32>, fragPos: vec3<f32>, ior: f32, roughness: f32, metallic: f32, position: vec3<f32>, direction: vec3<f32>, cones: vec2<f32>, color: vec3<f32>, base: vec3<f32>) -> PBRData {
  var L: vec3<f32> = normalize(position - fragPos);
  var H: vec3<f32> = normalize(L + V); // Halfway Vector
  var dist = distance(position, fragPos);

  var alpha = roughness*roughness;
  var k: f32 = alpha*alpha / 2.0; // could also be pow(alpha + 1.0, 2) / 8

  var D: f32 = trGGX(N, H, alpha); // Distribution
  // var F: f32 = schlickFresnelIOR(V, N, ior, k); // Fresnel
  var G: f32 = smithSurfaceRoughness(N, V, L, k); // Geometry

  var brdf: f32 = cookTorrance(D, 1.0, G, N, V, L);
  
  // Cones.x is the inner phi and cones.y is the outer phi
  var theta: f32 = mdot(normalize(direction), L);
  var epsilon: f32 = cones.x - cones.y;
  var intensity: f32 = (theta - cones.y) / epsilon;
  intensity = clamp(intensity, 0.0, 1.0);
  intensity /= dist*dist;

  var incoming: vec3<f32> = color * intensity;

  var angle: f32 = mdot(L, N);
  angle = pow(angle, 1.5); // Smoothing factor makes it less accurate, but reduces ugly "seams" bewteen light sources

  var specular: vec3<f32> = brdf*incoming*angle;
  var diffuse: vec3<f32> = incoming*fujiiOrenNayar(base, roughness, N, L, V);

  // Stores the specular and diffuse separately to allow for finer post processing
  // Could also be done (propably more properly) with a struct
  var out = PBRData(diffuse, specular);
  
  return out; // Returns angle along with color of light so the final color can be multiplied by angle as well (creates black areas)
}

// Environment mapping stuff
// Takes in a vector and converts it to an equivalent coordinate in a rectilinear texture. Should be replaced with cubemaps at some point
fn vecToRectCoord(dir: vec3<f32>) -> vec2<f32> {
  var tau: f32 = 6.28318530718;
  var pi: f32 = 3.14159265359;
  var out: vec2<f32> = vec2<f32>(0.0);

  out.x = atan2(dir.z, dir.x) / tau;
  out.x += 0.5;

  var phix: f32 = length(vec2(dir.x, dir.z));
  out.y = atan2(dir.y, phix) / pi + 0.5;

  return out;
}

//VTK::Renderer::Dec

//VTK::Color::Dec

//VTK::TCoord::Dec

// optional surface normal declaration
//VTK::Normal::Dec

//VTK::Select::Dec

//VTK::RenderEncoder::Dec

//VTK::Mapper::Dec

//VTK::IOStructs::Dec

@fragment
fn main(
//VTK::IOStructs::Input
)
//VTK::IOStructs::Output
{
  var output : fragmentOutput;

  // Temporary ambient, diffuse, and opacity
  var ambientColor: vec4<f32> = mapperUBO.AmbientColor;
  var diffuseColor: vec4<f32> = mapperUBO.DiffuseColor;
  var opacity: f32 = mapperUBO.Opacity;

  // This should be declared somewhere else
  var _diffuseMap: vec4<f32> = vec4<f32>(1.0);
  var _roughnessMap: vec4<f32> = vec4<f32>(1.0);
  var _metallicMap: vec4<f32> = vec4<f32>(1.0);
  var _normalMap: vec4<f32> = vec4<f32>(0.0, 0.0, 1.0, 0.0); // normal map was setting off the normal vector detection in fragment
  var _ambientOcclusionMap: vec4<f32> = vec4<f32>(1.);
  var _emissionMap: vec4<f32> = vec4<f32>(0.);

  //VTK::Color::Impl

  //VTK::TCoord::Impl

  //VTK::Normal::Impl

  var computedColor: vec4<f32> = vec4<f32>(diffuseColor.rgb, 1.0);

  //VTK::Light::Impl

  //VTK::Select::Impl

  if (computedColor.a == 0.0) { discard; };

  //VTK::Position::Impl

  //VTK::RenderEncoder::Impl

  return output;
}
`;
function mO(i) {
  return i.indexOf("edge") >= 0;
}
function fot(i, t) {
  t.classHierarchy.push("vtkWebGPUCellArrayMapper"), i.buildPass = (e) => {
    e && (t.is2D ? (t.WebGPUActor = i.getFirstAncestorOfType("vtkWebGPUActor2D"), t.forceZValue = !0) : (t.WebGPUActor = i.getFirstAncestorOfType("vtkWebGPUActor"), t.forceZValue = !1), t.coordinateSystem = t.WebGPUActor.getRenderable().getCoordinateSystem(), t.useRendererMatrix = t.coordinateSystem !== hot.DISPLAY, t.WebGPURenderer = t.WebGPUActor.getFirstAncestorOfType("vtkWebGPURenderer"), t.WebGPURenderWindow = t.WebGPURenderer.getParent(), t.device = t.WebGPURenderWindow.getDevice());
  }, i.translucentPass = (e) => {
    e && (i.prepareToDraw(t.WebGPURenderer.getRenderEncoder()), t.renderEncoder.registerDrawCallback(t.pipeline, i.draw));
  }, i.opaquePass = (e) => {
    e && (i.prepareToDraw(t.WebGPURenderer.getRenderEncoder()), t.renderEncoder.registerDrawCallback(t.pipeline, i.draw));
  }, i.updateUBO = () => {
    var r;
    const n = t.WebGPUActor.getRenderable().getProperty(), s = t.UBO.getSendTime();
    if (i.getMTime() > s || n.getMTime() > s || t.renderable.getMTime() > s) {
      const a = t.WebGPUActor.getKeyMatrices(t.WebGPURenderer);
      if (t.UBO.setArray("BCWCMatrix", a.bcwc), t.UBO.setArray("BCSCMatrix", a.bcsc), t.UBO.setArray("MCWCNormals", a.normalMatrix), t.is2D) {
        t.UBO.setValue("ZValue", t.WebGPUActor.getRenderable().getProperty().getDisplayLocation() === pot.FOREGROUND ? 1 : 0);
        const c = n.getColorByReference();
        t.UBO.setValue("AmbientIntensity", 1), t.UBO.setArray("DiffuseColor", [c[0], c[1], c[2], 1]), t.UBO.setValue("DiffuseIntensity", 0), t.UBO.setValue("SpecularIntensity", 0);
      } else {
        let c = n.getAmbientColorByReference();
        t.UBO.setValue("AmbientIntensity", n.getAmbient()), t.UBO.setArray("AmbientColor", [c[0], c[1], c[2], 1]), t.UBO.setValue("DiffuseIntensity", n.getDiffuse()), c = n.getDiffuseColorByReference(), t.UBO.setArray("DiffuseColor", [c[0], c[1], c[2], 1]), t.UBO.setValue("Roughness", n.getRoughness()), t.UBO.setValue("BaseIOR", n.getBaseIOR()), t.UBO.setValue("Metallic", n.getMetallic()), t.UBO.setValue("NormalStrength", n.getNormalStrength()), t.UBO.setValue("Emission", n.getEmission()), t.UBO.setValue("SpecularIntensity", n.getSpecular()), c = n.getSpecularColorByReference(), t.UBO.setArray("SpecularColor", [c[0], c[1], c[2], 1]);
      }
      const o = (r = n.getEdgeColorByReference) == null ? void 0 : r.call(n);
      o && t.UBO.setArray("EdgeColor", [o[0], o[1], o[2], 1]), t.UBO.setValue("LineWidth", n.getLineWidth()), t.UBO.setValue("Opacity", n.getOpacity()), t.UBO.setValue("PropID", t.WebGPUActor.getPropID());
      const l = t.WebGPURenderWindow.getDevice();
      t.UBO.sendIfNeeded(l);
    }
  }, i.haveWideLines = () => {
    const e = t.WebGPUActor.getRenderable(), n = e.getProperty().getRepresentation();
    return e.getProperty().getLineWidth() <= 1 || t.primitiveType === ma.Verts ? !1 : t.primitiveType === ma.Triangles || t.primitiveType === ma.TriangleStrips ? n === iM.WIREFRAME : !0;
  }, i.replaceShaderPosition = (e, n, s) => {
    const r = n.getShaderDescription("vertex");
    r.addBuiltinOutput("vec4<f32>", "@builtin(position) Position"), r.hasOutput("vertexVC") || r.addOutput("vec4<f32>", "vertexVC");
    let a = r.getCode();
    t.useRendererMatrix ? (a = kn.substitute(a, "//VTK::Position::Impl", ["    var pCoord: vec4<f32> = rendererUBO.SCPCMatrix*mapperUBO.BCSCMatrix*vertexBC;", "    output.vertexVC = rendererUBO.SCVCMatrix * mapperUBO.BCSCMatrix * vec4<f32>(vertexBC.xyz, 1.0);", "//VTK::Position::Impl"]).result, t.forceZValue && (a = kn.substitute(a, "//VTK::Position::Impl", ["pCoord = vec4<f32>(pCoord.xyz/pCoord.w, 1.0);", "pCoord.z = mapperUBO.ZValue;", "//VTK::Position::Impl"]).result)) : (a = kn.substitute(a, "//VTK::Position::Impl", ["    var pCoord: vec4<f32> = mapperUBO.BCSCMatrix*vertexBC;", "    pCoord.x = 2.0* pCoord.x / rendererUBO.viewportSize.x - 1.0;", "    pCoord.y = 2.0* pCoord.y / rendererUBO.viewportSize.y - 1.0;", "    pCoord.z = 0.5 - 0.5 * pCoord.z;", "//VTK::Position::Impl"]).result, t.forceZValue && (a = kn.substitute(a, "//VTK::Position::Impl", ["    pCoord.z = mapperUBO.ZValue;", "//VTK::Position::Impl"]).result)), i.haveWideLines() && (r.addBuiltinInput("u32", "@builtin(instance_index) instanceIndex"), a = kn.substitute(a, "//VTK::Position::Impl", [
      "    var tmpPos: vec4<f32> = pCoord;",
      "    var numSteps: f32 = ceil(mapperUBO.LineWidth - 1.0);",
      "    var offset: f32 = (mapperUBO.LineWidth - 1.0) * (f32(input.instanceIndex / 2u) - numSteps/2.0) / numSteps;",
      "    var tmpPos2: vec3<f32> = tmpPos.xyz / tmpPos.w;",
      "    tmpPos2.x = tmpPos2.x + 2.0 * (f32(input.instanceIndex) % 2.0) * offset / rendererUBO.viewportSize.x;",
      "    tmpPos2.y = tmpPos2.y + 2.0 * (f32(input.instanceIndex + 1u) % 2.0) * offset / rendererUBO.viewportSize.y;",
      "    tmpPos2.z = min(1.0, tmpPos2.z + 0.00001);",
      // could become a setting
      "    pCoord = vec4<f32>(tmpPos2.xyz * tmpPos.w, tmpPos.w);",
      "//VTK::Position::Impl"
    ]).result), a = kn.substitute(a, "//VTK::Position::Impl", ["    output.Position = pCoord;"]).result, r.setCode(a);
  }, t.shaderReplacements.set("replaceShaderPosition", i.replaceShaderPosition), i.replaceShaderNormal = (e, n, s) => {
    const r = s.getBuffer("normalMC"), a = t.WebGPUActor.getRenderable();
    if (r) {
      const o = n.getShaderDescription("vertex");
      o.hasOutput("normalVC") || o.addOutput("vec3<f32>", "normalVC", r.getArrayInformation()[0].interpolation), o.hasOutput("tangentVC") || o.addOutput("vec3<f32>", "tangentVC", r.getArrayInformation()[0].interpolation), o.hasOutput("bitangentVC") || o.addOutput("vec3<f32>", "bitangentVC", r.getArrayInformation()[0].interpolation);
      let l = o.getCode();
      l = kn.substitute(l, "//VTK::Normal::Impl", [
        "  output.normalVC = normalize((rendererUBO.WCVCNormals * mapperUBO.MCWCNormals * normalMC).xyz);",
        // This is just an approximation, but it happens to work extremely well
        // It only works well for normals that are head on and not super angled though
        // Definitely needs to be replaced
        "  var c1: vec3<f32> = cross(output.normalVC, vec3<f32>(0, 0, 1));",
        "  var c2: vec3<f32> = cross(output.normalVC, vec3<f32>(0, 1, 0));",
        "  var tangent: vec3<f32> = mix(c1, c2, distance(c1, c2));",
        "  output.tangentVC = normalize(tangent);",
        "  output.bitangentVC = normalize(cross(output.normalVC, tangent));"
      ]).result, o.setCode(l);
      const c = n.getShaderDescription("fragment");
      l = c.getCode(), a.getProperty().getNormalTexture() ? l = kn.substitute(l, "//VTK::Normal::Impl", ["  var normal: vec3<f32> = input.normalVC;", "  if (!input.frontFacing) { normal = -normal; }", "  var tangent: vec3<f32> = input.tangentVC;", "  var bitangent: vec3<f32> = input.bitangentVC;", "  var TCVCMatrix: mat3x3<f32> = mat3x3<f32>(", "    tangent.x, bitangent.x, normal.x,", "    tangent.y, bitangent.y, normal.y,", "    tangent.z, bitangent.z, normal.z,", "  );", "  var mappedNormal: vec3<f32> = TCVCMatrix * (_normalMap.xyz * 2 - 1);", "  normal = mix(normal, mappedNormal, mapperUBO.NormalStrength);", "  normal = normalize(normal);"]).result : l = kn.substitute(l, "//VTK::Normal::Impl", ["  var normal: vec3<f32> = input.normalVC;", "  if (!input.frontFacing) { normal = -normal; }", "  normal = normalize(normal);"]).result, c.setCode(l);
    }
  }, t.shaderReplacements.set("replaceShaderNormal", i.replaceShaderNormal), i.replaceShaderLight = (e, n, s) => {
    var c;
    if (e.includes("sel")) return;
    const r = n.getShaderDescription("vertex");
    r.hasOutput("vertexVC") || r.addOutput("vec4<f32>", "vertexVC");
    const a = t.WebGPURenderer.getRenderable(), o = n.getShaderDescription("fragment");
    let l = o.getCode();
    if (l.includes("var normal:") && t.useRendererMatrix && !mO(e) && !t.is2D && !e.includes("sel")) {
      const u = [
        // Constants
        "  var pi: f32 = 3.14159265359;",
        // Vectors needed for light calculations
        "  var fragPos: vec3<f32> = vec3<f32>(input.vertexVC.xyz);",
        "  var V: vec3<f32> = mix(normalize(-fragPos), vec3<f32>(0, 0, 1), f32(rendererUBO.cameraParallel)); // View Vector",
        // Values needed for light calculations
        "  var baseColor: vec3<f32> = _diffuseMap.rgb * diffuseColor.rgb;",
        "  var roughness: f32 = max(0.000001, mapperUBO.Roughness * _roughnessMap.r);",
        // Need to have a different way of sampling greyscale values aside from .r
        "  var metallic: f32 = mapperUBO.Metallic * _metallicMap.r;",
        "  var alpha: f32 = roughness*roughness;",
        "  var ior: f32 = mapperUBO.BaseIOR;",
        "  var k: f32 = alpha*alpha / 2;",
        // Split diffuse and specular components
        "  var diffuse: vec3<f32> = vec3<f32>(0.);",
        "  var specular: vec3<f32> = vec3<f32>(0.);",
        "  var emission: vec3<f32> = _emissionMap.rgb * mapperUBO.Emission;",
        // Summing diffuse and specular components of directional lights
        "  {",
        "    var i: i32 = 0;",
        "    loop {",
        "      if !(i < rendererUBO.LightCount) { break; }",
        "      switch (i32(rendererLightSSBO.values[i].LightData.x)) {",
        "         // Point Light",
        "         case 0 {",
        "           var color: vec3<f32> = rendererLightSSBO.values[i].LightColor.rgb * rendererLightSSBO.values[i].LightColor.w;",
        "           var pos: vec3<f32> = (rendererLightSSBO.values[i].LightPos).xyz;",
        "           var calculated: PBRData = calcPointLight(normal, V, fragPos, ior, roughness, metallic, pos, color, baseColor);",
        "           diffuse += max(vec3<f32>(0), calculated.diffuse);",
        "           specular += max(vec3<f32>(0), calculated.specular);",
        "          }",
        "         // Directional light",
        "         case 1 {",
        "           var dir: vec3<f32> = (rendererUBO.WCVCNormals * vec4<f32>(normalize(rendererLightSSBO.values[i].LightDir.xyz), 0.)).xyz;",
        "           dir = normalize(dir);",
        "           var color: vec3<f32> = rendererLightSSBO.values[i].LightColor.rgb * rendererLightSSBO.values[i].LightColor.w;",
        "           var calculated: PBRData = calcDirectionalLight(normal, V, ior, roughness, metallic, dir, color, baseColor); // diffuseColor.rgb needs to be fixed with a more dynamic diffuse color",
        "           diffuse += max(vec3<f32>(0), calculated.diffuse);",
        "           specular += max(vec3<f32>(0), calculated.specular);",
        "         }",
        "         // Spot Light",
        "         case 2 {",
        "           var color: vec3<f32> = rendererLightSSBO.values[i].LightColor.rgb * rendererLightSSBO.values[i].LightColor.w;",
        "           var pos: vec3<f32> = (rendererLightSSBO.values[i].LightPos).xyz;",
        "           var dir: vec3<f32> = (rendererUBO.WCVCNormals * vec4<f32>(normalize(rendererLightSSBO.values[i].LightDir.xyz), 0.)).xyz;",
        "           dir = normalize(dir);",
        "           var cones: vec2<f32> = vec2<f32>(rendererLightSSBO.values[i].LightData.y, rendererLightSSBO.values[i].LightData.z);",
        "           var calculated: PBRData = calcSpotLight(normal, V, fragPos, ior, roughness, metallic, pos, dir, cones, color, baseColor);",
        "           diffuse += max(vec3<f32>(0), calculated.diffuse);",
        "           specular += max(vec3<f32>(0), calculated.specular);",
        "         }",
        "         default { continue; }",
        "       }",
        "      continuing { i++; }",
        "    }",
        "  }",
        // Final variables for combining specular and diffuse
        "  var fresnel: f32 = schlickFresnelIOR(V, normal, ior, k); // Fresnel",
        "  fresnel = min(1.0, fresnel);",
        "  // This could be controlled with its own variable (that isnt base color) for better artistic control",
        "  var fresnelMetallic: vec3<f32> = schlickFresnelRGB(V, normal, baseColor); // Fresnel for metal, takes color into account",
        "  var kS: vec3<f32> = mix(vec3<f32>(fresnel), fresnelMetallic, metallic);",
        "  kS = min(vec3<f32>(1.0), kS);",
        "  var kD: vec3<f32> = (1.0 - kS) * (1.0 - metallic);",
        "  var PBR: vec3<f32> = mapperUBO.DiffuseIntensity*kD*diffuse + kS*specular;",
        "  PBR += emission;",
        "  computedColor = vec4<f32>(PBR, mapperUBO.Opacity);"
      ];
      (c = a.getEnvironmentTexture()) != null && c.getImageLoaded() && u.push(
        "  // To get diffuse IBL, the texture is sampled with normals in worldspace",
        "  var diffuseIBLCoords: vec3<f32> = (transpose(rendererUBO.WCVCNormals) * vec4<f32>(normal, 1.)).xyz;",
        "  var diffuseCoords: vec2<f32> = vecToRectCoord(diffuseIBLCoords);",
        "  // To get specular IBL, the texture is sampled as the worldspace reflection between the normal and view vectors",
        "  // Reflections are first calculated in viewspace, then converted to worldspace to sample the environment",
        "  var VreflN: vec3<f32> = normalize(reflect(-V, normal));",
        "  var reflectionIBLCoords = (transpose(rendererUBO.WCVCNormals) * vec4<f32>(VreflN, 1.)).xyz;",
        "  var specularCoords: vec2<f32> = vecToRectCoord(reflectionIBLCoords);",
        "  var diffuseIBL = textureSampleLevel(EnvironmentTexture, EnvironmentTextureSampler, diffuseCoords, rendererUBO.MaxEnvironmentMipLevel);",
        // Level multiplier should be set by UBO
        "  var level = roughness * rendererUBO.MaxEnvironmentMipLevel;",
        "  var specularIBL = textureSampleLevel(EnvironmentTexture, EnvironmentTextureSampler, specularCoords, level);",
        // Manual mip smoothing since not all formats support smooth level sampling
        "  var specularIBLContribution: vec3<f32> = specularIBL.rgb*rendererUBO.BackgroundSpecularStrength;",
        "  computedColor += vec4<f32>(specularIBLContribution*kS, 0);",
        "  var diffuseIBLContribution: vec3<f32> = diffuseIBL.rgb*rendererUBO.BackgroundDiffuseStrength;",
        "  diffuseIBLContribution *= baseColor * _ambientOcclusionMap.rgb;",
        // Multipy by baseColor may be changed
        "  computedColor += vec4<f32>(diffuseIBLContribution*kD, 0);"
      ), l = kn.substitute(l, "//VTK::Light::Impl", u).result, o.setCode(l);
    } else
      l = kn.substitute(l, "//VTK::Light::Impl", ["  var diffuse: vec3<f32> = diffuseColor.rgb;", "  var specular: vec3<f32> = mapperUBO.SpecularColor.rgb * mapperUBO.SpecularColor.a;", "  computedColor = vec4<f32>(diffuse * _diffuseMap.rgb, mapperUBO.Opacity);"]).result, o.setCode(l);
  }, t.shaderReplacements.set("replaceShaderLight", i.replaceShaderLight), i.replaceShaderColor = (e, n, s) => {
    if (mO(e)) {
      const c = n.getShaderDescription("fragment");
      let u = c.getCode();
      u = kn.substitute(u, "//VTK::Color::Impl", ["ambientColor = mapperUBO.EdgeColor;", "diffuseColor = mapperUBO.EdgeColor;"]).result, c.setCode(u);
      return;
    }
    const r = s.getBuffer("colorVI");
    if (!r) return;
    const a = n.getShaderDescription("vertex");
    a.addOutput("vec4<f32>", "color", r.getArrayInformation()[0].interpolation);
    let o = a.getCode();
    o = kn.substitute(o, "//VTK::Color::Impl", ["  output.color = colorVI;"]).result, a.setCode(o);
    const l = n.getShaderDescription("fragment");
    o = l.getCode(), o = kn.substitute(o, "//VTK::Color::Impl", ["ambientColor = input.color;", "diffuseColor = input.color;", "opacity = mapperUBO.Opacity * input.color.a;"]).result, l.setCode(o);
  }, t.shaderReplacements.set("replaceShaderColor", i.replaceShaderColor), i.replaceShaderTCoord = (e, n, s) => {
    var p, m, b, y, Z, g, f, T, M, N, W, x, V, X, C, R, z, F, P, j;
    if (!s.hasAttribute("tcoord")) return;
    const r = n.getShaderDescription("vertex"), a = s.getBuffer("tcoord"), o = Rr.getNumberOfComponentsFromBufferFormat(a.getArrayInformation()[0].format);
    let l = r.getCode();
    r.addOutput(`vec${o}<f32>`, "tcoordVS"), l = kn.substitute(l, "//VTK::TCoord::Impl", ["  output.tcoordVS = tcoord;"]).result, r.setCode(l);
    const c = n.getShaderDescription("fragment");
    l = c.getCode();
    const u = t.WebGPUActor.getRenderable(), d = (H) => H ? H.getDimensionality() === o : !1, h = [];
    ((b = (m = (p = u.getProperty()).getDiffuseTexture) == null ? void 0 : m.call(p)) != null && b.getImageLoaded() || u.getTextures()[0] || t.colorTexture) && // Chained or statements here are questionable
    (d((Z = (y = u.getProperty()).getDiffuseTexture) == null ? void 0 : Z.call(y)) || d(u.getTextures()[0]) || d(t.colorTexture)) && h.push("_diffuseMap = textureSample(DiffuseTexture, DiffuseTextureSampler, input.tcoordVS);"), (T = (f = (g = u.getProperty()).getRoughnessTexture) == null ? void 0 : f.call(g)) != null && T.getImageLoaded() && d(u.getProperty().getRoughnessTexture()) && h.push("_roughnessMap = textureSample(RoughnessTexture, RoughnessTextureSampler, input.tcoordVS);"), (W = (N = (M = u.getProperty()).getMetallicTexture) == null ? void 0 : N.call(M)) != null && W.getImageLoaded() && d(u.getProperty().getMetallicTexture()) && h.push("_metallicMap = textureSample(MetallicTexture, MetallicTextureSampler, input.tcoordVS);"), (X = (V = (x = u.getProperty()).getNormalTexture) == null ? void 0 : V.call(x)) != null && X.getImageLoaded() && d(u.getProperty().getNormalTexture()) && h.push("_normalMap = textureSample(NormalTexture, NormalTextureSampler, input.tcoordVS);"), (z = (R = (C = u.getProperty()).getAmbientOcclusionTexture) == null ? void 0 : R.call(C)) != null && z.getImageLoaded() && d(u.getProperty().getAmbientOcclusionTexture()) && h.push("_ambientOcclusionMap = textureSample(AmbientOcclusionTexture, AmbientOcclusionTextureSampler, input.tcoordVS);"), (j = (P = (F = u.getProperty()).getEmissionTexture) == null ? void 0 : P.call(F)) != null && j.getImageLoaded() && d(u.getProperty().getEmissionTexture()) && h.push("_emissionMap = textureSample(EmissionTexture, EmissionTextureSampler, input.tcoordVS);"), l = kn.substitute(l, "//VTK::TCoord::Impl", h).result, c.setCode(l);
  }, t.shaderReplacements.set("replaceShaderTCoord", i.replaceShaderTCoord), i.replaceShaderSelect = (e, n, s) => {
    if (e.includes("sel")) {
      const r = n.getShaderDescription("fragment");
      let a = r.getCode();
      a = kn.substitute(a, "//VTK::Select::Impl", ["  var compositeID: u32 = 0u;"]).result, r.setCode(a);
    }
  }, t.shaderReplacements.set("replaceShaderSelect", i.replaceShaderSelect), i.getUsage = (e, n) => e === iM.POINTS || n === ma.Points ? ir.Verts : n === ma.Lines ? ir.Lines : e === iM.WIREFRAME ? n === ma.Triangles ? ir.LinesFromTriangles : ir.LinesFromStrips : n === ma.Triangles ? ir.Triangles : n === ma.TriangleStrips ? ir.Strips : n === ma.TriangleEdges ? ir.LinesFromTriangles : ir.LinesFromStrips, i.getHashFromUsage = (e) => `pt${e}`, i.getTopologyFromUsage = (e) => {
    switch (e) {
      case ir.Triangles:
        return "triangle-list";
      case ir.Verts:
        return "point-list";
      case ir.Lines:
      default:
        return "line-list";
    }
  }, i.buildVertexInput = () => {
    var b, y;
    const e = t.currentInput, n = t.cellArray, s = t.primitiveType;
    let a = t.WebGPUActor.getRenderable().getProperty().getRepresentation();
    const o = t.WebGPURenderWindow.getDevice();
    let l = !1;
    s === ma.TriangleEdges && (l = !0, a = iM.WIREFRAME);
    const c = t.vertexInput, u = e.getPoints();
    let d;
    if (n) {
      const Z = {
        hash: `R${a}P${s}${n.getMTime()}`,
        usage: ir.Index,
        cells: n,
        numberOfPoints: u.getNumberOfPoints(),
        primitiveType: s,
        representation: a
      };
      d = o.getBufferManager().getBuffer(Z), c.setIndexBuffer(d);
    } else
      c.setIndexBuffer(null);
    if (u) {
      const Z = t.WebGPUActor.getBufferShift(t.WebGPURenderer), g = {
        hash: `${u.getMTime()}I${d.getMTime()}${Z.join()}float32x4`,
        usage: ir.PointArray,
        format: "float32x4",
        dataArray: u,
        indexBuffer: d,
        shift: Z,
        packExtra: !0
      }, f = o.getBufferManager().getBuffer(g);
      c.addBuffer(f, ["vertexBC"]);
    } else
      c.removeBufferIfPresent("vertexBC");
    const h = i.getUsage(a, s);
    if (t._usesCellNormals = !1, !t.is2D && // no lighting on Property2D
    (h === ir.Triangles || h === ir.Strips)) {
      const Z = e.getPointData().getNormals(), g = {
        format: "snorm8x4",
        indexBuffer: d,
        packExtra: !0,
        shift: 0,
        scale: 127
      };
      if (Z) {
        g.hash = `${Z.getMTime()}I${d.getMTime()}snorm8x4`, g.dataArray = Z, g.usage = ir.PointArray;
        const f = o.getBufferManager().getBuffer(g);
        c.addBuffer(f, ["normalMC"]);
      } else if (s === ma.Triangles) {
        t._usesCellNormals = !0, g.hash = `PFN${u.getMTime()}I${d.getMTime()}snorm8x4`, g.dataArray = u, g.cells = n, g.usage = ir.NormalsFromPoints;
        const f = o.getBufferManager().getBuffer(g);
        c.addBuffer(f, ["normalMC"]);
      } else
        c.removeBufferIfPresent("normalMC");
    } else
      c.removeBufferIfPresent("normalMC");
    let p = !1;
    if (t.renderable.getScalarVisibility()) {
      const Z = t.renderable.getColorMapColors();
      if (Z && !l) {
        const g = t.renderable.getScalarMode();
        let f = !1;
        (g === sM.USE_CELL_DATA || g === sM.USE_CELL_FIELD_DATA || g === sM.USE_FIELD_DATA || !e.getPointData().getScalars()) && g !== sM.USE_POINT_FIELD_DATA && Z && (f = !0);
        const T = {
          usage: ir.PointArray,
          format: "unorm8x4",
          hash: `${f}${Z.getMTime()}I${d.getMTime()}unorm8x4`,
          dataArray: Z,
          indexBuffer: d,
          cellData: f,
          cellOffset: 0
        }, M = o.getBufferManager().getBuffer(T);
        c.addBuffer(M, ["colorVI"]), p = !0;
      }
    }
    p || c.removeBufferIfPresent("colorVI");
    let m = null;
    if ((y = (b = t.renderable).getInterpolateScalarsBeforeMapping) != null && y.call(b) && t.renderable.getColorCoordinates() ? m = t.renderable.getColorCoordinates() : m = e.getPointData().getTCoords(), m && !l) {
      const Z = o.getBufferManager().getBufferForPointArray(m, c.getIndexBuffer());
      c.addBuffer(Z, ["tcoord"]);
    } else
      c.removeBufferIfPresent("tcoord");
  }, i.updateTextures = () => {
    var l, c, u, d, h, p, m, b, y, Z, g, f, T, M, N;
    const e = [], n = [], s = (c = (l = t.renderable).getColorTextureMap) == null ? void 0 : c.call(l);
    s && (t.colorTexture || (t.colorTexture = vc.newInstance({
      label: "polyDataColor"
    })), t.colorTexture.setInputData(s), n.push(["Diffuse", t.colorTexture]));
    const r = t.WebGPUActor.getRenderable(), a = t.WebGPURenderer.getRenderable(), o = [];
    if ((d = (u = r.getProperty()).getDiffuseTexture) != null && d.call(u)) {
      const W = ["Diffuse", r.getProperty().getDiffuseTexture()];
      o.push(W);
    }
    if (r.getTextures()[0]) {
      const W = ["Diffuse", r.getTextures()[0]];
      o.push(W);
    }
    if (t.colorTexture) {
      const W = ["Diffuse", t.colorTexture];
      o.push(W);
    }
    if ((p = (h = r.getProperty()).getRoughnessTexture) != null && p.call(h)) {
      const W = ["Roughness", r.getProperty().getRoughnessTexture()];
      o.push(W);
    }
    if ((b = (m = r.getProperty()).getMetallicTexture) != null && b.call(m)) {
      const W = ["Metallic", r.getProperty().getMetallicTexture()];
      o.push(W);
    }
    if ((Z = (y = r.getProperty()).getNormalTexture) != null && Z.call(y)) {
      const W = ["Normal", r.getProperty().getNormalTexture()];
      o.push(W);
    }
    if ((f = (g = r.getProperty()).getAmbientOcclusionTexture) != null && f.call(g)) {
      const W = ["AmbientOcclusion", r.getProperty().getAmbientOcclusionTexture()];
      o.push(W);
    }
    if ((M = (T = r.getProperty()).getEmissionTexture) != null && M.call(T)) {
      const W = ["Emission", r.getProperty().getEmissionTexture()];
      o.push(W);
    }
    if ((N = a.getEnvironmentTexture) != null && N.call(a)) {
      const W = ["Environment", a.getEnvironmentTexture()];
      o.push(W);
    }
    for (let W = 0; W < o.length; W++)
      (o[W][1].getInputData() || o[W][1].getJsImageData() || o[W][1].getCanvas()) && n.push(o[W]), o[W][1].getImage() && o[W][1].getImageLoaded() && n.push(o[W]);
    for (let W = 0; W < n.length; W++) {
      const x = n[W][1], V = n[W][0], X = t.device.getTextureManager().getTextureForVTKTexture(x);
      if (X.getReady()) {
        let C = !1;
        for (let R = 0; R < t.textures.length; R++)
          t.textures[R] === X && (C = !0, e[R] = !0);
        if (!C) {
          e[t.textures.length] = !0;
          const R = X.createView(`${V}Texture`);
          t.textures.push(X), t.textureViews.push(R);
          const z = x.getInterpolate() ? "linear" : "nearest";
          let F = null;
          !F && x.getEdgeClamp() && x.getRepeat() && (F = "mirror-repeat"), !F && x.getEdgeClamp() && (F = "clamp-to-edge"), !F && x.getRepeat() && (F = "repeat"), V !== "Environment" ? R.addSampler(t.device, {
            addressModeU: F,
            addressModeV: F,
            addressModeW: F,
            minFilter: z,
            magFilter: z
          }) : R.addSampler(t.device, {
            addressModeU: "repeat",
            addressModeV: "clamp-to-edge",
            addressModeW: "repeat",
            minFilter: z,
            magFilter: z,
            mipmapFilter: "linear"
          });
        }
      }
    }
    for (let W = t.textures.length - 1; W >= 0; W--)
      e[W] || (t.textures.splice(W, 1), t.textureViews.splice(W, 1));
  }, i.computePipelineHash = () => {
    let e = `pd${t.useRendererMatrix ? "r" : ""}${t.forceZValue ? "z" : ""}`;
    if (t.primitiveType === ma.TriangleEdges || t.primitiveType === ma.TriangleStripEdges)
      e += "edge";
    else {
      if (t.vertexInput.hasAttribute("normalMC") && (e += "n"), t.vertexInput.hasAttribute("colorVI") && (e += "c"), t.vertexInput.hasAttribute("tcoord")) {
        const s = t.vertexInput.getBuffer("tcoord"), r = Rr.getNumberOfComponentsFromBufferFormat(s.getArrayInformation()[0].format);
        e += `t${r}`;
      }
      t.textures.length && (e += `tx${t.textures.length}`);
    }
    t._usesCellNormals && (e += "cn"), t.SSBO && (e += "ssbo");
    const n = i.getHashFromUsage(t.usage);
    e += n, e += t.renderEncoder.getPipelineHash(), t.pipelineHash = e;
  }, i.updateBuffers = () => {
    t.primitiveType !== ma.TriangleEdges && t.primitiveType !== ma.TriangleStripEdges && i.updateTextures();
    const e = t.WebGPUActor.getRenderable(), n = e.getProperty().getRepresentation();
    t.usage = i.getUsage(n, t.primitiveType), i.buildVertexInput();
    const s = t.vertexInput.getBuffer("vertexBC");
    if (i.setNumberOfVertices(s.getSizeInBytes() / s.getStrideInBytes()), i.setTopology(i.getTopologyFromUsage(t.usage)), i.updateUBO(), i.haveWideLines()) {
      const r = e.getProperty();
      i.setNumberOfInstances(Math.ceil(r.getLineWidth() * 2));
    } else
      i.setNumberOfInstances(1);
  };
}
const got = {
  is2D: !1,
  cellArray: null,
  currentInput: null,
  cellOffset: 0,
  primitiveType: 0,
  colorTexture: null,
  renderEncoder: null,
  textures: null
};
function Gj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, got, e), fj.extend(i, t, e), t.fragmentShaderTemplate = bot, t.vertexShaderTemplate = mot, t._tmpMat3 = gi.identity(new Float64Array(9)), t._tmpMat4 = ut.identity(new Float64Array(16)), t.UBO = Cb.newInstance({
    label: "mapperUBO"
  }), t.UBO.addEntry("BCWCMatrix", "mat4x4<f32>"), t.UBO.addEntry("BCSCMatrix", "mat4x4<f32>"), t.UBO.addEntry("MCWCNormals", "mat4x4<f32>"), t.UBO.addEntry("AmbientColor", "vec4<f32>"), t.UBO.addEntry("DiffuseColor", "vec4<f32>"), t.UBO.addEntry("EdgeColor", "vec4<f32>"), t.UBO.addEntry("SpecularColor", "vec4<f32>"), t.UBO.addEntry("AmbientIntensity", "f32"), t.UBO.addEntry("DiffuseIntensity", "f32"), t.UBO.addEntry("Roughness", "f32"), t.UBO.addEntry("Metallic", "f32"), t.UBO.addEntry("Ambient", "f32"), t.UBO.addEntry("Normal", "f32"), t.UBO.addEntry("Emission", "f32"), t.UBO.addEntry("NormalStrength", "f32"), t.UBO.addEntry("BaseIOR", "f32"), t.UBO.addEntry("SpecularIntensity", "f32"), t.UBO.addEntry("LineWidth", "f32"), t.UBO.addEntry("Opacity", "f32"), t.UBO.addEntry("ZValue", "f32"), t.UBO.addEntry("PropID", "u32"), t.UBO.addEntry("ClipNear", "f32"), t.UBO.addEntry("ClipFar", "f32"), t.UBO.addEntry("Time", "u32"), gs(i, t, ["cellArray", "currentInput", "cellOffset", "is2D", "primitiveType", "renderEncoder"]), t.textures = [], fot(i, t);
}
const yot = In(Gj, "vtkWebGPUCellArrayMapper");
var jI = {
  newInstance: yot,
  extend: Gj
};
const {
  PrimitiveTypes: rM
} = Xg;
function Zot(i, t) {
  t.classHierarchy.push("vtkWebGPUPolyDataMapper"), i.createCellArrayMapper = () => jI.newInstance(), i.buildPass = (e) => {
    if (e) {
      t.WebGPUActor = i.getFirstAncestorOfType("vtkWebGPUActor"), t.renderable.getStatic() || t.renderable.update();
      const n = t.renderable.getInputData();
      t.renderable.mapScalars(n, 1), i.updateCellArrayMappers(n);
    }
  }, i.updateCellArrayMappers = (e) => {
    const n = [e.getVerts(), e.getLines(), e.getPolys(), e.getStrips()], s = [];
    let r = 0;
    for (let a = rM.Points; a <= rM.Triangles; a++)
      if (n[a].getNumberOfValues() > 0) {
        t.primitives[a] || (t.primitives[a] = i.createCellArrayMapper());
        const o = t.primitives[a];
        o.setCellArray(n[a]), o.setCurrentInput(e), o.setCellOffset(r), o.setPrimitiveType(a), o.setRenderable(t.renderable), r += n[a].getNumberOfCells(), s.push(o);
      } else
        t.primitives[a] = null;
    if (t.WebGPUActor.getRenderable().getProperty().getEdgeVisibility())
      for (let a = rM.TriangleEdges; a <= rM.TriangleStripEdges; a++)
        if (n[a - 2].getNumberOfValues() > 0) {
          t.primitives[a] || (t.primitives[a] = i.createCellArrayMapper());
          const o = t.primitives[a];
          o.setCellArray(n[a - 2]), o.setCurrentInput(e), o.setCellOffset(t.primitives[a - 2].getCellOffset()), o.setPrimitiveType(a), o.setRenderable(t.renderable), s.push(o);
        } else
          t.primitives[a] = null;
    i.prepareNodes(), i.addMissingChildren(s), i.removeUnusedNodes();
  };
}
const Tot = {
  primitives: null
};
function wj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Tot, e), ui.extend(i, t, e), t.primitives = [], Zot(i, t);
}
const xj = In(wj, "vtkWebGPUPolyDataMapper");
var Mot = {
  newInstance: xj,
  extend: wj
};
Xo("vtkMapper", xj);
const {
  PrimitiveTypes: bO
} = Xg;
function Not(i, t) {
  t.classHierarchy.push("vtkWebGPUPolyDataMapper2D"), i.createCellArrayMapper = () => jI.newInstance(), i.buildPass = (e) => {
    if (e) {
      t.WebGPUActor = i.getFirstAncestorOfType("vtkWebGPUActor2D"), t.renderable.getStatic() || t.renderable.update();
      const n = t.renderable.getInputData();
      t.renderable.mapScalars(n, 1), i.updateCellArrayMappers(n);
    }
  }, i.updateCellArrayMappers = (e) => {
    const n = [e.getVerts(), e.getLines(), e.getPolys(), e.getStrips()], s = [];
    let r = 0;
    for (let a = bO.Points; a <= bO.Triangles; a++)
      if (n[a].getNumberOfValues() > 0) {
        t.primitives[a] || (t.primitives[a] = i.createCellArrayMapper());
        const o = t.primitives[a];
        o.setCellArray(n[a]), o.setCurrentInput(e), o.setCellOffset(r), o.setPrimitiveType(a), o.setRenderable(t.renderable), o.setIs2D(!0), r += n[a].getNumberOfCells(), s.push(o);
      } else
        t.primitives[a] = null;
    i.prepareNodes(), i.addMissingChildren(s), i.removeUnusedNodes();
  };
}
function Wot(i) {
  return {
    primitives: [],
    ...i
  };
}
function Got(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Wot(e)), ui.extend(i, t, e), t.primitives = [], Not(i, t);
}
const wot = In(Got, "vtkWebGPUPolyDataMapper2D");
Xo("vtkMapper2D", wot);
function xot(i, t) {
  t.classHierarchy.push("vtkWebGPUScalarBarActor"), i.buildPass = (e) => {
    e && (t.WebGPURenderer = i.getFirstAncestorOfType("vtkWebGPURenderer"), t.WebGPURenderWindow = t.WebGPURenderer.getParent(), t.scalarBarActorHelper.getRenderable() || t.scalarBarActorHelper.setRenderable(t.renderable), i.prepareNodes(), i.addMissingNode(t.scalarBarActorHelper.getBarActor()), i.addMissingNode(t.scalarBarActorHelper.getTmActor()), i.removeUnusedNodes());
  }, i.opaquePass = (e, n) => {
    if (e) {
      const s = t.WebGPURenderer ? t.WebGPURenderer.getRenderable().getActiveCamera() : null, r = t.WebGPURenderer.getTiledSizeAndOrigin();
      t.scalarBarActorHelper.updateAPISpecificData([r.usize, r.vsize], s, t.WebGPURenderWindow.getRenderable());
    }
  };
}
const Sot = {};
function Lot(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Sot, e), ui.extend(i, t, e), t.scalarBarActorHelper = FI.newScalarBarActorHelper(), xot(i, t);
}
const Vot = In(Lot, "vtkWebGPUScalarBarActor");
Xo("vtkScalarBarActor", Vot);
function Xot(i, t) {
  t.classHierarchy.push("vtkWebGPUSampler"), i.create = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    t.device = e, t.options.addressModeU = n.addressModeU ? n.addressModeU : "clamp-to-edge", t.options.addressModeV = n.addressModeV ? n.addressModeV : "clamp-to-edge", t.options.addressModeW = n.addressModeW ? n.addressModeW : "clamp-to-edge", t.options.magFilter = n.magFilter ? n.magFilter : "nearest", t.options.minFilter = n.minFilter ? n.minFilter : "nearest", t.options.mipmapFilter = n.mipmapFilter ? n.mipmapFilter : "nearest", t.options.label = t.label, t.handle = t.device.getHandle().createSampler(t.options), t.bindGroupTime.modified();
  }, i.getShaderCode = (e, n) => `@binding(${e}) @group(${n}) var ${t.label}: sampler;`, i.getBindGroupEntry = () => ({
    resource: t.handle
  });
}
const Iot = {
  device: null,
  handle: null,
  label: null,
  options: null
};
function Sj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Iot, e), tt.obj(i, t), t.options = {}, t.bindGroupLayoutEntry = {
    /* eslint-disable no-undef */
    visibility: GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT,
    /* eslint-enable no-undef */
    sampler: {
      // type: 'filtering',
    }
  }, t.bindGroupTime = {}, tt.obj(t.bindGroupTime, {
    mtime: 0
  }), tt.get(i, t, ["bindGroupTime", "handle", "options"]), tt.setGet(i, t, ["bindGroupLayoutEntry", "device", "label"]), Xot(i, t);
}
const Cot = tt.newInstance(Sj);
var Lj = {
  newInstance: Cot,
  extend: Sj
};
function Yot(i, t) {
  t.classHierarchy.push("vtkWebGPUTextureView"), i.create = (e, n) => {
    t.texture = e, t.options = n, t.options.dimension = t.options.dimension || "2d", t.options.label = t.label, t.textureHandle = e.getHandle(), t.handle = t.textureHandle.createView(t.options), t.bindGroupLayoutEntry.texture.viewDimension = t.options.dimension;
    const s = Rr.getDetailsFromTextureFormat(t.texture.getFormat());
    t.bindGroupLayoutEntry.texture.sampleType = s.sampleType;
  }, i.createFromTextureHandle = (e, n) => {
    t.texture = null, t.options = n, t.options.dimension = t.options.dimension || "2d", t.options.label = t.label, t.textureHandle = e, t.handle = t.textureHandle.createView(t.options), t.bindGroupLayoutEntry.texture.viewDimension = t.options.dimension;
    const s = Rr.getDetailsFromTextureFormat(n.format);
    t.bindGroupLayoutEntry.texture.sampleType = s.sampleType, t.bindGroupTime.modified();
  }, i.getBindGroupEntry = () => ({
    resource: i.getHandle()
  }), i.getShaderCode = (e, n) => {
    let s = "f32";
    t.bindGroupLayoutEntry.texture.sampleType === "sint" ? s = "i32" : t.bindGroupLayoutEntry.texture.sampleType === "uint" && (s = "u32");
    let r = `@binding(${e}) @group(${n}) var ${t.label}: texture_${t.options.dimension}<${s}>;`;
    return t.bindGroupLayoutEntry.texture.sampleType === "depth" && (r = `@binding(${e}) @group(${n}) var ${t.label}: texture_depth_${t.options.dimension};`), r;
  }, i.addSampler = (e, n) => {
    const s = Lj.newInstance({
      label: `${t.label}Sampler`
    });
    s.create(e, n), i.setSampler(s);
  }, i.getBindGroupTime = () => (t.texture && t.texture.getHandle() !== t.textureHandle && (t.textureHandle = t.texture.getHandle(), t.handle = t.textureHandle.createView(t.options), t.bindGroupTime.modified()), t.bindGroupTime), i.getHandle = () => (t.texture && t.texture.getHandle() !== t.textureHandle && (t.textureHandle = t.texture.getHandle(), t.handle = t.textureHandle.createView(t.options), t.bindGroupTime.modified()), t.handle);
}
const vot = {
  texture: null,
  handle: null,
  sampler: null,
  label: null
};
function Vj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, vot, e), tt.obj(i, t), t.bindGroupLayoutEntry = {
    /* eslint-disable no-undef */
    visibility: GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT,
    /* eslint-enable no-undef */
    texture: {
      sampleType: "float",
      viewDimension: "2d"
      // multisampled: false,
    }
  }, t.bindGroupTime = {}, tt.obj(t.bindGroupTime, {
    mtime: 0
  }), tt.get(i, t, ["bindGroupTime", "texture"]), tt.setGet(i, t, ["bindGroupLayoutEntry", "label", "sampler"]), Yot(i, t);
}
const Rot = tt.newInstance(Vj);
var Dot = {
  newInstance: Rot,
  extend: Vj
};
const {
  BufferUsage: fO
} = Xg;
function Oot(i, t) {
  t.classHierarchy.push("vtkWebGPUTexture"), i.create = (e, n) => {
    t.device = e, t.width = n.width, t.height = n.height, t.depth = n.depth ? n.depth : 1;
    const s = t.depth === 1 ? "2d" : "3d";
    t.format = n.format ? n.format : "rgba8unorm", t.mipLevel = n.mipLevel ? n.mipLevel : 0, t.usage = n.usage ? n.usage : GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST, t.handle = t.device.getHandle().createTexture({
      size: [t.width, t.height, t.depth],
      format: t.format,
      // 'rgba8unorm',
      usage: t.usage,
      label: t.label,
      dimension: s,
      mipLevelCount: t.mipLevel + 1
    });
  }, i.assignFromHandle = (e, n, s) => {
    t.device = e, t.handle = n, t.width = s.width, t.height = s.height, t.depth = s.depth ? s.depth : 1, t.format = s.format ? s.format : "rgba8unorm", t.usage = s.usage ? s.usage : GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST;
  }, i.writeImageData = (e) => {
    let n = [];
    if (e.canvas) {
      t.device.getHandle().queue.copyExternalImageToTexture({
        source: e.canvas,
        flipY: e.flip
      }, {
        texture: t.handle,
        premultipliedAlpha: !0
      }, [t.width, t.height, t.depth]), t.ready = !0;
      return;
    }
    e.jsImageData && !e.nativeArray && (e.width = e.jsImageData.width, e.height = e.jsImageData.height, e.depth = 1, e.format = "rgba8unorm", e.flip = !0, e.nativeArray = e.jsImageData.data);
    const s = Rr.getDetailsFromTextureFormat(t.format);
    let r = t.width * s.stride;
    const a = (l, c, u) => {
      const d = l.length / (c * u) * l.BYTES_PER_ELEMENT, h = s.elementSize === 2 && s.sampleType === "float";
      if (h || d % 256) {
        const p = l, m = d / p.BYTES_PER_ELEMENT, b = s.elementSize, y = 256 * Math.floor((m * b + 255) / 256), Z = y / b, g = tt.newTypedArray(h ? "Uint16Array" : p.constructor.name, Z * c * u);
        for (let f = 0; f < c * u; f++)
          if (h)
            for (let T = 0; T < m; T++)
              g[f * Z + T] = Dp.toHalf(p[f * m + T]);
          else
            g.set(p.subarray(f * m, (f + 1) * m), f * Z);
        return [g, y];
      }
      return [l, d];
    };
    if (e.nativeArray && (n = e.nativeArray), e.image) {
      const l = document.createElement("canvas");
      l.width = e.image.width, l.height = e.image.height;
      const c = l.getContext("2d");
      c.translate(0, l.height), c.scale(1, -1), c.drawImage(e.image, 0, 0, e.image.width, e.image.height, 0, 0, l.width, l.height), n = c.getImageData(0, 0, e.image.width, e.image.height).data;
    }
    const o = t.device.createCommandEncoder();
    if (i.getDimensionality() !== 3) {
      const l = vc.generateMipmaps(n, t.width, t.height, t.mipLevel);
      let c = t.width, u = t.height;
      for (let d = 0; d <= t.mipLevel; d++) {
        const h = a(l[d], u, 1);
        r = h[1];
        const p = {
          dataArray: e.dataArray ? e.dataArray : null,
          nativeArray: h[0],
          /* eslint-disable no-undef */
          usage: fO.Texture
          /* eslint-enable no-undef */
        }, m = t.device.getBufferManager().getBuffer(p);
        o.copyBufferToTexture({
          buffer: m.getHandle(),
          offset: 0,
          bytesPerRow: r,
          rowsPerImage: u
        }, {
          texture: t.handle,
          mipLevel: d
        }, [c, u, 1]), c /= 2, u /= 2;
      }
      t.device.submitCommandEncoder(o), t.ready = !0;
    } else {
      const l = a(n, t.height, t.depth);
      r = l[1];
      const c = {
        dataArray: e.dataArray ? e.dataArray : null,
        /* eslint-disable no-undef */
        usage: fO.Texture
        /* eslint-enable no-undef */
      };
      c.nativeArray = l[0];
      const u = t.device.getBufferManager().getBuffer(c);
      o.copyBufferToTexture({
        buffer: u.getHandle(),
        offset: 0,
        bytesPerRow: r,
        rowsPerImage: t.height
      }, {
        texture: t.handle
      }, [t.width, t.height, t.depth]), t.device.submitCommandEncoder(o), t.ready = !0;
    }
  }, i.getScale = () => {
    const e = Rr.getDetailsFromTextureFormat(t.format);
    return e.elementSize === 2 && e.sampleType === "float" ? 1 : 255;
  }, i.getNumberOfComponents = () => Rr.getDetailsFromTextureFormat(t.format).numComponents, i.getDimensionality = () => {
    let e = 0;
    return t.width > 1 && e++, t.height > 1 && e++, t.depth > 1 && e++, e;
  }, i.resizeToMatch = (e) => {
    (e.getWidth() !== t.width || e.getHeight() !== t.height || e.getDepth() !== t.depth) && (t.width = e.getWidth(), t.height = e.getHeight(), t.depth = e.getDepth(), t.handle = t.device.getHandle().createTexture({
      size: [t.width, t.height, t.depth],
      format: t.format,
      usage: t.usage,
      label: t.label
    }));
  }, i.resize = function(e, n) {
    let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    (e !== t.width || n !== t.height || s !== t.depth) && (t.width = e, t.height = n, t.depth = s, t.handle = t.device.getHandle().createTexture({
      size: [t.width, t.height, t.depth],
      format: t.format,
      usage: t.usage,
      label: t.label
    }));
  }, i.createView = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    n.dimension || (n.dimension = t.depth === 1 ? "2d" : "3d");
    const s = Dot.newInstance({
      label: e
    });
    return s.create(i, n), s;
  };
}
const zot = {
  device: null,
  handle: null,
  buffer: null,
  ready: !1,
  label: null
};
function Eot(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, zot, e), tt.obj(i, t), tt.get(i, t, ["handle", "ready", "width", "height", "depth", "format", "usage"]), tt.setGet(i, t, ["device", "label"]), Oot(i, t);
}
tt.newInstance(Eot);
function kot(i, t) {
  t.classHierarchy.push("vtkWebGPUPixelSpaceCallbackMapper"), i.opaquePass = (e, n) => {
    t.WebGPURenderer = i.getFirstAncestorOfType("vtkWebGPURenderer"), t.WebGPURenderWindow = t.WebGPURenderer.getParent();
    const s = t.WebGPURenderer.getAspectRatio(), r = t.WebGPURenderer ? t.WebGPURenderer.getRenderable().getActiveCamera() : null, a = t.WebGPURenderer.getTiledSizeAndOrigin(), o = null;
    t.renderable.getUseZValues(), t.renderable.invokeCallback(t.renderable.getInputData(), r, s, a, o);
  };
}
const Fot = {};
function jot(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Fot, e), ui.extend(i, t, e), kot(i, t);
}
const Uot = tt.newInstance(jot, "vtkWebGPUPixelSpaceCallbackMapper");
Xo("vtkPixelSpaceCallbackMapper", Uot);
const {
  vtkErrorMacro: Pot
} = tt;
class Jot {
  constructor() {
    this.segmentMapping = {}, this.segments = [null], this.faces = [];
  }
  addSegment(t) {
    const e = t[0], n = t[t.length - 1];
    if (e === n || t.length < 2)
      return;
    const s = this.segmentMapping[e], r = this.segmentMapping[n];
    if (s !== void 0 && r !== void 0)
      if (Math.abs(s) === Math.abs(r)) {
        const a = s < r ? r : s, o = this.segments[a];
        if (s > 0)
          for (let l = 1; l < t.length - 1; l++)
            o.push(t[l]);
        else
          for (let l = 1; l < t.length - 1; l++)
            o.unshift(t[t.length - 1 - l]);
        this.faces.push(o), this.segments[a] = null, this.segmentMapping[e] = void 0, this.segmentMapping[n] = void 0;
      } else {
        const a = Math.abs(s), o = Math.abs(r), l = this.segments[a], c = this.segments[o];
        this.segments[a] = null, this.segments[o] = null, this.segmentMapping[l[0]] = void 0, this.segmentMapping[c[0]] = void 0, this.segmentMapping[l[l.length - 1]] = void 0, this.segmentMapping[c[c.length - 1]] = void 0, this.addSegment(t), this.addSegment(l), this.addSegment(c);
      }
    else if (s !== void 0) {
      if (s > 0) {
        const a = this.segments[s];
        for (let o = 1; o < t.length; o++)
          a.push(t[o]);
        this.segmentMapping[n] = s;
      } else {
        const a = this.segments[-s];
        this.segmentMapping[n] = s;
        for (let o = 1; o < t.length; o++)
          a.unshift(t[o]);
      }
      this.segmentMapping[e] = void 0;
    } else if (r !== void 0) {
      if (r > 0) {
        const a = this.segments[r];
        for (let o = 1; o < t.length; o++)
          a.push(t[t.length - 1 - o]);
        this.segmentMapping[e] = r;
      } else {
        const a = this.segments[-r];
        this.segmentMapping[e] = r;
        for (let o = 1; o < t.length; o++)
          a.unshift(t[t.length - o - 1]);
      }
      this.segmentMapping[n] = void 0;
    } else {
      const a = this.segments.length;
      this.segments.push(t), this.segmentMapping[e] = -a, this.segmentMapping[n] = a;
    }
  }
}
function Aot(i, t) {
  t.classHierarchy.push("vtkClosedPolyLineToSurfaceFilter"), i.requestData = (e, n) => {
    const s = e[0];
    if (!s) {
      Pot("Invalid or missing input");
      return;
    }
    const r = Ie.newInstance();
    r.shallowCopy(s);
    const a = new Jot(), o = s.getLines().getData();
    let l = 0;
    for (; l < o.length; ) {
      const h = o[l++], p = [];
      for (let m = 0; m < h; m++)
        p.push(o[l + m]);
      a.addSegment(p), l += h;
    }
    const {
      faces: c
    } = a;
    let u = c.length;
    for (let h = 0; h < c.length; h++)
      u += c[h].length;
    const d = new Uint16Array(u);
    l = 0;
    for (let h = 0; h < c.length; h++) {
      const p = c[h];
      d[l++] = p.length;
      for (let m = 0; m < p.length; m++)
        d[l++] = p[m];
    }
    r.setPolys(Ii.newInstance({
      values: d,
      name: "faces"
    })), n[0] = r;
  };
}
const Bot = {};
function Xj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Bot, e), tt.obj(i, t), tt.algo(i, t, 1, 1), Aot(i, t);
}
const Kot = tt.newInstance(Xj, "vtkClosedPolyLineToSurfaceFilter");
var Hot = {
  newInstance: Kot,
  extend: Xj
};
const {
  vtkErrorMacro: gO
} = kr;
function _ot(i) {
  const t = i.getPolys().getData(), e = i.getStrips().getData(), n = {
    cellSize: 0,
    cell: [],
    done: !1,
    polyIdx: 0,
    stripIdx: 0,
    remainingStripLength: 0,
    // returns a single poly cell
    next() {
      if (n.polyIdx < t.length) {
        n.cellSize = t[n.polyIdx];
        const s = n.polyIdx + 1, r = s + n.cellSize;
        n.polyIdx = r;
        let a = 0;
        for (let o = s; o < r; ++o)
          n.cell[a++] = t[o];
      } else if (n.stripIdx < e.length) {
        n.cellSize = 3, n.remainingStripLength === 0 && (n.remainingStripLength = e[n.stripIdx] - 2, n.stripIdx += 3);
        const s = n.stripIdx - 2, r = n.stripIdx + 1;
        n.stripIdx++, n.remainingStripLength--;
        let a = 0;
        for (let o = s; o < r; ++o)
          n.cell[a++] = e[o];
      } else if (!n.done)
        n.done = !0;
      else
        throw new Error("Iterator is done");
    }
  };
  return n.next(), n;
}
function Qot(i, t) {
  t.classHierarchy.push("vtkCutter");
  const e = {
    ...i
  };
  i.getMTime = () => {
    let s = e.getMTime();
    return t.cutFunction && (s = Math.max(s, t.cutFunction.getMTime())), s;
  };
  function n(s, r) {
    const a = s.getPoints(), o = a.getData(), l = a.getNumberOfPoints(), c = [], u = [], d = [];
    (!t.cutScalars || t.cutScalars.length < l) && (t.cutScalars = new Float32Array(l));
    let h = 0, p = 0;
    for (; h < o.length; )
      t.cutScalars[p++] = t.cutFunction.evaluateFunction(o[h++], o[h++], o[h++]);
    const m = [], b = new Array(3), y = new Array(3), Z = [];
    for (const f = _ot(s); !f.done; f.next()) {
      if (f.cellSize <= 2)
        continue;
      for (let x = 0; x < f.cellSize; )
        Z[x] = t.cutScalars[f.cell[x++]];
      const T = Z[0] > 0;
      let M = !0;
      for (let x = 1; x < f.cell.length; x++)
        if (Z[x] > 0 !== T) {
          M = !1;
          break;
        }
      if (M)
        continue;
      const N = [];
      for (let x = 0; x < f.cellSize; x++) {
        const V = x + 1 === f.cellSize ? 0 : x + 1, X = Z[x] > 0;
        if (Z[V] > 0 === X)
          continue;
        let R = x, z = V, F = Z[z] - Z[R];
        F <= 0 && (R = V, z = x, F *= -1);
        let P = 0;
        F !== 0 && (P = (t.cutValue - Z[R]) / F);
        const j = f.cell[R], H = f.cell[z];
        b[0] = o[j * 3], b[1] = o[j * 3 + 1], b[2] = o[j * 3 + 2], y[0] = o[H * 3], y[1] = o[H * 3 + 1], y[2] = o[H * 3 + 2];
        const B = [b[0] + P * (y[0] - b[0]), b[1] + P * (y[1] - b[1]), b[2] + P * (y[2] - b[2])];
        N.push({
          pointEdge1: j,
          // id of one point of the edge
          pointEdge2: H,
          // id of one point of the edge
          intersectedPoint: B,
          // 3D coordinate of points that intersected edge
          newPointID: -1
          // id of the intersected point when it will be added into vtkPoints
        });
      }
      for (let x = 0; x < N.length; x++) {
        const V = N[x];
        let X = !1;
        for (let C = 0; C < m.length; C++) {
          const R = m[C], z = V.pointEdge1 === R.pointEdge1 && V.pointEdge2 === R.pointEdge2, F = V.intersectedPoint[0] === R.intersectedPoint[0] && V.intersectedPoint[1] === R.intersectedPoint[1] && V.intersectedPoint[2] === R.intersectedPoint[2];
          if (z || F) {
            X = !0, N[x].newPointID = m[C].newPointID;
            break;
          }
        }
        X || (c.push(V.intersectedPoint[0]), c.push(V.intersectedPoint[1]), c.push(V.intersectedPoint[2]), N[x].newPointID = c.length / 3 - 1, m.push(N[x]));
      }
      const W = N.length;
      W === 2 ? u.push(W, N[0].newPointID, N[1].newPointID) : W > 2 && (d.push(W), N.forEach((x) => {
        d.push(x.newPointID);
      }));
    }
    r.getPoints().setData(LG(a.getDataType(), c), 3), u.length !== 0 && r.getLines().setData(Uint16Array.from(u)), d.length !== 0 && r.getPolys().setData(Uint16Array.from(d));
  }
  i.requestData = (s, r) => {
    const a = s[0];
    if (!a) {
      gO("Invalid or missing input");
      return;
    }
    if (!t.cutFunction) {
      gO("Missing cut function");
      return;
    }
    const o = Ie.newInstance();
    n(a, o), r[0] = o;
  };
}
const $ot = {
  cutFunction: null,
  // support method with evaluateFunction method
  cutScalars: null,
  cutValue: 0
};
function Ij(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, $ot, e), xi(i, t), _X(i, t, 1, 1), gs(i, t, ["cutFunction", "cutValue"]), Qot(i, t);
}
const qot = In(Ij, "vtkCutter");
var UI = {
  newInstance: qot,
  extend: Ij
};
const tlt = [2, 0, 1, 2, 2, 3, 2, 4, 5, 2, 6, 7, 2, 0, 2, 2, 1, 3, 2, 4, 6, 2, 5, 7, 2, 0, 4, 2, 1, 5, 2, 2, 6, 2, 3, 7], elt = [4, 0, 1, 3, 2, 4, 4, 6, 7, 5, 4, 8, 10, 11, 9, 4, 12, 13, 15, 14, 4, 16, 18, 19, 17, 4, 20, 21, 23, 22];
function nlt(i, t) {
  t.classHierarchy.push("vtkCubeSource");
  function e(n, s) {
    if (t.deleted)
      return;
    const r = Ie.newInstance();
    s[0] = r;
    const a = 24, o = tt.newTypedArray(t.pointType, a * 3);
    r.getPoints().setData(o, 3);
    const l = tt.newTypedArray(t.pointType, a * 3), c = We.newInstance({
      name: "Normals",
      values: l,
      numberOfComponents: 3
    });
    r.getPointData().setNormals(c);
    let u = 2;
    t.generate3DTextureCoordinates === !0 && (u = 3);
    const d = tt.newTypedArray(t.pointType, a * u), h = We.newInstance({
      name: "TextureCoordinates",
      values: d,
      numberOfComponents: u
    });
    r.getPointData().setTCoords(h);
    const p = [0, 0, 0], m = [0, 0, 0], b = [0, 0];
    let y = 0;
    p[0] = -t.xLength / 2, m[0] = -1, m[1] = 0, m[2] = 0;
    for (let Z = 0; Z < 2; Z++) {
      p[1] = -t.yLength / 2;
      for (let g = 0; g < 2; g++) {
        b[1] = p[1] + 0.5, p[2] = -t.zLength / 2;
        for (let f = 0; f < 2; f++)
          b[0] = (p[2] + 0.5) * (1 - 2 * Z), o[y * 3] = p[0], o[y * 3 + 1] = p[1], o[y * 3 + 2] = p[2], l[y * 3] = m[0], l[y * 3 + 1] = m[1], l[y * 3 + 2] = m[2], u === 2 ? (d[y * u] = b[0], d[y * u + 1] = b[1]) : (d[y * u] = 2 * Z - 1, d[y * u + 1] = 2 * g - 1, d[y * u + 2] = 2 * f - 1), y++, p[2] += t.zLength;
        p[1] += t.yLength;
      }
      p[0] += t.xLength, m[0] += 2;
    }
    p[1] = -t.yLength / 2, m[1] = -1, m[0] = 0, m[2] = 0;
    for (let Z = 0; Z < 2; Z++) {
      p[0] = -t.xLength / 2;
      for (let g = 0; g < 2; g++) {
        b[0] = (p[0] + 0.5) * (2 * Z - 1), p[2] = -t.zLength / 2;
        for (let f = 0; f < 2; f++)
          b[1] = (p[2] + 0.5) * -1, o[y * 3] = p[0], o[y * 3 + 1] = p[1], o[y * 3 + 2] = p[2], l[y * 3] = m[0], l[y * 3 + 1] = m[1], l[y * 3 + 2] = m[2], u === 2 ? (d[y * u] = b[0], d[y * u + 1] = b[1]) : (d[y * u] = 2 * g - 1, d[y * u + 1] = 2 * Z - 1, d[y * u + 2] = 2 * f - 1), y++, p[2] += t.zLength;
        p[0] += t.xLength;
      }
      p[1] += t.yLength, m[1] += 2;
    }
    p[2] = -t.zLength / 2, m[2] = -1, m[0] = 0, m[1] = 0;
    for (let Z = 0; Z < 2; Z++) {
      p[1] = -t.yLength / 2;
      for (let g = 0; g < 2; g++) {
        b[1] = p[1] + 0.5, p[0] = -t.xLength / 2;
        for (let f = 0; f < 2; f++)
          b[0] = (p[0] + 0.5) * (2 * Z - 1), o[y * 3] = p[0], o[y * 3 + 1] = p[1], o[y * 3 + 2] = p[2], l[y * 3] = m[0], l[y * 3 + 1] = m[1], l[y * 3 + 2] = m[2], u === 2 ? (d[y * u] = b[0], d[y * u + 1] = b[1]) : (d[y * u] = 2 * f - 1, d[y * u + 1] = 2 * g - 1, d[y * u + 2] = 2 * Z - 1), y++, p[0] += t.xLength;
        p[1] += t.yLength;
      }
      p[2] += t.zLength, m[2] += 2;
    }
    if (t.rotations && il.buildFromDegree().rotateX(t.rotations[0]).rotateY(t.rotations[1]).rotateZ(t.rotations[2]).apply(o).apply(l), t.center && il.buildFromRadian().translate(...t.center).apply(o), t.matrix) {
      il.buildFromRadian().setMatrix(t.matrix).apply(o);
      const Z = [t.matrix[0], t.matrix[1], t.matrix[2], 0, t.matrix[4], t.matrix[5], t.matrix[6], 0, t.matrix[8], t.matrix[9], t.matrix[10], 0, 0, 0, 0, 1];
      il.buildFromRadian().setMatrix(Z).apply(l);
    }
    t.generateFaces ? r.getPolys().deepCopy(t._polys) : r.getPolys().initialize(), t.generateLines ? (r.getLines().deepCopy(t._lineCells), r.getPointData().setNormals(null)) : r.getLines().initialize(), r.modified();
  }
  i.setBounds = function() {
    let n = [];
    if (Array.isArray(arguments.length <= 0 ? void 0 : arguments[0]))
      n = arguments.length <= 0 ? void 0 : arguments[0];
    else
      for (let s = 0; s < arguments.length; s++)
        n.push(s < 0 || arguments.length <= s ? void 0 : arguments[s]);
    n.length === 6 && (i.setXLength(n[1] - n[0]), i.setYLength(n[3] - n[2]), i.setZLength(n[5] - n[4]), i.setCenter([(n[0] + n[1]) / 2, (n[2] + n[3]) / 2, (n[4] + n[5]) / 2]));
  }, i.requestData = e;
}
const ilt = {
  xLength: 1,
  yLength: 1,
  zLength: 1,
  pointType: "Float64Array",
  generate3DTextureCoordinates: !1,
  generateFaces: !0,
  generateLines: !1
};
function Cj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, ilt, e), tt.obj(i, t), tt.setGet(i, t, ["xLength", "yLength", "zLength", "generate3DTextureCoordinates", "generateFaces", "generateLines"]), tt.setGetArray(i, t, ["center", "rotations"], 3), tt.setGetArray(i, t, ["matrix"], 16), t._polys = Ii.newInstance({
    values: Uint16Array.from(elt)
  }), t._lineCells = Ii.newInstance({
    values: Uint16Array.from(tlt)
  }), tt.moveToProtected(i, t, ["polys", "lineCells"]), tt.algo(i, t, 0, 1), nlt(i, t);
}
const slt = tt.newInstance(Cj, "vtkCubeSource");
var rlt = {
  newInstance: slt,
  extend: Cj
};
const {
  vtkErrorMacro: yO
} = tt;
function alt(i, t) {
  t.classHierarchy.push("vtkImageDataOutlineFilter");
  const e = {
    ...i
  };
  i.requestData = (n, s) => {
    const r = n[0];
    if (!r || !r.isA("vtkImageData")) {
      yO("Invalid or missing input");
      return;
    }
    const a = r.getSpatialExtent();
    if (!a) {
      yO("Unable to fetch spatial extents of input image.");
      return;
    }
    t._cubeSource.setBounds(a), t._cubeSource.setMatrix(r.getIndexToWorld()), s[0] = t._cubeSource.getOutputData();
  }, i.getMTime = () => Math.max(e.getMTime(), t._cubeSource.getMTime()), i.setGenerateFaces = t._cubeSource.setGenerateFaces, i.setGenerateLines = t._cubeSource.setGenerateLines, i.getGenerateFaces = t._cubeSource.getGenerateFaces, i.getGenerateLines = t._cubeSource.getGenerateLines;
}
const olt = {};
function Yj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, olt, e), tt.obj(i, t), tt.algo(i, t, 1, 1), t._cubeSource = rlt.newInstance(), tt.moveToProtected(i, t, ["cubeSource", "tmpOut"]), alt(i, t);
}
const llt = tt.newInstance(Yj, "vtkImageDataOutlineFilter");
var clt = {
  newInstance: llt,
  extend: Yj
};
let PI;
function ult(i, t) {
  t.classHierarchy.push("vtkAbstractTransform", "vtkHomogeneousTransform", "vtkTransform"), i.transformPoint = (e, n) => (I.transformMat4(n, e, t.matrix), n), i.transformPoints = (e, n) => {
    const s = new Float64Array(3), r = new Float64Array(3);
    for (let a = 0; a < e.length; a += 3)
      s[0] = e[a], s[1] = e[a + 1], s[2] = e[a + 2], I.transformMat4(r, s, t.matrix), n[a] = r[0], n[a + 1] = r[1], n[a + 2] = r[2];
    return n;
  }, i.preMultiply = () => {
    i.setPreMultiplyFlag(!0);
  }, i.postMultiply = () => {
    i.setPreMultiplyFlag(!1);
  }, i.transformMatrix = (e, n) => (t.preMultiplyFlag ? ut.multiply(n, t.matrix, e) : ut.multiply(n, e, t.matrix), n), i.transformMatrices = (e, n) => {
    const s = new Float64Array(16), r = new Float64Array(16), a = t.preMultiplyFlag ? () => ut.multiply(r, t.matrix, s) : () => ut.multiply(r, s, t.matrix);
    for (let o = 0; o < e.length; o += 16) {
      for (let l = 0; l < 16; ++l)
        s[l] = e[o + l];
      a();
      for (let l = 0; l < 16; ++l)
        n[o + l] = r[l];
    }
    return n;
  }, i.getInverse = () => PI({
    matrix: Hn.invertMatrix(Array.from(t.matrix), [], 4),
    preMultiplyFlag: t.preMultiplyFlag
  });
}
const dlt = {
  preMultiplyFlag: !1,
  matrix: [...oI]
};
function vj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, dlt, e), tt.obj(i, t), tt.setGet(i, t, ["preMultiplyFlag"]), tt.setGetArray(i, t, ["matrix"], 16), ult(i, t);
}
PI = tt.newInstance(vj, "vtkTransform");
var hlt = {
  newInstance: PI,
  extend: vj
}, plt = `//VTK::System::Dec

/*=========================================================================

  Program:   Visualization Toolkit
  Module:    vtkImageResliceMapperVS.glsl

  Copyright (c) Ken Martin, Will Schroeder, Bill Lorensen
  All rights reserved.
  See Copyright.txt or http://www.kitware.com/Copyright.htm for details.

     This software is distributed WITHOUT ANY WARRANTY; without even
     the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR
     PURPOSE.  See the above copyright notice for more information.

=========================================================================*/

// all variables that represent positions or directions have a suffix
// indicating the coordinate system they are in. The possible values are
// MC - Model coordinates
// WC - World coordinates
// VC - View coordinates
// DC - Display coordinates
// TC - Texture coordinates

// frag position in VC
//VTK::PositionVC::Dec

// Texture coordinates
//VTK::TCoord::Dec

// picking support
//VTK::Picking::Dec

// camera and actor matrix values
//VTK::Camera::Dec

void main()
{
  //VTK::PositionVC::Impl

  //VTK::TCoord::Impl

  //VTK::Picking::Impl
}
`, mlt = `//VTK::System::Dec

/*=========================================================================

  Program:   Visualization Toolkit
  Module:    vtkImageResliceMapperFS.glsl

  Copyright (c) Ken Martin, Will Schroeder, Bill Lorensen
  All rights reserved.
  See Copyright.txt or http://www.kitware.com/Copyright.htm for details.

     This software is distributed WITHOUT ANY WARRANTY; without even
     the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR
     PURPOSE.  See the above copyright notice for more information.

=========================================================================*/
// Template for the gpu image mapper fragment shader

// VC position of this fragment
//VTK::PositionVC::Dec

// Texture coordinates
//VTK::TCoord::Dec

// picking support
//VTK::Picking::Dec

// handle coincident offsets
//VTK::Coincident::Dec

//VTK::ZBuffer::Dec

// the output of this shader
//VTK::Output::Dec

void main()
{
  // VC position of this fragment. This should not branch/return/discard.
  //VTK::PositionVC::Impl

  // Place any calls that require uniform flow (e.g. dFdx) here.
  //VTK::UniformFlow::Impl

  // Set gl_FragDepth here (gl_FragCoord.z by default)
  //VTK::Depth::Impl

  // Early depth peeling abort:
  //VTK::DepthPeeling::PreColor

  //VTK::TCoord::Impl

  if (gl_FragData[0].a <= 0.0)
    {
    discard;
    }

  //VTK::DepthPeeling::Impl

  //VTK::Picking::Impl

  // handle coincident offsets
  //VTK::Coincident::Impl

  //VTK::ZBuffer::Impl

  //VTK::RenderPassFragmentShader::Impl
}
`;
const d0 = {
  NEAREST: 0,
  LINEAR: 1
};
var blt = {
  InterpolationType: d0
};
const {
  vtkErrorMacro: Wp
} = kr;
function ZO(i, t, e) {
  if (t) {
    const n = i.getIndependentComponents();
    return `${t.getMTime()}-${n}-${e}`;
  }
  return "0";
}
function TO(i, t, e) {
  return t.identity(e), i.reduce((n, s, r) => r === 0 ? s ? t.copy(n, s) : t.identity(n) : s ? t.multiply(n, n, s) : n, e);
}
function flt(i, t) {
  t.classHierarchy.push("vtkOpenGLImageResliceMapper"), i.buildPass = (n) => {
    if (n) {
      t.currentRenderPass = null, t._openGLImageSlice = i.getFirstAncestorOfType("vtkOpenGLImageSlice"), t._openGLRenderer = i.getFirstAncestorOfType("vtkOpenGLRenderer");
      const s = t._openGLRenderer.getRenderable();
      t._openGLCamera = t._openGLRenderer.getViewNodeFor(s.getActiveCamera()), t._openGLRenderWindow = t._openGLRenderer.getParent(), t.context = t._openGLRenderWindow.getContext(), t.tris.setOpenGLRenderWindow(t._openGLRenderWindow);
    }
  }, i.translucentPass = (n, s) => {
    n && (t.currentRenderPass = s, i.render());
  }, i.zBufferPass = (n) => {
    n && (t.haveSeenDepthRequest = !0, t.renderDepth = !0, i.render(), t.renderDepth = !1);
  }, i.opaqueZBufferPass = (n) => i.zBufferPass(n), i.opaquePass = (n) => {
    n && i.render();
  }, i.getCoincidentParameters = (n, s) => t.renderable.getResolveCoincidentTopology() ? t.renderable.getCoincidentTopologyPolygonOffsetParameters() : null, i.render = () => {
    const n = t._openGLImageSlice.getRenderable(), s = t._openGLRenderer.getRenderable();
    i.renderPiece(s, n);
  }, i.renderPiece = (n, s) => {
    if (i.invokeEvent({
      type: "StartEvent"
    }), t.renderable.update(), t.currentInput = t.renderable.getInputData(), !t.currentInput) {
      Wp("No input!");
      return;
    }
    i.updateResliceGeometry(), i.renderPieceStart(n, s), i.renderPieceDraw(n, s), i.renderPieceFinish(n, s), i.invokeEvent({
      type: "EndEvent"
    });
  }, i.renderPieceStart = (n, s) => {
    i.updateBufferObjects(n, s), s.getProperty().getInterpolationType() === d0.NEAREST ? (t.openGLTexture.setMinificationFilter(Qe.NEAREST), t.openGLTexture.setMagnificationFilter(Qe.NEAREST), t.colorTexture.setMinificationFilter(Qe.NEAREST), t.colorTexture.setMagnificationFilter(Qe.NEAREST), t.pwfTexture.setMinificationFilter(Qe.NEAREST), t.pwfTexture.setMagnificationFilter(Qe.NEAREST)) : (t.openGLTexture.setMinificationFilter(Qe.LINEAR), t.openGLTexture.setMagnificationFilter(Qe.LINEAR), t.colorTexture.setMinificationFilter(Qe.LINEAR), t.colorTexture.setMagnificationFilter(Qe.LINEAR), t.pwfTexture.setMinificationFilter(Qe.LINEAR), t.pwfTexture.setMagnificationFilter(Qe.LINEAR)), t.lastBoundBO = null;
  }, i.renderPieceDraw = (n, s) => {
    const r = t.context;
    t.openGLTexture.activate(), t.colorTexture.activate(), t.pwfTexture.activate(), i.updateShaders(t.tris, n, s), r.drawArrays(r.TRIANGLES, 0, Number(t.tris.getCABO().getElementCount())), t.tris.getVAO().release(), t.openGLTexture.deactivate(), t.colorTexture.deactivate(), t.pwfTexture.deactivate();
  }, i.renderPieceFinish = (n, s) => {
  }, i.updateBufferObjects = (n, s) => {
    i.getNeedToRebuildBufferObjects(n, s) && i.buildBufferObjects(n, s);
  }, i.getNeedToRebuildBufferObjects = (n, s) => t.VBOBuildTime.getMTime() < i.getMTime() || t.VBOBuildTime.getMTime() < s.getMTime() || t.VBOBuildTime.getMTime() < t.renderable.getMTime() || t.VBOBuildTime.getMTime() < s.getProperty().getMTime() || t.VBOBuildTime.getMTime() < t.currentInput.getMTime() || t.VBOBuildTime.getMTime() < t.resliceGeom.getMTime(), i.buildBufferObjects = (n, s) => {
    var N;
    const r = t.currentInput;
    if (!r)
      return;
    const a = (N = r.getPointData()) == null ? void 0 : N.getScalars();
    if (!a)
      return;
    t._scalars !== a && (t._openGLRenderWindow.releaseGraphicsResourcesForObject(t._scalars), t._scalars = a);
    const o = a.getNumberOfComponents();
    let l = `${r.getMTime()}A${a.getMTime()}`;
    const c = t._openGLRenderWindow.getGraphicsResourceForObject(a);
    if (!(c != null && c.vtkObj) || (c == null ? void 0 : c.hash) !== l || t.openGLTextureString !== l) {
      t.openGLTexture || (t.openGLTexture = bs.newInstance(), t.openGLTexture.setOpenGLRenderWindow(t._openGLRenderWindow));
      const W = r.getDimensions();
      t.openGLTexture.setOglNorm16Ext(t.context.getExtension("EXT_texture_norm16")), t.openGLTexture.releaseGraphicsResources(t._openGLRenderWindow), t.openGLTexture.resetFormatAndType(), t.openGLTexture.create3DFilterableFromDataArray(W[0], W[1], W[2], a), t.openGLTextureString = l, a && t._openGLRenderWindow.setGraphicsResourceForObject(a, t.openGLTexture, t.openGLTextureString);
    } else
      t.openGLTexture = c.vtkObj, t.openGLTextureString = c.hash;
    const d = s.getProperty(), h = d.getIndependentComponents(), p = h ? o : 1, m = h ? 2 * p : 1, b = d.getRGBTransferFunction();
    l = ZO(d, b, p);
    const y = t._openGLRenderWindow.getGraphicsResourceForObject(b);
    if (!(y != null && y.vtkObj) || (y == null ? void 0 : y.hash) !== l || t.colorTextureString !== l) {
      const x = 1024 * m * 3, V = new Uint8ClampedArray(x);
      if (t.colorTexture || (t.colorTexture = bs.newInstance(), t.colorTexture.setOpenGLRenderWindow(t._openGLRenderWindow)), b) {
        const X = new Float32Array(3072);
        for (let C = 0; C < p; C++) {
          const R = d.getRGBTransferFunction(C), z = R.getRange();
          if (R.getTable(z[0], z[1], 1024, X, 1), h)
            for (let F = 0; F < 1024 * 3; F++)
              V[C * 1024 * 6 + F] = 255 * X[F], V[C * 1024 * 6 + F + 1024 * 3] = 255 * X[F];
          else
            for (let F = 0; F < 1024 * 3; F++)
              V[C * 1024 * 6 + F] = 255 * X[F];
        }
        t.colorTexture.releaseGraphicsResources(t._openGLRenderWindow), t.colorTexture.resetFormatAndType(), t.colorTexture.create2DFromRaw(1024, m, 3, Ke.UNSIGNED_CHAR, V);
      } else {
        for (let X = 0; X < 1024 * 3; ++X)
          V[X] = 255 * X / (1023 * 3), V[X + 1] = 255 * X / (1023 * 3), V[X + 2] = 255 * X / (1023 * 3);
        t.colorTexture.releaseGraphicsResources(t._openGLRenderWindow), t.colorTexture.resetFormatAndType(), t.colorTexture.create2DFromRaw(1024, 1, 3, Ke.UNSIGNED_CHAR, V);
      }
      t.colorTextureString = l, b && t._openGLRenderWindow.setGraphicsResourceForObject(b, t.colorTexture, t.colorTextureString);
    } else
      t.colorTexture = y.vtkObj, t.colorTextureString = y.hash;
    const g = d.getPiecewiseFunction();
    l = ZO(d, g, p);
    const f = t._openGLRenderWindow.getGraphicsResourceForObject(g);
    if (!(f != null && f.vtkObj) || (f == null ? void 0 : f.hash) !== l || t.pwfTextureString !== l) {
      const x = 1024 * m, V = new Uint8ClampedArray(x);
      if (t.pwfTexture || (t.pwfTexture = bs.newInstance(), t.pwfTexture.setOpenGLRenderWindow(t._openGLRenderWindow)), g) {
        const X = new Float32Array(x), C = new Float32Array(1024);
        for (let R = 0; R < p; ++R) {
          const z = d.getPiecewiseFunction(R);
          if (z === null)
            X.fill(1);
          else {
            const F = z.getRange();
            if (z.getTable(F[0], F[1], 1024, C, 1), h)
              for (let P = 0; P < 1024; P++)
                X[R * 1024 * 2 + P] = C[P], X[R * 1024 * 2 + P + 1024] = C[P];
            else
              for (let P = 0; P < 1024; P++)
                X[R * 1024 * 2 + P] = C[P];
          }
        }
        t.pwfTexture.releaseGraphicsResources(t._openGLRenderWindow), t.pwfTexture.resetFormatAndType(), t.pwfTexture.create2DFromRaw(1024, m, 1, Ke.FLOAT, X);
      } else
        V.fill(255), t.pwfTexture.releaseGraphicsResources(t._openGLRenderWindow), t.pwfTexture.resetFormatAndType(), t.pwfTexture.create2DFromRaw(1024, 1, 1, Ke.UNSIGNED_CHAR, V);
      t.pwfTextureString = l, g && t._openGLRenderWindow.setGraphicsResourceForObject(g, t.pwfTexture, t.pwfTextureString);
    } else
      t.pwfTexture = f.vtkObj, t.pwfTextureString = f.hash;
    const M = `${t.resliceGeom.getMTime()}A${t.renderable.getSlabThickness()}`;
    if (!t.tris.getCABO().getElementCount() || t.VBOBuildString !== M) {
      const W = We.newInstance({
        numberOfComponents: 3,
        values: t.resliceGeom.getPoints().getData()
      });
      W.setName("points");
      const x = We.newInstance({
        numberOfComponents: 1,
        values: t.resliceGeom.getPolys().getData()
      }), V = {
        points: W,
        cellOffset: 0
      };
      if (t.renderable.getSlabThickness() > 0) {
        const X = t.resliceGeom.getPointData().getNormals();
        X ? V.normals = X : Wp("Slab mode requested without normals");
      }
      t.tris.getCABO().createVBO(x, "polys", Vn.SURFACE, V);
    }
    t.VBOBuildString = M, t.VBOBuildTime.modified();
  }, i.updateShaders = (n, s, r) => {
    if (t.lastBoundBO = n, i.getNeedToRebuildShaders(n, s, r)) {
      const a = {
        Vertex: null,
        Fragment: null,
        Geometry: null
      };
      i.buildShaders(a, s, r);
      const o = t._openGLRenderWindow.getShaderCache().readyShaderProgramArray(a.Vertex, a.Fragment, a.Geometry);
      o !== n.getProgram() && (n.setProgram(o), n.getVAO().releaseGraphicsResources()), n.getShaderSourceTime().modified();
    } else
      t._openGLRenderWindow.getShaderCache().readyShaderProgram(n.getProgram());
    n.getVAO().bind(), i.setMapperShaderParameters(n, s, r), i.setCameraShaderParameters(n, s, r), i.setPropertyShaderParameters(n, s, r);
  }, i.setMapperShaderParameters = (n, s, r) => {
    const a = n.getProgram();
    if (n.getCABO().getElementCount() && (t.VBOBuildTime.getMTime() > n.getAttributeUpdateTime().getMTime() || n.getShaderSourceTime().getMTime() > n.getAttributeUpdateTime().getMTime())) {
      a.isUniformUsed("texture1") && a.setUniformi("texture1", t.openGLTexture.getTextureUnit()), a.isAttributeUsed("vertexWC") && (n.getVAO().addAttributeArray(a, n.getCABO(), "vertexWC", n.getCABO().getVertexOffset(), n.getCABO().getStride(), t.context.FLOAT, 3, t.context.FALSE) || Wp("Error setting vertexWC in shader VAO.")), a.isAttributeUsed("normalWC") && (n.getVAO().addAttributeArray(a, n.getCABO(), "normalWC", n.getCABO().getNormalOffset(), n.getCABO().getStride(), t.context.FLOAT, 3, t.context.FALSE) || Wp("Error setting normalWC in shader VAO.")), a.isUniformUsed("slabThickness") && a.setUniformf("slabThickness", t.renderable.getSlabThickness()), a.isUniformUsed("spacing") && a.setUniform3fv("spacing", t.currentInput.getSpacing()), a.isUniformUsed("slabType") && a.setUniformi("slabType", t.renderable.getSlabType()), a.isUniformUsed("slabType") && a.setUniformi("slabType", t.renderable.getSlabType()), a.isUniformUsed("slabTrapezoid") && a.setUniformi("slabTrapezoid", t.renderable.getSlabTrapezoidIntegration());
      const l = n.getCABO().getCoordShiftAndScaleEnabled() ? n.getCABO().getInverseShiftAndScaleMatrix() : null;
      if (a.isUniformUsed("WCTCMatrix")) {
        const c = t.currentInput, u = c.getDimensions();
        ut.copy(t.tmpMat4, c.getIndexToWorld()), ut.scale(t.tmpMat4, t.tmpMat4, u), ut.invert(t.tmpMat4, t.tmpMat4), l && ut.multiply(t.tmpMat4, t.tmpMat4, l), a.setUniformMatrix("WCTCMatrix", t.tmpMat4);
      }
      a.isUniformUsed("vboScaling") && a.setUniform3fv("vboScaling", n.getCABO().getCoordScale()), n.getAttributeUpdateTime().modified();
    }
    if (t.haveSeenDepthRequest && n.getProgram().setUniformi("depthRequest", t.renderDepth ? 1 : 0), n.getProgram().isUniformUsed("coffset")) {
      const o = i.getCoincidentParameters(s, r);
      n.getProgram().setUniformf("coffset", o.offset), n.getProgram().isUniformUsed("cfactor") && n.getProgram().setUniformf("cfactor", o.factor);
    }
  }, i.setCameraShaderParameters = (n, s, r) => {
    const a = t._openGLCamera.getKeyMatrices(s), o = t._openGLImageSlice.getKeyMatrices(), c = n.getCABO().getCoordShiftAndScaleEnabled() ? n.getCABO().getInverseShiftAndScaleMatrix() : null, u = n.getProgram();
    u.isUniformUsed("MCPCMatrix") && (ut.identity(t.tmpMat4), u.setUniformMatrix("MCPCMatrix", TO([a.wcpc, o.mcwc, c], ut, t.tmpMat4))), u.isUniformUsed("MCVCMatrix") && (ut.identity(t.tmpMat4), u.setUniformMatrix("MCVCMatrix", TO([a.wcvc, o.mcwc, c], ut, t.tmpMat4)));
  }, i.setPropertyShaderParameters = (n, s, r) => {
    const a = n.getProgram(), o = r.getProperty(), l = o.getOpacity();
    a.setUniformf("opacity", l);
    const c = t.openGLTexture.getComponents(), u = o.getIndependentComponents();
    if (u)
      for (let m = 0; m < c; ++m)
        a.setUniformf(`mix${m}`, o.getComponentWeight(m));
    const d = t.openGLTexture.getVolumeInfo();
    for (let m = 0; m < c; m++) {
      let b = o.getColorWindow(), y = o.getColorLevel();
      const Z = u ? m : 0, g = o.getRGBTransferFunction(Z);
      if (g && o.getUseLookupTableScalarRange()) {
        const M = g.getRange();
        b = M[1] - M[0], y = 0.5 * (M[1] + M[0]);
      }
      const f = d.scale[m] / b, T = (d.offset[m] - y) / b + 0.5;
      a.setUniformf(`cshift${m}`, T), a.setUniformf(`cscale${m}`, f);
    }
    const h = t.colorTexture.getTextureUnit();
    a.setUniformi("colorTexture1", h);
    for (let m = 0; m < c; m++) {
      let b = 1, y = 0;
      const Z = u ? m : 0, g = o.getPiecewiseFunction(Z);
      if (g) {
        const f = g.getRange(), T = f[1] - f[0], M = 0.5 * (f[0] + f[1]);
        b = d.scale[m] / T, y = (d.offset[m] - M) / T + 0.5;
      }
      a.setUniformf(`pwfshift${m}`, y), a.setUniformf(`pwfscale${m}`, b);
    }
    const p = t.pwfTexture.getTextureUnit();
    a.setUniformi("pwfTexture1", p), a.setUniform4fv("backgroundColor", t.renderable.getBackgroundColor());
  }, i.getNeedToRebuildShaders = (n, s, r) => {
    var h;
    const a = t.openGLTexture.getComponents(), o = r.getProperty().getIndependentComponents(), l = t.renderable.getSlabThickness(), c = t.renderable.getSlabType(), u = t.renderable.getSlabTrapezoidIntegration();
    let d = !1;
    return (!t.currentRenderPass && t.lastRenderPassShaderReplacement || t.currentRenderPass && t.currentRenderPass.getShaderReplacement() !== t.lastRenderPassShaderReplacement) && (d = !0), d || t.lastHaveSeenDepthRequest !== t.haveSeenDepthRequest || ((h = n.getProgram()) == null ? void 0 : h.getHandle()) === 0 || t.lastTextureComponents !== a || t.lastIndependentComponents !== o || t.lastSlabThickness !== l || t.lastSlabType !== c || t.lastSlabTrapezoidIntegration !== u ? (t.lastHaveSeenDepthRequest = t.haveSeenDepthRequest, t.lastTextureComponents = a, t.lastIndependentComponents = o, t.lastSlabThickness = l, t.lastSlabType = c, t.lastSlabTrapezoidIntegration = u, !0) : !1;
  }, i.getShaderTemplate = (n, s, r) => {
    n.Vertex = plt, n.Fragment = mlt, n.Geometry = "";
  }, i.replaceShaderValues = (n, s, r) => {
    if (i.replaceShaderTCoord(n, s, r), i.replaceShaderPositionVC(n, s, r), t.haveSeenDepthRequest) {
      let a = n.Fragment;
      a = Ft.substitute(a, "//VTK::ZBuffer::Dec", "uniform int depthRequest;").result, a = Ft.substitute(a, "//VTK::ZBuffer::Impl", ["if (depthRequest == 1) {", "float iz = floor(gl_FragCoord.z*65535.0 + 0.1);", "float rf = floor(iz/256.0)/255.0;", "float gf = mod(iz,256.0)/255.0;", "gl_FragData[0] = vec4(rf, gf, 0.0, 1.0); }"]).result, n.Fragment = a;
    }
    i.replaceShaderCoincidentOffset(n, s, r);
  }, i.replaceShaderTCoord = (n, s, r) => {
    let a = n.Vertex;
    const o = n.Geometry;
    let l = n.Fragment;
    const c = ["uniform mat4 WCTCMatrix;", "out vec3 fragTexCoord;"], u = t.renderable.getSlabThickness();
    a = Ft.substitute(a, "//VTK::TCoord::Dec", c).result;
    const d = ["fragTexCoord = (WCTCMatrix * vertexWC).xyz;"];
    a = Ft.substitute(a, "//VTK::TCoord::Impl", d).result;
    const h = t.openGLTexture.getComponents(), p = r.getProperty().getIndependentComponents();
    let m = [
      "in vec3 fragTexCoord;",
      "uniform highp sampler3D texture1;",
      "uniform mat4 WCTCMatrix;",
      // color shift and scale
      "uniform float cshift0;",
      "uniform float cscale0;",
      // pwf shift and scale
      "uniform float pwfshift0;",
      "uniform float pwfscale0;",
      // color and pwf textures
      "uniform sampler2D colorTexture1;",
      "uniform sampler2D pwfTexture1;",
      // opacity
      "uniform float opacity;",
      // background color
      "uniform vec4 backgroundColor;"
    ];
    if (p) {
      for (let y = 1; y < h; y++)
        m = m.concat([
          // color shift and scale
          `uniform float cshift${y};`,
          `uniform float cscale${y};`,
          // weighting shift and scale
          `uniform float pwfshift${y};`,
          `uniform float pwfscale${y};`
        ]);
      switch (h) {
        case 1:
          m = m.concat(["uniform float mix0;", "#define height0 0.5"]);
          break;
        case 2:
          m = m.concat(["uniform float mix0;", "uniform float mix1;", "#define height0 0.25", "#define height1 0.75"]);
          break;
        case 3:
          m = m.concat(["uniform float mix0;", "uniform float mix1;", "uniform float mix2;", "#define height0 0.17", "#define height1 0.5", "#define height2 0.83"]);
          break;
        case 4:
          m = m.concat(["uniform float mix0;", "uniform float mix1;", "uniform float mix2;", "uniform float mix3;", "#define height0 0.125", "#define height1 0.375", "#define height2 0.625", "#define height3 0.875"]);
          break;
        default:
          Wp("Unsupported number of independent coordinates.");
      }
    }
    u > 0 && (m = m.concat(["uniform vec3 spacing;", "uniform float slabThickness;", "uniform int slabType;", "uniform int slabTrapezoid;", "uniform vec3 vboScaling;"]), m = m.concat(["vec4 compositeValue(vec4 currVal, vec4 valToComp, int trapezoid)", "{", "  vec4 retVal = vec4(1.0);", "  if (slabType == 0) // min", "  {", "    retVal = min(currVal, valToComp);", "  }", "  else if (slabType == 1) // max", "  {", "    retVal = max(currVal, valToComp);", "  }", "  else if (slabType == 3) // sum", "  {", "    retVal = currVal + (trapezoid > 0 ? 0.5 * valToComp : valToComp); ", "  }", "  else // mean", "  {", "    retVal = currVal + (trapezoid > 0 ? 0.5 * valToComp : valToComp); ", "  }", "  return retVal;", "}"])), l = Ft.substitute(l, "//VTK::TCoord::Dec", m).result;
    let b = ["if (any(greaterThan(fragTexCoord, vec3(1.0))) || any(lessThan(fragTexCoord, vec3(0.0))))", "{", "  // set the background color and exit", "  gl_FragData[0] = backgroundColor;", "  return;", "}", "vec4 tvalue = texture(texture1, fragTexCoord);"];
    if (u > 0 && (b = b.concat(["// Get the first and last samples", "int numSlices = 1;", "float scaling = min(min(spacing.x, spacing.y), spacing.z) * 0.5;", "vec3 normalxspacing = scaling * normalWCVSOutput;", "float distTraveled = length(normalxspacing);", "int trapezoid = 0;", "while (distTraveled < slabThickness * 0.5)", "{", "  distTraveled += length(normalxspacing);", "  float fnumSlices = float(numSlices);", "  if (distTraveled > slabThickness * 0.5)", "  {", "    // Before stepping outside the slab, sample at the boundaries", "    normalxspacing = normalWCVSOutput * slabThickness * 0.5 / fnumSlices;", "    trapezoid = slabTrapezoid;", "  }", "  vec3 fragTCoordNeg = (WCTCMatrix * vec4(vertexWCVSOutput.xyz - fnumSlices * normalxspacing * vboScaling, 1.0)).xyz;", "  if (!any(greaterThan(fragTCoordNeg, vec3(1.0))) && !any(lessThan(fragTCoordNeg, vec3(0.0))))", "  {", "    vec4 newVal = texture(texture1, fragTCoordNeg);", "    tvalue = compositeValue(tvalue, newVal, trapezoid);", "    numSlices += 1;", "  }", "  vec3 fragTCoordPos = (WCTCMatrix * vec4(vertexWCVSOutput.xyz + fnumSlices * normalxspacing * vboScaling, 1.0)).xyz;", "  if (!any(greaterThan(fragTCoordNeg, vec3(1.0))) && !any(lessThan(fragTCoordNeg, vec3(0.0))))", "  {", "    vec4 newVal = texture(texture1, fragTCoordPos);", "    tvalue = compositeValue(tvalue, newVal, trapezoid);", "    numSlices += 1;", "  }", "}", "// Finally, if slab type is *mean*, divide the sum by the numSlices", "if (slabType == 2)", "{", "  tvalue = tvalue / float(numSlices);", "}"])), p) {
      const y = ["r", "g", "b", "a"];
      for (let Z = 0; Z < h; ++Z)
        b = b.concat([`vec3 tcolor${Z} = mix${Z} * texture2D(colorTexture1, vec2(tvalue.${y[Z]} * cscale${Z} + cshift${Z}, height${Z})).rgb;`, `float compWeight${Z} = mix${Z} * texture2D(pwfTexture1, vec2(tvalue.${y[Z]} * pwfscale${Z} + pwfshift${Z}, height${Z})).r;`]);
      switch (h) {
        case 1:
          b = b.concat(["gl_FragData[0] = vec4(tcolor0.rgb, compWeight0 * opacity);"]);
          break;
        case 2:
          b = b.concat(["float weightSum = compWeight0 + compWeight1;", "gl_FragData[0] = vec4(vec3((tcolor0.rgb * (compWeight0 / weightSum)) + (tcolor1.rgb * (compWeight1 / weightSum))), opacity);"]);
          break;
        case 3:
          b = b.concat(["float weightSum = compWeight0 + compWeight1 + compWeight2;", "gl_FragData[0] = vec4(vec3((tcolor0.rgb * (compWeight0 / weightSum)) + (tcolor1.rgb * (compWeight1 / weightSum)) + (tcolor2.rgb * (compWeight2 / weightSum))), opacity);"]);
          break;
        case 4:
          b = b.concat(["float weightSum = compWeight0 + compWeight1 + compWeight2 + compWeight3;", "gl_FragData[0] = vec4(vec3((tcolor0.rgb * (compWeight0 / weightSum)) + (tcolor1.rgb * (compWeight1 / weightSum)) + (tcolor2.rgb * (compWeight2 / weightSum)) + (tcolor3.rgb * (compWeight3 / weightSum))), opacity);"]);
          break;
        default:
          Wp("Unsupported number of independent coordinates.");
      }
    } else
      switch (h) {
        case 1:
          b = b.concat(["// Dependent components", "float intensity = tvalue.r;", "vec3 tcolor = texture2D(colorTexture1, vec2(intensity * cscale0 + cshift0, 0.5)).rgb;", "float scalarOpacity = texture2D(pwfTexture1, vec2(intensity * pwfscale0 + pwfshift0, 0.5)).r;", "gl_FragData[0] = vec4(tcolor, scalarOpacity * opacity);"]);
          break;
        case 2:
          b = b.concat(["float intensity = tvalue.r*cscale0 + cshift0;", "gl_FragData[0] = vec4(texture2D(colorTexture1, vec2(intensity, 0.5)).rgb, pwfscale0*tvalue.g + pwfshift0);"]);
          break;
        case 3:
          b = b.concat(["vec4 tcolor = cscale0*tvalue + cshift0;", "gl_FragData[0] = vec4(texture2D(colorTexture1, vec2(tcolor.r,0.5)).r,", "  texture2D(colorTexture1, vec2(tcolor.g,0.5)).r,", "  texture2D(colorTexture1, vec2(tcolor.b,0.5)).r, opacity);"]);
          break;
        default:
          b = b.concat(["vec4 tcolor = cscale0*tvalue + cshift0;", "gl_FragData[0] = vec4(texture2D(colorTexture1, vec2(tcolor.r,0.5)).r,", "  texture2D(colorTexture1, vec2(tcolor.g,0.5)).r,", "  texture2D(colorTexture1, vec2(tcolor.b,0.5)).r, tcolor.a);"]);
      }
    l = Ft.substitute(l, "//VTK::TCoord::Impl", b).result, n.Vertex = a, n.Fragment = l, n.Geometry = o;
  }, i.replaceShaderPositionVC = (n, s, r) => {
    let a = n.Vertex;
    const o = n.Geometry;
    let l = n.Fragment;
    const c = t.renderable.getSlabThickness();
    let u = ["attribute vec4 vertexWC;"];
    u = u.concat([`//${i.getMTime()}${t.resliceGeomUpdateString}`]), c > 0 && (u = u.concat(["attribute vec3 normalWC;", "varying vec3 normalWCVSOutput;", "varying vec4 vertexWCVSOutput;"])), a = Ft.substitute(a, "//VTK::PositionVC::Dec", u).result;
    let d = ["gl_Position = MCPCMatrix * vertexWC;"];
    c > 0 && (d = d.concat(["normalWCVSOutput = normalWC;", "vertexWCVSOutput = vertexWC;"])), a = Ft.substitute(a, "//VTK::PositionVC::Impl", d).result, a = Ft.substitute(a, "//VTK::Camera::Dec", ["uniform mat4 MCPCMatrix;", "uniform mat4 MCVCMatrix;"]).result;
    let h = [];
    c > 0 && (h = h.concat(["varying vec3 normalWCVSOutput;", "varying vec4 vertexWCVSOutput;"])), l = Ft.substitute(l, "//VTK::PositionVC::Dec", h).result, n.Vertex = a, n.Geometry = o, n.Fragment = l;
  };
  function e(n) {
    Hn.normalize(n);
    const s = [0, 0, 0];
    for (let r = 0; r < 3; ++r) {
      I.zero(s), s[r] = 1;
      const a = Hn.dot(n, s);
      if (a < -0.999 || a > 0.999)
        return [!0, r];
    }
    return [!1, 2];
  }
  i.updateResliceGeometry = () => {
    var u;
    let n = "";
    const s = t.currentInput, r = s == null ? void 0 : s.getBounds();
    let a = !0, o = 2;
    const l = t.renderable.getSlicePolyData(), c = t.renderable.getSlicePlane();
    if (l)
      n = n.concat(`PolyData${l.getMTime()}`);
    else if (c) {
      n = n.concat(`Plane${c.getMTime()}`), s && (n = n.concat(`Image${s.getMTime()}`));
      const d = gi.fromValues(s == null ? void 0 : s.getDirection());
      gi.invert(d, d);
      const h = [...c.getNormal()];
      I.transformMat3(h, h, d), [a, o] = e(h);
    } else {
      const d = li.newInstance();
      d.setNormal(0, 0, 1);
      let h = [0, 1, 0, 1, 0, 1];
      s && (h = r), d.setOrigin(h[0], h[2], 0.5 * (h[5] + h[4])), t.renderable.setSlicePlane(d), n = n.concat(`Plane${c == null ? void 0 : c.getMTime()}`), s && (n = n.concat(`Image${s.getMTime()}`));
    }
    if (!t.resliceGeom || t.resliceGeomUpdateString !== n) {
      if (l)
        t.resliceGeom || (t.resliceGeom = Ie.newInstance()), t.resliceGeom.getPoints().setData(l.getPoints().getData(), 3), t.resliceGeom.getPolys().setData(l.getPolys().getData(), 1), t.resliceGeom.getPointData().setNormals(l.getPointData().getNormals());
      else if (c)
        if (a) {
          const d = new Float32Array(12), h = s.worldToIndex(c.getOrigin(), [0, 0, 0]), p = [(o + 1) % 3, (o + 2) % 3].sort(), m = s.getDimensions(), b = [0, m[0] - 1, 0, m[1] - 1, 0, m[2] - 1];
          let y = 0;
          for (let M = 0; M < 2; ++M)
            for (let N = 0; N < 2; ++N)
              d[y + o] = h[o], d[y + p[0]] = b[2 * p[0] + N], d[y + p[1]] = b[2 * p[1] + M], y += 3;
          t.transform.setMatrix(s.getIndexToWorld()), t.transform.transformPoints(d, d);
          const Z = new Uint16Array(8);
          Z[0] = 3, Z[1] = 0, Z[2] = 1, Z[3] = 3, Z[4] = 3, Z[5] = 0, Z[6] = 3, Z[7] = 2;
          const g = c.getNormal();
          Hn.normalize(g);
          const f = new Float32Array(12);
          for (let M = 0; M < 4; ++M)
            f[3 * M] = g[0], f[3 * M + 1] = g[1], f[3 * M + 2] = g[2];
          t.resliceGeom || (t.resliceGeom = Ie.newInstance()), t.resliceGeom.getPoints().setData(d, 3), t.resliceGeom.getPolys().setData(Z, 1);
          const T = We.newInstance({
            numberOfComponents: 3,
            values: f,
            name: "Normals"
          });
          t.resliceGeom.getPointData().setNormals(T);
        } else {
          t.outlineFilter.setInputData(s), t.cutter.setInputConnection(t.outlineFilter.getOutputPort()), t.cutter.setCutFunction(c), t.lineToSurfaceFilter.setInputConnection(t.cutter.getOutputPort()), t.lineToSurfaceFilter.update(), t.resliceGeom || (t.resliceGeom = Ie.newInstance());
          const d = t.lineToSurfaceFilter.getOutputData();
          t.resliceGeom.getPoints().setData(d.getPoints().getData(), 3), t.resliceGeom.getPolys().setData(d.getPolys().getData(), 1), t.resliceGeom.getPointData().setNormals(d.getPointData().getNormals());
          const h = c.getNormal(), p = t.resliceGeom.getNumberOfPoints();
          Hn.normalize(h);
          const m = new Float32Array(p * 3);
          for (let y = 0; y < p; ++y)
            m[3 * y] = h[0], m[3 * y + 1] = h[1], m[3 * y + 2] = h[2];
          const b = We.newInstance({
            numberOfComponents: 3,
            values: m,
            name: "Normals"
          });
          t.resliceGeom.getPointData().setNormals(b);
        }
      else
        Wp("Something went wrong.", "A default slice plane should have been created in the beginning of", "updateResliceGeometry.");
      t.resliceGeomUpdateString = n, (u = t.resliceGeom) == null || u.modified();
    }
  }, i.setOpenGLTexture = (n) => {
    n && (t.openGLTexture = n, t._externalOpenGLTexture = !0);
  };
}
const glt = {
  VBOBuildTime: {},
  VBOBuildString: null,
  haveSeenDepthRequest: !1,
  lastHaveSeenDepthRequest: !1,
  lastIndependentComponents: !1,
  lastTextureComponents: 0,
  lastSlabThickness: 0,
  lastSlabTrapezoidIntegration: 0,
  lastSlabType: -1,
  openGLTexture: null,
  openGLTextureString: null,
  colorTextureString: null,
  pwfTextureString: null,
  resliceGeom: null,
  resliceGeomUpdateString: null,
  tris: null,
  colorTexture: null,
  pwfTexture: null,
  _externalOpenGLTexture: !1,
  _scalars: null
};
function ylt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, glt, e), ui.extend(i, t, e), kc.implementReplaceShaderCoincidentOffset(i, t, e), kc.implementBuildShadersWithReplacements(i, t, e), t.tris = Jc.newInstance(), t.openGLTexture = null, t.colorTexture = null, t.pwfTexture = null, t.VBOBuildTime = {}, xi(t.VBOBuildTime), t.tmpMat4 = ut.identity(new Float64Array(16)), t.outlineFilter = clt.newInstance(), t.outlineFilter.setGenerateFaces(!0), t.outlineFilter.setGenerateLines(!1), t.cubePolyData = Ie.newInstance(), t.cutter = UI.newInstance(), t.lineToSurfaceFilter = Hot.newInstance(), t.transform = hlt.newInstance(), Sa(i, t, ["openGLTexture"]), flt(i, t);
}
const Zlt = In(ylt, "vtkOpenGLImageResliceMapper");
Js("vtkImageResliceMapper", Zlt);
const Tlt = {
  NONE: -1,
  I: 0,
  J: 1,
  K: 2,
  X: 3,
  Y: 4,
  Z: 5
};
var UG = {
  SlicingMode: Tlt
};
const {
  vtkWarningMacro: MO,
  vtkErrorMacro: Gp
} = kr, {
  SlicingMode: cl
} = UG;
function NO(i, t, e) {
  if (t) {
    const n = i.getIndependentComponents();
    return `${t.getMTime()}-${n}-${e}`;
  }
  return "0";
}
function Mlt(i) {
  const t = i.split(`
`), e = [];
  for (let n = 0; n < t.length; ++n) {
    const s = t[n].trim();
    s.length > 0 && e.push(s);
  }
  return e;
}
function Nlt(i, t) {
  t.classHierarchy.push("vtkOpenGLImageMapper"), i.buildPass = (e) => {
    if (e) {
      t.currentRenderPass = null, t.openGLImageSlice = i.getFirstAncestorOfType("vtkOpenGLImageSlice"), t._openGLRenderer = i.getFirstAncestorOfType("vtkOpenGLRenderer"), t._openGLRenderWindow = t._openGLRenderer.getParent(), t.context = t._openGLRenderWindow.getContext(), t.tris.setOpenGLRenderWindow(t._openGLRenderWindow);
      const n = t._openGLRenderer.getRenderable();
      t.openGLCamera = t._openGLRenderer.getViewNodeFor(n.getActiveCamera()), t.renderable.isA("vtkImageMapper") && t.renderable.getSliceAtFocalPoint() && t.renderable.setSliceFromCamera(n.getActiveCamera());
    }
  }, i.translucentPass = (e, n) => {
    e && (t.currentRenderPass = n, i.render());
  }, i.zBufferPass = (e) => {
    e && (t.haveSeenDepthRequest = !0, t.renderDepth = !0, i.render(), t.renderDepth = !1);
  }, i.opaqueZBufferPass = (e) => i.zBufferPass(e), i.opaquePass = (e) => {
    e && i.render();
  }, i.getCoincidentParameters = (e, n) => t.renderable.getResolveCoincidentTopology() ? t.renderable.getCoincidentTopologyPolygonOffsetParameters() : null, i.render = () => {
    const e = t.openGLImageSlice.getRenderable(), n = t._openGLRenderer.getRenderable();
    i.renderPiece(n, e);
  }, i.getShaderTemplate = (e, n, s) => {
    e.Vertex = EI, e.Fragment = IT, e.Geometry = "";
  }, i.replaceShaderValues = (e, n, s) => {
    let r = e.Vertex, a = e.Fragment;
    r = Ft.substitute(r, "//VTK::Camera::Dec", ["uniform mat4 MCPCMatrix;"]).result, r = Ft.substitute(r, "//VTK::PositionVC::Impl", ["  gl_Position = MCPCMatrix * vertexMC;"]).result, r = Ft.substitute(r, "//VTK::TCoord::Impl", "tcoordVCVSOutput = tcoordMC;").result, r = Ft.substitute(r, "//VTK::TCoord::Dec", "attribute vec2 tcoordMC; varying vec2 tcoordVCVSOutput;").result;
    const o = t.openGLTexture.getComponents(), l = s.getProperty().getIndependentComponents();
    let c = [
      "varying vec2 tcoordVCVSOutput;",
      // color shift and scale
      "uniform float cshift0;",
      "uniform float cscale0;",
      // pwf shift and scale
      "uniform float pwfshift0;",
      "uniform float pwfscale0;",
      "uniform sampler2D texture1;",
      "uniform sampler2D colorTexture1;",
      "uniform sampler2D pwfTexture1;",
      "uniform sampler2D labelOutlineTexture1;",
      "uniform float opacity;",
      "uniform float outlineOpacity;"
    ];
    if (l) {
      for (let d = 1; d < o; d++)
        c = c.concat([
          // color shift and scale
          `uniform float cshift${d};`,
          `uniform float cscale${d};`,
          // weighting shift and scale
          `uniform float pwfshift${d};`,
          `uniform float pwfscale${d};`
        ]);
      switch (o) {
        case 1:
          c = c.concat(["uniform float mix0;", "#define height0 0.5"]);
          break;
        case 2:
          c = c.concat(["uniform float mix0;", "uniform float mix1;", "#define height0 0.25", "#define height1 0.75"]);
          break;
        case 3:
          c = c.concat(["uniform float mix0;", "uniform float mix1;", "uniform float mix2;", "#define height0 0.17", "#define height1 0.5", "#define height2 0.83"]);
          break;
        case 4:
          c = c.concat(["uniform float mix0;", "uniform float mix1;", "uniform float mix2;", "uniform float mix3;", "#define height0 0.125", "#define height1 0.375", "#define height2 0.625", "#define height3 0.875"]);
          break;
        default:
          Gp("Unsupported number of independent coordinates.");
      }
    }
    if (a = Ft.substitute(a, "//VTK::TCoord::Dec", c).result, s.getProperty().getUseLabelOutline() === !0 && (a = Ft.substitute(a, "//VTK::LabelOutline::Dec", ["uniform int outlineThickness;", "uniform float vpWidth;", "uniform float vpHeight;", "uniform float vpOffsetX;", "uniform float vpOffsetY;", "uniform mat4 PCWCMatrix;", "uniform mat4 vWCtoIDX;", "uniform ivec3 imageDimensions;"]).result, a = Ft.substitute(a, "//VTK::ImageLabelOutlineOn", "#define vtkImageLabelOutlineOn").result, a = Ft.substitute(a, "//VTK::LabelOutlineHelperFunction", ["#ifdef vtkImageLabelOutlineOn", "vec3 fragCoordToIndexSpace(vec4 fragCoord) {", "  vec4 pcPos = vec4(", "    (fragCoord.x / vpWidth - vpOffsetX - 0.5) * 2.0,", "    (fragCoord.y / vpHeight - vpOffsetY - 0.5) * 2.0,", "    (fragCoord.z - 0.5) * 2.0,", "    1.0);", "", "  vec4 worldCoord = PCWCMatrix * pcPos;", "  vec4 vertex = (worldCoord/worldCoord.w);", "", "  vec3 index = (vWCtoIDX * vertex).xyz;", "", "  // half voxel fix for labelmapOutline", "  return (index + vec3(0.5)) / vec3(imageDimensions);", "}", "#endif"]).result), l) {
      const d = ["r", "g", "b", "a"];
      let h = ["vec4 tvalue = texture2D(texture1, tcoordVCVSOutput);"];
      for (let p = 0; p < o; p++)
        h = h.concat([`vec3 tcolor${p} = mix${p} * texture2D(colorTexture1, vec2(tvalue.${d[p]} * cscale${p} + cshift${p}, height${p})).rgb;`, `float compWeight${p} = mix${p} * texture2D(pwfTexture1, vec2(tvalue.${d[p]} * pwfscale${p} + pwfshift${p}, height${p})).r;`]);
      switch (o) {
        case 1:
          h = h.concat(["gl_FragData[0] = vec4(tcolor0.rgb, opacity);"]);
          break;
        case 2:
          h = h.concat(["float weightSum = compWeight0 + compWeight1;", "gl_FragData[0] = vec4(vec3((tcolor0.rgb * (compWeight0 / weightSum)) + (tcolor1.rgb * (compWeight1 / weightSum))), opacity);"]);
          break;
        case 3:
          h = h.concat(["float weightSum = compWeight0 + compWeight1 + compWeight2;", "gl_FragData[0] = vec4(vec3((tcolor0.rgb * (compWeight0 / weightSum)) + (tcolor1.rgb * (compWeight1 / weightSum)) + (tcolor2.rgb * (compWeight2 / weightSum))), opacity);"]);
          break;
        case 4:
          h = h.concat(["float weightSum = compWeight0 + compWeight1 + compWeight2 + compWeight3;", "gl_FragData[0] = vec4(vec3((tcolor0.rgb * (compWeight0 / weightSum)) + (tcolor1.rgb * (compWeight1 / weightSum)) + (tcolor2.rgb * (compWeight2 / weightSum)) + (tcolor3.rgb * (compWeight3 / weightSum))), opacity);"]);
          break;
        default:
          Gp("Unsupported number of independent coordinates.");
      }
      a = Ft.substitute(a, "//VTK::TCoord::Impl", h).result;
    } else
      switch (o) {
        case 1:
          a = Ft.substitute(a, "//VTK::TCoord::Impl", [...Mlt(`
                #ifdef vtkImageLabelOutlineOn
                  vec3 centerPosIS = fragCoordToIndexSpace(gl_FragCoord); 
                  float centerValue = texture2D(texture1, centerPosIS.xy).r;
                  bool pixelOnBorder = false;
                  vec3 tColor = texture2D(colorTexture1, vec2(centerValue * cscale0 + cshift0, 0.5)).rgb;
                  float scalarOpacity = texture2D(pwfTexture1, vec2(centerValue * pwfscale0 + pwfshift0, 0.5)).r;
                  float opacityToUse = scalarOpacity * opacity;
                  int segmentIndex = int(centerValue * 255.0);
                  float textureCoordinate = float(segmentIndex - 1) / 1024.0;
                  float textureValue = texture2D(labelOutlineTexture1, vec2(textureCoordinate, 0.5)).r;
                  int actualThickness = int(textureValue * 255.0);

                  if (segmentIndex == 0){
                    gl_FragData[0] = vec4(0.0, 1.0, 1.0, 0.0);
                    return;
                  }

                  if (actualThickness == 0) {
                    gl_FragData[0] = vec4(0.0, 0.0, 1.0, 1.0);
                    return;
                  }

                  for (int i = -actualThickness; i <= actualThickness; i++) {
                    for (int j = -actualThickness; j <= actualThickness; j++) {
                      if (i == 0 || j == 0) {
                        continue;
                      }
                      vec4 neighborPixelCoord = vec4(gl_FragCoord.x + float(i),
                        gl_FragCoord.y + float(j),
                        gl_FragCoord.z, gl_FragCoord.w);
                      vec3 neighborPosIS = fragCoordToIndexSpace(neighborPixelCoord);
                      float value = texture2D(texture1, neighborPosIS.xy).r;
                      if (value != centerValue) {
                        pixelOnBorder = true;
                        break;
                      }
                    }
                    if (pixelOnBorder == true) {
                      break;
                    }
                  }
                  if (pixelOnBorder == true) {
                    gl_FragData[0] = vec4(tColor, outlineOpacity);
                  }
                  else {
                    gl_FragData[0] = vec4(tColor, opacityToUse);
                  }
                #else
                  float intensity = texture2D(texture1, tcoordVCVSOutput).r;
                  vec3 tcolor = texture2D(colorTexture1, vec2(intensity * cscale0 + cshift0, 0.5)).rgb;
                  float scalarOpacity = texture2D(pwfTexture1, vec2(intensity * pwfscale0 + pwfshift0, 0.5)).r;
                  gl_FragData[0] = vec4(tcolor, scalarOpacity * opacity);
                #endif
                `)]).result;
          break;
        case 2:
          a = Ft.substitute(a, "//VTK::TCoord::Impl", ["vec4 tcolor = texture2D(texture1, tcoordVCVSOutput);", "float intensity = tcolor.r*cscale0 + cshift0;", "gl_FragData[0] = vec4(texture2D(colorTexture1, vec2(intensity, 0.5)).rgb, pwfscale0*tcolor.g + pwfshift0);"]).result;
          break;
        case 3:
          a = Ft.substitute(a, "//VTK::TCoord::Impl", ["vec4 tcolor = cscale0*texture2D(texture1, tcoordVCVSOutput.st) + cshift0;", "gl_FragData[0] = vec4(texture2D(colorTexture1, vec2(tcolor.r,0.5)).r,", "  texture2D(colorTexture1, vec2(tcolor.g,0.5)).r,", "  texture2D(colorTexture1, vec2(tcolor.b,0.5)).r, opacity);"]).result;
          break;
        default:
          a = Ft.substitute(a, "//VTK::TCoord::Impl", ["vec4 tcolor = cscale0*texture2D(texture1, tcoordVCVSOutput.st) + cshift0;", "gl_FragData[0] = vec4(texture2D(colorTexture1, vec2(tcolor.r,0.5)).r,", "  texture2D(colorTexture1, vec2(tcolor.g,0.5)).r,", "  texture2D(colorTexture1, vec2(tcolor.b,0.5)).r, tcolor.a);"]).result;
      }
    t.haveSeenDepthRequest && (a = Ft.substitute(a, "//VTK::ZBuffer::Dec", "uniform int depthRequest;").result, a = Ft.substitute(a, "//VTK::ZBuffer::Impl", ["if (depthRequest == 1) {", "float iz = floor(gl_FragCoord.z*65535.0 + 0.1);", "float rf = floor(iz/256.0)/255.0;", "float gf = mod(iz,256.0)/255.0;", "gl_FragData[0] = vec4(rf, gf, 0.0, 1.0); }"]).result), e.Vertex = r, e.Fragment = a, i.replaceShaderClip(e, n, s), i.replaceShaderCoincidentOffset(e, n, s);
  }, i.replaceShaderClip = (e, n, s) => {
    let r = e.Vertex, a = e.Fragment;
    if (t.renderable.getNumberOfClippingPlanes()) {
      let o = t.renderable.getNumberOfClippingPlanes();
      o > 6 && (Zn("OpenGL has a limit of 6 clipping planes"), o = 6), r = Ft.substitute(r, "//VTK::Clip::Dec", ["uniform int numClipPlanes;", "uniform vec4 clipPlanes[6];", "varying float clipDistancesVSOutput[6];"]).result, r = Ft.substitute(r, "//VTK::Clip::Impl", ["for (int planeNum = 0; planeNum < 6; planeNum++)", "    {", "    if (planeNum >= numClipPlanes)", "        {", "        break;", "        }", "    clipDistancesVSOutput[planeNum] = dot(clipPlanes[planeNum], vertexMC);", "    }"]).result, a = Ft.substitute(a, "//VTK::Clip::Dec", ["uniform int numClipPlanes;", "varying float clipDistancesVSOutput[6];"]).result, a = Ft.substitute(a, "//VTK::Clip::Impl", ["for (int planeNum = 0; planeNum < 6; planeNum++)", "    {", "    if (planeNum >= numClipPlanes)", "        {", "        break;", "        }", "    if (clipDistancesVSOutput[planeNum] < 0.0) discard;", "    }"]).result;
    }
    e.Vertex = r, e.Fragment = a;
  }, i.getNeedToRebuildShaders = (e, n, s) => {
    var l;
    const r = t.openGLTexture.getComponents(), a = s.getProperty().getIndependentComponents();
    let o = !1;
    return (!t.currentRenderPass && t.lastRenderPassShaderReplacement || t.currentRenderPass && t.currentRenderPass.getShaderReplacement() !== t.lastRenderPassShaderReplacement) && (o = !0), o || t.lastHaveSeenDepthRequest !== t.haveSeenDepthRequest || !e.getProgram() || ((l = e.getProgram()) == null ? void 0 : l.getHandle()) === 0 || t.lastTextureComponents !== r || t.lastIndependentComponents !== a ? (t.lastHaveSeenDepthRequest = t.haveSeenDepthRequest, t.lastTextureComponents = r, t.lastIndependentComponents = a, !0) : !1;
  }, i.updateShaders = (e, n, s) => {
    if (t.lastBoundBO = e, i.getNeedToRebuildShaders(e, n, s)) {
      const r = {
        Vertex: null,
        Fragment: null,
        Geometry: null
      };
      i.buildShaders(r, n, s);
      const a = t._openGLRenderWindow.getShaderCache().readyShaderProgramArray(r.Vertex, r.Fragment, r.Geometry);
      if (!a)
        return Gp("Error compiling image mapper shader program."), e.setProgram(null), !1;
      a !== e.getProgram() && (e.setProgram(a), e.getVAO().releaseGraphicsResources()), e.getShaderSourceTime().modified();
    } else if (!t._openGLRenderWindow.getShaderCache().readyShaderProgram(e.getProgram()))
      return MO("Unable to bind existing image mapper shader program; marking program for rebuild."), e.setProgram(null), !1;
    return e.getVAO().bind(), i.setMapperShaderParameters(e, n, s), i.setCameraShaderParameters(e, n, s), i.setPropertyShaderParameters(e, n, s), !0;
  }, i.setMapperShaderParameters = (e, n, s) => {
    e.getCABO().getElementCount() && (t.VBOBuildTime > e.getAttributeUpdateTime().getMTime() || e.getShaderSourceTime().getMTime() > e.getAttributeUpdateTime().getMTime()) && (e.getProgram().isAttributeUsed("vertexMC") && (e.getVAO().addAttributeArray(e.getProgram(), e.getCABO(), "vertexMC", e.getCABO().getVertexOffset(), e.getCABO().getStride(), t.context.FLOAT, 3, t.context.FALSE) || Gp("Error setting vertexMC in shader VAO.")), e.getProgram().isAttributeUsed("tcoordMC") && e.getCABO().getTCoordOffset() && (e.getVAO().addAttributeArray(e.getProgram(), e.getCABO(), "tcoordMC", e.getCABO().getTCoordOffset(), e.getCABO().getStride(), t.context.FLOAT, e.getCABO().getTCoordComponents(), t.context.FALSE) || Gp("Error setting tcoordMC in shader VAO.")), e.getAttributeUpdateTime().modified());
    const r = t.openGLTexture.getTextureUnit();
    e.getProgram().setUniformi("texture1", r);
    const a = t.openGLTexture.getComponents(), o = s.getProperty().getIndependentComponents();
    if (o)
      for (let p = 0; p < a; p++)
        e.getProgram().setUniformf(`mix${p}`, s.getProperty().getComponentWeight(p));
    const l = t.openGLTexture.getShiftAndScale();
    for (let p = 0; p < a; p++) {
      let m = s.getProperty().getColorWindow(), b = s.getProperty().getColorLevel();
      const y = o ? p : 0, Z = s.getProperty().getRGBTransferFunction(y);
      if (Z && s.getProperty().getUseLookupTableScalarRange()) {
        const T = Z.getRange();
        m = T[1] - T[0], b = 0.5 * (T[1] + T[0]);
      }
      const g = l.scale / m, f = (l.shift - b) / m + 0.5;
      e.getProgram().setUniformf(`cshift${p}`, f), e.getProgram().setUniformf(`cscale${p}`, g);
    }
    for (let p = 0; p < a; p++) {
      let m = 1, b = 0;
      const y = o ? p : 0, Z = s.getProperty().getPiecewiseFunction(y);
      if (Z) {
        const g = Z.getRange(), f = g[1] - g[0], T = 0.5 * (g[0] + g[1]);
        m = l.scale / f, b = (l.shift - T) / f + 0.5;
      }
      e.getProgram().setUniformf(`pwfshift${p}`, b), e.getProgram().setUniformf(`pwfscale${p}`, m);
    }
    if (t.haveSeenDepthRequest && e.getProgram().setUniformi("depthRequest", t.renderDepth ? 1 : 0), e.getProgram().isUniformUsed("coffset")) {
      const p = i.getCoincidentParameters(n, s);
      e.getProgram().setUniformf("coffset", p.offset), e.getProgram().isUniformUsed("cfactor") && e.getProgram().setUniformf("cfactor", p.factor);
    }
    const c = t.colorTexture.getTextureUnit();
    e.getProgram().setUniformi("colorTexture1", c);
    const u = t.pwfTexture.getTextureUnit();
    e.getProgram().setUniformi("pwfTexture1", u);
    const d = t.labelOutlineThicknessTexture.getTextureUnit();
    if (e.getProgram().setUniformi("labelOutlineTexture1", d), t.renderable.getNumberOfClippingPlanes()) {
      let p = t.renderable.getNumberOfClippingPlanes();
      p > 6 && (Zn("OpenGL has a limit of 6 clipping planes"), p = 6);
      const b = e.getCABO().getCoordShiftAndScaleEnabled() ? e.getCABO().getInverseShiftAndScaleMatrix() : null, y = b ? ut.copy(t.imagematinv, s.getMatrix()) : s.getMatrix();
      b && (ut.transpose(y, y), ut.multiply(y, y, b), ut.transpose(y, y)), ut.transpose(t.imagemat, t.currentInput.getIndexToWorld()), ut.multiply(t.imagematinv, y, t.imagemat);
      const Z = [];
      for (let g = 0; g < p; g++) {
        const f = [];
        t.renderable.getClippingPlaneInDataCoords(t.imagematinv, g, f);
        for (let T = 0; T < 4; T++)
          Z.push(f[T]);
      }
      e.getProgram().setUniformi("numClipPlanes", p), e.getProgram().setUniform4fv("clipPlanes", Z);
    }
    if (s.getProperty().getUseLabelOutline() === !0) {
      const p = s.getProperty().getLabelOutlineOpacity();
      e.getProgram().setUniformf("outlineOpacity", p);
    }
  }, i.setCameraShaderParameters = (e, n, s) => {
    const r = e.getProgram(), a = t.openGLImageSlice.getKeyMatrices(), o = t.currentInput, l = o.getIndexToWorld();
    ut.multiply(t.imagemat, a.mcwc, l);
    const c = t.openGLCamera.getKeyMatrices(n);
    if (ut.multiply(t.imagemat, c.wcpc, t.imagemat), e.getCABO().getCoordShiftAndScaleEnabled()) {
      const d = e.getCABO().getInverseShiftAndScaleMatrix();
      ut.multiply(t.imagemat, t.imagemat, d);
    }
    if (r.setUniformMatrix("MCPCMatrix", t.imagemat), s.getProperty().getUseLabelOutline() === !0) {
      const d = o.getWorldToIndex(), h = o.getDimensions();
      r.setUniform3i("imageDimensions", h[0], h[1], 1), r.setUniformMatrix("vWCtoIDX", d);
      const p = t.openGLCamera.getKeyMatrices(n);
      ut.invert(t.projectionToWorld, p.wcpc), t.openGLCamera.getKeyMatrices(n), r.setUniformMatrix("PCWCMatrix", t.projectionToWorld);
      const m = i.getRenderTargetSize();
      r.setUniformf("vpWidth", m[0]), r.setUniformf("vpHeight", m[1]);
      const b = i.getRenderTargetOffset();
      r.setUniformf("vpOffsetX", b[0] / m[0]), r.setUniformf("vpOffsetY", b[1] / m[1]);
    }
  }, i.setPropertyShaderParameters = (e, n, s) => {
    const r = e.getProgram(), o = s.getProperty().getOpacity();
    r.setUniformf("opacity", o);
  }, i.renderPieceStart = (e, n) => {
    i.updateBufferObjects(e, n), t.lastBoundBO = null;
  }, i.renderPieceDraw = (e, n) => {
    const s = t.context;
    t.openGLTexture.activate(), t.colorTexture.activate(), t.labelOutlineThicknessTexture.activate(), t.pwfTexture.activate(), t.tris.getCABO().getElementCount() && (i.updateShaders(t.tris, e, n) ? (s.drawArrays(s.TRIANGLES, 0, Number(t.tris.getCABO().getElementCount())), t.tris.getVAO().release()) : MO("Skipping image mapper draw because shader update failed.")), t.openGLTexture.deactivate(), t.colorTexture.deactivate(), t.labelOutlineThicknessTexture.deactivate(), t.pwfTexture.deactivate();
  }, i.renderPieceFinish = (e, n) => {
  }, i.renderPiece = (e, n) => {
    if (i.invokeEvent({
      type: "StartEvent"
    }), t.renderable.update(), t.currentInput = t.renderable.getCurrentImage(), i.invokeEvent({
      type: "EndEvent"
    }), !t.currentInput) {
      Gp("No input!");
      return;
    }
    i.renderPieceStart(e, n), i.renderPieceDraw(e, n), i.renderPieceFinish(e, n);
  }, i.computeBounds = (e, n) => {
    if (!i.getInput()) {
      Lg(t.bounds);
      return;
    }
    t.bounds = i.getInput().getBounds();
  }, i.updateBufferObjects = (e, n) => {
    i.getNeedToRebuildBufferObjects(e, n) && i.buildBufferObjects(e, n);
  }, i.getNeedToRebuildBufferObjects = (e, n) => t.VBOBuildTime.getMTime() < i.getMTime() || t.VBOBuildTime.getMTime() < n.getMTime() || t.VBOBuildTime.getMTime() < t.renderable.getMTime() || t.VBOBuildTime.getMTime() < n.getProperty().getMTime() || t.VBOBuildTime.getMTime() < t.currentInput.getMTime(), i.buildBufferObjects = (e, n) => {
    var C, R;
    const s = t.currentInput;
    if (!s)
      return;
    const r = s.getPointData() && s.getPointData().getScalars();
    if (!r)
      return;
    const a = r.getDataType(), o = r.getNumberOfComponents(), l = n.getProperty(), c = l.getInterpolationType(), u = l.getIndependentComponents(), d = u ? o : 1, h = u ? 2 * d : 1, p = l.getRGBTransferFunction(), m = NO(l, p, d), b = t._openGLRenderWindow.getGraphicsResourceForObject(p);
    if (!(b != null && b.vtkObj) || (b == null ? void 0 : b.hash) !== m || t.colorTextureString !== m) {
      const F = 1024 * h * 3, P = new Uint8ClampedArray(F);
      if (t.colorTexture || (t.colorTexture = bs.newInstance({
        resizable: !0
      }), t.colorTexture.setOpenGLRenderWindow(t._openGLRenderWindow)), c === d0.NEAREST ? (t.colorTexture.setMinificationFilter(Qe.NEAREST), t.colorTexture.setMagnificationFilter(Qe.NEAREST)) : (t.colorTexture.setMinificationFilter(Qe.LINEAR), t.colorTexture.setMagnificationFilter(Qe.LINEAR)), p) {
        const j = new Float32Array(3072);
        for (let H = 0; H < d; H++) {
          const B = l.getRGBTransferFunction(H), $ = B.getRange();
          if (B.getTable($[0], $[1], 1024, j, 1), u)
            for (let A = 0; A < 1024 * 3; A++)
              P[H * 1024 * 6 + A] = 255 * j[A], P[H * 1024 * 6 + A + 1024 * 3] = 255 * j[A];
          else
            for (let A = 0; A < 1024 * 3; A++)
              P[H * 1024 * 6 + A] = 255 * j[A];
        }
        t.colorTexture.releaseGraphicsResources(t._openGLRenderWindow), t.colorTexture.resetFormatAndType(), t.colorTexture.create2DFromRaw(1024, h, 3, Ke.UNSIGNED_CHAR, P);
      } else {
        for (let j = 0; j < 1024 * 3; ++j)
          P[j] = 255 * j / (1023 * 3), P[j + 1] = 255 * j / (1023 * 3), P[j + 2] = 255 * j / (1023 * 3);
        t.colorTexture.create2DFromRaw(1024, 1, 3, Ke.UNSIGNED_CHAR, P);
      }
      t.colorTextureString = m, p && t._openGLRenderWindow.setGraphicsResourceForObject(p, t.colorTexture, t.colorTextureString);
    } else
      t.colorTexture = b.vtkObj, t.colorTextureString = b.hash;
    const Z = l.getPiecewiseFunction(), g = NO(l, Z, d), f = t._openGLRenderWindow.getGraphicsResourceForObject(Z);
    if (!(f != null && f.vtkObj) || (f == null ? void 0 : f.hash) !== g || t.pwfTextureString !== g) {
      const F = 1024 * h, P = new Uint8ClampedArray(F);
      if (t.pwfTexture || (t.pwfTexture = bs.newInstance({
        resizable: !0
      }), t.pwfTexture.setOpenGLRenderWindow(t._openGLRenderWindow)), c === d0.NEAREST ? (t.pwfTexture.setMinificationFilter(Qe.NEAREST), t.pwfTexture.setMagnificationFilter(Qe.NEAREST)) : (t.pwfTexture.setMinificationFilter(Qe.LINEAR), t.pwfTexture.setMagnificationFilter(Qe.LINEAR)), Z) {
        const j = new Float32Array(F), H = new Float32Array(1024);
        for (let B = 0; B < d; ++B) {
          const $ = l.getPiecewiseFunction(B);
          if ($ === null)
            j.fill(1);
          else {
            const A = $.getRange();
            if ($.getTable(A[0], A[1], 1024, H, 1), u)
              for (let E = 0; E < 1024; E++)
                j[B * 1024 * 2 + E] = H[E], j[B * 1024 * 2 + E + 1024] = H[E];
            else
              for (let E = 0; E < 1024; E++)
                j[B * 1024 * 2 + E] = H[E];
          }
        }
        t.pwfTexture.releaseGraphicsResources(t._openGLRenderWindow), t.pwfTexture.resetFormatAndType(), t.pwfTexture.create2DFromRaw(1024, h, 1, Ke.FLOAT, j);
      } else
        P.fill(255), t.pwfTexture.create2DFromRaw(1024, 1, 1, Ke.UNSIGNED_CHAR, P);
      t.pwfTextureString = g, Z && t._openGLRenderWindow.setGraphicsResourceForObject(Z, t.pwfTexture, t.pwfTextureString);
    } else
      t.pwfTexture = f.vtkObj, t.pwfTextureString = f.hash;
    i.updatelabelOutlineThicknessTexture(n);
    const {
      ijkMode: M
    } = t.renderable.getClosestIJKAxis();
    let N = t.renderable.getSlice();
    M !== t.renderable.getSlicingMode() && (N = t.renderable.getSliceAtPosition(N));
    const W = t.renderable.isA("vtkImageArrayMapper") ? t.renderable.getSubSlice() : Math.round(N), x = s.getExtent();
    let V;
    M === cl.I && (V = W - x[0]), M === cl.J && (V = W - x[2]), (M === cl.K || M === cl.NONE) && (V = W - x[4]);
    const X = `${N}A${s.getMTime()}A${r.getMTime()}B${i.getMTime()}C${t.renderable.getSlicingMode()}D${n.getProperty().getInterpolationType()}`;
    if (t.VBOBuildString !== X) {
      const z = s.getDimensions();
      t.openGLTexture || (t.openGLTexture = bs.newInstance({
        resizable: !0
      }), t.openGLTexture.setOpenGLRenderWindow(t._openGLRenderWindow)), t.openGLTexture.setOglNorm16Ext(t.context.getExtension("EXT_texture_norm16")), c === d0.NEAREST ? ((/* @__PURE__ */ new Set([1, 3, 4])).has(o) && a === Ke.UNSIGNED_CHAR && !u && t.openGLTexture.setGenerateMipmap(!0), t.openGLTexture.setMinificationFilter(Qe.NEAREST), t.openGLTexture.setMagnificationFilter(Qe.NEAREST)) : (o === 4 && a === Ke.UNSIGNED_CHAR && !u ? (t.openGLTexture.setGenerateMipmap(!0), t.openGLTexture.setMinificationFilter(Qe.LINEAR_MIPMAP_LINEAR)) : t.openGLTexture.setMinificationFilter(Qe.LINEAR), t.openGLTexture.setMagnificationFilter(Qe.LINEAR)), t.openGLTexture.setWrapS(g2.CLAMP_TO_EDGE), t.openGLTexture.setWrapT(g2.CLAMP_TO_EDGE);
      const F = z[0] * z[1] * o, P = new Float32Array(12), j = new Float32Array(8);
      for (let Wt = 0; Wt < 4; Wt++)
        j[Wt * 2] = Wt % 2 ? 1 : 0, j[Wt * 2 + 1] = Wt > 1 ? 1 : 0;
      const H = [cl.X, cl.Y, cl.Z].includes(t.renderable.getSlicingMode()) ? N : W, B = s.getSpatialExtent(), $ = r.getData();
      let A = null;
      if (M === cl.I) {
        A = new $.constructor(z[2] * z[1] * o);
        let Wt = 0;
        for (let Zt = 0; Zt < z[2]; Zt++)
          for (let Gt = 0; Gt < z[1]; Gt++) {
            let Tt = (V + Gt * z[0] + Zt * z[0] * z[1]) * o;
            Wt = (Zt * z[1] + Gt) * o;
            const Q = Tt + o;
            for (; Tt < Q; )
              A[Wt++] = $[Tt++];
          }
        z[0] = z[1], z[1] = z[2], P[0] = H, P[1] = B[2], P[2] = B[4], P[3] = H, P[4] = B[3], P[5] = B[4], P[6] = H, P[7] = B[2], P[8] = B[5], P[9] = H, P[10] = B[3], P[11] = B[5];
      } else if (M === cl.J) {
        A = new $.constructor(z[2] * z[0] * o);
        let Wt = 0;
        for (let Zt = 0; Zt < z[2]; Zt++)
          for (let Gt = 0; Gt < z[0]; Gt++) {
            let Tt = (Gt + V * z[0] + Zt * z[0] * z[1]) * o;
            Wt = (Zt * z[0] + Gt) * o;
            const Q = Tt + o;
            for (; Tt < Q; )
              A[Wt++] = $[Tt++];
          }
        z[1] = z[2], P[0] = B[0], P[1] = H, P[2] = B[4], P[3] = B[1], P[4] = H, P[5] = B[4], P[6] = B[0], P[7] = H, P[8] = B[5], P[9] = B[1], P[10] = H, P[11] = B[5];
      } else M === cl.K || M === cl.NONE ? (A = $.subarray(V * F, (V + 1) * F), P[0] = B[0], P[1] = B[2], P[2] = H, P[3] = B[1], P[4] = B[2], P[5] = H, P[6] = B[0], P[7] = B[3], P[8] = H, P[9] = B[1], P[10] = B[3], P[11] = H) : Gp("Reformat slicing not yet supported.");
      const E = t._openGLRenderWindow.getGraphicsResourceForObject(A);
      E != null && E.vtkObj ? (t.openGLTexture = E.vtkObj, t.VBOBuildString = E.hash) : (t._scalars !== A && (t._openGLRenderWindow.releaseGraphicsResourcesForObject(t._scalars), t._scalars = A), t.openGLTexture.resetFormatAndType(), t.openGLTexture.create2DFilterableFromRaw(z[0], z[1], o, r.getDataType(), A, (R = (C = t.renderable).getPreferSizeOverAccuracy) == null ? void 0 : R.call(C)), t._openGLRenderWindow.setGraphicsResourceForObject(A, t.openGLTexture, t.VBOBuildString)), t.openGLTexture.activate(), t.openGLTexture.sendParameters(), t.openGLTexture.deactivate();
      const ct = We.newInstance({
        numberOfComponents: 3,
        values: P
      });
      ct.setName("points");
      const at = We.newInstance({
        numberOfComponents: 2,
        values: j
      });
      at.setName("tcoords");
      const dt = new Uint16Array(8);
      dt[0] = 3, dt[1] = 0, dt[2] = 1, dt[3] = 3, dt[4] = 3, dt[5] = 0, dt[6] = 3, dt[7] = 2;
      const gt = We.newInstance({
        numberOfComponents: 1,
        values: dt
      });
      t.tris.getCABO().createVBO(gt, "polys", Vn.SURFACE, {
        points: ct,
        tcoords: at,
        cellOffset: 0
      }), t.VBOBuildTime.modified(), t.VBOBuildString = X;
    }
  }, i.updatelabelOutlineThicknessTexture = (e) => {
    t.labelOutlineThicknessTexture || (t.labelOutlineThicknessTexture = bs.newInstance({
      resizable: !1
    }), t.labelOutlineThicknessTexture.setOpenGLRenderWindow(t._openGLRenderWindow));
    const n = e.getProperty().getLabelOutlineThickness(), s = t._openGLRenderWindow.getGraphicsResourceForObject(n), r = `${n.join("-")}`;
    if (!(s != null && s.vtkObj) || (s == null ? void 0 : s.hash) !== r || t.labelOutlineThicknessTextureString !== r) {
      const u = new Uint8Array(1024);
      for (let d = 0; d < 1024; ++d) {
        const h = n[d] || n[0];
        u[d] = h;
      }
      t.labelOutlineThicknessTexture.releaseGraphicsResources(t._openGLRenderWindow), t.labelOutlineThicknessTexture.resetFormatAndType(), t.labelOutlineThicknessTexture.setMinificationFilter(Qe.NEAREST), t.labelOutlineThicknessTexture.setMagnificationFilter(Qe.NEAREST), t.labelOutlineThicknessTexture.create2DFromRaw(1024, 1, 1, Ke.UNSIGNED_CHAR, u), t.labelOutlineThicknessTextureString = r, n && t._openGLRenderWindow.setGraphicsResourceForObject(n, t.labelOutlineThicknessTexture, t.labelOutlineThicknessTextureString);
    } else
      t.labelOutlineThicknessTexture = s.vtkObj, t.labelOutlineThicknessTextureString = s.hash;
  }, i.getRenderTargetSize = () => {
    if (t._useSmallViewport)
      return [t._smallViewportWidth, t._smallViewportHeight];
    const {
      usize: e,
      vsize: n
    } = t._openGLRenderer.getTiledSizeAndOrigin();
    return [e, n];
  }, i.getRenderTargetOffset = () => {
    const {
      lowerLeftU: e,
      lowerLeftV: n
    } = t._openGLRenderer.getTiledSizeAndOrigin();
    return [e, n];
  };
}
const Wlt = {
  VBOBuildTime: 0,
  VBOBuildString: null,
  openGLTexture: null,
  tris: null,
  imagemat: null,
  imagematinv: null,
  colorTexture: null,
  pwfTexture: null,
  labelOutlineThicknessTexture: null,
  labelOutlineThicknessTextureString: null,
  lastHaveSeenDepthRequest: !1,
  haveSeenDepthRequest: !1,
  lastTextureComponents: 0,
  _scalars: null
};
function Glt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Wlt, e), ui.extend(i, t, e), kc.implementReplaceShaderCoincidentOffset(i, t, e), kc.implementBuildShadersWithReplacements(i, t, e), t.tris = Jc.newInstance(), t.imagemat = ut.identity(new Float64Array(16)), t.imagematinv = ut.identity(new Float64Array(16)), t.projectionToWorld = ut.identity(new Float64Array(16)), t.idxToView = ut.identity(new Float64Array(16)), t.idxNormalMatrix = gi.identity(new Float64Array(9)), t.modelToView = ut.identity(new Float64Array(16)), t.projectionToView = ut.identity(new Float64Array(16)), gs(i, t, []), t.VBOBuildTime = {}, xi(t.VBOBuildTime), Nlt(i, t);
}
const wlt = In(Glt, "vtkOpenGLImageMapper");
Js("vtkAbstractImageMapper", wlt);
const wp = {
  MAX: 0,
  MIN: 1,
  AVERAGE: 2
}, {
  vtkErrorMacro: aM
} = tt;
function WO(i, t, e) {
  if (t.apply(i)) {
    const s = i.getIndependentComponents();
    return `${i.getMTime()}-${s}-${e}`;
  }
  return "0";
}
function xlt(i, t) {
  t.classHierarchy.push("vtkOpenGLImageCPRMapper"), i.buildPass = (e) => {
    e && (t.currentRenderPass = null, t.openGLImageSlice = i.getFirstAncestorOfType("vtkOpenGLImageSlice"), t._openGLRenderer = i.getFirstAncestorOfType("vtkOpenGLRenderer"), t._openGLRenderWindow = t._openGLRenderer.getParent(), t.context = t._openGLRenderWindow.getContext(), t.openGLCamera = t._openGLRenderer.getViewNodeFor(t._openGLRenderer.getRenderable().getActiveCamera()), t.tris.setOpenGLRenderWindow(t._openGLRenderWindow), t.volumeTexture.setOpenGLRenderWindow(t._openGLRenderWindow), t.colorTexture.setOpenGLRenderWindow(t._openGLRenderWindow), t.pwfTexture.setOpenGLRenderWindow(t._openGLRenderWindow));
  }, i.opaquePass = (e, n) => {
    e && (t.currentRenderPass = n, i.render());
  }, i.opaqueZBufferPass = (e) => {
    e && (t.haveSeenDepthRequest = !0, t.renderDepth = !0, i.render(), t.renderDepth = !1);
  }, i.getCoincidentParameters = (e, n) => t.renderable.getResolveCoincidentTopology() ? t.renderable.getCoincidentTopologyPolygonOffsetParameters() : null, i.render = () => {
    const e = t.openGLImageSlice.getRenderable(), n = t._openGLRenderer.getRenderable();
    i.renderPiece(n, e);
  }, i.renderPiece = (e, n) => {
    i.invokeEvent({
      type: "StartEvent"
    }), t.renderable.update(), i.invokeEvent({
      type: "EndEvent"
    }), t.renderable.preRenderCheck() && (t.currentImageDataInput = t.renderable.getInputData(0), t.currentCenterlineInput = t.renderable.getOrientedCenterline(), i.renderPieceStart(e, n), i.renderPieceDraw(e, n), i.renderPieceFinish(e, n));
  }, i.renderPieceStart = (e, n) => {
    i.updateBufferObjects(e, n);
  }, i.renderPieceDraw = (e, n) => {
    const s = t.context;
    t.volumeTexture.activate(), t.colorTexture.activate(), t.pwfTexture.activate(), t.tris.getCABO().getElementCount() && (i.updateShaders(t.tris, e, n), s.drawArrays(s.TRIANGLES, 0, Number(t.tris.getCABO().getElementCount())), t.tris.getVAO().release()), t.volumeTexture.deactivate(), t.colorTexture.deactivate(), t.pwfTexture.deactivate();
  }, i.renderPieceFinish = (e, n) => {
  }, i.updateBufferObjects = (e, n) => {
    i.getNeedToRebuildBufferObjects(e, n) && i.buildBufferObjects(e, n);
  }, i.getNeedToRebuildBufferObjects = (e, n) => {
    const s = t.VBOBuildTime.getMTime();
    return s < i.getMTime() || s < t.renderable.getMTime() || s < n.getMTime() || s < t.currentImageDataInput.getMTime() || s < t.currentCenterlineInput.getMTime();
  }, i.buildBufferObjects = (e, n) => {
    const s = t.currentImageDataInput, r = t.currentCenterlineInput;
    n.getProperty().getInterpolationType() === d0.NEAREST ? (t.volumeTexture.setMinificationFilter(Qe.NEAREST), t.volumeTexture.setMagnificationFilter(Qe.NEAREST), t.colorTexture.setMinificationFilter(Qe.NEAREST), t.colorTexture.setMagnificationFilter(Qe.NEAREST), t.pwfTexture.setMinificationFilter(Qe.NEAREST), t.pwfTexture.setMagnificationFilter(Qe.NEAREST)) : (t.volumeTexture.setMinificationFilter(Qe.LINEAR), t.volumeTexture.setMagnificationFilter(Qe.LINEAR), t.colorTexture.setMinificationFilter(Qe.LINEAR), t.colorTexture.setMagnificationFilter(Qe.LINEAR), t.pwfTexture.setMinificationFilter(Qe.LINEAR), t.pwfTexture.setMagnificationFilter(Qe.LINEAR));
    const o = s.getMTime();
    if (t.volumeTextureTime !== o) {
      const y = s.getDimensions(), Z = s.getPointData().getScalars();
      if (!Z)
        return;
      t.volumeTexture.setOglNorm16Ext(t.context.getExtension("EXT_texture_norm16")), t.volumeTexture.releaseGraphicsResources(t._openGLRenderWindow), t.volumeTexture.resetFormatAndType(), t.volumeTexture.create3DFilterableFromRaw(y[0], y[1], y[2], Z.getNumberOfComponents(), Z.getDataType(), Z.getData(), t.renderable.getPreferSizeOverAccuracy()), t.volumeTextureTime = o;
    }
    const l = s.getPointData() && s.getPointData().getScalars();
    if (!l)
      return;
    const c = l.getNumberOfComponents(), u = n.getProperty(), d = u.getIndependentComponents(), h = d ? c : 1, p = d ? 2 * h : 1, m = WO(u, u.getRGBTransferFunction, h);
    if (t.colorTextureString !== m) {
      const Z = 1024 * p * 3, g = new Uint8ClampedArray(Z);
      let f = u.getRGBTransferFunction();
      if (f) {
        const T = new Float32Array(3072);
        for (let M = 0; M < h; M++) {
          f = u.getRGBTransferFunction(M);
          const N = f.getRange();
          if (f.getTable(N[0], N[1], 1024, T, 1), d)
            for (let W = 0; W < 1024 * 3; W++)
              g[M * 1024 * 6 + W] = 255 * T[W], g[M * 1024 * 6 + W + 1024 * 3] = 255 * T[W];
          else
            for (let W = 0; W < 1024 * 3; W++)
              g[M * 1024 * 6 + W] = 255 * T[W];
        }
        t.colorTexture.releaseGraphicsResources(t._openGLRenderWindow), t.colorTexture.resetFormatAndType(), t.colorTexture.create2DFromRaw(1024, p, 3, Ke.UNSIGNED_CHAR, g);
      } else {
        for (let T = 0; T < 1024 * 3; ++T)
          g[T] = 255 * T / (1023 * 3), g[T + 1] = 255 * T / (1023 * 3), g[T + 2] = 255 * T / (1023 * 3);
        t.colorTexture.create2DFromRaw(1024, 1, 3, Ke.UNSIGNED_CHAR, g);
      }
      t.colorTextureString = m;
    }
    const b = WO(u, u.getPiecewiseFunction, h);
    if (t.pwfTextureString !== b) {
      const Z = 1024 * p, g = new Uint8ClampedArray(Z);
      let f = u.getPiecewiseFunction();
      if (t.pwfTexture.releaseGraphicsResources(t._openGLRenderWindow), t.pwfTexture.resetFormatAndType(), f) {
        const T = new Float32Array(Z), M = new Float32Array(1024);
        for (let N = 0; N < h; ++N)
          if (f = u.getPiecewiseFunction(N), f === null)
            T.fill(1);
          else {
            const W = f.getRange();
            if (f.getTable(W[0], W[1], 1024, M, 1), d)
              for (let x = 0; x < 1024; x++)
                T[N * 1024 * 2 + x] = M[x], T[N * 1024 * 2 + x + 1024] = M[x];
            else
              for (let x = 0; x < 1024; x++)
                T[N * 1024 * 2 + x] = M[x];
          }
        t.pwfTexture.create2DFromRaw(1024, p, 1, Ke.FLOAT, T);
      } else
        g.fill(255), t.pwfTexture.create2DFromRaw(1024, 1, 1, Ke.UNSIGNED_CHAR, g);
      t.pwfTextureString = b;
    }
    if (t.VBOBuildTime.getMTime() < t.renderable.getMTime() || t.VBOBuildTime.getMTime() < r.getMTime()) {
      const y = r.getNumberOfPoints(), Z = y <= 1 ? 0 : y - 1, g = r.getDistancesToFirstPoint(), f = t.renderable.getHeight(), T = 4 * Z, M = new Float32Array(3 * T), N = t.renderable.getWidth();
      for (let B = 0, $ = 0; B < Z; ++B)
        M.set([0, f - g[B], 0], $), $ += 3, M.set([N, f - g[B], 0], $), $ += 3, M.set([N, f - g[B + 1], 0], $), $ += 3, M.set([0, f - g[B + 1], 0], $), $ += 3;
      const W = We.newInstance({
        numberOfComponents: 3,
        values: M
      });
      W.setName("points");
      const x = new Uint16Array(5 * Z);
      for (let B = 0, $ = 0, A = 0; B < Z; ++B)
        x.set([4, A + 3, A + 2, A + 1, A], $), $ += 5, A += 4;
      const V = We.newInstance({
        numberOfComponents: 1,
        values: x
      }), X = r.getPoints(), C = new Float32Array(3 * T), R = new Array(3), z = new Array(3);
      for (let B = 0, $ = 0; B < Z; ++B)
        X.getPoint(B, R), X.getPoint(B + 1, z), C.set(R, $), $ += 3, C.set(R, $), $ += 3, C.set(z, $), $ += 3, C.set(z, $), $ += 3;
      const F = We.newInstance({
        numberOfComponents: 3,
        values: C,
        name: "centerlinePosition"
      }), P = new Float32Array(T);
      for (let B = 0, $ = 0; B < Z; ++B)
        P.set([
          0,
          // Top left
          1,
          // Top right
          3,
          // Bottom right
          2
          // Bottom left
        ], $), $ += 4;
      const j = We.newInstance({
        numberOfComponents: 1,
        values: P,
        name: "quadIndex"
      }), H = [F, j];
      if (!t.renderable.getUseUniformOrientation()) {
        const B = t.renderable.getOrientedCenterline().getOrientations() ?? [], $ = new Float32Array(4 * T), A = new Float32Array(4 * T);
        for (let at = 0; at < Z; ++at) {
          const dt = B[at], gt = B[at + 1];
          for (let Wt = 0; Wt < 4; ++Wt) {
            const Gt = 4 * (Wt + 4 * at);
            $.set(dt, Gt), A.set(gt, Gt);
          }
        }
        const E = We.newInstance({
          numberOfComponents: 4,
          values: $,
          name: "centerlineTopOrientation"
        }), ct = We.newInstance({
          numberOfComponents: 4,
          values: A,
          name: "centerlineBotOrientation"
        });
        H.push(E, ct);
      }
      t.tris.getCABO().createVBO(V, "polys", Vn.SURFACE, {
        points: W,
        customAttributes: H
      }), t.VBOBuildTime.modified();
    }
  }, i.getNeedToRebuildShaders = (e, n, s) => {
    const r = t.volumeTexture.getComponents(), a = s.getProperty().getIndependentComponents(), o = !!t.renderable.getCenterPoint(), l = t.renderable.getUseUniformOrientation(), c = t.renderable.isProjectionEnabled() && t.renderable.getProjectionMode();
    return e.getProgram() === 0 || t.lastUseCenterPoint !== o || t.lastUseUniformOrientation !== l || t.lastProjectionMode !== c || t.lastHaveSeenDepthRequest !== t.haveSeenDepthRequest || t.lastTextureComponents !== r || t.lastIndependentComponents !== a ? (t.lastUseCenterPoint = o, t.lastUseUniformOrientation = l, t.lastProjectionMode = c, t.lastHaveSeenDepthRequest = t.haveSeenDepthRequest, t.lastTextureComponents = r, t.lastIndependentComponents = a, !0) : !1;
  }, i.buildShaders = (e, n, s) => {
    i.getShaderTemplate(e, n, s), i.replaceShaderValues(e, n, s);
  }, i.replaceShaderValues = (e, n, s) => {
    let r = e.Vertex, a = e.Fragment;
    const o = ["vec3 applyQuaternionToVec(vec4 q, vec3 v) {", "  float uvx = q.y * v.z - q.z * v.y;", "  float uvy = q.z * v.x - q.x * v.z;", "  float uvz = q.x * v.y - q.y * v.x;", "  float uuvx = q.y * uvz - q.z * uvy;", "  float uuvy = q.z * uvx - q.x * uvz;", "  float uuvz = q.x * uvy - q.y * uvx;", "  float w2 = q.w * 2.0;", "  uvx *= w2;", "  uvy *= w2;", "  uvz *= w2;", "  uuvx *= 2.0;", "  uuvy *= 2.0;", "  uuvz *= 2.0;", "  return vec3(v.x + uvx + uuvx, v.y + uvy + uuvy, v.z + uvz + uuvz);", "}"];
    r = Ft.substitute(r, "//VTK::Camera::Dec", ["uniform mat4 MCPCMatrix;"]).result, r = Ft.substitute(r, "//VTK::PositionVC::Impl", ["  gl_Position = MCPCMatrix * vertexMC;"]).result;
    const l = ["attribute vec3 centerlinePosition;", "attribute float quadIndex;", "uniform float width;", "out vec2 quadOffsetVSOutput;", "out vec3 centerlinePosVSOutput;"], c = t.renderable.isProjectionEnabled(), u = t.renderable.getUseUniformOrientation();
    u ? (l.push("out vec3 samplingDirVSOutput;", "uniform vec4 centerlineOrientation;", "uniform vec3 tangentDirection;", ...o), c && l.push("out vec3 projectionDirVSOutput;", "uniform vec3 bitangentDirection;")) : l.push("out vec4 centerlineTopOrientationVSOutput;", "out vec4 centerlineBotOrientationVSOutput;", "attribute vec4 centerlineTopOrientation;", "attribute vec4 centerlineBotOrientation;"), r = Ft.substitute(r, "//VTK::Color::Dec", l).result;
    const d = [
      // quadOffsetVSOutput.x: left = -0.5* width; right = 0.5 * width
      // quadOffsetVSOutput.y: bottom = 0.0; top = 1.0;
      "quadOffsetVSOutput = vec2(width * (mod(quadIndex, 2.0) == 0.0 ? -0.5 : 0.5), quadIndex > 1.0 ? 0.0 : 1.0);",
      "centerlinePosVSOutput = centerlinePosition;"
    ];
    u ? (d.push("samplingDirVSOutput = applyQuaternionToVec(centerlineOrientation, tangentDirection);"), c && d.push("projectionDirVSOutput = applyQuaternionToVec(centerlineOrientation, bitangentDirection);")) : d.push("centerlineTopOrientationVSOutput = centerlineTopOrientation;", "centerlineBotOrientationVSOutput = centerlineBotOrientation;"), r = Ft.substitute(r, "//VTK::Color::Impl", d).result;
    const h = t.volumeTexture.getComponents(), p = s.getProperty().getIndependentComponents();
    let m = [
      // used to compute texture coordinates of the sample
      "uniform mat4 MCTCMatrix; // Model coordinates to texture coordinates",
      "in vec2 quadOffsetVSOutput;",
      "in vec3 centerlinePosVSOutput;",
      // volume texture
      "uniform highp sampler3D volumeTexture;",
      // color and pwf textures
      "uniform sampler2D colorTexture1;",
      "uniform sampler2D pwfTexture1;",
      // opacity
      "uniform float opacity;",
      // background color (out of volume samples)
      "uniform vec4 backgroundColor;",
      // color shift and scale
      "uniform float cshift0;",
      "uniform float cscale0;",
      // weighting shift and scale
      "uniform float pwfshift0;",
      "uniform float pwfscale0;"
    ];
    c && m.push("uniform vec3 volumeSizeMC;", "uniform int projectionSlabNumberOfSamples;", "uniform float projectionConstantOffset;", "uniform float projectionStepLength;"), u ? (m.push("in vec3 samplingDirVSOutput;"), c && m.push("in vec3 projectionDirVSOutput;")) : (m.push("uniform vec3 tangentDirection;", "in vec4 centerlineTopOrientationVSOutput;", "in vec4 centerlineBotOrientationVSOutput;", ...o), c && m.push("uniform vec3 bitangentDirection;"));
    const b = t.renderable.getCenterPoint();
    if (b && m.push("uniform vec3 globalCenterPoint;"), p) {
      for (let Z = 1; Z < h; Z++)
        m = m.concat([
          // color shift and scale
          `uniform float cshift${Z};`,
          `uniform float cscale${Z};`,
          // weighting shift and scale
          `uniform float pwfshift${Z};`,
          `uniform float pwfscale${Z};`
        ]);
      switch (h) {
        case 1:
          m = m.concat(["uniform float mix0;", "#define height0 0.5"]);
          break;
        case 2:
          m = m.concat(["uniform float mix0;", "uniform float mix1;", "#define height0 0.25", "#define height1 0.75"]);
          break;
        case 3:
          m = m.concat(["uniform float mix0;", "uniform float mix1;", "uniform float mix2;", "#define height0 0.17", "#define height1 0.5", "#define height2 0.83"]);
          break;
        case 4:
          m = m.concat(["uniform float mix0;", "uniform float mix1;", "uniform float mix2;", "uniform float mix3;", "#define height0 0.125", "#define height1 0.375", "#define height2 0.625", "#define height3 0.875"]);
          break;
        default:
          aM("Unsupported number of independent coordinates.");
      }
    }
    a = Ft.substitute(a, "//VTK::TCoord::Dec", m).result;
    let y = [];
    if (u ? (y.push("vec3 samplingDirection = samplingDirVSOutput;"), c && y.push("vec3 projectionDirection = projectionDirVSOutput;")) : (y.push(
      // Slerp / Lerp
      "vec4 q0 = centerlineBotOrientationVSOutput;",
      "vec4 q1 = centerlineTopOrientationVSOutput;",
      "float qCosAngle = dot(q0, q1);",
      "vec4 interpolatedOrientation;",
      "if (qCosAngle > 0.999 || qCosAngle < -0.999) {",
      "  // Use LERP instead of SLERP when the two quaternions are close or opposite",
      "  interpolatedOrientation = normalize(mix(q0, q1, quadOffsetVSOutput.y));",
      "} else {",
      "  float omega = acos(qCosAngle);",
      "  interpolatedOrientation = normalize(sin((1.0 - quadOffsetVSOutput.y) * omega) * q0 + sin(quadOffsetVSOutput.y * omega) * q1);",
      "}",
      "vec3 samplingDirection = applyQuaternionToVec(interpolatedOrientation, tangentDirection);"
    ), c && y.push("vec3 projectionDirection = applyQuaternionToVec(interpolatedOrientation, bitangentDirection);")), b ? y.push("float baseOffset = dot(samplingDirection, globalCenterPoint - centerlinePosVSOutput);", "float horizontalOffset = quadOffsetVSOutput.x + baseOffset;") : y.push("float horizontalOffset = quadOffsetVSOutput.x;"), y.push("vec3 volumePosMC = centerlinePosVSOutput + horizontalOffset * samplingDirection;", "vec3 volumePosTC = (MCTCMatrix * vec4(volumePosMC, 1.0)).xyz;", "if (any(lessThan(volumePosTC, vec3(0.0))) || any(greaterThan(volumePosTC, vec3(1.0))))", "{", "  // set the background color and exit", "  gl_FragData[0] = backgroundColor;", "  return;", "}"), c) {
      const Z = t.renderable.getProjectionMode();
      switch (Z) {
        case wp.MIN:
          y.push("const vec4 initialProjectionTextureValue = vec4(1.0);");
          break;
        case wp.MAX:
        case wp.AVERAGE:
        default:
          y.push("const vec4 initialProjectionTextureValue = vec4(0.0);");
          break;
      }
      switch (y.push("vec3 projectionScaledDirection = projectionDirection / volumeSizeMC;", "vec3 projectionStep = projectionStepLength * projectionScaledDirection;", "vec3 projectionStartPosition = volumePosTC + projectionConstantOffset * projectionScaledDirection;", "vec4 tvalue = initialProjectionTextureValue;", "for (int projectionSampleIdx = 0; projectionSampleIdx < projectionSlabNumberOfSamples; ++projectionSampleIdx) {", "  vec3 projectionSamplePosition = projectionStartPosition + float(projectionSampleIdx) * projectionStep;", "  vec4 sampledTextureValue = texture(volumeTexture, projectionSamplePosition);"), Z) {
        case wp.MAX:
          y.push("  tvalue = max(tvalue, sampledTextureValue);");
          break;
        case wp.MIN:
          y.push("  tvalue = min(tvalue, sampledTextureValue);");
          break;
        case wp.AVERAGE:
        default:
          y.push("  tvalue = tvalue + sampledTextureValue;");
          break;
      }
      y.push("}"), Z === wp.AVERAGE && y.push("tvalue = tvalue / float(projectionSlabNumberOfSamples);");
    } else
      y.push("vec4 tvalue = texture(volumeTexture, volumePosTC);");
    if (p) {
      const Z = ["r", "g", "b", "a"];
      for (let g = 0; g < h; ++g)
        y = y.concat([`vec3 tcolor${g} = mix${g} * texture2D(colorTexture1, vec2(tvalue.${Z[g]} * cscale${g} + cshift${g}, height${g})).rgb;`, `float compWeight${g} = mix${g} * texture2D(pwfTexture1, vec2(tvalue.${Z[g]} * pwfscale${g} + pwfshift${g}, height${g})).r;`]);
      switch (h) {
        case 1:
          y = y.concat(["gl_FragData[0] = vec4(tcolor0.rgb, compWeight0 * opacity);"]);
          break;
        case 2:
          y = y.concat(["float weightSum = compWeight0 + compWeight1;", "gl_FragData[0] = vec4(vec3((tcolor0.rgb * (compWeight0 / weightSum)) + (tcolor1.rgb * (compWeight1 / weightSum))), opacity);"]);
          break;
        case 3:
          y = y.concat(["float weightSum = compWeight0 + compWeight1 + compWeight2;", "gl_FragData[0] = vec4(vec3((tcolor0.rgb * (compWeight0 / weightSum)) + (tcolor1.rgb * (compWeight1 / weightSum)) + (tcolor2.rgb * (compWeight2 / weightSum))), opacity);"]);
          break;
        case 4:
          y = y.concat(["float weightSum = compWeight0 + compWeight1 + compWeight2 + compWeight3;", "gl_FragData[0] = vec4(vec3((tcolor0.rgb * (compWeight0 / weightSum)) + (tcolor1.rgb * (compWeight1 / weightSum)) + (tcolor2.rgb * (compWeight2 / weightSum)) + (tcolor3.rgb * (compWeight3 / weightSum))), opacity);"]);
          break;
        default:
          aM("Unsupported number of independent coordinates.");
      }
    } else
      switch (h) {
        case 1:
          y = y.concat(["// Dependent components", "float intensity = tvalue.r;", "vec3 tcolor = texture2D(colorTexture1, vec2(intensity * cscale0 + cshift0, 0.5)).rgb;", "float scalarOpacity = texture2D(pwfTexture1, vec2(intensity * pwfscale0 + pwfshift0, 0.5)).r;", "gl_FragData[0] = vec4(tcolor, scalarOpacity * opacity);"]);
          break;
        case 2:
          y = y.concat(["float intensity = tvalue.r*cscale0 + cshift0;", "gl_FragData[0] = vec4(texture2D(colorTexture1, vec2(intensity, 0.5)).rgb, pwfscale0*tvalue.g + pwfshift0);"]);
          break;
        case 3:
          y = y.concat(["vec4 tcolor = cscale0*tvalue + cshift0;", "gl_FragData[0] = vec4(texture2D(colorTexture1, vec2(tcolor.r,0.5)).r,", "  texture2D(colorTexture1, vec2(tcolor.g,0.5)).r,", "  texture2D(colorTexture1, vec2(tcolor.b,0.5)).r, opacity);"]);
          break;
        default:
          y = y.concat(["vec4 tcolor = cscale0*tvalue + cshift0;", "gl_FragData[0] = vec4(texture2D(colorTexture1, vec2(tcolor.r,0.5)).r,", "  texture2D(colorTexture1, vec2(tcolor.g,0.5)).r,", "  texture2D(colorTexture1, vec2(tcolor.b,0.5)).r, tcolor.a);"]);
      }
    a = Ft.substitute(a, "//VTK::TCoord::Impl", y).result, t.haveSeenDepthRequest && (a = Ft.substitute(a, "//VTK::ZBuffer::Dec", "uniform int depthRequest;").result, a = Ft.substitute(a, "//VTK::ZBuffer::Impl", ["if (depthRequest == 1) {", "float iz = floor(gl_FragCoord.z*65535.0 + 0.1);", "float rf = floor(iz/256.0)/255.0;", "float gf = mod(iz,256.0)/255.0;", "gl_FragData[0] = vec4(rf, gf, 0.0, 1.0); }"]).result), e.Vertex = r, e.Fragment = a, i.replaceShaderClip(e, n, s), i.replaceShaderCoincidentOffset(e, n, s);
  }, i.replaceShaderClip = (e, n, s) => {
    let r = e.Vertex, a = e.Fragment;
    if (t.renderable.getNumberOfClippingPlanes()) {
      let o = t.renderable.getNumberOfClippingPlanes();
      o > 6 && (tt.vtkErrorMacro("OpenGL has a limit of 6 clipping planes"), o = 6), r = Ft.substitute(r, "//VTK::Clip::Dec", ["uniform int numClipPlanes;", "uniform vec4 clipPlanes[6];", "varying float clipDistancesVSOutput[6];"]).result, r = Ft.substitute(r, "//VTK::Clip::Impl", ["for (int planeNum = 0; planeNum < 6; planeNum++)", "    {", "    if (planeNum >= numClipPlanes)", "        {", "        break;", "        }", "    clipDistancesVSOutput[planeNum] = dot(clipPlanes[planeNum], vertexMC);", "    }"]).result, a = Ft.substitute(a, "//VTK::Clip::Dec", ["uniform int numClipPlanes;", "varying float clipDistancesVSOutput[6];"]).result, a = Ft.substitute(a, "//VTK::Clip::Impl", ["for (int planeNum = 0; planeNum < 6; planeNum++)", "    {", "    if (planeNum >= numClipPlanes)", "        {", "        break;", "        }", "    if (clipDistancesVSOutput[planeNum] < 0.0) discard;", "    }"]).result;
    }
    e.Vertex = r, e.Fragment = a;
  }, i.getShaderTemplate = (e, n, s) => {
    e.Vertex = EI, e.Fragment = IT, e.Geometry = "";
  }, i.setMapperShaderParameters = (e, n, s) => {
    const r = e.getProgram(), a = e.getCABO();
    a.getElementCount() && (t.VBOBuildTime.getMTime() > e.getAttributeUpdateTime().getMTime() || e.getShaderSourceTime().getMTime() > e.getAttributeUpdateTime().getMTime()) && (r.isAttributeUsed("vertexMC") && (e.getVAO().addAttributeArray(r, a, "vertexMC", a.getVertexOffset(), a.getStride(), t.context.FLOAT, 3, t.context.FALSE) || aM("Error setting vertexMC in shader VAO.")), e.getCABO().getCustomData().forEach((h) => {
      h && r.isAttributeUsed(h.name) && !e.getVAO().addAttributeArray(r, a, h.name, h.offset, a.getStride(), t.context.FLOAT, h.components, t.context.FALSE) && aM(`Error setting ${h.name} in shader VAO.`);
    }), e.getAttributeUpdateTime().modified());
    const o = t.volumeTexture.getTextureUnit();
    if (r.setUniformi("volumeTexture", o), r.setUniformf("width", t.renderable.getWidth()), e.getProgram().setUniform4fv("backgroundColor", t.renderable.getBackgroundColor()), r.isUniformUsed("tangentDirection")) {
      const h = t.renderable.getTangentDirection();
      e.getProgram().setUniform3fArray("tangentDirection", h);
    }
    if (r.isUniformUsed("bitangentDirection")) {
      const h = t.renderable.getBitangentDirection();
      e.getProgram().setUniform3fArray("bitangentDirection", h);
    }
    if (r.isUniformUsed("centerlineOrientation")) {
      const h = t.renderable.getUniformOrientation();
      e.getProgram().setUniform4fv("centerlineOrientation", h);
    }
    if (r.isUniformUsed("globalCenterPoint")) {
      const h = t.renderable.getCenterPoint();
      r.setUniform3fArray("globalCenterPoint", h);
    }
    if (t.renderable.isProjectionEnabled()) {
      const h = t.currentImageDataInput, p = h.getSpacing(), m = h.getDimensions(), b = t.renderable.getProjectionSlabThickness(), y = t.renderable.getProjectionSlabNumberOfSamples(), Z = I.mul([], p, m);
      r.setUniform3fArray("volumeSizeMC", Z), r.setUniformi("projectionSlabNumberOfSamples", y);
      const g = -0.5 * b;
      r.setUniformf("projectionConstantOffset", g);
      const f = b / (y - 1);
      r.setUniformf("projectionStepLength", f);
    }
    const l = t.currentImageDataInput, c = l.getWorldToIndex(), u = ut.fromScaling(new Float32Array(16), I.inverse([], l.getDimensions())), d = ut.mul(u, u, c);
    if (r.setUniformMatrix("MCTCMatrix", d), t.haveSeenDepthRequest && e.getProgram().setUniformi("depthRequest", t.renderDepth ? 1 : 0), t.renderable.getNumberOfClippingPlanes()) {
      let h = t.renderable.getNumberOfClippingPlanes();
      h > 6 && (tt.vtkErrorMacro("OpenGL has a limit of 6 clipping planes"), h = 6);
      const m = a.getCoordShiftAndScaleEnabled() ? a.getInverseShiftAndScaleMatrix() : null, b = m ? ut.copy(t.imagematinv, s.getMatrix()) : s.getMatrix();
      m && (ut.transpose(b, b), ut.multiply(b, b, m), ut.transpose(b, b)), ut.transpose(t.imagemat, t.currentImageDataInput.getIndexToWorld()), ut.multiply(t.imagematinv, b, t.imagemat);
      const y = [];
      for (let Z = 0; Z < h; Z++) {
        const g = [];
        t.renderable.getClippingPlaneInDataCoords(t.imagematinv, Z, g);
        for (let f = 0; f < 4; f++)
          y.push(g[f]);
      }
      r.setUniformi("numClipPlanes", h), r.setUniform4fv("clipPlanes", y);
    }
    if (r.isUniformUsed("coffset")) {
      const h = i.getCoincidentParameters(n, s);
      r.setUniformf("coffset", h.offset), r.isUniformUsed("cfactor") && r.setUniformf("cfactor", h.factor);
    }
  }, i.setCameraShaderParameters = (e, n, s) => {
    const r = t.openGLImageSlice.getKeyMatrices().mcwc, a = t.openGLCamera.getKeyMatrices(n).wcpc;
    if (ut.multiply(t.imagemat, a, r), e.getCABO().getCoordShiftAndScaleEnabled()) {
      const o = e.getCABO().getInverseShiftAndScaleMatrix();
      ut.multiply(t.imagemat, t.imagemat, o);
    }
    e.getProgram().setUniformMatrix("MCPCMatrix", t.imagemat);
  }, i.setPropertyShaderParameters = (e, n, s) => {
    const r = e.getProgram(), a = s.getProperty(), o = a.getOpacity();
    r.setUniformf("opacity", o);
    const l = t.volumeTexture.getComponents(), c = a.getIndependentComponents();
    if (c)
      for (let p = 0; p < l; ++p)
        r.setUniformf(`mix${p}`, a.getComponentWeight(p));
    const u = t.volumeTexture.getVolumeInfo();
    for (let p = 0; p < l; p++) {
      let m = a.getColorWindow(), b = a.getColorLevel();
      const y = c ? p : 0, Z = a.getRGBTransferFunction(y);
      if (Z && a.getUseLookupTableScalarRange()) {
        const T = Z.getRange();
        m = T[1] - T[0], b = 0.5 * (T[1] + T[0]);
      }
      const g = u.scale[p] / m, f = (u.offset[p] - b) / m + 0.5;
      r.setUniformf(`cshift${p}`, f), r.setUniformf(`cscale${p}`, g);
    }
    const d = t.colorTexture.getTextureUnit();
    r.setUniformi("colorTexture1", d);
    for (let p = 0; p < l; p++) {
      let m = 1, b = 0;
      const y = c ? p : 0, Z = a.getPiecewiseFunction(y);
      if (Z) {
        const g = Z.getRange(), f = g[1] - g[0], T = 0.5 * (g[0] + g[1]);
        m = u.scale[p] / f, b = (u.offset[p] - T) / f + 0.5;
      }
      r.setUniformf(`pwfshift${p}`, b), r.setUniformf(`pwfscale${p}`, m);
    }
    const h = t.pwfTexture.getTextureUnit();
    r.setUniformi("pwfTexture1", h);
  }, i.updateShaders = (e, n, s) => {
    if (i.getNeedToRebuildShaders(e, n, s)) {
      const r = {
        Vertex: null,
        Fragment: null,
        Geometry: null
      };
      i.buildShaders(r, n, s);
      const a = t._openGLRenderWindow.getShaderCache().readyShaderProgramArray(r.Vertex, r.Fragment, r.Geometry);
      a !== e.getProgram() && (e.setProgram(a), e.getVAO().releaseGraphicsResources()), e.getShaderSourceTime().modified();
    } else
      t._openGLRenderWindow.getShaderCache().readyShaderProgram(e.getProgram());
    e.getVAO().bind(), i.setMapperShaderParameters(e, n, s), i.setCameraShaderParameters(e, n, s), i.setPropertyShaderParameters(e, n, s);
  };
}
const Slt = {
  currentRenderPass: null,
  volumeTexture: null,
  volumeTextureTime: 0,
  colorTexture: null,
  colorTextureString: null,
  pwfTexture: null,
  pwfTextureString: null,
  tris: null,
  lastHaveSeenDepthRequest: !1,
  haveSeenDepthRequest: !1,
  lastTextureComponents: 0,
  lastIndependentComponents: 0,
  imagemat: null,
  imagematinv: null
};
function Llt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Slt, e), ui.extend(i, t, e), kc.implementReplaceShaderCoincidentOffset(i, t, e), tt.algo(i, t, 2, 0), t.tris = Jc.newInstance(), t.volumeTexture = bs.newInstance(), t.colorTexture = bs.newInstance(), t.pwfTexture = bs.newInstance(), t.imagemat = ut.identity(new Float64Array(16)), t.imagematinv = ut.identity(new Float64Array(16)), t.VBOBuildTime = {}, tt.obj(t.VBOBuildTime, {
    mtime: 0
  }), xlt(i, t);
}
const Vlt = tt.newInstance(Llt, "vtkOpenGLImageCPRMapper");
Js("vtkImageCPRMapper", Vlt);
function Xlt(i, t) {
  t.classHierarchy.push("vtkOpenGLImageSlice"), i.buildPass = (e) => {
    if (!(!t.renderable || !t.renderable.getVisibility()) && e) {
      if (!t.renderable)
        return;
      t._openGLRenderWindow = i.getFirstAncestorOfType("vtkOpenGLRenderWindow"), t._openGLRenderer = i.getFirstAncestorOfType("vtkOpenGLRenderer"), t.context = t._openGLRenderWindow.getContext(), i.prepareNodes(), i.addMissingNode(t.renderable.getMapper()), i.removeUnusedNodes();
    }
  }, i.traverseZBufferPass = (e) => {
    !t.renderable || !t.renderable.getNestedVisibility() || t._openGLRenderer.getSelector() && !t.renderable.getNestedPickable() || (i.apply(e, !0), t.children.forEach((n) => {
      n.traverse(e);
    }), i.apply(e, !1));
  }, i.traverseOpaqueZBufferPass = (e) => i.traverseOpaquePass(e), i.traverseOpaquePass = (e) => {
    !t.renderable || !t.renderable.getNestedVisibility() || !t.renderable.getIsOpaque() || t._openGLRenderer.getSelector() && !t.renderable.getNestedPickable() || (i.apply(e, !0), t.children.forEach((n) => {
      n.traverse(e);
    }), i.apply(e, !1));
  }, i.traverseTranslucentPass = (e) => {
    !t.renderable || !t.renderable.getNestedVisibility() || t.renderable.getIsOpaque() || t._openGLRenderer.getSelector() && !t.renderable.getNestedPickable() || (i.apply(e, !0), t.children.forEach((n) => {
      n.traverse(e);
    }), i.apply(e, !1));
  }, i.queryPass = (e, n) => {
    if (e) {
      if (!t.renderable || !t.renderable.getVisibility())
        return;
      t.renderable.getIsOpaque() ? n.incrementOpaqueActorCount() : n.incrementTranslucentActorCount();
    }
  }, i.zBufferPass = (e, n) => i.opaquePass(e, n), i.opaqueZBufferPass = (e, n) => i.opaquePass(e, n), i.opaquePass = (e, n) => {
    e && t.context.depthMask(!0);
  }, i.translucentPass = (e, n) => {
    t.context.depthMask(!e);
  }, i.getKeyMatrices = () => (t.renderable.getMTime() > t.keyMatrixTime.getMTime() && (ut.copy(t.keyMatrices.mcwc, t.renderable.getMatrix()), ut.transpose(t.keyMatrices.mcwc, t.keyMatrices.mcwc), t.keyMatrixTime.modified()), t.keyMatrices);
}
const Ilt = {
  context: null,
  keyMatrixTime: null,
  keyMatrices: null
};
function Clt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Ilt, e), ui.extend(i, t, e), t.keyMatrixTime = {}, xi(t.keyMatrixTime, {
    mtime: 0
  }), t.keyMatrices = {
    mcwc: ut.identity(new Float64Array(16))
  }, gs(i, t, ["context"]), Xlt(i, t);
}
const Ylt = In(Clt, "vtkOpenGLImageSlice");
Js("vtkImageSlice", Ylt);
function vlt(i, t) {
  t.classHierarchy.push("vtkOpenGLVolume"), i.buildPass = (e) => {
    !t.renderable || !t.renderable.getVisibility() || e && (t._openGLRenderWindow = i.getFirstAncestorOfType("vtkOpenGLRenderWindow"), t._openGLRenderer = i.getFirstAncestorOfType("vtkOpenGLRenderer"), t.context = t._openGLRenderWindow.getContext(), i.prepareNodes(), i.addMissingNode(t.renderable.getMapper()), i.removeUnusedNodes());
  }, i.queryPass = (e, n) => {
    if (e) {
      if (!t.renderable || !t.renderable.getVisibility())
        return;
      n.incrementVolumeCount();
    }
  }, i.traverseVolumePass = (e) => {
    !t.renderable || !t.renderable.getNestedVisibility() || t._openGLRenderer.getSelector() && !t.renderable.getNestedPickable() || (i.apply(e, !0), t.children[0].traverse(e), i.apply(e, !1));
  }, i.volumePass = (e) => {
    !t.renderable || !t.renderable.getVisibility() || t.context.depthMask(!e);
  }, i.getKeyMatrices = () => (t.renderable.getMTime() > t.keyMatrixTime.getMTime() && (t.renderable.computeMatrix(), ut.copy(t.MCWCMatrix, t.renderable.getMatrix()), ut.transpose(t.MCWCMatrix, t.MCWCMatrix), t.renderable.getIsIdentity() ? gi.identity(t.normalMatrix) : (gi.fromMat4(t.normalMatrix, t.MCWCMatrix), gi.invert(t.normalMatrix, t.normalMatrix), gi.transpose(t.normalMatrix, t.normalMatrix)), t.keyMatrixTime.modified()), {
    mcwc: t.MCWCMatrix,
    normalMatrix: t.normalMatrix
  });
}
const Rlt = {
  // context: null,
  // keyMatrixTime: null,
  // normalMatrix: null,
  // MCWCMatrix: null,
  // _openGLRenderWindow: null,
};
function Dlt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Rlt, e), ui.extend(i, t, e), t.keyMatrixTime = {}, xi(t.keyMatrixTime, {
    mtime: 0
  }), t.normalMatrix = new Float64Array(9), t.MCWCMatrix = new Float64Array(16), gs(i, t, ["context"]), vlt(i, t);
}
const Olt = In(Dlt, "vtkOpenGLVolume");
Js("vtkVolume", Olt);
function zlt(i, t) {
  t.classHierarchy.push("vtkFramebuffer"), i.getBothMode = () => t.context.FRAMEBUFFER, i.saveCurrentBindingsAndBuffers = (e) => {
    const n = typeof e < "u" ? e : i.getBothMode();
    i.saveCurrentBindings(n), i.saveCurrentBuffers(n);
  }, i.saveCurrentBindings = (e) => {
    if (!t.context) {
      Zn("you must set the OpenGLRenderWindow before calling saveCurrentBindings");
      return;
    }
    const n = t.context;
    t.previousDrawBinding = n.getParameter(t.context.FRAMEBUFFER_BINDING), t.previousActiveFramebuffer = t._openGLRenderWindow.getActiveFramebuffer();
  }, i.saveCurrentBuffers = (e) => {
  }, i.restorePreviousBindingsAndBuffers = (e) => {
    const n = typeof e < "u" ? e : i.getBothMode();
    i.restorePreviousBindings(n), i.restorePreviousBuffers(n);
  }, i.restorePreviousBindings = (e) => {
    if (!t.context) {
      Zn("you must set the OpenGLRenderWindow before calling restorePreviousBindings");
      return;
    }
    const n = t.context;
    n.bindFramebuffer(n.FRAMEBUFFER, t.previousDrawBinding), t._openGLRenderWindow.setActiveFramebuffer(t.previousActiveFramebuffer);
  }, i.restorePreviousBuffers = (e) => {
  }, i.bind = function() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    n === null && (n = t.context.FRAMEBUFFER), t.context.bindFramebuffer(n, t.glFramebuffer);
    for (let s = 0; s < t.colorBuffers.length; s++)
      t.colorBuffers[s].bind();
    t._openGLRenderWindow.setActiveFramebuffer(i);
  }, i.create = (e, n) => {
    if (!t.context) {
      Zn("you must set the OpenGLRenderWindow before calling create");
      return;
    }
    t.glFramebuffer = t.context.createFramebuffer(), t.glFramebuffer.width = e, t.glFramebuffer.height = n;
  }, i.setColorBuffer = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    const s = t.context;
    if (!s) {
      Zn("you must set the OpenGLRenderWindow before calling setColorBuffer");
      return;
    }
    let r = s.COLOR_ATTACHMENT0;
    if (n > 0)
      if (t._openGLRenderWindow.getWebgl2())
        r += n;
      else {
        Zn("Using multiple framebuffer attachments requires WebGL 2");
        return;
      }
    t.colorBuffers[n] = e, s.framebufferTexture2D(s.FRAMEBUFFER, r, s.TEXTURE_2D, e.getHandle(), 0);
  }, i.removeColorBuffer = function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    const n = t.context;
    if (!n) {
      Zn("you must set the OpenGLRenderWindow before calling removeColorBuffer");
      return;
    }
    let s = n.COLOR_ATTACHMENT0;
    if (e > 0)
      if (t._openGLRenderWindow.getWebgl2())
        s += e;
      else {
        Zn("Using multiple framebuffer attachments requires WebGL 2");
        return;
      }
    n.framebufferTexture2D(n.FRAMEBUFFER, s, n.TEXTURE_2D, null, 0), t.colorBuffers = t.colorBuffers.splice(e, 1);
  }, i.setDepthBuffer = (e) => {
    if (!t.context) {
      Zn("you must set the OpenGLRenderWindow before calling setDepthBuffer");
      return;
    }
    if (t._openGLRenderWindow.getWebgl2()) {
      const n = t.context;
      n.framebufferTexture2D(n.FRAMEBUFFER, n.DEPTH_ATTACHMENT, n.TEXTURE_2D, e.getHandle(), 0);
    } else
      Zn("Attaching depth buffer textures to fbo requires WebGL 2");
  }, i.removeDepthBuffer = () => {
    if (!t.context) {
      Zn("you must set the OpenGLRenderWindow before calling removeDepthBuffer");
      return;
    }
    if (t._openGLRenderWindow.getWebgl2()) {
      const e = t.context;
      e.framebufferTexture2D(e.FRAMEBUFFER, e.DEPTH_ATTACHMENT, e.TEXTURE_2D, null, 0);
    } else
      Zn("Attaching depth buffer textures to framebuffers requires WebGL 2");
  }, i.getGLFramebuffer = () => t.glFramebuffer, i.setOpenGLRenderWindow = (e) => {
    t._openGLRenderWindow !== e && (i.releaseGraphicsResources(), t._openGLRenderWindow = e, t.context = null, e && (t.context = t._openGLRenderWindow.getContext()));
  }, i.releaseGraphicsResources = () => {
    t.glFramebuffer && t.context.deleteFramebuffer(t.glFramebuffer);
  }, i.getSize = () => t.glFramebuffer == null ? null : [t.glFramebuffer.width, t.glFramebuffer.height], i.populateFramebuffer = () => {
    if (!t.context) {
      Zn("you must set the OpenGLRenderWindow before calling populateFrameBuffer");
      return;
    }
    i.bind();
    const e = t.context, n = bs.newInstance();
    n.setOpenGLRenderWindow(t._openGLRenderWindow), n.setMinificationFilter(Qe.LINEAR), n.setMagnificationFilter(Qe.LINEAR), n.create2DFromRaw(t.glFramebuffer.width, t.glFramebuffer.height, 4, Ke.UNSIGNED_CHAR, null), i.setColorBuffer(n), t.depthTexture = e.createRenderbuffer(), e.bindRenderbuffer(e.RENDERBUFFER, t.depthTexture), e.renderbufferStorage(e.RENDERBUFFER, e.DEPTH_COMPONENT16, t.glFramebuffer.width, t.glFramebuffer.height), e.framebufferRenderbuffer(e.FRAMEBUFFER, e.DEPTH_ATTACHMENT, e.RENDERBUFFER, t.depthTexture);
  }, i.getColorTexture = () => t.colorBuffers[0];
}
const Elt = {
  // _openGLRenderWindow: null,
  glFramebuffer: null,
  colorBuffers: null,
  depthTexture: null,
  previousDrawBinding: 0,
  previousReadBinding: 0,
  previousDrawBuffer: 0,
  previousReadBuffer: 0,
  previousActiveFramebuffer: null
};
function Rj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Elt, e), xi(i, t), t.colorBuffers && Zn("you cannot initialize colorBuffers through the constructor. You should call setColorBuffer() instead."), t.colorBuffers = [], Sg(i, t, ["colorBuffers"]), zlt(i, t);
}
const klt = In(Rj, "vtkFramebuffer");
var gg = {
  newInstance: klt,
  extend: Rj
};
const Uh = {
  NEAREST: 0,
  LINEAR: 1,
  FAST_LINEAR: 2
}, Dj = {
  FRACTIONAL: 0,
  PROPORTIONAL: 1
}, oN = {
  CUSTOM: 0,
  ADDITIVE: 1,
  COLORIZE: 2
};
var Oj = {
  InterpolationType: Uh,
  OpacityMode: Dj,
  ColorMixPreset: oN
};
const zj = {
  COMPOSITE_BLEND: 0,
  MAXIMUM_INTENSITY_BLEND: 1,
  MINIMUM_INTENSITY_BLEND: 2,
  AVERAGE_INTENSITY_BLEND: 3,
  ADDITIVE_INTENSITY_BLEND: 4,
  RADON_TRANSFORM_BLEND: 5
}, Flt = {
  OFF: 0,
  NORMALIZED: 1,
  RAW: 2
};
var jlt = {
  BlendMode: zj,
  FilterMode: Flt
}, Ult = `//VTK::System::Dec

/*=========================================================================

  Program:   Visualization Toolkit
  Module:    vtkPolyDataVS.glsl

  Copyright (c) Ken Martin, Will Schroeder, Bill Lorensen
  All rights reserved.
  See Copyright.txt or http://www.kitware.com/Copyright.htm for details.

     This software is distributed WITHOUT ANY WARRANTY; without even
     the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR
     PURPOSE.  See the above copyright notice for more information.

=========================================================================*/

attribute vec4 vertexDC;

varying vec3 vertexVCVSOutput;
uniform mat4 PCVCMatrix;

uniform float dcxmin;
uniform float dcxmax;
uniform float dcymin;
uniform float dcymax;

void main()
{
  // dcsmall is the device coords reduced to the
  // x y area covered by the volume
  vec4 dcsmall = vec4(
    dcxmin + 0.5 * (vertexDC.x + 1.0) * (dcxmax - dcxmin),
    dcymin + 0.5 * (vertexDC.y + 1.0) * (dcymax - dcymin),
    vertexDC.z,
    vertexDC.w);
  vec4 vcpos = PCVCMatrix * dcsmall;
  vertexVCVSOutput = vcpos.xyz/vcpos.w;
  gl_Position = dcsmall;
}
`, Plt = `//VTK::System::Dec

/*=========================================================================

  Program:   Visualization Toolkit
  Module:    vtkVolumeFS.glsl

  Copyright (c) Ken Martin, Will Schroeder, Bill Lorensen
  All rights reserved.
  See Copyright.txt or http://www.kitware.com/Copyright.htm for details.

     This software is distributed WITHOUT ANY WARRANTY; without even
     the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR
     PURPOSE.  See the above copyright notice for more information.

=========================================================================*/
// Template for the volume mappers fragment shader

// the output of this shader
//VTK::Output::Dec

varying vec3 vertexVCVSOutput;

// first declare the settings from the mapper
// that impact the code paths in here

// always set vtkNumComponents 1,2,3,4
//VTK::NumComponents

// possibly define vtkTrilinearOn
//VTK::TrilinearOn

// possibly define UseIndependentComponents
//VTK::IndependentComponentsOn

// possibly define vtkCustomComponentsColorMix
//VTK::CustomComponentsColorMixOn

// possibly define any "proportional" components
//VTK::vtkProportionalComponents

// possibly define any components that are forced to nearest interpolation
//VTK::vtkForceNearestComponents

// Define the blend mode to use
#define vtkBlendMode //VTK::BlendMode

// Possibly define vtkImageLabelOutlineOn
//VTK::ImageLabelOutlineOn

#ifdef vtkImageLabelOutlineOn

uniform float outlineOpacity;
uniform float vpWidth;
uniform float vpHeight;
uniform float vpOffsetX;
uniform float vpOffsetY;
uniform mat4 PCWCMatrix;
uniform mat4 vWCtoIDX;
#endif

// define vtkLightComplexity
//VTK::LightComplexity
#if vtkLightComplexity > 0
uniform float vSpecularPower;
uniform float vAmbient;
uniform float vDiffuse;
uniform float vSpecular;
//VTK::Light::Dec
#endif

//VTK::VolumeShadowOn
//VTK::SurfaceShadowOn
//VTK::localAmbientOcclusionOn
//VTK::LAO::Dec
//VTK::VolumeShadow::Dec

// define vtkComputeNormalFromOpacity
//VTK::vtkComputeNormalFromOpacity

// possibly define vtkGradientOpacityOn
//VTK::GradientOpacityOn
#ifdef vtkGradientOpacityOn
uniform float goscale0;
uniform float goshift0;
uniform float gomin0;
uniform float gomax0;
#ifdef UseIndependentComponents
#if vtkNumComponents > 1
uniform float goscale1;
uniform float goshift1;
uniform float gomin1;
uniform float gomax1;
#if vtkNumComponents > 2
uniform float goscale2;
uniform float goshift2;
uniform float gomin2;
uniform float gomax2;
#if vtkNumComponents > 3
uniform float goscale3;
uniform float goshift3;
uniform float gomin3;
uniform float gomax3;
#endif
#endif
#endif
#endif
#endif

// if you want to see the raw tiled
// data in webgl1 uncomment the following line
// #define debugtile

// camera values
uniform float camThick;
uniform float camNear;
uniform float camFar;
uniform int cameraParallel;

// values describing the volume geometry
uniform vec3 vOriginVC;
uniform vec3 vSpacing;
uniform ivec3 volumeDimensions; // 3d texture dimensions
uniform vec3 vPlaneNormal0;
uniform float vPlaneDistance0;
uniform vec3 vPlaneNormal1;
uniform float vPlaneDistance1;
uniform vec3 vPlaneNormal2;
uniform float vPlaneDistance2;
uniform vec3 vPlaneNormal3;
uniform float vPlaneDistance3;
uniform vec3 vPlaneNormal4;
uniform float vPlaneDistance4;
uniform vec3 vPlaneNormal5;
uniform float vPlaneDistance5;

//VTK::ClipPlane::Dec

// opacity and color textures
uniform sampler2D otexture;
uniform float oshift0;
uniform float oscale0;
uniform sampler2D ctexture;
uniform float cshift0;
uniform float cscale0;

#if vtkNumComponents >= 2
uniform float oshift1;
uniform float oscale1;
uniform float cshift1;
uniform float cscale1;
#endif
#if vtkNumComponents >= 3
uniform float oshift2;
uniform float oscale2;
uniform float cshift2;
uniform float cscale2;
#endif
#if vtkNumComponents >= 4
uniform float oshift3;
uniform float oscale3;
uniform float cshift3;
uniform float cscale3;
#endif

// jitter texture
uniform sampler2D jtexture;
uniform sampler2D ttexture;


// some 3D texture values
uniform float sampleDistance;
uniform vec3 vVCToIJK;

// the heights defined below are the locations
// for the up to four components of the tfuns
// the tfuns have a height of 2XnumComps pixels so the
// values are computed to hit the middle of the two rows
// for that component
#ifdef UseIndependentComponents
#if vtkNumComponents == 1
uniform float mix0;
#define height0 0.5
#endif
#if vtkNumComponents == 2
uniform float mix0;
uniform float mix1;
#define height0 0.25
#define height1 0.75
#endif
#if vtkNumComponents == 3
uniform float mix0;
uniform float mix1;
uniform float mix2;
#define height0 0.17
#define height1 0.5
#define height2 0.83
#endif
#if vtkNumComponents == 4
uniform float mix0;
uniform float mix1;
uniform float mix2;
uniform float mix3;
#define height0 0.125
#define height1 0.375
#define height2 0.625
#define height3 0.875
#endif
#endif

uniform vec4 ipScalarRangeMin;
uniform vec4 ipScalarRangeMax;

// declaration for intermixed geometry
//VTK::ZBuffer::Dec

//=======================================================================
// global and custom variables (a temporary section before photorealistics rendering module is complete)
vec3 rayDirVC;
float sampleDistanceISVS;
float sampleDistanceIS;

#define SQRT3    1.7321
#define INV4PI   0.0796
#define EPSILON  0.001
#define PI       3.1415
#define PI2      9.8696

//=======================================================================
// Webgl2 specific version of functions
#if __VERSION__ == 300

uniform highp sampler3D texture1;

vec4 getTextureValue(vec3 pos)
{
  vec4 tmp = texture(texture1, pos);

  #if defined(vtkComponent0ForceNearest) || \\
      defined(vtkComponent1ForceNearest) || \\
      defined(vtkComponent2ForceNearest) || \\
      defined(vtkComponent3ForceNearest)
    vec3 nearestPos = (floor(pos * vec3(volumeDimensions)) + 0.5) / vec3(volumeDimensions);
    vec4 nearestValue = texture(texture1, nearestPos);
    #ifdef vtkComponent0ForceNearest
      tmp[0] = nearestValue[0];
    #endif
    #ifdef vtkComponent1ForceNearest
      tmp[1] = nearestValue[1];
    #endif
    #ifdef vtkComponent2ForceNearest
      tmp[2] = nearestValue[2];
    #endif
    #ifdef vtkComponent3ForceNearest
      tmp[3] = nearestValue[3];
    #endif
  #endif

  #ifndef UseIndependentComponents
    #if vtkNumComponents == 1
      tmp.a = tmp.r;
    #endif
    #if vtkNumComponents == 2
      tmp.a = tmp.g;
    #endif
    #if vtkNumComponents == 3
      tmp.a = length(tmp.rgb);
    #endif
  #endif

  return tmp;
}

//=======================================================================
// WebGL1 specific version of functions
#else

uniform sampler2D texture1;

uniform float texWidth;
uniform float texHeight;
uniform int xreps;
uniform int xstride;
uniform int ystride;

// if computing trilinear values from multiple z slices
#ifdef vtkTrilinearOn
vec4 getTextureValue(vec3 ijk)
{
  float zoff = 1.0/float(volumeDimensions.z);
  vec4 val1 = getOneTextureValue(ijk);
  vec4 val2 = getOneTextureValue(vec3(ijk.xy, ijk.z + zoff));

  float indexZ = float(volumeDimensions)*ijk.z;
  float zmix =  indexZ - floor(indexZ);

  return mix(val1, val2, zmix);
}

vec4 getOneTextureValue(vec3 ijk)
#else // nearest or fast linear
vec4 getTextureValue(vec3 ijk)
#endif
{
  vec3 tdims = vec3(volumeDimensions);

#ifdef debugtile
  vec2 tpos = vec2(ijk.x, ijk.y);
  vec4 tmp = texture2D(texture1, tpos);
  tmp.a = 1.0;

#else
  int z = int(ijk.z * tdims.z);
  int yz = z / xreps;
  int xz = z - yz*xreps;

  int tileWidth = volumeDimensions.x/xstride;
  int tileHeight = volumeDimensions.y/ystride;

  xz *= tileWidth;
  yz *= tileHeight;

  float ni = float(xz) + (ijk.x*float(tileWidth));
  float nj = float(yz) + (ijk.y*float(tileHeight));

  vec2 tpos = vec2(ni/texWidth, nj/texHeight);

  vec4 tmp = texture2D(texture1, tpos);

#if vtkNumComponents == 1
  tmp.a = tmp.r;
#endif
#if vtkNumComponents == 2
  tmp.g = tmp.a;
#endif
#if vtkNumComponents == 3
  tmp.a = length(tmp.rgb);
#endif
#endif

  return tmp;
}

// End of Webgl1 specific code
//=======================================================================
#endif

//=======================================================================
// transformation between VC and IS space

// convert vector position from idx to vc
#if (vtkLightComplexity > 0) || (defined vtkClippingPlanesOn)
vec3 IStoVC(vec3 posIS){
  vec3 posVC = posIS / vVCToIJK;
  return posVC.x * vPlaneNormal0 +
         posVC.y * vPlaneNormal2 +
         posVC.z * vPlaneNormal4 +
         vOriginVC;
}

// convert vector position from vc to idx
vec3 VCtoIS(vec3 posVC){
  posVC = posVC - vOriginVC;
  posVC = vec3(
    dot(posVC, vPlaneNormal0),
    dot(posVC, vPlaneNormal2),
    dot(posVC, vPlaneNormal4));
  return posVC * vVCToIJK;
}
#endif

//Rotate vector to view coordinate
#if (vtkLightComplexity > 0) || (defined vtkGradientOpacityOn)
void rotateToViewCoord(inout vec3 dirIS){
  dirIS.xyz =
    dirIS.x * vPlaneNormal0 +
    dirIS.y * vPlaneNormal2 +
    dirIS.z * vPlaneNormal4;
}

//Rotate vector to idx coordinate
vec3 rotateToIDX(vec3 dirVC){
  vec3 dirIS;
  dirIS.xyz = vec3(
    dot(dirVC, vPlaneNormal0),
    dot(dirVC, vPlaneNormal2),
    dot(dirVC, vPlaneNormal4));
  return dirIS;
}
#endif

//=======================================================================
// Given a normal compute the gradient opacity factors
float computeGradientOpacityFactor(
  float normalMag, float goscale, float goshift, float gomin, float gomax)
{
  return clamp(normalMag * goscale + goshift, gomin, gomax);
}

//=======================================================================
// compute the normal and gradient magnitude for a position, uses forward difference
#if (vtkLightComplexity > 0) || (defined vtkGradientOpacityOn)
  #ifdef vtkClippingPlanesOn
    void adjustClippedVoxelValues(vec3 pos, vec3 texPos[3], inout vec3 g1)
    {
      vec3 g1VC[3];
      for (int i = 0; i < 3; ++i)
      {
        g1VC[i] = IStoVC(texPos[i]);
      }
      vec3 posVC = IStoVC(pos);
      for (int i = 0; i < clip_numPlanes; ++i)
      {
        for (int j = 0; j < 3; ++j)
        {
          if(dot(vec3(vClipPlaneOrigins[i] - g1VC[j].xyz), vClipPlaneNormals[i]) > 0.0)
          {
            g1[j] = 0.0;
          }
        }
      }
    }
  #endif

  #ifdef vtkComputeNormalFromOpacity
    vec4 computeDensityNormal(vec3 opacityUCoords[2], float opactityTextureHeight, float gradientOpacity) {
      vec3 opacityG1, opacityG2;
      opacityG1.x = texture2D(otexture, vec2(opacityUCoords[0].x, opactityTextureHeight)).r;
      opacityG1.y = texture2D(otexture, vec2(opacityUCoords[0].y, opactityTextureHeight)).r;
      opacityG1.z = texture2D(otexture, vec2(opacityUCoords[0].z, opactityTextureHeight)).r;
      opacityG2.x = texture2D(otexture, vec2(opacityUCoords[1].x, opactityTextureHeight)).r;
      opacityG2.y = texture2D(otexture, vec2(opacityUCoords[1].y, opactityTextureHeight)).r;
      opacityG2.z = texture2D(otexture, vec2(opacityUCoords[1].z, opactityTextureHeight)).r;
      opacityG1.xyz *= gradientOpacity;
      opacityG2.xyz *= gradientOpacity;

      vec4 opacityG = vec4(opacityG1 - opacityG2, 1.0f);
      // divide by spacing
      opacityG.xyz /= vSpacing;
      opacityG.w = length(opacityG.xyz);
      // rotate to View Coords
      rotateToViewCoord(opacityG.xyz);
      if (!all(equal(opacityG.xyz, vec3(0.0)))) {
        return vec4(normalize(opacityG.xyz),opacityG.w);
      } else {
        return vec4(0.0);
      }
    }

    vec4 computeNormalForDensity(vec3 pos, vec3 tstep, out vec3 scalarInterp[2], const int opacityComponent)
    {
      vec3 xvec = vec3(tstep.x, 0.0, 0.0);
      vec3 yvec = vec3(0.0, tstep.y, 0.0);
      vec3 zvec = vec3(0.0, 0.0, tstep.z);
      vec3 texPosPVec[3];
      texPosPVec[0] = pos + xvec;
      texPosPVec[1] = pos + yvec;
      texPosPVec[2] = pos + zvec;
      vec3 texPosNVec[3];
      texPosNVec[0] = pos - xvec;
      texPosNVec[1] = pos - yvec;
      texPosNVec[2] = pos - zvec;
      vec3 g1, g2;

      scalarInterp[0].x = getTextureValue(texPosPVec[0])[opacityComponent];
      scalarInterp[0].y = getTextureValue(texPosPVec[1])[opacityComponent];
      scalarInterp[0].z = getTextureValue(texPosPVec[2])[opacityComponent];
      scalarInterp[1].x = getTextureValue(texPosNVec[0])[opacityComponent];
      scalarInterp[1].y = getTextureValue(texPosNVec[1])[opacityComponent];
      scalarInterp[1].z = getTextureValue(texPosNVec[2])[opacityComponent];

      #ifdef vtkClippingPlanesOn
        adjustClippedVoxelValues(pos, texPosPVec, scalarInterp[0]);
        adjustClippedVoxelValues(pos, texPosNVec, scalarInterp[1]);
      #endif
      vec4 result;
      result.x = scalarInterp[0].x - scalarInterp[1].x;
      result.y = scalarInterp[0].y - scalarInterp[1].y;
      result.z = scalarInterp[0].z - scalarInterp[1].z;
      // divide by spacing
      result.xyz /= vSpacing;
      result.w = length(result.xyz);
      // rotate to View Coords
      rotateToViewCoord(result.xyz);
      if (length(result.xyz) > 0.0) {
        return vec4(normalize(result.xyz),result.w);
      } else {
        return vec4(0.0);
      }
    }
  #endif

  // only works with dependent components
  vec4 computeNormal(vec3 pos, vec3 tstep)
  {
    vec3 xvec = vec3(tstep.x, 0.0, 0.0);
    vec3 yvec = vec3(0.0, tstep.y, 0.0);
    vec3 zvec = vec3(0.0, 0.0, tstep.z);
    vec3 texPosPVec[3];
    texPosPVec[0] = pos + xvec;
    texPosPVec[1] = pos + yvec;
    texPosPVec[2] = pos + zvec;
    vec3 texPosNVec[3];
    texPosNVec[0] = pos - xvec;
    texPosNVec[1] = pos - yvec;
    texPosNVec[2] = pos - zvec;
    vec3 g1, g2;
    g1.x = getTextureValue(texPosPVec[0]).a;
    g1.y = getTextureValue(texPosPVec[1]).a;
    g1.z = getTextureValue(texPosPVec[2]).a;
    g2.x = getTextureValue(texPosNVec[0]).a;
    g2.y = getTextureValue(texPosNVec[1]).a;
    g2.z = getTextureValue(texPosNVec[2]).a;
    #ifdef vtkClippingPlanesOn
      adjustClippedVoxelValues(pos, texPosPVec, g1);
      adjustClippedVoxelValues(pos, texPosNVec, g2);
    #endif
    vec4 result;
    result = vec4(g1 - g2, -1.0);
    // divide by spacing
    result.xyz /= vSpacing;
    result.w = length(result.xyz);
    if (result.w > 0.0){
      // rotate to View Coords
      rotateToViewCoord(result.xyz);
      return vec4(normalize(result.xyz),result.w);
    } else {
      return vec4(0.0);
    }
  }
#endif

#ifdef vtkImageLabelOutlineOn
vec3 fragCoordToIndexSpace(vec4 fragCoord) {
  vec4 pcPos = vec4(
    (fragCoord.x / vpWidth - vpOffsetX - 0.5) * 2.0,
    (fragCoord.y / vpHeight - vpOffsetY - 0.5) * 2.0,
    (fragCoord.z - 0.5) * 2.0,
    1.0);

  vec4 worldCoord = PCWCMatrix * pcPos;
  vec4 vertex = (worldCoord/worldCoord.w);

  vec3 index = (vWCtoIDX * vertex).xyz;

  // half voxel fix for labelmapOutline
  return (index + vec3(0.5)) / vec3(volumeDimensions);
}
#endif

//=======================================================================
// compute the normals and gradient magnitudes for a position
// for independent components
mat4 computeMat4Normal(vec3 pos, vec4 tValue, vec3 tstep)
{
  mat4 result;
  vec4 distX = getTextureValue(pos + vec3(tstep.x, 0.0, 0.0)) - tValue;
  vec4 distY = getTextureValue(pos + vec3(0.0, tstep.y, 0.0)) - tValue;
  vec4 distZ = getTextureValue(pos + vec3(0.0, 0.0, tstep.z)) - tValue;

  // divide by spacing
  distX /= vSpacing.x;
  distY /= vSpacing.y;
  distZ /= vSpacing.z;

  mat3 rot;
  rot[0] = vPlaneNormal0;
  rot[1] = vPlaneNormal2;
  rot[2] = vPlaneNormal4;

#if !defined(vtkComponent0Proportional)
  result[0].xyz = vec3(distX.r, distY.r, distZ.r);
  result[0].a = length(result[0].xyz);
  result[0].xyz *= rot;
  if (result[0].w > 0.0)
  {
    result[0].xyz /= result[0].w;
  }
#endif

// optionally compute the 2nd component
#if vtkNumComponents >= 2 && !defined(vtkComponent1Proportional)
  result[1].xyz = vec3(distX.g, distY.g, distZ.g);
  result[1].a = length(result[1].xyz);
  result[1].xyz *= rot;
  if (result[1].w > 0.0)
  {
    result[1].xyz /= result[1].w;
  }
#endif

// optionally compute the 3rd component
#if vtkNumComponents >= 3 && !defined(vtkComponent2Proportional)
  result[2].xyz = vec3(distX.b, distY.b, distZ.b);
  result[2].a = length(result[2].xyz);
  result[2].xyz *= rot;
  if (result[2].w > 0.0)
  {
    result[2].xyz /= result[2].w;
  }
#endif

// optionally compute the 4th component
#if vtkNumComponents >= 4 && !defined(vtkComponent3Proportional)
  result[3].xyz = vec3(distX.a, distY.a, distZ.a);
  result[3].a = length(result[3].xyz);
  result[3].xyz *= rot;
  if (result[3].w > 0.0)
  {
    result[3].xyz /= result[3].w;
  }
#endif

  return result;
}

//=======================================================================
// global shadow - secondary ray
#if defined(VolumeShadowOn) || defined(localAmbientOcclusionOn)
float random()
{
  float rand = fract(sin(dot(gl_FragCoord.xy,vec2(12.9898,78.233)))*43758.5453123);
  float jitter=texture2D(jtexture,gl_FragCoord.xy/32.).r;
  uint pcg_state = floatBitsToUint(jitter);
  uint state = pcg_state;
  pcg_state = pcg_state * uint(747796405) + uint(2891336453);
  uint word = ((state >> ((state >> uint(28)) + uint(4))) ^ state) * uint(277803737);
  return (float((((word >> uint(22)) ^ word) >> 1 ))/float(2147483647) + rand)/2.0;
}
#endif

#ifdef VolumeShadowOn
// henyey greenstein phase function
float phase_function(float cos_angle)
{
  // divide by 2.0 instead of 4pi to increase intensity
  return ((1.0-anisotropy2)/pow(1.0+anisotropy2-2.0*anisotropy*cos_angle, 1.5))/2.0;
}

// Computes the intersection between a ray and a box
struct Hit
{
  float tmin;
  float tmax;
};

struct Ray
{
  vec3 origin;
  vec3 dir;
  vec3 invDir;
};

bool BBoxIntersect(vec3 boundMin, vec3 boundMax, const Ray r, out Hit hit)
{
  vec3 tbot = r.invDir * (boundMin - r.origin);
  vec3 ttop = r.invDir * (boundMax - r.origin);
  vec3 tmin = min(ttop, tbot);
  vec3 tmax = max(ttop, tbot);
  vec2 t = max(tmin.xx, tmin.yz);
  float t0 = max(t.x, t.y);
  t = min(tmax.xx, tmax.yz);
  float t1 = min(t.x, t.y);
  hit.tmin = t0;
  hit.tmax = t1;
  return t1 > max(t0,0.0);
}

// As BBoxIntersect requires the inverse of the ray coords,
// this function is used to avoid numerical issues
void safe_0_vector(inout Ray ray)
{
  if(abs(ray.dir.x) < EPSILON) ray.dir.x = sign(ray.dir.x) * EPSILON;
  if(abs(ray.dir.y) < EPSILON) ray.dir.y = sign(ray.dir.y) * EPSILON;
  if(abs(ray.dir.z) < EPSILON) ray.dir.z = sign(ray.dir.z) * EPSILON;
}

float volume_shadow(vec3 posIS, vec3 lightDirNormIS)
{
  float shadow = 1.0;
  float opacity = 0.0;

  // modify sample distance with a random number between 1.5 and 3.0
  float sampleDistanceISVS_jitter = sampleDistanceISVS * mix(1.5, 3.0, random());
  float opacityPrev = texture2D(otexture, vec2(getTextureValue(posIS).r * oscale0 + oshift0, 0.5)).r;

  // in case the first sample near surface has a very tiled light ray, we need to offset start position
  posIS += sampleDistanceISVS_jitter * lightDirNormIS;

  // compute the start and end points for the ray
  Ray ray;
  Hit hit;
  ray.origin = posIS;
  ray.dir = lightDirNormIS;
  safe_0_vector(ray);
  ray.invDir = 1.0/ray.dir;

  if(!BBoxIntersect(vec3(0.0),vec3(1.0), ray, hit))
  {
    return 1.0;
  }
  float maxdist = hit.tmax;

  // interpolate shadow ray length between: 1 unit of sample distance in IS to SQRT3, based on globalIlluminationReach
  float maxgi = mix(sampleDistanceISVS_jitter,SQRT3,giReach);
  maxdist = min(maxdist,maxgi);
  if(maxdist < EPSILON) {
    return 1.0;
  }

  float current_dist = 0.0;
  float current_step = length(sampleDistanceISVS_jitter * lightDirNormIS);
  float clamped_step = 0.0;

  vec4 scalar = vec4(0.0);
  while(current_dist < maxdist)
  {
#ifdef vtkClippingPlanesOn
    vec3 posVC = IStoVC(posIS);
    for (int i = 0; i < clip_numPlanes; ++i)
    {
      if (dot(vec3(vClipPlaneOrigins[i] - posVC), vClipPlaneNormals[i]) > 0.0)
      {
        current_dist = maxdist;
      }
    }
#endif
    scalar = getTextureValue(posIS);
    opacity = texture2D(otexture, vec2(scalar.r * oscale0 + oshift0, 0.5)).r;
    #if defined(vtkGradientOpacityOn) && !defined(UseIndependentComponents)
      vec4 normal = computeNormal(posIS, vec3(1.0/vec3(volumeDimensions)));
      opacity *= computeGradientOpacityFactor(normal.w, goscale0, goshift0, gomin0, gomax0);
    #endif
    shadow *= 1.0 - opacity;

    // optimization: early termination
    if (shadow < EPSILON){
      return 0.0;
    }

    clamped_step = min(maxdist - current_dist, current_step);
    posIS += clamped_step * lightDirNormIS;
    current_dist += current_step;
  }

  return shadow;
}

vec3 applyShadowRay(vec3 tColor, vec3 posIS, vec3 viewDirectionVC)
{
  vec3 vertLight = vec3(0.0);
  vec3 secondary_contrib = vec3(0.0);
  // here we assume only positional light, no effect of cones
  for (int i = 0; i < lightNum; i++)
  {
    #if(vtkLightComplexity==3)
      if (lightPositional[i] == 1){
        vertLight = lightPositionVC[i] - IStoVC(posIS);
      }else{
        vertLight = - lightDirectionVC[i];
      }
    #else
      vertLight = - lightDirectionVC[i];
    #endif
    // here we assume achromatic light, only intensity
    float dDotL = dot(viewDirectionVC, normalize(vertLight));
    // isotropic scatter returns 0.5 instead of 1/4pi to increase intensity
    float phase_attenuation = 0.5;
    if (abs(anisotropy) > EPSILON){
      phase_attenuation = phase_function(dDotL);
    }
    float vol_shadow = volume_shadow(posIS, normalize(rotateToIDX(vertLight)));
    secondary_contrib += tColor * vDiffuse * lightColor[i] * vol_shadow * phase_attenuation;
    secondary_contrib += tColor * vAmbient;
  }
  return secondary_contrib;
}
#endif

//=======================================================================
// local ambient occlusion
#ifdef localAmbientOcclusionOn
vec3 sample_direction_uniform(int i)
{
  float rand = random() * 0.5;
  float theta = PI2 * (kernelSample[i][0] + rand);
  float phi = acos(2.0 * (kernelSample[i][1] + rand) -1.0) / 2.5;
  return normalize(vec3(cos(theta)*sin(phi), sin(theta)*sin(phi), cos(phi)));
}

// return a matrix that transform startDir into z axis; startDir should be normalized
mat3 zBaseRotationalMatrix(vec3 startDir){
  vec3 axis = cross(startDir, vec3(0.0,0.0,1.0));
  float cosA = startDir.z;
  float k = 1.0 / (1.0 + cosA);
  mat3 matrix = mat3((axis.x * axis.x * k) + cosA, (axis.y * axis.x * k) - axis.z, (axis.z * axis.x * k) + axis.y,
              (axis.x * axis.y * k) + axis.z, (axis.y * axis.y * k) + cosA, (axis.z * axis.y * k) - axis.x,
              (axis.x * axis.z * k) - axis.y, (axis.y * axis.z * k) + axis.x, (axis.z * axis.z * k) + cosA);
  return matrix;
}

float computeLAO(vec3 posIS, float op, vec3 lightDir, vec4 normal){
  // apply LAO only at selected locations, otherwise return full brightness
  if (normal.w > 0.0 && op > 0.05){
    float total_transmittance = 0.0;
    mat3 inverseRotateBasis = inverse(zBaseRotationalMatrix(normalize(-normal.xyz)));
    vec3 currPos, randomDirStep;
    float weight, transmittance, opacity;
    for (int i = 0; i < kernelSize; i++)
    {
      randomDirStep = inverseRotateBasis * sample_direction_uniform(i) * sampleDistanceIS;
      weight = 1.0 - dot(normalize(lightDir), normalize(randomDirStep));
      currPos = posIS;
      transmittance = 1.0;
      for (int j = 0; j < kernelRadius ; j++){
        currPos += randomDirStep;
        // check if it's at clipping plane, if so return full brightness
        if (all(greaterThan(currPos, vec3(EPSILON))) && all(lessThan(currPos,vec3(1.0-EPSILON)))){
          opacity = texture2D(otexture, vec2(getTextureValue(currPos).r * oscale0 + oshift0, 0.5)).r;
          #ifdef vtkGradientOpacityOn
             opacity *= computeGradientOpacityFactor(normal.w, goscale0, goshift0, gomin0, gomax0);
          #endif
          transmittance *= 1.0 - opacity;
        }
        else{
          break;
        }
      }
      total_transmittance += transmittance / float(kernelRadius) * weight;

      // early termination if fully translucent
      if (total_transmittance > 1.0 - EPSILON){
        return 1.0;
      }
    }
    // average transmittance and reduce variance
    return clamp(total_transmittance / float(kernelSize), 0.3, 1.0);
  } else {
    return 1.0;
  }
}
#endif

//=======================================================================
// surface light contribution
#if vtkLightComplexity > 0
  void applyLighting(inout vec3 tColor, vec4 normal)
  {
    vec3 diffuse = vec3(0.0, 0.0, 0.0);
    vec3 specular = vec3(0.0, 0.0, 0.0);
    float df, sf = 0.0;
    for (int i = 0; i < lightNum; i++){
        df = abs(dot(normal.rgb, -lightDirectionVC[i]));
        diffuse += df * lightColor[i];
        sf = pow( abs(dot(lightHalfAngleVC[i],normal.rgb)), vSpecularPower);
        specular += sf * lightColor[i];
    }
    tColor.rgb = tColor.rgb*(diffuse*vDiffuse + vAmbient) + specular*vSpecular;
  }
  #ifdef SurfaceShadowOn
  #if vtkLightComplexity < 3
    vec3 applyLightingDirectional(vec3 posIS, vec4 tColor, vec4 normal)
    {
      // everything in VC
      vec3 diffuse = vec3(0.0);
      vec3 specular = vec3(0.0);
      #ifdef localAmbientOcclusionOn
        vec3 ambient = vec3(0.0);
      #endif
      vec3 vertLightDirection;
      for (int i = 0; i < lightNum; i++){
        float ndotL,vdotR;
        vertLightDirection = lightDirectionVC[i];
        ndotL = dot(normal.xyz, vertLightDirection);
        if (ndotL < 0.0 && twoSidedLighting)
        {
          ndotL = -ndotL;
        }
        if (ndotL > 0.0)
        {
          diffuse += ndotL * lightColor[i];
          //specular
          vdotR = dot(-rayDirVC, normalize(2.0 * ndotL * -normal.xyz + vertLightDirection));
          if (vdotR > 0.0)
          {
            specular += pow(vdotR, vSpecularPower) * lightColor[i];
          }
        }
        #ifdef localAmbientOcclusionOn
            ambient += computeLAO(posIS, tColor.a, vertLightDirection, normal);
        #endif
      }
      #ifdef localAmbientOcclusionOn
        return tColor.rgb * (diffuse * vDiffuse + vAmbient * ambient) + specular*vSpecular;
      #else
        return tColor.rgb * (diffuse * vDiffuse + vAmbient) + specular*vSpecular;
      #endif
    }
  #else
    vec3 applyLightingPositional(vec3 posIS, vec4 tColor, vec4 normal, vec3 posVC)
    {
      // everything in VC
      vec3 diffuse = vec3(0.0);
      vec3 specular = vec3(0.0);
      #ifdef localAmbientOcclusionOn
        vec3 ambient = vec3(0.0);
      #endif
      vec3 vertLightDirection;
      for (int i = 0; i < lightNum; i++){
        float distance,attenuation,ndotL,vdotR;
        vec3 lightDir;
        if (lightPositional[i] == 1){
          lightDir = lightDirectionVC[i];
          vertLightDirection = posVC - lightPositionVC[i];
          distance = length(vertLightDirection);
          vertLightDirection = normalize(vertLightDirection);
          attenuation = 1.0 / (lightAttenuation[i].x
                              + lightAttenuation[i].y * distance
                              + lightAttenuation[i].z * distance * distance);
          // per OpenGL standard cone angle is 90 or less for a spot light
          if (lightConeAngle[i] <= 90.0){
            float coneDot = dot(vertLightDirection, lightDir);
            if (coneDot >= cos(radians(lightConeAngle[i]))){  // if inside cone
              attenuation = attenuation * pow(coneDot, lightExponent[i]);
            }
            else {
              attenuation = 0.0;
            }
          }
          ndotL = dot(normal.xyz, vertLightDirection);
          if (ndotL < 0.0 && twoSidedLighting)
          {
            ndotL = -ndotL;
          }
          if (ndotL > 0.0)
          {
            diffuse += ndotL * attenuation * lightColor[i];
            //specular
            vdotR = dot(-rayDirVC, normalize(2.0 * ndotL * -normal.xyz + vertLightDirection));
            if (vdotR > 0.0)
            {
              specular += pow(vdotR, vSpecularPower) * attenuation * lightColor[i];
            }
          }
          #ifdef localAmbientOcclusionOn
            ambient += computeLAO(posIS, tColor.a, vertLightDirection, normal);
          #endif
        } else {
          vertLightDirection = lightDirectionVC[i];
          ndotL = dot(normal.xyz, vertLightDirection);
          if (ndotL < 0.0 && twoSidedLighting)
          {
            ndotL = -ndotL;
          }
          if (ndotL > 0.0)
          {
            diffuse += ndotL * lightColor[i];
            //specular
            vdotR = dot(-rayDirVC, normalize(2.0 * ndotL * -normal.xyz + vertLightDirection));
            if (vdotR > 0.0)
            {
              specular += pow(vdotR, vSpecularPower) * lightColor[i];
            }
          }
          #ifdef localAmbientOcclusionOn
            ambient += computeLAO(posIS, tColor.a, vertLightDirection, normal);
          #endif
        }
      }
      #ifdef localAmbientOcclusionOn
        return tColor.rgb * (diffuse * vDiffuse + vAmbient * ambient) + specular*vSpecular;
      #else
        return tColor.rgb * (diffuse * vDiffuse + vAmbient) + specular*vSpecular;
      #endif
    }
  #endif
  #endif
#endif

// LAO of surface shadows and volume shadows only work with dependent components
vec3 applyAllLightning(vec3 tColor, float alpha, vec3 posIS, vec4 normalLight) {
  #if vtkLightComplexity > 0
    // surface shadows if needed
    #ifdef SurfaceShadowOn
      #if vtkLightComplexity < 3
        vec3 tColorS = applyLightingDirectional(posIS, vec4(tColor, alpha), normalLight);
      #else
        vec3 tColorS = applyLightingPositional(posIS, vec4(tColor, alpha), normalLight, IStoVC(posIS));
      #endif
    #endif

    // volume shadows if needed
    #ifdef VolumeShadowOn
      vec3 tColorVS = applyShadowRay(tColor, posIS, rayDirVC);
    #endif

    // merge
    #ifdef VolumeShadowOn
      #ifdef SurfaceShadowOn
        // surface shadows + volumetric shadows
        float vol_coef = volumetricScatteringBlending * (1.0 - alpha / 2.0) * (1.0 - atan(normalLight.w) * INV4PI);
        tColor = (1.0-vol_coef) * tColorS + vol_coef * tColorVS;
      #else
        // volumetric shadows only
        tColor = tColorVS;
      #endif
    #else
      #ifdef SurfaceShadowOn
        // surface shadows only
        tColor = tColorS;
      #else
        // no shadows
        applyLighting(tColor, normal3);
      #endif
    #endif
  #endif
  return tColor;
}

//=======================================================================
// Given a texture value compute the color and opacity
//
vec4 getColorForValue(vec4 tValue, vec3 posIS, vec3 tstep)
{
#ifdef vtkImageLabelOutlineOn
  vec3 centerPosIS = fragCoordToIndexSpace(gl_FragCoord); // pos in texture space
  vec4 centerValue = getTextureValue(centerPosIS);
  bool pixelOnBorder = false;
  vec4 tColor = texture2D(ctexture, vec2(centerValue.r * cscale0 + cshift0, 0.5));

  // Get alpha of segment from opacity function.
  tColor.a = texture2D(otexture, vec2(centerValue.r * oscale0 + oshift0, 0.5)).r;

  int segmentIndex = int(centerValue.r * 255.0);
  
  // Use texture sampling for outlineThickness
  float textureCoordinate = float(segmentIndex - 1) / 1024.0;
  float textureValue = texture2D(ttexture, vec2(textureCoordinate, 0.5)).r;

  int actualThickness = int(textureValue * 255.0);

  if (actualThickness == 0) {
    return vec4(0, 0, 1, 1);
  }

  // If it is the background (segment index 0), we should quickly bail out. 
  // Previously, this was determined by tColor.a, which was incorrect as it
  // prevented the outline from appearing when the fill is 0.
  if (segmentIndex == 0){
    return vec4(0, 0, 0, 0);
  }

  // Only perform outline check on fragments rendering voxels that aren't invisible.
  // Saves a bunch of needless checks on the background.
  // TODO define epsilon when building shader?
  for (int i = -actualThickness; i <= actualThickness; i++) {
    for (int j = -actualThickness; j <= actualThickness; j++) {
      if (i == 0 || j == 0) {
        continue;
      }

      vec4 neighborPixelCoord = vec4(gl_FragCoord.x + float(i),
        gl_FragCoord.y + float(j),
        gl_FragCoord.z, gl_FragCoord.w);

      vec3 neighborPosIS = fragCoordToIndexSpace(neighborPixelCoord);
      vec4 value = getTextureValue(neighborPosIS);

      // If any of my neighbours are not the same value as I
      // am, this means I am on the border of the segment.
      // We can break the loops
      if (any(notEqual(value, centerValue))) {
        pixelOnBorder = true;
        break;
      }
    }

    if (pixelOnBorder == true) {
      break;
    }
  }

  // If I am on the border, I am displayed at full opacity
  if (pixelOnBorder == true) {
    tColor.a = outlineOpacity;
  }

  return tColor;

#else
  // compute the normal and gradient magnitude if needed
  // We compute it as a vec4 if possible otherwise a mat4

  #ifdef UseIndependentComponents
    // sample textures
    vec3 tColor0 = texture2D(ctexture, vec2(tValue.r * cscale0 + cshift0, height0)).rgb;
    float pwfValue0 = texture2D(otexture, vec2(tValue.r * oscale0 + oshift0, height0)).r;

    #if vtkNumComponents > 1
      vec3 tColor1 = texture2D(ctexture, vec2(tValue.g * cscale1 + cshift1, height1)).rgb;
      float pwfValue1 = texture2D(otexture, vec2(tValue.g * oscale1 + oshift1, height1)).r;

      #if vtkNumComponents > 2
        vec3 tColor2 = texture2D(ctexture, vec2(tValue.b * cscale2 + cshift2, height2)).rgb;
        float pwfValue2 = texture2D(otexture, vec2(tValue.b * oscale2 + oshift2, height2)).r;

        #if vtkNumComponents > 3
          vec3 tColor3 = texture2D(ctexture, vec2(tValue.a * cscale3 + cshift3, height3)).rgb;
          float pwfValue3 = texture2D(otexture, vec2(tValue.a * oscale3 + oshift3, height3)).r;
        #endif
      #endif
    #endif

    #if !defined(vtkCustomComponentsColorMix)
      // default path for component color mix

      // compute the normal vectors as needed
      #if (vtkLightComplexity > 0) || defined(vtkGradientOpacityOn)
        mat4 normalMat = computeMat4Normal(posIS, tValue, tstep);
      #endif

      // compute gradient opacity factors as needed
      vec4 goFactor = vec4(1.0, 1.0 ,1.0 ,1.0);
      #if defined(vtkGradientOpacityOn)
        #if !defined(vtkComponent0Proportional)
          goFactor.x =
            computeGradientOpacityFactor(normalMat[0].a, goscale0, goshift0, gomin0, gomax0);
        #endif
        #if vtkNumComponents > 1
          #if !defined(vtkComponent1Proportional)
            goFactor.y =
              computeGradientOpacityFactor(normalMat[1].a, goscale1, goshift1, gomin1, gomax1);
          #endif
          #if vtkNumComponents > 2
            #if !defined(vtkComponent2Proportional)
              goFactor.z =
                computeGradientOpacityFactor(normalMat[2].a, goscale2, goshift2, gomin2, gomax2);
            #endif
            #if vtkNumComponents > 3
              #if !defined(vtkComponent3Proportional)
                goFactor.w =
                  computeGradientOpacityFactor(normalMat[3].a, goscale3, goshift3, gomin3, gomax3);
              #endif
            #endif
          #endif
        #endif
      #endif

      // process color and opacity for each component
      #if !defined(vtkComponent0Proportional)
        float alpha = goFactor.x*mix0*pwfValue0;
        #if vtkLightComplexity > 0
          applyLighting(tColor0, normalMat[0]);
        #endif
      #else
        tColor0 *= pwfValue0;
        float alpha = mix(pwfValue0, 1.0, (1.0 - mix0));
      #endif

      #if vtkNumComponents > 1
        #if !defined(vtkComponent1Proportional)
          alpha += goFactor.y*mix1*pwfValue1;
          #if vtkLightComplexity > 0
            applyLighting(tColor1, normalMat[1]);
          #endif
        #else
          tColor1 *= pwfValue1;
          alpha *= mix(pwfValue1, 1.0, (1.0 - mix1));
        #endif

        #if vtkNumComponents > 2
          #if !defined(vtkComponent2Proportional)
            alpha += goFactor.z*mix2*pwfValue2;
            #if vtkLightComplexity > 0
              applyLighting(tColor2, normalMat[2]);
            #endif
          #else
            tColor2 *= pwfValue2;
            alpha *= mix(pwfValue2, 1.0, (1.0 - mix2));
          #endif
        #endif

        #if vtkNumComponents > 3
          #if !defined(vtkComponent3Proportional)
            alpha += goFactor.w*mix3*pwfValue3;
            #if vtkLightComplexity > 0
              applyLighting(tColor3, normalMat[3]);
            #endif
          #else
            tColor3 *= pwfValue3;
            alpha *= mix(pwfValue3, 1.0, (1.0 - mix3));
          #endif
        #endif
      #endif

      // perform final independent blend
      vec3 tColor = mix0 * tColor0;
      #if vtkNumComponents > 1
        tColor += mix1 * tColor1;
        #if vtkNumComponents > 2
          tColor += mix2 * tColor2;
          #if vtkNumComponents > 3
            tColor += mix3 * tColor3;
          #endif
        #endif
      #endif

      return vec4(tColor, alpha);
    #else
      /*
       * Mix the color information from all the independent components to get a single rgba output
       * Gradient opactity factors and normals are not computed
       *
       * You can compute these using:
       * - computeMat4Normal: always available, compute normal only for non proportional components, used by default independent component mix
       * - computeDensityNormal & computeNormalForDensity: available if ((LightComplexity > 0) || GradientOpacityOn) && ComputeNormalFromOpacity),
       *                                                   used by dependent component color mix, see code for Additive preset in OpenGl/VolumeMapper
       * - computeGradientOpacityFactor: always available, used in a lot of places
       *
       * Using applyAllLightning() is advised for shading but some features don't work well with it (volume shadows, LAO)
       * mix0, mix1, ... are defined for each component that is used and correspond to the componentWeight
       */
      //VTK::CustomComponentsColorMix::Impl
    #endif
  #else
    // dependent components

    // compute normal if needed
    #if (vtkLightComplexity > 0) || defined(vtkGradientOpacityOn)
      // use component 3 of the opacity texture as getTextureValue() sets alpha to the opacity value
      #ifdef vtkComputeNormalFromOpacity
        vec3 scalarInterp[2];
        vec4 normal0 = computeNormalForDensity(posIS, tstep, scalarInterp, 3);
      #else
        vec4 normal0 = computeNormal(posIS, tstep);
      #endif
    #endif

    // compute gradient opacity factor enabled
    #if defined(vtkGradientOpacityOn)
      float gradientOpacity = computeGradientOpacityFactor(normal0.a, goscale0, goshift0, gomin0, gomax0);
    #else
      const float gradientOpacity = 1.0;
    #endif

    // get color and opacity
    #if vtkNumComponents == 1
      vec3 tColor = texture2D(ctexture, vec2(tValue.r * cscale0 + cshift0, 0.5)).rgb;
      float alpha = gradientOpacity*texture2D(otexture, vec2(tValue.r * oscale0 + oshift0, 0.5)).r;
      if (alpha < EPSILON){
        return vec4(0.0);
      }
    #endif
    #if vtkNumComponents == 2
      vec3 tColor = vec3(tValue.r * cscale0 + cshift0);
      float alpha = gradientOpacity*texture2D(otexture, vec2(tValue.a * oscale1 + oshift1, 0.5)).r;
    #endif
    #if vtkNumComponents == 3
      vec3 tColor;
      tColor.r = tValue.r * cscale0 + cshift0;
      tColor.g = tValue.g * cscale1 + cshift1;
      tColor.b = tValue.b * cscale2 + cshift2;
      float alpha = gradientOpacity*texture2D(otexture, vec2(tValue.a * oscale0 + oshift0, 0.5)).r;
    #endif
    #if vtkNumComponents == 4
      vec3 tColor;
      tColor.r = tValue.r * cscale0 + cshift0;
      tColor.g = tValue.g * cscale1 + cshift1;
      tColor.b = tValue.b * cscale2 + cshift2;
      float alpha = gradientOpacity*texture2D(otexture, vec2(tValue.a * oscale3 + oshift3, 0.5)).r;
    #endif

    // lighting
    #if (vtkLightComplexity > 0)
      #ifdef vtkComputeNormalFromOpacity
        vec4 normalLight;
        if (!all(equal(normal0, vec4(0.0)))) {
          scalarInterp[0] = scalarInterp[0] * oscale0 + oshift0;
          scalarInterp[1] = scalarInterp[1] * oscale0 + oshift0;
          normalLight = computeDensityNormal(scalarInterp, 0.5, gradientOpacity);
          if (all(equal(normalLight, vec4(0.0)))) {
            normalLight = normal0;
          }
        }
      #else
        vec4 normalLight = normal0;
      #endif
      tColor = applyAllLightning(tColor, alpha, posIS, normalLight);
    #endif

    return vec4(tColor, alpha);
  #endif // dependent
#endif
}

bool valueWithinScalarRange(vec4 val, vec4 min, vec4 max) {
  bool withinRange = false;
  #if vtkNumComponents == 1
    if (val.r >= min.r && val.r <= max.r) {
      withinRange = true;
    }
  #else
    #ifdef UseIndependentComponents
      #if vtkNumComponents == 2
        if (val.r >= min.r && val.r <= max.r &&
            val.g >= min.g && val.g <= max.g) {
          withinRange = true;
        }
      #else
        if (all(greaterThanEqual(val, ipScalarRangeMin)) &&
            all(lessThanEqual(val, ipScalarRangeMax))) {
          withinRange = true;
        }
      #endif
    #endif
  #endif
  return withinRange;
}

//=======================================================================
// Apply the specified blend mode operation along the ray's path.
//
void applyBlend(vec3 posIS, vec3 endIS, vec3 tdims)
{
  vec3 tstep = 1.0/tdims;

  // start slightly inside and apply some jitter
  vec3 delta = endIS - posIS;
  vec3 stepIS = normalize(delta)*sampleDistanceIS;
  float raySteps = length(delta)/sampleDistanceIS;

  // avoid 0.0 jitter
  float jitter = 0.01 + 0.99*texture2D(jtexture, gl_FragCoord.xy/32.0).r;
  float stepsTraveled = jitter;

  // local vars for the loop
  vec4 color = vec4(0.0, 0.0, 0.0, 0.0);
  vec4 tValue;
  vec4 tColor;

  // if we have less than one step then pick the middle point
  // as our value
  // if (raySteps <= 1.0)
  // {
  //   posIS = (posIS + endIS)*0.5;
  // }

  // Perform initial step at the volume boundary
  // compute the scalar
  tValue = getTextureValue(posIS);

  #if vtkBlendMode == 0 // COMPOSITE_BLEND
    // now map through opacity and color
    tColor = getColorForValue(tValue, posIS, tstep);

    // handle very thin volumes
    if (raySteps <= 1.0)
    {
      tColor.a = 1.0 - pow(1.0 - tColor.a, raySteps);
      gl_FragData[0] = tColor;
      return;
    }

    tColor.a = 1.0 - pow(1.0 - tColor.a, jitter);
    color = vec4(tColor.rgb*tColor.a, tColor.a);
    posIS += (jitter*stepIS);

    for (int i = 0; i < //VTK::MaximumSamplesValue ; ++i)
    {
      if (stepsTraveled + 1.0 >= raySteps) { break; }

      // compute the scalar
      tValue = getTextureValue(posIS);

      // now map through opacity and color
      tColor = getColorForValue(tValue, posIS, tstep);

      float mix = (1.0 - color.a);

      // this line should not be needed but nvidia seems to not handle
      // the break correctly on windows/chrome 58 angle
      //mix = mix * sign(max(raySteps - stepsTraveled - 1.0, 0.0));

      color = color + vec4(tColor.rgb*tColor.a, tColor.a)*mix;
      stepsTraveled++;
      posIS += stepIS;
      if (color.a > 0.99) { color.a = 1.0; break; }
    }

    if (color.a < 0.99 && (raySteps - stepsTraveled) > 0.0)
    {
      posIS = endIS;

      // compute the scalar
      tValue = getTextureValue(posIS);

      // now map through opacity and color
      tColor = getColorForValue(tValue, posIS, tstep);
      tColor.a = 1.0 - pow(1.0 - tColor.a, raySteps - stepsTraveled);

      float mix = (1.0 - color.a);
      color = color + vec4(tColor.rgb*tColor.a, tColor.a)*mix;
    }

    gl_FragData[0] = vec4(color.rgb/color.a, color.a);
  #endif
  #if vtkBlendMode == 1 || vtkBlendMode == 2
    // MAXIMUM_INTENSITY_BLEND || MINIMUM_INTENSITY_BLEND
    // Find maximum/minimum intensity along the ray.

    // Define the operation we will use (min or max)
    #if vtkBlendMode == 1
    #define OP max
    #else
    #define OP min
    #endif

    // If the clipping range is shorter than the sample distance
    // we can skip the sampling loop along the ray.
    if (raySteps <= 1.0)
    {
      gl_FragData[0] = getColorForValue(tValue, posIS, tstep);
      return;
    }

    vec4 value = tValue;
    posIS += (jitter*stepIS);

    // Sample along the ray until MaximumSamplesValue,
    // ending slightly inside the total distance
    for (int i = 0; i < //VTK::MaximumSamplesValue ; ++i)
    {
      // If we have reached the last step, break
      if (stepsTraveled + 1.0 >= raySteps) { break; }

      // compute the scalar
      tValue = getTextureValue(posIS);

      // Update the maximum value if necessary
      value = OP(tValue, value);

      // Otherwise, continue along the ray
      stepsTraveled++;
      posIS += stepIS;
    }

    // Perform the last step along the ray using the
    // residual distance
    posIS = endIS;
    tValue = getTextureValue(posIS);
    value = OP(tValue, value);

    // Now map through opacity and color
    gl_FragData[0] = getColorForValue(value, posIS, tstep);
  #endif
  #if vtkBlendMode == 3 || vtkBlendMode == 4 //AVERAGE_INTENSITY_BLEND || ADDITIVE_BLEND
    vec4 sum = vec4(0.);

    if (valueWithinScalarRange(tValue, ipScalarRangeMin, ipScalarRangeMax)) {
      sum += tValue;
    }

    if (raySteps <= 1.0) {
      gl_FragData[0] = getColorForValue(sum, posIS, tstep);
      return;
    }

    posIS += (jitter*stepIS);

    // Sample along the ray until MaximumSamplesValue,
    // ending slightly inside the total distance
    for (int i = 0; i < //VTK::MaximumSamplesValue ; ++i)
    {
      // If we have reached the last step, break
      if (stepsTraveled + 1.0 >= raySteps) { break; }

      // compute the scalar
      tValue = getTextureValue(posIS);

      // One can control the scalar range by setting the AverageIPScalarRange to disregard scalar values, not in the range of interest, from the average computation.
      // Notes:
      // - We are comparing all values in the texture to see if any of them
      //   are outside of the scalar range. In the future we might want to allow
      //   scalar ranges for each component.
      if (valueWithinScalarRange(tValue, ipScalarRangeMin, ipScalarRangeMax)) {
        // Sum the values across each step in the path
        sum += tValue;
      }
      stepsTraveled++;
      posIS += stepIS;
    }

    // Perform the last step along the ray using the
    // residual distance
    posIS = endIS;

    // compute the scalar
    tValue = getTextureValue(posIS);

    // One can control the scalar range by setting the IPScalarRange to disregard scalar values, not in the range of interest, from the average computation
    if (valueWithinScalarRange(tValue, ipScalarRangeMin, ipScalarRangeMax)) {
      sum += tValue;

      stepsTraveled++;
    }

    #if vtkBlendMode == 3 // Average
      sum /= vec4(stepsTraveled, stepsTraveled, stepsTraveled, 1.0);
    #endif

    gl_FragData[0] = getColorForValue(sum, posIS, tstep);
  #endif
  #if vtkBlendMode == 5 // RADON
    float normalizedRayIntensity = 1.0;

    // handle very thin volumes
    if (raySteps <= 1.0)
    {
      tValue = getTextureValue(posIS);
      normalizedRayIntensity = normalizedRayIntensity - sampleDistance*texture2D(otexture, vec2(tValue.r * oscale0 + oshift0, 0.5)).r;
      gl_FragData[0] = texture2D(ctexture, vec2(normalizedRayIntensity, 0.5));
      return;
    }

    posIS += (jitter*stepIS);

    for (int i = 0; i < //VTK::MaximumSamplesValue ; ++i)
    {
      if (stepsTraveled + 1.0 >= raySteps) { break; }

      // compute the scalar value
      tValue = getTextureValue(posIS);

      // Convert scalar value to normalizedRayIntensity coefficient and accumulate normalizedRayIntensity
      normalizedRayIntensity = normalizedRayIntensity - sampleDistance*texture2D(otexture, vec2(tValue.r * oscale0 + oshift0, 0.5)).r;

      posIS += stepIS;
      stepsTraveled++;
    }

    // map normalizedRayIntensity to color
    gl_FragData[0] = texture2D(ctexture, vec2(normalizedRayIntensity , 0.5));

  #endif
}

//=======================================================================
// Compute a new start and end point for a given ray based
// on the provided bounded clipping plane (aka a rectangle)
void getRayPointIntersectionBounds(
  vec3 rayPos, vec3 rayDir,
  vec3 planeDir, float planeDist,
  inout vec2 tbounds, vec3 vPlaneX, vec3 vPlaneY,
  float vSize1, float vSize2)
{
  float result = dot(rayDir, planeDir);
  if (abs(result) < 1e-6)
  {
    return;
  }
  result = -1.0 * (dot(rayPos, planeDir) + planeDist) / result;
  vec3 xposVC = rayPos + rayDir*result;
  vec3 vxpos = xposVC - vOriginVC;
  vec2 vpos = vec2(
    dot(vxpos, vPlaneX),
    dot(vxpos, vPlaneY));

  // on some apple nvidia systems this does not work
  // if (vpos.x < 0.0 || vpos.x > vSize1 ||
  //     vpos.y < 0.0 || vpos.y > vSize2)
  // even just
  // if (vpos.x < 0.0 || vpos.y < 0.0)
  // fails
  // so instead we compute a value that represents in and out
  //and then compute the return using this value
  float xcheck = max(0.0, vpos.x * (vpos.x - vSize1)); //  0 means in bounds
  float check = sign(max(xcheck, vpos.y * (vpos.y - vSize2))); //  0 means in bounds, 1 = out

  tbounds = mix(
   vec2(min(tbounds.x, result), max(tbounds.y, result)), // in value
   tbounds, // out value
   check);  // 0 in 1 out
}

//=======================================================================
// given a
// - ray direction (rayDir)
// - starting point (vertexVCVSOutput)
// - bounding planes of the volume
// - optionally depth buffer values
// - far clipping plane
// compute the start/end distances of the ray we need to cast
vec2 computeRayDistances(vec3 rayDir, vec3 tdims)
{
  vec2 dists = vec2(100.0*camFar, -1.0);

  vec3 vSize = vSpacing*tdims;

  // all this is in View Coordinates
  getRayPointIntersectionBounds(vertexVCVSOutput, rayDir,
    vPlaneNormal0, vPlaneDistance0, dists, vPlaneNormal2, vPlaneNormal4,
    vSize.y, vSize.z);
  getRayPointIntersectionBounds(vertexVCVSOutput, rayDir,
    vPlaneNormal1, vPlaneDistance1, dists, vPlaneNormal2, vPlaneNormal4,
    vSize.y, vSize.z);
  getRayPointIntersectionBounds(vertexVCVSOutput, rayDir,
    vPlaneNormal2, vPlaneDistance2, dists, vPlaneNormal0, vPlaneNormal4,
    vSize.x, vSize.z);
  getRayPointIntersectionBounds(vertexVCVSOutput, rayDir,
    vPlaneNormal3, vPlaneDistance3, dists, vPlaneNormal0, vPlaneNormal4,
    vSize.x, vSize.z);
  getRayPointIntersectionBounds(vertexVCVSOutput, rayDir,
    vPlaneNormal4, vPlaneDistance4, dists, vPlaneNormal0, vPlaneNormal2,
    vSize.x, vSize.y);
  getRayPointIntersectionBounds(vertexVCVSOutput, rayDir,
    vPlaneNormal5, vPlaneDistance5, dists, vPlaneNormal0, vPlaneNormal2,
    vSize.x, vSize.y);

  //VTK::ClipPlane::Impl

  // do not go behind front clipping plane
  dists.x = max(0.0,dists.x);

  // do not go PAST far clipping plane
  float farDist = -camThick/rayDir.z;
  dists.y = min(farDist,dists.y);

  // Do not go past the zbuffer value if set
  // This is used for intermixing opaque geometry
  //VTK::ZBuffer::Impl

  return dists;
}

//=======================================================================
// Compute the index space starting position (pos) and end
// position
//
void computeIndexSpaceValues(out vec3 pos, out vec3 endPos, vec3 rayDir, vec2 dists)
{
  // compute starting and ending values in volume space
  pos = vertexVCVSOutput + dists.x*rayDir;
  pos = pos - vOriginVC;
  // convert to volume basis and origin
  pos = vec3(
    dot(pos, vPlaneNormal0),
    dot(pos, vPlaneNormal2),
    dot(pos, vPlaneNormal4));

  endPos = vertexVCVSOutput + dists.y*rayDir;
  endPos = endPos - vOriginVC;
  endPos = vec3(
    dot(endPos, vPlaneNormal0),
    dot(endPos, vPlaneNormal2),
    dot(endPos, vPlaneNormal4));

  float delta = length(endPos - pos);

  pos *= vVCToIJK;
  endPos *= vVCToIJK;

  float delta2 = length(endPos - pos);
  sampleDistanceIS = sampleDistance*delta2/delta;
  #ifdef VolumeShadowOn
    sampleDistanceISVS = sampleDistanceIS * volumeShadowSamplingDistFactor;
  #endif
}

void main()
{

  if (cameraParallel == 1)
  {
    // Camera is parallel, so the rayDir is just the direction of the camera.
    rayDirVC = vec3(0.0, 0.0, -1.0);
  } else {
    // camera is at 0,0,0 so rayDir for perspective is just the vc coord
    rayDirVC = normalize(vertexVCVSOutput);
  }

  vec3 tdims = vec3(volumeDimensions);

  // compute the start and end points for the ray
  vec2 rayStartEndDistancesVC = computeRayDistances(rayDirVC, tdims);

  // do we need to composite? aka does the ray have any length
  // If not, bail out early
  if (rayStartEndDistancesVC.y <= rayStartEndDistancesVC.x)
  {
    discard;
  }

  // IS = Index Space
  vec3 posIS;
  vec3 endIS;
  computeIndexSpaceValues(posIS, endIS, rayDirVC, rayStartEndDistancesVC);

  // Perform the blending operation along the ray
  applyBlend(posIS, endIS, tdims);
}
`;
const {
  vtkWarningMacro: Px,
  vtkErrorMacro: oM
} = kr;
function GO(i, t, e) {
  return i ? `${i.getMTime()}-${t}-${e}` : "0";
}
function Jlt(i) {
  switch (i) {
    case oN.CUSTOM:
      return "//VTK::CustomColorMix";
    case oN.ADDITIVE:
      return `
        // compute normals
        mat4 normalMat = computeMat4Normal(posIS, tValue, tstep);
        #if (vtkLightComplexity > 0) && defined(vtkComputeNormalFromOpacity)
          vec3 scalarInterp0[2];
          vec4 normalLight0 = computeNormalForDensity(posIS, tstep, scalarInterp0, 0);
          scalarInterp0[0] = scalarInterp0[0] * oscale0 + oshift0;
          scalarInterp0[1] = scalarInterp0[1] * oscale0 + oshift0;
          normalLight0 = computeDensityNormal(scalarInterp0, height0, 1.0);

          vec3 scalarInterp1[2];
          vec4 normalLight1 = computeNormalForDensity(posIS, tstep, scalarInterp1, 1);
          scalarInterp1[0] = scalarInterp1[0] * oscale1 + oshift1;
          scalarInterp1[1] = scalarInterp1[1] * oscale1 + oshift1;
          normalLight1 = computeDensityNormal(scalarInterp1, height1, 1.0);
        #else
          vec4 normalLight0 = normalMat[0];
          vec4 normalLight1 = normalMat[1];
        #endif

        // compute opacities
        float opacity0 = pwfValue0;
        float opacity1 = pwfValue1;
        #ifdef vtkGradientOpacityOn
          float gof0 = computeGradientOpacityFactor(normalMat[0].a, goscale0, goshift0, gomin0, gomax0);
          opacity0 *= gof0;
          float gof1 = computeGradientOpacityFactor(normalMat[1].a, goscale1, goshift1, gomin1, gomax1);
          opacity1 *= gof1;
        #endif
        float opacitySum = opacity0 + opacity1;
        if (opacitySum <= 0.0) {
          return vec4(0.0);
        }

        // mix the colors and opacities
        tColor0 = applyAllLightning(tColor0, opacity0, posIS, normalLight0);
        tColor1 = applyAllLightning(tColor1, opacity1, posIS, normalLight1);
        vec3 mixedColor = (opacity0 * tColor0 + opacity1 * tColor1) / opacitySum;
        return vec4(mixedColor, min(1.0, opacitySum));
`;
    case oN.COLORIZE:
      return `
        // compute normals
        mat4 normalMat = computeMat4Normal(posIS, tValue, tstep);
        #if (vtkLightComplexity > 0) && defined(vtkComputeNormalFromOpacity)
          vec3 scalarInterp0[2];
          vec4 normalLight0 = computeNormalForDensity(posIS, tstep, scalarInterp0, 0);
          scalarInterp0[0] = scalarInterp0[0] * oscale0 + oshift0;
          scalarInterp0[1] = scalarInterp0[1] * oscale0 + oshift0;
          normalLight0 = computeDensityNormal(scalarInterp0, height0, 1.0);
        #else
          vec4 normalLight0 = normalMat[0];
        #endif

        // compute opacities
        float opacity0 = pwfValue0;
        #ifdef vtkGradientOpacityOn
          float gof0 = computeGradientOpacityFactor(normalMat[0].a, goscale0, goshift0, gomin0, gomax0);
          opacity0 *= gof0;
        #endif

        // mix the colors and opacities
        vec3 color = tColor0 * mix(vec3(1.0), tColor1, pwfValue1);
        color = applyAllLightning(color, opacity0, posIS, normalLight0);
        return vec4(color, opacity0);
`;
    default:
      return null;
  }
}
function Alt(i, t) {
  t.classHierarchy.push("vtkOpenGLVolumeMapper"), i.buildPass = () => {
    t.zBufferTexture = null;
  }, i.zBufferPass = (n, s) => {
    if (n) {
      const r = s.getZBufferTexture();
      r !== t.zBufferTexture && (t.zBufferTexture = r);
    }
  }, i.opaqueZBufferPass = (n, s) => i.zBufferPass(n, s), i.volumePass = (n, s) => {
    if (n) {
      t._openGLRenderWindow = i.getFirstAncestorOfType("vtkOpenGLRenderWindow"), t.context = t._openGLRenderWindow.getContext(), t.tris.setOpenGLRenderWindow(t._openGLRenderWindow), t.jitterTexture.setOpenGLRenderWindow(t._openGLRenderWindow), t.framebuffer.setOpenGLRenderWindow(t._openGLRenderWindow), t.scalarTexture.setOpenGLRenderWindow(t._openGLRenderWindow), t.colorTexture.setOpenGLRenderWindow(t._openGLRenderWindow), t.opacityTexture.setOpenGLRenderWindow(t._openGLRenderWindow), t.labelOutlineThicknessTexture.setOpenGLRenderWindow(t._openGLRenderWindow), t.openGLVolume = i.getFirstAncestorOfType("vtkOpenGLVolume");
      const r = t.openGLVolume.getRenderable();
      t._openGLRenderer = i.getFirstAncestorOfType("vtkOpenGLRenderer");
      const a = t._openGLRenderer.getRenderable();
      t.openGLCamera = t._openGLRenderer.getViewNodeFor(a.getActiveCamera()), i.renderPiece(a, r);
    }
  }, i.getShaderTemplate = (n, s, r) => {
    n.Vertex = Ult, n.Fragment = Plt, n.Geometry = "";
  }, i.useIndependentComponents = (n) => {
    var l, c;
    const s = n.getIndependentComponents(), r = t.currentInput, a = (c = (l = r == null ? void 0 : r.getPointData()) == null ? void 0 : l.getScalars()) == null ? void 0 : c.getNumberOfComponents(), o = n.getColorMixPreset();
    return s && a >= 2 || !!o;
  }, i.replaceShaderValues = (n, s, r) => {
    const a = r.getProperty();
    let o = n.Fragment;
    a.getInterpolationType() === Uh.LINEAR && (o = Ft.substitute(o, "//VTK::TrilinearOn", "#define vtkTrilinearOn").result), a.getUseLabelOutline() === !0 && (o = Ft.substitute(o, "//VTK::ImageLabelOutlineOn", "#define vtkImageLabelOutlineOn").result);
    const u = t.scalarTexture.getComponents();
    o = Ft.substitute(o, "//VTK::NumComponents", `#define vtkNumComponents ${u}`).result;
    const d = i.useIndependentComponents(a);
    d && (o = Ft.substitute(o, "//VTK::IndependentComponentsOn", "#define UseIndependentComponents").result);
    const h = [], p = [];
    for (let M = 0; M < u; M++)
      a.getOpacityMode(M) === Dj.PROPORTIONAL && h.push(`#define vtkComponent${M}Proportional`), a.getForceNearestInterpolation(M) && p.push(`#define vtkComponent${M}ForceNearest`);
    o = Ft.substitute(o, "//VTK::vtkProportionalComponents", h.join(`
`)).result, o = Ft.substitute(o, "//VTK::vtkForceNearestComponents", p.join(`
`)).result;
    const m = a.getColorMixPreset(), b = Jlt(m);
    b && (o = Ft.substitute(o, "//VTK::CustomComponentsColorMixOn", "#define vtkCustomComponentsColorMix").result, o = Ft.substitute(o, "//VTK::CustomComponentsColorMix::Impl", b).result);
    const y = t.currentInput.getSpatialExtent(), Z = t.currentInput.getSpacing(), g = new Float64Array(3);
    I.set(g, (y[1] - y[0]) * Z[0], (y[3] - y[2]) * Z[1], (y[5] - y[4]) * Z[2]);
    const f = I.length(g) / i.getCurrentSampleDistance(s);
    o = Ft.substitute(o, "//VTK::MaximumSamplesValue", `${Math.ceil(f)}`).result, o = Ft.substitute(o, "//VTK::LightComplexity", `#define vtkLightComplexity ${t.lightComplexity}`).result, t.lightComplexity > 0 && (t.renderable.getVolumetricScatteringBlending() > 0 && (o = Ft.substitute(o, "//VTK::VolumeShadowOn", "#define VolumeShadowOn").result), t.renderable.getVolumetricScatteringBlending() < 1 && (o = Ft.substitute(o, "//VTK::SurfaceShadowOn", "#define SurfaceShadowOn").result), t.renderable.getLocalAmbientOcclusion() && a.getAmbient() > 0 && (o = Ft.substitute(o, "//VTK::localAmbientOcclusionOn", "#define localAmbientOcclusionOn").result));
    const T = d ? u : 1;
    t.gopacity = !1;
    for (let M = 0; !t.gopacity && M < T; ++M)
      t.gopacity || (t.gopacity = a.getUseGradientOpacity(M));
    t.gopacity && (o = Ft.substitute(o, "//VTK::GradientOpacityOn", "#define vtkGradientOpacityOn").result), t.renderable.getComputeNormalFromOpacity() && (o = Ft.substitute(o, "//VTK::vtkComputeNormalFromOpacity", "#define vtkComputeNormalFromOpacity").result), t.zBufferTexture !== null && (o = Ft.substitute(o, "//VTK::ZBuffer::Dec", ["uniform sampler2D zBufferTexture;", "uniform float vpZWidth;", "uniform float vpZHeight;"]).result, o = Ft.substitute(o, "//VTK::ZBuffer::Impl", ["vec4 depthVec = texture2D(zBufferTexture, vec2(gl_FragCoord.x / vpZWidth, gl_FragCoord.y/vpZHeight));", "float zdepth = (depthVec.r*256.0 + depthVec.g)/257.0;", "zdepth = zdepth * 2.0 - 1.0;", "if (cameraParallel == 0) {", "zdepth = -2.0 * camFar * camNear / (zdepth*(camFar-camNear)-(camFar+camNear)) - camNear;}", "else {", `zdepth = (zdepth + 1.0) * 0.5 * (camFar - camNear);}
`, "zdepth = -zdepth/rayDir.z;", "dists.y = min(zdepth,dists.y);"]).result), o = Ft.substitute(o, "//VTK::BlendMode", `${t.renderable.getBlendMode()}`).result, n.Fragment = o, i.replaceShaderLight(n, s, r), i.replaceShaderClippingPlane(n, s, r);
  }, i.replaceShaderLight = (n, s, r) => {
    if (t.lightComplexity === 0)
      return;
    let a = n.Fragment, o = 0;
    s.getLights().forEach((l) => {
      l.getSwitch() && (o += 1);
    }), a = Ft.substitute(a, "//VTK::Light::Dec", ["uniform int lightNum;", "uniform bool twoSidedLighting;", `uniform vec3 lightColor[${o}];`, `uniform vec3 lightDirectionVC[${o}]; // normalized`, `uniform vec3 lightHalfAngleVC[${o}];`, "//VTK::Light::Dec"], !1).result, t.lightComplexity === 3 && (a = Ft.substitute(a, "//VTK::Light::Dec", [`uniform vec3 lightPositionVC[${o}];`, `uniform vec3 lightAttenuation[${o}];`, `uniform float lightConeAngle[${o}];`, `uniform float lightExponent[${o}];`, `uniform int lightPositional[${o}];`], !1).result), t.renderable.getVolumetricScatteringBlending() > 0 && (a = Ft.substitute(a, "//VTK::VolumeShadow::Dec", ["uniform float volumetricScatteringBlending;", "uniform float giReach;", "uniform float volumeShadowSamplingDistFactor;", "uniform float anisotropy;", "uniform float anisotropy2;"], !1).result), t.renderable.getLocalAmbientOcclusion() && r.getProperty().getAmbient() > 0 && (a = Ft.substitute(a, "//VTK::LAO::Dec", ["uniform int kernelRadius;", `uniform vec2 kernelSample[${t.renderable.getLAOKernelRadius()}];`, "uniform int kernelSize;"], !1).result), n.Fragment = a;
  }, i.replaceShaderClippingPlane = (n, s, r) => {
    let a = n.Fragment;
    if (t.renderable.getClippingPlanes().length > 0) {
      const o = t.renderable.getClippingPlanes().length;
      a = Ft.substitute(a, "//VTK::ClipPlane::Dec", ["uniform vec3 vClipPlaneNormals[6];", "uniform float vClipPlaneDistances[6];", "uniform vec3 vClipPlaneOrigins[6];", "uniform int clip_numPlanes;", "//VTK::ClipPlane::Dec", "#define vtkClippingPlanesOn"], !1).result, a = Ft.substitute(a, "//VTK::ClipPlane::Impl", [`for(int i = 0; i < ${o}; i++) {`, "  float rayDirRatio = dot(rayDir, vClipPlaneNormals[i]);", "  float equationResult = dot(vertexVCVSOutput, vClipPlaneNormals[i]) + vClipPlaneDistances[i];", "  if (rayDirRatio == 0.0)", "  {", "    if (equationResult < 0.0) dists.x = dists.y;", "    continue;", "  }", "  float result = -1.0 * equationResult / rayDirRatio;", "  if (rayDirRatio < 0.0) dists.y = min(dists.y, result);", "  else dists.x = max(dists.x, result);", "}", "//VTK::ClipPlane::Impl"], !1).result;
    }
    n.Fragment = a;
  };
  const e = (n, s) => {
    let r = 0;
    n.getProperty().getShade() && t.renderable.getBlendMode() === zj.COMPOSITE_BLEND && (r = 0, t.numberOfLights = 0, s.forEach((a) => {
      a.getSwitch() > 0 && (t.numberOfLights++, r === 0 && (r = 1)), r === 1 && (t.numberOfLights > 1 || a.getIntensity() !== 1 || !a.lightTypeIsHeadLight()) && (r = 2), r < 3 && a.getPositional() && (r = 3);
    })), r !== t.lightComplexity && (t.lightComplexity = r, i.modified());
  };
  i.getNeedToRebuildShaders = (n, s, r) => {
    var y;
    const a = r.getProperty();
    e(r, s.getLights());
    const o = t.scalarTexture.getComponents(), l = [], c = [];
    for (let Z = 0; Z < o; Z++)
      l.push(a.getOpacityMode(Z)), c.push(a.getForceNearestInterpolation(Z));
    const u = t.currentInput.getSpatialExtent(), d = t.currentInput.getSpacing(), h = new Float64Array(3);
    I.set(h, (u[1] - u[0]) * d[0], (u[3] - u[2]) * d[1], (u[5] - u[4]) * d[2]);
    const p = I.length(h) / i.getCurrentSampleDistance(s), m = !!t.zBufferTexture, b = {
      iComps: a.getIndependentComponents(),
      colorMixPreset: a.getColorMixPreset(),
      interpolationType: a.getInterpolationType(),
      useLabelOutline: a.getUseLabelOutline(),
      numComp: o,
      maxSamples: p,
      useGradientOpacity: a.getUseGradientOpacity(0),
      blendMode: t.renderable.getBlendMode(),
      hasZBufferTexture: m,
      opacityModes: l,
      forceNearestInterps: c
    };
    return !n.getProgram() || ((y = n.getProgram()) == null ? void 0 : y.getHandle()) === 0 || n.getShaderSourceTime().getMTime() < i.getMTime() || n.getShaderSourceTime().getMTime() < t.renderable.getMTime() || !t.previousState || !I3(t.previousState, b) ? (t.previousState = b, !0) : !1;
  }, i.updateShaders = (n, s, r) => {
    if (i.getNeedToRebuildShaders(n, s, r)) {
      const a = {
        Vertex: null,
        Fragment: null,
        Geometry: null
      };
      i.buildShaders(a, s, r);
      const o = t._openGLRenderWindow.getShaderCache().readyShaderProgramArray(a.Vertex, a.Fragment, a.Geometry);
      if (!o)
        return oM("Error compiling volume mapper shader program."), n.setProgram(null), !1;
      o !== n.getProgram() && (n.setProgram(o), n.getVAO().releaseGraphicsResources()), n.getShaderSourceTime().modified();
    } else if (!t._openGLRenderWindow.getShaderCache().readyShaderProgram(n.getProgram()))
      return Px("Unable to bind existing volume mapper shader program; marking program for rebuild."), n.setProgram(null), !1;
    return n.getVAO().bind(), i.setMapperShaderParameters(n, s, r), i.setCameraShaderParameters(n, s, r), i.setPropertyShaderParameters(n, s, r), i.getClippingPlaneShaderParameters(n, s, r), !0;
  }, i.setMapperShaderParameters = (n, s, r) => {
    const a = n.getProgram();
    n.getCABO().getElementCount() && (t.VBOBuildTime.getMTime() > n.getAttributeUpdateTime().getMTime() || n.getShaderSourceTime().getMTime() > n.getAttributeUpdateTime().getMTime()) && (a.isAttributeUsed("vertexDC") && (n.getVAO().addAttributeArray(a, n.getCABO(), "vertexDC", n.getCABO().getVertexOffset(), n.getCABO().getStride(), t.context.FLOAT, 3, t.context.FALSE) || oM("Error setting vertexDC in shader VAO.")), n.getAttributeUpdateTime().modified()), a.setUniformi("texture1", t.scalarTexture.getTextureUnit()), a.setUniformf("sampleDistance", i.getCurrentSampleDistance(s));
    const o = t.scalarTexture.getVolumeInfo(), l = t.renderable.getIpScalarRange(), c = [], u = [];
    for (let d = 0; d < 4; d++)
      c[d] = l[0] * o.dataComputedScale[d] + o.dataComputedOffset[d], u[d] = l[1] * o.dataComputedScale[d] + o.dataComputedOffset[d], c[d] = (c[d] - o.offset[d]) / o.scale[d], u[d] = (u[d] - o.offset[d]) / o.scale[d];
    if (a.setUniform4f("ipScalarRangeMin", c[0], c[1], c[2], c[3]), a.setUniform4f("ipScalarRangeMax", u[0], u[1], u[2], u[3]), t.zBufferTexture !== null) {
      a.setUniformi("zBufferTexture", t.zBufferTexture.getTextureUnit());
      const d = t._useSmallViewport ? [t._smallViewportWidth, t._smallViewportHeight] : t._openGLRenderWindow.getFramebufferSize();
      a.setUniformf("vpZWidth", d[0]), a.setUniformf("vpZHeight", d[1]);
    }
  }, i.setCameraShaderParameters = (n, s, r) => {
    const a = t.openGLCamera.getKeyMatrices(s), o = t.openGLVolume.getKeyMatrices();
    ut.multiply(t.modelToView, a.wcvc, o.mcwc);
    const l = n.getProgram(), c = t.openGLCamera.getRenderable(), u = c.getClippingRange();
    l.setUniformf("camThick", u[1] - u[0]), l.setUniformf("camNear", u[0]), l.setUniformf("camFar", u[1]);
    const d = t.currentInput.getBounds(), h = t.currentInput.getDimensions(), p = new Float64Array(3), m = new Float64Array(3);
    let b = 1, y = -1, Z = 1, g = -1;
    for (let P = 0; P < 8; ++P) {
      if (I.set(p, d[P % 2], d[2 + Math.floor(P / 2) % 2], d[4 + Math.floor(P / 4)]), I.transformMat4(p, p, t.modelToView), !c.getParallelProjection()) {
        I.normalize(m, p);
        const j = -u[0] / p[2];
        I.scale(p, m, j);
      }
      I.transformMat4(p, p, a.vcpc), b = Math.min(p[0], b), y = Math.max(p[0], y), Z = Math.min(p[1], Z), g = Math.max(p[1], g);
    }
    l.setUniformf("dcxmin", b), l.setUniformf("dcxmax", y), l.setUniformf("dcymin", Z), l.setUniformf("dcymax", g), l.isUniformUsed("cameraParallel") && l.setUniformi("cameraParallel", c.getParallelProjection());
    const f = t.currentInput.getSpatialExtent(), T = t.currentInput.getSpacing(), M = new Float64Array(3);
    I.set(M, (f[1] - f[0]) * T[0], (f[3] - f[2]) * T[1], (f[5] - f[4]) * T[2]), l.setUniform3f("vSpacing", T[0], T[1], T[2]), I.set(p, f[0], f[2], f[4]), t.currentInput.indexToWorldVec3(p, p), I.transformMat4(p, p, t.modelToView), l.setUniform3f("vOriginVC", p[0], p[1], p[2]);
    const N = t.currentInput.getIndexToWorld();
    ut.multiply(t.idxToView, t.modelToView, N), gi.multiply(t.idxNormalMatrix, a.normalMatrix, o.normalMatrix), gi.multiply(t.idxNormalMatrix, t.idxNormalMatrix, t.currentInput.getDirectionByReference());
    const W = I.length(M) / i.getCurrentSampleDistance(s);
    W > t.renderable.getMaximumSamplesPerRay() && Px(`The number of steps required ${Math.ceil(W)} is larger than the
        specified maximum number of steps ${t.renderable.getMaximumSamplesPerRay()}.
        Please either change the
        volumeMapper sampleDistance or its maximum number of samples.`);
    const x = new Float64Array(3);
    if (I.set(x, 1, 1, 1), I.divide(x, x, M), l.setUniform3f("vVCToIJK", x[0], x[1], x[2]), l.setUniform3i("volumeDimensions", h[0], h[1], h[2]), !t._openGLRenderWindow.getWebgl2()) {
      const P = t.scalarTexture.getVolumeInfo();
      l.setUniformf("texWidth", t.scalarTexture.getWidth()), l.setUniformf("texHeight", t.scalarTexture.getHeight()), l.setUniformi("xreps", P.xreps), l.setUniformi("xstride", P.xstride), l.setUniformi("ystride", P.ystride);
    }
    const V = new Float64Array(3), X = new Float64Array(3);
    for (let P = 0; P < 6; ++P) {
      switch (P) {
        case 1:
          I.set(V, -1, 0, 0), I.set(X, f[0], f[2], f[4]);
          break;
        case 2:
          I.set(V, 0, 1, 0), I.set(X, f[1], f[3], f[5]);
          break;
        case 3:
          I.set(V, 0, -1, 0), I.set(X, f[0], f[2], f[4]);
          break;
        case 4:
          I.set(V, 0, 0, 1), I.set(X, f[1], f[3], f[5]);
          break;
        case 5:
          I.set(V, 0, 0, -1), I.set(X, f[0], f[2], f[4]);
          break;
        case 0:
        default:
          I.set(V, 1, 0, 0), I.set(X, f[1], f[3], f[5]);
          break;
      }
      I.transformMat3(V, V, t.idxNormalMatrix), I.transformMat4(X, X, t.idxToView);
      const j = -1 * I.dot(X, V);
      l.setUniform3f(`vPlaneNormal${P}`, V[0], V[1], V[2]), l.setUniformf(`vPlaneDistance${P}`, j);
    }
    if (r.getProperty().getUseLabelOutline()) {
      const j = t.currentInput.getWorldToIndex();
      l.setUniformMatrix("vWCtoIDX", j);
      const H = s.getActiveCamera(), [B, $] = H.getClippingRange(), A = H.getDistance();
      H.setClippingRange(A, A + 0.1);
      const E = t.openGLCamera.getKeyMatrices(s);
      ut.invert(t.projectionToWorld, E.wcpc), H.setClippingRange(B, $), t.openGLCamera.getKeyMatrices(s), l.setUniformMatrix("PCWCMatrix", t.projectionToWorld);
      const ct = i.getRenderTargetSize();
      l.setUniformf("vpWidth", ct[0]), l.setUniformf("vpHeight", ct[1]);
      const at = i.getRenderTargetOffset();
      l.setUniformf("vpOffsetX", at[0] / ct[0]), l.setUniformf("vpOffsetY", at[1] / ct[1]);
    }
    if (ut.invert(t.projectionToView, a.vcpc), l.setUniformMatrix("PCVCMatrix", t.projectionToView), t.lightComplexity === 0)
      return;
    let C = 0;
    const R = [], z = [], F = [];
    if (s.getLights().forEach((P) => {
      if (P.getSwitch() > 0) {
        const H = P.getColor(), B = P.getIntensity();
        R[0 + C * 3] = H[0] * B, R[1 + C * 3] = H[1] * B, R[2 + C * 3] = H[2] * B;
        const $ = P.getDirection();
        I.set(V, $[0], $[1], $[2]), I.transformMat3(V, V, a.normalMatrix), I.normalize(V, V), z[0 + C * 3] = V[0], z[1 + C * 3] = V[1], z[2 + C * 3] = V[2], F[0 + C * 3] = -0.5 * V[0], F[1 + C * 3] = -0.5 * V[1], F[2 + C * 3] = -0.5 * (V[2] - 1), C++;
      }
    }), l.setUniformi("twoSidedLighting", s.getTwoSidedLighting()), l.setUniformi("lightNum", C), l.setUniform3fv("lightColor", R), l.setUniform3fv("lightDirectionVC", z), l.setUniform3fv("lightHalfAngleVC", F), t.lightComplexity === 3) {
      C = 0;
      const P = [], j = [], H = [], B = [], $ = [];
      s.getLights().forEach((A) => {
        if (A.getSwitch() > 0) {
          const ct = A.getAttenuationValues();
          j[0 + C * 3] = ct[0], j[1 + C * 3] = ct[1], j[2 + C * 3] = ct[2], B[C] = A.getExponent(), H[C] = A.getConeAngle(), $[C] = A.getPositional();
          const at = A.getTransformedPosition();
          I.transformMat4(at, at, t.modelToView), P[0 + C * 3] = at[0], P[1 + C * 3] = at[1], P[2 + C * 3] = at[2], C += 1;
        }
      }), l.setUniform3fv("lightPositionVC", P), l.setUniform3fv("lightAttenuation", j), l.setUniformfv("lightConeAngle", H), l.setUniformfv("lightExponent", B), l.setUniformiv("lightPositional", $);
    }
    if (t.renderable.getVolumetricScatteringBlending() > 0 && (l.setUniformf("giReach", t.renderable.getGlobalIlluminationReach()), l.setUniformf("volumetricScatteringBlending", t.renderable.getVolumetricScatteringBlending()), l.setUniformf("volumeShadowSamplingDistFactor", t.renderable.getVolumeShadowSamplingDistFactor()), l.setUniformf("anisotropy", t.renderable.getAnisotropy()), l.setUniformf("anisotropy2", t.renderable.getAnisotropy() ** 2)), t.renderable.getLocalAmbientOcclusion() && r.getProperty().getAmbient() > 0) {
      const P = t.renderable.getLAOKernelSize();
      l.setUniformi("kernelSize", P);
      const j = [];
      for (let H = 0; H < P; H++)
        j[H * 2] = Math.random() * 0.5, j[H * 2 + 1] = Math.random() * 0.5;
      l.setUniform2fv("kernelSample", j), l.setUniformi("kernelRadius", t.renderable.getLAOKernelRadius());
    }
  }, i.setPropertyShaderParameters = (n, s, r) => {
    const a = n.getProgram();
    a.setUniformi("ctexture", t.colorTexture.getTextureUnit()), a.setUniformi("otexture", t.opacityTexture.getTextureUnit()), a.setUniformi("jtexture", t.jitterTexture.getTextureUnit()), a.setUniformi("ttexture", t.labelOutlineThicknessTexture.getTextureUnit());
    const o = t.scalarTexture.getVolumeInfo(), l = r.getProperty(), c = t.scalarTexture.getComponents(), u = i.useIndependentComponents(l);
    if (u)
      for (let h = 0; h < c; h++)
        a.setUniformf(`mix${h}`, r.getProperty().getComponentWeight(h));
    for (let h = 0; h < c; h++) {
      const p = u ? h : 0, m = o.scale[h], y = l.getScalarOpacity(p).getRange(), Z = m / (y[1] - y[0]), g = (o.offset[h] - y[0]) / (y[1] - y[0]);
      a.setUniformf(`oshift${h}`, g), a.setUniformf(`oscale${h}`, Z);
      const T = l.getRGBTransferFunction(p).getRange(), M = (o.offset[h] - T[0]) / (T[1] - T[0]), N = m / (T[1] - T[0]);
      a.setUniformf(`cshift${h}`, M), a.setUniformf(`cscale${h}`, N);
    }
    if (t.gopacity)
      if (u)
        for (let h = 0; h < c; ++h) {
          const p = o.scale[h];
          if (l.getUseGradientOpacity(h)) {
            const b = l.getGradientOpacityMinimumOpacity(h), y = l.getGradientOpacityMaximumOpacity(h);
            a.setUniformf(`gomin${h}`, b), a.setUniformf(`gomax${h}`, y);
            const Z = [l.getGradientOpacityMinimumValue(h), l.getGradientOpacityMaximumValue(h)];
            a.setUniformf(`goscale${h}`, p * (y - b) / (Z[1] - Z[0])), a.setUniformf(`goshift${h}`, -Z[0] * (y - b) / (Z[1] - Z[0]) + b);
          } else
            a.setUniformf(`gomin${h}`, 1), a.setUniformf(`gomax${h}`, 1), a.setUniformf(`goscale${h}`, 0), a.setUniformf(`goshift${h}`, 1);
        }
      else {
        const h = o.scale[c - 1], p = l.getGradientOpacityMinimumOpacity(0), m = l.getGradientOpacityMaximumOpacity(0);
        a.setUniformf("gomin0", p), a.setUniformf("gomax0", m);
        const b = [l.getGradientOpacityMinimumValue(0), l.getGradientOpacityMaximumValue(0)];
        a.setUniformf("goscale0", h * (m - p) / (b[1] - b[0])), a.setUniformf("goshift0", -b[0] * (m - p) / (b[1] - b[0]) + p);
      }
    if (r.getProperty().getUseLabelOutline() === !0) {
      const h = r.getProperty().getLabelOutlineOpacity();
      a.setUniformf("outlineOpacity", h);
    }
    t.lightComplexity > 0 && (a.setUniformf("vAmbient", l.getAmbient()), a.setUniformf("vDiffuse", l.getDiffuse()), a.setUniformf("vSpecular", l.getSpecular()), a.setUniformf("vSpecularPower", l.getSpecularPower()));
  }, i.getClippingPlaneShaderParameters = (n, s, r) => {
    if (t.renderable.getClippingPlanes().length > 0) {
      const a = t.openGLCamera.getKeyMatrices(s), o = [], l = [], c = [], u = t.renderable.getClippingPlanes(), d = u.length;
      for (let p = 0; p < d; ++p) {
        const m = u[p].getNormal(), b = u[p].getOrigin();
        I.transformMat3(m, m, a.normalMatrix), I.transformMat4(b, b, a.wcvc);
        const y = -1 * I.dot(b, m);
        o.push(m[0]), o.push(m[1]), o.push(m[2]), l.push(y), c.push(b[0]), c.push(b[1]), c.push(b[2]);
      }
      const h = n.getProgram();
      h.setUniform3fv("vClipPlaneNormals", o), h.setUniformfv("vClipPlaneDistances", l), h.setUniform3fv("vClipPlaneOrigins", c), h.setUniformi("clip_numPlanes", d);
    }
  }, i.delete = $X(() => {
    t._animationRateSubscription && (t._animationRateSubscription.unsubscribe(), t._animationRateSubscription = null);
  }, i.delete), i.getRenderTargetSize = () => {
    if (t._useSmallViewport)
      return [t._smallViewportWidth, t._smallViewportHeight];
    const {
      usize: n,
      vsize: s
    } = t._openGLRenderer.getTiledSizeAndOrigin();
    return [n, s];
  }, i.getRenderTargetOffset = () => {
    const {
      lowerLeftU: n,
      lowerLeftV: s
    } = t._openGLRenderer.getTiledSizeAndOrigin();
    return [n, s];
  }, i.getCurrentSampleDistance = (n) => {
    const s = n.getVTKWindow().getInteractor(), r = t.renderable.getSampleDistance();
    if (s && s.isAnimating()) {
      const a = t.renderable.getInteractionSampleDistanceFactor();
      return r * a;
    }
    return r;
  }, i.renderPieceStart = (n, s) => {
    const r = n.getVTKWindow().getInteractor();
    if (t._lastScale || (t._lastScale = t.renderable.getInitialInteractionScale()), t._useSmallViewport = !1, r && r.isAnimating() && t._lastScale > 1.5 && (t._useSmallViewport = !0), r && !t._animationRateSubscription && (t._animationRateSubscription = r.onAnimationFrameRateUpdate(() => {
      if (t.renderable.getAutoAdjustSampleDistances()) {
        const o = r.getRecentAnimationFrameRate(), l = r.getDesiredUpdateRate() / o;
        (l > 1.15 || l < 0.85) && (t._lastScale *= l), t._lastScale > 400 && (t._lastScale = 400), t._lastScale < 1.5 && (t._lastScale = 1.5);
      } else
        t._lastScale = t.renderable.getImageSampleDistance() * t.renderable.getImageSampleDistance();
    })), t._useSmallViewport) {
      const o = t._openGLRenderWindow.getFramebufferSize(), l = 1 / Math.sqrt(t._lastScale);
      if (t._smallViewportWidth = Math.ceil(l * o[0]), t._smallViewportHeight = Math.ceil(l * o[1]), t._smallViewportHeight > o[1] && (t._smallViewportHeight = o[1]), t._smallViewportWidth > o[0] && (t._smallViewportWidth = o[0]), t.framebuffer.saveCurrentBindingsAndBuffers(), t.framebuffer.getGLFramebuffer() === null)
        t.framebuffer.create(o[0], o[1]), t.framebuffer.populateFramebuffer();
      else {
        const u = t.framebuffer.getSize();
        (!u || u[0] !== o[0] || u[1] !== o[1]) && (t.framebuffer.create(o[0], o[1]), t.framebuffer.populateFramebuffer());
      }
      t.framebuffer.bind();
      const c = t.context;
      c.clearColor(0, 0, 0, 0), c.colorMask(!0, !0, !0, !0), c.clear(c.COLOR_BUFFER_BIT), c.viewport(0, 0, t._smallViewportWidth, t._smallViewportHeight), t.fvp = [t._smallViewportWidth / o[0], t._smallViewportHeight / o[1]];
    }
    t.context.disable(t.context.DEPTH_TEST), i.updateBufferObjects(n, s), s.getProperty().getInterpolationType() === Uh.NEAREST ? (t.scalarTexture.setMinificationFilter(Qe.NEAREST), t.scalarTexture.setMagnificationFilter(Qe.NEAREST)) : (t.scalarTexture.setMinificationFilter(Qe.LINEAR), t.scalarTexture.setMagnificationFilter(Qe.LINEAR)), t.zBufferTexture !== null && t.zBufferTexture.activate();
  }, i.renderPieceDraw = (n, s) => {
    const r = t.context;
    t.scalarTexture.activate(), t.opacityTexture.activate(), t.labelOutlineThicknessTexture.activate(), t.colorTexture.activate(), t.jitterTexture.activate(), i.updateShaders(t.tris, n, s) ? (r.drawArrays(r.TRIANGLES, 0, Number(t.tris.getCABO().getElementCount())), t.tris.getVAO().release()) : Px("Skipping volume mapper draw because shader update failed."), t.scalarTexture.deactivate(), t.colorTexture.deactivate(), t.opacityTexture.deactivate(), t.labelOutlineThicknessTexture.deactivate(), t.jitterTexture.deactivate();
  }, i.renderPieceFinish = (n, s) => {
    if (t.zBufferTexture !== null && t.zBufferTexture.deactivate(), t._useSmallViewport) {
      if (t.framebuffer.restorePreviousBindingsAndBuffers(), t.copyShader === null) {
        t.copyShader = t._openGLRenderWindow.getShaderCache().readyShaderProgramArray(["//VTK::System::Dec", "attribute vec4 vertexDC;", "uniform vec2 tfactor;", "varying vec2 tcoord;", "void main() { tcoord = vec2(vertexDC.x*0.5 + 0.5, vertexDC.y*0.5 + 0.5) * tfactor; gl_Position = vertexDC; }"].join(`
`), ["//VTK::System::Dec", "//VTK::Output::Dec", "uniform sampler2D texture1;", "varying vec2 tcoord;", "void main() { gl_FragData[0] = texture2D(texture1,tcoord); }"].join(`
`), "");
        const l = t.copyShader;
        t.copyVAO = zI.newInstance(), t.copyVAO.setOpenGLRenderWindow(t._openGLRenderWindow), t.tris.getCABO().bind(), t.copyVAO.addAttributeArray(l, t.tris.getCABO(), "vertexDC", t.tris.getCABO().getVertexOffset(), t.tris.getCABO().getStride(), t.context.FLOAT, 3, t.context.FALSE) || oM("Error setting vertexDC in copy shader VAO.");
      } else
        t._openGLRenderWindow.getShaderCache().readyShaderProgram(t.copyShader);
      const r = t._openGLRenderWindow.getFramebufferSize();
      t.context.viewport(0, 0, r[0], r[1]);
      const a = t.framebuffer.getColorTexture();
      a.activate(), t.copyShader.setUniformi("texture", a.getTextureUnit()), t.copyShader.setUniform2f("tfactor", t.fvp[0], t.fvp[1]);
      const o = t.context;
      o.blendFuncSeparate(o.ONE, o.ONE_MINUS_SRC_ALPHA, o.ONE, o.ONE_MINUS_SRC_ALPHA), t.context.drawArrays(t.context.TRIANGLES, 0, Number(t.tris.getCABO().getElementCount())), a.deactivate(), o.blendFuncSeparate(o.SRC_ALPHA, o.ONE_MINUS_SRC_ALPHA, o.ONE, o.ONE_MINUS_SRC_ALPHA);
    }
  }, i.renderPiece = (n, s) => {
    if (i.invokeEvent({
      type: "StartEvent"
    }), t.renderable.update(), t.currentInput = t.renderable.getInputData(), i.invokeEvent({
      type: "EndEvent"
    }), !t.currentInput) {
      oM("No input!");
      return;
    }
    i.renderPieceStart(n, s), i.renderPieceDraw(n, s), i.renderPieceFinish(n, s);
  }, i.computeBounds = (n, s) => {
    if (!i.getInput()) {
      Lg(t.Bounds);
      return;
    }
    t.bounds = i.getInput().getBounds();
  }, i.updateBufferObjects = (n, s) => {
    i.getNeedToRebuildBufferObjects(n, s) && i.buildBufferObjects(n, s);
  }, i.getNeedToRebuildBufferObjects = (n, s) => t.VBOBuildTime.getMTime() < i.getMTime() || t.VBOBuildTime.getMTime() < s.getMTime() || t.VBOBuildTime.getMTime() < t.renderable.getMTime() || t.VBOBuildTime.getMTime() < s.getProperty().getMTime() || t.VBOBuildTime.getMTime() < t.currentInput.getMTime(), i.buildBufferObjects = (n, s) => {
    const r = t.currentInput;
    if (!r)
      return;
    const a = r.getPointData() && r.getPointData().getScalars();
    if (!a)
      return;
    t._scalars !== a && (t._openGLRenderWindow.releaseGraphicsResourcesForObject(t._scalars), t._scalars = a);
    const o = s.getProperty();
    if (!t.jitterTexture.getHandle()) {
      const T = new Uint8Array(1024);
      for (let M = 0; M < 1024; ++M)
        T[M] = 255 * Math.random();
      t.jitterTexture.setMinificationFilter(Qe.LINEAR), t.jitterTexture.setMagnificationFilter(Qe.LINEAR), t.jitterTexture.create2DFromRaw(32, 32, 1, Ke.UNSIGNED_CHAR, T);
    }
    const l = a.getNumberOfComponents(), c = i.useIndependentComponents(o), u = c ? l : 1, d = o.getScalarOpacity(), h = t._openGLRenderWindow.getGraphicsResourceForObject(d);
    let p = GO(d, c, u);
    if (!h.vtkObj || h.hash !== p || t.opacityTextureString !== p) {
      const M = 2048 * u, N = new Float32Array(M), W = new Float32Array(1024);
      for (let x = 0; x < u; ++x) {
        const V = o.getScalarOpacity(x), X = i.getCurrentSampleDistance(n) / o.getScalarOpacityUnitDistance(x), C = V.getRange();
        V.getTable(C[0], C[1], 1024, W, 1);
        for (let R = 0; R < 1024; ++R)
          N[x * 1024 * 2 + R] = 1 - (1 - W[R]) ** X, N[x * 1024 * 2 + R + 1024] = N[x * 1024 * 2 + R];
      }
      if (t.opacityTexture.releaseGraphicsResources(t._openGLRenderWindow), t.opacityTexture.resetFormatAndType(), t.opacityTexture.setMinificationFilter(Qe.LINEAR), t.opacityTexture.setMagnificationFilter(Qe.LINEAR), t._openGLRenderWindow.getWebgl2() || t.context.getExtension("OES_texture_float") && t.context.getExtension("OES_texture_float_linear"))
        t.opacityTexture.create2DFromRaw(1024, 2 * u, 1, Ke.FLOAT, N);
      else {
        const x = new Uint8ClampedArray(M);
        for (let V = 0; V < M; ++V)
          x[V] = 255 * N[V];
        t.opacityTexture.create2DFromRaw(1024, 2 * u, 1, Ke.UNSIGNED_CHAR, x);
      }
      t.opacityTextureString = p, d && t._openGLRenderWindow.setGraphicsResourceForObject(d, t.opacityTexture, t.opacityTextureString);
    } else
      t.opacityTexture = h.vtkObj, t.opacityTextureString = h.hash;
    const b = o.getRGBTransferFunction();
    p = GO(b, c, u);
    const y = t._openGLRenderWindow.getGraphicsResourceForObject(b);
    if (!(y != null && y.vtkObj) || (y == null ? void 0 : y.hash) !== p || t.colorTextureString !== p) {
      const M = 2048 * u * 3, N = new Uint8ClampedArray(M), W = new Float32Array(1024 * 3);
      for (let x = 0; x < u; ++x) {
        const V = o.getRGBTransferFunction(x), X = V.getRange();
        V.getTable(X[0], X[1], 1024, W, 1);
        for (let C = 0; C < 1024 * 3; ++C)
          N[x * 1024 * 6 + C] = 255 * W[C], N[x * 1024 * 6 + C + 1024 * 3] = 255 * W[C];
      }
      t.colorTexture.releaseGraphicsResources(t._openGLRenderWindow), t.colorTexture.resetFormatAndType(), t.colorTexture.setMinificationFilter(Qe.LINEAR), t.colorTexture.setMagnificationFilter(Qe.LINEAR), t.colorTexture.create2DFromRaw(1024, 2 * u, 3, Ke.UNSIGNED_CHAR, N), t.colorTextureString = p, b && t._openGLRenderWindow.setGraphicsResourceForObject(b, t.colorTexture, t.colorTextureString);
    } else
      t.colorTexture = y.vtkObj, t.colorTextureString = y.hash;
    i.updateLabelOutlineThicknessTexture(s);
    const g = t._openGLRenderWindow.getGraphicsResourceForObject(a);
    if (p = `${r.getMTime()}A${a.getMTime()}`, !(g != null && g.vtkObj) || (g == null ? void 0 : g.hash) !== p || t.scalarTextureString !== p) {
      const T = r.getDimensions();
      t.scalarTexture.setOglNorm16Ext(t.context.getExtension("EXT_texture_norm16")), t.scalarTexture.releaseGraphicsResources(t._openGLRenderWindow), t.scalarTexture.resetFormatAndType(), t.scalarTexture.create3DFilterableFromDataArray(T[0], T[1], T[2], a, t.renderable.getPreferSizeOverAccuracy()), t.scalarTextureString = p, a && t._openGLRenderWindow.setGraphicsResourceForObject(a, t.scalarTexture, t.scalarTextureString);
    } else
      t.scalarTexture = g.vtkObj, t.scalarTextureString = g.hash;
    if (!t.tris.getCABO().getElementCount()) {
      const T = new Float32Array(12);
      for (let x = 0; x < 4; x++)
        T[x * 3] = x % 2 * 2 - 1, T[x * 3 + 1] = x > 1 ? 1 : -1, T[x * 3 + 2] = -1;
      const M = new Uint16Array(8);
      M[0] = 3, M[1] = 0, M[2] = 1, M[3] = 3, M[4] = 3, M[5] = 0, M[6] = 3, M[7] = 2;
      const N = We.newInstance({
        numberOfComponents: 3,
        values: T
      });
      N.setName("points");
      const W = We.newInstance({
        numberOfComponents: 1,
        values: M
      });
      t.tris.getCABO().createVBO(W, "polys", Vn.SURFACE, {
        points: N,
        cellOffset: 0
      });
    }
    t.VBOBuildTime.modified();
  }, i.updateLabelOutlineThicknessTexture = (n) => {
    const s = n.getProperty().getLabelOutlineThickness(), r = t._openGLRenderWindow.getGraphicsResourceForObject(s), a = `${s.join("-")}`;
    if (!(r != null && r.vtkObj) || (r == null ? void 0 : r.hash) !== a || t.labelOutlineThicknessTextureString !== a) {
      const d = new Uint8Array(1024);
      for (let h = 0; h < 1024; ++h) {
        const p = s[h] || s[0];
        d[h] = p;
      }
      t.labelOutlineThicknessTexture.releaseGraphicsResources(t._openGLRenderWindow), t.labelOutlineThicknessTexture.resetFormatAndType(), t.labelOutlineThicknessTexture.setMinificationFilter(Qe.NEAREST), t.labelOutlineThicknessTexture.setMagnificationFilter(Qe.NEAREST), t.labelOutlineThicknessTexture.create2DFromRaw(1024, 1, 1, Ke.UNSIGNED_CHAR, d), t.labelOutlineThicknessTextureString = a, s && t._openGLRenderWindow.setGraphicsResourceForObject(s, t.labelOutlineThicknessTexture, t.labelOutlineThicknessTextureString);
    } else
      t.labelOutlineThicknessTexture = r.vtkObj, t.labelOutlineThicknessTextureString = r.hash;
  };
}
const Blt = {
  context: null,
  VBOBuildTime: null,
  scalarTexture: null,
  scalarTextureString: null,
  opacityTexture: null,
  opacityTextureString: null,
  colorTexture: null,
  colorTextureString: null,
  jitterTexture: null,
  labelOutlineThicknessTexture: null,
  labelOutlineThicknessTextureString: null,
  tris: null,
  framebuffer: null,
  copyShader: null,
  copyVAO: null,
  lastXYF: 1,
  targetXYF: 1,
  zBufferTexture: null,
  lastZBufferTexture: null,
  lightComplexity: 0,
  fullViewportTime: 1,
  idxToView: null,
  idxNormalMatrix: null,
  modelToView: null,
  projectionToView: null,
  avgWindowArea: 0,
  avgFrameTime: 0,
  _scalars: null
};
function Klt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Blt, e), ui.extend(i, t, e), kc.implementBuildShadersWithReplacements(i, t, e), t.VBOBuildTime = {}, xi(t.VBOBuildTime, {
    mtime: 0
  }), t.tris = Jc.newInstance(), t.scalarTexture = bs.newInstance(), t.opacityTexture = bs.newInstance(), t.colorTexture = bs.newInstance(), t.jitterTexture = bs.newInstance(), t.jitterTexture.setWrapS(g2.REPEAT), t.jitterTexture.setWrapT(g2.REPEAT), t.labelOutlineThicknessTexture = bs.newInstance(), t.framebuffer = gg.newInstance(), t.idxToView = ut.identity(new Float64Array(16)), t.idxNormalMatrix = gi.identity(new Float64Array(9)), t.modelToView = ut.identity(new Float64Array(16)), t.projectionToView = ut.identity(new Float64Array(16)), t.projectionToWorld = ut.identity(new Float64Array(16)), gs(i, t, ["context"]), Alt(i, t);
}
const Hlt = In(Klt, "vtkOpenGLVolumeMapper");
Js("vtkVolumeMapper", Hlt);
const {
  SlicingMode: wO
} = UG, _lt = `
//VTK::Renderer::Dec

//VTK::Mapper::Dec

//VTK::TCoord::Dec

//VTK::Image::Dec

//VTK::RenderEncoder::Dec

//VTK::IOStructs::Dec

@fragment
fn main(
//VTK::IOStructs::Input
)
//VTK::IOStructs::Output
{
  var output: fragmentOutput;

  //VTK::Image::Sample

  // var computedColor: vec4<f32> = vec4<f32>(1.0,0.7, 0.5, 1.0);

//VTK::RenderEncoder::Impl

  return output;
}
`;
function Qlt(i, t, e) {
  if (t.apply(i)) {
    const s = i.getIndependentComponents();
    return `${i.getMTime()}-${s}-${e}`;
  }
  return "0";
}
const Ba = new Float64Array(16), _l = new Float64Array(16), lM = new Float64Array(16), $c = new Float64Array(4), Ys = new Float64Array(4);
function $lt(i, t) {
  t.classHierarchy.push("vtkWebGPUImageMapper"), i.buildPass = (s) => {
    if (s) {
      t.WebGPUImageSlice = i.getFirstAncestorOfType("vtkWebGPUImageSlice"), t.WebGPURenderer = t.WebGPUImageSlice.getFirstAncestorOfType("vtkWebGPURenderer"), t.WebGPURenderWindow = t.WebGPURenderer.getParent(), t.device = t.WebGPURenderWindow.getDevice();
      const r = t.WebGPURenderer.getRenderable();
      t.renderable.getSliceAtFocalPoint() && t.renderable.setSliceFromCamera(r.getActiveCamera());
    }
  }, i.translucentPass = (s) => {
    s && i.render();
  }, i.opaquePass = (s) => {
    s && i.render();
  }, i.render = () => {
    t.renderable.update(), t.currentInput = t.renderable.getInputData(), i.prepareToDraw(t.WebGPURenderer.getRenderEncoder()), t.renderEncoder.registerDrawCallback(t.pipeline, i.draw);
  }, i.computePipelineHash = () => {
    const s = t.currentInput.getExtent();
    s[0] === s[1] || s[2] === s[3] || s[4] === s[5] ? (t.dimensions = 2, t.pipelineHash = "img2") : (t.dimensions = 3, t.pipelineHash = "img3");
  }, i.updateUBO = () => {
    const s = t.UBO.getSendTime(), r = t.WebGPUImageSlice.getRenderable(), a = r.getMapper();
    if (i.getMTime() > s || t.renderable.getMTime() > s || r.getProperty().getMTime() > s) {
      const o = a.getInputData(), l = t.WebGPURenderer.getStabilizedCenterByReference();
      ut.identity(Ba), ut.translate(Ba, Ba, l);
      const c = r.getMatrix();
      ut.transpose(_l, c), ut.invert(_l, _l), ut.multiply(Ba, _l, Ba);
      const u = o.getWorldToIndex();
      ut.multiply(Ba, u, Ba), ut.invert(lM, Ba), ut.fromTranslation(_l, [0.5, 0.5, 0.5]), ut.multiply(Ba, _l, Ba);
      const d = o.getDimensions();
      ut.identity(_l), ut.scale(_l, _l, [1 / d[0], 1 / d[1], 1 / d[2]]), ut.multiply(Ba, _l, Ba), t.UBO.setArray("SCTCMatrix", Ba);
      const h = t.currentInput.getExtent(), {
        ijkMode: p
      } = t.renderable.getClosestIJKAxis();
      let m = t.renderable.getSlice();
      p !== t.renderable.getSlicingMode() && (m = t.renderable.getSliceAtPosition(m));
      let b = 2, y = 0, Z = 1;
      p === wO.I ? (b = 0, y = 1, Z = 2) : p === wO.J && (b = 1, y = 2, Z = 0), $c[b] = m, $c[y] = h[y * 2] - 0.5, $c[Z] = h[Z * 2] - 0.5, $c[3] = 1, zn.transformMat4($c, $c, lM), t.UBO.setArray("Origin", $c), Ys[b] = m, Ys[y] = h[y * 2 + 1] + 0.5, Ys[Z] = h[Z * 2] - 0.5, Ys[3] = 1, zn.transformMat4(Ys, Ys, lM), zn.subtract(Ys, Ys, $c), Ys[3] = 1, t.UBO.setArray("Axis1", Ys), Ys[b] = m, Ys[y] = h[y * 2] - 0.5, Ys[Z] = h[Z * 2 + 1] + 0.5, Ys[3] = 1, zn.transformMat4(Ys, Ys, lM), zn.subtract(Ys, Ys, $c), Ys[3] = 1, t.UBO.setArray("Axis2", Ys);
      const g = [1, 1, 1, 1], f = [0, 0, 0, 0], T = t.textureViews[0], M = T.getTexture().getScale(), N = T.getTexture().getNumberOfComponents();
      for (let W = 0; W < N; W++) {
        let x = r.getProperty().getColorWindow(), V = r.getProperty().getColorLevel();
        const C = r.getProperty().getRGBTransferFunction(0);
        if (C) {
          const R = C.getRange();
          x = R[1] - R[0], V = 0.5 * (R[1] + R[0]);
        }
        g[W] = M / x, f[W] = -V / x + 0.5;
      }
      t.UBO.setArray("cScale", g), t.UBO.setArray("cShift", f), t.UBO.sendIfNeeded(t.device);
    }
  }, i.updateLUTImage = () => {
    const s = t.WebGPUImageSlice.getRenderable().getProperty();
    i.getTextureViews()[0].getTexture().getNumberOfComponents();
    const a = 1, o = Qlt(s, s.getRGBTransferFunction, a);
    if (t.colorTextureString !== o) {
      t.numRows = a;
      const l = new Uint8ClampedArray(t.numRows * 2 * t.rowLength * 4);
      let c = s.getRGBTransferFunction();
      if (c) {
        const u = new Float32Array(t.rowLength * 3);
        for (let d = 0; d < a; d++) {
          c = s.getRGBTransferFunction(d);
          const h = c.getRange();
          c.getTable(h[0], h[1], t.rowLength, u, 1);
          for (let p = 0; p < t.rowLength; p++) {
            const m = d * t.rowLength * 8 + p * 4;
            l[m] = 255 * u[p * 3], l[m + 1] = 255 * u[p * 3 + 1], l[m + 2] = 255 * u[p * 3 + 2], l[m + 3] = 255;
            for (let b = 0; b < 4; b++)
              l[m + t.rowLength * 4 + b] = l[m + b];
          }
        }
      } else
        for (let u = 0; u < t.rowLength; ++u) {
          const d = 255 * u / (t.rowLength - 1);
          l[u * 4] = d, l[u * 4 + 1] = d, l[u * 4 + 2] = d, l[u * 4 + 3] = 255;
          for (let h = 0; h < 4; h++)
            l[u * 4 + t.rowLength * 4 + h] = l[u * 4 + h];
        }
      {
        const u = {
          nativeArray: l,
          width: t.rowLength,
          height: t.numRows * 2,
          depth: 1,
          format: "rgba8unorm"
        }, h = t.device.getTextureManager().getTexture(u).createView("tfunTexture");
        t.textureViews[1] = h;
      }
      t.colorTextureString = o;
    }
  };
  const e = i.updateBuffers;
  i.updateBuffers = () => {
    e();
    const s = t.device.getTextureManager().getTextureForImageData(t.currentInput), r = t.textureViews;
    if (!r[0] || r[0].getTexture() !== s) {
      const l = s.createView("imgTexture");
      r[0] = l;
    }
    i.updateLUTImage(), i.updateUBO();
    const o = t.WebGPUImageSlice.getRenderable().getProperty().getInterpolationType() === d0.NEAREST ? "nearest" : "linear";
    (!t.clampSampler || o !== t.clampSampler.getOptions().minFilter) && (t.clampSampler = Lj.newInstance({
      label: "clampSampler"
    }), t.clampSampler.create(t.device, {
      minFilter: o,
      magFilter: o
    }), t.additionalBindables = [t.clampSampler]);
  };
  const n = i.getShaderReplacements();
  i.replaceShaderPosition = (s, r, a) => {
    const o = r.getShaderDescription("vertex");
    o.addBuiltinOutput("vec4<f32>", "@builtin(position) Position");
    let l = o.getCode();
    const c = ["var pos: vec4<f32> = mapperUBO.Origin +", "   (vertexBC.x * 0.5 + 0.5) * mapperUBO.Axis1 + (vertexBC.y * 0.5 + 0.5) * mapperUBO.Axis2;", "pos.w = 1.0;"];
    t.dimensions === 2 ? c.push("var tcoord : vec2<f32> = (mapperUBO.SCTCMatrix * pos).xy;") : c.push("var tcoord : vec3<f32> = (mapperUBO.SCTCMatrix * pos).xyz;"), c.push("output.tcoordVS = tcoord;", "output.Position = rendererUBO.SCPCMatrix * pos;"), l = kn.substitute(l, "//VTK::Position::Impl", c).result, o.setCode(l);
  }, n.set("replaceShaderPosition", i.replaceShaderPosition), i.replaceShaderTCoord = (s, r, a) => {
    const o = r.getShaderDescription("vertex");
    t.dimensions === 2 ? o.addOutput("vec2<f32>", "tcoordVS") : o.addOutput("vec3<f32>", "tcoordVS");
  }, n.set("replaceShaderTCoord", i.replaceShaderTCoord), i.replaceShaderImage = (s, r, a) => {
    const o = r.getShaderDescription("fragment");
    let l = o.getCode();
    t.dimensions === 3 ? l = kn.substitute(l, "//VTK::Image::Sample", ["    var computedColor: vec4<f32> =", "      textureSampleLevel(imgTexture, clampSampler, input.tcoordVS, 0.0);", "//VTK::Image::Sample"]).result : l = kn.substitute(l, "//VTK::Image::Sample", ["    var computedColor: vec4<f32> =", "      textureSampleLevel(imgTexture, clampSampler, input.tcoordVS, 0.0);", "//VTK::Image::Sample"]).result, l = kn.substitute(l, "//VTK::Image::Sample", ["    var coord: vec2<f32> =", "      vec2<f32>(computedColor.r * mapperUBO.cScale.r + mapperUBO.cShift.r, 0.5);", "    computedColor = textureSampleLevel(tfunTexture, clampSampler, coord, 0.0);"]).result, o.setCode(l);
  }, n.set("replaceShaderImage", i.replaceShaderImage);
}
const qlt = {
  rowLength: 1024
};
function tct(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, qlt, e), pL.extend(i, t, e), i.setFragmentShaderTemplate(_lt), t.UBO = Cb.newInstance({
    label: "mapperUBO"
  }), t.UBO.addEntry("SCTCMatrix", "mat4x4<f32>"), t.UBO.addEntry("Origin", "vec4<f32>"), t.UBO.addEntry("Axis2", "vec4<f32>"), t.UBO.addEntry("Axis1", "vec4<f32>"), t.UBO.addEntry("cScale", "vec4<f32>"), t.UBO.addEntry("cShift", "vec4<f32>"), t.lutBuildTime = {}, xi(t.lutBuildTime, {
    mtime: 0
  }), t.imagemat = ut.identity(new Float64Array(16)), t.imagematinv = ut.identity(new Float64Array(16)), t.VBOBuildTime = {}, xi(t.VBOBuildTime), $lt(i, t);
}
const ect = In(tct, "vtkWebGPUImageMapper");
Xo("vtkImageMapper", ect);
function nct(i, t) {
  t.classHierarchy.push("vtkWebGPUImageSlice"), i.buildPass = (e) => {
    if (!(!t.renderable || !t.renderable.getVisibility()) && e) {
      if (!t.renderable)
        return;
      t.WebGPURenderer = i.getFirstAncestorOfType("vtkWebGPURenderer"), t.WebGPURenderWindow = t.WebGPURenderer.getFirstAncestorOfType("vtkWebGPURenderWindow"), t.propID === void 0 && (t.propID = t.WebGPURenderWindow.getUniquePropID()), i.prepareNodes(), i.addMissingNode(t.renderable.getMapper()), i.removeUnusedNodes();
    }
  }, i.traverseOpaquePass = (e) => {
    !t.renderable || !t.renderable.getNestedVisibility() || !t.renderable.getIsOpaque() || t.WebGPURenderer.getSelector() && !t.renderable.getNestedPickable() || (i.apply(e, !0), t.children.forEach((n) => {
      n.traverse(e);
    }), i.apply(e, !1));
  }, i.traverseTranslucentPass = (e) => {
    !t.renderable || !t.renderable.getNestedVisibility() || t.renderable.getIsOpaque() || t.WebGPURenderer.getSelector() && !t.renderable.getNestedPickable() || (i.apply(e, !0), t.children.forEach((n) => {
      n.traverse(e);
    }), i.apply(e, !1));
  }, i.queryPass = (e, n) => {
    if (e) {
      if (!t.renderable || !t.renderable.getVisibility())
        return;
      t.renderable.getIsOpaque() ? n.incrementOpaqueActorCount() : n.incrementTranslucentActorCount();
    }
  }, i.getBufferShift = (e) => (i.getKeyMatrices(e), t.bufferShift), i.getKeyMatrices = (e) => {
    if (Math.max(t.renderable.getMTime(), e.getStabilizedTime()) > t.keyMatricesTime.getMTime()) {
      t.renderable.computeMatrix();
      const n = t.renderable.getMatrix(), s = e.getStabilizedCenterByReference();
      t.bufferShift[0] = n[3] - s[0], t.bufferShift[1] = n[7] - s[1], t.bufferShift[2] = n[11] - s[2], ut.transpose(t.keyMatrices.bcwc, n), t.renderable.getIsIdentity() ? ut.identity(t.keyMatrices.normalMatrix) : (ut.copy(t.keyMatrices.normalMatrix, t.keyMatrices.bcwc), t.keyMatrices.normalMatrix[3] = 0, t.keyMatrices.normalMatrix[7] = 0, t.keyMatrices.normalMatrix[11] = 0, ut.invert(t.keyMatrices.normalMatrix, t.keyMatrices.normalMatrix), ut.transpose(t.keyMatrices.normalMatrix, t.keyMatrices.normalMatrix)), ut.translate(t.keyMatrices.bcwc, t.keyMatrices.bcwc, [-t.bufferShift[0], -t.bufferShift[1], -t.bufferShift[2]]), ut.translate(t.keyMatrices.bcsc, t.keyMatrices.bcwc, [-s[0], -s[1], -s[2]]), t.keyMatricesTime.modified();
    }
    return t.keyMatrices;
  };
}
const ict = {
  bufferShift: void 0,
  keyMatrixTime: null,
  keyMatrices: null,
  propID: void 0
};
function sct(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, ict, e), ui.extend(i, t, e), t.keyMatricesTime = {}, xi(t.keyMatricesTime, {
    mtime: 0
  }), t.keyMatrices = {
    normalMatrix: new Float64Array(16),
    bcwc: new Float64Array(16),
    bcsc: new Float64Array(16)
  }, t.keyMatrixTime = {}, xi(t.keyMatrixTime, {
    mtime: 0
  }), t.keyMatrices = {
    mcwc: ut.identity(new Float64Array(16))
  }, t.bufferShift = [0, 0, 0, 0], Sa(i, t, ["propID", "keyMatricesTime"]), nct(i, t);
}
const rct = In(sct, "vtkWebGPUImageSlice");
Xo("vtkImageSlice", rct);
function act(i, t) {
  t.classHierarchy.push("vtkWebGPUVolume"), i.buildPass = (s) => {
    !t.renderable || !t.renderable.getVisibility() || s && (t.WebGPURenderer = i.getFirstAncestorOfType("vtkWebGPURenderer"), t.WebGPURenderWindow = t.WebGPURenderer.getFirstAncestorOfType("vtkWebGPURenderWindow"), t.propID === void 0 && (t.propID = t.WebGPURenderWindow.getUniquePropID()), t.renderable.getMapper().update());
  }, i.queryPass = (s, r) => {
    if (s) {
      if (!t.renderable || !t.renderable.getVisibility())
        return;
      const a = t.renderable.getMapper().getBounds();
      if (!a || a.length !== 6 || a[0] > a[1])
        return;
      r.addVolume(i);
    }
  };
  const e = new Float64Array(3), n = new Float64Array(3);
  i.getBoundingCubePoints = (s, r) => {
    const a = t.renderable.getMapper().getInputData();
    if (!a)
      return;
    const o = a.getExtent(), l = t.renderable.getMatrix();
    let c = 0;
    for (let u = 4; u < 6; u++) {
      e[2] = o[u];
      for (let d = 2; d < 4; d++) {
        e[1] = o[d];
        for (let h = 0; h < 2; h++) {
          e[0] = o[h], a.indexToWorld(e, n);
          let p = r + c * 3;
          s[p++] = l[0] * n[0] + l[1] * n[1] + l[2] * n[2] + l[3], s[p++] = l[4] * n[0] + l[5] * n[1] + l[6] * n[2] + l[7], s[p++] = l[8] * n[0] + l[9] * n[1] + l[10] * n[2] + l[11], c++;
        }
      }
    }
  }, i.getKeyMatrices = (s) => {
    if (Math.max(t.renderable.getMTime(), s.getStabilizedTime()) > t.keyMatricesTime.getMTime()) {
      t.renderable.computeMatrix();
      const r = t.renderable.getMatrix(), a = s.getStabilizedCenterByReference();
      ut.transpose(t.keyMatrices.bcwc, r), ut.translate(t.keyMatrices.bcsc, t.keyMatrices.bcwc, [-a[0], -a[1], -a[2]]), t.keyMatricesTime.modified();
    }
    return t.keyMatrices;
  };
}
const oct = {
  propID: void 0,
  keyMatricesTime: null
};
function lct(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, oct, e), ui.extend(i, t, e), t.keyMatricesTime = {}, tt.obj(t.keyMatricesTime, {
    mtime: 0
  }), t.keyMatrices = {
    bcwc: new Float64Array(16),
    bcsc: new Float64Array(16)
  }, tt.get(i, t, ["propID", "keyMatricesTime"]), act(i, t);
}
const cct = tt.newInstance(lct, "vtkWebGPUVolume");
Xo("vtkVolume", cct);
var uct = `//VTK::System::Dec

/*=========================================================================

  Program:   Visualization Toolkit
  Module:    vtkSphereMapperVS.glsl

  Copyright (c) Ken Martin, Will Schroeder, Bill Lorensen
  All rights reserved.
  See Copyright.txt or http://www.kitware.com/Copyright.htm for details.

     This software is distributed WITHOUT ANY WARRANTY; without even
     the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR
     PURPOSE.  See the above copyright notice for more information.

=========================================================================*/
// this shader implements imposters in OpenGL for Spheres

attribute vec4 vertexMC;
attribute vec2 offsetMC;

// optional normal declaration
//VTK::Normal::Dec

//VTK::Picking::Dec

// Texture coordinates
//VTK::TCoord::Dec

uniform mat3 normalMatrix; // transform model coordinate directions to view coordinates

// material property values
//VTK::Color::Dec

// clipping plane vars
//VTK::Clip::Dec

// camera and actor matrix values
//VTK::Camera::Dec

varying vec4 vertexVCVSOutput;
varying float radiusVCVSOutput;
varying vec3 centerVCVSOutput;

uniform int cameraParallel;
uniform float scaleFactor;

void main()
{
  //VTK::Picking::Impl

  //VTK::Color::Impl

  //VTK::Normal::Impl

  //VTK::TCoord::Impl

  //VTK::Clip::Impl

  // compute the projected vertex position
  vec2 scaledOffsetMC = scaleFactor * offsetMC;
  vertexVCVSOutput = MCVCMatrix * vertexMC;
  centerVCVSOutput = vertexVCVSOutput.xyz;
  radiusVCVSOutput = length(scaledOffsetMC)*0.5;

  // make the triangle face the camera
  if (cameraParallel == 0)
    {
    vec3 dir = normalize(-vertexVCVSOutput.xyz);
    vec3 base2 = normalize(cross(dir,vec3(1.0,0.0,0.0)));
    vec3 base1 = cross(base2,dir);
    vertexVCVSOutput.xyz = vertexVCVSOutput.xyz + scaledOffsetMC.x*base1 + scaledOffsetMC.y*base2;
    }
  else
    {
    // add in the offset
    vertexVCVSOutput.xy = vertexVCVSOutput.xy + scaledOffsetMC;
    }

  gl_Position = VCPCMatrix * vertexVCVSOutput;
}
`;
const {
  vtkErrorMacro: dct
} = kr;
function hct(i, t) {
  t.classHierarchy.push("vtkOpenGLSphereMapper");
  const e = {
    ...i
  };
  i.getShaderTemplate = (n, s, r) => {
    n.Vertex = uct, n.Fragment = IT, n.Geometry = "";
  }, i.replaceShaderValues = (n, s, r) => {
    let a = n.Vertex, o = n.Fragment;
    a = Ft.substitute(a, "//VTK::Camera::Dec", [`uniform mat4 VCPCMatrix;
`, "uniform mat4 MCVCMatrix;"]).result, o = Ft.substitute(o, "//VTK::PositionVC::Dec", ["varying vec4 vertexVCVSOutput;"]).result, o = Ft.substitute(o, "//VTK::PositionVC::Impl", [`vec4 vertexVC = vertexVCVSOutput;
`]).result;
    const l = [`uniform float invertedDepth;
`, `uniform int cameraParallel;
`, `varying float radiusVCVSOutput;
`, `varying vec3 centerVCVSOutput;
`, `uniform mat4 VCPCMatrix;
`];
    o = Ft.substitute(o, "//VTK::Normal::Dec", l).result;
    let c = "";
    t.context.getExtension("EXT_frag_depth") && (c = `gl_FragDepthEXT = (pos.z / pos.w + 1.0) / 2.0;
`), t._openGLRenderWindow.getWebgl2() && (c = `gl_FragDepth = (pos.z / pos.w + 1.0) / 2.0;
`), o = Ft.substitute(o, "//VTK::Depth::Impl", [
      // compute the eye position and unit direction
      `  vec3 EyePos;
`,
      `  vec3 EyeDir;
`,
      `  if (cameraParallel != 0) {
`,
      `    EyePos = vec3(vertexVC.x, vertexVC.y, vertexVC.z + 3.0*radiusVCVSOutput);
`,
      `    EyeDir = vec3(0.0,0.0,-1.0); }
`,
      `  else {
`,
      `    EyeDir = vertexVC.xyz;
`,
      `    EyePos = vec3(0.0,0.0,0.0);
`,
      `    float lengthED = length(EyeDir);
`,
      `    EyeDir = normalize(EyeDir);
`,
      // we adjust the EyePos to be closer if it is too far away
      // to prevent floating point precision noise
      `    if (lengthED > radiusVCVSOutput*3.0) {
`,
      `      EyePos = vertexVC.xyz - EyeDir*3.0*radiusVCVSOutput; }
`,
      `    }
`,
      // translate to Sphere center
      `  EyePos = EyePos - centerVCVSOutput;
`,
      // scale to radius 1.0
      `  EyePos = EyePos/radiusVCVSOutput;
`,
      // find the intersection
      `  float b = 2.0*dot(EyePos,EyeDir);
`,
      `  float c = dot(EyePos,EyePos) - 1.0;
`,
      `  float d = b*b - 4.0*c;
`,
      `  vec3 normalVCVSOutput = vec3(0.0,0.0,1.0);
`,
      `  if (d < 0.0) { discard; }
`,
      `  else {
`,
      `    float t = (-b - invertedDepth*sqrt(d))*0.5;
`,
      // compute the normal, for unit sphere this is just
      // the intersection point
      `    normalVCVSOutput = invertedDepth*normalize(EyePos + t*EyeDir);
`,
      // compute the intersection point in VC
      `    vertexVC.xyz = normalVCVSOutput*radiusVCVSOutput + centerVCVSOutput;
`,
      `    }
`,
      // compute the pixel's depth
      // ' normalVCVSOutput = vec3(0,0,1);\n'
      `  vec4 pos = VCPCMatrix * vertexVC;
`,
      c
    ]).result, o = Ft.substitute(o, "//VTK::Normal::Impl", "").result, t.haveSeenDepthRequest && (o = Ft.substitute(o, "//VTK::ZBuffer::Impl", ["if (depthRequest == 1) {", "float computedZ = (pos.z / pos.w + 1.0) / 2.0;", "float iz = floor(computedZ * 65535.0 + 0.1);", "float rf = floor(iz/256.0)/255.0;", "float gf = mod(iz,256.0)/255.0;", "gl_FragData[0] = vec4(rf, gf, 0.0, 1.0); }"]).result), n.Vertex = a, n.Fragment = o, e.replaceShaderValues(n, s, r);
  }, i.setMapperShaderParameters = (n, s, r) => {
    if (n.getCABO().getElementCount() && (t.VBOBuildTime > n.getAttributeUpdateTime().getMTime() || n.getShaderSourceTime().getMTime() > n.getAttributeUpdateTime().getMTime()) && n.getProgram().isAttributeUsed("offsetMC") && (n.getVAO().addAttributeArray(
      n.getProgram(),
      n.getCABO(),
      "offsetMC",
      12,
      // 12:this->VBO->ColorOffset+sizeof(float)
      n.getCABO().getStride(),
      t.context.FLOAT,
      2,
      !1
    ) || dct("Error setting 'offsetMC' in shader VAO.")), n.getProgram().isUniformUsed("invertedDepth") && n.getProgram().setUniformf("invertedDepth", t.invert ? -1 : 1), n.getProgram().isUniformUsed("scaleFactor")) {
      const o = t.currentInput.getPointData();
      t.renderable.getScaleArray() != null && o.hasArray(t.renderable.getScaleArray()) ? n.getProgram().setUniformf("scaleFactor", t.renderable.getScaleFactor()) : n.getProgram().setUniformf("scaleFactor", 1);
    }
    e.setMapperShaderParameters(n, s, r);
  }, i.setCameraShaderParameters = (n, s, r) => {
    const a = n.getProgram(), o = s.getActiveCamera(), l = t.openGLCamera.getKeyMatrices(s);
    if (a.isUniformUsed("VCPCMatrix") && a.setUniformMatrix("VCPCMatrix", l.vcpc), a.isUniformUsed("MCVCMatrix"))
      if (r.getIsIdentity())
        a.setUniformMatrix("MCVCMatrix", l.wcvc);
      else {
        const c = t.openGLActor.getKeyMatrices(), u = new Float64Array(16);
        ut.multiply(u, l.wcvc, c.mcwc), a.setUniformMatrix("MCVCMatrix", u);
      }
    a.isUniformUsed("cameraParallel") && n.getProgram().setUniformi("cameraParallel", o.getParallelProjection());
  }, i.getOpenGLMode = (n, s) => t.context.TRIANGLES, i.buildBufferObjects = (n, s) => {
    const r = t.currentInput;
    if (r === null)
      return;
    t.renderable.mapScalars(r, 1);
    const a = t.renderable.getColorMapColors(), o = t.primitives[t.primTypes.Tris].getCABO(), l = r.getPointData(), c = r.getPoints(), u = c.getNumberOfPoints(), d = c.getData(), h = 5;
    let p = null;
    t.renderable.getScaleArray() != null && l.hasArray(t.renderable.getScaleArray()) && (p = l.getArray(t.renderable.getScaleArray()).getData());
    let m = null, b = 0, y = null;
    a ? (b = a.getNumberOfComponents(), o.setColorOffset(0), o.setColorBOStride(4), m = a.getData(), y = new Uint8Array(3 * u * 4), o.getColorBO() || o.setColorBO(Rc.newInstance()), o.getColorBO().setOpenGLRenderWindow(t._openGLRenderWindow)) : o.getColorBO() && o.setColorBO(null), o.setColorComponents(b);
    const Z = new Float32Array(h * u * 3);
    o.setStride(h * 4);
    const g = Math.cos(Qi(30));
    let f = 0, T = 0, M = 0, N = 0;
    for (let W = 0; W < u; ++W) {
      let x = t.renderable.getRadius();
      p && (x = p[W]), f = W * 3, Z[M++] = d[f++], Z[M++] = d[f++], Z[M++] = d[f++], Z[M++] = -2 * x * g, Z[M++] = -x, m && (T = W * b, y[N++] = m[T], y[N++] = m[T + 1], y[N++] = m[T + 2], y[N++] = m[T + 3]), f = W * 3, Z[M++] = d[f++], Z[M++] = d[f++], Z[M++] = d[f++], Z[M++] = 2 * x * g, Z[M++] = -x, m && (y[N++] = m[T], y[N++] = m[T + 1], y[N++] = m[T + 2], y[N++] = m[T + 3]), f = W * 3, Z[M++] = d[f++], Z[M++] = d[f++], Z[M++] = d[f++], Z[M++] = 0, Z[M++] = 2 * x, m && (y[N++] = m[T], y[N++] = m[T + 1], y[N++] = m[T + 2], y[N++] = m[T + 3]);
    }
    o.setElementCount(M / h), o.upload(Z, id.ARRAY_BUFFER), a && o.getColorBO().upload(y, id.ARRAY_BUFFER), t.VBOBuildTime.modified();
  };
}
const pct = {};
function mct(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, pct, e), kI.extend(i, t, e), hct(i, t);
}
const bct = In(mct, "vtkOpenGLSphereMapper");
Js("vtkSphereMapper", bct);
var fct = `//VTK::System::Dec

/*=========================================================================

  Program:   Visualization Toolkit
  Module:    vtkStickMapperVS.glsl

  Copyright (c) Ken Martin, Will Schroeder, Bill Lorensen
  All rights reserved.
  See Copyright.txt or http://www.kitware.com/Copyright.htm for details.

     This software is distributed WITHOUT ANY WARRANTY; without even
     the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR
     PURPOSE.  See the above copyright notice for more information.

=========================================================================*/
// this shader implements imposters in OpenGL for Sticks

attribute vec4 vertexMC;
attribute vec3 orientMC;
attribute vec4 offsetMC;
attribute float radiusMC;

// optional normal declaration
//VTK::Normal::Dec

//VTK::Picking::Dec

// Texture coordinates
//VTK::TCoord::Dec

uniform mat3 normalMatrix; // transform model coordinate directions to view coordinates

// material property values
//VTK::Color::Dec

// clipping plane vars
//VTK::Clip::Dec

// camera and actor matrix values
//VTK::Camera::Dec

varying vec4 vertexVCVSOutput;
varying float radiusVCVSOutput;
varying float lengthVCVSOutput;
varying vec3 centerVCVSOutput;
varying vec3 orientVCVSOutput;

uniform int cameraParallel;

void main()
{
  //VTK::Picking::Impl

  //VTK::Color::Impl

  //VTK::Normal::Impl

  //VTK::TCoord::Impl

  //VTK::Clip::Impl

  vertexVCVSOutput = MCVCMatrix * vertexMC;
  centerVCVSOutput = vertexVCVSOutput.xyz;
  radiusVCVSOutput = radiusMC;
  lengthVCVSOutput = length(orientMC);
  orientVCVSOutput = normalMatrix * normalize(orientMC);

  // make sure it is pointing out of the screen
  if (orientVCVSOutput.z < 0.0)
    {
    orientVCVSOutput = -orientVCVSOutput;
    }

  // make the basis
  vec3 xbase;
  vec3 ybase;
  vec3 dir = vec3(0.0,0.0,1.0);
  if (cameraParallel == 0)
    {
    dir = normalize(-vertexVCVSOutput.xyz);
    }
  if (abs(dot(dir,orientVCVSOutput)) == 1.0)
    {
    xbase = normalize(cross(vec3(0.0,1.0,0.0),orientVCVSOutput));
    ybase = cross(xbase,orientVCVSOutput);
    }
  else
    {
    xbase = normalize(cross(orientVCVSOutput,dir));
    ybase = cross(orientVCVSOutput,xbase);
    }

  vec3 offsets = offsetMC.xyz*2.0-1.0;
  vertexVCVSOutput.xyz = vertexVCVSOutput.xyz +
    radiusVCVSOutput*offsets.x*xbase +
    radiusVCVSOutput*offsets.y*ybase +
    0.5*lengthVCVSOutput*offsets.z*orientVCVSOutput;

  gl_Position = VCPCMatrix * vertexVCVSOutput;
}
`;
const {
  vtkErrorMacro: cM
} = kr;
function gct(i, t) {
  t.classHierarchy.push("vtkOpenGLStickMapper");
  const e = {
    ...i
  };
  i.getShaderTemplate = (n, s, r) => {
    n.Vertex = fct, n.Fragment = IT, n.Geometry = "";
  }, i.replaceShaderValues = (n, s, r) => {
    let a = n.Vertex, o = n.Fragment;
    a = Ft.substitute(a, "//VTK::Camera::Dec", [`uniform mat4 VCPCMatrix;
`, "uniform mat4 MCVCMatrix;"]).result, o = Ft.substitute(o, "//VTK::PositionVC::Dec", "varying vec4 vertexVCVSOutput;").result, o = Ft.substitute(o, "//VTK::PositionVC::Impl", `  vec4 vertexVC = vertexVCVSOutput;
`).result;
    const l = [`uniform int cameraParallel;
`, `varying float radiusVCVSOutput;
`, `varying vec3 orientVCVSOutput;
`, `varying float lengthVCVSOutput;
`, `varying vec3 centerVCVSOutput;
`, `uniform mat4 VCPCMatrix;
`];
    o = Ft.substitute(o, "//VTK::Normal::Dec", l).result;
    let c = "";
    t.context.getExtension("EXT_frag_depth") && (c = `  gl_FragDepthEXT = (pos.z / pos.w + 1.0) / 2.0;
`), t._openGLRenderWindow.getWebgl2() && (c = `gl_FragDepth = (pos.z / pos.w + 1.0) / 2.0;
`), o = Ft.substitute(o, "//VTK::Depth::Impl", [
      // compute the eye position and unit direction
      `  vec3 EyePos;
`,
      `  vec3 EyeDir;
`,
      `  if (cameraParallel != 0) {
`,
      `    EyePos = vec3(vertexVC.x, vertexVC.y, vertexVC.z + 3.0*radiusVCVSOutput);
`,
      `    EyeDir = vec3(0.0,0.0,-1.0); }
`,
      `  else {
`,
      `    EyeDir = vertexVC.xyz;
`,
      `    EyePos = vec3(0.0,0.0,0.0);
`,
      `    float lengthED = length(EyeDir);
`,
      `    EyeDir = normalize(EyeDir);
`,
      // we adjust the EyePos to be closer if it is too far away
      // to prevent floating point precision noise
      `    if (lengthED > radiusVCVSOutput*3.0) {
`,
      `      EyePos = vertexVC.xyz - EyeDir*3.0*radiusVCVSOutput; }
`,
      `    }
`,
      // translate to Stick center
      `  EyePos = EyePos - centerVCVSOutput;
`,
      // rotate to new basis
      // base1, base2, orientVC
      `  vec3 base1;
`,
      `  if (abs(orientVCVSOutput.z) < 0.99) {
`,
      `    base1 = normalize(cross(orientVCVSOutput,vec3(0.0,0.0,1.0))); }
`,
      `  else {
`,
      `    base1 = normalize(cross(orientVCVSOutput,vec3(0.0,1.0,0.0))); }
`,
      `  vec3 base2 = cross(orientVCVSOutput,base1);
`,
      `  EyePos = vec3(dot(EyePos,base1),dot(EyePos,base2),dot(EyePos,orientVCVSOutput));
`,
      `  EyeDir = vec3(dot(EyeDir,base1),dot(EyeDir,base2),dot(EyeDir,orientVCVSOutput));
`,
      // scale by radius
      `  EyePos = EyePos/radiusVCVSOutput;
`,
      // find the intersection
      `  float a = EyeDir.x*EyeDir.x + EyeDir.y*EyeDir.y;
`,
      `  float b = 2.0*(EyePos.x*EyeDir.x + EyePos.y*EyeDir.y);
`,
      `  float c = EyePos.x*EyePos.x + EyePos.y*EyePos.y - 1.0;
`,
      `  float d = b*b - 4.0*a*c;
`,
      `  vec3 normalVCVSOutput = vec3(0.0,0.0,1.0);
`,
      `  if (d < 0.0) { discard; }
`,
      `  else {
`,
      `    float t =  (-b - sqrt(d))/(2.0*a);
`,
      `    float tz = EyePos.z + t*EyeDir.z;
`,
      `    vec3 iPoint = EyePos + t*EyeDir;
`,
      `    if (abs(iPoint.z)*radiusVCVSOutput > lengthVCVSOutput*0.5) {
`,
      // test for end cap
      `      float t2 = (-b + sqrt(d))/(2.0*a);
`,
      `      float tz2 = EyePos.z + t2*EyeDir.z;
`,
      `      if (tz2*radiusVCVSOutput > lengthVCVSOutput*0.5 || tz*radiusVCVSOutput < -0.5*lengthVCVSOutput) { discard; }
`,
      `      else {
`,
      `        normalVCVSOutput = orientVCVSOutput;
`,
      `        float t3 = (lengthVCVSOutput*0.5/radiusVCVSOutput - EyePos.z)/EyeDir.z;
`,
      `        iPoint = EyePos + t3*EyeDir;
`,
      `        vertexVC.xyz = radiusVCVSOutput*(iPoint.x*base1 + iPoint.y*base2 + iPoint.z*orientVCVSOutput) + centerVCVSOutput;
`,
      `        }
`,
      `      }
`,
      `    else {
`,
      // The normal is the iPoint.xy rotated back into VC
      `      normalVCVSOutput = iPoint.x*base1 + iPoint.y*base2;
`,
      // rescale rerotate and translate
      `      vertexVC.xyz = radiusVCVSOutput*(normalVCVSOutput + iPoint.z*orientVCVSOutput) + centerVCVSOutput;
`,
      `      }
`,
      `    }
`,
      //    '  vec3 normalVC = vec3(0.0,0.0,1.0);\n'
      // compute the pixel's depth
      `  vec4 pos = VCPCMatrix * vertexVC;
`,
      c
    ]).result, o = Ft.substitute(o, "//VTK::Normal::Impl", "").result, t.haveSeenDepthRequest && (o = Ft.substitute(o, "//VTK::ZBuffer::Impl", ["if (depthRequest == 1) {", "float computedZ = (pos.z / pos.w + 1.0) / 2.0;", "float iz = floor(computedZ * 65535.0 + 0.1);", "float rf = floor(iz/256.0)/255.0;", "float gf = mod(iz,256.0)/255.0;", "gl_FragData[0] = vec4(rf, gf, 0.0, 1.0); }"]).result), n.Vertex = a, n.Fragment = o, e.replaceShaderValues(n, s, r);
  }, i.setMapperShaderParameters = (n, s, r) => {
    n.getCABO().getElementCount() && (t.VBOBuildTime > n.getAttributeUpdateTime().getMTime() || n.getShaderSourceTime().getMTime() > n.getAttributeUpdateTime().getMTime()) && (n.getProgram().isAttributeUsed("orientMC") && (n.getVAO().addAttributeArray(
      n.getProgram(),
      n.getCABO(),
      "orientMC",
      12,
      // after X Y Z
      n.getCABO().getStride(),
      t.context.FLOAT,
      3,
      !1
    ) || cM("Error setting 'orientMC' in shader VAO.")), n.getProgram().isAttributeUsed("offsetMC") && (n.getVAO().addAttributeArray(n.getProgram(), n.getCABO().getColorBO(), "offsetMC", 0, n.getCABO().getColorBOStride(), t.context.UNSIGNED_BYTE, 3, !0) || cM("Error setting 'offsetMC' in shader VAO.")), n.getProgram().isAttributeUsed("radiusMC") && (n.getVAO().addAttributeArray(
      n.getProgram(),
      n.getCABO(),
      "radiusMC",
      24,
      // X Y Z OX OY OZ
      n.getCABO().getStride(),
      t.context.FLOAT,
      1,
      !1
    ) || cM("Error setting 'radiusMC' in shader VAO."))), e.setMapperShaderParameters(n, s, r);
  }, i.setCameraShaderParameters = (n, s, r) => {
    const a = n.getProgram(), o = s.getActiveCamera(), l = t.openGLCamera.getKeyMatrices(s);
    if (a.isUniformUsed("VCPCMatrix") && a.setUniformMatrix("VCPCMatrix", l.vcpc), r.getIsIdentity())
      a.isUniformUsed("MCVCMatrix") && a.setUniformMatrix("MCVCMatrix", l.wcvc), a.isUniformUsed("normalMatrix") && a.setUniformMatrix3x3("normalMatrix", l.normalMatrix);
    else {
      const c = t.openGLActor.getKeyMatrices();
      if (a.isUniformUsed("MCVCMatrix")) {
        const u = new Float64Array(16);
        ut.multiply(u, l.wcvc, c.mcwc), a.setUniformMatrix("MCVCMatrix", u);
      }
      if (a.isUniformUsed("normalMatrix")) {
        const u = new Float64Array(9);
        gi.multiply(u, l.normalMatrix, c.normalMatrix), a.setUniformMatrix3x3("normalMatrix", u);
      }
    }
    a.isUniformUsed("cameraParallel") && n.getProgram().setUniformi("cameraParallel", o.getParallelProjection());
  }, i.getOpenGLMode = (n, s) => t.context.TRIANGLES, i.buildBufferObjects = (n, s) => {
    const r = t.currentInput;
    if (r === null)
      return;
    t.renderable.mapScalars(r, 1);
    const a = t.renderable.getColorMapColors(), o = t.primitives[t.primTypes.Tris].getCABO(), l = r.getPointData(), c = r.getPoints(), u = c.getNumberOfPoints(), d = c.getData();
    let h = 3;
    h += 4;
    let p = null, m = 0;
    o.setColorBOStride(4), o.getColorBO() || o.setColorBO(Rc.newInstance()), o.getColorBO().setOpenGLRenderWindow(t._openGLRenderWindow), a && (m = a.getNumberOfComponents(), o.setColorOffset(4), p = a.getData(), o.setColorBOStride(8)), o.setColorComponents(m), o.setStride(h * 4);
    const b = new Float32Array(h * u * 12), y = new Uint8Array(12 * u * (p ? 8 : 4));
    let Z = null, g = null;
    t.renderable.getScaleArray() != null && l.hasArray(t.renderable.getScaleArray()) && (Z = l.getArray(t.renderable.getScaleArray()).getData()), t.renderable.getOrientationArray() != null && l.hasArray(t.renderable.getOrientationArray()) ? g = l.getArray(t.renderable.getOrientationArray()).getData() : cM([`Error setting orientationArray.
`, "You have to specify the stick orientation"]);
    const f = [0, 1, 3, 0, 3, 2, 2, 3, 5, 2, 5, 4];
    let T = 0, M = 0, N = 0, W = 0;
    for (let x = 0; x < u; ++x) {
      let V = t.renderable.getLength(), X = t.renderable.getRadius();
      Z && (V = Z[x * 2], X = Z[x * 2 + 1]);
      for (let C = 0; C < f.length; ++C)
        T = x * 3, b[N++] = d[T++], b[N++] = d[T++], b[N++] = d[T++], T = x * 3, b[N++] = g[T++] * V, b[N++] = g[T++] * V, b[N++] = g[T++] * V, b[N++] = X, y[W++] = 255 * (f[C] % 2), y[W++] = f[C] >= 4 ? 255 : 0, y[W++] = f[C] >= 2 ? 255 : 0, y[W++] = 255, M = x * m, p && (y[W++] = p[M], y[W++] = p[M + 1], y[W++] = p[M + 2], y[W++] = p[M + 3]);
    }
    o.setElementCount(N / h), o.upload(b, id.ARRAY_BUFFER), o.getColorBO().upload(y, id.ARRAY_BUFFER), t.VBOBuildTime.modified();
  };
}
const yct = {};
function Zct(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, yct, e), kI.extend(i, t, e), gct(i, t);
}
const Tct = In(Zct, "vtkOpenGLStickMapper");
Js("vtkStickMapper", Tct);
const Mct = "WebGL", yW = /* @__PURE__ */ Object.create(null);
function Ej(i, t) {
  yW[i] = t;
}
function Nct() {
  return Object.keys(yW);
}
function kj(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return yW[i] && yW[i](t);
}
function Wct(i, t) {
  t.classHierarchy.push("vtkRenderWindow"), i.addRenderer = (e) => {
    i.hasRenderer(e) || (e.setRenderWindow(i), t.renderers.push(e), i.modified());
  }, i.removeRenderer = (e) => {
    t.renderers = t.renderers.filter((n) => n !== e), i.modified();
  }, i.hasRenderer = (e) => t.renderers.indexOf(e) !== -1, i.newAPISpecificView = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return kj(e || t.defaultViewAPI, n);
  }, i.addView = (e) => {
    i.hasView(e) || (e.setRenderable(i), t._views.push(e), i.modified());
  }, i.removeView = (e) => {
    t._views = t._views.filter((n) => n !== e), i.modified();
  }, i.hasView = (e) => t._views.indexOf(e) !== -1, i.preRender = () => {
    t.renderers.forEach((e) => {
      e.isActiveCameraCreated() || e.resetCamera();
    });
  }, i.render = () => {
    i.preRender(), t.interactor ? t.interactor.render() : t._views.forEach((e) => e.traverseAllPasses());
  }, i.getStatistics = () => {
    const e = {
      propCount: 0,
      invisiblePropCount: 0,
      gpuMemoryMB: 0
    };
    return t._views.forEach((n) => {
      n.getGraphicsMemoryInfo && (e.gpuMemoryMB += n.getGraphicsMemoryInfo() / 1e6);
    }), t.renderers.forEach((n) => {
      const s = n.getViewProps(), r = t._views[0].getViewNodeFor(n);
      s.forEach((a) => {
        if (a.getVisibility()) {
          e.propCount += 1;
          const o = a.getMapper && a.getMapper();
          if (o && o.getPrimitiveCount) {
            const l = r.getViewNodeFor(o);
            if (l) {
              l.getAllocatedGPUMemoryInBytes && (e.gpuMemoryMB += l.getAllocatedGPUMemoryInBytes() / 1e6);
              const c = o.getPrimitiveCount();
              Object.keys(c).forEach((u) => {
                e[u] || (e[u] = 0), e[u] += c[u];
              });
            }
          }
        } else
          e.invisiblePropCount += 1;
      });
    }), e.str = Object.keys(e).map((n) => `${n}: ${e[n]}`).join(`
`), e;
  }, i.captureImages = function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "image/png", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return tt.setImmediate(i.render), t._views.map((s) => s.captureNextImage ? s.captureNextImage(e, n) : void 0).filter((s) => !!s);
  };
}
const Gct = {
  defaultViewAPI: Mct,
  renderers: [],
  views: [],
  interactor: null,
  neverRendered: !0,
  numberOfLayers: 1
};
function Fj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Gct, e), tt.obj(i, t), tt.setGet(i, t, ["interactor", "numberOfLayers", "_views", "defaultViewAPI"]), tt.get(i, t, ["neverRendered"]), tt.getArray(i, t, ["renderers"]), tt.moveToProtected(i, t, ["views"]), tt.event(i, t, "completion"), Wct(i, t);
}
const wct = tt.newInstance(Fj, "vtkRenderWindow");
var YT = {
  newInstance: wct,
  extend: Fj,
  registerViewConstructor: Ej,
  listViewAPIs: Nct,
  newAPISpecificView: kj
};
function xct(i, t) {
  t.classHierarchy.push("vtkRenderPass"), i.getOperation = () => t.currentOperation, i.setCurrentOperation = (e) => {
    t.currentOperation = e, t.currentTraverseOperation = `traverse${tt.capitalize(t.currentOperation)}`;
  }, i.getTraverseOperation = () => t.currentTraverseOperation, i.traverse = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    t.deleted || (t._currentParent = n, t.preDelegateOperations.forEach((s) => {
      i.setCurrentOperation(s), e.traverse(i);
    }), t.delegates.forEach((s) => {
      s.traverse(e, i);
    }), t.postDelegateOperations.forEach((s) => {
      i.setCurrentOperation(s), e.traverse(i);
    }));
  };
}
const Sct = {
  delegates: [],
  currentOperation: null,
  preDelegateOperations: [],
  postDelegateOperations: [],
  currentParent: null
};
function jj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Sct, e), tt.obj(i, t), tt.get(i, t, ["currentOperation"]), tt.setGet(i, t, ["delegates", "_currentParent", "preDelegateOperations", "postDelegateOperations"]), tt.moveToProtected(i, t, ["currentParent"]), xct(i, t);
}
const Lct = tt.newInstance(jj, "vtkRenderPass");
var PG = {
  newInstance: Lct,
  extend: jj
};
const {
  Representation: Vct
} = V0, {
  vtkErrorMacro: xO
} = tt;
function Xct(i) {
  const t = Ft.substitute(i.Fragment, "//VTK::RenderPassFragmentShader::Impl", `
      float weight = gl_FragData[0].a * pow(max(1.1 - gl_FragCoord.z, 0.0), 2.0);
      gl_FragData[0] = vec4(gl_FragData[0].rgb*weight, gl_FragData[0].a);
      gl_FragData[1].r = weight;
    `, !1);
  i.Fragment = t.result;
}
const Ict = `//VTK::System::Dec

in vec2 tcoord;

uniform sampler2D translucentRTexture;
uniform sampler2D translucentRGBATexture;

// the output of this shader
//VTK::Output::Dec

void main()
{
  vec4 t1Color = texture(translucentRGBATexture, tcoord);
  float t2Color = texture(translucentRTexture, tcoord).r;
  gl_FragData[0] = vec4(t1Color.rgb/max(t2Color,0.01), 1.0 - t1Color.a);
}
`;
function Cct(i, t) {
  t.classHierarchy.push("vtkOpenGLOrderIndependentTranslucentPass"), i.createVertexBuffer = () => {
    const e = new Float32Array([-1, -1, -1, 1, -1, -1, -1, 1, -1, 1, 1, -1]), n = new Float32Array([0, 0, 1, 0, 0, 1, 1, 1]), s = new Uint16Array([4, 0, 1, 3, 2]), r = We.newInstance({
      numberOfComponents: 3,
      values: e
    });
    r.setName("points");
    const a = We.newInstance({
      numberOfComponents: 2,
      values: n
    });
    a.setName("tcoords");
    const o = We.newInstance({
      numberOfComponents: 1,
      values: s
    });
    t.tris.getCABO().createVBO(o, "polys", Vct.SURFACE, {
      points: r,
      tcoords: a,
      cellOffset: 0
    }), t.VBOBuildTime.modified();
  }, i.createFramebuffer = (e) => {
    const n = e.getSize(), s = e.getContext();
    t.framebuffer = gg.newInstance(), t.framebuffer.setOpenGLRenderWindow(e), t.framebuffer.create(...n), t.framebuffer.saveCurrentBindingsAndBuffers(), t.framebuffer.bind(), t.translucentRGBATexture = bs.newInstance(), t.translucentRGBATexture.setInternalFormat(s.RGBA16F), t.translucentRGBATexture.setFormat(s.RGBA), t.translucentRGBATexture.setOpenGLDataType(s.HALF_FLOAT), t.translucentRGBATexture.setOpenGLRenderWindow(e), t.translucentRGBATexture.create2DFromRaw(n[0], n[1], 4, "Float32Array", null), t.translucentRTexture = bs.newInstance(), t.translucentRTexture.setInternalFormat(s.R16F), t.translucentRTexture.setFormat(s.RED), t.translucentRTexture.setOpenGLDataType(s.HALF_FLOAT), t.translucentRTexture.setOpenGLRenderWindow(e), t.translucentRTexture.create2DFromRaw(n[0], n[1], 1, "Float32Array", null), t.translucentZTexture = bs.newInstance(), t.translucentZTexture.setOpenGLRenderWindow(e), t.translucentZTexture.createDepthFromRaw(n[0], n[1], "Float32Array", null), t.framebuffer.setColorBuffer(t.translucentRGBATexture, 0), t.framebuffer.setColorBuffer(t.translucentRTexture, 1), t.framebuffer.setDepthBuffer(t.translucentZTexture);
  }, i.createCopyShader = (e) => {
    t.copyShader = e.getShaderCache().readyShaderProgramArray(["//VTK::System::Dec", "attribute vec4 vertexDC;", "attribute vec2 tcoordTC;", "varying vec2 tcoord;", "void main() { tcoord = tcoordTC; gl_Position = vertexDC; }"].join(`
`), Ict, "");
  }, i.createVBO = (e) => {
    const n = e.getContext();
    t.tris.setOpenGLRenderWindow(e), i.createVertexBuffer();
    const s = t.copyShader;
    t.tris.getCABO().bind(), t.copyVAO.addAttributeArray(s, t.tris.getCABO(), "vertexDC", t.tris.getCABO().getVertexOffset(), t.tris.getCABO().getStride(), n.FLOAT, 3, n.FALSE) || xO("Error setting vertexDC in copy shader VAO."), t.copyVAO.addAttributeArray(s, t.tris.getCABO(), "tcoordTC", t.tris.getCABO().getTCoordOffset(), t.tris.getCABO().getStride(), n.FLOAT, 2, n.FALSE) || xO("Error setting vertexDC in copy shader VAO.");
  }, i.traverse = (e, n, s) => {
    if (t.deleted)
      return;
    const r = e.getSize(), a = e.getContext();
    if (t._supported = !1, n.getSelector() || !a || !e.getWebgl2() || !a.getExtension("EXT_color_buffer_half_float") && !a.getExtension("EXT_color_buffer_float")) {
      i.setCurrentOperation("translucentPass"), n.traverse(i);
      return;
    }
    if (t._supported = !0, t.framebuffer === null)
      i.createFramebuffer(e);
    else {
      const l = t.framebuffer.getSize();
      l === null || l[0] !== r[0] || l[1] !== r[1] ? (t.framebuffer.releaseGraphicsResources(), t.translucentRGBATexture.releaseGraphicsResources(e), t.translucentRTexture.releaseGraphicsResources(e), t.translucentZTexture.releaseGraphicsResources(e), i.createFramebuffer(e)) : (t.framebuffer.saveCurrentBindingsAndBuffers(), t.framebuffer.bind());
    }
    a.drawBuffers([a.COLOR_ATTACHMENT0]), a.clearBufferfv(a.COLOR, 0, [0, 0, 0, 0]), a.clearBufferfv(a.DEPTH, 0, [1]), a.colorMask(!1, !1, !1, !1), s.getOpaqueActorCount() > 0 && (s.setCurrentOperation("opaqueZBufferPass"), n.traverse(s)), a.colorMask(!0, !0, !0, !0), a.drawBuffers([a.COLOR_ATTACHMENT0, a.COLOR_ATTACHMENT1]), a.viewport(0, 0, r[0], r[1]), a.scissor(0, 0, r[0], r[1]), a.clearBufferfv(a.COLOR, 0, [0, 0, 0, 1]), a.clearBufferfv(a.COLOR, 1, [0, 0, 0, 0]), a.enable(a.DEPTH_TEST), a.enable(a.BLEND), a.blendFuncSeparate(a.ONE, a.ONE, a.ZERO, a.ONE_MINUS_SRC_ALPHA), i.setCurrentOperation("translucentPass"), n.traverse(i), a.drawBuffers([a.NONE]), t.framebuffer.restorePreviousBindingsAndBuffers(), t.copyShader === null ? i.createCopyShader(e) : e.getShaderCache().readyShaderProgram(t.copyShader), t.copyVAO || (t.copyVAO = zI.newInstance(), t.copyVAO.setOpenGLRenderWindow(e)), t.copyVAO.bind(), t.VBOBuildTime.getMTime() < i.getMTime() && i.createVBO(e), a.blendFuncSeparate(a.SRC_ALPHA, a.ONE_MINUS_SRC_ALPHA, a.ONE, a.ONE_MINUS_SRC_ALPHA), a.depthMask(!1), a.depthFunc(a.ALWAYS), a.viewport(0, 0, r[0], r[1]), a.scissor(0, 0, r[0], r[1]), t.translucentRGBATexture.activate(), t.copyShader.setUniformi("translucentRGBATexture", t.translucentRGBATexture.getTextureUnit()), t.translucentRTexture.activate(), t.copyShader.setUniformi("translucentRTexture", t.translucentRTexture.getTextureUnit()), a.drawArrays(a.TRIANGLES, 0, Number(t.tris.getCABO().getElementCount())), a.depthMask(!0), a.depthFunc(a.LEQUAL), t.translucentRGBATexture.deactivate(), t.translucentRTexture.deactivate();
    const o = n.getTiledSizeAndOrigin();
    a.scissor(o.lowerLeftU, o.lowerLeftV, o.usize, o.vsize), a.viewport(o.lowerLeftU, o.lowerLeftV, o.usize, o.vsize);
  }, i.getShaderReplacement = () => t._supported ? Xct : null, i.releaseGraphicsResources = (e) => {
    t.framebuffer && (t.framebuffer.releaseGraphicsResources(e), t.framebuffer = null), t.translucentRGBATexture && (t.translucentRGBATexture.releaseGraphicsResources(e), t.translucentRGBATexture = null), t.translucentRTexture && (t.translucentRTexture.releaseGraphicsResources(e), t.translucentRTexture = null), t.translucentZTexture && (t.translucentZTexture.releaseGraphicsResources(e), t.translucentZTexture = null), t.copyVAO && (t.copyVAO.releaseGraphicsResources(e), t.copyVAO = null), t.copyShader && (t.copyShader.releaseGraphicsResources(e), t.copyShader = null), t.tris && (t.tris.releaseGraphicsResources(e), t.tris = null), i.modified();
  };
}
const Yct = {
  framebuffer: null,
  copyShader: null,
  tris: null
};
function Uj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Yct, e), PG.extend(i, t, e), t.VBOBuildTime = {}, tt.obj(t.VBOBuildTime, {
    mtime: 0
  }), t.tris = Jc.newInstance(), tt.get(i, t, ["framebuffer"]), Cct(i, t);
}
const vct = tt.newInstance(Uj, "vtkOpenGLOrderIndependentTranslucentPass");
var Pj = {
  newInstance: vct,
  extend: Uj
};
function Rct(i, t) {
  t.classHierarchy.push("vtkForwardPass"), i.traverse = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (t.deleted)
      return;
    t._currentParent = n, i.setCurrentOperation("buildPass"), e.traverse(i);
    const s = e.getRenderable().getNumberOfLayers(), r = e.getChildren();
    for (let a = 0; a < s; a++)
      for (let o = 0; o < r.length; o++) {
        const l = r[o], c = e.getRenderable().getRenderers()[o];
        if (c.getDraw() && c.getLayer() === a) {
          if (t.opaqueActorCount = 0, t.translucentActorCount = 0, t.volumeCount = 0, t.overlayActorCount = 0, i.setCurrentOperation("queryPass"), l.traverse(i), (t.opaqueActorCount > 0 || t.translucentActorCount > 0) && t.volumeCount > 0 || t.depthRequested) {
            const u = e.getFramebufferSize();
            t.framebuffer === null && (t.framebuffer = gg.newInstance()), t.framebuffer.setOpenGLRenderWindow(e), t.framebuffer.saveCurrentBindingsAndBuffers();
            const d = t.framebuffer.getSize();
            (d === null || d[0] !== u[0] || d[1] !== u[1]) && (t.framebuffer.create(u[0], u[1]), t.framebuffer.populateFramebuffer()), t.framebuffer.bind(), i.setCurrentOperation("zBufferPass"), l.traverse(i), t.framebuffer.restorePreviousBindingsAndBuffers(), t.depthRequested = !1;
          }
          i.setCurrentOperation("cameraPass"), l.traverse(i), t.opaqueActorCount > 0 && (i.setCurrentOperation("opaquePass"), l.traverse(i)), t.translucentActorCount > 0 && (t.translucentPass || (t.translucentPass = Pj.newInstance()), t.translucentPass.traverse(e, l, i)), t.volumeCount > 0 && (i.setCurrentOperation("volumePass"), l.traverse(i)), t.overlayActorCount > 0 && (i.setCurrentOperation("overlayPass"), l.traverse(i));
        }
      }
  }, i.getZBufferTexture = () => t.framebuffer ? t.framebuffer.getColorTexture() : null, i.requestDepth = () => {
    t.depthRequested = !0;
  }, i.incrementOpaqueActorCount = () => t.opaqueActorCount++, i.incrementTranslucentActorCount = () => t.translucentActorCount++, i.incrementVolumeCount = () => t.volumeCount++, i.incrementOverlayActorCount = () => t.overlayActorCount++;
}
const Dct = {
  opaqueActorCount: 0,
  translucentActorCount: 0,
  volumeCount: 0,
  overlayActorCount: 0,
  framebuffer: null,
  depthRequested: !1
};
function Jj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Dct, e), PG.extend(i, t, e), tt.get(i, t, ["framebuffer", "opaqueActorCount", "translucentActorCount", "volumeCount"]), Rct(i, t);
}
const Oct = tt.newInstance(Jj, "vtkForwardPass");
var zct = {
  newInstance: Oct,
  extend: Jj
};
const {
  FieldAssociations: Ect
} = Vg;
function kct(i, t) {
  t.classHierarchy.push("vtkHardwareSelector"), i.getSourceDataAsync = async (e, n, s, r, a) => {
  }, i.selectAsync = async (e, n, s, r, a) => {
    const o = await i.getSourceDataAsync(e, n, s, r, a);
    return o ? o.generateSelection(n, s, r, a) : [];
  };
}
const Fct = {
  fieldAssociation: Ect.FIELD_ASSOCIATION_CELLS,
  captureZValues: !1
};
function Aj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Fct, e), tt.obj(i, t), tt.setGet(i, t, ["fieldAssociation", "captureZValues"]), kct(i, t);
}
const jct = tt.newInstance(Aj, "vtkHardwareSelector");
var Uct = {
  newInstance: jct,
  extend: Aj
};
const Bj = {
  GLOBALIDS: 0,
  PEDIGREEIDS: 1,
  VALUES: 2,
  INDICES: 3,
  FRUSTUM: 4,
  LOCATIONS: 5,
  THRESHOLDS: 6,
  BLOCKS: 7,
  QUERY: 8
}, fL = {
  CELL: 0,
  POINT: 1,
  FIELD: 2,
  VERTEX: 3,
  EDGE: 4,
  ROW: 5
};
var Pct = {
  SelectionContent: Bj,
  SelectionField: fL
};
function Jct(i, t) {
  t.classHierarchy.push("vtkSelectionNode"), i.getBounds = () => t.points.getBounds();
}
const Act = {
  contentType: -1,
  fieldType: -1,
  properties: null,
  selectionList: []
};
function Kj(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Act, e), tt.obj(i, t), t.properties = {}, tt.setGet(i, t, ["contentType", "fieldType", "properties", "selectionList"]), Jct(i, t);
}
const Bct = tt.newInstance(Kj, "vtkSelectionNode");
var JI = {
  newInstance: Bct,
  extend: Kj,
  ...Pct
};
const {
  PassTypes: Os
} = z9, {
  SelectionContent: Kct,
  SelectionField: SO
} = JI, {
  FieldAssociations: n2
} = Vg, {
  vtkErrorMacro: Hj
} = tt, jd = 1;
function _j(i) {
  return `${i.propID} ${i.compositeID}`;
}
function Qj(i, t, e, n) {
  if (!e)
    return 0;
  const s = (t * (n[2] - n[0] + 1) + i) * 4;
  return e[s + 3];
}
function Hu(i, t, e, n) {
  if (!e)
    return 0;
  const s = (t * (n[2] - n[0] + 1) + i) * 4, r = e[s], a = e[s + 1];
  return (e[s + 2] * 256 + a) * 256 + r;
}
function $j(i, t) {
  let e = t;
  return e <<= 24, e |= i, e;
}
function Hct(i, t, e, n) {
  {
    if (n[0] = t[0], n[1] = t[1], t[0] < i.area[0] || t[0] > i.area[2] || t[1] < i.area[1] || t[1] > i.area[3])
      return null;
    const s = [t[0] - i.area[0], t[1] - i.area[1]], r = Hu(s[0], s[1], i.pixBuffer[Os.ACTOR_PASS], i.area);
    if (r <= 0 || r - jd >= i.props.length)
      return null;
    const a = {};
    a.valid = !0, a.propID = r - jd, a.prop = i.props[a.propID];
    let o = Hu(s[0], s[1], i.pixBuffer[Os.COMPOSITE_INDEX_PASS], i.area);
    if ((o < 0 || o > 16777215) && (o = 0), a.compositeID = o - jd, i.captureZValues) {
      const u = (s[1] * (i.area[2] - i.area[0] + 1) + s[0]) * 4;
      a.zValue = (256 * i.zBuffer[u] + i.zBuffer[u + 1]) / 65535, a.displayPosition = t;
    }
    if (i.pixBuffer[Os.ID_LOW24] && Qj(s[0], s[1], i.pixBuffer[Os.ID_LOW24], i.area) === 0)
      return a;
    const l = Hu(s[0], s[1], i.pixBuffer[Os.ID_LOW24], i.area), c = Hu(s[0], s[1], i.pixBuffer[Os.ID_HIGH24], i.area);
    return a.attributeID = $j(l, c), a;
  }
}
function qj(i, t, e, n, s) {
  const r = [];
  let a = 0;
  return t.forEach((o, l) => {
    const c = JI.newInstance();
    switch (c.setContentType(Kct.INDICES), i) {
      case n2.FIELD_ASSOCIATION_CELLS:
        c.setFieldType(SO.CELL);
        break;
      case n2.FIELD_ASSOCIATION_POINTS:
        c.setFieldType(SO.POINT);
        break;
      default:
        Hj("Unknown field association");
    }
    c.getProperties().propID = o.info.propID, c.getProperties().prop = o.info.prop, c.getProperties().compositeID = o.info.compositeID, c.getProperties().attributeID = o.info.attributeID, c.getProperties().pixelCount = o.pixelCount, e && (c.getProperties().displayPosition = [o.info.displayPosition[0], o.info.displayPosition[1], o.info.zValue], c.getProperties().worldPosition = s.displayToWorld(o.info.displayPosition[0], o.info.displayPosition[1], o.info.zValue, n)), c.setSelectionList(o.attributeIDs), r[a] = c, a++;
  }), r;
}
function _ct(i, t, e, n, s) {
  const r = Math.floor(t), a = Math.floor(e), o = Math.floor(n), l = Math.floor(s), c = /* @__PURE__ */ new Map(), u = [0, 0];
  for (let d = a; d <= l; d++)
    for (let h = r; h <= o; h++) {
      const m = Hct(i, [h, d], 0, u);
      if (m && m.valid) {
        const b = _j(m);
        if (!c.has(b))
          c.set(b, {
            info: m,
            pixelCount: 1,
            attributeIDs: [m.attributeID]
          });
        else {
          const y = c.get(b);
          y.pixelCount++, i.captureZValues && m.zValue < y.info.zValue && (y.info = m), y.attributeIDs.indexOf(m.attributeID) === -1 && y.attributeIDs.push(m.attributeID);
        }
      }
    }
  return qj(i.fieldAssociation, c, i.captureZValues, i.renderer, i.openGLRenderWindow);
}
function Qct(i, t) {
  t.classHierarchy.push("vtkOpenGLHardwareSelector"), i.releasePixBuffers = () => {
    t.rawPixBuffer = [], t.pixBuffer = [], t.zBuffer = null;
  }, i.beginSelection = () => {
    t._openGLRenderer = t._openGLRenderWindow.getViewNodeFor(t._renderer), t.maxAttributeId = 0;
    const n = t._openGLRenderWindow.getSize();
    if (!t.framebuffer)
      t.framebuffer = gg.newInstance(), t.framebuffer.setOpenGLRenderWindow(t._openGLRenderWindow), t.framebuffer.saveCurrentBindingsAndBuffers(), t.framebuffer.create(n[0], n[1]), t.framebuffer.populateFramebuffer();
    else {
      t.framebuffer.setOpenGLRenderWindow(t._openGLRenderWindow), t.framebuffer.saveCurrentBindingsAndBuffers();
      const s = t.framebuffer.getSize();
      !s || s[0] !== n[0] || s[1] !== n[1] ? (t.framebuffer.create(n[0], n[1]), t.framebuffer.populateFramebuffer()) : t.framebuffer.bind();
    }
    if (t._openGLRenderer.clear(), t._openGLRenderer.setSelector(i), t.hitProps = {}, t.propPixels = {}, t.props = [], i.releasePixBuffers(), t.fieldAssociation === n2.FIELD_ASSOCIATION_POINTS) {
      const s = t._openGLRenderWindow.getContext(), r = s.isEnabled(s.BLEND);
      s.disable(s.BLEND), t._openGLRenderWindow.traverseAllPasses(), r && s.enable(s.BLEND);
    }
  }, i.endSelection = () => {
    t.hitProps = {}, t._openGLRenderer.setSelector(null), t.framebuffer.restorePreviousBindingsAndBuffers();
  }, i.preCapturePass = () => {
    const n = t._openGLRenderWindow.getContext();
    t.originalBlending = n.isEnabled(n.BLEND), n.disable(n.BLEND);
  }, i.postCapturePass = () => {
    const n = t._openGLRenderWindow.getContext();
    t.originalBlending && n.enable(n.BLEND);
  }, i.select = () => {
    let n = null;
    return i.captureBuffers() && (n = i.generateSelection(t.area[0], t.area[1], t.area[2], t.area[3]), i.releasePixBuffers()), n;
  }, i.getSourceDataAsync = async (n, s, r, a, o) => {
    if (t._renderer = n, s === void 0) {
      const c = t._openGLRenderWindow.getSize();
      i.setArea(0, 0, c[0] - 1, c[1] - 1);
    } else
      i.setArea(s, r, a, o);
    if (!i.captureBuffers())
      return !1;
    const l = {
      area: [...t.area],
      pixBuffer: [...t.pixBuffer],
      captureZValues: t.captureZValues,
      zBuffer: t.zBuffer,
      props: [...t.props],
      fieldAssociation: t.fieldAssociation,
      renderer: n,
      openGLRenderWindow: t._openGLRenderWindow
    };
    return l.generateSelection = function() {
      for (var c = arguments.length, u = new Array(c), d = 0; d < c; d++)
        u[d] = arguments[d];
      return _ct(l, ...u);
    }, l;
  }, i.captureBuffers = () => {
    if (!t._renderer || !t._openGLRenderWindow)
      return Hj("Renderer and view must be set before calling Select."), !1;
    t._openGLRenderer = t._openGLRenderWindow.getViewNodeFor(t._renderer), t._openGLRenderWindow.getRenderable().preRender(), i.invokeEvent({
      type: "StartEvent"
    }), t.originalBackground = t._renderer.getBackgroundByReference(), t._renderer.setBackground(0, 0, 0, 0);
    const n = t._openGLRenderWindow.getRenderPasses();
    for (i.beginSelection(), t.currentPass = Os.MIN_KNOWN_PASS; t.currentPass <= Os.MAX_KNOWN_PASS; t.currentPass++)
      i.passRequired(t.currentPass) && (i.preCapturePass(t.currentPass), t.captureZValues && t.currentPass === Os.ACTOR_PASS && typeof n[0].requestDepth == "function" && typeof n[0].getFramebuffer == "function" && n[0].requestDepth(), t._openGLRenderWindow.traverseAllPasses(), i.postCapturePass(t.currentPass), i.savePixelBuffer(t.currentPass), i.processPixelBuffers());
    return i.endSelection(), t._renderer.setBackground(t.originalBackground), i.invokeEvent({
      type: "EndEvent"
    }), !0;
  }, i.processPixelBuffers = () => {
    t.props.forEach((n, s) => {
      i.isPropHit(s) && n.processSelectorPixelBuffers(i, t.propPixels[s]);
    });
  }, i.passRequired = (n) => {
    if (n === Os.ID_HIGH24) {
      if (t.fieldAssociation === n2.FIELD_ASSOCIATION_POINTS)
        return t.maximumPointId > 16777215;
      if (t.fieldAssociation === n2.FIELD_ASSOCIATION_CELLS)
        return t.maximumCellId > 16777215;
    }
    return !0;
  }, i.savePixelBuffer = (n) => {
    if (t.pixBuffer[n] = t._openGLRenderWindow.getPixelData(t.area[0], t.area[1], t.area[2], t.area[3]), !t.rawPixBuffer[n]) {
      const s = (t.area[2] - t.area[0] + 1) * (t.area[3] - t.area[1] + 1) * 4;
      t.rawPixBuffer[n] = new Uint8Array(s), t.rawPixBuffer[n].set(t.pixBuffer[n]);
    }
    if (n === Os.ACTOR_PASS) {
      if (t.captureZValues) {
        const s = t._openGLRenderWindow.getRenderPasses();
        if (typeof s[0].requestDepth == "function" && typeof s[0].getFramebuffer == "function") {
          const r = s[0].getFramebuffer();
          r.saveCurrentBindingsAndBuffers(), r.bind(), t.zBuffer = t._openGLRenderWindow.getPixelData(t.area[0], t.area[1], t.area[2], t.area[3]), r.restorePreviousBindingsAndBuffers();
        }
      }
      i.buildPropHitList(t.rawPixBuffer[n]);
    }
  }, i.buildPropHitList = (n) => {
    let s = 0;
    for (let r = 0; r <= t.area[3] - t.area[1]; r++)
      for (let a = 0; a <= t.area[2] - t.area[0]; a++) {
        let o = Hu(a, r, n, t.area);
        o > 0 && (o--, o in t.hitProps || (t.hitProps[o] = !0, t.propPixels[o] = []), t.propPixels[o].push(s * 4)), ++s;
      }
  }, i.renderProp = (n) => {
    t.currentPass === Os.ACTOR_PASS && (i.setPropColorValueFromInt(t.props.length + jd), t.props.push(n));
  }, i.renderCompositeIndex = (n) => {
    t.currentPass === Os.COMPOSITE_INDEX_PASS && i.setPropColorValueFromInt(n + jd);
  }, i.renderAttributeId = (n) => {
    n < 0 || (t.maxAttributeId = n > t.maxAttributeId ? n : t.maxAttributeId);
  }, i.passTypeToString = (n) => tt.enumToString(Os, n), i.isPropHit = (n) => !!t.hitProps[n], i.setPropColorValueFromInt = (n) => {
    t.propColorValue[0] = n % 256 / 255, t.propColorValue[1] = Math.floor(n / 256) % 256 / 255, t.propColorValue[2] = Math.floor(n / 65536) % 256 / 255;
  }, i.getPixelInformation = (n, s, r) => {
    const a = s < 0 ? 0 : s;
    if (a === 0) {
      if (r[0] = n[0], r[1] = n[1], n[0] < t.area[0] || n[0] > t.area[2] || n[1] < t.area[1] || n[1] > t.area[3])
        return null;
      const u = [n[0] - t.area[0], n[1] - t.area[1]], d = Hu(u[0], u[1], t.pixBuffer[Os.ACTOR_PASS], t.area);
      if (d <= 0 || d - jd >= t.props.length)
        return null;
      const h = {};
      h.valid = !0, h.propID = d - jd, h.prop = t.props[h.propID];
      let p = Hu(u[0], u[1], t.pixBuffer[Os.COMPOSITE_INDEX_PASS], t.area);
      if ((p < 0 || p > 16777215) && (p = 0), h.compositeID = p - jd, t.captureZValues) {
        const y = (u[1] * (t.area[2] - t.area[0] + 1) + u[0]) * 4;
        h.zValue = (256 * t.zBuffer[y] + t.zBuffer[y + 1]) / 65535, h.displayPosition = n;
      }
      if (t.pixBuffer[Os.ID_LOW24] && Qj(u[0], u[1], t.pixBuffer[Os.ID_LOW24], t.area) === 0)
        return h;
      const m = Hu(u[0], u[1], t.pixBuffer[Os.ID_LOW24], t.area), b = Hu(u[0], u[1], t.pixBuffer[Os.ID_HIGH24], t.area);
      return h.attributeID = $j(m, b), h;
    }
    const o = [n[0], n[1]], l = [0, 0];
    let c = i.getPixelInformation(n, 0, r);
    if (c && c.valid)
      return c;
    for (let u = 1; u < a; ++u) {
      for (let d = o[1] > u ? o[1] - u : 0; d <= o[1] + u; ++d)
        if (l[1] = d, o[0] >= u && (l[0] = o[0] - u, c = i.getPixelInformation(l, 0, r), c && c.valid) || (l[0] = o[0] + u, c = i.getPixelInformation(l, 0, r), c && c.valid))
          return c;
      for (let d = o[0] >= u ? o[0] - (u - 1) : 0; d <= o[0] + (u - 1); ++d)
        if (l[0] = d, o[1] >= u && (l[1] = o[1] - u, c = i.getPixelInformation(l, 0, r), c && c.valid) || (l[1] = o[1] + u, c = i.getPixelInformation(l, 0, r), c && c.valid))
          return c;
    }
    return r[0] = n[0], r[1] = n[1], null;
  }, i.generateSelection = (n, s, r, a) => {
    const o = Math.floor(n), l = Math.floor(s), c = Math.floor(r), u = Math.floor(a), d = /* @__PURE__ */ new Map(), h = [0, 0];
    for (let p = l; p <= u; p++)
      for (let m = o; m <= c; m++) {
        const b = [m, p], y = i.getPixelInformation(b, 0, h);
        if (y && y.valid) {
          const Z = _j(y);
          if (!d.has(Z))
            d.set(Z, {
              info: y,
              pixelCount: 1,
              attributeIDs: [y.attributeID]
            });
          else {
            const g = d.get(Z);
            g.pixelCount++, t.captureZValues && y.zValue < g.info.zValue && (g.info = y), g.attributeIDs.indexOf(y.attributeID) === -1 && g.attributeIDs.push(y.attributeID);
          }
        }
      }
    return qj(t.fieldAssociation, d, t.captureZValues, t._renderer, t._openGLRenderWindow);
  }, i.getRawPixelBuffer = (n) => t.rawPixBuffer[n], i.getPixelBuffer = (n) => t.pixBuffer[n], i.attach = (n, s) => {
    t._openGLRenderWindow = n, t._renderer = s;
  };
  const e = i.setArea;
  i.setArea = function() {
    return e(...arguments) ? (t.area[0] = Math.floor(t.area[0]), t.area[1] = Math.floor(t.area[1]), t.area[2] = Math.floor(t.area[2]), t.area[3] = Math.floor(t.area[3]), !0) : !1;
  };
}
const $ct = {
  area: void 0,
  // _renderer: null,
  // _openGLRenderWindow: null,
  // _openGLRenderer: null,
  currentPass: -1,
  propColorValue: null,
  props: null,
  maximumPointId: 0,
  maximumCellId: 0,
  idOffset: 1
};
function tU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, $ct, e), Uct.extend(i, t, e), t.propColorValue = [0, 0, 0], t.props = [], t.area || (t.area = [0, 0, 0, 0]), tt.setGetArray(i, t, ["area"], 4), tt.setGet(i, t, ["_renderer", "currentPass", "_openGLRenderWindow", "maximumPointId", "maximumCellId"]), tt.setGetArray(i, t, ["propColorValue"], 3), tt.moveToProtected(i, t, ["renderer", "openGLRenderWindow"]), tt.event(i, t, "event"), Qct(i, t);
}
const qct = tt.newInstance(tU, "vtkOpenGLHardwareSelector");
var JG = {
  newInstance: qct,
  extend: tU,
  ...z9
}, eU = { exports: {} };
(function(i, t) {
  (function(e) {
    i.exports = e();
  })(function(e) {
    var n = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    function s(Z, g) {
      var f = Z[0], T = Z[1], M = Z[2], N = Z[3];
      f += (T & M | ~T & N) + g[0] - 680876936 | 0, f = (f << 7 | f >>> 25) + T | 0, N += (f & T | ~f & M) + g[1] - 389564586 | 0, N = (N << 12 | N >>> 20) + f | 0, M += (N & f | ~N & T) + g[2] + 606105819 | 0, M = (M << 17 | M >>> 15) + N | 0, T += (M & N | ~M & f) + g[3] - 1044525330 | 0, T = (T << 22 | T >>> 10) + M | 0, f += (T & M | ~T & N) + g[4] - 176418897 | 0, f = (f << 7 | f >>> 25) + T | 0, N += (f & T | ~f & M) + g[5] + 1200080426 | 0, N = (N << 12 | N >>> 20) + f | 0, M += (N & f | ~N & T) + g[6] - 1473231341 | 0, M = (M << 17 | M >>> 15) + N | 0, T += (M & N | ~M & f) + g[7] - 45705983 | 0, T = (T << 22 | T >>> 10) + M | 0, f += (T & M | ~T & N) + g[8] + 1770035416 | 0, f = (f << 7 | f >>> 25) + T | 0, N += (f & T | ~f & M) + g[9] - 1958414417 | 0, N = (N << 12 | N >>> 20) + f | 0, M += (N & f | ~N & T) + g[10] - 42063 | 0, M = (M << 17 | M >>> 15) + N | 0, T += (M & N | ~M & f) + g[11] - 1990404162 | 0, T = (T << 22 | T >>> 10) + M | 0, f += (T & M | ~T & N) + g[12] + 1804603682 | 0, f = (f << 7 | f >>> 25) + T | 0, N += (f & T | ~f & M) + g[13] - 40341101 | 0, N = (N << 12 | N >>> 20) + f | 0, M += (N & f | ~N & T) + g[14] - 1502002290 | 0, M = (M << 17 | M >>> 15) + N | 0, T += (M & N | ~M & f) + g[15] + 1236535329 | 0, T = (T << 22 | T >>> 10) + M | 0, f += (T & N | M & ~N) + g[1] - 165796510 | 0, f = (f << 5 | f >>> 27) + T | 0, N += (f & M | T & ~M) + g[6] - 1069501632 | 0, N = (N << 9 | N >>> 23) + f | 0, M += (N & T | f & ~T) + g[11] + 643717713 | 0, M = (M << 14 | M >>> 18) + N | 0, T += (M & f | N & ~f) + g[0] - 373897302 | 0, T = (T << 20 | T >>> 12) + M | 0, f += (T & N | M & ~N) + g[5] - 701558691 | 0, f = (f << 5 | f >>> 27) + T | 0, N += (f & M | T & ~M) + g[10] + 38016083 | 0, N = (N << 9 | N >>> 23) + f | 0, M += (N & T | f & ~T) + g[15] - 660478335 | 0, M = (M << 14 | M >>> 18) + N | 0, T += (M & f | N & ~f) + g[4] - 405537848 | 0, T = (T << 20 | T >>> 12) + M | 0, f += (T & N | M & ~N) + g[9] + 568446438 | 0, f = (f << 5 | f >>> 27) + T | 0, N += (f & M | T & ~M) + g[14] - 1019803690 | 0, N = (N << 9 | N >>> 23) + f | 0, M += (N & T | f & ~T) + g[3] - 187363961 | 0, M = (M << 14 | M >>> 18) + N | 0, T += (M & f | N & ~f) + g[8] + 1163531501 | 0, T = (T << 20 | T >>> 12) + M | 0, f += (T & N | M & ~N) + g[13] - 1444681467 | 0, f = (f << 5 | f >>> 27) + T | 0, N += (f & M | T & ~M) + g[2] - 51403784 | 0, N = (N << 9 | N >>> 23) + f | 0, M += (N & T | f & ~T) + g[7] + 1735328473 | 0, M = (M << 14 | M >>> 18) + N | 0, T += (M & f | N & ~f) + g[12] - 1926607734 | 0, T = (T << 20 | T >>> 12) + M | 0, f += (T ^ M ^ N) + g[5] - 378558 | 0, f = (f << 4 | f >>> 28) + T | 0, N += (f ^ T ^ M) + g[8] - 2022574463 | 0, N = (N << 11 | N >>> 21) + f | 0, M += (N ^ f ^ T) + g[11] + 1839030562 | 0, M = (M << 16 | M >>> 16) + N | 0, T += (M ^ N ^ f) + g[14] - 35309556 | 0, T = (T << 23 | T >>> 9) + M | 0, f += (T ^ M ^ N) + g[1] - 1530992060 | 0, f = (f << 4 | f >>> 28) + T | 0, N += (f ^ T ^ M) + g[4] + 1272893353 | 0, N = (N << 11 | N >>> 21) + f | 0, M += (N ^ f ^ T) + g[7] - 155497632 | 0, M = (M << 16 | M >>> 16) + N | 0, T += (M ^ N ^ f) + g[10] - 1094730640 | 0, T = (T << 23 | T >>> 9) + M | 0, f += (T ^ M ^ N) + g[13] + 681279174 | 0, f = (f << 4 | f >>> 28) + T | 0, N += (f ^ T ^ M) + g[0] - 358537222 | 0, N = (N << 11 | N >>> 21) + f | 0, M += (N ^ f ^ T) + g[3] - 722521979 | 0, M = (M << 16 | M >>> 16) + N | 0, T += (M ^ N ^ f) + g[6] + 76029189 | 0, T = (T << 23 | T >>> 9) + M | 0, f += (T ^ M ^ N) + g[9] - 640364487 | 0, f = (f << 4 | f >>> 28) + T | 0, N += (f ^ T ^ M) + g[12] - 421815835 | 0, N = (N << 11 | N >>> 21) + f | 0, M += (N ^ f ^ T) + g[15] + 530742520 | 0, M = (M << 16 | M >>> 16) + N | 0, T += (M ^ N ^ f) + g[2] - 995338651 | 0, T = (T << 23 | T >>> 9) + M | 0, f += (M ^ (T | ~N)) + g[0] - 198630844 | 0, f = (f << 6 | f >>> 26) + T | 0, N += (T ^ (f | ~M)) + g[7] + 1126891415 | 0, N = (N << 10 | N >>> 22) + f | 0, M += (f ^ (N | ~T)) + g[14] - 1416354905 | 0, M = (M << 15 | M >>> 17) + N | 0, T += (N ^ (M | ~f)) + g[5] - 57434055 | 0, T = (T << 21 | T >>> 11) + M | 0, f += (M ^ (T | ~N)) + g[12] + 1700485571 | 0, f = (f << 6 | f >>> 26) + T | 0, N += (T ^ (f | ~M)) + g[3] - 1894986606 | 0, N = (N << 10 | N >>> 22) + f | 0, M += (f ^ (N | ~T)) + g[10] - 1051523 | 0, M = (M << 15 | M >>> 17) + N | 0, T += (N ^ (M | ~f)) + g[1] - 2054922799 | 0, T = (T << 21 | T >>> 11) + M | 0, f += (M ^ (T | ~N)) + g[8] + 1873313359 | 0, f = (f << 6 | f >>> 26) + T | 0, N += (T ^ (f | ~M)) + g[15] - 30611744 | 0, N = (N << 10 | N >>> 22) + f | 0, M += (f ^ (N | ~T)) + g[6] - 1560198380 | 0, M = (M << 15 | M >>> 17) + N | 0, T += (N ^ (M | ~f)) + g[13] + 1309151649 | 0, T = (T << 21 | T >>> 11) + M | 0, f += (M ^ (T | ~N)) + g[4] - 145523070 | 0, f = (f << 6 | f >>> 26) + T | 0, N += (T ^ (f | ~M)) + g[11] - 1120210379 | 0, N = (N << 10 | N >>> 22) + f | 0, M += (f ^ (N | ~T)) + g[2] + 718787259 | 0, M = (M << 15 | M >>> 17) + N | 0, T += (N ^ (M | ~f)) + g[9] - 343485551 | 0, T = (T << 21 | T >>> 11) + M | 0, Z[0] = f + Z[0] | 0, Z[1] = T + Z[1] | 0, Z[2] = M + Z[2] | 0, Z[3] = N + Z[3] | 0;
    }
    function r(Z) {
      var g = [], f;
      for (f = 0; f < 64; f += 4)
        g[f >> 2] = Z.charCodeAt(f) + (Z.charCodeAt(f + 1) << 8) + (Z.charCodeAt(f + 2) << 16) + (Z.charCodeAt(f + 3) << 24);
      return g;
    }
    function a(Z) {
      var g = [], f;
      for (f = 0; f < 64; f += 4)
        g[f >> 2] = Z[f] + (Z[f + 1] << 8) + (Z[f + 2] << 16) + (Z[f + 3] << 24);
      return g;
    }
    function o(Z) {
      var g = Z.length, f = [1732584193, -271733879, -1732584194, 271733878], T, M, N, W, x, V;
      for (T = 64; T <= g; T += 64)
        s(f, r(Z.substring(T - 64, T)));
      for (Z = Z.substring(T - 64), M = Z.length, N = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], T = 0; T < M; T += 1)
        N[T >> 2] |= Z.charCodeAt(T) << (T % 4 << 3);
      if (N[T >> 2] |= 128 << (T % 4 << 3), T > 55)
        for (s(f, N), T = 0; T < 16; T += 1)
          N[T] = 0;
      return W = g * 8, W = W.toString(16).match(/(.*?)(.{0,8})$/), x = parseInt(W[2], 16), V = parseInt(W[1], 16) || 0, N[14] = x, N[15] = V, s(f, N), f;
    }
    function l(Z) {
      var g = Z.length, f = [1732584193, -271733879, -1732584194, 271733878], T, M, N, W, x, V;
      for (T = 64; T <= g; T += 64)
        s(f, a(Z.subarray(T - 64, T)));
      for (Z = T - 64 < g ? Z.subarray(T - 64) : new Uint8Array(0), M = Z.length, N = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], T = 0; T < M; T += 1)
        N[T >> 2] |= Z[T] << (T % 4 << 3);
      if (N[T >> 2] |= 128 << (T % 4 << 3), T > 55)
        for (s(f, N), T = 0; T < 16; T += 1)
          N[T] = 0;
      return W = g * 8, W = W.toString(16).match(/(.*?)(.{0,8})$/), x = parseInt(W[2], 16), V = parseInt(W[1], 16) || 0, N[14] = x, N[15] = V, s(f, N), f;
    }
    function c(Z) {
      var g = "", f;
      for (f = 0; f < 4; f += 1)
        g += n[Z >> f * 8 + 4 & 15] + n[Z >> f * 8 & 15];
      return g;
    }
    function u(Z) {
      var g;
      for (g = 0; g < Z.length; g += 1)
        Z[g] = c(Z[g]);
      return Z.join("");
    }
    u(o("hello")), typeof ArrayBuffer < "u" && !ArrayBuffer.prototype.slice && (function() {
      function Z(g, f) {
        return g = g | 0 || 0, g < 0 ? Math.max(g + f, 0) : Math.min(g, f);
      }
      ArrayBuffer.prototype.slice = function(g, f) {
        var T = this.byteLength, M = Z(g, T), N = T, W, x, V, X;
        return f !== e && (N = Z(f, T)), M > N ? new ArrayBuffer(0) : (W = N - M, x = new ArrayBuffer(W), V = new Uint8Array(x), X = new Uint8Array(this, M, W), V.set(X), x);
      };
    })();
    function d(Z) {
      return /[\u0080-\uFFFF]/.test(Z) && (Z = unescape(encodeURIComponent(Z))), Z;
    }
    function h(Z, g) {
      var f = Z.length, T = new ArrayBuffer(f), M = new Uint8Array(T), N;
      for (N = 0; N < f; N += 1)
        M[N] = Z.charCodeAt(N);
      return g ? M : T;
    }
    function p(Z) {
      return String.fromCharCode.apply(null, new Uint8Array(Z));
    }
    function m(Z, g, f) {
      var T = new Uint8Array(Z.byteLength + g.byteLength);
      return T.set(new Uint8Array(Z)), T.set(new Uint8Array(g), Z.byteLength), T;
    }
    function b(Z) {
      var g = [], f = Z.length, T;
      for (T = 0; T < f - 1; T += 2)
        g.push(parseInt(Z.substr(T, 2), 16));
      return String.fromCharCode.apply(String, g);
    }
    function y() {
      this.reset();
    }
    return y.prototype.append = function(Z) {
      return this.appendBinary(d(Z)), this;
    }, y.prototype.appendBinary = function(Z) {
      this._buff += Z, this._length += Z.length;
      var g = this._buff.length, f;
      for (f = 64; f <= g; f += 64)
        s(this._hash, r(this._buff.substring(f - 64, f)));
      return this._buff = this._buff.substring(f - 64), this;
    }, y.prototype.end = function(Z) {
      var g = this._buff, f = g.length, T, M = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], N;
      for (T = 0; T < f; T += 1)
        M[T >> 2] |= g.charCodeAt(T) << (T % 4 << 3);
      return this._finish(M, f), N = u(this._hash), Z && (N = b(N)), this.reset(), N;
    }, y.prototype.reset = function() {
      return this._buff = "", this._length = 0, this._hash = [1732584193, -271733879, -1732584194, 271733878], this;
    }, y.prototype.getState = function() {
      return {
        buff: this._buff,
        length: this._length,
        hash: this._hash.slice()
      };
    }, y.prototype.setState = function(Z) {
      return this._buff = Z.buff, this._length = Z.length, this._hash = Z.hash, this;
    }, y.prototype.destroy = function() {
      delete this._hash, delete this._buff, delete this._length;
    }, y.prototype._finish = function(Z, g) {
      var f = g, T, M, N;
      if (Z[f >> 2] |= 128 << (f % 4 << 3), f > 55)
        for (s(this._hash, Z), f = 0; f < 16; f += 1)
          Z[f] = 0;
      T = this._length * 8, T = T.toString(16).match(/(.*?)(.{0,8})$/), M = parseInt(T[2], 16), N = parseInt(T[1], 16) || 0, Z[14] = M, Z[15] = N, s(this._hash, Z);
    }, y.hash = function(Z, g) {
      return y.hashBinary(d(Z), g);
    }, y.hashBinary = function(Z, g) {
      var f = o(Z), T = u(f);
      return g ? b(T) : T;
    }, y.ArrayBuffer = function() {
      this.reset();
    }, y.ArrayBuffer.prototype.append = function(Z) {
      var g = m(this._buff.buffer, Z), f = g.length, T;
      for (this._length += Z.byteLength, T = 64; T <= f; T += 64)
        s(this._hash, a(g.subarray(T - 64, T)));
      return this._buff = T - 64 < f ? new Uint8Array(g.buffer.slice(T - 64)) : new Uint8Array(0), this;
    }, y.ArrayBuffer.prototype.end = function(Z) {
      var g = this._buff, f = g.length, T = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], M, N;
      for (M = 0; M < f; M += 1)
        T[M >> 2] |= g[M] << (M % 4 << 3);
      return this._finish(T, f), N = u(this._hash), Z && (N = b(N)), this.reset(), N;
    }, y.ArrayBuffer.prototype.reset = function() {
      return this._buff = new Uint8Array(0), this._length = 0, this._hash = [1732584193, -271733879, -1732584194, 271733878], this;
    }, y.ArrayBuffer.prototype.getState = function() {
      var Z = y.prototype.getState.call(this);
      return Z.buff = p(Z.buff), Z;
    }, y.ArrayBuffer.prototype.setState = function(Z) {
      return Z.buff = h(Z.buff, !0), y.prototype.setState.call(this, Z);
    }, y.ArrayBuffer.prototype.destroy = y.prototype.destroy, y.ArrayBuffer.prototype._finish = y.prototype._finish, y.ArrayBuffer.hash = function(Z, g) {
      var f = l(new Uint8Array(Z)), T = u(f);
      return g ? b(T) : T;
    }, y;
  });
})(eU);
var tut = eU.exports;
const eut = /* @__PURE__ */ qi(tut), nut = ["lastShaderProgramBound", "context", "_openGLRenderWindow"];
function iut(i, t) {
  t.classHierarchy.push("vtkShaderCache"), i.replaceShaderValues = (e, n, s) => {
    let r = n;
    s.length > 0 && (r = Ft.substitute(r, "VSOut", "GSOut").result);
    const a = t._openGLRenderWindow.getWebgl2();
    let o = `
`, l = `#version 100
`;
    a ? l = `#version 300 es
#define attribute in
#define textureCube texture
#define texture2D texture
#define textureCubeLod textureLod
#define texture2DLod textureLod
` : (t.context.getExtension("OES_standard_derivatives"), t.context.getExtension("EXT_frag_depth") && (o = `#extension GL_EXT_frag_depth : enable
`), t.context.getExtension("EXT_shader_texture_lod") && (o += `#extension GL_EXT_shader_texture_lod : enable
#define textureCubeLod textureCubeLodEXT
#define texture2DLod texture2DLodEXT`)), r = Ft.substitute(r, "//VTK::System::Dec", [`${l}
`, a ? "" : `#extension GL_OES_standard_derivatives : enable
`, o, "#ifdef GL_FRAGMENT_PRECISION_HIGH", "precision highp float;", "precision highp int;", "#else", "precision mediump float;", "precision mediump int;", "#endif"]).result;
    let c = Ft.substitute(e, "//VTK::System::Dec", [`${l}
`, "#ifdef GL_FRAGMENT_PRECISION_HIGH", "precision highp float;", "precision highp int;", "#else", "precision mediump float;", "precision mediump int;", "#endif"]).result;
    if (a) {
      c = Ft.substitute(c, "varying", "out").result, r = Ft.substitute(r, "varying", "in").result;
      let d = "", h = 0;
      for (; r.includes(`gl_FragData[${h}]`); )
        r = Ft.substitute(r, `gl_FragData\\[${h}\\]`, `fragOutput${h}`).result, d += `layout(location = ${h}) out vec4 fragOutput${h};
`, h++;
      r = Ft.substitute(r, "//VTK::Output::Dec", d).result;
    }
    const u = Ft.substitute(s, "//VTK::System::Dec", l).result;
    return {
      VSSource: c,
      FSSource: r,
      GSSource: u
    };
  }, i.readyShaderProgramArray = (e, n, s) => {
    const r = i.replaceShaderValues(e, n, s), a = i.getShaderProgram(r.VSSource, r.FSSource, r.GSSource);
    return i.readyShaderProgram(a);
  }, i.readyShaderProgram = (e) => !e || !e.getCompiled() && !e.compileShader() || !i.bindShaderProgram(e) ? null : e, i.getShaderProgram = (e, n, s) => {
    const r = `${e}${n}${s}`;
    if (!(r in t.shaderPrograms)) {
      const a = eut.hash(r), o = Ft.newInstance();
      return o.setContext(t.context), o.getVertexShader().setSource(e), o.getFragmentShader().setSource(n), s && o.getGeometryShader().setSource(s), o.setMd5Hash(a), t.shaderPrograms[r] = o, o;
    }
    return t.shaderPrograms[r];
  }, i.releaseGraphicsResources = (e) => {
    i.releaseCurrentShaderProgram(), Object.keys(t.shaderPrograms).map((n) => t.shaderPrograms[n]).forEach((n) => n.cleanup()), t.shaderPrograms = {};
  }, i.releaseCurrentShaderProgram = () => {
    t.lastShaderProgramBound && (t.lastShaderProgramBound.cleanup(), t.lastShaderProgramBound = null);
  }, i.bindShaderProgram = (e) => (t.lastShaderProgramBound === e || (t.lastShaderProgramBound && t.lastShaderProgramBound.release(), e.bind(), t.lastShaderProgramBound = e), 1);
}
const sut = {
  lastShaderProgramBound: null,
  shaderPrograms: null,
  context: null
  // _openGLRenderWindow: null,
};
function nU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, sut, e), t.shaderPrograms = {}, tt.obj(i, t), tt.setGet(i, t, nut), tt.moveToProtected(i, t, ["openGLRenderWindow"]), iut(i, t);
}
const rut = tt.newInstance(nU, "vtkShaderCache");
var aut = {
  newInstance: rut,
  extend: nU
};
const {
  vtkErrorMacro: out
} = tt;
function lut(i, t) {
  t.classHierarchy.push("vtkOpenGLTextureUnitManager"), i.deleteTable = () => {
    for (let e = 0; e < t.numberOfTextureUnits; ++e)
      t.textureUnits[e] === !0 && out("some texture units  were not properly released");
    t.textureUnits = [], t.numberOfTextureUnits = 0;
  }, i.setContext = (e) => {
    if (t.context !== e) {
      if (t.context !== 0 && i.deleteTable(), t.context = e, t.context) {
        t.numberOfTextureUnits = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS);
        for (let n = 0; n < t.numberOfTextureUnits; ++n)
          t.textureUnits[n] = !1;
      }
      i.modified();
    }
  }, i.allocate = () => {
    for (let e = 0; e < t.numberOfTextureUnits; e++)
      if (!i.isAllocated(e))
        return t.textureUnits[e] = !0, e;
    return -1;
  }, i.allocateUnit = (e) => i.isAllocated(e) ? -1 : (t.textureUnits[e] = !0, e), i.isAllocated = (e) => t.textureUnits[e], i.free = (e) => {
    t.textureUnits[e] = !1;
  }, i.freeAll = () => {
    for (let e = 0; e < t.numberOfTextureUnits; ++e)
      t.textureUnits[e] = !1;
  };
}
const cut = {
  context: null,
  numberOfTextureUnits: 0,
  textureUnits: 0
};
function iU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, cut, e), tt.obj(i, t), t.textureUnits = [], tt.get(i, t, ["numberOfTextureUnits"]), tt.setGet(i, t, ["context"]), lut(i, t);
}
const uut = tt.newInstance(iU, "vtkOpenGLTextureUnitManager");
var dut = {
  newInstance: uut,
  extend: iU
};
function hut(i, t) {
  t.classHierarchy.push("vtkRenderWindowViewNode"), i.getViewNodeFactory = () => null, i.getAspectRatio = () => t.size[0] / t.size[1], i.getAspectRatioForRenderer = (e) => {
    const n = e.getViewportByReference();
    return t.size[0] * (n[2] - n[0]) / ((n[3] - n[1]) * t.size[1]);
  }, i.isInViewport = (e, n, s) => {
    const r = s.getViewportByReference(), a = i.getFramebufferSize();
    return r[0] * a[0] <= e && r[2] * a[0] >= e && r[1] * a[1] <= n && r[3] * a[1] >= n;
  }, i.getViewportSize = (e) => {
    const n = e.getViewportByReference(), s = i.getFramebufferSize();
    return [(n[2] - n[0]) * s[0], (n[3] - n[1]) * s[1]];
  }, i.getViewportCenter = (e) => {
    const n = i.getViewportSize(e);
    return [n[0] * 0.5, n[1] * 0.5];
  }, i.displayToNormalizedDisplay = (e, n, s) => {
    const r = i.getFramebufferSize();
    return [e / r[0], n / r[1], s];
  }, i.normalizedDisplayToDisplay = (e, n, s) => {
    const r = i.getFramebufferSize();
    return [e * r[0], n * r[1], s];
  }, i.worldToView = (e, n, s, r) => r.worldToView(e, n, s), i.viewToWorld = (e, n, s, r) => r.viewToWorld(e, n, s), i.worldToDisplay = (e, n, s, r) => {
    const a = r.worldToView(e, n, s), o = i.getViewportSize(r), l = r.viewToProjection(a[0], a[1], a[2], o[0] / o[1]), c = r.projectionToNormalizedDisplay(l[0], l[1], l[2]);
    return i.normalizedDisplayToDisplay(c[0], c[1], c[2]);
  }, i.displayToWorld = (e, n, s, r) => {
    const a = i.displayToNormalizedDisplay(e, n, s), o = r.normalizedDisplayToProjection(a[0], a[1], a[2]), l = i.getViewportSize(r), c = r.projectionToView(o[0], o[1], o[2], l[0] / l[1]);
    return r.viewToWorld(c[0], c[1], c[2]);
  }, i.normalizedDisplayToViewport = (e, n, s, r) => {
    let a = r.getViewportByReference();
    a = i.normalizedDisplayToDisplay(a[0], a[1], 0);
    const o = i.normalizedDisplayToDisplay(e, n, s);
    return [o[0] - a[0] - 0.5, o[1] - a[1] - 0.5, s];
  }, i.viewportToNormalizedViewport = (e, n, s, r) => {
    const a = i.getViewportSize(r);
    return a && a[0] !== 0 && a[1] !== 0 ? [e / (a[0] - 1), n / (a[1] - 1), s] : [e, n, s];
  }, i.normalizedViewportToViewport = (e, n, s, r) => {
    const a = i.getViewportSize(r);
    return [e * (a[0] - 1), n * (a[1] - 1), s];
  }, i.displayToLocalDisplay = (e, n, s) => {
    const r = i.getFramebufferSize();
    return [e, r[1] - n - 1, s];
  }, i.viewportToNormalizedDisplay = (e, n, s, r) => {
    let a = r.getViewportByReference();
    a = i.normalizedDisplayToDisplay(a[0], a[1], 0);
    const o = e + a[0] + 0.5, l = n + a[1] + 0.5;
    return i.displayToNormalizedDisplay(o, l, s);
  }, i.getComputedDevicePixelRatio = () => t.size[0] / i.getContainerSize()[0], i.getContainerSize = () => {
    tt.vtkErrorMacro("not implemented");
  }, i.getPixelData = (e, n, s, r) => {
    tt.vtkErrorMacro("not implemented");
  }, i.createSelector = () => {
    tt.vtkErrorMacro("not implemented");
  };
}
const put = {
  size: void 0,
  selector: void 0
};
function sU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, put, e), t.size || (t.size = [300, 300]), tt.getArray(i, t, ["size"], 2), tt.get(i, t, ["selector"]), ui.extend(i, t, e), hut(i, t);
}
const mut = tt.newInstance(sU, "vtkRenderWindowViewNode");
var but = {
  newInstance: mut,
  extend: sU
};
const fut = "__getUnderlyingContext";
function gut() {
  const i = /* @__PURE__ */ new Map(), t = {
    apply(s, r, a) {
      return i.has(a[0]) ? i.get(a[0]) : s.apply(r, a);
    }
  };
  function e(s) {
    return {
      apply(r, a, o) {
        return i.set(s, o[0]), r.apply(a, o);
      }
    };
  }
  const n = /* @__PURE__ */ Object.create(null);
  return n.getParameter = (s, r, a, o) => new Proxy(o.bind(s), t), n.depthMask = (s, r, a, o) => new Proxy(o.bind(s), e(s.DEPTH_WRITEMASK)), {
    get(s, r, a) {
      if (r === fut) return () => s;
      let o = Reflect.get(s, r, s);
      o instanceof Function && (o = o.bind(s));
      const l = n[r];
      return l ? l(s, r, a, o) : o;
    }
  };
}
const {
  vtkDebugMacro: LO,
  vtkErrorMacro: VO
} = tt, yut = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%"
};
function ba(i, t, e) {
  const n = i.createFramebuffer(), s = i.createTexture();
  i.bindTexture(i.TEXTURE_2D, s), i.texImage2D(i.TEXTURE_2D, 0, t, 2, 2, 0, t, e, null), i.bindFramebuffer(i.FRAMEBUFFER, n), i.framebufferTexture2D(i.FRAMEBUFFER, i.COLOR_ATTACHMENT0, i.TEXTURE_2D, s, 0);
  const r = i.checkFramebufferStatus(i.FRAMEBUFFER);
  return i.bindFramebuffer(i.FRAMEBUFFER, null), i.bindTexture(i.TEXTURE_2D, null), r === i.FRAMEBUFFER_COMPLETE;
}
let ZW = 0;
const AG = [];
function Zut() {
  ZW++, AG.forEach((i) => i(ZW));
}
function Tut() {
  ZW--, AG.forEach((i) => i(ZW));
}
function Mut(i) {
  AG.push(i);
}
function Nut(i) {
  return AG.pop();
}
function XO(i) {
  i.preventDefault();
}
function Wut(i, t) {
  t.classHierarchy.push("vtkOpenGLRenderWindow");
  const e = gut();
  i.getViewNodeFactory = () => t.myFactory, t.canvas.addEventListener("webglcontextlost", XO, !1), t.canvas.addEventListener("webglcontextrestored", i.restoreContext, !1);
  const n = [0, 0];
  function s() {
    t.renderable && (t.size[0] !== n[0] || t.size[1] !== n[1]) && (n[0] = t.size[0], n[1] = t.size[1], t.canvas.setAttribute("width", t.size[0]), t.canvas.setAttribute("height", t.size[1])), t.viewStream && t.viewStream.setSize(t.size[0], t.size[1]), t.canvas.style.display = t.useOffScreen ? "none" : "block", t.el && (t.el.style.cursor = t.cursorVisibility ? t.cursor : "none"), t.containerSize = null;
  }
  i.onModified(s), i.buildPass = (c) => {
    if (c) {
      if (!t.renderable)
        return;
      i.prepareNodes(), i.addMissingNodes(t.renderable.getRenderersByReference()), i.removeUnusedNodes(), i.initialize(), t.children.forEach((u) => {
        u.setOpenGLRenderWindow(i);
      });
    }
  }, i.initialize = () => {
    if (!t.initialized) {
      t.context = i.get3DContext(), t.textureUnitManager = dut.newInstance(), t.textureUnitManager.setContext(t.context), t.shaderCache.setContext(t.context);
      const c = t.context;
      c.blendFuncSeparate(c.SRC_ALPHA, c.ONE_MINUS_SRC_ALPHA, c.ONE, c.ONE_MINUS_SRC_ALPHA), c.depthFunc(c.LEQUAL), c.enable(c.BLEND), t.initialized = !0;
    }
  }, i.makeCurrent = () => {
    t.context.makeCurrent();
  }, i.setContainer = (c) => {
    t.el && t.el !== c && (t.canvas.parentNode !== t.el && VO("Error: canvas parent node does not match container"), t.el.removeChild(t.canvas), t.el.contains(t.bgImage) && t.el.removeChild(t.bgImage)), t.el !== c && (t.el = c, t.el && (t.el.appendChild(t.canvas), t.useBackgroundImage && t.el.appendChild(t.bgImage)), i.modified());
  }, i.getContainer = () => t.el, i.getContainerSize = () => {
    if (!t.containerSize && t.el) {
      const {
        width: c,
        height: u
      } = t.el.getBoundingClientRect();
      t.containerSize = [c, u];
    }
    return t.containerSize || t.size;
  }, i.getFramebufferSize = () => {
    var u;
    return ((u = t.activeFramebuffer) == null ? void 0 : u.getSize()) || t.size;
  }, i.getPixelData = (c, u, d, h) => {
    const p = new Uint8Array((d - c + 1) * (h - u + 1) * 4);
    return t.context.readPixels(c, u, d - c + 1, h - u + 1, t.context.RGBA, t.context.UNSIGNED_BYTE, p), p;
  }, i.get3DContext = function() {
    let c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
      preserveDrawingBuffer: !1,
      depth: !0,
      alpha: !0,
      powerPreference: "high-performance"
    }, u = null;
    const d = typeof WebGL2RenderingContext < "u";
    return t.webgl2 = !1, t.defaultToWebgl2 && d && (u = t.canvas.getContext("webgl2", c), u && (t.webgl2 = !0, LO("using webgl2"))), u || (LO("using webgl1"), u = t.canvas.getContext("webgl", c) || t.canvas.getContext("experimental-webgl", c)), new Proxy(u, e);
  }, i.restoreContext = () => {
    const c = PG.newInstance();
    c.setCurrentOperation("Release"), c.traverse(i, null);
  }, i.activateTexture = (c) => {
    const u = t._textureResourceIds.get(c);
    if (u !== void 0) {
      t.context.activeTexture(t.context.TEXTURE0 + u);
      return;
    }
    const d = i.getTextureUnitManager().allocate();
    if (d < 0) {
      VO("Hardware does not support the number of textures defined.");
      return;
    }
    t._textureResourceIds.set(c, d), t.context.activeTexture(t.context.TEXTURE0 + d);
  }, i.deactivateTexture = (c) => {
    const u = t._textureResourceIds.get(c);
    u !== void 0 && (i.getTextureUnitManager().free(u), t._textureResourceIds.delete(c));
  }, i.getTextureUnitForTexture = (c) => {
    const u = t._textureResourceIds.get(c);
    return u !== void 0 ? u : -1;
  }, i.getDefaultTextureByteSize = function(c) {
    let u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    if (t.webgl2)
      switch (c) {
        case Ke.CHAR:
        case Ke.SIGNED_CHAR:
        case Ke.UNSIGNED_CHAR:
          return 1;
        case u:
        case d:
        case Ke.UNSIGNED_SHORT:
        case Ke.SHORT:
        case Ke.VOID:
          return 2;
        default:
          return 4;
      }
    return 1;
  }, i.getDefaultTextureInternalFormat = function(c, u) {
    let d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
    if (t.webgl2)
      switch (c) {
        case Ke.UNSIGNED_CHAR:
          switch (u) {
            case 1:
              return t.context.R8;
            case 2:
              return t.context.RG8;
            case 3:
              return t.context.RGB8;
            case 4:
            default:
              return t.context.RGBA8;
          }
        case (d && !h && Ke.UNSIGNED_SHORT):
          switch (u) {
            case 1:
              return d.R16_EXT;
            case 2:
              return d.RG16_EXT;
            case 3:
              return d.RGB16_EXT;
            case 4:
            default:
              return d.RGBA16_EXT;
          }
        // prioritize norm16 over float
        case (d && !h && Ke.SHORT):
          switch (u) {
            case 1:
              return d.R16_SNORM_EXT;
            case 2:
              return d.RG16_SNORM_EXT;
            case 3:
              return d.RGB16_SNORM_EXT;
            case 4:
            default:
              return d.RGBA16_SNORM_EXT;
          }
        case Ke.UNSIGNED_SHORT:
        case Ke.SHORT:
        case Ke.FLOAT:
        default:
          switch (u) {
            case 1:
              return h ? t.context.R16F : t.context.R32F;
            case 2:
              return h ? t.context.RG16F : t.context.RG32F;
            case 3:
              return h ? t.context.RGB16F : t.context.RGB32F;
            case 4:
            default:
              return h ? t.context.RGBA16F : t.context.RGBA32F;
          }
      }
    switch (u) {
      case 1:
        return t.context.LUMINANCE;
      case 2:
        return t.context.LUMINANCE_ALPHA;
      case 3:
        return t.context.RGB;
      case 4:
      default:
        return t.context.RGBA;
    }
  }, i.setBackgroundImage = (c) => {
    t.bgImage.src = c.src;
  }, i.setUseBackgroundImage = (c) => {
    t.useBackgroundImage = c, t.useBackgroundImage && !t.el.contains(t.bgImage) ? t.el.appendChild(t.bgImage) : !t.useBackgroundImage && t.el.contains(t.bgImage) && t.el.removeChild(t.bgImage);
  };
  function r() {
    let c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : t.imageFormat;
    const u = document.createElement("canvas"), d = u.getContext("2d");
    u.width = t.canvas.width, u.height = t.canvas.height, d.drawImage(t.canvas, 0, 0);
    const h = t.canvas.getBoundingClientRect();
    t.renderable.getRenderers().forEach((y) => {
      y.getViewProps().forEach((g) => {
        if (g.getContainer) {
          const T = g.getContainer().getElementsByTagName("canvas");
          for (let M = 0; M < T.length; M++) {
            const N = T[M], W = N.getBoundingClientRect(), x = W.x - h.x, V = W.y - h.y;
            d.drawImage(N, x, V);
          }
        }
      });
    });
    const b = u.toDataURL(c);
    u.remove(), i.invokeImageReady(b);
  }
  i.captureNextImage = function() {
    let c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "image/png", {
      resetCamera: u = !1,
      size: d = null,
      scale: h = 1
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (t.deleted)
      return null;
    t.imageFormat = c;
    const p = t.notifyStartCaptureImage;
    return t.notifyStartCaptureImage = !0, t._screenshot = {
      size: d || h !== 1 ? d || t.size.map((m) => m * h) : null
    }, new Promise((m, b) => {
      const y = i.onImageReady((Z) => {
        if (t._screenshot.size === null)
          t.notifyStartCaptureImage = p, y.unsubscribe(), t._screenshot.placeHolder && (t.size = t._screenshot.originalSize, i.modified(), t._screenshot.cameras && t._screenshot.cameras.forEach((g) => {
            let {
              restoreParamsFn: f,
              arg: T
            } = g;
            return f(T);
          }), i.traverseAllPasses(), t.el.removeChild(t._screenshot.placeHolder), t._screenshot.placeHolder.remove(), t._screenshot = null), m(Z);
        else {
          const g = document.createElement("img");
          if (g.style = yut, g.src = Z, t._screenshot.placeHolder = t.el.appendChild(g), t.canvas.style.display = "none", t._screenshot.originalSize = t.size, t.size = t._screenshot.size, t._screenshot.size = null, i.modified(), u) {
            const f = u !== !0;
            t._screenshot.cameras = t.renderable.getRenderers().map((T) => {
              const M = T.getActiveCamera(), N = M.get("focalPoint", "position", "parallelScale");
              return {
                resetCameraArgs: f ? {
                  renderer: T
                } : void 0,
                resetCameraFn: f ? u : T.resetCamera,
                restoreParamsFn: M.set,
                // "clone" the params so we don't keep refs to properties
                arg: JSON.parse(JSON.stringify(N))
              };
            }), t._screenshot.cameras.forEach((T) => {
              let {
                resetCameraFn: M,
                resetCameraArgs: N
              } = T;
              return M(N);
            });
          }
          i.traverseAllPasses();
        }
      });
    });
  };
  let a;
  i.getHardwareMaximumLineWidth = () => {
    if (a != null)
      return a;
    const c = i.get3DContext(), u = c.getParameter(c.ALIASED_LINE_WIDTH_RANGE);
    return a = u[1], u[1];
  }, i.getGLInformations = () => {
    if (t._glInformation)
      return t._glInformation;
    const c = i.get3DContext(), u = c.getExtension("OES_texture_float"), d = c.getExtension("OES_texture_half_float"), h = c.getExtension("WEBGL_debug_renderer_info"), p = c.getExtension("WEBGL_draw_buffers"), m = c.getExtension("EXT_texture_filter_anisotropic") || c.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), b = [["Max Vertex Attributes", "MAX_VERTEX_ATTRIBS", c.getParameter(c.MAX_VERTEX_ATTRIBS)], ["Max Varying Vectors", "MAX_VARYING_VECTORS", c.getParameter(c.MAX_VARYING_VECTORS)], ["Max Vertex Uniform Vectors", "MAX_VERTEX_UNIFORM_VECTORS", c.getParameter(c.MAX_VERTEX_UNIFORM_VECTORS)], ["Max Fragment Uniform Vectors", "MAX_FRAGMENT_UNIFORM_VECTORS", c.getParameter(c.MAX_FRAGMENT_UNIFORM_VECTORS)], ["Max Fragment Texture Image Units", "MAX_TEXTURE_IMAGE_UNITS", c.getParameter(c.MAX_TEXTURE_IMAGE_UNITS)], ["Max Vertex Texture Image Units", "MAX_VERTEX_TEXTURE_IMAGE_UNITS", c.getParameter(c.MAX_VERTEX_TEXTURE_IMAGE_UNITS)], ["Max Combined Texture Image Units", "MAX_COMBINED_TEXTURE_IMAGE_UNITS", c.getParameter(c.MAX_COMBINED_TEXTURE_IMAGE_UNITS)], ["Max 2D Texture Size", "MAX_TEXTURE_SIZE", c.getParameter(c.MAX_TEXTURE_SIZE)], ["Max Cube Texture Size", "MAX_CUBE_MAP_TEXTURE_SIZE", c.getParameter(c.MAX_CUBE_MAP_TEXTURE_SIZE)], ["Max Texture Anisotropy", "MAX_TEXTURE_MAX_ANISOTROPY_EXT", m && c.getParameter(m.MAX_TEXTURE_MAX_ANISOTROPY_EXT)], ["Point Size Range", "ALIASED_POINT_SIZE_RANGE", c.getParameter(c.ALIASED_POINT_SIZE_RANGE).join(" - ")], ["Line Width Range", "ALIASED_LINE_WIDTH_RANGE", c.getParameter(c.ALIASED_LINE_WIDTH_RANGE).join(" - ")], ["Max Viewport Dimensions", "MAX_VIEWPORT_DIMS", c.getParameter(c.MAX_VIEWPORT_DIMS).join(" - ")], ["Max Renderbuffer Size", "MAX_RENDERBUFFER_SIZE", c.getParameter(c.MAX_RENDERBUFFER_SIZE)], ["Framebuffer Red Bits", "RED_BITS", c.getParameter(c.RED_BITS)], ["Framebuffer Green Bits", "GREEN_BITS", c.getParameter(c.GREEN_BITS)], ["Framebuffer Blue Bits", "BLUE_BITS", c.getParameter(c.BLUE_BITS)], ["Framebuffer Alpha Bits", "ALPHA_BITS", c.getParameter(c.ALPHA_BITS)], ["Framebuffer Depth Bits", "DEPTH_BITS", c.getParameter(c.DEPTH_BITS)], ["Framebuffer Stencil Bits", "STENCIL_BITS", c.getParameter(c.STENCIL_BITS)], ["Framebuffer Subpixel Bits", "SUBPIXEL_BITS", c.getParameter(c.SUBPIXEL_BITS)], ["MSAA Samples", "SAMPLES", c.getParameter(c.SAMPLES)], ["MSAA Sample Buffers", "SAMPLE_BUFFERS", c.getParameter(c.SAMPLE_BUFFERS)], ["Supported Formats for UByte Render Targets     ", "UNSIGNED_BYTE RENDER TARGET FORMATS", [u && ba(c, c.RGBA, c.UNSIGNED_BYTE) ? "RGBA" : "", u && ba(c, c.RGB, c.UNSIGNED_BYTE) ? "RGB" : "", u && ba(c, c.LUMINANCE, c.UNSIGNED_BYTE) ? "LUMINANCE" : "", u && ba(c, c.ALPHA, c.UNSIGNED_BYTE) ? "ALPHA" : "", u && ba(c, c.LUMINANCE_ALPHA, c.UNSIGNED_BYTE) ? "LUMINANCE_ALPHA" : ""].join(" ")], ["Supported Formats for Half Float Render Targets", "HALF FLOAT RENDER TARGET FORMATS", [d && ba(c, c.RGBA, d.HALF_FLOAT_OES) ? "RGBA" : "", d && ba(c, c.RGB, d.HALF_FLOAT_OES) ? "RGB" : "", d && ba(c, c.LUMINANCE, d.HALF_FLOAT_OES) ? "LUMINANCE" : "", d && ba(c, c.ALPHA, d.HALF_FLOAT_OES) ? "ALPHA" : "", d && ba(c, c.LUMINANCE_ALPHA, d.HALF_FLOAT_OES) ? "LUMINANCE_ALPHA" : ""].join(" ")], ["Supported Formats for Full Float Render Targets", "FLOAT RENDER TARGET FORMATS", [u && ba(c, c.RGBA, c.FLOAT) ? "RGBA" : "", u && ba(c, c.RGB, c.FLOAT) ? "RGB" : "", u && ba(c, c.LUMINANCE, c.FLOAT) ? "LUMINANCE" : "", u && ba(c, c.ALPHA, c.FLOAT) ? "ALPHA" : "", u && ba(c, c.LUMINANCE_ALPHA, c.FLOAT) ? "LUMINANCE_ALPHA" : ""].join(" ")], ["Max Multiple Render Targets Buffers", "MAX_DRAW_BUFFERS_WEBGL", p ? c.getParameter(p.MAX_DRAW_BUFFERS_WEBGL) : 0], ["High Float Precision in Vertex Shader", "HIGH_FLOAT VERTEX_SHADER", [c.getShaderPrecisionFormat(c.VERTEX_SHADER, c.HIGH_FLOAT).precision, " (-2<sup>", c.getShaderPrecisionFormat(c.VERTEX_SHADER, c.HIGH_FLOAT).rangeMin, "</sup> - 2<sup>", c.getShaderPrecisionFormat(c.VERTEX_SHADER, c.HIGH_FLOAT).rangeMax, "</sup>)"].join("")], ["Medium Float Precision in Vertex Shader", "MEDIUM_FLOAT VERTEX_SHADER", [c.getShaderPrecisionFormat(c.VERTEX_SHADER, c.MEDIUM_FLOAT).precision, " (-2<sup>", c.getShaderPrecisionFormat(c.VERTEX_SHADER, c.MEDIUM_FLOAT).rangeMin, "</sup> - 2<sup>", c.getShaderPrecisionFormat(c.VERTEX_SHADER, c.MEDIUM_FLOAT).rangeMax, "</sup>)"].join("")], ["Low Float Precision in Vertex Shader", "LOW_FLOAT VERTEX_SHADER", [c.getShaderPrecisionFormat(c.VERTEX_SHADER, c.LOW_FLOAT).precision, " (-2<sup>", c.getShaderPrecisionFormat(c.VERTEX_SHADER, c.LOW_FLOAT).rangeMin, "</sup> - 2<sup>", c.getShaderPrecisionFormat(c.VERTEX_SHADER, c.LOW_FLOAT).rangeMax, "</sup>)"].join("")], ["High Float Precision in Fragment Shader", "HIGH_FLOAT FRAGMENT_SHADER", [c.getShaderPrecisionFormat(c.FRAGMENT_SHADER, c.HIGH_FLOAT).precision, " (-2<sup>", c.getShaderPrecisionFormat(c.FRAGMENT_SHADER, c.HIGH_FLOAT).rangeMin, "</sup> - 2<sup>", c.getShaderPrecisionFormat(c.FRAGMENT_SHADER, c.HIGH_FLOAT).rangeMax, "</sup>)"].join("")], ["Medium Float Precision in Fragment Shader", "MEDIUM_FLOAT FRAGMENT_SHADER", [c.getShaderPrecisionFormat(c.FRAGMENT_SHADER, c.MEDIUM_FLOAT).precision, " (-2<sup>", c.getShaderPrecisionFormat(c.FRAGMENT_SHADER, c.MEDIUM_FLOAT).rangeMin, "</sup> - 2<sup>", c.getShaderPrecisionFormat(c.FRAGMENT_SHADER, c.MEDIUM_FLOAT).rangeMax, "</sup>)"].join("")], ["Low Float Precision in Fragment Shader", "LOW_FLOAT FRAGMENT_SHADER", [c.getShaderPrecisionFormat(c.FRAGMENT_SHADER, c.LOW_FLOAT).precision, " (-2<sup>", c.getShaderPrecisionFormat(c.FRAGMENT_SHADER, c.LOW_FLOAT).rangeMin, "</sup> - 2<sup>", c.getShaderPrecisionFormat(c.FRAGMENT_SHADER, c.LOW_FLOAT).rangeMax, "</sup>)"].join("")], ["High Int Precision in Vertex Shader", "HIGH_INT VERTEX_SHADER", [c.getShaderPrecisionFormat(c.VERTEX_SHADER, c.HIGH_INT).precision, " (-2<sup>", c.getShaderPrecisionFormat(c.VERTEX_SHADER, c.HIGH_INT).rangeMin, "</sup> - 2<sup>", c.getShaderPrecisionFormat(c.VERTEX_SHADER, c.HIGH_INT).rangeMax, "</sup>)"].join("")], ["Medium Int Precision in Vertex Shader", "MEDIUM_INT VERTEX_SHADER", [c.getShaderPrecisionFormat(c.VERTEX_SHADER, c.MEDIUM_INT).precision, " (-2<sup>", c.getShaderPrecisionFormat(c.VERTEX_SHADER, c.MEDIUM_INT).rangeMin, "</sup> - 2<sup>", c.getShaderPrecisionFormat(c.VERTEX_SHADER, c.MEDIUM_INT).rangeMax, "</sup>)"].join("")], ["Low Int Precision in Vertex Shader", "LOW_INT VERTEX_SHADER", [c.getShaderPrecisionFormat(c.VERTEX_SHADER, c.LOW_INT).precision, " (-2<sup>", c.getShaderPrecisionFormat(c.VERTEX_SHADER, c.LOW_INT).rangeMin, "</sup> - 2<sup>", c.getShaderPrecisionFormat(c.VERTEX_SHADER, c.LOW_INT).rangeMax, "</sup>)"].join("")], ["High Int Precision in Fragment Shader", "HIGH_INT FRAGMENT_SHADER", [c.getShaderPrecisionFormat(c.FRAGMENT_SHADER, c.HIGH_INT).precision, " (-2<sup>", c.getShaderPrecisionFormat(c.FRAGMENT_SHADER, c.HIGH_INT).rangeMin, "</sup> - 2<sup>", c.getShaderPrecisionFormat(c.FRAGMENT_SHADER, c.HIGH_INT).rangeMax, "</sup>)"].join("")], ["Medium Int Precision in Fragment Shader", "MEDIUM_INT FRAGMENT_SHADER", [c.getShaderPrecisionFormat(c.FRAGMENT_SHADER, c.MEDIUM_INT).precision, " (-2<sup>", c.getShaderPrecisionFormat(c.FRAGMENT_SHADER, c.MEDIUM_INT).rangeMin, "</sup> - 2<sup>", c.getShaderPrecisionFormat(c.FRAGMENT_SHADER, c.MEDIUM_INT).rangeMax, "</sup>)"].join("")], ["Low Int Precision in Fragment Shader", "LOW_INT FRAGMENT_SHADER", [c.getShaderPrecisionFormat(c.FRAGMENT_SHADER, c.LOW_INT).precision, " (-2<sup>", c.getShaderPrecisionFormat(c.FRAGMENT_SHADER, c.LOW_INT).rangeMin, "</sup> - 2<sup>", c.getShaderPrecisionFormat(c.FRAGMENT_SHADER, c.LOW_INT).rangeMax, "</sup>)"].join("")], ["Supported Extensions", "EXTENSIONS", c.getSupportedExtensions().join("<br/>					    ")], ["WebGL Renderer", "RENDERER", c.getParameter(c.RENDERER)], ["WebGL Vendor", "VENDOR", c.getParameter(c.VENDOR)], ["WebGL Version", "VERSION", c.getParameter(c.VERSION)], ["Shading Language Version", "SHADING_LANGUAGE_VERSION", c.getParameter(c.SHADING_LANGUAGE_VERSION)], ["Unmasked Renderer", "UNMASKED_RENDERER", h && c.getParameter(h.UNMASKED_RENDERER_WEBGL)], ["Unmasked Vendor", "UNMASKED_VENDOR", h && c.getParameter(h.UNMASKED_VENDOR_WEBGL)], ["WebGL Version", "WEBGL_VERSION", t.webgl2 ? 2 : 1]], y = {};
    for (; b.length; ) {
      const [Z, g, f] = b.pop();
      g && (y[g] = {
        label: Z,
        value: f
      });
    }
    return t._glInformation = y, y;
  }, i.traverseAllPasses = () => {
    if (t.renderPasses)
      for (let c = 0; c < t.renderPasses.length; ++c)
        t.renderPasses[c].traverse(i, null);
    t.notifyStartCaptureImage && r();
  }, i.disableCullFace = () => {
    t.cullFaceEnabled && (t.context.disable(t.context.CULL_FACE), t.cullFaceEnabled = !1);
  }, i.enableCullFace = () => {
    t.cullFaceEnabled || (t.context.enable(t.context.CULL_FACE), t.cullFaceEnabled = !0);
  }, i.setViewStream = (c) => {
    if (t.viewStream === c)
      return !1;
    if (t.subscription && (t.subscription.unsubscribe(), t.subscription = null), t.viewStream = c, t.viewStream) {
      const u = t.renderable.getRenderers()[0];
      u.getBackgroundByReference()[3] = 0, i.setUseBackgroundImage(!0), t.subscription = t.viewStream.onImageReady((d) => i.setBackgroundImage(d.image)), t.viewStream.setSize(t.size[0], t.size[1]), t.viewStream.invalidateCache(), t.viewStream.render(), i.modified();
    }
    return !0;
  }, i.createSelector = () => {
    const c = JG.newInstance();
    return c.setOpenGLRenderWindow(i), c;
  };
  function o() {
    t.canvas.removeEventListener("webglcontextlost", XO), t.canvas.removeEventListener("webglcontextrestored", i.restoreContext);
  }
  i.delete = tt.chain(o, i.delete, i.setViewStream, Tut), i.setActiveFramebuffer = (c) => {
    t.activeFramebuffer = c;
  };
  const l = i.setSize;
  i.setSize = (c, u) => {
    const d = l(c, u);
    return d && i.invokeWindowResizeEvent({
      width: c,
      height: u
    }), d;
  }, i.getGraphicsResourceForObject = (c) => {
    if (!c)
      return null;
    const u = t._graphicsResources.get(c), d = t._graphicsResourceHash.get(c);
    return {
      vtkObj: u,
      hash: d
    };
  }, i.setGraphicsResourceForObject = (c, u, d) => {
    c && (t._graphicsResources.set(c, u), t._graphicsResourceHash.set(c, d));
  }, i.getGraphicsMemoryInfo = () => {
    let c = 0;
    return t._graphicsResources.forEach((u, d) => {
      c += u.getAllocatedGPUMemoryInBytes();
    }), c;
  }, i.releaseGraphicsResourcesForObject = (c) => {
    var u;
    return c ? ((u = t._graphicsResources.get(c)) == null || u.releaseGraphicsResources(i), t._graphicsResources.delete(c) && t._graphicsResourceHash.delete(c)) : !1;
  }, i.releaseGraphicsResources = () => {
    t.shaderCache !== null && t.shaderCache.releaseGraphicsResources(i), t._graphicsResources.forEach((c, u) => {
      c.releaseGraphicsResources(i);
    }), t._graphicsResources.clear(), t._graphicsResourceHash.clear(), t.textureUnitManager !== null && t.textureUnitManager.freeAll(), t.renderable.getRenderersByReference().forEach((c) => {
      const u = i.getViewNodeFor(c);
      u == null || u.releaseGraphicsResources();
    });
  };
}
const Gut = {
  cullFaceEnabled: !1,
  shaderCache: null,
  initialized: !1,
  context: null,
  canvas: null,
  cursorVisibility: !0,
  cursor: "pointer",
  textureUnitManager: null,
  textureResourceIds: null,
  containerSize: null,
  renderPasses: [],
  notifyStartCaptureImage: !1,
  webgl2: !1,
  defaultToWebgl2: !0,
  // attempt webgl2 on by default
  activeFramebuffer: null,
  imageFormat: "image/png",
  useOffScreen: !1,
  useBackgroundImage: !1
};
function rU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Gut, e), but.extend(i, t, e), t.canvas = document.createElement("canvas"), t.canvas.style.width = "100%", Zut(), t.selector || (t.selector = JG.newInstance(), t.selector.setOpenGLRenderWindow(i)), t.bgImage = new Image(), t.bgImage.style.position = "absolute", t.bgImage.style.left = "0", t.bgImage.style.top = "0", t.bgImage.style.width = "100%", t.bgImage.style.height = "100%", t.bgImage.style.zIndex = "-1", t._textureResourceIds = /* @__PURE__ */ new Map(), t._graphicsResources = /* @__PURE__ */ new Map(), t._graphicsResourceHash = /* @__PURE__ */ new Map(), t._glInformation = null, t.myFactory = jet.newInstance(), t.myFactory.registerOverride("vtkRenderWindow", AI), t.shaderCache = aut.newInstance(), t.shaderCache.setOpenGLRenderWindow(i), t.renderPasses[0] = zct.newInstance(), tt.event(i, t, "imageReady"), tt.get(i, t, ["shaderCache", "textureUnitManager", "webgl2", "useBackgroundImage", "activeFramebuffer"]), tt.setGet(i, t, ["initialized", "context", "canvas", "renderPasses", "notifyStartCaptureImage", "defaultToWebgl2", "cursor", "useOffScreen"]), tt.setGetArray(i, t, ["size"], 2), tt.event(i, t, "windowResizeEvent"), Wut(i, t);
}
const AI = tt.newInstance(rU, "vtkOpenGLRenderWindow");
Ej("WebGL", AI);
var vT = {
  newInstance: AI,
  extend: rU,
  pushMonitorGLContextCount: Mut,
  popMonitorGLContextCount: Nut
};
const {
  InterpolationType: Ny,
  OpacityMode: wut
} = Oj, {
  vtkErrorMacro: Jx
} = tt, lN = 4;
function xut(i, t) {
  t.classHierarchy.push("vtkVolumeProperty"), i.getMTime = () => {
    let s = t.mtime, r;
    for (let a = 0; a < lN; a++)
      t.componentData[a].colorChannels === 1 ? t.componentData[a].grayTransferFunction && (r = t.componentData[a].grayTransferFunction.getMTime(), s = s > r ? s : r) : t.componentData[a].colorChannels === 3 && t.componentData[a].rGBTransferFunction && (r = t.componentData[a].rGBTransferFunction.getMTime(), s = s > r ? s : r), t.componentData[a].scalarOpacity && (r = t.componentData[a].scalarOpacity.getMTime(), s = s > r ? s : r), t.componentData[a].gradientOpacity && (t.componentData[a].disableGradientOpacity || (r = t.componentData[a].gradientOpacity.getMTime(), s = s > r ? s : r));
    return s;
  }, i.getColorChannels = (s) => s < 0 || s > 3 ? (Jx("Bad index - must be between 0 and 3"), 0) : t.componentData[s].colorChannels, i.setGrayTransferFunction = function() {
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, a = !1;
    return t.componentData[s].grayTransferFunction !== r && (t.componentData[s].grayTransferFunction = r, a = !0), t.componentData[s].colorChannels !== 1 && (t.componentData[s].colorChannels = 1, a = !0), a && i.modified(), a;
  }, i.getGrayTransferFunction = function() {
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t.componentData[s].grayTransferFunction === null && (t.componentData[s].grayTransferFunction = Bh.newInstance(), t.componentData[s].grayTransferFunction.addPoint(0, 0), t.componentData[s].grayTransferFunction.addPoint(1024, 1), t.componentData[s].colorChannels !== 1 && (t.componentData[s].colorChannels = 1), i.modified()), t.componentData[s].grayTransferFunction;
  }, i.setRGBTransferFunction = function() {
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, a = !1;
    return t.componentData[s].rGBTransferFunction !== r && (t.componentData[s].rGBTransferFunction = r, a = !0), t.componentData[s].colorChannels !== 3 && (t.componentData[s].colorChannels = 3, a = !0), a && i.modified(), a;
  }, i.getRGBTransferFunction = function() {
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t.componentData[s].rGBTransferFunction === null && (t.componentData[s].rGBTransferFunction = L0.newInstance(), t.componentData[s].rGBTransferFunction.addRGBPoint(0, 0, 0, 0), t.componentData[s].rGBTransferFunction.addRGBPoint(1024, 1, 1, 1), t.componentData[s].colorChannels !== 3 && (t.componentData[s].colorChannels = 3), i.modified()), t.componentData[s].rGBTransferFunction;
  }, i.setScalarOpacity = function() {
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return t.componentData[s].scalarOpacity !== r ? (t.componentData[s].scalarOpacity = r, i.modified(), !0) : !1;
  }, i.getScalarOpacity = function() {
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t.componentData[s].scalarOpacity === null && (t.componentData[s].scalarOpacity = Bh.newInstance(), t.componentData[s].scalarOpacity.addPoint(0, 1), t.componentData[s].scalarOpacity.addPoint(1024, 1), i.modified()), t.componentData[s].scalarOpacity;
  }, i.setComponentWeight = function() {
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (s < 0 || s >= lN)
      return Jx("Invalid index"), !1;
    const a = Math.min(1, Math.max(0, r));
    return t.componentData[s].componentWeight !== a ? (t.componentData[s].componentWeight = a, i.modified(), !0) : !1;
  }, i.getComponentWeight = function() {
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return s < 0 || s >= lN ? (Jx("Invalid index"), 0) : t.componentData[s].componentWeight;
  }, i.setInterpolationTypeToNearest = () => i.setInterpolationType(Ny.NEAREST), i.setInterpolationTypeToLinear = () => i.setInterpolationType(Ny.LINEAR), i.setInterpolationTypeToFastLinear = () => i.setInterpolationType(Ny.FAST_LINEAR), i.getInterpolationTypeAsString = () => tt.enumToString(Ny, t.interpolationType), ["useGradientOpacity", "scalarOpacityUnitDistance", "gradientOpacityMinimumValue", "gradientOpacityMinimumOpacity", "gradientOpacityMaximumValue", "gradientOpacityMaximumOpacity", "opacityMode", "forceNearestInterpolation"].forEach((s) => {
    const r = tt.capitalize(s);
    i[`set${r}`] = (a, o) => t.componentData[a][`${s}`] !== o ? (t.componentData[a][`${s}`] = o, i.modified(), !0) : !1;
  }), ["useGradientOpacity", "scalarOpacityUnitDistance", "gradientOpacityMinimumValue", "gradientOpacityMinimumOpacity", "gradientOpacityMaximumValue", "gradientOpacityMaximumOpacity", "opacityMode", "forceNearestInterpolation"].forEach((s) => {
    const r = tt.capitalize(s);
    i[`get${r}`] = (a) => t.componentData[a][`${s}`];
  });
}
const Sut = {
  colorMixPreset: null,
  independentComponents: !0,
  interpolationType: Ny.FAST_LINEAR,
  shade: !1,
  ambient: 0.1,
  diffuse: 0.7,
  specular: 0.2,
  specularPower: 10,
  useLabelOutline: !1,
  labelOutlineThickness: [1],
  labelOutlineOpacity: 1
};
function Lut(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (Object.assign(t, Sut, e), tt.obj(i, t), !t.componentData) {
    t.componentData = [];
    for (let n = 0; n < lN; ++n)
      t.componentData.push({
        colorChannels: 1,
        grayTransferFunction: null,
        rGBTransferFunction: null,
        scalarOpacity: null,
        scalarOpacityUnitDistance: 1,
        opacityMode: wut.FRACTIONAL,
        gradientOpacityMinimumValue: 0,
        gradientOpacityMinimumOpacity: 0,
        gradientOpacityMaximumValue: 1,
        gradientOpacityMaximumOpacity: 1,
        useGradientOpacity: !1,
        componentWeight: 1,
        forceNearestInterpolation: !1
      });
  }
  tt.setGet(i, t, ["colorMixPreset", "independentComponents", "interpolationType", "shade", "ambient", "diffuse", "specular", "specularPower", "useLabelOutline", "labelOutlineOpacity"]), tt.setGetArray(i, t, ["labelOutlineThickness"]), xut(i, t);
}
const Vut = tt.newInstance(Lut, "vtkVolumeProperty");
var Xut = {
  newInstance: Vut,
  ...Oj
};
const {
  vtkDebugMacro: Iut
} = tt;
function Cut(i, t) {
  t.classHierarchy.push("vtkVolume"), i.getVolumes = () => i, i.makeProperty = Xut.newInstance, i.getProperty = () => (t.property === null && (t.property = i.makeProperty()), t.property), i.getBounds = () => {
    if (t.mapper === null)
      return t.bounds;
    const e = t.mapper.getBounds();
    if (!e || e.length !== 6)
      return e;
    if (e[0] > e[1])
      return t.mapperBounds = e.concat(), t.bounds = [1, -1, 1, -1, 1, -1], t.boundsMTime.modified(), e;
    const n = (s) => s[0].map((r, a) => s.map((o) => o[a]));
    if (!t.mapperBounds || !n([e, t.mapperBounds]).reduce((s, r) => s && r[0] === r[1], !0) || i.getMTime() > t.boundsMTime.getMTime()) {
      Iut("Recomputing bounds..."), t.mapperBounds = e.map((a) => a);
      const s = [];
      qe.getCorners(e, s), i.computeMatrix();
      const r = new Float64Array(16);
      ut.transpose(r, t.matrix), s.forEach((a) => I.transformMat4(a, a, r)), t.bounds[0] = t.bounds[2] = t.bounds[4] = Number.MAX_VALUE, t.bounds[1] = t.bounds[3] = t.bounds[5] = -Number.MAX_VALUE, t.bounds = t.bounds.map((a, o) => o % 2 === 0 ? s.reduce((l, c) => l > c[o / 2] ? c[o / 2] : l, a) : s.reduce((l, c) => l < c[(o - 1) / 2] ? c[(o - 1) / 2] : l, a)), t.boundsMTime.modified();
    }
    return t.bounds;
  }, i.getMTime = () => {
    let e = t.mtime;
    if (t.property !== null) {
      const n = t.property.getMTime();
      e = n > e ? n : e;
    }
    return e;
  }, i.getRedrawMTime = () => {
    let e = t.mtime;
    if (t.mapper !== null) {
      let n = t.mapper.getMTime();
      e = n > e ? n : e, t.mapper.getInput() !== null && (t.mapper.getInputAlgorithm().update(), n = t.mapper.getInput().getMTime(), e = n > e ? n : e);
    }
    return e;
  };
}
const Yut = {
  mapper: null,
  property: null,
  bounds: [1, -1, 1, -1, 1, -1]
};
function aU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Yut, e), RI.extend(i, t, e), t.boundsMTime = {}, tt.obj(t.boundsMTime), tt.set(i, t, ["property"]), tt.setGet(i, t, ["mapper"]), tt.getArray(i, t, ["bounds"], 6), Cut(i, t);
}
const vut = tt.newInstance(aU, "vtkVolume");
var BI = {
  newInstance: vut,
  extend: aU
};
const {
  BlendMode: Rd,
  FilterMode: Wy
} = jlt;
function Rut(i, t, e, n, s) {
  let r = null;
  return s ? (r = s, r.removeAllPoints()) : r = Bh.newInstance(), r.addPointLong(-1024, 0, 1, 1), r.addPoint(i, t), r.addPoint(e, n), r;
}
const Dut = {
  createRadonTransferFunction: Rut
};
function Out(i, t) {
  t.classHierarchy.push("vtkVolumeMapper");
  const e = {
    ...i
  };
  i.getBounds = () => {
    const n = i.getInputData();
    return n ? (t.static || i.update(), t.bounds = n.getBounds()) : t.bounds = ad(), t.bounds;
  }, i.update = () => {
    i.getInputData();
  }, i.setBlendModeToComposite = () => {
    i.setBlendMode(Rd.COMPOSITE_BLEND);
  }, i.setBlendModeToMaximumIntensity = () => {
    i.setBlendMode(Rd.MAXIMUM_INTENSITY_BLEND);
  }, i.setBlendModeToMinimumIntensity = () => {
    i.setBlendMode(Rd.MINIMUM_INTENSITY_BLEND);
  }, i.setBlendModeToAverageIntensity = () => {
    i.setBlendMode(Rd.AVERAGE_INTENSITY_BLEND);
  }, i.setBlendModeToAdditiveIntensity = () => {
    i.setBlendMode(Rd.ADDITIVE_INTENSITY_BLEND);
  }, i.setBlendModeToRadonTransform = () => {
    i.setBlendMode(Rd.RADON_TRANSFORM_BLEND);
  }, i.getBlendModeAsString = () => tt.enumToString(Rd, t.blendMode), i.setAverageIPScalarRange = (n, s) => {
    console.warn("setAverageIPScalarRange is deprecated use setIpScalarRange"), i.setIpScalarRange(n, s);
  }, i.getFilterModeAsString = () => tt.enumToString(Wy, t.filterMode), i.setFilterModeToOff = () => {
    i.setFilterMode(Wy.OFF);
  }, i.setFilterModeToNormalized = () => {
    i.setFilterMode(Wy.NORMALIZED);
  }, i.setFilterModeToRaw = () => {
    i.setFilterMode(Wy.RAW);
  }, i.setGlobalIlluminationReach = (n) => e.setGlobalIlluminationReach(Ol(n, 0, 1)), i.setVolumetricScatteringBlending = (n) => e.setVolumetricScatteringBlending(Ol(n, 0, 1)), i.setVolumeShadowSamplingDistFactor = (n) => e.setVolumeShadowSamplingDistFactor(n >= 1 ? n : 1), i.setAnisotropy = (n) => e.setAnisotropy(Ol(n, -0.99, 0.99)), i.setLAOKernelSize = (n) => e.setLAOKernelSize(d2(Ol(n, 1, 32))), i.setLAOKernelRadius = (n) => e.setLAOKernelRadius(n >= 1 ? n : 1);
}
const zut = {
  bounds: [1, -1, 1, -1, 1, -1],
  sampleDistance: 1,
  imageSampleDistance: 1,
  maximumSamplesPerRay: 1e3,
  autoAdjustSampleDistances: !0,
  initialInteractionScale: 1,
  interactionSampleDistanceFactor: 1,
  blendMode: Rd.COMPOSITE_BLEND,
  ipScalarRange: [-1e6, 1e6],
  filterMode: Wy.OFF,
  // ignored by WebGL so no behavior change
  preferSizeOverAccuracy: !1,
  // Whether to use halfFloat representation of float, when it is inaccurate
  computeNormalFromOpacity: !1,
  // volume shadow parameters
  volumetricScatteringBlending: 0,
  globalIlluminationReach: 0,
  volumeShadowSamplingDistFactor: 5,
  anisotropy: 0,
  // local ambient occlusion
  localAmbientOcclusion: !1,
  LAOKernelSize: 15,
  LAOKernelRadius: 7
};
function oU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, zut, e), DI.extend(i, t, e), tt.setGet(i, t, ["sampleDistance", "imageSampleDistance", "maximumSamplesPerRay", "autoAdjustSampleDistances", "initialInteractionScale", "interactionSampleDistanceFactor", "blendMode", "filterMode", "preferSizeOverAccuracy", "computeNormalFromOpacity", "volumetricScatteringBlending", "globalIlluminationReach", "volumeShadowSamplingDistFactor", "anisotropy", "localAmbientOcclusion", "LAOKernelSize", "LAOKernelRadius"]), tt.setGetArray(i, t, ["ipScalarRange"], 2), tt.event(i, t, "lightingActivated"), Out(i, t);
}
const Eut = tt.newInstance(oU, "vtkVolumeMapper");
var KI = {
  newInstance: Eut,
  extend: oU,
  ...Dut
};
const gL = {
  Unknown: 0,
  LeftController: 1,
  RightController: 2
}, Gy = {
  Unknown: 0,
  Trigger: 1,
  TrackPad: 2,
  Grip: 3,
  Thumbstick: 4,
  A: 5,
  B: 6,
  ApplicationMenu: 7
  // Not exposed in WebXR API
}, kut = {
  Unknown: 0,
  TouchpadX: 1,
  TouchpadY: 2,
  ThumbstickX: 3,
  ThumbstickY: 4
};
var lU = {
  Device: gL,
  Input: Gy,
  Axis: kut
};
const {
  Device: uM,
  Input: xp
} = lU, {
  vtkWarningMacro: dM,
  vtkErrorMacro: hM,
  normalizeWheel: Fut,
  vtkOnceErrorMacro: jut
} = tt, q0 = {
  ctrlKey: !1,
  altKey: !1,
  shiftKey: !1
}, Ax = {
  "xr-standard": [xp.Trigger, xp.Grip, xp.TrackPad, xp.Thumbstick, xp.A, xp.B]
}, HI = ["StartAnimation", "Animation", "EndAnimation", "PointerEnter", "PointerLeave", "MouseEnter", "MouseLeave", "StartMouseMove", "MouseMove", "EndMouseMove", "LeftButtonPress", "LeftButtonRelease", "MiddleButtonPress", "MiddleButtonRelease", "RightButtonPress", "RightButtonRelease", "KeyPress", "KeyDown", "KeyUp", "StartMouseWheel", "MouseWheel", "EndMouseWheel", "StartPinch", "Pinch", "EndPinch", "StartPan", "Pan", "EndPan", "StartRotate", "Rotate", "EndRotate", "Button3D", "Move3D", "StartPointerLock", "EndPointerLock", "StartInteraction", "Interaction", "EndInteraction", "AnimationFrameRateUpdate"];
function ny(i) {
  i.cancelable && i.preventDefault();
}
function pM(i) {
  const t = /* @__PURE__ */ Object.create(null);
  return i.forEach((e) => {
    let {
      pointerId: n,
      position: s
    } = e;
    t[n] = s;
  }), t;
}
function Uut(i, t) {
  t.classHierarchy.push("vtkRenderWindowInteractor");
  const e = {
    ...i
  }, n = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Map();
  let r = 1;
  i.start = () => {
    !t.initialized && (i.initialize(), !t.initialized) || i.startEventLoop();
  }, i.setRenderWindow = (b) => {
    hM("you want to call setView(view) instead of setRenderWindow on a vtk.js interactor");
  }, i.setInteractorStyle = (b) => {
    t.interactorStyle !== b && (t.interactorStyle != null && t.interactorStyle.setInteractor(null), t.interactorStyle = b, t.interactorStyle != null && t.interactorStyle.getInteractor() !== i && t.interactorStyle.setInteractor(i));
  }, i.initialize = () => {
    t.initialized = !0, i.enable(), i.render();
  }, i.enable = () => i.setEnabled(!0), i.disable = () => i.setEnabled(!1), i.startEventLoop = () => dM("empty event loop");
  function a(b, y) {
    t._forcedRenderer || (t.currentRenderer = i.findPokedRenderer(b, y));
  }
  i.getCurrentRenderer = () => (t.currentRenderer || a(0, 0), t.currentRenderer);
  function o(b) {
    const y = t._view.getCanvas(), Z = y.getBoundingClientRect(), g = y.width / Z.width, f = y.height / Z.height, T = {
      x: g * (b.clientX - Z.left),
      y: f * (Z.height - b.clientY + Z.top),
      z: 0
    };
    return (s.size <= 1 || !t.currentRenderer) && a(T.x, T.y), T;
  }
  const l = t._getScreenEventPositionFor || o;
  function c(b) {
    return {
      controlKey: b.ctrlKey,
      altKey: b.altKey,
      shiftKey: b.shiftKey
    };
  }
  function u(b) {
    const y = c(b);
    return {
      key: b.key,
      keyCode: b.charCode,
      ...y
    };
  }
  function d(b) {
    return b.pointerType || "";
  }
  const h = () => {
    if (t.container === null)
      return;
    const {
      container: b
    } = t;
    b.addEventListener("contextmenu", ny), b.addEventListener("wheel", i.handleWheel), b.addEventListener("DOMMouseScroll", i.handleWheel), b.addEventListener("pointerenter", i.handlePointerEnter), b.addEventListener("pointerleave", i.handlePointerLeave), b.addEventListener("pointermove", i.handlePointerMove, {
      passive: !1
    }), b.addEventListener("mousedown", i.handleMouseDown, {
      passive: !1
    }), b.addEventListener("pointerdown", i.handlePointerDown, {
      passive: !1
    }), b.addEventListener("pointerup", i.handlePointerUp), b.addEventListener("mouseup", i.handleMouseUp), b.addEventListener("pointercancel", i.handlePointerCancel), document.addEventListener("keypress", i.handleKeyPress), document.addEventListener("keydown", i.handleKeyDown), document.addEventListener("keyup", i.handleKeyUp), document.addEventListener("pointerlockchange", i.handlePointerLockChange), b.style.touchAction = "none", b.style.userSelect = "none", b.style.webkitTapHighlightColor = "rgba(0,0,0,0)";
  };
  i.bindEvents = (b) => {
    if (b === null)
      return;
    e.setContainer(b) && h();
  };
  const p = () => {
    clearTimeout(t.moveTimeoutID), clearTimeout(t.wheelTimeoutID), t.moveTimeoutID = 0, t.wheelTimeoutID = 0, r = 1;
    const {
      container: b
    } = t;
    b && (b.removeEventListener("contextmenu", ny), b.removeEventListener("wheel", i.handleWheel), b.removeEventListener("DOMMouseScroll", i.handleWheel), b.removeEventListener("pointerenter", i.handlePointerEnter), b.removeEventListener("pointerleave", i.handlePointerLeave), b.removeEventListener("pointermove", i.handlePointerMove, {
      passive: !1
    }), b.removeEventListener("pointerdown", i.handlePointerDown, {
      passive: !1
    }), b.removeEventListener("mousedown", i.handleMouseDown, {
      passive: !1
    }), b.removeEventListener("pointerup", i.handlePointerUp), b.removeEventListener("mouseup", i.handleMouseUp), b.removeEventListener("pointercancel", i.handlePointerCancel)), document.removeEventListener("keypress", i.handleKeyPress), document.removeEventListener("keydown", i.handleKeyDown), document.removeEventListener("keyup", i.handleKeyUp), document.removeEventListener("pointerlockchange", i.handlePointerLockChange), s.clear();
  };
  i.unbindEvents = () => {
    p(), e.setContainer(null);
  }, i.handleKeyPress = (b) => {
    const y = u(b);
    i.keyPressEvent(y);
  }, i.handleKeyDown = (b) => {
    const y = u(b);
    i.keyDownEvent(y);
  }, i.handleKeyUp = (b) => {
    const y = u(b);
    i.keyUpEvent(y);
  }, i.handlePointerEnter = (b) => {
    const y = {
      ...c(b),
      position: l(b),
      deviceType: d(b)
    };
    i.pointerEnterEvent(y), y.deviceType === "mouse" && i.mouseEnterEvent(y);
  }, i.handlePointerLeave = (b) => {
    const y = {
      ...c(b),
      position: l(b),
      deviceType: d(b)
    };
    i.pointerLeaveEvent(y), y.deviceType === "mouse" && i.mouseLeaveEvent(y);
  }, i.handlePointerDown = (b) => {
    if (!(b.button > 2 || i.isPointerLocked()))
      switch (t.preventDefaultOnPointerDown && ny(b), b.target.hasPointerCapture(b.pointerId) && b.target.releasePointerCapture(b.pointerId), t.container.setPointerCapture(b.pointerId), s.has(b.pointerId) && dM("[RenderWindowInteractor] duplicate pointerId detected"), s.set(b.pointerId, {
        pointerId: b.pointerId,
        position: l(b)
      }), b.pointerType) {
        case "pen":
        case "touch":
          i.handleTouchStart(b);
          break;
      }
  }, i.handlePointerUp = (b) => {
    if (s.has(b.pointerId))
      switch (t.preventDefaultOnPointerUp && ny(b), s.delete(b.pointerId), t.container.releasePointerCapture(b.pointerId), b.pointerType) {
        case "pen":
        case "touch":
          i.handleTouchEnd(b);
          break;
      }
  }, i.handlePointerCancel = (b) => {
    if (s.has(b.pointerId))
      switch (s.delete(b.pointerId), b.pointerType) {
        case "pen":
        case "touch":
          i.handleTouchEnd(b);
          break;
        case "mouse":
        default:
          i.handleMouseUp(b);
          break;
      }
  }, i.handlePointerMove = (b) => {
    if (s.has(b.pointerId)) {
      const y = s.get(b.pointerId);
      y.position = l(b);
    }
    switch (b.pointerType) {
      case "pen":
      case "touch":
        i.handleTouchMove(b);
        break;
      case "mouse":
      default:
        i.handleMouseMove(b);
        break;
    }
  }, i.handleMouseDown = (b) => {
    const y = {
      ...c(b),
      position: l(b),
      deviceType: d(b)
    };
    switch (b.button) {
      case 0:
        i.leftButtonPressEvent(y);
        break;
      case 1:
        i.middleButtonPressEvent(y);
        break;
      case 2:
        i.rightButtonPressEvent(y);
        break;
      default:
        hM(`Unknown mouse button pressed: ${b.button}`);
        break;
    }
  }, i.requestPointerLock = () => {
    t.container && t.container.requestPointerLock();
  }, i.exitPointerLock = () => {
    var b;
    return (b = document.exitPointerLock) == null ? void 0 : b.call(document);
  }, i.isPointerLocked = () => !!t.container && document.pointerLockElement === t.container, i.handlePointerLockChange = () => {
    i.isPointerLocked() ? i.startPointerLockEvent() : i.endPointerLockEvent();
  };
  function m() {
    t._view && t.enabled && t.enableRender && (t.inRender = !0, t._view.traverseAllPasses(), t.inRender = !1), i.invokeRenderEvent();
  }
  i.requestAnimation = (b) => {
    if (b === void 0) {
      hM("undefined requester, can not start animating");
      return;
    }
    if (n.has(b)) {
      dM("requester is already registered for animating");
      return;
    }
    n.add(b), !t.animationRequest && n.size === 1 && !t.xrAnimation && (t._animationStartTime = Date.now(), t._animationFrameCount = 0, t.animationRequest = requestAnimationFrame(i.handleAnimation), i.startAnimationEvent());
  }, i.extendAnimation = (b) => {
    const y = Date.now() + b;
    t._animationExtendedEnd = Math.max(t._animationExtendedEnd, y), !t.animationRequest && n.size === 0 && !t.xrAnimation && (t._animationStartTime = Date.now(), t._animationFrameCount = 0, t.animationRequest = requestAnimationFrame(i.handleAnimation), i.startAnimationEvent());
  }, i.isAnimating = () => t.xrAnimation || t.animationRequest !== null, i.cancelAnimation = function(b) {
    let y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (!n.has(b)) {
      if (!y) {
        const Z = b && b.getClassName ? b.getClassName() : b;
        dM(`${Z} did not request an animation`);
      }
      return;
    }
    n.delete(b), t.animationRequest && n.size === 0 && Date.now() > t._animationExtendedEnd && (cancelAnimationFrame(t.animationRequest), t.animationRequest = null, i.endAnimationEvent(), i.render());
  }, i.switchToXRAnimation = () => {
    t.animationRequest && (cancelAnimationFrame(t.animationRequest), t.animationRequest = null), t.xrAnimation = !0;
  }, i.returnFromXRAnimation = () => {
    t.xrAnimation = !1, n.size !== 0 && (t.recentAnimationFrameRate = 10, t.animationRequest = requestAnimationFrame(i.handleAnimation));
  }, i.updateXRGamepads = (b, y, Z) => {
    b.inputSources.forEach((g) => {
      const f = g.gripSpace == null ? null : y.getPose(g.gripSpace, Z), T = g.gripSpace == null ? null : y.getPose(g.targetRaySpace, Z), M = g.gamepad, N = g.handedness;
      if (M) {
        M.index in t.lastGamepadValues || (t.lastGamepadValues[M.index] = {
          left: {
            buttons: {}
          },
          right: {
            buttons: {}
          },
          none: {
            buttons: {}
          }
        });
        for (let W = 0; W < M.buttons.length; ++W)
          W in t.lastGamepadValues[M.index][N].buttons || (t.lastGamepadValues[M.index][N].buttons[W] = !1), t.lastGamepadValues[M.index][N].buttons[W] !== M.buttons[W].pressed && f != null && (i.button3DEvent({
            gamepad: M,
            position: f.transform.position,
            orientation: f.transform.orientation,
            targetPosition: T.transform.position,
            targetOrientation: T.transform.orientation,
            pressed: M.buttons[W].pressed,
            device: g.handedness === "left" ? uM.LeftController : uM.RightController,
            input: Ax[M.mapping] && Ax[M.mapping][W] ? Ax[M.mapping][W] : xp.Trigger
          }), t.lastGamepadValues[M.index][N].buttons[W] = M.buttons[W].pressed), t.lastGamepadValues[M.index][N].buttons[W] && f != null && i.move3DEvent({
            gamepad: M,
            position: f.transform.position,
            orientation: f.transform.orientation,
            targetPosition: T.transform.position,
            targetOrientation: T.transform.orientation,
            device: g.handedness === "left" ? uM.LeftController : uM.RightController
          });
      }
    });
  }, i.handleMouseMove = (b) => {
    const y = {
      ...c(b),
      position: l(b),
      deviceType: d(b)
    };
    t.moveTimeoutID === 0 ? i.startMouseMoveEvent(y) : (i.mouseMoveEvent(y), clearTimeout(t.moveTimeoutID)), t.moveTimeoutID = setTimeout(() => {
      i.endMouseMoveEvent(), t.moveTimeoutID = 0;
    }, 200);
  }, i.handleAnimation = () => {
    const b = Date.now();
    t._animationFrameCount++, b - t._animationStartTime > 1e3 && t._animationFrameCount > 1 && (t.recentAnimationFrameRate = 1e3 * (t._animationFrameCount - 1) / (b - t._animationStartTime), t.lastFrameTime = 1 / t.recentAnimationFrameRate, i.animationFrameRateUpdateEvent(), t._animationStartTime = b, t._animationFrameCount = 1), i.animationEvent(), m(), n.size > 0 || Date.now() < t._animationExtendedEnd ? t.animationRequest = requestAnimationFrame(i.handleAnimation) : (cancelAnimationFrame(t.animationRequest), t.animationRequest = null, i.endAnimationEvent(), i.render());
  }, i.handleWheel = (b) => {
    ny(b);
    const y = {
      ...Fut(b),
      ...c(b),
      position: l(b),
      deviceType: d(b)
    };
    t.wheelTimeoutID === 0 && (Math.abs(y.spinY) >= 0.3 ? r = Math.abs(y.spinY) : r = 1), y.spinY /= r, t.wheelTimeoutID === 0 ? (i.startMouseWheelEvent(y), i.mouseWheelEvent(y)) : (i.mouseWheelEvent(y), clearTimeout(t.wheelTimeoutID)), t.mouseScrollDebounceByPass ? (i.extendAnimation(600), i.endMouseWheelEvent(), t.wheelTimeoutID = 0) : t.wheelTimeoutID = setTimeout(() => {
      i.extendAnimation(600), i.endMouseWheelEvent(), t.wheelTimeoutID = 0;
    }, 200);
  }, i.handleMouseUp = (b) => {
    const y = {
      ...c(b),
      position: l(b),
      deviceType: d(b)
    };
    switch (b.button) {
      case 0:
        i.leftButtonReleaseEvent(y);
        break;
      case 1:
        i.middleButtonReleaseEvent(y);
        break;
      case 2:
        i.rightButtonReleaseEvent(y);
        break;
      default:
        hM(`Unknown mouse button released: ${b.button}`);
        break;
    }
  }, i.handleTouchStart = (b) => {
    const y = [...s.values()];
    if (t.recognizeGestures && y.length > 1) {
      const Z = pM(s);
      if (y.length === 2) {
        const g = {
          ...c(q0),
          position: y[0].position,
          deviceType: d(b)
        };
        i.leftButtonReleaseEvent(g);
      }
      i.recognizeGesture("TouchStart", Z);
    } else if (y.length === 1) {
      const Z = {
        ...c(q0),
        position: l(b),
        deviceType: d(b)
      };
      i.leftButtonPressEvent(Z);
    }
  }, i.handleTouchMove = (b) => {
    const y = [...s.values()];
    if (t.recognizeGestures && y.length > 1) {
      const Z = pM(s);
      i.recognizeGesture("TouchMove", Z);
    } else if (y.length === 1) {
      const Z = {
        ...c(q0),
        position: y[0].position,
        deviceType: d(b)
      };
      i.mouseMoveEvent(Z);
    }
  }, i.handleTouchEnd = (b) => {
    const y = [...s.values()];
    if (t.recognizeGestures)
      if (y.length === 0) {
        const Z = {
          ...c(q0),
          position: l(b),
          deviceType: d(b)
        };
        i.leftButtonReleaseEvent(Z);
      } else if (y.length === 1) {
        const Z = pM(s);
        i.recognizeGesture("TouchEnd", Z);
        const g = {
          ...c(q0),
          position: y[0].position,
          deviceType: d(b)
        };
        i.leftButtonPressEvent(g);
      } else {
        const Z = pM(s);
        i.recognizeGesture("TouchMove", Z);
      }
    else if (y.length === 1) {
      const Z = {
        ...c(q0),
        position: y[0].position,
        deviceType: d(b)
      };
      i.leftButtonReleaseEvent(Z);
    }
  }, i.setView = (b) => {
    t._view !== b && (t._view = b, t._view.getRenderable().setInteractor(i), i.modified());
  }, i.getFirstRenderer = () => {
    var b, y, Z;
    return (Z = (y = (b = t._view) == null ? void 0 : b.getRenderable()) == null ? void 0 : y.getRenderersByReference()) == null ? void 0 : Z[0];
  }, i.findPokedRenderer = function() {
    var N, W;
    let b = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (!t._view)
      return null;
    const Z = (W = (N = t._view) == null ? void 0 : N.getRenderable()) == null ? void 0 : W.getRenderers();
    if (!Z || Z.length === 0)
      return null;
    Z.sort((x, V) => x.getLayer() - V.getLayer());
    let g = null, f = null, T = null, M = Z.length;
    for (; M--; ) {
      const x = Z[M];
      if (t._view.isInViewport(b, y, x) && x.getInteractive()) {
        T = x;
        break;
      }
      g === null && x.getInteractive() && (g = x), f === null && t._view.isInViewport(b, y, x) && (f = x);
    }
    return T === null && (T = g), T === null && (T = f), T == null && (T = Z[0]), T;
  }, i.render = () => {
    !i.isAnimating() && !t.inRender && m();
  }, HI.forEach((b) => {
    const y = b.charAt(0).toLowerCase() + b.slice(1);
    i[`${y}Event`] = (Z) => {
      if (!t.enabled)
        return;
      if (!i.getCurrentRenderer()) {
        jut(`
          Can not forward events without a current renderer on the interactor.
        `);
        return;
      }
      const f = {
        type: b,
        pokedRenderer: t.currentRenderer,
        firstRenderer: i.getFirstRenderer(),
        // Add the arguments to the call data
        ...Z
      };
      i[`invoke${b}`](f);
    };
  }), i.recognizeGesture = (b, y) => {
    if (Object.keys(y).length > 2)
      return;
    if (t.startingEventPositions || (t.startingEventPositions = {}), b === "TouchStart") {
      Object.keys(y).forEach((X) => {
        t.startingEventPositions[X] = y[X];
      }), t.currentGesture = "Start";
      return;
    }
    if (b === "TouchEnd") {
      t.currentGesture === "Pinch" && (i.render(), i.endPinchEvent()), t.currentGesture === "Rotate" && (i.render(), i.endRotateEvent()), t.currentGesture === "Pan" && (i.render(), i.endPanEvent()), t.currentGesture = "Start", t.startingEventPositions = {};
      return;
    }
    let Z = 0;
    const g = [], f = [];
    Object.keys(y).forEach((X) => {
      g[Z] = y[X], f[Z] = t.startingEventPositions[X], Z++;
    });
    const T = Math.sqrt((f[0].x - f[1].x) * (f[0].x - f[1].x) + (f[0].y - f[1].y) * (f[0].y - f[1].y)), M = Math.sqrt((g[0].x - g[1].x) * (g[0].x - g[1].x) + (g[0].y - g[1].y) * (g[0].y - g[1].y));
    let N = pg(Math.atan2(f[1].y - f[0].y, f[1].x - f[0].x)), W = pg(Math.atan2(g[1].y - g[0].y, g[1].x - g[0].x)), x = W - N;
    W = W + 180 >= 360 ? W - 180 : W + 180, N = N + 180 >= 360 ? N - 180 : N + 180, Math.abs(W - N) < Math.abs(x) && (x = W - N);
    const V = [];
    if (V[0] = (g[0].x - f[0].x + g[1].x - f[1].x) / 2, V[1] = (g[0].y - f[0].y + g[1].y - f[1].y) / 2, b === "TouchMove")
      if (t.currentGesture === "Start") {
        let X = 0.01 * Math.sqrt(t.container.clientWidth * t.container.clientWidth + t.container.clientHeight * t.container.clientHeight);
        X < 15 && (X = 15);
        const C = Math.abs(M - T), R = M * 3.1415926 * Math.abs(x) / 360, z = Math.sqrt(V[0] * V[0] + V[1] * V[1]);
        if (C > X && C > R && C > z) {
          t.currentGesture = "Pinch";
          const F = {
            scale: 1,
            touches: y
          };
          i.startPinchEvent(F);
        } else if (R > X && R > z) {
          t.currentGesture = "Rotate";
          const F = {
            rotation: 0,
            touches: y
          };
          i.startRotateEvent(F);
        } else if (z > X) {
          t.currentGesture = "Pan";
          const F = {
            translation: [0, 0],
            touches: y
          };
          i.startPanEvent(F);
        }
      } else {
        if (t.currentGesture === "Rotate") {
          const X = {
            rotation: x,
            touches: y
          };
          i.rotateEvent(X);
        }
        if (t.currentGesture === "Pinch") {
          const X = {
            scale: M / T,
            touches: y
          };
          i.pinchEvent(X);
        }
        if (t.currentGesture === "Pan") {
          const X = {
            translation: V,
            touches: y
          };
          i.panEvent(X);
        }
      }
  }, i.handleVisibilityChange = () => {
    t._animationStartTime = Date.now(), t._animationFrameCount = 0;
  }, i.setCurrentRenderer = (b) => {
    t._forcedRenderer = !!b, t.currentRenderer = b;
  }, i.setContainer = (b) => {
    p();
    const y = e.setContainer(b ?? null);
    return y && h(), y;
  }, i.delete = () => {
    for (; n.size; )
      i.cancelAnimation(n.values().next().value);
    typeof document.hidden < "u" && document.removeEventListener("visibilitychange", i.handleVisibilityChange), t.container && i.setContainer(null), e.delete();
  }, typeof document.hidden < "u" && document.addEventListener("visibilitychange", i.handleVisibilityChange, !1);
}
const Put = {
  renderWindow: null,
  interactorStyle: null,
  picker: null,
  pickingManager: null,
  initialized: !1,
  enabled: !1,
  enableRender: !0,
  currentRenderer: null,
  lightFollowCamera: !0,
  desiredUpdateRate: 30,
  stillUpdateRate: 2,
  container: null,
  // _view: null,
  recognizeGestures: !0,
  currentGesture: "Start",
  animationRequest: null,
  lastFrameTime: 0.1,
  recentAnimationFrameRate: 10,
  wheelTimeoutID: 0,
  moveTimeoutID: 0,
  lastGamepadValues: {},
  preventDefaultOnPointerDown: !1,
  preventDefaultOnPointerUp: !1,
  mouseScrollDebounceByPass: !1
};
function cU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Put, e), tt.obj(i, t), t._animationExtendedEnd = 0, tt.event(i, t, "RenderEvent"), HI.forEach((n) => tt.event(i, t, n)), tt.get(i, t, ["initialized", "interactorStyle", "lastFrameTime", "recentAnimationFrameRate", "_view"]), tt.setGet(i, t, ["container", "lightFollowCamera", "enabled", "enableRender", "recognizeGestures", "desiredUpdateRate", "stillUpdateRate", "picker", "preventDefaultOnPointerDown", "preventDefaultOnPointerUp", "mouseScrollDebounceByPass"]), tt.moveToProtected(i, t, ["view"]), Uut(i, t);
}
const Jut = tt.newInstance(cU, "vtkRenderWindowInteractor");
var RT = {
  newInstance: Jut,
  extend: cU,
  handledEvents: HI,
  ...lU
};
const {
  vtkDebugMacro: mM
} = tt;
function Aut(i, t) {
  t.classHierarchy.push("vtkCamera");
  const e = new Float64Array(3), n = new Float64Array([0, 0, -1]), s = new Float64Array([0, 1, 0]), r = ut.identity(new Float64Array(16)), a = ut.identity(new Float64Array(16)), o = new Float64Array(3), l = new Float64Array(3), c = new Float64Array(3), u = ut.identity(new Float64Array(16)), d = ut.identity(new Float64Array(16)), h = new Float64Array(3), p = new Float64Array(3);
  function m() {
    t.viewPlaneNormal[0] = -t.directionOfProjection[0], t.viewPlaneNormal[1] = -t.directionOfProjection[1], t.viewPlaneNormal[2] = -t.directionOfProjection[2];
  }
  i.orthogonalizeViewUp = () => {
    const b = i.getViewMatrix();
    t.viewUp[0] = b[4], t.viewUp[1] = b[5], t.viewUp[2] = b[6], i.modified();
  }, i.setPosition = (b, y, Z) => {
    b === t.position[0] && y === t.position[1] && Z === t.position[2] || (t.position[0] = b, t.position[1] = y, t.position[2] = Z, i.computeDistance(), i.modified());
  }, i.setFocalPoint = (b, y, Z) => {
    b === t.focalPoint[0] && y === t.focalPoint[1] && Z === t.focalPoint[2] || (t.focalPoint[0] = b, t.focalPoint[1] = y, t.focalPoint[2] = Z, i.computeDistance(), i.modified());
  }, i.setDistance = (b) => {
    if (t.distance === b)
      return;
    t.distance = b, t.distance < 1e-20 && (t.distance = 1e-20, mM("Distance is set to minimum."));
    const y = t.directionOfProjection;
    t.focalPoint[0] = t.position[0] + y[0] * t.distance, t.focalPoint[1] = t.position[1] + y[1] * t.distance, t.focalPoint[2] = t.position[2] + y[2] * t.distance, i.modified();
  }, i.computeDistance = () => {
    const b = t.focalPoint[0] - t.position[0], y = t.focalPoint[1] - t.position[1], Z = t.focalPoint[2] - t.position[2];
    if (t.distance = Math.sqrt(b * b + y * y + Z * Z), t.distance < 1e-20) {
      t.distance = 1e-20, mM("Distance is set to minimum.");
      const g = t.directionOfProjection;
      t.focalPoint[0] = t.position[0] + g[0] * t.distance, t.focalPoint[1] = t.position[1] + g[1] * t.distance, t.focalPoint[2] = t.position[2] + g[2] * t.distance;
    }
    t.directionOfProjection[0] = b / t.distance, t.directionOfProjection[1] = y / t.distance, t.directionOfProjection[2] = Z / t.distance, m();
  }, i.dolly = (b) => {
    if (b <= 0)
      return;
    const y = t.distance / b;
    i.setPosition(t.focalPoint[0] - y * t.directionOfProjection[0], t.focalPoint[1] - y * t.directionOfProjection[1], t.focalPoint[2] - y * t.directionOfProjection[2]);
  }, i.roll = (b) => {
    const y = t.position, Z = t.focalPoint, g = t.viewUp, f = new Float64Array([g[0], g[1], g[2], 0]);
    ut.identity(u);
    const T = new Float64Array([Z[0] - y[0], Z[1] - y[1], Z[2] - y[2]]);
    ut.rotate(u, u, Qi(b), T), zn.transformMat4(f, f, u), t.viewUp[0] = f[0], t.viewUp[1] = f[1], t.viewUp[2] = f[2], i.modified();
  }, i.azimuth = (b) => {
    const y = t.focalPoint;
    ut.identity(d), ut.translate(d, d, y), ut.rotate(d, d, Qi(b), t.viewUp), ut.translate(d, d, [-y[0], -y[1], -y[2]]), I.transformMat4(h, t.position, d), i.setPosition(h[0], h[1], h[2]);
  }, i.yaw = (b) => {
    const y = t.position;
    ut.identity(d), ut.translate(d, d, y), ut.rotate(d, d, Qi(b), t.viewUp), ut.translate(d, d, [-y[0], -y[1], -y[2]]), I.transformMat4(p, t.focalPoint, d), i.setFocalPoint(p[0], p[1], p[2]);
  }, i.elevation = (b) => {
    const y = t.focalPoint, Z = i.getViewMatrix(), g = [-Z[0], -Z[1], -Z[2]];
    ut.identity(d), ut.translate(d, d, y), ut.rotate(d, d, Qi(b), g), ut.translate(d, d, [-y[0], -y[1], -y[2]]), I.transformMat4(h, t.position, d), i.setPosition(h[0], h[1], h[2]);
  }, i.pitch = (b) => {
    const y = t.position, Z = i.getViewMatrix(), g = [Z[0], Z[1], Z[2]];
    ut.identity(d), ut.translate(d, d, y), ut.rotate(d, d, Qi(b), g), ut.translate(d, d, [-y[0], -y[1], -y[2]]), I.transformMat4(p, t.focalPoint, d), i.setFocalPoint(...p);
  }, i.zoom = (b) => {
    b <= 0 || (t.parallelProjection ? t.parallelScale /= b : t.viewAngle /= b, i.modified());
  }, i.translate = (b, y, Z) => {
    const g = [b, y, Z];
    b0(t.position, g, t.position), b0(t.focalPoint, g, t.focalPoint), i.computeDistance(), i.modified();
  }, i.applyTransform = (b) => {
    const y = [...t.viewUp, 1], Z = [], g = [], f = [];
    y[0] += t.position[0], y[1] += t.position[1], y[2] += t.position[2], zn.transformMat4(Z, [...t.position, 1], b), zn.transformMat4(g, [...t.focalPoint, 1], b), zn.transformMat4(f, y, b), f[0] -= Z[0], f[1] -= Z[1], f[2] -= Z[2], i.setPosition(...Z.slice(0, 3)), i.setFocalPoint(...g.slice(0, 3)), i.setViewUp(...f.slice(0, 3));
  }, i.getThickness = () => t.clippingRange[1] - t.clippingRange[0], i.setThickness = (b) => {
    let y = b;
    y < 1e-20 && (y = 1e-20, mM("Thickness is set to minimum.")), i.setClippingRange(t.clippingRange[0], t.clippingRange[0] + y);
  }, i.setThicknessFromFocalPoint = (b) => {
    let y = b;
    y < 1e-20 && (y = 1e-20, mM("Thickness is set to minimum.")), i.setClippingRange(t.distance - y / 2, t.distance + y / 2);
  }, i.setRoll = (b) => {
  }, i.getRoll = () => {
  }, i.setObliqueAngles = (b, y) => {
  }, i.getOrientation = () => {
  }, i.getOrientationWXYZ = () => {
  }, i.getFrustumPlanes = (b) => {
  }, i.getCameraLightTransformMatrix = (b) => (ut.copy(b, t.cameraLightTransform), b), i.computeCameraLightTransform = () => {
    ut.copy(r, i.getViewMatrix()), ut.invert(r, r), ut.fromScaling(a, [t.distance, t.distance, t.distance]), ut.multiply(r, r, a), ut.identity(t.cameraLightTransform), ut.translate(t.cameraLightTransform, r, [0, 0, -1]);
  }, i.deepCopy = (b) => {
  }, i.physicalOrientationToWorldDirection = (b) => {
    const y = ps.fromValues(b[0], b[1], b[2], b[3]), Z = ps.create(), g = ps.fromValues(0, 0, 1, 0);
    return ps.conjugate(Z, y), ps.multiply(g, y, g), ps.multiply(g, g, Z), [g[0], g[1], g[2]];
  }, i.getPhysicalToWorldMatrix = (b) => {
    i.getWorldToPhysicalMatrix(b), ut.invert(b, b);
  }, i.getWorldToPhysicalMatrix = (b) => {
    ut.identity(b);
    const y = [3];
    Wi(t.physicalViewNorth, t.physicalViewUp, y), b[0] = y[0], b[1] = y[1], b[2] = y[2], b[4] = t.physicalViewUp[0], b[5] = t.physicalViewUp[1], b[6] = t.physicalViewUp[2], b[8] = -t.physicalViewNorth[0], b[9] = -t.physicalViewNorth[1], b[10] = -t.physicalViewNorth[2], ut.transpose(b, b), I.set(o, 1 / t.physicalScale, 1 / t.physicalScale, 1 / t.physicalScale), ut.scale(b, b, o), ut.translate(b, b, t.physicalTranslation);
  }, i.computeViewParametersFromViewMatrix = (b) => {
    ut.invert(r, b), I.transformMat4(o, e, r), i.computeDistance();
    const y = t.distance;
    i.setPosition(o[0], o[1], o[2]), I.transformMat4(l, n, r), I.subtract(l, l, o), I.normalize(l, l), i.setDirectionOfProjection(l[0], l[1], l[2]), I.transformMat4(c, s, r), I.subtract(c, c, o), I.normalize(c, c), i.setViewUp(c[0], c[1], c[2]), i.setDistance(y);
  }, i.computeViewParametersFromPhysicalMatrix = (b) => {
    i.getWorldToPhysicalMatrix(r), ut.multiply(r, b, r), i.computeViewParametersFromViewMatrix(r);
  }, i.setViewMatrix = (b) => {
    t.viewMatrix = b, t.viewMatrix && (ut.copy(r, t.viewMatrix), i.computeViewParametersFromViewMatrix(r), ut.transpose(t.viewMatrix, t.viewMatrix));
  }, i.getViewMatrix = () => {
    if (t.viewMatrix)
      return t.viewMatrix;
    ut.lookAt(
      r,
      t.position,
      // eye
      t.focalPoint,
      // at
      t.viewUp
      // up
    ), ut.transpose(r, r);
    const b = new Float64Array(16);
    return ut.copy(b, r), b;
  }, i.setProjectionMatrix = (b) => {
    t.projectionMatrix = b;
  }, i.getProjectionMatrix = (b, y, Z) => {
    const g = new Float64Array(16);
    if (ut.identity(g), t.projectionMatrix) {
      const M = 1 / t.physicalScale;
      return I.set(o, M, M, M), ut.copy(g, t.projectionMatrix), ut.scale(g, g, o), ut.transpose(g, g), g;
    }
    ut.identity(r);
    const f = t.clippingRange[1] - t.clippingRange[0], T = [t.clippingRange[0] + (y + 1) * f / 2, t.clippingRange[0] + (Z + 1) * f / 2];
    if (t.parallelProjection) {
      const M = t.parallelScale * b, N = t.parallelScale, W = (t.windowCenter[0] - 1) * M, x = (t.windowCenter[0] + 1) * M, V = (t.windowCenter[1] - 1) * N, X = (t.windowCenter[1] + 1) * N;
      ut.ortho(r, W, x, V, X, T[0], T[1]), ut.transpose(r, r);
    } else {
      if (t.useOffAxisProjection)
        throw new Error("Off-Axis projection is not supported at this time");
      {
        const M = Math.tan(Qi(t.viewAngle) / 2);
        let N, W;
        t.useHorizontalViewAngle === !0 ? (N = t.clippingRange[0] * M, W = t.clippingRange[0] * M / b) : (N = t.clippingRange[0] * M * b, W = t.clippingRange[0] * M);
        const x = (t.windowCenter[0] - 1) * N, V = (t.windowCenter[0] + 1) * N, X = (t.windowCenter[1] - 1) * W, C = (t.windowCenter[1] + 1) * W, R = T[0], z = T[1];
        r[0] = 2 * R / (V - x), r[5] = 2 * R / (C - X), r[2] = (x + V) / (V - x), r[6] = (X + C) / (C - X), r[10] = -(R + z) / (z - R), r[14] = -1, r[11] = -2 * R * z / (z - R), r[15] = 0;
      }
    }
    return ut.copy(g, r), g;
  }, i.getCompositeProjectionMatrix = (b, y, Z) => {
    const g = i.getViewMatrix(), f = i.getProjectionMatrix(b, y, Z);
    return ut.multiply(f, g, f), f;
  }, i.setDirectionOfProjection = (b, y, Z) => {
    if (t.directionOfProjection[0] === b && t.directionOfProjection[1] === y && t.directionOfProjection[2] === Z)
      return;
    t.directionOfProjection[0] = b, t.directionOfProjection[1] = y, t.directionOfProjection[2] = Z;
    const g = t.directionOfProjection;
    t.focalPoint[0] = t.position[0] + g[0] * t.distance, t.focalPoint[1] = t.position[1] + g[1] * t.distance, t.focalPoint[2] = t.position[2] + g[2] * t.distance, m();
  }, i.setDeviceAngles = (b, y, Z, g) => {
    const f = [3];
    Wi(t.physicalViewNorth, t.physicalViewUp, f);
    const T = ut.identity(new Float64Array(16));
    ut.rotate(T, T, Qi(b), t.physicalViewUp), ut.rotate(T, T, Qi(y), f), ut.rotate(T, T, Qi(Z), t.physicalViewNorth), ut.rotate(T, T, Qi(-g), t.physicalViewUp);
    const M = new Float64Array([-t.physicalViewUp[0], -t.physicalViewUp[1], -t.physicalViewUp[2]]), N = new Float64Array(t.physicalViewNorth);
    I.transformMat4(M, M, T), I.transformMat4(N, N, T), i.setDirectionOfProjection(M[0], M[1], M[2]), i.setViewUp(N[0], N[1], N[2]), i.modified();
  }, i.setOrientationWXYZ = (b, y, Z, g) => {
    const f = ut.identity(new Float64Array(16));
    if (b !== 0 && (y !== 0 || Z !== 0 || g !== 0)) {
      const N = Qi(b), W = ps.create();
      ps.setAxisAngle(W, [y, Z, g], N), ut.fromQuat(f, W);
    }
    const T = new Float64Array(3);
    I.transformMat4(T, [0, 0, -1], f);
    const M = new Float64Array(3);
    I.transformMat4(M, [0, 1, 0], f), i.setDirectionOfProjection(...T), i.setViewUp(...M), i.modified();
  }, i.computeClippingRange = (b) => {
    let y = null, Z = null;
    y = t.viewPlaneNormal, Z = t.position;
    const g = -y[0], f = -y[1], T = -y[2], M = -(g * Z[0] + f * Z[1] + T * Z[2]), N = [g * b[0] + f * b[2] + T * b[4] + M, 1e-18];
    for (let W = 0; W < 2; W++)
      for (let x = 0; x < 2; x++)
        for (let V = 0; V < 2; V++) {
          const X = g * b[V] + f * b[2 + x] + T * b[4 + W] + M;
          N[0] = X < N[0] ? X : N[0], N[1] = X > N[1] ? X : N[1];
        }
    return N;
  };
}
const But = {
  position: [0, 0, 1],
  focalPoint: [0, 0, 0],
  viewUp: [0, 1, 0],
  directionOfProjection: [0, 0, -1],
  parallelProjection: !1,
  useHorizontalViewAngle: !1,
  viewAngle: 30,
  parallelScale: 1,
  clippingRange: [0.01, 1000.01],
  windowCenter: [0, 0],
  viewPlaneNormal: [0, 0, 1],
  useOffAxisProjection: !1,
  screenBottomLeft: [-0.5, -0.5, -0.5],
  screenBottomRight: [0.5, -0.5, -0.5],
  screenTopRight: [0.5, 0.5, -0.5],
  freezeFocalPoint: !1,
  projectionMatrix: null,
  viewMatrix: null,
  cameraLightTransform: ut.create(),
  // used for world to physical transformations
  physicalTranslation: [0, 0, 0],
  physicalScale: 1,
  physicalViewUp: [0, 1, 0],
  physicalViewNorth: [0, 0, -1]
};
function uU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, But, e), tt.obj(i, t), tt.get(i, t, ["distance"]), tt.setGet(i, t, ["parallelProjection", "useHorizontalViewAngle", "viewAngle", "parallelScale", "useOffAxisProjection", "freezeFocalPoint", "physicalScale"]), tt.getArray(i, t, ["directionOfProjection", "viewPlaneNormal", "position", "focalPoint"]), tt.setGetArray(i, t, ["clippingRange", "windowCenter"], 2), tt.setGetArray(i, t, ["viewUp", "screenBottomLeft", "screenBottomRight", "screenTopRight", "physicalTranslation", "physicalViewUp", "physicalViewNorth"], 3), Aut(i, t);
}
const Kut = tt.newInstance(uU, "vtkCamera");
var ip = {
  newInstance: Kut,
  extend: uU
};
function Hut(i, t) {
  t.classHierarchy.push("vtkLight");
  const e = new Float64Array(3);
  i.getTransformedPosition = () => (t.transformMatrix ? I.transformMat4(e, t.position, t.transformMatrix) : I.set(e, t.position[0], t.position[1], t.position[2]), e), i.getTransformedFocalPoint = () => (t.transformMatrix ? I.transformMat4(e, t.focalPoint, t.transformMatrix) : I.set(e, t.focalPoint[0], t.focalPoint[1], t.focalPoint[2]), e), i.getDirection = () => (t.directionMTime < t.mtime && (I.sub(t.direction, t.focalPoint, t.position), Fn(t.direction), t.directionMTime = t.mtime), t.direction), i.setDirection = (n) => {
    const s = new Float64Array(3);
    I.sub(s, t.position, n), t.focalPoint = s;
  }, i.setDirectionAngle = (n, s) => {
    const r = Qi(n), a = Qi(s);
    i.setPosition(Math.cos(r) * Math.sin(a), Math.sin(r), Math.cos(r) * Math.cos(a)), i.setFocalPoint(0, 0, 0), i.setPositional(0);
  }, i.setLightTypeToHeadLight = () => {
    i.setLightType("HeadLight");
  }, i.setLightTypeToCameraLight = () => {
    i.setLightType("CameraLight");
  }, i.setLightTypeToSceneLight = () => {
    i.setTransformMatrix(null), i.setLightType("SceneLight");
  }, i.lightTypeIsHeadLight = () => t.lightType === "HeadLight", i.lightTypeIsSceneLight = () => t.lightType === "SceneLight", i.lightTypeIsCameraLight = () => t.lightType === "CameraLight";
}
const _ut = {
  switch: !0,
  intensity: 1,
  color: [1, 1, 1],
  position: [0, 0, 1],
  focalPoint: [0, 0, 0],
  positional: !1,
  exponent: 1,
  coneAngle: 30,
  coneFalloff: 5,
  attenuationValues: [1, 0, 0],
  transformMatrix: null,
  lightType: "SceneLight",
  shadowAttenuation: 1,
  direction: [0, 0, 0],
  directionMTime: 0
};
function Qut(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, _ut, e), tt.obj(i, t), tt.setGet(i, t, ["intensity", "switch", "positional", "exponent", "coneAngle", "coneFalloff", "transformMatrix", "lightType", "shadowAttenuation", "attenuationValues"]), tt.setGetArray(i, t, ["color", "position", "focalPoint", "attenuationValues"], 3), Hut(i, t);
}
const $ut = tt.newInstance(Qut, "vtkLight");
var qut = {
  newInstance: $ut
};
const {
  vtkErrorMacro: cN
} = tt;
function tdt(i) {
  return () => cN(`vtkViewport::${i} - NOT IMPLEMENTED`);
}
function edt(i, t) {
  t.classHierarchy.push("vtkViewport"), i.getViewProps = () => t.props, i.hasViewProp = (n) => t.props.includes(n), i.addViewProp = (n) => {
    n && !i.hasViewProp(n) && t.props.push(n);
  }, i.removeViewProp = (n) => {
    const s = t.props.filter((r) => r !== n);
    t.props.length !== s.length && (t.props = s);
  }, i.removeAllViewProps = () => {
    t.props = [];
  };
  function e(n) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    s.push(n);
    const r = n.getNestedProps();
    if (r && r.length)
      for (let a = 0; a < r.length; a++)
        e(r[a], s);
    return s;
  }
  i.getViewPropsWithNestedProps = () => {
    const n = [];
    for (let s = 0; s < t.props.length; s++)
      e(t.props[s], n);
    return n;
  }, i.addActor2D = i.addViewProp, i.removeActor2D = (n) => {
    i.removeViewProp(n);
  }, i.getActors2D = () => (t.actors2D = [], t.props.forEach((n) => {
    t.actors2D = t.actors2D.concat(n.getActors2D());
  }), t.actors2D), i.displayToView = () => cN("call displayToView on your view instead"), i.viewToDisplay = () => cN("callviewtodisplay on your view instead"), i.getSize = () => cN("call getSize on your View instead"), i.normalizedDisplayToProjection = (n, s, r) => {
    const a = i.normalizedDisplayToNormalizedViewport(n, s, r);
    return i.normalizedViewportToProjection(a[0], a[1], a[2]);
  }, i.normalizedDisplayToNormalizedViewport = (n, s, r) => {
    const a = [t.viewport[2] - t.viewport[0], t.viewport[3] - t.viewport[1]];
    return [(n - t.viewport[0]) / a[0], (s - t.viewport[1]) / a[1], r];
  }, i.normalizedViewportToProjection = (n, s, r) => [n * 2 - 1, s * 2 - 1, r * 2 - 1], i.projectionToNormalizedDisplay = (n, s, r) => {
    const a = i.projectionToNormalizedViewport(n, s, r);
    return i.normalizedViewportToNormalizedDisplay(a[0], a[1], a[2]);
  }, i.normalizedViewportToNormalizedDisplay = (n, s, r) => {
    const a = [t.viewport[2] - t.viewport[0], t.viewport[3] - t.viewport[1]];
    return [n * a[0] + t.viewport[0], s * a[1] + t.viewport[1], r];
  }, i.projectionToNormalizedViewport = (n, s, r) => [(n + 1) * 0.5, (s + 1) * 0.5, (r + 1) * 0.5], i.PickPropFrom = tdt("PickPropFrom");
}
const ndt = {
  // _vtkWindow: null,
  background: [0, 0, 0],
  background2: [0.2, 0.2, 0.2],
  gradientBackground: !1,
  viewport: [0, 0, 1, 1],
  aspect: [1, 1],
  pixelAspect: [1, 1],
  props: [],
  actors2D: []
};
function dU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, ndt, e), tt.obj(i, t), tt.event(i, t, "event"), tt.setGetArray(i, t, ["viewport"], 4), tt.setGetArray(i, t, ["background", "background2"], 3), edt(i, t);
}
const idt = tt.newInstance(dU, "vtkViewport");
var sdt = {
  newInstance: idt,
  extend: dU
};
const {
  vtkDebugMacro: iy,
  vtkErrorMacro: Dd,
  vtkWarningMacro: rdt
} = kr;
function IO(i) {
  return () => Dd(`vtkRenderer::${i} - NOT IMPLEMENTED`);
}
function adt(i, t) {
  t.classHierarchy.push("vtkRenderer");
  const e = {
    type: "ComputeVisiblePropBoundsEvent",
    renderer: i
  }, n = {
    type: "ResetCameraClippingRangeEvent",
    renderer: i
  }, s = {
    type: "ResetCameraEvent",
    renderer: i
  };
  i.updateCamera = () => (t.activeCamera || (iy("No cameras are on, creating one."), i.getActiveCameraAndResetIfCreated()), t.activeCamera.render(i), !0), i.updateLightsGeometryToFollowCamera = () => {
    const r = i.getActiveCameraAndResetIfCreated();
    t.lights.forEach((a) => {
      a.lightTypeIsSceneLight() || (a.lightTypeIsHeadLight() ? (a.setPositionFrom(r.getPositionByReference()), a.setFocalPointFrom(r.getFocalPointByReference()), a.modified(r.getMTime())) : a.lightTypeIsCameraLight() ? a.setTransformMatrix(r.getCameraLightTransformMatrix(ut.create())) : Dd("light has unknown light type", a.get()));
    });
  }, i.updateLightGeometry = () => t.lightFollowCamera ? i.updateLightsGeometryToFollowCamera() : !0, i.allocateTime = IO("allocateTime"), i.updateGeometry = IO("updateGeometry"), i.getVTKWindow = () => t._renderWindow, i.setLayer = (r) => {
    iy(i.getClassName(), i, "setting Layer to ", r), t.layer !== r && (t.layer = r, i.modified()), i.setPreserveColorBuffer(!!r);
  }, i.setActiveCamera = (r) => t.activeCamera === r ? !1 : (t.activeCamera = r, i.modified(), i.invokeEvent({
    type: "ActiveCameraEvent",
    camera: r
  }), !0), i.makeCamera = () => {
    const r = ip.newInstance();
    return i.invokeEvent({
      type: "CreateCameraEvent",
      camera: r
    }), r;
  }, i.getActiveCamera = () => (t.activeCamera || (t.activeCamera = i.makeCamera()), t.activeCamera), i.getActiveCameraAndResetIfCreated = () => (t.activeCamera || (i.getActiveCamera(), i.resetCamera()), t.activeCamera), i.getActors = () => (t.actors = [], t.props.forEach((r) => {
    t.actors = t.actors.concat(r.getActors());
  }), t.actors), i.addActor = i.addViewProp, i.removeActor = (r) => {
    t.actors = t.actors.filter((a) => a !== r), i.removeViewProp(r), i.modified();
  }, i.removeAllActors = () => {
    i.getActors().forEach((a) => {
      i.removeViewProp(a);
    }), t.actors = [], i.modified();
  }, i.getVolumes = () => (t.volumes = [], t.props.forEach((r) => {
    t.volumes = t.volumes.concat(r.getVolumes());
  }), t.volumes), i.addVolume = i.addViewProp, i.removeVolume = (r) => {
    t.volumes = t.volumes.filter((a) => a !== r), i.removeViewProp(r), i.modified();
  }, i.removeAllVolumes = () => {
    i.getVolumes().forEach((a) => {
      i.removeViewProp(a);
    }), t.volumes = [], i.modified();
  }, i.hasLight = (r) => t.lights.includes(r), i.addLight = (r) => {
    r && !i.hasLight(r) && (t.lights.push(r), i.modified());
  }, i.removeLight = (r) => {
    t.lights = t.lights.filter((a) => a !== r), i.modified();
  }, i.removeAllLights = () => {
    t.lights = [], i.modified();
  }, i.setLightCollection = (r) => {
    t.lights = r, i.modified();
  }, i.makeLight = qut.newInstance, i.createLight = () => {
    t.automaticLightCreation && (t._createdLight && (i.removeLight(t._createdLight), t._createdLight.delete(), t._createdLight = null), t._createdLight = i.makeLight(), i.addLight(t._createdLight), t._createdLight.setLightTypeToHeadLight(), t._createdLight.setPosition(i.getActiveCamera().getPosition()), t._createdLight.setFocalPoint(i.getActiveCamera().getFocalPoint()));
  }, i.normalizedDisplayToWorld = (r, a, o, l) => {
    let c = i.normalizedDisplayToProjection(r, a, o);
    return c = i.projectionToView(c[0], c[1], c[2], l), i.viewToWorld(c[0], c[1], c[2]);
  }, i.worldToNormalizedDisplay = (r, a, o, l) => {
    let c = i.worldToView(r, a, o);
    return c = i.viewToProjection(c[0], c[1], c[2], l), i.projectionToNormalizedDisplay(c[0], c[1], c[2]);
  }, i.viewToWorld = (r, a, o) => {
    if (t.activeCamera === null)
      return Dd("ViewToWorld: no active camera, cannot compute view to world, returning 0,0,0"), [0, 0, 0];
    const l = t.activeCamera.getViewMatrix();
    ut.invert(l, l), ut.transpose(l, l);
    const c = new Float64Array([r, a, o]);
    return I.transformMat4(c, c, l), c;
  }, i.projectionToView = (r, a, o, l) => {
    if (t.activeCamera === null)
      return Dd("ProjectionToView: no active camera, cannot compute projection to view, returning 0,0,0"), [0, 0, 0];
    const c = t.activeCamera.getProjectionMatrix(l, -1, 1);
    ut.invert(c, c), ut.transpose(c, c);
    const u = new Float64Array([r, a, o]);
    return I.transformMat4(u, u, c), u;
  }, i.worldToView = (r, a, o) => {
    if (t.activeCamera === null)
      return Dd("WorldToView: no active camera, cannot compute view to world, returning 0,0,0"), [0, 0, 0];
    const l = t.activeCamera.getViewMatrix();
    ut.transpose(l, l);
    const c = new Float64Array([r, a, o]);
    return I.transformMat4(c, c, l), c;
  }, i.viewToProjection = (r, a, o, l) => {
    if (t.activeCamera === null)
      return Dd("ViewToProjection: no active camera, cannot compute view to projection, returning 0,0,0"), [0, 0, 0];
    const c = t.activeCamera.getProjectionMatrix(l, -1, 1);
    ut.transpose(c, c);
    const u = new Float64Array([r, a, o]);
    return I.transformMat4(u, u, c), u;
  }, i.computeVisiblePropBounds = () => {
    t.allBounds[0] = qe.INIT_BOUNDS[0], t.allBounds[1] = qe.INIT_BOUNDS[1], t.allBounds[2] = qe.INIT_BOUNDS[2], t.allBounds[3] = qe.INIT_BOUNDS[3], t.allBounds[4] = qe.INIT_BOUNDS[4], t.allBounds[5] = qe.INIT_BOUNDS[5];
    let r = !0;
    i.invokeEvent(e);
    for (let a = 0; a < t.props.length; ++a) {
      const o = t.props[a];
      if (o.getVisibility() && o.getUseBounds()) {
        const l = o.getBounds();
        l && nN(l) && (r = !1, l[0] < t.allBounds[0] && (t.allBounds[0] = l[0]), l[1] > t.allBounds[1] && (t.allBounds[1] = l[1]), l[2] < t.allBounds[2] && (t.allBounds[2] = l[2]), l[3] > t.allBounds[3] && (t.allBounds[3] = l[3]), l[4] < t.allBounds[4] && (t.allBounds[4] = l[4]), l[5] > t.allBounds[5] && (t.allBounds[5] = l[5]));
      }
    }
    return r && (Lg(t.allBounds), iy("Can't compute bounds, no 3D props are visible")), t.allBounds;
  }, i.resetCamera = function() {
    const a = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null) || i.computeVisiblePropBounds(), o = [0, 0, 0];
    if (!nN(a))
      return iy("Cannot reset camera!"), !1;
    let l = null;
    if (i.getActiveCamera())
      l = t.activeCamera.getViewPlaneNormal();
    else
      return Dd("Trying to reset non-existent camera"), !1;
    t.activeCamera.setViewAngle(30), o[0] = (a[0] + a[1]) / 2, o[1] = (a[2] + a[3]) / 2, o[2] = (a[4] + a[5]) / 2;
    let c = a[1] - a[0], u = a[3] - a[2], d = a[5] - a[4];
    c *= c, u *= u, d *= d;
    let h = c + u + d;
    h = h === 0 ? 1 : h, h = Math.sqrt(h) * 0.5;
    const p = Qi(t.activeCamera.getViewAngle()), m = h, b = h / Math.sin(p * 0.5), y = t.activeCamera.getViewUp();
    return Math.abs(tn(y, l)) > 0.999 && (rdt("Resetting view-up since view plane normal is parallel"), t.activeCamera.setViewUp(-y[2], y[0], y[1])), t.activeCamera.setFocalPoint(o[0], o[1], o[2]), t.activeCamera.setPosition(o[0] + b * l[0], o[1] + b * l[1], o[2] + b * l[2]), i.resetCameraClippingRange(a), t.activeCamera.setParallelScale(m), t.activeCamera.setPhysicalScale(h), t.activeCamera.setPhysicalTranslation(-o[0], -o[1], -o[2]), i.invokeEvent(s), !0;
  }, i.resetCameraClippingRange = function() {
    const a = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null) || i.computeVisiblePropBounds();
    if (!nN(a))
      return iy("Cannot reset camera clipping range!"), !1;
    if (i.getActiveCameraAndResetIfCreated(), !t.activeCamera)
      return Dd("Trying to reset clipping range of non-existent camera"), !1;
    const o = t.activeCamera.computeClippingRange(a);
    let l = 0;
    if (t.activeCamera.getParallelProjection())
      l = 0.2 * t.activeCamera.getParallelScale();
    else {
      const c = Qi(t.activeCamera.getViewAngle());
      l = 0.2 * Math.tan(c / 2) * o[1];
    }
    return o[1] - o[0] < l && (l = l - o[1] + o[0], o[1] += l / 2, o[0] -= l / 2), o[0] < 0 && (o[0] = 0), o[0] = 0.99 * o[0] - (o[1] - o[0]) * t.clippingRangeExpansion, o[1] = 1.01 * o[1] + (o[1] - o[0]) * t.clippingRangeExpansion, o[0] = o[0] >= o[1] ? 0.01 * o[1] : o[0], t.nearClippingPlaneTolerance || (t.nearClippingPlaneTolerance = 0.01), o[0] < t.nearClippingPlaneTolerance * o[1] && (o[0] = t.nearClippingPlaneTolerance * o[1]), t.activeCamera.setClippingRange(o[0], o[1]), i.invokeEvent(n), !1;
  }, i.setRenderWindow = (r) => {
    r !== t._renderWindow && (t._vtkWindow = r, t._renderWindow = r);
  }, i.visibleActorCount = () => t.props.filter((r) => r.getVisibility()).length, i.visibleVolumeCount = i.visibleActorCount, i.getMTime = () => {
    let r = t.mtime;
    const a = t.activeCamera ? t.activeCamera.getMTime() : 0;
    a > r && (r = a);
    const o = t._createdLight ? t._createdLight.getMTime() : 0;
    return o > r && (r = o), r;
  }, i.getTransparent = () => !!t.preserveColorBuffer, i.isActiveCameraCreated = () => !!t.activeCamera;
}
const odt = {
  pickedProp: null,
  activeCamera: null,
  allBounds: [],
  ambient: [1, 1, 1],
  allocatedRenderTime: 100,
  timeFactor: 1,
  automaticLightCreation: !0,
  twoSidedLighting: !0,
  lastRenderTimeInSeconds: -1,
  renderWindow: null,
  lights: [],
  actors: [],
  volumes: [],
  lightFollowCamera: !0,
  numberOfPropsRendered: 0,
  propArray: null,
  pathArray: null,
  layer: 0,
  preserveColorBuffer: !1,
  preserveDepthBuffer: !1,
  computeVisiblePropBounds: ad(),
  interactive: !0,
  nearClippingPlaneTolerance: 0,
  clippingRangeExpansion: 0.05,
  erase: !0,
  draw: !0,
  useShadows: !1,
  useDepthPeeling: !1,
  occlusionRatio: 0,
  maximumNumberOfPeels: 4,
  selector: null,
  delegate: null,
  texturedBackground: !1,
  backgroundTexture: null,
  environmentTexture: null,
  environmentTextureDiffuseStrength: 1,
  environmentTextureSpecularStrength: 1,
  useEnvironmentTextureAsBackground: !1,
  pass: 0
};
function hU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  for (Object.assign(t, odt, e), sdt.extend(i, t, e), t.background || (t.background = [0, 0, 0, 1]); t.background.length < 3; ) t.background.push(0);
  t.background.length === 3 && t.background.push(1), Sa(i, t, ["_renderWindow", "allocatedRenderTime", "timeFactor", "lastRenderTimeInSeconds", "numberOfPropsRendered", "lastRenderingUsedDepthPeeling", "selector"]), gs(i, t, ["twoSidedLighting", "lightFollowCamera", "automaticLightCreation", "erase", "draw", "nearClippingPlaneTolerance", "clippingRangeExpansion", "backingStore", "interactive", "layer", "preserveColorBuffer", "preserveDepthBuffer", "useDepthPeeling", "occlusionRatio", "maximumNumberOfPeels", "delegate", "backgroundTexture", "texturedBackground", "environmentTexture", "environmentTextureDiffuseStrength", "environmentTextureSpecularStrength", "useEnvironmentTextureAsBackground", "useShadows", "pass"]), Sg(i, t, ["actors", "volumes", "lights"]), HX(i, t, ["background"], 4, 1), wT(i, t, ["renderWindow"]), adt(i, t);
}
const ldt = In(hU, "vtkRenderer");
var ld = {
  newInstance: ldt,
  extend: hU
};
function cdt(i, t) {
  t.classHierarchy.push("vtkAbstractImageMapper"), i.getIsOpaque = () => !0, i.getCurrentImage = () => null, i.getBoundsForSlice = () => (tt.vtkErrorMacro("vtkAbstractImageMapper.getBoundsForSlice - NOT IMPLEMENTED"), ad());
}
const udt = {
  slice: 0,
  customDisplayExtent: [0, 0, 0, 0, 0, 0],
  useCustomExtents: !1,
  backgroundColor: [0, 0, 0, 1]
};
function ddt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, udt, e), DI.extend(i, t, e), tt.setGet(i, t, ["slice", "useCustomExtents"]), tt.setGetArray(i, t, ["customDisplayExtent"], 6), tt.setGetArray(i, t, ["backgroundColor"], 4), cdt(i, t);
}
var hdt = {
  extend: ddt
};
function pU(i, t, e) {
  const n = e.getCurrentImage(), s = n.getExtent(), r = [s[0], s[2], s[4]], {
    ijkMode: a
  } = e.getClosestIJKAxis();
  let o = e.isA("vtkImageArrayMapper") ? e.getSubSlice() : e.getSlice();
  a !== e.getSlicingMode() && (o = e.getSliceAtPosition(o)), r[a] += o;
  const l = [0, 0, 0];
  n.indexToWorld(r, l), r[a] += 1;
  const c = [0, 0, 0];
  n.indexToWorld(r, c), c[0] -= l[0], c[1] -= l[1], c[2] -= l[2], I.normalize(c, c);
  const u = li.intersectWithLine(i, t, l, c);
  if (u.intersection) {
    const d = u.x, h = [0, 0, 0];
    return n.worldToIndex(d, h), {
      t: u.t,
      absoluteIJK: h
    };
  }
  return null;
}
function pdt(i, t, e) {
  const n = pU(i, t, e);
  if (n) {
    const r = e.getCurrentImage().getExtent(), a = [Math.round(n.absoluteIJK[0]), Math.round(n.absoluteIJK[1]), Math.round(n.absoluteIJK[2])];
    return a[0] < r[0] || a[0] > r[1] || a[1] < r[2] || a[1] > r[3] || a[2] < r[4] || a[2] > r[5] ? null : {
      t: n.t,
      ijk: a
    };
  }
  return null;
}
function mdt(i, t, e) {
  const n = pU(i, t, e);
  if (n) {
    const r = e.getCurrentImage().getExtent(), a = n.absoluteIJK, o = [Math.floor(a[0]), Math.floor(a[1]), Math.floor(a[2])];
    if (o[0] < r[0] || o[0] > r[1] - 1 || o[1] < r[2] || o[1] > r[3] - 1 || o[2] < r[4] || // handle single-slice images
    o[2] > (r[5] ? r[5] - 1 : r[5]))
      return null;
    const l = [a[0] - o[0], a[1] - o[1], a[2] - o[2]];
    return {
      t: n.t,
      ijk: o,
      pCoords: l
    };
  }
  return null;
}
const {
  staticOffsetAPI: bdt,
  otherStaticMethods: fdt
} = jG, {
  SlicingMode: On
} = UG;
function gdt(i, t) {
  t.classHierarchy.push("vtkImageMapper"), i.getSliceAtPosition = (n) => {
    const s = i.getCurrentImage();
    let r;
    if (n.length === 3)
      r = n;
    else if (Number.isFinite(n)) {
      const u = s.getBounds();
      switch (t.slicingMode) {
        case On.X:
          r = [n, (u[3] + u[2]) / 2, (u[5] + u[4]) / 2];
          break;
        case On.Y:
          r = [(u[1] + u[0]) / 2, n, (u[5] + u[4]) / 2];
          break;
        case On.Z:
          r = [(u[1] + u[0]) / 2, (u[3] + u[2]) / 2, n];
          break;
      }
    }
    const a = [0, 0, 0];
    s.worldToIndex(r, a);
    const o = s.getExtent(), {
      ijkMode: l
    } = i.getClosestIJKAxis();
    let c = 0;
    switch (l) {
      case On.I:
        c = Ol(a[0], o[0], o[1]);
        break;
      case On.J:
        c = Ol(a[1], o[2], o[3]);
        break;
      case On.K:
        c = Ol(a[2], o[4], o[5]);
        break;
      default:
        return 0;
    }
    return c;
  }, i.setSliceFromCamera = (n) => {
    const s = n.getFocalPoint();
    switch (t.slicingMode) {
      case On.I:
      case On.J:
      case On.K:
        {
          const r = i.getSliceAtPosition(s);
          i.setSlice(r);
        }
        break;
      case On.X:
        i.setSlice(s[0]);
        break;
      case On.Y:
        i.setSlice(s[1]);
        break;
      case On.Z:
        i.setSlice(s[2]);
        break;
    }
  }, i.setXSlice = (n) => {
    i.setSlicingMode(On.X), i.setSlice(n);
  }, i.setYSlice = (n) => {
    i.setSlicingMode(On.Y), i.setSlice(n);
  }, i.setZSlice = (n) => {
    i.setSlicingMode(On.Z), i.setSlice(n);
  }, i.setISlice = (n) => {
    i.setSlicingMode(On.I), i.setSlice(n);
  }, i.setJSlice = (n) => {
    i.setSlicingMode(On.J), i.setSlice(n);
  }, i.setKSlice = (n) => {
    i.setSlicingMode(On.K), i.setSlice(n);
  }, i.getSlicingModeNormal = () => {
    const n = [0, 0, 0], s = i.getCurrentImage().getDirection();
    switch (t.slicingMode) {
      case On.X:
        n[0] = 1;
        break;
      case On.Y:
        n[1] = 1;
        break;
      case On.Z:
        n[2] = 1;
        break;
      case On.I:
        tN(s, [1, 0, 0], n);
        break;
      case On.J:
        tN(s, [0, 1, 0], n);
        break;
      case On.K:
        tN(s, [0, 0, 1], n);
        break;
    }
    return n;
  };
  function e() {
    let n;
    switch (t.slicingMode) {
      case On.X:
        n = 0;
        break;
      case On.Y:
        n = 1;
        break;
      case On.Z:
        n = 2;
        break;
      default:
        t.closestIJKAxis = {
          ijkMode: t.slicingMode,
          flip: !1
        };
        return;
    }
    const s = i.getCurrentImage().getDirection(), r = Hk(s);
    let a = 0;
    for (; a < 3 && r[n + 3 * a] === 0; ++a)
      ;
    const o = r[n + 3 * a] < 0;
    t.closestIJKAxis = {
      ijkMode: a,
      flip: o
    };
  }
  i.setSlicingMode = (n) => {
    t.slicingMode !== n && (t.slicingMode = n, i.getCurrentImage() && e(), i.modified());
  }, i.getClosestIJKAxis = () => ((t.closestIJKAxis === void 0 || t.closestIJKAxis.ijkMode === On.NONE) && i.getCurrentImage() && e(), t.closestIJKAxis), i.getBounds = () => {
    const n = i.getCurrentImage();
    if (!n)
      return ad();
    if (!t.useCustomExtents)
      return n.getBounds();
    const s = t.customDisplayExtent.slice(), {
      ijkMode: r
    } = i.getClosestIJKAxis();
    let a = t.slice;
    switch (r !== t.slicingMode && (a = i.getSliceAtPosition(t.slice)), r) {
      case On.I:
        s[0] = a, s[1] = a;
        break;
      case On.J:
        s[2] = a, s[3] = a;
        break;
      case On.K:
        s[4] = a, s[5] = a;
        break;
    }
    return n.extentToBounds(s);
  }, i.getBoundsForSlice = function() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : t.slice, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    const r = i.getCurrentImage();
    if (!r)
      return ad();
    const a = r.getSpatialExtent(), {
      ijkMode: o
    } = i.getClosestIJKAxis();
    let l = n;
    switch (o !== t.slicingMode && (l = i.getSliceAtPosition(n)), o) {
      case On.I:
        a[0] = l - s, a[1] = l + s;
        break;
      case On.J:
        a[2] = l - s, a[3] = l + s;
        break;
      case On.K:
        a[4] = l - s, a[5] = l + s;
        break;
    }
    return r.extentToBounds(a);
  }, i.intersectWithLineForPointPicking = (n, s) => pdt(n, s, i), i.intersectWithLineForCellPicking = (n, s) => mdt(n, s, i), i.getCurrentImage = () => i.getInputData();
}
const ydt = {
  slicingMode: On.NONE,
  closestIJKAxis: {
    ijkMode: On.NONE,
    flip: !1
  },
  renderToRectangle: !1,
  sliceAtFocalPoint: !1,
  preferSizeOverAccuracy: !1
  // Whether to use halfFloat representation of float, when it is inaccurate
};
function mU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, ydt, e), hdt.extend(i, t, e), tt.get(i, t, ["slicingMode"]), tt.setGet(i, t, ["closestIJKAxis", "renderToRectangle", "sliceAtFocalPoint", "preferSizeOverAccuracy"]), jG.implementCoincidentTopologyMethods(i, t), gdt(i, t);
}
const Zdt = tt.newInstance(mU, "vtkImageMapper");
var jp = {
  newInstance: Zdt,
  extend: mU,
  ...bdt,
  ...fdt,
  ...UG
};
const {
  InterpolationType: uN
} = blt, {
  vtkErrorMacro: CO
} = tt, dN = 4;
function Tdt(i, t) {
  t.classHierarchy.push("vtkImageProperty"), i.getMTime = () => {
    let e = t.mtime, n;
    for (let s = 0; s < dN; s++)
      t.componentData[s].rGBTransferFunction && (n = t.componentData[s].rGBTransferFunction.getMTime(), e = e > n ? e : n), t.componentData[s].piecewiseFunction && (n = t.componentData[s].piecewiseFunction.getMTime(), e = e > n ? e : n);
    return e;
  }, i.setRGBTransferFunction = function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, s = e, r = n;
    return Number.isInteger(e) || (r = e, s = 0), t.componentData[s].rGBTransferFunction !== r ? (t.componentData[s].rGBTransferFunction = r, i.modified(), !0) : !1;
  }, i.getRGBTransferFunction = function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t.componentData[e].rGBTransferFunction;
  }, i.setPiecewiseFunction = function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, s = e, r = n;
    return Number.isInteger(e) || (r = e, s = 0), t.componentData[s].piecewiseFunction !== r ? (t.componentData[s].piecewiseFunction = r, i.modified(), !0) : !1;
  }, i.getPiecewiseFunction = function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t.componentData[e].piecewiseFunction;
  }, i.setScalarOpacity = function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, s = e, r = n;
    return Number.isInteger(e) || (r = e, s = 0), i.setPiecewiseFunction(s, r);
  }, i.getScalarOpacity = function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return i.getPiecewiseFunction(e);
  }, i.setComponentWeight = function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (e < 0 || e >= dN)
      return CO("Invalid index"), !1;
    const s = Math.min(1, Math.max(0, n));
    return t.componentData[e].componentWeight !== s ? (t.componentData[e].componentWeight = s, i.modified(), !0) : !1;
  }, i.getComponentWeight = function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return e < 0 || e >= dN ? (CO("Invalid index"), 0) : t.componentData[e].componentWeight;
  }, i.setInterpolationTypeToNearest = () => i.setInterpolationType(uN.NEAREST), i.setInterpolationTypeToLinear = () => i.setInterpolationType(uN.LINEAR), i.getInterpolationTypeAsString = () => tt.enumToString(uN, t.interpolationType);
}
const Mdt = {
  independentComponents: !1,
  interpolationType: uN.LINEAR,
  colorWindow: 255,
  colorLevel: 127.5,
  ambient: 1,
  diffuse: 0,
  opacity: 1,
  useLookupTableScalarRange: !1,
  useLabelOutline: !1,
  labelOutlineThickness: [1],
  labelOutlineOpacity: 1
};
function Ndt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (Object.assign(t, Mdt, e), tt.obj(i, t), !t.componentData) {
    t.componentData = [];
    for (let n = 0; n < dN; n++)
      t.componentData.push({
        rGBTransferFunction: null,
        piecewiseFunction: null,
        componentWeight: 1
      });
  }
  tt.setGet(i, t, ["independentComponents", "interpolationType", "colorWindow", "colorLevel", "ambient", "diffuse", "opacity", "useLookupTableScalarRange", "useLabelOutline", "labelOutlineOpacity"]), tt.setGetArray(i, t, ["labelOutlineThickness"]), Tdt(i, t);
}
const Wdt = tt.newInstance(Ndt, "vtkImageProperty");
var Gdt = {
  newInstance: Wdt
};
const {
  vtkDebugMacro: wdt
} = tt;
function xdt(i, t) {
  t.classHierarchy.push("vtkImageSlice"), i.getActors = () => i, i.getImages = () => i, i.getIsOpaque = () => {
    if (t.forceOpaque)
      return !0;
    if (t.forceTranslucent)
      return !1;
    t.property || i.getProperty();
    let e = t.property.getOpacity() >= 1;
    return e = e && (!t.mapper || t.mapper.getIsOpaque()), e;
  }, i.hasTranslucentPolygonalGeometry = () => !1, i.makeProperty = Gdt.newInstance, i.getProperty = () => (t.property === null && (t.property = i.makeProperty()), t.property), i.getBounds = () => {
    if (t.mapper === null)
      return t.bounds;
    const e = t.mapper.getBounds();
    if (!e || e.length !== 6)
      return e;
    if (e[0] > e[1])
      return t.mapperBounds = e.concat(), t.bounds = [1, -1, 1, -1, 1, -1], t.boundsMTime.modified(), e;
    const n = (s) => s[0].map((r, a) => s.map((o) => o[a]));
    if (!t.mapperBounds || !n([e, t.mapperBounds]).reduce((s, r) => s && r[0] === r[1], !0) || i.getMTime() > t.boundsMTime.getMTime()) {
      wdt("Recomputing bounds..."), t.mapperBounds = e.map((r) => r), i.computeMatrix();
      const s = new Float64Array(16);
      ut.transpose(s, t.matrix), qe.transformBounds(e, s, t.bounds), t.boundsMTime.modified();
    }
    return t.bounds;
  }, i.getBoundsForSlice = (e, n) => {
    const s = t.mapper.getBoundsForSlice(e, n);
    if (!qe.isValid(s))
      return s;
    i.computeMatrix();
    const r = new Float64Array(16);
    return ut.transpose(r, t.matrix), qe.transformBounds(s, r);
  }, i.getMinXBound = () => i.getBounds()[0], i.getMaxXBound = () => i.getBounds()[1], i.getMinYBound = () => i.getBounds()[2], i.getMaxYBound = () => i.getBounds()[3], i.getMinZBound = () => i.getBounds()[4], i.getMaxZBound = () => i.getBounds()[5], i.getMTime = () => {
    let e = t.mtime;
    if (t.property !== null) {
      const n = t.property.getMTime();
      e = n > e ? n : e;
    }
    return e;
  }, i.getRedrawMTime = () => {
    let e = t.mtime;
    if (t.mapper !== null) {
      let n = t.mapper.getMTime();
      e = n > e ? n : e, t.mapper.getInput() !== null && (t.mapper.getInputAlgorithm().update(), n = t.mapper.getInput().getMTime(), e = n > e ? n : e);
    }
    if (t.property !== null) {
      let n = t.property.getMTime();
      e = n > e ? n : e, t.property.getRGBTransferFunction() !== null && (n = t.property.getRGBTransferFunction().getMTime(), e = n > e ? n : e);
    }
    return e;
  }, i.getSupportsSelection = () => t.mapper ? t.mapper.getSupportsSelection() : !1;
}
const Sdt = {
  mapper: null,
  property: null,
  bounds: [...qe.INIT_BOUNDS]
};
function bU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Sdt, e), RI.extend(i, t, e), t.boundsMTime = {}, tt.obj(t.boundsMTime), tt.set(i, t, ["property"]), tt.setGet(i, t, ["mapper"]), tt.getArray(i, t, ["bounds"], 6), xdt(i, t);
}
const Ldt = tt.newInstance(bU, "vtkImageSlice");
var Up = {
  newInstance: Ldt,
  extend: bU
};
const Zo = {
  CLAMP: 0,
  REPEAT: 1,
  MIRROR: 2
}, zi = {
  NEAREST: 0,
  LINEAR: 1,
  CUBIC: 2
};
var fU = {
  ImageBorderMode: Zo,
  InterpolationMode: zi
};
const gU = {
  pointer: null,
  extent: [0, -1, 0, -1, 0, -1],
  increments: [0, 0, 0],
  scalarType: null,
  // dataType
  dataTypeSize: 1,
  // BYTES_PER_ELEMENT
  numberOfComponents: 1,
  borderMode: Zo.CLAMP,
  interpolationMode: zi.LINEAR,
  extraInfo: null
}, Vdt = {
  ...gU,
  positions: [0, 0, 0],
  weights: null,
  weightExtent: [0, -1, 0, -1, 0, -1],
  kernelSize: [1, 1, 1],
  workspace: null,
  lastY: null,
  lastZ: null
};
function Tb(i) {
  const t = Math.floor(i);
  return {
    floored: t,
    error: i - t
  };
}
function Yb(i) {
  return Math.round(i);
}
function hl(i, t, e) {
  let n = i <= e ? i : e;
  return n -= t, n = n >= 0 ? n : 0, n;
}
function Ql(i, t, e) {
  const n = e - t + 1;
  let s = i - t;
  return s %= n, s = s >= 0 ? s : s + n, s;
}
function $l(i, t, e) {
  const n = e - t, s = n === 0 ? 1 : 0, r = 2 * n + s;
  let a = i - t;
  return a = a >= 0 ? a : -a, a %= r, a = a <= n ? a : r - a, a;
}
const {
  ImageBorderMode: Xdt
} = fU;
function Idt(i, t) {
  t.classHierarchy.push("vtkAbstractImageInterpolator"), i.initialize = (e) => {
    i.releaseData(), t.scalars = e.getPointData().getScalars(), t.spacing = e.getSpacing(), t.origin = e.getOrigin(), t.extent = e.getExtent(), i.update();
  }, i.releaseData = () => {
    t.scalars = null;
  }, i.update = () => {
    if (!t.scalars) {
      t.interpolationInfo.pointer = null, t.interpolationInfo.numberOfComponents = 1;
      return;
    }
    t.interpolationInfo.extent = t.extent.slice();
    const e = i.computeSupportSize(null), n = Math.max(Math.max(e[0], e[1]), e[2]), s = Number.MIN_SAFE_INTEGER + n / 2, r = Number.MAX_SAFE_INTEGER - n / 2;
    for (let h = 0; h < 3; ++h) {
      const p = Math.max(0.5 * (t.extent[2 * h] === t.extent[2 * h + 1]), t.tolerance);
      t.structuredBounds[2 * h] = Math.max(t.extent[2 * h] - p, s), t.structuredBounds[2 * h + 1] = Math.min(t.extent[2 * h + 1] + p, r);
    }
    const a = t.extent[1] - t.extent[0] + 1, o = t.extent[3] - t.extent[2] + 1, l = t.scalars.getNumberOfComponents();
    t.interpolationInfo.increments[0] = l, t.interpolationInfo.increments[1] = t.interpolationInfo.increments[0] * a, t.interpolationInfo.increments[2] = t.interpolationInfo.increments[1] * o;
    let c = t.componentOffset;
    c = c > 0 ? c : 0, c = c < l ? c : l - 1;
    const u = 1, d = t.scalars.getData();
    t.interpolationInfo.pointer = d.subarray(c * u), t.interpolationInfo.scalarType = t.scalars.dataType, t.interpolationInfo.dataTypeSize = 1, t.interpolationInfo.numberOfComponents = i.computeNumberOfComponents(l), t.interpolationInfo.borderMode = t.borderMode, i.internalUpdate();
  }, i.internalUpdate = () => {
  }, i.interpolateXYZ = (e, n, s, r) => {
    let a = t.outValue;
    const o = [e, n, s], l = [(o[0] - t.origin[0]) / t.spacing[0], (o[1] - t.origin[1]) / t.spacing[1], (o[2] - t.origin[2]) / t.spacing[2]];
    if (i.checkBoundsIJK(l)) {
      const c = {
        ...t.interpolationInfo
      }, u = c.increments[0] - t.componentOffset, d = 1;
      let h = r > 0 ? r : 0;
      h = h < u ? h : u - 1, c.pointer = t.interpolationInfo.pointer.subarray(d * h), c.numberOfComponents = 1;
      const p = [a];
      i.interpolatePoint(c, l, p), a = p[0];
    }
    return a;
  }, i.interpolate = (e, n) => {
    const s = [(e[0] - t.origin[0]) / t.spacing[0], (e[1] - t.origin[1]) / t.spacing[1], (e[2] - t.origin[2]) / t.spacing[2]];
    if (i.checkBoundsIJK(s))
      return i.interpolatePoint(t.interpolationInfo, s, n), !0;
    for (let r = 0; r < t.interpolationInfo.numberOfComponents; ++r)
      n[r] = t.outValue;
    return !1;
  }, i.computeNumberOfComponents = (e) => {
    const n = Math.min(Math.max(t.componentOffset, 0), e - 1), s = t.componentCount < e - n ? t.componentCount : e - n;
    return s > 0 ? s : e - n;
  }, i.getNumberOfComponents = () => t.interpolationInfo.numberOfComponents, i.interpolateIJK = (e, n) => {
    i.interpolatePoint(t.interpolationInfo, e, n);
  }, i.checkBoundsIJK = (e) => !(e[0] < t.structuredBounds[0] || e[0] > t.structuredBounds[1] || e[1] < t.structuredBounds[2] || e[1] > t.structuredBounds[3] || e[2] < t.structuredBounds[4] || e[2] > t.structuredBounds[5]), i.computeSupportSize = null, i.isSeparable = null, i.precomputeWeightsForExtent = (e, n, s) => {
  }, i.FreePrecomputedWeights = (e) => {
  }, i.interpolatePoint = (e, n, s) => {
  }, i.interpolateRow = (e, n, s, r, a, o) => {
  };
}
const Cdt = {
  outValue: 0,
  tolerance: Number.EPSILON,
  componentOffset: 0,
  componentCount: -1,
  borderMode: Xdt.CLAMP,
  slidingWindow: !1,
  scalars: null,
  interpolationInfo: {
    ...gU
  },
  interpolationFunc: null,
  rowInterpolationFunc: null,
  structuredBounds: [0, -1, 0, -1, 0, -1],
  spacing: null,
  origin: null,
  extent: null
};
function yU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Cdt, e), tt.obj(i, t), tt.setGet(i, t, ["outValue", "tolerance", "componentOffset", "componentCount", "borderMode", "slidingWindow"]), tt.get(i, t, ["origin", "spacing"]), Idt(i, t);
}
const Ydt = tt.newInstance(yU, "vtkAbstractImageInterpolator");
var vdt = {
  newInstance: Ydt,
  extend: yU,
  ...fU
};
function Rdt(i, t) {
  t.classHierarchy.push("vtkImageInterpolator"), i.computeSupportSize = (e) => {
    let n = 1;
    t.interpolationMode === zi.LINEAR ? n = 2 : t.interpolationMode === zi.CUBIC && (n = 4);
    const s = [n, n, n];
    if (e == null || e[12] !== 0 || e[13] !== 0 || e[14] !== 0 || e[15] !== 1)
      return s;
    for (let r = 0; r < 3; ++r) {
      let a = !0;
      for (let o = 0; o < 3; ++o)
        a = a && Number.isInteger(e[4 * r + o]);
      a && (s[r] = 1);
    }
    return s;
  }, i.internalUpdate = () => {
    t.interpolationInfo.interpolationMode = t.interpolationMode;
  }, i.isSeparable = () => !0, i.interpolateNearest = (e, n, s) => {
    const r = e.extent, a = e.increments, o = e.numberOfComponents;
    let l = Yb(n[0]), c = Yb(n[1]), u = Yb(n[2]);
    switch (e.borderMode) {
      case Zo.REPEAT:
        l = Ql(l, r[0], r[1]), c = Ql(c, r[2], r[3]), u = Ql(u, r[4], r[5]);
        break;
      case Zo.MIRROR:
        l = $l(l, r[0], r[1]), c = $l(c, r[2], r[3]), u = $l(u, r[4], r[5]);
        break;
      default:
        l = hl(l, r[0], r[1]), c = hl(c, r[2], r[3]), u = hl(u, r[4], r[5]);
        break;
    }
    const d = l * a[0] + c * a[1] + u * a[2];
    for (let h = 0; h < o; ++h)
      s[h] = e.pointer[d + h];
  }, i.interpolateLinear = (e, n, s) => {
    const r = e.extent, a = e.increments, o = e.numberOfComponents, l = Tb(n[0]), c = Tb(n[1]), u = Tb(n[2]);
    let d = l.floored, h = c.floored, p = u.floored;
    const m = l.error, b = c.error, y = u.error;
    let Z = d + (m !== 0), g = h + (b !== 0), f = p + (y !== 0);
    switch (e.borderMode) {
      case Zo.REPEAT:
        d = Ql(d, r[0], r[1]), h = Ql(h, r[2], r[3]), p = Ql(p, r[4], r[5]), Z = Ql(Z, r[0], r[1]), g = Ql(g, r[2], r[3]), f = Ql(f, r[4], r[5]);
        break;
      case Zo.MIRROR:
        d = $l(d, r[0], r[1]), h = $l(h, r[2], r[3]), p = $l(p, r[4], r[5]), Z = $l(Z, r[0], r[1]), g = $l(g, r[2], r[3]), f = $l(f, r[4], r[5]);
        break;
      default:
        d = hl(d, r[0], r[1]), h = hl(h, r[2], r[3]), p = hl(p, r[4], r[5]), Z = hl(Z, r[0], r[1]), g = hl(g, r[2], r[3]), f = hl(f, r[4], r[5]);
        break;
    }
    const T = d * a[0], M = Z * a[0], N = h * a[1], W = g * a[1], x = p * a[2], V = f * a[2], X = N + x, C = N + V, R = W + x, z = W + V, F = 1 - m, P = 1 - b, j = 1 - y, H = P * j, B = b * j, $ = P * y, A = b * y, E = e.pointer;
    for (let ct = 0; ct < o; ++ct)
      s[ct] = F * (H * E[T + X + ct * 4] + $ * E[T + C + ct * 4] + B * E[T + R + ct * 4] + A * E[T + z + ct * 4]) + m * (H * E[M + X + ct * 4] + $ * E[M + C + ct * 4] + B * E[M + R + ct * 4] + A * E[M + z + ct * 4]);
  }, i.interpolatePoint = (e, n, s) => {
    switch (t.interpolationMode) {
      case zi.LINEAR:
        i.interpolateLinear(e, n, s);
        break;
      case zi.CUBIC:
        console.log("CUBIC not implemented");
        break;
      case zi.NEAREST:
      default:
        i.interpolateNearest(e, n, s);
        break;
    }
  }, i.interpolateRowNearest = (e, n, s, r, a, o) => {
    const l = e.positions[0].subarray(n), c = e.positions[1].subarray(s), u = e.positions[2].subarray(r), d = e.pointer.subarray(c[0] + u[0]), h = e.numberOfComponents;
    for (let p = 0; p < o; ++p)
      a.set(d.subarray(l[p], h), p * h);
  }, i.interpolateRowLinear = (e, n, s, r, a, o) => {
    const l = e.kernelSize[0], c = e.kernelSize[1], u = e.kernelSize[2], d = n * l, h = s * c, p = r * u, m = e.weights[0].subarray(d), b = e.weights[1].subarray(h), y = e.weights[2].subarray(p), Z = e.positions[0].subarray(d), g = e.positions[1].subarray(h), f = e.positions[2].subarray(p), T = e.pointer, M = e.numberOfComponents, N = g.subarray(f[0]);
    let W = N, x = N, V = N, X = 1, C = 0, R = 1, z = 0;
    c === 2 && (x = g[1].subarray(f[0]), V = x, X = b[0], C = b[1]), u === 2 && (W = g[0].subarray(f[1]), V = W, R = y[0], z = y[1]), c + u === 4 && (V = g[1].subarray(f[1]));
    const F = X * R, P = X * z, j = C * R, H = C * z;
    if (l === 1)
      if (C === 0 && z === 0)
        for (let B = o; B > 0; --B)
          for (let $ = 0; $ < M; $++)
            a[$ + o - B] = T[N + Z[o - B] + $];
      else if (C === 0)
        for (let B = o; B > 0; --B)
          for (let $ = 0; $ < M; $++)
            a[$ + o - B] = R * T[Z[o - B] + N + $ * 4] + z * T[Z[o - B] + W + $ * 4];
      else
        for (let B = o; B > 0; --B)
          for (let $ = 0; $ < M; $++)
            a[$ + o - B] = F * T[Z[o - B] + N + $ * 4] + P * T[Z[o - B] + W + $ * 4] + j * T[Z[o - B] + x + $ * 4] + H * T[Z[o - B] + V + $ * 4];
    else if (z === 0) {
      let B = 0;
      for (let $ = o; $ > 0; --$) {
        const A = m[0 + 2 * B], E = m[1 + 2 * B], ct = Z[0 + 2 * B], at = Z[1 + 2 * B];
        for (let dt = 0; dt < M; dt++)
          a[dt + o - $] = A * (X * T[ct + N + dt * 4] + C * T[ct + x + dt * 4]) + E * (X * T[at + N + dt * 4] + C * T[at + x + dt * 4]);
        B++;
      }
    } else {
      let B = 0;
      for (let $ = o; $ > 0; --$) {
        const A = m[0 + 2 * B], E = m[1 + 2 * B], ct = Z[0 + 2 * B], at = Z[1 + 2 * B];
        for (let dt = 0; dt < M; dt++)
          a[dt] = A * (F * T[ct + N + dt * 4] + P * T[ct + W + dt * 4] + j * T[ct + x + dt * 4] + H * T[ct + V + dt * 4]) + E * (F * T[at + N + dt * 4] + P * T[at + W + dt * 4] + j * T[at + x + dt * 4] + H * T[at + V + dt * 4]);
        B++;
      }
    }
  }, i.interpolateRow = (e, n, s, r, a, o) => {
    switch (t.interpolationMode) {
      case zi.LINEAR:
        i.interpolateRowLinear(e, n, s, r, a, o);
        break;
      case zi.CUBIC:
        console.log("CUBIC not implemented");
        break;
      case zi.NEAREST:
      default:
        i.interpolateRowNearest(e, n, s, r, a, o);
        break;
    }
  }, i.vtkTricubicInterpWeights = (e) => {
    const s = e - 1, r = e * 0.5, a = e * 3;
    return [-r * s * s, ((a - 2) * r - 1) * s, -((a - 4) * e - 1) * r, e * r * s];
  }, i.precomputeWeightsForExtent = (e, n, s) => {
    const r = {
      ...Vdt.newInstance(),
      ...t.interpolationInfo
    };
    r.weightType = "Float32Array";
    const a = r.interpolationMode;
    let o = !0;
    for (let l = 0; l < 3; ++l) {
      let c;
      for (c = 0; c < 3 && e[4 * l + c] === 0; ++c)
        ;
      s[2 * l] = n[2 * l], s[2 * l + 1] = n[2 * l + 1];
      const u = r.extent[2 * c], d = r.extent[2 * c + 1], h = t.structuredBounds[2 * c], p = t.structuredBounds[2 * c + 1];
      let m = 1;
      m = a < zi.LINEAR ? m : 2, m = a < zi.CUBIC ? m : 4;
      const b = d - u + 1;
      m = m < b ? m : b, Number.isInteger(e[4 * l + c]) && Number.isInteger(e[4 * c + c]) && (m = 1);
      const y = m * (n[2 * l + 1] - n[2 * l] + 1), Z = new Int16Array(y), g = m * n[2 * l];
      let f = null;
      a !== zi.NEAREST && (f = new Int16Array(y)), r.kernelSize[l] = m, r.weightExtent[2 * l] = n[2 * l], r.weightExtent[2 * l + 1] = n[2 * l + 1], r.positions[l] = Z, r.weights[l] = f;
      let T = 0;
      for (let M = n[2 * l]; M <= n[2 * l + 1]; ++M) {
        const N = e[12 + c] + M * e[4 * l + c];
        let W = m, x = 0, V = 0;
        if (a === zi.NEAREST)
          x = Math.round(N);
        else {
          const z = Tb(N);
          x = z.integer, V = z.error, a === zi.CUBIC && m !== 1 && (x--, W = 4);
        }
        const X = [0, 0, 0, 0];
        let C = 0;
        switch (r.borderMode) {
          case Zo.REPEAT:
            do
              X[C] = Ql(x, u, d), x++;
            while (++C < W);
            break;
          case Zo.MIRROR:
            do
              X[C] = $l(x, u, d), x++;
            while (++C < W);
            break;
          default:
            do
              X[C] = hl(x, u, d), x++;
            while (++C < W);
            break;
        }
        const R = r.increments[c];
        if (Z[m * M - g] = X[0] * R, a !== zi.NEAREST && (f[m * M - g] = 1), m > 1) {
          if (a === zi.LINEAR)
            Z[m * M + 1 - g] = X[1] * R, f[m * M - g] = 1 - V, f[m * M + 1 - g] = V;
          else if (a === zi.CUBIC) {
            const z = i.vtkTricubicInterpWeights(V);
            if (m === 4)
              for (let F = 0; F < 4; F++)
                Z[m * M + F - g] = X[F] * R, f[m * M + F - g] = z[F];
            else {
              const F = [0, 0, 0, 0];
              for (let P = 0; P < 4; P++) {
                const j = X[P] - u;
                F[j] += z[P];
              }
              for (let P = 0; P < m; P++)
                Z[m * M + P - g] = u + P, f[m * M + P - g] = F[P];
            }
          }
        }
        N >= h && N <= p ? T === 0 && (T = 1, s[2 * l] = M) : T === 1 && (T = 2, s[2 * l + 1] = M - 1);
      }
      (T === 0 || s[2 * l] > s[2 * l + 1]) && (o = !1);
    }
    if (!o)
      for (let l = 0; l < 3; l++)
        s[2 * l] = n[2 * l], s[2 * l + 1] = n[2 * l] - 1;
  };
}
const Ddt = {
  interpolationMode: zi.NEAREST
};
function ZU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Ddt, e), vdt.extend(i, t, e), tt.setGet(i, t, ["interpolationMode"]), Rdt(i, t);
}
const Odt = tt.newInstance(ZU, "vtkImageInterpolator");
var zdt = {
  newInstance: Odt,
  extend: ZU
};
function Edt(i, t) {
  t.classHierarchy.push("vtkImagePointDataIterator"), i.initialize = (e, n, s, r) => {
    const a = e.getExtent();
    let o = n;
    o == null && (o = a);
    let l = !1;
    for (let h = 0; h < 6; h += 2)
      t.extent[h] = Math.max(o[h], a[h]), t.extent[h + 1] = Math.min(o[h + 1], a[h + 1]), t.extent[h] > t.extent[h + 1] && (l = !0);
    t.rowIncrement = a[1] - a[0] + 1, t.sliceIncrement = t.rowIncrement * (a[3] - a[2] + 1);
    let c, u, d;
    if (!l)
      c = t.extent[1] - t.extent[0] + 1, u = t.extent[3] - t.extent[2] + 1, d = t.extent[5] - t.extent[4] + 1, t.id = t.extent[0] - a[0] + (t.extent[2] - a[2]) * t.rowIncrement + (t.extent[4] - a[4]) * t.sliceIncrement, t.rowEndIncrement = t.rowIncrement - c, t.sliceEndIncrement = t.rowEndIncrement + t.sliceIncrement - t.rowIncrement * u;
    else {
      c = 0, u = 0, d = 0, t.id = 0, t.rowEndIncrement = 0, t.sliceEndIncrement = 0;
      for (let h = 0; h < 6; h += 2)
        t.extent[h] = a[h], t.extent[h + 1] = a[h] - 1;
    }
    if (t.spanEnd = t.id + c, t.rowEnd = t.id + c, t.sliceEnd = t.id + (t.rowIncrement * u - t.rowEndIncrement), t.end = t.id + (t.sliceIncrement * d - t.sliceEndIncrement), t.index[0] = t.extent[0], t.index[1] = t.extent[2], t.index[2] = t.extent[4], t.startY = t.index[1], s) {
      t.hasStencil = !0, t.inStencil = !1, t.spanIndex = 0;
      const h = s.getExtent();
      if (t.spanSliceIncrement = 0, t.spanSliceEndIncrement = 0, h[3] >= h[2] && h[5] >= h[4]) {
        t.spanSliceIncrement = h[3] - h[2] + 1;
        const y = t.extent[2] - h[2];
        y >= 0 && (t.spanSliceEndIncrement += y);
        const Z = h[3] - t.extent[3];
        Z >= 0 && (t.spanSliceEndIncrement += Z);
      }
      let p = 0;
      const m = t.extent[2] - h[2];
      m < 0 ? (t.extent[2] = h[2], p -= 1) : p += m, h[3] <= t.extent[3] && (t.extent[3] = h[3]);
      const b = t.extent[4] - h[4];
      b < 0 ? (t.extent[4] = h[4], m >= 0 && (p -= 1 + t.spanSliceEndIncrement)) : p += b * t.spanSliceIncrement, h[5] <= t.extent[5] && (t.extent[5] = h[5]), t.extent[2] <= t.extent[3] && t.extent[4] <= t.extent[5] ? (t.spanCountPointer = s.extentListLengths.subarray(p), t.spanListPointer = s.extentLists.subarray(p), m >= 0 && b >= 0 && (t.inStencil = !0, t.setSpanState(t.extent[0]))) : (t.spanCountPointer = null, t.spanListPointer = null, t.inStencil = !1);
    } else
      t.hasStencil = !1, t.inStencil = !0, t.spanSliceEndIncrement = 0, t.spanSliceIncrement = 0, t.spanIndex = 0, t.spanCountPointer = null, t.spanListPointer = null;
    if (r) {
      t.algorithm = r;
      const h = u * d;
      t.target = h / 50 + 1, t.count = t.target * 50 - h / t.target * t.target + 1;
    } else
      t.algorithm = null, t.target = 0, t.count = 0;
  }, i.setSpanState = (e) => {
    let n = !1;
    const s = t.spanListPointer, r = t.spanCountPointer[0];
    let a;
    for (a = 0; a < r && !(s[a] > e); ++a)
      n = !n;
    t.spanIndex = a, t.inStencil = n;
    let o = t.extent[1] + 1;
    a < r && s[a] <= t.extent[1] && (o = s[a]);
    const l = t.rowEnd - (t.rowIncrement - t.rowEndIncrement);
    t.id = l + (e - t.extent[0]), t.spanEnd = l + (o - t.extent[0]);
  }, i.nextSpan = () => {
    if (t.spanEnd === t.rowEnd) {
      let e = 1;
      if (t.spanEnd !== t.sliceEnd)
        t.id = t.rowEnd + t.rowEndIncrement, t.rowEnd += t.rowIncrement, t.spanEnd = t.rowEnd, t.index[1]++;
      else if (t.spanEnd !== t.end)
        t.id = t.sliceEnd + t.sliceEndIncrement, t.sliceEnd += t.sliceIncrement, t.rowEnd = t.id + (t.rowIncrement - t.rowEndIncrement), t.spanEnd = t.rowEnd, t.index[1] = t.startY, t.index[2]++, e += t.spanSliceEndIncrement;
      else {
        t.id = t.end;
        return;
      }
      t.index[0] = t.extent[0], t.hasStencil && (t.index[1] >= t.extent[2] && t.index[1] <= t.extent[3] && t.index[2] >= t.extent[4] && t.index[2] <= t.extent[5] ? (t.spanCountPointer = t.spanCountPointer.subarray(e), t.spanListPointer = t.spanListPointer.subarray(e), i.setSpanState(t.extent[0])) : t.inStencil = !1), t.algorithm && i.reportProgress();
    } else {
      t.id = t.spanEnd;
      const e = t.spanCountPointer[0];
      let n = t.extent[1] + 1;
      if (t.index[0] = n, t.spanIndex < e) {
        const s = t.spanListPointer[t.spanIndex];
        s < n && (t.index[0] = s);
      }
      if (t.spanIndex++, t.spanIndex < e) {
        const s = t.spanListPointer[t.spanIndex];
        s < n && (n = s);
      }
      t.spanEnd = t.rowEnd - (t.rowIncrement - t.rowEndIncrement) + (n - t.extent[0]), t.inStencil = !t.inStencil;
    }
  }, i.isAtEnd = () => t.id === t.end, i.isInStencil = () => t.inStencil, i.spanEndId = () => t.spanEnd, i.reportProgress = () => {
  }, i.getArray = (e, n) => e.getData().subarray(n * e.getNumberOfComponents()), i.getScalars = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return i.getArray(e.getPointData().getScalars(), n);
  };
}
const kdt = {
  spanState: 0,
  extent: [0, -1, 0, -1, 0, -1],
  end: 0,
  spanEnd: 0,
  rowEnd: 0,
  sliceEnd: 0,
  rowIncrement: 0,
  rowEndIncrement: 0,
  sliceIncrement: 0,
  sliceEndIncrement: 0,
  id: 0,
  index: [0, 0, 0],
  startY: 0,
  hasStencil: !1,
  inStencil: !0,
  spanIndex: 0,
  spanSliceIncrement: 0,
  spanSliceEndIncrement: 0,
  spanCountPointer: null,
  spanListPointer: null,
  algorithm: null,
  target: 0,
  count: 0
};
function TU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, kdt, e), tt.obj(i, t), tt.get(i, t, ["id", "index"]), Edt(i, t);
}
const Fdt = tt.newInstance(TU, "vtkImagePointDataIterator");
var jdt = {
  newInstance: Fdt,
  extend: TU
};
const Pp = {
  MIN: 0,
  MAX: 1,
  MEAN: 2,
  SUM: 3
};
var MU = {
  SlabMode: Pp
};
const {
  SlabMode: ab
} = MU, {
  vtkErrorMacro: Udt
} = tt;
function Pdt(i, t) {
  t.classHierarchy.push("vtkImageReslice");
  const e = {
    ...i
  }, n = ut.identity(new Float64Array(16));
  let s = null;
  function r(p, m, b, y) {
    const Z = b - 1;
    for (let g = 0; g < m; g += 1) {
      let f = p[g] * 0.5;
      for (let T = 1; T < Z; T += 1)
        f += p[g + T * m];
      f += p[g + Z * m] * 0.5, p[g] = f * y;
    }
  }
  function a(p, m, b, y) {
    for (let Z = 0; Z < m; Z += 1) {
      let g = p[Z];
      for (let f = 1; f < b; f += 1)
        g += p[Z + f * m];
      p[Z] = g * y;
    }
  }
  function o(p, m, b) {
    for (let y = 0; y < m; y += 1) {
      let Z = p[y];
      for (let g = 1; g < b; g += 1)
        Z = Math.min(Z, p[y + g * m]);
      p[y] = Z;
    }
  }
  function l(p, m, b) {
    for (let y = 0; y < m; y += 1) {
      let Z = p[y];
      for (let g = 1; g < b; g += 1)
        Z = Math.max(Z, p[y + g * m]);
      p[y] = Z;
    }
  }
  function c(p, m, b) {
    const y = 1 / b;
    a(p, m, b, y);
  }
  function u(p, m, b) {
    const y = 1 / (b - 1);
    r(p, m, b, y);
  }
  function d(p, m, b) {
    a(p, m, b, 1);
  }
  function h(p, m, b) {
    r(p, m, b, 1);
  }
  i.getMTime = () => {
    let p = e.getMTime();
    return t.resliceTransform && (p = Math.max(p, t.resliceTransform.getMTime())), p;
  }, i.setResliceAxes = (p) => (t.resliceAxes || (t.resliceAxes = ut.identity(new Float64Array(16))), ut.exactEquals(t.resliceAxes, p) ? !1 : (ut.copy(t.resliceAxes, p), i.modified(), !0)), i.requestData = (p, m) => {
    const b = p[0];
    if (!b) {
      Udt("Invalid or missing input");
      return;
    }
    const y = b.getOrigin(), Z = b.getSpacing(), g = b.getDimensions(), f = b.getPointData().getScalars(), T = [0, g[0] - 1, 0, g[1] - 1, 0, g[2] - 1], M = [0, 0, 0], N = [1, 1, 1], W = [0, 0, 0, 0, 0, 0], x = [0, 0, 0], V = ut.identity(new Float64Array(16));
    t.resliceAxes && ut.multiply(V, V, t.resliceAxes);
    const X = new Float64Array(16);
    ut.invert(X, V);
    const C = [y[0] + 0.5 * (T[0] + T[1]) * Z[0], y[1] + 0.5 * (T[2] + T[3]) * Z[1], y[2] + 0.5 * (T[4] + T[5]) * Z[2]];
    let R = null;
    t.autoCropOutput && (R = i.getAutoCroppedOutputBounds(b));
    for (let at = 0; at < 3; at++) {
      let dt = 0, gt = 0, Wt = 0, Zt = 0;
      if (t.transformInputSampling) {
        let Gt = 0;
        for (let Tt = 0; Tt < 3; Tt++) {
          Zt += X[4 * Tt + at] * (C[Tt] - V[12 + Tt]);
          const Q = V[4 * at + Tt] * V[4 * at + Tt];
          dt += Q * Math.abs(Z[Tt]), gt += Q * (T[2 * Tt + 1] - T[2 * Tt]) * Math.abs(Z[Tt]), Wt += Q * T[2 * Tt], Gt += Q;
        }
        dt /= Gt, gt /= Gt * Math.sqrt(Gt), Wt /= Gt;
      } else
        Zt = C[at], dt = Z[at], gt = (T[2 * at + 1] - T[2 * at]) * dt, Wt = T[2 * at];
      t.outputSpacing == null ? N[at] = dt : N[at] = t.outputSpacing[at], at >= t.outputDimensionality ? (W[2 * at] = 0, W[2 * at + 1] = 0) : t.outputExtent == null ? (t.autoCropOutput && (gt = R[2 * at + 1] - R[2 * at]), W[2 * at] = Math.round(Wt), W[2 * at + 1] = Math.round(W[2 * at] + Math.abs(gt / N[at]))) : (W[2 * at] = t.outputExtent[2 * at], W[2 * at + 1] = t.outputExtent[2 * at + 1]), at >= t.outputDimensionality ? M[at] = 0 : t.outputOrigin == null ? t.autoCropOutput ? M[at] = R[2 * at] - W[2 * at] * N[at] : M[at] = Zt - 0.5 * (W[2 * at] + W[2 * at + 1]) * N[at] : M[at] = t.outputOrigin[at], x[at] = W[2 * at + 1] - W[2 * at] + 1;
    }
    let z = f.getDataType();
    t.outputScalarType && (z = t.outputScalarType);
    const F = b.getPointData().getScalars().getNumberOfComponents(), P = tt.newTypedArray(z, x[0] * x[1] * x[2] * F), j = We.newInstance({
      name: "Scalars",
      values: P,
      numberOfComponents: F
    }), H = xs.newInstance();
    H.setDimensions(x), H.setOrigin(M), H.setSpacing(N), t.outputDirection && H.setDirection(t.outputDirection), H.getPointData().setScalars(j), i.getIndexMatrix(b, H);
    let B = t.interpolationMode;
    t.usePermuteExecute = !1, t.optimization && s == null && t.slabSliceSpacingFraction === 1 && t.interpolator.isSeparable() && i.isPermutationMatrix(n) && (t.usePermuteExecute = !0, i.canUseNearestNeighbor(n, W) && (B = zi.NEAREST)), t.interpolator.setInterpolationMode(B);
    let $ = Zo.CLAMP;
    $ = t.wrap ? Zo.REPEAT : $, $ = t.mirror ? Zo.MIRROR : $, t.interpolator.setBorderMode($);
    const A = 762939453125e-17, E = 2 * 2147483647;
    let ct = 0.5 * t.border;
    ct = $ === Zo.CLAMP ? ct : E, ct = ct > A ? ct : A, t.interpolator.setTolerance(ct), t.interpolator.initialize(b), i.vtkImageResliceExecute(b, H), t.interpolator.releaseData(), m[0] = H;
  }, i.vtkImageResliceExecute = (p, m) => {
    const b = p.getPointData().getScalars(), y = m.getPointData().getScalars();
    let Z = y.getData();
    const g = m.getExtent(), f = n, T = Math.max(t.slabNumberOfSlices, 1), M = t.slabSliceSpacingFraction, N = i.isPerspectiveMatrix(f);
    let W = b.getData();
    const x = 1, V = b.getDataType(), X = b.getNumberOfComponents(), C = t.interpolator.getComponentOffset(), R = t.interpolator.getBorderMode(), z = p.getDimensions(), F = [0, z[0] - 1, 0, z[1] - 1, 0, z[2] - 1], P = [0, 0, 0];
    P[0] = b.getNumberOfComponents(), P[1] = P[0] * z[0], P[2] = P[1] * z[1];
    const j = z[0] * z[1] * z[2];
    C > 0 && C + X < P[0] && (W = W.subarray(x * C));
    let H = zi.NEAREST;
    t.interpolator.isA("vtkImageInterpolator") && (H = t.interpolator.getInterpolationMode());
    const B = null, $ = t.scalarShift !== 0 || t.scalarScale !== 1, A = H === zi.NEAREST && R === Zo.CLAMP && !(s != null || N || B != null || $) && V === y.getDataType() && j === b.getNumberOfTuples() && t.border === !0 && T <= 1, E = y.getDataType(), ct = 1, at = y.getNumberOfComponents(), dt = [0, 0, 0, 0], gt = [0, 0, 0, 0], Wt = [0, 0, 0, 0], Zt = [0, 0, 0, 0];
    for (let ue = 0; ue < 4; ++ue)
      dt[ue] = f[0 + ue], gt[ue] = f[4 + ue], Wt[ue] = f[8 + ue], Zt[ue] = f[12 + ue];
    let Gt = null;
    A || (Gt = new Float64Array(X * (g[1] - g[0] + T)));
    const Tt = tt.newTypedArray(V, t.backgroundColor), Q = H > zi.LINEAR || T > 1 && t.slabMode === ab.SUM, D = i.getConversionFunc(V, E, t.scalarShift, t.scalarScale, Q), q = i.getSetPixelsFunc(E, ct, at, Z), nt = i.getCompositeFunc(t.slabMode, t.slabTrapezoidIntegration);
    let et = g[2] - 1, ot = g[4] - 1;
    const it = [0, 0, 0, 0], ht = [0, 0, 0, 0], lt = jdt.newInstance();
    lt.initialize(m, g, t.stencil, null);
    const mt = lt.getScalars(m, 0);
    let wt = 0;
    const Xt = tt.newTypedArray(E, qe.getDiagonalLength(g) * at * 2), At = new Float64Array(X * T), he = new Float64Array(X);
    for (; !lt.isAtEnd(); lt.nextSpan()) {
      const ue = lt.spanEndId() - lt.getId();
      if (wt = lt.getId() * ct * at, lt.isInStencil()) {
        const Dt = lt.getIndex();
        Dt[2] > ot && (ot = Dt[2], it[0] = Zt[0] + ot * Wt[0], it[1] = Zt[1] + ot * Wt[1], it[2] = Zt[2] + ot * Wt[2], it[3] = Zt[3] + ot * Wt[3], et = g[2] - 1), Dt[1] > et && (et = Dt[1], ht[0] = it[0] + et * gt[0], ht[1] = it[1] + et * gt[1], ht[2] = it[2] + et * gt[2], ht[3] = it[3] + et * gt[3]);
        const ee = Dt[0], yt = ee + ue - 1;
        if (A) {
          const fe = W, Xe = Z, Se = P[0] * x, Vt = P[1] * x, Rt = P[2] * x, $t = F[1] - F[0] + 1, zt = F[3] - F[2] + 1, Bt = F[5] - F[4] + 1;
          let Kt = ee, ne = ee - 1, ae = !1;
          const Ge = x * X;
          for (let je = ee; je <= yt; je++) {
            const we = [ht[0] + je * dt[0], ht[1] + je * dt[1], ht[2] + je * dt[2]], ln = Yb(we[0]) - F[0], Ls = Yb(we[1]) - F[2], ys = Yb(we[2]) - F[4];
            if (ln >= 0 && ln < $t && Ls >= 0 && Ls < zt && ys >= 0 && ys < Bt) {
              if (!ae) {
                Kt = je, ae = !0;
                const be = q(Xt, Tt, at, Kt - ee);
                for (let rn = 0; rn < be; ++rn)
                  mt[wt++] = Xt[rn];
              }
              ne = je;
              let re = ln * Se + Ls * Vt + ys * Rt;
              switch (Ge) {
                case 1:
                  mt[wt++] = fe[re];
                  break;
                case 2:
                case 3:
                case 4:
                case 8:
                case 12:
                case 16:
                  for (let be = 0; be < Ge; ++be)
                    mt[wt++] = fe[re + be];
                  break;
                default: {
                  let be = 0;
                  do
                    mt[wt++] = fe[re++];
                  while (++be !== Ge);
                  break;
                }
              }
            } else if (ae)
              break;
          }
          Z = Xe;
          const He = q(Xt, Tt, at, yt - ne);
          for (let je = 0; je < He; ++je)
            mt[wt++] = Xt[je];
        } else {
          let fe = 1, Xe = 1, Se = ee, Vt = ee;
          const Rt = Gt;
          let $t = 0;
          for (; Se <= yt; ) {
            for (; Vt <= yt && Xe === fe; Vt++) {
              const ne = [ht[0] + Vt * dt[0], ht[1] + Vt * dt[1], ht[2] + Vt * dt[2], ht[3] + Vt * dt[3]], ae = [0, 0, 0, 0];
              let Ge = ne;
              Xe = !1;
              let He = 0;
              for (let je = 0; je < T; ++je) {
                if (T > 1) {
                  let we = je - 0.5 * (T - 1);
                  we *= M, ae[0] = ne[0] + we * Wt[0], ae[1] = ne[1] + we * Wt[1], ae[2] = ne[2] + we * Wt[2], ae[3] = ne[3] + we * Wt[3], Ge = ae;
                }
                if (N) {
                  const we = 1 / Ge[3];
                  Ge[0] *= we, Ge[1] *= we, Ge[2] *= we;
                }
                if (s !== null) {
                  const we = t.interpolator.getOrigin(), ln = t.interpolator.getSpacing(), Ls = [1 / ln[0], 1 / ln[1], 1 / ln[2]];
                  i.applyTransform(s, Ge, we, Ls);
                }
                if (t.interpolator.checkBoundsIJK(Ge)) {
                  Xe = 1, t.interpolator.interpolateIJK(Ge, he);
                  for (let we = 0; we < X; ++we)
                    At[He++] = he[we];
                }
              }
              He > X && nt(At, X, He / X);
              for (let je = 0; je < X; ++je)
                Rt[$t++] = At[je];
              fe = Vt > ee ? fe : Xe;
            }
            const Bt = Vt - 1 - (Xe !== fe) - Se + 1;
            let Kt = 0;
            fe ? ($ && i.rescaleScalars(Gt, X, yt - ee + 1, t.scalarShift, t.scalarScale), Kt = D(Xt, Gt.subarray(Se * X), at, Bt)) : Kt = q(Xt, Tt, at, Bt);
            for (let ne = 0; ne < Kt; ++ne)
              mt[wt++] = Xt[ne];
            Se += Bt, fe = Xe;
          }
        }
      } else {
        const Dt = q(Xt, Tt, at, ue);
        for (let ee = 0; ee < Dt; ++ee)
          mt[wt++] = Xt[ee];
      }
    }
  }, i.getIndexMatrix = (p, m) => {
    const b = ut.identity(new Float64Array(16));
    s = null, t.resliceAxes && ut.copy(b, t.resliceAxes), t.resliceTransform && (t.resliceTransform.isA("vtkHomogeneousTransform") ? ut.multiply(b, t.resliceTransform.getMatrix(), b) : SG("Non homogeneous transform have not yet been ported"));
    const y = m.getIndexToWorld();
    if (ut.multiply(b, b, y), s == null) {
      const Z = p.getWorldToIndex();
      ut.multiply(b, Z, b);
    }
    return ut.copy(n, b), n;
  }, i.getAutoCroppedOutputBounds = (p) => {
    const m = p.getOrigin(), b = p.getSpacing(), y = p.getDirection(), Z = p.getDimensions(), g = [0, Z[0] - 1, 0, Z[1] - 1, 0, Z[2] - 1], f = new Float64Array(16);
    t.resliceAxes ? ut.invert(f, t.resliceAxes) : ut.identity(f);
    let T = null;
    t.resliceTransform && (T = t.resliceTransform.getInverse());
    let M = null;
    Hn.isIdentity3x3(y) || (M = il.buildFromRadian().translate(m[0], m[1], m[2]).multiply3x3(y).translate(-m[0], -m[1], -m[2]).invert().getMatrix());
    const N = [Number.MAX_VALUE, -Number.MAX_VALUE, Number.MAX_VALUE, -Number.MAX_VALUE, Number.MAX_VALUE, -Number.MAX_VALUE], W = [0, 0, 0, 0];
    for (let x = 0; x < 8; ++x) {
      W[0] = m[0] + g[x % 2] * b[0], W[1] = m[1] + g[2 + Math.floor(x / 2) % 2] * b[1], W[2] = m[2] + g[4 + Math.floor(x / 4) % 2] * b[2], W[3] = 1, M && zn.transformMat4(W, W, M), t.resliceTransform && T.transformPoint(W, W), zn.transformMat4(W, W, f);
      const V = 1 / W[3];
      W[0] *= V, W[1] *= V, W[2] *= V;
      for (let X = 0; X < 3; ++X)
        W[X] > N[2 * X + 1] && (N[2 * X + 1] = W[X]), W[X] < N[2 * X] && (N[2 * X] = W[X]);
    }
    return N;
  }, i.getDataTypeMinMax = (p) => {
    switch (p) {
      case "Int8Array":
        return {
          min: -128,
          max: 127
        };
      case "Int16Array":
        return {
          min: -32768,
          max: 32767
        };
      case "Uint16Array":
        return {
          min: 0,
          max: 65535
        };
      case "Int32Array":
        return {
          min: -2147483648,
          max: 2147483647
        };
      case "Uint32Array":
        return {
          min: 0,
          max: 4294967295
        };
      case "Float32Array":
        return {
          min: -12e37,
          max: 12e37
        };
      case "Float64Array":
        return {
          min: -12e37,
          max: 12e37
        };
      case "Uint8Array":
      case "Uint8ClampedArray":
      default:
        return {
          min: 0,
          max: 255
        };
    }
  }, i.clamp = (p, m, b, y, Z, g) => {
    const f = y * b;
    for (let T = 0; T < f; ++T)
      p[T] = hl(m[T], Z, g);
    return f;
  }, i.convert = (p, m, b, y) => {
    const Z = y * b;
    for (let g = 0; g < Z; ++g)
      p[g] = Math.round(m[g]);
    return Z;
  }, i.getConversionFunc = (p, m, b, y, Z) => {
    let g = Z;
    if (m !== Ke.FLOAT && m !== Ke.DOUBLE && !Z) {
      const f = i.getDataTypeMinMax(p);
      let T = (f.min + b) * y, M = (f.max + b) * y;
      const N = i.getDataTypeMinMax(m), W = N.min, x = N.max;
      if (T > M) {
        const V = M;
        M = T, T = V;
      }
      g = T < W || M > x;
    }
    if (g && m !== Ke.FLOAT && m !== Ke.DOUBLE) {
      const f = i.getDataTypeMinMax(m);
      return (M, N, W, x) => i.clamp(M, N, W, x, f.min, f.max);
    }
    return i.convert;
  }, i.set = (p, m, b, y) => {
    const Z = b * y;
    for (let g = 0; g < y; ++g)
      p[g] = m[g];
    return Z;
  }, i.set1 = (p, m, b, y) => (p.fill(m[0], 0, y), y), i.getSetPixelsFunc = (p, m, b, y) => b === 1 ? i.set1 : i.set, i.getCompositeFunc = (p, m) => {
    let b = null;
    switch (p) {
      case ab.MIN:
        b = o;
        break;
      case ab.MAX:
        b = l;
        break;
      case ab.MEAN:
        m ? b = u : b = c;
        break;
      case ab.SUM:
        m ? b = h : b = d;
        break;
    }
    return b;
  }, i.applyTransform = (p, m, b, y) => {
    m[3] = 1, zn.transformMat4(m, m, p), m[0] -= b[0], m[1] -= b[1], m[2] -= b[2], m[0] *= y[0], m[1] *= y[1], m[2] *= y[2];
  }, i.rescaleScalars = (p, m, b, y, Z) => {
    const g = b * m;
    for (let f = 0; f < g; ++f)
      p[f] = (p[f] + y) * Z;
  }, i.isPermutationMatrix = (p) => {
    for (let m = 0; m < 3; m++)
      if (p[4 * m + 3] !== 0)
        return !1;
    if (p[15] !== 1)
      return !1;
    for (let m = 0; m < 3; m++) {
      let b = 0;
      for (let y = 0; y < 3; y++)
        p[4 * m + y] !== 0 && b++;
      if (b !== 1)
        return !1;
    }
    return !0;
  }, i.isIdentityMatrix = (p) => {
    for (let m = 0; m < 4; ++m)
      for (let b = 0; b < 4; ++b)
        if ((m === b ? 1 : 0) !== p[4 * b + m])
          return !1;
    return !0;
  }, i.isPerspectiveMatrix = (p) => p[3] !== 0 || p[7] !== 0 || p[11] !== 0 || p[15] !== 1, i.canUseNearestNeighbor = (p, m) => {
    for (let b = 0; b < 3; b++) {
      let y;
      for (y = 0; y < 3 && p[4 * y + b] === 0; y++)
        ;
      if (y >= 3)
        return !1;
      let Z = p[4 * y + b], g = p[12 + b];
      m[2 * y] === m[2 * y + 1] && (g += Z * m[2 * b], Z = 0);
      const f = Tb(Z).error, T = Tb(g).error;
      if (f !== 0 || T !== 0)
        return !1;
    }
    return !0;
  };
}
const Jdt = {
  transformInputSampling: !0,
  autoCropOutput: !1,
  outputDimensionality: 3,
  outputSpacing: null,
  // automatically computed if null
  outputOrigin: null,
  // automatically computed if null
  outputDirection: null,
  // identity if null
  outputExtent: null,
  // automatically computed if null
  outputScalarType: null,
  wrap: !1,
  // don't wrap
  mirror: !1,
  // don't mirror
  border: !0,
  // apply a border
  interpolationMode: zi.NEAREST,
  // only NEAREST supported so far
  slabMode: ab.MIN,
  slabTrapezoidIntegration: !1,
  slabNumberOfSlices: 1,
  slabSliceSpacingFraction: 1,
  optimization: !1,
  // not supported yet
  scalarShift: 0,
  // for rescaling the data
  scalarScale: 1,
  backgroundColor: [0, 0, 0, 0],
  resliceAxes: null,
  // resliceTransform: null,
  interpolator: zdt.newInstance(),
  usePermuteExecute: !1
  // no supported yet
};
function NU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Jdt, e), tt.obj(i, t), tt.algo(i, t, 1, 1), tt.setGet(i, t, ["outputDimensionality", "outputScalarType", "scalarShift", "scalarScale", "transformInputSampling", "autoCropOutput", "wrap", "mirror", "border", "interpolationMode", "resliceTransform", "slabMode", "slabTrapezoidIntegration", "slabNumberOfSlices", "slabSliceSpacingFraction"]), tt.setGetArray(i, t, ["outputOrigin", "outputSpacing"], 3), tt.setGetArray(i, t, ["outputExtent"], 6), tt.setGetArray(i, t, ["outputDirection"], 9), tt.setGetArray(i, t, ["backgroundColor"], 4), tt.get(i, t, ["resliceAxes"]), Pdt(i, t);
}
const Adt = tt.newInstance(NU, "vtkImageReslice");
var ob = {
  newInstance: Adt,
  extend: NU,
  ...MU
};
const Ce = {
  fullscreen: { xmin: 0, ymin: 0, xmax: 1, ymax: 1 },
  bottomLeft: { xmin: 0, ymin: 0, xmax: 0.5, ymax: 0.5 },
  bottomRight: { xmin: 0.5, ymin: 0, xmax: 1, ymax: 0.5 },
  topLeft: { xmin: 0, ymin: 0.5, xmax: 0.5, ymax: 1 },
  topRight: { xmin: 0.5, ymin: 0.5, xmax: 1, ymax: 1 },
  left: { xmin: 0, ymin: 0, xmax: 0.5, ymax: 1 },
  right: { xmin: 0.5, ymin: 0, xmax: 1, ymax: 1 },
  bottomRight3: { xmin: 0.5, ymin: 0, xmax: 1, ymax: 1 / 3 },
  middleRight3: { xmin: 0.5, ymin: 1 / 3, xmax: 1, ymax: 2 / 3 },
  topRight3: { xmin: 0.5, ymin: 2 / 3, xmax: 1, ymax: 1 },
  topRight31: { xmin: 2 / 3, ymin: 0.5, xmax: 1, ymax: 1 },
  topMiddle31: { xmin: 1 / 3, ymin: 0.5, xmax: 2 / 3, ymax: 1 },
  topLeft31: { xmin: 0, ymin: 0.5, xmax: 1 / 3, ymax: 1 },
  left23: { xmin: 0, ymin: 0, xmax: 2 / 3, ymax: 1 },
  bottomRight1313: { xmin: 2 / 3, ymin: 0, xmax: 1, ymax: 1 / 3 },
  middleRight1313: { xmin: 2 / 3, ymin: 1 / 3, xmax: 1, ymax: 2 / 3 },
  topRight1313: { xmin: 2 / 3, ymin: 2 / 3, xmax: 1, ymax: 1 },
  // 1/3 width, 1/2 height
  topRight1312: { xmin: 2 / 3, ymin: 1 / 2, xmax: 1, ymax: 1 },
  // 1/3 width, 1/2 height
  bottomRight1312: { xmin: 2 / 3, ymin: 0, xmax: 1, ymax: 1 / 2 },
  // 1/4 width, 1/2 heigth
  centerPreview: { xmin: 0.4, ymin: 0, xmax: 2 / 3, ymax: 1 },
  topRightPreview: { xmin: 2 / 3, ymin: 1 / 2, xmax: 1, ymax: 1 },
  bottomRightPreview: { xmin: 2 / 3, ymin: 0, xmax: 1, ymax: 1 / 2 },
  // 1/3 width, 1/2 height
  bottomMiddle1312: { xmin: 1 / 3, ymin: 0, xmax: 2 / 3, ymax: 1 / 2 },
  // 1/3 width, 1/2 height
  bottomLeft1312: { xmin: 0, ymin: 0, xmax: 1 / 3, ymax: 1 / 2 },
  // 2/3 width, 2/3 height
  topLeft2323: { xmin: 0, ymin: 1 / 3, xmax: 2 / 3, ymax: 1 },
  // 1/2 width, 2/3 height
  topLeft1223: { xmin: 0, ymin: 1 / 3, xmax: 1 / 2, ymax: 1 },
  topRight1223: { xmin: 1 / 2, ymin: 1 / 3, xmax: 1, ymax: 1 },
  // 2/3 width, 1/3 height
  bottomLeft2313: { xmin: 0, ymin: 0, xmax: 2 / 3, ymax: 1 / 3 },
  top: { xmin: 0, ymin: 0.5, xmax: 1, ymax: 1 },
  bottom: { xmin: 0, ymin: 0, xmax: 1, ymax: 0.5 },
  top13: { xmin: 0, ymin: 2 / 3, xmax: 1, ymax: 1 },
  hmiddle13: { xmin: 0, ymin: 1 / 3, xmax: 1, ymax: 2 / 3 },
  bottom13: { xmin: 0, ymin: 0, xmax: 1, ymax: 1 / 3 },
  left13: { xmin: 0, ymin: 0, xmax: 1 / 3, ymax: 1 },
  vmiddle13: { xmin: 1 / 3, ymin: 0, xmax: 2 / 3, ymax: 1 },
  right13: { xmin: 2 / 3, ymin: 0, xmax: 1, ymax: 1 }
};
function _I(i, t) {
  const { x: e, y: n, w: s, h: r } = t, a = i[0], o = i[1];
  return {
    xmin: e / a,
    ymin: (o - n - r - 1) / o,
    xmax: (e + s) / a,
    ymax: (o - n - 1) / o
  };
}
function Bdt(i, t) {
  const e = i[0], n = i[1];
  return {
    x: t.xmin * e,
    y: (1 - t.ymax) * n,
    w: (t.xmax - t.xmin) * e,
    h: (t.ymax - t.ymin) * n
  };
}
function Kdt(i, t) {
  t.classHierarchy.push("vtkSphereSource"), i.requestData = (e, n) => {
    if (t.deleted)
      return;
    let s = n[0];
    const r = s ? s.getPoints().getDataType() : t.pointType;
    s = Ie.newInstance();
    let a = 0, {
      thetaResolution: o
    } = t, l = t.startTheta < t.endTheta ? t.startTheta : t.endTheta;
    l *= Math.PI / 180;
    let c = t.endTheta > t.startTheta ? t.endTheta : t.startTheta;
    c *= Math.PI / 180;
    let u = t.startPhi < t.endPhi ? t.startPhi : t.endPhi;
    u *= Math.PI / 180;
    let d = t.endPhi > t.startPhi ? t.endPhi : t.startPhi;
    d *= Math.PI / 180, Math.abs(l - c) < 2 * Math.PI && ++o;
    const h = (c - l) / t.thetaResolution, p = t.startPhi <= 0 ? 1 : 0, m = t.phiResolution + (t.endPhi >= 180 ? -1 : 0), b = t.phiResolution * o + 2, y = t.phiResolution * 2 * t.thetaResolution;
    let Z = 0, g = tt.newTypedArray(r, b * 3), f = new Float32Array(b * 3), T = 0, M = new Uint32Array(y * 5);
    t.startPhi <= 0 && (g[Z * 3 + 0] = t.center[0], g[Z * 3 + 1] = t.center[1], g[Z * 3 + 2] = t.center[2] + t.radius, f[Z * 3 + 0] = 0, f[Z * 3 + 1] = 0, f[Z * 3 + 2] = 1, Z++, a++), t.endPhi >= 180 && (g[Z * 3 + 0] = t.center[0], g[Z * 3 + 1] = t.center[1], g[Z * 3 + 2] = t.center[2] - t.radius, f[Z * 3 + 0] = 0, f[Z * 3 + 1] = 0, f[Z * 3 + 2] = -1, Z++, a++);
    const N = t.phiResolution - a, W = (d - u) / (t.phiResolution - 1);
    for (let X = 0; X < o; X++) {
      const C = l + X * h;
      for (let R = p; R < m; R++) {
        const z = u + R * W, F = t.radius * Math.sin(z);
        f[Z * 3 + 0] = F * Math.cos(C), f[Z * 3 + 1] = F * Math.sin(C), f[Z * 3 + 2] = t.radius * Math.cos(z), g[Z * 3 + 0] = f[Z * 3 + 0] + t.center[0], g[Z * 3 + 1] = f[Z * 3 + 1] + t.center[1], g[Z * 3 + 2] = f[Z * 3 + 2] + t.center[2];
        let P = Math.sqrt(f[Z * 3 + 0] * f[Z * 3 + 0] + f[Z * 3 + 1] * f[Z * 3 + 1] + f[Z * 3 + 2] * f[Z * 3 + 2]);
        P = P === 0 ? 1 : P, f[Z * 3 + 0] /= P, f[Z * 3 + 1] /= P, f[Z * 3 + 2] /= P, Z++;
      }
    }
    const x = N * o;
    if (Math.abs(l - c) < 2 * Math.PI && --o, t.startPhi <= 0)
      for (let X = 0; X < o; X++)
        M[T++] = 3, M[T++] = N * X + a, M[T++] = N * (X + 1) % x + a, M[T++] = 0;
    if (t.endPhi >= 180) {
      const X = N - 1 + a;
      for (let C = 0; C < o; C++)
        M[T++] = 3, M[T++] = N * C + X, M[T++] = a - 1, M[T++] = N * (C + 1) % x + X;
    }
    for (let X = 0; X < o; X++)
      for (let C = 0; C < N - 1; C++) {
        const R = N * X + C + a, z = R + 1, F = (N * (X + 1) + C) % x + a + 1;
        t.latLongTessellation ? (M[T++] = 4, M[T++] = R, M[T++] = z, M[T++] = F, M[T++] = F - 1) : (M[T++] = 3, M[T++] = R, M[T++] = z, M[T++] = F, M[T++] = 3, M[T++] = R, M[T++] = F, M[T++] = F - 1);
      }
    g = g.subarray(0, Z * 3), s.getPoints().setData(g, 3), f = f.subarray(0, Z * 3);
    const V = We.newInstance({
      name: "Normals",
      values: f,
      numberOfComponents: 3
    });
    s.getPointData().setNormals(V), M = M.subarray(0, T), s.getPolys().setData(M, 1), n[0] = s;
  };
}
const Hdt = {
  radius: 0.5,
  latLongTessellation: !1,
  thetaResolution: 8,
  startTheta: 0,
  endTheta: 360,
  phiResolution: 8,
  startPhi: 0,
  endPhi: 180,
  center: [0, 0, 0],
  pointType: "Float64Array"
};
function WU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Hdt, e), tt.obj(i, t), tt.setGet(i, t, ["radius", "latLongTessellation", "thetaResolution", "startTheta", "endTheta", "phiResolution", "startPhi", "endPhi"]), tt.setGetArray(i, t, ["center"], 3), tt.algo(i, t, 0, 1), Kdt(i, t);
}
const _dt = tt.newInstance(WU, "vtkSphereSource");
var sp = {
  newInstance: _dt,
  extend: WU
};
function Qdt(i, t) {
  t.classHierarchy.push("vtkAbstractPicker"), i.initialize = () => {
    t.renderer = null, t.selectionPoint[0] = 0, t.selectionPoint[1] = 0, t.selectionPoint[2] = 0, t.pickPosition[0] = 0, t.pickPosition[1] = 0, t.pickPosition[2] = 0;
  }, i.initializePickList = () => {
    t.pickList = [];
  }, i.addPickList = (e) => {
    t.pickList.push(e);
  }, i.deletePickList = (e) => {
    const n = t.pickList.indexOf(e);
    n !== -1 && t.pickList.splice(n, 1);
  };
}
const $dt = {
  renderer: null,
  selectionPoint: [0, 0, 0],
  pickPosition: [0, 0, 0],
  pickFromList: 0,
  pickList: []
};
function GU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, $dt, e), tt.obj(i, t), tt.get(i, t, ["renderer"]), tt.getArray(i, t, ["selectionPoint", "pickPosition"]), tt.setGet(i, t, ["pickFromList", "pickList"]), Qdt(i, t);
}
const qdt = tt.newInstance(GU, "vtkAbstractPicker");
var tht = {
  newInstance: qdt,
  extend: GU
};
const {
  vtkErrorMacro: eht
} = tt, {
  vtkWarningMacro: bM
} = tt;
function nht(i, t) {
  t.classHierarchy.push("vtkPicker");
  const e = {
    ...i
  };
  function n() {
    e.initialize(), t.actors = [], t.pickedPositions = [], t.mapperPosition[0] = 0, t.mapperPosition[1] = 0, t.mapperPosition[2] = 0, t.mapper = null, t.dataSet = null, t.globalTMin = Number.MAX_VALUE;
  }
  function s(a, o, l) {
    let c = 0;
    const u = l.getRenderWindow().getViews()[0], d = l.getViewport(), h = u.getSize();
    let p = h[0] * d[0], m = h[1] * d[1];
    const b = u.displayToNormalizedDisplay(p, m, a), y = l.normalizedDisplayToWorld(b[0], b[1], b[2], o);
    p = h[0] * d[2], m = h[1] * d[3];
    const Z = u.displayToNormalizedDisplay(p, m, a), g = l.normalizedDisplayToWorld(Z[0], Z[1], Z[2], o);
    for (let f = 0; f < 3; f++)
      c += (g[f] - y[f]) * (g[f] - y[f]);
    return Math.sqrt(c);
  }
  function r(a, o, l, c) {
    const u = new Float64Array(4), d = new Float64Array(4), h = [], p = [], m = t.pickFromList ? t.pickList : a.getActors(), b = new Float64Array(3), y = new Float64Array(3);
    m.forEach((g) => {
      var W, x, V;
      const f = g.getMapper(), T = ((V = (W = g.getProperty) == null ? void 0 : (x = W.call(g)).getOpacity) == null ? void 0 : V.call(x)) === 0;
      if (!(g.getNestedPickable() && g.getNestedVisibility() && !T))
        return;
      t.transformMatrix = g.getMatrix().slice(0), ut.transpose(t.transformMatrix, t.transformMatrix), ut.invert(t.transformMatrix, t.transformMatrix), zn.transformMat4(u, l, t.transformMatrix), zn.transformMat4(d, c, t.transformMatrix), I.scale(u, u, 1 / u[3]), I.scale(d, d, 1 / d[3]), fi(d, u, h);
      const N = f ? qe.inflate(f.getBounds(), o) : [...qe.INIT_BOUNDS];
      if (qe.intersectBox(N, u, h, p, [])) {
        ut.getScaling(b, t.transformMatrix);
        const X = t.intersectWithLine(u, d, o * 0.333 * (b[0] + b[1] + b[2]), g, f);
        if (X < Number.MAX_VALUE) {
          y[0] = (1 - X) * l[0] + X * c[0], y[1] = (1 - X) * l[1] + X * c[1], y[2] = (1 - X) * l[2] + X * c[2];
          const C = t.actors.indexOf(g);
          if (C !== -1) {
            const R = t.pickedPositions[C];
            zs(l, y) < zs(l, R) && (t.pickedPositions[C] = y.slice(0));
          } else
            t.actors.push(g), t.pickedPositions.push(y.slice(0));
        }
      }
    });
    const Z = [];
    for (let g = 0; g < t.pickedPositions.length; g++)
      Z.push({
        actor: t.actors[g],
        pickedPosition: t.pickedPositions[g],
        distance2: zs(l, t.pickedPositions[g])
      });
    Z.sort((g, f) => {
      const T = g.distance2, M = f.distance2;
      return T < M ? -1 : T > M ? 1 : 0;
    }), t.pickedPositions = [], t.actors = [], Z.forEach((g) => {
      t.pickedPositions.push(g.pickedPosition), t.actors.push(g.actor);
    });
  }
  t.intersectWithLine = (a, o, l, c, u) => {
    if (!u)
      return Number.MAX_VALUE;
    const d = u.getCenter(), h = I.subtract(new Float64Array(3), o, a), p = tn(h, h);
    return p === 0 ? 2 : (h[0] * (d[0] - a[0]) + h[1] * (d[1] - a[1]) + h[2] * (d[2] - a[2])) / p;
  }, i.pick = (a, o) => {
    if (a.length !== 3 && bM("vtkPicker.pick - selection needs three components"), !o)
      throw eht("vtkPicker.pick - renderer cannot be null"), new Error("renderer cannot be null");
    n();
    const l = a[0], c = a[1];
    let u = a[2];
    t.renderer = o, t.selectionPoint[0] = l, t.selectionPoint[1] = c, t.selectionPoint[2] = u;
    const d = new Float64Array(4), h = new Float64Array(4), p = o.getActiveCamera(), m = p.getPosition(), b = p.getFocalPoint(), y = o.getRenderWindow().getViews()[0], Z = y.getViewportSize(o);
    if (Z[1] === 0) {
      bM("vtkPicker.pick - viewport area is 0");
      return;
    }
    const g = Z[0] / Z[1];
    let f = [];
    f = o.worldToNormalizedDisplay(b[0], b[1], b[2], g), f = y.normalizedDisplayToDisplay(f[0], f[1], f[2]), u = f[2];
    const T = y.displayToNormalizedDisplay(l, c, u), M = o.normalizedDisplayToWorld(T[0], T[1], T[2], g);
    for (let z = 0; z < 3; z++)
      t.pickPosition[z] = M[z];
    const N = [];
    for (let z = 0; z < 3; z++)
      N[z] = t.pickPosition[z] - m[z];
    const W = [];
    for (let z = 0; z < 3; z++)
      W[z] = b[z] - m[z];
    Fn(W);
    const x = tn(W, N);
    if (x === 0) {
      bM("Picker::Pick Cannot process points");
      return;
    }
    const V = p.getClippingRange();
    let X, C;
    if (p.getParallelProjection()) {
      X = V[0] - x, C = V[1] - x;
      for (let z = 0; z < 3; z++)
        d[z] = t.pickPosition[z] + X * W[z], h[z] = t.pickPosition[z] + C * W[z];
    } else {
      X = V[0] / x, C = V[1] / x;
      for (let z = 0; z < 3; z++)
        d[z] = m[z] + X * N[z], h[z] = m[z] + C * N[z];
    }
    d[3] = 1, h[3] = 1;
    const R = s(u, g, o) * t.tolerance;
    r(t.renderer, R, d, h);
  }, i.pick3DPoint = (a, o, l) => {
    if (!l)
      throw new Error("renderer cannot be null");
    n(), t.renderer = l, I.copy(t.selectionPoint, a);
    const u = l.getRenderWindow().getViews()[0].getViewportSize(l);
    if (u[1] === 0) {
      bM("vtkPicker.pick3DPoint - viewport area is 0");
      return;
    }
    const d = u[0] / u[1], h = s(t.selectionPoint[2], d, l) * t.tolerance;
    r(l, h, a, o);
  };
}
const iht = {
  tolerance: 0.025,
  mapperPosition: [0, 0, 0],
  mapper: null,
  dataSet: null,
  actors: [],
  pickedPositions: [],
  transformMatrix: null,
  globalTMin: Number.MAX_VALUE
};
function wU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, iht, e), tht.extend(i, t, e), tt.setGet(i, t, ["tolerance"]), tt.setGetArray(i, t, ["mapperPosition"], 3), tt.get(i, t, ["mapper", "dataSet", "actors", "pickedPositions"]), tt.event(i, t, "pickChange"), nht(i, t);
}
const sht = tt.newInstance(wU, "vtkPicker");
var rht = {
  newInstance: sht,
  extend: wU
};
function aht(i, t) {
  t.classHierarchy.push("vtkPolyLine");
  const e = Vr.newInstance();
  e.getPoints().setNumberOfPoints(2), i.getCellDimension = () => 1, i.intersectWithLine = (n, s, r, a, o, l, c) => {
    const u = {
      intersect: 0,
      t: Number.MAX_VALUE,
      subId: 0,
      betweenPoints: null
    }, d = i.getNumberOfPoints() - 1;
    let h = Number.MAX_VALUE;
    for (let p = 0; p < d; p++) {
      const m = [0, 0, 0];
      e.getPoints().getData().set(t.points.getData().subarray(3 * p, 3 * (p + 2)));
      const b = e.intersectWithLine(r, a, o, l, c);
      if (b.intersect === 1 && b.t <= u.t + o && b.t >= n && b.t <= s) {
        u.intersect = 1;
        const y = e.getParametricDistance(m);
        (y < h || y === h && b.t < u.t) && (u.subId = p, u.t = b.t, h = y);
      }
    }
    return u;
  }, i.evaluateLocation = (n, s, r, a) => (e.getPoints().getData().set(t.points.getData().subarray(3 * n, 3 * (n + 2))), e.evaluateLocation(s, r, a)), i.evaluateOrientation = (n, s, r, a) => (t.orientations ? e.setOrientations([t.orientations[n], t.orientations[n + 1]]) : e.setOrientations(null), e.evaluateOrientation(s, r, a)), i.getDistancesToFirstPoint = () => {
    const n = t.distancesTime.getMTime();
    if (n < t.points.getMTime() || n < i.getMTime()) {
      const s = i.getNumberOfPoints();
      if (t.distances ? t.distances.length = s : t.distances = new Array(s), s > 0) {
        const r = new Array(3), a = new Array(3);
        let o = 0;
        t.distances[0] = o, t.points.getPoint(0, r);
        for (let l = 1; l < s; ++l)
          t.points.getPoint(l, a), o += t.distanceFunction(r, a), t.distances[l] = o, I.copy(r, a);
      }
      t.distancesTime.modified();
    }
    return t.distances;
  }, i.findPointIdAtDistanceFromFirstPoint = (n) => {
    const s = i.getDistancesToFirstPoint();
    if (s.length < 2)
      return -1;
    let r = 0, a = s.length - 1;
    if (n < s[r] || n > s[a] || s[a] === 0)
      return -1;
    for (; a - r > 1; ) {
      const o = Math.floor((r + a) / 2);
      s[o] <= n ? r = o : a = o;
    }
    return r;
  };
}
const oht = {
  orientations: null,
  // an array of quat or null
  distanceFunction: I.dist
};
function xU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, oht, e), mg.extend(i, t, e), tt.setGet(i, t, ["orientations", "distanceFunction"]), t.distancesTime = {}, tt.obj(t.distancesTime, {
    mtime: 0
  }), aht(i, t);
}
const lht = tt.newInstance(xU, "vtkPolyLine");
var cht = {
  newInstance: lht,
  extend: xU
};
function YO() {
  return {
    intersected: !1,
    subId: -1,
    x: [0, 0, 0],
    pCoords: [0, 0, 0],
    t: -1
  };
}
function uht(i, t) {
  t.classHierarchy.push("vtkQuad"), i.getCellDimension = () => 2, i.getCellType = () => ei.VTK_QUAD, i.getNumberOfEdges = () => 4, i.getNumberOfFaces = () => 0, i.intersectWithLine = (e, n, s, r, a) => {
    let o = {
      subId: 0,
      t: Number.MAX_VALUE,
      intersect: 0,
      betweenPoints: !1
    }, l;
    const c = t.points.getPoint(0, []), u = t.points.getPoint(1, []), d = t.points.getPoint(2, []), h = t.points.getPoint(3, []), p = zs(c, d), m = zs(u, h);
    if (p === m) {
      let N, W = 0, x = 0;
      for (let V = 0; V < 4; V++)
        N = t.pointsIds[V], N > W && (W = N, x = V);
      x === 0 || x === 2 ? l = 0 : l = 1;
    } else p < m ? l = 0 : l = 1;
    let b = null;
    t.triangle ? b = t.triangle.getPoints() : (t.triangle = xI.newInstance(), b = yi.newInstance(), b.setNumberOfPoints(3), t.triangle.initialize(b));
    let y;
    const Z = YO();
    let g;
    const f = YO();
    let T, M;
    switch (l) {
      case 0:
        b.setPoint(0, ...c), b.setPoint(1, ...u), b.setPoint(2, ...d), y = t.triangle.intersectWithLine(e, n, s, Z.x, Z.pCoords), b.setPoint(0, ...d), b.setPoint(1, ...h), b.setPoint(2, ...c), g = t.triangle.intersectWithLine(e, n, s, f.x, f.pCoords), T = y.intersect && g.intersect ? y.t <= g.t : y.intersect, M = y.intersect && g.intersect ? g.t < y.t : g.intersect, T ? (o = y, r[0] = Z.x[0], r[1] = Z.x[1], r[2] = Z.x[2], a[0] = Z.pCoords[0] + Z.pCoords[1], a[1] = Z.pCoords[1], a[2] = Z.pCoords[2]) : M && (o = g, r[0] = f.x[0], r[1] = f.x[1], r[2] = f.x[2], a[0] = 1 - (f.pCoords[0] + f.pCoords[1]), a[1] = 1 - f.pCoords[1], a[2] = f.pCoords[2]);
        break;
      case 1:
        b.setPoint(0, ...c), b.setPoint(1, ...u), b.setPoint(2, ...h), y = t.triangle.intersectWithLine(e, n, s, Z.x, Z.pCoords), b.setPoint(0, ...d), b.setPoint(1, ...h), b.setPoint(2, ...u), g = t.triangle.intersectWithLine(e, n, s, f.x, f.pCoords), T = y.intersect && g.intersect ? y.t <= g.t : y.intersect, M = y.intersect && g.intersect ? g.t < y.t : g.intersect, T ? (o = y, r[0] = Z.x[0], r[1] = Z.x[1], r[2] = Z.x[2], a[0] = Z.pCoords[0], a[1] = Z.pCoords[1], a[2] = Z.pCoords[2]) : M && (o = g, r[0] = f.x[0], r[1] = f.x[1], r[2] = f.x[2], a[0] = 1 - f.pCoords[0], a[1] = 1 - f.pCoords[1], a[2] = f.pCoords[2]);
        break;
    }
    return o;
  }, i.interpolationFunctions = (e, n) => {
    const s = 1 - e[0], r = 1 - e[1];
    n[0] = s * r, n[1] = e[0] * r, n[2] = e[0] * e[1], n[3] = s * e[1];
  }, i.evaluateLocation = (e, n, s) => {
    const r = [];
    i.interpolationFunctions(e, s), n[0] = 0, n[1] = 0, n[2] = 0;
    for (let a = 0; a < 4; a++) {
      t.points.getPoint(a, r);
      for (let o = 0; o < 3; o++)
        n[o] += r[o] * s[a];
    }
  };
}
const dht = {};
function SU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, dht, e), mg.extend(i, t, e), uht(i, t);
}
const hht = tt.newInstance(SU, "vtkQuad");
var pht = {
  newInstance: hht,
  extend: SU
};
function LU(i, t, e) {
  let n = -1, s = -1, r = 0, a = 1;
  for (let d = 0; d < 3; d++)
    for (let h = 0; h < 2; h++) {
      const p = 2 * d + h, m = (i[p] - t[d]) * (1 - 2 * h), b = (i[p] - e[d]) * (1 - 2 * h);
      if (m > 0 && b > 0)
        return;
      if (m > 0 || b > 0) {
        let y = 0;
        if (m !== 0 && (y = m / (m - b)), m > 0 ? y >= r && (r = y, n = p) : y <= a && (a = y, s = p), r > a && (n < 0 || s < 0))
          return;
      }
    }
  function o(d, h) {
    const p = [0, 0, 0];
    for (let m = 0; m < 2; m++)
      for (let b = 0; b < 3; b++)
        d === 2 * b || d === 2 * b + 1 ? p[b] = i[d] : (p[b] = t[b] * (1 - h) + e[b] * h, p[b] < i[2 * b] && (p[b] = i[2 * b]), p[b] > i[2 * b + 1] && (p[b] = i[2 * b + 1]));
    return p;
  }
  const l = o(n, r), c = o(s, a);
  return {
    t1: r,
    t2: a,
    x1: l,
    x2: c
  };
}
const mht = {};
function bht(i, t) {
  t.classHierarchy.push("vtkBox"), i.setBounds = function() {
    let e = [];
    for (var n = arguments.length, s = new Array(n), r = 0; r < n; r++)
      s[r] = arguments[r];
    if (Array.isArray(s[0]))
      e = s[0];
    else
      for (let a = 0; a < s.length; a++)
        e.push(s[a]);
    if (e.length !== 6) {
      console.log("vtkBox.setBounds", e, s);
      return;
    }
    qe.setBounds(t.bbox, e);
  }, i.getBounds = () => t.bbox, i.evaluateFunction = (e, n, s) => {
    const r = Array.isArray(e) ? e : [e, n, s];
    let a, o, l, c = -Number.MAX_VALUE, u = 0;
    const d = qe.getMinPoint(t.bbox), h = qe.getMaxPoint(t.bbox);
    let p = 1;
    for (let m = 0; m < 3; m++)
      a = qe.getLength(t.bbox, m), a !== 0 ? (l = (r[m] - d[m]) / a, l < 0 ? (p = 0, o = d[m] - r[m]) : l > 1 ? (p = 0, o = r[m] - h[m]) : (l <= 0.5 ? o = d[m] - r[m] : o = r[m] - h[m], o > c && (c = o))) : (o = Math.abs(r[m] - d[m]), o > 0 && (p = 0)), o > 0 && (u += o * o);
    return u = Math.sqrt(u), p ? c : u;
  }, i.addBounds = function() {
    let e = [];
    if (Array.isArray(arguments.length <= 0 ? void 0 : arguments[0]))
      e = arguments.length <= 0 ? void 0 : arguments[0];
    else
      for (let n = 0; n < arguments.length; n++)
        e.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    e.length === 6 && (qe.addBounds(t.bbox, ...e), i.modified());
  }, i.addBox = (e) => i.addBounds(e.getBounds()), i.intersectWithLine = (e, n) => LU(t.bbox, e, n);
}
const fht = {
  bbox: [...qe.INIT_BOUNDS]
};
function VU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, fht, e), tt.obj(i, t), bht(i, t);
}
const ght = tt.newInstance(VU, "vtkBox");
var yht = {
  newInstance: ght,
  extend: VU,
  intersectWithLine: LU,
  ...mht
};
function vO() {
  return {
    [ei.VTK_LINE]: Vr.newInstance(),
    [ei.VTK_POLY_LINE]: cht.newInstance(),
    [ei.VTK_TRIANGLE]: xI.newInstance(),
    [ei.VTK_QUAD]: pht.newInstance()
  };
}
function XU(i, t, e, n) {
  const s = {
    planeId: -1,
    t1: 0,
    t2: 1,
    intersect: 0
  }, r = i.getNumberOfClippingPlanes(), a = [];
  for (let o = 0; o < r; o++) {
    i.getClippingPlaneInDataCoords(t, o, a);
    const l = a[0] * e[0] + a[1] * e[1] + a[2] * e[2] + a[3], c = a[0] * n[0] + a[1] * n[1] + a[2] * n[2] + a[3];
    if (l < 0 && c < 0)
      return 0;
    if (l < 0 || c < 0) {
      let u = 0;
      if (l !== 0 && (u = l / (l - c)), l < 0 ? u >= s.t1 && (s.t1 = u, s.planeId = o) : u <= s.t2 && (s.t2 = u), s.t1 > s.t2)
        return s.intersect = 0, s;
    }
  }
  return s.intersect = 1, s;
}
const Zht = {
  clipLineWithPlane: XU
};
function Tht(i, t) {
  t.classHierarchy.push("vtkCellPicker");
  const e = {
    ...i
  };
  function n() {
    t.cellId = -1, t.pCoords[0] = 0, t.pCoords[1] = 0, t.pCoords[2] = 0, t.cellIJK[0] = 0, t.cellIJK[1] = 0, t.cellIJK[2] = 0, t.mapperNormal[0] = 0, t.mapperNormal[1] = 0, t.mapperNormal[2] = 1, t.pickNormal[0] = 0, t.pickNormal[1] = 0, t.pickNormal[2] = 1;
  }
  function s() {
    t.dataSet = null, t.mapper = null, n();
  }
  i.initialize = () => {
    s(), e.initialize();
  }, i.computeSurfaceNormal = (r, a, o, l) => {
    const c = r.getPointData().getNormals();
    if (c) {
      l[0] = 0, l[1] = 0, l[2] = 0;
      const u = [];
      for (let d = 0; d < 3; d++)
        c.getTuple(a.getPointsIds()[d], u), l[0] += u[0] * o[d], l[1] += u[1] * o[d], l[2] += u[2] * o[d];
      Fn(l);
    } else
      return 0;
    return 1;
  }, i.pick = (r, a) => {
    i.initialize();
    const o = e.pick(r, a);
    if (o) {
      const l = a.getActiveCamera(), c = [];
      if (l.getPosition(c), l.getParallelProjection()) {
        const u = [];
        l.getFocalPoint(u), t.pickNormal[0] = c[0] - u[0], t.pickNormal[1] = c[1] - u[1], t.pickNormal[2] = c[2] - u[2];
      } else
        t.pickNormal[0] = c[0] - t.pickPosition[0], t.pickNormal[1] = c[1] - t.pickPosition[1], t.pickNormal[2] = c[2] - t.pickPosition[2];
      Fn(t.pickNormal);
    }
    return o;
  }, t.intersectWithLine = (r, a, o, l, c) => {
    let u = Number.MAX_VALUE, d = 0, h = 1;
    const p = 1e-14, m = XU(c, t.transformMatrix, r, a);
    if (c && !m.intersect)
      return Number.MAX_VALUE;
    if (c.isA("vtkImageMapper") || c.isA("vtkImageArrayMapper")) {
      const b = c.intersectWithLineForCellPicking(r, a);
      b && (u = b.t, t.cellIJK = b.ijk, t.pCoords = b.pCoords);
    } else if (c.isA("vtkVolumeMapper")) {
      const b = yht.intersectWithLine(c.getBounds(), r, a);
      d = (b == null ? void 0 : b.t1) > m.t1 ? b.t1 : m.t1, h = (b == null ? void 0 : b.t2) < m.t2 ? b.t2 : m.t2, u = t.intersectVolumeWithLine(r, a, d, h, o, l);
    } else c.isA("vtkMapper") && (u = t.intersectActorWithLine(r, a, d, h, o, c));
    if (u < t.globalTMin) {
      if (t.globalTMin = u, Math.abs(u - d) < p && m.clippingPlaneId >= 0) {
        t.mapperPosition[0] = r[0] * (1 - d) + a[0] * d, t.mapperPosition[1] = r[1] * (1 - d) + a[1] * d, t.mapperPosition[2] = r[2] * (1 - d) + a[2] * d;
        const y = [];
        c.getClippingPlaneInDataCoords(t.transformMatrix, m.clippingPlaneId, y), Fn(y), t.mapperNormal[0] = -y[0], t.mapperNormal[1] = -y[1], t.mapperNormal[2] = -y[2];
      }
      I.transformMat4(t.pickPosition, t.mapperPosition, t.transformMatrix);
      const b = t.transformMatrix;
      t.mapperNormal[0] = b[0] * t.pickNormal[0] + b[4] * t.pickNormal[1] + b[8] * t.pickNormal[2], t.mapperNormal[1] = b[1] * t.pickNormal[0] + b[5] * t.pickNormal[1] + b[9] * t.pickNormal[2], t.mapperNormal[2] = b[2] * t.pickNormal[0] + b[6] * t.pickNormal[1] + b[10] * t.pickNormal[2];
    }
    return u;
  }, t.intersectVolumeWithLine = (r, a, o, l, c, u) => {
    let d = Number.MAX_VALUE;
    const p = u.getMapper().getInputData(), m = p.getOrigin(), b = p.getSpacing(), y = p.getDimensions(), Z = p.getPointData().getScalars().getData(), g = p.getExtent(), f = p.getDirection();
    let T;
    Ok(f) || (T = il.buildFromRadian().translate(m[0], m[1], m[2]).multiply3x3(f).translate(-m[0], -m[1], -m[2]).invert().getMatrix());
    const M = 1, N = 1024, W = new Float32Array(N), x = new Float32Array(N);
    let V, X;
    const C = u.getMapper().getSampleDistance();
    for (let at = 0; at < M; ++at) {
      V = u.getProperty().getScalarOpacity(at), X = V.getRange(), V.getTable(X[0], X[1], N, W, 1);
      const dt = C / u.getProperty().getScalarOpacityUnitDistance(at);
      for (let gt = 0; gt < N; ++gt)
        x[gt] = 1 - (1 - W[gt]) ** dt;
    }
    const R = N / (X[1] - X[0] + 1), z = [0, 0, 0], F = [0, 0, 0];
    if (z[0] = r[0], z[1] = r[1], z[2] = r[2], F[0] = a[0], F[1] = a[1], F[2] = a[2], o !== 0 || l !== 1)
      for (let at = 0; at < 3; at++)
        z[at] = r[at] * (1 - o) + a[at] * o, F[at] = r[at] * (1 - l) + a[at] * l;
    const P = [0, 0, 0], j = [0, 0, 0];
    for (let at = 0; at < 3; at++)
      P[at] = (z[at] - m[at]) / b[at], j[at] = (F[at] - m[at]) / b[at];
    const H = [0, 0, 0, 0], B = [0, 0, 0], $ = y[1] * y[0], A = y[0], E = 1 / Math.sqrt(zs(P, j));
    let ct;
    for (let at = 0; at < 1; at += E) {
      ct = !0;
      for (let dt = 0; dt < 3; dt++)
        H[dt] = P[dt] * (1 - at) + j[dt] * at;
      H[3] = 1, T && zn.transformMat4(H, H, T);
      for (let dt = 0; dt < 3; dt++)
        H[dt] < g[2 * dt] ? (H[dt] = g[2 * dt], ct = !1) : H[dt] > g[2 * dt + 1] && (H[dt] = g[2 * dt + 1], ct = !1), B[dt] = Math.round(H[dt]);
      if (ct) {
        const dt = B[2] * $ + B[1] * A + B[0];
        let gt = Z[dt];
        if (gt < X[0] ? gt = X[0] : gt > X[1] && (gt = X[1]), gt = Math.floor((gt - X[0]) * R), W[gt] > t.opacityThreshold) {
          d = o * (1 - at) + l * at;
          break;
        }
      }
    }
    return d;
  }, t.intersectActorWithLine = (r, a, o, l, c, u) => {
    let d = Number.MAX_VALUE;
    const h = [0, 0, 0];
    let p = Number.MAX_VALUE;
    const m = [0, 0, 0];
    let b = null, y = null, Z = null, g = null;
    const f = [], T = u.getInputData(), M = [0, 0, 0], N = [0, 0, 0];
    if (M[0] = r[0], M[1] = r[1], M[2] = r[2], N[0] = a[0], N[1] = a[1], N[2] = a[2], o !== 0 || l !== 1)
      for (let W = 0; W < 3; W++)
        M[W] = r[W] * (1 - o) + a[W] * o, N[W] = r[W] * (1 - l) + a[W] * l;
    if (T.getCells) {
      T.getCells() || T.buildLinks();
      const W = vO(), x = vO(), V = T.getNumberOfCells();
      for (let X = 0; X < V; X++) {
        const C = [0, 0, 0];
        if (Z = T.getCellType(X), Z === ei.VTK_EMPTY_CELL)
          continue;
        const R = W[Z];
        if (R == null)
          continue;
        y = x[Z], T.getCell(X, R);
        let z;
        if (aL.hasSubCells(Z) ? z = R.intersectWithLine(o, l, r, a, c, f, C) : z = R.intersectWithLine(r, a, c, f, C), z.intersect === 1 && z.t <= d + t.tolerance && z.t >= o && z.t <= l) {
          const F = R.getParametricDistance(C);
          if (F < p || F === p && z.t < d) {
            d = z.t, p = F, g = z.subId, b = X, R.deepCopy(y);
            for (let P = 0; P < 3; P++)
              h[P] = f[P], m[P] = C[P];
          }
        }
      }
    }
    if (b >= 0 && d < t.globalTMin) {
      s();
      const W = y.getNumberOfPoints(), x = new Array(W);
      for (let R = 0; R < W; R++)
        x[R] = 0;
      const V = [];
      aL.hasSubCells(Z) ? y.evaluateLocation(g, m, V, x) : y.evaluateLocation(m, V, x), t.dataSet = T, t.cellId = b, t.pCoords[0] = m[0], t.pCoords[1] = m[1], t.pCoords[2] = m[2];
      let X = 0, C = -1;
      for (let R = 0; R < W; R++)
        x[R] > X && (C = R, X = x[R]);
      C !== -1 && (t.pointId = y.getPointsIds()[C]), t.mapperPosition[0] = h[0], t.mapperPosition[1] = h[1], t.mapperPosition[2] = h[2], i.computeSurfaceNormal(T, y, x, t.mapperNormal) || (t.mapperNormal[0] = r[0] - a[0], t.mapperNormal[1] = r[1] - a[1], t.mapperNormal[2] = r[2] - a[2], Fn(t.mapperNormal));
    }
    return d;
  };
}
const Mht = {
  cellId: -1,
  pCoords: [],
  cellIJK: [],
  pickNormal: [],
  mapperNormal: [],
  opacityThreshold: 0.2
};
function IU(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Mht, e), rht.extend(i, t, e), tt.getArray(i, t, ["pickNormal", "mapperNormal", "pCoords", "cellIJK"]), tt.setGet(i, t, ["opacityThreshold"]), tt.get(i, t, ["cellId"]), Tht(i, t);
}
const Nht = tt.newInstance(IU, "vtkCellPicker");
var CU = {
  newInstance: Nht,
  extend: IU,
  ...Zht
};
function YU(i, t) {
  const e = new WheelEvent(i.type, i);
  t == null || t.dispatchEvent(e), i.stopImmediatePropagation();
}
const Wht = {
  enabled: !0,
  lazy: !0,
  scrollThrough: !1,
  noContainerResize: !1
};
class Ght {
  constructor(t, e, n = {}, s) {
    S(this, "enabled");
    S(this, "restoreEnabled");
    S(this, "lazy");
    S(this, "z");
    S(this, "el");
    S(this, "container");
    S(this, "constructorFn");
    S(this, "cleanupFn");
    S(this, "scrollThrough");
    S(this, "noContainerResize");
    const r = { ...Wht, ...n };
    this.lazy = r.lazy ?? !1, this.z = r.z, this.scrollThrough = r.scrollThrough ?? !1, this.noContainerResize = r.noContainerResize ?? !1, this.container = t, this.constructorFn = e, this.cleanupFn = s, r.enabled && this.show(), this.enabled = r.enabled ?? !1;
  }
  setEnabled(t) {
    t ? this.show() : this.hide();
  }
  hideRestore(t) {
    t ? (this.restoreEnabled = this.enabled, this.enabled && this.setEnabled(!1)) : this.restoreEnabled && this.setEnabled(!0);
  }
  remove() {
    this.removeComponent();
  }
  createComponent() {
    this.el = document.createElement("div"), this.el.style.position = "absolute", this.noContainerResize || (this.el.style.width = "100%", this.el.style.height = "100%", this.el.style.overflow = "hidden"), this.scrollThrough || this.el.addEventListener(
      "wheel",
      (t) => {
        t.stopPropagation();
      },
      {
        passive: !0
      }
    ), this.z !== void 0 && (this.el.style.zIndex = this.z.toString()), this.container.appendChild(this.el), this.constructorFn(this.el), this.lazy || this.createComponent();
  }
  removeComponent() {
    var t;
    (t = this.cleanupFn) == null || t.call(this), this.el && (this.container.removeChild(this.el), this.el = void 0);
  }
  show() {
    if (!this.enabled) {
      if (this.lazy)
        this.createComponent();
      else {
        if (!this.el) return;
        this.el.style.display = "block";
      }
      this.enabled = !0;
    }
  }
  hide() {
    if (this.enabled) {
      if (this.lazy)
        this.removeComponent();
      else {
        if (!this.el) return;
        this.el.style.display = "none";
      }
      this.enabled = !1;
    }
  }
}
function Pi(i) {
  const t = [], e = (a) => {
    t.push(a);
  }, n = () => {
    t.reduceRight((a, o) => (o(), null), null);
  }, s = (a, o = {}, l) => {
    const c = new Ght(i, a, o, l);
    return e(() => c.remove()), c;
  };
  return {
    createOverlayComponent: s,
    createVueOverlayComponent: (a, o, l = {}) => {
      let c;
      return s((h) => {
        c = c7(a, o);
        const { symbol: p, plugin: m } = M7;
        c.provide(p, m), c.mount(h);
      }, l, () => {
        c == null || c.unmount();
      });
    },
    cleanup: n
  };
}
class vU {
  constructor(t, e, n, s, r) {
    S(this, "el");
    S(this, "elInner");
    S(this, "viewport");
    S(this, "borderWidth");
    S(this, "gapWidth");
    S(this, "borderColor", "black");
    S(this, "gapColor", "black");
    S(this, "borderEnabled", !1);
    S(this, "isDeleted", !1);
    const a = document.createElement("div");
    a.style.position = "absolute", a.style.pointerEvents = "none", a.draggable = !1, a.style.userSelect = "none", r && (a.style.zIndex = r);
    const o = document.createElement("div");
    o.style.position = "absolute", o.style.pointerEvents = "none", o.draggable = !1, o.style.userSelect = "none", o.style.inset = "0px", a.appendChild(o), t.appendChild(a), this.el = a, this.elInner = o, this.viewport = e, this.updateOverlaySize(this.viewport.get()), this.viewport.subscribe((l) => this.updateOverlaySize(l)), this.borderWidth = n, this.gapWidth = s;
  }
  updateOverlaySize(t) {
    this.el.style.left = `${t.xmin * 100 + "%"}`, this.el.style.right = `${(1 - t.xmax) * 100 + "%"}`, this.el.style.bottom = `${t.ymin * 100 + "%"}`, this.el.style.top = `${(1 - t.ymax) * 100 + "%"}`;
  }
  setBorderColor(t) {
    this.borderColor = t, this.borderEnabled && this.showBorder();
  }
  setGapColor(t) {
    this.gapColor = t, this.borderEnabled && this.showBorder();
  }
  showBorder() {
    this.checkDeleted(), this.el.style.border = `${this.gapWidth}px solid ${this.gapColor}`, this.elInner.style.border = `${this.borderWidth}px solid ${this.borderColor}`, this.borderEnabled = !0;
  }
  hideBorder() {
    this.checkDeleted(), this.el.style.border = `${this.gapWidth}px solid transparent`, this.elInner.style.border = `${this.borderWidth}px solid transparent`;
  }
  show() {
    this.checkDeleted(), this.el.style.display = "block";
  }
  hide() {
    this.checkDeleted(), this.el.style.display = "none";
  }
  getElement() {
    return this.checkDeleted(), this.elInner;
  }
  checkDeleted() {
    if (this.isDeleted)
      throw new Error("OverlayContainer has been deleted");
  }
  delete() {
    this.el.remove(), this.viewport.unsubscribe(this.updateOverlaySize), this.isDeleted = !0;
  }
}
function wht(i) {
  const {
    items: t,
    anchors: e,
    bounds: n,
    margin: s,
    edgeMargin: r,
    anchorMargin: a,
    avoidAnchors: o
  } = i, l = t.map((p) => ({
    x: p.x,
    y: p.y,
    left: p.left,
    right: p.right,
    top: p.top,
    bottom: p.bottom,
    width: p.width,
    height: p.height
  })), c = (p, m, b) => {
    p.x += m, p.left += m, p.right += m, p.y += b, p.top += b, p.bottom += b;
  }, u = (p) => {
    let m = !1;
    return p.left < n.left + r && (c(p, n.left + r - p.left, 0), m = !0), p.right > n.right - r && (c(p, -(p.right - (n.right - r)), 0), m = !0), p.top < n.top + r && (c(p, 0, n.top + r - p.top), m = !0), p.bottom > n.bottom - r && (c(p, 0, -(p.bottom - (n.bottom - r))), m = !0), m;
  }, d = 20;
  let h = !1;
  for (let p = 0; p < d && !h; p++)
    h = !0, l.forEach((m) => {
      u(m) && (h = !1);
    }), l.forEach((m) => {
      l.forEach((b) => {
        if (m.right + s <= b.left || b.right + s <= m.left || m.bottom + s <= b.top || b.bottom + s <= m.top)
          return;
        h = !1;
        let y = (m.left + m.right) / 2, Z = (m.top + m.bottom) / 2;
        const g = (b.left + b.right) / 2, f = (m.top + m.bottom) / 2;
        y === g && (y += 1), Z === f && (Z += 1), Math.abs(y - g) - (m.width + b.width) / 2, Math.abs(Z - f) - (m.height + b.height) / 2;
        let T, M;
        y > g ? T = (b.right + s - m.left) / 2 : T = (m.right + s - b.left) / 2, Z > f ? M = (b.bottom + s - m.top) / 2 : M = (m.bottom + s - b.top) / 2, Math.abs(T) < Math.abs(M) ? (c(m, T, 0), c(b, -T, 0)) : (c(m, 0, M), c(b, 0, -M));
      }), o && l.forEach((b, y) => {
        const [Z, g] = e[y];
        if (m.right + a <= Z || m.left - a >= Z || m.bottom + a <= g || m.top - a >= g)
          return;
        h = !1;
        let f = (m.left + m.right) / 2, T = (m.top + m.bottom) / 2;
        f === Z && (f += 1), f === g && (T += 1), Math.abs(f - Z) - m.width / 2, Math.abs(T - g) - m.height / 2;
        let M, N;
        f > Z ? M = Z + a - m.left : M = Z - a - m.right, T > g ? N = g + a - m.top : N = g - a - m.bottom, Math.abs(M) < Math.abs(N) ? c(m, M, 0) : c(m, 0, N);
      }), u(m);
    });
  return l.map((p) => [p.x, p.y]);
}
function Le(i) {
  let t = i.get();
  const e = u7((s, r) => ({
    get: () => (s(), t),
    set: (a) => {
      t = a, r();
    }
  })), n = (s) => {
    e.value = s;
  };
  return i.subscribe(n), wg(() => i.unsubscribe(n)), e;
}
const xht = {
  key: 1,
  style: { width: "100%", height: "100%", "vertical-align": "top" }
}, Sht = ["cx", "cy"], Lht = ["x1", "x2", "y1", "y2"], Vht = ["x1", "x2", "y1", "y2"], RU = /* @__PURE__ */ Ne({
  __name: "ObjectInfoContainer",
  props: {
    viewSize: {},
    objectPosition: {},
    defaultOffset: {},
    computedPosition: {},
    objectVisible: { type: Boolean },
    drawPoint: { type: Boolean },
    lineStyle: {},
    interactive: { type: Boolean }
  },
  emits: ["sizeUpdated", "positionUpdated"],
  setup(i, { emit: t }) {
    const e = i, n = t, { computedPosition: s, viewSize: r } = Vo(e), a = Lt(0), o = Lt(0), l = Lt(e.defaultOffset[0]), c = Lt(e.defaultOffset[1]), u = Lt(null), d = Lt(null), h = Lt();
    s3(u, (W) => {
      h.value = W, Z(e.objectPosition[0] + l.value, e.objectPosition[1] + c.value), n("sizeUpdated", {
        w: h.value.width,
        h: h.value.height
      });
    }), gn(r, () => {
      Z(e.objectPosition[0] + l.value, e.objectPosition[1] + c.value);
    });
    const p = Lt(0), m = Lt(0), b = Lt(0), y = Lt(0), Z = (W, x) => {
      if (r != null) {
        if (!h.value || !r.value)
          return;
        const V = Math.max(0, Math.min(W, r.value[0] - h.value.width)), X = Math.max(0, Math.min(x, r.value[1] - h.value.height));
        a.value = V, o.value = X;
      } else
        throw Error("viewSize is undefined!");
    };
    xn(() => {
      u.value && (h.value = u.value.getBoundingClientRect()), Z(e.objectPosition[0] + l.value, e.objectPosition[1] + c.value);
    });
    const g = (W, x) => {
      p.value = W, m.value = x, b.value = a.value, y.value = o.value;
    }, f = (W, x) => {
      const V = W - p.value, X = x - m.value;
      let C = b.value + V, R = y.value + X;
      Z(C, R), l.value = a.value - e.objectPosition[0], c.value = o.value - e.objectPosition[1];
    }, T = () => {
      n("positionUpdated", {
        x: a.value - e.objectPosition[0],
        y: o.value - e.objectPosition[1]
      });
    };
    gn(e, (W) => {
      Z(W.objectPosition[0] + l.value, W.objectPosition[1] + c.value);
    }), Ga(u, "left", "page", {
      onDragStart: g,
      onDrag: f,
      onDragEnd: T
    });
    const M = te(() => {
      if (!h.value)
        return [a.value, o.value];
      const { left: W, right: x, top: V, bottom: X } = h.value, C = [
        [W, V],
        [W, X],
        [x, V],
        [x, X],
        [(W + x) / 2, V],
        [(W + x) / 2, X],
        [W, (V + X) / 2],
        [x, (V + X) / 2]
      ].map(([P, j]) => [a.value + P, o.value + j]), [R, z] = e.objectPosition, F = C.map(([P, j]) => Math.pow(R - P, 2) + Math.pow(z - j, 2)).reduce((P, j, H, B) => j < B[P] ? H : P, 0);
      return C[F];
    });
    gn(s, (W) => {
      if (!W)
        return;
      const [x, V] = W;
      a.value = x, o.value = V;
    });
    const N = (W) => {
      YU(W, d.value);
    };
    return (W, x) => (Mt(), Ot("div", {
      ref_key: "root",
      ref: d,
      style: { position: "absolute", width: "100%", height: "100%" }
    }, [
      i.objectVisible ? (Mt(), Ot("div", {
        key: 0,
        ref_key: "content",
        ref: u,
        style: xe([{
          left: a.value + "px",
          top: o.value + "px",
          "pointer-events": i.interactive ? "auto" : "none"
        }, { position: "absolute" }]),
        onWheelPassive: N
      }, [
        Jh(W.$slots, "default")
      ], 36)) : Qt("", !0),
      i.objectVisible ? (Mt(), Ot("svg", xht, [
        i.drawPoint ? (Mt(), Ot("ellipse", {
          key: 0,
          cx: i.objectPosition[0],
          cy: i.objectPosition[1],
          fill: "rgba(255, 255, 255, 1)",
          rx: "1",
          ry: "1",
          stroke: "rgba(255, 255, 255, 1)"
        }, null, 8, Sht)) : Qt("", !0),
        i.lineStyle === "solid" ? (Mt(), Ot("line", {
          key: 1,
          x1: i.objectPosition[0],
          x2: M.value[0],
          y1: i.objectPosition[1],
          y2: M.value[1],
          stroke: "rgba(255, 255, 255, 0.5)"
        }, null, 8, Lht)) : Qt("", !0),
        i.lineStyle === "dashed" ? (Mt(), Ot("line", {
          key: 2,
          x1: i.objectPosition[0],
          x2: M.value[0],
          y1: i.objectPosition[1],
          y2: M.value[1],
          stroke: "rgba(255, 255, 255, 0.5)",
          "stroke-dasharray": "10"
        }, null, 8, Vht)) : Qt("", !0)
      ])) : Qt("", !0)
    ], 512));
  }
}), Xht = { class: "label" }, RO = 14, Iht = /* @__PURE__ */ Ne({
  __name: "AnnotationLabel",
  props: {
    view: {},
    viewSize: {},
    visible: {},
    interactive: {},
    str: {},
    objectScreenPosition: {}
  },
  setup(i) {
    x0((o) => ({
      d4d2c906: `${RO}px`
    }));
    const t = i, e = Le(t.viewSize), n = Le(t.objectScreenPosition), s = Le(t.visible), r = Le(t.interactive), a = Le(t.str);
    return (o, l) => as((Mt(), le(RU, {
      viewSize: K(e),
      objectPosition: K(n),
      defaultOffset: [5, -5 - RO],
      objectVisible: !0,
      drawPoint: !1,
      interactive: K(r),
      lineStyle: "dashed"
    }, {
      default: oe(() => [
        kt("div", Xht, pe(K(a)), 1)
      ]),
      _: 1
    }, 8, ["viewSize", "objectPosition", "defaultOffset", "interactive"])), [
      [Ss, K(s)]
    ]);
  }
}), Dn = (i, t) => {
  const e = i.__vccOpts || i;
  for (const [n, s] of t)
    e[n] = s;
  return e;
}, Cht = /* @__PURE__ */ Dn(Iht, [["__scopeId", "data-v-6be31d7a"]]), Yht = { style: { position: "absolute", width: "100%", height: "100%", overflow: "hidden" } }, vht = 14, Rht = /* @__PURE__ */ Ne({
  __name: "BoundingBoxLabels",
  props: {
    xLabel: {},
    yLabel: {},
    zLabel: {},
    xPosition: {},
    yPosition: {},
    zPosition: {}
  },
  setup(i) {
    x0((l) => ({
      e4941ea2: `${vht}px`
    }));
    const t = i, e = Le(t.xLabel), n = Le(t.yLabel), s = Le(t.zLabel), r = Le(t.xPosition), a = Le(t.yPosition), o = Le(t.zPosition);
    return (l, c) => (Mt(), Ot("div", Yht, [
      kt("div", {
        class: "label",
        style: xe({ left: K(r)[0] + "px", bottom: K(r)[1] + "px" })
      }, pe(K(e)), 5),
      kt("div", {
        class: "label",
        style: xe({ left: K(a)[0] + "px", bottom: K(a)[1] + "px" })
      }, pe(K(n)), 5),
      kt("div", {
        class: "label",
        style: xe({ left: K(o)[0] + "px", bottom: K(o)[1] + "px" })
      }, pe(K(s)), 5)
    ]));
  }
}), Dht = /* @__PURE__ */ Dn(Rht, [["__scopeId", "data-v-457b82fe"]]);
class se {
  constructor() {
    S(this, "observers");
    this.observers = [];
  }
  subscribe(t) {
    this.observers.includes(t) || this.observers.push(t);
  }
  unsubscribe(t) {
    this.observers.forEach((e, n) => {
      e === t && this.observers.splice(n, 1);
    });
  }
  notify(t) {
    this.observers.forEach((e) => e(t));
  }
}
class qt {
  constructor(t) {
    S(this, "value");
    S(this, "event");
    this.value = t, this.event = new se();
  }
  subscribe(t) {
    this.event.subscribe(t);
  }
  unsubscribe(t) {
    this.event.unsubscribe(t);
  }
  set(t) {
    this.value = t, this.event.notify(t);
  }
  update(t) {
    this.set(t(this.value));
  }
  get() {
    return i2 == null || i2(this), this.value;
  }
  modified() {
    this.event.notify(this.value);
  }
}
let i2;
class qo {
  constructor(t) {
    S(this, "observable");
    this.observable = t;
  }
  subscribe(t) {
    this.observable.subscribe(t);
  }
  unsubscribe(t) {
    this.observable.unsubscribe(t);
  }
  get() {
    return this.observable.get();
  }
}
const hN = [], Oht = (i) => {
  hN.push(i);
}, DU = (i) => {
  hN.length = 0, i2 = Oht;
  const t = new qt(i());
  i2 = void 0;
  const e = [...hN];
  return hN.length = 0, [t, e];
};
class md {
  constructor(t) {
    S(this, "observable");
    S(this, "deps");
    S(this, "observer");
    [this.observable, this.deps] = DU(t), this.observer = () => this.observable.set(t()), this.deps.forEach((e) => {
      e.subscribe(this.observer);
    });
  }
  subscribe(t) {
    this.observable.subscribe(t);
  }
  unsubscribe(t) {
    this.observable.unsubscribe(t);
  }
  get() {
    return this.observable.get();
  }
  stop() {
    this.deps.forEach((t) => {
      t && t.unsubscribe(this.observer);
    });
  }
}
class OU {
  constructor(t) {
    S(this, "observable");
    S(this, "deps");
    S(this, "modified", !1);
    S(this, "onModified", () => {
      this.modified = !0;
    });
    S(this, "fn");
    this.fn = t, this.deps = null;
  }
  setupDependencies() {
    [this.observable, this.deps] = DU(this.fn), this.deps.forEach((t) => {
      t.subscribe(this.onModified);
    });
  }
  get() {
    return this.deps === null ? this.setupDependencies() : this.modified && (this.observable.set(this.fn()), this.modified = !1), this.observable.get();
  }
  stop() {
    var t;
    (t = this.deps) == null || t.forEach((e) => {
      e && e.unsubscribe(this.onModified);
    });
  }
}
function An() {
  const i = [], t = (o) => {
    i.push(o);
  };
  return {
    watch: (o, l) => {
      o.subscribe(l), t(() => o.unsubscribe(l));
    },
    computed: (o) => {
      const l = new md(o);
      return t(() => l.stop()), l;
    },
    lazyComputed: (o) => {
      const l = new OU(o);
      return t(() => l.stop()), l;
    },
    onEvent: (o, l) => {
      o.subscribe(l), t(() => o.unsubscribe(l));
    },
    cleanupAll: () => {
      i.reduceRight((o, l) => (l(), null), null);
    }
  };
}
var pr = /* @__PURE__ */ ((i) => (i[i.topLeft = 0] = "topLeft", i[i.topRight = 1] = "topRight", i[i.bottomLeft = 2] = "bottomLeft", i[i.bottomRight = 3] = "bottomRight", i))(pr || {});
const zht = { style: { display: "flex", width: "100%", "padding-left": "10px", "margin-top": "11px", "margin-bottom": "11px" } }, Eht = { style: { display: "flex", "flex-grow": "1", "flex-direction": "row", "justify-content": "space-between" } }, kht = { style: { color: "var(--p-wiz-object-list-text-color)", "pointer-events": "none", "user-select": "none" } }, Fht = { class: "pointer" }, jht = { key: 0 }, Uht = { key: 1 }, QI = /* @__PURE__ */ Ne({
  __name: "MovableWindow",
  props: {
    title: {},
    collapsible: { type: Boolean, default: !1 },
    width: {},
    maxHeight: {},
    viewSize: {},
    defaultMargin: { default: 0 },
    minMargin: { default: 0 },
    additionalTopMargin: { default: 0 },
    initialPosition: {},
    showDockButton: { type: Boolean },
    parent: {},
    dockEvent: {}
  },
  setup(i) {
    const t = i, e = Lt(24), n = Lt(0), s = Lt(0), r = Lt(null), a = Lt(), { viewSize: o } = Vo(t);
    let l = !0;
    const c = () => {
      !o.value || !a.value || (b.value = t.initialPosition, t.initialPosition === pr.topLeft ? (n.value = t.defaultMargin, s.value = t.defaultMargin + t.additionalTopMargin + t.minMargin) : t.initialPosition === pr.topRight ? (n.value = o.value[0] - a.value.width - t.defaultMargin, s.value = t.defaultMargin + t.additionalTopMargin + t.minMargin) : t.initialPosition === pr.bottomLeft ? (n.value = t.defaultMargin, s.value = o.value[1] - a.value.height - t.defaultMargin - t.additionalTopMargin - t.minMargin) : t.initialPosition === pr.bottomRight && (n.value = o.value[0] - a.value.width - t.defaultMargin, s.value = o.value[1] - a.value.height - t.defaultMargin - t.additionalTopMargin - t.minMargin), r.value && (r.value.style.top = `${s.value}px`, r.value.style.left = `${n.value}px`));
    };
    let u = !0;
    s3(r, (V) => a.value = V), gn(a, (V) => {
      V && l && c(), y(n.value, s.value), u && x();
    }), gn(o, (V, X) => {
      if (V && l) {
        c(), x();
        return;
      }
      if (V && X) {
        if (V[0] === 0 && V[1] === 0 || X[0] === 0 && X[1] === 0)
          return;
        M(X, V), x();
      }
    });
    const d = Lt(0), h = Lt(0), p = Lt(0), m = Lt(0), b = Lt(pr.topLeft), y = (V, X) => {
      if (!r.value || !a.value || !o.value)
        return;
      const C = Math.max(t.minMargin, Math.min(V, o.value[0] - a.value.width - t.minMargin)), R = Math.max(t.additionalTopMargin + t.minMargin, Math.min(X, o.value[1] - a.value.height - t.additionalTopMargin - t.minMargin));
      n.value = C, s.value = R, r.value && (r.value.style.top = `${s.value}px`, r.value.style.left = `${n.value}px`);
    }, Z = () => {
      if (!r.value || !a.value || !o.value)
        return;
      const V = n.value, X = o.value[0] - (n.value + a.value.width), C = s.value, R = o.value[1] - (s.value + a.value.height), z = V <= X, F = C <= R;
      z && F ? b.value = pr.topLeft : !z && F ? b.value = pr.topRight : z && !F ? b.value = pr.bottomLeft : !z && !F && (b.value = pr.bottomRight);
    };
    Ga(r, "left", "page", {
      onDragStart: (V, X) => {
        var C, R;
        l = !1, d.value = V, h.value = X, n.value = parseInt(((C = r.value) == null ? void 0 : C.style.left.replaceAll("px", "")) || "0"), s.value = parseInt(((R = r.value) == null ? void 0 : R.style.top.replaceAll("px", "")) || "0"), p.value = n.value, m.value = s.value, u = !1;
      },
      onDrag: (V, X) => {
        const C = V - d.value, R = X - h.value;
        let z = p.value + C, F = m.value + R;
        y(z, F);
      },
      onDragEnd: () => {
        Z();
      }
    });
    const M = (V, X) => {
      const C = n.value, R = s.value;
      let z = C, F = R;
      b.value === pr.topRight ? z = C + (X[0] - V[0]) : b.value === pr.bottomLeft ? F = R + (X[1] - V[1]) : b.value === pr.bottomRight && (z = C + (X[0] - V[0]), F = R + (X[1] - V[1])), y(z, F);
    };
    xn(() => {
      c();
    });
    const N = Lt(!1), W = () => {
      N.value = !N.value, l = !1;
    }, x = () => {
      t.dockEvent && t.dockEvent(), u = !0;
    };
    return (V, X) => (Mt(), Ot("div", {
      ref_key: "root",
      ref: r,
      style: xe([{
        // left: offsetLeft + 'px',
        // top: offsetTop + 'px',
        width: i.width + "px",
        maxHeight: (K(o) ? Math.min(i.maxHeight || K(o)[1], K(o)[1]) : i.maxHeight) + "px",
        display: !K(o) || K(o)[0] >= i.width && K(o)[1] >= e.value ? "flex" : "none"
      }, { position: "absolute", color: "white", "pointer-events": "auto", "flex-direction": "column", "min-height": "40px", background: "var(--p-rg-component-background-color)" }]),
      class: "all-radius"
    }, [
      kt("div", zht, [
        kt("div", Eht, [
          kt("span", kht, pe(i.title), 1),
          Jh(V.$slots, "headerButtons"),
          i.showDockButton ? (Mt(), Ot("button", {
            key: 0,
            class: "p-button p-button-text no-padding",
            onClick: X[0] || (X[0] = () => x())
          }, [
            Pt(K(Vb), {
              height: 16,
              width: 16,
              cIcon: "new_icons/ik_object_placement_black"
            })
          ])) : Qt("", !0)
        ]),
        i.collapsible ? (Mt(), Ot("div", {
          key: 0,
          class: "cursor-pointer",
          style: { width: "24px", "pointer-events": "auto", display: "flex", "justify-content": "center", "align-items": "center", "user-select": "none", "margin-right": "1px" },
          onClick: W,
          onMousedown: X[1] || (X[1] = o0(() => {
          }, ["stop"]))
        }, [
          kt("div", Fht, [
            N.value ? Qt("", !0) : (Mt(), Ot("div", jht, [
              Pt(K(Vb), {
                cIcon: "expand_object_list_grey",
                height: 16,
                width: 16
              })
            ])),
            N.value ? (Mt(), Ot("div", Uht, [
              Pt(K(Vb), {
                cIcon: "collapse_object_list_grey",
                height: 16,
                width: 16
              })
            ])) : Qt("", !0)
          ])
        ], 32)) : Qt("", !0)
      ]),
      kt("div", {
        style: xe([{
          display: N.value ? "none" : "block"
        }, { width: "100%", height: "100%", "overflow-y": "auto", "user-select": "none" }]),
        onMousedown: X[2] || (X[2] = o0(() => {
        }, ["stop"]))
      }, [
        Jh(V.$slots, "default")
      ], 36)
    ], 4));
  }
}), Pht = { style: { padding: "0 10px 10px 10px" } }, Jht = { key: 0 }, Aht = { style: { display: "flex", "padding-top": "10px" } }, Bht = { style: { "flex-grow": "1" } }, Kht = ["value", "onInput"], Hht = { style: { width: "40px", "text-align": "end", color: "var(--p-wiz-object-list-text-color)" } }, _ht = {
  class: "buttonsRow",
  style: { display: "flex", "justify-content": "space-between" }
}, Qht = /* @__PURE__ */ Ne({
  __name: "ClippingPlanesWidget",
  props: {
    planes: {},
    events: {},
    viewSize: {},
    widgetSize: {},
    initialPosition: {},
    additionalTopMargin: {},
    showDockButton: { type: Boolean },
    parent: {},
    dockEvent: { type: Function }
  },
  setup(i) {
    const t = i, e = Le(t.planes), n = Le(t.viewSize), s = Le(t.widgetSize || new qt([320, 419])), r = t.initialPosition || pr.topRight, a = t.additionalTopMargin ?? 34, o = t.showDockButton ?? !1, l = t.parent, c = t.dockEvent, u = () => t.events.addNewClippingPlane.notify(), d = (f) => t.events.invertPlane.notify(f), h = (f) => t.events.setPlaneToMiddle.notify(f), p = (f) => t.events.setPlaneRotate.notify(f), m = (f) => t.events.setPlaneActivated.notify(f), b = (f) => t.events.removePlane.notify(f), y = (f, T) => t.events.setPlaneSliderValue.notify({ planeId: f, value: T }), Z = (f) => ({
      padding: "6px",
      borderRadius: "6px",
      border: f ? "2px solid #99c8ff" : "1px solid transparent",
      height: "2rem",
      color: "var(--p-primary-contrast-color)",
      background: "var(--p-clipping-planes-btn-background)"
    }), g = (f, T) => {
      if (f.target) {
        const M = f.target.value;
        y(T.id, parseFloat(M));
      }
    };
    return (f, T) => (Mt(), le(QI, {
      collapsible: !1,
      defaultMargin: 10,
      minMargin: 10,
      additionalTopMargin: K(a),
      viewSize: K(n),
      maxHeight: K(s)[1],
      width: K(s)[0],
      title: "Clipping Planes",
      initialPosition: K(r),
      showDockButton: K(o),
      parent: K(l),
      dockEvent: K(c)
    }, {
      headerButtons: oe(() => [
        kt("button", {
          class: "p-button p-button-text text-lg no-padding mr-4",
          onClick: u
        }, "+")
      ]),
      default: oe(() => [
        kt("div", Pht, [
          K(e).length > 0 ? (Mt(), Ot("div", Jht, [
            (Mt(!0), Ot(Me, null, Xn(K(e), (M, N) => (Mt(), Ot(Me, { key: N }, [
              kt("div", Aht, [
                kt("div", Bht, [
                  kt("input", {
                    value: M.sliderValue,
                    max: "1",
                    min: "0",
                    step: "0.001",
                    style: { width: "100%" },
                    type: "range",
                    onInput: (W) => g(W, M)
                  }, null, 40, Kht)
                ]),
                kt("div", Hht, pe(M.sliderValue.toFixed(3)), 1)
              ]),
              kt("div", _ht, [
                Pt(K(qg), {
                  style: xe(Z(!1)),
                  onClick: () => d(M.id)
                }, {
                  default: oe(() => [...T[0] || (T[0] = [
                    Ws("Invert", -1)
                  ])]),
                  _: 1
                }, 8, ["style", "onClick"]),
                Pt(K(qg), {
                  style: xe(Z(!1)),
                  onClick: () => h(M.id)
                }, {
                  default: oe(() => [...T[1] || (T[1] = [
                    Ws("Middle", -1)
                  ])]),
                  _: 1
                }, 8, ["style", "onClick"]),
                Pt(K(qg), {
                  style: xe(Z(M.rotate)),
                  onClick: () => p(M.id)
                }, {
                  default: oe(() => [...T[2] || (T[2] = [
                    Ws("Rotate", -1)
                  ])]),
                  _: 1
                }, 8, ["style", "onClick"]),
                Pt(K(qg), {
                  style: xe(Z(M.activated)),
                  onClick: () => m(M.id)
                }, {
                  default: oe(() => [...T[3] || (T[3] = [
                    Ws("Visible", -1)
                  ])]),
                  _: 1
                }, 8, ["style", "onClick"]),
                Pt(K(qg), {
                  style: xe(Z(!1)),
                  onClick: () => b(M.id)
                }, {
                  default: oe(() => [...T[4] || (T[4] = [
                    Ws("Remove", -1)
                  ])]),
                  _: 1
                }, 8, ["style", "onClick"])
              ])
            ], 64))), 128))
          ])) : Qt("", !0)
        ])
      ]),
      _: 1
    }, 8, ["additionalTopMargin", "viewSize", "maxHeight", "width", "initialPosition", "showDockButton", "parent", "dockEvent"]));
  }
});
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
function $ht(i, t, e) {
  return (t = tpt(t)) in i ? Object.defineProperty(i, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : i[t] = e, i;
}
function DO(i, t) {
  var e = Object.keys(i);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(i);
    t && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(i, s).enumerable;
    })), e.push.apply(e, n);
  }
  return e;
}
function Ze(i) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? DO(Object(e), !0).forEach(function(n) {
      $ht(i, n, e[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(e)) : DO(Object(e)).forEach(function(n) {
      Object.defineProperty(i, n, Object.getOwnPropertyDescriptor(e, n));
    });
  }
  return i;
}
function qht(i, t) {
  if (typeof i != "object" || !i) return i;
  var e = i[Symbol.toPrimitive];
  if (e !== void 0) {
    var n = e.call(i, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(i);
}
function tpt(i) {
  var t = qht(i, "string");
  return typeof t == "symbol" ? t : t + "";
}
const OO = () => {
};
let $I = {}, zU = {}, EU = null, kU = {
  mark: OO,
  measure: OO
};
try {
  typeof window < "u" && ($I = window), typeof document < "u" && (zU = document), typeof MutationObserver < "u" && (EU = MutationObserver), typeof performance < "u" && (kU = performance);
} catch {
}
const {
  userAgent: zO = ""
} = $I.navigator || {}, Kh = $I, Ui = zU, EO = EU, fM = kU;
Kh.document;
const bd = !!Ui.documentElement && !!Ui.head && typeof Ui.addEventListener == "function" && typeof Ui.createElement == "function", FU = ~zO.indexOf("MSIE") || ~zO.indexOf("Trident/");
var ept = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, npt = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, jU = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  }
}, ipt = {
  GROUP: "duotone-group",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, UU = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], ra = "classic", BG = "duotone", spt = "sharp", rpt = "sharp-duotone", PU = [ra, BG, spt, rpt], apt = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, opt = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, lpt = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}]]), cpt = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    brands: "fab"
  },
  duotone: {
    solid: "fad",
    regular: "fadr",
    light: "fadl",
    thin: "fadt"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds",
    regular: "fasdr",
    light: "fasdl",
    thin: "fasdt"
  }
}, upt = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], kO = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, dpt = ["kit"], hpt = {
  kit: {
    "fa-kit": "fak"
  }
}, ppt = ["fak", "fakd"], mpt = {
  kit: {
    fak: "fa-kit"
  }
}, FO = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, gM = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, bpt = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], fpt = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], gpt = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, ypt = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  }
}, Zpt = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
}, yL = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  }
}, Tpt = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"], ZL = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...bpt, ...Tpt], Mpt = ["solid", "regular", "light", "thin", "duotone", "brands"], JU = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], Npt = JU.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), Wpt = [...Object.keys(Zpt), ...Mpt, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", gM.GROUP, gM.SWAP_OPACITY, gM.PRIMARY, gM.SECONDARY].concat(JU.map((i) => "".concat(i, "x"))).concat(Npt.map((i) => "w-".concat(i))), Gpt = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
};
const cd = "___FONT_AWESOME___", TL = 16, AU = "fa", BU = "svg-inline--fa", g0 = "data-fa-i2svg", ML = "data-fa-pseudo-element", wpt = "data-fa-pseudo-element-pending", qI = "data-prefix", tC = "data-icon", jO = "fontawesome-i2svg", xpt = "async", Spt = ["HTML", "HEAD", "STYLE", "SCRIPT"], KU = (() => {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
})();
function DT(i) {
  return new Proxy(i, {
    get(t, e) {
      return e in t ? t[e] : t[ra];
    }
  });
}
const HU = Ze({}, jU);
HU[ra] = Ze(Ze(Ze(Ze({}, {
  "fa-duotone": "duotone"
}), jU[ra]), kO.kit), kO["kit-duotone"]);
const Lpt = DT(HU), NL = Ze({}, cpt);
NL[ra] = Ze(Ze(Ze(Ze({}, {
  duotone: "fad"
}), NL[ra]), FO.kit), FO["kit-duotone"]);
const UO = DT(NL), WL = Ze({}, yL);
WL[ra] = Ze(Ze({}, WL[ra]), mpt.kit);
const eC = DT(WL), GL = Ze({}, ypt);
GL[ra] = Ze(Ze({}, GL[ra]), hpt.kit);
DT(GL);
const Vpt = ept, _U = "fa-layers-text", Xpt = npt, Ipt = Ze({}, apt);
DT(Ipt);
const Cpt = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], Bx = ipt, Ypt = [...dpt, ...Wpt], s2 = Kh.FontAwesomeConfig || {};
function vpt(i) {
  var t = Ui.querySelector("script[" + i + "]");
  if (t)
    return t.getAttribute(i);
}
function Rpt(i) {
  return i === "" ? !0 : i === "false" ? !1 : i === "true" ? !0 : i;
}
Ui && typeof Ui.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((t) => {
  let [e, n] = t;
  const s = Rpt(vpt(e));
  s != null && (s2[n] = s);
});
const QU = {
  styleDefault: "solid",
  familyDefault: ra,
  cssPrefix: AU,
  replacementClass: BU,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
s2.familyPrefix && (s2.cssPrefix = s2.familyPrefix);
const yg = Ze(Ze({}, QU), s2);
yg.autoReplaceSvg || (yg.observeMutations = !1);
const Be = {};
Object.keys(QU).forEach((i) => {
  Object.defineProperty(Be, i, {
    enumerable: !0,
    set: function(t) {
      yg[i] = t, r2.forEach((e) => e(Be));
    },
    get: function() {
      return yg[i];
    }
  });
});
Object.defineProperty(Be, "familyPrefix", {
  enumerable: !0,
  set: function(i) {
    yg.cssPrefix = i, r2.forEach((t) => t(Be));
  },
  get: function() {
    return yg.cssPrefix;
  }
});
Kh.FontAwesomeConfig = Be;
const r2 = [];
function Dpt(i) {
  return r2.push(i), () => {
    r2.splice(r2.indexOf(i), 1);
  };
}
const Vd = TL, Dc = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function Opt(i) {
  if (!i || !bd)
    return;
  const t = Ui.createElement("style");
  t.setAttribute("type", "text/css"), t.innerHTML = i;
  const e = Ui.head.childNodes;
  let n = null;
  for (let s = e.length - 1; s > -1; s--) {
    const r = e[s], a = (r.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(a) > -1 && (n = r);
  }
  return Ui.head.insertBefore(t, n), i;
}
const zpt = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function y2() {
  let i = 12, t = "";
  for (; i-- > 0; )
    t += zpt[Math.random() * 62 | 0];
  return t;
}
function Ig(i) {
  const t = [];
  for (let e = (i || []).length >>> 0; e--; )
    t[e] = i[e];
  return t;
}
function nC(i) {
  return i.classList ? Ig(i.classList) : (i.getAttribute("class") || "").split(" ").filter((t) => t);
}
function $U(i) {
  return "".concat(i).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Ept(i) {
  return Object.keys(i || {}).reduce((t, e) => t + "".concat(e, '="').concat($U(i[e]), '" '), "").trim();
}
function KG(i) {
  return Object.keys(i || {}).reduce((t, e) => t + "".concat(e, ": ").concat(i[e].trim(), ";"), "");
}
function iC(i) {
  return i.size !== Dc.size || i.x !== Dc.x || i.y !== Dc.y || i.rotate !== Dc.rotate || i.flipX || i.flipY;
}
function kpt(i) {
  let {
    transform: t,
    containerWidth: e,
    iconWidth: n
  } = i;
  const s = {
    transform: "translate(".concat(e / 2, " 256)")
  }, r = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "), a = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), o = "rotate(".concat(t.rotate, " 0 0)"), l = {
    transform: "".concat(r, " ").concat(a, " ").concat(o)
  }, c = {
    transform: "translate(".concat(n / 2 * -1, " -256)")
  };
  return {
    outer: s,
    inner: l,
    path: c
  };
}
function Fpt(i) {
  let {
    transform: t,
    width: e = TL,
    height: n = TL,
    startCentered: s = !1
  } = i, r = "";
  return s && FU ? r += "translate(".concat(t.x / Vd - e / 2, "em, ").concat(t.y / Vd - n / 2, "em) ") : s ? r += "translate(calc(-50% + ".concat(t.x / Vd, "em), calc(-50% + ").concat(t.y / Vd, "em)) ") : r += "translate(".concat(t.x / Vd, "em, ").concat(t.y / Vd, "em) "), r += "scale(".concat(t.size / Vd * (t.flipX ? -1 : 1), ", ").concat(t.size / Vd * (t.flipY ? -1 : 1), ") "), r += "rotate(".concat(t.rotate, "deg) "), r;
}
var jpt = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}`;
function qU() {
  const i = AU, t = BU, e = Be.cssPrefix, n = Be.replacementClass;
  let s = jpt;
  if (e !== i || n !== t) {
    const r = new RegExp("\\.".concat(i, "\\-"), "g"), a = new RegExp("\\--".concat(i, "\\-"), "g"), o = new RegExp("\\.".concat(t), "g");
    s = s.replace(r, ".".concat(e, "-")).replace(a, "--".concat(e, "-")).replace(o, ".".concat(n));
  }
  return s;
}
let PO = !1;
function Kx() {
  Be.autoAddCss && !PO && (Opt(qU()), PO = !0);
}
var Upt = {
  mixout() {
    return {
      dom: {
        css: qU,
        insertCss: Kx
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        Kx();
      },
      beforeI2svg() {
        Kx();
      }
    };
  }
};
const ud = Kh || {};
ud[cd] || (ud[cd] = {});
ud[cd].styles || (ud[cd].styles = {});
ud[cd].hooks || (ud[cd].hooks = {});
ud[cd].shims || (ud[cd].shims = []);
var Oc = ud[cd];
const tP = [], eP = function() {
  Ui.removeEventListener("DOMContentLoaded", eP), TW = 1, tP.map((i) => i());
};
let TW = !1;
bd && (TW = (Ui.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(Ui.readyState), TW || Ui.addEventListener("DOMContentLoaded", eP));
function Ppt(i) {
  bd && (TW ? setTimeout(i, 0) : tP.push(i));
}
function OT(i) {
  const {
    tag: t,
    attributes: e = {},
    children: n = []
  } = i;
  return typeof i == "string" ? $U(i) : "<".concat(t, " ").concat(Ept(e), ">").concat(n.map(OT).join(""), "</").concat(t, ">");
}
function JO(i, t, e) {
  if (i && i[t] && i[t][e])
    return {
      prefix: t,
      iconName: e,
      icon: i[t][e]
    };
}
var Hx = function(t, e, n, s) {
  var r = Object.keys(t), a = r.length, o = e, l, c, u;
  for (n === void 0 ? (l = 1, u = t[r[0]]) : (l = 0, u = n); l < a; l++)
    c = r[l], u = o(u, t[c], c, t);
  return u;
};
function Jpt(i) {
  const t = [];
  let e = 0;
  const n = i.length;
  for (; e < n; ) {
    const s = i.charCodeAt(e++);
    if (s >= 55296 && s <= 56319 && e < n) {
      const r = i.charCodeAt(e++);
      (r & 64512) == 56320 ? t.push(((s & 1023) << 10) + (r & 1023) + 65536) : (t.push(s), e--);
    } else
      t.push(s);
  }
  return t;
}
function wL(i) {
  const t = Jpt(i);
  return t.length === 1 ? t[0].toString(16) : null;
}
function Apt(i, t) {
  const e = i.length;
  let n = i.charCodeAt(t), s;
  return n >= 55296 && n <= 56319 && e > t + 1 && (s = i.charCodeAt(t + 1), s >= 56320 && s <= 57343) ? (n - 55296) * 1024 + s - 56320 + 65536 : n;
}
function AO(i) {
  return Object.keys(i).reduce((t, e) => {
    const n = i[e];
    return !!n.icon ? t[n.iconName] = n.icon : t[e] = n, t;
  }, {});
}
function xL(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: n = !1
  } = e, s = AO(t);
  typeof Oc.hooks.addPack == "function" && !n ? Oc.hooks.addPack(i, AO(t)) : Oc.styles[i] = Ze(Ze({}, Oc.styles[i] || {}), s), i === "fas" && xL("fa", t);
}
const {
  styles: Z2,
  shims: Bpt
} = Oc, nP = Object.keys(eC), Kpt = nP.reduce((i, t) => (i[t] = Object.keys(eC[t]), i), {});
let sC = null, iP = {}, sP = {}, rP = {}, aP = {}, oP = {};
function Hpt(i) {
  return ~Ypt.indexOf(i);
}
function _pt(i, t) {
  const e = t.split("-"), n = e[0], s = e.slice(1).join("-");
  return n === i && s !== "" && !Hpt(s) ? s : null;
}
const lP = () => {
  const i = (n) => Hx(Z2, (s, r, a) => (s[a] = Hx(r, n, {}), s), {});
  iP = i((n, s, r) => (s[3] && (n[s[3]] = r), s[2] && s[2].filter((o) => typeof o == "number").forEach((o) => {
    n[o.toString(16)] = r;
  }), n)), sP = i((n, s, r) => (n[r] = r, s[2] && s[2].filter((o) => typeof o == "string").forEach((o) => {
    n[o] = r;
  }), n)), oP = i((n, s, r) => {
    const a = s[2];
    return n[r] = r, a.forEach((o) => {
      n[o] = r;
    }), n;
  });
  const t = "far" in Z2 || Be.autoFetchSvg, e = Hx(Bpt, (n, s) => {
    const r = s[0];
    let a = s[1];
    const o = s[2];
    return a === "far" && !t && (a = "fas"), typeof r == "string" && (n.names[r] = {
      prefix: a,
      iconName: o
    }), typeof r == "number" && (n.unicodes[r.toString(16)] = {
      prefix: a,
      iconName: o
    }), n;
  }, {
    names: {},
    unicodes: {}
  });
  rP = e.names, aP = e.unicodes, sC = HG(Be.styleDefault, {
    family: Be.familyDefault
  });
};
Dpt((i) => {
  sC = HG(i.styleDefault, {
    family: Be.familyDefault
  });
});
lP();
function rC(i, t) {
  return (iP[i] || {})[t];
}
function Qpt(i, t) {
  return (sP[i] || {})[t];
}
function Jp(i, t) {
  return (oP[i] || {})[t];
}
function cP(i) {
  return rP[i] || {
    prefix: null,
    iconName: null
  };
}
function $pt(i) {
  const t = aP[i], e = rC("fas", i);
  return t || (e ? {
    prefix: "fas",
    iconName: e
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function Hh() {
  return sC;
}
const uP = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function qpt(i) {
  let t = ra;
  const e = nP.reduce((n, s) => (n[s] = "".concat(Be.cssPrefix, "-").concat(s), n), {});
  return PU.forEach((n) => {
    (i.includes(e[n]) || i.some((s) => Kpt[n].includes(s))) && (t = n);
  }), t;
}
function HG(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: e = ra
  } = t, n = Lpt[e][i];
  if (e === BG && !i)
    return "fad";
  const s = UO[e][i] || UO[e][n], r = i in Oc.styles ? i : null;
  return s || r || null;
}
function tmt(i) {
  let t = [], e = null;
  return i.forEach((n) => {
    const s = _pt(Be.cssPrefix, n);
    s ? e = s : n && t.push(n);
  }), {
    iconName: e,
    rest: t
  };
}
function BO(i) {
  return i.sort().filter((t, e, n) => n.indexOf(t) === e);
}
function _G(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: e = !1
  } = t;
  let n = null;
  const s = ZL.concat(fpt), r = BO(i.filter((d) => s.includes(d))), a = BO(i.filter((d) => !ZL.includes(d))), o = r.filter((d) => (n = d, !UU.includes(d))), [l = null] = o, c = qpt(r), u = Ze(Ze({}, tmt(a)), {}, {
    prefix: HG(l, {
      family: c
    })
  });
  return Ze(Ze(Ze({}, u), smt({
    values: i,
    family: c,
    styles: Z2,
    config: Be,
    canonical: u,
    givenPrefix: n
  })), emt(e, n, u));
}
function emt(i, t, e) {
  let {
    prefix: n,
    iconName: s
  } = e;
  if (i || !n || !s)
    return {
      prefix: n,
      iconName: s
    };
  const r = t === "fa" ? cP(s) : {}, a = Jp(n, s);
  return s = r.iconName || a || s, n = r.prefix || n, n === "far" && !Z2.far && Z2.fas && !Be.autoFetchSvg && (n = "fas"), {
    prefix: n,
    iconName: s
  };
}
const nmt = PU.filter((i) => i !== ra || i !== BG), imt = Object.keys(yL).filter((i) => i !== ra).map((i) => Object.keys(yL[i])).flat();
function smt(i) {
  const {
    values: t,
    family: e,
    canonical: n,
    givenPrefix: s = "",
    styles: r = {},
    config: a = {}
  } = i, o = e === BG, l = t.includes("fa-duotone") || t.includes("fad"), c = a.familyDefault === "duotone", u = n.prefix === "fad" || n.prefix === "fa-duotone";
  if (!o && (l || c || u) && (n.prefix = "fad"), (t.includes("fa-brands") || t.includes("fab")) && (n.prefix = "fab"), !n.prefix && nmt.includes(e) && (Object.keys(r).find((h) => imt.includes(h)) || a.autoFetchSvg)) {
    const h = lpt.get(e).defaultShortPrefixId;
    n.prefix = h, n.iconName = Jp(n.prefix, n.iconName) || n.iconName;
  }
  return (n.prefix === "fa" || s === "fa") && (n.prefix = Hh() || "fas"), n;
}
class rmt {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
      e[n] = arguments[n];
    const s = e.reduce(this._pullDefinitions, {});
    Object.keys(s).forEach((r) => {
      this.definitions[r] = Ze(Ze({}, this.definitions[r] || {}), s[r]), xL(r, s[r]);
      const a = eC[ra][r];
      a && xL(a, s[r]), lP();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(t, e) {
    const n = e.prefix && e.iconName && e.icon ? {
      0: e
    } : e;
    return Object.keys(n).map((s) => {
      const {
        prefix: r,
        iconName: a,
        icon: o
      } = n[s], l = o[2];
      t[r] || (t[r] = {}), l.length > 0 && l.forEach((c) => {
        typeof c == "string" && (t[r][c] = o);
      }), t[r][a] = o;
    }), t;
  }
}
let KO = [], Mb = {};
const vb = {}, amt = Object.keys(vb);
function omt(i, t) {
  let {
    mixoutsTo: e
  } = t;
  return KO = i, Mb = {}, Object.keys(vb).forEach((n) => {
    amt.indexOf(n) === -1 && delete vb[n];
  }), KO.forEach((n) => {
    const s = n.mixout ? n.mixout() : {};
    if (Object.keys(s).forEach((r) => {
      typeof s[r] == "function" && (e[r] = s[r]), typeof s[r] == "object" && Object.keys(s[r]).forEach((a) => {
        e[r] || (e[r] = {}), e[r][a] = s[r][a];
      });
    }), n.hooks) {
      const r = n.hooks();
      Object.keys(r).forEach((a) => {
        Mb[a] || (Mb[a] = []), Mb[a].push(r[a]);
      });
    }
    n.provides && n.provides(vb);
  }), e;
}
function SL(i, t) {
  for (var e = arguments.length, n = new Array(e > 2 ? e - 2 : 0), s = 2; s < e; s++)
    n[s - 2] = arguments[s];
  return (Mb[i] || []).forEach((a) => {
    t = a.apply(null, [t, ...n]);
  }), t;
}
function y0(i) {
  for (var t = arguments.length, e = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    e[n - 1] = arguments[n];
  (Mb[i] || []).forEach((r) => {
    r.apply(null, e);
  });
}
function _h() {
  const i = arguments[0], t = Array.prototype.slice.call(arguments, 1);
  return vb[i] ? vb[i].apply(null, t) : void 0;
}
function LL(i) {
  i.prefix === "fa" && (i.prefix = "fas");
  let {
    iconName: t
  } = i;
  const e = i.prefix || Hh();
  if (t)
    return t = Jp(e, t) || t, JO(dP.definitions, e, t) || JO(Oc.styles, e, t);
}
const dP = new rmt(), lmt = () => {
  Be.autoReplaceSvg = !1, Be.observeMutations = !1, y0("noAuto");
}, cmt = {
  i2svg: function() {
    let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return bd ? (y0("beforeI2svg", i), _h("pseudoElements2svg", i), _h("i2svg", i)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: t
    } = i;
    Be.autoReplaceSvg === !1 && (Be.autoReplaceSvg = !0), Be.observeMutations = !0, Ppt(() => {
      dmt({
        autoReplaceSvgRoot: t
      }), y0("watch", i);
    });
  }
}, umt = {
  icon: (i) => {
    if (i === null)
      return null;
    if (typeof i == "object" && i.prefix && i.iconName)
      return {
        prefix: i.prefix,
        iconName: Jp(i.prefix, i.iconName) || i.iconName
      };
    if (Array.isArray(i) && i.length === 2) {
      const t = i[1].indexOf("fa-") === 0 ? i[1].slice(3) : i[1], e = HG(i[0]);
      return {
        prefix: e,
        iconName: Jp(e, t) || t
      };
    }
    if (typeof i == "string" && (i.indexOf("".concat(Be.cssPrefix, "-")) > -1 || i.match(Vpt))) {
      const t = _G(i.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: t.prefix || Hh(),
        iconName: Jp(t.prefix, t.iconName) || t.iconName
      };
    }
    if (typeof i == "string") {
      const t = Hh();
      return {
        prefix: t,
        iconName: Jp(t, i) || i
      };
    }
  }
}, Io = {
  noAuto: lmt,
  config: Be,
  dom: cmt,
  parse: umt,
  library: dP,
  findIconDefinition: LL,
  toHtml: OT
}, dmt = function() {
  let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: t = Ui
  } = i;
  (Object.keys(Oc.styles).length > 0 || Be.autoFetchSvg) && bd && Be.autoReplaceSvg && Io.dom.i2svg({
    node: t
  });
};
function QG(i, t) {
  return Object.defineProperty(i, "abstract", {
    get: t
  }), Object.defineProperty(i, "html", {
    get: function() {
      return i.abstract.map((e) => OT(e));
    }
  }), Object.defineProperty(i, "node", {
    get: function() {
      if (!bd) return;
      const e = Ui.createElement("div");
      return e.innerHTML = i.html, e.children;
    }
  }), i;
}
function hmt(i) {
  let {
    children: t,
    main: e,
    mask: n,
    attributes: s,
    styles: r,
    transform: a
  } = i;
  if (iC(a) && e.found && !n.found) {
    const {
      width: o,
      height: l
    } = e, c = {
      x: o / l / 2,
      y: 0.5
    };
    s.style = KG(Ze(Ze({}, r), {}, {
      "transform-origin": "".concat(c.x + a.x / 16, "em ").concat(c.y + a.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: s,
    children: t
  }];
}
function pmt(i) {
  let {
    prefix: t,
    iconName: e,
    children: n,
    attributes: s,
    symbol: r
  } = i;
  const a = r === !0 ? "".concat(t, "-").concat(Be.cssPrefix, "-").concat(e) : r;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: Ze(Ze({}, s), {}, {
        id: a
      }),
      children: n
    }]
  }];
}
function aC(i) {
  const {
    icons: {
      main: t,
      mask: e
    },
    prefix: n,
    iconName: s,
    transform: r,
    symbol: a,
    title: o,
    maskId: l,
    titleId: c,
    extra: u,
    watchable: d = !1
  } = i, {
    width: h,
    height: p
  } = e.found ? e : t, m = ppt.includes(n), b = [Be.replacementClass, s ? "".concat(Be.cssPrefix, "-").concat(s) : ""].filter((M) => u.classes.indexOf(M) === -1).filter((M) => M !== "" || !!M).concat(u.classes).join(" ");
  let y = {
    children: [],
    attributes: Ze(Ze({}, u.attributes), {}, {
      "data-prefix": n,
      "data-icon": s,
      class: b,
      role: u.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(h, " ").concat(p)
    })
  };
  const Z = m && !~u.classes.indexOf("fa-fw") ? {
    width: "".concat(h / p * 16 * 0.0625, "em")
  } : {};
  d && (y.attributes[g0] = ""), o && (y.children.push({
    tag: "title",
    attributes: {
      id: y.attributes["aria-labelledby"] || "title-".concat(c || y2())
    },
    children: [o]
  }), delete y.attributes.title);
  const g = Ze(Ze({}, y), {}, {
    prefix: n,
    iconName: s,
    main: t,
    mask: e,
    maskId: l,
    transform: r,
    symbol: a,
    styles: Ze(Ze({}, Z), u.styles)
  }), {
    children: f,
    attributes: T
  } = e.found && t.found ? _h("generateAbstractMask", g) || {
    children: [],
    attributes: {}
  } : _h("generateAbstractIcon", g) || {
    children: [],
    attributes: {}
  };
  return g.children = f, g.attributes = T, a ? pmt(g) : hmt(g);
}
function HO(i) {
  const {
    content: t,
    width: e,
    height: n,
    transform: s,
    title: r,
    extra: a,
    watchable: o = !1
  } = i, l = Ze(Ze(Ze({}, a.attributes), r ? {
    title: r
  } : {}), {}, {
    class: a.classes.join(" ")
  });
  o && (l[g0] = "");
  const c = Ze({}, a.styles);
  iC(s) && (c.transform = Fpt({
    transform: s,
    startCentered: !0,
    width: e,
    height: n
  }), c["-webkit-transform"] = c.transform);
  const u = KG(c);
  u.length > 0 && (l.style = u);
  const d = [];
  return d.push({
    tag: "span",
    attributes: l,
    children: [t]
  }), r && d.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [r]
  }), d;
}
function mmt(i) {
  const {
    content: t,
    title: e,
    extra: n
  } = i, s = Ze(Ze(Ze({}, n.attributes), e ? {
    title: e
  } : {}), {}, {
    class: n.classes.join(" ")
  }), r = KG(n.styles);
  r.length > 0 && (s.style = r);
  const a = [];
  return a.push({
    tag: "span",
    attributes: s,
    children: [t]
  }), e && a.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [e]
  }), a;
}
const {
  styles: _x
} = Oc;
function VL(i) {
  const t = i[0], e = i[1], [n] = i.slice(4);
  let s = null;
  return Array.isArray(n) ? s = {
    tag: "g",
    attributes: {
      class: "".concat(Be.cssPrefix, "-").concat(Bx.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(Be.cssPrefix, "-").concat(Bx.SECONDARY),
        fill: "currentColor",
        d: n[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(Be.cssPrefix, "-").concat(Bx.PRIMARY),
        fill: "currentColor",
        d: n[1]
      }
    }]
  } : s = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: n
    }
  }, {
    found: !0,
    width: t,
    height: e,
    icon: s
  };
}
const bmt = {
  found: !1,
  width: 512,
  height: 512
};
function fmt(i, t) {
  !KU && !Be.showMissingIcons && i && console.error('Icon with name "'.concat(i, '" and prefix "').concat(t, '" is missing.'));
}
function XL(i, t) {
  let e = t;
  return t === "fa" && Be.styleDefault !== null && (t = Hh()), new Promise((n, s) => {
    if (e === "fa") {
      const r = cP(i) || {};
      i = r.iconName || i, t = r.prefix || t;
    }
    if (i && t && _x[t] && _x[t][i]) {
      const r = _x[t][i];
      return n(VL(r));
    }
    fmt(i, t), n(Ze(Ze({}, bmt), {}, {
      icon: Be.showMissingIcons && i ? _h("missingIconAbstract") || {} : {}
    }));
  });
}
const _O = () => {
}, IL = Be.measurePerformance && fM && fM.mark && fM.measure ? fM : {
  mark: _O,
  measure: _O
}, wy = 'FA "6.7.2"', gmt = (i) => (IL.mark("".concat(wy, " ").concat(i, " begins")), () => hP(i)), hP = (i) => {
  IL.mark("".concat(wy, " ").concat(i, " ends")), IL.measure("".concat(wy, " ").concat(i), "".concat(wy, " ").concat(i, " begins"), "".concat(wy, " ").concat(i, " ends"));
};
var oC = {
  begin: gmt,
  end: hP
};
const pN = () => {
};
function QO(i) {
  return typeof (i.getAttribute ? i.getAttribute(g0) : null) == "string";
}
function ymt(i) {
  const t = i.getAttribute ? i.getAttribute(qI) : null, e = i.getAttribute ? i.getAttribute(tC) : null;
  return t && e;
}
function Zmt(i) {
  return i && i.classList && i.classList.contains && i.classList.contains(Be.replacementClass);
}
function Tmt() {
  return Be.autoReplaceSvg === !0 ? mN.replace : mN[Be.autoReplaceSvg] || mN.replace;
}
function Mmt(i) {
  return Ui.createElementNS("http://www.w3.org/2000/svg", i);
}
function Nmt(i) {
  return Ui.createElement(i);
}
function pP(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: e = i.tag === "svg" ? Mmt : Nmt
  } = t;
  if (typeof i == "string")
    return Ui.createTextNode(i);
  const n = e(i.tag);
  return Object.keys(i.attributes || []).forEach(function(r) {
    n.setAttribute(r, i.attributes[r]);
  }), (i.children || []).forEach(function(r) {
    n.appendChild(pP(r, {
      ceFn: e
    }));
  }), n;
}
function Wmt(i) {
  let t = " ".concat(i.outerHTML, " ");
  return t = "".concat(t, "Font Awesome fontawesome.com "), t;
}
const mN = {
  replace: function(i) {
    const t = i[0];
    if (t.parentNode)
      if (i[1].forEach((e) => {
        t.parentNode.insertBefore(pP(e), t);
      }), t.getAttribute(g0) === null && Be.keepOriginalSource) {
        let e = Ui.createComment(Wmt(t));
        t.parentNode.replaceChild(e, t);
      } else
        t.remove();
  },
  nest: function(i) {
    const t = i[0], e = i[1];
    if (~nC(t).indexOf(Be.replacementClass))
      return mN.replace(i);
    const n = new RegExp("".concat(Be.cssPrefix, "-.*"));
    if (delete e[0].attributes.id, e[0].attributes.class) {
      const r = e[0].attributes.class.split(" ").reduce((a, o) => (o === Be.replacementClass || o.match(n) ? a.toSvg.push(o) : a.toNode.push(o), a), {
        toNode: [],
        toSvg: []
      });
      e[0].attributes.class = r.toSvg.join(" "), r.toNode.length === 0 ? t.removeAttribute("class") : t.setAttribute("class", r.toNode.join(" "));
    }
    const s = e.map((r) => OT(r)).join(`
`);
    t.setAttribute(g0, ""), t.innerHTML = s;
  }
};
function $O(i) {
  i();
}
function mP(i, t) {
  const e = typeof t == "function" ? t : pN;
  if (i.length === 0)
    e();
  else {
    let n = $O;
    Be.mutateApproach === xpt && (n = Kh.requestAnimationFrame || $O), n(() => {
      const s = Tmt(), r = oC.begin("mutate");
      i.map(s), r(), e();
    });
  }
}
let lC = !1;
function bP() {
  lC = !0;
}
function CL() {
  lC = !1;
}
let MW = null;
function qO(i) {
  if (!EO || !Be.observeMutations)
    return;
  const {
    treeCallback: t = pN,
    nodeCallback: e = pN,
    pseudoElementsCallback: n = pN,
    observeMutationsRoot: s = Ui
  } = i;
  MW = new EO((r) => {
    if (lC) return;
    const a = Hh();
    Ig(r).forEach((o) => {
      if (o.type === "childList" && o.addedNodes.length > 0 && !QO(o.addedNodes[0]) && (Be.searchPseudoElements && n(o.target), t(o.target)), o.type === "attributes" && o.target.parentNode && Be.searchPseudoElements && n(o.target.parentNode), o.type === "attributes" && QO(o.target) && ~Cpt.indexOf(o.attributeName))
        if (o.attributeName === "class" && ymt(o.target)) {
          const {
            prefix: l,
            iconName: c
          } = _G(nC(o.target));
          o.target.setAttribute(qI, l || a), c && o.target.setAttribute(tC, c);
        } else Zmt(o.target) && e(o.target);
    });
  }), bd && MW.observe(s, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function Gmt() {
  MW && MW.disconnect();
}
function wmt(i) {
  const t = i.getAttribute("style");
  let e = [];
  return t && (e = t.split(";").reduce((n, s) => {
    const r = s.split(":"), a = r[0], o = r.slice(1);
    return a && o.length > 0 && (n[a] = o.join(":").trim()), n;
  }, {})), e;
}
function xmt(i) {
  const t = i.getAttribute("data-prefix"), e = i.getAttribute("data-icon"), n = i.innerText !== void 0 ? i.innerText.trim() : "";
  let s = _G(nC(i));
  return s.prefix || (s.prefix = Hh()), t && e && (s.prefix = t, s.iconName = e), s.iconName && s.prefix || (s.prefix && n.length > 0 && (s.iconName = Qpt(s.prefix, i.innerText) || rC(s.prefix, wL(i.innerText))), !s.iconName && Be.autoFetchSvg && i.firstChild && i.firstChild.nodeType === Node.TEXT_NODE && (s.iconName = i.firstChild.data)), s;
}
function Smt(i) {
  const t = Ig(i.attributes).reduce((s, r) => (s.name !== "class" && s.name !== "style" && (s[r.name] = r.value), s), {}), e = i.getAttribute("title"), n = i.getAttribute("data-fa-title-id");
  return Be.autoA11y && (e ? t["aria-labelledby"] = "".concat(Be.replacementClass, "-title-").concat(n || y2()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
}
function Lmt() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: Dc,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function t5(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: e,
    prefix: n,
    rest: s
  } = xmt(i), r = Smt(i), a = SL("parseNodeAttributes", {}, i);
  let o = t.styleParser ? wmt(i) : [];
  return Ze({
    iconName: e,
    title: i.getAttribute("title"),
    titleId: i.getAttribute("data-fa-title-id"),
    prefix: n,
    transform: Dc,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: s,
      styles: o,
      attributes: r
    }
  }, a);
}
const {
  styles: Vmt
} = Oc;
function fP(i) {
  const t = Be.autoReplaceSvg === "nest" ? t5(i, {
    styleParser: !1
  }) : t5(i);
  return ~t.extra.classes.indexOf(_U) ? _h("generateLayersText", i, t) : _h("generateSvgReplacementMutation", i, t);
}
function Xmt() {
  return [...upt, ...ZL];
}
function e5(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!bd) return Promise.resolve();
  const e = Ui.documentElement.classList, n = (u) => e.add("".concat(jO, "-").concat(u)), s = (u) => e.remove("".concat(jO, "-").concat(u)), r = Be.autoFetchSvg ? Xmt() : UU.concat(Object.keys(Vmt));
  r.includes("fa") || r.push("fa");
  const a = [".".concat(_U, ":not([").concat(g0, "])")].concat(r.map((u) => ".".concat(u, ":not([").concat(g0, "])"))).join(", ");
  if (a.length === 0)
    return Promise.resolve();
  let o = [];
  try {
    o = Ig(i.querySelectorAll(a));
  } catch {
  }
  if (o.length > 0)
    n("pending"), s("complete");
  else
    return Promise.resolve();
  const l = oC.begin("onTree"), c = o.reduce((u, d) => {
    try {
      const h = fP(d);
      h && u.push(h);
    } catch (h) {
      KU || h.name === "MissingIcon" && console.error(h);
    }
    return u;
  }, []);
  return new Promise((u, d) => {
    Promise.all(c).then((h) => {
      mP(h, () => {
        n("active"), n("complete"), s("pending"), typeof t == "function" && t(), l(), u();
      });
    }).catch((h) => {
      l(), d(h);
    });
  });
}
function Imt(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  fP(i).then((e) => {
    e && mP([e], t);
  });
}
function Cmt(i) {
  return function(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = (t || {}).icon ? t : LL(t || {});
    let {
      mask: s
    } = e;
    return s && (s = (s || {}).icon ? s : LL(s || {})), i(n, Ze(Ze({}, e), {}, {
      mask: s
    }));
  };
}
const Ymt = function(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: e = Dc,
    symbol: n = !1,
    mask: s = null,
    maskId: r = null,
    title: a = null,
    titleId: o = null,
    classes: l = [],
    attributes: c = {},
    styles: u = {}
  } = t;
  if (!i) return;
  const {
    prefix: d,
    iconName: h,
    icon: p
  } = i;
  return QG(Ze({
    type: "icon"
  }, i), () => (y0("beforeDOMElementCreation", {
    iconDefinition: i,
    params: t
  }), Be.autoA11y && (a ? c["aria-labelledby"] = "".concat(Be.replacementClass, "-title-").concat(o || y2()) : (c["aria-hidden"] = "true", c.focusable = "false")), aC({
    icons: {
      main: VL(p),
      mask: s ? VL(s.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: d,
    iconName: h,
    transform: Ze(Ze({}, Dc), e),
    symbol: n,
    title: a,
    maskId: r,
    titleId: o,
    extra: {
      attributes: c,
      styles: u,
      classes: l
    }
  })));
};
var vmt = {
  mixout() {
    return {
      icon: Cmt(Ymt)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(i) {
        return i.treeCallback = e5, i.nodeCallback = Imt, i;
      }
    };
  },
  provides(i) {
    i.i2svg = function(t) {
      const {
        node: e = Ui,
        callback: n = () => {
        }
      } = t;
      return e5(e, n);
    }, i.generateSvgReplacementMutation = function(t, e) {
      const {
        iconName: n,
        title: s,
        titleId: r,
        prefix: a,
        transform: o,
        symbol: l,
        mask: c,
        maskId: u,
        extra: d
      } = e;
      return new Promise((h, p) => {
        Promise.all([XL(n, a), c.iconName ? XL(c.iconName, c.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((m) => {
          let [b, y] = m;
          h([t, aC({
            icons: {
              main: b,
              mask: y
            },
            prefix: a,
            iconName: n,
            transform: o,
            symbol: l,
            maskId: u,
            title: s,
            titleId: r,
            extra: d,
            watchable: !0
          })]);
        }).catch(p);
      });
    }, i.generateAbstractIcon = function(t) {
      let {
        children: e,
        attributes: n,
        main: s,
        transform: r,
        styles: a
      } = t;
      const o = KG(a);
      o.length > 0 && (n.style = o);
      let l;
      return iC(r) && (l = _h("generateAbstractTransformGrouping", {
        main: s,
        transform: r,
        containerWidth: s.width,
        iconWidth: s.width
      })), e.push(l || s.icon), {
        children: e,
        attributes: n
      };
    };
  }
}, Rmt = {
  mixout() {
    return {
      layer(i) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: e = []
        } = t;
        return QG({
          type: "layer"
        }, () => {
          y0("beforeDOMElementCreation", {
            assembler: i,
            params: t
          });
          let n = [];
          return i((s) => {
            Array.isArray(s) ? s.map((r) => {
              n = n.concat(r.abstract);
            }) : n = n.concat(s.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(Be.cssPrefix, "-layers"), ...e].join(" ")
            },
            children: n
          }];
        });
      }
    };
  }
}, Dmt = {
  mixout() {
    return {
      counter(i) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: e = null,
          classes: n = [],
          attributes: s = {},
          styles: r = {}
        } = t;
        return QG({
          type: "counter",
          content: i
        }, () => (y0("beforeDOMElementCreation", {
          content: i,
          params: t
        }), mmt({
          content: i.toString(),
          title: e,
          extra: {
            attributes: s,
            styles: r,
            classes: ["".concat(Be.cssPrefix, "-layers-counter"), ...n]
          }
        })));
      }
    };
  }
}, Omt = {
  mixout() {
    return {
      text(i) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: e = Dc,
          title: n = null,
          classes: s = [],
          attributes: r = {},
          styles: a = {}
        } = t;
        return QG({
          type: "text",
          content: i
        }, () => (y0("beforeDOMElementCreation", {
          content: i,
          params: t
        }), HO({
          content: i,
          transform: Ze(Ze({}, Dc), e),
          title: n,
          extra: {
            attributes: r,
            styles: a,
            classes: ["".concat(Be.cssPrefix, "-layers-text"), ...s]
          }
        })));
      }
    };
  },
  provides(i) {
    i.generateLayersText = function(t, e) {
      const {
        title: n,
        transform: s,
        extra: r
      } = e;
      let a = null, o = null;
      if (FU) {
        const l = parseInt(getComputedStyle(t).fontSize, 10), c = t.getBoundingClientRect();
        a = c.width / l, o = c.height / l;
      }
      return Be.autoA11y && !n && (r.attributes["aria-hidden"] = "true"), Promise.resolve([t, HO({
        content: t.innerHTML,
        width: a,
        height: o,
        transform: s,
        title: n,
        extra: r,
        watchable: !0
      })]);
    };
  }
};
const zmt = new RegExp('"', "ug"), n5 = [1105920, 1112319], i5 = Ze(Ze(Ze(Ze({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), opt), Gpt), gpt), YL = Object.keys(i5).reduce((i, t) => (i[t.toLowerCase()] = i5[t], i), {}), Emt = Object.keys(YL).reduce((i, t) => {
  const e = YL[t];
  return i[t] = e[900] || [...Object.entries(e)][0][1], i;
}, {});
function kmt(i) {
  const t = i.replace(zmt, ""), e = Apt(t, 0), n = e >= n5[0] && e <= n5[1], s = t.length === 2 ? t[0] === t[1] : !1;
  return {
    value: wL(s ? t[0] : t),
    isSecondary: n || s
  };
}
function Fmt(i, t) {
  const e = i.replace(/^['"]|['"]$/g, "").toLowerCase(), n = parseInt(t), s = isNaN(n) ? "normal" : n;
  return (YL[e] || {})[s] || Emt[e];
}
function s5(i, t) {
  const e = "".concat(wpt).concat(t.replace(":", "-"));
  return new Promise((n, s) => {
    if (i.getAttribute(e) !== null)
      return n();
    const a = Ig(i.children).filter((h) => h.getAttribute(ML) === t)[0], o = Kh.getComputedStyle(i, t), l = o.getPropertyValue("font-family"), c = l.match(Xpt), u = o.getPropertyValue("font-weight"), d = o.getPropertyValue("content");
    if (a && !c)
      return i.removeChild(a), n();
    if (c && d !== "none" && d !== "") {
      const h = o.getPropertyValue("content");
      let p = Fmt(l, u);
      const {
        value: m,
        isSecondary: b
      } = kmt(h), y = c[0].startsWith("FontAwesome");
      let Z = rC(p, m), g = Z;
      if (y) {
        const f = $pt(m);
        f.iconName && f.prefix && (Z = f.iconName, p = f.prefix);
      }
      if (Z && !b && (!a || a.getAttribute(qI) !== p || a.getAttribute(tC) !== g)) {
        i.setAttribute(e, g), a && i.removeChild(a);
        const f = Lmt(), {
          extra: T
        } = f;
        T.attributes[ML] = t, XL(Z, p).then((M) => {
          const N = aC(Ze(Ze({}, f), {}, {
            icons: {
              main: M,
              mask: uP()
            },
            prefix: p,
            iconName: g,
            extra: T,
            watchable: !0
          })), W = Ui.createElementNS("http://www.w3.org/2000/svg", "svg");
          t === "::before" ? i.insertBefore(W, i.firstChild) : i.appendChild(W), W.outerHTML = N.map((x) => OT(x)).join(`
`), i.removeAttribute(e), n();
        }).catch(s);
      } else
        n();
    } else
      n();
  });
}
function jmt(i) {
  return Promise.all([s5(i, "::before"), s5(i, "::after")]);
}
function Umt(i) {
  return i.parentNode !== document.head && !~Spt.indexOf(i.tagName.toUpperCase()) && !i.getAttribute(ML) && (!i.parentNode || i.parentNode.tagName !== "svg");
}
function r5(i) {
  if (bd)
    return new Promise((t, e) => {
      const n = Ig(i.querySelectorAll("*")).filter(Umt).map(jmt), s = oC.begin("searchPseudoElements");
      bP(), Promise.all(n).then(() => {
        s(), CL(), t();
      }).catch(() => {
        s(), CL(), e();
      });
    });
}
var Pmt = {
  hooks() {
    return {
      mutationObserverCallbacks(i) {
        return i.pseudoElementsCallback = r5, i;
      }
    };
  },
  provides(i) {
    i.pseudoElements2svg = function(t) {
      const {
        node: e = Ui
      } = t;
      Be.searchPseudoElements && r5(e);
    };
  }
};
let a5 = !1;
var Jmt = {
  mixout() {
    return {
      dom: {
        unwatch() {
          bP(), a5 = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        qO(SL("mutationObserverCallbacks", {}));
      },
      noAuto() {
        Gmt();
      },
      watch(i) {
        const {
          observeMutationsRoot: t
        } = i;
        a5 ? CL() : qO(SL("mutationObserverCallbacks", {
          observeMutationsRoot: t
        }));
      }
    };
  }
};
const o5 = (i) => {
  let t = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return i.toLowerCase().split(" ").reduce((e, n) => {
    const s = n.toLowerCase().split("-"), r = s[0];
    let a = s.slice(1).join("-");
    if (r && a === "h")
      return e.flipX = !0, e;
    if (r && a === "v")
      return e.flipY = !0, e;
    if (a = parseFloat(a), isNaN(a))
      return e;
    switch (r) {
      case "grow":
        e.size = e.size + a;
        break;
      case "shrink":
        e.size = e.size - a;
        break;
      case "left":
        e.x = e.x - a;
        break;
      case "right":
        e.x = e.x + a;
        break;
      case "up":
        e.y = e.y - a;
        break;
      case "down":
        e.y = e.y + a;
        break;
      case "rotate":
        e.rotate = e.rotate + a;
        break;
    }
    return e;
  }, t);
};
var Amt = {
  mixout() {
    return {
      parse: {
        transform: (i) => o5(i)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(i, t) {
        const e = t.getAttribute("data-fa-transform");
        return e && (i.transform = o5(e)), i;
      }
    };
  },
  provides(i) {
    i.generateAbstractTransformGrouping = function(t) {
      let {
        main: e,
        transform: n,
        containerWidth: s,
        iconWidth: r
      } = t;
      const a = {
        transform: "translate(".concat(s / 2, " 256)")
      }, o = "translate(".concat(n.x * 32, ", ").concat(n.y * 32, ") "), l = "scale(".concat(n.size / 16 * (n.flipX ? -1 : 1), ", ").concat(n.size / 16 * (n.flipY ? -1 : 1), ") "), c = "rotate(".concat(n.rotate, " 0 0)"), u = {
        transform: "".concat(o, " ").concat(l, " ").concat(c)
      }, d = {
        transform: "translate(".concat(r / 2 * -1, " -256)")
      }, h = {
        outer: a,
        inner: u,
        path: d
      };
      return {
        tag: "g",
        attributes: Ze({}, h.outer),
        children: [{
          tag: "g",
          attributes: Ze({}, h.inner),
          children: [{
            tag: e.icon.tag,
            children: e.icon.children,
            attributes: Ze(Ze({}, e.icon.attributes), h.path)
          }]
        }]
      };
    };
  }
};
const Qx = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function l5(i) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return i.attributes && (i.attributes.fill || t) && (i.attributes.fill = "black"), i;
}
function Bmt(i) {
  return i.tag === "g" ? i.children : [i];
}
var Kmt = {
  hooks() {
    return {
      parseNodeAttributes(i, t) {
        const e = t.getAttribute("data-fa-mask"), n = e ? _G(e.split(" ").map((s) => s.trim())) : uP();
        return n.prefix || (n.prefix = Hh()), i.mask = n, i.maskId = t.getAttribute("data-fa-mask-id"), i;
      }
    };
  },
  provides(i) {
    i.generateAbstractMask = function(t) {
      let {
        children: e,
        attributes: n,
        main: s,
        mask: r,
        maskId: a,
        transform: o
      } = t;
      const {
        width: l,
        icon: c
      } = s, {
        width: u,
        icon: d
      } = r, h = kpt({
        transform: o,
        containerWidth: u,
        iconWidth: l
      }), p = {
        tag: "rect",
        attributes: Ze(Ze({}, Qx), {}, {
          fill: "white"
        })
      }, m = c.children ? {
        children: c.children.map(l5)
      } : {}, b = {
        tag: "g",
        attributes: Ze({}, h.inner),
        children: [l5(Ze({
          tag: c.tag,
          attributes: Ze(Ze({}, c.attributes), h.path)
        }, m))]
      }, y = {
        tag: "g",
        attributes: Ze({}, h.outer),
        children: [b]
      }, Z = "mask-".concat(a || y2()), g = "clip-".concat(a || y2()), f = {
        tag: "mask",
        attributes: Ze(Ze({}, Qx), {}, {
          id: Z,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [p, y]
      }, T = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: g
          },
          children: Bmt(d)
        }, f]
      };
      return e.push(T, {
        tag: "rect",
        attributes: Ze({
          fill: "currentColor",
          "clip-path": "url(#".concat(g, ")"),
          mask: "url(#".concat(Z, ")")
        }, Qx)
      }), {
        children: e,
        attributes: n
      };
    };
  }
}, Hmt = {
  provides(i) {
    let t = !1;
    Kh.matchMedia && (t = Kh.matchMedia("(prefers-reduced-motion: reduce)").matches), i.missingIconAbstract = function() {
      const e = [], n = {
        fill: "currentColor"
      }, s = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      e.push({
        tag: "path",
        attributes: Ze(Ze({}, n), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      const r = Ze(Ze({}, s), {}, {
        attributeName: "opacity"
      }), a = {
        tag: "circle",
        attributes: Ze(Ze({}, n), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return t || a.children.push({
        tag: "animate",
        attributes: Ze(Ze({}, s), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: Ze(Ze({}, r), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), e.push(a), e.push({
        tag: "path",
        attributes: Ze(Ze({}, n), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: t ? [] : [{
          tag: "animate",
          attributes: Ze(Ze({}, r), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), t || e.push({
        tag: "path",
        attributes: Ze(Ze({}, n), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: Ze(Ze({}, r), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: e
      };
    };
  }
}, _mt = {
  hooks() {
    return {
      parseNodeAttributes(i, t) {
        const e = t.getAttribute("data-fa-symbol"), n = e === null ? !1 : e === "" ? !0 : e;
        return i.symbol = n, i;
      }
    };
  }
}, Qmt = [Upt, vmt, Rmt, Dmt, Omt, Pmt, Jmt, Amt, Kmt, Hmt, _mt];
omt(Qmt, {
  mixoutsTo: Io
});
Io.noAuto;
const gP = Io.config;
Io.library;
Io.dom;
const NW = Io.parse;
Io.findIconDefinition;
Io.toHtml;
const $mt = Io.icon;
Io.layer;
const qmt = Io.text;
Io.counter;
function vL(i, t) {
  (t == null || t > i.length) && (t = i.length);
  for (var e = 0, n = Array(t); e < t; e++) n[e] = i[e];
  return n;
}
function t0t(i) {
  if (Array.isArray(i)) return vL(i);
}
function Ar(i, t, e) {
  return (t = a0t(t)) in i ? Object.defineProperty(i, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : i[t] = e, i;
}
function e0t(i) {
  if (typeof Symbol < "u" && i[Symbol.iterator] != null || i["@@iterator"] != null) return Array.from(i);
}
function n0t() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function c5(i, t) {
  var e = Object.keys(i);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(i);
    t && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(i, s).enumerable;
    })), e.push.apply(e, n);
  }
  return e;
}
function Yl(i) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? c5(Object(e), !0).forEach(function(n) {
      Ar(i, n, e[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(e)) : c5(Object(e)).forEach(function(n) {
      Object.defineProperty(i, n, Object.getOwnPropertyDescriptor(e, n));
    });
  }
  return i;
}
function i0t(i, t) {
  if (i == null) return {};
  var e, n, s = s0t(i, t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(i);
    for (n = 0; n < r.length; n++) e = r[n], t.indexOf(e) === -1 && {}.propertyIsEnumerable.call(i, e) && (s[e] = i[e]);
  }
  return s;
}
function s0t(i, t) {
  if (i == null) return {};
  var e = {};
  for (var n in i) if ({}.hasOwnProperty.call(i, n)) {
    if (t.indexOf(n) !== -1) continue;
    e[n] = i[n];
  }
  return e;
}
function RL(i) {
  return t0t(i) || e0t(i) || o0t(i) || n0t();
}
function r0t(i, t) {
  if (typeof i != "object" || !i) return i;
  var e = i[Symbol.toPrimitive];
  if (e !== void 0) {
    var n = e.call(i, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(i);
}
function a0t(i) {
  var t = r0t(i, "string");
  return typeof t == "symbol" ? t : t + "";
}
function WW(i) {
  "@babel/helpers - typeof";
  return WW = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, WW(i);
}
function o0t(i, t) {
  if (i) {
    if (typeof i == "string") return vL(i, t);
    var e = {}.toString.call(i).slice(8, -1);
    return e === "Object" && i.constructor && (e = i.constructor.name), e === "Map" || e === "Set" ? Array.from(i) : e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? vL(i, t) : void 0;
  }
}
function a2(i, t) {
  return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? Ar({}, i, t) : {};
}
function l0t(i) {
  var t, e = (t = {
    "fa-spin": i.spin,
    "fa-pulse": i.pulse,
    // the fixedWidth property has been deprecated as of version 7.0.0
    "fa-fw": i.fixedWidth,
    "fa-border": i.border,
    "fa-li": i.listItem,
    "fa-inverse": i.inverse,
    "fa-flip": i.flip === !0,
    "fa-flip-horizontal": i.flip === "horizontal" || i.flip === "both",
    "fa-flip-vertical": i.flip === "vertical" || i.flip === "both"
  }, Ar(Ar(Ar(Ar(Ar(Ar(Ar(Ar(Ar(Ar(t, "fa-".concat(i.size), i.size !== null), "fa-rotate-".concat(i.rotation), i.rotation !== null), "fa-rotate-by", i.rotateBy), "fa-pull-".concat(i.pull), i.pull !== null), "fa-swap-opacity", i.swapOpacity), "fa-bounce", i.bounce), "fa-shake", i.shake), "fa-beat", i.beat), "fa-fade", i.fade), "fa-beat-fade", i.beatFade), Ar(Ar(Ar(Ar(t, "fa-flash", i.flash), "fa-spin-pulse", i.spinPulse), "fa-spin-reverse", i.spinReverse), "fa-width-auto", i.widthAuto));
  return Object.keys(e).map(function(n) {
    return e[n] ? n : null;
  }).filter(function(n) {
    return n;
  });
}
var c0t = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, yP = { exports: {} };
(function(i) {
  (function(t) {
    var e = function(Z, g, f) {
      if (!c(g) || d(g) || h(g) || p(g) || l(g))
        return g;
      var T, M = 0, N = 0;
      if (u(g))
        for (T = [], N = g.length; M < N; M++)
          T.push(e(Z, g[M], f));
      else {
        T = {};
        for (var W in g)
          Object.prototype.hasOwnProperty.call(g, W) && (T[Z(W, f)] = e(Z, g[W], f));
      }
      return T;
    }, n = function(Z, g) {
      g = g || {};
      var f = g.separator || "_", T = g.split || /(?=[A-Z])/;
      return Z.split(T).join(f);
    }, s = function(Z) {
      return m(Z) ? Z : (Z = Z.replace(/[\-_\s]+(.)?/g, function(g, f) {
        return f ? f.toUpperCase() : "";
      }), Z.substr(0, 1).toLowerCase() + Z.substr(1));
    }, r = function(Z) {
      var g = s(Z);
      return g.substr(0, 1).toUpperCase() + g.substr(1);
    }, a = function(Z, g) {
      return n(Z, g).toLowerCase();
    }, o = Object.prototype.toString, l = function(Z) {
      return typeof Z == "function";
    }, c = function(Z) {
      return Z === Object(Z);
    }, u = function(Z) {
      return o.call(Z) == "[object Array]";
    }, d = function(Z) {
      return o.call(Z) == "[object Date]";
    }, h = function(Z) {
      return o.call(Z) == "[object RegExp]";
    }, p = function(Z) {
      return o.call(Z) == "[object Boolean]";
    }, m = function(Z) {
      return Z = Z - 0, Z === Z;
    }, b = function(Z, g) {
      var f = g && "process" in g ? g.process : g;
      return typeof f != "function" ? Z : function(T, M) {
        return f(T, Z, M);
      };
    }, y = {
      camelize: s,
      decamelize: a,
      pascalize: r,
      depascalize: a,
      camelizeKeys: function(Z, g) {
        return e(b(s, g), Z);
      },
      decamelizeKeys: function(Z, g) {
        return e(b(a, g), Z, g);
      },
      pascalizeKeys: function(Z, g) {
        return e(b(r, g), Z);
      },
      depascalizeKeys: function() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };
    i.exports ? i.exports = y : t.humps = y;
  })(c0t);
})(yP);
var u0t = yP.exports, d0t = ["class", "style"];
function h0t(i) {
  return i.split(";").map(function(t) {
    return t.trim();
  }).filter(function(t) {
    return t;
  }).reduce(function(t, e) {
    var n = e.indexOf(":"), s = u0t.camelize(e.slice(0, n)), r = e.slice(n + 1).trim();
    return t[s] = r, t;
  }, {});
}
function p0t(i) {
  return i.split(/\s+/).reduce(function(t, e) {
    return t[e] = !0, t;
  }, {});
}
function cC(i) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof i == "string")
    return i;
  var n = (i.children || []).map(function(l) {
    return cC(l);
  }), s = Object.keys(i.attributes || {}).reduce(function(l, c) {
    var u = i.attributes[c];
    switch (c) {
      case "class":
        l.class = p0t(u);
        break;
      case "style":
        l.style = h0t(u);
        break;
      default:
        l.attrs[c] = u;
    }
    return l;
  }, {
    attrs: {},
    class: {},
    style: {}
  });
  e.class;
  var r = e.style, a = r === void 0 ? {} : r, o = i0t(e, d0t);
  return wG(i.tag, Yl(Yl(Yl({}, t), {}, {
    class: s.class,
    style: Yl(Yl({}, s.style), a)
  }, s.attrs), o), n);
}
var ZP = !1;
try {
  ZP = process.env.NODE_ENV === "production";
} catch {
}
function m0t() {
  if (!ZP && console && typeof console.error == "function") {
    var i;
    (i = console).error.apply(i, arguments);
  }
}
function u5(i) {
  if (i && WW(i) === "object" && i.prefix && i.iconName && i.icon)
    return i;
  if (NW.icon)
    return NW.icon(i);
  if (i === null)
    return null;
  if (WW(i) === "object" && i.prefix && i.iconName)
    return i;
  if (Array.isArray(i) && i.length === 2)
    return {
      prefix: i[0],
      iconName: i[1]
    };
  if (typeof i == "string")
    return {
      prefix: "fas",
      iconName: i
    };
}
var b0t = Ne({
  name: "FontAwesomeIcon",
  props: {
    border: {
      type: Boolean,
      default: !1
    },
    // the fixedWidth property has been deprecated as of version 7
    fixedWidth: {
      type: Boolean,
      default: !1
    },
    flip: {
      type: [Boolean, String],
      default: !1,
      validator: function(t) {
        return [!0, !1, "horizontal", "vertical", "both"].indexOf(t) > -1;
      }
    },
    icon: {
      type: [Object, Array, String],
      required: !0
    },
    mask: {
      type: [Object, Array, String],
      default: null
    },
    maskId: {
      type: String,
      default: null
    },
    listItem: {
      type: Boolean,
      default: !1
    },
    pull: {
      type: String,
      default: null,
      validator: function(t) {
        return ["right", "left"].indexOf(t) > -1;
      }
    },
    pulse: {
      type: Boolean,
      default: !1
    },
    rotation: {
      type: [String, Number],
      default: null,
      validator: function(t) {
        return [90, 180, 270].indexOf(Number.parseInt(t, 10)) > -1;
      }
    },
    // the rotateBy property is only supported in version 7.0.0 and later
    rotateBy: {
      type: Boolean,
      default: !1
    },
    swapOpacity: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: null,
      validator: function(t) {
        return ["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"].indexOf(t) > -1;
      }
    },
    spin: {
      type: Boolean,
      default: !1
    },
    transform: {
      type: [String, Object],
      default: null
    },
    symbol: {
      type: [Boolean, String],
      default: !1
    },
    title: {
      type: String,
      default: null
    },
    titleId: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    bounce: {
      type: Boolean,
      default: !1
    },
    shake: {
      type: Boolean,
      default: !1
    },
    beat: {
      type: Boolean,
      default: !1
    },
    fade: {
      type: Boolean,
      default: !1
    },
    beatFade: {
      type: Boolean,
      default: !1
    },
    flash: {
      type: Boolean,
      default: !1
    },
    spinPulse: {
      type: Boolean,
      default: !1
    },
    spinReverse: {
      type: Boolean,
      default: !1
    },
    // the widthAuto property is only supported in version 7.0.0 and later
    widthAuto: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(t, e) {
    var n = e.attrs, s = te(function() {
      return u5(t.icon);
    }), r = te(function() {
      return a2("classes", l0t(t));
    }), a = te(function() {
      return a2("transform", typeof t.transform == "string" ? NW.transform(t.transform) : t.transform);
    }), o = te(function() {
      return a2("mask", u5(t.mask));
    }), l = te(function() {
      var u = Yl(Yl(Yl(Yl({}, r.value), a.value), o.value), {}, {
        symbol: t.symbol,
        maskId: t.maskId
      });
      return u.title = t.title, u.titleId = t.titleId, $mt(s.value, u);
    });
    gn(l, function(u) {
      if (!u)
        return m0t("Could not find one or more icon(s)", s.value, o.value);
    }, {
      immediate: !0
    });
    var c = te(function() {
      return l.value ? cC(l.value.abstract[0], {}, n) : null;
    });
    return function() {
      return c.value;
    };
  }
});
Ne({
  name: "FontAwesomeLayers",
  props: {
    fixedWidth: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(t, e) {
    var n = e.slots, s = gP.familyPrefix, r = te(function() {
      return ["".concat(s, "-layers")].concat(RL(t.fixedWidth ? ["".concat(s, "-fw")] : []));
    });
    return function() {
      return wG("div", {
        class: r.value
      }, n.default ? n.default() : []);
    };
  }
});
Ne({
  name: "FontAwesomeLayersText",
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    transform: {
      type: [String, Object],
      default: null
    },
    counter: {
      type: Boolean,
      default: !1
    },
    position: {
      type: String,
      default: null,
      validator: function(t) {
        return ["bottom-left", "bottom-right", "top-left", "top-right"].indexOf(t) > -1;
      }
    }
  },
  setup: function(t, e) {
    var n = e.attrs, s = gP.familyPrefix, r = te(function() {
      return a2("classes", [].concat(RL(t.counter ? ["".concat(s, "-layers-counter")] : []), RL(t.position ? ["".concat(s, "-layers-").concat(t.position)] : [])));
    }), a = te(function() {
      return a2("transform", typeof t.transform == "string" ? NW.transform(t.transform) : t.transform);
    }), o = te(function() {
      var c = qmt(t.value.toString(), Yl(Yl({}, a.value), r.value)), u = c.abstract;
      return t.counter && (u[0].attributes.class = u[0].attributes.class.replace("fa-layers-text", "")), u[0];
    }), l = te(function() {
      return cC(o.value, {}, n);
    });
    return function() {
      return l.value;
    };
  }
});
function aa() {
  d7(() => {
    var e;
    const i = (e = l0()) == null ? void 0 : e.appContext.app;
    (i == null ? void 0 : i.component("font-awesome-icon")) !== void 0 || (i == null || i.use(l3), i == null || i.component("font-awesome-icon", b0t), i == null || i.component("router-link", {}), i == null || i.directive("tooltip", A7));
  });
}
const zT = /* @__PURE__ */ Ne({
  __name: "ContextMenu",
  props: {
    menuItems: {},
    x: {},
    y: {}
  },
  setup(i) {
    const t = i;
    aa();
    const e = Lt(), n = Lt(), s = Oh(t.menuItems), r = (a) => {
      a.preventDefault();
    };
    return xn(async () => {
      if (document.addEventListener("contextmenu", r, { capture: !0 }), await dg(), n.value && e.value) {
        const { x: a, y: o } = n.value.getBoundingClientRect(), l = new PointerEvent("click", { clientX: a + t.x, clientY: o + t.y });
        e.value.show(l), l.stopImmediatePropagation();
      } else
        throw Error("div.value and/or menu.value is undefined");
    }), wg(() => {
      document.removeEventListener("contextmenu", r, { capture: !0 });
    }), (a, o) => (Mt(), Ot("div", {
      ref_key: "div",
      ref: n,
      style: { position: "absolute" },
      onContextmenuCapture: o[0] || (o[0] = o0(() => {
      }, ["prevent", "stop"]))
    }, [
      Pt(K(xG), {
        ref_key: "menu",
        ref: e,
        model: s
      }, null, 8, ["model"])
    ], 544));
  }
}), f0t = {};
function g0t(i, t) {
  return Mt(), Ot("span", null, ' Hello world, "engine"!');
}
const mDt = /* @__PURE__ */ Dn(f0t, [["render", g0t]]), y0t = Ne({
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(i) {
    return {
      str: Le(i.model.origin)
    };
  }
}), Z0t = { style: { position: "absolute", left: "0", bottom: "0" } };
function T0t(i, t, e, n, s, r) {
  return Mt(), Ot("div", Z0t, pe(i.str), 1);
}
const bDt = /* @__PURE__ */ Dn(y0t, [["render", T0t]]), M0t = { style: { background: "rgba(0, 0, 0, 0.5)", color: "white", "font-size": "14px", "min-width": "50px", padding: "2px", "white-space": "nowrap" } }, N0t = /* @__PURE__ */ Ne({
  __name: "ObjectInfoLabel",
  props: {
    str: {}
  },
  setup(i) {
    return (t, e) => (Mt(), Ot("div", M0t, pe(i.str), 1));
  }
}), TP = /* @__PURE__ */ Ne({
  __name: "ObjectInfos",
  props: {
    model: {},
    view: {},
    viewSize: {},
    viewObjectPositions: {},
    infoFlag: {}
  },
  setup(i) {
    const t = i, e = Le(t.viewSize), n = Le(t.viewObjectPositions), s = Le(t.infoFlag), r = Le(t.model.interactorActive), a = (Z) => {
      if (!e.value)
        return [];
      const g = new DOMRectReadOnly(0, 0, e.value[0], e.value[1]);
      return wht({
        items: Z,
        anchors: n.value.map((f) => f.position),
        bounds: g,
        margin: 20,
        edgeMargin: 5,
        anchorMargin: 20,
        avoidAnchors: !0
      });
    }, o = {}, l = {}, c = {}, u = Lt([]), d = (Z, g, f, T) => [Math.max(0, Math.min(e.value[0] - f, Z)), Math.max(0, Math.min(e.value[1] - T, g))], h = (Z) => {
      u.value.length = 0;
      const g = [], f = [];
      Object.entries(o).forEach(([M, { x: N, y: W }]) => {
        let x = n.value.find((C) => C.id === M);
        if (!x || !x.visible || !x.visibleInView)
          return;
        let { w: V, h: X } = c[M];
        g.push(new DOMRectReadOnly(x.position[0] + N, x.position[1] + W, V, X)), f.push(x);
      });
      let T;
      !Z || r.value ? T = f.map((M, N) => {
        if (l[M.id]) {
          const { x: W, y: x } = l[M.id], { w: V, h: X } = c[M.id];
          return d(M.position[0] + W, M.position[1] + x, V, X);
        } else {
          const { x: W, y: x } = g[N], { w: V, h: X } = c[M.id];
          return d(W, x, V, X);
        }
      }) : T = a(g), T.forEach(([M, N], W) => {
        const x = f[W];
        u.value.push([x, M, N]), l[x.id] = {
          x: M - x.position[0],
          y: N - x.position[1]
        };
      });
    }, m = ((Z, g) => {
      let f;
      return () => {
        window.clearTimeout(f), f = window.setTimeout(Z, g);
      };
    })(() => h(!0), 100);
    gn(n, (Z) => {
      let g = !1;
      Z.forEach((f) => {
        o[f.id] || (o[f.id] = {
          x: 20,
          y: 20
        }, c[f.id] = { w: 0, h: 0 }, g = !0);
      }), Object.keys(o).forEach((f) => {
        n.value.find((T) => T.id === f) || (delete o[f], g = !0);
      }), g ? h(!0) : (h(!1), m());
    }), gn(r, (Z, g) => {
      !Z && g && h(!0);
    });
    const b = (Z, g, f) => {
      c[Z] = { w: g, h: f }, h(!0);
    }, y = (Z, g, f) => {
      o[Z] = { x: g, y: f }, h(!0);
    };
    return (Z, g) => K(s) ? (Mt(!0), Ot(Me, { key: 0 }, Xn(u.value, ([f, T, M]) => as((Mt(), le(RU, {
      key: f.id,
      viewSize: K(e),
      objectPosition: f.position,
      defaultOffset: [20, 20],
      computedPosition: [T, M],
      objectVisible: f.visible && f.visibleInView,
      drawPoint: !0,
      lineStyle: "solid",
      interactive: !0,
      onSizeUpdated: ({ w: N, h: W }) => b(f.id, N, W),
      onPositionUpdated: ({ x: N, y: W }) => y(f.id, N, W)
    }, {
      default: oe(() => [
        Pt(N0t, {
          str: f.name || ""
        }, null, 8, ["str"])
      ]),
      _: 2
    }, 1032, ["viewSize", "objectPosition", "computedPosition", "objectVisible", "onSizeUpdated", "onPositionUpdated"])), [
      [Ss, f.visible && f.name]
    ])), 128)) : Qt("", !0);
  }
});
let DL = null;
function W0t(i) {
  return !!i && typeof i.global < "u";
}
function fDt(i) {
  DL = W0t(i) ? i.global : i;
}
function G0t() {
  return DL || (console.warn("[lib] i18n not initialized. Returning fallback composer."), {
    t: (i) => i
    // just echoes the key back
    // you can add other methods as needed (d, n, locale, etc.)
  });
}
function jt(i, t) {
  const e = G0t();
  return t === void 0 ? e.t(i) : e.t(i, t);
}
const w0t = { class: "tree-container" }, x0t = ["onDblclick", "onClick"], S0t = { class: "ff-roboto-12 wiz-object-list-text" }, L0t = ["onClick"], V0t = ["onClick"], X0t = /* @__PURE__ */ Ne({
  __name: "ObjectList",
  props: {
    objectTree: {},
    initialExpandedKeys: {},
    viewSize: {},
    listSize: { default: () => new qt([250, 419]) },
    additionalTopMargin: { default: 34 },
    initialPosition: {},
    onMultiSelect: {},
    getContextMenuItems: {},
    getContextMenuItemsForKeys: {},
    showDockButton: { type: Boolean },
    parent: {},
    dockEvent: {}
  },
  setup(i) {
    const t = i;
    aa();
    const e = Le(t.viewSize), n = Le(t.listSize), s = Le(t.objectTree), r = (j) => `rgb(${j[0]}, ${j[1]}, ${j[2]})`, a = Oh([]), o = Lt({}), l = Lt([]), c = Lt(null), u = (j) => {
      var $;
      let H = null;
      j.visible !== void 0 && (H = j.visible, o.value[j.key] = {
        checked: j.visible,
        partialChecked: null
      });
      const B = ($ = j.children) == null ? void 0 : $.map((A) => u(A));
      if (B) {
        let A = !0, E = !0;
        for (const ct of B)
          ct.checked === !0 && (A = !1), ct.checked === !1 && (E = !1);
        E && !A ? (H = !0, o.value[j.key] = {
          checked: !0,
          partialChecked: null
        }) : !E && A ? (H = !1, o.value[j.key] = {
          checked: !1,
          partialChecked: null
        }) : (H = null, o.value[j.key] = {
          checked: null,
          partialChecked: !0
        });
      }
      return {
        key: j.key,
        label: j.label,
        checked: H,
        children: B,
        data: {
          color: j.color ? r(j.color) : void 0,
          hasDropdown: j.dropdown !== void 0,
          isLocked: j.isLocked,
          lockDisabled: j.lockDisabled
        }
      };
    };
    gn(
      s,
      () => {
        o.value = {}, a.splice(0, a.length);
        for (const j of s.value.items)
          a.push(u(j));
      },
      {
        immediate: !0
      }
    );
    const d = Lt([]), h = (j) => {
      var B;
      const H = x(j);
      (B = H == null ? void 0 : H.onClick) == null || B.call(H, j);
    }, p = (j) => {
      var B;
      const H = x(j);
      (B = H == null ? void 0 : H.onDoubleClick) == null || B.call(H, j);
    }, m = (j, H, B) => {
      var A, E, ct;
      let $ = [];
      return j.visible !== H && $.push(j.key), H ? (A = j.onSelect) == null || A.call(j, j.key, B) : (E = j.onUnselect) == null || E.call(j, j.key, B), (ct = j.children) == null || ct.forEach((at) => {
        $ = $.concat(m(at, H, B));
      }), $;
    }, b = () => {
      const j = [], H = (B) => {
        if (B.children && B.children.length) {
          B.children.forEach(($) => H($));
          return;
        }
        j.push(B);
      };
      return s.value.items.forEach((B) => H(B)), j;
    }, y = (j) => j.multiSelectGroup ?? "__default__", Z = (j) => {
      const H = x(j);
      if (!H || H.children && H.children.length)
        return !1;
      const B = y(H);
      for (const $ of l.value) {
        const A = x($);
        if (!(!A || A.children && A.children.length) && y(A) !== B)
          return !1;
      }
      return !0;
    }, g = (j) => {
      l.value = Array.from(new Set(j));
    }, f = (j, H) => {
      const B = b(), $ = B.findIndex((Wt) => Wt.key === j), A = B.findIndex((Wt) => Wt.key === H);
      if ($ === -1 || A === -1) {
        g([H]);
        return;
      }
      const E = x(H);
      if (!E) {
        g([H]);
        return;
      }
      const ct = y(E), at = Math.min($, A), dt = Math.max($, A), gt = B.slice(at, dt + 1).filter((Wt) => y(Wt) === ct).map((Wt) => Wt.key);
      g(gt.length ? gt : [H]);
    }, T = (j, H, B) => {
      if (h(H), B)
        return;
      const $ = j.metaKey || j.ctrlKey;
      j.shiftKey && c.value && Z(H) ? f(c.value, H) : $ ? l.value.includes(H) ? g(l.value.filter((A) => A !== H)) : Z(H) ? g([...l.value, H]) : g([H]) : g([H]), c.value = H;
    }, M = (j) => {
      var B;
      if (j.key == null || j.key === "")
        return;
      const H = x(j.key);
      if (H) {
        const $ = H.children !== void 0 && H.children.length > 0, A = m(H, !0, $);
        $ && ((B = t.onMultiSelect) == null || B.call(t, A, !0));
      }
    }, N = (j) => {
      var B;
      if (j.key == null || j.key === "")
        return;
      const H = x(j.key);
      if (H) {
        const $ = H.children !== void 0 && H.children.length > 0, A = m(H, !1, $);
        $ && ((B = t.onMultiSelect) == null || B.call(t, A, !1));
      }
    }, W = {};
    if (t.initialExpandedKeys)
      for (const j of t.initialExpandedKeys)
        W[j] = !0;
    const x = (j) => {
      for (const H of s.value.items) {
        const B = V(H, j);
        if (B) return B;
      }
      return null;
    }, V = (j, H) => {
      if (j.key === H)
        return j;
      if (j.children)
        for (const B of j.children) {
          const $ = V(B, H);
          if ($) return $;
        }
      return null;
    }, X = (j) => {
      var $;
      if (j.length > 1 && t.getContextMenuItemsForKeys) {
        d.value = t.getContextMenuItemsForKeys(j) || [];
        return;
      }
      const H = j[0];
      if (!H) {
        d.value = [];
        return;
      }
      const B = x(H);
      B && B.dropdown ? d.value = (($ = B.dropdown(H)) == null ? void 0 : $.items) || [] : t.getContextMenuItemsForKeys ? d.value = t.getContextMenuItemsForKeys([H]) || [] : B && t.getContextMenuItems ? d.value = t.getContextMenuItems(H) || [] : d.value = [];
    }, C = Lt(), R = (j, H) => {
      var B, $;
      X(H), d.value.length ? (B = C.value) == null || B.toggle(j) : ($ = C.value) == null || $.hide();
    }, z = (j, H) => {
      let B;
      l.value.includes(H) ? B = [...l.value] : (B = [H], g(B)), c.value = H, R(j, B);
    }, F = (j, H) => {
      if (!(H || !l.value.includes(j)))
        return {
          backgroundColor: "rgba(160, 160, 160, 0.25)",
          borderRadius: "4px"
        };
    }, P = (j) => {
      const H = x(j);
      H && !H.lockDisabled && (H.isLocked = !H.isLocked, H.onLockToggle && H.onLockToggle(j));
    };
    return (j, H) => (Mt(), le(QI, {
      collapsible: !0,
      defaultMargin: 10,
      maxHeight: K(n)[1],
      minMargin: 10,
      additionalTopMargin: i.additionalTopMargin,
      viewSize: K(e),
      width: K(n)[0],
      title: K(jt)("implant-planner.objects"),
      initialPosition: i.initialPosition,
      showDockButton: i.showDockButton,
      parent: i.parent,
      dockEvent: i.dockEvent,
      style: { border: "1px solid rgba(218, 218, 218, 0.68)" }
    }, {
      default: oe(() => [
        kt("div", w0t, [
          Pt(K(B7), {
            expandedKeys: W,
            modelValue: a,
            selectionKeys: o.value,
            value: a,
            class: "w-full",
            emptyMessage: "No objects found.",
            responsiveLayout: "scroll",
            selectionMode: "checkbox",
            onNodeSelect: M,
            onNodeUnselect: N
          }, {
            default: oe((B) => {
              var $, A;
              return [
                kt("div", {
                  class: "formgroup-inline w-full",
                  style: xe(F(B.node.key, !!(($ = B.node.children) != null && $.length))),
                  onDblclick: () => p(B.node.key),
                  onClick: o0((E) => {
                    var ct;
                    return T(E, B.node.key, !!((ct = B.node.children) != null && ct.length));
                  }, ["stop"])
                }, [
                  B.node.data.color ? (Mt(), Ot("span", {
                    key: 0,
                    style: xe(`background-color: ${B.node.data.color}; outline: 1px solid rgba(156,156,156,0.5)`),
                    class: "all-radius-2 wiz-object-list-color"
                  }, null, 4)) : Qt("", !0),
                  kt("span", S0t, pe(B.node.label), 1),
                  B.node.data.isLocked != null && !B.node.data.lockDisabled ? (Mt(), Ot("button", {
                    key: 1,
                    class: Rn(["wiz-object-list-menu-button p-button p-button-text no-padding"]),
                    style: xe({
                      backgroundColor: B.node.data.isLocked ? "transparent" : "#e0e0e054"
                    }),
                    onClick: o0(() => P(B.node.key), ["stop"])
                  }, [
                    Pt(K(Vb), {
                      height: 16,
                      width: 16,
                      cIcon: "new_icons/ik_object_placement_black"
                    })
                  ], 12, L0t)) : Qt("", !0),
                  !((A = B.node.children) != null && A.length) && (B.node.data.hasDropdown || t.getContextMenuItems || t.getContextMenuItemsForKeys) ? (Mt(), Ot("button", {
                    key: 2,
                    class: "wiz-object-list-menu-button p-button p-button-text no-padding",
                    onClick: o0((E) => z(E, B.node.key), ["stop"])
                  }, [
                    Pt(K(Vb), {
                      height: 16,
                      width: 16,
                      cIcon: "icon_menu",
                      style: { transform: "scale(1.5)" }
                    })
                  ], 8, V0t)) : Qt("", !0)
                ], 44, x0t)
              ];
            }),
            _: 1
          }, 8, ["modelValue", "selectionKeys", "value"])
        ]),
        Pt(K(xG), {
          ref_key: "menu",
          ref: C,
          model: d.value
        }, null, 8, ["model"])
      ]),
      _: 1
    }, 8, ["maxHeight", "additionalTopMargin", "viewSize", "width", "title", "initialPosition", "showDockButton", "parent", "dockEvent"]));
  }
}), $G = /* @__PURE__ */ Dn(X0t, [["__scopeId", "data-v-d8ed7719"]]), I0t = ["src"], C0t = ["src"], Y0t = ["src"], v0t = ["src"], R0t = ["src"], D0t = ["src"], O0t = ["src"], Ye = 15, z0t = 290, MP = /* @__PURE__ */ Ne({
  __name: "ObjectMoveHandle",
  props: {
    x: {},
    y: {},
    color: {},
    viewSize: {},
    visible: { type: Boolean },
    selected: { type: Boolean },
    preciseMoveClicked: { type: Function },
    onDrag: { type: Function },
    onDragStart: { type: Function },
    onDragEnd: { type: Function },
    onClick: { type: Function },
    lockedFlag: { type: Boolean },
    preciseStepFlag: { type: Boolean },
    showLengthStepButtons: { type: Boolean }
  },
  setup(i) {
    aa();
    const t = i, e = jl(), { viewSize: n } = Vo(t), s = Lt(0), r = Lt(0), a = Lt(null), o = Lt(0), l = Lt(0), c = Lt(0), u = Lt(0), d = Lt(!1), h = Lt(!1), p = () => ({ ctrlKey: h.value }), m = (P) => {
      var H;
      const j = (H = P.key) == null ? void 0 : H.toLowerCase();
      (P.ctrlKey || j === "ctrl" || j === "control") && (d.value = !0);
    }, b = (P) => {
      P.ctrlKey || (d.value = !1);
    }, y = () => {
      d.value = !1;
    }, Z = (P, j) => {
      if (!a.value || !n.value)
        return;
      const H = Math.max(0, Math.min(P, n.value[0] - Ye)), B = Math.max(0, Math.min(j, n.value[1] - Ye));
      s.value = H, r.value = B;
    };
    xn(() => {
      Z(t.x - Ye / 2, t.y - Ye / 2), window.addEventListener("keydown", m), window.addEventListener("keyup", b), window.addEventListener("blur", y);
    }), wg(() => {
      window.removeEventListener("keydown", m), window.removeEventListener("keyup", b), window.removeEventListener("blur", y);
    });
    const g = (P, j) => {
      var H;
      t.lockedFlag || (h.value = d.value, o.value = P, l.value = j, c.value = s.value, u.value = r.value, (H = t.onDragStart) == null || H.call(t, c.value + Ye / 2, u.value + Ye / 2, p()));
    }, f = (P, j) => {
      var H;
      if (!t.lockedFlag) {
        const B = P - o.value, $ = j - l.value;
        let A = c.value + B, E = u.value + $;
        Z(A, E), (H = t.onDrag) == null || H.call(t, s.value + Ye / 2, r.value + Ye / 2, p());
      }
    }, T = (P, j) => {
      var H;
      if (!t.lockedFlag) {
        const B = P - o.value, $ = j - l.value;
        let A = c.value + B, E = u.value + $;
        Z(A, E), (H = t.onDragEnd) == null || H.call(t, s.value + Ye / 2, r.value + Ye / 2, p());
      }
    };
    gn(t, (P) => {
      Z(P.x - Ye / 2, P.y - Ye / 2);
    }), Ga(a, "left", "page", {
      onDragStart: g,
      onDrag: f,
      onDragEnd: T
    });
    const M = Lt(!1);
    let N = performance.now();
    const W = (P) => {
      P ? t.lockedFlag || (N = performance.now(), M.value = P) : setTimeout(() => {
        performance.now() - N > z0t && (M.value = P);
      }, 300);
    }, x = () => {
      t.lockedFlag && t.onClick && t.onClick();
    }, V = () => {
      t.preciseMoveClicked("Left");
    }, X = () => {
      t.preciseMoveClicked("Right");
    }, C = () => {
      t.preciseMoveClicked("Up");
    }, R = () => {
      t.preciseMoveClicked("Down");
    }, z = () => {
      t.preciseMoveClicked("Plus");
    }, F = () => {
      t.preciseMoveClicked("Minus");
    };
    return (P, j) => (Mt(), Ot(Me, null, [
      t.visible ? (Mt(), Ot("div", {
        key: 0,
        ref_key: "root",
        ref: a,
        onMouseover: j[0] || (j[0] = (H) => W(!0)),
        onClick: x,
        style: xe([{
          left: t.x - Ye / 2 + "px",
          top: t.y - Ye / 2 + "px",
          width: Ye + "px",
          height: Ye + "px",
          background: `rgba(${i.color[0]}, ${i.color[1]}, ${i.color[2]}, 0.5)`
        }, { position: "absolute", "border-radius": "50%", "pointer-events": "auto", cursor: "pointer", "z-index": "10" }])
      }, [
        kt("img", {
          draggable: "false",
          class: "object-contain svg-icon-color",
          height: Ye,
          width: Ye,
          src: K(e).getAssetUrl("/icons/cursors/ik_move.svg"),
          style: { display: "flex", "pointer-events": "none", "border-style": "none", transform: "scale(1.8)" }
        }, null, 8, I0t)
      ], 36)) : Qt("", !0),
      !i.lockedFlag && i.preciseStepFlag ? (Mt(), Ot(Me, { key: 1 }, [
        M.value && t.selected ? (Mt(), Ot(Me, { key: 0 }, [
          kt("div", {
            style: xe([{
              left: t.x - Ye / 2 - (Ye + 8) + "px",
              top: t.y - Ye / 2 - (Ye + 8) + "px",
              width: 3 * Ye + 16 + "px",
              height: 3 * Ye + 16 + "px",
              background: "rgba(0,0,0,0)"
            }, { position: "absolute", "pointer-events": "auto", cursor: "auto", "z-index": "9" }]),
            onMouseover: j[1] || (j[1] = (H) => W(!1))
          }, null, 36),
          kt("div", {
            ref: "up",
            onMouseover: j[2] || (j[2] = (H) => W(!0)),
            onClick: j[3] || (j[3] = (H) => C()),
            style: xe([{
              left: t.x - Ye / 2 + "px",
              top: t.y - Ye / 2 - (Ye + 2) + "px",
              width: Ye + "px",
              height: Ye + "px",
              background: `rgba(${i.color[0]}, ${i.color[1]}, ${i.color[2]}, 0.3)`
            }, { position: "absolute", "border-radius": "50%", "pointer-events": "auto", cursor: "pointer", "z-index": "10" }])
          }, [
            kt("img", {
              draggable: "false",
              class: "object-contain svg-icon-color",
              height: Ye,
              width: Ye,
              src: K(e).getAssetUrl("/icons/32x32/up_icon.svg"),
              style: { display: "flex", "pointer-events": "none", "border-style": "none", transform: "scale(0.7)" }
            }, null, 8, C0t)
          ], 36),
          kt("div", {
            ref: "down",
            onMouseover: j[4] || (j[4] = (H) => W(!0)),
            onClick: j[5] || (j[5] = (H) => R()),
            style: xe([{
              left: t.x - Ye / 2 + "px",
              top: t.y - Ye / 2 + (Ye + 2) + "px",
              width: Ye + "px",
              height: Ye + "px",
              background: `rgba(${i.color[0]}, ${i.color[1]}, ${i.color[2]}, 0.3)`
            }, { position: "absolute", "border-radius": "50%", "pointer-events": "auto", cursor: "pointer", "z-index": "10" }])
          }, [
            kt("img", {
              draggable: "false",
              class: "object-contain svg-icon-color",
              height: Ye,
              width: Ye,
              src: K(e).getAssetUrl("/icons/32x32/down_icon.svg"),
              style: { display: "flex", "pointer-events": "none", "border-style": "none", transform: "scale(0.7)" }
            }, null, 8, Y0t)
          ], 36),
          kt("div", {
            ref: "left",
            onMouseover: j[6] || (j[6] = (H) => W(!0)),
            onClick: j[7] || (j[7] = (H) => V()),
            style: xe([{
              left: t.x - Ye / 2 - (Ye + 2) + "px",
              top: t.y - Ye / 2 + "px",
              width: Ye + "px",
              height: Ye + "px",
              background: `rgba(${i.color[0]}, ${i.color[1]}, ${i.color[2]}, 0.3)`
            }, { position: "absolute", "border-radius": "50%", "pointer-events": "auto", cursor: "pointer", "z-index": "10" }])
          }, [
            kt("img", {
              draggable: "false",
              class: "object-contain svg-icon-color",
              height: Ye,
              width: Ye,
              src: K(e).getAssetUrl("/icons/32x32/left_icon.svg"),
              style: { display: "flex", "pointer-events": "none", "border-style": "none", transform: "scale(0.7)" }
            }, null, 8, v0t)
          ], 36),
          kt("div", {
            ref: "right",
            onMouseover: j[8] || (j[8] = (H) => W(!0)),
            onClick: j[9] || (j[9] = (H) => X()),
            style: xe([{
              left: t.x - Ye / 2 + (Ye + 2) + "px",
              top: t.y - Ye / 2 + "px",
              width: Ye + "px",
              height: Ye + "px",
              background: `rgba(${i.color[0]}, ${i.color[1]}, ${i.color[2]}, 0.3)`
            }, { position: "absolute", "border-radius": "50%", "pointer-events": "auto", cursor: "pointer", "z-index": "10" }])
          }, [
            kt("img", {
              draggable: "false",
              class: "object-contain svg-icon-color",
              height: Ye,
              width: Ye,
              src: K(e).getAssetUrl("/icons/32x32/right_icon.svg"),
              style: { display: "flex", "pointer-events": "none", "border-style": "none", transform: "scale(0.7)" }
            }, null, 8, R0t)
          ], 36),
          t.showLengthStepButtons ? (Mt(), Ot(Me, { key: 0 }, [
            kt("div", {
              onMouseover: j[10] || (j[10] = (H) => W(!0)),
              onClick: j[11] || (j[11] = (H) => z()),
              style: xe([{
                left: t.x - Ye / 2 - (Ye + 2) + "px",
                top: t.y - Ye / 2 - (Ye + 2) + "px",
                width: Ye + "px",
                height: Ye + "px",
                background: `rgba(${i.color[0]}, ${i.color[1]}, ${i.color[2]}, 0.3)`
              }, { position: "absolute", "border-radius": "50%", "pointer-events": "auto", cursor: "pointer", "z-index": "10" }])
            }, [
              kt("img", {
                draggable: "false",
                class: "object-contain svg-icon-color",
                height: Ye,
                width: Ye,
                src: K(e).getAssetUrl("/icons/32x32/plus_icon.svg"),
                style: { display: "flex", "pointer-events": "none", "border-style": "none", transform: "scale(0.7)" }
              }, null, 8, D0t)
            ], 36),
            kt("div", {
              onMouseover: j[12] || (j[12] = (H) => W(!0)),
              onClick: j[13] || (j[13] = (H) => F()),
              style: xe([{
                left: t.x - Ye / 2 + (Ye + 2) + "px",
                top: t.y - Ye / 2 - (Ye + 2) + "px",
                width: Ye + "px",
                height: Ye + "px",
                background: `rgba(${i.color[0]}, ${i.color[1]}, ${i.color[2]}, 0.3)`
              }, { position: "absolute", "border-radius": "50%", "pointer-events": "auto", cursor: "pointer", "z-index": "10" }])
            }, [
              kt("img", {
                draggable: "false",
                class: "object-contain svg-icon-color",
                height: Ye,
                width: Ye,
                src: K(e).getAssetUrl("/icons/32x32/minus_icon.svg"),
                style: { display: "flex", "pointer-events": "none", "border-style": "none", transform: "scale(0.7)" }
              }, null, 8, O0t)
            ], 36)
          ], 64)) : Qt("", !0)
        ], 64)) : Qt("", !0)
      ], 64)) : Qt("", !0)
    ], 64));
  }
}), E0t = ["src"], sr = 10, yM = /* @__PURE__ */ Ne({
  __name: "ObjectRotateHandle",
  props: {
    x: {},
    y: {},
    color: {},
    viewSize: {},
    visible: { type: Boolean },
    onDrag: { type: Function },
    onDragStart: { type: Function },
    onDragEnd: { type: Function },
    lockedFlag: { type: Boolean }
  },
  setup(i) {
    aa();
    const t = jl(), e = i, { viewSize: n } = Vo(e), s = Lt(0), r = Lt(0), a = Lt(null), o = Lt(0), l = Lt(0), c = Lt(0), u = Lt(0), d = (b, y) => {
      if (!a.value || !n.value)
        return;
      const Z = Math.max(0, Math.min(b, n.value[0] - sr)), g = Math.max(0, Math.min(y, n.value[1] - sr));
      s.value = Z, r.value = g;
    };
    xn(() => {
      d(e.x - sr / 2, e.y - sr / 2);
    });
    const h = (b, y) => {
      var Z;
      if (!e.lockedFlag) {
        const g = b - o.value, f = y - l.value;
        let T = c.value + g, M = u.value + f;
        d(T, M), (Z = e.onDragEnd) == null || Z.call(e, s.value + sr / 2, r.value + sr / 2);
      }
    }, p = (b, y) => {
      var Z;
      e.lockedFlag || (o.value = b, l.value = y, c.value = s.value, u.value = r.value, (Z = e.onDragStart) == null || Z.call(e, c.value + sr / 2, u.value + sr / 2));
    }, m = (b, y) => {
      var Z;
      if (!e.lockedFlag) {
        const g = b - o.value, f = y - l.value;
        let T = c.value + g, M = u.value + f;
        d(T, M), (Z = e.onDrag) == null || Z.call(e, s.value + sr / 2, r.value + sr / 2);
      }
    };
    return gn(e, (b) => {
      d(b.x - sr / 2, b.y - sr / 2);
    }), Ga(a, "left", "page", {
      onDragStart: p,
      onDrag: m,
      onDragEnd: h
    }), (b, y) => e.visible && !e.lockedFlag ? (Mt(), Ot("div", {
      key: 0,
      ref_key: "root",
      ref: a,
      style: xe([{
        left: e.x - sr / 2 + "px",
        top: e.y - sr / 2 + "px",
        width: sr + "px",
        height: sr + "px",
        background: `rgba(${i.color[0]}, ${i.color[1]}, ${i.color[2]}, 0.6)`
      }, { position: "absolute", "border-radius": "50%", "pointer-events": "auto", cursor: "pointer", "z-index": "10" }])
    }, [
      kt("img", {
        draggable: "false",
        class: "object-contain svg-icon-color",
        height: sr,
        width: sr,
        src: K(t).getAssetUrl("/icons/cursors/ik_rotate.svg"),
        style: { display: "flex", "pointer-events": "none", "border-style": "none", transform: "scale(1.4)" }
      }, null, 8, E0t)
    ], 4)) : Qt("", !0);
  }
});
var Yt = /* @__PURE__ */ ((i) => (i[i._NONE = 0] = "_NONE", i[i._ANNOTATION = 1] = "_ANNOTATION", i[i._DISTANCE = 2] = "_DISTANCE", i[i._ANGLE = 3] = "_ANGLE", i[i._POLYGON = 4] = "_POLYGON", i[i._CURSOR_CROSS = 5] = "_CURSOR_CROSS", i[i._CONTRAST_CONTROL = 6] = "_CONTRAST_CONTROL", i[i._NERVE = 7] = "_NERVE", i[i._IMPLANT = 8] = "_IMPLANT", i[i._CPR_CURVE = 9] = "_CPR_CURVE", i[i._DENTAL_CONTROL = 10] = "_DENTAL_CONTROL", i[i._CLIPPING_PLANES = 11] = "_CLIPPING_PLANES", i[i._FLY_CAMERA = 12] = "_FLY_CAMERA", i[i._THINSLAB = 13] = "_THINSLAB", i[i._MIP_INDICATOR = 14] = "_MIP_INDICATOR", i[i._CPR_MIP_INDICATOR = 15] = "_CPR_MIP_INDICATOR", i[i._CROSS_INDICATOR = 16] = "_CROSS_INDICATOR", i[i._CPR_CROSS_INDICATOR = 17] = "_CPR_CROSS_INDICATOR", i[i._CPR_SHAPE_INDICATOR = 18] = "_CPR_SHAPE_INDICATOR", i[i._SCULPTING = 19] = "_SCULPTING", i[i._CURVE = 20] = "_CURVE", i[i._WIZARD_CONTROL = 21] = "_WIZARD_CONTROL", i[i._NERVE_LEFT = 22] = "_NERVE_LEFT", i[i._NERVE_RIGHT = 23] = "_NERVE_RIGHT", i[i._CPR_CUSTOM = 24] = "_CPR_CUSTOM", i[i._CPR_DENTAL = 25] = "_CPR_DENTAL", i[i._CPR_AIRWAY = 26] = "_CPR_AIRWAY", i[i._TOOTH_MARKER = 27] = "_TOOTH_MARKER", i[i._TMJ_CURSOR_CROSS = 28] = "_TMJ_CURSOR_CROSS", i[i._STL_TEETH_MODEL = 29] = "_STL_TEETH_MODEL", i[i._STL_PROSTHESIS = 30] = "_STL_PROSTHESIS", i[i._PIN = 31] = "_PIN", i[i._STL_TOOTH = 32] = "_STL_TOOTH", i[i._STL_OBJECT = 33] = "_STL_OBJECT", i[i._THINSLAB_CPR = 34] = "_THINSLAB_CPR", i[i.OBJECT3D_SELECTION = 35] = "OBJECT3D_SELECTION", i[i._EXPORT_CROSS_INDICATOR = 36] = "_EXPORT_CROSS_INDICATOR", i[i._SPHERE_INDICATOR = 37] = "_SPHERE_INDICATOR", i[i._ABUTMENT = 38] = "_ABUTMENT", i[i._MARKER = 39] = "_MARKER", i[i._SLEEVE = 40] = "_SLEEVE", i[i._COLLISION_ZONE = 41] = "_COLLISION_ZONE", i[i._MAXILLA = 42] = "_MAXILLA", i[i._MANDIBLA = 43] = "_MANDIBLA", i[i._SECONDARY_ABUTMENT = 44] = "_SECONDARY_ABUTMENT", i[i._SECONDARY_SCAN_ABUTMENT = 45] = "_SECONDARY_SCAN_ABUTMENT", i[i._IMPLANT_ANALOG = 46] = "_IMPLANT_ANALOG", i[i._PRIMARY_SCAN_ABUTMENT = 47] = "_PRIMARY_SCAN_ABUTMENT", i[i._PREVIEW = 48] = "_PREVIEW", i[i._ANALOG_EXTRUSION = 49] = "_ANALOG_EXTRUSION", i[i._MERGED_CROWN_ROOT = 50] = "_MERGED_CROWN_ROOT", i[i._REFERENCE_PLANE = 51] = "_REFERENCE_PLANE", i[i._TEXTURED_FRONT_IMAGE = 184] = "_TEXTURED_FRONT_IMAGE", i[i._TEXTURED_TOP_IMAGE = 185] = "_TEXTURED_TOP_IMAGE", i[i._TEXTURED_LEFT_IMAGE = 186] = "_TEXTURED_LEFT_IMAGE", i[i._TEXTURED_RIGHT_IMAGE = 187] = "_TEXTURED_RIGHT_IMAGE", i[i._WEBLINK_CURVE = 101] = "_WEBLINK_CURVE", i[i._WEBLINK_AXIS = 102] = "_WEBLINK_AXIS", i[i._WEBLINK_BOUNDING_BOX = 103] = "_WEBLINK_BOUNDING_BOX", i[i._CENTERLINE = 104] = "_CENTERLINE", i[i._WEBLINK_COORDINATE_SYSTEM = 105] = "_WEBLINK_COORDINATE_SYSTEM", i[i._VOLUME_LABEL = 106] = "_VOLUME_LABEL", i[i._GUIDE_SUPPORT_OBJECT = 107] = "_GUIDE_SUPPORT_OBJECT", i))(Yt || {});
const k0t = {
  key: 0,
  style: { "z-index": "1000", position: "absolute", width: "100%", height: "100%", "pointer-events": "auto", cursor: "pointer" }
}, F0t = { style: { position: "absolute", width: "100%", height: "100%" } }, j0t = ["stroke", "x1", "x2", "y1", "y2"], U0t = ["stroke", "x1", "x2", "y1", "y2"], Xd = 10, NP = /* @__PURE__ */ Ne({
  __name: "ObjectMoveTool",
  props: {
    viewSize: {},
    viewObjectPositions: {},
    objectMoveStartEvent: {},
    objectMoveEvent: {},
    objectPreciseMoveEvent: {},
    objectRotateTopBottomEvent: {},
    objectRotateTopBottomStartEvent: {},
    objectMoveRotateEndEvent: {},
    objectSnapEvent: {},
    createUndoEvent: {},
    view3D: { type: Boolean },
    cprtommTransform: { type: Boolean }
  },
  setup(i) {
    const t = i, e = Le(t.viewObjectPositions), n = Le(t.viewSize), s = Lt(!1), r = (p, m, b) => {
      t.cprtommTransform ? t.objectMoveEvent.notify({
        objectId: b,
        viewPosition: [p, m],
        cprTool: t.cprtommTransform
      }) : t.objectMoveEvent.notify({
        objectId: b,
        viewPosition: [p, m]
      });
    }, a = (p, m, b) => {
      s.value = !1, t.objectSnapEvent.notify(p), Math.abs(o[0] - m) > 0.05 && Math.abs(o[1] - b) > 0.05 && t.createUndoEvent.notify({
        objectId: p
      }), t.objectMoveRotateEndEvent.notify({ objectId: p });
    };
    let o = [0, 0];
    const l = (p, m, b) => {
      o = [p, m], s.value = !0, t.cprtommTransform ? t.objectMoveStartEvent.notify({
        objectId: b,
        viewPosition: [p, m],
        cprTool: t.cprtommTransform
      }) : t.objectMoveStartEvent.notify({
        objectId: b,
        viewPosition: [p, m]
      });
    }, c = (p, m, b, y) => {
      s.value = !0, t.cprtommTransform ? t.objectRotateTopBottomStartEvent.notify({
        objectId: b,
        viewPosition: [p, m],
        top: y,
        cprTool: t.cprtommTransform
      }) : t.objectRotateTopBottomStartEvent.notify({
        objectId: b,
        viewPosition: [p, m],
        top: y
      });
    }, u = (p, m, b, y) => {
      s.value = !0, t.cprtommTransform ? t.objectRotateTopBottomEvent.notify({
        objectId: b,
        viewPosition: [p, m],
        top: y,
        cprTool: t.cprtommTransform
      }) : t.objectRotateTopBottomEvent.notify({
        objectId: b,
        viewPosition: [p, m],
        top: y
      });
    }, d = (p) => {
      t.objectSnapEvent.notify(p);
    }, h = (p, m) => {
      t.objectPreciseMoveEvent.notify({
        objectId: p,
        direction: m,
        cprTool: t.cprtommTransform
      }), t.objectSnapEvent.notify(p), m !== "Plus" && m !== "Minus" && t.createUndoEvent.notify({
        objectId: p
      });
    };
    return (p, m) => (Mt(), Ot(Me, null, [
      s.value ? (Mt(), Ot("div", k0t)) : Qt("", !0),
      i.view3D ? (Mt(!0), Ot(Me, { key: 2 }, Xn(K(e), (b) => (Mt(), Ot(Me, {
        key: b.id
      }, [
        b.handleTop !== null ? (Mt(), le(yM, {
          key: 0,
          color: b.color,
          onDragStart: (y, Z) => c(y, Z, b.id, !0),
          onDragEnd: (y, Z) => a(b.id, y, Z),
          onDrag: (y, Z) => u(y, Z, b.id, !0),
          visible: b.selectedFlag && (Math.abs(b.position[0] - b.handleTop[0]) > Xd || Math.abs(b.position[1] - b.handleTop[1]) > Xd) && b.visible,
          viewSize: K(n),
          x: b.centerlineTop ? b.centerlineTop[1][0] : b.handleTop[0],
          y: b.centerlineTop ? b.centerlineTop[1][1] : b.handleTop[1],
          lockedFlag: b.lockedFlag
        }, null, 8, ["color", "onDragStart", "onDragEnd", "onDrag", "visible", "viewSize", "x", "y", "lockedFlag"])) : Qt("", !0),
        b.handleBottom !== null ? (Mt(), le(yM, {
          key: 1,
          color: b.color,
          onDragStart: (y, Z) => c(y, Z, b.id, !1),
          onDragEnd: (y, Z) => a(b.id, y, Z),
          onDrag: (y, Z) => u(y, Z, b.id, !1),
          visible: b.selectedFlag && b.visible && (Math.abs(b.position[0] - b.handleBottom[0]) > Xd || Math.abs(b.position[1] - b.handleBottom[1]) > Xd),
          viewSize: K(n),
          x: b.centerlineBottom ? b.centerlineBottom[1][0] : b.handleBottom[0],
          y: b.centerlineBottom ? b.centerlineBottom[1][1] : b.handleBottom[1],
          lockedFlag: b.lockedFlag
        }, null, 8, ["color", "onDragStart", "onDragEnd", "onDrag", "visible", "viewSize", "x", "y", "lockedFlag"])) : Qt("", !0)
      ], 64))), 128)) : (Mt(!0), Ot(Me, { key: 1 }, Xn(K(e), (b) => (Mt(), Ot(Me, {
        key: b.id
      }, [
        Pt(MP, {
          color: b.color,
          onDrag: (y, Z) => r(y, Z, b.id),
          onDragStart: (y, Z) => l(y, Z, b.id),
          onDragEnd: (y, Z) => a(b.id, y, Z),
          onClick: () => d(b.id),
          preciseMoveClicked: (y) => h(b.id, y),
          visible: b.visibleInView && b.visible,
          selected: b.selectedFlag,
          viewSize: K(n),
          x: b.position[0],
          y: b.position[1],
          lockedFlag: b.lockedFlag,
          preciseStepFlag: b.preciseStepFlag,
          showLengthStepButtons: b.type === K(Yt)._IMPLANT
        }, null, 8, ["color", "onDrag", "onDragStart", "onDragEnd", "onClick", "preciseMoveClicked", "visible", "selected", "viewSize", "x", "y", "lockedFlag", "preciseStepFlag", "showLengthStepButtons"]),
        b.handleTop !== null ? (Mt(), le(yM, {
          key: 0,
          color: b.color,
          onDragStart: (y, Z) => c(y, Z, b.id, !0),
          onDragEnd: (y, Z) => a(b.id, y, Z),
          onDrag: (y, Z) => u(y, Z, b.id, !0),
          visible: b.selectedFlag && (Math.abs(b.position[0] - b.handleTop[0]) > Xd || Math.abs(b.position[1] - b.handleTop[1]) > Xd) && b.visibleInView && b.visible,
          viewSize: K(n),
          x: b.handleTop[0],
          y: b.handleTop[1],
          lockedFlag: b.lockedFlag
        }, null, 8, ["color", "onDragStart", "onDragEnd", "onDrag", "visible", "viewSize", "x", "y", "lockedFlag"])) : Qt("", !0),
        b.handleBottom !== null ? (Mt(), le(yM, {
          key: 1,
          color: b.color,
          onDragStart: (y, Z) => c(y, Z, b.id, !1),
          onDragEnd: (y, Z) => a(b.id, y, Z),
          onDrag: (y, Z) => u(y, Z, b.id, !1),
          visible: b.selectedFlag && (Math.abs(b.position[0] - b.handleBottom[0]) > Xd || Math.abs(b.position[1] - b.handleBottom[1]) > Xd) && b.visibleInView && b.visible,
          viewSize: K(n),
          x: b.handleBottom[0],
          y: b.handleBottom[1],
          lockedFlag: b.lockedFlag
        }, null, 8, ["color", "onDragStart", "onDragEnd", "onDrag", "visible", "viewSize", "x", "y", "lockedFlag"])) : Qt("", !0)
      ], 64))), 128)),
      (Mt(), Ot("svg", F0t, [
        (Mt(!0), Ot(Me, null, Xn(K(e), (b) => (Mt(), Ot(Me, {
          key: b.id
        }, [
          !i.view3D && b.visibleInView && b.type === K(Yt)._IMPLANT && b.visible ? (Mt(), Ot(Me, { key: 0 }, [
            b.centerlineBottom != null ? (Mt(), Ot("line", {
              key: 0,
              stroke: `rgba(${b.color[0]}, ${b.color[1]}, ${b.color[2]}, 1)`,
              x1: b.centerlineBottom[0][0],
              x2: b.centerlineBottom[1][0],
              y1: b.centerlineBottom[0][1],
              y2: b.centerlineBottom[1][1],
              "stroke-width": 1,
              "stroke-linecap": "round"
            }, null, 8, j0t)) : Qt("", !0),
            b.centerlineTop != null ? (Mt(), Ot("line", {
              key: 1,
              stroke: `rgba(${b.color[0]}, ${b.color[1]}, ${b.color[2]}, 1)`,
              x1: b.centerlineTop[0][0],
              x2: b.centerlineTop[1][0],
              y1: b.centerlineTop[0][1],
              y2: b.centerlineTop[1][1],
              "stroke-width": 1,
              "stroke-linecap": "round"
            }, null, 8, U0t)) : Qt("", !0)
          ], 64)) : Qt("", !0)
        ], 64))), 128))
      ]))
    ], 64));
  }
}), P0t = () => {
  const i = new qt([0, 0, 0]), t = new qt([]), e = new qt(!1);
  return {
    origin: i,
    objects: t,
    interactorActive: e
  };
};
var ks = /* @__PURE__ */ ((i) => (i.Top = "Top", i.Bottom = "Bottom", i.Left = "Left", i.Right = "Right", i.Front = "Front", i.Back = "Back", i))(ks || {});
const J0t = new se(), WP = new se(), uC = new se(), A0t = ["data-cy-view"], B0t = { key: 1 }, GP = /* @__PURE__ */ Ne({
  __name: "OrientationWidgetMenu",
  props: {
    model: {},
    view: {},
    size: {},
    margin: {},
    handler: {}
  },
  setup(i) {
    var h, p, m;
    aa();
    const t = i;
    ((h = l0()) == null ? void 0 : h.appContext.app.component("router-link")) !== void 0 || ((p = l0()) == null || p.appContext.app.use(l3), (m = l0()) == null || m.appContext.app.component("router-link", {}));
    const n = Object.keys(ks), s = te(
      () => n.map((b) => ({
        label: jt(`medic-web-engine.orientation${b}`),
        command: () => u(b)
      }))
    ), r = Lt(), a = Lt(!1);
    gn(a, (b) => {
      if (b) {
        const y = [];
        if (t.handler.HasExternalMenu()) {
          const Z = t.handler.GetExternalMenuItems();
          for (let g = 0; g < Z.size(); g++) {
            const f = Z.get(g);
            y.push({
              id: f.id,
              fromRecon: f.fromRecon,
              selected: f.selected,
              preview: "data:image/png;base64," + f.preview
            });
          }
        }
        l.value = y;
      }
    });
    let o = (b, y) => {
      t.handler && t.handler.RunCallback(b, y);
    }, l = Lt([]);
    const c = (b) => {
      t.handler ? a.value = !a.value : r.value.toggle(b);
    }, u = (b) => {
      uC.notify({ orientation: b, id: t.view });
    }, d = (b, y) => {
      o && o(b, y);
    };
    return (b, y) => (Mt(), Ot("div", {
      style: xe([{ position: "absolute", "pointer-events": "auto", cursor: "pointer" }, {
        bottom: t.handler && a.value ? i.margin + i.size + "px" : i.margin + "px",
        left: i.margin + "px",
        width: i.size + "px",
        height: i.size + "px",
        display: "flex",
        flexDirection: t.handler ? "column-reverse" : "column"
      }]),
      "data-cy": "orientation-widget",
      "data-cy-view": t.view,
      onClick: c
    }, [
      t.handler == null ? (Mt(), le(K(xG), {
        key: 0,
        ref_key: "menu",
        ref: r,
        model: s.value,
        popup: !0,
        "data-cy": "orientation-menu"
      }, null, 8, ["model"])) : a.value ? (Mt(), Ot("div", B0t, [
        (Mt(!0), Ot(Me, null, Xn(K(l), (Z) => (Mt(), le(K(ye), {
          key: Z.id,
          "preview-src": Z.preview,
          togglable: !0,
          toggled: Z.selected,
          "onUpdate:toggled": (g) => Z.selected = g,
          "icon-src-height": i.size + "px",
          "icon-src-width": i.size + "px",
          ignoreSvgFilter: !0,
          style: xe({
            width: i.size + i.margin * 2 + "px"
          }),
          onClick: (g) => d(Z.id, Z.fromRecon),
          onToggledChange: (g) => d(Z.id, Z.fromRecon)
        }, null, 8, ["preview-src", "toggled", "onUpdate:toggled", "icon-src-height", "icon-src-width", "style", "onClick", "onToggledChange"]))), 128))
      ])) : Qt("", !0)
    ], 12, A0t));
  }
}), K0t = "rgb(0, 255, 0)", ZM = "4px", TM = "-2px", H0t = /* @__PURE__ */ Ne({
  __name: "Resizer",
  props: {
    side: {},
    onResize: { type: Function }
  },
  setup(i) {
    const t = i, e = te(() => t.side === "left" || t.side === "right" ? "col-resize" : "row-resize"), n = Lt(!1), s = te(() => o.value || n.value ? K0t : void 0), r = te(() => t.side === "left" ? {
      top: 0,
      bottom: 0,
      left: TM,
      width: ZM
    } : t.side === "right" ? {
      top: 0,
      bottom: 0,
      right: TM,
      width: ZM
    } : t.side === "top" ? {
      top: TM,
      left: 0,
      right: 0,
      height: ZM
    } : t.side === "bottom" ? {
      bottom: TM,
      left: 0,
      right: 0,
      width: ZM
    } : {}), a = te(
      () => ({
        ...r.value,
        cursor: e.value,
        background: s.value
      })
    );
    let o = Lt(!1), l = [0, 0];
    const c = (y, Z) => {
      n.value && (l = [y, Z], o.value = !0);
    }, u = (y, Z) => {
      if (o.value) {
        if (t.side === "left") {
          const g = y - l[0];
          t.onResize(-g);
        } else if (t.side === "right") {
          const g = y - l[0];
          t.onResize(g);
        } else if (t.side === "top") {
          const g = Z - l[1];
          t.onResize(-g);
        } else if (t.side === "bottom") {
          const g = Z - l[1];
          t.onResize(g);
        }
        l = [y, Z];
      }
    }, d = () => {
      o.value = !1;
    }, h = Lt();
    Ga(h, "left", "page", {
      onDragStart: c,
      onDrag: u,
      onDragEnd: d
    });
    const p = (y) => {
      y.buttons || (n.value = !0);
    }, m = (y) => {
      y.buttons || (n.value = !0);
    }, b = () => {
      n.value = !1;
    };
    return (y, Z) => (Mt(), Ot("div", {
      ref_key: "resizer",
      ref: h,
      style: xe(a.value),
      class: "resizer",
      onMouseenter: p,
      onMouseout: b,
      onMouseup: m
    }, null, 36));
  }
}), d5 = /* @__PURE__ */ Dn(H0t, [["__scopeId", "data-v-1e538535"]]), _0t = { class: "slider-box" }, Q0t = {
  preserveAspectRatio: "none",
  style: { position: "absolute", width: "100%", height: "10px", top: "-12px" },
  viewBox: "0 0 100 100"
}, h5 = 20, $0t = /* @__PURE__ */ Ne({
  __name: "ViewSliderVertical",
  props: {
    min: {},
    max: {},
    modelValue: {},
    viewSize: {},
    lengthPercent: {},
    theme: {}
  },
  emits: ["update:modelValue", "dragEnd"],
  setup(i, { emit: t }) {
    x0((T) => ({
      v1c7ad142: f.value
    }));
    const e = i, n = t, { min: s, max: r, modelValue: a, viewSize: o } = Vo(e), l = te(() => (100 - e.lengthPercent) / 2), c = {
      top: `${l.value}%`,
      bottom: `${l.value}%`
    }, u = te(() => s.value === r.value ? 0.5 : (a.value - s.value) / (r.value - s.value)), d = te(() => {
      const T = o.value[1], M = T * (e.lengthPercent / 100) - h5, N = (T - M) / 2;
      return [N, T - N];
    }), h = te(() => (d.value[1] - d.value[0]) * Math.max(0, Math.min(1, u.value)));
    let p = 0, m = 0;
    const b = (T, M) => {
      m = M, p = u.value;
    }, y = (T, M) => {
      let N = p + (M - m) / (d.value[1] - d.value[0]);
      const W = Math.max(s.value, Math.min(r.value, Math.round(s.value + N * (r.value - s.value))));
      n("update:modelValue", W);
    }, Z = () => {
      n("dragEnd");
    }, g = Lt();
    Ga(g, "left", "page", {
      onDragStart: b,
      onDrag: y,
      onDragEnd: Z
    });
    const f = te(() => e.theme === "light" ? "invert(0%) sepia(4%) saturate(31%) hue-rotate(73deg) brightness(101%) contrast(100%)" : "invert(100%) sepia(0%) saturate(2110%) hue-rotate(303deg) brightness(109%) contrast(69%)");
    return (T, M) => (Mt(), Ot("div", {
      style: c,
      class: "slider-container"
    }, [
      M[2] || (M[2] = kt("div", { class: "slider-line" }, null, -1)),
      kt("div", {
        ref_key: "sliderHandle",
        ref: g,
        style: xe({
          top: h.value + "px"
        }),
        class: "slider-handle"
      }, [
        kt("div", _0t, pe(Math.round(K(a))), 1),
        as((Mt(), Ot("svg", Q0t, [...M[0] || (M[0] = [
          kt("polygon", { points: "25 100 75 100 50 0" }, null, -1)
        ])], 512)), [
          [Ss, u.value > 0]
        ]),
        as((Mt(), Ot("svg", {
          style: xe([{
            top: h5 + 2 + "px"
          }, { position: "absolute", width: "100%", height: "10px" }]),
          preserveAspectRatio: "none",
          viewBox: "0 0 100 100"
        }, [...M[1] || (M[1] = [
          kt("polygon", { points: "25 0 75 0 50 100" }, null, -1)
        ])], 4)), [
          [Ss, u.value < 1]
        ])
      ], 4)
    ]));
  }
}), q0t = /* @__PURE__ */ Dn($0t, [["__scopeId", "data-v-b8832cb4"]]), tbt = { class: "slider-box" }, ebt = {
  preserveAspectRatio: "none",
  style: { position: "absolute", height: "100%", width: "10px", left: "-12px", top: "0px" },
  viewBox: "0 0 100 100"
}, p5 = 30, nbt = /* @__PURE__ */ Ne({
  __name: "ViewSliderHorizontal",
  props: {
    min: {},
    max: {},
    modelValue: {},
    viewSize: {},
    lengthPercent: {},
    theme: {}
  },
  emits: ["update:modelValue", "dragEnd"],
  setup(i, { emit: t }) {
    x0((T) => ({
      v4d0a69b2: f.value
    }));
    const e = i, n = t, { min: s, max: r, modelValue: a, viewSize: o } = Vo(e), l = te(() => (100 - e.lengthPercent) / 2), c = {
      left: `${l.value}%`,
      right: `${l.value}%`
    }, u = te(() => s.value === r.value ? 0.5 : (a.value - s.value) / (r.value - s.value)), d = te(() => {
      const T = o.value[0], M = T * (e.lengthPercent / 100) - p5, N = (T - M) / 2;
      return [N, T - N];
    }), h = te(() => (d.value[1] - d.value[0]) * Math.max(0, Math.min(1, u.value)));
    let p = 0, m = 0;
    const b = (T, M) => {
      m = T, p = u.value;
    }, y = (T, M) => {
      let N = p + (T - m) / (d.value[1] - d.value[0]);
      const W = Math.max(s.value, Math.min(r.value, Math.round(s.value + N * (r.value - s.value))));
      n("update:modelValue", W);
    }, Z = () => {
      n("dragEnd");
    }, g = Lt();
    Ga(g, "left", "page", {
      onDragStart: b,
      onDrag: y,
      onDragEnd: Z
    });
    const f = te(() => e.theme === "light" ? "invert(0%) sepia(4%) saturate(31%) hue-rotate(73deg) brightness(101%) contrast(100%)" : "invert(100%) sepia(0%) saturate(2110%) hue-rotate(303deg) brightness(109%) contrast(69%)");
    return (T, M) => (Mt(), Ot("div", {
      style: c,
      class: "slider-container"
    }, [
      M[2] || (M[2] = kt("div", { class: "slider-line" }, null, -1)),
      kt("div", {
        ref_key: "sliderHandle",
        ref: g,
        style: xe({
          left: h.value + "px"
        }),
        class: "slider-handle"
      }, [
        kt("div", tbt, pe(Math.round(K(a))), 1),
        as((Mt(), Ot("svg", ebt, [...M[0] || (M[0] = [
          kt("polygon", { points: "100 12.5 100 87.5 0 50" }, null, -1)
        ])], 512)), [
          [Ss, u.value > 0]
        ]),
        as((Mt(), Ot("svg", {
          style: xe([{
            left: p5 + 2 + "px"
          }, { position: "absolute", height: "100%", width: "10px", top: "0px" }]),
          preserveAspectRatio: "none",
          viewBox: "0 0 100 100"
        }, [...M[1] || (M[1] = [
          kt("polygon", { points: "0 12.5 0 87.5 100 50" }, null, -1)
        ])], 4)), [
          [Ss, u.value < 1]
        ])
      ], 4)
    ]));
  }
}), ibt = /* @__PURE__ */ Dn(nbt, [["__scopeId", "data-v-344637e7"]]), m5 = /* @__PURE__ */ Ne({
  __name: "SectionalViewSlider",
  props: {
    type: {},
    context: {},
    viewSize: {},
    events: {}
  },
  setup(i) {
    const t = i, e = Le(t.viewSize), n = Lt(0), s = (o) => {
      const l = o - n.value;
      n.value = o, t.events.rotateEvent.notify({ degrees: l });
    }, r = () => {
      n.value = 0;
    }, a = Le(t.context.viewConfiguration.colorScheme);
    return (o, l) => (Mt(), Ot(Me, null, [
      i.type === "vertical" ? (Mt(), le(q0t, {
        key: 0,
        min: -180,
        max: 180,
        modelValue: n.value,
        "onUpdate:modelValue": s,
        viewSize: K(e),
        onDragEnd: r,
        lengthPercent: 90,
        theme: K(a)
      }, null, 8, ["modelValue", "viewSize", "theme"])) : Qt("", !0),
      i.type === "horizontal" ? (Mt(), le(ibt, {
        key: 1,
        min: -180,
        max: 180,
        modelValue: n.value,
        "onUpdate:modelValue": s,
        viewSize: K(e),
        onDragEnd: r,
        lengthPercent: 90,
        theme: K(a)
      }, null, 8, ["modelValue", "viewSize", "theme"])) : Qt("", !0)
    ], 64));
  }
});
function OL(i) {
  return i.map((t) => Math.max(1, Math.ceil(t / 2)));
}
function b5(i, t) {
  const e = i.getExtension("EXT_texture_norm16"), n = e ? 2 : 4, s = {
    fits: !1,
    dimensions: t,
    estimatedBytes: t.reduce((l, c) => l * c, n),
    contextLost: i.isContextLost()
  }, r = i.getParameter(i.MAX_3D_TEXTURE_SIZE);
  if (s.contextLost || t.some((l) => !Number.isSafeInteger(l) || l < 1 || l > r)) return s;
  const a = i.getParameter(i.TEXTURE_BINDING_3D), o = i.createTexture();
  if (!o) return s;
  try {
    for (let l = 0; l < 16 && i.getError() !== i.NO_ERROR; l++)
      ;
    return i.bindTexture(i.TEXTURE_3D, o), i.texImage3D(i.TEXTURE_3D, 0, e ? e.R16_SNORM_EXT : i.R32F, ...t, 0, i.RED, e ? i.SHORT : i.FLOAT, null), s.contextLost = i.isContextLost(), s.fits = i.getError() === i.NO_ERROR && !s.contextLost, s;
  } finally {
    i.bindTexture(i.TEXTURE_3D, a), i.deleteTexture(o);
  }
}
function gDt(i, t = !1) {
  var s;
  const n = document.createElement("canvas").getContext("webgl2", { powerPreference: "high-performance", preserveDrawingBuffer: !1 });
  if (!n) return null;
  try {
    const r = t ? OL(i) : i, a = b5(n, r);
    return a.fits || a.contextLost || t ? { current: a } : { current: a, reduced: b5(n, OL(i)) };
  } finally {
    (s = n.getExtension("WEBGL_lose_context")) == null || s.loseContext();
  }
}
function sbt(i) {
  const t = OL(i.getDimensions()), e = i.getSpacing(), n = ob.newInstance();
  n.setInputData(i), n.setOutputSpacing([e[0] * 2, e[1] * 2, e[2] * 2]), n.setOutputOrigin(i.getOrigin()), n.setOutputExtent([0, t[0] - 1, 0, t[1] - 1, 0, t[2] - 1]), n.setInterpolationMode(1), n.update();
  const s = n.getOutputData();
  return n.delete(), s;
}
const GW = 1e-5;
function wP(i, t, e) {
  const n = nd(i, t);
  if (n > Hn.Pi() - GW) {
    const s = [i[0], i[1], i[2]];
    s[0] == 0 ? s[0] = 0.5 : s[1] == 0 ? s[1] = 0.5 : s[2] == 0 ? s[2] = 0.5 : s[0] -= 0.5, Hn.normalize(s);
    const r = I.create();
    Hn.cross(i, s, r), Hn.normalize(r), ut.fromRotation(e, n, r);
  } else if (n > GW) {
    const s = I.create();
    Hn.cross(i, t, s), Hn.normalize(s), ut.fromRotation(e, n, s);
  }
}
function rbt(i, t, e, n) {
  const s = nd(i, t);
  if (s > Hn.Pi() - GW)
    ut.fromRotation(n, s, e);
  else if (s > GW) {
    const r = I.create();
    Hn.cross(i, t, r), Hn.normalize(r), ut.fromRotation(n, s, r);
  }
}
function abt(i, t, e, n, s) {
  const r = s || obt(n), a = qG(i, t, e, r);
  n.setUserMatrix(a);
}
function qG(i, t, e, n) {
  const s = ut.create(), r = ut.create();
  ut.translate(r, s, [-n[0], -n[1], -n[2]]);
  const a = [0, 0, 1], o = [1, 0, 0], l = ut.create();
  wP(a, t, l);
  const c = I.create();
  I.transformMat4(c, o, l);
  const u = ut.create();
  rbt(c, e, t, u);
  const d = ut.create();
  ut.translate(d, s, i);
  const h = ut.create();
  return ut.mul(h, l, r), ut.mul(h, u, h), ut.mul(h, d, h), h;
}
function f5(i, t, e) {
  const n = [t, t, t], s = ut.create(), r = ut.create(), a = ut.create();
  ut.scale(r, s, n), ut.translate(a, s, i);
  const o = ut.create();
  if (ut.multiply(o, a, r), e) {
    const l = ut.create();
    return ut.invert(l, o), l;
  } else
    return o;
}
function obt(i) {
  var n;
  const t = (n = i.getMapper()) == null ? void 0 : n.getInputData().getBounds();
  return [(t[0] + t[1]) * 0.5, (t[2] + t[3]) * 0.5, (t[4] + t[5]) * 0.5];
}
function lbt(i) {
  var n;
  const t = I.create(), e = (n = i.getMapper()) == null ? void 0 : n.getInputData().getBounds();
  return I.transformMat4(t, [0, 0, e[5]], i.getUserMatrix()), t;
}
function yDt(i) {
  var e;
  const t = (e = i.getMapper()) == null ? void 0 : e.getInputData().getBounds();
  return t[5] - t[4];
}
function xP(i) {
  var a;
  const t = I.create(), e = lbt(i), n = cbt(i), s = (a = i.getMapper()) == null ? void 0 : a.getInputData().getBounds(), r = s[5] - s[4];
  for (let o = 0; o < 3; o++)
    t[o] = e[o] - n[o] * r / 2;
  return t;
}
function cbt(i) {
  const t = I.create();
  for (let e = 0; e < 3; e++) t[e] = i.getUserMatrix()[8 + e];
  return I.normalize(t, t), t;
}
function ubt(i, t, e) {
  const n = I.create();
  n[0] = i[0] - t[0], n[1] = i[1] - t[1], n[2] = i[2] - t[2];
  const s = I.dot(n, e), r = I.create();
  return r[0] = i[0] - s * e[0], r[1] = i[1] - s * e[1], r[2] = i[2] - s * e[2], r;
}
function ZDt(i, t) {
  const e = I.create(), n = I.create();
  I.scaleAndAdd(e, [i[0] / 2, i[1] / 2, i[2] / 2], t, -(i[0] + i[1] + i[2])), I.scaleAndAdd(n, [i[0] / 2, i[1] / 2, i[2] / 2], t, i[0] + i[1] + i[2]);
  const s = T2([0, i[0], 0, i[1], 0, i[2]], e, n);
  return s ? I.distance(s[0], s[1]) : (console.error("failed to calculate spacing"), -1);
}
function TDt(i, t, e, n, s, r, a) {
  if (t.getParallelProjection()) {
    const o = i.displayToWorld(e, n, 0);
    a[0] = o[0], a[1] = o[1], a[2] = o[2], I.copy(r, t.getDirectionOfProjection());
  } else {
    const o = i.displayToWorld(s[0], s[1], s[2]), l = t.getPositionByReference();
    for (let c = 0; c < 3; c++)
      a[c] = o[c], r[c] = a[c] - l[c];
    I.normalize(r, r), I.copy(a, l);
  }
}
function T2(i, t, e) {
  let n = Number.MIN_VALUE, s = Number.MAX_VALUE;
  const r = 22250738585072014e-324;
  for (let a = 0; a < 3; a++)
    for (let o = 0; o < 2; o++) {
      const l = 2 * a + o, c = Math.abs(i[l] - t[a]) < r ? 0 : (i[l] - t[a]) / (e[a] - t[a]), u = t[(a + 1) % 3] + c * (e[(a + 1) % 3] - t[(a + 1) % 3]), d = t[(a + 2) % 3] + c * (e[(a + 2) % 3] - t[(a + 2) % 3]);
      if (u >= i[(2 * a + 2) % 6] && u <= i[(2 * a + 3) % 6] && d >= i[(2 * a + 4) % 6] && d <= i[(2 * a + 5) % 6])
        if (n === Number.MIN_VALUE)
          n = c;
        else if (c >= n) {
          s = c;
          break;
        } else {
          s = n, n = c;
          break;
        }
    }
  if (n !== Number.MIN_VALUE) {
    const a = I.create();
    a[0] = t[0] + n * (e[0] - t[0]), a[1] = t[1] + n * (e[1] - t[1]), a[2] = t[2] + n * (e[2] - t[2]);
    const o = I.create();
    return o[0] = t[0] + s * (e[0] - t[0]), o[1] = t[1] + s * (e[1] - t[1]), o[2] = t[2] + s * (e[2] - t[2]), [a, o];
  }
  return null;
}
function dbt(i, t, e, n) {
  const [s, r] = i, [a, o] = t, [l, c] = e, [u, d] = n, h = (s - a) * (c - d) - (r - o) * (l - u);
  if (h === 0)
    return null;
  const p = ((s - l) * (c - d) - (r - c) * (l - u)) / h, m = ((s - l) * (r - o) - (r - c) * (s - a)) / h;
  return p >= 0 && p <= 1 && m >= 0 && m <= 1 ? [s + p * (a - s), r + p * (o - r)] : null;
}
function zL(i, t, e, n, s) {
  const r = I.create();
  I.sub(r, t, e);
  const a = I.dot(r, i) / I.dot(n, i);
  I.copy(s, n), I.scale(s, s, a), I.add(s, s, e);
}
function wW(i) {
  const t = i[0] * i[0] + i[1] * i[1];
  if (t <= 0.5)
    i[2] = -Math.sqrt(1 - t);
  else {
    i[2] = -0.5 / Math.sqrt(t);
    let e, n, s;
    i[0] === 0 ? (e = 0, n = Math.sqrt(1 - i[2] * i[2]), i[1] < 0 && (n = -n)) : (s = i[1] / i[0], e = Math.sqrt((1 - i[2] * i[2]) / (1 + s * s)), i[0] < 0 && (e = -e), n = s * e), i[0] = e, i[1] = n;
  }
}
function MDt(i, t, e, n) {
  const s = I.create(), r = I.create();
  Fs(I.fromValues(0, 0, 0), t, e, s), Fs(i, t, e, r), I.subtract(n, r, s), I.normalize(n, n);
}
function Fs(i, t, e, n) {
  const s = I.create();
  I.sub(s, i, t);
  const r = I.dot(e, s);
  I.scaleAndAdd(n, i, e, -r);
}
function EL(i, t, e) {
  const n = ut.clone(i);
  ut.invert(n, n), ut.transpose(n, n), I.transformMat4(e, t, n);
}
function NDt(i, t, e) {
  I.transformMat4(e, t, i);
}
function MM(i, t, e, n) {
  const s = { t: Number.MIN_VALUE, distance: 0 };
  let r;
  const a = I.create();
  I.sub(a, e, t);
  const o = a[0] * (i[0] - t[0]) + a[1] * (i[1] - t[1]) + a[2] * (i[2] - t[2]), l = I.dot(a, a);
  let c = 1e-5 * o;
  return l !== 0 && (s.t = o / l), c < 0 && (c = -c), -c < l && l < c || l <= 0 || s.t < 0 ? r = t : s.t > 1 ? r = e : (r = a, a[0] = t[0] + s.t * a[0], a[1] = t[1] + s.t * a[1], a[2] = t[2] + s.t * a[2]), n && (n[0] = r[0], n[1] = r[1], n[2] = r[2]), s.distance = Hn.distance2BetweenPoints(r, i), s;
}
function g5(i, t, e) {
  const n = I.create();
  I.normalize(n, n), I.sub(n, e, t);
  const s = I.create();
  I.sub(s, i, t);
  const r = I.dot(n, s), a = I.create();
  return I.scaleAndAdd(a, t, n, r), I.sqrDist(a, i);
}
function hbt(i, t, e, n, s) {
  const r = I.create(), a = I.create(), o = I.create();
  I.sub(r, n, i), I.sub(a, s, i), I.scale(r, r, 1 / t), I.scale(a, a, 1 / t);
  const l = I.fromValues(0, 0, 1), c = ut.create();
  wP(e, l, c), I.transformMat4(r, r, c), I.transformMat4(a, a, c), wW(r), wW(a), ut.invert(c, c), EL(c, r, r), EL(c, a, a), I.cross(o, r, a), I.normalize(o, o);
  const u = nd(r, a), d = o, h = ut.create();
  return ut.fromRotation(h, u, d), h;
}
function pbt(i, t, e, n, s, r) {
  const a = I.create();
  I.cross(a, t, n);
  const o = I.create(), l = I.create(), c = I.create(), u = I.create(), d = I.create();
  I.sub(o, s, i), I.sub(l, r, i), BS(o, t, u), BS(l, t, d), I.sub(u, o, u), I.sub(d, l, d);
  const h = I.create();
  I.add(h, i, t);
  const p = Math.sqrt(g5(s, i, h)), m = Math.sqrt(g5(r, i, h));
  o[0] = (nd(a, u) > Math.PI / 2 ? -1 : 1) * p, o[1] = 0, o[2] = 0, l[0] = (nd(a, d) > Math.PI / 2 ? -1 : 1) * m, l[1] = 0, l[2] = 0, I.scale(o, o, 1 / e), I.scale(l, l, 1 / e), wW(o), wW(l), I.cross(c, o, l), I.normalize(c, c);
  let b = nd(o, l);
  c[1] < 0 && (b *= -1);
  const y = ut.create();
  return ut.fromRotation(y, b, t), y;
}
/*! Calculate angle betwen vectors OA and OB. */
function kL(i, t, e, n) {
  const s = I.create(), r = I.create(), a = I.create();
  for (let o = 0; o < 3; o++)
    s[o] = e[o] - i[o], r[o] = e[o] - t[o];
  return I.cross(a, s, r), I.dot(a, n) > 0 ? Hn.angleBetweenVectors(s, r) : -Hn.angleBetweenVectors(s, r);
}
/*! Calculate angle [-PI/2, PI/2] betwen vectors A and B in the plane of rotation rot. */
function y5(i, t, e) {
  const n = I.create(), s = I.create(), r = I.create();
  Fs(i, I.fromValues(0, 0, 0), e, n), Fs(t, I.fromValues(0, 0, 0), e, s);
  let a = Hn.angleBetweenVectors(n, s);
  return a > Math.PI / 2 && (a -= Math.PI), a < -Math.PI / 2 && (a += Math.PI), I.cross(r, i, t), I.dot(r, e) > 0 ? a : -a;
}
const mbt = 1e-5;
/*!
 * TS port of RealGUIDE GetBLOrientation (MedicCommon-GUI/util/xMath.cpp:114), the single
 * source of truth for buccal/lingual orientation of the cross-sectional view. Decides from the
 * sign of the world-X component of `nn` (rot = (0,1,0) x nn, so rot·(0,0,1) = -nn_x). The C++
 * mutates one of the frame vectors in place; here we instead return the sign together with the
 * (possibly negated) frame vectors the caller should use downstream:
 *   sign === -1 : nn_x < 0  -> `nn` negated
 *   sign === +1 : nn_x > 0  -> `tt` negated
 *   sign ===  0 : degenerate (nn ~parallel to world-Y) -> caller keeps its frame unchanged
 * Inputs are not mutated.
 */
function SP(i, t) {
  const e = I.fromValues(0, 1, 0), n = I.fromValues(0, 0, 1), s = I.create();
  I.cross(s, e, i);
  const r = I.clone(i), a = I.clone(t);
  return I.length(s) <= mbt ? { sign: 0, nn: r, tt: a } : (I.normalize(s, s), I.dot(s, n) > 0 ? (I.negate(r, r), { sign: -1, nn: r, tt: a }) : (I.negate(a, a), { sign: 1, nn: r, tt: a }));
}
/*!
\return 0 if no intersection rect and line
RR[left, top, right, bottom]
*/
function Z5(i, t, e) {
  let n = 0;
  const s = e[2], r = e[3], a = t[0] - i[0], o = t[1] - i[1];
  if (Math.abs(a) < Number.EPSILON && Math.abs(o) < Number.EPSILON)
    return null;
  if (Math.abs(a) < Number.EPSILON)
    return [
      [i[0], e[1]],
      [i[0], e[3]]
    ];
  if (Math.abs(o) < Number.EPSILON)
    return [
      [e[0], i[1]],
      [e[2], i[1]]
    ];
  {
    const l = o / a, c = i[1] - l * i[0], u = Fi.create(), d = Fi.create(), h = Fi.create(), p = Fi.create();
    u[0] = e[0], u[1] = l * e[0] + c, d[0] = (e[1] - c) / l, d[1] = e[1], h[0] = s, h[1] = l * s + c, p[0] = (r - c) / l, p[1] = r;
    const m = zn.fromValues(0, 0, 0, 0);
    return n = 0, u[1] > e[1] && u[1] < e[3] && (m[n++] = u[0], m[n++] = u[1]), d[0] > e[0] && d[0] < e[2] && (m[n++] = d[0], m[n++] = d[1]), h[1] > e[1] && h[1] < e[3] && (m[n++] = h[0], m[n++] = h[1]), p[0] > e[0] && p[0] < e[2] && (m[n++] = p[0], m[n++] = p[1]), n == 4 ? [
      [m[0], m[1]],
      [m[2], m[3]]
    ] : null;
  }
}
function WDt(i, t, e, n, s) {
  const a = e[0], o = e[1], l = e[2], c = e[3], u = e[4], d = e[5], h = [(a - i[0]) / t[0], (o - i[1]) / t[1], (l - i[2]) / t[2]], p = [(c - i[0]) / t[0], (u - i[1]) / t[1], (d - i[2]) / t[2]], m = [Math.min(h[0], p[0]), Math.min(h[1], p[1]), Math.min(h[2], p[2])], b = [Math.max(h[0], p[0]), Math.max(h[1], p[1]), Math.max(h[2], p[2])], y = Math.max(m[0], m[1], m[2]), Z = Math.min(b[0], b[1], b[2]);
  if (y > Z + 1e-6 || Z < 0)
    return 0;
  if (Math.abs(y - Z) < 1e-6) {
    if (y < 0)
      return -1;
    {
      const T = [i[0] + y * t[0], i[1] + y * t[1], i[2] + y * t[2]];
      return n[0] = T[0], n[1] = T[1], n[2] = T[2], -1;
    }
  }
  const g = [i[0] + y * t[0], i[1] + y * t[1], i[2] + y * t[2]], f = [i[0] + Z * t[0], i[1] + Z * t[1], i[2] + Z * t[2]];
  return n[0] = g[0], n[1] = g[1], n[2] = g[2], s[0] = f[0], s[1] = f[1], s[2] = f[2], 1;
}
function bbt(i, t, e) {
  const n = I.create(), s = I.create(), r = I.create(), a = I.create();
  let o = 0;
  const l = I.fromValues(e[0], e[2], e[4]), c = I.fromValues(e[1], e[3], e[5]);
  if (Math.abs(i[0]) > Number.EPSILON) {
    const u = (l[0] - t[0]) / i[0], d = (c[0] - t[0]) / i[0];
    for (let h = 0; h < 3; h++)
      n[h] = t[h] + u * i[h], s[h] = t[h] + d * i[h];
    if (n[1] > l[1] && n[1] < c[1] && n[2] > l[2] && n[2] < c[2] && (I.set(r, n[0], n[1], n[2]), o++), s[1] > l[1] && s[1] < c[1] && s[2] > l[2] && s[2] < c[2]) {
      if (o)
        return I.set(a, s[0], s[1], s[2]), [r, a];
      I.set(r, s[0], s[1], s[2]), o++;
    }
  }
  if (Math.abs(i[1]) > Number.EPSILON) {
    const u = (l[1] - t[1]) / i[1], d = (c[1] - t[1]) / i[1];
    for (let h = 0; h < 3; h++)
      n[h] = t[h] + u * i[h], s[h] = t[h] + d * i[h];
    if (n[0] > l[0] && n[0] < c[0] && n[2] > l[2] && n[2] < c[2]) {
      if (o)
        return I.set(a, n[0], n[1], n[2]), [r, a];
      I.set(r, n[0], n[1], n[2]), o++;
    }
    if (s[0] > l[0] && s[0] < c[0] && s[2] > l[2] && s[2] < c[2]) {
      if (o)
        return I.set(a, s[0], s[1], s[2]), [r, a];
      I.set(r, s[0], s[1], s[2]), o++;
    }
  }
  if (Math.abs(i[2]) > Number.EPSILON) {
    const u = (l[2] - t[2]) / i[2], d = (c[2] - t[2]) / i[2];
    for (let h = 0; h < 3; h++)
      n[h] = t[h] + u * i[h], s[h] = t[h] + d * i[h];
    if (n[1] > l[1] && n[1] < c[1] && n[0] > l[0] && n[0] < c[0]) {
      if (o)
        return I.set(a, n[0], n[1], n[2]), [r, a];
      I.set(r, n[0], n[1], n[2]), o++;
    }
    if (s[1] > l[1] && s[1] < c[1] && s[0] > l[0] && s[0] < c[0]) {
      if (o)
        return I.set(a, s[0], s[1], s[2]), [r, a];
      console.log("No way!", o, r, a), I.set(r, s[0], s[1], s[2]), o++;
    }
  }
  return [r, a];
}
function zh(i, t, e, n) {
  let s = null;
  const r = i.getVolume().volumeActor, a = t.getCellPicker();
  r && (r.setPickable(!0), a.initializePickList(), a.addPickList(r)), a.pick([e, n, 0], t.getRenderer());
  const o = a.getPickedPositions();
  return r == null || r.setPickable(!1), o.length && (s = o[0]), s;
}
function Eh(i, t, e) {
  if (!t) return e;
  if (!e) return t;
  const n = i.getRenderer().getActiveCamera().getPosition(), s = I.distance(n, t), r = I.distance(n, e);
  return s < r ? t : e;
}
function ea(i, t) {
  let n = -1, s = 9999;
  if (i.length > 1) {
    n = 0;
    for (let o = 0; o < i.length; o += 3) {
      const l = I.distance(t, i[o]);
      l < s && (s = l, n = o);
    }
    const r = Math.max(0, n - 3), a = Math.min(i.length, n + 3);
    for (let o = r; o < a; o++) {
      const l = I.distance(t, i[o]);
      l < s && (s = l, n = o);
    }
  }
  return { nearestIndex: n, mind: s };
}
function T5(i, t) {
  let e;
  typeof I == typeof i[0] ? e = LP(i) : e = i;
  let n = -1, s = 99999;
  if (e.length > 3)
    for (let a = 0; a < e.length / 3 - 1; a++) {
      const o = I.fromValues(e[a * 3], e[a * 3 + 1], e[a * 3 + 2]), l = I.fromValues(e[(a + 1) * 3], e[(a + 1) * 3 + 1], e[(a + 1) * 3 + 2]), c = I.squaredDistance(o, l), u = ((t[0] - o[0]) * (l[0] - o[0]) + (t[1] - o[1]) * (l[1] - o[1]) + (t[2] - o[2]) * (l[2] - o[2])) / c, d = Math.max(0, Math.min(1, u)), h = I.fromValues(o[0] + d * (l[0] - o[0]), o[1] + d * (l[1] - o[1]), o[2] + d * (l[2] - o[2]));
      let p = I.squaredDistance(t, h);
      d == 1 && (p = 999999), p < s && (s = p, n = a);
    }
  const r = e.length / 3 - 1;
  return { nearestIndex: n, mind: s, numOfSegments: r };
}
function LP(i) {
  const t = [];
  return i.forEach((e) => {
    t.push(...e);
  }), t;
}
/*! get reslicerMatrix for \params o plane origin, n plane normal, evu desired viewup, can also rotate
    \return view.resliceAxe */
function qc(i, t, e, n = [0, 0, 0], s = 0, r = [0, 0, 0], a = 0) {
  const o = [1, 0, 0], l = [0, 1, 0], c = [0, 0, 1], u = ut.create();
  if (I.set(o, t[0], t[1], t[2]), 1 - Math.abs(I.dot(o, e)) < Number.EPSILON)
    return console.log("getViewMatrix::Desired viewup and plane normal are parallel. will return identity", o, e), ut.identity(u);
  if (I.cross(l, o, e), I.cross(c, l, o), Math.abs(s) > Number.EPSILON && 1 - Math.abs(I.dot(o, n)) > 1e-3) {
    const d = ut.create();
    ut.fromRotation(d, s, n), I.transformMat4(o, o, d), I.transformMat4(c, c, d), I.transformMat4(l, l, d);
  }
  if (Math.abs(a) > Number.EPSILON && 1 - Math.abs(I.dot(o, r)) > 1e-3) {
    const d = ut.create();
    ut.fromRotation(d, a, r), I.transformMat4(o, o, d), I.transformMat4(c, c, d), I.transformMat4(l, l, d);
  }
  return ut.set(u, l[0], l[1], l[2], 0, c[0], c[1], c[2], 0, o[0], o[1], o[2], 0, i[0], i[1], i[2], 1), u;
}
function GDt(i, t) {
  return !(t[0] < i[0] || t[0] > i[1] || t[1] < i[2] || t[1] > i[3] || t[2] < i[4] || t[2] > i[5]);
}
function wDt(i, t) {
  i[0] = Math.min(Math.max(i[0], t[0]), t[1]), i[1] = Math.min(Math.max(i[1], t[2]), t[3]), i[2] = Math.min(Math.max(i[2], t[4]), t[5]);
}
function M5(i, t) {
  const e = I.create();
  return i.worldToIndexVec3(t, e), I.round(e, e), i.indexToWorldVec3(e, e), e;
}
function N5(i, t, e, n, s) {
  const r = I.create(), a = I.create();
  i[0] >= 0 ? (r[0] = e[0], a[0] = e[1]) : (r[0] = e[1], a[0] = e[0]), i[1] >= 0 ? (r[1] = e[2], a[1] = e[3]) : (r[1] = e[3], a[1] = e[2]), i[2] >= 0 ? (r[2] = e[4], a[2] = e[5]) : (r[2] = e[5], a[2] = e[4]);
  let o = I.dot(i, r) - I.dot(i, t);
  for (let l = 0; l < 3; l++)
    n[l] = t[l] + o * i[l];
  o = I.dot(i, a) - I.dot(i, t);
  for (let l = 0; l < 3; l++)
    s[l] = t[l] + o * i[l];
}
/*! Calculte intersection of the plane and line. Plane has given normal N and contains global
origin. Line is given by two point s A, B.
\return
0 intersection valid,
-2 line parallel with plane
-1 no intersection, line above plane,
1 no intersection line below plane - X get it value as infinite line intersect the plane
2 plane contains line
*/
function fbt(i, t, e, n, s) {
  const r = I.create();
  let a = 0, o = I.dot(i, t), l = I.dot(i, e), c = I.dot(i, n);
  if (Math.abs(o - l) < 2e-16 && Math.abs(o - c) < 2e-16) {
    for (let u = 0; u < 3; u++) s[u] = e[u];
    return 2;
  } else if (Math.abs(o - l) < 2e-16) {
    for (let u = 0; u < 3; u++) s[u] = e[u];
    return 0;
  } else if (Math.abs(o - c) < 2e-16) {
    for (let u = 0; u < 3; u++) s[u] = n[u];
    return 0;
  } else {
    for (let d = 0; d < 3; d++) r[d] = n[d] - e[d];
    let u = I.len(r);
    if (u < 2e-16) {
      let d = o - l;
      a = -(d < 0 ? -1 : d > 0 ? 1 : 0);
      for (let h = 0; h < 3; h++) s[h] = n[h];
      return a;
    } else {
      I.normalize(r, r);
      let d = I.dot(i, r);
      if (Math.abs(d) < 2e-16)
        return -2;
      {
        let h = o - l, p = (o - l) / d;
        for (let m = 0; m < 3; m++) s[m] = r[m] * p + e[m];
        return (p < 0 || p > u) && (a = -(h < 0 ? -1 : h > 0 ? 1 : 0)), a;
      }
    }
  }
}
function xW(i) {
  return Math.PI * i / 180;
}
function xDt(i) {
  return 180 * i / Math.PI;
}
function bN(i, t) {
  const e = I.create();
  e[0] = t[0] * i[0] + t[4] * i[1] + t[8] * i[2], e[1] = t[1] * i[0] + t[5] * i[1] + t[9] * i[2], e[2] = t[2] * i[0] + t[6] * i[1] + t[10] * i[2];
  const n = I.len(e);
  for (let s = 0; s < 3; s++)
    i[s] = e[s] / n;
}
function gbt(i, t, e, n, s) {
  const r = ut.create(), a = I.create();
  I.subtract(a, i, n);
  const o = I.len(a);
  I.normalize(a, a), VP(e, t, r), bN(a, r), I.scale(a, a, o), I.add(s, n, a);
}
function VP(i, t, e) {
  let n = I.len(i);
  if (n < 1e-6)
    return;
  for (let o = 0; o < 3; o++)
    i[o] /= n;
  const s = Math.cos(t), r = Math.sin(t), a = 1 - s;
  e[0] = a * i[0] * i[0] + s, e[1] = a * i[0] * i[1] - r * i[2], e[2] = a * i[0] * i[2] + r * i[1], e[3] = 0, e[4] = a * i[0] * i[1] + r * i[2], e[5] = a * i[1] * i[1] + s, e[6] = a * i[1] * i[2] - r * i[0], e[7] = 0, e[8] = a * i[0] * i[2] - r * i[1], e[9] = a * i[1] * i[2] + r * i[0], e[10] = a * i[2] * i[2] + s, e[11] = 0;
}
function NM(i) {
  const t = i.length;
  let e = -1 / 0;
  for (let n = 0; n < t; n++)
    e = Number(i[n]) > e ? i[n] : e;
  return Number(e);
}
function WM(i) {
  const t = i.length;
  let e = 1 / 0;
  for (let n = 0; n < t; n++)
    e = Number(i[n]) < e ? i[n] : e;
  return Number(e);
}
function ybt(i, t) {
  if (i.length !== t.length)
    return !1;
  for (let e = 0; e < i.length; e++)
    if (i[e] !== t[e])
      return !1;
  return !0;
}
function Zbt(i) {
  const t = I.create();
  if (i.length > 2) {
    const e = I.create(), n = I.create(), s = I.fromValues(i[0][0], i[0][1], i[0][2]), r = I.fromValues(i[1][0], i[1][1], i[1][2]), a = I.fromValues(i[2][0], i[2][1], i[2][2]);
    I.sub(e, r, s), I.sub(n, a, s), I.normalize(e, e), I.normalize(n, n), I.cross(t, n, e), I.normalize(t, t);
    const o = I.fromValues(0, 1, 0), l = I.fromValues(0, 0, 1);
    I.normalize(t, t), I.dot(l, t) > 0 && (t[0] = t[0] * -1, t[1] = t[1] * -1, t[2] = t[2] * -1);
    const c = I.create(), u = I.create(), d = I.create();
    return I.cross(c, t, o), I.normalize(c, c), I.cross(u, c, t), I.normalize(u, u), d[0] = t[0] * -1, d[1] = t[1] * -1, d[2] = t[2] * -1, {
      t: c,
      s: u,
      n: d,
      o: i[0]
    };
  }
}
function Tbt(i, t) {
  if (i === 0) return 0;
  const e = Math.pow(10, t - Math.floor(Math.log10(Math.abs(i))) - 1);
  return Math.round(i * e) / e;
}
function Ha(i) {
  const t = -Math.floor(Math.log10(i)) + 2;
  return Tbt(i, t);
}
function XP(i, t = 12) {
  if (!Number.isFinite(i) || i === 0)
    return Number.isFinite(i) ? 0 : i;
  const e = Number.parseFloat(i.toPrecision(t));
  return Object.is(e, -0) ? 0 : e;
}
function Bi(i) {
  let t = 0;
  if (i - Math.floor(i) > 0) {
    let e = 1e3;
    for (let n = 2; n >= 0; --n) {
      if (Math.floor(e * i) % 10 != 0) {
        t = n + 1;
        break;
      }
      e /= 10;
    }
  }
  return t;
}
const Mbt = { style: { position: "absolute", width: "100%", height: "100%" } }, Nbt = ["stroke", "x1", "x2", "y1", "y2"], Wbt = ["src"], Gbt = ["src"], Ci = 16, wbt = 32, xbt = /* @__PURE__ */ Ne({
  __name: "SliceIndicator2D",
  props: {
    viewId: {},
    point1: {},
    point2: {},
    origin: {},
    color: {},
    viewSize: {}
  },
  setup(i) {
    const t = jl(), e = i, n = (d, h, p) => {
      const m = d, b = h, [y, Z] = e.viewSize, [g, f] = e.origin, T = [
        [p, 0],
        [p, Z]
      ], M = [
        [y - p, 0],
        [y - p, Z]
      ], N = [
        [0, p],
        [y, p]
      ], W = [
        [0, Z - p],
        [y, Z - p]
      ], x = [], V = [];
      return g > p && V.push(T), g < y - p && V.push(M), f > p && V.push(N), f < Z - p && V.push(W), [m, b].forEach((X) => {
        const C = V.map((F) => dbt(X, [g, f], F[0], F[1])).filter((F) => F !== null);
        if (C.length === 0)
          return;
        const R = C.map((F) => Math.pow(F[0] - g, 2) + Math.pow(F[1] - f, 2)), z = C[R.indexOf(Math.min(...R))];
        x.push(z);
      }), x.filter((X) => X[0] >= Ci / 2 && X[0] <= y - Ci / 2 && X[1] >= Ci / 2 && X[1] <= Z - Ci / 2 && Math.pow(g - X[0], 2) + Math.pow(f - X[1], 2) > Math.pow(Ci + 5, 2));
    }, s = te(() => n(e.point1, e.point2, wbt)), r = te(() => s.value[0] || null), a = te(() => s.value[1] || null), o = Ci / 2 + 1, l = te(() => n(e.point1, e.point2, o)), c = te(() => l.value[0] || null), u = te(() => l.value[1] || null);
    return (d, h) => (Mt(), Ot(Me, null, [
      (Mt(), Ot("svg", Mbt, [
        kt("line", {
          stroke: `rgba(${i.color[0]}, ${i.color[1]}, ${i.color[2]}, 1)`,
          x1: i.point1[0],
          x2: i.point2[0],
          y1: i.point1[1],
          y2: i.point2[1]
        }, null, 8, Nbt)
      ])),
      r.value ? (Mt(), Ot("div", {
        key: 0,
        ref: "rotateHandle1",
        style: xe([{
          width: Ci + "px",
          height: Ci + "px",
          left: r.value[0] - Ci / 2 + "px",
          top: r.value[1] - Ci / 2 + "px",
          backgroundColor: `rgba(${i.color[0]}, ${i.color[1]}, ${i.color[2]}, 0.8)`
        }, { cursor: "pointer" }]),
        class: "rotate-handle"
      }, [
        r.value ? (Mt(), Ot("img", {
          key: 0,
          draggable: "false",
          class: "object-contain svg-icon-color",
          height: Ci,
          width: Ci,
          src: K(t).getAssetUrl("/icons/cursors/ik_rotate.svg"),
          style: { display: "flex", "pointer-events": "none", "border-style": "none", transform: "scale(1.4)" }
        }, null, 8, Wbt)) : Qt("", !0)
      ], 4)) : Qt("", !0),
      a.value ? (Mt(), Ot("div", {
        key: 1,
        ref: "rotateHandle2",
        style: xe([{
          width: Ci + "px",
          height: Ci + "px",
          left: a.value[0] - Ci / 2 + "px",
          top: a.value[1] - Ci / 2 + "px",
          backgroundColor: `rgba(${i.color[0]}, ${i.color[1]}, ${i.color[2]}, 0.8)`
        }, { cursor: "pointer" }]),
        class: "rotate-handle"
      }, [
        a.value ? (Mt(), Ot("img", {
          key: 0,
          draggable: "false",
          class: "object-contain svg-icon-color",
          height: Ci,
          width: Ci,
          src: K(t).getAssetUrl("/icons/cursors/ik_rotate.svg"),
          style: { display: "flex", "pointer-events": "none", "border-style": "none", transform: "scale(1.4)" }
        }, null, 8, Gbt)) : Qt("", !0)
      ], 4)) : Qt("", !0),
      c.value ? (Mt(), Ot("div", {
        key: 2,
        ref: "moveHandle1",
        style: xe({
          width: Ci + "px",
          height: Ci + "px",
          left: c.value[0] - Ci / 2 + "px",
          top: c.value[1] - Ci / 2 + "px",
          backgroundColor: `rgba(${i.color[0]}, ${i.color[1]}, ${i.color[2]}, 1)`
        }),
        class: "move-handle"
      }, null, 4)) : Qt("", !0),
      u.value ? (Mt(), Ot("div", {
        key: 3,
        ref: "moveHandle2",
        style: xe({
          width: Ci + "px",
          height: Ci + "px",
          left: u.value[0] - Ci / 2 + "px",
          top: u.value[1] - Ci / 2 + "px",
          backgroundColor: `rgba(${i.color[0]}, ${i.color[1]}, ${i.color[2]}, 1)`
        }),
        class: "move-handle"
      }, null, 4)) : Qt("", !0)
    ], 64));
  }
}), Sbt = /* @__PURE__ */ Dn(xbt, [["__scopeId", "data-v-94b4fe90"]]), Lbt = /* @__PURE__ */ Ne({
  __name: "ToolbarTextContainer",
  props: {
    top: { type: Boolean },
    offset: {},
    size: {},
    originPosition: {},
    viewSize: {},
    xOffset: {},
    angle: {}
  },
  setup(i) {
    const t = i, e = Le(t.viewSize), n = Lt(0);
    return t.angle != null && An().watch(t.angle, () => {
      t.angle && (t.top ? n.value = t.originPosition.get()[0] - (t.originPosition.get()[1] - t.offset) * Math.tan(t.angle.get()) : n.value = t.originPosition.get()[0] + (t.viewSize.get()[1] - t.originPosition.get()[1] - t.offset) * Math.tan(t.angle.get()), n.value = Math.max(t.size[0] / 2, Math.min(n.value, t.viewSize.get()[0] - t.size[0] / 2)));
    }), (s, r) => (Mt(), Ot("div", {
      class: "toolbar",
      style: xe({
        width: t.size[0] + "px",
        height: t.size[1] + "px",
        left: n.value - t.size[0] / 2 + (t.xOffset || 0) + "px",
        top: t.top ? t.offset - t.size[1] / 2 + "px" : K(e)[1] - t.offset - t.size[1] / 2 + "px"
      })
    }, [
      Jh(s.$slots, "default", {}, void 0, !0)
    ], 4));
  }
}), Vbt = /* @__PURE__ */ Dn(Lbt, [["__scopeId", "data-v-3b0f4534"]]), kh = /* @__PURE__ */ Ne({
  __name: "SliceIndicatorLabels",
  props: {
    sliceInfoLabel: {},
    angle: {},
    label: {},
    placeholder: {},
    src: {},
    scale: {},
    angleChangeCallback: { type: Function }
  },
  setup(i) {
    const t = i, e = jl();
    te(() => e.getAssetUrl(`${t.src}`));
    const n = Lt(!1), s = (o) => {
      o != null && t.angleChangeCallback && t.angleChangeCallback(o), n.value = !1;
    }, r = (o, l) => {
      o != null && t.angleChangeCallback && !l && t.angleChangeCallback(o), n.value = !1;
    };
    let a;
    return t.label && (a = Le(t.label)), aa(), (o, l) => (Mt(), le(Vbt, {
      top: i.sliceInfoLabel.top,
      offset: i.sliceInfoLabel.offset,
      originPosition: i.sliceInfoLabel.originPosition,
      viewSize: i.sliceInfoLabel.viewSize,
      size: i.sliceInfoLabel.size,
      xOffset: i.sliceInfoLabel.xOffset,
      angle: i.angle
    }, {
      default: oe(() => [
        Pt(K(ye), {
          modelValue: n.value,
          "onUpdate:modelValue": l[1] || (l[1] = (c) => n.value = c),
          class: "w-full h-full flex justify-center",
          style: { border: "none" },
          label: K(a),
          iconSrcHeight: "19px",
          iconSrcWidth: "19px",
          "icon-src": t.src,
          inputChangeCallback: t.angleChangeCallback,
          "custom-input": !!i.angleChangeCallback,
          isToolbarButton: !0
        }, {
          default: oe(() => [
            i.angleChangeCallback ? (Mt(), le(K(r3), {
              key: 0,
              focused: n.value,
              "onUpdate:focused": l[0] || (l[0] = (c) => n.value = c),
              placeholder: t.placeholder,
              onCustomSelected: s,
              onOnBlur: r
            }, null, 8, ["focused", "placeholder"])) : Qt("", !0)
          ]),
          _: 1
        }, 8, ["modelValue", "label", "icon-src", "inputChangeCallback", "custom-input"])
      ]),
      _: 1
    }, 8, ["top", "offset", "originPosition", "viewSize", "size", "xOffset", "angle"]));
  }
}), Xbt = { style: { width: "100%", height: "100%", overflow: "hidden" } }, Ibt = { style: { position: "absolute", width: "100%", height: "100%" } }, Cbt = ["x1", "x2", "y1", "y2", "stroke"], Ybt = ["x1", "x2", "y1", "y2", "stroke"], GM = 50, wM = 20, vbt = 35, W5 = 50, $x = 25, SDt = /* @__PURE__ */ Ne({
  __name: "SliceIndicators2D",
  props: {
    slices: {},
    originPosition: {},
    viewSize: {},
    crossSectionLines: {},
    thicknessLines: {},
    visible: {},
    angle: {},
    labelAngle: {},
    positionLabel: {},
    onClick: { type: Function },
    angleChangeCallback: { type: Function },
    stepChangeCallback: { type: Function }
  },
  setup(i) {
    const t = i;
    aa();
    const e = Le(t.slices), n = Le(t.viewSize), s = Le(t.originPosition), r = Le(t.crossSectionLines), a = Le(t.thicknessLines);
    let o = Lt(!0);
    return t.visible && (o = Le(t.visible)), (l, c) => (Mt(), Ot("div", Xbt, [
      (Mt(!0), Ot(Me, null, Xn(Object.entries(K(e)), (u) => (Mt(), Ot(Me, {
        key: u[0]
      }, [
        u[1].visible ? (Mt(), le(Sbt, {
          key: 0,
          viewId: u[1].viewId,
          point1: u[1].point1,
          point2: u[1].point2,
          origin: K(s),
          color: u[1].color,
          viewSize: K(n)
        }, null, 8, ["viewId", "point1", "point2", "origin", "color", "viewSize"])) : Qt("", !0)
      ], 64))), 128)),
      t.labelAngle && t.angle && K(o) ? (Mt(), le(kh, {
        key: 0,
        "slice-info-label": {
          top: !0,
          offset: GM,
          size: [vbt, wM],
          originPosition: t.originPosition,
          viewSize: t.viewSize
        },
        placeholder: "Angle",
        angle: t.angle,
        label: t.labelAngle,
        angleChangeCallback: t.angleChangeCallback
      }, null, 8, ["slice-info-label", "angle", "label", "angleChangeCallback"])) : Qt("", !0),
      t.positionLabel && t.angle && K(o) ? (Mt(), le(kh, {
        key: 1,
        "slice-info-label": {
          top: !1,
          offset: GM,
          size: [W5, wM],
          originPosition: t.originPosition,
          viewSize: t.viewSize
        },
        placeholder: "Step",
        angle: t.angle,
        label: t.positionLabel,
        style: { "border-radius": "0" },
        angleChangeCallback: t.stepChangeCallback
      }, null, 8, ["slice-info-label", "angle", "label", "angleChangeCallback"])) : Qt("", !0),
      t.positionLabel && t.angle && t.labelAngle && K(o) ? (Mt(), le(kh, {
        key: 2,
        "slice-info-label": {
          top: !1,
          offset: GM,
          size: [$x, wM],
          originPosition: t.originPosition,
          viewSize: t.viewSize,
          xOffset: W5 / 2 + $x / 2 - 0
        },
        angle: t.angle,
        src: "/icons/32x32/right_icon.svg",
        scale: 0.6,
        style: { "border-radius": "0 4px 4px 0" },
        onClick: c[0] || (c[0] = (u) => {
          var d;
          return (d = t.onClick) == null ? void 0 : d.call(t, !1);
        })
      }, null, 8, ["slice-info-label", "angle"])) : Qt("", !0),
      t.positionLabel && t.angle && t.labelAngle && K(o) ? (Mt(), le(kh, {
        key: 3,
        "slice-info-label": {
          top: !1,
          offset: GM,
          size: [$x, wM],
          originPosition: t.originPosition,
          viewSize: t.viewSize,
          xOffset: -37.5
        },
        angle: t.angle,
        src: "/icons/32x32/left_icon.svg",
        scale: 0.6,
        style: { "border-radius": "4px 0 0 4px" },
        onClick: c[1] || (c[1] = (u) => {
          var d;
          return (d = t.onClick) == null ? void 0 : d.call(t, !0);
        })
      }, null, 8, ["slice-info-label", "angle"])) : Qt("", !0),
      (Mt(), Ot("svg", Ibt, [
        (Mt(!0), Ot(Me, null, Xn(K(r), (u, d) => (Mt(), Ot("line", {
          key: d,
          x1: u.point1[0],
          x2: u.point2[0],
          y1: u.point1[1],
          y2: u.point2[1],
          stroke: `rgba(${u.color[0]}, ${u.color[1]}, ${u.color[2]}, 1)`
        }, null, 8, Cbt))), 128)),
        (Mt(!0), Ot(Me, null, Xn(K(a), (u, d) => (Mt(), Ot("line", {
          key: d,
          x1: u.point1[0],
          x2: u.point2[0],
          y1: u.point1[1],
          y2: u.point2[1],
          stroke: `rgba(${u.color[0]}, ${u.color[1]}, ${u.color[2]}, 1)`
        }, null, 8, Ybt))), 128))
      ]))
    ]));
  }
}), Rbt = { style: { width: "100%", height: "100%", overflow: "hidden" } }, Dbt = 40, qx = 50, xM = 20, Obt = 35, G5 = 50, tS = 25, zbt = /* @__PURE__ */ Ne({
  __name: "CprCrossIndicatorButtons",
  props: {
    originPosition: {},
    viewSize: {},
    visible: {},
    angle: {},
    labelAngle: {},
    positionLabel: {},
    onClick: { type: Function },
    angleChangeCallback: { type: Function },
    stepChangeCallback: { type: Function }
  },
  setup(i) {
    const t = i;
    aa();
    let e = Lt(!0);
    return t.visible && (e = Le(t.visible)), (n, s) => (Mt(), Ot("div", Rbt, [
      t.labelAngle && t.angle && K(e) ? (Mt(), le(kh, {
        key: 0,
        "slice-info-label": {
          top: !0,
          offset: Dbt,
          size: [Obt, xM],
          originPosition: t.originPosition,
          viewSize: t.viewSize
        },
        placeholder: "Angle",
        angle: t.angle,
        label: t.labelAngle,
        angleChangeCallback: t.angleChangeCallback
      }, null, 8, ["slice-info-label", "angle", "label", "angleChangeCallback"])) : Qt("", !0),
      t.positionLabel && t.angle && K(e) ? (Mt(), le(kh, {
        key: 1,
        "slice-info-label": {
          top: !1,
          offset: qx,
          size: [G5, xM],
          originPosition: t.originPosition,
          viewSize: t.viewSize
        },
        placeholder: "Step",
        angle: t.angle,
        label: t.positionLabel,
        style: { "border-radius": "0" },
        angleChangeCallback: t.stepChangeCallback
      }, null, 8, ["slice-info-label", "angle", "label", "angleChangeCallback"])) : Qt("", !0),
      t.positionLabel && t.angle && t.labelAngle && K(e) ? (Mt(), le(kh, {
        key: 2,
        "slice-info-label": {
          top: !1,
          offset: qx,
          size: [tS, xM],
          originPosition: t.originPosition,
          viewSize: t.viewSize,
          xOffset: G5 / 2 + tS / 2 - 0
        },
        angle: t.angle,
        src: "/icons/32x32/right_icon.svg",
        scale: 0.6,
        style: { "border-radius": "0 4px 4px 0" },
        onClick: s[0] || (s[0] = (r) => {
          var a;
          return (a = t.onClick) == null ? void 0 : a.call(t, !1);
        })
      }, null, 8, ["slice-info-label", "angle"])) : Qt("", !0),
      t.positionLabel && t.angle && t.labelAngle && K(e) ? (Mt(), le(kh, {
        key: 3,
        "slice-info-label": {
          top: !1,
          offset: qx,
          size: [tS, xM],
          originPosition: t.originPosition,
          viewSize: t.viewSize,
          xOffset: -37.5
        },
        angle: t.angle,
        src: "/icons/32x32/left_icon.svg",
        scale: 0.6,
        style: { "border-radius": "4px 0 0 4px" },
        onClick: s[1] || (s[1] = (r) => {
          var a;
          return (a = t.onClick) == null ? void 0 : a.call(t, !0);
        })
      }, null, 8, ["slice-info-label", "angle"])) : Qt("", !0)
    ]));
  }
}), Ebt = {
  key: 0,
  style: { position: "absolute", width: "100%", height: "100%" }
}, kbt = ["d"], Fbt = { style: { position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)", "text-align": "center", color: "blue", "user-select": "none" } }, Id = 240, sy = 200, w5 = 50, jbt = /* @__PURE__ */ Ne({
  __name: "STLRotateHandle",
  props: {
    x: {},
    y: {},
    origin: {},
    color: {},
    viewSize: {},
    visible: { type: Boolean },
    onDrag: { type: Function },
    onDragStart: { type: Function },
    onDragEnd: { type: Function },
    lockedFlag: { type: Boolean }
  },
  setup(i) {
    const t = i, e = Lt(null);
    let n = [0, 0];
    const s = Lt(0), r = Lt(0), a = Lt(0), o = te(() => (a.value - s.value + 360 + 180) % 360 - 180), l = Lt(!1), c = (f, T) => {
      n = [f, T];
      const M = n[0] - t.x, N = n[1] - t.y;
      s.value = Math.atan2(N, M) * 180 / Math.PI, r.value = s.value, l.value = !0, t.onDragStart(f, T);
    }, u = Lt(!1), d = Lt(!1);
    Ga(e, "left", "offset", {
      onDragStart: c,
      onDrag: (f, T) => {
        if (!u.value) {
          u.value = !0, c(f, T);
          return;
        }
        d.value = !0;
        const M = f - t.x, N = T - t.y;
        a.value = Math.atan2(N, M) * 180 / Math.PI;
        const W = r.value - a.value;
        r.value = a.value, t.onDrag(W);
      },
      onDragEnd: (f, T) => {
        u.value = !1, d.value = !1, l.value = !1, t.onDragEnd(f, T);
      }
    });
    const m = (f, T, M, N) => {
      const W = N * Math.PI / 180;
      return {
        x: f + M * Math.cos(W),
        y: T + M * Math.sin(W)
      };
    }, b = (f, T, M, N, W) => {
      const x = m(f, T, M, W), V = m(f, T, M, N);
      let X;
      return W > N ? X = W - N <= 180 ? "0" : "1" : X = W + 360 - N <= 180 ? "0" : "1", [
        "M",
        x.x,
        x.y,
        "A",
        M,
        M,
        0,
        0,
        X,
        V.x,
        V.y,
        "L",
        f,
        T,
        "L",
        x.x,
        x.y
      ].join(" ");
    }, y = te(() => b(t.x, t.y, w5, s.value, a.value)), Z = te(() => m(t.x, t.y, w5 + 20, a.value));
    function g(f) {
      const T = [], M = Math.PI * f, N = Math.PI * 2 / M, W = M * (5 / 8);
      for (let x = W; x < M + W; x++) {
        const V = N * x, X = f * Math.cos(V), C = f * Math.sin(V), R = `calc( 50% + ${X}px ) calc( 50% + ${C}px )`;
        T.push(R);
      }
      return T.push(T[0]), `polygon( evenodd,
    /* outer rect */
    0 0,       /* top - left */
    100% 0,    /* top - right */
    100% 100%, /* bottom - right */
    0% 100%,   /* bottom - left */
    0 0,       /* and top - left again */
    ${T.join(",")}
   )`;
    }
    return (f, T) => t.visible && !t.lockedFlag ? (Mt(), Ot(Me, { key: 0 }, [
      kt("div", {
        style: xe([{ pointerEvents: l.value ? "auto" : "none" }, { "z-index": "10", width: "100%", height: "100%", position: "absolute", cursor: "pointer" }])
      }, null, 4),
      kt("div", {
        ref_key: "root",
        ref: e,
        id: "circle",
        style: xe([{
          left: t.x - Id / 2 + "px",
          top: t.y - Id / 2 + "px",
          width: Id + "px",
          height: Id + "px",
          background: `rgba(${i.color[0]}, ${i.color[1]}, ${i.color[2]}, 0)`,
          clipPath: g(sy / 2),
          pointerEvents: u.value ? "none" : "auto"
        }, { position: "absolute", "border-radius": "50%", cursor: "pointer" }])
      }, null, 4),
      kt("div", {
        ref: "root1",
        id: "circle1",
        style: xe([{
          left: t.x - Id / 2 + "px",
          top: t.y - Id / 2 + "px",
          width: Id + "px",
          height: Id + "px"
        }, { position: "absolute", "border-radius": "50%", border: "2px solid blue", "pointer-events": "none" }])
      }, null, 4),
      kt("div", {
        ref: "root2",
        id: "circle2",
        style: xe([{
          left: t.x - sy / 2 + "px",
          top: t.y - sy / 2 + "px",
          width: sy + "px",
          height: sy + "px"
        }, { position: "absolute", "border-radius": "50%", border: "2px solid blue", "pointer-events": "none" }])
      }, null, 4),
      d.value ? (Mt(), Ot("svg", Ebt, [
        kt("path", {
          d: y.value,
          fill: "rgba(0,0,255,0.5)"
        }, null, 8, kbt)
      ])) : Qt("", !0),
      d.value ? (Mt(), Ot("div", {
        key: 1,
        style: xe([{
          left: Z.value.x + "px",
          top: Z.value.y + "px"
        }, { position: "absolute" }])
      }, [
        kt("div", Fbt, pe(Math.abs(o.value).toFixed(1)), 1)
      ], 4)) : Qt("", !0)
    ], 64)) : Qt("", !0);
  }
}), Ubt = {
  key: 0,
  style: { "z-index": "1000", position: "absolute", width: "100%", height: "100%", "pointer-events": "auto", cursor: "pointer" }
}, Pbt = /* @__PURE__ */ Ne({
  __name: "STLMoveWidget",
  props: {
    viewSize: {},
    viewObjectPositions: {},
    objectMoveEvent: {},
    objectMoveStartEvent: {},
    objectRotateEvent: {},
    objectRotateStartEvent: {},
    createUndoEvent: {},
    objectPreciseMoveEvent: {},
    cprtommTransform: { type: Boolean }
  },
  setup(i) {
    const t = i, e = Le(t.viewObjectPositions), n = Le(t.viewSize), s = Lt(!1), r = Lt(!1);
    let a = [0, 0];
    const o = (p, m, b, y) => {
      s.value = !0, r.value = !!(y != null && y.ctrlKey), a = [p, m], t.objectMoveStartEvent.notify({
        objectId: b,
        viewPosition: [p, m],
        setRotationCenter: r.value || void 0
      });
    }, l = (p, m, b) => {
      a = [m, b], t.objectRotateStartEvent.notify({
        objectId: p,
        angle: 0
      });
    }, c = (p, m, b, y) => {
      if (s.value = !1, r.value) {
        r.value = !1;
        return;
      }
      Math.abs(a[0] - m) > 0.05 && Math.abs(a[1] - b) > 0.05 && t.createUndoEvent.notify({
        objectId: p
      });
    }, u = (p, m, b, y) => {
      r.value ? t.objectMoveEvent.notify({
        objectId: b,
        viewPosition: [p, m],
        setRotationCenter: !0
      }) : t.objectMoveEvent.notify({
        objectId: b,
        viewPosition: [p, m]
      });
    }, d = (p, m) => {
      t.objectRotateEvent.notify({
        objectId: m,
        angle: p
      });
    }, h = (p, m) => {
      t.objectPreciseMoveEvent.notify({
        objectId: p,
        direction: m,
        cprTool: t.cprtommTransform
      }), t.createUndoEvent.notify({
        objectId: p
      });
    };
    return (p, m) => (Mt(), Ot(Me, null, [
      s.value ? (Mt(), Ot("div", Ubt)) : Qt("", !0),
      (Mt(!0), Ot(Me, null, Xn(K(e), (b) => (Mt(), le(MP, {
        key: b.id,
        color: b.color,
        onDrag: (y, Z, g) => u(y, Z, b.id),
        onDragStart: (y, Z, g) => o(y, Z, b.id, g),
        onDragEnd: (y, Z, g) => c(b.id, y, Z),
        preciseMoveClicked: (y) => h(b.id, y),
        visible: !b.lockedFlag && b.visible,
        selected: b.selectedFlag,
        viewSize: K(n),
        x: b.position[0],
        y: b.position[1],
        lockedFlag: !1,
        preciseStepFlag: b.preciseStepFlag
      }, null, 8, ["color", "onDrag", "onDragStart", "onDragEnd", "preciseMoveClicked", "visible", "selected", "viewSize", "x", "y", "preciseStepFlag"]))), 128)),
      (Mt(!0), Ot(Me, null, Xn(K(e), (b) => (Mt(), le(jbt, {
        key: b.id,
        color: b.color,
        onDrag: (y) => d(y, b.id),
        onDragStart: (y, Z) => l(b.id, y, Z),
        onDragEnd: (y, Z) => c(b.id, y, Z),
        visible: !b.lockedFlag && b.visible,
        viewSize: K(n),
        x: b.position[0],
        y: b.position[1],
        origin: b.position,
        lockedFlag: b.lockedFlag
      }, null, 8, ["color", "onDrag", "onDragStart", "onDragEnd", "visible", "viewSize", "x", "y", "origin", "lockedFlag"]))), 128))
    ], 64));
  }
}), Jbt = {}, Abt = { class: "toolbar1" }, Bbt = { class: "toolbar" };
function Kbt(i, t) {
  return Mt(), Ot("div", Abt, [
    kt("div", Bbt, [
      Jh(i.$slots, "default", {}, void 0, !0)
    ])
  ]);
}
const Cg = /* @__PURE__ */ Dn(Jbt, [["render", Kbt], ["__scopeId", "data-v-d0b59798"]]), Hbt = /* @__PURE__ */ Ne({
  __name: "Toolbar2D",
  props: {
    isFullscreen: {},
    layout: {},
    layouts: {},
    isCrossSection: {},
    spacing: {},
    spacings: {},
    thickness: {},
    filterMode: {},
    filterModeOptions: {},
    minThickness: {},
    maxThickness: {},
    sliceWindow: {},
    sliceLevel: {},
    setWindowLevel: { type: Function },
    setThickness: { type: Function },
    setFilterMode: { type: Function },
    crossAngle: {},
    openCrossAngleDialog: { type: Function },
    events: {}
  },
  setup(i) {
    const t = i;
    aa();
    const e = Le(t.isFullscreen), n = Le(t.layout), s = Le(t.isCrossSection), r = Le(t.spacing), a = Le(t.sliceWindow), o = Le(t.sliceLevel);
    let l;
    t.crossAngle && (l = Le(t.crossAngle));
    const c = te(() => {
      const A = [];
      for (let E in t.layouts)
        A.push({ label: t.layouts[E], value: E });
      return A;
    }), u = te(() => {
      const A = [];
      for (let E of t.spacings.get())
        A.push({ label: E.toFixed(2) + " mm", value: E });
      return A;
    }), { filterModeOptions: d } = Vo(t), h = te(() => {
      const A = [];
      return Object.entries(CW).forEach((E) => {
        d.value.includes(Number(E[0])) && A.push({
          label: E[1].long,
          value: Number(E[0])
        });
      }), A;
    }), p = te(() => CW[m.value].short), m = Le(t.filterMode), b = Le(t.thickness), y = [];
    Math.round(t.maxThickness / 4) > 20 && y.push(Math.round(t.maxThickness / 4)), Math.round(t.maxThickness / 2) > 20 && y.push(Math.round(t.maxThickness / 2)), y.push(Math.round(t.maxThickness));
    const Z = [t.minThickness, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, ...y], g = te(() => {
      const A = [];
      for (let E in Z)
        A.push({ label: Z[E].toFixed(1) + " mm", value: Z[E] });
      return A;
    }), f = () => {
      t.events.setFullscreenEvent.notify({ value: !e.value });
    }, T = () => {
      t.events.screenshotEvent.notify();
    }, M = (A) => {
      A.label !== n.value && t.events.setLayoutEvent.notify({ preset: A.label });
    }, N = Lt(!1), W = (A) => {
      A.value !== r.value && t.events.setSpacingEvent.notify({ spacingMm: Number(A.value) });
    }, x = (A) => {
      if (A && A >= 0) {
        if (A === r.value)
          return;
        t.events.setSpacingEvent.notify({ spacingMm: A }), N.value = !1;
      }
    }, V = (A) => {
      A.value !== m.value && t.setFilterMode(A.value);
    }, X = Lt(!1), C = (A) => {
      A.value !== b.value && t.setThickness(Number(A.value));
    }, R = (A) => {
      if (A && A >= 0) {
        if (A === b.value)
          return;
        t.setThickness(A), X.value = !1;
      }
    }, z = /* @__PURE__ */ new Map([
      ["Bone", [2500, 500]],
      ["Tissue", [1200, 300]],
      ["Calcium", [1, 130]],
      ["Default W/L", [4e3, 1e3]],
      ["Auto Contrast", [0, 0]]
    ]), F = Lt(!1), P = te(() => {
      const A = [];
      for (let E of z) {
        let ct = "";
        (E[0] == "Default W/L" || E[0] == "Auto Contrast") && (ct = E[0]), ct = E[0] + "(" + E[1][0] + "," + E[1][1] + ")", A.push({
          label: ct,
          value: E[0]
        });
      }
      return A;
    }), j = (A) => {
      const E = z.get(A.value);
      if (E) {
        if (E[0] === a.value && E[1] === o.value)
          return;
        t.setWindowLevel(A.value, E[0], E[1]);
      }
    }, H = Lt(!1), B = (A) => {
      A != null && t.openCrossAngleDialog && t.openCrossAngleDialog(A), H.value = !1;
    }, $ = (A, E) => {
      A != null && t.openCrossAngleDialog && !E && t.openCrossAngleDialog(A), H.value = !1;
    };
    return (A, E) => (Mt(), le(Cg, null, {
      default: oe(() => [
        Pt(K(ye), {
          iconSrc: "/icons/new_icons/toolbar_3d/ik_fullscreen_28.svg",
          onClick: f,
          isToolbarButton: !0,
          tooltip: K(jt)("medic-web-engine.toggleFullscreen")
        }, null, 8, ["tooltip"]),
        Pt(K(ye), {
          iconSrc: "/icons/new_icons/toolbar_3d/ik_screenshot_28.svg",
          onClick: T,
          isToolbarButton: !0,
          tooltip: K(jt)("medic-web-engine.captureScreenshot")
        }, null, 8, ["tooltip"]),
        Pt(K(ye), {
          label: K(n),
          dropdown: !0,
          isToolbarButton: !0,
          tooltip: K(jt)("medic-web-engine.layout")
        }, {
          default: oe(() => [
            Pt(K(Fd), {
              "dropdown-items": c.value,
              onSelected: M
            }, null, 8, ["dropdown-items"])
          ]),
          _: 1
        }, 8, ["label", "tooltip"]),
        K(s) ? (Mt(), le(K(ye), {
          key: 0,
          dropdownState: N.value,
          "onUpdate:dropdownState": E[0] || (E[0] = (ct) => N.value = ct),
          label: `Sp: ${K(r).toFixed(2)} mm`,
          dropdown: !0,
          isToolbarButton: !0,
          tooltip: K(jt)("medic-web-engine.crossSectionSpacing")
        }, {
          default: oe(() => [
            Pt(K(Fd), {
              "dropdown-items": u.value,
              customInput: !0,
              onSelected: W,
              onCustomSelected: x
            }, null, 8, ["dropdown-items"])
          ]),
          _: 1
        }, 8, ["dropdownState", "label", "tooltip"])) : Qt("", !0),
        Pt(K(ye), {
          label: p.value,
          dropdown: !0,
          isToolbarButton: !0,
          tooltip: K(jt)("medic-web-engine.visualizationMode")
        }, {
          default: oe(() => [
            Pt(K(Fd), {
              "dropdown-items": h.value,
              onSelected: V
            }, null, 8, ["dropdown-items"])
          ]),
          _: 1
        }, 8, ["label", "tooltip"]),
        Pt(K(ye), {
          dropdownState: X.value,
          "onUpdate:dropdownState": E[1] || (E[1] = (ct) => X.value = ct),
          label: `Th:${K(b).toFixed(1)} mm`,
          dropdown: !0,
          isToolbarButton: !0,
          tooltip: K(jt)("medic-web-engine.sliceThickness")
        }, {
          default: oe(() => [
            Pt(K(Fd), {
              "dropdown-items": g.value,
              customInput: !0,
              onSelected: C,
              onCustomSelected: R
            }, null, 8, ["dropdown-items"])
          ]),
          _: 1
        }, 8, ["dropdownState", "label", "tooltip"]),
        Pt(K(ye), {
          dropdownState: F.value,
          "onUpdate:dropdownState": E[2] || (E[2] = (ct) => F.value = ct),
          label: `W/L:=${Math.round(K(a))}/${Math.round(K(o))}`,
          dropdown: !0,
          isToolbarButton: !0,
          tooltip: K(jt)("shared.wL")
        }, {
          default: oe(() => [
            Pt(K(Fd), {
              "dropdown-items": P.value,
              onSelected: j
            }, null, 8, ["dropdown-items"])
          ]),
          _: 1
        }, 8, ["dropdownState", "label", "tooltip"]),
        K(l) != null ? (Mt(), le(K(ye), {
          key: 1,
          dropdownState: H.value,
          "onUpdate:dropdownState": E[4] || (E[4] = (ct) => H.value = ct),
          label: `Angle:${(K(l) * 180 / Math.PI).toFixed(1)}°`,
          customInput: !0,
          isToolbarButton: !0,
          tooltip: K(jt)("medic-web-engine.cprAngle")
        }, {
          default: oe(() => [
            Pt(K(r3), {
              focused: H.value,
              "onUpdate:focused": E[3] || (E[3] = (ct) => H.value = ct),
              min: "-45",
              max: "45",
              step: "1",
              placeholder: "Angle °",
              onCustomSelected: B,
              onOnBlur: $
            }, null, 8, ["focused"])
          ]),
          _: 1
        }, 8, ["dropdownState", "label", "tooltip"])) : Qt("", !0)
      ]),
      _: 1
    }));
  }
}), _bt = /* @__PURE__ */ Ne({
  __name: "Toolbar2DCustom",
  props: {
    isFullscreen: {},
    filterMode: {},
    filterModeOptions: {},
    thickness: {},
    sliceWindow: {},
    sliceLevel: {},
    setWindowLevel: { type: Function },
    events: {}
  },
  setup(i) {
    const t = i;
    aa();
    const e = Le(t.isFullscreen), n = Le(t.filterMode), s = Le(t.thickness), r = Le(t.sliceWindow), a = Le(t.sliceLevel), o = [1, 2, 5, 10, 20], l = te(() => {
      const N = [];
      for (let W in o)
        N.push({ label: o[W].toFixed(1) + " mm", value: o[W] });
      return N;
    }), { filterModeOptions: c } = Vo(t), u = te(() => {
      const N = [];
      return Object.entries(CW).forEach((W) => {
        c.value.includes(Number(W[0])) && N.push({
          label: W[1].long,
          value: Number(W[0])
        });
      }), N;
    }), d = te(() => CW[n.value].short), h = () => {
      t.events.setFullscreenEvent.notify({ value: !e.value });
    }, p = () => {
      t.events.screenshotEvent.notify();
    }, m = (N) => {
      N.value !== n.value && t.events.setFilterModeEvent.notify({ filterMode: N.value });
    }, b = Lt(!1), y = (N) => {
      N.value !== s.value && t.events.setThicknessEvent.notify({ thickness: N.value });
    }, Z = (N) => {
      if (N && N >= 0) {
        if (N === s.value)
          return;
        t.events.setThicknessEvent.notify({ thickness: N }), b.value = !1;
      }
    }, g = /* @__PURE__ */ new Map([
      ["Bone", [2500, 500]],
      ["Tissue", [1200, 300]],
      ["Calcium", [1, 130]],
      ["Default W/L", [4e3, 1e3]],
      ["Auto Contrast", [0, 0]]
    ]), f = Lt(!1), T = te(() => {
      const N = [];
      for (let W of g) {
        let x = "";
        (W[0] == "Default W/L" || W[0] == "Auto Contrast") && (x = W[0]), x = W[0] + "(" + W[1][0] + "," + W[1][1] + ")", N.push({
          label: x,
          value: W[0]
        });
      }
      return N;
    }), M = (N) => {
      const W = g.get(N.value);
      if (W) {
        if (W[0] === r.value && W[1] === a.value)
          return;
        t.setWindowLevel(N.value, W[0], W[1]);
      }
    };
    return (N, W) => (Mt(), le(Cg, null, {
      default: oe(() => [
        Pt(K(ye), {
          iconSrc: "/icons/new_icons/toolbar_3d/ik_fullscreen_28.svg",
          onClick: h,
          isToolbarButton: !0,
          tooltip: K(jt)("medic-web-engine.toggleFullscreen")
        }, null, 8, ["tooltip"]),
        Pt(K(ye), {
          iconSrc: "/icons/new_icons/toolbar_3d/ik_screenshot_28.svg",
          onClick: p,
          isToolbarButton: !0,
          tooltip: K(jt)("medic-web-engine.captureScreenshot")
        }, null, 8, ["tooltip"]),
        Pt(K(ye), {
          label: d.value,
          dropdown: !0,
          isToolbarButton: !0,
          tooltip: K(jt)("medic-web-engine.visualizationMode")
        }, {
          default: oe(() => [
            Pt(K(Fd), {
              "dropdown-items": u.value,
              onSelected: m
            }, null, 8, ["dropdown-items"])
          ]),
          _: 1
        }, 8, ["label", "tooltip"]),
        Pt(K(ye), {
          dropdownState: b.value,
          "onUpdate:dropdownState": W[0] || (W[0] = (x) => b.value = x),
          label: `Th:${K(s).toFixed(1)} mm`,
          dropdown: !0,
          isToolbarButton: !0,
          tooltip: K(jt)("medic-web-engine.sliceThickness")
        }, {
          default: oe(() => [
            Pt(K(Fd), {
              "dropdown-items": l.value,
              customInput: !0,
              onSelected: y,
              onCustomSelected: Z
            }, null, 8, ["dropdown-items"])
          ]),
          _: 1
        }, 8, ["dropdownState", "label", "tooltip"]),
        Pt(K(ye), {
          dropdownState: f.value,
          "onUpdate:dropdownState": W[1] || (W[1] = (x) => f.value = x),
          label: `W/L:=${Math.round(K(r))}/${Math.round(K(a))}`,
          dropdown: !0,
          isToolbarButton: !0,
          tooltip: K(jt)("shared.wL")
        }, {
          default: oe(() => [
            Pt(K(Fd), {
              "dropdown-items": T.value,
              onSelected: M
            }, null, 8, ["dropdown-items"])
          ]),
          _: 1
        }, 8, ["dropdownState", "label", "tooltip"])
      ]),
      _: 1
    }));
  }
}), Qbt = /* @__PURE__ */ Ne({
  __name: "Toolbar3D",
  props: {
    isFullscreen: {},
    setScoutPlanesType: { type: Function },
    events: {}
  },
  setup(i) {
    const t = i, e = Le(t.isFullscreen);
    aa();
    const n = () => {
      t.events.setFullscreenEvent.notify({ value: !e.value });
    }, s = () => {
      t.events.screenshotEvent.notify();
    }, r = (c) => {
      t.events.setVolumeTemplateEvent.notify(c);
    }, a = () => {
      t.events.toggleVolumeVisibilityEvent.notify();
    }, o = (c) => {
      t.events.toggleObjectTypeVisibilityEvent.notify(c);
    }, l = (c) => {
      t.setScoutPlanesType(c);
    };
    return (c, u) => (Mt(), le(Cg, null, {
      default: oe(() => [
        Pt(K(ye), {
          isToolbarButton: !0,
          iconSrc: "/icons/new_icons/toolbar_3d/ik_fullscreen_28.svg",
          onClick: n,
          tooltip: K(jt)("medic-web-engine.toggleFullscreen")
        }, null, 8, ["tooltip"]),
        Pt(K(ye), {
          isToolbarButton: !0,
          iconSrc: "/icons/new_icons/toolbar_3d/ik_screenshot_28.svg",
          onClick: s,
          tooltip: K(jt)("medic-web-engine.captureScreenshot")
        }, null, 8, ["tooltip"]),
        Pt(K(ye), {
          isToolbarButton: !0,
          iconSrc: "/icons/new_icons/toolbar_3d/ik_xray_28.svg",
          onClick: u[0] || (u[0] = (d) => r(0)),
          tooltip: K(jt)("medic-web-engine.xRay")
        }, null, 8, ["tooltip"]),
        Pt(K(ye), {
          isToolbarButton: !0,
          iconSrc: "/icons/new_icons/toolbar_3d/ik_bones_28.svg",
          onClick: u[1] || (u[1] = (d) => r(1)),
          tooltip: K(jt)("medic-web-engine.bones")
        }, null, 8, ["tooltip"]),
        Pt(K(ye), {
          isToolbarButton: !0,
          iconSrc: "/icons/new_icons/toolbar_3d/ik_face_28.svg",
          onClick: u[2] || (u[2] = (d) => r(2)),
          tooltip: K(jt)("medic-web-engine.softTissues")
        }, null, 8, ["tooltip"]),
        Pt(K(ye), {
          isToolbarButton: !0,
          iconSrc: "/icons/new_icons/toolbar_3d/ik_teeth3DTemplates_28.svg",
          onClick: u[3] || (u[3] = (d) => r(3)),
          tooltip: K(jt)("shared.teeth")
        }, null, 8, ["tooltip"]),
        Pt(K(ye), {
          isToolbarButton: !0,
          iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg",
          onClick: a,
          tooltip: K(jt)("medic-web-engine.showHideDicom")
        }, null, 8, ["tooltip"]),
        Pt(K(ye), {
          isToolbarButton: !0,
          iconSrc: "/icons/new_icons/toolbar_3d/ik_implant_28.svg",
          onClick: u[4] || (u[4] = (d) => o(0)),
          tooltip: K(jt)("medic-web-engine.showHideImplants")
        }, null, 8, ["tooltip"]),
        Pt(K(ye), {
          isToolbarButton: !0,
          iconSrc: "/icons/new_icons/toolbar_3d/ik_abutment_28.svg",
          onClick: u[5] || (u[5] = (d) => o(1)),
          tooltip: K(jt)("medic-web-engine.showHideAbutments")
        }, null, 8, ["tooltip"]),
        Pt(K(ye), {
          isToolbarButton: !0,
          iconSrc: "/icons/new_icons/toolbar_3d/ik_sleeve_28.svg",
          onClick: u[6] || (u[6] = (d) => o(2)),
          tooltip: K(jt)("medic-web-engine.showHideSleeves")
        }, null, 8, ["tooltip"]),
        Pt(K(ye), {
          isToolbarButton: !0,
          iconSrc: "/icons/new_icons/toolbar_3d/ik_scout1_28.svg",
          onClick: u[7] || (u[7] = (d) => l(2)),
          tooltip: K(jt)("medic-web-engine.showScoutPlanes")
        }, null, 8, ["tooltip"]),
        Pt(K(ye), {
          isToolbarButton: !0,
          iconSrc: "/icons/new_icons/toolbar_3d/ik_scout2_28.svg",
          onClick: u[8] || (u[8] = (d) => l(1)),
          tooltip: K(jt)("medic-web-engine.showScoutLines")
        }, null, 8, ["tooltip"]),
        Pt(K(ye), {
          isToolbarButton: !0,
          iconSrc: "/icons/new_icons/toolbar_3d/ik_scout3_28.svg",
          onClick: u[9] || (u[9] = (d) => l(0)),
          tooltip: K(jt)("medic-web-engine.hideScout")
        }, null, 8, ["tooltip"])
      ]),
      _: 1
    }));
  }
}), LDt = /* @__PURE__ */ Ne({
  __name: "Toolbar3DTeethView",
  props: {
    events: {}
  },
  setup(i) {
    const t = i, e = () => {
      t.events.toggleVolumeVisibility.notify();
    };
    return aa(), (n, s) => (Mt(), le(Cg, null, {
      default: oe(() => [
        Pt(K(ye), {
          isToolbarButton: !0,
          iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg",
          onClick: e,
          tooltip: K(jt)("medic-web-engine.showHideDicom")
        }, null, 8, ["tooltip"])
      ]),
      _: 1
    }));
  }
}), $bt = { class: "fullscreen-button" }, qbt = /* @__PURE__ */ Ne({
  __name: "ToolbarFullscreenButton",
  props: {
    state: { type: Boolean }
  },
  setup(i) {
    return (t, e) => (Mt(), Ot("div", $bt, pe(i.state ? "↘" : "⤡"), 1));
  }
}), VDt = /* @__PURE__ */ Dn(qbt, [["__scopeId", "data-v-148ba0a2"]]), tft = {
  key: 0,
  class: "menu"
}, eft = /* @__PURE__ */ Ne({
  __name: "ToolbarMenu",
  props: {
    buttonText: {},
    modelValue: { type: Boolean, default: !1 },
    onOpen: {},
    onClose: {}
  },
  emits: ["update:modelValue"],
  setup(i, { emit: t }) {
    const e = i, n = t, { modelValue: s } = Vo(e), r = Lt(!1);
    gn(r, (l) => {
      var c, u;
      n("update:modelValue", l), l ? (c = e.onOpen) == null || c.call(e) : (u = e.onClose) == null || u.call(e);
    }), gn(s, (l) => {
      r.value = l;
    });
    const a = () => {
      r.value = !r.value;
    }, o = Lt();
    return N7(
      o,
      () => {
        r.value = !1;
      },
      r
    ), (l, c) => (Mt(), Ot("div", {
      ref_key: "menuButton",
      ref: o,
      class: "menu-button",
      onClick: a
    }, [
      Ws(pe(i.buttonText) + " ", 1),
      r.value ? (Mt(), Ot("div", tft, [
        Jh(l.$slots, "default", {}, void 0, !0)
      ])) : Qt("", !0)
    ], 512));
  }
}), XDt = /* @__PURE__ */ Dn(eft, [["__scopeId", "data-v-cfe5e0f7"]]), nft = { class: "slider-box" }, eS = 20, ift = /* @__PURE__ */ Ne({
  __name: "ViewSliceSlider",
  props: {
    sliceInfo: {},
    viewSize: {},
    events: {}
  },
  setup(i) {
    const t = i, e = Le(t.sliceInfo), n = Le(t.viewSize), s = te(() => {
      const { min: b, max: y, value: Z } = e.value;
      return b === y ? 0.5 : 1 - (Z - b) / (y - b);
    }), r = te(() => {
      const b = n.value[1];
      return [(b - eS) / 4, (b - eS) * 3 / 4];
    }), a = te(() => (r.value[1] - r.value[0]) * Math.max(0, Math.min(1, s.value))), o = (b) => {
      const { min: y, max: Z, value: g } = e.value, f = Math.max(y, Math.min(Z, b));
      f !== g && t.events.sliceSelectEvent.notify({
        slice: f
      });
    };
    let l = 0, c = 0;
    const u = (b, y) => {
      c = y, l = 1 - s.value;
    }, d = (b, y) => {
      const Z = l - (y - c) / (r.value[1] - r.value[0]), { min: g, max: f } = e.value, T = Math.max(g, Math.min(f, Math.round(Z * (f - g) + g)));
      o(T);
    }, h = Lt();
    Ga(h, "left", "page", {
      onDragStart: u,
      onDrag: d
    });
    const p = (b) => {
      if (b.deltaY > 0) {
        const { min: y, value: Z } = e.value;
        Z > y && o(Z - 1);
      } else if (b.deltaY < 0) {
        const { max: y, value: Z } = e.value;
        Z < y && o(Z + 1);
      }
    }, m = (b) => {
      const { value: y } = e.value, Z = y + (b ? -1 : 1);
      o(Z);
    };
    return (b, y) => K(e) ? (Mt(), Ot("div", {
      key: 0,
      class: "slider-container",
      onWheel: p
    }, [
      y[4] || (y[4] = kt("div", { class: "slider-line" }, null, -1)),
      kt("div", {
        ref_key: "sliderHandle",
        ref: h,
        style: xe({
          top: a.value + "px"
        }),
        class: "slider-handle"
      }, [
        kt("div", nft, pe(Math.round(K(e).value)), 1),
        as((Mt(), Ot("svg", {
          preserveAspectRatio: "none",
          style: { position: "absolute", width: "100%", height: "10px", top: "-12px" },
          viewBox: "0 0 100 100",
          onClick: y[0] || (y[0] = (Z) => m())
        }, [...y[2] || (y[2] = [
          kt("polygon", {
            points: "25 100 75 100 50 0",
            style: { fill: "white" }
          }, null, -1)
        ])], 512)), [
          [Ss, s.value > 0]
        ]),
        as((Mt(), Ot("svg", {
          style: xe([{
            top: eS + 5 + "px"
          }, { position: "absolute", width: "100%", height: "10px" }]),
          preserveAspectRatio: "none",
          viewBox: "0 0 100 100",
          onClick: y[1] || (y[1] = (Z) => m(!0))
        }, [...y[3] || (y[3] = [
          kt("polygon", {
            points: "25 0 75 0 50 100",
            style: { fill: "white" }
          }, null, -1)
        ])], 4)), [
          [Ss, s.value < 1]
        ])
      ], 4)
    ], 32)) : Qt("", !0);
  }
}), IP = /* @__PURE__ */ Dn(ift, [["__scopeId", "data-v-dc47ba27"]]);
/*!
  * shared v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function Fc(i, t) {
  typeof console < "u" && (console.warn("[intlify] " + i), t && console.warn(t.stack));
}
const x5 = {};
function sft(i) {
  x5[i] || (x5[i] = !0, Fc(i));
}
const dd = typeof window < "u";
let wo, Z0;
if (process.env.NODE_ENV !== "production") {
  const i = dd && window.performance;
  i && i.mark && i.measure && i.clearMarks && // @ts-ignore browser compat
  i.clearMeasures && (wo = (t) => {
    i.mark(t);
  }, Z0 = (t, e, n) => {
    i.measure(t, e, n), i.clearMarks(e), i.clearMarks(n);
  });
}
const rft = /\{([0-9a-zA-Z]+)\}/g;
function tw(i, ...t) {
  return t.length === 1 && si(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), i.replace(rft, (e, n) => t.hasOwnProperty(n) ? t[n] : "");
}
const fd = (i, t = !1) => t ? Symbol.for(i) : Symbol(i), aft = (i, t, e) => oft({ l: i, k: t, s: e }), oft = (i) => JSON.stringify(i).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), br = (i) => typeof i == "number" && isFinite(i), lft = (i) => dC(i) === "[object Date]", SW = (i) => dC(i) === "[object RegExp]", ew = (i) => ii(i) && Object.keys(i).length === 0, fr = Object.assign, cft = Object.create, wi = (i = null) => cft(i);
let S5;
const Ap = () => S5 || (S5 = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : wi());
function L5(i) {
  return i.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function V5(i) {
  return i.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function uft(i) {
  return i = i.replace(/(\w+)\s*=\s*"([^"]*)"/g, (n, s, r) => `${s}="${V5(r)}"`), i = i.replace(/(\w+)\s*=\s*'([^']*)'/g, (n, s, r) => `${s}='${V5(r)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(i) && (process.env.NODE_ENV !== "production" && Fc("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), i = i.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), [
    // In href, src, action, formaction attributes
    /(\s+(?:href|src|action|formaction)\s*=\s*["']?)\s*javascript:/gi,
    // In style attributes within url()
    /(style\s*=\s*["'][^"']*url\s*\(\s*)javascript:/gi
  ].forEach((n) => {
    i = i.replace(n, "$1javascript&#58;");
  }), i;
}
const dft = Object.prototype.hasOwnProperty;
function zl(i, t) {
  return dft.call(i, t);
}
const Gs = Array.isArray, $i = (i) => typeof i == "function", Ee = (i) => typeof i == "string", Ns = (i) => typeof i == "boolean", si = (i) => i !== null && typeof i == "object", hft = (i) => si(i) && $i(i.then) && $i(i.catch), CP = Object.prototype.toString, dC = (i) => CP.call(i), ii = (i) => dC(i) === "[object Object]", pft = (i) => i == null ? "" : Gs(i) || ii(i) && i.toString === CP ? JSON.stringify(i, null, 2) : String(i);
function hC(i, t = "") {
  return i.reduce((e, n, s) => s === 0 ? e + n : e + t + n, "");
}
const X5 = 2;
function mft(i, t = 0, e = i.length) {
  const n = i.split(/\r?\n/);
  let s = 0;
  const r = [];
  for (let a = 0; a < n.length; a++)
    if (s += n[a].length + 1, s >= t) {
      for (let o = a - X5; o <= a + X5 || e > s; o++) {
        if (o < 0 || o >= n.length)
          continue;
        const l = o + 1;
        r.push(`${l}${" ".repeat(3 - String(l).length)}|  ${n[o]}`);
        const c = n[o].length;
        if (o === a) {
          const u = t - (s - c) + 1, d = Math.max(1, e > s ? c - u : e - t);
          r.push("   |  " + " ".repeat(u) + "^".repeat(d));
        } else if (o > a) {
          if (e > s) {
            const u = Math.max(Math.min(e - s, c), 1);
            r.push("   |  " + "^".repeat(u));
          }
          s += c + 1;
        }
      }
      break;
    }
  return r.join(`
`);
}
function bft() {
  const i = /* @__PURE__ */ new Map();
  return {
    events: i,
    on(e, n) {
      const s = i.get(e);
      s && s.push(n) || i.set(e, [n]);
    },
    off(e, n) {
      const s = i.get(e);
      s && s.splice(s.indexOf(n) >>> 0, 1);
    },
    emit(e, n) {
      (i.get(e) || []).slice().map((s) => s(n)), (i.get("*") || []).slice().map((s) => s(e, n));
    }
  };
}
const SM = (i) => !si(i) || Gs(i);
function fN(i, t) {
  if (SM(i) || SM(t))
    throw new Error("Invalid value");
  const e = [{ src: i, des: t }];
  for (; e.length; ) {
    const { src: n, des: s } = e.pop();
    Object.keys(n).forEach((r) => {
      r !== "__proto__" && (si(n[r]) && !si(s[r]) && (s[r] = Array.isArray(n[r]) ? [] : wi()), SM(s[r]) || SM(n[r]) ? s[r] = n[r] : e.push({ src: n[r], des: s[r] }));
    });
  }
}
/*!
  * message-compiler v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function fft(i, t, e) {
  return { line: i, column: t, offset: e };
}
function FL(i, t, e) {
  return { start: i, end: t };
}
const an = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, gft = 17, yft = {
  // tokenizer error messages
  [an.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [an.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [an.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [an.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [an.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [an.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [an.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [an.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [an.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [an.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [an.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [an.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [an.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [an.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [an.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [an.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function Yg(i, t, e = {}) {
  const { domain: n, messages: s, args: r } = e, a = process.env.NODE_ENV !== "production" ? tw((s || yft)[i] || "", ...r || []) : i, o = new SyntaxError(String(a));
  return o.code = i, t && (o.location = t), o.domain = n, o;
}
function Zft(i) {
  throw i;
}
const Tft = /<\/?[\w\s="/.':;#-\/]+>/, Mft = (i) => Tft.test(i), ql = " ", Nft = "\r", Br = `
`, Wft = "\u2028", Gft = "\u2029";
function wft(i) {
  const t = i;
  let e = 0, n = 1, s = 1, r = 0;
  const a = (W) => t[W] === Nft && t[W + 1] === Br, o = (W) => t[W] === Br, l = (W) => t[W] === Gft, c = (W) => t[W] === Wft, u = (W) => a(W) || o(W) || l(W) || c(W), d = () => e, h = () => n, p = () => s, m = () => r, b = (W) => a(W) || l(W) || c(W) ? Br : t[W], y = () => b(e), Z = () => b(e + r);
  function g() {
    return r = 0, u(e) && (n++, s = 0), a(e) && e++, e++, s++, t[e];
  }
  function f() {
    return a(e + r) && r++, r++, t[e + r];
  }
  function T() {
    e = 0, n = 1, s = 1, r = 0;
  }
  function M(W = 0) {
    r = W;
  }
  function N() {
    const W = e + r;
    for (; W !== e; )
      g();
    r = 0;
  }
  return {
    index: d,
    line: h,
    column: p,
    peekOffset: m,
    charAt: b,
    currentChar: y,
    currentPeek: Z,
    next: g,
    peek: f,
    reset: T,
    resetPeek: M,
    skipToPeek: N
  };
}
const tu = void 0, xft = ".", I5 = "'", Sft = "tokenizer";
function Lft(i, t = {}) {
  const e = t.location !== !1, n = wft(i), s = () => n.index(), r = () => fft(n.line(), n.column(), n.index()), a = r(), o = s(), l = {
    currentType: 13,
    offset: o,
    startLoc: a,
    endLoc: a,
    lastType: 13,
    lastOffset: o,
    lastStartLoc: a,
    lastEndLoc: a,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, c = () => l, { onError: u } = t;
  function d(lt, mt, wt, ...Xt) {
    const At = c();
    if (mt.column += wt, mt.offset += wt, u) {
      const he = e ? FL(At.startLoc, mt) : null, ue = Yg(lt, he, {
        domain: Sft,
        args: Xt
      });
      u(ue);
    }
  }
  function h(lt, mt, wt) {
    lt.endLoc = r(), lt.currentType = mt;
    const Xt = { type: mt };
    return e && (Xt.loc = FL(lt.startLoc, lt.endLoc)), wt != null && (Xt.value = wt), Xt;
  }
  const p = (lt) => h(
    lt,
    13
    /* TokenTypes.EOF */
  );
  function m(lt, mt) {
    return lt.currentChar() === mt ? (lt.next(), mt) : (d(an.EXPECTED_TOKEN, r(), 0, mt), "");
  }
  function b(lt) {
    let mt = "";
    for (; lt.currentPeek() === ql || lt.currentPeek() === Br; )
      mt += lt.currentPeek(), lt.peek();
    return mt;
  }
  function y(lt) {
    const mt = b(lt);
    return lt.skipToPeek(), mt;
  }
  function Z(lt) {
    if (lt === tu)
      return !1;
    const mt = lt.charCodeAt(0);
    return mt >= 97 && mt <= 122 || // a-z
    mt >= 65 && mt <= 90 || // A-Z
    mt === 95;
  }
  function g(lt) {
    if (lt === tu)
      return !1;
    const mt = lt.charCodeAt(0);
    return mt >= 48 && mt <= 57;
  }
  function f(lt, mt) {
    const { currentType: wt } = mt;
    if (wt !== 2)
      return !1;
    b(lt);
    const Xt = Z(lt.currentPeek());
    return lt.resetPeek(), Xt;
  }
  function T(lt, mt) {
    const { currentType: wt } = mt;
    if (wt !== 2)
      return !1;
    b(lt);
    const Xt = lt.currentPeek() === "-" ? lt.peek() : lt.currentPeek(), At = g(Xt);
    return lt.resetPeek(), At;
  }
  function M(lt, mt) {
    const { currentType: wt } = mt;
    if (wt !== 2)
      return !1;
    b(lt);
    const Xt = lt.currentPeek() === I5;
    return lt.resetPeek(), Xt;
  }
  function N(lt, mt) {
    const { currentType: wt } = mt;
    if (wt !== 7)
      return !1;
    b(lt);
    const Xt = lt.currentPeek() === ".";
    return lt.resetPeek(), Xt;
  }
  function W(lt, mt) {
    const { currentType: wt } = mt;
    if (wt !== 8)
      return !1;
    b(lt);
    const Xt = Z(lt.currentPeek());
    return lt.resetPeek(), Xt;
  }
  function x(lt, mt) {
    const { currentType: wt } = mt;
    if (!(wt === 7 || wt === 11))
      return !1;
    b(lt);
    const Xt = lt.currentPeek() === ":";
    return lt.resetPeek(), Xt;
  }
  function V(lt, mt) {
    const { currentType: wt } = mt;
    if (wt !== 9)
      return !1;
    const Xt = () => {
      const he = lt.currentPeek();
      return he === "{" ? Z(lt.peek()) : he === "@" || he === "|" || he === ":" || he === "." || he === ql || !he ? !1 : he === Br ? (lt.peek(), Xt()) : C(lt, !1);
    }, At = Xt();
    return lt.resetPeek(), At;
  }
  function X(lt) {
    b(lt);
    const mt = lt.currentPeek() === "|";
    return lt.resetPeek(), mt;
  }
  function C(lt, mt = !0) {
    const wt = (At = !1, he = "") => {
      const ue = lt.currentPeek();
      return ue === "{" || ue === "@" || !ue ? At : ue === "|" ? !(he === ql || he === Br) : ue === ql ? (lt.peek(), wt(!0, ql)) : ue === Br ? (lt.peek(), wt(!0, Br)) : !0;
    }, Xt = wt();
    return mt && lt.resetPeek(), Xt;
  }
  function R(lt, mt) {
    const wt = lt.currentChar();
    return wt === tu ? tu : mt(wt) ? (lt.next(), wt) : null;
  }
  function z(lt) {
    const mt = lt.charCodeAt(0);
    return mt >= 97 && mt <= 122 || // a-z
    mt >= 65 && mt <= 90 || // A-Z
    mt >= 48 && mt <= 57 || // 0-9
    mt === 95 || // _
    mt === 36;
  }
  function F(lt) {
    return R(lt, z);
  }
  function P(lt) {
    const mt = lt.charCodeAt(0);
    return mt >= 97 && mt <= 122 || // a-z
    mt >= 65 && mt <= 90 || // A-Z
    mt >= 48 && mt <= 57 || // 0-9
    mt === 95 || // _
    mt === 36 || // $
    mt === 45;
  }
  function j(lt) {
    return R(lt, P);
  }
  function H(lt) {
    const mt = lt.charCodeAt(0);
    return mt >= 48 && mt <= 57;
  }
  function B(lt) {
    return R(lt, H);
  }
  function $(lt) {
    const mt = lt.charCodeAt(0);
    return mt >= 48 && mt <= 57 || // 0-9
    mt >= 65 && mt <= 70 || // A-F
    mt >= 97 && mt <= 102;
  }
  function A(lt) {
    return R(lt, $);
  }
  function E(lt) {
    let mt = "", wt = "";
    for (; mt = B(lt); )
      wt += mt;
    return wt;
  }
  function ct(lt) {
    let mt = "";
    for (; ; ) {
      const wt = lt.currentChar();
      if (wt === "{" || wt === "}" || wt === "@" || wt === "|" || !wt)
        break;
      if (wt === ql || wt === Br)
        if (C(lt))
          mt += wt, lt.next();
        else {
          if (X(lt))
            break;
          mt += wt, lt.next();
        }
      else
        mt += wt, lt.next();
    }
    return mt;
  }
  function at(lt) {
    y(lt);
    let mt = "", wt = "";
    for (; mt = j(lt); )
      wt += mt;
    const Xt = lt.currentChar();
    if (Xt && Xt !== "}" && Xt !== tu && Xt !== ql && Xt !== Br && Xt !== "　") {
      const At = Q(lt);
      return d(an.INVALID_TOKEN_IN_PLACEHOLDER, r(), 0, wt + At), wt + At;
    }
    return lt.currentChar() === tu && d(an.UNTERMINATED_CLOSING_BRACE, r(), 0), wt;
  }
  function dt(lt) {
    y(lt);
    let mt = "";
    return lt.currentChar() === "-" ? (lt.next(), mt += `-${E(lt)}`) : mt += E(lt), lt.currentChar() === tu && d(an.UNTERMINATED_CLOSING_BRACE, r(), 0), mt;
  }
  function gt(lt) {
    return lt !== I5 && lt !== Br;
  }
  function Wt(lt) {
    y(lt), m(lt, "'");
    let mt = "", wt = "";
    for (; mt = R(lt, gt); )
      mt === "\\" ? wt += Zt(lt) : wt += mt;
    const Xt = lt.currentChar();
    return Xt === Br || Xt === tu ? (d(an.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, r(), 0), Xt === Br && (lt.next(), m(lt, "'")), wt) : (m(lt, "'"), wt);
  }
  function Zt(lt) {
    const mt = lt.currentChar();
    switch (mt) {
      case "\\":
      case "'":
        return lt.next(), `\\${mt}`;
      case "u":
        return Gt(lt, mt, 4);
      case "U":
        return Gt(lt, mt, 6);
      default:
        return d(an.UNKNOWN_ESCAPE_SEQUENCE, r(), 0, mt), "";
    }
  }
  function Gt(lt, mt, wt) {
    m(lt, mt);
    let Xt = "";
    for (let At = 0; At < wt; At++) {
      const he = A(lt);
      if (!he) {
        d(an.INVALID_UNICODE_ESCAPE_SEQUENCE, r(), 0, `\\${mt}${Xt}${lt.currentChar()}`);
        break;
      }
      Xt += he;
    }
    return `\\${mt}${Xt}`;
  }
  function Tt(lt) {
    return lt !== "{" && lt !== "}" && lt !== ql && lt !== Br;
  }
  function Q(lt) {
    y(lt);
    let mt = "", wt = "";
    for (; mt = R(lt, Tt); )
      wt += mt;
    return wt;
  }
  function D(lt) {
    let mt = "", wt = "";
    for (; mt = F(lt); )
      wt += mt;
    return wt;
  }
  function q(lt) {
    const mt = (wt) => {
      const Xt = lt.currentChar();
      return Xt === "{" || Xt === "@" || Xt === "|" || Xt === "(" || Xt === ")" || !Xt || Xt === ql ? wt : (wt += Xt, lt.next(), mt(wt));
    };
    return mt("");
  }
  function nt(lt) {
    y(lt);
    const mt = m(
      lt,
      "|"
      /* TokenChars.Pipe */
    );
    return y(lt), mt;
  }
  function et(lt, mt) {
    let wt = null;
    switch (lt.currentChar()) {
      case "{":
        return mt.braceNest >= 1 && d(an.NOT_ALLOW_NEST_PLACEHOLDER, r(), 0), lt.next(), wt = h(
          mt,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), y(lt), mt.braceNest++, wt;
      case "}":
        return mt.braceNest > 0 && mt.currentType === 2 && d(an.EMPTY_PLACEHOLDER, r(), 0), lt.next(), wt = h(
          mt,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), mt.braceNest--, mt.braceNest > 0 && y(lt), mt.inLinked && mt.braceNest === 0 && (mt.inLinked = !1), wt;
      case "@":
        return mt.braceNest > 0 && d(an.UNTERMINATED_CLOSING_BRACE, r(), 0), wt = ot(lt, mt) || p(mt), mt.braceNest = 0, wt;
      default: {
        let At = !0, he = !0, ue = !0;
        if (X(lt))
          return mt.braceNest > 0 && d(an.UNTERMINATED_CLOSING_BRACE, r(), 0), wt = h(mt, 1, nt(lt)), mt.braceNest = 0, mt.inLinked = !1, wt;
        if (mt.braceNest > 0 && (mt.currentType === 4 || mt.currentType === 5 || mt.currentType === 6))
          return d(an.UNTERMINATED_CLOSING_BRACE, r(), 0), mt.braceNest = 0, it(lt, mt);
        if (At = f(lt, mt))
          return wt = h(mt, 4, at(lt)), y(lt), wt;
        if (he = T(lt, mt))
          return wt = h(mt, 5, dt(lt)), y(lt), wt;
        if (ue = M(lt, mt))
          return wt = h(mt, 6, Wt(lt)), y(lt), wt;
        if (!At && !he && !ue)
          return wt = h(mt, 12, Q(lt)), d(an.INVALID_TOKEN_IN_PLACEHOLDER, r(), 0, wt.value), y(lt), wt;
        break;
      }
    }
    return wt;
  }
  function ot(lt, mt) {
    const { currentType: wt } = mt;
    let Xt = null;
    const At = lt.currentChar();
    switch ((wt === 7 || wt === 8 || wt === 11 || wt === 9) && (At === Br || At === ql) && d(an.INVALID_LINKED_FORMAT, r(), 0), At) {
      case "@":
        return lt.next(), Xt = h(
          mt,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), mt.inLinked = !0, Xt;
      case ".":
        return y(lt), lt.next(), h(
          mt,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return y(lt), lt.next(), h(
          mt,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return X(lt) ? (Xt = h(mt, 1, nt(lt)), mt.braceNest = 0, mt.inLinked = !1, Xt) : N(lt, mt) || x(lt, mt) ? (y(lt), ot(lt, mt)) : W(lt, mt) ? (y(lt), h(mt, 11, D(lt))) : V(lt, mt) ? (y(lt), At === "{" ? et(lt, mt) || Xt : h(mt, 10, q(lt))) : (wt === 7 && d(an.INVALID_LINKED_FORMAT, r(), 0), mt.braceNest = 0, mt.inLinked = !1, it(lt, mt));
    }
  }
  function it(lt, mt) {
    let wt = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (mt.braceNest > 0)
      return et(lt, mt) || p(mt);
    if (mt.inLinked)
      return ot(lt, mt) || p(mt);
    switch (lt.currentChar()) {
      case "{":
        return et(lt, mt) || p(mt);
      case "}":
        return d(an.UNBALANCED_CLOSING_BRACE, r(), 0), lt.next(), h(
          mt,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return ot(lt, mt) || p(mt);
      default: {
        if (X(lt))
          return wt = h(mt, 1, nt(lt)), mt.braceNest = 0, mt.inLinked = !1, wt;
        if (C(lt))
          return h(mt, 0, ct(lt));
        break;
      }
    }
    return wt;
  }
  function ht() {
    const { currentType: lt, offset: mt, startLoc: wt, endLoc: Xt } = l;
    return l.lastType = lt, l.lastOffset = mt, l.lastStartLoc = wt, l.lastEndLoc = Xt, l.offset = s(), l.startLoc = r(), n.currentChar() === tu ? h(
      l,
      13
      /* TokenTypes.EOF */
    ) : it(n, l);
  }
  return {
    nextToken: ht,
    currentOffset: s,
    currentPosition: r,
    context: c
  };
}
const Vft = "parser", Xft = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function Ift(i, t, e) {
  switch (i) {
    case "\\\\":
      return "\\";
    // eslint-disable-next-line no-useless-escape
    case "\\'":
      return "'";
    default: {
      const n = parseInt(t || e, 16);
      return n <= 55295 || n >= 57344 ? String.fromCodePoint(n) : "�";
    }
  }
}
function Cft(i = {}) {
  const t = i.location !== !1, { onError: e } = i;
  function n(Z, g, f, T, ...M) {
    const N = Z.currentPosition();
    if (N.offset += T, N.column += T, e) {
      const W = t ? FL(f, N) : null, x = Yg(g, W, {
        domain: Vft,
        args: M
      });
      e(x);
    }
  }
  function s(Z, g, f) {
    const T = { type: Z };
    return t && (T.start = g, T.end = g, T.loc = { start: f, end: f }), T;
  }
  function r(Z, g, f, T) {
    t && (Z.end = g, Z.loc && (Z.loc.end = f));
  }
  function a(Z, g) {
    const f = Z.context(), T = s(3, f.offset, f.startLoc);
    return T.value = g, r(T, Z.currentOffset(), Z.currentPosition()), T;
  }
  function o(Z, g) {
    const f = Z.context(), { lastOffset: T, lastStartLoc: M } = f, N = s(5, T, M);
    return N.index = parseInt(g, 10), Z.nextToken(), r(N, Z.currentOffset(), Z.currentPosition()), N;
  }
  function l(Z, g) {
    const f = Z.context(), { lastOffset: T, lastStartLoc: M } = f, N = s(4, T, M);
    return N.key = g, Z.nextToken(), r(N, Z.currentOffset(), Z.currentPosition()), N;
  }
  function c(Z, g) {
    const f = Z.context(), { lastOffset: T, lastStartLoc: M } = f, N = s(9, T, M);
    return N.value = g.replace(Xft, Ift), Z.nextToken(), r(N, Z.currentOffset(), Z.currentPosition()), N;
  }
  function u(Z) {
    const g = Z.nextToken(), f = Z.context(), { lastOffset: T, lastStartLoc: M } = f, N = s(8, T, M);
    return g.type !== 11 ? (n(Z, an.UNEXPECTED_EMPTY_LINKED_MODIFIER, f.lastStartLoc, 0), N.value = "", r(N, T, M), {
      nextConsumeToken: g,
      node: N
    }) : (g.value == null && n(Z, an.UNEXPECTED_LEXICAL_ANALYSIS, f.lastStartLoc, 0, tc(g)), N.value = g.value || "", r(N, Z.currentOffset(), Z.currentPosition()), {
      node: N
    });
  }
  function d(Z, g) {
    const f = Z.context(), T = s(7, f.offset, f.startLoc);
    return T.value = g, r(T, Z.currentOffset(), Z.currentPosition()), T;
  }
  function h(Z) {
    const g = Z.context(), f = s(6, g.offset, g.startLoc);
    let T = Z.nextToken();
    if (T.type === 8) {
      const M = u(Z);
      f.modifier = M.node, T = M.nextConsumeToken || Z.nextToken();
    }
    switch (T.type !== 9 && n(Z, an.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, tc(T)), T = Z.nextToken(), T.type === 2 && (T = Z.nextToken()), T.type) {
      case 10:
        T.value == null && n(Z, an.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, tc(T)), f.key = d(Z, T.value || "");
        break;
      case 4:
        T.value == null && n(Z, an.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, tc(T)), f.key = l(Z, T.value || "");
        break;
      case 5:
        T.value == null && n(Z, an.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, tc(T)), f.key = o(Z, T.value || "");
        break;
      case 6:
        T.value == null && n(Z, an.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, tc(T)), f.key = c(Z, T.value || "");
        break;
      default: {
        n(Z, an.UNEXPECTED_EMPTY_LINKED_KEY, g.lastStartLoc, 0);
        const M = Z.context(), N = s(7, M.offset, M.startLoc);
        return N.value = "", r(N, M.offset, M.startLoc), f.key = N, r(f, M.offset, M.startLoc), {
          nextConsumeToken: T,
          node: f
        };
      }
    }
    return r(f, Z.currentOffset(), Z.currentPosition()), {
      node: f
    };
  }
  function p(Z) {
    const g = Z.context(), f = g.currentType === 1 ? Z.currentOffset() : g.offset, T = g.currentType === 1 ? g.endLoc : g.startLoc, M = s(2, f, T);
    M.items = [];
    let N = null;
    do {
      const V = N || Z.nextToken();
      switch (N = null, V.type) {
        case 0:
          V.value == null && n(Z, an.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, tc(V)), M.items.push(a(Z, V.value || ""));
          break;
        case 5:
          V.value == null && n(Z, an.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, tc(V)), M.items.push(o(Z, V.value || ""));
          break;
        case 4:
          V.value == null && n(Z, an.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, tc(V)), M.items.push(l(Z, V.value || ""));
          break;
        case 6:
          V.value == null && n(Z, an.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, tc(V)), M.items.push(c(Z, V.value || ""));
          break;
        case 7: {
          const X = h(Z);
          M.items.push(X.node), N = X.nextConsumeToken || null;
          break;
        }
      }
    } while (g.currentType !== 13 && g.currentType !== 1);
    const W = g.currentType === 1 ? g.lastOffset : Z.currentOffset(), x = g.currentType === 1 ? g.lastEndLoc : Z.currentPosition();
    return r(M, W, x), M;
  }
  function m(Z, g, f, T) {
    const M = Z.context();
    let N = T.items.length === 0;
    const W = s(1, g, f);
    W.cases = [], W.cases.push(T);
    do {
      const x = p(Z);
      N || (N = x.items.length === 0), W.cases.push(x);
    } while (M.currentType !== 13);
    return N && n(Z, an.MUST_HAVE_MESSAGES_IN_PLURAL, f, 0), r(W, Z.currentOffset(), Z.currentPosition()), W;
  }
  function b(Z) {
    const g = Z.context(), { offset: f, startLoc: T } = g, M = p(Z);
    return g.currentType === 13 ? M : m(Z, f, T, M);
  }
  function y(Z) {
    const g = Lft(Z, fr({}, i)), f = g.context(), T = s(0, f.offset, f.startLoc);
    return t && T.loc && (T.loc.source = Z), T.body = b(g), i.onCacheKey && (T.cacheKey = i.onCacheKey(Z)), f.currentType !== 13 && n(g, an.UNEXPECTED_LEXICAL_ANALYSIS, f.lastStartLoc, 0, Z[f.offset] || ""), r(T, g.currentOffset(), g.currentPosition()), T;
  }
  return { parse: y };
}
function tc(i) {
  if (i.type === 13)
    return "EOF";
  const t = (i.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function Yft(i, t = {}) {
  const e = {
    ast: i,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => e, helper: (r) => (e.helpers.add(r), r) };
}
function C5(i, t) {
  for (let e = 0; e < i.length; e++)
    pC(i[e], t);
}
function pC(i, t) {
  switch (i.type) {
    case 1:
      C5(i.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      C5(i.items, t);
      break;
    case 6: {
      pC(i.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function vft(i, t = {}) {
  const e = Yft(i);
  e.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), i.body && pC(i.body, e);
  const n = e.context();
  i.helpers = Array.from(n.helpers);
}
function Rft(i) {
  const t = i.body;
  return t.type === 2 ? Y5(t) : t.cases.forEach((e) => Y5(e)), i;
}
function Y5(i) {
  if (i.items.length === 1) {
    const t = i.items[0];
    (t.type === 3 || t.type === 9) && (i.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let e = 0; e < i.items.length; e++) {
      const n = i.items[e];
      if (!(n.type === 3 || n.type === 9) || n.value == null)
        break;
      t.push(n.value);
    }
    if (t.length === i.items.length) {
      i.static = hC(t);
      for (let e = 0; e < i.items.length; e++) {
        const n = i.items[e];
        (n.type === 3 || n.type === 9) && delete n.value;
      }
    }
  }
}
const Dft = "minifier";
function lb(i) {
  switch (i.t = i.type, i.type) {
    case 0: {
      const t = i;
      lb(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = i, e = t.cases;
      for (let n = 0; n < e.length; n++)
        lb(e[n]);
      t.c = e, delete t.cases;
      break;
    }
    case 2: {
      const t = i, e = t.items;
      for (let n = 0; n < e.length; n++)
        lb(e[n]);
      t.i = e, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = i;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = i;
      lb(t.key), t.k = t.key, delete t.key, t.modifier && (lb(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = i;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = i;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw Yg(an.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: Dft,
          args: [i.type]
        });
  }
  delete i.type;
}
const Oft = "parser";
function zft(i, t) {
  const { filename: e, breakLineCode: n, needIndent: s } = t, r = t.location !== !1, a = {
    filename: e,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: n,
    needIndent: s,
    indentLevel: 0
  };
  r && i.loc && (a.source = i.loc.source);
  const o = () => a;
  function l(b, y) {
    a.code += b;
  }
  function c(b, y = !0) {
    const Z = y ? n : "";
    l(s ? Z + "  ".repeat(b) : Z);
  }
  function u(b = !0) {
    const y = ++a.indentLevel;
    b && c(y);
  }
  function d(b = !0) {
    const y = --a.indentLevel;
    b && c(y);
  }
  function h() {
    c(a.indentLevel);
  }
  return {
    context: o,
    push: l,
    indent: u,
    deindent: d,
    newline: h,
    helper: (b) => `_${b}`,
    needIndent: () => a.needIndent
  };
}
function Eft(i, t) {
  const { helper: e } = i;
  i.push(`${e(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Zg(i, t.key), t.modifier ? (i.push(", "), Zg(i, t.modifier), i.push(", _type")) : i.push(", undefined, _type"), i.push(")");
}
function kft(i, t) {
  const { helper: e, needIndent: n } = i;
  i.push(`${e(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), i.indent(n());
  const s = t.items.length;
  for (let r = 0; r < s && (Zg(i, t.items[r]), r !== s - 1); r++)
    i.push(", ");
  i.deindent(n()), i.push("])");
}
function Fft(i, t) {
  const { helper: e, needIndent: n } = i;
  if (t.cases.length > 1) {
    i.push(`${e(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), i.indent(n());
    const s = t.cases.length;
    for (let r = 0; r < s && (Zg(i, t.cases[r]), r !== s - 1); r++)
      i.push(", ");
    i.deindent(n()), i.push("])");
  }
}
function jft(i, t) {
  t.body ? Zg(i, t.body) : i.push("null");
}
function Zg(i, t) {
  const { helper: e } = i;
  switch (t.type) {
    case 0:
      jft(i, t);
      break;
    case 1:
      Fft(i, t);
      break;
    case 2:
      kft(i, t);
      break;
    case 6:
      Eft(i, t);
      break;
    case 8:
      i.push(JSON.stringify(t.value), t);
      break;
    case 7:
      i.push(JSON.stringify(t.value), t);
      break;
    case 5:
      i.push(`${e(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${e(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      i.push(`${e(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${e(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      i.push(JSON.stringify(t.value), t);
      break;
    case 3:
      i.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw Yg(an.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: Oft,
          args: [t.type]
        });
  }
}
const Uft = (i, t = {}) => {
  const e = Ee(t.mode) ? t.mode : "normal", n = Ee(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const s = t.breakLineCode != null ? t.breakLineCode : e === "arrow" ? ";" : `
`, r = t.needIndent ? t.needIndent : e !== "arrow", a = i.helpers || [], o = zft(i, {
    filename: n,
    breakLineCode: s,
    needIndent: r
  });
  o.push(e === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), o.indent(r), a.length > 0 && (o.push(`const { ${hC(a.map((u) => `${u}: _${u}`), ", ")} } = ctx`), o.newline()), o.push("return "), Zg(o, i), o.deindent(r), o.push("}"), delete i.helpers;
  const { code: l, map: c } = o.context();
  return {
    ast: i,
    code: l,
    map: c ? c.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function Pft(i, t = {}) {
  const e = fr({}, t), n = !!e.jit, s = !!e.minify, r = e.optimize == null ? !0 : e.optimize, o = Cft(e).parse(i);
  return n ? (r && Rft(o), s && lb(o), { ast: o, code: "" }) : (vft(o, e), Uft(o, e));
}
/*!
  * core-base v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function Jft() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Ap().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Ap().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function kl(i) {
  return si(i) && mC(i) === 0 && (zl(i, "b") || zl(i, "body"));
}
const YP = ["b", "body"];
function Aft(i) {
  return rp(i, YP);
}
const vP = ["c", "cases"];
function Bft(i) {
  return rp(i, vP, []);
}
const RP = ["s", "static"];
function Kft(i) {
  return rp(i, RP);
}
const DP = ["i", "items"];
function Hft(i) {
  return rp(i, DP, []);
}
const OP = ["t", "type"];
function mC(i) {
  return rp(i, OP);
}
const zP = ["v", "value"];
function LM(i, t) {
  const e = rp(i, zP);
  if (e != null)
    return e;
  throw M2(t);
}
const EP = ["m", "modifier"];
function _ft(i) {
  return rp(i, EP);
}
const kP = ["k", "key"];
function Qft(i) {
  const t = rp(i, kP);
  if (t)
    return t;
  throw M2(
    6
    /* NodeTypes.Linked */
  );
}
function rp(i, t, e) {
  for (let n = 0; n < t.length; n++) {
    const s = t[n];
    if (zl(i, s) && i[s] != null)
      return i[s];
  }
  return e;
}
const FP = [
  ...YP,
  ...vP,
  ...RP,
  ...DP,
  ...kP,
  ...EP,
  ...zP,
  ...OP
];
function M2(i) {
  return new Error(`unhandled node type: ${i}`);
}
function nS(i) {
  return (e) => $ft(e, i);
}
function $ft(i, t) {
  const e = Aft(t);
  if (e == null)
    throw M2(
      0
      /* NodeTypes.Resource */
    );
  if (mC(e) === 1) {
    const r = Bft(e);
    return i.plural(r.reduce((a, o) => [
      ...a,
      v5(i, o)
    ], []));
  } else
    return v5(i, e);
}
function v5(i, t) {
  const e = Kft(t);
  if (e != null)
    return i.type === "text" ? e : i.normalize([e]);
  {
    const n = Hft(t).reduce((s, r) => [...s, jL(i, r)], []);
    return i.normalize(n);
  }
}
function jL(i, t) {
  const e = mC(t);
  switch (e) {
    case 3:
      return LM(t, e);
    case 9:
      return LM(t, e);
    case 4: {
      const n = t;
      if (zl(n, "k") && n.k)
        return i.interpolate(i.named(n.k));
      if (zl(n, "key") && n.key)
        return i.interpolate(i.named(n.key));
      throw M2(e);
    }
    case 5: {
      const n = t;
      if (zl(n, "i") && br(n.i))
        return i.interpolate(i.list(n.i));
      if (zl(n, "index") && br(n.index))
        return i.interpolate(i.list(n.index));
      throw M2(e);
    }
    case 6: {
      const n = t, s = _ft(n), r = Qft(n);
      return i.linked(jL(i, r), s ? jL(i, s) : void 0, i.type);
    }
    case 7:
      return LM(t, e);
    case 8:
      return LM(t, e);
    default:
      throw new Error(`unhandled node on format message part: ${e}`);
  }
}
const qft = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function tgt(i, t) {
  t && Mft(i) && Fc(tw(qft, { source: i }));
}
const egt = (i) => i;
let VM = wi();
function ngt(i, t = {}) {
  let e = !1;
  const n = t.onError || Zft;
  return t.onError = (s) => {
    e = !0, n(s);
  }, { ...Pft(i, t), detectError: e };
}
// @__NO_SIDE_EFFECTS__
function igt(i, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && Ee(i)) {
    const e = Ns(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && tgt(i, e);
    const s = (t.onCacheKey || egt)(i), r = VM[s];
    if (r)
      return r;
    const { ast: a, detectError: o } = ngt(i, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), l = nS(a);
    return o ? l : VM[s] = l;
  } else {
    if (process.env.NODE_ENV !== "production" && !kl(i))
      return Fc(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), (() => i);
    const e = i.cacheKey;
    if (e) {
      const n = VM[e];
      return n || (VM[e] = nS(i));
    } else
      return nS(i);
  }
}
let N2 = null;
function sgt(i) {
  N2 = i;
}
function rgt(i, t, e) {
  N2 && N2.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: i,
    version: t,
    meta: e
  });
}
const agt = /* @__PURE__ */ ogt("function:translate");
function ogt(i) {
  return (t) => N2 && N2.emit(i, t);
}
const ia = {
  INVALID_ARGUMENT: gft,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, lgt = 24;
function qu(i) {
  return Yg(i, null, process.env.NODE_ENV !== "production" ? { messages: cgt } : void 0);
}
const cgt = {
  [ia.INVALID_ARGUMENT]: "Invalid arguments",
  [ia.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [ia.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [ia.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [ia.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [ia.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [ia.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function bC(i, t) {
  return t.locale != null ? R5(t.locale) : R5(i.locale);
}
let iS;
function R5(i) {
  if (Ee(i))
    return i;
  if ($i(i)) {
    if (i.resolvedOnce && iS != null)
      return iS;
    if (i.constructor.name === "Function") {
      const t = i();
      if (hft(t))
        throw qu(ia.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return iS = t;
    } else
      throw qu(ia.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw qu(ia.NOT_SUPPORT_LOCALE_TYPE);
}
function ugt(i, t, e) {
  return [.../* @__PURE__ */ new Set([
    e,
    ...Gs(t) ? t : si(t) ? Object.keys(t) : Ee(t) ? [t] : [e]
  ])];
}
function jP(i, t, e) {
  const n = Ee(e) ? e : LW, s = i;
  s.__localeChainCache || (s.__localeChainCache = /* @__PURE__ */ new Map());
  let r = s.__localeChainCache.get(n);
  if (!r) {
    r = [];
    let a = [e];
    for (; Gs(a); )
      a = D5(r, a, t);
    const o = Gs(t) || !ii(t) ? t : t.default ? t.default : null;
    a = Ee(o) ? [o] : o, Gs(a) && D5(r, a, !1), s.__localeChainCache.set(n, r);
  }
  return r;
}
function D5(i, t, e) {
  let n = !0;
  for (let s = 0; s < t.length && Ns(n); s++) {
    const r = t[s];
    Ee(r) && (n = dgt(i, t[s], e));
  }
  return n;
}
function dgt(i, t, e) {
  let n;
  const s = t.split("-");
  do {
    const r = s.join("-");
    n = hgt(i, r, e), s.splice(-1, 1);
  } while (s.length && n === !0);
  return n;
}
function hgt(i, t, e) {
  let n = !1;
  if (!i.includes(t) && (n = !0, t)) {
    n = t[t.length - 1] !== "!";
    const s = t.replace(/!/g, "");
    i.push(s), (Gs(e) || ii(e)) && e[s] && (n = e[s]);
  }
  return n;
}
const ap = [];
ap[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
ap[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
ap[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
ap[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
ap[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
ap[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
ap[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const pgt = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function mgt(i) {
  return pgt.test(i);
}
function bgt(i) {
  const t = i.charCodeAt(0), e = i.charCodeAt(i.length - 1);
  return t === e && (t === 34 || t === 39) ? i.slice(1, -1) : i;
}
function fgt(i) {
  if (i == null)
    return "o";
  switch (i.charCodeAt(0)) {
    case 91:
    // [
    case 93:
    // ]
    case 46:
    // .
    case 34:
    // "
    case 39:
      return i;
    case 95:
    // _
    case 36:
    // $
    case 45:
      return "i";
    case 9:
    // Tab (HT)
    case 10:
    // Newline (LF)
    case 13:
    // Return (CR)
    case 160:
    // No-break space (NBSP)
    case 65279:
    // Byte Order Mark (BOM)
    case 8232:
    // Line Separator (LS)
    case 8233:
      return "w";
  }
  return "i";
}
function ggt(i) {
  const t = i.trim();
  return i.charAt(0) === "0" && isNaN(parseInt(i)) ? !1 : mgt(t) ? bgt(t) : "*" + t;
}
function ygt(i) {
  const t = [];
  let e = -1, n = 0, s = 0, r, a, o, l, c, u, d;
  const h = [];
  h[
    0
    /* Actions.APPEND */
  ] = () => {
    a === void 0 ? a = o : a += o;
  }, h[
    1
    /* Actions.PUSH */
  ] = () => {
    a !== void 0 && (t.push(a), a = void 0);
  }, h[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    h[
      0
      /* Actions.APPEND */
    ](), s++;
  }, h[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (s > 0)
      s--, n = 4, h[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (s = 0, a === void 0 || (a = ggt(a), a === !1))
        return !1;
      h[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function p() {
    const m = i[e + 1];
    if (n === 5 && m === "'" || n === 6 && m === '"')
      return e++, o = "\\" + m, h[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; n !== null; )
    if (e++, r = i[e], !(r === "\\" && p())) {
      if (l = fgt(r), d = ap[n], c = d[l] || d.l || 8, c === 8 || (n = c[0], c[1] !== void 0 && (u = h[c[1]], u && (o = r, u() === !1))))
        return;
      if (n === 7)
        return t;
    }
}
const O5 = /* @__PURE__ */ new Map();
function Zgt(i, t) {
  return si(i) ? i[t] : null;
}
function Tgt(i, t) {
  if (!si(i))
    return null;
  let e = O5.get(t);
  if (e || (e = ygt(t), e && O5.set(t, e)), !e)
    return null;
  const n = e.length;
  let s = i, r = 0;
  for (; r < n; ) {
    const a = e[r];
    if (FP.includes(a) && kl(s))
      return null;
    const o = s[a];
    if (o === void 0 || $i(s))
      return null;
    s = o, r++;
  }
  return s;
}
const Fa = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
}, Mgt = 8, Ngt = {
  [Fa.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Fa.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Fa.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Fa.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Fa.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Fa.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Fa.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function T0(i, ...t) {
  return tw(Ngt[i], ...t);
}
const Wgt = "11.1.12", nw = -1, LW = "en-US", VW = "", z5 = (i) => `${i.charAt(0).toLocaleUpperCase()}${i.substr(1)}`;
function Ggt() {
  return {
    upper: (i, t) => t === "text" && Ee(i) ? i.toUpperCase() : t === "vnode" && si(i) && "__v_isVNode" in i ? i.children.toUpperCase() : i,
    lower: (i, t) => t === "text" && Ee(i) ? i.toLowerCase() : t === "vnode" && si(i) && "__v_isVNode" in i ? i.children.toLowerCase() : i,
    capitalize: (i, t) => t === "text" && Ee(i) ? z5(i) : t === "vnode" && si(i) && "__v_isVNode" in i ? z5(i.children) : i
  };
}
let UP;
function wgt(i) {
  UP = i;
}
let PP;
function xgt(i) {
  PP = i;
}
let JP;
function Sgt(i) {
  JP = i;
}
let AP = null;
const Lgt = /* @__NO_SIDE_EFFECTS__ */ (i) => {
  AP = i;
}, Vgt = /* @__NO_SIDE_EFFECTS__ */ () => AP;
let BP = null;
const E5 = (i) => {
  BP = i;
}, Xgt = () => BP;
let k5 = 0;
function Igt(i = {}) {
  const t = $i(i.onWarn) ? i.onWarn : Fc, e = Ee(i.version) ? i.version : Wgt, n = Ee(i.locale) || $i(i.locale) ? i.locale : LW, s = $i(n) ? LW : n, r = Gs(i.fallbackLocale) || ii(i.fallbackLocale) || Ee(i.fallbackLocale) || i.fallbackLocale === !1 ? i.fallbackLocale : s, a = ii(i.messages) ? i.messages : sS(s), o = ii(i.datetimeFormats) ? i.datetimeFormats : sS(s), l = ii(i.numberFormats) ? i.numberFormats : sS(s), c = fr(wi(), i.modifiers, Ggt()), u = i.pluralRules || wi(), d = $i(i.missing) ? i.missing : null, h = Ns(i.missingWarn) || SW(i.missingWarn) ? i.missingWarn : !0, p = Ns(i.fallbackWarn) || SW(i.fallbackWarn) ? i.fallbackWarn : !0, m = !!i.fallbackFormat, b = !!i.unresolving, y = $i(i.postTranslation) ? i.postTranslation : null, Z = ii(i.processor) ? i.processor : null, g = Ns(i.warnHtmlMessage) ? i.warnHtmlMessage : !0, f = !!i.escapeParameter, T = $i(i.messageCompiler) ? i.messageCompiler : UP;
  process.env.NODE_ENV !== "production" && $i(i.messageCompiler) && sft(T0(Fa.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const M = $i(i.messageResolver) ? i.messageResolver : PP || Zgt, N = $i(i.localeFallbacker) ? i.localeFallbacker : JP || ugt, W = si(i.fallbackContext) ? i.fallbackContext : void 0, x = i, V = si(x.__datetimeFormatters) ? x.__datetimeFormatters : /* @__PURE__ */ new Map(), X = si(x.__numberFormatters) ? x.__numberFormatters : /* @__PURE__ */ new Map(), C = si(x.__meta) ? x.__meta : {};
  k5++;
  const R = {
    version: e,
    cid: k5,
    locale: n,
    fallbackLocale: r,
    messages: a,
    modifiers: c,
    pluralRules: u,
    missing: d,
    missingWarn: h,
    fallbackWarn: p,
    fallbackFormat: m,
    unresolving: b,
    postTranslation: y,
    processor: Z,
    warnHtmlMessage: g,
    escapeParameter: f,
    messageCompiler: T,
    messageResolver: M,
    localeFallbacker: N,
    fallbackContext: W,
    onWarn: t,
    __meta: C
  };
  return R.datetimeFormats = o, R.numberFormats = l, R.__datetimeFormatters = V, R.__numberFormatters = X, process.env.NODE_ENV !== "production" && (R.__v_emitter = x.__v_emitter != null ? x.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && rgt(R, e, C), R;
}
const sS = (i) => ({ [i]: wi() });
function iw(i, t) {
  return i instanceof RegExp ? i.test(t) : i;
}
function KP(i, t) {
  return i instanceof RegExp ? i.test(t) : i;
}
function fC(i, t, e, n, s) {
  const { missing: r, onWarn: a } = i;
  if (process.env.NODE_ENV !== "production") {
    const o = i.__v_emitter;
    o && o.emit("missing", {
      locale: e,
      key: t,
      type: s,
      groupId: `${s}:${t}`
    });
  }
  if (r !== null) {
    const o = r(i, e, t, s);
    return Ee(o) ? o : t;
  } else
    return process.env.NODE_ENV !== "production" && KP(n, t) && a(T0(Fa.NOT_FOUND_KEY, { key: t, locale: e })), t;
}
function ry(i, t, e) {
  const n = i;
  n.__localeChainCache = /* @__PURE__ */ new Map(), i.localeFallbacker(i, e, t);
}
function HP(i, t) {
  return i === t ? !1 : i.split("-")[0] === t.split("-")[0];
}
function Cgt(i, t) {
  const e = t.indexOf(i);
  if (e === -1)
    return !1;
  for (let n = e + 1; n < t.length; n++)
    if (HP(i, t[n]))
      return !0;
  return !1;
}
const F5 = typeof Intl < "u", _P = {
  dateTimeFormat: F5 && typeof Intl.DateTimeFormat < "u",
  numberFormat: F5 && typeof Intl.NumberFormat < "u"
};
function j5(i, ...t) {
  const { datetimeFormats: e, unresolving: n, fallbackLocale: s, onWarn: r, localeFallbacker: a } = i, { __datetimeFormatters: o } = i;
  if (process.env.NODE_ENV !== "production" && !_P.dateTimeFormat)
    return r(T0(Fa.CANNOT_FORMAT_DATE)), VW;
  const [l, c, u, d] = UL(...t), h = Ns(u.missingWarn) ? u.missingWarn : i.missingWarn, p = Ns(u.fallbackWarn) ? u.fallbackWarn : i.fallbackWarn, m = !!u.part, b = bC(i, u), y = a(
    i,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    b
  );
  if (!Ee(l) || l === "")
    return new Intl.DateTimeFormat(b, d).format(c);
  let Z = {}, g, f = null, T = b, M = null;
  const N = "datetime format";
  for (let V = 0; V < y.length; V++) {
    if (g = M = y[V], process.env.NODE_ENV !== "production" && b !== g && iw(p, l) && r(T0(Fa.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: g
    })), process.env.NODE_ENV !== "production" && b !== g) {
      const X = i.__v_emitter;
      X && X.emit("fallback", {
        type: N,
        key: l,
        from: T,
        to: M,
        groupId: `${N}:${l}`
      });
    }
    if (Z = e[g] || {}, f = Z[l], ii(f))
      break;
    fC(i, l, g, h, N), T = M;
  }
  if (!ii(f) || !Ee(g))
    return n ? nw : l;
  let W = `${g}__${l}`;
  ew(d) || (W = `${W}__${JSON.stringify(d)}`);
  let x = o.get(W);
  return x || (x = new Intl.DateTimeFormat(g, fr({}, f, d)), o.set(W, x)), m ? x.formatToParts(c) : x.format(c);
}
const QP = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function UL(...i) {
  const [t, e, n, s] = i, r = wi();
  let a = wi(), o;
  if (Ee(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw qu(ia.INVALID_ISO_DATE_ARGUMENT);
    const c = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    o = new Date(c);
    try {
      o.toISOString();
    } catch {
      throw qu(ia.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (lft(t)) {
    if (isNaN(t.getTime()))
      throw qu(ia.INVALID_DATE_ARGUMENT);
    o = t;
  } else if (br(t))
    o = t;
  else
    throw qu(ia.INVALID_ARGUMENT);
  return Ee(e) ? r.key = e : ii(e) && Object.keys(e).forEach((l) => {
    QP.includes(l) ? a[l] = e[l] : r[l] = e[l];
  }), Ee(n) ? r.locale = n : ii(n) && (a = n), ii(s) && (a = s), [r.key || "", o, r, a];
}
function U5(i, t, e) {
  const n = i;
  for (const s in e) {
    const r = `${t}__${s}`;
    n.__datetimeFormatters.has(r) && n.__datetimeFormatters.delete(r);
  }
}
function P5(i, ...t) {
  const { numberFormats: e, unresolving: n, fallbackLocale: s, onWarn: r, localeFallbacker: a } = i, { __numberFormatters: o } = i;
  if (process.env.NODE_ENV !== "production" && !_P.numberFormat)
    return r(T0(Fa.CANNOT_FORMAT_NUMBER)), VW;
  const [l, c, u, d] = PL(...t), h = Ns(u.missingWarn) ? u.missingWarn : i.missingWarn, p = Ns(u.fallbackWarn) ? u.fallbackWarn : i.fallbackWarn, m = !!u.part, b = bC(i, u), y = a(
    i,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    b
  );
  if (!Ee(l) || l === "")
    return new Intl.NumberFormat(b, d).format(c);
  let Z = {}, g, f = null, T = b, M = null;
  const N = "number format";
  for (let V = 0; V < y.length; V++) {
    if (g = M = y[V], process.env.NODE_ENV !== "production" && b !== g && iw(p, l) && r(T0(Fa.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: g
    })), process.env.NODE_ENV !== "production" && b !== g) {
      const X = i.__v_emitter;
      X && X.emit("fallback", {
        type: N,
        key: l,
        from: T,
        to: M,
        groupId: `${N}:${l}`
      });
    }
    if (Z = e[g] || {}, f = Z[l], ii(f))
      break;
    fC(i, l, g, h, N), T = M;
  }
  if (!ii(f) || !Ee(g))
    return n ? nw : l;
  let W = `${g}__${l}`;
  ew(d) || (W = `${W}__${JSON.stringify(d)}`);
  let x = o.get(W);
  return x || (x = new Intl.NumberFormat(g, fr({}, f, d)), o.set(W, x)), m ? x.formatToParts(c) : x.format(c);
}
const $P = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function PL(...i) {
  const [t, e, n, s] = i, r = wi();
  let a = wi();
  if (!br(t))
    throw qu(ia.INVALID_ARGUMENT);
  const o = t;
  return Ee(e) ? r.key = e : ii(e) && Object.keys(e).forEach((l) => {
    $P.includes(l) ? a[l] = e[l] : r[l] = e[l];
  }), Ee(n) ? r.locale = n : ii(n) && (a = n), ii(s) && (a = s), [r.key || "", o, r, a];
}
function J5(i, t, e) {
  const n = i;
  for (const s in e) {
    const r = `${t}__${s}`;
    n.__numberFormatters.has(r) && n.__numberFormatters.delete(r);
  }
}
const Ygt = (i) => i, vgt = (i) => "", Rgt = "text", Dgt = (i) => i.length === 0 ? "" : hC(i), Ogt = pft;
function A5(i, t) {
  return i = Math.abs(i), t === 2 ? i ? i > 1 ? 1 : 0 : 1 : i ? Math.min(i, 2) : 0;
}
function zgt(i) {
  const t = br(i.pluralIndex) ? i.pluralIndex : -1;
  return i.named && (br(i.named.count) || br(i.named.n)) ? br(i.named.count) ? i.named.count : br(i.named.n) ? i.named.n : t : t;
}
function Egt(i, t) {
  t.count || (t.count = i), t.n || (t.n = i);
}
function kgt(i = {}) {
  const t = i.locale, e = zgt(i), n = si(i.pluralRules) && Ee(t) && $i(i.pluralRules[t]) ? i.pluralRules[t] : A5, s = si(i.pluralRules) && Ee(t) && $i(i.pluralRules[t]) ? A5 : void 0, r = (Z) => Z[n(e, Z.length, s)], a = i.list || [], o = (Z) => a[Z], l = i.named || wi();
  br(i.pluralIndex) && Egt(e, l);
  const c = (Z) => l[Z];
  function u(Z, g) {
    const f = $i(i.messages) ? i.messages(Z, !!g) : si(i.messages) ? i.messages[Z] : !1;
    return f || (i.parent ? i.parent.message(Z) : vgt);
  }
  const d = (Z) => i.modifiers ? i.modifiers[Z] : Ygt, h = ii(i.processor) && $i(i.processor.normalize) ? i.processor.normalize : Dgt, p = ii(i.processor) && $i(i.processor.interpolate) ? i.processor.interpolate : Ogt, m = ii(i.processor) && Ee(i.processor.type) ? i.processor.type : Rgt, y = {
    list: o,
    named: c,
    plural: r,
    linked: (Z, ...g) => {
      const [f, T] = g;
      let M = "text", N = "";
      g.length === 1 ? si(f) ? (N = f.modifier || N, M = f.type || M) : Ee(f) && (N = f || N) : g.length === 2 && (Ee(f) && (N = f || N), Ee(T) && (M = T || M));
      const W = u(Z, !0)(y), x = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        M === "vnode" && Gs(W) && N ? W[0] : W
      );
      return N ? d(N)(x, M) : x;
    },
    message: u,
    type: m,
    interpolate: p,
    normalize: h,
    values: fr(wi(), a, l)
  };
  return y;
}
const B5 = () => "", tl = (i) => $i(i);
function K5(i, ...t) {
  const { fallbackFormat: e, postTranslation: n, unresolving: s, messageCompiler: r, fallbackLocale: a, messages: o } = i, [l, c] = JL(...t), u = Ns(c.missingWarn) ? c.missingWarn : i.missingWarn, d = Ns(c.fallbackWarn) ? c.fallbackWarn : i.fallbackWarn, h = Ns(c.escapeParameter) ? c.escapeParameter : i.escapeParameter, p = !!c.resolvedMessage, m = Ee(c.default) || Ns(c.default) ? Ns(c.default) ? r ? l : () => l : c.default : e ? r ? l : () => l : null, b = e || m != null && (Ee(m) || $i(m)), y = bC(i, c);
  h && Fgt(c);
  let [Z, g, f] = p ? [
    l,
    y,
    o[y] || wi()
  ] : qP(i, l, y, a, d, u), T = Z, M = l;
  if (!p && !(Ee(T) || kl(T) || tl(T)) && b && (T = m, M = T), !p && (!(Ee(T) || kl(T) || tl(T)) || !Ee(g)))
    return s ? nw : l;
  if (process.env.NODE_ENV !== "production" && Ee(T) && i.messageCompiler == null)
    return Fc(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let N = !1;
  const W = () => {
    N = !0;
  }, x = tl(T) ? T : tJ(i, l, g, T, M, W);
  if (N)
    return T;
  const V = Jgt(i, g, f, c), X = kgt(V), C = jgt(i, x, X);
  let R = n ? n(C, l) : C;
  if (h && Ee(R) && (R = uft(R)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const z = {
      timestamp: Date.now(),
      key: Ee(l) ? l : tl(T) ? T.key : "",
      locale: g || (tl(T) ? T.locale : ""),
      format: Ee(T) ? T : tl(T) ? T.source : "",
      message: R
    };
    z.meta = fr({}, i.__meta, /* @__PURE__ */ Vgt() || {}), agt(z);
  }
  return R;
}
function Fgt(i) {
  Gs(i.list) ? i.list = i.list.map((t) => Ee(t) ? L5(t) : t) : si(i.named) && Object.keys(i.named).forEach((t) => {
    Ee(i.named[t]) && (i.named[t] = L5(i.named[t]));
  });
}
function qP(i, t, e, n, s, r) {
  const { messages: a, onWarn: o, messageResolver: l, localeFallbacker: c } = i, u = c(i, n, e);
  let d = wi(), h, p = null, m = e, b = null;
  const y = "translate";
  for (let Z = 0; Z < u.length; Z++) {
    if (h = b = u[Z], process.env.NODE_ENV !== "production" && e !== h && !HP(e, h) && iw(s, t) && o(T0(Fa.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: h
    })), process.env.NODE_ENV !== "production" && e !== h) {
      const M = i.__v_emitter;
      M && M.emit("fallback", {
        type: y,
        key: t,
        from: m,
        to: b,
        groupId: `${y}:${t}`
      });
    }
    d = a[h] || wi();
    let g = null, f, T;
    if (process.env.NODE_ENV !== "production" && dd && (g = window.performance.now(), f = "intlify-message-resolve-start", T = "intlify-message-resolve-end", wo && wo(f)), (p = l(d, t)) === null && (p = d[t]), process.env.NODE_ENV !== "production" && dd) {
      const M = window.performance.now(), N = i.__v_emitter;
      N && g && p && N.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: p,
        time: M - g,
        groupId: `${y}:${t}`
      }), f && T && wo && Z0 && (wo(T), Z0("intlify message resolve", f, T));
    }
    if (Ee(p) || kl(p) || tl(p))
      break;
    if (!Cgt(h, u)) {
      const M = fC(
        i,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        h,
        r,
        y
      );
      M !== t && (p = M);
    }
    m = b;
  }
  return [p, h, d];
}
function tJ(i, t, e, n, s, r) {
  const { messageCompiler: a, warnHtmlMessage: o } = i;
  if (tl(n)) {
    const h = n;
    return h.locale = h.locale || e, h.key = h.key || t, h;
  }
  if (a == null) {
    const h = (() => n);
    return h.locale = e, h.key = t, h;
  }
  let l = null, c, u;
  process.env.NODE_ENV !== "production" && dd && (l = window.performance.now(), c = "intlify-message-compilation-start", u = "intlify-message-compilation-end", wo && wo(c));
  const d = a(n, Ugt(i, e, s, n, o, r));
  if (process.env.NODE_ENV !== "production" && dd) {
    const h = window.performance.now(), p = i.__v_emitter;
    p && l && p.emit("message-compilation", {
      type: "message-compilation",
      message: n,
      time: h - l,
      groupId: `translate:${t}`
    }), c && u && wo && Z0 && (wo(u), Z0("intlify message compilation", c, u));
  }
  return d.locale = e, d.key = t, d.source = n, d;
}
function jgt(i, t, e) {
  let n = null, s, r;
  process.env.NODE_ENV !== "production" && dd && (n = window.performance.now(), s = "intlify-message-evaluation-start", r = "intlify-message-evaluation-end", wo && wo(s));
  const a = t(e);
  if (process.env.NODE_ENV !== "production" && dd) {
    const o = window.performance.now(), l = i.__v_emitter;
    l && n && l.emit("message-evaluation", {
      type: "message-evaluation",
      value: a,
      time: o - n,
      groupId: `translate:${t.key}`
    }), s && r && wo && Z0 && (wo(r), Z0("intlify message evaluation", s, r));
  }
  return a;
}
function JL(...i) {
  const [t, e, n] = i, s = wi();
  if (!Ee(t) && !br(t) && !tl(t) && !kl(t))
    throw qu(ia.INVALID_ARGUMENT);
  const r = br(t) ? String(t) : (tl(t), t);
  return br(e) ? s.plural = e : Ee(e) ? s.default = e : ii(e) && !ew(e) ? s.named = e : Gs(e) && (s.list = e), br(n) ? s.plural = n : Ee(n) ? s.default = n : ii(n) && fr(s, n), [r, s];
}
function Ugt(i, t, e, n, s, r) {
  return {
    locale: t,
    key: e,
    warnHtmlMessage: s,
    onError: (a) => {
      if (r && r(a), process.env.NODE_ENV !== "production") {
        const o = Pgt(n), l = `Message compilation error: ${a.message}`, c = a.location && o && mft(o, a.location.start.offset, a.location.end.offset), u = i.__v_emitter;
        u && o && u.emit("compile-error", {
          message: o,
          error: a.message,
          start: a.location && a.location.start.offset,
          end: a.location && a.location.end.offset,
          groupId: `translate:${e}`
        }), console.error(c ? `${l}
${c}` : l);
      } else
        throw a;
    },
    onCacheKey: (a) => aft(t, e, a)
  };
}
function Pgt(i) {
  if (Ee(i))
    return i;
  if (i.loc && i.loc.source)
    return i.loc.source;
}
function Jgt(i, t, e, n) {
  const { modifiers: s, pluralRules: r, messageResolver: a, fallbackLocale: o, fallbackWarn: l, missingWarn: c, fallbackContext: u } = i, h = {
    locale: t,
    modifiers: s,
    pluralRules: r,
    messages: (p, m) => {
      let b = a(e, p);
      if (b == null && (u || m)) {
        const [, , y] = qP(
          u || i,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          p,
          t,
          o,
          l,
          c
        );
        b = a(y, p);
      }
      if (Ee(b) || kl(b)) {
        let y = !1;
        const g = tJ(i, p, t, b, p, () => {
          y = !0;
        });
        return y ? B5 : g;
      } else return tl(b) ? b : B5;
    }
  };
  return i.processor && (h.processor = i.processor), n.list && (h.list = n.list), n.named && (h.named = n.named), br(n.plural) && (h.pluralIndex = n.plural), h;
}
Jft();
/*!
  * vue-i18n v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const Agt = "11.1.12";
function Bgt() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (Ap().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (Ap().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Ap().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Ap().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const Lr = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: lgt,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function W2(i, ...t) {
  return Yg(i, null, process.env.NODE_ENV !== "production" ? { messages: Kgt, args: t } : void 0);
}
const Kgt = {
  [Lr.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [Lr.INVALID_ARGUMENT]: "Invalid argument",
  [Lr.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [Lr.NOT_INSTALLED]: "Need to install with `app.use` function",
  [Lr.UNEXPECTED_ERROR]: "Unexpected error",
  [Lr.REQUIRED_VALUE]: "Required in value: {0}",
  [Lr.INVALID_VALUE]: "Invalid value",
  [Lr.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [Lr.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [Lr.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [Lr.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, AL = /* @__PURE__ */ fd("__translateVNode"), BL = /* @__PURE__ */ fd("__datetimeParts"), KL = /* @__PURE__ */ fd("__numberParts"), HL = /* @__PURE__ */ fd("__enableEmitter"), _L = /* @__PURE__ */ fd("__disableEmitter"), Hgt = fd("__setPluralRules"), eJ = /* @__PURE__ */ fd("__injectWithOption"), QL = /* @__PURE__ */ fd("__dispose"), Cc = {
  FALLBACK_TO_ROOT: Mgt,
  // 8
  NOT_FOUND_PARENT_SCOPE: 9,
  IGNORE_OBJ_FLATTEN: 10,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: 11,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: 12,
  // duplicate `useI18n` calling
  DUPLICATE_USE_I18N_CALLING: 13
}, _gt = {
  [Cc.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [Cc.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [Cc.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [Cc.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [Cc.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead.",
  [Cc.DUPLICATE_USE_I18N_CALLING]: "Duplicate `useI18n` calling by local scope. Please don't call it on local scope, due to it does not work properly in component."
};
function XW(i, ...t) {
  return tw(_gt[i], ...t);
}
function G2(i) {
  if (!si(i) || kl(i))
    return i;
  for (const t in i)
    if (zl(i, t))
      if (!t.includes("."))
        si(i[t]) && G2(i[t]);
      else {
        const e = t.split("."), n = e.length - 1;
        let s = i, r = !1;
        for (let a = 0; a < n; a++) {
          if (e[a] === "__proto__")
            throw new Error(`unsafe key: ${e[a]}`);
          if (e[a] in s || (s[e[a]] = wi()), !si(s[e[a]])) {
            process.env.NODE_ENV !== "production" && Fc(XW(Cc.IGNORE_OBJ_FLATTEN, {
              key: e[a]
            })), r = !0;
            break;
          }
          s = s[e[a]];
        }
        if (r || (kl(s) ? FP.includes(e[n]) || delete i[t] : (s[e[n]] = i[t], delete i[t])), !kl(s)) {
          const a = s[e[n]];
          si(a) && G2(a);
        }
      }
  return i;
}
function nJ(i, t) {
  const { messages: e, __i18n: n, messageResolver: s, flatJson: r } = t, a = ii(e) ? e : Gs(n) ? wi() : { [i]: wi() };
  if (Gs(n) && n.forEach((o) => {
    if ("locale" in o && "resource" in o) {
      const { locale: l, resource: c } = o;
      l ? (a[l] = a[l] || wi(), fN(c, a[l])) : fN(c, a);
    } else
      Ee(o) && fN(JSON.parse(o), a);
  }), s == null && r)
    for (const o in a)
      zl(a, o) && G2(a[o]);
  return a;
}
function iJ(i) {
  return i.type;
}
function Qgt(i, t, e) {
  let n = si(t.messages) ? t.messages : wi();
  "__i18nGlobal" in e && (n = nJ(i.locale.value, {
    messages: n,
    __i18n: e.__i18nGlobal
  }));
  const s = Object.keys(n);
  s.length && s.forEach((r) => {
    i.mergeLocaleMessage(r, n[r]);
  });
  {
    if (si(t.datetimeFormats)) {
      const r = Object.keys(t.datetimeFormats);
      r.length && r.forEach((a) => {
        i.mergeDateTimeFormat(a, t.datetimeFormats[a]);
      });
    }
    if (si(t.numberFormats)) {
      const r = Object.keys(t.numberFormats);
      r.length && r.forEach((a) => {
        i.mergeNumberFormat(a, t.numberFormats[a]);
      });
    }
  }
}
function H5(i) {
  return Pt(h7, null, i, 0);
}
const _5 = "__INTLIFY_META__", Q5 = () => [], $gt = () => !1;
let $5 = 0;
function q5(i) {
  return ((t, e, n, s) => i(e, n, l0() || void 0, s));
}
const qgt = /* @__NO_SIDE_EFFECTS__ */ () => {
  const i = l0();
  let t = null;
  return i && (t = iJ(i)[_5]) ? { [_5]: t } : null;
};
function tyt(i = {}) {
  const { __root: t, __injectWithOption: e } = i, n = t === void 0, s = i.flatJson, r = dd ? Lt : gb;
  let a = Ns(i.inheritLocale) ? i.inheritLocale : !0;
  const o = r(
    // prettier-ignore
    t && a ? t.locale.value : Ee(i.locale) ? i.locale : LW
  ), l = r(
    // prettier-ignore
    t && a ? t.fallbackLocale.value : Ee(i.fallbackLocale) || Gs(i.fallbackLocale) || ii(i.fallbackLocale) || i.fallbackLocale === !1 ? i.fallbackLocale : o.value
  ), c = r(nJ(o.value, i)), u = r(ii(i.datetimeFormats) ? i.datetimeFormats : { [o.value]: {} }), d = r(ii(i.numberFormats) ? i.numberFormats : { [o.value]: {} });
  let h = t ? t.missingWarn : Ns(i.missingWarn) || SW(i.missingWarn) ? i.missingWarn : !0, p = t ? t.fallbackWarn : Ns(i.fallbackWarn) || SW(i.fallbackWarn) ? i.fallbackWarn : !0, m = t ? t.fallbackRoot : Ns(i.fallbackRoot) ? i.fallbackRoot : !0, b = !!i.fallbackFormat, y = $i(i.missing) ? i.missing : null, Z = $i(i.missing) ? q5(i.missing) : null, g = $i(i.postTranslation) ? i.postTranslation : null, f = t ? t.warnHtmlMessage : Ns(i.warnHtmlMessage) ? i.warnHtmlMessage : !0, T = !!i.escapeParameter;
  const M = t ? t.modifiers : ii(i.modifiers) ? i.modifiers : {};
  let N = i.pluralRules || t && t.pluralRules, W;
  W = (() => {
    n && E5(null);
    const Dt = {
      version: Agt,
      locale: o.value,
      fallbackLocale: l.value,
      messages: c.value,
      modifiers: M,
      pluralRules: N,
      missing: Z === null ? void 0 : Z,
      missingWarn: h,
      fallbackWarn: p,
      fallbackFormat: b,
      unresolving: !0,
      postTranslation: g === null ? void 0 : g,
      warnHtmlMessage: f,
      escapeParameter: T,
      messageResolver: i.messageResolver,
      messageCompiler: i.messageCompiler,
      __meta: { framework: "vue" }
    };
    Dt.datetimeFormats = u.value, Dt.numberFormats = d.value, Dt.__datetimeFormatters = ii(W) ? W.__datetimeFormatters : void 0, Dt.__numberFormatters = ii(W) ? W.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (Dt.__v_emitter = ii(W) ? W.__v_emitter : void 0);
    const ee = Igt(Dt);
    return n && E5(ee), ee;
  })(), ry(W, o.value, l.value);
  function V() {
    return [
      o.value,
      l.value,
      c.value,
      u.value,
      d.value
    ];
  }
  const X = te({
    get: () => o.value,
    set: (Dt) => {
      W.locale = Dt, o.value = Dt;
    }
  }), C = te({
    get: () => l.value,
    set: (Dt) => {
      W.fallbackLocale = Dt, l.value = Dt, ry(W, o.value, Dt);
    }
  }), R = te(() => c.value), z = /* @__PURE__ */ te(() => u.value), F = /* @__PURE__ */ te(() => d.value);
  function P() {
    return $i(g) ? g : null;
  }
  function j(Dt) {
    g = Dt, W.postTranslation = Dt;
  }
  function H() {
    return y;
  }
  function B(Dt) {
    Dt !== null && (Z = q5(Dt)), y = Dt, W.missing = Z;
  }
  function $(Dt, ee) {
    return Dt !== "translate" || !ee.resolvedMessage;
  }
  const A = (Dt, ee, yt, fe, Xe, Se) => {
    V();
    let Vt;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, n || (W.fallbackContext = t ? Xgt() : void 0), Vt = Dt(W);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, n || (W.fallbackContext = void 0);
    }
    if (yt !== "translate exists" && // for not `te` (e.g `t`)
    br(Vt) && Vt === nw || yt === "translate exists" && !Vt) {
      const [Rt, $t] = ee();
      if (process.env.NODE_ENV !== "production" && t && Ee(Rt) && $(yt, $t) && (m && (iw(p, Rt) || KP(h, Rt)) && Fc(XW(Cc.FALLBACK_TO_ROOT, {
        key: Rt,
        type: yt
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: zt } = W;
        zt && m && zt.emit("fallback", {
          type: yt,
          key: Rt,
          to: "global",
          groupId: `${yt}:${Rt}`
        });
      }
      return t && m ? fe(t) : Xe(Rt);
    } else {
      if (Se(Vt))
        return Vt;
      throw W2(Lr.UNEXPECTED_RETURN_TYPE);
    }
  };
  function E(...Dt) {
    return A((ee) => Reflect.apply(K5, null, [ee, ...Dt]), () => JL(...Dt), "translate", (ee) => Reflect.apply(ee.t, ee, [...Dt]), (ee) => ee, (ee) => Ee(ee));
  }
  function ct(...Dt) {
    const [ee, yt, fe] = Dt;
    if (fe && !si(fe))
      throw W2(Lr.INVALID_ARGUMENT);
    return E(ee, yt, fr({ resolvedMessage: !0 }, fe || {}));
  }
  function at(...Dt) {
    return A((ee) => Reflect.apply(j5, null, [ee, ...Dt]), () => UL(...Dt), "datetime format", (ee) => Reflect.apply(ee.d, ee, [...Dt]), () => VW, (ee) => Ee(ee) || Gs(ee));
  }
  function dt(...Dt) {
    return A((ee) => Reflect.apply(P5, null, [ee, ...Dt]), () => PL(...Dt), "number format", (ee) => Reflect.apply(ee.n, ee, [...Dt]), () => VW, (ee) => Ee(ee) || Gs(ee));
  }
  function gt(Dt) {
    return Dt.map((ee) => Ee(ee) || br(ee) || Ns(ee) ? H5(String(ee)) : ee);
  }
  const Zt = {
    normalize: gt,
    interpolate: (Dt) => Dt,
    type: "vnode"
  };
  function Gt(...Dt) {
    return A((ee) => {
      let yt;
      const fe = ee;
      try {
        fe.processor = Zt, yt = Reflect.apply(K5, null, [fe, ...Dt]);
      } finally {
        fe.processor = null;
      }
      return yt;
    }, () => JL(...Dt), "translate", (ee) => ee[AL](...Dt), (ee) => [H5(ee)], (ee) => Gs(ee));
  }
  function Tt(...Dt) {
    return A((ee) => Reflect.apply(P5, null, [ee, ...Dt]), () => PL(...Dt), "number format", (ee) => ee[KL](...Dt), Q5, (ee) => Ee(ee) || Gs(ee));
  }
  function Q(...Dt) {
    return A((ee) => Reflect.apply(j5, null, [ee, ...Dt]), () => UL(...Dt), "datetime format", (ee) => ee[BL](...Dt), Q5, (ee) => Ee(ee) || Gs(ee));
  }
  function D(Dt) {
    N = Dt, W.pluralRules = N;
  }
  function q(Dt, ee) {
    return A(() => {
      if (!Dt)
        return !1;
      const yt = Ee(ee) ? ee : o.value, fe = ot(yt), Xe = W.messageResolver(fe, Dt);
      return kl(Xe) || tl(Xe) || Ee(Xe);
    }, () => [Dt], "translate exists", (yt) => Reflect.apply(yt.te, yt, [Dt, ee]), $gt, (yt) => Ns(yt));
  }
  function nt(Dt) {
    let ee = null;
    const yt = jP(W, l.value, o.value);
    for (let fe = 0; fe < yt.length; fe++) {
      const Xe = c.value[yt[fe]] || {}, Se = W.messageResolver(Xe, Dt);
      if (Se != null) {
        ee = Se;
        break;
      }
    }
    return ee;
  }
  function et(Dt) {
    const ee = nt(Dt);
    return ee ?? (t ? t.tm(Dt) || {} : {});
  }
  function ot(Dt) {
    return c.value[Dt] || {};
  }
  function it(Dt, ee) {
    if (s) {
      const yt = { [Dt]: ee };
      for (const fe in yt)
        zl(yt, fe) && G2(yt[fe]);
      ee = yt[Dt];
    }
    c.value[Dt] = ee, W.messages = c.value;
  }
  function ht(Dt, ee) {
    c.value[Dt] = c.value[Dt] || {};
    const yt = { [Dt]: ee };
    if (s)
      for (const fe in yt)
        zl(yt, fe) && G2(yt[fe]);
    ee = yt[Dt], fN(ee, c.value[Dt]), W.messages = c.value;
  }
  function lt(Dt) {
    return u.value[Dt] || {};
  }
  function mt(Dt, ee) {
    u.value[Dt] = ee, W.datetimeFormats = u.value, U5(W, Dt, ee);
  }
  function wt(Dt, ee) {
    u.value[Dt] = fr(u.value[Dt] || {}, ee), W.datetimeFormats = u.value, U5(W, Dt, ee);
  }
  function Xt(Dt) {
    return d.value[Dt] || {};
  }
  function At(Dt, ee) {
    d.value[Dt] = ee, W.numberFormats = d.value, J5(W, Dt, ee);
  }
  function he(Dt, ee) {
    d.value[Dt] = fr(d.value[Dt] || {}, ee), W.numberFormats = d.value, J5(W, Dt, ee);
  }
  $5++, t && dd && (gn(t.locale, (Dt) => {
    a && (o.value = Dt, W.locale = Dt, ry(W, o.value, l.value));
  }), gn(t.fallbackLocale, (Dt) => {
    a && (l.value = Dt, W.fallbackLocale = Dt, ry(W, o.value, l.value));
  }));
  const ue = {
    id: $5,
    locale: X,
    fallbackLocale: C,
    get inheritLocale() {
      return a;
    },
    set inheritLocale(Dt) {
      a = Dt, Dt && t && (o.value = t.locale.value, l.value = t.fallbackLocale.value, ry(W, o.value, l.value));
    },
    get availableLocales() {
      return Object.keys(c.value).sort();
    },
    messages: R,
    get modifiers() {
      return M;
    },
    get pluralRules() {
      return N || {};
    },
    get isGlobal() {
      return n;
    },
    get missingWarn() {
      return h;
    },
    set missingWarn(Dt) {
      h = Dt, W.missingWarn = h;
    },
    get fallbackWarn() {
      return p;
    },
    set fallbackWarn(Dt) {
      p = Dt, W.fallbackWarn = p;
    },
    get fallbackRoot() {
      return m;
    },
    set fallbackRoot(Dt) {
      m = Dt;
    },
    get fallbackFormat() {
      return b;
    },
    set fallbackFormat(Dt) {
      b = Dt, W.fallbackFormat = b;
    },
    get warnHtmlMessage() {
      return f;
    },
    set warnHtmlMessage(Dt) {
      f = Dt, W.warnHtmlMessage = Dt;
    },
    get escapeParameter() {
      return T;
    },
    set escapeParameter(Dt) {
      T = Dt, W.escapeParameter = Dt;
    },
    t: E,
    getLocaleMessage: ot,
    setLocaleMessage: it,
    mergeLocaleMessage: ht,
    getPostTranslationHandler: P,
    setPostTranslationHandler: j,
    getMissingHandler: H,
    setMissingHandler: B,
    [Hgt]: D
  };
  return ue.datetimeFormats = z, ue.numberFormats = F, ue.rt = ct, ue.te = q, ue.tm = et, ue.d = at, ue.n = dt, ue.getDateTimeFormat = lt, ue.setDateTimeFormat = mt, ue.mergeDateTimeFormat = wt, ue.getNumberFormat = Xt, ue.setNumberFormat = At, ue.mergeNumberFormat = he, ue[eJ] = e, ue[AL] = Gt, ue[BL] = Q, ue[KL] = Tt, process.env.NODE_ENV !== "production" && (ue[HL] = (Dt) => {
    W.__v_emitter = Dt;
  }, ue[_L] = () => {
    W.__v_emitter = void 0;
  }), ue;
}
function tz(i, t) {
}
const gC = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (i) => i === "parent" || i === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function eyt({ slots: i }, t) {
  return t.length === 1 && t[0] === "default" ? (i.default ? i.default() : []).reduce((n, s) => [
    ...n,
    // prettier-ignore
    ...s.type === Me ? s.children : [s]
  ], []) : t.reduce((e, n) => {
    const s = i[n];
    return s && (e[n] = s()), e;
  }, wi());
}
function sJ() {
  return Me;
}
fr({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (i) => br(i) || !isNaN(i)
  }
}, gC);
function nyt(i) {
  return Gs(i) && !Ee(i[0]);
}
function rJ(i, t, e, n) {
  const { slots: s, attrs: r } = t;
  return () => {
    const a = { part: !0 };
    let o = wi();
    i.locale && (a.locale = i.locale), Ee(i.format) ? a.key = i.format : si(i.format) && (Ee(i.format.key) && (a.key = i.format.key), o = Object.keys(i.format).reduce((h, p) => e.includes(p) ? fr(wi(), h, { [p]: i.format[p] }) : h, wi()));
    const l = n(i.value, a, o);
    let c = [a.key];
    Gs(l) ? c = l.map((h, p) => {
      const m = s[h.type], b = m ? m({ [h.type]: h.value, index: p, parts: l }) : [h.value];
      return nyt(b) && (b[0].key = `${h.type}-${p}`), b;
    }) : Ee(l) && (c = [l]);
    const u = fr(wi(), r), d = Ee(i.tag) || si(i.tag) ? i.tag : sJ();
    return wG(d, u, c);
  };
}
fr({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, gC);
const iyt = /* @__PURE__ */ fd("global-vue-i18n");
function La(i = {}) {
  const t = l0();
  if (t == null)
    throw W2(Lr.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw W2(Lr.NOT_INSTALLED);
  const e = syt(t), n = ayt(e), s = iJ(t), r = ryt(i, s);
  if (r === "global")
    return Qgt(n, i, s), n;
  if (r === "parent") {
    let l = oyt(e, t, i.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && Fc(XW(Cc.NOT_FOUND_PARENT_SCOPE)), l = n), l;
  }
  const a = e;
  let o = a.__getInstance(t);
  if (o == null) {
    const l = fr({}, i);
    "__i18n" in s && (l.__i18n = s.__i18n), n && (l.__root = n), o = tyt(l), a.__composerExtend && (o[QL] = a.__composerExtend(o)), cyt(a, t, o), a.__setInstance(t, o);
  } else
    process.env.NODE_ENV !== "production" && r === "local" && Fc(XW(Cc.DUPLICATE_USE_I18N_CALLING));
  return o;
}
function syt(i) {
  const t = gr(i.isCE ? iyt : i.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw W2(i.isCE ? Lr.NOT_INSTALLED_WITH_PROVIDE : Lr.UNEXPECTED_ERROR);
  return t;
}
function ryt(i, t) {
  return ew(i) ? "__i18n" in t ? "local" : "global" : i.useScope ? i.useScope : "local";
}
function ayt(i) {
  return i.mode === "composition" ? i.global : i.global.__composer;
}
function oyt(i, t, e = !1) {
  let n = null;
  const s = t.root;
  let r = lyt(t, e);
  for (; r != null; ) {
    const a = i;
    if (i.mode === "composition")
      n = a.__getInstance(r);
    else if (__VUE_I18N_LEGACY_API__) {
      const o = a.__getInstance(r);
      o != null && (n = o.__composer, e && n && !n[eJ] && (n = null));
    }
    if (n != null || s === r)
      break;
    r = r.parent;
  }
  return n;
}
function lyt(i, t = !1) {
  return i == null ? null : t && i.vnode.ctx || i.parent;
}
function cyt(i, t, e) {
  let n = null;
  xn(() => {
    if (process.env.NODE_ENV !== "production" && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = e, n = bft();
      const s = e;
      s[HL] && s[HL](n), n.on("*", tz);
    }
  }, t), wg(() => {
    const s = e;
    process.env.NODE_ENV !== "production" && t.vnode.el && t.vnode.el.__VUE_I18N__ && (n && n.off("*", tz), s[_L] && s[_L](), delete t.vnode.el.__VUE_I18N__), i.__deleteInstance(t);
    const r = s[QL];
    r && (r(), delete s[QL]);
  }, t);
}
fr({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, gC);
Bgt();
wgt(igt);
xgt(Tgt);
Sgt(jP);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const i = Ap();
  i.__INTLIFY__ = !0, sgt(i.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const uyt = ["src"], dyt = ["src"], hyt = { class: "flex flex-row-wrap" }, pyt = ["src"], yC = /* @__PURE__ */ Ne({
  __name: "FilePreviewComponent",
  props: {
    selectedFiles: {},
    allFiles: {},
    zoomInStep: {}
  },
  setup(i) {
    const t = i, { selectedFiles: e, allFiles: n, zoomInStep: s } = Vo(t), r = jl(), { t: a } = La(), o = Lt([]), l = Lt([]), c = Lt([]), u = Lt([]), d = /* @__PURE__ */ new Set(), h = (g) => new Promise((f, T) => {
      const M = new FileReader();
      M.onloadend = function(N) {
        let W = "";
        N.target && (W = N.target.result), f(W);
      }, M.onerror = (N) => {
        var W;
        T((W = N.target) == null ? void 0 : W.error);
      }, M.readAsDataURL(g);
    });
    function p(g, f) {
      const T = URL.createObjectURL(g);
      f.add(T);
      const M = s.value ?? 0;
      if (!M || M <= 0)
        return T;
      const N = Math.pow(1.1, M), W = Math.round(100 * N), x = new URL(T);
      return x.hash = `zoom=${W}`, x.toString();
    }
    const m = (g) => {
      const f = g.toLowerCase();
      return f.endsWith(".png") || f.endsWith(".jpg") || f.endsWith(".jpeg") || f.endsWith(".bmp") || f.endsWith(".svg") || f.endsWith(".heic") || f.endsWith(".heif");
    }, b = (g) => g.toLowerCase().endsWith(".heic") || g.toLowerCase().endsWith(".heif"), y = (g) => new Promise((f) => {
      const T = new Image();
      T.onload = () => f(!0), T.onerror = () => f(!1), T.src = g;
    });
    async function Z() {
      if (n.value) {
        const g = [], f = [], T = [], M = [], N = /* @__PURE__ */ new Set();
        for (let W of e.value) {
          const x = W.name.toLowerCase();
          if (m(W.name)) {
            const V = l.value.find((X) => X.fName == W.name);
            if (V)
              T.push({ fName: V.fName, preview: V.preview });
            else {
              const X = await h(W);
              b(W.name) ? await y(X) ? T.push({ fName: W.name, preview: X }) : M.push(W.name) : T.push({ fName: W.name, preview: X });
            }
          } else x.endsWith(".docx") && !f.includes("docx") ? f.push("docx") : x.endsWith(".doc") && !f.includes("doc") ? f.push("doc") : x.endsWith(".zip") && !f.includes("zip") ? f.push("zip") : x.endsWith(".pdf") ? W.type === "application/pdf" && g.push(p(W, N)) : (x.endsWith(".txt") || x.endsWith(".pts")) && !f.includes("txt") ? f.push("txt") : (x.endsWith(".xml") || x.endsWith(".constructioninfo")) && !f.includes("xml") ? f.push("xml") : x.endsWith(".xls") && !f.includes("xls") ? f.push("xls") : x.endsWith(".xlsx") && !f.includes("xlsx") && f.push("xlsx");
        }
        (!f.every((W) => o.value.includes(W)) || !f.length || f.length != o.value.length) && (o.value = f), (!T.every((W) => l.value.includes(W)) || !T.length) && (l.value = T), (!M.every((W) => c.value.includes(W)) || !M.length) && (c.value = M);
        for (const W of d)
          N.has(W) || URL.revokeObjectURL(W);
        d.clear(), N.forEach((W) => d.add(W)), u.value = g;
      }
    }
    return xn(async () => {
      await Z();
    }), gn(e, async () => {
      await Z();
    }), gn(s, async () => {
      await Z();
    }), yr(() => {
      for (const g of d)
        URL.revokeObjectURL(g);
      d.clear();
    }), (g, f) => (Mt(), Ot(Me, null, [
      (Mt(!0), Ot(Me, null, Xn(u.value, (T) => (Mt(), Ot("iframe", {
        key: T,
        src: T,
        style: { border: "none", minHeight: "30vh", width: "100%" },
        allowfullscreen: ""
      }, null, 8, uyt))), 128)),
      (Mt(!0), Ot(Me, null, Xn(l.value, (T) => (Mt(), Ot("img", {
        key: T.fName,
        src: T.preview,
        alt: "icon",
        style: { maxWidth: "20vw", objectFit: "contain" },
        draggable: "false"
      }, null, 8, dyt))), 128)),
      (Mt(!0), Ot(Me, null, Xn(c.value, (T) => (Mt(), Ot("div", {
        key: T,
        class: "unsupported-preview-note text-2xl justify-center flex"
      }, pe(K(a)("shared.previewNotSupportedInBrowser")) + ": " + pe(T), 1))), 128)),
      kt("div", hyt, [
        (Mt(!0), Ot(Me, null, Xn(o.value, (T) => (Mt(), Ot("img", {
          key: T,
          src: K(r).getAssetUrl(`/img/${T}_file_icon.png`),
          alt: "icon",
          style: { width: "10vh", height: "10vh" },
          draggable: "false"
        }, null, 8, pyt))), 128))
      ])
    ], 64));
  }
});
var aJ = /* @__PURE__ */ ((i) => (i[i.eUNDERCUT = 0] = "eUNDERCUT", i[i.eVOLUME_THICKNESS = 1] = "eVOLUME_THICKNESS", i[i.eCONTACTS = 2] = "eCONTACTS", i[i.eSANDBOX_CARVE_DIRECTION = 3] = "eSANDBOX_CARVE_DIRECTION", i))(aJ || {});
const Cn = class Cn {
  static updateTitle(t) {
    Cn.title.set(t);
  }
  static resetActiveScalarBarMode() {
    Cn.setActiveScalarBarMode(
      2
      /* eCONTACTS */
    );
  }
  static setActiveScalarBarMode(t) {
    Cn.sScalarBarMode.set(t), Cn.scaleChangeEvent.notify(Cn.getActiveScalarBarScale());
  }
  static getActiveScalarBarMode() {
    return Cn.sScalarBarMode;
  }
  static getActiveScalarBarLUT() {
    return Cn.getScalarBarLUT(Cn.sScalarBarMode.get());
  }
  static getScalarBarLUT(t) {
    const e = [];
    let n = [1, 0, 1];
    const s = [1 / 255, 100 / 255, 204 / 255], r = Cn.getScalarBarScale(t), a = Cn.getScalarBarScale(t) / 5;
    if (t == 1)
      e.push([0 * a, [1 / 255, 100 / 255, 204 / 255]]), e.push([1 * a, [48 / 255, 198 / 255, 12 / 255]]), e.push([2 * a, [1, 1, 0]]), e.push([3 * a, [1, 0.5, 0]]), e.push([4 * a, [1, 0, 0]]), e.push([5 * a, [1, 0, 1]]);
    else if (t == 0 || t == 3)
      e.push([0 * a, [1 / 255, 100 / 255, 204 / 255]]), e.push([1 * a, [48 / 255, 198 / 255, 12 / 255]]), e.push([2 * a, [1, 1, 0]]), e.push([3 * a, [1, 0.5, 0]]), e.push([4 * a, [1, 0, 0]]), e.push([5 * a, [1, 0, 1]]);
    else {
      const o = r < 0.01 + Number.EPSILON;
      o ? (e.push([0, [1, 0, 1]]), e.push([r, [1, 0, 1]])) : (e.push([0 * a, [1 / 255, 100 / 255, 204 / 255]]), e.push([1 * a, [48 / 255, 198 / 255, 12 / 255]]), e.push([2 * a, [1, 1, 0]]), e.push([3 * a, [1, 0.5, 0]]), e.push([4 * a, [1, 0, 0]]), e.push([5 * a, [1, 0, 1]])), o || (n = s);
    }
    return { pLUT: e, aboveRangeColor: n, belowRangeColor: s };
  }
  static getScalarBarGradientHexColors(t, e) {
    const n = (r, a, o) => {
      const l = (c) => {
        const u = Math.round(c).toString(16);
        return u.length == 1 ? "0" + u : u;
      };
      return "#" + l(r) + l(a) + l(o);
    };
    let s = [];
    return t == 1 ? s = [n(1, 100, 204), n(48, 198, 12), n(255, 255, 0), n(255, 127, 0), n(255, 0, 0), n(255, 0, 255)] : t == 0 || t == 3 ? s = [n(1, 100, 204), n(48, 198, 12), n(255, 255, 0), n(255, 127, 0), n(255, 0, 0), n(255, 0, 255)] : Cn.getScalarBarScale(t) < 0.01 + Number.EPSILON ? s = [n(255, 0, 255), n(255, 0, 255), n(255, 0, 255), n(255, 0, 255), n(255, 0, 255), n(255, 0, 255)] : s = [n(1, 100, 204), n(48, 198, 12), n(255, 255, 0), n(255, 127, 0), n(255, 0, 0), n(255, 0, 255)], e && (s = s.reverse()), s;
  }
  static setActiveScalarBarScale(t) {
    const e = Cn.sScalarBarScale.get(Cn.sScalarBarMode.get());
    e && e != t && (Cn.sScalarBarScale.set(Cn.sScalarBarMode.get(), t), Cn.scaleChangeEvent.notify(e));
  }
  static getScalarBarScale(t) {
    const e = Cn.sScalarBarScale.get(t);
    return e || 0;
  }
  static getActiveScalarBarScale() {
    return Cn.getScalarBarScale(Cn.sScalarBarMode.get());
  }
};
S(Cn, "sScalarBarMode", new qt(
  2
  /* eCONTACTS */
)), S(Cn, "sReverseGradient", new qt(!1)), S(Cn, "sHint", new qt("D")), S(Cn, "sScalarBarScale", /* @__PURE__ */ new Map([
  [0, 1.5],
  [1, 1.5],
  [2, 1],
  [3, 3]
])), S(Cn, "title", new qt("Scalar Bar")), S(Cn, "headerButtonVisible", new qt(!0)), S(Cn, "headerButtonChecked", new qt(!0)), S(Cn, "contactsButtonVisible", new qt(!0)), S(Cn, "contactsButtonChecked", new qt(!0)), S(Cn, "modelContactsButtonVisible", new qt(!0)), S(Cn, "modelContactsButtonChecked", new qt(!1)), S(Cn, "gradientColors", new md(() => Cn.getScalarBarGradientHexColors(Cn.sScalarBarMode.get(), Cn.sReverseGradient.get()))), S(Cn, "scaleChangeEvent", new se());
let Kr = Cn;
const myt = { class: "flex flex-row flex-grow justify-end gap-2" }, byt = { class: "gradient-scale" }, fyt = { class: "ticks-class" }, gyt = /* @__PURE__ */ Ne({
  __name: "ScalarBarWidget",
  props: {
    viewSize: {},
    barSize: { default: () => new qt([220, 419]) },
    initialPosition: {},
    onWheelCallback: {},
    headerButtonClicked: {},
    contactsButtonClicked: {},
    modelContactsButtonClicked: {}
  },
  setup(i) {
    aa();
    const t = i, e = Le(Kr.title), n = Le(t.viewSize), s = Le(t.barSize), r = Le(Kr.gradientColors), a = Le(Kr.sHint), o = Le(Kr.headerButtonVisible), l = Le(Kr.headerButtonChecked), c = Le(Kr.contactsButtonVisible), u = Le(Kr.contactsButtonChecked), d = Le(Kr.modelContactsButtonVisible), h = Le(Kr.modelContactsButtonChecked), p = Lt(Kr.getActiveScalarBarScale());
    Kr.scaleChangeEvent.subscribe((g) => {
      console.log("Scale changed event", g), p.value = g;
    });
    const m = te(() => {
      const g = p.value / 5, f = [];
      for (let T = 0; T < 6; T++)
        f.push(T * g);
      return f;
    }), b = te(() => ({
      background: `linear-gradient(to right, ${r.value.join(", ")})`
    })), y = (g) => ({
      left: `calc(${g / p.value} * 100%)`
    }), Z = (g) => {
      const f = g.deltaY < 0 ? -1 : 1;
      let T = Kr.getActiveScalarBarScale();
      T < 0.1 + 1e-10 ? T += f * 0.01 : (T += f * 0.05, T = Math.max(T, 0.1));
      const M = Math.max(0.01, Math.min(10, T));
      Kr.setActiveScalarBarScale(M), t.onWheelCallback(g);
    };
    return (g, f) => (Mt(), le(QI, {
      collapsible: !1,
      defaultMargin: 10,
      minMargin: 10,
      viewSize: K(n),
      maxHeight: K(s)[1],
      width: K(s)[0],
      title: K(e),
      initialPosition: i.initialPosition
    }, p7({
      default: oe(() => [
        kt("div", byt, [
          kt("div", {
            class: "gradient-bar",
            onWheel: Z
          }, [
            kt("div", {
              class: "color-palette",
              style: xe(b.value)
            }, null, 4),
            kt("div", fyt, [
              (Mt(!0), Ot(Me, null, Xn(m.value, (T, M) => (Mt(), Ot("div", {
                key: M,
                class: "tick",
                style: xe(y(T))
              }, pe(T.toFixed(2)), 5))), 128))
            ])
          ], 32)
        ])
      ]),
      _: 2
    }, [
      i.contactsButtonClicked && i.modelContactsButtonClicked && i.headerButtonClicked ? {
        name: "headerButtons",
        fn: oe(() => [
          kt("div", myt, [
            K(d) ? (Mt(), le(K(ye), {
              key: 0,
              iconSrc: "/icons/IKD_32_05_a.png",
              style: { width: "35px", height: "35px", "border-radius": "8px" },
              "is-toolbar-button": !0,
              iconSrcWidth: "26px",
              iconSrcHeight: "26px",
              togglable: !0,
              toggled: K(h),
              tooltip: "Adjacent Contacts",
              onToggledChange: i.modelContactsButtonClicked
            }, null, 8, ["toggled", "onToggledChange"])) : Qt("", !0),
            K(c) ? (Mt(), le(K(ye), {
              key: 1,
              iconSrc: "/cad/computecontacts/ik_contact_detailed_C_128.png",
              style: { width: "35px", height: "35px", "border-radius": "8px" },
              "is-toolbar-button": !0,
              iconSrcWidth: "26px",
              iconSrcHeight: "26px",
              togglable: !0,
              toggled: K(u),
              tooltip: K(a),
              onToggledChange: i.contactsButtonClicked
            }, null, 8, ["toggled", "tooltip", "onToggledChange"])) : Qt("", !0),
            K(o) ? (Mt(), le(K(ye), {
              key: 2,
              iconSrc: "/icons/new_icons/ik_eye_28.svg",
              style: { width: "35px", height: "35px", "border-radius": "8px" },
              "is-toolbar-button": !0,
              togglable: !0,
              toggled: K(l),
              onToggledChange: i.headerButtonClicked
            }, null, 8, ["toggled", "onToggledChange"])) : Qt("", !0)
          ])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["viewSize", "maxHeight", "width", "title", "initialPosition"]));
  }
}), IDt = /* @__PURE__ */ Dn(gyt, [["__scopeId", "data-v-1339bd8b"]]), yyt = /* @__PURE__ */ Ne({
  __name: "DynamicButton",
  props: /* @__PURE__ */ rl({
    smallFont: { type: Boolean },
    context: {}
  }, {
    widgetParams: { required: !0 },
    widgetParamsModifiers: {}
  }),
  emits: ["update:widgetParams"],
  setup(i) {
    const t = zr(i, "widgetParams"), e = i, n = Lt(!1), s = Lt(!0), r = Lt(""), a = Lt(!1), o = Lt(!0), l = Lt(""), c = Lt(!1), u = Lt(!1), d = te(() => t.value ? `btn-${t.value.mName}` : void 0), h = te(() => {
      if (l.value)
        return l.value.replace("..", "./cadResources");
    });
    let p;
    const m = async () => {
      n.value || (p == null || p.freezeWizardPanel(!0), await new Promise((T, M) => {
        const N = (W) => {
          T(W);
        };
        t.value.onGuiValueChangedLambda.opcallAsync(1, N);
      }), p == null || p.freezeWizardPanel(!1)), n.value = !1;
    }, b = async () => {
      n.value = !0, s.value = await new Promise((f, T) => {
        const M = (N) => {
          f(N);
        };
        t.value.GetVisibilityLambda.opcallAsync(M);
      }), o.value = await new Promise((f, T) => {
        const M = (N) => {
          f(N);
        };
        t.value.GetEnabledLambda.opcallAsync(M);
      }), r.value = await new Promise((f, T) => {
        const M = (N) => {
          f(N);
        };
        t.value.GetLabelLambda.opcallAsync(M);
      }), a.value = await new Promise((f, T) => {
        const M = (N) => {
          f(!!N);
        };
        t.value.GetStateLambda.opcallAsync(M);
      }), console.log("DynamicButton Received value from All changed C++:", a.value), l.value = await new Promise((f, T) => {
        const M = (N) => {
          f(N);
        };
        t.value.GetPathLambda.opcallAsync(0, 0, M);
      }), c.value = await new Promise((f, T) => {
        const M = (N) => {
          f(N);
        };
        t.value.GetIconOnlyLambda.opcallAsync(M);
      }), u.value = await new Promise((f, T) => {
        const M = (N) => {
          f(N);
        };
        t.value.GetIsAIButtonLambda.opcallAsync(M);
      }), n.value = !1;
    };
    xn(async () => {
      try {
        p = e.context ? ge(e.context) : ge(cY());
      } catch (f) {
        console.log("DynamicButton onMounted error: ", f);
      }
      await b();
    });
    const y = async () => {
      const f = await new Promise((T, M) => {
        const N = (W) => {
          T(!!W);
        };
        t.value.GetStateLambda.opcallAsync(N);
      });
      console.log("DynamicButton Received value from C++:", f), a.value = f;
    };
    t.value.SetCadValueChangedCallback(y);
    const Z = async () => {
      s.value = await new Promise((f, T) => {
        const M = (N) => {
          f(N);
        };
        t.value.GetVisibilityLambda.opcallAsync(M);
      });
    };
    t.value.SetCadVisibilityChangedCallback(Z);
    const g = async () => {
      o.value = await new Promise((f, T) => {
        const M = (N) => {
          f(N);
        };
        t.value.GetEnabledLambda.opcallAsync(M);
      });
    };
    return t.value.SetCadEnableChangeddCallback(g), (f, T) => {
      var M;
      return s.value ? (Mt(), le(K(ye), {
        key: 0,
        class: "web-rg-wiz-btn",
        label: c.value ? "" : r.value,
        labelFont: i.smallFont ? "0.75rem" : "1rem",
        disabled: !o.value,
        toggled: a.value,
        togglable: !0,
        iconSrc: h.value,
        icon: u.value ? "pi pi-sparkles" : void 0,
        iconSrcHeight: c.value ? "28px" : "36px",
        iconSrcWidth: c.value ? "28px" : "36px",
        "is-toolbar-button": c.value,
        tooltip: c.value ? r.value : void 0,
        dynamicButton: !0,
        "data-cy": d.value,
        style: xe({
          justifyContent: (M = h.value) != null && M.length && !c.value ? "start" : void 0
        }),
        onClick: m
      }, null, 8, ["label", "labelFont", "disabled", "toggled", "iconSrc", "icon", "iconSrcHeight", "iconSrcWidth", "is-toolbar-button", "tooltip", "data-cy", "style"])) : Qt("", !0);
    };
  }
}), Zyt = {
  key: 0,
  style: { display: "flex", "flex-direction": "row" }
}, Tyt = /* @__PURE__ */ Ne({
  __name: "DynamicCollapsible",
  props: /* @__PURE__ */ rl({
    smallFont: { type: Boolean },
    context: {}
  }, {
    widgetParams: { required: !0 },
    widgetParamsModifiers: {}
  }),
  emits: ["update:widgetParams"],
  setup(i) {
    const t = zr(i, "widgetParams"), e = i, n = t.value.GetCollapsibleNestedWidgets(), s = t.value.GetCollapsibleNestedWidgetsOrder();
    console.log("nestedParamsOrger", s);
    const r = Lt(!1), a = Lt(!0), o = Lt(""), l = Lt(!1), c = Lt(!0), u = Lt(""), d = Lt(!1), h = te(() => t.value ? `collapsible-${t.value.mName}` : void 0), p = te(() => {
      if (u.value)
        return u.value.replace("..", "./cadResources");
    });
    let m;
    const b = async () => {
      const M = !l.value;
      r.value || (m == null || m.freezeWizardPanel(!0, !0), await new Promise((W) => {
        const x = (V) => {
          W(V);
        };
        t.value.onGuiValueChangedLambda.opcallAsync(M ? 1 : 0, x);
      }), m == null || m.freezeWizardPanel(!1)), r.value = !1;
    }, y = async () => {
      r.value = !0, a.value = await new Promise((M) => {
        const N = (W) => {
          M(W);
        };
        t.value.GetVisibilityLambda.opcallAsync(N);
      }), c.value = await new Promise((M) => {
        const N = (W) => {
          M(W);
        };
        t.value.GetEnabledLambda.opcallAsync(N);
      }), o.value = await new Promise((M) => {
        const N = (W) => {
          M(W);
        };
        t.value.GetLabelLambda.opcallAsync(N);
      }), l.value = await new Promise((M) => {
        const N = (W) => {
          M(!!W);
        };
        t.value.GetStateLambda.opcallAsync(N);
      }), u.value = await new Promise((M) => {
        const N = (W) => {
          M(W);
        };
        t.value.GetPathLambda.opcallAsync(0, 0, N);
      }), d.value = await new Promise((M) => {
        const N = (W) => {
          M(W);
        };
        t.value.GetIconOnlyLambda.opcallAsync(N);
      }), r.value = !1;
    };
    xn(async () => {
      try {
        m = e.context ? ge(e.context) : ge(cY());
      } catch (M) {
        console.log("DynamicButton onMounted error: ", M);
      }
      await y();
    });
    const Z = async () => {
      const M = await new Promise((N) => {
        const W = (x) => {
          N(!!x);
        };
        t.value.GetStateLambda.opcallAsync(W);
      });
      l.value = M;
    };
    t.value.SetCadValueChangedCallback(Z);
    const g = async () => {
      a.value = await new Promise((M) => {
        const N = (W) => {
          M(W);
        };
        t.value.GetVisibilityLambda.opcallAsync(N);
      });
    };
    t.value.SetCadVisibilityChangedCallback(g);
    const f = async () => {
      c.value = await new Promise((M) => {
        const N = (W) => {
          M(W);
        };
        t.value.GetEnabledLambda.opcallAsync(N);
      });
    };
    t.value.SetCadEnableChangeddCallback(f);
    const T = async () => {
      u.value = await new Promise((M) => {
        const N = (W) => {
          M(W);
        };
        t.value.GetPathLambda.opcallAsync(0, 0, N);
      }), d.value = await new Promise((M) => {
        const N = (W) => {
          M(W);
        };
        t.value.GetIconOnlyLambda.opcallAsync(N);
      }), o.value = await new Promise((M) => {
        const N = (W) => {
          M(W);
        };
        t.value.GetLabelLambda.opcallAsync(N);
      });
    };
    return t.value.SetCadAllChangeddCallback(T), (M, N) => {
      var W;
      return a.value ? (Mt(), Ot("div", Zyt, [
        a.value ? (Mt(), le(K(ye), {
          key: 0,
          class: "web-rg-wiz-btn",
          style: xe([{ width: "100%" }, {
            justifyContent: (W = p.value) != null && W.length && !d.value ? "start" : void 0
          }]),
          label: d.value ? "" : o.value,
          labelFont: e.smallFont ? "0.75rem" : "1rem",
          disabled: !c.value,
          toggled: l.value,
          togglable: !0,
          iconSrc: p.value,
          iconSrcHeight: d.value ? "28px" : "36px",
          iconSrcWidth: d.value ? "28px" : "36px",
          "is-toolbar-button": d.value,
          tooltip: d.value ? o.value : void 0,
          dynamicButton: !0,
          "data-cy": h.value,
          onClick: b
        }, null, 8, ["label", "labelFont", "disabled", "toggled", "iconSrc", "iconSrcHeight", "iconSrcWidth", "is-toolbar-button", "tooltip", "style", "data-cy"])) : Qt("", !0),
        as(kt("div", null, [
          Pt(K(w2), {
            style: { padding: "8px" },
            toolTitle: "",
            widgetParams: K(n),
            widgetOrder: K(s),
            context: e.context
          }, null, 8, ["widgetParams", "widgetOrder", "context"])
        ], 512), [
          [Ss, l.value]
        ])
      ])) : Qt("", !0);
    };
  }
}), Myt = /* @__PURE__ */ Ne({
  __name: "DynamicCombobox",
  props: /* @__PURE__ */ rl({
    smallFont: { type: Boolean }
  }, {
    widgetParams: { required: !0 },
    widgetParamsModifiers: {}
  }),
  emits: ["update:widgetParams"],
  setup(i) {
    const t = zr(i, "widgetParams"), e = Lt(!1), n = Lt(!0), s = Lt(""), r = Lt(!0), a = Lt(), o = Lt([]), l = te(() => t.value ? `combobox-${t.value.mName}` : void 0), c = async () => {
      if (!e.value && a.value != null) {
        const y = a.value.id, Z = o.value.findIndex((f) => f.id === y);
        await new Promise((f, T) => {
          const M = (N) => {
            f(N);
          };
          t.value.onGuiValueChangedLambda.opcallAsync(Z, M);
        });
      }
      e.value = !1;
    }, u = async () => {
      const y = [], Z = await new Promise((g, f) => {
        const T = (M) => {
          g(M);
        };
        t.value.GetItemLabelsLambda.opcallAsync(T);
      });
      if (Z.size()) {
        const g = await new Promise((f, T) => {
          const M = (N) => {
            f(N);
          };
          t.value.GetItemsLambda.opcallAsync(M);
        });
        for (let f = 0; f < Z.size(); f++)
          y.push({ name: Z.get(f), id: g.get(f) });
      }
      o.value = y;
    }, d = async () => {
      e.value = !0, n.value = await new Promise((Z, g) => {
        const f = (T) => {
          Z(T);
        };
        t.value.GetVisibilityLambda.opcallAsync(f);
      }), r.value = await new Promise((Z, g) => {
        const f = (T) => {
          Z(T);
        };
        t.value.GetEnabledLambda.opcallAsync(f);
      }), s.value = await new Promise((Z, g) => {
        const f = (T) => {
          Z(T);
        };
        t.value.GetLabelLambda.opcallAsync(f);
      }), await u();
      const y = await new Promise((Z, g) => {
        const f = (T) => {
          Z(T);
        };
        t.value.GetSelectedLambda.opcallAsync(f);
      });
      y > -1 && y < o.value.length && (a.value = o.value[y]), e.value = !1;
    };
    xn(async () => {
      await d();
    });
    const h = async () => {
      const y = await new Promise((Z, g) => {
        const f = (T) => {
          Z(T);
        };
        t.value.GetSelectedLambda.opcallAsync(f);
      });
      console.log("Received selected value from C++:", y), y > -1 && y < o.value.length && (a.value = o.value[y]);
    };
    t.value.SetCadValueChangedCallback(h);
    const p = async () => {
      n.value = await new Promise((y, Z) => {
        const g = (f) => {
          y(f);
        };
        t.value.GetVisibilityLambda.opcallAsync(g);
      });
    };
    t.value.SetCadVisibilityChangedCallback(p);
    const m = async () => {
      r.value = await new Promise((y, Z) => {
        const g = (f) => {
          y(f);
        };
        t.value.GetEnabledLambda.opcallAsync(g);
      });
    };
    t.value.SetCadEnableChangeddCallback(m);
    const b = async () => {
      await d();
    };
    return t.value.SetCadAllChangeddCallback(b), (y, Z) => n.value ? (Mt(), le(K(Te), {
      key: 0,
      class: "flex-col"
    }, {
      default: oe(() => [
        s.value.length ? (Mt(), le(K(Te), {
          key: 0,
          style: { "align-items": "center" }
        }, {
          default: oe(() => [
            kt("span", {
              class: Rn({
                "text-sm": i.smallFont,
                "text-base": !i.smallFont
              }),
              style: { "user-select": "none" }
            }, pe(s.value), 3)
          ]),
          _: 1
        })) : Qt("", !0),
        Pt(K(Te), {
          class: "mt-1",
          style: { "align-items": "center" }
        }, {
          default: oe(() => [
            Pt(K(Ku), {
              modelValue: a.value,
              "onUpdate:modelValue": Z[0] || (Z[0] = (g) => a.value = g),
              onChange: c,
              options: o.value,
              disabled: !r.value,
              class: "w-full",
              optionLabel: "name",
              placeholder: "None",
              showClear: !1,
              "data-cy": l.value
            }, null, 8, ["modelValue", "options", "disabled", "data-cy"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })) : Qt("", !0);
  }
}), Nyt = /* @__PURE__ */ Ne({
  __name: "DynamicGUIComponent",
  props: /* @__PURE__ */ rl({
    activeWidget: {},
    freeFormer: { type: Boolean },
    smallFont: { type: Boolean },
    context: {},
    retrieveActiveWidgetOnMount: { type: Boolean, default: !0 }
  }, {
    toolTitle: { required: !0 },
    toolTitleModifiers: {},
    widgetParams: { required: !1 },
    widgetParamsModifiers: {},
    widgetOrder: { required: !0 },
    widgetOrderModifiers: {}
  }),
  emits: ["update:toolTitle", "update:widgetParams", "update:widgetOrder"],
  setup(i) {
    const t = zr(i, "toolTitle"), e = zr(i, "widgetParams"), n = zr(i, "widgetOrder"), s = i, r = Lt(Math.random());
    let a = Lt([]);
    const o = () => {
      a.value = [];
      let m = [], b = -1;
      const y = n.value.slice();
      let Z = 0;
      for (let g of y) {
        let f = 1, T = g;
        g >= 100 && (f = Math.trunc(Number(g) / 100), T = Number(g) % 100), (b !== T || T == -1) && m.length && (a.value.push(m), m = []), m.push([Z, f]), b = T, Z++;
      }
      if (a.value.push(m), m = [], e.value)
        for (let g = 0; g < e.value.size(); g++)
          e.value.get(g);
      r.value = Math.random();
    }, l = Lt(!0);
    let c, u = !1, d = 0;
    xn(async () => {
      u = !0;
      const m = ++d;
      if (!(!s.freeFormer && (c = s.context ? ge(s.context) : ge(cY()), await new Promise((y) => {
        const Z = () => {
          if (!u || m !== d) {
            y();
            return;
          }
          const g = c.getContextCAD().GetMainForm();
          !g || !g.GetDisableGUIRetrieve() ? (console.log("GUI retrieve is now enabled"), y()) : (console.log("Waiting for GUI retrieve to be enabled..."), setTimeout(Z, 200));
        };
        Z();
      }), !u || m !== d)))
        if (s.activeWidget) {
          const b = ge(s.activeWidget), y = (g) => {
            !u || m !== d || (n.value = g.GetWidgetOrder().slice(), e.value = g.GetWidgets(), t.value = g.GetToolTitle(), o());
          };
          console.log("000000 DynamicGUIComponent setting OnGUIRetrieve lambda 1..."), b.SetOnGUIRetrieve(y), console.log("000000 DynamicGUIComponent setting OnGUIRetrieve lambda 2"), !s.freeFormer && s.retrieveActiveWidgetOnMount ? (b.RetrieveGUI(), console.log("000000 DynamicGUIComponent setting OnGUIRetrieve lambda 3:")) : s.retrieveActiveWidgetOnMount || y(b);
          const Z = async () => {
            const g = await new Promise((f, T) => {
              const M = (N) => {
                f(N);
              };
              b.GetVisibilityLambda.opcallAsync(M);
            });
            !u || m !== d || (l.value = g);
          };
          b.SetCadVisibilityChangedCallback(Z);
        } else
          o();
    }), yr(() => {
      u = !1, d++;
    });
    const h = (m) => {
      switch ((m == null ? void 0 : m.mType).value) {
        case Zr.eTWT_SLIDER:
          return Iyt;
        case Zr.eTWT_SWITHCHER:
          return Cyt;
        case Zr.eTWT_LABEL:
          return Syt;
        case Zr.eTWT_BUTTON:
          return yyt;
        case Zr.eTWT_COMBOBOX:
          return Myt;
        case Zr.eTWT_LINE:
          return Xyt;
        case Zr.eTWT_IMAGE:
          return xyt;
        case Zr.eTWT_ACTIVE_TOOL:
          return w2;
        case Zr.eTWT_TEETH_VIEW:
          return Uyt;
        case Zr.eTWT_COLLAPSIBLE:
          return Tyt;
        case Zr.eTWT_LINE_EDIT:
          return Jyt;
        default:
          return null;
      }
    }, p = (m) => {
      const b = m == null ? void 0 : m.mType.value;
      return b === void 0 || ![Zr.eTWT_BUTTON, Zr.eTWT_COLLAPSIBLE, Zr.eTWT_ACTIVE_TOOL].includes(b) || !s.context ? {} : { context: ge(s.context) };
    };
    return (m, b) => e.value && l.value ? (Mt(), le(K(Te), {
      class: "flex-col w-full",
      key: r.value
    }, {
      default: oe(() => [
        t.value && !i.activeWidget ? (Mt(), le(K(Te), {
          key: 0,
          class: "flex-row gap-2 tool-label-class"
        }, {
          default: oe(() => [
            kt("div", null, pe(t.value), 1)
          ]),
          _: 1
        })) : Qt("", !0),
        (Mt(!0), Ot(Me, null, Xn(K(a), (y, Z) => (Mt(), Ot(Me, { key: Z }, [
          y.length ? (Mt(), le(K(Te), {
            key: 0,
            class: Rn(["flex-row gap-2 align-items-center"])
          }, {
            default: oe(() => [
              (Mt(!0), Ot(Me, null, Xn(y, (g, f) => (Mt(), Ot(Me, { key: f }, [
                e.value.get(g[0]) && e.value.get(g[0]).mType.value != 7 ? (Mt(), le(m7(h(e.value.get(g[0]))), HM({
                  key: 0,
                  class: "flex w-full mt-2",
                  "widget-params": e.value.get(g[0]),
                  style: {
                    flexDirection: [K(Zr).eTWT_COLLAPSIBLE, K(Zr).eTWT_COMBOBOX].includes(e.value.get(g[0]).mType.value) ? "column" : "row",
                    flexGrow: g[1],
                    flexShrink: 1,
                    flexBasis: 0
                  }
                }, { ref_for: !0 }, p(e.value.get(g[0])), { smallFont: i.smallFont }), null, 16, ["widget-params", "style", "smallFont"])) : e.value.get(g[0]) && e.value.get(g[0]).mType.value == 7 ? (Mt(), le(K(w2), {
                  key: 1,
                  style: { "background-color": "#9999990a" },
                  activeWidget: e.value.get(g[0]),
                  toolTitle: "",
                  "widget-order": [],
                  context: s.context,
                  "retrieve-active-widget-on-mount": s.retrieveActiveWidgetOnMount
                }, null, 8, ["activeWidget", "context", "retrieve-active-widget-on-mount"])) : Qt("", !0)
              ], 64))), 128))
            ]),
            _: 2
          }, 1024)) : Qt("", !0)
        ], 64))), 128))
      ]),
      _: 1
    })) : Qt("", !0);
  }
}), w2 = /* @__PURE__ */ Dn(Nyt, [["__scopeId", "data-v-a7dff039"]]), Wyt = {
  key: 0,
  class: "img-class"
}, Gyt = ["src"], wyt = /* @__PURE__ */ Ne({
  __name: "DynamicImage",
  props: {
    widgetParams: { required: !0 },
    widgetParamsModifiers: {}
  },
  emits: ["update:widgetParams"],
  setup(i) {
    x0((p) => ({
      v6573fdc4: c.value,
      v279d4091: u.value
    }));
    const t = zr(i, "widgetParams"), e = Lt(!0), n = Lt(-1), s = Lt(""), r = async () => {
      s.value = await new Promise((p, m) => {
        const b = (y) => {
          p(y);
        };
        t.value.GetPathLambda.opcallAsync(200, 170, b);
      });
    }, a = async () => {
      e.value = await new Promise((p, m) => {
        const b = (y) => {
          p(y);
        };
        t.value.GetVisibilityLambda.opcallAsync(b);
      }), console.log("Pre DynamicImage Alignemnt", n.value);
      try {
        n.value = await new Promise((p, m) => {
          const b = (y) => {
            p(y);
          };
          t.value.GetAlignmentLambda.opcallAsync(b);
        });
      } catch (p) {
        console.warn("Error getting alignment:", p), n.value = 132;
      }
      console.log("Alignment image", n.value), await r();
    };
    xn(async () => {
      await a();
    });
    const o = jl(), l = te(() => {
      if (s.value) {
        if (s.value.startsWith("data:image/"))
          return s.value;
        const p = s.value.replace("..", "./cadResources");
        return o.getAssetUrl(`${p}`);
      }
    }), c = te(() => {
      let p = "";
      switch (n.value) {
        case 20:
          p = "start";
          break;
        case 40:
          p = "end";
          break;
        case 80:
          p = "center";
          break;
        case 100:
          p = "baseline";
          break;
      }
      return p;
    }), u = te(() => {
      let p = "";
      switch (n.value) {
        case 1:
          p = "start";
          break;
        case 2:
          p = "end";
          break;
        case 4:
          p = "center";
          break;
      }
      return p;
    }), d = async () => {
      await r();
    };
    t.value.SetCadValueChangedCallback(d);
    const h = async () => {
      e.value = await new Promise((p, m) => {
        const b = (y) => {
          p(y);
        };
        t.value.GetVisibilityLambda.opcallAsync(b);
      });
    };
    return t.value.SetCadVisibilityChangedCallback(h), (p, m) => e.value ? (Mt(), Ot("div", Wyt, [
      kt("img", {
        alt: "icon",
        src: l.value,
        draggable: "false",
        style: { "max-width": "100%", "max-height": "100%", width: "auto", height: "auto", "object-fit": "cover" }
      }, null, 8, Gyt)
    ])) : Qt("", !0);
  }
}), xyt = /* @__PURE__ */ Dn(wyt, [["__scopeId", "data-v-404e7f53"]]), Syt = /* @__PURE__ */ Ne({
  __name: "DynamicLabel",
  props: /* @__PURE__ */ rl({
    smallFont: { type: Boolean }
  }, {
    widgetParams: { required: !0 },
    widgetParamsModifiers: {}
  }),
  emits: ["update:widgetParams"],
  setup(i) {
    const t = zr(i, "widgetParams"), e = Lt(!0), n = Lt(!1), s = Lt(""), r = Lt(!1), a = Lt(!1), o = Lt(0), l = async () => {
      e.value = await new Promise((Z, g) => {
        const f = (T) => {
          Z(T);
        };
        t.value.GetVisibilityLambda.opcallAsync(f);
      }), n.value = await new Promise((Z, g) => {
        const f = (T) => {
          Z(T);
        };
        t.value.GetEnabledLambda.opcallAsync(f);
      }), a.value = await new Promise((Z, g) => {
        const f = (T) => {
          Z(T);
        };
        t.value.GetBottomBorderLambda.opcallAsync(f);
      }), r.value = await new Promise((Z, g) => {
        const f = (T) => {
          Z(T);
        };
        t.value.GetTitleLambda.opcallAsync(f);
      }), s.value = await new Promise((Z, g) => {
        const f = (T) => {
          Z(T);
        };
        t.value.GetLabelLambda.opcallAsync(f);
      }), o.value = await new Promise((Z, g) => {
        const f = (T) => {
          Z(T);
        };
        t.value.GetAlignmentLambda.opcallAsync(f);
      }), console.log("Alignment", o.value);
    };
    xn(async () => {
      await l();
    });
    const c = te(() => a.value ? "1px solid var(--webcad-primary-text-color)" : ""), u = te(() => n.value ? "1" : "0.5"), d = te(() => r.value ? "1.5rem" : "0.8rem"), h = te(() => {
      switch (o.value) {
        case 0:
          return "left";
        case 1:
          return "right";
        case 2:
          return "center";
        case 3:
          return "justify";
        default:
          return r.value ? "left" : "center";
      }
    }), p = te(() => r.value ? "1rem" : "0"), m = async () => {
      s.value = await new Promise((Z) => {
        const g = (f) => {
          Z(f);
        };
        t.value.GetLabelLambda.opcallAsync(g);
      });
    };
    t.value.SetCadValueChangedCallback(m);
    const b = async () => {
      e.value = await new Promise((Z, g) => {
        const f = (T) => {
          Z(T);
        };
        t.value.GetVisibilityLambda.opcallAsync(f);
      });
    };
    t.value.SetCadVisibilityChangedCallback(b);
    const y = async () => {
      n.value = await new Promise((Z, g) => {
        const f = (T) => {
          Z(T);
        };
        t.value.GetEnabledLambda.opcallAsync(f);
      });
    };
    return t.value.SetCadEnableChangeddCallback(y), (Z, g) => e.value ? (Mt(), Ot("div", {
      key: 0,
      style: xe({
        width: "100%",
        color: "var(--webcad-primary-text-color)",
        borderBottom: c.value,
        opacity: u.value,
        fontSize: d.value,
        padding: p.value,
        textAlign: h.value,
        whiteSpace: "pre-wrap"
      })
    }, [
      kt("span", {
        class: Rn({
          "text-sm": i.smallFont,
          "text-base": !i.smallFont
        }),
        style: { "user-select": "none" }
      }, pe(s.value), 3)
    ], 4)) : Qt("", !0);
  }
}), Lyt = {
  key: 0,
  class: "line-class"
}, Vyt = /* @__PURE__ */ Ne({
  __name: "DynamicLine",
  props: {
    widgetParams: { required: !0 },
    widgetParamsModifiers: {}
  },
  emits: ["update:widgetParams"],
  setup(i) {
    x0((h) => ({
      v62847208: c.value,
      d942b328: o.value,
      v58334074: l.value
    }));
    const t = zr(i, "widgetParams"), e = Lt(!0), n = Lt(!1), s = Lt(!1), r = Lt(0), a = async () => {
      e.value = await new Promise((h, p) => {
        const m = (b) => {
          h(b);
        };
        t.value.GetVisibilityLambda.opcallAsync(m);
      }), n.value = await new Promise((h, p) => {
        const m = (b) => {
          h(b);
        };
        t.value.GetEnabledLambda.opcallAsync(m);
      }), s.value = await new Promise((h, p) => {
        const m = (b) => {
          h(b);
        };
        t.value.GetBottomBorderLambda.opcallAsync(m);
      }), r.value = await new Promise((h, p) => {
        const m = (b) => {
          h(b);
        };
        t.value.GetHeightLambda.opcallAsync(m);
      });
    };
    xn(async () => {
      await a();
    });
    const o = te(() => s.value ? "1px solid var(--webcad-primary-text-color)" : ""), l = te(() => n.value ? "1" : "0.5"), c = te(() => r.value + "px"), u = async () => {
      e.value = await new Promise((h, p) => {
        const m = (b) => {
          h(b);
        };
        t.value.GetVisibilityLambda.opcallAsync(m);
      });
    };
    t.value.SetCadVisibilityChangedCallback(u);
    const d = async () => {
      n.value = await new Promise((h, p) => {
        const m = (b) => {
          h(b);
        };
        t.value.GetEnabledLambda.opcallAsync(m);
      });
    };
    return t.value.SetCadEnableChangeddCallback(d), (h, p) => e.value ? (Mt(), Ot("div", Lyt)) : Qt("", !0);
  }
}), Xyt = /* @__PURE__ */ Dn(Vyt, [["__scopeId", "data-v-fdf70b90"]]), CDt = /* @__PURE__ */ Ne({
  __name: "DynamicPrevNext",
  props: {
    tabHandler: {},
    context: {}
  },
  emits: ["nextStepNested", "previousStepNested"],
  setup(i, { emit: t }) {
    const e = An(), n = i, s = t, r = Lt(!n.tabHandler.tabButtonsEnabled.get()), a = Lt(n.tabHandler.nextText.get()), o = Lt(n.tabHandler.prevText.get()), l = Lt("Close"), c = Lt(n.tabHandler.prevVis.get()), u = Lt(n.tabHandler.nextVis.get()), d = Lt(n.tabHandler.closeVis.get()), h = Lt(n.tabHandler.prevEnabled.get()), p = Lt(n.tabHandler.nextEnabled.get()), m = Lt(n.context.loadingFlag.get());
    n.context && n.context.tabButtonsEnabled.set(n.tabHandler.tabButtonsEnabled.get());
    const b = Lt(!1), y = Lt([]), Z = Lt(!1);
    let g = null;
    const f = async (V) => {
      b.value = !1, y.value = [], g && (g(V.label), g = null);
    };
    n.tabHandler.SetProceedWithCallback(async (V) => {
      n.context.freezeWizardPanel(!1);
      const X = [];
      for (const z of V)
        X.push({
          label: z,
          value: z
        });
      return y.value = X, b.value = !0, await new Promise((z) => {
        g = z;
      });
    });
    const T = () => {
      g && (y.value = [], g && (g(null), g = null));
    };
    e.watch(n.tabHandler.nextText, (V) => {
      a.value = V;
    }), e.watch(n.tabHandler.prevText, (V) => {
      o.value = V;
    }), e.watch(n.tabHandler.nextVis, (V) => {
      u.value = V;
    }), e.watch(n.tabHandler.prevVis, (V) => {
      c.value = V;
    }), e.watch(n.tabHandler.closeVis, (V) => {
      d.value = V;
    }), e.watch(n.tabHandler.nextEnabled, (V) => {
      p.value = V;
    }), e.watch(n.tabHandler.prevEnabled, (V) => {
      h.value = V;
    }), e.watch(n.tabHandler.tabButtonsEnabled, (V) => {
      r.value = !V, n.context && n.context.tabButtonsEnabled.set(V);
    }), e.watch(n.context.loadingFlag, (V) => {
      m.value = V;
    });
    const M = async (V) => {
      if (!(!n.context || Z.value)) {
        Z.value = !0, n.context.freezeWizardPanel(!0);
        try {
          await V();
        } finally {
          n.context.freezeWizardPanel(!1), Z.value = !1;
        }
      }
    }, N = async () => {
      m.value || Z.value || !h.value || (n.context && !n.tabHandler.tabButtonsEnabled.get() ? await M(() => {
        var V;
        return (V = n.context.contextCAD.GetMainForm()) == null ? void 0 : V.PrevClickedAsync();
      }) : s("previousStepNested"));
    }, W = async () => {
      m.value || Z.value || !p.value || (n.context && !n.tabHandler.tabButtonsEnabled.get() ? await M(() => {
        var V;
        return (V = n.context.contextCAD.GetMainForm()) == null ? void 0 : V.NextClickedAsync();
      }) : s("nextStepNested"));
    }, x = async () => {
      m.value || Z.value || n.context && await M(() => {
        var V;
        return (V = n.context.contextCAD.GetMainForm()) == null ? void 0 : V.CloseClickedAsync();
      });
    };
    return (V, X) => r.value ? (Mt(), le(K(hg), {
      key: 0,
      class: "gap-2 mb-2",
      style: { "margin-top": "auto" }
    }, {
      default: oe(() => [
        c.value ? (Mt(), le(K(ye), {
          key: 0,
          id: "btnPreviousStep",
          iconSrc: "/icons/rg_chevron_left.svg",
          "icon-src-height": "21px",
          "icon-src-width": "21px",
          class: "web-rg-icon-btn",
          style: { flex: "1 1 0" },
          label: o.value,
          enabled: h.value && !m.value && !Z.value,
          onClick: N
        }, null, 8, ["label", "enabled"])) : Qt("", !0),
        u.value ? (Mt(), le(K(ye), {
          key: 1,
          id: "btnNextStep",
          iconSrc: "/icons/rg_chevron_right.svg",
          iconRight: !0,
          "icon-src-height": "21px",
          "icon-src-width": "21px",
          class: "web-rg-icon-btn",
          style: { flex: "1 1 0", overflow: "visible" },
          label: a.value,
          enabled: p.value && !m.value && !Z.value,
          dropdown: y.value.length > 0,
          dropdownLocationTopLeft: !0,
          dropdownState: b.value,
          dynamicDropdown: !0,
          onClick: W,
          onClosedByClickOutside: T
        }, {
          default: oe(() => [
            (Mt(!0), Ot(Me, null, Xn(y.value, (C, R) => (Mt(), le(K(ye), {
              key: R,
              class: "web-rg-icon-btn menu-item w-full",
              onClick: (z) => f(C),
              label: C.label.toString(),
              style: { "border-radius": "4px !important" }
            }, null, 8, ["onClick", "label"]))), 128))
          ]),
          _: 1
        }, 8, ["label", "enabled", "dropdown", "dropdownState"])) : Qt("", !0),
        d.value ? (Mt(), le(K(ye), {
          key: 2,
          class: "web-rg-icon-btn",
          style: { flex: "1 1 0" },
          label: l.value,
          enabled: !m.value && !Z.value,
          onClick: x
        }, null, 8, ["label", "enabled"])) : Qt("", !0)
      ]),
      _: 1
    })) : Qt("", !0);
  }
}), Iyt = /* @__PURE__ */ Ne({
  __name: "DynamicSlider",
  props: /* @__PURE__ */ rl({
    smallFont: { type: Boolean }
  }, {
    widgetParams: { required: !0 },
    widgetParamsModifiers: {}
  }),
  emits: ["update:widgetParams"],
  setup(i) {
    const t = zr(i, "widgetParams"), e = Lt(!1), n = Lt(!0), s = Lt(""), r = Lt(""), a = Lt(0), o = Lt(0), l = Lt(5), c = Lt(0.01), u = Lt(!0), d = Lt(!1), h = te(() => t.value ? `slider-${t.value.mName}` : void 0);
    let p = Lt(0);
    function m(M) {
      return parseFloat(M.toFixed(p.value));
    }
    const b = async () => {
      if (!e.value && a.value != null) {
        const M = parseFloat(a.value.toFixed(p.value));
        await new Promise((W, x) => {
          const V = (X) => {
            W(X);
          };
          t.value.onGuiValueChangedLambda.opcallAsync(M, V);
        }), console.log("Slidervalue changed", a.value);
      }
      e.value = !1;
    }, y = async () => {
      e.value = !0, n.value = await new Promise((x, V) => {
        const X = (C) => {
          x(C);
        };
        t.value.GetVisibilityLambda.opcallAsync(X);
      }), u.value = await new Promise((x, V) => {
        const X = (C) => {
          x(C);
        };
        t.value.GetEnabledLambda.opcallAsync(X);
      }), s.value = await new Promise((x, V) => {
        const X = (C) => {
          x(C);
        };
        t.value.GetLabelLambda.opcallAsync(X);
      }), r.value = await new Promise((x, V) => {
        const X = (C) => {
          x(C);
        };
        t.value.GetUnitLabelLambda.opcallAsync(X);
      }), o.value = await new Promise((x, V) => {
        const X = (C) => {
          x(C);
        };
        t.value.GetMinLambda.opcallAsync(X);
      }), l.value = await new Promise((x, V) => {
        const X = (C) => {
          x(C);
        };
        t.value.GetMaxLambda.opcallAsync(X);
      });
      const M = await new Promise((x, V) => {
        const X = (C) => {
          x(C);
        };
        t.value.GetStepLambda.opcallAsync(X);
      }), N = Ha(M);
      p.value = Bi(N), c.value = Ha(M);
      const W = await new Promise((x, V) => {
        const X = (C) => {
          x(C);
        };
        t.value.GetValueLambda.opcallAsync(X);
      });
      a.value = m(W), d.value = await new Promise((x, V) => {
        const X = (C) => {
          x(C);
        };
        t.value.GetDoubleRowLayoutLambda.opcallAsync(X);
      }), e.value = !1;
    };
    xn(async () => {
      await y();
    });
    const Z = async () => {
      const M = await new Promise((N, W) => {
        const x = (V) => {
          N(V);
        };
        t.value.GetValueLambda.opcallAsync(x);
      });
      e.value = !0, a.value = m(M);
    };
    t.value.SetCadValueChangedCallback(Z);
    const g = async () => {
      n.value = await new Promise((M, N) => {
        const W = (x) => {
          M(x);
        };
        t.value.GetVisibilityLambda.opcallAsync(W);
      });
    };
    t.value.SetCadVisibilityChangedCallback(g);
    const f = async () => {
      u.value = await new Promise((M, N) => {
        const W = (x) => {
          M(x);
        };
        t.value.GetEnabledLambda.opcallAsync(W);
      });
    };
    t.value.SetCadEnableChangeddCallback(f);
    const T = async () => {
      await y();
    };
    return t.value.SetCadAllChangeddCallback(T), (M, N) => n.value ? (Mt(), le(K(Te), {
      key: 0,
      class: Rn({
        "flex-row": !d.value,
        "flex-col": d.value,
        "w-full": !0
      })
    }, {
      default: oe(() => [
        Pt(K(Te), {
          class: "no-padding",
          style: { "align-items": "center", flex: "1 1 0" }
        }, {
          default: oe(() => [
            kt("span", {
              class: Rn({
                "text-sm": i.smallFont,
                "text-base": !i.smallFont
              }),
              style: { "user-select": "none" }
            }, pe(s.value), 3)
          ]),
          _: 1
        }),
        Pt(K(Te), {
          class: "gap-2 no-padding",
          style: { flex: "2 1 0" }
        }, {
          default: oe(() => [
            Pt(K(Te), {
              class: Rn({
                "justify-end": !d.value,
                "ml-1": d.value,
                "w-full": !0
              }),
              style: { "align-items": "center" }
            }, {
              default: oe(() => [
                Pt(K(zo), {
                  class: "no-padding",
                  onChange: b,
                  modelValue: a.value,
                  "onUpdate:modelValue": N[0] || (N[0] = (W) => a.value = W),
                  min: o.value,
                  max: l.value,
                  step: c.value,
                  disabled: !u.value,
                  showButtons: !1,
                  fractionDigits: K(p),
                  smallFont: i.smallFont,
                  "unit-label": r.value,
                  scrollable: !0,
                  "data-cy": h.value
                }, null, 8, ["modelValue", "min", "max", "step", "disabled", "fractionDigits", "smallFont", "unit-label", "data-cy"])
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"])) : Qt("", !0);
  }
}), Cyt = /* @__PURE__ */ Ne({
  __name: "DynamicSwitcher",
  props: /* @__PURE__ */ rl({
    smallFont: { type: Boolean }
  }, {
    widgetParams: { required: !0 },
    widgetParamsModifiers: {}
  }),
  emits: ["update:widgetParams"],
  setup(i) {
    const t = zr(i, "widgetParams"), e = i, n = Lt(!1), s = Lt(!0), r = Lt(""), a = Lt(!1), o = Lt(!0), l = te(() => t.value ? `switch-${t.value.mName}` : void 0), c = async () => {
      if (!n.value && a.value != null) {
        const m = a.value;
        await new Promise((y) => {
          const Z = (g) => {
            y(g);
          };
          t.value.onGuiValueChangedLambda.opcallAsync(m ? 1 : 0, Z);
        }), console.log("switcherState changed", a.value);
      }
      n.value = !1;
    }, u = async () => {
      n.value = !0, a.value = await new Promise((m) => {
        const b = (y) => {
          m(!!y);
        };
        t.value.GetStateLambda.opcallAsync(b);
      }), s.value = await new Promise((m) => {
        const b = (y) => {
          m(y);
        };
        t.value.GetVisibilityLambda.opcallAsync(b);
      }), o.value = await new Promise((m) => {
        const b = (y) => {
          m(y);
        };
        t.value.GetEnabledLambda.opcallAsync(b);
      }), r.value = await new Promise((m) => {
        const b = (y) => {
          m(y);
        };
        t.value.GetLabelLambda.opcallAsync(b);
      }), n.value = !1;
    };
    xn(async () => {
      await u();
    });
    const d = async () => {
      const m = await new Promise((b) => {
        const y = (Z) => {
          b(!!Z);
        };
        t.value.GetStateLambda.opcallAsync(y);
      });
      console.log("Received state from C++:", m), a.value = m;
    };
    t.value.SetCadValueChangedCallback(d);
    const h = async () => {
      s.value = await new Promise((m) => {
        const b = (y) => {
          m(y);
        };
        t.value.GetVisibilityLambda.opcallAsync(b);
      });
    };
    t.value.SetCadVisibilityChangedCallback(h);
    const p = async () => {
      o.value = await new Promise((m) => {
        const b = (y) => {
          m(y);
        };
        t.value.GetEnabledLambda.opcallAsync(b);
      });
    };
    return t.value.SetCadEnableChangeddCallback(p), (m, b) => s.value ? (Mt(), le(K(Te), {
      key: 0,
      class: "flex-row"
    }, {
      default: oe(() => [
        Pt(K(Te), {
          class: "",
          style: { "align-items": "center" }
        }, {
          default: oe(() => [
            Pt(K(W7), {
              state: a.value,
              "onUpdate:state": b[0] || (b[0] = (y) => a.value = y),
              onChange: c,
              disabled: !o.value,
              "data-cy": l.value
            }, null, 8, ["state", "disabled", "data-cy"])
          ]),
          _: 1
        }),
        Pt(K(Te), {
          class: "ml-4",
          style: { "align-items": "center" }
        }, {
          default: oe(() => [
            kt("span", {
              class: Rn({
                "text-sm": e.smallFont,
                "text-base": !e.smallFont
              }),
              style: { "user-select": "none" }
            }, pe(r.value), 3)
          ]),
          _: 1
        })
      ]),
      _: 1
    })) : Qt("", !0);
  }
}), ai = [...Array(16).keys()].map((i) => i + 1);
var $e = /* @__PURE__ */ ((i) => (i[i.MAXILLA = 0] = "MAXILLA", i[i.MANDIBLE = 1] = "MANDIBLE", i))($e || {}), _e = /* @__PURE__ */ ((i) => (i[i.EMPTY = 0] = "EMPTY", i[i.OK = 1] = "OK", i[i.OK_SELECTED = 2] = "OK_SELECTED", i[i.COLLISION = 3] = "COLLISION", i[i.COLLISION_SELECTED = 4] = "COLLISION_SELECTED", i[i.ADDING_IN_PROGRESS = 5] = "ADDING_IN_PROGRESS", i[i.TEETH_MARKER = 6] = "TEETH_MARKER", i[i.TEETH_MARKER_SELECTED = 7] = "TEETH_MARKER_SELECTED", i[i.REFERENCESEG_TEMP = 8] = "REFERENCESEG_TEMP", i[i.REFERENCESEG_TEMP_SELECTED = 9] = "REFERENCESEG_TEMP_SELECTED", i[i.CROWN_SEGMENTATION = 10] = "CROWN_SEGMENTATION", i[i.CROWN_SEGMENTATION_SELECTED = 11] = "CROWN_SEGMENTATION_SELECTED", i[i.WARNING = 12] = "WARNING", i[i.WARNING_SELECTED = 13] = "WARNING_SELECTED", i[i.INLAY_ONLAY = 14] = "INLAY_ONLAY", i[i.INLAY_ONLAY_SELECTED = 15] = "INLAY_ONLAY_SELECTED", i[i.CEMENTED = 16] = "CEMENTED", i[i.CEMENTED_SELECTED = 17] = "CEMENTED_SELECTED", i[i.CEMENTED_COPING = 18] = "CEMENTED_COPING", i[i.CEMENTED_COPING_SELECTED = 19] = "CEMENTED_COPING_SELECTED", i[i.PONTIC = 20] = "PONTIC", i[i.PONTIC_SELECTED = 21] = "PONTIC_SELECTED", i[i.SCANNED_TI_BASE_OCCLUSAL_SCREW = 22] = "SCANNED_TI_BASE_OCCLUSAL_SCREW", i[i.SCANNED_TI_BASE_OCCLUSAL_SCREW_SELECTED = 23] = "SCANNED_TI_BASE_OCCLUSAL_SCREW_SELECTED", i[i.SCANNED_TI_BASE_ABUTMENT = 24] = "SCANNED_TI_BASE_ABUTMENT", i[i.SCANNED_TI_BASE_ABUTMENT_SELECTED = 25] = "SCANNED_TI_BASE_ABUTMENT_SELECTED", i[i.IMPLANT_SCAN_BODY_OCCLUSAL_SCREW = 26] = "IMPLANT_SCAN_BODY_OCCLUSAL_SCREW", i[i.IMPLANT_SCAN_BODY_OCCLUSAL_SCREW_SELECTED = 27] = "IMPLANT_SCAN_BODY_OCCLUSAL_SCREW_SELECTED", i[i.IMPLANT_SCAN_BODY_ABUTMENT = 28] = "IMPLANT_SCAN_BODY_ABUTMENT", i[i.IMPLANT_SCAN_BODY_ABUTMENT_SELECTED = 29] = "IMPLANT_SCAN_BODY_ABUTMENT_SELECTED", i[i.STOCK_LIBRARY_CROWN = 30] = "STOCK_LIBRARY_CROWN", i[i.STOCK_LIBRARY_CROWN_SELECTED = 31] = "STOCK_LIBRARY_CROWN_SELECTED", i[i.STOCK_LIBRARY_ABUTMENT = 32] = "STOCK_LIBRARY_ABUTMENT", i[i.STOCK_LIBRARY_ABUTMENT_SELECTED = 33] = "STOCK_LIBRARY_ABUTMENT_SELECTED", i))(_e || {}), x2 = /* @__PURE__ */ ((i) => (i[i.ADD = 0] = "ADD", i[i.ADD_REMOVE = 1] = "ADD_REMOVE", i[i.SELECT_ONLY = 2] = "SELECT_ONLY", i[i.NO_EDIT = 3] = "NO_EDIT", i[i.TEETH_WIZARD = 4] = "TEETH_WIZARD", i))(x2 || {}), Yr = /* @__PURE__ */ ((i) => (i[i.NONE = 0] = "NONE", i[i.ADD = 1] = "ADD", i[i.REMOVE = 2] = "REMOVE", i))(Yr || {});
const ET = ["18", "17", "16", "15", "14", "13", "12", "11", "21", "22", "23", "24", "25", "26", "27", "28"], kT = ["48", "47", "46", "45", "44", "43", "42", "41", "31", "32", "33", "34", "35", "36", "37", "38"], FT = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16"], jT = ["32", "31", "30", "29", "28", "27", "26", "25", "24", "23", "22", "21", "20", "19", "18", "17"];
function gd(i) {
  return i ? jT : kT;
}
function yd(i) {
  return i ? FT : ET;
}
function Yyt(i, t) {
  return i === $e.MANDIBLE ? gd(t) : yd(t);
}
function YDt(i, t, e) {
  return Yyt(i, e)[t - 1];
}
function vyt(i, t, e) {
  const n = yd(t).indexOf(i);
  if ((e === void 0 || e === $e.MAXILLA) && n >= 0)
    return n + 1;
  const s = gd(t).indexOf(i);
  if ((e === void 0 || e === $e.MANDIBLE) && s >= 0)
    return s + 1;
}
function oJ(i, t, e) {
  return vyt(i, t, e) !== void 0;
}
function vDt(i, t) {
  return yd(t).filter((s) => i.indexOf(s) < 0);
}
function RDt(i, t) {
  return gd(t).filter((s) => i.indexOf(s) < 0);
}
function DDt(i) {
  const t = FT.indexOf(i);
  if (t >= 0)
    return ET[t];
  const e = jT.indexOf(i);
  if (e >= 0)
    return kT[e];
  throw new Error(`Invalid US tooth name: ${i}`);
}
function ODt(i) {
  const t = ET.indexOf(i);
  if (t >= 0)
    return FT[t];
  const e = kT.indexOf(i);
  if (e >= 0)
    return jT[e];
  throw new Error(`Invalid tooth name: ${i}`);
}
function Ryt(i) {
  const t = FT.indexOf(i);
  if (t >= 0)
    return ET[t];
  const e = jT.indexOf(i);
  if (e >= 0)
    return kT[e];
}
function Dyt(i) {
  const t = ET.indexOf(i);
  if (t >= 0)
    return FT[t];
  const e = kT.indexOf(i);
  if (e >= 0)
    return jT[e];
}
function rS(i, t, e) {
  return t === e ? i : (t ? Ryt(i) : Dyt(i)) ?? i;
}
function lJ() {
  return [
    {
      id: _e.INLAY_ONLAY,
      label: Kl("medic-web-framework.inlayOnlay"),
      background: "#8C185F"
    },
    {
      id: _e.CEMENTED,
      label: Kl("medic-web-framework.cemented"),
      background: "#D2FFA2"
    },
    {
      id: _e.CEMENTED_COPING,
      label: Kl("medic-web-framework.cementedCoping"),
      background: "#8D4A32"
    },
    {
      id: _e.PONTIC,
      label: Kl("medic-web-framework.pontic"),
      background: "#97C5E7"
    },
    {
      id: _e.SCANNED_TI_BASE_OCCLUSAL_SCREW,
      label: Kl("medic-web-framework.scannedTiBaseOcclusalScrew"),
      background: "#f9d499"
    },
    {
      id: _e.SCANNED_TI_BASE_ABUTMENT,
      label: Kl("medic-web-framework.scannedTiBaseAbutment"),
      background: "#323362"
    },
    {
      id: _e.IMPLANT_SCAN_BODY_OCCLUSAL_SCREW,
      label: Kl("medic-web-framework.implantScanBodyOcclusalScrew"),
      background: "#04535c"
    },
    {
      id: _e.IMPLANT_SCAN_BODY_ABUTMENT,
      label: Kl("medic-web-framework.implantScanBodyAbutment"),
      background: "#ee6b3b"
    },
    {
      id: _e.STOCK_LIBRARY_CROWN,
      label: Kl("medic-web-framework.stockLibraryCrown"),
      background: "#23b14b"
    },
    {
      id: _e.STOCK_LIBRARY_ABUTMENT,
      label: Kl("medic-web-framework.stockLibraryAbutment"),
      background: "#f3b0d8"
    }
  ];
}
function cJ() {
  return {
    [_e.EMPTY]: [255, 255, 255, 1],
    [_e.OK]: [210, 255, 162, 200],
    [_e.OK_SELECTED]: [111, 215, 0, 200],
    [_e.COLLISION]: [199, 2, 2, 80],
    [_e.COLLISION_SELECTED]: [199, 2, 2, 200],
    [_e.ADDING_IN_PROGRESS]: [207, 18, 203, 200],
    [_e.TEETH_MARKER]: [0, 128, 255, 80],
    [_e.TEETH_MARKER_SELECTED]: [0, 128, 255, 200],
    [_e.REFERENCESEG_TEMP]: [0, 128, 255, 80],
    [_e.REFERENCESEG_TEMP_SELECTED]: [0, 128, 255, 200],
    [_e.WARNING]: [255, 255, 0, 120],
    [_e.WARNING_SELECTED]: [255, 255, 0, 200],
    // defaults
    [_e.CROWN_SEGMENTATION]: [0, 0, 0, 255],
    [_e.CROWN_SEGMENTATION_SELECTED]: [0, 0, 0, 255],
    // reconstruction types
    [_e.INLAY_ONLAY]: [140, 24, 95, 200],
    [_e.INLAY_ONLAY_SELECTED]: [140, 24, 95, 240],
    [_e.CEMENTED]: [210, 255, 162, 200],
    [_e.CEMENTED_SELECTED]: [210, 255, 162, 240],
    [_e.CEMENTED_COPING]: [141, 74, 50, 200],
    [_e.CEMENTED_COPING_SELECTED]: [141, 74, 50, 240],
    [_e.PONTIC]: [151, 197, 231, 200],
    [_e.PONTIC_SELECTED]: [151, 197, 231, 240],
    [_e.SCANNED_TI_BASE_OCCLUSAL_SCREW]: [249, 212, 153, 200],
    [_e.SCANNED_TI_BASE_OCCLUSAL_SCREW_SELECTED]: [249, 212, 153, 240],
    [_e.SCANNED_TI_BASE_ABUTMENT]: [50, 51, 98, 200],
    [_e.SCANNED_TI_BASE_ABUTMENT_SELECTED]: [50, 51, 98, 240],
    [_e.IMPLANT_SCAN_BODY_OCCLUSAL_SCREW]: [4, 83, 92, 200],
    [_e.IMPLANT_SCAN_BODY_OCCLUSAL_SCREW_SELECTED]: [4, 83, 92, 240],
    [_e.IMPLANT_SCAN_BODY_ABUTMENT]: [238, 107, 59, 200],
    [_e.IMPLANT_SCAN_BODY_ABUTMENT_SELECTED]: [238, 107, 59, 240],
    [_e.STOCK_LIBRARY_CROWN]: [35, 177, 75, 200],
    [_e.STOCK_LIBRARY_CROWN_SELECTED]: [35, 177, 75, 240],
    [_e.STOCK_LIBRARY_ABUTMENT]: [243, 176, 216, 200],
    [_e.STOCK_LIBRARY_ABUTMENT_SELECTED]: [243, 176, 216, 240]
  };
}
function ZC() {
  return {
    1: ["teeth/18_m.png", [7, 158], [-23, 179]],
    2: ["teeth/17_m.png", [12, 128], [-18, 146]],
    3: ["teeth/16_m.png", [18, 95], [-10, 112]],
    4: ["teeth/15_m.png", [31, 72], [1, 78]],
    5: ["teeth/14_m.png", [42, 51], [17, 56]],
    6: ["teeth/13_m.png", [57, 28], [35, 33]],
    7: ["teeth/12_m.png", [74, 14], [61, 13]],
    8: ["teeth/11_m.png", [95, 6], [96, 0]],
    9: ["teeth/21_m.png", [124, 6], [129, 0]],
    10: ["teeth/22_m.png", [149, 14], [160, 10]],
    11: ["teeth/23_m.png", [160, 28], [187, 30]],
    12: ["teeth/24_m.png", [171, 51], [208, 58]],
    13: ["teeth/25_m.png", [181, 72], [220, 80]],
    14: ["teeth/26_m.png", [185, 95], [232, 107]],
    15: ["teeth/27_m.png", [195, 128], [242, 141]],
    16: ["teeth/28_m.png", [206, 158], [246, 174]]
  };
}
function TC() {
  return {
    1: ["teeth/48_m.png", [10, 13], [-16, 21]],
    2: ["teeth/47_m.png", [17, 43], [-11, 56]],
    3: ["teeth/46_m.png", [25, 74], [0, 97]],
    4: ["teeth/45_m.png", [43, 108], [16, 129]],
    5: ["teeth/44_m.png", [54, 130], [33, 152]],
    6: ["teeth/43_m.png", [70, 152], [52, 176]],
    7: ["teeth/42_m.png", [86, 164], [76, 190]],
    8: ["teeth/41_m.png", [105, 170], [101, 194]],
    9: ["teeth/31_m.png", [124, 170], [126, 194]],
    10: ["teeth/32_m.png", [141, 164], [152, 189]],
    11: ["teeth/33_m.png", [152, 152], [174, 176]],
    12: ["teeth/34_m.png", [164, 130], [193, 153]],
    13: ["teeth/35_m.png", [175, 108], [206, 129]],
    14: ["teeth/36_m.png", [184, 74], [222, 102]],
    15: ["teeth/37_m.png", [197, 43], [234, 59]],
    16: ["teeth/38_m.png", [204, 13], [242, 22]]
  };
}
function uJ() {
  return {
    //mColorLUT[0] = xColor(1.0f, 1.0f, 1.0f);
    1: [128, 0, 0, 200],
    2: [153, 153, 0, 200],
    3: [54, 89, 217, 200],
    4: [201, 115, 255, 200],
    5: [41, 166, 57, 200],
    6: [245, 130, 49, 200],
    7: [145, 30, 180, 200],
    8: [23, 193, 230, 200],
    9: [191, 239, 69, 200],
    10: [240, 50, 230, 200],
    11: [42, 140, 130, 200],
    12: [255, 224, 13, 200],
    13: [190, 0, 95, 200],
    14: [46, 230, 100, 200],
    15: [153, 90, 18, 200],
    16: [0, 0, 128, 200]
  };
}
function dJ() {
  return {
    // the opaque values were retrieved by halving the saturation value (S) in HSV (gimps color picker)
    //mColorOpaqueLUT[0] = xColor(128.0f, 128.0f, 128.0f);
    1: [255, 185, 175, 200],
    2: [235, 255, 154, 200],
    3: [194, 212, 255, 200],
    4: [255, 224, 255, 200],
    5: [177, 255, 184, 200],
    6: [255, 228, 185, 200],
    7: [255, 204, 255, 200],
    8: [186, 255, 255, 200],
    9: [231, 255, 176, 200],
    10: [255, 208, 255, 200],
    11: [164, 241, 232, 200],
    12: [255, 255, 169, 200],
    13: [255, 192, 229, 200],
    14: [187, 255, 213, 200],
    15: [255, 224, 175, 200],
    16: [201, 199, 247, 200]
  };
}
const Oyt = { style: { "font-size": "x-small", "font-weight": "bold", color: "red", "white-space": "pre-wrap", "text-shadow": "1px 1px 5px rgba(0, 0, 0, 1)" } }, zyt = ["src"], Eyt = ["src"], kyt = /* @__PURE__ */ Ne({
  __name: "MDynamicTeethView",
  props: {
    jawboneType: {},
    teeth: {},
    useUSStyleToothChart: { type: Boolean },
    modelValue: {},
    warningString: {},
    showLines: { type: Boolean }
  },
  emits: ["toothClick", "toothClickRight", "toothMouseOver", "toothMouseOut", "update:modelValue"],
  setup(i, { emit: t }) {
    const e = ZC(), n = TC(), s = i, r = Lt(0), a = t, { jawboneType: o, useUSStyleToothChart: l } = Vo(s), c = te(() => s.teeth), u = te(() => o.value === $e.MAXILLA ? 18 : 0), d = Lt(null), h = document.createElement("canvas"), p = jl(), m = te(() => {
      let Tt = "flex justify-content-center";
      return s.showLines && (Tt += " line-in-middle"), s.showLines && s.jawboneType === $e.MANDIBLE && (Tt += " horizontal-line"), Tt;
    }), b = te(() => {
      let Tt = "relative";
      return s.showLines && s.jawboneType === $e.MANDIBLE && (Tt += " mandible-mt"), Tt;
    }), y = new Image(), Z = {};
    let g = !1;
    const f = new Image(), T = {};
    let M = !1;
    const N = te(() => o.value === $e.MAXILLA ? y : f), W = te(() => o.value === $e.MAXILLA ? e : n), x = te(() => o.value === $e.MAXILLA ? Z : T), V = (Tt) => !!Tt && Tt.complete && Tt.naturalWidth > 0 && Tt.naturalHeight > 0, X = () => o.value === $e.MAXILLA ? g : M, C = () => V(N.value) && ai.every((Tt) => V(x.value[Tt])), R = (Tt) => {
      let Q = 1 + ai.length;
      const D = () => {
        Q--, Q === 0 && (Tt(), g = !0);
      };
      y.onload = () => D(), y.src = p.getAssetUrl("/resources/teeth/maxilla.png"), ai.forEach((q) => {
        const [nt] = e[q], et = new Image();
        et.onload = () => D();
        const ot = `/resources/${nt}`;
        et.src = p.getAssetUrl(ot), Z[q] = et;
      });
    }, z = (Tt) => {
      let Q = 1 + ai.length;
      const D = () => {
        Q--, Q === 0 && (Tt(), M = !0);
      };
      f.onload = () => D(), f.src = p.getAssetUrl("/resources/teeth/mandible.png"), ai.forEach((q) => {
        const [nt] = n[q], et = new Image();
        et.onload = () => D();
        const ot = `/resources/${nt}`;
        et.src = p.getAssetUrl(ot), T[q] = et;
      });
    }, F = (Tt) => {
      for (const Q of c.value)
        if (Q.id === Tt.id)
          return r.value === Tt.id ? Q.hoverColor : Q.color;
      return [255, 255, 255, 1];
    }, P = (Tt, Q, D, q, nt, et) => {
      Q.save(), Q.clearRect(0, 0, Tt.width, Tt.height), Q.drawImage(D, nt, et), Q.fillStyle = q, Q.globalCompositeOperation = "source-in", Q.fillRect(0, 0, Tt.width, Tt.height), Q.restore();
    }, j = () => {
      const Tt = N.value;
      if (!d.value || !C())
        return;
      const Q = d.value.getContext("2d");
      if (!Q)
        return;
      d.value.width = Tt.naturalWidth, d.value.height = Tt.naturalHeight, h.width = d.value.width, h.height = d.value.height;
      const D = h.getContext("2d");
      D && (Q.clearRect(0, 0, d.value.width, d.value.height), Q.drawImage(Tt, 0, 0), c.value.forEach((q) => {
        const [, nt] = W.value[q.id], [et, ot, it, ht] = F(q), lt = `rgba(${et}, ${ot}, ${it}, ${ht / 255})`, mt = x.value[q.id];
        P(h, D, mt, lt, nt[0], nt[1]), Q.drawImage(h, 0, 0);
      }));
    }, H = Oh(Object.fromEntries(ai.map((Tt) => [Tt, Lt("")]))), B = () => {
      for (const Tt of ai)
        H[Tt] = "";
      c.value.forEach((Tt) => {
        const [Q, D, q] = F(Tt), nt = `rgb(${Q}, ${D}, ${q}) !important`;
        H[Tt.id] = nt;
      });
    };
    B();
    const $ = te(() => o.value === $e.MAXILLA ? Object.fromEntries(yd(l.value).map((Tt, Q) => [ai[Q], Tt])) : Object.fromEntries(gd(l.value).map((Tt, Q) => [ai[Q], Tt]))), A = new Uint8Array(49600), E = (Tt, Q) => A[Tt + Q * 248], ct = () => {
      if (!d.value || !C() || d.value.width <= 0 || d.value.height <= 0)
        return;
      const Tt = document.createElement("canvas");
      Tt.width = d.value.width, Tt.height = d.value.height;
      const Q = Tt.getContext("2d");
      if (!Q)
        return;
      const D = h.getContext("2d");
      if (!D)
        return;
      for (const nt of ai) {
        const et = x.value[nt], [, ot] = W.value[nt], it = `rgb(${nt}, 0, 0)`;
        P(h, D, et, it, ot[0], ot[1]), Q.drawImage(h, 0, 0);
      }
      const q = Q.getImageData(0, 0, Tt.width, Tt.height).data;
      for (let nt = 0; nt < q.length / 4; nt++)
        A[nt] = q[nt * 4];
    }, at = (Tt) => {
      const Q = E(Tt.offsetX, Tt.offsetY);
      Q !== 0 && a("toothClick", Q, Tt, s.jawboneType);
    }, dt = (Tt) => {
      const Q = E(Tt.offsetX, Tt.offsetY);
      Q !== r.value && (r.value !== 0 && a("toothMouseOut", r.value, Tt, s.jawboneType), Q !== 0 && a("toothMouseOver", Q, Tt, s.jawboneType), a("update:modelValue", Q), r.value = Q);
    }, gt = (Tt) => {
      Tt.preventDefault();
      const Q = E(Tt.offsetX, Tt.offsetY);
      Q !== 0 && a("toothClickRight", Q, Tt, s.jawboneType);
    };
    xn(() => {
      R(() => {
        o.value === $e.MAXILLA && (j(), ct());
      }), z(() => {
        o.value === $e.MANDIBLE && (j(), ct());
      });
    }), gn(
      () => s.teeth,
      () => {
        X() && j(), B();
      },
      {
        deep: !0,
        immediate: !0
      }
    ), gn(o, () => {
      C() && (j(), ct());
    });
    const Wt = (Tt) => {
      const [, , Q] = W.value[Tt];
      return {
        left: Q[0] + 5 + "px",
        top: Q[1] + 2 + "px"
      };
    }, Zt = (Tt) => {
      const Q = x.value[Tt], [, D] = W.value[Tt];
      let q = 0, nt = 0;
      return Q != null && Q.complete && (q = Q.width / 2 - 14, nt = Q.height / 2 - 14), {
        left: D[0] + q + "px",
        top: D[1] + nt + u.value + "px"
      };
    }, Gt = () => o.value === $e.MAXILLA ? { top: "50%" } : { top: "10%" };
    return (Tt, Q) => (Mt(), Ot("div", {
      class: Rn(m.value),
      style: { height: "214px", "user-select": "none", "justify-content": "center" }
    }, [
      kt("div", {
        style: xe({
          paddingTop: u.value + "px"
        }),
        class: Rn(b.value)
      }, [
        kt("canvas", {
          id: "canvas",
          ref_key: "canvas",
          ref: d,
          class: Rn([{ "cursor-pointer": r.value !== 0 }, "all-radius-8"]),
          onClick: at,
          onMousemove: dt,
          onContextmenu: gt
        }, null, 34),
        (Mt(!0), Ot(Me, null, Xn(c.value, (D) => (Mt(), Ot("div", {
          key: D.id,
          style: xe([[
            {
              color: H[D.id]
            },
            Wt(D.id)
          ], { "font-size": "12px", "font-weight": "bold", "text-shadow": "1px 1px 5px rgba(0, 0, 0, 1)" }]),
          class: "absolute pointer-events-none shadow-sm c-color-primary"
        }, pe($.value[D.id]), 5))), 128)),
        kt("div", {
          class: "absolute w-6 h-6 flex justify-content-center",
          style: xe([Gt(), { "text-align": "center", left: "25%" }])
        }, [
          kt("span", Oyt, pe(i.warningString), 1)
        ], 4),
        (Mt(!0), Ot(Me, null, Xn(c.value, (D) => (Mt(), Ot(Me, {
          key: D.id
        }, [
          r.value == D.id ? (Mt(), Ot(Me, { key: 0 }, [
            D.hoverIconType === K(Yr).ADD ? (Mt(), Ot("img", {
              key: 0,
              style: xe([Zt(D.id), { width: "28px", height: "28px" }]),
              class: "absolute rounded-full pointer-events-none",
              src: K(p).getAssetUrl("/resources/teeth/AddPin.png"),
              draggable: "false"
            }, null, 12, zyt)) : D.hoverIconType === K(Yr).REMOVE ? (Mt(), Ot("img", {
              key: 1,
              style: xe([Zt(D.id), { width: "28px", height: "28px" }]),
              class: "absolute rounded-full pointer-events-none",
              src: K(p).getAssetUrl("/resources/teeth/RemovePin.png"),
              draggable: "false"
            }, null, 12, Eyt)) : Qt("", !0)
          ], 64)) : Qt("", !0)
        ], 64))), 128))
      ], 6)
    ], 2));
  }
}), Fyt = /* @__PURE__ */ Dn(kyt, [["__scopeId", "data-v-2e5f5569"]]), jyt = "", Uyt = /* @__PURE__ */ Ne({
  __name: "DynamicTeethView",
  props: {
    widgetParams: { required: !0 },
    widgetParamsModifiers: {}
  },
  emits: ["update:widgetParams"],
  setup(i) {
    const t = zr(i, "widgetParams"), e = Oh([]), n = Lt(!0);
    let s = $e.MAXILLA;
    const r = () => {
      var g, f;
      const Z = localStorage.getItem("viewerSettings");
      if (!Z)
        return !1;
      try {
        return !!((f = (g = JSON.parse(Z)) == null ? void 0 : g.general) != null && f.useUSStyleToothChart);
      } catch {
        return !1;
      }
    }, a = Lt(r()), o = async () => {
      n.value = await new Promise((Z, g) => {
        const f = (T) => {
          Z(T);
        };
        t.value.GetVisibilityLambda.opcallAsync(f);
      });
    }, l = (Z, g) => Z === $e.MAXILLA ? g <= 8 ? 1 : 2 : Z === $e.MANDIBLE ? g <= 8 ? 4 : 3 : -1, c = (Z, g) => g <= 8 ? 9 - g : g - 8, u = (Z) => {
      let g = 0;
      return Z.shiftKey && (g |= 2), Z.ctrlKey && (g |= 4), Z.altKey && (g |= 8), Z.metaKey && (g |= 16), g;
    }, d = (Z, g, f) => {
      const T = g.button;
      let M;
      if (T === 0)
        M = 0;
      else if (T === 2)
        M = 1;
      else
        return;
      const N = l(f, Z), W = c(f, Z), x = u(g);
      new Promise((V, X) => {
        const C = () => {
          V();
        };
        t.value.onGuiToothEventLambda.opcallAsync(M, N, W, x, C);
      });
    }, h = (Z, g, f) => {
      const M = l(f, Z), N = c(f, Z), W = u(g);
      new Promise((x, V) => {
        const X = () => {
          x();
        };
        t.value.onGuiToothEventLambda.opcallAsync(2, M, N, W, X);
      });
    }, p = (Z, g, f) => {
      const M = l(f, Z), N = c(f, Z), W = u(g);
      new Promise((x, V) => {
        const X = () => {
          x();
        };
        t.value.onGuiToothEventLambda.opcallAsync(3, M, N, W, X);
      });
    }, m = () => {
      const Z = (g) => {
        const f = (M) => M === -1 ? Yr.NONE : M === 0 ? Yr.ADD : M === 1 ? Yr.REMOVE : Yr.NONE, T = [];
        for (let M = 0; M < g.size(); M++) {
          const N = g.get(M);
          if (s == $e.MAXILLA && N.id >= 16 || s == $e.MANDIBLE && N.id <= 15)
            continue;
          let W = -1;
          M < 8 ? W = 8 - M : M < 16 ? W = M + 1 : M < 24 ? W = M - 8 + 1 : M < 32 && (W = 32 - M), T.map((x) => x.hoverIconType), T.push({
            id: W,
            color: N.color,
            hoverColor: N.hoverColor,
            iconType: f(N.iconType),
            hoverIconType: f(N.hoverIconType)
          });
        }
        Object.assign(e, T);
      };
      t.value.GetTeethViewRenderInfoLambda.opcallAsync(Z);
    }, b = () => {
      m();
    };
    xn(async () => {
      a.value = r(), s = await new Promise((Z, g) => {
        const f = (T) => {
          Z(T);
        };
        t.value.GetJawboneTypeLambda.opcallAsync(f);
      }), m(), await o();
    }), t.value.SetTeethViewUpdateCallback(b);
    const y = async () => {
      await o();
    };
    return t.value.SetCadVisibilityChangedCallback(y), (Z, g) => n.value && e.length ? (Mt(), le(Fyt, {
      key: 0,
      jawboneType: K(s),
      teeth: e,
      useUSStyleToothChart: a.value,
      warningString: jyt,
      onToothClick: d,
      onToothClickRight: d,
      onToothMouseOut: p,
      onToothMouseOver: h
    }, null, 8, ["jawboneType", "teeth", "useUSStyleToothChart"])) : Qt("", !0);
  }
}), Pyt = {
  key: 0,
  style: { display: "flex", flex: "1 1 0", "align-items": "center" }
}, Jyt = /* @__PURE__ */ Ne({
  __name: "DynamicLineEdit",
  props: {
    widgetParams: { required: !0 },
    widgetParamsModifiers: {}
  },
  emits: ["update:widgetParams"],
  setup(i) {
    const t = zr(i, "widgetParams"), e = Lt(!1), n = Lt(!0), s = Lt(""), r = Lt(""), a = Lt(!0), o = async () => {
      e.value || await new Promise((p, m) => {
        const b = (y) => {
          p(y);
        };
        t.value.onGuiInputTextChangedLambda.opcallAsync(r.value, b);
      }), e.value = !1;
    };
    gn(r, () => {
      o();
    });
    const l = async () => {
      e.value = !0, n.value = await new Promise((h, p) => {
        const m = (b) => {
          h(b);
        };
        t.value.GetVisibilityLambda.opcallAsync(m);
      }), a.value = await new Promise((h, p) => {
        const m = (b) => {
          h(b);
        };
        t.value.GetEnabledLambda.opcallAsync(m);
      }), s.value = await new Promise((h, p) => {
        const m = (b) => {
          h(b);
        };
        t.value.GetLabelLambda.opcallAsync(m);
      }), r.value = await new Promise((h, p) => {
        const m = (b) => {
          h(b);
        };
        t.value.GetInputTextLambda.opcallAsync(m);
      }), e.value = !1;
    };
    xn(async () => {
      await l();
    });
    const c = async () => {
      const h = await new Promise((p, m) => {
        const b = (y) => {
          p(y);
        };
        t.value.GetInputTextLambda.opcallAsync(b);
      });
      console.log("DynamicInputText Received value from C++:", h), r.value = h;
    };
    t.value.SetCadValueChangedCallback(c);
    const u = async () => {
      n.value = await new Promise((h, p) => {
        const m = (b) => {
          h(b);
        };
        t.value.GetVisibilityLambda.opcallAsync(m);
      });
    };
    t.value.SetCadVisibilityChangedCallback(u);
    const d = async () => {
      a.value = await new Promise((h, p) => {
        const m = (b) => {
          h(b);
        };
        t.value.GetEnabledLambda.opcallAsync(m);
      });
    };
    return t.value.SetCadEnableChangeddCallback(d), (h, p) => {
      const m = tr("InputText");
      return Mt(), le(K(Te), { class: "flex-row gap-2" }, {
        default: oe(() => [
          s.value ? (Mt(), Ot("span", Pyt, pe(s.value), 1)) : Qt("", !0),
          n.value ? (Mt(), le(m, {
            key: 1,
            modelValue: r.value,
            "onUpdate:modelValue": p[0] || (p[0] = (b) => r.value = b),
            placeholder: "",
            disabled: !a.value,
            style: { display: "flex", flex: "2 1 0" }
          }, null, 8, ["modelValue", "disabled"])) : Qt("", !0)
        ]),
        _: 1
      });
    };
  }
}), ez = (i) => new Promise((t) => window.setTimeout(t, i)), Ayt = () => new Promise((i) => window.requestAnimationFrame(() => i()));
async function zDt({
  mainForm: i,
  widgetsOrder: t,
  getRootToolWidget: e,
  isActive: n = () => !0,
  attempts: s = 3,
  delayMs: r = 50
}) {
  var a, o, l, c, u;
  await dg(), await Ayt();
  for (let d = 0; d < 20 && n() && ((a = i.GetDisableGUIRetrieve) != null && a.call(i)); d++)
    await ez(25);
  for (let d = 0; d < s && n() && t.value.length === 0; d++)
    (o = i.GetDisableGUIRetrieve) != null && o.call(i) || ((l = i.RetrieveCurrentWizardGUI) == null || l.call(i), (u = (c = e == null ? void 0 : e()) == null ? void 0 : c.RetrieveGUI) == null || u.call(c)), await ez(r), await dg();
}
var Zr = /* @__PURE__ */ ((i) => (i[i.eTWT_SLIDER = 0] = "eTWT_SLIDER", i[i.eTWT_SWITHCHER = 1] = "eTWT_SWITHCHER", i[i.eTWT_LABEL = 2] = "eTWT_LABEL", i[i.eTWT_LINE = 3] = "eTWT_LINE", i[i.eTWT_COMBOBOX = 4] = "eTWT_COMBOBOX", i[i.eTWT_BUTTON = 5] = "eTWT_BUTTON", i[i.eTWT_IMAGE = 6] = "eTWT_IMAGE", i[i.eTWT_ACTIVE_TOOL = 7] = "eTWT_ACTIVE_TOOL", i[i.eTWT_TEETH_VIEW = 8] = "eTWT_TEETH_VIEW", i[i.eTWT_COLLAPSIBLE = 9] = "eTWT_COLLAPSIBLE", i[i.eTWT_LINE_EDIT = 10] = "eTWT_LINE_EDIT", i))(Zr || {});
function IW(i, t) {
  i.getActiveCamera().setParallelProjection(!0), i.setUseDepthPeeling(!0), i.setMaximumNumberOfPeels(200), i.setOcclusionRatio(0.1), i.setLayer(t), t > 1 && (i.setInteractive(!1), i.setErase(!0));
}
function Byt(i) {
  i.setNumberOfLayers(3);
}
class Kyt {
  constructor() {
    S(this, "mapper", Ue.newInstance());
    S(this, "data", Ie.newInstance());
    S(this, "actor", Re.newInstance());
    S(this, "points", yi.newInstance());
    S(this, "lines", Ii.newInstance());
    this.mapper.setInputData(this.data), this.actor.setMapper(this.mapper), this.data.setPoints(this.points), this.data.setLines(this.lines), this.actor.setVisibility(!0), this.actor.setPickable(!1);
  }
  setData(t) {
    const n = new Float32Array(24), s = new Uint16Array(24 / 2), r = 0;
    for (let a = 0; a < 3; a++)
      n[3 * r + a] = t.center[a] - t.size * t.left[a], n[3 * (r + 1) + a] = t.center[a] - t.size / 2 * t.left[a], n[3 * (r + 2) + a] = t.center[a] + t.size * t.left[a], n[3 * (r + 3) + a] = t.center[a] + t.size / 2 * t.left[a], n[3 * (r + 4) + a] = t.center[a] + t.size * t.up[a], n[3 * (r + 5) + a] = t.center[a] + t.size / 2 * t.up[a], n[3 * (r + 6) + a] = t.center[a] - t.size * t.up[a], n[3 * (r + 7) + a] = t.center[a] - t.size / 2 * t.up[a];
    s[0] = 2, s[1] = 0, s[2] = 1, s[3] = 2, s[4] = 2, s[5] = 3, s[6] = 2, s[7] = 4, s[8] = 5, s[9] = 2, s[10] = 6, s[11] = 7, this.points.setData(n, 3), this.lines.setData(s), this.actor.getProperty().setColor(t.color), this.data.modified();
  }
  getActor() {
    return this.actor;
  }
  getMapper() {
    return this.mapper;
  }
  delete() {
    this.points.delete(), this.lines.delete(), this.data.delete(), this.mapper.delete(), this.actor.delete();
  }
}
const Hyt = { style: { width: "100%", height: "100%", overflow: "hidden" } }, _yt = ["src"], tb = 16, Qyt = /* @__PURE__ */ Ne({
  __name: "Hotspots2D",
  props: {
    hotspotPoints: {}
  },
  setup(i) {
    const t = jl(), e = i;
    aa();
    const n = Le(e.hotspotPoints);
    return (s, r) => (Mt(), Ot("div", Hyt, [
      (Mt(!0), Ot(Me, null, Xn(Object.entries(K(n)), (a) => (Mt(), Ot(Me, {
        key: a[0]
      }, [
        a[1].visible ? (Mt(), Ot("div", {
          key: 0,
          style: xe([{
            width: tb + "px",
            height: tb + "px",
            left: a[1].position[0] - tb / 2 + "px",
            top: a[1].position[1] - tb / 2 + "px",
            backgroundColor: `rgba(${a[1].color[0]}, ${a[1].color[1]}, ${a[1].color[2]}, 0.8)`
          }, { cursor: "pointer", "z-index": "10" }]),
          class: "rotate-handle"
        }, [
          a[1].icon ? (Mt(), Ot("img", {
            key: 0,
            draggable: "false",
            class: "object-contain svg-icon-color",
            height: tb,
            width: tb,
            src: K(t).getAssetUrl("/icons/cursors/ik_rotate.svg"),
            style: { display: "flex", "pointer-events": "none", "border-style": "none", transform: "scale(1.4)" }
          }, null, 8, _yt)) : Qt("", !0)
        ], 4)) : Qt("", !0)
      ], 64))), 128))
    ]));
  }
}), $yt = /* @__PURE__ */ Dn(Qyt, [["__scopeId", "data-v-a9e5510d"]]);
class qyt {
  constructor(t) {
    S(this, "coordControl");
    S(this, "mapper", Ue.newInstance());
    S(this, "data", Ie.newInstance());
    S(this, "actor", Re.newInstance());
    S(this, "points", yi.newInstance());
    S(this, "lines", Ii.newInstance());
    S(this, "colorArray");
    S(this, "viewTypes", [Nt.SAGITTAL, Nt.CORONAL, Nt.AXIAL, Nt.CPR, Nt.CROSS, Nt.TANGENT]);
    S(this, "hotspotPoints", new qt([]));
    S(this, "overlayComponents");
    S(this, "hotspotVue");
    this.coordControl = t, this.mapper.setInputData(this.data), this.actor.setMapper(this.mapper), this.mapper.setScalarModeToUseCellData(), this.colorArray = We.newInstance({
      name: "colors",
      values: new Uint8Array(0),
      numberOfComponents: 3
    }), this.mapper.setColorByArrayName("colors");
  }
  delete() {
    var t, e;
    this.points.delete(), this.lines.delete(), this.data.delete(), this.mapper.delete(), this.actor.delete(), this.colorArray.delete(), (t = this.hotspotVue) == null || t.remove(), (e = this.overlayComponents) == null || e.cleanup();
  }
  isViewEnabled(t) {
    for (let e = 0; e < this.viewTypes.length; e++) if (this.viewTypes[e] == t.getViewMode()) return !0;
    return t.isMultiCross();
  }
  OnViewWidget(t, e) {
    var n, s, r;
    if (!t.isMultiCross() && !t.isViewMode3D()) {
      if (e == me.eVE_DESTROY) {
        t.removeActor(this.actor), (n = this.hotspotVue) == null || n.remove(), this.hotspotVue = void 0, (s = this.overlayComponents) == null || s.cleanup(), this.overlayComponents = void 0;
        return;
      } else
        t.addActor(this.actor, 1), this.overlayComponents || (this.overlayComponents = Pi(t.getOverlayContainer())), !this.hotspotVue && this.overlayComponents && (this.hotspotVue = this.overlayComponents.createVueOverlayComponent($yt, { hotspotPoints: this.hotspotPoints }, { enabled: !1 })), (r = this.hotspotVue) == null || r.setEnabled(!0);
      this.updateCross(t);
    }
  }
  getScoutList(t) {
    const e = this.coordControl.context.getPresenterWindows(), n = [];
    if (this.coordControl.context.cprSettings && (t.getViewMode() == Nt.CORONAL || t.getViewMode() == Nt.SAGITTAL)) {
      const s = this.coordControl.context.getViewWidget(Nt.AXIAL);
      return s && s.isVisible() && n.push(s), n;
    } else if (t.getViewMode() == Nt.TANGENT || t.getViewMode() == Nt.CROSS) {
      const s = this.coordControl.context.getViewWidget(Nt.AXIAL);
      return s && s.isVisible() && n.push(s), n;
    } else if (t.getViewMode() == Nt.CPR) {
      if (!this.coordControl.context.cprSettings) {
        const s = this.coordControl.context.getViewWidget(Nt.AXIAL);
        s && s.isVisible() && n.push(s);
        const r = this.coordControl.context.getPresenterWindow(Nt.CROSS), a = r == null ? void 0 : r.getMainView();
        r && a && n.push(a);
      }
      return n;
    }
    for (let s = 0; s < e.length; s++) {
      const r = e[s].getMainView();
      r && r.getViewMode() != t.getViewMode() && r.isVisible() && r.getViewMode() != Nt.STL3D && r.getViewMode() != Nt._STL_3D_PREVIEW && r.getViewMode() != Nt._3D && r.getViewMode() != Nt.CPR && r.getFilterMode() != Je.SCOUT && n.push(r);
    }
    return n;
  }
  updateCross(t) {
    const e = this.getScoutList(t), n = this.coordControl.context.settings.general.crosshairType;
    let s = 0;
    n == "Full" ? s = 1 : n == "Small" ? s = 2 : n == "Centered" && (s = 4), s > 0 && this.actor.setVisibility(s > 0);
    const r = e.length * s, a = 2 * r, o = new Uint16Array(3 * r), l = new Float32Array(3 * a);
    this.colorArray.setData(new Uint8Array(r * 3));
    for (let d = 0; d < r; d++)
      o[3 * d] = 2, o[3 * d + 1] = d * 2 + 0, o[3 * d + 2] = d * 2 + 1;
    let c = 0, u = 0;
    e.forEach((d) => {
      let h = d.color;
      this.coordControl.context.cprSettings && (h = [255, 255, 0]);
      const p = I.create();
      I.cross(p, d.getNormal(), t.getNormal());
      const m = this.coordControl.getEdgePoint3D(t, d);
      I.subtract(p, m[1], m[0]), I.normalize(p, p);
      const b = I.distance(d.getOrigin(), m[0]), y = t.getFixedSizeScale([t.getOrigin()[0], t.getOrigin()[1], t.getOrigin()[2]], 10, 10), Z = 2 * this.coordControl.fixed2DSize * y, g = 2 * this.coordControl.fixed2DSize * y;
      if (s == 4) {
        for (let f = 0; f < 3; f++)
          l[3 * c + f] = m[0][f];
        c++;
        for (let f = 0; f < 3; f++)
          l[3 * c + f] = m[0][f] + p[f] * Z;
        c++, this.colorArray.setTuple(u, [d.color[0], d.color[1], d.color[2]]), u++;
        for (let f = 0; f < 3; f++)
          l[3 * c + f] = m[1][f] - p[f] * Z;
        c++;
        for (let f = 0; f < 3; f++)
          l[3 * c + f] = m[1][f];
        c++, this.colorArray.setTuple(u, [d.color[0], d.color[1], d.color[2]]), u++;
        for (let f = 0; f < 3; f++)
          l[3 * c + f] = m[0][f] + p[f] * (b - 2 * g);
        c++;
        for (let f = 0; f < 3; f++)
          l[3 * c + f] = m[0][f] + p[f] * (b - g);
        c++, this.colorArray.setTuple(u, [d.color[0], d.color[1], d.color[2]]), u++;
        for (let f = 0; f < 3; f++)
          l[3 * c + f] = m[0][f] + p[f] * (b + g);
        c++;
        for (let f = 0; f < 3; f++)
          l[3 * c + f] = m[0][f] + p[f] * (b + 2 * g);
        c++, this.colorArray.setTuple(u, [d.color[0], d.color[1], d.color[2]]), u++;
      } else if (s == 2) {
        for (let f = 0; f < 3; f++)
          l[3 * c + f] = m[0][f];
        c++;
        for (let f = 0; f < 3; f++)
          l[3 * c + f] = m[0][f] + p[f] * Z;
        c++, this.colorArray.setTuple(u, [d.color[0], d.color[1], d.color[2]]), u++;
        for (let f = 0; f < 3; f++)
          l[3 * c + f] = m[1][f] - p[f] * Z;
        c++;
        for (let f = 0; f < 3; f++)
          l[3 * c + f] = m[1][f];
        c++, this.colorArray.setTuple(u, [d.color[0], d.color[1], d.color[2]]), u++;
      } else if (s == 1) {
        for (let f = 0; f < 3; f++)
          l[3 * c + f] = m[0][f];
        c++;
        for (let f = 0; f < 3; f++)
          l[3 * c + f] = m[1][f];
        c++, this.colorArray.setTuple(u, [h[0], h[1], h[2]]), u++;
      }
    }), this.points.setData(l, 3), this.lines.setData(o), this.data.setPoints(this.points), this.data.setLines(this.lines), this.data.getCellData().setScalars(this.colorArray), this.data.modified(), e && t.getViewMode() != Nt._3D && this.updateIcons(t);
  }
  updateIcons(t) {
    const e = this.getScoutList(t);
    !t.isViewMode3D() && !t.isMultiCross() && (t.getViewMode() == Nt.CPR && t.updateCrossSliceIndicator(), this.hotspotPoints.update((n) => {
      n = [];
      let s;
      return e.forEach((r) => {
        let a = r.color, o = this.coordControl.getActionPoint(t, r, this.coordControl.fixed2DSize);
        const l = this.coordControl.getActionPoint(t, r, 0);
        if (t.getViewMode() == Nt.CPR && o && l) {
          const c = Math.abs(o[0][1] - l[0][1]);
          o = this.coordControl.getActionPoint(t, r, this.coordControl.fixed2DSize * this.coordControl.fixed2DSize / c / 2 * 3);
        }
        if (this.coordControl.context.cprSettings) {
          a = [155, 255, 10];
          const c = t.worldToViewV3(r.getOrigin());
          s = {
            color: a,
            position: [c[0], c[1]],
            visible: !0,
            icon: !1
          }, n.push(s);
        }
        if (o)
          for (let c = 0; c < 2; c++)
            s = {
              color: a,
              position: [o[c][0], o[c][1]],
              visible: !0,
              icon: !0
            }, n.push(s);
        if (l)
          for (let c = 0; c < 2; c++)
            s = {
              color: a,
              position: [l[c][0], l[c][1]],
              visible: !0,
              icon: !1
            }, n.push(s);
      }), n;
    }));
  }
}
class t2t {
  constructor(t) {
    S(this, "coordControl");
    S(this, "mapper", Ue.newInstance());
    S(this, "data", Ie.newInstance());
    S(this, "actor", Re.newInstance());
    S(this, "points", yi.newInstance());
    S(this, "lines", Ii.newInstance());
    S(this, "colorArray");
    this.coordControl = t, this.mapper.setInputData(this.data), this.actor.setMapper(this.mapper), this.mapper.setScalarModeToUseCellData(), this.colorArray = We.newInstance({
      name: "colors",
      values: new Uint8Array(0),
      numberOfComponents: 3
    }), this.mapper.setColorByArrayName("colors");
  }
  delete() {
    this.points.delete(), this.lines.delete(), this.data.delete(), this.mapper.delete(), this.actor.delete(), this.colorArray.delete();
  }
  OnViewWidget(t, e) {
    !t.isMultiCross() && !t.isViewMode3D() && (e == me.eVE_DESTROY ? t.removeActor(this.actor) : t.addActor(this.actor), this.updateCross(t));
  }
  getScoutList(t) {
    var s, r, a;
    const e = this.coordControl.context.getPresenterWindows(), n = [];
    if (t.getViewMode() == Nt.TANGENT || t.getViewMode() == Nt.CROSS) {
      const o = this.coordControl.context.getViewWidget(Nt.AXIAL);
      return o && o.isVisible() && n.push(o), n;
    } else if (t.getViewMode() == Nt.CPR) {
      if (!this.coordControl.context.cprSettings) {
        const o = this.coordControl.context.getPresenterWindow(Nt.AXIAL);
        o && ((s = o.getViews()) == null || s.forEach((c) => {
          c.isVisible() && n.push(c);
        }));
        const l = this.coordControl.context.getPresenterWindow(Nt.CROSS);
        l && ((r = l.getViews()) == null || r.forEach((c) => {
          c.isVisible() && n.push(c);
        }));
      }
      return n;
    }
    for (let o = 0; o < e.length; o++) {
      const l = e[o].getMainView();
      l && l.getViewMode() != t.getViewMode() && l.isVisible() && l.getViewMode() != Nt._3D && l.getViewMode() != Nt.CPR && l.getFilterMode() != Je.SCOUT && ((a = e[o].getViews()) == null || a.forEach((c) => {
        n.push(c);
      }));
    }
    return n;
  }
  updateCross(t) {
    const e = this.getScoutList(t), s = e.length * 2, r = 2 * s, a = new Uint16Array(3 * s), o = new Float32Array(3 * r);
    this.colorArray.setData(new Uint8Array(s * 3));
    for (let u = 0; u < s; u++)
      a[3 * u] = 2, a[3 * u + 1] = u * 2 + 0, a[3 * u + 2] = u * 2 + 1;
    let l = 0, c = 0;
    e.forEach((u) => {
      u.color, this.coordControl.context.cprSettings;
      const d = I.create();
      I.cross(d, u.getNormal(), t.getNormal());
      const h = this.coordControl.getEdgePoint3D(t, u);
      I.subtract(d, h[1], h[0]), I.normalize(d, d);
      const p = I.distance(u.getOrigin(), h[0]), m = t.getFixedSizeScale([t.getOrigin()[0], t.getOrigin()[1], t.getOrigin()[2]], 10, 10), b = 2 * this.coordControl.fixed2DSize * m;
      if (t.getViewMode() == Nt.AXIAL && u.getViewMode() == Nt.CROSS) {
        for (let y = 0; y < 3; y++)
          o[3 * l + y] = h[0][y] + d[y] * (p - b);
        l++;
        for (let y = 0; y < 3; y++)
          o[3 * l + y] = h[0][y] + d[y] * p;
        l++, this.colorArray.setTuple(c, [u.color[0], u.color[1], u.color[2]]), c++;
        for (let y = 0; y < 3; y++)
          o[3 * l + y] = h[0][y] + d[y] * p;
        l++;
        for (let y = 0; y < 3; y++)
          o[3 * l + y] = h[0][y] + d[y] * (p + b);
        l++, this.colorArray.setTuple(c, [u.color[0], u.color[1], u.color[2]]), c++;
      } else {
        for (let y = 0; y < 3; y++)
          o[3 * l + y] = h[0][y];
        l++;
        for (let y = 0; y < 3; y++)
          o[3 * l + y] = h[0][y] + d[y] * b;
        l++, this.colorArray.setTuple(c, [u.color[0], u.color[1], u.color[2]]), c++;
        for (let y = 0; y < 3; y++)
          o[3 * l + y] = h[1][y] - d[y] * b;
        l++;
        for (let y = 0; y < 3; y++)
          o[3 * l + y] = h[1][y];
        l++, this.colorArray.setTuple(c, [u.color[0], u.color[1], u.color[2]]), c++;
      }
    }), this.points.setData(o, 3), this.lines.setData(a), this.data.setPoints(this.points), this.data.setLines(this.lines), this.data.getCellData().setScalars(this.colorArray), this.data.modified();
  }
}
class e2t {
  // private displayMode = 0; //{0/ invisible, 1- lines only, 2 - full}
  constructor(t) {
    S(this, "parent");
    S(this, "mapper", Ue.newInstance());
    S(this, "data", Ie.newInstance());
    S(this, "actor", Re.newInstance());
    S(this, "points", yi.newInstance());
    S(this, "lines", Ii.newInstance());
    S(this, "colorArray");
    S(this, "planeMapper", /* @__PURE__ */ new Map());
    S(this, "planeActor", /* @__PURE__ */ new Map());
    S(this, "planeSource", /* @__PURE__ */ new Map());
    this.parent = t, this.mapper.setInputData(this.data), this.actor.setMapper(this.mapper), this.mapper.setScalarModeToUseCellData(), this.colorArray = We.newInstance({
      name: "colors",
      values: new Uint8Array(0),
      numberOfComponents: 3
    }), this.mapper.setColorByArrayName("colors");
  }
  delete() {
    this.points.delete(), this.lines.delete(), this.data.delete(), this.mapper.delete(), this.actor.delete(), this.colorArray.delete(), this.planeActor.forEach((t) => {
      t.delete();
    }), this.planeMapper.forEach((t) => {
      t.delete();
    });
  }
  OnViewWidget(t, e) {
    const n = this.getScoutList(t);
    t.getViewMode() == Nt._3D && (e == me.eVE_DESTROY ? (t.removeActor(this.actor), this.planeActor.forEach((s) => {
      t.removeActor(s), s.delete();
    }), this.planeMapper.forEach((s) => {
      s.delete();
    }), this.planeSource.forEach((s) => {
      s.delete();
    })) : (t.addActor(this.actor), this.parent.getScoutDispalyMode() ? (n.forEach((s) => {
      var a, o;
      this.planeActor.get(s) || this.planeActor.set(s, Up.newInstance()), this.planeMapper.get(s) || this.planeMapper.set(s, jp.newInstance());
      const r = this.planeMapper.get(s);
      if (r) {
        (a = this.planeActor.get(s)) == null || a.setMapper(r);
        let l = Fi.fromValues(0, 0);
        if (s.getViewMode() == Nt.CROSS) {
          const u = Fi.fromValues(this.parent.context.settings.general.crossSectionSizeMm, this.parent.context.settings.general.crossSectionSizeMm);
          l = Fi.fromValues(u[0], u[1]);
        }
        const c = s.getImagedata(l);
        this.planeSource.get(s) && ((o = this.planeSource.get(s)) == null || o.delete()), this.planeSource.set(s, c), r.setInputData(this.planeSource.get(s));
      }
      this.parent.getScoutDispalyMode() == 2 ? t.addActor(this.planeActor.get(s)) : t.removeActor(this.planeActor.get(s));
    }), this.updateCross(t)) : (t.removeActor(this.actor), n.forEach((s) => {
      t.removeActor(this.planeActor.get(s));
    }))));
  }
  getScoutList(t) {
    const e = this.parent.context.getPresenterWindows(), n = [];
    if (t.getViewMode() != Nt._3D) return n;
    for (let s = 0; s < e.length; s++) {
      const r = e[s].getMainView();
      r && r.getViewMode() != t.getViewMode() && r.isVisible() && (this.parent.context.layoutManager.layoutContainsCpr(this.parent.context.getLayout()) ? r.getViewMode() == Nt.CROSS && n.push(r) : (r.getViewMode() == Nt.AXIAL || r.getViewMode() == Nt.CORONAL || r.getViewMode() == Nt.SAGITTAL) && n.push(r));
    }
    return n;
  }
  updateCross(t) {
    const e = this.getScoutList(t);
    this.planeActor.forEach((u) => {
      u.setVisibility(!1);
    });
    const s = e.length * 4, r = e.length * 4, a = new Uint16Array(3 * s), o = new Float32Array(3 * r);
    this.colorArray.setData(new Uint8Array(s * 3));
    for (let u = 0; u < e.length; u++)
      a[0 + u * 12] = 2, a[1 + u * 12] = 0 + u * 4, a[2 + u * 12] = 1 + u * 4, a[3 + u * 12] = 2, a[4 + u * 12] = 1 + u * 4, a[5 + u * 12] = 2 + u * 4, a[6 + u * 12] = 2, a[7 + u * 12] = 2 + u * 4, a[8 + u * 12] = 3 + u * 4, a[9 + u * 12] = 2, a[10 + u * 12] = 3 + u * 4, a[11 + u * 12] = 0 + u * 4;
    let l = 0, c = 0;
    this.parent.getScoutDispalyMode() && (e.forEach((u) => {
      var T, M, N, W;
      u.color;
      const d = u.getViewMatrix();
      let h = u.getOrigin();
      const p = u.getViewup(), m = u.getTangent(), b = u.getBounds();
      let y = (b[1] - b[0]) / 2, Z = (b[5] - b[4]) / 2;
      (T = this.planeActor.get(u)) == null || T.setUserMatrix(d), (M = this.planeActor.get(u)) == null || M.setVisibility(!0);
      const g = u.getWindowLevel();
      (N = this.planeActor.get(u)) == null || N.getProperty().setColorWindow(g[0]), (W = this.planeActor.get(u)) == null || W.getProperty().setColorLevel(g[1]);
      const f = this.planeSource.get(u);
      if (f) {
        const x = f.getDimensions(), V = this.parent.context.getDataSpacing();
        y = x[0] * V / 2, Z = x[1] * V / 2, u.getViewMode() == Nt.CROSS || (h = this.parent.context.getImageData().getCenter(), Fs(h, u.getOrigin(), u.getNormal(), h));
      }
      for (let x = 0; x < 3; x++)
        o[3 * l + x] = h[x] + y * m[x] + Z * p[x];
      l++, this.colorArray.setTuple(c, [u.color[0], u.color[1], u.color[2]]), c++;
      for (let x = 0; x < 3; x++)
        o[3 * l + x] = h[x] + y * m[x] - Z * p[x];
      l++, this.colorArray.setTuple(c, [u.color[0], u.color[1], u.color[2]]), c++;
      for (let x = 0; x < 3; x++)
        o[3 * l + x] = h[x] - y * m[x] - Z * p[x];
      l++, this.colorArray.setTuple(c, [u.color[0], u.color[1], u.color[2]]), c++;
      for (let x = 0; x < 3; x++)
        o[3 * l + x] = h[x] - y * m[x] + Z * p[x];
      l++, this.colorArray.setTuple(c, [u.color[0], u.color[1], u.color[2]]), c++;
    }), this.points.setData(o, 3), this.lines.setData(a), this.data.setPoints(this.points), this.data.setLines(this.lines), this.data.getCellData().setScalars(this.colorArray), this.data.modified());
  }
}
class n2t {
  constructor(t) {
    S(this, "coordControl");
    S(this, "mapper", Ue.newInstance());
    S(this, "data", Ie.newInstance());
    S(this, "actor", Re.newInstance());
    S(this, "points", yi.newInstance());
    S(this, "lines", Ii.newInstance());
    S(this, "colorArray");
    S(this, "rectData", Ie.newInstance());
    S(this, "rectActor", Re.newInstance());
    S(this, "rectMapper", Ue.newInstance());
    S(this, "rectPoints", yi.newInstance());
    S(this, "rectFaces", Ii.newInstance());
    S(this, "rectColorArray");
    S(this, "scoutView", null);
    S(this, "scoutViewDir", 0);
    this.coordControl = t, this.mapper.setInputData(this.data), this.actor.setMapper(this.mapper), this.mapper.setScalarModeToUseCellData(), this.colorArray = We.newInstance({
      name: "colors",
      values: new Uint8Array(0),
      numberOfComponents: 3
    }), this.mapper.setColorByArrayName("colors"), this.rectMapper.setInputData(this.rectData), this.rectMapper.setScalarModeToUseCellData(), this.rectActor.setMapper(this.rectMapper), this.rectActor.getProperty().setColor(1, 0, 0), this.rectActor.setPickable(!1), this.rectActor.setVisibility(!0), this.rectActor.getProperty().setOpacity(0.3), this.rectColorArray = We.newInstance({
      name: "rectcolors",
      values: new Uint8Array(0),
      numberOfComponents: 3
    }), this.rectMapper.setColorByArrayName("rectcolors");
  }
  delete() {
    this.points.delete(), this.lines.delete(), this.data.delete(), this.mapper.delete(), this.actor.delete(), this.colorArray.delete(), this.rectPoints.delete(), this.rectFaces.delete(), this.rectData.delete(), this.rectMapper.delete(), this.rectActor.delete(), this.rectColorArray.delete();
  }
  OnViewWidget(t, e) {
    !t.isMultiCross() && !t.isViewMode3D() && (e == me.eVE_DESTROY ? (t.removeActor(this.actor), t.removeActor(this.rectActor)) : (t.addActor(this.actor), t.addActor(this.rectActor)), this.updateCross(t));
  }
  isMIP(t) {
    return t.getFilterMode() == Je.MIP || t.getFilterMode() == Je.MINMIP || t.getFilterMode() == Je.RAYSUM;
  }
  getScoutList(t) {
    const e = this.coordControl.context.getPresenterWindows(), n = [];
    if (this.coordControl.context.cprSettings) return n;
    if (t.getViewMode() == Nt.TANGENT || t.getViewMode() == Nt.CROSS) {
      const s = this.coordControl.context.getViewWidget(Nt.AXIAL);
      return s && s.isVisible() && this.isMIP(s) && n.push(s), n;
    } else if (t.getViewMode() == Nt.CPR) {
      if (this.coordControl.context.cprSettings) return n;
      {
        const s = this.coordControl.context.getPresenterWindow(Nt.CROSS), r = s == null ? void 0 : s.getMainView();
        return s && r && r.isVisible() && this.isMIP(r) && n.push(r), n;
      }
    }
    for (let s = 0; s < e.length; s++) {
      const r = e[s].getMainView();
      r && r.getViewMode() != t.getViewMode() && r.isVisible() && r.getViewMode() != Nt._3D && r.getViewMode() != Nt.CPR && this.isMIP(r) && n.push(r);
    }
    return n;
  }
  updateCross(t) {
    const e = this.getScoutList(t), n = 2, s = t.getFixedSizeScale([t.getOrigin()[0], t.getOrigin()[1], t.getOrigin()[2]], 10, 10), r = 4 * this.coordControl.fixed2DSize * s, a = e.length * n * 2, o = 2 * a, l = new Uint16Array(3 * a), c = new Float32Array(3 * o);
    this.colorArray.setData(new Uint8Array(a * 3));
    for (let y = 0; y < a; y++)
      l[3 * y] = 2, l[3 * y + 1] = y * 2 + 0, l[3 * y + 2] = y * 2 + 1;
    const u = 12, d = 8, h = new Uint16Array(u * e.length);
    this.rectColorArray.setData(new Uint8Array(e.length * 2 * 3));
    for (let y = 0; y < e.length; y++)
      h[0 + y * u] = 5, h[1 + y * u] = 0 + y * d, h[2 + y * u] = 1 + y * d, h[3 + y * u] = 5 + y * d, h[4 + y * u] = 4 + y * d, h[5 + y * u] = 0 + y * d, h[6 + y * u] = 5, h[7 + y * u] = 2 + y * d, h[8 + y * u] = 3 + y * d, h[9 + y * u] = 7 + y * d, h[10 + y * u] = 6 + y * d, h[11 + y * u] = 2 + y * d;
    let p = 0, m = 0, b = 0;
    e.forEach((y) => {
      const Z = I.fromValues(0, 0, 0);
      for (let g = -1; g < 2; g += 2) {
        y.color, this.coordControl.context.cprSettings;
        const f = I.create(), T = this.coordControl.getEdgePoint3D(t, y, g * y.getFilterThickness() / 2);
        if (I.subtract(f, T[1], T[0]), I.normalize(f, f), I.length(Z) < Number.EPSILON && I.set(Z, f[0], f[1], f[2]), I.dot(Z, f) < 0) {
          I.scale(f, f, -1);
          const M = T[0];
          T[0] = T[1], T[1] = M;
        }
        {
          for (let M = 0; M < 3; M++)
            c[3 * p + M] = T[0][M] - f[M] * r;
          p++;
          for (let M = 0; M < 3; M++)
            c[3 * p + M] = T[0][M] + f[M] * r;
          p++, this.colorArray.setTuple(m, [y.color[0], y.color[1], y.color[2]]), m++;
          for (let M = 0; M < 3; M++)
            c[3 * p + M] = T[1][M] - f[M] * r;
          p++;
          for (let M = 0; M < 3; M++)
            c[3 * p + M] = T[1][M] + f[M] * r;
          p++, this.colorArray.setTuple(m, [y.color[0], y.color[1], y.color[2]]), m++, this.rectColorArray.setTuple(b, [y.color[0], y.color[1], y.color[2]]), b++;
        }
      }
    }), this.points.setData(c, 3), this.lines.setData(l), this.data.setPoints(this.points), this.data.setLines(this.lines), this.data.getCellData().setScalars(this.colorArray), this.data.modified(), this.rectPoints.setData(c, 3), this.rectFaces.setData(h), this.rectData.setPoints(this.rectPoints), this.rectData.setPolys(this.rectFaces), this.rectData.getCellData().setScalars(this.rectColorArray), this.rectData.modified();
  }
  mouseOver(t, e) {
    const n = this.getScoutList(e);
    let s = td.NONE;
    const r = 2 * this.coordControl.fixed2DSize;
    return n.forEach((a) => {
      for (let o = -1; o < 2; o += 2) {
        const l = this.coordControl.getActionPoint(e, a, 0, o * a.getFilterThickness() / 2), c = this.coordControl.getActionPoint(e, a, r, o * a.getFilterThickness() / 2);
        l && c && (this.coordControl.onLine2D(l[0], c[0], t) || this.coordControl.onLine2D(l[1], c[1], t)) && (s = td.THICKNESS, this.scoutView = a, this.scoutViewDir = o);
      }
    }), s;
  }
  getScoutView() {
    return this.scoutView ? [this.scoutView, this.scoutViewDir] : null;
  }
}
const i2t = {
  VARY_RADIUS_OFF: 0,
  // default
  VARY_RADIUS_BY_SCALAR: 1,
  VARY_RADIUS_BY_VECTOR: 2,
  VARY_RADIUS_BY_ABSOLUTE_SCALAR: 3
}, s2t = {
  TCOORDS_OFF: 0,
  // default
  TCOORDS_FROM_NORMALIZED_LENGTH: 1,
  TCOORDS_FROM_LENGTH: 2,
  TCOORDS_FROM_SCALARS: 3
};
var r2t = {
  VaryRadius: i2t,
  GenerateTCoords: s2t
};
const {
  VaryRadius: xy,
  GenerateTCoords: Sp
} = r2t, {
  vtkDebugMacro: a2t,
  vtkErrorMacro: o2t,
  vtkWarningMacro: ay
} = tt;
function l2t(i, t) {
  t.classHierarchy.push("vtkTubeFilter");
  function e(l, c) {
    let u = l;
    return t.sidesShareVertices ? u += t.numberOfSides * c : u += 2 * t.numberOfSides * c, t.capping && (u += 2 * t.numberOfSides), u;
  }
  function n(l, c, u) {
    const d = c[u], h = l.slice(3 * d, 3 * (d + 1));
    let p = u + 1;
    for (; p < c.length; ) {
      const m = c[p], b = l.slice(3 * m, 3 * (m + 1));
      if (h !== b)
        return p - 1;
      ++p;
    }
    return c.length;
  }
  function s(l, c, u) {
    let d = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, h = [0, 0, 1];
    const p = c;
    let m = p[0];
    for (let b = 0; b < p.length; b += m + 1)
      if (m = p[b], m === 1)
        u.setTuple(p[b + 1], h);
      else if (m > 1) {
        let y = 0, Z = [0, 0, 0];
        const g = [0, 0, 0], f = p.slice(b + 1, b + 1 + m);
        if (y = n(l, f, 0), y !== m) {
          let T = f[y], M = l.slice(3 * T, 3 * (T + 1)), N = f[y + 1], W = l.slice(3 * N, 3 * (N + 1));
          if (Z = W.map((V, X) => V - M[X]), Fn(Z), d)
            h = d;
          else {
            for (; ++y < m; )
              if (y = n(l, f, y), y !== m) {
                T = f[y], M = l.slice(3 * T, 3 * (T + 1)), N = f[y + 1], W = l.slice(3 * N, 3 * (N + 1));
                for (let X = 0; X < 3; ++X)
                  g[X] = W[X] - M[X];
                Fn(g);
                const V = [0, 0, 0];
                if (Wi(Z, g, V), Or(V) > 1e-3) {
                  h = V, Z = g;
                  break;
                }
              }
            if (y >= m) {
              for (let V = 0; V < 3; ++V)
                if (Z[V] !== 0) {
                  h[(V + 2) % 3] = 0, h[(V + 1) % 3] = 1, h[V] = -Z[(V + 1) % 3] / Z[V];
                  break;
                }
            }
          }
          Fn(h);
          let x = 0;
          for (; ++y < m && (y = n(l, f, y), y !== m); ) {
            T = f[y], M = l.slice(3 * T, 3 * (T + 1)), N = f[y + 1], W = l.slice(3 * N, 3 * (N + 1));
            for (let X = 0; X < 3; ++X)
              g[X] = W[X] - M[X];
            Fn(g);
            const V = [0, 0, 0];
            if (Wi(Z, h, V), Fn(V) !== 0) {
              const X = [0, 0, 0];
              if (Wi(g, Z, X), Fn(X) !== 0) {
                const C = tn(X, h);
                let R = 1 - C * C;
                R > 0 ? R = Math.sqrt(R) : R = 0;
                const z = [0, 0, 0];
                for (let F = 0; F < 3; ++F)
                  z[F] = g[F] + Z[F];
                Fn(z), Wi(z, X, V), Wi(Z, X, z), tn(h, z) * tn(V, z) < 0 && (R *= -1);
                for (let F = x; F < y; ++F)
                  u.setTuple(f[F], h);
                x = y, Z = g, h = C * X + R * V;
              }
            }
          }
          for (let V = x; V < m; ++V)
            u.setTuple(f[V], h);
        } else
          for (let T = 0; T < m; ++T)
            u.setTuple(f[T], h);
      }
    return 1;
  }
  function r(l, c, u, d, h, p, m, b, y, Z, g, f, T, M) {
    const N = [0, 0, 0], W = [0, 0, 0], x = [0, 0, 0], V = [0, 0, 0];
    let X = [0, 0, 0], C = [0, 0, 0], R = [0, 0, 0], z = [0, 0, 0];
    const F = [0, 0, 0], P = [0, 0, 0], j = [0, 0, 0];
    let H = 1, B = l;
    const $ = [];
    for (let A = 0; A < c; ++A) {
      if (A === 0) {
        X = d.slice(3 * u[0], 3 * (u[0] + 1)), C = d.slice(3 * u[1], 3 * (u[1] + 1));
        for (let E = 0; E < 3; ++E)
          N[E] = C[E] - X[E], W[E] = N[E], x[E] = -W[E];
        Fn(x);
      } else if (A === c - 1) {
        for (let E = 0; E < 3; ++E)
          W[E] = N[E], X[E] = C[E], V[E] = N[E];
        Fn(V);
      } else {
        for (let E = 0; E < 3; ++E)
          X[E] = C[E];
        C = d.slice(3 * u[A + 1], 3 * (u[A + 1] + 1));
        for (let E = 0; E < 3; ++E)
          W[E] = N[E], N[E] = C[E] - X[E];
      }
      if (Fn(N) === 0)
        return ay("Coincident points!"), 0;
      for (let E = 0; E < 3; ++E)
        R[E] = (W[E] + N[E]) / 2;
      if (z = T.slice(3 * u[A], 3 * (u[A] + 1)), Fn(R) === 0 && (Wi(W, z, R), Fn(R) === 0 && a2t("Using alternate bevel vector")), Wi(R, z, F), Fn(F) === 0) {
        let E = "Bad normal: s = ";
        return E += `${R[0]},  ${R[1]}, ${R[2]}`, E += ` n = ${z[0]},  ${z[1]}, ${z[2]}`, ay(E), 0;
      }
      if (Wi(F, R, P), Fn(P), y && t.varyRadius === xy.VARY_RADIUS_BY_SCALAR)
        H = 1 + (t.radiusFactor - 1) * (y.getComponent(u[A], 0) - Z[0]) / (Z[1] - Z[0]);
      else if (g && t.varyRadius === xy.VARY_RADIUS_BY_VECTOR)
        H = Math.sqrt(f / Or(g.getTuple(u[A], $))), H > t.radiusFactor && (H = t.radiusFactor);
      else if (y && t.varyRadius === xy.VARY_RADIUS_BY_ABSOLUTE_SCALAR && (H = y.getComponent(u[A], 0), H < 0))
        return ay("Scalar value less than zero, skipping line"), 0;
      if (t.sidesShareVertices)
        for (let E = 0; E < t.numberOfSides; ++E) {
          for (let ct = 0; ct < 3; ++ct)
            j[ct] = F[ct] * Math.cos(E * M) + P[ct] * Math.sin(E * M), R[ct] = X[ct] + t.radius * H * j[ct], h[3 * B + ct] = R[ct], b[3 * B + ct] = j[ct];
          m.passData(p, u[A], B), B++;
        }
      else {
        const E = [0, 0, 0], ct = [0, 0, 0];
        for (let at = 0; at < t.numberOfSides; ++at) {
          for (let dt = 0; dt < 3; ++dt)
            j[dt] = F[dt] * Math.cos(at * M) + P[dt] * Math.sin(at * M), E[dt] = F[dt] * Math.cos((at - 0.5) * M) + P[dt] * Math.sin((at - 0.5) * M), ct[dt] = F[dt] * Math.cos((at + 0.5) * M) + P[dt] * Math.sin((at + 0.5) * M), R[dt] = X[dt] + t.radius * H * j[dt], h[3 * B + dt] = R[dt], b[3 * B + dt] = E[dt], h[3 * (B + 1) + dt] = R[dt], b[3 * (B + 1) + dt] = ct[dt];
          m.passData(p, u[A], B + 1), B += 2;
        }
      }
    }
    if (t.capping) {
      let A = t.numberOfSides, E = 1;
      t.sidesShareVertices || (A = 2 * t.numberOfSides, E = 2);
      for (let at = 0; at < A; at += E) {
        R = h.slice(3 * (l + at), 3 * (l + at + 1));
        for (let dt = 0; dt < 3; ++dt)
          h[3 * B + dt] = R[dt], b[3 * B + dt] = x[dt];
        m.passData(p, u[0], B), B++;
      }
      let ct = l + (c - 1) * t.numberOfSides;
      t.sidesShareVertices || (ct = l + 2 * (c - 1) * t.numberOfSides);
      for (let at = 0; at < A; at += E) {
        R = h.slice(3 * (ct + at), 3 * (ct + at + 1));
        for (let dt = 0; dt < 3; ++dt)
          h[3 * B + dt] = R[dt], b[3 * B + dt] = V[dt];
        m.passData(p, u[c - 1], B), B++;
      }
    }
    return 1;
  }
  function a(l, c, u, d, h, p, m) {
    let b = 0, y = 0, Z = 0, g = d, f = 0;
    const T = m.getData();
    let M = 0;
    for (; f < T.length && M !== d; )
      f += T[f] + 1, M++;
    if (t.sidesShareVertices)
      for (let N = l; N < t.numberOfSides + l; N += t.onRatio) {
        b = N % t.numberOfSides, y = (N + 1) % t.numberOfSides, T[f++] = c * 2;
        for (let W = 0; W < c; ++W)
          Z = W * t.numberOfSides, T[f++] = l + y + Z, T[f++] = l + b + Z;
        p.passData(h, u, g++);
      }
    else
      for (let N = l; N < t.numberOfSides + l; N += t.onRatio) {
        b = 2 * (N % t.numberOfSides) + 1, y = 2 * ((N + 1) % t.numberOfSides), T[f] = c * 2, f++;
        for (let W = 0; W < c; ++W)
          Z = W * 2 * t.numberOfSides, T[f++] = l + y + Z, T[f++] = l + b + Z;
        p.passData(h, u, g++);
      }
    if (t.capping) {
      let N = l + c * t.numberOfSides, W = 0;
      t.sidesShareVertices || (N = l + 2 * c * t.numberOfSides), T[f++] = t.numberOfSides, T[f++] = N, T[f++] = N + 1;
      let x = 0;
      for (b = t.numberOfSides - 1, y = 2, x = 0; x < t.numberOfSides - 2; ++x)
        x % 2 ? (W = N + y, T[f++] = W, y++) : (W = N + b, T[f++] = W, b--);
      for (p.passData(h, u, g++), N += t.numberOfSides, T[f++] = t.numberOfSides, T[f++] = N, T[f++] = N + t.numberOfSides - 1, b = t.numberOfSides - 2, y = 1, x = 0; x < t.numberOfSides - 2; ++x)
        x % 2 ? (W = N + b, T[f++] = W, b--) : (W = N + y, T[f++] = W, y++);
      p.passData(h, u, g++);
    }
    return g;
  }
  function o(l, c, u, d, h, p) {
    let m = t.numberOfSides;
    t.sidesShareVertices || (m = 2 * t.numberOfSides);
    let b = 0, y = 0, Z = 0;
    const g = h.getData();
    if (t.generateTCoords === Sp.TCOORDS_FROM_SCALARS) {
      y = g[u[0]];
      for (let f = 0; f < c; ++f) {
        Z = g[u[f]], b = (Z - y) / t.textureLength;
        for (let T = 0; T < m; ++T) {
          const M = T / (m - 1), N = 2 * (l + f * m + T);
          p[N] = b, p[N + 1] = M;
        }
      }
    } else if (t.generateTCoords === Sp.TCOORDS_FROM_LENGTH) {
      let f = 0;
      const T = d.slice(3 * u[0], 3 * (u[0] + 1));
      for (let M = 0; M < c; ++M) {
        const N = d.slice(3 * u[M], 3 * (u[M] + 1));
        f += Math.sqrt(zs(N, T)), b = f / t.textureLength;
        for (let W = 0; W < m; ++W) {
          const x = W / (m - 1), V = 2 * (l + M * m + W);
          p[V] = b, p[V + 1] = x;
        }
        for (let W = 0; W < 3; ++W)
          T[W] = N[W];
      }
    } else if (t.generateTCoords === Sp.TCOORDS_FROM_NORMALIZED_LENGTH) {
      let f = 0, T = 0, M = d.slice(3 * u[0], 3 * (u[0] + 1));
      for (let N = 0; N < c; ++N) {
        const W = d.slice(3 * u[N], 3 * (u[N] + 1));
        T += Math.sqrt(zs(W, M));
        for (let x = 0; x < 3; ++x)
          M[x] = W[x];
      }
      M = d.slice(3 * u[0], 3 * (u[0] + 1));
      for (let N = 0; N < c; ++N) {
        const W = d.slice(3 * u[N], 3 * (u[N] + 1));
        f += Math.sqrt(zs(W, M)), b = f / T;
        for (let x = 0; x < m; ++x) {
          const V = x / (m - 1), X = 2 * (l + N * m + x);
          p[X] = b, p[X + 1] = V;
        }
        for (let x = 0; x < 3; ++x)
          M[x] = W[x];
      }
    }
    if (t.capping) {
      const f = l + c * m;
      for (let T = 0; T < t.numberOfSides; ++T) {
        const M = 2 * (f + T);
        p[M] = 0, p[M + 1] = 0;
      }
      for (let T = 0; T < t.numberOfSides; ++T) {
        const M = 2 * (f + t.numberOfSides + T);
        p[M] = 0, p[M + 1] = 0;
      }
    }
  }
  i.requestData = (l, c) => {
    const u = Ie.newInstance();
    c[0] = u;
    const d = l[0];
    if (!d) {
      o2t("Invalid or missing input");
      return;
    }
    const h = d.getPoints();
    if (!h)
      return;
    const p = h.getNumberOfPoints();
    if (p < 1)
      return;
    const m = d.getLines();
    if (!m || m.getNumberOfCells() < 1)
      return;
    let y = 0, Z = 0;
    const g = m.getData();
    let f = g[0];
    for (let D = 0; D < g.length; D += f + 1)
      f = g[D], y = e(y, f), Z += (2 * f + 1) * Math.ceil(t.numberOfSides / t.onRatio), t.capping && (Z += 2 * (t.numberOfSides + 1));
    let T = h.getDataType();
    t.outputPointsPrecision === uW.SINGLE ? T = Ke.FLOAT : t.outputPointsPrecision === uW.DOUBLE && (T = Ke.DOUBLE);
    const M = yi.newInstance({
      dataType: T,
      size: y * 3,
      numberOfComponents: 3
    }), N = 3 * y, W = new Float32Array(N), x = We.newInstance({
      numberOfComponents: 3,
      values: W,
      name: "TubeNormals"
    }), V = new Uint32Array(Z), X = Ii.newInstance({
      values: V
    });
    let C = 0, R = d.getPointData().getNormals(), z = null, F = !1;
    (!R || t.useDefaultNormal) && (z = new Float32Array(3 * p), R = We.newInstance({
      numberOfComponents: 3,
      values: z,
      name: "Normals"
    }), t.useDefaultNormal ? z = z.map((D, q) => {
      const nt = q % 3;
      return t.defaultNormal[nt];
    }) : F = !0);
    const P = d.getPointData().getNumberOfArrays();
    let j = null, H = null;
    for (let D = 0; D < P; D++)
      j = d.getPointData().getArrayByIndex(D), H = We.newInstance({
        name: j.getName(),
        dataType: j.getDataType(),
        numberOfComponents: j.getNumberOfComponents(),
        size: y * j.getNumberOfComponents()
      }), u.getPointData().addArray(H);
    let B = m.getNumberOfCells() * t.numberOfSides;
    t.capping && (B += 2);
    const $ = d.getCellData().getNumberOfArrays();
    for (let D = 0; D < $; D++)
      j = d.getCellData().getArrayByIndex(D), H = We.newInstance({
        name: j.getName(),
        dataType: j.getDataType(),
        numberOfComponents: j.getNumberOfComponents(),
        size: B * j.getNumberOfComponents()
      }), u.getCellData().addArray(H);
    const A = i.getInputArrayToProcess(0);
    let E = null, ct = [];
    A && (E = We.newInstance({
      name: A.getName(),
      dataType: A.getDataType(),
      numberOfComponents: A.getNumberOfComponents(),
      size: y * A.getNumberOfComponents()
    }), ct = A.getRange(), ct[1] - ct[0] === 0 && (t.varyRadius === xy.VARY_RADIUS_BY_SCALAR && ay("Scalar range is zero!"), ct[1] = ct[0] + 1));
    const at = i.getInputArrayToProcess(1);
    let dt = 0;
    at && (dt = at.getMaxNorm());
    const gt = u.getCellData();
    gt.copyNormalsOff(), gt.passData(d.getCellData());
    const Wt = u.getPointData();
    Wt.getNormals() !== null && Wt.copyNormalsOff(), A && E && Wt.setScalars(E);
    let Zt = null;
    if (t.generateTCoords === Sp.TCOORDS_FROM_SCALARS && A || t.generateTCoords === Sp.TCOORDS_FROM_LENGTH || t.generateTCoords === Sp.TCOORDS_FROM_NORMALIZED_LENGTH) {
      const D = new Float32Array(2 * y);
      Zt = We.newInstance({
        numberOfComponents: 2,
        values: D,
        name: "TCoords"
      }), Wt.copyTCoordsOff();
    }
    Wt.passData(d.getPointData());
    const Gt = 2 * Math.PI / t.numberOfSides;
    f = g[0];
    let Tt = 0, Q = d.getVerts().getNumberOfCells();
    for (let D = 0; D < g.length; D += f + 1) {
      f = g[D];
      const q = g.slice(D + 1, D + 1 + f);
      if (f > 1 && F) {
        const nt = g.slice(D, D + f + 1);
        s(h.getData(), nt, R);
      }
      r(Tt, f, q, h.getData(), M.getData(), d.getPointData(), Wt, W, A, ct, at, dt, z, Gt) ? (C = a(Tt, f, Q, C, d.getCellData(), gt, X), Zt && o(Tt, f, q, h.getData(), A, Zt.getData())) : ay("Could not generate points"), Tt = e(Tt, f), Q++;
    }
    u.setPoints(M), u.setStrips(X), u.setPointData(Wt), Wt.setNormals(x), c[0] = u;
  };
}
const c2t = {
  outputPointsPrecision: uW.DEFAULT,
  radius: 0.5,
  varyRadius: xy.VARY_RADIUS_OFF,
  numberOfSides: 3,
  radiusFactor: 10,
  defaultNormal: [0, 0, 1],
  useDefaultNormal: !1,
  sidesShareVertices: !0,
  capping: !1,
  onRatio: 1,
  offset: 0,
  generateTCoords: Sp.TCOORDS_OFF,
  textureLength: 1
};
function hJ(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, c2t, e), tt.setGet(i, t, ["outputPointsPrecision", "radius", "varyRadius", "numberOfSides", "radiusFactor", "defaultNormal", "useDefaultNormal", "sidesShareVertices", "capping", "onRatio", "offset", "generateTCoords", "textureLength"]), tt.obj(i, t), tt.algo(i, t, 1, 1), l2t(i, t);
}
const u2t = tt.newInstance(hJ, "vtkTubeFilter");
var Qh = {
  newInstance: u2t,
  extend: hJ
};
class d2t {
  // 3d
  constructor(t) {
    S(this, "coordControl");
    S(this, "mapper", Ue.newInstance());
    S(this, "data", Ie.newInstance());
    S(this, "actor", Re.newInstance());
    S(this, "points", yi.newInstance());
    S(this, "lines", Ii.newInstance());
    S(this, "planeMapper", Ue.newInstance());
    S(this, "planeData", Ie.newInstance());
    S(this, "planeActor", Re.newInstance());
    S(this, "planePoints", yi.newInstance());
    S(this, "planeLines", Ii.newInstance());
    S(this, "filter", Qh.newInstance({
      radius: 0.3,
      numberOfSides: 10,
      capping: !0
    }));
    S(this, "radius", 0.3);
    S(this, "MOUSE_OFFSET", 5);
    this.coordControl = t, this.data.setPoints(this.points), this.data.setLines(this.lines), this.mapper.setInputData(this.data), this.actor.setMapper(this.mapper), this.actor.getProperty().setColor([1, 0, 0]), this.actor.getProperty().setLineWidth(3), this.actor.getProperty().setOpacity(1), this.actor.setPickable(!1), this.planeData.setPoints(this.planePoints), this.planeData.setLines(this.planeLines), this.planeMapper.setInputData(this.planeData), this.planeActor.setMapper(this.planeMapper), this.planeActor.getProperty().setColor([1, 0, 0]), this.planeActor.getProperty().setLineWidth(3), this.planeActor.getProperty().setOpacity(1), this.planeActor.setPickable(!1);
  }
  delete() {
    this.points.delete(), this.lines.delete(), this.data.delete(), this.filter.delete(), this.mapper.delete(), this.actor.delete(), this.planePoints.delete(), this.planeLines.delete(), this.planeData.delete(), this.planeMapper.delete(), this.planeActor.delete();
  }
  OnViewWidget(t, e) {
    this.isVisibleOn(t) && (e == me.eVE_DESTROY ? (t.removeActor(this.actor), t.removeActor(this.planeActor)) : (t.getViewMode() == Nt._3D ? t.addActor(this.actor) : t.addActor(this.actor, 1), t.addActor(this.planeActor)), this.updateCross(t));
  }
  isVisibleOn(t) {
    return t.getViewMode() == Nt._3D || t.getViewMode() == Nt.AXIAL;
  }
  updateCross(t) {
    const e = this.coordControl.context.objects.CPRCurve.splineVec, n = this.coordControl.context.objects.CPRCurve.splineBinormals, s = e.length;
    if (t.getViewMode() == Nt.AXIAL && (!this.coordControl.context.layoutManager.layoutContainsCpr(this.coordControl.context.getLayout()) || s < 2)) {
      this.actor.setVisibility(!1);
      return;
    }
    if (t.getViewMode() == Nt._3D && (this.coordControl.getScoutDispalyMode() == 0 || s < 2)) {
      this.actor.setVisibility(!1), this.planeActor.setVisibility(!1);
      return;
    }
    this.actor.setVisibility(!0);
    const r = new Float32Array(s * 3), a = new Uint16Array(s + 1), o = new Float32Array(2 * s * 3), l = new Uint16Array(2 * s + 1), c = this.coordControl.context.CPRHeight;
    for (let d = 0; d < s; d++) {
      const h = I.fromValues(e[d][0], e[d][1], e[d][2]);
      if (t.getViewMode() == Nt.AXIAL && Fs(e[d], t.getOrigin(), t.getNormal(), h), r[3 * d] = h[0], r[3 * d + 1] = h[1], r[3 * d + 2] = h[2], a[d + 1] = d, t.getViewMode() == Nt._3D && this.coordControl.context.settings.general.showCPRScoutPlane) {
        for (let p = 0; p < 3; p++)
          o[3 * d + p] = h[p] + n[d][p] * c / 2, o[3 * (2 * s - d - 1) + p] = h[p] - n[d][p] * c / 2;
        l[d + 1] = d, l[2 * s - d - 1] = 2 * s - d;
      }
    }
    l[2 * s - 1] = 0, a[0] = s, l[0] = 2 * s, this.points.setData(r, 3), this.lines.setData(a), this.data.setPoints(this.points), this.data.setLines(this.lines), this.filter.setRadius(this.radius);
    const u = [
      this.coordControl.context.settings.defaultColors.cprColor[0] / 255,
      this.coordControl.context.settings.defaultColors.cprColor[1] / 255,
      this.coordControl.context.settings.defaultColors.cprColor[2] / 255
    ];
    this.actor.getProperty().setColor(t.color), t.getViewMode() == Nt.AXIAL && (this.actor.getProperty().setLineWidth(2), this.actor.getProperty().setColor(u)), t.getViewMode() == Nt._3D && this.coordControl.context.settings.general.showCPRScoutPlane && (this.planeActor.setVisibility(!0), this.planePoints.setData(o, 3), this.planeLines.setData(l), this.planeData.setPoints(this.planePoints), this.planeData.setLines(this.planeLines), this.planeActor.getProperty().setColor(t.color), this.planeActor.getProperty().setLineWidth(2), this.planeActor.getProperty().setColor(u)), this.data.modified();
  }
  mouseOver(t, e) {
    var s, r;
    let n = td.NONE;
    if (e.getViewMode() == Nt.AXIAL && this.actor.getVisibility()) {
      const a = this.coordControl.context.objects.CPRCurve.splineVec;
      a.length;
      const o = e.viewToWorldV3([t[0], t[1], 0]), l = (s = this.coordControl.context.objects.CPRCurve.owner) == null ? void 0 : s.o, c = (r = this.coordControl.context.objects.CPRCurve.owner) == null ? void 0 : r.n;
      Fs(o, l, c, o);
      const u = ea(a, o);
      if (u.nearestIndex, u.mind < this.MOUSE_OFFSET)
        return td.CPR;
    }
    return n;
  }
}
function MC() {
  return {
    name: "",
    displayText: "",
    objectType: Yt._STL_OBJECT,
    objectSubType: Yt._STL_OBJECT,
    visible: !0,
    color: [255, 255, 255],
    opacity: 255,
    objectNote: "",
    enabled: 1,
    deleted: 0,
    owners: [],
    shapePoints: 0,
    ownerCount: 0
  };
}
function h2t() {
  return {
    ...MC(),
    objectType: Yt._TOOTH_MARKER,
    origin: [0, 0, 0],
    CadToothInfoOrderNumber: -1,
    CadToothInfoType: 0
  };
}
function p2t() {
  return {
    name: "",
    guide_radius_hexagon: 0,
    guide_lip_length: 0,
    guide_cut_size: 0,
    guide_rotation_all: 0,
    guide_rotation_cut: 0
  };
}
function m2t() {
  return {
    name: "",
    // todo should be != ""
    d1Model: 0,
    d2Model: 0,
    l1Model: 0,
    l2Model: 0,
    cutSizeModel: 0,
    bottomExtrusionRModel: 0,
    // todo should be != 0
    support_lenght: 0,
    supportRModel: 0,
    base_lenght: 0,
    // todo should be != 0
    rotation_cutModel: 0,
    stlFileGuid: ""
  };
}
function b2t() {
  return {
    name: "",
    filename: "",
    manufacturerName: "",
    modelName: "",
    color: "",
    guid: "",
    stlFile: {
      fileName: "",
      data: new Int8Array(),
      fileSize: 0
    }
  };
}
function EDt() {
  return {
    ...MC(),
    ...m2t(),
    ...p2t(),
    origin: [0, 0, 0],
    normal: [0, 0, 1],
    tangent: [0, 1, 0],
    viewUp: [1, 0, 0],
    pinInfo: b2t()
  };
}
function UT() {
  return {
    ...MC(),
    origin: [0, 0, 0],
    normal: [0, 0, 1],
    tangent: [0, 1, 0],
    viewUp: [1, 0, 0],
    isTextureConverted: 0,
    storedOrigin: [0, 0, 0],
    storedNormal: [0, 0, 1],
    storedViewUp: [1, 0, 0],
    registrationMatrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    registrationMatrixInverse: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
    diameter: 0,
    diameter2: 0,
    height: 0,
    implantInfo: {
      objectName: "",
      displayText: "",
      objectType: Yt._STL_OBJECT,
      objectSubType: Yt._STL_OBJECT,
      name: "",
      manufacturerName: "",
      implantFileName: "",
      implantOriginalName: "",
      modelName: "",
      sameManufacturerImplants: "",
      guid: "",
      sellingCode: "",
      orientation: 0,
      implantConnectorHeight: 0,
      diameter: 0,
      length: 0,
      color: 0,
      nonSymmetric: 0,
      fileSha: "",
      connectionSides: 0,
      stlFile: {
        fileName: "",
        data: new Int8Array(),
        fileSize: 0
      },
      plyFilename: "",
      stlSuffix: ""
    },
    rotation: 0,
    implantType: 1,
    cadType: -1,
    cadToothInfoOrderNumber: -1,
    cadToothInfoType: 0,
    cadCorrespondenceId: -1,
    cadReconstructionTypeId: -1,
    toothPosition: "",
    trackingType: 0,
    abutmentColor: [255, 170, 0, 255],
    secScanAbutmentColor: [255, 170, 0, 255],
    scanAbutmentColor: [255, 170, 0, 255],
    secAbutmentColor: [255, 170, 0, 255]
  };
}
var xo = /* @__PURE__ */ ((i) => (i[i.MAXILLA = 1] = "MAXILLA", i[i._0 = 0] = "_0", i[i.MANDIBLE = -1] = "MANDIBLE", i))(xo || {}), on = /* @__PURE__ */ ((i) => (i[i.PRIMARY = 0] = "PRIMARY", i[i.SECONDARY = 1] = "SECONDARY", i[i.TERTIARY = 2] = "TERTIARY", i[i.QUATERNARY = 3] = "QUATERNARY", i))(on || {}), sn = /* @__PURE__ */ ((i) => (i[i.NONE = 0] = "NONE", i[i.PICKER = 1] = "PICKER", i[i.BRUSH = 2] = "BRUSH", i[i.CPR = 3] = "CPR", i[i.NERVE = 4] = "NERVE", i[i.POLYGON_PICKER = 5] = "POLYGON_PICKER", i[i.CROPPING = 6] = "CROPPING", i[i.SCULPTING = 7] = "SCULPTING", i[i.MATCHING_TOOL = 8] = "MATCHING_TOOL", i))(sn || {});
class Ja {
  constructor() {
    S(this, "layer", 0);
    S(this, "type", 0);
    S(this, "supportsUndo", !1);
  }
  callFunction(t) {
    console.log("Base Tool Call Function", t);
  }
}
const f2t = /* @__PURE__ */ Ne({
  __name: "TextLabel",
  props: {
    label: {},
    fontSizePx: {},
    cssColor: {},
    textShadow: {}
  },
  setup(i) {
    const e = Le(i.label);
    return (n, s) => (Mt(), Ot("div", {
      style: xe({
        position: "absolute",
        left: K(e)[1][0] + "px",
        top: K(e)[1][1] + "px",
        fontSize: i.fontSizePx + "px",
        color: i.cssColor,
        textShadow: i.textShadow
      }),
      class: "label"
    }, pe(K(e)[0]), 5));
  }
}), g2t = /* @__PURE__ */ Dn(f2t, [["__scopeId", "data-v-d947f5d6"]]);
class pJ {
  constructor(t, e) {
    S(this, "pItem");
    S(this, "rectData", Ie.newInstance());
    S(this, "rectActor", Re.newInstance());
    S(this, "rectMapper", Ue.newInstance());
    S(this, "rectPoints", yi.newInstance());
    S(this, "rectFaces", Ii.newInstance());
    S(this, "angleString");
    S(this, "textLabel");
    S(this, "overlayComponents");
    S(this, "context");
    S(this, "A", I.fromValues(0, 0, 0));
    S(this, "B", I.fromValues(0, 0, 0));
    S(this, "C", I.fromValues(0, 0, 0));
    S(this, "color", [1, 1, 0]);
    this.pItem = null, this.context = t, this.rectMapper.setInputData(this.rectData), this.rectActor.setMapper(this.rectMapper), this.rectActor.getProperty().setColor(this.color[0], this.color[1], this.color[2]), this.rectActor.setPickable(!1), this.rectActor.setVisibility(!0), this.rectActor.getProperty().setOpacity(0.3);
  }
  delete() {
    var t, e;
    this.rectPoints.delete(), this.rectFaces.delete(), this.rectData.delete(), this.rectMapper.delete(), this.rectActor.delete(), (t = this.textLabel) == null || t.remove(), (e = this.overlayComponents) == null || e.cleanup();
  }
  setItem(t) {
    this.pItem = t;
  }
  setPoints(t, e, n) {
    this.A = t, this.B = e, this.C = n;
  }
  setColor(t) {
    this.color = t;
  }
  OnViewWidget(t, e) {
    var n, s, r, a;
    if ((n = this.textLabel) == null || n.setEnabled(!1), e == me.eVE_DESTROY)
      t.removeActor(this.rectActor), (s = this.textLabel) == null || s.setEnabled(!1), (r = this.textLabel) == null || r.remove(), (a = this.overlayComponents) == null || a.cleanup();
    else {
      if (t.addActor(this.rectActor, 1), !this.overlayComponents) {
        const o = "white", l = "1px 1px 2px black";
        this.angleString = new qt(["90", [100, 100]]), this.overlayComponents = Pi(t.getOverlayContainer()), this.textLabel = this.overlayComponents.createVueOverlayComponent(g2t, {
          label: this.angleString,
          fontSizePx: 20,
          cssColor: o,
          textShadow: l
        });
      }
      this.update(t);
    }
  }
  update(t) {
    if (console.log("Cross Angle update", t.getViewMode()), this.pItem) {
      const e = I.fromValues(0, 0, 0), n = I.fromValues(0, 0, 0), s = I.fromValues(0, 0, 0), r = this.pItem.getBounds(), a = 0, o = r[5] - r[4], l = this.pItem.getPosition(), c = this.pItem.getNormal(), u = t.getViewup();
      I.normalize(c, c);
      for (let d = 0; d < 3; d++)
        n[d] = l[d] - a / 2 * c[d], e[d] = n[d] + (o + a) * c[d], s[d] = n[d] + (a + o) * u[d];
      this.Arc(e, n, s, o, 45, t);
    } else
      this.rectActor.getProperty().setColor(this.color[0], this.color[1], this.color[2]), this.Arc(this.A, this.B, this.C, 20, 45, t);
  }
  Arc(t, e, n, s, r, a) {
    var f, T;
    const o = I.fromValues(0, 0, 0), l = I.fromValues(0, 0, 0), c = I.fromValues(0, 0, 0);
    I.subtract(o, t, e), I.subtract(l, n, e), I.normalize(o, o), I.normalize(l, l), I.cross(c, o, l), I.normalize(c, c);
    const u = I.angle(o, l), d = I.fromValues(0, 0, 0);
    for (let M = 0; M < 3; M++)
      d[M] = (2 * e[M] + s / 2 * (o[M] + l[M])) / 2;
    const h = a.worldToViewV3(d);
    (f = this.textLabel) == null || f.setEnabled(!0);
    const p = Math.floor(u * 180 / 3.14) + "°";
    (T = this.angleString) == null || T.set([p, [h[0], h[1]]]);
    const m = u / r, b = r + 2, y = new Float32Array(3 * b), Z = new Uint16Array(b + 2);
    Z[0] = b + 1, Z[Z[0]] = 0;
    for (let M = 0; M < Z[0]; M++)
      Z[M + 1] = M;
    for (let M = 0; M < 3; M++)
      y[M] = e[M];
    const g = ut.create();
    ut.fromRotation(g, m, c);
    for (let M = 0; M <= r; M++) {
      I.normalize(o, o);
      for (let N = 0; N < 3; N++)
        y[3 * (M + 1) + N] = e[N] + s * o[N];
      I.transformMat4(o, o, g);
    }
    this.rectPoints.setData(y, 3), this.rectFaces.setData(Z), this.rectData.setPoints(this.rectPoints), this.rectData.setPolys(this.rectFaces), this.rectData.modified();
  }
}
var td = /* @__PURE__ */ ((i) => (i[i.NONE = 0] = "NONE", i[i.MOVE = 1] = "MOVE", i[i.ROTATE = 2] = "ROTATE", i[i.SLIDE = 3] = "SLIDE", i[i.THICKNESS = 4] = "THICKNESS", i[i.CPR = 5] = "CPR", i))(td || {});
class y2t extends Ja {
  constructor(e) {
    super();
    S(this, "scoutView", null);
    //  set in mouseOn in case SLIDE
    S(this, "currentView", null);
    //  set in mouseOn in case SLIDE
    S(this, "crossAngle", new qt(0));
    // dental cross angle
    S(this, "viewUpAngle", new qt(0));
    S(this, "tangentAngle", 0);
    S(this, "crossRep", /* @__PURE__ */ new Map());
    S(this, "MultiCrossRep", /* @__PURE__ */ new Map());
    S(this, "MIPRep", /* @__PURE__ */ new Map());
    S(this, "CPRRep", /* @__PURE__ */ new Map());
    S(this, "ScoutPlanesRep", /* @__PURE__ */ new Map());
    S(this, "CrossAngleRep", /* @__PURE__ */ new Map());
    S(this, "context");
    S(this, "bLeftDown", !1);
    S(this, "bRightDown", !1);
    S(this, "bMiddleDown", !1);
    S(this, "IMode", 0);
    S(this, "startP3", I.create());
    S(this, "endP3", I.create());
    S(this, "startP2", I.create());
    S(this, "endP2", I.create());
    S(this, "CrossAngleP1", I.create());
    S(this, "CrossAngleP2", I.create());
    S(this, "fixed2DSize", 50);
    S(this, "scoutDisplayMode", 0);
    S(this, "hideCrossIndicators", !1);
    this.context = e;
  }
  delete() {
  }
  // callData position in dispaly coordinates
  onLeftPress(e, n) {
    var s;
    if (!e.isViewMode3D()) {
      if ((s = this.context.getViewWidget(Nt._STL_3D_PREVIEW)) != null && s.isVisible())
        return !1;
      this.context.objects.unSelectObject() && this.viewUpAngle.set(0), this.bLeftDown = !0;
      const r = e.displayToView(n.position.x, n.position.y);
      if (this.startP2 = I.fromValues(r[0], r[1], 0), this.startP3 = e.viewToWorldV3(this.startP2), this.IMode = this.mouseOver([this.startP2[0], this.startP2[1]], e), this.IMode == 2) {
        if (this.scoutView) {
          const a = I.create();
          return I.cross(a, e.getNormal(), this.scoutView.getNormal()), I.scaleAndAdd(this.CrossAngleP1, this.scoutView.getOrigin(), a, 100), I.scaleAndAdd(this.CrossAngleP2, this.scoutView.getOrigin(), a, 100), this.currentView = e, !0;
        }
        return e.setCursor(this.IMode), !0;
      } else {
        if (this.IMode == 3)
          return e.setCursor(this.IMode), !0;
        if (this.IMode == 4)
          return e.setCursor(this.IMode), !0;
        if (this.IMode == 5)
          return this.snapToCPR(this.startP3, e), e.setCursor(this.IMode), !0;
        this.setCenter(this.startP3, e), this.IMode = 1;
      }
      e.setCursor(this.IMode);
    }
    return !1;
  }
  // callData position in dispaly coordinates
  onMouseMove(e, n) {
    var s;
    if (!e.isViewMode3D()) {
      const r = e.displayToView(n.position.x, n.position.y);
      if (this.endP2 = I.fromValues(r[0], r[1], 0), this.endP3 = e.viewToWorldV3(this.endP2), this.bLeftDown)
        if (e.setCursor(this.IMode), this.IMode == 2)
          if (e.getViewMode() == Nt.CPR) {
            const a = e.worldToViewV3(e.getOrigin()), o = kL(this.endP2, this.startP2, I.fromValues(a[0], a[1], 0), I.fromValues(0, 0, 1));
            return this.Rotate(e, o, e.getNormal()), this.startP2 = this.endP2, !0;
          } else {
            const a = kL(this.startP3, this.endP3, e.getOrigin(), e.getNormal());
            return this.Rotate(e, a, e.getNormal()), this.startP3 = this.endP3, !0;
          }
        else if (this.IMode == 3) {
          const a = I.create();
          I.subtract(a, this.endP3, this.startP3);
          let o = I.length(a);
          this.startP3 = this.endP3;
          const l = e.getOrigin();
          if (this.scoutView) {
            const c = I.create();
            return I.cross(c, e.getNormal(), this.scoutView.getNormal()), o *= Math.sign(I.dot(a, this.scoutView.getNormal())), I.scaleAndAdd(l, e.getOrigin(), (s = this.scoutView) == null ? void 0 : s.getNormal(), o), this.setCenter(l, e), !0;
          }
        } else {
          if (this.IMode == 1)
            return this.setCenter(this.endP3, e), !0;
          if (this.IMode == 5)
            return this.snapToCPR(this.endP3, e);
          if (this.IMode == 4)
            return this.setThickness(this.endP3, e), this.startP3 = this.endP3, !0;
        }
      else {
        const a = this.mouseOver([this.endP2[0], this.endP2[1]], e);
        a == 2 ? e.setCursor(
          2
          /* ROTATE */
        ) : a == 3 ? e.setCursor(
          3
          /* SLIDE */
        ) : a == 5 ? e.setCursor(
          5
          /* CPR */
        ) : a == 4 ? e.setCursor(
          4
          /* THICKNESS */
        ) : e.setCursor(
          0
          /* NONE */
        );
      }
    }
    return !1;
  }
  onLeftRelease(e) {
    var n;
    return e.isViewMode3D() || (this.bLeftDown = !1, this.scoutView = null, this.currentView = null, (n = this.CrossAngleRep.get(e)) == null || n.OnViewWidget(e, me.eVE_DESTROY), this.IMode == 2 && e.sceneRepaint(), this.IMode = 0), !1;
  }
  onMouseWheel(e, n) {
    var r;
    if (!Number.isFinite(n.spinY) || n.spinY === 0)
      return !1;
    const s = Math.sign(n.spinY);
    if (!e.isViewMode3D() && e.getFilterMode() != Je.SCOUT)
      if (e.getViewMode() == Nt.CPR) {
        const a = this.context.getViewWidget(Nt.CPR);
        if (a) {
          const o = this.context.curveDelta.get().value - s;
          return a.shiftCurve(o);
        }
        return !1;
      } else if (e.getViewMode() == Nt.CROSS) {
        const a = this.context.getViewWidget(Nt.CPR), o = -s;
        if (a) {
          if ((r = this.context.getViewWidget(Nt._STL_3D_PREVIEW)) != null && r.isVisible()) {
            const l = this.context.objects.selectedObject.get();
            if (l && l.type == Yt._IMPLANT)
              return l.moveInTangentDirection(o), !0;
          }
          a.slide(o);
        }
      } else {
        const a = e.getDirectionalSpacing(), o = e.getOrigin();
        return I.scaleAndAdd(o, o, e.getNormal(), a * -s), this.setCenter(o, e), !0;
      }
    return !1;
  }
  // public override getCursor(){ return this.cursor}
  showAngleOn(e) {
    return e.getViewMode() == Nt.AXIAL || e.getViewMode() == Nt.CORONAL || e.getViewMode() == Nt.SAGITTAL;
  }
  onViewWidgetEvent(e, n) {
    var s, r, a, o, l, c, u, d, h, p, m, b, y, Z, g;
    this.hideCrossIndicators && (n = me.eVE_DESTROY), n == me.eVE_DESTROY ? ((s = this.crossRep.get(e)) == null || s.OnViewWidget(e, n), (r = this.MultiCrossRep.get(e)) == null || r.OnViewWidget(e, n), (a = this.MIPRep.get(e)) == null || a.OnViewWidget(e, n), (o = this.CPRRep.get(e)) == null || o.OnViewWidget(e, n), (l = this.ScoutPlanesRep.get(e)) == null || l.OnViewWidget(e, n), (c = this.CrossAngleRep.get(e)) == null || c.OnViewWidget(e, n)) : (this.crossRep.get(e) || this.crossRep.set(e, new qyt(this)), this.MultiCrossRep.get(e) || this.MultiCrossRep.set(e, new t2t(this)), this.MIPRep.get(e) || this.MIPRep.set(e, new n2t(this)), this.CPRRep.get(e) || this.CPRRep.set(e, new d2t(this)), e.getViewMode() == Nt._3D && (this.ScoutPlanesRep.get(e) || this.ScoutPlanesRep.set(e, new e2t(this))), this.IMode == 2 && this.currentView == e && this.scoutView && this.showAngleOn(e) ? (this.CrossAngleRep.get(e) || this.CrossAngleRep.set(e, new pJ(this.context, e)), (u = this.CrossAngleRep.get(e)) == null || u.setPoints(this.CrossAngleP1, this.scoutView.getOrigin(), this.CrossAngleP2), (d = this.CrossAngleRep.get(e)) == null || d.setColor(this.scoutView.color), (h = this.CrossAngleRep.get(e)) == null || h.OnViewWidget(e, n)) : (p = this.CrossAngleRep.get(e)) == null || p.OnViewWidget(e, me.eVE_DESTROY), (m = this.crossRep.get(e)) == null || m.OnViewWidget(e, n), (b = this.MultiCrossRep.get(e)) == null || b.OnViewWidget(e, n), (y = this.MIPRep.get(e)) == null || y.OnViewWidget(e, n), (Z = this.CPRRep.get(e)) == null || Z.OnViewWidget(e, n), (g = this.ScoutPlanesRep.get(e)) == null || g.OnViewWidget(e, n));
  }
  snapToCPR(e, n) {
    const s = this.context.getViewWidget(Nt.CPR);
    if (s) {
      const r = this.context.objects.CPRCurve.splineVec, o = ea(r, this.endP3).nearestIndex, l = I.fromValues(0, 0, 0);
      return Fs(this.context.objects.CPRCurve.splineVec[o], n.getOrigin(), n.getNormal(), l), this.setCenter(l, s), !0;
    }
    return !1;
  }
  // P = view position
  mouseOver(e, n) {
    var o, l;
    const s = (o = this.MIPRep.get(n)) == null ? void 0 : o.mouseOver(e, n);
    if (s == 4)
      return s;
    const r = (l = this.CPRRep.get(n)) == null ? void 0 : l.mouseOver(e, n);
    if (r == 5)
      return r;
    const a = this.context.getPresenterWindows();
    for (let c = 0; c < a.length; c++) {
      const u = a[c].getMainView();
      if (u != null && u.isVisible() && !u.isViewMode3D() && u.getViewMode() != Nt.CPR && n != u && !n.isViewMode3D() && !n.isCrossSection) {
        let d = this.getActionPoint(n, u, this.fixed2DSize);
        const h = this.getActionPoint(n, u, 0);
        if (n.getViewMode() == Nt.CPR && d && h) {
          const p = Math.abs(d[0][1] - h[0][1]);
          d = this.getActionPoint(n, u, this.fixed2DSize * this.fixed2DSize / p / 2 * 3);
        }
        if (d && (this.onPoint2D(d[0], e) || this.onPoint2D(d[1], e)))
          return this.scoutView = u, 2;
        if (h && (this.onPoint2D(h[0], e) || this.onPoint2D(h[1], e)))
          return this.scoutView = u, 3;
      }
    }
    return 0;
  }
  onPoint2D(e, n) {
    return (e[0] - n[0]) * (e[0] - n[0]) + (e[1] - n[1]) * (e[1] - n[1]) < 400;
  }
  onLine2D(e, n, s) {
    const a = Math.abs(e[0] * (n[1] - s[1]) + n[0] * (s[1] - e[1]) + s[0] * (e[1] - n[1])), o = Fi.create();
    Fi.subtract(o, n, e);
    const l = Fi.length(o);
    if (l > Number.EPSILON) {
      const c = 2 * a / l;
      return s[0] < Math.max(e[0], n[0]) + 20 && s[0] > Math.min(e[0], n[0]) - 20 && s[1] < Math.max(e[1], n[1]) + 20 && s[1] > Math.min(e[1], n[1]) - 20 ? c < 20 : !1;
    } else return !1;
  }
  /** substract edge points by offset */
  getActionPoint(e, n, s, r = 0) {
    const a = this.getEdgePoint(e, n, r);
    if (a) {
      const o = Fi.create();
      Fi.subtract(o, a[1], a[0]), Fi.normalize(o, o);
      for (let l = 0; l < 2; l++)
        a[0][l] += s * o[l], a[1][l] -= s * o[l];
    }
    return a;
  }
  /** get 3D points at the edge of the view */
  getEdgePoint3D(e, n, s) {
    let r = I.create();
    I.cross(r, n.getNormal(), e.getNormal());
    const a = bbt(r, n.getOrigin(), e.getBounds());
    if (e.getViewMode() == Nt._3D)
      I.scaleAndAdd(a[0], n.getOrigin(), n.getNormal(), -100), I.scaleAndAdd(a[1], n.getOrigin(), n.getNormal(), 100), r = I.clone(n.getNormal());
    else {
      const o = this.context.toolManager.coordControl.getEdgePoint(e, n, s);
      o && (e.getViewMode() == Nt.CPR ? (a[0] = e.viewToWorldV33(I.fromValues(o[0][0], o[0][1], 0)), a[1] = e.viewToWorldV33(I.fromValues(o[1][0], o[1][1], 0)), Fs(a[0], I.fromValues(0, 0, 0), I.fromValues(0, 1, 0), a[0]), Fs(a[1], I.fromValues(0, 0, 0), I.fromValues(0, 1, 0), a[1])) : (a[0] = e.viewToWorldV3(I.fromValues(o[0][0], o[0][1], 0)), a[1] = e.viewToWorldV3(I.fromValues(o[1][0], o[1][1], 0)), Fs(a[0], e.getOrigin(), e.getNormal(), a[0]), Fs(a[1], e.getOrigin(), e.getNormal(), a[1])));
    }
    return a;
  }
  /** get 2D points at the edge of the view */
  getEdgePoint(e, n, s) {
    if (e.getViewMode() == Nt.CPR) {
      const [r, a] = e.state.viewSize.get(), o = n.getOrigin();
      s && I.scaleAndAdd(o, n.getOrigin(), n.getNormal(), s);
      const l = e.worldToViewV3(o), c = Fi.create();
      if (n.getViewMode() == Nt.CROSS) {
        const u = Fi.fromValues(Math.cos(Math.PI / 2 - this.crossAngle.get()), Math.sin(Math.PI / 2 - this.crossAngle.get()));
        Fi.scaleAndAdd(c, l, u, 100);
      } else if (n.getViewMode() == Nt.AXIAL) {
        const u = Fi.fromValues(1, 0);
        Fi.scaleAndAdd(c, l, u, 100);
      }
      return Z5(l, c, zn.fromValues(0, 0, r, a));
    } else {
      const a = I.create(), o = I.create(), l = n.getOrigin();
      I.cross(o, n.getNormal(), e.getNormal()), I.normalize(o, o), s && I.scaleAndAdd(l, n.getOrigin(), n.getNormal(), s), Fs(l, e.getOrigin(), e.getNormal(), l), I.scaleAndAdd(a, l, o, 100);
      const c = e.worldToViewV3(a), u = e.worldToViewV3(l), [d, h] = e.state.viewSize.get();
      return Z5(c, u, zn.fromValues(0, 0, d, h));
    }
  }
  resetCPRParams() {
    this.crossAngle.set(0), this.viewUpAngle.set(0), this.tangentAngle = 0;
  }
  getRealGuideImplantUpDirection(e) {
    const n = e.getNormal(), s = I.fromValues(0, 0, 1);
    return I.dot(n, s) > 0 && I.negate(n, n), n;
  }
  /*! Resolve CPR view-up rotation mode and axis from selected object (none/implant/pin). */
  getCprViewUpRotationModeAndAxis() {
    const e = I.fromValues(0, 0, 1), n = this.context.objects.selectedObject.get();
    return n ? n.type === Yt._PIN ? (I.copy(e, n.getNormal()), { mode: 2, axis: e }) : n.type === Yt._IMPLANT ? { mode: 1, axis: this.getRealGuideImplantUpDirection(n) } : { mode: 0, axis: e } : { mode: 0, axis: e };
  }
  getCprSplineVectors(e, n, s, r) {
    const a = this.context.objects.CPRCurve.splineVec, o = this.context.objects.CPRCurve.splineTangents, l = this.context.objects.CPRCurve.splineBinormals, c = this.context.objects.CPRCurve.splineNormals;
    if (a.length === 0 || o.length === 0 || l.length === 0 || c.length === 0)
      return { t: I.clone(n), b: I.clone(s), n: I.clone(r) };
    const u = ea(a, e).nearestIndex;
    return u < 0 || u >= o.length || u >= l.length || u >= c.length ? { t: I.clone(n), b: I.clone(s), n: I.clone(r) } : {
      t: I.clone(o[u]),
      b: I.clone(l[u]),
      n: I.clone(c[u])
    };
  }
  getRealGuideCprCrossFrame(e, n, s, r) {
    const a = this.getCprSplineVectors(e, n, s, r), o = I.clone(a.n), l = I.clone(a.b), c = I.clone(a.t), u = SP(o, c);
    return {
      normal: u.tt,
      viewUp: l,
      tangent: u.nn,
      blOrientation: u.sign
    };
  }
  rotateCprCrossFrame(e, n, s) {
    if (!Number.isFinite(n) || Math.abs(n) <= Number.EPSILON)
      return;
    const r = I.clone(s);
    if (I.length(r) <= Number.EPSILON)
      return;
    I.normalize(r, r);
    const a = ut.create();
    VP(r, n, a), bN(e.normal, a), bN(e.viewUp, a), bN(e.tangent, a);
  }
  buildViewMatrixFromWidgetFrame(e, n) {
    const s = ut.create();
    return ut.set(
      s,
      n.tangent[0],
      n.tangent[1],
      n.tangent[2],
      0,
      n.viewUp[0],
      n.viewUp[1],
      n.viewUp[2],
      0,
      n.normal[0],
      n.normal[1],
      n.normal[2],
      0,
      e[0],
      e[1],
      e[2],
      1
    ), s;
  }
  buildRealGuideCprCrossMatrix(e, n, s, r) {
    const a = this.getRealGuideCprCrossFrame(e, n, s, r), { mode: o, axis: l } = this.getCprViewUpRotationModeAndAxis();
    o === 2 && I.negate(a.normal, a.normal);
    const c = o === 2 ? 0 : this.crossAngle.get(), u = -a.blOrientation * c;
    o !== 2 && this.rotateCprCrossFrame(a, u, a.tangent);
    const d = a.blOrientation * this.viewUpAngle.get(), h = o === 0 ? a.viewUp : l;
    return this.rotateCprCrossFrame(a, d, h), this.buildViewMatrixFromWidgetFrame(e, a);
  }
  /*! \params o point in 3D \parms t,b,n, cpr curve vectors \params csAngle crosssection angle*/
  setCPRCenter(e, n, s, r) {
    const a = this.crossAngle.get(), o = this.tangentAngle, l = this.viewUpAngle.get(), { mode: c, axis: u } = this.getCprViewUpRotationModeAndAxis(), h = this.getRealGuideCprCrossFrame(e, n, s, r).blOrientation * l, p = c === 2 ? 0 : a, m = c === 2 ? 0 : o, b = this.context.getPresenterWindows(), y = this.context.objects.selectedObject.get();
    b.forEach((Z) => {
      const g = Z.getMainView();
      if ((g == null ? void 0 : g.getViewMode()) == Nt.CROSS || (g == null ? void 0 : g.getViewMode()) == Nt.CORONAL) {
        if (g.getViewMode() == Nt.CROSS)
          Z.setViewMatrix(this.buildRealGuideCprCrossMatrix(e, n, s, r));
        else {
          const f = [0, 0, -1], T = I.create();
          I.negate(T, n), c === 2 && I.scale(T, T, -1), Z.setViewMatrix(qc(e, T, f, r, p, u, h));
        }
        g.panToPosition3D(g.getOrigin());
      }
      if ((g == null ? void 0 : g.getViewMode()) == Nt.TANGENT || (g == null ? void 0 : g.getViewMode()) == Nt.SAGITTAL) {
        const f = I.create();
        I.negate(f, r);
        const T = [0, 0, -1];
        Z.setViewMatrix(qc(e, f, T, n, m, u, h)), g.panToPosition3D(g.getOrigin());
      }
      if ((g == null ? void 0 : g.getViewMode()) == Nt.AXIAL) {
        const f = [0, 1, 0], T = I.create();
        I.set(T, s[0], s[1], s[2]), this.context.CPRType == xo.MAXILLA && I.scale(T, T, -1), y && (y.type == Yt._IMPLANT || y.type == Yt._PIN) && (I.dot(T, y.getNormal()) < 0 ? I.scale(T, y.getNormal(), -1) : I.copy(T, y.getNormal())), Z.setViewMatrix(qc(e, T, f));
      }
      Z.setSliceInfoNormal();
    }), this.context.sceneRepaint();
  }
  setThickness(e, n) {
    var r;
    const s = (r = this.MIPRep.get(n)) == null ? void 0 : r.getScoutView();
    if (s) {
      let a = s[0].getFilterThickness();
      const o = s[0].getNormal(), l = I.create();
      I.subtract(l, this.endP3, this.startP3), a += s[1] * 2 * I.dot(o, l), !s[0].isViewMode3D() && s[0].getViewMode() != Nt.CPR && s[0].getPresenterWindow().setThicknessFcn(a), this.setCenter(s[0].getOrigin());
    }
  }
  /*! \sa setCPRCenter*/
  setCenter(e, n, s) {
    var a;
    const r = this.context.getViewWidget(Nt.CPR);
    if (!((n == null ? void 0 : n.getViewMode()) == Nt.CPR && !this.context.objects.hasCPR()))
      if (r && (n == r && !this.context.cprSettings || n != null && n.isViewMode3D() && this.context.layoutManager.layoutContainsCpr(this.context.getLayout())))
        r.setViewOrigin(e), this.setCPRCenter(e, r.getTangent(), r.getViewup(), r.getNormal());
      else {
        if (s) {
          const o = this.context.getPresenterWindows();
          for (const l of o)
            if (!((a = l.getMainView()) != null && a.isViewMode3D()) && s == l.getMainView()) {
              l.setViewOrigin(e);
              return;
            }
        } else
          this.context.getPresenterWindows().forEach((l) => {
            var c;
            (c = l.getMainView()) != null && c.isViewMode3D() || l.setViewOrigin(e);
          });
        r && r.updateCrossSliceIndicator(), this.context.sceneRepaint();
      }
  }
  Rotate(e, n, s) {
    var r, a;
    if (e.getViewMode() == Nt.CPR) {
      this.crossAngle.update((l) => (l += n, l));
      const o = this.context.getViewWidget(Nt.CROSS);
      o && ((r = o.getPresenterWindow()) == null || r.setViewMatrix(this.buildRealGuideCprCrossMatrix(e.getOrigin(), e.getTangent(), e.getViewup(), e.getNormal()))), e.updateCrossSliceIndicator();
    } else {
      if (this.context.cprSettings && ((a = this.context.toolManager.cprTool) != null && a.getByPointsEnabled())) {
        const l = this.context.getViewWidget(Nt.CPR);
        l && l.rotateOwner();
      }
      this.context.getPresenterWindows().forEach((l) => {
        var c;
        (c = l.getMainView()) != null && c.isViewMode3D() || e.getPresenterWindow() != l && l.rotateView(n, s), l.setSliceInfoNormal();
      });
    }
    if (this.scoutView) {
      const o = I.create();
      I.cross(o, e.getNormal(), this.scoutView.getNormal()), I.scaleAndAdd(this.CrossAngleP2, this.scoutView.getOrigin(), o, 100);
    }
    this.context.sceneRepaint();
  }
  /**stllib stuff for positioning implnants and pins*/
  getObjectPos(e = Yt._NONE) {
    const n = this.context.getPresenterWindows();
    let s = I.create();
    return I.set(s, 0, 0, 0), n.forEach((r) => {
      const a = r.getMainView();
      ((a == null ? void 0 : a.getViewMode()) == Nt.CORONAL || (a == null ? void 0 : a.getViewMode()) == Nt.CROSS) && (s = a == null ? void 0 : a.getOrigin());
    }), s;
  }
  getObjectViewup(e = Yt._NONE) {
    let n = this.context.getViewWidget(Nt.CROSS);
    if ((!n || !n.isVisible()) && (n = this.context.getViewWidget(Nt.SAGITTAL)), n) {
      if (e == Yt._PIN)
        return n.getViewup();
      {
        const s = I.create();
        return I.negate(s, n.getTangent());
      }
    } else
      return console.log("getObjectViewup: Missing corrsection image"), [0, 0, 1];
  }
  getObjectDir(e = Yt._NONE) {
    let n = this.context.getViewWidget(Nt.CROSS);
    (!n || !n.isVisible()) && (n = this.context.getViewWidget(Nt.SAGITTAL));
    const s = this.context.CPRType;
    if (n) {
      if (e == Yt._PIN)
        return n.getTangent();
      if (s == xo.MAXILLA)
        return console.log("maxila"), n.getViewup();
      {
        console.log("mandibla");
        const r = I.create();
        return I.negate(r, n.getViewup()), r;
      }
    } else
      return console.log("getObjectDir: Missing corrsection image"), [0, 0, 1];
  }
  snapToObject(e, n, s, r, a) {
    var o;
    if (a == Yt._IMPLANT) {
      const l = this.context.getPresenterWindows(), c = this.context.getViewWidget(Nt.CPR);
      if (c && c.isVisible() && !this.context.cprSettings || c && ((o = this.context.getViewWidget(Nt._STL_3D_PREVIEW)) != null && o.isVisible()))
        c.setViewOrigin(e), this.crossAngle.set(this.context.CPRMath.getCrossAngle(n, e)), this.tangentAngle = this.context.CPRMath.getTangentAngle(n, e), this.setCPRCenter(c.getOrigin(), c.getTangent(), n, c.getNormal());
      else {
        const u = this.context.settings.general.snapToImplant;
        l.forEach((d) => {
          const h = d.getMainView();
          if ((h == null ? void 0 : h.getViewMode()) == Nt.TANGENT || (h == null ? void 0 : h.getViewMode()) == Nt.CORONAL) {
            const p = [0, 0, -1], m = I.create();
            I.set(m, s[0], s[1], s[2]), (h == null ? void 0 : h.getViewMode()) === Nt.CORONAL && !u ? d.setViewOrigin(e) : d.setViewMatrix(qc(e, m, p));
          } else if ((h == null ? void 0 : h.getViewMode()) == Nt.CROSS || (h == null ? void 0 : h.getViewMode()) == Nt.SAGITTAL) {
            const p = [0, 0, -1], m = I.create();
            I.set(m, r[0], r[1], r[2]), (h == null ? void 0 : h.getViewMode()) === Nt.SAGITTAL && !u ? d.setViewOrigin(e) : d.setViewMatrix(qc(e, m, p));
          } else if ((h == null ? void 0 : h.getViewMode()) == Nt.AXIAL) {
            const p = [0, 1, 0], m = I.create();
            I.set(m, n[0], n[1], n[2]), this.context.CPRType == xo.MAXILLA && I.scale(m, m, -1), u ? d.setViewMatrix(qc(e, m, p)) : d.setViewOrigin(e);
          } else (h == null ? void 0 : h.getViewMode()) == Nt.CPR;
          d.setSliceInfoNormal();
        }), this.context.sceneRepaint();
      }
    } else a == Yt._PIN && (this.context.getPresenterWindows().forEach((c) => {
      const u = c.getMainView();
      if ((u == null ? void 0 : u.getViewMode()) == Nt.CROSS || (u == null ? void 0 : u.getViewMode()) == Nt.SAGITTAL) {
        const d = [0, 0, -1], h = I.create();
        I.set(h, s[0], s[1], s[2]), c.setViewMatrix(qc(e, h, d));
      }
      if ((u == null ? void 0 : u.getViewMode()) == Nt.TANGENT || (u == null ? void 0 : u.getViewMode()) == Nt.CORONAL) {
        const d = [0, 0, -1], h = I.create();
        I.set(h, -n[0], -n[1], -n[2]), c.setViewMatrix(qc(e, h, d));
      }
      if ((u == null ? void 0 : u.getViewMode()) == Nt.AXIAL) {
        const d = [0, 1, 0], h = I.create();
        I.set(h, -r[0], -r[1], -r[2]), c.setViewMatrix(qc(e, h, d));
      }
      c.setSliceInfoNormal();
    }), this.context.sceneRepaint());
    setTimeout(() => {
      this.context.updateObject2DPositionEvent.notify();
    }, 0);
  }
  setScoutDispalyMode(e) {
    this.scoutDisplayMode = e;
  }
  getScoutDispalyMode() {
    return this.scoutDisplayMode;
  }
  set3DViewOrientation(e) {
    const n = [0, 0, 0], s = [0, 0, 0];
    switch (e) {
      case ks.Left:
        s[2] = 1, n[0] = 1;
        break;
      case ks.Right:
        s[2] = 1, n[0] = -1;
        break;
      case ks.Front:
        s[2] = 1, n[1] = -1;
        break;
      case ks.Back:
        s[2] = 1, n[1] = 1;
        break;
      case ks.Top:
        s[1] = 1, n[2] = 1;
        break;
      case ks.Bottom:
        s[1] = -1, n[2] = -1;
        break;
    }
    const r = this.context.getViewWidget(Nt._3D);
    if (r) {
      const o = r.getRenderer().getActiveCamera(), l = o.getFocalPoint(), c = o.getDistance();
      o.setPosition(l[0] + c * n[0], l[1] + c * n[1], l[2] + c * n[2]), o.setViewUp(s), r.cameraModified(), this.context.repaint();
    }
  }
}
class NC {
  constructor() {
    S(this, "delete");
    S(this, "onInitialize");
  }
  /** Estimate of the amount of memory used by this item. (in kB)*/
  getMemory() {
    return 10;
  }
}
class vr extends NC {
  constructor(e) {
    super();
    S(this, "onUndo");
    S(this, "onRedo");
    this.onUndo = e.onUndo, this.onRedo = e.onRedo, this.delete = e.delete, this.onInitialize = e.onInitialize, e.getMemory && (this.getMemory = e.getMemory);
  }
}
var ws = /* @__PURE__ */ ((i) => (i[i.NONE = 0] = "NONE", i[i.SCENE_REPAINT = 1] = "SCENE_REPAINT", i[i.SCENE_REFRESH = 2] = "SCENE_REFRESH", i))(ws || {});
function nz(i, t, e) {
  let n = !1, s = 0, r = i.length;
  for (; s < r; )
    t(i[s]) ? (e && e(i[s]), i.splice(s, 1), r--, n = !0) : s++;
  return n;
}
class Z2t {
  constructor(t, e, n, s) {
    S(this, "undoStack", []);
    S(this, "description");
    S(this, "undoEvent");
    S(this, "resetTool");
    /** Reverse the undo stack after each undo/redo. */
    S(this, "flip");
    /** Called before and after each undo/redo. */
    S(this, "onUndoRedoEvent");
    // in RG this is a std::any that is never set to a value, change the type if this is used in the future
    S(this, "undoRedoEventData");
    this.description = t, this.undoEvent = e, this.resetTool = n, this.flip = s;
  }
  delete() {
    this.undoStack.forEach(([t, e]) => {
      var n;
      (n = e == null ? void 0 : e.delete) == null || n.call(e);
    });
  }
  addFront(t, e) {
    var n;
    this.undoStack.unshift([t, e]), (n = e.onInitialize) == null || n.call(e);
  }
  add(t, e) {
    var n;
    this.undoStack.push([t, e]), (n = e.onInitialize) == null || n.call(e);
  }
  appendStack(t) {
    this.undoStack.push(...t.undoStack);
  }
  async undo() {
    var t, e;
    (t = this.onUndoRedoEvent) == null || t.call(this, 0, this.undoRedoEventData);
    for (const n of this.undoStack) {
      const [, { onUndo: s }] = n;
      await s();
    }
    this.flip && this.undoStack.reverse(), (e = this.onUndoRedoEvent) == null || e.call(this, 1, this.undoRedoEventData);
  }
  async redo() {
    var t, e;
    (t = this.onUndoRedoEvent) == null || t.call(this, 2, this.undoRedoEventData);
    for (const n of this.undoStack) {
      const [, { onRedo: s }] = n;
      await s();
    }
    this.flip && this.undoStack.reverse(), (e = this.onUndoRedoEvent) == null || e.call(this, 3, this.undoRedoEventData);
  }
  exists(t) {
    return this.undoStack.some((e) => e[0] === t);
  }
  revertLast() {
    var t;
    return (t = this.undoStack.pop()) == null ? void 0 : t[1];
  }
  remove(t, e = !1) {
    return nz(this.undoStack, (n) => n[0] === t, e ? ([, { onUndo: n }]) => n() : void 0);
  }
  removeUndoData(t, e = !1) {
    return nz(this.undoStack, ([, n]) => n === t, e ? ([, { onUndo: n }]) => n() : void 0);
  }
  setDescription(t) {
    this.description = t;
  }
  getDescription() {
    return this.description;
  }
  setUndoEvent(t) {
    this.undoEvent = t;
  }
  getUndoEvent() {
    return this.undoEvent;
  }
  setResetTool(t) {
    this.resetTool = t;
  }
  getResetTool() {
    return this.resetTool;
  }
  setFlip(t) {
    this.flip = t;
  }
  setUndoRedoEvent(t) {
    this.onUndoRedoEvent = t;
  }
  getStack() {
    return this.undoStack;
  }
  getMemory() {
    let t = 0;
    for (const [, e] of this.undoStack)
      t += e.getMemory();
    return t;
  }
}
var Nt = /* @__PURE__ */ ((i) => (i[i.SAGITTAL = 0] = "SAGITTAL", i[i.CORONAL = 1] = "CORONAL", i[i.AXIAL = 2] = "AXIAL", i[i.CPR = 3] = "CPR", i[i.CROSS = 4] = "CROSS", i[i.TANGENT = 5] = "TANGENT", i[i._3D = 6] = "_3D", i[i.SECTIONAL_VIEW = 7] = "SECTIONAL_VIEW", i[i.STL3D = 8] = "STL3D", i[i._STL_3D_PREVIEW = 9] = "_STL_3D_PREVIEW", i[i.CAD_3D = 10] = "CAD_3D", i))(Nt || {}), me = /* @__PURE__ */ ((i) => (i[i.eVE_SHOW = 0] = "eVE_SHOW", i[i.eVE_HIDE = 1] = "eVE_HIDE", i[i.eVE_RENDER = 2] = "eVE_RENDER", i[i.eVE_DESTROY = 3] = "eVE_DESTROY", i))(me || {}), Je = /* @__PURE__ */ ((i) => (i[i.MPR = 0] = "MPR", i[i.MIP = 1] = "MIP", i[i.RAYSUM = 2] = "RAYSUM", i[i.MINMIP = 3] = "MINMIP", i[i.SCOUT = 4] = "SCOUT", i[i.CAPTURE_3D = 5] = "CAPTURE_3D", i[i.CAPTURE_MIP = 6] = "CAPTURE_MIP", i[i.CUSTOM_FILTER_0 = 7] = "CUSTOM_FILTER_0", i[i.CUSTOM_FILTER_1 = 8] = "CUSTOM_FILTER_1", i[i.CUSTOM_FILTER_2 = 9] = "CUSTOM_FILTER_2", i[i.CUSTOM_FILTER_3 = 10] = "CUSTOM_FILTER_3", i))(Je || {});
const CW = {
  0: {
    short: "MPR",
    long: "MPR"
  },
  2: {
    short: "RAY",
    long: "Raysum (Thick MPR)"
  },
  1: {
    short: "MIP",
    long: "MIP (Maximum Intensity Projection)"
  },
  3: {
    short: "MIN",
    long: "MIN (Minimum Intensity Projection)"
  },
  4: {
    short: "SCT",
    long: "SCT (Scout Image)"
  },
  5: {
    short: "",
    long: ""
  },
  6: {
    short: "",
    long: ""
  },
  7: {
    short: "TMP1",
    long: "X-ray (Bones)"
  },
  8: {
    short: "TMP2",
    long: "X-ray (Cephalometry)"
  },
  9: {
    short: "TMP3",
    long: "X-ray (User defined 1)"
  },
  10: {
    short: "TMP4",
    long: "X-ray (User defined 2)"
  }
}, T2t = {
  viewport: Ce.fullscreen,
  background: [0.2, 0.3, 0.4],
  color: [255, 255, 255]
};
let M2t = 0;
class op {
  constructor(t, e, n = {}) {
    S(this, "viewMode");
    S(this, "filterMode", 0);
    S(this, "resliceAxes", ut.create());
    // make this "one and only" observable
    S(this, "filterThickness", 0);
    S(this, "id");
    S(this, "color");
    // border/slice color
    S(this, "panZoom_o");
    S(this, "panZoom_Origin");
    S(this, "panZoom_v");
    S(this, "panZoom_ZoomChange");
    S(this, "panZoom_EndZoom");
    S(this, "cursor", null);
    S(this, "viewEventHandler", null);
    S(this, "events", {
      cameraModified: new se(),
      afterSceneRefresh: new se()
    });
    S(this, "renderer");
    S(this, "rendererOverlay");
    S(this, "context");
    S(this, "contextState");
    S(this, "isShown", new qt(!1));
    S(this, "focalSource");
    S(this, "focalMapper");
    S(this, "focalActor");
    S(this, "crossHair", null);
    S(this, "cellPicker");
    S(this, "overlayContainer");
    S(this, "viewSize", new qt([0, 0]));
    S(this, "viewport");
    S(this, "viewObjectPositions", new qt([]));
    S(this, "actorModifiedEvent", new se());
    S(this, "createUndoEvent", new se());
    S(this, "objectPreciseMoveEvent", new se());
    S(this, "stlPreciseMoveEvent", new se());
    S(this, "objectMoveStartEvent", new se());
    S(this, "objectMoveEvent", new se());
    S(this, "objectRotateTopBottomEvent", new se());
    S(this, "objectRotateTopBottomStartEvent", new se());
    S(this, "stlMoveEvent", new se());
    S(this, "stlMoveStartEvent", new se());
    S(this, "stlRotateEvent", new se());
    S(this, "stlRotateStartEvent", new se());
    S(this, "objectSnapEvent", new se());
    S(this, "stlRotationCenterView", new qt(null));
    S(this, "stlRotationCenter", new qo(this.stlRotationCenterView));
    S(this, "onCleanupArray", []);
    S(this, "state");
    S(this, "startUM", ut.create());
    S(this, "startVPos", [0, 0]);
    S(this, "centerOfSTLRotation", [0, 0, 0]);
    S(this, "stlRotationCenterOffset", I.create());
    S(this, "hasCustomStlRotationCenter", !1);
    var u;
    this.viewMode = e, this.id = M2t++, this.context = t, this.contextState = this.context.getState(), ut.identity(this.resliceAxes);
    const s = { ...T2t, ...n };
    this.viewport = new qt(s.viewport), this.color = s.color, this.panZoom_o = [0, 0, 0], this.panZoom_Origin = [0, 0, 0], this.panZoom_v = [0, 0, 0], this.panZoom_ZoomChange = 0, this.panZoom_EndZoom = 0, this.crossHair = new Kyt(), this.state = {
      viewport: new qo(this.viewport),
      viewSize: new qo(this.viewSize),
      isShown: new qo(this.isShown)
    }, this.renderer = ld.newInstance(), this.renderer.setBackground(this.context.viewConfiguration.colors.get().viewBackground), IW(this.renderer, 0);
    const r = this.renderer.getActiveCamera(), a = [0, 0, 0];
    a[1] -= 1, r.setPosition(a[0], a[1], a[2]), r.setDirectionOfProjection(0, 1, 0), r.setFocalPoint(0, 0, 0), r.setViewUp(0, 0, 1), r.setParallelProjection(!0), r.zoom(1), this.rendererOverlay = ld.newInstance(), IW(this.rendererOverlay, 1), this.rendererOverlay.setInteractive(!1), this.rendererOverlay.setActiveCamera(this.renderer.getActiveCamera()), this.rendererOverlay.setLayer(1), this.watch(this.context.viewConfiguration.colors, (d) => {
      this.renderer.setBackground(d.viewBackground), this.sceneRefresh();
    }), this.focalSource = sp.newInstance(), this.focalSource.setRadius(1), this.focalSource.setPhiResolution(50), this.focalSource.setThetaResolution(50), this.focalMapper = Ue.newInstance(), this.focalMapper.setInputConnection(this.focalSource.getOutputPort()), this.focalMapper.setScalarVisibility(!1), this.focalActor = Re.newInstance(), this.focalActor.setMapper(this.focalMapper), this.focalActor.setPickable(!1), this.focalActor.getProperty().setColor(0, 1, 0), this.focalActor.setVisibility(!1), this.renderer.addActor(this.focalActor), this.cellPicker = CU.newInstance(), this.cellPicker.setOpacityThreshold(0.3), this.cellPicker.setPickFromList(1), this.cellPicker.setTolerance(0), this.cellPicker.initializePickList(), this.overlayContainer = new vU(
      this.context.getOverlayContainer(),
      this.viewport,
      this.context.layoutManager.borderWidth,
      this.context.layoutManager.gapWidth
    ), this.isShown.get() ? this.overlayContainer.show() : this.overlayContainer.hide(), this.onCleanup(() => this.overlayContainer.delete), this.updateGapColor(), this.watch(this.context.viewConfiguration.colorScheme, () => {
      this.updateGapColor();
    });
    const { cleanup: o } = Pi(this.overlayContainer.getElement());
    this.onCleanup(() => o());
    const l = (d, h) => {
      const [p, m] = d;
      this.viewSize.set([
        p * (h.xmax - h.xmin) - 2 * this.context.layoutManager.borderWidth - 2 * this.context.layoutManager.gapWidth,
        m * (h.ymax - h.ymin) - 2 * this.context.layoutManager.borderWidth - 2 * this.context.layoutManager.gapWidth
      ]);
    };
    this.watch(this.contextState.canvasSize, (d) => {
      l(d, this.viewport.get());
    }), this.watch(this.viewport, (d) => {
      this.renderer.setViewport(d.xmin, d.ymin, d.xmax, d.ymax), this.rendererOverlay.setViewport(d.xmin, d.ymin, d.xmax, d.ymax), l(this.contextState.canvasSize.get(), d);
    }), this.watch(this.viewSize, () => {
      this.cameraModified(), this.isShown.get() && queueMicrotask(() => {
        this.notifyEvent(
          2
          /* eVE_RENDER */
        );
      });
    }), this.watch(this.contextState.object3DInfos, () => {
      this.updateObject2DPositions();
    }), this.onEvent(this.createUndoEvent, ({ objectId: d }) => {
      if (d == "uid") {
        this.context.undoManager.push("Move Object", ws.NONE), this.context.getObjects().stls.forEach((g) => {
          if (!g.getLocked() && g.getVisibility()) {
            const f = this.context.getObjects().getStlObject(g.id);
            if (f == null) {
              console.warn("Object not found id", g.id);
              return;
            }
            (f.type === Yt._STL_TEETH_MODEL || f.type === Yt._STL_OBJECT && (f.getName() === "Anatomy" || f.getName() === "Antagonist")) && this.context.getObjects().checkCollisions();
            const T = ut.clone(f.startUM), M = ut.clone(f.getMatrix());
            let N = 0, W = 0;
            for (let V = 0; V < 16; V++)
              N += T[V], W += M[V];
            if (Math.abs(N - W) < 1e-6)
              return;
            const x = new vr({
              onUndo: () => {
                f.setMatrix(T), f.update3dInfo(), this.context.sceneRepaint();
              },
              onRedo: () => {
                f.setMatrix(M), f.update3dInfo(), this.context.sceneRepaint();
              }
            });
            this.context.undoManager.add(f, x);
          }
        }), this.context.undoManager.pop();
        return;
      }
      const h = this.context.getObjects().getStlObject(d);
      if (h == null) {
        console.error("Object not found");
        return;
      }
      const p = ut.clone(this.startUM), m = ut.clone(h.getMatrix());
      let b = 0, y = 0;
      for (let g = 0; g < 16; g++)
        b += p[g], y += m[g];
      if (Math.abs(b - y) < 1e-6)
        return;
      const Z = new vr({
        onUndo: () => {
          h.setMatrix(p), h.type == Yt._IMPLANT && h.updatePosition(), h.type == Yt._PIN ? h.updatePosition() : (h.update3dInfo(), this.context.sceneRepaint());
        },
        onRedo: () => {
          h.setMatrix(m), h.type == Yt._IMPLANT && h.updatePosition(), h.type == Yt._PIN ? h.updatePosition() : (h.update3dInfo(), this.context.sceneRepaint());
        }
      });
      this.context.undoManager.pushPop(h, Z, "Move Object", ws.NONE);
    }), this.onEvent(this.objectPreciseMoveEvent, ({ objectId: d, direction: h, cprTool: p }) => {
      var f;
      const m = this.contextState.object3DInfos.get().find((T) => T.id == d);
      if (!m) {
        console.warn("objectMoveEvent: object not found precise id", d);
        return;
      }
      if (((f = this.context.getObjects().selectedObject.get()) == null ? void 0 : f.id) != d)
        return;
      if (h === "Plus" || h === "Minus") {
        this.context.objectImplantLengthStepEvent.notify({
          objectId: d,
          step: h === "Plus" ? 1 : -1
        });
        return;
      }
      this.cloneUserMatrix(d);
      const b = I.create(), y = m.position;
      let Z = I.create();
      if (p) {
        if (h == "Right") {
          const T = this.context.CPRMath.getClosestSplineTangent(y);
          Z = I.fromValues(T[0], T[1], T[2]);
        } else if (h == "Left") {
          const T = this.context.CPRMath.getClosestSplineTangent(y);
          Z = I.fromValues(T[0], T[1], T[2]), I.negate(Z, Z);
        } else if (h == "Up") {
          const T = this.context.CPRMath.getClosestSplineBinormal(y);
          Z = I.fromValues(T[0], T[1], T[2]), I.negate(Z, Z);
        } else if (h == "Down") {
          const T = this.context.CPRMath.getClosestSplineBinormal(y);
          Z = I.fromValues(T[0], T[1], T[2]);
        }
      } else {
        const T = this.getViewMatrix();
        switch (h) {
          case "Right":
            Z = I.fromValues(T[0], T[1], T[2]), I.negate(Z, Z);
            break;
          case "Left":
            Z = I.fromValues(T[0], T[1], T[2]);
            break;
          case "Up":
            Z = I.fromValues(T[4], T[5], T[6]), I.negate(Z, Z);
            break;
          case "Down":
            Z = I.fromValues(T[4], T[5], T[6]);
            break;
        }
        (h === "Left" || h === "Right") && this.isCrossCameraDirectionFlipped() && I.negate(Z, Z);
      }
      I.scaleAndAdd(b, y, Z, this.context.settings.implants.preciseMovementStepMm), this.context.objectMoveEvent.notify({
        objectId: d,
        position: b
      });
      const g = this.context.getObjects().implants.get(d) || this.context.getObjects().pins.get(d);
      g && this.context.getObjects().checkCollisions(g);
    }), this.onEvent(this.objectMoveStartEvent, ({ objectId: d }) => {
      this.cloneUserMatrix(d);
    }), this.onEvent(this.objectMoveEvent, ({ objectId: d, viewPosition: h, cprTool: p }) => {
      var y;
      const m = this.contextState.object3DInfos.get().find((Z) => Z.id == d);
      if (!m) {
        console.warn("objectMoveEvent: object not found clasic id", d);
        return;
      }
      if (((y = this.context.getObjects().selectedObject.get()) == null ? void 0 : y.id) != d)
        return;
      let b;
      if (p) {
        const Z = this.context.CPRMath.convertMMtoCPR(m.position), g = this.worldToDisplay(...Z)[2];
        b = this.viewToWorld(...h, g), b = this.context.CPRMath.convertCPRtoMM(b);
      } else {
        const Z = this.worldToDisplay(...m.position)[2];
        b = this.viewToWorld(...h, Z);
      }
      this.context.objectMoveEvent.notify({
        objectId: d,
        position: b
      });
    }), this.onEvent(this.objectRotateTopBottomEvent, ({ objectId: d, viewPosition: h, top: p, cprTool: m }) => {
      const b = this.contextState.object3DInfos.get().find((Z) => Z.id == d);
      if (!b) {
        console.warn("objectRotateEvent: object not found");
        return;
      }
      let y;
      if (m) {
        const Z = this.context.CPRMath.convertMMtoCPR(b.position), g = this.worldToDisplay(...Z)[2];
        y = this.viewToWorld(...h, g), y = this.context.CPRMath.convertCPRtoMM(y);
      } else {
        const Z = this.worldToDisplay(...b.position)[2];
        y = this.viewToWorld(...h, Z);
      }
      this.context.objectRotateTopBottomEvent.notify({
        objectId: d,
        position: y,
        top: p,
        viewMode: this.viewMode
      });
    }), this.onEvent(this.objectRotateTopBottomStartEvent, ({ objectId: d, viewPosition: h, top: p, cprTool: m }) => {
      const b = this.contextState.object3DInfos.get().find((g) => g.id == d);
      if (!b) {
        console.warn("objectRotateEvent: object not found");
        return;
      }
      const y = this.context.getObjects().getStlObject(d);
      if (y == null) {
        console.error("Object not found");
        return;
      }
      this.startUM = ut.clone(y.getMatrix());
      let Z;
      if (m) {
        const g = this.context.CPRMath.convertMMtoCPR(b.position), f = this.worldToDisplay(...g)[2];
        Z = this.viewToWorld(...h, f), Z = this.context.CPRMath.convertCPRtoMM(Z);
      } else {
        const g = this.worldToDisplay(...b.position)[2];
        Z = this.viewToWorld(...h, g);
      }
      this.context.objectRotateTopBottomStartEvent.notify({
        objectId: d,
        position: Z,
        top: p,
        viewMode: this.viewMode
      });
    }), this.onEvent(this.objectSnapEvent, (d) => {
      this.context.getObjects().selectObject(d);
    }), this.onEvent(this.context.updateObject2DPositionEvent, () => {
      this.updateObject2DPositions(), this.context.onObjectsModified.notify();
    }), this.onEvent(this.stlPreciseMoveEvent, ({ objectId: d, direction: h, cprTool: p }) => {
      this.context.getObjects().stls.forEach((m) => {
        if (!m.getLocked() && m.getVisibility()) {
          const b = this.contextState.object3DInfos.get().find((y) => y.id == m.id);
          if (b) {
            this.cloneUserMatrix(m.id);
            const y = I.create(), Z = b.position;
            let g = I.create();
            if (p) {
              if (h == "Right") {
                const f = this.context.CPRMath.getClosestSplineTangent(Z);
                g = I.fromValues(f[0], f[1], f[2]);
              } else if (h == "Left") {
                const f = this.context.CPRMath.getClosestSplineTangent(Z);
                g = I.fromValues(f[0], f[1], f[2]), I.negate(g, g);
              } else if (h == "Up") {
                const f = this.context.CPRMath.getClosestSplineBinormal(Z);
                g = I.fromValues(f[0], f[1], f[2]), I.negate(g, g);
              } else if (h == "Down") {
                const f = this.context.CPRMath.getClosestSplineBinormal(Z);
                g = I.fromValues(f[0], f[1], f[2]);
              }
            } else {
              const f = this.renderer.getActiveCamera(), T = f.getViewPlaneNormal(), M = f.getViewUp();
              switch (h) {
                case "Right":
                  I.cross(g, M, T);
                  break;
                case "Left":
                  I.cross(g, T, M);
                  break;
                case "Up":
                  I.copy(g, M);
                  break;
                case "Down":
                  I.copy(g, M), I.negate(g, g);
                  break;
              }
              I.normalize(g, g);
            }
            I.scaleAndAdd(y, Z, g, this.context.settings.implants.preciseMovementStepMm), this.context.getObjects().moveSTL(m.id, y);
          }
        }
      });
    }), this.onEvent(this.stlMoveEvent, ({ objectId: d, viewPosition: h, setRotationCenter: p }) => {
      if (p) {
        this.setCustomStlRotationCenter(h);
        return;
      }
      this.context.getObjects().stls.forEach((m) => {
        if (!m.getLocked() && m.getVisibility()) {
          const b = this.contextState.object3DInfos.get().find((y) => y.id == m.id);
          if (b) {
            const y = this.worldToDisplay(...b.position)[2], Z = this.viewToWorld(this.startVPos[0], this.startVPos[1], y), g = this.viewToWorld(h[0], h[1], y), f = I.create();
            I.sub(f, g, Z);
            const T = I.create();
            I.add(T, b.position, f), this.context.getObjects().moveSTL(m.id, T);
          }
        }
      }), this.startVPos = h;
    }), this.onEvent(this.stlMoveStartEvent, ({ objectId: d, viewPosition: h, setRotationCenter: p }) => {
      this.startVPos = h, !p && this.context.getObjects().stls.forEach((m) => {
        !m.getLocked() && m.getVisibility() && this.cloneUserMatrix(m.id);
      });
    }), this.onEvent(this.stlRotateStartEvent, ({ objectId: d }) => {
      this.updateStlRotationCenter(), this.context.getObjects().stls.forEach((h) => {
        !h.getLocked() && h.getVisibility() && this.cloneUserMatrix(h.id);
      });
    }), this.onEvent(this.stlRotateEvent, ({ objectId: d, angle: h }) => {
      const m = this.renderer.getActiveCamera().getViewPlaneNormal();
      this.context.getObjects().stls.forEach((b) => {
        !b.getLocked() && b.getVisibility() && this.context.getObjects().rotateStl(b.id, h, m, this.centerOfSTLRotation);
      });
    });
    const c = {
      onKeyDown(d, h, p) {
        const m = t.objects.selectedObject.get(), b = t.settings.implants.preciseMovementStepMm, y = Math.PI * t.settings.implants.preciseRotationStepDeg / 180, Z = (g) => {
          const f = I.create(), T = I.create();
          if (g.type != Yt._IMPLANT && g.type != Yt._PIN ? (I.copy(f, d.getViewup()), I.scale(f, f, -1), I.cross(T, d.getNormal(), d.getViewup()), I.normalize(T, T)) : g.getMoveDeltaVectors(d, f, T), h.key == "w" || h.key == "ArrowUp")
            return g.moveDelta(f, b), !0;
          if (h.key == "s" || h.key == "ArrowDown")
            return g.moveDelta(f, -b), !0;
          if (h.key == "a" || h.key == "ArrowLeft")
            return g.moveDelta(T, b), !0;
          if (h.key == "d" || h.key == "ArrowRight")
            return g.moveDelta(T, -b), !0;
          if (h.key == "q" || h.key == "+") {
            if (g.type == Yt._IMPLANT)
              return g.rotateImplantFi(y, d.getNormal(), "bottom"), !0;
            if (g.type == Yt._PIN)
              return g.rotatePinFi(y, d.getNormal(), "bottom"), !0;
            {
              const M = y * 180 / Math.PI;
              return d.stlRotateStartEvent.notify({ objectId: g.id, angle: 0 }), d.stlRotateEvent.notify({ objectId: g.id, angle: M }), !0;
            }
          } else if (h.key == "e" || h.key == "-") {
            if (g.type == Yt._IMPLANT)
              return g.rotateImplantFi(-y, d.getNormal(), "bottom"), !0;
            if (g.type == Yt._PIN)
              return g.rotatePinFi(-y, d.getNormal(), "bottom"), !0;
            {
              const M = y * 180 / Math.PI;
              return d.stlRotateStartEvent.notify({ objectId: g.id, angle: 0 }), d.stlRotateEvent.notify({ objectId: g.id, angle: -M }), !0;
            }
          } else if (h.key == "z") {
            if (g.type == Yt._IMPLANT)
              return g.rotateImplantFi(-y, d.getNormal(), "top"), !0;
            if (g.type == Yt._PIN)
              return g.rotatePinFi(-y, d.getNormal(), "top"), !0;
            {
              const M = y * 180 / Math.PI;
              return d.stlRotateStartEvent.notify({ objectId: g.id, angle: 0 }), d.stlRotateEvent.notify({ objectId: g.id, angle: -M }), !0;
            }
          } else if (h.key == "c") {
            if (g.type == Yt._IMPLANT)
              return g.rotateImplantFi(y, d.getNormal(), "top"), !0;
            if (g.type == Yt._PIN)
              return g.rotatePinFi(y, d.getNormal(), "top"), !0;
            {
              const M = y * 180 / Math.PI;
              return d.stlRotateStartEvent.notify({ objectId: g.id, angle: 0 }), d.stlRotateEvent.notify({ objectId: g.id, angle: M }), !0;
            }
          }
          return !1;
        };
        if (m) {
          if (m && !m.IsVolume())
            return Z(m);
        } else {
          let g = !1;
          return t.getObjects().stls.forEach((f) => {
            if (!f.getLocked() && f.getVisibility() && !f.IsVolume()) {
              g = !0, Z(f);
              const T = t.getState().object3DInfos.get().find((M) => M.id === f.id);
              T && (T.position = f.getPosition(), t.objects.object3DInfos.modified());
            }
          }), g;
        }
        return !1;
      },
      getCursor: () => this.cursor
    };
    this.viewEventHandler = c, (u = this.context.getInteractorStyle()) == null || u.setViewEventHandler(this, c);
  }
  cloneUserMatrix(t) {
    const e = this.context.getObjects().getStlObject(t);
    if (e == null) {
      console.warn("Object not found objectId:", t);
      return;
    }
    this.startUM = ut.clone(e.getMatrix()), e.startUM = ut.clone(e.getMatrix());
  }
  getPresenterWindow() {
    var t;
    for (const e of this.context.getPresenterWindows()) {
      if (((t = e.getMainView()) == null ? void 0 : t.id) == this.id)
        return e;
      const n = e.getViews();
      if (n) {
        for (const s of n)
          if (s.id == this.id)
            return e;
      }
    }
    return null;
  }
  fitZoomToScreen() {
    console.log("ViewBase::fitZoomToScreen", this.viewMode);
  }
  show(t) {
    const e = this.context.getRenderWindow();
    e.hasRenderer(this.renderer) || (e.addRenderer(this.renderer), e.addRenderer(this.rendererOverlay)), this.overlayContainer.show(), this.isShown.set(!0), !t && this.notifyEvent(
      0
      /* eVE_SHOW */
    );
  }
  hide() {
    const t = this.context.getRenderWindow();
    t.hasRenderer(this.renderer) && (t.removeRenderer(this.renderer), t.removeRenderer(this.rendererOverlay)), this.overlayContainer.hide(), this.isShown.set(!1);
  }
  updateGapColor() {
    let t = "rgb(0, 0, 0)";
    const e = document.getElementById("mainContainer");
    e && (t = window.getComputedStyle(e).backgroundColor), this.overlayContainer.setGapColor(t);
  }
  showBorder(t) {
    const e = `rgb(${t[0]}, ${t[1]}, ${t[2]})`;
    this.overlayContainer.setBorderColor(e), this.overlayContainer.showBorder();
  }
  hideBorder() {
    this.overlayContainer.hideBorder();
  }
  getViewport() {
    return this.viewport.get();
  }
  setViewport(t) {
    this.viewport.set(t);
  }
  startZoom(t, e, n) {
    this.panZoom_o = [t, e, n], this.panZoom_Origin = this.renderer.getActiveCamera().getFocalPoint();
    const s = this.renderer.getActiveCamera().getViewPlaneNormal(), r = I.dot(s, this.panZoom_o) - I.dot(s, this.panZoom_Origin);
    I.scaleAndAdd(this.panZoom_o, this.panZoom_o, s, -r), this.panZoom_EndZoom = this.renderer.getActiveCamera().getParallelScale() / 3, this.panZoom_ZoomChange = 0;
    for (let a = 0; a < 3; a++)
      this.panZoom_v[a] = this.panZoom_Origin[a] - this.panZoom_o[a];
  }
  zoomWidget(t, e) {
    const n = this.GetPanZoomParams(e), s = this.renderer.getActiveCamera().getDistance(), r = this.renderer.getActiveCamera().getViewPlaneNormal(), a = [0, 0, 0];
    for (let o = 0; o < 3; ++o) a[o] = this.panZoom_Origin[o] + s * r[o];
    this.renderer.getActiveCamera().setPosition(a[0], a[1], a[2]), this.renderer.getActiveCamera().setFocalPoint(this.panZoom_Origin[0], this.panZoom_Origin[1], this.panZoom_Origin[2]), this.renderer.getActiveCamera().setParallelScale(n), this.ShowZoomIndicator(!0), this.context.toolManager.coordControl && this.context.toolManager.coordControl.onViewWidgetEvent(
      this,
      2
      /* eVE_RENDER */
    );
  }
  ShowZoomIndicator(t) {
    if (this.crossHair && this.crossHair.getActor().setVisibility(t), t) {
      const e = [1, 0, 0];
      let n = [0, 1, 0];
      const s = this.renderer.getActiveCamera().getViewPlaneNormal(), r = this.renderer.getActiveCamera().getParallelScale();
      n = this.renderer.getActiveCamera().getViewUp(), I.cross(e, n, s), I.normalize(e, e);
      const a = this.viewSize.get()[1], o = 100 * r / a;
      this.crossHair && (this.crossHair.setData({
        center: this.panZoom_o,
        left: e,
        up: n,
        size: o,
        color: [0, 1, 0]
      }), this.rendererOverlay.addActor(this.crossHair.getActor()));
    }
  }
  GetPanZoomParams(t) {
    const n = 10 * this.viewSize.get()[0], s = 1;
    let r = this.renderer.getActiveCamera().getParallelScale(), a = this.renderer.getActiveCamera().getParallelScale();
    const o = Math.abs(t / 500);
    t < 0 ? a = a * (o + 1) : t > 0 && (a = a * (1 - o)), a < s && (a = s), a > n && (a = n);
    {
      r = Math.abs(a - r) / 2, this.panZoom_ZoomChange += r, this.panZoom_ZoomChange > this.panZoom_EndZoom && (this.panZoom_ZoomChange = this.panZoom_EndZoom);
      const l = (this.panZoom_EndZoom - this.panZoom_ZoomChange) / this.panZoom_EndZoom, c = l * l;
      for (let u = 0; u < 3; u++)
        this.panZoom_Origin[u] = this.panZoom_o[u] + c * this.panZoom_v[u];
    }
    return a;
  }
  endZoom() {
    this.ShowZoomIndicator(!1);
  }
  setActors(t) {
    const e = this.renderer.getActors();
    for (const n of e)
      n !== this.focalActor && (t.includes(n) || this.renderer.removeActor(n));
    for (const n of t)
      e.includes(n) || this.renderer.addActor(n);
  }
  containsRenderer(t) {
    return t === this.renderer;
  }
  getExternal() {
    return !1;
  }
  getRenderer() {
    return this.renderer;
  }
  getRendererOverlay() {
    return this.rendererOverlay;
  }
  getReslicer() {
    return null;
  }
  getWindowLevel() {
    return [0, 0];
  }
  setWindowLevel(t) {
    console.log("setwindowlevel base", this);
  }
  getOverlayContainer() {
    return this.overlayContainer.getElement();
  }
  showFocal(t, e, n) {
    this.focalActor.setVisibility(!0), this.focalActor.setPosition(t, e, n);
    const s = this.getFixedSizeScale([t, e, n], 1, 15 * this.context.getPixelRatio());
    this.focalActor.setScale(s, s, s);
  }
  getFixedSizeScale(t, e, n, s = 0.5) {
    const r = this.worldToDisplay(...t), a = this.renderer.getActiveCamera().getViewUp(), o = t, l = [o[0] + e * a[0], o[1] + e * a[1], o[2] + e * a[2]], c = this.worldToDisplay(...l), u = I.dist(c, r), d = n / 2, h = s / 2;
    if (Math.abs(u - d) > h) {
      const p = [r[0] + d, r[1], r[2]], m = this.displayToWorld(...p);
      return I.dist(m, o) / e;
    }
    return 1;
  }
  hideFocal() {
    this.focalActor.setVisibility(!1);
  }
  representations2DUpdate(t = 2) {
    var n, s;
    performance.now(), this.viewMode == 3 && this.context.getObjects().CPRCurve.points.length < 2 && (t = 3);
    let e = this.context.getObjects();
    if (this.context.activeReconstruction && (e = this.context.activeReconstruction.objects), t == 2 || t == 0) {
      for (const a of e.implants.values()) {
        a.sendToParallelExecutor(this);
        const o = a.getSupportObjects();
        if (o.size)
          for (let [l, c] of o)
            c.sendToParallelExecutor(this);
      }
      for (const a of e.pins.values()) {
        a.sendToParallelExecutor(this);
        const o = a.getSupportObjects();
        o.size && o.forEach((l) => {
          l.sendToParallelExecutor(this);
        });
      }
      for (const a of e.stls.values())
        a.sendToParallelExecutor(this);
      for (const a of e.volumes.values())
        a.sendToParallelExecutor(this);
      for (const a of e.nerveObjects.values())
        (n = a.nerve) == null || n.sendToParallelExecutor(this);
      const r = this.context.getWasmDocumentInstance();
      r && r.WaitForParallelExecutor();
    }
    for (const r of e.implants.values()) {
      r.onViewWidgetEvent(this, t);
      const a = r.getSupportObjects();
      if (a.size)
        for (let [o, l] of a)
          l.onViewWidgetEvent(this, t);
    }
    for (const r of e.pins.values()) {
      r.onViewWidgetEvent(this, t);
      const a = r.getSupportObjects();
      if (a.size)
        for (let [o, l] of a)
          l.onViewWidgetEvent(this, t);
    }
    for (const r of e.stls.values())
      r.onViewWidgetEvent(this, t);
    for (const r of e.volumes.values())
      r.onViewWidgetEvent(this, t);
    for (const r of e.nerveObjects.values())
      (s = r.nerve) == null || s.onViewWidgetEvent(this, t);
    this.context.toolManager.measurementsTool && this.context.toolManager.measurementsTool.onViewWidgetEvent(this, t);
  }
  sceneRefresh(t) {
    const e = (a, o) => {
      const l = [...a];
      return l[0] = Math.min(a[0], o[0]), l[1] = Math.max(a[1], o[1]), l[2] = Math.min(a[2], o[2]), l[3] = Math.max(a[3], o[3]), l[4] = Math.min(a[4], o[4]), l[5] = Math.max(a[5], o[5]), l;
    }, n = this.rendererOverlay.computeVisiblePropBounds();
    let s;
    n[0] == 1 && n[1] == -1 && n[2] == 1 && n[3] == -1 && n[4] == 1 && n[5] == -1 ? s = this.renderer.computeVisiblePropBounds() : s = e(this.renderer.computeVisiblePropBounds(), n);
    const r = this.renderer.getActiveCamera();
    if (r.getParallelProjection() && this.isViewMode3D()) {
      const a = r.getFocalPoint(), o = [s[0], s[2], s[4]], l = [s[1], s[3], s[5]], c = Math.max(Math.sqrt(Hn.distance2BetweenPoints(a, o)), Hn.distance2BetweenPoints(a, l)), u = 0.5 * Hn.radiansFromDegrees(r.getViewAngle()), d = 2 * c + c / Math.tan(u);
      I.scaleAndAdd(a, a, r.getDirectionOfProjection(), -10 * d), r.setPosition(...a);
    }
    this.renderer.resetCameraClippingRange(s), this.renderer.updateLightsGeometryToFollowCamera(), t || this.context.repaint(), this.events.afterSceneRefresh.notify();
  }
  sceneRepaint(t, e) {
    this.notifyEvent(2, t), !t && this.sceneRefresh(e);
  }
  notifyEvent(t, e) {
    if (this.viewMode == 3 && this.context.getObjects().CPRCurve.points.length < 2 && (t = 3), this.viewMode == 8)
      return;
    if (e) {
      e(this, t);
      return;
    }
    const n = this.context.toolManager.getLayersByPriority();
    for (const s of n) {
      const r = this.context.toolManager.getToolInstance(s);
      r && r.onViewWidgetEvent(this, t);
    }
    this.representations2DUpdate(t), this.context.toolManager.coordControl && this.context.toolManager.coordControl.onViewWidgetEvent(this, t), this.context.toolManager.implantPinTool && this.context.toolManager.implantPinTool.onViewWidgetEvent(this, t), this.context.toolManager.stlMoveTool && this.context.toolManager.stlMoveTool.onViewWidgetEvent(this, t);
  }
  // World to display coordinates (display (0, 0) is bottom left corner)
  worldToDisplay(t, e, n) {
    return this.context.worldToDisplay(this.renderer, t, e, n);
  }
  /**To convert to this view coordinates use worldToViewV3! */
  worldToDisplayV3(t) {
    return this.context.worldToDisplay(this.renderer, t[0], t[1], t[2]);
  }
  // Display to world coordinates (display (0, 0) is bottom left corner)
  displayToWorld(t, e, n) {
    return this.context.displayToWorld(this.renderer, t, e, n);
  }
  displayToWorldV3(t) {
    return this.pickWorldPoint(t[0], t[1]);
  }
  // World to view coordinates ((0, 0) is top left corner of view)
  worldToViewV3(t) {
    const e = this.worldToDisplay(t[0], t[1], t[2]);
    return this.displayToView(e[0], e[1]);
  }
  worldToView(t, e, n) {
    const s = this.worldToDisplay(t, e, n);
    return this.displayToView(s[0], s[1]);
  }
  // View to world coordinates ((0, 0) is top left corner of view)
  viewToWorld(t, e, n) {
    return this.displayToWorld(...this.viewToDisplay(t, e), n || 0);
  }
  viewToWorldV3(t) {
    const e = this.viewToDisplay(t[0], t[1]), n = this.getOrigin(), s = this.worldToDisplay(...n)[2];
    return this.displayToWorld(e[0], e[1], s);
  }
  viewToDisplay(t, e) {
    const n = this.viewport.get(), [s, r] = this.contextState.canvasSize.get(), a = s * n.xmin, o = r * (1 - n.ymax);
    return [
      t + a + this.context.layoutManager.borderWidth + this.context.layoutManager.gapWidth,
      r - (e + o + this.context.layoutManager.borderWidth + this.context.layoutManager.gapWidth)
    ];
  }
  displayToView(t, e) {
    const n = this.viewport.get(), [s, r] = this.contextState.canvasSize.get(), a = n.xmin * s, o = (1 - n.ymax) * r;
    return [
      t - a - this.context.layoutManager.borderWidth - this.context.layoutManager.gapWidth,
      r - e - o - this.context.layoutManager.borderWidth - this.context.layoutManager.gapWidth
    ];
  }
  cellPickFromList(t, e, n) {
    this.cellPicker.setPickFromList(1), this.cellPicker.setPickList(t), this.cellPicker.pick([e, n, 0], this.renderer);
    const r = this.cellPicker.getPickedPositions()[0];
    return r !== void 0 ? r : null;
  }
  hardwareSelectorPick(t, e, n, s, r) {
    if (n !== void 0) {
      if (n === 0) {
        const a = this.rendererOverlay.getDraw();
        this.rendererOverlay.setDraw(!1);
        const o = this.context.hardwareSelectorPick(this.renderer, t, e, s ?? !1, r ?? !1);
        return this.rendererOverlay.setDraw(a), o;
      } else if (n === 1)
        return this.renderer.getDraw(), this.context.hardwareSelectorPick(this.rendererOverlay, t, e, s ?? !1, r ?? !1);
      return null;
    } else {
      let a = this.context.hardwareSelectorPick(this.rendererOverlay, t, e, s ?? !1, r ?? !1);
      if (a && a.length)
        return a;
      const o = this.rendererOverlay.getDraw();
      return this.rendererOverlay.setDraw(!1), a = this.context.hardwareSelectorPick(this.renderer, t, e, s ?? !1, r ?? !1), this.rendererOverlay.setDraw(o), a;
    }
  }
  hardwareSelectorCapture(t, e, n) {
    if (t === 0) {
      const s = this.rendererOverlay.getDraw();
      this.rendererOverlay.setDraw(!1), this.context.hardwareSelectorCaptureBuffers(this.renderer, e ?? !1, n ?? !1), this.rendererOverlay.setDraw(s);
    } else t === 1 && this.context.hardwareSelectorCaptureBuffers(this.rendererOverlay, e ?? !1, n ?? !1);
  }
  hardwareSelectorPickCaptured(t, e, n, s, r) {
    var l, c;
    const a = (l = this.context.hardwareSelector) == null ? void 0 : l.getCapturedBuffersValid(), o = t === 1 ? this.rendererOverlay : this.renderer;
    return a && a === o || this.hardwareSelectorCapture(t, e, n), ((c = this.context.hardwareSelector) == null ? void 0 : c.generateSelection(s, r, s, r)) ?? null;
  }
  hardwareSelectorReleaseBuffers() {
    var t;
    (t = this.context.hardwareSelector) == null || t.releasePixBuffers();
  }
  /**
   * Get the vtk prop at the given display coordinates.
   * */
  pickProp(t, e, n) {
    const s = this.hardwareSelectorPick(t, e, n, !1);
    if (s && s.length) {
      const a = s[0].getProperties().prop;
      return a || null;
    }
    return null;
  }
  /**
   * Get the vtk prop and world coordinates of the picked point.
   * If the exact world point is not needed, pickProp is faster.
   * */
  pickPropPoint(t, e, n) {
    const s = this.hardwareSelectorPick(t, e, n, !0);
    if (s && s.length) {
      const r = s[0].getProperties(), a = r.prop;
      if (a) {
        const o = r.worldPosition;
        if (o !== void 0)
          return [a, o];
      }
      return null;
    }
    return null;
  }
  pickAll(t, e, n) {
    const s = this.hardwareSelectorPick(t, e, n, !0);
    if (s && s.length) {
      const r = s[0].getProperties();
      r.prop;
      const a = r.worldPosition;
      if (a !== void 0)
        return a;
    }
    return this.pickWorldPoint(t, e);
  }
  pickWorldPoint(t, e) {
    const n = this.getOrigin(), s = this.worldToDisplay(...n)[2], r = this.displayToWorld(t, e, s);
    return console.assert(r !== void 0), r;
  }
  getViewMode() {
    return this.viewMode;
  }
  getNormal() {
    return this.renderer.getActiveCamera().getViewPlaneNormal();
  }
  getTangent() {
    const t = this.getNormal(), e = this.getViewup(), n = I.create();
    return I.cross(n, t, e), I.normalize(n, n), n;
  }
  getViewup() {
    return this.renderer.getActiveCamera().getViewUp();
  }
  getOrigin() {
    return this.renderer.getActiveCamera().getFocalPoint();
  }
  cameraModified() {
    this.isShown.get() && (this.updateObject2DPositions(), this.context.toolManager.measurementsTool.viewCameraModified.notify(this), this.events.cameraModified.notify());
  }
  updateObject2DPositions() {
    if (this.context.isDestructed())
      return;
    const [t, e] = this.viewSize.get(), n = this.contextState.object3DInfos.get();
    this.viewObjectPositions.set(
      n.map((s) => {
        var g, f;
        const r = this.context.getObjects().implants.get(s.id) || this.context.getObjects().pins.get(s.id) || this.context.getObjects().stls.get(s.id), a = r ? r.getLocked() : !0;
        let o = !1;
        const l = this.context.getObjects().selectedObject.get();
        l && l.id == s.id && (o = !0);
        let c = !0;
        if (!this.isViewMode3D()) {
          const M = this.getOrigin(), N = this.getNormal(), W = I.create();
          I.sub(W, M, s.position), Math.abs(I.dot(W, N)) > 4 && (c = !1);
        }
        const u = (r == null ? void 0 : r.getStandardInfoString(!1)) || null, d = this.worldToView(...s.position), h = d[0] >= 0 && d[0] < t && d[1] >= 0 && d[1] < e && c;
        let p = s.handleTop ? this.worldToView(...s.handleTop) : null;
        if (this.isViewMode3D() && s.type == Yt._PIN) {
          const T = ((g = this.context.getObjects().pins.get(s.id)) == null ? void 0 : g.getTop(0)) || null;
          T && (p = this.worldToView(...T));
        }
        let m = s.handleBottom ? this.worldToView(...s.handleBottom) : null;
        if (this.isViewMode3D() && s.type == Yt._PIN) {
          const T = ((f = this.context.getObjects().pins.get(s.id)) == null ? void 0 : f.getBottom(0)) || null;
          T && (m = this.worldToView(...T));
        }
        const b = s.centerlineTop ? [this.worldToView(...s.centerlineTop[0]), this.worldToView(...s.centerlineTop[1])] : null, y = s.centerlineBottom ? [this.worldToView(...s.centerlineBottom[0]), this.worldToView(...s.centerlineBottom[1])] : null;
        let Z = !0;
        return ((r == null ? void 0 : r.type) == Yt._PIN || (r == null ? void 0 : r.type) == Yt._IMPLANT) && (Z = r.selectedForGuideDesign), {
          id: s.id,
          selectedFlag: o,
          name: u,
          type: s.type,
          position: d,
          handleTop: p,
          handleBottom: m,
          centerlineTop: b,
          centerlineBottom: y,
          visible: s.visible,
          color: s.color,
          lockedFlag: a,
          visibleInView: h,
          selected: Z,
          preciseStepFlag: this.context.settings.implants.showImplantStepButtons
        };
      })
    ), this.updateStlRotationCenter();
  }
  updateObject2DPositionsById(t) {
    if (this.context.isDestructed())
      return;
    const [e, n] = this.viewSize.get(), s = this.contextState.object3DInfos.get();
    this.viewObjectPositions.set(
      s.map((r) => {
        var g, f;
        if (r.id != t) {
          const T = this.viewObjectPositions.get().map((M) => M.id).indexOf(t);
          return this.viewObjectPositions.get()[T];
        }
        const a = this.context.getObjects().implants.get(r.id) || this.context.getObjects().pins.get(r.id) || this.context.getObjects().stls.get(r.id), o = a ? a.getLocked() : !0;
        let l = !1;
        const c = this.context.getObjects().selectedObject.get();
        c && c.id == r.id && (l = !0);
        let u = !0;
        if (!this.isViewMode3D()) {
          const M = this.getOrigin(), N = this.getNormal(), W = I.create();
          I.sub(W, M, r.position), Math.abs(I.dot(W, N)) > 4 && (u = !1);
        }
        const d = (a == null ? void 0 : a.getStandardInfoString(!1)) || null, h = this.worldToView(...r.position), p = h[0] >= 0 && h[0] < e && h[1] >= 0 && h[1] < n && u;
        let m = r.handleTop ? this.worldToView(...r.handleTop) : null;
        if (this.isViewMode3D() && r.type == Yt._PIN) {
          const T = ((g = this.context.getObjects().pins.get(r.id)) == null ? void 0 : g.getTop(0)) || null;
          T && (m = this.worldToView(...T));
        }
        let b = r.handleBottom ? this.worldToView(...r.handleBottom) : null;
        if (this.isViewMode3D() && r.type == Yt._PIN) {
          const T = ((f = this.context.getObjects().pins.get(r.id)) == null ? void 0 : f.getBottom(0)) || null;
          T && (b = this.worldToView(...T));
        }
        const y = r.centerlineTop ? [this.worldToView(...r.centerlineTop[0]), this.worldToView(...r.centerlineTop[1])] : null, Z = r.centerlineBottom ? [this.worldToView(...r.centerlineBottom[0]), this.worldToView(...r.centerlineBottom[1])] : null;
        return ((a == null ? void 0 : a.type) == Yt._PIN || (a == null ? void 0 : a.type) == Yt._IMPLANT) && a.selectedForGuideDesign, {
          id: r.id,
          selectedFlag: l,
          name: d,
          type: r.type,
          position: h,
          handleTop: m,
          handleBottom: b,
          centerlineTop: y,
          centerlineBottom: Z,
          visible: r.visible,
          color: r.color,
          lockedFlag: o,
          visibleInView: p,
          selected: !0
        };
      })
    ), this.updateStlRotationCenter();
  }
  computeStlCenterInView() {
    const t = this.viewObjectPositions.get().filter(
      (s) => s.type !== void 0 && [Yt._STL_OBJECT, Yt._STL_TEETH_MODEL, Yt._STL_PROSTHESIS, Yt._REFERENCE_PLANE, Yt._STL_TOOTH].includes(s.type) && !s.lockedFlag
    ), e = [0, 0];
    let n = 0;
    return t.forEach((s) => {
      s.visible && !s.lockedFlag && (n++, e[0] += s.position[0], e[1] += s.position[1]);
    }), n === 0 ? null : (e[0] /= n, e[1] /= n, e);
  }
  updateStlRotationCenter() {
    const t = this.computeStlCenterInView();
    if (!t) {
      this.stlRotationCenterView.set(null), this.centerOfSTLRotation = [0, 0, 0];
      return;
    }
    const e = this.getOrigin()[2], n = this.viewToWorld(t[0], t[1], e), s = I.fromValues(n[0], n[1], n[2]), r = I.create();
    I.copy(r, s), this.hasCustomStlRotationCenter && I.add(r, s, this.stlRotationCenterOffset), this.centerOfSTLRotation = [r[0], r[1], r[2]], this.stlRotationCenterView.set(this.worldToView(r[0], r[1], r[2]));
  }
  setCustomStlRotationCenter(t) {
    const e = this.computeStlCenterInView();
    if (!e)
      return;
    const n = this.getOrigin()[2], s = this.viewToWorld(e[0], e[1], n), r = this.viewToWorld(t[0], t[1], n), a = I.fromValues(s[0], s[1], s[2]), o = I.fromValues(r[0], r[1], r[2]);
    I.sub(this.stlRotationCenterOffset, o, a), this.hasCustomStlRotationCenter = !0, this.updateStlRotationCenter();
  }
  watch(t, e) {
    t.subscribe(e), this.onCleanup(() => t.unsubscribe(e));
  }
  computed(t) {
    const e = new md(t);
    return this.onCleanup(() => e.stop()), e;
  }
  lazyComputed(t) {
    const e = new OU(t);
    return this.onCleanup(() => e.stop()), e;
  }
  onEvent(t, e) {
    t.subscribe(e), this.onCleanup(() => t.unsubscribe(e));
  }
  onCleanup(t) {
    this.onCleanupArray.push(t);
  }
  isShownWrapper() {
    return this.isShown;
  }
  isVisible() {
    return this.isShown.get();
  }
  isViewShown() {
    return this.isShown;
  }
  isViewMode3D() {
    return !1;
  }
  isMultiCross() {
    return !1;
  }
  isCrossCameraDirectionFlipped() {
    return !1;
  }
  panToPosition(t, e, n) {
    console.warn("base", t, e, n);
  }
  cleanup() {
    this.notifyEvent(
      3
      /* eVE_DESTROY */
    ), this.hide(), this.onCleanupArray.reduceRight((t, e) => (e(), null), null), this.focalActor.delete(), this.focalMapper.delete(), this.focalSource.delete(), this.renderer.delete();
  }
  setViewPosition(t, e, n, s) {
    console.warn("base", t, e, n, s);
  }
  setViewOrigin(t) {
    console.warn("base", t);
  }
  rotateView(t, e) {
    console.warn("base", t, e);
  }
  setViewMatrix(t) {
    ut.copy(this.resliceAxes, t);
  }
  getViewMatrix() {
    const t = ut.create();
    return ut.identity(t), t;
  }
  //! reset viewMatrix based on ViewMode
  resetViewPosition(t = !0) {
  }
  /*! pan camera to reslicer origin*/
  resetViewCamera() {
  }
  getFilterMode() {
    return this.filterMode;
  }
  getFilterThickness() {
    return this.filterThickness;
  }
  setFilterMode(t, e = -1) {
    this.filterMode = t, e > 0 && (this.filterThickness = e);
  }
  addImageActor(t) {
    t && this.renderer.removeActor(t), this.renderer.addActor(t);
  }
  addActor(t, e = 0, n) {
    if (t) {
      let s = this.renderer;
      if (e == 0 ? s = this.renderer : e == 1 && (s = this.rendererOverlay), !s) return;
      s.getViewProps().includes(t) || s.addActor(t);
    }
  }
  removeActor(t) {
    if (t) {
      const e = this.renderer;
      if (e)
        try {
          e.getViewProps().includes(t) && e.removeActor(t);
        } catch (s) {
          console.warn("Removing actor exception", s);
        }
      const n = this.rendererOverlay;
      if (n)
        try {
          n.getViewProps().includes(t) && n.removeActor(t);
        } catch (s) {
          console.warn("Removing actor exception", s);
        }
    }
  }
  getViewObjectPositions() {
    return this.viewObjectPositions;
  }
  getStlRotationCenter() {
    return this.stlRotationCenter;
  }
  computeClippingPlanes() {
    const t = I.create(), e = I.create();
    I.scaleAndAdd(t, this.getOrigin(), this.getNormal(), this.filterThickness / 2), I.scaleAndAdd(e, this.getOrigin(), this.getNormal(), -this.filterThickness / 2);
    const n = I.create();
    return I.negate(n, this.getNormal()), [
      li.newInstance({ normal: this.getNormal(), origin: e }),
      li.newInstance({ normal: n, origin: t })
    ];
  }
  updateCrossSliceIndicator() {
  }
  slide(t) {
  }
  setCursor(t) {
    t === td.SLIDE || t === td.ROTATE || t == td.THICKNESS || t == td.CPR ? this.cursor = "pointer" : this.cursor = null;
  }
  getBounds() {
    return [0, 100, 0, 100, 0, 100];
  }
  panToPosition3D(t) {
    if (!this.isViewMode3D() && this.viewMode != 3) {
      const e = I.create(), n = this.getRenderer().getActiveCamera(), s = n.getDistance(), r = n.getViewPlaneNormal();
      I.scaleAndAdd(e, t, r, s), n.setPosition(...e), n.setFocalPoint(...t);
    }
  }
  getImagedata(t) {
    const e = xs.newInstance(), n = this.getReslicer();
    if (!n)
      throw new Error("Reslicer not found");
    const s = n.GetSliceView(), r = xs.newInstance();
    Go(s, r);
    const a = r.getDimensions(), o = r.getOrigin(), l = this.context.getDataSpacing(), c = Fi.fromValues(-o[0] / l, -o[1] / l);
    let u = Fi.fromValues(t[0] / l, t[1] / l);
    if (t[0] == 0)
      return e.shallowCopy(r), e;
    const d = Fi.fromValues(Math.floor(u[1] / 2), Math.floor(u[1] / 2));
    u[0] = 2 * d[0], u[1] = 2 * d[1], e.setDimensions(u[0], u[1], 1), e.setSpacing(r.getSpacing()), e.setOrigin([-(u[0] - 1) / 2 * l, -(u[1] - 1) / 2 * l, 0]);
    const h = r.getPointData().getScalars().getData(), p = new Int16Array(u[0] * u[1]), m = r.getPointData().getNumberOfComponents(), b = Fi.fromValues(c[0] - u[0] / 2, c[1] - u[1] / 2), y = Fi.fromValues(b[0] - Math.floor(b[0]), b[1] - Math.floor(b[1]));
    for (let g = 0; g < u[0]; g++)
      for (let f = 0; f < u[1]; f++)
        if (g + b[0] > 0 && g + b[0] + 1 < a[0] && f + b[1] > 0 && f + b[1] + 1 < a[1]) {
          const T = Number(h[g + Math.floor(b[0]) + (f + Math.floor(b[1])) * a[0]]), M = Number(h[g + Math.floor(b[0]) + (f + Math.floor(b[1] + 1)) * a[0]]), N = Number(h[g + Math.floor(b[0] + 1) + (f + Math.floor(b[1] + 1)) * a[0]]), W = Number(h[g + Math.floor(b[0] + 1) + (f + Math.floor(b[1])) * a[0]]), x = (1 - y[0]) * T + y[0] * W, V = (1 - y[0]) * M + y[0] * N;
          p[g + f * u[0]] = (1 - y[1]) * x + y[1] * V;
        } else p[g + f * u[0]] = this.context.getImageData().getPointData().getScalars().getRange()[0];
    const Z = We.newInstance({
      values: p,
      numberOfComponents: m
    });
    return e.getPointData().setScalars(Z), e;
  }
  getDirectionalSpacing() {
    return 0;
  }
  getCellPicker() {
    return this.cellPicker;
  }
  hideOverlayComponents(t) {
  }
  hideObjectList(t) {
  }
}
const {
  vtkErrorMacro: N2t,
  VOID: W2t
} = tt;
function G2t(i, t, e, n) {
  return i.getRenderWindow().getViews()[0].worldToDisplay(t, e, n, i);
}
function w2t(i, t, e, n) {
  return i.getRenderWindow().getViews()[0].displayToWorld(t, e, n, i);
}
const x2t = {
  computeWorldToDisplay: G2t,
  computeDisplayToWorld: w2t
};
function S2t(i, t) {
  t.classHierarchy.push("vtkInteractorObserver");
  const e = {
    ...i
  };
  function n() {
    for (; t.subscribedEvents.length; )
      t.subscribedEvents.pop().unsubscribe();
  }
  function s() {
    RT.handledEvents.forEach((r) => {
      i[`handle${r}`] && t.subscribedEvents.push(t._interactor[`on${r}`]((a) => t.processEvents ? i[`handle${r}`](a) : W2t, t.priority));
    });
  }
  i.setInteractor = (r) => {
    r !== t._interactor && (n(), t._interactor = r, r && t.enabled && s(), i.modified());
  }, i.setEnabled = (r) => {
    r !== t.enabled && (n(), r && (t._interactor ? s() : N2t(`
          The interactor must be set before subscribing to events
        `)), t.enabled = r, i.modified());
  }, i.computeDisplayToWorld = (r, a, o, l) => r ? t._interactor.getView().displayToWorld(a, o, l, r) : null, i.computeWorldToDisplay = (r, a, o, l) => r ? t._interactor.getView().worldToDisplay(a, o, l, r) : null, i.setPriority = (r) => {
    e.setPriority(r) && t._interactor && (n(), s());
  };
}
const L2t = {
  enabled: !0,
  // _interactor: null,
  priority: 0,
  processEvents: !0,
  subscribedEvents: []
};
function mJ(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, L2t, e), tt.obj(i, t), tt.event(i, t, "InteractionEvent"), tt.event(i, t, "StartInteractionEvent"), tt.event(i, t, "EndInteractionEvent"), tt.get(i, t, ["_interactor", "enabled"]), tt.setGet(i, t, ["priority", "processEvents"]), tt.moveToProtected(i, t, ["interactor"]), S2t(i, t);
}
const V2t = tt.newInstance(mJ, "vtkInteractorObserver");
var bJ = {
  newInstance: V2t,
  extend: mJ,
  ...x2t
};
const X2t = {
  IS_START: 0,
  IS_NONE: 0,
  IS_ROTATE: 1,
  IS_PAN: 2,
  IS_SPIN: 3,
  IS_DOLLY: 4,
  IS_CAMERA_POSE: 11,
  IS_WINDOW_LEVEL: 1024,
  IS_SLICE: 1025
};
var WC = {
  States: X2t
};
const {
  States: lc
} = WC, aS = {
  Rotate: lc.IS_ROTATE,
  Pan: lc.IS_PAN,
  Spin: lc.IS_SPIN,
  Dolly: lc.IS_DOLLY,
  CameraPose: lc.IS_CAMERA_POSE,
  WindowLevel: lc.IS_WINDOW_LEVEL,
  Slice: lc.IS_SLICE
};
function I2t(i, t) {
  t.classHierarchy.push("vtkInteractorStyle"), Object.keys(aS).forEach((e) => {
    tt.event(i, t, `Start${e}Event`), i[`start${e}`] = () => {
      t.state === lc.IS_NONE && (t.state = aS[e], t._interactor.requestAnimation(i), i.invokeStartInteractionEvent({
        type: "StartInteractionEvent"
      }), i[`invokeStart${e}Event`]({
        type: `Start${e}Event`
      }));
    }, tt.event(i, t, `End${e}Event`), i[`end${e}`] = () => {
      t.state === aS[e] && (t.state = lc.IS_NONE, t._interactor.cancelAnimation(i), i.invokeEndInteractionEvent({
        type: "EndInteractionEvent"
      }), i[`invokeEnd${e}Event`]({
        type: `End${e}Event`
      }), t._interactor.render());
    };
  }), i.handleKeyPress = (e) => {
    const n = t._interactor;
    let s = null;
    switch (e.key) {
      case "r":
      case "R":
        e.pokedRenderer.resetCamera(), n.render();
        break;
      case "w":
      case "W":
        s = e.pokedRenderer.getActors(), s.forEach((r) => {
          const a = r.getProperty();
          a.setRepresentationToWireframe && a.setRepresentationToWireframe();
        }), n.render();
        break;
      case "s":
      case "S":
        s = e.pokedRenderer.getActors(), s.forEach((r) => {
          const a = r.getProperty();
          a.setRepresentationToSurface && a.setRepresentationToSurface();
        }), n.render();
        break;
      case "v":
      case "V":
        s = e.pokedRenderer.getActors(), s.forEach((r) => {
          const a = r.getProperty();
          a.setRepresentationToPoints && a.setRepresentationToPoints();
        }), n.render();
        break;
    }
  };
}
const C2t = {
  state: lc.IS_NONE,
  handleObservers: 1,
  autoAdjustCameraClippingRange: 1
};
function fJ(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, C2t, e), bJ.extend(i, t, e), I2t(i, t);
}
const Y2t = tt.newInstance(fJ, "vtkInteractorStyle");
var v2t = {
  newInstance: Y2t,
  extend: fJ,
  ...WC
};
const {
  States: ec
} = WC;
function R2t(i, t) {
  t.classHierarchy.push("vtkInteractorStyleTrackballCamera"), i.handleMouseMove = (e) => {
    const n = e.position, s = e.pokedRenderer;
    switch (t.state) {
      case ec.IS_ROTATE:
        i.handleMouseRotate(s, n), i.invokeInteractionEvent({
          type: "InteractionEvent"
        });
        break;
      case ec.IS_PAN:
        i.handleMousePan(s, n), i.invokeInteractionEvent({
          type: "InteractionEvent"
        });
        break;
      case ec.IS_DOLLY:
        i.handleMouseDolly(s, n), i.invokeInteractionEvent({
          type: "InteractionEvent"
        });
        break;
      case ec.IS_SPIN:
        i.handleMouseSpin(s, n), i.invokeInteractionEvent({
          type: "InteractionEvent"
        });
        break;
    }
    t.previousPosition = n;
  }, i.handleButton3D = (e) => {
    if (e && e.pressed && e.device === gL.RightController && (e.input === Gy.Trigger || e.input === Gy.TrackPad)) {
      i.startCameraPose();
      return;
    }
    e && !e.pressed && e.device === gL.RightController && (e.input === Gy.Trigger || e.input === Gy.TrackPad) && t.state === ec.IS_CAMERA_POSE && i.endCameraPose();
  }, i.handleMove3D = (e) => {
    switch (t.state) {
      case ec.IS_CAMERA_POSE:
        i.updateCameraPose(e);
        break;
    }
  }, i.updateCameraPose = (e) => {
    const n = e.pokedRenderer.getActiveCamera(), s = n.getPhysicalTranslation(), a = 0.5 * 0.05 * n.getPhysicalScale(), o = n.physicalOrientationToWorldDirection([e.orientation.x, e.orientation.y, e.orientation.z, e.orientation.w]);
    n.setPhysicalTranslation(s[0] + o[0] * a, s[1] + o[1] * a, s[2] + o[2] * a);
  }, i.handleLeftButtonPress = (e) => {
    const n = e.position;
    t.previousPosition = n, e.shiftKey ? e.controlKey || e.altKey ? i.startDolly() : i.startPan() : e.controlKey || e.altKey ? i.startSpin() : i.startRotate();
  }, i.handleLeftButtonRelease = () => {
    switch (t.state) {
      case ec.IS_DOLLY:
        i.endDolly();
        break;
      case ec.IS_PAN:
        i.endPan();
        break;
      case ec.IS_SPIN:
        i.endSpin();
        break;
      case ec.IS_ROTATE:
        i.endRotate();
        break;
    }
  }, i.handleStartMouseWheel = () => {
    i.startDolly();
  }, i.handleEndMouseWheel = () => {
    i.endDolly();
  }, i.handleStartPinch = (e) => {
    t.previousScale = e.scale, i.startDolly();
  }, i.handleEndPinch = () => {
    i.endDolly();
  }, i.handleStartRotate = (e) => {
    t.previousRotation = e.rotation, i.startRotate();
  }, i.handleEndRotate = () => {
    i.endRotate();
  }, i.handleStartPan = (e) => {
    t.previousTranslation = e.translation, i.startPan();
  }, i.handleEndPan = () => {
    i.endPan();
  }, i.handlePinch = (e) => {
    i.dollyByFactor(e.pokedRenderer, e.scale / t.previousScale), t.previousScale = e.scale;
  }, i.handlePan = (e) => {
    const n = e.pokedRenderer.getActiveCamera();
    let s = n.getFocalPoint();
    s = i.computeWorldToDisplay(e.pokedRenderer, s[0], s[1], s[2]);
    const r = s[2], a = e.translation, o = t.previousTranslation, l = i.computeDisplayToWorld(e.pokedRenderer, s[0] + a[0] - o[0], s[1] + a[1] - o[1], r), c = i.computeDisplayToWorld(e.pokedRenderer, s[0], s[1], r), u = [];
    u[0] = c[0] - l[0], u[1] = c[1] - l[1], u[2] = c[2] - l[2], s = n.getFocalPoint();
    const d = n.getPosition();
    n.setFocalPoint(u[0] + s[0], u[1] + s[1], u[2] + s[2]), n.setPosition(u[0] + d[0], u[1] + d[1], u[2] + d[2]), t._interactor.getLightFollowCamera() && e.pokedRenderer.updateLightsGeometryToFollowCamera(), n.orthogonalizeViewUp(), t.previousTranslation = e.translation;
  }, i.handleRotate = (e) => {
    const n = e.pokedRenderer.getActiveCamera();
    n.roll(e.rotation - t.previousRotation), n.orthogonalizeViewUp(), t.previousRotation = e.rotation;
  }, i.handleMouseRotate = (e, n) => {
    if (!t.previousPosition)
      return;
    const s = t._interactor, r = n.x - t.previousPosition.x, a = n.y - t.previousPosition.y, o = s.getView().getViewportSize(e);
    let l = -0.1, c = -0.1;
    o[0] && o[1] && (l = -20 / o[1], c = -20 / o[0]);
    const u = r * c * t.motionFactor, d = a * l * t.motionFactor, h = e.getActiveCamera();
    !Number.isNaN(u) && !Number.isNaN(d) && (h.azimuth(u), h.elevation(d), h.orthogonalizeViewUp()), t.autoAdjustCameraClippingRange && e.resetCameraClippingRange(), s.getLightFollowCamera() && e.updateLightsGeometryToFollowCamera();
  }, i.handleMouseSpin = (e, n) => {
    if (!t.previousPosition)
      return;
    const s = t._interactor, r = e.getActiveCamera(), a = s.getView().getViewportCenter(e), o = pg(Math.atan2(t.previousPosition.y - a[1], t.previousPosition.x - a[0])), l = pg(Math.atan2(n.y - a[1], n.x - a[0])) - o;
    Number.isNaN(l) || (r.roll(l), r.orthogonalizeViewUp());
  }, i.handleMousePan = (e, n) => {
    if (!t.previousPosition)
      return;
    const s = e.getActiveCamera();
    let r = s.getFocalPoint();
    r = i.computeWorldToDisplay(e, r[0], r[1], r[2]);
    const a = r[2], o = i.computeDisplayToWorld(e, n.x, n.y, a), l = i.computeDisplayToWorld(e, t.previousPosition.x, t.previousPosition.y, a), c = [];
    c[0] = l[0] - o[0], c[1] = l[1] - o[1], c[2] = l[2] - o[2], r = s.getFocalPoint();
    const u = s.getPosition();
    s.setFocalPoint(c[0] + r[0], c[1] + r[1], c[2] + r[2]), s.setPosition(c[0] + u[0], c[1] + u[1], c[2] + u[2]), t._interactor.getLightFollowCamera() && e.updateLightsGeometryToFollowCamera();
  }, i.handleMouseDolly = (e, n) => {
    if (!t.previousPosition)
      return;
    const s = n.y - t.previousPosition.y, a = t._interactor.getView().getViewportCenter(e), o = t.motionFactor * s / a[1];
    i.dollyByFactor(e, 1.1 ** o);
  }, i.handleMouseWheel = (e) => {
    const n = 1 - e.spinY / t.zoomFactor;
    i.dollyByFactor(e.pokedRenderer, n);
  }, i.dollyByFactor = (e, n) => {
    if (Number.isNaN(n))
      return;
    const s = e.getActiveCamera();
    s.getParallelProjection() ? s.setParallelScale(s.getParallelScale() / n) : (s.dolly(n), t.autoAdjustCameraClippingRange && e.resetCameraClippingRange()), t._interactor.getLightFollowCamera() && e.updateLightsGeometryToFollowCamera();
  };
}
const D2t = {
  motionFactor: 10,
  zoomFactor: 10
};
function gJ(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, D2t, e), v2t.extend(i, t, e), tt.setGet(i, t, ["motionFactor", "zoomFactor"]), R2t(i, t);
}
const O2t = tt.newInstance(gJ, "vtkInteractorStyleTrackballCamera");
var GC = {
  newInstance: O2t,
  extend: gJ
}, $L = /* @__PURE__ */ ((i) => (i[i.REALGUIDE = 0] = "REALGUIDE", i[i.IMPLANTPLANNER = 1] = "IMPLANTPLANNER", i))($L || {});
function yJ(...i) {
  const t = (e, ...n) => {
    var s;
    for (const r of i)
      if ((s = r[e]) == null ? void 0 : s.call(r, n[0], n[1], n[2])) return !0;
    return !1;
  };
  return {
    onLeftPress: (...e) => t("onLeftPress", ...e),
    onLeftRelease: (...e) => t("onLeftRelease", ...e),
    onRightPress: (...e) => t("onRightPress", ...e),
    onRightRelease: (...e) => t("onRightRelease", ...e),
    onMiddlePress: (...e) => t("onMiddlePress", ...e),
    onMiddleRelease: (...e) => t("onMiddleRelease", ...e),
    onMouseWheel: (...e) => t("onMouseWheel", ...e),
    onMouseMove: (...e) => t("onMouseMove", ...e),
    onMouseEnter: (...e) => t("onMouseEnter", ...e),
    onMouseLeave: (...e) => t("onMouseLeave", ...e),
    onKeyDown: (...e) => t("onKeyDown", ...e),
    onKeyPress: (...e) => t("onKeyPress", ...e),
    onKeyUp: (...e) => t("onKeyUp", ...e),
    getCursor: () => {
      var e;
      for (const n of i) {
        const s = (e = n.getCursor) == null ? void 0 : e.call(n);
        if (s)
          return s;
      }
      return null;
    }
  };
}
var z2t = /* @__PURE__ */ ((i) => (i[i.N = 0] = "N", i[i.S = 1] = "S", i[i.C = 3] = "C", i[i.A = 5] = "A", i[i.SC = 4] = "SC", i[i.SA = 6] = "SA", i[i.SCA = 9] = "SCA", i[i.CA = 8] = "CA", i))(z2t || {});
function eu(i) {
  const [t, e, n] = [i.shiftKey, i.controlKey, i.altKey];
  return Number(t) + Number(e) * 3 + Number(n) * 5;
}
function E2t(i, t) {
  t.classHierarchy.push("xInteractorStyle"), t.leftDown = !1, t.rightDown = !1, t.middleDown = !1, t.drag = !1, t.hover = !1, t.grabFocalPoint = !1, t.lastMouseDown = [-1, -1], t.lastMouseMove = [-1, -1], t.cursorMode = !1, t.focalPoint = [0, 0, 0], t.mouseWheelMotionFactor = 1, t.windowLevelTools = null, t.activeMeasurementTools = null, t.activeTools = /* @__PURE__ */ new Map(), t.measurementTools = null, t.viewEventHandlers = /* @__PURE__ */ new Map(), t.cursorTools = null, t.defaultCursor = "default", t.currentCursor = t.defaultCursor, t.animationRequest = void 0;
  const e = (f) => {
    if (t.state !== 0 || t.leftDown || t.middleDown || t.rightDown)
      return t.view || null;
    if (!f.pokedRenderer)
      return t.view = void 0, null;
    const T = t.context.getView(f.pokedRenderer);
    return T ? (t.view = T, T) : (t.view = void 0, null);
  }, n = (f) => t.context.toolManager.getTools() || t.activeTools.get(f) || null, s = (f, T, M) => {
    var N;
    switch (t.view && t.context.getInputMode().onInteractorBegin.notify(t.view), f) {
      case 4:
        i.startDolly();
        break;
      case 2:
        i.startPan();
        break;
      case 3:
        i.startSpin();
        break;
      case 1:
        i.startRotate();
        break;
    }
    if (t.state = f, f === 4 && t.view && T !== void 0 && M !== void 0) {
      const W = t.view.getPresenterWindow();
      W && ((N = W.startZoom) == null || N.call(W, T, M, t.view));
    }
    a(), t.drag = !0;
  }, r = () => {
    var f, T;
    if (t.state === 4) {
      const M = (f = t.view) == null ? void 0 : f.getPresenterWindow();
      M && ((T = M.endZoom) == null || T.call(M));
    }
    switch (t.state) {
      case 4:
        i.endDolly();
        break;
      case 2:
        i.endPan();
        break;
      case 3:
        i.endSpin();
        break;
      case 1:
        i.endRotate();
        break;
    }
    t.state = 0, t.view && t.context.getInputMode().onInteractorEnd.notify(t.view), l(), t.drag = !1;
  }, a = () => {
    t.animationRequest = requestAnimationFrame(o);
  }, o = () => {
    t.animationRequest = requestAnimationFrame(o);
  }, l = () => {
    t.animationRequest && (cancelAnimationFrame(t.animationRequest), t.animationRequest = void 0);
  }, c = (f, T) => {
    const M = f.getRenderer(), N = M.getActiveCamera();
    N.getParallelProjection() ? N.setParallelScale(N.getParallelScale() / Math.pow(1.1, T)) : (N.dolly(Math.pow(1.1, T)), t.autoAdjustCameraClippingRange && M.resetCameraClippingRange());
  }, u = (f, T) => {
    console.log("pushOrigin (not implemented!)", f, T);
  }, d = (f, T) => {
    t.focalPoint = f.pickAll(T.x, T.y), t.grabFocalPoint = !0;
  }, h = (f) => {
    var N;
    t.context.getInputMode().onInteractorBegin.notify(f);
    const T = f.getRenderer().getActiveCamera(), M = [0, 0, 0];
    I.subtract(M, T.getPosition(), T.getFocalPoint()), T.setFocalPoint(...t.focalPoint), I.add(M, t.focalPoint, M), T.setPosition(...M), (N = f.getRenderer().getRenderWindow()) == null || N.render(), f.isViewMode3D() && t.options.mouseMode, t.context.getInputMode().onInteractorEnd.notify(f), f.cameraModified(), f.sceneRefresh();
  }, p = (f) => {
    f && f !== t.currentCursor ? t._interactor.getView().setCursor(f) : f !== t.defaultCursor && t._interactor.getView().setCursor(t.defaultCursor);
  }, m = () => ({
    mouseButtons: {
      left: t.leftDown,
      middle: t.middleDown,
      right: t.rightDown
    },
    cameraDragActive: t.drag
  }), b = () => {
    t.holdTimer && (clearInterval(t.holdTimer), t.holdTimer = null);
  }, y = (f, T) => {
    b(), t.holdTimer = setInterval(() => {
      Z(f);
    }, 50);
  };
  i.handleLeftButtonPress = (f) => {
    var F, P, j, H, B, $, A, E, ct, at, dt, gt;
    b();
    const T = e(f);
    if (!T)
      return;
    t.lastMouseDown = [f.position.x, f.position.y], t.lastMouseMove = [f.position.x, f.position.y], t.previousPosition = f.position, t.leftDown = !0, t.drag = !1, r();
    let M = null;
    const N = m(), W = t.windowLevelTools;
    if (W) {
      const Wt = (F = W.onLeftPress) == null ? void 0 : F.call(W, T, f, N);
      if (M = M || ((P = W.getCursor) == null ? void 0 : P.call(W)), Wt) {
        p(M), y(T);
        return;
      }
    }
    const x = t.activeMeasurementTools;
    if (x) {
      const Wt = (j = x.onLeftPress) == null ? void 0 : j.call(x, T, f, N);
      if (M = M || ((H = x.getCursor) == null ? void 0 : H.call(x)), Wt) {
        p(M), y(T);
        return;
      }
    }
    const V = n(T);
    if (V && V.length)
      for (const Wt of V) {
        const Zt = (B = Wt.onLeftPress) == null ? void 0 : B.call(Wt, T, f, N);
        if (M = M || (($ = Wt.getCursor) == null ? void 0 : $.call(Wt)), Zt) {
          p(M), y(T);
          return;
        }
      }
    const X = t.measurementTools;
    if (X) {
      const Wt = (A = X.onLeftPress) == null ? void 0 : A.call(X, T, f, N);
      if (M = M || ((E = X.getCursor) == null ? void 0 : E.call(X)), Wt) {
        p(M), y(T);
        return;
      }
    }
    const C = t.viewEventHandlers.get(T);
    if (C) {
      const Wt = (ct = C.onLeftPress) == null ? void 0 : ct.call(C, T, f, N);
      if (M = M || ((at = C.getCursor) == null ? void 0 : at.call(C)), Wt) {
        p(M), y(T);
        return;
      }
    }
    const R = t.cursorTools;
    if (R) {
      const Wt = (dt = R.onLeftPress) == null ? void 0 : dt.call(R, T, f, N);
      if (M = M || ((gt = R.getCursor) == null ? void 0 : gt.call(R)), Wt) {
        p(M), y(T);
        return;
      }
    }
    const z = eu(f);
    T.isViewMode3D() ? t.options.mouseMode === 1 ? z === 0 && t.options.cameraInteractorEnabled && t.rightDown && !t.middleDown && s(
      2
      /* IS_PAN */
    ) : t.options.mouseMode === 0 && z === 0 && t.options.cameraInteractorEnabled && (!t.rightDown && !t.middleDown ? s(
      1
      /* IS_ROTATE */
    ) : t.rightDown && !t.middleDown && s(
      2
      /* IS_PAN */
    )) : t.options.mouseMode2D === 1 ? z === 0 && t.options.cameraInteractorEnabled && t.rightDown && !t.middleDown && s(
      2
      /* IS_PAN */
    ) : t.options.mouseMode2D === 0 && z === 0 && t.options.cameraInteractorEnabled && !t.rightDown && t.middleDown, p(M), y(T);
  }, i.handleLeftButtonRelease = (f) => {
    var F, P, j, H, B, $, A, E, ct, at, dt, gt;
    b();
    const T = e(f);
    if (!T)
      return;
    t.leftDown = !1, r();
    let M = null;
    const N = m(), W = t.windowLevelTools;
    if (W) {
      const Wt = (F = W.onLeftRelease) == null ? void 0 : F.call(W, T, f, N);
      if (M = M || ((P = W.getCursor) == null ? void 0 : P.call(W)), Wt) {
        p(M), y(T);
        return;
      }
    }
    const x = t.activeMeasurementTools;
    if (x) {
      const Wt = (j = x.onLeftRelease) == null ? void 0 : j.call(x, T, f, N);
      if (M = M || ((H = x.getCursor) == null ? void 0 : H.call(x)), Wt) {
        p(M), y(T);
        return;
      }
    }
    const V = n(T);
    if (V && V.length)
      for (const Wt of V) {
        const Zt = (B = Wt.onLeftRelease) == null ? void 0 : B.call(Wt, T, f, N);
        if (M = M || (($ = Wt.getCursor) == null ? void 0 : $.call(Wt)), Zt) {
          p(M), y(T);
          return;
        }
      }
    const X = t.measurementTools;
    if (X) {
      const Wt = (A = X.onLeftRelease) == null ? void 0 : A.call(X, T, f, N);
      if (M = M || ((E = X.getCursor) == null ? void 0 : E.call(X)), Wt) {
        p(M), y(T);
        return;
      }
    }
    const C = t.viewEventHandlers.get(T);
    if (C) {
      const Wt = (ct = C.onLeftRelease) == null ? void 0 : ct.call(C, T, f, N);
      if (M = M || ((at = C.getCursor) == null ? void 0 : at.call(C)), Wt) {
        p(M), y(T);
        return;
      }
    }
    const R = t.cursorTools;
    if (R) {
      const Wt = (dt = R.onLeftRelease) == null ? void 0 : dt.call(R, T, f, N);
      if (M = M || ((gt = R.getCursor) == null ? void 0 : gt.call(R)), Wt) {
        p(M), y(T);
        return;
      }
    }
    const z = eu(f);
    T.isViewMode3D() ? z === 0 ? t.options.mouseMode === 1 ? t.options.cameraInteractorEnabled && t.rightDown && !t.middleDown ? s(
      1
      /* IS_ROTATE */
    ) : (i.invokeInteractionEvent({
      type: "EndInteractionEvent"
    }), t.context.getInputMode().onInteractorEnd.notify(T)) : t.options.cameraInteractorEnabled && t.rightDown && !t.middleDown ? s(4, f.position.x, f.position.y) : t.options.cameraInteractorEnabled && !t.rightDown && t.middleDown ? s(
      2
      /* IS_PAN */
    ) : (i.invokeInteractionEvent({
      type: "EndInteractionEvent"
    }), t.context.getInputMode().onInteractorEnd.notify(T)) : (i.invokeInteractionEvent({
      type: "EndInteractionEvent"
    }), t.context.getInputMode().onInteractorEnd.notify(T)) : t.options.mouseMode2D === 0 ? z === 0 ? t.options.cameraInteractorEnabled && t.rightDown && !t.middleDown ? s(4, f.position.x, f.position.y) : t.options.cameraInteractorEnabled && !t.rightDown && t.middleDown ? s(
      2
      /* IS_PAN */
    ) : (i.invokeInteractionEvent({
      type: "EndInteractionEvent"
    }), t.context.getInputMode().onInteractorEnd.notify(T)) : (i.invokeInteractionEvent({
      type: "EndInteractionEvent"
    }), t.context.getInputMode().onInteractorEnd.notify(T)) : t.options.mouseMode2D === 1 && (z === 0 ? (i.invokeInteractionEvent({
      type: "EndInteractionEvent"
    }), t.context.getInputMode().onInteractorEnd.notify(T)) : (i.invokeInteractionEvent({
      type: "EndInteractionEvent"
    }), t.context.getInputMode().onInteractorEnd.notify(T))), p(M), y(T);
  }, i.handleRightButtonPress = (f) => {
    var R, z, F, P, j, H, B, $;
    b();
    const T = e(f);
    if (!T)
      return;
    t.lastMouseDown = [f.position.x, f.position.y], t.lastMouseMove = [f.position.x, f.position.y], t.rightDown = !0, r();
    let M = null;
    const N = m(), W = t.activeMeasurementTools;
    if (W) {
      const A = (R = W.onRightPress) == null ? void 0 : R.call(W, T, f, N);
      if (M = M || ((z = W.getCursor) == null ? void 0 : z.call(W)), A) {
        p(M), y(T);
        return;
      }
    }
    const x = n(T);
    if (x && x.length)
      for (const A of x) {
        const E = (F = A.onRightPress) == null ? void 0 : F.call(A, T, f, N);
        if (M = M || ((P = A.getCursor) == null ? void 0 : P.call(A)), E) {
          p(M), y(T);
          return;
        }
      }
    const V = t.viewEventHandlers.get(T);
    if (V) {
      const A = (j = V.onRightPress) == null ? void 0 : j.call(V, T, f, N);
      if (M = M || ((H = V.getCursor) == null ? void 0 : H.call(V)), A) {
        p(M), y(T);
        return;
      }
    }
    const X = t.cursorTools;
    if (X) {
      const A = (B = X.onRightPress) == null ? void 0 : B.call(X, T, f, N);
      if (M = M || (($ = X.getCursor) == null ? void 0 : $.call(X)), A) {
        p(M), y(T);
        return;
      }
    }
    const C = eu(f);
    C === 1 ? t.options.cameraInteractorEnabled && t.rightDown && !t.middleDown && s(
      1
      /* IS_ROTATE */
    ) : C === 0 && t.options.cameraInteractorEnabled && (T.isViewMode3D() ? t.options.mouseMode === 1 ? !t.middleDown && !t.leftDown ? s(
      1
      /* IS_ROTATE */
    ) : !t.middleDown && t.leftDown && s(
      2
      /* IS_PAN */
    ) : t.options.mouseMode === 0 && (!t.middleDown && !t.leftDown ? s(4, f.position.x, f.position.y) : !t.middleDown && t.leftDown && s(
      2
      /* IS_PAN */
    )) : t.options.mouseMode2D === 1 ? !t.middleDown && t.leftDown && s(
      2
      /* IS_PAN */
    ) : t.options.mouseMode2D === 0 && !t.middleDown && !t.leftDown && s(4, f.position.x, f.position.y)), p(M), y(T);
  }, i.handleRightButtonRelease = (f) => {
    var R, z, F, P, j, H, B, $;
    b();
    const T = e(f);
    if (!T)
      return;
    t.rightDown = !1, r();
    let M = null;
    const N = m(), W = t.activeMeasurementTools;
    if (W) {
      const A = (R = W.onRightRelease) == null ? void 0 : R.call(W, T, f, N);
      if (M = M || ((z = W.getCursor) == null ? void 0 : z.call(W)), A) {
        p(M), y(T);
        return;
      }
    }
    const x = n(T);
    if (x && x.length)
      for (const A of x) {
        const E = (F = A.onRightRelease) == null ? void 0 : F.call(A, T, f, N);
        if (M = M || ((P = A.getCursor) == null ? void 0 : P.call(A)), E) {
          p(M), y(T);
          return;
        }
      }
    const V = t.viewEventHandlers.get(T);
    if (V) {
      const A = (j = V.onRightRelease) == null ? void 0 : j.call(V, T, f, N);
      if (M = M || ((H = V.getCursor) == null ? void 0 : H.call(V)), A) {
        p(M), y(T);
        return;
      }
    }
    const X = t.cursorTools;
    if (X) {
      const A = (B = X.onRightRelease) == null ? void 0 : B.call(X, T, f, N);
      if (M = M || (($ = X.getCursor) == null ? void 0 : $.call(X)), A) {
        p(M), y(T);
        return;
      }
    }
    const C = eu(f);
    t.options.cameraInteractorEnabled && (T.isViewMode3D() ? C === 0 && t.options.mouseMode === 0 && (t.leftDown && !t.middleDown ? s(
      1
      /* IS_ROTATE */
    ) : !t.leftDown && t.middleDown && s(
      2
      /* IS_PAN */
    )) : C === 0 && t.options.mouseMode2D === 0 && !t.leftDown && t.middleDown && s(
      2
      /* IS_PAN */
    )), p(M), y(T);
  }, i.handleMiddleButtonPress = (f) => {
    var C, R, z, F, P, j;
    b();
    const T = e(f);
    if (!T)
      return;
    t.lastMouseDown = [f.position.x, f.position.y], t.lastMouseMove = [f.position.x, f.position.y], t.middleDown = !0, t.grabFocalPoint = !1, r();
    let M = null;
    const N = m(), W = n(T);
    if (W && W.length)
      for (const H of W) {
        const B = (C = H.onMiddlePress) == null ? void 0 : C.call(H, T, f, N);
        if (M = M || ((R = H.getCursor) == null ? void 0 : R.call(H)), B) {
          p(M), y(T);
          return;
        }
      }
    const x = t.viewEventHandlers.get(T);
    if (x) {
      const H = (z = x.onMiddlePress) == null ? void 0 : z.call(x, T, f, N);
      if (M = M || ((F = x.getCursor) == null ? void 0 : F.call(x)), H) {
        p(M), y(T);
        return;
      }
    }
    const V = t.cursorTools;
    if (V) {
      const H = (P = V.onMiddlePress) == null ? void 0 : P.call(V, T, f, N);
      if (M = M || ((j = V.getCursor) == null ? void 0 : j.call(V)), H) {
        p(M), y(T);
        return;
      }
    }
    const X = eu(f);
    T.isViewMode3D() ? X === 0 && t.options.cameraInteractorEnabled && (t.options.mouseMode === 1 ? !t.leftDown && !t.rightDown && s(
      2
      /* IS_PAN */
    ) : t.options.mouseMode === 0 && !t.leftDown && !t.rightDown && s(
      2
      /* IS_PAN */
    )) : t.options.mouseMode2D === 0 && X === 0 && t.options.cameraInteractorEnabled && !t.leftDown && !t.rightDown && s(
      2
      /* IS_PAN */
    ), p(M), y(T);
  }, i.handleMiddleButtonRelease = (f) => {
    var R, z, F, P, j, H;
    b();
    const T = e(f);
    if (!T)
      return;
    t.middleDown = !1;
    const M = Math.pow(t.lastMouseDown[0] - f.position.x, 2) + Math.pow(t.lastMouseDown[1] - f.position.y, 2);
    r();
    let N = null;
    const W = m(), x = n(T);
    if (x && x.length)
      for (const B of x) {
        const $ = (R = B.onMiddleRelease) == null ? void 0 : R.call(B, T, f, W);
        if (N = N || ((z = B.getCursor) == null ? void 0 : z.call(B)), $) {
          p(N), y(T);
          return;
        }
      }
    const V = t.viewEventHandlers.get(T);
    if (V) {
      const B = (F = V.onMiddleRelease) == null ? void 0 : F.call(V, T, f, W);
      if (N = N || ((P = V.getCursor) == null ? void 0 : P.call(V)), B) {
        p(N), y(T);
        return;
      }
    }
    const X = t.cursorTools;
    if (X) {
      const B = (j = X.onMiddleRelease) == null ? void 0 : j.call(X, T, f, W);
      if (N = N || ((H = X.getCursor) == null ? void 0 : H.call(X)), B) {
        p(N), y(T);
        return;
      }
    }
    const C = eu(f);
    if (T.isViewMode3D())
      C === 0 && (t.options.mouseMode === 1 ? t.options.cameraInteractorEnabled && !t.drag && !t.leftDown && !t.rightDown && M < 1e-6 && (d(T, f.position), h(T)) : t.options.mouseMode === 0 && t.options.cameraInteractorEnabled && (!t.leftDown && t.rightDown ? s(4, f.position.x, f.position.y) : t.leftDown && !t.rightDown ? s(
        1
        /* IS_ROTATE */
      ) : !t.drag && !t.leftDown && !t.rightDown && M < 1e-6 && (d(T, f.position), h(T))));
    else if (t.options.mouseMode2D === 0)
      C === 0 && t.options.cameraInteractorEnabled && (!t.leftDown && t.rightDown ? s(
        4
        /* IS_DOLLY */
      ) : t.leftDown && !t.rightDown ? s(
        1
        /* IS_ROTATE */
      ) : !t.drag && !t.leftDown && !t.middleDown && !t.rightDown && M < 1e-6 && (d(T, f.position), h(T)));
    else if (t.options.mouseMode2D === 1 && C === 0) {
      const { x: B, y: $ } = f.position;
      Math.abs(t.lastMouseDown[0] - B) < 5 && Math.abs(t.lastMouseDown[1] - $) < 5 || t.leftDown && t.rightDown && s(
        2
        /* IS_PAN */
      );
    }
    p(N), y(T);
  }, i.handleMouseMove = (f) => {
    var j, H, B, $, A, E, ct, at, dt, gt, Wt, Zt;
    b();
    const T = e(f);
    if (!T)
      return;
    let M = null;
    const N = m(), W = t.windowLevelTools;
    if (W) {
      const Gt = (j = W.onMouseMove) == null ? void 0 : j.call(W, T, f, N);
      if (M = M || ((H = W.getCursor) == null ? void 0 : H.call(W)), Gt) {
        p(M), y(T);
        return;
      }
    }
    const x = t.activeMeasurementTools;
    if (x) {
      const Gt = (B = x.onMouseMove) == null ? void 0 : B.call(x, T, f, N);
      if (M = M || (($ = x.getCursor) == null ? void 0 : $.call(x)), Gt) {
        p(M), y(T);
        return;
      }
    }
    const V = n(T);
    if (V && V.length)
      for (const Gt of V) {
        const Tt = (A = Gt.onMouseMove) == null ? void 0 : A.call(Gt, T, f, N);
        if (M = M || ((E = Gt.getCursor) == null ? void 0 : E.call(Gt)), Tt) {
          p(M), y(T);
          return;
        }
      }
    const X = t.measurementTools;
    if (X) {
      const Gt = (ct = X.onMouseMove) == null ? void 0 : ct.call(X, T, f, N);
      if (M = M || ((at = X.getCursor) == null ? void 0 : at.call(X)), Gt) {
        p(M), y(T);
        return;
      }
    }
    const C = t.viewEventHandlers.get(T);
    let R = !1;
    if (C && (C.onMouseMove && (R = (dt = C.onMouseMove) == null ? void 0 : dt.call(C, T, f, N)), M = M || ((gt = C.getCursor) == null ? void 0 : gt.call(C)), R)) {
      p(M), y(T);
      return;
    }
    const z = t.cursorTools;
    if (z) {
      const Gt = (Wt = z.onMouseMove) == null ? void 0 : Wt.call(z, T, f, N);
      if (M = M || ((Zt = z.getCursor) == null ? void 0 : Zt.call(z)), Gt) {
        p(M), y(T);
        return;
      }
    }
    const F = f.position, P = T.getRenderer();
    if (t.state != 0 && t.options.cameraInteractorEnabled) {
      switch (t.state) {
        case 1:
          i.handleMouseRotate(P, F), i.invokeInteractionEvent({
            type: "InteractionEvent"
          });
          break;
        case 2:
          if (t.view) {
            const Gt = t.view.getPresenterWindow();
            Gt ? Gt.panWidget(F) : (i.handleMousePan(P, F), i.invokeInteractionEvent({
              type: "InteractionEvent"
            })), t.lastMouseMove = [f.position.x, f.position.y];
          } else
            i.handleMousePan(P, F), i.invokeInteractionEvent({
              type: "InteractionEvent"
            });
          break;
        case 4:
          if (t.view) {
            const Gt = t.view.getPresenterWindow();
            Gt ? Gt.zoomWidget(F.x - t.lastMouseMove[0], F.y - t.lastMouseMove[1]) : (i.handleMouseDolly(P, F), i.invokeInteractionEvent({
              type: "InteractionEvent"
            })), t.lastMouseMove = [f.position.x, f.position.y];
          } else
            i.handleMouseDolly(P, F), i.invokeInteractionEvent({
              type: "InteractionEvent"
            });
          break;
        case 3:
          i.handleMouseSpin(P, F), i.invokeInteractionEvent({
            type: "InteractionEvent"
          });
          break;
      }
      t.context.repaint(), t.context.getInputMode().onInteractorModified.notify(T);
    }
    p(M), y(T), t.previousPosition = F;
  };
  const Z = (f, T) => {
    var x, V, X;
    if (!f)
      return;
    const M = n(f);
    if (M && M.length) {
      for (const C of M)
        if ((x = C.onMouseHold) == null ? void 0 : x.call(C))
          return;
    }
    const N = t.viewEventHandlers.get(f);
    if (N && ((V = N.onMouseHold) == null ? void 0 : V.call(N)))
      return;
    const W = t.cursorTools;
    W && ((X = W.onMouseHold) != null && X.call(W));
  };
  i.handleStartMouseWheel = () => {
  }, i.handleMouseWheel = (f) => {
    var X, C, R, z, F;
    if (b(), !Number.isFinite(f.spinY) || f.spinY === 0)
      return;
    const T = e(f);
    if (!T)
      return;
    const M = m(), N = n(T);
    if (N && N.length) {
      for (const P of N)
        if ((X = P == null ? void 0 : P.onMouseWheel) != null && X.call(P, T, f, M)) {
          y(T);
          return;
        }
    }
    if ((R = (C = t.viewEventHandlers.get(T)) == null ? void 0 : C.onMouseWheel) != null && R.call(C, T, f, M)) {
      y(T);
      return;
    }
    if ((F = (z = t.cursorTools) == null ? void 0 : z.onMouseWheel) != null && F.call(z, T, f, M)) {
      y(T);
      return;
    }
    const W = eu(f), x = f.spinY > 0, V = (P) => {
      s(
        4
        /* IS_DOLLY */
      );
      const j = t.motionFactor * -0.2 * (P ? 1 : -1) * t.mouseWheelMotionFactor;
      c(T, j), r(), T.cameraModified();
    };
    T.isViewMode3D() ? W === 0 && t.options.cameraInteractorEnabled && !t.leftDown && !t.middleDown && !t.rightDown && V(x) : t.options.mouseMode2D === 0 ? t.options.cameraInteractorEnabled && !t.leftDown && !t.middleDown && t.rightDown : t.options.mouseMode2D === 1 && W === 0 && V(x), y(T);
  }, i.handleEndMouseWheel = () => {
  }, i.handleKeyDown = (f) => {
    var C, R, z, F, P, j;
    const T = e(f);
    if (!T)
      return;
    let M = null;
    const N = m(), W = n(T);
    if (W && W.length)
      for (const H of W) {
        const B = (C = H.onKeyDown) == null ? void 0 : C.call(H, T, f, N);
        if (M = M || ((R = H.getCursor) == null ? void 0 : R.call(H)), B) {
          p(M);
          return;
        }
      }
    const x = t.viewEventHandlers.get(T);
    if (x) {
      const H = (z = x.onKeyDown) == null ? void 0 : z.call(x, T, f, N);
      if (M = M || ((F = x.getCursor) == null ? void 0 : F.call(x)), H) {
        p(M);
        return;
      }
    }
    const V = t.cursorTools;
    if (V) {
      const H = (P = V.onKeyDown) == null ? void 0 : P.call(V, T, f, N);
      if (M = M || ((j = V.getCursor) == null ? void 0 : j.call(V)), H) {
        p(M);
        return;
      }
    }
    const X = eu(f);
    X === 3 && f.key === "z" && console.log("undo"), X === 3 && f.key === "y" && console.log("redo"), T.isViewMode3D() || (f.key === "ArrowLeft" ? u(!1, 1) : f.key === "ArrowRight" && u(!1, -1)), T.isViewMode3D() ? t.options.mouseMode === 0 && !t.cursorMode && f.key === " " && (r(), t.cursorMode = !0) : t.options.mouseMode2D === 0 && !t.cursorMode && f.key === " " && (r(), t.cursorMode = !0), t.context.getInputMode().onKeyPressRelease.notify({
      symbol: f.key,
      autoRepeat: t.keyAutoRepeat,
      modKeys: X,
      press: !0
    }), p(M);
  }, i.handleKeyUp = (f) => {
    var C, R, z, F, P, j;
    const T = e(f);
    if (!T)
      return;
    let M = null;
    const N = m(), W = n(T);
    if (W && W.length)
      for (const H of W) {
        const B = (C = H.onKeyUp) == null ? void 0 : C.call(H, T, f, N);
        if (M = M || ((R = H.getCursor) == null ? void 0 : R.call(H)), B) {
          p(M);
          return;
        }
      }
    const x = t.viewEventHandlers.get(T);
    if (x) {
      const H = (z = x.onKeyUp) == null ? void 0 : z.call(x, T, f, N);
      if (M = M || ((F = x.getCursor) == null ? void 0 : F.call(x)), H) {
        p(M);
        return;
      }
    }
    const V = t.cursorTools;
    if (V) {
      const H = (P = V.onKeyUp) == null ? void 0 : P.call(V, T, f, N);
      if (M = M || ((j = V.getCursor) == null ? void 0 : j.call(V)), H) {
        p(M);
        return;
      }
    }
    const X = eu(f);
    T.isViewMode3D() ? t.options.mouseMode === 0 && (t.cursorMode && f.key === " " ? (t.cursorMode = !1, r(), t.options.cameraInteractorEnabled && (!t.leftDown && t.rightDown && !t.middleDown ? s(4, t.previousPosition.x, t.previousPosition.y) : t.leftDown && !t.rightDown && !t.middleDown ? s(
      1
      /* IS_ROTATE */
    ) : t.leftDown && !t.rightDown && t.middleDown && s(
      2
      /* IS_PAN */
    ))) : t.state === 2 && (r(), t.options.cameraInteractorEnabled && (t.leftDown && !t.middleDown ? s(
      1
      /* IS_ROTATE */
    ) : !t.leftDown && t.middleDown && s(
      2
      /* IS_PAN */
    )))) : t.options.mouseMode2D === 0 && (t.cursorMode && f.key === " " ? (t.cursorMode = !1, r(), t.options.cameraInteractorEnabled && (!t.leftDown && t.rightDown && !t.middleDown ? s(4, t.previousPosition.x, t.previousPosition.y) : !t.leftDown && !t.rightDown && t.middleDown && s(
      2
      /* IS_PAN */
    ))) : t.state === 2 && (r(), t.options.cameraInteractorEnabled && (t.leftDown && !t.middleDown ? s(
      1
      /* IS_ROTATE */
    ) : !t.leftDown && t.middleDown && s(
      2
      /* IS_PAN */
    )))), t.context.getInputMode().onKeyPressRelease.notify({
      symbol: f.key,
      autoRepeat: t.keyAutoRepeat,
      modKeys: X,
      press: !1
    }), p(M);
  }, i.handleKeyPress = (f) => {
    var X, C, R, z, F, P;
    const T = e(f);
    if (!T)
      return;
    let M = null;
    const N = m(), W = n(T);
    if (W && W.length)
      for (const j of W) {
        const H = (X = j.onKeyPress) == null ? void 0 : X.call(j, T, f, N);
        if (M = M || ((C = j.getCursor) == null ? void 0 : C.call(j)), H) {
          p(M);
          return;
        }
      }
    const x = t.viewEventHandlers.get(T);
    if (x) {
      const j = (R = x.onKeyPress) == null ? void 0 : R.call(x, T, f, N);
      if (M = M || ((z = x.getCursor) == null ? void 0 : z.call(x)), j) {
        p(M);
        return;
      }
    }
    const V = t.cursorTools;
    if (V) {
      const j = (F = V.onKeyPress) == null ? void 0 : F.call(V, T, f, N);
      if (M = M || ((P = V.getCursor) == null ? void 0 : P.call(V)), j) {
        p(M);
        return;
      }
    }
    p(M);
  }, i.handleMouseEnter = (f) => {
    var X, C, R, z, F, P;
    const T = e(f);
    if (!T)
      return;
    let M = null;
    const N = m(), W = n(T);
    if (W && W.length)
      for (const j of W) {
        const H = (X = j.onMouseEnter) == null ? void 0 : X.call(j, T, f, N);
        if (M = M || ((C = j.getCursor) == null ? void 0 : C.call(j)), H) {
          p(M);
          return;
        }
      }
    const x = t.viewEventHandlers.get(T);
    if (x) {
      const j = (R = x.onMouseEnter) == null ? void 0 : R.call(x, T, f, N);
      if (M = M || ((z = x.getCursor) == null ? void 0 : z.call(x)), j) {
        p(M);
        return;
      }
    }
    const V = t.cursorTools;
    if (V) {
      const j = (F = V.onMouseEnter) == null ? void 0 : F.call(V, T, f, N);
      if (M = M || ((P = V.getCursor) == null ? void 0 : P.call(V)), j) {
        p(M);
        return;
      }
    }
    p(M);
  }, i.handleMouseLeave = (f) => {
    var X, C, R, z, F, P;
    const T = e(f);
    if (!T)
      return;
    let M = null;
    const N = m(), W = n(T);
    if (W && W.length)
      for (const j of W) {
        const H = (X = j.onMouseLeave) == null ? void 0 : X.call(j, T, f, N);
        if (M = M || ((C = j.getCursor) == null ? void 0 : C.call(j)), H) {
          p(M);
          return;
        }
      }
    const x = t.viewEventHandlers.get(T);
    if (x) {
      const j = (R = x.onMouseLeave) == null ? void 0 : R.call(x, T, f, N);
      if (M = M || ((z = x.getCursor) == null ? void 0 : z.call(x)), j) {
        p(M);
        return;
      }
    }
    const V = t.cursorTools;
    if (V) {
      const j = (F = V.onMouseLeave) == null ? void 0 : F.call(V, T, f, N);
      if (M = M || ((P = V.getCursor) == null ? void 0 : P.call(V)), j) {
        p(M);
        return;
      }
    }
    p(M);
  }, i.getMouseMode = () => t.options.mouseMode, i.setMouseMode = (f) => {
    t.options.mouseMode = f;
  }, i.getMouseMode2D = () => t.options.mouseMode2D, i.setMouseMode2D = (f) => {
    t.options.mouseMode2D = f;
  }, i.getCameraInteractorEnabled = () => t.options.cameraInteractorEnabled, i.setCameraInteractorEnabled = (f) => {
    t.options.cameraInteractorEnabled = f;
  }, i.setWindowLevelTool = (f) => {
    f ? t.windowLevelTools = f : t.windowLevelTools = null;
  }, i.setActiveMeasurementTool = (f) => {
    f ? t.activeMeasurementTools = f : t.activeMeasurementTools = null;
  }, i.setActiveTool = (f, T) => {
    t.context.toolManager.setTool(sn.NONE, on.PRIMARY), t.context.toolManager.setTool(sn.NONE, on.SECONDARY), t.context.toolManager.setTool(sn.NONE, on.TERTIARY), t.context.toolManager.setTool(sn.NONE, on.QUATERNARY), T ? t.activeTools.set(f, T) : t.activeTools.delete(f);
  }, i.setMeasurementTool = (f) => {
    f ? t.measurementTools = f : t.measurementTools = null;
  }, i.setViewEventHandler = (f, T) => {
    T ? t.viewEventHandlers.set(f, T) : t.viewEventHandlers.delete(f);
  }, i.setCursorTool = (f) => {
    f ? t.cursorTools = f : t.cursorTools = null;
  }, i.setMeasurementToolDragActive = (f) => {
    t.measurementToolDragActive = f;
  };
  const g = {
    Rotate: 1,
    Pan: 2,
    Spin: 3,
    Dolly: 4,
    CameraPose: 11,
    WindowLevel: 1024,
    Slice: 1025
    /* IS_SLICE */
  };
  Object.keys(g).forEach((f) => {
    i[`start${f}`] = () => {
      t.state === 0 && (t.state = g[f], i.invokeStartInteractionEvent({
        type: "StartInteractionEvent"
      }), i[`invokeStart${f}Event`]({ type: `Start${f}Event` }), f === "Rotate" && t.view && t.context.getInputMode().onRotateBegin.notify(t.view));
    }, i[`end${f}`] = () => {
      t.state === g[f] && (t.state = 0, i.invokeEndInteractionEvent({
        type: "EndInteractionEvent"
      }), i[`invokeEnd${f}Event`]({ type: `End${f}Event` }), f === "Rotate" && t.view && t.context.getInputMode().onRotateEnd.notify(t.view), t._interactor.render());
    };
  });
}
const k2t = {
  options: {
    mouseMode: 0,
    mouseMode2D: 0,
    cameraInteractorEnabled: !0
  }
}, F2t = {
  motionFactor: 10,
  zoomFactor: 10
};
function ZJ(i, t, e = {}) {
  Object.assign(t, k2t, e), GC.extend(i, t, F2t), E2t(i, t);
}
const j2t = tt.newInstance(ZJ, "xInteractorStyle"), U2t = { newInstance: j2t, extend: ZJ };
var ni = /* @__PURE__ */ ((i) => (i[i.PresenterWindow2D = 0] = "PresenterWindow2D", i[i.PresenterWindow3D = 1] = "PresenterWindow3D", i[i.PresenterWindow2DCustom = 2] = "PresenterWindow2DCustom", i))(ni || {});
class wC {
  constructor(t, e) {
    S(this, "context");
    S(this, "mainView", null);
    //public views: IView[] = [];
    S(this, "overlayContainer");
    S(this, "viewport");
    S(this, "toolbarEnabled", new qt(!0));
    S(this, "onCleanupArray", []);
    S(this, "isFullscreen", new qt(!1));
    S(this, "setFullscreenEvent", new se());
    S(this, "screenshotEvent", new se());
    S(this, "lastLayout", []);
    S(this, "presenterWindowType");
    S(this, "window", new qt(4e3));
    S(this, "level", new qt(1e3));
    this.context = t, this.presenterWindowType = e, this.viewport = new qt(Ce.fullscreen);
    const { onEvent: n, cleanupAll: s } = An();
    this.onCleanup(() => s()), this.overlayContainer = new vU(
      this.context.getOverlayContainer(),
      this.viewport,
      this.context.layoutManager.borderWidth,
      this.context.layoutManager.gapWidth,
      "100"
    ), this.onCleanup(() => this.overlayContainer.delete), n(this.setFullscreenEvent, ({ value: r }) => {
      r ? (this.lastLayout = t.getLayout(), t.setLayout([[this, Ce.fullscreen]])) : t.setLayout(this.lastLayout), this.isFullscreen.set(r);
    });
  }
  setViewport(t) {
    this.isFullscreen.set(!1), this.viewport.set(t);
  }
  computeViewViewport(t) {
    const { xmin: e, xmax: n, ymin: s, ymax: r } = this.viewport.get(), a = n - e, o = r - s;
    return {
      xmin: e + a * t.xmin,
      xmax: e + a * t.xmax,
      ymin: s + o * t.ymin,
      ymax: s + o * t.ymax
    };
  }
  setViewViewport(t, e) {
    t.setViewport(this.computeViewViewport(e));
  }
  show(t) {
    var e;
    (e = this.mainView) == null || e.show(t), this.overlayContainer.show();
  }
  hide() {
    var t;
    this.overlayContainer.hide(), (t = this.mainView) == null || t.hide();
  }
  getMainView() {
    return this.mainView;
  }
  getViews() {
    return null;
  }
  setToolbarEnabled(t) {
    this.toolbarEnabled.set(t);
  }
  onCleanup(t) {
    this.onCleanupArray.push(t);
  }
  cleanup() {
    this.onCleanupArray.reduceRight((t, e) => (e(), null), null);
  }
  createScreenshotFilename(t) {
    var o;
    const e = /* @__PURE__ */ new Date(), n = (l) => String(l).padStart(2, "0"), r = String(((o = this.context.projectInfo) == null ? void 0 : o.projectFilename) ?? "Screenshot").replace(".zip", "").replace(/[\\/:*?"<>|]/g, "_").trim() || "Screenshot", a = Nt[t] ?? "View";
    return `${r}_${a}_${e.getFullYear()}-${n(e.getMonth() + 1)}-${n(e.getDate())}_${n(e.getHours())}.${n(e.getMinutes())}.${n(e.getSeconds())}.png`;
  }
  async convertDataUrlToBlob(t) {
    try {
      const e = await fetch(t);
      return e.ok ? await e.blob() : null;
    } catch {
      return null;
    }
  }
  async downloadAndNotifyScreenshot(t, e) {
    const n = await this.convertDataUrlToBlob(t);
    if (!n)
      return;
    const s = this.createScreenshotFilename(e), r = window.URL.createObjectURL(n), a = document.createElement("a");
    document.body.appendChild(a), a.href = r, a.download = s, a.click(), a.remove(), window.setTimeout(() => window.URL.revokeObjectURL(r), 0), this.context.screenshotUploadEvent.notify({
      filename: s,
      image: n
    });
  }
  setSliceInfoNormal() {
  }
  zoomWidget(t, e) {
    var n;
    (n = this.mainView) == null || n.zoomWidget(t, e);
  }
  startZoom(t, e, n) {
    var r;
    const s = n.displayToWorld(t, e, 0);
    (r = this.mainView) == null || r.startZoom(s[0], s[1], s[2]);
  }
  endZoom() {
    var t;
    (t = this.mainView) == null || t.endZoom();
  }
  panWidget(t) {
  }
  setViewOrigin(t) {
  }
  setViewMatrix(t) {
  }
  getViewMatrix() {
    return ut.create();
  }
  getBookmark() {
    var t;
    return {
      id: ((t = this.mainView) == null ? void 0 : t.id) || -1,
      matrix: ut.clone(this.getViewMatrix())
    };
  }
  rotateView(t, e) {
  }
  setWindowLevel(t) {
    console.log("setwindowlevel base", this);
  }
  hideOverlayComponents(t) {
    console.log("hideOverlayComponents base", t);
  }
}
class P2t {
  constructor() {
    S(this, "onInteractorBegin", new se());
    S(this, "onInteractorEnd", new se());
    S(this, "onInteractorModified", new se());
    S(this, "onRotateBegin", new se());
    S(this, "onRotateEnd", new se());
    S(this, "onKeyPressRelease", new se());
  }
}
function J2t(i, t) {
  if (i.match(/^[a-z]+:\/\//i))
    return i;
  if (i.match(/^\/\//))
    return window.location.protocol + i;
  if (i.match(/^[a-z]+:/i))
    return i;
  const e = document.implementation.createHTMLDocument(), n = e.createElement("base"), s = e.createElement("a");
  return e.head.appendChild(n), e.body.appendChild(s), t && (n.href = t), s.href = i, s.href;
}
const A2t = /* @__PURE__ */ (() => {
  let i = 0;
  const t = () => (
    // eslint-disable-next-line no-bitwise
    `0000${(Math.random() * 36 ** 4 << 0).toString(36)}`.slice(-4)
  );
  return () => (i += 1, `u${t()}${i}`);
})();
function Ph(i) {
  const t = [];
  for (let e = 0, n = i.length; e < n; e++)
    t.push(i[e]);
  return t;
}
let eb = null;
function TJ(i = {}) {
  return eb || (i.includeStyleProperties ? (eb = i.includeStyleProperties, eb) : (eb = Ph(window.getComputedStyle(document.documentElement)), eb));
}
function YW(i, t) {
  const n = (i.ownerDocument.defaultView || window).getComputedStyle(i).getPropertyValue(t);
  return n ? parseFloat(n.replace("px", "")) : 0;
}
function B2t(i) {
  const t = YW(i, "border-left-width"), e = YW(i, "border-right-width");
  return i.clientWidth + t + e;
}
function K2t(i) {
  const t = YW(i, "border-top-width"), e = YW(i, "border-bottom-width");
  return i.clientHeight + t + e;
}
function MJ(i, t = {}) {
  const e = t.width || B2t(i), n = t.height || K2t(i);
  return { width: e, height: n };
}
function H2t() {
  let i, t;
  try {
    t = process;
  } catch {
  }
  const e = t && t.env ? t.env.devicePixelRatio : null;
  return e && (i = parseInt(e, 10), Number.isNaN(i) && (i = 1)), i || window.devicePixelRatio || 1;
}
const Ka = 16384;
function _2t(i) {
  (i.width > Ka || i.height > Ka) && (i.width > Ka && i.height > Ka ? i.width > i.height ? (i.height *= Ka / i.width, i.width = Ka) : (i.width *= Ka / i.height, i.height = Ka) : i.width > Ka ? (i.height *= Ka / i.width, i.width = Ka) : (i.width *= Ka / i.height, i.height = Ka));
}
function vW(i) {
  return new Promise((t, e) => {
    const n = new Image();
    n.onload = () => {
      n.decode().then(() => {
        requestAnimationFrame(() => t(n));
      });
    }, n.onerror = e, n.crossOrigin = "anonymous", n.decoding = "async", n.src = i;
  });
}
async function Q2t(i) {
  return Promise.resolve().then(() => new XMLSerializer().serializeToString(i)).then(encodeURIComponent).then((t) => `data:image/svg+xml;charset=utf-8,${t}`);
}
async function $2t(i, t, e) {
  const n = "http://www.w3.org/2000/svg", s = document.createElementNS(n, "svg"), r = document.createElementNS(n, "foreignObject");
  return s.setAttribute("width", `${t}`), s.setAttribute("height", `${e}`), s.setAttribute("viewBox", `0 0 ${t} ${e}`), r.setAttribute("width", "100%"), r.setAttribute("height", "100%"), r.setAttribute("x", "0"), r.setAttribute("y", "0"), r.setAttribute("externalResourcesRequired", "true"), s.appendChild(r), r.appendChild(i), Q2t(s);
}
const Ua = (i, t) => {
  if (i instanceof t)
    return !0;
  const e = Object.getPrototypeOf(i);
  return e === null ? !1 : e.constructor.name === t.name || Ua(e, t);
};
function q2t(i) {
  const t = i.getPropertyValue("content");
  return `${i.cssText} content: '${t.replace(/'|"/g, "")}';`;
}
function tZt(i, t) {
  return TJ(t).map((e) => {
    const n = i.getPropertyValue(e), s = i.getPropertyPriority(e);
    return `${e}: ${n}${s ? " !important" : ""};`;
  }).join(" ");
}
function eZt(i, t, e, n) {
  const s = `.${i}:${t}`, r = e.cssText ? q2t(e) : tZt(e, n);
  return document.createTextNode(`${s}{${r}}`);
}
function iz(i, t, e, n) {
  const s = window.getComputedStyle(i, e), r = s.getPropertyValue("content");
  if (r === "" || r === "none")
    return;
  const a = A2t();
  try {
    t.className = `${t.className} ${a}`;
  } catch {
    return;
  }
  const o = document.createElement("style");
  o.appendChild(eZt(a, e, s, n)), t.appendChild(o);
}
function nZt(i, t, e) {
  iz(i, t, ":before", e), iz(i, t, ":after", e);
}
const sz = "application/font-woff", rz = "image/jpeg", iZt = {
  woff: sz,
  woff2: sz,
  ttf: "application/font-truetype",
  eot: "application/vnd.ms-fontobject",
  png: "image/png",
  jpg: rz,
  jpeg: rz,
  gif: "image/gif",
  tiff: "image/tiff",
  svg: "image/svg+xml",
  webp: "image/webp"
};
function sZt(i) {
  const t = /\.([^./]*?)$/g.exec(i);
  return t ? t[1] : "";
}
function xC(i) {
  const t = sZt(i).toLowerCase();
  return iZt[t] || "";
}
function rZt(i) {
  return i.split(/,/)[1];
}
function qL(i) {
  return i.search(/^(data:)/) !== -1;
}
function aZt(i, t) {
  return `data:${t};base64,${i}`;
}
async function NJ(i, t, e) {
  const n = await fetch(i, t);
  if (n.status === 404)
    throw new Error(`Resource "${n.url}" not found`);
  const s = await n.blob();
  return new Promise((r, a) => {
    const o = new FileReader();
    o.onerror = a, o.onloadend = () => {
      try {
        r(e({ res: n, result: o.result }));
      } catch (l) {
        a(l);
      }
    }, o.readAsDataURL(s);
  });
}
const oS = {};
function oZt(i, t, e) {
  let n = i.replace(/\?.*/, "");
  return e && (n = i), /ttf|otf|eot|woff2?/i.test(n) && (n = n.replace(/.*\//, "")), t ? `[${t}]${n}` : n;
}
async function SC(i, t, e) {
  const n = oZt(i, t, e.includeQueryParams);
  if (oS[n] != null)
    return oS[n];
  e.cacheBust && (i += (/\?/.test(i) ? "&" : "?") + (/* @__PURE__ */ new Date()).getTime());
  let s;
  try {
    const r = await NJ(i, e.fetchRequestInit, ({ res: a, result: o }) => (t || (t = a.headers.get("Content-Type") || ""), rZt(o)));
    s = aZt(r, t);
  } catch (r) {
    s = e.imagePlaceholder || "";
    let a = `Failed to fetch resource: ${i}`;
    r && (a = typeof r == "string" ? r : r.message), a && console.warn(a);
  }
  return oS[n] = s, s;
}
async function lZt(i) {
  const t = i.toDataURL();
  return t === "data:," ? i.cloneNode(!1) : vW(t);
}
async function cZt(i, t) {
  if (i.currentSrc) {
    const r = document.createElement("canvas"), a = r.getContext("2d");
    r.width = i.clientWidth, r.height = i.clientHeight, a == null || a.drawImage(i, 0, 0, r.width, r.height);
    const o = r.toDataURL();
    return vW(o);
  }
  const e = i.poster, n = xC(e), s = await SC(e, n, t);
  return vW(s);
}
async function uZt(i, t) {
  var e;
  try {
    if (!((e = i == null ? void 0 : i.contentDocument) === null || e === void 0) && e.body)
      return await sw(i.contentDocument.body, t, !0);
  } catch {
  }
  return i.cloneNode(!1);
}
async function dZt(i, t) {
  return Ua(i, HTMLCanvasElement) ? lZt(i) : Ua(i, HTMLVideoElement) ? cZt(i, t) : Ua(i, HTMLIFrameElement) ? uZt(i, t) : i.cloneNode(WJ(i));
}
const hZt = (i) => i.tagName != null && i.tagName.toUpperCase() === "SLOT", WJ = (i) => i.tagName != null && i.tagName.toUpperCase() === "SVG";
async function pZt(i, t, e) {
  var n, s;
  if (WJ(t))
    return t;
  let r = [];
  return hZt(i) && i.assignedNodes ? r = Ph(i.assignedNodes()) : Ua(i, HTMLIFrameElement) && (!((n = i.contentDocument) === null || n === void 0) && n.body) ? r = Ph(i.contentDocument.body.childNodes) : r = Ph(((s = i.shadowRoot) !== null && s !== void 0 ? s : i).childNodes), r.length === 0 || Ua(i, HTMLVideoElement) || await r.reduce((a, o) => a.then(() => sw(o, e)).then((l) => {
    l && t.appendChild(l);
  }), Promise.resolve()), t;
}
function mZt(i, t, e) {
  const n = t.style;
  if (!n)
    return;
  const s = window.getComputedStyle(i);
  s.cssText ? (n.cssText = s.cssText, n.transformOrigin = s.transformOrigin) : TJ(e).forEach((r) => {
    let a = s.getPropertyValue(r);
    r === "font-size" && a.endsWith("px") && (a = `${Math.floor(parseFloat(a.substring(0, a.length - 2))) - 0.1}px`), Ua(i, HTMLIFrameElement) && r === "display" && a === "inline" && (a = "block"), r === "d" && t.getAttribute("d") && (a = `path(${t.getAttribute("d")})`), n.setProperty(r, a, s.getPropertyPriority(r));
  });
}
function bZt(i, t) {
  Ua(i, HTMLTextAreaElement) && (t.innerHTML = i.value), Ua(i, HTMLInputElement) && t.setAttribute("value", i.value);
}
function fZt(i, t) {
  if (Ua(i, HTMLSelectElement)) {
    const e = t, n = Array.from(e.children).find((s) => i.value === s.getAttribute("value"));
    n && n.setAttribute("selected", "");
  }
}
function gZt(i, t, e) {
  return Ua(t, Element) && (mZt(i, t, e), nZt(i, t, e), bZt(i, t), fZt(i, t)), t;
}
async function yZt(i, t) {
  const e = i.querySelectorAll ? i.querySelectorAll("use") : [];
  if (e.length === 0)
    return i;
  const n = {};
  for (let r = 0; r < e.length; r++) {
    const o = e[r].getAttribute("xlink:href");
    if (o) {
      const l = i.querySelector(o), c = document.querySelector(o);
      !l && c && !n[o] && (n[o] = await sw(c, t, !0));
    }
  }
  const s = Object.values(n);
  if (s.length) {
    const r = "http://www.w3.org/1999/xhtml", a = document.createElementNS(r, "svg");
    a.setAttribute("xmlns", r), a.style.position = "absolute", a.style.width = "0", a.style.height = "0", a.style.overflow = "hidden", a.style.display = "none";
    const o = document.createElementNS(r, "defs");
    a.appendChild(o);
    for (let l = 0; l < s.length; l++)
      o.appendChild(s[l]);
    i.appendChild(a);
  }
  return i;
}
async function sw(i, t, e) {
  return !e && t.filter && !t.filter(i) ? null : Promise.resolve(i).then((n) => dZt(n, t)).then((n) => pZt(i, n, t)).then((n) => gZt(i, n, t)).then((n) => yZt(n, t));
}
const GJ = /url\((['"]?)([^'"]+?)\1\)/g, ZZt = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g, TZt = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function MZt(i) {
  const t = i.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
  return new RegExp(`(url\\(['"]?)(${t})(['"]?\\))`, "g");
}
function NZt(i) {
  const t = [];
  return i.replace(GJ, (e, n, s) => (t.push(s), e)), t.filter((e) => !qL(e));
}
async function WZt(i, t, e, n, s) {
  try {
    const r = e ? J2t(t, e) : t, a = xC(t);
    let o;
    return s || (o = await SC(r, a, n)), i.replace(MZt(t), `$1${o}$3`);
  } catch {
  }
  return i;
}
function GZt(i, { preferredFontFormat: t }) {
  return t ? i.replace(TZt, (e) => {
    for (; ; ) {
      const [n, , s] = ZZt.exec(e) || [];
      if (!s)
        return "";
      if (s === t)
        return `src: ${n};`;
    }
  }) : i;
}
function wJ(i) {
  return i.search(GJ) !== -1;
}
async function xJ(i, t, e) {
  if (!wJ(i))
    return i;
  const n = GZt(i, e);
  return NZt(n).reduce((r, a) => r.then((o) => WZt(o, a, t, e)), Promise.resolve(n));
}
async function nb(i, t, e) {
  var n;
  const s = (n = t.style) === null || n === void 0 ? void 0 : n.getPropertyValue(i);
  if (s) {
    const r = await xJ(s, null, e);
    return t.style.setProperty(i, r, t.style.getPropertyPriority(i)), !0;
  }
  return !1;
}
async function wZt(i, t) {
  await nb("background", i, t) || await nb("background-image", i, t), await nb("mask", i, t) || await nb("-webkit-mask", i, t) || await nb("mask-image", i, t) || await nb("-webkit-mask-image", i, t);
}
async function xZt(i, t) {
  const e = Ua(i, HTMLImageElement);
  if (!(e && !qL(i.src)) && !(Ua(i, SVGImageElement) && !qL(i.href.baseVal)))
    return;
  const n = e ? i.src : i.href.baseVal, s = await SC(n, xC(n), t);
  await new Promise((r, a) => {
    i.onload = r, i.onerror = t.onImageErrorHandler ? (...l) => {
      try {
        r(t.onImageErrorHandler(...l));
      } catch (c) {
        a(c);
      }
    } : a;
    const o = i;
    o.decode && (o.decode = r), o.loading === "lazy" && (o.loading = "eager"), e ? (i.srcset = "", i.src = s) : i.href.baseVal = s;
  });
}
async function SZt(i, t) {
  const n = Ph(i.childNodes).map((s) => SJ(s, t));
  await Promise.all(n).then(() => i);
}
async function SJ(i, t) {
  Ua(i, Element) && (await wZt(i, t), await xZt(i, t), await SZt(i, t));
}
function LZt(i, t) {
  const { style: e } = i;
  t.backgroundColor && (e.backgroundColor = t.backgroundColor), t.width && (e.width = `${t.width}px`), t.height && (e.height = `${t.height}px`);
  const n = t.style;
  return n != null && Object.keys(n).forEach((s) => {
    e[s] = n[s];
  }), i;
}
const az = {};
async function oz(i) {
  let t = az[i];
  if (t != null)
    return t;
  const n = await (await fetch(i)).text();
  return t = { url: i, cssText: n }, az[i] = t, t;
}
async function lz(i, t) {
  let e = i.cssText;
  const n = /url\(["']?([^"')]+)["']?\)/g, r = (e.match(/url\([^)]+\)/g) || []).map(async (a) => {
    let o = a.replace(n, "$1");
    return o.startsWith("https://") || (o = new URL(o, i.url).href), NJ(o, t.fetchRequestInit, ({ result: l }) => (e = e.replace(a, `url(${l})`), [a, l]));
  });
  return Promise.all(r).then(() => e);
}
function cz(i) {
  if (i == null)
    return [];
  const t = [], e = /(\/\*[\s\S]*?\*\/)/gi;
  let n = i.replace(e, "");
  const s = new RegExp("((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})", "gi");
  for (; ; ) {
    const l = s.exec(n);
    if (l === null)
      break;
    t.push(l[0]);
  }
  n = n.replace(s, "");
  const r = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi, a = "((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})", o = new RegExp(a, "gi");
  for (; ; ) {
    let l = r.exec(n);
    if (l === null) {
      if (l = o.exec(n), l === null)
        break;
      r.lastIndex = o.lastIndex;
    } else
      o.lastIndex = r.lastIndex;
    t.push(l[0]);
  }
  return t;
}
async function VZt(i, t) {
  const e = [], n = [];
  return i.forEach((s) => {
    if ("cssRules" in s)
      try {
        Ph(s.cssRules || []).forEach((r, a) => {
          if (r.type === CSSRule.IMPORT_RULE) {
            let o = a + 1;
            const l = r.href, c = oz(l).then((u) => lz(u, t)).then((u) => cz(u).forEach((d) => {
              try {
                s.insertRule(d, d.startsWith("@import") ? o += 1 : s.cssRules.length);
              } catch (h) {
                console.error("Error inserting rule from remote css", {
                  rule: d,
                  error: h
                });
              }
            })).catch((u) => {
              console.error("Error loading remote css", u.toString());
            });
            n.push(c);
          }
        });
      } catch (r) {
        const a = i.find((o) => o.href == null) || document.styleSheets[0];
        s.href != null && n.push(oz(s.href).then((o) => lz(o, t)).then((o) => cz(o).forEach((l) => {
          a.insertRule(l, a.cssRules.length);
        })).catch((o) => {
          console.error("Error loading remote stylesheet", o);
        })), console.error("Error inlining remote css file", r);
      }
  }), Promise.all(n).then(() => (i.forEach((s) => {
    if ("cssRules" in s)
      try {
        Ph(s.cssRules || []).forEach((r) => {
          e.push(r);
        });
      } catch (r) {
        console.error(`Error while reading CSS rules from ${s.href}`, r);
      }
  }), e));
}
function XZt(i) {
  return i.filter((t) => t.type === CSSRule.FONT_FACE_RULE).filter((t) => wJ(t.style.getPropertyValue("src")));
}
async function IZt(i, t) {
  if (i.ownerDocument == null)
    throw new Error("Provided element is not within a Document");
  const e = Ph(i.ownerDocument.styleSheets), n = await VZt(e, t);
  return XZt(n);
}
function LJ(i) {
  return i.trim().replace(/["']/g, "");
}
function CZt(i) {
  const t = /* @__PURE__ */ new Set();
  function e(n) {
    (n.style.fontFamily || getComputedStyle(n).fontFamily).split(",").forEach((r) => {
      t.add(LJ(r));
    }), Array.from(n.children).forEach((r) => {
      r instanceof HTMLElement && e(r);
    });
  }
  return e(i), t;
}
async function YZt(i, t) {
  const e = await IZt(i, t), n = CZt(i);
  return (await Promise.all(e.filter((r) => n.has(LJ(r.style.fontFamily))).map((r) => {
    const a = r.parentStyleSheet ? r.parentStyleSheet.href : null;
    return xJ(r.cssText, a, t);
  }))).join(`
`);
}
async function vZt(i, t) {
  const e = t.fontEmbedCSS != null ? t.fontEmbedCSS : t.skipFonts ? null : await YZt(i, t);
  if (e) {
    const n = document.createElement("style"), s = document.createTextNode(e);
    n.appendChild(s), i.firstChild ? i.insertBefore(n, i.firstChild) : i.appendChild(n);
  }
}
async function RZt(i, t = {}) {
  const { width: e, height: n } = MJ(i, t), s = await sw(i, t, !0);
  return await vZt(s, t), await SJ(s, t), LZt(s, t), await $2t(s, e, n);
}
async function gN(i, t = {}) {
  const { width: e, height: n } = MJ(i, t), s = await RZt(i, t), r = await vW(s), a = document.createElement("canvas"), o = a.getContext("2d"), l = t.pixelRatio || H2t(), c = t.canvasWidth || e, u = t.canvasHeight || n;
  return a.width = c * l, a.height = u * l, t.skipAutoScale || _2t(a), a.style.width = `${c}`, a.style.height = `${u}`, t.backgroundColor && (o.fillStyle = t.backgroundColor, o.fillRect(0, 0, a.width, a.height)), o.drawImage(r, 0, 0, a.width, a.height), a;
}
const DZt = {
  viewBackground: [0, 0, 0, 0],
  // handled by css background
  overlayBackground: [112 / 255, 112 / 255, 112 / 255],
  // #707070
  sectionalViewActorColor: [1, 1, 1],
  sectionalViewBackground: [40 / 255, 41 / 255, 44 / 255]
  // #28292C, $backgroundMainColor
}, OZt = {
  viewBackground: [0, 0, 0, 0],
  // handled by css background
  overlayBackground: [1, 1, 1],
  sectionalViewActorColor: [0, 0, 0],
  sectionalViewBackground: [1, 1, 1]
  // $backgroundMainColor
}, zZt = () => {
  const i = new qt("dark"), t = new md(() => i.get() === "dark" ? DZt : OZt);
  return {
    colorScheme: i,
    colors: t
  };
};
function EZt(i, t, e) {
  const n = t[0] * e + i[0] * (1 - e), s = t[1] * e + i[1] * (1 - e), r = t[2] * e + i[2] * (1 - e);
  return [n, s, r];
}
const {
  vtkWarningMacro: kZt
} = tt;
function FZt(i, t) {
  t.classHierarchy.push("vtkLineSource"), i.requestData = (e, n) => {
    if (t.deleted)
      return;
    const s = n[0], r = s ? s.getPoints().getDataType() : t.pointType, a = Ie.newInstance(), o = [];
    if (fi(t.point2, t.point1, o), Or(o) <= 0) {
      kZt("Zero-length line definition");
      return;
    }
    const l = t.resolution, c = l + 1, u = tt.newTypedArray(r, c * 3);
    a.getPoints().setData(u, 3);
    const d = new Uint32Array(c + 1);
    a.getLines().setData(d, 1);
    let h = 0, p = 0;
    for (let m = 0; m < l + 1; m++)
      p = m / l, u[h * 3] = t.point1[0] + p * o[0], u[h * 3 + 1] = t.point1[1] + p * o[1], u[h * 3 + 2] = t.point1[2] + p * o[2], h++;
    h = 0, d[0] = c;
    for (let m = 0; m < c; m++)
      d[m + 1] = m;
    n[0] = a;
  };
}
const jZt = {
  resolution: 10,
  point1: [-1, 0, 0],
  point2: [1, 0, 0],
  pointType: "Float64Array"
};
function VJ(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, jZt, e), tt.obj(i, t), tt.setGet(i, t, ["resolution"]), tt.setGetArray(i, t, ["point1", "point2"], 3), tt.algo(i, t, 0, 1), FZt(i, t);
}
const UZt = tt.newInstance(VJ, "vtkLineSource");
var rw = {
  newInstance: UZt,
  extend: VJ
};
class PZt {
  constructor(t) {
    S(this, "sphere");
    S(this, "mapper");
    S(this, "actor");
    this.sphere = sp.newInstance(), this.sphere.setRadius(1), this.sphere.setPhiResolution(50), this.sphere.setThetaResolution(50), this.mapper = Ue.newInstance(), this.mapper.setInputConnection(this.sphere.getOutputPort()), this.mapper.setScalarVisibility(!1), this.actor = Re.newInstance(), this.actor.setMapper(this.mapper), this.actor.setPickable(!1), this.actor.setVisibility(!0), this.sphere.setCenter(t);
  }
  getActor() {
    return this.actor;
  }
  delete() {
    this.sphere.delete(), this.mapper.delete(), this.actor.delete();
  }
}
class JZt {
  constructor(t, e) {
    S(this, "line");
    S(this, "mapper");
    S(this, "actor");
    this.line = rw.newInstance({
      resolution: 10
    }), this.mapper = Ue.newInstance(), this.mapper.setInputConnection(this.line.getOutputPort()), this.actor = Re.newInstance(), this.actor.setMapper(this.mapper), this.actor.setPickable(!1), this.actor.setVisibility(!0), this.line.setPoint1From(t), this.line.setPoint2From(e);
  }
  getActor() {
    return this.actor;
  }
  delete() {
    this.line.delete(), this.mapper.delete(), this.actor.delete();
  }
}
let zc;
const Rb = [];
function AZt(i) {
  zc = i, Rb.forEach((t) => {
    zc == null || zc.getRenderers().forEach((e) => {
      e.addActor(t.getActor());
    });
  });
}
function kDt(...i) {
  i.forEach((t) => {
    const e = new PZt(t);
    zc == null || zc.getRenderers().forEach((n) => {
      n.addActor(e.getActor());
    }), Rb.push(e);
  });
}
function BZt(i, t) {
  const e = new JZt(i, t);
  zc == null || zc.getRenderers().forEach((n) => {
    n.addActor(e.getActor());
  }), Rb.push(e);
}
function FDt(i, t) {
  const e = I.create();
  I.scaleAndAdd(e, i, t, 1e3), BZt(i, e);
}
function jDt() {
  Rb.forEach((i) => i.delete()), Rb.splice(0, Rb.length);
}
var KZt = /* @__PURE__ */ ((i) => (i[i.NEAREST = 0] = "NEAREST", i[i.LINEAR = 1] = "LINEAR", i[i.FAST_LINEAR = 2] = "FAST_LINEAR", i))(KZt || {}), Co = /* @__PURE__ */ ((i) => (i[i.NO_SHADING = 0] = "NO_SHADING", i[i.LIGHT_SHADING = 1] = "LIGHT_SHADING", i[i.DARK_SHADING = 2] = "DARK_SHADING", i[i.SHINY_SHADING = 3] = "SHINY_SHADING", i[i.CUSTOM_SHADING = 4] = "CUSTOM_SHADING", i))(Co || {});
class XJ {
  constructor(t) {
    S(this, "template");
    S(this, "lookupTable", L0.newInstance());
    S(this, "piecewiseFunction", Bh.newInstance());
    S(this, "interpolationType", 0);
    S(this, "settingsOverride", !1);
    S(this, "overrideScalarOpacityUnitDistance");
    S(this, "onModified", new se());
    this.setTemplate(t);
  }
  updateFunctions() {
    this.lookupTable.removeAllPoints(), this.piecewiseFunction.removeAllPoints(), this.template.points.forEach((t) => {
      this.lookupTable.addRGBPoint(t.intensity, t.red, t.green, t.blue), this.piecewiseFunction.addPoint(t.intensity, t.alpha);
    }), this.settingsOverride = !1;
  }
  updateFunctionsCustomWL(t, e) {
    this.lookupTable.removeAllPoints(), this.piecewiseFunction.removeAllPoints();
    const n = this.template.points;
    if (n.length < 4) {
      this.updateFunctions();
      return;
    }
    const r = Math.max(1, Math.abs(t)), a = e - r / 2, o = n[1].intensity, l = n[n.length - 2].intensity, c = Math.max(1, l - o), u = r / c, d = n.map((h, p) => p === 0 || p === n.length - 1 ? { ...h } : {
      ...h,
      intensity: (h.intensity - o) * u + a
    });
    this.template.points = d, d.forEach((h) => {
      this.lookupTable.addRGBPoint(h.intensity, h.red, h.green, h.blue), this.piecewiseFunction.addPoint(h.intensity, h.alpha);
    });
  }
  normalizeWindowWidthLevel(t, e) {
    const n = this.template.points;
    if (!n.length) {
      const u = Number.isFinite(t) ? Math.max(0, t) : 0, d = Number.isFinite(e) ? e : 0;
      return [u, d];
    }
    let s = n[0].intensity, r = n[0].intensity;
    for (let u = 1; u < n.length; u++)
      s = Math.min(s, n[u].intensity), r = Math.max(r, n[u].intensity);
    const a = Math.min(Math.max(Number.isFinite(e) ? e : s, s), r), o = Math.max(0, Number.isFinite(t) ? t : 0), l = 2 * Math.min(a - s, r - a);
    return [Math.min(o, Math.max(0, l)), a];
  }
  addPoint(t) {
    this.template.points.push(t), this.template.points.sort((e, n) => n.intensity - e.intensity), this.updateFunctions(), this.onModified.notify();
  }
  setTemplate(t) {
    this.template = { ...t, points: t.points.map((e) => ({ ...e })) }, this.updateFunctions(), this.onModified.notify();
  }
  setPoints(t) {
    this.template.points = t, this.updateFunctions(), this.onModified.notify();
  }
  setMIP(t) {
    this.template.mip = t, this.onModified.notify();
  }
  setShading(t) {
    this.template.shading = t, this.onModified.notify();
  }
  setInterpolationType(t) {
    this.interpolationType = t, this.onModified.notify();
  }
  setVolumeShading(t, e, n) {
    const s = t.getProperty();
    if (e == 0)
      s.setShade(!1);
    else {
      if (e == 4) {
        if (!n) {
          console.warn("custom volume shading missing parameters");
          return;
        }
        s.setAmbient(n.ambient), s.setDiffuse(n.diffuse), s.setSpecular(n.specular), s.setSpecularPower(n.specularPower);
      } else {
        let r = 0, a = 0, o = 0, l = 0;
        e == 1 ? (r = 0, a = 1, o = 0.3, l = 10) : e == 2 ? (r = 0, a = 1, o = 0, l = 0) : e == 3 && (r = 0, a = 1, o = 0.5, l = 100), s.setAmbient(r), s.setDiffuse(a), s.setSpecular(o), s.setSpecularPower(l);
      }
      s.modified(), s.setShade(!0);
    }
  }
  updateVolumeOptions(t, e) {
    const n = e.getProperty();
    if (n.setRGBTransferFunction(0, this.lookupTable), this.template.mip) {
      const r = Bh.newInstance(), a = [-32e3, 32e3];
      r.addPoint(a[0], 0), r.addPoint(a[1] + 1, 1), n.setScalarOpacity(0, r);
    } else
      n.setScalarOpacity(0, this.piecewiseFunction);
    this.interpolationType == 0 ? n.setInterpolationType(Uh.NEAREST) : this.interpolationType == 1 ? n.setInterpolationType(Uh.LINEAR) : this.interpolationType == 2 && n.setInterpolationType(Uh.FAST_LINEAR);
    const s = this.template.shading !== void 0 ? this.template.shading : 1;
    this.setVolumeShading(e, s), this.template.mip ? t.setBlendModeToMaximumIntensity() : t.setBlendModeToComposite(), this.template.volumeOpacity, this.overrideScalarOpacityUnitDistance && n.setScalarOpacityUnitDistance(...this.overrideScalarOpacityUnitDistance);
  }
  setWindowWidthLevel(t, e, n) {
    this.settingsOverride && (this.settingsOverride = !1, this.overrideScalarOpacityUnitDistance = void 0);
    const [s, r] = this.normalizeWindowWidthLevel(e, n);
    if (this.updateFunctionsCustomWL(s, r), t) {
      const a = t.getProperty();
      a.setScalarOpacity(0, this.piecewiseFunction), a.setRGBTransferFunction(0, this.lookupTable);
    }
    return this.onModified.notify(), [s, r];
  }
  getWindowWidthLevel() {
    const t = this.template.points;
    if (t.length >= 4) {
      const e = t[t.length - 2].intensity - t[1].intensity, n = (t[t.length - 2].intensity + t[1].intensity) / 2;
      return [e, n];
    } else
      return [0, 0];
  }
  getCurrentTemplate() {
    return this.template;
  }
  /** opacity and color functions override to set separate intensity thresholds
   * W/L setting is not supported if using this mode */
  overrideSettings(t, e, n) {
    this.lookupTable.removeAllPoints(), this.piecewiseFunction.removeAllPoints();
    for (const s of t) {
      const [r, a] = s;
      this.piecewiseFunction.addPoint(r, a);
    }
    for (const s of e) {
      const [r, a, o, l] = s;
      this.lookupTable.addRGBPoint(r, a, o, l);
    }
    this.overrideScalarOpacityUnitDistance = n, this.settingsOverride = !0, this.onModified.notify();
  }
}
const HZt = {
  name: "Airways",
  mip: !1,
  volumeOpacity: 1,
  shading: Co.LIGHT_SHADING,
  points: [
    {
      intensity: -1024,
      alpha: 0,
      red: 0,
      green: 0.2,
      blue: 0.6
    },
    {
      intensity: -808,
      alpha: 0,
      red: 0.666666666666667,
      green: 0.329411764705882,
      blue: 1
    },
    {
      intensity: -463,
      alpha: 0.08503056,
      red: 0.666666666666667,
      green: 0.666666666666667,
      blue: 1
    },
    {
      intensity: -170,
      alpha: 0,
      red: 1,
      green: 1,
      blue: 1
    },
    {
      intensity: 3071,
      alpha: 0,
      red: 1,
      green: 1,
      blue: 1
    }
  ],
  thumbnailFile: "airways.png"
}, IJ = {
  name: "Bones",
  mip: !1,
  shading: Co.LIGHT_SHADING,
  volumeOpacity: 0.5,
  points: [
    {
      intensity: -1024,
      alpha: 0,
      red: 0,
      green: 0,
      blue: 0
    },
    {
      intensity: 526,
      alpha: 0,
      red: 0.588235294117647,
      green: 0.454901960784314,
      blue: 0.0549019607843137
    },
    {
      intensity: 1105,
      alpha: 1,
      red: 0.992156862745098,
      green: 0.972549019607843,
      blue: 0.909803921568627
    },
    {
      intensity: 3071,
      alpha: 1,
      red: 1,
      green: 1,
      blue: 1
    }
  ],
  thumbnailFile: "bones.png"
}, _Zt = { ...structuredClone(IJ), name: "Default" }, QZt = {
  name: "Soft Tissues",
  mip: !1,
  shading: Co.LIGHT_SHADING,
  points: [
    {
      intensity: -1024,
      alpha: 0,
      red: 0,
      green: 0,
      blue: 0
    },
    {
      intensity: -574,
      alpha: 0,
      red: 1,
      green: 0.831372549019608,
      blue: 0.796078431372549
    },
    {
      intensity: 16,
      alpha: 0.957072507025477,
      red: 1,
      green: 0,
      blue: 0
    },
    {
      intensity: 635,
      alpha: 0,
      red: 1,
      green: 1,
      blue: 1
    },
    {
      intensity: 1106,
      alpha: 1,
      red: 0.992156862745098,
      green: 0.972549019607843,
      blue: 0.909803921568627
    },
    {
      intensity: 3071,
      alpha: 1,
      red: 1,
      green: 1,
      blue: 1
    }
  ],
  thumbnailFile: "soft_tissues.png"
}, $Zt = {
  name: "Teeth",
  mip: !1,
  shading: Co.LIGHT_SHADING,
  points: [
    {
      intensity: -1024,
      alpha: 0,
      red: 0,
      green: 0,
      blue: 0
    },
    {
      intensity: 266,
      alpha: 0,
      red: 0.211764705882353,
      green: 0.211764705882353,
      blue: 0.211764705882353
    },
    {
      intensity: 766,
      alpha: 0.0256,
      red: 1,
      green: 1,
      blue: 1
    },
    {
      intensity: 1262,
      alpha: 0,
      red: 1,
      green: 1,
      blue: 1
    },
    {
      intensity: 1562,
      alpha: 0,
      red: 0.513725490196078,
      green: 0.509803921568627,
      blue: 0.0235294117647059
    },
    {
      intensity: 2406,
      alpha: 1,
      red: 0.984313725490196,
      green: 0.87843137254902,
      blue: 0.670588235294118
    },
    {
      intensity: 3071,
      alpha: 1,
      red: 1,
      green: 1,
      blue: 1
    }
  ],
  thumbnailFile: "teeth.png"
}, qZt = {
  name: "X-Ray",
  mip: !1,
  shading: Co.LIGHT_SHADING,
  points: [
    {
      intensity: -1024,
      alpha: 0,
      red: 0,
      green: 0,
      blue: 0
    },
    {
      intensity: 173,
      alpha: 0,
      red: 0,
      green: 0,
      blue: 0
    },
    {
      intensity: 1066,
      alpha: 0.0214755572378635,
      red: 1,
      green: 1,
      blue: 1
    },
    {
      intensity: 3071,
      alpha: 0.0214755572378635,
      red: 1,
      green: 1,
      blue: 1
    }
  ],
  thumbnailFile: "x-ray.png"
}, tTt = {
  name: "Airways",
  mip: !1,
  shading: Co.SHINY_SHADING,
  points: [
    {
      intensity: -1024,
      alpha: 0,
      red: 0,
      green: 0,
      blue: 0
    },
    {
      intensity: -808,
      alpha: 0,
      red: 0.666666666666667,
      green: 0,
      blue: 1
    },
    {
      intensity: -497,
      alpha: 0.185056261374385,
      red: 0,
      green: 0.333333333333333,
      blue: 1
    },
    {
      intensity: -170,
      alpha: 0,
      red: 1,
      green: 1,
      blue: 1
    },
    {
      intensity: 3071,
      alpha: 0,
      red: 1,
      green: 1,
      blue: 1
    }
  ]
}, eTt = {
  name: "Bone Vessels",
  mip: !1,
  shading: Co.LIGHT_SHADING,
  points: [
    {
      intensity: -1024,
      alpha: 0,
      red: 0,
      green: 0,
      blue: 0
    },
    {
      intensity: -444,
      alpha: 0.0010037298509671,
      red: 0.945098039215686,
      green: 0,
      blue: 0
    },
    {
      intensity: 90,
      alpha: 0.0010037298509671,
      red: 0.666666666666667,
      green: 0,
      blue: 0
    },
    {
      intensity: 654,
      alpha: 1,
      red: 0.984313725490196,
      green: 0.964705882352941,
      blue: 0.901960784313726
    },
    {
      intensity: 3071,
      alpha: 1,
      red: 1,
      green: 1,
      blue: 1
    }
  ]
}, CJ = {
  name: "Bones",
  mip: !1,
  shading: Co.LIGHT_SHADING,
  volumeOpacity: 0.5,
  points: [
    {
      intensity: -1024,
      alpha: 0,
      red: 0,
      green: 0,
      blue: 0
    },
    {
      intensity: 526,
      alpha: 0,
      red: 0.588235294117647,
      green: 0.454901960784314,
      blue: 0.0549019607843137
    },
    {
      intensity: 1105,
      alpha: 1,
      red: 0.992156862745098,
      green: 0.972549019607843,
      blue: 0.909803921568627
    },
    {
      intensity: 3071,
      alpha: 1,
      red: 1,
      green: 1,
      blue: 1
    }
  ]
}, nTt = CJ, iTt = {
  name: "MIP",
  mip: !0,
  shading: Co.NO_SHADING,
  points: [
    {
      intensity: -1024,
      alpha: 0,
      red: 0,
      green: 0,
      blue: 0
    },
    {
      intensity: -163,
      alpha: 0,
      red: 0,
      green: 0,
      blue: 0
    },
    {
      intensity: 449,
      alpha: 1,
      red: 1,
      green: 1,
      blue: 1
    },
    {
      intensity: 3071,
      alpha: 1,
      red: 1,
      green: 1,
      blue: 1
    }
  ]
}, sTt = {
  name: "Vessels Bones Airways",
  mip: !1,
  shading: Co.LIGHT_SHADING,
  points: [
    {
      intensity: -1024,
      alpha: 0,
      red: 0,
      green: 0,
      blue: 0
    },
    {
      intensity: -597,
      alpha: 0,
      red: 0.666666666666667,
      green: 0,
      blue: 1
    },
    {
      intensity: -285,
      alpha: 1,
      red: 0,
      green: 0.333333333333333,
      blue: 1
    },
    {
      intensity: 3,
      alpha: 1,
      red: 0.666666666666667,
      green: 0,
      blue: 0
    },
    {
      intensity: 198,
      alpha: 0,
      red: 1,
      green: 1,
      blue: 1
    },
    {
      intensity: 341,
      alpha: 0,
      red: 1,
      green: 1,
      blue: 1
    },
    {
      intensity: 464,
      alpha: 1,
      red: 0.580392156862745,
      green: 0.454901960784314,
      blue: 0.0470588235294118
    },
    {
      intensity: 719,
      alpha: 1,
      red: 1,
      green: 1,
      blue: 1
    },
    {
      intensity: 828,
      alpha: 0,
      red: 0.984313725490196,
      green: 0.964705882352941,
      blue: 0.901960784313726
    },
    {
      intensity: 3071,
      alpha: 0,
      red: 1,
      green: 1,
      blue: 1
    }
  ]
}, rTt = {
  name: "Vessels",
  mip: !1,
  shading: Co.LIGHT_SHADING,
  points: [
    {
      intensity: -1024,
      alpha: 0,
      red: 0,
      green: 0,
      blue: 0
    },
    {
      intensity: -36,
      alpha: 0.0023453179805698,
      red: 0.666666666666667,
      green: 0,
      blue: 0
    },
    {
      intensity: 235,
      alpha: 0.532821560055136,
      red: 0.96078431372549,
      green: 0,
      blue: 0
    },
    {
      intensity: 770,
      alpha: 1,
      red: 0.984313725490196,
      green: 0.964705882352941,
      blue: 0.901960784313726
    },
    {
      intensity: 3071,
      alpha: 1,
      red: 1,
      green: 1,
      blue: 1
    }
  ]
}, aTt = {
  name: "Default",
  mip: !1,
  shading: Co.LIGHT_SHADING,
  volumeOpacity: 0.5,
  points: [
    {
      intensity: -1024,
      alpha: 0,
      red: 0,
      green: 0,
      blue: 0
    },
    {
      intensity: 526,
      alpha: 0,
      red: 0.588235294117647,
      green: 0.454901960784314,
      blue: 0.0549019607843137
    },
    {
      intensity: 1105,
      alpha: 1,
      red: 0.992156862745098,
      green: 0.972549019607843,
      blue: 0.909803921568627
    },
    {
      intensity: 3071,
      alpha: 1,
      red: 1,
      green: 1,
      blue: 1
    }
  ]
}, Sy = {
  Dental: {
    Airways: HZt,
    Bones: IJ,
    Default: _Zt,
    SoftTissues: QZt,
    Teeth: $Zt,
    XRay: qZt
  },
  GeneralCT: {
    Airways: tTt,
    BoneVessels: eTt,
    Bones: CJ,
    Default: nTt,
    MIP: iTt,
    VesselsBonesAirways: sTt,
    Vessels: rTt
  },
  Segmentator: {
    Default: aTt
  }
};
class PT {
  constructor(t, e, n) {
    S(this, "menu");
    S(this, "reactivity", An());
    S(this, "context");
    S(this, "view");
    S(this, "overlayComponents");
    S(this, "rendererOrientationWidget");
    S(this, "menuEnabled");
    S(this, "visibility", !1);
    S(this, "onCleanupArray", []);
    S(this, "onCleanup", (t) => {
      this.onCleanupArray.push(t);
    });
    this.context = e, this.view = t, this.overlayComponents = Pi(t.getOverlayContainer()), this.rendererOrientationWidget = ld.newInstance(), this.rendererOrientationWidget.setInteractive(!1), this.updateOrientationWidgetPosition(t.state.viewport.get()), this.rendererOrientationWidget.setBackground(0, 0, 0, 0.5);
    const { createVueOverlayComponent: s } = this.overlayComponents;
    this.menu = s(
      GP,
      {
        model: this.context.overlayModel,
        view: t.id,
        size: 40,
        margin: 5
      },
      {
        enabled: n.get()
      }
    ), this.menuEnabled = n, this.view.isViewMode3D() || this.menu.setEnabled(!1), this.view.isViewMode3D() && n.subscribe((r) => {
      this.menu.setEnabled(r);
    }), this.reactivity.onEvent(t.events.cameraModified, () => {
      this.alignOrientationWidget(t.getRenderer().getActiveCamera());
    }), this.reactivity.watch(t.state.viewSize, () => {
      this.updateOrientationWidgetPosition(t.state.viewport.get());
    }), this.loadHeadModel();
  }
  show() {
    (this.menuEnabled.get() || this.view.isViewMode3D()) && (this.context.getRenderWindow().hasRenderer(this.rendererOrientationWidget) || (this.context.getRenderWindow().addRenderer(this.rendererOrientationWidget), this.visibility = !0));
  }
  hide() {
    this.context.getRenderWindow().hasRenderer(this.rendererOrientationWidget) && (this.context.getRenderWindow().removeRenderer(this.rendererOrientationWidget), this.visibility = !1);
  }
  hideMenu(t) {
    this.menu.hideRestore(t);
  }
  isVisible() {
    return this.visibility;
  }
  delete() {
    this.onCleanupArray.reduceRight((t, e) => (e(), null), null), this.overlayComponents.cleanup(), this.reactivity.cleanupAll();
  }
  async loadHeadModel() {
    var r;
    const t = zG.newInstance(), e = this.context.getResourceUrl() + "head_model.stl";
    await t.setUrl(e, {
      binary: !0
    });
    const n = Ue.newInstance();
    n.setInputConnection(t.getOutputPort()), n.setScalarVisibility(!1);
    const s = Re.newInstance();
    s.setMapper(n), this.rendererOrientationWidget.addActor(s), s.getProperty().setAmbient(0), s.getProperty().setDiffuse(0.7), s.getProperty().setSpecular(0), this.rendererOrientationWidget.getActiveCamera().setParallelProjection(!0), this.alignOrientationWidget(this.view.getRenderer().getActiveCamera()), (r = this.rendererOrientationWidget.getRenderWindow()) == null || r.render(), this.onCleanup(() => {
      s.delete(), n.delete(), t.delete();
    });
  }
  /** update orientation widget position on screen */
  updateOrientationWidgetPosition(t) {
    const [e, n] = this.context.getState().canvasSize.get(), s = 10, r = 40, a = _I([e, n], {
      x: s,
      y: n - r - s,
      w: r,
      h: r
    });
    this.rendererOrientationWidget.setViewport(
      t.xmin + a.xmin,
      t.ymin + a.ymin,
      t.xmin + a.xmax,
      t.ymin + a.ymax
    );
  }
  /** align orientation widget rotation with camera */
  alignOrientationWidget(t) {
    const e = this.rendererOrientationWidget.getActiveCamera();
    e.setPosition(...t.getPosition()), e.setFocalPoint(...t.getFocalPoint()), e.setViewUp(t.getViewUp()), this.rendererOrientationWidget.resetCamera(), e.zoom(1.4), this.rendererOrientationWidget.updateLightsGeometryToFollowCamera();
  }
}
const oTt = /* @__PURE__ */ Ne({
  __name: "OrientationLabels",
  props: {
    labels: {},
    fontSizePx: {}
  },
  setup(i) {
    const e = Le(i.labels);
    return (n, s) => (Mt(), Ot(Me, null, [
      K(e).left ? (Mt(), Ot("div", {
        key: 0,
        style: xe({ fontSize: i.fontSizePx + "px" }),
        class: "label left"
      }, pe(K(e).left), 5)) : Qt("", !0),
      K(e).right ? (Mt(), Ot("div", {
        key: 1,
        style: xe({ fontSize: i.fontSizePx + "px" }),
        class: "label right"
      }, pe(K(e).right), 5)) : Qt("", !0),
      K(e).top ? (Mt(), Ot("div", {
        key: 2,
        style: xe({ fontSize: i.fontSizePx + "px" }),
        class: "label top"
      }, pe(K(e).top), 5)) : Qt("", !0),
      K(e).bottom ? (Mt(), Ot("div", {
        key: 3,
        style: xe({ fontSize: i.fontSizePx + "px" }),
        class: "label bottom"
      }, pe(K(e).bottom), 5)) : Qt("", !0)
    ], 64));
  }
}), lTt = /* @__PURE__ */ Dn(oTt, [["__scopeId", "data-v-ebae4939"]]), cTt = {
  showOverlays: !0,
  sliceOffset: 0,
  isCrossSection: !1,
  useWasmReslicer: !1
};
class vl extends op {
  constructor(e, n, s, r = {}, a = {}) {
    var P;
    super(e, n, r);
    S(this, "reslicerMap", []);
    S(this, "wasmReslicer", null);
    S(this, "planeAxis1", [0, 0, 0]);
    S(this, "normal", [0, 0, 0]);
    S(this, "viewUp", [0, 0, 0]);
    S(this, "presenterWindow");
    S(this, "pauseOriginUpdate", !1);
    S(this, "viewSliceIndicators", new qt([]));
    S(this, "origin2DPosition", new qt([0, 0]));
    S(this, "sliceInfo", new qt({ min: 0, max: 0, value: 0 }));
    S(this, "indicatorAxial", new qt({
      viewId: 0,
      color: [255, 0, 0],
      point1: [0, 0],
      point2: [0, 0],
      visible: !0
    }));
    S(this, "horizontalSliceInfo", null);
    S(this, "totalThickness");
    S(this, "sliceSelectEvent", new se());
    S(this, "horizontalSliceSelectEvent", new se());
    S(this, "recreateSliders", new se());
    S(this, "bounds");
    S(this, "sliceOffset");
    S(this, "isCrossSection");
    S(this, "imageSpacingForNormal");
    S(this, "CPRSagital", !1);
    S(this, "orientationWidget", null);
    S(this, "stLabel");
    S(this, "implantPanFlag", !1);
    S(this, "useWasmReslicer");
    S(this, "showOrientationWidget", new qt(!0));
    const { showOverlays: o, sliceOffset: l, isCrossSection: c, useWasmReslicer: u } = {
      ...cTt,
      ...a
    };
    this.useWasmReslicer = u, this.stLabel = "APRL", !c && this.viewMode !== Nt.CROSS && (this.orientationWidget = new PT(this, this.context, this.isShown), this.onCleanup(() => {
      var j;
      return (j = this.orientationWidget) == null ? void 0 : j.delete();
    }), this.orientationWidget.hide(), this.watch(this.isShown, (j) => {
      var H, B;
      j && this.showOrientationWidget.get() ? (H = this.orientationWidget) == null || H.show() : (B = this.orientationWidget) == null || B.hide();
    }));
    let d;
    if (u) {
      const { reslicer: j, mapper: H, actor: B, bounds: $, spacing: A } = e.createWasmReslicer(this.resliceAxes);
      this.wasmReslicer = j, d = A, this.bounds = $, this.sliceOffset = l, this.isCrossSection = c;
      const E = {
        label: "3Dvolume",
        reslicer: j,
        actor: B,
        mapper: H
      };
      this.reslicerMap.push(E), this.renderer.addActor(B), this.presenterWindow = s;
    } else {
      const { reslice: j, mapper: H, actor: B, bounds: $, spacing: A } = e.createResliceObject(e.getImageData());
      d = A, this.bounds = $, this.sliceOffset = l, this.isCrossSection = c;
      const E = {
        label: "3Dvolume",
        reslicer: j,
        actor: B,
        mapper: H
      };
      this.reslicerMap.push(E), this.renderer.addActor(B), this.presenterWindow = s;
    }
    switch (this.resliceAxes = ut.identity(new Float32Array(16)), n) {
      case Nt.SAGITTAL:
        this.planeAxis1 = [0, 1, 0], this.normal = [1, 0, 0], this.viewUp = [0, 0, -1];
        break;
      case Nt.CORONAL:
        this.planeAxis1 = [1, 0, 0], this.normal = [0, 1, 0], this.viewUp = [0, 0, -1];
        break;
      case Nt.TANGENT:
        this.planeAxis1 = [0, 1, 0], this.normal = [1, 0, 0], this.viewUp = [0, 0, -1];
        break;
      case Nt.CROSS:
        this.planeAxis1 = [1, 0, 0], this.normal = [0, 1, 0], this.viewUp = [0, 0, -1];
        break;
      case Nt.AXIAL:
        this.planeAxis1 = [1, 0, 0], this.normal = [0, 0, 1], this.viewUp = [0, 1, 0];
        break;
    }
    const h = (j, H) => {
      const B = I.create(), $ = I.create();
      I.scaleAndAdd(B, [j[0] / 2, j[1] / 2, j[2] / 2], H, -(j[0] + j[1] + j[2])), I.scaleAndAdd($, [j[0] / 2, j[1] / 2, j[2] / 2], H, j[0] + j[1] + j[2]);
      const A = T2([0, j[0], 0, j[1], 0, j[2]], B, $);
      return A ? I.distance(A[0], A[1]) : (console.error("failed to calculate spacing"), -1);
    };
    this.imageSpacingForNormal = this.lazyComputed(() => h(d, this.getNormal())), this.totalThickness = this.computed(() => {
      const j = this.getNormal(), H = I.create();
      return H[0] = this.bounds[1] - this.bounds[0], H[1] = this.bounds[3] - this.bounds[2], H[2] = this.bounds[5] - this.bounds[4], Math.abs(H[0] * j[0]) + Math.abs(H[1] * j[1]) + Math.abs(H[2] * j[2]);
    }), this.updateSlider(), this.onEvent(this.sliceSelectEvent, ({ slice: j }) => {
      if (this.viewMode == Nt.CROSS) {
        const H = j - this.context.indexOnSpline.get(), B = this.context.getViewWidget(Nt.CPR);
        B == null || B.slide(H);
      } else
        this.setSliceNumber(j), this.updateSlider();
    }), this.viewMode == Nt.CROSS && (this.horizontalSliceInfo = this.computed(() => ({
      min: -90,
      max: 90,
      value: Math.round(this.context.toolManager.coordControl.viewUpAngle.get() * 180 / Math.PI)
    })), this.onEvent(this.horizontalSliceSelectEvent, (j) => {
      this.context.toolManager.coordControl.viewUpAngle.set(Math.PI * j.slice / 180);
      const H = this.context.getViewWidget(Nt.CPR);
      H && this.context.toolManager.coordControl.setCenter(this.getOrigin(), H);
    }));
    for (const j of e.predictions) {
      const { reslice: H, mapper: B, actor: $ } = e.createReslicePrediction(j), A = {
        label: j.label,
        reslicer: H,
        actor: $,
        mapper: B
      };
      this.reslicerMap.push(A), this.rendererOverlay.addActor($), this.presenterWindow = s, this.context.toolManager.coordControl.setCenter(this.getOrigin(), this), this.sceneRefresh();
    }
    this.onEvent(this.context.onCrossSectionAdded, (j) => {
      const { reslice: H, mapper: B, actor: $ } = e.createReslicePrediction(j), A = {
        label: j.label,
        reslicer: H,
        actor: $,
        mapper: B
      };
      this.reslicerMap.push(A), this.rendererOverlay.addActor($), this.presenterWindow = s, this.context.toolManager.coordControl.setCenter(this.getOrigin(), this), this.sceneRefresh();
    }), this.onEvent(this.context.onCrossSectionRemoved, (j) => {
      console.log(this.reslicerMap);
      const H = this.reslicerMap.map((B) => B.label).indexOf(j);
      H != -1 && (this.reslicerMap[H].actor.delete(), this.reslicerMap[H].mapper.delete(), this.reslicerMap.splice(H, 1), this.sceneRefresh());
    });
    const p = this.renderer.getActiveCamera();
    p.setViewUp(...this.viewUp), p.setParallelProjection(!0);
    const m = 10, b = I.create();
    I.scaleAndAdd(b, this.getOrigin(), this.normal, m), p.setPosition(b[0], b[1], b[2]);
    const y = this.context.getImageData().getCenter();
    p.setFocalPoint(...y), ut.set(
      this.resliceAxes,
      this.planeAxis1[0],
      this.planeAxis1[1],
      this.planeAxis1[2],
      0,
      this.viewUp[0],
      this.viewUp[1],
      this.viewUp[2],
      0,
      this.normal[0],
      this.normal[1],
      this.normal[2],
      0,
      y[0],
      y[1],
      y[2],
      1
    ), this.renderer.resetCamera();
    const { createVueOverlayComponent: Z, cleanup: g } = Pi(this.overlayContainer.getElement());
    this.onCleanup(() => g());
    let f = null;
    const T = (j, H, B) => {
      f = Z(zT, {
        menuItems: j,
        x: H,
        y: B
      });
    }, M = () => {
      f && (f.remove(), f = null);
    }, N = () => {
      this.context.resetOrientation();
    }, W = () => {
      var B;
      const j = ($) => {
        const A = $.imageSpacingForNormal.get(), E = $.viewSize.get()[1];
        A <= 0 || E <= 0 || ($.getRenderer().getActiveCamera().setParallelScale(A * E / 2), $.cameraModified());
      }, H = this.getPresenterWindow();
      if (H) {
        const $ = H.getMainView();
        $ instanceof vl && j($), (B = H.getViews()) == null || B.forEach((A) => {
          A instanceof vl && j(A);
        });
      } else
        j(this);
      this.context.repaint();
    }, x = () => {
      var B;
      const j = ($) => {
        $.fitZoomToScreen();
      }, H = this.getPresenterWindow();
      if (H) {
        const $ = H.getMainView();
        $ instanceof vl && j($), (B = H.getViews()) == null || B.forEach((A) => {
          A instanceof vl && j(A);
        });
      } else
        j(this);
    }, V = [
      {
        label: "Reset MPR Angles",
        command: () => {
          N();
        }
      },
      {
        label: "Zoom: 100%",
        command: () => {
          W();
        }
      },
      {
        label: "Zoom: Best Fit",
        command: () => {
          x();
        }
      }
    ], X = { moved: !1, start: { x: 0, y: 0 } }, C = {
      onRightPress: (j, H) => (X.moved = !1, X.start = { x: H.position.x, y: H.position.y }, M(), !1),
      onRightRelease: (j, H, B) => {
        if (M(), B.cameraDragActive || X.moved)
          return !1;
        const { x: $, y: A } = H.position, [E, ct] = this.displayToView($, A);
        return T(V, E, ct), !0;
      },
      onLeftPress: () => (M(), !1),
      onMouseMove: (j, H, B) => {
        if (!B.mouseButtons.right || X.moved)
          return !1;
        const $ = H.position.x - X.start.x, A = H.position.y - X.start.y;
        return Math.abs($) + Math.abs(A) > 30 && (X.moved = !0), !1;
      }
    }, R = this.viewEventHandler ? yJ(C, this.viewEventHandler) : C;
    (P = this.context.getInteractorStyle()) == null || P.setViewEventHandler(this, R), this.onCleanup(() => {
      var j, H;
      M(), this.viewEventHandler ? (j = this.context.getInteractorStyle()) == null || j.setViewEventHandler(this, this.viewEventHandler) : (H = this.context.getInteractorStyle()) == null || H.setViewEventHandler(this, null);
    });
    const z = new qt({});
    this.onEvent(this.events.cameraModified, () => {
      this.GetOrientaitonLabels(), z.set({
        left: this.stLabel[2],
        right: this.stLabel[3],
        top: this.stLabel[1],
        bottom: this.stLabel[0]
      });
    });
    const F = Z(
      lTt,
      {
        labels: z,
        fontSizePx: 24
      },
      { enabled: !1 }
    );
    o && F.setEnabled(!0), this.resetViewPosition();
  }
  getReslicer() {
    const e = this.reslicerMap.find((n) => n.label == "3Dvolume");
    return e ? e.reslicer : null;
  }
  replaceReslicer() {
    if (this.useWasmReslicer) {
      if (console.log("Cropping reslicer with wasm!"), this.wasmReslicer) {
        this.wasmReslicer.ReinitializeInputImage(), this.wasmReslicer.updateMatrix(new Float64Array(this.resliceAxes));
        const n = this.wasmReslicer.GetSliceView();
        for (const s of this.reslicerMap)
          s.label == "3Dvolume" && ND(n, s.mapper.getInputData());
      }
      const e = this.context.getImageData().getBounds();
      this.bounds = e, this.resetViewPosition(!0);
    } else {
      console.log("Cropping reslicer without wasm!");
      const e = this.reslicerMap.map((l) => l.label).indexOf("3Dvolume");
      console.log("index", e), this.renderer.removeActor(this.reslicerMap[e].actor), this.reslicerMap[e].actor.delete(), this.reslicerMap[e].mapper.delete(), this.reslicerMap.splice(e, 1);
      const { reslice: n, mapper: s, actor: r, bounds: a } = this.context.createResliceObject(this.context.getImageData());
      this.bounds = a;
      const o = {
        label: "3Dvolume",
        reslicer: n,
        actor: r,
        mapper: s
      };
      this.reslicerMap.push(o), this.renderer.addActor(r);
    }
    this.sceneRefresh();
  }
  getVisible(e) {
    return !(this.context.toolManager.getTool(on.PRIMARY) === sn.CPR && (this.viewMode == Nt.AXIAL || e != this.context.getViewId(Nt.AXIAL)));
  }
  /** Resets camera + clipping range, preserving parallel scale. */
  resetCamera(e) {
    const n = e.getParallelScale();
    this.renderer.resetCamera(), e.setParallelScale(n), this.renderer.resetCameraClippingRange(this.renderer.computeVisiblePropBounds());
  }
  GetOrientaitonLabels() {
    const n = [1, 0, 0], s = this.renderer.getActiveCamera().getViewPlaneNormal(), r = this.renderer.getActiveCamera().getViewUp();
    if (I.cross(n, r, s), I.normalize(n, n), this.viewMode == Nt.CPR && (this.stLabel = "SIRL"), this.viewMode == Nt.CROSS) {
      const a = this.context.objects.CPRCurve.splineVec;
      if (a.length > 2) {
        const o = I.create();
        I.add(o, a[0], a[a.length - 1]), I.scale(o, o, 0.5);
        const l = I.create();
        I.subtract(l, o, this.getOrigin()), this.stLabel = I.dot(this.getTangent(), l) > 0 ? "  BL" : "  LB";
      } else {
        const { sign: o } = SP(this.getNormal(), this.getTangent());
        o === 1 ? this.stLabel = "  BL" : o === -1 ? this.stLabel = "  LB" : this.stLabel = "    ";
      }
    } else
      Math.abs(r[2] - 1) < 0.2 ? this.stLabel = "IS" : Math.abs(r[2] + 1) < 0.2 ? this.stLabel = "SI" : Math.abs(r[1] + 1) < 0.2 ? this.stLabel = "PA" : Math.abs(r[1] - 1) < 0.2 ? this.stLabel = "AP" : Math.abs(r[0] - 1) < 0.2 ? this.stLabel = "LR" : Math.abs(r[0] + 1) < 0.2 ? this.stLabel = "RL" : this.stLabel = "  ", Math.abs(n[1] - 1) < 0.2 ? this.stLabel += "AP" : Math.abs(n[1] + 1) < 0.2 ? this.stLabel += "PA" : Math.abs(n[0] - 1) < 0.2 ? this.stLabel += "RL" : Math.abs(n[0] + 1) < 0.2 ? this.stLabel += "LR" : Math.abs(n[2] - 1) < 0.2 ? this.stLabel += "IS" : Math.abs(n[2] + 1) < 0.2 ? this.stLabel += "SI" : this.stLabel += "  ";
  }
  updateSlider() {
    this.sliceInfo.update(() => {
      let e, n, s;
      if (this.viewMode == Nt.CROSS)
        e = 0, n = this.context.splineLength.get(), s = this.context.indexOnSpline.get();
      else {
        const r = this.context.getImageData().getDimensions(), a = this.context.getImageData().getSpacing();
        let o = I.create(), l = I.create(), c = I.create(), u = I.create(), d = I.create(), h = I.create();
        for (let g = 0; g < 3; g++)
          o[g] = (r[g] - 1) * a[g];
        const p = this.getOrigin(), m = this.getNormal();
        N5(m, p, this.bounds, l, c), I.subtract(u, c, l);
        const b = I.len(u);
        let y = 0;
        const Z = fbt(m, p, l, c, d);
        Z == 0 ? (I.subtract(h, d, l), y = I.len(h)) : Z == 1 ? y = 0 : Z == -1 && (y = b), e = 0, n = b, s = y;
      }
      return {
        min: e,
        max: n,
        value: s
      };
    });
  }
  isCrossCameraDirectionFlipped() {
    return !1;
  }
  /*! reset angles */
  resetViewPosition(e = !0) {
    var n;
    if (e) {
      let s = this.getOrigin();
      this.context.cursorRoundToIndex ? s = M5(this.context.getImageData(), this.context.getImageData().getCenter()) : s = this.context.getImageData().getCenter();
      const r = ut.identity(new Float32Array(16));
      ut.set(
        r,
        this.planeAxis1[0],
        this.planeAxis1[1],
        this.planeAxis1[2],
        0,
        this.viewUp[0],
        this.viewUp[1],
        this.viewUp[2],
        0,
        this.normal[0],
        this.normal[1],
        this.normal[2],
        0,
        s[0],
        s[1],
        s[2],
        1
      ), this.setViewMatrix(r), this.showOrientationWidget.set(!1), (n = this.orientationWidget) == null || n.hide();
    } else
      this.setViewMatrix(this.getViewMatrix());
    this.updateSlider();
  }
  setViewOrigin(e) {
    this.context.cursorRoundToIndex && (e = M5(this.context.getImageData(), e));
    const n = ut.identity(new Float32Array(16));
    ut.set(
      n,
      this.resliceAxes[0],
      this.resliceAxes[1],
      this.resliceAxes[2],
      this.resliceAxes[3],
      this.resliceAxes[4],
      this.resliceAxes[5],
      this.resliceAxes[6],
      this.resliceAxes[7],
      this.resliceAxes[8],
      this.resliceAxes[9],
      this.resliceAxes[10],
      this.resliceAxes[11],
      e[0],
      e[1],
      e[2],
      1
    ), this.setViewMatrix(n);
  }
  setViewPosition(e, n, s, r) {
    const a = ut.identity(new Float32Array(16));
    ut.set(a, r[0], r[1], r[2], 0, s[0], s[1], s[2], 0, n[0], n[1], n[2], 0, e[0], e[1], e[2], 1), this.setViewMatrix(a);
  }
  getViewMatrix() {
    const e = ut.identity(new Float32Array(16));
    return ut.copy(e, this.resliceAxes), e;
  }
  /*! main update. set matrix and update reslicer & camera if visible*/
  setViewMatrix(e) {
    var s;
    if (this.showOrientationWidget.get() || nd([this.resliceAxes[8], this.resliceAxes[9], this.resliceAxes[10]], [this.normal[0], this.normal[1], this.normal[2]]) > 0.01 && (this.showOrientationWidget.set(!0), (s = this.orientationWidget) == null || s.show()), ut.copy(this.resliceAxes, e), !this.isShown.get()) return;
    if (this.presenterWindow.scoutUpToDateFlag && this.getFilterMode() == Je.SCOUT) {
      this.updateSlider();
      return;
    }
    this.presenterWindow.scoutUpToDateFlag = !0;
    const n = (r) => {
      for (const u of this.reslicerMap)
        u.actor.setUserMatrix(r);
      const a = this.renderer.getActiveCamera(), o = this.getNormal();
      this.viewMode != Nt.CROSS && this.viewMode != Nt.TANGENT && I.scale(o, o, -1);
      const l = this.renderer.getActiveCamera().getDistance();
      a.setParallelProjection(!0);
      const c = a.getFocalPoint();
      a.setPosition(c[0] + o[0] * l, c[1] + o[1] * l, c[2] + o[2] * l), a.setFocalPoint(c[0], c[1], c[2]), a.setViewUp(-r[4], -r[5], -r[6]), a.modified(), this.cameraModified();
    };
    if (this.wasmReslicer) {
      const r = ut.create();
      ut.copy(r, this.resliceAxes);
      for (const o of r)
        if (!Number.isFinite(o))
          return;
      this.wasmReslicer.updateMatrix(new Float64Array(r));
      const a = this.wasmReslicer.GetSliceView();
      for (const o of this.reslicerMap)
        o.label == "3Dvolume" && ND(a, o.mapper.getInputData());
      n(r), this.updateSlider();
    } else {
      for (const r of this.reslicerMap) {
        const a = r.reslicer;
        a.setResliceAxes(this.resliceAxes), a.modified();
      }
      n(this.resliceAxes), this.updateSlider();
    }
  }
  /*! rotate view directions around axis, dont use this, will move this to coordcontrol*/
  rotateView(e, n) {
    if (this.getFilterMode() == Je.SCOUT)
      return;
    const s = ut.create(), r = ut.create();
    ut.fromRotation(r, e, n);
    const a = this.getNormal(), o = this.getTangent(), l = this.getViewup(), c = this.getOrigin();
    1 - Math.abs(I.dot(a, n)) < 1e-3 || (I.transformMat4(a, a, r), I.transformMat4(l, l, r), I.transformMat4(o, o, r), ut.set(s, o[0], o[1], o[2], 0, l[0], l[1], l[2], 0, a[0], a[1], a[2], 0, c[0], c[1], c[2], 1), this.setViewMatrix(s));
  }
  isViewMode3D() {
    return !1;
  }
  cameraModified() {
    super.cameraModified();
  }
  getNormal() {
    return I.fromValues(this.resliceAxes[8], this.resliceAxes[9], this.resliceAxes[10]);
  }
  getTangent() {
    return I.fromValues(this.resliceAxes[0], this.resliceAxes[1], this.resliceAxes[2]);
  }
  getViewup() {
    return I.fromValues(this.resliceAxes[4], this.resliceAxes[5], this.resliceAxes[6]);
  }
  getOrigin() {
    return this.getFilterMode() == Je.SCOUT ? this.context.getImageData().getCenter() : I.fromValues(this.resliceAxes[12], this.resliceAxes[13], this.resliceAxes[14]);
  }
  get2DLineThroughPoints(e, n) {
    const s = n[1] - e[1], r = e[0] - n[0], a = s * e[0] + r * e[1], [o, l] = this.viewSize.get();
    if (o === 0 || l === 0)
      return null;
    const c = [0, a / r], u = [a / s, 0], d = [o, (a - o * s) / r], h = [(a - l * r) / s, l], p = [c, u, d, h].filter((m) => m[0] >= 0 && m[0] <= o && m[1] >= 0 && m[1] <= l);
    return p.length === 2 ? p : null;
  }
  getSlice2DLineCross(e, n, s) {
    const r = I.create();
    I.cross(r, n, this.getNormal()), I.normalize(r, r);
    const a = e, o = I.create(), l = I.create();
    I.scaleAndAdd(o, a, r, s), I.scaleAndAdd(l, a, r, -s);
    const c = this.worldToView(...o), u = this.worldToView(...l);
    return [c, u];
  }
  getSlice2DLine(e, n) {
    const s = I.create();
    I.cross(s, n, this.getNormal()), I.normalize(s, s);
    const r = e, a = I.create();
    I.scaleAndAdd(a, r, s, 1e6);
    const o = this.worldToView(...r), l = this.worldToView(...a);
    return this.get2DLineThroughPoints(o, l);
  }
  intersectLineWithLine2D(e, n, s, r) {
    const [a, o] = e, [l, c] = n, [u, d] = s, [h, p] = r, m = (a - l) * (d - p) - (o - c) * (u - h);
    if (m === 0)
      return null;
    const b = ((a - u) * (d - p) - (o - d) * (u - h)) / m, y = ((a - u) * (o - c) - (o - d) * (a - l)) / m;
    return b >= 0 && b <= 1 && y >= 0 && y <= 1 ? [a + b * (l - a), o + b * (c - o)] : null;
  }
  setBorder(e) {
    e ? (this.showBorder(e), this.color = e) : this.hideBorder();
  }
  orientationWidgetShown(e) {
    this.orientationWidget != null && (e ? this.orientationWidget.show() : this.orientationWidget.hide());
  }
  setFilterMode(e, n = -1) {
    (this.filterMode != e || n != this.filterThickness) && (this.filterMode = e, n > 0 && (this.filterThickness = n, this.setFilterModeThickness()));
  }
  setFilterModeThickness() {
    this.cursor = "wait";
    const e = this.reslicerMap.map((n) => n.label).indexOf("3Dvolume");
    if (e != -1) {
      let n = Pp.MEAN, s = this.reslicerMap[e].reslicer;
      if (this.getFilterMode() == Je.MIP ? n = Pp.MAX : this.getFilterMode() == Je.MINMIP ? n = Pp.MIN : this.getFilterMode() == Je.SCOUT && (this.resetViewPosition(!0), this.presenterWindow.scoutUpToDateFlag = !1, n = Pp.MAX), this.wasmReslicer)
        this.wasmReslicer.updateFilterModeThickness(n, this.getFilterThickness(), this.getDirectionalSpacing());
      else {
        s = s, s.setSlabMode(n);
        const r = Math.min(this.getFilterThickness(), 4);
        s.setSlabSliceSpacingFraction(r), s.setSlabNumberOfSlices(Math.max(Math.round(this.getFilterThickness() / this.getDirectionalSpacing() / r), 1));
      }
    }
    this.cursor = null;
  }
  getDirectionalSpacing() {
    const e = this.getNormal(), n = this.context.getImageData().getSpacing();
    return Math.abs(e[0]) * n[0] + Math.abs(e[1]) * n[1] + Math.abs(e[2]) * n[2];
  }
  getResliceAxes() {
    return this.resliceAxes;
  }
  getViewSliceIndicators() {
    return this.viewSliceIndicators;
  }
  cleanup() {
    for (const e of this.reslicerMap) {
      this.context.removeActor(e.actor);
      try {
        e.actor.delete();
      } catch (n) {
        console.log(n);
      }
      this.context.removeMapper(e.mapper);
      try {
        e.mapper.delete();
      } catch (n) {
        console.log(n);
      }
      if (!this.wasmReslicer)
        try {
          e.reslicer.delete();
        } catch (n) {
          console.log(n);
        }
    }
    this.reslicerMap.length = 0, super.cleanup();
  }
  /*! pan camera to reslicer origin*/
  resetViewCamera() {
    const e = this.renderer.getActiveCamera(), n = this.getNormal(), s = this.getViewup(), r = this.getOrigin();
    I.negate(n, n), I.negate(s, s);
    const a = this.renderer.getActiveCamera().getDistance();
    e.setParallelProjection(!0), e.setPosition(r[0] + n[0] * a, r[1] + n[1] * a, r[2] + n[2] * a), e.setFocalPoint(r[0], r[1], r[2]), e.setViewUp(s[0], s[1], s[2]), this.cameraModified();
  }
  /*! no pan*/
  fitZoomToScreen() {
    const e = [0, 0], [n, s] = this.viewSize.get();
    e[0] = this.context.settings.general.crossSectionSizeMm, e[1] = this.context.settings.general.crossSectionSizeMm;
    let r = 0;
    this.viewMode == Nt.AXIAL ? (e[0] = this.bounds[1] - this.bounds[0], e[1] = this.bounds[3] - this.bounds[2]) : this.viewMode == Nt.CORONAL ? (e[0] = this.bounds[1] - this.bounds[0], e[1] = this.bounds[5] - this.bounds[4]) : this.viewMode == Nt.SAGITTAL && (e[0] = this.bounds[3] - this.bounds[2], e[1] = this.bounds[5] - this.bounds[4]);
    const a = n / e[0];
    e[1] * a > s ? r = e[1] / 2 : r = (e[1] + (s - e[1] * a) / a) / 2, this.renderer.getActiveCamera().setParallelScale(r), this.context.repaint();
  }
  setSliceNumber(e) {
    const n = this.context.getImageData().getDimensions(), s = this.context.getImageData().getSpacing();
    let r = I.create(), a = I.create(), o = I.create();
    for (let d = 0; d < 3; d++)
      r[d] = (n[d] - 1) * s[d];
    const l = this.getOrigin(), c = this.getNormal();
    N5(c, l, this.bounds, a, o);
    const u = this.getOrigin();
    I.scaleAndAdd(u, a, this.getNormal(), e), this.context.toolManager.coordControl.setCenter(u, this);
  }
  setSliceDelta(e) {
    const n = this.getOrigin();
    I.scaleAndAdd(n, n, this.getNormal(), e), this.context.toolManager.coordControl.setCenter(n, this);
  }
  getnormalBoundsIntersections() {
    const e = this.getOrigin(), n = this.getNormal(), s = I.create(), r = I.create();
    return I.scaleAndAdd(s, e, n, -1e3), I.scaleAndAdd(r, e, n, 1e3), T2(this.bounds, s, r);
  }
  getBounds() {
    return this.bounds;
  }
  isMultiCross() {
    return this.isCrossSection;
  }
  getWindowLevel() {
    let e = 0, n = 0;
    const s = this.reslicerMap.map((r) => r.label).indexOf("3Dvolume");
    return s != -1 && (e = this.reslicerMap[s].actor.getProperty().getColorWindow(), n = this.reslicerMap[s].actor.getProperty().getColorLevel()), [e, n];
  }
  setWindowLevel(e) {
    const n = this.reslicerMap.map((s) => s.label).indexOf("3Dvolume");
    n != -1 && (this.reslicerMap[n].actor.getProperty().setColorWindow(e[0]), this.reslicerMap[n].actor.getProperty().setColorLevel(e[1])), this.isCrossSection || (this.presenterWindow.window.set(e[0]), this.presenterWindow.level.set(e[1]));
  }
  hideOverlayComponents(e) {
    var n, s;
    e ? (n = this.orientationWidget) == null || n.hide() : this.showOrientationWidget.get() ?? ((s = this.orientationWidget) == null || s.show());
  }
}
class UDt extends op {
  constructor(t, e, n = {}) {
    super(t, e, n), this.setBorder(n.color), this.renderer.getActiveCamera().setDirectionOfProjection(0, 1, 0), this.renderer.getActiveCamera().setViewUp(0, 0, 1), this.renderer.resetCamera();
    const s = new PT(this, this.context, this.isShown);
    this.onCleanup(() => s.delete()), this.isShown.get() && s.show(), this.watch(this.isShown, (r) => {
      r ? s.show() : s.hide();
    });
  }
  isViewMode3D() {
    return !0;
  }
  cameraModified() {
    super.cameraModified();
  }
  setBorder(t) {
    t ? this.showBorder(t) : this.hideBorder();
  }
  fitZoomToScreen() {
  }
  isShownWrapper() {
    return this.isShown;
  }
}
var Yn = /* @__PURE__ */ ((i) => (i[i._MPR = 0] = "_MPR", i[i._3D_MPR = 1] = "_3D_MPR", i[i._LARGE_3D_MPR = 2] = "_LARGE_3D_MPR", i[i._FULLSCREEN_3D = 3] = "_FULLSCREEN_3D", i[i._FULLSCREEN_AXIAL = 4] = "_FULLSCREEN_AXIAL", i[i._FULLSCREEN_CORONAL = 5] = "_FULLSCREEN_CORONAL", i[i._FULLSCREEN_SAGITTAL = 6] = "_FULLSCREEN_SAGITTAL", i[i._FULLSCREEN_CPR = 7] = "_FULLSCREEN_CPR", i[i._FULLSCREEN_CROSS = 8] = "_FULLSCREEN_CROSS", i[i._3D_3X1_CPR_XRAY = 9] = "_3D_3X1_CPR_XRAY", i[i._3D_CROSS_AXIAL = 10] = "_3D_CROSS_AXIAL", i[i._3D_CROSS_CPR = 11] = "_3D_CROSS_CPR", i[i._3D_CROSS_TANGENT_AXIAL = 12] = "_3D_CROSS_TANGENT_AXIAL", i[i._3D_CPR_CROSS_TANGENT_AXIAL = 13] = "_3D_CPR_CROSS_TANGENT_AXIAL", i[i._3D_AXIAL_5X1 = 14] = "_3D_AXIAL_5X1", i[i._CPR_SETTINGS_WIZARD = 15] = "_CPR_SETTINGS_WIZARD", i[i._NERVE_DRAWING_WIZARD = 16] = "_NERVE_DRAWING_WIZARD", i[i._MATCHING_WIZARD = 17] = "_MATCHING_WIZARD", i[i._STL_PICKER_PREVIEW = 18] = "_STL_PICKER_PREVIEW", i[i._STL_PICKER_PREVIEW_2 = 19] = "_STL_PICKER_PREVIEW_2", i[i._FULLSCREEN_TANGENT = 20] = "_FULLSCREEN_TANGENT", i))(Yn || {}), Jn = /* @__PURE__ */ ((i) => (i[i.VOI_SETTINGS = 0] = "VOI_SETTINGS", i[i.THREED_SETTINGS = 1] = "THREED_SETTINGS", i[i.DATA_IMPORT = 2] = "DATA_IMPORT", i[i.CPR_SETTINGS = 3] = "CPR_SETTINGS", i[i.NERVE_DRAWING = 4] = "NERVE_DRAWING", i[i.TEETH_SETUP = 5] = "TEETH_SETUP", i[i.IMPLANT_PLANNING = 6] = "IMPLANT_PLANNING", i[i.REPORTS_EXPORT = 7] = "REPORTS_EXPORT", i[i.ADVANCED_TOOLS = 8] = "ADVANCED_TOOLS", i[i.OBJECT_LIST = 9] = "OBJECT_LIST", i[i.GUIDE_DESIGN = 10] = "GUIDE_DESIGN", i[i.CREATE_MODEL = 11] = "CREATE_MODEL", i[i.SEGMENTATION = 12] = "SEGMENTATION", i[i.SANDBOX = 13] = "SANDBOX", i[i.PROJECT_SETUP = 14] = "PROJECT_SETUP", i[i.RECONSTRUCTION_SETUP = 15] = "RECONSTRUCTION_SETUP", i[i.ACTIVE_RECONSTRUCTION = 16] = "ACTIVE_RECONSTRUCTION", i[i.CAD = 17] = "CAD", i[i.CAD_INTEGRATION_TEST = 18] = "CAD_INTEGRATION_TEST", i[i.CAD_DESIGN = 19] = "CAD_DESIGN", i))(Jn || {});
const uz = {
  0: [
    [1, Ce.left],
    [2, Ce.topRight],
    [3, Ce.bottomRight]
  ],
  1: [
    [0, Ce.topLeft],
    [1, Ce.bottomLeft],
    [2, Ce.topRight],
    [3, Ce.bottomRight]
  ],
  2: [
    [0, Ce.left23],
    [1, Ce.topRight1313],
    [2, Ce.middleRight1313],
    [3, Ce.bottomRight1313]
  ],
  3: [[0, Ce.fullscreen]],
  4: [[1, Ce.fullscreen]],
  5: [[2, Ce.fullscreen]],
  6: [[3, Ce.fullscreen]],
  7: [[4, Ce.fullscreen]],
  8: [[5, Ce.fullscreen]],
  9: [
    [0, Ce.topLeft],
    [5, Ce.topRight],
    [4, Ce.bottom]
  ],
  10: [
    [0, Ce.left23],
    [5, Ce.topRight1312],
    [1, Ce.bottomRight1312]
  ],
  11: [
    [0, Ce.topLeft],
    [5, Ce.topRight],
    [4, Ce.bottom]
  ],
  12: [
    [0, Ce.left23],
    [5, Ce.topRight1313],
    [6, Ce.middleRight1313],
    [1, Ce.bottomRight1313]
  ],
  13: [
    [0, Ce.topLeft2323],
    [4, Ce.bottomLeft2313],
    [5, Ce.topRight1313],
    [6, Ce.middleRight1313],
    [1, Ce.bottomRight1313]
  ],
  14: [
    [0, Ce.topLeft1223],
    [1, Ce.topRight1223],
    [5, Ce.bottom13]
  ],
  15: [
    [2, Ce.topLeft31],
    [1, Ce.topMiddle31],
    [3, Ce.topRight31],
    [4, Ce.bottom]
  ],
  16: [
    [5, Ce.top],
    [4, Ce.bottom]
  ],
  17: [
    [0, Ce.topLeft],
    [7, Ce.topRight],
    [1, Ce.bottomLeft1312],
    [2, Ce.bottomMiddle1312],
    [3, Ce.bottomRight1312]
  ],
  18: [
    [8, Ce.centerPreview],
    [5, Ce.topRightPreview],
    [6, Ce.bottomRightPreview]
  ],
  19: [
    [8, Ce.centerPreview],
    [5, Ce.topRightPreview],
    [0, Ce.bottomRightPreview]
  ],
  20: [[6, Ce.fullscreen]]
};
class uTt {
  constructor(t) {
    S(this, "context");
    S(this, "borderWidth", 2);
    S(this, "gapWidth", 1);
    S(this, "storedLayouts", /* @__PURE__ */ new Map());
    S(this, "defaultLayout", 1);
    S(this, "currentLayout");
    S(this, "constructors");
    S(this, "wizardTabIndex", new qt(
      0
      /* VOI_SETTINGS */
    ));
    S(this, "reactivity", An());
    S(this, "watch", this.reactivity.watch);
    S(this, "views", {
      0: null,
      1: null,
      2: null,
      3: null,
      4: null,
      5: null,
      6: null,
      7: null,
      8: null
    });
    S(this, "background", [0.24, 0.24, 0.24]);
    S(this, "viewColors", {
      sagittal: [0, 255, 0],
      coronal: [0, 0, 255],
      axial: [255, 0, 0],
      cpr: [255, 255, 255],
      _3d: [255, 255, 255],
      cross: [255, 0, 255],
      tan: [255, 255, 0]
    });
    S(this, "USEWASM", !0);
    this.context = t, this.constructors = {
      0: () => new c2(this.context, RW, Nt._3D, {
        background: this.background,
        color: this.viewColors._3d
      }),
      3: () => new oy(
        this.context,
        vl,
        Nt.SAGITTAL,
        {
          background: this.background,
          color: this.viewColors.sagittal
        },
        { useWasmReslicer: this.USEWASM }
      ),
      2: () => new oy(
        this.context,
        vl,
        Nt.CORONAL,
        {
          background: this.background,
          color: this.viewColors.coronal
        },
        { useWasmReslicer: this.USEWASM }
      ),
      1: () => new oy(
        this.context,
        vl,
        Nt.AXIAL,
        {
          background: this.background,
          color: this.viewColors.axial
        },
        { useWasmReslicer: this.USEWASM }
      ),
      4: () => new ZNt(t, Nt.CPR, {
        background: this.background,
        color: this.viewColors.cpr
      }),
      5: () => new oy(
        this.context,
        vl,
        Nt.CROSS,
        {
          background: this.background,
          color: this.viewColors.coronal
          // color: this.viewColors.cross,
        },
        { useWasmReslicer: this.USEWASM }
      ),
      6: () => new oy(
        this.context,
        vl,
        Nt.TANGENT,
        {
          background: this.background,
          color: this.viewColors.sagittal
          // color: this.viewColors.tan,
        },
        { useWasmReslicer: this.USEWASM }
      ),
      7: () => new c2(this.context, RW, Nt.STL3D, {
        background: this.background,
        color: this.viewColors._3d,
        toolbarDisable: !0
      }),
      8: () => new c2(this.context, TNt, Nt._STL_3D_PREVIEW, {
        background: this.background,
        color: this.viewColors._3d,
        toolbarDisable: !0
      })
    }, this.watch(this.wizardTabIndex, () => {
      console.log("LayoutManager, wizTab", this.wizardTabIndex.get());
    });
  }
  construct3DWindow() {
    const t = this.constructors[
      0
      /* _3D */
    ]();
    this.context.addWindow(t), this.views[0] = t;
  }
  constructAllWindows() {
    const t = this.constructors[0]();
    this.context.addWindow(t), this.views[0] = t;
    const e = this.constructors[1]();
    this.context.addWindow(e), this.views[1] = e;
    const n = this.constructors[2]();
    this.context.addWindow(n), this.views[2] = n;
    const s = this.constructors[3]();
    this.context.addWindow(s), this.views[3] = s;
    const r = this.constructors[4]();
    this.context.addWindow(r), this.views[4] = r;
    const a = this.constructors[5]();
    this.context.addWindow(a), this.views[5] = a;
    const o = this.constructors[6]();
    this.context.addWindow(o), this.views[6] = o;
  }
  setLayout(t) {
    const e = uz[t], n = [];
    for (const [a, o] of e) {
      let l = this.views[a];
      l === null && (l = this.constructors[a](), this.context.addWindow(l), this.views[a] = l), n.push([l, o]);
    }
    this.context.setLayout(n);
    const s = this.context.getPresenterWindow(Nt.CROSS), r = this.context.getPresenterWindow(Nt.CPR);
    this.currentLayout == 9 && r.setFilterModeEvent.notify({ filterMode: Je.MPR }), (this.currentLayout == 14 || this.currentLayout == 9) && t != 14 && t != 9 && s.setLayoutEvent.notify({ preset: l2._1x1 }), t == 14 ? s.setLayoutEvent.notify({ preset: l2._5x1 }) : t == 9 && (s.setLayoutEvent.notify({ preset: l2._3x1 }), r.setFilterModeEvent.notify({ filterMode: Je.RAYSUM })), this.currentLayout, this.currentLayout = t, this.context.cadMode.get() ? new Promise((o) => {
      const l = () => {
        this.context.cadMode.get() ? (console.log("Waiting for CAD to close..."), setTimeout(l, 200)) : (console.log("CAD is closed, proceeding with layout change..."), o());
      };
      l();
    }).then(() => {
      this.context.resetOrientation({ resetMode: !1, preserveCPRAngles: !0 });
    }) : this.context.resetOrientation({ resetMode: !1, preserveCPRAngles: !0 });
  }
  storeLayout(t, e) {
    this.storedLayouts.set(t, e);
  }
  getLayout(t) {
    const e = this.storedLayouts.get(t);
    if (e !== void 0)
      return e;
  }
  getDefaultLayout() {
    return this.defaultLayout;
  }
  /** Returns the current layout template and 2d presenter window layouts. */
  getCurrentLayoutState() {
    var e;
    const t = {
      template: this.currentLayout,
      presenterWindow2dLayouts: {}
    };
    for (const n of this.context.getPresenterWindows()) {
      const s = n.presenterWindowType;
      if (s === ni.PresenterWindow2D && s === ni.PresenterWindow2D) {
        const r = (e = n.getMainView()) == null ? void 0 : e.getViewMode();
        r && (t.presenterWindow2dLayouts[r] = n.getLayout());
      }
    }
    return t;
  }
  /** Restores saved layout template and 2d presenter window layouts. */
  restoreLayoutState(t) {
    var e;
    t.template != null && this.setLayout(t.template);
    for (const n of this.context.getPresenterWindows())
      if (n.presenterWindowType === ni.PresenterWindow2D) {
        const r = (e = n.getMainView()) == null ? void 0 : e.getViewMode();
        if (r) {
          const a = t.presenterWindow2dLayouts[r];
          a && n.setLayout(a);
        }
      }
  }
  sceneRepaint(t, e) {
    var n, s, r;
    for (const a of this.context.getPresenterWindows())
      if ((n = a.getMainView()) != null && n.isVisible()) {
        if (t && t != a.getMainView())
          continue;
        if (t && t == a.getMainView()) {
          (s = a.getMainView()) == null || s.sceneRepaint(e, !0);
          return;
        } else
          (r = a.getMainView()) == null || r.sceneRepaint(e, !0);
        if (a.presenterWindowType == ni.PresenterWindow2D) {
          for (const o of a.views)
            if (!(t && t != a.getMainView())) if (t && t == o) {
              o.sceneRepaint(e, !0);
              return;
            } else
              o.sceneRepaint(e, !0);
        }
      }
    for (const a of this.context.getViews())
      a && a.sceneRepaint(e, !0);
  }
  sceneRefresh(t) {
    this.context.getPresenterWindows().forEach((e) => {
      var n, s;
      if ((n = e.getMainView()) != null && n.isVisible()) {
        if (t && t != e.getMainView()) return;
        (s = e.getMainView()) == null || s.sceneRefresh(!0), e.presenterWindowType == ni.PresenterWindow2D && e.views.forEach((r) => {
          r.sceneRefresh(!0);
        });
      }
    });
  }
  layoutTemplateContainsCpr(t) {
    for (const e of uz[t]) {
      const n = e[0];
      if (n === 4 || n === 5)
        return !0;
    }
    return !1;
  }
  isLayoutStlLibrary() {
    return this.currentLayout == 18 || this.currentLayout == 19;
  }
  layoutContainsCpr(t) {
    var e;
    for (const n of t)
      if ("getViewMode" in n[0]) {
        const s = n[0].getViewMode();
        if (s === Nt.CPR || s === Nt.CROSS)
          return !0;
      } else {
        const s = (e = n[0].getMainView()) == null ? void 0 : e.getViewMode();
        if (s === Nt.CPR || s === Nt.CROSS)
          return !0;
      }
    return !1;
  }
  delete() {
    this.reactivity.cleanupAll();
  }
}
//! Desktop View modes. Each View Mode may appaer in any LayoutType.
var YJ = /* @__PURE__ */ ((i) => (i[i._DEFAULT_DESK = 0] = "_DEFAULT_DESK", i[i._MPR_VIEW = 1] = "_MPR_VIEW", i[i._MPR_3D_VIEW = 2] = "_MPR_3D_VIEW", i[i._MPR_3D_COMPACT_VIEW = 3] = "_MPR_3D_COMPACT_VIEW", i[i._3D_FULLSCREEN_VIEW = 4] = "_3D_FULLSCREEN_VIEW", i[i._CPR_FULLSCREEN_VIEW = 5] = "_CPR_FULLSCREEN_VIEW", i[i._AXIAL_FULLSCREEN_VIEW = 6] = "_AXIAL_FULLSCREEN_VIEW", i[i._CORONAL_FULLSCREEN_VIEW = 7] = "_CORONAL_FULLSCREEN_VIEW", i[i._SAGITTAL_FULLSCREEN_VIEW = 8] = "_SAGITTAL_FULLSCREEN_VIEW", i[i._CROSS_FULLSCREEN_VIEW = 9] = "_CROSS_FULLSCREEN_VIEW", i[i._3D_CROSS_AXIAL = 10] = "_3D_CROSS_AXIAL", i[i._3D_CROSS_CPR = 11] = "_3D_CROSS_CPR", i[i._3D_CROSS_TANGENT_AXIAL = 12] = "_3D_CROSS_TANGENT_AXIAL", i[i._3D_CPR_CROSS_TANGENT_AXIAL = 13] = "_3D_CPR_CROSS_TANGENT_AXIAL", i[i._3D_AXIAL_5X1 = 14] = "_3D_AXIAL_5X1", i[i._CPR_CROSS_3D_VIEW = 15] = "_CPR_CROSS_3D_VIEW", i[i._CPR_CROSS_AXIAL_VIEW = 16] = "_CPR_CROSS_AXIAL_VIEW", i[i._CROSS_TANGENT_3D_VIEW = 17] = "_CROSS_TANGENT_3D_VIEW", i[i._CROSS_AXIAL_3D_VIEW = 18] = "_CROSS_AXIAL_3D_VIEW", i[i._TMJ_VIEW = 19] = "_TMJ_VIEW", i[i._DRAW_CPR_VIEW = 20] = "_DRAW_CPR_VIEW", i[i._DRAW_NERVE_VIEW = 21] = "_DRAW_NERVE_VIEW", i[i._DRAW_AIRWAYS = 22] = "_DRAW_AIRWAYS", i[i._PREVIEW_CROSS_TANGENT = 23] = "_PREVIEW_CROSS_TANGENT", i[i._PREVIEW_CROSS_3D = 24] = "_PREVIEW_CROSS_3D", i[i._TMJ_LAYOUT_MPR = 25] = "_TMJ_LAYOUT_MPR", i[i._STL_REGISTRATION_VIEW = 26] = "_STL_REGISTRATION_VIEW", i[i._3D_3x1_CPRRAYSUM = 27] = "_3D_3x1_CPRRAYSUM", i[i._TANGENT_FULLSCREEN_VIEW = 28] = "_TANGENT_FULLSCREEN_VIEW", i))(YJ || {});
function dTt(i) {
  switch (i) {
    case 1:
      return 0;
    case 2:
      return 1;
    case 3:
      return 2;
    case 4:
      return 3;
    case 5:
      return 7;
    case 6:
      return 4;
    case 7:
      return 5;
    case 8:
      return 6;
    case 9:
      return 8;
    case 10:
      return 10;
    case 11:
      return 11;
    case 12:
      return 12;
    case 13:
      return 13;
  }
  return null;
}
function hTt(i) {
  switch (i) {
    case 0:
      return 1;
    case 1:
      return 2;
    case 2:
      return 3;
    case 3:
      return 4;
    case 7:
      return 5;
    case 4:
      return 6;
    case 5:
      return 7;
    case 6:
      return 8;
    case 8:
      return 9;
    case 10:
      return 10;
    case 11:
      return 11;
    case 12:
      return 12;
    case 13:
      return 13;
  }
  return null;
}
class RW extends op {
  constructor(e, n, s = {}) {
    var r;
    super(e, n, s);
    S(this, "overlayComponents");
    S(this, "orientationWidget");
    S(this, "moveFlag", !1);
    S(this, "pickedObjectId", null);
    S(this, "startPosition", [0, 0]);
    S(this, "startXY", [0, 0]);
    S(this, "startUserM", ut.create());
    if (this.setBorder(s.color), n != Nt.STL3D) {
      n != Nt.CAD_3D && this.setActors(e.objects.getActors());
      const a = e.getModalsInstance(), o = this.context.objects.measurementsObjects;
      let l = null;
      const c = (at, dt, gt) => {
        l = p(zT, {
          menuItems: at,
          x: dt,
          y: gt
        });
      }, u = () => {
        l && (l.remove(), l = null);
      }, d = (at, dt, gt) => {
        const Wt = this.context.getObjects().getSTLObjectIdByActor(at);
        if (Wt === null)
          return !1;
        const Zt = this.context.getObjects().getStlObject(Wt);
        if (Zt === null)
          return !1;
        const Gt = Zt.type;
        if (![
          Yt._STL_OBJECT,
          Yt._STL_TEETH_MODEL,
          Yt._STL_PROSTHESIS,
          Yt._STL_TOOTH,
          Yt._IMPLANT,
          Yt._PIN,
          Yt._VOLUME_LABEL
        ].includes(Gt))
          return !1;
        const Tt = Zt.type === Yt._STL_OBJECT || Zt.type === Yt._STL_TEETH_MODEL || Zt.type === Yt._STL_PROSTHESIS || Zt.type === Yt._STL_TOOTH || Zt.type === Yt._VOLUME_LABEL ? Z(Wt) : y(Wt);
        if (Tt) {
          const Q = this.context.getState().canvasSize.get();
          return c(Tt.items, dt, Q[1] - gt - 1), !0;
        }
        return !1;
      }, h = {
        onRightPress: () => (u(), !1),
        onRightRelease: (at, dt, gt) => {
          u();
          const { x: Wt, y: Zt } = dt.position;
          if (gt.cameraDragActive)
            return !1;
          const Gt = at.pickProp(Wt, Zt);
          return Gt ? d(Gt, Wt, Zt) : !1;
        },
        onLeftPress: (at, dt) => {
          this.pickedObjectId = null;
          const gt = this.pickProp(dt.position.x, dt.position.y);
          if (gt != null && (this.pickedObjectId = this.context.getObjects().implants.getByActor(gt) || this.context.getObjects().pins.getByActor(gt) || "", console.log("pickProp ID", this.pickedObjectId), this.pickedObjectId)) {
            this.viewObjectPositions.get().forEach((Zt) => {
              Zt.id == this.pickedObjectId && (this.startXY = [dt.position.x, dt.position.y], this.startPosition = [...Zt.position]);
            });
            const Wt = this.context.getObjects().getStlObject(this.pickedObjectId);
            if (Wt == null)
              throw Error("Should not happen - Object not found");
            this.startUserM = ut.clone(Wt.getMatrix());
          }
          return u(), this.moveFlag = !1, !1;
        },
        onLeftRelease: (at, dt) => {
          if (this.moveFlag) {
            if (this.pickedObjectId) {
              this.context.getObjects().snapToObject(this.pickedObjectId);
              const gt = this.context.getObjects().getStlObject(this.pickedObjectId);
              if (gt == null)
                return console.error("Picked object not found!"), !1;
              const Wt = ut.clone(gt.getMatrix()), Zt = ut.clone(this.startUserM), Gt = new vr({
                onUndo: () => {
                  if (gt == null) {
                    console.error("Picked object not found!");
                    return;
                  }
                  gt.setMatrix(Zt), gt.type == Yt._IMPLANT && gt.updatePosition(), gt.type == Yt._PIN && gt.updatePosition(), this.context.objectMoveRotateEndEvent.notify({ objectId: gt.id });
                },
                onRedo: () => {
                  if (gt == null) {
                    console.error("Picked object not found!");
                    return;
                  }
                  gt.setMatrix(Wt), gt.type == Yt._IMPLANT && gt.updatePosition(), gt.type == Yt._PIN && gt.updatePosition(), this.context.objectMoveRotateEndEvent.notify({ objectId: gt.id });
                }
              });
              return this.context.undoManager.pushPop(gt, Gt, jt("medic-web-engine.moveObject"), ws.NONE), this.context.objectMoveRotateEndEvent.notify({ objectId: gt.id }), !0;
            }
          } else {
            if (this.pickedObjectId)
              return this.context.getObjects().selectObject(this.pickedObjectId), !0;
            this.context.getObjects().unSelectObject();
            const gt = at.pickPropPoint(dt.position.x, dt.position.y);
            let Wt = null;
            gt && (Wt = gt[1]);
            const Zt = zh(this.context, this, dt.position.x, dt.position.y), Gt = Eh(at, Zt, Wt);
            if (Gt)
              return this.context.toolManager.coordControl.setCenter(Gt, this), !0;
          }
          return !1;
        },
        onMouseMove: (at, dt, gt) => {
          if (this.moveFlag = !0, this.pickedObjectId != null && gt.mouseButtons.left) {
            let Wt = !1;
            return this.viewObjectPositions.get().forEach((Zt) => {
              var Gt;
              if (Zt.id == this.pickedObjectId && Zt.type != Yt._STL_OBJECT && Zt.id == ((Gt = this.context.getObjects().selectedObject.get()) == null ? void 0 : Gt.id)) {
                const Tt = dt.position.x - this.startXY[0], Q = dt.position.y - this.startXY[1];
                this.objectMoveEvent.notify({ objectId: this.pickedObjectId, viewPosition: [this.startPosition[0] + Tt, this.startPosition[1] - Q] }), Wt = !0;
              }
            }), Wt;
          }
          return !1;
        },
        onKeyDown(at, dt, gt) {
          const Wt = e.objects.selectedObject.get();
          if (Wt && !Wt.IsVolume()) {
            const Zt = Wt, Gt = e.settings.implants.preciseMovementStepMm, Tt = Math.PI * e.settings.implants.preciseRotationStepDeg / 180, Q = I.create(), D = I.create();
            if (Zt.getMoveDeltaVectors(at, Q, D), dt.key == "w" || dt.key == "ArrowUp")
              return Zt.moveDelta(Q, Gt), !0;
            if (dt.key == "s" || dt.key == "ArrowDown")
              return Zt.moveDelta(Q, -Gt), !0;
            if (dt.key == "a" || dt.key == "ArrowLeft")
              return Zt.moveDelta(D, Gt), !0;
            if (dt.key == "d" || dt.key == "ArrowRight")
              return Zt.moveDelta(D, -Gt), !0;
            if (dt.key == "q" || dt.key == "+") {
              if (Zt.type == Yt._IMPLANT)
                return Zt.rotateImplantFi(Tt, at.getNormal(), "bottom"), !0;
              if (Zt.type == Yt._PIN)
                return Zt.rotatePinFi(Tt, at.getNormal(), "bottom"), !0;
            } else {
              if (dt.key == "e" || dt.key == "-")
                return Zt.type == Yt._IMPLANT ? (Zt.rotateImplantFi(-Tt, at.getNormal(), "bottom"), !0) : (Zt.type == Yt._PIN && Zt.rotatePinFi(-Tt, at.getNormal(), "bottom"), !0);
              if (dt.key == "z")
                return Zt.type == Yt._IMPLANT ? (Zt.rotateImplantFi(-Tt, at.getNormal(), "top"), !0) : (Zt.type == Yt._PIN && Zt.rotatePinFi(-Tt, at.getNormal(), "top"), !0);
              if (dt.key == "c")
                return Zt.type == Yt._IMPLANT ? (Zt.rotateImplantFi(Tt, at.getNormal(), "top"), !0) : (Zt.type == Yt._PIN && Zt.rotatePinFi(Tt, at.getNormal(), "top"), !0);
            }
          }
          return !1;
        }
      };
      (r = this.context.getInteractorStyle()) == null || r.setViewEventHandler(this, h), this.onCleanup(() => {
        var at;
        (at = this.context.getInteractorStyle()) == null || at.setViewEventHandler(this, null);
      });
      const { createVueOverlayComponent: p, cleanup: m } = Pi(this.overlayContainer.getElement());
      this.onCleanup(() => m());
      const b = (at) => {
        if (at.length <= 1)
          return;
        const dt = Array.from(new Set(at)), gt = dt.map((Q) => this.context.getObjects().getStlObject(Q));
        if (gt.some((Q) => Q === null))
          return [];
        const Wt = gt.filter((Q) => Q !== null);
        if (!Wt.length)
          return [];
        const Zt = Wt[0].type;
        if (Wt.some((Q) => Q.type !== Zt))
          return [];
        const Tt = [];
        return this.context.readOnly || Tt.push({
          label: `${jt("shared.delete")} (${dt.length})`,
          command: () => {
            a.showConfirmModal(
              jt("weblink.deleteConfirmation"),
              jt("implant-planner.deleteSelectedObjectsPrompt", { count: dt.length })
            ).then((Q) => {
              Q && N(dt);
            });
          }
        }), Tt;
      }, y = (at) => {
        const dt = this.context.getObjects().getStlObject(at);
        if (!dt)
          return console.warn("create dropdown: object not found"), null;
        let gt = jt("medic-web-engine.object");
        dt.type == Yt._IMPLANT ? gt = jt("shared.implant") : dt.type == Yt._PIN && (gt = jt("medic-web-engine.pin"));
        const Wt = this.context.settings.general.useUSStyleToothChart, Zt = this.context.CPRType === xo.MAXILLA ? yd(Wt) : gd(Wt), Gt = [], Tt = [];
        Zt.forEach((D) => {
          this.context.getObjects().implantExists(D) ? D != dt.getName() && Tt.push(D) : Gt.push(D);
        });
        const Q = {
          items: [
            {
              label: dt.getVisibility() ? jt("shared.hide") + " " + gt : jt("shared.show") + " " + gt,
              command: () => {
                const D = dt.getVisibility();
                W(at, !D), T();
              }
            }
          ]
        };
        return e.readOnly || Q.items.push(
          {
            label: jt("shared.delete") + " " + gt,
            command: () => {
              N(at);
            }
          },
          {
            label: this.context.getObjects().getLockStatus(at) ? jt("medic-web-engine.unlock") + " " + gt : jt("medic-web-engine.lock") + " " + gt,
            command: () => {
              const D = this.context.getObjects().getLockStatus(at);
              D != null && (this.context.getObjects().changeLockStatus(at, !D), T());
            }
          },
          {
            label: jt("medic-web-engine.lockUnlockAll"),
            command: () => {
              const D = this.context.getObjects().getLockStatus(at);
              D != null && (this.context.getObjects().lockUnlockAllImplantPins(!D), T());
            }
          },
          {
            label: jt("shared.editNotes"),
            command: () => {
              const D = dt.getNotes();
              a.showTextInputModal(jt("shared.notes"), D).then((q) => {
                q !== null && q !== D && dt.setNotes(q);
              });
            }
          }
        ), dt.type !== Yt._PIN && Q.items.push({
          label: jt("shared.changeColor"),
          command: () => {
            const q = dt.getColor().map((nt) => nt * 255);
            a.showColorPickerModal(jt("shared.setItemColor"), q).then((nt) => {
              nt !== null && nt !== q && (this.context.getObjects().setObjectColor(at, nt), R(), this.sceneRefresh());
            });
          }
        }), Q.items.push({
          label: jt("medic-web-engine.transparency"),
          items: [0, 20, 50, 80, 100].map((D) => ({
            label: D ? D + "%" : "Opaque",
            command: () => {
              this.context.getObjects().setObjectTransparency(at, D), T();
            }
          }))
        }), dt.type == Yt._IMPLANT && !this.context.readOnly && Q.items.push(
          {
            label: jt("medic-web-engine.setAxisParallelTo"),
            items: Tt.map((D) => ({
              label: D,
              command: () => {
                this.context.getObjects().setAxisParallelTo(at, D), T();
              }
            }))
          },
          {
            label: jt("medic-web-engine.changeToothNumber"),
            items: Gt.map((D) => ({
              label: D,
              command: () => {
                this.context.getObjects().changeToothNumber(at, D), T();
              }
            }))
          }
        ), Q;
      }, Z = (at) => {
        const dt = this.context.getObjects().getStlObject(at);
        if (!dt)
          return console.warn("create dropdown: object not found with id: ", at), null;
        const gt = dt.isTrackedObject(), Wt = {
          items: [
            {
              label: dt.getVisibility() ? jt("implant-planner.hideObject") : jt("implant-planner.showObject"),
              command: () => {
                const Zt = dt.getVisibility();
                W(at, !Zt), T();
              }
            }
          ]
        };
        return this.context.readOnly || (Wt.items.push(
          // {
          //     label: object.getVisibility() ? "Hide All Object" : "Show All Objects",
          //     command: () => {
          //         const visible = object.getVisibility();
          //         setAllObjectsVisibility(!visible);
          //         updateDeferred();
          //     },
          // },
          {
            label: jt("implant-planner.deleteObject"),
            command: () => {
              N(at);
            }
          },
          {
            label: jt("shared.editNotes"),
            command: () => {
              const Zt = dt.getNotes();
              a.showTextInputModal(jt("shared.notes"), Zt).then((Gt) => {
                Gt !== null && Gt !== Zt && dt.setNotes(Gt);
              });
            }
          }
        ), dt.type != Yt._STL_TOOTH && Wt.items.push({
          label: this.context.getObjects().getLockStatus(at) ? "🔒 " + jt("medic-web-engine.unlockObject") : "🔓 " + jt("medic-web-engine.lockObject"),
          command: () => {
            const Zt = this.context.getObjects().getLockStatus(at);
            Zt != null && (this.context.getObjects().changeLockStatus(at, !Zt), T());
          }
        })), Wt.items.push(
          {
            label: jt("shared.changeColor"),
            command: () => {
              const Gt = dt.getColor().map((Tt) => Tt * 255);
              a.showColorPickerModal(jt("shared.setItemColor"), Gt).then((Tt) => {
                Tt !== null && Tt !== Gt && (this.context.getObjects().setObjectColor(at, Tt), R(), this.sceneRefresh());
              });
            }
          },
          {
            label: jt("medic-web-engine.changeTransparency"),
            items: [0, 30, 60].map((Zt) => ({
              label: Zt ? Zt + "%" : jt("medic-web-engine.opaque"),
              command: () => {
                this.context.getObjects().setObjectTransparency(at, Zt), T();
              }
            }))
          },
          {
            label: jt("medic-web-engine.toggleWireframe"),
            command: () => {
              this.context.getObjects().toggleObjectWireframe(at);
            }
          }
        ), this.context.readOnly || Wt.items.push(
          {
            label: jt("medic-web-engine.matchObject"),
            command: () => {
              this.context.startMatchingWithObjectId = at, this.context.layoutManager.wizardTabIndex.set(Jn.DATA_IMPORT);
            }
          },
          {
            label: jt("medic-web-engine.renameObject"),
            command: () => {
              const Zt = dt.getDisplayText();
              a.showTextInputModal(jt("medic-web-engine.newObjectName"), Zt).then((Gt) => {
                Gt !== null && Gt !== Zt && (this.context.getObjects().setSTLName(at, Gt), R());
              });
            }
          }
        ), !gt && !this.context.readOnly && Wt.items.push({
          label: jt("medic-web-engine.changeObjectType"),
          items: [
            "Marker Scan",
            "Anatomy",
            "Antagonist",
            "Waxup-Prosthesis",
            "Bone Surface",
            "Bone Graft",
            "Surgical Guide",
            "Bone Reduction Guide",
            "Acrylic Flange",
            "Bar",
            "Other"
          ].map((Zt) => ({
            label: Zt,
            command: () => {
              this.context.getObjects().setSTLType(at, Zt), R();
            }
          }))
        }), this.context.readOnly || Wt.items.push({
          label: jt("medic-web-engine.duplicateObject"),
          command: () => {
            this.context.getObjects().duplicateSTL(at);
          }
        }), Wt.items.push({
          label: jt("medic-web-engine.calculateVolume"),
          command: () => {
            this.context.getObjects().getObjectVolume(at);
          }
        }), Wt;
      }, g = (at) => {
        if (!this.context.getObjects().getStlObject(at)) {
          console.warn("object list item click: item not found with key: ", at);
          return;
        }
      };
      let f = !1;
      const T = () => {
        f || (f = !0, queueMicrotask(() => {
          f = !1, this.sceneRefresh(), R();
        }));
      }, M = (at) => at === Yt._IMPLANT || at === Yt._PIN || at === Yt._STL_OBJECT || at === Yt._STL_TEETH_MODEL || at === Yt._STL_PROSTHESIS || at === Yt._STL_TOOTH || at === Yt._REFERENCE_PLANE, N = (at) => {
        const gt = (Array.isArray(at) ? at : [at]).map((Zt) => {
          const Gt = this.context.getObjects().getStlObject(Zt);
          return Gt ? { key: Zt, type: Gt.type } : null;
        }).filter((Zt) => Zt !== null);
        if (!gt.length)
          return;
        const Wt = gt.every((Zt) => M(Zt.type));
        Wt && this.context.undoManager.push(jt("shared.delete"), ws.SCENE_REPAINT);
        for (const { key: Zt, type: Gt } of gt)
          this.context.getObjects().removeObject(Zt, Gt);
        Wt && this.context.undoManager.pop(), T();
      }, W = (at, dt) => {
        const gt = Array.isArray(at) ? at : [at];
        let Wt = !1;
        this.context.undoManager.push(jt("medic-web-engine.setObjectVisibility"), ws.NONE);
        for (const Zt of gt) {
          const Gt = this.context.getObjects().getStlObject(Zt);
          if (Gt) {
            const Q = Gt.getVisibility(), D = new vr({
              onRedo: () => {
                this.context.getObjects().setObjectVisibility(Zt, dt);
              },
              onUndo: () => {
                this.context.getObjects().setObjectVisibility(Zt, Q);
              }
            });
            this.context.getObjects().setObjectVisibility(Zt, dt, !1), this.context.undoManager.add(Gt, D), Wt = !0;
            continue;
          }
          const Tt = o.get().get(Zt);
          if (Tt) {
            const Q = Tt.annotation.getVisible();
            if (Q === void 0) {
              console.warn("object tree: measurement visibility not found");
              continue;
            }
            const D = (nt) => {
              this.context.toolManager.measurementsTool.measurementTool.setSingleMeasurementVisibility(Zt, nt);
            }, q = new vr({
              onRedo: () => D(dt),
              onUndo: () => D(Q)
            });
            D(dt), this.context.undoManager.add(Tt, q);
            continue;
          }
        }
        this.context.undoManager.pop(), Wt && T();
      }, x = (at, dt) => {
        dt || W(at, !0);
      }, V = (at, dt) => {
        dt || W(at, !1);
      }, X = (at, dt) => {
        W(at, dt);
      }, C = new qt([]), R = () => {
        const at = [], dt = [], gt = [], Wt = [], Zt = [], Gt = [], Tt = [], Q = [], D = (nt) => ({
          key: nt.id,
          label: nt.name,
          visible: nt.visible,
          multiSelectGroup: String(nt.type),
          color: nt.color || [255, 255, 0],
          dropdown: nt.type === Yt._STL_OBJECT || nt.type === Yt._STL_TEETH_MODEL || nt.type === Yt._STL_PROSTHESIS || nt.type === Yt._STL_TOOTH || nt.type === Yt._VOLUME_LABEL ? Z : nt.type != Yt._NERVE && nt.type != Yt._GUIDE_SUPPORT_OBJECT ? y : void 0,
          onClick: g,
          // onDoubleClick: (key: string) => {},
          onSelect: x,
          onUnselect: V
        }), q = [];
        for (const nt of this.contextState.object3DInfos.get()) {
          if (n == Nt.CAD_3D) {
            const ot = [
              ...this.context.getObjects().stls.values(),
              ...this.context.getObjects().implants.values(),
              ...this.context.getObjects().pins.values(),
              ...this.context.getObjects().volumes.values()
            ];
            for (let ht of this.context.getObjects().nerveObjects.values())
              ot.push(ht.nerve);
            if (ot.findIndex((ht) => ht.id == nt.id) == -1) continue;
          }
          const et = D(nt);
          if (nt.type === Yt._STL_OBJECT || nt.type === Yt._STL_TEETH_MODEL || nt.type === Yt._STL_PROSTHESIS) {
            const ot = this.context.getObjects().getStlObject(nt.id);
            ot && (et.isLocked = ot.getLocked(), et.lockDisabled = this.context.readOnly, et.onLockToggle = (it) => {
              const ht = this.context.getObjects().getStlObject(it);
              ht && (ht.setLocked(!ht.getLocked()), T(), this.context.objects.object3DInfos.modified(), setTimeout(() => {
                this.context.updateObject2DPositionEvent.notify();
              }, 0));
            }), ot && ot.IsVolume() ? dt.push(et) : at.push(et);
          } else if (nt.type === Yt._STL_TOOTH)
            gt.push(et);
          else if (nt.type === Yt._REFERENCE_PLANE)
            Wt.push(et);
          else if (nt.type === Yt._IMPLANT)
            if (this.context.isCADObjectList.get()) {
              const ot = [];
              ot.push(et);
              const it = this.context.getObjects().implants.get(nt.id), ht = it == null ? void 0 : it.getAbutment();
              if (ht) {
                const wt = ht.getColor(), Xt = [0, 0, 0];
                Xt[0] = wt[0] * 255, Xt[1] = wt[1] * 255, Xt[2] = wt[2] * 255;
                const At = {
                  key: ht.id,
                  label: jt("shared.abutment"),
                  visible: ht.getVisibility(),
                  multiSelectGroup: String(Yt._ABUTMENT),
                  color: Xt,
                  dropdown: void 0,
                  onSelect: () => {
                    ht.setVisibility(!0), T();
                  },
                  onUnselect: () => {
                    ht.setVisibility(!1), T();
                  }
                };
                ot.push(At);
              }
              const lt = it == null ? void 0 : it.getSleeve();
              if (lt) {
                const wt = lt.getColor(), Xt = [0, 0, 0];
                Xt[0] = wt[0] * 255, Xt[1] = wt[1] * 255, Xt[2] = wt[2] * 255;
                const At = {
                  key: lt.id,
                  label: jt("implant-planner.sleeve"),
                  visible: lt.getVisibility(),
                  multiSelectGroup: String(Yt._SLEEVE),
                  color: Xt,
                  dropdown: void 0,
                  onSelect: () => {
                    lt.setVisibility(!0), T();
                  },
                  onUnselect: () => {
                    lt.setVisibility(!1), T();
                  }
                };
                ot.push(At);
              }
              const mt = it == null ? void 0 : it.getSupportObjects();
              mt && mt.size && mt.forEach((wt) => {
                const Xt = this.context.getObjects().getObject3dInfoById(wt.id || "");
                if (Xt) {
                  const At = D(Xt);
                  ot.push(At);
                }
              }), q.push({
                key: nt.id + " ",
                label: nt.name,
                children: ot
              });
            } else
              Zt.push(et);
          else if (nt.type === Yt._PIN)
            if (this.context.isCADObjectList.get()) {
              const ot = [];
              ot.push(et);
              const it = this.context.getObjects().pins.get(nt.id), ht = it == null ? void 0 : it.getSleeve();
              if (ht) {
                const mt = ht.getColor(), wt = [0, 0, 0];
                wt[0] = mt[0] * 255, wt[1] = mt[1] * 255, wt[2] = mt[2] * 255;
                const Xt = {
                  key: ht.id,
                  label: jt("implant-planner.sleeve"),
                  visible: ht.getVisibility(),
                  multiSelectGroup: String(Yt._SLEEVE),
                  color: wt,
                  dropdown: void 0,
                  onSelect: () => {
                    ht.setVisibility(!0), T();
                  },
                  onUnselect: () => {
                    ht.setVisibility(!1), T();
                  }
                };
                ot.push(Xt);
              }
              const lt = it == null ? void 0 : it.getSupportObjects();
              lt && lt.size && lt.forEach((mt) => {
                const wt = this.context.getObjects().getObject3dInfoById(mt.id || "");
                if (wt) {
                  const Xt = D(wt);
                  ot.push(Xt);
                }
              }), q.push({
                key: nt.id + " ",
                label: nt.name,
                children: ot
              });
            } else
              Gt.push(et);
          else nt.type === Yt._NERVE ? Tt.push(et) : nt.type === Yt._VOLUME_LABEL && Q.push(et);
        }
        at.length > 0 && q.push({
          key: "Objects",
          label: jt("implant-planner.objects"),
          children: at
        }), dt.length > 0 && q.push({
          key: "Segmentations",
          label: jt("implant-planner.segmentations"),
          children: dt
        }), gt.length > 0 && q.push({
          key: "Teeth",
          label: jt("shared.teeth"),
          children: gt
        }), Wt.length > 0 && q.push({
          key: "Reference Planes",
          label: jt("implant-planner.referencePlanes"),
          children: Wt
        }), this.context.isCADObjectList.get() || (Zt.length > 0 && q.push({
          key: "Implants",
          label: jt("implant-planner.implants"),
          children: Zt
        }), Gt.length > 0 && q.push({
          key: "Pins",
          label: jt("implant-planner.pins"),
          children: Gt
        })), Tt.length > 0 && q.push({
          key: "Nerves",
          label: jt("implant-planner.nerves"),
          children: Tt
        }), Q.length > 0 && q.push({
          key: "Volumes",
          label: jt("medic-web-engine.volumes"),
          children: Q
        }), C.set(q);
      };
      R(), this.watch(this.contextState.object3DInfos, () => {
        R();
      }), this.watch(this.context.isCADObjectList, () => {
        R();
      });
      const z = (at) => {
        const dt = o.get().get(at);
        if (dt && this.context.projectBookmarks) {
          for (const gt of this.context.projectBookmarks.layout.bookmarks)
            gt.stateId == dt.annotation.projectName && this.context.toolManager.measurementsTool.snapToBookmark(gt, dt.annotation.curveDelta ? dt.annotation.curveDelta : void 0);
          return;
        }
      }, F = (at) => {
        const dt = o.get().get(at);
        if (!dt)
          return console.warn("create dropdown: object not found"), null;
        let gt = jt("shared.rulerAnnotation");
        dt.annotation.isDistance() ? gt = jt("shared.distance") : dt.annotation.isAngle() ? gt = jt("shared.rulerAngle") : dt.annotation.isROI() && (gt = jt("shared.rulerRoi"));
        const Wt = {
          items: [
            {
              label: dt.annotation.getVisible() ? jt("shared.hide") + " " + gt : jt("shared.show") + " " + gt,
              command: () => {
                const Zt = dt.annotation.getVisible();
                dt.annotation.setVisible(!Zt), j();
              }
            },
            {
              label: jt("shared.delete") + " " + gt,
              command: () => {
                this.context.toolManager.measurementsTool.deleteMeasurementById(at), j();
              }
            }
          ]
        };
        return dt.view.isViewMode3D() || Wt.items.push({
          label: dt.annotation.alwaysOnTop ? "✓ " + jt("shared.alwaysOnTop") : jt("shared.alwaysOnTop"),
          command: () => {
            dt.annotation.alwaysOnTop = !dt.annotation.alwaysOnTop, j();
          }
        }), Wt;
      };
      let P = !1;
      const j = () => {
        P || (P = !0, queueMicrotask(() => {
          P = !1, this.context.sceneRepaint(), B();
        }));
      }, H = new qt([]), B = () => {
        const at = [];
        for (const [dt, gt] of o.get().entries())
          at.push({
            key: dt,
            label: gt.annotation.projectName,
            visible: gt.annotation.getVisible(),
            multiSelectGroup: "measurement",
            color: [255, 0, 255],
            dropdown: F,
            onClick: z,
            onSelect: x,
            onUnselect: V
          });
        H.set(at);
      };
      B(), this.watch(o, () => B());
      const $ = nl(), A = nl(), E = new md(() => {
        const at = [], dt = C.get();
        at.push(...dt);
        const gt = H.get();
        return gt.length && at.push({
          key: A,
          label: jt("medic-web-engine.measurements"),
          children: gt
        }), {
          items: at
        };
      }), ct = this.context.overlayComponents.createVueOverlayComponent($G, {
        objectTree: E,
        initialExpandedKeys: [$, A],
        viewSize: this.context.overlayContainerSize,
        initialPosition: pr.topRight,
        onMultiSelect: X,
        getContextMenuItemsForKeys: b,
        showDockButton: !0,
        parent: this.context.getOverlayContainer(),
        dockEvent: () => {
          this.context.dockOverlays();
        }
      });
      this.overlayComponents = {
        objectList: ct
      };
    }
    this.renderer.getActiveCamera().setDirectionOfProjection(0, 1, 0), this.renderer.getActiveCamera().setViewUp(0, 0, 1), this.renderer.resetCamera(), this.onEvent(this.context.onActorAdded, ({ actor: a }) => {
      this.renderer.addActor(a), this.sceneRefresh();
    }), this.orientationWidget = new PT(this, this.context, this.isShown), this.onCleanup(() => this.orientationWidget.delete()), this.isShown.get() && this.orientationWidget.show(), this.watch(this.isShown, (a) => {
      a ? this.orientationWidget.show() : this.orientationWidget.hide();
    });
  }
  isViewMode3D() {
    return !0;
  }
  cameraModified() {
    super.cameraModified();
  }
  panToPosition(e, n, s) {
    const r = this.renderer.getActiveCamera(), a = r.getDistance(), o = r.getViewPlaneNormal();
    r.setPosition(e + a * o[0], n + a * o[1], s + a * o[2]), r.setFocalPoint(e, n, s), this.renderer.resetCameraClippingRange(), this.cameraModified();
  }
  setBorder(e) {
    e ? this.showBorder(e) : this.hideBorder();
  }
  fitZoomToScreen() {
    const e = (y, Z) => {
      const g = [...y];
      return g[0] = Math.min(y[0], Z[0]), g[1] = Math.max(y[1], Z[1]), g[2] = Math.min(y[2], Z[2]), g[3] = Math.max(y[3], Z[3]), g[4] = Math.min(y[4], Z[4]), g[5] = Math.max(y[5], Z[5]), g;
    }, n = this.rendererOverlay.computeVisiblePropBounds();
    let s;
    n[0] == 1 && n[1] == -1 && n[2] == 1 && n[3] == -1 && n[4] == 1 && n[5] == -1 ? s = this.renderer.computeVisiblePropBounds() : s = e(this.renderer.computeVisiblePropBounds(), n), this.renderer.resetCameraClippingRange(s);
    const r = [(s[1] + s[0]) / 2, (s[3] + s[2]) / 2, (s[5] + s[4]) / 2], a = [0, -1, 0], o = [0, 0, 1], c = this.getRenderer().getActiveCamera(), u = c.getDistance();
    c.setPosition(r[0] + u * a[0], r[1] + u * a[1], r[2] + u * a[2]), c.setViewUp(o), c.setFocalPoint(...r);
    const [d, h] = this.state.viewSize.get();
    let p = 1;
    const m = d / (s[1] - s[0]);
    (s[5] - s[4]) * m > h ? p = (s[5] - s[4]) / 2 : p = (s[5] - s[4] + (h - (s[5] - s[4]) * m) / m) / 2, this.renderer.getActiveCamera().setParallelScale(p * 1.5), this.cameraModified();
  }
  isShownWrapper() {
    return this.isShown;
  }
  getWindowLevel() {
    return this.context.getVolumeWindowWidthLevel();
  }
  setWindowLevel(e) {
    this.context.setVolumeWindowWidthLevel(...e);
  }
  hideOverlayComponents(e) {
    var n;
    e ? this.overlayContainer.hideBorder() : this.overlayContainer.showBorder(), (n = this.overlayComponents) == null || n.objectList.hideRestore(e), this.orientationWidget.hideMenu(e), e ? this.orientationWidget.hide() : this.orientationWidget.show();
  }
  hideObjectList(e) {
    var n;
    (n = this.overlayComponents) == null || n.objectList.hideRestore(e);
  }
}
function ki(i, t, e, n, s, r = 0.5) {
  const a = i.worldToDisplay(t, ...e), o = t.getActiveCamera().getViewUp(), l = e, c = [l[0] + n * o[0], l[1] + n * o[1], l[2] + n * o[2]], u = i.worldToDisplay(t, ...c), d = I.dist(u, a), h = s / 2, p = r / 2;
  if (Math.abs(d - h) > p) {
    const m = [a[0] + h, a[1], a[2]], b = i.displayToWorld(t, ...m);
    return I.dist(b, l) / n;
  }
  return 1;
}
function pTt(i, t, e, n) {
  const s = I.create(), r = I.create(), a = t.getActiveCamera().getViewUp();
  I.scaleAndAdd(s, e, a, -0.5 * n), I.scaleAndAdd(r, e, a, 0.5 * n);
  const o = i.worldToDisplay(t, s[0], s[1], s[2]), l = i.worldToDisplay(t, r[0], r[1], r[2]);
  return I.distance(o, l);
}
function X0(i) {
  const { camera: t, orientation: e, focalPoint: n } = i, s = I.create(), r = I.create();
  switch (e) {
    case "left":
      s[2] = 1, r[0] = -1;
      break;
    case "right":
      s[2] = 1, r[0] = 1;
      break;
    case "front":
      s[2] = 1, r[1] = 1;
      break;
    case "back":
      s[2] = 1, r[1] = -1;
      break;
    case "top":
      s[1] = 1, r[2] = -1;
      break;
    case "bottom":
      s[1] = -1, r[2] = 1;
      break;
  }
  const a = I.create();
  I.scaleAndAdd(a, n, r, -i.distance), t.setPosition(a[0], a[1], a[2]), t.setViewUp(s[0], s[1], s[2]), t.setFocalPoint(n[0], n[1], n[2]);
}
const {
  vtkWarningMacro: mTt
} = tt, bTt = 1e-6;
function fTt(i, t) {
  t.classHierarchy.push("vtkPlaneSource"), i.requestData = (e, n) => {
    if (t.deleted)
      return;
    const s = n[0], r = s ? s.getPoints().getDataType() : t.pointType, a = Ie.newInstance(), o = [], l = [];
    if (fi(t.point1, t.origin, o), fi(t.point2, t.origin, l), !i.updatePlane(o, l)) {
      mTt("Bad plane definition");
      return;
    }
    const c = t.xResolution, u = t.yResolution, d = (c + 1) * (u + 1), h = c * u, p = tt.newTypedArray(r, d * 3);
    a.getPoints().setData(p, 3);
    const m = new Uint32Array(5 * h);
    a.getPolys().setData(m, 1);
    const b = new Float32Array(d * 3), y = We.newInstance({
      numberOfComponents: 3,
      values: b,
      name: "Normals"
    });
    a.getPointData().setNormals(y);
    const Z = new Float32Array(d * 2), g = We.newInstance({
      numberOfComponents: 2,
      values: Z,
      name: "TextureCoordinates"
    });
    a.getPointData().setTCoords(g);
    const f = new Float32Array(2);
    let T = 0;
    for (let M = 0; M < u + 1; M++) {
      f[1] = M / u;
      for (let N = 0; N < c + 1; N++)
        f[0] = N / c, p[T * 3] = t.origin[0] + f[0] * o[0] + f[1] * l[0], p[T * 3 + 1] = t.origin[1] + f[0] * o[1] + f[1] * l[1], p[T * 3 + 2] = t.origin[2] + f[0] * o[2] + f[1] * l[2], Z[T * 2] = f[0], Z[T * 2 + 1] = f[1], b[T * 3] = t.normal[0], b[T * 3 + 1] = t.normal[1], b[T * 3 + 2] = t.normal[2], T++;
    }
    T = 0;
    for (let M = 0; M < u; M++)
      for (let N = 0; N < c; N++)
        m[T * 5 + 0] = 4, m[T * 5 + 1] = N + M * (c + 1), m[T * 5 + 2] = m[T * 5 + 1] + 1, m[T * 5 + 3] = m[T * 5 + 1] + c + 2, m[T * 5 + 4] = m[T * 5 + 1] + c + 1, T++;
    n[0] = a;
  }, i.setNormal = function() {
    let e = [];
    if (arguments.length === 1 || Array.isArray(arguments.length <= 0 ? void 0 : arguments[0]) ? e = [...arguments.length <= 0 ? void 0 : arguments[0]] : arguments.length === 3 && (e = [arguments.length <= 0 ? void 0 : arguments[0], arguments.length <= 1 ? void 0 : arguments[1], arguments.length <= 2 ? void 0 : arguments[2]]), Fn(e) !== 0) {
      const n = tn(t.normal, e);
      let s = 0;
      const r = [];
      n < 1 && (n <= -1 ? (s = Qi(180), fi(t.point1, t.origin, r)) : (Wi(t.normal, e, r), s = Math.acos(n)), i.rotate(s, r));
    }
  }, i.rotate = (e, n) => {
    if (Math.abs(e) < bTt)
      return;
    const s = ut.identity(new Float64Array(16)), r = [];
    I.negate(r, t.center), ut.translate(s, s, t.center), ut.rotate(s, s, e, n), ut.translate(s, s, r), I.transformMat4(t.origin, t.origin, s), I.transformMat4(t.point1, t.point1, s), I.transformMat4(t.point2, t.point2, s), il.buildFromRadian().rotate(e, n).apply(t.normal), i.modified();
  }, i.setCenter = function() {
    let e = [];
    if (arguments.length === 1 || Array.isArray(arguments.length <= 0 ? void 0 : arguments[0]) ? e = [...arguments.length <= 0 ? void 0 : arguments[0]] : arguments.length === 3 && (e = [arguments.length <= 0 ? void 0 : arguments[0], arguments.length <= 1 ? void 0 : arguments[1], arguments.length <= 2 ? void 0 : arguments[2]]), !I.exactEquals(e, t.center)) {
      const n = [];
      fi(t.point1, t.origin, n);
      const s = [];
      fi(t.point2, t.origin, s);
      for (let r = 0; r < 3; r++)
        t.center[r] = e[r], t.origin[r] = t.center[r] - 0.5 * (n[r] + s[r]), t.point1[r] = t.origin[r] + n[r], t.point2[r] = t.origin[r] + s[r];
      i.modified();
    }
  }, i.setPoint1 = function() {
    let e = [];
    if (arguments.length === 1 || Array.isArray(arguments.length <= 0 ? void 0 : arguments[0]) ? e = [...arguments.length <= 0 ? void 0 : arguments[0]] : arguments.length === 3 && (e = [arguments.length <= 0 ? void 0 : arguments[0], arguments.length <= 1 ? void 0 : arguments[1], arguments.length <= 2 ? void 0 : arguments[2]]), !I.exactEquals(e, t.point1)) {
      const n = [], s = [];
      t.point1 = [...e], fi(t.point1, t.origin, n), fi(t.point2, t.origin, s), i.updatePlane(n, s), i.modified();
    }
  }, i.setPoint2 = function() {
    let e = [];
    if (arguments.length === 1 || Array.isArray(arguments.length <= 0 ? void 0 : arguments[0]) ? e = [...arguments.length <= 0 ? void 0 : arguments[0]] : arguments.length === 3 && (e = [arguments.length <= 0 ? void 0 : arguments[0], arguments.length <= 1 ? void 0 : arguments[1], arguments.length <= 2 ? void 0 : arguments[2]]), !I.exactEquals(e, t.point2)) {
      const n = [], s = [];
      t.point2 = [...e], fi(t.point1, t.origin, n), fi(t.point2, t.origin, s), i.updatePlane(n, s), i.modified();
    }
  }, i.updatePlane = (e, n) => {
    for (let s = 0; s < 3; s++)
      t.center[s] = t.origin[s] + 0.5 * (e[s] + n[s]);
    return Wi(e, n, t.normal), Fn(t.normal) !== 0;
  };
}
const gTt = {
  xResolution: 10,
  yResolution: 10,
  origin: [0, 0, 0],
  point1: [1, 0, 0],
  point2: [0, 1, 0],
  pointType: "Float64Array"
};
function vJ(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, gTt, e), t.normal = [0, 0, 1], t.center = [0, 0, 0], tt.obj(i, t), tt.setGet(i, t, ["xResolution", "yResolution"]), tt.setGetArray(i, t, ["origin"], 3), tt.getArray(i, t, ["point1", "point2", "normal", "center"], 3), tt.algo(i, t, 0, 1), fTt(i, t), i.setPoint1(t.point1), i.setPoint2(t.point2);
}
const yTt = tt.newInstance(vJ, "vtkPlaneSource");
var ZTt = {
  newInstance: yTt,
  extend: vJ
};
function Cd() {
  const i = rw.newInstance({
    resolution: 10
  }), t = Qh.newInstance({
    radius: 0.3,
    numberOfSides: 10,
    capping: !0
  }), e = Ue.newInstance();
  e.setInputConnection(i.getOutputPort());
  const n = Re.newInstance();
  return n.setMapper(e), n.setPickable(!1), n.setVisibility(!0), {
    source: i,
    filter: t,
    mapper: e,
    actor: n
  };
}
function TTt() {
  const i = sp.newInstance({
    radius: 0.05
  }), t = Ue.newInstance(), e = Re.newInstance();
  return t.setInputConnection(i.getOutputPort()), e.setMapper(t), {
    source: i,
    mapper: t,
    actor: e
  };
}
class MTt {
  constructor() {
    S(this, "mapper", Ue.newInstance());
    S(this, "actor", Re.newInstance());
    S(this, "plane", ZTt.newInstance());
    S(this, "borders", {
      left: Cd(),
      right: Cd(),
      top: Cd(),
      bottom: Cd()
    });
    S(this, "centerCross", {
      left: Cd(),
      right: Cd(),
      top: Cd(),
      bottom: Cd(),
      point: TTt()
    });
    S(this, "actors", [
      this.actor,
      this.borders.left.actor,
      this.borders.right.actor,
      this.borders.top.actor,
      this.borders.bottom.actor,
      this.centerCross.left.actor,
      this.centerCross.right.actor,
      this.centerCross.top.actor,
      this.centerCross.bottom.actor,
      this.centerCross.point.actor
    ]);
    S(this, "centerCrossColor", [0.2, 0.2, 1]);
    S(this, "borderDefaultColor", [0.2, 0.2, 1]);
    S(this, "borderHighlightColor", [0, 1, 0]);
    S(this, "selectedEdge", null);
    this.mapper.setInputConnection(this.plane.getOutputPort()), this.actor.setMapper(this.mapper), this.actor.setVisibility(!0), this.actor.setPickable(!1), this.actor.getProperty().setOpacity(0.5), this.borders.left.actor.setPickable(!1), this.borders.right.actor.setPickable(!1), this.borders.top.actor.setPickable(!1), this.borders.bottom.actor.setPickable(!1), this.setEdgeHighlight(null), this.centerCross.left.actor.setPickable(!1), this.centerCross.right.actor.setPickable(!1), this.centerCross.top.actor.setPickable(!1), this.centerCross.bottom.actor.setPickable(!1), this.centerCross.point.actor.setPickable(!1), this.centerCross.left.actor.getProperty().setColor(this.centerCrossColor), this.centerCross.right.actor.getProperty().setColor(this.centerCrossColor), this.centerCross.top.actor.getProperty().setColor(this.centerCrossColor), this.centerCross.bottom.actor.getProperty().setColor(this.centerCrossColor), this.centerCross.point.actor.getProperty().setColor(this.centerCrossColor);
  }
  setData(t) {
    this.plane.setOrigin(t.origin), this.plane.setPoint1(t.point1), this.plane.setPoint2(t.point2), this.actor.getProperty().setColor(t.color);
    const e = I.create();
    I.sub(e, t.point1, t.origin), I.add(e, t.point2, e), this.borders.left.source.setPoint1From(t.origin), this.borders.left.source.setPoint2From(t.point2), this.borders.right.source.setPoint1From(t.point1), this.borders.right.source.setPoint2From(e), this.borders.top.source.setPoint1From(t.point2), this.borders.top.source.setPoint2From(e), this.borders.bottom.source.setPoint1From(t.origin), this.borders.bottom.source.setPoint2From(t.point1), this.borders.left.source.modified(), this.borders.right.source.modified(), this.borders.top.source.modified(), this.borders.bottom.source.modified();
    const n = I.create();
    I.sub(n, t.origin, t.point1), I.normalize(n, n);
    const s = I.create();
    I.sub(s, t.origin, t.point2), I.normalize(s, s);
    const r = I.create();
    I.add(r, t.origin, e), I.scale(r, r, 0.5);
    const a = I.create();
    I.sub(a, t.point1, t.origin);
    const o = I.length(a);
    I.sub(a, t.point2, t.origin);
    const l = I.length(a), c = I.create(), u = I.create(), d = Math.min(o / 2, l / 2, 3), h = d / 3;
    I.scaleAndAdd(c, r, n, -d), I.scaleAndAdd(u, r, n, -h), this.centerCross.left.source.setPoint1From(c), this.centerCross.left.source.setPoint2From(u), I.scaleAndAdd(c, r, n, d), I.scaleAndAdd(u, r, n, h), this.centerCross.right.source.setPoint1From(c), this.centerCross.right.source.setPoint2From(u), I.scaleAndAdd(c, r, s, d), I.scaleAndAdd(u, r, s, h), this.centerCross.top.source.setPoint1From(c), this.centerCross.top.source.setPoint2From(u), I.scaleAndAdd(c, r, s, -d), I.scaleAndAdd(u, r, s, -h), this.centerCross.bottom.source.setPoint1From(c), this.centerCross.bottom.source.setPoint2From(u), this.centerCross.left.source.modified(), this.centerCross.right.source.modified(), this.centerCross.top.source.modified(), this.centerCross.bottom.source.modified(), this.centerCross.point.source.setCenter(r);
  }
  getActors() {
    return this.actors;
  }
  getRotationAxis(t) {
    return t === this.borders.left.actor || t === this.borders.right.actor ? 1 : t === this.borders.top.actor || t === this.borders.bottom.actor ? 2 : null;
  }
  getClosestEdge(t) {
    const e = this.plane.getOrigin(), n = this.plane.getPoint1(), s = this.plane.getPoint2(), r = I.create();
    I.sub(r, n, e), I.add(r, r, s);
    let a = "left", o = Number.MAX_VALUE;
    const l = MM(t, e, s).distance;
    l < o && (a = "left", o = l);
    const c = MM(t, n, r).distance;
    c < o && (a = "right", o = c);
    const u = MM(t, s, r).distance;
    u < o && (a = "top", o = u);
    const d = MM(t, e, n).distance;
    return d < o && (a = "bottom", o = d), {
      edge: a,
      distance2: o
    };
  }
  setEdgeHighlight(t) {
    this.borders.left.actor.getProperty().setColor(t === "left" ? this.borderHighlightColor : this.borderDefaultColor), this.borders.right.actor.getProperty().setColor(t === "right" ? this.borderHighlightColor : this.borderDefaultColor), this.borders.top.actor.getProperty().setColor(t === "top" ? this.borderHighlightColor : this.borderDefaultColor), this.borders.bottom.actor.getProperty().setColor(t === "bottom" ? this.borderHighlightColor : this.borderDefaultColor);
    const e = this.selectedEdge !== t;
    return this.selectedEdge = t, e;
  }
  /** update the center point scale to keep its pixel size fixed */
  updatePointScale(t) {
    this.centerCross.point.source.setRadius(3 * t);
  }
  delete() {
    this.plane.delete(), this.mapper.delete(), this.actor.delete(), this.actors.forEach((t) => t.delete());
  }
}
const NTt = { class: "toolbar-button all-radius" }, WTt = /* @__PURE__ */ Ne({
  __name: "ToolbarButton",
  props: {
    src: {}
  },
  setup(i) {
    return (t, e) => (Mt(), Ot("div", NTt, [
      Pt(K(Vb), { cIcon: i.src }, null, 8, ["cIcon"])
    ]));
  }
}), dz = /* @__PURE__ */ Dn(WTt, [["__scopeId", "data-v-5b8d8e10"]]), GTt = /* @__PURE__ */ Ne({
  __name: "ToolbarSectionalView",
  props: {
    events: {}
  },
  setup(i) {
    const t = i;
    aa();
    const e = () => {
      t.events.zoomIn.notify();
    }, n = () => {
      t.events.zoomOut.notify();
    };
    return (s, r) => (Mt(), le(Cg, null, {
      default: oe(() => [
        Pt(dz, {
          src: "icon_zoom_in",
          onClick: e
        }),
        Pt(dz, {
          src: "icon_zoom_out",
          onClick: n
        })
      ]),
      _: 1
    }));
  }
}), wTt = { style: { position: "absolute", width: "100%", height: "100%", overflow: "hidden" } }, xTt = 14, STt = /* @__PURE__ */ Ne({
  __name: "CoordinateSystemLabels",
  props: {
    xLabel: {},
    yLabel: {},
    zLabel: {},
    xPosition: {},
    yPosition: {},
    zPosition: {}
  },
  setup(i) {
    x0((l) => ({
      v26a46319: `${xTt}px`
    }));
    const t = i, e = Le(t.xLabel), n = Le(t.yLabel), s = Le(t.zLabel), r = Le(t.xPosition), a = Le(t.yPosition), o = Le(t.zPosition);
    return (l, c) => (Mt(), Ot("div", wTt, [
      kt("div", {
        class: "label",
        style: xe({ left: K(r)[0] + "px", bottom: K(r)[1] + "px" })
      }, pe(K(e)), 5),
      kt("div", {
        class: "label",
        style: xe({ left: K(a)[0] + "px", bottom: K(a)[1] + "px" })
      }, pe(K(n)), 5),
      kt("div", {
        class: "label",
        style: xe({ left: K(o)[0] + "px", bottom: K(o)[1] + "px" })
      }, pe(K(s)), 5)
    ]));
  }
}), LTt = /* @__PURE__ */ Dn(STt, [["__scopeId", "data-v-785daa9d"]]);
function VTt(i, t) {
  t.classHierarchy.push("vtkConeSource");
  function e(n, s) {
    if (t.deleted)
      return;
    let r = s[0];
    const a = 2 * Math.PI / t.resolution, o = -t.height / 2, l = t.resolution + 1, c = 4 * t.resolution + 1 + t.resolution;
    let u = 0;
    const d = tt.newTypedArray(t.pointType, l * 3);
    let h = 0;
    const p = new Uint32Array(c);
    d[0] = t.height / 2, d[1] = 0, d[2] = 0, t.capping && (p[h++] = t.resolution);
    for (let m = 0; m < t.resolution; m++)
      u++, d[u * 3 + 0] = o, d[u * 3 + 1] = t.radius * Math.cos(m * a), d[u * 3 + 2] = t.radius * Math.sin(m * a), t.capping && (p[t.resolution - h++ + 1] = u);
    for (let m = 0; m < t.resolution; m++)
      p[h++] = 3, p[h++] = 0, p[h++] = m + 1, p[h++] = m + 2 > t.resolution ? 1 : m + 2;
    il.buildFromRadian().translate(...t.center).rotateFromDirections([1, 0, 0], t.direction).apply(d), r = Ie.newInstance(), r.getPoints().setData(d, 3), r.getPolys().setData(p, 1), s[0] = r;
  }
  i.requestData = e;
}
const XTt = {
  height: 1,
  radius: 0.5,
  resolution: 6,
  center: [0, 0, 0],
  direction: [1, 0, 0],
  capping: !0,
  pointType: "Float64Array"
};
function RJ(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, XTt, e), tt.obj(i, t), tt.setGet(i, t, ["height", "radius", "resolution", "capping"]), tt.setGetArray(i, t, ["center", "direction"], 3), tt.algo(i, t, 0, 1), VTt(i, t);
}
const ITt = tt.newInstance(RJ, "vtkConeSource");
var CTt = {
  newInstance: ITt,
  extend: RJ
};
class tV {
  constructor() {
    S(this, "cone", CTt.newInstance());
    S(this, "mapper", Ue.newInstance());
    S(this, "actor", Re.newInstance());
    this.cone.setResolution(100), this.mapper.setInputConnection(this.cone.getOutputPort()), this.actor.setMapper(this.mapper), this.actor.setVisibility(!0), this.actor.setPickable(!0);
  }
  setSize(t) {
    const e = this.getApexPosition();
    this.cone.setHeight(2 * t), this.cone.setRadius(t), this.setApexPosition(e);
  }
  setApexPosition(t) {
    const e = this.cone.getHeight(), n = this.cone.getDirection(), s = I.create();
    I.scaleAndAdd(s, t, n, -0.5 * e), this.cone.setCenter(s);
  }
  getApexPosition() {
    const t = this.cone.getCenter(), e = this.cone.getHeight(), n = this.cone.getDirection(), s = I.create();
    return I.scaleAndAdd(s, t, n, 0.5 * e), s;
  }
  setDirection(t) {
    const e = this.getApexPosition();
    this.cone.setDirection(t), this.setApexPosition(e);
  }
  getActor() {
    return this.actor;
  }
  delete() {
    this.cone.delete(), this.mapper.delete(), this.actor.delete();
  }
}
class YTt {
  constructor() {
    S(this, "source", rw.newInstance({
      resolution: 10
    }));
    S(this, "mapper", Ue.newInstance());
    S(this, "actor", Re.newInstance());
    S(this, "filter", Qh.newInstance({
      radius: 0.1,
      numberOfSides: 10,
      capping: !0
    }));
    this.setLineWidth(0), this.actor.setMapper(this.mapper);
  }
  setLineWidth(t) {
    t !== 0 ? (this.filter.setRadius(t), this.filter.setInputConnection(this.source.getOutputPort()), this.mapper.setInputConnection(this.filter.getOutputPort())) : this.mapper.setInputConnection(this.source.getOutputPort());
  }
  getActor() {
    return this.actor;
  }
  setPoints(t, e) {
    this.source.setPoint1From(t), this.source.setPoint2From(e), this.source.modified();
  }
  delete() {
    this.source.delete(), this.mapper.delete(), this.filter.delete(), this.actor.delete();
  }
}
class yN {
  constructor() {
    S(this, "cone", new tV());
    S(this, "line", new YTt());
    S(this, "actors", [this.cone.getActor(), this.line.getActor()]);
    S(this, "defaultColor", [0.2, 0.2, 1]);
    S(this, "highlightColor", [0, 1, 0]);
    S(this, "highlight", !1);
    this.setPickable(!0), this.updateActorColors();
  }
  setPickable(t) {
    this.actors.forEach((e) => {
      e.setPickable(t);
    });
  }
  setDefaultColor(t) {
    this.defaultColor = t, this.updateActorColors();
  }
  updateActorColors() {
    const t = this.highlight ? this.highlightColor : this.defaultColor;
    this.actors.forEach((e) => {
      e.getProperty().setColor(t);
    });
  }
  setData(t) {
    const { point1: e, point2: n, lineRadius: s } = t, r = t.coneSize ?? 0.2, a = I.create();
    I.sub(a, n, e), I.normalize(a, a);
    const o = I.create();
    I.scaleAndAdd(o, n, a, -r), s !== void 0 ? this.line.setLineWidth(s) : this.line.setLineWidth(0), this.line.setPoints(e, o), this.cone.setDirection(a), this.cone.setApexPosition(n), this.cone.setSize(r);
  }
  getApex() {
    return this.cone.getApexPosition();
  }
  getActors() {
    return this.actors;
  }
  getConeActor() {
    return this.cone.getActor();
  }
  hasActor(t) {
    return this.actors.find((e) => e === t) !== void 0;
  }
  setHighlight(t, e) {
    if (!(t !== this.highlight))
      return !1;
    this.highlight = t;
    const s = t ? this.highlightColor : this.defaultColor;
    return e ? this.cone.getActor().getProperty().setColor(s) : this.actors.forEach((r) => {
      r.getProperty().setColor(s);
    }), !0;
  }
  delete() {
    this.cone.delete(), this.line.delete();
  }
}
class vTt {
  constructor() {
    S(this, "mapper", Ue.newInstance());
    S(this, "data", Ie.newInstance());
    S(this, "actor", Re.newInstance());
    S(this, "points", yi.newInstance());
    S(this, "lines", Ii.newInstance());
    this.mapper.setInputData(this.data), this.actor.setMapper(this.mapper), this.data.setPoints(this.points), this.data.setLines(this.lines), this.actor.setVisibility(!1), this.actor.setPickable(!1), this.actor.modified();
  }
  setData(t) {
    const { origin: e, normal: n, viewUp: s, spacing: r, nCells: a, color: o } = t, l = o, c = 1, u = I.create();
    I.cross(u, n, s), I.normalize(u, u), I.scale(u, u, r);
    const d = I.clone(s);
    I.normalize(d, d), I.scale(d, d, r);
    const h = I.create();
    I.scaleAndAdd(h, e, u, -a / 2), I.scaleAndAdd(h, h, d, -a / 2);
    const p = I.create(), m = I.create(), b = new Float32Array((a + 1) * 4 * 3), y = new Uint16Array((a + 1) * 2 * 3);
    let Z = 0, g = 0;
    for (let f = 0; f <= a; f++)
      I.scaleAndAdd(p, h, u, f), I.scaleAndAdd(m, p, d, a), y[g++] = 2, y[g++] = Z / 3, b[Z++] = p[0], b[Z++] = p[1], b[Z++] = p[2], y[g++] = Z / 3, b[Z++] = m[0], b[Z++] = m[1], b[Z++] = m[2];
    for (let f = 0; f <= a; f++)
      I.scaleAndAdd(p, h, d, f), I.scaleAndAdd(m, p, u, a), y[g++] = 2, y[g++] = Z / 3, b[Z++] = p[0], b[Z++] = p[1], b[Z++] = p[2], y[g++] = Z / 3, b[Z++] = m[0], b[Z++] = m[1], b[Z++] = m[2];
    this.points.setData(b, 3), this.lines.setData(y), this.actor.getProperty().setColor(l), this.actor.getProperty().setOpacity(c), this.data.modified();
  }
  setVisibility(t) {
    this.actor.setVisibility(t);
  }
  getActor() {
    return this.actor;
  }
  delete() {
    this.points.delete(), this.lines.delete(), this.data.delete(), this.mapper.delete(), this.actor.delete();
  }
}
function DJ(i, t, e) {
  const n = i === "down" ? "mousedown" : "mouseup", s = (a) => {
    a.button === t && (e(a), document.removeEventListener(n, s));
  };
  return document.addEventListener(n, s), () => document.removeEventListener(n, s);
}
function PDt(i, t) {
  return DJ("down", i, t);
}
function lS(i, t) {
  return DJ("up", i, t);
}
function RTt(i, t) {
  t.classHierarchy.push("vtkSphereMapper");
}
const DTt = {
  scaleArray: null,
  radius: 0.05,
  scaleFactor: 1
};
function OJ(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DTt, e), Ue.extend(i, t, e), tt.setGet(i, t, ["radius", "scaleArray", "scaleFactor"]), RTt(i, t);
}
const OTt = tt.newInstance(OJ, "vtkSphereMapper");
var LC = {
  newInstance: OTt,
  extend: OJ
};
function zTt(i, t) {
  t.classHierarchy.push("vtkStickMapper");
}
const ETt = {
  scaleArray: null,
  orientationArray: null,
  radius: 0.025,
  length: 0.1
};
function zJ(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, ETt, e), Ue.extend(i, t, e), tt.setGet(i, t, ["scaleArray", "orientationArray", "radius", "length"]), zTt(i, t);
}
const kTt = tt.newInstance(zJ, "vtkStickMapper");
var FTt = {
  newInstance: kTt,
  extend: zJ
}, EJ = { exports: {} };
(function(i, t) {
  (function(e, n) {
    i.exports = n();
  })(Mo, (function() {
    return (function(e) {
      var n = {};
      function s(r) {
        if (n[r]) return n[r].exports;
        var a = n[r] = { i: r, l: !1, exports: {} };
        return e[r].call(a.exports, a, a.exports, s), a.l = !0, a.exports;
      }
      return s.m = e, s.c = n, s.d = function(r, a, o) {
        s.o(r, a) || Object.defineProperty(r, a, { enumerable: !0, get: o });
      }, s.r = function(r) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(r, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(r, "__esModule", { value: !0 });
      }, s.t = function(r, a) {
        if (1 & a && (r = s(r)), 8 & a || 4 & a && typeof r == "object" && r && r.__esModule) return r;
        var o = /* @__PURE__ */ Object.create(null);
        if (s.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: r }), 2 & a && typeof r != "string") for (var l in r) s.d(o, l, (function(c) {
          return r[c];
        }).bind(null, l));
        return o;
      }, s.n = function(r) {
        var a = r && r.__esModule ? function() {
          return r.default;
        } : function() {
          return r;
        };
        return s.d(a, "a", a), a;
      }, s.o = function(r, a) {
        return Object.prototype.hasOwnProperty.call(r, a);
      }, s.p = "", s(s.s = 184);
    })([function(e, n, s) {
      function r(a) {
        for (var o in a) n.hasOwnProperty(o) || (n[o] = a[o]);
      }
      Object.defineProperty(n, "__esModule", { value: !0 }), r(s(240)), r(s(251)), r(s(175)), r(s(107)), r(s(29)), r(s(73)), r(s(106)), r(s(30)), r(s(252)), r(s(52)), r(s(97)), r(s(253)), r(s(37)), r(s(51)), r(s(173)), r(s(176)), r(s(172)), r(s(108)), r(s(254)), r(s(255)), r(s(256)), r(s(72)), r(s(177)), r(s(105)), r(s(17)), r(s(257)), r(s(12)), r(s(174));
    }, function(e, n, s) {
      var r = this && this.__values || function(f) {
        var T = typeof Symbol == "function" && Symbol.iterator, M = T && f[T], N = 0;
        if (M) return M.call(f);
        if (f && typeof f.length == "number") return { next: function() {
          return f && N >= f.length && (f = void 0), { value: f && f[N++], done: !f };
        } };
        throw new TypeError(T ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = s(212);
      n.FixedSizeSet = a.FixedSizeSet;
      var o = s(213);
      n.ObjectCache = o.ObjectCache;
      var l = s(214);
      n.CompareCache = l.CompareCache;
      var c = s(215);
      n.Lazy = c.Lazy;
      var u = s(216);
      function d(f, T, M) {
        if (Z(f)) f.forEach((function(W, x) {
          return T.call(M, x, W);
        }));
        else for (var N in f) f.hasOwnProperty(N) && T.call(M, N, f[N]);
      }
      function h(f) {
        var T, M;
        if (p(f)) return f;
        if (b(f)) {
          var N = [];
          try {
            for (var W = r(f), x = W.next(); !x.done; x = W.next()) {
              var V = x.value;
              N.push(h(V));
            }
          } catch (R) {
            T = { error: R };
          } finally {
            try {
              x && !x.done && (M = W.return) && M.call(W);
            } finally {
              if (T) throw T.error;
            }
          }
          return N;
        }
        if (m(f)) {
          N = {};
          for (var X in f) if (f.hasOwnProperty(X)) {
            var C = f[X];
            N[X] = h(C);
          }
          return N;
        }
        return f;
      }
      function p(f) {
        return !!f && Object.prototype.toString.call(f) === "[object Function]";
      }
      function m(f) {
        var T = typeof f;
        return !!f && (T === "function" || T === "object");
      }
      function b(f) {
        return Array.isArray(f);
      }
      function y(f) {
        return f instanceof Set;
      }
      function Z(f) {
        return f instanceof Map;
      }
      function g(f) {
        if (m(f)) {
          var T = Object.getPrototypeOf(f), M = T.constructor;
          return T && M && typeof M == "function" && M instanceof M && Function.prototype.toString.call(M) === Function.prototype.toString.call(Object);
        }
        return !1;
      }
      n.StringWalker = u.StringWalker, n.applyMixin = function(f, T) {
        for (var M = [], N = 2; N < arguments.length; N++) M[N - 2] = arguments[N];
        Object.getOwnPropertyNames(T.prototype).forEach((function(W) {
          if (W !== "constructor") {
            if (M.indexOf(W) !== -1) {
              var x = Object.getOwnPropertyDescriptor(f.prototype, W);
              x && Object.defineProperty(f.prototype, "_" + W, x);
            }
            var V = Object.getOwnPropertyDescriptor(T.prototype, W);
            V && Object.defineProperty(f.prototype, W, V);
          }
        }));
      }, n.applyDefaults = function f(T, M, N) {
        N === void 0 && (N = !1);
        var W = h(T || {});
        return d(M, (function(x, V) {
          g(V) ? W[x] = f(W[x], V, N) : (N || W[x] === void 0) && (W[x] = V);
        })), W;
      }, n.forEachArray = function(f, T, M) {
        f.forEach(T, M);
      }, n.forEachObject = d, n.arrayLength = function(f) {
        return y(f) ? f.size : f.length;
      }, n.objectLength = function(f) {
        return Z(f) ? f.size : Object.keys(f).length;
      }, n.getObjectValue = function(f, T) {
        return Z(f) ? f.get(T) : f[T];
      }, n.removeObjectValue = function(f, T) {
        Z(f) ? f.delete(T) : delete f[T];
      }, n.clone = h, n.isBoolean = function(f) {
        return typeof f == "boolean";
      }, n.isNumber = function(f) {
        return typeof f == "number";
      }, n.isString = function(f) {
        return typeof f == "string";
      }, n.isFunction = p, n.isObject = m, n.isArray = b, n.isSet = y, n.isMap = Z, n.isEmpty = function(f) {
        if (b(f)) return !f.length;
        if (y(f) || Z(f)) return !f.size;
        if (m(f)) {
          for (var T in f) if (f.hasOwnProperty(T)) return !1;
          return !0;
        }
        return !1;
      }, n.isPlainObject = g, n.isIterable = function(f) {
        return f && typeof f[Symbol.iterator] == "function";
      }, n.getValue = function(f) {
        return p(f.valueOf) ? f.valueOf() : f;
      }, n.utf8Encode = function(f) {
        for (var T = new Uint8Array(4 * f.length), M = 0, N = 0; N < f.length; N++) {
          var W = f.charCodeAt(N);
          if (W < 128) T[M++] = W;
          else {
            if (W < 2048) T[M++] = W >> 6 | 192;
            else {
              if (W > 55295 && W < 56320) {
                if (++N >= f.length) throw new Error("Incomplete surrogate pair.");
                var x = f.charCodeAt(N);
                if (x < 56320 || x > 57343) throw new Error("Invalid surrogate character.");
                W = 65536 + ((1023 & W) << 10) + (1023 & x), T[M++] = W >> 18 | 240, T[M++] = W >> 12 & 63 | 128;
              } else T[M++] = W >> 12 | 224;
              T[M++] = W >> 6 & 63 | 128;
            }
            T[M++] = 63 & W | 128;
          }
        }
        return T.subarray(0, M);
      }, n.utf8Decode = function(f) {
        for (var T = "", M = 0; M < f.length; ) {
          var N = f[M++];
          if (N > 127) if (N > 191 && N < 224) {
            if (M >= f.length) throw new Error("Incomplete 2-byte sequence.");
            N = (31 & N) << 6 | 63 & f[M++];
          } else if (N > 223 && N < 240) {
            if (M + 1 >= f.length) throw new Error("Incomplete 3-byte sequence.");
            N = (15 & N) << 12 | (63 & f[M++]) << 6 | 63 & f[M++];
          } else {
            if (!(N > 239 && N < 248)) throw new Error("Unknown multi-byte start.");
            if (M + 2 >= f.length) throw new Error("Incomplete 4-byte sequence.");
            N = (7 & N) << 18 | (63 & f[M++]) << 12 | (63 & f[M++]) << 6 | 63 & f[M++];
          }
          if (N <= 65535) T += String.fromCharCode(N);
          else {
            if (!(N <= 1114111)) throw new Error("Code point exceeds UTF-16 limit.");
            N -= 65536, T += String.fromCharCode(N >> 10 | 55296), T += String.fromCharCode(1023 & N | 56320);
          }
        }
        return T;
      };
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 }), (function(r) {
        r[r.Before = 0] = "Before", r[r.Equal = 1] = "Equal", r[r.After = 2] = "After";
      })(n.BoundaryPosition || (n.BoundaryPosition = {})), (function(r) {
        r[r.None = 0] = "None", r[r.Capturing = 1] = "Capturing", r[r.AtTarget = 2] = "AtTarget", r[r.Bubbling = 3] = "Bubbling";
      })(n.EventPhase || (n.EventPhase = {})), (function(r) {
        r[r.Element = 1] = "Element", r[r.Attribute = 2] = "Attribute", r[r.Text = 3] = "Text", r[r.CData = 4] = "CData", r[r.EntityReference = 5] = "EntityReference", r[r.Entity = 6] = "Entity", r[r.ProcessingInstruction = 7] = "ProcessingInstruction", r[r.Comment = 8] = "Comment", r[r.Document = 9] = "Document", r[r.DocumentType = 10] = "DocumentType", r[r.DocumentFragment = 11] = "DocumentFragment", r[r.Notation = 12] = "Notation";
      })(n.NodeType || (n.NodeType = {})), (function(r) {
        r[r.Disconnected = 1] = "Disconnected", r[r.Preceding = 2] = "Preceding", r[r.Following = 4] = "Following", r[r.Contains = 8] = "Contains", r[r.ContainedBy = 16] = "ContainedBy", r[r.ImplementationSpecific = 32] = "ImplementationSpecific";
      })(n.Position || (n.Position = {})), (function(r) {
        r[r.Accept = 1] = "Accept", r[r.Reject = 2] = "Reject", r[r.Skip = 3] = "Skip";
      })(n.FilterResult || (n.FilterResult = {})), (function(r) {
        r[r.All = 4294967295] = "All", r[r.Element = 1] = "Element", r[r.Attribute = 2] = "Attribute", r[r.Text = 4] = "Text", r[r.CDataSection = 8] = "CDataSection", r[r.EntityReference = 16] = "EntityReference", r[r.Entity = 32] = "Entity", r[r.ProcessingInstruction = 64] = "ProcessingInstruction", r[r.Comment = 128] = "Comment", r[r.Document = 256] = "Document", r[r.DocumentType = 512] = "DocumentType", r[r.DocumentFragment = 1024] = "DocumentFragment", r[r.Notation = 2048] = "Notation";
      })(n.WhatToShow || (n.WhatToShow = {})), (function(r) {
        r[r.StartToStart = 0] = "StartToStart", r[r.StartToEnd = 1] = "StartToEnd", r[r.EndToEnd = 2] = "EndToEnd", r[r.EndToStart = 3] = "EndToStart";
      })(n.HowToCompare || (n.HowToCompare = {}));
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(241);
      n.Cast = r.Cast;
      var a = s(150);
      n.Guard = a.Guard;
      var o = s(242);
      n.EmptySet = o.EmptySet;
    }, function(e, n, s) {
      var r = s(11), a = s(55).f, o = s(21), l = s(25), c = s(80), u = s(119), d = s(123);
      e.exports = function(h, p) {
        var m, b, y, Z, g, f = h.target, T = h.global, M = h.stat;
        if (m = T ? r : M ? r[f] || c(f, {}) : (r[f] || {}).prototype) for (b in p) {
          if (Z = p[b], y = h.noTargetGet ? (g = a(m, b)) && g.value : m[b], !d(T ? b : f + (M ? "." : "#") + b, h.forced) && y !== void 0) {
            if (typeof Z == typeof y) continue;
            u(Z, y);
          }
          (h.sham || y && y.sham) && o(Z, "sham", !0), l(m, b, Z, h);
        }
      };
    }, function(e, n, s) {
      var r = s(11), a = s(81), o = s(14), l = s(58), c = s(86), u = s(124), d = a("wks"), h = r.Symbol, p = u ? h : h && h.withoutSetter || l;
      e.exports = function(m) {
        return o(d, m) || (c && o(h, m) ? d[m] = h[m] : d[m] = p("Symbol." + m)), d[m];
      };
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(1), a = s(29), o = (function() {
        function l() {
          this._features = { mutationObservers: !0, customElements: !0, slots: !0, steps: !0 }, this._window = null, this._compareCache = new r.CompareCache(), this._rangeList = new r.FixedSizeSet();
        }
        return l.prototype.setFeatures = function(c) {
          if (c === void 0 && (c = !0), r.isObject(c)) for (var u in c) this._features[u] = c[u] || !1;
          else for (var u in this._features) this._features[u] = c;
        }, Object.defineProperty(l.prototype, "features", { get: function() {
          return this._features;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(l.prototype, "window", { get: function() {
          return this._window === null && (this._window = a.create_window()), this._window;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(l.prototype, "compareCache", { get: function() {
          return this._compareCache;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(l.prototype, "rangeList", { get: function() {
          return this._rangeList;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(l, "instance", { get: function() {
          return l._instance || (l._instance = new l()), l._instance;
        }, enumerable: !0, configurable: !0 }), l;
      })();
      n.dom = o.instance;
    }, function(e, n, s) {
      var r = this && this.__importStar || function(g) {
        if (g && g.__esModule) return g;
        var f = {};
        if (g != null) for (var T in g) Object.hasOwnProperty.call(g, T) && (f[T] = g[T]);
        return f.default = g, f;
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = r(s(228));
      n.base64 = a;
      var o = r(s(146));
      n.byte = o;
      var l = r(s(147));
      n.byteSequence = l;
      var c = r(s(96));
      n.codePoint = c;
      var u = r(s(232));
      n.json = u;
      var d = r(s(233));
      n.list = d;
      var h = r(s(234));
      n.map = h;
      var p = r(s(235));
      n.namespace = p;
      var m = r(s(236));
      n.queue = m;
      var b = r(s(237));
      n.set = b;
      var y = r(s(238));
      n.stack = y;
      var Z = r(s(239));
      n.string = Z;
    }, function(e, n) {
      e.exports = function(s) {
        try {
          return !!s();
        } catch {
          return !0;
        }
      };
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(B, $) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(A, E) {
          A.__proto__ = E;
        } || function(A, E) {
          for (var ct in E) E.hasOwnProperty(ct) && (A[ct] = E[ct]);
        })(B, $);
      }, function(B, $) {
        function A() {
          this.constructor = B;
        }
        r(B, $), B.prototype = $ === null ? Object.create($) : (A.prototype = $.prototype, new A());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = (function(B) {
        function $(A, E) {
          E === void 0 && (E = "");
          var ct = B.call(this, E) || this;
          return ct.name = A, ct;
        }
        return a($, B), $;
      })(Error);
      n.DOMException = o;
      var l = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "DOMStringSizeError", A) || this;
        }
        return a($, B), $;
      })(o);
      n.DOMStringSizeError = l;
      var c = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "WrongDocumentError", "The object is in the wrong document. " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.WrongDocumentError = c;
      var u = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "NoDataAllowedError", A) || this;
        }
        return a($, B), $;
      })(o);
      n.NoDataAllowedError = u;
      var d = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "NoModificationAllowedError", "The object can not be modified. " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.NoModificationAllowedError = d;
      var h = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "NotSupportedError", "The operation is not supported. " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.NotSupportedError = h;
      var p = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "InUseAttributeError", A) || this;
        }
        return a($, B), $;
      })(o);
      n.InUseAttributeError = p;
      var m = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "InvalidStateError", "The object is in an invalid state. " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.InvalidStateError = m;
      var b = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "InvalidModificationError", "The object can not be modified in this way. " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.InvalidModificationError = b;
      var y = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "NamespaceError", "The operation is not allowed by Namespaces in XML. [XMLNS] " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.NamespaceError = y;
      var Z = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "InvalidAccessError", "The object does not support the operation or argument. " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.InvalidAccessError = Z;
      var g = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "ValidationError", A) || this;
        }
        return a($, B), $;
      })(o);
      n.ValidationError = g;
      var f = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "TypeMismatchError", A) || this;
        }
        return a($, B), $;
      })(o);
      n.TypeMismatchError = f;
      var T = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "SecurityError", "The operation is insecure. " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.SecurityError = T;
      var M = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "NetworkError", "A network error occurred. " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.NetworkError = M;
      var N = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "AbortError", "The operation was aborted. " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.AbortError = N;
      var W = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "URLMismatchError", "The given URL does not match another URL. " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.URLMismatchError = W;
      var x = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "QuotaExceededError", "The quota has been exceeded. " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.QuotaExceededError = x;
      var V = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "TimeoutError", "The operation timed out. " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.TimeoutError = V;
      var X = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "InvalidNodeTypeError", "The supplied node is incorrect or has an incorrect ancestor for this operation. " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.InvalidNodeTypeError = X;
      var C = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "DataCloneError", "The object can not be cloned. " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.DataCloneError = C;
      var R = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "NotImplementedError", "The DOM method is not implemented by this module. " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.NotImplementedError = R;
      var z = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "HierarchyRequestError", "The operation would yield an incorrect node tree. " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.HierarchyRequestError = z;
      var F = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "NotFoundError", "The object can not be found here. " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.NotFoundError = F;
      var P = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "IndexSizeError", "The index is not in the allowed range. " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.IndexSizeError = P;
      var j = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "SyntaxError", "The string did not match the expected pattern. " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.SyntaxError = j;
      var H = (function(B) {
        function $(A) {
          return A === void 0 && (A = ""), B.call(this, "InvalidCharacterError", "The string contains invalid characters. " + A) || this;
        }
        return a($, B), $;
      })(o);
      n.InvalidCharacterError = H;
    }, function(e, n, s) {
      var r = s(53), a = ["kind", "resolve", "construct", "instanceOf", "predicate", "represent", "defaultStyle", "styleAliases"], o = ["scalar", "sequence", "mapping"];
      e.exports = function(l, c) {
        var u, d;
        if (c = c || {}, Object.keys(c).forEach((function(h) {
          if (a.indexOf(h) === -1) throw new r('Unknown option "' + h + '" is met in definition of "' + l + '" YAML type.');
        })), this.tag = l, this.kind = c.kind || null, this.resolve = c.resolve || function() {
          return !0;
        }, this.construct = c.construct || function(h) {
          return h;
        }, this.instanceOf = c.instanceOf || null, this.predicate = c.predicate || null, this.represent = c.represent || null, this.defaultStyle = c.defaultStyle || null, this.styleAliases = (u = c.styleAliases || null, d = {}, u !== null && Object.keys(u).forEach((function(h) {
          u[h].forEach((function(p) {
            d[String(p)] = h;
          }));
        })), d), o.indexOf(this.kind) === -1) throw new r('Unknown kind "' + this.kind + '" is specified for "' + l + '" YAML type.');
      };
    }, function(e, n, s) {
      (function(r) {
        var a = function(o) {
          return o && o.Math == Math && o;
        };
        e.exports = a(typeof globalThis == "object" && globalThis) || a(typeof window == "object" && window) || a(typeof self == "object" && self) || a(typeof r == "object" && r) || Function("return this")();
      }).call(this, s(78));
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 }), n.idl_defineConst = function(r, a, o) {
        Object.defineProperty(r, a, { writable: !1, enumerable: !0, configurable: !1, value: o });
      };
    }, function(e, n) {
      e.exports = function(s) {
        return typeof s == "object" ? s !== null : typeof s == "function";
      };
    }, function(e, n) {
      var s = {}.hasOwnProperty;
      e.exports = function(r, a) {
        return s.call(r, a);
      };
    }, function(e, n, s) {
      var r = s(16), a = s(115), o = s(18), l = s(56), c = Object.defineProperty;
      n.f = r ? c : function(u, d, h) {
        if (o(u), d = l(d, !0), o(h), a) try {
          return c(u, d, h);
        } catch {
        }
        if ("get" in h || "set" in h) throw TypeError("Accessors not supported");
        return "value" in h && (u[d] = h.value), u;
      };
    }, function(e, n, s) {
      var r = s(8);
      e.exports = !r((function() {
        return Object.defineProperty({}, 1, { get: function() {
          return 7;
        } })[1] != 7;
      }));
    }, function(e, n, s) {
      var r = this && this.__values || function(f) {
        var T = typeof Symbol == "function" && Symbol.iterator, M = T && f[T], N = 0;
        if (M) return M.call(f);
        if (f && typeof f.length == "number") return { next: function() {
          return f && N >= f.length && (f = void 0), { value: f && f[N++], done: !f };
        } };
        throw new TypeError(T ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = s(3), o = s(2);
      function l(f, T, M) {
        if (M === void 0 && (M = !1), M && a.Guard.isElementNode(T) && a.Guard.isShadowRoot(T.shadowRoot) && T.shadowRoot._firstChild) return T.shadowRoot._firstChild;
        if (T._firstChild) return T._firstChild;
        if (T === f) return null;
        if (T._nextSibling) return T._nextSibling;
        for (var N = T._parent; N && N !== f; ) {
          if (N._nextSibling) return N._nextSibling;
          N = N._parent;
        }
        return null;
      }
      function c() {
        var f;
        return (f = {})[Symbol.iterator] = function() {
          return { next: function() {
            return { done: !0, value: null };
          } };
        }, f;
      }
      function u(f, T, M, N) {
        T === void 0 && (T = !1), M === void 0 && (M = !1);
        for (var W = T ? f : l(f, f, M); W && N && !N(W); ) W = l(f, W, M);
        return W;
      }
      function d(f, T, M, N, W) {
        N === void 0 && (N = !1);
        for (var x = l(f, T, N); x && W && !W(x); ) x = l(f, x, N);
        return x;
      }
      function h(f, T, M, N) {
        var W;
        return T === void 0 && (T = !1), M === void 0 && (M = !1), T || f._children.size !== 0 ? ((W = {})[Symbol.iterator] = function() {
          var x = T ? f : l(f, f, M);
          return { next: function() {
            for (; x && N && !N(x); ) x = l(f, x, M);
            if (x === null) return { done: !0, value: null };
            var V = { done: !1, value: x };
            return x = l(f, x, M), V;
          } };
        }, W) : c();
      }
      function p(f, T, M) {
        T === void 0 && (T = !1);
        for (var N = T ? f : f._parent; N && M && !M(N); ) N = N._parent;
        return N;
      }
      function m(f, T, M, N) {
        for (var W = T._parent; W && N && !N(W); ) W = W._parent;
        return W;
      }
      function b(f) {
        return a.Guard.isDocumentTypeNode(f) ? 0 : a.Guard.isCharacterDataNode(f) ? f._data.length : f._children.size;
      }
      function y(f, T) {
        if (T === void 0 && (T = !1), T) {
          var M = y(f, !1);
          return a.Guard.isShadowRoot(M) ? y(M._host, !0) : M;
        }
        return f._parent ? y(f._parent) : f;
      }
      function Z(f, T, M, N) {
        M === void 0 && (M = !1), N === void 0 && (N = !1);
        for (var W = M ? f : N && a.Guard.isShadowRoot(f) ? f._host : f._parent; W !== null; ) {
          if (W === T) return !0;
          W = N && a.Guard.isShadowRoot(W) ? W._host : W._parent;
        }
        return !1;
      }
      function g(f) {
        for (var T = y(f), M = 0, N = u(T); N !== null; ) {
          if (M++, N === f) return M;
          N = d(T, N);
        }
        return -1;
      }
      n.tree_getFirstDescendantNode = u, n.tree_getNextDescendantNode = d, n.tree_getDescendantNodes = h, n.tree_getDescendantElements = function(f, T, M, N) {
        var W;
        return T === void 0 && (T = !1), M === void 0 && (M = !1), T || f._children.size !== 0 ? ((W = {})[Symbol.iterator] = function() {
          var x = h(f, T, M, (function(X) {
            return a.Guard.isElementNode(X);
          }))[Symbol.iterator](), V = x.next().value;
          return { next: function() {
            for (; V && N && !N(V); ) V = x.next().value;
            if (V === null) return { done: !0, value: null };
            var X = { done: !1, value: V };
            return V = x.next().value, X;
          } };
        }, W) : c();
      }, n.tree_getSiblingNodes = function(f, T, M) {
        var N;
        return T === void 0 && (T = !1), f._parent && f._parent._children.size !== 0 ? ((N = {})[Symbol.iterator] = function() {
          var W = f._parent ? f._parent._firstChild : null;
          return { next: function() {
            for (; W && (M && !M(W) || !T && W === f); ) W = W._nextSibling;
            if (W === null) return { done: !0, value: null };
            var x = { done: !1, value: W };
            return W = W._nextSibling, x;
          } };
        }, N) : c();
      }, n.tree_getFirstAncestorNode = p, n.tree_getNextAncestorNode = m, n.tree_getAncestorNodes = function(f, T, M) {
        var N;
        return T === void 0 && (T = !1), T || f._parent ? ((N = {})[Symbol.iterator] = function() {
          var W = p(f, T, M);
          return { next: function() {
            if (W === null) return { done: !0, value: null };
            var x = { done: !1, value: W };
            return W = m(0, W, T, M), x;
          } };
        }, N) : c();
      }, n.tree_getCommonAncestor = function(f, T) {
        if (f === T) return f._parent;
        for (var M = [], N = [], W = p(f, !0); W !== null; ) M.push(W), W = m(0, W);
        for (var x = p(T, !0); x !== null; ) N.push(x), x = m(0, x);
        for (var V = M.length, X = N.length, C = null, R = Math.min(V, X); R > 0; R--) {
          var z = M[--V];
          if (z !== N[--X]) break;
          C = z;
        }
        return C;
      }, n.tree_getFollowingNode = function(f, T) {
        if (T._firstChild) return T._firstChild;
        if (T._nextSibling) return T._nextSibling;
        for (; ; ) {
          var M = T._parent;
          if (M === null || M === f) return null;
          if (M._nextSibling) return M._nextSibling;
          T = M;
        }
      }, n.tree_getPrecedingNode = function(f, T) {
        return T === f ? null : T._previousSibling ? (T = T._previousSibling)._lastChild ? T._lastChild : T : T._parent;
      }, n.tree_isConstrained = function f(T) {
        var M, N, W, x, V, X;
        switch (T._nodeType) {
          case o.NodeType.Document:
            var C = !1, R = !1;
            try {
              for (var z = r(T._children), F = z.next(); !F.done; F = z.next())
                switch (F.value._nodeType) {
                  case o.NodeType.ProcessingInstruction:
                  case o.NodeType.Comment:
                    break;
                  case o.NodeType.DocumentType:
                    if (C || R) return !1;
                    C = !0;
                    break;
                  case o.NodeType.Element:
                    if (R) return !1;
                    R = !0;
                    break;
                  default:
                    return !1;
                }
            } catch ($) {
              M = { error: $ };
            } finally {
              try {
                F && !F.done && (N = z.return) && N.call(z);
              } finally {
                if (M) throw M.error;
              }
            }
            break;
          case o.NodeType.DocumentFragment:
          case o.NodeType.Element:
            try {
              for (var P = r(T._children), j = P.next(); !j.done; j = P.next())
                switch (j.value._nodeType) {
                  case o.NodeType.Element:
                  case o.NodeType.Text:
                  case o.NodeType.ProcessingInstruction:
                  case o.NodeType.CData:
                  case o.NodeType.Comment:
                    break;
                  default:
                    return !1;
                }
            } catch ($) {
              W = { error: $ };
            } finally {
              try {
                j && !j.done && (x = P.return) && x.call(P);
              } finally {
                if (W) throw W.error;
              }
            }
            break;
          case o.NodeType.DocumentType:
          case o.NodeType.Text:
          case o.NodeType.ProcessingInstruction:
          case o.NodeType.CData:
          case o.NodeType.Comment:
            return !T.hasChildNodes();
        }
        try {
          for (var H = r(T._children), B = H.next(); !B.done; B = H.next())
            if (!f(B.value)) return !1;
        } catch ($) {
          V = { error: $ };
        } finally {
          try {
            B && !B.done && (X = H.return) && X.call(H);
          } finally {
            if (V) throw V.error;
          }
        }
        return !0;
      }, n.tree_nodeLength = b, n.tree_isEmpty = function(f) {
        return b(f) === 0;
      }, n.tree_rootNode = y, n.tree_isDescendantOf = function(f, T, M, N) {
        M === void 0 && (M = !1), N === void 0 && (N = !1);
        for (var W = u(f, M, N); W !== null; ) {
          if (W === T) return !0;
          W = d(f, W, M, N);
        }
        return !1;
      }, n.tree_isAncestorOf = Z, n.tree_isHostIncludingAncestorOf = function f(T, M, N) {
        if (N === void 0 && (N = !1), Z(T, M, N)) return !0;
        var W = y(T);
        return !(!a.Guard.isDocumentFragmentNode(W) || W._host === null || !f(W._host, M, N));
      }, n.tree_isSiblingOf = function(f, T, M) {
        return M === void 0 && (M = !1), f !== T ? f._parent !== null && f._parent === T._parent : !!M;
      }, n.tree_isPreceding = function(f, T) {
        var M = g(f), N = g(T);
        return M !== -1 && N !== -1 && y(f) === y(T) && N < M;
      }, n.tree_isFollowing = function(f, T) {
        var M = g(f), N = g(T);
        return M !== -1 && N !== -1 && y(f) === y(T) && N > M;
      }, n.tree_isParentOf = function(f, T) {
        return f._parent === T;
      }, n.tree_isChildOf = function(f, T) {
        return T._parent === f;
      }, n.tree_previousSibling = function(f) {
        return f._previousSibling;
      }, n.tree_nextSibling = function(f) {
        return f._nextSibling;
      }, n.tree_firstChild = function(f) {
        return f._firstChild;
      }, n.tree_lastChild = function(f) {
        return f._lastChild;
      }, n.tree_treePosition = g, n.tree_index = function(f) {
        for (var T = 0; f._previousSibling !== null; ) T++, f = f._previousSibling;
        return T;
      }, n.tree_retarget = function(f, T) {
        for (; ; ) {
          if (!f || !a.Guard.isNode(f)) return f;
          var M = y(f);
          if (!a.Guard.isShadowRoot(M) || T && a.Guard.isNode(T) && Z(M, T, !0, !0)) return f;
          f = M.host;
        }
      };
    }, function(e, n, s) {
      var r = s(13);
      e.exports = function(a) {
        if (!r(a)) throw TypeError(String(a) + " is not an object");
        return a;
      };
    }, function(e, n, s) {
      var r = s(24), a = s(130), o = s(49), l = s(43), c = s(88), u = l.set, d = l.getterFor("Array Iterator");
      e.exports = c(Array, "Array", (function(h, p) {
        u(this, { type: "Array Iterator", target: r(h), index: 0, kind: p });
      }), (function() {
        var h = d(this), p = h.target, m = h.kind, b = h.index++;
        return !p || b >= p.length ? (h.target = void 0, { value: void 0, done: !0 }) : m == "keys" ? { value: b, done: !1 } : m == "values" ? { value: p[b], done: !1 } : { value: [b, p[b]], done: !1 };
      }), "values"), o.Arguments = o.Array, a("keys"), a("values"), a("entries");
    }, function(e, n, s) {
      var r = s(90), a = s(25), o = s(202);
      r || a(Object.prototype, "toString", o, { unsafe: !0 });
    }, function(e, n, s) {
      var r = s(16), a = s(15), o = s(40);
      e.exports = r ? function(l, c, u) {
        return a.f(l, c, o(1, u));
      } : function(l, c, u) {
        return l[c] = u, l;
      };
    }, function(e, n, s) {
      var r = s(137).charAt, a = s(43), o = s(88), l = a.set, c = a.getterFor("String Iterator");
      o(String, "String", (function(u) {
        l(this, { type: "String Iterator", string: String(u), index: 0 });
      }), (function() {
        var u, d = c(this), h = d.string, p = d.index;
        return p >= h.length ? { value: void 0, done: !0 } : (u = r(h, p), d.index += u.length, { value: u, done: !1 });
      }));
    }, function(e, n, s) {
      var r = s(11), a = s(203), o = s(19), l = s(21), c = s(5), u = c("iterator"), d = c("toStringTag"), h = o.values;
      for (var p in a) {
        var m = r[p], b = m && m.prototype;
        if (b) {
          if (b[u] !== h) try {
            l(b, u, h);
          } catch {
            b[u] = h;
          }
          if (b[d] || l(b, d, p), a[p]) {
            for (var y in o) if (b[y] !== o[y]) try {
              l(b, y, o[y]);
            } catch {
              b[y] = o[y];
            }
          }
        }
      }
    }, function(e, n, s) {
      var r = s(41), a = s(35);
      e.exports = function(o) {
        return r(a(o));
      };
    }, function(e, n, s) {
      var r = s(11), a = s(21), o = s(14), l = s(80), c = s(117), u = s(43), d = u.get, h = u.enforce, p = String(String).split("String");
      (e.exports = function(m, b, y, Z) {
        var g = !!Z && !!Z.unsafe, f = !!Z && !!Z.enumerable, T = !!Z && !!Z.noTargetGet;
        typeof y == "function" && (typeof b != "string" || o(y, "name") || a(y, "name", b), h(y).source = p.join(typeof b == "string" ? b : "")), m !== r ? (g ? !T && m[b] && (f = !0) : delete m[b], f ? m[b] = y : a(m, b, y)) : f ? m[b] = y : l(b, y);
      })(Function.prototype, "toString", (function() {
        return typeof this == "function" && d(this).source || c(this);
      }));
    }, function(e, n, s) {
      var r = s(47), a = Math.min;
      e.exports = function(o) {
        return o > 0 ? a(r(o), 9007199254740991) : 0;
      };
    }, function(e, n, s) {
      var r = s(35);
      e.exports = function(a) {
        return Object(r(a));
      };
    }, function(e, n, s) {
      var r = s(16), a = s(8), o = s(14), l = Object.defineProperty, c = {}, u = function(d) {
        throw d;
      };
      e.exports = function(d, h) {
        if (o(c, d)) return c[d];
        h || (h = {});
        var p = [][d], m = !!o(h, "ACCESSORS") && h.ACCESSORS, b = o(h, 0) ? h[0] : u, y = o(h, 1) ? h[1] : void 0;
        return c[d] = !!p && !a((function() {
          if (m && !r) return !0;
          var Z = { length: -1 };
          m ? l(Z, 1, { enumerable: !0, get: u }) : Z[1] = 1, p.call(Z, b, y);
        }));
      };
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(148), a = s(149), o = s(151), l = s(98), c = s(153), u = s(154), d = s(155), h = s(99), p = s(100), m = s(156), b = s(157), y = s(101), Z = s(158), g = s(159), f = s(160), T = s(161), M = s(162), N = s(163), W = s(164), x = s(165), V = s(166), X = s(167), C = s(168), R = s(169), z = s(170);
      n.create_domImplementation = function(F) {
        return r.DOMImplementationImpl._create(F);
      }, n.create_window = function() {
        return a.WindowImpl._create();
      }, n.create_xmlDocument = function() {
        return new o.XMLDocumentImpl();
      }, n.create_document = function() {
        return new l.DocumentImpl();
      }, n.create_abortController = function() {
        return new c.AbortControllerImpl();
      }, n.create_abortSignal = function() {
        return u.AbortSignalImpl._create();
      }, n.create_documentType = function(F, P, j, H) {
        return d.DocumentTypeImpl._create(F, P, j, H);
      }, n.create_element = function(F, P, j, H) {
        return h.ElementImpl._create(F, P, j, H);
      }, n.create_htmlElement = function(F, P, j, H) {
        return h.ElementImpl._create(F, P, j, H);
      }, n.create_htmlUnknownElement = function(F, P, j, H) {
        return h.ElementImpl._create(F, P, j, H);
      }, n.create_documentFragment = function(F) {
        return p.DocumentFragmentImpl._create(F);
      }, n.create_shadowRoot = function(F, P) {
        return m.ShadowRootImpl._create(F, P);
      }, n.create_attr = function(F, P) {
        return b.AttrImpl._create(F, P);
      }, n.create_text = function(F, P) {
        return y.TextImpl._create(F, P);
      }, n.create_cdataSection = function(F, P) {
        return Z.CDATASectionImpl._create(F, P);
      }, n.create_comment = function(F, P) {
        return g.CommentImpl._create(F, P);
      }, n.create_processingInstruction = function(F, P, j) {
        return f.ProcessingInstructionImpl._create(F, P, j);
      }, n.create_htmlCollection = function(F, P) {
        return P === void 0 && (P = function() {
          return !0;
        }), T.HTMLCollectionImpl._create(F, P);
      }, n.create_nodeList = function(F) {
        return M.NodeListImpl._create(F);
      }, n.create_nodeListStatic = function(F, P) {
        return N.NodeListStaticImpl._create(F, P);
      }, n.create_namedNodeMap = function(F) {
        return W.NamedNodeMapImpl._create(F);
      }, n.create_range = function(F, P) {
        return x.RangeImpl._create(F, P);
      }, n.create_nodeIterator = function(F, P, j) {
        return V.NodeIteratorImpl._create(F, P, j);
      }, n.create_treeWalker = function(F, P) {
        return X.TreeWalkerImpl._create(F, P);
      }, n.create_nodeFilter = function() {
        return C.NodeFilterImpl._create();
      }, n.create_mutationRecord = function(F, P, j, H, B, $, A, E, ct) {
        return R.MutationRecordImpl._create(F, P, j, H, B, $, A, E, ct);
      }, n.create_domTokenList = function(F, P) {
        return z.DOMTokenListImpl._create(F, P);
      };
    }, function(e, n, s) {
      var r = this && this.__values || function(b) {
        var y = typeof Symbol == "function" && Symbol.iterator, Z = y && b[y], g = 0;
        if (Z) return Z.call(b);
        if (b && typeof b.length == "number") return { next: function() {
          return b && g >= b.length && (b = void 0), { value: b && b[g++], done: !b };
        } };
        throw new TypeError(y ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = s(6), o = s(17), l = s(3), c = s(72), u = /* @__PURE__ */ new Map();
      function d(b, y) {
        if (y !== b._root && o.tree_isAncestorOf(b._reference, y, !0)) {
          if (b._pointerBeforeReference) for (; ; ) {
            var Z = o.tree_getFollowingNode(b._root, y);
            if (Z !== null && o.tree_isDescendantOf(b._root, Z, !0) && !o.tree_isDescendantOf(y, Z, !0)) return void (b._reference = Z);
            if (Z === null) return void (b._pointerBeforeReference = !1);
          }
          if (y._previousSibling === null) y._parent !== null && (b._reference = y._parent);
          else {
            for (var g = y._previousSibling, f = o.tree_getFirstDescendantNode(y._previousSibling, !0, !1); f !== null; ) f !== null && (g = f), f = o.tree_getNextDescendantNode(y._previousSibling, f, !0, !1);
            b._reference = g;
          }
        }
      }
      function h(b, y, Z, g, f) {
        if (l.Guard.isSlot(b) && y === "name" && f === null) {
          if (g === Z || g === null && Z === "" || g === "" && Z === null) return;
          b._name = g === null || g === "" ? "" : g, c.shadowTree_assignSlotablesForATree(o.tree_rootNode(b));
        }
      }
      function p(b, y, Z, g, f) {
        if (l.Guard.isSlotable(b) && y === "slot" && f === null) {
          if (g === Z || g === null && Z === "" || g === "" && Z === null) return;
          b._name = g === null || g === "" ? "" : g, c.shadowTree_isAssigned(b) && c.shadowTree_assignSlotables(b._assignedSlot), c.shadowTree_assignASlot(b);
        }
      }
      function m(b, y, Z, g) {
        y === "id" && g === null && (b._uniqueIdentifier = Z || void 0);
      }
      n.dom_runRemovingSteps = function(b, y) {
      }, n.dom_runCloningSteps = function(b, y, Z, g) {
      }, n.dom_runAdoptingSteps = function(b, y) {
      }, n.dom_runAttributeChangeSteps = function(b, y, Z, g, f) {
        var T, M;
        a.dom.features.slots && (p.call(b, b, y, Z, g, f), h.call(b, b, y, Z, g, f)), m.call(b, b, y, g, f);
        try {
          for (var N = r(b._attributeChangeSteps), W = N.next(); !W.done; W = N.next())
            W.value.call(b, b, y, Z, g, f);
        } catch (x) {
          T = { error: x };
        } finally {
          try {
            W && !W.done && (M = N.return) && M.call(N);
          } finally {
            if (T) throw T.error;
          }
        }
      }, n.dom_runInsertionSteps = function(b) {
      }, n.dom_runNodeIteratorPreRemovingSteps = function(b, y) {
        d.call(b, b, y);
      }, n.dom_hasSupportedTokens = function(b) {
        return u.has(b);
      }, n.dom_getSupportedTokens = function(b) {
        return u.get(b) || /* @__PURE__ */ new Set();
      }, n.dom_runEventConstructingSteps = function(b) {
      }, n.dom_runChildTextContentChangeSteps = function(b) {
      };
    }, function(e, n, s) {
      var r = s(4), a = s(11), o = s(46), l = s(44), c = s(16), u = s(86), d = s(124), h = s(8), p = s(14), m = s(59), b = s(13), y = s(18), Z = s(27), g = s(24), f = s(56), T = s(40), M = s(60), N = s(61), W = s(82), x = s(190), V = s(85), X = s(55), C = s(15), R = s(79), z = s(21), F = s(25), P = s(81), j = s(57), H = s(45), B = s(58), $ = s(5), A = s(125), E = s(126), ct = s(62), at = s(43), dt = s(36).forEach, gt = j("hidden"), Wt = $("toPrimitive"), Zt = at.set, Gt = at.getterFor("Symbol"), Tt = Object.prototype, Q = a.Symbol, D = o("JSON", "stringify"), q = X.f, nt = C.f, et = x.f, ot = R.f, it = P("symbols"), ht = P("op-symbols"), lt = P("string-to-symbol-registry"), mt = P("symbol-to-string-registry"), wt = P("wks"), Xt = a.QObject, At = !Xt || !Xt.prototype || !Xt.prototype.findChild, he = c && h((function() {
        return M(nt({}, "a", { get: function() {
          return nt(this, "a", { value: 7 }).a;
        } })).a != 7;
      })) ? function(Rt, $t, zt) {
        var Bt = q(Tt, $t);
        Bt && delete Tt[$t], nt(Rt, $t, zt), Bt && Rt !== Tt && nt(Tt, $t, Bt);
      } : nt, ue = function(Rt, $t) {
        var zt = it[Rt] = M(Q.prototype);
        return Zt(zt, { type: "Symbol", tag: Rt, description: $t }), c || (zt.description = $t), zt;
      }, Dt = d ? function(Rt) {
        return typeof Rt == "symbol";
      } : function(Rt) {
        return Object(Rt) instanceof Q;
      }, ee = function(Rt, $t, zt) {
        Rt === Tt && ee(ht, $t, zt), y(Rt);
        var Bt = f($t, !0);
        return y(zt), p(it, Bt) ? (zt.enumerable ? (p(Rt, gt) && Rt[gt][Bt] && (Rt[gt][Bt] = !1), zt = M(zt, { enumerable: T(0, !1) })) : (p(Rt, gt) || nt(Rt, gt, T(1, {})), Rt[gt][Bt] = !0), he(Rt, Bt, zt)) : nt(Rt, Bt, zt);
      }, yt = function(Rt, $t) {
        y(Rt);
        var zt = g($t), Bt = N(zt).concat(Vt(zt));
        return dt(Bt, (function(Kt) {
          c && !fe.call(zt, Kt) || ee(Rt, Kt, zt[Kt]);
        })), Rt;
      }, fe = function(Rt) {
        var $t = f(Rt, !0), zt = ot.call(this, $t);
        return !(this === Tt && p(it, $t) && !p(ht, $t)) && (!(zt || !p(this, $t) || !p(it, $t) || p(this, gt) && this[gt][$t]) || zt);
      }, Xe = function(Rt, $t) {
        var zt = g(Rt), Bt = f($t, !0);
        if (zt !== Tt || !p(it, Bt) || p(ht, Bt)) {
          var Kt = q(zt, Bt);
          return !Kt || !p(it, Bt) || p(zt, gt) && zt[gt][Bt] || (Kt.enumerable = !0), Kt;
        }
      }, Se = function(Rt) {
        var $t = et(g(Rt)), zt = [];
        return dt($t, (function(Bt) {
          p(it, Bt) || p(H, Bt) || zt.push(Bt);
        })), zt;
      }, Vt = function(Rt) {
        var $t = Rt === Tt, zt = et($t ? ht : g(Rt)), Bt = [];
        return dt(zt, (function(Kt) {
          !p(it, Kt) || $t && !p(Tt, Kt) || Bt.push(it[Kt]);
        })), Bt;
      };
      u || (F((Q = function() {
        if (this instanceof Q) throw TypeError("Symbol is not a constructor");
        var Rt = arguments.length && arguments[0] !== void 0 ? String(arguments[0]) : void 0, $t = B(Rt), zt = function(Bt) {
          this === Tt && zt.call(ht, Bt), p(this, gt) && p(this[gt], $t) && (this[gt][$t] = !1), he(this, $t, T(1, Bt));
        };
        return c && At && he(Tt, $t, { configurable: !0, set: zt }), ue($t, Rt);
      }).prototype, "toString", (function() {
        return Gt(this).tag;
      })), F(Q, "withoutSetter", (function(Rt) {
        return ue(B(Rt), Rt);
      })), R.f = fe, C.f = ee, X.f = Xe, W.f = x.f = Se, V.f = Vt, A.f = function(Rt) {
        return ue($(Rt), Rt);
      }, c && (nt(Q.prototype, "description", { configurable: !0, get: function() {
        return Gt(this).description;
      } }), l || F(Tt, "propertyIsEnumerable", fe, { unsafe: !0 }))), r({ global: !0, wrap: !0, forced: !u, sham: !u }, { Symbol: Q }), dt(N(wt), (function(Rt) {
        E(Rt);
      })), r({ target: "Symbol", stat: !0, forced: !u }, { for: function(Rt) {
        var $t = String(Rt);
        if (p(lt, $t)) return lt[$t];
        var zt = Q($t);
        return lt[$t] = zt, mt[zt] = $t, zt;
      }, keyFor: function(Rt) {
        if (!Dt(Rt)) throw TypeError(Rt + " is not a symbol");
        if (p(mt, Rt)) return mt[Rt];
      }, useSetter: function() {
        At = !0;
      }, useSimple: function() {
        At = !1;
      } }), r({ target: "Object", stat: !0, forced: !u, sham: !c }, { create: function(Rt, $t) {
        return $t === void 0 ? M(Rt) : yt(M(Rt), $t);
      }, defineProperty: ee, defineProperties: yt, getOwnPropertyDescriptor: Xe }), r({ target: "Object", stat: !0, forced: !u }, { getOwnPropertyNames: Se, getOwnPropertySymbols: Vt }), r({ target: "Object", stat: !0, forced: h((function() {
        V.f(1);
      })) }, { getOwnPropertySymbols: function(Rt) {
        return V.f(Z(Rt));
      } }), D && r({ target: "JSON", stat: !0, forced: !u || h((function() {
        var Rt = Q();
        return D([Rt]) != "[null]" || D({ a: Rt }) != "{}" || D(Object(Rt)) != "{}";
      })) }, { stringify: function(Rt, $t, zt) {
        for (var Bt, Kt = [Rt], ne = 1; arguments.length > ne; ) Kt.push(arguments[ne++]);
        if (Bt = $t, (b($t) || Rt !== void 0) && !Dt(Rt)) return m($t) || ($t = function(ae, Ge) {
          if (typeof Bt == "function" && (Ge = Bt.call(this, ae, Ge)), !Dt(Ge)) return Ge;
        }), Kt[1] = $t, D.apply(null, Kt);
      } }), Q.prototype[Wt] || z(Q.prototype, Wt, Q.prototype.valueOf), ct(Q, "Symbol"), H[gt] = !0;
    }, function(e, n, s) {
      var r = s(4), a = s(16), o = s(11), l = s(14), c = s(13), u = s(15).f, d = s(119), h = o.Symbol;
      if (a && typeof h == "function" && (!("description" in h.prototype) || h().description !== void 0)) {
        var p = {}, m = function() {
          var f = arguments.length < 1 || arguments[0] === void 0 ? void 0 : String(arguments[0]), T = this instanceof m ? new h(f) : f === void 0 ? h() : h(f);
          return f === "" && (p[T] = !0), T;
        };
        d(m, h);
        var b = m.prototype = h.prototype;
        b.constructor = m;
        var y = b.toString, Z = String(h("test")) == "Symbol(test)", g = /^Symbol\((.*)\)[^)]+$/;
        u(b, "description", { configurable: !0, get: function() {
          var f = c(this) ? this.valueOf() : this, T = y.call(f);
          if (l(p, f)) return "";
          var M = Z ? T.slice(7, -1) : T.replace(g, "$1");
          return M === "" ? void 0 : M;
        } }), r({ global: !0, forced: !0 }, { Symbol: m });
      }
    }, function(e, n, s) {
      s(126)("iterator");
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(Z, g) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(f, T) {
          f.__proto__ = T;
        } || function(f, T) {
          for (var M in T) T.hasOwnProperty(M) && (f[M] = T[M]);
        })(Z, g);
      }, function(Z, g) {
        function f() {
          this.constructor = Z;
        }
        r(Z, g), Z.prototype = g === null ? Object.create(g) : (f.prototype = g.prototype, new f());
      }), o = this && this.__values || function(Z) {
        var g = typeof Symbol == "function" && Symbol.iterator, f = g && Z[g], T = 0;
        if (f) return f.call(Z);
        if (Z && typeof Z.length == "number") return { next: function() {
          return Z && T >= Z.length && (Z = void 0), { value: Z && Z[T++], done: !Z };
        } };
        throw new TypeError(g ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var l = s(6), c = s(2), u = s(70), d = s(3), h = s(9), p = s(0), m = s(152), b = s(12), y = (function(Z) {
        function g() {
          var f = Z.call(this) || this;
          return f._parent = null, f._firstChild = null, f._lastChild = null, f._previousSibling = null, f._nextSibling = null, f;
        }
        return a(g, Z), Object.defineProperty(g.prototype, "_childNodes", { get: function() {
          return this.__childNodes || (this.__childNodes = p.create_nodeList(this));
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(g.prototype, "_nodeDocument", { get: function() {
          return this._nodeDocumentOverride || l.dom.window._associatedDocument;
        }, set: function(f) {
          this._nodeDocumentOverride = f;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(g.prototype, "_registeredObserverList", { get: function() {
          return this.__registeredObserverList || (this.__registeredObserverList = []);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(g.prototype, "nodeType", { get: function() {
          return this._nodeType;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(g.prototype, "nodeName", { get: function() {
          return d.Guard.isElementNode(this) ? this._htmlUppercasedQualifiedName : d.Guard.isAttrNode(this) ? this._qualifiedName : d.Guard.isExclusiveTextNode(this) ? "#text" : d.Guard.isCDATASectionNode(this) ? "#cdata-section" : d.Guard.isProcessingInstructionNode(this) ? this._target : d.Guard.isCommentNode(this) ? "#comment" : d.Guard.isDocumentNode(this) ? "#document" : d.Guard.isDocumentTypeNode(this) ? this._name : d.Guard.isDocumentFragmentNode(this) ? "#document-fragment" : "";
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(g.prototype, "baseURI", { get: function() {
          return m.urlSerializer(this._nodeDocument._URL);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(g.prototype, "isConnected", { get: function() {
          return d.Guard.isElementNode(this) && p.shadowTree_isConnected(this);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(g.prototype, "ownerDocument", { get: function() {
          return this._nodeType === c.NodeType.Document ? null : this._nodeDocument;
        }, enumerable: !0, configurable: !0 }), g.prototype.getRootNode = function(f) {
          return p.tree_rootNode(this, !!f && f.composed);
        }, Object.defineProperty(g.prototype, "parentNode", { get: function() {
          return this._nodeType === c.NodeType.Attribute ? null : this._parent;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(g.prototype, "parentElement", { get: function() {
          return this._parent && d.Guard.isElementNode(this._parent) ? this._parent : null;
        }, enumerable: !0, configurable: !0 }), g.prototype.hasChildNodes = function() {
          return this._firstChild !== null;
        }, Object.defineProperty(g.prototype, "childNodes", { get: function() {
          return this._childNodes;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(g.prototype, "firstChild", { get: function() {
          return this._firstChild;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(g.prototype, "lastChild", { get: function() {
          return this._lastChild;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(g.prototype, "previousSibling", { get: function() {
          return this._previousSibling;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(g.prototype, "nextSibling", { get: function() {
          return this._nextSibling;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(g.prototype, "nodeValue", { get: function() {
          return d.Guard.isAttrNode(this) ? this._value : d.Guard.isCharacterDataNode(this) ? this._data : null;
        }, set: function(f) {
          f === null && (f = ""), d.Guard.isAttrNode(this) ? p.attr_setAnExistingAttributeValue(this, f) : d.Guard.isCharacterDataNode(this) && p.characterData_replaceData(this, 0, this._data.length, f);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(g.prototype, "textContent", { get: function() {
          return d.Guard.isDocumentFragmentNode(this) || d.Guard.isElementNode(this) ? p.text_descendantTextContent(this) : d.Guard.isAttrNode(this) ? this._value : d.Guard.isCharacterDataNode(this) ? this._data : null;
        }, set: function(f) {
          f === null && (f = ""), d.Guard.isDocumentFragmentNode(this) || d.Guard.isElementNode(this) ? p.node_stringReplaceAll(f, this) : d.Guard.isAttrNode(this) ? p.attr_setAnExistingAttributeValue(this, f) : d.Guard.isCharacterDataNode(this) && p.characterData_replaceData(this, 0, p.tree_nodeLength(this), f);
        }, enumerable: !0, configurable: !0 }), g.prototype.normalize = function() {
          for (var f, T, M, N, W = [], x = p.tree_getFirstDescendantNode(this, !1, !1, (function(dt) {
            return d.Guard.isExclusiveTextNode(dt);
          })); x !== null; ) W.push(x), x = p.tree_getNextDescendantNode(this, x, !1, !1, (function(dt) {
            return d.Guard.isExclusiveTextNode(dt);
          }));
          for (var V = 0; V < W.length; V++) {
            var X = W[V];
            if (X._parent !== null) {
              var C = p.tree_nodeLength(X);
              if (C !== 0) {
                var R = [], z = "";
                try {
                  for (var F = (f = void 0, o(p.text_contiguousExclusiveTextNodes(X))), P = F.next(); !P.done; P = F.next()) {
                    var j = P.value;
                    R.push(j), z += j._data;
                  }
                } catch (dt) {
                  f = { error: dt };
                } finally {
                  try {
                    P && !P.done && (T = F.return) && T.call(F);
                  } finally {
                    if (f) throw f.error;
                  }
                }
                if (p.characterData_replaceData(X, C, 0, z), l.dom.rangeList.size !== 0) for (var H = X._nextSibling; H !== null && d.Guard.isExclusiveTextNode(H); ) {
                  var B = H, $ = p.tree_index(B);
                  try {
                    for (var A = (M = void 0, o(l.dom.rangeList)), E = A.next(); !E.done; E = A.next()) {
                      var ct = E.value;
                      ct._start[0] === B && (ct._start[0] = X, ct._start[1] += C), ct._end[0] === B && (ct._end[0] = X, ct._end[1] += C), ct._start[0] === B._parent && ct._start[1] === $ && (ct._start[0] = X, ct._start[1] = C), ct._end[0] === B._parent && ct._end[1] === $ && (ct._end[0] = X, ct._end[1] = C);
                    }
                  } catch (dt) {
                    M = { error: dt };
                  } finally {
                    try {
                      E && !E.done && (N = A.return) && N.call(A);
                    } finally {
                      if (M) throw M.error;
                    }
                  }
                  C += p.tree_nodeLength(H), H = H._nextSibling;
                }
                for (var at = 0; at < R.length; at++)
                  (j = R[at])._parent !== null && p.mutation_remove(j, j._parent);
              } else p.mutation_remove(X, X._parent);
            }
          }
        }, g.prototype.cloneNode = function(f) {
          if (f === void 0 && (f = !1), d.Guard.isShadowRoot(this)) throw new h.NotSupportedError();
          return p.node_clone(this, null, f);
        }, g.prototype.isEqualNode = function(f) {
          return f === void 0 && (f = null), f !== null && p.node_equals(this, f);
        }, g.prototype.isSameNode = function(f) {
          return f === void 0 && (f = null), this === f;
        }, g.prototype.compareDocumentPosition = function(f) {
          if (f === this) return 0;
          var T = f, M = this, N = null, W = null;
          if (d.Guard.isAttrNode(T) && (T = (N = T)._element), d.Guard.isAttrNode(M) && (M = (W = M)._element, N && T && T === M)) for (var x = 0; x < M._attributeList.length; x++) {
            var V = M._attributeList[x];
            if (p.node_equals(V, N)) return c.Position.ImplementationSpecific | c.Position.Preceding;
            if (p.node_equals(V, W)) return c.Position.ImplementationSpecific | c.Position.Following;
          }
          return T === null || M === null || p.tree_rootNode(T) !== p.tree_rootNode(M) ? c.Position.Disconnected | c.Position.ImplementationSpecific | (l.dom.compareCache.check(this, f) ? c.Position.Preceding : c.Position.Following) : !N && p.tree_isAncestorOf(M, T) || W && T === M ? c.Position.Contains | c.Position.Preceding : !W && p.tree_isDescendantOf(M, T) || N && T === M ? c.Position.ContainedBy | c.Position.Following : p.tree_isPreceding(M, T) ? c.Position.Preceding : c.Position.Following;
        }, g.prototype.contains = function(f) {
          return f !== null && p.tree_isDescendantOf(this, f, !0);
        }, g.prototype.lookupPrefix = function(f) {
          return f ? d.Guard.isElementNode(this) ? p.node_locateANamespacePrefix(this, f) : d.Guard.isDocumentNode(this) ? this.documentElement === null ? null : p.node_locateANamespacePrefix(this.documentElement, f) : d.Guard.isDocumentTypeNode(this) || d.Guard.isDocumentFragmentNode(this) ? null : d.Guard.isAttrNode(this) ? this._element === null ? null : p.node_locateANamespacePrefix(this._element, f) : this._parent !== null && d.Guard.isElementNode(this._parent) ? p.node_locateANamespacePrefix(this._parent, f) : null : null;
        }, g.prototype.lookupNamespaceURI = function(f) {
          return p.node_locateANamespace(this, f || null);
        }, g.prototype.isDefaultNamespace = function(f) {
          return f || (f = null), p.node_locateANamespace(this, null) === f;
        }, g.prototype.insertBefore = function(f, T) {
          return p.mutation_preInsert(f, this, T);
        }, g.prototype.appendChild = function(f) {
          return p.mutation_append(f, this);
        }, g.prototype.replaceChild = function(f, T) {
          return p.mutation_replace(T, f, this);
        }, g.prototype.removeChild = function(f) {
          return p.mutation_preRemove(f, this);
        }, g.prototype._getTheParent = function(f) {
          return d.Guard.isSlotable(this) && p.shadowTree_isAssigned(this) ? this._assignedSlot : this._parent;
        }, g.ELEMENT_NODE = 1, g.ATTRIBUTE_NODE = 2, g.TEXT_NODE = 3, g.CDATA_SECTION_NODE = 4, g.ENTITY_REFERENCE_NODE = 5, g.ENTITY_NODE = 6, g.PROCESSING_INSTRUCTION_NODE = 7, g.COMMENT_NODE = 8, g.DOCUMENT_NODE = 9, g.DOCUMENT_TYPE_NODE = 10, g.DOCUMENT_FRAGMENT_NODE = 11, g.NOTATION_NODE = 12, g.DOCUMENT_POSITION_DISCONNECTED = 1, g.DOCUMENT_POSITION_PRECEDING = 2, g.DOCUMENT_POSITION_FOLLOWING = 4, g.DOCUMENT_POSITION_CONTAINS = 8, g.DOCUMENT_POSITION_CONTAINED_BY = 16, g.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC = 32, g;
      })(u.EventTargetImpl);
      n.NodeImpl = y, y.prototype._children = new d.EmptySet(), b.idl_defineConst(y.prototype, "ELEMENT_NODE", 1), b.idl_defineConst(y.prototype, "ATTRIBUTE_NODE", 2), b.idl_defineConst(y.prototype, "TEXT_NODE", 3), b.idl_defineConst(y.prototype, "CDATA_SECTION_NODE", 4), b.idl_defineConst(y.prototype, "ENTITY_REFERENCE_NODE", 5), b.idl_defineConst(y.prototype, "ENTITY_NODE", 6), b.idl_defineConst(y.prototype, "PROCESSING_INSTRUCTION_NODE", 7), b.idl_defineConst(y.prototype, "COMMENT_NODE", 8), b.idl_defineConst(y.prototype, "DOCUMENT_NODE", 9), b.idl_defineConst(y.prototype, "DOCUMENT_TYPE_NODE", 10), b.idl_defineConst(y.prototype, "DOCUMENT_FRAGMENT_NODE", 11), b.idl_defineConst(y.prototype, "NOTATION_NODE", 12), b.idl_defineConst(y.prototype, "DOCUMENT_POSITION_DISCONNECTED", 1), b.idl_defineConst(y.prototype, "DOCUMENT_POSITION_PRECEDING", 2), b.idl_defineConst(y.prototype, "DOCUMENT_POSITION_FOLLOWING", 4), b.idl_defineConst(y.prototype, "DOCUMENT_POSITION_CONTAINS", 8), b.idl_defineConst(y.prototype, "DOCUMENT_POSITION_CONTAINED_BY", 16), b.idl_defineConst(y.prototype, "DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC", 32);
    }, function(e, n) {
      e.exports = function(s) {
        if (s == null) throw TypeError("Can't call method on " + s);
        return s;
      };
    }, function(e, n, s) {
      var r = s(87), a = s(41), o = s(27), l = s(26), c = s(128), u = [].push, d = function(h) {
        var p = h == 1, m = h == 2, b = h == 3, y = h == 4, Z = h == 6, g = h == 5 || Z;
        return function(f, T, M, N) {
          for (var W, x, V = o(f), X = a(V), C = r(T, M, 3), R = l(X.length), z = 0, F = N || c, P = p ? F(f, R) : m ? F(f, 0) : void 0; R > z; z++) if ((g || z in X) && (x = C(W = X[z], z, V), h)) {
            if (p) P[z] = x;
            else if (x) switch (h) {
              case 3:
                return !0;
              case 5:
                return W;
              case 6:
                return z;
              case 2:
                u.call(P, W);
            }
            else if (y) return !1;
          }
          return Z ? -1 : b || y ? y : P;
        };
      };
      e.exports = { forEach: d(0), map: d(1), filter: d(2), some: d(3), every: d(4), find: d(5), findIndex: d(6) };
    }, function(e, n, s) {
      var r = this && this.__values || function(V) {
        var X = typeof Symbol == "function" && Symbol.iterator, C = X && V[X], R = 0;
        if (C) return C.call(V);
        if (V && typeof V.length == "number") return { next: function() {
          return V && R >= V.length && (V = void 0), { value: V && V[R++], done: !V };
        } };
        throw new TypeError(X ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }, a = this && this.__read || function(V, X) {
        var C = typeof Symbol == "function" && V[Symbol.iterator];
        if (!C) return V;
        var R, z, F = C.call(V), P = [];
        try {
          for (; (X === void 0 || X-- > 0) && !(R = F.next()).done; ) P.push(R.value);
        } catch (j) {
          z = { error: j };
        } finally {
          try {
            R && !R.done && (C = F.return) && C.call(F);
          } finally {
            if (z) throw z.error;
          }
        }
        return P;
      }, o = this && this.__spread || function() {
        for (var V = [], X = 0; X < arguments.length; X++) V = V.concat(a(arguments[X]));
        return V;
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var l = s(6), c = s(9), u = s(2), d = s(3), h = s(1), p = s(7), m = s(73), b = s(17), y = s(172), Z = s(72), g = s(51), f = s(30), T = s(106);
      function M(V, X, C) {
        var R, z, F, P, j, H, B, $, A = X._nodeType, E = V._nodeType, ct = C ? C._nodeType : null;
        if (A !== u.NodeType.Document && A !== u.NodeType.DocumentFragment && A !== u.NodeType.Element) throw new c.HierarchyRequestError("Only document, document fragment and element nodes can contain child nodes. Parent node is " + X.nodeName + ".");
        if (b.tree_isHostIncludingAncestorOf(X, V, !0)) throw new c.HierarchyRequestError("The node to be inserted cannot be an inclusive ancestor of parent node. Node is " + V.nodeName + ", parent node is " + X.nodeName + ".");
        if (C !== null && C._parent !== X) throw new c.NotFoundError("The reference child node cannot be found under parent node. Child node is " + C.nodeName + ", parent node is " + X.nodeName + ".");
        if (E !== u.NodeType.DocumentFragment && E !== u.NodeType.DocumentType && E !== u.NodeType.Element && E !== u.NodeType.Text && E !== u.NodeType.ProcessingInstruction && E !== u.NodeType.CData && E !== u.NodeType.Comment) throw new c.HierarchyRequestError("Only document fragment, document type, element, text, processing instruction, cdata section or comment nodes can be inserted. Node is " + V.nodeName + ".");
        if (E === u.NodeType.Text && A === u.NodeType.Document) throw new c.HierarchyRequestError("Cannot insert a text node as a child of a document node. Node is " + V.nodeName + ".");
        if (E === u.NodeType.DocumentType && A !== u.NodeType.Document) throw new c.HierarchyRequestError("A document type node can only be inserted under a document node. Parent node is " + X.nodeName + ".");
        if (A === u.NodeType.Document) {
          if (E === u.NodeType.DocumentFragment) {
            var at = 0;
            try {
              for (var dt = r(V._children), gt = dt.next(); !gt.done; gt = dt.next()) {
                var Wt = gt.value;
                if (Wt._nodeType === u.NodeType.Element) at++;
                else if (Wt._nodeType === u.NodeType.Text) throw new c.HierarchyRequestError("Cannot insert text a node as a child of a document node. Node is " + Wt.nodeName + ".");
              }
            } catch (ot) {
              R = { error: ot };
            } finally {
              try {
                gt && !gt.done && (z = dt.return) && z.call(dt);
              } finally {
                if (R) throw R.error;
              }
            }
            if (at > 1) throw new c.HierarchyRequestError("A document node can only have one document element node. Document fragment to be inserted has " + at + " element nodes.");
            if (at === 1) {
              try {
                for (var Zt = r(X._children), Gt = Zt.next(); !Gt.done; Gt = Zt.next())
                  if (Gt.value._nodeType === u.NodeType.Element) throw new c.HierarchyRequestError("The document node already has a document element node.");
              } catch (ot) {
                F = { error: ot };
              } finally {
                try {
                  Gt && !Gt.done && (P = Zt.return) && P.call(Zt);
                } finally {
                  if (F) throw F.error;
                }
              }
              if (C) {
                if (ct === u.NodeType.DocumentType) throw new c.HierarchyRequestError("Cannot insert an element node before a document type node.");
                for (var Tt = C._nextSibling; Tt; ) {
                  if (Tt._nodeType === u.NodeType.DocumentType) throw new c.HierarchyRequestError("Cannot insert an element node before a document type node.");
                  Tt = Tt._nextSibling;
                }
              }
            }
          } else if (E === u.NodeType.Element) {
            try {
              for (var Q = r(X._children), D = Q.next(); !D.done; D = Q.next())
                if (D.value._nodeType === u.NodeType.Element) throw new c.HierarchyRequestError("Document already has a document element node. Node is " + V.nodeName + ".");
            } catch (ot) {
              j = { error: ot };
            } finally {
              try {
                D && !D.done && (H = Q.return) && H.call(Q);
              } finally {
                if (j) throw j.error;
              }
            }
            if (C) {
              if (ct === u.NodeType.DocumentType) throw new c.HierarchyRequestError("Cannot insert an element node before a document type node. Node is " + V.nodeName + ".");
              for (Tt = C._nextSibling; Tt; ) {
                if (Tt._nodeType === u.NodeType.DocumentType) throw new c.HierarchyRequestError("Cannot insert an element node before a document type node. Node is " + V.nodeName + ".");
                Tt = Tt._nextSibling;
              }
            }
          } else if (E === u.NodeType.DocumentType) {
            try {
              for (var q = r(X._children), nt = q.next(); !nt.done; nt = q.next())
                if (nt.value._nodeType === u.NodeType.DocumentType) throw new c.HierarchyRequestError("Document already has a document type node. Node is " + V.nodeName + ".");
            } catch (ot) {
              B = { error: ot };
            } finally {
              try {
                nt && !nt.done && ($ = q.return) && $.call(q);
              } finally {
                if (B) throw B.error;
              }
            }
            if (C) for (var et = C._previousSibling; et; ) {
              if (et._nodeType === u.NodeType.Element) throw new c.HierarchyRequestError("Cannot insert a document type node before an element node. Node is " + V.nodeName + ".");
              et = et._previousSibling;
            }
            else for (et = X._firstChild; et; ) {
              if (et._nodeType === u.NodeType.Element) throw new c.HierarchyRequestError("Cannot insert a document type node before an element node. Node is " + V.nodeName + ".");
              et = et._nextSibling;
            }
          }
        }
      }
      function N(V, X, C) {
        M(V, X, C);
        var R = C;
        return R === V && (R = V._nextSibling), T.document_adopt(V, X._nodeDocument), W(V, X, R), V;
      }
      function W(V, X, C, R) {
        var z, F;
        if (C !== null || V._nodeType === u.NodeType.DocumentFragment) {
          var P = V._nodeType === u.NodeType.DocumentFragment ? V._children.size : 1;
          if (C !== null && l.dom.rangeList.size !== 0) {
            var j = b.tree_index(C);
            try {
              for (var H = r(l.dom.rangeList), B = H.next(); !B.done; B = H.next()) {
                var $ = B.value;
                $._start[0] === X && $._start[1] > j && ($._start[1] += P), $._end[0] === X && $._end[1] > j && ($._end[1] += P);
              }
            } catch (Gt) {
              z = { error: Gt };
            } finally {
              try {
                B && !B.done && (F = H.return) && F.call(H);
              } finally {
                if (z) throw z.error;
              }
            }
          }
          var A = V._nodeType === u.NodeType.DocumentFragment ? new (Array.bind.apply(Array, o([void 0], V._children)))() : [V];
          if (V._nodeType === u.NodeType.DocumentFragment) for (; V._firstChild; ) x(V._firstChild, V, !0);
          l.dom.features.mutationObservers && V._nodeType === u.NodeType.DocumentFragment && g.observer_queueTreeMutationRecord(V, [], A, null, null);
          for (var E = C ? C._previousSibling : X._lastChild, ct = C === null ? -1 : b.tree_index(C), at = 0; at < A.length; at++) {
            var dt = A[at];
            if (d.Guard.isElementNode(dt) && (d.Guard.isDocumentNode(X) && (X._documentElement = dt), dt._nodeDocument._hasNamespaces || dt._namespace === null && dt._namespacePrefix === null || (dt._nodeDocument._hasNamespaces = !0)), dt._parent = X, C === null ? p.set.append(X._children, dt) : (p.set.insert(X._children, dt, ct), ct++), X._firstChild === null) dt._previousSibling = null, dt._nextSibling = null, X._firstChild = dt, X._lastChild = dt;
            else {
              var gt = C ? C._previousSibling : X._lastChild, Wt = C || null;
              dt._previousSibling = gt, dt._nextSibling = Wt, gt && (gt._nextSibling = dt), Wt && (Wt._previousSibling = dt), gt || (X._firstChild = dt), Wt || (X._lastChild = dt);
            }
            l.dom.features.slots && X._shadowRoot !== null && d.Guard.isSlotable(dt) && Z.shadowTree_assignASlot(dt), l.dom.features.steps && d.Guard.isTextNode(dt) && f.dom_runChildTextContentChangeSteps(X), l.dom.features.slots && d.Guard.isShadowRoot(b.tree_rootNode(X)) && d.Guard.isSlot(X) && h.isEmpty(X._assignedNodes) && Z.shadowTree_signalASlotChange(X), l.dom.features.slots && Z.shadowTree_assignSlotablesForATree(b.tree_rootNode(dt));
            for (var Zt = b.tree_getFirstDescendantNode(dt, !0, !0); Zt !== null; ) l.dom.features.steps && f.dom_runInsertionSteps(Zt), l.dom.features.customElements && d.Guard.isElementNode(Zt) && Z.shadowTree_isConnected(Zt) && (d.Guard.isCustomElementNode(Zt) ? m.customElement_enqueueACustomElementCallbackReaction(Zt, "connectedCallback", []) : m.customElement_tryToUpgrade(Zt)), Zt = b.tree_getNextDescendantNode(dt, Zt, !0, !0);
          }
          l.dom.features.mutationObservers && (R || g.observer_queueTreeMutationRecord(X, A, [], E, C));
        } else (function(Gt, Tt, Q) {
          var D = Tt._lastChild;
          if (d.Guard.isElementNode(Gt) && (d.Guard.isDocumentNode(Tt) && (Tt._documentElement = Gt), Gt._nodeDocument._hasNamespaces || Gt._namespace === null && Gt._namespacePrefix === null || (Gt._nodeDocument._hasNamespaces = !0)), Gt._parent = Tt, Tt._children.add(Gt), Tt._firstChild === null) Gt._previousSibling = null, Gt._nextSibling = null, Tt._firstChild = Gt, Tt._lastChild = Gt;
          else {
            var q = Tt._lastChild;
            Gt._previousSibling = q, Gt._nextSibling = null, q && (q._nextSibling = Gt), q || (Tt._firstChild = Gt), Tt._lastChild = Gt;
          }
          l.dom.features.slots && Tt._shadowRoot !== null && d.Guard.isSlotable(Gt) && Z.shadowTree_assignASlot(Gt), l.dom.features.steps && d.Guard.isTextNode(Gt) && f.dom_runChildTextContentChangeSteps(Tt), l.dom.features.slots && d.Guard.isShadowRoot(b.tree_rootNode(Tt)) && d.Guard.isSlot(Tt) && h.isEmpty(Tt._assignedNodes) && Z.shadowTree_signalASlotChange(Tt), l.dom.features.slots && Z.shadowTree_assignSlotablesForATree(b.tree_rootNode(Gt)), l.dom.features.steps && f.dom_runInsertionSteps(Gt), l.dom.features.customElements && d.Guard.isElementNode(Gt) && Z.shadowTree_isConnected(Gt) && (d.Guard.isCustomElementNode(Gt) ? m.customElement_enqueueACustomElementCallbackReaction(Gt, "connectedCallback", []) : m.customElement_tryToUpgrade(Gt)), l.dom.features.mutationObservers && (Q || g.observer_queueTreeMutationRecord(Tt, [Gt], [], D, null));
        })(V, X, R);
      }
      function x(V, X, C) {
        var R, z, F, P, j, H, B, $;
        if (l.dom.rangeList.size !== 0) {
          var A = b.tree_index(V);
          try {
            for (var E = r(l.dom.rangeList), ct = E.next(); !ct.done; ct = E.next()) {
              var at = ct.value;
              b.tree_isDescendantOf(V, at._start[0], !0) && (at._start = [X, A]), b.tree_isDescendantOf(V, at._end[0], !0) && (at._end = [X, A]), at._start[0] === X && at._start[1] > A && at._start[1]--, at._end[0] === X && at._end[1] > A && at._end[1]--;
            }
          } catch (lt) {
            R = { error: lt };
          } finally {
            try {
              ct && !ct.done && (z = E.return) && z.call(E);
            } finally {
              if (R) throw R.error;
            }
          }
          try {
            for (var dt = r(l.dom.rangeList), gt = dt.next(); !gt.done; gt = dt.next())
              (at = gt.value)._start[0] === X && at._start[1] > A && (at._start[1] -= 1), at._end[0] === X && at._end[1] > A && (at._end[1] -= 1);
          } catch (lt) {
            F = { error: lt };
          } finally {
            try {
              gt && !gt.done && (P = dt.return) && P.call(dt);
            } finally {
              if (F) throw F.error;
            }
          }
        }
        if (l.dom.features.steps) try {
          for (var Wt = r(y.nodeIterator_iteratorList()), Zt = Wt.next(); !Zt.done; Zt = Wt.next()) {
            var Gt = Zt.value;
            Gt._root._nodeDocument === V._nodeDocument && f.dom_runNodeIteratorPreRemovingSteps(Gt, V);
          }
        } catch (lt) {
          j = { error: lt };
        } finally {
          try {
            Zt && !Zt.done && (H = Wt.return) && H.call(Wt);
          } finally {
            if (j) throw j.error;
          }
        }
        var Tt = V._previousSibling, Q = V._nextSibling;
        d.Guard.isDocumentNode(X) && d.Guard.isElementNode(V) && (X._documentElement = null), V._parent = null, X._children.delete(V);
        var D = V._previousSibling, q = V._nextSibling;
        V._previousSibling = null, V._nextSibling = null, D && (D._nextSibling = q), q && (q._previousSibling = D), D || (X._firstChild = q), q || (X._lastChild = D), l.dom.features.slots && d.Guard.isSlotable(V) && V._assignedSlot !== null && Z.shadowTree_isAssigned(V) && Z.shadowTree_assignSlotables(V._assignedSlot), l.dom.features.slots && d.Guard.isShadowRoot(b.tree_rootNode(X)) && d.Guard.isSlot(X) && h.isEmpty(X._assignedNodes) && Z.shadowTree_signalASlotChange(X), l.dom.features.slots && b.tree_getFirstDescendantNode(V, !0, !1, (function(lt) {
          return d.Guard.isSlot(lt);
        })) !== null && (Z.shadowTree_assignSlotablesForATree(b.tree_rootNode(X)), Z.shadowTree_assignSlotablesForATree(V)), l.dom.features.steps && f.dom_runRemovingSteps(V, X), l.dom.features.customElements && d.Guard.isCustomElementNode(V) && m.customElement_enqueueACustomElementCallbackReaction(V, "disconnectedCallback", []);
        for (var nt = b.tree_getFirstDescendantNode(V, !1, !0); nt !== null; ) l.dom.features.steps && f.dom_runRemovingSteps(nt, V), l.dom.features.customElements && d.Guard.isCustomElementNode(nt) && m.customElement_enqueueACustomElementCallbackReaction(nt, "disconnectedCallback", []), nt = b.tree_getNextDescendantNode(V, nt, !1, !0);
        if (l.dom.features.mutationObservers) for (var et = b.tree_getFirstAncestorNode(X, !0); et !== null; ) {
          try {
            for (var ot = (B = void 0, r(et._registeredObserverList)), it = ot.next(); !it.done; it = ot.next()) {
              var ht = it.value;
              ht.options.subtree && V._registeredObserverList.push({ observer: ht.observer, options: ht.options, source: ht });
            }
          } catch (lt) {
            B = { error: lt };
          } finally {
            try {
              it && !it.done && ($ = ot.return) && $.call(ot);
            } finally {
              if (B) throw B.error;
            }
          }
          et = b.tree_getNextAncestorNode(X, et, !0);
        }
        l.dom.features.mutationObservers && (C || g.observer_queueTreeMutationRecord(X, [], [V], Tt, Q)), l.dom.features.steps && d.Guard.isTextNode(V) && f.dom_runChildTextContentChangeSteps(X);
      }
      n.mutation_ensurePreInsertionValidity = M, n.mutation_preInsert = N, n.mutation_insert = W, n.mutation_append = function(V, X) {
        return N(V, X, null);
      }, n.mutation_replace = function(V, X, C) {
        var R, z, F, P, j, H, B, $;
        if (C._nodeType !== u.NodeType.Document && C._nodeType !== u.NodeType.DocumentFragment && C._nodeType !== u.NodeType.Element) throw new c.HierarchyRequestError("Only document, document fragment and element nodes can contain child nodes. Parent node is " + C.nodeName + ".");
        if (b.tree_isHostIncludingAncestorOf(C, X, !0)) throw new c.HierarchyRequestError("The node to be inserted cannot be an ancestor of parent node. Node is " + X.nodeName + ", parent node is " + C.nodeName + ".");
        if (V._parent !== C) throw new c.NotFoundError("The reference child node cannot be found under parent node. Child node is " + V.nodeName + ", parent node is " + C.nodeName + ".");
        if (X._nodeType !== u.NodeType.DocumentFragment && X._nodeType !== u.NodeType.DocumentType && X._nodeType !== u.NodeType.Element && X._nodeType !== u.NodeType.Text && X._nodeType !== u.NodeType.ProcessingInstruction && X._nodeType !== u.NodeType.CData && X._nodeType !== u.NodeType.Comment) throw new c.HierarchyRequestError("Only document fragment, document type, element, text, processing instruction, cdata section or comment nodes can be inserted. Node is " + X.nodeName + ".");
        if (X._nodeType === u.NodeType.Text && C._nodeType === u.NodeType.Document) throw new c.HierarchyRequestError("Cannot insert a text node as a child of a document node. Node is " + X.nodeName + ".");
        if (X._nodeType === u.NodeType.DocumentType && C._nodeType !== u.NodeType.Document) throw new c.HierarchyRequestError("A document type node can only be inserted under a document node. Parent node is " + C.nodeName + ".");
        if (C._nodeType === u.NodeType.Document) {
          if (X._nodeType === u.NodeType.DocumentFragment) {
            var A = 0;
            try {
              for (var E = r(X._children), ct = E.next(); !ct.done; ct = E.next()) {
                var at = ct.value;
                if (at._nodeType === u.NodeType.Element) A++;
                else if (at._nodeType === u.NodeType.Text) throw new c.HierarchyRequestError("Cannot insert text a node as a child of a document node. Node is " + at.nodeName + ".");
              }
            } catch (ht) {
              R = { error: ht };
            } finally {
              try {
                ct && !ct.done && (z = E.return) && z.call(E);
              } finally {
                if (R) throw R.error;
              }
            }
            if (A > 1) throw new c.HierarchyRequestError("A document node can only have one document element node. Document fragment to be inserted has " + A + " element nodes.");
            if (A === 1) {
              try {
                for (var dt = r(C._children), gt = dt.next(); !gt.done; gt = dt.next())
                  if ((D = gt.value)._nodeType === u.NodeType.Element && D !== V) throw new c.HierarchyRequestError("The document node already has a document element node.");
              } catch (ht) {
                F = { error: ht };
              } finally {
                try {
                  gt && !gt.done && (P = dt.return) && P.call(dt);
                } finally {
                  if (F) throw F.error;
                }
              }
              for (var Wt = V._nextSibling; Wt; ) {
                if (Wt._nodeType === u.NodeType.DocumentType) throw new c.HierarchyRequestError("Cannot insert an element node before a document type node.");
                Wt = Wt._nextSibling;
              }
            }
          } else if (X._nodeType === u.NodeType.Element) {
            try {
              for (var Zt = r(C._children), Gt = Zt.next(); !Gt.done; Gt = Zt.next())
                if ((D = Gt.value)._nodeType === u.NodeType.Element && D !== V) throw new c.HierarchyRequestError("Document already has a document element node. Node is " + X.nodeName + ".");
            } catch (ht) {
              j = { error: ht };
            } finally {
              try {
                Gt && !Gt.done && (H = Zt.return) && H.call(Zt);
              } finally {
                if (j) throw j.error;
              }
            }
            for (Wt = V._nextSibling; Wt; ) {
              if (Wt._nodeType === u.NodeType.DocumentType) throw new c.HierarchyRequestError("Cannot insert an element node before a document type node. Node is " + X.nodeName + ".");
              Wt = Wt._nextSibling;
            }
          } else if (X._nodeType === u.NodeType.DocumentType) {
            try {
              for (var Tt = r(C._children), Q = Tt.next(); !Q.done; Q = Tt.next()) {
                var D;
                if ((D = Q.value)._nodeType === u.NodeType.DocumentType && D !== V) throw new c.HierarchyRequestError("Document already has a document type node. Node is " + X.nodeName + ".");
              }
            } catch (ht) {
              B = { error: ht };
            } finally {
              try {
                Q && !Q.done && ($ = Tt.return) && $.call(Tt);
              } finally {
                if (B) throw B.error;
              }
            }
            for (var q = V._previousSibling; q; ) {
              if (q._nodeType === u.NodeType.Element) throw new c.HierarchyRequestError("Cannot insert a document type node before an element node. Node is " + X.nodeName + ".");
              q = q._previousSibling;
            }
          }
        }
        var nt = V._nextSibling;
        nt === X && (nt = X._nextSibling);
        var et = V._previousSibling;
        T.document_adopt(X, C._nodeDocument);
        var ot = [];
        V._parent !== null && (ot.push(V), x(V, V._parent, !0));
        var it = [];
        return X._nodeType === u.NodeType.DocumentFragment ? it = Array.from(X._children) : it.push(X), W(X, C, nt, !0), l.dom.features.mutationObservers && g.observer_queueTreeMutationRecord(C, it, ot, et, nt), V;
      }, n.mutation_replaceAll = function(V, X) {
        var C, R;
        V !== null && T.document_adopt(V, X._nodeDocument);
        var z = Array.from(X._children), F = [];
        V && V._nodeType === u.NodeType.DocumentFragment ? F = Array.from(V._children) : V !== null && F.push(V);
        try {
          for (var P = r(z), j = P.next(); !j.done; j = P.next())
            x(j.value, X, !0);
        } catch (H) {
          C = { error: H };
        } finally {
          try {
            j && !j.done && (R = P.return) && R.call(P);
          } finally {
            if (C) throw C.error;
          }
        }
        V !== null && W(V, X, null, !0), l.dom.features.mutationObservers && g.observer_queueTreeMutationRecord(X, F, z, null, null);
      }, n.mutation_preRemove = function(V, X) {
        if (V._parent !== X) throw new c.NotFoundError("The child node cannot be found under parent node. Child node is " + V.nodeName + ", parent node is " + X.nodeName + ".");
        return x(V, X), V;
      }, n.mutation_remove = x;
    }, function(e, n, s) {
      function r(a) {
        return a == null;
      }
      e.exports.isNothing = r, e.exports.isObject = function(a) {
        return typeof a == "object" && a !== null;
      }, e.exports.toArray = function(a) {
        return Array.isArray(a) ? a : r(a) ? [] : [a];
      }, e.exports.repeat = function(a, o) {
        var l, c = "";
        for (l = 0; l < o; l += 1) c += a;
        return c;
      }, e.exports.isNegativeZero = function(a) {
        return a === 0 && Number.NEGATIVE_INFINITY === 1 / a;
      }, e.exports.extend = function(a, o) {
        var l, c, u, d;
        if (o) for (l = 0, c = (d = Object.keys(o)).length; l < c; l += 1) a[u = d[l]] = o[u];
        return a;
      };
    }, function(e, n, s) {
      var r = s(38), a = s(53), o = s(10);
      function l(u, d, h) {
        var p = [];
        return u.include.forEach((function(m) {
          h = l(m, d, h);
        })), u[d].forEach((function(m) {
          h.forEach((function(b, y) {
            b.tag === m.tag && b.kind === m.kind && p.push(y);
          })), h.push(m);
        })), h.filter((function(m, b) {
          return p.indexOf(b) === -1;
        }));
      }
      function c(u) {
        this.include = u.include || [], this.implicit = u.implicit || [], this.explicit = u.explicit || [], this.implicit.forEach((function(d) {
          if (d.loadKind && d.loadKind !== "scalar") throw new a("There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.");
        })), this.compiledImplicit = l(this, "implicit", []), this.compiledExplicit = l(this, "explicit", []), this.compiledTypeMap = (function() {
          var d, h, p = { scalar: {}, sequence: {}, mapping: {}, fallback: {} };
          function m(b) {
            p[b.kind][b.tag] = p.fallback[b.tag] = b;
          }
          for (d = 0, h = arguments.length; d < h; d += 1) arguments[d].forEach(m);
          return p;
        })(this.compiledImplicit, this.compiledExplicit);
      }
      c.DEFAULT = null, c.create = function() {
        var u, d;
        switch (arguments.length) {
          case 1:
            u = c.DEFAULT, d = arguments[0];
            break;
          case 2:
            u = arguments[0], d = arguments[1];
            break;
          default:
            throw new a("Wrong number of arguments for Schema.create function");
        }
        if (u = r.toArray(u), d = r.toArray(d), !u.every((function(h) {
          return h instanceof c;
        }))) throw new a("Specified list of super schemas (or a single Schema object) contains a non-Schema object.");
        if (!d.every((function(h) {
          return h instanceof o;
        }))) throw new a("Specified list of YAML types (or a single Type object) contains a non-Type object.");
        return new c({ include: u, explicit: d });
      }, e.exports = c;
    }, function(e, n) {
      e.exports = function(s, r) {
        return { enumerable: !(1 & s), configurable: !(2 & s), writable: !(4 & s), value: r };
      };
    }, function(e, n, s) {
      var r = s(8), a = s(42), o = "".split;
      e.exports = r((function() {
        return !Object("z").propertyIsEnumerable(0);
      })) ? function(l) {
        return a(l) == "String" ? o.call(l, "") : Object(l);
      } : Object;
    }, function(e, n) {
      var s = {}.toString;
      e.exports = function(r) {
        return s.call(r).slice(8, -1);
      };
    }, function(e, n, s) {
      var r, a, o, l = s(186), c = s(11), u = s(13), d = s(21), h = s(14), p = s(57), m = s(45), b = c.WeakMap;
      if (l) {
        var y = new b(), Z = y.get, g = y.has, f = y.set;
        r = function(M, N) {
          return f.call(y, M, N), N;
        }, a = function(M) {
          return Z.call(y, M) || {};
        }, o = function(M) {
          return g.call(y, M);
        };
      } else {
        var T = p("state");
        m[T] = !0, r = function(M, N) {
          return d(M, T, N), N;
        }, a = function(M) {
          return h(M, T) ? M[T] : {};
        }, o = function(M) {
          return h(M, T);
        };
      }
      e.exports = { set: r, get: a, has: o, enforce: function(M) {
        return o(M) ? a(M) : r(M, {});
      }, getterFor: function(M) {
        return function(N) {
          var W;
          if (!u(N) || (W = a(N)).type !== M) throw TypeError("Incompatible receiver, " + M + " required");
          return W;
        };
      } };
    }, function(e, n) {
      e.exports = !1;
    }, function(e, n) {
      e.exports = {};
    }, function(e, n, s) {
      var r = s(120), a = s(11), o = function(l) {
        return typeof l == "function" ? l : void 0;
      };
      e.exports = function(l, c) {
        return arguments.length < 2 ? o(r[l]) || o(a[l]) : r[l] && r[l][c] || a[l] && a[l][c];
      };
    }, function(e, n) {
      var s = Math.ceil, r = Math.floor;
      e.exports = function(a) {
        return isNaN(a = +a) ? 0 : (a > 0 ? r : s)(a);
      };
    }, function(e, n, s) {
      var r = s(8);
      e.exports = function(a, o) {
        var l = [][a];
        return !!l && r((function() {
          l.call(null, o || function() {
            throw 1;
          }, 1);
        }));
      };
    }, function(e, n) {
      e.exports = {};
    }, function(e, n, s) {
      s(31), s(32), s(33), s(220), s(64), s(19), s(65), s(20), s(68), s(66), s(92), s(144), s(22), s(94), s(23);
      var r = this && this.__values || function(m) {
        var b = typeof Symbol == "function" && Symbol.iterator, y = b && m[b], Z = 0;
        if (y) return y.call(m);
        if (m && typeof m.length == "number") return { next: function() {
          return m && Z >= m.length && (m = void 0), { value: m && m[Z++], done: !m };
        } };
        throw new TypeError(b ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }, a = this && this.__read || function(m, b) {
        var y = typeof Symbol == "function" && m[Symbol.iterator];
        if (!y) return m;
        var Z, g, f = y.call(m), T = [];
        try {
          for (; (b === void 0 || b-- > 0) && !(Z = f.next()).done; ) T.push(Z.value);
        } catch (M) {
          g = { error: M };
        } finally {
          try {
            Z && !Z.done && (y = f.return) && y.call(f);
          } finally {
            if (g) throw g.error;
          }
        }
        return T;
      }, o = this && this.__spread || function() {
        for (var m = [], b = 0; b < arguments.length; b++) m = m.concat(a(arguments[b]));
        return m;
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var l = s(2), c = s(69), u = s(95), d = s(7), h = s(0), p = (function() {
        function m(b) {
          this.level = 0, this._builderOptions = b;
        }
        return m.prototype.declaration = function(b, y, Z) {
        }, m.prototype.docType = function(b, y, Z) {
        }, m.prototype.comment = function(b) {
        }, m.prototype.text = function(b) {
        }, m.prototype.instruction = function(b, y) {
        }, m.prototype.cdata = function(b) {
        }, m.prototype.openTagBegin = function(b) {
        }, m.prototype.openTagEnd = function(b, y, Z) {
        }, m.prototype.closeTag = function(b) {
        }, m.prototype.attributes = function(b) {
          var y, Z;
          try {
            for (var g = r(b), f = g.next(); !f.done; f = g.next()) {
              var T = f.value;
              this.attribute(T[1] === null ? T[2] : T[1] + ":" + T[2], T[3]);
            }
          } catch (M) {
            y = { error: M };
          } finally {
            try {
              f && !f.done && (Z = g.return) && Z.call(g);
            } finally {
              if (y) throw y.error;
            }
          }
        }, m.prototype.attribute = function(b, y) {
        }, m.prototype.beginElement = function(b) {
        }, m.prototype.endElement = function(b) {
        }, m.prototype.serializeNode = function(b, y) {
          var Z = b._nodeDocument !== void 0 && b._nodeDocument._hasNamespaces;
          if (this.level = 0, this.currentNode = b, Z) {
            var g = new u.NamespacePrefixMap();
            g.set("xml", d.namespace.XML), this._serializeNodeNS(b, null, g, { value: 1 }, y);
          } else this._serializeNode(b, y);
        }, m.prototype._serializeNodeNS = function(b, y, Z, g, f) {
          switch (this.currentNode = b, b.nodeType) {
            case l.NodeType.Element:
              this._serializeElementNS(b, y, Z, g, f);
              break;
            case l.NodeType.Document:
              this._serializeDocumentNS(b, y, Z, g, f);
              break;
            case l.NodeType.Comment:
              this._serializeComment(b, f);
              break;
            case l.NodeType.Text:
              this._serializeText(b, f);
              break;
            case l.NodeType.DocumentFragment:
              this._serializeDocumentFragmentNS(b, y, Z, g, f);
              break;
            case l.NodeType.DocumentType:
              this._serializeDocumentType(b, f);
              break;
            case l.NodeType.ProcessingInstruction:
              this._serializeProcessingInstruction(b, f);
              break;
            case l.NodeType.CData:
              this._serializeCData(b, f);
              break;
            default:
              throw new Error("Unknown node type: " + b.nodeType);
          }
        }, m.prototype._serializeNode = function(b, y) {
          switch (this.currentNode = b, b.nodeType) {
            case l.NodeType.Element:
              this._serializeElement(b, y);
              break;
            case l.NodeType.Document:
              this._serializeDocument(b, y);
              break;
            case l.NodeType.Comment:
              this._serializeComment(b, y);
              break;
            case l.NodeType.Text:
              this._serializeText(b, y);
              break;
            case l.NodeType.DocumentFragment:
              this._serializeDocumentFragment(b, y);
              break;
            case l.NodeType.DocumentType:
              this._serializeDocumentType(b, y);
              break;
            case l.NodeType.ProcessingInstruction:
              this._serializeProcessingInstruction(b, y);
              break;
            case l.NodeType.CData:
              this._serializeCData(b, y);
              break;
            default:
              throw new Error("Unknown node type: " + b.nodeType);
          }
        }, m.prototype._serializeElementNS = function(b, y, Z, g, f) {
          var T, M, N = [];
          if (f && (b.localName.indexOf(":") !== -1 || !h.xml_isName(b.localName))) throw new Error("Node local name contains invalid characters (well-formed required).");
          var W = "", x = !1, V = !1, X = Z.copy(), C = {}, R = this._recordNamespaceInformation(b, X, C), z = y, F = b.namespaceURI;
          if (z === F) R !== null && (V = !0), W = F === d.namespace.XML ? "xml:" + b.localName : b.localName, this.beginElement(W), this.openTagBegin(W);
          else {
            var P = b.prefix, j = null;
            if (P === null && F === R || (j = X.get(P, F)), P === "xmlns") {
              if (f) throw new Error("An element cannot have the 'xmlns' prefix (well-formed required).");
              j = P;
            }
            j !== null ? (W = j + ":" + b.localName, R !== null && R !== d.namespace.XML && (z = R || null), this.beginElement(W), this.openTagBegin(W)) : P !== null ? (P in C && (P = this._generatePrefix(F, X, g)), X.set(P, F), W += P + ":" + b.localName, this.beginElement(W), this.openTagBegin(W), N.push([null, "xmlns", P, this._serializeAttributeValue(F, f)]), R !== null && (z = R || null)) : R === null || R !== null && R !== F ? (V = !0, W += b.localName, z = F, this.beginElement(W), this.openTagBegin(W), N.push([null, null, "xmlns", this._serializeAttributeValue(F, f)])) : (W += b.localName, z = F, this.beginElement(W), this.openTagBegin(W));
          }
          N.push.apply(N, o(this._serializeAttributesNS(b, X, g, C, V, f))), this.attributes(N);
          var H = F === d.namespace.HTML;
          if (H && b.childNodes.length === 0 && m._VoidElementNames.has(b.localName) ? (this.openTagEnd(W, !0, !0), this.endElement(W), x = !0) : H || b.childNodes.length !== 0 ? this.openTagEnd(W, !1, !1) : (this.openTagEnd(W, !0, !1), this.endElement(W), x = !0), !x) {
            if (!(H && b.localName === "template")) try {
              for (var B = r(b.childNodes), $ = B.next(); !$.done; $ = B.next()) {
                var A = $.value;
                this.level++, this._serializeNodeNS(A, z, X, g, f), this.level--;
              }
            } catch (E) {
              T = { error: E };
            } finally {
              try {
                $ && !$.done && (M = B.return) && M.call(B);
              } finally {
                if (T) throw T.error;
              }
            }
            this.closeTag(W), this.endElement(W);
          }
        }, m.prototype._serializeElement = function(b, y) {
          var Z, g;
          if (y && (b.localName.indexOf(":") !== -1 || !h.xml_isName(b.localName))) throw new Error("Node local name contains invalid characters (well-formed required).");
          var f = !1, T = b.localName;
          this.beginElement(T), this.openTagBegin(T);
          var M = this._serializeAttributes(b, y);
          if (this.attributes(M), b.hasChildNodes() ? this.openTagEnd(T, !1, !1) : (this.openTagEnd(T, !0, !1), this.endElement(T), f = !0), !f) {
            try {
              for (var N = r(b._children), W = N.next(); !W.done; W = N.next()) {
                var x = W.value;
                this.level++, this._serializeNode(x, y), this.level--;
              }
            } catch (V) {
              Z = { error: V };
            } finally {
              try {
                W && !W.done && (g = N.return) && g.call(N);
              } finally {
                if (Z) throw Z.error;
              }
            }
            this.closeTag(T), this.endElement(T);
          }
        }, m.prototype._serializeDocumentNS = function(b, y, Z, g, f) {
          var T, M;
          if (f && b.documentElement === null) throw new Error("Missing document element (well-formed required).");
          try {
            for (var N = r(b.childNodes), W = N.next(); !W.done; W = N.next()) {
              var x = W.value;
              this._serializeNodeNS(x, y, Z, g, f);
            }
          } catch (V) {
            T = { error: V };
          } finally {
            try {
              W && !W.done && (M = N.return) && M.call(N);
            } finally {
              if (T) throw T.error;
            }
          }
        }, m.prototype._serializeDocument = function(b, y) {
          var Z, g;
          if (y && b.documentElement === null) throw new Error("Missing document element (well-formed required).");
          try {
            for (var f = r(b._children), T = f.next(); !T.done; T = f.next()) {
              var M = T.value;
              this._serializeNode(M, y);
            }
          } catch (N) {
            Z = { error: N };
          } finally {
            try {
              T && !T.done && (g = f.return) && g.call(f);
            } finally {
              if (Z) throw Z.error;
            }
          }
        }, m.prototype._serializeComment = function(b, y) {
          if (y && (!h.xml_isLegalChar(b.data) || b.data.indexOf("--") !== -1 || b.data.endsWith("-"))) throw new Error("Comment data contains invalid characters (well-formed required).");
          this.comment(b.data);
        }, m.prototype._serializeText = function(b, y) {
          if (y && !h.xml_isLegalChar(b.data)) throw new Error("Text data contains invalid characters (well-formed required).");
          var Z = b.data.replace(/(?!&([^&;]*);)&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
          this.text(Z);
        }, m.prototype._serializeDocumentFragmentNS = function(b, y, Z, g, f) {
          var T, M;
          try {
            for (var N = r(b.childNodes), W = N.next(); !W.done; W = N.next()) {
              var x = W.value;
              this._serializeNodeNS(x, y, Z, g, f);
            }
          } catch (V) {
            T = { error: V };
          } finally {
            try {
              W && !W.done && (M = N.return) && M.call(N);
            } finally {
              if (T) throw T.error;
            }
          }
        }, m.prototype._serializeDocumentFragment = function(b, y) {
          var Z, g;
          try {
            for (var f = r(b._children), T = f.next(); !T.done; T = f.next()) {
              var M = T.value;
              this._serializeNode(M, y);
            }
          } catch (N) {
            Z = { error: N };
          } finally {
            try {
              T && !T.done && (g = f.return) && g.call(f);
            } finally {
              if (Z) throw Z.error;
            }
          }
        }, m.prototype._serializeDocumentType = function(b, y) {
          if (y && !h.xml_isPubidChar(b.publicId)) throw new Error("DocType public identifier does not match PubidChar construct (well-formed required).");
          if (y && (!h.xml_isLegalChar(b.systemId) || b.systemId.indexOf('"') !== -1 && b.systemId.indexOf("'") !== -1)) throw new Error("DocType system identifier contains invalid characters (well-formed required).");
          this.docType(b.name, b.publicId, b.systemId);
        }, m.prototype._serializeProcessingInstruction = function(b, y) {
          if (y && (b.target.indexOf(":") !== -1 || /^xml$/i.test(b.target))) throw new Error("Processing instruction target contains invalid characters (well-formed required).");
          if (y && (!h.xml_isLegalChar(b.data) || b.data.indexOf("?>") !== -1)) throw new Error("Processing instruction data contains invalid characters (well-formed required).");
          this.instruction(b.target, b.data);
        }, m.prototype._serializeCData = function(b, y) {
          if (y && b.data.indexOf("]]>") !== -1) throw new Error("CDATA contains invalid characters (well-formed required).");
          this.cdata(b.data);
        }, m.prototype._serializeAttributesNS = function(b, y, Z, g, f, T) {
          var M, N, W = [], x = T ? new c.LocalNameSet() : void 0;
          try {
            for (var V = r(b.attributes), X = V.next(); !X.done; X = V.next()) {
              var C = X.value;
              if (T || f || C.namespaceURI !== null) {
                if (T && x && x.has(C.namespaceURI, C.localName)) throw new Error("Element contains duplicate attributes (well-formed required).");
                T && x && x.set(C.namespaceURI, C.localName);
                var R = C.namespaceURI, z = null;
                if (R !== null) if (z = y.get(C.prefix, R), R === d.namespace.XMLNS) {
                  if (C.value === d.namespace.XML || C.prefix === null && f || C.prefix !== null && (!(C.localName in g) || g[C.localName] !== C.value) && y.has(C.localName, C.value)) continue;
                  if (T && C.value === d.namespace.XMLNS) throw new Error("XMLNS namespace is reserved (well-formed required).");
                  if (T && C.value === "") throw new Error("Namespace prefix declarations cannot be used to undeclare a namespace (well-formed required).");
                  C.prefix === "xmlns" && (z = "xmlns");
                } else z === null && (z = C.prefix === null || y.hasPrefix(C.prefix) && !y.has(C.prefix, R) ? this._generatePrefix(R, y, Z) : C.prefix, W.push([null, "xmlns", z, this._serializeAttributeValue(R, T)]));
                if (T && (C.localName.indexOf(":") !== -1 || !h.xml_isName(C.localName) || C.localName === "xmlns" && R === null)) throw new Error("Attribute local name contains invalid characters (well-formed required).");
                W.push([R, z, C.localName, this._serializeAttributeValue(C.value, T)]);
              } else W.push([null, null, C.localName, this._serializeAttributeValue(C.value, T)]);
            }
          } catch (F) {
            M = { error: F };
          } finally {
            try {
              X && !X.done && (N = V.return) && N.call(V);
            } finally {
              if (M) throw M.error;
            }
          }
          return W;
        }, m.prototype._serializeAttributes = function(b, y) {
          var Z, g, f = [], T = y ? {} : void 0;
          try {
            for (var M = r(b.attributes), N = M.next(); !N.done; N = M.next()) {
              var W = N.value;
              if (y) {
                if (y && T && W.localName in T) throw new Error("Element contains duplicate attributes (well-formed required).");
                if (y && T && (T[W.localName] = !0), y && (W.localName.indexOf(":") !== -1 || !h.xml_isName(W.localName))) throw new Error("Attribute local name contains invalid characters (well-formed required).");
                f.push([null, null, W.localName, this._serializeAttributeValue(W.value, y)]);
              } else f.push([null, null, W.localName, this._serializeAttributeValue(W.value, y)]);
            }
          } catch (x) {
            Z = { error: x };
          } finally {
            try {
              N && !N.done && (g = M.return) && g.call(M);
            } finally {
              if (Z) throw Z.error;
            }
          }
          return f;
        }, m.prototype._recordNamespaceInformation = function(b, y, Z) {
          var g, f, T = null;
          try {
            for (var M = r(b.attributes), N = M.next(); !N.done; N = M.next()) {
              var W = N.value, x = W.namespaceURI, V = W.prefix;
              if (x === d.namespace.XMLNS) {
                if (V === null) {
                  T = W.value;
                  continue;
                }
                var X = W.localName, C = W.value;
                if (C === d.namespace.XML || (C === "" && (C = null), y.has(X, C))) continue;
                y.set(X, C), Z[X] = C || "";
              }
            }
          } catch (R) {
            g = { error: R };
          } finally {
            try {
              N && !N.done && (f = M.return) && f.call(M);
            } finally {
              if (g) throw g.error;
            }
          }
          return T;
        }, m.prototype._generatePrefix = function(b, y, Z) {
          var g = "ns" + Z.value.toString();
          return Z.value++, y.set(g, b), g;
        }, m.prototype._serializeAttributeValue = function(b, y) {
          if (y && b !== null && !h.xml_isLegalChar(b)) throw new Error("Invalid characters in attribute value.");
          return b === null ? "" : b.replace(/(?!&([^&;]*);)&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
        }, m._VoidElementNames = /* @__PURE__ */ new Set(["area", "base", "basefont", "bgsound", "br", "col", "embed", "frame", "hr", "img", "input", "keygen", "link", "menuitem", "meta", "param", "source", "track", "wbr"]), m;
      })();
      n.BaseWriter = p;
    }, function(e, n, s) {
      var r = this && this.__values || function(y) {
        var Z = typeof Symbol == "function" && Symbol.iterator, g = Z && y[Z], f = 0;
        if (g) return g.call(y);
        if (y && typeof y.length == "number") return { next: function() {
          return y && f >= y.length && (y = void 0), { value: y && y[f++], done: !y };
        } };
        throw new TypeError(Z ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }, a = this && this.__read || function(y, Z) {
        var g = typeof Symbol == "function" && y[Symbol.iterator];
        if (!g) return y;
        var f, T, M = g.call(y), N = [];
        try {
          for (; (Z === void 0 || Z-- > 0) && !(f = M.next()).done; ) N.push(f.value);
        } catch (W) {
          T = { error: W };
        } finally {
          try {
            f && !f.done && (g = M.return) && g.call(M);
          } finally {
            if (T) throw T.error;
          }
        }
        return N;
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(6), l = s(3), c = s(7), u = s(29), d = s(17), h = s(97);
      function p() {
        var y = o.dom.window;
        y._mutationObserverMicrotaskQueued || (y._mutationObserverMicrotaskQueued = !0, Promise.resolve().then((function() {
          m();
        })));
      }
      function m() {
        var y, Z, g, f, T = o.dom.window;
        T._mutationObserverMicrotaskQueued = !1;
        var M = c.set.clone(T._mutationObservers), N = c.set.clone(T._signalSlots);
        c.set.empty(T._signalSlots);
        var W = function(z) {
          var F = c.list.clone(z._recordQueue);
          c.list.empty(z._recordQueue);
          for (var P = 0; P < z._nodeList.length; P++) {
            var j = z._nodeList[P];
            c.list.remove(j._registeredObserverList, (function(H) {
              return l.Guard.isTransientRegisteredObserver(H) && H.observer === z;
            }));
          }
          if (!c.list.isEmpty(F)) try {
            z._callback.call(z, F, z);
          } catch {
          }
        };
        try {
          for (var x = r(M), V = x.next(); !V.done; V = x.next())
            W(V.value);
        } catch (z) {
          y = { error: z };
        } finally {
          try {
            V && !V.done && (Z = x.return) && Z.call(x);
          } finally {
            if (y) throw y.error;
          }
        }
        if (o.dom.features.slots) try {
          for (var X = r(N), C = X.next(); !C.done; C = X.next()) {
            var R = C.value;
            h.event_fireAnEvent("slotchange", R, void 0, { bubbles: !0 });
          }
        } catch (z) {
          g = { error: z };
        } finally {
          try {
            C && !C.done && (f = X.return) && f.call(X);
          } finally {
            if (g) throw g.error;
          }
        }
      }
      function b(y, Z, g, f, T, M, N, W, x) {
        for (var V, X, C = /* @__PURE__ */ new Map(), R = d.tree_getFirstAncestorNode(Z, !0); R !== null; ) {
          for (var z = 0; z < R._registeredObserverList.length; z++) {
            var F = R._registeredObserverList[z], P = F.options;
            if ((R === Z || P.subtree) && (y !== "attributes" || P.attributes) && (y !== "attributes" || !P.attributeFilter || P.attributeFilter.indexOf(g || "") && f === null) && (y !== "characterData" || P.characterData) && (y !== "childList" || P.childList)) {
              var j = F.observer;
              C.has(j) || C.set(j, null), (y === "attributes" && P.attributeOldValue || y === "characterData" && P.characterDataOldValue) && C.set(j, T);
            }
          }
          R = d.tree_getNextAncestorNode(Z, R, !0);
        }
        try {
          for (var H = r(C), B = H.next(); !B.done; B = H.next()) {
            var $ = a(B.value, 2), A = $[0], E = $[1], ct = u.create_mutationRecord(y, Z, u.create_nodeListStatic(Z, M), u.create_nodeListStatic(Z, N), W, x, g, f, E);
            A._recordQueue.push(ct);
          }
        } catch (at) {
          V = { error: at };
        } finally {
          try {
            B && !B.done && (X = H.return) && X.call(H);
          } finally {
            if (V) throw V.error;
          }
        }
        p();
      }
      n.observer_queueAMutationObserverMicrotask = p, n.observer_notifyMutationObservers = m, n.observer_queueMutationRecord = b, n.observer_queueTreeMutationRecord = function(y, Z, g, f, T) {
        b("childList", y, null, null, null, Z, g, f, T);
      }, n.observer_queueAttributeMutationRecord = function(y, Z, g, f) {
        b("attributes", y, Z, g, f, [], [], null, null);
      };
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(6), a = s(7), o = s(3), l = s(9), c = s(29), u = s(73), d = s(51), h = s(30), p = s(37), m = s(106);
      function b(M, N, W) {
        r.dom.features.mutationObservers && d.observer_queueAttributeMutationRecord(N, M._localName, M._namespace, M._value), r.dom.features.customElements && o.Guard.isCustomElementNode(N) && u.customElement_enqueueACustomElementCallbackReaction(N, "attributeChangedCallback", [M._localName, M._value, W, M._namespace]), r.dom.features.steps && h.dom_runAttributeChangeSteps(N, M._localName, M._value, W, M._namespace), M._value = W;
      }
      function y(M, N) {
        r.dom.features.mutationObservers && d.observer_queueAttributeMutationRecord(N, M._localName, M._namespace, null), r.dom.features.customElements && o.Guard.isCustomElementNode(N) && u.customElement_enqueueACustomElementCallbackReaction(N, "attributeChangedCallback", [M._localName, null, M._value, M._namespace]), r.dom.features.steps && h.dom_runAttributeChangeSteps(N, M._localName, null, M._value, M._namespace), N._attributeList._asArray().push(M), M._element = N, N._nodeDocument._hasNamespaces || M._namespace === null && M._namespacePrefix === null && M._localName !== "xmlns" || (N._nodeDocument._hasNamespaces = !0);
      }
      function Z(M, N) {
        r.dom.features.mutationObservers && d.observer_queueAttributeMutationRecord(N, M._localName, M._namespace, M._value), r.dom.features.customElements && o.Guard.isCustomElementNode(N) && u.customElement_enqueueACustomElementCallbackReaction(N, "attributeChangedCallback", [M._localName, M._value, null, M._namespace]), r.dom.features.steps && h.dom_runAttributeChangeSteps(N, M._localName, M._value, null, M._namespace);
        var W = N._attributeList._asArray().indexOf(M);
        N._attributeList._asArray().splice(W, 1), M._element = null;
      }
      function g(M, N, W) {
        r.dom.features.mutationObservers && d.observer_queueAttributeMutationRecord(W, M._localName, M._namespace, M._value), r.dom.features.customElements && o.Guard.isCustomElementNode(W) && u.customElement_enqueueACustomElementCallbackReaction(W, "attributeChangedCallback", [M._localName, M._value, N._value, M._namespace]), r.dom.features.steps && h.dom_runAttributeChangeSteps(W, M._localName, M._value, N._value, M._namespace);
        var x = W._attributeList._asArray().indexOf(M);
        x !== -1 && (W._attributeList._asArray()[x] = N), M._element = null, N._element = W, W._nodeDocument._hasNamespaces || N._namespace === null && N._namespacePrefix === null && N._localName !== "xmlns" || (W._nodeDocument._hasNamespaces = !0);
      }
      function f(M, N) {
        return N._namespace === a.namespace.HTML && N._nodeDocument._type === "html" && (M = M.toLowerCase()), N._attributeList._asArray().find((function(W) {
          return W._qualifiedName === M;
        })) || null;
      }
      function T(M, N, W) {
        var x = M || null;
        return W._attributeList._asArray().find((function(V) {
          return V._namespace === x && V._localName === N;
        })) || null;
      }
      n.element_has = function(M, N) {
        return N._attributeList._asArray().indexOf(M) !== -1;
      }, n.element_change = b, n.element_append = y, n.element_remove = Z, n.element_replace = g, n.element_getAnAttributeByName = f, n.element_getAnAttributeByNamespaceAndLocalName = T, n.element_getAnAttributeValue = function(M, N, W) {
        W === void 0 && (W = "");
        var x = T(W, N, M);
        return x === null ? "" : x._value;
      }, n.element_setAnAttribute = function(M, N) {
        if (M._element !== null && M._element !== N) throw new l.InUseAttributeError("This attribute already exists in the document: " + M._qualifiedName + " as a child of " + M._element._qualifiedName + ".");
        var W = T(M._namespace || "", M._localName, N);
        return W === M ? M : (W !== null ? g(W, M, N) : y(M, N), W);
      }, n.element_setAnAttributeValue = function(M, N, W, x, V) {
        x === void 0 && (x = null), V === void 0 && (V = null);
        var X = T(V || "", N, M);
        if (X === null) {
          var C = c.create_attr(M._nodeDocument, N);
          return C._namespace = V, C._namespacePrefix = x, C._value = W, void y(C, M);
        }
        b(X, M, W);
      }, n.element_removeAnAttributeByName = function(M, N) {
        var W = f(M, N);
        return W !== null && Z(W, N), W;
      }, n.element_removeAnAttributeByNamespaceAndLocalName = function(M, N, W) {
        var x = T(M, N, W);
        return x !== null && Z(x, W), x;
      }, n.element_createAnElement = function(M, N, W, x, V, X) {
        x === void 0 && (x = null), V === void 0 && (V = null), X === void 0 && (X = !1);
        var C = null;
        if (!r.dom.features.customElements) return (C = c.create_element(M, N, W, x))._customElementState = "uncustomized", C._customElementDefinition = null, C._is = V, C;
        var R = u.customElement_lookUpACustomElementDefinition(M, W, N, V);
        if (R !== null && R.name !== R.localName) (C = new (m.document_elementInterface(N, a.namespace.HTML))())._localName = N, C._namespace = a.namespace.HTML, C._namespacePrefix = x, C._customElementState = "undefined", C._customElementDefinition = null, C._is = V, C._nodeDocument = M, X ? u.customElement_upgrade(R, C) : u.customElement_enqueueACustomElementUpgradeReaction(C, R);
        else if (R !== null) if (X) try {
          var z = new R.constructor();
          if (console.assert(z._customElementState !== void 0), console.assert(z._customElementDefinition !== void 0), console.assert(z._namespace === a.namespace.HTML), z._attributeList.length !== 0) throw new l.NotSupportedError("Custom element already has attributes.");
          if (z._children.size !== 0) throw new l.NotSupportedError("Custom element already has child nodes.");
          if (z._parent !== null) throw new l.NotSupportedError("Custom element already has a parent node.");
          if (z._nodeDocument !== M) throw new l.NotSupportedError("Custom element is already in a document.");
          if (z._localName !== N) throw new l.NotSupportedError("Custom element has a different local name.");
          z._namespacePrefix = x, z._is = null;
        } catch {
          (C = c.create_htmlUnknownElement(M, N, a.namespace.HTML, x))._customElementState = "failed", C._customElementDefinition = null, C._is = null;
        }
        else (C = c.create_htmlElement(M, N, a.namespace.HTML, x))._customElementState = "undefined", C._customElementDefinition = null, C._is = null, u.customElement_enqueueACustomElementUpgradeReaction(C, R);
        else
          (C = new (m.document_elementInterface(N, W))())._localName = N, C._namespace = W, C._namespacePrefix = x, C._customElementState = "uncustomized", C._customElementDefinition = null, C._is = V, C._nodeDocument = M, W !== a.namespace.HTML || V === null && !u.customElement_isValidCustomElementName(N) || (C._customElementState = "undefined");
        if (C === null) throw new Error("Unable to create element.");
        return C;
      }, n.element_insertAdjacent = function(M, N, W) {
        switch (N.toLowerCase()) {
          case "beforebegin":
            return M._parent === null ? null : p.mutation_preInsert(W, M._parent, M);
          case "afterbegin":
            return p.mutation_preInsert(W, M, M._firstChild);
          case "beforeend":
            return p.mutation_preInsert(W, M, null);
          case "afterend":
            return M._parent === null ? null : p.mutation_preInsert(W, M._parent, M._nextSibling);
          default:
            throw new l.SyntaxError(`Invalid 'where' argument. "beforebegin", "afterbegin", "beforeend" or "afterend" expected`);
        }
      };
    }, function(e, n, s) {
      function r(a, o) {
        Error.call(this), this.name = "YAMLException", this.reason = a, this.mark = o, this.message = (this.reason || "(unknown reason)") + (this.mark ? " " + this.mark.toString() : ""), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack || "";
      }
      r.prototype = Object.create(Error.prototype), r.prototype.constructor = r, r.prototype.toString = function(a) {
        var o = this.name + ": ";
        return o += this.reason || "(unknown reason)", !a && this.mark && (o += " " + this.mark.toString()), o;
      }, e.exports = r;
    }, function(e, n, s) {
      var r = s(39);
      e.exports = new r({ include: [s(181)], implicit: [s(293), s(294)], explicit: [s(295), s(296), s(297), s(298)] });
    }, function(e, n, s) {
      var r = s(16), a = s(79), o = s(40), l = s(24), c = s(56), u = s(14), d = s(115), h = Object.getOwnPropertyDescriptor;
      n.f = r ? h : function(p, m) {
        if (p = l(p), m = c(m, !0), d) try {
          return h(p, m);
        } catch {
        }
        if (u(p, m)) return o(!a.f.call(p, m), p[m]);
      };
    }, function(e, n, s) {
      var r = s(13);
      e.exports = function(a, o) {
        if (!r(a)) return a;
        var l, c;
        if (o && typeof (l = a.toString) == "function" && !r(c = l.call(a)) || typeof (l = a.valueOf) == "function" && !r(c = l.call(a)) || !o && typeof (l = a.toString) == "function" && !r(c = l.call(a))) return c;
        throw TypeError("Can't convert object to primitive value");
      };
    }, function(e, n, s) {
      var r = s(81), a = s(58), o = r("keys");
      e.exports = function(l) {
        return o[l] || (o[l] = a(l));
      };
    }, function(e, n) {
      var s = 0, r = Math.random();
      e.exports = function(a) {
        return "Symbol(" + String(a === void 0 ? "" : a) + ")_" + (++s + r).toString(36);
      };
    }, function(e, n, s) {
      var r = s(42);
      e.exports = Array.isArray || function(a) {
        return r(a) == "Array";
      };
    }, function(e, n, s) {
      var r, a = s(18), o = s(188), l = s(84), c = s(45), u = s(189), d = s(116), h = s(57), p = h("IE_PROTO"), m = function() {
      }, b = function(Z) {
        return "<script>" + Z + "<\/script>";
      }, y = function() {
        try {
          r = document.domain && new ActiveXObject("htmlfile");
        } catch {
        }
        var Z, g;
        y = r ? (function(T) {
          T.write(b("")), T.close();
          var M = T.parentWindow.Object;
          return T = null, M;
        })(r) : ((g = d("iframe")).style.display = "none", u.appendChild(g), g.src = "javascript:", (Z = g.contentWindow.document).open(), Z.write(b("document.F=Object")), Z.close(), Z.F);
        for (var f = l.length; f--; ) delete y.prototype[l[f]];
        return y();
      };
      c[p] = !0, e.exports = Object.create || function(Z, g) {
        var f;
        return Z !== null ? (m.prototype = a(Z), f = new m(), m.prototype = null, f[p] = Z) : f = y(), g === void 0 ? f : o(f, g);
      };
    }, function(e, n, s) {
      var r = s(121), a = s(84);
      e.exports = Object.keys || function(o) {
        return r(o, a);
      };
    }, function(e, n, s) {
      var r = s(15).f, a = s(14), o = s(5)("toStringTag");
      e.exports = function(l, c, u) {
        l && !a(l = u ? l : l.prototype, o) && r(l, o, { configurable: !0, value: c });
      };
    }, function(e, n, s) {
      var r = s(8), a = s(5), o = s(129), l = a("species");
      e.exports = function(c) {
        return o >= 51 || !r((function() {
          var u = [];
          return (u.constructor = {})[l] = function() {
            return { foo: 1 };
          }, u[c](Boolean).foo !== 1;
        }));
      };
    }, function(e, n, s) {
      var r = s(4), a = s(122).indexOf, o = s(48), l = s(28), c = [].indexOf, u = !!c && 1 / [1].indexOf(1, -0) < 0, d = o("indexOf"), h = l("indexOf", { ACCESSORS: !0, 1: 0 });
      r({ target: "Array", proto: !0, forced: u || !d || !h }, { indexOf: function(p) {
        return u ? c.apply(this, arguments) || 0 : a(this, p, arguments.length > 1 ? arguments[1] : void 0);
      } });
    }, function(e, n, s) {
      var r = s(16), a = s(15).f, o = Function.prototype, l = o.toString, c = /^\s*function ([^ (]*)/;
      r && !("name" in o) && a(o, "name", { configurable: !0, get: function() {
        try {
          return l.call(this).match(c)[1];
        } catch {
          return "";
        }
      } });
    }, function(e, n, s) {
      var r = s(25), a = s(18), o = s(8), l = s(136), c = RegExp.prototype, u = c.toString, d = o((function() {
        return u.call({ source: "a", flags: "b" }) != "/a/b";
      })), h = u.name != "toString";
      (d || h) && r(RegExp.prototype, "toString", (function() {
        var p = a(this), m = String(p.source), b = p.flags;
        return "/" + m + "/" + String(b === void 0 && p instanceof RegExp && !("flags" in c) ? l.call(p) : b);
      }), { unsafe: !0 });
    }, function(e, n, s) {
      s(31), s(32), s(33), s(19), s(138), s(20), s(66), s(22), s(23);
      var r, a = this && this.__extends || (r = function(d, h) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, m) {
          p.__proto__ = m;
        } || function(p, m) {
          for (var b in m) m.hasOwnProperty(b) && (p[b] = m[b]);
        })(d, h);
      }, function(d, h) {
        function p() {
          this.constructor = d;
        }
        r(d, h), d.prototype = h === null ? Object.create(h) : (p.prototype = h.prototype, new p());
      }), o = this && this.__values || function(d) {
        var h = typeof Symbol == "function" && Symbol.iterator, p = h && d[h], m = 0;
        if (p) return p.call(d);
        if (d && typeof d.length == "number") return { next: function() {
          return d && m >= d.length && (d = void 0), { value: d && d[m++], done: !d };
        } };
        throw new TypeError(h ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var l = s(1), c = s(2), u = (function(d) {
        function h(p, m) {
          var b = d.call(this, p) || this;
          return b._writerOptions = l.applyDefaults(m, { format: "object", wellFormed: !1, group: !1, verbose: !1 }), b;
        }
        return a(h, d), h.prototype.serialize = function(p) {
          return this._currentList = [], this._currentIndex = 0, this._listRegister = [this._currentList], this.serializeNode(p, this._writerOptions.wellFormed), this._process(this._currentList, this._writerOptions);
        }, h.prototype._process = function(p, m) {
          var b, y, Z, g, f, T, M;
          if (p.length === 0) return {};
          for (var N = {}, W = !1, x = 0, V = 0, X = 0, C = 0, R = 0; R < p.length; R++) {
            var z = p[R];
            switch (Tt = Object.keys(z)[0]) {
              case "@":
                continue;
              case "#":
                x++;
                break;
              case "!":
                V++;
                break;
              case "?":
                X++;
                break;
              case "$":
                C++;
                break;
              default:
                N[Tt] ? W = !0 : N[Tt] = !0;
            }
          }
          var F = this._getAttrKey(), P = this._getNodeKey(c.NodeType.Text), j = this._getNodeKey(c.NodeType.Comment), H = this._getNodeKey(c.NodeType.ProcessingInstruction), B = this._getNodeKey(c.NodeType.CData);
          if (x === 1 && p.length === 1 && l.isString(p[0]["#"])) return p[0]["#"];
          if (W) {
            var $ = {};
            for (R = 0; R < p.length; R++)
              if (z = p[R], (Tt = Object.keys(z)[0]) === "@") {
                var A = z["@"];
                (Q = Object.keys(A)).length === 1 ? $[F + Q[0]] = A[Q[0]] : $[F] = z["@"];
              }
            var E = [];
            for (R = 0; R < p.length; R++)
              switch (z = p[R], Tt = Object.keys(z)[0]) {
                case "@":
                  break;
                case "#":
                  E.push(((b = {})[P] = z["#"], b));
                  break;
                case "!":
                  E.push(((y = {})[j] = z["!"], y));
                  break;
                case "?":
                  E.push(((Z = {})[H] = z["?"], Z));
                  break;
                case "$":
                  E.push(((g = {})[B] = z.$, g));
                  break;
                default:
                  if ((q = z)[Tt].length !== 0 && l.isArray(q[Tt][0])) {
                    for (var ct = [], at = q[Tt], dt = 0; dt < at.length; dt++) ct.push(this._process(at[dt], m));
                    E.push(((f = {})[Tt] = ct, f));
                  } else m.verbose ? E.push(((T = {})[Tt] = [this._process(q[Tt], m)], T)) : E.push(((M = {})[Tt] = this._process(q[Tt], m), M));
              }
            return $[P] = E, $;
          }
          var gt = 1, Wt = 1, Zt = 1, Gt = 1;
          for ($ = {}, R = 0; R < p.length; R++) {
            var Tt;
            switch (z = p[R], Tt = Object.keys(z)[0]) {
              case "@":
                A = z["@"];
                var Q = Object.keys(A);
                if (m.group && Q.length !== 1) $[F] = A;
                else for (var D in A) $[F + D] = A[D];
                break;
              case "#":
                gt = this._processSpecItem(z["#"], $, m.group, P, x, gt);
                break;
              case "!":
                Wt = this._processSpecItem(z["!"], $, m.group, j, V, Wt);
                break;
              case "?":
                Zt = this._processSpecItem(z["?"], $, m.group, H, X, Zt);
                break;
              case "$":
                Gt = this._processSpecItem(z.$, $, m.group, B, C, Gt);
                break;
              default:
                var q;
                if ((q = z)[Tt].length !== 0 && l.isArray(q[Tt][0])) {
                  ct = [], at = q[Tt];
                  for (var nt = 0; nt < at.length; nt++) ct.push(this._process(at[nt], m));
                  $[Tt] = ct;
                } else m.verbose ? $[Tt] = [this._process(q[Tt], m)] : $[Tt] = this._process(q[Tt], m);
            }
          }
          return $;
        }, h.prototype._processSpecItem = function(p, m, b, y, Z, g) {
          var f, T;
          if (!b && l.isArray(p) && Z + p.length > 2) try {
            for (var M = o(p), N = M.next(); !N.done; N = M.next()) {
              var W = N.value;
              m[y + (g++).toString()] = W;
            }
          } catch (x) {
            f = { error: x };
          } finally {
            try {
              N && !N.done && (T = M.return) && T.call(M);
            } finally {
              if (f) throw f.error;
            }
          }
          else m[Z > 1 ? y + (g++).toString() : y] = p;
          return g;
        }, h.prototype.beginElement = function(p) {
          var m, b, y = [];
          if (this._currentList.length === 0) this._currentList.push(((m = {})[p] = y, m));
          else {
            var Z = this._currentList[this._currentList.length - 1];
            this._isElementNode(Z, p) ? Z[p].length !== 0 && l.isArray(Z[p][0]) ? Z[p].push(y) : Z[p] = [Z[p], y] : this._currentList.push(((b = {})[p] = y, b));
          }
          this._currentIndex++, this._listRegister.length > this._currentIndex ? this._listRegister[this._currentIndex] = y : this._listRegister.push(y), this._currentList = y;
        }, h.prototype.endElement = function() {
          this._currentList = this._listRegister[--this._currentIndex];
        }, h.prototype.attribute = function(p, m) {
          var b, y;
          if (this._currentList.length === 0) this._currentList.push({ "@": (b = {}, b[p] = m, b) });
          else {
            var Z = this._currentList[this._currentList.length - 1];
            this._isAttrNode(Z) ? Z["@"][p] = m : this._currentList.push({ "@": (y = {}, y[p] = m, y) });
          }
        }, h.prototype.comment = function(p) {
          if (this._currentList.length === 0) this._currentList.push({ "!": p });
          else {
            var m = this._currentList[this._currentList.length - 1];
            this._isCommentNode(m) ? l.isArray(m["!"]) ? m["!"].push(p) : m["!"] = [m["!"], p] : this._currentList.push({ "!": p });
          }
        }, h.prototype.text = function(p) {
          if (this._currentList.length === 0) this._currentList.push({ "#": p });
          else {
            var m = this._currentList[this._currentList.length - 1];
            this._isTextNode(m) ? l.isArray(m["#"]) ? m["#"].push(p) : m["#"] = [m["#"], p] : this._currentList.push({ "#": p });
          }
        }, h.prototype.instruction = function(p, m) {
          var b = m === "" ? p : p + " " + m;
          if (this._currentList.length === 0) this._currentList.push({ "?": b });
          else {
            var y = this._currentList[this._currentList.length - 1];
            this._isInstructionNode(y) ? l.isArray(y["?"]) ? y["?"].push(b) : y["?"] = [y["?"], b] : this._currentList.push({ "?": b });
          }
        }, h.prototype.cdata = function(p) {
          if (this._currentList.length === 0) this._currentList.push({ $: p });
          else {
            var m = this._currentList[this._currentList.length - 1];
            this._isCDATANode(m) ? l.isArray(m.$) ? m.$.push(p) : m.$ = [m.$, p] : this._currentList.push({ $: p });
          }
        }, h.prototype._isAttrNode = function(p) {
          return "@" in p;
        }, h.prototype._isTextNode = function(p) {
          return "#" in p;
        }, h.prototype._isCommentNode = function(p) {
          return "!" in p;
        }, h.prototype._isInstructionNode = function(p) {
          return "?" in p;
        }, h.prototype._isCDATANode = function(p) {
          return "$" in p;
        }, h.prototype._isElementNode = function(p, m) {
          return m in p;
        }, h.prototype._getAttrKey = function() {
          return this._builderOptions.convert.att;
        }, h.prototype._getNodeKey = function(p) {
          switch (p) {
            case c.NodeType.Comment:
              return this._builderOptions.convert.comment;
            case c.NodeType.Text:
              return this._builderOptions.convert.text;
            case c.NodeType.ProcessingInstruction:
              return this._builderOptions.convert.ins;
            case c.NodeType.CData:
              return this._builderOptions.convert.cdata;
            default:
              throw new Error("Invalid node type.");
          }
        }, h;
      })(s(50).BaseWriter);
      n.ObjectWriter = u;
    }, function(e, n, s) {
      var r = s(4), a = s(93);
      r({ target: "RegExp", proto: !0, forced: /./.exec !== a }, { exec: a });
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = (function() {
        function a() {
          this._items = {}, this._nullItems = {};
        }
        return a.prototype.set = function(o, l) {
          o === null ? this._nullItems[l] = !0 : (this._items[o] || (this._items[o] = {}), this._items[o][l] = !0);
        }, a.prototype.has = function(o, l) {
          return o === null ? this._nullItems[l] === !0 : !!this._items[o] && this._items[o][l] === !0;
        }, a;
      })();
      n.LocalNameSet = r;
    }, function(e, n, s) {
      var r = this && this.__read || function(u, d) {
        var h = typeof Symbol == "function" && u[Symbol.iterator];
        if (!h) return u;
        var p, m, b = h.call(u), y = [];
        try {
          for (; (d === void 0 || d-- > 0) && !(p = b.next()).done; ) y.push(p.value);
        } catch (Z) {
          m = { error: Z };
        } finally {
          try {
            p && !p.done && (h = b.return) && h.call(b);
          } finally {
            if (m) throw m.error;
          }
        }
        return y;
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = s(9), o = s(3), l = s(0), c = (function() {
        function u() {
        }
        return Object.defineProperty(u.prototype, "_eventListenerList", { get: function() {
          return this.__eventListenerList || (this.__eventListenerList = []);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(u.prototype, "_eventHandlerMap", { get: function() {
          return this.__eventHandlerMap || (this.__eventHandlerMap = {});
        }, enumerable: !0, configurable: !0 }), u.prototype.addEventListener = function(d, h, p) {
          p === void 0 && (p = { passive: !1, once: !1, capture: !1 });
          var m, b = r(l.eventTarget_flattenMore(p), 3), y = b[0], Z = b[1], g = b[2];
          h && (m = o.Guard.isEventListener(h) ? h : { handleEvent: h }, l.eventTarget_addEventListener(this, { type: d, callback: m, capture: y, passive: Z, once: g, removed: !1 }));
        }, u.prototype.removeEventListener = function(d, h, p) {
          p === void 0 && (p = { capture: !1 });
          var m = l.eventTarget_flatten(p);
          if (h) for (var b = 0; b < this._eventListenerList.length; b++) {
            var y = this._eventListenerList[b];
            if (y.type === d && y.capture === m) {
              if (o.Guard.isEventListener(h) && y.callback === h) {
                l.eventTarget_removeEventListener(this, y, b);
                break;
              }
              if (h && y.callback.handleEvent === h) {
                l.eventTarget_removeEventListener(this, y, b);
                break;
              }
            }
          }
        }, u.prototype.dispatchEvent = function(d) {
          if (d._dispatchFlag || !d._initializedFlag) throw new a.InvalidStateError();
          return d._isTrusted = !1, l.event_dispatch(d, this);
        }, u.prototype._getTheParent = function(d) {
          return null;
        }, u;
      })();
      n.EventTargetImpl = c;
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(u, d) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(h, p) {
          h.__proto__ = p;
        } || function(h, p) {
          for (var m in p) p.hasOwnProperty(m) && (h[m] = p[m]);
        })(u, d);
      }, function(u, d) {
        function h() {
          this.constructor = u;
        }
        r(u, d), u.prototype = d === null ? Object.create(d) : (h.prototype = d.prototype, new h());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(34), l = s(0), c = (function(u) {
        function d(h) {
          var p = u.call(this) || this;
          return p._data = h, p;
        }
        return a(d, u), Object.defineProperty(d.prototype, "data", { get: function() {
          return this._data;
        }, set: function(h) {
          l.characterData_replaceData(this, 0, this._data.length, h);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(d.prototype, "length", { get: function() {
          return this._data.length;
        }, enumerable: !0, configurable: !0 }), d.prototype.substringData = function(h, p) {
          return l.characterData_substringData(this, h, p);
        }, d.prototype.appendData = function(h) {
          return l.characterData_replaceData(this, this._data.length, 0, h);
        }, d.prototype.insertData = function(h, p) {
          l.characterData_replaceData(this, h, 0, p);
        }, d.prototype.deleteData = function(h, p) {
          l.characterData_replaceData(this, h, p, "");
        }, d.prototype.replaceData = function(h, p, m) {
          l.characterData_replaceData(this, h, p, m);
        }, Object.defineProperty(d.prototype, "previousElementSibling", { get: function() {
          throw new Error("Mixin: NonDocumentTypeChildNode not implemented.");
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(d.prototype, "nextElementSibling", { get: function() {
          throw new Error("Mixin: NonDocumentTypeChildNode not implemented.");
        }, enumerable: !0, configurable: !0 }), d.prototype.before = function() {
          for (var h = [], p = 0; p < arguments.length; p++) h[p] = arguments[p];
          throw new Error("Mixin: ChildNode not implemented.");
        }, d.prototype.after = function() {
          for (var h = [], p = 0; p < arguments.length; p++) h[p] = arguments[p];
          throw new Error("Mixin: ChildNode not implemented.");
        }, d.prototype.replaceWith = function() {
          for (var h = [], p = 0; p < arguments.length; p++) h[p] = arguments[p];
          throw new Error("Mixin: ChildNode not implemented.");
        }, d.prototype.remove = function() {
          throw new Error("Mixin: ChildNode not implemented.");
        }, d;
      })(o.NodeImpl);
      n.CharacterDataImpl = c;
    }, function(e, n, s) {
      var r = this && this.__values || function(Z) {
        var g = typeof Symbol == "function" && Symbol.iterator, f = g && Z[g], T = 0;
        if (f) return f.call(Z);
        if (Z && typeof Z.length == "number") return { next: function() {
          return Z && T >= Z.length && (Z = void 0), { value: Z && Z[T++], done: !Z };
        } };
        throw new TypeError(g ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }, a = this && this.__read || function(Z, g) {
        var f = typeof Symbol == "function" && Z[Symbol.iterator];
        if (!f) return Z;
        var T, M, N = f.call(Z), W = [];
        try {
          for (; (g === void 0 || g-- > 0) && !(T = N.next()).done; ) W.push(T.value);
        } catch (x) {
          M = { error: x };
        } finally {
          try {
            T && !T.done && (f = N.return) && f.call(N);
          } finally {
            if (M) throw M.error;
          }
        }
        return W;
      }, o = this && this.__spread || function() {
        for (var Z = [], g = 0; g < arguments.length; g++) Z = Z.concat(a(arguments[g]));
        return Z;
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var l = s(6), c = s(3), u = s(1), d = s(17), h = s(51);
      function p(Z) {
        l.dom.window._signalSlots.add(Z), h.observer_queueAMutationObserverMicrotask();
      }
      function m(Z, g) {
        g === void 0 && (g = !1);
        var f = c.Cast.asNode(Z)._parent;
        if (f === null) return null;
        var T = f._shadowRoot || null;
        if (T === null || g && T._mode !== "open") return null;
        for (var M = d.tree_getFirstDescendantNode(T, !1, !0, (function(N) {
          return c.Guard.isSlot(N);
        })); M !== null; ) {
          if (M._name === Z._name) return M;
          M = d.tree_getNextDescendantNode(T, M, !1, !0, (function(N) {
            return c.Guard.isSlot(N);
          }));
        }
        return null;
      }
      function b(Z) {
        var g, f, T = [], M = d.tree_rootNode(Z);
        if (!c.Guard.isShadowRoot(M)) return T;
        var N = M._host;
        try {
          for (var W = r(N._children), x = W.next(); !x.done; x = W.next()) {
            var V = x.value;
            c.Guard.isSlotable(V) && m(V) === Z && T.push(V);
          }
        } catch (X) {
          g = { error: X };
        } finally {
          try {
            x && !x.done && (f = W.return) && f.call(W);
          } finally {
            if (g) throw g.error;
          }
        }
        return T;
      }
      function y(Z) {
        var g, f, T = b(Z);
        if (T.length === Z._assignedNodes.length) {
          for (var M = !0, N = 0; N < T.length; N++) if (T[N] !== Z._assignedNodes[N]) {
            M = !1;
            break;
          }
          M || p(Z);
        }
        Z._assignedNodes = T;
        try {
          for (var W = r(T), x = W.next(); !x.done; x = W.next())
            x.value._assignedSlot = Z;
        } catch (V) {
          g = { error: V };
        } finally {
          try {
            x && !x.done && (f = W.return) && f.call(W);
          } finally {
            if (g) throw g.error;
          }
        }
      }
      n.shadowTree_signalASlotChange = p, n.shadowTree_isConnected = function(Z) {
        return c.Guard.isDocumentNode(d.tree_rootNode(Z, !0));
      }, n.shadowTree_isAssigned = function(Z) {
        return Z._assignedSlot !== null;
      }, n.shadowTree_findASlot = m, n.shadowTree_findSlotables = b, n.shadowTree_findFlattenedSlotables = function Z(g) {
        var f, T, M, N, W = [], x = d.tree_rootNode(g);
        if (!c.Guard.isShadowRoot(x)) return W;
        var V = b(g);
        if (u.isEmpty(V)) try {
          for (var X = r(g._children), C = X.next(); !C.done; C = X.next()) {
            var R = C.value;
            c.Guard.isSlotable(R) && V.push(R);
          }
        } catch (H) {
          f = { error: H };
        } finally {
          try {
            C && !C.done && (T = X.return) && T.call(X);
          } finally {
            if (f) throw f.error;
          }
        }
        try {
          for (var z = r(V), F = z.next(); !F.done; F = z.next()) {
            var P = F.value;
            if (c.Guard.isSlot(P) && c.Guard.isShadowRoot(d.tree_rootNode(P))) {
              var j = Z(P);
              W.push.apply(W, o(j));
            } else W.push(P);
          }
        } catch (H) {
          M = { error: H };
        } finally {
          try {
            F && !F.done && (N = z.return) && N.call(z);
          } finally {
            if (M) throw M.error;
          }
        }
        return W;
      }, n.shadowTree_assignSlotables = y, n.shadowTree_assignSlotablesForATree = function(Z) {
        for (var g = d.tree_getFirstDescendantNode(Z, !0, !1, (function(f) {
          return c.Guard.isSlot(f);
        })); g !== null; ) y(g), g = d.tree_getNextDescendantNode(Z, g, !0, !1, (function(f) {
          return c.Guard.isSlot(f);
        }));
      }, n.shadowTree_assignASlot = function(Z) {
        var g = m(Z);
        g !== null && y(g);
      };
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = /[a-z]([\0-\t\x2D\._a-z\xB7\xC0-\xD6\xD8-\xF6\xF8-\u037D\u037F-\u1FFF\u200C\u200D\u203F\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])*-([\0-\t\x2D\._a-z\xB7\xC0-\xD6\xD8-\xF6\xF8-\u037D\u037F-\u1FFF\u200C\u200D\u203F\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])*/, a = /* @__PURE__ */ new Set(["annotation-xml", "color-profile", "font-face", "font-face-src", "font-face-uri", "font-face-format", "font-face-name", "missing-glyph"]), o = /* @__PURE__ */ new Set(["article", "aside", "blockquote", "body", "div", "footer", "h1", "h2", "h3", "h4", "h5", "h6", "header", "main", "nav", "p", "section", "span"]), l = /* @__PURE__ */ new Set(["area", "base", "basefont", "bgsound", "br", "col", "embed", "frame", "hr", "img", "input", "keygen", "link", "menuitem", "meta", "param", "source", "track", "wbr"]), c = /* @__PURE__ */ new Set(["article", "aside", "blockquote", "body", "div", "footer", "h1", "h2", "h3", "h4", "h5", "h6", "header", "main", "nav", "p", "section", "span"]);
      n.customElement_isValidCustomElementName = function(u) {
        return !!r.test(u) && !a.has(u);
      }, n.customElement_isValidElementName = function(u) {
        return o.has(u);
      }, n.customElement_isVoidElementName = function(u) {
        return l.has(u);
      }, n.customElement_isValidShadowHostName = function(u) {
        return c.has(u);
      }, n.customElement_enqueueACustomElementUpgradeReaction = function(u, d) {
      }, n.customElement_enqueueACustomElementCallbackReaction = function(u, d, h) {
      }, n.customElement_upgrade = function(u, d) {
      }, n.customElement_tryToUpgrade = function(u) {
      }, n.customElement_lookUpACustomElementDefinition = function(u, d, h, p) {
        return null;
      };
    }, function(e, n, s) {
      s(4)({ target: "String", proto: !0 }, { repeat: s(259) });
    }, function(e, n, s) {
      s(278), s(68), s(179), s(94), Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(109), a = (function() {
        function o(l) {
          this._builderOptions = l, l.parser && Object.assign(this, l.parser);
        }
        return o.prototype._docType = function(l, c, u, d) {
          return l.dtd({ name: c, pubID: u, sysID: d });
        }, o.prototype._comment = function(l, c) {
          return l.com(c);
        }, o.prototype._text = function(l, c) {
          return l.txt(c);
        }, o.prototype._instruction = function(l, c, u) {
          return l.ins(c, u);
        }, o.prototype._cdata = function(l, c) {
          return l.dat(c);
        }, o.prototype._element = function(l, c, u) {
          return c === void 0 ? l.ele(u) : l.ele(c, u);
        }, o.prototype._attribute = function(l, c, u, d) {
          return c === void 0 ? l.att(u, d) : l.att(c, u, d);
        }, o.prototype._sanitize = function(l) {
          return r.sanitizeInput(l, this._builderOptions.invalidCharReplacement);
        }, o.prototype._decodeText = function(l) {
          return l == null ? l : l.replace(/&(quot|amp|apos|lt|gt);/g, (function(c, u) {
            return o._entityTable[u];
          })).replace(/&#(?:x([a-fA-F0-9]+)|([0-9]+));/g, (function(c, u, d) {
            return String.fromCodePoint(parseInt(u || d, u ? 16 : 10));
          }));
        }, o.prototype._decodeAttributeValue = function(l) {
          return this._decodeText(l);
        }, o.prototype.parse = function(l, c) {
          return this._parse(l, c);
        }, o.prototype.docType = function(l, c, u, d) {
          return this._docType(l, c, u, d);
        }, o.prototype.comment = function(l, c) {
          return this._comment(l, c);
        }, o.prototype.text = function(l, c) {
          return this._text(l, c);
        }, o.prototype.instruction = function(l, c, u) {
          return this._instruction(l, c, u);
        }, o.prototype.cdata = function(l, c) {
          return this._cdata(l, c);
        }, o.prototype.element = function(l, c, u) {
          return this._element(l, c, u);
        }, o.prototype.attribute = function(l, c, u, d) {
          return this._attribute(l, c, u, d);
        }, o.prototype.sanitize = function(l) {
          return this._sanitize(l);
        }, o._entityTable = { lt: "<", gt: ">", amp: "&", quot: '"', apos: "'" }, o;
      })();
      n.BaseReader = a;
    }, function(e, n, s) {
      var r = s(39);
      e.exports = r.DEFAULT = new r({ include: [s(54)], explicit: [s(299), s(300), s(301)] });
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(185);
      n.XMLBuilderImpl = r.XMLBuilderImpl;
      var a = s(304);
      n.XMLBuilderCBImpl = a.XMLBuilderCBImpl;
      var o = s(183);
      n.builder = o.builder, n.create = o.create, n.fragment = o.fragment, n.convert = o.convert;
      var l = s(309);
      n.createCB = l.createCB, n.fragmentCB = l.fragmentCB;
    }, function(e, n) {
      var s;
      s = /* @__PURE__ */ (function() {
        return this;
      })();
      try {
        s = s || new Function("return this")();
      } catch {
        typeof window == "object" && (s = window);
      }
      e.exports = s;
    }, function(e, n, s) {
      var r = {}.propertyIsEnumerable, a = Object.getOwnPropertyDescriptor, o = a && !r.call({ 1: 2 }, 1);
      n.f = o ? function(l) {
        var c = a(this, l);
        return !!c && c.enumerable;
      } : r;
    }, function(e, n, s) {
      var r = s(11), a = s(21);
      e.exports = function(o, l) {
        try {
          a(r, o, l);
        } catch {
          r[o] = l;
        }
        return l;
      };
    }, function(e, n, s) {
      var r = s(44), a = s(118);
      (e.exports = function(o, l) {
        return a[o] || (a[o] = l !== void 0 ? l : {});
      })("versions", []).push({ version: "3.6.5", mode: r ? "pure" : "global", copyright: "© 2020 Denis Pushkarev (zloirock.ru)" });
    }, function(e, n, s) {
      var r = s(121), a = s(84).concat("length", "prototype");
      n.f = Object.getOwnPropertyNames || function(o) {
        return r(o, a);
      };
    }, function(e, n, s) {
      var r = s(47), a = Math.max, o = Math.min;
      e.exports = function(l, c) {
        var u = r(l);
        return u < 0 ? a(u + c, 0) : o(u, c);
      };
    }, function(e, n) {
      e.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
    }, function(e, n) {
      n.f = Object.getOwnPropertySymbols;
    }, function(e, n, s) {
      var r = s(8);
      e.exports = !!Object.getOwnPropertySymbols && !r((function() {
        return !String(Symbol());
      }));
    }, function(e, n, s) {
      var r = s(127);
      e.exports = function(a, o, l) {
        if (r(a), o === void 0) return a;
        switch (l) {
          case 0:
            return function() {
              return a.call(o);
            };
          case 1:
            return function(c) {
              return a.call(o, c);
            };
          case 2:
            return function(c, u) {
              return a.call(o, c, u);
            };
          case 3:
            return function(c, u, d) {
              return a.call(o, c, u, d);
            };
        }
        return function() {
          return a.apply(o, arguments);
        };
      };
    }, function(e, n, s) {
      var r = s(4), a = s(195), o = s(132), l = s(133), c = s(62), u = s(21), d = s(25), h = s(5), p = s(44), m = s(49), b = s(131), y = b.IteratorPrototype, Z = b.BUGGY_SAFARI_ITERATORS, g = h("iterator"), f = function() {
        return this;
      };
      e.exports = function(T, M, N, W, x, V, X) {
        a(N, M, W);
        var C, R, z, F = function(E) {
          if (E === x && $) return $;
          if (!Z && E in H) return H[E];
          switch (E) {
            case "keys":
            case "values":
            case "entries":
              return function() {
                return new N(this, E);
              };
          }
          return function() {
            return new N(this);
          };
        }, P = M + " Iterator", j = !1, H = T.prototype, B = H[g] || H["@@iterator"] || x && H[x], $ = !Z && B || F(x), A = M == "Array" && H.entries || B;
        if (A && (C = o(A.call(new T())), y !== Object.prototype && C.next && (p || o(C) === y || (l ? l(C, y) : typeof C[g] != "function" && u(C, g, f)), c(C, P, !0, !0), p && (m[P] = f))), x == "values" && B && B.name !== "values" && (j = !0, $ = function() {
          return B.call(this);
        }), p && !X || H[g] === $ || u(H, g, $), m[M] = $, x) if (R = { values: F("values"), keys: V ? $ : F("keys"), entries: F("entries") }, X) for (z in R) (Z || j || !(z in H)) && d(H, z, R[z]);
        else r({ target: M, proto: !0, forced: Z || j }, R);
        return R;
      };
    }, function(e, n, s) {
      var r = s(4), a = s(13), o = s(59), l = s(83), c = s(26), u = s(24), d = s(134), h = s(5), p = s(63), m = s(28), b = p("slice"), y = m("slice", { ACCESSORS: !0, 0: 0, 1: 2 }), Z = h("species"), g = [].slice, f = Math.max;
      r({ target: "Array", proto: !0, forced: !b || !y }, { slice: function(T, M) {
        var N, W, x, V = u(this), X = c(V.length), C = l(T, X), R = l(M === void 0 ? X : M, X);
        if (o(V) && (typeof (N = V.constructor) != "function" || N !== Array && !o(N.prototype) ? a(N) && (N = N[Z]) === null && (N = void 0) : N = void 0, N === Array || N === void 0)) return g.call(V, C, R);
        for (W = new (N === void 0 ? Array : N)(f(R - C, 0)), x = 0; C < R; C++, x++) C in V && d(W, x, V[C]);
        return W.length = x, W;
      } });
    }, function(e, n, s) {
      var r = {};
      r[s(5)("toStringTag")] = "z", e.exports = String(r) === "[object z]";
    }, function(e, n, s) {
      s(19), s(138), s(20), s(92), s(22), s(23), Object.defineProperty(n, "__esModule", { value: !0 }), n.DefaultBuilderOptions = { version: "1.0", encoding: void 0, standalone: void 0, keepNullNodes: !1, keepNullAttributes: !1, ignoreConverters: !1, convert: { att: "@", ins: "?", text: "#", cdata: "$", comment: "!" }, defaultNamespace: { ele: void 0, att: void 0 }, namespaceAlias: { html: "http://www.w3.org/1999/xhtml", xml: "http://www.w3.org/XML/1998/namespace", xmlns: "http://www.w3.org/2000/xmlns/", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg", xlink: "http://www.w3.org/1999/xlink" }, invalidCharReplacement: void 0, parser: void 0 }, n.XMLBuilderOptionKeys = new Set(Object.keys(n.DefaultBuilderOptions)), n.DefaultXMLBuilderCBOptions = { format: "xml", wellFormed: !1, prettyPrint: !1, indent: "  ", newline: `
`, offset: 0, width: 0, allowEmptyTags: !1, spaceBeforeSlash: !1, keepNullNodes: !1, keepNullAttributes: !1, ignoreConverters: !1, convert: { att: "@", ins: "?", text: "#", cdata: "$", comment: "!" }, defaultNamespace: { ele: void 0, att: void 0 }, namespaceAlias: { html: "http://www.w3.org/1999/xhtml", xml: "http://www.w3.org/XML/1998/namespace", xmlns: "http://www.w3.org/2000/xmlns/", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg", xlink: "http://www.w3.org/1999/xlink" } };
    }, function(e, n, s) {
      var r = s(139), a = s(143);
      e.exports = r("Set", (function(o) {
        return function() {
          return o(this, arguments.length ? arguments[0] : void 0);
        };
      }), a);
    }, function(e, n, s) {
      var r, a, o = s(136), l = s(221), c = RegExp.prototype.exec, u = String.prototype.replace, d = c, h = (r = /a/, a = /b*/g, c.call(r, "a"), c.call(a, "a"), r.lastIndex !== 0 || a.lastIndex !== 0), p = l.UNSUPPORTED_Y || l.BROKEN_CARET, m = /()??/.exec("")[1] !== void 0;
      (h || m || p) && (d = function(b) {
        var y, Z, g, f, T = this, M = p && T.sticky, N = o.call(T), W = T.source, x = 0, V = b;
        return M && ((N = N.replace("y", "")).indexOf("g") === -1 && (N += "g"), V = String(b).slice(T.lastIndex), T.lastIndex > 0 && (!T.multiline || T.multiline && b[T.lastIndex - 1] !== `
`) && (W = "(?: " + W + ")", V = " " + V, x++), Z = new RegExp("^(?:" + W + ")", N)), m && (Z = new RegExp("^" + W + "$(?!\\s)", N)), h && (y = T.lastIndex), g = c.call(M ? Z : T, V), M ? g ? (g.input = g.input.slice(x), g[0] = g[0].slice(x), g.index = T.lastIndex, T.lastIndex += g[0].length) : T.lastIndex = 0 : h && g && (T.lastIndex = T.global ? g.index + g[0].length : y), m && g && g.length > 1 && u.call(g[0], Z, (function() {
          for (f = 1; f < arguments.length - 2; f++) arguments[f] === void 0 && (g[f] = void 0);
        })), g;
      }), e.exports = d;
    }, function(e, n, s) {
      var r = s(225), a = s(18), o = s(27), l = s(26), c = s(47), u = s(35), d = s(226), h = s(227), p = Math.max, m = Math.min, b = Math.floor, y = /\$([$&'`]|\d\d?|<[^>]*>)/g, Z = /\$([$&'`]|\d\d?)/g;
      r("replace", 2, (function(g, f, T, M) {
        var N = M.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE, W = M.REPLACE_KEEPS_$0, x = N ? "$" : "$0";
        return [function(X, C) {
          var R = u(this), z = X == null ? void 0 : X[g];
          return z !== void 0 ? z.call(X, R, C) : f.call(String(R), X, C);
        }, function(X, C) {
          if (!N && W || typeof C == "string" && C.indexOf(x) === -1) {
            var R = T(f, X, this, C);
            if (R.done) return R.value;
          }
          var z = a(X), F = String(this), P = typeof C == "function";
          P || (C = String(C));
          var j = z.global;
          if (j) {
            var H = z.unicode;
            z.lastIndex = 0;
          }
          for (var B = []; ; ) {
            var $ = h(z, F);
            if ($ === null || (B.push($), !j)) break;
            String($[0]) === "" && (z.lastIndex = d(F, l(z.lastIndex), H));
          }
          for (var A, E = "", ct = 0, at = 0; at < B.length; at++) {
            $ = B[at];
            for (var dt = String($[0]), gt = p(m(c($.index), F.length), 0), Wt = [], Zt = 1; Zt < $.length; Zt++) Wt.push((A = $[Zt]) === void 0 ? A : String(A));
            var Gt = $.groups;
            if (P) {
              var Tt = [dt].concat(Wt, gt, F);
              Gt !== void 0 && Tt.push(Gt);
              var Q = String(C.apply(void 0, Tt));
            } else Q = V(dt, F, gt, Wt, Gt, C);
            gt >= ct && (E += F.slice(ct, gt) + Q, ct = gt + dt.length);
          }
          return E + F.slice(ct);
        }];
        function V(X, C, R, z, F, P) {
          var j = R + X.length, H = z.length, B = Z;
          return F !== void 0 && (F = o(F), B = y), f.call(P, B, (function($, A) {
            var E;
            switch (A.charAt(0)) {
              case "$":
                return "$";
              case "&":
                return X;
              case "`":
                return C.slice(0, R);
              case "'":
                return C.slice(j);
              case "<":
                E = F[A.slice(1, -1)];
                break;
              default:
                var ct = +A;
                if (ct === 0) return $;
                if (ct > H) {
                  var at = b(ct / 10);
                  return at === 0 ? $ : at <= H ? z[at - 1] === void 0 ? A.charAt(1) : z[at - 1] + A.charAt(1) : $;
                }
                E = z[ct - 1];
            }
            return E === void 0 ? "" : E;
          }));
        }
      }));
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = (function() {
        function a() {
          this._items = {}, this._nullItems = [];
        }
        return a.prototype.copy = function() {
          var o = new a();
          for (var l in this._items) o._items[l] = this._items[l].slice(0);
          return o._nullItems = this._nullItems.slice(0), o;
        }, a.prototype.get = function(o, l) {
          var c = l === null ? this._nullItems : this._items[l] || null;
          if (c === null) return null;
          for (var u = null, d = 0; d < c.length; d++) if ((u = c[d]) === o) return u;
          return u;
        }, a.prototype.has = function(o, l) {
          var c = l === null ? this._nullItems : this._items[l] || null;
          return c !== null && c.indexOf(o) !== -1;
        }, a.prototype.hasPrefix = function(o) {
          if (this._nullItems.indexOf(o) !== -1) return !0;
          for (var l in this._items) if (this._items[l].indexOf(o) !== -1) return !0;
          return !1;
        }, a.prototype.set = function(o, l) {
          var c = l === null ? this._nullItems : this._items[l] || null;
          l !== null && c === null ? this._items[l] = [o] : c.push(o);
        }, a;
      })();
      n.NamespacePrefixMap = r;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 }), n.Surrogate = /[\uD800-\uDFFF]/, n.ScalarValue = /[\uD800-\uDFFF]/, n.NonCharacter = /[\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]/, n.ASCIICodePoint = /[\u0000-\u007F]/, n.ASCIITabOrNewLine = /[\t\n\r]/, n.ASCIIWhiteSpace = /[\t\n\f\r ]/, n.C0Control = /[\u0000-\u001F]/, n.C0ControlOrSpace = /[\u0000-\u001F ]/, n.Control = /[\u0000-\u001F\u007F-\u009F]/, n.ASCIIDigit = /[0-9]/, n.ASCIIUpperHexDigit = /[0-9A-F]/, n.ASCIILowerHexDigit = /[0-9a-f]/, n.ASCIIHexDigit = /[0-9A-Fa-f]/, n.ASCIIUpperAlpha = /[A-Z]/, n.ASCIILowerAlpha = /[a-z]/, n.ASCIIAlpha = /[A-Za-z]/, n.ASCIIAlphanumeric = /[0-9A-Za-z]/;
    }, function(e, n, s) {
      var r = this && this.__values || function(C) {
        var R = typeof Symbol == "function" && Symbol.iterator, z = R && C[R], F = 0;
        if (z) return z.call(C);
        if (C && typeof C.length == "number") return { next: function() {
          return C && F >= C.length && (C = void 0), { value: C && C[F++], done: !C };
        } };
        throw new TypeError(R ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }, a = this && this.__read || function(C, R) {
        var z = typeof Symbol == "function" && C[Symbol.iterator];
        if (!z) return C;
        var F, P, j = z.call(C), H = [];
        try {
          for (; (R === void 0 || R-- > 0) && !(F = j.next()).done; ) H.push(F.value);
        } catch (B) {
          P = { error: B };
        } finally {
          try {
            F && !F.done && (z = j.return) && z.call(j);
          } finally {
            if (P) throw P.error;
          }
        }
        return H;
      }, o = this && this.__spread || function() {
        for (var C = [], R = 0; R < arguments.length; R++) C = C.concat(a(arguments[R]));
        return C;
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var l = s(6), c = s(2), u = s(3), d = s(171), h = s(104), p = s(9), m = s(17), b = s(72), y = s(30);
      function Z(C, R) {
        R === void 0 && (R = void 0), R === void 0 && (R = null);
        var z = g(C, R, /* @__PURE__ */ new Date(), {});
        return z._isTrusted = !0, z;
      }
      function g(C, R, z, F) {
        var P = new C("");
        return P._initializedFlag = !0, P._timeStamp = z.getTime(), Object.assign(P, F), l.dom.features.steps && y.dom_runEventConstructingSteps(P), P;
      }
      function f(C, R, z, F) {
        var P, j, H, B;
        z === void 0 && (z = !1), F === void 0 && (F = { value: !1 });
        var $ = !1;
        C._dispatchFlag = !0;
        var A = R;
        if (z) {
          var E = R._associatedDocument;
          u.Guard.isDocumentNode(E) && (A = E);
        }
        var ct = null, at = m.tree_retarget(C._relatedTarget, R);
        if (R !== at || R === C._relatedTarget) {
          var dt = [];
          try {
            for (var gt = r(C._touchTargetList), Wt = gt.next(); !Wt.done; Wt = gt.next()) {
              var Zt = Wt.value;
              dt.push(m.tree_retarget(Zt, R));
            }
          } catch (wt) {
            P = { error: wt };
          } finally {
            try {
              Wt && !Wt.done && (j = gt.return) && j.call(gt);
            } finally {
              if (P) throw P.error;
            }
          }
          T(C, R, A, at, dt, !1);
          var Gt = u.Guard.isMouseEvent(C) && C._type === "click";
          Gt && R._activationBehavior !== void 0 && (ct = R);
          for (var Tt = u.Guard.isSlotable(R) && b.shadowTree_isAssigned(R) ? R : null, Q = !1, D = R._getTheParent(C); D !== null && u.Guard.isNode(D); ) {
            if (Tt !== null) {
              if (!u.Guard.isSlot(D)) throw new Error("Parent node of a slotable should be a slot.");
              Tt = null;
              var q = m.tree_rootNode(D, !0);
              u.Guard.isShadowRoot(q) && q._mode === "closed" && (Q = !0);
            }
            u.Guard.isSlotable(D) && b.shadowTree_isAssigned(D) && (Tt = D), at = m.tree_retarget(C._relatedTarget, D), dt = [];
            try {
              for (var nt = (H = void 0, r(C._touchTargetList)), et = nt.next(); !et.done; et = nt.next())
                Zt = et.value, dt.push(m.tree_retarget(Zt, D));
            } catch (wt) {
              H = { error: wt };
            } finally {
              try {
                et && !et.done && (B = nt.return) && B.call(nt);
              } finally {
                if (H) throw H.error;
              }
            }
            u.Guard.isWindow(D) || u.Guard.isNode(D) && u.Guard.isNode(R) && m.tree_isAncestorOf(m.tree_rootNode(R, !0), D, !0, !0) ? (Gt && C._bubbles && ct === null && D._activationBehavior && (ct = D), T(C, D, null, at, dt, Q)) : D === at ? D = null : (R = D, Gt && ct === null && R._activationBehavior && (ct = R), T(C, D, R, at, dt, Q)), D !== null && (D = D._getTheParent(C)), Q = !1;
          }
          for (var ot = null, it = C._path, ht = it.length - 1; ht >= 0; ht--)
            if ((mt = it[ht]).shadowAdjustedTarget !== null) {
              ot = mt;
              break;
            }
          if (ot !== null) if (u.Guard.isNode(ot.shadowAdjustedTarget) && u.Guard.isShadowRoot(m.tree_rootNode(ot.shadowAdjustedTarget, !0))) $ = !0;
          else if (u.Guard.isNode(ot.relatedTarget) && u.Guard.isShadowRoot(m.tree_rootNode(ot.relatedTarget, !0))) $ = !0;
          else for (var lt = 0; lt < ot.touchTargetList.length; lt++) {
            var mt = ot.touchTargetList[lt];
            if (u.Guard.isNode(mt) && u.Guard.isShadowRoot(m.tree_rootNode(mt, !0))) {
              $ = !0;
              break;
            }
          }
          for (ct !== null && ct._legacyPreActivationBehavior !== void 0 && ct._legacyPreActivationBehavior(C), ht = it.length - 1; ht >= 0; ht--)
            (mt = it[ht]).shadowAdjustedTarget !== null ? C._eventPhase = c.EventPhase.AtTarget : C._eventPhase = c.EventPhase.Capturing, M(mt, C, "capturing", F);
          for (ht = 0; ht < it.length; ht++) {
            if ((mt = it[ht]).shadowAdjustedTarget !== null) C._eventPhase = c.EventPhase.AtTarget;
            else {
              if (!C._bubbles) continue;
              C._eventPhase = c.EventPhase.Bubbling;
            }
            M(mt, C, "bubbling", F);
          }
        }
        return C._eventPhase = c.EventPhase.None, C._currentTarget = null, C._path = [], C._dispatchFlag = !1, C._stopPropagationFlag = !1, C._stopImmediatePropagationFlag = !1, $ && (C._target = null, C._relatedTarget = null, C._touchTargetList = []), ct !== null && (C._canceledFlag || ct._activationBehavior === void 0 ? ct._legacyCanceledActivationBehavior !== void 0 && ct._legacyCanceledActivationBehavior(C) : ct._activationBehavior(C)), !C._canceledFlag;
      }
      function T(C, R, z, F, P, j) {
        var H = !1;
        u.Guard.isNode(R) && u.Guard.isShadowRoot(m.tree_rootNode(R)) && (H = !0);
        var B = !1;
        u.Guard.isShadowRoot(R) && R._mode === "closed" && (B = !0), C._path.push({ invocationTarget: R, invocationTargetInShadowTree: H, shadowAdjustedTarget: z, relatedTarget: F, touchTargetList: P, rootOfClosedTree: B, slotInClosedTree: j });
      }
      function M(C, R, z, F) {
        F === void 0 && (F = { value: !1 });
        for (var P = R._path, j = -1, H = 0; H < P.length; H++) if (P[H] === C) {
          j = H;
          break;
        }
        if (j !== -1) {
          var B = P[j];
          (B.shadowAdjustedTarget !== null || j > 0 && (B = P[j - 1]).shadowAdjustedTarget !== null) && (R._target = B.shadowAdjustedTarget);
        }
        if (R._relatedTarget = C.relatedTarget, R._touchTargetList = C.touchTargetList, !R._stopPropagationFlag) {
          R._currentTarget = C.invocationTarget;
          var $ = R._currentTarget._eventListenerList, A = new (Array.bind.apply(Array, o([void 0], $)))();
          if (!N(R, A, z, C, F) && R._isTrusted) {
            var E = R._type;
            E === "animationend" ? R._type = "webkitAnimationEnd" : E === "animationiteration" ? R._type = "webkitAnimationIteration" : E === "animationstart" ? R._type = "webkitAnimationStart" : E === "transitionend" && (R._type = "webkitTransitionEnd"), N(R, A, z, C, F), R._type = E;
          }
        }
      }
      function N(C, R, z, F, P) {
        P === void 0 && (P = { value: !1 });
        for (var j = !1, H = 0; H < R.length; H++) {
          var B = R[H];
          if (!B.removed) {
            if (C._type !== B.type || (j = !0, z === "capturing" && !B.capture) || z === "bubbling" && B.capture) continue;
            if (B.once && C._currentTarget !== null) {
              for (var $ = C._currentTarget, A = -1, E = 0; E < $._eventListenerList.length; E++) if ($._eventListenerList[E] === B) {
                A = E;
                break;
              }
              A !== -1 && $._eventListenerList.splice(A, 1);
            }
            var ct = void 0, at = void 0;
            u.Guard.isWindow(ct) && (at = ct._currentEvent, F.invocationTargetInShadowTree === !1 && (ct._currentEvent = C)), B.passive && (C._inPassiveListenerFlag = !0);
            try {
              B.callback.handleEvent.call(C._currentTarget, C);
            } catch {
              P.value = !0;
            }
            if (B.passive && (C._inPassiveListenerFlag = !1), u.Guard.isWindow(ct) && (ct._currentEvent = at), C._stopImmediatePropagationFlag) return j;
          }
        }
        return j;
      }
      function W(C, R) {
        return null;
      }
      function x(C, R) {
        return null;
      }
      function V(C, R) {
      }
      function X(C, R) {
      }
      n.event_setTheCanceledFlag = function(C) {
        C._cancelable && !C._inPassiveListenerFlag && (C._canceledFlag = !0);
      }, n.event_initialize = function(C, R, z, F) {
        C._initializedFlag = !0, C._stopPropagationFlag = !1, C._stopImmediatePropagationFlag = !1, C._canceledFlag = !1, C._isTrusted = !1, C._target = null, C._type = R, C._bubbles = z, C._cancelable = F;
      }, n.event_createAnEvent = Z, n.event_innerEventCreationSteps = g, n.event_dispatch = f, n.event_appendToAnEventPath = T, n.event_invoke = M, n.event_innerInvoke = N, n.event_fireAnEvent = function(C, R, z, F, P) {
        z === void 0 && (z = h.EventImpl);
        var j = Z(z);
        if (j._type = C, F) for (var H in F)
          j[H] = F[H];
        return f(j, R, P);
      }, n.event_createLegacyEvent = function(C) {
        var R = null;
        switch (C.toLowerCase()) {
          case "beforeunloadevent":
          case "compositionevent":
            break;
          case "customevent":
            R = d.CustomEventImpl;
            break;
          case "devicemotionevent":
          case "deviceorientationevent":
          case "dragevent":
            break;
          case "event":
          case "events":
            R = h.EventImpl;
        }
        if (R === null) throw new p.NotSupportedError("Event constructor not found for interface " + C + ".");
        var z = new R("");
        return z._type = "", z._timeStamp = (/* @__PURE__ */ new Date()).getTime(), z._isTrusted = !1, z._initializedFlag = !1, z;
      }, n.event_getterEventHandlerIDLAttribute = function(C, R) {
        return null;
      }, n.event_setterEventHandlerIDLAttribute = function(C, R, z) {
      }, n.event_determineTheTargetOfAnEventHandler = W, n.event_getTheCurrentValueOfAnEventHandler = x, n.event_activateAnEventHandler = V, n.event_deactivateAnEventHandler = X;
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(T, M) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(N, W) {
          N.__proto__ = W;
        } || function(N, W) {
          for (var x in W) W.hasOwnProperty(x) && (N[x] = W[x]);
        })(T, M);
      }, function(T, M) {
        function N() {
          this.constructor = T;
        }
        r(T, M), T.prototype = M === null ? Object.create(M) : (N.prototype = M.prototype, new N());
      }), o = this && this.__values || function(T) {
        var M = typeof Symbol == "function" && Symbol.iterator, N = M && T[M], W = 0;
        if (N) return N.call(T);
        if (T && typeof T.length == "number") return { next: function() {
          return T && W >= T.length && (T = void 0), { value: T && T[W++], done: !T };
        } };
        throw new TypeError(M ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }, l = this && this.__read || function(T, M) {
        var N = typeof Symbol == "function" && T[Symbol.iterator];
        if (!N) return T;
        var W, x, V = N.call(T), X = [];
        try {
          for (; (M === void 0 || M-- > 0) && !(W = V.next()).done; ) X.push(W.value);
        } catch (C) {
          x = { error: C };
        } finally {
          try {
            W && !W.done && (N = V.return) && N.call(V);
          } finally {
            if (x) throw x.error;
          }
        }
        return X;
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var c = s(6), u = s(2), d = s(9), h = s(34), p = s(3), m = s(1), b = s(7), y = s(152), Z = s(0), g = s(12), f = (function(T) {
        function M() {
          var N = T.call(this) || this;
          return N._children = /* @__PURE__ */ new Set(), N._encoding = { name: "UTF-8", labels: ["unicode-1-1-utf-8", "utf-8", "utf8"] }, N._contentType = "application/xml", N._URL = { scheme: "about", username: "", password: "", host: null, port: null, path: ["blank"], query: null, fragment: null, _cannotBeABaseURLFlag: !0, _blobURLEntry: null }, N._origin = null, N._type = "xml", N._mode = "no-quirks", N._documentElement = null, N._hasNamespaces = !1, N._nodeDocumentOverwrite = null, N;
        }
        return a(M, T), Object.defineProperty(M.prototype, "_nodeDocument", { get: function() {
          return this._nodeDocumentOverwrite || this;
        }, set: function(N) {
          this._nodeDocumentOverwrite = N;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(M.prototype, "implementation", { get: function() {
          return this._implementation || (this._implementation = Z.create_domImplementation(this));
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(M.prototype, "URL", { get: function() {
          return y.urlSerializer(this._URL);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(M.prototype, "documentURI", { get: function() {
          return this.URL;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(M.prototype, "origin", { get: function() {
          return "null";
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(M.prototype, "compatMode", { get: function() {
          return this._mode === "quirks" ? "BackCompat" : "CSS1Compat";
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(M.prototype, "characterSet", { get: function() {
          return this._encoding.name;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(M.prototype, "charset", { get: function() {
          return this._encoding.name;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(M.prototype, "inputEncoding", { get: function() {
          return this._encoding.name;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(M.prototype, "contentType", { get: function() {
          return this._contentType;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(M.prototype, "doctype", { get: function() {
          var N, W;
          try {
            for (var x = o(this._children), V = x.next(); !V.done; V = x.next()) {
              var X = V.value;
              if (p.Guard.isDocumentTypeNode(X)) return X;
            }
          } catch (C) {
            N = { error: C };
          } finally {
            try {
              V && !V.done && (W = x.return) && W.call(x);
            } finally {
              if (N) throw N.error;
            }
          }
          return null;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(M.prototype, "documentElement", { get: function() {
          return this._documentElement;
        }, enumerable: !0, configurable: !0 }), M.prototype.getElementsByTagName = function(N) {
          return Z.node_listOfElementsWithQualifiedName(N, this);
        }, M.prototype.getElementsByTagNameNS = function(N, W) {
          return Z.node_listOfElementsWithNamespace(N, W, this);
        }, M.prototype.getElementsByClassName = function(N) {
          return Z.node_listOfElementsWithClassNames(N, this);
        }, M.prototype.createElement = function(N, W) {
          if (!Z.xml_isName(N)) throw new d.InvalidCharacterError();
          this._type === "html" && (N = N.toLowerCase());
          var x = null;
          W !== void 0 && (x = m.isString(W) ? W : W.is);
          var V = this._type === "html" || this._contentType === "application/xhtml+xml" ? b.namespace.HTML : null;
          return Z.element_createAnElement(this, N, V, null, x, !0);
        }, M.prototype.createElementNS = function(N, W, x) {
          return Z.document_internalCreateElementNS(this, N, W, x);
        }, M.prototype.createDocumentFragment = function() {
          return Z.create_documentFragment(this);
        }, M.prototype.createTextNode = function(N) {
          return Z.create_text(this, N);
        }, M.prototype.createCDATASection = function(N) {
          if (this._type === "html") throw new d.NotSupportedError();
          if (N.indexOf("]]>") !== -1) throw new d.InvalidCharacterError();
          return Z.create_cdataSection(this, N);
        }, M.prototype.createComment = function(N) {
          return Z.create_comment(this, N);
        }, M.prototype.createProcessingInstruction = function(N, W) {
          if (!Z.xml_isName(N)) throw new d.InvalidCharacterError();
          if (W.indexOf("?>") !== -1) throw new d.InvalidCharacterError();
          return Z.create_processingInstruction(this, N, W);
        }, M.prototype.importNode = function(N, W) {
          if (W === void 0 && (W = !1), p.Guard.isDocumentNode(N) || p.Guard.isShadowRoot(N)) throw new d.NotSupportedError();
          return Z.node_clone(N, this, W);
        }, M.prototype.adoptNode = function(N) {
          if (p.Guard.isDocumentNode(N)) throw new d.NotSupportedError();
          if (p.Guard.isShadowRoot(N)) throw new d.HierarchyRequestError();
          return Z.document_adopt(N, this), N;
        }, M.prototype.createAttribute = function(N) {
          if (!Z.xml_isName(N)) throw new d.InvalidCharacterError();
          return this._type === "html" && (N = N.toLowerCase()), Z.create_attr(this, N);
        }, M.prototype.createAttributeNS = function(N, W) {
          var x = l(Z.namespace_validateAndExtract(N, W), 3), V = x[0], X = x[1], C = x[2], R = Z.create_attr(this, C);
          return R._namespace = V, R._namespacePrefix = X, R;
        }, M.prototype.createEvent = function(N) {
          return Z.event_createLegacyEvent(N);
        }, M.prototype.createRange = function() {
          var N = Z.create_range();
          return N._start = [this, 0], N._end = [this, 0], N;
        }, M.prototype.createNodeIterator = function(N, W, x) {
          W === void 0 && (W = u.WhatToShow.All), x === void 0 && (x = null);
          var V = Z.create_nodeIterator(N, N, !0);
          return V._whatToShow = W, V._iteratorCollection = Z.create_nodeList(N), m.isFunction(x) ? (V._filter = Z.create_nodeFilter(), V._filter.acceptNode = x) : V._filter = x, V;
        }, M.prototype.createTreeWalker = function(N, W, x) {
          W === void 0 && (W = u.WhatToShow.All), x === void 0 && (x = null);
          var V = Z.create_treeWalker(N, N);
          return V._whatToShow = W, m.isFunction(x) ? (V._filter = Z.create_nodeFilter(), V._filter.acceptNode = x) : V._filter = x, V;
        }, M.prototype._getTheParent = function(N) {
          return N._type === "load" ? null : c.dom.window;
        }, M.prototype.getElementById = function(N) {
          throw new Error("Mixin: NonElementParentNode not implemented.");
        }, Object.defineProperty(M.prototype, "children", { get: function() {
          throw new Error("Mixin: ParentNode not implemented.");
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(M.prototype, "firstElementChild", { get: function() {
          throw new Error("Mixin: ParentNode not implemented.");
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(M.prototype, "lastElementChild", { get: function() {
          throw new Error("Mixin: ParentNode not implemented.");
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(M.prototype, "childElementCount", { get: function() {
          throw new Error("Mixin: ParentNode not implemented.");
        }, enumerable: !0, configurable: !0 }), M.prototype.prepend = function() {
          for (var N = [], W = 0; W < arguments.length; W++) N[W] = arguments[W];
          throw new Error("Mixin: ParentNode not implemented.");
        }, M.prototype.append = function() {
          for (var N = [], W = 0; W < arguments.length; W++) N[W] = arguments[W];
          throw new Error("Mixin: ParentNode not implemented.");
        }, M.prototype.querySelector = function(N) {
          throw new Error("Mixin: ParentNode not implemented.");
        }, M.prototype.querySelectorAll = function(N) {
          throw new Error("Mixin: ParentNode not implemented.");
        }, M;
      })(h.NodeImpl);
      n.DocumentImpl = f, g.idl_defineConst(f.prototype, "_nodeType", u.NodeType.Document);
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(y, Z) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(g, f) {
          g.__proto__ = f;
        } || function(g, f) {
          for (var T in f) f.hasOwnProperty(T) && (g[T] = f[T]);
        })(y, Z);
      }, function(y, Z) {
        function g() {
          this.constructor = y;
        }
        r(y, Z), y.prototype = Z === null ? Object.create(Z) : (g.prototype = Z.prototype, new g());
      }), o = this && this.__values || function(y) {
        var Z = typeof Symbol == "function" && Symbol.iterator, g = Z && y[Z], f = 0;
        if (g) return g.call(y);
        if (y && typeof y.length == "number") return { next: function() {
          return y && f >= y.length && (y = void 0), { value: y && y[f++], done: !y };
        } };
        throw new TypeError(Z ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }, l = this && this.__read || function(y, Z) {
        var g = typeof Symbol == "function" && y[Symbol.iterator];
        if (!g) return y;
        var f, T, M = g.call(y), N = [];
        try {
          for (; (Z === void 0 || Z-- > 0) && !(f = M.next()).done; ) N.push(f.value);
        } catch (W) {
          T = { error: W };
        } finally {
          try {
            f && !f.done && (g = M.return) && g.call(M);
          } finally {
            if (T) throw T.error;
          }
        }
        return N;
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var c = s(2), u = s(34), d = s(9), h = s(7), p = s(0), m = s(12), b = (function(y) {
        function Z() {
          var g = y.call(this) || this;
          return g._children = /* @__PURE__ */ new Set(), g._namespace = null, g._namespacePrefix = null, g._localName = "", g._customElementState = "undefined", g._customElementDefinition = null, g._is = null, g._shadowRoot = null, g._attributeList = p.create_namedNodeMap(g), g._attributeChangeSteps = [], g._name = "", g._assignedSlot = null, g;
        }
        return a(Z, y), Object.defineProperty(Z.prototype, "namespaceURI", { get: function() {
          return this._namespace;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(Z.prototype, "prefix", { get: function() {
          return this._namespacePrefix;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(Z.prototype, "localName", { get: function() {
          return this._localName;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(Z.prototype, "tagName", { get: function() {
          return this._htmlUppercasedQualifiedName;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(Z.prototype, "id", { get: function() {
          return p.element_getAnAttributeValue(this, "id");
        }, set: function(g) {
          p.element_setAnAttributeValue(this, "id", g);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(Z.prototype, "className", { get: function() {
          return p.element_getAnAttributeValue(this, "class");
        }, set: function(g) {
          p.element_setAnAttributeValue(this, "class", g);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(Z.prototype, "classList", { get: function() {
          var g = p.element_getAnAttributeByName("class", this);
          return g === null && (g = p.create_attr(this._nodeDocument, "class")), p.create_domTokenList(this, g);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(Z.prototype, "slot", { get: function() {
          return p.element_getAnAttributeValue(this, "slot");
        }, set: function(g) {
          p.element_setAnAttributeValue(this, "slot", g);
        }, enumerable: !0, configurable: !0 }), Z.prototype.hasAttributes = function() {
          return this._attributeList.length !== 0;
        }, Object.defineProperty(Z.prototype, "attributes", { get: function() {
          return this._attributeList;
        }, enumerable: !0, configurable: !0 }), Z.prototype.getAttributeNames = function() {
          var g, f, T = [];
          try {
            for (var M = o(this._attributeList), N = M.next(); !N.done; N = M.next()) {
              var W = N.value;
              T.push(W._qualifiedName);
            }
          } catch (x) {
            g = { error: x };
          } finally {
            try {
              N && !N.done && (f = M.return) && f.call(M);
            } finally {
              if (g) throw g.error;
            }
          }
          return T;
        }, Z.prototype.getAttribute = function(g) {
          var f = p.element_getAnAttributeByName(g, this);
          return f ? f._value : null;
        }, Z.prototype.getAttributeNS = function(g, f) {
          var T = p.element_getAnAttributeByNamespaceAndLocalName(g, f, this);
          return T ? T._value : null;
        }, Z.prototype.setAttribute = function(g, f) {
          if (!p.xml_isName(g)) throw new d.InvalidCharacterError();
          this._namespace === h.namespace.HTML && this._nodeDocument._type === "html" && (g = g.toLowerCase());
          for (var T = null, M = 0; M < this._attributeList.length; M++) {
            var N = this._attributeList[M];
            if (N._qualifiedName === g) {
              T = N;
              break;
            }
          }
          if (T === null) return (T = p.create_attr(this._nodeDocument, g))._value = f, void p.element_append(T, this);
          p.element_change(T, this, f);
        }, Z.prototype.setAttributeNS = function(g, f, T) {
          var M = l(p.namespace_validateAndExtract(g, f), 3), N = M[0], W = M[1], x = M[2];
          p.element_setAnAttributeValue(this, x, T, W, N);
        }, Z.prototype.removeAttribute = function(g) {
          p.element_removeAnAttributeByName(g, this);
        }, Z.prototype.removeAttributeNS = function(g, f) {
          p.element_removeAnAttributeByNamespaceAndLocalName(g, f, this);
        }, Z.prototype.hasAttribute = function(g) {
          this._namespace === h.namespace.HTML && this._nodeDocument._type === "html" && (g = g.toLowerCase());
          for (var f = 0; f < this._attributeList.length; f++)
            if (this._attributeList[f]._qualifiedName === g) return !0;
          return !1;
        }, Z.prototype.toggleAttribute = function(g, f) {
          if (!p.xml_isName(g)) throw new d.InvalidCharacterError();
          this._namespace === h.namespace.HTML && this._nodeDocument._type === "html" && (g = g.toLowerCase());
          for (var T = null, M = 0; M < this._attributeList.length; M++) {
            var N = this._attributeList[M];
            if (N._qualifiedName === g) {
              T = N;
              break;
            }
          }
          return T === null ? (f === void 0 || f === !0) && ((T = p.create_attr(this._nodeDocument, g))._value = "", p.element_append(T, this), !0) : f !== void 0 && f !== !1 || (p.element_removeAnAttributeByName(g, this), !1);
        }, Z.prototype.hasAttributeNS = function(g, f) {
          for (var T = g || null, M = 0; M < this._attributeList.length; M++) {
            var N = this._attributeList[M];
            if (N._namespace === T && N._localName === f) return !0;
          }
          return !1;
        }, Z.prototype.getAttributeNode = function(g) {
          return p.element_getAnAttributeByName(g, this);
        }, Z.prototype.getAttributeNodeNS = function(g, f) {
          return p.element_getAnAttributeByNamespaceAndLocalName(g, f, this);
        }, Z.prototype.setAttributeNode = function(g) {
          return p.element_setAnAttribute(g, this);
        }, Z.prototype.setAttributeNodeNS = function(g) {
          return p.element_setAnAttribute(g, this);
        }, Z.prototype.removeAttributeNode = function(g) {
          for (var f = !1, T = 0; T < this._attributeList.length; T++)
            if (this._attributeList[T] === g) {
              f = !0;
              break;
            }
          if (!f) throw new d.NotFoundError();
          return p.element_remove(g, this), g;
        }, Z.prototype.attachShadow = function(g) {
          if (this._namespace !== h.namespace.HTML) throw new d.NotSupportedError();
          if (!p.customElement_isValidCustomElementName(this._localName) && !p.customElement_isValidShadowHostName(this._localName)) throw new d.NotSupportedError();
          if (p.customElement_isValidCustomElementName(this._localName) || this._is !== null) {
            var f = p.customElement_lookUpACustomElementDefinition(this._nodeDocument, this._namespace, this._localName, this._is);
            if (f !== null && f.disableShadow === !0) throw new d.NotSupportedError();
          }
          if (this._shadowRoot !== null) throw new d.NotSupportedError();
          var T = p.create_shadowRoot(this._nodeDocument, this);
          return T._mode = g.mode, this._shadowRoot = T, T;
        }, Object.defineProperty(Z.prototype, "shadowRoot", { get: function() {
          var g = this._shadowRoot;
          return g === null || g.mode === "closed" ? null : g;
        }, enumerable: !0, configurable: !0 }), Z.prototype.closest = function(g) {
          throw new d.NotImplementedError();
        }, Z.prototype.matches = function(g) {
          throw new d.NotImplementedError();
        }, Z.prototype.webkitMatchesSelector = function(g) {
          return this.matches(g);
        }, Z.prototype.getElementsByTagName = function(g) {
          return p.node_listOfElementsWithQualifiedName(g, this);
        }, Z.prototype.getElementsByTagNameNS = function(g, f) {
          return p.node_listOfElementsWithNamespace(g, f, this);
        }, Z.prototype.getElementsByClassName = function(g) {
          return p.node_listOfElementsWithClassNames(g, this);
        }, Z.prototype.insertAdjacentElement = function(g, f) {
          return p.element_insertAdjacent(this, g, f);
        }, Z.prototype.insertAdjacentText = function(g, f) {
          var T = p.create_text(this._nodeDocument, f);
          p.element_insertAdjacent(this, g, T);
        }, Object.defineProperty(Z.prototype, "_qualifiedName", { get: function() {
          return this._namespacePrefix ? this._namespacePrefix + ":" + this._localName : this._localName;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(Z.prototype, "_htmlUppercasedQualifiedName", { get: function() {
          var g = this._qualifiedName;
          return this._namespace === h.namespace.HTML && this._nodeDocument._type === "html" && (g = g.toUpperCase()), g;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(Z.prototype, "children", { get: function() {
          throw new Error("Mixin: ParentNode not implemented.");
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(Z.prototype, "firstElementChild", { get: function() {
          throw new Error("Mixin: ParentNode not implemented.");
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(Z.prototype, "lastElementChild", { get: function() {
          throw new Error("Mixin: ParentNode not implemented.");
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(Z.prototype, "childElementCount", { get: function() {
          throw new Error("Mixin: ParentNode not implemented.");
        }, enumerable: !0, configurable: !0 }), Z.prototype.prepend = function() {
          for (var g = [], f = 0; f < arguments.length; f++) g[f] = arguments[f];
          throw new Error("Mixin: ParentNode not implemented.");
        }, Z.prototype.append = function() {
          for (var g = [], f = 0; f < arguments.length; f++) g[f] = arguments[f];
          throw new Error("Mixin: ParentNode not implemented.");
        }, Z.prototype.querySelector = function(g) {
          throw new Error("Mixin: ParentNode not implemented.");
        }, Z.prototype.querySelectorAll = function(g) {
          throw new Error("Mixin: ParentNode not implemented.");
        }, Object.defineProperty(Z.prototype, "previousElementSibling", { get: function() {
          throw new Error("Mixin: NonDocumentTypeChildNode not implemented.");
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(Z.prototype, "nextElementSibling", { get: function() {
          throw new Error("Mixin: NonDocumentTypeChildNode not implemented.");
        }, enumerable: !0, configurable: !0 }), Z.prototype.before = function() {
          for (var g = [], f = 0; f < arguments.length; f++) g[f] = arguments[f];
          throw new Error("Mixin: ChildNode not implemented.");
        }, Z.prototype.after = function() {
          for (var g = [], f = 0; f < arguments.length; f++) g[f] = arguments[f];
          throw new Error("Mixin: ChildNode not implemented.");
        }, Z.prototype.replaceWith = function() {
          for (var g = [], f = 0; f < arguments.length; f++) g[f] = arguments[f];
          throw new Error("Mixin: ChildNode not implemented.");
        }, Z.prototype.remove = function() {
          throw new Error("Mixin: ChildNode not implemented.");
        }, Object.defineProperty(Z.prototype, "assignedSlot", { get: function() {
          throw new Error("Mixin: Slotable not implemented.");
        }, enumerable: !0, configurable: !0 }), Z._create = function(g, f, T, M) {
          T === void 0 && (T = null), M === void 0 && (M = null);
          var N = new Z();
          return N._localName = f, N._namespace = T, N._namespacePrefix = M, N._nodeDocument = g, N;
        }, Z;
      })(u.NodeImpl);
      n.ElementImpl = b, m.idl_defineConst(b.prototype, "_nodeType", c.NodeType.Element);
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(d, h) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, m) {
          p.__proto__ = m;
        } || function(p, m) {
          for (var b in m) m.hasOwnProperty(b) && (p[b] = m[b]);
        })(d, h);
      }, function(d, h) {
        function p() {
          this.constructor = d;
        }
        r(d, h), d.prototype = h === null ? Object.create(h) : (p.prototype = h.prototype, new p());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(2), l = s(34), c = s(12), u = (function(d) {
        function h(p) {
          p === void 0 && (p = null);
          var m = d.call(this) || this;
          return m._children = /* @__PURE__ */ new Set(), m._host = p, m;
        }
        return a(h, d), h.prototype.getElementById = function(p) {
          throw new Error("Mixin: NonElementParentNode not implemented.");
        }, Object.defineProperty(h.prototype, "children", { get: function() {
          throw new Error("Mixin: ParentNode not implemented.");
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(h.prototype, "firstElementChild", { get: function() {
          throw new Error("Mixin: ParentNode not implemented.");
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(h.prototype, "lastElementChild", { get: function() {
          throw new Error("Mixin: ParentNode not implemented.");
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(h.prototype, "childElementCount", { get: function() {
          throw new Error("Mixin: ParentNode not implemented.");
        }, enumerable: !0, configurable: !0 }), h.prototype.prepend = function() {
          for (var p = [], m = 0; m < arguments.length; m++) p[m] = arguments[m];
          throw new Error("Mixin: ParentNode not implemented.");
        }, h.prototype.append = function() {
          for (var p = [], m = 0; m < arguments.length; m++) p[m] = arguments[m];
          throw new Error("Mixin: ParentNode not implemented.");
        }, h.prototype.querySelector = function(p) {
          throw new Error("Mixin: ParentNode not implemented.");
        }, h.prototype.querySelectorAll = function(p) {
          throw new Error("Mixin: ParentNode not implemented.");
        }, h._create = function(p, m) {
          m === void 0 && (m = null);
          var b = new h(m);
          return b._nodeDocument = p, b;
        }, h;
      })(l.NodeImpl);
      n.DocumentFragmentImpl = u, c.idl_defineConst(u.prototype, "_nodeType", o.NodeType.DocumentFragment);
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(p, m) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(b, y) {
          b.__proto__ = y;
        } || function(b, y) {
          for (var Z in y) y.hasOwnProperty(Z) && (b[Z] = y[Z]);
        })(p, m);
      }, function(p, m) {
        function b() {
          this.constructor = p;
        }
        r(p, m), p.prototype = m === null ? Object.create(m) : (b.prototype = m.prototype, new b());
      }), o = this && this.__values || function(p) {
        var m = typeof Symbol == "function" && Symbol.iterator, b = m && p[m], y = 0;
        if (b) return b.call(p);
        if (p && typeof p.length == "number") return { next: function() {
          return p && y >= p.length && (p = void 0), { value: p && p[y++], done: !p };
        } };
        throw new TypeError(m ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var l = s(2), c = s(71), u = s(0), d = s(12), h = (function(p) {
        function m(b) {
          b === void 0 && (b = "");
          var y = p.call(this, b) || this;
          return y._name = "", y._assignedSlot = null, y;
        }
        return a(m, p), Object.defineProperty(m.prototype, "wholeText", { get: function() {
          var b, y, Z = "";
          try {
            for (var g = o(u.text_contiguousTextNodes(this, !0)), f = g.next(); !f.done; f = g.next())
              Z += f.value._data;
          } catch (T) {
            b = { error: T };
          } finally {
            try {
              f && !f.done && (y = g.return) && y.call(g);
            } finally {
              if (b) throw b.error;
            }
          }
          return Z;
        }, enumerable: !0, configurable: !0 }), m.prototype.splitText = function(b) {
          return u.text_split(this, b);
        }, Object.defineProperty(m.prototype, "assignedSlot", { get: function() {
          throw new Error("Mixin: Slotable not implemented.");
        }, enumerable: !0, configurable: !0 }), m._create = function(b, y) {
          y === void 0 && (y = "");
          var Z = new m(y);
          return Z._nodeDocument = b, Z;
        }, m;
      })(c.CharacterDataImpl);
      n.TextImpl = h, d.idl_defineConst(h.prototype, "_nodeType", l.NodeType.Text);
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = (function() {
        function a() {
        }
        return Object.defineProperty(a.prototype, "_startNode", { get: function() {
          return this._start[0];
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(a.prototype, "_startOffset", { get: function() {
          return this._start[1];
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(a.prototype, "_endNode", { get: function() {
          return this._end[0];
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(a.prototype, "_endOffset", { get: function() {
          return this._end[1];
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(a.prototype, "_collapsed", { get: function() {
          return this._start[0] === this._end[0] && this._start[1] === this._end[1];
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(a.prototype, "startContainer", { get: function() {
          return this._startNode;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(a.prototype, "startOffset", { get: function() {
          return this._startOffset;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(a.prototype, "endContainer", { get: function() {
          return this._endNode;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(a.prototype, "endOffset", { get: function() {
          return this._endOffset;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(a.prototype, "collapsed", { get: function() {
          return this._collapsed;
        }, enumerable: !0, configurable: !0 }), a;
      })();
      n.AbstractRangeImpl = r;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(2), a = (function() {
        function o(l) {
          this._activeFlag = !1, this._root = l, this._whatToShow = r.WhatToShow.All, this._filter = null;
        }
        return Object.defineProperty(o.prototype, "root", { get: function() {
          return this._root;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(o.prototype, "whatToShow", { get: function() {
          return this._whatToShow;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(o.prototype, "filter", { get: function() {
          return this._filter;
        }, enumerable: !0, configurable: !0 }), o;
      })();
      n.TraverserImpl = a;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(2), a = s(0), o = s(12), l = (function() {
        function c(u, d) {
          this._target = null, this._relatedTarget = null, this._touchTargetList = [], this._path = [], this._currentTarget = null, this._eventPhase = r.EventPhase.None, this._stopPropagationFlag = !1, this._stopImmediatePropagationFlag = !1, this._canceledFlag = !1, this._inPassiveListenerFlag = !1, this._composedFlag = !1, this._initializedFlag = !1, this._dispatchFlag = !1, this._isTrusted = !1, this._bubbles = !1, this._cancelable = !1, this._type = u, d && (this._bubbles = d.bubbles || !1, this._cancelable = d.cancelable || !1, this._composedFlag = d.composed || !1), this._initializedFlag = !0, this._timeStamp = (/* @__PURE__ */ new Date()).getTime();
        }
        return Object.defineProperty(c.prototype, "type", { get: function() {
          return this._type;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(c.prototype, "target", { get: function() {
          return this._target;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(c.prototype, "srcElement", { get: function() {
          return this._target;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(c.prototype, "currentTarget", { get: function() {
          return this._currentTarget;
        }, enumerable: !0, configurable: !0 }), c.prototype.composedPath = function() {
          var u = [], d = this._path;
          if (d.length === 0) return u;
          var h = this._currentTarget;
          if (h === null) throw new Error("Event currentTarget is null.");
          u.push(h);
          for (var p = 0, m = 0, b = d.length - 1; b >= 0; ) {
            if (d[b].rootOfClosedTree && m++, d[b].invocationTarget === h) {
              p = b;
              break;
            }
            d[b].slotInClosedTree && m--, b--;
          }
          var y = m, Z = m;
          for (b = p - 1; b >= 0; ) d[b].rootOfClosedTree && y++, y <= Z && u.unshift(d[b].invocationTarget), d[b].slotInClosedTree && --y < Z && (Z = y), b--;
          for (y = m, Z = m, b = p + 1; b < d.length; ) d[b].slotInClosedTree && y++, y <= Z && u.push(d[b].invocationTarget), d[b].rootOfClosedTree && --y < Z && (Z = y), b++;
          return u;
        }, Object.defineProperty(c.prototype, "eventPhase", { get: function() {
          return this._eventPhase;
        }, enumerable: !0, configurable: !0 }), c.prototype.stopPropagation = function() {
          this._stopPropagationFlag = !0;
        }, Object.defineProperty(c.prototype, "cancelBubble", { get: function() {
          return this._stopPropagationFlag;
        }, set: function(u) {
          u && this.stopPropagation();
        }, enumerable: !0, configurable: !0 }), c.prototype.stopImmediatePropagation = function() {
          this._stopPropagationFlag = !0, this._stopImmediatePropagationFlag = !0;
        }, Object.defineProperty(c.prototype, "bubbles", { get: function() {
          return this._bubbles;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(c.prototype, "cancelable", { get: function() {
          return this._cancelable;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(c.prototype, "returnValue", { get: function() {
          return !this._canceledFlag;
        }, set: function(u) {
          u || a.event_setTheCanceledFlag(this);
        }, enumerable: !0, configurable: !0 }), c.prototype.preventDefault = function() {
          a.event_setTheCanceledFlag(this);
        }, Object.defineProperty(c.prototype, "defaultPrevented", { get: function() {
          return this._canceledFlag;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(c.prototype, "composed", { get: function() {
          return this._composedFlag;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(c.prototype, "isTrusted", { get: function() {
          return this._isTrusted;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(c.prototype, "timeStamp", { get: function() {
          return this._timeStamp;
        }, enumerable: !0, configurable: !0 }), c.prototype.initEvent = function(u, d, h) {
          d === void 0 && (d = !1), h === void 0 && (h = !1), this._dispatchFlag || a.event_initialize(this, u, d, h);
        }, c.NONE = 0, c.CAPTURING_PHASE = 1, c.AT_TARGET = 2, c.BUBBLING_PHASE = 3, c;
      })();
      n.EventImpl = l, o.idl_defineConst(l.prototype, "NONE", 0), o.idl_defineConst(l.prototype, "CAPTURING_PHASE", 1), o.idl_defineConst(l.prototype, "AT_TARGET", 2), o.idl_defineConst(l.prototype, "BUBBLING_PHASE", 3);
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(2), a = s(9);
      n.traversal_filter = function(o, l) {
        if (o._activeFlag) throw new a.InvalidStateError();
        var c = 1 << l._nodeType - 1;
        if ((o.whatToShow & c) == 0) return r.FilterResult.Skip;
        if (!o.filter) return r.FilterResult.Accept;
        o._activeFlag = !0;
        var u = r.FilterResult.Reject;
        try {
          u = o.filter.acceptNode(l);
        } catch (d) {
          throw o._activeFlag = !1, d;
        }
        return o._activeFlag = !1, u;
      };
    }, function(e, n, s) {
      var r = this && this.__read || function(Z, g) {
        var f = typeof Symbol == "function" && Z[Symbol.iterator];
        if (!f) return Z;
        var T, M, N = f.call(Z), W = [];
        try {
          for (; (g === void 0 || g-- > 0) && !(T = N.next()).done; ) W.push(T.value);
        } catch (x) {
          M = { error: x };
        } finally {
          try {
            T && !T.done && (f = N.return) && f.call(N);
          } finally {
            if (M) throw M.error;
          }
        }
        return W;
      }, a = this && this.__values || function(Z) {
        var g = typeof Symbol == "function" && Symbol.iterator, f = g && Z[g], T = 0;
        if (f) return f.call(Z);
        if (Z && typeof Z.length == "number") return { next: function() {
          return Z && T >= Z.length && (Z = void 0), { value: Z && Z[T++], done: !Z };
        } };
        throw new TypeError(g ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(6), l = s(3), c = s(1), u = s(99), d = s(73), h = s(17), p = s(173), m = s(30), b = s(52), y = s(37);
      n.document_elementInterface = function(Z, g) {
        return u.ElementImpl;
      }, n.document_internalCreateElementNS = function(Z, g, f, T) {
        var M = r(p.namespace_validateAndExtract(g, f), 3), N = M[0], W = M[1], x = M[2], V = null;
        return T !== void 0 && (V = c.isString(T) ? T : T.is), b.element_createAnElement(Z, x, N, W, V, !0);
      }, n.document_adopt = function(Z, g) {
        var f, T;
        if (Z._nodeDocument !== g || Z._parent !== null) {
          var M = Z._nodeDocument;
          if (Z._parent && y.mutation_remove(Z, Z._parent), g !== M) for (var N = h.tree_getFirstDescendantNode(Z, !0, !0); N !== null; ) {
            if (N._nodeDocument = g, l.Guard.isElementNode(N)) try {
              for (var W = (f = void 0, a(N._attributeList._asArray())), x = W.next(); !x.done; x = W.next())
                x.value._nodeDocument = g;
            } catch (V) {
              f = { error: V };
            } finally {
              try {
                x && !x.done && (T = W.return) && T.call(W);
              } finally {
                if (f) throw f.error;
              }
            }
            o.dom.features.customElements && l.Guard.isElementNode(N) && N._customElementState === "custom" && d.customElement_enqueueACustomElementCallbackReaction(N, "adoptedCallback", [M, g]), o.dom.features.steps && m.dom_runAdoptingSteps(N, M), N = h.tree_getNextDescendantNode(Z, N, !0, !0);
          }
        }
      };
    }, function(e, n, s) {
      var r = this && this.__values || function(h) {
        var p = typeof Symbol == "function" && Symbol.iterator, m = p && h[p], b = 0;
        if (m) return m.call(h);
        if (h && typeof h.length == "number") return { next: function() {
          return h && b >= h.length && (h = void 0), { value: h && h[b++], done: !h };
        } };
        throw new TypeError(p ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = s(6), o = s(3), l = s(9), c = s(17), u = s(51), d = s(30);
      n.characterData_replaceData = function(h, p, m, b) {
        var y, Z, g = c.tree_nodeLength(h);
        if (p > g) throw new l.IndexSizeError("Offset exceeds character data length. Offset: " + p + ", Length: " + g + ", Node is " + h.nodeName + ".");
        p + m > g && (m = g - p), a.dom.features.mutationObservers && u.observer_queueMutationRecord("characterData", h, null, null, h._data, [], [], null, null);
        var f = h._data.substring(0, p) + b + h._data.substring(p + m);
        h._data = f;
        try {
          for (var T = r(a.dom.rangeList), M = T.next(); !M.done; M = T.next()) {
            var N = M.value;
            N._start[0] === h && N._start[1] > p && N._start[1] <= p + m && (N._start[1] = p), N._end[0] === h && N._end[1] > p && N._end[1] <= p + m && (N._end[1] = p), N._start[0] === h && N._start[1] > p + m && (N._start[1] += b.length - m), N._end[0] === h && N._end[1] > p + m && (N._end[1] += b.length - m);
          }
        } catch (W) {
          y = { error: W };
        } finally {
          try {
            M && !M.done && (Z = T.return) && Z.call(T);
          } finally {
            if (y) throw y.error;
          }
        }
        a.dom.features.steps && o.Guard.isTextNode(h) && h._parent !== null && d.dom_runChildTextContentChangeSteps(h._parent);
      }, n.characterData_substringData = function(h, p, m) {
        var b = c.tree_nodeLength(h);
        if (p > b) throw new l.IndexSizeError("Offset exceeds character data length. Offset: " + p + ", Length: " + b + ", Node is " + h.nodeName + ".");
        return p + m > b ? h._data.substr(p) : h._data.substr(p, m);
      };
    }, function(e, n, s) {
      var r = this && this.__read || function(d, h) {
        var p = typeof Symbol == "function" && d[Symbol.iterator];
        if (!p) return d;
        var m, b, y = p.call(d), Z = [];
        try {
          for (; (h === void 0 || h-- > 0) && !(m = y.next()).done; ) Z.push(m.value);
        } catch (g) {
          b = { error: g };
        } finally {
          try {
            m && !m.done && (p = y.return) && p.call(y);
          } finally {
            if (b) throw b.error;
          }
        }
        return Z;
      }, a = this && this.__spread || function() {
        for (var d = [], h = 0; h < arguments.length; h++) d = d.concat(r(arguments[h]));
        return d;
      }, o = this && this.__values || function(d) {
        var h = typeof Symbol == "function" && Symbol.iterator, p = h && d[h], m = 0;
        if (p) return p.call(d);
        if (d && typeof d.length == "number") return { next: function() {
          return d && m >= d.length && (d = void 0), { value: d && d[m++], done: !d };
        } };
        throw new TypeError(h ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var l = s(7);
      function c(d) {
        var h = l.string.splitAStringOnASCIIWhitespace(d);
        return new Set(h);
      }
      function u(d) {
        return a(d).join(" ");
      }
      n.orderedSet_parse = c, n.orderedSet_serialize = u, n.orderedSet_sanitize = function(d) {
        return u(c(d));
      }, n.orderedSet_contains = function(d, h, p) {
        var m, b, y, Z;
        try {
          for (var g = o(h), f = g.next(); !f.done; f = g.next()) {
            var T = f.value, M = !1;
            try {
              for (var N = (y = void 0, o(d)), W = N.next(); !W.done; W = N.next()) {
                var x = W.value;
                if (p) {
                  if (x === T) {
                    M = !0;
                    break;
                  }
                } else if (x.toUpperCase() === T.toUpperCase()) {
                  M = !0;
                  break;
                }
              }
            } catch (V) {
              y = { error: V };
            } finally {
              try {
                W && !W.done && (Z = N.return) && Z.call(N);
              } finally {
                if (y) throw y.error;
              }
            }
            if (!M) return !1;
          }
        } catch (V) {
          m = { error: V };
        } finally {
          try {
            f && !f.done && (b = g.return) && b.call(g);
          } finally {
            if (m) throw m.error;
          }
        }
        return !0;
      };
    }, function(e, n, s) {
      s(179), Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(262), a = s(110), o = s(1);
      a.dom.setFeatures(!1), n.createDocument = function() {
        var l = new r.DOMImplementation().createDocument(null, "root", null);
        return l.documentElement && l.removeChild(l.documentElement), l;
      }, n.sanitizeInput = function(l, c) {
        if (l == null) return l;
        if (c === void 0) return l + "";
        var u = "";
        l += "";
        for (var d = 0; d < l.length; d++) {
          var h = l.charCodeAt(d);
          if (h === 9 || h === 10 || h === 13 || h >= 32 && h <= 55295 || h >= 57344 && h <= 65533) u += l.charAt(d);
          else if (h >= 55296 && h <= 56319 && d < l.length - 1) {
            var p = l.charCodeAt(d + 1);
            p >= 56320 && p <= 57343 ? (h = 1024 * (h - 55296) + p - 56320 + 65536, u += String.fromCodePoint(h), d++) : u += o.isString(c) ? c : c(l.charAt(d), d, l);
          } else u += o.isString(c) ? c : c(l.charAt(d), d, l);
        }
        return u;
      };
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(1), a = s(153);
      n.AbortController = a.AbortControllerImpl;
      var o = s(154);
      n.AbortSignal = o.AbortSignalImpl;
      var l = s(102);
      n.AbstractRange = l.AbstractRangeImpl;
      var c = s(157);
      n.Attr = c.AttrImpl;
      var u = s(158);
      n.CDATASection = u.CDATASectionImpl;
      var d = s(71);
      n.CharacterData = d.CharacterDataImpl;
      var h = s(263), p = s(159);
      n.Comment = p.CommentImpl;
      var m = s(171);
      n.CustomEvent = m.CustomEventImpl;
      var b = s(100);
      n.DocumentFragment = b.DocumentFragmentImpl;
      var y = s(98);
      n.Document = y.DocumentImpl;
      var Z = s(264), g = s(155);
      n.DocumentType = g.DocumentTypeImpl;
      var f = s(6);
      n.dom = f.dom;
      var T = s(148);
      n.DOMImplementation = T.DOMImplementationImpl;
      var M = s(170);
      n.DOMTokenList = M.DOMTokenListImpl;
      var N = s(99);
      n.Element = N.ElementImpl;
      var W = s(104);
      n.Event = W.EventImpl;
      var x = s(70);
      n.EventTarget = x.EventTargetImpl;
      var V = s(161);
      n.HTMLCollection = V.HTMLCollectionImpl;
      var X = s(265);
      n.MutationObserver = X.MutationObserverImpl;
      var C = s(169);
      n.MutationRecord = C.MutationRecordImpl;
      var R = s(164);
      n.NamedNodeMap = R.NamedNodeMapImpl;
      var z = s(168);
      n.NodeFilter = z.NodeFilterImpl;
      var F = s(34);
      n.Node = F.NodeImpl;
      var P = s(166);
      n.NodeIterator = P.NodeIteratorImpl;
      var j = s(162);
      n.NodeList = j.NodeListImpl;
      var H = s(163);
      n.NodeListStatic = H.NodeListStaticImpl;
      var B = s(266), $ = s(267), A = s(268), E = s(160);
      n.ProcessingInstruction = E.ProcessingInstructionImpl;
      var ct = s(165);
      n.Range = ct.RangeImpl;
      var at = s(156);
      n.ShadowRoot = at.ShadowRootImpl;
      var dt = s(269), gt = s(270);
      n.StaticRange = gt.StaticRangeImpl;
      var Wt = s(101);
      n.Text = Wt.TextImpl;
      var Zt = s(103);
      n.Traverser = Zt.TraverserImpl;
      var Gt = s(167);
      n.TreeWalker = Gt.TreeWalkerImpl;
      var Tt = s(149);
      n.Window = Tt.WindowImpl;
      var Q = s(151);
      n.XMLDocument = Q.XMLDocumentImpl, r.applyMixin(N.ElementImpl, h.ChildNodeImpl), r.applyMixin(d.CharacterDataImpl, h.ChildNodeImpl), r.applyMixin(g.DocumentTypeImpl, h.ChildNodeImpl), r.applyMixin(y.DocumentImpl, Z.DocumentOrShadowRootImpl), r.applyMixin(at.ShadowRootImpl, Z.DocumentOrShadowRootImpl), r.applyMixin(N.ElementImpl, B.NonDocumentTypeChildNodeImpl), r.applyMixin(d.CharacterDataImpl, B.NonDocumentTypeChildNodeImpl), r.applyMixin(y.DocumentImpl, $.NonElementParentNodeImpl), r.applyMixin(b.DocumentFragmentImpl, $.NonElementParentNodeImpl), r.applyMixin(y.DocumentImpl, A.ParentNodeImpl), r.applyMixin(b.DocumentFragmentImpl, A.ParentNodeImpl), r.applyMixin(N.ElementImpl, A.ParentNodeImpl), r.applyMixin(Wt.TextImpl, dt.SlotableImpl), r.applyMixin(N.ElementImpl, dt.SlotableImpl);
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 }), (function(r) {
        r[r.EOF = 0] = "EOF", r[r.Declaration = 1] = "Declaration", r[r.DocType = 2] = "DocType", r[r.Element = 3] = "Element", r[r.Text = 4] = "Text", r[r.CDATA = 5] = "CDATA", r[r.PI = 6] = "PI", r[r.Comment = 7] = "Comment", r[r.ClosingTag = 8] = "ClosingTag";
      })(n.TokenType || (n.TokenType = {}));
    }, function(e, n, s) {
      s(64), s(20), s(66);
      var r, a = this && this.__extends || (r = function(c, u) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, h) {
          d.__proto__ = h;
        } || function(d, h) {
          for (var p in h) h.hasOwnProperty(p) && (d[p] = h[p]);
        })(c, u);
      }, function(c, u) {
        function d() {
          this.constructor = c;
        }
        r(c, u), c.prototype = u === null ? Object.create(u) : (d.prototype = u.prototype, new d());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(1), l = (function(c) {
        function u() {
          return c !== null && c.apply(this, arguments) || this;
        }
        return a(u, c), u.prototype._parse = function(d, h) {
          var p = this, m = this._builderOptions, b = null;
          return o.isFunction(h) ? b = this.parse(d, h.apply(this)) : o.isArray(h) || o.isSet(h) ? o.forEachArray(h, (function(y) {
            return b = p.parse(d, y);
          }), this) : o.isMap(h) || o.isObject(h) ? o.forEachObject(h, (function(y, Z) {
            if (o.isFunction(Z) && (Z = Z.apply(p)), m.ignoreConverters || y.indexOf(m.convert.att) !== 0) if (m.ignoreConverters || y.indexOf(m.convert.text) !== 0) if (m.ignoreConverters || y.indexOf(m.convert.cdata) !== 0) if (m.ignoreConverters || y.indexOf(m.convert.comment) !== 0) if (m.ignoreConverters || y.indexOf(m.convert.ins) !== 0) {
              if (!((o.isArray(Z) || o.isSet(Z)) && o.isEmpty(Z))) {
                if ((o.isMap(Z) || o.isObject(Z)) && o.isEmpty(Z)) b = p.element(d, void 0, p.sanitize(y)) || b;
                else if (m.keepNullNodes || Z != null) if (o.isArray(Z) || o.isSet(Z)) o.forEachArray(Z, (function(N) {
                  var W = {};
                  W[y] = N, b = p.parse(d, W);
                }), p);
                else if (o.isMap(Z) || o.isObject(Z))
                  (g = p.element(d, void 0, p.sanitize(y))) && (b = g, p.parse(g, Z));
                else if (Z != null && Z !== "") {
                  var g;
                  (g = p.element(d, void 0, p.sanitize(y))) && (b = g, p.text(g, p._decodeText(p.sanitize(Z))));
                } else b = p.element(d, void 0, p.sanitize(y)) || b;
              }
            } else if (o.isString(Z)) {
              var f = Z.indexOf(" "), T = f === -1 ? Z : Z.substr(0, f), M = f === -1 ? "" : Z.substr(f + 1);
              b = p.instruction(d, p.sanitize(T), p.sanitize(M)) || b;
            } else o.isArray(Z) || o.isSet(Z) ? o.forEachArray(Z, (function(N) {
              var W = N.indexOf(" "), x = W === -1 ? N : N.substr(0, W), V = W === -1 ? "" : N.substr(W + 1);
              b = p.instruction(d, p.sanitize(x), p.sanitize(V)) || b;
            }), p) : o.forEachObject(Z, (function(N, W) {
              return b = p.instruction(d, p.sanitize(N), p.sanitize(W)) || b;
            }), p);
            else o.isArray(Z) || o.isSet(Z) ? o.forEachArray(Z, (function(N) {
              return b = p.comment(d, p.sanitize(N)) || b;
            }), p) : b = p.comment(d, p.sanitize(Z)) || b;
            else o.isArray(Z) || o.isSet(Z) ? o.forEachArray(Z, (function(N) {
              return b = p.cdata(d, p.sanitize(N)) || b;
            }), p) : b = p.cdata(d, p.sanitize(Z)) || b;
            else b = o.isMap(Z) || o.isObject(Z) ? p.parse(d, Z) : p.text(d, p._decodeText(p.sanitize(Z))) || b;
            else if (y === m.convert.att) {
              if (o.isArray(Z) || o.isSet(Z)) throw new Error("Invalid attribute: " + Z.toString() + ". " + d._debugInfo());
              o.forEachObject(Z, (function(N, W) {
                b = p.attribute(d, void 0, p.sanitize(N), p._decodeAttributeValue(p.sanitize(W))) || b;
              }));
            } else b = p.attribute(d, void 0, p.sanitize(y.substr(m.convert.att.length)), p._decodeAttributeValue(p.sanitize(Z))) || b;
          }), this) : (m.keepNullNodes || h != null) && (b = this.text(d, this._decodeText(this.sanitize(h))) || b), b || d;
        }, u;
      })(s(75).BaseReader);
      n.ObjectReader = l;
    }, function(e, n, s) {
      var r = s(39);
      e.exports = new r({ explicit: [s(286), s(287), s(288)] });
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = function(a) {
        this.level = 0, this._builderOptions = a, this._writerOptions = a;
      };
      n.BaseCBWriter = r;
    }, function(e, n, s) {
      var r = s(16), a = s(8), o = s(116);
      e.exports = !r && !a((function() {
        return Object.defineProperty(o("div"), "a", { get: function() {
          return 7;
        } }).a != 7;
      }));
    }, function(e, n, s) {
      var r = s(11), a = s(13), o = r.document, l = a(o) && a(o.createElement);
      e.exports = function(c) {
        return l ? o.createElement(c) : {};
      };
    }, function(e, n, s) {
      var r = s(118), a = Function.toString;
      typeof r.inspectSource != "function" && (r.inspectSource = function(o) {
        return a.call(o);
      }), e.exports = r.inspectSource;
    }, function(e, n, s) {
      var r = s(11), a = s(80), o = r["__core-js_shared__"] || a("__core-js_shared__", {});
      e.exports = o;
    }, function(e, n, s) {
      var r = s(14), a = s(187), o = s(55), l = s(15);
      e.exports = function(c, u) {
        for (var d = a(u), h = l.f, p = o.f, m = 0; m < d.length; m++) {
          var b = d[m];
          r(c, b) || h(c, b, p(u, b));
        }
      };
    }, function(e, n, s) {
      var r = s(11);
      e.exports = r;
    }, function(e, n, s) {
      var r = s(14), a = s(24), o = s(122).indexOf, l = s(45);
      e.exports = function(c, u) {
        var d, h = a(c), p = 0, m = [];
        for (d in h) !r(l, d) && r(h, d) && m.push(d);
        for (; u.length > p; ) r(h, d = u[p++]) && (~o(m, d) || m.push(d));
        return m;
      };
    }, function(e, n, s) {
      var r = s(24), a = s(26), o = s(83), l = function(c) {
        return function(u, d, h) {
          var p, m = r(u), b = a(m.length), y = o(h, b);
          if (c && d != d) {
            for (; b > y; ) if ((p = m[y++]) != p) return !0;
          } else for (; b > y; y++) if ((c || y in m) && m[y] === d) return c || y || 0;
          return !c && -1;
        };
      };
      e.exports = { includes: l(!0), indexOf: l(!1) };
    }, function(e, n, s) {
      var r = s(8), a = /#|\.prototype\./, o = function(h, p) {
        var m = c[l(h)];
        return m == d || m != u && (typeof p == "function" ? r(p) : !!p);
      }, l = o.normalize = function(h) {
        return String(h).replace(a, ".").toLowerCase();
      }, c = o.data = {}, u = o.NATIVE = "N", d = o.POLYFILL = "P";
      e.exports = o;
    }, function(e, n, s) {
      var r = s(86);
      e.exports = r && !Symbol.sham && typeof Symbol.iterator == "symbol";
    }, function(e, n, s) {
      var r = s(5);
      n.f = r;
    }, function(e, n, s) {
      var r = s(120), a = s(14), o = s(125), l = s(15).f;
      e.exports = function(c) {
        var u = r.Symbol || (r.Symbol = {});
        a(u, c) || l(u, c, { value: o.f(c) });
      };
    }, function(e, n) {
      e.exports = function(s) {
        if (typeof s != "function") throw TypeError(String(s) + " is not a function");
        return s;
      };
    }, function(e, n, s) {
      var r = s(13), a = s(59), o = s(5)("species");
      e.exports = function(l, c) {
        var u;
        return a(l) && (typeof (u = l.constructor) != "function" || u !== Array && !a(u.prototype) ? r(u) && (u = u[o]) === null && (u = void 0) : u = void 0), new (u === void 0 ? Array : u)(c === 0 ? 0 : c);
      };
    }, function(e, n, s) {
      var r, a, o = s(11), l = s(193), c = o.process, u = c && c.versions, d = u && u.v8;
      d ? a = (r = d.split("."))[0] + r[1] : l && (!(r = l.match(/Edge\/(\d+)/)) || r[1] >= 74) && (r = l.match(/Chrome\/(\d+)/)) && (a = r[1]), e.exports = a && +a;
    }, function(e, n, s) {
      var r = s(5), a = s(60), o = s(15), l = r("unscopables"), c = Array.prototype;
      c[l] == null && o.f(c, l, { configurable: !0, value: a(null) }), e.exports = function(u) {
        c[l][u] = !0;
      };
    }, function(e, n, s) {
      var r, a, o, l = s(132), c = s(21), u = s(14), d = s(5), h = s(44), p = d("iterator"), m = !1;
      [].keys && ("next" in (o = [].keys()) ? (a = l(l(o))) !== Object.prototype && (r = a) : m = !0), r == null && (r = {}), h || u(r, p) || c(r, p, (function() {
        return this;
      })), e.exports = { IteratorPrototype: r, BUGGY_SAFARI_ITERATORS: m };
    }, function(e, n, s) {
      var r = s(14), a = s(27), o = s(57), l = s(196), c = o("IE_PROTO"), u = Object.prototype;
      e.exports = l ? Object.getPrototypeOf : function(d) {
        return d = a(d), r(d, c) ? d[c] : typeof d.constructor == "function" && d instanceof d.constructor ? d.constructor.prototype : d instanceof Object ? u : null;
      };
    }, function(e, n, s) {
      var r = s(18), a = s(197);
      e.exports = Object.setPrototypeOf || ("__proto__" in {} ? (function() {
        var o, l = !1, c = {};
        try {
          (o = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(c, []), l = c instanceof Array;
        } catch {
        }
        return function(u, d) {
          return r(u), a(d), l ? o.call(u, d) : u.__proto__ = d, u;
        };
      })() : void 0);
    }, function(e, n, s) {
      var r = s(56), a = s(15), o = s(40);
      e.exports = function(l, c, u) {
        var d = r(c);
        d in l ? a.f(l, d, o(0, u)) : l[d] = u;
      };
    }, function(e, n, s) {
      var r = s(90), a = s(42), o = s(5)("toStringTag"), l = a(/* @__PURE__ */ (function() {
        return arguments;
      })()) == "Arguments";
      e.exports = r ? a : function(c) {
        var u, d, h;
        return c === void 0 ? "Undefined" : c === null ? "Null" : typeof (d = (function(p, m) {
          try {
            return p[m];
          } catch {
          }
        })(u = Object(c), o)) == "string" ? d : l ? a(u) : (h = a(u)) == "Object" && typeof u.callee == "function" ? "Arguments" : h;
      };
    }, function(e, n, s) {
      var r = s(18);
      e.exports = function() {
        var a = r(this), o = "";
        return a.global && (o += "g"), a.ignoreCase && (o += "i"), a.multiline && (o += "m"), a.dotAll && (o += "s"), a.unicode && (o += "u"), a.sticky && (o += "y"), o;
      };
    }, function(e, n, s) {
      var r = s(47), a = s(35), o = function(l) {
        return function(c, u) {
          var d, h, p = String(a(c)), m = r(u), b = p.length;
          return m < 0 || m >= b ? l ? "" : void 0 : (d = p.charCodeAt(m)) < 55296 || d > 56319 || m + 1 === b || (h = p.charCodeAt(m + 1)) < 56320 || h > 57343 ? l ? p.charAt(m) : d : l ? p.slice(m, m + 2) : h - 56320 + (d - 55296 << 10) + 65536;
        };
      };
      e.exports = { codeAt: o(!1), charAt: o(!0) };
    }, function(e, n, s) {
      var r = s(4), a = s(27), o = s(61);
      r({ target: "Object", stat: !0, forced: s(8)((function() {
        o(1);
      })) }, { keys: function(l) {
        return o(a(l));
      } });
    }, function(e, n, s) {
      var r = s(4), a = s(11), o = s(123), l = s(25), c = s(140), u = s(141), d = s(142), h = s(13), p = s(8), m = s(208), b = s(62), y = s(209);
      e.exports = function(Z, g, f) {
        var T = Z.indexOf("Map") !== -1, M = Z.indexOf("Weak") !== -1, N = T ? "set" : "add", W = a[Z], x = W && W.prototype, V = W, X = {}, C = function(H) {
          var B = x[H];
          l(x, H, H == "add" ? function($) {
            return B.call(this, $ === 0 ? 0 : $), this;
          } : H == "delete" ? function($) {
            return !(M && !h($)) && B.call(this, $ === 0 ? 0 : $);
          } : H == "get" ? function($) {
            return M && !h($) ? void 0 : B.call(this, $ === 0 ? 0 : $);
          } : H == "has" ? function($) {
            return !(M && !h($)) && B.call(this, $ === 0 ? 0 : $);
          } : function($, A) {
            return B.call(this, $ === 0 ? 0 : $, A), this;
          });
        };
        if (o(Z, typeof W != "function" || !(M || x.forEach && !p((function() {
          new W().entries().next();
        }))))) V = f.getConstructor(g, Z, T, N), c.REQUIRED = !0;
        else if (o(Z, !0)) {
          var R = new V(), z = R[N](M ? {} : -0, 1) != R, F = p((function() {
            R.has(1);
          })), P = m((function(H) {
            new W(H);
          })), j = !M && p((function() {
            for (var H = new W(), B = 5; B--; ) H[N](B, B);
            return !H.has(-0);
          }));
          P || ((V = g((function(H, B) {
            d(H, V, Z);
            var $ = y(new W(), H, V);
            return B != null && u(B, $[N], $, T), $;
          }))).prototype = x, x.constructor = V), (F || j) && (C("delete"), C("has"), T && C("get")), (j || z) && C(N), M && x.clear && delete x.clear;
        }
        return X[Z] = V, r({ global: !0, forced: V != W }, X), b(V, Z), M || f.setStrong(V, Z, T), V;
      };
    }, function(e, n, s) {
      var r = s(45), a = s(13), o = s(14), l = s(15).f, c = s(58), u = s(204), d = c("meta"), h = 0, p = Object.isExtensible || function() {
        return !0;
      }, m = function(y) {
        l(y, d, { value: { objectID: "O" + ++h, weakData: {} } });
      }, b = e.exports = { REQUIRED: !1, fastKey: function(y, Z) {
        if (!a(y)) return typeof y == "symbol" ? y : (typeof y == "string" ? "S" : "P") + y;
        if (!o(y, d)) {
          if (!p(y)) return "F";
          if (!Z) return "E";
          m(y);
        }
        return y[d].objectID;
      }, getWeakData: function(y, Z) {
        if (!o(y, d)) {
          if (!p(y)) return !0;
          if (!Z) return !1;
          m(y);
        }
        return y[d].weakData;
      }, onFreeze: function(y) {
        return u && b.REQUIRED && p(y) && !o(y, d) && m(y), y;
      } };
      r[d] = !0;
    }, function(e, n, s) {
      var r = s(18), a = s(205), o = s(26), l = s(87), c = s(206), u = s(207), d = function(h, p) {
        this.stopped = h, this.result = p;
      };
      (e.exports = function(h, p, m, b, y) {
        var Z, g, f, T, M, N, W, x = l(p, m, b ? 2 : 1);
        if (y) Z = h;
        else {
          if (typeof (g = c(h)) != "function") throw TypeError("Target is not iterable");
          if (a(g)) {
            for (f = 0, T = o(h.length); T > f; f++) if ((M = b ? x(r(W = h[f])[0], W[1]) : x(h[f])) && M instanceof d) return M;
            return new d(!1);
          }
          Z = g.call(h);
        }
        for (N = Z.next; !(W = N.call(Z)).done; ) if (typeof (M = u(Z, x, W.value, b)) == "object" && M && M instanceof d) return M;
        return new d(!1);
      }).stop = function(h) {
        return new d(!0, h);
      };
    }, function(e, n) {
      e.exports = function(s, r, a) {
        if (!(s instanceof r)) throw TypeError("Incorrect " + (a ? a + " " : "") + "invocation");
        return s;
      };
    }, function(e, n, s) {
      var r = s(15).f, a = s(60), o = s(210), l = s(87), c = s(142), u = s(141), d = s(88), h = s(211), p = s(16), m = s(140).fastKey, b = s(43), y = b.set, Z = b.getterFor;
      e.exports = { getConstructor: function(g, f, T, M) {
        var N = g((function(X, C) {
          c(X, N, f), y(X, { type: f, index: a(null), first: void 0, last: void 0, size: 0 }), p || (X.size = 0), C != null && u(C, X[M], X, T);
        })), W = Z(f), x = function(X, C, R) {
          var z, F, P = W(X), j = V(X, C);
          return j ? j.value = R : (P.last = j = { index: F = m(C, !0), key: C, value: R, previous: z = P.last, next: void 0, removed: !1 }, P.first || (P.first = j), z && (z.next = j), p ? P.size++ : X.size++, F !== "F" && (P.index[F] = j)), X;
        }, V = function(X, C) {
          var R, z = W(X), F = m(C);
          if (F !== "F") return z.index[F];
          for (R = z.first; R; R = R.next) if (R.key == C) return R;
        };
        return o(N.prototype, { clear: function() {
          for (var X = W(this), C = X.index, R = X.first; R; ) R.removed = !0, R.previous && (R.previous = R.previous.next = void 0), delete C[R.index], R = R.next;
          X.first = X.last = void 0, p ? X.size = 0 : this.size = 0;
        }, delete: function(X) {
          var C = W(this), R = V(this, X);
          if (R) {
            var z = R.next, F = R.previous;
            delete C.index[R.index], R.removed = !0, F && (F.next = z), z && (z.previous = F), C.first == R && (C.first = z), C.last == R && (C.last = F), p ? C.size-- : this.size--;
          }
          return !!R;
        }, forEach: function(X) {
          for (var C, R = W(this), z = l(X, arguments.length > 1 ? arguments[1] : void 0, 3); C = C ? C.next : R.first; ) for (z(C.value, C.key, this); C && C.removed; ) C = C.previous;
        }, has: function(X) {
          return !!V(this, X);
        } }), o(N.prototype, T ? { get: function(X) {
          var C = V(this, X);
          return C && C.value;
        }, set: function(X, C) {
          return x(this, X === 0 ? 0 : X, C);
        } } : { add: function(X) {
          return x(this, X = X === 0 ? 0 : X, X);
        } }), p && r(N.prototype, "size", { get: function() {
          return W(this).size;
        } }), N;
      }, setStrong: function(g, f, T) {
        var M = f + " Iterator", N = Z(f), W = Z(M);
        d(g, f, (function(x, V) {
          y(this, { type: M, target: x, state: N(x), kind: V, last: void 0 });
        }), (function() {
          for (var x = W(this), V = x.kind, X = x.last; X && X.removed; ) X = X.previous;
          return x.target && (x.last = X = X ? X.next : x.state.first) ? V == "keys" ? { value: X.key, done: !1 } : V == "values" ? { value: X.value, done: !1 } : { value: [X.key, X.value], done: !1 } : (x.target = void 0, { value: void 0, done: !0 });
        }), T ? "entries" : "values", !T, !0), h(f);
      } };
    }, function(e, n, s) {
      var r, a = s(4), o = s(55).f, l = s(26), c = s(222), u = s(35), d = s(224), h = s(44), p = "".endsWith, m = Math.min, b = d("endsWith");
      a({ target: "String", proto: !0, forced: !!(h || b || (r = o(String.prototype, "endsWith"), !r || r.writable)) && !b }, { endsWith: function(y) {
        var Z = String(u(this));
        c(y);
        var g = arguments.length > 1 ? arguments[1] : void 0, f = l(Z.length), T = g === void 0 ? f : m(l(g), f), M = String(y);
        return p ? p.call(Z, M, T) : Z.slice(T - M.length, T) === M;
      } });
    }, function(e, n, s) {
      (function(r) {
        /*!
         * The buffer module from node.js, for the browser.
         *
         * @author   Feross Aboukhadijeh <http://feross.org>
         * @license  MIT
         */
        var a = s(229), o = s(230), l = s(231);
        function c() {
          return d.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
        }
        function u(Q, D) {
          if (c() < D) throw new RangeError("Invalid typed array length");
          return d.TYPED_ARRAY_SUPPORT ? (Q = new Uint8Array(D)).__proto__ = d.prototype : (Q === null && (Q = new d(D)), Q.length = D), Q;
        }
        function d(Q, D, q) {
          if (!(d.TYPED_ARRAY_SUPPORT || this instanceof d)) return new d(Q, D, q);
          if (typeof Q == "number") {
            if (typeof D == "string") throw new Error("If encoding is specified then the first argument must be a string");
            return m(this, Q);
          }
          return h(this, Q, D, q);
        }
        function h(Q, D, q, nt) {
          if (typeof D == "number") throw new TypeError('"value" argument must not be a number');
          return typeof ArrayBuffer < "u" && D instanceof ArrayBuffer ? (function(et, ot, it, ht) {
            if (ot.byteLength, it < 0 || ot.byteLength < it) throw new RangeError("'offset' is out of bounds");
            if (ot.byteLength < it + (ht || 0)) throw new RangeError("'length' is out of bounds");
            return ot = it === void 0 && ht === void 0 ? new Uint8Array(ot) : ht === void 0 ? new Uint8Array(ot, it) : new Uint8Array(ot, it, ht), d.TYPED_ARRAY_SUPPORT ? (et = ot).__proto__ = d.prototype : et = b(et, ot), et;
          })(Q, D, q, nt) : typeof D == "string" ? (function(et, ot, it) {
            if (typeof it == "string" && it !== "" || (it = "utf8"), !d.isEncoding(it)) throw new TypeError('"encoding" must be a valid string encoding');
            var ht = 0 | Z(ot, it), lt = (et = u(et, ht)).write(ot, it);
            return lt !== ht && (et = et.slice(0, lt)), et;
          })(Q, D, q) : (function(et, ot) {
            if (d.isBuffer(ot)) {
              var it = 0 | y(ot.length);
              return (et = u(et, it)).length === 0 || ot.copy(et, 0, 0, it), et;
            }
            if (ot) {
              if (typeof ArrayBuffer < "u" && ot.buffer instanceof ArrayBuffer || "length" in ot) return typeof ot.length != "number" || (ht = ot.length) != ht ? u(et, 0) : b(et, ot);
              if (ot.type === "Buffer" && l(ot.data)) return b(et, ot.data);
            }
            var ht;
            throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
          })(Q, D);
        }
        function p(Q) {
          if (typeof Q != "number") throw new TypeError('"size" argument must be a number');
          if (Q < 0) throw new RangeError('"size" argument must not be negative');
        }
        function m(Q, D) {
          if (p(D), Q = u(Q, D < 0 ? 0 : 0 | y(D)), !d.TYPED_ARRAY_SUPPORT) for (var q = 0; q < D; ++q) Q[q] = 0;
          return Q;
        }
        function b(Q, D) {
          var q = D.length < 0 ? 0 : 0 | y(D.length);
          Q = u(Q, q);
          for (var nt = 0; nt < q; nt += 1) Q[nt] = 255 & D[nt];
          return Q;
        }
        function y(Q) {
          if (Q >= c()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + c().toString(16) + " bytes");
          return 0 | Q;
        }
        function Z(Q, D) {
          if (d.isBuffer(Q)) return Q.length;
          if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(Q) || Q instanceof ArrayBuffer)) return Q.byteLength;
          typeof Q != "string" && (Q = "" + Q);
          var q = Q.length;
          if (q === 0) return 0;
          for (var nt = !1; ; ) switch (D) {
            case "ascii":
            case "latin1":
            case "binary":
              return q;
            case "utf8":
            case "utf-8":
            case void 0:
              return Zt(Q).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * q;
            case "hex":
              return q >>> 1;
            case "base64":
              return Gt(Q).length;
            default:
              if (nt) return Zt(Q).length;
              D = ("" + D).toLowerCase(), nt = !0;
          }
        }
        function g(Q, D, q) {
          var nt = !1;
          if ((D === void 0 || D < 0) && (D = 0), D > this.length || ((q === void 0 || q > this.length) && (q = this.length), q <= 0) || (q >>>= 0) <= (D >>>= 0)) return "";
          for (Q || (Q = "utf8"); ; ) switch (Q) {
            case "hex":
              return j(this, D, q);
            case "utf8":
            case "utf-8":
              return z(this, D, q);
            case "ascii":
              return F(this, D, q);
            case "latin1":
            case "binary":
              return P(this, D, q);
            case "base64":
              return R(this, D, q);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return H(this, D, q);
            default:
              if (nt) throw new TypeError("Unknown encoding: " + Q);
              Q = (Q + "").toLowerCase(), nt = !0;
          }
        }
        function f(Q, D, q) {
          var nt = Q[D];
          Q[D] = Q[q], Q[q] = nt;
        }
        function T(Q, D, q, nt, et) {
          if (Q.length === 0) return -1;
          if (typeof q == "string" ? (nt = q, q = 0) : q > 2147483647 ? q = 2147483647 : q < -2147483648 && (q = -2147483648), q = +q, isNaN(q) && (q = et ? 0 : Q.length - 1), q < 0 && (q = Q.length + q), q >= Q.length) {
            if (et) return -1;
            q = Q.length - 1;
          } else if (q < 0) {
            if (!et) return -1;
            q = 0;
          }
          if (typeof D == "string" && (D = d.from(D, nt)), d.isBuffer(D)) return D.length === 0 ? -1 : M(Q, D, q, nt, et);
          if (typeof D == "number") return D &= 255, d.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? et ? Uint8Array.prototype.indexOf.call(Q, D, q) : Uint8Array.prototype.lastIndexOf.call(Q, D, q) : M(Q, [D], q, nt, et);
          throw new TypeError("val must be string, number or Buffer");
        }
        function M(Q, D, q, nt, et) {
          var ot, it = 1, ht = Q.length, lt = D.length;
          if (nt !== void 0 && ((nt = String(nt).toLowerCase()) === "ucs2" || nt === "ucs-2" || nt === "utf16le" || nt === "utf-16le")) {
            if (Q.length < 2 || D.length < 2) return -1;
            it = 2, ht /= 2, lt /= 2, q /= 2;
          }
          function mt(he, ue) {
            return it === 1 ? he[ue] : he.readUInt16BE(ue * it);
          }
          if (et) {
            var wt = -1;
            for (ot = q; ot < ht; ot++) if (mt(Q, ot) === mt(D, wt === -1 ? 0 : ot - wt)) {
              if (wt === -1 && (wt = ot), ot - wt + 1 === lt) return wt * it;
            } else wt !== -1 && (ot -= ot - wt), wt = -1;
          } else for (q + lt > ht && (q = ht - lt), ot = q; ot >= 0; ot--) {
            for (var Xt = !0, At = 0; At < lt; At++) if (mt(Q, ot + At) !== mt(D, At)) {
              Xt = !1;
              break;
            }
            if (Xt) return ot;
          }
          return -1;
        }
        function N(Q, D, q, nt) {
          q = Number(q) || 0;
          var et = Q.length - q;
          nt ? (nt = Number(nt)) > et && (nt = et) : nt = et;
          var ot = D.length;
          if (ot % 2 != 0) throw new TypeError("Invalid hex string");
          nt > ot / 2 && (nt = ot / 2);
          for (var it = 0; it < nt; ++it) {
            var ht = parseInt(D.substr(2 * it, 2), 16);
            if (isNaN(ht)) return it;
            Q[q + it] = ht;
          }
          return it;
        }
        function W(Q, D, q, nt) {
          return Tt(Zt(D, Q.length - q), Q, q, nt);
        }
        function x(Q, D, q, nt) {
          return Tt((function(et) {
            for (var ot = [], it = 0; it < et.length; ++it) ot.push(255 & et.charCodeAt(it));
            return ot;
          })(D), Q, q, nt);
        }
        function V(Q, D, q, nt) {
          return x(Q, D, q, nt);
        }
        function X(Q, D, q, nt) {
          return Tt(Gt(D), Q, q, nt);
        }
        function C(Q, D, q, nt) {
          return Tt((function(et, ot) {
            for (var it, ht, lt, mt = [], wt = 0; wt < et.length && !((ot -= 2) < 0); ++wt) it = et.charCodeAt(wt), ht = it >> 8, lt = it % 256, mt.push(lt), mt.push(ht);
            return mt;
          })(D, Q.length - q), Q, q, nt);
        }
        function R(Q, D, q) {
          return D === 0 && q === Q.length ? a.fromByteArray(Q) : a.fromByteArray(Q.slice(D, q));
        }
        function z(Q, D, q) {
          q = Math.min(Q.length, q);
          for (var nt = [], et = D; et < q; ) {
            var ot, it, ht, lt, mt = Q[et], wt = null, Xt = mt > 239 ? 4 : mt > 223 ? 3 : mt > 191 ? 2 : 1;
            if (et + Xt <= q) switch (Xt) {
              case 1:
                mt < 128 && (wt = mt);
                break;
              case 2:
                (192 & (ot = Q[et + 1])) == 128 && (lt = (31 & mt) << 6 | 63 & ot) > 127 && (wt = lt);
                break;
              case 3:
                ot = Q[et + 1], it = Q[et + 2], (192 & ot) == 128 && (192 & it) == 128 && (lt = (15 & mt) << 12 | (63 & ot) << 6 | 63 & it) > 2047 && (lt < 55296 || lt > 57343) && (wt = lt);
                break;
              case 4:
                ot = Q[et + 1], it = Q[et + 2], ht = Q[et + 3], (192 & ot) == 128 && (192 & it) == 128 && (192 & ht) == 128 && (lt = (15 & mt) << 18 | (63 & ot) << 12 | (63 & it) << 6 | 63 & ht) > 65535 && lt < 1114112 && (wt = lt);
            }
            wt === null ? (wt = 65533, Xt = 1) : wt > 65535 && (wt -= 65536, nt.push(wt >>> 10 & 1023 | 55296), wt = 56320 | 1023 & wt), nt.push(wt), et += Xt;
          }
          return (function(At) {
            var he = At.length;
            if (he <= 4096) return String.fromCharCode.apply(String, At);
            for (var ue = "", Dt = 0; Dt < he; ) ue += String.fromCharCode.apply(String, At.slice(Dt, Dt += 4096));
            return ue;
          })(nt);
        }
        n.Buffer = d, n.SlowBuffer = function(Q) {
          return +Q != Q && (Q = 0), d.alloc(+Q);
        }, n.INSPECT_MAX_BYTES = 50, d.TYPED_ARRAY_SUPPORT = r.TYPED_ARRAY_SUPPORT !== void 0 ? r.TYPED_ARRAY_SUPPORT : (function() {
          try {
            var Q = new Uint8Array(1);
            return Q.__proto__ = { __proto__: Uint8Array.prototype, foo: function() {
              return 42;
            } }, Q.foo() === 42 && typeof Q.subarray == "function" && Q.subarray(1, 1).byteLength === 0;
          } catch {
            return !1;
          }
        })(), n.kMaxLength = c(), d.poolSize = 8192, d._augment = function(Q) {
          return Q.__proto__ = d.prototype, Q;
        }, d.from = function(Q, D, q) {
          return h(null, Q, D, q);
        }, d.TYPED_ARRAY_SUPPORT && (d.prototype.__proto__ = Uint8Array.prototype, d.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && d[Symbol.species] === d && Object.defineProperty(d, Symbol.species, { value: null, configurable: !0 })), d.alloc = function(Q, D, q) {
          return (function(nt, et, ot, it) {
            return p(et), et <= 0 ? u(nt, et) : ot !== void 0 ? typeof it == "string" ? u(nt, et).fill(ot, it) : u(nt, et).fill(ot) : u(nt, et);
          })(null, Q, D, q);
        }, d.allocUnsafe = function(Q) {
          return m(null, Q);
        }, d.allocUnsafeSlow = function(Q) {
          return m(null, Q);
        }, d.isBuffer = function(Q) {
          return !(Q == null || !Q._isBuffer);
        }, d.compare = function(Q, D) {
          if (!d.isBuffer(Q) || !d.isBuffer(D)) throw new TypeError("Arguments must be Buffers");
          if (Q === D) return 0;
          for (var q = Q.length, nt = D.length, et = 0, ot = Math.min(q, nt); et < ot; ++et) if (Q[et] !== D[et]) {
            q = Q[et], nt = D[et];
            break;
          }
          return q < nt ? -1 : nt < q ? 1 : 0;
        }, d.isEncoding = function(Q) {
          switch (String(Q).toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return !0;
            default:
              return !1;
          }
        }, d.concat = function(Q, D) {
          if (!l(Q)) throw new TypeError('"list" argument must be an Array of Buffers');
          if (Q.length === 0) return d.alloc(0);
          var q;
          if (D === void 0) for (D = 0, q = 0; q < Q.length; ++q) D += Q[q].length;
          var nt = d.allocUnsafe(D), et = 0;
          for (q = 0; q < Q.length; ++q) {
            var ot = Q[q];
            if (!d.isBuffer(ot)) throw new TypeError('"list" argument must be an Array of Buffers');
            ot.copy(nt, et), et += ot.length;
          }
          return nt;
        }, d.byteLength = Z, d.prototype._isBuffer = !0, d.prototype.swap16 = function() {
          var Q = this.length;
          if (Q % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
          for (var D = 0; D < Q; D += 2) f(this, D, D + 1);
          return this;
        }, d.prototype.swap32 = function() {
          var Q = this.length;
          if (Q % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
          for (var D = 0; D < Q; D += 4) f(this, D, D + 3), f(this, D + 1, D + 2);
          return this;
        }, d.prototype.swap64 = function() {
          var Q = this.length;
          if (Q % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
          for (var D = 0; D < Q; D += 8) f(this, D, D + 7), f(this, D + 1, D + 6), f(this, D + 2, D + 5), f(this, D + 3, D + 4);
          return this;
        }, d.prototype.toString = function() {
          var Q = 0 | this.length;
          return Q === 0 ? "" : arguments.length === 0 ? z(this, 0, Q) : g.apply(this, arguments);
        }, d.prototype.equals = function(Q) {
          if (!d.isBuffer(Q)) throw new TypeError("Argument must be a Buffer");
          return this === Q || d.compare(this, Q) === 0;
        }, d.prototype.inspect = function() {
          var Q = "", D = n.INSPECT_MAX_BYTES;
          return this.length > 0 && (Q = this.toString("hex", 0, D).match(/.{2}/g).join(" "), this.length > D && (Q += " ... ")), "<Buffer " + Q + ">";
        }, d.prototype.compare = function(Q, D, q, nt, et) {
          if (!d.isBuffer(Q)) throw new TypeError("Argument must be a Buffer");
          if (D === void 0 && (D = 0), q === void 0 && (q = Q ? Q.length : 0), nt === void 0 && (nt = 0), et === void 0 && (et = this.length), D < 0 || q > Q.length || nt < 0 || et > this.length) throw new RangeError("out of range index");
          if (nt >= et && D >= q) return 0;
          if (nt >= et) return -1;
          if (D >= q) return 1;
          if (this === Q) return 0;
          for (var ot = (et >>>= 0) - (nt >>>= 0), it = (q >>>= 0) - (D >>>= 0), ht = Math.min(ot, it), lt = this.slice(nt, et), mt = Q.slice(D, q), wt = 0; wt < ht; ++wt) if (lt[wt] !== mt[wt]) {
            ot = lt[wt], it = mt[wt];
            break;
          }
          return ot < it ? -1 : it < ot ? 1 : 0;
        }, d.prototype.includes = function(Q, D, q) {
          return this.indexOf(Q, D, q) !== -1;
        }, d.prototype.indexOf = function(Q, D, q) {
          return T(this, Q, D, q, !0);
        }, d.prototype.lastIndexOf = function(Q, D, q) {
          return T(this, Q, D, q, !1);
        }, d.prototype.write = function(Q, D, q, nt) {
          if (D === void 0) nt = "utf8", q = this.length, D = 0;
          else if (q === void 0 && typeof D == "string") nt = D, q = this.length, D = 0;
          else {
            if (!isFinite(D)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
            D |= 0, isFinite(q) ? (q |= 0, nt === void 0 && (nt = "utf8")) : (nt = q, q = void 0);
          }
          var et = this.length - D;
          if ((q === void 0 || q > et) && (q = et), Q.length > 0 && (q < 0 || D < 0) || D > this.length) throw new RangeError("Attempt to write outside buffer bounds");
          nt || (nt = "utf8");
          for (var ot = !1; ; ) switch (nt) {
            case "hex":
              return N(this, Q, D, q);
            case "utf8":
            case "utf-8":
              return W(this, Q, D, q);
            case "ascii":
              return x(this, Q, D, q);
            case "latin1":
            case "binary":
              return V(this, Q, D, q);
            case "base64":
              return X(this, Q, D, q);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return C(this, Q, D, q);
            default:
              if (ot) throw new TypeError("Unknown encoding: " + nt);
              nt = ("" + nt).toLowerCase(), ot = !0;
          }
        }, d.prototype.toJSON = function() {
          return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
        };
        function F(Q, D, q) {
          var nt = "";
          q = Math.min(Q.length, q);
          for (var et = D; et < q; ++et) nt += String.fromCharCode(127 & Q[et]);
          return nt;
        }
        function P(Q, D, q) {
          var nt = "";
          q = Math.min(Q.length, q);
          for (var et = D; et < q; ++et) nt += String.fromCharCode(Q[et]);
          return nt;
        }
        function j(Q, D, q) {
          var nt = Q.length;
          (!D || D < 0) && (D = 0), (!q || q < 0 || q > nt) && (q = nt);
          for (var et = "", ot = D; ot < q; ++ot) et += Wt(Q[ot]);
          return et;
        }
        function H(Q, D, q) {
          for (var nt = Q.slice(D, q), et = "", ot = 0; ot < nt.length; ot += 2) et += String.fromCharCode(nt[ot] + 256 * nt[ot + 1]);
          return et;
        }
        function B(Q, D, q) {
          if (Q % 1 != 0 || Q < 0) throw new RangeError("offset is not uint");
          if (Q + D > q) throw new RangeError("Trying to access beyond buffer length");
        }
        function $(Q, D, q, nt, et, ot) {
          if (!d.isBuffer(Q)) throw new TypeError('"buffer" argument must be a Buffer instance');
          if (D > et || D < ot) throw new RangeError('"value" argument is out of bounds');
          if (q + nt > Q.length) throw new RangeError("Index out of range");
        }
        function A(Q, D, q, nt) {
          D < 0 && (D = 65535 + D + 1);
          for (var et = 0, ot = Math.min(Q.length - q, 2); et < ot; ++et) Q[q + et] = (D & 255 << 8 * (nt ? et : 1 - et)) >>> 8 * (nt ? et : 1 - et);
        }
        function E(Q, D, q, nt) {
          D < 0 && (D = 4294967295 + D + 1);
          for (var et = 0, ot = Math.min(Q.length - q, 4); et < ot; ++et) Q[q + et] = D >>> 8 * (nt ? et : 3 - et) & 255;
        }
        function ct(Q, D, q, nt, et, ot) {
          if (q + nt > Q.length) throw new RangeError("Index out of range");
          if (q < 0) throw new RangeError("Index out of range");
        }
        function at(Q, D, q, nt, et) {
          return et || ct(Q, 0, q, 4), o.write(Q, D, q, nt, 23, 4), q + 4;
        }
        function dt(Q, D, q, nt, et) {
          return et || ct(Q, 0, q, 8), o.write(Q, D, q, nt, 52, 8), q + 8;
        }
        d.prototype.slice = function(Q, D) {
          var q, nt = this.length;
          if ((Q = ~~Q) < 0 ? (Q += nt) < 0 && (Q = 0) : Q > nt && (Q = nt), (D = D === void 0 ? nt : ~~D) < 0 ? (D += nt) < 0 && (D = 0) : D > nt && (D = nt), D < Q && (D = Q), d.TYPED_ARRAY_SUPPORT) (q = this.subarray(Q, D)).__proto__ = d.prototype;
          else {
            var et = D - Q;
            q = new d(et, void 0);
            for (var ot = 0; ot < et; ++ot) q[ot] = this[ot + Q];
          }
          return q;
        }, d.prototype.readUIntLE = function(Q, D, q) {
          Q |= 0, D |= 0, q || B(Q, D, this.length);
          for (var nt = this[Q], et = 1, ot = 0; ++ot < D && (et *= 256); ) nt += this[Q + ot] * et;
          return nt;
        }, d.prototype.readUIntBE = function(Q, D, q) {
          Q |= 0, D |= 0, q || B(Q, D, this.length);
          for (var nt = this[Q + --D], et = 1; D > 0 && (et *= 256); ) nt += this[Q + --D] * et;
          return nt;
        }, d.prototype.readUInt8 = function(Q, D) {
          return D || B(Q, 1, this.length), this[Q];
        }, d.prototype.readUInt16LE = function(Q, D) {
          return D || B(Q, 2, this.length), this[Q] | this[Q + 1] << 8;
        }, d.prototype.readUInt16BE = function(Q, D) {
          return D || B(Q, 2, this.length), this[Q] << 8 | this[Q + 1];
        }, d.prototype.readUInt32LE = function(Q, D) {
          return D || B(Q, 4, this.length), (this[Q] | this[Q + 1] << 8 | this[Q + 2] << 16) + 16777216 * this[Q + 3];
        }, d.prototype.readUInt32BE = function(Q, D) {
          return D || B(Q, 4, this.length), 16777216 * this[Q] + (this[Q + 1] << 16 | this[Q + 2] << 8 | this[Q + 3]);
        }, d.prototype.readIntLE = function(Q, D, q) {
          Q |= 0, D |= 0, q || B(Q, D, this.length);
          for (var nt = this[Q], et = 1, ot = 0; ++ot < D && (et *= 256); ) nt += this[Q + ot] * et;
          return nt >= (et *= 128) && (nt -= Math.pow(2, 8 * D)), nt;
        }, d.prototype.readIntBE = function(Q, D, q) {
          Q |= 0, D |= 0, q || B(Q, D, this.length);
          for (var nt = D, et = 1, ot = this[Q + --nt]; nt > 0 && (et *= 256); ) ot += this[Q + --nt] * et;
          return ot >= (et *= 128) && (ot -= Math.pow(2, 8 * D)), ot;
        }, d.prototype.readInt8 = function(Q, D) {
          return D || B(Q, 1, this.length), 128 & this[Q] ? -1 * (255 - this[Q] + 1) : this[Q];
        }, d.prototype.readInt16LE = function(Q, D) {
          D || B(Q, 2, this.length);
          var q = this[Q] | this[Q + 1] << 8;
          return 32768 & q ? 4294901760 | q : q;
        }, d.prototype.readInt16BE = function(Q, D) {
          D || B(Q, 2, this.length);
          var q = this[Q + 1] | this[Q] << 8;
          return 32768 & q ? 4294901760 | q : q;
        }, d.prototype.readInt32LE = function(Q, D) {
          return D || B(Q, 4, this.length), this[Q] | this[Q + 1] << 8 | this[Q + 2] << 16 | this[Q + 3] << 24;
        }, d.prototype.readInt32BE = function(Q, D) {
          return D || B(Q, 4, this.length), this[Q] << 24 | this[Q + 1] << 16 | this[Q + 2] << 8 | this[Q + 3];
        }, d.prototype.readFloatLE = function(Q, D) {
          return D || B(Q, 4, this.length), o.read(this, Q, !0, 23, 4);
        }, d.prototype.readFloatBE = function(Q, D) {
          return D || B(Q, 4, this.length), o.read(this, Q, !1, 23, 4);
        }, d.prototype.readDoubleLE = function(Q, D) {
          return D || B(Q, 8, this.length), o.read(this, Q, !0, 52, 8);
        }, d.prototype.readDoubleBE = function(Q, D) {
          return D || B(Q, 8, this.length), o.read(this, Q, !1, 52, 8);
        }, d.prototype.writeUIntLE = function(Q, D, q, nt) {
          Q = +Q, D |= 0, q |= 0, nt || $(this, Q, D, q, Math.pow(2, 8 * q) - 1, 0);
          var et = 1, ot = 0;
          for (this[D] = 255 & Q; ++ot < q && (et *= 256); ) this[D + ot] = Q / et & 255;
          return D + q;
        }, d.prototype.writeUIntBE = function(Q, D, q, nt) {
          Q = +Q, D |= 0, q |= 0, nt || $(this, Q, D, q, Math.pow(2, 8 * q) - 1, 0);
          var et = q - 1, ot = 1;
          for (this[D + et] = 255 & Q; --et >= 0 && (ot *= 256); ) this[D + et] = Q / ot & 255;
          return D + q;
        }, d.prototype.writeUInt8 = function(Q, D, q) {
          return Q = +Q, D |= 0, q || $(this, Q, D, 1, 255, 0), d.TYPED_ARRAY_SUPPORT || (Q = Math.floor(Q)), this[D] = 255 & Q, D + 1;
        }, d.prototype.writeUInt16LE = function(Q, D, q) {
          return Q = +Q, D |= 0, q || $(this, Q, D, 2, 65535, 0), d.TYPED_ARRAY_SUPPORT ? (this[D] = 255 & Q, this[D + 1] = Q >>> 8) : A(this, Q, D, !0), D + 2;
        }, d.prototype.writeUInt16BE = function(Q, D, q) {
          return Q = +Q, D |= 0, q || $(this, Q, D, 2, 65535, 0), d.TYPED_ARRAY_SUPPORT ? (this[D] = Q >>> 8, this[D + 1] = 255 & Q) : A(this, Q, D, !1), D + 2;
        }, d.prototype.writeUInt32LE = function(Q, D, q) {
          return Q = +Q, D |= 0, q || $(this, Q, D, 4, 4294967295, 0), d.TYPED_ARRAY_SUPPORT ? (this[D + 3] = Q >>> 24, this[D + 2] = Q >>> 16, this[D + 1] = Q >>> 8, this[D] = 255 & Q) : E(this, Q, D, !0), D + 4;
        }, d.prototype.writeUInt32BE = function(Q, D, q) {
          return Q = +Q, D |= 0, q || $(this, Q, D, 4, 4294967295, 0), d.TYPED_ARRAY_SUPPORT ? (this[D] = Q >>> 24, this[D + 1] = Q >>> 16, this[D + 2] = Q >>> 8, this[D + 3] = 255 & Q) : E(this, Q, D, !1), D + 4;
        }, d.prototype.writeIntLE = function(Q, D, q, nt) {
          if (Q = +Q, D |= 0, !nt) {
            var et = Math.pow(2, 8 * q - 1);
            $(this, Q, D, q, et - 1, -et);
          }
          var ot = 0, it = 1, ht = 0;
          for (this[D] = 255 & Q; ++ot < q && (it *= 256); ) Q < 0 && ht === 0 && this[D + ot - 1] !== 0 && (ht = 1), this[D + ot] = (Q / it >> 0) - ht & 255;
          return D + q;
        }, d.prototype.writeIntBE = function(Q, D, q, nt) {
          if (Q = +Q, D |= 0, !nt) {
            var et = Math.pow(2, 8 * q - 1);
            $(this, Q, D, q, et - 1, -et);
          }
          var ot = q - 1, it = 1, ht = 0;
          for (this[D + ot] = 255 & Q; --ot >= 0 && (it *= 256); ) Q < 0 && ht === 0 && this[D + ot + 1] !== 0 && (ht = 1), this[D + ot] = (Q / it >> 0) - ht & 255;
          return D + q;
        }, d.prototype.writeInt8 = function(Q, D, q) {
          return Q = +Q, D |= 0, q || $(this, Q, D, 1, 127, -128), d.TYPED_ARRAY_SUPPORT || (Q = Math.floor(Q)), Q < 0 && (Q = 255 + Q + 1), this[D] = 255 & Q, D + 1;
        }, d.prototype.writeInt16LE = function(Q, D, q) {
          return Q = +Q, D |= 0, q || $(this, Q, D, 2, 32767, -32768), d.TYPED_ARRAY_SUPPORT ? (this[D] = 255 & Q, this[D + 1] = Q >>> 8) : A(this, Q, D, !0), D + 2;
        }, d.prototype.writeInt16BE = function(Q, D, q) {
          return Q = +Q, D |= 0, q || $(this, Q, D, 2, 32767, -32768), d.TYPED_ARRAY_SUPPORT ? (this[D] = Q >>> 8, this[D + 1] = 255 & Q) : A(this, Q, D, !1), D + 2;
        }, d.prototype.writeInt32LE = function(Q, D, q) {
          return Q = +Q, D |= 0, q || $(this, Q, D, 4, 2147483647, -2147483648), d.TYPED_ARRAY_SUPPORT ? (this[D] = 255 & Q, this[D + 1] = Q >>> 8, this[D + 2] = Q >>> 16, this[D + 3] = Q >>> 24) : E(this, Q, D, !0), D + 4;
        }, d.prototype.writeInt32BE = function(Q, D, q) {
          return Q = +Q, D |= 0, q || $(this, Q, D, 4, 2147483647, -2147483648), Q < 0 && (Q = 4294967295 + Q + 1), d.TYPED_ARRAY_SUPPORT ? (this[D] = Q >>> 24, this[D + 1] = Q >>> 16, this[D + 2] = Q >>> 8, this[D + 3] = 255 & Q) : E(this, Q, D, !1), D + 4;
        }, d.prototype.writeFloatLE = function(Q, D, q) {
          return at(this, Q, D, !0, q);
        }, d.prototype.writeFloatBE = function(Q, D, q) {
          return at(this, Q, D, !1, q);
        }, d.prototype.writeDoubleLE = function(Q, D, q) {
          return dt(this, Q, D, !0, q);
        }, d.prototype.writeDoubleBE = function(Q, D, q) {
          return dt(this, Q, D, !1, q);
        }, d.prototype.copy = function(Q, D, q, nt) {
          if (q || (q = 0), nt || nt === 0 || (nt = this.length), D >= Q.length && (D = Q.length), D || (D = 0), nt > 0 && nt < q && (nt = q), nt === q || Q.length === 0 || this.length === 0) return 0;
          if (D < 0) throw new RangeError("targetStart out of bounds");
          if (q < 0 || q >= this.length) throw new RangeError("sourceStart out of bounds");
          if (nt < 0) throw new RangeError("sourceEnd out of bounds");
          nt > this.length && (nt = this.length), Q.length - D < nt - q && (nt = Q.length - D + q);
          var et, ot = nt - q;
          if (this === Q && q < D && D < nt) for (et = ot - 1; et >= 0; --et) Q[et + D] = this[et + q];
          else if (ot < 1e3 || !d.TYPED_ARRAY_SUPPORT) for (et = 0; et < ot; ++et) Q[et + D] = this[et + q];
          else Uint8Array.prototype.set.call(Q, this.subarray(q, q + ot), D);
          return ot;
        }, d.prototype.fill = function(Q, D, q, nt) {
          if (typeof Q == "string") {
            if (typeof D == "string" ? (nt = D, D = 0, q = this.length) : typeof q == "string" && (nt = q, q = this.length), Q.length === 1) {
              var et = Q.charCodeAt(0);
              et < 256 && (Q = et);
            }
            if (nt !== void 0 && typeof nt != "string") throw new TypeError("encoding must be a string");
            if (typeof nt == "string" && !d.isEncoding(nt)) throw new TypeError("Unknown encoding: " + nt);
          } else typeof Q == "number" && (Q &= 255);
          if (D < 0 || this.length < D || this.length < q) throw new RangeError("Out of range index");
          if (q <= D) return this;
          var ot;
          if (D >>>= 0, q = q === void 0 ? this.length : q >>> 0, Q || (Q = 0), typeof Q == "number") for (ot = D; ot < q; ++ot) this[ot] = Q;
          else {
            var it = d.isBuffer(Q) ? Q : Zt(new d(Q, nt).toString()), ht = it.length;
            for (ot = 0; ot < q - D; ++ot) this[ot + D] = it[ot % ht];
          }
          return this;
        };
        var gt = /[^+\/0-9A-Za-z-_]/g;
        function Wt(Q) {
          return Q < 16 ? "0" + Q.toString(16) : Q.toString(16);
        }
        function Zt(Q, D) {
          var q;
          D = D || 1 / 0;
          for (var nt = Q.length, et = null, ot = [], it = 0; it < nt; ++it) {
            if ((q = Q.charCodeAt(it)) > 55295 && q < 57344) {
              if (!et) {
                if (q > 56319) {
                  (D -= 3) > -1 && ot.push(239, 191, 189);
                  continue;
                }
                if (it + 1 === nt) {
                  (D -= 3) > -1 && ot.push(239, 191, 189);
                  continue;
                }
                et = q;
                continue;
              }
              if (q < 56320) {
                (D -= 3) > -1 && ot.push(239, 191, 189), et = q;
                continue;
              }
              q = 65536 + (et - 55296 << 10 | q - 56320);
            } else et && (D -= 3) > -1 && ot.push(239, 191, 189);
            if (et = null, q < 128) {
              if ((D -= 1) < 0) break;
              ot.push(q);
            } else if (q < 2048) {
              if ((D -= 2) < 0) break;
              ot.push(q >> 6 | 192, 63 & q | 128);
            } else if (q < 65536) {
              if ((D -= 3) < 0) break;
              ot.push(q >> 12 | 224, q >> 6 & 63 | 128, 63 & q | 128);
            } else {
              if (!(q < 1114112)) throw new Error("Invalid code point");
              if ((D -= 4) < 0) break;
              ot.push(q >> 18 | 240, q >> 12 & 63 | 128, q >> 6 & 63 | 128, 63 & q | 128);
            }
          }
          return ot;
        }
        function Gt(Q) {
          return a.toByteArray((function(D) {
            if ((D = (function(q) {
              return q.trim ? q.trim() : q.replace(/^\s+|\s+$/g, "");
            })(D).replace(gt, "")).length < 2) return "";
            for (; D.length % 4 != 0; ) D += "=";
            return D;
          })(Q));
        }
        function Tt(Q, D, q, nt) {
          for (var et = 0; et < nt && !(et + q >= D.length || et >= Q.length); ++et) D[et + q] = Q[et];
          return et;
        }
      }).call(this, s(78));
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 }), n.isASCIIByte = function(r) {
        return r >= 0 && r <= 127;
      };
    }, function(e, n, s) {
      var r = this && this.__read || function(o, l) {
        var c = typeof Symbol == "function" && o[Symbol.iterator];
        if (!c) return o;
        var u, d, h = c.call(o), p = [];
        try {
          for (; (l === void 0 || l-- > 0) && !(u = h.next()).done; ) p.push(u.value);
        } catch (m) {
          d = { error: m };
        } finally {
          try {
            u && !u.done && (c = h.return) && c.call(h);
          } finally {
            if (d) throw d.error;
          }
        }
        return p;
      }, a = this && this.__spread || function() {
        for (var o = [], l = 0; l < arguments.length; l++) o = o.concat(r(arguments[l]));
        return o;
      };
      Object.defineProperty(n, "__esModule", { value: !0 }), n.length = function(o) {
        return o.length;
      }, n.byteLowercase = function(o) {
        for (var l = 0; l < o.length; l++) {
          var c = o[l];
          c >= 65 && c <= 90 && (o[l] = c + 32);
        }
      }, n.byteUppercase = function(o) {
        for (var l = 0; l < o.length; l++) {
          var c = o[l];
          c >= 97 && c <= 122 && (o[l] = c - 32);
        }
      }, n.byteCaseInsensitiveMatch = function(o, l) {
        if (o.length !== l.length) return !1;
        for (var c = 0; c < o.length; c++) {
          var u = o[c], d = l[c];
          if (u >= 65 && u <= 90 && (u += 32), d >= 65 && d <= 90 && (d += 32), u !== d) return !1;
        }
        return !0;
      }, n.startsWith = function(o, l) {
        for (var c = 0; ; ) {
          if (c >= o.length) return !1;
          if (c >= l.length) return !0;
          if (o[c] !== l[c]) return !1;
          c++;
        }
      }, n.byteLessThan = function(o, l) {
        for (var c = 0; ; ) {
          if (c >= o.length) return !1;
          if (c >= l.length) return !0;
          var u = o[c], d = l[c];
          if (u < d) return !0;
          if (u > d) return !1;
          c++;
        }
      }, n.isomorphicDecode = function(o) {
        return String.fromCodePoint.apply(String, a(o));
      };
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(6), a = s(7), o = s(0), l = s(12), c = (function() {
        function u(d) {
          this._associatedDocument = d || r.dom.window.document;
        }
        return u.prototype.createDocumentType = function(d, h, p) {
          return o.namespace_validate(d), o.create_documentType(this._associatedDocument, d, h, p);
        }, u.prototype.createDocument = function(d, h, p) {
          p === void 0 && (p = null);
          var m = o.create_xmlDocument(), b = null;
          return h && (b = o.document_internalCreateElementNS(m, d, h)), p && m.appendChild(p), b && m.appendChild(b), m._origin = this._associatedDocument._origin, d === a.namespace.HTML ? m._contentType = "application/xhtml+xml" : d === a.namespace.SVG ? m._contentType = "image/svg+xml" : m._contentType = "application/xml", m;
        }, u.prototype.createHTMLDocument = function(d) {
          var h = o.create_document();
          h._type = "html", h._contentType = "text/html", h.appendChild(o.create_documentType(h, "html", "", ""));
          var p = o.element_createAnElement(h, "html", a.namespace.HTML);
          h.appendChild(p);
          var m = o.element_createAnElement(h, "head", a.namespace.HTML);
          if (p.appendChild(m), d !== void 0) {
            var b = o.element_createAnElement(h, "title", a.namespace.HTML);
            m.appendChild(b);
            var y = o.create_text(h, d);
            b.appendChild(y);
          }
          var Z = o.element_createAnElement(h, "body", a.namespace.HTML);
          return p.appendChild(Z), h._origin = this._associatedDocument._origin, h;
        }, u.prototype.hasFeature = function() {
          return !0;
        }, u._create = function(d) {
          return new u(d);
        }, u;
      })();
      n.DOMImplementationImpl = c, l.idl_defineConst(c.prototype, "_ID", "@oozcitak/dom");
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(d, h) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, m) {
          p.__proto__ = m;
        } || function(p, m) {
          for (var b in m) m.hasOwnProperty(b) && (p[b] = m[b]);
        })(d, h);
      }, function(d, h) {
        function p() {
          this.constructor = d;
        }
        r(d, h), d.prototype = h === null ? Object.create(h) : (p.prototype = h.prototype, new p());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(70), l = s(1), c = s(0), u = (function(d) {
        function h() {
          var p = d.call(this) || this;
          return p._signalSlots = /* @__PURE__ */ new Set(), p._mutationObserverMicrotaskQueued = !1, p._mutationObservers = /* @__PURE__ */ new Set(), p._iteratorList = new l.FixedSizeSet(), p._associatedDocument = c.create_document(), p;
        }
        return a(h, d), Object.defineProperty(h.prototype, "document", { get: function() {
          return this._associatedDocument;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(h.prototype, "event", { get: function() {
          return this._currentEvent;
        }, enumerable: !0, configurable: !0 }), h._create = function() {
          return new h();
        }, h;
      })(o.EventTargetImpl);
      n.WindowImpl = u;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(2), a = (function() {
        function o() {
        }
        return o.isNode = function(l) {
          return !!l && l._nodeType !== void 0;
        }, o.isDocumentNode = function(l) {
          return o.isNode(l) && l._nodeType === r.NodeType.Document;
        }, o.isDocumentTypeNode = function(l) {
          return o.isNode(l) && l._nodeType === r.NodeType.DocumentType;
        }, o.isDocumentFragmentNode = function(l) {
          return o.isNode(l) && l._nodeType === r.NodeType.DocumentFragment;
        }, o.isAttrNode = function(l) {
          return o.isNode(l) && l._nodeType === r.NodeType.Attribute;
        }, o.isCharacterDataNode = function(l) {
          if (!o.isNode(l)) return !1;
          var c = l._nodeType;
          return c === r.NodeType.Text || c === r.NodeType.ProcessingInstruction || c === r.NodeType.Comment || c === r.NodeType.CData;
        }, o.isTextNode = function(l) {
          return o.isNode(l) && (l._nodeType === r.NodeType.Text || l._nodeType === r.NodeType.CData);
        }, o.isExclusiveTextNode = function(l) {
          return o.isNode(l) && l._nodeType === r.NodeType.Text;
        }, o.isCDATASectionNode = function(l) {
          return o.isNode(l) && l._nodeType === r.NodeType.CData;
        }, o.isCommentNode = function(l) {
          return o.isNode(l) && l._nodeType === r.NodeType.Comment;
        }, o.isProcessingInstructionNode = function(l) {
          return o.isNode(l) && l._nodeType === r.NodeType.ProcessingInstruction;
        }, o.isElementNode = function(l) {
          return o.isNode(l) && l._nodeType === r.NodeType.Element;
        }, o.isCustomElementNode = function(l) {
          return o.isElementNode(l) && l._customElementState === "custom";
        }, o.isShadowRoot = function(l) {
          return !!l && l.host !== void 0;
        }, o.isMouseEvent = function(l) {
          return !!l && l.screenX !== void 0 && l.screenY != null;
        }, o.isSlotable = function(l) {
          return !!l && l._name !== void 0 && l._assignedSlot !== void 0 && (o.isTextNode(l) || o.isElementNode(l));
        }, o.isSlot = function(l) {
          return !!l && l._name !== void 0 && l._assignedNodes !== void 0 && o.isElementNode(l);
        }, o.isWindow = function(l) {
          return !!l && l.navigator !== void 0;
        }, o.isEventListener = function(l) {
          return !!l && l.handleEvent !== void 0;
        }, o.isRegisteredObserver = function(l) {
          return !!l && l.observer !== void 0 && l.options !== void 0;
        }, o.isTransientRegisteredObserver = function(l) {
          return !!l && l.source !== void 0 && o.isRegisteredObserver(l);
        }, o;
      })();
      n.Guard = a;
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(l, c) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, d) {
          u.__proto__ = d;
        } || function(u, d) {
          for (var h in d) d.hasOwnProperty(h) && (u[h] = d[h]);
        })(l, c);
      }, function(l, c) {
        function u() {
          this.constructor = l;
        }
        r(l, c), l.prototype = c === null ? Object.create(c) : (u.prototype = c.prototype, new u());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = (function(l) {
        function c() {
          return l.call(this) || this;
        }
        return a(c, l), c;
      })(s(98).DocumentImpl);
      n.XMLDocumentImpl = o;
    }, function(e, n, s) {
      var r = this && this.__values || function(nt) {
        var et = typeof Symbol == "function" && Symbol.iterator, ot = et && nt[et], it = 0;
        if (ot) return ot.call(nt);
        if (nt && typeof nt.length == "number") return { next: function() {
          return nt && it >= nt.length && (nt = void 0), { value: nt && nt[it++], done: !nt };
        } };
        throw new TypeError(et ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }, a = this && this.__read || function(nt, et) {
        var ot = typeof Symbol == "function" && nt[Symbol.iterator];
        if (!ot) return nt;
        var it, ht, lt = ot.call(nt), mt = [];
        try {
          for (; (et === void 0 || et-- > 0) && !(it = lt.next()).done; ) mt.push(it.value);
        } catch (wt) {
          ht = { error: wt };
        } finally {
          try {
            it && !it.done && (ot = lt.return) && ot.call(lt);
          } finally {
            if (ht) throw ht.error;
          }
        }
        return mt;
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o, l = s(1), c = s(243), u = s(7), d = s(244), h = { ftp: 21, file: null, http: 80, https: 443, ws: 80, wss: 443 }, p = /[\0-\x1F\x7F-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, m = /[ "<>`]|[\0-\x1F\x7F-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, b = /[ "<>`#?{}]|[\0-\x1F\x7F-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, y = /[ "<>`#?{}/:;=@\[\]\\\^\|]|[\0-\x1F\x7F-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, Z = /[0-9A-Za-z!\$&-\/:;=\?@_~\xA0-\uD7FF\uE000-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB40-\uDB7E\uDB80-\uDBBE\uDBC0-\uDBFE][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDC00-\uDFFD]/, g = /[\0\t\f\r #%/:?@\[\\\]]/;
      function f(nt) {
        o !== void 0 && o.call(null, "Validation Error: " + nt);
      }
      function T() {
        return { scheme: "", username: "", password: "", host: null, port: null, path: [], query: null, fragment: null, _cannotBeABaseURLFlag: !1, _blobURLEntry: null };
      }
      function M(nt) {
        return nt in h;
      }
      function N(nt) {
        return M(nt.scheme);
      }
      function W(nt) {
        return h[nt] || null;
      }
      function x(nt) {
        return nt.username !== "" || nt.password !== "";
      }
      function V(nt, et) {
        var ot, it;
        et === void 0 && (et = !1);
        var ht = nt.scheme + ":";
        if (nt.host !== null ? (ht += "//", x(nt) && (ht += nt.username, nt.password !== "" && (ht += ":" + nt.password), ht += "@"), ht += X(nt.host), nt.port !== null && (ht += ":" + nt.port)) : nt.host === null && nt.scheme === "file" && (ht += "//"), nt._cannotBeABaseURLFlag) ht += nt.path[0];
        else try {
          for (var lt = r(nt.path), mt = lt.next(); !mt.done; mt = lt.next())
            ht += "/" + mt.value;
        } catch (wt) {
          ot = { error: wt };
        } finally {
          try {
            mt && !mt.done && (it = lt.return) && it.call(lt);
          } finally {
            if (ot) throw ot.error;
          }
        }
        return nt.query !== null && (ht += "?" + nt.query), et || nt.fragment === null || (ht += "#" + nt.fragment), ht;
      }
      function X(nt) {
        return l.isNumber(nt) ? C(nt) : l.isArray(nt) ? "[" + R(nt) + "]" : nt;
      }
      function C(nt) {
        for (var et = "", ot = nt, it = 1; it <= 4; it++) et = (ot % 256).toString() + et, it !== 4 && (et = "." + et), ot = Math.floor(ot / 256);
        return et;
      }
      function R(nt) {
        for (var et = "", ot = null, it = -1, ht = 0, lt = 0, mt = 0; mt < 8; mt++) if (nt[mt] === 0) {
          ht = 1;
          for (var wt = mt + 1; wt < 8 && nt[wt] === 0; wt++) ht++;
          ht > lt && (lt = ht, it = mt);
        }
        lt > 1 && (ot = it);
        for (var Xt = !1, At = 0; At < 8; At++) Xt && nt[At] === 0 || (Xt && (Xt = !1), ot !== At ? (et += nt[At].toString(16), At !== 7 && (et += ":")) : (et += At === 0 ? "::" : ":", Xt = !0));
        return et;
      }
      function z(nt, et, ot, it, ht) {
        var lt, mt, wt, Xt;
        if (it === void 0) {
          it = { scheme: "", username: "", password: "", host: null, port: null, path: [], query: null, fragment: null, _cannotBeABaseURLFlag: !1, _blobURLEntry: null };
          var At = /^[\u0000-\u001F\u0020]+/, he = /[\u0000-\u001F\u0020]+$/;
          (At.test(nt) || he.test(nt)) && f("Input string contains leading or trailing control characters or space."), nt = (nt = nt.replace(At, "")).replace(he, "");
        }
        var ue = /[\u0009\u000A\u000D]/g;
        ue.test(nt) && f("Input string contains tab or newline characters."), nt = nt.replace(ue, "");
        var Dt = ht === void 0 ? c.ParserState.SchemeStart : ht;
        et === void 0 && (et = null);
        for (var ee = ot === void 0 || ot === "replacement" || ot === "UTF-16BE" || ot === "UTF-16LE" ? "UTF-8" : ot, yt = "", fe = !1, Xe = !1, Se = !1, Vt = new l.StringWalker(nt); ; ) {
          switch (Dt) {
            case c.ParserState.SchemeStart:
              if (u.codePoint.ASCIIAlpha.test(Vt.c())) yt += Vt.c().toLowerCase(), Dt = c.ParserState.Scheme;
              else {
                if (ht !== void 0) return f("Invalid scheme start character."), null;
                Dt = c.ParserState.NoScheme, Vt.pointer--;
              }
              break;
            case c.ParserState.Scheme:
              if (u.codePoint.ASCIIAlphanumeric.test(Vt.c()) || Vt.c() === "+" || Vt.c() === "-" || Vt.c() === ".") yt += Vt.c().toLowerCase();
              else {
                if (Vt.c() !== ":") {
                  if (ht === void 0) {
                    yt = "", Dt = c.ParserState.NoScheme, Vt.pointer = 0;
                    continue;
                  }
                  return f("Invalid input string."), null;
                }
                if (ht !== void 0 && (M(it.scheme) && !M(yt) || !M(it.scheme) && M(yt) || (x(it) || it.port !== null) && yt === "file" || it.scheme === "file" && (it.host === "" || it.host === null)))
                  return it;
                if (it.scheme = yt, ht !== void 0) return it.port === W(it.scheme) && (it.port = null), it;
                yt = "", it.scheme === "file" ? (Vt.remaining().startsWith("//") || f("Invalid file URL scheme, '//' expected."), Dt = c.ParserState.File) : N(it) && et !== null && et.scheme === it.scheme ? Dt = c.ParserState.SpecialRelativeOrAuthority : N(it) ? Dt = c.ParserState.SpecialAuthoritySlashes : Vt.remaining().startsWith("/") ? (Dt = c.ParserState.PathOrAuthority, Vt.pointer++) : (it._cannotBeABaseURLFlag = !0, it.path.push(""), Dt = c.ParserState.CannotBeABaseURLPath);
              }
              break;
            case c.ParserState.NoScheme:
              if (et === null || et._cannotBeABaseURLFlag && Vt.c() !== "#") return f("Invalid input string."), null;
              et._cannotBeABaseURLFlag && Vt.c() === "#" ? (it.scheme = et.scheme, it.path = u.list.clone(et.path), it.query = et.query, it.fragment = "", it._cannotBeABaseURLFlag = !0, Dt = c.ParserState.Fragment) : et.scheme !== "file" ? (Dt = c.ParserState.Relative, Vt.pointer--) : (Dt = c.ParserState.File, Vt.pointer--);
              break;
            case c.ParserState.SpecialRelativeOrAuthority:
              Vt.c() === "/" && Vt.remaining().startsWith("/") ? (Dt = c.ParserState.SpecialAuthorityIgnoreSlashes, Vt.pointer++) : (f("Invalid input string."), Dt = c.ParserState.Relative, Vt.pointer--);
              break;
            case c.ParserState.PathOrAuthority:
              Vt.c() === "/" ? Dt = c.ParserState.Authority : (Dt = c.ParserState.Path, Vt.pointer--);
              break;
            case c.ParserState.Relative:
              if (et === null) throw new Error("Invalid parser state. Base URL is null.");
              switch (it.scheme = et.scheme, Vt.c()) {
                case "":
                  it.username = et.username, it.password = et.password, it.host = et.host, it.port = et.port, it.path = u.list.clone(et.path), it.query = et.query;
                  break;
                case "/":
                  Dt = c.ParserState.RelativeSlash;
                  break;
                case "?":
                  it.username = et.username, it.password = et.password, it.host = et.host, it.port = et.port, it.path = u.list.clone(et.path), it.query = "", Dt = c.ParserState.Query;
                  break;
                case "#":
                  it.username = et.username, it.password = et.password, it.host = et.host, it.port = et.port, it.path = u.list.clone(et.path), it.query = et.query, it.fragment = "", Dt = c.ParserState.Fragment;
                  break;
                default:
                  N(it) && Vt.c() === "\\" ? (f("Invalid input string."), Dt = c.ParserState.RelativeSlash) : (it.username = et.username, it.password = et.password, it.host = et.host, it.port = et.port, it.path = u.list.clone(et.path), it.path.length !== 0 && it.path.splice(it.path.length - 1, 1), Dt = c.ParserState.Path, Vt.pointer--);
              }
              break;
            case c.ParserState.RelativeSlash:
              if (!N(it) || Vt.c() !== "/" && Vt.c() !== "\\") if (Vt.c() === "/") Dt = c.ParserState.Authority;
              else {
                if (et === null) throw new Error("Invalid parser state. Base URL is null.");
                it.username = et.username, it.password = et.password, it.host = et.host, it.port = et.port, Dt = c.ParserState.Path, Vt.pointer--;
              }
              else Vt.c() === "\\" && f("Invalid input string."), Dt = c.ParserState.SpecialAuthorityIgnoreSlashes;
              break;
            case c.ParserState.SpecialAuthoritySlashes:
              Vt.c() === "/" && Vt.remaining().startsWith("/") ? (Dt = c.ParserState.SpecialAuthorityIgnoreSlashes, Vt.pointer++) : (f("Expected '//'."), Dt = c.ParserState.SpecialAuthorityIgnoreSlashes, Vt.pointer--);
              break;
            case c.ParserState.SpecialAuthorityIgnoreSlashes:
              Vt.c() !== "/" && Vt.c() !== "\\" ? (Dt = c.ParserState.Authority, Vt.pointer--) : f("Unexpected '/' or '\\'.");
              break;
            case c.ParserState.Authority:
              if (Vt.c() === "@") {
                f("Unexpected '@'."), fe && (yt = "%40" + yt), fe = !0;
                try {
                  for (var Rt = (lt = void 0, r(yt)), $t = Rt.next(); !$t.done; $t = Rt.next()) {
                    var zt = $t.value;
                    if (zt !== ":" || Se) {
                      var Bt = Tt(zt, y);
                      Se ? it.password += Bt : it.username += Bt;
                    } else Se = !0;
                  }
                } catch (ln) {
                  lt = { error: ln };
                } finally {
                  try {
                    $t && !$t.done && (mt = Rt.return) && mt.call(Rt);
                  } finally {
                    if (lt) throw lt.error;
                  }
                }
                yt = "";
              } else if (Vt.c() === "" || Vt.c() === "/" || Vt.c() === "?" || Vt.c() === "#" || N(it) && Vt.c() === "\\") {
                if (fe && yt === "") return f("Invalid input string."), null;
                Vt.pointer -= yt.length + 1, yt = "", Dt = c.ParserState.Host;
              } else yt += Vt.c();
              break;
            case c.ParserState.Host:
            case c.ParserState.Hostname:
              if (ht !== void 0 && it.scheme === "file") Vt.pointer--, Dt = c.ParserState.FileHost;
              else if (Vt.c() !== ":" || Xe) if (Vt.c() === "" || Vt.c() === "/" || Vt.c() === "?" || Vt.c() === "#" || N(it) && Vt.c() === "\\") {
                if (Vt.pointer--, N(it) && yt === "") return f("Invalid input string."), null;
                if (ht !== void 0 && yt === "" && (x(it) || it.port !== null)) return f("Invalid input string."), it;
                if ((ne = A(yt, !N(it))) === null) return null;
                if (it.host = ne, yt = "", Dt = c.ParserState.PathStart, ht !== void 0) return it;
              } else Vt.c() === "[" && (Xe = !0), Vt.c() === "]" && (Xe = !1), yt += Vt.c();
              else {
                if (yt === "") return f("Invalid input string."), null;
                if ((ne = A(yt, !N(it))) === null) return null;
                if (it.host = ne, yt = "", Dt = c.ParserState.Port, ht === c.ParserState.Hostname) return it;
              }
              break;
            case c.ParserState.Port:
              if (u.codePoint.ASCIIDigit.test(Vt.c())) yt += Vt.c();
              else {
                if (!(Vt.c() === "" || Vt.c() === "/" || Vt.c() === "?" || Vt.c() === "#" || N(it) && Vt.c() === "\\" || ht)) return f("Invalid input string."), null;
                if (yt !== "" && yt !== "") {
                  var Kt = parseInt(yt, 10);
                  if (Kt > Math.pow(2, 16) - 1) return f("Invalid port number."), null;
                  it.port = Kt === W(it.scheme) ? null : Kt, yt = "";
                }
                if (ht !== void 0) return it;
                Dt = c.ParserState.PathStart, Vt.pointer--;
              }
              break;
            case c.ParserState.File:
              if (it.scheme = "file", Vt.c() === "/" || Vt.c() === "\\") Vt.c() === "\\" && f("Invalid input string."), Dt = c.ParserState.FileSlash;
              else if (et !== null && et.scheme === "file") switch (Vt.c()) {
                case "":
                  it.host = et.host, it.path = u.list.clone(et.path), it.query = et.query;
                  break;
                case "?":
                  it.host = et.host, it.path = u.list.clone(et.path), it.query = "", Dt = c.ParserState.Query;
                  break;
                case "#":
                  it.host = et.host, it.path = u.list.clone(et.path), it.query = et.query, it.fragment = "", Dt = c.ParserState.Fragment;
                  break;
                default:
                  $(Vt.substring()) ? f("Unexpected windows drive letter in input string.") : (it.host = et.host, it.path = u.list.clone(et.path), j(it)), Dt = c.ParserState.Path, Vt.pointer--;
              }
              else Dt = c.ParserState.Path, Vt.pointer--;
              break;
            case c.ParserState.FileSlash:
              Vt.c() === "/" || Vt.c() === "\\" ? (Vt.c() === "\\" && f("Invalid input string."), Dt = c.ParserState.FileHost) : (et === null || et.scheme !== "file" || $(Vt.substring()) || (H(et.path[0]) ? it.path.push(et.path[0]) : it.host = et.host), Dt = c.ParserState.Path, Vt.pointer--);
              break;
            case c.ParserState.FileHost:
              if (Vt.c() === "" || Vt.c() === "/" || Vt.c() === "\\" || Vt.c() === "?" || Vt.c() === "#") if (Vt.pointer--, ht === void 0 && B(yt)) f("Unexpected windows drive letter in input string."), Dt = c.ParserState.Path;
              else if (yt === "") {
                if (it.host = "", ht !== void 0) return it;
                Dt = c.ParserState.PathStart;
              } else {
                var ne;
                if ((ne = A(yt, !N(it))) === null) return null;
                if (ne === "localhost" && (ne = ""), it.host = ne, ht !== void 0) return it;
                yt = "", Dt = c.ParserState.PathStart;
              }
              else yt += Vt.c();
              break;
            case c.ParserState.PathStart:
              N(it) ? (Vt.c() === "\\" && f("Invalid input string."), Dt = c.ParserState.Path, Vt.c() !== "/" && Vt.c() !== "\\" && Vt.pointer--) : ht === void 0 && Vt.c() === "?" ? (it.query = "", Dt = c.ParserState.Query) : ht === void 0 && Vt.c() === "#" ? (it.fragment = "", Dt = c.ParserState.Fragment) : Vt.c() !== "" && (Dt = c.ParserState.Path, Vt.c() !== "/" && Vt.pointer--);
              break;
            case c.ParserState.Path:
              if (Vt.c() === "" || Vt.c() === "/" || N(it) && Vt.c() === "\\" || ht === void 0 && (Vt.c() === "?" || Vt.c() === "#")) {
                if (N(it) && Vt.c() === "\\" && f("Invalid input string."), P(yt)) j(it), Vt.c() === "/" || N(it) && Vt.c() === "\\" || it.path.push("");
                else if (!F(yt) || Vt.c() === "/" || N(it) && Vt.c() === "\\") {
                  if (!F(yt)) {
                    if (it.scheme === "file" && it.path.length === 0 && B(yt)) {
                      it.host !== null && it.host !== "" && (f("Invalid input string."), it.host = "");
                      var ae = Array.from(yt);
                      yt = ae.slice(0, 1) + ":" + ae.slice(2);
                    }
                    it.path.push(yt);
                  }
                } else it.path.push("");
                if (yt = "", it.scheme === "file" && (Vt.c() === "" || Vt.c() === "?" || Vt.c() === "#")) for (; it.path.length > 1 && it.path[0] === ""; ) f("Invalid input string."), it.path.splice(0, 1);
                Vt.c() === "?" && (it.query = "", Dt = c.ParserState.Query), Vt.c() === "#" && (it.fragment = "", Dt = c.ParserState.Fragment);
              } else Z.test(Vt.c()) || Vt.c() === "%" || f("Character is not a URL code point or a percent encoded character."), Vt.c() !== "%" || /^[0-9a-fA-F][0-9a-fA-F]/.test(Vt.remaining()) || f("Percent encoded character must be followed by two hex digits."), yt += Tt(Vt.c(), b);
              break;
            case c.ParserState.CannotBeABaseURLPath:
              Vt.c() === "?" ? (it.query = "", Dt = c.ParserState.Query) : Vt.c() === "#" ? (it.fragment = "", Dt = c.ParserState.Fragment) : (Vt.c() === "" || Z.test(Vt.c()) || Vt.c() === "%" || f("Character is not a URL code point or a percent encoded character."), Vt.c() !== "%" || /^[0-9a-fA-F][0-9a-fA-F]/.test(Vt.remaining()) || f("Percent encoded character must be followed by two hex digits."), Vt.c() !== "" && (it.path[0] += Tt(Vt.c(), p)));
              break;
            case c.ParserState.Query:
              if (ee === "UTF-8" || N(it) && it.scheme !== "ws" && it.scheme !== "wss" || (ee = "UTF-8"), ht === void 0 && Vt.c() === "#") it.fragment = "", Dt = c.ParserState.Fragment;
              else if (Vt.c() !== "") {
                if (Z.test(Vt.c()) || Vt.c() === "%" || f("Character is not a URL code point or a percent encoded character."), Vt.c() !== "%" || /^[0-9a-fA-F][0-9a-fA-F]/.test(Vt.remaining()) || f("Percent encoded character must be followed by two hex digits."), ee.toUpperCase() !== "UTF-8") throw new Error("Only UTF-8 encoding is supported.");
                var Ge = l.utf8Encode(Vt.c());
                if (Ge.length >= 3 && Ge[0] === 38 && Ge[1] === 35 && Ge[Ge.length - 1] === 59) Ge = Ge.subarray(2, Ge.length - 1), it.query += "%26%23" + u.byteSequence.isomorphicDecode(Ge) + "%3B";
                else try {
                  for (var He = (wt = void 0, r(Ge)), je = He.next(); !je.done; je = He.next()) {
                    var we = je.value;
                    we < 33 || we > 126 || we === 34 || we === 35 || we === 60 || we === 62 || we === 39 && N(it) ? it.query += Wt(we) : it.query += String.fromCharCode(we);
                  }
                } catch (ln) {
                  wt = { error: ln };
                } finally {
                  try {
                    je && !je.done && (Xt = He.return) && Xt.call(He);
                  } finally {
                    if (wt) throw wt.error;
                  }
                }
              }
              break;
            case c.ParserState.Fragment:
              Vt.c() === "" || (Vt.c() === "\0" ? f("NULL character in input string.") : (Z.test(Vt.c()) || Vt.c() === "%" || f("Unexpected character in fragment string."), Vt.c() !== "%" || /^[A-Za-z0-9][A-Za-z0-9]/.test(Vt.remaining()) || f("Unexpected character in fragment string."), it.fragment += Tt(Vt.c(), m)));
          }
          if (Vt.eof) break;
          Vt.pointer++;
        }
        return it;
      }
      function F(nt) {
        return nt === "." || nt.toLowerCase() === "%2e";
      }
      function P(nt) {
        var et = nt.toLowerCase();
        return et === ".." || et === ".%2e" || et === "%2e." || et === "%2e%2e";
      }
      function j(nt) {
        var et = nt.path;
        et.length !== 0 && (nt.scheme === "file" && et.length === 1 && H(et[0]) || nt.path.splice(nt.path.length - 1, 1));
      }
      function H(nt) {
        return nt.length >= 2 && u.codePoint.ASCIIAlpha.test(nt[0]) && nt[1] === ":";
      }
      function B(nt) {
        return nt.length >= 2 && u.codePoint.ASCIIAlpha.test(nt[0]) && (nt[1] === ":" || nt[1] === "|");
      }
      function $(nt) {
        return nt.length >= 2 && B(nt) && (nt.length === 2 || nt[2] === "/" || nt[2] === "\\" || nt[2] === "?" || nt[2] === "#");
      }
      function A(nt, et) {
        if (et === void 0 && (et = !1), nt.startsWith("[")) return nt.endsWith("]") ? at(nt.substring(1, nt.length - 1)) : (f("Expected ']' after '['."), null);
        if (et) return dt(nt);
        var ot = q(l.utf8Decode(Gt(nt)));
        if (ot === null || g.test(ot)) return f("Invalid domain."), null;
        var it = ct(ot);
        return it === null || l.isNumber(it) ? it : ot;
      }
      function E(nt, et) {
        et === void 0 && (et = { value: !1 });
        var ot = 10;
        return nt.startsWith("0x") || nt.startsWith("0X") ? (et.value = !0, nt = nt.substr(2), ot = 16) : nt.length >= 2 && nt[0] === "0" && (et.value = !0, nt = nt.substr(1), ot = 8), nt === "" ? 0 : (ot === 10 ? /^[0-9]+$/ : ot === 16 ? /^[0-9A-Fa-f]+$/ : /^[0-7]+$/).test(nt) ? parseInt(nt, ot) : null;
      }
      function ct(nt) {
        var et, ot, it, ht, lt = { value: !1 }, mt = nt.split(".");
        if (mt[mt.length - 1] === "" && (lt.value = !0, mt.length > 1 && mt.pop()), mt.length > 4) return nt;
        var wt = [];
        try {
          for (var Xt = r(mt), At = Xt.next(); !At.done; At = Xt.next()) {
            var he = At.value;
            if (he === "" || (Xe = E(he, lt)) === null) return nt;
            wt.push(Xe);
          }
        } catch (Se) {
          et = { error: Se };
        } finally {
          try {
            At && !At.done && (ot = Xt.return) && ot.call(Xt);
          } finally {
            if (et) throw et.error;
          }
        }
        lt.value && f("Invalid IP v4 address.");
        for (var ue = 0; ue < wt.length; ue++)
          if (wt[ue] > 255 && (f("Invalid IP v4 address."), ue < wt.length - 1)) return null;
        if (wt[wt.length - 1] >= Math.pow(256, 5 - wt.length)) return f("Invalid IP v4 address."), null;
        var Dt = wt[wt.length - 1];
        wt.pop();
        var ee = 0;
        try {
          for (var yt = r(wt), fe = yt.next(); !fe.done; fe = yt.next()) {
            var Xe;
            Dt += (Xe = fe.value) * Math.pow(256, 3 - ee), ee++;
          }
        } catch (Se) {
          it = { error: Se };
        } finally {
          try {
            fe && !fe.done && (ht = yt.return) && ht.call(yt);
          } finally {
            if (it) throw it.error;
          }
        }
        return Dt;
      }
      function at(nt) {
        var et, ot = [0, 0, 0, 0, 0, 0, 0, 0], it = 0, ht = null, lt = new l.StringWalker(nt);
        if (lt.c() === ":") {
          if (!lt.remaining().startsWith(":")) return f("Invalid IP v6 address."), null;
          lt.pointer += 2, ht = it += 1;
        }
        for (; lt.c() !== ""; ) {
          if (it === 8) return f("Invalid IP v6 address."), null;
          if (lt.c() !== ":") {
            for (var mt = 0, wt = 0; wt < 4 && u.codePoint.ASCIIHexDigit.test(lt.c()); ) mt = 16 * mt + parseInt(lt.c(), 16), lt.pointer++, wt++;
            if (lt.c() === ".") {
              if (wt === 0 || (lt.pointer -= wt, it > 6)) return f("Invalid IP v6 address."), null;
              for (var Xt = 0; lt.c() !== ""; ) {
                var At = null;
                if (Xt > 0) {
                  if (!(lt.c() === "." && Xt < 4)) return f("Invalid IP v6 address."), null;
                  lt.pointer++;
                }
                if (!u.codePoint.ASCIIDigit.test(lt.c())) return f("Invalid IP v6 address."), null;
                for (; u.codePoint.ASCIIDigit.test(lt.c()); ) {
                  var he = parseInt(lt.c(), 10);
                  if (At === null) At = he;
                  else {
                    if (At === 0) return f("Invalid IP v6 address."), null;
                    At = 10 * At + he;
                  }
                  if (At > 255) return f("Invalid IP v6 address."), null;
                  lt.pointer++;
                }
                if (At === null) return f("Invalid IP v6 address."), null;
                ot[it] = 256 * ot[it] + At, ++Xt !== 2 && Xt !== 4 || it++;
              }
              if (Xt !== 4) return f("Invalid IP v6 address."), null;
              break;
            }
            if (lt.c() === ":") {
              if (lt.pointer++, lt.c() === "") return f("Invalid IP v6 address."), null;
            } else if (lt.c() !== "") return f("Invalid IP v6 address."), null;
            ot[it] = mt, it++;
          } else {
            if (ht !== null) return f("Invalid IP v6 address."), null;
            lt.pointer++, ht = ++it;
          }
        }
        if (ht !== null) {
          var ue = it - ht;
          for (it = 7; it !== 0 && ue > 0; ) et = a([ot[ht + ue - 1], ot[it]], 2), ot[it] = et[0], ot[ht + ue - 1] = et[1], it--, ue--;
        } else if (ht === null && it !== 8) return f("Invalid IP v6 address."), null;
        return ot;
      }
      function dt(nt) {
        var et, ot;
        if (/[\x00\t\f\r #/:?@\[\\\]]/.test(nt)) return f("Invalid host string."), null;
        var it = "";
        try {
          for (var ht = r(nt), lt = ht.next(); !lt.done; lt = ht.next())
            it += Tt(lt.value, p);
        } catch (mt) {
          et = { error: mt };
        } finally {
          try {
            lt && !lt.done && (ot = ht.return) && ot.call(ht);
          } finally {
            if (et) throw et.error;
          }
        }
        return it;
      }
      function gt(nt) {
        return null;
      }
      function Wt(nt) {
        return "%" + ("00" + nt.toString(16).toUpperCase()).slice(-2);
      }
      function Zt(nt) {
        for (var et = function(wt) {
          return wt >= 48 && wt <= 57 || wt >= 65 && wt <= 70 || wt >= 97 && wt <= 102;
        }, ot = new Uint8Array(nt.length), it = 0, ht = 0; ht < nt.length; ht++) {
          var lt = nt[ht];
          if (lt !== 37) ot[it] = lt, it++;
          else if (lt === 37 && ht >= nt.length - 2) ot[it] = lt, it++;
          else if (lt !== 37 || et(nt[ht + 1]) && et(nt[ht + 2])) {
            var mt = parseInt(l.utf8Decode(Uint8Array.of(nt[ht + 1], nt[ht + 2])), 16);
            ot[it] = mt, it++, ht += 2;
          } else ot[it] = lt, it++;
        }
        return ot.subarray(0, it);
      }
      function Gt(nt) {
        return Zt(l.utf8Encode(nt));
      }
      function Tt(nt, et) {
        var ot, it;
        if (!et.test(nt)) return nt;
        var ht = l.utf8Encode(nt), lt = "";
        try {
          for (var mt = r(ht), wt = mt.next(); !wt.done; wt = mt.next())
            lt += Wt(wt.value);
        } catch (Xt) {
          ot = { error: Xt };
        } finally {
          try {
            wt && !wt.done && (it = mt.return) && it.call(mt);
          } finally {
            if (ot) throw ot.error;
          }
        }
        return lt;
      }
      function Q(nt) {
        var et, ot, it, ht, lt = [], mt = [];
        try {
          for (var wt = r(nt), Xt = wt.next(); !Xt.done; Xt = wt.next()) {
            var At = Xt.value;
            At === 38 ? (lt.push(Uint8Array.from(mt)), mt = []) : mt.push(At);
          }
        } catch ($t) {
          et = { error: $t };
        } finally {
          try {
            Xt && !Xt.done && (ot = wt.return) && ot.call(wt);
          } finally {
            if (et) throw et.error;
          }
        }
        mt.length !== 0 && lt.push(Uint8Array.from(mt));
        var he = [];
        try {
          for (var ue = r(lt), Dt = ue.next(); !Dt.done; Dt = ue.next()) {
            var ee = Dt.value;
            if (ee.length !== 0) {
              for (var yt = ee.indexOf(61), fe = yt !== -1 ? ee.slice(0, yt) : ee, Xe = yt !== -1 ? ee.slice(yt + 1) : new Uint8Array(), Se = 0; Se < fe.length; Se++) fe[Se] === 43 && (fe[Se] = 32);
              for (Se = 0; Se < Xe.length; Se++) Xe[Se] === 43 && (Xe[Se] = 32);
              var Vt = l.utf8Decode(fe), Rt = l.utf8Decode(Xe);
              he.push([Vt, Rt]);
            }
          }
        } catch ($t) {
          it = { error: $t };
        } finally {
          try {
            Dt && !Dt.done && (ht = ue.return) && ht.call(ue);
          } finally {
            if (it) throw it.error;
          }
        }
        return he;
      }
      function D(nt) {
        var et, ot, it = "";
        try {
          for (var ht = r(nt), lt = ht.next(); !lt.done; lt = ht.next()) {
            var mt = lt.value;
            it += mt === 32 ? "+" : mt === 42 || mt === 45 || mt === 46 || mt >= 48 && mt <= 57 || mt >= 65 && mt <= 90 || mt === 95 || mt >= 97 && mt <= 122 ? String.fromCodePoint(mt) : Wt(mt);
          }
        } catch (wt) {
          et = { error: wt };
        } finally {
          try {
            lt && !lt.done && (ot = ht.return) && ot.call(ht);
          } finally {
            if (et) throw et.error;
          }
        }
        return it;
      }
      function q(nt, et) {
        var ot = d.domainToASCII(nt);
        return ot === "" ? (f("Invalid domain name."), null) : ot;
      }
      n.setValidationErrorCallback = function(nt) {
        o = nt;
      }, n.newURL = T, n.isSpecialScheme = M, n.isSpecial = N, n.defaultPort = W, n.includesCredentials = x, n.cannotHaveAUsernamePasswordPort = function(nt) {
        return nt.host === null || nt.host === "" || nt._cannotBeABaseURLFlag || nt.scheme === "file";
      }, n.urlSerializer = V, n.hostSerializer = X, n.iPv4Serializer = C, n.iPv6Serializer = R, n.urlParser = function(nt, et, ot) {
        var it = z(nt, et, ot);
        return it === null ? null : (it.scheme !== "blob" || (it._blobURLEntry = null), it);
      }, n.basicURLParser = z, n.setTheUsername = function(nt, et) {
        var ot, it, ht = "";
        try {
          for (var lt = r(et), mt = lt.next(); !mt.done; mt = lt.next())
            ht += Tt(mt.value, y);
        } catch (wt) {
          ot = { error: wt };
        } finally {
          try {
            mt && !mt.done && (it = lt.return) && it.call(lt);
          } finally {
            if (ot) throw ot.error;
          }
        }
        nt.username = ht;
      }, n.setThePassword = function(nt, et) {
        var ot, it, ht = "";
        try {
          for (var lt = r(et), mt = lt.next(); !mt.done; mt = lt.next())
            ht += Tt(mt.value, y);
        } catch (wt) {
          ot = { error: wt };
        } finally {
          try {
            mt && !mt.done && (it = lt.return) && it.call(lt);
          } finally {
            if (ot) throw ot.error;
          }
        }
        nt.password = ht;
      }, n.isSingleDotPathSegment = F, n.isDoubleDotPathSegment = P, n.shorten = j, n.isNormalizedWindowsDriveLetter = H, n.isWindowsDriveLetter = B, n.startsWithAWindowsDriveLetter = $, n.hostParser = A, n.iPv4NumberParser = E, n.iPv4Parser = ct, n.iPv6Parser = at, n.opaqueHostParser = dt, n.resolveABlobURL = gt, n.percentEncode = Wt, n.percentDecode = Zt, n.stringPercentDecode = Gt, n.utf8PercentEncode = Tt, n.hostEquals = function(nt, et) {
        return nt === et;
      }, n.urlEquals = function(nt, et, ot) {
        return ot === void 0 && (ot = !1), V(nt, ot) === V(et, ot);
      }, n.urlEncodedStringParser = function(nt) {
        return Q(l.utf8Encode(nt));
      }, n.urlEncodedParser = Q, n.urlEncodedByteSerializer = D, n.urlEncodedSerializer = function(nt, et) {
        var ot, it;
        if ((et === void 0 || et === "replacement" || et === "UTF-16BE" || et === "UTF-16LE" ? "UTF-8" : et).toUpperCase() !== "UTF-8") throw new Error("Only UTF-8 encoding is supported.");
        var ht = "";
        try {
          for (var lt = r(nt), mt = lt.next(); !mt.done; mt = lt.next()) {
            var wt = mt.value, Xt = D(l.utf8Encode(wt[0])), At = wt[1];
            At = D(l.utf8Encode(At)), ht !== "" && (ht += "&"), ht += Xt + "=" + At;
          }
        } catch (he) {
          ot = { error: he };
        } finally {
          try {
            mt && !mt.done && (it = lt.return) && it.call(lt);
          } finally {
            if (ot) throw ot.error;
          }
        }
        return ht;
      }, n.origin = function nt(et) {
        switch (et.scheme) {
          case "blob":
            et._blobURLEntry;
            var ot = z(et.path[0]);
            return ot === null ? c.OpaqueOrigin : nt(ot);
          case "ftp":
          case "http":
          case "https":
          case "ws":
          case "wss":
            return [et.scheme, et.host === null ? "" : et.host, et.port, null];
          case "file":
          default:
            return c.OpaqueOrigin;
        }
      }, n.domainToASCII = q, n.domainToUnicode = function(nt, et) {
        var ot = d.domainToUnicode(nt);
        return ot === "" && f("Invalid domain name."), ot;
      }, n.asciiSerializationOfAnOrigin = function(nt) {
        if (nt[0] === "" && nt[1] === "" && nt[2] === null && nt[3] === null) return "null";
        var et = nt[0] + "://" + X(nt[1]);
        return nt[2] !== null && (et += ":" + nt[2].toString()), et;
      };
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(0), a = (function() {
        function o() {
          this._signal = r.create_abortSignal();
        }
        return Object.defineProperty(o.prototype, "signal", { get: function() {
          return this._signal;
        }, enumerable: !0, configurable: !0 }), o.prototype.abort = function() {
          r.abort_signalAbort(this._signal);
        }, o;
      })();
      n.AbortControllerImpl = a;
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(u, d) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(h, p) {
          h.__proto__ = p;
        } || function(h, p) {
          for (var m in p) p.hasOwnProperty(m) && (h[m] = p[m]);
        })(u, d);
      }, function(u, d) {
        function h() {
          this.constructor = u;
        }
        r(u, d), u.prototype = d === null ? Object.create(d) : (h.prototype = d.prototype, new h());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(70), l = s(0), c = (function(u) {
        function d() {
          var h = u.call(this) || this;
          return h._abortedFlag = !1, h._abortAlgorithms = /* @__PURE__ */ new Set(), h;
        }
        return a(d, u), Object.defineProperty(d.prototype, "aborted", { get: function() {
          return this._abortedFlag;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(d.prototype, "onabort", { get: function() {
          return l.event_getterEventHandlerIDLAttribute(this, "onabort");
        }, set: function(h) {
          l.event_setterEventHandlerIDLAttribute(this, "onabort", h);
        }, enumerable: !0, configurable: !0 }), d._create = function() {
          return new d();
        }, d;
      })(o.EventTargetImpl);
      n.AbortSignalImpl = c;
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(d, h) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, m) {
          p.__proto__ = m;
        } || function(p, m) {
          for (var b in m) m.hasOwnProperty(b) && (p[b] = m[b]);
        })(d, h);
      }, function(d, h) {
        function p() {
          this.constructor = d;
        }
        r(d, h), d.prototype = h === null ? Object.create(h) : (p.prototype = h.prototype, new p());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(2), l = s(34), c = s(12), u = (function(d) {
        function h(p, m, b) {
          var y = d.call(this) || this;
          return y._name = "", y._publicId = "", y._systemId = "", y._name = p, y._publicId = m, y._systemId = b, y;
        }
        return a(h, d), Object.defineProperty(h.prototype, "name", { get: function() {
          return this._name;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(h.prototype, "publicId", { get: function() {
          return this._publicId;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(h.prototype, "systemId", { get: function() {
          return this._systemId;
        }, enumerable: !0, configurable: !0 }), h.prototype.before = function() {
          for (var p = [], m = 0; m < arguments.length; m++) p[m] = arguments[m];
          throw new Error("Mixin: ChildNode not implemented.");
        }, h.prototype.after = function() {
          for (var p = [], m = 0; m < arguments.length; m++) p[m] = arguments[m];
          throw new Error("Mixin: ChildNode not implemented.");
        }, h.prototype.replaceWith = function() {
          for (var p = [], m = 0; m < arguments.length; m++) p[m] = arguments[m];
          throw new Error("Mixin: ChildNode not implemented.");
        }, h.prototype.remove = function() {
          throw new Error("Mixin: ChildNode not implemented.");
        }, h._create = function(p, m, b, y) {
          b === void 0 && (b = ""), y === void 0 && (y = "");
          var Z = new h(m, b, y);
          return Z._nodeDocument = p, Z;
        }, h;
      })(l.NodeImpl);
      n.DocumentTypeImpl = u, c.idl_defineConst(u.prototype, "_nodeType", o.NodeType.DocumentType);
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(d, h) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, m) {
          p.__proto__ = m;
        } || function(p, m) {
          for (var b in m) m.hasOwnProperty(b) && (p[b] = m[b]);
        })(d, h);
      }, function(d, h) {
        function p() {
          this.constructor = d;
        }
        r(d, h), d.prototype = h === null ? Object.create(h) : (p.prototype = h.prototype, new p());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(100), l = s(1), c = s(0), u = (function(d) {
        function h(p, m) {
          var b = d.call(this) || this;
          return b._host = p, b._mode = m, b;
        }
        return a(h, d), Object.defineProperty(h.prototype, "mode", { get: function() {
          return this._mode;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(h.prototype, "host", { get: function() {
          return this._host;
        }, enumerable: !0, configurable: !0 }), h.prototype._getTheParent = function(p) {
          return p._composedFlag || l.isEmpty(p._path) || c.tree_rootNode(p._path[0].invocationTarget) !== this ? this._host : null;
        }, h._create = function(p, m) {
          return new h(m, "closed");
        }, h;
      })(o.DocumentFragmentImpl);
      n.ShadowRootImpl = u;
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(h, p) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(m, b) {
          m.__proto__ = b;
        } || function(m, b) {
          for (var y in b) b.hasOwnProperty(y) && (m[y] = b[y]);
        })(h, p);
      }, function(h, p) {
        function m() {
          this.constructor = h;
        }
        r(h, p), h.prototype = p === null ? Object.create(p) : (m.prototype = p.prototype, new m());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(2), l = s(34), c = s(0), u = s(12), d = (function(h) {
        function p(m) {
          var b = h.call(this) || this;
          return b._namespace = null, b._namespacePrefix = null, b._element = null, b._value = "", b._localName = m, b;
        }
        return a(p, h), Object.defineProperty(p.prototype, "ownerElement", { get: function() {
          return this._element;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(p.prototype, "namespaceURI", { get: function() {
          return this._namespace;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(p.prototype, "prefix", { get: function() {
          return this._namespacePrefix;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(p.prototype, "localName", { get: function() {
          return this._localName;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(p.prototype, "name", { get: function() {
          return this._qualifiedName;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(p.prototype, "value", { get: function() {
          return this._value;
        }, set: function(m) {
          c.attr_setAnExistingAttributeValue(this, m);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(p.prototype, "_qualifiedName", { get: function() {
          return this._namespacePrefix !== null ? this._namespacePrefix + ":" + this._localName : this._localName;
        }, enumerable: !0, configurable: !0 }), p._create = function(m, b) {
          var y = new p(b);
          return y._nodeDocument = m, y;
        }, p;
      })(l.NodeImpl);
      n.AttrImpl = d, u.idl_defineConst(d.prototype, "_nodeType", o.NodeType.Attribute), u.idl_defineConst(d.prototype, "specified", !0);
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(d, h) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, m) {
          p.__proto__ = m;
        } || function(p, m) {
          for (var b in m) m.hasOwnProperty(b) && (p[b] = m[b]);
        })(d, h);
      }, function(d, h) {
        function p() {
          this.constructor = d;
        }
        r(d, h), d.prototype = h === null ? Object.create(h) : (p.prototype = h.prototype, new p());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(101), l = s(2), c = s(12), u = (function(d) {
        function h(p) {
          return d.call(this, p) || this;
        }
        return a(h, d), h._create = function(p, m) {
          m === void 0 && (m = "");
          var b = new h(m);
          return b._nodeDocument = p, b;
        }, h;
      })(o.TextImpl);
      n.CDATASectionImpl = u, c.idl_defineConst(u.prototype, "_nodeType", l.NodeType.CData);
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(d, h) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, m) {
          p.__proto__ = m;
        } || function(p, m) {
          for (var b in m) m.hasOwnProperty(b) && (p[b] = m[b]);
        })(d, h);
      }, function(d, h) {
        function p() {
          this.constructor = d;
        }
        r(d, h), d.prototype = h === null ? Object.create(h) : (p.prototype = h.prototype, new p());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(2), l = s(71), c = s(12), u = (function(d) {
        function h(p) {
          return p === void 0 && (p = ""), d.call(this, p) || this;
        }
        return a(h, d), h._create = function(p, m) {
          m === void 0 && (m = "");
          var b = new h(m);
          return b._nodeDocument = p, b;
        }, h;
      })(l.CharacterDataImpl);
      n.CommentImpl = u, c.idl_defineConst(u.prototype, "_nodeType", o.NodeType.Comment);
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(d, h) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, m) {
          p.__proto__ = m;
        } || function(p, m) {
          for (var b in m) m.hasOwnProperty(b) && (p[b] = m[b]);
        })(d, h);
      }, function(d, h) {
        function p() {
          this.constructor = d;
        }
        r(d, h), d.prototype = h === null ? Object.create(h) : (p.prototype = h.prototype, new p());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(2), l = s(71), c = s(12), u = (function(d) {
        function h(p, m) {
          var b = d.call(this, m) || this;
          return b._target = p, b;
        }
        return a(h, d), Object.defineProperty(h.prototype, "target", { get: function() {
          return this._target;
        }, enumerable: !0, configurable: !0 }), h._create = function(p, m, b) {
          var y = new h(m, b);
          return y._nodeDocument = p, y;
        }, h;
      })(l.CharacterDataImpl);
      n.ProcessingInstructionImpl = u, c.idl_defineConst(u.prototype, "_nodeType", o.NodeType.ProcessingInstruction);
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(7), a = s(0), o = s(3), l = s(1), c = (function() {
        function u(d, h) {
          return this._live = !0, this._root = d, this._filter = h, new Proxy(this, this);
        }
        return Object.defineProperty(u.prototype, "length", { get: function() {
          for (var d = this, h = 0, p = a.tree_getFirstDescendantNode(this._root, !1, !1, (function(m) {
            return o.Guard.isElementNode(m) && d._filter(m);
          })); p !== null; ) h++, p = a.tree_getNextDescendantNode(this._root, p, !1, !1, (function(m) {
            return o.Guard.isElementNode(m) && d._filter(m);
          }));
          return h;
        }, enumerable: !0, configurable: !0 }), u.prototype.item = function(d) {
          for (var h = this, p = 0, m = a.tree_getFirstDescendantNode(this._root, !1, !1, (function(b) {
            return o.Guard.isElementNode(b) && h._filter(b);
          })); m !== null; ) {
            if (p === d) return m;
            p++, m = a.tree_getNextDescendantNode(this._root, m, !1, !1, (function(b) {
              return o.Guard.isElementNode(b) && h._filter(b);
            }));
          }
          return null;
        }, u.prototype.namedItem = function(d) {
          var h = this;
          if (d === "") return null;
          for (var p = a.tree_getFirstDescendantNode(this._root, !1, !1, (function(y) {
            return o.Guard.isElementNode(y) && h._filter(y);
          })); p != null; ) {
            if (p._uniqueIdentifier === d) return p;
            if (p._namespace === r.namespace.HTML) for (var m = 0; m < p._attributeList.length; m++) {
              var b = p._attributeList[m];
              if (b._localName === "name" && b._namespace === null && b._namespacePrefix === null && b._value === d) return p;
            }
            p = a.tree_getNextDescendantNode(this._root, p, !1, !1, (function(y) {
              return o.Guard.isElementNode(y) && h._filter(y);
            }));
          }
          return null;
        }, u.prototype[Symbol.iterator] = function() {
          var d = this._root, h = this._filter, p = a.tree_getFirstDescendantNode(d, !1, !1, (function(m) {
            return o.Guard.isElementNode(m) && h(m);
          }));
          return { next: function() {
            if (p === null) return { done: !0, value: null };
            var m = { done: !1, value: p };
            return p = a.tree_getNextDescendantNode(d, p, !1, !1, (function(b) {
              return o.Guard.isElementNode(b) && h(b);
            })), m;
          } };
        }, u.prototype.get = function(d, h, p) {
          if (!l.isString(h) || u.reservedNames.indexOf(h) !== -1) return Reflect.get(d, h, p);
          var m = Number(h);
          return isNaN(m) ? d.namedItem(h) || void 0 : d.item(m) || void 0;
        }, u.prototype.set = function(d, h, p, m) {
          if (!l.isString(h) || u.reservedNames.indexOf(h) !== -1) return Reflect.set(d, h, p, m);
          var b = Number(h), y = isNaN(b) ? d.namedItem(h) || void 0 : d.item(b) || void 0;
          return !(!y || !y._parent) && (a.mutation_replace(y, p, y._parent), !0);
        }, u._create = function(d, h) {
          return h === void 0 && (h = function() {
            return !0;
          }), new u(d, h);
        }, u.reservedNames = ["_root", "_live", "_filter", "length", "item", "namedItem", "get", "set"], u;
      })();
      n.HTMLCollectionImpl = c;
    }, function(e, n, s) {
      var r = this && this.__values || function(u) {
        var d = typeof Symbol == "function" && Symbol.iterator, h = d && u[d], p = 0;
        if (h) return h.call(u);
        if (u && typeof u.length == "number") return { next: function() {
          return u && p >= u.length && (u = void 0), { value: u && u[p++], done: !u };
        } };
        throw new TypeError(d ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = s(6), o = s(1), l = s(0), c = (function() {
        function u(d) {
          return this._live = !0, this._filter = null, this._length = 0, this._root = d, new Proxy(this, this);
        }
        return Object.defineProperty(u.prototype, "length", { get: function() {
          return this._root._children.size;
        }, enumerable: !0, configurable: !0 }), u.prototype.item = function(d) {
          if (d < 0 || d > this.length - 1) return null;
          if (d < this.length / 2) {
            for (var h = 0, p = this._root._firstChild; p !== null && h !== d; ) p = p._nextSibling, h++;
            return p;
          }
          for (h = this.length - 1, p = this._root._lastChild; p !== null && h !== d; ) p = p._previousSibling, h--;
          return p;
        }, u.prototype.keys = function() {
          var d;
          return (d = {})[Symbol.iterator] = (function() {
            var h = 0;
            return { next: (function() {
              return h === this.length ? { done: !0, value: null } : { done: !1, value: h++ };
            }).bind(this) };
          }).bind(this), d;
        }, u.prototype.values = function() {
          var d;
          return (d = {})[Symbol.iterator] = (function() {
            var h = this[Symbol.iterator]();
            return { next: function() {
              return h.next();
            } };
          }).bind(this), d;
        }, u.prototype.entries = function() {
          var d;
          return (d = {})[Symbol.iterator] = (function() {
            var h = this[Symbol.iterator](), p = 0;
            return { next: function() {
              var m = h.next();
              return m.done ? { done: !0, value: null } : { done: !1, value: [p++, m.value] };
            } };
          }).bind(this), d;
        }, u.prototype[Symbol.iterator] = function() {
          return this._root._children[Symbol.iterator]();
        }, u.prototype.forEach = function(d, h) {
          var p, m;
          h === void 0 && (h = a.dom.window);
          var b = 0;
          try {
            for (var y = r(this._root._children), Z = y.next(); !Z.done; Z = y.next()) {
              var g = Z.value;
              d.call(h, g, b++, this);
            }
          } catch (f) {
            p = { error: f };
          } finally {
            try {
              Z && !Z.done && (m = y.return) && m.call(y);
            } finally {
              if (p) throw p.error;
            }
          }
        }, u.prototype.get = function(d, h, p) {
          if (!o.isString(h)) return Reflect.get(d, h, p);
          var m = Number(h);
          return isNaN(m) ? Reflect.get(d, h, p) : d.item(m) || void 0;
        }, u.prototype.set = function(d, h, p, m) {
          if (!o.isString(h)) return Reflect.set(d, h, p, m);
          var b = Number(h);
          if (isNaN(b)) return Reflect.set(d, h, p, m);
          var y = d.item(b) || void 0;
          return !!y && !!y._parent && (l.mutation_replace(y, p, y._parent), !0);
        }, u._create = function(d) {
          return new u(d);
        }, u;
      })();
      n.NodeListImpl = c;
    }, function(e, n, s) {
      var r = this && this.__values || function(c) {
        var u = typeof Symbol == "function" && Symbol.iterator, d = u && c[u], h = 0;
        if (d) return d.call(c);
        if (c && typeof c.length == "number") return { next: function() {
          return c && h >= c.length && (c = void 0), { value: c && c[h++], done: !c };
        } };
        throw new TypeError(u ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = s(6), o = s(1), l = (function() {
        function c(u) {
          return this._live = !1, this._items = [], this._length = 0, this._root = u, this._items = [], this._filter = function(d) {
            return !0;
          }, new Proxy(this, this);
        }
        return Object.defineProperty(c.prototype, "length", { get: function() {
          return this._items.length;
        }, enumerable: !0, configurable: !0 }), c.prototype.item = function(u) {
          return u < 0 || u > this.length - 1 ? null : this._items[u];
        }, c.prototype.keys = function() {
          var u;
          return (u = {})[Symbol.iterator] = (function() {
            var d = 0;
            return { next: (function() {
              return d === this.length ? { done: !0, value: null } : { done: !1, value: d++ };
            }).bind(this) };
          }).bind(this), u;
        }, c.prototype.values = function() {
          var u;
          return (u = {})[Symbol.iterator] = (function() {
            var d = this[Symbol.iterator]();
            return { next: function() {
              return d.next();
            } };
          }).bind(this), u;
        }, c.prototype.entries = function() {
          var u;
          return (u = {})[Symbol.iterator] = (function() {
            var d = this[Symbol.iterator](), h = 0;
            return { next: function() {
              var p = d.next();
              return p.done ? { done: !0, value: null } : { done: !1, value: [h++, p.value] };
            } };
          }).bind(this), u;
        }, c.prototype[Symbol.iterator] = function() {
          var u = this._items[Symbol.iterator]();
          return { next: function() {
            return u.next();
          } };
        }, c.prototype.forEach = function(u, d) {
          var h, p;
          d === void 0 && (d = a.dom.window);
          var m = 0;
          try {
            for (var b = r(this._items), y = b.next(); !y.done; y = b.next()) {
              var Z = y.value;
              u.call(d, Z, m++, this);
            }
          } catch (g) {
            h = { error: g };
          } finally {
            try {
              y && !y.done && (p = b.return) && p.call(b);
            } finally {
              if (h) throw h.error;
            }
          }
        }, c.prototype.get = function(u, d, h) {
          if (!o.isString(d)) return Reflect.get(u, d, h);
          var p = Number(d);
          return isNaN(p) ? Reflect.get(u, d, h) : u._items[p] || void 0;
        }, c.prototype.set = function(u, d, h, p) {
          if (!o.isString(d)) return Reflect.set(u, d, h, p);
          var m = Number(d);
          return isNaN(m) ? Reflect.set(u, d, h, p) : m >= 0 && m < u._items.length && (u._items[m] = h, !0);
        }, c._create = function(u, d) {
          var h = new c(u);
          return h._items = d, h;
        }, c;
      })();
      n.NodeListStaticImpl = l;
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(u, d) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(h, p) {
          h.__proto__ = p;
        } || function(h, p) {
          for (var m in p) p.hasOwnProperty(m) && (h[m] = p[m]);
        })(u, d);
      }, function(u, d) {
        function h() {
          this.constructor = u;
        }
        r(u, d), u.prototype = d === null ? Object.create(d) : (h.prototype = d.prototype, new h());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(9), l = s(0), c = (function(u) {
        function d(h) {
          var p = u.call(this) || this;
          return p._element = h, Object.setPrototypeOf(p, d.prototype), p;
        }
        return a(d, u), d.prototype._asArray = function() {
          return this;
        }, d.prototype.item = function(h) {
          return this[h] || null;
        }, d.prototype.getNamedItem = function(h) {
          return l.element_getAnAttributeByName(h, this._element);
        }, d.prototype.getNamedItemNS = function(h, p) {
          return l.element_getAnAttributeByNamespaceAndLocalName(h || "", p, this._element);
        }, d.prototype.setNamedItem = function(h) {
          return l.element_setAnAttribute(h, this._element);
        }, d.prototype.setNamedItemNS = function(h) {
          return l.element_setAnAttribute(h, this._element);
        }, d.prototype.removeNamedItem = function(h) {
          var p = l.element_removeAnAttributeByName(h, this._element);
          if (p === null) throw new o.NotFoundError();
          return p;
        }, d.prototype.removeNamedItemNS = function(h, p) {
          var m = l.element_removeAnAttributeByNamespaceAndLocalName(h || "", p, this._element);
          if (m === null) throw new o.NotFoundError();
          return m;
        }, d._create = function(h) {
          return new d(h);
        }, d;
      })(Array);
      n.NamedNodeMapImpl = c;
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(y, Z) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(g, f) {
          g.__proto__ = f;
        } || function(g, f) {
          for (var T in f) f.hasOwnProperty(T) && (g[T] = f[T]);
        })(y, Z);
      }, function(y, Z) {
        function g() {
          this.constructor = y;
        }
        r(y, Z), y.prototype = Z === null ? Object.create(Z) : (g.prototype = Z.prototype, new g());
      }), o = this && this.__values || function(y) {
        var Z = typeof Symbol == "function" && Symbol.iterator, g = Z && y[Z], f = 0;
        if (g) return g.call(y);
        if (y && typeof y.length == "number") return { next: function() {
          return y && f >= y.length && (y = void 0), { value: y && y[f++], done: !y };
        } };
        throw new TypeError(Z ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var l = s(6), c = s(2), u = s(102), d = s(9), h = s(0), p = s(12), m = s(3), b = (function(y) {
        function Z() {
          var g = y.call(this) || this, f = l.dom.window._associatedDocument;
          return g._start = [f, 0], g._end = [f, 0], l.dom.rangeList.add(g), g;
        }
        return a(Z, y), Object.defineProperty(Z.prototype, "commonAncestorContainer", { get: function() {
          for (var g = this._start[0]; !h.tree_isAncestorOf(this._end[0], g, !0); ) {
            if (g._parent === null) throw new Error("Parent node  is null.");
            g = g._parent;
          }
          return g;
        }, enumerable: !0, configurable: !0 }), Z.prototype.setStart = function(g, f) {
          h.range_setTheStart(this, g, f);
        }, Z.prototype.setEnd = function(g, f) {
          h.range_setTheEnd(this, g, f);
        }, Z.prototype.setStartBefore = function(g) {
          var f = g._parent;
          if (f === null) throw new d.InvalidNodeTypeError();
          h.range_setTheStart(this, f, h.tree_index(g));
        }, Z.prototype.setStartAfter = function(g) {
          var f = g._parent;
          if (f === null) throw new d.InvalidNodeTypeError();
          h.range_setTheStart(this, f, h.tree_index(g) + 1);
        }, Z.prototype.setEndBefore = function(g) {
          var f = g._parent;
          if (f === null) throw new d.InvalidNodeTypeError();
          h.range_setTheEnd(this, f, h.tree_index(g));
        }, Z.prototype.setEndAfter = function(g) {
          var f = g._parent;
          if (f === null) throw new d.InvalidNodeTypeError();
          h.range_setTheEnd(this, f, h.tree_index(g) + 1);
        }, Z.prototype.collapse = function(g) {
          g ? this._end = this._start : this._start = this._end;
        }, Z.prototype.selectNode = function(g) {
          h.range_select(g, this);
        }, Z.prototype.selectNodeContents = function(g) {
          if (m.Guard.isDocumentTypeNode(g)) throw new d.InvalidNodeTypeError();
          var f = h.tree_nodeLength(g);
          this._start = [g, 0], this._end = [g, f];
        }, Z.prototype.compareBoundaryPoints = function(g, f) {
          if (g !== c.HowToCompare.StartToStart && g !== c.HowToCompare.StartToEnd && g !== c.HowToCompare.EndToEnd && g !== c.HowToCompare.EndToStart) throw new d.NotSupportedError();
          if (h.range_root(this) !== h.range_root(f)) throw new d.WrongDocumentError();
          var T, M;
          switch (g) {
            case c.HowToCompare.StartToStart:
              T = this._start, M = f._start;
              break;
            case c.HowToCompare.StartToEnd:
              T = this._end, M = f._start;
              break;
            case c.HowToCompare.EndToEnd:
              T = this._end, M = f._end;
              break;
            case c.HowToCompare.EndToStart:
              T = this._start, M = f._end;
              break;
            default:
              throw new d.NotSupportedError();
          }
          var N = h.boundaryPoint_position(T, M);
          return N === c.BoundaryPosition.Before ? -1 : N === c.BoundaryPosition.After ? 1 : 0;
        }, Z.prototype.deleteContents = function() {
          var g, f, T, M;
          if (!h.range_collapsed(this)) {
            var N = this._startNode, W = this._startOffset, x = this._endNode, V = this._endOffset;
            if (N === x && m.Guard.isCharacterDataNode(N)) h.characterData_replaceData(N, W, V - W, "");
            else {
              var X, C, R = [];
              try {
                for (var z = o(h.range_getContainedNodes(this)), F = z.next(); !F.done; F = z.next()) {
                  var P = ($ = F.value)._parent;
                  P !== null && h.range_isContained(P, this) || R.push($);
                }
              } catch (A) {
                g = { error: A };
              } finally {
                try {
                  F && !F.done && (f = z.return) && f.call(z);
                } finally {
                  if (g) throw g.error;
                }
              }
              if (h.tree_isAncestorOf(x, N, !0)) X = N, C = W;
              else {
                for (var j = N; j._parent !== null && !h.tree_isAncestorOf(x, j._parent, !0); ) j = j._parent;
                if (j._parent === null) throw new Error("Parent node is null.");
                X = j._parent, C = h.tree_index(j) + 1;
              }
              m.Guard.isCharacterDataNode(N) && h.characterData_replaceData(N, W, h.tree_nodeLength(N) - W, "");
              try {
                for (var H = o(R), B = H.next(); !B.done; B = H.next()) {
                  var $;
                  ($ = B.value)._parent && h.mutation_remove($, $._parent);
                }
              } catch (A) {
                T = { error: A };
              } finally {
                try {
                  B && !B.done && (M = H.return) && M.call(H);
                } finally {
                  if (T) throw T.error;
                }
              }
              m.Guard.isCharacterDataNode(x) && h.characterData_replaceData(x, 0, V, ""), this._start = [X, C], this._end = [X, C];
            }
          }
        }, Z.prototype.extractContents = function() {
          return h.range_extract(this);
        }, Z.prototype.cloneContents = function() {
          return h.range_cloneTheContents(this);
        }, Z.prototype.insertNode = function(g) {
          return h.range_insert(g, this);
        }, Z.prototype.surroundContents = function(g) {
          var f, T;
          try {
            for (var M = o(h.range_getPartiallyContainedNodes(this)), N = M.next(); !N.done; N = M.next()) {
              var W = N.value;
              if (!m.Guard.isTextNode(W)) throw new d.InvalidStateError();
            }
          } catch (V) {
            f = { error: V };
          } finally {
            try {
              N && !N.done && (T = M.return) && T.call(M);
            } finally {
              if (f) throw f.error;
            }
          }
          if (m.Guard.isDocumentNode(g) || m.Guard.isDocumentTypeNode(g) || m.Guard.isDocumentFragmentNode(g)) throw new d.InvalidNodeTypeError();
          var x = h.range_extract(this);
          g._children.size !== 0 && h.mutation_replaceAll(null, g), h.range_insert(g, this), h.mutation_append(x, g), h.range_select(g, this);
        }, Z.prototype.cloneRange = function() {
          return h.create_range(this._start, this._end);
        }, Z.prototype.detach = function() {
          l.dom.rangeList.delete(this);
        }, Z.prototype.isPointInRange = function(g, f) {
          if (h.tree_rootNode(g) !== h.range_root(this)) return !1;
          if (m.Guard.isDocumentTypeNode(g)) throw new d.InvalidNodeTypeError();
          if (f > h.tree_nodeLength(g)) throw new d.IndexSizeError();
          var T = [g, f];
          return h.boundaryPoint_position(T, this._start) !== c.BoundaryPosition.Before && h.boundaryPoint_position(T, this._end) !== c.BoundaryPosition.After;
        }, Z.prototype.comparePoint = function(g, f) {
          if (h.tree_rootNode(g) !== h.range_root(this)) throw new d.WrongDocumentError();
          if (m.Guard.isDocumentTypeNode(g)) throw new d.InvalidNodeTypeError();
          if (f > h.tree_nodeLength(g)) throw new d.IndexSizeError();
          var T = [g, f];
          return h.boundaryPoint_position(T, this._start) === c.BoundaryPosition.Before ? -1 : h.boundaryPoint_position(T, this._end) === c.BoundaryPosition.After ? 1 : 0;
        }, Z.prototype.intersectsNode = function(g) {
          if (h.tree_rootNode(g) !== h.range_root(this)) return !1;
          var f = g._parent;
          if (f === null) return !0;
          var T = h.tree_index(g);
          return h.boundaryPoint_position([f, T], this._end) === c.BoundaryPosition.Before && h.boundaryPoint_position([f, T + 1], this._start) === c.BoundaryPosition.After;
        }, Z.prototype.toString = function() {
          var g, f, T = "";
          if (this._startNode === this._endNode && m.Guard.isTextNode(this._startNode)) return this._startNode._data.substring(this._startOffset, this._endOffset);
          m.Guard.isTextNode(this._startNode) && (T += this._startNode._data.substring(this._startOffset));
          try {
            for (var M = o(h.range_getContainedNodes(this)), N = M.next(); !N.done; N = M.next()) {
              var W = N.value;
              m.Guard.isTextNode(W) && (T += W._data);
            }
          } catch (x) {
            g = { error: x };
          } finally {
            try {
              N && !N.done && (f = M.return) && f.call(M);
            } finally {
              if (g) throw g.error;
            }
          }
          return m.Guard.isTextNode(this._endNode) && (T += this._endNode._data.substring(0, this._endOffset)), T;
        }, Z._create = function(g, f) {
          var T = new Z();
          return g && (T._start = g), f && (T._end = f), T;
        }, Z.START_TO_START = 0, Z.START_TO_END = 1, Z.END_TO_END = 2, Z.END_TO_START = 3, Z;
      })(u.AbstractRangeImpl);
      n.RangeImpl = b, p.idl_defineConst(b.prototype, "START_TO_START", 0), p.idl_defineConst(b.prototype, "START_TO_END", 1), p.idl_defineConst(b.prototype, "END_TO_END", 2), p.idl_defineConst(b.prototype, "END_TO_START", 3);
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(u, d) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(h, p) {
          h.__proto__ = p;
        } || function(h, p) {
          for (var m in p) p.hasOwnProperty(m) && (h[m] = p[m]);
        })(u, d);
      }, function(u, d) {
        function h() {
          this.constructor = u;
        }
        r(u, d), u.prototype = d === null ? Object.create(d) : (h.prototype = d.prototype, new h());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(103), l = s(0), c = (function(u) {
        function d(h, p, m) {
          var b = u.call(this, h) || this;
          return b._iteratorCollection = void 0, b._reference = p, b._pointerBeforeReference = m, l.nodeIterator_iteratorList().add(b), b;
        }
        return a(d, u), Object.defineProperty(d.prototype, "referenceNode", { get: function() {
          return this._reference;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(d.prototype, "pointerBeforeReferenceNode", { get: function() {
          return this._pointerBeforeReference;
        }, enumerable: !0, configurable: !0 }), d.prototype.nextNode = function() {
          return l.nodeIterator_traverse(this, !0);
        }, d.prototype.previousNode = function() {
          return l.nodeIterator_traverse(this, !1);
        }, d.prototype.detach = function() {
          l.nodeIterator_iteratorList().delete(this);
        }, d._create = function(h, p, m) {
          return new d(h, p, m);
        }, d;
      })(o.TraverserImpl);
      n.NodeIteratorImpl = c;
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(d, h) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, m) {
          p.__proto__ = m;
        } || function(p, m) {
          for (var b in m) m.hasOwnProperty(b) && (p[b] = m[b]);
        })(d, h);
      }, function(d, h) {
        function p() {
          this.constructor = d;
        }
        r(d, h), d.prototype = h === null ? Object.create(h) : (p.prototype = h.prototype, new p());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(2), l = s(103), c = s(0), u = (function(d) {
        function h(p, m) {
          var b = d.call(this, p) || this;
          return b._current = m, b;
        }
        return a(h, d), Object.defineProperty(h.prototype, "currentNode", { get: function() {
          return this._current;
        }, set: function(p) {
          this._current = p;
        }, enumerable: !0, configurable: !0 }), h.prototype.parentNode = function() {
          for (var p = this._current; p !== null && p !== this._root; ) if ((p = p._parent) !== null && c.traversal_filter(this, p) === o.FilterResult.Accept) return this._current = p, p;
          return null;
        }, h.prototype.firstChild = function() {
          return c.treeWalker_traverseChildren(this, !0);
        }, h.prototype.lastChild = function() {
          return c.treeWalker_traverseChildren(this, !1);
        }, h.prototype.nextSibling = function() {
          return c.treeWalker_traverseSiblings(this, !0);
        }, h.prototype.previousNode = function() {
          for (var p = this._current; p !== this._root; ) {
            for (var m = p._previousSibling; m; ) {
              p = m;
              for (var b = c.traversal_filter(this, p); b !== o.FilterResult.Reject && p._lastChild; ) p = p._lastChild, b = c.traversal_filter(this, p);
              if (b === o.FilterResult.Accept) return this._current = p, p;
              m = p._previousSibling;
            }
            if (p === this._root || p._parent === null) return null;
            if (p = p._parent, c.traversal_filter(this, p) === o.FilterResult.Accept) return this._current = p, p;
          }
          return null;
        }, h.prototype.previousSibling = function() {
          return c.treeWalker_traverseSiblings(this, !1);
        }, h.prototype.nextNode = function() {
          for (var p = this._current, m = o.FilterResult.Accept; ; ) {
            for (; m !== o.FilterResult.Reject && p._firstChild; ) if (p = p._firstChild, (m = c.traversal_filter(this, p)) === o.FilterResult.Accept) return this._current = p, p;
            for (var b = null, y = p; y !== null; ) {
              if (y === this._root) return null;
              if ((b = y._nextSibling) !== null) {
                p = b;
                break;
              }
              y = y._parent;
            }
            if ((m = c.traversal_filter(this, p)) === o.FilterResult.Accept) return this._current = p, p;
          }
        }, h._create = function(p, m) {
          return new h(p, m);
        }, h;
      })(l.TraverserImpl);
      n.TreeWalkerImpl = u;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(2), a = s(12), o = (function() {
        function l() {
        }
        return l.prototype.acceptNode = function(c) {
          return r.FilterResult.Accept;
        }, l._create = function() {
          return new l();
        }, l.FILTER_ACCEPT = 1, l.FILTER_REJECT = 2, l.FILTER_SKIP = 3, l.SHOW_ALL = 4294967295, l.SHOW_ELEMENT = 1, l.SHOW_ATTRIBUTE = 2, l.SHOW_TEXT = 4, l.SHOW_CDATA_SECTION = 8, l.SHOW_ENTITY_REFERENCE = 16, l.SHOW_ENTITY = 32, l.SHOW_PROCESSING_INSTRUCTION = 64, l.SHOW_COMMENT = 128, l.SHOW_DOCUMENT = 256, l.SHOW_DOCUMENT_TYPE = 512, l.SHOW_DOCUMENT_FRAGMENT = 1024, l.SHOW_NOTATION = 2048, l;
      })();
      n.NodeFilterImpl = o, a.idl_defineConst(o.prototype, "FILTER_ACCEPT", 1), a.idl_defineConst(o.prototype, "FILTER_REJECT", 2), a.idl_defineConst(o.prototype, "FILTER_SKIP", 3), a.idl_defineConst(o.prototype, "SHOW_ALL", 4294967295), a.idl_defineConst(o.prototype, "SHOW_ELEMENT", 1), a.idl_defineConst(o.prototype, "SHOW_ATTRIBUTE", 2), a.idl_defineConst(o.prototype, "SHOW_TEXT", 4), a.idl_defineConst(o.prototype, "SHOW_CDATA_SECTION", 8), a.idl_defineConst(o.prototype, "SHOW_ENTITY_REFERENCE", 16), a.idl_defineConst(o.prototype, "SHOW_ENTITY", 32), a.idl_defineConst(o.prototype, "SHOW_PROCESSING_INSTRUCTION", 64), a.idl_defineConst(o.prototype, "SHOW_COMMENT", 128), a.idl_defineConst(o.prototype, "SHOW_DOCUMENT", 256), a.idl_defineConst(o.prototype, "SHOW_DOCUMENT_TYPE", 512), a.idl_defineConst(o.prototype, "SHOW_DOCUMENT_FRAGMENT", 1024), a.idl_defineConst(o.prototype, "SHOW_NOTATION", 2048);
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = (function() {
        function a(o, l, c, u, d, h, p, m, b) {
          this._type = o, this._target = l, this._addedNodes = c, this._removedNodes = u, this._previousSibling = d, this._nextSibling = h, this._attributeName = p, this._attributeNamespace = m, this._oldValue = b;
        }
        return Object.defineProperty(a.prototype, "type", { get: function() {
          return this._type;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(a.prototype, "target", { get: function() {
          return this._target;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(a.prototype, "addedNodes", { get: function() {
          return this._addedNodes;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(a.prototype, "removedNodes", { get: function() {
          return this._removedNodes;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(a.prototype, "previousSibling", { get: function() {
          return this._previousSibling;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(a.prototype, "nextSibling", { get: function() {
          return this._nextSibling;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(a.prototype, "attributeName", { get: function() {
          return this._attributeName;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(a.prototype, "attributeNamespace", { get: function() {
          return this._attributeNamespace;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(a.prototype, "oldValue", { get: function() {
          return this._oldValue;
        }, enumerable: !0, configurable: !0 }), a._create = function(o, l, c, u, d, h, p, m, b) {
          return new a(o, l, c, u, d, h, p, m, b);
        }, a;
      })();
      n.MutationRecordImpl = r;
    }, function(e, n, s) {
      var r = this && this.__values || function(d) {
        var h = typeof Symbol == "function" && Symbol.iterator, p = h && d[h], m = 0;
        if (p) return p.call(d);
        if (d && typeof d.length == "number") return { next: function() {
          return d && m >= d.length && (d = void 0), { value: d && d[m++], done: !d };
        } };
        throw new TypeError(h ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = s(6), o = s(9), l = s(7), c = s(0), u = (function() {
        function d(h, p) {
          this._element = h, this._attribute = p, this._tokenSet = /* @__PURE__ */ new Set();
          var m = p._localName, b = c.element_getAnAttributeValue(h, m), y = this;
          this._element._attributeChangeSteps.push((function(Z, g, f, T, M) {
            g === y._attribute._localName && M === null && (T ? y._tokenSet = c.orderedSet_parse(T) : y._tokenSet.clear());
          })), a.dom.features.steps && c.dom_runAttributeChangeSteps(h, m, b, b, null);
        }
        return Object.defineProperty(d.prototype, "length", { get: function() {
          return this._tokenSet.size;
        }, enumerable: !0, configurable: !0 }), d.prototype.item = function(h) {
          var p, m, b = 0;
          try {
            for (var y = r(this._tokenSet), Z = y.next(); !Z.done; Z = y.next()) {
              var g = Z.value;
              if (b === h) return g;
              b++;
            }
          } catch (f) {
            p = { error: f };
          } finally {
            try {
              Z && !Z.done && (m = y.return) && m.call(y);
            } finally {
              if (p) throw p.error;
            }
          }
          return null;
        }, d.prototype.contains = function(h) {
          return this._tokenSet.has(h);
        }, d.prototype.add = function() {
          for (var h, p, m = [], b = 0; b < arguments.length; b++) m[b] = arguments[b];
          try {
            for (var y = r(m), Z = y.next(); !Z.done; Z = y.next()) {
              var g = Z.value;
              if (g === "") throw new o.SyntaxError("Cannot add an empty token.");
              if (l.codePoint.ASCIIWhiteSpace.test(g)) throw new o.InvalidCharacterError("Token cannot contain whitespace.");
              this._tokenSet.add(g);
            }
          } catch (f) {
            h = { error: f };
          } finally {
            try {
              Z && !Z.done && (p = y.return) && p.call(y);
            } finally {
              if (h) throw h.error;
            }
          }
          c.tokenList_updateSteps(this);
        }, d.prototype.remove = function() {
          for (var h, p, m = [], b = 0; b < arguments.length; b++) m[b] = arguments[b];
          try {
            for (var y = r(m), Z = y.next(); !Z.done; Z = y.next()) {
              var g = Z.value;
              if (g === "") throw new o.SyntaxError("Cannot remove an empty token.");
              if (l.codePoint.ASCIIWhiteSpace.test(g)) throw new o.InvalidCharacterError("Token cannot contain whitespace.");
              this._tokenSet.delete(g);
            }
          } catch (f) {
            h = { error: f };
          } finally {
            try {
              Z && !Z.done && (p = y.return) && p.call(y);
            } finally {
              if (h) throw h.error;
            }
          }
          c.tokenList_updateSteps(this);
        }, d.prototype.toggle = function(h, p) {
          if (p === void 0 && (p = void 0), h === "") throw new o.SyntaxError("Cannot toggle an empty token.");
          if (l.codePoint.ASCIIWhiteSpace.test(h)) throw new o.InvalidCharacterError("Token cannot contain whitespace.");
          return this._tokenSet.has(h) ? p !== void 0 && p !== !1 || (this._tokenSet.delete(h), c.tokenList_updateSteps(this), !1) : (p === void 0 || p === !0) && (this._tokenSet.add(h), c.tokenList_updateSteps(this), !0);
        }, d.prototype.replace = function(h, p) {
          if (h === "" || p === "") throw new o.SyntaxError("Cannot replace an empty token.");
          if (l.codePoint.ASCIIWhiteSpace.test(h) || l.codePoint.ASCIIWhiteSpace.test(p)) throw new o.InvalidCharacterError("Token cannot contain whitespace.");
          return !!this._tokenSet.has(h) && (l.set.replace(this._tokenSet, h, p), c.tokenList_updateSteps(this), !0);
        }, d.prototype.supports = function(h) {
          return c.tokenList_validationSteps(this, h);
        }, Object.defineProperty(d.prototype, "value", { get: function() {
          return c.tokenList_serializeSteps(this);
        }, set: function(h) {
          c.element_setAnAttributeValue(this._element, this._attribute._localName, h);
        }, enumerable: !0, configurable: !0 }), d.prototype[Symbol.iterator] = function() {
          var h = this._tokenSet[Symbol.iterator]();
          return { next: function() {
            return h.next();
          } };
        }, d._create = function(h, p) {
          return new d(h, p);
        }, d;
      })();
      n.DOMTokenListImpl = u;
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(u, d) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(h, p) {
          h.__proto__ = p;
        } || function(h, p) {
          for (var m in p) p.hasOwnProperty(m) && (h[m] = p[m]);
        })(u, d);
      }, function(u, d) {
        function h() {
          this.constructor = u;
        }
        r(u, d), u.prototype = d === null ? Object.create(d) : (h.prototype = d.prototype, new h());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(104), l = s(0), c = (function(u) {
        function d(h, p) {
          var m = u.call(this, h, p) || this;
          return m._detail = null, m._detail = p && p.detail || null, m;
        }
        return a(d, u), Object.defineProperty(d.prototype, "detail", { get: function() {
          return this._detail;
        }, enumerable: !0, configurable: !0 }), d.prototype.initCustomEvent = function(h, p, m, b) {
          p === void 0 && (p = !1), m === void 0 && (m = !1), b === void 0 && (b = null), this._dispatchFlag || (l.event_initialize(this, h, p, m), this._detail = b);
        }, d;
      })(o.EventImpl);
      n.CustomEventImpl = c;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(6), a = s(2), o = s(105), l = s(17);
      n.nodeIterator_traverse = function(c, u) {
        for (var d = c._reference, h = c._pointerBeforeReference; ; ) {
          if (u) if (h) h = !1;
          else {
            var p = l.tree_getFollowingNode(c._root, d);
            if (!p) return null;
            d = p;
          }
          else if (h) {
            var m = l.tree_getPrecedingNode(c.root, d);
            if (!m) return null;
            d = m;
          } else h = !0;
          if (o.traversal_filter(c, d) === a.FilterResult.Accept) break;
        }
        return c._reference = d, c._pointerBeforeReference = h, d;
      }, n.nodeIterator_iteratorList = function() {
        return r.dom.window._iteratorList;
      };
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(9), a = s(7), o = s(174);
      function l(c) {
        if (!o.xml_isName(c)) throw new r.InvalidCharacterError("Invalid XML name: " + c);
        if (!o.xml_isQName(c)) throw new r.InvalidCharacterError("Invalid XML qualified name: " + c + ".");
      }
      n.namespace_validate = l, n.namespace_validateAndExtract = function(c, u) {
        c || (c = null), l(u);
        var d = u.split(":"), h = d.length === 2 ? d[0] : null, p = d.length === 2 ? d[1] : u;
        if (h && c === null) throw new r.NamespaceError("Qualified name includes a prefix but the namespace is null.");
        if (h === "xml" && c !== a.namespace.XML) throw new r.NamespaceError('Qualified name includes the "xml" prefix but the namespace is not the XML namespace.');
        if (c !== a.namespace.XMLNS && (h === "xmlns" || u === "xmlns")) throw new r.NamespaceError('Qualified name includes the "xmlns" prefix but the namespace is not the XMLNS namespace.');
        if (c === a.namespace.XMLNS && h !== "xmlns" && u !== "xmlns") throw new r.NamespaceError('Qualified name does not include the "xmlns" prefix but the namespace is the XMLNS namespace.');
        return [c, h, p];
      }, n.namespace_extractQName = function(c) {
        l(c);
        var u = c.split(":");
        return [u.length === 2 ? u[0] : null, u.length === 2 ? u[1] : c];
      };
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 }), n.xml_isName = function(r) {
        for (var a = 0; a < r.length; a++) {
          var o = r.charCodeAt(a);
          if (!(o >= 97 && o <= 122 || o >= 65 && o <= 90 || o === 58 || o === 95 || o >= 192 && o <= 214 || o >= 216 && o <= 246 || o >= 248 && o <= 767 || o >= 880 && o <= 893 || o >= 895 && o <= 8191 || o >= 8204 && o <= 8205 || o >= 8304 && o <= 8591 || o >= 11264 && o <= 12271 || o >= 12289 && o <= 55295 || o >= 63744 && o <= 64975 || o >= 65008 && o <= 65533) && (a === 0 || !(o === 45 || o === 46 || o >= 48 && o <= 57 || o === 183 || o >= 768 && o <= 879 || o >= 8255 && o <= 8256))) {
            if (o >= 55296 && o <= 56319 && a < r.length - 1) {
              var l = r.charCodeAt(a + 1);
              if (l >= 56320 && l <= 57343 && (a++, (o = 1024 * (o - 55296) + l - 56320 + 65536) >= 65536 && o <= 983039)) continue;
            }
            return !1;
          }
        }
        return !0;
      }, n.xml_isQName = function(r) {
        for (var a = !1, o = 0; o < r.length; o++) {
          var l = r.charCodeAt(o);
          if (!(l >= 97 && l <= 122 || l >= 65 && l <= 90 || l === 95 || l >= 192 && l <= 214 || l >= 216 && l <= 246 || l >= 248 && l <= 767 || l >= 880 && l <= 893 || l >= 895 && l <= 8191 || l >= 8204 && l <= 8205 || l >= 8304 && l <= 8591 || l >= 11264 && l <= 12271 || l >= 12289 && l <= 55295 || l >= 63744 && l <= 64975 || l >= 65008 && l <= 65533) && (o === 0 || !(l === 45 || l === 46 || l >= 48 && l <= 57 || l === 183 || l >= 768 && l <= 879 || l >= 8255 && l <= 8256))) {
            if (o === 0 || l !== 58) {
              if (l >= 55296 && l <= 56319 && o < r.length - 1) {
                var c = r.charCodeAt(o + 1);
                if (c >= 56320 && c <= 57343 && (o++, (l = 1024 * (l - 55296) + c - 56320 + 65536) >= 65536 && l <= 983039)) continue;
              }
              return !1;
            }
            if (a || o === r.length - 1) return !1;
            a = !0;
          }
        }
        return !0;
      }, n.xml_isLegalChar = function(r) {
        for (var a = 0; a < r.length; a++) {
          var o = r.charCodeAt(a);
          if (!(o === 9 || o === 10 || o === 13 || o >= 32 && o <= 55295 || o >= 57344 && o <= 65533)) {
            if (o >= 55296 && o <= 56319 && a < r.length - 1) {
              var l = r.charCodeAt(a + 1);
              if (l >= 56320 && l <= 57343 && (a++, (o = 1024 * (o - 55296) + l - 56320 + 65536) >= 65536 && o <= 1114111)) continue;
            }
            return !1;
          }
        }
        return !0;
      }, n.xml_isPubidChar = function(r) {
        for (var a = 0; a < r.length; a++) {
          var o = r.charCodeAt(a);
          if (!(o >= 97 && o <= 122 || o >= 65 && o <= 90 || o >= 39 && o <= 59 || o === 32 || o === 13 || o === 10 || o >= 35 && o <= 37 || o === 33 || o === 61 || o === 63 || o === 64 || o === 95)) return !1;
        }
        return !0;
      };
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(2), a = s(17);
      n.boundaryPoint_position = function o(l, c) {
        var u = l[0], d = l[1], h = c[0], p = c[1];
        if (console.assert(a.tree_rootNode(u) === a.tree_rootNode(h), "Boundary points must share the same root node."), u === h) return d === p ? r.BoundaryPosition.Equal : d < p ? r.BoundaryPosition.Before : r.BoundaryPosition.After;
        if (a.tree_isFollowing(h, u)) {
          var m = o([h, p], [u, d]);
          if (m === r.BoundaryPosition.Before) return r.BoundaryPosition.After;
          if (m === r.BoundaryPosition.After) return r.BoundaryPosition.Before;
        }
        if (a.tree_isAncestorOf(h, u)) {
          for (var b = h; !a.tree_isChildOf(u, b); ) b._parent !== null && (b = b._parent);
          if (a.tree_index(b) < d) return r.BoundaryPosition.After;
        }
        return r.BoundaryPosition.Before;
      };
    }, function(e, n, s) {
      var r = this && this.__values || function(m) {
        var b = typeof Symbol == "function" && Symbol.iterator, y = b && m[b], Z = 0;
        if (y) return y.call(m);
        if (m && typeof m.length == "number") return { next: function() {
          return m && Z >= m.length && (m = void 0), { value: m && m[Z++], done: !m };
        } };
        throw new TypeError(b ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = s(6), o = s(3), l = s(7), c = s(29), u = s(108), d = s(30), h = s(37), p = s(52);
      n.node_stringReplaceAll = function(m, b) {
        var y = null;
        m !== "" && (y = c.create_text(b._nodeDocument, m)), h.mutation_replaceAll(y, b);
      }, n.node_clone = function m(b, y, Z) {
        var g, f, T, M, N;
        if (y === void 0 && (y = null), Z === void 0 && (Z = !1), y === null && (y = b._nodeDocument), o.Guard.isElementNode(b)) {
          N = p.element_createAnElement(y, b._localName, b._namespace, b._namespacePrefix, b._is, !1);
          try {
            for (var W = r(b._attributeList), x = W.next(); !x.done; x = W.next()) {
              var V = m(x.value, y);
              p.element_append(V, N);
            }
          } catch (P) {
            g = { error: P };
          } finally {
            try {
              x && !x.done && (f = W.return) && f.call(W);
            } finally {
              if (g) throw g.error;
            }
          }
        } else if (o.Guard.isDocumentNode(b)) {
          var X = c.create_document();
          X._encoding = b._encoding, X._contentType = b._contentType, X._URL = b._URL, X._origin = b._origin, X._type = b._type, X._mode = b._mode, N = X;
        } else if (o.Guard.isDocumentTypeNode(b))
          N = c.create_documentType(y, b._name, b._publicId, b._systemId);
        else if (o.Guard.isAttrNode(b)) {
          var C = c.create_attr(y, b.localName);
          C._namespace = b._namespace, C._namespacePrefix = b._namespacePrefix, C._value = b._value, N = C;
        } else N = o.Guard.isExclusiveTextNode(b) ? c.create_text(y, b._data) : o.Guard.isCDATASectionNode(b) ? c.create_cdataSection(y, b._data) : o.Guard.isCommentNode(b) ? c.create_comment(y, b._data) : o.Guard.isProcessingInstructionNode(b) ? c.create_processingInstruction(y, b._target, b._data) : o.Guard.isDocumentFragmentNode(b) ? c.create_documentFragment(y) : Object.create(b);
        if (o.Guard.isDocumentNode(N) ? (N._nodeDocument = N, y = N) : N._nodeDocument = y, a.dom.features.steps && d.dom_runCloningSteps(N, b, y, Z), Z) try {
          for (var R = r(b._children), z = R.next(); !z.done; z = R.next()) {
            var F = m(z.value, y, !0);
            h.mutation_append(F, N);
          }
        } catch (P) {
          T = { error: P };
        } finally {
          try {
            z && !z.done && (M = R.return) && M.call(R);
          } finally {
            if (T) throw T.error;
          }
        }
        return N;
      }, n.node_equals = function m(b, y) {
        var Z, g, f, T;
        if (b._nodeType !== y._nodeType) return !1;
        if (o.Guard.isDocumentTypeNode(b) && o.Guard.isDocumentTypeNode(y)) {
          if (b._name !== y._name || b._publicId !== y._publicId || b._systemId !== y._systemId) return !1;
        } else if (o.Guard.isElementNode(b) && o.Guard.isElementNode(y)) {
          if (b._namespace !== y._namespace || b._namespacePrefix !== y._namespacePrefix || b._localName !== y._localName || b._attributeList.length !== y._attributeList.length) return !1;
        } else if (o.Guard.isAttrNode(b) && o.Guard.isAttrNode(y)) {
          if (b._namespace !== y._namespace || b._localName !== y._localName || b._value !== y._value) return !1;
        } else if (o.Guard.isProcessingInstructionNode(b) && o.Guard.isProcessingInstructionNode(y)) {
          if (b._target !== y._target || b._data !== y._data) return !1;
        } else if (o.Guard.isCharacterDataNode(b) && o.Guard.isCharacterDataNode(y) && b._data !== y._data) return !1;
        if (o.Guard.isElementNode(b) && o.Guard.isElementNode(y)) {
          var M = {};
          try {
            for (var N = r(b._attributeList), W = N.next(); !W.done; W = N.next())
              M[(X = W.value)._localName] = X;
          } catch (j) {
            Z = { error: j };
          } finally {
            try {
              W && !W.done && (g = N.return) && g.call(N);
            } finally {
              if (Z) throw Z.error;
            }
          }
          try {
            for (var x = r(y._attributeList), V = x.next(); !V.done; V = x.next()) {
              var X, C = V.value;
              if (!(X = M[C._localName]) || !m(X, C)) return !1;
            }
          } catch (j) {
            f = { error: j };
          } finally {
            try {
              V && !V.done && (T = x.return) && T.call(x);
            } finally {
              if (f) throw f.error;
            }
          }
        }
        if (b._children.size !== y._children.size) return !1;
        for (var R = b._children[Symbol.iterator](), z = y._children[Symbol.iterator](), F = R.next(), P = z.next(); !F.done && !P.done; ) {
          if (!m(F.value, P.value)) return !1;
          F = R.next(), P = z.next();
        }
        return !0;
      }, n.node_listOfElementsWithQualifiedName = function(m, b) {
        return m === "*" ? c.create_htmlCollection(b) : b._nodeDocument._type === "html" ? c.create_htmlCollection(b, (function(y) {
          return y._namespace === l.namespace.HTML && y._qualifiedName === m.toLowerCase() || y._namespace !== l.namespace.HTML && y._qualifiedName === m;
        })) : c.create_htmlCollection(b, (function(y) {
          return y._qualifiedName === m;
        }));
      }, n.node_listOfElementsWithNamespace = function(m, b, y) {
        return m === "" && (m = null), m === "*" && b === "*" ? c.create_htmlCollection(y) : m === "*" ? c.create_htmlCollection(y, (function(Z) {
          return Z._localName === b;
        })) : b === "*" ? c.create_htmlCollection(y, (function(Z) {
          return Z._namespace === m;
        })) : c.create_htmlCollection(y, (function(Z) {
          return Z._localName === b && Z._namespace === m;
        }));
      }, n.node_listOfElementsWithClassNames = function(m, b) {
        var y = u.orderedSet_parse(m);
        if (y.size === 0) return c.create_htmlCollection(b, (function() {
          return !1;
        }));
        var Z = b._nodeDocument._mode !== "quirks";
        return c.create_htmlCollection(b, (function(g) {
          var f = g.classList;
          return u.orderedSet_contains(f._tokenSet, y, Z);
        }));
      }, n.node_locateANamespacePrefix = function m(b, y) {
        if (b._namespace === y && b._namespacePrefix !== null) return b._namespacePrefix;
        for (var Z = 0; Z < b._attributeList.length; Z++) {
          var g = b._attributeList[Z];
          if (g._namespacePrefix === "xmlns" && g._value === y) return g._localName;
        }
        return b._parent && o.Guard.isElementNode(b._parent) ? m(b._parent, y) : null;
      }, n.node_locateANamespace = function m(b, y) {
        if (o.Guard.isElementNode(b)) {
          if (b._namespace !== null && b._namespacePrefix === y) return b._namespace;
          for (var Z = 0; Z < b._attributeList.length; Z++) {
            var g = b._attributeList[Z];
            if (g._namespace === l.namespace.XMLNS && g._namespacePrefix === "xmlns" && g._localName === y || y === null && g._namespace === l.namespace.XMLNS && g._namespacePrefix === null && g._localName === "xmlns") return g._value || null;
          }
          return b.parentElement === null ? null : m(b.parentElement, y);
        }
        return o.Guard.isDocumentNode(b) ? b.documentElement === null ? null : m(b.documentElement, y) : o.Guard.isDocumentTypeNode(b) || o.Guard.isDocumentFragmentNode(b) ? null : o.Guard.isAttrNode(b) ? b._element === null ? null : m(b._element, y) : b._parent && o.Guard.isElementNode(b._parent) ? m(b._parent, y) : null;
      };
    }, function(e, n, s) {
      var r = this && this.__values || function(p) {
        var m = typeof Symbol == "function" && Symbol.iterator, b = m && p[m], y = 0;
        if (b) return b.call(p);
        if (p && typeof p.length == "number") return { next: function() {
          return p && y >= p.length && (p = void 0), { value: p && p[y++], done: !p };
        } };
        throw new TypeError(m ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = s(6), o = s(3), l = s(9), c = s(29), u = s(17), d = s(107), h = s(37);
      n.text_contiguousTextNodes = function(p, m) {
        var b;
        return m === void 0 && (m = !1), (b = {})[Symbol.iterator] = function() {
          for (var y = p; y && o.Guard.isTextNode(y._previousSibling); ) y = y._previousSibling;
          return { next: function() {
            if (y && !m && y === p && (y = o.Guard.isTextNode(y._nextSibling) ? y._nextSibling : null), y === null) return { done: !0, value: null };
            var Z = { done: !1, value: y };
            return y = o.Guard.isTextNode(y._nextSibling) ? y._nextSibling : null, Z;
          } };
        }, b;
      }, n.text_contiguousExclusiveTextNodes = function(p, m) {
        var b;
        return m === void 0 && (m = !1), (b = {})[Symbol.iterator] = function() {
          for (var y = p; y && o.Guard.isExclusiveTextNode(y._previousSibling); ) y = y._previousSibling;
          return { next: function() {
            if (y && !m && y === p && (y = o.Guard.isExclusiveTextNode(y._nextSibling) ? y._nextSibling : null), y === null) return { done: !0, value: null };
            var Z = { done: !1, value: y };
            return y = o.Guard.isExclusiveTextNode(y._nextSibling) ? y._nextSibling : null, Z;
          } };
        }, b;
      }, n.text_descendantTextContent = function(p) {
        for (var m = "", b = u.tree_getFirstDescendantNode(p, !1, !1, (function(y) {
          return o.Guard.isTextNode(y);
        })); b !== null; ) m += b._data, b = u.tree_getNextDescendantNode(p, b, !1, !1, (function(y) {
          return o.Guard.isTextNode(y);
        }));
        return m;
      }, n.text_split = function(p, m) {
        var b, y, Z = p._data.length;
        if (m > Z) throw new l.IndexSizeError();
        var g = Z - m, f = d.characterData_substringData(p, m, g), T = c.create_text(p._nodeDocument, f), M = p._parent;
        if (M !== null) {
          h.mutation_insert(T, M, p._nextSibling);
          try {
            for (var N = r(a.dom.rangeList), W = N.next(); !W.done; W = N.next()) {
              var x = W.value;
              x._start[0] === p && x._start[1] > m && (x._start[0] = T, x._start[1] -= m), x._end[0] === p && x._end[1] > m && (x._end[0] = T, x._end[1] -= m);
              var V = u.tree_index(p);
              x._start[0] === M && x._start[1] === V + 1 && x._start[1]++, x._end[0] === M && x._end[1] === V + 1 && x._end[1]++;
            }
          } catch (X) {
            b = { error: X };
          } finally {
            try {
              W && !W.done && (y = N.return) && y.call(N);
            } finally {
              if (b) throw b.error;
            }
          }
        }
        return d.characterData_replaceData(p, m, g, ""), T;
      };
    }, function(e, n, s) {
      var r = s(4), a = s(41), o = s(24), l = s(48), c = [].join, u = a != Object, d = l("join", ",");
      r({ target: "Array", proto: !0, forced: u || !d }, { join: function(h) {
        return c.call(o(this), h === void 0 ? "," : h);
      } });
    }, function(e, n, s) {
      var r = s(4), a = s(83), o = String.fromCharCode, l = String.fromCodePoint;
      r({ target: "String", stat: !0, forced: !!l && l.length != 1 }, { fromCodePoint: function(c) {
        for (var u, d = [], h = arguments.length, p = 0; h > p; ) {
          if (u = +arguments[p++], a(u, 1114111) !== u) throw RangeError(u + " is not a valid code point");
          d.push(u < 65536 ? o(u) : o(55296 + ((u -= 65536) >> 10), u % 1024 + 56320));
        }
        return d.join("");
      } });
    }, function(e, n, s) {
      var r = this && this.__read || function(l, c) {
        var u = typeof Symbol == "function" && l[Symbol.iterator];
        if (!u) return l;
        var d, h, p = u.call(l), m = [];
        try {
          for (; (c === void 0 || c-- > 0) && !(d = p.next()).done; ) m.push(d.value);
        } catch (b) {
          h = { error: b };
        } finally {
          try {
            d && !d.done && (u = p.return) && u.call(p);
          } finally {
            if (h) throw h.error;
          }
        }
        return m;
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = s(111), o = (function() {
        function l(c, u) {
          this._options = { skipWhitespaceOnlyText: !1 }, this.err = { line: -1, col: -1, index: -1, str: "" }, this._str = c, this._index = 0, this._length = c.length, u && (this._options.skipWhitespaceOnlyText = u.skipWhitespaceOnlyText || !1);
        }
        return l.prototype.nextToken = function() {
          if (this.eof()) return { type: a.TokenType.EOF };
          var c = this.skipIfStartsWith("<") ? this.openBracket() : this.text();
          return this._options.skipWhitespaceOnlyText && c.type === a.TokenType.Text && l.isWhiteSpaceToken(c) && (c = this.nextToken()), c;
        }, l.prototype.openBracket = function() {
          return this.skipIfStartsWith("?") ? this.skipIfStartsWith("xml") ? l.isSpace(this._str[this._index]) ? this.declaration() : (this.seek(-3), this.pi()) : this.pi() : this.skipIfStartsWith("!") ? this.skipIfStartsWith("--") ? this.comment() : this.skipIfStartsWith("[CDATA[") ? this.cdata() : this.skipIfStartsWith("DOCTYPE") ? this.doctype() : void this.throwError("Invalid '!' in opening tag.") : this.skipIfStartsWith("/") ? this.closeTag() : this.openTag();
        }, l.prototype.declaration = function() {
          for (var c = "", u = "", d = ""; !this.eof(); ) {
            if (this.skipSpace(), this.skipIfStartsWith("?>")) return { type: a.TokenType.Declaration, version: c, encoding: u, standalone: d };
            var h = r(this.attribute(), 2), p = h[0], m = h[1];
            p === "version" ? c = m : p === "encoding" ? u = m : p === "standalone" ? d = m : this.throwError("Invalid attribute name: " + p);
          }
          this.throwError("Missing declaration end symbol `?>`");
        }, l.prototype.doctype = function() {
          var c = "", u = "";
          this.skipSpace();
          var d = this.takeUntil2("[", ">", !0);
          return this.skipSpace(), this.skipIfStartsWith("PUBLIC") ? (c = this.quotedString(), u = this.quotedString()) : this.skipIfStartsWith("SYSTEM") && (u = this.quotedString()), this.skipSpace(), this.skipIfStartsWith("[") && (this.skipUntil("]"), this.skipIfStartsWith("]") || this.throwError("Missing end bracket of DTD internal subset")), this.skipSpace(), this.skipIfStartsWith(">") || this.throwError("Missing doctype end symbol `>`"), { type: a.TokenType.DocType, name: d, pubId: c, sysId: u };
        }, l.prototype.pi = function() {
          var c = this.takeUntilStartsWith("?>", !0);
          if (this.eof() && this.throwError("Missing processing instruction end symbol `?>`"), this.skipSpace(), this.skipIfStartsWith("?>")) return { type: a.TokenType.PI, target: c, data: "" };
          var u = this.takeUntilStartsWith("?>");
          return this.eof() && this.throwError("Missing processing instruction end symbol `?>`"), this.seek(2), { type: a.TokenType.PI, target: c, data: u };
        }, l.prototype.text = function() {
          var c = this.takeUntil("<");
          return { type: a.TokenType.Text, data: c };
        }, l.prototype.comment = function() {
          var c = this.takeUntilStartsWith("-->");
          return this.eof() && this.throwError("Missing comment end symbol `-->`"), this.seek(3), { type: a.TokenType.Comment, data: c };
        }, l.prototype.cdata = function() {
          var c = this.takeUntilStartsWith("]]>");
          return this.eof() && this.throwError("Missing CDATA end symbol `]>`"), this.seek(3), { type: a.TokenType.CDATA, data: c };
        }, l.prototype.openTag = function() {
          this.skipSpace();
          var c = this.takeUntil2(">", "/", !0);
          if (this.skipSpace(), this.skipIfStartsWith(">")) return { type: a.TokenType.Element, name: c, attributes: [], selfClosing: !1 };
          if (this.skipIfStartsWith("/>")) return { type: a.TokenType.Element, name: c, attributes: [], selfClosing: !0 };
          for (var u = []; !this.eof(); ) {
            if (this.skipSpace(), this.skipIfStartsWith(">")) return { type: a.TokenType.Element, name: c, attributes: u, selfClosing: !1 };
            if (this.skipIfStartsWith("/>")) return { type: a.TokenType.Element, name: c, attributes: u, selfClosing: !0 };
            var d = this.attribute();
            u.push(d);
          }
          this.throwError("Missing opening element tag end symbol `>`");
        }, l.prototype.closeTag = function() {
          this.skipSpace();
          var c = this.takeUntil(">", !0);
          return this.skipSpace(), this.skipIfStartsWith(">") || this.throwError("Missing closing element tag end symbol `>`"), { type: a.TokenType.ClosingTag, name: c };
        }, l.prototype.attribute = function() {
          this.skipSpace();
          var c = this.takeUntil("=", !0);
          return this.skipSpace(), this.skipIfStartsWith("=") || this.throwError("Missing equals sign before attribute value"), [c, this.quotedString()];
        }, l.prototype.quotedString = function() {
          this.skipSpace();
          var c = this.take(1);
          l.isQuote(c) || this.throwError("Missing start quote character before quoted value");
          var u = this.takeUntil(c);
          return this.skipIfStartsWith(c) || this.throwError("Missing end quote character after quoted value"), u;
        }, l.prototype.eof = function() {
          return this._index >= this._length;
        }, l.prototype.skipIfStartsWith = function(c) {
          var u = c.length;
          if (u === 1) return this._str[this._index] === c && (this._index++, !0);
          for (var d = 0; d < u; d++) if (this._str[this._index + d] !== c[d]) return !1;
          return this._index += u, !0;
        }, l.prototype.seek = function(c) {
          this._index += c, this._index < 0 && (this._index = 0), this._index > this._length && (this._index = this._length);
        }, l.prototype.skipSpace = function() {
          for (; !this.eof() && l.isSpace(this._str[this._index]); ) this._index++;
        }, l.prototype.take = function(c) {
          if (c === 1) return this._str[this._index++];
          var u = this._index;
          return this.seek(c), this._str.slice(u, this._index);
        }, l.prototype.takeUntil = function(c, u) {
          u === void 0 && (u = !1);
          for (var d = this._index; this._index < this._length; ) {
            var h = this._str[this._index];
            if (h === c || u && l.isSpace(h)) break;
            this._index++;
          }
          return this._str.slice(d, this._index);
        }, l.prototype.takeUntil2 = function(c, u, d) {
          d === void 0 && (d = !1);
          for (var h = this._index; this._index < this._length; ) {
            var p = this._str[this._index];
            if (p === c || p === u || d && l.isSpace(p)) break;
            this._index++;
          }
          return this._str.slice(h, this._index);
        }, l.prototype.takeUntilStartsWith = function(c, u) {
          u === void 0 && (u = !1);
          for (var d = this._index, h = c.length; this._index < this._length; ) {
            for (var p = !0, m = 0; m < h; m++) {
              var b = this._str[this._index + m], y = c[m];
              if (u && l.isSpace(b)) return this._str.slice(d, this._index);
              if (b !== y) {
                this._index++, p = !1;
                break;
              }
            }
            if (p) return this._str.slice(d, this._index);
          }
          return this._index = this._length, this._str.slice(d);
        }, l.prototype.skipUntil = function(c) {
          for (; this._index < this._length && this._str[this._index] !== c; )
            this._index++;
        }, l.isWhiteSpaceToken = function(c) {
          for (var u = c.data, d = 0; d < u.length; d++) {
            var h = u[d];
            if (h !== " " && h !== `
` && h !== "\r" && h !== "	" && h !== "\f") return !1;
          }
          return !0;
        }, l.isSpace = function(c) {
          return c === " " || c === `
` || c === "\r" || c === "	";
        }, l.isQuote = function(c) {
          return c === '"' || c === "'";
        }, l.prototype.throwError = function(c) {
          for (var u = /\r\n|\r|\n/g, d = null, h = 0, p = 0, m = this._str.length; (d = u.exec(this._str)) !== null && d !== null; ) if (h++, d.index < this._index && (p = u.lastIndex), d.index > this._index) {
            m = d.index;
            break;
          }
          throw this.err = { line: h, col: this._index - p, index: this._index, str: this._str.substring(p, m) }, new Error(c + `
Index: ` + this.err.index + `
Ln: ` + this.err.line + ", Col: " + this.err.col + `
Input: ` + this.err.str);
        }, l.prototype[Symbol.iterator] = function() {
          return this._index = 0, { next: (function() {
            var c = this.nextToken();
            return c.type === a.TokenType.EOF ? { done: !0, value: null } : { done: !1, value: c };
          }).bind(this) };
        }, l;
      })();
      n.XMLStringLexer = o;
    }, function(e, n, s) {
      var r = s(39);
      e.exports = new r({ include: [s(182)] });
    }, function(e, n, s) {
      var r = s(39);
      e.exports = new r({ include: [s(113)], implicit: [s(289), s(290), s(291), s(292)] });
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(91), a = s(1), o = s(3), l = s(77), c = s(109);
      function u(m, b) {
        var y = h(m === void 0 || d(m) ? m : r.DefaultBuilderOptions), Z = d(m) ? b : m, g = c.createDocument();
        p(g, y);
        var f = new l.XMLBuilderImpl(g);
        return Z !== void 0 && f.ele(Z), f;
      }
      function d(m) {
        if (!a.isPlainObject(m)) return !1;
        for (var b in m) if (m.hasOwnProperty(b) && !r.XMLBuilderOptionKeys.has(b)) return !1;
        return !0;
      }
      function h(m) {
        m === void 0 && (m = {});
        var b = a.applyDefaults(m, r.DefaultBuilderOptions);
        if (b.convert.att.length === 0 || b.convert.ins.length === 0 || b.convert.text.length === 0 || b.convert.cdata.length === 0 || b.convert.comment.length === 0) throw new Error("JS object converter strings cannot be zero length.");
        return b;
      }
      function p(m, b, y) {
        var Z = m;
        Z._xmlBuilderOptions = b, Z._isFragment = y;
      }
      n.builder = function(m, b) {
        var y = h(d(m) ? m : r.DefaultBuilderOptions), Z = o.Guard.isNode(m) || a.isArray(m) ? m : b;
        if (Z === void 0) throw new Error("Invalid arguments.");
        if (a.isArray(Z)) {
          for (var g = [], f = 0; f < Z.length; f++) {
            var T = new l.XMLBuilderImpl(Z[f]);
            T.set(y), g.push(T);
          }
          return g;
        }
        var M = new l.XMLBuilderImpl(Z);
        return M.set(y), M;
      }, n.create = u, n.fragment = function(m, b) {
        var y = h(m === void 0 || d(m) ? m : r.DefaultBuilderOptions), Z = d(m) ? b : m, g = c.createDocument();
        p(g, y, !0);
        var f = new l.XMLBuilderImpl(g.createDocumentFragment());
        return Z !== void 0 && f.ele(Z), f;
      }, n.convert = function(m, b, y) {
        var Z, g, f;
        return d(m) && b !== void 0 ? (Z = m, g = b, f = y) : (Z = r.DefaultBuilderOptions, g = m, f = b || void 0), u(Z, g).end(f);
      };
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(77);
      n.builder = r.builder, n.create = r.create, n.fragment = r.fragment, n.convert = r.convert, n.createCB = r.createCB, n.fragmentCB = r.fragmentCB;
    }, function(e, n, s) {
      s(31), s(32), s(33), s(191), s(192), s(194), s(64), s(19), s(198), s(199), s(89), s(201), s(65), s(20), s(66), s(22), s(23);
      var r = this && this.__read || function(Z, g) {
        var f = typeof Symbol == "function" && Z[Symbol.iterator];
        if (!f) return Z;
        var T, M, N = f.call(Z), W = [];
        try {
          for (; (g === void 0 || g-- > 0) && !(T = N.next()).done; ) W.push(T.value);
        } catch (x) {
          M = { error: x };
        } finally {
          try {
            T && !T.done && (f = N.return) && f.call(N);
          } finally {
            if (M) throw M.error;
          }
        }
        return W;
      }, a = this && this.__values || function(Z) {
        var g = typeof Symbol == "function" && Symbol.iterator, f = g && Z[g], T = 0;
        if (f) return f.call(Z);
        if (Z && typeof Z.length == "number") return { next: function() {
          return Z && T >= Z.length && (Z = void 0), { value: Z && Z[T++], done: !Z };
        } };
        throw new TypeError(g ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(91), l = s(1), c = s(217), u = s(2), d = s(3), h = s(0), p = s(109), m = s(7), b = s(276), y = (function() {
        function Z(g) {
          this._domNode = g;
        }
        return Object.defineProperty(Z.prototype, "node", { get: function() {
          return this._domNode;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(Z.prototype, "options", { get: function() {
          return this._options;
        }, enumerable: !0, configurable: !0 }), Z.prototype.set = function(g) {
          return this._options = l.applyDefaults(l.applyDefaults(this._options, g, !0), o.DefaultBuilderOptions), this;
        }, Z.prototype.ele = function(g, f, T) {
          var M, N, W, x, V, X;
          if (l.isObject(g)) return new b.ObjectReader(this._options).parse(this, g);
          if (g !== null && /^\s*</.test(g)) return new b.XMLReader(this._options).parse(this, g);
          if (g !== null && /^\s*[\{\[]/.test(g)) return new b.JSONReader(this._options).parse(this, g);
          if (g !== null && /^(\s*|(#.*)|(%.*))*---/.test(g)) return new b.YAMLReader(this._options).parse(this, g);
          if ((g === null || l.isString(g)) && l.isString(f)) x = (M = r([g, f, T], 3))[0], V = M[1], X = M[2];
          else {
            if (g === null) throw new Error("Element name cannot be null. " + this._debugInfo());
            x = (N = r([void 0, g, l.isObject(f) ? f : void 0], 3))[0], V = N[1], X = N[2];
          }
          if (X && (X = l.getValue(X)), x = (W = r(this._extractNamespace(p.sanitizeInput(x, this._options.invalidCharReplacement), p.sanitizeInput(V, this._options.invalidCharReplacement), !0), 2))[0], V = W[1], x === void 0) {
            var C = r(h.namespace_extractQName(V), 1)[0];
            x = this.node.lookupNamespaceURI(C);
          }
          var R = x != null ? this._doc.createElementNS(x, V) : this._doc.createElement(V);
          this.node.appendChild(R);
          var z = new Z(R), F = this._doc.doctype;
          if (R === this._doc.documentElement && F !== null) {
            var P = this._doc.implementation.createDocumentType(this._doc.documentElement.tagName, F.publicId, F.systemId);
            this._doc.replaceChild(P, F);
          }
          return X && !l.isEmpty(X) && z.att(X), z;
        }, Z.prototype.remove = function() {
          var g = this.up();
          return g.node.removeChild(this.node), g;
        }, Z.prototype.att = function(g, f, T) {
          var M, N, W, x, V, X, C = this;
          if (l.isMap(g) || l.isObject(g)) return l.forEachObject(g, (function(B, $) {
            return C.att(B, $);
          }), this), this;
          if (g != null && (g = l.getValue(g + "")), f != null && (f = l.getValue(f + "")), T != null && (T = l.getValue(T + "")), g !== null && !l.isString(g) || !l.isString(f) || T !== null && !l.isString(T)) {
            if (!l.isString(g) || f != null && !l.isString(f)) throw new Error("Attribute name and value not specified. " + this._debugInfo());
            x = (N = r([void 0, g, f], 3))[0], V = N[1], X = N[2];
          } else x = (M = r([g, f, T], 3))[0], V = M[1], X = M[2];
          if (this._options.keepNullAttributes && X == null) X = "";
          else if (X == null) return this;
          if (!d.Guard.isElementNode(this.node)) throw new Error("An attribute can only be assigned to an element node.");
          var R = this.node;
          x = (W = r(this._extractNamespace(x, V, !1), 2))[0], V = W[1], V = p.sanitizeInput(V, this._options.invalidCharReplacement), x = p.sanitizeInput(x, this._options.invalidCharReplacement), X = p.sanitizeInput(X, this._options.invalidCharReplacement);
          var z = r(h.namespace_extractQName(V), 2), F = z[0], P = z[1], j = r(h.namespace_extractQName(R.prefix ? R.prefix + ":" + R.localName : R.localName), 1)[0], H = null;
          return F === "xmlns" ? (x = m.namespace.XMLNS, R.namespaceURI === null && j === P && (H = X)) : F === null && P === "xmlns" && j === null && (x = m.namespace.XMLNS, H = X), H !== null && (this._updateNamespace(H), R = this.node), x !== void 0 ? R.setAttributeNS(x, V, X) : R.setAttribute(V, X), this;
        }, Z.prototype.removeAtt = function(g, f) {
          var T, M, N = this;
          if (!d.Guard.isElementNode(this.node)) throw new Error("An attribute can only be removed from an element node.");
          if (g = l.getValue(g), f !== void 0 && (f = l.getValue(f)), g !== null && f === void 0) M = g;
          else {
            if (g !== null && !l.isString(g) || f === void 0) throw new Error("Attribute namespace must be a string. " + this._debugInfo());
            T = g, M = f;
          }
          return l.isArray(M) || l.isSet(M) ? l.forEachArray(M, (function(W) {
            return T === void 0 ? N.removeAtt(W) : N.removeAtt(T, W);
          }), this) : T !== void 0 ? (M = p.sanitizeInput(M, this._options.invalidCharReplacement), T = p.sanitizeInput(T, this._options.invalidCharReplacement), this.node.removeAttributeNS(T, M)) : (M = p.sanitizeInput(M, this._options.invalidCharReplacement), this.node.removeAttribute(M)), this;
        }, Z.prototype.txt = function(g) {
          if (g == null) {
            if (!this._options.keepNullNodes) return this;
            g = "";
          }
          var f = this._doc.createTextNode(p.sanitizeInput(g, this._options.invalidCharReplacement));
          return this.node.appendChild(f), this;
        }, Z.prototype.com = function(g) {
          if (g == null) {
            if (!this._options.keepNullNodes) return this;
            g = "";
          }
          var f = this._doc.createComment(p.sanitizeInput(g, this._options.invalidCharReplacement));
          return this.node.appendChild(f), this;
        }, Z.prototype.dat = function(g) {
          if (g == null) {
            if (!this._options.keepNullNodes) return this;
            g = "";
          }
          var f = this._doc.createCDATASection(p.sanitizeInput(g, this._options.invalidCharReplacement));
          return this.node.appendChild(f), this;
        }, Z.prototype.ins = function(g, f) {
          var T = this;
          if (f === void 0 && (f = ""), f == null) {
            if (!this._options.keepNullNodes) return this;
            f = "";
          }
          if (l.isArray(g) || l.isSet(g)) l.forEachArray(g, (function(N) {
            var W = (N += "").indexOf(" "), x = W === -1 ? N : N.substr(0, W), V = W === -1 ? "" : N.substr(W + 1);
            T.ins(x, V);
          }), this);
          else if (l.isMap(g) || l.isObject(g)) l.forEachObject(g, (function(N, W) {
            return T.ins(N, W);
          }), this);
          else {
            var M = this._doc.createProcessingInstruction(p.sanitizeInput(g, this._options.invalidCharReplacement), p.sanitizeInput(f, this._options.invalidCharReplacement));
            this.node.appendChild(M);
          }
          return this;
        }, Z.prototype.dec = function(g) {
          return this._options.version = g.version || "1.0", this._options.encoding = g.encoding, this._options.standalone = g.standalone, this;
        }, Z.prototype.dtd = function(g) {
          var f = p.sanitizeInput(g && g.name || (this._doc.documentElement ? this._doc.documentElement.tagName : "ROOT"), this._options.invalidCharReplacement), T = p.sanitizeInput(g && g.pubID || "", this._options.invalidCharReplacement), M = p.sanitizeInput(g && g.sysID || "", this._options.invalidCharReplacement);
          if (this._doc.documentElement !== null && f !== this._doc.documentElement.tagName) throw new Error("DocType name does not match document element name.");
          var N = this._doc.implementation.createDocumentType(f, T, M);
          return this._doc.doctype !== null ? this._doc.replaceChild(N, this._doc.doctype) : this._doc.insertBefore(N, this._doc.documentElement), this;
        }, Z.prototype.import = function(g) {
          var f, T, M = this._domNode, N = this._doc, W = g.node;
          if (d.Guard.isDocumentNode(W)) {
            var x = W.documentElement;
            if (x === null) throw new Error("Imported document has no document element node. " + this._debugInfo());
            var V = N.importNode(x, !0);
            M.appendChild(V);
            var X = r(h.namespace_extractQName(V.prefix ? V.prefix + ":" + V.localName : V.localName), 1)[0], C = M.lookupNamespaceURI(X);
            new Z(V)._updateNamespace(C);
          } else if (d.Guard.isDocumentFragmentNode(W)) try {
            for (var R = a(W.childNodes), z = R.next(); !z.done; z = R.next()) {
              var F = z.value;
              V = N.importNode(F, !0), M.appendChild(V), d.Guard.isElementNode(V) && (X = r(h.namespace_extractQName(V.prefix ? V.prefix + ":" + V.localName : V.localName), 1)[0], C = M.lookupNamespaceURI(X), new Z(V)._updateNamespace(C));
            }
          } catch (P) {
            f = { error: P };
          } finally {
            try {
              z && !z.done && (T = R.return) && T.call(R);
            } finally {
              if (f) throw f.error;
            }
          }
          else
            V = N.importNode(W, !0), M.appendChild(V), d.Guard.isElementNode(V) && (X = r(h.namespace_extractQName(V.prefix ? V.prefix + ":" + V.localName : V.localName), 1)[0], C = M.lookupNamespaceURI(X), new Z(V)._updateNamespace(C));
          return this;
        }, Z.prototype.doc = function() {
          if (this._doc._isFragment) {
            for (var g = this.node; g && g.nodeType !== u.NodeType.DocumentFragment; ) g = g.parentNode;
            if (g === null) throw new Error("Node has no parent node while searching for document fragment ancestor. " + this._debugInfo());
            return new Z(g);
          }
          return new Z(this._doc);
        }, Z.prototype.root = function() {
          var g = this._doc.documentElement;
          if (!g) throw new Error("Document root element is null. " + this._debugInfo());
          return new Z(g);
        }, Z.prototype.up = function() {
          var g = this._domNode.parentNode;
          if (!g) throw new Error("Parent node is null. " + this._debugInfo());
          return new Z(g);
        }, Z.prototype.prev = function() {
          var g = this._domNode.previousSibling;
          if (!g) throw new Error("Previous sibling node is null. " + this._debugInfo());
          return new Z(g);
        }, Z.prototype.next = function() {
          var g = this._domNode.nextSibling;
          if (!g) throw new Error("Next sibling node is null. " + this._debugInfo());
          return new Z(g);
        }, Z.prototype.first = function() {
          var g = this._domNode.firstChild;
          if (!g) throw new Error("First child node is null. " + this._debugInfo());
          return new Z(g);
        }, Z.prototype.last = function() {
          var g = this._domNode.lastChild;
          if (!g) throw new Error("Last child node is null. " + this._debugInfo());
          return new Z(g);
        }, Z.prototype.each = function(g, f, T, M) {
          f === void 0 && (f = !1), T === void 0 && (T = !1);
          for (var N = this._getFirstDescendantNode(this._domNode, f, T); N[0]; ) {
            var W = this._getNextDescendantNode(this._domNode, N[0], T, N[1], N[2]);
            g.call(M, new Z(N[0]), N[1], N[2]), N = W;
          }
          return this;
        }, Z.prototype.map = function(g, f, T, M) {
          f === void 0 && (f = !1), T === void 0 && (T = !1);
          var N = [];
          return this.each((function(W, x, V) {
            return N.push(g.call(M, W, x, V));
          }), f, T), N;
        }, Z.prototype.reduce = function(g, f, T, M, N) {
          T === void 0 && (T = !1), M === void 0 && (M = !1);
          var W = f;
          return this.each((function(x, V, X) {
            return W = g.call(N, W, x, V, X);
          }), T, M), W;
        }, Z.prototype.find = function(g, f, T, M) {
          f === void 0 && (f = !1), T === void 0 && (T = !1);
          for (var N = this._getFirstDescendantNode(this._domNode, f, T); N[0]; ) {
            var W = new Z(N[0]);
            if (g.call(M, W, N[1], N[2])) return W;
            N = this._getNextDescendantNode(this._domNode, N[0], T, N[1], N[2]);
          }
        }, Z.prototype.filter = function(g, f, T, M) {
          f === void 0 && (f = !1), T === void 0 && (T = !1);
          var N = [];
          return this.each((function(W, x, V) {
            g.call(M, W, x, V) && N.push(W);
          }), f, T), N;
        }, Z.prototype.every = function(g, f, T, M) {
          f === void 0 && (f = !1), T === void 0 && (T = !1);
          for (var N = this._getFirstDescendantNode(this._domNode, f, T); N[0]; ) {
            var W = new Z(N[0]);
            if (!g.call(M, W, N[1], N[2])) return !1;
            N = this._getNextDescendantNode(this._domNode, N[0], T, N[1], N[2]);
          }
          return !0;
        }, Z.prototype.some = function(g, f, T, M) {
          f === void 0 && (f = !1), T === void 0 && (T = !1);
          for (var N = this._getFirstDescendantNode(this._domNode, f, T); N[0]; ) {
            var W = new Z(N[0]);
            if (g.call(M, W, N[1], N[2])) return !0;
            N = this._getNextDescendantNode(this._domNode, N[0], T, N[1], N[2]);
          }
          return !1;
        }, Z.prototype.toArray = function(g, f) {
          g === void 0 && (g = !1), f === void 0 && (f = !1);
          var T = [];
          return this.each((function(M) {
            return T.push(M);
          }), g, f), T;
        }, Z.prototype.toString = function(g) {
          return (g = g || {}).format === void 0 && (g.format = "xml"), this._serialize(g);
        }, Z.prototype.toObject = function(g) {
          return (g = g || {}).format === void 0 && (g.format = "object"), this._serialize(g);
        }, Z.prototype.end = function(g) {
          return (g = g || {}).format === void 0 && (g.format = "xml"), this.doc()._serialize(g);
        }, Z.prototype._getFirstDescendantNode = function(g, f, T) {
          return f ? [this._domNode, 0, 0] : T ? this._getNextDescendantNode(g, g, T, 0, 0) : [this._domNode.firstChild, 0, 1];
        }, Z.prototype._getNextDescendantNode = function(g, f, T, M, N) {
          if (!T) return g === f ? [f.firstChild, 0, N + 1] : [f.nextSibling, M + 1, N];
          if (f.firstChild) return [f.firstChild, 0, N + 1];
          if (f === g) return [null, -1, -1];
          if (f.nextSibling) return [f.nextSibling, M + 1, N];
          for (var W = f.parentNode; W && W !== g; ) {
            if (W.nextSibling) return [W.nextSibling, h.tree_index(W.nextSibling), N - 1];
            W = W.parentNode, N--;
          }
          return [null, -1, -1];
        }, Z.prototype._serialize = function(g) {
          if (g.format === "xml") return new c.XMLWriter(this._options, g).serialize(this.node);
          if (g.format === "map") return new c.MapWriter(this._options, g).serialize(this.node);
          if (g.format === "object") return new c.ObjectWriter(this._options, g).serialize(this.node);
          if (g.format === "json") return new c.JSONWriter(this._options, g).serialize(this.node);
          if (g.format === "yaml") return new c.YAMLWriter(this._options, g).serialize(this.node);
          throw new Error("Invalid writer format: " + g.format + ". " + this._debugInfo());
        }, Z.prototype._extractNamespace = function(g, f, T) {
          var M = f.indexOf("@");
          if (M > 0 && (g === void 0 && (g = f.slice(M + 1)), f = f.slice(0, M)), g === void 0) g = T ? this._options.defaultNamespace.ele : this._options.defaultNamespace.att;
          else if (g !== null && g[0] === "@") {
            var N = g.slice(1);
            if ((g = this._options.namespaceAlias[N]) === void 0) throw new Error("Namespace alias `" + N + "` is not defined. " + this._debugInfo());
          }
          return [g, f];
        }, Z.prototype._updateNamespace = function(g) {
          var f, T, M, N, W = this._domNode;
          if (d.Guard.isElementNode(W) && g !== null && W.namespaceURI !== g) {
            var x = r(h.namespace_extractQName(W.prefix ? W.prefix + ":" + W.localName : W.localName), 2), V = x[0], X = x[1], C = h.create_element(this._doc, X, g, V);
            try {
              for (var R = a(W.attributes), z = R.next(); !z.done; z = R.next()) {
                var F = z.value, P = F.prefix ? F.prefix + ":" + F.localName : F.localName, j = r(h.namespace_extractQName(P), 1)[0], H = F.namespaceURI;
                H === null && j !== null && (H = W.lookupNamespaceURI(j)), H === null ? C.setAttribute(P, F.value) : C.setAttributeNS(H, P, F.value);
              }
            } catch (dt) {
              f = { error: dt };
            } finally {
              try {
                z && !z.done && (T = R.return) && T.call(R);
              } finally {
                if (f) throw f.error;
              }
            }
            var B = W.parentNode;
            if (B === null) throw new Error("Parent node is null." + this._debugInfo());
            B.replaceChild(C, W), this._domNode = C;
            try {
              for (var $ = a(W.childNodes), A = $.next(); !A.done; A = $.next()) {
                var E = A.value.cloneNode(!0);
                if (C.appendChild(E), d.Guard.isElementNode(E)) {
                  var ct = r(h.namespace_extractQName(E.prefix ? E.prefix + ":" + E.localName : E.localName), 1)[0], at = C.lookupNamespaceURI(ct);
                  new Z(E)._updateNamespace(at);
                }
              }
            } catch (dt) {
              M = { error: dt };
            } finally {
              try {
                A && !A.done && (N = $.return) && N.call($);
              } finally {
                if (M) throw M.error;
              }
            }
          }
        }, Object.defineProperty(Z.prototype, "_doc", { get: function() {
          var g = this.node;
          if (d.Guard.isDocumentNode(g)) return g;
          var f = g.ownerDocument;
          if (!f) throw new Error("Owner document is null. " + this._debugInfo());
          return f;
        }, enumerable: !0, configurable: !0 }), Z.prototype._debugInfo = function(g) {
          var f = this.node, T = f.parentNode;
          g = g || f.nodeName;
          var M = T ? T.nodeName : "";
          return M ? "node: <" + g + ">, parent: <" + M + ">" : "node: <" + g + ">";
        }, Object.defineProperty(Z.prototype, "_options", { get: function() {
          var g = this._doc;
          if (g._xmlBuilderOptions === void 0) throw new Error("Builder options is not set.");
          return g._xmlBuilderOptions;
        }, set: function(g) {
          this._doc._xmlBuilderOptions = g;
        }, enumerable: !0, configurable: !0 }), Z;
      })();
      n.XMLBuilderImpl = y;
    }, function(e, n, s) {
      var r = s(11), a = s(117), o = r.WeakMap;
      e.exports = typeof o == "function" && /native code/.test(a(o));
    }, function(e, n, s) {
      var r = s(46), a = s(82), o = s(85), l = s(18);
      e.exports = r("Reflect", "ownKeys") || function(c) {
        var u = a.f(l(c)), d = o.f;
        return d ? u.concat(d(c)) : u;
      };
    }, function(e, n, s) {
      var r = s(16), a = s(15), o = s(18), l = s(61);
      e.exports = r ? Object.defineProperties : function(c, u) {
        o(c);
        for (var d, h = l(u), p = h.length, m = 0; p > m; ) a.f(c, d = h[m++], u[d]);
        return c;
      };
    }, function(e, n, s) {
      var r = s(46);
      e.exports = r("document", "documentElement");
    }, function(e, n, s) {
      var r = s(24), a = s(82).f, o = {}.toString, l = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
      e.exports.f = function(c) {
        return l && o.call(c) == "[object Window]" ? (function(u) {
          try {
            return a(u);
          } catch {
            return l.slice();
          }
        })(c) : a(r(c));
      };
    }, function(e, n, s) {
      var r = s(4), a = s(36).every, o = s(48), l = s(28), c = o("every"), u = l("every");
      r({ target: "Array", proto: !0, forced: !c || !u }, { every: function(d) {
        return a(this, d, arguments.length > 1 ? arguments[1] : void 0);
      } });
    }, function(e, n, s) {
      var r = s(4), a = s(36).filter, o = s(63), l = s(28), c = o("filter"), u = l("filter");
      r({ target: "Array", proto: !0, forced: !c || !u }, { filter: function(d) {
        return a(this, d, arguments.length > 1 ? arguments[1] : void 0);
      } });
    }, function(e, n, s) {
      var r = s(46);
      e.exports = r("navigator", "userAgent") || "";
    }, function(e, n, s) {
      var r = s(4), a = s(36).find, o = s(130), l = s(28), c = !0, u = l("find");
      "find" in [] && Array(1).find((function() {
        c = !1;
      })), r({ target: "Array", proto: !0, forced: c || !u }, { find: function(d) {
        return a(this, d, arguments.length > 1 ? arguments[1] : void 0);
      } }), o("find");
    }, function(e, n, s) {
      var r = s(131).IteratorPrototype, a = s(60), o = s(40), l = s(62), c = s(49), u = function() {
        return this;
      };
      e.exports = function(d, h, p) {
        var m = h + " Iterator";
        return d.prototype = a(r, { next: o(1, p) }), l(d, m, !1, !0), c[m] = u, d;
      };
    }, function(e, n, s) {
      var r = s(8);
      e.exports = !r((function() {
        function a() {
        }
        return a.prototype.constructor = null, Object.getPrototypeOf(new a()) !== a.prototype;
      }));
    }, function(e, n, s) {
      var r = s(13);
      e.exports = function(a) {
        if (!r(a) && a !== null) throw TypeError("Can't set " + String(a) + " as a prototype");
        return a;
      };
    }, function(e, n, s) {
      var r = s(4), a = s(36).map, o = s(63), l = s(28), c = o("map"), u = l("map");
      r({ target: "Array", proto: !0, forced: !c || !u }, { map: function(d) {
        return a(this, d, arguments.length > 1 ? arguments[1] : void 0);
      } });
    }, function(e, n, s) {
      var r = s(4), a = s(200).left, o = s(48), l = s(28), c = o("reduce"), u = l("reduce", { 1: 0 });
      r({ target: "Array", proto: !0, forced: !c || !u }, { reduce: function(d) {
        return a(this, d, arguments.length, arguments.length > 1 ? arguments[1] : void 0);
      } });
    }, function(e, n, s) {
      var r = s(127), a = s(27), o = s(41), l = s(26), c = function(u) {
        return function(d, h, p, m) {
          r(h);
          var b = a(d), y = o(b), Z = l(b.length), g = u ? Z - 1 : 0, f = u ? -1 : 1;
          if (p < 2) for (; ; ) {
            if (g in y) {
              m = y[g], g += f;
              break;
            }
            if (g += f, u ? g < 0 : Z <= g) throw TypeError("Reduce of empty array with no initial value");
          }
          for (; u ? g >= 0 : Z > g; g += f) g in y && (m = h(m, y[g], g, b));
          return m;
        };
      };
      e.exports = { left: c(!1), right: c(!0) };
    }, function(e, n, s) {
      var r = s(4), a = s(36).some, o = s(48), l = s(28), c = o("some"), u = l("some");
      r({ target: "Array", proto: !0, forced: !c || !u }, { some: function(d) {
        return a(this, d, arguments.length > 1 ? arguments[1] : void 0);
      } });
    }, function(e, n, s) {
      var r = s(90), a = s(135);
      e.exports = r ? {}.toString : function() {
        return "[object " + a(this) + "]";
      };
    }, function(e, n) {
      e.exports = { CSSRuleList: 0, CSSStyleDeclaration: 0, CSSValueList: 0, ClientRectList: 0, DOMRectList: 0, DOMStringList: 0, DOMTokenList: 1, DataTransferItemList: 0, FileList: 0, HTMLAllCollection: 0, HTMLCollection: 0, HTMLFormElement: 0, HTMLSelectElement: 0, MediaList: 0, MimeTypeArray: 0, NamedNodeMap: 0, NodeList: 1, PaintRequestList: 0, Plugin: 0, PluginArray: 0, SVGLengthList: 0, SVGNumberList: 0, SVGPathSegList: 0, SVGPointList: 0, SVGStringList: 0, SVGTransformList: 0, SourceBufferList: 0, StyleSheetList: 0, TextTrackCueList: 0, TextTrackList: 0, TouchList: 0 };
    }, function(e, n, s) {
      var r = s(8);
      e.exports = !r((function() {
        return Object.isExtensible(Object.preventExtensions({}));
      }));
    }, function(e, n, s) {
      var r = s(5), a = s(49), o = r("iterator"), l = Array.prototype;
      e.exports = function(c) {
        return c !== void 0 && (a.Array === c || l[o] === c);
      };
    }, function(e, n, s) {
      var r = s(135), a = s(49), o = s(5)("iterator");
      e.exports = function(l) {
        if (l != null) return l[o] || l["@@iterator"] || a[r(l)];
      };
    }, function(e, n, s) {
      var r = s(18);
      e.exports = function(a, o, l, c) {
        try {
          return c ? o(r(l)[0], l[1]) : o(l);
        } catch (d) {
          var u = a.return;
          throw u !== void 0 && r(u.call(a)), d;
        }
      };
    }, function(e, n, s) {
      var r = s(5)("iterator"), a = !1;
      try {
        var o = 0, l = { next: function() {
          return { done: !!o++ };
        }, return: function() {
          a = !0;
        } };
        l[r] = function() {
          return this;
        }, Array.from(l, (function() {
          throw 2;
        }));
      } catch {
      }
      e.exports = function(c, u) {
        if (!u && !a) return !1;
        var d = !1;
        try {
          var h = {};
          h[r] = function() {
            return { next: function() {
              return { done: d = !0 };
            } };
          }, c(h);
        } catch {
        }
        return d;
      };
    }, function(e, n, s) {
      var r = s(13), a = s(133);
      e.exports = function(o, l, c) {
        var u, d;
        return a && typeof (u = l.constructor) == "function" && u !== c && r(d = u.prototype) && d !== c.prototype && a(o, d), o;
      };
    }, function(e, n, s) {
      var r = s(25);
      e.exports = function(a, o, l) {
        for (var c in o) r(a, c, o[c], l);
        return a;
      };
    }, function(e, n, s) {
      var r = s(46), a = s(15), o = s(5), l = s(16), c = o("species");
      e.exports = function(u) {
        var d = r(u), h = a.f;
        l && d && !d[c] && h(d, c, { configurable: !0, get: function() {
          return this;
        } });
      };
    }, function(e, n, s) {
      var r = this && this.__generator || function(l, c) {
        var u, d, h, p, m = { label: 0, sent: function() {
          if (1 & h[0]) throw h[1];
          return h[1];
        }, trys: [], ops: [] };
        return p = { next: b(0), throw: b(1), return: b(2) }, typeof Symbol == "function" && (p[Symbol.iterator] = function() {
          return this;
        }), p;
        function b(y) {
          return function(Z) {
            return (function(g) {
              if (u) throw new TypeError("Generator is already executing.");
              for (; m; ) try {
                if (u = 1, d && (h = 2 & g[0] ? d.return : g[0] ? d.throw || ((h = d.return) && h.call(d), 0) : d.next) && !(h = h.call(d, g[1])).done) return h;
                switch (d = 0, h && (g = [2 & g[0], h.value]), g[0]) {
                  case 0:
                  case 1:
                    h = g;
                    break;
                  case 4:
                    return m.label++, { value: g[1], done: !1 };
                  case 5:
                    m.label++, d = g[1], g = [0];
                    continue;
                  case 7:
                    g = m.ops.pop(), m.trys.pop();
                    continue;
                  default:
                    if (h = m.trys, !((h = h.length > 0 && h[h.length - 1]) || g[0] !== 6 && g[0] !== 2)) {
                      m = 0;
                      continue;
                    }
                    if (g[0] === 3 && (!h || g[1] > h[0] && g[1] < h[3])) {
                      m.label = g[1];
                      break;
                    }
                    if (g[0] === 6 && m.label < h[1]) {
                      m.label = h[1], h = g;
                      break;
                    }
                    if (h && m.label < h[2]) {
                      m.label = h[2], m.ops.push(g);
                      break;
                    }
                    h[2] && m.ops.pop(), m.trys.pop();
                    continue;
                }
                g = c.call(l, m);
              } catch (f) {
                g = [6, f], d = 0;
              } finally {
                u = h = 0;
              }
              if (5 & g[0]) throw g[1];
              return { value: g[0] ? g[1] : void 0, done: !0 };
            })([y, Z]);
          };
        }
      }, a = this && this.__values || function(l) {
        var c = typeof Symbol == "function" && Symbol.iterator, u = c && l[c], d = 0;
        if (u) return u.call(l);
        if (l && typeof l.length == "number") return { next: function() {
          return l && d >= l.length && (l = void 0), { value: l && l[d++], done: !l };
        } };
        throw new TypeError(c ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = (function() {
        function l(c) {
          c === void 0 && (c = 1e3), this._items = /* @__PURE__ */ new Set(), this._limit = c;
        }
        return l.prototype.add = function(c) {
          if (this._items.add(c), this._items.size > this._limit) {
            var u = this._items.values().next();
            u.done || this._items.delete(u.value);
          }
          return this;
        }, l.prototype.delete = function(c) {
          return this._items.delete(c);
        }, l.prototype.has = function(c) {
          return this._items.has(c);
        }, l.prototype.clear = function() {
          this._items.clear();
        }, Object.defineProperty(l.prototype, "size", { get: function() {
          return this._items.size;
        }, enumerable: !0, configurable: !0 }), l.prototype.forEach = function(c, u) {
          var d = this;
          this._items.forEach((function(h) {
            return c.call(u, h, h, d);
          }));
        }, l.prototype.keys = function() {
          return r(this, (function(c) {
            switch (c.label) {
              case 0:
                return [5, a(this._items.keys())];
              case 1:
                return c.sent(), [2];
            }
          }));
        }, l.prototype.values = function() {
          return r(this, (function(c) {
            switch (c.label) {
              case 0:
                return [5, a(this._items.values())];
              case 1:
                return c.sent(), [2];
            }
          }));
        }, l.prototype.entries = function() {
          return r(this, (function(c) {
            switch (c.label) {
              case 0:
                return [5, a(this._items.entries())];
              case 1:
                return c.sent(), [2];
            }
          }));
        }, l.prototype[Symbol.iterator] = function() {
          return r(this, (function(c) {
            switch (c.label) {
              case 0:
                return [5, a(this._items)];
              case 1:
                return c.sent(), [2];
            }
          }));
        }, Object.defineProperty(l.prototype, Symbol.toStringTag, { get: function() {
          return "FixedSizeSet";
        }, enumerable: !0, configurable: !0 }), l;
      })();
      n.FixedSizeSet = o;
    }, function(e, n, s) {
      var r = this && this.__generator || function(l, c) {
        var u, d, h, p, m = { label: 0, sent: function() {
          if (1 & h[0]) throw h[1];
          return h[1];
        }, trys: [], ops: [] };
        return p = { next: b(0), throw: b(1), return: b(2) }, typeof Symbol == "function" && (p[Symbol.iterator] = function() {
          return this;
        }), p;
        function b(y) {
          return function(Z) {
            return (function(g) {
              if (u) throw new TypeError("Generator is already executing.");
              for (; m; ) try {
                if (u = 1, d && (h = 2 & g[0] ? d.return : g[0] ? d.throw || ((h = d.return) && h.call(d), 0) : d.next) && !(h = h.call(d, g[1])).done) return h;
                switch (d = 0, h && (g = [2 & g[0], h.value]), g[0]) {
                  case 0:
                  case 1:
                    h = g;
                    break;
                  case 4:
                    return m.label++, { value: g[1], done: !1 };
                  case 5:
                    m.label++, d = g[1], g = [0];
                    continue;
                  case 7:
                    g = m.ops.pop(), m.trys.pop();
                    continue;
                  default:
                    if (h = m.trys, !((h = h.length > 0 && h[h.length - 1]) || g[0] !== 6 && g[0] !== 2)) {
                      m = 0;
                      continue;
                    }
                    if (g[0] === 3 && (!h || g[1] > h[0] && g[1] < h[3])) {
                      m.label = g[1];
                      break;
                    }
                    if (g[0] === 6 && m.label < h[1]) {
                      m.label = h[1], h = g;
                      break;
                    }
                    if (h && m.label < h[2]) {
                      m.label = h[2], m.ops.push(g);
                      break;
                    }
                    h[2] && m.ops.pop(), m.trys.pop();
                    continue;
                }
                g = c.call(l, m);
              } catch (f) {
                g = [6, f], d = 0;
              } finally {
                u = h = 0;
              }
              if (5 & g[0]) throw g[1];
              return { value: g[0] ? g[1] : void 0, done: !0 };
            })([y, Z]);
          };
        }
      }, a = this && this.__values || function(l) {
        var c = typeof Symbol == "function" && Symbol.iterator, u = c && l[c], d = 0;
        if (u) return u.call(l);
        if (l && typeof l.length == "number") return { next: function() {
          return l && d >= l.length && (l = void 0), { value: l && l[d++], done: !l };
        } };
        throw new TypeError(c ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = (function() {
        function l(c) {
          c === void 0 && (c = 1e3), this._items = /* @__PURE__ */ new Map(), this._limit = c;
        }
        return l.prototype.get = function(c) {
          return this._items.get(c);
        }, l.prototype.set = function(c, u) {
          if (this._items.set(c, u), this._items.size > this._limit) {
            var d = this._items.keys().next();
            d.done || this._items.delete(d.value);
          }
        }, l.prototype.delete = function(c) {
          return this._items.delete(c);
        }, l.prototype.has = function(c) {
          return this._items.has(c);
        }, l.prototype.clear = function() {
          this._items.clear();
        }, Object.defineProperty(l.prototype, "size", { get: function() {
          return this._items.size;
        }, enumerable: !0, configurable: !0 }), l.prototype.forEach = function(c, u) {
          this._items.forEach((function(d, h) {
            return c.call(u, h, d);
          }));
        }, l.prototype.keys = function() {
          return r(this, (function(c) {
            switch (c.label) {
              case 0:
                return [5, a(this._items.keys())];
              case 1:
                return c.sent(), [2];
            }
          }));
        }, l.prototype.values = function() {
          return r(this, (function(c) {
            switch (c.label) {
              case 0:
                return [5, a(this._items.values())];
              case 1:
                return c.sent(), [2];
            }
          }));
        }, l.prototype.entries = function() {
          return r(this, (function(c) {
            switch (c.label) {
              case 0:
                return [5, a(this._items.entries())];
              case 1:
                return c.sent(), [2];
            }
          }));
        }, l.prototype[Symbol.iterator] = function() {
          return r(this, (function(c) {
            switch (c.label) {
              case 0:
                return [5, a(this._items)];
              case 1:
                return c.sent(), [2];
            }
          }));
        }, Object.defineProperty(l.prototype, Symbol.toStringTag, { get: function() {
          return "ObjectCache";
        }, enumerable: !0, configurable: !0 }), l;
      })();
      n.ObjectCache = o;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = (function() {
        function a(o) {
          o === void 0 && (o = 1e3), this._items = /* @__PURE__ */ new Map(), this._limit = o;
        }
        return a.prototype.check = function(o, l) {
          if (this._items.get(o) === l) return !0;
          if (this._items.get(l) === o) return !1;
          var c = Math.random() < 0.5;
          if (c ? this._items.set(o, l) : this._items.set(l, o), this._items.size > this._limit) {
            var u = this._items.keys().next();
            u.done || this._items.delete(u.value);
          }
          return c;
        }, a;
      })();
      n.CompareCache = r;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = (function() {
        function a(o) {
          this._initialized = !1, this._value = void 0, this._initFunc = o;
        }
        return Object.defineProperty(a.prototype, "value", { get: function() {
          return this._initialized || (this._value = this._initFunc(), this._initialized = !0), this._value;
        }, enumerable: !0, configurable: !0 }), a;
      })();
      n.Lazy = r;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = (function() {
        function a(o) {
          this._pointer = 0, this._chars = Array.from(o), this._length = this._chars.length;
        }
        return Object.defineProperty(a.prototype, "eof", { get: function() {
          return this._pointer >= this._length;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(a.prototype, "length", { get: function() {
          return this._length;
        }, enumerable: !0, configurable: !0 }), a.prototype.codePoint = function() {
          if (this._codePoint === void 0) if (this.eof) this._codePoint = -1;
          else {
            var o = this._chars[this._pointer].codePointAt(0);
            this._codePoint = o !== void 0 ? o : -1;
          }
          return this._codePoint;
        }, a.prototype.c = function() {
          return this._c === void 0 && (this._c = this.eof ? "" : this._chars[this._pointer]), this._c;
        }, a.prototype.remaining = function() {
          return this._remaining === void 0 && (this._remaining = this.eof ? "" : this._chars.slice(this._pointer + 1).join("")), this._remaining;
        }, a.prototype.substring = function() {
          return this._substring === void 0 && (this._substring = this.eof ? "" : this._chars.slice(this._pointer).join("")), this._substring;
        }, Object.defineProperty(a.prototype, "pointer", { get: function() {
          return this._pointer;
        }, set: function(o) {
          o !== this._pointer && (this._pointer = o, this._codePoint = void 0, this._c = void 0, this._remaining = void 0, this._substring = void 0);
        }, enumerable: !0, configurable: !0 }), a;
      })();
      n.StringWalker = r;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(218);
      n.MapWriter = r.MapWriter;
      var a = s(258);
      n.XMLWriter = a.XMLWriter;
      var o = s(67);
      n.ObjectWriter = o.ObjectWriter;
      var l = s(260);
      n.JSONWriter = l.JSONWriter;
      var c = s(261);
      n.YAMLWriter = c.YAMLWriter;
    }, function(e, n, s) {
      s(19), s(219), s(20), s(22), s(23);
      var r, a = this && this.__extends || (r = function(u, d) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(h, p) {
          h.__proto__ = p;
        } || function(h, p) {
          for (var m in p) p.hasOwnProperty(m) && (h[m] = p[m]);
        })(u, d);
      }, function(u, d) {
        function h() {
          this.constructor = u;
        }
        r(u, d), u.prototype = d === null ? Object.create(d) : (h.prototype = d.prototype, new h());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(1), l = s(67), c = (function(u) {
        function d(h, p) {
          var m = u.call(this, h) || this;
          return m._writerOptions = o.applyDefaults(p, { format: "map", wellFormed: !1, group: !1, verbose: !1 }), m;
        }
        return a(d, u), d.prototype.serialize = function(h) {
          var p = o.applyDefaults(this._writerOptions, { format: "object", wellFormed: !1, verbose: !1 }), m = new l.ObjectWriter(this._builderOptions, p).serialize(h);
          return this._convertObject(m);
        }, d.prototype._convertObject = function(h) {
          if (o.isArray(h)) {
            for (var p = 0; p < h.length; p++) h[p] = this._convertObject(h[p]);
            return h;
          }
          if (o.isObject(h)) {
            var m = /* @__PURE__ */ new Map();
            for (var b in h) m.set(b, this._convertObject(h[b]));
            return m;
          }
          return h;
        }, d;
      })(s(50).BaseWriter);
      n.MapWriter = c;
    }, function(e, n, s) {
      var r = s(139), a = s(143);
      e.exports = r("Map", (function(o) {
        return function() {
          return o(this, arguments.length ? arguments[0] : void 0);
        };
      }), a);
    }, function(e, n, s) {
      var r = s(4), a = s(8), o = s(59), l = s(13), c = s(27), u = s(26), d = s(134), h = s(128), p = s(63), m = s(5), b = s(129), y = m("isConcatSpreadable"), Z = b >= 51 || !a((function() {
        var T = [];
        return T[y] = !1, T.concat()[0] !== T;
      })), g = p("concat"), f = function(T) {
        if (!l(T)) return !1;
        var M = T[y];
        return M !== void 0 ? !!M : o(T);
      };
      r({ target: "Array", proto: !0, forced: !Z || !g }, { concat: function(T) {
        var M, N, W, x, V, X = c(this), C = h(X, 0), R = 0;
        for (M = -1, W = arguments.length; M < W; M++) if (f(V = M === -1 ? X : arguments[M])) {
          if (R + (x = u(V.length)) > 9007199254740991) throw TypeError("Maximum allowed index exceeded");
          for (N = 0; N < x; N++, R++) N in V && d(C, R, V[N]);
        } else {
          if (R >= 9007199254740991) throw TypeError("Maximum allowed index exceeded");
          d(C, R++, V);
        }
        return C.length = R, C;
      } });
    }, function(e, n, s) {
      var r = s(8);
      function a(o, l) {
        return RegExp(o, l);
      }
      n.UNSUPPORTED_Y = r((function() {
        var o = a("a", "y");
        return o.lastIndex = 2, o.exec("abcd") != null;
      })), n.BROKEN_CARET = r((function() {
        var o = a("^r", "gy");
        return o.lastIndex = 2, o.exec("str") != null;
      }));
    }, function(e, n, s) {
      var r = s(223);
      e.exports = function(a) {
        if (r(a)) throw TypeError("The method doesn't accept regular expressions");
        return a;
      };
    }, function(e, n, s) {
      var r = s(13), a = s(42), o = s(5)("match");
      e.exports = function(l) {
        var c;
        return r(l) && ((c = l[o]) !== void 0 ? !!c : a(l) == "RegExp");
      };
    }, function(e, n, s) {
      var r = s(5)("match");
      e.exports = function(a) {
        var o = /./;
        try {
          "/./"[a](o);
        } catch {
          try {
            return o[r] = !1, "/./"[a](o);
          } catch {
          }
        }
        return !1;
      };
    }, function(e, n, s) {
      s(68);
      var r = s(25), a = s(8), o = s(5), l = s(93), c = s(21), u = o("species"), d = !a((function() {
        var y = /./;
        return y.exec = function() {
          var Z = [];
          return Z.groups = { a: "7" }, Z;
        }, "".replace(y, "$<a>") !== "7";
      })), h = "a".replace(/./, "$0") === "$0", p = o("replace"), m = !!/./[p] && /./[p]("a", "$0") === "", b = !a((function() {
        var y = /(?:)/, Z = y.exec;
        y.exec = function() {
          return Z.apply(this, arguments);
        };
        var g = "ab".split(y);
        return g.length !== 2 || g[0] !== "a" || g[1] !== "b";
      }));
      e.exports = function(y, Z, g, f) {
        var T = o(y), M = !a((function() {
          var C = {};
          return C[T] = function() {
            return 7;
          }, ""[y](C) != 7;
        })), N = M && !a((function() {
          var C = !1, R = /a/;
          return y === "split" && ((R = {}).constructor = {}, R.constructor[u] = function() {
            return R;
          }, R.flags = "", R[T] = /./[T]), R.exec = function() {
            return C = !0, null;
          }, R[T](""), !C;
        }));
        if (!M || !N || y === "replace" && (!d || !h || m) || y === "split" && !b) {
          var W = /./[T], x = g(T, ""[y], (function(C, R, z, F, P) {
            return R.exec === l ? M && !P ? { done: !0, value: W.call(R, z, F) } : { done: !0, value: C.call(z, R, F) } : { done: !1 };
          }), { REPLACE_KEEPS_$0: h, REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: m }), V = x[0], X = x[1];
          r(String.prototype, y, V), r(RegExp.prototype, T, Z == 2 ? function(C, R) {
            return X.call(C, this, R);
          } : function(C) {
            return X.call(C, this);
          });
        }
        f && c(RegExp.prototype[T], "sham", !0);
      };
    }, function(e, n, s) {
      var r = s(137).charAt;
      e.exports = function(a, o, l) {
        return o + (l ? r(a, o).length : 1);
      };
    }, function(e, n, s) {
      var r = s(42), a = s(93);
      e.exports = function(o, l) {
        var c = o.exec;
        if (typeof c == "function") {
          var u = c.call(o, l);
          if (typeof u != "object") throw TypeError("RegExp exec method returned something other than an Object or null");
          return u;
        }
        if (r(o) !== "RegExp") throw TypeError("RegExp#exec called on incompatible receiver");
        return a.call(o, l);
      };
    }, function(e, n, s) {
      (function(r) {
        Object.defineProperty(n, "__esModule", { value: !0 });
        var a = s(96);
        n.forgivingBase64Encode = function(o) {
          return r.from(o).toString("base64");
        }, n.forgivingBase64Decode = function(o) {
          return o === "" ? "" : ((o = o.replace(a.ASCIIWhiteSpace, "")).length % 4 == 0 && (o.endsWith("==") ? o = o.substr(0, o.length - 2) : o.endsWith("=") && (o = o.substr(0, o.length - 1))), o.length % 4 == 1 ? null : /[0-9A-Za-z+/]/.test(o) ? r.from(o, "base64").toString("utf8") : null);
        };
      }).call(this, s(145).Buffer);
    }, function(e, n, s) {
      n.byteLength = function(p) {
        var m = d(p), b = m[0], y = m[1];
        return 3 * (b + y) / 4 - y;
      }, n.toByteArray = function(p) {
        var m, b, y = d(p), Z = y[0], g = y[1], f = new o((function(N, W, x) {
          return 3 * (W + x) / 4 - x;
        })(0, Z, g)), T = 0, M = g > 0 ? Z - 4 : Z;
        for (b = 0; b < M; b += 4) m = a[p.charCodeAt(b)] << 18 | a[p.charCodeAt(b + 1)] << 12 | a[p.charCodeAt(b + 2)] << 6 | a[p.charCodeAt(b + 3)], f[T++] = m >> 16 & 255, f[T++] = m >> 8 & 255, f[T++] = 255 & m;
        return g === 2 && (m = a[p.charCodeAt(b)] << 2 | a[p.charCodeAt(b + 1)] >> 4, f[T++] = 255 & m), g === 1 && (m = a[p.charCodeAt(b)] << 10 | a[p.charCodeAt(b + 1)] << 4 | a[p.charCodeAt(b + 2)] >> 2, f[T++] = m >> 8 & 255, f[T++] = 255 & m), f;
      }, n.fromByteArray = function(p) {
        for (var m, b = p.length, y = b % 3, Z = [], g = 0, f = b - y; g < f; g += 16383) Z.push(h(p, g, g + 16383 > f ? f : g + 16383));
        return y === 1 ? (m = p[b - 1], Z.push(r[m >> 2] + r[m << 4 & 63] + "==")) : y === 2 && (m = (p[b - 2] << 8) + p[b - 1], Z.push(r[m >> 10] + r[m >> 4 & 63] + r[m << 2 & 63] + "=")), Z.join("");
      };
      for (var r = [], a = [], o = typeof Uint8Array < "u" ? Uint8Array : Array, l = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", c = 0, u = l.length; c < u; ++c) r[c] = l[c], a[l.charCodeAt(c)] = c;
      function d(p) {
        var m = p.length;
        if (m % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        var b = p.indexOf("=");
        return b === -1 && (b = m), [b, b === m ? 0 : 4 - b % 4];
      }
      function h(p, m, b) {
        for (var y, Z, g = [], f = m; f < b; f += 3) y = (p[f] << 16 & 16711680) + (p[f + 1] << 8 & 65280) + (255 & p[f + 2]), g.push(r[(Z = y) >> 18 & 63] + r[Z >> 12 & 63] + r[Z >> 6 & 63] + r[63 & Z]);
        return g.join("");
      }
      a[45] = 62, a[95] = 63;
    }, function(e, n) {
      n.read = function(s, r, a, o, l) {
        var c, u, d = 8 * l - o - 1, h = (1 << d) - 1, p = h >> 1, m = -7, b = a ? l - 1 : 0, y = a ? -1 : 1, Z = s[r + b];
        for (b += y, c = Z & (1 << -m) - 1, Z >>= -m, m += d; m > 0; c = 256 * c + s[r + b], b += y, m -= 8) ;
        for (u = c & (1 << -m) - 1, c >>= -m, m += o; m > 0; u = 256 * u + s[r + b], b += y, m -= 8) ;
        if (c === 0) c = 1 - p;
        else {
          if (c === h) return u ? NaN : 1 / 0 * (Z ? -1 : 1);
          u += Math.pow(2, o), c -= p;
        }
        return (Z ? -1 : 1) * u * Math.pow(2, c - o);
      }, n.write = function(s, r, a, o, l, c) {
        var u, d, h, p = 8 * c - l - 1, m = (1 << p) - 1, b = m >> 1, y = l === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, Z = o ? 0 : c - 1, g = o ? 1 : -1, f = r < 0 || r === 0 && 1 / r < 0 ? 1 : 0;
        for (r = Math.abs(r), isNaN(r) || r === 1 / 0 ? (d = isNaN(r) ? 1 : 0, u = m) : (u = Math.floor(Math.log(r) / Math.LN2), r * (h = Math.pow(2, -u)) < 1 && (u--, h *= 2), (r += u + b >= 1 ? y / h : y * Math.pow(2, 1 - b)) * h >= 2 && (u++, h /= 2), u + b >= m ? (d = 0, u = m) : u + b >= 1 ? (d = (r * h - 1) * Math.pow(2, l), u += b) : (d = r * Math.pow(2, b - 1) * Math.pow(2, l), u = 0)); l >= 8; s[a + Z] = 255 & d, Z += g, d /= 256, l -= 8) ;
        for (u = u << l | d, p += l; p > 0; s[a + Z] = 255 & u, Z += g, u /= 256, p -= 8) ;
        s[a + Z - g] |= 128 * f;
      };
    }, function(e, n) {
      var s = {}.toString;
      e.exports = Array.isArray || function(r) {
        return s.call(r) == "[object Array]";
      };
    }, function(e, n, s) {
      var r = this && this.__values || function(l) {
        var c = typeof Symbol == "function" && Symbol.iterator, u = c && l[c], d = 0;
        if (u) return u.call(l);
        if (l && typeof l.length == "number") return { next: function() {
          return l && d >= l.length && (l = void 0), { value: l && l[d++], done: !l };
        } };
        throw new TypeError(c ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = s(1);
      function o(l) {
        var c, u;
        if (l === null || a.isString(l) || a.isNumber(l)) return l;
        if (a.isArray(l)) {
          var d = new Array();
          try {
            for (var h = r(l), p = h.next(); !p.done; p = h.next()) {
              var m = p.value;
              d.push(o(m));
            }
          } catch (Z) {
            c = { error: Z };
          } finally {
            try {
              p && !p.done && (u = h.return) && u.call(h);
            } finally {
              if (c) throw c.error;
            }
          }
          return d;
        }
        if (a.isObject(l)) {
          d = /* @__PURE__ */ new Map();
          for (var b in l) if (l.hasOwnProperty(b)) {
            var y = l[b];
            d.set(b, o(y));
          }
          return d;
        }
        return l;
      }
      n.parseJSONFromBytes = function(l) {
        var c = a.utf8Decode(l);
        return JSON.parse.call(void 0, c);
      }, n.serializeJSONToBytes = function(l) {
        var c = JSON.stringify.call(void 0, l);
        return a.utf8Encode(c);
      }, n.parseJSONIntoInfraValues = function(l) {
        return o(JSON.parse.call(void 0, l));
      }, n.convertAJSONDerivedJavaScriptValueToAnInfraValue = o;
    }, function(e, n, s) {
      var r = this && this.__generator || function(u, d) {
        var h, p, m, b, y = { label: 0, sent: function() {
          if (1 & m[0]) throw m[1];
          return m[1];
        }, trys: [], ops: [] };
        return b = { next: Z(0), throw: Z(1), return: Z(2) }, typeof Symbol == "function" && (b[Symbol.iterator] = function() {
          return this;
        }), b;
        function Z(g) {
          return function(f) {
            return (function(T) {
              if (h) throw new TypeError("Generator is already executing.");
              for (; y; ) try {
                if (h = 1, p && (m = 2 & T[0] ? p.return : T[0] ? p.throw || ((m = p.return) && m.call(p), 0) : p.next) && !(m = m.call(p, T[1])).done) return m;
                switch (p = 0, m && (T = [2 & T[0], m.value]), T[0]) {
                  case 0:
                  case 1:
                    m = T;
                    break;
                  case 4:
                    return y.label++, { value: T[1], done: !1 };
                  case 5:
                    y.label++, p = T[1], T = [0];
                    continue;
                  case 7:
                    T = y.ops.pop(), y.trys.pop();
                    continue;
                  default:
                    if (m = y.trys, !((m = m.length > 0 && m[m.length - 1]) || T[0] !== 6 && T[0] !== 2)) {
                      y = 0;
                      continue;
                    }
                    if (T[0] === 3 && (!m || T[1] > m[0] && T[1] < m[3])) {
                      y.label = T[1];
                      break;
                    }
                    if (T[0] === 6 && y.label < m[1]) {
                      y.label = m[1], m = T;
                      break;
                    }
                    if (m && y.label < m[2]) {
                      y.label = m[2], y.ops.push(T);
                      break;
                    }
                    m[2] && y.ops.pop(), y.trys.pop();
                    continue;
                }
                T = d.call(u, y);
              } catch (M) {
                T = [6, M], p = 0;
              } finally {
                h = m = 0;
              }
              if (5 & T[0]) throw T[1];
              return { value: T[0] ? T[1] : void 0, done: !0 };
            })([g, f]);
          };
        }
      }, a = this && this.__read || function(u, d) {
        var h = typeof Symbol == "function" && u[Symbol.iterator];
        if (!h) return u;
        var p, m, b = h.call(u), y = [];
        try {
          for (; (d === void 0 || d-- > 0) && !(p = b.next()).done; ) y.push(p.value);
        } catch (Z) {
          m = { error: Z };
        } finally {
          try {
            p && !p.done && (h = b.return) && h.call(b);
          } finally {
            if (m) throw m.error;
          }
        }
        return y;
      }, o = this && this.__spread || function() {
        for (var u = [], d = 0; d < arguments.length; d++) u = u.concat(a(arguments[d]));
        return u;
      }, l = this && this.__values || function(u) {
        var d = typeof Symbol == "function" && Symbol.iterator, h = d && u[d], p = 0;
        if (h) return h.call(u);
        if (u && typeof u.length == "number") return { next: function() {
          return u && p >= u.length && (u = void 0), { value: u && u[p++], done: !u };
        } };
        throw new TypeError(d ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var c = s(1);
      n.append = function(u, d) {
        u.push(d);
      }, n.extend = function(u, d) {
        u.push.apply(u, o(d));
      }, n.prepend = function(u, d) {
        u.unshift(d);
      }, n.replace = function(u, d, h) {
        var p, m, b = 0;
        try {
          for (var y = l(u), Z = y.next(); !Z.done; Z = y.next()) {
            var g = Z.value;
            if (c.isFunction(d)) d.call(null, g) && (u[b] = h);
            else if (g === d) return void (u[b] = h);
            b++;
          }
        } catch (f) {
          p = { error: f };
        } finally {
          try {
            Z && !Z.done && (m = y.return) && m.call(y);
          } finally {
            if (p) throw p.error;
          }
        }
      }, n.insert = function(u, d, h) {
        u.splice(h, 0, d);
      }, n.remove = function(u, d) {
        for (var h = u.length; h--; ) {
          var p = u[h];
          if (c.isFunction(d)) d.call(null, p) && u.splice(h, 1);
          else if (p === d) return void u.splice(h, 1);
        }
      }, n.empty = function(u) {
        u.length = 0;
      }, n.contains = function(u, d) {
        var h, p;
        try {
          for (var m = l(u), b = m.next(); !b.done; b = m.next()) {
            var y = b.value;
            if (c.isFunction(d)) {
              if (d.call(null, y)) return !0;
            } else if (y === d) return !0;
          }
        } catch (Z) {
          h = { error: Z };
        } finally {
          try {
            b && !b.done && (p = m.return) && p.call(m);
          } finally {
            if (h) throw h.error;
          }
        }
        return !1;
      }, n.size = function(u, d) {
        var h, p;
        if (d === void 0) return u.length;
        var m = 0;
        try {
          for (var b = l(u), y = b.next(); !y.done; y = b.next()) {
            var Z = y.value;
            d.call(null, Z) && m++;
          }
        } catch (g) {
          h = { error: g };
        } finally {
          try {
            y && !y.done && (p = b.return) && p.call(b);
          } finally {
            if (h) throw h.error;
          }
        }
        return m;
      }, n.isEmpty = function(u) {
        return u.length === 0;
      }, n.forEach = function(u, d) {
        var h, p, m, b, y, Z;
        return r(this, (function(g) {
          switch (g.label) {
            case 0:
              return d !== void 0 ? [3, 2] : [5, l(u)];
            case 1:
              return g.sent(), [3, 9];
            case 2:
              g.trys.push([2, 7, 8, 9]), h = l(u), p = h.next(), g.label = 3;
            case 3:
              return p.done ? [3, 6] : (m = p.value, d.call(null, m) ? [4, m] : [3, 5]);
            case 4:
              g.sent(), g.label = 5;
            case 5:
              return p = h.next(), [3, 3];
            case 6:
              return [3, 9];
            case 7:
              return b = g.sent(), y = { error: b }, [3, 9];
            case 8:
              try {
                p && !p.done && (Z = h.return) && Z.call(h);
              } finally {
                if (y) throw y.error;
              }
              return [7];
            case 9:
              return [2];
          }
        }));
      }, n.clone = function(u) {
        return new (Array.bind.apply(Array, o([void 0], u)))();
      }, n.sortInAscendingOrder = function(u, d) {
        return u.sort((function(h, p) {
          return d.call(null, h, p) ? -1 : 1;
        }));
      }, n.sortInDescendingOrder = function(u, d) {
        return u.sort((function(h, p) {
          return d.call(null, h, p) ? 1 : -1;
        }));
      };
    }, function(e, n, s) {
      var r = this && this.__generator || function(u, d) {
        var h, p, m, b, y = { label: 0, sent: function() {
          if (1 & m[0]) throw m[1];
          return m[1];
        }, trys: [], ops: [] };
        return b = { next: Z(0), throw: Z(1), return: Z(2) }, typeof Symbol == "function" && (b[Symbol.iterator] = function() {
          return this;
        }), b;
        function Z(g) {
          return function(f) {
            return (function(T) {
              if (h) throw new TypeError("Generator is already executing.");
              for (; y; ) try {
                if (h = 1, p && (m = 2 & T[0] ? p.return : T[0] ? p.throw || ((m = p.return) && m.call(p), 0) : p.next) && !(m = m.call(p, T[1])).done) return m;
                switch (p = 0, m && (T = [2 & T[0], m.value]), T[0]) {
                  case 0:
                  case 1:
                    m = T;
                    break;
                  case 4:
                    return y.label++, { value: T[1], done: !1 };
                  case 5:
                    y.label++, p = T[1], T = [0];
                    continue;
                  case 7:
                    T = y.ops.pop(), y.trys.pop();
                    continue;
                  default:
                    if (m = y.trys, !((m = m.length > 0 && m[m.length - 1]) || T[0] !== 6 && T[0] !== 2)) {
                      y = 0;
                      continue;
                    }
                    if (T[0] === 3 && (!m || T[1] > m[0] && T[1] < m[3])) {
                      y.label = T[1];
                      break;
                    }
                    if (T[0] === 6 && y.label < m[1]) {
                      y.label = m[1], m = T;
                      break;
                    }
                    if (m && y.label < m[2]) {
                      y.label = m[2], y.ops.push(T);
                      break;
                    }
                    m[2] && y.ops.pop(), y.trys.pop();
                    continue;
                }
                T = d.call(u, y);
              } catch (M) {
                T = [6, M], p = 0;
              } finally {
                h = m = 0;
              }
              if (5 & T[0]) throw T[1];
              return { value: T[0] ? T[1] : void 0, done: !0 };
            })([g, f]);
          };
        }
      }, a = this && this.__values || function(u) {
        var d = typeof Symbol == "function" && Symbol.iterator, h = d && u[d], p = 0;
        if (h) return h.call(u);
        if (u && typeof u.length == "number") return { next: function() {
          return u && p >= u.length && (u = void 0), { value: u && u[p++], done: !u };
        } };
        throw new TypeError(d ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }, o = this && this.__read || function(u, d) {
        var h = typeof Symbol == "function" && u[Symbol.iterator];
        if (!h) return u;
        var p, m, b = h.call(u), y = [];
        try {
          for (; (d === void 0 || d-- > 0) && !(p = b.next()).done; ) y.push(p.value);
        } catch (Z) {
          m = { error: Z };
        } finally {
          try {
            p && !p.done && (h = b.return) && h.call(b);
          } finally {
            if (m) throw m.error;
          }
        }
        return y;
      }, l = this && this.__spread || function() {
        for (var u = [], d = 0; d < arguments.length; d++) u = u.concat(o(arguments[d]));
        return u;
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var c = s(1);
      n.get = function(u, d) {
        return u.get(d);
      }, n.set = function(u, d, h) {
        u.set(d, h);
      }, n.remove = function(u, d) {
        var h, p, m, b;
        if (c.isFunction(d)) {
          var y = [];
          try {
            for (var Z = a(u), g = Z.next(); !g.done; g = Z.next()) {
              var f = g.value;
              d.call(null, f) && y.push(f[0]);
            }
          } catch (W) {
            h = { error: W };
          } finally {
            try {
              g && !g.done && (p = Z.return) && p.call(Z);
            } finally {
              if (h) throw h.error;
            }
          }
          try {
            for (var T = a(y), M = T.next(); !M.done; M = T.next()) {
              var N = M.value;
              u.delete(N);
            }
          } catch (W) {
            m = { error: W };
          } finally {
            try {
              M && !M.done && (b = T.return) && b.call(T);
            } finally {
              if (m) throw m.error;
            }
          }
        } else u.delete(d);
      }, n.contains = function(u, d) {
        var h, p;
        if (c.isFunction(d)) {
          try {
            for (var m = a(u), b = m.next(); !b.done; b = m.next()) {
              var y = b.value;
              if (d.call(null, y)) return !0;
            }
          } catch (Z) {
            h = { error: Z };
          } finally {
            try {
              b && !b.done && (p = m.return) && p.call(m);
            } finally {
              if (h) throw h.error;
            }
          }
          return !1;
        }
        return u.has(d);
      }, n.keys = function(u) {
        return new Set(u.keys());
      }, n.values = function(u) {
        return l(u.values());
      }, n.size = function(u, d) {
        var h, p;
        if (d === void 0) return u.size;
        var m = 0;
        try {
          for (var b = a(u), y = b.next(); !y.done; y = b.next()) {
            var Z = y.value;
            d.call(null, Z) && m++;
          }
        } catch (g) {
          h = { error: g };
        } finally {
          try {
            y && !y.done && (p = b.return) && p.call(b);
          } finally {
            if (h) throw h.error;
          }
        }
        return m;
      }, n.isEmpty = function(u) {
        return u.size === 0;
      }, n.forEach = function(u, d) {
        var h, p, m, b, y, Z;
        return r(this, (function(g) {
          switch (g.label) {
            case 0:
              return d !== void 0 ? [3, 2] : [5, a(u)];
            case 1:
              return g.sent(), [3, 9];
            case 2:
              g.trys.push([2, 7, 8, 9]), h = a(u), p = h.next(), g.label = 3;
            case 3:
              return p.done ? [3, 6] : (m = p.value, d.call(null, m) ? [4, m] : [3, 5]);
            case 4:
              g.sent(), g.label = 5;
            case 5:
              return p = h.next(), [3, 3];
            case 6:
              return [3, 9];
            case 7:
              return b = g.sent(), y = { error: b }, [3, 9];
            case 8:
              try {
                p && !p.done && (Z = h.return) && Z.call(h);
              } finally {
                if (y) throw y.error;
              }
              return [7];
            case 9:
              return [2];
          }
        }));
      }, n.clone = function(u) {
        return new Map(u);
      }, n.sortInAscendingOrder = function(u, d) {
        var h = new (Array.bind.apply(Array, l([void 0], u)))();
        return h.sort((function(p, m) {
          return d.call(null, p, m) ? -1 : 1;
        })), new Map(h);
      }, n.sortInDescendingOrder = function(u, d) {
        var h = new (Array.bind.apply(Array, l([void 0], u)))();
        return h.sort((function(p, m) {
          return d.call(null, p, m) ? 1 : -1;
        })), new Map(h);
      };
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 }), n.HTML = "http://www.w3.org/1999/xhtml", n.XML = "http://www.w3.org/XML/1998/namespace", n.XMLNS = "http://www.w3.org/2000/xmlns/", n.MathML = "http://www.w3.org/1998/Math/MathML", n.SVG = "http://www.w3.org/2000/svg", n.XLink = "http://www.w3.org/1999/xlink";
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 }), n.enqueue = function(r, a) {
        r.push(a);
      }, n.dequeue = function(r) {
        return r.shift() || null;
      };
    }, function(e, n, s) {
      var r = this && this.__generator || function(d, h) {
        var p, m, b, y, Z = { label: 0, sent: function() {
          if (1 & b[0]) throw b[1];
          return b[1];
        }, trys: [], ops: [] };
        return y = { next: g(0), throw: g(1), return: g(2) }, typeof Symbol == "function" && (y[Symbol.iterator] = function() {
          return this;
        }), y;
        function g(f) {
          return function(T) {
            return (function(M) {
              if (p) throw new TypeError("Generator is already executing.");
              for (; Z; ) try {
                if (p = 1, m && (b = 2 & M[0] ? m.return : M[0] ? m.throw || ((b = m.return) && b.call(m), 0) : m.next) && !(b = b.call(m, M[1])).done) return b;
                switch (m = 0, b && (M = [2 & M[0], b.value]), M[0]) {
                  case 0:
                  case 1:
                    b = M;
                    break;
                  case 4:
                    return Z.label++, { value: M[1], done: !1 };
                  case 5:
                    Z.label++, m = M[1], M = [0];
                    continue;
                  case 7:
                    M = Z.ops.pop(), Z.trys.pop();
                    continue;
                  default:
                    if (b = Z.trys, !((b = b.length > 0 && b[b.length - 1]) || M[0] !== 6 && M[0] !== 2)) {
                      Z = 0;
                      continue;
                    }
                    if (M[0] === 3 && (!b || M[1] > b[0] && M[1] < b[3])) {
                      Z.label = M[1];
                      break;
                    }
                    if (M[0] === 6 && Z.label < b[1]) {
                      Z.label = b[1], b = M;
                      break;
                    }
                    if (b && Z.label < b[2]) {
                      Z.label = b[2], Z.ops.push(M);
                      break;
                    }
                    b[2] && Z.ops.pop(), Z.trys.pop();
                    continue;
                }
                M = h.call(d, Z);
              } catch (N) {
                M = [6, N], m = 0;
              } finally {
                p = b = 0;
              }
              if (5 & M[0]) throw M[1];
              return { value: M[0] ? M[1] : void 0, done: !0 };
            })([f, T]);
          };
        }
      }, a = this && this.__values || function(d) {
        var h = typeof Symbol == "function" && Symbol.iterator, p = h && d[h], m = 0;
        if (p) return p.call(d);
        if (d && typeof d.length == "number") return { next: function() {
          return d && m >= d.length && (d = void 0), { value: d && d[m++], done: !d };
        } };
        throw new TypeError(h ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }, o = this && this.__read || function(d, h) {
        var p = typeof Symbol == "function" && d[Symbol.iterator];
        if (!p) return d;
        var m, b, y = p.call(d), Z = [];
        try {
          for (; (h === void 0 || h-- > 0) && !(m = y.next()).done; ) Z.push(m.value);
        } catch (g) {
          b = { error: g };
        } finally {
          try {
            m && !m.done && (p = y.return) && p.call(y);
          } finally {
            if (b) throw b.error;
          }
        }
        return Z;
      }, l = this && this.__spread || function() {
        for (var d = [], h = 0; h < arguments.length; h++) d = d.concat(o(arguments[h]));
        return d;
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var c = s(1);
      function u(d, h) {
        var p, m;
        try {
          for (var b = a(d), y = b.next(); !y.done; y = b.next()) {
            var Z = y.value;
            if (!h.has(Z)) return !1;
          }
        } catch (g) {
          p = { error: g };
        } finally {
          try {
            y && !y.done && (m = b.return) && m.call(b);
          } finally {
            if (p) throw p.error;
          }
        }
        return !0;
      }
      n.append = function(d, h) {
        d.add(h);
      }, n.extend = function(d, h) {
        h.forEach(d.add, d);
      }, n.prepend = function(d, h) {
        var p = new Set(d);
        d.clear(), d.add(h), p.forEach(d.add, d);
      }, n.replace = function(d, h, p) {
        var m, b, y = /* @__PURE__ */ new Set();
        try {
          for (var Z = a(d), g = Z.next(); !g.done; g = Z.next()) {
            var f = g.value;
            c.isFunction(h) ? h.call(null, f) ? y.add(p) : y.add(f) : f === h ? y.add(p) : y.add(f);
          }
        } catch (T) {
          m = { error: T };
        } finally {
          try {
            g && !g.done && (b = Z.return) && b.call(Z);
          } finally {
            if (m) throw m.error;
          }
        }
        d.clear(), y.forEach(d.add, d);
      }, n.insert = function(d, h, p) {
        var m, b, y = /* @__PURE__ */ new Set(), Z = 0;
        try {
          for (var g = a(d), f = g.next(); !f.done; f = g.next()) {
            var T = f.value;
            Z === p && y.add(h), y.add(T), Z++;
          }
        } catch (M) {
          m = { error: M };
        } finally {
          try {
            f && !f.done && (b = g.return) && b.call(g);
          } finally {
            if (m) throw m.error;
          }
        }
        d.clear(), y.forEach(d.add, d);
      }, n.remove = function(d, h) {
        var p, m, b, y;
        if (c.isFunction(h)) {
          var Z = [];
          try {
            for (var g = a(d), f = g.next(); !f.done; f = g.next()) {
              var T = f.value;
              h.call(null, T) && Z.push(T);
            }
          } catch (x) {
            p = { error: x };
          } finally {
            try {
              f && !f.done && (m = g.return) && m.call(g);
            } finally {
              if (p) throw p.error;
            }
          }
          try {
            for (var M = a(Z), N = M.next(); !N.done; N = M.next()) {
              var W = N.value;
              d.delete(W);
            }
          } catch (x) {
            b = { error: x };
          } finally {
            try {
              N && !N.done && (y = M.return) && y.call(M);
            } finally {
              if (b) throw b.error;
            }
          }
        } else d.delete(h);
      }, n.empty = function(d) {
        d.clear();
      }, n.contains = function(d, h) {
        var p, m;
        if (!c.isFunction(h)) return d.has(h);
        try {
          for (var b = a(d), y = b.next(); !y.done; y = b.next()) {
            var Z = y.value;
            if (h.call(null, Z)) return !0;
          }
        } catch (g) {
          p = { error: g };
        } finally {
          try {
            y && !y.done && (m = b.return) && m.call(b);
          } finally {
            if (p) throw p.error;
          }
        }
        return !1;
      }, n.size = function(d, h) {
        var p, m;
        if (h === void 0) return d.size;
        var b = 0;
        try {
          for (var y = a(d), Z = y.next(); !Z.done; Z = y.next()) {
            var g = Z.value;
            h.call(null, g) && b++;
          }
        } catch (f) {
          p = { error: f };
        } finally {
          try {
            Z && !Z.done && (m = y.return) && m.call(y);
          } finally {
            if (p) throw p.error;
          }
        }
        return b;
      }, n.isEmpty = function(d) {
        return d.size === 0;
      }, n.forEach = function(d, h) {
        var p, m, b, y, Z, g;
        return r(this, (function(f) {
          switch (f.label) {
            case 0:
              return h !== void 0 ? [3, 2] : [5, a(d)];
            case 1:
              return f.sent(), [3, 9];
            case 2:
              f.trys.push([2, 7, 8, 9]), p = a(d), m = p.next(), f.label = 3;
            case 3:
              return m.done ? [3, 6] : (b = m.value, h.call(null, b) ? [4, b] : [3, 5]);
            case 4:
              f.sent(), f.label = 5;
            case 5:
              return m = p.next(), [3, 3];
            case 6:
              return [3, 9];
            case 7:
              return y = f.sent(), Z = { error: y }, [3, 9];
            case 8:
              try {
                m && !m.done && (g = p.return) && g.call(p);
              } finally {
                if (Z) throw Z.error;
              }
              return [7];
            case 9:
              return [2];
          }
        }));
      }, n.clone = function(d) {
        return new Set(d);
      }, n.sortInAscendingOrder = function(d, h) {
        var p = new (Array.bind.apply(Array, l([void 0], d)))();
        return p.sort((function(m, b) {
          return h.call(null, m, b) ? -1 : 1;
        })), new Set(p);
      }, n.sortInDescendingOrder = function(d, h) {
        var p = new (Array.bind.apply(Array, l([void 0], d)))();
        return p.sort((function(m, b) {
          return h.call(null, m, b) ? 1 : -1;
        })), new Set(p);
      }, n.isSubsetOf = u, n.isSupersetOf = function(d, h) {
        return u(h, d);
      }, n.intersection = function(d, h) {
        var p, m, b = /* @__PURE__ */ new Set();
        try {
          for (var y = a(d), Z = y.next(); !Z.done; Z = y.next()) {
            var g = Z.value;
            h.has(g) && b.add(g);
          }
        } catch (f) {
          p = { error: f };
        } finally {
          try {
            Z && !Z.done && (m = y.return) && m.call(y);
          } finally {
            if (p) throw p.error;
          }
        }
        return b;
      }, n.union = function(d, h) {
        var p = new Set(d);
        return h.forEach(p.add, p), p;
      }, n.range = function(d, h) {
        for (var p = /* @__PURE__ */ new Set(), m = d; m <= h; m++) p.add(m);
        return p;
      };
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 }), n.push = function(r, a) {
        r.push(a);
      }, n.pop = function(r) {
        return r.pop() || null;
      };
    }, function(e, n, s) {
      var r = this && this.__values || function(Z) {
        var g = typeof Symbol == "function" && Symbol.iterator, f = g && Z[g], T = 0;
        if (f) return f.call(Z);
        if (Z && typeof Z.length == "number") return { next: function() {
          return Z && T >= Z.length && (Z = void 0), { value: Z && Z[T++], done: !Z };
        } };
        throw new TypeError(g ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = s(96), o = s(147), l = s(146), c = s(1);
      function u(Z, g) {
        for (var f = 0; ; ) {
          var T = f < Z.length ? Z.charCodeAt(f) : null, M = f < g.length ? g.charCodeAt(f) : null;
          if (T === null) return !0;
          if (T !== M) return !1;
          f++;
        }
      }
      function d(Z) {
        var g, f, T = Array.from(Z), M = new Uint8Array(T.length), N = 0;
        try {
          for (var W = r(Z), x = W.next(); !x.done; x = W.next()) {
            var V = x.value.codePointAt(0);
            console.assert(V !== void 0 && V <= 255, "isomorphicEncode requires string bytes to be less than or equal to 0x00FF."), V !== void 0 && V <= 255 && (M[N++] = V);
          }
        } catch (X) {
          g = { error: X };
        } finally {
          try {
            x && !x.done && (f = W.return) && f.call(W);
          } finally {
            if (g) throw g.error;
          }
        }
        return M;
      }
      function h(Z) {
        return /^[\u0000-\u007F]*$/.test(Z);
      }
      function p(Z) {
        var g, f, T = "";
        try {
          for (var M = r(Z), N = M.next(); !N.done; N = M.next()) {
            var W = N.value, x = W.codePointAt(0);
            T += x !== void 0 && x >= 65 && x <= 90 ? String.fromCodePoint(x + 32) : W;
          }
        } catch (V) {
          g = { error: V };
        } finally {
          try {
            N && !N.done && (f = M.return) && f.call(M);
          } finally {
            if (g) throw g.error;
          }
        }
        return T;
      }
      function m(Z) {
        return Z.replace(/^[\t\n\f\r ]+/, "").replace(/[\t\n\f\r ]+$/, "");
      }
      function b(Z, g, f) {
        if (!c.isArray(g)) return b(Z, Array.from(g), f);
        for (var T = ""; f.position < g.length && Z.call(null, g[f.position]); ) T += g[f.position], f.position++;
        return T;
      }
      function y(Z, g) {
        b((function(f) {
          return a.ASCIIWhiteSpace.test(f);
        }), Z, g);
      }
      n.isCodeUnitPrefix = u, n.isCodeUnitLessThan = function(Z, g) {
        if (u(g, Z)) return !1;
        if (u(Z, g)) return !0;
        for (var f = 0; f < Math.min(Z.length, g.length); f++) {
          var T = Z.charCodeAt(f), M = g.charCodeAt(f);
          if (T !== M) return T < M;
        }
        return !1;
      }, n.isomorphicEncode = d, n.isASCIIString = h, n.asciiLowercase = p, n.asciiUppercase = function(Z) {
        var g, f, T = "";
        try {
          for (var M = r(Z), N = M.next(); !N.done; N = M.next()) {
            var W = N.value, x = W.codePointAt(0);
            T += x !== void 0 && x >= 97 && x <= 122 ? String.fromCodePoint(x - 32) : W;
          }
        } catch (V) {
          g = { error: V };
        } finally {
          try {
            N && !N.done && (f = M.return) && f.call(M);
          } finally {
            if (g) throw g.error;
          }
        }
        return T;
      }, n.asciiCaseInsensitiveMatch = function(Z, g) {
        return p(Z) === p(g);
      }, n.asciiEncode = function(Z) {
        return console.assert(h(Z), "asciiEncode requires an ASCII string."), d(Z);
      }, n.asciiDecode = function(Z) {
        var g, f;
        try {
          for (var T = r(Z), M = T.next(); !M.done; M = T.next()) {
            var N = M.value;
            console.assert(l.isASCIIByte(N), "asciiDecode requires an ASCII byte sequence.");
          }
        } catch (W) {
          g = { error: W };
        } finally {
          try {
            M && !M.done && (f = T.return) && f.call(T);
          } finally {
            if (g) throw g.error;
          }
        }
        return o.isomorphicDecode(Z);
      }, n.stripNewlines = function(Z) {
        return Z.replace(/[\n\r]/g, "");
      }, n.normalizeNewlines = function(Z) {
        return Z.replace(/\r\n/g, `
`).replace(/\r/g, `
`);
      }, n.stripLeadingAndTrailingASCIIWhitespace = m, n.stripAndCollapseASCIIWhitespace = function(Z) {
        return m(Z.replace(/[\t\n\f\r ]{2,}/g, " "));
      }, n.collectASequenceOfCodePoints = b, n.skipASCIIWhitespace = y, n.strictlySplit = function Z(g, f) {
        if (!c.isArray(g)) return Z(Array.from(g), f);
        var T = { position: 0 }, M = [], N = b((function(W) {
          return f !== W;
        }), g, T);
        for (M.push(N); T.position < g.length; ) console.assert(g[T.position] === f, "strictlySplit found no delimiter in input string."), T.position++, N = b((function(W) {
          return f !== W;
        }), g, T), M.push(N);
        return M;
      }, n.splitAStringOnASCIIWhitespace = function Z(g) {
        if (!c.isArray(g)) return Z(Array.from(g));
        var f = { position: 0 }, T = [];
        for (y(g, f); f.position < g.length; ) {
          var M = b((function(N) {
            return !a.ASCIIWhiteSpace.test(N);
          }), g, f);
          T.push(M), y(g, f);
        }
        return T;
      }, n.splitAStringOnCommas = function Z(g) {
        if (!c.isArray(g)) return Z(Array.from(g));
        for (var f = { position: 0 }, T = []; f.position < g.length; ) {
          var M = b((function(N) {
            return N !== ",";
          }), g, f);
          T.push(m(M)), f.position < g.length && (console.assert(g[f.position] === ",", "splitAStringOnCommas found no delimiter in input string."), f.position++);
        }
        return T;
      }, n.concatenate = function(Z, g) {
        return g === void 0 && (g = ""), Z.length === 0 ? "" : Z.join(g);
      };
    }, function(e, n, s) {
      var r = this && this.__values || function(o) {
        var l = typeof Symbol == "function" && Symbol.iterator, c = l && o[l], u = 0;
        if (c) return c.call(o);
        if (o && typeof o.length == "number") return { next: function() {
          return o && u >= o.length && (o = void 0), { value: o && o[u++], done: !o };
        } };
        throw new TypeError(l ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = s(97);
      n.abort_add = function(o, l) {
        l._abortedFlag || l._abortAlgorithms.add(o);
      }, n.abort_remove = function(o, l) {
        l._abortAlgorithms.delete(o);
      }, n.abort_signalAbort = function(o) {
        var l, c;
        if (!o._abortedFlag) {
          o._abortedFlag = !0;
          try {
            for (var u = r(o._abortAlgorithms), d = u.next(); !d.done; d = u.next())
              d.value.call(o);
          } catch (h) {
            l = { error: h };
          } finally {
            try {
              d && !d.done && (c = u.return) && c.call(u);
            } finally {
              if (l) throw l.error;
            }
          }
          o._abortAlgorithms.clear(), a.event_fireAnEvent("abort", o);
        }
      };
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(150), a = (function() {
        function o() {
        }
        return o.asNode = function(l) {
          if (r.Guard.isNode(l)) return l;
          throw new Error("Invalid object. Node expected.");
        }, o;
      })();
      n.Cast = a;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = (function() {
        function o() {
        }
        return Object.defineProperty(o.prototype, "size", { get: function() {
          return 0;
        }, enumerable: !0, configurable: !0 }), o.prototype.add = function(l) {
          throw new Error("Cannot add to an empty set.");
        }, o.prototype.clear = function() {
        }, o.prototype.delete = function(l) {
          return !1;
        }, o.prototype.forEach = function(l, c) {
        }, o.prototype.has = function(l) {
          return !1;
        }, o.prototype[Symbol.iterator] = function() {
          return new a();
        }, o.prototype.entries = function() {
          return new a();
        }, o.prototype.keys = function() {
          return new a();
        }, o.prototype.values = function() {
          return new a();
        }, Object.defineProperty(o.prototype, Symbol.toStringTag, { get: function() {
          return "EmptySet";
        }, enumerable: !0, configurable: !0 }), o;
      })();
      n.EmptySet = r;
      var a = (function() {
        function o() {
        }
        return o.prototype[Symbol.iterator] = function() {
          return this;
        }, o.prototype.next = function() {
          return { done: !0, value: null };
        }, o;
      })();
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 }), (function(r) {
        r[r.SchemeStart = 0] = "SchemeStart", r[r.Scheme = 1] = "Scheme", r[r.NoScheme = 2] = "NoScheme", r[r.SpecialRelativeOrAuthority = 3] = "SpecialRelativeOrAuthority", r[r.PathOrAuthority = 4] = "PathOrAuthority", r[r.Relative = 5] = "Relative", r[r.RelativeSlash = 6] = "RelativeSlash", r[r.SpecialAuthoritySlashes = 7] = "SpecialAuthoritySlashes", r[r.SpecialAuthorityIgnoreSlashes = 8] = "SpecialAuthorityIgnoreSlashes", r[r.Authority = 9] = "Authority", r[r.Host = 10] = "Host", r[r.Hostname = 11] = "Hostname", r[r.Port = 12] = "Port", r[r.File = 13] = "File", r[r.FileSlash = 14] = "FileSlash", r[r.FileHost = 15] = "FileHost", r[r.PathStart = 16] = "PathStart", r[r.Path = 17] = "Path", r[r.CannotBeABaseURLPath = 18] = "CannotBeABaseURLPath", r[r.Query = 19] = "Query", r[r.Fragment = 20] = "Fragment";
      })(n.ParserState || (n.ParserState = {})), n.OpaqueOrigin = ["", "", null, null];
    }, function(e, n, s) {
      var r = s(245), a = s(247);
      function o() {
        this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
      }
      n.parse = M, n.resolve = function(N, W) {
        return M(N, !1, !0).resolve(W);
      }, n.resolveObject = function(N, W) {
        return N ? M(N, !1, !0).resolveObject(W) : W;
      }, n.format = function(N) {
        return a.isString(N) && (N = M(N)), N instanceof o ? N.format() : o.prototype.format.call(N);
      }, n.Url = o;
      var l = /^([a-z0-9.+-]+:)/i, c = /:[0-9]*$/, u = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, d = ["{", "}", "|", "\\", "^", "`"].concat(["<", ">", '"', "`", " ", "\r", `
`, "	"]), h = ["'"].concat(d), p = ["%", "/", "?", ";", "#"].concat(h), m = ["/", "?", "#"], b = /^[+a-z0-9A-Z_-]{0,63}$/, y = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, Z = { javascript: !0, "javascript:": !0 }, g = { javascript: !0, "javascript:": !0 }, f = { http: !0, https: !0, ftp: !0, gopher: !0, file: !0, "http:": !0, "https:": !0, "ftp:": !0, "gopher:": !0, "file:": !0 }, T = s(248);
      function M(N, W, x) {
        if (N && a.isObject(N) && N instanceof o) return N;
        var V = new o();
        return V.parse(N, W, x), V;
      }
      o.prototype.parse = function(N, W, x) {
        if (!a.isString(N)) throw new TypeError("Parameter 'url' must be a string, not " + typeof N);
        var V = N.indexOf("?"), X = V !== -1 && V < N.indexOf("#") ? "?" : "#", C = N.split(X);
        C[0] = C[0].replace(/\\/g, "/");
        var R = N = C.join(X);
        if (R = R.trim(), !x && N.split("#").length === 1) {
          var z = u.exec(R);
          if (z) return this.path = R, this.href = R, this.pathname = z[1], z[2] ? (this.search = z[2], this.query = W ? T.parse(this.search.substr(1)) : this.search.substr(1)) : W && (this.search = "", this.query = {}), this;
        }
        var F = l.exec(R);
        if (F) {
          var P = (F = F[0]).toLowerCase();
          this.protocol = P, R = R.substr(F.length);
        }
        if (x || F || R.match(/^\/\/[^@\/]+@[^@\/]+/)) {
          var j = R.substr(0, 2) === "//";
          !j || F && g[F] || (R = R.substr(2), this.slashes = !0);
        }
        if (!g[F] && (j || F && !f[F])) {
          for (var H, B, $ = -1, A = 0; A < m.length; A++)
            (E = R.indexOf(m[A])) !== -1 && ($ === -1 || E < $) && ($ = E);
          for ((B = $ === -1 ? R.lastIndexOf("@") : R.lastIndexOf("@", $)) !== -1 && (H = R.slice(0, B), R = R.slice(B + 1), this.auth = decodeURIComponent(H)), $ = -1, A = 0; A < p.length; A++) {
            var E;
            (E = R.indexOf(p[A])) !== -1 && ($ === -1 || E < $) && ($ = E);
          }
          $ === -1 && ($ = R.length), this.host = R.slice(0, $), R = R.slice($), this.parseHost(), this.hostname = this.hostname || "";
          var ct = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
          if (!ct) for (var at = this.hostname.split(/\./), dt = (A = 0, at.length); A < dt; A++) {
            var gt = at[A];
            if (gt && !gt.match(b)) {
              for (var Wt = "", Zt = 0, Gt = gt.length; Zt < Gt; Zt++) gt.charCodeAt(Zt) > 127 ? Wt += "x" : Wt += gt[Zt];
              if (!Wt.match(b)) {
                var Tt = at.slice(0, A), Q = at.slice(A + 1), D = gt.match(y);
                D && (Tt.push(D[1]), Q.unshift(D[2])), Q.length && (R = "/" + Q.join(".") + R), this.hostname = Tt.join(".");
                break;
              }
            }
          }
          this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), ct || (this.hostname = r.toASCII(this.hostname));
          var q = this.port ? ":" + this.port : "", nt = this.hostname || "";
          this.host = nt + q, this.href += this.host, ct && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), R[0] !== "/" && (R = "/" + R));
        }
        if (!Z[P]) for (A = 0, dt = h.length; A < dt; A++) {
          var et = h[A];
          if (R.indexOf(et) !== -1) {
            var ot = encodeURIComponent(et);
            ot === et && (ot = escape(et)), R = R.split(et).join(ot);
          }
        }
        var it = R.indexOf("#");
        it !== -1 && (this.hash = R.substr(it), R = R.slice(0, it));
        var ht = R.indexOf("?");
        if (ht !== -1 ? (this.search = R.substr(ht), this.query = R.substr(ht + 1), W && (this.query = T.parse(this.query)), R = R.slice(0, ht)) : W && (this.search = "", this.query = {}), R && (this.pathname = R), f[P] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
          q = this.pathname || "";
          var lt = this.search || "";
          this.path = q + lt;
        }
        return this.href = this.format(), this;
      }, o.prototype.format = function() {
        var N = this.auth || "";
        N && (N = (N = encodeURIComponent(N)).replace(/%3A/i, ":"), N += "@");
        var W = this.protocol || "", x = this.pathname || "", V = this.hash || "", X = !1, C = "";
        this.host ? X = N + this.host : this.hostname && (X = N + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && (X += ":" + this.port)), this.query && a.isObject(this.query) && Object.keys(this.query).length && (C = T.stringify(this.query));
        var R = this.search || C && "?" + C || "";
        return W && W.substr(-1) !== ":" && (W += ":"), this.slashes || (!W || f[W]) && X !== !1 ? (X = "//" + (X || ""), x && x.charAt(0) !== "/" && (x = "/" + x)) : X || (X = ""), V && V.charAt(0) !== "#" && (V = "#" + V), R && R.charAt(0) !== "?" && (R = "?" + R), W + X + (x = x.replace(/[?#]/g, (function(z) {
          return encodeURIComponent(z);
        }))) + (R = R.replace("#", "%23")) + V;
      }, o.prototype.resolve = function(N) {
        return this.resolveObject(M(N, !1, !0)).format();
      }, o.prototype.resolveObject = function(N) {
        if (a.isString(N)) {
          var W = new o();
          W.parse(N, !1, !0), N = W;
        }
        for (var x = new o(), V = Object.keys(this), X = 0; X < V.length; X++) {
          var C = V[X];
          x[C] = this[C];
        }
        if (x.hash = N.hash, N.href === "") return x.href = x.format(), x;
        if (N.slashes && !N.protocol) {
          for (var R = Object.keys(N), z = 0; z < R.length; z++) {
            var F = R[z];
            F !== "protocol" && (x[F] = N[F]);
          }
          return f[x.protocol] && x.hostname && !x.pathname && (x.path = x.pathname = "/"), x.href = x.format(), x;
        }
        if (N.protocol && N.protocol !== x.protocol) {
          if (!f[N.protocol]) {
            for (var P = Object.keys(N), j = 0; j < P.length; j++) {
              var H = P[j];
              x[H] = N[H];
            }
            return x.href = x.format(), x;
          }
          if (x.protocol = N.protocol, N.host || g[N.protocol]) x.pathname = N.pathname;
          else {
            for (var B = (N.pathname || "").split("/"); B.length && !(N.host = B.shift()); ) ;
            N.host || (N.host = ""), N.hostname || (N.hostname = ""), B[0] !== "" && B.unshift(""), B.length < 2 && B.unshift(""), x.pathname = B.join("/");
          }
          if (x.search = N.search, x.query = N.query, x.host = N.host || "", x.auth = N.auth, x.hostname = N.hostname || N.host, x.port = N.port, x.pathname || x.search) {
            var $ = x.pathname || "", A = x.search || "";
            x.path = $ + A;
          }
          return x.slashes = x.slashes || N.slashes, x.href = x.format(), x;
        }
        var E = x.pathname && x.pathname.charAt(0) === "/", ct = N.host || N.pathname && N.pathname.charAt(0) === "/", at = ct || E || x.host && N.pathname, dt = at, gt = x.pathname && x.pathname.split("/") || [], Wt = (B = N.pathname && N.pathname.split("/") || [], x.protocol && !f[x.protocol]);
        if (Wt && (x.hostname = "", x.port = null, x.host && (gt[0] === "" ? gt[0] = x.host : gt.unshift(x.host)), x.host = "", N.protocol && (N.hostname = null, N.port = null, N.host && (B[0] === "" ? B[0] = N.host : B.unshift(N.host)), N.host = null), at = at && (B[0] === "" || gt[0] === "")), ct) x.host = N.host || N.host === "" ? N.host : x.host, x.hostname = N.hostname || N.hostname === "" ? N.hostname : x.hostname, x.search = N.search, x.query = N.query, gt = B;
        else if (B.length) gt || (gt = []), gt.pop(), gt = gt.concat(B), x.search = N.search, x.query = N.query;
        else if (!a.isNullOrUndefined(N.search))
          return Wt && (x.hostname = x.host = gt.shift(), (D = !!(x.host && x.host.indexOf("@") > 0) && x.host.split("@")) && (x.auth = D.shift(), x.host = x.hostname = D.shift())), x.search = N.search, x.query = N.query, a.isNull(x.pathname) && a.isNull(x.search) || (x.path = (x.pathname ? x.pathname : "") + (x.search ? x.search : "")), x.href = x.format(), x;
        if (!gt.length) return x.pathname = null, x.search ? x.path = "/" + x.search : x.path = null, x.href = x.format(), x;
        for (var Zt = gt.slice(-1)[0], Gt = (x.host || N.host || gt.length > 1) && (Zt === "." || Zt === "..") || Zt === "", Tt = 0, Q = gt.length; Q >= 0; Q--) (Zt = gt[Q]) === "." ? gt.splice(Q, 1) : Zt === ".." ? (gt.splice(Q, 1), Tt++) : Tt && (gt.splice(Q, 1), Tt--);
        if (!at && !dt) for (; Tt--; Tt) gt.unshift("..");
        !at || gt[0] === "" || gt[0] && gt[0].charAt(0) === "/" || gt.unshift(""), Gt && gt.join("/").substr(-1) !== "/" && gt.push("");
        var D, q = gt[0] === "" || gt[0] && gt[0].charAt(0) === "/";
        return Wt && (x.hostname = x.host = q ? "" : gt.length ? gt.shift() : "", (D = !!(x.host && x.host.indexOf("@") > 0) && x.host.split("@")) && (x.auth = D.shift(), x.host = x.hostname = D.shift())), (at = at || x.host && gt.length) && !q && gt.unshift(""), gt.length ? x.pathname = gt.join("/") : (x.pathname = null, x.path = null), a.isNull(x.pathname) && a.isNull(x.search) || (x.path = (x.pathname ? x.pathname : "") + (x.search ? x.search : "")), x.auth = N.auth || x.auth, x.slashes = x.slashes || N.slashes, x.href = x.format(), x;
      }, o.prototype.parseHost = function() {
        var N = this.host, W = c.exec(N);
        W && ((W = W[0]) !== ":" && (this.port = W.substr(1)), N = N.substr(0, N.length - W.length)), N && (this.hostname = N);
      };
    }, function(e, n, s) {
      (function(r, a) {
        var o;
        /*! https://mths.be/punycode v1.4.1 by @mathias */
        (function(l) {
          n && n.nodeType, r && r.nodeType;
          var c = typeof a == "object" && a;
          c.global !== c && c.window !== c && c.self;
          var u, d = 2147483647, h = /^xn--/, p = /[^\x20-\x7E]/, m = /[\x2E\u3002\uFF0E\uFF61]/g, b = { overflow: "Overflow: input needs wider integers to process", "not-basic": "Illegal input >= 0x80 (not a basic code point)", "invalid-input": "Invalid input" }, y = Math.floor, Z = String.fromCharCode;
          function g(C) {
            throw new RangeError(b[C]);
          }
          function f(C, R) {
            for (var z = C.length, F = []; z--; ) F[z] = R(C[z]);
            return F;
          }
          function T(C, R) {
            var z = C.split("@"), F = "";
            return z.length > 1 && (F = z[0] + "@", C = z[1]), F + f((C = C.replace(m, ".")).split("."), R).join(".");
          }
          function M(C) {
            for (var R, z, F = [], P = 0, j = C.length; P < j; ) (R = C.charCodeAt(P++)) >= 55296 && R <= 56319 && P < j ? (64512 & (z = C.charCodeAt(P++))) == 56320 ? F.push(((1023 & R) << 10) + (1023 & z) + 65536) : (F.push(R), P--) : F.push(R);
            return F;
          }
          function N(C) {
            return f(C, (function(R) {
              var z = "";
              return R > 65535 && (z += Z((R -= 65536) >>> 10 & 1023 | 55296), R = 56320 | 1023 & R), z += Z(R);
            })).join("");
          }
          function W(C, R) {
            return C + 22 + 75 * (C < 26) - ((R != 0) << 5);
          }
          function x(C, R, z) {
            var F = 0;
            for (C = z ? y(C / 700) : C >> 1, C += y(C / R); C > 455; F += 36) C = y(C / 35);
            return y(F + 36 * C / (C + 38));
          }
          function V(C) {
            var R, z, F, P, j, H, B, $, A, E, ct, at = [], dt = C.length, gt = 0, Wt = 128, Zt = 72;
            for ((z = C.lastIndexOf("-")) < 0 && (z = 0), F = 0; F < z; ++F) C.charCodeAt(F) >= 128 && g("not-basic"), at.push(C.charCodeAt(F));
            for (P = z > 0 ? z + 1 : 0; P < dt; ) {
              for (j = gt, H = 1, B = 36; P >= dt && g("invalid-input"), (($ = (ct = C.charCodeAt(P++)) - 48 < 10 ? ct - 22 : ct - 65 < 26 ? ct - 65 : ct - 97 < 26 ? ct - 97 : 36) >= 36 || $ > y((d - gt) / H)) && g("overflow"), gt += $ * H, !($ < (A = B <= Zt ? 1 : B >= Zt + 26 ? 26 : B - Zt)); B += 36) H > y(d / (E = 36 - A)) && g("overflow"), H *= E;
              Zt = x(gt - j, R = at.length + 1, j == 0), y(gt / R) > d - Wt && g("overflow"), Wt += y(gt / R), gt %= R, at.splice(gt++, 0, Wt);
            }
            return N(at);
          }
          function X(C) {
            var R, z, F, P, j, H, B, $, A, E, ct, at, dt, gt, Wt, Zt = [];
            for (at = (C = M(C)).length, R = 128, z = 0, j = 72, H = 0; H < at; ++H) (ct = C[H]) < 128 && Zt.push(Z(ct));
            for (F = P = Zt.length, P && Zt.push("-"); F < at; ) {
              for (B = d, H = 0; H < at; ++H) (ct = C[H]) >= R && ct < B && (B = ct);
              for (B - R > y((d - z) / (dt = F + 1)) && g("overflow"), z += (B - R) * dt, R = B, H = 0; H < at; ++H) if ((ct = C[H]) < R && ++z > d && g("overflow"), ct == R) {
                for ($ = z, A = 36; !($ < (E = A <= j ? 1 : A >= j + 26 ? 26 : A - j)); A += 36) Wt = $ - E, gt = 36 - E, Zt.push(Z(W(E + Wt % gt, 0))), $ = y(Wt / gt);
                Zt.push(Z(W($, 0))), j = x(z, dt, F == P), z = 0, ++F;
              }
              ++z, ++R;
            }
            return Zt.join("");
          }
          u = { version: "1.4.1", ucs2: { decode: M, encode: N }, decode: V, encode: X, toASCII: function(C) {
            return T(C, (function(R) {
              return p.test(R) ? "xn--" + X(R) : R;
            }));
          }, toUnicode: function(C) {
            return T(C, (function(R) {
              return h.test(R) ? V(R.slice(4).toLowerCase()) : R;
            }));
          } }, (o = (function() {
            return u;
          }).call(n, s, n, r)) === void 0 || (r.exports = o);
        })();
      }).call(this, s(246)(e), s(78));
    }, function(e, n) {
      e.exports = function(s) {
        return s.webpackPolyfill || (s.deprecate = function() {
        }, s.paths = [], s.children || (s.children = []), Object.defineProperty(s, "loaded", { enumerable: !0, get: function() {
          return s.l;
        } }), Object.defineProperty(s, "id", { enumerable: !0, get: function() {
          return s.i;
        } }), s.webpackPolyfill = 1), s;
      };
    }, function(e, n, s) {
      e.exports = { isString: function(r) {
        return typeof r == "string";
      }, isObject: function(r) {
        return typeof r == "object" && r !== null;
      }, isNull: function(r) {
        return r === null;
      }, isNullOrUndefined: function(r) {
        return r == null;
      } };
    }, function(e, n, s) {
      n.decode = n.parse = s(249), n.encode = n.stringify = s(250);
    }, function(e, n, s) {
      function r(o, l) {
        return Object.prototype.hasOwnProperty.call(o, l);
      }
      e.exports = function(o, l, c, u) {
        l = l || "&", c = c || "=";
        var d = {};
        if (typeof o != "string" || o.length === 0) return d;
        var h = /\+/g;
        o = o.split(l);
        var p = 1e3;
        u && typeof u.maxKeys == "number" && (p = u.maxKeys);
        var m = o.length;
        p > 0 && m > p && (m = p);
        for (var b = 0; b < m; ++b) {
          var y, Z, g, f, T = o[b].replace(h, "%20"), M = T.indexOf(c);
          M >= 0 ? (y = T.substr(0, M), Z = T.substr(M + 1)) : (y = T, Z = ""), g = decodeURIComponent(y), f = decodeURIComponent(Z), r(d, g) ? a(d[g]) ? d[g].push(f) : d[g] = [d[g], f] : d[g] = f;
        }
        return d;
      };
      var a = Array.isArray || function(o) {
        return Object.prototype.toString.call(o) === "[object Array]";
      };
    }, function(e, n, s) {
      var r = function(c) {
        switch (typeof c) {
          case "string":
            return c;
          case "boolean":
            return c ? "true" : "false";
          case "number":
            return isFinite(c) ? c : "";
          default:
            return "";
        }
      };
      e.exports = function(c, u, d, h) {
        return u = u || "&", d = d || "=", c === null && (c = void 0), typeof c == "object" ? o(l(c), (function(p) {
          var m = encodeURIComponent(r(p)) + d;
          return a(c[p]) ? o(c[p], (function(b) {
            return m + encodeURIComponent(r(b));
          })).join(u) : m + encodeURIComponent(r(c[p]));
        })).join(u) : h ? encodeURIComponent(r(h)) + d + encodeURIComponent(r(c)) : "";
      };
      var a = Array.isArray || function(c) {
        return Object.prototype.toString.call(c) === "[object Array]";
      };
      function o(c, u) {
        if (c.map) return c.map(u);
        for (var d = [], h = 0; h < c.length; h++) d.push(u(c[h], h));
        return d;
      }
      var l = Object.keys || function(c) {
        var u = [];
        for (var d in c) Object.prototype.hasOwnProperty.call(c, d) && u.push(d);
        return u;
      };
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(52);
      n.attr_setAnExistingAttributeValue = function(a, o) {
        a._element === null ? a._value = o : r.element_change(a, a._element, o);
      };
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(108), a = s(30), o = s(52);
      n.tokenList_validationSteps = function(l, c) {
        if (!a.dom_hasSupportedTokens(l._attribute._localName)) throw new TypeError("There are no supported tokens defined for attribute name: '" + l._attribute._localName + "'.");
        return a.dom_getSupportedTokens(l._attribute._localName).has(c.toLowerCase());
      }, n.tokenList_updateSteps = function(l) {
        (l._element.hasAttribute(l._attribute._localName) || l._tokenSet.size !== 0) && o.element_setAnAttributeValue(l._element, l._attribute._localName, r.orderedSet_serialize(l._tokenSet));
      }, n.tokenList_serializeSteps = function(l) {
        return o.element_getAnAttributeValue(l._element, l._attribute._localName);
      };
    }, function(e, n, s) {
      var r = this && this.__values || function(l) {
        var c = typeof Symbol == "function" && Symbol.iterator, u = c && l[c], d = 0;
        if (u) return u.call(l);
        if (l && typeof l.length == "number") return { next: function() {
          return l && d >= l.length && (l = void 0), { value: l && l[d++], done: !l };
        } };
        throw new TypeError(c ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = s(1);
      function o(l) {
        return a.isBoolean(l) ? l : l.capture || !1;
      }
      n.eventTarget_flatten = o, n.eventTarget_flattenMore = function(l) {
        var c = o(l), u = !1, d = !1;
        return a.isBoolean(l) || (u = l.once || !1, d = l.passive || !1), [c, d, u];
      }, n.eventTarget_addEventListener = function(l, c) {
        if (c.callback !== null) {
          for (var u = 0; u < l._eventListenerList.length; u++) {
            var d = l._eventListenerList[u];
            if (d.type === c.type && d.callback.handleEvent === c.callback.handleEvent && d.capture === c.capture) return;
          }
          l._eventListenerList.push(c);
        }
      }, n.eventTarget_removeEventListener = function(l, c, u) {
        c.removed = !0, l._eventListenerList.splice(u, 1);
      }, n.eventTarget_removeAllEventListeners = function(l) {
        var c, u;
        try {
          for (var d = r(l._eventListenerList), h = d.next(); !h.done; h = d.next())
            h.value.removed = !0;
        } catch (p) {
          c = { error: p };
        } finally {
          try {
            h && !h.done && (u = d.return) && u.call(d);
          } finally {
            if (c) throw c.error;
          }
        }
        l._eventListenerList.length = 0;
      };
    }, function(e, n, s) {
      var r = this && this.__values || function(l) {
        var c = typeof Symbol == "function" && Symbol.iterator, u = c && l[c], d = 0;
        if (u) return u.call(l);
        if (l && typeof l.length == "number") return { next: function() {
          return l && d >= l.length && (l = void 0), { value: l && l[d++], done: !l };
        } };
        throw new TypeError(c ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = s(1), o = s(29);
      n.parentNode_convertNodesIntoANode = function(l, c) {
        for (var u, d, h = null, p = 0; p < l.length; p++) {
          var m = l[p];
          if (a.isString(m)) {
            var b = o.create_text(c, m);
            l[p] = b;
          }
        }
        if (l.length === 1) h = l[0];
        else {
          var y = h = o.create_documentFragment(c);
          try {
            for (var Z = r(l), g = Z.next(); !g.done; g = Z.next())
              m = g.value, y.appendChild(m);
          } catch (f) {
            u = { error: f };
          } finally {
            try {
              g && !g.done && (d = Z.return) && d.call(Z);
            } finally {
              if (u) throw u.error;
            }
          }
        }
        return h;
      };
    }, function(e, n, s) {
      var r = this && this.__values || function(W) {
        var x = typeof Symbol == "function" && Symbol.iterator, V = x && W[x], X = 0;
        if (V) return V.call(W);
        if (W && typeof W.length == "number") return { next: function() {
          return W && X >= W.length && (W = void 0), { value: W && W[X++], done: !W };
        } };
        throw new TypeError(x ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }, a = this && this.__read || function(W, x) {
        var V = typeof Symbol == "function" && W[Symbol.iterator];
        if (!V) return W;
        var X, C, R = V.call(W), z = [];
        try {
          for (; (x === void 0 || x-- > 0) && !(X = R.next()).done; ) z.push(X.value);
        } catch (F) {
          C = { error: F };
        } finally {
          try {
            X && !X.done && (V = R.return) && V.call(R);
          } finally {
            if (C) throw C.error;
          }
        }
        return z;
      }, o = this && this.__spread || function() {
        for (var W = [], x = 0; x < arguments.length; x++) W = W.concat(a(arguments[x]));
        return W;
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var l = s(2), c = s(9), u = s(3), d = s(29), h = s(17), p = s(175), m = s(107), b = s(176), y = s(37), Z = s(177);
      function g(W) {
        return W._startNode === W._endNode && W._startOffset === W._endOffset;
      }
      function f(W) {
        return h.tree_rootNode(W._startNode);
      }
      function T(W, x) {
        return h.tree_rootNode(W) === f(x) && p.boundaryPoint_position([W, 0], x._start) === l.BoundaryPosition.After && p.boundaryPoint_position([W, h.tree_nodeLength(W)], x._end) === l.BoundaryPosition.Before;
      }
      function M(W, x) {
        var V = h.tree_isAncestorOf(x._startNode, W, !0), X = h.tree_isAncestorOf(x._endNode, W, !0);
        return V && !X || !V && X;
      }
      function N(W) {
        var x, V, X, C, R, z, F = d.create_documentFragment(W._startNode._nodeDocument);
        if (g(W)) return F;
        var P = W._startNode, j = W._startOffset, H = W._endNode, B = W._endOffset;
        if (P === H && u.Guard.isCharacterDataNode(P)) return (nt = b.node_clone(P))._data = m.characterData_substringData(P, j, B - j), y.mutation_append(nt, F), m.characterData_replaceData(P, j, B - j, ""), F;
        for (var $ = P; !h.tree_isAncestorOf(H, $, !0); ) {
          if ($._parent === null) throw new Error("Parent node  is null.");
          $ = $._parent;
        }
        var A = null;
        if (!h.tree_isAncestorOf(H, P, !0)) try {
          for (var E = r($._children), ct = E.next(); !ct.done; ct = E.next())
            if (M(Wt = ct.value, W)) {
              A = Wt;
              break;
            }
        } catch (lt) {
          x = { error: lt };
        } finally {
          try {
            ct && !ct.done && (V = E.return) && V.call(E);
          } finally {
            if (x) throw x.error;
          }
        }
        var at = null;
        if (!h.tree_isAncestorOf(P, H, !0)) for (var dt = o($._children), gt = dt.length - 1; gt > 0; gt--) {
          var Wt;
          if (M(Wt = dt[gt], W)) {
            at = Wt;
            break;
          }
        }
        var Zt, Gt, Tt = [];
        try {
          for (var Q = r($._children), D = Q.next(); !D.done; D = Q.next())
            if (T(ht = D.value, W)) {
              if (u.Guard.isDocumentTypeNode(ht)) throw new c.HierarchyRequestError();
              Tt.push(ht);
            }
        } catch (lt) {
          X = { error: lt };
        } finally {
          try {
            D && !D.done && (C = Q.return) && C.call(Q);
          } finally {
            if (X) throw X.error;
          }
        }
        if (h.tree_isAncestorOf(H, P, !0)) Zt = P, Gt = j;
        else {
          for (var q = P; q._parent !== null && !h.tree_isAncestorOf(H, q._parent); ) q = q._parent;
          if (q._parent === null) throw new Error("Parent node is null.");
          Zt = q._parent, Gt = 1 + h.tree_index(q);
        }
        if (u.Guard.isCharacterDataNode(A)) (nt = b.node_clone(P))._data = m.characterData_substringData(P, j, h.tree_nodeLength(P) - j), y.mutation_append(nt, F), m.characterData_replaceData(P, j, h.tree_nodeLength(P) - j, "");
        else if (A !== null) {
          var nt = b.node_clone(A);
          y.mutation_append(nt, F);
          var et = N(d.create_range([P, j], [A, h.tree_nodeLength(A)]));
          y.mutation_append(et, nt);
        }
        try {
          for (var ot = r(Tt), it = ot.next(); !it.done; it = ot.next()) {
            var ht = it.value;
            y.mutation_append(ht, F);
          }
        } catch (lt) {
          R = { error: lt };
        } finally {
          try {
            it && !it.done && (z = ot.return) && z.call(ot);
          } finally {
            if (R) throw R.error;
          }
        }
        return u.Guard.isCharacterDataNode(at) ? ((nt = b.node_clone(H))._data = m.characterData_substringData(H, 0, B), y.mutation_append(nt, F), m.characterData_replaceData(H, 0, B, "")) : at !== null && (nt = b.node_clone(at), y.mutation_append(nt, F), et = N(d.create_range([at, 0], [H, B])), y.mutation_append(et, nt)), W._start = [Zt, Gt], W._end = [Zt, Gt], F;
      }
      n.range_collapsed = g, n.range_root = f, n.range_isContained = T, n.range_isPartiallyContained = M, n.range_setTheStart = function(W, x, V) {
        if (u.Guard.isDocumentTypeNode(x)) throw new c.InvalidNodeTypeError();
        if (V > h.tree_nodeLength(x)) throw new c.IndexSizeError();
        var X = [x, V];
        f(W) === h.tree_rootNode(x) && p.boundaryPoint_position(X, W._end) !== l.BoundaryPosition.After || (W._end = X), W._start = X;
      }, n.range_setTheEnd = function(W, x, V) {
        if (u.Guard.isDocumentTypeNode(x)) throw new c.InvalidNodeTypeError();
        if (V > h.tree_nodeLength(x)) throw new c.IndexSizeError();
        var X = [x, V];
        f(W) === h.tree_rootNode(x) && p.boundaryPoint_position(X, W._start) !== l.BoundaryPosition.Before || (W._start = X), W._end = X;
      }, n.range_select = function(W, x) {
        var V = W._parent;
        if (V === null) throw new c.InvalidNodeTypeError();
        var X = h.tree_index(W);
        x._start = [V, X], x._end = [V, X + 1];
      }, n.range_extract = N, n.range_cloneTheContents = function W(x) {
        var V, X, C, R, z, F, P = d.create_documentFragment(x._startNode._nodeDocument);
        if (g(x)) return P;
        var j = x._startNode, H = x._startOffset, B = x._endNode, $ = x._endOffset;
        j === B && u.Guard.isCharacterDataNode(j) && ((D = b.node_clone(j))._data = m.characterData_substringData(j, H, $ - H), y.mutation_append(D, P));
        for (var A = j; !h.tree_isAncestorOf(B, A, !0); ) {
          if (A._parent === null) throw new Error("Parent node  is null.");
          A = A._parent;
        }
        var E = null;
        if (!h.tree_isAncestorOf(B, j, !0)) try {
          for (var ct = r(A._children), at = ct.next(); !at.done; at = ct.next())
            if (M(Zt = at.value, x)) {
              E = Zt;
              break;
            }
        } catch (it) {
          V = { error: it };
        } finally {
          try {
            at && !at.done && (X = ct.return) && X.call(ct);
          } finally {
            if (V) throw V.error;
          }
        }
        var dt = null;
        if (!h.tree_isAncestorOf(j, B, !0)) for (var gt = o(A._children), Wt = gt.length - 1; Wt > 0; Wt--) {
          var Zt;
          if (M(Zt = gt[Wt], x)) {
            dt = Zt;
            break;
          }
        }
        var Gt = [];
        try {
          for (var Tt = r(A._children), Q = Tt.next(); !Q.done; Q = Tt.next())
            if (T(ot = Q.value, x)) {
              if (u.Guard.isDocumentTypeNode(ot)) throw new c.HierarchyRequestError();
              Gt.push(ot);
            }
        } catch (it) {
          C = { error: it };
        } finally {
          try {
            Q && !Q.done && (R = Tt.return) && R.call(Tt);
          } finally {
            if (C) throw C.error;
          }
        }
        if (u.Guard.isCharacterDataNode(E)) (D = b.node_clone(j))._data = m.characterData_substringData(j, H, h.tree_nodeLength(j) - H), y.mutation_append(D, P);
        else if (E !== null) {
          var D = b.node_clone(E);
          y.mutation_append(D, P);
          var q = W(d.create_range([j, H], [E, h.tree_nodeLength(E)]));
          y.mutation_append(q, D);
        }
        try {
          for (var nt = r(Gt), et = nt.next(); !et.done; et = nt.next()) {
            var ot = et.value, D = b.node_clone(ot);
            y.mutation_append(D, P);
          }
        } catch (it) {
          z = { error: it };
        } finally {
          try {
            et && !et.done && (F = nt.return) && F.call(nt);
          } finally {
            if (z) throw z.error;
          }
        }
        return u.Guard.isCharacterDataNode(dt) ? ((D = b.node_clone(B))._data = m.characterData_substringData(B, 0, $), y.mutation_append(D, P)) : dt !== null && (D = b.node_clone(dt), P.append(D), q = N(d.create_range([dt, 0], [B, $])), y.mutation_append(q, D)), P;
      }, n.range_insert = function(W, x) {
        var V, X;
        if (u.Guard.isProcessingInstructionNode(x._startNode) || u.Guard.isCommentNode(x._startNode) || u.Guard.isTextNode(x._startNode) && x._startNode._parent === null || x._startNode === W) throw new c.HierarchyRequestError();
        var C, R = null;
        if (u.Guard.isTextNode(x._startNode)) R = x._startNode;
        else {
          var z = 0;
          try {
            for (var F = r(x._startNode._children), P = F.next(); !P.done; P = F.next()) {
              var j = P.value;
              if (z === x._startOffset) {
                R = j;
                break;
              }
              z++;
            }
          } catch (B) {
            V = { error: B };
          } finally {
            try {
              P && !P.done && (X = F.return) && X.call(F);
            } finally {
              if (V) throw V.error;
            }
          }
        }
        if (R === null) C = x._startNode;
        else {
          if (R._parent === null) throw new Error("Parent node is null.");
          C = R._parent;
        }
        y.mutation_ensurePreInsertionValidity(W, C, R), u.Guard.isTextNode(x._startNode) && (R = Z.text_split(x._startNode, x._startOffset)), W === R && (R = W._nextSibling), W._parent !== null && y.mutation_remove(W, W._parent);
        var H = R === null ? h.tree_nodeLength(C) : h.tree_index(R);
        u.Guard.isDocumentFragmentNode(W) ? H += h.tree_nodeLength(W) : H++, y.mutation_preInsert(W, C, R), g(x) && (x._end = [C, H]);
      }, n.range_getContainedNodes = function(W) {
        var x;
        return (x = {})[Symbol.iterator] = function() {
          var V = W.commonAncestorContainer, X = h.tree_getFirstDescendantNode(V);
          return { next: function() {
            for (; X && !T(X, W); ) X = h.tree_getNextDescendantNode(V, X);
            if (X === null) return { done: !0, value: null };
            var C = { done: !1, value: X };
            return X = h.tree_getNextDescendantNode(V, X), C;
          } };
        }, x;
      }, n.range_getPartiallyContainedNodes = function(W) {
        var x;
        return (x = {})[Symbol.iterator] = function() {
          var V = W.commonAncestorContainer, X = h.tree_getFirstDescendantNode(V);
          return { next: function() {
            for (; X && !M(X, W); ) X = h.tree_getNextDescendantNode(V, X);
            if (X === null) return { done: !0, value: null };
            var C = { done: !1, value: X };
            return X = h.tree_getNextDescendantNode(V, X), C;
          } };
        }, x;
      };
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(9);
      n.selectors_scopeMatchASelectorsString = function(a, o) {
        throw new r.NotSupportedError();
      };
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(2), a = s(105);
      n.treeWalker_traverseChildren = function(o, l) {
        for (var c = l ? o._current._firstChild : o._current._lastChild; c !== null; ) {
          var u = a.traversal_filter(o, c);
          if (u === r.FilterResult.Accept) return o._current = c, c;
          if (u === r.FilterResult.Skip) {
            var d = l ? c._firstChild : c._lastChild;
            if (d !== null) {
              c = d;
              continue;
            }
          }
          for (; c !== null; ) {
            var h = l ? c._nextSibling : c._previousSibling;
            if (h !== null) {
              c = h;
              break;
            }
            var p = c._parent;
            if (p === null || p === o._root || p === o._current) return null;
            c = p;
          }
        }
        return null;
      }, n.treeWalker_traverseSiblings = function(o, l) {
        var c = o._current;
        if (c === o._root) return null;
        for (; ; ) {
          for (var u = l ? c._nextSibling : c._previousSibling; u !== null; ) {
            c = u;
            var d = a.traversal_filter(o, c);
            if (d === r.FilterResult.Accept) return o._current = c, c;
            u = l ? c._firstChild : c._lastChild, d !== r.FilterResult.Reject && u !== null || (u = l ? c._nextSibling : c._previousSibling);
          }
          if ((c = c._parent) === null || c === o._root || a.traversal_filter(o, c) === r.FilterResult.Accept) return null;
        }
      };
    }, function(e, n, s) {
      s(89), s(74);
      var r, a = this && this.__extends || (r = function(h, p) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(m, b) {
          m.__proto__ = b;
        } || function(m, b) {
          for (var y in b) b.hasOwnProperty(y) && (m[y] = b[y]);
        })(h, p);
      }, function(h, p) {
        function m() {
          this.constructor = h;
        }
        r(h, p), h.prototype = p === null ? Object.create(p) : (m.prototype = p.prototype, new m());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(1), l = s(2), c = s(50), u = s(3), d = (function(h) {
        function p(m, b) {
          var y = h.call(this, m) || this;
          return y._indentation = {}, y._lengthToLastNewline = 0, y._writerOptions = o.applyDefaults(b, { wellFormed: !1, headless: !1, prettyPrint: !1, indent: "  ", newline: `
`, offset: 0, width: 0, allowEmptyTags: !1, indentTextOnlyNodes: !1, spaceBeforeSlash: !1 }), y;
        }
        return a(p, h), p.prototype.serialize = function(m) {
          return this._refs = { suppressPretty: !1, emptyNode: !1, markup: "" }, m.nodeType !== l.NodeType.Document || this._writerOptions.headless || this.declaration(this._builderOptions.version, this._builderOptions.encoding, this._builderOptions.standalone), this.serializeNode(m, this._writerOptions.wellFormed), this._writerOptions.prettyPrint && this._refs.markup.slice(-this._writerOptions.newline.length) === this._writerOptions.newline && (this._refs.markup = this._refs.markup.slice(0, -this._writerOptions.newline.length)), this._refs.markup;
        }, p.prototype.declaration = function(m, b, y) {
          this._beginLine(), this._refs.markup += '<?xml version="' + m + '"', b !== void 0 && (this._refs.markup += ' encoding="' + b + '"'), y !== void 0 && (this._refs.markup += ' standalone="' + (y ? "yes" : "no") + '"'), this._refs.markup += "?>", this._endLine();
        }, p.prototype.docType = function(m, b, y) {
          this._beginLine(), this._refs.markup += b && y ? "<!DOCTYPE " + m + ' PUBLIC "' + b + '" "' + y + '">' : b ? "<!DOCTYPE " + m + ' PUBLIC "' + b + '">' : y ? "<!DOCTYPE " + m + ' SYSTEM "' + y + '">' : "<!DOCTYPE " + m + ">", this._endLine();
        }, p.prototype.openTagBegin = function(m) {
          this._beginLine(), this._refs.markup += "<" + m;
        }, p.prototype.openTagEnd = function(m, b, y) {
          if (this._refs.suppressPretty = !1, this._refs.emptyNode = !1, this._writerOptions.prettyPrint && !b && !y) {
            for (var Z = !0, g = !0, f = this.currentNode.firstChild, T = 0, M = 0; f; ) {
              if (u.Guard.isExclusiveTextNode(f)) M++;
              else {
                if (!u.Guard.isCDATASectionNode(f)) {
                  Z = !1, g = !1;
                  break;
                }
                T++;
              }
              f.data !== "" && (g = !1), f = f.nextSibling;
            }
            this._refs.suppressPretty = !this._writerOptions.indentTextOnlyNodes && Z && (T <= 1 && M === 0 || T === 0), this._refs.emptyNode = g;
          }
          (y || b || this._refs.emptyNode) && this._writerOptions.allowEmptyTags ? this._refs.markup += "></" + m + ">" : this._refs.markup += y ? " />" : b || this._refs.emptyNode ? this._writerOptions.spaceBeforeSlash ? " />" : "/>" : ">", this._endLine();
        }, p.prototype.closeTag = function(m) {
          this._refs.emptyNode || (this._beginLine(), this._refs.markup += "</" + m + ">"), this._refs.suppressPretty = !1, this._refs.emptyNode = !1, this._endLine();
        }, p.prototype.attribute = function(m, b) {
          var y = m + '="' + b + '"';
          this._writerOptions.prettyPrint && this._writerOptions.width > 0 && this._refs.markup.length - this._lengthToLastNewline + 1 + y.length > this._writerOptions.width ? (this._endLine(), this._beginLine(), this._refs.markup += this._indent(1) + y) : this._refs.markup += " " + y;
        }, p.prototype.text = function(m) {
          m !== "" && (this._beginLine(), this._refs.markup += m, this._endLine());
        }, p.prototype.cdata = function(m) {
          m !== "" && (this._beginLine(), this._refs.markup += "<![CDATA[" + m + "]]>", this._endLine());
        }, p.prototype.comment = function(m) {
          this._beginLine(), this._refs.markup += "<!--" + m + "-->", this._endLine();
        }, p.prototype.instruction = function(m, b) {
          this._beginLine(), this._refs.markup += "<?" + (b === "" ? m : m + " " + b) + "?>", this._endLine();
        }, p.prototype._beginLine = function() {
          this._writerOptions.prettyPrint && !this._refs.suppressPretty && (this._refs.markup += this._indent(this._writerOptions.offset + this.level));
        }, p.prototype._endLine = function() {
          this._writerOptions.prettyPrint && !this._refs.suppressPretty && (this._refs.markup += this._writerOptions.newline, this._lengthToLastNewline = this._refs.markup.length);
        }, p.prototype._indent = function(m) {
          if (m <= 0) return "";
          if (this._indentation[m] !== void 0) return this._indentation[m];
          var b = this._writerOptions.indent.repeat(m);
          return this._indentation[m] = b, b;
        }, p;
      })(c.BaseWriter);
      n.XMLWriter = d;
    }, function(e, n, s) {
      var r = s(47), a = s(35);
      e.exports = "".repeat || function(o) {
        var l = String(a(this)), c = "", u = r(o);
        if (u < 0 || u == 1 / 0) throw RangeError("Wrong number of repetitions");
        for (; u > 0; (u >>>= 1) && (l += l)) 1 & u && (c += l);
        return c;
      };
    }, function(e, n, s) {
      s(31), s(32), s(33), s(19), s(178), s(20), s(22), s(23);
      var r, a = this && this.__extends || (r = function(d, h) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, m) {
          p.__proto__ = m;
        } || function(p, m) {
          for (var b in m) m.hasOwnProperty(b) && (p[b] = m[b]);
        })(d, h);
      }, function(d, h) {
        function p() {
          this.constructor = d;
        }
        r(d, h), d.prototype = h === null ? Object.create(h) : (p.prototype = h.prototype, new p());
      }), o = this && this.__values || function(d) {
        var h = typeof Symbol == "function" && Symbol.iterator, p = h && d[h], m = 0;
        if (p) return p.call(d);
        if (d && typeof d.length == "number") return { next: function() {
          return d && m >= d.length && (d = void 0), { value: d && d[m++], done: !d };
        } };
        throw new TypeError(h ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var l = s(67), c = s(1), u = (function(d) {
        function h(p, m) {
          var b = d.call(this, p) || this;
          return b._writerOptions = c.applyDefaults(m, { wellFormed: !1, prettyPrint: !1, indent: "  ", newline: `
`, offset: 0, group: !1, verbose: !1 }), b;
        }
        return a(h, d), h.prototype.serialize = function(p) {
          var m = c.applyDefaults(this._writerOptions, { format: "object", wellFormed: !1 }), b = new l.ObjectWriter(this._builderOptions, m).serialize(p);
          return this._beginLine(this._writerOptions, 0) + this._convertObject(b, this._writerOptions);
        }, h.prototype._convertObject = function(p, m, b) {
          var y, Z, g = this;
          b === void 0 && (b = 0);
          var f = "", T = this._isLeafNode(p);
          if (c.isArray(p)) {
            f += "[";
            var M = p.length, N = 0;
            try {
              for (var W = o(p), x = W.next(); !x.done; x = W.next()) {
                var V = x.value;
                f += this._endLine(m, b + 1) + this._beginLine(m, b + 1) + this._convertObject(V, m, b + 1), N < M - 1 && (f += ","), N++;
              }
            } catch (R) {
              y = { error: R };
            } finally {
              try {
                x && !x.done && (Z = W.return) && Z.call(W);
              } finally {
                if (y) throw y.error;
              }
            }
            f += this._endLine(m, b) + this._beginLine(m, b), f += "]";
          } else if (c.isObject(p)) {
            f += "{";
            var X = c.objectLength(p), C = 0;
            c.forEachObject(p, (function(R, z) {
              T && m.prettyPrint ? f += " " : f += g._endLine(m, b + 1) + g._beginLine(m, b + 1), f += g._key(R), m.prettyPrint && (f += " "), f += g._convertObject(z, m, b + 1), C < X - 1 && (f += ","), C++;
            }), this), T && m.prettyPrint ? f += " " : f += this._endLine(m, b) + this._beginLine(m, b), f += "}";
          } else f += this._val(p);
          return f;
        }, h.prototype._beginLine = function(p, m) {
          if (!p.prettyPrint) return "";
          var b = p.offset + m + 1;
          return b > 0 ? new Array(b).join(p.indent) : "";
        }, h.prototype._endLine = function(p, m) {
          return p.prettyPrint ? p.newline : "";
        }, h.prototype._key = function(p) {
          return '"' + p + '":';
        }, h.prototype._val = function(p) {
          return JSON.stringify(p);
        }, h.prototype._isLeafNode = function(p) {
          return this._descendantCount(p) <= 1;
        }, h.prototype._descendantCount = function(p, m) {
          var b = this;
          return m === void 0 && (m = 0), c.isArray(p) ? c.forEachArray(p, (function(y) {
            return m += b._descendantCount(y, m);
          }), this) : c.isObject(p) ? c.forEachObject(p, (function(y, Z) {
            return m += b._descendantCount(Z, m);
          }), this) : m++, m;
        }, h;
      })(s(50).BaseWriter);
      n.JSONWriter = u;
    }, function(e, n, s) {
      s(31), s(32), s(33), s(19), s(178), s(89), s(20), s(22), s(23);
      var r, a = this && this.__extends || (r = function(d, h) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, m) {
          p.__proto__ = m;
        } || function(p, m) {
          for (var b in m) m.hasOwnProperty(b) && (p[b] = m[b]);
        })(d, h);
      }, function(d, h) {
        function p() {
          this.constructor = d;
        }
        r(d, h), d.prototype = h === null ? Object.create(h) : (p.prototype = h.prototype, new p());
      }), o = this && this.__values || function(d) {
        var h = typeof Symbol == "function" && Symbol.iterator, p = h && d[h], m = 0;
        if (p) return p.call(d);
        if (d && typeof d.length == "number") return { next: function() {
          return d && m >= d.length && (d = void 0), { value: d && d[m++], done: !d };
        } };
        throw new TypeError(h ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var l = s(67), c = s(1), u = (function(d) {
        function h(p, m) {
          var b = d.call(this, p) || this;
          if (b._writerOptions = c.applyDefaults(m, { wellFormed: !1, indent: "  ", newline: `
`, offset: 0, group: !1, verbose: !1 }), b._writerOptions.indent.length < 2) throw new Error("YAML indententation string must be at least two characters long.");
          if (b._writerOptions.offset < 0) throw new Error("YAML offset should be zero or a positive number.");
          return b;
        }
        return a(h, d), h.prototype.serialize = function(p) {
          var m = c.applyDefaults(this._writerOptions, { format: "object", wellFormed: !1 }), b = new l.ObjectWriter(this._builderOptions, m).serialize(p), y = this._beginLine(this._writerOptions, 0) + "---" + this._endLine(this._writerOptions) + this._convertObject(b, this._writerOptions, 0);
          return y.slice(-this._writerOptions.newline.length) === this._writerOptions.newline && (y = y.slice(0, -this._writerOptions.newline.length)), y;
        }, h.prototype._convertObject = function(p, m, b, y) {
          var Z, g, f = this;
          y === void 0 && (y = !1);
          var T = "";
          if (c.isArray(p)) try {
            for (var M = o(p), N = M.next(); !N.done; N = M.next()) {
              var W = N.value;
              T += this._beginLine(m, b, !0), c.isObject(W) ? c.isEmpty(W) ? T += '""' + this._endLine(m) : T += this._convertObject(W, m, b, !0) : T += this._val(W) + this._endLine(m);
            }
          } catch (x) {
            Z = { error: x };
          } finally {
            try {
              N && !N.done && (g = M.return) && g.call(M);
            } finally {
              if (Z) throw Z.error;
            }
          }
          else c.forEachObject(p, (function(x, V) {
            y ? (T += f._key(x), y = !1) : T += f._beginLine(m, b) + f._key(x), c.isObject(V) ? c.isEmpty(V) ? T += ' ""' + f._endLine(m) : T += f._endLine(m) + f._convertObject(V, m, b + 1) : T += " " + f._val(V) + f._endLine(m);
          }), this);
          return T;
        }, h.prototype._beginLine = function(p, m, b) {
          b === void 0 && (b = !1);
          var y = p.offset + m + 1, Z = new Array(y).join(p.indent);
          return b ? Z.substr(0, Z.length - 2) + "-" + Z.substr(-1, 1) : Z;
        }, h.prototype._endLine = function(p) {
          return p.newline;
        }, h.prototype._key = function(p) {
          return '"' + p + '":';
        }, h.prototype._val = function(p) {
          return JSON.stringify(p);
        }, h;
      })(s(50).BaseWriter);
      n.YAMLWriter = u;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 }), s(110).dom.setFeatures(!0);
      var r = s(110);
      n.DOMImplementation = r.DOMImplementation;
      var a = s(271);
      n.DOMParser = a.DOMParser;
      var o = s(274);
      n.XMLSerializer = o.XMLSerializer;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(3), a = s(0), o = (function() {
        function l() {
        }
        return l.prototype.before = function() {
          for (var c = [], u = 0; u < arguments.length; u++) c[u] = arguments[u];
          var d = r.Cast.asNode(this), h = d._parent;
          if (h !== null) {
            for (var p = d._previousSibling, m = !0; m && p; ) {
              m = !1;
              for (var b = 0; b < c.length; b++) {
                var y = c[b];
                if (y === p) {
                  p = p._previousSibling, m = !0;
                  break;
                }
              }
            }
            var Z = a.parentNode_convertNodesIntoANode(c, d._nodeDocument);
            p = p === null ? h._firstChild : p._nextSibling, a.mutation_preInsert(Z, h, p);
          }
        }, l.prototype.after = function() {
          for (var c = [], u = 0; u < arguments.length; u++) c[u] = arguments[u];
          var d = r.Cast.asNode(this), h = d._parent;
          if (h) {
            for (var p = d._nextSibling, m = !0; m && p; ) {
              m = !1;
              for (var b = 0; b < c.length; b++) {
                var y = c[b];
                if (y === p) {
                  p = p._nextSibling, m = !0;
                  break;
                }
              }
            }
            var Z = a.parentNode_convertNodesIntoANode(c, d._nodeDocument);
            a.mutation_preInsert(Z, h, p);
          }
        }, l.prototype.replaceWith = function() {
          for (var c = [], u = 0; u < arguments.length; u++) c[u] = arguments[u];
          var d = r.Cast.asNode(this), h = d._parent;
          if (h) {
            for (var p = d._nextSibling, m = !0; m && p; ) {
              m = !1;
              for (var b = 0; b < c.length; b++) {
                var y = c[b];
                if (y === p) {
                  p = p._nextSibling, m = !0;
                  break;
                }
              }
            }
            var Z = a.parentNode_convertNodesIntoANode(c, d._nodeDocument);
            d._parent === h ? a.mutation_replace(d, Z, h) : a.mutation_preInsert(Z, h, p);
          }
        }, l.prototype.remove = function() {
          var c = r.Cast.asNode(this), u = c._parent;
          u && a.mutation_remove(c, u);
        }, l;
      })();
      n.ChildNodeImpl = o;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = function() {
      };
      n.DocumentOrShadowRootImpl = r;
    }, function(e, n, s) {
      var r = this && this.__values || function(u) {
        var d = typeof Symbol == "function" && Symbol.iterator, h = d && u[d], p = 0;
        if (h) return h.call(u);
        if (u && typeof u.length == "number") return { next: function() {
          return u && p >= u.length && (u = void 0), { value: u && u[p++], done: !u };
        } };
        throw new TypeError(d ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = s(6), o = s(3), l = s(7), c = (function() {
        function u(d) {
          this._nodeList = [], this._recordQueue = [], this._callback = d;
          var h = a.dom.window;
          l.set.append(h._mutationObservers, this);
        }
        return u.prototype.observe = function(d, h) {
          var p, m;
          if ((h = h || { childList: !1, subtree: !1 }).attributeOldValue === void 0 && h.attributeFilter === void 0 || h.attributes !== void 0 || (h.attributes = !0), h.characterDataOldValue !== void 0 && h.characterData === void 0 && (h.characterData = !0), !h.childList && !h.attributes && !h.characterData) throw new TypeError();
          if (h.attributeOldValue && !h.attributes) throw new TypeError();
          if (h.attributeFilter !== void 0 && !h.attributes) throw new TypeError();
          if (h.characterDataOldValue && !h.characterData) throw new TypeError();
          var b = !1, y = h, Z = function(M) {
            var N, W;
            if (M.observer === g) {
              b = !0;
              try {
                for (var x = (N = void 0, r(g._nodeList)), V = x.next(); !V.done; V = x.next()) {
                  var X = V.value;
                  l.list.remove(X._registeredObserverList, (function(C) {
                    return o.Guard.isTransientRegisteredObserver(C) && C.source === M;
                  }));
                }
              } catch (C) {
                N = { error: C };
              } finally {
                try {
                  V && !V.done && (W = x.return) && W.call(x);
                } finally {
                  if (N) throw N.error;
                }
              }
              M.options = y;
            }
          }, g = this;
          try {
            for (var f = r(d._registeredObserverList), T = f.next(); !T.done; T = f.next())
              Z(T.value);
          } catch (M) {
            p = { error: M };
          } finally {
            try {
              T && !T.done && (m = f.return) && m.call(f);
            } finally {
              if (p) throw p.error;
            }
          }
          b || (d._registeredObserverList.push({ observer: this, options: h }), this._nodeList.push(d));
        }, u.prototype.disconnect = function() {
          var d, h, p = this;
          try {
            for (var m = r(this._nodeList), b = m.next(); !b.done; b = m.next()) {
              var y = b.value;
              l.list.remove(y._registeredObserverList, (function(Z) {
                return Z.observer === p;
              }));
            }
          } catch (Z) {
            d = { error: Z };
          } finally {
            try {
              b && !b.done && (h = m.return) && h.call(m);
            } finally {
              if (d) throw d.error;
            }
          }
          this._recordQueue = [];
        }, u.prototype.takeRecords = function() {
          var d = this._recordQueue;
          return this._recordQueue = [], d;
        }, u;
      })();
      n.MutationObserverImpl = c;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(3), a = (function() {
        function o() {
        }
        return Object.defineProperty(o.prototype, "previousElementSibling", { get: function() {
          for (var l = r.Cast.asNode(this)._previousSibling; l; ) {
            if (r.Guard.isElementNode(l)) return l;
            l = l._previousSibling;
          }
          return null;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(o.prototype, "nextElementSibling", { get: function() {
          for (var l = r.Cast.asNode(this)._nextSibling; l; ) {
            if (r.Guard.isElementNode(l)) return l;
            l = l._nextSibling;
          }
          return null;
        }, enumerable: !0, configurable: !0 }), o;
      })();
      n.NonDocumentTypeChildNodeImpl = a;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(3), a = s(0), o = (function() {
        function l() {
        }
        return l.prototype.getElementById = function(c) {
          for (var u = a.tree_getFirstDescendantNode(r.Cast.asNode(this), !1, !1, (function(d) {
            return r.Guard.isElementNode(d);
          })); u !== null; ) {
            if (u._uniqueIdentifier === c) return u;
            u = a.tree_getNextDescendantNode(r.Cast.asNode(this), u, !1, !1, (function(d) {
              return r.Guard.isElementNode(d);
            }));
          }
          return null;
        }, l;
      })();
      n.NonElementParentNodeImpl = o;
    }, function(e, n, s) {
      var r = this && this.__values || function(c) {
        var u = typeof Symbol == "function" && Symbol.iterator, d = u && c[u], h = 0;
        if (d) return d.call(c);
        if (c && typeof c.length == "number") return { next: function() {
          return c && h >= c.length && (c = void 0), { value: c && c[h++], done: !c };
        } };
        throw new TypeError(u ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = s(3), o = s(0), l = (function() {
        function c() {
        }
        return Object.defineProperty(c.prototype, "children", { get: function() {
          return o.create_htmlCollection(a.Cast.asNode(this));
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(c.prototype, "firstElementChild", { get: function() {
          for (var u = a.Cast.asNode(this)._firstChild; u; ) {
            if (a.Guard.isElementNode(u)) return u;
            u = u._nextSibling;
          }
          return null;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(c.prototype, "lastElementChild", { get: function() {
          for (var u = a.Cast.asNode(this)._lastChild; u; ) {
            if (a.Guard.isElementNode(u)) return u;
            u = u._previousSibling;
          }
          return null;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(c.prototype, "childElementCount", { get: function() {
          var u, d, h = 0;
          try {
            for (var p = r(a.Cast.asNode(this)._children), m = p.next(); !m.done; m = p.next()) {
              var b = m.value;
              a.Guard.isElementNode(b) && h++;
            }
          } catch (y) {
            u = { error: y };
          } finally {
            try {
              m && !m.done && (d = p.return) && d.call(p);
            } finally {
              if (u) throw u.error;
            }
          }
          return h;
        }, enumerable: !0, configurable: !0 }), c.prototype.prepend = function() {
          for (var u = [], d = 0; d < arguments.length; d++) u[d] = arguments[d];
          var h = a.Cast.asNode(this), p = o.parentNode_convertNodesIntoANode(u, h._nodeDocument);
          o.mutation_preInsert(p, h, h._firstChild);
        }, c.prototype.append = function() {
          for (var u = [], d = 0; d < arguments.length; d++) u[d] = arguments[d];
          var h = a.Cast.asNode(this), p = o.parentNode_convertNodesIntoANode(u, h._nodeDocument);
          o.mutation_append(p, h);
        }, c.prototype.querySelector = function(u) {
          var d = a.Cast.asNode(this), h = o.selectors_scopeMatchASelectorsString(u, d);
          return h.length === 0 ? null : h[0];
        }, c.prototype.querySelectorAll = function(u) {
          var d = a.Cast.asNode(this), h = o.selectors_scopeMatchASelectorsString(u, d);
          return o.create_nodeListStatic(d, h);
        }, c;
      })();
      n.ParentNodeImpl = l;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(0), a = (function() {
        function o() {
        }
        return Object.defineProperty(o.prototype, "_name", { get: function() {
          return this.__name || "";
        }, set: function(l) {
          this.__name = l;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(o.prototype, "_assignedSlot", { get: function() {
          return this.__assignedSlot || null;
        }, set: function(l) {
          this.__assignedSlot = l;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(o.prototype, "assignedSlot", { get: function() {
          return r.shadowTree_findASlot(this, !0);
        }, enumerable: !0, configurable: !0 }), o;
      })();
      n.SlotableImpl = a;
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(d, h) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, m) {
          p.__proto__ = m;
        } || function(p, m) {
          for (var b in m) m.hasOwnProperty(b) && (p[b] = m[b]);
        })(d, h);
      }, function(d, h) {
        function p() {
          this.constructor = d;
        }
        r(d, h), d.prototype = h === null ? Object.create(h) : (p.prototype = h.prototype, new p());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(102), l = s(9), c = s(3), u = (function(d) {
        function h(p) {
          var m = d.call(this) || this;
          if (c.Guard.isDocumentTypeNode(p.startContainer) || c.Guard.isAttrNode(p.startContainer) || c.Guard.isDocumentTypeNode(p.endContainer) || c.Guard.isAttrNode(p.endContainer)) throw new l.InvalidNodeTypeError();
          return m._start = [p.startContainer, p.startOffset], m._end = [p.endContainer, p.endOffset], m;
        }
        return a(h, d), h;
      })(o.AbstractRangeImpl);
      n.StaticRangeImpl = u;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(272);
      n.DOMParser = r.DOMParserImpl;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(0), a = s(273), o = (function() {
        function l() {
        }
        return l.prototype.parseFromString = function(c, u) {
          if (u === "text/html") throw new Error("HTML parser not implemented.");
          try {
            return (d = new a.XMLParserImpl().parse(c))._contentType = u, d;
          } catch (b) {
            var d, h = "http://www.mozilla.org/newlayout/xml/parsererror.xml", p = (d = r.create_xmlDocument()).createElementNS(h, "parsererror"), m = d.createElementNS(h, "error");
            return m.setAttribute("message", b.message), p.appendChild(m), d.appendChild(p), d;
          }
        }, l;
      })();
      n.DOMParserImpl = o;
    }, function(e, n, s) {
      var r = this && this.__read || function(p, m) {
        var b = typeof Symbol == "function" && p[Symbol.iterator];
        if (!b) return p;
        var y, Z, g = b.call(p), f = [];
        try {
          for (; (m === void 0 || m-- > 0) && !(y = g.next()).done; ) f.push(y.value);
        } catch (T) {
          Z = { error: T };
        } finally {
          try {
            y && !y.done && (b = g.return) && b.call(g);
          } finally {
            if (Z) throw Z.error;
          }
        }
        return f;
      }, a = this && this.__values || function(p) {
        var m = typeof Symbol == "function" && Symbol.iterator, b = m && p[m], y = 0;
        if (b) return b.call(p);
        if (p && typeof p.length == "number") return { next: function() {
          return p && y >= p.length && (p = void 0), { value: p && p[y++], done: !p };
        } };
        throw new TypeError(m ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(180), l = s(111), c = s(7), u = s(0), d = s(69), h = (function() {
        function p() {
        }
        return p.prototype.parse = function(m) {
          for (var b, y, Z, g, f = new o.XMLStringLexer(m, { skipWhitespaceOnlyText: !0 }), T = u.create_document(), M = T, N = f.nextToken(); N.type !== l.TokenType.EOF; ) {
            switch (N.type) {
              case l.TokenType.Declaration:
                var W = N;
                if (W.version !== "1.0") throw new Error("Invalid xml version: " + W.version);
                break;
              case l.TokenType.DocType:
                var x = N;
                if (!u.xml_isPubidChar(x.pubId)) throw new Error("DocType public identifier does not match PubidChar construct.");
                if (!u.xml_isLegalChar(x.sysId) || x.sysId.indexOf('"') !== -1 && x.sysId.indexOf("'") !== -1) throw new Error("DocType system identifier contains invalid characters.");
                M.appendChild(T.implementation.createDocumentType(x.name, x.pubId, x.sysId));
                break;
              case l.TokenType.CDATA:
                var V = N;
                if (!u.xml_isLegalChar(V.data) || V.data.indexOf("]]>") !== -1) throw new Error("CDATA contains invalid characters.");
                M.appendChild(T.createCDATASection(V.data));
                break;
              case l.TokenType.Comment:
                var X = N;
                if (!u.xml_isLegalChar(X.data) || X.data.indexOf("--") !== -1 || X.data.endsWith("-")) throw new Error("Comment data contains invalid characters.");
                M.appendChild(T.createComment(X.data));
                break;
              case l.TokenType.PI:
                var C = N;
                if (C.target.indexOf(":") !== -1 || /^xml$/i.test(C.target)) throw new Error("Processing instruction target contains invalid characters.");
                if (!u.xml_isLegalChar(C.data) || C.data.indexOf("?>") !== -1) throw new Error("Processing instruction data contains invalid characters.");
                M.appendChild(T.createProcessingInstruction(C.target, C.data));
                break;
              case l.TokenType.Text:
                var R = N;
                if (!u.xml_isLegalChar(R.data)) throw new Error("Text data contains invalid characters.");
                M.appendChild(T.createTextNode(this._decodeText(R.data)));
                break;
              case l.TokenType.Element:
                var z = N, F = r(u.namespace_extractQName(z.name), 2), P = F[0], j = F[1];
                if (j.indexOf(":") !== -1 || !u.xml_isName(j)) throw new Error("Node local name contains invalid characters.");
                if (P === "xmlns") throw new Error("An element cannot have the 'xmlns' prefix.");
                var H = M.lookupNamespaceURI(P), B = {};
                try {
                  for (var $ = (b = void 0, a(z.attributes)), A = $.next(); !A.done; A = $.next()) {
                    var E = r(A.value, 2), ct = E[0], at = E[1];
                    if (ct === "xmlns") H = at;
                    else {
                      var dt = r(u.namespace_extractQName(ct), 2), gt = dt[0], Wt = dt[1];
                      gt === "xmlns" && (Wt === P && (H = at), B[Wt] = at);
                    }
                  }
                } catch (et) {
                  b = { error: et };
                } finally {
                  try {
                    A && !A.done && (y = $.return) && y.call($);
                  } finally {
                    if (b) throw b.error;
                  }
                }
                var Zt = H !== null ? T.createElementNS(H, z.name) : T.createElement(z.name);
                M.appendChild(Zt);
                var Gt = new d.LocalNameSet();
                try {
                  for (var Tt = (Z = void 0, a(z.attributes)), Q = Tt.next(); !Q.done; Q = Tt.next()) {
                    var D = r(Q.value, 2), q = (ct = D[0], at = D[1], r(u.namespace_extractQName(ct), 2)), nt = (gt = q[0], Wt = q[1], null);
                    if (gt === "xmlns" || gt === null && Wt === "xmlns" ? nt = c.namespace.XMLNS : (nt = Zt.lookupNamespaceURI(gt)) !== null && Zt.isDefaultNamespace(nt) ? nt = null : nt === null && gt !== null && (nt = B[gt] || null), Gt.has(nt, Wt)) throw new Error("Element contains duplicate attributes.");
                    if (Gt.set(nt, Wt), nt === c.namespace.XMLNS && at === c.namespace.XMLNS) throw new Error("XMLNS namespace is reserved.");
                    if (Wt.indexOf(":") !== -1 || !u.xml_isName(Wt)) throw new Error("Attribute local name contains invalid characters.");
                    if (gt === "xmlns" && at === "") throw new Error("Empty XML namespace is not allowed.");
                    nt !== null ? Zt.setAttributeNS(nt, ct, this._decodeAttributeValue(at)) : Zt.setAttribute(ct, this._decodeAttributeValue(at));
                  }
                } catch (et) {
                  Z = { error: et };
                } finally {
                  try {
                    Q && !Q.done && (g = Tt.return) && g.call(Tt);
                  } finally {
                    if (Z) throw Z.error;
                  }
                }
                z.selfClosing || (M = Zt);
                break;
              case l.TokenType.ClosingTag:
                if (N.name !== M.nodeName) throw new Error("Closing tag name does not match opening tag name.");
                M._parent && (M = M._parent);
            }
            N = f.nextToken();
          }
          return T;
        }, p.prototype._decodeText = function(m) {
          return m == null ? m : m.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&");
        }, p.prototype._decodeAttributeValue = function(m) {
          return m == null ? m : m.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&");
        }, p;
      })();
      n.XMLParserImpl = h;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(275);
      n.XMLSerializer = r.XMLSerializerImpl;
    }, function(e, n, s) {
      var r = this && this.__values || function(p) {
        var m = typeof Symbol == "function" && Symbol.iterator, b = m && p[m], y = 0;
        if (b) return b.call(p);
        if (p && typeof p.length == "number") return { next: function() {
          return p && y >= p.length && (p = void 0), { value: p && p[y++], done: !p };
        } };
        throw new TypeError(m ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = s(2), o = s(69), l = s(95), c = s(9), u = s(7), d = s(0), h = (function() {
        function p() {
        }
        return p.prototype.serializeToString = function(m) {
          return this._xmlSerialization(m, !1);
        }, p.prototype._xmlSerialization = function(m, b) {
          if (m._nodeDocument === void 0 || m._nodeDocument._hasNamespaces) {
            var y = new l.NamespacePrefixMap();
            y.set("xml", u.namespace.XML);
            try {
              return this._serializeNodeNS(m, null, y, { value: 1 }, b);
            } catch {
              throw new c.InvalidStateError();
            }
          } else try {
            return this._serializeNode(m, b);
          } catch {
            throw new c.InvalidStateError();
          }
        }, p.prototype._serializeNodeNS = function(m, b, y, Z, g) {
          switch (m.nodeType) {
            case a.NodeType.Element:
              return this._serializeElementNS(m, b, y, Z, g);
            case a.NodeType.Document:
              return this._serializeDocumentNS(m, b, y, Z, g);
            case a.NodeType.Comment:
              return this._serializeComment(m, g);
            case a.NodeType.Text:
              return this._serializeText(m, g);
            case a.NodeType.DocumentFragment:
              return this._serializeDocumentFragmentNS(m, b, y, Z, g);
            case a.NodeType.DocumentType:
              return this._serializeDocumentType(m, g);
            case a.NodeType.ProcessingInstruction:
              return this._serializeProcessingInstruction(m, g);
            case a.NodeType.CData:
              return this._serializeCData(m, g);
            default:
              throw new Error("Unknown node type: " + m.nodeType);
          }
        }, p.prototype._serializeNode = function(m, b) {
          switch (m.nodeType) {
            case a.NodeType.Element:
              return this._serializeElement(m, b);
            case a.NodeType.Document:
              return this._serializeDocument(m, b);
            case a.NodeType.Comment:
              return this._serializeComment(m, b);
            case a.NodeType.Text:
              return this._serializeText(m, b);
            case a.NodeType.DocumentFragment:
              return this._serializeDocumentFragment(m, b);
            case a.NodeType.DocumentType:
              return this._serializeDocumentType(m, b);
            case a.NodeType.ProcessingInstruction:
              return this._serializeProcessingInstruction(m, b);
            case a.NodeType.CData:
              return this._serializeCData(m, b);
            default:
              throw new Error("Unknown node type: " + m.nodeType);
          }
        }, p.prototype._serializeElementNS = function(m, b, y, Z, g) {
          var f, T;
          if (g && (m.localName.indexOf(":") !== -1 || !d.xml_isName(m.localName))) throw new Error("Node local name contains invalid characters (well-formed required).");
          var M = "<", N = "", W = !1, x = !1, V = y.copy(), X = {}, C = this._recordNamespaceInformation(m, V, X), R = b, z = m.namespaceURI;
          if (R === z) C !== null && (x = !0), M += N = z === u.namespace.XML ? "xml:" + m.localName : m.localName;
          else {
            var F = m.prefix, P = null;
            if (F === null && z === C || (P = V.get(F, z)), F === "xmlns") {
              if (g) throw new Error("An element cannot have the 'xmlns' prefix (well-formed required).");
              P = F;
            }
            P !== null ? (N = P + ":" + m.localName, C !== null && C !== u.namespace.XML && (R = C || null), M += N) : F !== null ? (F in X && (F = this._generatePrefix(z, V, Z)), V.set(F, z), M += N += F + ":" + m.localName, M += " xmlns:" + F + '="' + this._serializeAttributeValue(z, g) + '"', C !== null && (R = C || null)) : C === null || C !== null && C !== z ? (x = !0, R = z, M += N += m.localName, M += ' xmlns="' + this._serializeAttributeValue(z, g) + '"') : (R = z, M += N += m.localName);
          }
          M += this._serializeAttributesNS(m, V, Z, X, x, g);
          var j = z === u.namespace.HTML;
          if (j && m.childNodes.length === 0 && p._VoidElementNames.has(m.localName) ? (M += " /", W = !0) : j || m.childNodes.length !== 0 || (M += "/", W = !0), M += ">", W) return M;
          if (!(j && m.localName === "template")) try {
            for (var H = r(m._children || m.childNodes), B = H.next(); !B.done; B = H.next()) {
              var $ = B.value;
              M += this._serializeNodeNS($, R, V, Z, g);
            }
          } catch (A) {
            f = { error: A };
          } finally {
            try {
              B && !B.done && (T = H.return) && T.call(H);
            } finally {
              if (f) throw f.error;
            }
          }
          return M += "</" + N + ">";
        }, p.prototype._serializeDocumentNS = function(m, b, y, Z, g) {
          var f, T;
          if (g && m.documentElement === null) throw new Error("Missing document element (well-formed required).");
          var M = "";
          try {
            for (var N = r(m._children || m.childNodes), W = N.next(); !W.done; W = N.next()) {
              var x = W.value;
              M += this._serializeNodeNS(x, b, y, Z, g);
            }
          } catch (V) {
            f = { error: V };
          } finally {
            try {
              W && !W.done && (T = N.return) && T.call(N);
            } finally {
              if (f) throw f.error;
            }
          }
          return M;
        }, p.prototype._serializeComment = function(m, b) {
          if (b && (!d.xml_isLegalChar(m.data) || m.data.indexOf("--") !== -1 || m.data.endsWith("-"))) throw new Error("Comment data contains invalid characters (well-formed required).");
          return "<!--" + m.data + "-->";
        }, p.prototype._serializeText = function(m, b) {
          if (b && !d.xml_isLegalChar(m.data)) throw new Error("Text data contains invalid characters (well-formed required).");
          for (var y = "", Z = 0; Z < m.data.length; Z++) {
            var g = m.data[Z];
            y += g === "&" ? "&amp;" : g === "<" ? "&lt;" : g === ">" ? "&gt;" : g;
          }
          return y;
        }, p.prototype._serializeDocumentFragmentNS = function(m, b, y, Z, g) {
          var f, T, M = "";
          try {
            for (var N = r(m._children || m.childNodes), W = N.next(); !W.done; W = N.next()) {
              var x = W.value;
              M += this._serializeNodeNS(x, b, y, Z, g);
            }
          } catch (V) {
            f = { error: V };
          } finally {
            try {
              W && !W.done && (T = N.return) && T.call(N);
            } finally {
              if (f) throw f.error;
            }
          }
          return M;
        }, p.prototype._serializeDocumentType = function(m, b) {
          if (b && !d.xml_isPubidChar(m.publicId)) throw new Error("DocType public identifier does not match PubidChar construct (well-formed required).");
          if (b && (!d.xml_isLegalChar(m.systemId) || m.systemId.indexOf('"') !== -1 && m.systemId.indexOf("'") !== -1)) throw new Error("DocType system identifier contains invalid characters (well-formed required).");
          return m.publicId && m.systemId ? "<!DOCTYPE " + m.name + ' PUBLIC "' + m.publicId + '" "' + m.systemId + '">' : m.publicId ? "<!DOCTYPE " + m.name + ' PUBLIC "' + m.publicId + '">' : m.systemId ? "<!DOCTYPE " + m.name + ' SYSTEM "' + m.systemId + '">' : "<!DOCTYPE " + m.name + ">";
        }, p.prototype._serializeProcessingInstruction = function(m, b) {
          if (b && (m.target.indexOf(":") !== -1 || /^xml$/i.test(m.target))) throw new Error("Processing instruction target contains invalid characters (well-formed required).");
          if (b && (!d.xml_isLegalChar(m.data) || m.data.indexOf("?>") !== -1)) throw new Error("Processing instruction data contains invalid characters (well-formed required).");
          return "<?" + (m.data === "" ? m.target : m.target + " " + m.data) + "?>";
        }, p.prototype._serializeCData = function(m, b) {
          if (b && m.data.indexOf("]]>") !== -1) throw new Error("CDATA contains invalid characters (well-formed required).");
          return "<![CDATA[" + m.data + "]]>";
        }, p.prototype._serializeAttributesNS = function(m, b, y, Z, g, f) {
          var T, M, N = "", W = f ? new o.LocalNameSet() : void 0;
          try {
            for (var x = r(m.attributes), V = x.next(); !V.done; V = x.next()) {
              var X = V.value;
              if (g || f || X.namespaceURI !== null) {
                if (f && W && W.has(X.namespaceURI, X.localName)) throw new Error("Element contains duplicate attributes (well-formed required).");
                f && W && W.set(X.namespaceURI, X.localName);
                var C = X.namespaceURI, R = null;
                if (C !== null) if (R = b.get(X.prefix, C), C === u.namespace.XMLNS) {
                  if (X.value === u.namespace.XML || X.prefix === null && g || X.prefix !== null && (!(X.localName in Z) || Z[X.localName] !== X.value) && b.has(X.localName, X.value)) continue;
                  if (f && X.value === u.namespace.XMLNS) throw new Error("XMLNS namespace is reserved (well-formed required).");
                  if (f && X.value === "") throw new Error("Namespace prefix declarations cannot be used to undeclare a namespace (well-formed required).");
                  X.prefix === "xmlns" && (R = "xmlns");
                } else R === null && (N += " xmlns:" + (R = X.prefix === null || b.hasPrefix(X.prefix) && !b.has(X.prefix, C) ? this._generatePrefix(C, b, y) : X.prefix) + '="' + this._serializeAttributeValue(C, f) + '"');
                if (N += " ", R !== null && (N += R + ":"), f && (X.localName.indexOf(":") !== -1 || !d.xml_isName(X.localName) || X.localName === "xmlns" && C === null)) throw new Error("Attribute local name contains invalid characters (well-formed required).");
                N += X.localName + '="' + this._serializeAttributeValue(X.value, f) + '"';
              } else N += " " + X.localName + '="' + this._serializeAttributeValue(X.value, f) + '"';
            }
          } catch (z) {
            T = { error: z };
          } finally {
            try {
              V && !V.done && (M = x.return) && M.call(x);
            } finally {
              if (T) throw T.error;
            }
          }
          return N;
        }, p.prototype._recordNamespaceInformation = function(m, b, y) {
          var Z, g, f = null;
          try {
            for (var T = r(m.attributes), M = T.next(); !M.done; M = T.next()) {
              var N = M.value, W = N.namespaceURI, x = N.prefix;
              if (W === u.namespace.XMLNS) {
                if (x === null) {
                  f = N.value;
                  continue;
                }
                var V = N.localName, X = N.value;
                if (X === u.namespace.XML || (X === "" && (X = null), b.has(V, X))) continue;
                b.set(V, X), y[V] = X || "";
              }
            }
          } catch (C) {
            Z = { error: C };
          } finally {
            try {
              M && !M.done && (g = T.return) && g.call(T);
            } finally {
              if (Z) throw Z.error;
            }
          }
          return f;
        }, p.prototype._generatePrefix = function(m, b, y) {
          var Z = "ns" + y.value;
          return y.value++, b.set(Z, m), Z;
        }, p.prototype._serializeAttributeValue = function(m, b) {
          if (b && m !== null && !d.xml_isLegalChar(m)) throw new Error("Invalid characters in attribute value.");
          if (m === null) return "";
          for (var y = "", Z = 0; Z < m.length; Z++) {
            var g = m[Z];
            y += g === '"' ? "&quot;" : g === "&" ? "&amp;" : g === "<" ? "&lt;" : g === ">" ? "&gt;" : g;
          }
          return y;
        }, p.prototype._serializeElement = function(m, b) {
          var y, Z;
          if (b && (m.localName.indexOf(":") !== -1 || !d.xml_isName(m.localName))) throw new Error("Node local name contains invalid characters (well-formed required).");
          var g = !1, f = m.localName, T = "<" + f;
          if (T += this._serializeAttributes(m, b), m._children.size === 0 && (T += "/", g = !0), T += ">", g) return T;
          try {
            for (var M = r(m._children), N = M.next(); !N.done; N = M.next()) {
              var W = N.value;
              T += this._serializeNode(W, b);
            }
          } catch (x) {
            y = { error: x };
          } finally {
            try {
              N && !N.done && (Z = M.return) && Z.call(M);
            } finally {
              if (y) throw y.error;
            }
          }
          return T += "</" + f + ">";
        }, p.prototype._serializeDocument = function(m, b) {
          var y, Z;
          if (b && m.documentElement === null) throw new Error("Missing document element (well-formed required).");
          var g = "";
          try {
            for (var f = r(m._children), T = f.next(); !T.done; T = f.next()) {
              var M = T.value;
              g += this._serializeNode(M, b);
            }
          } catch (N) {
            y = { error: N };
          } finally {
            try {
              T && !T.done && (Z = f.return) && Z.call(f);
            } finally {
              if (y) throw y.error;
            }
          }
          return g;
        }, p.prototype._serializeDocumentFragment = function(m, b) {
          var y, Z, g = "";
          try {
            for (var f = r(m._children), T = f.next(); !T.done; T = f.next()) {
              var M = T.value;
              g += this._serializeNode(M, b);
            }
          } catch (N) {
            y = { error: N };
          } finally {
            try {
              T && !T.done && (Z = f.return) && Z.call(f);
            } finally {
              if (y) throw y.error;
            }
          }
          return g;
        }, p.prototype._serializeAttributes = function(m, b) {
          var y, Z, g = "", f = b ? {} : void 0;
          try {
            for (var T = r(m.attributes), M = T.next(); !M.done; M = T.next()) {
              var N = M.value;
              if (b && f && N.localName in f) throw new Error("Element contains duplicate attributes (well-formed required).");
              if (b && f && (f[N.localName] = !0), b && (N.localName.indexOf(":") !== -1 || !d.xml_isName(N.localName))) throw new Error("Attribute local name contains invalid characters (well-formed required).");
              g += " " + N.localName + '="' + this._serializeAttributeValue(N.value, b) + '"';
            }
          } catch (W) {
            y = { error: W };
          } finally {
            try {
              M && !M.done && (Z = T.return) && Z.call(T);
            } finally {
              if (y) throw y.error;
            }
          }
          return g;
        }, p._VoidElementNames = /* @__PURE__ */ new Set(["area", "base", "basefont", "bgsound", "br", "col", "embed", "frame", "hr", "img", "input", "keygen", "link", "menuitem", "meta", "param", "source", "track", "wbr"]), p;
      })();
      n.XMLSerializerImpl = h;
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(277);
      n.XMLReader = r.XMLReader;
      var a = s(112);
      n.ObjectReader = a.ObjectReader;
      var o = s(280);
      n.JSONReader = o.JSONReader;
      var l = s(281);
      n.YAMLReader = l.YAMLReader;
    }, function(e, n, s) {
      s(31), s(32), s(33), s(19), s(65), s(20), s(22), s(23);
      var r, a = this && this.__extends || (r = function(m, b) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(y, Z) {
          y.__proto__ = Z;
        } || function(y, Z) {
          for (var g in Z) Z.hasOwnProperty(g) && (y[g] = Z[g]);
        })(m, b);
      }, function(m, b) {
        function y() {
          this.constructor = m;
        }
        r(m, b), m.prototype = b === null ? Object.create(b) : (y.prototype = b.prototype, new y());
      }), o = this && this.__read || function(m, b) {
        var y = typeof Symbol == "function" && m[Symbol.iterator];
        if (!y) return m;
        var Z, g, f = y.call(m), T = [];
        try {
          for (; (b === void 0 || b-- > 0) && !(Z = f.next()).done; ) T.push(Z.value);
        } catch (M) {
          g = { error: M };
        } finally {
          try {
            Z && !Z.done && (y = f.return) && y.call(f);
          } finally {
            if (g) throw g.error;
          }
        }
        return T;
      }, l = this && this.__values || function(m) {
        var b = typeof Symbol == "function" && Symbol.iterator, y = b && m[b], Z = 0;
        if (y) return y.call(m);
        if (m && typeof m.length == "number") return { next: function() {
          return m && Z >= m.length && (m = void 0), { value: m && m[Z++], done: !m };
        } };
        throw new TypeError(b ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var c = s(180), u = s(111), d = s(7), h = s(0), p = (function(m) {
        function b() {
          return m !== null && m.apply(this, arguments) || this;
        }
        return a(b, m), b.prototype._parse = function(y, Z) {
          for (var g, f, T, M, N = new c.XMLStringLexer(Z, { skipWhitespaceOnlyText: !0 }), W = y, x = y, V = N.nextToken(); V.type !== u.TokenType.EOF; ) {
            switch (V.type) {
              case u.TokenType.Declaration:
                var X = V, C = this.sanitize(X.version);
                if (C !== "1.0") throw new Error("Invalid xml version: " + C);
                var R = { version: C };
                X.encoding && (R.encoding = this.sanitize(X.encoding)), X.standalone && (R.standalone = this.sanitize(X.standalone) === "yes"), x.set(R);
                break;
              case u.TokenType.DocType:
                var z = V;
                x = this.docType(x, this.sanitize(z.name), this.sanitize(z.pubId), this.sanitize(z.sysId)) || x;
                break;
              case u.TokenType.CDATA:
                var F = V;
                x = this.cdata(x, this.sanitize(F.data)) || x;
                break;
              case u.TokenType.Comment:
                var P = V;
                x = this.comment(x, this.sanitize(P.data)) || x;
                break;
              case u.TokenType.PI:
                var j = V;
                x = this.instruction(x, this.sanitize(j.target), this.sanitize(j.data)) || x;
                break;
              case u.TokenType.Text:
                var H = V;
                x = this.text(x, this._decodeText(this.sanitize(H.data))) || x;
                break;
              case u.TokenType.Element:
                var B = V, $ = this.sanitize(B.name), A = o(h.namespace_extractQName($), 1)[0], E = x.node.lookupNamespaceURI(A), ct = {};
                try {
                  for (var at = (g = void 0, l(B.attributes)), dt = at.next(); !dt.done; dt = at.next()) {
                    var gt = o(dt.value, 2), Wt = gt[0], Zt = gt[1];
                    if (Wt = this.sanitize(Wt), Zt = this.sanitize(Zt), Wt === "xmlns") E = Zt;
                    else {
                      var Gt = o(h.namespace_extractQName(Wt), 2), Tt = Gt[0], Q = Gt[1];
                      Tt === "xmlns" && (Q === A && (E = Zt), ct[Q] = Zt);
                    }
                  }
                } catch (ht) {
                  g = { error: ht };
                } finally {
                  try {
                    dt && !dt.done && (f = at.return) && f.call(at);
                  } finally {
                    if (g) throw g.error;
                  }
                }
                var D = E !== null ? this.element(x, E, $) : this.element(x, void 0, $);
                if (D === void 0) break;
                x.node === y.node && (W = D);
                try {
                  for (var q = (T = void 0, l(B.attributes)), nt = q.next(); !nt.done; nt = q.next()) {
                    var et = o(nt.value, 2);
                    Wt = et[0], Zt = et[1], Wt = this.sanitize(Wt), Zt = this.sanitize(Zt);
                    var ot = o(h.namespace_extractQName(Wt), 2), it = (Tt = ot[0], Q = ot[1], null);
                    Tt === "xmlns" || Tt === null && Q === "xmlns" ? it = d.namespace.XMLNS : (it = D.node.lookupNamespaceURI(Tt)) !== null && D.node.isDefaultNamespace(it) ? it = null : it === null && Tt !== null && (it = ct[Tt] || null), it !== null ? this.attribute(D, it, Wt, this._decodeAttributeValue(Zt)) : this.attribute(D, void 0, Wt, this._decodeAttributeValue(Zt));
                  }
                } catch (ht) {
                  T = { error: ht };
                } finally {
                  try {
                    nt && !nt.done && (M = q.return) && M.call(q);
                  } finally {
                    if (T) throw T.error;
                  }
                }
                B.selfClosing || (x = D);
                break;
              case u.TokenType.ClosingTag:
                x.node.parentNode && (x = x.up());
            }
            V = N.nextToken();
          }
          return W;
        }, b;
      })(s(75).BaseReader);
      n.XMLReader = p;
    }, function(e, n, s) {
      var r = s(4), a = s(279);
      r({ target: "Object", stat: !0, forced: Object.assign !== a }, { assign: a });
    }, function(e, n, s) {
      var r = s(16), a = s(8), o = s(61), l = s(85), c = s(79), u = s(27), d = s(41), h = Object.assign, p = Object.defineProperty;
      e.exports = !h || a((function() {
        if (r && h({ b: 1 }, h(p({}, "a", { enumerable: !0, get: function() {
          p(this, "b", { value: 3, enumerable: !1 });
        } }), { b: 2 })).b !== 1) return !0;
        var m = {}, b = {}, y = Symbol();
        return m[y] = 7, "abcdefghijklmnopqrst".split("").forEach((function(Z) {
          b[Z] = Z;
        })), h({}, m)[y] != 7 || o(h({}, b)).join("") != "abcdefghijklmnopqrst";
      })) ? function(m, b) {
        for (var y = u(m), Z = arguments.length, g = 1, f = l.f, T = c.f; Z > g; ) for (var M, N = d(arguments[g++]), W = f ? o(N).concat(f(N)) : o(N), x = W.length, V = 0; x > V; ) M = W[V++], r && !T.call(N, M) || (y[M] = N[M]);
        return y;
      } : h;
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(c, u) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, h) {
          d.__proto__ = h;
        } || function(d, h) {
          for (var p in h) h.hasOwnProperty(p) && (d[p] = h[p]);
        })(c, u);
      }, function(c, u) {
        function d() {
          this.constructor = c;
        }
        r(c, u), c.prototype = u === null ? Object.create(u) : (d.prototype = u.prototype, new d());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(112), l = (function(c) {
        function u() {
          return c !== null && c.apply(this, arguments) || this;
        }
        return a(u, c), u.prototype._parse = function(d, h) {
          return new o.ObjectReader(this._builderOptions).parse(d, JSON.parse(h));
        }, u;
      })(s(75).BaseReader);
      n.JSONReader = l;
    }, function(e, n, s) {
      var r, a = this && this.__extends || (r = function(d, h) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, m) {
          p.__proto__ = m;
        } || function(p, m) {
          for (var b in m) m.hasOwnProperty(b) && (p[b] = m[b]);
        })(d, h);
      }, function(d, h) {
        function p() {
          this.constructor = d;
        }
        r(d, h), d.prototype = h === null ? Object.create(h) : (p.prototype = h.prototype, new p());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = s(112), l = s(75), c = s(282), u = (function(d) {
        function h() {
          return d !== null && d.apply(this, arguments) || this;
        }
        return a(h, d), h.prototype._parse = function(p, m) {
          var b = c.safeLoad(m);
          if (b === void 0) throw new Error("Unable to parse YAML document.");
          return new o.ObjectReader(this._builderOptions).parse(p, b);
        }, h;
      })(l.BaseReader);
      n.YAMLReader = u;
    }, function(e, n, s) {
      var r = s(283);
      e.exports = r;
    }, function(e, n, s) {
      var r = s(284), a = s(303);
      function o(l) {
        return function() {
          throw new Error("Function " + l + " is deprecated and cannot be used.");
        };
      }
      e.exports.Type = s(10), e.exports.Schema = s(39), e.exports.FAILSAFE_SCHEMA = s(113), e.exports.JSON_SCHEMA = s(182), e.exports.CORE_SCHEMA = s(181), e.exports.DEFAULT_SAFE_SCHEMA = s(54), e.exports.DEFAULT_FULL_SCHEMA = s(76), e.exports.load = r.load, e.exports.loadAll = r.loadAll, e.exports.safeLoad = r.safeLoad, e.exports.safeLoadAll = r.safeLoadAll, e.exports.dump = a.dump, e.exports.safeDump = a.safeDump, e.exports.YAMLException = s(53), e.exports.MINIMAL_SCHEMA = s(113), e.exports.SAFE_SCHEMA = s(54), e.exports.DEFAULT_SCHEMA = s(76), e.exports.scan = o("scan"), e.exports.parse = o("parse"), e.exports.compose = o("compose"), e.exports.addConstructor = o("addConstructor");
    }, function(e, n, s) {
      var r = s(38), a = s(53), o = s(285), l = s(54), c = s(76), u = Object.prototype.hasOwnProperty, d = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, h = /[\x85\u2028\u2029]/, p = /[,\[\]\{\}]/, m = /^(?:!|!!|![a-z\-]+!)$/i, b = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;
      function y(D) {
        return Object.prototype.toString.call(D);
      }
      function Z(D) {
        return D === 10 || D === 13;
      }
      function g(D) {
        return D === 9 || D === 32;
      }
      function f(D) {
        return D === 9 || D === 32 || D === 10 || D === 13;
      }
      function T(D) {
        return D === 44 || D === 91 || D === 93 || D === 123 || D === 125;
      }
      function M(D) {
        var q;
        return 48 <= D && D <= 57 ? D - 48 : 97 <= (q = 32 | D) && q <= 102 ? q - 97 + 10 : -1;
      }
      function N(D) {
        return D === 48 ? "\0" : D === 97 ? "\x07" : D === 98 ? "\b" : D === 116 || D === 9 ? "	" : D === 110 ? `
` : D === 118 ? "\v" : D === 102 ? "\f" : D === 114 ? "\r" : D === 101 ? "\x1B" : D === 32 ? " " : D === 34 ? '"' : D === 47 ? "/" : D === 92 ? "\\" : D === 78 ? "" : D === 95 ? " " : D === 76 ? "\u2028" : D === 80 ? "\u2029" : "";
      }
      function W(D) {
        return D <= 65535 ? String.fromCharCode(D) : String.fromCharCode(55296 + (D - 65536 >> 10), 56320 + (D - 65536 & 1023));
      }
      for (var x = new Array(256), V = new Array(256), X = 0; X < 256; X++) x[X] = N(X) ? 1 : 0, V[X] = N(X);
      function C(D, q) {
        this.input = D, this.filename = q.filename || null, this.schema = q.schema || c, this.onWarning = q.onWarning || null, this.legacy = q.legacy || !1, this.json = q.json || !1, this.listener = q.listener || null, this.implicitTypes = this.schema.compiledImplicit, this.typeMap = this.schema.compiledTypeMap, this.length = D.length, this.position = 0, this.line = 0, this.lineStart = 0, this.lineIndent = 0, this.documents = [];
      }
      function R(D, q) {
        return new a(q, new o(D.filename, D.input, D.position, D.line, D.position - D.lineStart));
      }
      function z(D, q) {
        throw R(D, q);
      }
      function F(D, q) {
        D.onWarning && D.onWarning.call(null, R(D, q));
      }
      var P = { YAML: function(D, q, nt) {
        var et, ot, it;
        D.version !== null && z(D, "duplication of %YAML directive"), nt.length !== 1 && z(D, "YAML directive accepts exactly one argument"), (et = /^([0-9]+)\.([0-9]+)$/.exec(nt[0])) === null && z(D, "ill-formed argument of the YAML directive"), ot = parseInt(et[1], 10), it = parseInt(et[2], 10), ot !== 1 && z(D, "unacceptable YAML version of the document"), D.version = nt[0], D.checkLineBreaks = it < 2, it !== 1 && it !== 2 && F(D, "unsupported YAML version of the document");
      }, TAG: function(D, q, nt) {
        var et, ot;
        nt.length !== 2 && z(D, "TAG directive accepts exactly two arguments"), et = nt[0], ot = nt[1], m.test(et) || z(D, "ill-formed tag handle (first argument) of the TAG directive"), u.call(D.tagMap, et) && z(D, 'there is a previously declared suffix for "' + et + '" tag handle'), b.test(ot) || z(D, "ill-formed tag prefix (second argument) of the TAG directive"), D.tagMap[et] = ot;
      } };
      function j(D, q, nt, et) {
        var ot, it, ht, lt;
        if (q < nt) {
          if (lt = D.input.slice(q, nt), et) for (ot = 0, it = lt.length; ot < it; ot += 1) (ht = lt.charCodeAt(ot)) === 9 || 32 <= ht && ht <= 1114111 || z(D, "expected valid JSON character");
          else d.test(lt) && z(D, "the stream contains non-printable characters");
          D.result += lt;
        }
      }
      function H(D, q, nt, et) {
        var ot, it, ht, lt;
        for (r.isObject(nt) || z(D, "cannot merge mappings; the provided source object is unacceptable"), ht = 0, lt = (ot = Object.keys(nt)).length; ht < lt; ht += 1) it = ot[ht], u.call(q, it) || (q[it] = nt[it], et[it] = !0);
      }
      function B(D, q, nt, et, ot, it, ht, lt) {
        var mt, wt;
        if (Array.isArray(ot)) for (mt = 0, wt = (ot = Array.prototype.slice.call(ot)).length; mt < wt; mt += 1) Array.isArray(ot[mt]) && z(D, "nested arrays are not supported inside keys"), typeof ot == "object" && y(ot[mt]) === "[object Object]" && (ot[mt] = "[object Object]");
        if (typeof ot == "object" && y(ot) === "[object Object]" && (ot = "[object Object]"), ot = String(ot), q === null && (q = {}), et === "tag:yaml.org,2002:merge") if (Array.isArray(it)) for (mt = 0, wt = it.length; mt < wt; mt += 1) H(D, q, it[mt], nt);
        else H(D, q, it, nt);
        else D.json || u.call(nt, ot) || !u.call(q, ot) || (D.line = ht || D.line, D.position = lt || D.position, z(D, "duplicated mapping key")), q[ot] = it, delete nt[ot];
        return q;
      }
      function $(D) {
        var q;
        (q = D.input.charCodeAt(D.position)) === 10 ? D.position++ : q === 13 ? (D.position++, D.input.charCodeAt(D.position) === 10 && D.position++) : z(D, "a line break is expected"), D.line += 1, D.lineStart = D.position;
      }
      function A(D, q, nt) {
        for (var et = 0, ot = D.input.charCodeAt(D.position); ot !== 0; ) {
          for (; g(ot); ) ot = D.input.charCodeAt(++D.position);
          if (q && ot === 35) do
            ot = D.input.charCodeAt(++D.position);
          while (ot !== 10 && ot !== 13 && ot !== 0);
          if (!Z(ot)) break;
          for ($(D), ot = D.input.charCodeAt(D.position), et++, D.lineIndent = 0; ot === 32; ) D.lineIndent++, ot = D.input.charCodeAt(++D.position);
        }
        return nt !== -1 && et !== 0 && D.lineIndent < nt && F(D, "deficient indentation"), et;
      }
      function E(D) {
        var q, nt = D.position;
        return !((q = D.input.charCodeAt(nt)) !== 45 && q !== 46 || q !== D.input.charCodeAt(nt + 1) || q !== D.input.charCodeAt(nt + 2) || (nt += 3, (q = D.input.charCodeAt(nt)) !== 0 && !f(q)));
      }
      function ct(D, q) {
        q === 1 ? D.result += " " : q > 1 && (D.result += r.repeat(`
`, q - 1));
      }
      function at(D, q) {
        var nt, et, ot = D.tag, it = D.anchor, ht = [], lt = !1;
        for (D.anchor !== null && (D.anchorMap[D.anchor] = ht), et = D.input.charCodeAt(D.position); et !== 0 && et === 45 && f(D.input.charCodeAt(D.position + 1)); ) if (lt = !0, D.position++, A(D, !0, -1) && D.lineIndent <= q) ht.push(null), et = D.input.charCodeAt(D.position);
        else if (nt = D.line, Wt(D, q, 3, !1, !0), ht.push(D.result), A(D, !0, -1), et = D.input.charCodeAt(D.position), (D.line === nt || D.lineIndent > q) && et !== 0) z(D, "bad indentation of a sequence entry");
        else if (D.lineIndent < q) break;
        return !!lt && (D.tag = ot, D.anchor = it, D.kind = "sequence", D.result = ht, !0);
      }
      function dt(D) {
        var q, nt, et, ot, it = !1, ht = !1;
        if ((ot = D.input.charCodeAt(D.position)) !== 33) return !1;
        if (D.tag !== null && z(D, "duplication of a tag property"), (ot = D.input.charCodeAt(++D.position)) === 60 ? (it = !0, ot = D.input.charCodeAt(++D.position)) : ot === 33 ? (ht = !0, nt = "!!", ot = D.input.charCodeAt(++D.position)) : nt = "!", q = D.position, it) {
          do
            ot = D.input.charCodeAt(++D.position);
          while (ot !== 0 && ot !== 62);
          D.position < D.length ? (et = D.input.slice(q, D.position), ot = D.input.charCodeAt(++D.position)) : z(D, "unexpected end of the stream within a verbatim tag");
        } else {
          for (; ot !== 0 && !f(ot); ) ot === 33 && (ht ? z(D, "tag suffix cannot contain exclamation marks") : (nt = D.input.slice(q - 1, D.position + 1), m.test(nt) || z(D, "named tag handle cannot contain such characters"), ht = !0, q = D.position + 1)), ot = D.input.charCodeAt(++D.position);
          et = D.input.slice(q, D.position), p.test(et) && z(D, "tag suffix cannot contain flow indicator characters");
        }
        return et && !b.test(et) && z(D, "tag name cannot contain such characters: " + et), it ? D.tag = et : u.call(D.tagMap, nt) ? D.tag = D.tagMap[nt] + et : nt === "!" ? D.tag = "!" + et : nt === "!!" ? D.tag = "tag:yaml.org,2002:" + et : z(D, 'undeclared tag handle "' + nt + '"'), !0;
      }
      function gt(D) {
        var q, nt;
        if ((nt = D.input.charCodeAt(D.position)) !== 38) return !1;
        for (D.anchor !== null && z(D, "duplication of an anchor property"), nt = D.input.charCodeAt(++D.position), q = D.position; nt !== 0 && !f(nt) && !T(nt); ) nt = D.input.charCodeAt(++D.position);
        return D.position === q && z(D, "name of an anchor node must contain at least one character"), D.anchor = D.input.slice(q, D.position), !0;
      }
      function Wt(D, q, nt, et, ot) {
        var it, ht, lt, mt, wt, Xt, At, he, ue = 1, Dt = !1, ee = !1;
        if (D.listener !== null && D.listener("open", D), D.tag = null, D.anchor = null, D.kind = null, D.result = null, it = ht = lt = nt === 4 || nt === 3, et && A(D, !0, -1) && (Dt = !0, D.lineIndent > q ? ue = 1 : D.lineIndent === q ? ue = 0 : D.lineIndent < q && (ue = -1)), ue === 1) for (; dt(D) || gt(D); ) A(D, !0, -1) ? (Dt = !0, lt = it, D.lineIndent > q ? ue = 1 : D.lineIndent === q ? ue = 0 : D.lineIndent < q && (ue = -1)) : lt = !1;
        if (lt && (lt = Dt || ot), ue !== 1 && nt !== 4 || (At = nt === 1 || nt === 2 ? q : q + 1, he = D.position - D.lineStart, ue === 1 ? lt && (at(D, he) || (function(yt, fe, Xe) {
          var Se, Vt, Rt, $t, zt, Bt = yt.tag, Kt = yt.anchor, ne = {}, ae = {}, Ge = null, He = null, je = null, we = !1, ln = !1;
          for (yt.anchor !== null && (yt.anchorMap[yt.anchor] = ne), zt = yt.input.charCodeAt(yt.position); zt !== 0; ) {
            if (Se = yt.input.charCodeAt(yt.position + 1), Rt = yt.line, $t = yt.position, zt !== 63 && zt !== 58 || !f(Se)) {
              if (!Wt(yt, Xe, 2, !1, !0)) break;
              if (yt.line === Rt) {
                for (zt = yt.input.charCodeAt(yt.position); g(zt); ) zt = yt.input.charCodeAt(++yt.position);
                if (zt === 58) f(zt = yt.input.charCodeAt(++yt.position)) || z(yt, "a whitespace character is expected after the key-value separator within a block mapping"), we && (B(yt, ne, ae, Ge, He, null), Ge = He = je = null), ln = !0, we = !1, Vt = !1, Ge = yt.tag, He = yt.result;
                else {
                  if (!ln) return yt.tag = Bt, yt.anchor = Kt, !0;
                  z(yt, "can not read an implicit mapping pair; a colon is missed");
                }
              } else {
                if (!ln) return yt.tag = Bt, yt.anchor = Kt, !0;
                z(yt, "can not read a block mapping entry; a multiline key may not be an implicit key");
              }
            } else zt === 63 ? (we && (B(yt, ne, ae, Ge, He, null), Ge = He = je = null), ln = !0, we = !0, Vt = !0) : we ? (we = !1, Vt = !0) : z(yt, "incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line"), yt.position += 1, zt = Se;
            if ((yt.line === Rt || yt.lineIndent > fe) && (Wt(yt, fe, 4, !0, Vt) && (we ? He = yt.result : je = yt.result), we || (B(yt, ne, ae, Ge, He, je, Rt, $t), Ge = He = je = null), A(yt, !0, -1), zt = yt.input.charCodeAt(yt.position)), yt.lineIndent > fe && zt !== 0) z(yt, "bad indentation of a mapping entry");
            else if (yt.lineIndent < fe) break;
          }
          return we && B(yt, ne, ae, Ge, He, null), ln && (yt.tag = Bt, yt.anchor = Kt, yt.kind = "mapping", yt.result = ne), ln;
        })(D, he, At)) || (function(yt, fe) {
          var Xe, Se, Vt, Rt, $t, zt, Bt, Kt, ne, ae, Ge = !0, He = yt.tag, je = yt.anchor, we = {};
          if ((ae = yt.input.charCodeAt(yt.position)) === 91) Vt = 93, zt = !1, Se = [];
          else {
            if (ae !== 123) return !1;
            Vt = 125, zt = !0, Se = {};
          }
          for (yt.anchor !== null && (yt.anchorMap[yt.anchor] = Se), ae = yt.input.charCodeAt(++yt.position); ae !== 0; ) {
            if (A(yt, !0, fe), (ae = yt.input.charCodeAt(yt.position)) === Vt) return yt.position++, yt.tag = He, yt.anchor = je, yt.kind = zt ? "mapping" : "sequence", yt.result = Se, !0;
            Ge || z(yt, "missed comma between flow collection entries"), ne = null, Rt = $t = !1, ae === 63 && f(yt.input.charCodeAt(yt.position + 1)) && (Rt = $t = !0, yt.position++, A(yt, !0, fe)), Xe = yt.line, Wt(yt, fe, 1, !1, !0), Kt = yt.tag, Bt = yt.result, A(yt, !0, fe), ae = yt.input.charCodeAt(yt.position), !$t && yt.line !== Xe || ae !== 58 || (Rt = !0, ae = yt.input.charCodeAt(++yt.position), A(yt, !0, fe), Wt(yt, fe, 1, !1, !0), ne = yt.result), zt ? B(yt, Se, we, Kt, Bt, ne) : Rt ? Se.push(B(yt, null, we, Kt, Bt, ne)) : Se.push(Bt), A(yt, !0, fe), (ae = yt.input.charCodeAt(yt.position)) === 44 ? (Ge = !0, ae = yt.input.charCodeAt(++yt.position)) : Ge = !1;
          }
          z(yt, "unexpected end of the stream within a flow collection");
        })(D, At) ? ee = !0 : (ht && (function(yt, fe) {
          var Xe, Se, Vt, Rt, $t, zt = 1, Bt = !1, Kt = !1, ne = fe, ae = 0, Ge = !1;
          if ((Rt = yt.input.charCodeAt(yt.position)) === 124) Se = !1;
          else {
            if (Rt !== 62) return !1;
            Se = !0;
          }
          for (yt.kind = "scalar", yt.result = ""; Rt !== 0; ) if ((Rt = yt.input.charCodeAt(++yt.position)) === 43 || Rt === 45) zt === 1 ? zt = Rt === 43 ? 3 : 2 : z(yt, "repeat of a chomping mode identifier");
          else {
            if (!((Vt = 48 <= ($t = Rt) && $t <= 57 ? $t - 48 : -1) >= 0)) break;
            Vt === 0 ? z(yt, "bad explicit indentation width of a block scalar; it cannot be less than one") : Kt ? z(yt, "repeat of an indentation width identifier") : (ne = fe + Vt - 1, Kt = !0);
          }
          if (g(Rt)) {
            do
              Rt = yt.input.charCodeAt(++yt.position);
            while (g(Rt));
            if (Rt === 35) do
              Rt = yt.input.charCodeAt(++yt.position);
            while (!Z(Rt) && Rt !== 0);
          }
          for (; Rt !== 0; ) {
            for ($(yt), yt.lineIndent = 0, Rt = yt.input.charCodeAt(yt.position); (!Kt || yt.lineIndent < ne) && Rt === 32; ) yt.lineIndent++, Rt = yt.input.charCodeAt(++yt.position);
            if (!Kt && yt.lineIndent > ne && (ne = yt.lineIndent), Z(Rt)) ae++;
            else {
              if (yt.lineIndent < ne) {
                zt === 3 ? yt.result += r.repeat(`
`, Bt ? 1 + ae : ae) : zt === 1 && Bt && (yt.result += `
`);
                break;
              }
              for (Se ? g(Rt) ? (Ge = !0, yt.result += r.repeat(`
`, Bt ? 1 + ae : ae)) : Ge ? (Ge = !1, yt.result += r.repeat(`
`, ae + 1)) : ae === 0 ? Bt && (yt.result += " ") : yt.result += r.repeat(`
`, ae) : yt.result += r.repeat(`
`, Bt ? 1 + ae : ae), Bt = !0, Kt = !0, ae = 0, Xe = yt.position; !Z(Rt) && Rt !== 0; ) Rt = yt.input.charCodeAt(++yt.position);
              j(yt, Xe, yt.position, !1);
            }
          }
          return !0;
        })(D, At) || (function(yt, fe) {
          var Xe, Se, Vt;
          if ((Xe = yt.input.charCodeAt(yt.position)) !== 39) return !1;
          for (yt.kind = "scalar", yt.result = "", yt.position++, Se = Vt = yt.position; (Xe = yt.input.charCodeAt(yt.position)) !== 0; ) if (Xe === 39) {
            if (j(yt, Se, yt.position, !0), (Xe = yt.input.charCodeAt(++yt.position)) !== 39) return !0;
            Se = yt.position, yt.position++, Vt = yt.position;
          } else Z(Xe) ? (j(yt, Se, Vt, !0), ct(yt, A(yt, !1, fe)), Se = Vt = yt.position) : yt.position === yt.lineStart && E(yt) ? z(yt, "unexpected end of the document within a single quoted scalar") : (yt.position++, Vt = yt.position);
          z(yt, "unexpected end of the stream within a single quoted scalar");
        })(D, At) || (function(yt, fe) {
          var Xe, Se, Vt, Rt, $t, zt, Bt;
          if ((zt = yt.input.charCodeAt(yt.position)) !== 34) return !1;
          for (yt.kind = "scalar", yt.result = "", yt.position++, Xe = Se = yt.position; (zt = yt.input.charCodeAt(yt.position)) !== 0; ) {
            if (zt === 34) return j(yt, Xe, yt.position, !0), yt.position++, !0;
            if (zt === 92) {
              if (j(yt, Xe, yt.position, !0), Z(zt = yt.input.charCodeAt(++yt.position))) A(yt, !1, fe);
              else if (zt < 256 && x[zt]) yt.result += V[zt], yt.position++;
              else if (($t = (Bt = zt) === 120 ? 2 : Bt === 117 ? 4 : Bt === 85 ? 8 : 0) > 0) {
                for (Vt = $t, Rt = 0; Vt > 0; Vt--) ($t = M(zt = yt.input.charCodeAt(++yt.position))) >= 0 ? Rt = (Rt << 4) + $t : z(yt, "expected hexadecimal character");
                yt.result += W(Rt), yt.position++;
              } else z(yt, "unknown escape sequence");
              Xe = Se = yt.position;
            } else Z(zt) ? (j(yt, Xe, Se, !0), ct(yt, A(yt, !1, fe)), Xe = Se = yt.position) : yt.position === yt.lineStart && E(yt) ? z(yt, "unexpected end of the document within a double quoted scalar") : (yt.position++, Se = yt.position);
          }
          z(yt, "unexpected end of the stream within a double quoted scalar");
        })(D, At) ? ee = !0 : (function(yt) {
          var fe, Xe, Se;
          if ((Se = yt.input.charCodeAt(yt.position)) !== 42) return !1;
          for (Se = yt.input.charCodeAt(++yt.position), fe = yt.position; Se !== 0 && !f(Se) && !T(Se); ) Se = yt.input.charCodeAt(++yt.position);
          return yt.position === fe && z(yt, "name of an alias node must contain at least one character"), Xe = yt.input.slice(fe, yt.position), yt.anchorMap.hasOwnProperty(Xe) || z(yt, 'unidentified alias "' + Xe + '"'), yt.result = yt.anchorMap[Xe], A(yt, !0, -1), !0;
        })(D) ? (ee = !0, D.tag === null && D.anchor === null || z(D, "alias node should not have any properties")) : (function(yt, fe, Xe) {
          var Se, Vt, Rt, $t, zt, Bt, Kt, ne, ae = yt.kind, Ge = yt.result;
          if (f(ne = yt.input.charCodeAt(yt.position)) || T(ne) || ne === 35 || ne === 38 || ne === 42 || ne === 33 || ne === 124 || ne === 62 || ne === 39 || ne === 34 || ne === 37 || ne === 64 || ne === 96 || (ne === 63 || ne === 45) && (f(Se = yt.input.charCodeAt(yt.position + 1)) || Xe && T(Se))) return !1;
          for (yt.kind = "scalar", yt.result = "", Vt = Rt = yt.position, $t = !1; ne !== 0; ) {
            if (ne === 58) {
              if (f(Se = yt.input.charCodeAt(yt.position + 1)) || Xe && T(Se)) break;
            } else if (ne === 35) {
              if (f(yt.input.charCodeAt(yt.position - 1))) break;
            } else {
              if (yt.position === yt.lineStart && E(yt) || Xe && T(ne)) break;
              if (Z(ne)) {
                if (zt = yt.line, Bt = yt.lineStart, Kt = yt.lineIndent, A(yt, !1, -1), yt.lineIndent >= fe) {
                  $t = !0, ne = yt.input.charCodeAt(yt.position);
                  continue;
                }
                yt.position = Rt, yt.line = zt, yt.lineStart = Bt, yt.lineIndent = Kt;
                break;
              }
            }
            $t && (j(yt, Vt, Rt, !1), ct(yt, yt.line - zt), Vt = Rt = yt.position, $t = !1), g(ne) || (Rt = yt.position + 1), ne = yt.input.charCodeAt(++yt.position);
          }
          return j(yt, Vt, Rt, !1), !!yt.result || (yt.kind = ae, yt.result = Ge, !1);
        })(D, At, nt === 1) && (ee = !0, D.tag === null && (D.tag = "?")), D.anchor !== null && (D.anchorMap[D.anchor] = D.result)) : ue === 0 && (ee = lt && at(D, he))), D.tag !== null && D.tag !== "!") if (D.tag === "?") {
          for (D.result !== null && D.kind !== "scalar" && z(D, 'unacceptable node kind for !<?> tag; it should be "scalar", not "' + D.kind + '"'), mt = 0, wt = D.implicitTypes.length; mt < wt; mt += 1) if ((Xt = D.implicitTypes[mt]).resolve(D.result)) {
            D.result = Xt.construct(D.result), D.tag = Xt.tag, D.anchor !== null && (D.anchorMap[D.anchor] = D.result);
            break;
          }
        } else u.call(D.typeMap[D.kind || "fallback"], D.tag) ? (Xt = D.typeMap[D.kind || "fallback"][D.tag], D.result !== null && Xt.kind !== D.kind && z(D, "unacceptable node kind for !<" + D.tag + '> tag; it should be "' + Xt.kind + '", not "' + D.kind + '"'), Xt.resolve(D.result) ? (D.result = Xt.construct(D.result), D.anchor !== null && (D.anchorMap[D.anchor] = D.result)) : z(D, "cannot resolve a node with !<" + D.tag + "> explicit tag")) : z(D, "unknown tag !<" + D.tag + ">");
        return D.listener !== null && D.listener("close", D), D.tag !== null || D.anchor !== null || ee;
      }
      function Zt(D) {
        var q, nt, et, ot, it = D.position, ht = !1;
        for (D.version = null, D.checkLineBreaks = D.legacy, D.tagMap = {}, D.anchorMap = {}; (ot = D.input.charCodeAt(D.position)) !== 0 && (A(D, !0, -1), ot = D.input.charCodeAt(D.position), !(D.lineIndent > 0 || ot !== 37)); ) {
          for (ht = !0, ot = D.input.charCodeAt(++D.position), q = D.position; ot !== 0 && !f(ot); ) ot = D.input.charCodeAt(++D.position);
          for (et = [], (nt = D.input.slice(q, D.position)).length < 1 && z(D, "directive name must not be less than one character in length"); ot !== 0; ) {
            for (; g(ot); ) ot = D.input.charCodeAt(++D.position);
            if (ot === 35) {
              do
                ot = D.input.charCodeAt(++D.position);
              while (ot !== 0 && !Z(ot));
              break;
            }
            if (Z(ot)) break;
            for (q = D.position; ot !== 0 && !f(ot); ) ot = D.input.charCodeAt(++D.position);
            et.push(D.input.slice(q, D.position));
          }
          ot !== 0 && $(D), u.call(P, nt) ? P[nt](D, nt, et) : F(D, 'unknown document directive "' + nt + '"');
        }
        A(D, !0, -1), D.lineIndent === 0 && D.input.charCodeAt(D.position) === 45 && D.input.charCodeAt(D.position + 1) === 45 && D.input.charCodeAt(D.position + 2) === 45 ? (D.position += 3, A(D, !0, -1)) : ht && z(D, "directives end mark is expected"), Wt(D, D.lineIndent - 1, 4, !1, !0), A(D, !0, -1), D.checkLineBreaks && h.test(D.input.slice(it, D.position)) && F(D, "non-ASCII line breaks are interpreted as content"), D.documents.push(D.result), D.position === D.lineStart && E(D) ? D.input.charCodeAt(D.position) === 46 && (D.position += 3, A(D, !0, -1)) : D.position < D.length - 1 && z(D, "end of the stream or a document separator is expected");
      }
      function Gt(D, q) {
        q = q || {}, (D = String(D)).length !== 0 && (D.charCodeAt(D.length - 1) !== 10 && D.charCodeAt(D.length - 1) !== 13 && (D += `
`), D.charCodeAt(0) === 65279 && (D = D.slice(1)));
        var nt = new C(D, q), et = D.indexOf("\0");
        for (et !== -1 && (nt.position = et, z(nt, "null byte is not allowed in input")), nt.input += "\0"; nt.input.charCodeAt(nt.position) === 32; ) nt.lineIndent += 1, nt.position += 1;
        for (; nt.position < nt.length - 1; ) Zt(nt);
        return nt.documents;
      }
      function Tt(D, q, nt) {
        q !== null && typeof q == "object" && nt === void 0 && (nt = q, q = null);
        var et = Gt(D, nt);
        if (typeof q != "function") return et;
        for (var ot = 0, it = et.length; ot < it; ot += 1) q(et[ot]);
      }
      function Q(D, q) {
        var nt = Gt(D, q);
        if (nt.length !== 0) {
          if (nt.length === 1) return nt[0];
          throw new a("expected a single document in the stream, but found more");
        }
      }
      e.exports.loadAll = Tt, e.exports.load = Q, e.exports.safeLoadAll = function(D, q, nt) {
        return typeof q == "object" && q !== null && nt === void 0 && (nt = q, q = null), Tt(D, q, r.extend({ schema: l }, nt));
      }, e.exports.safeLoad = function(D, q) {
        return Q(D, r.extend({ schema: l }, q));
      };
    }, function(e, n, s) {
      var r = s(38);
      function a(o, l, c, u, d) {
        this.name = o, this.buffer = l, this.position = c, this.line = u, this.column = d;
      }
      a.prototype.getSnippet = function(o, l) {
        var c, u, d, h, p;
        if (!this.buffer) return null;
        for (o = o || 4, l = l || 75, c = "", u = this.position; u > 0 && `\0\r
\u2028\u2029`.indexOf(this.buffer.charAt(u - 1)) === -1; ) if (u -= 1, this.position - u > l / 2 - 1) {
          c = " ... ", u += 5;
          break;
        }
        for (d = "", h = this.position; h < this.buffer.length && `\0\r
\u2028\u2029`.indexOf(this.buffer.charAt(h)) === -1; ) if ((h += 1) - this.position > l / 2 - 1) {
          d = " ... ", h -= 5;
          break;
        }
        return p = this.buffer.slice(u, h), r.repeat(" ", o) + c + p + d + `
` + r.repeat(" ", o + this.position - u + c.length) + "^";
      }, a.prototype.toString = function(o) {
        var l, c = "";
        return this.name && (c += 'in "' + this.name + '" '), c += "at line " + (this.line + 1) + ", column " + (this.column + 1), o || (l = this.getSnippet()) && (c += `:
` + l), c;
      }, e.exports = a;
    }, function(e, n, s) {
      var r = s(10);
      e.exports = new r("tag:yaml.org,2002:str", { kind: "scalar", construct: function(a) {
        return a !== null ? a : "";
      } });
    }, function(e, n, s) {
      var r = s(10);
      e.exports = new r("tag:yaml.org,2002:seq", { kind: "sequence", construct: function(a) {
        return a !== null ? a : [];
      } });
    }, function(e, n, s) {
      var r = s(10);
      e.exports = new r("tag:yaml.org,2002:map", { kind: "mapping", construct: function(a) {
        return a !== null ? a : {};
      } });
    }, function(e, n, s) {
      var r = s(10);
      e.exports = new r("tag:yaml.org,2002:null", { kind: "scalar", resolve: function(a) {
        if (a === null) return !0;
        var o = a.length;
        return o === 1 && a === "~" || o === 4 && (a === "null" || a === "Null" || a === "NULL");
      }, construct: function() {
        return null;
      }, predicate: function(a) {
        return a === null;
      }, represent: { canonical: function() {
        return "~";
      }, lowercase: function() {
        return "null";
      }, uppercase: function() {
        return "NULL";
      }, camelcase: function() {
        return "Null";
      } }, defaultStyle: "lowercase" });
    }, function(e, n, s) {
      var r = s(10);
      e.exports = new r("tag:yaml.org,2002:bool", { kind: "scalar", resolve: function(a) {
        if (a === null) return !1;
        var o = a.length;
        return o === 4 && (a === "true" || a === "True" || a === "TRUE") || o === 5 && (a === "false" || a === "False" || a === "FALSE");
      }, construct: function(a) {
        return a === "true" || a === "True" || a === "TRUE";
      }, predicate: function(a) {
        return Object.prototype.toString.call(a) === "[object Boolean]";
      }, represent: { lowercase: function(a) {
        return a ? "true" : "false";
      }, uppercase: function(a) {
        return a ? "TRUE" : "FALSE";
      }, camelcase: function(a) {
        return a ? "True" : "False";
      } }, defaultStyle: "lowercase" });
    }, function(e, n, s) {
      var r = s(38), a = s(10);
      function o(c) {
        return 48 <= c && c <= 55;
      }
      function l(c) {
        return 48 <= c && c <= 57;
      }
      e.exports = new a("tag:yaml.org,2002:int", { kind: "scalar", resolve: function(c) {
        if (c === null) return !1;
        var u, d, h = c.length, p = 0, m = !1;
        if (!h) return !1;
        if ((u = c[p]) !== "-" && u !== "+" || (u = c[++p]), u === "0") {
          if (p + 1 === h) return !0;
          if ((u = c[++p]) === "b") {
            for (p++; p < h; p++) if ((u = c[p]) !== "_") {
              if (u !== "0" && u !== "1") return !1;
              m = !0;
            }
            return m && u !== "_";
          }
          if (u === "x") {
            for (p++; p < h; p++) if ((u = c[p]) !== "_") {
              if (!(48 <= (d = c.charCodeAt(p)) && d <= 57 || 65 <= d && d <= 70 || 97 <= d && d <= 102)) return !1;
              m = !0;
            }
            return m && u !== "_";
          }
          for (; p < h; p++) if ((u = c[p]) !== "_") {
            if (!o(c.charCodeAt(p))) return !1;
            m = !0;
          }
          return m && u !== "_";
        }
        if (u === "_") return !1;
        for (; p < h; p++) if ((u = c[p]) !== "_") {
          if (u === ":") break;
          if (!l(c.charCodeAt(p))) return !1;
          m = !0;
        }
        return !(!m || u === "_") && (u !== ":" || /^(:[0-5]?[0-9])+$/.test(c.slice(p)));
      }, construct: function(c) {
        var u, d, h = c, p = 1, m = [];
        return h.indexOf("_") !== -1 && (h = h.replace(/_/g, "")), (u = h[0]) !== "-" && u !== "+" || (u === "-" && (p = -1), u = (h = h.slice(1))[0]), h === "0" ? 0 : u === "0" ? h[1] === "b" ? p * parseInt(h.slice(2), 2) : h[1] === "x" ? p * parseInt(h, 16) : p * parseInt(h, 8) : h.indexOf(":") !== -1 ? (h.split(":").forEach((function(b) {
          m.unshift(parseInt(b, 10));
        })), h = 0, d = 1, m.forEach((function(b) {
          h += b * d, d *= 60;
        })), p * h) : p * parseInt(h, 10);
      }, predicate: function(c) {
        return Object.prototype.toString.call(c) === "[object Number]" && c % 1 == 0 && !r.isNegativeZero(c);
      }, represent: { binary: function(c) {
        return c >= 0 ? "0b" + c.toString(2) : "-0b" + c.toString(2).slice(1);
      }, octal: function(c) {
        return c >= 0 ? "0" + c.toString(8) : "-0" + c.toString(8).slice(1);
      }, decimal: function(c) {
        return c.toString(10);
      }, hexadecimal: function(c) {
        return c >= 0 ? "0x" + c.toString(16).toUpperCase() : "-0x" + c.toString(16).toUpperCase().slice(1);
      } }, defaultStyle: "decimal", styleAliases: { binary: [2, "bin"], octal: [8, "oct"], decimal: [10, "dec"], hexadecimal: [16, "hex"] } });
    }, function(e, n, s) {
      var r = s(38), a = s(10), o = new RegExp("^(?:[-+]?(?:0|[1-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?|[-+]?[0-9][0-9_]*(?::[0-5]?[0-9])+\\.[0-9_]*|[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$"), l = /^[-+]?[0-9]+e/;
      e.exports = new a("tag:yaml.org,2002:float", { kind: "scalar", resolve: function(c) {
        return c !== null && !(!o.test(c) || c[c.length - 1] === "_");
      }, construct: function(c) {
        var u, d, h, p;
        return d = (u = c.replace(/_/g, "").toLowerCase())[0] === "-" ? -1 : 1, p = [], "+-".indexOf(u[0]) >= 0 && (u = u.slice(1)), u === ".inf" ? d === 1 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY : u === ".nan" ? NaN : u.indexOf(":") >= 0 ? (u.split(":").forEach((function(m) {
          p.unshift(parseFloat(m, 10));
        })), u = 0, h = 1, p.forEach((function(m) {
          u += m * h, h *= 60;
        })), d * u) : d * parseFloat(u, 10);
      }, predicate: function(c) {
        return Object.prototype.toString.call(c) === "[object Number]" && (c % 1 != 0 || r.isNegativeZero(c));
      }, represent: function(c, u) {
        var d;
        if (isNaN(c)) switch (u) {
          case "lowercase":
            return ".nan";
          case "uppercase":
            return ".NAN";
          case "camelcase":
            return ".NaN";
        }
        else if (Number.POSITIVE_INFINITY === c) switch (u) {
          case "lowercase":
            return ".inf";
          case "uppercase":
            return ".INF";
          case "camelcase":
            return ".Inf";
        }
        else if (Number.NEGATIVE_INFINITY === c) switch (u) {
          case "lowercase":
            return "-.inf";
          case "uppercase":
            return "-.INF";
          case "camelcase":
            return "-.Inf";
        }
        else if (r.isNegativeZero(c)) return "-0.0";
        return d = c.toString(10), l.test(d) ? d.replace("e", ".e") : d;
      }, defaultStyle: "lowercase" });
    }, function(e, n, s) {
      var r = s(10), a = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9])-([0-9][0-9])$"), o = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9]?)-([0-9][0-9]?)(?:[Tt]|[ \\t]+)([0-9][0-9]?):([0-9][0-9]):([0-9][0-9])(?:\\.([0-9]*))?(?:[ \\t]*(Z|([-+])([0-9][0-9]?)(?::([0-9][0-9]))?))?$");
      e.exports = new r("tag:yaml.org,2002:timestamp", { kind: "scalar", resolve: function(l) {
        return l !== null && (a.exec(l) !== null || o.exec(l) !== null);
      }, construct: function(l) {
        var c, u, d, h, p, m, b, y, Z = 0, g = null;
        if ((c = a.exec(l)) === null && (c = o.exec(l)), c === null) throw new Error("Date resolve error");
        if (u = +c[1], d = +c[2] - 1, h = +c[3], !c[4]) return new Date(Date.UTC(u, d, h));
        if (p = +c[4], m = +c[5], b = +c[6], c[7]) {
          for (Z = c[7].slice(0, 3); Z.length < 3; ) Z += "0";
          Z = +Z;
        }
        return c[9] && (g = 6e4 * (60 * +c[10] + +(c[11] || 0)), c[9] === "-" && (g = -g)), y = new Date(Date.UTC(u, d, h, p, m, b, Z)), g && y.setTime(y.getTime() - g), y;
      }, instanceOf: Date, represent: function(l) {
        return l.toISOString();
      } });
    }, function(e, n, s) {
      var r = s(10);
      e.exports = new r("tag:yaml.org,2002:merge", { kind: "scalar", resolve: function(a) {
        return a === "<<" || a === null;
      } });
    }, function(e, n, s) {
      var r;
      try {
        r = s(145).Buffer;
      } catch {
      }
      var a = s(10), o = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=
\r`;
      e.exports = new a("tag:yaml.org,2002:binary", { kind: "scalar", resolve: function(l) {
        if (l === null) return !1;
        var c, u, d = 0, h = l.length, p = o;
        for (u = 0; u < h; u++) if (!((c = p.indexOf(l.charAt(u))) > 64)) {
          if (c < 0) return !1;
          d += 6;
        }
        return d % 8 == 0;
      }, construct: function(l) {
        var c, u, d = l.replace(/[\r\n=]/g, ""), h = d.length, p = o, m = 0, b = [];
        for (c = 0; c < h; c++) c % 4 == 0 && c && (b.push(m >> 16 & 255), b.push(m >> 8 & 255), b.push(255 & m)), m = m << 6 | p.indexOf(d.charAt(c));
        return (u = h % 4 * 6) === 0 ? (b.push(m >> 16 & 255), b.push(m >> 8 & 255), b.push(255 & m)) : u === 18 ? (b.push(m >> 10 & 255), b.push(m >> 2 & 255)) : u === 12 && b.push(m >> 4 & 255), r ? r.from ? r.from(b) : new r(b) : b;
      }, predicate: function(l) {
        return r && r.isBuffer(l);
      }, represent: function(l) {
        var c, u, d = "", h = 0, p = l.length, m = o;
        for (c = 0; c < p; c++) c % 3 == 0 && c && (d += m[h >> 18 & 63], d += m[h >> 12 & 63], d += m[h >> 6 & 63], d += m[63 & h]), h = (h << 8) + l[c];
        return (u = p % 3) === 0 ? (d += m[h >> 18 & 63], d += m[h >> 12 & 63], d += m[h >> 6 & 63], d += m[63 & h]) : u === 2 ? (d += m[h >> 10 & 63], d += m[h >> 4 & 63], d += m[h << 2 & 63], d += m[64]) : u === 1 && (d += m[h >> 2 & 63], d += m[h << 4 & 63], d += m[64], d += m[64]), d;
      } });
    }, function(e, n, s) {
      var r = s(10), a = Object.prototype.hasOwnProperty, o = Object.prototype.toString;
      e.exports = new r("tag:yaml.org,2002:omap", { kind: "sequence", resolve: function(l) {
        if (l === null) return !0;
        var c, u, d, h, p, m = [], b = l;
        for (c = 0, u = b.length; c < u; c += 1) {
          if (d = b[c], p = !1, o.call(d) !== "[object Object]") return !1;
          for (h in d) if (a.call(d, h)) {
            if (p) return !1;
            p = !0;
          }
          if (!p || m.indexOf(h) !== -1) return !1;
          m.push(h);
        }
        return !0;
      }, construct: function(l) {
        return l !== null ? l : [];
      } });
    }, function(e, n, s) {
      var r = s(10), a = Object.prototype.toString;
      e.exports = new r("tag:yaml.org,2002:pairs", { kind: "sequence", resolve: function(o) {
        if (o === null) return !0;
        var l, c, u, d, h, p = o;
        for (h = new Array(p.length), l = 0, c = p.length; l < c; l += 1) {
          if (u = p[l], a.call(u) !== "[object Object]" || (d = Object.keys(u)).length !== 1) return !1;
          h[l] = [d[0], u[d[0]]];
        }
        return !0;
      }, construct: function(o) {
        if (o === null) return [];
        var l, c, u, d, h, p = o;
        for (h = new Array(p.length), l = 0, c = p.length; l < c; l += 1) u = p[l], d = Object.keys(u), h[l] = [d[0], u[d[0]]];
        return h;
      } });
    }, function(e, n, s) {
      var r = s(10), a = Object.prototype.hasOwnProperty;
      e.exports = new r("tag:yaml.org,2002:set", { kind: "mapping", resolve: function(o) {
        if (o === null) return !0;
        var l, c = o;
        for (l in c) if (a.call(c, l) && c[l] !== null) return !1;
        return !0;
      }, construct: function(o) {
        return o !== null ? o : {};
      } });
    }, function(e, n, s) {
      var r = s(10);
      e.exports = new r("tag:yaml.org,2002:js/undefined", { kind: "scalar", resolve: function() {
        return !0;
      }, construct: function() {
      }, predicate: function(a) {
        return a === void 0;
      }, represent: function() {
        return "";
      } });
    }, function(e, n, s) {
      var r = s(10);
      e.exports = new r("tag:yaml.org,2002:js/regexp", { kind: "scalar", resolve: function(a) {
        if (a === null || a.length === 0) return !1;
        var o = a, l = /\/([gim]*)$/.exec(a), c = "";
        return !(o[0] === "/" && (l && (c = l[1]), c.length > 3 || o[o.length - c.length - 1] !== "/"));
      }, construct: function(a) {
        var o = a, l = /\/([gim]*)$/.exec(a), c = "";
        return o[0] === "/" && (l && (c = l[1]), o = o.slice(1, o.length - c.length - 1)), new RegExp(o, c);
      }, predicate: function(a) {
        return Object.prototype.toString.call(a) === "[object RegExp]";
      }, represent: function(a) {
        var o = "/" + a.source + "/";
        return a.global && (o += "g"), a.multiline && (o += "m"), a.ignoreCase && (o += "i"), o;
      } });
    }, function(e, n, s) {
      var r;
      try {
        r = s(302);
      } catch {
        typeof window < "u" && (r = window.esprima);
      }
      var a = s(10);
      e.exports = new a("tag:yaml.org,2002:js/function", { kind: "scalar", resolve: function(o) {
        if (o === null) return !1;
        try {
          var l = "(" + o + ")", c = r.parse(l, { range: !0 });
          return c.type === "Program" && c.body.length === 1 && c.body[0].type === "ExpressionStatement" && (c.body[0].expression.type === "ArrowFunctionExpression" || c.body[0].expression.type === "FunctionExpression");
        } catch {
          return !1;
        }
      }, construct: function(o) {
        var l, c = "(" + o + ")", u = r.parse(c, { range: !0 }), d = [];
        if (u.type !== "Program" || u.body.length !== 1 || u.body[0].type !== "ExpressionStatement" || u.body[0].expression.type !== "ArrowFunctionExpression" && u.body[0].expression.type !== "FunctionExpression") throw new Error("Failed to resolve function");
        return u.body[0].expression.params.forEach((function(h) {
          d.push(h.name);
        })), l = u.body[0].expression.body.range, u.body[0].expression.body.type === "BlockStatement" ? new Function(d, c.slice(l[0] + 1, l[1] - 1)) : new Function(d, "return " + c.slice(l[0], l[1]));
      }, predicate: function(o) {
        return Object.prototype.toString.call(o) === "[object Function]";
      }, represent: function(o) {
        return o.toString();
      } });
    }, function(e, n, s) {
      var r;
      r = function() {
        return (function(a) {
          var o = {};
          function l(c) {
            if (o[c]) return o[c].exports;
            var u = o[c] = { exports: {}, id: c, loaded: !1 };
            return a[c].call(u.exports, u, u.exports, l), u.loaded = !0, u.exports;
          }
          return l.m = a, l.c = o, l.p = "", l(0);
        })([function(a, o, l) {
          Object.defineProperty(o, "__esModule", { value: !0 });
          var c = l(1), u = l(3), d = l(8), h = l(15);
          function p(b, y, Z) {
            var g = null, f = function(X, C) {
              Z && Z(X, C), g && g.visit(X, C);
            }, T = typeof Z == "function" ? f : null, M = !1;
            if (y) {
              M = typeof y.comment == "boolean" && y.comment;
              var N = typeof y.attachComment == "boolean" && y.attachComment;
              (M || N) && ((g = new c.CommentHandler()).attach = N, y.comment = !0, T = f);
            }
            var W, x = !1;
            y && typeof y.sourceType == "string" && (x = y.sourceType === "module"), W = y && typeof y.jsx == "boolean" && y.jsx ? new u.JSXParser(b, y, T) : new d.Parser(b, y, T);
            var V = x ? W.parseModule() : W.parseScript();
            return M && g && (V.comments = g.comments), W.config.tokens && (V.tokens = W.tokens), W.config.tolerant && (V.errors = W.errorHandler.errors), V;
          }
          o.parse = p, o.parseModule = function(b, y, Z) {
            var g = y || {};
            return g.sourceType = "module", p(b, g, Z);
          }, o.parseScript = function(b, y, Z) {
            var g = y || {};
            return g.sourceType = "script", p(b, g, Z);
          }, o.tokenize = function(b, y, Z) {
            var g, f = new h.Tokenizer(b, y);
            g = [];
            try {
              for (; ; ) {
                var T = f.getNextToken();
                if (!T) break;
                Z && (T = Z(T)), g.push(T);
              }
            } catch (M) {
              f.errorHandler.tolerate(M);
            }
            return f.errorHandler.tolerant && (g.errors = f.errors()), g;
          };
          var m = l(2);
          o.Syntax = m.Syntax, o.version = "4.0.1";
        }, function(a, o, l) {
          Object.defineProperty(o, "__esModule", { value: !0 });
          var c = l(2), u = (function() {
            function d() {
              this.attach = !1, this.comments = [], this.stack = [], this.leading = [], this.trailing = [];
            }
            return d.prototype.insertInnerComments = function(h, p) {
              if (h.type === c.Syntax.BlockStatement && h.body.length === 0) {
                for (var m = [], b = this.leading.length - 1; b >= 0; --b) {
                  var y = this.leading[b];
                  p.end.offset >= y.start && (m.unshift(y.comment), this.leading.splice(b, 1), this.trailing.splice(b, 1));
                }
                m.length && (h.innerComments = m);
              }
            }, d.prototype.findTrailingComments = function(h) {
              var p = [];
              if (this.trailing.length > 0) {
                for (var m = this.trailing.length - 1; m >= 0; --m) {
                  var b = this.trailing[m];
                  b.start >= h.end.offset && p.unshift(b.comment);
                }
                return this.trailing.length = 0, p;
              }
              var y = this.stack[this.stack.length - 1];
              if (y && y.node.trailingComments) {
                var Z = y.node.trailingComments[0];
                Z && Z.range[0] >= h.end.offset && (p = y.node.trailingComments, delete y.node.trailingComments);
              }
              return p;
            }, d.prototype.findLeadingComments = function(h) {
              for (var p, m = []; this.stack.length > 0 && (Z = this.stack[this.stack.length - 1]) && Z.start >= h.start.offset; ) p = Z.node, this.stack.pop();
              if (p) {
                for (var b = (p.leadingComments ? p.leadingComments.length : 0) - 1; b >= 0; --b) {
                  var y = p.leadingComments[b];
                  y.range[1] <= h.start.offset && (m.unshift(y), p.leadingComments.splice(b, 1));
                }
                return p.leadingComments && p.leadingComments.length === 0 && delete p.leadingComments, m;
              }
              for (b = this.leading.length - 1; b >= 0; --b) {
                var Z;
                (Z = this.leading[b]).start <= h.start.offset && (m.unshift(Z.comment), this.leading.splice(b, 1));
              }
              return m;
            }, d.prototype.visitNode = function(h, p) {
              if (!(h.type === c.Syntax.Program && h.body.length > 0)) {
                this.insertInnerComments(h, p);
                var m = this.findTrailingComments(p), b = this.findLeadingComments(p);
                b.length > 0 && (h.leadingComments = b), m.length > 0 && (h.trailingComments = m), this.stack.push({ node: h, start: p.start.offset });
              }
            }, d.prototype.visitComment = function(h, p) {
              var m = h.type[0] === "L" ? "Line" : "Block", b = { type: m, value: h.value };
              if (h.range && (b.range = h.range), h.loc && (b.loc = h.loc), this.comments.push(b), this.attach) {
                var y = { comment: { type: m, value: h.value, range: [p.start.offset, p.end.offset] }, start: p.start.offset };
                h.loc && (y.comment.loc = h.loc), h.type = m, this.leading.push(y), this.trailing.push(y);
              }
            }, d.prototype.visit = function(h, p) {
              h.type === "LineComment" || h.type === "BlockComment" ? this.visitComment(h, p) : this.attach && this.visitNode(h, p);
            }, d;
          })();
          o.CommentHandler = u;
        }, function(a, o) {
          Object.defineProperty(o, "__esModule", { value: !0 }), o.Syntax = { AssignmentExpression: "AssignmentExpression", AssignmentPattern: "AssignmentPattern", ArrayExpression: "ArrayExpression", ArrayPattern: "ArrayPattern", ArrowFunctionExpression: "ArrowFunctionExpression", AwaitExpression: "AwaitExpression", BlockStatement: "BlockStatement", BinaryExpression: "BinaryExpression", BreakStatement: "BreakStatement", CallExpression: "CallExpression", CatchClause: "CatchClause", ClassBody: "ClassBody", ClassDeclaration: "ClassDeclaration", ClassExpression: "ClassExpression", ConditionalExpression: "ConditionalExpression", ContinueStatement: "ContinueStatement", DoWhileStatement: "DoWhileStatement", DebuggerStatement: "DebuggerStatement", EmptyStatement: "EmptyStatement", ExportAllDeclaration: "ExportAllDeclaration", ExportDefaultDeclaration: "ExportDefaultDeclaration", ExportNamedDeclaration: "ExportNamedDeclaration", ExportSpecifier: "ExportSpecifier", ExpressionStatement: "ExpressionStatement", ForStatement: "ForStatement", ForOfStatement: "ForOfStatement", ForInStatement: "ForInStatement", FunctionDeclaration: "FunctionDeclaration", FunctionExpression: "FunctionExpression", Identifier: "Identifier", IfStatement: "IfStatement", ImportDeclaration: "ImportDeclaration", ImportDefaultSpecifier: "ImportDefaultSpecifier", ImportNamespaceSpecifier: "ImportNamespaceSpecifier", ImportSpecifier: "ImportSpecifier", Literal: "Literal", LabeledStatement: "LabeledStatement", LogicalExpression: "LogicalExpression", MemberExpression: "MemberExpression", MetaProperty: "MetaProperty", MethodDefinition: "MethodDefinition", NewExpression: "NewExpression", ObjectExpression: "ObjectExpression", ObjectPattern: "ObjectPattern", Program: "Program", Property: "Property", RestElement: "RestElement", ReturnStatement: "ReturnStatement", SequenceExpression: "SequenceExpression", SpreadElement: "SpreadElement", Super: "Super", SwitchCase: "SwitchCase", SwitchStatement: "SwitchStatement", TaggedTemplateExpression: "TaggedTemplateExpression", TemplateElement: "TemplateElement", TemplateLiteral: "TemplateLiteral", ThisExpression: "ThisExpression", ThrowStatement: "ThrowStatement", TryStatement: "TryStatement", UnaryExpression: "UnaryExpression", UpdateExpression: "UpdateExpression", VariableDeclaration: "VariableDeclaration", VariableDeclarator: "VariableDeclarator", WhileStatement: "WhileStatement", WithStatement: "WithStatement", YieldExpression: "YieldExpression" };
        }, function(a, o, l) {
          var c, u = this && this.__extends || (c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(T, M) {
            T.__proto__ = M;
          } || function(T, M) {
            for (var N in M) M.hasOwnProperty(N) && (T[N] = M[N]);
          }, function(T, M) {
            function N() {
              this.constructor = T;
            }
            c(T, M), T.prototype = M === null ? Object.create(M) : (N.prototype = M.prototype, new N());
          });
          Object.defineProperty(o, "__esModule", { value: !0 });
          var d = l(4), h = l(5), p = l(6), m = l(7), b = l(8), y = l(13), Z = l(14);
          function g(T) {
            var M;
            switch (T.type) {
              case p.JSXSyntax.JSXIdentifier:
                M = T.name;
                break;
              case p.JSXSyntax.JSXNamespacedName:
                var N = T;
                M = g(N.namespace) + ":" + g(N.name);
                break;
              case p.JSXSyntax.JSXMemberExpression:
                var W = T;
                M = g(W.object) + "." + g(W.property);
            }
            return M;
          }
          y.TokenName[100] = "JSXIdentifier", y.TokenName[101] = "JSXText";
          var f = (function(T) {
            function M(N, W, x) {
              return T.call(this, N, W, x) || this;
            }
            return u(M, T), M.prototype.parsePrimaryExpression = function() {
              return this.match("<") ? this.parseJSXRoot() : T.prototype.parsePrimaryExpression.call(this);
            }, M.prototype.startJSX = function() {
              this.scanner.index = this.startMarker.index, this.scanner.lineNumber = this.startMarker.line, this.scanner.lineStart = this.startMarker.index - this.startMarker.column;
            }, M.prototype.finishJSX = function() {
              this.nextToken();
            }, M.prototype.reenterJSX = function() {
              this.startJSX(), this.expectJSX("}"), this.config.tokens && this.tokens.pop();
            }, M.prototype.createJSXNode = function() {
              return this.collectComments(), { index: this.scanner.index, line: this.scanner.lineNumber, column: this.scanner.index - this.scanner.lineStart };
            }, M.prototype.createJSXChildNode = function() {
              return { index: this.scanner.index, line: this.scanner.lineNumber, column: this.scanner.index - this.scanner.lineStart };
            }, M.prototype.scanXHTMLEntity = function(N) {
              for (var W = "&", x = !0, V = !1, X = !1, C = !1; !this.scanner.eof() && x && !V; ) {
                var R = this.scanner.source[this.scanner.index];
                if (R === N) break;
                if (V = R === ";", W += R, ++this.scanner.index, !V) switch (W.length) {
                  case 2:
                    X = R === "#";
                    break;
                  case 3:
                    X && (x = (C = R === "x") || d.Character.isDecimalDigit(R.charCodeAt(0)), X = X && !C);
                    break;
                  default:
                    x = (x = x && !(X && !d.Character.isDecimalDigit(R.charCodeAt(0)))) && !(C && !d.Character.isHexDigit(R.charCodeAt(0)));
                }
              }
              if (x && V && W.length > 2) {
                var z = W.substr(1, W.length - 2);
                X && z.length > 1 ? W = String.fromCharCode(parseInt(z.substr(1), 10)) : C && z.length > 2 ? W = String.fromCharCode(parseInt("0" + z.substr(1), 16)) : X || C || !Z.XHTMLEntities[z] || (W = Z.XHTMLEntities[z]);
              }
              return W;
            }, M.prototype.lexJSX = function() {
              var N = this.scanner.source.charCodeAt(this.scanner.index);
              if (N === 60 || N === 62 || N === 47 || N === 58 || N === 61 || N === 123 || N === 125) return { type: 7, value: R = this.scanner.source[this.scanner.index++], lineNumber: this.scanner.lineNumber, lineStart: this.scanner.lineStart, start: this.scanner.index - 1, end: this.scanner.index };
              if (N === 34 || N === 39) {
                for (var W = this.scanner.index, x = this.scanner.source[this.scanner.index++], V = ""; !this.scanner.eof() && (z = this.scanner.source[this.scanner.index++]) !== x; ) V += z === "&" ? this.scanXHTMLEntity(x) : z;
                return { type: 8, value: V, lineNumber: this.scanner.lineNumber, lineStart: this.scanner.lineStart, start: W, end: this.scanner.index };
              }
              if (N === 46) {
                var X = this.scanner.source.charCodeAt(this.scanner.index + 1), C = this.scanner.source.charCodeAt(this.scanner.index + 2), R = X === 46 && C === 46 ? "..." : ".";
                return W = this.scanner.index, this.scanner.index += R.length, { type: 7, value: R, lineNumber: this.scanner.lineNumber, lineStart: this.scanner.lineStart, start: W, end: this.scanner.index };
              }
              if (N === 96) return { type: 10, value: "", lineNumber: this.scanner.lineNumber, lineStart: this.scanner.lineStart, start: this.scanner.index, end: this.scanner.index };
              if (d.Character.isIdentifierStart(N) && N !== 92) {
                for (W = this.scanner.index, ++this.scanner.index; !this.scanner.eof(); ) {
                  var z = this.scanner.source.charCodeAt(this.scanner.index);
                  if (d.Character.isIdentifierPart(z) && z !== 92) ++this.scanner.index;
                  else {
                    if (z !== 45) break;
                    ++this.scanner.index;
                  }
                }
                return { type: 100, value: this.scanner.source.slice(W, this.scanner.index), lineNumber: this.scanner.lineNumber, lineStart: this.scanner.lineStart, start: W, end: this.scanner.index };
              }
              return this.scanner.lex();
            }, M.prototype.nextJSXToken = function() {
              this.collectComments(), this.startMarker.index = this.scanner.index, this.startMarker.line = this.scanner.lineNumber, this.startMarker.column = this.scanner.index - this.scanner.lineStart;
              var N = this.lexJSX();
              return this.lastMarker.index = this.scanner.index, this.lastMarker.line = this.scanner.lineNumber, this.lastMarker.column = this.scanner.index - this.scanner.lineStart, this.config.tokens && this.tokens.push(this.convertToken(N)), N;
            }, M.prototype.nextJSXText = function() {
              this.startMarker.index = this.scanner.index, this.startMarker.line = this.scanner.lineNumber, this.startMarker.column = this.scanner.index - this.scanner.lineStart;
              for (var N = this.scanner.index, W = ""; !this.scanner.eof(); ) {
                var x = this.scanner.source[this.scanner.index];
                if (x === "{" || x === "<") break;
                ++this.scanner.index, W += x, d.Character.isLineTerminator(x.charCodeAt(0)) && (++this.scanner.lineNumber, x === "\r" && this.scanner.source[this.scanner.index] === `
` && ++this.scanner.index, this.scanner.lineStart = this.scanner.index);
              }
              this.lastMarker.index = this.scanner.index, this.lastMarker.line = this.scanner.lineNumber, this.lastMarker.column = this.scanner.index - this.scanner.lineStart;
              var V = { type: 101, value: W, lineNumber: this.scanner.lineNumber, lineStart: this.scanner.lineStart, start: N, end: this.scanner.index };
              return W.length > 0 && this.config.tokens && this.tokens.push(this.convertToken(V)), V;
            }, M.prototype.peekJSXToken = function() {
              var N = this.scanner.saveState();
              this.scanner.scanComments();
              var W = this.lexJSX();
              return this.scanner.restoreState(N), W;
            }, M.prototype.expectJSX = function(N) {
              var W = this.nextJSXToken();
              W.type === 7 && W.value === N || this.throwUnexpectedToken(W);
            }, M.prototype.matchJSX = function(N) {
              var W = this.peekJSXToken();
              return W.type === 7 && W.value === N;
            }, M.prototype.parseJSXIdentifier = function() {
              var N = this.createJSXNode(), W = this.nextJSXToken();
              return W.type !== 100 && this.throwUnexpectedToken(W), this.finalize(N, new h.JSXIdentifier(W.value));
            }, M.prototype.parseJSXElementName = function() {
              var N = this.createJSXNode(), W = this.parseJSXIdentifier();
              if (this.matchJSX(":")) {
                var x = W;
                this.expectJSX(":");
                var V = this.parseJSXIdentifier();
                W = this.finalize(N, new h.JSXNamespacedName(x, V));
              } else if (this.matchJSX(".")) for (; this.matchJSX("."); ) {
                var X = W;
                this.expectJSX(".");
                var C = this.parseJSXIdentifier();
                W = this.finalize(N, new h.JSXMemberExpression(X, C));
              }
              return W;
            }, M.prototype.parseJSXAttributeName = function() {
              var N, W = this.createJSXNode(), x = this.parseJSXIdentifier();
              if (this.matchJSX(":")) {
                var V = x;
                this.expectJSX(":");
                var X = this.parseJSXIdentifier();
                N = this.finalize(W, new h.JSXNamespacedName(V, X));
              } else N = x;
              return N;
            }, M.prototype.parseJSXStringLiteralAttribute = function() {
              var N = this.createJSXNode(), W = this.nextJSXToken();
              W.type !== 8 && this.throwUnexpectedToken(W);
              var x = this.getTokenRaw(W);
              return this.finalize(N, new m.Literal(W.value, x));
            }, M.prototype.parseJSXExpressionAttribute = function() {
              var N = this.createJSXNode();
              this.expectJSX("{"), this.finishJSX(), this.match("}") && this.tolerateError("JSX attributes must only be assigned a non-empty expression");
              var W = this.parseAssignmentExpression();
              return this.reenterJSX(), this.finalize(N, new h.JSXExpressionContainer(W));
            }, M.prototype.parseJSXAttributeValue = function() {
              return this.matchJSX("{") ? this.parseJSXExpressionAttribute() : this.matchJSX("<") ? this.parseJSXElement() : this.parseJSXStringLiteralAttribute();
            }, M.prototype.parseJSXNameValueAttribute = function() {
              var N = this.createJSXNode(), W = this.parseJSXAttributeName(), x = null;
              return this.matchJSX("=") && (this.expectJSX("="), x = this.parseJSXAttributeValue()), this.finalize(N, new h.JSXAttribute(W, x));
            }, M.prototype.parseJSXSpreadAttribute = function() {
              var N = this.createJSXNode();
              this.expectJSX("{"), this.expectJSX("..."), this.finishJSX();
              var W = this.parseAssignmentExpression();
              return this.reenterJSX(), this.finalize(N, new h.JSXSpreadAttribute(W));
            }, M.prototype.parseJSXAttributes = function() {
              for (var N = []; !this.matchJSX("/") && !this.matchJSX(">"); ) {
                var W = this.matchJSX("{") ? this.parseJSXSpreadAttribute() : this.parseJSXNameValueAttribute();
                N.push(W);
              }
              return N;
            }, M.prototype.parseJSXOpeningElement = function() {
              var N = this.createJSXNode();
              this.expectJSX("<");
              var W = this.parseJSXElementName(), x = this.parseJSXAttributes(), V = this.matchJSX("/");
              return V && this.expectJSX("/"), this.expectJSX(">"), this.finalize(N, new h.JSXOpeningElement(W, V, x));
            }, M.prototype.parseJSXBoundaryElement = function() {
              var N = this.createJSXNode();
              if (this.expectJSX("<"), this.matchJSX("/")) {
                this.expectJSX("/");
                var W = this.parseJSXElementName();
                return this.expectJSX(">"), this.finalize(N, new h.JSXClosingElement(W));
              }
              var x = this.parseJSXElementName(), V = this.parseJSXAttributes(), X = this.matchJSX("/");
              return X && this.expectJSX("/"), this.expectJSX(">"), this.finalize(N, new h.JSXOpeningElement(x, X, V));
            }, M.prototype.parseJSXEmptyExpression = function() {
              var N = this.createJSXChildNode();
              return this.collectComments(), this.lastMarker.index = this.scanner.index, this.lastMarker.line = this.scanner.lineNumber, this.lastMarker.column = this.scanner.index - this.scanner.lineStart, this.finalize(N, new h.JSXEmptyExpression());
            }, M.prototype.parseJSXExpressionContainer = function() {
              var N, W = this.createJSXNode();
              return this.expectJSX("{"), this.matchJSX("}") ? (N = this.parseJSXEmptyExpression(), this.expectJSX("}")) : (this.finishJSX(), N = this.parseAssignmentExpression(), this.reenterJSX()), this.finalize(W, new h.JSXExpressionContainer(N));
            }, M.prototype.parseJSXChildren = function() {
              for (var N = []; !this.scanner.eof(); ) {
                var W = this.createJSXChildNode(), x = this.nextJSXText();
                if (x.start < x.end) {
                  var V = this.getTokenRaw(x), X = this.finalize(W, new h.JSXText(x.value, V));
                  N.push(X);
                }
                if (this.scanner.source[this.scanner.index] !== "{") break;
                var C = this.parseJSXExpressionContainer();
                N.push(C);
              }
              return N;
            }, M.prototype.parseComplexJSXElement = function(N) {
              for (var W = []; !this.scanner.eof(); ) {
                N.children = N.children.concat(this.parseJSXChildren());
                var x = this.createJSXChildNode(), V = this.parseJSXBoundaryElement();
                if (V.type === p.JSXSyntax.JSXOpeningElement) {
                  var X = V;
                  if (X.selfClosing) {
                    var C = this.finalize(x, new h.JSXElement(X, [], null));
                    N.children.push(C);
                  } else W.push(N), N = { node: x, opening: X, closing: null, children: [] };
                }
                if (V.type === p.JSXSyntax.JSXClosingElement) {
                  N.closing = V;
                  var R = g(N.opening.name);
                  if (R !== g(N.closing.name) && this.tolerateError("Expected corresponding JSX closing tag for %0", R), !(W.length > 0)) break;
                  C = this.finalize(N.node, new h.JSXElement(N.opening, N.children, N.closing)), (N = W[W.length - 1]).children.push(C), W.pop();
                }
              }
              return N;
            }, M.prototype.parseJSXElement = function() {
              var N = this.createJSXNode(), W = this.parseJSXOpeningElement(), x = [], V = null;
              if (!W.selfClosing) {
                var X = this.parseComplexJSXElement({ node: N, opening: W, closing: V, children: x });
                x = X.children, V = X.closing;
              }
              return this.finalize(N, new h.JSXElement(W, x, V));
            }, M.prototype.parseJSXRoot = function() {
              this.config.tokens && this.tokens.pop(), this.startJSX();
              var N = this.parseJSXElement();
              return this.finishJSX(), N;
            }, M.prototype.isStartOfExpression = function() {
              return T.prototype.isStartOfExpression.call(this) || this.match("<");
            }, M;
          })(b.Parser);
          o.JSXParser = f;
        }, function(a, o) {
          Object.defineProperty(o, "__esModule", { value: !0 });
          var l = { NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/, NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFC-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C4\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/ };
          o.Character = { fromCodePoint: function(c) {
            return c < 65536 ? String.fromCharCode(c) : String.fromCharCode(55296 + (c - 65536 >> 10)) + String.fromCharCode(56320 + (c - 65536 & 1023));
          }, isWhiteSpace: function(c) {
            return c === 32 || c === 9 || c === 11 || c === 12 || c === 160 || c >= 5760 && [5760, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8239, 8287, 12288, 65279].indexOf(c) >= 0;
          }, isLineTerminator: function(c) {
            return c === 10 || c === 13 || c === 8232 || c === 8233;
          }, isIdentifierStart: function(c) {
            return c === 36 || c === 95 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || c === 92 || c >= 128 && l.NonAsciiIdentifierStart.test(o.Character.fromCodePoint(c));
          }, isIdentifierPart: function(c) {
            return c === 36 || c === 95 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || c >= 48 && c <= 57 || c === 92 || c >= 128 && l.NonAsciiIdentifierPart.test(o.Character.fromCodePoint(c));
          }, isDecimalDigit: function(c) {
            return c >= 48 && c <= 57;
          }, isHexDigit: function(c) {
            return c >= 48 && c <= 57 || c >= 65 && c <= 70 || c >= 97 && c <= 102;
          }, isOctalDigit: function(c) {
            return c >= 48 && c <= 55;
          } };
        }, function(a, o, l) {
          Object.defineProperty(o, "__esModule", { value: !0 });
          var c = l(6), u = function(M) {
            this.type = c.JSXSyntax.JSXClosingElement, this.name = M;
          };
          o.JSXClosingElement = u;
          var d = function(M, N, W) {
            this.type = c.JSXSyntax.JSXElement, this.openingElement = M, this.children = N, this.closingElement = W;
          };
          o.JSXElement = d;
          var h = function() {
            this.type = c.JSXSyntax.JSXEmptyExpression;
          };
          o.JSXEmptyExpression = h;
          var p = function(M) {
            this.type = c.JSXSyntax.JSXExpressionContainer, this.expression = M;
          };
          o.JSXExpressionContainer = p;
          var m = function(M) {
            this.type = c.JSXSyntax.JSXIdentifier, this.name = M;
          };
          o.JSXIdentifier = m;
          var b = function(M, N) {
            this.type = c.JSXSyntax.JSXMemberExpression, this.object = M, this.property = N;
          };
          o.JSXMemberExpression = b;
          var y = function(M, N) {
            this.type = c.JSXSyntax.JSXAttribute, this.name = M, this.value = N;
          };
          o.JSXAttribute = y;
          var Z = function(M, N) {
            this.type = c.JSXSyntax.JSXNamespacedName, this.namespace = M, this.name = N;
          };
          o.JSXNamespacedName = Z;
          var g = function(M, N, W) {
            this.type = c.JSXSyntax.JSXOpeningElement, this.name = M, this.selfClosing = N, this.attributes = W;
          };
          o.JSXOpeningElement = g;
          var f = function(M) {
            this.type = c.JSXSyntax.JSXSpreadAttribute, this.argument = M;
          };
          o.JSXSpreadAttribute = f;
          var T = function(M, N) {
            this.type = c.JSXSyntax.JSXText, this.value = M, this.raw = N;
          };
          o.JSXText = T;
        }, function(a, o) {
          Object.defineProperty(o, "__esModule", { value: !0 }), o.JSXSyntax = { JSXAttribute: "JSXAttribute", JSXClosingElement: "JSXClosingElement", JSXElement: "JSXElement", JSXEmptyExpression: "JSXEmptyExpression", JSXExpressionContainer: "JSXExpressionContainer", JSXIdentifier: "JSXIdentifier", JSXMemberExpression: "JSXMemberExpression", JSXNamespacedName: "JSXNamespacedName", JSXOpeningElement: "JSXOpeningElement", JSXSpreadAttribute: "JSXSpreadAttribute", JSXText: "JSXText" };
        }, function(a, o, l) {
          Object.defineProperty(o, "__esModule", { value: !0 });
          var c = l(2), u = function(re) {
            this.type = c.Syntax.ArrayExpression, this.elements = re;
          };
          o.ArrayExpression = u;
          var d = function(re) {
            this.type = c.Syntax.ArrayPattern, this.elements = re;
          };
          o.ArrayPattern = d;
          var h = function(re, be, rn) {
            this.type = c.Syntax.ArrowFunctionExpression, this.id = null, this.params = re, this.body = be, this.generator = !1, this.expression = rn, this.async = !1;
          };
          o.ArrowFunctionExpression = h;
          var p = function(re, be, rn) {
            this.type = c.Syntax.AssignmentExpression, this.operator = re, this.left = be, this.right = rn;
          };
          o.AssignmentExpression = p;
          var m = function(re, be) {
            this.type = c.Syntax.AssignmentPattern, this.left = re, this.right = be;
          };
          o.AssignmentPattern = m;
          var b = function(re, be, rn) {
            this.type = c.Syntax.ArrowFunctionExpression, this.id = null, this.params = re, this.body = be, this.generator = !1, this.expression = rn, this.async = !0;
          };
          o.AsyncArrowFunctionExpression = b;
          var y = function(re, be, rn) {
            this.type = c.Syntax.FunctionDeclaration, this.id = re, this.params = be, this.body = rn, this.generator = !1, this.expression = !1, this.async = !0;
          };
          o.AsyncFunctionDeclaration = y;
          var Z = function(re, be, rn) {
            this.type = c.Syntax.FunctionExpression, this.id = re, this.params = be, this.body = rn, this.generator = !1, this.expression = !1, this.async = !0;
          };
          o.AsyncFunctionExpression = Z;
          var g = function(re) {
            this.type = c.Syntax.AwaitExpression, this.argument = re;
          };
          o.AwaitExpression = g;
          var f = function(re, be, rn) {
            var Fr = re === "||" || re === "&&";
            this.type = Fr ? c.Syntax.LogicalExpression : c.Syntax.BinaryExpression, this.operator = re, this.left = be, this.right = rn;
          };
          o.BinaryExpression = f;
          var T = function(re) {
            this.type = c.Syntax.BlockStatement, this.body = re;
          };
          o.BlockStatement = T;
          var M = function(re) {
            this.type = c.Syntax.BreakStatement, this.label = re;
          };
          o.BreakStatement = M;
          var N = function(re, be) {
            this.type = c.Syntax.CallExpression, this.callee = re, this.arguments = be;
          };
          o.CallExpression = N;
          var W = function(re, be) {
            this.type = c.Syntax.CatchClause, this.param = re, this.body = be;
          };
          o.CatchClause = W;
          var x = function(re) {
            this.type = c.Syntax.ClassBody, this.body = re;
          };
          o.ClassBody = x;
          var V = function(re, be, rn) {
            this.type = c.Syntax.ClassDeclaration, this.id = re, this.superClass = be, this.body = rn;
          };
          o.ClassDeclaration = V;
          var X = function(re, be, rn) {
            this.type = c.Syntax.ClassExpression, this.id = re, this.superClass = be, this.body = rn;
          };
          o.ClassExpression = X;
          var C = function(re, be) {
            this.type = c.Syntax.MemberExpression, this.computed = !0, this.object = re, this.property = be;
          };
          o.ComputedMemberExpression = C;
          var R = function(re, be, rn) {
            this.type = c.Syntax.ConditionalExpression, this.test = re, this.consequent = be, this.alternate = rn;
          };
          o.ConditionalExpression = R;
          var z = function(re) {
            this.type = c.Syntax.ContinueStatement, this.label = re;
          };
          o.ContinueStatement = z;
          var F = function() {
            this.type = c.Syntax.DebuggerStatement;
          };
          o.DebuggerStatement = F;
          var P = function(re, be) {
            this.type = c.Syntax.ExpressionStatement, this.expression = re, this.directive = be;
          };
          o.Directive = P;
          var j = function(re, be) {
            this.type = c.Syntax.DoWhileStatement, this.body = re, this.test = be;
          };
          o.DoWhileStatement = j;
          var H = function() {
            this.type = c.Syntax.EmptyStatement;
          };
          o.EmptyStatement = H;
          var B = function(re) {
            this.type = c.Syntax.ExportAllDeclaration, this.source = re;
          };
          o.ExportAllDeclaration = B;
          var $ = function(re) {
            this.type = c.Syntax.ExportDefaultDeclaration, this.declaration = re;
          };
          o.ExportDefaultDeclaration = $;
          var A = function(re, be, rn) {
            this.type = c.Syntax.ExportNamedDeclaration, this.declaration = re, this.specifiers = be, this.source = rn;
          };
          o.ExportNamedDeclaration = A;
          var E = function(re, be) {
            this.type = c.Syntax.ExportSpecifier, this.exported = be, this.local = re;
          };
          o.ExportSpecifier = E;
          var ct = function(re) {
            this.type = c.Syntax.ExpressionStatement, this.expression = re;
          };
          o.ExpressionStatement = ct;
          var at = function(re, be, rn) {
            this.type = c.Syntax.ForInStatement, this.left = re, this.right = be, this.body = rn, this.each = !1;
          };
          o.ForInStatement = at;
          var dt = function(re, be, rn) {
            this.type = c.Syntax.ForOfStatement, this.left = re, this.right = be, this.body = rn;
          };
          o.ForOfStatement = dt;
          var gt = function(re, be, rn, Fr) {
            this.type = c.Syntax.ForStatement, this.init = re, this.test = be, this.update = rn, this.body = Fr;
          };
          o.ForStatement = gt;
          var Wt = function(re, be, rn, Fr) {
            this.type = c.Syntax.FunctionDeclaration, this.id = re, this.params = be, this.body = rn, this.generator = Fr, this.expression = !1, this.async = !1;
          };
          o.FunctionDeclaration = Wt;
          var Zt = function(re, be, rn, Fr) {
            this.type = c.Syntax.FunctionExpression, this.id = re, this.params = be, this.body = rn, this.generator = Fr, this.expression = !1, this.async = !1;
          };
          o.FunctionExpression = Zt;
          var Gt = function(re) {
            this.type = c.Syntax.Identifier, this.name = re;
          };
          o.Identifier = Gt;
          var Tt = function(re, be, rn) {
            this.type = c.Syntax.IfStatement, this.test = re, this.consequent = be, this.alternate = rn;
          };
          o.IfStatement = Tt;
          var Q = function(re, be) {
            this.type = c.Syntax.ImportDeclaration, this.specifiers = re, this.source = be;
          };
          o.ImportDeclaration = Q;
          var D = function(re) {
            this.type = c.Syntax.ImportDefaultSpecifier, this.local = re;
          };
          o.ImportDefaultSpecifier = D;
          var q = function(re) {
            this.type = c.Syntax.ImportNamespaceSpecifier, this.local = re;
          };
          o.ImportNamespaceSpecifier = q;
          var nt = function(re, be) {
            this.type = c.Syntax.ImportSpecifier, this.local = re, this.imported = be;
          };
          o.ImportSpecifier = nt;
          var et = function(re, be) {
            this.type = c.Syntax.LabeledStatement, this.label = re, this.body = be;
          };
          o.LabeledStatement = et;
          var ot = function(re, be) {
            this.type = c.Syntax.Literal, this.value = re, this.raw = be;
          };
          o.Literal = ot;
          var it = function(re, be) {
            this.type = c.Syntax.MetaProperty, this.meta = re, this.property = be;
          };
          o.MetaProperty = it;
          var ht = function(re, be, rn, Fr, Og) {
            this.type = c.Syntax.MethodDefinition, this.key = re, this.computed = be, this.value = rn, this.kind = Fr, this.static = Og;
          };
          o.MethodDefinition = ht;
          var lt = function(re) {
            this.type = c.Syntax.Program, this.body = re, this.sourceType = "module";
          };
          o.Module = lt;
          var mt = function(re, be) {
            this.type = c.Syntax.NewExpression, this.callee = re, this.arguments = be;
          };
          o.NewExpression = mt;
          var wt = function(re) {
            this.type = c.Syntax.ObjectExpression, this.properties = re;
          };
          o.ObjectExpression = wt;
          var Xt = function(re) {
            this.type = c.Syntax.ObjectPattern, this.properties = re;
          };
          o.ObjectPattern = Xt;
          var At = function(re, be, rn, Fr, Og, e1) {
            this.type = c.Syntax.Property, this.key = be, this.computed = rn, this.value = Fr, this.kind = re, this.method = Og, this.shorthand = e1;
          };
          o.Property = At;
          var he = function(re, be, rn, Fr) {
            this.type = c.Syntax.Literal, this.value = re, this.raw = be, this.regex = { pattern: rn, flags: Fr };
          };
          o.RegexLiteral = he;
          var ue = function(re) {
            this.type = c.Syntax.RestElement, this.argument = re;
          };
          o.RestElement = ue;
          var Dt = function(re) {
            this.type = c.Syntax.ReturnStatement, this.argument = re;
          };
          o.ReturnStatement = Dt;
          var ee = function(re) {
            this.type = c.Syntax.Program, this.body = re, this.sourceType = "script";
          };
          o.Script = ee;
          var yt = function(re) {
            this.type = c.Syntax.SequenceExpression, this.expressions = re;
          };
          o.SequenceExpression = yt;
          var fe = function(re) {
            this.type = c.Syntax.SpreadElement, this.argument = re;
          };
          o.SpreadElement = fe;
          var Xe = function(re, be) {
            this.type = c.Syntax.MemberExpression, this.computed = !1, this.object = re, this.property = be;
          };
          o.StaticMemberExpression = Xe;
          var Se = function() {
            this.type = c.Syntax.Super;
          };
          o.Super = Se;
          var Vt = function(re, be) {
            this.type = c.Syntax.SwitchCase, this.test = re, this.consequent = be;
          };
          o.SwitchCase = Vt;
          var Rt = function(re, be) {
            this.type = c.Syntax.SwitchStatement, this.discriminant = re, this.cases = be;
          };
          o.SwitchStatement = Rt;
          var $t = function(re, be) {
            this.type = c.Syntax.TaggedTemplateExpression, this.tag = re, this.quasi = be;
          };
          o.TaggedTemplateExpression = $t;
          var zt = function(re, be) {
            this.type = c.Syntax.TemplateElement, this.value = re, this.tail = be;
          };
          o.TemplateElement = zt;
          var Bt = function(re, be) {
            this.type = c.Syntax.TemplateLiteral, this.quasis = re, this.expressions = be;
          };
          o.TemplateLiteral = Bt;
          var Kt = function() {
            this.type = c.Syntax.ThisExpression;
          };
          o.ThisExpression = Kt;
          var ne = function(re) {
            this.type = c.Syntax.ThrowStatement, this.argument = re;
          };
          o.ThrowStatement = ne;
          var ae = function(re, be, rn) {
            this.type = c.Syntax.TryStatement, this.block = re, this.handler = be, this.finalizer = rn;
          };
          o.TryStatement = ae;
          var Ge = function(re, be) {
            this.type = c.Syntax.UnaryExpression, this.operator = re, this.argument = be, this.prefix = !0;
          };
          o.UnaryExpression = Ge;
          var He = function(re, be, rn) {
            this.type = c.Syntax.UpdateExpression, this.operator = re, this.argument = be, this.prefix = rn;
          };
          o.UpdateExpression = He;
          var je = function(re, be) {
            this.type = c.Syntax.VariableDeclaration, this.declarations = re, this.kind = be;
          };
          o.VariableDeclaration = je;
          var we = function(re, be) {
            this.type = c.Syntax.VariableDeclarator, this.id = re, this.init = be;
          };
          o.VariableDeclarator = we;
          var ln = function(re, be) {
            this.type = c.Syntax.WhileStatement, this.test = re, this.body = be;
          };
          o.WhileStatement = ln;
          var Ls = function(re, be) {
            this.type = c.Syntax.WithStatement, this.object = re, this.body = be;
          };
          o.WithStatement = Ls;
          var ys = function(re, be) {
            this.type = c.Syntax.YieldExpression, this.argument = re, this.delegate = be;
          };
          o.YieldExpression = ys;
        }, function(a, o, l) {
          Object.defineProperty(o, "__esModule", { value: !0 });
          var c = l(9), u = l(10), d = l(11), h = l(7), p = l(12), m = l(2), b = l(13), y = (function() {
            function Z(g, f, T) {
              f === void 0 && (f = {}), this.config = { range: typeof f.range == "boolean" && f.range, loc: typeof f.loc == "boolean" && f.loc, source: null, tokens: typeof f.tokens == "boolean" && f.tokens, comment: typeof f.comment == "boolean" && f.comment, tolerant: typeof f.tolerant == "boolean" && f.tolerant }, this.config.loc && f.source && f.source !== null && (this.config.source = String(f.source)), this.delegate = T, this.errorHandler = new u.ErrorHandler(), this.errorHandler.tolerant = this.config.tolerant, this.scanner = new p.Scanner(g, this.errorHandler), this.scanner.trackComment = this.config.comment, this.operatorPrecedence = { ")": 0, ";": 0, ",": 0, "=": 0, "]": 0, "||": 1, "&&": 2, "|": 3, "^": 4, "&": 5, "==": 6, "!=": 6, "===": 6, "!==": 6, "<": 7, ">": 7, "<=": 7, ">=": 7, "<<": 8, ">>": 8, ">>>": 8, "+": 9, "-": 9, "*": 11, "/": 11, "%": 11 }, this.lookahead = { type: 2, value: "", lineNumber: this.scanner.lineNumber, lineStart: 0, start: 0, end: 0 }, this.hasLineTerminator = !1, this.context = { isModule: !1, await: !1, allowIn: !0, allowStrictDirective: !0, allowYield: !0, firstCoverInitializedNameError: null, isAssignmentTarget: !1, isBindingElement: !1, inFunctionBody: !1, inIteration: !1, inSwitch: !1, labelSet: {}, strict: !1 }, this.tokens = [], this.startMarker = { index: 0, line: this.scanner.lineNumber, column: 0 }, this.lastMarker = { index: 0, line: this.scanner.lineNumber, column: 0 }, this.nextToken(), this.lastMarker = { index: this.scanner.index, line: this.scanner.lineNumber, column: this.scanner.index - this.scanner.lineStart };
            }
            return Z.prototype.throwError = function(g) {
              for (var f = [], T = 1; T < arguments.length; T++) f[T - 1] = arguments[T];
              var M = Array.prototype.slice.call(arguments, 1), N = g.replace(/%(\d)/g, (function(X, C) {
                return c.assert(C < M.length, "Message reference must be in range"), M[C];
              })), W = this.lastMarker.index, x = this.lastMarker.line, V = this.lastMarker.column + 1;
              throw this.errorHandler.createError(W, x, V, N);
            }, Z.prototype.tolerateError = function(g) {
              for (var f = [], T = 1; T < arguments.length; T++) f[T - 1] = arguments[T];
              var M = Array.prototype.slice.call(arguments, 1), N = g.replace(/%(\d)/g, (function(X, C) {
                return c.assert(C < M.length, "Message reference must be in range"), M[C];
              })), W = this.lastMarker.index, x = this.scanner.lineNumber, V = this.lastMarker.column + 1;
              this.errorHandler.tolerateError(W, x, V, N);
            }, Z.prototype.unexpectedTokenError = function(g, f) {
              var T, M = f || d.Messages.UnexpectedToken;
              if (g ? (f || (M = g.type === 2 ? d.Messages.UnexpectedEOS : g.type === 3 ? d.Messages.UnexpectedIdentifier : g.type === 6 ? d.Messages.UnexpectedNumber : g.type === 8 ? d.Messages.UnexpectedString : g.type === 10 ? d.Messages.UnexpectedTemplate : d.Messages.UnexpectedToken, g.type === 4 && (this.scanner.isFutureReservedWord(g.value) ? M = d.Messages.UnexpectedReserved : this.context.strict && this.scanner.isStrictModeReservedWord(g.value) && (M = d.Messages.StrictReservedWord))), T = g.value) : T = "ILLEGAL", M = M.replace("%0", T), g && typeof g.lineNumber == "number") {
                var N = g.start, W = g.lineNumber, x = this.lastMarker.index - this.lastMarker.column, V = g.start - x + 1;
                return this.errorHandler.createError(N, W, V, M);
              }
              return N = this.lastMarker.index, W = this.lastMarker.line, V = this.lastMarker.column + 1, this.errorHandler.createError(N, W, V, M);
            }, Z.prototype.throwUnexpectedToken = function(g, f) {
              throw this.unexpectedTokenError(g, f);
            }, Z.prototype.tolerateUnexpectedToken = function(g, f) {
              this.errorHandler.tolerate(this.unexpectedTokenError(g, f));
            }, Z.prototype.collectComments = function() {
              if (this.config.comment) {
                var g = this.scanner.scanComments();
                if (g.length > 0 && this.delegate) for (var f = 0; f < g.length; ++f) {
                  var T = g[f], M = void 0;
                  M = { type: T.multiLine ? "BlockComment" : "LineComment", value: this.scanner.source.slice(T.slice[0], T.slice[1]) }, this.config.range && (M.range = T.range), this.config.loc && (M.loc = T.loc);
                  var N = { start: { line: T.loc.start.line, column: T.loc.start.column, offset: T.range[0] }, end: { line: T.loc.end.line, column: T.loc.end.column, offset: T.range[1] } };
                  this.delegate(M, N);
                }
              } else this.scanner.scanComments();
            }, Z.prototype.getTokenRaw = function(g) {
              return this.scanner.source.slice(g.start, g.end);
            }, Z.prototype.convertToken = function(g) {
              var f = { type: b.TokenName[g.type], value: this.getTokenRaw(g) };
              if (this.config.range && (f.range = [g.start, g.end]), this.config.loc && (f.loc = { start: { line: this.startMarker.line, column: this.startMarker.column }, end: { line: this.scanner.lineNumber, column: this.scanner.index - this.scanner.lineStart } }), g.type === 9) {
                var T = g.pattern, M = g.flags;
                f.regex = { pattern: T, flags: M };
              }
              return f;
            }, Z.prototype.nextToken = function() {
              var g = this.lookahead;
              this.lastMarker.index = this.scanner.index, this.lastMarker.line = this.scanner.lineNumber, this.lastMarker.column = this.scanner.index - this.scanner.lineStart, this.collectComments(), this.scanner.index !== this.startMarker.index && (this.startMarker.index = this.scanner.index, this.startMarker.line = this.scanner.lineNumber, this.startMarker.column = this.scanner.index - this.scanner.lineStart);
              var f = this.scanner.lex();
              return this.hasLineTerminator = g.lineNumber !== f.lineNumber, f && this.context.strict && f.type === 3 && this.scanner.isStrictModeReservedWord(f.value) && (f.type = 4), this.lookahead = f, this.config.tokens && f.type !== 2 && this.tokens.push(this.convertToken(f)), g;
            }, Z.prototype.nextRegexToken = function() {
              this.collectComments();
              var g = this.scanner.scanRegExp();
              return this.config.tokens && (this.tokens.pop(), this.tokens.push(this.convertToken(g))), this.lookahead = g, this.nextToken(), g;
            }, Z.prototype.createNode = function() {
              return { index: this.startMarker.index, line: this.startMarker.line, column: this.startMarker.column };
            }, Z.prototype.startNode = function(g, f) {
              f === void 0 && (f = 0);
              var T = g.start - g.lineStart, M = g.lineNumber;
              return T < 0 && (T += f, M--), { index: g.start, line: M, column: T };
            }, Z.prototype.finalize = function(g, f) {
              if (this.config.range && (f.range = [g.index, this.lastMarker.index]), this.config.loc && (f.loc = { start: { line: g.line, column: g.column }, end: { line: this.lastMarker.line, column: this.lastMarker.column } }, this.config.source && (f.loc.source = this.config.source)), this.delegate) {
                var T = { start: { line: g.line, column: g.column, offset: g.index }, end: { line: this.lastMarker.line, column: this.lastMarker.column, offset: this.lastMarker.index } };
                this.delegate(f, T);
              }
              return f;
            }, Z.prototype.expect = function(g) {
              var f = this.nextToken();
              f.type === 7 && f.value === g || this.throwUnexpectedToken(f);
            }, Z.prototype.expectCommaSeparator = function() {
              if (this.config.tolerant) {
                var g = this.lookahead;
                g.type === 7 && g.value === "," ? this.nextToken() : g.type === 7 && g.value === ";" ? (this.nextToken(), this.tolerateUnexpectedToken(g)) : this.tolerateUnexpectedToken(g, d.Messages.UnexpectedToken);
              } else this.expect(",");
            }, Z.prototype.expectKeyword = function(g) {
              var f = this.nextToken();
              f.type === 4 && f.value === g || this.throwUnexpectedToken(f);
            }, Z.prototype.match = function(g) {
              return this.lookahead.type === 7 && this.lookahead.value === g;
            }, Z.prototype.matchKeyword = function(g) {
              return this.lookahead.type === 4 && this.lookahead.value === g;
            }, Z.prototype.matchContextualKeyword = function(g) {
              return this.lookahead.type === 3 && this.lookahead.value === g;
            }, Z.prototype.matchAssign = function() {
              if (this.lookahead.type !== 7) return !1;
              var g = this.lookahead.value;
              return g === "=" || g === "*=" || g === "**=" || g === "/=" || g === "%=" || g === "+=" || g === "-=" || g === "<<=" || g === ">>=" || g === ">>>=" || g === "&=" || g === "^=" || g === "|=";
            }, Z.prototype.isolateCoverGrammar = function(g) {
              var f = this.context.isBindingElement, T = this.context.isAssignmentTarget, M = this.context.firstCoverInitializedNameError;
              this.context.isBindingElement = !0, this.context.isAssignmentTarget = !0, this.context.firstCoverInitializedNameError = null;
              var N = g.call(this);
              return this.context.firstCoverInitializedNameError !== null && this.throwUnexpectedToken(this.context.firstCoverInitializedNameError), this.context.isBindingElement = f, this.context.isAssignmentTarget = T, this.context.firstCoverInitializedNameError = M, N;
            }, Z.prototype.inheritCoverGrammar = function(g) {
              var f = this.context.isBindingElement, T = this.context.isAssignmentTarget, M = this.context.firstCoverInitializedNameError;
              this.context.isBindingElement = !0, this.context.isAssignmentTarget = !0, this.context.firstCoverInitializedNameError = null;
              var N = g.call(this);
              return this.context.isBindingElement = this.context.isBindingElement && f, this.context.isAssignmentTarget = this.context.isAssignmentTarget && T, this.context.firstCoverInitializedNameError = M || this.context.firstCoverInitializedNameError, N;
            }, Z.prototype.consumeSemicolon = function() {
              this.match(";") ? this.nextToken() : this.hasLineTerminator || (this.lookahead.type === 2 || this.match("}") || this.throwUnexpectedToken(this.lookahead), this.lastMarker.index = this.startMarker.index, this.lastMarker.line = this.startMarker.line, this.lastMarker.column = this.startMarker.column);
            }, Z.prototype.parsePrimaryExpression = function() {
              var g, f, T, M = this.createNode();
              switch (this.lookahead.type) {
                case 3:
                  (this.context.isModule || this.context.await) && this.lookahead.value === "await" && this.tolerateUnexpectedToken(this.lookahead), g = this.matchAsyncFunction() ? this.parseFunctionExpression() : this.finalize(M, new h.Identifier(this.nextToken().value));
                  break;
                case 6:
                case 8:
                  this.context.strict && this.lookahead.octal && this.tolerateUnexpectedToken(this.lookahead, d.Messages.StrictOctalLiteral), this.context.isAssignmentTarget = !1, this.context.isBindingElement = !1, f = this.nextToken(), T = this.getTokenRaw(f), g = this.finalize(M, new h.Literal(f.value, T));
                  break;
                case 1:
                  this.context.isAssignmentTarget = !1, this.context.isBindingElement = !1, f = this.nextToken(), T = this.getTokenRaw(f), g = this.finalize(M, new h.Literal(f.value === "true", T));
                  break;
                case 5:
                  this.context.isAssignmentTarget = !1, this.context.isBindingElement = !1, f = this.nextToken(), T = this.getTokenRaw(f), g = this.finalize(M, new h.Literal(null, T));
                  break;
                case 10:
                  g = this.parseTemplateLiteral();
                  break;
                case 7:
                  switch (this.lookahead.value) {
                    case "(":
                      this.context.isBindingElement = !1, g = this.inheritCoverGrammar(this.parseGroupExpression);
                      break;
                    case "[":
                      g = this.inheritCoverGrammar(this.parseArrayInitializer);
                      break;
                    case "{":
                      g = this.inheritCoverGrammar(this.parseObjectInitializer);
                      break;
                    case "/":
                    case "/=":
                      this.context.isAssignmentTarget = !1, this.context.isBindingElement = !1, this.scanner.index = this.startMarker.index, f = this.nextRegexToken(), T = this.getTokenRaw(f), g = this.finalize(M, new h.RegexLiteral(f.regex, T, f.pattern, f.flags));
                      break;
                    default:
                      g = this.throwUnexpectedToken(this.nextToken());
                  }
                  break;
                case 4:
                  !this.context.strict && this.context.allowYield && this.matchKeyword("yield") ? g = this.parseIdentifierName() : !this.context.strict && this.matchKeyword("let") ? g = this.finalize(M, new h.Identifier(this.nextToken().value)) : (this.context.isAssignmentTarget = !1, this.context.isBindingElement = !1, this.matchKeyword("function") ? g = this.parseFunctionExpression() : this.matchKeyword("this") ? (this.nextToken(), g = this.finalize(M, new h.ThisExpression())) : g = this.matchKeyword("class") ? this.parseClassExpression() : this.throwUnexpectedToken(this.nextToken()));
                  break;
                default:
                  g = this.throwUnexpectedToken(this.nextToken());
              }
              return g;
            }, Z.prototype.parseSpreadElement = function() {
              var g = this.createNode();
              this.expect("...");
              var f = this.inheritCoverGrammar(this.parseAssignmentExpression);
              return this.finalize(g, new h.SpreadElement(f));
            }, Z.prototype.parseArrayInitializer = function() {
              var g = this.createNode(), f = [];
              for (this.expect("["); !this.match("]"); ) if (this.match(",")) this.nextToken(), f.push(null);
              else if (this.match("...")) {
                var T = this.parseSpreadElement();
                this.match("]") || (this.context.isAssignmentTarget = !1, this.context.isBindingElement = !1, this.expect(",")), f.push(T);
              } else f.push(this.inheritCoverGrammar(this.parseAssignmentExpression)), this.match("]") || this.expect(",");
              return this.expect("]"), this.finalize(g, new h.ArrayExpression(f));
            }, Z.prototype.parsePropertyMethod = function(g) {
              this.context.isAssignmentTarget = !1, this.context.isBindingElement = !1;
              var f = this.context.strict, T = this.context.allowStrictDirective;
              this.context.allowStrictDirective = g.simple;
              var M = this.isolateCoverGrammar(this.parseFunctionSourceElements);
              return this.context.strict && g.firstRestricted && this.tolerateUnexpectedToken(g.firstRestricted, g.message), this.context.strict && g.stricted && this.tolerateUnexpectedToken(g.stricted, g.message), this.context.strict = f, this.context.allowStrictDirective = T, M;
            }, Z.prototype.parsePropertyMethodFunction = function() {
              var g = this.createNode(), f = this.context.allowYield;
              this.context.allowYield = !0;
              var T = this.parseFormalParameters(), M = this.parsePropertyMethod(T);
              return this.context.allowYield = f, this.finalize(g, new h.FunctionExpression(null, T.params, M, !1));
            }, Z.prototype.parsePropertyMethodAsyncFunction = function() {
              var g = this.createNode(), f = this.context.allowYield, T = this.context.await;
              this.context.allowYield = !1, this.context.await = !0;
              var M = this.parseFormalParameters(), N = this.parsePropertyMethod(M);
              return this.context.allowYield = f, this.context.await = T, this.finalize(g, new h.AsyncFunctionExpression(null, M.params, N));
            }, Z.prototype.parseObjectPropertyKey = function() {
              var g, f = this.createNode(), T = this.nextToken();
              switch (T.type) {
                case 8:
                case 6:
                  this.context.strict && T.octal && this.tolerateUnexpectedToken(T, d.Messages.StrictOctalLiteral);
                  var M = this.getTokenRaw(T);
                  g = this.finalize(f, new h.Literal(T.value, M));
                  break;
                case 3:
                case 1:
                case 5:
                case 4:
                  g = this.finalize(f, new h.Identifier(T.value));
                  break;
                case 7:
                  T.value === "[" ? (g = this.isolateCoverGrammar(this.parseAssignmentExpression), this.expect("]")) : g = this.throwUnexpectedToken(T);
                  break;
                default:
                  g = this.throwUnexpectedToken(T);
              }
              return g;
            }, Z.prototype.isPropertyKey = function(g, f) {
              return g.type === m.Syntax.Identifier && g.name === f || g.type === m.Syntax.Literal && g.value === f;
            }, Z.prototype.parseObjectProperty = function(g) {
              var f, T = this.createNode(), M = this.lookahead, N = null, W = null, x = !1, V = !1, X = !1, C = !1;
              if (M.type === 3) {
                var R = M.value;
                this.nextToken(), x = this.match("["), N = (C = !(this.hasLineTerminator || R !== "async" || this.match(":") || this.match("(") || this.match("*") || this.match(","))) ? this.parseObjectPropertyKey() : this.finalize(T, new h.Identifier(R));
              } else this.match("*") ? this.nextToken() : (x = this.match("["), N = this.parseObjectPropertyKey());
              var z = this.qualifiedPropertyName(this.lookahead);
              if (M.type === 3 && !C && M.value === "get" && z) f = "get", x = this.match("["), N = this.parseObjectPropertyKey(), this.context.allowYield = !1, W = this.parseGetterMethod();
              else if (M.type === 3 && !C && M.value === "set" && z) f = "set", x = this.match("["), N = this.parseObjectPropertyKey(), W = this.parseSetterMethod();
              else if (M.type === 7 && M.value === "*" && z) f = "init", x = this.match("["), N = this.parseObjectPropertyKey(), W = this.parseGeneratorMethod(), V = !0;
              else if (N || this.throwUnexpectedToken(this.lookahead), f = "init", this.match(":") && !C) !x && this.isPropertyKey(N, "__proto__") && (g.value && this.tolerateError(d.Messages.DuplicateProtoProperty), g.value = !0), this.nextToken(), W = this.inheritCoverGrammar(this.parseAssignmentExpression);
              else if (this.match("(")) W = C ? this.parsePropertyMethodAsyncFunction() : this.parsePropertyMethodFunction(), V = !0;
              else if (M.type === 3) if (R = this.finalize(T, new h.Identifier(M.value)), this.match("=")) {
                this.context.firstCoverInitializedNameError = this.lookahead, this.nextToken(), X = !0;
                var F = this.isolateCoverGrammar(this.parseAssignmentExpression);
                W = this.finalize(T, new h.AssignmentPattern(R, F));
              } else X = !0, W = R;
              else this.throwUnexpectedToken(this.nextToken());
              return this.finalize(T, new h.Property(f, N, x, W, V, X));
            }, Z.prototype.parseObjectInitializer = function() {
              var g = this.createNode();
              this.expect("{");
              for (var f = [], T = { value: !1 }; !this.match("}"); ) f.push(this.parseObjectProperty(T)), this.match("}") || this.expectCommaSeparator();
              return this.expect("}"), this.finalize(g, new h.ObjectExpression(f));
            }, Z.prototype.parseTemplateHead = function() {
              c.assert(this.lookahead.head, "Template literal must start with a template head");
              var g = this.createNode(), f = this.nextToken(), T = f.value, M = f.cooked;
              return this.finalize(g, new h.TemplateElement({ raw: T, cooked: M }, f.tail));
            }, Z.prototype.parseTemplateElement = function() {
              this.lookahead.type !== 10 && this.throwUnexpectedToken();
              var g = this.createNode(), f = this.nextToken(), T = f.value, M = f.cooked;
              return this.finalize(g, new h.TemplateElement({ raw: T, cooked: M }, f.tail));
            }, Z.prototype.parseTemplateLiteral = function() {
              var g = this.createNode(), f = [], T = [], M = this.parseTemplateHead();
              for (T.push(M); !M.tail; ) f.push(this.parseExpression()), M = this.parseTemplateElement(), T.push(M);
              return this.finalize(g, new h.TemplateLiteral(T, f));
            }, Z.prototype.reinterpretExpressionAsPattern = function(g) {
              switch (g.type) {
                case m.Syntax.Identifier:
                case m.Syntax.MemberExpression:
                case m.Syntax.RestElement:
                case m.Syntax.AssignmentPattern:
                  break;
                case m.Syntax.SpreadElement:
                  g.type = m.Syntax.RestElement, this.reinterpretExpressionAsPattern(g.argument);
                  break;
                case m.Syntax.ArrayExpression:
                  g.type = m.Syntax.ArrayPattern;
                  for (var f = 0; f < g.elements.length; f++) g.elements[f] !== null && this.reinterpretExpressionAsPattern(g.elements[f]);
                  break;
                case m.Syntax.ObjectExpression:
                  for (g.type = m.Syntax.ObjectPattern, f = 0; f < g.properties.length; f++) this.reinterpretExpressionAsPattern(g.properties[f].value);
                  break;
                case m.Syntax.AssignmentExpression:
                  g.type = m.Syntax.AssignmentPattern, delete g.operator, this.reinterpretExpressionAsPattern(g.left);
              }
            }, Z.prototype.parseGroupExpression = function() {
              var g;
              if (this.expect("("), this.match(")")) this.nextToken(), this.match("=>") || this.expect("=>"), g = { type: "ArrowParameterPlaceHolder", params: [], async: !1 };
              else {
                var f = this.lookahead, T = [];
                if (this.match("...")) g = this.parseRestElement(T), this.expect(")"), this.match("=>") || this.expect("=>"), g = { type: "ArrowParameterPlaceHolder", params: [g], async: !1 };
                else {
                  var M = !1;
                  if (this.context.isBindingElement = !0, g = this.inheritCoverGrammar(this.parseAssignmentExpression), this.match(",")) {
                    var N = [];
                    for (this.context.isAssignmentTarget = !1, N.push(g); this.lookahead.type !== 2 && this.match(","); ) {
                      if (this.nextToken(), this.match(")")) {
                        this.nextToken();
                        for (var W = 0; W < N.length; W++) this.reinterpretExpressionAsPattern(N[W]);
                        M = !0, g = { type: "ArrowParameterPlaceHolder", params: N, async: !1 };
                      } else if (this.match("...")) {
                        for (this.context.isBindingElement || this.throwUnexpectedToken(this.lookahead), N.push(this.parseRestElement(T)), this.expect(")"), this.match("=>") || this.expect("=>"), this.context.isBindingElement = !1, W = 0; W < N.length; W++) this.reinterpretExpressionAsPattern(N[W]);
                        M = !0, g = { type: "ArrowParameterPlaceHolder", params: N, async: !1 };
                      } else N.push(this.inheritCoverGrammar(this.parseAssignmentExpression));
                      if (M) break;
                    }
                    M || (g = this.finalize(this.startNode(f), new h.SequenceExpression(N)));
                  }
                  if (!M) {
                    if (this.expect(")"), this.match("=>") && (g.type === m.Syntax.Identifier && g.name === "yield" && (M = !0, g = { type: "ArrowParameterPlaceHolder", params: [g], async: !1 }), !M)) {
                      if (this.context.isBindingElement || this.throwUnexpectedToken(this.lookahead), g.type === m.Syntax.SequenceExpression) for (W = 0; W < g.expressions.length; W++) this.reinterpretExpressionAsPattern(g.expressions[W]);
                      else this.reinterpretExpressionAsPattern(g);
                      g = { type: "ArrowParameterPlaceHolder", params: g.type === m.Syntax.SequenceExpression ? g.expressions : [g], async: !1 };
                    }
                    this.context.isBindingElement = !1;
                  }
                }
              }
              return g;
            }, Z.prototype.parseArguments = function() {
              this.expect("(");
              var g = [];
              if (!this.match(")")) for (; ; ) {
                var f = this.match("...") ? this.parseSpreadElement() : this.isolateCoverGrammar(this.parseAssignmentExpression);
                if (g.push(f), this.match(")") || (this.expectCommaSeparator(), this.match(")"))) break;
              }
              return this.expect(")"), g;
            }, Z.prototype.isIdentifierName = function(g) {
              return g.type === 3 || g.type === 4 || g.type === 1 || g.type === 5;
            }, Z.prototype.parseIdentifierName = function() {
              var g = this.createNode(), f = this.nextToken();
              return this.isIdentifierName(f) || this.throwUnexpectedToken(f), this.finalize(g, new h.Identifier(f.value));
            }, Z.prototype.parseNewExpression = function() {
              var g, f = this.createNode(), T = this.parseIdentifierName();
              if (c.assert(T.name === "new", "New expression must start with `new`"), this.match(".")) if (this.nextToken(), this.lookahead.type === 3 && this.context.inFunctionBody && this.lookahead.value === "target") {
                var M = this.parseIdentifierName();
                g = new h.MetaProperty(T, M);
              } else this.throwUnexpectedToken(this.lookahead);
              else {
                var N = this.isolateCoverGrammar(this.parseLeftHandSideExpression), W = this.match("(") ? this.parseArguments() : [];
                g = new h.NewExpression(N, W), this.context.isAssignmentTarget = !1, this.context.isBindingElement = !1;
              }
              return this.finalize(f, g);
            }, Z.prototype.parseAsyncArgument = function() {
              var g = this.parseAssignmentExpression();
              return this.context.firstCoverInitializedNameError = null, g;
            }, Z.prototype.parseAsyncArguments = function() {
              this.expect("(");
              var g = [];
              if (!this.match(")")) for (; ; ) {
                var f = this.match("...") ? this.parseSpreadElement() : this.isolateCoverGrammar(this.parseAsyncArgument);
                if (g.push(f), this.match(")") || (this.expectCommaSeparator(), this.match(")"))) break;
              }
              return this.expect(")"), g;
            }, Z.prototype.parseLeftHandSideExpressionAllowCall = function() {
              var g, f = this.lookahead, T = this.matchContextualKeyword("async"), M = this.context.allowIn;
              for (this.context.allowIn = !0, this.matchKeyword("super") && this.context.inFunctionBody ? (g = this.createNode(), this.nextToken(), g = this.finalize(g, new h.Super()), this.match("(") || this.match(".") || this.match("[") || this.throwUnexpectedToken(this.lookahead)) : g = this.inheritCoverGrammar(this.matchKeyword("new") ? this.parseNewExpression : this.parsePrimaryExpression); ; ) if (this.match(".")) {
                this.context.isBindingElement = !1, this.context.isAssignmentTarget = !0, this.expect(".");
                var N = this.parseIdentifierName();
                g = this.finalize(this.startNode(f), new h.StaticMemberExpression(g, N));
              } else if (this.match("(")) {
                var W = T && f.lineNumber === this.lookahead.lineNumber;
                this.context.isBindingElement = !1, this.context.isAssignmentTarget = !1;
                var x = W ? this.parseAsyncArguments() : this.parseArguments();
                if (g = this.finalize(this.startNode(f), new h.CallExpression(g, x)), W && this.match("=>")) {
                  for (var V = 0; V < x.length; ++V) this.reinterpretExpressionAsPattern(x[V]);
                  g = { type: "ArrowParameterPlaceHolder", params: x, async: !0 };
                }
              } else if (this.match("[")) this.context.isBindingElement = !1, this.context.isAssignmentTarget = !0, this.expect("["), N = this.isolateCoverGrammar(this.parseExpression), this.expect("]"), g = this.finalize(this.startNode(f), new h.ComputedMemberExpression(g, N));
              else {
                if (this.lookahead.type !== 10 || !this.lookahead.head) break;
                var X = this.parseTemplateLiteral();
                g = this.finalize(this.startNode(f), new h.TaggedTemplateExpression(g, X));
              }
              return this.context.allowIn = M, g;
            }, Z.prototype.parseSuper = function() {
              var g = this.createNode();
              return this.expectKeyword("super"), this.match("[") || this.match(".") || this.throwUnexpectedToken(this.lookahead), this.finalize(g, new h.Super());
            }, Z.prototype.parseLeftHandSideExpression = function() {
              c.assert(this.context.allowIn, "callee of new expression always allow in keyword.");
              for (var g = this.startNode(this.lookahead), f = this.matchKeyword("super") && this.context.inFunctionBody ? this.parseSuper() : this.inheritCoverGrammar(this.matchKeyword("new") ? this.parseNewExpression : this.parsePrimaryExpression); ; ) if (this.match("[")) {
                this.context.isBindingElement = !1, this.context.isAssignmentTarget = !0, this.expect("[");
                var T = this.isolateCoverGrammar(this.parseExpression);
                this.expect("]"), f = this.finalize(g, new h.ComputedMemberExpression(f, T));
              } else if (this.match(".")) this.context.isBindingElement = !1, this.context.isAssignmentTarget = !0, this.expect("."), T = this.parseIdentifierName(), f = this.finalize(g, new h.StaticMemberExpression(f, T));
              else {
                if (this.lookahead.type !== 10 || !this.lookahead.head) break;
                var M = this.parseTemplateLiteral();
                f = this.finalize(g, new h.TaggedTemplateExpression(f, M));
              }
              return f;
            }, Z.prototype.parseUpdateExpression = function() {
              var g, f = this.lookahead;
              if (this.match("++") || this.match("--")) {
                var T = this.startNode(f), M = this.nextToken();
                g = this.inheritCoverGrammar(this.parseUnaryExpression), this.context.strict && g.type === m.Syntax.Identifier && this.scanner.isRestrictedWord(g.name) && this.tolerateError(d.Messages.StrictLHSPrefix), this.context.isAssignmentTarget || this.tolerateError(d.Messages.InvalidLHSInAssignment);
                var N = !0;
                g = this.finalize(T, new h.UpdateExpression(M.value, g, N)), this.context.isAssignmentTarget = !1, this.context.isBindingElement = !1;
              } else if (g = this.inheritCoverGrammar(this.parseLeftHandSideExpressionAllowCall), !this.hasLineTerminator && this.lookahead.type === 7 && (this.match("++") || this.match("--"))) {
                this.context.strict && g.type === m.Syntax.Identifier && this.scanner.isRestrictedWord(g.name) && this.tolerateError(d.Messages.StrictLHSPostfix), this.context.isAssignmentTarget || this.tolerateError(d.Messages.InvalidLHSInAssignment), this.context.isAssignmentTarget = !1, this.context.isBindingElement = !1;
                var W = this.nextToken().value;
                N = !1, g = this.finalize(this.startNode(f), new h.UpdateExpression(W, g, N));
              }
              return g;
            }, Z.prototype.parseAwaitExpression = function() {
              var g = this.createNode();
              this.nextToken();
              var f = this.parseUnaryExpression();
              return this.finalize(g, new h.AwaitExpression(f));
            }, Z.prototype.parseUnaryExpression = function() {
              var g;
              if (this.match("+") || this.match("-") || this.match("~") || this.match("!") || this.matchKeyword("delete") || this.matchKeyword("void") || this.matchKeyword("typeof")) {
                var f = this.startNode(this.lookahead), T = this.nextToken();
                g = this.inheritCoverGrammar(this.parseUnaryExpression), g = this.finalize(f, new h.UnaryExpression(T.value, g)), this.context.strict && g.operator === "delete" && g.argument.type === m.Syntax.Identifier && this.tolerateError(d.Messages.StrictDelete), this.context.isAssignmentTarget = !1, this.context.isBindingElement = !1;
              } else g = this.context.await && this.matchContextualKeyword("await") ? this.parseAwaitExpression() : this.parseUpdateExpression();
              return g;
            }, Z.prototype.parseExponentiationExpression = function() {
              var g = this.lookahead, f = this.inheritCoverGrammar(this.parseUnaryExpression);
              if (f.type !== m.Syntax.UnaryExpression && this.match("**")) {
                this.nextToken(), this.context.isAssignmentTarget = !1, this.context.isBindingElement = !1;
                var T = f, M = this.isolateCoverGrammar(this.parseExponentiationExpression);
                f = this.finalize(this.startNode(g), new h.BinaryExpression("**", T, M));
              }
              return f;
            }, Z.prototype.binaryPrecedence = function(g) {
              var f = g.value;
              return g.type === 7 ? this.operatorPrecedence[f] || 0 : g.type === 4 && (f === "instanceof" || this.context.allowIn && f === "in") ? 7 : 0;
            }, Z.prototype.parseBinaryExpression = function() {
              var g = this.lookahead, f = this.inheritCoverGrammar(this.parseExponentiationExpression), T = this.lookahead, M = this.binaryPrecedence(T);
              if (M > 0) {
                this.nextToken(), this.context.isAssignmentTarget = !1, this.context.isBindingElement = !1;
                for (var N = [g, this.lookahead], W = f, x = this.isolateCoverGrammar(this.parseExponentiationExpression), V = [W, T.value, x], X = [M]; !((M = this.binaryPrecedence(this.lookahead)) <= 0); ) {
                  for (; V.length > 2 && M <= X[X.length - 1]; ) {
                    x = V.pop();
                    var C = V.pop();
                    X.pop(), W = V.pop(), N.pop();
                    var R = this.startNode(N[N.length - 1]);
                    V.push(this.finalize(R, new h.BinaryExpression(C, W, x)));
                  }
                  V.push(this.nextToken().value), X.push(M), N.push(this.lookahead), V.push(this.isolateCoverGrammar(this.parseExponentiationExpression));
                }
                var z = V.length - 1;
                f = V[z];
                for (var F = N.pop(); z > 1; ) {
                  var P = N.pop(), j = F && F.lineStart;
                  R = this.startNode(P, j), C = V[z - 1], f = this.finalize(R, new h.BinaryExpression(C, V[z - 2], f)), z -= 2, F = P;
                }
              }
              return f;
            }, Z.prototype.parseConditionalExpression = function() {
              var g = this.lookahead, f = this.inheritCoverGrammar(this.parseBinaryExpression);
              if (this.match("?")) {
                this.nextToken();
                var T = this.context.allowIn;
                this.context.allowIn = !0;
                var M = this.isolateCoverGrammar(this.parseAssignmentExpression);
                this.context.allowIn = T, this.expect(":");
                var N = this.isolateCoverGrammar(this.parseAssignmentExpression);
                f = this.finalize(this.startNode(g), new h.ConditionalExpression(f, M, N)), this.context.isAssignmentTarget = !1, this.context.isBindingElement = !1;
              }
              return f;
            }, Z.prototype.checkPatternParam = function(g, f) {
              switch (f.type) {
                case m.Syntax.Identifier:
                  this.validateParam(g, f, f.name);
                  break;
                case m.Syntax.RestElement:
                  this.checkPatternParam(g, f.argument);
                  break;
                case m.Syntax.AssignmentPattern:
                  this.checkPatternParam(g, f.left);
                  break;
                case m.Syntax.ArrayPattern:
                  for (var T = 0; T < f.elements.length; T++) f.elements[T] !== null && this.checkPatternParam(g, f.elements[T]);
                  break;
                case m.Syntax.ObjectPattern:
                  for (T = 0; T < f.properties.length; T++) this.checkPatternParam(g, f.properties[T].value);
              }
              g.simple = g.simple && f instanceof h.Identifier;
            }, Z.prototype.reinterpretAsCoverFormalsList = function(g) {
              var f, T = [g], M = !1;
              switch (g.type) {
                case m.Syntax.Identifier:
                  break;
                case "ArrowParameterPlaceHolder":
                  T = g.params, M = g.async;
                  break;
                default:
                  return null;
              }
              f = { simple: !0, paramSet: {} };
              for (var N = 0; N < T.length; ++N) (W = T[N]).type === m.Syntax.AssignmentPattern ? W.right.type === m.Syntax.YieldExpression && (W.right.argument && this.throwUnexpectedToken(this.lookahead), W.right.type = m.Syntax.Identifier, W.right.name = "yield", delete W.right.argument, delete W.right.delegate) : M && W.type === m.Syntax.Identifier && W.name === "await" && this.throwUnexpectedToken(this.lookahead), this.checkPatternParam(f, W), T[N] = W;
              if (this.context.strict || !this.context.allowYield) for (N = 0; N < T.length; ++N) {
                var W;
                (W = T[N]).type === m.Syntax.YieldExpression && this.throwUnexpectedToken(this.lookahead);
              }
              if (f.message === d.Messages.StrictParamDupe) {
                var x = this.context.strict ? f.stricted : f.firstRestricted;
                this.throwUnexpectedToken(x, f.message);
              }
              return { simple: f.simple, params: T, stricted: f.stricted, firstRestricted: f.firstRestricted, message: f.message };
            }, Z.prototype.parseAssignmentExpression = function() {
              var g;
              if (!this.context.allowYield && this.matchKeyword("yield")) g = this.parseYieldExpression();
              else {
                var f = this.lookahead, T = f;
                if (g = this.parseConditionalExpression(), T.type === 3 && T.lineNumber === this.lookahead.lineNumber && T.value === "async" && (this.lookahead.type === 3 || this.matchKeyword("yield"))) {
                  var M = this.parsePrimaryExpression();
                  this.reinterpretExpressionAsPattern(M), g = { type: "ArrowParameterPlaceHolder", params: [M], async: !0 };
                }
                if (g.type === "ArrowParameterPlaceHolder" || this.match("=>")) {
                  this.context.isAssignmentTarget = !1, this.context.isBindingElement = !1;
                  var N = g.async, W = this.reinterpretAsCoverFormalsList(g);
                  if (W) {
                    this.hasLineTerminator && this.tolerateUnexpectedToken(this.lookahead), this.context.firstCoverInitializedNameError = null;
                    var x = this.context.strict, V = this.context.allowStrictDirective;
                    this.context.allowStrictDirective = W.simple;
                    var X = this.context.allowYield, C = this.context.await;
                    this.context.allowYield = !0, this.context.await = N;
                    var R = this.startNode(f);
                    this.expect("=>");
                    var z = void 0;
                    if (this.match("{")) {
                      var F = this.context.allowIn;
                      this.context.allowIn = !0, z = this.parseFunctionSourceElements(), this.context.allowIn = F;
                    } else z = this.isolateCoverGrammar(this.parseAssignmentExpression);
                    var P = z.type !== m.Syntax.BlockStatement;
                    this.context.strict && W.firstRestricted && this.throwUnexpectedToken(W.firstRestricted, W.message), this.context.strict && W.stricted && this.tolerateUnexpectedToken(W.stricted, W.message), g = N ? this.finalize(R, new h.AsyncArrowFunctionExpression(W.params, z, P)) : this.finalize(R, new h.ArrowFunctionExpression(W.params, z, P)), this.context.strict = x, this.context.allowStrictDirective = V, this.context.allowYield = X, this.context.await = C;
                  }
                } else if (this.matchAssign()) {
                  if (this.context.isAssignmentTarget || this.tolerateError(d.Messages.InvalidLHSInAssignment), this.context.strict && g.type === m.Syntax.Identifier) {
                    var j = g;
                    this.scanner.isRestrictedWord(j.name) && this.tolerateUnexpectedToken(T, d.Messages.StrictLHSAssignment), this.scanner.isStrictModeReservedWord(j.name) && this.tolerateUnexpectedToken(T, d.Messages.StrictReservedWord);
                  }
                  this.match("=") ? this.reinterpretExpressionAsPattern(g) : (this.context.isAssignmentTarget = !1, this.context.isBindingElement = !1);
                  var H = (T = this.nextToken()).value, B = this.isolateCoverGrammar(this.parseAssignmentExpression);
                  g = this.finalize(this.startNode(f), new h.AssignmentExpression(H, g, B)), this.context.firstCoverInitializedNameError = null;
                }
              }
              return g;
            }, Z.prototype.parseExpression = function() {
              var g = this.lookahead, f = this.isolateCoverGrammar(this.parseAssignmentExpression);
              if (this.match(",")) {
                var T = [];
                for (T.push(f); this.lookahead.type !== 2 && this.match(","); ) this.nextToken(), T.push(this.isolateCoverGrammar(this.parseAssignmentExpression));
                f = this.finalize(this.startNode(g), new h.SequenceExpression(T));
              }
              return f;
            }, Z.prototype.parseStatementListItem = function() {
              var g;
              if (this.context.isAssignmentTarget = !0, this.context.isBindingElement = !0, this.lookahead.type === 4) switch (this.lookahead.value) {
                case "export":
                  this.context.isModule || this.tolerateUnexpectedToken(this.lookahead, d.Messages.IllegalExportDeclaration), g = this.parseExportDeclaration();
                  break;
                case "import":
                  this.context.isModule || this.tolerateUnexpectedToken(this.lookahead, d.Messages.IllegalImportDeclaration), g = this.parseImportDeclaration();
                  break;
                case "const":
                  g = this.parseLexicalDeclaration({ inFor: !1 });
                  break;
                case "function":
                  g = this.parseFunctionDeclaration();
                  break;
                case "class":
                  g = this.parseClassDeclaration();
                  break;
                case "let":
                  g = this.isLexicalDeclaration() ? this.parseLexicalDeclaration({ inFor: !1 }) : this.parseStatement();
                  break;
                default:
                  g = this.parseStatement();
              }
              else g = this.parseStatement();
              return g;
            }, Z.prototype.parseBlock = function() {
              var g = this.createNode();
              this.expect("{");
              for (var f = []; !this.match("}"); ) f.push(this.parseStatementListItem());
              return this.expect("}"), this.finalize(g, new h.BlockStatement(f));
            }, Z.prototype.parseLexicalBinding = function(g, f) {
              var T = this.createNode(), M = this.parsePattern([], g);
              this.context.strict && M.type === m.Syntax.Identifier && this.scanner.isRestrictedWord(M.name) && this.tolerateError(d.Messages.StrictVarName);
              var N = null;
              return g === "const" ? this.matchKeyword("in") || this.matchContextualKeyword("of") || (this.match("=") ? (this.nextToken(), N = this.isolateCoverGrammar(this.parseAssignmentExpression)) : this.throwError(d.Messages.DeclarationMissingInitializer, "const")) : (!f.inFor && M.type !== m.Syntax.Identifier || this.match("=")) && (this.expect("="), N = this.isolateCoverGrammar(this.parseAssignmentExpression)), this.finalize(T, new h.VariableDeclarator(M, N));
            }, Z.prototype.parseBindingList = function(g, f) {
              for (var T = [this.parseLexicalBinding(g, f)]; this.match(","); ) this.nextToken(), T.push(this.parseLexicalBinding(g, f));
              return T;
            }, Z.prototype.isLexicalDeclaration = function() {
              var g = this.scanner.saveState();
              this.scanner.scanComments();
              var f = this.scanner.lex();
              return this.scanner.restoreState(g), f.type === 3 || f.type === 7 && f.value === "[" || f.type === 7 && f.value === "{" || f.type === 4 && f.value === "let" || f.type === 4 && f.value === "yield";
            }, Z.prototype.parseLexicalDeclaration = function(g) {
              var f = this.createNode(), T = this.nextToken().value;
              c.assert(T === "let" || T === "const", "Lexical declaration must be either let or const");
              var M = this.parseBindingList(T, g);
              return this.consumeSemicolon(), this.finalize(f, new h.VariableDeclaration(M, T));
            }, Z.prototype.parseBindingRestElement = function(g, f) {
              var T = this.createNode();
              this.expect("...");
              var M = this.parsePattern(g, f);
              return this.finalize(T, new h.RestElement(M));
            }, Z.prototype.parseArrayPattern = function(g, f) {
              var T = this.createNode();
              this.expect("[");
              for (var M = []; !this.match("]"); ) if (this.match(",")) this.nextToken(), M.push(null);
              else {
                if (this.match("...")) {
                  M.push(this.parseBindingRestElement(g, f));
                  break;
                }
                M.push(this.parsePatternWithDefault(g, f)), this.match("]") || this.expect(",");
              }
              return this.expect("]"), this.finalize(T, new h.ArrayPattern(M));
            }, Z.prototype.parsePropertyPattern = function(g, f) {
              var T, M, N = this.createNode(), W = !1, x = !1;
              if (this.lookahead.type === 3) {
                var V = this.lookahead;
                T = this.parseVariableIdentifier();
                var X = this.finalize(N, new h.Identifier(V.value));
                if (this.match("=")) {
                  g.push(V), x = !0, this.nextToken();
                  var C = this.parseAssignmentExpression();
                  M = this.finalize(this.startNode(V), new h.AssignmentPattern(X, C));
                } else this.match(":") ? (this.expect(":"), M = this.parsePatternWithDefault(g, f)) : (g.push(V), x = !0, M = X);
              } else W = this.match("["), T = this.parseObjectPropertyKey(), this.expect(":"), M = this.parsePatternWithDefault(g, f);
              return this.finalize(N, new h.Property("init", T, W, M, !1, x));
            }, Z.prototype.parseObjectPattern = function(g, f) {
              var T = this.createNode(), M = [];
              for (this.expect("{"); !this.match("}"); ) M.push(this.parsePropertyPattern(g, f)), this.match("}") || this.expect(",");
              return this.expect("}"), this.finalize(T, new h.ObjectPattern(M));
            }, Z.prototype.parsePattern = function(g, f) {
              var T;
              return this.match("[") ? T = this.parseArrayPattern(g, f) : this.match("{") ? T = this.parseObjectPattern(g, f) : (!this.matchKeyword("let") || f !== "const" && f !== "let" || this.tolerateUnexpectedToken(this.lookahead, d.Messages.LetInLexicalBinding), g.push(this.lookahead), T = this.parseVariableIdentifier(f)), T;
            }, Z.prototype.parsePatternWithDefault = function(g, f) {
              var T = this.lookahead, M = this.parsePattern(g, f);
              if (this.match("=")) {
                this.nextToken();
                var N = this.context.allowYield;
                this.context.allowYield = !0;
                var W = this.isolateCoverGrammar(this.parseAssignmentExpression);
                this.context.allowYield = N, M = this.finalize(this.startNode(T), new h.AssignmentPattern(M, W));
              }
              return M;
            }, Z.prototype.parseVariableIdentifier = function(g) {
              var f = this.createNode(), T = this.nextToken();
              return T.type === 4 && T.value === "yield" ? this.context.strict ? this.tolerateUnexpectedToken(T, d.Messages.StrictReservedWord) : this.context.allowYield || this.throwUnexpectedToken(T) : T.type !== 3 ? this.context.strict && T.type === 4 && this.scanner.isStrictModeReservedWord(T.value) ? this.tolerateUnexpectedToken(T, d.Messages.StrictReservedWord) : (this.context.strict || T.value !== "let" || g !== "var") && this.throwUnexpectedToken(T) : (this.context.isModule || this.context.await) && T.type === 3 && T.value === "await" && this.tolerateUnexpectedToken(T), this.finalize(f, new h.Identifier(T.value));
            }, Z.prototype.parseVariableDeclaration = function(g) {
              var f = this.createNode(), T = this.parsePattern([], "var");
              this.context.strict && T.type === m.Syntax.Identifier && this.scanner.isRestrictedWord(T.name) && this.tolerateError(d.Messages.StrictVarName);
              var M = null;
              return this.match("=") ? (this.nextToken(), M = this.isolateCoverGrammar(this.parseAssignmentExpression)) : T.type === m.Syntax.Identifier || g.inFor || this.expect("="), this.finalize(f, new h.VariableDeclarator(T, M));
            }, Z.prototype.parseVariableDeclarationList = function(g) {
              var f = { inFor: g.inFor }, T = [];
              for (T.push(this.parseVariableDeclaration(f)); this.match(","); ) this.nextToken(), T.push(this.parseVariableDeclaration(f));
              return T;
            }, Z.prototype.parseVariableStatement = function() {
              var g = this.createNode();
              this.expectKeyword("var");
              var f = this.parseVariableDeclarationList({ inFor: !1 });
              return this.consumeSemicolon(), this.finalize(g, new h.VariableDeclaration(f, "var"));
            }, Z.prototype.parseEmptyStatement = function() {
              var g = this.createNode();
              return this.expect(";"), this.finalize(g, new h.EmptyStatement());
            }, Z.prototype.parseExpressionStatement = function() {
              var g = this.createNode(), f = this.parseExpression();
              return this.consumeSemicolon(), this.finalize(g, new h.ExpressionStatement(f));
            }, Z.prototype.parseIfClause = function() {
              return this.context.strict && this.matchKeyword("function") && this.tolerateError(d.Messages.StrictFunction), this.parseStatement();
            }, Z.prototype.parseIfStatement = function() {
              var g, f = this.createNode(), T = null;
              this.expectKeyword("if"), this.expect("(");
              var M = this.parseExpression();
              return !this.match(")") && this.config.tolerant ? (this.tolerateUnexpectedToken(this.nextToken()), g = this.finalize(this.createNode(), new h.EmptyStatement())) : (this.expect(")"), g = this.parseIfClause(), this.matchKeyword("else") && (this.nextToken(), T = this.parseIfClause())), this.finalize(f, new h.IfStatement(M, g, T));
            }, Z.prototype.parseDoWhileStatement = function() {
              var g = this.createNode();
              this.expectKeyword("do");
              var f = this.context.inIteration;
              this.context.inIteration = !0;
              var T = this.parseStatement();
              this.context.inIteration = f, this.expectKeyword("while"), this.expect("(");
              var M = this.parseExpression();
              return !this.match(")") && this.config.tolerant ? this.tolerateUnexpectedToken(this.nextToken()) : (this.expect(")"), this.match(";") && this.nextToken()), this.finalize(g, new h.DoWhileStatement(T, M));
            }, Z.prototype.parseWhileStatement = function() {
              var g, f = this.createNode();
              this.expectKeyword("while"), this.expect("(");
              var T = this.parseExpression();
              if (!this.match(")") && this.config.tolerant) this.tolerateUnexpectedToken(this.nextToken()), g = this.finalize(this.createNode(), new h.EmptyStatement());
              else {
                this.expect(")");
                var M = this.context.inIteration;
                this.context.inIteration = !0, g = this.parseStatement(), this.context.inIteration = M;
              }
              return this.finalize(f, new h.WhileStatement(T, g));
            }, Z.prototype.parseForStatement = function() {
              var g, f, T, M = null, N = null, W = null, x = !0, V = this.createNode();
              if (this.expectKeyword("for"), this.expect("("), this.match(";")) this.nextToken();
              else if (this.matchKeyword("var")) {
                M = this.createNode(), this.nextToken();
                var X = this.context.allowIn;
                this.context.allowIn = !1;
                var C = this.parseVariableDeclarationList({ inFor: !0 });
                if (this.context.allowIn = X, C.length === 1 && this.matchKeyword("in")) {
                  var R = C[0];
                  R.init && (R.id.type === m.Syntax.ArrayPattern || R.id.type === m.Syntax.ObjectPattern || this.context.strict) && this.tolerateError(d.Messages.ForInOfLoopInitializer, "for-in"), M = this.finalize(M, new h.VariableDeclaration(C, "var")), this.nextToken(), g = M, f = this.parseExpression(), M = null;
                } else C.length === 1 && C[0].init === null && this.matchContextualKeyword("of") ? (M = this.finalize(M, new h.VariableDeclaration(C, "var")), this.nextToken(), g = M, f = this.parseAssignmentExpression(), M = null, x = !1) : (M = this.finalize(M, new h.VariableDeclaration(C, "var")), this.expect(";"));
              } else if (this.matchKeyword("const") || this.matchKeyword("let")) {
                M = this.createNode();
                var z = this.nextToken().value;
                this.context.strict || this.lookahead.value !== "in" ? (X = this.context.allowIn, this.context.allowIn = !1, C = this.parseBindingList(z, { inFor: !0 }), this.context.allowIn = X, C.length === 1 && C[0].init === null && this.matchKeyword("in") ? (M = this.finalize(M, new h.VariableDeclaration(C, z)), this.nextToken(), g = M, f = this.parseExpression(), M = null) : C.length === 1 && C[0].init === null && this.matchContextualKeyword("of") ? (M = this.finalize(M, new h.VariableDeclaration(C, z)), this.nextToken(), g = M, f = this.parseAssignmentExpression(), M = null, x = !1) : (this.consumeSemicolon(), M = this.finalize(M, new h.VariableDeclaration(C, z)))) : (M = this.finalize(M, new h.Identifier(z)), this.nextToken(), g = M, f = this.parseExpression(), M = null);
              } else {
                var F = this.lookahead;
                if (X = this.context.allowIn, this.context.allowIn = !1, M = this.inheritCoverGrammar(this.parseAssignmentExpression), this.context.allowIn = X, this.matchKeyword("in")) this.context.isAssignmentTarget && M.type !== m.Syntax.AssignmentExpression || this.tolerateError(d.Messages.InvalidLHSInForIn), this.nextToken(), this.reinterpretExpressionAsPattern(M), g = M, f = this.parseExpression(), M = null;
                else if (this.matchContextualKeyword("of")) this.context.isAssignmentTarget && M.type !== m.Syntax.AssignmentExpression || this.tolerateError(d.Messages.InvalidLHSInForLoop), this.nextToken(), this.reinterpretExpressionAsPattern(M), g = M, f = this.parseAssignmentExpression(), M = null, x = !1;
                else {
                  if (this.match(",")) {
                    for (var P = [M]; this.match(","); ) this.nextToken(), P.push(this.isolateCoverGrammar(this.parseAssignmentExpression));
                    M = this.finalize(this.startNode(F), new h.SequenceExpression(P));
                  }
                  this.expect(";");
                }
              }
              if (g === void 0 && (this.match(";") || (N = this.parseExpression()), this.expect(";"), this.match(")") || (W = this.parseExpression())), !this.match(")") && this.config.tolerant) this.tolerateUnexpectedToken(this.nextToken()), T = this.finalize(this.createNode(), new h.EmptyStatement());
              else {
                this.expect(")");
                var j = this.context.inIteration;
                this.context.inIteration = !0, T = this.isolateCoverGrammar(this.parseStatement), this.context.inIteration = j;
              }
              return g === void 0 ? this.finalize(V, new h.ForStatement(M, N, W, T)) : x ? this.finalize(V, new h.ForInStatement(g, f, T)) : this.finalize(V, new h.ForOfStatement(g, f, T));
            }, Z.prototype.parseContinueStatement = function() {
              var g = this.createNode();
              this.expectKeyword("continue");
              var f = null;
              if (this.lookahead.type === 3 && !this.hasLineTerminator) {
                var T = this.parseVariableIdentifier();
                f = T;
                var M = "$" + T.name;
                Object.prototype.hasOwnProperty.call(this.context.labelSet, M) || this.throwError(d.Messages.UnknownLabel, T.name);
              }
              return this.consumeSemicolon(), f !== null || this.context.inIteration || this.throwError(d.Messages.IllegalContinue), this.finalize(g, new h.ContinueStatement(f));
            }, Z.prototype.parseBreakStatement = function() {
              var g = this.createNode();
              this.expectKeyword("break");
              var f = null;
              if (this.lookahead.type === 3 && !this.hasLineTerminator) {
                var T = this.parseVariableIdentifier(), M = "$" + T.name;
                Object.prototype.hasOwnProperty.call(this.context.labelSet, M) || this.throwError(d.Messages.UnknownLabel, T.name), f = T;
              }
              return this.consumeSemicolon(), f !== null || this.context.inIteration || this.context.inSwitch || this.throwError(d.Messages.IllegalBreak), this.finalize(g, new h.BreakStatement(f));
            }, Z.prototype.parseReturnStatement = function() {
              this.context.inFunctionBody || this.tolerateError(d.Messages.IllegalReturn);
              var g = this.createNode();
              this.expectKeyword("return");
              var f = (this.match(";") || this.match("}") || this.hasLineTerminator || this.lookahead.type === 2) && this.lookahead.type !== 8 && this.lookahead.type !== 10 ? null : this.parseExpression();
              return this.consumeSemicolon(), this.finalize(g, new h.ReturnStatement(f));
            }, Z.prototype.parseWithStatement = function() {
              this.context.strict && this.tolerateError(d.Messages.StrictModeWith);
              var g, f = this.createNode();
              this.expectKeyword("with"), this.expect("(");
              var T = this.parseExpression();
              return !this.match(")") && this.config.tolerant ? (this.tolerateUnexpectedToken(this.nextToken()), g = this.finalize(this.createNode(), new h.EmptyStatement())) : (this.expect(")"), g = this.parseStatement()), this.finalize(f, new h.WithStatement(T, g));
            }, Z.prototype.parseSwitchCase = function() {
              var g, f = this.createNode();
              this.matchKeyword("default") ? (this.nextToken(), g = null) : (this.expectKeyword("case"), g = this.parseExpression()), this.expect(":");
              for (var T = []; !(this.match("}") || this.matchKeyword("default") || this.matchKeyword("case")); ) T.push(this.parseStatementListItem());
              return this.finalize(f, new h.SwitchCase(g, T));
            }, Z.prototype.parseSwitchStatement = function() {
              var g = this.createNode();
              this.expectKeyword("switch"), this.expect("(");
              var f = this.parseExpression();
              this.expect(")");
              var T = this.context.inSwitch;
              this.context.inSwitch = !0;
              var M = [], N = !1;
              for (this.expect("{"); !this.match("}"); ) {
                var W = this.parseSwitchCase();
                W.test === null && (N && this.throwError(d.Messages.MultipleDefaultsInSwitch), N = !0), M.push(W);
              }
              return this.expect("}"), this.context.inSwitch = T, this.finalize(g, new h.SwitchStatement(f, M));
            }, Z.prototype.parseLabelledStatement = function() {
              var g, f = this.createNode(), T = this.parseExpression();
              if (T.type === m.Syntax.Identifier && this.match(":")) {
                this.nextToken();
                var M = T, N = "$" + M.name;
                Object.prototype.hasOwnProperty.call(this.context.labelSet, N) && this.throwError(d.Messages.Redeclaration, "Label", M.name), this.context.labelSet[N] = !0;
                var W = void 0;
                if (this.matchKeyword("class")) this.tolerateUnexpectedToken(this.lookahead), W = this.parseClassDeclaration();
                else if (this.matchKeyword("function")) {
                  var x = this.lookahead, V = this.parseFunctionDeclaration();
                  this.context.strict ? this.tolerateUnexpectedToken(x, d.Messages.StrictFunction) : V.generator && this.tolerateUnexpectedToken(x, d.Messages.GeneratorInLegacyContext), W = V;
                } else W = this.parseStatement();
                delete this.context.labelSet[N], g = new h.LabeledStatement(M, W);
              } else this.consumeSemicolon(), g = new h.ExpressionStatement(T);
              return this.finalize(f, g);
            }, Z.prototype.parseThrowStatement = function() {
              var g = this.createNode();
              this.expectKeyword("throw"), this.hasLineTerminator && this.throwError(d.Messages.NewlineAfterThrow);
              var f = this.parseExpression();
              return this.consumeSemicolon(), this.finalize(g, new h.ThrowStatement(f));
            }, Z.prototype.parseCatchClause = function() {
              var g = this.createNode();
              this.expectKeyword("catch"), this.expect("("), this.match(")") && this.throwUnexpectedToken(this.lookahead);
              for (var f = [], T = this.parsePattern(f), M = {}, N = 0; N < f.length; N++) {
                var W = "$" + f[N].value;
                Object.prototype.hasOwnProperty.call(M, W) && this.tolerateError(d.Messages.DuplicateBinding, f[N].value), M[W] = !0;
              }
              this.context.strict && T.type === m.Syntax.Identifier && this.scanner.isRestrictedWord(T.name) && this.tolerateError(d.Messages.StrictCatchVariable), this.expect(")");
              var x = this.parseBlock();
              return this.finalize(g, new h.CatchClause(T, x));
            }, Z.prototype.parseFinallyClause = function() {
              return this.expectKeyword("finally"), this.parseBlock();
            }, Z.prototype.parseTryStatement = function() {
              var g = this.createNode();
              this.expectKeyword("try");
              var f = this.parseBlock(), T = this.matchKeyword("catch") ? this.parseCatchClause() : null, M = this.matchKeyword("finally") ? this.parseFinallyClause() : null;
              return T || M || this.throwError(d.Messages.NoCatchOrFinally), this.finalize(g, new h.TryStatement(f, T, M));
            }, Z.prototype.parseDebuggerStatement = function() {
              var g = this.createNode();
              return this.expectKeyword("debugger"), this.consumeSemicolon(), this.finalize(g, new h.DebuggerStatement());
            }, Z.prototype.parseStatement = function() {
              var g;
              switch (this.lookahead.type) {
                case 1:
                case 5:
                case 6:
                case 8:
                case 10:
                case 9:
                  g = this.parseExpressionStatement();
                  break;
                case 7:
                  var f = this.lookahead.value;
                  g = f === "{" ? this.parseBlock() : f === "(" ? this.parseExpressionStatement() : f === ";" ? this.parseEmptyStatement() : this.parseExpressionStatement();
                  break;
                case 3:
                  g = this.matchAsyncFunction() ? this.parseFunctionDeclaration() : this.parseLabelledStatement();
                  break;
                case 4:
                  switch (this.lookahead.value) {
                    case "break":
                      g = this.parseBreakStatement();
                      break;
                    case "continue":
                      g = this.parseContinueStatement();
                      break;
                    case "debugger":
                      g = this.parseDebuggerStatement();
                      break;
                    case "do":
                      g = this.parseDoWhileStatement();
                      break;
                    case "for":
                      g = this.parseForStatement();
                      break;
                    case "function":
                      g = this.parseFunctionDeclaration();
                      break;
                    case "if":
                      g = this.parseIfStatement();
                      break;
                    case "return":
                      g = this.parseReturnStatement();
                      break;
                    case "switch":
                      g = this.parseSwitchStatement();
                      break;
                    case "throw":
                      g = this.parseThrowStatement();
                      break;
                    case "try":
                      g = this.parseTryStatement();
                      break;
                    case "var":
                      g = this.parseVariableStatement();
                      break;
                    case "while":
                      g = this.parseWhileStatement();
                      break;
                    case "with":
                      g = this.parseWithStatement();
                      break;
                    default:
                      g = this.parseExpressionStatement();
                  }
                  break;
                default:
                  g = this.throwUnexpectedToken(this.lookahead);
              }
              return g;
            }, Z.prototype.parseFunctionSourceElements = function() {
              var g = this.createNode();
              this.expect("{");
              var f = this.parseDirectivePrologues(), T = this.context.labelSet, M = this.context.inIteration, N = this.context.inSwitch, W = this.context.inFunctionBody;
              for (this.context.labelSet = {}, this.context.inIteration = !1, this.context.inSwitch = !1, this.context.inFunctionBody = !0; this.lookahead.type !== 2 && !this.match("}"); ) f.push(this.parseStatementListItem());
              return this.expect("}"), this.context.labelSet = T, this.context.inIteration = M, this.context.inSwitch = N, this.context.inFunctionBody = W, this.finalize(g, new h.BlockStatement(f));
            }, Z.prototype.validateParam = function(g, f, T) {
              var M = "$" + T;
              this.context.strict ? (this.scanner.isRestrictedWord(T) && (g.stricted = f, g.message = d.Messages.StrictParamName), Object.prototype.hasOwnProperty.call(g.paramSet, M) && (g.stricted = f, g.message = d.Messages.StrictParamDupe)) : g.firstRestricted || (this.scanner.isRestrictedWord(T) ? (g.firstRestricted = f, g.message = d.Messages.StrictParamName) : this.scanner.isStrictModeReservedWord(T) ? (g.firstRestricted = f, g.message = d.Messages.StrictReservedWord) : Object.prototype.hasOwnProperty.call(g.paramSet, M) && (g.stricted = f, g.message = d.Messages.StrictParamDupe)), typeof Object.defineProperty == "function" ? Object.defineProperty(g.paramSet, M, { value: !0, enumerable: !0, writable: !0, configurable: !0 }) : g.paramSet[M] = !0;
            }, Z.prototype.parseRestElement = function(g) {
              var f = this.createNode();
              this.expect("...");
              var T = this.parsePattern(g);
              return this.match("=") && this.throwError(d.Messages.DefaultRestParameter), this.match(")") || this.throwError(d.Messages.ParameterAfterRestParameter), this.finalize(f, new h.RestElement(T));
            }, Z.prototype.parseFormalParameter = function(g) {
              for (var f = [], T = this.match("...") ? this.parseRestElement(f) : this.parsePatternWithDefault(f), M = 0; M < f.length; M++) this.validateParam(g, f[M], f[M].value);
              g.simple = g.simple && T instanceof h.Identifier, g.params.push(T);
            }, Z.prototype.parseFormalParameters = function(g) {
              var f;
              if (f = { simple: !0, params: [], firstRestricted: g }, this.expect("("), !this.match(")")) for (f.paramSet = {}; this.lookahead.type !== 2 && (this.parseFormalParameter(f), !this.match(")")) && (this.expect(","), !this.match(")")); ) ;
              return this.expect(")"), { simple: f.simple, params: f.params, stricted: f.stricted, firstRestricted: f.firstRestricted, message: f.message };
            }, Z.prototype.matchAsyncFunction = function() {
              var g = this.matchContextualKeyword("async");
              if (g) {
                var f = this.scanner.saveState();
                this.scanner.scanComments();
                var T = this.scanner.lex();
                this.scanner.restoreState(f), g = f.lineNumber === T.lineNumber && T.type === 4 && T.value === "function";
              }
              return g;
            }, Z.prototype.parseFunctionDeclaration = function(g) {
              var f = this.createNode(), T = this.matchContextualKeyword("async");
              T && this.nextToken(), this.expectKeyword("function");
              var M, N = !T && this.match("*");
              N && this.nextToken();
              var W = null, x = null;
              if (!g || !this.match("(")) {
                var V = this.lookahead;
                W = this.parseVariableIdentifier(), this.context.strict ? this.scanner.isRestrictedWord(V.value) && this.tolerateUnexpectedToken(V, d.Messages.StrictFunctionName) : this.scanner.isRestrictedWord(V.value) ? (x = V, M = d.Messages.StrictFunctionName) : this.scanner.isStrictModeReservedWord(V.value) && (x = V, M = d.Messages.StrictReservedWord);
              }
              var X = this.context.await, C = this.context.allowYield;
              this.context.await = T, this.context.allowYield = !N;
              var R = this.parseFormalParameters(x), z = R.params, F = R.stricted;
              x = R.firstRestricted, R.message && (M = R.message);
              var P = this.context.strict, j = this.context.allowStrictDirective;
              this.context.allowStrictDirective = R.simple;
              var H = this.parseFunctionSourceElements();
              return this.context.strict && x && this.throwUnexpectedToken(x, M), this.context.strict && F && this.tolerateUnexpectedToken(F, M), this.context.strict = P, this.context.allowStrictDirective = j, this.context.await = X, this.context.allowYield = C, T ? this.finalize(f, new h.AsyncFunctionDeclaration(W, z, H)) : this.finalize(f, new h.FunctionDeclaration(W, z, H, N));
            }, Z.prototype.parseFunctionExpression = function() {
              var g = this.createNode(), f = this.matchContextualKeyword("async");
              f && this.nextToken(), this.expectKeyword("function");
              var T, M = !f && this.match("*");
              M && this.nextToken();
              var N, W = null, x = this.context.await, V = this.context.allowYield;
              if (this.context.await = f, this.context.allowYield = !M, !this.match("(")) {
                var X = this.lookahead;
                W = this.context.strict || M || !this.matchKeyword("yield") ? this.parseVariableIdentifier() : this.parseIdentifierName(), this.context.strict ? this.scanner.isRestrictedWord(X.value) && this.tolerateUnexpectedToken(X, d.Messages.StrictFunctionName) : this.scanner.isRestrictedWord(X.value) ? (N = X, T = d.Messages.StrictFunctionName) : this.scanner.isStrictModeReservedWord(X.value) && (N = X, T = d.Messages.StrictReservedWord);
              }
              var C = this.parseFormalParameters(N), R = C.params, z = C.stricted;
              N = C.firstRestricted, C.message && (T = C.message);
              var F = this.context.strict, P = this.context.allowStrictDirective;
              this.context.allowStrictDirective = C.simple;
              var j = this.parseFunctionSourceElements();
              return this.context.strict && N && this.throwUnexpectedToken(N, T), this.context.strict && z && this.tolerateUnexpectedToken(z, T), this.context.strict = F, this.context.allowStrictDirective = P, this.context.await = x, this.context.allowYield = V, f ? this.finalize(g, new h.AsyncFunctionExpression(W, R, j)) : this.finalize(g, new h.FunctionExpression(W, R, j, M));
            }, Z.prototype.parseDirective = function() {
              var g = this.lookahead, f = this.createNode(), T = this.parseExpression(), M = T.type === m.Syntax.Literal ? this.getTokenRaw(g).slice(1, -1) : null;
              return this.consumeSemicolon(), this.finalize(f, M ? new h.Directive(T, M) : new h.ExpressionStatement(T));
            }, Z.prototype.parseDirectivePrologues = function() {
              for (var g = null, f = []; ; ) {
                var T = this.lookahead;
                if (T.type !== 8) break;
                var M = this.parseDirective();
                f.push(M);
                var N = M.directive;
                if (typeof N != "string") break;
                N === "use strict" ? (this.context.strict = !0, g && this.tolerateUnexpectedToken(g, d.Messages.StrictOctalLiteral), this.context.allowStrictDirective || this.tolerateUnexpectedToken(T, d.Messages.IllegalLanguageModeDirective)) : !g && T.octal && (g = T);
              }
              return f;
            }, Z.prototype.qualifiedPropertyName = function(g) {
              switch (g.type) {
                case 3:
                case 8:
                case 1:
                case 5:
                case 6:
                case 4:
                  return !0;
                case 7:
                  return g.value === "[";
              }
              return !1;
            }, Z.prototype.parseGetterMethod = function() {
              var g = this.createNode(), f = this.context.allowYield;
              this.context.allowYield = !0;
              var T = this.parseFormalParameters();
              T.params.length > 0 && this.tolerateError(d.Messages.BadGetterArity);
              var M = this.parsePropertyMethod(T);
              return this.context.allowYield = f, this.finalize(g, new h.FunctionExpression(null, T.params, M, !1));
            }, Z.prototype.parseSetterMethod = function() {
              var g = this.createNode(), f = this.context.allowYield;
              this.context.allowYield = !0;
              var T = this.parseFormalParameters();
              T.params.length !== 1 ? this.tolerateError(d.Messages.BadSetterArity) : T.params[0] instanceof h.RestElement && this.tolerateError(d.Messages.BadSetterRestParameter);
              var M = this.parsePropertyMethod(T);
              return this.context.allowYield = f, this.finalize(g, new h.FunctionExpression(null, T.params, M, !1));
            }, Z.prototype.parseGeneratorMethod = function() {
              var g = this.createNode(), f = this.context.allowYield;
              this.context.allowYield = !0;
              var T = this.parseFormalParameters();
              this.context.allowYield = !1;
              var M = this.parsePropertyMethod(T);
              return this.context.allowYield = f, this.finalize(g, new h.FunctionExpression(null, T.params, M, !0));
            }, Z.prototype.isStartOfExpression = function() {
              var g = !0, f = this.lookahead.value;
              switch (this.lookahead.type) {
                case 7:
                  g = f === "[" || f === "(" || f === "{" || f === "+" || f === "-" || f === "!" || f === "~" || f === "++" || f === "--" || f === "/" || f === "/=";
                  break;
                case 4:
                  g = f === "class" || f === "delete" || f === "function" || f === "let" || f === "new" || f === "super" || f === "this" || f === "typeof" || f === "void" || f === "yield";
              }
              return g;
            }, Z.prototype.parseYieldExpression = function() {
              var g = this.createNode();
              this.expectKeyword("yield");
              var f = null, T = !1;
              if (!this.hasLineTerminator) {
                var M = this.context.allowYield;
                this.context.allowYield = !1, (T = this.match("*")) ? (this.nextToken(), f = this.parseAssignmentExpression()) : this.isStartOfExpression() && (f = this.parseAssignmentExpression()), this.context.allowYield = M;
              }
              return this.finalize(g, new h.YieldExpression(f, T));
            }, Z.prototype.parseClassElement = function(g) {
              var f = this.lookahead, T = this.createNode(), M = "", N = null, W = null, x = !1, V = !1, X = !1, C = !1;
              if (this.match("*")) this.nextToken();
              else if (x = this.match("["), (N = this.parseObjectPropertyKey()).name === "static" && (this.qualifiedPropertyName(this.lookahead) || this.match("*")) && (f = this.lookahead, X = !0, x = this.match("["), this.match("*") ? this.nextToken() : N = this.parseObjectPropertyKey()), f.type === 3 && !this.hasLineTerminator && f.value === "async") {
                var R = this.lookahead.value;
                R !== ":" && R !== "(" && R !== "*" && (C = !0, f = this.lookahead, N = this.parseObjectPropertyKey(), f.type === 3 && f.value === "constructor" && this.tolerateUnexpectedToken(f, d.Messages.ConstructorIsAsync));
              }
              var z = this.qualifiedPropertyName(this.lookahead);
              return f.type === 3 ? f.value === "get" && z ? (M = "get", x = this.match("["), N = this.parseObjectPropertyKey(), this.context.allowYield = !1, W = this.parseGetterMethod()) : f.value === "set" && z && (M = "set", x = this.match("["), N = this.parseObjectPropertyKey(), W = this.parseSetterMethod()) : f.type === 7 && f.value === "*" && z && (M = "init", x = this.match("["), N = this.parseObjectPropertyKey(), W = this.parseGeneratorMethod(), V = !0), !M && N && this.match("(") && (M = "init", W = C ? this.parsePropertyMethodAsyncFunction() : this.parsePropertyMethodFunction(), V = !0), M || this.throwUnexpectedToken(this.lookahead), M === "init" && (M = "method"), x || (X && this.isPropertyKey(N, "prototype") && this.throwUnexpectedToken(f, d.Messages.StaticPrototype), !X && this.isPropertyKey(N, "constructor") && ((M !== "method" || !V || W && W.generator) && this.throwUnexpectedToken(f, d.Messages.ConstructorSpecialMethod), g.value ? this.throwUnexpectedToken(f, d.Messages.DuplicateConstructor) : g.value = !0, M = "constructor")), this.finalize(T, new h.MethodDefinition(N, x, W, M, X));
            }, Z.prototype.parseClassElementList = function() {
              var g = [], f = { value: !1 };
              for (this.expect("{"); !this.match("}"); ) this.match(";") ? this.nextToken() : g.push(this.parseClassElement(f));
              return this.expect("}"), g;
            }, Z.prototype.parseClassBody = function() {
              var g = this.createNode(), f = this.parseClassElementList();
              return this.finalize(g, new h.ClassBody(f));
            }, Z.prototype.parseClassDeclaration = function(g) {
              var f = this.createNode(), T = this.context.strict;
              this.context.strict = !0, this.expectKeyword("class");
              var M = g && this.lookahead.type !== 3 ? null : this.parseVariableIdentifier(), N = null;
              this.matchKeyword("extends") && (this.nextToken(), N = this.isolateCoverGrammar(this.parseLeftHandSideExpressionAllowCall));
              var W = this.parseClassBody();
              return this.context.strict = T, this.finalize(f, new h.ClassDeclaration(M, N, W));
            }, Z.prototype.parseClassExpression = function() {
              var g = this.createNode(), f = this.context.strict;
              this.context.strict = !0, this.expectKeyword("class");
              var T = this.lookahead.type === 3 ? this.parseVariableIdentifier() : null, M = null;
              this.matchKeyword("extends") && (this.nextToken(), M = this.isolateCoverGrammar(this.parseLeftHandSideExpressionAllowCall));
              var N = this.parseClassBody();
              return this.context.strict = f, this.finalize(g, new h.ClassExpression(T, M, N));
            }, Z.prototype.parseModule = function() {
              this.context.strict = !0, this.context.isModule = !0, this.scanner.isModule = !0;
              for (var g = this.createNode(), f = this.parseDirectivePrologues(); this.lookahead.type !== 2; ) f.push(this.parseStatementListItem());
              return this.finalize(g, new h.Module(f));
            }, Z.prototype.parseScript = function() {
              for (var g = this.createNode(), f = this.parseDirectivePrologues(); this.lookahead.type !== 2; ) f.push(this.parseStatementListItem());
              return this.finalize(g, new h.Script(f));
            }, Z.prototype.parseModuleSpecifier = function() {
              var g = this.createNode();
              this.lookahead.type !== 8 && this.throwError(d.Messages.InvalidModuleSpecifier);
              var f = this.nextToken(), T = this.getTokenRaw(f);
              return this.finalize(g, new h.Literal(f.value, T));
            }, Z.prototype.parseImportSpecifier = function() {
              var g, f, T = this.createNode();
              return this.lookahead.type === 3 ? (f = g = this.parseVariableIdentifier(), this.matchContextualKeyword("as") && (this.nextToken(), f = this.parseVariableIdentifier())) : (f = g = this.parseIdentifierName(), this.matchContextualKeyword("as") ? (this.nextToken(), f = this.parseVariableIdentifier()) : this.throwUnexpectedToken(this.nextToken())), this.finalize(T, new h.ImportSpecifier(f, g));
            }, Z.prototype.parseNamedImports = function() {
              this.expect("{");
              for (var g = []; !this.match("}"); ) g.push(this.parseImportSpecifier()), this.match("}") || this.expect(",");
              return this.expect("}"), g;
            }, Z.prototype.parseImportDefaultSpecifier = function() {
              var g = this.createNode(), f = this.parseIdentifierName();
              return this.finalize(g, new h.ImportDefaultSpecifier(f));
            }, Z.prototype.parseImportNamespaceSpecifier = function() {
              var g = this.createNode();
              this.expect("*"), this.matchContextualKeyword("as") || this.throwError(d.Messages.NoAsAfterImportNamespace), this.nextToken();
              var f = this.parseIdentifierName();
              return this.finalize(g, new h.ImportNamespaceSpecifier(f));
            }, Z.prototype.parseImportDeclaration = function() {
              this.context.inFunctionBody && this.throwError(d.Messages.IllegalImportDeclaration);
              var g, f = this.createNode();
              this.expectKeyword("import");
              var T = [];
              if (this.lookahead.type === 8) g = this.parseModuleSpecifier();
              else {
                if (this.match("{") ? T = T.concat(this.parseNamedImports()) : this.match("*") ? T.push(this.parseImportNamespaceSpecifier()) : this.isIdentifierName(this.lookahead) && !this.matchKeyword("default") ? (T.push(this.parseImportDefaultSpecifier()), this.match(",") && (this.nextToken(), this.match("*") ? T.push(this.parseImportNamespaceSpecifier()) : this.match("{") ? T = T.concat(this.parseNamedImports()) : this.throwUnexpectedToken(this.lookahead))) : this.throwUnexpectedToken(this.nextToken()), !this.matchContextualKeyword("from")) {
                  var M = this.lookahead.value ? d.Messages.UnexpectedToken : d.Messages.MissingFromClause;
                  this.throwError(M, this.lookahead.value);
                }
                this.nextToken(), g = this.parseModuleSpecifier();
              }
              return this.consumeSemicolon(), this.finalize(f, new h.ImportDeclaration(T, g));
            }, Z.prototype.parseExportSpecifier = function() {
              var g = this.createNode(), f = this.parseIdentifierName(), T = f;
              return this.matchContextualKeyword("as") && (this.nextToken(), T = this.parseIdentifierName()), this.finalize(g, new h.ExportSpecifier(f, T));
            }, Z.prototype.parseExportDeclaration = function() {
              this.context.inFunctionBody && this.throwError(d.Messages.IllegalExportDeclaration);
              var g, f = this.createNode();
              if (this.expectKeyword("export"), this.matchKeyword("default")) if (this.nextToken(), this.matchKeyword("function")) {
                var T = this.parseFunctionDeclaration(!0);
                g = this.finalize(f, new h.ExportDefaultDeclaration(T));
              } else this.matchKeyword("class") ? (T = this.parseClassDeclaration(!0), g = this.finalize(f, new h.ExportDefaultDeclaration(T))) : this.matchContextualKeyword("async") ? (T = this.matchAsyncFunction() ? this.parseFunctionDeclaration(!0) : this.parseAssignmentExpression(), g = this.finalize(f, new h.ExportDefaultDeclaration(T))) : (this.matchContextualKeyword("from") && this.throwError(d.Messages.UnexpectedToken, this.lookahead.value), T = this.match("{") ? this.parseObjectInitializer() : this.match("[") ? this.parseArrayInitializer() : this.parseAssignmentExpression(), this.consumeSemicolon(), g = this.finalize(f, new h.ExportDefaultDeclaration(T)));
              else if (this.match("*")) {
                if (this.nextToken(), !this.matchContextualKeyword("from")) {
                  var M = this.lookahead.value ? d.Messages.UnexpectedToken : d.Messages.MissingFromClause;
                  this.throwError(M, this.lookahead.value);
                }
                this.nextToken();
                var N = this.parseModuleSpecifier();
                this.consumeSemicolon(), g = this.finalize(f, new h.ExportAllDeclaration(N));
              } else if (this.lookahead.type === 4) {
                switch (T = void 0, this.lookahead.value) {
                  case "let":
                  case "const":
                    T = this.parseLexicalDeclaration({ inFor: !1 });
                    break;
                  case "var":
                  case "class":
                  case "function":
                    T = this.parseStatementListItem();
                    break;
                  default:
                    this.throwUnexpectedToken(this.lookahead);
                }
                g = this.finalize(f, new h.ExportNamedDeclaration(T, [], null));
              } else if (this.matchAsyncFunction()) T = this.parseFunctionDeclaration(), g = this.finalize(f, new h.ExportNamedDeclaration(T, [], null));
              else {
                var W = [], x = null, V = !1;
                for (this.expect("{"); !this.match("}"); ) V = V || this.matchKeyword("default"), W.push(this.parseExportSpecifier()), this.match("}") || this.expect(",");
                this.expect("}"), this.matchContextualKeyword("from") ? (this.nextToken(), x = this.parseModuleSpecifier(), this.consumeSemicolon()) : V ? (M = this.lookahead.value ? d.Messages.UnexpectedToken : d.Messages.MissingFromClause, this.throwError(M, this.lookahead.value)) : this.consumeSemicolon(), g = this.finalize(f, new h.ExportNamedDeclaration(null, W, x));
              }
              return g;
            }, Z;
          })();
          o.Parser = y;
        }, function(a, o) {
          Object.defineProperty(o, "__esModule", { value: !0 }), o.assert = function(l, c) {
            if (!l) throw new Error("ASSERT: " + c);
          };
        }, function(a, o) {
          Object.defineProperty(o, "__esModule", { value: !0 });
          var l = (function() {
            function c() {
              this.errors = [], this.tolerant = !1;
            }
            return c.prototype.recordError = function(u) {
              this.errors.push(u);
            }, c.prototype.tolerate = function(u) {
              if (!this.tolerant) throw u;
              this.recordError(u);
            }, c.prototype.constructError = function(u, d) {
              var h = new Error(u);
              try {
                throw h;
              } catch (p) {
                Object.create && Object.defineProperty && (h = Object.create(p), Object.defineProperty(h, "column", { value: d }));
              }
              return h;
            }, c.prototype.createError = function(u, d, h, p) {
              var m = "Line " + d + ": " + p, b = this.constructError(m, h);
              return b.index = u, b.lineNumber = d, b.description = p, b;
            }, c.prototype.throwError = function(u, d, h, p) {
              throw this.createError(u, d, h, p);
            }, c.prototype.tolerateError = function(u, d, h, p) {
              var m = this.createError(u, d, h, p);
              if (!this.tolerant) throw m;
              this.recordError(m);
            }, c;
          })();
          o.ErrorHandler = l;
        }, function(a, o) {
          Object.defineProperty(o, "__esModule", { value: !0 }), o.Messages = { BadGetterArity: "Getter must not have any formal parameters", BadSetterArity: "Setter must have exactly one formal parameter", BadSetterRestParameter: "Setter function argument must not be a rest parameter", ConstructorIsAsync: "Class constructor may not be an async method", ConstructorSpecialMethod: "Class constructor may not be an accessor", DeclarationMissingInitializer: "Missing initializer in %0 declaration", DefaultRestParameter: "Unexpected token =", DuplicateBinding: "Duplicate binding %0", DuplicateConstructor: "A class may only have one constructor", DuplicateProtoProperty: "Duplicate __proto__ fields are not allowed in object literals", ForInOfLoopInitializer: "%0 loop variable declaration may not have an initializer", GeneratorInLegacyContext: "Generator declarations are not allowed in legacy contexts", IllegalBreak: "Illegal break statement", IllegalContinue: "Illegal continue statement", IllegalExportDeclaration: "Unexpected token", IllegalImportDeclaration: "Unexpected token", IllegalLanguageModeDirective: "Illegal 'use strict' directive in function with non-simple parameter list", IllegalReturn: "Illegal return statement", InvalidEscapedReservedWord: "Keyword must not contain escaped characters", InvalidHexEscapeSequence: "Invalid hexadecimal escape sequence", InvalidLHSInAssignment: "Invalid left-hand side in assignment", InvalidLHSInForIn: "Invalid left-hand side in for-in", InvalidLHSInForLoop: "Invalid left-hand side in for-loop", InvalidModuleSpecifier: "Unexpected token", InvalidRegExp: "Invalid regular expression", LetInLexicalBinding: "let is disallowed as a lexically bound name", MissingFromClause: "Unexpected token", MultipleDefaultsInSwitch: "More than one default clause in switch statement", NewlineAfterThrow: "Illegal newline after throw", NoAsAfterImportNamespace: "Unexpected token", NoCatchOrFinally: "Missing catch or finally after try", ParameterAfterRestParameter: "Rest parameter must be last formal parameter", Redeclaration: "%0 '%1' has already been declared", StaticPrototype: "Classes may not have static property named prototype", StrictCatchVariable: "Catch variable may not be eval or arguments in strict mode", StrictDelete: "Delete of an unqualified identifier in strict mode.", StrictFunction: "In strict mode code, functions can only be declared at top level or inside a block", StrictFunctionName: "Function name may not be eval or arguments in strict mode", StrictLHSAssignment: "Assignment to eval or arguments is not allowed in strict mode", StrictLHSPostfix: "Postfix increment/decrement may not have eval or arguments operand in strict mode", StrictLHSPrefix: "Prefix increment/decrement may not have eval or arguments operand in strict mode", StrictModeWith: "Strict mode code may not include a with statement", StrictOctalLiteral: "Octal literals are not allowed in strict mode.", StrictParamDupe: "Strict mode function may not have duplicate parameter names", StrictParamName: "Parameter name eval or arguments is not allowed in strict mode", StrictReservedWord: "Use of future reserved word in strict mode", StrictVarName: "Variable name may not be eval or arguments in strict mode", TemplateOctalLiteral: "Octal literals are not allowed in template strings.", UnexpectedEOS: "Unexpected end of input", UnexpectedIdentifier: "Unexpected identifier", UnexpectedNumber: "Unexpected number", UnexpectedReserved: "Unexpected reserved word", UnexpectedString: "Unexpected string", UnexpectedTemplate: "Unexpected quasi %0", UnexpectedToken: "Unexpected token %0", UnexpectedTokenIllegal: "Unexpected token ILLEGAL", UnknownLabel: "Undefined label '%0'", UnterminatedRegExp: "Invalid regular expression: missing /" };
        }, function(a, o, l) {
          Object.defineProperty(o, "__esModule", { value: !0 });
          var c = l(9), u = l(4), d = l(11);
          function h(b) {
            return "0123456789abcdef".indexOf(b.toLowerCase());
          }
          function p(b) {
            return "01234567".indexOf(b);
          }
          var m = (function() {
            function b(y, Z) {
              this.source = y, this.errorHandler = Z, this.trackComment = !1, this.isModule = !1, this.length = y.length, this.index = 0, this.lineNumber = y.length > 0 ? 1 : 0, this.lineStart = 0, this.curlyStack = [];
            }
            return b.prototype.saveState = function() {
              return { index: this.index, lineNumber: this.lineNumber, lineStart: this.lineStart };
            }, b.prototype.restoreState = function(y) {
              this.index = y.index, this.lineNumber = y.lineNumber, this.lineStart = y.lineStart;
            }, b.prototype.eof = function() {
              return this.index >= this.length;
            }, b.prototype.throwUnexpectedToken = function(y) {
              return y === void 0 && (y = d.Messages.UnexpectedTokenIllegal), this.errorHandler.throwError(this.index, this.lineNumber, this.index - this.lineStart + 1, y);
            }, b.prototype.tolerateUnexpectedToken = function(y) {
              y === void 0 && (y = d.Messages.UnexpectedTokenIllegal), this.errorHandler.tolerateError(this.index, this.lineNumber, this.index - this.lineStart + 1, y);
            }, b.prototype.skipSingleLineComment = function(y) {
              var Z, g, f = [];
              for (this.trackComment && (f = [], Z = this.index - y, g = { start: { line: this.lineNumber, column: this.index - this.lineStart - y }, end: {} }); !this.eof(); ) {
                var T = this.source.charCodeAt(this.index);
                if (++this.index, u.Character.isLineTerminator(T)) {
                  if (this.trackComment) {
                    g.end = { line: this.lineNumber, column: this.index - this.lineStart - 1 };
                    var M = { multiLine: !1, slice: [Z + y, this.index - 1], range: [Z, this.index - 1], loc: g };
                    f.push(M);
                  }
                  return T === 13 && this.source.charCodeAt(this.index) === 10 && ++this.index, ++this.lineNumber, this.lineStart = this.index, f;
                }
              }
              return this.trackComment && (g.end = { line: this.lineNumber, column: this.index - this.lineStart }, M = { multiLine: !1, slice: [Z + y, this.index], range: [Z, this.index], loc: g }, f.push(M)), f;
            }, b.prototype.skipMultiLineComment = function() {
              var y, Z, g = [];
              for (this.trackComment && (g = [], y = this.index - 2, Z = { start: { line: this.lineNumber, column: this.index - this.lineStart - 2 }, end: {} }); !this.eof(); ) {
                var f = this.source.charCodeAt(this.index);
                if (u.Character.isLineTerminator(f)) f === 13 && this.source.charCodeAt(this.index + 1) === 10 && ++this.index, ++this.lineNumber, ++this.index, this.lineStart = this.index;
                else if (f === 42) {
                  if (this.source.charCodeAt(this.index + 1) === 47) {
                    if (this.index += 2, this.trackComment) {
                      Z.end = { line: this.lineNumber, column: this.index - this.lineStart };
                      var T = { multiLine: !0, slice: [y + 2, this.index - 2], range: [y, this.index], loc: Z };
                      g.push(T);
                    }
                    return g;
                  }
                  ++this.index;
                } else ++this.index;
              }
              return this.trackComment && (Z.end = { line: this.lineNumber, column: this.index - this.lineStart }, T = { multiLine: !0, slice: [y + 2, this.index], range: [y, this.index], loc: Z }, g.push(T)), this.tolerateUnexpectedToken(), g;
            }, b.prototype.scanComments = function() {
              var y;
              this.trackComment && (y = []);
              for (var Z = this.index === 0; !this.eof(); ) {
                var g = this.source.charCodeAt(this.index);
                if (u.Character.isWhiteSpace(g)) ++this.index;
                else if (u.Character.isLineTerminator(g)) ++this.index, g === 13 && this.source.charCodeAt(this.index) === 10 && ++this.index, ++this.lineNumber, this.lineStart = this.index, Z = !0;
                else if (g === 47) if ((g = this.source.charCodeAt(this.index + 1)) === 47) {
                  this.index += 2;
                  var f = this.skipSingleLineComment(2);
                  this.trackComment && (y = y.concat(f)), Z = !0;
                } else {
                  if (g !== 42) break;
                  this.index += 2, f = this.skipMultiLineComment(), this.trackComment && (y = y.concat(f));
                }
                else if (Z && g === 45) {
                  if (this.source.charCodeAt(this.index + 1) !== 45 || this.source.charCodeAt(this.index + 2) !== 62) break;
                  this.index += 3, f = this.skipSingleLineComment(3), this.trackComment && (y = y.concat(f));
                } else {
                  if (g !== 60 || this.isModule || this.source.slice(this.index + 1, this.index + 4) !== "!--") break;
                  this.index += 4, f = this.skipSingleLineComment(4), this.trackComment && (y = y.concat(f));
                }
              }
              return y;
            }, b.prototype.isFutureReservedWord = function(y) {
              switch (y) {
                case "enum":
                case "export":
                case "import":
                case "super":
                  return !0;
                default:
                  return !1;
              }
            }, b.prototype.isStrictModeReservedWord = function(y) {
              switch (y) {
                case "implements":
                case "interface":
                case "package":
                case "private":
                case "protected":
                case "public":
                case "static":
                case "yield":
                case "let":
                  return !0;
                default:
                  return !1;
              }
            }, b.prototype.isRestrictedWord = function(y) {
              return y === "eval" || y === "arguments";
            }, b.prototype.isKeyword = function(y) {
              switch (y.length) {
                case 2:
                  return y === "if" || y === "in" || y === "do";
                case 3:
                  return y === "var" || y === "for" || y === "new" || y === "try" || y === "let";
                case 4:
                  return y === "this" || y === "else" || y === "case" || y === "void" || y === "with" || y === "enum";
                case 5:
                  return y === "while" || y === "break" || y === "catch" || y === "throw" || y === "const" || y === "yield" || y === "class" || y === "super";
                case 6:
                  return y === "return" || y === "typeof" || y === "delete" || y === "switch" || y === "export" || y === "import";
                case 7:
                  return y === "default" || y === "finally" || y === "extends";
                case 8:
                  return y === "function" || y === "continue" || y === "debugger";
                case 10:
                  return y === "instanceof";
                default:
                  return !1;
              }
            }, b.prototype.codePointAt = function(y) {
              var Z = this.source.charCodeAt(y);
              if (Z >= 55296 && Z <= 56319) {
                var g = this.source.charCodeAt(y + 1);
                g >= 56320 && g <= 57343 && (Z = 1024 * (Z - 55296) + g - 56320 + 65536);
              }
              return Z;
            }, b.prototype.scanHexEscape = function(y) {
              for (var Z = y === "u" ? 4 : 2, g = 0, f = 0; f < Z; ++f) {
                if (this.eof() || !u.Character.isHexDigit(this.source.charCodeAt(this.index))) return null;
                g = 16 * g + h(this.source[this.index++]);
              }
              return String.fromCharCode(g);
            }, b.prototype.scanUnicodeCodePointEscape = function() {
              var y = this.source[this.index], Z = 0;
              for (y === "}" && this.throwUnexpectedToken(); !this.eof() && (y = this.source[this.index++], u.Character.isHexDigit(y.charCodeAt(0))); ) Z = 16 * Z + h(y);
              return (Z > 1114111 || y !== "}") && this.throwUnexpectedToken(), u.Character.fromCodePoint(Z);
            }, b.prototype.getIdentifier = function() {
              for (var y = this.index++; !this.eof(); ) {
                var Z = this.source.charCodeAt(this.index);
                if (Z === 92) return this.index = y, this.getComplexIdentifier();
                if (Z >= 55296 && Z < 57343) return this.index = y, this.getComplexIdentifier();
                if (!u.Character.isIdentifierPart(Z)) break;
                ++this.index;
              }
              return this.source.slice(y, this.index);
            }, b.prototype.getComplexIdentifier = function() {
              var y, Z = this.codePointAt(this.index), g = u.Character.fromCodePoint(Z);
              for (this.index += g.length, Z === 92 && (this.source.charCodeAt(this.index) !== 117 && this.throwUnexpectedToken(), ++this.index, this.source[this.index] === "{" ? (++this.index, y = this.scanUnicodeCodePointEscape()) : (y = this.scanHexEscape("u")) !== null && y !== "\\" && u.Character.isIdentifierStart(y.charCodeAt(0)) || this.throwUnexpectedToken(), g = y); !this.eof() && (Z = this.codePointAt(this.index), u.Character.isIdentifierPart(Z)); ) g += y = u.Character.fromCodePoint(Z), this.index += y.length, Z === 92 && (g = g.substr(0, g.length - 1), this.source.charCodeAt(this.index) !== 117 && this.throwUnexpectedToken(), ++this.index, this.source[this.index] === "{" ? (++this.index, y = this.scanUnicodeCodePointEscape()) : (y = this.scanHexEscape("u")) !== null && y !== "\\" && u.Character.isIdentifierPart(y.charCodeAt(0)) || this.throwUnexpectedToken(), g += y);
              return g;
            }, b.prototype.octalToDecimal = function(y) {
              var Z = y !== "0", g = p(y);
              return !this.eof() && u.Character.isOctalDigit(this.source.charCodeAt(this.index)) && (Z = !0, g = 8 * g + p(this.source[this.index++]), "0123".indexOf(y) >= 0 && !this.eof() && u.Character.isOctalDigit(this.source.charCodeAt(this.index)) && (g = 8 * g + p(this.source[this.index++]))), { code: g, octal: Z };
            }, b.prototype.scanIdentifier = function() {
              var y, Z = this.index, g = this.source.charCodeAt(Z) === 92 ? this.getComplexIdentifier() : this.getIdentifier();
              if ((y = g.length === 1 ? 3 : this.isKeyword(g) ? 4 : g === "null" ? 5 : g === "true" || g === "false" ? 1 : 3) != 3 && Z + g.length !== this.index) {
                var f = this.index;
                this.index = Z, this.tolerateUnexpectedToken(d.Messages.InvalidEscapedReservedWord), this.index = f;
              }
              return { type: y, value: g, lineNumber: this.lineNumber, lineStart: this.lineStart, start: Z, end: this.index };
            }, b.prototype.scanPunctuator = function() {
              var y = this.index, Z = this.source[this.index];
              switch (Z) {
                case "(":
                case "{":
                  Z === "{" && this.curlyStack.push("{"), ++this.index;
                  break;
                case ".":
                  ++this.index, this.source[this.index] === "." && this.source[this.index + 1] === "." && (this.index += 2, Z = "...");
                  break;
                case "}":
                  ++this.index, this.curlyStack.pop();
                  break;
                case ")":
                case ";":
                case ",":
                case "[":
                case "]":
                case ":":
                case "?":
                case "~":
                  ++this.index;
                  break;
                default:
                  (Z = this.source.substr(this.index, 4)) === ">>>=" ? this.index += 4 : (Z = Z.substr(0, 3)) === "===" || Z === "!==" || Z === ">>>" || Z === "<<=" || Z === ">>=" || Z === "**=" ? this.index += 3 : (Z = Z.substr(0, 2)) === "&&" || Z === "||" || Z === "==" || Z === "!=" || Z === "+=" || Z === "-=" || Z === "*=" || Z === "/=" || Z === "++" || Z === "--" || Z === "<<" || Z === ">>" || Z === "&=" || Z === "|=" || Z === "^=" || Z === "%=" || Z === "<=" || Z === ">=" || Z === "=>" || Z === "**" ? this.index += 2 : (Z = this.source[this.index], "<>=!+-*%&|^/".indexOf(Z) >= 0 && ++this.index);
              }
              return this.index === y && this.throwUnexpectedToken(), { type: 7, value: Z, lineNumber: this.lineNumber, lineStart: this.lineStart, start: y, end: this.index };
            }, b.prototype.scanHexLiteral = function(y) {
              for (var Z = ""; !this.eof() && u.Character.isHexDigit(this.source.charCodeAt(this.index)); ) Z += this.source[this.index++];
              return Z.length === 0 && this.throwUnexpectedToken(), u.Character.isIdentifierStart(this.source.charCodeAt(this.index)) && this.throwUnexpectedToken(), { type: 6, value: parseInt("0x" + Z, 16), lineNumber: this.lineNumber, lineStart: this.lineStart, start: y, end: this.index };
            }, b.prototype.scanBinaryLiteral = function(y) {
              for (var Z, g = ""; !this.eof() && ((Z = this.source[this.index]) === "0" || Z === "1"); ) g += this.source[this.index++];
              return g.length === 0 && this.throwUnexpectedToken(), this.eof() || (Z = this.source.charCodeAt(this.index), (u.Character.isIdentifierStart(Z) || u.Character.isDecimalDigit(Z)) && this.throwUnexpectedToken()), { type: 6, value: parseInt(g, 2), lineNumber: this.lineNumber, lineStart: this.lineStart, start: y, end: this.index };
            }, b.prototype.scanOctalLiteral = function(y, Z) {
              var g = "", f = !1;
              for (u.Character.isOctalDigit(y.charCodeAt(0)) ? (f = !0, g = "0" + this.source[this.index++]) : ++this.index; !this.eof() && u.Character.isOctalDigit(this.source.charCodeAt(this.index)); ) g += this.source[this.index++];
              return f || g.length !== 0 || this.throwUnexpectedToken(), (u.Character.isIdentifierStart(this.source.charCodeAt(this.index)) || u.Character.isDecimalDigit(this.source.charCodeAt(this.index))) && this.throwUnexpectedToken(), { type: 6, value: parseInt(g, 8), octal: f, lineNumber: this.lineNumber, lineStart: this.lineStart, start: Z, end: this.index };
            }, b.prototype.isImplicitOctalLiteral = function() {
              for (var y = this.index + 1; y < this.length; ++y) {
                var Z = this.source[y];
                if (Z === "8" || Z === "9") return !1;
                if (!u.Character.isOctalDigit(Z.charCodeAt(0))) return !0;
              }
              return !0;
            }, b.prototype.scanNumericLiteral = function() {
              var y = this.index, Z = this.source[y];
              c.assert(u.Character.isDecimalDigit(Z.charCodeAt(0)) || Z === ".", "Numeric literal must start with a decimal digit or a decimal point");
              var g = "";
              if (Z !== ".") {
                if (g = this.source[this.index++], Z = this.source[this.index], g === "0") {
                  if (Z === "x" || Z === "X") return ++this.index, this.scanHexLiteral(y);
                  if (Z === "b" || Z === "B") return ++this.index, this.scanBinaryLiteral(y);
                  if (Z === "o" || Z === "O") return this.scanOctalLiteral(Z, y);
                  if (Z && u.Character.isOctalDigit(Z.charCodeAt(0)) && this.isImplicitOctalLiteral()) return this.scanOctalLiteral(Z, y);
                }
                for (; u.Character.isDecimalDigit(this.source.charCodeAt(this.index)); ) g += this.source[this.index++];
                Z = this.source[this.index];
              }
              if (Z === ".") {
                for (g += this.source[this.index++]; u.Character.isDecimalDigit(this.source.charCodeAt(this.index)); ) g += this.source[this.index++];
                Z = this.source[this.index];
              }
              if (Z === "e" || Z === "E") if (g += this.source[this.index++], (Z = this.source[this.index]) !== "+" && Z !== "-" || (g += this.source[this.index++]), u.Character.isDecimalDigit(this.source.charCodeAt(this.index))) for (; u.Character.isDecimalDigit(this.source.charCodeAt(this.index)); ) g += this.source[this.index++];
              else this.throwUnexpectedToken();
              return u.Character.isIdentifierStart(this.source.charCodeAt(this.index)) && this.throwUnexpectedToken(), { type: 6, value: parseFloat(g), lineNumber: this.lineNumber, lineStart: this.lineStart, start: y, end: this.index };
            }, b.prototype.scanStringLiteral = function() {
              var y = this.index, Z = this.source[y];
              c.assert(Z === "'" || Z === '"', "String literal must starts with a quote"), ++this.index;
              for (var g = !1, f = ""; !this.eof(); ) {
                var T = this.source[this.index++];
                if (T === Z) {
                  Z = "";
                  break;
                }
                if (T === "\\") if ((T = this.source[this.index++]) && u.Character.isLineTerminator(T.charCodeAt(0))) ++this.lineNumber, T === "\r" && this.source[this.index] === `
` && ++this.index, this.lineStart = this.index;
                else switch (T) {
                  case "u":
                    if (this.source[this.index] === "{") ++this.index, f += this.scanUnicodeCodePointEscape();
                    else {
                      var M = this.scanHexEscape(T);
                      M === null && this.throwUnexpectedToken(), f += M;
                    }
                    break;
                  case "x":
                    var N = this.scanHexEscape(T);
                    N === null && this.throwUnexpectedToken(d.Messages.InvalidHexEscapeSequence), f += N;
                    break;
                  case "n":
                    f += `
`;
                    break;
                  case "r":
                    f += "\r";
                    break;
                  case "t":
                    f += "	";
                    break;
                  case "b":
                    f += "\b";
                    break;
                  case "f":
                    f += "\f";
                    break;
                  case "v":
                    f += "\v";
                    break;
                  case "8":
                  case "9":
                    f += T, this.tolerateUnexpectedToken();
                    break;
                  default:
                    if (T && u.Character.isOctalDigit(T.charCodeAt(0))) {
                      var W = this.octalToDecimal(T);
                      g = W.octal || g, f += String.fromCharCode(W.code);
                    } else f += T;
                }
                else {
                  if (u.Character.isLineTerminator(T.charCodeAt(0))) break;
                  f += T;
                }
              }
              return Z !== "" && (this.index = y, this.throwUnexpectedToken()), { type: 8, value: f, octal: g, lineNumber: this.lineNumber, lineStart: this.lineStart, start: y, end: this.index };
            }, b.prototype.scanTemplate = function() {
              var y = "", Z = !1, g = this.index, f = this.source[g] === "`", T = !1, M = 2;
              for (++this.index; !this.eof(); ) {
                var N = this.source[this.index++];
                if (N === "`") {
                  M = 1, T = !0, Z = !0;
                  break;
                }
                if (N === "$") {
                  if (this.source[this.index] === "{") {
                    this.curlyStack.push("${"), ++this.index, Z = !0;
                    break;
                  }
                  y += N;
                } else if (N === "\\") if (N = this.source[this.index++], u.Character.isLineTerminator(N.charCodeAt(0))) ++this.lineNumber, N === "\r" && this.source[this.index] === `
` && ++this.index, this.lineStart = this.index;
                else switch (N) {
                  case "n":
                    y += `
`;
                    break;
                  case "r":
                    y += "\r";
                    break;
                  case "t":
                    y += "	";
                    break;
                  case "u":
                    if (this.source[this.index] === "{") ++this.index, y += this.scanUnicodeCodePointEscape();
                    else {
                      var W = this.index, x = this.scanHexEscape(N);
                      x !== null ? y += x : (this.index = W, y += N);
                    }
                    break;
                  case "x":
                    var V = this.scanHexEscape(N);
                    V === null && this.throwUnexpectedToken(d.Messages.InvalidHexEscapeSequence), y += V;
                    break;
                  case "b":
                    y += "\b";
                    break;
                  case "f":
                    y += "\f";
                    break;
                  case "v":
                    y += "\v";
                    break;
                  default:
                    N === "0" ? (u.Character.isDecimalDigit(this.source.charCodeAt(this.index)) && this.throwUnexpectedToken(d.Messages.TemplateOctalLiteral), y += "\0") : u.Character.isOctalDigit(N.charCodeAt(0)) ? this.throwUnexpectedToken(d.Messages.TemplateOctalLiteral) : y += N;
                }
                else u.Character.isLineTerminator(N.charCodeAt(0)) ? (++this.lineNumber, N === "\r" && this.source[this.index] === `
` && ++this.index, this.lineStart = this.index, y += `
`) : y += N;
              }
              return Z || this.throwUnexpectedToken(), f || this.curlyStack.pop(), { type: 10, value: this.source.slice(g + 1, this.index - M), cooked: y, head: f, tail: T, lineNumber: this.lineNumber, lineStart: this.lineStart, start: g, end: this.index };
            }, b.prototype.testRegExp = function(y, Z) {
              var g = y, f = this;
              Z.indexOf("u") >= 0 && (g = g.replace(/\\u\{([0-9a-fA-F]+)\}|\\u([a-fA-F0-9]{4})/g, (function(T, M, N) {
                var W = parseInt(M || N, 16);
                return W > 1114111 && f.throwUnexpectedToken(d.Messages.InvalidRegExp), W <= 65535 ? String.fromCharCode(W) : "￿";
              })).replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, "￿"));
              try {
                RegExp(g);
              } catch {
                this.throwUnexpectedToken(d.Messages.InvalidRegExp);
              }
              try {
                return new RegExp(y, Z);
              } catch {
                return null;
              }
            }, b.prototype.scanRegExpBody = function() {
              var y = this.source[this.index];
              c.assert(y === "/", "Regular expression literal must start with a slash");
              for (var Z = this.source[this.index++], g = !1, f = !1; !this.eof(); ) if (Z += y = this.source[this.index++], y === "\\") y = this.source[this.index++], u.Character.isLineTerminator(y.charCodeAt(0)) && this.throwUnexpectedToken(d.Messages.UnterminatedRegExp), Z += y;
              else if (u.Character.isLineTerminator(y.charCodeAt(0))) this.throwUnexpectedToken(d.Messages.UnterminatedRegExp);
              else if (g) y === "]" && (g = !1);
              else {
                if (y === "/") {
                  f = !0;
                  break;
                }
                y === "[" && (g = !0);
              }
              return f || this.throwUnexpectedToken(d.Messages.UnterminatedRegExp), Z.substr(1, Z.length - 2);
            }, b.prototype.scanRegExpFlags = function() {
              for (var y = ""; !this.eof(); ) {
                var Z = this.source[this.index];
                if (!u.Character.isIdentifierPart(Z.charCodeAt(0))) break;
                if (++this.index, Z !== "\\" || this.eof()) y += Z;
                else if ((Z = this.source[this.index]) === "u") {
                  ++this.index;
                  var g = this.index, f = this.scanHexEscape("u");
                  if (f !== null) for (y += f; g < this.index; ++g) this.source[g];
                  else this.index = g, y += "u";
                  this.tolerateUnexpectedToken();
                } else this.tolerateUnexpectedToken();
              }
              return y;
            }, b.prototype.scanRegExp = function() {
              var y = this.index, Z = this.scanRegExpBody(), g = this.scanRegExpFlags();
              return { type: 9, value: "", pattern: Z, flags: g, regex: this.testRegExp(Z, g), lineNumber: this.lineNumber, lineStart: this.lineStart, start: y, end: this.index };
            }, b.prototype.lex = function() {
              if (this.eof()) return { type: 2, value: "", lineNumber: this.lineNumber, lineStart: this.lineStart, start: this.index, end: this.index };
              var y = this.source.charCodeAt(this.index);
              return u.Character.isIdentifierStart(y) ? this.scanIdentifier() : y === 40 || y === 41 || y === 59 ? this.scanPunctuator() : y === 39 || y === 34 ? this.scanStringLiteral() : y === 46 ? u.Character.isDecimalDigit(this.source.charCodeAt(this.index + 1)) ? this.scanNumericLiteral() : this.scanPunctuator() : u.Character.isDecimalDigit(y) ? this.scanNumericLiteral() : y === 96 || y === 125 && this.curlyStack[this.curlyStack.length - 1] === "${" ? this.scanTemplate() : y >= 55296 && y < 57343 && u.Character.isIdentifierStart(this.codePointAt(this.index)) ? this.scanIdentifier() : this.scanPunctuator();
            }, b;
          })();
          o.Scanner = m;
        }, function(a, o) {
          Object.defineProperty(o, "__esModule", { value: !0 }), o.TokenName = {}, o.TokenName[1] = "Boolean", o.TokenName[2] = "<end>", o.TokenName[3] = "Identifier", o.TokenName[4] = "Keyword", o.TokenName[5] = "Null", o.TokenName[6] = "Numeric", o.TokenName[7] = "Punctuator", o.TokenName[8] = "String", o.TokenName[9] = "RegularExpression", o.TokenName[10] = "Template";
        }, function(a, o) {
          Object.defineProperty(o, "__esModule", { value: !0 }), o.XHTMLEntities = { quot: '"', amp: "&", apos: "'", gt: ">", nbsp: " ", iexcl: "¡", cent: "¢", pound: "£", curren: "¤", yen: "¥", brvbar: "¦", sect: "§", uml: "¨", copy: "©", ordf: "ª", laquo: "«", not: "¬", shy: "­", reg: "®", macr: "¯", deg: "°", plusmn: "±", sup2: "²", sup3: "³", acute: "´", micro: "µ", para: "¶", middot: "·", cedil: "¸", sup1: "¹", ordm: "º", raquo: "»", frac14: "¼", frac12: "½", frac34: "¾", iquest: "¿", Agrave: "À", Aacute: "Á", Acirc: "Â", Atilde: "Ã", Auml: "Ä", Aring: "Å", AElig: "Æ", Ccedil: "Ç", Egrave: "È", Eacute: "É", Ecirc: "Ê", Euml: "Ë", Igrave: "Ì", Iacute: "Í", Icirc: "Î", Iuml: "Ï", ETH: "Ð", Ntilde: "Ñ", Ograve: "Ò", Oacute: "Ó", Ocirc: "Ô", Otilde: "Õ", Ouml: "Ö", times: "×", Oslash: "Ø", Ugrave: "Ù", Uacute: "Ú", Ucirc: "Û", Uuml: "Ü", Yacute: "Ý", THORN: "Þ", szlig: "ß", agrave: "à", aacute: "á", acirc: "â", atilde: "ã", auml: "ä", aring: "å", aelig: "æ", ccedil: "ç", egrave: "è", eacute: "é", ecirc: "ê", euml: "ë", igrave: "ì", iacute: "í", icirc: "î", iuml: "ï", eth: "ð", ntilde: "ñ", ograve: "ò", oacute: "ó", ocirc: "ô", otilde: "õ", ouml: "ö", divide: "÷", oslash: "ø", ugrave: "ù", uacute: "ú", ucirc: "û", uuml: "ü", yacute: "ý", thorn: "þ", yuml: "ÿ", OElig: "Œ", oelig: "œ", Scaron: "Š", scaron: "š", Yuml: "Ÿ", fnof: "ƒ", circ: "ˆ", tilde: "˜", Alpha: "Α", Beta: "Β", Gamma: "Γ", Delta: "Δ", Epsilon: "Ε", Zeta: "Ζ", Eta: "Η", Theta: "Θ", Iota: "Ι", Kappa: "Κ", Lambda: "Λ", Mu: "Μ", Nu: "Ν", Xi: "Ξ", Omicron: "Ο", Pi: "Π", Rho: "Ρ", Sigma: "Σ", Tau: "Τ", Upsilon: "Υ", Phi: "Φ", Chi: "Χ", Psi: "Ψ", Omega: "Ω", alpha: "α", beta: "β", gamma: "γ", delta: "δ", epsilon: "ε", zeta: "ζ", eta: "η", theta: "θ", iota: "ι", kappa: "κ", lambda: "λ", mu: "μ", nu: "ν", xi: "ξ", omicron: "ο", pi: "π", rho: "ρ", sigmaf: "ς", sigma: "σ", tau: "τ", upsilon: "υ", phi: "φ", chi: "χ", psi: "ψ", omega: "ω", thetasym: "ϑ", upsih: "ϒ", piv: "ϖ", ensp: " ", emsp: " ", thinsp: " ", zwnj: "‌", zwj: "‍", lrm: "‎", rlm: "‏", ndash: "–", mdash: "—", lsquo: "‘", rsquo: "’", sbquo: "‚", ldquo: "“", rdquo: "”", bdquo: "„", dagger: "†", Dagger: "‡", bull: "•", hellip: "…", permil: "‰", prime: "′", Prime: "″", lsaquo: "‹", rsaquo: "›", oline: "‾", frasl: "⁄", euro: "€", image: "ℑ", weierp: "℘", real: "ℜ", trade: "™", alefsym: "ℵ", larr: "←", uarr: "↑", rarr: "→", darr: "↓", harr: "↔", crarr: "↵", lArr: "⇐", uArr: "⇑", rArr: "⇒", dArr: "⇓", hArr: "⇔", forall: "∀", part: "∂", exist: "∃", empty: "∅", nabla: "∇", isin: "∈", notin: "∉", ni: "∋", prod: "∏", sum: "∑", minus: "−", lowast: "∗", radic: "√", prop: "∝", infin: "∞", ang: "∠", and: "∧", or: "∨", cap: "∩", cup: "∪", int: "∫", there4: "∴", sim: "∼", cong: "≅", asymp: "≈", ne: "≠", equiv: "≡", le: "≤", ge: "≥", sub: "⊂", sup: "⊃", nsub: "⊄", sube: "⊆", supe: "⊇", oplus: "⊕", otimes: "⊗", perp: "⊥", sdot: "⋅", lceil: "⌈", rceil: "⌉", lfloor: "⌊", rfloor: "⌋", loz: "◊", spades: "♠", clubs: "♣", hearts: "♥", diams: "♦", lang: "⟨", rang: "⟩" };
        }, function(a, o, l) {
          Object.defineProperty(o, "__esModule", { value: !0 });
          var c = l(10), u = l(12), d = l(13), h = (function() {
            function m() {
              this.values = [], this.curly = this.paren = -1;
            }
            return m.prototype.beforeFunctionExpression = function(b) {
              return ["(", "{", "[", "in", "typeof", "instanceof", "new", "return", "case", "delete", "throw", "void", "=", "+=", "-=", "*=", "**=", "/=", "%=", "<<=", ">>=", ">>>=", "&=", "|=", "^=", ",", "+", "-", "*", "**", "/", "%", "++", "--", "<<", ">>", ">>>", "&", "|", "^", "!", "~", "&&", "||", "?", ":", "===", "==", ">=", "<=", "<", ">", "!=", "!=="].indexOf(b) >= 0;
            }, m.prototype.isRegexStart = function() {
              var b = this.values[this.values.length - 1], y = b !== null;
              switch (b) {
                case "this":
                case "]":
                  y = !1;
                  break;
                case ")":
                  var Z = this.values[this.paren - 1];
                  y = Z === "if" || Z === "while" || Z === "for" || Z === "with";
                  break;
                case "}":
                  if (y = !1, this.values[this.curly - 3] === "function") y = !!(g = this.values[this.curly - 4]) && !this.beforeFunctionExpression(g);
                  else if (this.values[this.curly - 4] === "function") {
                    var g;
                    y = !(g = this.values[this.curly - 5]) || !this.beforeFunctionExpression(g);
                  }
              }
              return y;
            }, m.prototype.push = function(b) {
              b.type === 7 || b.type === 4 ? (b.value === "{" ? this.curly = this.values.length : b.value === "(" && (this.paren = this.values.length), this.values.push(b.value)) : this.values.push(null);
            }, m;
          })(), p = (function() {
            function m(b, y) {
              this.errorHandler = new c.ErrorHandler(), this.errorHandler.tolerant = !!y && typeof y.tolerant == "boolean" && y.tolerant, this.scanner = new u.Scanner(b, this.errorHandler), this.scanner.trackComment = !!y && typeof y.comment == "boolean" && y.comment, this.trackRange = !!y && typeof y.range == "boolean" && y.range, this.trackLoc = !!y && typeof y.loc == "boolean" && y.loc, this.buffer = [], this.reader = new h();
            }
            return m.prototype.errors = function() {
              return this.errorHandler.errors;
            }, m.prototype.getNextToken = function() {
              if (this.buffer.length === 0) {
                var b = this.scanner.scanComments();
                if (this.scanner.trackComment) for (var y = 0; y < b.length; ++y) {
                  var Z = b[y], g = this.scanner.source.slice(Z.slice[0], Z.slice[1]), f = { type: Z.multiLine ? "BlockComment" : "LineComment", value: g };
                  this.trackRange && (f.range = Z.range), this.trackLoc && (f.loc = Z.loc), this.buffer.push(f);
                }
                if (!this.scanner.eof()) {
                  var T = void 0;
                  this.trackLoc && (T = { start: { line: this.scanner.lineNumber, column: this.scanner.index - this.scanner.lineStart }, end: {} });
                  var M = this.scanner.source[this.scanner.index] === "/" && this.reader.isRegexStart() ? this.scanner.scanRegExp() : this.scanner.lex();
                  this.reader.push(M);
                  var N = { type: d.TokenName[M.type], value: this.scanner.source.slice(M.start, M.end) };
                  if (this.trackRange && (N.range = [M.start, M.end]), this.trackLoc && (T.end = { line: this.scanner.lineNumber, column: this.scanner.index - this.scanner.lineStart }, N.loc = T), M.type === 9) {
                    var W = M.pattern, x = M.flags;
                    N.regex = { pattern: W, flags: x };
                  }
                  this.buffer.push(N);
                }
              }
              return this.buffer.shift();
            }, m;
          })();
          o.Tokenizer = p;
        }]);
      }, e.exports = r();
    }, function(e, n, s) {
      var r = s(38), a = s(53), o = s(76), l = s(54), c = Object.prototype.toString, u = Object.prototype.hasOwnProperty, d = { 0: "\\0", 7: "\\a", 8: "\\b", 9: "\\t", 10: "\\n", 11: "\\v", 12: "\\f", 13: "\\r", 27: "\\e", 34: '\\"', 92: "\\\\", 133: "\\N", 160: "\\_", 8232: "\\L", 8233: "\\P" }, h = ["y", "Y", "yes", "Yes", "YES", "on", "On", "ON", "n", "N", "no", "No", "NO", "off", "Off", "OFF"];
      function p(F) {
        var P, j, H;
        if (P = F.toString(16).toUpperCase(), F <= 255) j = "x", H = 2;
        else if (F <= 65535) j = "u", H = 4;
        else {
          if (!(F <= 4294967295)) throw new a("code point within a string may not be greater than 0xFFFFFFFF");
          j = "U", H = 8;
        }
        return "\\" + j + r.repeat("0", H - P.length) + P;
      }
      function m(F) {
        this.schema = F.schema || o, this.indent = Math.max(1, F.indent || 2), this.noArrayIndent = F.noArrayIndent || !1, this.skipInvalid = F.skipInvalid || !1, this.flowLevel = r.isNothing(F.flowLevel) ? -1 : F.flowLevel, this.styleMap = (function(P, j) {
          var H, B, $, A, E, ct, at;
          if (j === null) return {};
          for (H = {}, $ = 0, A = (B = Object.keys(j)).length; $ < A; $ += 1) E = B[$], ct = String(j[E]), E.slice(0, 2) === "!!" && (E = "tag:yaml.org,2002:" + E.slice(2)), (at = P.compiledTypeMap.fallback[E]) && u.call(at.styleAliases, ct) && (ct = at.styleAliases[ct]), H[E] = ct;
          return H;
        })(this.schema, F.styles || null), this.sortKeys = F.sortKeys || !1, this.lineWidth = F.lineWidth || 80, this.noRefs = F.noRefs || !1, this.noCompatMode = F.noCompatMode || !1, this.condenseFlow = F.condenseFlow || !1, this.implicitTypes = this.schema.compiledImplicit, this.explicitTypes = this.schema.compiledExplicit, this.tag = null, this.result = "", this.duplicates = [], this.usedDuplicates = null;
      }
      function b(F, P) {
        for (var j, H = r.repeat(" ", P), B = 0, $ = -1, A = "", E = F.length; B < E; ) ($ = F.indexOf(`
`, B)) === -1 ? (j = F.slice(B), B = E) : (j = F.slice(B, $ + 1), B = $ + 1), j.length && j !== `
` && (A += H), A += j;
        return A;
      }
      function y(F, P) {
        return `
` + r.repeat(" ", F.indent * P);
      }
      function Z(F) {
        return F === 32 || F === 9;
      }
      function g(F) {
        return 32 <= F && F <= 126 || 161 <= F && F <= 55295 && F !== 8232 && F !== 8233 || 57344 <= F && F <= 65533 && F !== 65279 || 65536 <= F && F <= 1114111;
      }
      function f(F, P) {
        return g(F) && F !== 65279 && F !== 44 && F !== 91 && F !== 93 && F !== 123 && F !== 125 && F !== 58 && (F !== 35 || P && (function(j) {
          return g(j) && !Z(j) && j !== 65279 && j !== 13 && j !== 10;
        })(P));
      }
      function T(F) {
        return /^\n* /.test(F);
      }
      function M(F, P, j, H, B) {
        var $, A, E, ct, at = !1, dt = !1, gt = H !== -1, Wt = -1, Zt = g(ct = F.charCodeAt(0)) && ct !== 65279 && !Z(ct) && ct !== 45 && ct !== 63 && ct !== 58 && ct !== 44 && ct !== 91 && ct !== 93 && ct !== 123 && ct !== 125 && ct !== 35 && ct !== 38 && ct !== 42 && ct !== 33 && ct !== 124 && ct !== 61 && ct !== 62 && ct !== 39 && ct !== 34 && ct !== 37 && ct !== 64 && ct !== 96 && !Z(F.charCodeAt(F.length - 1));
        if (P) for ($ = 0; $ < F.length; $++) {
          if (!g(A = F.charCodeAt($))) return 5;
          E = $ > 0 ? F.charCodeAt($ - 1) : null, Zt = Zt && f(A, E);
        }
        else {
          for ($ = 0; $ < F.length; $++) {
            if ((A = F.charCodeAt($)) === 10) at = !0, gt && (dt = dt || $ - Wt - 1 > H && F[Wt + 1] !== " ", Wt = $);
            else if (!g(A)) return 5;
            E = $ > 0 ? F.charCodeAt($ - 1) : null, Zt = Zt && f(A, E);
          }
          dt = dt || gt && $ - Wt - 1 > H && F[Wt + 1] !== " ";
        }
        return at || dt ? j > 9 && T(F) ? 5 : dt ? 4 : 3 : Zt && !B(F) ? 1 : 2;
      }
      function N(F, P, j, H) {
        F.dump = (function() {
          if (P.length === 0) return "''";
          if (!F.noCompatMode && h.indexOf(P) !== -1) return "'" + P + "'";
          var B = F.indent * Math.max(1, j), $ = F.lineWidth === -1 ? -1 : Math.max(Math.min(F.lineWidth, 40), F.lineWidth - B), A = H || F.flowLevel > -1 && j >= F.flowLevel;
          switch (M(P, A, F.indent, $, (function(E) {
            return (function(ct, at) {
              var dt, gt;
              for (dt = 0, gt = ct.implicitTypes.length; dt < gt; dt += 1) if (ct.implicitTypes[dt].resolve(at)) return !0;
              return !1;
            })(F, E);
          }))) {
            case 1:
              return P;
            case 2:
              return "'" + P.replace(/'/g, "''") + "'";
            case 3:
              return "|" + W(P, F.indent) + x(b(P, B));
            case 4:
              return ">" + W(P, F.indent) + x(b((function(E, ct) {
                for (var at, dt, gt = /(\n+)([^\n]*)/g, Wt = (Gt = E.indexOf(`
`), Gt = Gt !== -1 ? Gt : E.length, gt.lastIndex = Gt, V(E.slice(0, Gt), ct)), Zt = E[0] === `
` || E[0] === " ", Gt; dt = gt.exec(E); ) {
                  var Tt = dt[1], Q = dt[2];
                  at = Q[0] === " ", Wt += Tt + (Zt || at || Q === "" ? "" : `
`) + V(Q, ct), Zt = at;
                }
                return Wt;
              })(P, $), B));
            case 5:
              return '"' + (function(E) {
                for (var ct, at, dt, gt = "", Wt = 0; Wt < E.length; Wt++) (ct = E.charCodeAt(Wt)) >= 55296 && ct <= 56319 && (at = E.charCodeAt(Wt + 1)) >= 56320 && at <= 57343 ? (gt += p(1024 * (ct - 55296) + at - 56320 + 65536), Wt++) : (dt = d[ct], gt += !dt && g(ct) ? E[Wt] : dt || p(ct));
                return gt;
              })(P) + '"';
            default:
              throw new a("impossible error: invalid scalar style");
          }
        })();
      }
      function W(F, P) {
        var j = T(F) ? String(P) : "", H = F[F.length - 1] === `
`;
        return j + (H && (F[F.length - 2] === `
` || F === `
`) ? "+" : H ? "" : "-") + `
`;
      }
      function x(F) {
        return F[F.length - 1] === `
` ? F.slice(0, -1) : F;
      }
      function V(F, P) {
        if (F === "" || F[0] === " ") return F;
        for (var j, H, B = / [^ ]/g, $ = 0, A = 0, E = 0, ct = ""; j = B.exec(F); ) (E = j.index) - $ > P && (H = A > $ ? A : E, ct += `
` + F.slice($, H), $ = H + 1), A = E;
        return ct += `
`, F.length - $ > P && A > $ ? ct += F.slice($, A) + `
` + F.slice(A + 1) : ct += F.slice($), ct.slice(1);
      }
      function X(F, P, j) {
        var H, B, $, A, E, ct;
        for ($ = 0, A = (B = j ? F.explicitTypes : F.implicitTypes).length; $ < A; $ += 1) if (((E = B[$]).instanceOf || E.predicate) && (!E.instanceOf || typeof P == "object" && P instanceof E.instanceOf) && (!E.predicate || E.predicate(P))) {
          if (F.tag = j ? E.tag : "?", E.represent) {
            if (ct = F.styleMap[E.tag] || E.defaultStyle, c.call(E.represent) === "[object Function]") H = E.represent(P, ct);
            else {
              if (!u.call(E.represent, ct)) throw new a("!<" + E.tag + '> tag resolver accepts not "' + ct + '" style');
              H = E.represent[ct](P, ct);
            }
            F.dump = H;
          }
          return !0;
        }
        return !1;
      }
      function C(F, P, j, H, B, $) {
        F.tag = null, F.dump = j, X(F, j, !1) || X(F, j, !0);
        var A = c.call(F.dump);
        H && (H = F.flowLevel < 0 || F.flowLevel > P);
        var E, ct, at = A === "[object Object]" || A === "[object Array]";
        if (at && (ct = (E = F.duplicates.indexOf(j)) !== -1), (F.tag !== null && F.tag !== "?" || ct || F.indent !== 2 && P > 0) && (B = !1), ct && F.usedDuplicates[E]) F.dump = "*ref_" + E;
        else {
          if (at && ct && !F.usedDuplicates[E] && (F.usedDuplicates[E] = !0), A === "[object Object]") H && Object.keys(F.dump).length !== 0 ? ((function(gt, Wt, Zt, Gt) {
            var Tt, Q, D, q, nt, et, ot = "", it = gt.tag, ht = Object.keys(Zt);
            if (gt.sortKeys === !0) ht.sort();
            else if (typeof gt.sortKeys == "function") ht.sort(gt.sortKeys);
            else if (gt.sortKeys) throw new a("sortKeys must be a boolean or a function");
            for (Tt = 0, Q = ht.length; Tt < Q; Tt += 1) et = "", Gt && Tt === 0 || (et += y(gt, Wt)), q = Zt[D = ht[Tt]], C(gt, Wt + 1, D, !0, !0, !0) && ((nt = gt.tag !== null && gt.tag !== "?" || gt.dump && gt.dump.length > 1024) && (gt.dump && gt.dump.charCodeAt(0) === 10 ? et += "?" : et += "? "), et += gt.dump, nt && (et += y(gt, Wt)), C(gt, Wt + 1, q, !0, nt) && (gt.dump && gt.dump.charCodeAt(0) === 10 ? et += ":" : et += ": ", ot += et += gt.dump));
            gt.tag = it, gt.dump = ot || "{}";
          })(F, P, F.dump, B), ct && (F.dump = "&ref_" + E + F.dump)) : ((function(gt, Wt, Zt) {
            var Gt, Tt, Q, D, q, nt = "", et = gt.tag, ot = Object.keys(Zt);
            for (Gt = 0, Tt = ot.length; Gt < Tt; Gt += 1) q = "", Gt !== 0 && (q += ", "), gt.condenseFlow && (q += '"'), D = Zt[Q = ot[Gt]], C(gt, Wt, Q, !1, !1) && (gt.dump.length > 1024 && (q += "? "), q += gt.dump + (gt.condenseFlow ? '"' : "") + ":" + (gt.condenseFlow ? "" : " "), C(gt, Wt, D, !1, !1) && (nt += q += gt.dump));
            gt.tag = et, gt.dump = "{" + nt + "}";
          })(F, P, F.dump), ct && (F.dump = "&ref_" + E + " " + F.dump));
          else if (A === "[object Array]") {
            var dt = F.noArrayIndent && P > 0 ? P - 1 : P;
            H && F.dump.length !== 0 ? ((function(gt, Wt, Zt, Gt) {
              var Tt, Q, D = "", q = gt.tag;
              for (Tt = 0, Q = Zt.length; Tt < Q; Tt += 1) C(gt, Wt + 1, Zt[Tt], !0, !0) && (Gt && Tt === 0 || (D += y(gt, Wt)), gt.dump && gt.dump.charCodeAt(0) === 10 ? D += "-" : D += "- ", D += gt.dump);
              gt.tag = q, gt.dump = D || "[]";
            })(F, dt, F.dump, B), ct && (F.dump = "&ref_" + E + F.dump)) : ((function(gt, Wt, Zt) {
              var Gt, Tt, Q = "", D = gt.tag;
              for (Gt = 0, Tt = Zt.length; Gt < Tt; Gt += 1) C(gt, Wt, Zt[Gt], !1, !1) && (Gt !== 0 && (Q += "," + (gt.condenseFlow ? "" : " ")), Q += gt.dump);
              gt.tag = D, gt.dump = "[" + Q + "]";
            })(F, dt, F.dump), ct && (F.dump = "&ref_" + E + " " + F.dump));
          } else {
            if (A !== "[object String]") {
              if (F.skipInvalid) return !1;
              throw new a("unacceptable kind of an object to dump " + A);
            }
            F.tag !== "?" && N(F, F.dump, P, $);
          }
          F.tag !== null && F.tag !== "?" && (F.dump = "!<" + F.tag + "> " + F.dump);
        }
        return !0;
      }
      function R(F, P) {
        var j, H, B = [], $ = [];
        for ((function A(E, ct, at) {
          var dt, gt, Wt;
          if (E !== null && typeof E == "object") if ((gt = ct.indexOf(E)) !== -1) at.indexOf(gt) === -1 && at.push(gt);
          else if (ct.push(E), Array.isArray(E)) for (gt = 0, Wt = E.length; gt < Wt; gt += 1) A(E[gt], ct, at);
          else for (dt = Object.keys(E), gt = 0, Wt = dt.length; gt < Wt; gt += 1) A(E[dt[gt]], ct, at);
        })(F, B, $), j = 0, H = $.length; j < H; j += 1) P.duplicates.push(B[$[j]]);
        P.usedDuplicates = new Array(H);
      }
      function z(F, P) {
        var j = new m(P = P || {});
        return j.noRefs || R(F, j), C(j, 0, F, !0, !0) ? j.dump + `
` : "";
      }
      e.exports.dump = z, e.exports.safeDump = function(F, P) {
        return z(F, r.extend({ schema: l }, P));
      };
    }, function(e, n, s) {
      s(31), s(32), s(33), s(64), s(19), s(65), s(20), s(68), s(92), s(144), s(22), s(94), s(23);
      var r, a = this && this.__extends || (r = function(M, N) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(W, x) {
          W.__proto__ = x;
        } || function(W, x) {
          for (var V in x) x.hasOwnProperty(V) && (W[V] = x[V]);
        })(M, N);
      }, function(M, N) {
        function W() {
          this.constructor = M;
        }
        r(M, N), M.prototype = N === null ? Object.create(N) : (W.prototype = N.prototype, new W());
      }), o = this && this.__values || function(M) {
        var N = typeof Symbol == "function" && Symbol.iterator, W = N && M[N], x = 0;
        if (W) return W.call(M);
        if (M && typeof M.length == "number") return { next: function() {
          return M && x >= M.length && (M = void 0), { value: M && M[x++], done: !M };
        } };
        throw new TypeError(N ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }, l = this && this.__read || function(M, N) {
        var W = typeof Symbol == "function" && M[Symbol.iterator];
        if (!W) return M;
        var x, V, X = W.call(M), C = [];
        try {
          for (; (N === void 0 || N-- > 0) && !(x = X.next()).done; ) C.push(x.value);
        } catch (R) {
          V = { error: R };
        } finally {
          try {
            x && !x.done && (W = X.return) && W.call(X);
          } finally {
            if (V) throw V.error;
          }
        }
        return C;
      };
      Object.defineProperty(n, "__esModule", { value: !0 });
      var c = s(91), u = s(1), d = s(183), h = s(0), p = s(7), m = s(95), b = s(69), y = s(3), Z = s(305), g = s(306), f = s(307), T = (function(M) {
        function N(W, x) {
          x === void 0 && (x = !1);
          var V = M.call(this) || this;
          return V._hasDeclaration = !1, V._docTypeName = "", V._hasDocumentElement = !1, V._currentElementSerialized = !1, V._openTags = [], V._ended = !1, V._fragment = x, V._options = u.applyDefaults(W || {}, c.DefaultXMLBuilderCBOptions), V._builderOptions = { defaultNamespace: V._options.defaultNamespace, namespaceAlias: V._options.namespaceAlias }, V._options.format === "json" ? V._writer = new g.JSONCBWriter(V._options) : V._options.format === "yaml" ? V._writer = new f.YAMLCBWriter(V._options) : V._writer = new Z.XMLCBWriter(V._options), V._options.data !== void 0 && V.on("data", V._options.data), V._options.end !== void 0 && V.on("end", V._options.end), V._options.error !== void 0 && V.on("error", V._options.error), V._prefixMap = new m.NamespacePrefixMap(), V._prefixMap.set("xml", p.namespace.XML), V._prefixIndex = { value: 1 }, V._push(V._writer.frontMatter()), V;
        }
        return a(N, M), N.prototype.ele = function(W, x, V) {
          var X, C;
          if (u.isObject(W) || u.isString(W) && (/^\s*</.test(W) || /^\s*[\{\[]/.test(W) || /^(\s*|(#.*)|(%.*))*---/.test(W))) {
            var R = d.fragment().set(this._options);
            try {
              R.ele(W);
            } catch (j) {
              return this.emit("error", j), this;
            }
            try {
              for (var z = o(R.node.childNodes), F = z.next(); !F.done; F = z.next()) {
                var P = F.value;
                this._fromNode(P);
              }
            } catch (j) {
              X = { error: j };
            } finally {
              try {
                F && !F.done && (C = z.return) && C.call(z);
              } finally {
                if (X) throw X.error;
              }
            }
            return this;
          }
          if (this._serializeOpenTag(!0), !this._fragment && this._hasDocumentElement && this._writer.level === 0) return this.emit("error", new Error("Document cannot have multiple document element nodes.")), this;
          try {
            this._currentElement = d.fragment(this._builderOptions).ele(W, x, V);
          } catch (j) {
            return this.emit("error", j), this;
          }
          return this._fragment || this._hasDocumentElement || this._docTypeName === "" || this._currentElement.node._qualifiedName === this._docTypeName ? (this._currentElementSerialized = !1, this._fragment || (this._hasDocumentElement = !0), this) : (this.emit("error", new Error("Document element name does not match DocType declaration name.")), this);
        }, N.prototype.att = function(W, x, V) {
          if (this._currentElement === void 0) return this.emit("error", new Error("Cannot insert an attribute node as child of a document node.")), this;
          try {
            this._currentElement.att(W, x, V);
          } catch (X) {
            return this.emit("error", X), this;
          }
          return this;
        }, N.prototype.com = function(W) {
          var x;
          this._serializeOpenTag(!0);
          try {
            x = d.fragment(this._builderOptions).com(W).first().node;
          } catch (V) {
            return this.emit("error", V), this;
          }
          return !this._options.wellFormed || h.xml_isLegalChar(x.data) && x.data.indexOf("--") === -1 && !x.data.endsWith("-") ? (this._push(this._writer.comment(x.data)), this) : (this.emit("error", new Error("Comment data contains invalid characters (well-formed required).")), this);
        }, N.prototype.txt = function(W) {
          if (!this._fragment && this._currentElement === void 0) return this.emit("error", new Error("Cannot insert a text node as child of a document node.")), this;
          var x;
          this._serializeOpenTag(!0);
          try {
            x = d.fragment(this._builderOptions).txt(W).first().node;
          } catch (X) {
            return this.emit("error", X), this;
          }
          if (this._options.wellFormed && !h.xml_isLegalChar(x.data)) return this.emit("error", new Error("Text data contains invalid characters (well-formed required).")), this;
          var V = x.data.replace(/(?!&(lt|gt|amp|apos|quot);)&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
          return this._push(this._writer.text(V)), this;
        }, N.prototype.ins = function(W, x) {
          var V;
          x === void 0 && (x = ""), this._serializeOpenTag(!0);
          try {
            V = d.fragment(this._builderOptions).ins(W, x).first().node;
          } catch (X) {
            return this.emit("error", X), this;
          }
          return this._options.wellFormed && (V.target.indexOf(":") !== -1 || /^xml$/i.test(V.target)) ? (this.emit("error", new Error("Processing instruction target contains invalid characters (well-formed required).")), this) : this._options.wellFormed && !h.xml_isLegalChar(V.data) ? (this.emit("error", Error("Processing instruction data contains invalid characters (well-formed required).")), this) : (this._push(this._writer.instruction(V.target, V.data)), this);
        }, N.prototype.dat = function(W) {
          var x;
          this._serializeOpenTag(!0);
          try {
            x = d.fragment(this._builderOptions).dat(W).first().node;
          } catch (V) {
            return this.emit("error", V), this;
          }
          return this._push(this._writer.cdata(x.data)), this;
        }, N.prototype.dec = function(W) {
          return W === void 0 && (W = { version: "1.0" }), this._fragment ? (this.emit("error", Error("Cannot insert an XML declaration into a document fragment.")), this) : this._hasDeclaration ? (this.emit("error", Error("XML declaration is already inserted.")), this) : (this._push(this._writer.declaration(W.version || "1.0", W.encoding, W.standalone)), this._hasDeclaration = !0, this);
        }, N.prototype.dtd = function(W) {
          if (this._fragment) return this.emit("error", Error("Cannot insert a DocType declaration into a document fragment.")), this;
          if (this._docTypeName !== "") return this.emit("error", new Error("DocType declaration is already inserted.")), this;
          if (this._hasDocumentElement) return this.emit("error", new Error("Cannot insert DocType declaration after document element.")), this;
          var x;
          try {
            x = d.create().dtd(W).first().node;
          } catch (V) {
            return this.emit("error", V), this;
          }
          return this._options.wellFormed && !h.xml_isPubidChar(x.publicId) ? (this.emit("error", new Error("DocType public identifier does not match PubidChar construct (well-formed required).")), this) : this._options.wellFormed && (!h.xml_isLegalChar(x.systemId) || x.systemId.indexOf('"') !== -1 && x.systemId.indexOf("'") !== -1) ? (this.emit("error", new Error("DocType system identifier contains invalid characters (well-formed required).")), this) : (this._docTypeName = W.name, this._push(this._writer.docType(W.name, x.publicId, x.systemId)), this);
        }, N.prototype.import = function(W) {
          var x, V, X = d.fragment().set(this._options);
          try {
            X.import(W);
          } catch (F) {
            return this.emit("error", F), this;
          }
          try {
            for (var C = o(X.node.childNodes), R = C.next(); !R.done; R = C.next()) {
              var z = R.value;
              this._fromNode(z);
            }
          } catch (F) {
            x = { error: F };
          } finally {
            try {
              R && !R.done && (V = C.return) && V.call(C);
            } finally {
              if (x) throw x.error;
            }
          }
          return this;
        }, N.prototype.up = function() {
          return this._serializeOpenTag(!1), this._serializeCloseTag(), this;
        }, N.prototype.end = function() {
          for (this._serializeOpenTag(!1); this._openTags.length > 0; ) this._serializeCloseTag();
          return this._push(null), this;
        }, N.prototype._serializeOpenTag = function(W) {
          if (!this._currentElementSerialized && this._currentElement !== void 0) {
            var x = this._currentElement.node;
            if (!this._options.wellFormed || x.localName.indexOf(":") === -1 && h.xml_isName(x.localName)) {
              var V = "", X = !1, C = this._prefixMap.copy(), R = {}, z = this._recordNamespaceInformation(x, C, R), F = this._openTags.length === 0 ? null : this._openTags[this._openTags.length - 1][1], P = x.namespaceURI;
              if (P === null && (P = F), F === P) z !== null && (X = !0), V = P === p.namespace.XML ? "xml:" + x.localName : x.localName, this._writer.beginElement(V), this._push(this._writer.openTagBegin(V));
              else {
                var j = x.prefix, H = null;
                if (j === null && P === z || (H = C.get(j, P)), j === "xmlns") {
                  if (this._options.wellFormed) return void this.emit("error", new Error("An element cannot have the 'xmlns' prefix (well-formed required)."));
                  H = j;
                }
                H !== null ? (V = H + ":" + x.localName, z !== null && z !== p.namespace.XML && (F = z || null), this._writer.beginElement(V), this._push(this._writer.openTagBegin(V))) : j !== null ? (j in R && (j = this._generatePrefix(P, C, this._prefixIndex)), C.set(j, P), V += j + ":" + x.localName, this._writer.beginElement(V), this._push(this._writer.openTagBegin(V)), this._push(this._writer.attribute("xmlns:" + j, this._serializeAttributeValue(P, this._options.wellFormed))), z !== null && (F = z || null)) : z === null || z !== null && z !== P ? (X = !0, V += x.localName, F = P, this._writer.beginElement(V), this._push(this._writer.openTagBegin(V)), this._push(this._writer.attribute("xmlns", this._serializeAttributeValue(P, this._options.wellFormed)))) : (V += x.localName, F = P, this._writer.beginElement(V), this._push(this._writer.openTagBegin(V)));
              }
              this._serializeAttributes(x, C, this._prefixIndex, R, X, this._options.wellFormed);
              var B = P === p.namespace.HTML;
              B && !W && N._VoidElementNames.has(x.localName) ? (this._push(this._writer.openTagEnd(V, !0, !0)), this._writer.endElement(V)) : B || W ? this._push(this._writer.openTagEnd(V, !1, !1)) : (this._push(this._writer.openTagEnd(V, !0, !1)), this._writer.endElement(V)), this._currentElementSerialized = !0, this._openTags.push([V, F, this._prefixMap, W]), this._isPrefixMapModified(this._prefixMap, C) && (this._prefixMap = C), this._writer.level++;
            } else this.emit("error", new Error("Node local name contains invalid characters (well-formed required)."));
          }
        }, N.prototype._serializeCloseTag = function() {
          this._writer.level--;
          var W = this._openTags.pop();
          if (W !== void 0) {
            var x = l(W, 4), V = x[0], X = (x[1], x[2]), C = x[3];
            this._prefixMap = X, C && (this._push(this._writer.closeTag(V)), this._writer.endElement(V));
          } else this.emit("error", new Error("Last element is undefined."));
        }, N.prototype._push = function(W) {
          W === null ? (this._ended = !0, this.emit("end")) : this._ended ? this.emit("error", new Error("Cannot push to ended stream.")) : W.length !== 0 && (this._writer.hasData = !0, this.emit("data", W, this._writer.level));
        }, N.prototype._fromNode = function(W) {
          var x, V, X, C;
          if (y.Guard.isElementNode(W)) {
            var R = W.prefix ? W.prefix + ":" + W.localName : W.localName;
            W.namespaceURI !== null ? this.ele(W.namespaceURI, R) : this.ele(R);
            try {
              for (var z = o(W.attributes), F = z.next(); !F.done; F = z.next()) {
                var P = F.value, j = P.prefix ? P.prefix + ":" + P.localName : P.localName;
                P.namespaceURI !== null ? this.att(P.namespaceURI, j, P.value) : this.att(j, P.value);
              }
            } catch (A) {
              x = { error: A };
            } finally {
              try {
                F && !F.done && (V = z.return) && V.call(z);
              } finally {
                if (x) throw x.error;
              }
            }
            try {
              for (var H = o(W.childNodes), B = H.next(); !B.done; B = H.next()) {
                var $ = B.value;
                this._fromNode($);
              }
            } catch (A) {
              X = { error: A };
            } finally {
              try {
                B && !B.done && (C = H.return) && C.call(H);
              } finally {
                if (X) throw X.error;
              }
            }
            this.up();
          } else y.Guard.isExclusiveTextNode(W) && W.data ? this.txt(W.data) : y.Guard.isCommentNode(W) ? this.com(W.data) : y.Guard.isCDATASectionNode(W) ? this.dat(W.data) : y.Guard.isProcessingInstructionNode(W) && this.ins(W.target, W.data);
        }, N.prototype._serializeAttributes = function(W, x, V, X, C, R) {
          var z, F, P = R ? new b.LocalNameSet() : void 0;
          try {
            for (var j = o(W.attributes), H = j.next(); !H.done; H = j.next()) {
              var B = H.value;
              if (R || C || B.namespaceURI !== null) {
                if (R && P && P.has(B.namespaceURI, B.localName)) return void this.emit("error", new Error("Element contains duplicate attributes (well-formed required)."));
                R && P && P.set(B.namespaceURI, B.localName);
                var $ = B.namespaceURI, A = null;
                if ($ !== null) if (A = x.get(B.prefix, $), $ === p.namespace.XMLNS) {
                  if (B.value === p.namespace.XML || B.prefix === null && C || B.prefix !== null && (!(B.localName in X) || X[B.localName] !== B.value) && x.has(B.localName, B.value)) continue;
                  if (R && B.value === p.namespace.XMLNS) return void this.emit("error", new Error("XMLNS namespace is reserved (well-formed required)."));
                  if (R && B.value === "") return void this.emit("error", new Error("Namespace prefix declarations cannot be used to undeclare a namespace (well-formed required)."));
                  B.prefix === "xmlns" && (A = "xmlns");
                } else A === null && (A = B.prefix === null || x.hasPrefix(B.prefix) && !x.has(B.prefix, $) ? this._generatePrefix($, x, V) : B.prefix, this._push(this._writer.attribute("xmlns:" + A, this._serializeAttributeValue($, this._options.wellFormed))));
                if (R && (B.localName.indexOf(":") !== -1 || !h.xml_isName(B.localName) || B.localName === "xmlns" && $ === null)) return void this.emit("error", new Error("Attribute local name contains invalid characters (well-formed required)."));
                this._push(this._writer.attribute((A !== null ? A + ":" : "") + B.localName, this._serializeAttributeValue(B.value, this._options.wellFormed)));
              } else this._push(this._writer.attribute(B.localName, this._serializeAttributeValue(B.value, this._options.wellFormed)));
            }
          } catch (E) {
            z = { error: E };
          } finally {
            try {
              H && !H.done && (F = j.return) && F.call(j);
            } finally {
              if (z) throw z.error;
            }
          }
        }, N.prototype._serializeAttributeValue = function(W, x) {
          return x && W !== null && !h.xml_isLegalChar(W) ? (this.emit("error", new Error("Invalid characters in attribute value.")), "") : W === null ? "" : W.replace(/(?!&(lt|gt|amp|apos|quot);)&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
        }, N.prototype._recordNamespaceInformation = function(W, x, V) {
          var X, C, R = null;
          try {
            for (var z = o(W.attributes), F = z.next(); !F.done; F = z.next()) {
              var P = F.value, j = P.namespaceURI, H = P.prefix;
              if (j === p.namespace.XMLNS) {
                if (H === null) {
                  R = P.value;
                  continue;
                }
                var B = P.localName, $ = P.value;
                if ($ === p.namespace.XML || ($ === "" && ($ = null), x.has(B, $))) continue;
                x.set(B, $), V[B] = $ || "";
              }
            }
          } catch (A) {
            X = { error: A };
          } finally {
            try {
              F && !F.done && (C = z.return) && C.call(z);
            } finally {
              if (X) throw X.error;
            }
          }
          return R;
        }, N.prototype._generatePrefix = function(W, x, V) {
          var X = "ns" + V.value;
          return V.value++, x.set(X, W), X;
        }, N.prototype._isPrefixMapModified = function(W, x) {
          var V = W._items, X = x._items, C = W._nullItems, R = x._nullItems;
          for (var z in X) {
            var F = V[z];
            if (F === void 0) return !0;
            var P = X[z];
            if (F.length !== P.length) return !0;
            for (var j = 0; j < F.length; j++) if (F[j] !== P[j]) return !0;
          }
          if (C.length !== R.length) return !0;
          for (j = 0; j < C.length; j++) if (C[j] !== R[j]) return !0;
          return !1;
        }, N._VoidElementNames = /* @__PURE__ */ new Set(["area", "base", "basefont", "bgsound", "br", "col", "embed", "frame", "hr", "img", "input", "keygen", "link", "menuitem", "meta", "param", "source", "track", "wbr"]), N;
      })(s(308).EventEmitter);
      n.XMLBuilderCBImpl = T;
    }, function(e, n, s) {
      s(74);
      var r, a = this && this.__extends || (r = function(l, c) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, d) {
          u.__proto__ = d;
        } || function(u, d) {
          for (var h in d) d.hasOwnProperty(h) && (u[h] = d[h]);
        })(l, c);
      }, function(l, c) {
        function u() {
          this.constructor = l;
        }
        r(l, c), l.prototype = c === null ? Object.create(c) : (u.prototype = c.prototype, new u());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = (function(l) {
        function c(u) {
          var d = l.call(this, u) || this;
          return d._lineLength = 0, d;
        }
        return a(c, l), c.prototype.frontMatter = function() {
          return "";
        }, c.prototype.declaration = function(u, d, h) {
          var p = this._beginLine() + "<?xml";
          return p += ' version="' + u + '"', d !== void 0 && (p += ' encoding="' + d + '"'), h !== void 0 && (p += ' standalone="' + (h ? "yes" : "no") + '"'), p += "?>";
        }, c.prototype.docType = function(u, d, h) {
          var p = this._beginLine();
          return p += d && h ? "<!DOCTYPE " + u + ' PUBLIC "' + d + '" "' + h + '">' : d ? "<!DOCTYPE " + u + ' PUBLIC "' + d + '">' : h ? "<!DOCTYPE " + u + ' SYSTEM "' + h + '">' : "<!DOCTYPE " + u + ">";
        }, c.prototype.comment = function(u) {
          return this._beginLine() + "<!--" + u + "-->";
        }, c.prototype.text = function(u) {
          return this._beginLine() + u;
        }, c.prototype.instruction = function(u, d) {
          return d ? this._beginLine() + "<?" + u + " " + d + "?>" : this._beginLine() + "<?" + u + "?>";
        }, c.prototype.cdata = function(u) {
          return this._beginLine() + "<![CDATA[" + u + "]]>";
        }, c.prototype.openTagBegin = function(u) {
          return this._lineLength += 1 + u.length, this._beginLine() + "<" + u;
        }, c.prototype.openTagEnd = function(u, d, h) {
          return h ? " />" : d ? this._writerOptions.allowEmptyTags ? "></" + u + ">" : this._writerOptions.spaceBeforeSlash ? " />" : "/>" : ">";
        }, c.prototype.closeTag = function(u) {
          return this._beginLine() + "</" + u + ">";
        }, c.prototype.attribute = function(u, d) {
          var h = u + '="' + d + '"';
          return this._writerOptions.prettyPrint && this._writerOptions.width > 0 && this._lineLength + 1 + h.length > this._writerOptions.width ? (h = this._beginLine() + this._indent(1) + h, this._lineLength = h.length, h) : (this._lineLength += 1 + h.length, " " + h);
        }, c.prototype.beginElement = function(u) {
        }, c.prototype.endElement = function(u) {
        }, c.prototype._beginLine = function() {
          if (this._writerOptions.prettyPrint) {
            var u = (this.hasData ? this._writerOptions.newline : "") + this._indent(this._writerOptions.offset + this.level);
            return this._lineLength = u.length, u;
          }
          return "";
        }, c.prototype._indent = function(u) {
          return u <= 0 ? "" : this._writerOptions.indent.repeat(u);
        }, c;
      })(s(114).BaseCBWriter);
      n.XMLCBWriter = o;
    }, function(e, n, s) {
      s(74);
      var r, a = this && this.__extends || (r = function(l, c) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, d) {
          u.__proto__ = d;
        } || function(u, d) {
          for (var h in d) d.hasOwnProperty(h) && (u[h] = d[h]);
        })(l, c);
      }, function(l, c) {
        function u() {
          this.constructor = l;
        }
        r(l, c), l.prototype = c === null ? Object.create(c) : (u.prototype = c.prototype, new u());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = (function(l) {
        function c(u) {
          var d = l.call(this, u) || this;
          return d._hasChildren = [], d._additionalLevel = 0, d;
        }
        return a(c, l), c.prototype.frontMatter = function() {
          return "";
        }, c.prototype.declaration = function(u, d, h) {
          return "";
        }, c.prototype.docType = function(u, d, h) {
          return "";
        }, c.prototype.comment = function(u) {
          return this._comma() + this._beginLine() + "{" + this._sep() + this._key(this._builderOptions.convert.comment) + this._sep() + this._val(u) + this._sep() + "}";
        }, c.prototype.text = function(u) {
          return this._comma() + this._beginLine() + "{" + this._sep() + this._key(this._builderOptions.convert.text) + this._sep() + this._val(u) + this._sep() + "}";
        }, c.prototype.instruction = function(u, d) {
          return this._comma() + this._beginLine() + "{" + this._sep() + this._key(this._builderOptions.convert.ins) + this._sep() + this._val(d ? u + " " + d : u) + this._sep() + "}";
        }, c.prototype.cdata = function(u) {
          return this._comma() + this._beginLine() + "{" + this._sep() + this._key(this._builderOptions.convert.cdata) + this._sep() + this._val(u) + this._sep() + "}";
        }, c.prototype.attribute = function(u, d) {
          return this._comma() + this._beginLine(1) + "{" + this._sep() + this._key(this._builderOptions.convert.att + u) + this._sep() + this._val(d) + this._sep() + "}";
        }, c.prototype.openTagBegin = function(u) {
          var d = this._comma() + this._beginLine() + "{" + this._sep() + this._key(u) + this._sep() + "{";
          return this._additionalLevel++, this.hasData = !0, d += this._beginLine() + this._key(this._builderOptions.convert.text) + this._sep() + "[", this._hasChildren.push(!1), d;
        }, c.prototype.openTagEnd = function(u, d, h) {
          if (d) {
            var p = this._sep() + "]";
            return this._additionalLevel--, p += this._beginLine() + "}" + this._sep() + "}";
          }
          return "";
        }, c.prototype.closeTag = function(u) {
          var d = this._beginLine() + "]";
          return this._additionalLevel--, d += this._beginLine() + "}" + this._sep() + "}";
        }, c.prototype.beginElement = function(u) {
        }, c.prototype.endElement = function(u) {
          this._hasChildren.pop();
        }, c.prototype._beginLine = function(u) {
          return u === void 0 && (u = 0), this._writerOptions.prettyPrint ? (this.hasData ? this._writerOptions.newline : "") + this._indent(this._writerOptions.offset + this.level + u) : "";
        }, c.prototype._indent = function(u) {
          return u + this._additionalLevel <= 0 ? "" : this._writerOptions.indent.repeat(u + this._additionalLevel);
        }, c.prototype._comma = function() {
          var u = this._hasChildren[this._hasChildren.length - 1] ? "," : "";
          return this._hasChildren.length > 0 && (this._hasChildren[this._hasChildren.length - 1] = !0), u;
        }, c.prototype._sep = function() {
          return this._writerOptions.prettyPrint ? " " : "";
        }, c.prototype._key = function(u) {
          return '"' + u + '":';
        }, c.prototype._val = function(u) {
          return JSON.stringify(u);
        }, c;
      })(s(114).BaseCBWriter);
      n.JSONCBWriter = o;
    }, function(e, n, s) {
      s(74);
      var r, a = this && this.__extends || (r = function(l, c) {
        return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, d) {
          u.__proto__ = d;
        } || function(u, d) {
          for (var h in d) d.hasOwnProperty(h) && (u[h] = d[h]);
        })(l, c);
      }, function(l, c) {
        function u() {
          this.constructor = l;
        }
        r(l, c), l.prototype = c === null ? Object.create(c) : (u.prototype = c.prototype, new u());
      });
      Object.defineProperty(n, "__esModule", { value: !0 });
      var o = (function(l) {
        function c(u) {
          var d = l.call(this, u) || this;
          if (d._rootWritten = !1, d._additionalLevel = 0, u.indent.length < 2) throw new Error("YAML indententation string must be at least two characters long.");
          if (u.offset < 0) throw new Error("YAML offset should be zero or a positive number.");
          return d;
        }
        return a(c, l), c.prototype.frontMatter = function() {
          return this._beginLine() + "---";
        }, c.prototype.declaration = function(u, d, h) {
          return "";
        }, c.prototype.docType = function(u, d, h) {
          return "";
        }, c.prototype.comment = function(u) {
          return this._beginLine() + this._key(this._builderOptions.convert.comment) + " " + this._val(u);
        }, c.prototype.text = function(u) {
          return this._beginLine() + this._key(this._builderOptions.convert.text) + " " + this._val(u);
        }, c.prototype.instruction = function(u, d) {
          return this._beginLine() + this._key(this._builderOptions.convert.ins) + " " + this._val(d ? u + " " + d : u);
        }, c.prototype.cdata = function(u) {
          return this._beginLine() + this._key(this._builderOptions.convert.cdata) + " " + this._val(u);
        }, c.prototype.attribute = function(u, d) {
          this._additionalLevel++;
          var h = this._beginLine() + this._key(this._builderOptions.convert.att + u) + " " + this._val(d);
          return this._additionalLevel--, h;
        }, c.prototype.openTagBegin = function(u) {
          var d = this._beginLine() + this._key(u);
          return this._rootWritten || (this._rootWritten = !0), this.hasData = !0, this._additionalLevel++, d += this._beginLine(!0) + this._key(this._builderOptions.convert.text);
        }, c.prototype.openTagEnd = function(u, d, h) {
          return d ? " " + this._val("") : "";
        }, c.prototype.closeTag = function(u) {
          return this._additionalLevel--, "";
        }, c.prototype.beginElement = function(u) {
        }, c.prototype.endElement = function(u) {
        }, c.prototype._beginLine = function(u) {
          return u === void 0 && (u = !1), (this.hasData ? this._writerOptions.newline : "") + this._indent(this._writerOptions.offset + this.level, u);
        }, c.prototype._indent = function(u, d) {
          if (u + this._additionalLevel <= 0) return "";
          var h = this._writerOptions.indent.repeat(u + this._additionalLevel);
          return !d && this._rootWritten ? h.substr(0, h.length - 2) + "-" + h.substr(-1, 1) : h;
        }, c.prototype._key = function(u) {
          return '"' + u + '":';
        }, c.prototype._val = function(u) {
          return JSON.stringify(u);
        }, c;
      })(s(114).BaseCBWriter);
      n.YAMLCBWriter = o;
    }, function(e, n, s) {
      var r, a = typeof Reflect == "object" ? Reflect : null, o = a && typeof a.apply == "function" ? a.apply : function(f, T, M) {
        return Function.prototype.apply.call(f, T, M);
      };
      r = a && typeof a.ownKeys == "function" ? a.ownKeys : Object.getOwnPropertySymbols ? function(f) {
        return Object.getOwnPropertyNames(f).concat(Object.getOwnPropertySymbols(f));
      } : function(f) {
        return Object.getOwnPropertyNames(f);
      };
      var l = Number.isNaN || function(f) {
        return f != f;
      };
      function c() {
        c.init.call(this);
      }
      e.exports = c, c.EventEmitter = c, c.prototype._events = void 0, c.prototype._eventsCount = 0, c.prototype._maxListeners = void 0;
      var u = 10;
      function d(f) {
        if (typeof f != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof f);
      }
      function h(f) {
        return f._maxListeners === void 0 ? c.defaultMaxListeners : f._maxListeners;
      }
      function p(f, T, M, N) {
        var W, x, V, X;
        if (d(M), (x = f._events) === void 0 ? (x = f._events = /* @__PURE__ */ Object.create(null), f._eventsCount = 0) : (x.newListener !== void 0 && (f.emit("newListener", T, M.listener ? M.listener : M), x = f._events), V = x[T]), V === void 0) V = x[T] = M, ++f._eventsCount;
        else if (typeof V == "function" ? V = x[T] = N ? [M, V] : [V, M] : N ? V.unshift(M) : V.push(M), (W = h(f)) > 0 && V.length > W && !V.warned) {
          V.warned = !0;
          var C = new Error("Possible EventEmitter memory leak detected. " + V.length + " " + String(T) + " listeners added. Use emitter.setMaxListeners() to increase limit");
          C.name = "MaxListenersExceededWarning", C.emitter = f, C.type = T, C.count = V.length, X = C, console && console.warn && console.warn(X);
        }
        return f;
      }
      function m() {
        if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
      }
      function b(f, T, M) {
        var N = { fired: !1, wrapFn: void 0, target: f, type: T, listener: M }, W = m.bind(N);
        return W.listener = M, N.wrapFn = W, W;
      }
      function y(f, T, M) {
        var N = f._events;
        if (N === void 0) return [];
        var W = N[T];
        return W === void 0 ? [] : typeof W == "function" ? M ? [W.listener || W] : [W] : M ? (function(x) {
          for (var V = new Array(x.length), X = 0; X < V.length; ++X) V[X] = x[X].listener || x[X];
          return V;
        })(W) : g(W, W.length);
      }
      function Z(f) {
        var T = this._events;
        if (T !== void 0) {
          var M = T[f];
          if (typeof M == "function") return 1;
          if (M !== void 0) return M.length;
        }
        return 0;
      }
      function g(f, T) {
        for (var M = new Array(T), N = 0; N < T; ++N) M[N] = f[N];
        return M;
      }
      Object.defineProperty(c, "defaultMaxListeners", { enumerable: !0, get: function() {
        return u;
      }, set: function(f) {
        if (typeof f != "number" || f < 0 || l(f)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + f + ".");
        u = f;
      } }), c.init = function() {
        this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
      }, c.prototype.setMaxListeners = function(f) {
        if (typeof f != "number" || f < 0 || l(f)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + f + ".");
        return this._maxListeners = f, this;
      }, c.prototype.getMaxListeners = function() {
        return h(this);
      }, c.prototype.emit = function(f) {
        for (var T = [], M = 1; M < arguments.length; M++) T.push(arguments[M]);
        var N = f === "error", W = this._events;
        if (W !== void 0) N = N && W.error === void 0;
        else if (!N) return !1;
        if (N) {
          var x;
          if (T.length > 0 && (x = T[0]), x instanceof Error) throw x;
          var V = new Error("Unhandled error." + (x ? " (" + x.message + ")" : ""));
          throw V.context = x, V;
        }
        var X = W[f];
        if (X === void 0) return !1;
        if (typeof X == "function") o(X, this, T);
        else {
          var C = X.length, R = g(X, C);
          for (M = 0; M < C; ++M) o(R[M], this, T);
        }
        return !0;
      }, c.prototype.addListener = function(f, T) {
        return p(this, f, T, !1);
      }, c.prototype.on = c.prototype.addListener, c.prototype.prependListener = function(f, T) {
        return p(this, f, T, !0);
      }, c.prototype.once = function(f, T) {
        return d(T), this.on(f, b(this, f, T)), this;
      }, c.prototype.prependOnceListener = function(f, T) {
        return d(T), this.prependListener(f, b(this, f, T)), this;
      }, c.prototype.removeListener = function(f, T) {
        var M, N, W, x, V;
        if (d(T), (N = this._events) === void 0) return this;
        if ((M = N[f]) === void 0) return this;
        if (M === T || M.listener === T) --this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete N[f], N.removeListener && this.emit("removeListener", f, M.listener || T));
        else if (typeof M != "function") {
          for (W = -1, x = M.length - 1; x >= 0; x--) if (M[x] === T || M[x].listener === T) {
            V = M[x].listener, W = x;
            break;
          }
          if (W < 0) return this;
          W === 0 ? M.shift() : (function(X, C) {
            for (; C + 1 < X.length; C++) X[C] = X[C + 1];
            X.pop();
          })(M, W), M.length === 1 && (N[f] = M[0]), N.removeListener !== void 0 && this.emit("removeListener", f, V || T);
        }
        return this;
      }, c.prototype.off = c.prototype.removeListener, c.prototype.removeAllListeners = function(f) {
        var T, M, N;
        if ((M = this._events) === void 0) return this;
        if (M.removeListener === void 0) return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : M[f] !== void 0 && (--this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete M[f]), this;
        if (arguments.length === 0) {
          var W, x = Object.keys(M);
          for (N = 0; N < x.length; ++N) (W = x[N]) !== "removeListener" && this.removeAllListeners(W);
          return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
        }
        if (typeof (T = M[f]) == "function") this.removeListener(f, T);
        else if (T !== void 0) for (N = T.length - 1; N >= 0; N--) this.removeListener(f, T[N]);
        return this;
      }, c.prototype.listeners = function(f) {
        return y(this, f, !0);
      }, c.prototype.rawListeners = function(f) {
        return y(this, f, !1);
      }, c.listenerCount = function(f, T) {
        return typeof f.listenerCount == "function" ? f.listenerCount(T) : Z.call(f, T);
      }, c.prototype.listenerCount = Z, c.prototype.eventNames = function() {
        return this._eventsCount > 0 ? r(this._events) : [];
      };
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(77);
      n.createCB = function(a) {
        return new r.XMLBuilderCBImpl(a);
      }, n.fragmentCB = function(a) {
        return new r.XMLBuilderCBImpl(a, !0);
      };
    }]);
  }));
})(EJ);
var jTt = EJ.exports, No = Uint8Array, Bp = Uint16Array, kJ = Uint32Array, FJ = new No([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  /* unused */
  0,
  0,
  /* impossible */
  0
]), jJ = new No([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  /* unused */
  0,
  0
]), UTt = new No([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), UJ = function(i, t) {
  for (var e = new Bp(31), n = 0; n < 31; ++n)
    e[n] = t += 1 << i[n - 1];
  for (var s = new kJ(e[30]), n = 1; n < 30; ++n)
    for (var r = e[n]; r < e[n + 1]; ++r)
      s[r] = r - e[n] << 5 | n;
  return [e, s];
}, PJ = UJ(FJ, 2), JJ = PJ[0], PTt = PJ[1];
JJ[28] = 258, PTt[258] = 28;
var JTt = UJ(jJ, 0), ATt = JTt[0], eV = new Bp(32768);
for (var ji = 0; ji < 32768; ++ji) {
  var Yd = (ji & 43690) >>> 1 | (ji & 21845) << 1;
  Yd = (Yd & 52428) >>> 2 | (Yd & 13107) << 2, Yd = (Yd & 61680) >>> 4 | (Yd & 3855) << 4, eV[ji] = ((Yd & 65280) >>> 8 | (Yd & 255) << 8) >>> 1;
}
var o2 = (function(i, t, e) {
  for (var n = i.length, s = 0, r = new Bp(t); s < n; ++s)
    i[s] && ++r[i[s] - 1];
  var a = new Bp(t);
  for (s = 0; s < t; ++s)
    a[s] = a[s - 1] + r[s - 1] << 1;
  var o;
  if (e) {
    o = new Bp(1 << t);
    var l = 15 - t;
    for (s = 0; s < n; ++s)
      if (i[s])
        for (var c = s << 4 | i[s], u = t - i[s], d = a[i[s] - 1]++ << u, h = d | (1 << u) - 1; d <= h; ++d)
          o[eV[d] >>> l] = c;
  } else
    for (o = new Bp(n), s = 0; s < n; ++s)
      i[s] && (o[s] = eV[a[i[s] - 1]++] >>> 15 - i[s]);
  return o;
}), JT = new No(288);
for (var ji = 0; ji < 144; ++ji)
  JT[ji] = 8;
for (var ji = 144; ji < 256; ++ji)
  JT[ji] = 9;
for (var ji = 256; ji < 280; ++ji)
  JT[ji] = 7;
for (var ji = 280; ji < 288; ++ji)
  JT[ji] = 8;
var AJ = new No(32);
for (var ji = 0; ji < 32; ++ji)
  AJ[ji] = 5;
var BTt = /* @__PURE__ */ o2(JT, 9, 1), KTt = /* @__PURE__ */ o2(AJ, 5, 1), cS = function(i) {
  for (var t = i[0], e = 1; e < i.length; ++e)
    i[e] > t && (t = i[e]);
  return t;
}, ul = function(i, t, e) {
  var n = t / 8 | 0;
  return (i[n] | i[n + 1] << 8) >> (t & 7) & e;
}, uS = function(i, t) {
  var e = t / 8 | 0;
  return (i[e] | i[e + 1] << 8 | i[e + 2] << 16) >> (t & 7);
}, HTt = function(i) {
  return (i + 7) / 8 | 0;
}, _Tt = function(i, t, e) {
  (e == null || e > i.length) && (e = i.length);
  var n = new (i.BYTES_PER_ELEMENT == 2 ? Bp : i.BYTES_PER_ELEMENT == 4 ? kJ : No)(e - t);
  return n.set(i.subarray(t, e)), n;
}, QTt = [
  "unexpected EOF",
  "invalid block type",
  "invalid length/literal",
  "invalid distance",
  "stream finished",
  "no stream handler",
  ,
  "no callback",
  "invalid UTF-8 data",
  "extra field too long",
  "date not in range 1980-2099",
  "filename too long",
  "stream finishing",
  "invalid zip data"
  // determined by unknown compression method
], Xl = function(i, t, e) {
  var n = new Error(t || QTt[i]);
  if (n.code = i, Error.captureStackTrace && Error.captureStackTrace(n, Xl), !e)
    throw n;
  return n;
}, VC = function(i, t, e) {
  var n = i.length;
  if (!n || e && e.f && !e.l)
    return t || new No(0);
  var s = !t || e, r = !e || e.i;
  e || (e = {}), t || (t = new No(n * 3));
  var a = function(Wt) {
    var Zt = t.length;
    if (Wt > Zt) {
      var Gt = new No(Math.max(Zt * 2, Wt));
      Gt.set(t), t = Gt;
    }
  }, o = e.f || 0, l = e.p || 0, c = e.b || 0, u = e.l, d = e.d, h = e.m, p = e.n, m = n * 8;
  do {
    if (!u) {
      o = ul(i, l, 1);
      var b = ul(i, l + 1, 3);
      if (l += 3, b)
        if (b == 1)
          u = BTt, d = KTt, h = 9, p = 5;
        else if (b == 2) {
          var f = ul(i, l, 31) + 257, T = ul(i, l + 10, 15) + 4, M = f + ul(i, l + 5, 31) + 1;
          l += 14;
          for (var N = new No(M), W = new No(19), x = 0; x < T; ++x)
            W[UTt[x]] = ul(i, l + x * 3, 7);
          l += T * 3;
          for (var V = cS(W), X = (1 << V) - 1, C = o2(W, V, 1), x = 0; x < M; ) {
            var R = C[ul(i, l, X)];
            l += R & 15;
            var y = R >>> 4;
            if (y < 16)
              N[x++] = y;
            else {
              var z = 0, F = 0;
              for (y == 16 ? (F = 3 + ul(i, l, 3), l += 2, z = N[x - 1]) : y == 17 ? (F = 3 + ul(i, l, 7), l += 3) : y == 18 && (F = 11 + ul(i, l, 127), l += 7); F--; )
                N[x++] = z;
            }
          }
          var P = N.subarray(0, f), j = N.subarray(f);
          h = cS(P), p = cS(j), u = o2(P, h, 1), d = o2(j, p, 1);
        } else
          Xl(1);
      else {
        var y = HTt(l) + 4, Z = i[y - 4] | i[y - 3] << 8, g = y + Z;
        if (g > n) {
          r && Xl(0);
          break;
        }
        s && a(c + Z), t.set(i.subarray(y, g), c), e.b = c += Z, e.p = l = g * 8, e.f = o;
        continue;
      }
      if (l > m) {
        r && Xl(0);
        break;
      }
    }
    s && a(c + 131072);
    for (var H = (1 << h) - 1, B = (1 << p) - 1, $ = l; ; $ = l) {
      var z = u[uS(i, l) & H], A = z >>> 4;
      if (l += z & 15, l > m) {
        r && Xl(0);
        break;
      }
      if (z || Xl(2), A < 256)
        t[c++] = A;
      else if (A == 256) {
        $ = l, u = null;
        break;
      } else {
        var E = A - 254;
        if (A > 264) {
          var x = A - 257, ct = FJ[x];
          E = ul(i, l, (1 << ct) - 1) + JJ[x], l += ct;
        }
        var at = d[uS(i, l) & B], dt = at >>> 4;
        at || Xl(3), l += at & 15;
        var j = ATt[dt];
        if (dt > 3) {
          var ct = jJ[dt];
          j += uS(i, l) & (1 << ct) - 1, l += ct;
        }
        if (l > m) {
          r && Xl(0);
          break;
        }
        s && a(c + 131072);
        for (var gt = c + E; c < gt; c += 4)
          t[c] = t[c - j], t[c + 1] = t[c + 1 - j], t[c + 2] = t[c + 2 - j], t[c + 3] = t[c + 3 - j];
        c = gt;
      }
    }
    e.l = u, e.p = $, e.b = c, e.f = o, u && (o = 1, e.m = h, e.d = d, e.n = p);
  } while (!o);
  return c == t.length ? t : _Tt(t, 0, c);
}, $Tt = /* @__PURE__ */ new No(0), qTt = function(i) {
  (i[0] != 31 || i[1] != 139 || i[2] != 8) && Xl(6, "invalid gzip data");
  var t = i[3], e = 10;
  t & 4 && (e += i[10] | (i[11] << 8) + 2);
  for (var n = (t >> 3 & 1) + (t >> 4 & 1); n > 0; n -= !i[e++])
    ;
  return e + (t & 2);
}, t1t = function(i) {
  var t = i.length;
  return (i[t - 4] | i[t - 3] << 8 | i[t - 2] << 16 | i[t - 1] << 24) >>> 0;
}, e1t = function(i) {
  ((i[0] & 15) != 8 || i[0] >>> 4 > 7 || (i[0] << 8 | i[1]) % 31) && Xl(6, "invalid zlib data"), i[1] & 32 && Xl(6, "invalid zlib data: preset dictionaries not supported");
};
function n1t(i, t) {
  return VC(i, t);
}
function i1t(i, t) {
  return VC(i.subarray(qTt(i), -8), new No(t1t(i)));
}
function s1t(i, t) {
  return VC((e1t(i), i.subarray(2, -4)), t);
}
function r1t(i, t) {
  return i[0] == 31 && i[1] == 139 && i[2] == 8 ? i1t(i) : (i[0] & 15) != 8 || i[0] >> 4 > 7 || (i[0] << 8 | i[1]) % 31 ? n1t(i, t) : s1t(i, t);
}
var a1t = typeof TextDecoder < "u" && /* @__PURE__ */ new TextDecoder(), o1t = 0;
try {
  a1t.decode($Tt, { stream: !0 }), o1t = 1;
} catch {
}
const bo = [];
bo[45] = 62;
bo[95] = 63;
const Nb = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (let i = 0; i < Nb.length; i++)
  bo[Nb.charCodeAt(i)] = i;
function ac(i) {
  return bo[i.charCodeAt(0)] !== void 0;
}
function l1t(i) {
  const t = i.length, e = [];
  let n = null;
  for (let s = 0; s < t; s++)
    ac(i[s]) ? (n || (n = {
      start: s,
      count: 0
    }), n.count++, n.end = s) : i[s] === "=" && n && (e.push(n), n = null);
  return n && e.push(n), e;
}
function c1t(i, t, e, n) {
  const {
    start: s,
    count: r
  } = t, a = r % 4, o = Math.floor(r / 4);
  let l = s, c = null, u = e;
  for (let d = 0; d < o; d++) {
    for (; !ac(i[l]); )
      l++;
    for (c = bo[i.charCodeAt(l++)] << 18; !ac(i[l]); )
      l++;
    for (c |= bo[i.charCodeAt(l++)] << 12; !ac(i[l]); )
      l++;
    for (c |= bo[i.charCodeAt(l++)] << 6; !ac(i[l]); )
      l++;
    c |= bo[i.charCodeAt(l++)], n[u++] = c >> 16 & 255, n[u++] = c >> 8 & 255, n[u++] = c & 255;
  }
  switch (a) {
    case 3:
      for (; !ac(i[l]); )
        l++;
      for (c = bo[i.charCodeAt(l++)] << 10; !ac(i[l]); )
        l++;
      for (c |= bo[i.charCodeAt(l++)] << 4; !ac(i[l]); )
        l++;
      c |= bo[i.charCodeAt(l++)] >> 2, n[u++] = c >> 8 & 255, n[u++] = c & 255;
      break;
    case 2:
      for (; !ac(i[l]); )
        l++;
      for (c = bo[i.charCodeAt(l++)] << 2; !ac(i[l]); )
        l++;
      c |= bo[i.charCodeAt(l++)] >> 4, n[u++] = c & 255;
      break;
    case 1:
      throw new Error("BASE64: remain 1 should not happen");
  }
  return u;
}
function u1t(i) {
  const t = l1t(i), e = t[t.length - 1].end + 1, n = (4 - e % 4) % 4, s = (e + n) * 3 / 4 - n, r = new ArrayBuffer(s), a = new Uint8Array(r);
  let o = 0;
  for (let l = 0; l < t.length; l++)
    o += c1t(i, t[l], o, a), o += (4 - t[l].count % 4) % 4;
  return r;
}
function hz(i, t, e) {
  const n = (i << 16) + (t << 8) + e;
  return Nb[n >> 18] + Nb[n >> 12 & 63] + Nb[n >> 6 & 63] + Nb[n & 63];
}
function d1t(i) {
  const t = new Uint8Array(i), e = i.byteLength % 3, n = i.byteLength - e, s = Array(n / 3);
  for (let r = 0; r < s.length; r++) {
    const a = r * 3;
    s[r] = hz(t[a], t[a + 1], t[a + 2]);
  }
  if (e > 0) {
    const r = hz(t[n], t[n + 1] || 0, t[n + 2] || 0);
    e === 1 ? s.push(`${r.substr(0, 2)}==`) : e === 2 && s.push(`${r.substr(0, 3)}=`);
  }
  return s.join("");
}
var XC = {
  toArrayBuffer: u1t,
  fromArrayBuffer: d1t
};
function h1t(i, t) {
  t.classHierarchy.push("vtkStringArray"), i.getComponent = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return t.values[e * t.numberOfComponents + n];
  }, i.setComponent = (e, n, s) => {
    s !== t.values[e * t.numberOfComponents + n] && (t.values[e * t.numberOfComponents + n] = s, i.modified());
  }, i.getData = () => t.values, i.getTuple = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    const s = t.numberOfComponents || 1;
    n.length && (n.length = s);
    const r = e * s;
    for (let a = 0; a < s; a++)
      n[a] = t.values[r + a];
    return n;
  }, i.getTupleLocation = function() {
    return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1) * t.numberOfComponents;
  }, i.getNumberOfComponents = () => t.numberOfComponents, i.getNumberOfValues = () => t.values.length, i.getNumberOfTuples = () => t.values.length / t.numberOfComponents, i.getDataType = () => t.dataType, i.newClone = () => KJ({
    name: t.name,
    numberOfComponents: t.numberOfComponents,
    empty: !0
  }), i.getName = () => (t.name || i.setName(`vtkStringArray${i.getMTime()}`), t.name), i.setData = (e, n) => {
    t.values = e, t.size = e.length, n && (t.numberOfComponents = n), t.size % t.numberOfComponents !== 0 && (t.numberOfComponents = 1), i.modified();
  };
}
const p1t = {
  name: "",
  numberOfComponents: 1,
  size: 0,
  // values: null,
  dataType: "string"
};
function BJ(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (Object.assign(t, p1t, e), !t.empty && !t.values && !t.size)
    throw new TypeError("Cannot create vtkStringArray object without: size > 0, values");
  t.values ? Array.isArray(t.values) && (t.values = [...t.values]) : t.values = [], t.values && (t.size = t.values.length), tt.obj(i, t), tt.set(i, t, ["name"]), h1t(i, t);
}
const KJ = tt.newInstance(BJ, "vtkStringArray");
var m1t = {
  newInstance: KJ,
  extend: BJ
};
function b1t(i, t) {
  return [...i.getElementsByTagName(t)];
}
function pz(i, t) {
  return b1t(i, t)[0];
}
function f1t(i) {
  return jTt.create(i);
}
function g1t(i) {
  const t = /^\s*<AppendedData\s+encoding="raw">\s*_/m, e = /\n\s*<\/AppendedData>/m;
  return p2.extractBinary(i, t, e);
}
const Fh = {
  Int8: Int8Array,
  UInt8: Uint8Array,
  Int16: Int16Array,
  UInt16: Uint16Array,
  Int32: Int32Array,
  UInt32: Uint32Array,
  Int64: Int32Array,
  // Not supported with JavaScript will cause error in binary
  UInt64: Uint32Array,
  // Not supported with JavaScript will cause error in binary
  Float32: Float32Array,
  Float64: Float64Array
}, S2 = {
  Int8: 1,
  UInt8: 1,
  Int16: 2,
  UInt16: 2,
  Int32: 4,
  UInt32: 4,
  Int64: 8,
  // Not supported with JavaScript will cause error in binary
  UInt64: 8,
  // Not supported with JavaScript will cause error in binary
  Float32: 4,
  Float64: 8
};
function nV(i) {
  const t = i.length - 1;
  return i.filter((e, n) => n < t && n % 2 === 0);
}
function iV(i, t, e) {
  if (!["UInt64", "UInt32"].includes(e))
    throw new Error(`Cannot handle a header type of ${e}`);
  let n = Fh[e], s = Fh[t], r = !1;
  e === "UInt64" && (n = Fh.UInt32), /^U?Int64$/.test(t) && (r = !0, s = Fh[t.replace("64", "32")]);
  const {
    byteOffset: a
  } = i, o = S2[t], l = S2[e];
  let c;
  a % l === 0 ? c = new n(i.buffer, a, 1) : c = new n(i.buffer.slice(a, a + l));
  const u = Number(c[0]);
  let d, h = u / o;
  r && (h *= 2);
  const p = a + l;
  return p % o === 0 ? d = new s(i.buffer, p, h) : d = new s(i.buffer.slice(p, p + u)), r && (d = nV(d)), d;
}
function y1t(i, t) {
  if (t === "UInt64") {
    let c = new Uint32Array(i.buffer, 0, 6);
    const u = c[0], d = c[2], h = c[4], p = [8, u, d, h];
    c = new Uint32Array(i.buffer, 24, u * 2);
    for (let m = 0; m < u; m++)
      p.push(c[m * 2]);
    return p;
  }
  let e = new Uint32Array(i.buffer, 0, 3);
  const n = 4, s = e[0], r = e[1], a = e[2], o = [n, s, r, a];
  e = new Uint32Array(i.buffer, 12, s);
  for (let l = 0; l < s; l++)
    o.push(e[l]);
  return o;
}
function Z1t(i, t) {
  const [e] = i;
  return (i.length - 1) * e;
}
function T1t(i, t) {
  const e = r1t(i);
  t.uint8.set(e, t.offset), t.offset += e.length;
}
function IC(i, t) {
  const e = y1t(i, t), n = e[1], s = e[2], r = e[3];
  let a = 0;
  n > 0 && (r === 0 ? a = n * s : a = (n - 1) * s + r);
  const o = new ArrayBuffer(a), l = {
    offset: 0,
    uint8: new Uint8Array(o)
  };
  let c = Z1t(e);
  for (; c < i.length && i[c] !== 120; )
    c++;
  for (let u = 0; u < n; u++) {
    const d = e[4 + u], h = new Uint8Array(i.buffer, c, d);
    T1t(h, l), c += d;
  }
  return l.uint8;
}
function L2(i, t, e, n, s, r) {
  const a = t.getAttribute("type"), o = t.getAttribute("Name"), l = t.getAttribute("format"), c = Number(t.getAttribute("NumberOfComponents") || "1");
  let u = null;
  if (l === "ascii") {
    u = new Fh[a](i * c);
    let d = 0;
    t.firstChild.nodeValue.split(/[\\t \\n]+/).forEach((h) => {
      h.trim().length && (u[d++] = Number(h));
    });
  } else if (l === "binary") {
    const d = new Uint8Array(XC.toArrayBuffer(t.firstChild.nodeValue.trim()));
    if (e === "vtkZLibDataCompressor") {
      const h = IC(d, s);
      u = new Fh[a](h.buffer), /^U?Int64$/.test(a) && (u = nV(u));
    } else
      u = new Fh[a](d.buffer, S2[s]), a.indexOf("Int64") !== -1 && (u = nV(u));
  } else if (l === "appended") {
    const d = Number(t.getAttribute("offset"));
    u = iV(new Uint8Array(r, d), a, s);
  } else
    console.error("Format not supported", l);
  return {
    name: o,
    values: u,
    numberOfComponents: c
  };
}
function dS(i) {
  return new TextDecoder().decode(i).split("\0").slice(0, -1);
}
function M1t(i, t, e, n, s) {
  const r = i.getAttribute("Name"), a = i.getAttribute("format"), o = Number(i.getAttribute("NumberOfComponents") || "1"), c = Number(i.getAttribute("NumberOfTuples") || "1") * o, u = [];
  if (a === "ascii") {
    const d = i.firstChild.nodeValue.trim().split(/\s+/);
    let h = 0;
    const p = [];
    for (; u.length < c; ) {
      const m = Number(d[h++]);
      m === 0 ? (u.push(p.join("")), p.length = 0) : p.push(String.fromCharCode(m));
    }
  } else if (a === "binary") {
    const d = new Uint8Array(XC.toArrayBuffer(i.firstChild.nodeValue.trim()));
    if (t === "vtkZLibDataCompressor") {
      const h = IC(d, n);
      u.push(...dS(h));
    } else {
      const h = iV(d, "UInt8", n);
      u.push(...dS(h));
    }
  } else if (a === "appended") {
    const d = Number(i.getAttribute("offset")), h = iV(new Uint8Array(s, d), "UInt8", n);
    u.push(...dS(h));
  } else
    tt.vtkErrorMacro(`Format not supported: ${a}`);
  return {
    name: r,
    values: u,
    numberOfComponents: o
  };
}
function N1t(i, t, e, n, s, r) {
  const a = {}, o = t.getElementsByTagName("DataArray");
  for (let m = 0; m < o.length; m++) {
    const b = o[m];
    a[b.getAttribute("Name")] = b;
  }
  const l = L2(i, a.offsets, e, n, s, r).values, c = l[l.length - 1], u = L2(c, a.connectivity, e, n, s, r).values, d = new Uint32Array(i + c);
  let h = 0, p = 0;
  return l.forEach((m) => {
    const b = m - p;
    d[h++] = b;
    for (let y = 0; y < b; y++)
      d[h++] = u[p + y];
    p = m;
  }), d;
}
function W1t(i, t, e, n, s, r, a) {
  if (t) {
    const o = ["Scalars", "Vectors", "Normals", "Tensors", "TCoords"], l = {};
    o.forEach((d) => {
      const h = t.getAttribute(d);
      h && (l[h] = e[`set${d}`]);
    });
    const c = t.getElementsByTagName("DataArray"), u = c.length;
    for (let d = 0; d < u; d++) {
      const h = c[d], p = We.newInstance(L2(i, h, n, s, r, a)), m = p.getName();
      (l[m] || e.addArray)(p);
    }
  }
}
function G1t(i, t, e, n, s) {
  const r = [...i.getElementsByTagName("DataArray")].map((o) => We.newInstance(L2(Number(o.getAttribute("NumberOfTuples")), o, t, e, n, s))), a = [...i.getElementsByTagName("Array")].filter((o) => o.getAttribute("type") === "String").map((o) => m1t.newInstance(M1t(o, t, e, n, s)));
  return [...r, ...a];
}
function w1t(i, t) {
  t.classHierarchy.push("vtkXMLReader"), t.dataAccessHelper || (t.dataAccessHelper = DG.get("http"));
  function e(n) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return t.dataAccessHelper.fetchBinary(n, s);
  }
  i.setUrl = function(n) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    t.url = n;
    const r = n.split("/");
    return r.pop(), t.baseURL = r.join("/"), i.loadData(s);
  }, i.loadData = function() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return e(t.url, n).then(i.parseAsArrayBuffer);
  }, i.parseAsArrayBuffer = (n) => {
    if (!n)
      return !1;
    if (n !== t.rawDataBuffer)
      i.modified();
    else
      return !0;
    const {
      text: s,
      binaryBuffer: r
    } = g1t(n);
    t.rawDataBuffer = n, t.binaryBuffer = r;
    const o = f1t(s).root(), l = o.node, c = l.getAttribute("type"), u = l.getAttribute("compressor"), d = l.getAttribute("byte_order"), h = l.getAttribute("header_type") || "UInt32";
    if (u && u !== "vtkZLibDataCompressor")
      return console.error("Invalid compressor", u), !1;
    if (d && d !== "LittleEndian")
      return console.error("Only LittleEndian encoding is supported"), !1;
    if (c !== t.dataType)
      return console.error("Invalid data type", c, "expecting", t.dataType), !1;
    if (pz(l, "AppendedData")) {
      const b = pz(l, "AppendedData"), y = b.getAttribute("encoding"), Z = o.filter((W) => {
        const {
          node: x
        } = W;
        return x.nodeType === Node.ELEMENT_NODE && x.getAttribute("format") === "appended" && x.hasAttribute("offset");
      }, !1, !0).map((W) => ({
        node: W.node,
        offset: Number(W.node.getAttribute("offset"))
      }));
      Z.sort((W, x) => W.offset - x.offset);
      let g = t.binaryBuffer;
      y === "base64" && (g = b.textContent.trim().substr(1));
      const f = [];
      for (let W = 0; W < Z.length; ++W) {
        const x = Z[W].offset;
        let V = 0;
        W === Z.length - 1 ? V = g.length || g.byteLength : V = Z[W + 1].offset, y === "base64" ? f.push(new Uint8Array(XC.toArrayBuffer(g.substring(x, V)))) : f.push(new Uint8Array(g.slice(x, V)));
      }
      if (u === "vtkZLibDataCompressor")
        for (let W = 0; W < f.length; ++W) {
          const x = f[W], V = IC(x, h), X = new Uint8Array(V.length + S2[h]);
          new Fh[h](X.buffer, 0, 1)[0] = V.length, X.set(V, S2[h]), f[W] = X;
        }
      const T = f.reduce((W, x) => W + x.length, 0), M = new ArrayBuffer(T), N = new Uint8Array(M);
      for (let W = 0, x = 0; W < f.length; ++W)
        Z[W].node.setAttribute("offset", x), N.set(f[W], x), x += f[W].length;
      if (t.binaryBuffer = M, !t.binaryBuffer)
        return console.error("Processing appended data format: requires binaryBuffer to parse"), !1;
    }
    i.parseXML(l, c, u, d, h);
    const m = l.getElementsByTagName(c)[0].getElementsByTagName("FieldData")[0];
    if (m) {
      const b = G1t(m, u, d, h, t.binaryBuffer);
      for (let y = 0; y < t.output.length; y++) {
        const Z = t.output[y].getFieldData();
        for (let g = 0; g < b.length; g++)
          Z.addArray(b[g]);
      }
    }
    return !0;
  }, i.requestData = (n, s) => {
    i.parseAsArrayBuffer(t.rawDataBuffer);
  };
}
const x1t = {
  // baseURL: null,
  // dataAccessHelper: null,
  // url: null,
};
function S1t(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, x1t, e), tt.obj(i, t), tt.get(i, t, ["url", "baseURL"]), tt.setGet(i, t, ["dataAccessHelper"]), tt.algo(i, t, 0, 1), w1t(i, t);
}
var V2 = {
  extend: S1t,
  processDataArray: L2,
  processFieldData: W1t,
  processCells: N1t
};
function L1t(i, t, e, n, s, r, a) {
  const o = Number(e.getAttribute(`NumberOf${t}`));
  if (o > 0) {
    const l = e.getElementsByTagName(t)[0].getElementsByTagName("DataArray")[0], {
      values: c,
      numberOfComponents: u
    } = V2.processDataArray(o, l, n, s, r, a);
    i[`get${t}`]().setData(c, u);
  }
  return o;
}
function V1t(i, t, e, n, s, r, a) {
  const o = Number(e.getAttribute(`NumberOf${t}`));
  if (o > 0) {
    const l = V2.processCells(o, e.getElementsByTagName(t)[0], n, s, r, a);
    i[`get${t}`]().setData(l);
  }
  return o;
}
function X1t(i, t) {
  t.classHierarchy.push("vtkXMLPolyDataReader"), i.parseXML = (e, n, s, r, a) => {
    const l = e.getElementsByTagName(t.dataType)[0].getElementsByTagName("Piece"), c = l.length;
    for (let u = 0; u < c; u++) {
      const d = Ie.newInstance(), h = l[u], p = L1t(d, "Points", h, s, r, a, t.binaryBuffer);
      let m = 0;
      ["Verts", "Lines", "Strips", "Polys"].forEach((b) => {
        m += V1t(d, b, h, s, r, a, t.binaryBuffer);
      }), V2.processFieldData(p, h.getElementsByTagName("PointData")[0], d.getPointData(), s, r, a, t.binaryBuffer), V2.processFieldData(m, h.getElementsByTagName("CellData")[0], d.getCellData(), s, r, a, t.binaryBuffer), t.output[u] = d;
    }
  };
}
const I1t = {
  dataType: "PolyData"
};
function HJ(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, I1t, e), V2.extend(i, t, e), X1t(i, t);
}
const C1t = tt.newInstance(HJ, "vtkXMLPolyDataReader");
var _J = {
  newInstance: C1t,
  extend: HJ
};
class Y1t {
  constructor() {
    S(this, "mapper", Ue.newInstance());
    S(this, "data", Ie.newInstance());
    S(this, "actor", Re.newInstance());
    S(this, "points", yi.newInstance());
    S(this, "lines", Ii.newInstance());
    this.mapper.setInputData(this.data), this.actor.setMapper(this.mapper), this.data.setPoints(this.points), this.data.setLines(this.lines), this.actor.setPickable(!1);
  }
  setData(t) {
    const { xAxis: e, yAxis: n, zAxis: s, origin: r } = t, a = I.clone(r), o = I.create();
    I.add(o, a, e);
    const l = I.create();
    I.add(l, o, n);
    const c = I.create();
    I.add(c, a, n);
    const u = I.create();
    I.add(u, a, s);
    const d = I.create();
    I.add(d, o, s);
    const h = I.create();
    I.add(h, l, s);
    const p = I.create();
    I.add(p, c, s), this.points.setNumberOfPoints(8), this.points.setData(new Float32Array([...a, ...o, ...l, ...c, ...u, ...d, ...h, ...p]));
    const m = new Uint16Array([
      2,
      3,
      0,
      2,
      0,
      1,
      2,
      1,
      2,
      2,
      2,
      3,
      2,
      7,
      4,
      2,
      4,
      5,
      2,
      5,
      6,
      2,
      6,
      7,
      2,
      0,
      4,
      2,
      1,
      5,
      2,
      2,
      6,
      2,
      3,
      7
    ]);
    this.lines.setData(m), this.actor.getProperty().setColor(t.color), this.data.modified();
  }
  getActor() {
    return this.actor;
  }
  delete() {
    this.points.delete(), this.lines.delete(), this.data.delete(), this.mapper.delete(), this.actor.delete();
  }
}
function v1t() {
  const i = sp.newInstance({
    radius: 1
  }), t = Ue.newInstance();
  t.setInputConnection(i.getOutputPort()), t.setScalarVisibility(!1);
  const e = Re.newInstance();
  return e.setMapper(t), e.setPickable(!0), e.getProperty().setColor(1, 0, 1), e.setVisibility(!0), {
    source: i,
    mapper: t,
    actor: e
  };
}
class R1t {
  constructor() {
    S(this, "arrowX", new yN());
    S(this, "arrowY", new yN());
    S(this, "arrowZ", new yN());
    S(this, "origin", v1t());
    this.arrowX.setPickable(!1), this.arrowY.setPickable(!1), this.arrowZ.setPickable(!1), this.origin.actor.setPickable(!1);
  }
  setData(t) {
    const { xAxis: e, yAxis: n, zAxis: s, origin: r, xLength: a, yLength: o, zLength: l } = t, c = I.create();
    I.normalize(c, e);
    const u = I.create();
    I.normalize(u, n);
    const d = I.create();
    I.normalize(d, s);
    const h = I.create(), p = I.create(), m = I.create();
    I.scaleAndAdd(h, r, c, a), I.scaleAndAdd(p, r, u, o), I.scaleAndAdd(m, r, d, l);
    const b = 0.1;
    this.arrowX.setData({
      point1: r,
      point2: h,
      coneSize: b
    }), this.arrowY.setData({
      point1: r,
      point2: p,
      coneSize: b
    }), this.arrowZ.setData({
      point1: r,
      point2: m,
      coneSize: b
    }), this.origin.source.setCenter(r), this.origin.source.setRadius(t.originRadius), this.arrowX.setDefaultColor(t.xColor), this.arrowY.setDefaultColor(t.yColor), this.arrowZ.setDefaultColor(t.zColor), this.origin.actor.getProperty().setColor(t.originColor);
  }
  getActors() {
    return [...this.arrowX.getActors(), ...this.arrowY.getActors(), ...this.arrowZ.getActors(), this.origin.actor];
  }
  delete() {
    this.arrowX.delete(), this.arrowY.delete(), this.arrowZ.delete(), this.origin.source.delete(), this.origin.mapper.delete(), this.origin.actor.delete();
  }
}
function ZN(i) {
  return Math.max(10, I.length(i) * 2);
}
function D1t(i, t) {
  const e = _J.newInstance();
  e.parseAsArrayBuffer(i);
  const n = e.getOutputData(), s = LC.newInstance();
  s.setRadius(0.05);
  const r = Re.newInstance();
  return s.setInputData(n), r.setMapper(s), r.getProperty().setColor(t.map((a) => a / 255)), {
    mapper: s,
    actor: r
  };
}
function O1t(i, t) {
  const s = _J.newInstance();
  s.parseAsArrayBuffer(i);
  const r = s.getOutputData(), a = r.getPoints(), o = a.getData(), l = I.fromValues(Number(o[0]), Number(o[1]), Number(o[2])), c = I.fromValues(Number(o[3]), Number(o[4]), Number(o[5]));
  I.normalize(c, c);
  const u = I.create();
  I.add(u, l, c), o[3] = u[0], o[4] = u[1], o[5] = u[2], a.setData(o), a.modified(), r.setPoints(a), r.modified();
  const d = FTt.newInstance(), h = We.newInstance({
    name: "orientations",
    values: new Float32Array(3),
    numberOfComponents: 3,
    numberOfTuples: 1
  });
  h.setTuple(0, c), r.getPointData().addArray(h);
  const p = We.newInstance({
    name: "scales",
    values: new Float32Array(3),
    numberOfComponents: 3,
    numberOfTuples: 1
  });
  p.setTuple(0, [10, 0.02, 1]), r.getPointData().addArray(p);
  const m = We.newInstance({
    name: "colors",
    values: new Float32Array(3),
    numberOfComponents: 3
  });
  m.setTuple(
    0,
    t.map((y) => y / 255)
  ), r.getPointData().setScalars(m), d.setColorModeToDirectScalars(), r.modified(), d.setOrientationArray("orientations"), d.setScaleArray("scales");
  const b = Re.newInstance();
  return d.setInputData(r), b.setMapper(d), b.setVisibility(!0), {
    mapper: d,
    actor: b
  };
}
function z1t(i) {
  const t = new Y1t(), e = t.getActor();
  return e.setVisibility(!1), t.setData({ ...i, color: [1, 1, 1] }), {
    actor: e,
    cleanup: () => t.delete()
  };
}
function E1t(i) {
  const t = new R1t(), e = t.getActors();
  for (const n of e)
    n.setVisibility(!1);
  return t.setData({
    ...i,
    xColor: [1, 0, 0],
    yColor: [0, 1, 0],
    zColor: [0, 0, 1],
    originColor: [1, 1, 1],
    originRadius: 0
  }), {
    actors: e,
    cleanup: () => t.delete()
  };
}
async function k1t(i, t) {
  const e = (s) => {
    const { axis_x: r, axis_y: a, axis_z: o, origin: l } = s;
    return {
      xAxis: I.fromValues(parseFloat(r.x), parseFloat(r.y), parseFloat(r.z)),
      yAxis: I.fromValues(parseFloat(a.x), parseFloat(a.y), parseFloat(a.z)),
      zAxis: I.fromValues(parseFloat(o.x), parseFloat(o.y), parseFloat(o.z)),
      origin: I.fromValues(parseFloat(l.x), parseFloat(l.y), parseFloat(l.z))
    };
  }, n = e;
  for (const s of t.constructionInfos) {
    const r = new Int8Array(s.mesh), a = (W) => [parseFloat(W.r), parseFloat(W.g), parseFloat(W.b)], o = a(s.color), l = 0.8, c = UT();
    c.implantInfo.stlFile.data = r, c.name = s.name, c.color = o, c.opacity = l;
    const u = await i.objects.setupObject(c, !1);
    i.objects.object3DInfos.update((W) => (W.push({
      id: u.id,
      name: c.name,
      visible: !0,
      position: xP(u.actor),
      handleTop: null,
      handleBottom: null,
      centerlineTop: null,
      centerlineBottom: null,
      color: c.color
    }), W));
    const d = u.id, h = [], p = [], m = [255, 255, 255];
    for (const W of s.curves) {
      const x = new Int8Array(W.points), V = W.color ? a(W.color) : m, { actor: X, mapper: C } = D1t(x, V);
      h.push(X), i.objects.addVtkObject({
        mapper: C,
        actor: X,
        objectType: Yt._WEBLINK_CURVE
      }), i.onObjectsModified.notify();
    }
    for (const W of s.axes) {
      const x = new Int8Array(W.points), V = W.color ? a(W.color) : m, { actor: X, mapper: C } = O1t(x, V);
      p.push(X), i.objects.addVtkObject({
        mapper: C,
        actor: X,
        objectType: Yt._WEBLINK_AXIS
      }), i.onObjectsModified.notify();
    }
    let b = null, y = null;
    if (s.boundingBox) {
      y = e(s.boundingBox), i.reconstructionBoundingBoxes.set(u.actor, y);
      const { actor: W, cleanup: x } = z1t(y);
      b = W, i.objects.onCleanup(x), i.onObjectsModified.notify(), i.onActorAdded.notify({ actor: W, objectType: Yt._WEBLINK_BOUNDING_BOX });
    }
    const Z = [];
    if (s.coordinateSystem) {
      const W = n(s.coordinateSystem);
      i.reconstructionCoordinateSystems.set(u.actor, W);
      let x = 10, V = 10, X = 10;
      y && (x = ZN(y.xAxis), V = ZN(y.yAxis), X = ZN(y.zAxis));
      const { actors: C, cleanup: R } = E1t({ ...W, xLength: x, yLength: V, zLength: X });
      Z.push(...C), i.objects.onCleanup(R), i.onObjectsModified.notify(), i.onActorAdded.notify({ actor: C[0], objectType: Yt._WEBLINK_COORDINATE_SYSTEM });
    }
    const g = new qt(!0), f = new qt(o), T = new qt(l), M = new qt(!1), N = new qt(!1);
    i.objects.watch(g, (W) => {
      i.objects.object3DInfos.update((x) => {
        for (const V of x)
          V.id === u.id && (V.visible = W);
        return x;
      });
    }), i.objects.watch(f, (W) => {
      i.objects.object3DInfos.update((x) => {
        for (const V of x)
          V.id === u.id && (V.color = W);
        return x;
      });
    }), i.objects.object3DInfos.update((W) => {
      for (const x of W)
        x.id === u.id && (x.color = o);
      return W;
    }), i.constructionInfos.set(
      d,
      new X3({
        stlActor: u.actor,
        curveActors: h,
        axisActors: p,
        boundingBoxActor: b,
        coordinateSystemActors: Z,
        model: {
          visibility: g,
          stlColor: f,
          stlOpacity: T,
          boundingBoxVisibility: M,
          coordinateSystemVisibility: N
        }
      })
    );
  }
}
class F1t {
  constructor() {
    S(this, "mapper", Ue.newInstance());
    S(this, "data", Ie.newInstance());
    S(this, "actor", Re.newInstance());
    S(this, "points", yi.newInstance());
    S(this, "lines", Ii.newInstance());
    this.mapper.setInputData(this.data), this.actor.setMapper(this.mapper), this.data.setPoints(this.points), this.data.setLines(this.lines), this.actor.setVisibility(!0), this.actor.setPickable(!1);
  }
  setData(t) {
    const e = I.create();
    I.normalize(e, t.dir1);
    const n = I.create();
    I.normalize(n, t.dir2);
    const s = 200, r = ps.create();
    ps.rotationTo(r, e, n);
    const a = new Float32Array(s * 3), o = new Uint16Array(s + 1), l = I.create(), c = ps.create();
    for (let u = 0; u < s; u++) {
      const d = u / (s - 1);
      ps.scale(c, r, d), I.copy(l, e), I.transformQuat(l, l, c), I.normalize(l, l), I.scale(l, l, t.radius), I.add(l, l, t.origin), a[3 * u] = l[0], a[3 * u + 1] = l[1], a[3 * u + 2] = l[2], o[u + 1] = u;
    }
    o[0] = s, this.points.setData(a, 3), this.lines.setData(o), this.actor.getProperty().setColor(t.color), this.data.modified();
  }
  getActor() {
    return this.actor;
  }
  delete() {
    this.points.delete(), this.lines.delete(), this.data.delete(), this.mapper.delete(), this.actor.delete();
  }
}
function j1t(i, t) {
  t.classHierarchy.push("vtkPriorityQueue"), i.push = (e, n) => {
    const s = t.elements.findIndex((r) => r.priority > e);
    t.elements.splice(s, 0, {
      priority: e,
      element: n
    });
  }, i.pop = () => t.elements.length > 0 ? t.elements.shift().element : null, i.deleteById = (e) => {
    t.elements = t.elements.filter((n) => {
      let {
        element: s
      } = n;
      return s.id !== e;
    });
  }, i.length = () => t.elements.length;
}
const U1t = {
  elements: []
};
function QJ(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, U1t, e), tt.obj(i, t), j1t(i, t);
}
const P1t = tt.newInstance(QJ, "vtkPriorityQueue");
var J1t = {
  newInstance: P1t,
  extend: QJ
};
const XM = 1e-6, mz = 11920929e-14, A1t = 1e-8, Lp = {
  FAILURE: -1,
  OUTSIDE: 0,
  INSIDE: 1,
  INTERSECTION: 2,
  ON_LINE: 3
};
function bz(i, t, e, n, s) {
  return (n[i] - e[i]) * (s[t] - e[t]) - (s[i] - e[i]) * (n[t] - e[t]);
}
function B1t(i, t, e, n) {
  if (i[0] < e[0] || i[0] > e[1] || i[1] < e[2] || i[1] > e[3] || i[2] < e[4] || i[2] > e[5])
    return Lp.OUTSIDE;
  if (Fn(n) <= mz)
    return Lp.FAILURE;
  let s = A1t * ((e[1] - e[0]) * (e[1] - e[0]) + (e[3] - e[2]) * (e[3] - e[2]) + (e[5] - e[4]) * (e[5] - e[4]));
  s *= s, s = s === 0 ? mz : s;
  const r = [], a = [];
  for (let u = 0; u < t.length; ) {
    if (r[0] = t[u++], r[1] = t[u++], r[2] = t[u++], zs(i, r) <= s)
      return Lp.INSIDE;
    const {
      distance: d,
      t: h
    } = Vr.distanceToLine(i, r, a);
    if (d <= s && h > 0 && h < 1)
      return Lp.INSIDE;
  }
  let o, l;
  Math.abs(n[0]) > Math.abs(n[1]) ? Math.abs(n[0]) > Math.abs(n[2]) ? (o = 1, l = 2) : (o = 0, l = 1) : Math.abs(n[1]) > Math.abs(n[2]) ? (o = 0, l = 2) : (o = 0, l = 1);
  let c = 0;
  for (let u = 0; u < t.length; )
    r[0] = t[u++], r[1] = t[u++], r[2] = t[u++], u < t.length ? (a[0] = t[u], a[1] = t[u + 1], a[2] = t[u + 2]) : (a[0] = t[0], a[1] = t[1], a[2] = t[2]), r[l] <= i[l] ? a[l] > i[l] && bz(o, l, r, a, i) > 0 && ++c : a[l] <= i[l] && bz(o, l, r, a, i) < 0 && --c;
  return c === 0 ? Lp.OUTSIDE : Lp.INSIDE;
}
function K1t(i, t, e) {
  const n = i.length, s = [];
  t.getPoint(i[0], s), e[0] = s[0], e[1] = s[0], e[2] = s[1], e[3] = s[1], e[4] = s[2], e[5] = s[2];
  for (let a = 1; a < n; a++)
    t.getPoint(i[a], s), qe.addPoint(e, ...s);
  const r = qe.getLengths(e);
  return tn(r, r);
}
function H1t(i, t, e) {
  e.length = 3, e[0] = 0, e[1] = 0, e[2] = 0;
  const n = [];
  let s = [], r = [];
  const a = [], o = [];
  t.getPoint(i[0], n), t.getPoint(i[1], s);
  for (let l = 2; l < i.length; l++) {
    t.getPoint(i[l], r), fi(r, s, a), fi(n, s, o);
    const c = [0, 0, 0];
    Wi(a, o, c), b0(e, c, e), [s, r] = [r, s];
  }
  return Fn(e);
}
const _1t = {
  PolygonWithPointIntersectionState: Lp,
  pointInPolygon: B1t,
  getBounds: K1t,
  getNormal: H1t
};
function Q1t(i, t) {
  t.classHierarchy.push("vtkPolygon");
  function e() {
    const o = [0, 0, 0], l = [0, 0, 0];
    t.normal = [0, 0, 0];
    const c = [...t.firstPoint.point];
    let u = t.firstPoint;
    for (let d = 0; d < t.pointCount; d++) {
      fi(u.point, c, o), fi(u.next.point, c, l);
      const h = [0, 0, 0];
      Wi(o, l, h), b0(t.normal, h, t.normal), u = u.next;
    }
    return Fn(t.normal);
  }
  function n(o) {
    const l = [0, 0, 0], c = [0, 0, 0], u = [0, 0, 0], d = [0, 0, 0];
    fi(o.point, o.previous.point, l), fi(o.next.point, o.point, c), fi(o.previous.point, o.next.point, u), Wi(l, c, d);
    const h = tn(d, t.normal);
    if (h <= 0)
      return -1;
    const p = Or(l) + Or(c) + Or(u);
    return p * p / h;
  }
  function s(o) {
    if (t.pointCount <= 3)
      return !0;
    const l = o.previous, c = o.next, u = [0, 0, 0];
    fi(c.point, l.point, u);
    const d = [0, 0, 0];
    if (Wi(u, t.normal, d), Fn(d), Or(d) === 0)
      return !1;
    let h = li.evaluate(d, l.point, c.next.point), p = h > XM ? 1 : h < -XM ? -1 : 0, m = p < 0 ? 1 : 0;
    for (let b = c.next.next; b.id !== l.id; b = b.next) {
      const y = b.previous;
      h = li.evaluate(d, l.point, b.point);
      const Z = h > XM ? 1 : h < -XM ? -1 : 0;
      if (Z !== p) {
        if (m || (m = Z <= 0 ? 1 : 0), Vr.intersection(l.point, c.point, b.point, y.point, [0], [0]) === e9.YES_INTERSECTION)
          return !1;
        p = Z;
      }
    }
    return m === 1;
  }
  function r(o, l) {
    t.pointCount -= 1;
    const c = o.previous, u = o.next;
    t.tris = t.tris.concat(o.point), t.tris = t.tris.concat(u.point), t.tris = t.tris.concat(c.point), c.next = u, u.previous = c, l.deleteById(c.id), l.deleteById(u.id);
    const d = n(c);
    d > 0 && l.push(d, c);
    const h = n(u);
    h > 0 && l.push(h, u), o.id === t.firstPoint.id && (t.firstPoint = u);
  }
  function a() {
    e();
    const o = J1t.newInstance();
    let l = t.firstPoint;
    for (let c = 0; c < t.pointCount; c++) {
      const u = n(l);
      u > 0 && o.push(u, l), l = l.next;
    }
    for (; t.pointCount > 2 && o.length() > 0; )
      if (t.pointCount === o.length()) {
        const c = o.pop();
        r(c, o);
      } else {
        const c = o.pop();
        s(c) && r(c, o);
      }
    return t.pointCount <= 2;
  }
  i.triangulate = () => t.firstPoint ? a() : null, i.setPoints = (o) => {
    t.pointCount = o.length, t.firstPoint = {
      id: 0,
      point: o[0],
      next: null,
      previous: null
    };
    let l = t.firstPoint;
    for (let c = 1; c < t.pointCount; c++)
      l.next = {
        id: c,
        point: o[c],
        next: null,
        previous: l
      }, l = l.next;
    t.firstPoint.previous = l, l.next = t.firstPoint;
  }, i.getPointArray = () => t.tris;
}
const $1t = {
  firstPoint: null,
  pointCount: 0,
  tris: []
};
function $J(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, $1t, e), tt.obj(i, t), Q1t(i, t);
}
const q1t = tt.newInstance($J, "vtkPolygon");
var tMt = {
  newInstance: q1t,
  extend: $J,
  ..._1t
};
const {
  vtkWarningMacro: eMt
} = tt;
function nMt(i, t) {
  t.classHierarchy.push("vtkTriangleFilter"), i.requestData = (e, n) => {
    const s = e[0], r = s.getPoints().getData(), a = s.getPolys().getData(), o = s.getPolys().getDataType(), l = s.getPoints().getDataType(), c = [], u = [];
    if (t.errorCount = 0, a) {
      let h = 0, p = !1;
      for (let m = 0; m < a.length; m += h + 1) {
        h = a[m], p = a[m + 1] === a[m + h], p && --h;
        const b = [];
        b.length = h;
        for (let y = 0; y < h; y++) {
          const Z = a[m + y + 1];
          b[y] = [r[3 * Z], r[3 * Z + 1], r[3 * Z + 2]];
        }
        if (h === 3) {
          const y = u.length / 3;
          c.push(3, y, y + 1, y + 2), u.push(...b[0], ...b[1], ...b[2]);
        } else if (h > 3) {
          const y = tMt.newInstance();
          y.setPoints(b), y.triangulate() || (eMt(`Triangulation failed at cellOffset ${m}`), ++t.errorCount);
          const Z = y.getPointArray(), g = Math.floor(Z.length / 9), f = [];
          f.length = 9;
          for (let T = 0; T < g; T++) {
            for (let N = 0; N < 9; N++)
              f[N] = Z[9 * T + N];
            const M = u.length / 3;
            c.push(3, M, M + 1, M + 2), u.push(...f);
          }
        }
        p && ++h;
      }
    }
    const d = Ie.newInstance();
    d.getPoints().setData(tt.newTypedArrayFrom(l, u)), d.getPolys().setData(tt.newTypedArrayFrom(o, c)), n[0] = d;
  };
}
const iMt = {
  errorCount: 0
};
function qJ(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, iMt, e), tt.setGet(i, t, []), tt.get(i, t, ["errorCount"]), tt.obj(i, t), tt.algo(i, t, 1, 1), nMt(i, t);
}
const sMt = tt.newInstance(qJ, "vtkTriangleFilter");
var rMt = {
  newInstance: sMt,
  extend: qJ
};
function aMt(i, t, e = 2) {
  const n = t && t.length, s = n ? t[0] * e : i.length;
  let r = tA(i, 0, s, e, !0);
  const a = [];
  if (!r || r.next === r.prev) return a;
  let o, l, c;
  if (n && (r = dMt(i, t, r, e)), i.length > 80 * e) {
    o = i[0], l = i[1];
    let u = o, d = l;
    for (let h = e; h < s; h += e) {
      const p = i[h], m = i[h + 1];
      p < o && (o = p), m < l && (l = m), p > u && (u = p), m > d && (d = m);
    }
    c = Math.max(u - o, d - l), c = c !== 0 ? 32767 / c : 0;
  }
  return X2(r, a, e, o, l, c, 0), a;
}
function tA(i, t, e, n, s) {
  let r;
  if (s === NMt(i, t, e, n) > 0)
    for (let a = t; a < e; a += n) r = fz(a / n | 0, i[a], i[a + 1], r);
  else
    for (let a = e - n; a >= t; a -= n) r = fz(a / n | 0, i[a], i[a + 1], r);
  return r && Tg(r, r.next) && (C2(r), r = r.next), r;
}
function M0(i, t) {
  if (!i) return i;
  t || (t = i);
  let e = i, n;
  do
    if (n = !1, !e.steiner && (Tg(e, e.next) || ss(e.prev, e, e.next) === 0)) {
      if (C2(e), e = t = e.prev, e === e.next) break;
      n = !0;
    } else
      e = e.next;
  while (n || e !== t);
  return t;
}
function X2(i, t, e, n, s, r, a) {
  if (!i) return;
  !a && r && fMt(i, n, s, r);
  let o = i;
  for (; i.prev !== i.next; ) {
    const l = i.prev, c = i.next;
    if (r ? lMt(i, n, s, r) : oMt(i)) {
      t.push(l.i, i.i, c.i), C2(i), i = c.next, o = c.next;
      continue;
    }
    if (i = c, i === o) {
      a ? a === 1 ? (i = cMt(M0(i), t), X2(i, t, e, n, s, r, 2)) : a === 2 && uMt(i, t, e, n, s, r) : X2(M0(i), t, e, n, s, r, 1);
      break;
    }
  }
}
function oMt(i) {
  const t = i.prev, e = i, n = i.next;
  if (ss(t, e, n) >= 0) return !1;
  const s = t.x, r = e.x, a = n.x, o = t.y, l = e.y, c = n.y, u = Math.min(s, r, a), d = Math.min(o, l, c), h = Math.max(s, r, a), p = Math.max(o, l, c);
  let m = n.next;
  for (; m !== t; ) {
    if (m.x >= u && m.x <= h && m.y >= d && m.y <= p && Ly(s, o, r, l, a, c, m.x, m.y) && ss(m.prev, m, m.next) >= 0) return !1;
    m = m.next;
  }
  return !0;
}
function lMt(i, t, e, n) {
  const s = i.prev, r = i, a = i.next;
  if (ss(s, r, a) >= 0) return !1;
  const o = s.x, l = r.x, c = a.x, u = s.y, d = r.y, h = a.y, p = Math.min(o, l, c), m = Math.min(u, d, h), b = Math.max(o, l, c), y = Math.max(u, d, h), Z = sV(p, m, t, e, n), g = sV(b, y, t, e, n);
  let f = i.prevZ, T = i.nextZ;
  for (; f && f.z >= Z && T && T.z <= g; ) {
    if (f.x >= p && f.x <= b && f.y >= m && f.y <= y && f !== s && f !== a && Ly(o, u, l, d, c, h, f.x, f.y) && ss(f.prev, f, f.next) >= 0 || (f = f.prevZ, T.x >= p && T.x <= b && T.y >= m && T.y <= y && T !== s && T !== a && Ly(o, u, l, d, c, h, T.x, T.y) && ss(T.prev, T, T.next) >= 0)) return !1;
    T = T.nextZ;
  }
  for (; f && f.z >= Z; ) {
    if (f.x >= p && f.x <= b && f.y >= m && f.y <= y && f !== s && f !== a && Ly(o, u, l, d, c, h, f.x, f.y) && ss(f.prev, f, f.next) >= 0) return !1;
    f = f.prevZ;
  }
  for (; T && T.z <= g; ) {
    if (T.x >= p && T.x <= b && T.y >= m && T.y <= y && T !== s && T !== a && Ly(o, u, l, d, c, h, T.x, T.y) && ss(T.prev, T, T.next) >= 0) return !1;
    T = T.nextZ;
  }
  return !0;
}
function cMt(i, t) {
  let e = i;
  do {
    const n = e.prev, s = e.next.next;
    !Tg(n, s) && nA(n, e, e.next, s) && I2(n, s) && I2(s, n) && (t.push(n.i, e.i, s.i), C2(e), C2(e.next), e = i = s), e = e.next;
  } while (e !== i);
  return M0(e);
}
function uMt(i, t, e, n, s, r) {
  let a = i;
  do {
    let o = a.next.next;
    for (; o !== a.prev; ) {
      if (a.i !== o.i && ZMt(a, o)) {
        let l = iA(a, o);
        a = M0(a, a.next), l = M0(l, l.next), X2(a, t, e, n, s, r, 0), X2(l, t, e, n, s, r, 0);
        return;
      }
      o = o.next;
    }
    a = a.next;
  } while (a !== i);
}
function dMt(i, t, e, n) {
  const s = [];
  for (let r = 0, a = t.length; r < a; r++) {
    const o = t[r] * n, l = r < a - 1 ? t[r + 1] * n : i.length, c = tA(i, o, l, n, !1);
    c === c.next && (c.steiner = !0), s.push(yMt(c));
  }
  s.sort(hMt);
  for (let r = 0; r < s.length; r++)
    e = pMt(s[r], e);
  return e;
}
function hMt(i, t) {
  let e = i.x - t.x;
  if (e === 0 && (e = i.y - t.y, e === 0)) {
    const n = (i.next.y - i.y) / (i.next.x - i.x), s = (t.next.y - t.y) / (t.next.x - t.x);
    e = n - s;
  }
  return e;
}
function pMt(i, t) {
  const e = mMt(i, t);
  if (!e)
    return t;
  const n = iA(e, i);
  return M0(n, n.next), M0(e, e.next);
}
function mMt(i, t) {
  let e = t;
  const n = i.x, s = i.y;
  let r = -1 / 0, a;
  if (Tg(i, e)) return e;
  do {
    if (Tg(i, e.next)) return e.next;
    if (s <= e.y && s >= e.next.y && e.next.y !== e.y) {
      const d = e.x + (s - e.y) * (e.next.x - e.x) / (e.next.y - e.y);
      if (d <= n && d > r && (r = d, a = e.x < e.next.x ? e : e.next, d === n))
        return a;
    }
    e = e.next;
  } while (e !== t);
  if (!a) return null;
  const o = a, l = a.x, c = a.y;
  let u = 1 / 0;
  e = a;
  do {
    if (n >= e.x && e.x >= l && n !== e.x && eA(s < c ? n : r, s, l, c, s < c ? r : n, s, e.x, e.y)) {
      const d = Math.abs(s - e.y) / (n - e.x);
      I2(e, i) && (d < u || d === u && (e.x > a.x || e.x === a.x && bMt(a, e))) && (a = e, u = d);
    }
    e = e.next;
  } while (e !== o);
  return a;
}
function bMt(i, t) {
  return ss(i.prev, i, t.prev) < 0 && ss(t.next, i, i.next) < 0;
}
function fMt(i, t, e, n) {
  let s = i;
  do
    s.z === 0 && (s.z = sV(s.x, s.y, t, e, n)), s.prevZ = s.prev, s.nextZ = s.next, s = s.next;
  while (s !== i);
  s.prevZ.nextZ = null, s.prevZ = null, gMt(s);
}
function gMt(i) {
  let t, e = 1;
  do {
    let n = i, s;
    i = null;
    let r = null;
    for (t = 0; n; ) {
      t++;
      let a = n, o = 0;
      for (let c = 0; c < e && (o++, a = a.nextZ, !!a); c++)
        ;
      let l = e;
      for (; o > 0 || l > 0 && a; )
        o !== 0 && (l === 0 || !a || n.z <= a.z) ? (s = n, n = n.nextZ, o--) : (s = a, a = a.nextZ, l--), r ? r.nextZ = s : i = s, s.prevZ = r, r = s;
      n = a;
    }
    r.nextZ = null, e *= 2;
  } while (t > 1);
  return i;
}
function sV(i, t, e, n, s) {
  return i = (i - e) * s | 0, t = (t - n) * s | 0, i = (i | i << 8) & 16711935, i = (i | i << 4) & 252645135, i = (i | i << 2) & 858993459, i = (i | i << 1) & 1431655765, t = (t | t << 8) & 16711935, t = (t | t << 4) & 252645135, t = (t | t << 2) & 858993459, t = (t | t << 1) & 1431655765, i | t << 1;
}
function yMt(i) {
  let t = i, e = i;
  do
    (t.x < e.x || t.x === e.x && t.y < e.y) && (e = t), t = t.next;
  while (t !== i);
  return e;
}
function eA(i, t, e, n, s, r, a, o) {
  return (s - a) * (t - o) >= (i - a) * (r - o) && (i - a) * (n - o) >= (e - a) * (t - o) && (e - a) * (r - o) >= (s - a) * (n - o);
}
function Ly(i, t, e, n, s, r, a, o) {
  return !(i === a && t === o) && eA(i, t, e, n, s, r, a, o);
}
function ZMt(i, t) {
  return i.next.i !== t.i && i.prev.i !== t.i && !TMt(i, t) && // doesn't intersect other edges
  (I2(i, t) && I2(t, i) && MMt(i, t) && // locally visible
  (ss(i.prev, i, t.prev) || ss(i, t.prev, t)) || // does not create opposite-facing sectors
  Tg(i, t) && ss(i.prev, i, i.next) > 0 && ss(t.prev, t, t.next) > 0);
}
function ss(i, t, e) {
  return (t.y - i.y) * (e.x - t.x) - (t.x - i.x) * (e.y - t.y);
}
function Tg(i, t) {
  return i.x === t.x && i.y === t.y;
}
function nA(i, t, e, n) {
  const s = CM(ss(i, t, e)), r = CM(ss(i, t, n)), a = CM(ss(e, n, i)), o = CM(ss(e, n, t));
  return !!(s !== r && a !== o || s === 0 && IM(i, e, t) || r === 0 && IM(i, n, t) || a === 0 && IM(e, i, n) || o === 0 && IM(e, t, n));
}
function IM(i, t, e) {
  return t.x <= Math.max(i.x, e.x) && t.x >= Math.min(i.x, e.x) && t.y <= Math.max(i.y, e.y) && t.y >= Math.min(i.y, e.y);
}
function CM(i) {
  return i > 0 ? 1 : i < 0 ? -1 : 0;
}
function TMt(i, t) {
  let e = i;
  do {
    if (e.i !== i.i && e.next.i !== i.i && e.i !== t.i && e.next.i !== t.i && nA(e, e.next, i, t)) return !0;
    e = e.next;
  } while (e !== i);
  return !1;
}
function I2(i, t) {
  return ss(i.prev, i, i.next) < 0 ? ss(i, t, i.next) >= 0 && ss(i, i.prev, t) >= 0 : ss(i, t, i.prev) < 0 || ss(i, i.next, t) < 0;
}
function MMt(i, t) {
  let e = i, n = !1;
  const s = (i.x + t.x) / 2, r = (i.y + t.y) / 2;
  do
    e.y > r != e.next.y > r && e.next.y !== e.y && s < (e.next.x - e.x) * (r - e.y) / (e.next.y - e.y) + e.x && (n = !n), e = e.next;
  while (e !== i);
  return n;
}
function iA(i, t) {
  const e = rV(i.i, i.x, i.y), n = rV(t.i, t.x, t.y), s = i.next, r = t.prev;
  return i.next = t, t.prev = i, e.next = s, s.prev = e, n.next = e, e.prev = n, r.next = n, n.prev = r, n;
}
function fz(i, t, e, n) {
  const s = rV(i, t, e);
  return n ? (s.next = n.next, s.prev = n, n.next.prev = s, n.next = s) : (s.prev = s, s.next = s), s;
}
function C2(i) {
  i.next.prev = i.prev, i.prev.next = i.next, i.prevZ && (i.prevZ.nextZ = i.nextZ), i.nextZ && (i.nextZ.prevZ = i.prevZ);
}
function rV(i, t, e) {
  return {
    i,
    // vertex index in coordinates array
    x: t,
    y: e,
    // vertex coordinates
    prev: null,
    // previous and next vertex nodes in a polygon ring
    next: null,
    z: 0,
    // z-order curve value
    prevZ: null,
    // previous and next nodes in z-order
    nextZ: null,
    steiner: !1
    // indicates whether this is a steiner point
  };
}
function NMt(i, t, e, n) {
  let s = 0;
  for (let r = t, a = e - n; r < e; r += n)
    s += (i[a] - i[r]) * (i[r + 1] + i[a + 1]), a = r;
  return s;
}
const gl = {
  FAILURE: -1,
  OUTSIDE: 0,
  INSIDE: 1
}, WMt = 1e-6, GMt = 11920929e-14, wMt = 1e-8;
class CC {
  constructor() {
    S(this, "mapper", Ue.newInstance());
    S(this, "mapper2", Ue.newInstance());
    S(this, "actor2", Re.newInstance());
    S(this, "actor", Re.newInstance());
    S(this, "data", Ie.newInstance());
    S(this, "data2", Ie.newInstance());
    S(this, "points", yi.newInstance());
    S(this, "lines", Ii.newInstance());
    S(this, "polys", Ii.newInstance());
    S(this, "closedPolyLine", !0);
    S(this, "isInverted", !1);
    this.mapper.setInputData(this.data), this.actor.setMapper(this.mapper), this.data.setPoints(this.points), this.data.setLines(this.lines), this.data2.setPoints(this.points), this.data2.setLines(this.lines), this.data2.setPolys(this.polys);
    const t = rMt.newInstance();
    this.mapper2 = Ue.newInstance(), this.actor2 = Re.newInstance(), t.setInputData(this.data2), this.mapper2.setInputConnection(t.getOutputPort()), this.actor2.setMapper(this.mapper2), this.data.modified(), this.data2.modified(), this.actor.setVisibility(!0), this.actor.setPickable(!1), this.actor2.setPickable(!1);
  }
  setData(t) {
    this.isInverted = t.invert || !1;
    const e = t.points.length, n = new Float32Array(e * 3), s = new Uint16Array(e + 1 + 1), r = new Uint16Array(e + 1);
    for (let a = 0; a < e; a++) {
      const o = t.points[a];
      n[3 * a] = o[0], n[3 * a + 1] = o[1], n[3 * a + 2] = o[2], s[a + 1] = a, r[a + 1] = e - 1 - a;
    }
    if (this.closedPolyLine && (s[e + 1] = 0), r[0] = e, s[0] = e + 1, this.points.setData(n, 3), this.lines.setData(s), !t.invert)
      this.polys.setData(r);
    else if (e >= 3) {
      const o = t.points[0], l = t.points[1], c = t.points[2], u = I.sub(I.create(), l, o), d = I.sub(I.create(), c, o), h = I.normalize(I.create(), I.cross(I.create(), u, d)), p = I.normalize(I.create(), u), m = I.cross(I.create(), h, p), b = t.points.map((j) => {
        const H = I.sub(I.create(), j, o);
        return [I.dot(H, p), I.dot(H, m)];
      });
      let y = 1 / 0, Z = 1 / 0, g = -1 / 0, f = -1 / 0;
      for (const [j, H] of b)
        j < y && (y = j), H < Z && (Z = H), j > g && (g = j), H > f && (f = H);
      const T = 200;
      y -= T, Z -= T, g += T, f += T;
      const M = [
        [y, Z],
        [g, Z],
        [g, f],
        [y, f]
      ];
      ((j) => j.reduce((H, B, $) => {
        const A = j[($ + 1) % j.length];
        return H + (B[0] * A[1] - A[0] * B[1]);
      }, 0))(b) > 0 && b.reverse();
      const W = [];
      for (const [j, H] of M) W.push(j, H);
      for (const [j, H] of b) W.push(j, H);
      const x = [M.length], V = aMt(W, x, 2), X = [...M, ...b].map(([j, H]) => {
        const B = I.scaleAndAdd(I.create(), o, p, j);
        return I.scaleAndAdd(B, B, m, H), [B[0], B[1], B[2]];
      }), C = V.length / 3, R = new Uint16Array(C * 4);
      for (let j = 0; j < C; j++)
        R[4 * j + 0] = 3, R[4 * j + 1] = V[3 * j + 0], R[4 * j + 2] = V[3 * j + 1], R[4 * j + 3] = V[3 * j + 2];
      const z = new Float32Array(X.flat());
      this.points.setData(z, 3);
      const F = M.length, P = new Uint16Array(e + 1 + 1);
      P[0] = e + 1;
      for (let j = 0; j < e; j++)
        P[j + 1] = F + j;
      this.closedPolyLine && (P[e + 1] = F), this.lines.setData(P), this.polys.setData(R);
    } else
      this.polys.setData([]);
    this.actor.getProperty().setColor(t.color), this.actor.getProperty().setEdgeVisibility(!0), this.actor.getProperty().setOpacity(t.lineOpacity ? t.lineOpacity : 0), this.actor2.getProperty().setOpacity(0.25), this.actor2.getProperty().setColor(t.color), this.polys.modified(), this.data.modified(), this.data2.modified();
  }
  pointInPolygon(t, e, n, s) {
    if (t[0] < n[0] || t[0] > n[1] || t[1] < n[2] || t[1] > n[3] || t[2] < n[4] || t[2] > n[5])
      return gl.OUTSIDE;
    if (I.len(s) <= WMt)
      return gl.FAILURE;
    let r = wMt * ((n[1] - n[0]) * (n[1] - n[0]) + (n[3] - n[2]) * (n[3] - n[2]) + (n[5] - n[4]) * (n[5] - n[4]));
    r *= r, r = r === 0 ? GMt : r;
    const a = [0, 0, 0], o = [0, 0, 0];
    for (let h = 0; h < e.length; ) {
      if (a[0] = e[h++], a[1] = e[h++], a[2] = e[h++], Hn.distance2BetweenPoints(t, a) <= r)
        return gl.INSIDE;
      o[0] = e[h], o[1] = e[h + 1], o[2] = e[h + 2];
      const { distance: p, t: m } = Vr.distanceToLine(t, a, o);
      if (p <= r && m > 0 && m < 1)
        return gl.INSIDE;
    }
    let l, c;
    Math.abs(s[0]) > Math.abs(s[1]) ? Math.abs(s[0]) > Math.abs(s[2]) ? (l = 1, c = 2) : (l = 0, c = 1) : Math.abs(s[1]) > Math.abs(s[2]) ? (l = 0, c = 2) : (l = 0, c = 1);
    let u = 0;
    for (let h = 0; h < e.length; )
      a[0] = e[h++], a[1] = e[h++], a[2] = e[h++], h < e.length ? (o[0] = e[h], o[1] = e[h + 1], o[2] = e[h + 2]) : (o[0] = e[0], o[1] = e[1], o[2] = e[2]), a[c] <= t[c] ? o[c] > t[c] && this.pointLocation(l, c, a, o, t) > 0 && ++u : o[c] <= t[c] && this.pointLocation(l, c, a, o, t) < 0 && --u;
    const d = u !== 0;
    return this.isInverted ? d ? gl.OUTSIDE : gl.INSIDE : d ? gl.INSIDE : gl.OUTSIDE;
  }
  pointLocation(t, e, n, s, r) {
    return (s[t] - n[t]) * (r[e] - n[e]) - (r[t] - n[t]) * (s[e] - n[e]);
  }
  getActor() {
    return this.actor;
  }
  getMapper() {
    return this.mapper;
  }
  getActor2() {
    return this.actor2;
  }
  getMapper2() {
    return this.mapper2;
  }
  delete() {
    this.points.delete(), this.lines.delete(), this.data.delete(), this.data2.delete(), this.mapper.delete(), this.mapper2.delete(), this.actor.delete(), this.actor2.delete();
  }
}
class sA extends Ja {
  constructor(e) {
    super();
    S(this, "pickedPointsShifted", new se());
    S(this, "pointAddedEvent", new se());
    S(this, "pointMovedEvent", new se());
    S(this, "removeLastPointEvent", new se());
    S(this, "rerenderPoints", new se());
    S(this, "pointsArray", []);
    S(this, "colorsArray", []);
    S(this, "scaleArray", []);
    S(this, "context");
    S(this, "leftDown");
    S(this, "reactivity", An());
    S(this, "onEvent", this.reactivity.onEvent);
    S(this, "flag", !0);
    S(this, "actorOnHover", null);
    S(this, "pointIndex", -1);
    S(this, "pointAddedFlag", !1);
    S(this, "addPointThreshold", 5);
    // adjust if needed
    S(this, "color", [1, 0, 1]);
    this.context = e, this.leftDown = !1, this.onEvent(this.pickedPointsShifted, (n) => {
      this.pointsArray.length = 0, this.colorsArray.length = 0, this.scaleArray.length = 0, n.forEach((s) => {
        this.pointsArray.push(...s);
      }), this.pointAddedEvent.notify();
    }), this.onEvent(this.removeLastPointEvent, () => {
      this.pointsArray.splice(-3, 3), this.colorsArray.splice(-3, 3), this.scaleArray.splice(-1, 1);
    });
  }
  onLeftPress(e, n) {
    if (this.pointAddedFlag = !1, this.leftDown = !0, this.pointIndex != -1)
      return !1;
    if (e.isViewMode3D()) {
      const s = e.pickWorldPoint(n.position.x, n.position.y);
      return this.pointsArray.push(...s), this.scaleArray.push(1), this.colorsArray.push(...this.color), this.pointAddedEvent.notify(), !0;
    }
    return !1;
  }
  onLeftRelease() {
    return this.leftDown = !1, !1;
  }
  onRightPress() {
    return this.removeLastPointEvent.notify(), this.pointAddedEvent.notify(), !1;
  }
  onMouseWheel() {
    return !1;
  }
  onMouseMove(e, n) {
    if (!this.leftDown) {
      this.actorOnHover && (console.log("closestIndex,", this.pointIndex), this.pointIndex >= 0 && this.pointIndex < this.pointsArray.length / 3 && (this.setPointColor(this.pointIndex, [1, 0, 1]), this.rerenderPoints.notify()), this.pointIndex = -1, this.context.repaint(), this.actorOnHover = null);
      const s = e.pickPropPoint(n.position.x, n.position.y, 1);
      if (s) {
        this.actorOnHover = s[0].getActors()[0];
        const r = s[1], a = this.getClosestPointIndex(r);
        a != null && (console.log("closestIndex,", a), this.pointIndex = a, this.setPointColor(a, [0, 1, 0]), this.rerenderPoints.notify()), this.context.repaint();
      }
      return !1;
    }
    if (this.leftDown && this.actorOnHover)
      if (this.pointIndex != -1) {
        const s = e.pickWorldPoint(n.position.x, n.position.y);
        return e.isViewMode3D() && (this.setPointPosition(this.pointIndex, s), this.rerenderPoints.notify()), this.pointMovedEvent.notify(), !0;
      } else
        return !1;
    else if (this.leftDown && !this.actorOnHover) {
      if (e.isViewMode3D()) {
        const s = e.pickWorldPoint(n.position.x, n.position.y);
        if (this.pointsArray.length >= 3) {
          const r = I.fromValues(
            this.pointsArray[this.pointsArray.length - 3],
            this.pointsArray[this.pointsArray.length - 2],
            this.pointsArray[this.pointsArray.length - 1]
          ), a = I.sqrDist(r, s), o = this.addPointThreshold * this.addPointThreshold;
          if (a > o)
            return this.addPoint(s), !0;
        } else
          return this.addPoint(s), !0;
      }
      return !1;
    } else
      return !1;
  }
  getPickedPoints() {
    return this.pointsArray;
  }
  getPickedPointsV() {
    const e = [];
    for (let n = 0; n < this.pointsArray.length / 3; n++)
      e.push(I.fromValues(this.pointsArray[3 * n], this.pointsArray[3 * n + 1], this.pointsArray[3 * n + 2]));
    return e;
  }
  addPoint(e, n = 1, s = this.color) {
    this.pointsArray.push(...e), this.scaleArray.push(n), this.colorsArray.push(...s), this.pointAddedEvent.notify();
  }
  delete() {
    this.flag = !0, this.reactivity.cleanupAll();
  }
  insertPointAtIndex(e, n, s = 1, r = [1, 0, 1]) {
    for (let a = this.pointsArray.length / 3 - 1; a > n - 1; a--) {
      const o = [this.pointsArray[a * 3], this.pointsArray[a * 3 + 1], this.pointsArray[a * 3 + 2]];
      this.pointsArray[(a + 1) * 3] = o[0], this.pointsArray[(a + 1) * 3 + 1] = o[1], this.pointsArray[(a + 1) * 3 + 2] = o[2];
      const l = [this.colorsArray[a * 3], this.colorsArray[a * 3 + 1], this.colorsArray[a * 3 + 2]];
      this.colorsArray[(a + 1) * 3] = l[0], this.colorsArray[(a + 1) * 3 + 1] = l[1], this.colorsArray[(a + 1) * 3 + 2] = l[2];
      const c = this.scaleArray[a];
      this.scaleArray[a + 1] = c;
    }
    this.pointsArray[n * 3] = e[0], this.pointsArray[n * 3 + 1] = e[1], this.pointsArray[n * 3 + 2] = e[2], this.colorsArray[n * 3] = r[0], this.colorsArray[n * 3 + 1] = r[1], this.colorsArray[n * 3 + 2] = r[2], this.scaleArray[n] = s;
  }
  setPointColor(e, n) {
    this.colorsArray[e * 3] = n[0], this.colorsArray[e * 3 + 1] = n[1], this.colorsArray[e * 3 + 2] = n[2];
  }
  setPointPosition(e, n) {
    this.pointsArray[e * 3] = n[0], this.pointsArray[e * 3 + 1] = n[1], this.pointsArray[e * 3 + 2] = n[2];
  }
  setPointScale(e, n) {
    this.scaleArray[e] = n;
  }
  getClosestPointIndex(e) {
    const n = this.pointsArray.length;
    if (n === 0)
      return null;
    let s = Number.POSITIVE_INFINITY, r = -1;
    for (let a = 0; a < n / 3; a++) {
      const o = I.fromValues(this.pointsArray[a * 3], this.pointsArray[a * 3 + 1], this.pointsArray[a * 3 + 2]), l = I.sqrDist(e, o);
      l < s && (s = l, r = a);
    }
    return r;
  }
  getNormal() {
    const e = I.fromValues(0, 0, 0);
    if (this.pointsArray.length >= 9) {
      const n = I.fromValues(this.pointsArray[0], this.pointsArray[1], this.pointsArray[2]), s = I.fromValues(this.pointsArray[3], this.pointsArray[4], this.pointsArray[5]), r = I.fromValues(this.pointsArray[6], this.pointsArray[7], this.pointsArray[8]), a = I.create(), o = I.create();
      I.subtract(a, n, s), I.subtract(o, r, s), I.cross(e, o, a);
    }
    return e;
  }
  onViewWidgetEvent() {
  }
}
class ed {
  constructor(t, e) {
    S(this, "mapper", LC.newInstance());
    S(this, "data", Ie.newInstance());
    S(this, "actor", Re.newInstance());
    S(this, "points", yi.newInstance());
    S(this, "scaleArray");
    S(this, "colorArray");
    S(this, "opacity", 1);
    S(this, "scaling", 1);
    this.colorArray = We.newInstance({
      name: "colors",
      values: new Float32Array(0),
      numberOfComponents: 3
    }), this.scaleArray = We.newInstance({
      name: "scales",
      values: new Float32Array(0),
      numberOfComponents: 1
    }), this.data.getPointData().addArray(this.scaleArray), this.data.setPoints(this.points), this.data.getPointData().setScalars(this.colorArray), this.mapper.setInputData(this.data), this.mapper.setRadius(1), this.actor.setMapper(this.mapper), this.mapper.setScaleArray("scales"), this.mapper.setColorModeToDirectScalars(), this.actor.setVisibility(!0), t && (this.opacity = t), e && (this.scaling = e), this.actor.getProperty().setOpacity(this.opacity);
  }
  setData(t, e, n) {
    const { points: s, scales: r, colors: a } = t;
    if (console.assert(s.length % 3 === 0, "Points len  % 3 !== 0"), console.assert(s.length === 3 * r.length, "Points len !== 3 * scales.length"), console.assert(s.length === a.length, "Points len !== colors.length"), e) {
      const o = n ?? 2, l = [];
      for (let d = 0; d < s.length / 3; d++) {
        const h = I.fromValues(s[3 * d], s[3 * d + 1], s[3 * d + 2]), p = I.create();
        e.getViewMode() != Nt.CPR && (I.sub(p, h, e.getOrigin()), Math.abs(I.dot(p, e.getNormal())) < o && l.push(d));
      }
      const c = [], u = [];
      this.points.setNumberOfPoints(l.length), this.colorArray.setData(new Float32Array(l.length * 3));
      for (let d = 0; d < l.length; d++) {
        const h = l[d];
        c.push(s[3 * h], s[3 * h + 1], s[3 * h + 2]), u.push(r[h] * this.scaling), this.colorArray.setTuple(d, [a[3 * h], a[3 * h + 1], a[3 * h + 2]]);
      }
      this.points.setData(c), this.scaleArray.setData(u);
    } else {
      this.points.setNumberOfPoints(s.length / 3), this.points.setData(s);
      const o = [];
      r.forEach((l) => {
        o.push(l * this.scaling);
      }), this.scaleArray.setData(o), this.colorArray.setData(new Float32Array(a.length));
      for (let l = 0; l < a.length / 3; l++) {
        const c = a.slice(3 * l, 3 * (l + 1));
        this.colorArray.setTuple(l, c);
      }
    }
    this.data.modified();
  }
  getActor() {
    return this.actor;
  }
  getClosestPointIndex(t) {
    const e = this.points.getNumberOfPoints();
    if (e === 0)
      return null;
    let n = Number.POSITIVE_INFINITY, s = -1;
    for (let r = 0; r < e; r++) {
      const a = this.points.getPoint(r), o = I.sqrDist(t, a);
      o < n && (n = o, s = r);
    }
    return s;
  }
  setPointPosition(t, e) {
    console.assert(t >= 0 && t < this.points.getNumberOfPoints()), this.points.setTuple(t, e), this.data.modified();
  }
  setPointScale(t, e) {
    console.assert(t >= 0 && t < this.points.getNumberOfPoints()), this.scaleArray.setTuple(t, [e]), this.data.modified();
  }
  setPointColor(t, e) {
    console.assert(t >= 0 && t < this.points.getNumberOfPoints()), this.colorArray.setTuple(t, e), this.data.modified(), this.mapper.modified();
  }
  setOpacity(t) {
    this.opacity = t, this.actor.getProperty().setOpacity(t), this.mapper.modified();
  }
  setScaling(t) {
    this.scaling = t;
  }
  delete() {
    this.points.delete(), this.data.delete(), this.mapper.delete(), this.actor.delete();
  }
}
var YC = /* @__PURE__ */ ((i) => (i[i.Mm = 0] = "Mm", i[i.Inch = 1] = "Inch", i))(YC || {});
class xMt {
  constructor() {
    S(this, "measurementsDistanceUnit");
    S(this, "onSettingsModified", new se());
    S(this, "reactivity", An());
    const t = {
      measurementsDistanceUnit: 0
      /* Mm */
    };
    this.measurementsDistanceUnit = t.measurementsDistanceUnit, this.reactivity.onEvent(O4.toggleMeasurementUnit, (e) => {
      this.update({ measurementsDistanceUnit: e });
    });
  }
  initialize(t) {
    const e = this.readLocalStorage();
    Object.assign(this, t), Object.assign(this, e), this.onSettingsModified.notify();
  }
  update(t) {
    Object.assign(this, t), this.saveToLocalStorage(), this.onSettingsModified.notify();
  }
  delete() {
    this.reactivity.cleanupAll();
  }
  saveToLocalStorage() {
    localStorage.setItem("measurementsDistanceUnit", this.measurementsDistanceUnit === 0 ? "mm" : "inch");
  }
  readLocalStorage() {
    const t = {}, e = localStorage.getItem("measurementsDistanceUnit");
    return e && (t.measurementsDistanceUnit = e === "mm" ? 0 : 1), t;
  }
}
const En = 10, nu = En, gz = En * 4, ib = En * 4, mr = [1, 0, 1], vC = [0, 1, 0];
function TN() {
  const i = sp.newInstance();
  i.setRadius(1), i.setPhiResolution(50), i.setThetaResolution(50);
  const t = Ue.newInstance();
  t.setInputConnection(i.getOutputPort()), t.setScalarVisibility(!1);
  const e = Re.newInstance();
  return e.setMapper(t), e.setPickable(!0), e.setVisibility(!0), {
    source: i,
    mapper: t,
    actor: e
  };
}
function go() {
  const i = rw.newInstance({
    resolution: 10
  }), t = Ue.newInstance();
  t.setInputConnection(i.getOutputPort());
  const e = Re.newInstance();
  return e.setMapper(t), e.setPickable(!1), e.getProperty().setColor(mr), e.setVisibility(!0), {
    source: i,
    mapper: t,
    actor: e
  };
}
class RC {
  constructor(t, e) {
    S(this, "context");
    S(this, "owner");
    this.context = t, this.owner = e;
  }
  delete() {
    this.context.undoManager.remove(this);
  }
}
class Kp extends RC {
  constructor(e, n, s, r, a) {
    super(e, n);
    S(this, "point1", null);
    S(this, "point2", null);
    S(this, "line", null);
    S(this, "crossLine1", null);
    S(this, "crossLine2", null);
    S(this, "sphere1", TN());
    S(this, "cone1", new tV());
    S(this, "cone2", new tV());
    S(this, "renderer");
    S(this, "name");
    S(this, "projectName");
    S(this, "visible", !0);
    S(this, "onLabelPointMoved", new se());
    S(this, "onVisibilityChanged", new se());
    S(this, "onDelete", new se());
    S(this, "isDistanceMeasurement", !1);
    S(this, "bookmark", /* @__PURE__ */ new Map());
    S(this, "curveDelta", null);
    S(this, "statisticsText", new qt(""));
    S(this, "alwaysOnTop", !1);
    S(this, "added", !1);
    this.renderer = s, this.name = r, this.projectName = a, this.sphere1.actor.getProperty().setColor(mr), this.cone1.getActor().getProperty().setColor(mr), this.cone2.getActor().getProperty().setColor(mr);
  }
  static newDistanceMeasurement(e, n, s, r) {
    const a = new qt(""), o = new Kp(e, n, s, a, r);
    return o.isDistanceMeasurement = !0, o;
  }
  delete() {
    var n, s, r, a, o, l, c, u, d;
    super.delete();
    const e = this.context.objects.projectCollection2D.objects.map((h) => h.name).indexOf(this.projectName);
    if (e != -1 && (this.isAngle() ? this.context.objects.projectCollection2D.iAngleAdded-- : this.isDistance() ? this.context.objects.projectCollection2D.iDistanceAdded-- : this.context.objects.projectCollection2D.iAnnotAdded--, this.context.objects.projectCollection2D.objects.splice(e, 1)), this.context.projectBookmarks.windows.windows[0] && this.context.projectBookmarks.windows.windows[1] && this.context.projectBookmarks.windows.windows[2] && this.context.projectBookmarks.windows.windows[4]) {
      const h = this.context.projectBookmarks.layout.bookmarks.map((p) => p.stateId).indexOf(this.projectName);
      if (h != -1) {
        const p = this.context.projectBookmarks.layout.bookmarks[h].indexId;
        let m = this.context.projectBookmarks.windows.windows[0].presenterWindow.bookmarks.map((y) => y.stateId).indexOf(p);
        m != -1 && this.context.projectBookmarks.windows.windows[0].presenterWindow.bookmarks.splice(m, 1);
        let b = this.context.projectBookmarks.windows.windows[0].presenterWindow.viewWidget.bookmarks.map((y) => y.stateId).indexOf(p);
        b != -1 && this.context.projectBookmarks.windows.windows[0].presenterWindow.viewWidget.bookmarks.splice(b, 1), m = this.context.projectBookmarks.windows.windows[1].presenterWindow.bookmarks.map((y) => y.stateId).indexOf(p), m != -1 && this.context.projectBookmarks.windows.windows[1].presenterWindow.bookmarks.splice(m, 1), b = this.context.projectBookmarks.windows.windows[1].presenterWindow.viewWidget.bookmarks.map((y) => y.stateId).indexOf(p), b != -1 && this.context.projectBookmarks.windows.windows[1].presenterWindow.viewWidget.bookmarks.splice(b, 1), m = this.context.projectBookmarks.windows.windows[2].presenterWindow.bookmarks.map((y) => y.stateId).indexOf(p), m != -1 && this.context.projectBookmarks.windows.windows[2].presenterWindow.bookmarks.splice(m, 1), b = this.context.projectBookmarks.windows.windows[2].presenterWindow.viewWidget.bookmarks.map((y) => y.stateId).indexOf(p), b != -1 && this.context.projectBookmarks.windows.windows[2].presenterWindow.viewWidget.bookmarks.splice(b, 1), m = this.context.projectBookmarks.windows.windows[4].presenterWindow.bookmarks.map((y) => y.stateId).indexOf(p), m != -1 && this.context.projectBookmarks.windows.windows[4].presenterWindow.bookmarks.splice(m, 1), b = this.context.projectBookmarks.windows.windows[4].presenterWindow.viewWidget.bookmarks.map((y) => y.stateId).indexOf(p), b != -1 && this.context.projectBookmarks.windows.windows[4].presenterWindow.viewWidget.bookmarks.splice(b, 1), this.context.projectBookmarks.layout.bookmarks.splice(h, 1);
      }
    }
    this.sphere1.source.delete(), this.sphere1.mapper.delete(), this.sphere1.actor.delete(), this.cone1.delete(), this.cone2.delete(), (n = this.line) == null || n.source.delete(), (s = this.line) == null || s.mapper.delete(), (r = this.line) == null || r.actor.delete(), (a = this.crossLine1) == null || a.source.delete(), (o = this.crossLine1) == null || o.mapper.delete(), (l = this.crossLine1) == null || l.actor.delete(), (c = this.crossLine2) == null || c.source.delete(), (u = this.crossLine2) == null || u.mapper.delete(), (d = this.crossLine2) == null || d.actor.delete(), this.onDelete.notify();
  }
  addFirstPoint(e) {
    this.point1 = e, this.isDistanceMeasurement ? (this.cone1.setApexPosition(e), this.cone1.setSize(this.getFixedSizeScale(e, En)), this.renderer.addActor(this.cone1.getActor())) : (this.sphere1.source.setCenter(this.point1), this.sphere1.source.setRadius(this.getFixedSizeScale(e, En)), this.renderer.addActor(this.sphere1.actor)), this.point2 = e, this.cone2.setApexPosition(e), this.cone2.setSize(this.getFixedSizeScale(e, nu));
    const n = I.create();
    I.sub(n, this.point2, this.point1), I.normalize(n, n), this.isDistanceMeasurement && I.negate(n, n), this.cone2.setDirection(n);
  }
  updateLine(e) {
    if (this.point2 = e, !this.point1) {
      console.error("first point not set");
      return;
    }
    I.equals(this.point1, e) || (this.line || (this.line = go(), this.renderer.addActor(this.line.actor)), this.line.source.setPoint1From(this.point1), this.line.source.setPoint2From(this.point2), this.line.source.modified()), this.updatePoints(this.point1, this.point2), this.isDistanceMeasurement && this.setDistanceLabel(this.point1, this.point2);
  }
  mmToInch(e) {
    return e / 25.4;
  }
  setDistanceLabel(e, n) {
    const s = I.distance(e, n);
    let r;
    this.context.weblinkSettings.measurementsDistanceUnit === YC.Inch ? r = this.mmToInch(s).toFixed(2) + " in" : r = s.toFixed(2) + " mm", this.name.set(r);
  }
  updateDistanceLabel() {
    this.isDistanceMeasurement && this.point1 && this.point2 && this.setDistanceLabel(this.point1, this.point2);
  }
  updatePoints(e, n) {
    const s = I.equals(e, n), r = I.create(), a = I.create();
    if (!s)
      I.sub(r, n, e), I.normalize(r, r), I.negate(a, r);
    else {
      const o = this.renderer.getActiveCamera(), l = o.getViewUp(), c = o.getDirectionOfProjection();
      I.cross(r, c, l), I.normalize(r, r), I.negate(a, r);
    }
    if (this.renderer.getActiveCamera().getViewUp, this.isDistanceMeasurement) {
      this.crossLine1 || (this.crossLine1 = go(), this.renderer.addActor(this.crossLine1.actor)), this.crossLine2 || (this.crossLine2 = go(), this.renderer.addActor(this.crossLine2.actor));
      const o = I.create(), l = this.renderer.getActiveCamera().getDirectionOfProjection();
      I.cross(o, l, r), I.normalize(o, o);
      const c = this.getFixedSizeScale(e, ib), u = this.getFixedSizeScale(n, ib), d = I.create();
      I.scaleAndAdd(d, e, o, -c * 0.5);
      const h = I.create();
      I.scaleAndAdd(h, e, o, +c * 0.5), this.crossLine1.source.setPoint1(...d), this.crossLine1.source.setPoint2(...h);
      const p = I.create();
      I.scaleAndAdd(p, n, o, -u * 0.5);
      const m = I.create();
      I.scaleAndAdd(m, n, o, +u * 0.5), this.crossLine2.source.setPoint1(...p), this.crossLine2.source.setPoint2(...m);
    }
    this.isDistanceMeasurement ? (this.cone1.setDirection(r), this.cone2.setDirection(a), this.cone1.setApexPosition(e), this.cone2.setApexPosition(n), this.cone1.setSize(this.getFixedSizeScale(e, nu)), this.cone2.setSize(this.getFixedSizeScale(n, nu))) : (this.sphere1.source.setCenter(this.point1), this.sphere1.source.setRadius(this.getFixedSizeScale(e, En)), this.cone2.setDirection(r), this.cone2.setApexPosition(n), this.cone2.setSize(this.getFixedSizeScale(n, nu)));
  }
  updateLinePoints() {
    if (!this.point1 || !this.point2) {
      console.error("points not set");
      return;
    }
    I.equals(this.point1, this.point2) || (this.line || (this.line = go(), this.renderer.addActor(this.line.actor)), this.line.source.setPoint1From(this.point1), this.line.source.setPoint2From(this.point2), this.line.source.modified(), this.updatePoints(this.point1, this.point2), this.isDistanceMeasurement && this.setDistanceLabel(this.point1, this.point2));
  }
  showSecondPoint() {
    this.added || (this.added = !0, this.renderer.addActor(this.cone2.getActor()));
  }
  setVisible(e) {
    var n, s, r;
    this.sphere1.actor.setVisibility(e), this.cone1.getActor().setVisibility(e), this.cone2.getActor().setVisibility(e), (n = this.line) == null || n.actor.setVisibility(e), (s = this.crossLine1) == null || s.actor.setVisibility(e), (r = this.crossLine2) == null || r.actor.setVisibility(e), this.onVisibilityChanged.notify(e), this.visible = e;
  }
  getVisible() {
    return this.visible;
  }
  setPickable(e) {
    this.sphere1.actor.setPickable(e), this.cone1.getActor().setPickable(e), this.cone2.getActor().setPickable(e);
  }
  getPickedPoint(e, n) {
    return e === this.cone1.getActor() || e === this.sphere1.actor ? this.point1 && I.distance(this.point1, n) < En * 1.5 ? 0 : null : e === this.cone2.getActor() && this.point2 && I.distance(this.point2, n) < En * 1.5 ? 1 : null;
  }
  getPointPosition(e) {
    if (e === 0 && this.point1)
      return this.point1;
    if (e === 1 && this.point2)
      return this.point2;
    throw `point ${e} does not exist`;
  }
  movePickedPoint(e, n) {
    if (e !== 0 && e !== 1)
      throw `point ${e} does not exist`;
    return e === 0 ? (this.point1 = n, this.cone1.setApexPosition(n), this.cone1.setSize(this.getFixedSizeScale(n, nu)), this.sphere1.source.setCenter(n), this.sphere1.source.setRadius(this.getFixedSizeScale(n, En))) : e === 1 && (this.point2 = n, this.cone2.setApexPosition(n), this.cone2.setSize(this.getFixedSizeScale(n, nu))), this.updateLinePoints(), e === 0 && this.point1 && this.onLabelPointMoved.notify(this.point1), !0;
  }
  setPointHighlight(e, n) {
    if (e !== 0 && e !== 1)
      throw `point ${e} does not exist`;
    const s = n ? vC : mr;
    e === 0 ? (this.sphere1.actor.getProperty().setColor(s), this.cone1.getActor().getProperty().setColor(s)) : e === 1 && this.cone2.getActor().getProperty().setColor(s);
  }
  getFixedSizeScale(e, n) {
    return ki(this.context, this.renderer, e, 1, n) * window.devicePixelRatio;
  }
  onCameraModified() {
    this.point1 && this.point2 && this.updatePoints(this.point1, this.point2);
  }
  addAnnotationToRenderer(e, n = 1) {
    if (this.isDistanceMeasurement) {
      const s = I.create();
      if (this.point1 && this.point2) {
        const r = I.equals(this.point1, this.point2), a = I.create(), o = I.create();
        if (!r)
          I.sub(a, this.point2, this.point1), I.normalize(a, a), I.negate(o, a);
        else {
          const c = e.getRendererOverlay().getActiveCamera(), u = c.getViewUp(), d = c.getDirectionOfProjection();
          I.cross(a, d, u), I.normalize(a, a), I.negate(o, a);
        }
        const l = e.getRendererOverlay().getActiveCamera().getDirectionOfProjection();
        I.cross(s, l, a), I.normalize(s, s);
      }
      if (this.crossLine1 && this.point1 && this.point2) {
        const r = ki(this.context, e.getRendererOverlay(), this.point1, 1, ib) * window.devicePixelRatio, a = I.create();
        I.scaleAndAdd(a, this.point1, s, -r * 0.5);
        const o = I.create();
        I.scaleAndAdd(o, this.point1, s, +r * 0.5), this.crossLine1.source.setPoint1(...a), this.crossLine1.source.setPoint2(...o), e.addActor(this.crossLine1.actor, n);
      }
      if (this.crossLine2 && this.point1 && this.point2) {
        const r = ki(this.context, e.getRendererOverlay(), this.point2, 1, ib) * window.devicePixelRatio, a = I.create();
        I.scaleAndAdd(a, this.point2, s, -r * 0.5);
        const o = I.create();
        I.scaleAndAdd(o, this.point2, s, +r * 0.5), this.crossLine2.source.setPoint1(...a), this.crossLine2.source.setPoint2(...o), e.addActor(this.crossLine2.actor, n);
      }
      this.cone1.setSize(
        ki(this.context, e.getRendererOverlay(), this.cone1.getApexPosition(), 1, En) * window.devicePixelRatio
      ), e.addActor(this.cone1.getActor(), n);
    } else
      this.point1 && this.sphere1.source.setRadius(
        ki(this.context, e.getRendererOverlay(), this.point1, 1, En) * window.devicePixelRatio
      ), e.addActor(this.sphere1.actor, n);
    this.cone2.setSize(
      ki(this.context, e.getRendererOverlay(), this.cone2.getApexPosition(), 1, En) * window.devicePixelRatio
    ), e.addActor(this.cone2.getActor(), n), this.line && e.addActor(this.line.actor, n);
  }
  removeAnnotationFromRenderer(e) {
    this.isDistanceMeasurement ? (this.crossLine1 && e.removeActor(this.crossLine1.actor), this.crossLine2 && e.removeActor(this.crossLine2.actor), e.removeActor(this.cone1.getActor())) : e.removeActor(this.sphere1.actor), e.removeActor(this.cone2.getActor()), this.line && e.removeActor(this.line.actor);
  }
  copyAnnotationInformation(e, n) {
    if (e.isAngle()) throw new Error("Use only for Distance/Annotation Measurement");
    this.point1 = e.getPointPosition(0), this.point2 = e.getPointPosition(1), this.line = go(), this.line.source.setPoint1From(this.point1), this.line.source.setPoint2From(this.point2), this.line.source.modified();
    const s = I.equals(this.point1, this.point1), r = I.create(), a = I.create();
    if (!s)
      I.sub(r, this.point2, this.point1), I.normalize(r, r), I.negate(a, r);
    else {
      const o = n.getActiveCamera(), l = o.getViewUp(), c = o.getDirectionOfProjection();
      I.cross(r, c, l), I.normalize(r, r), I.negate(a, r);
    }
    if (this.cone2.setApexPosition(this.point2), this.cone2.setSize(
      ki(this.context, n, this.point2, 1, nu) * window.devicePixelRatio
    ), this.cone1.setDirection(r), e.isDistance()) {
      this.isDistanceMeasurement = !0, this.cone1.setApexPosition(this.point1), this.cone1.setSize(
        ki(this.context, n, this.point1, 1, En) * window.devicePixelRatio
      ), this.crossLine1 = go(), this.crossLine2 = go();
      const o = I.create(), l = n.getActiveCamera().getDirectionOfProjection();
      I.cross(o, l, r), I.normalize(o, o);
      const c = ki(this.context, n, this.point1, 1, ib) * window.devicePixelRatio, u = ki(this.context, n, this.point2, 1, ib) * window.devicePixelRatio, d = I.create();
      I.scaleAndAdd(d, this.point1, o, -c * 0.5);
      const h = I.create();
      I.scaleAndAdd(h, this.point1, o, +c * 0.5), this.crossLine1.source.setPoint1(...d), this.crossLine1.source.setPoint2(...h);
      const p = I.create();
      I.scaleAndAdd(p, this.point2, o, -u * 0.5);
      const m = I.create();
      I.scaleAndAdd(m, this.point2, o, +u * 0.5), this.crossLine2.source.setPoint1(...p), this.crossLine2.source.setPoint2(...m), this.cone2.setDirection(a), this.cone1.setApexPosition(this.point1), this.cone1.setSize(
        ki(this.context, n, this.point1, 1, nu) * window.devicePixelRatio
      );
    } else
      this.sphere1.source.setCenter(this.point1), this.sphere1.source.setRadius(
        ki(this.context, n, this.point1, 1, En) * window.devicePixelRatio
      ), this.cone2.setDirection(r), this.cone2.setApexPosition(this.point2), this.cone2.setSize(
        ki(this.context, n, this.point2, 1, nu) * window.devicePixelRatio
      );
  }
  isROI() {
    return !1;
  }
  isAngle() {
    return !1;
  }
  isDistance() {
    return this.isDistanceMeasurement;
  }
  setBookmark(e) {
    this.bookmark = e;
  }
  getBookmark() {
    return this.bookmark;
  }
  getNumberOfPoints() {
    return 2;
  }
}
class yz extends RC {
  constructor(e, n, s, r) {
    super(e, n);
    S(this, "point1", null);
    S(this, "point2", null);
    S(this, "point3", null);
    S(this, "spheres", [TN(), TN(), TN()]);
    S(this, "line1", null);
    S(this, "line2", null);
    S(this, "arc", new F1t());
    S(this, "arcActor", null);
    S(this, "renderer");
    S(this, "name");
    S(this, "projectName");
    S(this, "visible", !0);
    S(this, "onLabelPointMoved", new se());
    S(this, "onVisibilityChanged", new se());
    S(this, "onDelete", new se());
    S(this, "bookmark", /* @__PURE__ */ new Map());
    S(this, "curveDelta", null);
    S(this, "statisticsText", new qt(""));
    S(this, "alwaysOnTop", !1);
    this.renderer = s, this.name = new qt(""), this.projectName = r;
  }
  delete() {
    var n, s, r, a, o, l, c;
    super.delete();
    const e = this.context.objects.projectCollection2D.objects.map((u) => u.name).indexOf(this.projectName);
    if (e != -1 && (this.isAngle() ? this.context.objects.projectCollection2D.iAngleAdded-- : this.isDistance() ? this.context.objects.projectCollection2D.iDistanceAdded-- : this.context.objects.projectCollection2D.iAnnotAdded--, this.context.objects.projectCollection2D.objects.splice(e, 1)), this.context.projectBookmarks.windows.windows[0] && this.context.projectBookmarks.windows.windows[1] && this.context.projectBookmarks.windows.windows[2] && this.context.projectBookmarks.windows.windows[4]) {
      const u = this.context.projectBookmarks.layout.bookmarks.map((d) => d.stateId).indexOf(this.projectName);
      if (u != -1) {
        const d = this.context.projectBookmarks.layout.bookmarks[u].indexId;
        let h = this.context.projectBookmarks.windows.windows[0].presenterWindow.bookmarks.map((m) => m.stateId).indexOf(d);
        h != -1 && this.context.projectBookmarks.windows.windows[0].presenterWindow.bookmarks.splice(h, 1);
        let p = this.context.projectBookmarks.windows.windows[0].presenterWindow.viewWidget.bookmarks.map((m) => m.stateId).indexOf(d);
        p != -1 && this.context.projectBookmarks.windows.windows[0].presenterWindow.viewWidget.bookmarks.splice(p, 1), h = this.context.projectBookmarks.windows.windows[1].presenterWindow.bookmarks.map((m) => m.stateId).indexOf(d), h != -1 && this.context.projectBookmarks.windows.windows[1].presenterWindow.bookmarks.splice(h, 1), p = this.context.projectBookmarks.windows.windows[1].presenterWindow.viewWidget.bookmarks.map((m) => m.stateId).indexOf(d), p != -1 && this.context.projectBookmarks.windows.windows[1].presenterWindow.viewWidget.bookmarks.splice(p, 1), h = this.context.projectBookmarks.windows.windows[2].presenterWindow.bookmarks.map((m) => m.stateId).indexOf(d), h != -1 && this.context.projectBookmarks.windows.windows[2].presenterWindow.bookmarks.splice(h, 1), p = this.context.projectBookmarks.windows.windows[2].presenterWindow.viewWidget.bookmarks.map((m) => m.stateId).indexOf(d), p != -1 && this.context.projectBookmarks.windows.windows[2].presenterWindow.viewWidget.bookmarks.splice(p, 1), h = this.context.projectBookmarks.windows.windows[4].presenterWindow.bookmarks.map((m) => m.stateId).indexOf(d), h != -1 && this.context.projectBookmarks.windows.windows[4].presenterWindow.bookmarks.splice(h, 1), p = this.context.projectBookmarks.windows.windows[4].presenterWindow.viewWidget.bookmarks.map((m) => m.stateId).indexOf(d), p != -1 && this.context.projectBookmarks.windows.windows[4].presenterWindow.viewWidget.bookmarks.splice(p, 1), this.context.projectBookmarks.layout.bookmarks.splice(u, 1);
      }
    }
    this.renderer.removeActor(this.spheres[0].actor), this.renderer.removeActor(this.spheres[1].actor), this.renderer.removeActor(this.spheres[2].actor), this.spheres[0].source.delete(), this.spheres[0].mapper.delete(), this.spheres[0].actor.delete(), this.spheres[1].source.delete(), this.spheres[1].mapper.delete(), this.spheres[1].actor.delete(), this.spheres[2].source.delete(), this.spheres[2].mapper.delete(), this.spheres[2].actor.delete(), this.line1 && this.renderer.removeActor(this.line1.actor), this.line2 && this.renderer.removeActor(this.line2.actor), (n = this.line1) == null || n.source.delete(), (s = this.line1) == null || s.mapper.delete(), (r = this.line1) == null || r.actor.delete(), (a = this.line2) == null || a.source.delete(), (o = this.line2) == null || o.mapper.delete(), (l = this.line2) == null || l.actor.delete(), this.arcActor && this.renderer.removeActor(this.arcActor), (c = this.arcActor) == null || c.delete(), this.onDelete.notify();
  }
  addFirstPoint(e) {
    this.point1 = e, this.spheres[0].source.setCenter(this.point1), this.spheres[0].source.setRadius(this.getFixedSizeScale(this.point1, En)), this.spheres[0].actor.getProperty().setColor(mr), this.renderer.addActor(this.spheres[0].actor);
  }
  calculateAngleDegrees(e, n, s) {
    const r = I.create(), a = I.create();
    return I.sub(r, n, e), I.sub(a, s, e), nd(r, a) / Math.PI * 180;
  }
  updateLabel(e) {
    this.name.set(e.toFixed(2) + "°");
  }
  updateArc(e, n, s) {
    const r = I.create();
    I.sub(r, n, e);
    const a = I.create();
    I.sub(a, s, e);
    const o = Math.min(I.distance(e, n), I.distance(e, s)), l = Math.min(o, this.getFixedSizeScale(e, gz));
    this.arc.setData({
      origin: e,
      dir1: r,
      dir2: a,
      radius: l,
      color: mr
    }), this.arcActor || (this.arcActor = this.arc.getActor(), this.renderer.addActor(this.arcActor));
  }
  updateLine(e) {
    let n, s;
    if (this.point1 && this.point2 && this.point3)
      !this.line2 && !I.equals(this.point1, this.point3) && (this.line2 = go(), this.renderer.addActor(this.line2.actor)), this.line2 && (n = this.line2.source, s = this.point1, n.setPoint1From(s), n.setPoint2From(e), n.modified());
    else if (this.point1 && this.point2)
      !this.line1 && !I.equals(this.point1, this.point2) && (this.line1 = go(), this.renderer.addActor(this.line1.actor)), this.line1 && (n = this.line1.source, s = this.point1, n.setPoint1From(s), n.setPoint2From(e), n.modified());
    else {
      console.error("first point not set");
      return;
    }
    if (this.point1 && this.point2 && this.point3) {
      const r = this.calculateAngleDegrees(this.point1, this.point2, e);
      this.updateLabel(r), this.updateArc(this.point1, this.point2, e);
    }
  }
  updateLinePoints() {
    if (!this.point1 || !this.point2 || !this.point3) {
      console.error("points not set");
      return;
    }
    if (!this.line1 && !I.equals(this.point1, this.point2) && (this.line1 = go(), this.renderer.addActor(this.line1.actor)), !this.line2 && !I.equals(this.point1, this.point3) && (this.line2 = go(), this.renderer.addActor(this.line2.actor)), this.line1 && !I.equals(this.point1, this.point2) && (this.line1.source.setPoint1From(this.point1), this.line1.source.setPoint2From(this.point2), this.line1.source.modified()), this.line2 && !I.equals(this.point1, this.point3) && (this.line2.source.setPoint1From(this.point1), this.line2.source.setPoint2From(this.point3), this.line2.source.modified()), this.spheres[0].source.setRadius(this.getFixedSizeScale(this.point1, En)), this.spheres[1].source.setRadius(this.getFixedSizeScale(this.point2, En)), this.point3) {
      this.spheres[2].source.setRadius(this.getFixedSizeScale(this.point3, En));
      const e = this.calculateAngleDegrees(this.point1, this.point2, this.point3);
      this.updateLabel(e), this.updateArc(this.point1, this.point2, this.point3);
    }
  }
  updateSecondPoint(e) {
    if (!this.point1) {
      console.error("first point not set");
      return;
    }
    const n = this.point2 !== null;
    this.point2 = e, this.spheres[1].source.setCenter(this.point2), this.spheres[1].source.setRadius(this.getFixedSizeScale(this.point2, En)), this.spheres[1].actor.getProperty().setColor(mr), n || this.renderer.addActor(this.spheres[1].actor);
  }
  updateThirdPoint(e) {
    if (!this.point1 || !this.point2) {
      console.error("first 2 points not set not set");
      return;
    }
    const n = this.point3 !== null;
    this.point3 = e, this.spheres[2].source.setCenter(this.point3), this.spheres[2].source.setRadius(this.getFixedSizeScale(this.point3, En)), this.spheres[2].actor.getProperty().setColor(mr), n || this.renderer.addActor(this.spheres[2].actor);
  }
  setVisible(e) {
    var n, s, r;
    this.spheres[0].actor.setVisibility(e), this.spheres[1].actor.setVisibility(e), this.spheres[2].actor.setVisibility(e), (n = this.line1) == null || n.actor.setVisibility(e), (s = this.line2) == null || s.actor.setVisibility(e), (r = this.arcActor) == null || r.setVisibility(e), this.onVisibilityChanged.notify(e), this.visible = e;
  }
  getVisible() {
    return this.visible;
  }
  setPickable(e) {
    this.spheres[0].actor.setPickable(e), this.spheres[1].actor.setPickable(e), this.spheres[2].actor.setPickable(e);
  }
  getPickedPoint(e, n) {
    return e === this.spheres[0].actor ? this.point1 && I.distance(this.point1, n) < En * 1.5 ? 0 : null : e === this.spheres[1].actor ? this.point2 && I.distance(this.point2, n) < En * 1.5 ? 1 : null : e === this.spheres[2].actor && this.point3 && I.distance(this.point3, n) < En * 1.5 ? 2 : null;
  }
  getPointPosition(e) {
    if (e === 0 && this.point1)
      return this.point1;
    if (e === 1 && this.point2)
      return this.point2;
    if (e === 2 && this.point3)
      return this.point3;
    throw `point ${e} does not exist`;
  }
  movePickedPoint(e, n) {
    if (e !== 0 && e !== 1 && e !== 2)
      throw `point ${e} does not exist`;
    return e === 0 ? (this.point1 = n, this.spheres[0].source.setCenter(n)) : e === 1 ? (this.point2 = n, this.spheres[1].source.setCenter(n)) : e === 2 && (this.point3 = n, this.spheres[2].source.setCenter(n)), this.updateLinePoints(), e === 0 && this.point1 && this.onLabelPointMoved.notify(this.point1), !0;
  }
  setPointHighlight(e, n) {
    if (e !== 0 && e !== 1 && e !== 2)
      throw `point ${e} does not exist`;
    const s = n ? vC : mr;
    this.spheres[e].actor.getProperty().setColor(s);
  }
  getFixedSizeScale(e, n) {
    return ki(this.context, this.renderer, e, 1, n) * window.devicePixelRatio;
  }
  onCameraModified() {
    if (this.point1) {
      const e = this.getFixedSizeScale(this.point1, En);
      this.spheres[0].source.setRadius(e);
    }
    if (this.point2) {
      const e = this.getFixedSizeScale(this.point2, En);
      this.spheres[1].source.setRadius(e);
    }
    if (this.point3) {
      const e = this.getFixedSizeScale(this.point3, En);
      this.spheres[2].source.setRadius(e);
    }
    this.point1 && this.point2 && this.point3 && this.updateArc(this.point1, this.point2, this.point3);
  }
  addAnnotationToRenderer(e, n = 1) {
    this.spheres[0].source.setRadius(
      ki(this.context, e.getRendererOverlay(), this.point1, 1, En) * window.devicePixelRatio
    ), this.point2 && this.spheres[1].source.setRadius(
      ki(this.context, e.getRendererOverlay(), this.point2, 1, En) * window.devicePixelRatio
    ), this.point3 && this.spheres[2].source.setRadius(
      ki(this.context, e.getRendererOverlay(), this.point3, 1, En) * window.devicePixelRatio
    ), e.addActor(this.spheres[0].actor, n), e.addActor(this.spheres[1].actor, n), e.addActor(this.spheres[2].actor, n), this.arcActor && e.addActor(this.arcActor, n), this.line2 && e.addActor(this.line2.actor, n), this.line1 && e.addActor(this.line1.actor, n);
  }
  removeAnnotationFromRenderer(e) {
    e.removeActor(this.spheres[0].actor), e.removeActor(this.spheres[1].actor), e.removeActor(this.spheres[2].actor), this.arcActor && e.removeActor(this.arcActor), this.line2 && e.removeActor(this.line2.actor), this.line1 && e.removeActor(this.line1.actor);
  }
  copyAnnotationInformation(e, n) {
    if (!e.isAngle()) throw new Error("Use only for Angle Measurement");
    this.point1 = e.getPointPosition(0), this.spheres[0].source.setCenter(this.point1), this.spheres[0].source.setRadius(
      ki(this.context, n, this.point1, 1, En) * window.devicePixelRatio
    ), this.spheres[0].actor.getProperty().setColor(mr), this.point2 = e.getPointPosition(1), this.spheres[1].source.setCenter(this.point2), this.spheres[1].source.setRadius(
      ki(this.context, n, this.point2, 1, En) * window.devicePixelRatio
    ), this.spheres[1].actor.getProperty().setColor(mr), this.point3 = e.getPointPosition(2), this.spheres[2].source.setCenter(this.point3), this.spheres[2].source.setRadius(
      ki(this.context, n, this.point3, 1, En) * window.devicePixelRatio
    ), this.spheres[2].actor.getProperty().setColor(mr), this.line1 = go(), this.line1.source.setPoint1From(this.point1), this.line1.source.setPoint2From(this.point2), this.line1.source.modified(), this.line2 = go(), this.line2.source.setPoint1From(this.point1), this.line2.source.setPoint2From(this.point3), this.line2.source.modified();
    const s = this.calculateAngleDegrees(this.point1, this.point2, this.point3);
    this.updateLabel(s);
    const r = I.create();
    I.sub(r, this.point2, this.point1);
    const a = I.create();
    I.sub(a, this.point3, this.point1);
    const o = Math.min(I.distance(this.point1, this.point2), I.distance(this.point1, this.point3)), l = Math.min(
      o,
      ki(this.context, n, this.point1, 1, gz) * window.devicePixelRatio
    );
    this.arc.setData({
      origin: this.point1,
      dir1: r,
      dir2: a,
      radius: l,
      color: mr
    }), this.arcActor = this.arc.getActor();
  }
  isROI() {
    return !1;
  }
  isAngle() {
    return !0;
  }
  isDistance() {
    return !1;
  }
  setBookmark(e) {
    this.bookmark = e;
  }
  getBookmark() {
    return this.bookmark;
  }
  getNumberOfPoints() {
    return 3;
  }
}
class Zz extends RC {
  constructor(e, n, s, r) {
    super(e, n);
    S(this, "points", []);
    S(this, "polygonRepresentation", new CC());
    S(this, "pointRepresentation", new ed());
    S(this, "polygonPicker");
    S(this, "renderer");
    S(this, "name", new qt(""));
    S(this, "projectName");
    S(this, "visible", !0);
    S(this, "curveDelta", null);
    S(this, "bookmark", /* @__PURE__ */ new Map());
    S(this, "onLabelPointMoved", new se());
    S(this, "onVisibilityChanged", new se());
    S(this, "onDelete", new se());
    S(this, "currentIndex", 0);
    S(this, "statistics", {
      area: 0,
      length: 0,
      avg: 0,
      max: 0,
      min: 0,
      stdDev: 0
    });
    S(this, "statisticsText", new qt(""));
    S(this, "alwaysOnTop", !1);
    this.renderer = s, this.projectName = r, this.polygonPicker = new sA(this.context), this.pointRepresentation.getActor().setPickable(!0);
  }
  delete() {
    super.delete();
    const e = this.context.objects.projectCollection2D.objects.map((n) => n.name).indexOf(this.projectName);
    if (e != -1 && (this.isAngle() ? this.context.objects.projectCollection2D.iAngleAdded-- : this.isROI() ? this.context.objects.projectCollection2D.iPolyAdded-- : this.isDistance() ? this.context.objects.projectCollection2D.iDistanceAdded-- : this.context.objects.projectCollection2D.iAnnotAdded--, this.context.objects.projectCollection2D.objects.splice(e, 1)), this.context.projectBookmarks.windows.windows[0] && this.context.projectBookmarks.windows.windows[1] && this.context.projectBookmarks.windows.windows[2] && this.context.projectBookmarks.windows.windows[4]) {
      const n = this.context.projectBookmarks.layout.bookmarks.map((s) => s.stateId).indexOf(this.projectName);
      if (n != -1) {
        const s = this.context.projectBookmarks.layout.bookmarks[n].indexId;
        let r = this.context.projectBookmarks.windows.windows[0].presenterWindow.bookmarks.map((o) => o.stateId).indexOf(s);
        r != -1 && this.context.projectBookmarks.windows.windows[0].presenterWindow.bookmarks.splice(r, 1);
        let a = this.context.projectBookmarks.windows.windows[0].presenterWindow.viewWidget.bookmarks.map((o) => o.stateId).indexOf(s);
        a != -1 && this.context.projectBookmarks.windows.windows[0].presenterWindow.viewWidget.bookmarks.splice(a, 1), r = this.context.projectBookmarks.windows.windows[1].presenterWindow.bookmarks.map((o) => o.stateId).indexOf(s), r != -1 && this.context.projectBookmarks.windows.windows[1].presenterWindow.bookmarks.splice(r, 1), a = this.context.projectBookmarks.windows.windows[1].presenterWindow.viewWidget.bookmarks.map((o) => o.stateId).indexOf(s), a != -1 && this.context.projectBookmarks.windows.windows[1].presenterWindow.viewWidget.bookmarks.splice(a, 1), r = this.context.projectBookmarks.windows.windows[2].presenterWindow.bookmarks.map((o) => o.stateId).indexOf(s), r != -1 && this.context.projectBookmarks.windows.windows[2].presenterWindow.bookmarks.splice(r, 1), a = this.context.projectBookmarks.windows.windows[2].presenterWindow.viewWidget.bookmarks.map((o) => o.stateId).indexOf(s), a != -1 && this.context.projectBookmarks.windows.windows[2].presenterWindow.viewWidget.bookmarks.splice(a, 1), r = this.context.projectBookmarks.windows.windows[4].presenterWindow.bookmarks.map((o) => o.stateId).indexOf(s), r != -1 && this.context.projectBookmarks.windows.windows[4].presenterWindow.bookmarks.splice(r, 1), a = this.context.projectBookmarks.windows.windows[4].presenterWindow.viewWidget.bookmarks.map((o) => o.stateId).indexOf(s), a != -1 && this.context.projectBookmarks.windows.windows[4].presenterWindow.viewWidget.bookmarks.splice(a, 1), this.context.projectBookmarks.layout.bookmarks.splice(n, 1);
      }
    }
    this.renderer.removeActor(this.polygonRepresentation.getActor()), this.renderer.removeActor(this.pointRepresentation.getActor()), this.polygonRepresentation.delete(), this.pointRepresentation.delete(), this.polygonPicker.delete(), this.onDelete.notify();
  }
  addFirstPoint(e) {
    this.currentIndex++, this.points.push(e), this.polygonPicker.addPoint(e, this.getFixedSizeScale(e, En), mr);
  }
  updateLinePoints(e = !0) {
    this.polygonRepresentation.setData({
      points: this.polygonPicker.getPickedPointsV(),
      color: mr,
      lineOpacity: 1
    }), e && this.points.forEach((n, s) => {
      this.polygonPicker.setPointScale(s, this.getFixedSizeScale(n, En));
    }), this.pointRepresentation.setData({
      points: this.polygonPicker.pointsArray,
      colors: this.polygonPicker.colorsArray,
      scales: this.polygonPicker.scaleArray
    });
  }
  updateNextPoint(e) {
    this.currentIndex++, this.points.push(e), this.polygonPicker.addPoint(e, this.getFixedSizeScale(e, En), mr);
  }
  updateCurrentPoint(e) {
    this.points[this.currentIndex] = e, this.polygonPicker.setPointPosition(this.currentIndex, e), this.setPointHighlight(this.currentIndex - 1, !1), this.setPointHighlight(this.currentIndex, !0), this.updateLinePoints();
  }
  setVisible(e) {
    this.polygonRepresentation.getActor().setVisibility(e), this.pointRepresentation.getActor().setVisibility(e), this.onVisibilityChanged.notify(e), this.visible = e;
  }
  getVisible() {
    return this.visible;
  }
  setPickable(e) {
    this.polygonRepresentation.getActor().setPickable(e), this.pointRepresentation.getActor().setPickable(e);
  }
  getPickedPoint(e, n) {
    let s = 0;
    for (const r of this.points) {
      if (I.distance(r, n) < 1.5)
        return s;
      s++;
    }
    return null;
  }
  getPointPosition(e) {
    if (e >= 0 && e < this.points.length && this.points.length > 0)
      return this.points[e];
    throw `point ${e} does not exist`;
  }
  movePickedPoint(e, n) {
    if (e >= 0 && e < this.points.length && this.points.length > 0)
      return this.points[e] = n, this.polygonPicker.setPointPosition(e, n), this.updateLinePoints(), e === 0 && this.points.length > 0 && this.onLabelPointMoved.notify(this.points[0]), !0;
    throw `point ${e} does not exist`;
  }
  setPointHighlight(e, n) {
    if (e >= 0 && e < this.points.length && this.points.length > 0) {
      const s = n ? vC : mr;
      this.polygonPicker.setPointColor(e, s);
    } else
      throw `point ${e} does not exist`;
  }
  getFixedSizeScale(e, n) {
    return ki(this.context, this.renderer, e, 1, n) * window.devicePixelRatio;
  }
  onCameraModified() {
    this.updateLinePoints();
  }
  addAnnotationToRenderer(e, n = 1) {
    this.points.forEach((s, r) => {
      this.polygonPicker.setPointScale(
        r,
        ki(this.context, e.getRendererOverlay(), s, 1, En) * window.devicePixelRatio
      );
    }), this.updateLinePoints(!1), e.addActor(this.pointRepresentation.getActor(), n), e.addActor(this.polygonRepresentation.getActor(), n);
  }
  removeAnnotationFromRenderer(e) {
    e.removeActor(this.pointRepresentation.getActor()), e.removeActor(this.polygonRepresentation.getActor());
  }
  updateLabel() {
    const e = this.calculateStatistics();
    this.statisticsText.set(e);
  }
  calculateStatistics() {
    let e = 99999, n = -99999, s = 0, r = 0;
    if (this.owner.getViewMode() != Nt._3D) {
      const h = this.polygonRepresentation.data.getPoints().getData();
      let p = 99999, m = 99999, b = 99999, y = -99999, Z = -99999, g = -99999;
      this.polygonPicker.getPickedPointsV().forEach((C) => {
        y = C[0] > y ? C[0] : y, Z = C[1] > Z ? C[1] : Z, g = C[2] > g ? C[2] : g, p = C[0] < p ? C[0] : p, m = C[1] < m ? C[1] : m, b = C[2] < b ? C[2] : b;
      });
      const f = this.context.getImageData().getBounds();
      p = Math.max(p, f[0] + 0.5), y = Math.min(y, f[1] - 0.5), m = Math.max(m, f[2] + 0.5), Z = Math.min(Z, f[3] - 0.5), b = Math.max(b, f[4] + 0.5), g = Math.min(g, f[5] - 0.5);
      const T = [p, y, m, Z, b, g], M = [];
      let N = 0, W = 0;
      const x = this.context.getImageData().getPointData().getScalars().getData(), V = this.polygonPicker.getNormal();
      for (let C = p; C <= y; C++)
        for (let R = m; R <= Z; R++)
          for (let z = b; z <= g; z++)
            if (this.polygonRepresentation.pointInPolygon([C, R, z], h, T, V) == gl.INSIDE && this.owner.getViewMode() != Nt._3D && this.owner.getViewMode() != Nt.CPR) {
              const P = this.context.getImageData().getOffsetIndexFromWorld([C, R, z]), j = Number(x[P]);
              W += j, j < e && (e = j), j > n && (n = j), M.push(j), N++;
            }
      N > 0 && (s = W / N);
      let X = 0;
      for (let C = 0; C < N; C++)
        X = X + (M[C] - s) * (M[C] - s);
      N == 0 ? r = -1 : X <= 0 ? r = 0 : r = Math.sqrt(X / N);
    }
    let a = 0;
    for (let h = 0; h < this.getNumberOfPoints() - 1; h++)
      a += I.distance(this.points[h], this.points[h + 1]);
    a += I.distance(this.points[this.getNumberOfPoints() - 1], this.points[0]);
    let o = 0, l = 0;
    const c = this.owner.getNormal(), u = I.create();
    for (let h = 0; h < this.getNumberOfPoints() - 1; h++)
      I.cross(u, this.points[h], this.points[h + 1]), l += I.dot(c, u);
    return I.cross(u, this.points[this.getNumberOfPoints() - 1], this.points[0]), l += I.dot(c, u), o = Math.abs(l / 2), this.generateString(o, a, s, n, e, r);
  }
  generateString(e, n, s, r, a, o) {
    let l = "";
    return this.owner.getViewMode() == Nt._3D ? (l += jt("medic-web-engine.area") + ": " + e.toFixed(1) + ` mm²
`, l += jt("medic-web-engine.perimeter") + ": " + n.toFixed(1) + ` mm
`) : (l += jt("medic-web-engine.area") + ": " + e.toFixed(1) + ` mm²
`, l += jt("medic-web-engine.perimeter") + ": " + n.toFixed(1) + ` mm
`, l += jt("medic-web-engine.average") + ": " + s.toFixed(1) + `
`, l += jt("medic-web-engine.max") + ": " + r.toFixed(0) + `
`, l += jt("medic-web-engine.min") + ": " + a.toFixed(0) + `
`, l += jt("medic-web-engine.stdDev") + ": " + o.toFixed(0) + `
`), this.statistics = {
      area: e,
      length: n,
      avg: s,
      max: r,
      min: a,
      stdDev: o
    }, l;
  }
  copyAnnotationInformation(e, n) {
    console.log("not implemented", e, n);
  }
  isROI() {
    return !0;
  }
  isAngle() {
    return !1;
  }
  isDistance() {
    return !1;
  }
  setBookmark(e) {
    this.bookmark = e;
  }
  getBookmark() {
    return this.bookmark;
  }
  getNumberOfPoints() {
    return this.points.length;
  }
}
class SMt {
  constructor(t, e, n) {
    S(this, "plane");
    S(this, "cutter");
    S(this, "mapper");
    S(this, "actor");
    S(this, "onDelete");
    var r;
    this.plane = e, this.cutter = UI.newInstance(), this.cutter.setCutFunction(this.plane), this.cutter.setInputConnection((r = t.getMapper()) == null ? void 0 : r.getInputConnection()), this.mapper = Ue.newInstance(), this.mapper.setInputConnection(this.cutter.getOutputPort()), this.actor = Re.newInstance(), this.actor.setMapper(this.mapper), this.actor.setPickable(!1);
    const s = (a) => {
      this.actor.getProperty().setColor(a);
    };
    s(n.get()), n.subscribe(s), this.onDelete = () => {
      n.unsubscribe(s);
    };
  }
  getActor() {
    return this.actor;
  }
  setColor(t) {
    this.actor.getProperty().setColor(t);
  }
  delete() {
    this.onDelete(), this.cutter.delete(), this.mapper.delete(), this.actor.delete();
  }
}
class LMt extends op {
  constructor(e, n, s, r) {
    var Se;
    super(n, Nt.SECTIONAL_VIEW);
    S(this, "parentView");
    S(this, "plane");
    S(this, "planeRepresentation");
    S(this, "arrowRepresentation");
    S(this, "origin");
    S(this, "viewUp");
    S(this, "reactivity", An());
    S(this, "eventHandler");
    S(this, "planeWidth", 10);
    S(this, "planeHeight", 10);
    S(this, "grid", new vTt());
    S(this, "displayMode", 1);
    S(this, "cutterUseStlColors", new qt(!0));
    S(this, "selectAndCenterObjectEvent", new se());
    S(this, "objectSlices", /* @__PURE__ */ new Map());
    n.addSectionalView(this), this.show(), this.parentView = e, this.viewUp = [0, 1, 0], this.origin = [0, 0, 0], this.renderer.setLayer(2), this.renderer.setPreserveColorBuffer(!1), this.rendererOverlay.setLayer(2);
    const { canvasSize: a } = this.context.getState();
    let o = { x: 0, y: 0, w: 0, h: 0 }, l = 0.2, c = 0.5;
    const u = () => {
      const [Vt, Rt] = a.get(), $t = 10, zt = (Vt - 2 * $t) * l, Bt = (Rt - 2 * $t) * c, Kt = Vt - zt - $t, ne = Rt - Bt - $t, ae = zt, Ge = Bt;
      o = { x: Kt, y: ne, w: ae, h: Ge };
      const He = _I([Vt, Rt], { x: Kt, y: ne, w: ae, h: Ge });
      this.viewport.set(He);
    };
    let d = document.createElement("canvas");
    this.onCleanup(() => {
      d == null || d.remove(), d = null;
    });
    const h = () => {
      d && (d.width = Math.floor(o.w), d.height = Math.floor(o.h)), this.sceneRefresh();
    };
    this.reactivity.watch(a, () => {
      u(), h();
    }), u(), h();
    const p = d.getContext("2d");
    this.getOverlayContainer().appendChild(d), d.style.position = "absolute", d.style.pointerEvents = "none";
    const m = (Vt) => {
      const Rt = `rgb(${Vt[0] * 255}, ${Vt[1] * 255}, ${Vt[2] * 255})`;
      d && (d.style.backgroundColor = Rt);
    }, b = () => {
      const Vt = this.context.getVtkCanvas();
      if (!Vt || !d) return;
      let { x: Rt, y: $t, w: zt, h: Bt } = o;
      Rt = Math.ceil(Rt + 0.5), $t = Math.ceil($t + 0.5), zt = Math.floor(zt - 1), Bt = Math.floor(Bt - 1), p == null || p.drawImage(Vt, Rt, $t, zt, Bt, 0, 0, zt, Bt);
    };
    this.onEvent(this.events.afterSceneRefresh, () => {
      b();
    }), this.plane = li.newInstance({
      origin: [0, 0, 0],
      normal: [0, 0, 1]
    }), this.renderer.getActiveCamera().setParallelProjection(!0), this.resetCamera(), this.planeRepresentation = new MTt(), this.arrowRepresentation = new yN();
    const Z = (Vt, Rt, $t) => {
      const [zt, Bt] = this.viewSize.get(), Kt = this.viewToWorld(0, 0, 0), ne = this.viewToWorld(zt, Bt, 0), ae = this.viewToWorld(0, Bt, 0), Ge = I.distance(ae, ne), He = I.distance(ae, Kt);
      this.planeWidth = Ge, this.planeHeight = He;
      const je = I.create();
      I.cross(je, Rt, $t), I.normalize(je, je);
      const we = I.create();
      I.copy(we, $t), I.normalize(we, we);
      const ln = I.create();
      I.scaleAndAdd(ln, Vt, je, -Ge / 2), I.scaleAndAdd(ln, ln, we, -He / 2);
      const Ls = I.create();
      I.scaleAndAdd(Ls, Vt, je, Ge / 2), I.scaleAndAdd(Ls, Ls, we, -He / 2);
      const ys = I.create();
      I.scaleAndAdd(ys, Vt, we, He / 2), I.scaleAndAdd(ys, ys, je, -Ge / 2), this.planeRepresentation.setData({
        origin: ln,
        point1: Ls,
        point2: ys,
        color: [0.5, 0.5, 1]
      });
      const re = I.create();
      I.scaleAndAdd(re, Vt, je, Ge / 2), I.scaleAndAdd(re, re, we, He / 2);
      const be = I.create();
      I.scaleAndAdd(be, re, Rt, -1), this.arrowRepresentation.setData({
        point1: be,
        point2: re
      });
    }, g = () => {
      Z(this.origin, this.plane.getNormal(), this.viewUp);
    }, f = (Vt, Rt, $t = !1) => {
      this.renderer.setBackground(Rt.sectionalViewBackground), m(Rt.sectionalViewBackground), this.updateGrid(), $t && this.sceneRefresh();
    };
    this.reactivity.watch(this.context.viewConfiguration.colorScheme, (Vt) => {
      f(Vt, this.context.viewConfiguration.colors.get(), !0);
    }), f(this.context.viewConfiguration.colorScheme.get(), this.context.viewConfiguration.colors.get());
    const { createVueOverlayComponent: T, cleanup: M } = Pi(this.overlayContainer.getElement());
    this.onCleanup(() => M());
    const { createVueOverlayComponent: N, cleanup: W } = Pi(this.parentView.getOverlayContainer());
    this.onCleanup(() => W());
    const x = {
      x: new qt(I.create()),
      y: new qt(I.create()),
      z: new qt(I.create())
    }, V = {
      x: new qt([0, 0]),
      y: new qt([0, 0]),
      z: new qt([0, 0])
    }, X = {
      x: new qt(I.create()),
      y: new qt(I.create()),
      z: new qt(I.create())
    }, C = {
      x: new qt([0, 0]),
      y: new qt([0, 0]),
      z: new qt([0, 0])
    }, R = () => {
      V.x.set(this.parentView.worldToDisplay(...x.x.get()).slice(0, 2)), V.y.set(this.parentView.worldToDisplay(...x.y.get()).slice(0, 2)), V.z.set(this.parentView.worldToDisplay(...x.z.get()).slice(0, 2)), C.x.set(
        this.parentView.worldToDisplay(...X.x.get()).slice(0, 2)
      ), C.y.set(
        this.parentView.worldToDisplay(...X.y.get()).slice(0, 2)
      ), C.z.set(
        this.parentView.worldToDisplay(...X.z.get()).slice(0, 2)
      );
    }, z = {
      x: new qt("X mm"),
      y: new qt("Y mm"),
      z: new qt("Z mm")
    }, F = (Vt) => {
      const { xAxis: Rt, yAxis: $t, zAxis: zt } = Vt;
      if (n.weblinkSettings.measurementsDistanceUnit === YC.Inch) {
        const Bt = (Kt) => Kt / 25.4;
        z.x.set(`${Bt(I.length(Rt)).toFixed(2)} in`), z.y.set(`${Bt(I.length($t)).toFixed(2)} in`), z.z.set(`${Bt(I.length(zt)).toFixed(2)} in`);
      } else
        z.x.set(`${I.length(Rt).toFixed(2)} mm`), z.y.set(`${I.length($t).toFixed(2)} mm`), z.z.set(`${I.length(zt).toFixed(2)} mm`);
    }, P = (Vt, Rt) => {
      const { xAxis: $t, yAxis: zt, zAxis: Bt, origin: Kt } = Vt, ne = I.create(), ae = I.create(), Ge = I.create();
      if (I.scaleAndAdd(ne, Kt, $t, 0.5), I.scaleAndAdd(ae, Kt, zt, 0.5), I.scaleAndAdd(Ge, Kt, Bt, 0.5), x.x.set(ne), x.y.set(ae), x.z.set(Ge), Rt) {
        const He = (je, we, ln) => {
          const Ls = I.create(), ys = ZN(ln), re = I.create();
          return I.normalize(re, we), I.scaleAndAdd(Ls, je, re, ys + 1), Ls;
        };
        X.x.set(He(Rt.origin, Rt.xAxis, Vt.xAxis)), X.y.set(He(Rt.origin, Rt.yAxis, Vt.yAxis)), X.z.set(He(Rt.origin, Rt.zAxis, Vt.zAxis));
      }
      F(Vt), R();
    };
    this.onEvent(this.parentView.events.cameraModified, () => {
      R();
      const Vt = ki(n, s, this.plane.getOrigin(), 1, 1, 0.1);
      this.planeRepresentation.updatePointScale(Vt);
    });
    const j = N(
      Dht,
      {
        xPosition: V.x,
        yPosition: V.y,
        zPosition: V.z,
        xLabel: z.x,
        yLabel: z.y,
        zLabel: z.z
      },
      { enabled: !1 }
    ), H = N(
      LTt,
      {
        xPosition: C.x,
        yPosition: C.y,
        zPosition: C.z,
        xLabel: new qt("X"),
        yLabel: new qt("Y"),
        zLabel: new qt("Z")
      },
      { enabled: !1 }
    ), B = () => {
      j.setEnabled(!0);
    }, $ = () => {
      H.setEnabled(!0);
    };
    let A;
    this.onCleanup(() => {
      A == null || A();
    });
    let E = !1;
    const ct = (Vt, Rt, $t, zt) => {
      A == null || A(), A = null, E || (this.planeRepresentation.getActors().forEach((Kt) => {
        s.addActor(Kt);
      }), this.arrowRepresentation.getActors().forEach((Kt) => {
        s.addActor(Kt);
      }), E = !0), this.displayMode === 0 && (this.objectSlices.get(Vt) || at(Vt));
      const Bt = this.context.getActorId(Vt);
      if (Bt) {
        const Kt = this.context.constructionInfos.get(Bt);
        Kt == null || Kt.model.boundingBoxVisibility.set(!0), Kt == null || Kt.model.coordinateSystemVisibility.set(!0);
        const ne = () => {
          const ae = (Kt == null ? void 0 : Kt.model.visibility.get()) && Kt.model.boundingBoxVisibility.get() || !1;
          j.setEnabled(ae);
          const Ge = (Kt == null ? void 0 : Kt.model.visibility.get()) && Kt.model.coordinateSystemVisibility.get() || !1;
          H.setEnabled(Ge);
        };
        if (Kt == null || Kt.model.visibility.subscribe(ne), Kt == null || Kt.model.boundingBoxVisibility.subscribe(ne), Kt == null || Kt.model.coordinateSystemVisibility.subscribe(ne), A = () => {
          this.displayMode === 0 && this.objectSlices.get(Vt) && dt(Vt), Kt == null || Kt.model.visibility.unsubscribe(ne), Kt == null || Kt.model.boundingBoxVisibility.unsubscribe(ne), Kt == null || Kt.model.boundingBoxVisibility.set(!1), Kt == null || Kt.model.coordinateSystemVisibility.unsubscribe(ne), Kt == null || Kt.model.coordinateSystemVisibility.set(!1);
        }, Vt.getVisibility()) {
          const ae = this.context.reconstructionBoundingBoxes.get(Vt), Ge = this.context.reconstructionCoordinateSystems.get(Vt);
          ae && (P(ae, Ge), B(), Ge && $());
        }
      }
      $t || ($t = s.getActiveCamera().getDirectionOfProjection()), zt || (zt = s.getActiveCamera().getViewUp()), this.updatePlane({ origin: Rt, normal: $t, viewUp: zt }), Z(Rt, $t, zt), this.show(), this.sceneRefresh(), this.parentView.sceneRefresh();
    };
    this.onEvent(this.selectAndCenterObjectEvent, (Vt) => {
      const Rt = this.context.constructionInfos.get(Vt);
      if (!Rt) return;
      const $t = Rt.getStlActor();
      if (!$t) return;
      const zt = this.context.reconstructionBoundingBoxes.get($t);
      let Bt = $t.getCenter(), Kt = s.getActiveCamera().getViewUp(), ne = s.getActiveCamera().getDirectionOfProjection();
      zt && (Bt = I.create(), I.scaleAndAdd(Bt, zt.origin, zt.xAxis, 0.5), I.scaleAndAdd(Bt, Bt, zt.yAxis, 0.5), I.scaleAndAdd(Bt, Bt, zt.zAxis, 0.5), Kt = I.create(), I.negate(Kt, zt.zAxis), I.normalize(Kt, Kt), ne = I.create(), I.negate(ne, zt.yAxis), I.normalize(ne, ne)), ct($t, Bt, ne, Kt);
    });
    const at = (Vt) => {
      if (this.objectSlices.get(Vt))
        return !1;
      const Rt = Vt.getProperty().getColor(), $t = new md(() => {
        const Bt = this.context.viewConfiguration.colors.get().sectionalViewActorColor;
        return this.cutterUseStlColors.get() ? Rt : Bt;
      }), zt = new SMt(Vt, this.plane, $t);
      return this.objectSlices.set(Vt, zt), this.renderer.addActor(zt.getActor()), !0;
    }, dt = (Vt) => {
      const Rt = this.objectSlices.get(Vt);
      return Rt ? (this.renderer.removeActor(Rt.getActor()), Rt.delete(), this.objectSlices.delete(Vt), !0) : !1;
    };
    let gt = !1;
    const Wt = () => {
      gt || (gt = !0, queueMicrotask(() => {
        gt = !1, this.sceneRefresh();
      }));
    };
    this.context.constructionInfos.forEach((Vt) => {
      this.watch(Vt.model.visibility, (Rt) => {
        const $t = Vt.getStlActor();
        Rt ? at($t) && Wt() : dt($t) && Wt();
      }), this.watch(Vt.model.stlColor, (Rt) => {
        const $t = Vt.getStlActor(), zt = this.objectSlices.get($t);
        zt && (zt.setColor(Rt), Wt());
      });
    });
    const Zt = () => {
      for (const Vt of this.context.constructionInfos.values()) {
        const Rt = Vt.getStlActor();
        Rt.getVisibility() && at(Rt);
      }
    };
    this.displayMode === 1 && Zt();
    const Gt = (Vt, Rt, $t, zt) => {
      const Bt = $t[0], Kt = $t[1], ne = this.origin, ae = Math.sqrt(this.planeWidth * this.planeWidth + this.planeHeight * this.planeHeight) / 2, Ge = I.create(), He = I.create();
      hS(this.parentView, Vt, Bt, Kt, ne, Ge, He);
      let je;
      if (zt) {
        const Ls = Vt.getDirectionOfProjection();
        je = pbt(ne, zt, ae, Ls, Rt, $t);
      } else
        je = hbt(ne, ae, Ge, Rt, $t);
      const we = this.plane.getNormal(), ln = this.viewUp;
      EL(je, we, we), I.transformMat4(ln, ln, je), this.updatePlane({ normal: we, viewUp: ln }, !0);
    }, Tt = (Vt, Rt, $t, zt, Bt) => {
      const Kt = I.create(), ne = I.create();
      return hS(this.parentView, Vt, zt, Bt, Rt, Kt, ne), Fs(ne, Rt, $t, ne), ne;
    }, Q = (Vt, Rt) => {
      const $t = Vt.getDirectionOfProjection(), zt = I.create(), Bt = I.create();
      return I.cross(Bt, $t, Rt), I.cross(zt, Rt, Bt), I.normalize(zt, zt), zt;
    }, D = (Vt, Rt) => {
      const $t = I.create(), zt = I.create(), Bt = this.plane.getNormal(), Kt = this.plane.getOrigin();
      hS(this.parentView, s.getActiveCamera(), Vt, Rt, Kt, $t, zt), I.normalize($t, $t);
      const ne = I.create();
      zL(Bt, Kt, zt, $t, ne);
      const { edge: ae, distance2: Ge } = this.planeRepresentation.getClosestEdge(ne), He = ki(n, s, Kt, 1, 1) * 10;
      return Ge < 1 * He * He ? ae : null;
    }, q = (Vt) => {
      const Rt = I.create();
      I.add(Rt, this.plane.getOrigin(), Vt), this.updatePlane({ origin: Rt }, !0), g();
    }, nt = (Vt, Rt, $t, zt) => {
      const Bt = s.getActiveCamera(), Kt = this.plane.getOrigin(), ne = this.plane.getNormal(), ae = Tt(Bt, Kt, this.viewUp, Vt, Rt), Ge = Tt(Bt, Kt, this.viewUp, $t, zt), He = I.create();
      I.sub(He, Ge, ae);
      const je = I.create();
      I.cross(je, ne, this.viewUp), I.normalize(je, je);
      const we = ubt(He, [0, 0, 0], je);
      q(we);
    }, et = /* @__PURE__ */ (() => {
      let Vt = [0, 0], Rt = !1;
      return {
        start: (ne, ae) => {
          Rt = !0, Vt = [ne, ae];
        },
        update: (ne, ae) => {
          nt(...Vt, ne, ae), Vt = [ne, ae];
        },
        end: () => {
          Rt = !1;
        },
        getActive: () => Rt
      };
    })();
    let ot, it = [0, 0, 0];
    this.eventHandler = {
      onLeftPress: (Vt, Rt) => {
        if (Vt !== this.parentView)
          return !1;
        const { x: $t, y: zt } = Rt.position, Bt = Vt.pickPropPoint($t, zt);
        if (Bt) {
          const [ne] = Bt;
          if (this.arrowRepresentation.hasActor(ne))
            return et.start($t, zt), lS(0, () => {
              et.end(), this.arrowRepresentation.setHighlight(!1) && this.sceneRefresh();
            }), !0;
        }
        const Kt = D($t, zt);
        if (Kt) {
          this.planeRepresentation.setEdgeHighlight(Kt), ot = I.create(), Kt === "left" || Kt === "right" ? I.copy(ot, this.viewUp) : I.cross(ot, this.plane.getNormal(), this.viewUp), I.normalize(ot, ot);
          const ne = s.getActiveCamera(), ae = Q(ne, ot);
          return it = Tt(ne, this.plane.getOrigin(), ae, $t, zt), lS(0, () => {
            ot = null, this.planeRepresentation.setEdgeHighlight(null) && this.sceneRefresh();
          }), !0;
        }
        if (Bt) {
          const [ne, ae] = Bt;
          if (n.getActorType(ne) === Yt._STL_OBJECT || n.getActorType(ne) === Yt._STL_TEETH_MODEL || n.getActorType(ne) === Yt._STL_PROSTHESIS || n.getActorType(ne) == Yt._STL_TOOTH)
            return ct(ne, ae), !0;
        }
        return !1;
      },
      onMouseMove: (Vt, Rt, $t) => {
        if ($t.cameraDragActive || Vt !== this.parentView)
          return !1;
        if (et.getActive()) {
          const { x: Kt, y: ne } = Rt.position;
          return et.update(Kt, ne), this.sceneRefresh(), !0;
        }
        if (ot) {
          const { x: Kt, y: ne } = Rt.position, ae = s.getActiveCamera(), Ge = Q(ae, ot), He = Tt(ae, this.plane.getOrigin(), Ge, Kt, ne);
          return Gt(ae, it, He, ot), g(), it = He, Vt.sceneRefresh(), !0;
        }
        let zt = !1;
        const Bt = Vt.pickProp(Rt.position.x, Rt.position.y);
        if (Bt) {
          if (this.arrowRepresentation.hasActor(Bt))
            return zt = zt || this.arrowRepresentation.setHighlight(!0), zt = zt || this.planeRepresentation.setEdgeHighlight(null), zt && this.sceneRefresh(), !1;
          zt = zt || this.arrowRepresentation.setHighlight(!1);
        } else
          zt = zt || this.arrowRepresentation.setHighlight(!1);
        if (!ot) {
          const { x: Kt, y: ne } = Rt.position, ae = D(Kt, ne);
          zt = zt || this.planeRepresentation.setEdgeHighlight(ae);
        }
        return zt && Vt.sceneRefresh(), !1;
      }
    };
    const ht = (Vt, Rt, $t, zt) => {
      const Bt = this.displayToWorld(Vt, Rt, 0), Kt = this.displayToWorld($t, zt, 0), ne = I.create();
      I.sub(ne, Kt, Bt), q(ne);
    };
    let lt = !1, mt;
    const Xt = yJ({
      onLeftPress: (Vt, Rt) => {
        if (lt)
          return !0;
        const { x: $t, y: zt } = Rt.position, Bt = this.pickWorldPoint($t, zt), Kt = I.create();
        return I.sub(Kt, Bt, this.plane.getOrigin()), this.updatePlane({ origin: Bt }), g(), this.cameraModified(), this.sceneRefresh(), !0;
      },
      onMiddlePress: (Vt, Rt) => {
        const { x: $t, y: zt } = Rt.position;
        return lt = !0, mt = [$t, zt], lS(1, () => {
          lt = !1;
        }), !0;
      },
      onMouseMove: (Vt, Rt) => {
        const { x: $t, y: zt } = Rt.position;
        return lt ? (ht($t, zt, ...mt), this.cameraModified(), this.sceneRefresh(), mt = [$t, zt], !0) : !1;
      },
      onMouseWheel: (Vt, Rt) => {
        if (Rt.spinY === 0) return !0;
        const $t = Rt.spinY > 0, zt = 0.1, Bt = I.create();
        return I.scaleAndAdd(Bt, this.plane.getOrigin(), this.plane.getNormal(), $t ? zt : -zt), this.updatePlane({ origin: Bt }, !0), g(), this.cameraModified(), !0;
      }
    });
    (Se = this.context.getInteractorStyle()) == null || Se.setViewEventHandler(this, Xt), this.onCleanup(() => {
      var Vt;
      (Vt = this.context.getInteractorStyle()) == null || Vt.setViewEventHandler(this, null);
    });
    const At = (Vt, Rt) => {
      const $t = I.create(), zt = I.create(), Bt = ut.create();
      ut.fromRotation(Bt, Rt, Vt), I.transformMat4($t, this.plane.getNormal(), Bt), I.transformMat4(zt, this.viewUp, Bt), this.updatePlane({ normal: $t, viewUp: zt }, !0);
    }, he = new se();
    this.onEvent(he, ({ degrees: Vt }) => {
      const Rt = Vt * Math.PI / 180, $t = I.create();
      I.cross($t, this.plane.getNormal(), this.viewUp), At($t, Rt), g(), this.sceneRefresh();
    });
    const ue = new se();
    this.onEvent(ue, ({ degrees: Vt }) => {
      const Rt = Vt * Math.PI / 180;
      At(this.viewUp, Rt), g(), this.sceneRefresh();
    }), T(m5, {
      type: "vertical",
      context: this.context,
      viewSize: this.viewSize,
      events: {
        rotateEvent: he
      }
    }), T(m5, {
      type: "horizontal",
      context: this.context,
      viewSize: this.viewSize,
      events: {
        rotateEvent: ue
      }
    });
    const Dt = (Vt) => {
      const Rt = a.get();
      l = l + Vt / Rt[0], l = Math.max(0.1, Math.min(l, 1)), u(), h(), g(), this.sceneRefresh();
    }, ee = (Vt) => {
      const Rt = a.get();
      c = c + Vt / Rt[1], c = Math.max(0.1, Math.min(c, 1)), u(), h(), g(), this.sceneRefresh();
    };
    T(d5, {
      side: "left",
      onResize: Dt
    }), T(d5, {
      side: "top",
      onResize: ee
    });
    const yt = new se(), fe = new se();
    T(GTt, {
      events: {
        zoomIn: yt,
        zoomOut: fe
      }
    });
    const Xe = 0.2;
    this.onEvent(yt, () => {
      const Vt = this.renderer.getActiveCamera(), Rt = Vt.getParallelScale();
      Vt.setParallelScale(Rt * (1 - Xe)), this.updatePlane({ origin: this.plane.getOrigin() }), g(), this.cameraModified();
    }), this.onEvent(fe, () => {
      const Vt = this.renderer.getActiveCamera(), Rt = Vt.getParallelScale();
      Vt.setParallelScale(Rt * (1 / (1 - Xe))), this.updatePlane({ origin: this.plane.getOrigin() }), g(), this.cameraModified();
    }), this.updateGrid(), this.renderer.addActor(this.grid.getActor()), this.onEvent(this.events.cameraModified, () => {
      this.updateGrid();
    }), r && ct(r.actor, r.position), this.onEvent(n.weblinkSettings.onSettingsModified, () => {
      for (const Vt of n.reconstructionBoundingBoxes.values())
        F(Vt);
      for (const Vt of n.objects.measurementsObjects.get().values()) {
        const Rt = Vt.annotation;
        Rt instanceof Kp && Rt.updateDistanceLabel();
      }
    });
  }
  updatePlane(e, n) {
    const s = this.origin;
    if (e.origin && (this.origin = e.origin, this.plane.setOrigin(e.origin)), e.normal && this.plane.setNormal(e.normal), e.viewUp && (this.viewUp = e.viewUp), e.normal || e.viewUp)
      this.resetCamera(n);
    else if (e.origin) {
      const r = I.create();
      I.sub(r, e.origin, s), this.renderer.getActiveCamera().translate(r[0], r[1], r[2]);
    }
    for (const [r, a] of this.context.objects.measurementsObjects.get().entries())
      a.view === this && this.context.toolManager.measurementsTool.deleteMeasurementById(r);
    this.updateGrid();
  }
  updateGrid() {
    const e = this.plane.getOrigin(), n = this.plane.getNormal(), s = this.viewUp, r = 1, a = pTt(this.context, this.renderer, e, r);
    this.grid.setVisibility(a > 4);
    let o = Math.ceil(Math.max(...this.viewSize.get()) / a * 1.3);
    o % 2 !== 0 && o++, I.scaleAndAdd(e, e, n, 1);
    const { sectionalViewBackground: l, sectionalViewActorColor: c } = this.context.viewConfiguration.colors.get(), u = EZt(l, c, 0.1);
    this.grid.setData({ origin: e, normal: n, viewUp: s, spacing: r, nCells: o, color: u });
  }
  resetCamera(e) {
    const n = I.create(), s = this.plane.getNormal(), r = this.plane.getOrigin();
    I.scaleAndAdd(n, r, s, -10);
    const a = this.renderer.getActiveCamera();
    a.setPosition(...n), a.setDirectionOfProjection(...s), a.setViewUp(this.viewUp), e || a.setParallelScale(10);
  }
  isViewMode3D() {
    return !0;
  }
  panToPosition() {
    console.warn("panToPosition not implemented");
  }
  pickWorldPoint(e, n) {
    const s = super.pickWorldPoint(e, n), r = I.create();
    return Fs(s, this.plane.getOrigin(), this.plane.getNormal(), r), r;
  }
  selectAndCenterObject(e) {
    this.selectAndCenterObjectEvent.notify(e);
  }
  delete() {
    this.planeRepresentation.delete(), this.arrowRepresentation.delete(), this.objectSlices.forEach((e) => {
      e.delete();
    }), this.plane.delete(), this.grid.delete(), this.reactivity.cleanupAll(), this.context.removeSectionalView(this), super.cleanup();
  }
}
function hS(i, t, e, n, s, r, a) {
  if (t.getParallelProjection()) {
    const o = i.displayToWorld(e, n, 0);
    a[0] = o[0], a[1] = o[1], a[2] = o[2], I.copy(r, t.getDirectionOfProjection());
  } else {
    const o = i.displayToWorld(s[0], s[1], s[2]), l = t.getPositionByReference();
    for (let c = 0; c < 3; c++)
      a[c] = o[c], r[c] = a[c] - l[c];
    I.normalize(r, r), I.copy(a, l);
  }
}
class VMt {
  constructor(t, e) {
    S(this, "info", new qt([]));
    S(this, "context");
    S(this, "camera");
    S(this, "planes", []);
    this.context = t, this.camera = e;
  }
  addClippingPlane() {
    const t = this.context.objects.getActors(), e = this.camera.getDirectionOfProjection(), n = Tz(t);
    if (!n)
      return;
    const s = Mz(n), r = {
      id: nl(),
      origin: s,
      normal: e,
      invert: !1,
      activated: !0,
      rotate: !1,
      position: 0.5
    }, a = new XMt(r);
    this.planes.push(a), t.forEach((o) => {
      var l;
      (l = o.getMapper()) == null || l.addClippingPlane(a.plane);
    }), this.updatePlaneInfo();
  }
  removePlane(t) {
    const e = this.getPlane(t);
    return e ? (Nz(this.context.objects.getActors(), e.plane), this.planes.splice(this.planes.indexOf(e), 1), this.updatePlaneInfo(), !0) : !1;
  }
  invertPlane(t) {
    const e = this.getPlane(t);
    if (e) {
      const n = I.create();
      return I.negate(n, e.properties.normal), e.properties.normal = n, e.plane.setNormal(n), !0;
    }
    return !1;
  }
  setPlaneToMiddle(t) {
    const e = this.getPlane(t);
    if (e) {
      const n = [1, 0, 0];
      if (n === e.properties.normal)
        return !1;
      e.properties.normal = n, e.plane.setNormal(n), this.updatePlaneInfo();
    }
    return !0;
  }
  setPlanePosition(t, e) {
    const n = this.getPlane(t);
    if (n) {
      const s = this.updatePlane(n, e, n.properties.normal);
      return this.updatePlaneInfo(), s;
    }
    return !1;
  }
  setPlaneActivated(t) {
    const e = this.getPlane(t);
    return e ? (e.properties.activated ? (e.properties.activated = !1, Nz(this.context.objects.getActors(), e.plane)) : (e.properties.activated = !0, IMt(this.context.objects.getActors(), e.plane)), this.updatePlaneInfo(), !0) : !1;
  }
  setPlaneRotate(t) {
    const e = this.getPlane(t);
    return e ? (e.properties.rotate = !e.properties.rotate, this.updatePlaneInfo(), this.updateRotations()) : !1;
  }
  cameraRotationModified() {
    return this.updateRotations();
  }
  getPlane(t) {
    return this.planes.find((e) => e.properties.id === t) || null;
  }
  updatePlaneInfo() {
    this.info.set(this.planes.map((t) => ({
      id: t.properties.id,
      sliderValue: t.properties.position,
      rotate: t.properties.rotate,
      activated: t.properties.activated
    })));
  }
  updateRotations() {
    let t = !1;
    return this.planes.forEach((e) => {
      if (e.properties.rotate) {
        const n = this.camera.getDirectionOfProjection();
        t = t || this.updatePlane(e, e.properties.position, n);
      }
    }), t;
  }
  updatePlane(t, e, n) {
    if (console.assert(e >= 0 && e <= 1), e === t.properties.position && n === t.properties.normal)
      return !1;
    const s = this.context.objects.getActors(), r = Tz(s);
    if (!r)
      return !1;
    const a = Mz(r), o = I.create(), l = I.create();
    I.add(o, a, n), I.sub(l, a, n);
    const c = T2(r, o, l), u = I.create();
    if (!c)
      return !1;
    I.sub(u, c[1], c[0]);
    const d = I.create();
    return I.scaleAndAdd(d, c[0], u, e), t.properties.position = e, t.properties.origin = d, t.plane.setOrigin(d), t.properties.normal = n, t.plane.setNormal(n), !0;
  }
}
class XMt {
  constructor(t) {
    S(this, "plane");
    S(this, "properties");
    this.properties = t, this.plane = li.newInstance({
      origin: t.origin,
      normal: t.normal
    });
  }
}
function Tz(i) {
  if (!i.length)
    return null;
  const t = i[0].getBounds();
  for (let e = 1; e < i.length; e++) {
    const n = i[e].getBounds();
    t[0] = Math.min(n[0], t[0]), t[1] = Math.max(n[1], t[1]), t[2] = Math.min(n[2], t[2]), t[3] = Math.max(n[3], t[3]), t[4] = Math.min(n[4], t[4]), t[5] = Math.max(n[5], t[5]);
  }
  return t;
}
function Mz(i) {
  return [
    (i[0] + i[1]) / 2,
    (i[2] + i[3]) / 2,
    (i[4] + i[5]) / 2
  ];
}
function IMt(i, t) {
  i.forEach((e) => {
    var n;
    (n = e.getMapper()) == null || n.addClippingPlane(t);
  });
}
function Nz(i, t) {
  i.forEach((e) => {
    var n;
    (n = e.getMapper()) == null || n.removeClippingPlane(t);
  });
}
class CMt {
  /**
   * Create clipping planes tool and optionally configure widget docking/movable layout.
   */
  constructor(t, e, n, s, r, a = {}) {
    S(this, "actions", {
      setWidgetVisibility: new se()
    });
    S(this, "events", {
      /** called when any plane properties are changed, requiring a redraw */
      planesModified: new se()
    });
    S(this, "widget");
    S(this, "reactivity", An());
    S(this, "onEvent", this.reactivity.onEvent);
    S(this, "context");
    S(this, "overlayComponents");
    this.context = e, this.overlayComponents = Pi(s);
    const { createVueOverlayComponent: o } = this.overlayComponents, l = {
      viewSize: a.viewSize ?? e.overlayContainerSize,
      widgetSize: a.widgetSize,
      initialPosition: a.initialPosition ?? pr.topRight,
      additionalTopMargin: a.additionalTopMargin ?? 34,
      showDockButton: a.showDockButton ?? !1,
      parent: a.parent,
      dockEvent: a.dockEvent
    }, c = new VMt(this.context, n.getActiveCamera());
    this.onEvent(t.events.cameraModified, () => {
      c.cameraRotationModified() && this.events.planesModified.notify();
    });
    const u = {
      addNewClippingPlane: new se(),
      invertPlane: new se(),
      setPlaneToMiddle: new se(),
      setPlaneRotate: new se(),
      setPlaneActivated: new se(),
      removePlane: new se(),
      setPlaneSliderValue: new se()
    };
    u.addNewClippingPlane.subscribe(() => {
      c.addClippingPlane(), this.events.planesModified.notify();
    }), u.invertPlane.subscribe((d) => {
      c.invertPlane(d) && this.events.planesModified.notify();
    }), u.setPlaneToMiddle.subscribe((d) => {
      c.setPlaneToMiddle(d) && this.events.planesModified.notify();
    }), u.setPlaneRotate.subscribe((d) => {
      c.setPlaneRotate(d) && this.events.planesModified.notify();
    }), u.setPlaneActivated.subscribe((d) => {
      c.setPlaneActivated(d) && this.events.planesModified.notify();
    }), u.removePlane.subscribe((d) => {
      c.removePlane(d) && this.events.planesModified.notify();
    }), u.setPlaneSliderValue.subscribe(({ planeId: d, value: h }) => {
      c.setPlanePosition(d, h) && this.events.planesModified.notify();
    }), this.widget = o(
      Qht,
      {
        planes: c.info,
        events: u,
        viewSize: l.viewSize,
        widgetSize: l.widgetSize,
        initialPosition: l.initialPosition,
        additionalTopMargin: l.additionalTopMargin,
        showDockButton: l.showDockButton,
        parent: l.parent,
        dockEvent: l.dockEvent
      },
      {
        enabled: r.get()
      }
    ), r.subscribe((d) => {
      this.widget.setEnabled(d);
    });
  }
  delete() {
    this.overlayComponents.cleanup(), this.reactivity.cleanupAll();
  }
}
class JDt extends op {
  constructor(e, n = {}) {
    var A;
    super(e, Nt._3D, n);
    S(this, "overlayComponents");
    S(this, "sectionalView", null);
    S(this, "objectTreeItems", new qt([]));
    for (const E of e.constructionInfos.values())
      for (const ct of E.getActors())
        this.renderer.addActor(ct);
    this.renderer.getActiveCamera().setDirectionOfProjection(0, 1, 0), this.renderer.getActiveCamera().setViewUp(0, 0, 1), this.renderer.resetCamera(), this.onEvent(this.context.onActorAdded, ({ actor: E }) => {
      this.renderer.addActor(E), this.sceneRefresh();
    });
    const s = new PT(this, this.context, this.isShown);
    this.onCleanup(() => s.delete()), this.isShown.get() && s.show(), this.watch(this.isShown, (E) => {
      E ? s.show() : s.hide();
    });
    const r = e.getModalsInstance(), a = this.context.objects.measurementsObjects;
    let o = null;
    const l = (E, ct, at) => {
      o = h(zT, {
        menuItems: E,
        x: ct,
        y: at
      });
    }, c = () => {
      o && (o.remove(), o = null);
    }, u = (E, ct, at) => {
      const dt = this.context.getActorType(E);
      if (dt !== Yt._STL_OBJECT && dt !== Yt._STL_TEETH_MODEL && dt !== Yt._STL_PROSTHESIS && dt !== Yt._STL_TOOTH)
        return !1;
      const gt = this.context.getActorId(E);
      if (gt === void 0)
        return !1;
      const Wt = f(gt);
      return Wt ? (l(Wt.items, ct, this.viewSize.get()[1] - at - 1), !0) : !1;
    }, d = {
      onRightPress: () => (c(), !1),
      onRightRelease: (E, ct, at) => {
        c();
        const { x: dt, y: gt } = ct.position;
        if (at.cameraDragActive)
          return !1;
        const Wt = E.pickProp(dt, gt);
        return Wt ? u(Wt, dt, gt) : !1;
      },
      onLeftPress: () => (c(), !1)
    };
    this.onEvent(O4.toggleInspect, (E) => {
      var ct, at, dt, gt;
      if (E && !this.sectionalView) {
        let Wt, Zt;
        for (const Q of this.context.constructionInfos.values()) {
          const D = Q.getStlActor();
          if (D && (Wt || (Wt = D), D.getVisibility())) {
            Zt = D;
            break;
          }
        }
        let Gt;
        const Tt = Zt || Wt;
        Tt && (Gt = {
          actor: Tt,
          position: Tt.getCenter()
        }), this.sectionalView = new LMt(this, this.context, this.renderer, Gt), (ct = this.context.getInteractorStyle()) == null || ct.setActiveTool(this, this.sectionalView.eventHandler), (at = this.context.getInteractorStyle()) == null || at.setViewEventHandler(this, d);
      } else !E && this.sectionalView && (this.sectionalView.delete(), this.sectionalView = null, (dt = this.context.getInteractorStyle()) == null || dt.setActiveTool(this, null), (gt = this.context.getInteractorStyle()) == null || gt.setViewEventHandler(this, null), this.sceneRefresh());
    }), (A = this.context.getInteractorStyle()) == null || A.setViewEventHandler(this, d), this.onCleanup(() => {
      var E, ct;
      (E = this.context.getInteractorStyle()) == null || E.setActiveTool(this, null), (ct = this.context.getInteractorStyle()) == null || ct.setViewEventHandler(this, null);
    });
    const { createVueOverlayComponent: h, cleanup: p } = Pi(this.overlayContainer.getElement());
    this.onCleanup(() => p());
    const m = (E) => {
      const ct = this.contextState.object3DInfos.get().find((at) => at.id === E);
      if (!ct) {
        console.warn("pan to position: item not found");
        return;
      }
      WP.notify({ position: ct.position });
    }, b = (E) => {
      E.model.stlOpacity.update((ct) => ct === 1 ? 0.5 : 1), this.sceneRefresh();
    }, y = (E) => {
      E.model.visibility.update((ct) => !ct), this.sceneRefresh();
    }, Z = (E, ct) => {
      const at = 1 - ct / 100;
      E.model.stlOpacity.set(at), this.sceneRefresh();
    }, g = (E) => {
      const ct = E.model.stlColor.get();
      r.showColorPickerModal(jt("shared.setItemColor"), ct).then((at) => {
        at !== null && at !== ct && (E.model.stlColor.set(at), this.sceneRefresh());
      });
    }, f = (E) => {
      const ct = this.context.constructionInfos.get(E);
      return ct ? {
        items: [
          {
            label: jt("medic-web-engine.toggleTransparency"),
            command: () => {
              b(ct);
            }
          },
          {
            label: jt("medic-web-engine.toggleVisibility"),
            command: () => {
              y(ct);
            }
          },
          {
            label: jt("medic-web-engine.transparency"),
            items: [0, 20, 50, 80, 100].map((dt) => ({ label: dt + "%", command: () => Z(ct, dt) }))
          },
          {
            label: jt("medic-web-engine.setColor"),
            command: () => {
              g(ct);
            }
          }
        ]
      } : (console.warn("create dropdown: item not found"), null);
    }, T = (E) => {
      var at;
      if (!this.context.constructionInfos.get(E)) {
        console.warn("object list item click: item not found");
        return;
      }
      (at = this.sectionalView) == null || at.selectAndCenterObject(E);
    };
    let M = !1;
    const N = () => {
      M || (M = !0, queueMicrotask(() => {
        M = !1, this.sceneRefresh();
      }));
    }, W = (E, ct) => {
      const at = this.context.constructionInfos.get(E);
      if (at) {
        const gt = at.model.visibility.get();
        ct !== gt && (at.model.visibility.set(ct), N());
        return;
      }
      if (a.get().get(E)) {
        this.context.toolManager.measurementsTool.measurementTool.setSingleMeasurementVisibility(E, ct);
        return;
      }
    }, x = (E) => W(E, !0), V = (E) => W(E, !1), X = () => {
      const E = this.contextState.object3DInfos.get().map((ct) => ({
        key: ct.id,
        label: ct.name,
        visible: ct.visible,
        color: ct.color || [255, 255, 0],
        dropdown: f,
        onClick: T,
        onDoubleClick: m,
        onSelect: x,
        onUnselect: V
      }));
      this.objectTreeItems.set(E);
    };
    this.watch(this.contextState.object3DInfos, () => {
      X();
    }), X();
    const C = new qt([]), R = () => {
      const E = [];
      for (const [ct, at] of a.get().entries())
        E.push({
          key: ct,
          label: at.annotation.name.get(),
          visible: at.annotation.getVisible(),
          color: [255, 0, 255],
          onSelect: x,
          onUnselect: V
        });
      C.set(E);
    };
    R(), this.watch(a, () => R());
    const z = nl(), F = nl(), P = new md(() => {
      const E = [], ct = this.objectTreeItems.get();
      ct.length && E.push({
        key: z,
        label: jt("implant-planner.objects"),
        children: ct
      });
      const at = C.get();
      return at.length && E.push({
        key: F,
        label: jt("medic-web-engine.measurements"),
        children: at
      }), {
        items: E
      };
    }), j = new qt([320, 419]), H = this.context.overlayComponents.createVueOverlayComponent($G, {
      objectTree: P,
      initialExpandedKeys: [z, F],
      viewSize: this.context.overlayContainerSize,
      listSize: j,
      initialPosition: pr.topRight,
      showDockButton: !0,
      parent: this.context.getOverlayContainer(),
      additionalTopMargin: 0,
      dockEvent: () => {
        this.context.dockOverlays();
      }
    }), B = new qt(!0), $ = new CMt(
      this,
      this.context,
      this.renderer,
      this.context.overlayContainerGlobal,
      new qo(B),
      {
        viewSize: this.context.overlayContainerSize,
        initialPosition: pr.topRight,
        additionalTopMargin: 0,
        showDockButton: !1,
        parent: this.context.getOverlayContainer(),
        dockEvent: () => {
          this.context.dockOverlays();
        }
      }
    );
    $.events.planesModified.subscribe(() => {
      this.sceneRefresh(), this.context.dockOverlays();
    }), this.onCleanup(() => {
      $.delete();
    }), this.overlayComponents = {
      objectList: H
    }, this.context.dockOverlays();
  }
  isViewMode3D() {
    return !0;
  }
  cameraModified() {
    super.cameraModified();
  }
  panToPosition(e, n, s) {
    const r = this.renderer.getActiveCamera(), a = r.getDistance(), o = r.getViewPlaneNormal();
    r.setPosition(e + a * o[0], n + a * o[1], s + a * o[2]), r.setFocalPoint(e, n, s), this.renderer.resetCameraClippingRange(), this.cameraModified();
  }
  sceneRepaint(e) {
    var n;
    super.sceneRepaint(e), (n = this.sectionalView) == null || n.sceneRepaint(e);
  }
  fitZoomToScreen() {
    const e = this.renderer.computeVisiblePropBounds();
    this.renderer.resetCameraClippingRange(e);
    const n = ((e[1] - e[0]) ** 2 + (e[3] - e[2]) ** 2 + (e[5] - e[4]) ** 2) ** 0.5 * 0.5, [s, r] = this.state.viewSize.get();
    let a = 1;
    const o = s / n;
    n * o > r ? a = n / 2 : a = (n + (r - n * o) / o) / 2, this.renderer.getActiveCamera().setParallelScale(a), this.context.repaint();
  }
  cleanup() {
    var e;
    (e = this.sectionalView) == null || e.cleanup(), super.cleanup();
  }
}
class YMt {
  constructor(t, e, n, s, r = "") {
    S(this, "menu");
    S(this, "viewMode");
    S(this, "reactivity", An());
    S(this, "overlayContainer");
    S(this, "resizeObserver");
    S(this, "overlayComponents");
    S(this, "renderWindow");
    S(this, "resizeRenderPending", !1);
    S(this, "rendererOrientationWidget");
    S(this, "handler");
    S(this, "events");
    // private menuEnabled: ReadableObservable<boolean>;
    S(this, "visibility", !1);
    S(this, "onCleanupArray", []);
    S(this, "onCleanup", (t) => {
      this.onCleanupArray.push(t);
    });
    S(this, "resourcesUrl", "");
    if (this.resourcesUrl = r, this.overlayContainer = Lt(t), this.overlayComponents = Pi(t), this.events = e, this.handler = n, this.viewMode = s, this.rendererOrientationWidget = ld.newInstance(), this.rendererOrientationWidget.setInteractive(!1), this.updateOrientationWidgetPosition(Ce.fullscreen), this.rendererOrientationWidget.setBackground(0, 0, 0, 0.5), this.viewMode == 0 || this.viewMode == 7 || this.viewMode == 16) {
      const { createVueOverlayComponent: a } = this.overlayComponents;
      this.menu = a(
        GP,
        {
          model: null,
          view: this.viewMode,
          size: 40,
          margin: 5,
          handler: this.viewMode == 16 ? n : void 0
        },
        {
          enabled: !0
        }
      );
    }
    this.reactivity.onEvent(uC, ({ orientation: a, id: o }) => {
      if (this.viewMode == o)
        if (this.viewMode == 0 || this.viewMode == 7) {
          let l = 0;
          switch (a) {
            case ks.Left:
              l = 2;
              break;
            case ks.Right:
              l = 3;
              break;
            case ks.Front:
              l = 0;
              break;
            case ks.Back:
              l = 1;
              break;
            case ks.Top:
              l = 4;
              break;
            case ks.Bottom:
              l = 5;
              break;
          }
          new Promise((c) => {
            const u = (d) => {
              c(d);
            };
            n.SetOrientationAsync(l, u);
          });
        } else this.viewMode == 16;
    }), this.reactivity.onEvent(this.events.SetVisibilityEvent, (a) => {
      var o;
      (o = this.menu) == null || o.setEnabled(a), a ? this.show() : this.hide();
    }), this.reactivity.onEvent(this.events.CameraChanged, () => {
      var o;
      const a = this.getSourceCamera();
      a && this.alignOrientationWidget(a), (o = this.renderWindow) == null || o.render();
    }), this.resizeObserver = new ResizeObserver((a) => {
      for (const o of a)
        o.target === this.overlayContainer.value && (this.updateOrientationWidgetPosition(Ce.fullscreen), this.queueResizeRender());
    }), this.resizeObserver.observe(this.overlayContainer.value);
  }
  setRenderWindow(t) {
    this.renderWindow || (this.renderWindow = t, this.loadHeadModel(), this.show());
  }
  show() {
    this.renderWindow && !this.renderWindow.hasRenderer(this.rendererOrientationWidget) && (this.renderWindow.addRenderer(this.rendererOrientationWidget), this.visibility = !0);
  }
  hide() {
    this.renderWindow && this.renderWindow.hasRenderer(this.rendererOrientationWidget) && (this.renderWindow.removeRenderer(this.rendererOrientationWidget), this.visibility = !1);
  }
  isVisible() {
    return this.visibility;
  }
  delete() {
    var t;
    (t = this.resizeObserver) == null || t.disconnect(), this.onCleanupArray.reduceRight((e, n) => (n(), null), null), this.overlayComponents.cleanup(), this.reactivity.cleanupAll();
  }
  async loadHeadModel() {
    var a;
    const t = zG.newInstance(), e = this.resourcesUrl + "head_model.stl";
    await t.setUrl(e, {
      binary: !0
    });
    const n = Ue.newInstance();
    n.setInputConnection(t.getOutputPort()), n.setScalarVisibility(!1);
    const s = Re.newInstance();
    s.setMapper(n), this.rendererOrientationWidget.addActor(s), s.getProperty().setAmbient(0), s.getProperty().setDiffuse(0.7), s.getProperty().setSpecular(0), this.rendererOrientationWidget.getActiveCamera().setParallelProjection(!0);
    const r = this.getSourceCamera();
    r && this.alignOrientationWidget(r), (a = this.rendererOrientationWidget.getRenderWindow()) == null || a.render(), this.onCleanup(() => {
      s.delete(), n.delete(), t.delete();
    });
  }
  /** update orientation widget position on screen */
  updateOrientationWidgetPosition(t) {
    if (!this.overlayContainer.value) return;
    const e = this.overlayContainer.value.getBoundingClientRect(), n = e.width, s = e.height;
    if (n && s) {
      const o = _I([n, s], {
        x: 10,
        y: s - 40 - 10,
        w: 40,
        h: 40
      });
      this.rendererOrientationWidget.setViewport(
        t.xmin + o.xmin,
        t.ymin + o.ymin,
        t.xmin + o.xmax,
        t.ymin + o.ymax
      );
    }
  }
  /** align orientation widget rotation with camera */
  alignOrientationWidget(t) {
    const e = this.rendererOrientationWidget.getActiveCamera();
    e.setPosition(...t.getPosition()), e.setFocalPoint(...t.getFocalPoint()), e.setViewUp(t.getViewUp()), this.rendererOrientationWidget.resetCamera(), e.zoom(1.4), this.rendererOrientationWidget.updateLightsGeometryToFollowCamera();
  }
  getSourceCamera() {
    var s;
    if (!this.renderWindow)
      return null;
    const t = this.renderWindow.getRenderers().filter((r) => r !== this.rendererOrientationWidget);
    if (!t.length)
      return null;
    const e = t.filter((r) => r.getInteractive());
    return ((s = (e.length ? e : t).slice().sort((r, a) => r.getLayer() - a.getLayer())[0]) == null ? void 0 : s.getActiveCamera()) ?? null;
  }
  queueResizeRender() {
    this.resizeRenderPending || !this.renderWindow || (this.resizeRenderPending = !0, requestAnimationFrame(() => {
      this.resizeRenderPending = !1, !(!this.renderWindow || !this.visibility) && this.renderWindow.hasRenderer(this.rendererOrientationWidget) && this.renderWindow.render();
    }));
  }
}
const vMt = { class: "slider-box" }, pS = 30, RMt = /* @__PURE__ */ Ne({
  __name: "ViewSliceHorizontalSlider",
  props: {
    sliceInfo: {},
    viewSize: {},
    events: {}
  },
  setup(i) {
    const t = i, e = Le(t.sliceInfo), n = Le(t.viewSize), s = te(() => {
      const { min: b, max: y, value: Z } = e.value;
      return b === y ? 0.5 : (Z - b) / (y - b);
    }), r = te(() => {
      const b = n.value[0];
      return [(b - pS) / 4, (b - pS) * 3 / 4];
    }), a = te(() => (r.value[1] - r.value[0]) * Math.max(0, Math.min(1, s.value))), o = (b) => {
      const { min: y, max: Z, value: g } = e.value, f = Math.max(y, Math.min(Z, b));
      f !== g && t.events.sliceSelectEvent.notify({
        slice: f
      });
    };
    let l = 0, c = 0;
    const u = (b, y) => {
      c = b, l = s.value;
    }, d = (b, y) => {
      let Z = l + (b - c) / (r.value[1] - r.value[0]);
      const { min: g, max: f } = e.value, T = Math.max(g, Math.min(f, Math.round(Z * (f - g) + g)));
      o(T);
    }, h = Lt();
    Ga(h, "left", "page", {
      onDragStart: u,
      onDrag: d
    });
    const p = (b) => {
      if (b.deltaY > 0) {
        const { max: y, value: Z } = e.value;
        Z < y && o(Z + 1);
      } else if (b.deltaY < 0) {
        const { min: y, value: Z } = e.value;
        Z > y && o(Z - 1);
      }
    }, m = (b) => {
      const { value: y } = e.value, Z = y + (b ? -1 : 1);
      o(Z);
    };
    return (b, y) => K(e) ? (Mt(), Ot("div", {
      key: 0,
      class: "slider-container",
      onWheel: p
    }, [
      y[4] || (y[4] = kt("div", { class: "slider-line" }, null, -1)),
      kt("div", {
        ref_key: "sliderHandle",
        ref: h,
        style: xe({
          left: a.value + "px"
        }),
        class: "slider-handle"
      }, [
        kt("div", vMt, pe(Math.round(K(e).value)), 1),
        as((Mt(), Ot("svg", {
          preserveAspectRatio: "none",
          style: { position: "absolute", height: "100%", width: "10px", left: "-12px", top: "0px" },
          viewBox: "0 0 100 100",
          onClick: y[0] || (y[0] = (Z) => m())
        }, [...y[2] || (y[2] = [
          kt("polygon", {
            points: "100 12.5 100 87.5 0 50",
            style: { fill: "white" }
          }, null, -1)
        ])], 512)), [
          [Ss, s.value > 0]
        ]),
        as((Mt(), Ot("svg", {
          style: xe([{
            left: pS + 2 + "px"
          }, { position: "absolute", height: "100%", width: "10px", top: "0px" }]),
          preserveAspectRatio: "none",
          viewBox: "0 0 100 100",
          onClick: y[1] || (y[1] = (Z) => m(!0))
        }, [...y[3] || (y[3] = [
          kt("polygon", {
            points: "0 12.5 0 87.5 100 50",
            style: { fill: "white" }
          }, null, -1)
        ])], 4)), [
          [Ss, s.value < 1]
        ])
      ], 4)
    ], 32)) : Qt("", !0);
  }
}), DMt = /* @__PURE__ */ Dn(RMt, [["__scopeId", "data-v-7a1c2f35"]]);
function DW(i) {
  if (i.length < 3)
    throw new Error(`Invalid color: ${i}`);
  if (i.length === 3)
    return `rgb(${i[0]}, ${i[1]}, ${i[2]})`;
  if (i.length === 4)
    return `rgba(${i[0]}, ${i[1]}, ${i[2]}, ${i[3]})`;
  throw new Error(`Invalid color: ${i}`);
}
function OMt(i) {
  return [i >> 16 & 255, i >> 8 & 255, i & 255];
}
const zMt = 2;
function EMt(i) {
  return !!i && i.getNumberOfPoints() > 0 && i.getNumberOfCells() > 0;
}
function kMt(i, t, e = zMt) {
  for (let n = 0; n + 3 < i.length; n += 4)
    if (Math.abs(i[n] - t[0]) > e || Math.abs(i[n + 1] - t[1]) > e || Math.abs(i[n + 2] - t[2]) > e || Math.abs(i[n + 3] - t[3]) > e)
      return !0;
  return !1;
}
async function FMt(i, t) {
  const e = new Image();
  e.src = i, await e.decode();
  const n = document.createElement("canvas");
  n.width = e.naturalWidth, n.height = e.naturalHeight;
  const s = n.getContext("2d", { willReadFrequently: !0 });
  return !s || n.width === 0 || n.height === 0 ? !1 : (s.drawImage(e, 0, 0), kMt(s.getImageData(0, 0, n.width, n.height).data, t));
}
async function rA(i, t, e) {
  return i.captureImages(t, e)[0];
}
let Wa = null, MN = null;
const Db = [], jMt = 3e4;
function DC() {
  MN && (clearTimeout(MN), MN = null);
}
function aA() {
  var i;
  try {
    (i = Wa == null ? void 0 : Wa.releaseGraphicsResources) == null || i.call(Wa);
  } catch (t) {
    console.warn("Failed to release screenshot graphics resources", t);
  }
}
function UMt() {
  if (DC(), !!Wa) {
    aA();
    try {
      Wa.setContainer(null);
    } catch (i) {
      console.warn("Failed to detach reusable screenshot render window", i);
    }
    try {
      Wa.delete();
    } catch (i) {
      console.warn("Failed to delete reusable screenshot render window", i);
    }
    Wa = null;
  }
}
function PMt() {
  DC(), MN = setTimeout(UMt, jMt);
}
function JMt() {
  Db.splice(0, 1), Db.length && Db[0]();
}
async function vg(i) {
  await new Promise((l) => {
    Db.push(l), Db.length === 1 && Db[0]();
  }), DC();
  const t = YT.newInstance();
  Wa || (Wa = vT.newInstance({ useOffScreen: !0 }));
  const e = document.createElement("div");
  e.style.width = i.width + "px", e.style.height = i.height + "px", Wa.setContainer(e);
  const n = ld.newInstance();
  t.addView(Wa), t.addRenderer(n);
  const s = i.actor.isA("vtkVolume"), r = i.actor.isA("vtkImageSlice");
  s ? n.addVolume(i.actor) : n.addActor(i.actor), n.setBackground(i.background);
  const a = n.getActiveCamera();
  a.setPosition(...i.camera.getPosition()), a.setViewUp(i.camera.getViewUp()), a.setDirectionOfProjection(...i.camera.getDirectionOfProjection()), a.setFocalPoint(...i.camera.getFocalPoint()), a.setParallelProjection(i.camera.getParallelProjection()), a.setParallelScale(i.camera.getParallelScale()), n.resetCamera(), t.render();
  const o = {
    resetCamera: !1,
    size: [i.width, i.height],
    scale: i.zoom !== void 0 ? i.zoom : 1
  };
  try {
    return await rA(t, i.format ?? "image/png", o);
  } finally {
    aA(), n.removeAllViewProps(), t.removeRenderer(n), t.removeView(Wa);
    try {
      Wa.setContainer(null);
    } catch (l) {
      console.warn("Failed to detach screenshot render window container", l);
    }
    n.delete(), t.delete(), e.remove(), JMt(), PMt();
  }
}
async function AMt(i) {
  const t = ip.newInstance();
  try {
    return t.setParallelProjection(!0), i.orientation && i.focalPoint && X0({
      camera: t,
      orientation: i.orientation,
      focalPoint: i.focalPoint,
      distance: i.distance || 1
    }), await vg({
      actor: i.actor,
      camera: t,
      width: i.width,
      height: i.height,
      background: i.background,
      zoom: i.zoom,
      format: i.format
    });
  } finally {
    t.delete();
  }
}
function ADt(i, t = "data.json") {
  const e = JSON.stringify(i, null, 2), n = new Blob([e], { type: "application/json" }), s = document.createElement("a");
  s.href = URL.createObjectURL(n), s.download = t, s.click();
}
function BDt(i, t) {
  const e = document.createElement("a");
  e.download = i, e.href = t, e.click();
}
function KDt(i, t) {
  const e = document.createElement("a");
  e.download = i, e.href = URL.createObjectURL(t), e.click();
}
async function oA(i, t, e) {
  let n = "";
  const s = i.getViewWidget(t);
  if (s) {
    const r = i.layoutManager.getCurrentLayoutState().template;
    let a = Yn._FULLSCREEN_3D;
    switch (t) {
      case Nt.AXIAL:
        a = Yn._FULLSCREEN_AXIAL;
        break;
      case Nt.CORONAL:
        a = Yn._FULLSCREEN_CORONAL;
        break;
      case Nt.SAGITTAL:
        a = Yn._FULLSCREEN_SAGITTAL;
        break;
      case Nt.CROSS:
        a = Yn._FULLSCREEN_CROSS;
        break;
      case Nt.TANGENT:
        a = Yn._FULLSCREEN_TANGENT;
        break;
      case Nt.CPR:
        a = Yn._FULLSCREEN_CPR;
        break;
    }
    i.layoutManager.setLayout(a);
    const o = await aw({ context: i, view: s, noOverlay: !0, compression: e });
    o && (n = o), r && i.layoutManager.setLayout(r);
  }
  return n;
}
async function aw(i) {
  var f, T;
  const t = i.context.getRenderWindow(), e = i.context.getState().canvasSize.get(), n = {
    resetCamera: !1,
    size: e,
    scale: 1
  };
  let s = null;
  if (i.noOverlay) {
    const M = /* @__PURE__ */ new Set(), N = i.context.getViews();
    for (const W of N)
      M.add(W.getRendererOverlay());
    for (const W of i.context.getPresenterWindows()) {
      const x = W.getMainView();
      x && M.add(x.getRendererOverlay());
      const V = W.getViews();
      if (V)
        for (const X of V)
          M.add(X.getRendererOverlay());
    }
    s = Array.from(M).map((W) => ({ renderer: W, draw: W.getDraw() }));
    for (const W of s)
      W.renderer.setDraw(!1);
  }
  let r = null;
  try {
    r = await rA(t, "image/png", n);
  } finally {
    if (s)
      for (const M of s)
        M.renderer.setDraw(M.draw);
  }
  if (!r)
    return null;
  const a = i.view.state.viewport.get(), o = Bdt(e, a), { x: l, y: c, w: u, h: d } = o, h = document.createElement("canvas");
  h.style.width = u + "px", h.style.height = d + "px", h.width = u, h.height = d;
  const m = await (async (M) => new Promise((N, W) => {
    const x = new Image();
    return x.addEventListener("load", () => N(x)), x.addEventListener("error", (V) => W(V)), x.src = M, x;
  }))(r), b = h.getContext("2d");
  if (!b)
    return null;
  if (i.gradientBackground) {
    const M = b.createLinearGradient(0, 0, 0, d);
    M.addColorStop(0, DW([6, 33, 51])), M.addColorStop(1, DW([0, 99, 164])), b.fillStyle = M, b.fillRect(0, 0, u, d);
  }
  i.compression && i.background && (b.fillStyle = i.background, b.fillRect(0, 0, u, d)), (f = i.view.getPresenterWindow()) == null || f.hideOverlayComponents(!0);
  const y = i.context.getOverlayContainer(), Z = {
    // override absolute position of the div
    style: {
      position: "static"
    },
    useCORS: !0,
    // downscale overlay to vtk canvas dimensions
    pixelRatio: 1
  };
  let g;
  return i.noOverlay || (g = await gN(y, Z)), (T = i.view.getPresenterWindow()) == null || T.hideOverlayComponents(!1), b.drawImage(m, l, c, u, d, 0, 0, u, d), !i.noOverlay && g && b.drawImage(g, l, c, u, d, 0, 0, u, d), i.compression ? h.toDataURL("image/jpeg", i.compression) : h.toDataURL("image/png");
}
async function BMt(i) {
  let t = i.actor, e = null;
  if (i.actor.isA("vtkActor")) {
    i.actor = i.actor, e = Re.newInstance();
    const s = i.actor.getMapper();
    if (!s)
      return console.warn("take screenshot: mapper is null"), null;
    e.setMapper(s), e.getProperty().setColor(i.actor.getProperty().getColor()), t = e;
  }
  const n = ip.newInstance();
  try {
    return n.setParallelProjection(!0), X0({
      camera: n,
      orientation: "front",
      focalPoint: i.actor.getOrigin(),
      distance: 10
      // renderer.resetCamera is called later to set correct distance based on object size
    }), await vg({
      ...i,
      actor: t,
      camera: n
    });
  } finally {
    e == null || e.delete(), n.delete();
  }
}
async function KMt(i) {
  const t = await BMt({
    actor: i,
    width: 75,
    height: 75,
    background: [0.2, 0.2, 0.2, 1]
  });
  if (t != null)
    return t;
}
async function HDt(i, t = "dark") {
  const e = t == "dark" ? [0.2, 0.204, 0.216, 0] : [0.933, 0.933, 0.933, 0], n = await i.getScreenshot({
    width: 75,
    height: 75,
    background: e,
    orientation: "front"
  });
  if (n != null)
    return n;
}
async function lA(i, t, e = "dark") {
  const n = e == "dark" ? [0.2, 0.204, 0.216, 0] : [0.933, 0.933, 0.933, 0], s = await i.getScreenshot({
    width: 300,
    height: 300,
    background: n,
    orientation: "front",
    transform: t
  });
  if (s != null)
    return s;
}
async function _Dt(i, t) {
  const { volumeMapper: e, volumeActor: n } = i.getVolume();
  if (!e || !n)
    return;
  const s = KI.newInstance(), r = BI.newInstance();
  s.setInputData(e.getInputData()), r.setMapper(s), new XJ(t).updateVolumeOptions(s, r);
  try {
    return await KMt(r);
  } finally {
    r.delete(), s.delete();
  }
}
async function HMt(i, t, e, n, s) {
  const r = Ue.newInstance(), a = Re.newInstance();
  if (n) {
    const o = VI(i.implantInfo.stlFile.data);
    r.setInputConnection(o.getOutputPort());
  } else if (s) {
    const o = new File([new Int8Array(i.implantInfo.stlFile.data)], "file.obj"), l = await EG(o);
    r.setInputConnection(l.getOutputPort());
  } else {
    const o = LI(i.implantInfo.stlFile.data);
    o.getOutputData().getCellData().removeAllArrays(), o.getOutputData().getPointData().removeAllArrays(), r.setInputConnection(o.getOutputPort());
  }
  return a.setMapper(r), n ? r.setScalarVisibility(!0) : a.getProperty().setColor(i.color.map((o) => o / 255)), i.opacity !== void 0 && a.getProperty().setOpacity(i.opacity), a;
}
async function QDt(i) {
  const t = UT();
  t.implantInfo.stlFile.data = new Int8Array(i.data);
  const e = await HMt(t, !1, void 0, i.isPly, i.isObj), n = e.getMapper();
  try {
    n == null || n.update();
    const s = n == null ? void 0 : n.getInputData();
    if (!EMt(s))
      return console.warn("Cannot take STL screenshot: mesh contains no renderable geometry"), null;
    const r = i.background.map((l) => l / 255), a = s.getBounds(), o = [(a[0] + a[1]) / 2, (a[2] + a[3]) / 2, (a[4] + a[5]) / 2];
    for (const l of ["front", "left", "top"]) {
      const c = await AMt({
        actor: e,
        orientation: l,
        focalPoint: o,
        distance: 10,
        background: r,
        width: i.width,
        height: i.height,
        format: i.format
      });
      if (c && await FMt(c, i.background))
        return c;
    }
    return console.warn("Cannot take STL screenshot: mesh is not visible from any thumbnail camera direction"), null;
  } finally {
    e.delete(), n == null || n.delete();
  }
}
var l2 = /* @__PURE__ */ ((i) => (i._1x1 = "1x1", i._3x1 = "3x1", i._1x3 = "1x3", i._3x3 = "3x3", i._5x1 = "5x1", i))(l2 || {});
const mS = [
  { xmin: 0, xmax: 1 / 3, ymin: 0, ymax: 1 },
  { xmin: 1 / 3, xmax: 2 / 3, ymin: 0, ymax: 1 },
  { xmin: 2 / 3, xmax: 1, ymin: 0, ymax: 1 }
], bS = [
  { xmin: 0, xmax: 1, ymin: 2 / 3, ymax: 1 },
  { xmin: 0, xmax: 1, ymin: 1 / 3, ymax: 2 / 3 },
  { xmin: 0, xmax: 1, ymin: 0, ymax: 1 / 3 }
], fS = [
  { xmin: 0, xmax: 1 / 3, ymin: 2 / 3, ymax: 1 },
  { xmin: 1 / 3, xmax: 2 / 3, ymin: 2 / 3, ymax: 1 },
  { xmin: 2 / 3, xmax: 1, ymin: 2 / 3, ymax: 1 },
  { xmin: 0, xmax: 1 / 3, ymin: 1 / 3, ymax: 2 / 3 },
  { xmin: 1 / 3, xmax: 2 / 3, ymin: 1 / 3, ymax: 2 / 3 },
  { xmin: 2 / 3, xmax: 1, ymin: 1 / 3, ymax: 2 / 3 },
  { xmin: 0, xmax: 1 / 3, ymin: 0, ymax: 1 / 3 },
  { xmin: 1 / 3, xmax: 2 / 3, ymin: 0, ymax: 1 / 3 },
  { xmin: 2 / 3, xmax: 1, ymin: 0, ymax: 1 / 3 }
], gS = [
  { xmin: 0, xmax: 1 / 5, ymin: 0, ymax: 1 },
  { xmin: 1 / 5, xmax: 2 / 5, ymin: 0, ymax: 1 },
  { xmin: 2 / 5, xmax: 3 / 5, ymin: 0, ymax: 1 },
  { xmin: 3 / 5, xmax: 4 / 5, ymin: 0, ymax: 1 },
  { xmin: 4 / 5, xmax: 1, ymin: 0, ymax: 1 }
];
class oy extends wC {
  constructor(e, n, s, r = {}, a = { useWasmReslicer: !1 }) {
    super(e, ni.PresenterWindow2D);
    S(this, "views", []);
    S(this, "localRotation", new qt(0));
    S(this, "imageSpacing");
    S(this, "imageSlider", Lt(0));
    S(this, "windowSize");
    S(this, "selectedSpacing", new qt(0));
    S(this, "mainView");
    S(this, "mainViewViewport", Ce.fullscreen);
    S(this, "viewports", []);
    S(this, "layout");
    S(this, "setLayoutEvent", new se());
    S(this, "setSpacingEvent", new se());
    S(this, "imageSpacingOptions");
    S(this, "computedOffsets", []);
    S(this, "viewType");
    S(this, "viewMode");
    S(this, "viewOptions");
    S(this, "verticalSlider");
    S(this, "horizontalSlider");
    S(this, "minThickness", 1);
    S(this, "maxThickness", 128);
    S(this, "thickness");
    S(this, "filterMode", new qt(Je.MPR));
    S(this, "scoutUpToDateFlag", !0);
    this.viewType = n, this.mainView = new this.viewType(e, s, this, r, a), this.viewMode = s, this.viewOptions = r, this.viewMode < 3 && (this.minThickness = this.context.getImageData().getSpacing()[Math.min(this.viewMode, 2)], this.maxThickness = Math.round(
      this.context.getImageData().getDimensions()[Math.min(this.viewMode, 2)] * this.context.getImageData().getSpacing()[Math.min(this.viewMode, 2)]
    )), this.thickness = new qt(this.minThickness);
    const { onEvent: o, computed: l, lazyComputed: c, watch: u, cleanupAll: d } = An();
    this.onCleanup(() => d());
    const h = this.context.getState();
    this.windowSize = l(() => {
      const [N, W] = h.canvasSize.get(), x = this.viewport.get();
      return [N * (x.xmax - x.xmin), W * (x.ymax - x.ymin)];
    }), this.layout = new qt(
      "1x1"
      /* _1x1 */
    ), this.setLayout(
      "1x1"
      /* _1x1 */
    ), u(this.viewport, () => {
      this.setViewViewport(this.mainView, this.mainViewViewport), this.views.forEach((N, W) => {
        this.setViewViewport(N, this.viewports[W]);
      });
    }), o(this.setLayoutEvent, ({ preset: N }) => {
      this.setLayout(N), this.setSliceInfoNormal(), this.context.toolManager.coordControl.setCenter(this.mainView.getOrigin());
    }), this.imageSpacing = c(() => this.calculateImageSpacingForNormal(this.context.getImageData().getSpacing(), this.mainView.getNormal())), this.selectedSpacing.set(this.imageSpacing.get()), o(this.setSpacingEvent, ({ spacingMm: N }) => {
      this.selectedSpacing.set(N), this.setSliceInfoNormal(), this.context.toolManager.coordControl.setCenter(this.mainView.getOrigin());
    }), this.imageSpacingOptions = c(() => this.computeSpacingMenuOptions());
    const p = l(
      () => this.layout.get() !== "1x1"
      /* _1x1 */
    ), { createVueOverlayComponent: m, cleanup: b } = Pi(this.overlayContainer.getElement());
    this.onCleanup(() => b());
    const y = (N) => {
      this.setThicknessFcn(N);
    }, Z = (N) => {
      this.setFilterModeFcn(N);
    }, g = (N, W, x) => {
      let V = W, X = x;
      if (N == "Auto Contrast") {
        const C = this.context.getImageData().getPointData().getScalars().getRange();
        V = C[1] - C[0], X = (C[0] + C[1]) / 2;
      } else N == "Default W/L" && (V = this.context.settings.general.defaultWindowWidth, X = this.context.settings.general.defaultWindowLevel);
      this.context.getPresenterWindows().forEach((C) => {
        var R;
        (R = C.getMainView()) != null && R.isViewMode3D() || C.setWindowLevel([V, X]);
      }), this.context.repaint();
    }, f = (N) => {
      const W = this.context.getViewWidget(Nt.CPR);
      if (W) {
        const x = N * Math.PI / 180;
        this.context.toolManager.coordControl.crossAngle.set(x), this.context.toolManager.coordControl.setCenter(W.getOrigin(), W);
      }
    }, T = [Je.MPR, Je.RAYSUM, Je.MIP, Je.MINMIP, Je.SCOUT], M = m(
      Hbt,
      {
        iview: this.getMainView(),
        isFullscreen: this.isFullscreen,
        layout: this.layout,
        layouts: Object.values(l2),
        isCrossSection: p,
        spacing: this.selectedSpacing,
        spacings: this.imageSpacingOptions,
        thickness: this.thickness,
        filterMode: this.filterMode,
        filterModeOptions: T,
        minThickness: this.minThickness,
        maxThickness: this.maxThickness,
        sliceWindow: this.window,
        sliceLevel: this.level,
        setWindowLevel: g,
        setThickness: y,
        setFilterMode: Z,
        crossAngle: this.mainView.getViewMode() == Nt.CROSS ? this.context.toolManager.coordControl.crossAngle : void 0,
        openCrossAngleDialog: this.mainView.getViewMode() == Nt.CROSS ? f : void 0,
        events: {
          setFullscreenEvent: this.setFullscreenEvent,
          setLayoutEvent: this.setLayoutEvent,
          setSpacingEvent: this.setSpacingEvent,
          screenshotEvent: this.screenshotEvent
        }
      },
      {
        enabled: this.toolbarEnabled.get(),
        z: 10
      }
    );
    M.setEnabled(this.toolbarEnabled.get()), u(this.toolbarEnabled, (N) => {
      M.setEnabled(N);
    }), this.verticalSlider = m(
      IP,
      {
        sliceInfo: this.mainView.sliceInfo,
        viewSize: this.windowSize,
        events: {
          sliceSelectEvent: this.mainView.sliceSelectEvent
        }
      },
      { z: 10 }
    ), this.viewMode == Nt.CROSS && (this.horizontalSlider = m(
      DMt,
      {
        sliceInfo: this.mainView.horizontalSliceInfo,
        viewSize: this.windowSize,
        events: {
          sliceSelectEvent: this.mainView.horizontalSliceSelectEvent
        }
      },
      { z: 10 }
    )), o(this.screenshotEvent, async () => {
      if (this.mainView) {
        const N = await aw({ context: this.context, view: this.mainView });
        if (!N)
          return;
        await this.downloadAndNotifyScreenshot(N, this.mainView.getViewMode());
      }
    }), this.mainView.fitZoomToScreen();
  }
  setThicknessFcn(e) {
    console.log("oldT", this.thickness.get(), "newT", e, "d", Math.abs(this.thickness.get() - e)), Math.abs(this.thickness.get() - e) > 0.01 && (this.thickness.set(e), e != this.minThickness && this.filterMode.get() == Je.MPR && this.filterMode.set(Je.RAYSUM), e != this.maxThickness && this.filterMode.get() == Je.SCOUT && this.filterMode.set(Je.MIP), e == this.minThickness && this.filterMode.get() != Je.MPR && this.filterMode.set(Je.MPR), this.mainView.setFilterMode(this.filterMode.get(), this.thickness.get()), this.mainView.setFilterModeThickness(), this.views.forEach((n) => {
      n.setFilterMode(this.filterMode.get(), this.thickness.get()), n.setFilterModeThickness();
    }), this.setSliceInfoNormal(), this.context.toolManager.coordControl.setCenter(this.mainView.getOrigin()));
  }
  setFilterModeThicknessFcn(e, n) {
    (this.filterMode.get() != e || Math.abs(this.thickness.get() - n) > 0.01) && (this.thickness.set(n), this.filterMode.set(e), e == Je.SCOUT && (this.scoutUpToDateFlag = !1), this.mainView.setFilterMode(this.filterMode.get(), this.thickness.get()), this.mainView.setFilterModeThickness(), this.views.forEach((s) => {
      s.setFilterMode(this.filterMode.get(), this.thickness.get()), s.setFilterModeThickness();
    }), this.setSliceInfoNormal(), this.context.toolManager.coordControl.setCenter(this.mainView.getOrigin()));
  }
  setFilterModeFcn(e) {
    this.filterMode.get() != e && (this.filterMode.set(e), e == Je.MPR ? this.thickness.set(this.minThickness) : e == Je.SCOUT && (this.scoutUpToDateFlag = !1, this.thickness.set(this.maxThickness)), e != Je.MPR && this.thickness.get() == this.minThickness && this.thickness.set(2), this.mainView.setFilterMode(this.filterMode.get(), this.thickness.get()), this.mainView.setFilterModeThickness(), this.views.forEach((n) => {
      n.setFilterMode(this.filterMode.get(), this.thickness.get()), n.setFilterModeThickness();
    }), this.setSliceInfoNormal(), this.context.toolManager.coordControl.setCenter(this.mainView.getOrigin()));
  }
  calculateImageSpacingForNormal(e, n) {
    const s = I.create(), r = I.create();
    I.scaleAndAdd(s, [e[0] / 2, e[1] / 2, e[2] / 2], n, -(e[0] + e[1] + e[2])), I.scaleAndAdd(r, [e[0] / 2, e[1] / 2, e[2] / 2], n, e[0] + e[1] + e[2]);
    const a = T2([0, e[0], 0, e[1], 0, e[2]], s, r);
    return a ? I.distance(a[0], a[1]) : (console.error("failed to calculate spacing"), -1);
  }
  show(e) {
    super.show(e), this.mainView.show(e), this.views.forEach((n) => n.show(e));
  }
  hide() {
    this.mainView.hide(), this.views.forEach((e) => e.hide()), super.hide();
  }
  cleanup() {
    this.views.forEach((e) => e.cleanup()), this.mainView.cleanup(), this.computedOffsets.forEach((e) => e.stop()), super.cleanup();
  }
  getLayout() {
    return this.layout.get();
  }
  setLayout(e) {
    this.views.forEach((a) => {
      a.cleanup();
    }), this.computedOffsets.forEach((a) => a.stop()), this.computedOffsets.length = 0, this.views = [];
    const n = (a, o) => {
      const l = new md(() => o * (this.selectedSpacing.get() / this.imageSpacing.get()));
      this.computedOffsets.push(l);
      const c = new this.viewType(this.context, this.viewMode, this, this.viewOptions, {
        showOverlays: !1,
        sliceOffset: l,
        isCrossSection: !0,
        useWasmReslicer: this.mainView.useWasmReslicer
      });
      this.setViewViewport(c, a), this.views.push(c), this.viewports.push(a), c.setFilterMode(this.filterMode.get(), this.thickness.get()), c.setFilterModeThickness(), c.setWindowLevel(this.mainView.getWindowLevel());
    }, s = [255, 255, 0], r = [0, 255, 255];
    switch (e) {
      case "1x1": {
        this.mainViewViewport = Ce.fullscreen, this.setViewViewport(this.mainView, this.mainViewViewport);
        break;
      }
      case "3x1": {
        console.log("3x1"), n(mS[0], -1), n(mS[2], 1), this.mainViewViewport = mS[1], this.setViewViewport(this.mainView, this.mainViewViewport), this.views[0].setBorder(s), this.views[1].setBorder(), this.views[this.views.length - 1].setBorder(r);
        break;
      }
      case "1x3": {
        n(bS[0], -1), n(bS[2], 1), this.mainViewViewport = bS[1], this.setViewViewport(this.mainView, this.mainViewViewport), this.views[0].setBorder(s), this.views[1].setBorder(), this.views[this.views.length - 1].setBorder(r);
        break;
      }
      case "3x3": {
        for (let a = 0; a < 4; a++)
          n(fS[a], -(4 - a + 1));
        for (let a = 5; a < 9; a++)
          n(fS[a], a - 4);
        this.mainViewViewport = fS[4], this.setViewViewport(this.mainView, this.mainViewViewport), this.views[0].setBorder(s), this.views[1].setBorder(), this.views[2].setBorder(), this.views[3].setBorder(), this.views[5].setBorder(), this.views[6].setBorder(), this.views[7].setBorder(), this.views[this.views.length - 1].setBorder(r);
        break;
      }
      case "5x1": {
        console.log("5x1");
        for (let a = 0; a < 2; a++)
          console.log("i", a, "offset", -(2 - a)), n(gS[a], -(2 - a));
        for (let a = 3; a < 5; a++)
          console.log("i", a, "offset", a - 2), n(gS[a], a - 2);
        this.mainViewViewport = gS[2], this.setViewViewport(this.mainView, this.mainViewViewport), this.views[0].setBorder(s), this.views[1].setBorder(), this.views[3].setBorder(), this.views[this.views.length - 1].setBorder(r);
        break;
      }
    }
    this.mainView.setBorder(this.mainView.color), this.views.forEach((a) => a.show()), this.layout.set(e), this.setSliceInfoNormal(), this.context.toolManager.coordControl.setCenter(this.mainView.getOrigin()), this.views.forEach((a) => {
      a.fitZoomToScreen(), a.resetViewCamera();
    }), this.mainView.fitZoomToScreen(), this.mainView.resetViewCamera(), this.context.repaint();
  }
  setSliceInfoNormal() {
    this.context.setSliceInfo(this.mainView.id, {
      normal: this.mainView.getNormal(),
      color: this.mainView.color,
      crossSectionCount: this.views.length / 2,
      crossSectionSpacing: this.selectedSpacing.get(),
      thickness: this.thickness.get() != this.minThickness ? this.thickness.get() : void 0
    });
  }
  computeSpacingMenuOptions() {
    const e = this.imageSpacing.get(), n = this.mainView.getNormal(), s = I.create();
    s[0] = this.mainView.bounds[1] - this.mainView.bounds[0], s[1] = this.mainView.bounds[3] - this.mainView.bounds[2], s[2] = this.mainView.bounds[5] - this.mainView.bounds[4];
    const a = (Math.abs(s[0] * n[0]) + Math.abs(s[1] * n[1]) + Math.abs(s[2] * n[2])) / (this.views.length + 1), o = 1, l = [];
    for (let c = 0; c < 11; c++) {
      let u;
      c < 4 ? u = e * (1 + c * o) : u = e * (1 + (c - 2) * (c - 2) * o), u < a / 4 && l.push(u);
    }
    for (let c = 2; c >= 0; c--) {
      const u = a / Math.pow(2, c);
      l.push(u);
    }
    return l;
  }
  returnMainView() {
    return this.mainView;
  }
  getViews() {
    return this.views;
  }
  startZoom(e, n, s) {
    const r = s.displayToWorld(e, n, 0);
    this.mainView.startZoom(r[0], r[1], r[2]), this.views.forEach((a) => {
      a.startZoom(r[0], r[1], r[2]);
    });
  }
  zoomWidget(e, n) {
    this.mainView.zoomWidget(e, n), this.views.forEach((s) => {
      s.zoomWidget(e, n);
    });
  }
  endZoom() {
    this.mainView.endZoom(), this.views.forEach((e) => {
      e.endZoom();
    });
  }
  panWidget(e) {
    var n;
    (n = this.context.getInteractorStyle()) == null || n.handleMousePan(this.mainView.getRenderer(), e), this.context.toolManager.coordControl.onViewWidgetEvent(this.mainView, me.eVE_RENDER), this.views.forEach((s) => {
      var r;
      (r = this.context.getInteractorStyle()) == null || r.handleMousePan(s.getRenderer(), e), this.context.toolManager.coordControl && console.log("panWIdget");
    });
  }
  setViewOrigin(e) {
    this.mainView.setViewOrigin(e), this.UpdateViews();
  }
  setViewMatrix(e) {
    this.mainView.setViewMatrix(e), this.UpdateViews();
  }
  getViewMatrix() {
    return this.mainView.getViewMatrix();
  }
  getBookmark() {
    return {
      id: this.mainView.id,
      matrix: ut.clone(this.getViewMatrix()),
      layout: this.context.getLayout()
    };
  }
  rotateView(e, n) {
    this.mainView.rotateView(e, n), this.UpdateViews();
  }
  UpdateViews() {
    let e = ut.identity(new Float32Array(16));
    for (let n = 0; n < this.views.length; n++)
      n < this.views.length / 2 ? e = this.getViewOffMatrix(n - this.views.length / 2) : e = this.getViewOffMatrix(n - this.views.length / 2 + 1), this.views[n].setViewMatrix(e);
  }
  /**get view matrix for k-th view */
  getViewOffMatrix(e) {
    const n = this.mainView.getOrigin(), s = this.selectedSpacing.get(), r = this.mainView.getNormal(), a = this.mainView.getViewMatrix();
    for (let o = 0; o < 3; o++)
      a[12 + o] = n[o] + e * s * r[o];
    return a;
  }
  setWindowLevel(e) {
    this.mainView.setWindowLevel(e);
    for (let n = 0; n < this.views.length; n++)
      this.views[n].setWindowLevel(e);
  }
  hideOverlayComponents(e) {
    this.toolbarEnabled.set(!e), this.mainView.hideOverlayComponents(e);
  }
}
const _Mt = /* @__PURE__ */ Ne({
  __name: "TextLabels",
  props: {
    labels: {},
    fontSizePx: {},
    cssColor: {},
    textShadow: {}
  },
  setup(i) {
    const e = Le(i.labels);
    return (n, s) => (Mt(!0), Ot(Me, null, Xn(K(e), ([r, [a, o]], l) => (Mt(), Ot("div", {
      key: l,
      style: xe({
        position: "absolute",
        left: a + "px",
        top: o + "px",
        fontSize: i.fontSizePx + "px",
        color: i.cssColor,
        textShadow: i.textShadow
      }),
      class: "label"
    }, pe(r), 5))), 128));
  }
}), Wz = /* @__PURE__ */ Dn(_Mt, [["__scopeId", "data-v-e4156c78"]]);
class QMt {
  constructor() {
    S(this, "mapper", Ue.newInstance());
    S(this, "data", Ie.newInstance());
    S(this, "actor", Re.newInstance());
    S(this, "points", yi.newInstance());
    S(this, "lines", Ii.newInstance());
    S(this, "n", -1);
    S(this, "size", 0);
    // private offset: [number, number, number] = [0, 0, 0];
    S(this, "lbPoints", []);
    this.mapper.setInputData(this.data), this.actor.setMapper(this.mapper), this.data.setPoints(this.points), this.data.setLines(this.lines), this.actor.setVisibility(!0), this.actor.setPickable(!1);
  }
  setSize(t, e) {
    this.n = t, this.size = e;
  }
  update(t, e) {
    this.n > -1 && this.setData({
      n: this.n,
      size: this.size,
      height: t,
      offset: e
    });
  }
  setData(t) {
    this.n = Math.floor(t.n), this.size = t.size;
    const e = 6 * (this.n + 2), n = 3 * (this.n + 2), s = new Float32Array(e), r = new Uint16Array(n);
    for (let y = 0; y < n; y++)
      r[3 * y] = 2, r[3 * y + 1] = y * 2 + 0, r[3 * y + 2] = y * 2 + 1;
    const a = [1, 0, 0], o = [0, 0, 1], l = [0, 0, 1];
    for (let y = 0; y < 3; y++)
      l[y] = s[y] = t.offset[y], s[y + 3] = t.offset[y] + t.size * a[y];
    const c = t.height * 2, u = t.height * 1.5, d = t.height, h = [0, 0, 1], p = Math.floor(t.size / this.n);
    let m = 2;
    for (let y = 0; y <= this.n; y++) {
      for (let Z = 0; Z < 3; Z++)
        s[3 * m + Z] = h[Z] = l[Z] + p * y * a[Z], y % 10 == 0 ? s[3 * (m + 1) + Z] = h[Z] + c * o[Z] : y % 5 == 0 ? s[3 * (m + 1) + Z] = h[Z] + u * o[Z] : s[3 * (m + 1) + Z] = h[Z] + d * o[Z];
      m++, m++;
    }
    this.points.setData(s, 3), this.lines.setData(r);
    const b = [1, 1, 1];
    this.actor.getProperty().setColor(b), this.data.modified();
  }
  updateLbPoints2D(t, e, n) {
    this.lbPoints = [];
    for (let s = 0; s <= this.n; s++)
      s % 10 == 0 && this.lbPoints.push([s.toString(), [e + s / t, n]]);
  }
  getActor() {
    return this.actor;
  }
  getMapper() {
    return this.mapper;
  }
  delete() {
    this.points.delete(), this.lines.delete(), this.data.delete(), this.mapper.delete(), this.actor.delete();
  }
}
class yS {
  constructor() {
    S(this, "Tangents", []);
    S(this, "Normals", []);
    S(this, "Binormals", []);
    S(this, "Points", []);
  }
  // public iPoints:number = 0;
  /*fill up all arrays*/
  SetPoints(t) {
    this.Points = [], this.Binormals = [], this.Tangents = [], this.Normals = [];
    for (let e = 0; e < t.length; e++)
      this.Points.push([0, 0, 0]), this.Normals.push([0, 0, 0]), this.Binormals.push([0, 0, 0]), this.Tangents.push([0, 0, 0]);
  }
  SetCurve(t, e, n, s) {
    if (t.length > 0) {
      this.Points = [], this.Binormals = [], this.Tangents = [], this.Normals = [];
      for (let r = 0; r < t.length; r++) {
        const a = I.create(), o = I.create(), l = I.create(), c = I.create();
        I.set(a, t[3 * r], t[3 * r + 1], t[3 * r + 2]), I.set(o, e[3 * r], e[3 * r + 1], e[3 * r + 2]), I.set(c, n[3 * r], n[3 * r + 1], n[3 * r + 2]), I.set(l, s[3 * r], s[3 * r + 1], s[3 * r + 2]), this.Points.push(a), this.Normals.push(o), this.Binormals.push(l), this.Tangents.push(c);
      }
    }
  }
  ShiftCurve(t) {
    for (let e = 0; e < this.Points.length; e++)
      for (let n = 0; n < 3; n++)
        this.Points[e][n] += t * this.Normals[e][n];
  }
  findNearestPoint(t) {
    let n = -1, s = 9999;
    if (this.Points.length > 0) {
      n = 0;
      for (let o = 0; o < this.Points.length; o += 3) {
        const l = I.distance(t, this.Points[o]);
        l < s && (s = l, n = o);
      }
      const r = Math.max(0, n - 3), a = Math.min(this.Points.length, n + 3);
      for (let o = r; o < a; o++) {
        const l = I.distance(t, this.Points[o]);
        l < s && (s = l, n = o);
      }
    }
    return n;
  }
  /*! Calculate tangent at SplinePoint[k]. first derivation of the aSpline
  \return 0 if fail
  */
  GetSplineTangent(t, e) {
    let n = t, s = t;
    const r = e.length, a = 1e-6, o = [0, 0, 0];
    for (let l = 0; l < 3; l++) o[l] = 0;
    for (; I.length(o) < a && n > -1 && s < r; ) {
      if (n--, s++, n < 0 && s > r - 1)
        return [o, !1];
      n < 0 && (n = 0), s > r - 1 && (s = r - 1);
      for (let l = 0; l < 3; l++) o[l] = e[n][l] - e[s][l];
    }
    return I.length(o) < a ? [o, !1] : (I.normalize(o, o), [o, !0]);
  }
  /*! find dominant Binomal that "orthogonal" to most tangents. This is exact when splinepoints complanar*/
  GetFirstViewUp(t) {
    const e = new Array(this.Points.length).fill(0);
    for (let a = 0; a < this.Points.length; a++) e[a] = 0;
    const n = 0.01;
    for (let a = 0; a < this.Points.length; a++)
      for (let o = 0; o < this.Points.length; o++)
        Math.abs(I.dot(this.Binormals[a], this.Tangents[o])) < n && e[a]++;
    const s = e[0];
    let r = 0;
    for (let a = 0; a < this.Points.length; a++)
      e[a] > s && (r = a);
    for (let a = 0; a < 3; a++) t[a] = this.Binormals[r][a];
    I.normalize(t, t);
  }
  /*! Calculate "clovecek in vetrcek" tangents, normals, binormals, based on \param aSpline */
  SetSimpleSpline(t, e) {
    this.SetPoints(t);
    const n = t.length;
    let s = !1;
    if (n > 1) {
      for (let o = 0; o < n; o++)
        I.copy(this.Points[o], t[o]), [this.Tangents[o], s] = this.GetSplineTangent(o, t);
      for (let o = 0; o < n; o++)
        if ([this.Normals[o], s] = this.GetSplineTangent(o, this.Tangents), s ? I.cross(this.Binormals[o], this.Tangents[o], this.Normals[o]) : I.set(this.Binormals[o], e[0], e[1], e[2]), I.cross(this.Normals[o], this.Tangents[o], this.Binormals[o]), I.cross(this.Binormals[o], this.Tangents[o], this.Normals[o]), I.normalize(this.Binormals[o], this.Binormals[o]), this.Binormals[o][2] < -0.5)
          for (let l = 0; l < 3; l++) this.Binormals[o][l] = -this.Binormals[o][l];
      this.GetFirstViewUp(this.Binormals[0]), I.cross(this.Normals[0], this.Binormals[0], this.Tangents[0]), I.normalize(this.Normals[0], this.Normals[0]);
      let r;
      const a = 0.1;
      for (let o = 1; o < n; o++) {
        for (let l = 0; l < 3; l++)
          this.Binormals[o][l] = (1 - a) * this.Binormals[o - 1][l] + a * this.Binormals[o][l];
        I.normalize(this.Binormals[o], this.Binormals[o]), r = I.dot(this.Binormals[o], this.Tangents[o]);
        for (let l = 0; l < 3; l++) this.Binormals[o][l] = this.Binormals[o][l] - r * this.Tangents[o][l];
        I.normalize(this.Binormals[o], this.Binormals[o]), I.cross(this.Normals[o], this.Binormals[o], this.Tangents[o]), I.normalize(this.Normals[o], this.Normals[o]);
      }
    }
  }
}
let $Mt = 0;
class ow {
  constructor(t) {
    S(this, "subType", Yt._NONE);
    S(this, "cadType", Pe.eOT_UNKNOWN);
    S(this, "id", ($Mt++).toString());
    S(this, "cprId", 0);
    S(this, "forceUpdateCS", !1);
    S(this, "name", "");
    S(this, "displayText", "");
    /** RGB 0-1 */
    S(this, "color", [1, 1, 1]);
    /**
     * Temporary color override for collisions etc.
     * RGB 0-1
     * */
    S(this, "colorOverride", null);
    /** 0-1 */
    S(this, "opacity", 1);
    S(this, "visibility", !0);
    S(this, "visibilityRestore", null);
    S(this, "pickable", !0);
    S(this, "locked", !0);
    S(this, "objectNote", "");
    S(this, "enabled", 1);
    S(this, "deleted", 0);
    S(this, "owners", []);
    S(this, "cadToothInfoOrderNumber", -1);
    S(this, "cadToothInfoType", -1);
    S(this, "trackingType", !1);
    S(this, "isVolume", !1);
    S(this, "renderingLayer", 0);
    S(this, "isPly", !1);
    S(this, "glossy", !0);
    S(this, "texture", null);
    S(this, "mpColorTF", L0.newInstance());
    S(this, "mappers", /* @__PURE__ */ new Map());
    S(this, "actors", /* @__PURE__ */ new Map());
    S(this, "representations2D", /* @__PURE__ */ new Map());
    S(this, "wasmStlObject");
    S(this, "wasmVolumeObject");
    t && (this.id = t);
  }
  setName(t) {
    var e, n;
    this.name = t, (e = this.wasmStlObject) == null || e.SetName(t), (n = this.wasmVolumeObject) == null || n.SetName(t);
  }
  getName() {
    return this.name;
  }
  setDisplayText(t) {
    var e, n;
    this.displayText = t, (e = this.wasmStlObject) == null || e.SetDisplayText(t), (n = this.wasmVolumeObject) == null || n.SetDisplayText(t);
  }
  getDisplayText() {
    return this.displayText;
  }
  getGUIName() {
    return this.displayText != "" && this.displayText != this.name ? this.displayText + " (" + this.name + ")" : this.name;
  }
  getVisibility() {
    return this.visibility;
  }
  getPickable() {
    return this.pickable;
  }
  getColor() {
    return this.color;
  }
  getNotes() {
    return this.objectNote;
  }
  setNotes(t) {
    this.objectNote = t;
  }
  isTrackedObject() {
    return this.trackingType || this.getName() == "Surgical Guide" || this.getName() == "Prosthesis Surgical Guide";
  }
  setTracked(t) {
    this.trackingType = t;
  }
  setColorOverride(t) {
    this.colorOverride = t;
  }
  getColorOverride() {
    return this.colorOverride;
  }
  getDisplayedColor() {
    return this.colorOverride ?? this.color;
  }
  getOpacity() {
    return this.opacity;
  }
  getLocked() {
    return this.locked;
  }
  isImage3D() {
    return [
      Pe.eOT_TEXTURED_LEFT_IMAGE,
      Pe.eOT_TEXTURED_RIGHT_IMAGE,
      Pe.eOT_TEXTURED_FRONT_IMAGE,
      Pe.eOT_TEXTURED_TOP_IMAGE,
      Pe.eOT_TEXTURED_IMAGE
    ].includes(this.cadType);
  }
  isImplant() {
    return !1;
  }
  IsVolume() {
    return this.isVolume;
  }
  setRenderingLayer(t) {
    this.renderingLayer = t;
  }
  getStandardInfoString(t) {
    return null;
  }
  getRenderingLayer() {
    return this.renderingLayer;
  }
  getPosition() {
    return I.create();
  }
  addTexture(t) {
    this.texture = t, this.actors.forEach((e, n) => {
      n.isViewMode3D() && (e.addTexture(t), e.getProperty().setColor(1, 1, 1), this.setGlossy(!1));
    }), this.mappers.forEach((e, n) => {
      n.isViewMode3D() && e.setScalarVisibility(!1);
    });
  }
  removeTexture(t) {
    this.texture = null, this.actors.forEach((e, n) => {
      n.isViewMode3D() && e.removeTexture(t);
    }), this.mappers.forEach((e, n) => {
      n.isViewMode3D() && this.isPly && e.setScalarVisibility(!0);
    });
  }
  setGlossy(t) {
    this.glossy = t, this.wasmStlObject && ge(this.wasmStlObject).SetGlossy(t), this.wasmVolumeObject && ge(this.wasmVolumeObject).SetGlossy(t), this.actors.forEach((e, n) => {
      n.isViewMode3D() && (e.getProperty().setSpecular(t ? 0.75 : 0), e.getProperty().setSpecularPower(t ? 128 : 0));
    });
  }
  getGlossy() {
    return this.glossy;
  }
  hideVisibility(t) {
    this.visibilityRestore = this.visibility, this.setVisibility(!!t, !0);
  }
  restoreVisibility() {
    this.visibilityRestore !== null && (this.setVisibility(this.visibilityRestore, !0), this.visibilityRestore = null);
  }
}
class Gz {
  constructor(t) {
    S(this, "context");
    S(this, "objectId");
    S(this, "actor3d");
    S(this, "jsReady");
    S(this, "wasmCrosssection");
    S(this, "polydata", null);
    S(this, "slicePolydata", null);
    S(this, "actor", null);
    S(this, "sliceActor", null);
    S(this, "mapper", null);
    S(this, "sliceMapper", null);
    S(this, "triangleFilter", null);
    S(this, "cutter", null);
    S(this, "vtkSubscriptions", []);
    S(this, "USE_WASM", !0);
    S(this, "oldO", null);
    S(this, "oldN", null);
    S(this, "cprid", 0);
    S(this, "initialised", !1);
    S(this, "isCollisionZoone");
    S(this, "isVolume");
    this.context = t.context, this.actor3d = t.actor, this.objectId = t.objectId, t.collZone ? this.isCollisionZoone = t.collZone : this.isCollisionZoone = !1, t.isVolume ? this.isVolume = t.isVolume : this.isVolume = !1, this.USE_WASM ? (this.jsReady = !1, this.initialised = this.init()) : this.jsReady = this.initJs();
  }
  initJs() {
    this.cutter = UI.newInstance();
    const t = this.actor3d.getMapper();
    if (!t)
      return console.warn("crosssection init failed: mapper is undefined"), !1;
    const e = t.getInputConnection();
    if (e)
      return this.cutter.setInputConnection(e), !0;
    const n = t.getInputData();
    return n ? (this.cutter.setInputData(n), !0) : !1;
  }
  init() {
    const t = this.actor3d.getMapper();
    if (!t)
      return console.warn("crosssection init failed: mapper is undefined"), !1;
    if (!t.getInputData())
      return console.warn("crosssection init failed: polydata is undefined"), !1;
    const n = this.context.getEngine();
    if (!n)
      return !1;
    const s = new n.xCrossSection();
    return s.initializeMeshById(this.objectId, this.isCollisionZoone), this.wasmCrosssection = s, !0;
  }
  replaceActor() {
    this.wasmCrosssection ? this.wasmCrosssection.initializeMeshById(this.objectId, this.isCollisionZoone) : (console.warn("wasmCrosssection is undefined!"), this.initialised = this.init());
  }
  updateJs(t) {
    const e = li.newInstance();
    e.setOrigin(...t.origin), e.setNormal(...t.normal), this.cutter.setCutFunction(e);
  }
  updateWasm(t) {
    if (this.initialised || (this.initialised = this.init()), this.initialised || console.error("crosssection wasm not initialised"), !this.wasmCrosssection) {
      console.error("this.wasmCrosssection is undefined");
      return;
    }
    if (t.mpr)
      t.mpr.force ? this.wasmCrosssection.update(new Float64Array(t.mpr.origin), new Float64Array(t.mpr.normal), 1) : this.wasmCrosssection.update(new Float64Array(t.mpr.origin), new Float64Array(t.mpr.normal), 0);
    else if (t.cpr) {
      const e = (o) => {
        const l = new Float32Array(o.length * 3);
        let c = 0;
        for (const u of o)
          l[c++] = u[0], l[c++] = u[1], l[c++] = u[2];
        return l;
      }, n = e(t.cpr.points), s = e(t.cpr.normals), r = e(t.cpr.tangents), a = e(t.cpr.binormals);
      this.wasmCrosssection.CPRSpacingX = this.context.CPRSpacing.get()[0], this.wasmCrosssection.CPRHeight = this.context.CPRHeight, t.cpr.force ? this.wasmCrosssection.updateCPR(n, s, r, a, 1) : this.wasmCrosssection.updateCPR(n, s, r, a, 0);
    }
  }
  update(t) {
    this.updateInternal({ mpr: t });
  }
  updateCPR(t) {
    this.updateInternal({ cpr: t });
  }
  updateInternal(t) {
    const e = this.actor3d.getUserMatrix(), n = ut.create(), s = ut.create();
    ut.invert(n, e), ut.transpose(s, e);
    const r = zn.create(), a = zn.create();
    let o = I.create(), l = I.create(), c = zn.create(), u = zn.create();
    if (t.mpr) {
      u = [t.mpr.normal[0], t.mpr.normal[1], t.mpr.normal[2], 1], c = [t.mpr.origin[0], t.mpr.origin[1], t.mpr.origin[2], 1], zn.transformMat4(r, c, n), zn.transformMat4(a, u, s), o = [r[0], r[1], r[2]], l = [a[0], a[1], a[2]], I.normalize(l, l), I.normalize(l, l);
      const d = 1e-5, h = li.newInstance();
      if (h.setNormal(l[0], l[1], l[2]), h.setOrigin(o[0], o[1], o[2]), this.oldO && Hn.angleBetweenVectors(this.oldO, l) < d && h.distanceToPlane(this.oldO) < d && !t.mpr.force)
        return;
      this.oldO = o, this.oldN = l;
    }
    if (this.USE_WASM)
      if (t.cpr) {
        const d = this.actor3d.getUserMatrix(), h = ut.create(), p = ut.create();
        ut.invert(h, d), ut.transpose(p, d);
        const m = [], b = [], y = [], Z = [];
        t.cpr.points.forEach((W) => {
          const x = zn.create();
          zn.transformMat4(x, zn.fromValues(W[0], W[1], W[2], 1), h), m.push(I.fromValues(x[0], x[1], x[2]));
        });
        let g = 0;
        const f = m.length, T = 10, M = f / T;
        for (let W = 0; W < M; W++)
          g += Math.abs(m[W * T][0]) + Math.abs(2 * m[W * T][1]) + Math.abs(5 * m[W * T][2]);
        if (Math.abs(this.cprid - g) < 1e-5 && !t.cpr.force)
          return;
        this.cprid = g, t.cpr.normals.forEach((W) => {
          const x = zn.create();
          zn.transformMat4(x, zn.fromValues(W[0], W[1], W[2], 1), p), b.push(I.fromValues(x[0], x[1], x[2]));
        }), t.cpr.tangents.forEach((W) => {
          const x = zn.create();
          zn.transformMat4(x, zn.fromValues(W[0], W[1], W[2], 1), p), y.push(I.fromValues(x[0], x[1], x[2]));
        }), t.cpr.binormals.forEach((W) => {
          const x = zn.create();
          zn.transformMat4(x, zn.fromValues(W[0], W[1], W[2], 1), p), Z.push(I.fromValues(x[0], x[1], x[2]));
        }), this.updateWasm({
          cpr: {
            points: m,
            normals: b,
            tangents: y,
            binormals: Z,
            force: t.cpr.force
          }
        });
      } else
        this.updateWasm({
          mpr: {
            origin: o,
            normal: l,
            force: t.mpr.force
          }
        });
    else
      t.mpr ? this.updateJs({ origin: o, normal: t.mpr.normal }) : t.cpr && console.warn("cpr mode is only supported in wasm");
  }
  syncResult(t) {
    const e = (n) => {
      var r, a, o, l, c, u, d, h, p;
      const s = (r = this.wasmCrosssection) == null ? void 0 : r.getOutputPoints();
      if (!n && this.wasmCrosssection || this.wasmCrosssection && s && s.length >= 0) {
        const m = this.wasmCrosssection.getOutputLines();
        if (m && m.length > 1e6) {
          console.error("crosssection wasm output bug?");
          return;
        }
        if ((a = this.polydata) == null || a.getLines().setData(m), s && s.length > 1e6) {
          console.error("crosssection wasm output bug?");
          return;
        }
        if ((o = this.polydata) == null || o.getPoints().setData(s), this.isVolume) {
          const b = (l = this.wasmCrosssection) == null ? void 0 : l.getOutputPolys();
          b && b.length > 1e6 && console.error("crosssection wasm output bug?"), (c = this.slicePolydata) == null || c.getPoints().setData(s), (u = this.slicePolydata) == null || u.getLines().setData(m), (d = this.slicePolydata) == null || d.getPolys().setData(b), (h = this.slicePolydata) == null || h.modified();
        }
        (p = this.polydata) == null || p.modified();
      }
    };
    if (this.actor)
      this.USE_WASM && e(!1);
    else {
      if (this.mapper = Ue.newInstance(), this.actor = Re.newInstance(), this.actor.setPickable(!1), this.isVolume && (this.sliceActor = Re.newInstance(), this.sliceMapper = Ue.newInstance()), this.USE_WASM) {
        if (this.polydata = Ie.newInstance(), this.isVolume && (this.slicePolydata = Ie.newInstance()), e(!0), this.mapper.setInputData(this.polydata), this.isVolume && this.sliceMapper && this.sliceActor) {
          this.sliceMapper.setInputData(this.slicePolydata), this.sliceActor.setMapper(this.sliceMapper), this.sliceActor.getProperty().setColor(this.actor3d.getProperty().getColor());
          const a = this.actor3d.getProperty().onModified(() => {
            var o;
            (o = this.sliceActor) == null || o.getProperty().setColor(this.actor3d.getProperty().getColor());
          });
          this.vtkSubscriptions.push(a);
        }
      } else
        this.cutter.modified(), this.mapper.setInputConnection(this.cutter.getOutputPort());
      this.actor.setMapper(this.mapper), this.actor.getProperty().setColor(this.actor3d.getProperty().getColor());
      const n = this.actor3d.getProperty().onModified(() => {
        var a;
        (a = this.actor) == null || a.getProperty().setColor(this.actor3d.getProperty().getColor());
      });
      this.vtkSubscriptions.push(n);
      const s = () => {
        var o, l;
        const a = ut.clone(this.actor3d.getUserMatrix());
        t && ((o = this.actor) == null || o.setUserMatrix(a), this.isVolume && ((l = this.sliceActor) == null || l.setUserMatrix(a)));
      };
      s();
      const r = this.actor3d.onModified(() => {
        var a, o;
        s(), (a = this.actor) == null || a.setVisibility(this.actor3d.getVisibility()), this.isVolume && ((o = this.sliceActor) == null || o.setVisibility(this.actor3d.getVisibility()));
      });
      this.vtkSubscriptions.push(r);
    }
  }
  getActor() {
    return this.actor;
  }
  getSliceActor() {
    return this.sliceActor;
  }
  delete() {
    var t, e, n, s;
    if (this.vtkSubscriptions.forEach((r) => r.unsubscribe()), (t = this.actor) == null || t.delete(), (e = this.mapper) == null || e.delete(), (n = this.cutter) == null || n.delete(), (s = this.polydata) == null || s.delete(), this.wasmCrosssection) {
      const r = this.context.getWasmDocumentInstance();
      r && r.WaitForParallelExecutor();
      const a = ge(this.wasmCrosssection);
      a && a.delete();
    }
  }
}
class qMt {
}
class jh extends qMt {
  constructor(e, n, s, r, a, o) {
    super();
    S(this, "context");
    S(this, "view");
    /** Reference to the stl object's vtkPolyData. Should not be modified/deleted by this object. */
    S(this, "polydataRef");
    S(this, "mapper3d");
    S(this, "actor3d");
    S(this, "crosssection");
    S(this, "actorMatrix", ut.create());
    S(this, "color", [1, 1, 1]);
    S(this, "visibility", !0);
    S(this, "opacity", 1);
    S(this, "stlObject");
    S(this, "isCollisionZone", !1);
    S(this, "force", !1);
    S(this, "isVolume", !1);
    S(this, "mappers", /* @__PURE__ */ new Map());
    S(this, "actors", /* @__PURE__ */ new Map());
    o && (this.isVolume = o), this.context = e, this.view = n, this.polydataRef = s, this.mapper3d = Ue.newInstance(), this.actor3d = Re.newInstance(), this.mapper3d.setInputData(this.polydataRef), this.actor3d.setMapper(this.mapper3d), this.stlObject = r, a && (this.isCollisionZone = a);
  }
  updatePolydata(e) {
    this.polydataRef = e, this.mapper3d.setInputData(this.polydataRef), this.mapper3d.modified(), this.replaceActorById();
    const n = this.context.getObjects().getStlObject(this.stlObject.id);
    n && this.context.sceneRepaint(void 0, (s, r) => {
      n.sendToParallelExecutor(s, !0), n.onViewWidgetEvent(s, r);
    });
  }
  replaceActorById() {
    this.crosssection && (this.crosssection.replaceActor(), this.force = !0);
  }
  setActorMatrix(e) {
    this.actorMatrix = e, this.actor3d.setUserMatrix(this.actorMatrix);
  }
  setColor(e) {
    var s;
    this.color = e;
    const n = (s = this.crosssection) == null ? void 0 : s.getActor();
    n == null || n.getProperty().setColor(this.color);
  }
  setVisibility(e) {
    var n, s, r, a;
    this.visibility = e, this.actors.forEach((o) => {
      o.setVisibility(e);
    }), (s = (n = this.crosssection) == null ? void 0 : n.getActor()) == null || s.setVisibility(e), this.isVolume && ((a = (r = this.crosssection) == null ? void 0 : r.getSliceActor()) == null || a.setVisibility(e));
  }
  setOpacity(e) {
    this.opacity = e;
  }
  onViewWidgetEvent(e, n) {
    var s, r, a, o, l, c, u, d, h, p, m, b;
    if (e === this.view)
      switch (n) {
        case me.eVE_SHOW:
        case me.eVE_RENDER:
          if (wz(e)) {
            const Z = e.getOrigin(), g = e.getNormal();
            (s = this.crosssection) == null || s.syncResult({ origin: Z, normal: g, force: this.force });
            const f = (r = this.crosssection) == null ? void 0 : r.getActor();
            if (!f) return;
            const T = this.actors.get(e);
            if (e.getFilterMode() != Je.MPR) {
              e.removeActor(f), T || this.create3dActor(e);
              const M = e.computeClippingPlanes();
              T && ((a = T.getMapper()) == null || a.removeAllClippingPlanes(), (o = T.getMapper()) == null || o.addClippingPlane(M[0]), (l = T.getMapper()) == null || l.addClippingPlane(M[1]), (c = T.getMapper()) == null || c.modified(), e.addActor(T, 1), T.getProperty().setColor(this.color), T.setVisibility(this.visibility), T.setUserMatrix(this.actorMatrix));
            } else if (T && e.removeActor(T), e.addActor(f, 1), f.getProperty().setColor(this.color), f.getProperty().setOpacity(this.opacity), f.setVisibility(this.visibility), this.isVolume) {
              const M = (u = this.crosssection) == null ? void 0 : u.getSliceActor();
              M && (e.addActor(M, 1), M.getProperty().setColor(this.color), M.getProperty().setOpacity(0.3), M.setVisibility(this.visibility));
            }
          } else if (e.getViewMode() === Nt.CPR) {
            (d = this.crosssection) == null || d.syncResult();
            const Z = (h = this.crosssection) == null ? void 0 : h.getActor();
            if (!Z) return;
            const g = this.actors.get(e);
            if (this.context.CPRfilterMode.get() != Je.MPR) {
              if (e.removeActor(Z), (this.stlObject.type == Yt._IMPLANT || this.stlObject.type == Yt._PIN || this.stlObject.type == Yt._ABUTMENT) && (g || this.create3dActor(e), g))
                if (e.addActor(g, 1), g.getProperty().setColor(this.color), g.setVisibility(this.visibility), this.stlObject.type != Yt._ABUTMENT) {
                  const f = ut.clone(this.actorMatrix);
                  let T = this.context.CPRMath.GetCPRMatrix([f[12], f[13], f[14]]);
                  ut.invert(T, T);
                  const M = this.context.CPRMath.convertMMtoCPR([f[12], f[13], f[14]], !1);
                  let N = [1, 0, 0], W = [0, 1, 0], x = [0, 0, 1];
                  I.transformMat4(N, [f[0], f[1], f[2]], T), I.transformMat4(x, [f[4], f[5], f[6]], T), I.transformMat4(W, [f[8], f[9], f[10]], T), I.normalize(N, N), I.normalize(x, x), I.normalize(W, W);
                  let V = ut.create();
                  ut.set(V, N[0], N[1], N[2], 0, x[0], x[1], x[2], 0, W[0], W[1], W[2], 0, M[0], M[1], M[2], 1), g.setUserMatrix(V);
                } else {
                  const f = ut.clone(this.stlObject.getImplantMatrix());
                  let T = this.context.CPRMath.GetCPRMatrix([f[12], f[13], f[14]]);
                  ut.invert(T, T);
                  const M = this.context.CPRMath.convertMMtoCPR([f[12], f[13], f[14]], !1);
                  let N = [1, 0, 0], W = [0, 1, 0], x = [0, 0, 1];
                  I.transformMat4(N, [f[0], f[1], f[2]], T), I.transformMat4(x, [f[4], f[5], f[6]], T), I.transformMat4(W, [f[8], f[9], f[10]], T), I.normalize(N, N), I.normalize(x, x), I.normalize(W, W);
                  let V = ut.create();
                  ut.set(V, N[0], N[1], N[2], 0, x[0], x[1], x[2], 0, W[0], W[1], W[2], 0, M[0], M[1], M[2], 1);
                  const X = this.stlObject.calculateAbutmentoffset();
                  ut.translate(V, V, [0, 0, X]), g.setUserMatrix(V);
                }
            } else if ((this.stlObject.type == Yt._IMPLANT || this.stlObject.type == Yt._PIN || this.stlObject.type == Yt._ABUTMENT) && g && e.removeActor(g), e.addActor(Z, 1), Z.getProperty().setColor(this.color), Z.getProperty().setOpacity(this.opacity), Z.setVisibility(this.visibility), this.isVolume) {
              const f = (p = this.crosssection) == null ? void 0 : p.getSliceActor();
              f && (this.visibility ? e.addActor(f, 1) : e.removeActor(f), e.addActor(f, 1), f.getProperty().setColor(this.color), f.getProperty().setOpacity(0.3), f.setVisibility(this.visibility));
            }
          }
          break;
        case me.eVE_HIDE:
        case me.eVE_DESTROY:
          const y = (m = this.crosssection) == null ? void 0 : m.getActor();
          if (y && e.removeActor(y), this.isVolume) {
            const Z = (b = this.crosssection) == null ? void 0 : b.getSliceActor();
            Z && e.removeActor(Z);
          }
          this.delete3dActor(e);
          break;
      }
  }
  sendToParallelExecutor(e, n) {
    if (wz(e)) {
      this.crosssection || (this.crosssection = new Gz({
        actor: this.actor3d,
        context: this.context,
        objectId: this.stlObject.id,
        collZone: this.isCollisionZone,
        isVolume: this.isVolume
      }));
      const s = e.getOrigin(), r = e.getNormal();
      (this.visibility || this.force) && this.crosssection.update({ origin: s, normal: r, force: this.force }), this.force = !1;
    } else if (e.getViewMode() === Nt.CPR) {
      this.crosssection || (this.crosssection = new Gz({
        actor: this.actor3d,
        context: this.context,
        objectId: this.stlObject.id,
        collZone: this.isCollisionZone,
        isVolume: this.isVolume
      }));
      const s = this.context.objects.CPRCurve.splineVec, r = this.context.objects.CPRCurve.splineNormals, a = this.context.objects.CPRCurve.splineTangents, o = this.context.objects.CPRCurve.splineBinormals;
      s.length && r.length && (this.visibility || this.force) && this.crosssection.updateCPR({ points: s, normals: r, tangents: a, binormals: o, force: this.force });
    }
    if (n) {
      const s = this.context.getWasmDocumentInstance();
      s && s.WaitForParallelExecutor();
    }
  }
  setForceCSRefreshOnTrue() {
    this.force = !0;
  }
  delete() {
    var e, n, s;
    this.onViewWidgetEvent(this.view, me.eVE_DESTROY);
    for (const [r, a] of this.actors)
      r.removeActor(a), a.delete();
    for (const r of this.mappers.values())
      r.delete();
    (e = this.mapper3d) == null || e.delete(), (n = this.actor3d) == null || n.delete(), (s = this.crosssection) == null || s.delete();
  }
  create3dActor(e, n) {
    e.getViewMode() == Nt.STL3D && (this.visibility = !0), e.getViewMode() == Nt._3D;
    const { mapper: s, actor: r } = this.createActorObjects(n);
    this.mappers.set(e, s), this.actors.set(e, r), e.addActor(r, 1);
  }
  delete3dActor(e) {
    var s;
    const n = this.actors.get(e);
    n && (e.removeActor(n), n.delete()), (s = this.mappers.get(e)) == null || s.delete(), this.actors.delete(e), this.mappers.delete(e);
  }
  createActorObjects(e) {
    const n = Ue.newInstance();
    n.setInputData(this.polydataRef);
    const s = Re.newInstance();
    return s.setMapper(n), s.getProperty().setColor(this.color), s.getProperty().setOpacity(this.opacity), s.setPickable(!1), s.setVisibility(this.visibility), s.setUserMatrix(this.actorMatrix), { mapper: n, actor: s };
  }
}
function wz(i) {
  switch (i.getViewMode()) {
    case Nt.SAGITTAL:
    case Nt.CORONAL:
    case Nt.AXIAL:
    case Nt.SECTIONAL_VIEW:
    case Nt.CROSS:
    case Nt.TANGENT:
      return !0;
    case Nt._3D:
    case Nt.CPR:
    case Nt.STL3D:
    case Nt._STL_3D_PREVIEW:
    case Nt.CAD_3D:
      return !1;
  }
}
class vn extends ow {
  constructor(e) {
    super(e.id);
    S(this, "type", Yt._STL_OBJECT);
    S(this, "subType", Yt._STL_OBJECT);
    S(this, "context");
    S(this, "projectSTLData");
    S(this, "polydata", Ie.newInstance());
    S(this, "height", 0);
    S(this, "mDeleted", !1);
    S(this, "mLastBounds", null);
    S(this, "wasmCollisionZonePolydataReady", !1);
    S(this, "replaceFlag", !1);
    S(this, "matrix", ut.create());
    S(this, "startUM", ut.create());
    S(this, "ignoreTransform", !1);
    S(this, "stlFilename");
    S(this, "plyFilename");
    S(this, "collisionReport", "");
    S(this, "collisionMap", /* @__PURE__ */ new Map());
    S(this, "collisions", {
      implantCollision: !1,
      securityZoneCollision: !1,
      nerveCollision: !1,
      sleeveCollision: !1,
      sleeveChanged: null,
      anatomyCollision: !1
    });
    S(this, "collZoneRepresentations2D", /* @__PURE__ */ new Map());
    S(this, "representation", Vn.SURFACE);
    this.context = e.context;
  }
  initialize(e) {
    this.polydata = e.polydata;
    const n = this.polydata.getBounds();
    if (this.mLastBounds = [n[0], n[1], n[2], n[3], n[4], n[5]], this.height = Math.abs(n[5] - n[4]), this.matrix = e.matrix, this.stlFilename = e.stlFilename, this.plyFilename = e.plyFilename, this.isPly = !!e.ply, this.ignoreTransform = !!e.ignoreTransform, e.oType && (this.cadType = e.oType), e.ply) {
      const s = this.polydata.getPointData().getScalars();
      if (s) {
        const l = s.getData();
        NM(l) == 0 && WM(l) == 0 ? this.polydata.getPointData().removeArray(s.getName()) : (s.setName("Colors"), this.polydata.getPointData().setActiveScalars("Colors"));
      } else
        this.polydata.getPointData().getArray("Colors") && this.polydata.getPointData().setActiveScalars("Colors");
      const r = this.polydata.getPointData().getTCoords();
      if (r) {
        const l = r.getData();
        NM(l) == 0 && WM(l) == 0 ? this.polydata.getPointData().removeArray(r.getName()) : (r.setName("Texture2DCoordinates"), this.polydata.getPointData().setActiveTCoords("Texture2DCoordinates"));
      } else
        this.polydata.getPointData().getArray("Texture2DCoordinates") && this.polydata.getPointData().setActiveTCoords("Texture2DCoordinates");
      const a = this.polydata.getCellData().getScalars();
      if (a) {
        const l = a.getData();
        NM(l) == 0 && WM(l) == 0 ? this.polydata.getCellData().removeArray(a.getName()) : (a.setName("Colors"), this.polydata.getCellData().setActiveScalars("Colors"));
      } else
        this.polydata.getCellData().getArray("Colors") && this.polydata.getCellData().setActiveScalars("Colors");
      const o = this.polydata.getCellData().getTCoords();
      if (o) {
        const l = o.getData();
        NM(l) == 0 && WM(l) == 0 ? this.polydata.getCellData().removeArray(o.getName()) : (o.setName("Texture2DCoordinates"), this.polydata.getCellData().setActiveTCoords("Texture2DCoordinates"));
      } else
        this.polydata.getCellData().getArray("Texture2DCoordinates") && this.polydata.getCellData().setActiveTCoords("Texture2DCoordinates");
    }
    if (e.id !== "preview3d" && !e.skipCopyToWasm) {
      const s = this.context.getEngine(), r = new s.xWasmStlObject(this.id, e.oType ?? Pe.eOT_UNKNOWN, this.type, this.subType), a = !0;
      nn.debug("object name", this.id, " Perserve data", a, "skip sync", e.skipSync), e.skipSync || (du(r, this.polydata, a, !1, !e.ply, a), $o(r, this.matrix), !this.isPly && !e.hasTexture && r.SetMeshSplitting(!0), Cr(r, this.polydata, a)), this.wasmStlObject = r;
    }
  }
  static fromProjectStlObject(e, n, s) {
    let r;
    s.ply ? r = Lo(n.implantInfo.stlFile.data, "ply") : r = Lo(n.implantInfo.stlFile.data, "stl");
    let a;
    if (s.fromDataImport)
      a = ut.create();
    else {
      let l;
      s != null && s.ignoreScaling ? l = n.origin : l = e.objects.scaleVectorFromImplantPlanner(n.origin);
      const c = r.getBounds(), u = I.fromValues((c[0] + c[1]) / 2, (c[2] + c[3]) / 2, (c[4] + c[5]) / 2);
      a = qG(l, n.normal, n.viewUp, u);
    }
    const o = new vn({
      context: e,
      id: s.forcedIid
    });
    if (o.projectSTLData = structuredClone(n), o.type = n.objectType, o.subType = n.objectSubType, o.initialize({
      polydata: r,
      matrix: a,
      stlData: n.implantInfo.stlFile.data,
      stlFilename: n.implantInfo.stlFile.fileName,
      plyFilename: n.implantInfo.plyFilename,
      ply: s.ply,
      hasTexture: s.hasTexture,
      skipCopyToWasm: s.skipCopyToWasm,
      ignoreTransform: s.ignoreTransform,
      id: s.forcedIid,
      oType: n.cadType
    }), s.ply && n.implantInfo.textureFiles && n.implantInfo.textureFiles[0] && o.wasmStlObject && n.implantInfo.textureFiles[0].data.length)
      if (o.wasmStlObject.LoadTextureImage(n.implantInfo.textureFiles[0].data), o.wasmStlObject.HasTextureImageData()) {
        const l = xs.newInstance(), c = o.wasmStlObject.GetTextureImageDataView();
        Go(c, l, !1), c.delete();
        const u = vc.newInstance({ repeat: !1, interpolate: !0 });
        u.setInputData(l), o.addTexture(u);
      } else
        console.warn("fromProjectStlObject: stored texture for", n.name, "could not be decoded, loading without texture"), o.projectSTLData.implantInfo.textureCount = 0, o.projectSTLData.implantInfo.textureFileNames = [], o.projectSTLData.implantInfo.textureFiles = [];
    return o.wasmStlObject && (o.wasmStlObject.SetCADToothInfoOrderNumber(n.cadToothInfoOrderNumber), o.wasmStlObject.SetCADToothInfoType(n.cadToothInfoType), o.wasmStlObject.SetCADCorrespondenceId(n.cadCorrespondenceId), o.wasmStlObject.SetCADReconstructionTypeId(n.cadReconstructionTypeId)), o.isPly = s.ply || !1, o.setName(n.name), o.setDisplayText(n.displayText), o.setColor(Kn(n.color)), o.setVisibility(n.visible, !0), o.opacity = n.opacity / 255, o.objectNote = n.objectNote, o.enabled = n.enabled, o.deleted = n.deleted, o.owners = n.owners, o;
  }
  static async fromProjectOBJObject(e, n) {
    const s = new File([new Int8Array(n.implantInfo.stlFile.data)], "file.obj");
    let a = (await EG(s)).getOutputData(), o = ut.create();
    const l = new vn({
      context: e
    });
    return l.projectSTLData = structuredClone(n), l.type = n.objectType, l.subType = n.objectSubType, l.initialize({
      polydata: a,
      matrix: o,
      stlData: n.implantInfo.stlFile.data,
      stlFilename: n.implantInfo.stlFile.fileName,
      plyFilename: n.implantInfo.plyFilename,
      oType: n.cadType
    }), l.isPly = !1, l.setName(n.name), l.setDisplayText(n.displayText), l.setColor(Kn(n.color)), l.setVisibility(n.visible, !0), l.opacity = n.opacity / 255, l.objectNote = n.objectNote, l.enabled = n.enabled, l.deleted = n.deleted, l.owners = n.owners, l;
  }
  static copyStlObject(e, n, s) {
    const r = n.toProjectStlObject();
    return vn.fromProjectStlObject(e, r, { hasTexture: s, ply: n.isPly });
  }
  static ConvertVolumeToSTL(e, n) {
    const s = ut.clone(n.getMatrix()), r = e.getEngine(), a = new r.xFileUtilsWasm();
    let o = new Int8Array(0);
    a.GetSTLBufferForSaveByObjectId(n.id, !1, this.name) && (o = a.GetBuffer().slice()), a.delete();
    const l = Ie.newInstance(), c = new vn({
      context: e
    });
    return c.type = n.type, c.subType = Yt._STL_OBJECT, c.initialize({
      polydata: l,
      matrix: s,
      stlData: o,
      stlFilename: "",
      plyFilename: ".",
      ply: !1,
      skipSync: !0,
      oType: n.cadType
    }), c.setName(n.getName()), c.setDisplayText(n.getDisplayText()), c.setColor(n.getColor()), c.setVisibility(n.getVisibility(), !0), c.isPly = !1, c.opacity = n.getOpacity(), c.visibilityRestore = c.visibility, c.updateMeshBySrcId(n.id), c;
  }
  static async fromBuffer(e) {
    let n;
    if (e.iXFs)
      n = e.iXFs;
    else {
      const o = e.context.getEngine();
      n = new o.xFileUtilsWasm();
    }
    const s = n.PolyDataLoadBufferWrapper(e.intArr, e.fileType, !!e.flip, !0), r = Ie.newInstance();
    Cr(s, r, !0, !0), s.delete();
    const a = new vn({
      context: e.context
    });
    return a.type = e.ipOType ?? Yt._NONE, a.subType = e.ipOSubType ?? Yt._NONE, a.initialize({
      polydata: r,
      matrix: ut.create(),
      stlData: new Int8Array(0),
      skipCopyToWasm: e.skipCopyToWasm
    }), a.setName("fromBuffer"), a.setDisplayText("fromBuffer"), a.setColor(a.getColor()), a.setVisibility(a.getVisibility(), !0), e.context.objects.stls.set(a.id, a), e.iXFs || n.delete(), a;
  }
  // TODO finish this
  static async fromFile(e) {
    let n, s;
    if (!e.iWasmFS || !e.iXFs) {
      n = await e.context.getFS();
      const h = e.context.getEngine();
      s = new h.xFileUtilsWasm();
    } else
      n = e.iWasmFS, s = e.iXFs;
    let r = e.intArr;
    if (!r) {
      const p = await (await fetch(e.path)).arrayBuffer();
      r = new Int8Array(p);
    }
    n.FS.writeFile(e.path, r), e.textureIntArr && e.texturePath && n.FS.writeFile(e.texturePath, e.textureIntArr);
    let a;
    const o = new vn({
      context: e.context,
      id: e.forcedId
    });
    let l;
    if (!e.skipCopyToWasm) {
      const h = e.context.getEngine();
      l = new h.xWasmStlObject(o.id, e.cadType ?? Pe.eOT_UNKNOWN, e.oType, Yt._STL_OBJECT);
    }
    const c = e.path.split(".");
    let u = c[c.length - 1];
    // oType == ObjectType._STL_TOOTH ||
    // oType == ObjectType._PIN ||
    !u || u == "" || u == "dec" || u == "part" || u.includes("dec") || u == "n" ? l ? l.ReadStlFromFile(e.path, !0, !1) : (performance.now(), a = s.LoadSTLFromStreamDataWrapper(e.path, !0), performance.now()) : l ? l.ReadMeshFromFile(e.path, e.cadType ?? Pe.eOT_UNKNOWN, u != "ply", !1) : (performance.now(), a = s.ImportMeshLabelFromFileWrapper(e.path, e.cadType ?? Pe.eOT_UNKNOWN, u != "ply"), performance.now());
    let d = Ie.newInstance();
    if (!e.skipCopyToWasm && l) {
      const h = e.cadType != Pe.eOT_IP_ABUTMENT && e.cadType != Pe.eOT_PIN_SLEEVE && e.cadType != Pe.eOT_PIN && e.cadType != Pe.eOT_IMPLANT;
      $o(l, ut.create()), Cr(l, d, h, !1), o.wasmStlObject = l;
    } else a && Cr(a, d, !0, !0);
    if (o.initialize({
      polydata: d,
      matrix: ut.create(),
      stlData: new Int8Array(0),
      skipCopyToWasm: !0,
      id: e.forcedId,
      ply: u == "ply",
      oType: e.cadType
    }), o.setName(e.path), o.setColor(o.getColor()), o.setVisibility(o.getVisibility(), !0), e.context.objects.stls.set(o.id, o), n.FS.unlink(e.path), e.textureIntArr && e.texturePath) {
      if (o.wasmStlObject && o.wasmStlObject.HasTextureImageData()) {
        const h = xs.newInstance(), p = o.wasmStlObject.GetTextureImageDataView();
        Go(p, h, !1), p.delete();
        const m = vc.newInstance({ repeat: !1, interpolate: !0 });
        m.setInputData(h), o.addTexture(m);
      }
      n.FS.unlink(e.texturePath);
    }
    return (!e.iWasmFS || !e.iXFs) && s.delete(), o;
  }
  static async fromFileBase(e) {
    const n = new vn({
      context: e.context,
      id: e.forcedId
    }), s = e.context.getEngine(), r = new s.xWasmStlObject(n.id, e.cadType ?? Pe.eOT_UNKNOWN, e.oType, Yt._STL_OBJECT), a = e.path.split(".");
    let o = a[a.length - 1];
    // oType == ObjectType._STL_TOOTH ||
    // oType == ObjectType._PIN ||
    !o || o == "" || o == "dec" || o == "part" || o.includes("dec") || o == "n" ? r.ReadStlFromFile(e.path, !0, !1) : (nn.debug("STL from File load wasmObject.ReadMeshFromFile: ", e.path, o), r.ReadMeshFromFile(e.path, e.cadType ?? Pe.eOT_UNKNOWN, o == "ply" || o == "obj", !1));
    let l = Ie.newInstance();
    const c = e.cadType != Pe.eOT_IP_ABUTMENT && e.cadType != Pe.eOT_PIN_SLEEVE && e.cadType != Pe.eOT_PIN && e.cadType != Pe.eOT_IMPLANT;
    if ($o(r, ut.create()), Cr(r, l, c, !1), n.wasmStlObject = r, n.initialize({
      polydata: l,
      matrix: ut.create(),
      stlData: new Int8Array(0),
      skipCopyToWasm: !0,
      id: e.forcedId,
      ply: o == "ply" || o == "obj",
      oType: e.cadType
    }), n.setName(e.path), n.setColor(n.getColor()), n.setVisibility(n.getVisibility(), !0), n.wasmStlObject && n.wasmStlObject.HasTextureImageData()) {
      const u = xs.newInstance(), d = n.wasmStlObject.GetTextureImageDataView();
      Go(d, u, !1), d.delete();
      const h = vc.newInstance({ repeat: !1, interpolate: !0 });
      h.setInputData(u), n.addTexture(h);
    }
    return n;
  }
  static async from2DImageFile(e) {
    let n, s;
    if (!e.iWasmFS || !e.iXFs) {
      n = await e.context.getFS();
      const l = e.context.getEngine();
      s = new l.xFileUtilsWasm();
    } else
      n = e.iWasmFS, s = e.iXFs;
    let r = e.intArr;
    if (!r) {
      const c = await (await fetch(e.path)).arrayBuffer();
      r = new Int8Array(c);
    }
    n.FS.writeFile(e.path, r);
    const a = new vn({
      context: e.context,
      id: e.forcedId
    }), o = Ie.newInstance();
    if (a.initialize({
      polydata: o,
      matrix: ut.create(),
      stlData: new Int8Array(0),
      skipCopyToWasm: e.skipCopyToWasm,
      id: e.forcedId,
      oType: e.cadType
    }), !a.wasmStlObject) {
      const l = e.context.getEngine();
      a.wasmStlObject = new l.xWasmStlObject(a.id, e.cadType, a.type, a.subType);
    }
    if (s.ImportMeshLabelForm2DImageWrapper(e.path, e.cadType, a.id), a.wasmStlObject) {
      a.syncWasmInfo(!1);
      const l = xs.newInstance(), c = a.wasmStlObject.GetTextureImageDataView();
      Go(c, l), c.delete();
      const u = vc.newInstance({ repeat: !1, interpolate: !0 });
      u.setInputData(l), a.addTexture(u);
    }
    return a.setName(e.path), a.setDisplayText(e.path), a.setColor(a.getColor()), a.setVisibility(a.getVisibility(), !0), e.context.getObjects().images2D.set(a.id, a), n.FS.unlink(e.path), (!e.iWasmFS || !e.iXFs) && s.delete(), a;
  }
  toProjectStlObject() {
    const e = I.clone(this.getCenter()), n = ut.clone(this.getMatrix());
    I.transformMat4(e, e, n);
    const s = this.context.objects.scaleVectorToImplantPlanner(e);
    this.projectSTLData || (this.projectSTLData = UT()), this.projectSTLData.color = Pa(this.color);
    const r = this.context.getEngine(), a = new r.xFileUtilsWasm();
    let o = new Int8Array(0);
    if (a.GetSTLBufferForSaveByObjectId(this.id, this.isPly, this.name)) {
      if (o = a.GetBuffer().slice(), this.projectSTLData.implantInfo.textureCount = 0, this.projectSTLData.implantInfo.textureFileNames = [], this.projectSTLData.implantInfo.textureFiles = [], this.isPly && a.IsTextureWritten()) {
        const l = this.context.getFS(), c = this.name + ".jpg";
        try {
          const u = l.FS.readFile(c), d = new Int8Array(u);
          d.length && (this.projectSTLData.implantInfo.textureCount = 1, this.projectSTLData.implantInfo.textureFileNames.push(c), this.projectSTLData.implantInfo.textureFiles.push({
            fileSize: d.length,
            data: d,
            fileName: c
          })), l.FS.unlink(c);
        } catch (u) {
          console.warn("toProjectStlObject: texture sidecar", c, "could not be read, saving without texture", u);
        }
      }
      this.projectSTLData.implantInfo.stlFile.data = o, this.projectSTLData.implantInfo.stlFile.fileSize = o.length, this.projectSTLData.implantInfo.stlFile.fileName = this.name + (this.isPly ? ".ply" : ".stl"), this.projectSTLData.implantInfo.stlSuffix = this.isPly ? ".ply" : ".", this.projectSTLData.implantInfo.plyFilename = this.name + (this.isPly ? ".ply" : ".stl"), this.projectSTLData.implantInfo.implantFileName = this.name + (this.isPly ? ".ply" : ".stl");
    }
    if (a.delete(), this.projectSTLData.displayText = this.displayText, this.projectSTLData.name = this.name, this.projectSTLData.viewUp = [n[0], n[1], n[2]], this.projectSTLData.tangent = [n[4], n[5], n[6]], this.projectSTLData.normal = [n[8], n[9], n[10]], this.projectSTLData.origin = s, this.projectSTLData.objectType = this.type, this.projectSTLData.objectSubType = this.subType, this.projectSTLData.cadType = this.cadType, this.projectSTLData.opacity = this.getOpacity() * 255, this.projectSTLData.visible = this.getVisibility(), this.projectSTLData.objectNote = this.objectNote, this.wasmStlObject) {
      const l = ge(this.wasmStlObject);
      this.projectSTLData.cadToothInfoOrderNumber = l.GetCADToothInfoOrderNumber(), this.projectSTLData.cadToothInfoType = l.GetCADToothInfoType(), this.projectSTLData.cadCorrespondenceId = l.GetCADCorrespondenceId(), this.projectSTLData.cadReconstructionTypeId = l.GetCADReconstructionTypeId(), this.projectSTLData.generateTexts = l.GetGenerateTexts(), this.projectSTLData.sleeveIndexes = l.GetSleeveIndexes();
    }
    return this.projectSTLData;
  }
  toClonedProjectStlObject() {
    return structuredClone(this.toProjectStlObject());
  }
  onViewWidgetEvent(e, n) {
    if (e.isViewMode3D()) {
      const s = this.actors.get(ge(e));
      switch (n) {
        case me.eVE_SHOW:
        case me.eVE_RENDER:
          if (e.getViewMode() === Nt._STL_3D_PREVIEW)
            if (this.id == "preview3d")
              s || this.create3dActor(e, { ignoreTransform: !1 });
            else {
              const r = this.context.objects.selectedObject.get(), a = r instanceof h0 ? r : null, o = a == null ? void 0 : a.objectBelongsToImplant(this);
              !s && o ? this.create3dActor(e, { ignoreTransform: !1 }) : s && !o && this.delete3dActor(e);
            }
          else
            s ? s.getProperty().setRepresentation(this.representation) : this.create3dActor(e, { ignoreTransform: this.ignoreTransform });
          break;
        case me.eVE_HIDE:
          break;
        case me.eVE_DESTROY:
          this.delete3dActor(e);
          break;
      }
    } else {
      let s = this.representations2D.get(e.id);
      switch (n) {
        case me.eVE_SHOW:
        case me.eVE_RENDER:
          s || (s = new jh(this.context, ge(e), this.polydata, this), this.representations2D.set(e.id, s)), s.setColor(this.getDisplayedColor()), s.setActorMatrix(this.matrix), s.setVisibility(this.visibility), s.onViewWidgetEvent(ge(e), n);
          break;
        case me.eVE_HIDE:
          break;
        case me.eVE_DESTROY:
          s == null || s.onViewWidgetEvent(ge(e), n), s == null || s.delete(), this.representations2D.delete(e.id);
          break;
      }
    }
    if (!e.isViewMode3D() && this.isImplant() && this.wasmCollisionZonePolydataReady) {
      let s = this.collZoneRepresentations2D.get(e.id);
      switch (n) {
        case me.eVE_SHOW:
        case me.eVE_RENDER:
          s || (s = new jh(this.context, ge(e), this.polydata, this, !0), this.collZoneRepresentations2D.set(e.id, s)), s.setColor(Kn(this.context.settings.defaultColors.securityZone));
          const r = this.getMatrix(), a = ut.create();
          ut.translate(a, ut.create(), [0, 0, this.getBounds()[5] - this.getImplantInfo().implantInfo.implantConnectorHeight]), ut.mul(a, r, a), s.setActorMatrix(a), s.setVisibility(this.visibility && this.context.settings.implants.securityZone), s.setOpacity(this.context.settings.implants.securityZoneTransparencyPercent / 100), s.onViewWidgetEvent(ge(e), n);
          break;
        case me.eVE_HIDE:
          break;
        case me.eVE_DESTROY:
          s == null || s.onViewWidgetEvent(ge(e), n), s == null || s.delete(), this.collZoneRepresentations2D.delete(e.id);
          break;
      }
    }
  }
  sendToParallelExecutor(e, n) {
    let s = this.representations2D.get(e.id);
    if (s || (s = new jh(this.context, ge(e), this.polydata, this), this.representations2D.set(e.id, s)), s.sendToParallelExecutor(ge(e)), !e.isViewMode3D() && this.isImplant() && this.wasmCollisionZonePolydataReady) {
      let r = this.collZoneRepresentations2D.get(e.id);
      r || (r = new jh(this.context, ge(e), this.polydata, this, !0), this.collZoneRepresentations2D.set(e.id, r)), r.sendToParallelExecutor(ge(e));
    }
    if (n) {
      const r = this.context.getWasmDocumentInstance();
      r && r.WaitForParallelExecutor();
    }
  }
  updateMeshBySrcId(e) {
    if (this.wasmStlObject) {
      const n = ge(this.wasmStlObject);
      n.UpdateMeshBySrcId(e), Cr(n, this.polydata, !0);
    }
  }
  syncWasmInfo(e = !0) {
    if (!this.wasmStlObject) return;
    const n = ge(this.wasmStlObject);
    this.cadType = n.GetTypeInt(), this.setName(n.GetNameString()), this.setDisplayText(n.GetDisplayTextString()), this.setVisibility(n.GetVisibility()), this.setOpacity(n.GetOpacity());
    const s = n.GetColor();
    this.setColor([s[0], s[1], s[2]]), Cr(n, this.polydata, !0, e), this.syncMatrixFromWasm();
  }
  syncMatrixFromWasm() {
    if (!this.wasmStlObject) return;
    const e = ge(this.wasmStlObject), n = sL(e), s = ut.fromValues(n[0], n[4], n[8], n[12], n[1], n[5], n[9], n[13], n[2], n[6], n[10], n[14], n[3], n[7], n[11], n[15]);
    this.setMatrix(s), this.polydata.modified(), this.update3dInfo();
  }
  getCadCorrespondenceId() {
    var e;
    return this.wasmStlObject ? ge(this.wasmStlObject).GetCADCorrespondenceId() : ((e = this.projectSTLData) == null ? void 0 : e.cadCorrespondenceId) ?? -1;
  }
  getCadReconstructionTypeId() {
    var e;
    return this.wasmStlObject ? ge(this.wasmStlObject).GetCADReconstructionTypeId() : ((e = this.projectSTLData) == null ? void 0 : e.cadReconstructionTypeId) ?? -1;
  }
  updateDisplayedColor() {
    const e = this.getDisplayedColor();
    for (const n of this.actors.values())
      n.getProperty().setColor(e);
    this.representations2D.forEach((n) => {
      n.setColor(e);
    }), this.update3dInfo(), this.context.objects.onStlColorChanged.notify({ id: this.id.toString(), color: e });
  }
  setColor(e) {
    if (this.color = e, this.wasmStlObject) {
      const n = ge(this.wasmStlObject);
      n && n.SetColor(e[0], e[1], e[2], 1);
    }
    this.colorOverride || this.updateDisplayedColor();
  }
  setColorOverride(e) {
    e === null && this.colorOverride === null || e !== this.colorOverride && (super.setColorOverride(e), this.updateDisplayedColor());
  }
  setLocked(e) {
    this.locked = e;
  }
  setOpacity(e) {
    this.opacity = e;
    for (const n of this.actors.values())
      n.getProperty().setOpacity(e);
    this.context.repaint();
  }
  setPickable(e) {
    this.pickable = e;
    for (const n of this.actors.values())
      n.setPickable(e);
  }
  toggleRepresentationWireframe() {
    this.representation == Vn.SURFACE ? this.representation = Vn.WIREFRAME : this.representation == Vn.WIREFRAME && (this.representation = Vn.SURFACE), this.context.sceneRepaint();
  }
  setVisibility(e, n) {
    if (!this.mDeleted) {
      if (this.visibility = e, this.wasmStlObject) {
        const s = ge(this.wasmStlObject);
        s && s.SetVisibility(e);
      }
      for (const s of this.actors.values())
        s.setVisibility(e);
      this.representations2D.forEach((s) => {
        s.setVisibility(e);
      }), this.update3dInfo(), !n && this.updateCrosssections(n);
    }
  }
  removeFromObject3dInfos() {
    this.context.objects.object3DInfos.update((e) => {
      const n = e.findIndex((s) => s.id === this.id);
      return n !== -1 && e.splice(n, 1), e;
    });
  }
  delete(e) {
    var n;
    if (!this.mDeleted) {
      this.mDeleted = !0, (n = super.delete) == null || n.call(this, e);
      for (const [s, r] of this.actors)
        s.removeActor(r), r.delete();
      for (const s of this.mappers.values())
        s.delete();
      this.polydata.delete();
      for (const [s, r] of this.representations2D)
        r.delete(), this.representations2D.delete(s);
      for (const [s, r] of this.collZoneRepresentations2D)
        r.delete(), this.collZoneRepresentations2D.delete(s);
      this.context.objects.stlsMatching.delete(this.id), this.context.objects.stls.delete(this.id), e || this.removeFromObject3dInfos(), this.context.undoManager.remove(this), console.warn("Deleting StlObject", this.id);
      try {
        if (this.wasmStlObject) {
          const s = ge(this.wasmStlObject);
          s && s.delete();
        }
      } catch (s) {
        console.log(s);
      }
      this.wasmStlObject = void 0;
    }
  }
  updateCrosssections(e) {
    this.context.sceneRepaint(
      void 0,
      (n, s) => {
        this.sendToParallelExecutor(n, !0), this.onViewWidgetEvent(n, s);
      },
      e
    );
  }
  setMatrix(e) {
    ut.copy(this.matrix, e);
    for (const [n, s] of this.actors.entries())
      s.setUserMatrix(this.matrix), n.getViewMode() === Nt._STL_3D_PREVIEW && this.resetStlPreviewCamera(n);
    if (this.wasmStlObject)
      try {
        $o(this.wasmStlObject, this.getMatrix());
      } catch (n) {
        console.log("EXCPTION: Update wasm Matrix", n);
      }
  }
  getMatrix() {
    return this.matrix;
  }
  getBounds() {
    var n, s;
    if (this.mDeleted || (s = (n = this.polydata).isDeleted) != null && s.call(n))
      return this.mLastBounds ?? [0, 0, 0, 0, 0, 0];
    const e = this.polydata.getBounds();
    return this.mLastBounds = e, e;
  }
  getWorldBounds() {
    const e = Ue.newInstance();
    e.setInputData(this.polydata);
    const n = Re.newInstance();
    return n.setMapper(e), n.setUserMatrix(this.matrix), e.modified(), n.getBounds();
  }
  getHeight() {
    return this.height;
  }
  getCenter() {
    const e = this.getBounds();
    return I.fromValues((e[0] + e[1]) / 2, (e[2] + e[3]) / 2, (e[4] + e[5]) / 2);
  }
  getWorldCenter() {
    const e = this.getWorldBounds();
    return I.fromValues((e[0] + e[1]) / 2, (e[2] + e[3]) / 2, (e[4] + e[5]) / 2);
  }
  getNormal() {
    return I.fromValues(this.matrix[8], this.matrix[9], this.matrix[10]);
  }
  getTangent() {
    return I.fromValues(this.matrix[0], this.matrix[1], this.matrix[2]);
  }
  getBinormal() {
    return I.fromValues(this.matrix[4], this.matrix[5], this.matrix[6]);
  }
  //should be same as in VolumeObject
  getMoveDeltaVectors(e, n, s) {
    if (I.copy(n, this.getNormal()), oJ(this.getName(), this.context.settings.general.useUSStyleToothChart, $e.MAXILLA) && I.scale(n, n, -1), e.getViewMode() == Nt.CPR) {
      const r = this.getPosition();
      I.scale(s, this.context.CPRMath.getClosestSplineTangent(r), -1);
    } else
      I.cross(s, e.getNormal(), e.getViewup()), I.normalize(s, s), e.isCrossCameraDirectionFlipped() && I.negate(s, s);
  }
  // move implant, pin, stlObject
  moveTo(e) {
    const n = ut.clone(this.matrix), s = this.getPosition(), r = I.create();
    I.sub(r, e, s);
    const a = ut.create();
    ut.translate(a, a, r);
    const o = ut.create();
    ut.mul(o, a, n), this.matrix = ut.clone(o), this.setMatrix(this.matrix), (this.type == Yt._STL_OBJECT || this.type === Yt._STL_TEETH_MODEL || this.type === Yt._STL_PROSTHESIS || this.type == Yt._STL_TOOTH) && this.updateCrosssections();
  }
  moveDelta(e, n) {
    const s = this.getPosition();
    I.scaleAndAdd(s, s, e, n), this.moveTo(s), this.cadType == Pe.eOT_IP_IMPLANT || this.type == Yt._IMPLANT ? this.context.getObjects().checkCollisions(this) : this.cadType == Pe.eOT_IP_PIN || this.type == Yt._PIN ? this.context.getObjects().checkCollisions(this) : this.isAnatomyCollisionObject() && this.context.getObjects().checkCollisions();
  }
  isAnatomyObject() {
    return this.type === Yt._STL_TEETH_MODEL || this.type === Yt._STL_OBJECT && this.getName() === "Anatomy";
  }
  isAntagonistObject() {
    return this.type === Yt._STL_OBJECT && this.getName() === "Antagonist";
  }
  isAnatomyCollisionObject() {
    return this.isAnatomyObject() || this.isAntagonistObject();
  }
  // move only for stlObject
  rotate(e, n, s) {
    const r = n * Math.PI / 180;
    s || (s = this.getPosition());
    const a = ut.create();
    ut.fromRotation(a, r, e);
    const o = ut.clone(this.getMatrix());
    o[12] -= s[0], o[13] -= s[1], o[14] -= s[2], ut.mul(o, a, o), o[12] += s[0], o[13] += s[1], o[14] += s[2], this.setMatrix(o);
  }
  rotateImplantPin(e, n, s, r, a) {
    if (this.locked) return;
    const o = a === "top" ? this.getBottom() : this.getTop();
    I.set(n, s[0], s[1], s[2]), Fs(e, o, r, e), Fs(n, o, r, n);
    const l = kL(e, n, o, r);
    I.set(e, n[0], n[1], n[2]), this.rotateImplantPinFi(l, r, a, o);
  }
  rotateImplantPinFi(e, n, s, r) {
    if (this.locked) return;
    let a = r;
    a == null && (a = s === "top" ? this.getBottom() : this.getTop());
    const o = ut.create();
    ut.fromRotation(o, e, n);
    const l = this.getMatrix(), c = I.create();
    for (let h = 0; h < 3; h++)
      c[h] = l[12 + h], l[12 + h] = 0;
    ut.mul(l, o, l);
    let u = Math.sqrt(Hn.distance2BetweenPoints(c, a));
    (s === "top" && this.getBounds()[4] < 0 || s === "bottom" && this.getBounds()[5] < 0) && (u *= -1);
    const d = this.getNormal();
    for (let h = 0; h < 3; h++) l[12 + h] = a[h] - u * d[h];
    this.setMatrix(l);
  }
  getTop(e, n) {
    const s = this.getBounds();
    let r;
    return n ? r = I.fromValues((s[0] + s[1]) / 2, (s[2] + s[3]) / 2, s[5]) : r = I.fromValues(0, 0, s[5]), I.transformMat4(r, r, this.getMatrix()), e && I.scaleAndAdd(r, r, this.getNormal(), e), r;
  }
  getBottom(e, n) {
    const s = this.getBounds();
    let r;
    return n ? r = I.fromValues((s[0] + s[1]) / 2, (s[2] + s[3]) / 2, s[4]) : r = I.fromValues(0, 0, s[4]), I.transformMat4(r, r, this.getMatrix()), e && I.scaleAndAdd(r, r, this.getNormal(), -e), r;
  }
  setForceCSRefreshOnTrue(e) {
    this.forceUpdateCS = !0, this.representations2D.forEach((n, s) => {
      e ? e.id == s && n.setForceCSRefreshOnTrue() : n.setForceCSRefreshOnTrue();
    });
  }
  getPosition() {
    const e = I.clone(this.getCenter());
    return I.transformMat4(e, e, this.getMatrix()), e;
  }
  createActorObjects(e) {
    var a, o, l, c, u;
    const n = Ue.newInstance();
    n.setInputData(this.polydata);
    const s = Re.newInstance();
    s.setMapper(n), s.getProperty().setOpacity(this.opacity), s.setPickable(this.pickable), s.setVisibility(this.visibility), s.getProperty().setRepresentation(this.representation), e != null && e.ignoreTransform ? (this.type === Yt._ABUTMENT && s.setUserMatrix(this.calculateRelativePosition()), (this.type === Yt._PRIMARY_SCAN_ABUTMENT || this.type === Yt._SECONDARY_ABUTMENT || this.type === Yt._SECONDARY_SCAN_ABUTMENT) && s.setUserMatrix(this.calculateRelativePosition()), this.type === Yt._SLEEVE && s.setUserMatrix(this.calculateRelativePosition())) : s.setUserMatrix(this.matrix), s.getProperty().setSpecular(0.75), (a = s.getBackfaceProperty()) == null || a.setSpecular(0);
    const r = 1;
    return s.getProperty().setDiffuse(r), (o = s.getBackfaceProperty()) == null || o.setDiffuse(Math.max(r - 0.5, 0)), s.getProperty().setSpecularPower(128), (l = s.getBackfaceProperty()) == null || l.setSpecularPower(128), this.texture ? (s.addTexture(this.texture), s.getProperty().setColor(1, 1, 1), n.setScalarVisibility(!1), s.getProperty().setAmbient(0.2), (c = s.getBackfaceProperty()) == null || c.setAmbient(0.5), this.setGlossy(!1)) : (this.isPly ? n.setScalarVisibility(!0) : s.getProperty().setColor(this.getDisplayedColor()), s.getProperty().setAmbient(0.05), (u = s.getBackfaceProperty()) == null || u.setAmbient(0.05)), this.glossy || (s.getProperty().setSpecular(0), s.getProperty().setSpecularPower(0)), { mapper: n, actor: s };
  }
  async getScreenshot(e) {
    const { width: n, height: s, background: r, orientation: a, zoom: o } = e;
    let l = a;
    switch (this.cadType) {
      case Pe.eOT_TEXTURED_FRONT_IMAGE:
        l = "front";
        break;
      case Pe.eOT_TEXTURED_LEFT_IMAGE:
        l = "left";
        break;
      case Pe.eOT_TEXTURED_RIGHT_IMAGE:
        l = "right";
        break;
      case Pe.eOT_TEXTURED_TOP_IMAGE:
        l = "top";
        break;
    }
    const { mapper: c, actor: u } = this.createActorObjects({ ignoreTransform: !e.transform });
    u.setVisibility(!0);
    const d = ip.newInstance();
    d.setParallelProjection(!0), X0({
      camera: d,
      orientation: l,
      focalPoint: u.getOrigin(),
      distance: 1
    });
    try {
      return await vg({
        actor: u,
        camera: d,
        width: n,
        height: s,
        background: r,
        zoom: o
      });
    } finally {
      u.delete(), c.delete(), d.delete();
    }
  }
  create3dActor(e, n) {
    e.getViewMode() == Nt.STL3D && (this.visibility = !0), e.getViewMode() == Nt._3D;
    const s = ge(e), { mapper: r, actor: a } = this.createActorObjects(n);
    this.mappers.set(s, r), this.actors.set(s, a), e.addActor(a, this.getRenderingLayer()), e.getViewMode() === Nt._STL_3D_PREVIEW && this.resetStlPreviewCamera(e);
  }
  getStlPreviewCameraFocus(e) {
    const n = this.context.objects.selectedObject.get(), s = n instanceof h0 ? n : null;
    if (s) {
      const r = s.getTop(0, !0);
      return [r[0], r[1], r[2]];
    }
    return this.getTop(0, !0);
  }
  getStlPreviewCameraPlane() {
    const e = this.context.objects.selectedObject.get(), n = e instanceof h0 ? e : null;
    if (!n || this.id !== "preview3d" && !n.objectBelongsToImplant(this))
      return null;
    const s = n.getTangent();
    I.scale(s, s, -1);
    const r = n.getNormal();
    return {
      direction: [s[0], s[1], s[2]],
      viewUp: [r[0], r[1], r[2]]
    };
  }
  resetStlPreviewCamera(e) {
    const n = this.getStlPreviewCameraFocus(e), s = this.getStlPreviewCameraPlane(), r = e;
    if (s && r.resetViewCameraToPlane) {
      r.resetViewCameraToPlane(n, s.direction, s.viewUp);
      return;
    }
    e.resetViewCamera(n);
  }
  delete3dActor(e) {
    var r;
    const n = ge(e), s = this.actors.get(n);
    s && (e.removeActor(s), s.delete()), (r = this.mappers.get(n)) == null || r.delete(), this.actors.delete(n), this.mappers.delete(n);
  }
  getPolydata() {
    return this.polydata;
  }
  setPolyData(e) {
    this.polydata = e;
    const n = e.getBounds();
    this.mLastBounds = [n[0], n[1], n[2], n[3], n[4], n[5]], this.height = Math.abs(n[5] - n[4]), this.context.getPresenterWindows().forEach((s) => {
      const r = s.getMainView();
      r && r.getViewMode() == Nt._3D && this.delete3dActor(r);
    });
  }
  collisionDetection(e) {
    if (!this.wasmStlObject || !e.wasmStlObject) return !1;
    const n = ge(this.wasmStlObject), s = ge(e.wasmStlObject);
    $o(n, this.getMatrix()), $o(s, e.getMatrix());
    const r = n.CollisionDetection(e.id);
    return r ? (this.collisionMap.set(e, !!n.collisionZoneFlag), e.collisionMap.set(this, !!n.collisionZoneFlag)) : (this.collisionMap.delete(e), e.collisionMap.delete(this)), r;
  }
  resetCollisions() {
    this.collisions.implantCollision = !1, this.collisions.securityZoneCollision = !1, this.collisions.nerveCollision = !1, this.collisions.sleeveCollision = !1, this.collisions.sleeveChanged = null, this.collisions.anatomyCollision = !1;
  }
  isActorObject(e) {
    for (const [, n] of this.actors)
      if (e == n) return this.id;
    return null;
  }
  update3dInfo() {
    var n, s;
    if (this.mDeleted || (s = (n = this.polydata).isDeleted) != null && s.call(n) || this.isImage3D()) return;
    const e = {
      id: this.id,
      name: this.getGUIName(),
      visible: this.visibility,
      position: this.getPosition(),
      handleTop: null,
      handleBottom: null,
      centerlineTop: null,
      centerlineBottom: null,
      color: Pa(this.getColor()),
      type: this.type
    };
    this.context.objects.object3DInfos.update((r) => {
      const a = r.findIndex((o) => o.id === this.id);
      return a !== -1 ? r[a] = e : r.push(e), r;
    });
  }
  SetReportDims(e, n, s, r, a, o) {
  }
  async getCrossScreenshot(e, n, s) {
    let r = "";
    if (!this.context.objects.hasCPR()) return r;
    this.context.objects.snapToObject(this.id);
    const a = await oA(this.context, e, 0.75);
    return a && (r = a), r;
  }
}
class $Dt extends NC {
  constructor(e, n) {
    super();
    S(this, "wasmUndoObject");
    S(this, "onUndo");
    S(this, "onRedo");
    const s = e.getEngine();
    this.wasmUndoObject = new s.WasmStlUndoObject(n.id), this.onUndo = () => {
      this.wasmUndoObject.OnUndo(), n.wasmStlObject && (Cr(n.wasmStlObject, n.getPolydata(), !0), e.repaint());
    }, this.onRedo = () => {
      this.wasmUndoObject.OnRedo(), n.wasmStlObject && (Cr(n.wasmStlObject, n.getPolydata(), !0), e.repaint());
    }, this.delete = () => {
      this.wasmUndoObject.delete();
    }, this.getMemory = () => this.wasmUndoObject.GetMemory();
  }
}
class xz {
  constructor() {
    S(this, "mapper", Ue.newInstance());
    S(this, "data", Ie.newInstance());
    S(this, "actor", Re.newInstance());
    S(this, "points", yi.newInstance());
    S(this, "lines", Ii.newInstance());
    S(this, "radius", 0.3);
    S(this, "filter", Qh.newInstance({
      radius: 0.3,
      numberOfSides: 30,
      capping: !0
    }));
    this.filter.setInputData(this.data), this.mapper.setInputConnection(this.filter.getOutputPort()), this.actor.setMapper(this.mapper), this.data.setPoints(this.points), this.data.setLines(this.lines), this.actor.setVisibility(!0), this.actor.setPickable(!0);
  }
  setData(t) {
    const e = t.points.length, n = new Float32Array(e * 3), s = new Uint16Array(e + 1);
    for (let r = 0; r < e; r++) {
      const a = t.points[r];
      n[3 * r] = a[0], n[3 * r + 1] = a[1], n[3 * r + 2] = a[2], s[r + 1] = r;
    }
    s[0] = e, this.points.setData(n, 3), this.lines.setData(s), t.color[0] > 1 || t.color[1] > 1 || t.color[2] > 1 ? this.actor.getProperty().setColor([t.color[0] / 255, t.color[1] / 255, t.color[2] / 255]) : this.actor.getProperty().setColor(t.color), this.radius = t.radius, this.filter.setRadius(this.radius), this.data.modified();
  }
  getRadius() {
    return this.radius;
  }
  getActor() {
    return this.actor;
  }
  getMapper() {
    return this.mapper;
  }
  delete() {
    this.points.delete(), this.lines.delete(), this.data.delete(), this.filter.delete(), this.mapper.delete(), this.actor.delete();
  }
}
class OC extends vn {
  constructor(e) {
    super(e);
    S(this, "type", Yt._ABUTMENT);
    S(this, "subType", Yt._NONE);
    S(this, "implant");
    S(this, "abutmentInfo");
    this.initialize(e), this.implant = e.implant, this.abutmentInfo = e.info, this.abutmentInfo.fileName = "tmp/" + this.abutmentInfo.guid;
  }
  static fromProjectAbutment(e, n, s, r) {
    var c, u, d;
    if (!s.stlFile) throw "No STL file found for abutment";
    const a = Lo(s.stlFile.data, "stl"), o = ut.create(), l = new OC({
      stlData: ((c = s.stlFile) == null ? void 0 : c.data) || new Int8Array(),
      context: e,
      polydata: a,
      matrix: o,
      implant: n,
      info: s,
      stlFilename: ((u = s.stlFile) == null ? void 0 : u.fileName) || "",
      plyFilename: "",
      oType: Pe.eOT_IP_ABUTMENT
    });
    return l.setColor([r[0] / 255, r[1] / 255, r[2] / 255]), l.setVisibility(n.getVisibility()), l.setName(n.getName()), (d = l.wasmStlObject) == null || d.SetAbutmentAngle(l.abutmentInfo.angle), l.opacity = r[3] / 255, l;
  }
  onViewWidgetEvent(e, n) {
    super.onViewWidgetEvent(e, n);
  }
  delete(e) {
    super.delete(e);
  }
  /** Calculate transform matrix for abutment relative to implant */
  calculateAbutmentoffset() {
    ut.create();
    const e = this.implant.getBounds()[5], n = this.getAbutmentBaseHeight(), s = this.abutmentInfo.connectorHeight, r = this.implant.getImplantInfo().implantInfo.implantConnectorHeight;
    return e + n - s - r;
  }
  /** Calculate transform matrix for abutment relative to implant */
  calculateRelativePosition() {
    const e = ut.create(), n = this.implant.getBounds()[5], s = this.getAbutmentBaseHeight(), r = this.abutmentInfo.connectorHeight, a = this.implant.getImplantInfo().implantInfo.implantConnectorHeight, o = n + s - r - a;
    return ut.translate(e, ut.create(), [0, 0, o]), e;
  }
  getAbutmentInfo() {
    return this.abutmentInfo.fileName = "tmp/" + this.abutmentInfo.guid, this.abutmentInfo;
  }
  getAbutmentBaseHeight() {
    return -this.getBounds()[4];
  }
  getImplantMatrix() {
    return this.implant.getMatrix();
  }
}
class zC extends vn {
  constructor(e) {
    super(e);
    S(this, "subType", Yt._NONE);
    S(this, "implant");
    S(this, "attachmentInfo");
    this.implant = e.implant, this.attachmentInfo = e.info, this.attachmentInfo.fileName = "tmp/" + this.attachmentInfo.guid;
  }
  /** Calculate transform matrix for attachment relative to implant. */
  calculateRelativePosition() {
    const e = ut.create(), n = this.implant.getBounds()[5], s = this.implant.getImplantInfo().implantInfo.implantConnectorHeight, r = n - s;
    return ut.translate(e, ut.create(), [0, 0, r]), e;
  }
  getAttachmentInfo() {
    return this.attachmentInfo.fileName = "tmp/" + this.attachmentInfo.guid, this.attachmentInfo;
  }
}
class EC extends zC {
  constructor(e) {
    super(e);
    S(this, "type", Yt._PRIMARY_SCAN_ABUTMENT);
    this.initialize(e);
  }
  /** Build a scan abutment attachment from project data. */
  static fromProjectScanAbutment(e, n, s, r) {
    var c, u;
    if (!s.stlFile) throw "No STL file found for scan abutment";
    const a = Lo(s.stlFile.data, "stl"), o = ut.create(), l = new EC({
      stlData: ((c = s.stlFile) == null ? void 0 : c.data) || new Int8Array(),
      context: e,
      polydata: a,
      matrix: o,
      implant: n,
      info: s,
      stlFilename: ((u = s.stlFile) == null ? void 0 : u.fileName) || "",
      plyFilename: "",
      oType: Pe.eOT_IP_SCAN_ABUTMENT
    });
    return l.setColor([r[0] / 255, r[1] / 255, r[2] / 255]), l.setVisibility(n.getVisibility()), l.setName(n.getName()), l.opacity = r[3] / 255, l;
  }
}
class kC extends zC {
  constructor(e) {
    super(e);
    S(this, "type", Yt._SECONDARY_ABUTMENT);
    this.initialize(e);
  }
  /** Build a secondary abutment attachment from project data. */
  static fromProjectSecondaryAbutment(e, n, s, r) {
    var c, u;
    if (!s.stlFile) throw "No STL file found for secondary abutment";
    const a = Lo(s.stlFile.data, "stl"), o = ut.create(), l = new kC({
      stlData: ((c = s.stlFile) == null ? void 0 : c.data) || new Int8Array(),
      context: e,
      polydata: a,
      matrix: o,
      implant: n,
      info: s,
      stlFilename: ((u = s.stlFile) == null ? void 0 : u.fileName) || "",
      plyFilename: "",
      oType: Pe.eOT_IP_SECONDARY_ABUTMENT
    });
    return l.setColor([r[0] / 255, r[1] / 255, r[2] / 255]), l.setVisibility(n.getVisibility()), l.setName(n.getName()), l.opacity = r[3] / 255, l;
  }
}
class FC extends zC {
  constructor(e) {
    super(e);
    S(this, "type", Yt._SECONDARY_SCAN_ABUTMENT);
    this.initialize(e);
  }
  /** Build a secondary scan abutment attachment from project data. */
  static fromProjectSecondaryScanAbutment(e, n, s, r) {
    var c, u;
    if (!s.stlFile) throw "No STL file found for secondary scan abutment";
    const a = Lo(s.stlFile.data, "stl"), o = ut.create(), l = new FC({
      stlData: ((c = s.stlFile) == null ? void 0 : c.data) || new Int8Array(),
      context: e,
      polydata: a,
      matrix: o,
      implant: n,
      info: s,
      stlFilename: ((u = s.stlFile) == null ? void 0 : u.fileName) || "",
      plyFilename: "",
      oType: Pe.eOT_IP_SECONDARY_SCAN_ABUTMENT
    });
    return l.setColor([r[0] / 255, r[1] / 255, r[2] / 255]), l.setVisibility(n.getVisibility()), l.setName(n.getName()), l.opacity = r[3] / 255, l;
  }
}
class lw extends vn {
  constructor(e) {
    super(e);
    S(this, "type", Yt._SLEEVE);
    S(this, "subType", Yt._NONE);
    S(this, "implant");
    S(this, "sleeveInfo");
    S(this, "drillLengths", []);
    S(this, "drillLength", 0);
    S(this, "sleeveDistance", 0);
    S(this, "minimalDrillLength", 0);
    S(this, "sleeveLength", 0);
    S(this, "sleeveIntRadius", 0);
    S(this, "sleeveExtRadius", 0);
    S(this, "sleeveManuallyChanged", 0);
    // if sleeve was manually changed, mark it in collisions
    S(this, "sleeveOffset", 0);
    this.initialize(e), this.implant = e.implant, this.sleeveInfo = e.sleeveInfo;
  }
  static fromProjectSleeve(e, n, s) {
    var d, h, p, m, b;
    let r, a = Kn(e.settings.defaultColors.sleeves), o = s.dExternal / 2, l = s.dInternal / 2, c = s.lSleeve;
    if (s.stlData) {
      r = Lo(s.stlData.data, "stl");
      const y = r.getBounds();
      let Z = [0, 0, 0];
      Z[0] = Math.abs(y[1] - y[0]), Z[1] = Math.abs(y[3] - y[2]), Z[2] = Math.abs(y[5] - y[4]), o = Math.max(Z[0], Z[1]) / 2, l = o * 0.8, c = Z[2];
    } else {
      const y = e.getEngine(), Z = new y.TGuideVTK(
        o,
        l,
        n.isImplant() ? 30 : 40,
        // height = guide_length-> Implant -> 30, pim -> 40
        s.distanceFromImplant,
        c,
        jS(s, n.isImplant()),
        s.lLip,
        s.lCut,
        s.rotationAll ?? 0,
        s.rotationCut ?? 0,
        n.isImplant() ? 0 : 1,
        2,
        1,
        0.12
      );
      r = Ie.newInstance(), r.getPoints().setData(Z.pointsView);
      const g = new Uint32Array(Z.polysView.length);
      for (let f = 0; f < Z.polysView.length; f++)
        g[f] = Number(Z.polysView[f]);
      r.getPolys().setData(g);
    }
    const u = new lw({
      stlData: ((d = s.stlData) == null ? void 0 : d.data) || new Int8Array(),
      context: e,
      polydata: r,
      matrix: ut.create(),
      implant: n,
      sleeveInfo: s,
      oType: Pe.eOT_PIN_SLEEVE
    });
    return u.setVisibility(n.getVisibility()), u.setColor(a), u.setName(n.getName()), (h = u.wasmStlObject) == null || h.SetSleeveManufacturerName(u.sleeveInfo.manufacturerName), (p = u.wasmStlObject) == null || p.SetSleeveModelName(u.sleeveInfo.modelName), (m = u.wasmStlObject) == null || m.SetSleeveCustomSupport(s.customSleeveSupport ?? !1), (b = u.wasmStlObject) == null || b.SetIsParametricObject(!s.stlNegativeData), u.opacity = n.getOpacity(), u.sleeveLength = c, u.sleeveExtRadius = o, u.sleeveIntRadius = l, u.sleeveDistance = u.roundDistance(s.distanceFromImplant), u.setSleeveParameters(u.sleeveInfo, !0), u.updateSleeveOffsetFromInfo(), u;
  }
  onViewWidgetEvent(e, n) {
    super.onViewWidgetEvent(e, n);
  }
  delete(e) {
    super.delete(e);
  }
  /** Calculate transform matrix for sleeve relative to implant */
  calculateRelativePosition() {
    const e = ut.create(), n = this.sleeveInfo.distanceFromImplant, s = this.implant.isImplant() ? this.implant.getImplantInfo().implantInfo.implantConnectorHeight : 0, a = (this.implant.isImplant() ? this.implant.getBounds()[5] : this.implant.getBounds()[4]) + n - s;
    if (this.implant.isImplant()) {
      const o = this.sleeveInfo.connectionIndex, l = this.implant.getProjectImplantInfo().connectionSides;
      o && l && ut.rotateZ(e, e, xW(360 * o / l));
    }
    return ut.translate(e, e, [0, 0, a]), e;
  }
  getSleeveInfo() {
    return this.sleeveInfo;
  }
  getDrillLengths() {
    return this.drillLengths;
  }
  getDrillLength() {
    return this.drillLength;
  }
  getOverallLength() {
    let e = 0;
    return this.implant.isImplant() && (e = this.implant.getProjectImplantInfo().implantConnectorHeight), this.sleeveInfo.distanceFromImplant + this.sleeveLength + this.implant.getHeight() - e;
  }
  getDistanceFromImplant() {
    return this.sleeveInfo.distanceFromImplant;
  }
  setDrillLengths() {
    this.sleeveInfo.drillLengthSizes.length && (this.drillLengths = this.sleeveInfo.drillLengthSizes.split(";").map((e) => Number(e)).filter((e) => e > 0), this.restoreDrillLength());
  }
  restoreDrillLength() {
    this.drillLengths.length && this.setDrillLength(this.drillLengths[0]);
  }
  setDrillLength(e, n) {
    this.implant.isImplant() && (this.drillLength = e, this.drillLength >= 0 && (this.sleeveDistance = this.roundDistance(
      this.drillLength - (this.implant.getHeight() - this.implant.getProjectImplantInfo().implantConnectorHeight) - this.sleeveLength - this.sleeveInfo.reductionSystemSize
    ), this.sleeveInfo.distanceFromImplant = this.roundDistance(this.sleeveDistance), this.updateSleeveOffsetFromInfo()));
  }
  setDrillLengthAutomatically(e) {
    if (this.implant.isImplant() && this.drillLengths.length > 1) {
      let n = -1;
      const s = this.context.objects.findSleeveIntersectionObject();
      if (s && this.wasmStlObject) {
        let a;
        this.implant.isImplant() ? a = this.implant.getTop(0, !0) : a = this.implant.getBottom(0, !0), n = this.wasmStlObject.CalculateMinimalSleeveDistance(
          s.id,
          this.sleeveExtRadius,
          this.sleeveIntRadius,
          this.sleeveLength,
          this.sleeveInfo.distanceFromImplant,
          new Float64Array(a),
          new Float64Array(this.getNormal())
        );
      }
      this.minimalDrillLength = this.implant.getHeight() - this.implant.getProjectImplantInfo().implantConnectorHeight + n + this.sleeveLength + this.sleeveInfo.reductionSystemSize;
      let r = -1;
      for (let a = 0; a < this.drillLengths.length; a++)
        if (this.drillLengths[a] > this.minimalDrillLength) {
          r = this.drillLengths[a];
          break;
        }
      (this.getDrillLength() <= 0 || e) && (n < 0 ? this.setDrillLength(this.drillLengths[0]) : r < 0 ? this.setDrillLength(this.drillLengths[this.drillLengths.length - 1]) : this.setDrillLength(r));
    }
  }
  sleeveHeightChange(e) {
    !this.sleeveManuallyChanged && this.sleeveInfo.originalDistanceFromImplant < 0 && (this.sleeveInfo.originalDistanceFromImplant = this.roundDistance(this.sleeveInfo.distanceFromImplant)), this.sleeveInfo.distanceFromImplant = this.roundDistance(e), this.setSleeveParameters(this.sleeveInfo), this.isEqual(this.sleeveInfo.originalDistanceFromImplant, this.sleeveInfo.distanceFromImplant) && this.sleeveInfo.referencedSleeve ? this.sleeveManuallyChanged = 0 : this.sleeveManuallyChanged = 1, this.updateSleeveOffsetFromInfo();
  }
  setSleeveParameters(e, n) {
    (n || this.sleeveInfo != e || e.drillLengthSizes.length) && (this.sleeveManuallyChanged = 0, this.drillLength = 0, this.sleeveInfo.distanceFromImplant = this.roundDistance(e.distanceFromImplant), this.sleeveInfo.originalDistanceFromImplant >= 0 && (this.sleeveInfo.originalDistanceFromImplant = this.roundDistance(this.sleeveInfo.originalDistanceFromImplant)), this.sleeveInfo.referencedSleeve = e.referencedSleeve, this.sleeveInfo.dExternal < 1e-4 && !this.sleeveInfo.stlData && (this.sleeveInfo.dExternal = 6, this.sleeveInfo.dInternal = 5, this.sleeveInfo.lSleeve = 3, this.sleeveInfo.distanceFromImplant = 5), this.setDrillLengths(), this.updateSleeveOffsetFromInfo());
  }
  isEqual(e, n) {
    return Math.abs(e - n) <= 1e-6;
  }
  roundDistance(e) {
    return XP(e, 12);
  }
  updateSleeveOffsetFromInfo() {
    let e = 0;
    if (this.sleeveInfo.originalDistanceFromImplant >= 0) {
      const n = this.sleeveInfo.distanceFromImplant - this.sleeveInfo.originalDistanceFromImplant;
      this.isEqual(n, 0) || (e = n);
    }
    this.sleeveOffset = this.roundDistance(e);
  }
  getSleeveName() {
    const e = this.sleeveInfo.originalName, n = e.split("__");
    let s;
    return n.length == 2 ? s = `${this.sleeveInfo.manufacturerName} / ${this.sleeveInfo.modelName} / ${this.sleeveInfo.sellingCode}` : e.endsWith("[CUSTOM]") ? s = "CUSTOM/" + e : s = "UNKNOWN/" + e, s;
  }
}
class Wb extends vn {
  constructor(e) {
    super(e);
    S(this, "implant");
    S(this, "part");
    S(this, "extrusionInfo");
    S(this, "scaleMatrix");
    S(this, "extrusionBuilder");
    S(this, "type", Yt._GUIDE_SUPPORT_OBJECT);
    S(this, "subType", Yt._GUIDE_SUPPORT_OBJECT);
    this.initialize(e), this.implant = e.implant, this.extrusionInfo = e.extrusionInfo, this.extrusionBuilder = e.extrusionBuilder, this.part = e.part, this.scaleMatrix = e.scaleMatrix, this.implant.addExtrusionObject(this);
  }
  //part 2 = eOT_IP_TOP_EXTRUSION, part 3 = eOT_IP_BOTTOM_EXTRUSION, 4 = eOT_IP_ANALOG_EXTRUSION,
  static async constructExtrusionObject(e, n, s, r, a) {
    var m, b;
    const o = e.getEngine();
    let l, c = Ie.newInstance();
    const u = ut.create(), d = Kn(e.settings.defaultColors.modelTools);
    if (!s.stlData || s.stlData.data.length == 0) {
      l = new o.TModelToolVTK(
        n.isImplant() ? 0 : 1,
        s.supportRModel / 2,
        s.support_lenght,
        s.d1Model / 2,
        s.d2Model / 2,
        s.l1Model,
        s.l2Model,
        s.bottomExtrusionRModel / 2,
        s.base_lenght,
        s.cutSizeModel,
        s.rotation_cutModel,
        r,
        a
      ), c.getPoints().setData(l.pointsView);
      const y = new Uint32Array(l.polysView.length);
      for (let Z = 0; Z < l.polysView.length; Z++)
        y[Z] = Number(l.polysView[Z]);
      c.getPolys().setData(y);
    } else if (s.stlData) {
      c = Lo(s.stlData.data, "stl");
      const y = c.getBounds(), Z = I.create();
      Z[0] = Math.abs(y[1] - y[0]), Z[1] = Math.abs(y[2] - y[3]), Z[2] = Math.abs(y[5] - y[4]);
      const g = Math.max(Z[0], Z[1]) / 2, f = I.create();
      f[0] = -(y[1] + y[0]) / 2, f[1] = -(y[2] + y[3]) / 2, f[2] = -(y[5] + y[4]) / 2;
      let T = 0.2 / 2;
      T = (g + T * 1) / g, ut.fromScaling(u, I.fromValues(T, T, 1));
    }
    let h = Pe.eOT_UNKNOWN;
    n.isImplant() ? r == 2 ? h = Pe.eOT_IP_TOP_EXTRUSION : r == 3 ? h = Pe.eOT_IP_BOTTOM_EXTRUSION : r == 4 ? h = Pe.eOT_IP_ANALOG_EXTRUSION : console.error("Unknown part for implant extrusion object", r) : r == 3 ? h = Pe.eOT_IP_PIN_EXTRUSION : console.error("Unknown part for pin extrusion object", r);
    const p = new Wb({
      stlData: ((m = s.stlData) == null ? void 0 : m.data) || new Int8Array(),
      context: e,
      polydata: c,
      implant: n,
      matrix: ut.create(),
      extrusionInfo: s,
      extrusionBuilder: l,
      oType: h,
      part: r,
      scaleMatrix: u
    });
    return p.visibility = !0, p.locked = !0, p.color = d, p.updatePosition(), p.wasmStlObject && (p.wasmStlObject.SetIsParametricObject(!s.stlData), p.wasmStlObject.SetModelSupportRadius(s.supportRModel / 2), p.wasmStlObject.SetModelSupportLength(s.support_lenght), p.wasmStlObject.SetModelBaseRadius(s.bottomExtrusionRModel / 2), p.wasmStlObject.SetModelBaseLength(s.base_lenght), (b = n.wasmStlObject) == null || b.SetModelObjById(p.id, p.cadType)), p;
  }
  onViewWidgetEvent(e, n) {
    super.onViewWidgetEvent(e, n);
  }
  delete(e) {
    var n, s;
    super.delete(e), (n = this.wasmStlObject) == null || n.DeleteModelObj(this.cadType), this.implant.removeFromExtrusionObjects(this.id), this.context.objects.stls.delete(this.id), (s = this.extrusionBuilder) == null || s.delete();
  }
  // TODO carefull this is on two position here and in Constructor
  updateObject(e) {
    const n = this.extrusionInfo, s = this.implant;
    let r = Ie.newInstance();
    if (!n.stlData && this.extrusionBuilder) {
      this.extrusionBuilder.CreateVTKObjects(
        s.isImplant() ? 0 : 1,
        n.supportRModel / 2,
        n.support_lenght,
        n.d1Model / 2,
        n.d2Model / 2,
        n.l1Model,
        n.l2Model,
        n.bottomExtrusionRModel / 2,
        n.base_lenght,
        n.cutSizeModel,
        n.rotation_cutModel,
        this.part,
        e
      ), r.getPoints().setData(this.extrusionBuilder.pointsView);
      const o = new Uint32Array(this.extrusionBuilder.polysView.length);
      for (let l = 0; l < this.extrusionBuilder.polysView.length; l++)
        o[l] = Number(this.extrusionBuilder.polysView[l]);
      r.getPolys().setData(o);
    } else if (n.stlData) {
      r = Lo(n.stlData.data, "stl");
      const o = this.polydata.getBounds(), l = I.create();
      l[0] = Math.abs(o[1] - o[0]), l[1] = Math.abs(o[2] - o[3]), l[2] = Math.abs(o[5] - o[4]);
      const c = Math.max(l[0], l[1]) / 2, u = I.create();
      u[0] = -(o[1] + o[0]) / 2, u[1] = -(o[2] + o[3]) / 2, u[2] = -(o[5] + o[4]) / 2;
      let d = 0.2 / 2;
      d = (c + d * 1) / c, ut.fromScaling(this.scaleMatrix, I.fromValues(d, d, 1));
    }
    const a = !0;
    this.wasmStlObject ? (du(this.wasmStlObject, r, a, !1, !1, a), $o(this.wasmStlObject, this.matrix), this.wasmStlObject.SetMeshSplitting(!0), Cr(this.wasmStlObject, this.polydata, a)) : console.error("Wasm object not found for guide object"), this.updatePosition(), this.polydata.modified();
  }
  /** Calculate transform matrix for sleeve relative to implant */
  calculateRelativePosition() {
    var a, o;
    const e = ut.create();
    let s = this.implant.isImplant() ? this.implant.getBounds()[5] : this.implant.getBounds()[4], r = 0;
    return this.implant.isImplant() ? (r = this.implant.getImplantInfo().implantInfo.implantConnectorHeight, !this.extrusionInfo.stlData || this.extrusionInfo.stlData.data.length == 0 ? s = s + (((a = this.extrusionBuilder) == null ? void 0 : a.GetHeight()) || 0) / 2 - r : this.extrusionInfo.stlData && (s = s - r)) : s = s + (((o = this.extrusionBuilder) == null ? void 0 : o.GetHeight()) || 0) / 2 + this.extrusionInfo.base_lenght, ut.mul(e, e, this.scaleMatrix), ut.translate(e, e, [0, 0, s]), e;
  }
  updatePosition() {
    const e = this.implant.getMatrix(), n = this.calculateRelativePosition();
    ut.mul(n, e, n), this.setMatrix(n);
  }
  getExtrusionInfo() {
    return this.extrusionInfo;
  }
  setToothSelected(e) {
    var n;
    (n = this.wasmStlObject) == null || n.SetToothSelected(e);
  }
}
const Pr = 1e-6, tNt = 1;
class Sz {
  constructor(t, e) {
    S(this, "polyData", Ie.newInstance());
    S(this, "points", yi.newInstance());
    S(this, "lines", Ii.newInstance());
    S(this, "tubeFilter", Qh.newInstance({
      radius: 0.08,
      numberOfSides: 12,
      capping: !0
    }));
    S(this, "mapper", Ue.newInstance());
    S(this, "actor", Re.newInstance());
    this.polyData.setPoints(this.points), this.polyData.setLines(this.lines), this.tubeFilter.setInputData(this.polyData), this.tubeFilter.setRadius(e), this.mapper.setInputConnection(this.tubeFilter.getOutputPort()), this.actor.setMapper(this.mapper), this.actor.setPickable(!1), this.actor.getProperty().setColor(t), this.actor.getProperty().setAmbient(1), this.actor.getProperty().setDiffuse(0), this.actor.getProperty().setSpecular(0);
  }
  setSegments(t) {
    if (t.length === 0) {
      this.points.setData(new Float32Array(0), 3), this.lines.setData(new Uint32Array(0)), this.polyData.modified();
      return;
    }
    const e = new Float32Array(t.length * 2 * 3), n = new Uint32Array(t.length * 3);
    let s = 0, r = 0;
    for (const [a, o] of t) {
      e[s * 3 + 0] = a[0], e[s * 3 + 1] = a[1], e[s * 3 + 2] = a[2];
      const l = s;
      s++, e[s * 3 + 0] = o[0], e[s * 3 + 1] = o[1], e[s * 3 + 2] = o[2];
      const c = s;
      s++, n[r++] = 2, n[r++] = l, n[r++] = c;
    }
    this.points.setData(e, 3), this.lines.setData(n), this.polyData.modified();
  }
  addToView(t) {
    t.addActor(this.actor);
  }
  removeFromView(t) {
    t.removeActor(this.actor);
  }
  delete() {
    this.points.delete(), this.lines.delete(), this.polyData.delete(), this.tubeFilter.delete(), this.mapper.delete(), this.actor.delete();
  }
}
class eNt {
  constructor() {
    S(this, "dimLines", new Sz([0.6, 0.6, 0.6], 0.05));
    S(this, "dimTexts", new Sz([0.95, 0.95, 0.95], 0.035));
  }
  update(t) {
    const e = [], n = [], s = this.normalize(t.axis);
    let r = this.normalize(t.front);
    Math.abs(I.dot(r, s)) > 0.98 && (r = I.cross(I.create(), s, this.normalize(t.right)), I.length(r) < Pr && (r = I.cross(I.create(), s, I.fromValues(1, 0, 0))), I.length(r) < Pr && (r = I.cross(I.create(), s, I.fromValues(0, 1, 0))), r = this.normalize(r));
    let a = I.cross(I.create(), r, s);
    I.length(a) < Pr && (a = this.normalize(t.right)), I.length(a) < Pr && (a = I.fromValues(1, 0, 0)), I.normalize(a, a), r = I.cross(I.create(), s, a), I.normalize(r, r);
    const o = Math.max(t.sleeveDiameter, Pr), l = Math.max(t.sleeveInnerDiameter, Pr), c = Math.max(t.implantDiameter, Pr), u = t.showLipDimension, d = u ? Math.max(t.lipHeight, 0) : 0, h = Math.max(t.sleeveHeight, 0), p = Math.max(t.distanceHeight, 0), m = Math.max(0.45, o * 0.14), b = Math.max(1.35, o * 0.55), y = 0, Z = Math.max(0.8, o * 0.16), g = Math.max(0.2, o * 0.05), f = 0.5 * o, T = 0.5 * l, M = 0.5 * c, N = this.projectToAxis(t.topImplant, t.topImplant, s), W = this.projectToAxis(t.bottomImplant, t.topImplant, s), x = this.projectToAxis(t.topSleeve, t.topImplant, s), V = this.projectToAxis(t.bottomSleeve, t.topImplant, s), X = I.scale(I.create(), I.add(I.create(), V, N), 0.5), C = -0.5 * o - b * 1.35, R = 0.5 * o + b, z = R + 0.9, F = C + Math.max(0.9, b * 0.35), P = Math.max(2.1, o * 0.38), j = Math.min(F, -f - P), H = Math.max(0.75, Math.min(1.05, b * 0.42)), B = Math.max(1.05, o * 0.2), $ = Math.min(C, j - B), A = 1.7 + Z, E = 0.05 + Z, ct = this.offset(x, a, s, r, $, 0, y), at = this.offset(W, a, s, r, $, 0, y);
    this.appendDimension(e, ct, at, r, m, t.totalHeight);
    const dt = this.offset(x, a, s, r, -f, 0, y), gt = this.offset(W, a, s, r, -Math.max(M * 0.65, 0.2), 0, y);
    this.appendConnector(e, dt, ct), this.appendConnector(e, gt, at), this.appendText(
      n,
      this.formatValue(t.totalHeight),
      this.offset(I.scale(I.create(), I.add(I.create(), ct, at), 0.5), a, s, r, -1.2, 0, -0.3),
      a,
      s,
      g
    );
    const Wt = this.offset(x, a, s, r, -f, A, y), Zt = this.offset(x, a, s, r, f, A, y);
    this.appendDimension(e, Wt, Zt, r, m, o);
    const Gt = this.offset(x, a, s, r, -f, 0, y), Tt = this.offset(x, a, s, r, f, 0, y);
    if (this.appendConnector(e, Gt, Wt), this.appendConnector(e, Tt, Zt), this.appendText(
      n,
      `⌀${this.formatValue(t.sleeveExternalDiameterLabel)}`,
      this.offset(I.scale(I.create(), I.add(I.create(), Wt, Zt), 0.5), a, s, r, 0, 1.1, -0.2),
      a,
      s,
      g
    ), t.showInnerDiameterDimension && l > Pr) {
      const Q = this.offset(x, a, s, r, -T, E, y), D = this.offset(x, a, s, r, T, E, y);
      this.appendDimension(e, Q, D, r, m, l);
      const q = this.offset(x, a, s, r, -T, 0, y), nt = this.offset(x, a, s, r, T, 0, y);
      this.appendConnector(e, q, Q), this.appendConnector(e, nt, D), this.appendText(
        n,
        `⌀${this.formatValue(t.sleeveInternalDiameterLabel)}`,
        this.offset(I.scale(I.create(), I.add(I.create(), Q, D), 0.5), a, s, r, 0, 0.7, -0.2),
        a,
        s,
        g
      );
    }
    if (t.showHexagonDimension) {
      const Q = this.offset(X, a, s, r, -f, 0.2 + Z * 0.35, y), D = this.offset(X, a, s, r, f, 0.2 + Z * 0.35, y);
      this.appendDimension(e, Q, D, r, m, o);
      const q = this.offset(V, a, s, r, -f, 0, y), nt = this.offset(V, a, s, r, f, 0, y);
      this.appendConnector(e, q, Q), this.appendConnector(e, nt, D), this.appendText(
        n,
        `⌀${this.formatValue(Math.abs(t.sleeveHexagonDiameterLabel))}`,
        this.offset(I.scale(I.create(), I.add(I.create(), Q, D), 0.5), a, s, r, 0, 1, -0.2),
        a,
        s,
        g
      );
    }
    if (u && d > Pr) {
      const Q = this.offset(x, a, s, r, j, 0, y), D = this.offset(x, a, s, r, j, -d, y);
      this.appendDimension(e, Q, D, r, m, d);
      const q = this.offset(x, a, s, r, -f, 0, y), nt = this.offset(x, a, s, r, -f, -d, y);
      this.appendConnector(e, q, Q), this.appendConnector(e, nt, D), this.appendText(
        n,
        this.formatValue(d),
        this.offset(I.scale(I.create(), I.add(I.create(), Q, D), 0.5), a, s, r, H, -0.35, -0.15),
        a,
        s,
        g
      );
    }
    if (h > Pr) {
      const Q = this.offset(x, a, s, r, R, 0, y), D = u ? this.offset(x, a, s, r, R, -h, y) : this.offset(V, a, s, r, R, 0, y);
      this.appendDimension(e, Q, D, r, m, h);
      const q = this.offset(x, a, s, r, f, 0, y), nt = u ? this.offset(x, a, s, r, f, -h, y) : this.offset(V, a, s, r, f, 0, y);
      this.appendConnector(e, q, Q), this.appendConnector(e, nt, D), this.appendText(
        n,
        this.formatValue(h),
        this.offset(I.scale(I.create(), I.add(I.create(), Q, D), 0.5), a, s, r, 1.2, 0, -0.15),
        a,
        s,
        g
      );
    }
    if (p > Pr) {
      const Q = this.offset(V, a, s, r, z, 0, y), D = this.offset(N, a, s, r, z, 0, y);
      this.appendDimension(e, Q, D, r, m, p);
      const q = this.offset(V, a, s, r, f, 0, y), nt = this.offset(N, a, s, r, Math.max(M, 0.2), 0, y);
      this.appendConnector(e, q, Q), this.appendConnector(e, nt, D), this.appendText(
        n,
        this.formatValue(p),
        this.offset(I.scale(I.create(), I.add(I.create(), Q, D), 0.5), a, s, r, 1.2, 0, -0.15),
        a,
        s,
        g
      );
    }
    this.dimLines.setSegments(e), this.dimTexts.setSegments(n);
  }
  addToView(t) {
    this.dimLines.addToView(t), this.dimTexts.addToView(t);
  }
  removeFromView(t) {
    this.dimLines.removeFromView(t), this.dimTexts.removeFromView(t);
  }
  delete() {
    this.dimLines.delete(), this.dimTexts.delete();
  }
  appendDimension(t, e, n, s, r, a) {
    const o = I.subtract(I.create(), n, e), l = I.length(o);
    if (l < Pr)
      return;
    I.scale(o, o, 1 / l);
    let c = I.cross(I.create(), s, o);
    I.length(c) < Pr && (c = I.cross(I.create(), o, [0, 0, 1])), I.length(c) < Pr && (c = I.fromValues(1, 0, 0)), I.normalize(c, c), t.push([I.clone(e), I.clone(n)]);
    const u = a <= tNt + Pr, d = u ? I.scale(I.create(), o, -1) : I.clone(o), h = u ? I.clone(o) : I.scale(I.create(), o, -1);
    this.appendArrow(t, e, d, c, r), this.appendArrow(t, n, h, c, r);
  }
  appendArrow(t, e, n, s, r) {
    const a = I.add(I.create(), e, I.add(I.create(), I.scale(I.create(), n, r), I.scale(I.create(), s, r * 0.45))), o = I.add(I.create(), e, I.add(I.create(), I.scale(I.create(), n, r), I.scale(I.create(), s, -r * 0.45)));
    t.push([I.clone(e), a]), t.push([I.clone(e), o]);
  }
  appendConnector(t, e, n) {
    t.push([I.clone(e), I.clone(n)]);
  }
  appendText(t, e, n, s, r, a) {
    const o = this.getGlyphSegments(e);
    if (o.length === 0)
      return;
    let l = Number.POSITIVE_INFINITY, c = Number.NEGATIVE_INFINITY;
    for (const [[d], [h]] of o)
      l = Math.min(l, d, h), c = Math.max(c, d, h);
    const u = -0.5 * (l + c);
    for (const [[d, h], [p, m]] of o) {
      const b = this.offset(n, s, r, null, (d + u) * a, h * a, 0), y = this.offset(n, s, r, null, (p + u) * a, m * a, 0);
      t.push([b, y]);
    }
  }
  getGlyphSegments(t) {
    const e = {
      a: [
        [0, 2],
        [1, 2]
      ],
      b: [
        [1, 2],
        [1, 1]
      ],
      c: [
        [1, 1],
        [1, 0]
      ],
      d: [
        [0, 0],
        [1, 0]
      ],
      e: [
        [0, 1],
        [0, 0]
      ],
      f: [
        [0, 2],
        [0, 1]
      ],
      g: [
        [0, 1],
        [1, 1]
      ]
    }, n = {
      0: ["a", "b", "c", "d", "e", "f"],
      1: ["b", "c"],
      2: ["a", "b", "g", "e", "d"],
      3: ["a", "b", "g", "c", "d"],
      4: ["f", "g", "b", "c"],
      5: ["a", "f", "g", "c", "d"],
      6: ["a", "f", "g", "e", "c", "d"],
      7: ["a", "b", "c"],
      8: ["a", "b", "c", "d", "e", "f", "g"],
      9: ["a", "b", "c", "d", "f", "g"],
      O: ["a", "b", "c", "d", "e", "f"],
      "-": ["g"],
      ".": [],
      " ": []
    }, s = [];
    let r = 0;
    const a = 1.45;
    for (const o of t) {
      if (o === "⌀" || o === "Ø" || o === "ø") {
        const c = [
          [
            [0.22, 1.78],
            [0.4, 1.93]
          ],
          [
            [0.4, 1.93],
            [0.66, 2]
          ],
          [
            [0.66, 2],
            [0.9, 1.9]
          ],
          [
            [0.9, 1.9],
            [1.08, 1.68]
          ],
          [
            [1.08, 1.68],
            [1.16, 1.37]
          ],
          [
            [1.16, 1.37],
            [1.13, 1.04]
          ],
          [
            [1.13, 1.04],
            [0.97, 0.8]
          ],
          [
            [0.97, 0.8],
            [0.73, 0.66]
          ],
          [
            [0.73, 0.66],
            [0.46, 0.67]
          ],
          [
            [0.46, 0.67],
            [0.25, 0.82]
          ],
          [
            [0.25, 0.82],
            [0.12, 1.07]
          ],
          [
            [0.12, 1.07],
            [0.1, 1.38]
          ],
          [
            [0.1, 1.38],
            [0.22, 1.78]
          ],
          [
            [0.05, 0.62],
            [1.18, 2.02]
          ]
        ], u = 0.615, d = 1.32, h = 0.5, p = 1, m = 0.9, b = 1.25;
        for (const [[y, Z], [g, f]] of c) {
          const T = (y - u) * m + h, M = (Z - d) * b + p, N = (g - u) * m + h, W = (f - d) * b + p;
          s.push([
            [r + T, M],
            [r + N, W]
          ]);
        }
        r += a;
        continue;
      }
      if (o === "/") {
        s.push([
          [r + 0.05, 0],
          [r + 1.05, 2]
        ]), r += a;
        continue;
      }
      if (o === ".") {
        s.push([
          [r + 0.5, 0],
          [r + 0.5, 0.18]
        ]), r += 0.8;
        continue;
      }
      const l = n[o] ?? [];
      for (const c of l) {
        const [[u, d], [h, p]] = e[c];
        s.push([
          [r + u, d],
          [r + h, p]
        ]);
      }
      r += a;
    }
    return s;
  }
  offset(t, e, n, s, r, a, o) {
    const l = I.clone(t);
    return I.scaleAndAdd(l, l, e, r), I.scaleAndAdd(l, l, n, a), s && I.scaleAndAdd(l, l, s, o), l;
  }
  formatValue(t) {
    return t.toFixed(2);
  }
  normalize(t) {
    const e = I.clone(t);
    return I.length(e) < Pr ? I.fromValues(0, 0, 1) : (I.normalize(e, e), e);
  }
  projectToAxis(t, e, n) {
    const s = I.subtract(I.create(), t, e), r = I.dot(s, n);
    return I.scaleAndAdd(I.create(), e, n, r);
  }
}
class h0 extends vn {
  constructor(e) {
    super(e);
    S(this, "type", Yt._IMPLANT);
    S(this, "subType", Yt._NONE);
    S(this, "tooth");
    S(this, "implantRotationRad", 0);
    //angle of implant rotation store in degrees: xml->SetData(tabString + "ROTATION", GetRotation());
    S(this, "prostheticRotation", 0);
    S(this, "topCenterLine");
    S(this, "bottomCenterLine");
    S(this, "centerLineViews", /* @__PURE__ */ new Set());
    S(this, "TOP_CENTER_LINE_RADIUS", 0.8);
    S(this, "BOTTOM_CENTER_LINE_RADIUS", 0.4);
    S(this, "CENTER_LINE_HEIGHT", 20);
    S(this, "BOTTOM_HANDLE_OFFSET", 5);
    S(this, "TOP_HANDLE_OFFSET", 5);
    S(this, "sleeveDimensionsPreview");
    S(this, "implant");
    S(this, "abutment");
    S(this, "scanAbutment");
    S(this, "secondaryAbutment");
    S(this, "secondaryScanAbutment");
    S(this, "sleeve");
    S(this, "implantExtrusion");
    // TODO mabe rename to Extrusion???
    S(this, "centerLinesEnabled");
    S(this, "object3dInfo");
    S(this, "reactivity", An());
    S(this, "oldSecurityZone", 0);
    S(this, "extrusionObjects", /* @__PURE__ */ new Map());
    S(this, "supportObjects", /* @__PURE__ */ new Map());
    S(this, "selectedForGuideDesign", !0);
    this.initialize(e);
    const { implant: n, centerLinesEnabled: s, tooth: r } = e;
    this.implant = n, this.centerLinesEnabled = s, this.tooth = r, this.update3dInfo(), this.updateCenterLines(), this.reactivity.onEvent(this.context.settings.onSettingsModified, () => {
      var u, d;
      (((u = this.bottomCenterLine) == null ? void 0 : u.getRadius()) != this.context.settings.general.bottomCenterlineSizeOn3dMm || ((d = this.topCenterLine) == null ? void 0 : d.getRadius()) != this.context.settings.general.topCenterlineSizeOn3dMm) && this.updatePosition();
    });
    const a = this.context.settings.implants.securityZoneSizeMm, o = this.getBounds(), l = o[5] - o[4], c = this.getImplantInfo().implantInfo;
    this.wasmStlObject ? this.wasmStlObject.ConstructImplantCollisionZone(l - c.implantConnectorHeight, a, c.diameter / 2 + a) : console.warn("iMPLANT - wasmStlObject does not exist --> Implant"), this.wasmCollisionZonePolydataReady = !0, this.oldSecurityZone = a, this.setLocked(!1);
  }
  static fromProjectImplant(e, n, s) {
    var p, m, b, y;
    const r = Lo(n.implantInfo.stlFile.data, "stl");
    let a;
    s != null && s.ignoreScaling ? a = n.origin : a = e.objects.scaleVectorFromImplantPlanner(n.origin);
    const o = r.getBounds(), l = I.fromValues((o[0] + o[1]) / 2, (o[2] + o[3]) / 2, (o[4] + o[5]) / 2), c = qG(a, n.normal, n.viewUp, l), u = new h0({
      stlData: n.implantInfo.stlFile.data,
      centerLinesEnabled: !(s != null && s.disableCenterLines),
      implant: n,
      context: e,
      polydata: r,
      matrix: c,
      tooth: parseInt(n.name),
      stlFilename: n.implantInfo.stlFile.fileName,
      plyFilename: "",
      oType: Pe.eOT_IP_IMPLANT
    });
    u.setName(n.name), (p = u.wasmStlObject) == null || p.SetImplantStandardInfoString(u.getStandardInfoString(!0)), (m = u.wasmStlObject) == null || m.SetSleeveConnectionSides(n.implantInfo.connectionSides ?? 0), u.setColor(Kn(n.color)), u.setVisibility(n.visible), u.opacity = n.opacity / 255, u.implantRotationRad = n.rotation * (Math.PI / 180), u.abutment = n.abutment && n.abutment.stlFile ? OC.fromProjectAbutment(e, u, n.abutment, n.abutmentColor) : void 0, u.scanAbutment = n.scanAbutment && n.scanAbutment.stlFile ? EC.fromProjectScanAbutment(e, u, n.scanAbutment, n.scanAbutmentColor) : void 0, u.secondaryAbutment = n.secondaryAbutment && n.secondaryAbutment.stlFile ? kC.fromProjectSecondaryAbutment(e, u, n.secondaryAbutment, n.secAbutmentColor) : void 0, u.secondaryScanAbutment = n.secondaryScanAbutment && n.secondaryScanAbutment.stlFile ? FC.fromProjectSecondaryScanAbutment(e, u, n.secondaryScanAbutment, n.secScanAbutmentColor) : void 0, u.sleeve = n.sleeveInfo ? lw.fromProjectSleeve(e, u, n.sleeveInfo) : void 0;
    const d = u.wasmStlObject;
    d && (d.SetAbutmentById(u.abutment ? u.abutment.id : "null"), d.SetScanAbutmentById(u.scanAbutment ? u.scanAbutment.id : "null"), d.SetSecondaryAbutmentById(u.secondaryAbutment ? u.secondaryAbutment.id : "null"), d.SetSecondaryScanAbutmentById(u.secondaryScanAbutment ? u.secondaryScanAbutment.id : "null"), d.SetSleeveById(u.sleeve ? u.sleeve.id : "null"));
    const h = u.implant.drillLengthMm;
    return h && h > 0 && ((b = u.sleeve) == null || b.setDrillLength(h)), u.implantExtrusion = n.implantModel ? n.implantModel : void 0, u.updatePosition(), e.layoutManager.isLayoutStlLibrary() && ((y = u.sleeve) == null || y.setDrillLengthAutomatically(!0), u.updatePosition()), u.sleeve && n.sleeveManuallyChanged !== void 0 && (u.sleeve.sleeveManuallyChanged = n.sleeveManuallyChanged ? 1 : 0), u;
  }
  updateCollisionZone() {
    if (this.oldSecurityZone != this.context.settings.implants.securityZoneSizeMm) {
      const e = this.context.settings.implants.securityZoneSizeMm, n = this.getBounds(), s = n[5] - n[4], r = this.getImplantInfo().implantInfo;
      console.log("iMPLANT - iParams", s - r.implantConnectorHeight, ", ", e, ", ", r.diameter / 2 + e), this.wasmStlObject ? this.wasmStlObject.UpdateImplantCollisionZone(s - r.implantConnectorHeight, e, r.diameter / 2 + e) : console.warn("iMPLANT - wasmStlObject does not exist --> Implant"), this.wasmCollisionZonePolydataReady = !0, this.oldSecurityZone = e, console.log("updateCollisionZone  Scene refresh with flat", this.replaceFlag), this.collZoneRepresentations2D.forEach((a) => {
        a.replaceActorById();
      }), this.context.sceneRepaint(void 0, (a, o) => {
        this.sendToParallelExecutor(a, !0), this.onViewWidgetEvent(a, o);
      });
    }
  }
  toProjectImplantParts() {
    var u, d, h, p;
    const e = this.getImplantInfo(), n = this.getAbutment();
    e.abutment = n == null ? void 0 : n.getAbutmentInfo(), e.scanAbutment = ((u = this.scanAbutment) == null ? void 0 : u.getAttachmentInfo()) ?? e.scanAbutment, e.secondaryAbutment = ((d = this.secondaryAbutment) == null ? void 0 : d.getAttachmentInfo()) ?? e.secondaryAbutment, e.secondaryScanAbutment = ((h = this.secondaryScanAbutment) == null ? void 0 : h.getAttachmentInfo()) ?? e.secondaryScanAbutment;
    const s = this.getSleeve();
    e.sleeveInfo = s == null ? void 0 : s.getSleeveInfo(), s && (e.sleeveManuallyChanged = s.sleeveManuallyChanged);
    const r = this.getMatrix(), a = I.clone(this.getCenter());
    I.transformMat4(a, a, r), e.origin = this.context.objects.scaleVectorToImplantPlanner(a), e.normal = this.getNormal(), e.viewUp = this.getTangent(), e.tangent = this.getBinormal(), e.rotation = this.implantRotationRad * (180 / Math.PI), e.color = Pa(this.getColor()), n && (e.abutmentColor = [...Pa(n.getColor()), n.getOpacity() * 255]), e.opacity = this.opacity * 255, e.visible = this.visibility, e.implantInfo.implantFileName = "tmp/" + e.implantInfo.guid, e.implantType = 0;
    const o = ((p = this.sleeve) == null ? void 0 : p.getDrillLength()) || 0, l = this.context.getImageData().getSpacing(), c = Math.min(...l);
    return e.drillLength = o / c, e.drillLengthMm = o, e;
  }
  onViewWidgetEvent(e, n) {
    var s, r, a, o, l;
    if (super.onViewWidgetEvent(e, n), (s = this.abutment) == null || s.onViewWidgetEvent(e, n), (r = this.sleeve) == null || r.onViewWidgetEvent(e, n), (a = this.scanAbutment) == null || a.onViewWidgetEvent(e, n), (o = this.secondaryAbutment) == null || o.onViewWidgetEvent(e, n), (l = this.secondaryScanAbutment) == null || l.onViewWidgetEvent(e, n), this.context.toolManager.implantPinTool && this.context.toolManager.implantPinTool.onViewWidgetEvent(e, n), e.getViewMode() === Nt._STL_3D_PREVIEW) {
      this.updateSleeveDimensionsPreview(e, n), this.resetStlPreviewCamera(e);
      return;
    }
    if (e.isViewMode3D())
      switch (n) {
        case me.eVE_SHOW:
        case me.eVE_RENDER:
          this.centerLinesEnabled && this.renderCenterLines(e);
          break;
        case me.eVE_HIDE:
        case me.eVE_DESTROY:
          this.removeCenterLinesFromView(e);
          break;
      }
  }
  sendToParallelExecutor(e, n) {
    var s, r, a, o, l;
    super.sendToParallelExecutor(e, n), (s = this.abutment) == null || s.sendToParallelExecutor(e, n), (r = this.sleeve) == null || r.sendToParallelExecutor(e, n), (a = this.scanAbutment) == null || a.sendToParallelExecutor(e, n), (o = this.secondaryAbutment) == null || o.sendToParallelExecutor(e, n), (l = this.secondaryScanAbutment) == null || l.sendToParallelExecutor(e, n);
  }
  updateDisplayedColor() {
    var n, s;
    super.updateDisplayedColor();
    const e = this.getDisplayedColor();
    (n = this.topCenterLine) == null || n.getActor().getProperty().setColor(e), (s = this.bottomCenterLine) == null || s.getActor().getProperty().setColor(e);
  }
  getTooth() {
    return this.tooth;
  }
  getImplantInfo() {
    return this.implant;
  }
  getProjectImplantInfo() {
    return this.implant.implantInfo;
  }
  getAbutment() {
    return this.abutment;
  }
  /** Get scan abutment attachment. */
  getScanAbutment() {
    return this.scanAbutment;
  }
  /** Set scan abutment attachment. */
  setScanAbutment(e) {
    var n;
    this.scanAbutment = e, this.implant.scanAbutment = e == null ? void 0 : e.getAttachmentInfo(), (n = this.wasmStlObject) == null || n.SetScanAbutmentById(e ? e.id : "null");
  }
  /** Get secondary abutment attachment. */
  getSecondaryAbutment() {
    return this.secondaryAbutment;
  }
  /** Set secondary abutment attachment. */
  setSecondaryAbutment(e) {
    var n;
    this.secondaryAbutment = e, this.implant.secondaryAbutment = e == null ? void 0 : e.getAttachmentInfo(), (n = this.wasmStlObject) == null || n.SetSecondaryAbutmentById(e ? e.id : "null");
  }
  /** Get secondary scan abutment attachment. */
  getSecondaryScanAbutment() {
    return this.secondaryScanAbutment;
  }
  /** Set secondary scan abutment attachment. */
  setSecondaryScanAbutment(e) {
    var n;
    this.secondaryScanAbutment = e, this.implant.secondaryScanAbutment = e == null ? void 0 : e.getAttachmentInfo(), (n = this.wasmStlObject) == null || n.SetSecondaryScanAbutmentById(e ? e.id : "null");
  }
  /** Get analog extrusion object. */
  getAnalogExtrusion() {
    return this.implantExtrusion;
  }
  setAbutment(e) {
    var n;
    this.abutment = e, (n = this.wasmStlObject) == null || n.SetAbutmentById(e ? e.id : "null");
  }
  getSleeve() {
    return this.sleeve;
  }
  setSleeve(e) {
    var n;
    this.sleeve = e, (n = this.wasmStlObject) == null || n.SetSleeveById(e ? e.id : "null");
  }
  objectBelongsToImplant(e) {
    return e === this || e === this.abutment || e === this.scanAbutment || e === this.secondaryAbutment || e === this.secondaryScanAbutment || e === this.sleeve;
  }
  getCenterLine(e = !1) {
    return e ? this.topCenterLine : this.bottomCenterLine;
  }
  moveTo(e) {
    super.moveTo(e), this.context.layoutManager.isLayoutStlLibrary() && this.sleeve && (this.sleeve.restoreDrillLength(), this.sleeve.setDrillLengthAutomatically(!0), this.updatePosition(!0)), this.updatePosition();
  }
  // move in STLPicker preview
  moveInTangentDirection(e) {
    var r, a, o, l;
    const n = (r = this.context.getViewWidget(Nt.CROSS)) == null ? void 0 : r.getNormal(), s = I.create();
    n && (I.scaleAndAdd(s, this.getPosition(), n, e), this.moveTo(s)), this.context.getObjects().snapToObject(this.id), (a = this.context.getViewWidget(Nt._STL_3D_PREVIEW)) != null && a.isVisible() && ((o = this.context.getViewWidget(Nt.CROSS)) == null || o.panToPosition3D(this.getPosition()), (l = this.context.getViewWidget(Nt.TANGENT)) == null || l.panToPosition3D(this.getPosition()));
  }
  setVisibility(e, n) {
    var s, r, a, o, l;
    super.setVisibility(e), (s = this.abutment) == null || s.setVisibility(e), (r = this.sleeve) == null || r.setVisibility(e), (a = this.scanAbutment) == null || a.setVisibility(e), (o = this.secondaryAbutment) == null || o.setVisibility(e), (l = this.secondaryScanAbutment) == null || l.setVisibility(e), this.updatePosition(n);
  }
  rotateImplant(e, n, s, r, a) {
    this.rotateImplantPin(e, n, s, r, a), this.updatePosition();
  }
  rotateImplantFi(e, n, s) {
    this.rotateImplantPinFi(e, n, s), this.updatePosition(), this.context.getObjects().checkCollisions(this);
  }
  renderCenterLines(e) {
    if (!this.topCenterLine || !this.bottomCenterLine)
      return;
    const n = this.topCenterLine.getActor(), s = this.bottomCenterLine.getActor();
    n.setVisibility(this.visibility), s.setVisibility(this.visibility), n.getProperty().setColor(this.getDisplayedColor()), s.getProperty().setColor(this.getDisplayedColor()), e.addActor(n), e.addActor(s), this.centerLineViews.add(e);
  }
  removeCenterLinesFromView(e) {
    !this.topCenterLine || !this.bottomCenterLine || (e.removeActor(this.topCenterLine.getActor()), e.removeActor(this.bottomCenterLine.getActor()), this.centerLineViews.delete(e));
  }
  updateSleeveDimensionsPreview(e, n) {
    var X, C, R;
    if (n === me.eVE_HIDE || n === me.eVE_DESTROY) {
      (X = this.sleeveDimensionsPreview) == null || X.removeFromView(e);
      return;
    }
    if (n !== me.eVE_SHOW && n !== me.eVE_RENDER)
      return;
    const s = this.context.objects.selectedObject.get(), r = s instanceof h0 ? s : null;
    if (!r || r.id !== this.id) {
      (C = this.sleeveDimensionsPreview) == null || C.removeFromView(e);
      return;
    }
    if (!this.sleeve || !this.visibility || !this.sleeve.getVisibility()) {
      (R = this.sleeveDimensionsPreview) == null || R.removeFromView(e);
      return;
    }
    this.sleeveDimensionsPreview || (this.sleeveDimensionsPreview = new eNt());
    const a = this.sleeve.getSleeveInfo(), o = !!(a.stlData || a.stlFileGuid && a.stlFileGuid.length > 0), l = this.sleeve.sleeveExtRadius > 0 ? this.sleeve.sleeveExtRadius * 2 : a.dExternal, c = this.sleeve.sleeveIntRadius > 0 ? this.sleeve.sleeveIntRadius * 2 : a.dInternal, u = (z) => Number.isFinite(z) && z !== 0, d = o && u(a.dExternal) ? a.dExternal : l, h = o && u(a.dInternal) ? a.dInternal : c, p = Math.abs(u(a.dHexagon) ? a.dHexagon : l), m = this.getProjectImplantInfo().diameter > 0 ? this.getProjectImplantInfo().diameter : l, b = o ? 0 : a.lLip || 0, y = this.sleeve.sleeveLength > 0 ? this.sleeve.sleeveLength : a.lSleeve, Z = this.sleeve.getDistanceFromImplant(), g = this.sleeve.getOverallLength(), f = this.sleeve.getTop(0, !0), T = this.sleeve.getBottom(0, !0), M = this.getTop(0, !0), N = this.getBottom(0, !0), W = this.getNormal(), x = this.getBinormal(), V = I.scale(I.create(), this.getTangent(), -1);
    this.sleeveDimensionsPreview.update({
      topSleeve: f,
      bottomSleeve: T,
      topImplant: M,
      bottomImplant: N,
      axis: W,
      right: x,
      front: V,
      sleeveDiameter: l,
      sleeveInnerDiameter: c,
      sleeveExternalDiameterLabel: d,
      sleeveInternalDiameterLabel: h,
      sleeveHexagonDiameterLabel: p,
      showInnerDiameterDimension: !0,
      showHexagonDimension: !o && b > 0,
      implantDiameter: m,
      lipHeight: b,
      showLipDimension: !o,
      sleeveHeight: y,
      distanceHeight: Z,
      totalHeight: g
    }), this.sleeveDimensionsPreview.addToView(e);
  }
  updateCenterLines() {
    const e = this.getBounds(), n = e[5] - e[4];
    this.topCenterLine || (this.topCenterLine = new xz());
    const s = I.create(), r = I.create();
    this.getAbutmentPoints(s, r, this.CENTER_LINE_HEIGHT), this.topCenterLine.setData({
      points: [s, r],
      radius: this.context.settings.general.topCenterlineSizeOn3dMm,
      color: this.getDisplayedColor()
    }), this.bottomCenterLine || (this.bottomCenterLine = new xz()), this.bottomCenterLine.setData({
      points: [this.getBottom(), this.getBottom(n)],
      radius: this.context.settings.general.bottomCenterlineSizeOn3dMm,
      color: this.getDisplayedColor()
    });
  }
  update3dInfo() {
    var p, m, b;
    const e = this.getBounds(), n = e[5] - e[4];
    let s = ((p = this.sleeve) == null ? void 0 : p.getSleeveInfo().distanceFromImplant) || 0, r = !1;
    this.abutment && (r = this.abutment.getVisibility() || !1, r && (s = -(((m = this.abutment) == null ? void 0 : m.getBounds()[4]) || 0) - (((b = this.implant.implantInfo) == null ? void 0 : b.implantConnectorHeight) || 0) - (this.abutment.getAbutmentInfo().connectorHeight || 0)));
    const a = I.create(), o = I.create();
    this.getAbutmentPoints(a, o, this.CENTER_LINE_HEIGHT);
    const l = I.create(), c = I.create();
    this.getAbutmentPoints(l, c, s + this.TOP_HANDLE_OFFSET);
    const u = this.getBottom(this.BOTTOM_HANDLE_OFFSET), d = [a, o], h = [this.getBottom(), this.getBottom(n)];
    this.object3dInfo = {
      id: this.id,
      name: this.getImplantDisplayName(),
      visible: this.visibility,
      position: this.getPosition(),
      handleTop: c,
      handleBottom: u,
      centerlineTop: [d[0], d[1]],
      centerlineBottom: [h[0], h[1]],
      color: Pa(this.getColor()),
      type: Yt._IMPLANT
    }, this.context.objects.object3DInfos.update((y) => {
      const Z = y.findIndex((g) => g.id === this.id);
      return Z !== -1 ? y[Z] = this.object3dInfo : y.push(this.object3dInfo), y;
    });
  }
  getImplantDisplayName() {
    return "Implant " + this.implant.name;
  }
  setTooth(e) {
    this.tooth = Number(e), this.setName(e), this.implant.name = e, this.update3dInfo();
  }
  setAxisParallelTo(e) {
    const n = this.getMatrix();
    for (let s = 0; s < 12; s++)
      n[s] = e[s];
    this.setMatrix(n), this.updatePosition();
  }
  updateHandles() {
    this.update3dInfo();
  }
  updatePosition(e) {
    const n = this.getMatrix();
    if (this.abutment) {
      const s = this.abutment.calculateRelativePosition();
      ut.mul(s, n, s), this.abutment.setMatrix(s);
    }
    if (this.scanAbutment) {
      const s = this.scanAbutment.calculateRelativePosition();
      ut.mul(s, n, s), this.scanAbutment.setMatrix(s);
    }
    if (this.secondaryAbutment) {
      const s = this.secondaryAbutment.calculateRelativePosition();
      ut.mul(s, n, s), this.secondaryAbutment.setMatrix(s);
    }
    if (this.secondaryScanAbutment) {
      const s = this.secondaryScanAbutment.calculateRelativePosition();
      ut.mul(s, n, s), this.secondaryScanAbutment.setMatrix(s);
    }
    if (this.sleeve) {
      const s = this.sleeve.calculateRelativePosition();
      ut.mul(s, n, s), this.sleeve.setMatrix(s);
    }
    this.update3dInfo(), this.updateCenterLines(), this.context.sceneRepaint(
      void 0,
      (s, r) => {
        this.sendToParallelExecutor(s, !0), this.onViewWidgetEvent(s, r);
      },
      e
    );
  }
  getTopOfImplantPoint() {
    const e = I.fromValues(0, 0, 0), n = this.getBounds();
    return e[0] = (n[0] + n[1]) / 2, e[1] = (n[2] + n[3]) / 2, e[2] = n[5], I.transformMat4(e, e, this.getMatrix()), e;
  }
  /**
  from =  top of implant or abutment, top = position of angled abutment point
  /param ignoreAbutment using for origin of rotation \sa GetRotateOrigin
  **/
  getAbutmentPoints(e, n, s, r) {
    const a = I.create(), o = I.fromValues(0, 0, -1);
    let l = 0;
    this.abutment && this.abutment.getVisibility() && (l = xW(this.abutment.getAbutmentInfo().angle));
    const c = this.getBounds();
    a[0] = (c[0] + c[1]) / 2, a[1] = (c[2] + c[3]) / 2;
    const u = this.implant.implantInfo.implantConnectorHeight;
    if (r)
      a[2] = c[5];
    else if (this.abutment && this.abutment.getVisibility()) {
      const b = -this.abutment.getBounds()[4], y = this.abutment.getAbutmentInfo().connectorHeight;
      a[2] = c[5] + (b - u) - y;
    } else
      a[2] = 2 * c[5] - u;
    o[0] = a[0] + s * Math.sin(l), o[1] = a[1], o[2] = a[2] + s * Math.cos(l);
    const d = I.fromValues(0, 0, 0), h = I.fromValues(0, 0, 1), p = this.abutment ? this.abutment.getAbutmentInfo().rotationZ : 0;
    gbt(o, xW(360 - p - 90), h, d, o), I.transformMat4(e, a, this.getMatrix()), I.transformMat4(n, o, this.getMatrix());
  }
  /*get the prosthetic axis*/
  GetProstheticAxis() {
    const e = I.fromValues(0, 0, 0), n = I.create(), s = I.create();
    this.getAbutmentPoints(n, s, this.CENTER_LINE_HEIGHT);
    for (let r = 0; r < 3; r++) e[r] = s[r] - n[r];
    return I.length(e) > Number.EPSILON && I.normalize(e, e), e;
  }
  /**get degrees*/
  GetRotation(e = !1) {
    return e ? this.prostheticRotation * 180 / Math.PI : this.implantRotationRad * 180 / Math.PI;
  }
  /**rotate implant around rot_axis */
  RotateAroundAxis(e, n) {
    const s = ut.create();
    ut.fromRotation(s, e, n);
    const r = this.getMatrix(), a = I.create();
    for (let o = 0; o < 3; o++)
      a[o] = r[12 + o], r[12 + o] = 0;
    ut.mul(r, s, r);
    for (let o = 0; o < 3; o++) r[12 + o] = a[o];
    this.setMatrix(r), this.updatePosition();
  }
  /** Set rotation from GUI, angle in rad*/
  SetRotation(e, n = !1) {
    let s, r;
    n ? (s = this.GetProstheticAxis(), r = e - this.prostheticRotation, this.prostheticRotation = e) : (s = this.getNormal(), r = e - this.implantRotationRad, this.implantRotationRad = e), this.RotateAroundAxis(r, s);
  }
  collisionDetection(e) {
    let n = super.collisionDetection(e);
    if (e.isImplant()) {
      const s = this.getSleeve(), r = e.getSleeve();
      if (s && r) {
        const a = s.collisionDetection(r);
        n = n || a;
      }
    }
    return n;
  }
  anatomyCollisionDetection(e) {
    const n = this.getSleeve();
    return n ? n.collisionDetection(e) : !1;
  }
  isInCollision() {
    return this.collisions.anatomyCollision || this.collisions.implantCollision || this.collisions.securityZoneCollision || this.collisions.nerveCollision || this.collisions.sleeveCollision;
  }
  isSleeveChanged() {
    var e;
    return this.collisions.sleeveChanged != null || ((e = this.sleeve) == null ? void 0 : e.sleeveManuallyChanged);
  }
  addExtrusionObject(e) {
    e.setToothSelected(this.selectedForGuideDesign), this.extrusionObjects.set(e.id, e);
  }
  removeFromExtrusionObjects(e) {
    this.extrusionObjects.delete(e);
  }
  getExtrusionObjects() {
    return this.extrusionObjects;
  }
  addSupportObject(e) {
    e.setToothSelected(this.selectedForGuideDesign), this.supportObjects.set(e.id, e);
  }
  removeFromSupportObjects(e) {
    this.supportObjects.delete(e);
  }
  getSupportObjects() {
    return this.supportObjects;
  }
  deleteSupportObjects(e) {
    this.supportObjects.forEach((n) => {
      n.delete(e);
    }), this.supportObjects.clear();
  }
  getStandardInfoString(e) {
    var s;
    let n;
    return (s = this.stlFilename) != null && s.length ? n = (e ? "" : this.getName() + " : ") + "⌀" + this.getImplantInfo().implantInfo.implantOriginalName : n = (e ? "" : this.getName() + " : ") + "⌀" + this.getImplantInfo().implantInfo.diameter + " x " + this.getImplantInfo().implantInfo.length, n;
  }
  isImplant() {
    return !0;
  }
  setGuideOrigin(e) {
    var n;
    (n = this.wasmStlObject) == null || n.SetGuideTop(e);
  }
  setGuideDirection(e) {
    var n;
    (n = this.wasmStlObject) == null || n.SetGuideDirection(e);
  }
  setGuideBiDirection(e) {
    var n;
    (n = this.wasmStlObject) == null || n.SetGuideBiDirection(e);
  }
  setGuideDiameter(e) {
    var n;
    (n = this.wasmStlObject) == null || n.SetGuideDiameter(e);
  }
  setGuideHeight(e) {
    var n;
    (n = this.wasmStlObject) == null || n.SetGuideHeight(e);
  }
  setGuidePin(e) {
    var n;
    (n = this.wasmStlObject) == null || n.SetGuidePin(e);
  }
  toggleSelectedForGuideDesign(e) {
    var n;
    this.selectedForGuideDesign = e ?? !this.selectedForGuideDesign, (n = this.wasmStlObject) == null || n.SetToothSelected(this.selectedForGuideDesign), this.supportObjects.forEach((s) => {
      s.setToothSelected(this.selectedForGuideDesign);
    });
  }
  async loadExtrusionParts() {
    this.implantExtrusion ? this.implantExtrusion.stlData && this.implantExtrusion.stlData.data.length > 0 ? (console.log("Loading extrusions from stl"), await Wb.constructExtrusionObject(this.context, this, this.implantExtrusion, 4, 0.2)) : (console.log("Loading extrusions from parameters"), await Wb.constructExtrusionObject(this.context, this, this.implantExtrusion, 2, 0.2), await Wb.constructExtrusionObject(this.context, this, this.implantExtrusion, 3, 0.2), await Wb.constructExtrusionObject(this.context, this, this.implantExtrusion, 4, 0.2)) : console.error("No extrusion data");
  }
  deleteExtrusionParts() {
    this.extrusionObjects.forEach((e) => {
      e.delete();
    }), this.extrusionObjects.clear();
  }
  delete(e) {
    var n, s, r, a, o, l, c, u;
    for (const d of [...this.centerLineViews])
      this.removeCenterLinesFromView(d);
    this.centerLineViews.clear(), (n = this.topCenterLine) == null || n.delete(), (s = this.bottomCenterLine) == null || s.delete(), e || this.removeFromObject3dInfos(), (r = this.abutment) == null || r.delete(e), (a = this.scanAbutment) == null || a.delete(e), (o = this.secondaryAbutment) == null || o.delete(e), (l = this.secondaryScanAbutment) == null || l.delete(e), (c = this.sleeve) == null || c.delete(e), (u = this.sleeveDimensionsPreview) == null || u.delete(), this.sleeveDimensionsPreview = void 0, this.deleteSupportObjects(e), this.deleteExtrusionParts(), this.reactivity.cleanupAll(), super.delete(e);
  }
}
class jC extends vn {
  constructor(e) {
    super(e);
    S(this, "type", Yt._PIN);
    S(this, "subType", Yt._NONE);
    S(this, "projectPin");
    S(this, "sleeve");
    S(this, "object3dInfo");
    S(this, "BOTTOM_HANDLE_OFFSET", 5);
    S(this, "TOP_HANDLE_OFFSET", 5);
    S(this, "extrusionObjects", /* @__PURE__ */ new Map());
    S(this, "supportObjects", /* @__PURE__ */ new Map());
    S(this, "selectedForGuideDesign", !0);
    this.initialize(e);
    const { projectPin: n } = e;
    this.projectPin = n, this.setLocked(!1);
  }
  static fromProjectPin(e, n, s) {
    const r = Lo(n.pinInfo.stlFile.data, "stl");
    let a;
    s != null && s.ignoreScaling ? a = n.origin : a = e.objects.scaleVectorFromImplantPlanner(n.origin);
    const o = r.getBounds(), l = I.fromValues((o[0] + o[1]) / 2, (o[2] + o[3]) / 2, (o[4] + o[5]) / 2), c = qG(a, n.normal, n.viewUp, l), u = new jC({
      stlData: n.pinInfo.stlFile.data,
      projectPin: n,
      context: e,
      polydata: r,
      matrix: c,
      stlFilename: n.pinInfo.stlFile.fileName,
      plyFilename: "",
      oType: Pe.eOT_IP_PIN
    });
    return u.setName(n.name), u.setColor(Kn(OMt(parseInt(n.pinInfo.color)))), u.setVisibility(n.visible), u.opacity = n.opacity, u.locked = !0, u.updatePosition(), n.sleeveInfo && u.replaceSleeve(n.sleeveInfo), u;
  }
  toProjectPin() {
    const e = this.getSleeve(), n = e == null ? void 0 : e.getSleeveInfo(), s = this.projectPin;
    return s.origin = this.context.objects.scaleVectorToImplantPlanner(this.getPosition()), s.normal = this.getNormal(), s.viewUp = this.getTangent(), s.tangent = this.getBinormal(), s.name = this.name, s.displayText = this.displayText, s.color = Pa(this.getColor()), s.opacity = this.getOpacity(), s.visible = this.getVisibility(), s.pinInfo.filename = "tmp/" + s.pinInfo.guid, {
      pin: s,
      sleeve: n
    };
  }
  onViewWidgetEvent(e, n) {
    var s;
    super.onViewWidgetEvent(e, n), (s = this.sleeve) == null || s.onViewWidgetEvent(e, n);
  }
  sendToParallelExecutor(e, n) {
    var s;
    super.sendToParallelExecutor(e, n), (s = this.sleeve) == null || s.sendToParallelExecutor(e, n);
  }
  delete(e) {
    var n;
    (n = this.getSleeve()) == null || n.delete(e), this.deleteSupportObjects(e), e || this.removeFromObject3dInfos(), super.delete(e);
  }
  getPinIndex() {
    return parseInt(this.name);
  }
  moveTo(e) {
    super.moveTo(e), this.updatePosition();
  }
  rotatePin(e, n, s, r, a) {
    this.rotateImplantPin(e, n, s, r, a), this.updatePosition();
  }
  rotatePinFi(e, n, s) {
    this.rotateImplantPinFi(e, n, s), this.updatePosition(), this.context.getObjects().checkCollisions(this);
  }
  update3dInfo() {
    this.object3dInfo = {
      id: this.id,
      name: this.name,
      visible: this.visibility,
      position: this.getPosition(),
      handleTop: this.getTop(this.TOP_HANDLE_OFFSET),
      handleBottom: this.getBottom(this.BOTTOM_HANDLE_OFFSET),
      centerlineTop: null,
      centerlineBottom: null,
      color: Pa(this.getColor()),
      type: Yt._PIN
    }, this.context.objects.object3DInfos.update((e) => {
      const n = e.findIndex((s) => s.id === this.id);
      return n !== -1 ? e[n] = this.object3dInfo : e.push(this.object3dInfo), e;
    });
  }
  setVisibility(e, n) {
    var s;
    super.setVisibility(e, n), (s = this.sleeve) == null || s.setVisibility(e, n), this.updatePosition(n);
  }
  updatePosition(e) {
    const n = this.getMatrix();
    if (this.sleeve) {
      const s = this.sleeve.calculateRelativePosition();
      ut.mul(s, n, s), this.sleeve.setMatrix(s);
    }
    this.update3dInfo(), this.context.sceneRepaint(void 0, (s, r) => {
      this.sendToParallelExecutor(s, !0), this.onViewWidgetEvent(s, r);
    });
  }
  getSleeve() {
    return this.sleeve;
  }
  replaceSleeve(e) {
    this.sleeve && this.sleeve.delete(), this.sleeve = lw.fromProjectSleeve(this.context, this, e), this.wasmStlObject && this.wasmStlObject.SetSleeveById(this.sleeve.id), this.updatePosition(), this.context.sceneRepaint(void 0, (n, s) => {
      this.sendToParallelExecutor(n, !0), this.onViewWidgetEvent(n, s);
    });
  }
  setGuideOrigin(e) {
    var n;
    (n = this.wasmStlObject) == null || n.SetGuideTop(e);
  }
  setGuideDirection(e) {
    var n;
    (n = this.wasmStlObject) == null || n.SetGuideDirection(e);
  }
  setGuideBiDirection(e) {
    var n;
    (n = this.wasmStlObject) == null || n.SetGuideBiDirection(e);
  }
  setGuideDiameter(e) {
    var n;
    (n = this.wasmStlObject) == null || n.SetGuideDiameter(e);
  }
  setGuideHeight(e) {
    var n;
    (n = this.wasmStlObject) == null || n.SetGuideHeight(e);
  }
  setGuidePin(e) {
    var n;
    (n = this.wasmStlObject) == null || n.SetGuidePin(e);
  }
  addExtrusionObject(e) {
    e.setToothSelected(this.selectedForGuideDesign), this.extrusionObjects.set(e.id, e);
  }
  removeFromExtrusionObjects(e) {
    this.extrusionObjects.delete(e);
  }
  addSupportObject(e) {
    e.setToothSelected(this.selectedForGuideDesign), this.supportObjects.set(e.id, e);
  }
  removeFromSupportObjects(e) {
    this.supportObjects.delete(e);
  }
  getProjectImplantInfo() {
    var e;
    (e = this.sleeve) == null || e.getSleeveInfo();
  }
  getProjectPinInfo() {
    return this.projectPin.pinInfo;
  }
  getSupportObjects() {
    return this.supportObjects;
  }
  deleteSupportObjects(e) {
    this.supportObjects.forEach((n) => {
      n.delete(e);
    }), this.supportObjects.clear();
  }
  toggleSelectedForGuideDesign(e) {
    var n;
    this.selectedForGuideDesign = e ?? !this.selectedForGuideDesign, (n = this.wasmStlObject) == null || n.SetToothSelected(this.selectedForGuideDesign), this.supportObjects.forEach((s) => {
      s.setToothSelected(this.selectedForGuideDesign);
    });
  }
  collisionDetection(e) {
    let n = super.collisionDetection(e);
    if (e.isImplant()) {
      const s = this.getSleeve(), r = e.getSleeve();
      if (s && r) {
        const a = s.collisionDetection(r);
        n = n || a;
      }
    }
    return n;
  }
  anatomyCollisionDetection(e) {
    const n = this.getSleeve();
    return n ? n.collisionDetection(e) : !1;
  }
}
class cA extends ow {
  constructor(e) {
    super();
    S(this, "type", Yt._STL_OBJECT);
    S(this, "subType", Yt._STL_OBJECT);
    S(this, "context");
    S(this, "polydata");
    S(this, "matrix", ut.create());
    S(this, "startUM", ut.create());
    S(this, "representation", Vn.SURFACE);
    S(this, "mShowThickness", !1);
    S(this, "mpReferenceObject", null);
    S(this, "mMaxRange", 2);
    S(this, "projectStl");
    this.isVolume = !0, this.context = e.context, this.polydata = Ie.newInstance();
    const n = this.context.getEngine(), s = new n.xWasmVolumeObject(this.id, e.objectType ?? Pe.eOT_UNKNOWN, this.type, this.subType);
    e.fPath != "" && (s.SetImageDataFromFile(e.fPath), Cr(s, this.polydata, !0)), (e.objectType == Pe.eOT_SEGMENTED_BONE || e.objectType == Pe.eOT_SEGMENTED_TOOTH || e.objectType == Pe.eOT_CNN_SEGMENTED_TOOTH) && s.SetEnableVolumeMask(!1), e.objectType && (this.cadType = e.objectType), this.setName(e.name), this.setDisplayText(e.name), this.setColor(this.getColor()), this.setVisibility(this.getVisibility(), !0), this.wasmVolumeObject = s;
  }
  syncWasmInfo() {
    if (!this.wasmVolumeObject) return;
    const e = ge(this.wasmVolumeObject);
    this.cadType = e.GetTypeInt(), this.setName(e.GetNameString()), this.setDisplayText(e.GetDisplayTextString()), this.setVisibility(e.GetVisibility()), this.setOpacity(e.GetOpacity());
    const n = e.GetColor();
    this.setColor([n[0], n[1], n[2]]), Cr(e, this.polydata, !0, !0);
    const s = sL(e), r = ut.fromValues(s[0], s[4], s[8], s[12], s[1], s[5], s[9], s[13], s[2], s[6], s[10], s[14], s[3], s[7], s[11], s[15]);
    this.setMatrix(r), this.polydata.modified(), this.update3dInfo();
  }
  toProjectStlObject() {
    const e = I.clone(this.getCenter()), n = ut.clone(this.getMatrix());
    I.transformMat4(e, e, n);
    const s = this.context.objects.scaleVectorToImplantPlanner(e), r = this.context.getEngine(), a = new r.xFileUtilsWasm();
    let o = new Int8Array(0);
    return a.GetSTLBufferForSaveByObjectId(this.id, this.isPly, this.name) && (o = a.GetBuffer().slice()), a.delete(), this.projectStl || (this.projectStl = UT(), console.warn("Project stl not defined for object: " + this.name + " !!!!")), this.projectStl.implantInfo.stlFile.data = o, this.projectStl.color = Pa(this.color), this.projectStl.opacity = this.opacity * 255, this.projectStl.displayText = this.displayText, this.projectStl.name = this.name, this.projectStl.viewUp = [n[0], n[1], n[2]], this.projectStl.tangent = [n[4], n[5], n[6]], this.projectStl.normal = [n[8], n[9], n[10]], this.projectStl.origin = s, this.projectStl.objectSubType = this.subType, this.projectStl.objectType = this.type, this.projectStl.visible = this.getVisibility(), this.projectStl.objectNote = this.objectNote, this.projectStl;
  }
  onViewWidgetEvent(e, n) {
    if (e.isViewMode3D() && e.getViewMode() !== Nt._STL_3D_PREVIEW) {
      const s = this.actors.get(ge(e));
      switch (n) {
        case me.eVE_SHOW:
        case me.eVE_RENDER:
          s ? s.getProperty().setRepresentation(this.representation) : this.create3dActor(e);
          break;
        case me.eVE_HIDE:
          break;
        case me.eVE_DESTROY:
          this.delete3dActor(e);
          break;
      }
    } else {
      let s = this.representations2D.get(e.id);
      switch (n) {
        case me.eVE_SHOW:
        case me.eVE_RENDER:
          s || (s = new jh(this.context, ge(e), this.polydata, this, !1, !0), this.representations2D.set(e.id, s)), s.setColor(this.getDisplayedColor()), s.setActorMatrix(this.matrix), s.setVisibility(this.visibility), s.onViewWidgetEvent(ge(e), n);
          break;
        case me.eVE_HIDE:
          break;
        case me.eVE_DESTROY:
          s == null || s.onViewWidgetEvent(ge(e), n), s == null || s.delete(), this.representations2D.delete(e.id);
          break;
      }
    }
  }
  sendToParallelExecutor(e, n) {
    let s = this.representations2D.get(e.id);
    if (s || (s = new jh(this.context, ge(e), this.polydata, this, !1, !0), this.representations2D.set(e.id, s)), s.sendToParallelExecutor(e), n) {
      const r = this.context.getWasmDocumentInstance();
      r && r.WaitForParallelExecutor();
    }
  }
  updateDisplayedColor() {
    const e = this.getDisplayedColor();
    for (const n of this.actors.values())
      n.getProperty().setColor(e);
    this.representations2D.forEach((n) => {
      n.setColor(e);
    }), this.update3dInfo();
  }
  setColor(e) {
    this.color = e, this.wasmVolumeObject && ge(this.wasmVolumeObject).SetColor(e[0], e[1], e[2], 1), this.colorOverride || this.updateDisplayedColor();
  }
  setColorOverride(e) {
    e === null && this.colorOverride === null || e !== this.colorOverride && (super.setColorOverride(e), this.updateDisplayedColor());
  }
  setLocked(e) {
    this.locked = e;
  }
  setOpacity(e) {
    this.opacity = e;
    for (const n of this.actors.values())
      n.getProperty().setOpacity(e);
    this.context.repaint();
  }
  setPickable(e) {
    this.pickable = e;
    for (const n of this.actors.values())
      n.setPickable(e);
  }
  toggleRepresentationWireframe() {
    this.representation == Vn.SURFACE ? this.representation = Vn.WIREFRAME : this.representation == Vn.WIREFRAME && (this.representation = Vn.SURFACE), this.context.sceneRepaint();
  }
  setVisibility(e, n) {
    this.visibility = e, this.wasmVolumeObject && ge(this.wasmVolumeObject).SetVisibility(e);
    for (const s of this.actors.values())
      s.setVisibility(e);
    this.representations2D.forEach((s) => {
      s.setVisibility(e);
    }), this.update3dInfo(), this.updateCrosssections(n);
  }
  removeFromObject3dInfos() {
    this.context.objects.object3DInfos.update((e) => {
      const n = e.findIndex((s) => s.id === this.id);
      return n !== -1 && e.splice(n, 1), e;
    });
  }
  delete(e) {
    var n;
    console.log("Deleting Volume", this.id), (n = super.delete) == null || n.call(this, e);
    for (const [s, r] of this.actors)
      s.removeActor(r), r.delete();
    for (const s of this.mappers.values())
      s.delete();
    this.polydata.delete();
    for (const [s, r] of this.representations2D)
      r.delete(), this.representations2D.delete(s);
    this.context.objects.volumes.delete(this.id), this.context.objects.stls.delete(this.id), e || this.removeFromObject3dInfos(), this.context.undoManager.remove(this), console.warn("Deleting VolumeObject");
    try {
      if (this.wasmVolumeObject) {
        const s = ge(this.wasmVolumeObject);
        s && s.delete();
      }
    } catch (s) {
      console.log(s);
    }
    this.wasmVolumeObject = void 0;
  }
  updateCrosssections(e) {
    this.context.sceneRepaint(
      void 0,
      (n, s) => {
        this.sendToParallelExecutor(n, !0), this.onViewWidgetEvent(n, s);
      },
      e
    );
  }
  setMatrix(e) {
    ut.copy(this.matrix, e);
    for (const [n, s] of this.actors.entries())
      n.getViewMode() !== Nt._STL_3D_PREVIEW && s.setUserMatrix(this.matrix);
    if (this.wasmVolumeObject) {
      const n = ge(this.wasmVolumeObject);
      $o(n, this.getMatrix());
    }
  }
  getMatrix() {
    return this.matrix;
  }
  getTop(e, n) {
    const s = this.getBounds();
    let r;
    return n ? r = I.fromValues((s[0] + s[1]) / 2, (s[2] + s[3]) / 2, s[5]) : r = I.fromValues(0, 0, s[5]), I.transformMat4(r, r, this.getMatrix()), e && I.scaleAndAdd(r, r, this.getNormal(), e), r;
  }
  getBottom(e, n) {
    const s = this.getBounds();
    let r;
    return n ? r = I.fromValues((s[0] + s[1]) / 2, (s[2] + s[3]) / 2, s[4]) : r = I.fromValues(0, 0, s[4]), I.transformMat4(r, r, this.getMatrix()), e && I.scaleAndAdd(r, r, this.getNormal(), -e), r;
  }
  getBounds() {
    return this.polydata.getBounds();
  }
  getWorldBounds() {
    const e = Ue.newInstance();
    e.setInputData(this.polydata);
    const n = Re.newInstance();
    return n.setMapper(e), n.setUserMatrix(this.matrix), e.modified(), n.getBounds();
  }
  getCenter() {
    const e = this.getBounds();
    return I.fromValues((e[0] + e[1]) / 2, (e[2] + e[3]) / 2, (e[4] + e[5]) / 2);
  }
  getWorldCenter() {
    const e = this.getWorldBounds();
    return I.fromValues((e[0] + e[1]) / 2, (e[2] + e[3]) / 2, (e[4] + e[5]) / 2);
  }
  getNormal() {
    return I.fromValues(this.matrix[8], this.matrix[9], this.matrix[10]);
  }
  getTangent() {
    return I.fromValues(this.matrix[0], this.matrix[1], this.matrix[2]);
  }
  getBinormal() {
    return I.fromValues(this.matrix[4], this.matrix[5], this.matrix[6]);
  }
  //should be same as in STLObject
  getMoveDeltaVectors(e, n, s) {
    if (I.copy(n, this.getNormal()), oJ(this.getName(), this.context.settings.general.useUSStyleToothChart, $e.MAXILLA) && I.scale(n, n, -1), e.getViewMode() == Nt.CPR) {
      const r = this.getPosition();
      I.scale(s, this.context.CPRMath.getClosestSplineTangent(r), -1);
    } else
      I.cross(s, e.getNormal(), e.getViewup()), I.normalize(s, s);
  }
  moveDelta(e, n) {
    const s = this.getPosition();
    I.scaleAndAdd(s, s, e, n), this.moveTo(s);
  }
  // move implant, pin, stlObject
  moveTo(e) {
    const n = ut.clone(this.matrix), s = this.getPosition(), r = I.create();
    I.sub(r, e, s);
    const a = ut.create();
    ut.translate(a, a, r);
    const o = ut.create();
    ut.mul(o, a, n), this.matrix = ut.clone(o), this.setMatrix(this.matrix), this.updateCrosssections();
  }
  // move only for stlObject
  rotate(e, n, s) {
    const r = n * Math.PI / 180;
    s || (s = this.getPosition());
    const a = ut.create();
    ut.fromRotation(a, r, e);
    const o = ut.clone(this.getMatrix());
    o[12] -= s[0], o[13] -= s[1], o[14] -= s[2], ut.mul(o, a, o), o[12] += s[0], o[13] += s[1], o[14] += s[2], this.setMatrix(o);
  }
  getPosition() {
    const e = I.clone(this.getCenter());
    return I.transformMat4(e, e, this.getMatrix()), e;
  }
  createActorObjects(e) {
    const n = Ue.newInstance();
    n.setInputData(this.polydata);
    const s = Re.newInstance();
    return s.setMapper(n), s.getProperty().setColor(this.getDisplayedColor()), s.getProperty().setOpacity(this.opacity), s.setPickable(this.pickable), s.setVisibility(this.visibility), s.getProperty().setRepresentation(this.representation), e != null && e.ignoreTransform || s.setUserMatrix(this.matrix), { mapper: n, actor: s };
  }
  async getScreenshot(e) {
    const { width: n, height: s, background: r, orientation: a, zoom: o } = e, { mapper: l, actor: c } = this.createActorObjects({ ignoreTransform: !e.transform });
    c.setVisibility(!0);
    const u = ip.newInstance();
    u.setParallelProjection(!0), X0({
      camera: u,
      orientation: a,
      focalPoint: c.getOrigin(),
      distance: 1
    });
    try {
      return await vg({
        actor: c,
        camera: u,
        width: n,
        height: s,
        background: r,
        zoom: o
      });
    } finally {
      c.delete(), l.delete(), u.delete();
    }
  }
  create3dActor(e, n) {
    const s = ge(e);
    e.getViewMode() == Nt.STL3D && (this.visibility = !0), e.getViewMode() == Nt._3D;
    const { mapper: r, actor: a } = this.createActorObjects(n);
    this.mappers.set(s, r), this.actors.set(s, a), e.addActor(a, this.getRenderingLayer());
  }
  delete3dActor(e) {
    var r;
    const n = ge(e), s = this.actors.get(n);
    s && (e.removeActor(s), s.delete()), (r = this.mappers.get(n)) == null || r.delete(), this.actors.delete(n), this.mappers.delete(n);
  }
  getPolydata() {
    return this.polydata;
  }
  isActorObject(e) {
    for (const [, n] of this.actors)
      if (e == n) return this.id;
    return null;
  }
  update3dInfo() {
    const e = {
      id: this.id,
      name: this.getGUIName(),
      visible: this.visibility,
      position: this.getPosition(),
      handleTop: null,
      handleBottom: null,
      centerlineTop: null,
      centerlineBottom: null,
      color: Pa(this.getColor()),
      type: this.type
    };
    this.context.objects.object3DInfos.update((n) => {
      const s = n.findIndex((r) => r.id === this.id);
      return s !== -1 ? n[s] = e : n.push(e), n;
    });
  }
  setForceCSRefreshOnTrue(e) {
    this.representations2D.forEach((n, s) => {
      e ? e.id == s && n.setForceCSRefreshOnTrue() : n.setForceCSRefreshOnTrue();
    });
  }
  reconstructVolume(e, n) {
    if (this.wasmVolumeObject) {
      const s = ge(this.wasmVolumeObject);
      if (s.Reconstruct(), Cr(s, this.polydata, e), n) {
        const r = sL(s), a = ut.fromValues(r[0], r[4], r[8], r[12], r[1], r[5], r[9], r[13], r[2], r[6], r[10], r[14], r[3], r[7], r[11], r[15]);
        this.setMatrix(a);
      }
      this.polydata.modified();
    }
  }
  replacePolyDataArrays() {
    if (this.wasmVolumeObject) {
      const e = ge(this.wasmVolumeObject);
      NI(e, this.polydata), this.polydata.modified();
    }
  }
  showThickness(e, n, s = 2) {
    this.mShowThickness = n, this.mpReferenceObject = e.id, this.mMaxRange = s, this.updateThickness();
  }
  updateThickness() {
    if (this.wasmVolumeObject && this.mpReferenceObject) {
      const e = ge(this.wasmVolumeObject);
      if (e.UpdateThickness(this.mShowThickness, this.mpReferenceObject), !this.mShowThickness) {
        this.mappers.forEach((n) => {
          n.setScalarVisibility(!1);
        }), this.context.repaint();
        return;
      }
      Cr(e, this.polydata, !0), this.updateThicknessLUT(), this.mappers.forEach((n) => {
        n.setScalarVisibility(!0), n.setScalarModeToUsePointData(), n.setColorModeToMapScalars(), n.setLookupTable(this.mpColorTF);
      }), this.context.repaint();
    }
  }
  updateThicknessLUT() {
    const e = this.getThicknessRange();
    if (!e) return;
    const { pLUT: n, aboveRangeColor: s, belowRangeColor: r } = Kr.getScalarBarLUT(aJ.eVOLUME_THICKNESS);
    this.mpColorTF.removeAllPoints();
    for (const [a, o] of n)
      this.mpColorTF.addRGBPoint(e[0] + a, o[0], o[1], o[2]);
    this.mpColorTF.setBelowRangeColor(r[0], r[1], r[2], 1), this.mpColorTF.setAboveRangeColor(s[0], s[1], s[2], 1), this.mpColorTF.setUseAboveRangeColor(!0), n.length > 1 && this.mappers.forEach((a) => {
      a.setScalarRange(e[0] + n[0][0], e[0] + n[n.length - 1][0]);
    });
  }
  getThicknessRange() {
    const e = this.polydata.getPointData().getArray("Thickness");
    return e ? e.getRange() : null;
  }
  SetImplantPlanerProjectStl(e) {
    this.projectStl = e;
  }
}
class qDt extends NC {
  constructor(e, n) {
    super();
    S(this, "wasmUndoObject");
    S(this, "onUndo");
    S(this, "onRedo");
    const s = e.getEngine();
    this.wasmUndoObject = new s.WasmVolumeUndoObject(n.id, !1), this.onUndo = () => {
      this.wasmUndoObject.OnUndo(), n.wasmVolumeObject && (Cr(n.wasmVolumeObject, n.getPolydata(), !0), e.repaint());
    }, this.onRedo = () => {
      this.wasmUndoObject.OnRedo(), n.wasmVolumeObject && (Cr(n.wasmVolumeObject, n.getPolydata(), !0), e.repaint());
    }, this.delete = () => {
      this.wasmUndoObject.delete();
    }, this.getMemory = () => Number(this.wasmUndoObject.GetMemory());
  }
}
const {
  vtkErrorMacro: ZS
} = tt;
function nNt(i, t) {
  t.classHierarchy.push("vtkSpline1D"), i.computeCloseCoefficients = (e, n, s, r) => {
    ZS(`${t.classHierarchy.slice(-1)[0]} should implement computeCloseCoefficients`);
  }, i.computeOpenCoefficients = function(e, n, s, r) {
    ZS(`${t.classHierarchy.slice(-1)[0]} should implement computeOpenCoefficients`);
  }, i.getValue = (e, n) => {
    ZS(`${t.classHierarchy.slice(-1)[0]} should implement getValue`);
  };
}
const iNt = {};
function uA(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, iNt, e), tt.obj(i, t), nNt(i, t);
}
const sNt = tt.newInstance(uA, "vtkSpline1D");
var dA = {
  newInstance: sNt,
  extend: uA
};
const na = {
  DEFAULT: 0,
  DERIVATIVE: 1,
  SECOND_DERIVATIVE: 2,
  SECOND_DERIVATIVE_INTERIOR_POINT: 3
}, Lz = 1e-4;
function rNt(i, t) {
  t.classHierarchy.push("vtkCardinalSpline1D"), i.computeCloseCoefficients = (e, n, s, r) => {
    (!t.coefficients || t.coefficients.length !== 4 * e) && (t.coefficients = new Float32Array(4 * e));
    const a = e - 1;
    for (let p = 1; p < a; p++) {
      const m = s[p] - s[p - 1], b = s[p + 1] - s[p];
      t.coefficients[4 * p + 0] = b, t.coefficients[4 * p + 1] = 2 * (b + m), t.coefficients[4 * p + 2] = m, n[p] = 3 * (b * (r[p] - r[p - 1]) / m + m * (r[p + 1] - r[p]) / b);
    }
    const o = s[a] - s[a - 1], l = s[1] - s[0];
    t.coefficients[4 * a + 0] = l, t.coefficients[4 * a + 1] = 2 * (l + o), t.coefficients[4 * a + 2] = o, n[a] = 3 * (l * (r[a] - r[a - 1]) / o + o * (r[1] - r[0]) / l);
    const c = t.coefficients[4 * a + 0], u = t.coefficients[4 * a + 1], d = t.coefficients[4 * a + 2], h = n[a];
    t.coefficients[2] = 0, n[0] = 0, t.coefficients[3] = 1;
    for (let p = 1; p <= a; p++)
      t.coefficients[4 * p + 1] -= t.coefficients[4 * p + 0] * t.coefficients[4 * (p - 1) + 2], t.coefficients[4 * p + 2] = t.coefficients[4 * p + 2] / t.coefficients[4 * p + 1], n[p] = (n[p] - t.coefficients[4 * p + 0] * n[p - 1]) / t.coefficients[4 * p + 1], t.coefficients[4 * p + 3] = -t.coefficients[4 * p + 0] * t.coefficients[4 * (p - 1) + 3] / t.coefficients[4 * p + 1];
    t.coefficients[4 * a + 0] = 1, t.coefficients[4 * a + 1] = 0;
    for (let p = a - 1; p > 0; p--)
      t.coefficients[4 * p + 0] = t.coefficients[4 * p + 3] - t.coefficients[4 * p + 2] * t.coefficients[4 * (p + 1) + 0], t.coefficients[4 * p + 1] = n[p] - t.coefficients[4 * p + 2] * t.coefficients[4 * (p + 1) + 1];
    n[0] = (h - d * t.coefficients[5] - c * t.coefficients[4 * (a - 1) + 1]) / (u + d * t.coefficients[4] + c * t.coefficients[4 * (a - 1) + 0]), n[a] = n[0];
    for (let p = 1; p < a; p++)
      n[p] = t.coefficients[4 * p + 0] * n[a] + t.coefficients[4 * p + 1];
    for (let p = 0; p < a; p++) {
      const m = s[p + 1] - s[p];
      t.coefficients[4 * p + 0] = r[p], t.coefficients[4 * p + 1] = n[p], t.coefficients[4 * p + 2] = 3 * (r[p + 1] - r[p]) / (m * m) - (n[p + 1] + 2 * n[p]) / m, t.coefficients[4 * p + 3] = 2 * (r[p] - r[p + 1]) / (m * m * m) + (n[p + 1] + n[p]) / (m * m);
    }
    t.coefficients[4 * a + 0] = r[a], t.coefficients[4 * a + 1] = n[a], t.coefficients[4 * a + 2] = t.coefficients[2], t.coefficients[4 * a + 3] = t.coefficients[3];
  }, i.computeOpenCoefficients = function(e, n, s, r) {
    let a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    (!t.coefficients || t.coefficients.length !== 4 * e) && (t.coefficients = new Float32Array(4 * e));
    const o = e - 1;
    switch (a.leftConstraint) {
      case na.DERIVATIVE:
        t.coefficients[1] = 1, t.coefficients[2] = 0, n[0] = a.leftValue;
        break;
      case na.SECOND_DERIVATIVE:
        t.coefficients[1] = 2, t.coefficients[2] = 1, n[0] = 3 * ((r[1] - r[0]) / (s[1] - s[0])) - 0.5 * (s[1] - s[0]) * a.leftValue;
        break;
      case na.SECOND_DERIVATIVE_INTERIOR_POINT:
        t.coefficients[1] = 2, Math.abs(a.leftValue + 2) > Lz ? (t.coefficients[2] = 4 * ((0.5 + a.leftValue) / (2 + a.leftValue)), n[0] = 6 * ((1 + a.leftValue) / (2 + a.leftValue)) * ((r[1] - r[0]) / (s[1] - s[0]))) : (t.coefficients[2] = 0, n[0] = 0);
        break;
      case na.DEFAULT:
      default:
        t.coefficients[1] = 1, t.coefficients[2] = 0, n[0] = r[2] - r[0];
        break;
    }
    for (let l = 1; l < o; l++) {
      const c = s[l] - s[l - 1], u = s[l + 1] - s[l];
      t.coefficients[4 * l + 0] = u, t.coefficients[4 * l + 1] = 2 * (u + c), t.coefficients[4 * l + 2] = c, n[l] = 3 * (u * (r[l] - r[l - 1]) / c + c * (r[l + 1] - r[l]) / u);
    }
    switch (a.rightConstraint) {
      case na.DERIVATIVE:
        t.coefficients[4 * o + 0] = 0, t.coefficients[4 * o + 1] = 1, n[o] = a.rightValue;
        break;
      case na.SECOND_DERIVATIVE:
        t.coefficients[4 * o + 0] = 1, t.coefficients[4 * o + 1] = 2, n[o] = 3 * ((r[o] - r[o - 1]) / (s[o] - s[o - 1])) + 0.5 * (s[o] - s[o - 1]) * a.rightValue;
        break;
      case na.SECOND_DERIVATIVE_INTERIOR_POINT:
        t.coefficients[4 * o + 1] = 2, Math.abs(a.rightValue + 2) > Lz ? (t.coefficients[4 * o + 0] = 4 * ((0.5 + a.rightValue) / (2 + a.rightValue)), n[o] = 6 * ((1 + a.rightValue) / (2 + a.rightValue)) * ((r[o] - r[e - 2]) / (s[o] - s[e - 2]))) : (t.coefficients[4 * o + 0] = 0, n[o] = 0);
        break;
      case na.DEFAULT:
      default:
        t.coefficients[4 * o + 0] = 0, t.coefficients[4 * o + 1] = 1, n[o] = r[o] - r[o - 2];
        break;
    }
    t.coefficients[2] /= t.coefficients[1], n[0] /= t.coefficients[4 * o + 1], t.coefficients[4 * o + 3] = 1;
    for (let l = 1; l <= o; l++)
      t.coefficients[4 * l + 1] -= t.coefficients[4 * l + 0] * t.coefficients[4 * (l - 1) + 2], t.coefficients[4 * l + 2] /= t.coefficients[4 * l + 1], n[l] = (n[l] - t.coefficients[4 * l + 0] * n[l - 1]) / t.coefficients[4 * l + 1];
    for (let l = o - 1; l >= 0; l--)
      n[l] -= t.coefficients[4 * l + 2] * n[l + 1];
    for (let l = 0; l < o; l++) {
      const c = s[l + 1] - s[l];
      t.coefficients[4 * l + 0] = r[l], t.coefficients[4 * l + 1] = n[l], t.coefficients[4 * l + 2] = 3 * (r[l + 1] - r[l]) / (c * c) - (n[l + 1] + 2 * n[l]) / c, t.coefficients[4 * l + 3] = 2 * (r[l] - r[l + 1]) / (c * c * c) + (n[l + 1] + n[l]) / (c * c);
    }
    t.coefficients[4 * o + 0] = r[o], t.coefficients[4 * o + 1] = n[o], t.coefficients[4 * o + 2] = t.coefficients[2], t.coefficients[4 * o + 3] = t.coefficients[3];
  }, i.getValue = (e, n) => {
    const s = n * n, r = n * n * n;
    return t.coefficients[4 * e + 3] * r + t.coefficients[4 * e + 2] * s + t.coefficients[4 * e + 1] * n + t.coefficients[4 * e + 0];
  };
}
const aNt = {};
function hA(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, aNt, e), dA.extend(i, t, e), tt.obj(i, t), rNt(i, t);
}
const oNt = tt.newInstance(hA, "vtkCardinalSpline1D");
var TS = {
  newInstance: oNt,
  extend: hA
};
const Vz = 1e-4;
function lNt(i, t) {
  t.classHierarchy.push("vtkKochanekSpline1D"), i.computeCloseCoefficients = (e, n, s, r) => {
    (!t.coefficients || t.coefficients.length !== 4 * e) && (t.coefficients = new Float32Array(4 * e));
    const a = e - 1;
    for (let p = 1; p < a; p++) {
      const m = r[p] - r[p - 1], b = r[p + 1] - r[p];
      let y = m * ((1 - t.tension) * (1 - t.continuity) * (1 + t.bias)) + b * ((1 - t.tension) * (1 + t.continuity) * (1 - t.bias)), Z = m * ((1 - t.tension) * (1 + t.continuity) * (1 + t.bias)) + b * ((1 - t.tension) * (1 - t.continuity) * (1 - t.bias));
      const g = s[p + 1] - s[p], f = s[p] - s[p - 1];
      y *= f / (f + g), Z *= g / (f + g), t.coefficients[4 * p + 0] = r[p], t.coefficients[4 * p + 1] = Z, t.coefficients[4 * p + 2] = y;
    }
    t.coefficients[0] = r[0], t.coefficients[4 * a + 0] = r[a], t.coefficients[4 * a + 1] = 0, t.coefficients[4 * a + 2] = 0, t.coefficients[4 * a + 3] = 0;
    const o = r[a] - r[a - 1], l = r[1] - r[0];
    let c = o * ((1 - t.tension) * (1 - t.continuity) * (1 + t.bias)) + l * ((1 - t.tension) * (1 + t.continuity) * (1 - t.bias)), u = o * ((1 - t.tension) * (1 + t.continuity) * (1 + t.bias)) + l * ((1 - t.tension) * (1 - t.continuity) * (1 - t.bias));
    const d = s[1] - s[0], h = s[a] - s[a - 1];
    c *= h / (h + d), u *= d / (h + d), t.coefficients[1] = u, t.coefficients[2] = c, t.coefficients[4 * a + 1] = u, t.coefficients[4 * a + 2] = c;
    for (let p = 0; p < a; p++)
      t.coefficients[4 * p + 2] = -3 * r[p] + 3 * r[p + 1] + -2 * t.coefficients[4 * p + 1] + -1 * t.coefficients[4 * (p + 1) + 2], t.coefficients[4 * p + 3] = 2 * r[p] + -2 * r[p + 1] + 1 * t.coefficients[4 * p + 1] + 1 * t.coefficients[4 * (p + 1) + 2];
  }, i.computeOpenCoefficients = function(e, n, s, r) {
    let a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    (!t.coefficients || t.coefficients.length !== 4 * e) && (t.coefficients = new Float32Array(4 * e));
    const o = e - 1;
    for (let l = 1; l < o; l++) {
      const c = r[l] - r[l - 1], u = r[l + 1] - r[l];
      let d = c * ((1 - t.tension) * (1 - t.continuity) * (1 + t.bias)) + u * ((1 - t.tension) * (1 + t.continuity) * (1 - t.bias)), h = c * ((1 - t.tension) * (1 + t.continuity) * (1 + t.bias)) + u * ((1 - t.tension) * (1 - t.continuity) * (1 - t.bias));
      const p = s[l + 1] - s[l], m = s[l] - s[l - 1];
      d *= m / (m + p), h *= p / (m + p), t.coefficients[4 * l + 0] = r[l], t.coefficients[4 * l + 1] = h, t.coefficients[4 * l + 2] = d;
    }
    switch (t.coefficients[0] = r[0], t.coefficients[4 * o + 0] = r[o], a.leftConstraint) {
      // desired slope at leftmost point is leftValue
      case na.DERIVATIVE:
        t.coefficients[1] = a.leftValue;
        break;
      case na.SECOND_DERIVATIVE:
        t.coefficients[1] = (6 * (r[1] - r[0]) - 2 * t.coefficients[6] - a.leftValue) / 4;
        break;
      case na.SECOND_DERIVATIVE_INTERIOR_POINT:
        Math.abs(a.leftValue + 2) > Vz ? t.coefficients[1] = (3 * (1 + a.leftValue) * (r[1] - r[0]) - (1 + 2 * a.leftValue) * t.coefficients[6]) / (2 + a.leftValue) : t.coefficients[1] = 0;
        break;
      case na.DEFAULT:
      default:
        t.coefficients[1] = r[2] - r[0];
        break;
    }
    switch (a.rightConstraint) {
      case na.DERIVATIVE:
        t.coefficients[4 * o + 2] = a.leftValue;
        break;
      case na.SECOND_DERIVATIVE:
        t.coefficients[4 * o + 2] = (6 * (r[o] - r[o - 1]) - 2 * t.coefficients[4 * (o - 1) + 1] + a.leftValue) / 4;
        break;
      case na.SECOND_DERIVATIVE_INTERIOR_POINT:
        Math.abs(a.leftValue + 2) > Vz ? t.coefficients[4 * o + 2] = (3 * (1 + a.leftValue) * (r[o] - r[o - 1]) - (1 + 2 * a.leftValue) * t.coefficients[4 * (o - 1) + 1]) / (2 + a.leftValue) : t.coefficients[4 * o + 2] = 0;
        break;
      case na.DEFAULT:
      default:
        t.coefficients[4 * o + 2] = r[o] - r[o - 2];
        break;
    }
    for (let l = 0; l < o; l++)
      t.coefficients[4 * l + 2] = -3 * r[l] + 3 * r[l + 1] + -2 * t.coefficients[4 * l + 1] + -1 * t.coefficients[4 * (l + 1) + 2], t.coefficients[4 * l + 3] = 2 * r[l] + -2 * r[l + 1] + 1 * t.coefficients[4 * l + 1] + 1 * t.coefficients[4 * (l + 1) + 2];
  }, i.getValue = (e, n) => {
    const s = n * n, r = n * n * n;
    return t.coefficients[4 * e + 3] * r + t.coefficients[4 * e + 2] * s + t.coefficients[4 * e + 1] * n + t.coefficients[4 * e + 0];
  };
}
const cNt = {
  tension: 0,
  bias: 0,
  continuity: 0
};
function pA(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, cNt, e), dA.extend(i, t, e), tt.obj(i, t), lNt(i, t);
}
const uNt = tt.newInstance(pA, "vtkKochanekSpline1D");
var MS = {
  newInstance: uNt,
  extend: pA
};
const OW = {
  CARDINAL_SPLINE: "CARDINAL_SPLINE",
  KOCHANEK_SPLINE: "KOCHANEK_SPLINE"
}, {
  vtkErrorMacro: Xz
} = tt;
function dNt(i, t) {
  t.classHierarchy.push("vtkSpline3D");
  function e(n, s, r) {
    s.length === 0 && Xz("Splines require at least one points"), s.length === 1 && s.push(s[0]);
    const a = s.length;
    let o = null, l = null;
    if (o = new Float32Array(a), t.intervals.length === 0) {
      l = new Float32Array(a);
      for (let c = 0; c < l.length; c++)
        l[c] = c;
    } else
      l = t.intervals;
    t.close ? n.computeCloseCoefficients(a, o, l, s) : n.computeOpenCoefficients(a, o, l, s, {
      leftConstraint: t.boundaryCondition,
      leftValue: r,
      rightConstraint: t.boundaryCondition,
      rightValue: r
    });
  }
  i.computeCoefficients = (n) => {
    const s = n.map((o) => o[0]), r = n.map((o) => o[1]), a = n.map((o) => o[2]);
    e(t.splineX, s, t.boundaryConditionValues[0]), e(t.splineY, r, t.boundaryConditionValues[1]), e(t.splineZ, a, t.boundaryConditionValues[2]);
  }, i.getPoint = (n, s) => [t.splineX.getValue(n, s), t.splineY.getValue(n, s), t.splineZ.getValue(n, s)], t.kind === OW.KOCHANEK_SPLINE ? (t.splineX = MS.newInstance({
    tension: t.tension,
    continuity: t.continuity,
    bias: t.bias
  }), t.splineY = MS.newInstance({
    tension: t.tension,
    continuity: t.continuity,
    bias: t.bias
  }), t.splineZ = MS.newInstance({
    tension: t.tension,
    continuity: t.continuity,
    bias: t.bias
  })) : t.kind === OW.CARDINAL_SPLINE ? (t.splineX = TS.newInstance(), t.splineY = TS.newInstance(), t.splineZ = TS.newInstance()) : Xz(`Unknown spline type ${t.kind}`);
}
const hNt = {
  close: !1,
  intervals: [],
  kind: OW.KOCHANEK_SPLINE,
  boundaryConditionValues: [0, 0, 0],
  // Passed to the vtkKochanekSpline1D
  tension: 0,
  continuity: 0,
  bias: 0
};
function mA(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, hNt, e), tt.obj(i, t), tt.setGet(i, t, ["close", "intervals"]), dNt(i, t);
}
const pNt = tt.newInstance(mA, "vtkSpline3D");
var bA = {
  newInstance: pNt,
  extend: mA
};
class fA extends ow {
  constructor(e, n, s, r) {
    super(s);
    S(this, "context");
    S(this, "type", Yt._NERVE);
    S(this, "projectNerve");
    S(this, "object3dInfo");
    S(this, "objectSubType");
    S(this, "radius");
    S(this, "points");
    S(this, "wasmId");
    S(this, "wasmIdCount", 0);
    S(this, "matrix", ut.create());
    // public override wasmStlObject?: IEngineGenerated.prototype.WasmStlObject;
    S(this, "N", 10);
    S(this, "splPoints", []);
    S(this, "spline", bA.newInstance({ close: !1, kind: OW.KOCHANEK_SPLINE }));
    S(this, "data", Ie.newInstance());
    S(this, "polyPoints", yi.newInstance());
    S(this, "lines", Ii.newInstance());
    S(this, "filter", Qh.newInstance({
      radius: 0.3,
      numberOfSides: 10,
      capping: !0
    }));
    S(this, "filterCollision", Qh.newInstance({
      radius: 0.5,
      numberOfSides: 10,
      capping: !0
    }));
    S(this, "oldSecurityZone", 0);
    S(this, "updateCSFlag", !1);
    S(this, "collisionReport", "");
    S(this, "collisionMap", /* @__PURE__ */ new Map());
    S(this, "pT", 0);
    this.context = e, this.filter.setInputData(this.data), this.filterCollision.setInputData(this.data), this.data.setPoints(this.polyPoints), this.data.setLines(this.lines), this.pickable = !1, this.color = Kn(e.settings.defaultColors.nerves), this.wasmId = this.id, n ? (this.projectNerve = n, this.objectSubType = n.objectSubType, this.name = n.name, this.displayText = n.displayText, this.color = Kn(n.color), this.opacity = n.opacity, this.visibility = n.visible, this.radius = n.radius * this.context.getDataSpacing(), r ? this.points = n.points : this.points = n.points.map((a) => this.context.objects.scaleVectorFromImplantPlanner(a)), this.setData(this.points, this.points, !0)) : (this.projectNerve = {
      radius: 1,
      points: [],
      opacity: 1,
      name: "",
      objectType: Yt._NERVE,
      objectSubType: Yt._NONE,
      color: Kn(e.settings.defaultColors.nerves),
      visible: !0,
      displayText: "",
      objectNote: "",
      shapePoints: 0,
      enabled: 1,
      deleted: 0,
      ownerCount: 0,
      owners: []
    }, this.objectSubType = this.projectNerve.objectSubType, this.radius = 1, this.points = []);
  }
  setData(e, n, s = !1) {
    this.updateCSFlag = !0, n != null && (this.points = n), this.splPoints = [];
    let r = e;
    if (e.length > 2 && s) {
      this.spline.computeCoefficients(e), this.splPoints.push(this.spline.getPoint(0, 0));
      for (let c = 0; c < e.length - 1; c++)
        for (let u = 1; u <= this.N; u++)
          this.splPoints.push(this.spline.getPoint(c, u / this.N));
      r = this.splPoints;
    }
    const a = r.length, o = new Float32Array(a * 3), l = new Uint16Array(a + 1);
    for (let c = 0; c < a; c++) {
      const u = r[c];
      o[3 * c] = u[0], o[3 * c + 1] = u[1], o[3 * c + 2] = u[2], l[c + 1] = c;
    }
    l[0] = a, this.polyPoints.setData(o, 3), this.lines.setData(l), this.filter.setRadius(this.radius), this.oldSecurityZone = this.context.settings.implants.minimumDistanceFromNerveMm, this.filterCollision.setRadius(this.radius + this.context.settings.implants.minimumDistanceFromNerveMm), this.data.modified(), this.filter.modified(), this.filterCollision.modified(), this.updatePosition(), this.syncWasmPolydata();
    for (const [c, u] of this.representations2D)
      u.updatePolydata(this.filter.getOutputData());
  }
  updateCollisionZone() {
    if (this.oldSecurityZone != this.context.settings.implants.minimumDistanceFromNerveMm)
      if (this.oldSecurityZone = this.context.settings.implants.minimumDistanceFromNerveMm, this.filterCollision.setRadius(this.radius + this.context.settings.implants.minimumDistanceFromNerveMm), this.data.modified(), this.filterCollision.modified(), this.wasmStlObject) {
        const e = this.filter.getOutputData();
        du(this.wasmStlObject, e, !0, !1), du(this.wasmStlObject, this.filterCollision.getOutputData(), !1, !0), $o(this.wasmStlObject, this.matrix);
      } else
        console.warn("Wasm STL object not exist!!");
  }
  toProjectNerve() {
    const e = this.projectNerve;
    return e.name = this.name, e.displayText = this.displayText, e.color = Pa(this.getColor()), e.opacity = this.getOpacity(), e.visible = this.getVisibility(), e.points = this.points.map((n) => this.context.objects.scaleVectorToImplantPlanner(n)), e.radius = this.radius / this.context.getDataSpacing(), e.objectSubType = this.objectSubType, e.objectType = this.type, e;
  }
  onViewWidgetEvent(e, n) {
    if (e.getViewMode() !== Nt._STL_3D_PREVIEW)
      if (e.isViewMode3D()) {
        const s = this.actors.get(ge(e));
        switch (n) {
          case me.eVE_SHOW:
          case me.eVE_RENDER:
            if (!s)
              this.create3dActor(e), console.log("NERVE - creating 3d nerve actor!");
            else {
              const r = this.mappers.get(ge(e));
              r && (r.setInputData(this.filter.getOutputData()), r.modified());
            }
            break;
          case me.eVE_HIDE:
            break;
          case me.eVE_DESTROY:
            this.delete3dActor(e), console.log("NERVE - deleting 3d nerve actor!");
            break;
        }
      } else {
        let s = this.representations2D.get(e.id);
        switch (n) {
          case me.eVE_SHOW:
          case me.eVE_RENDER:
            s || (s = new jh(this.context, ge(e), this.filter.getOutputData(), this), this.representations2D.set(e.id, s)), s.setColor(this.getDisplayedColor()), s.setActorMatrix(this.matrix), s.setVisibility(this.visibility), s.onViewWidgetEvent(ge(e), n);
            break;
          case me.eVE_HIDE:
            break;
          case me.eVE_DESTROY:
            s == null || s.onViewWidgetEvent(ge(e), n), s == null || s.delete(), this.representations2D.delete(e.id);
            break;
        }
      }
  }
  sendToParallelExecutor(e, n) {
    let s = this.representations2D.get(e.id);
    if (s || (s = new jh(this.context, ge(e), this.filter.getOutputData(), this), this.representations2D.set(e.id, s)), s.sendToParallelExecutor(e), n) {
      const r = this.context.getWasmDocumentInstance();
      r && r.WaitForParallelExecutor();
    }
  }
  createActorObjects() {
    const e = this.filter.getOutputData(), n = Ue.newInstance();
    n.setInputData(e);
    const s = Re.newInstance();
    return s.setMapper(n), s.getProperty().setColor(this.getDisplayedColor()), s.getProperty().setOpacity(this.opacity), s.setPickable(!1), s.setVisibility(this.visibility), s.setUserMatrix(this.matrix), { mapper: n, actor: s };
  }
  async getScreenshot(e) {
    let n = null;
    const s = performance.now();
    if (s - this.pT > 100) {
      const { width: r, height: a, background: o, orientation: l, zoom: c } = e, { mapper: u, actor: d } = this.createActorObjects();
      d.getProperty().setColor(this.getColor()), d.setVisibility(!0), d.setUserMatrix(ut.create());
      const h = ip.newInstance();
      h.setParallelProjection(!0), X0({
        camera: h,
        orientation: l,
        focalPoint: d.getOrigin(),
        distance: 1
      });
      try {
        n = await vg({
          actor: d,
          camera: h,
          width: r,
          height: a,
          background: o,
          zoom: c
        });
      } finally {
        d.delete(), u.delete(), h.delete();
      }
    }
    return this.pT = s, n;
  }
  create3dActor(e) {
    const n = ge(e), { mapper: s, actor: r } = this.createActorObjects();
    this.mappers.set(n, s), this.actors.set(n, r), e.getRenderer().addActor(r);
  }
  delete3dActor(e) {
    var r;
    const n = ge(e), s = this.actors.get(n);
    s && (e.removeActor(s), s.delete()), (r = this.mappers.get(n)) == null || r.delete(), this.actors.delete(n), this.mappers.delete(n), this.removeFromObject3dInfos();
  }
  isActorObject(e) {
    for (const [, n] of this.actors)
      if (e == n) return this.id;
    return null;
  }
  getNerveIndex() {
    return parseInt(this.name);
  }
  update3dInfo() {
    this.object3dInfo = {
      id: this.id,
      name: this.name,
      visible: this.visibility,
      position: [0, 0, 0],
      handleTop: null,
      handleBottom: null,
      centerlineTop: null,
      centerlineBottom: null,
      color: this.projectNerve.color,
      type: Yt._NERVE
    }, this.context.objects.object3DInfos.update((e) => {
      const n = e.findIndex((s) => s.id === this.id);
      return n !== -1 ? e[n] = this.object3dInfo : e.push(this.object3dInfo), e;
    });
  }
  removeFromObject3dInfos() {
    this.context.objects.object3DInfos.update((e) => {
      const n = e.findIndex((s) => s.id === this.id);
      return n !== -1 && e.splice(n, 1), e;
    });
  }
  updatePosition() {
    this.update3dInfo();
  }
  updateDisplayedColor() {
    const e = this.getDisplayedColor();
    for (const n of this.actors.values())
      n.getProperty().setColor(e);
    this.representations2D.forEach((n) => {
      n.setColor(e);
    }), this.update3dInfo(), this.context.getObjects().onStlColorChanged.notify({ id: this.id.toString(), color: e }), this.context.repaint();
  }
  setColor(e) {
    var n;
    this.color = e, (n = this.wasmStlObject) == null || n.SetColor(e[0], e[1], e[2], 1), this.colorOverride || this.updateDisplayedColor();
  }
  setColorOverride(e) {
    e === null && this.colorOverride === null || e !== this.colorOverride && (super.setColorOverride(e), this.updateDisplayedColor());
  }
  setLocked(e) {
    this.locked = e;
  }
  setOpacity(e) {
    this.opacity = e;
    for (const n of this.actors.values())
      n.getProperty().setOpacity(e);
    this.context.repaint();
  }
  setPickable(e) {
    this.pickable = e;
    for (const n of this.actors.values())
      n.setPickable(e);
  }
  setVisibility(e) {
    var n;
    this.visibility = e, (n = this.wasmStlObject) == null || n.SetVisibility(e);
    for (const s of this.actors.values())
      s.setVisibility(e);
    this.update3dInfo(), this.context.sceneRepaint(void 0, (s, r) => {
      this.sendToParallelExecutor(s, !0), this.onViewWidgetEvent(s, r);
    }), this.context.repaint();
  }
  setMatrix(e) {
    ut.copy(this.matrix, e);
    for (const n of this.actors.values())
      n.setUserMatrix(this.matrix);
  }
  setRadius(e) {
    this.radius = e;
  }
  getRadius() {
    return this.radius;
  }
  setDiameter(e) {
    this.radius = e / 2;
  }
  getDiameter() {
    return this.radius * 2;
  }
  getMatrix() {
    return this.matrix;
  }
  syncWasmPolydata() {
    if (this.wasmStlObject) {
      this.data.modified(), this.filter.modified(), this.context.repaint();
      const e = this.filter.getOutputData();
      du(this.wasmStlObject, e, !0, !1), du(this.wasmStlObject, this.filterCollision.getOutputData(), !1, !0), $o(this.wasmStlObject, this.matrix);
    } else {
      const e = this.context.getEngine();
      this.data.modified(), this.filter.modified(), this.context.repaint();
      const n = this.filter.getOutputData(), s = new e.xWasmStlObject(this.id, Pe.eOT_IP_NERVE, this.type, this.objectSubType);
      du(s, n, !0, !1), du(s, this.filterCollision.getOutputData(), !1, !0), $o(s, this.matrix), this.wasmStlObject = s, this.setName(this.name), this.setDisplayText(this.displayText), this.setColor(this.color);
    }
  }
  deleteWasmPolydata() {
    this.wasmStlObject && (console.warn("Nerve -deleteWasmPolydata"), this.wasmStlObject.delete(), this.wasmStlObject = void 0);
  }
  delete(e) {
    for (const [n, s] of this.actors)
      n.getRenderer().removeActor(s);
    for (const n of this.mappers.values())
      n.delete();
    for (const [n, s] of this.representations2D)
      s.delete(), this.representations2D.delete(n);
    e || this.removeFromObject3dInfos(), this.polyPoints.delete(), this.lines.delete(), this.data.delete(), this.filter.delete(), this.deleteWasmPolydata();
  }
}
class zW extends vn {
  constructor(e, n, s, r, a) {
    super({ context: e });
    S(this, "owner");
    S(this, "markerRepresentations", /* @__PURE__ */ new Map());
    S(this, "projectMarker");
    this.type = Yt._TOOTH_MARKER, this.subType = Yt._NONE, this.setPositionAndText(n, s), a && (this.owner = a), this.color = [1, 1, 0], this.projectMarker = r;
    const o = this.context.getEngine();
    this.wasmStlObject = new o.xWasmStlObject(this.id, Pe.eOT_MARKER, this.type, this.subType);
  }
  static fromProjectToothMarker(e, n, s) {
    let r;
    s != null && s.ignoreScaling ? r = n.origin : r = e.objects.scaleVectorFromImplantPlanner(n.origin);
    const a = new zW(e, r, n.name, n);
    return a.displayText = n.displayText, a.setName(n.name), a.setDisplayText(n.displayText), a.setColor(Kn(n.color)), a.setVisibility(n.visible), a.opacity = n.opacity, a.objectNote = n.objectNote, a.enabled = n.enabled, a.deleted = n.deleted, a.owners = n.owners, a.cadToothInfoOrderNumber = n.CadToothInfoOrderNumber, a.cadToothInfoType = n.CadToothInfoType, a;
  }
  toProjectToothMarkerObject() {
    const e = this.getPosition(), n = this.context.objects.scaleVectorToImplantPlanner(e);
    return this.projectMarker.color = Pa(this.color), this.projectMarker.opacity = this.opacity * 255, this.projectMarker.displayText = this.displayText, this.projectMarker.name = this.name, this.projectMarker.origin = n, this.projectMarker.objectSubType = this.subType, this.projectMarker.objectType = this.type, this.projectMarker.visible = this.getVisibility(), this.projectMarker.objectNote = this.objectNote, this.projectMarker;
  }
  setPositionAndText(e, n) {
    const s = ut.create();
    ut.fromTranslation(s, e), this.setMatrix(s), this.setName(n);
  }
  onViewWidgetEvent(e, n) {
    if (e.isViewMode3D()) {
      let s = this.markerRepresentations.get(e);
      switch (n) {
        case me.eVE_SHOW:
        case me.eVE_RENDER:
          s || (s = this.createRepresentation(e), this.markerRepresentations.set(e, s));
          for (const [r, a] of this.markerRepresentations)
            a.actor.setUserMatrix(this.getMatrix()), a.actor.getProperty().setColor(this.color);
          break;
        case me.eVE_HIDE:
          break;
        case me.eVE_DESTROY:
          this.deleteRepresentation(e);
          break;
      }
    }
  }
  createRepresentation(e) {
    const n = sp.newInstance({ radius: 1 }), s = Re.newInstance(), r = Ue.newInstance();
    return r.setInputConnection(n.getOutputPort()), s.setMapper(r), e.addActor(s), {
      source: n,
      actor: s,
      mapper: r
    };
  }
  deleteRepresentation(e) {
    const n = this.markerRepresentations.get(e);
    n && (e.removeActor(n.actor), n.actor.delete(), n.mapper.delete(), n.source.delete());
  }
  delete(e) {
    for (const [n, s] of this.markerRepresentations)
      this.deleteRepresentation(n);
    this.markerRepresentations.clear(), this.context.objects.toothMarkers.delete(this.id), super.delete(e);
  }
  setMatrix(e) {
    super.setMatrix(e);
    for (const [n, s] of this.markerRepresentations.entries())
      s.actor.setUserMatrix(this.matrix);
  }
  getPosition() {
    return I.fromValues(this.matrix[12], this.matrix[13], this.matrix[14]);
  }
  setOpacity(e) {
    super.setOpacity(e);
    for (const n of this.actors.values())
      n.getProperty().setOpacity(e);
  }
  setPickable(e) {
    super.setPickable(e);
    for (const [n, s] of this.markerRepresentations.entries())
      s.actor.setPickable(e);
  }
  setVisibility(e) {
    super.setVisibility(e);
    for (const [n, s] of this.markerRepresentations.entries())
      s.actor.setVisibility(e);
  }
}
class kd extends vn {
  constructor(e) {
    super(e);
    S(this, "implant");
    S(this, "isSupport", !1);
    S(this, "sleeveInfo");
    S(this, "part");
    S(this, "scaleMatrix");
    S(this, "sleeveBuilder");
    S(this, "guideTop", I.create());
    S(this, "guideDir", I.create());
    S(this, "guideBiDir", I.create());
    S(this, "guideHeight", 0);
    S(this, "type", Yt._GUIDE_SUPPORT_OBJECT);
    this.initialize(e), this.implant = e.implant, this.sleeveInfo = e.sleeveInfo, this.sleeveBuilder = e.sleeveBuilder, this.part = e.part, this.scaleMatrix = e.scaleMatrix, this.implant.addSupportObject(this);
  }
  //part 1 = suport, part 2 = sleeve, 7 upper extrusion, 8 lower extrusions,
  static constructGuideObject(e, n, s, r, a, o, l) {
    var f, T, M, N, W, x, V;
    const c = e.getEngine();
    let u, d = Ie.newInstance();
    const h = ut.create(), p = [0, 170 / 255, 255 / 255];
    let m;
    n.isImplant() ? m = a : m = o;
    const b = m / 2;
    let y = s.distanceFromImplant;
    if (r == 1 || r == 7 || !s.stlNegativeData) {
      if (y = s.distanceFromImplant, r == 1 && s.stlNegativeData && !n.isImplant()) {
        const z = (f = n.getSleeve()) == null ? void 0 : f.getBounds()[4];
        z && (y = z);
      }
      const X = ((T = n.getSleeve()) == null ? void 0 : T.sleeveExtRadius) || s.dExternal / 2, C = ((M = n.getSleeve()) == null ? void 0 : M.sleeveLength) || s.lSleeve;
      u = new c.TGuideVTK(
        X,
        b,
        //info.dInternal / 2,
        n.isImplant() ? 30 : 40,
        // height = guide_length-> Implant -> 30, pim -> 40
        y,
        //info.distanceFromImplant,
        C,
        jS(s, n.isImplant()),
        s.lLip,
        s.lCut,
        s.rotationAll ?? 0,
        s.rotationCut ?? 0,
        n.isImplant() ? 0 : 1,
        // isFixationPin
        r,
        0,
        // visualization
        l
      ), d.getPoints().setData(u.pointsView);
      const R = new Uint32Array(u.polysView.length);
      for (let z = 0; z < u.polysView.length; z++)
        R[z] = Number(u.polysView[z]);
      d.getPolys().setData(R);
    } else if (s.stlNegativeData) {
      const X = ((N = n.getSleeve()) == null ? void 0 : N.sleeveExtRadius) || s.dExternal / 2;
      d = Lo(s.stlNegativeData.data, "stl");
      let C = l / 2;
      C = (X + C) / X, ut.fromScaling(h, I.fromValues(C, C, 1));
    }
    let Z = Pe.eOT_UNKNOWN;
    r == 1 ? Z = Pe.eOT_PIN_SUPPORT : r == 7 ? Z = Pe.eOT_PIN_EXTRUSION_UPPER : r == 8 && (Z = Pe.eOT_PIN_EXTRUSION_LOWER);
    const g = new kd({
      stlData: ((W = s.stlNegativeData) == null ? void 0 : W.data) || new Int8Array(),
      context: e,
      polydata: d,
      implant: n,
      matrix: ut.create(),
      sleeveInfo: s,
      sleeveBuilder: u,
      oType: Z,
      part: r,
      scaleMatrix: h
    });
    if (g.visibility = !1, g.locked = !0, g.updatePosition(), (r == 1 || !s.stlNegativeData) && u && (u.CalculateFreeFormGeometry(new Float32Array(g.getMatrix())), r == 1)) {
      const X = u.GetGuideTop().slice();
      g.guideTop = I.fromValues(X[0], X[1], X[2]);
      const C = u.GetGuideNormal().slice();
      g.guideDir = I.fromValues(C[0], C[1], C[2]);
      const R = u.GetGuideBiNormal().slice();
      g.guideBiDir = I.fromValues(R[0], R[1], R[2]), g.guideHeight = u.GetGuideHeight();
    }
    return r == 1 && (g.isSupport = !0), (x = n.wasmStlObject) == null || x.SetIsParametricObject(!s.stlNegativeData), (V = n.wasmStlObject) == null || V.SetModelObjById(g.id, g.cadType), g.setColor(p), g;
  }
  onViewWidgetEvent(e, n) {
    super.onViewWidgetEvent(e, n);
  }
  delete(e) {
    var n, s;
    super.delete(e), (n = this.implant.wasmStlObject) == null || n.ClearModelObj(this.cadType), this.implant.removeFromSupportObjects(this.id), this.context.objects.stls.delete(this.id), (s = this.sleeveBuilder) == null || s.delete();
  }
  updateObject(e, n, s) {
    var h, p, m, b;
    const r = this.sleeveInfo, a = this.implant;
    let o = Ie.newInstance(), l;
    a.isImplant() ? l = e : l = n;
    const c = l / 2;
    let u = r.distanceFromImplant;
    if ((this.part == 1 || this.part == 7 || !r.stlNegativeData) && this.sleeveBuilder) {
      if (u = r.distanceFromImplant, this.part == 1 && r.stlNegativeData && !a.isImplant()) {
        const f = (h = a.getSleeve()) == null ? void 0 : h.getBounds()[4];
        f && (u = f);
      }
      const y = ((p = a.getSleeve()) == null ? void 0 : p.sleeveExtRadius) || r.dExternal / 2, Z = ((m = a.getSleeve()) == null ? void 0 : m.sleeveLength) || r.lSleeve;
      this.sleeveBuilder.CreateVTKObjects(
        y,
        c,
        //info.dInternal / 2,
        a.isImplant() ? 30 : 40,
        // height = guide_length-> Implant -> 30, pim -> 40
        u,
        //info.distanceFromImplant,
        Z,
        jS(r, a.isImplant()),
        r.lLip,
        r.lCut,
        r.rotationAll ?? 0,
        r.rotationCut ?? 0,
        a.isImplant() ? 0 : 1,
        // isFixationPin
        this.part,
        0,
        // visualization
        s
      ), o.getPoints().setData(this.sleeveBuilder.pointsView);
      const g = new Uint32Array(this.sleeveBuilder.polysView.length);
      for (let f = 0; f < this.sleeveBuilder.polysView.length; f++)
        g[f] = Number(this.sleeveBuilder.polysView[f]);
      o.getPolys().setData(g);
    } else if (r.stlNegativeData) {
      const y = ((b = a.getSleeve()) == null ? void 0 : b.sleeveExtRadius) || r.dExternal / 2;
      o = Lo(r.stlNegativeData.data, "stl");
      let Z = s / 2;
      Z = (y + Z) / y, ut.fromScaling(this.scaleMatrix, I.fromValues(Z, Z, 1));
    }
    const d = !0;
    if (this.wasmStlObject ? (du(this.wasmStlObject, o, d, !1, !1, d), $o(this.wasmStlObject, this.matrix), this.wasmStlObject.SetMeshSplitting(!0), Cr(this.wasmStlObject, this.polydata, d)) : console.error("Wasm object not found for guide object"), this.updatePosition(), (this.part == 1 || !r.stlNegativeData) && this.sleeveBuilder && (this.sleeveBuilder.CalculateFreeFormGeometry(new Float32Array(this.getMatrix())), this.part == 1)) {
      const y = this.sleeveBuilder.GetGuideTop().slice();
      this.guideTop = I.fromValues(y[0], y[1], y[2]);
      const Z = this.sleeveBuilder.GetGuideNormal().slice();
      this.guideDir = I.fromValues(Z[0], Z[1], Z[2]);
      const g = this.sleeveBuilder.GetGuideBiNormal().slice();
      this.guideBiDir = I.fromValues(g[0], g[1], g[2]), this.guideHeight = this.sleeveBuilder.GetGuideHeight();
    }
    this.polydata.modified();
  }
  /** Calculate transform matrix for sleeve relative to implant */
  calculateRelativePosition() {
    const e = ut.create(), n = (this.implant.isImplant() ? 30 : 40) / 2, s = this.implant.isImplant() ? this.implant.getImplantInfo().implantInfo.implantConnectorHeight : 0, r = this.implant.isImplant() ? this.implant.getBounds()[5] : this.implant.getBounds()[4];
    let a;
    this.part == 8 && this.sleeveInfo.stlNegativeData ? a = this.sleeveInfo.distanceFromImplant - s - 1e-3 : a = n - s;
    const o = r + a;
    if (this.implant.isImplant()) {
      const l = this.sleeveInfo.connectionIndex, c = this.implant.getProjectImplantInfo().connectionSides;
      l && c && (console.warn("Check if rotation of guide support works correctly"), ut.rotateZ(e, e, xW(360 * l / c)));
    }
    return ut.mul(e, e, this.scaleMatrix), ut.translate(e, e, [0, 0, o]), e;
  }
  IsSupport() {
    return this.isSupport;
  }
  updatePosition() {
    const e = this.implant.getMatrix(), n = this.calculateRelativePosition();
    ut.mul(n, e, n), this.setMatrix(n);
  }
  getSleeveInfo() {
    return this.sleeveInfo;
  }
  getGuideTop() {
    return this.guideTop;
  }
  getGuideNormal() {
    return this.guideDir;
  }
  getGuideBiNormal() {
    return this.guideBiDir;
  }
  getGuideHeight() {
    return this.guideHeight;
  }
  setToothSelected(e) {
    var n;
    (n = this.wasmStlObject) == null || n.SetToothSelected(e);
  }
}
var UC = /* @__PURE__ */ ((i) => (i[i.LOWER_JAW = 0] = "LOWER_JAW", i[i.UPPER_JAW = 1] = "UPPER_JAW", i[i.LOWER_WAXUP = 2] = "LOWER_WAXUP", i[i.UPPER_WAXUP = 3] = "UPPER_WAXUP", i[i.LOWER_GINGIVA = 4] = "LOWER_GINGIVA", i[i.UPPER_GINGIVA = 5] = "UPPER_GINGIVA", i[i.LOWER_MARKER = 6] = "LOWER_MARKER", i[i.UPPER_MARKER = 7] = "UPPER_MARKER", i[i.MOVEMENT_SCAN_MARKER = 8] = "MOVEMENT_SCAN_MARKER", i[i.FACE_SCAN = 9] = "FACE_SCAN", i[i.GENERIC = 10] = "GENERIC", i[i.TOOTH = 11] = "TOOTH", i))(UC || {});
const tOt = te(() => [
  {
    label: jt("medic-web-engine.lowerJaw"),
    value: 0
    /* LOWER_JAW */
  },
  {
    label: jt("medic-web-engine.upperJaw"),
    value: 1
    /* UPPER_JAW */
  },
  {
    label: jt("medic-web-engine.lowerWaxup"),
    value: 2
    /* LOWER_WAXUP */
  },
  {
    label: jt("medic-web-engine.upperWaxup"),
    value: 3
    /* UPPER_WAXUP */
  },
  {
    label: jt("medic-web-engine.lowerGingiva"),
    value: 4
    /* LOWER_GINGIVA */
  },
  {
    label: jt("medic-web-engine.upperGingiva"),
    value: 5
    /* UPPER_GINGIVA */
  },
  {
    label: jt("medic-web-engine.lowerMarker"),
    value: 6
    /* LOWER_MARKER */
  },
  {
    label: jt("medic-web-engine.upperMarker"),
    value: 7
    /* UPPER_MARKER */
  },
  {
    label: jt("medic-web-engine.movementScanMarker"),
    value: 8
    /* MOVEMENT_SCAN_MARKER */
  },
  {
    label: jt("medic-web-engine.faceScan"),
    value: 9
    /* FACE_SCAN */
  },
  {
    label: jt("medic-web-engine.generic"),
    value: 10
    /* GENERIC */
  },
  {
    label: jt("shared.tooth"),
    value: 11
    /* TOOTH */
  }
]);
class mNt {
  constructor() {
    S(this, "root", { tag: "", children: [], childMap: /* @__PURE__ */ new Map() });
    S(this, "encoder", new TextEncoder());
  }
  setData(t, e) {
    let n = this.root;
    for (const s of t) {
      let r = n.childMap.get(s);
      r || (r = { tag: s, children: [], childMap: /* @__PURE__ */ new Map() }, n.childMap.set(s, r), n.children.push(r)), n = r;
    }
    n.data = e;
  }
  toBytes() {
    const t = [];
    for (const e of this.root.children)
      this.writeNode(e, 0, t);
    return this.concatChunks(t);
  }
  writeNode(t, e, n) {
    const s = "   ".repeat(e);
    if (t.children.length) {
      this.pushString(n, `${s}<${t.tag}>\r
`);
      for (const a of t.children)
        this.writeNode(a, e + 1, n);
      this.pushString(n, `${s}</${t.tag}>\r
`);
      return;
    }
    const r = t.data ?? new Uint8Array();
    this.pushString(n, `${s}<${t.tag} len=${r.length}>`), n.push(r), this.pushString(n, `</${t.tag}>\r
`);
  }
  pushString(t, e) {
    t.push(this.encoder.encode(e));
  }
  concatChunks(t) {
    let e = 0;
    for (const r of t)
      e += r.length;
    const n = new Uint8Array(e);
    let s = 0;
    for (const r of t)
      n.set(r, s), s += r.length;
    return n;
  }
}
function Pa(i) {
  return i.map((t) => t * 255);
}
function Kn(i) {
  return i.map((t) => t / 255);
}
class bNt extends Map {
  getByTooth(t) {
    for (const n of this.values())
      if (n.getName() === t)
        return n;
    const e = parseInt(t);
    for (const n of this.values())
      if (n.getTooth() === e)
        return n;
  }
  deleteByTooth(t) {
    for (const n of this.values())
      if (n.getName() === t) {
        this.delete(n.id), n.delete();
        return;
      }
    const e = parseInt(t);
    for (const n of this.values())
      if (n.getTooth() === e) {
        this.delete(n.id), n.delete();
        return;
      }
  }
  getByActor(t) {
    var e, n, s, r;
    for (const a of this.values())
      if (a.isActorObject(t) != null || ((e = a.getAbutment()) == null ? void 0 : e.isActorObject(t)) != null || ((n = a.getSleeve()) == null ? void 0 : n.isActorObject(t)) != null || ((s = a.getCenterLine(!1)) == null ? void 0 : s.getActor()) == t || ((r = a.getCenterLine(!0)) == null ? void 0 : r.getActor()) == t)
        return a.id;
    return null;
  }
}
class fNt extends Map {
  getByName(t) {
    for (const e of this.values())
      if (e.getName() === t)
        return e;
  }
  getIdByName(t) {
    for (const e of this.values())
      if (e.getName() === t)
        return e.id;
    return "";
  }
  getByActor(t) {
    var e;
    for (const n of this.values())
      if (n.isActorObject(t) != null || ((e = n.getSleeve()) == null ? void 0 : e.isActorObject(t)) != null)
        return n.id;
    return null;
  }
}
class gA {
  constructor(t) {
    S(this, "context");
    S(this, "implants", new bNt());
    S(this, "pins", new fNt());
    S(this, "volumes", /* @__PURE__ */ new Map());
    S(this, "stls", /* @__PURE__ */ new Map());
    S(this, "tmpStls", /* @__PURE__ */ new Map());
    S(this, "tmpStlFilePaths", /* @__PURE__ */ new Map());
    S(this, "images2D", /* @__PURE__ */ new Map());
    S(this, "toothMarkers", /* @__PURE__ */ new Map());
    S(this, "stlsMatching", /* @__PURE__ */ new Map());
    S(this, "object3DInfos", new qt([]));
    S(this, "mappers", []);
    S(this, "actors", []);
    S(this, "actorIds", /* @__PURE__ */ new Map());
    S(this, "selectedObject", new qt(null));
    S(this, "updateImplantPlannerGUIEvent", new se());
    S(this, "object3DColorChangedEvent", new se());
    S(this, "startPos", I.create());
    S(this, "endPos", I.create());
    S(this, "nerveObjects", /* @__PURE__ */ new Map());
    S(this, "CPRCurve");
    S(this, "onStlVisibilityChanged", new se());
    S(this, "onStlColorChanged", new se());
    S(this, "measurementsObjects", new qt(/* @__PURE__ */ new Map()));
    S(this, "previousMinNerveDist");
    S(this, "previousSecurityZone");
    // objects loaded from project that are currently not supported by webcad
    // stored here so they can be saved back to project
    // type: JsonProjectObject[]
    S(this, "unsupportedProjectStlObjects", []);
    S(this, "projectCollection2D", {
      objects: [],
      iAngleAdded: 0,
      iAnnotAdded: 0,
      iDistanceAdded: 0,
      iPolyAdded: 0
    });
    S(this, "cprFromProject", {
      points: [],
      splineVec: [],
      splineNormals: [],
      splineTangents: [],
      splineBinormals: [],
      owner: {
        o: [0, 0, 0],
        n: [0, 0, 0],
        s: [0, 0, 0],
        t: [0, 0, 0]
      },
      name: "",
      color: [1, 1, 1],
      maxilla0Mandible: xo.MAXILLA
    });
    S(this, "cprImage", null);
    S(this, "isModified", !1);
    S(this, "rptCPRSize", [0, 0]);
    S(this, "rptFrontalSize", [0, 0]);
    S(this, "rptTemplateName", "");
    S(this, "rptBackgroundColor", [0, 0, 0]);
    S(this, "reactivity", An());
    S(this, "watch", this.reactivity.watch);
    S(this, "onCleanupArray", []);
    S(this, "onCleanup", (t) => {
      this.onCleanupArray.push(t);
    });
    this.context = t, this.previousMinNerveDist = this.context.settings.implants.minimumDistanceFromNerveMm, this.previousSecurityZone = this.context.settings.implants.securityZoneSizeMm, this.reactivity.onEvent(this.onStlVisibilityChanged, ({ id: e }) => {
      const n = this.getStlObject(e);
      if (!n) return;
      const s = this.context.getState().object3DInfos.get().find((r) => r.id === e);
      s && (s.visible = n.getVisibility(), this.context.objects.object3DInfos.modified());
    }), this.reactivity.onEvent(this.onStlColorChanged, ({ id: e }) => {
      const n = this.getStlObject(e);
      if (!n) return;
      const s = this.context.getState().object3DInfos.get().find((r) => r.id === e);
      s && (s.color = Pa(n.getDisplayedColor()), this.context.objects.object3DInfos.modified());
    }), this.reactivity.onEvent(this.context.settings.onSettingsModified, () => {
      this.implants.forEach((e) => {
        var n;
        e.updateCollisionZone(), (n = e.getSleeve()) == null || n.setColor(Kn(this.context.settings.defaultColors.sleeves));
      }), this.pins.forEach((e) => {
        var n;
        (n = e.getSleeve()) == null || n.setColor(Kn(this.context.settings.defaultColors.sleeves));
      }), this.nerveObjects.forEach((e) => {
        e.nerve.updateCollisionZone(), e.nerve.setColor(Kn(this.context.settings.defaultColors.nerves));
      }), this.stls.forEach((e) => {
        e instanceof vn && (e.type === Yt._STL_TOOTH ? e.setColor(Kn(this.context.settings.defaultColors.teeth)) : e.isAnatomyObject() ? e.setColor(Kn(this.context.settings.defaultColors.teethScanStl)) : e.isAntagonistObject() ? e.setColor(Kn(this.context.settings.defaultColors.prosthesisScanStl)) : (e.cadType === Pe.eOT_SURGICAL_GUIDE || e.getName() === "Surgical Guide") && e.setColor(Kn(this.context.settings.defaultColors.guides)));
      }), this.CPRCurve.setColor(Kn(this.context.settings.defaultColors.cprColor)), (this.context.settings.implants.minimumDistanceFromNerveMm != this.previousMinNerveDist && this.context.settings.implants.nerveWarning || this.context.settings.implants.securityZoneSizeMm != this.previousSecurityZone && this.context.settings.implants.securityZone) && (this.previousMinNerveDist = this.context.settings.implants.minimumDistanceFromNerveMm, this.previousSecurityZone = this.context.settings.implants.securityZoneSizeMm, this.checkCollisions());
    }), this.CPRCurve = new EW(this.context, void 0, { color: Kn(this.context.settings.defaultColors.cprColor), lineWidth: 2 });
  }
  scaleVectorFromImplantPlanner(t) {
    const e = f5(this.context.getImageData().getOrigin(), this.context.getMinSpacing(), !1), n = I.create();
    return I.transformMat4(n, t, e), n;
  }
  scaleVectorToImplantPlanner(t) {
    const e = f5(this.context.getImageData().getOrigin(), this.context.getMinSpacing(), !0), n = I.create();
    return I.transformMat4(n, t, e), n;
  }
  remapBookmarksFromProject() {
    this.context.projectBookmarks.layout.bookmarks.forEach((t) => {
      let e = Jn.VOI_SETTINGS;
      switch (t.layoutType) {
        case 12:
          e = Jn.VOI_SETTINGS;
          break;
        case 13:
          e = Jn.THREED_SETTINGS;
          break;
        case 29:
          e = Jn.DATA_IMPORT;
          break;
        case 15:
          e = Jn.CPR_SETTINGS;
          break;
        case 16:
          e = Jn.NERVE_DRAWING;
          break;
        case 17:
          e = Jn.TEETH_SETUP;
          break;
        case 8:
          e = Jn.IMPLANT_PLANNING;
          break;
        case 27:
          e = Jn.REPORTS_EXPORT;
          break;
        case 11:
          e = Jn.ADVANCED_TOOLS;
          break;
        case 28:
          e = Jn.OBJECT_LIST;
          break;
        case 23:
          e = Jn.GUIDE_DESIGN;
          break;
        case 24:
          e = Jn.CREATE_MODEL;
          break;
        case 79:
          e = Jn.SANDBOX;
          break;
        case 44:
          e = Jn.PROJECT_SETUP;
          break;
        case 46:
          e = Jn.RECONSTRUCTION_SETUP;
          break;
      }
      t.layoutType = e;
      const n = dTt(t.desktopType) ?? Yn._3D_MPR;
      t.desktopType = n;
    });
  }
  remapBookmarksToProject(t) {
    return t.layout.bookmarks.forEach((e) => {
      let n = 12;
      switch (e.layoutType) {
        case Jn.VOI_SETTINGS:
          n = 12;
          break;
        case Jn.THREED_SETTINGS:
          n = 13;
          break;
        case Jn.DATA_IMPORT:
          n = 29;
          break;
        case Jn.CPR_SETTINGS:
          n = 15;
          break;
        case Jn.NERVE_DRAWING:
          n = 16;
          break;
        case Jn.TEETH_SETUP:
          n = 17;
          break;
        case Jn.IMPLANT_PLANNING:
          n = 8;
          break;
        case Jn.REPORTS_EXPORT:
          n = 27;
          break;
        case Jn.ADVANCED_TOOLS:
          n = 11;
          break;
        case Jn.OBJECT_LIST:
          n = 28;
          break;
        case Jn.GUIDE_DESIGN:
          n = 23;
          break;
        case Jn.CREATE_MODEL:
          n = 24;
          break;
        case Jn.SANDBOX:
          n = 79;
          break;
        case Jn.PROJECT_SETUP:
          n = 44;
          break;
        case Jn.RECONSTRUCTION_SETUP:
          n = 46;
          break;
      }
      e.layoutType = n;
      const s = hTt(e.desktopType) ?? YJ._MPR_3D_VIEW;
      return e.desktopType = s, e;
    }), t;
  }
  snapToObject(t) {
    const e = this.implants.get(t) || this.pins.get(t) || this.pins.getByName(t) || this.stls.get(t);
    if (e) {
      const n = e.getPosition(), s = e.getNormal(), r = e.getTangent(), a = e.getBinormal();
      this.context.toolManager.coordControl.snapToObject(n, s, a, r, e.type);
    }
  }
  selectImplant(t, e = !0) {
    const n = this.implants.getByTooth(t);
    n && this.selectObject(n.id, e);
  }
  selectPin(t, e = !0) {
    const n = this.pins.getByName(t);
    n && this.selectObject(n.id, e);
  }
  selectObject(t, e = !0) {
    e && this.snapToObject(t);
    let n = !1;
    const s = this.implants.get(t) || this.pins.get(t) || this.pins.getByName(t) || this.stls.get(t);
    if (s && (this.selectedObject.get() != s && (this.selectedObject.update(() => s), this.updateHandles()), n = !0), !n) {
      console.warn("Could not find object!");
      return;
    }
  }
  unSelectObject() {
    return this.selectedObject.get() != null ? (this.selectedObject.update(() => null), this.updateHandles(), !0) : !1;
  }
  addProjectImplant(t) {
    this.addImplant(t);
  }
  projectImplantMemory(t) {
    var r, a, o, l;
    const e = t.implantInfo.stlFile.data.length, n = ((a = (r = t.abutment) == null ? void 0 : r.stlFile) == null ? void 0 : a.data.length) || 0, s = ((l = (o = t.sleeveInfo) == null ? void 0 : o.stlData) == null ? void 0 : l.data.length) || 0;
    return e + n + s >> 10;
  }
  addImplant(t, e) {
    const n = h0.fromProjectImplant(this.context, t, e);
    n.setLocked(!1), n.setVisibility(!0), this.implants.set(n.id, n), this.updateImplantPlannerGUIEvent.notify(null), this.isModified = !0;
  }
  replaceImplant(t, e, n) {
    const s = this.getImplantByToothName(t.name), r = s == null ? void 0 : s.getTop(0, !0), a = s == null ? void 0 : s.getMatrix(), o = s == null ? void 0 : s.id;
    if (o && this.removeImplant(o), this.addImplant(t, n), e) {
      const l = this.getImplantByToothName(t.name);
      if (a && (l == null || l.setMatrix(a)), r && l) {
        const c = l.getTop(0, !0), u = l.getPosition(), d = I.create();
        I.sub(d, r, c), I.add(u, u, d), l.moveTo(u);
      }
    }
  }
  removeImplant(t) {
    const e = this.implants.get(t);
    this.selectedObject.get() == e && this.selectedObject.set(null), e && e.delete(), this.implants.delete(t), this.isModified = !0;
  }
  addPin(t, e = !1) {
    const n = jC.fromProjectPin(this.context, t, { ignoreScaling: e });
    n.setLocked(!1), this.pins.set(n.id, n), this.isModified = !0;
  }
  replacePin(t) {
    var o;
    let e;
    const n = this.pins.getByName(t.name), s = n == null ? void 0 : n.id;
    n && (e = n.getMatrix());
    const r = s ? (o = this.context.getState().object3DInfos.get().find((l) => l.id === s)) == null ? void 0 : o.position : void 0;
    s && this.removePin(s), this.addPin(t, !0);
    const a = this.pins.getByName(t.name);
    a && e && a.setMatrix(e), a && r && this.moveObject(a.id, r), this.selectObject(t.name);
  }
  removePin(t) {
    const e = this.pins.get(t) || this.pins.getByName(t);
    if (!e)
      return;
    const n = e.getName(), s = e.toProjectPin().pin, r = s.pinInfo.stlFile.data.length >> 10, a = new vr({
      onUndo: () => {
        this.addPin(s, !1);
      },
      onRedo: () => {
        const o = this.pins.getIdByName(n), l = o ? this.pins.get(o) : void 0;
        l == null || l.delete(), o && this.pins.delete(o);
      },
      getMemory: () => r
    });
    this.context.undoManager.isPush() ? this.context.undoManager.add(this, a) : this.context.undoManager.pushPop(this, a, "Undo Delete Object", ws.SCENE_REPAINT), e.delete(), this.pins.delete(e.id), this.pins.delete(this.pins.getIdByName(n)), this.selectedObject.set(null), this.isModified = !0;
  }
  removeSTL(t) {
    const e = this.stls.get(t);
    if (e && !e.IsVolume()) {
      const n = e.type === Yt._STL_TOOTH, s = n ? e.getName() : "", r = n ? [...this.toothMarkers.values()].filter((d) => d.getName() === s) : [], a = r.map((d) => d.toProjectToothMarkerObject()), o = [], l = e.toProjectStlObject(), c = e.isPly, u = t;
      if (e && l) {
        const d = new vr({
          onUndo: () => {
            this.addSTL(l, { ignoreScaling: !1, ply: c, forcedIid: u }), o.length = 0;
            for (const h of a) {
              const p = zW.fromProjectToothMarker(this.context, h, { ignoreScaling: !1 });
              this.toothMarkers.set(p.id, p), o.push(p.id);
            }
          },
          onRedo: () => {
            const h = this.stls.get(u);
            if (h && (h.delete(), this.stls.delete(u)), n) {
              for (const p of o) {
                const m = this.toothMarkers.get(p);
                m && m.delete();
              }
              o.length = 0;
            }
          },
          getMemory: () => l.implantInfo.stlFile.data.length >> 10
        });
        this.context.undoManager.isPush() ? this.context.undoManager.add(this, d) : this.context.undoManager.pushPop(this, d, "Undo Delete Object", ws.SCENE_REPAINT), e.delete();
      }
      this.stls.delete(t);
      for (const d of r)
        d.delete();
    } else e && e.IsVolume() && e.delete();
    this.isModified = !0;
  }
  duplicateSTL(t) {
    const e = this.getStlObject(t);
    if (e instanceof vn) {
      if (e.type == Yt._STL_OBJECT || e.type == Yt._STL_TEETH_MODEL || e.type == Yt._STL_PROSTHESIS || e.type == Yt._STL_TOOTH) {
        const n = e, s = n.toClonedProjectStlObject();
        if (e.type == Yt._STL_TOOTH && (s.objectType = Yt._STL_OBJECT), n.isAnatomyObject()) {
          const a = "Other", o = e.getDisplayText() || e.getName();
          let l = o, c = 1;
          for (; this.findStlByNameAndDisplayText(a, l, !0); )
            l = `${o}_${c++}`;
          s.name = a, s.displayText = l, s.objectType = Yt._STL_OBJECT, s.objectSubType = Yt._STL_OBJECT;
        } else
          s.name = s.name + "_copy", s.displayText = "";
        const r = e.isPly;
        return this.addSTL(s, { ignoreScaling: !1, ply: r }), !0;
      }
      return !1;
    } else
      return !1;
  }
  addToothMarker(t, e) {
    const n = new zW(this.context, t, e, h2t());
    return this.toothMarkers.set(n.id, n), this.isModified = !0, n;
  }
  getObject3dInfoById(t) {
    let e = null;
    return this.context.getState().object3DInfos.get().forEach((n) => {
      n.id == t && (e = n);
    }), e;
  }
  getObjectVolume(t) {
    const e = this.getStlObject(t);
    if (e && !e.IsVolume() && e.wasmStlObject) {
      const n = e.wasmStlObject.CalculateObjectVolume();
      this.context.warningString.set(jt("medic-web-engine.volumeValue", { value: n.toFixed(2) })), e.wasmStlObject.VolumeCalculationFlag && this.context.warningString.set(jt("medic-web-engine.approximateVolume", { value: n.toFixed(2) })), this.context.warningDialogEvent.notify(jt("shared.information"));
    } else if (e && e.IsVolume() && e.wasmVolumeObject) {
      const n = e.wasmVolumeObject.CalculateObjectVolume();
      this.context.warningString.set(jt("medic-web-engine.volumeValue", { value: n.toFixed(2) })), e.wasmVolumeObject.VolumeCalculationFlag && this.context.warningString.set(jt("medic-web-engine.approximateVolume", { value: n.toFixed(2) })), this.context.warningDialogEvent.notify(jt("shared.information"));
    } else
      console.warn("Object or wasmStlObject not found!");
  }
  getImplantObjectData() {
    const t = [];
    for (const e of this.implants.values())
      t.push(e.toProjectImplantParts());
    return t;
  }
  getMarkerByTooth(t) {
    for (const e of this.toothMarkers.values())
      if (parseInt(e.getName()) === t)
        return e;
  }
  getMarkerByToothName(t) {
    for (const e of this.toothMarkers.values())
      if (e.getName() === t)
        return e;
  }
  getImplantByTooth(t) {
    for (const e of this.implants.values())
      if (e.getTooth() === t)
        return e;
  }
  getImplantByToothName(t) {
    return this.implants.getByTooth(t);
  }
  convertToothNames(t, e) {
    if (t !== e) {
      for (const n of this.implants.values()) {
        const s = rS(n.getName(), t, e);
        s !== n.getName() && n.setTooth(s);
      }
      for (const n of this.toothMarkers.values()) {
        const s = rS(n.getName(), t, e);
        s !== n.getName() && n.setPositionAndText(n.getPosition(), s);
      }
      for (const n of this.stls.values()) {
        if (n.type !== Yt._STL_TOOTH)
          continue;
        const s = rS(n.getName(), t, e);
        s !== n.getName() && n.setName(s);
      }
    }
  }
  getPinByIndex(t) {
    for (const e of this.pins.values())
      if (e.getPinIndex() === t)
        return e;
  }
  getImplantObjectDataById(t) {
    var e;
    return (e = this.implants.get(t)) == null ? void 0 : e.toProjectImplantParts();
  }
  getPinObjectData() {
    const t = [];
    for (const e of this.pins.values())
      t.push(e.toProjectPin());
    return t;
  }
  // for data import wizard
  getStlObjectList() {
    const t = [];
    for (const e of this.stls.values())
      t.push(e);
    return t;
  }
  addVolume(t, e, n, s) {
    this.isModified = !0;
    const r = new cA({ context: this.context, fPath: t, name: e, objectType: s });
    n && r.wasmVolumeObject && r.wasmVolumeObject.SetObtainedByThreshold(n), s == Pe.eOT_SEGMENTED_BONE && r.setColor([228 / 255, 201 / 255, 168 / 255]), r.setLocked(!0);
    const a = r.id;
    return this.stls.set(a, r), r.update3dInfo(), r;
  }
  setSTLName(t, e) {
    const n = this.stls.get(t);
    if (n) {
      const s = n.isTrackedObject();
      n.setDisplayText(e), n.update3dInfo(), n.setTracked(s);
    }
  }
  setSTLType(t, e) {
    const n = this.stls.get(t);
    if (n instanceof vn) {
      const s = n.type, r = n.getName();
      e == "Anatomy" && this.findAnatomyObject(t) ? (this.context.warningString.set(jt("medic-web-engine.anatomyObjectExists")), this.context.warningDialogEvent.notify(jt("implant-planner.warning"))) : (e === "Anatomy" ? n.type = Yt._STL_TEETH_MODEL : e === "Waxup-Prosthesis" ? n.type = Yt._STL_PROSTHESIS : n.type = Yt._STL_OBJECT, n.setName(e), n.update3dInfo(), (n.isAnatomyCollisionObject() || s === Yt._STL_TEETH_MODEL || r === "Antagonist") && this.checkCollisions());
    }
  }
  findAnatomyObject(t) {
    for (const e of this.stls.values())
      if (e instanceof vn && e.id !== t && !e.IsVolume() && e.isAnatomyObject())
        return e;
    return null;
  }
  findAntagonistObject(t) {
    for (const e of this.stls.values())
      if (e instanceof vn && e.id !== t && !e.IsVolume() && e.isAntagonistObject())
        return e;
    return null;
  }
  findStlByDisplayText(t, e = !1) {
    for (const [n, s] of this.stls)
      if ((!e || e && !s.IsVolume()) && s.getDisplayText() == t)
        return s;
    return null;
  }
  findStlByName(t, e = !1) {
    for (const [n, s] of this.stls)
      if ((!e || e && !s.IsVolume()) && s.getName() == t)
        return s;
    return null;
  }
  findStlByNameAndDisplayText(t, e, n = !1) {
    for (const [s, r] of this.stls)
      if ((!n || n && !r.IsVolume()) && r.getName() == t && e == r.getDisplayText())
        return r;
    return null;
  }
  renameGuideObject(t, e) {
    let n = "";
    for (const a of this.implants.values())
      a.selectedForGuideDesign && (n += (n.length ? "-" : "") + a.getName());
    let s = n, r = 1;
    for (; this.context.objects.findStlByNameAndDisplayText(t.getName(), s); )
      s = n + "_" + r++;
    t.setDisplayText(s), t.update3dInfo(), e == null || e.setDisplayText(s), e == null || e.update3dInfo();
  }
  restoreSelectedForGuideDesign() {
    for (let [t, e] of this.context.objects.pins)
      e.toggleSelectedForGuideDesign(!0);
    for (let [t, e] of this.context.objects.implants)
      e.toggleSelectedForGuideDesign(!0);
  }
  async addOBJ(t) {
    this.isModified = !0;
    const e = await vn.fromProjectOBJObject(this.context, t), n = e.id;
    return this.stls.set(n, e), e.update3dInfo(), e.id;
  }
  addSTL(t, e) {
    const n = vn.fromProjectStlObject(this.context, t, e || {});
    n.setLocked(!0);
    const s = n.id;
    return this.stls.set(s, n), n.update3dInfo(), this.isModified = !0, n.id;
  }
  addMatchingSTL(t, e) {
    this.isModified = !0;
    const n = vn.copyStlObject(this.context, t, e == null ? void 0 : e.hasTexture);
    return n.setMatrix(t.getMatrix()), n.setPickable(!0), n.setLocked(!0), n;
  }
  async setupObject(t, e, n, s, r) {
    const a = Ue.newInstance(), o = Re.newInstance();
    if (s) {
      const c = VI(t.implantInfo.stlFile.data);
      a.setInputConnection(c.getOutputPort());
    } else if (r) {
      const c = new File([new Int8Array(t.implantInfo.stlFile.data)], "file.obj"), u = await EG(c);
      a.setInputConnection(u.getOutputPort());
    } else {
      const c = LI(t.implantInfo.stlFile.data);
      c.getOutputData().getCellData().removeAllArrays(), c.getOutputData().getPointData().removeAllArrays(), a.setInputConnection(c.getOutputPort());
    }
    o.setMapper(a), s ? a.setScalarVisibility(!0) : o.getProperty().setColor(t.color.map((c) => c / 255)), t.opacity !== void 0 && o.getProperty().setOpacity(t.opacity), e && abt(t.origin, t.normal, t.viewUp, o, n), this.mappers.push(a), this.actors.push(o), this.context.onObjectsModified.notify(), this.context.onActorAdded.notify({ actor: o, objectType: t.objectType });
    const l = nl();
    return this.actorIds.set(o, l), {
      ...t,
      mapper: a,
      actor: o,
      id: l
    };
  }
  addVtkObject(t) {
    const { mapper: e, actor: n, objectType: s } = t;
    this.mappers.push(e), this.actors.push(n), this.context.onActorAdded.notify({ actor: n, objectType: s });
  }
  addVtkImage(t) {
    const { mapper: e, actor: n } = t;
    this.mappers.push(e), this.actors.push(n);
  }
  addVtkImageSlice(t) {
    const { mapper: e, actor: n } = t;
    this.mappers.push(e), this.actors.push(n);
  }
  removeActor(t) {
    const e = this.actors.indexOf(t);
    e !== -1 && this.actors.splice(e, 1);
  }
  removeImplantObjectByTooth(t, e) {
    const n = this.getImplantByToothName(t);
    n && this.removeImplantObject(n, e);
  }
  removeImplantObjectById(t, e) {
    const n = this.implants.get(t);
    n && this.removeImplantObject(n, e);
  }
  removeImplantObject(t, e) {
    var n, s, r, a, o;
    if (this.isModified = !0, e === Yt._IMPLANT) {
      this.implants.delete(t.id);
      const l = t.getName(), c = t.toProjectImplantParts(), u = this.projectImplantMemory(c), d = new vr({
        onUndo: () => {
          this.addImplant(c);
        },
        onRedo: () => {
          this.implants.deleteByTooth(l);
        },
        getMemory: () => u
      });
      this.context.undoManager.isPush() ? this.context.undoManager.add(this, d) : this.context.undoManager.pushPop(this, d, "Remove Implant" + t.id, ws.SCENE_REFRESH), t.delete(), this.selectedObject.set(null);
    } else e === Yt._ABUTMENT ? ((n = t.getAbutment()) == null || n.delete(), t.setAbutment(void 0)) : e === Yt._PRIMARY_SCAN_ABUTMENT ? ((s = t.getScanAbutment()) == null || s.delete(), t.setScanAbutment(void 0)) : e === Yt._SECONDARY_ABUTMENT ? ((r = t.getSecondaryAbutment()) == null || r.delete(), t.setSecondaryAbutment(void 0)) : e === Yt._SECONDARY_SCAN_ABUTMENT ? ((a = t.getSecondaryScanAbutment()) == null || a.delete(), t.setSecondaryScanAbutment(void 0)) : e === Yt._SLEEVE ? ((o = t.getSleeve()) == null || o.delete(), t.setSleeve(void 0)) : e === Yt._ANALOG_EXTRUSION && t.deleteExtrusionParts();
    this.updateImplantPlannerGUIEvent.notify(this.selectedObject.get()), this.context.repaint();
  }
  removeObject(t, e) {
    if (this.isModified = !0, e == null) {
      const n = this.getStlObject(t);
      n ? e = n.type : (console.error("Type not given and object not found"), e = Yt._NONE);
    }
    if (e === Yt._IMPLANT || e === Yt._ABUTMENT || e === Yt._PRIMARY_SCAN_ABUTMENT || e === Yt._SECONDARY_ABUTMENT || e === Yt._SECONDARY_SCAN_ABUTMENT || e === Yt._ANALOG_EXTRUSION || e === Yt._SLEEVE) {
      this.removeImplantObjectById(t, e);
      return;
    }
    if (e === Yt._PIN) {
      this.removePin(t);
      return;
    }
    if (e === Yt._STL_OBJECT || e === Yt._STL_TEETH_MODEL || e === Yt._STL_PROSTHESIS || e == Yt._STL_TOOTH || e == Yt._REFERENCE_PLANE) {
      this.removeSTL(t);
      return;
    }
    this.updateImplantPlannerGUIEvent.notify(this.selectedObject.get()), this.context.objects.object3DInfos.update((n) => {
      const s = n.findIndex((r) => r.id === t);
      return s !== -1 && n.splice(s, 1), n;
    }), this.context.sceneRepaint();
  }
  changeAngle(t, e, n) {
    const s = this.implants.getByTooth(t);
    s && s.SetRotation(Math.PI * e / 180, n);
  }
  removeMapper(t) {
    const e = this.mappers.indexOf(t);
    e !== -1 && this.mappers.splice(e, 1);
  }
  markerExists(t) {
    return this.getMarkerByToothName(t) !== void 0;
  }
  implantExists(t) {
    return this.getImplantByToothName(t) !== void 0;
  }
  pinExists(t) {
    return this.pins.getByName(t) !== void 0;
  }
  getActors() {
    return this.actors;
  }
  getStlObject(t) {
    var e;
    return ((e = this.nerveObjects.get(t)) == null ? void 0 : e.nerve) || this.implants.get(t) || this.pins.getByName(t) || this.pins.get(t) || this.stls.get(t) || this.volumes.get(t) || null;
  }
  getStlOrVolumeObject(t) {
    return this.stls.get(t) || this.volumes.get(t) || null;
  }
  // matching
  hideAllObjects(t, e) {
    var n, s, r;
    for (const a of this.stls.values())
      a.hideVisibility(), a.update3dInfo();
    if (!t) {
      for (const a of this.implants.values())
        (n = a.getSleeve()) == null || n.hideVisibility(), (s = a.getAbutment()) == null || s.hideVisibility(), a.hideVisibility(), a.update3dInfo();
      for (const a of this.pins.values())
        (r = a.getSleeve()) == null || r.hideVisibility(), a.hideVisibility(), a.update3dInfo();
      for (const a of this.nerveObjects.values())
        a.nerve.hideVisibility(), a.nerve.update3dInfo();
    }
    e || (this.context.sceneRepaint(), this.context.objects.object3DInfos.modified(), this.updateImplantPlannerGUIEvent.notify(this.selectedObject.get()));
  }
  restoreAllObjectsVisibility(t) {
    var e, n, s;
    for (const r of this.stls.values())
      r.restoreVisibility(), r.update3dInfo();
    if (!t) {
      for (const r of this.implants.values())
        r.restoreVisibility(), (e = r.getAbutment()) == null || e.restoreVisibility(), (n = r.getSleeve()) == null || n.restoreVisibility(), r.update3dInfo();
      for (const r of this.pins.values())
        r.restoreVisibility(), (s = r.getSleeve()) == null || s.restoreVisibility(), r.update3dInfo();
      for (const r of this.nerveObjects.values())
        r.nerve.restoreVisibility(), r.nerve.update3dInfo();
    }
    this.context.sceneRepaint(), this.context.objects.object3DInfos.modified(), this.updateImplantPlannerGUIEvent.notify(this.selectedObject.get());
  }
  // 3D Toolbar
  setAllObjectsVisibility(t, e) {
    var n, s, r;
    if (e === Yt._IMPLANT) {
      for (const a of this.implants.values())
        a.setVisibility(t, !0);
      this.updateImplantPlannerGUIEvent.notify(this.selectedObject.get());
      return;
    }
    if (e === Yt._ABUTMENT) {
      for (const a of this.implants.values())
        (n = a.getAbutment()) == null || n.setVisibility(t, !0), a.updatePosition();
      this.updateImplantPlannerGUIEvent.notify(this.selectedObject.get());
      return;
    }
    if (e === Yt._SLEEVE) {
      for (const a of this.implants.values())
        (s = a.getSleeve()) == null || s.setVisibility(t, !0), a.updatePosition();
      for (const a of this.pins.values())
        (r = a.getSleeve()) == null || r.setVisibility(t, !0), a.updatePosition();
      this.updateImplantPlannerGUIEvent.notify(this.selectedObject.get());
      return;
    }
    if (e === Yt._PIN) {
      for (const a of this.pins.values())
        a.setVisibility(t, !0);
      this.updateImplantPlannerGUIEvent.notify(this.selectedObject.get());
      return;
    }
  }
  // IPImplantPlanner.vue
  setImplantPartVisibility(t, e, n) {
    var r, a, o, l, c;
    const s = this.implants.getByTooth(t);
    s && (e === Yt._IMPLANT ? s.setVisibility(n) : e === Yt._ABUTMENT ? ((r = s.getAbutment()) == null || r.setVisibility(n), s.updatePosition()) : e === Yt._PRIMARY_SCAN_ABUTMENT ? ((a = s.getScanAbutment()) == null || a.setVisibility(n), s.updatePosition()) : e === Yt._SECONDARY_ABUTMENT ? ((o = s.getSecondaryAbutment()) == null || o.setVisibility(n), s.updatePosition()) : e === Yt._SECONDARY_SCAN_ABUTMENT ? ((l = s.getSecondaryScanAbutment()) == null || l.setVisibility(n), s.updatePosition()) : e === Yt._ANALOG_EXTRUSION ? s.updatePosition() : e === Yt._SLEEVE && ((c = s.getSleeve()) == null || c.setVisibility(n), s.updatePosition()), this.context.onObjectsModified.notify(), this.updateImplantPlannerGUIEvent.notify(this.selectedObject.get()), this.context.objects.object3DInfos.modified(), this.context.repaint());
  }
  //IPPinPlanning
  setObjectPartVisibility(t, e, n) {
    var s, r;
    if (e === Yt._PIN)
      this.setObjectVisibility(t, n);
    else if (e === Yt._SLEEVE) {
      const a = ((s = this.pins.get(t)) == null ? void 0 : s.getSleeve()) || ((r = this.pins.getByName(t)) == null ? void 0 : r.getSleeve());
      a && a.setVisibility(n), this.context.objects.object3DInfos.modified();
    }
    this.updateImplantPlannerGUIEvent.notify(this.selectedObject.get()), this.context.repaint();
  }
  // 3DImport --> STL + pinPlanning
  setObjectVisibility(t, e, n = !0) {
    var r;
    const s = ((r = this.nerveObjects.get(t)) == null ? void 0 : r.nerve) || this.implants.get(t) || this.pins.getByName(t) || this.pins.get(t) || this.stls.get(t);
    s && (s.setVisibility(e), this.context.objects.object3DInfos.modified()), this.updateImplantPlannerGUIEvent.notify(this.selectedObject.get()), n && this.context.repaint();
  }
  setObjectColor(t, e) {
    var s;
    const n = ((s = this.nerveObjects.get(t)) == null ? void 0 : s.nerve) || this.implants.get(t) || this.pins.get(t) || this.stls.get(t);
    if (n) {
      if (n.type === Yt._PIN)
        return;
      this.isModified = !0;
      const r = n.getColor(), a = Kn(e), o = (c) => n.setColor(c), l = new vr({
        onUndo: () => o(r),
        onRedo: () => o(a)
      });
      o(a), this.context.undoManager.pushPop(n, l, "Set Object Color", ws.NONE), this.object3DColorChangedEvent.notify(t);
      return;
    }
  }
  /**
   *
   * @param id
   * @param pickable
   * Set actors pickable property for object (nerve, stl, volume) with id.
   */
  setObjectPickable(t, e) {
    var s;
    const n = ((s = this.nerveObjects.get(t)) == null ? void 0 : s.nerve) || this.stls.get(t) || this.volumes.get(t);
    if (n) {
      n.setPickable(e);
      return;
    }
  }
  setObjectTransparency(t, e) {
    var s;
    this.isModified = !0;
    const n = ((s = this.nerveObjects.get(t)) == null ? void 0 : s.nerve) || this.implants.get(t) || this.pins.get(t) || this.stls.get(t);
    if (n) {
      const r = 1 - e / 100, a = n.getOpacity(), o = (c) => {
        var u, d, h, p;
        if (n.setOpacity(c), n.type === Yt._IMPLANT) {
          const m = n;
          (u = m.getAbutment()) == null || u.setOpacity(c), (d = m.getSleeve()) == null || d.setOpacity(c), (h = m.getCenterLine(!1)) == null || h.getActor().getProperty().setOpacity(c), (p = m.getCenterLine(!0)) == null || p.getActor().getProperty().setOpacity(c);
        }
      }, l = new vr({
        onUndo: () => o(a),
        onRedo: () => o(r)
      });
      o(r), this.context.undoManager.pushPop(n, l, "Set Object Opacity", ws.NONE);
      return;
    }
  }
  changeToothNumber(t, e) {
    this.isModified = !0;
    const n = this.implants.get(t);
    n && (n.setTooth(e), this.updateImplantPlannerGUIEvent.notify(this.selectedObject.get()));
  }
  setAxisParallelTo(t, e) {
    this.isModified = !0;
    const n = this.getImplantByToothName(e), s = this.implants.get(t);
    n && s && s.setAxisParallelTo(ut.clone(n.getMatrix()));
  }
  updateObjectPosition(t) {
    const e = this.implants.get(t) || this.pins.get(t);
    if (e) {
      e.updatePosition();
      return;
    }
  }
  startRotateObject(t, e) {
    I.set(this.startPos, e[0], e[1], e[2]);
  }
  rotateObject(t, e, n, s) {
    this.isModified = !0;
    const r = this.implants.get(t);
    if (r) {
      r.rotateImplant(this.startPos, this.endPos, e, n, s ? "top" : "bottom");
      return;
    }
    const a = this.pins.get(t);
    if (a) {
      a.rotatePin(this.startPos, this.endPos, e, n, s ? "top" : "bottom");
      return;
    }
  }
  updateHandles() {
    for (const t of this.implants.values())
      t.updateHandles();
  }
  updateHandlesById(t) {
    var e;
    (e = this.implants.get(t)) == null || e.updateHandles();
  }
  moveObject(t, e) {
    this.isModified = !0;
    const n = this.implants.get(t) || this.pins.get(t);
    if (!n) {
      this.moveSTL(t, e) || console.trace("move object: object not found");
      return;
    }
    n.getLocked() || n.moveTo(e);
  }
  moveSTL(t, e) {
    this.isModified = !0;
    const n = this.stls.get(t);
    if (!n)
      return console.warn("moveSTL: stl not found"), !1;
    if (n.getLocked())
      return !1;
    n.moveTo(e);
    const s = this.context.getState().object3DInfos.get().find((r) => r.id === t);
    return s ? (s.position = n.getPosition(), this.context.objects.object3DInfos.modified(), !0) : !1;
  }
  rotateStl(t, e, n, s) {
    this.isModified = !0;
    const r = this.stls.get(t);
    if (!r) {
      console.warn("moveSTL: stl not found");
      return;
    }
    if (r.getLocked())
      return;
    r.rotate(n, e, s), r.updateCrosssections(), this.context.getState().object3DInfos.get().find((o) => o.id === t) && this.context.objects.object3DInfos.modified();
  }
  getLockStatus(t) {
    const e = this.implants.get(t) || this.pins.getByName(t) || this.pins.get(t) || this.stls.get(t);
    return e ? e.getLocked() : null;
  }
  changeLockStatus(t, e) {
    const n = this.implants.get(t) || this.pins.getByName(t) || this.pins.get(t) || this.stls.get(t);
    if (n) {
      const s = new vr({
        onUndo: () => {
          n.setLocked(!e), this.context.objects.object3DInfos.modified(), this.updateImplantPlannerGUIEvent.notify(this.selectedObject.get()), setTimeout(() => {
            this.context.updateObject2DPositionEvent.notify();
          }, 0);
        },
        onRedo: () => {
          n.setLocked(e), this.context.objects.object3DInfos.modified(), this.updateImplantPlannerGUIEvent.notify(this.selectedObject.get()), setTimeout(() => {
            this.context.updateObject2DPositionEvent.notify();
          }, 0);
        }
      });
      this.context.undoManager.pushPop(n, s, "Change Lock Status", ws.NONE), n.setLocked(e), this.context.objects.object3DInfos.modified();
    }
    this.updateImplantPlannerGUIEvent.notify(this.selectedObject.get()), setTimeout(() => {
      this.context.updateObject2DPositionEvent.notify();
    }, 0);
  }
  lockUnlockAllImplantPins(t) {
    this.implants.forEach((e) => {
      e.setLocked(t);
    }), this.pins.forEach((e) => {
      e.setLocked(t);
    }), this.context.objects.object3DInfos.modified(), this.updateImplantPlannerGUIEvent.notify(this.selectedObject.get()), setTimeout(() => {
      this.context.updateObject2DPositionEvent.notify();
    }, 0);
  }
  toggleObjectPlacement(t) {
    const e = this.implants.get(t) || this.pins.get(t) || this.stls.get(t);
    e && (e.setLocked(!e.getLocked()), this.context.objects.object3DInfos.modified()), this.updateImplantPlannerGUIEvent.notify(this.selectedObject.get()), setTimeout(() => {
      this.context.updateObject2DPositionEvent.notify();
    }, 0);
  }
  toggleObjectWireframe(t) {
    const e = this.stls.get(t);
    e && e.toggleRepresentationWireframe();
  }
  addCPRCurve(t, e) {
    this.CPRCurve = new EW(this.context, t, {
      color: Kn(t.color),
      lineWidth: 2,
      ignoreScaling: e
    }), this.context.CPRType = t.maxilla0Mandible, this.initializeCPRCurve(), this.isModified = !0;
  }
  /** Update CPR representations - has to be called separately after view initialization if CPR was already in the project */
  initializeCPRCurve() {
    const t = this.context.getViewWidget(Nt.CPR);
    t && t.insertPointsFromProject();
  }
  addNerve(t, e, n) {
    this.isModified = !0;
    const s = new fA(this.context, t, e, n), r = {
      projectNerve: t,
      id: s.id,
      name: s.getName(),
      length: 0,
      nerve: s
    };
    this.nerveObjects.set(r.id, r);
  }
  hasCPR() {
    return this.CPRCurve.points.length > 0;
  }
  getCprCurveObjectData() {
    return this.CPRCurve.points.length == 0 ? null : this.CPRCurve.toProjectCPR();
  }
  getNerveObjectData() {
    const t = [];
    for (const e of this.nerveObjects.values()) {
      const n = e.nerve.toProjectNerve();
      e.projectNerve = n, t.push(n);
    }
    return t;
  }
  getStlObjectData() {
    const t = [];
    return this.stls.forEach((e) => {
      t.push(e.toProjectStlObject());
    }), t;
  }
  getToothMarkerObjectData() {
    const t = [];
    for (const e of this.toothMarkers.values())
      t.push(e.toProjectToothMarkerObject());
    return t;
  }
  getSTLObjectIdByActor(t) {
    let e = this.pins.getByActor(t);
    if (e != null || (e = this.implants.getByActor(t), e != null)) return e;
    for (const n of this.stls.values())
      if (e = n.isActorObject(t), e != null) return e;
    return null;
  }
  updateObjectInfos3D(t) {
    const e = {
      id: t.id,
      name: t.getName(),
      visible: t.getVisibility(),
      position: t.getPosition(),
      handleTop: null,
      handleBottom: null,
      centerlineTop: null,
      centerlineBottom: null,
      color: Pa(t.getColor()),
      type: t.type
    };
    this.context.objects.object3DInfos.update((n) => {
      const s = n.findIndex((r) => r.id === t.id);
      return s !== -1 ? n[s] = e : n.push(e), n;
    });
  }
  findSleeveIntersectionObject() {
    let t = this.findAnatomyObject();
    if (t) {
      if (!t.getVisibility()) {
        const e = this.findAntagonistObject();
        e && e.getVisibility() && (t = e);
      }
    } else
      t = this.findAntagonistObject();
    return t || null;
  }
  checkCollisions(t, e, n) {
    performance.now();
    const s = [...this.implants.values(), ...this.pins.values()], r = t ? [t] : s, a = this.findSleeveIntersectionObject();
    for (let l = 0; l < r.length; l++) {
      let c = r[l];
      if (!e) {
        a && c.anatomyCollisionDetection(a);
        for (let u = l; u < s.length; u++) {
          let d = s[u];
          d !== c && c.collisionDetection(d);
        }
      }
      if (this.context.settings.implants.nerveWarning)
        for (const u of this.nerveObjects.values())
          c.collisionDetection(u.nerve);
    }
    const o = this.context.warningString.get();
    this.context.warningString.set("");
    for (const l of s) {
      if (l.collisionReport = "", l.resetCollisions(), l.collisionMap.size > 0)
        for (const [u, d] of l.collisionMap) {
          if (!this.context.settings.implants.securityZone && d) continue;
          let h = "";
          u.type == Yt._IMPLANT && (h = "Implant "), l.collisionReport += "	Collision with: " + h + u.getName() + (d ? " Collision Zone" : "") + `
`, l.setColorOverride(Kn(this.context.settings.defaultColors.collision)), u.type == Yt._NERVE ? l.collisions.nerveCollision = !0 : l.collisions.implantCollision = !0, d && u.type !== Yt._NERVE && (l.collisions.securityZoneCollision = !0);
        }
      else
        l.setColorOverride(null);
      const c = l.getSleeve();
      if (c) {
        if (c.collisionMap.size > 0) {
          let u = !1;
          for (const [d, h] of c.collisionMap)
            d instanceof vn && d.isAnatomyCollisionObject() ? (l.collisionReport += `	Anatomy Collision 
`, l.setColorOverride(Kn(this.context.settings.defaultColors.collision)), c.setColorOverride(Kn(this.context.settings.defaultColors.collision)), l.collisions.anatomyCollision = !0) : u || (u = !0, c.setColorOverride(Kn(this.context.settings.defaultColors.collision)), l.collisionReport += `	Sleeve Collision 
`, l.collisions.sleeveCollision = !0);
        } else
          c.setColorOverride(null);
        if (l.collisions.sleeveChanged = null, l.isImplant()) {
          const u = !!c.sleeveManuallyChanged || !c.getSleeveInfo().referencedSleeve, d = c.getSleeveInfo().distanceFromImplant < 0, h = u || d;
          if (h && c.getColorOverride() == null && c.setColorOverride(Kn([255, 255, 0])), h) {
            const p = XP(c.sleeveOffset, 12);
            Math.abs(p) <= 1e-6 ? l.collisions.sleeveChanged = "Sleeve changed" : p <= 0 ? l.collisions.sleeveChanged = "Sleeve changed " + p + "mm" : l.collisions.sleeveChanged = "Sleeve changed +" + p + "mm";
          }
        }
      }
      this.context.warningString.update((u) => {
        const d = !!n && l.collisions.sleeveChanged != null;
        return (l.collisionReport != "" || d) && (u += l.isImplant() ? "Implant " : "", u += l.getName(), u += `: 
`, u += l.collisionReport, d && (u += "	" + l.collisions.sleeveChanged + `
`)), u;
      });
    }
    for (const l of this.nerveObjects.values())
      l.nerve.collisionMap.size > 0 ? l.nerve.setColorOverride(Kn(this.context.settings.defaultColors.collision)) : l.nerve.setColorOverride(null);
    this.context.repaint(), this.context.settings.implants.showWarningsPopup && this.context.warningString.get().length && this.context.warningString.get() != o && this.context.warningDialogEvent.notify(jt("implant-planner.warning")), this.context.objects.updateImplantPlannerGUIEvent.notify(this.selectedObject.get());
  }
  replaceGuideObjectParts(t, e, n) {
    this.implants.forEach((s) => {
      s.getSleeve() && s.getSupportObjects().forEach((a) => {
        a.updateObject(t, e, n), a.isSupport && (s.setGuideOrigin(new Float64Array(a.getGuideTop())), s.setGuideDirection(new Float64Array(a.getGuideNormal())), s.setGuideBiDirection(new Float64Array(a.getGuideBiNormal())), s.setGuideDiameter(s.isImplant() ? t : e), s.setGuideHeight(2 * a.getGuideHeight()));
      });
    }), this.pins.forEach((s) => {
      s.getSleeve() && s.getSupportObjects().forEach((a) => {
        a.updateObject(t, e, n), a.isSupport && (s.setGuideOrigin(new Float64Array(a.getGuideTop())), s.setGuideDirection(new Float64Array(a.getGuideNormal())), s.setGuideBiDirection(new Float64Array(a.getGuideBiNormal())), s.setGuideDiameter(s.isImplant() ? t : e), s.setGuideHeight(2 * a.getGuideHeight()));
      });
    }), this.context.repaint();
  }
  loadGuideObjectsParts(t, e, n) {
    this.implants.forEach((s) => {
      var a;
      const r = (a = s.getSleeve()) == null ? void 0 : a.getSleeveInfo();
      if (r) {
        const o = kd.constructGuideObject(this.context, s, r, 1, t, e, n), l = "Support";
        if (this.stls.set(o.id, o), o.setName(l), o.update3dInfo(), s.setGuideOrigin(new Float64Array(o.getGuideTop())), s.setGuideDirection(new Float64Array(o.getGuideNormal())), s.setGuideBiDirection(new Float64Array(o.getGuideBiNormal())), s.setGuideDiameter(s.isImplant() ? t : e), s.setGuideHeight(2 * o.getGuideHeight()), s.setGuidePin(!s.isImplant()), !r.stlNegativeData) {
          const d = kd.constructGuideObject(this.context, s, r, 7, t, e, n), h = "Upper Extrusion";
          this.stls.set(d.id, d), d.setName(h), d.update3dInfo();
        }
        const c = kd.constructGuideObject(this.context, s, r, 8, t, e, n), u = "Lower Extrusion";
        this.stls.set(c.id, c), c.setName(u), c.update3dInfo();
      }
    }), this.pins.forEach((s) => {
      var a;
      const r = (a = s.getSleeve()) == null ? void 0 : a.getSleeveInfo();
      if (r) {
        const o = kd.constructGuideObject(this.context, s, r, 1, t, e, n), l = "Support";
        this.stls.set(o.id, o), o.setName(l), o.update3dInfo(), s.setGuideOrigin(new Float64Array(o.getGuideTop())), s.setGuideDirection(new Float64Array(o.getGuideNormal())), s.setGuideBiDirection(new Float64Array(o.getGuideBiNormal())), s.setGuideDiameter(s.isImplant() ? t : e), s.setGuideHeight(2 * o.getGuideHeight()), s.setGuidePin(!s.isImplant());
        const c = kd.constructGuideObject(this.context, s, r, 7, t, e, n), u = "Upper Extrusion";
        this.stls.set(c.id, c), c.setName(u), c.update3dInfo();
        const d = kd.constructGuideObject(this.context, s, r, 8, t, e, n), h = "Lower Extrusion";
        this.stls.set(d.id, d), d.setName(h), d.update3dInfo();
      }
    }), this.context.sceneRepaint();
  }
  clearGuideObjectParts(t, e) {
    this.implants.forEach((n) => {
      n.deleteSupportObjects(e);
    }), this.pins.forEach((n) => {
      n.deleteSupportObjects(e);
    }), t || this.context.sceneRepaint();
  }
  getActorStlObject(t) {
    for (const e of this.stls.values())
      if (e instanceof vn && e.isActorObject(t))
        return e;
    return null;
  }
  async getObjectImportPreviewList() {
    const t = [];
    for (let [e, n] of this.stls) {
      const s = this.context.viewConfiguration.colorScheme.get(), r = await lA(n, !0, s) || "", a = {
        id: n.id,
        name: n.getName(),
        selected: !1,
        preview: r,
        typeCAD: UC.LOWER_JAW
      };
      t.push(a);
    }
    return t;
  }
  SetImplantReportDims(t, e, n, s, r, a, o) {
    let l = s;
    this.rptCPRSize = t, this.rptFrontalSize = s;
    for (let c of this.implants.values())
      c.SetReportDims(e, r, l, a, o, n);
    for (let c of this.pins.values())
      c.SetReportDims(e, r, l, a, o, n);
    this.rptTemplateName = a, this.rptBackgroundColor = o;
  }
  async SaveImplantReportCPR(t) {
    let e = "";
    if (this.hasCPR()) {
      const n = this.context.getViewWidget(Nt.CPR), s = n == null ? void 0 : n.getPresenterWindow();
      if (n && s) {
        const r = n.getFilterMode(), a = n.getFilterThickness();
        s.setFilterCPRThicknessEvent.notify({ filterMode: Je.MIP, thickness: 5 }), n.setFilterMode(Je.MIP, 5), t && n.shiftCurve(0);
        const o = await oA(this.context, Nt.CPR, 0.75);
        o && (e = o), s.setFilterCPRThicknessEvent.notify({ filterMode: r, thickness: a });
      }
    }
    return e;
  }
  getReportXML() {
    const t = new mNt(), e = this.context.getImageData().getSpacing(), n = Math.min(...e);
    let s = 0;
    const r = (b, y) => {
      t.setData(b, new TextEncoder().encode(y || ""));
    }, a = (b, y) => {
      const Z = Number.isFinite(y) ? String(y) : "0";
      t.setData(b, new TextEncoder().encode(Z));
    }, o = (b, y) => {
      t.setData(b, new Uint8Array(y));
    }, l = (b, y) => {
      y && (r([...b, "FileName"], y.fileName), o([...b, "FileStream"], y.data), a([...b, "FileSize"], y.fileSize));
    }, c = (b) => ({
      originalName: (b == null ? void 0 : b.originalName) ?? "",
      manufacturerName: (b == null ? void 0 : b.manufacturerName) ?? "",
      modelName: (b == null ? void 0 : b.modelName) ?? "",
      sellingCode: (b == null ? void 0 : b.sellingCode) ?? "",
      drillLengthSizes: (b == null ? void 0 : b.drillLengthSizes) ?? "",
      dExternal: (b == null ? void 0 : b.dExternal) ?? 0,
      dInternal: (b == null ? void 0 : b.dInternal) ?? 0,
      dHexagon: (b == null ? void 0 : b.dHexagon) ?? 0,
      lSleeve: (b == null ? void 0 : b.lSleeve) ?? 0,
      lLip: (b == null ? void 0 : b.lLip) ?? 0,
      lCut: (b == null ? void 0 : b.lCut) ?? 0,
      distanceFromImplant: (b == null ? void 0 : b.distanceFromImplant) ?? 0,
      originalDistanceFromImplant: (b == null ? void 0 : b.originalDistanceFromImplant) ?? -1,
      referencedSleeve: (b == null ? void 0 : b.referencedSleeve) ?? 0,
      reductionSystemSize: (b == null ? void 0 : b.reductionSystemSize) ?? 0,
      cylinderShape: (b == null ? void 0 : b.cylinderShape) ?? !1,
      lockDistance: (b == null ? void 0 : b.lockDistance) ?? 0,
      distanceFromImplantOffset: (b == null ? void 0 : b.distanceFromImplantOffset) ?? 0,
      rotationAll: (b == null ? void 0 : b.rotationAll) ?? 0,
      rotationCut: (b == null ? void 0 : b.rotationCut) ?? 0,
      connectionIndex: (b == null ? void 0 : b.connectionIndex) ?? 0,
      stlFileGuid: (b == null ? void 0 : b.stlFileGuid) ?? "",
      stlFileNegativeGuid: (b == null ? void 0 : b.stlFileNegativeGuid) ?? "",
      stlData: b == null ? void 0 : b.stlData,
      stlNegativeData: b == null ? void 0 : b.stlNegativeData
    }), u = (b) => ({
      "Pin A": "Pin 1",
      "Pin B": "Pin 2",
      "Pin C": "Pin 3",
      "Pin D": "Pin 4",
      "Pin E": "Pin 5",
      "Pin F": "Pin 6",
      "Pin G": "Pin 7",
      "Pin H": "Pin 8",
      "Pin I": "Pin 9"
    })[b] ?? b, d = (b, y, Z) => {
      const g = y.originalDistanceFromImplant != null && y.originalDistanceFromImplant >= 0 ? y.originalDistanceFromImplant : y.distanceFromImplant;
      if (r([...b, "SLEEVE_ORIGINAL_NAME"], y.originalName), r([...b, "SLEEVE_MANUFACTURER"], y.manufacturerName), r([...b, "SLEEVE_MODEL"], y.modelName), r([...b, "SLEEVE_SELLING_CODE"], y.sellingCode), r([...b, "SLEEVE_DRILL_SIZES"], y.drillLengthSizes), a([...b, "SLEEVE_DEXTERNAL"], y.dExternal), a([...b, "SLEEVE_DINTERNAL"], y.dInternal), a([...b, "SLEEVE_DHEXAGON"], c3(y.dHexagon, y.cylinderShape)), a([...b, "SLEEVE_LSLEEVE"], y.lSleeve), a([...b, "SLEEVE_LLIP"], y.lLip), a([...b, "SLEEVE_LCUT"], y.lCut), a([...b, "SLEEVE_DISTANCE_FROM_IMPLANT"], y.distanceFromImplant), a([...b, "SLEEVE_ORIGINAL_DISTANCE_FROM_IMPLANT"], g), a([...b, "SLEEVE_REFERENCED_SLEEVE"], y.referencedSleeve ?? 0), a([...b, "SLEEVE_REDUCTION_SYSTEM_SIZE"], y.reductionSystemSize), a([...b, "SLEEVE_CYLINDER_SHAPE"], y.cylinderShape || y.dHexagon < 0 ? 1 : 0), a([...b, "SLEEVE_LOCK_DISTANCE"], Number(y.lockDistance ?? 0)), y.stlFileGuid && r([...b, "SLEEVE_STL_FILEGUID"], y.stlFileGuid), y.stlFileNegativeGuid && r([...b, "SLEEVE_STL_NEGATIVE_FILEGUID"], y.stlFileNegativeGuid), l([...b, "SLEEVE_STL_FILE"], y.stlData), l([...b, "SLEEVE_STL_NEGATIVE_FILE"], y.stlNegativeData), !Z) return;
      const f = y.distanceFromImplant;
      let T = g, M = 0;
      (y.originalDistanceFromImplant ?? -1) >= 0 && (T = y.originalDistanceFromImplant ?? f, Math.abs(T - f) > 1e-6 && (M = f - T)), r([...b, "SLEEVE_ORIGINAL_DISTANCE_FROM_IMPLANT"], T.toFixed(2)), r([...b, "SLEEVE_DISTANCE_FROM_IMPLANT_OFFSET"], M.toFixed(2)), a([...b, "SLEEVE_REFERENCED_SLEEVE"], y.referencedSleeve ?? 0), a([...b, "ROTATION_ALL"], y.rotationAll ?? 0), a([...b, "ROTATION_CUT"], y.rotationCut ?? 0), a([...b, "CONNECTION_INDEX"], y.connectionIndex ?? 0);
    }, h = (b, y) => {
      r([...b, "OBJECT_NAME"], y.getName()), r([...b, "OBJECT_DISPLAY_TEXT"], y.getDisplayText()), a([...b, "OBJECT_TYPE"], y.type), a([...b, "OBJECT_SUB_TYPE"], y.subType);
    }, p = (b) => {
      var x, V, X;
      const y = ["COLLECTION_3D", `OBJECT_${s}`];
      h(y, b);
      const Z = b.getProjectImplantInfo(), g = [...y, "IMPLANT"], f = ((x = b.getSleeve()) == null ? void 0 : x.getDrillLength()) ?? 0;
      r([...g, "IMPLANT_ORIGINAL_NAME"], Z.implantOriginalName), r([...g, "MODEL_NAME"], Z.modelName), r([...g, "MANUFACTURER_NAME"], Z.manufacturerName), r([...g, "FILE_NAME"], Z.implantFileName), r([...g, "NAME"], Z.name), r([...g, "SAME_MANUFACTURER_IMPLANTS"], Z.sameManufacturerImplants), r([...g, "GUID"], Z.guid), a([...g, "IMPLANT_CONECTOR_HEIGHT"], Z.implantConnectorHeight), r([...g, "IMPLANT_SELLING_CODE"], Z.sellingCode), a([...g, "DIAMETER"], Z.diameter), a([...g, "LENGTH"], Z.length), a([...g, "COLOR"], Z.color), a([...g, "DRILL_LENGTH"], f / n), a([...g, "DRILL_LENGTH_MM"], f);
      const T = ((V = b.getAbutment()) == null ? void 0 : V.getAbutmentInfo()) ?? b.getImplantInfo().abutment, M = [...y, "ABUTMENT"];
      r([...M, "MANUFACTURER_NAME"], (T == null ? void 0 : T.manufacturerName) ?? ""), r([...M, "MODEL_NAME"], (T == null ? void 0 : T.modelName) ?? ""), r([...M, "FILE_NAME"], (T == null ? void 0 : T.fileName) ?? ""), r([...M, "NAME"], (T == null ? void 0 : T.name) ?? ""), r([...M, "GUID"], (T == null ? void 0 : T.guid) ?? ""), a([...M, "COLOR"], (T == null ? void 0 : T.color) ?? 0), a([...M, "ANGLE"], (T == null ? void 0 : T.angle) ?? 0), a([...M, "CONNECTION_HEIGHT"], (T == null ? void 0 : T.connectorHeight) ?? 0), r([...M, "ABUTMENT_SELLING_CODE"], (T == null ? void 0 : T.abutmentSellingCode) ?? ""), a([...M, "ROTATION_Z"], (T == null ? void 0 : T.rotationZ) ?? 0);
      const N = b.getImplantInfo().secondaryAbutment;
      if (N != null && N.guid) {
        const C = [...y, "SECONDARY_ABUTMENT"];
        r([...C, "MANUFACTURER_NAME"], N.manufacturerName), r([...C, "MODEL_NAME"], N.modelName), r([...C, "FILE_NAME"], N.fileName), r([...C, "NAME"], N.name), r([...C, "GUID"], N.guid), a([...C, "COLOR"], N.color), a([...C, "ANGLE"], N.angle), a([...C, "CONNECTION_HEIGHT"], N.connectorHeight), r([...C, "ABUTMENT_SELLING_CODE"], N.abutmentSellingCode), a([...C, "ROTATION_Z"], N.rotationZ);
      }
      const W = c(((X = b.getSleeve()) == null ? void 0 : X.getSleeveInfo()) ?? b.getImplantInfo().sleeveInfo);
      d([...y, "SLEEVE_INFO"], W, !0), s++;
    }, m = (b) => {
      var T;
      const y = ["COLLECTION_3D", `OBJECT_${s}`];
      h(y, b);
      const Z = b.getProjectPinInfo(), g = [...y, "PIN"];
      r([...g, "NAME"], u(Z.name)), r([...g, "FILENAME"], Z.filename || Z.stlFile.fileName), r([...g, "MANUFACTURER_NAME"], Z.manufacturerName), r([...g, "MODEL_NAME"], Z.modelName), a([...g, "COLOR"], Number(Z.color) || 0), r([...g, "GUID"], Z.guid), l([...g, "STLFile"], Z.stlFile);
      const f = c((T = b.getSleeve()) == null ? void 0 : T.getSleeveInfo());
      d([...y, "SLEEVE_INFO"], f, !1), s++;
    };
    for (const b of this.implants.values())
      p(b);
    for (const b of this.pins.values())
      m(b);
    return a(["COLLECTION_3D", "OBJECTS_COUNT"], s), t.toBytes();
  }
  clearTeethAndMarkers() {
    this.isModified = !0, this.context.objects.toothMarkers.forEach((t) => {
      t.delete();
    }), this.context.objects.toothMarkers.clear(), this.stls.forEach((t) => {
      t.type == Yt._STL_TOOTH && t.delete();
    });
  }
  clearMergedTeeth() {
    this.isModified = !0;
    const t = /* @__PURE__ */ new Set(["Waxup-Prosthesis", "Antagonist Waxup"]);
    Array.from(this.stls.values()).filter((n) => {
      if (n.IsVolume() || !t.has(n.getName()))
        return !1;
      const s = n;
      return s.getCadCorrespondenceId() !== -1 && s.getCadReconstructionTypeId() !== -1;
    }).forEach((n) => {
      n.delete();
    });
  }
  clearReferencePlanes() {
    this.isModified = !0, this.context.objects.stls.forEach((t) => {
      t.type == Yt._REFERENCE_PLANE && t.delete();
    });
  }
  clearTmpStls() {
    for (let t of this.tmpStls.values())
      t.delete();
    this.tmpStls.clear(), this.tmpStlFilePaths.clear();
  }
  registerTmpStlForFile(t, e) {
    this.tmpStlFilePaths.set(t, e.id);
  }
  importTmpStlsByPaths(t) {
    const e = [];
    if (!t.length) return e;
    const n = new Set(t);
    for (const s of n) {
      const r = this.tmpStlFilePaths.get(s);
      if (!r) continue;
      const a = this.tmpStls.get(r);
      a && (this.stls.set(a.id, a), a.update3dInfo(), this.tmpStls.delete(r), this.tmpStlFilePaths.delete(s), e.push(a));
    }
    return e;
  }
  cleanup() {
    var t;
    this.onCleanupArray.reduceRight((e, n) => (n(), null), null), this.reactivity.cleanupAll(), this.mappers.forEach((e) => e.delete()), this.actors.forEach((e) => e.delete());
    for (const e of this.implants.values())
      e.delete(!0);
    for (const e of this.pins.values())
      e.delete(!0);
    for (const e of this.stls.values())
      e.delete(!0);
    for (const e of this.tmpStls.values())
      e.delete(!0);
    this.tmpStlFilePaths.clear();
    for (const e of this.stlsMatching.values())
      e.delete(!0);
    for (const e of this.volumes.values())
      e.delete(!0);
    for (const e of this.nerveObjects.values())
      (t = e.nerve) == null || t.delete(!0);
    for (const e of this.toothMarkers.values())
      e.delete(!0);
    for (const e of this.images2D.values())
      e.delete(!0);
  }
}
class EW extends ow {
  constructor(e, n, s) {
    super();
    S(this, "context");
    S(this, "type", Yt._CPR_CURVE);
    S(this, "objectSubType", Yt._CPR_DENTAL);
    S(this, "maxillaOmandible");
    S(this, "owner");
    S(this, "lineWidth", 0.5);
    S(this, "projectCurve");
    S(this, "object3dInfo");
    S(this, "radius", 0.3);
    S(this, "points");
    S(this, "newObject", !1);
    S(this, "matrix", ut.create());
    S(this, "data", Ie.newInstance());
    S(this, "polyPoints", yi.newInstance());
    S(this, "lines", Ii.newInstance());
    S(this, "filter", Qh.newInstance({
      radius: 0.3,
      numberOfSides: 10,
      capping: !0
    }));
    S(this, "splineVec", []);
    S(this, "splineNormals", []);
    S(this, "splineTangents", []);
    S(this, "splineBinormals", []);
    this.context = e, this.filter.setInputData(this.data), this.data.setPoints(this.polyPoints), this.data.setLines(this.lines), this.pickable = !1, s ? (this.color = s.color, this.lineWidth = s.lineWidth) : this.color = [1, 1, 1], n ? (this.projectCurve = n, this.name = n.name, this.displayText = n.displayText, this.color = Kn(n.color), this.opacity = n.opacity, this.visibility = n.visible, s != null && s.ignoreScaling ? this.points = n.points : this.points = n.points.map((r) => this.context.objects.scaleVectorFromImplantPlanner(r)), this.objectSubType = n.objectSubType, this.maxillaOmandible = n.maxilla0Mandible, this.owner = n.owner, this.owner && n.owner && !(s != null && s.ignoreScaling) && (this.owner.o = this.context.objects.scaleVectorFromImplantPlanner(n.owner.o)), this.setData(this.points, this.points)) : (this.newObject = !0, this.points = [], this.maxillaOmandible = xo.MAXILLA, this.owner = {
      o: [0, 0, 0],
      n: [0, 0, 1],
      s: [0, 1, 0],
      t: [1, 0, 0]
    }, this.projectCurve = {
      points: this.points,
      opacity: this.opacity,
      name: this.name,
      objectType: this.type,
      objectSubType: this.objectSubType,
      color: this.color,
      visible: this.visibility,
      displayText: this.displayText,
      maxilla0Mandible: this.maxillaOmandible,
      owner: this.owner,
      objectNote: this.objectNote,
      shapePoints: 0,
      enabled: 1,
      deleted: 0,
      ownerCount: 1,
      owners: ["AXIAL"]
    });
  }
  setData(e, n) {
    n != null && (this.points = n);
    const s = e.length, r = new Float32Array(s * 3), a = new Uint16Array(s + 1);
    for (let o = 0; o < s; o++) {
      const l = e[o];
      r[3 * o] = l[0], r[3 * o + 1] = l[1], r[3 * o + 2] = l[2], a[o + 1] = o;
    }
    a[0] = s, this.polyPoints.setData(r, 3), this.lines.setData(a), this.filter.setRadius(this.radius), this.data.modified(), this.updatePosition();
  }
  setMaxillaMandible(e) {
    this.maxillaOmandible = e, e == xo.MAXILLA ? this.name = "Maxilla_CPR" : e == xo.MANDIBLE ? this.name = "Mandible_CPR" : e == xo._0 && (this.name = "CPR");
  }
  toProjectCPR() {
    const e = this.projectCurve;
    return e.name = this.name, e.displayText = this.displayText, e.color = Pa(this.getColor()), e.opacity = this.getOpacity(), e.visible = this.getVisibility(), e.points = this.points.map((n) => this.context.objects.scaleVectorToImplantPlanner(n)), e.objectSubType = this.objectSubType, e.objectType = this.type, e.owner = this.owner, e.owner && this.owner && (e.owner.o = this.context.objects.scaleVectorToImplantPlanner(this.owner.o)), e.maxilla0Mandible = this.maxillaOmandible, e;
  }
  onViewWidgetEvent(e, n) {
    if (e.getViewMode() === Nt._STL_3D_PREVIEW)
      return;
    this.context.layoutManager.layoutContainsCpr(this.context.getLayout()) || (n = me.eVE_DESTROY);
    const s = this.actors.get(e);
    switch (n) {
      case me.eVE_SHOW:
      case me.eVE_RENDER:
        if (!s)
          e.getViewMode() == Nt._3D ? this.context.toolManager.coordControl.getScoutDispalyMode() && this.create3dActor(e) : e.getViewMode() == Nt.AXIAL && this.create2dActor(e);
        else {
          const r = this.mappers.get(e);
          r && (e.isViewMode3D() && this.context.cprScoutVisible ? (r.setInputData(this.filter.getOutputData()), r.modified()) : e.getViewMode() == Nt.AXIAL && (r.setInputData(this.data), r.modified()));
        }
        break;
      case me.eVE_HIDE:
        break;
      case me.eVE_DESTROY:
        this.delete3dActor(e);
        break;
    }
  }
  createActorObjects() {
    const e = Ue.newInstance();
    e.setInputData(this.filter.getOutputData());
    const n = Re.newInstance();
    return n.setMapper(e), n.getProperty().setColor(this.color), n.getProperty().setLineWidth(this.lineWidth), n.getProperty().setOpacity(this.opacity), n.setPickable(!1), n.setVisibility(this.visibility), n.setUserMatrix(this.matrix), { mapper: e, actor: n };
  }
  create3dActor(e) {
    const { mapper: n, actor: s } = this.createActorObjects();
    this.mappers.set(e, n), this.actors.set(e, s), e.getRenderer().addActor(s);
  }
  delete3dActor(e) {
    var s;
    const n = this.actors.get(e);
    n && (e.getRenderer().removeActor(n), n.delete()), (s = this.mappers.get(e)) == null || s.delete(), this.actors.delete(e), this.mappers.delete(e);
  }
  create2dActor(e) {
    const { mapper: n, actor: s } = this.create2DActorObjects();
    this.mappers.set(e, n), this.actors.set(e, s), e.addActor(s, 1);
  }
  create2DActorObjects() {
    const e = Ue.newInstance();
    e.setInputData(this.data);
    const n = Re.newInstance();
    return n.setMapper(e), n.getProperty().setColor(this.color), n.getProperty().setLineWidth(this.lineWidth), n.getProperty().setOpacity(this.opacity), n.setPickable(!1), n.setVisibility(this.visibility), n.setUserMatrix(this.matrix), { mapper: e, actor: n };
  }
  isActorObject(e) {
    for (const [, n] of this.actors)
      if (e == n) return this.id;
    return null;
  }
  update3dInfo() {
    this.object3dInfo = {
      id: this.id,
      name: this.name,
      visible: this.visibility,
      position: [0, 0, 0],
      handleTop: null,
      handleBottom: null,
      centerlineTop: null,
      centerlineBottom: null,
      color: this.projectCurve.color,
      type: Yt._CPR_CURVE
    }, this.context.objects.object3DInfos.update((e) => {
      const n = e.findIndex((s) => s.id === this.id);
      return n !== -1 ? e[n] = this.object3dInfo : e.push(this.object3dInfo), e;
    });
  }
  removeFromObject3dInfos() {
    this.context.objects.object3DInfos.update((e) => {
      const n = e.findIndex((s) => s.id === this.id);
      return n !== -1 && e.splice(n, 1), e;
    });
  }
  updatePosition() {
    this.update3dInfo();
  }
  setColor(e) {
    this.color = e;
    for (const n of this.actors.values())
      n.getProperty().setColor(e);
    this.context.objects.onStlColorChanged.notify({ id: this.id.toString(), color: this.color }), this.context.repaint();
  }
  setLineWidth(e) {
    this.lineWidth = e;
    for (const n of this.actors.values())
      n.getProperty().setLineWidth(e);
    this.context.repaint();
  }
  setLocked(e) {
    this.locked = e;
  }
  setOpacity(e) {
    this.opacity = e;
    for (const n of this.actors.values())
      n.getProperty().setOpacity(e);
    this.context.repaint();
  }
  setPickable(e) {
    this.pickable = e;
    for (const n of this.actors.values())
      n.setPickable(e);
  }
  setVisibility(e) {
    this.visibility = e;
    for (const n of this.actors.values())
      n.setVisibility(e);
    this.update3dInfo(), this.context.sceneRepaint(void 0, (n, s) => this.onViewWidgetEvent(n, s));
  }
  setMatrix(e) {
    ut.copy(this.matrix, e);
    for (const n of this.actors.values())
      n.setUserMatrix(this.matrix);
  }
  setRadius(e) {
    this.radius = e;
  }
  getRadius() {
    return this.radius;
  }
  getMatrix() {
    return this.matrix;
  }
  delete(e) {
    for (const [n, s] of this.actors)
      n.getRenderer().removeActor(s), s.delete();
    for (const n of this.mappers.values())
      n.delete();
    e || this.removeFromObject3dInfos(), this.polyPoints.delete(), this.lines.delete(), this.data.delete(), this.filter.delete();
  }
  sendToParallelExecutor(e) {
    console.log("CPRXUrve - sendToParallelExecutor", e);
  }
}
class gNt extends op {
  constructor(e, n, s, r = {}) {
    var M;
    super(e, n, r);
    S(this, "presenterWindow");
    S(this, "sliceSelectEvent", new se());
    S(this, "objectListVisible", new qt(!1));
    S(this, "cprRuler", null);
    S(this, "textLabels");
    S(this, "altTextLabels");
    S(this, "altLabel");
    S(this, "cprRulerLabels");
    S(this, "origin2DPosition", new qt([0, 0]));
    S(this, "angleObs", new qt(0));
    S(this, "angleLabelObs", new qt(""));
    S(this, "positionLabelObs", new qt(""));
    S(this, "visibleFlag", new qt(!0));
    S(this, "moveCrossStep", 1);
    S(this, "pointsInsertedFromProjectFlag", !1);
    S(this, "ownerMatrix", ut.create());
    S(this, "reslicerCPR");
    S(this, "CPRActor", null);
    S(this, "hasOffsetSplines", !1);
    S(this, "CPRCurveP", new EW(this.context));
    S(this, "CPRCurveN", new EW(this.context));
    S(this, "splineTangents", []);
    S(this, "splineNormals", []);
    S(this, "splineBinormals", []);
    S(this, "splineVec", []);
    S(this, "inputCurve", new yS());
    S(this, "inputCurveFixed", new yS());
    S(this, "splineCurve", new yS());
    S(this, "cprOwnerNormal", I.create());
    S(this, "curveMovedEvent", new se());
    S(this, "previousDelta", 0);
    S(this, "rotateOwnerLastMs", 0);
    S(this, "rotateOwnerThrottleMs", 50);
    this.presenterWindow = s;
    const { createVueOverlayComponent: a, cleanup: o } = Pi(this.overlayContainer.getElement());
    this.onCleanup(() => o());
    let l = null;
    const c = (N, W, x) => {
      l = a(zT, {
        menuItems: N,
        x: W,
        y: x
      });
    }, u = () => {
      l && (l.remove(), l = null);
    }, d = () => {
      const N = this.context.CPRSpacing.get()[1], W = this.viewSize.get()[1];
      N <= 0 || W <= 0 || (this.renderer.getActiveCamera().setParallelScale(N * W / 2), this.cameraModified(), this.context.repaint());
    }, h = [
      {
        label: jt("medic-web-engine.resetMprAngles"),
        command: () => {
          this.context.toolManager.coordControl.resetCPRParams(), this.context.toolManager.coordControl.setCenter(this.getOrigin(), this);
        }
      },
      {
        label: jt("medic-web-engine.zoom100"),
        command: () => {
          d(), this.updateCrossSliceIndicator(), this.cameraModified(), this.context.repaint();
        }
      },
      {
        label: jt("medic-web-engine.zoomBestFit"),
        command: () => {
          this.fitZoomToScreen(), this.updateCrossSliceIndicator(), this.cameraModified(), this.context.repaint();
        }
      },
      {
        label: jt("medic-web-engine.resetPanoOffset"),
        command: () => {
          this.shiftCurve(0, !0), this.context.repaint();
        }
      }
    ], p = { moved: !1, start: { x: 0, y: 0 } }, m = {
      onRightPress: (N, W) => (p.moved = !1, p.start = { x: W.position.x, y: W.position.y }, u(), !1),
      onRightRelease: (N, W, x) => {
        if (u(), x.cameraDragActive || p.moved)
          return !1;
        const { x: V, y: X } = W.position;
        return c(h, V, this.viewSize.get()[1] - X - 1), !0;
      },
      onLeftPress: () => (u(), !1),
      onMouseMove: (N, W, x) => {
        if (!x.mouseButtons.right || p.moved)
          return !1;
        const V = W.position.x - p.start.x, X = W.position.y - p.start.y;
        return Math.abs(V) + Math.abs(X) > 30 && (p.moved = !0), !1;
      }
    };
    (M = this.context.getInteractorStyle()) == null || M.setViewEventHandler(this, m), this.onCleanup(() => {
      var N;
      u(), (N = this.context.getInteractorStyle()) == null || N.setViewEventHandler(this, null);
    }), this.cprRulerLabels = new qt([]), this.cprRuler = new QMt(), this.altLabel = new qt([[jt("medic-web-engine.cprDoesNotExistDrawCprByPointsOrUseAutomaticCprLocalization"), [100, 100]]]);
    const b = "white", y = "1px 1px 2px black";
    this.textLabels = a(Wz, { labels: this.cprRulerLabels, fontSizePx: 20, cssColor: b, textShadow: y }), this.altTextLabels = a(Wz, { labels: this.altLabel, fontSizePx: 20, cssColor: b, textShadow: y }), e.objects.hasCPR() ? this.altTextLabels.setEnabled(!1) : this.altTextLabels.setEnabled(!0);
    const Z = (N) => {
      const W = Math.max(1, Math.round(this.moveCrossStep / this.context.CPRSpacing.get()[0]));
      this.slide(N ? -W : W);
    }, g = (N) => {
      const W = N * Math.PI / 180;
      this.context.toolManager.coordControl.crossAngle.set(W), this.context.toolManager.coordControl.setCenter(this.getOrigin(), this);
    }, f = (N) => {
      this.moveCrossStep = N;
    };
    this.updateCrossSliceIndicator(), a(
      zbt,
      {
        originPosition: this.origin2DPosition,
        viewSize: this.viewSize,
        visible: this.visibleFlag,
        angle: this.angleObs,
        labelAngle: this.angleLabelObs,
        positionLabel: this.positionLabelObs,
        onClick: Z,
        angleChangeCallback: g,
        stepChangeCallback: f
      },
      { enabled: !1 }
    ).setEnabled(!0), this.onEvent(this.sliceSelectEvent, (N) => {
      this.shiftCurve(N.slice);
    }), ut.identity(this.ownerMatrix), this.initializeCprReslicer(), this.watch(this.isShown, () => {
      this.isShown.get() && setTimeout(() => {
        this.updateRuler(), this.context.repaint();
      }, 100);
    });
  }
  saveOwner() {
    const e = this.context.getViewWidget(Nt.AXIAL);
    if (e) {
      const n = e.getViewMatrix();
      ut.copy(this.ownerMatrix, n), this.context.objects.CPRCurve.owner = {
        t: e.getTangent(),
        n: e.getNormal(),
        s: e.getViewup(),
        o: e.getOrigin()
      };
    }
  }
  computeCPR(e) {
    e.length == 1 && (this.saveOwner(), this.context.objects.CPRCurve.setMaxillaMandible(this.context.CPRType)), this.inputCurveFixed.SetSimpleSpline(e, this.getCprBinormal()), this.setCPRViewMatrix(this.inputCurveFixed.Points, this.getCprBinormal());
  }
  setOwnerMatrix() {
    let e = this.context.objects.CPRCurve.owner;
    e && (this.ownerMatrix = ut.fromValues(e.t[0], e.t[1], e.t[2], 0, e.s[0], e.s[1], e.s[2], 0, e.n[0], e.n[1], e.n[2], 0, e.o[0], e.o[1], e.o[2], 1));
  }
  initializeCprReslicer() {
    const e = this.context.getEngine();
    this.reslicerCPR = new e.TCPRReslicer(), this.reslicerCPR.SetCPRHeight(this.context.CPRHeight), this.reslicerCPR.SetInputPoints(0, new Float64Array(), new Float64Array()), this.setThickness(-1);
    const n = Je.MPR;
    this.setFilterMode(n);
  }
  reinitializeInputImage() {
    this.reslicerCPR.ReinitializeInputImage(), this.reslicerCPR.SetCPRHeight(this.context.CPRHeight), this.reslicerCPR.SetInputPoints(0, new Float64Array(), new Float64Array()), this.setThickness(-1);
    const e = Je.MPR;
    this.setFilterMode(e);
  }
  setCPRViewMatrix(e, n, s) {
    var a, o;
    if (this.splineVec = [], this.splineNormals = [], this.splineBinormals = [], this.splineTangents = [], e.length > 1 && this.reslicerCPR) {
      const l = this.context.CPRMath.getOrientatedCurvePointsVec3(e), c = [], u = [];
      for (let f = 0; f < e.length; f++) {
        const T = this.context.getImageData().worldToIndex(l[f]);
        c.push(...T), u.push(...n);
      }
      this.reslicerCPR.SetInputPoints(e.length, new Float64Array(c), new Float64Array(u)), this.reslicerCPR.SetInput(), this.reslicerCPR.SetCPRThickness(this.context.CPRthickness.get());
      const d = this.context.CPRfilterMode.get();
      this.reslicerCPR.SetCPRFilterMode(yNt(d)), this.reslicerCPR.PerformCPR(), this.reslicerCPR.GetOutputImage(), this.context.splineLength.set(this.reslicerCPR.GetSplineLength());
      const h = this.reslicerCPR.GetOutputImageSpacing().slice();
      this.context.CPRSpacing.set([h[0], h[1]]), I.set(this.cprOwnerNormal, -n[0], -n[1], -n[2]), this.populateSplineFrameFromReslicer() || this.calculateSplineMoveDirections(), this.splineCurve.SetSimpleSpline(this.splineVec, n);
      const p = xs.newInstance(), m = (f) => {
        p.setDimensions([f.dimensions[1], f.dimensions[0], 1]), p.setOrigin(f.origin), p.setSpacing(f.spacing);
        const T = We.newInstance({
          size: f.data.length,
          values: f.data,
          numberOfComponents: 1,
          dataType: Ke.SHORT,
          name: "scalars"
        });
        p.getPointData().setScalars(T), b.setInputData(p);
      }, b = jp.newInstance(), y = this.reslicerCPR.GetOutputImageDim();
      m({
        data: this.reslicerCPR.GetOutputImage(),
        dimensions: [y[0], y[1]],
        origin: [0, 0, 0],
        spacing: [this.reslicerCPR.GetmmCPR(), this.reslicerCPR.Getmmy(), 0]
      });
      const Z = Up.newInstance();
      Z.setMapper(b), Z.getProperty().setColorLevel(((a = this.getPresenterWindow()) == null ? void 0 : a.level.get()) || 1e3), Z.getProperty().setColorWindow(((o = this.getPresenterWindow()) == null ? void 0 : o.window.get()) || 4e3);
      const g = ut.create();
      ut.set(g, 1, 0, 0, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 0, 0, 1), Z.setUserMatrix(g), this.addCPRActor(Z), this.updateCPRObjects(), s || (this.resetViewCamera(), this.fitZoomToScreen());
    } else
      this.renderer.removeAllActors(), this.rendererOverlay.removeAllActors(), this.textLabels.setEnabled(!1), this.altTextLabels.setEnabled(!0), this.updateCPRObjects();
    this.updateCrossSliceIndicator();
    const r = this.context.getViewWidget(Nt.AXIAL);
    r && this.context.toolManager.coordControl.onViewWidgetEvent(r, me.eVE_RENDER), s || this.context.repaint();
  }
  addCPRActor(e) {
    this.CPRActor && this.renderer.removeActor(this.CPRActor), this.renderer.addActor(e), this.CPRActor = e;
    const n = this.reslicerCPR.GetSplineLength() * this.reslicerCPR.GetOutputImageSpacing()[0];
    if (this.setupRuler(n, 1), this.context.CPRthickness.get() > 1)
      this.getOffsetIndicativeSplines(this.context.CPRthickness.get()), this.hasOffsetSplines = !0;
    else if (this.hasOffsetSplines) {
      this.hasOffsetSplines = !1;
      const s = (r) => {
        r.getViewMode() == Nt.AXIAL && (this.CPRCurveN.onViewWidgetEvent(r, me.eVE_DESTROY), this.CPRCurveP.onViewWidgetEvent(r, me.eVE_DESTROY));
      };
      this.context.sceneRepaint(void 0, s);
    }
  }
  getOffsetIndicativeSplines(e) {
    const n = [], s = [], r = e / 2;
    this.splineVec.forEach((o, l) => {
      const c = I.create(), u = I.create(), d = I.create();
      I.scale(c, this.splineNormals[l], r);
      const h = I.create();
      I.scale(h, this.splineNormals[l], -r), I.add(u, o, c), I.add(d, o, h), n.push(u), s.push(d);
    }), this.CPRCurveN.setData(s, null), this.CPRCurveP.setData(n, null);
    const a = (o, l) => {
      o.getViewMode() == Nt.AXIAL && (this.CPRCurveN.onViewWidgetEvent(o, l), this.CPRCurveP.onViewWidgetEvent(o, l));
    };
    this.context.sceneRepaint(void 0, a);
  }
  populateSplineFrameFromReslicer() {
    const e = this.reslicerCPR.GetSplinePoints(), n = this.reslicerCPR.GetSplineNormals(), s = this.reslicerCPR.GetSplineTangents(), r = this.reslicerCPR.GetSplineBinormals();
    if (e.length < 3 || n.length !== e.length || s.length !== e.length || r.length !== e.length)
      return !1;
    this.splineTangents = [], this.splineNormals = [], this.splineBinormals = [], this.splineVec = [];
    const a = this.context.getImageData().getOrigin();
    for (let o = 0; o < e.length; o += 3)
      this.splineVec.push(I.fromValues(e[o] + a[0], e[o + 1] + a[1], e[o + 2] + a[2])), this.splineNormals.push(this.readSplineVector(n, o)), this.splineTangents.push(this.readSplineVector(s, o)), this.splineBinormals.push(this.readSplineVector(r, o));
    return !0;
  }
  readSplineVector(e, n) {
    const s = I.fromValues(e[n], e[n + 1], e[n + 2]);
    return I.length(s) > Number.EPSILON && I.normalize(s, s), s;
  }
  calculateSplineMoveDirections() {
    const e = this.reslicerCPR.GetSplinePoints(), n = this.context.getImageData().getOrigin();
    let s = I.create(), r = I.create(), a = I.create();
    this.splineTangents = [], this.splineNormals = [], this.splineBinormals = [], this.splineVec = [];
    for (let o = 0; o < e.length - 3; o = o + 3) {
      let l = I.create();
      s = I.create(), r = I.create(), a = I.create(), l = I.fromValues(e[o] + n[0], e[o + 1] + n[1], e[o + 2] + n[2]), s = I.fromValues(e[o + 3] + n[0], e[o + 4] + n[1], e[o + 5] + n[2]), I.subtract(r, s, l), I.normalize(r, r), I.cross(a, this.cprOwnerNormal, r), I.normalize(a, a), this.splineVec.push(l), this.splineTangents.push(r), this.splineNormals.push(a), this.splineBinormals.push(I.clone(this.cprOwnerNormal));
    }
    this.splineVec.push(s), this.splineTangents.push(r), this.splineNormals.push(a), this.splineBinormals.push(I.clone(this.cprOwnerNormal));
  }
  setThickness(e) {
    this.context.CPRthickness.set(e), e > 1 && this.context.CPRfilterMode.get() == Je.MPR && this.context.CPRfilterMode.set(Je.RAYSUM), e == 1 && this.context.CPRfilterMode.get() != Je.MPR && this.context.CPRfilterMode.set(Je.MPR);
  }
  setFilterMode(e) {
    this.context.CPRfilterMode.set(e), e == Je.MPR ? this.context.CPRthickness.set(1) : this.context.CPRthickness.get() == 1 && this.context.CPRthickness.set(10);
  }
  getCprBinormal() {
    return I.fromValues(this.ownerMatrix[8], this.ownerMatrix[9], this.ownerMatrix[10]);
  }
  adjustCPRHeight(e) {
    const s = this.reslicerCPR.GetCPRHeight() + e;
    this.reslicerCPR.SetCPRHeight(s), this.context.CPRHeight = s, this.setCPRViewMatrix(this.inputCurveFixed.Points, this.getCprBinormal());
  }
  getCPRHeight() {
    return this.reslicerCPR.GetCPRHeight();
  }
  getCPRWidth() {
    return this.context.splineLength.get() * this.context.CPRSpacing.get()[0];
  }
  setCPRType(e) {
    this.context.CPRType = e, this.context.objects.CPRCurve.setMaxillaMandible(e);
  }
  getCPRType() {
    return this.context.CPRType;
  }
  getSplineNormals() {
    return this.splineNormals.length == 0 && !this.populateSplineFrameFromReslicer() && this.calculateSplineMoveDirections(), this.splineNormals;
  }
  updateCPRObjects() {
    this.context.objects.CPRCurve.points = this.inputCurveFixed.Points, this.context.objects.CPRCurve.splineVec = [...this.splineVec], this.context.objects.CPRCurve.splineNormals = [...this.splineNormals], this.context.objects.CPRCurve.splineTangents = [...this.splineTangents], this.context.objects.CPRCurve.splineBinormals = [...this.splineBinormals], this.context.objects.cprImage = this.CPRActor;
  }
  insertPointsFromProject() {
    this.context.objects.CPRCurve.points.length > 0 && (this.context.objects.CPRCurve.owner || this.saveOwner(), this.setOwnerMatrix(), this.computeCPR(this.context.objects.CPRCurve.points), this.context.CPRType = this.context.objects.CPRCurve.maxillaOmandible, this.pointsInsertedFromProjectFlag = !0);
  }
  shiftCurve(e, n = !1) {
    var s;
    if (Math.abs(e) < UX || n) {
      const r = this.worldToViewV3(this.getOrigin());
      this.context.curveDelta.update((o) => (o.value = e, o)), this.inputCurve.SetSimpleSpline(this.inputCurveFixed.Points, this.getCprBinormal()), this.context.cprSettings ? (this.inputCurve.ShiftCurve((this.context.curveDelta.get().value - this.previousDelta) * 0.2), this.previousDelta = this.context.curveDelta.get().value) : this.inputCurve.ShiftCurve(this.context.curveDelta.get().value * 0.2), this.setCPRViewMatrix(this.inputCurve.Points, this.getCprBinormal(), !0), this.curveMovedEvent.notify();
      const a = this.viewToWorldV3([r[0], r[1], 0]);
      return this.context.toolManager.coordControl.setCenter(a, this), (s = this.context.toolManager.cprTool) == null || s.getPointPicker().pickedPointsShifted.notify(this.inputCurve.Points), !0;
    }
    return !1;
  }
  slide(e) {
    let n = this.context.indexOnSpline.get();
    const s = I.fromValues(0, 0, 0), r = I.fromValues(0, 0, 0);
    I.subtract(r, this.getOrigin(), this.context.objects.CPRCurve.splineVec[n]), n += e, n > -1 && n < this.context.objects.CPRCurve.splineVec.length && (I.add(s, this.context.objects.CPRCurve.splineVec[n], r), this.context.indexOnSpline.set(n), this.context.toolManager.coordControl.setCenter(s, this));
  }
  projectInputPoints() {
    const e = this.context.getViewWidget(Nt.AXIAL), n = [];
    if (e)
      for (let s of this.inputCurveFixed.Points) {
        const r = I.create();
        Fs(s, e.getOrigin(), e.getNormal(), r), n.push(r);
      }
    return n;
  }
  rotateOwner(e = !1) {
    var a;
    const n = Date.now();
    if (!e && n - this.rotateOwnerLastMs < this.rotateOwnerThrottleMs)
      return;
    this.rotateOwnerLastMs = n;
    const s = this.projectInputPoints();
    this.saveOwner();
    const r = (a = this.context.toolManager.cprTool) == null ? void 0 : a.getPointPicker();
    if (r) {
      r.pickedPointsShifted.notify(s);
      return;
    }
    this.computeCPR(s);
  }
  updateOrigin2DPosition() {
    var a;
    const e = (a = this.context.getViewWidget(Nt.CROSS)) == null ? void 0 : a.getOrigin();
    if (e) {
      const o = this.worldToView(...this.context.CPRMath.convertMMtoCPR([e[0], e[1], e[2]]));
      this.origin2DPosition.set(o);
    }
    this.angleObs.set(this.context.toolManager.coordControl.crossAngle.get());
    const s = this.context.toolManager.coordControl.crossAngle.get() * 180 / Math.PI;
    this.angleLabelObs.set(Math.abs(s).toFixed(1) + "°");
    const r = this.context.indexOnSpline.get() * this.context.CPRSpacing.get()[0];
    this.positionLabelObs.set(r.toFixed(1) + " mm"), this.visibleFlag.set(!this.context.cprSettings);
  }
  updateCrossSliceIndicator() {
    this.updateOrigin2DPosition();
  }
  updateRuler() {
    if (this.viewMode == Nt.CPR && this.isShown.get()) {
      const e = this.viewSize.get()[1], n = this.renderer.getActiveCamera().getParallelScale(), s = 20 * n / e, a = [this.worldToView(0, 0, 0)[0], e - 10, 0];
      let o = [0, 100, 0];
      o = this.viewToWorld(a[0], a[1], a[2]);
      let l = [0, 0];
      l = this.worldToView(0, 0, 0), this.cprRuler && (this.cprRuler.update(s, o), this.cprRuler.updateLbPoints2D(2 * n / e * 0.992, l[0], a[1] - 30), this.renderer.addActor(this.cprRuler.getActor()));
    }
  }
  setupRuler(e, n) {
    var s;
    this.cprRuler && ((s = this.cprRuler) == null || s.setSize(e / n, e), this.updateRuler());
  }
  fitZoomToScreen() {
    const e = this.context.CPRHeight, n = this.context.objects.CPRCurve.splineVec.length * this.context.CPRSpacing.get()[0], [s, r] = this.viewSize.get();
    let a;
    const o = s / n;
    e * o > r ? a = e / 2 : a = (e + (r - e * o) / o) / 2, this.renderer.getActiveCamera().setParallelScale(a), this.cameraModified();
  }
  setBorder(e) {
    e ? this.showBorder(e) : this.hideBorder();
  }
  setViewOrigin(e) {
    if (this.context.objects.CPRCurve.splineVec.length > 1) {
      const n = ut.create(), s = ea(this.context.objects.CPRCurve.splineVec, e).nearestIndex;
      this.context.indexOnSpline.set(s), ut.set(
        n,
        ...this.context.objects.CPRCurve.splineTangents[s],
        0,
        ...this.context.objects.CPRCurve.splineBinormals[s],
        0,
        ...this.context.objects.CPRCurve.splineNormals[s],
        0,
        e[0],
        e[1],
        e[2],
        1
      ), this.setViewMatrix(n);
    }
  }
  getViewMatrixForBookmark() {
    const e = ut.create();
    if (this.context.objects.CPRCurve.splineVec.length > 1) {
      const n = this.getOrigin(), s = ea(this.context.objects.CPRCurve.splineVec, n).nearestIndex;
      this.context.indexOnSpline.set(s), ut.set(
        e,
        ...this.context.objects.CPRCurve.splineTangents[s],
        0,
        ...this.context.objects.CPRCurve.splineBinormals[s],
        0,
        ...this.context.objects.CPRCurve.splineNormals[s],
        0,
        n[0],
        n[1],
        n[2],
        1
      );
    }
    return e;
  }
  getNormal() {
    return I.fromValues(this.resliceAxes[8], this.resliceAxes[9], this.resliceAxes[10]);
  }
  getTangent() {
    return I.fromValues(this.resliceAxes[0], this.resliceAxes[1], this.resliceAxes[2]);
  }
  getViewup() {
    return I.fromValues(this.resliceAxes[4], this.resliceAxes[5], this.resliceAxes[6]);
  }
  getOrigin() {
    return I.fromValues(this.resliceAxes[12], this.resliceAxes[13], this.resliceAxes[14]);
  }
  isViewMode3D() {
    return !1;
  }
  panToPosition(e, n, s) {
    console.warn("panToPos CPR - should not be here", e, n, s);
  }
  viewToWorldV33(e) {
    const n = this.viewToDisplay(e[0], e[1]), s = this.getOrigin(), r = this.worldToDisplay(...s)[2];
    return this.displayToWorld(n[0], n[1], r);
  }
  viewToWorldV3(e) {
    if (this.context.objects.CPRCurve.splineVec.length > 1) {
      const n = this.viewToDisplay(e[0], e[1]), s = this.pickWorldPoint(n[0], n[1]), r = Fi.fromValues(s[0], s[2]);
      return this.context.CPRMath.convertCPRtoMMX(r);
    }
    return I.create();
  }
  displayToWorldV3(e) {
    if (this.context.objects.CPRCurve.splineVec.length > 1) {
      const n = this.pickWorldPoint(e[0], e[1]), s = Fi.fromValues(n[0], n[2]);
      return this.context.CPRMath.convertCPRtoMMX(s);
    }
    return I.create();
  }
  // World to view coordinates ((0, 0) is top left corner of view)
  worldToViewV3(e) {
    const n = this.context.CPRMath.convertMMtoCPR(e);
    return this.worldToView(...n);
  }
  isShownWrapper() {
    return this.isShown;
  }
  isVisible() {
    return this.context.objects.CPRCurve.splineVec.length > 1 ? this.isShown.get() : !1;
  }
  rotate(e, n) {
    console.warn("VCPR", e, n);
  }
  resetViewPosition(e) {
    e && (this.context.indexOnSpline.set(Math.floor(this.context.objects.CPRCurve.splineVec.length / 2)), this.setViewOrigin(this.context.objects.CPRCurve.splineVec[this.context.indexOnSpline.get()]));
  }
  cameraModified() {
    var n;
    this.cprRuler && (this.updateRuler(), this.cprRulerLabels.set((n = this.cprRuler) == null ? void 0 : n.lbPoints)), this.updateOrigin2DPosition();
    const e = this.viewSize.get();
    this.altLabel.update((s) => (s = [[jt("medic-web-engine.cprDoesNotExistDrawCprByPointsOrUseAutomaticCprLocalization"), [e[0] / 2, e[1] / 2]]], s)), super.cameraModified();
  }
  /*! pan camera to reslicer origin*/
  resetViewCamera() {
    var n;
    const e = this.renderer.getActiveCamera();
    if (this.context.objects.cprImage) {
      const [s, r] = this.viewSize.get(), a = s / r, o = this.context.CPRHeight, l = this.context.objects.CPRCurve.splineVec.length * this.context.CPRSpacing.get()[0], c = Math.max(l / a, o) / 2;
      e.setParallelScale(c);
      const u = this.context.objects.cprImage.getBounds();
      u[2] = -100, u[3] = 100, this.renderer.resetCameraClippingRange(u);
      const d = [(u[1] + u[0]) / 2, 0, (u[4] + u[5]) / 2], h = [0, -1, 0], p = [0, 0, 1], m = 800;
      e.setPosition(d[0] + h[0] * m, d[1] + h[1] * m, d[2] + h[2] * m), e.setFocalPoint(d[0], d[1], d[2]), e.setViewUp(p[0], p[1], p[2]), this.cameraModified();
    } else
      console.log("resetViewCamera CPR this.context.objects.cprImage == null");
    this.altTextLabels.setEnabled(!this.context.objects.hasCPR()), this.textLabels.setEnabled(this.context.objects.hasCPR()), (n = this.cprRuler) == null || n.getActor().setVisibility(this.context.objects.hasCPR());
  }
  getWindowLevel() {
    let e = 0, n = 0;
    const s = this.context.objects.cprImage;
    return s && (e = s.getProperty().getColorWindow(), n = s.getProperty().getColorLevel()), [e, n];
  }
  setWindowLevel(e) {
    const n = this.context.objects.cprImage;
    n && (n.getProperty().setColorWindow(e[0]), n.getProperty().setColorLevel(e[1])), this.presenterWindow.window.set(e[0]), this.presenterWindow.level.set(e[1]);
  }
  cleanup() {
    try {
      this.reslicerCPR.delete();
    } catch (e) {
      console.log(e);
    }
    super.cleanup();
  }
}
function yNt(i) {
  return i == Je.MPR ? Xa._MPR : i === Je.MIP ? Xa._MIP : i === Je.RAYSUM ? Xa._RAYSUM : i === Je.MINMIP ? Xa._MINMIP : i === Je.SCOUT ? Xa._SCOUT : i === Je.CAPTURE_3D ? Xa._CAPTURE_3D : i === Je.CAPTURE_MIP ? Xa._CAPTURE_MIP : i === Je.CUSTOM_FILTER_0 ? Xa._CUSTOM_FILTER_0 : i === Je.CUSTOM_FILTER_1 ? Xa._CUSTOM_FILTER_1 : i === Je.CUSTOM_FILTER_2 ? Xa._CUSTOM_FILTER_2 : i === Je.CUSTOM_FILTER_3 ? Xa._CUSTOM_FILTER_3 : Xa._MPR;
}
class ZNt extends wC {
  constructor(e, n, s = {}) {
    super(e, ni.PresenterWindow2DCustom);
    S(this, "views", []);
    S(this, "localRotation", new qt(0));
    S(this, "imageSpacing", new qt(0));
    S(this, "imageSlider", Lt(0));
    S(this, "windowSize");
    S(this, "selectedSpacing", new qt(0));
    S(this, "mainView");
    S(this, "mainViewViewport", Ce.fullscreen);
    S(this, "viewports", []);
    S(this, "computedOffsets", []);
    S(this, "viewMode");
    S(this, "viewOptions");
    S(this, "slider");
    S(this, "setFilterModeEvent", new se());
    S(this, "setCPRThicknessEvent", new se());
    S(this, "setFilterCPRThicknessEvent", new se());
    this.mainView = new gNt(e, n, this, s), this.mainView.setBorder([155, 255, 0]), this.viewOptions = s, this.viewMode = n;
    const { onEvent: r, computed: a, watch: o, cleanupAll: l } = An();
    this.onCleanup(() => l()), o(this.isFullscreen, () => {
      this.returnMainView().fitZoomToScreen(), this.returnMainView().cameraModified();
    });
    const c = this.context.getState();
    this.windowSize = a(() => {
      const [b, y] = c.canvasSize.get(), Z = this.viewport.get();
      return [b * (Z.xmax - Z.xmin), y * (Z.ymax - Z.ymin)];
    }), o(this.viewport, () => {
      this.setViewViewport(this.mainView, this.mainViewViewport), this.views.forEach((b, y) => {
        this.setViewViewport(b, this.viewports[y]);
      });
    });
    const { createVueOverlayComponent: u, cleanup: d } = Pi(this.overlayContainer.getElement());
    this.onCleanup(() => d());
    const h = (b, y, Z) => {
      let g = y, f = Z;
      if (b == "Auto Contrast") {
        const T = this.context.getImageData().getPointData().getScalars().getRange();
        g = T[1] - T[0], f = (T[0] + T[1]) / 2;
      } else b == "Default W/L" && (g = this.context.settings.general.defaultWindowWidth, f = this.context.settings.general.defaultWindowLevel);
      this.context.getPresenterWindows().forEach((T) => {
        var M;
        (M = T.getMainView()) != null && M.isViewMode3D() || T.setWindowLevel([g, f]);
      }), this.context.sceneRepaint(this.mainView);
    }, p = [Je.MPR, Je.RAYSUM, Je.MIP, Je.MINMIP], m = u(
      _bt,
      {
        isFullscreen: this.isFullscreen,
        filterMode: this.context.CPRfilterMode,
        thickness: this.context.CPRthickness,
        filterModeOptions: p,
        sliceWindow: this.window,
        sliceLevel: this.level,
        setWindowLevel: h,
        events: {
          setFullscreenEvent: this.setFullscreenEvent,
          setFilterModeEvent: this.setFilterModeEvent,
          setThicknessEvent: this.setCPRThicknessEvent,
          screenshotEvent: this.screenshotEvent
        }
      },
      {
        enabled: this.toolbarEnabled.get(),
        z: 10
      }
    );
    m.setEnabled(this.toolbarEnabled.get()), o(this.toolbarEnabled, (b) => {
      m.setEnabled(b);
    }), this.slider = u(
      IP,
      {
        sliceInfo: this.context.curveDelta,
        viewSize: this.windowSize,
        events: {
          sliceSelectEvent: this.mainView.sliceSelectEvent
        }
      },
      { z: 10, enabled: !1 }
    ), r(this.screenshotEvent, async () => {
      if (this.mainView) {
        const b = await aw({ context: this.context, view: this.mainView });
        if (!b)
          return;
        await this.downloadAndNotifyScreenshot(b, this.mainView.getViewMode());
      }
    }), r(this.setFilterModeEvent, (b) => {
      this.context.CPRfilterMode.get() != b.filterMode && (this.context.CPRfilterMode.set(b.filterMode), this.mainView.setFilterMode(b.filterMode), this.mainView.setCPRViewMatrix(this.mainView.inputCurveFixed.Points, this.mainView.getCprBinormal()), this.context.sceneRepaint(this.mainView));
    }), r(this.setCPRThicknessEvent, (b) => {
      Math.abs(this.context.CPRthickness.get() || 0 - b.thickness) > 0.01 && (this.context.CPRthickness.set(b.thickness), this.mainView.setThickness(b.thickness), this.mainView.setCPRViewMatrix(this.mainView.inputCurveFixed.Points, this.mainView.getCprBinormal()), this.context.sceneRepaint(this.mainView));
    }), r(this.setFilterCPRThicknessEvent, (b) => {
      (this.context.CPRfilterMode.get() != b.filterMode || Math.abs(this.context.CPRthickness.get() || 0 - b.thickness) > 0.01) && (this.context.CPRfilterMode.set(b.filterMode), this.context.CPRthickness.set(b.thickness), this.mainView.setFilterMode(b.filterMode), this.mainView.setThickness(b.thickness), this.mainView.setCPRViewMatrix(this.mainView.inputCurveFixed.Points, this.mainView.getCprBinormal()), this.context.sceneRepaint(this.mainView));
    }), this.mainView.fitZoomToScreen(), this.mainView.updateCrossSliceIndicator();
  }
  show(e) {
    super.show(e), this.mainView.updateCrossSliceIndicator(), this.slider.setEnabled(!0), this.mainView.show(e), this.views.forEach((n) => n.show(e));
  }
  hide() {
    this.mainView.hide(), this.slider.setEnabled(!1), this.views.forEach((e) => e.hide()), super.hide();
  }
  cleanup() {
    this.views.forEach((e) => e.cleanup()), this.mainView.cleanup(), this.computedOffsets.forEach((e) => e.stop()), super.cleanup();
  }
  returnMainView() {
    return this.mainView;
  }
  startZoom(e, n, s) {
    const r = s.displayToWorld(e, n, 0);
    this.mainView.startZoom(r[0], r[1], r[2]), this.views.forEach((a) => {
      a.startZoom(r[0], r[1], r[2]);
    });
  }
  zoomWidget(e, n) {
    this.mainView.zoomWidget(e, n), this.views.forEach((s) => {
      s.zoomWidget(e, n);
    });
  }
  endZoom() {
    this.mainView.endZoom(), this.views.forEach((e) => {
      e.endZoom();
    });
  }
  panWidget(e) {
    var n;
    (n = this.context.getInteractorStyle()) == null || n.handleMousePan(this.mainView.getRenderer(), e), this.context.toolManager.coordControl.onViewWidgetEvent(this.mainView, me.eVE_RENDER), this.views.forEach((s) => {
      var r;
      (r = this.context.getInteractorStyle()) == null || r.handleMousePan(s.getRenderer(), e);
    });
  }
  getBookmark() {
    return {
      id: this.mainView.id,
      matrix: ut.clone(this.mainView.getViewMatrixForBookmark()),
      layout: this.context.getLayout(),
      curveDelta: this.context.curveDelta.get().value
    };
  }
  setWindowLevel(e) {
    this.mainView.setWindowLevel(e);
  }
  setViewOrigin(e) {
    this.mainView.setViewOrigin(e);
  }
  hideOverlayComponents(e) {
    this.toolbarEnabled.set(!e), this.mainView.hideOverlayComponents(e);
  }
}
class c2 extends wC {
  constructor(e, n, s, r = {}) {
    super(e, ni.PresenterWindow3D);
    S(this, "mainView");
    S(this, "setVolumeTemplateEvent", new se());
    S(this, "toggleVolumeVisibilityEvent", new se());
    S(this, "toggleObjectTypeVisibilityEvent", new se());
    S(this, "volumeVisibility", !0);
    S(this, "implantVisibility", !0);
    S(this, "abutmentVisibility", !0);
    S(this, "sleeveVisibility", !0);
    this.mainView = new n(e, s, r);
    const { watch: a, cleanupAll: o, onEvent: l } = An();
    this.onCleanup(() => o()), a(this.viewport, () => {
      this.setViewViewport(this.mainView, Ce.fullscreen);
    });
    const { createVueOverlayComponent: c, cleanup: u } = Pi(this.overlayContainer.getElement());
    if (this.onCleanup(() => u()), !r.toolbarDisable) {
      const d = (p) => {
        this.context.toolManager.coordControl.setScoutDispalyMode(p), this.context.sceneRepaint();
      }, h = c(
        Qbt,
        {
          isFullscreen: this.isFullscreen,
          setScoutPlanesType: d,
          events: {
            setFullscreenEvent: this.setFullscreenEvent,
            screenshotEvent: this.screenshotEvent,
            setVolumeTemplateEvent: this.setVolumeTemplateEvent,
            toggleVolumeVisibilityEvent: this.toggleVolumeVisibilityEvent,
            toggleObjectTypeVisibilityEvent: this.toggleObjectTypeVisibilityEvent
          }
        },
        {
          enabled: this.toolbarEnabled.get(),
          z: 10
        }
      );
      h.setEnabled(this.toolbarEnabled.get()), a(this.toolbarEnabled, (p) => {
        h.setEnabled(p);
      }), l(this.toggleObjectTypeVisibilityEvent, (p) => {
        p === 0 ? (this.implantVisibility = !this.implantVisibility, this.abutmentVisibility = !this.abutmentVisibility, this.sleeveVisibility = !this.sleeveVisibility, this.context.objects.setAllObjectsVisibility(this.implantVisibility, Yt._IMPLANT), this.context.objects.setAllObjectsVisibility(this.implantVisibility, Yt._PIN)) : p === 1 ? (this.abutmentVisibility = !this.abutmentVisibility, this.context.objects.setAllObjectsVisibility(this.abutmentVisibility, Yt._ABUTMENT)) : p === 2 && (this.sleeveVisibility = !this.sleeveVisibility, this.context.objects.setAllObjectsVisibility(this.sleeveVisibility, Yt._SLEEVE));
      }), l(this.setVolumeTemplateEvent, (p) => {
        this.volumeVisibility = !0, this.context.setVolumeActorVisibility(this.volumeVisibility), p === 0 ? this.context.setVolumeOptions(Sy.Dental.XRay) : p === 1 ? this.context.setVolumeOptions(Sy.Dental.Bones) : p === 2 ? this.context.setVolumeOptions(Sy.Dental.SoftTissues) : p === 3 && this.context.setVolumeOptions(Sy.Dental.Teeth);
      }), l(this.toggleVolumeVisibilityEvent, () => {
        this.volumeVisibility = !this.volumeVisibility, this.context.setVolumeActorVisibility(this.volumeVisibility);
      }), l(this.screenshotEvent, async () => {
        if (this.mainView) {
          const p = await aw({ context: this.context, view: this.mainView });
          if (!p)
            return;
          await this.downloadAndNotifyScreenshot(p, this.mainView.getViewMode());
        }
      });
    }
  }
  getBookmark() {
    return {
      id: this.mainView.id,
      matrix: ut.clone(this.getViewMatrix()),
      layout: this.context.getLayout()
    };
  }
  panWidget(e) {
    var n;
    (n = this.context.getInteractorStyle()) == null || n.handleMousePan(this.mainView.getRenderer(), e);
  }
  returnMainView() {
    return this.mainView;
  }
  show(e) {
    super.show(e);
  }
  hide() {
    super.hide();
  }
  cleanup() {
    this.mainView.cleanup(), super.cleanup();
  }
  hideOverlayComponents(e) {
    this.toolbarEnabled.set(!e), this.mainView.hideOverlayComponents(e);
  }
}
class TNt extends op {
  constructor(t, e, n = {}) {
    var r;
    super(t, e, n), IW(this.renderer, 0), this.renderer.resetCamera();
    const s = {
      onMouseWheel(a, o, l) {
        const c = a.displayToView(o.position.x, o.position.y), [u, d] = a.viewSize.get();
        return !(c[0] >= 0 && c[0] < u && c[1] >= 0 && c[1] < d);
      }
    };
    (r = this.context.getInteractorStyle()) == null || r.setViewEventHandler(this, s);
  }
  addActor(t, e = 0, n) {
    super.addActor(t, e, n);
  }
  isViewMode3D() {
    return !0;
  }
  panToPosition(t, e, n) {
    const s = this.renderer.getActiveCamera(), r = s.getDistance(), a = s.getViewPlaneNormal();
    s.setPosition(t + r * a[0], e + r * a[1], n + r * a[2]), s.setFocalPoint(t, e, n), this.renderer.resetCameraClippingRange(), this.cameraModified();
  }
  resetViewCamera(t) {
    const e = this.renderer.getActiveCamera();
    t && X0({
      camera: e,
      orientation: "front",
      focalPoint: t,
      distance: 1
    }), this.renderer.resetCamera();
  }
  mergeBounds(t, e) {
    const n = [...t];
    return n[0] = Math.min(t[0], e[0]), n[1] = Math.max(t[1], e[1]), n[2] = Math.min(t[2], e[2]), n[3] = Math.max(t[3], e[3]), n[4] = Math.min(t[4], e[4]), n[5] = Math.max(t[5], e[5]), n;
  }
  isBoundsInvalid(t) {
    return t[0] == 1 && t[1] == -1 && t[2] == 1 && t[3] == -1 && t[4] == 1 && t[5] == -1;
  }
  getVisibleBounds() {
    const t = this.renderer.computeVisiblePropBounds(), e = this.rendererOverlay.computeVisiblePropBounds(), n = this.isBoundsInvalid(t), s = this.isBoundsInvalid(e);
    return n && s ? null : n ? e : s ? t : this.mergeBounds(t, e);
  }
  /** Reset preview camera to a custom plane-facing projection. */
  resetViewCameraToPlane(t, e, n) {
    const s = this.renderer.getActiveCamera(), r = I.fromValues(e[0], e[1], e[2]), a = I.fromValues(n[0], n[1], n[2]);
    if (I.length(r) < 1e-6 || I.length(a) < 1e-6) {
      this.resetViewCamera(t);
      return;
    }
    if (I.normalize(r, r), I.normalize(a, a), Math.abs(I.dot(r, a)) > 0.98) {
      const c = Math.abs(r[2]) < 0.9 ? I.fromValues(0, 0, 1) : I.fromValues(0, 1, 0);
      I.cross(a, c, r), I.length(a) < 1e-6 && I.cross(a, I.fromValues(1, 0, 0), r), I.normalize(a, a);
    }
    this.renderer.resetCamera();
    const o = Math.max(s.getDistance(), 1);
    s.setFocalPoint(t[0], t[1], t[2]), s.setPosition(t[0] - r[0] * o, t[1] - r[1] * o, t[2] - r[2] * o), s.setViewUp(a[0], a[1], a[2]);
    const l = this.getVisibleBounds();
    if (l) {
      const c = I.clone(r), u = I.cross(I.create(), c, a);
      I.length(u) < 1e-6 && I.cross(u, c, I.fromValues(0, 0, 1)), I.length(u) < 1e-6 && I.cross(u, c, I.fromValues(1, 0, 0)), I.normalize(u, u);
      const d = I.clone(a);
      I.normalize(d, d);
      const h = [
        [l[0], l[2], l[4]],
        [l[0], l[2], l[5]],
        [l[0], l[3], l[4]],
        [l[0], l[3], l[5]],
        [l[1], l[2], l[4]],
        [l[1], l[2], l[5]],
        [l[1], l[3], l[4]],
        [l[1], l[3], l[5]]
      ];
      let p = 0, m = 0;
      for (const f of h) {
        const T = I.fromValues(f[0] - t[0], f[1] - t[1], f[2] - t[2]);
        p = Math.max(p, Math.abs(I.dot(T, u))), m = Math.max(m, Math.abs(I.dot(T, d)));
      }
      const [b, y] = this.state.viewSize.get(), Z = b > 0 && y > 0 ? b / y : 1, g = Math.max(m, p / Math.max(Z, 1e-6));
      g > 1e-6 && s.setParallelScale(g * 1.15), this.renderer.resetCameraClippingRange(l);
    } else
      this.renderer.resetCameraClippingRange();
    this.cameraModified();
  }
  fitZoomToScreen() {
    const t = (b, y) => {
      const Z = [...b];
      return Z[0] = Math.min(b[0], y[0]), Z[1] = Math.max(b[1], y[1]), Z[2] = Math.min(b[2], y[2]), Z[3] = Math.max(b[3], y[3]), Z[4] = Math.min(b[4], y[4]), Z[5] = Math.max(b[5], y[5]), Z;
    }, e = this.rendererOverlay.computeVisiblePropBounds();
    let n;
    e[0] == 1 && e[1] == -1 && e[2] == 1 && e[3] == -1 && e[4] == 1 && e[5] == -1 ? n = this.renderer.computeVisiblePropBounds() : n = t(this.renderer.computeVisiblePropBounds(), e), this.renderer.resetCameraClippingRange(n);
    const s = [(n[1] + n[0]) / 2, (n[3] + n[2]) / 2, (n[5] + n[4]) / 2], r = [0, -1, 0], a = [0, 0, 1], l = this.getRenderer().getActiveCamera(), c = l.getDistance();
    l.setPosition(s[0] + c * r[0], s[1] + c * r[1], s[2] + c * r[2]), l.setViewUp(a), l.setFocalPoint(...s);
    const [u, d] = this.state.viewSize.get();
    let h = 1;
    const p = u / (n[1] - n[0]);
    (n[5] - n[4]) * p > d ? h = (n[5] - n[4]) / 2 : h = (n[5] - n[4] + (d - (n[5] - n[4]) * p) / p) / 2, this.renderer.getActiveCamera().setParallelScale(h * 1.5), this.cameraModified();
  }
  cleanup() {
    super.cleanup();
  }
}
function MNt(i, t) {
  t.classHierarchy.push("vtkCircleSource");
  function e(n, s) {
    if (t.deleted)
      return;
    let r = s[0];
    const a = tt.newTypedArray(t.pointType, t.resolution * 3), o = new Uint32Array(t.resolution + 2);
    o[0] = t.resolution + 1;
    const l = 2 * Math.PI / t.resolution;
    for (let c = 0; c < t.resolution; c++) {
      const u = t.center[0], d = t.radius * Math.cos(c * l) + t.center[1], h = t.radius * Math.sin(c * l) + t.center[2];
      a.set([u, d, h], c * 3), o[c + 1] = c;
    }
    o[o.length - 1] = o[1], r = Ie.newInstance(), r.getPoints().setData(a, 3), t.lines && r.getLines().setData(o, 1), t.face && r.getPolys().setData(o, 1), il.buildFromRadian().translate(...t.center).rotateFromDirections([1, 0, 0], t.direction).translate(...h2([...t.center], -1)).apply(a), s[0] = r;
  }
  i.requestData = e;
}
function NNt(i) {
  return {
    face: !0,
    center: [0, 0, 0],
    lines: !1,
    direction: [1, 0, 0],
    pointType: "Float64Array",
    radius: 1,
    resolution: 6,
    ...i
  };
}
function yA(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, NNt(e)), tt.obj(i, t), tt.setGet(i, t, ["radius", "resolution", "lines", "face"]), tt.setGetArray(i, t, ["center", "direction"], 3), tt.algo(i, t, 0, 1), MNt(i, t);
}
const WNt = tt.newInstance(yA, "vtkCircleSource");
var GNt = {
  newInstance: WNt,
  extend: yA
};
const {
  vtkErrorMacro: Iz
} = tt;
function wNt(i, t) {
  t.classHierarchy.push("vtkImageCropFilter"), i.reset = () => {
    const e = i.getInputData();
    e && i.setCroppingPlanes(...e.getExtent());
  }, i.requestData = (e, n) => {
    const s = e[0];
    if (!s) {
      Iz("Invalid or missing input");
      return;
    }
    const r = s.getPointData().getScalars();
    if (!r) {
      Iz("No scalars from input");
      return;
    }
    const a = s.getExtent(), o = t.croppingPlanes && t.croppingPlanes.length === 6 ? a.map((T, M) => M % 2 === 0 ? Math.max(T, Math.round(t.croppingPlanes[M])) : Math.min(T, Math.round(t.croppingPlanes[M]))) : a.slice();
    if (o[0] === a[0] && o[1] === a[1] && o[2] === a[2] && o[3] === a[3] && o[4] === a[4] && o[5] === a[5]) {
      const T = xs.newInstance();
      T.shallowCopy(s), n[0] = T;
      return;
    }
    for (let T = 0; T < 3; ++T)
      o[T * 2] > o[T * 2 + 1] && ([o[T * 2], o[T * 2 + 1]] = [o[T * 2 + 1], o[T * 2]]);
    for (let T = 0; T < 6; T += 2)
      o[T] = Math.max(o[T], a[T]), o[T + 1] = Math.min(o[T + 1], a[T + 1]);
    const l = r.getNumberOfComponents(), c = (o[1] - o[0] + 1) * (o[3] - o[2] + 1) * (o[5] - o[4] + 1) * l, u = r.getData(), d = s.getDimensions(), h = l * d[0], p = l * d[0] * d[1], m = (o[0] - a[0]) * l, b = (o[1] - o[0] + 1) * l, y = new u.constructor(c);
    let Z = 0;
    for (let T = o[4]; T <= o[5]; ++T)
      for (let M = o[2]; M <= o[3]; ++M) {
        const N = m + (M - a[2]) * h + (T - a[4]) * p, W = N + b, x = u.subarray(N, W);
        y.set(x, Z), Z += x.length;
      }
    const g = xs.newInstance({
      extent: o,
      origin: s.getOrigin(),
      direction: s.getDirection(),
      spacing: s.getSpacing()
    }), f = We.newInstance({
      name: r.getName(),
      numberOfComponents: l,
      values: y
    });
    g.getPointData().setScalars(f), n[0] = g;
  }, i.isResetAvailable = () => {
    if (t.croppingPlanes == null || t.croppingPlanes.length === 0)
      return !1;
    const e = i.getInputData();
    return e ? e.getExtent().find((r, a) => Math.abs(t.croppingPlanes[a] - r) > Number.EPSILON) !== void 0 : !1;
  };
}
const xNt = {
  // croppingPlanes: null,
};
function ZA(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, xNt, e), tt.obj(i, t), tt.algo(i, t, 1, 1), tt.setGetArray(i, t, ["croppingPlanes"], 6), wNt(i, t);
}
const SNt = tt.newInstance(ZA, "vtkImageCropFilter");
var TA = {
  newInstance: SNt,
  extend: ZA
};
class LNt {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    this.oriented = t, this.edgeMap = /* @__PURE__ */ new Map();
  }
  initialize() {
    this.edgeMap.clear();
  }
  computeEdgeKey(t, e) {
    return this.oriented || t < e ? (
      // Cantor pairing function:
      0.5 * (t * e) * (t * e + 1) + e
    ) : 0.5 * (e * t) * (e * t + 1) + t;
  }
  insertUniqueEdge(t, e, n) {
    const s = this.computeEdgeKey(t, e);
    let r = this.edgeMap.get(s);
    return r || (r = {
      key: s,
      edgeId: this.edgeMap.size,
      value: n
    }, this.edgeMap.set(s, r)), r;
  }
  insertEdge(t, e, n) {
    const s = this.computeEdgeKey(t, e), r = {
      key: s,
      edgeId: this.edgeMap.size,
      value: n
    };
    return this.edgeMap.set(s, r), r;
  }
  isInsertedEdge(t, e) {
    const n = this.computeEdgeKey(t, e);
    return this.edgeMap.get(n);
  }
  static getEdgePointIds(t) {
    const e = 0.5 * (-1 + Math.sqrt(8 * t.key + 1)), n = t.key - 0.5 * (e + 1) * e, s = e - n;
    return [n, s];
  }
}
function VNt() {
  let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return new LNt(i.oriented);
}
var XNt = {
  newInstance: VNt
};
const INt = [
  [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [0, 3, 8, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [0, 9, 1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [1, 3, 8, 9, 1, 8, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [1, 11, 2, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [0, 3, 8, 1, 11, 2, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [9, 11, 2, 0, 9, 2, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [2, 3, 8, 2, 8, 11, 11, 8, 9, -1, -1, -1, -1, -1, -1, -1],
  [3, 2, 10, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [0, 2, 10, 8, 0, 10, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [1, 0, 9, 2, 10, 3, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [1, 2, 10, 1, 10, 9, 9, 10, 8, -1, -1, -1, -1, -1, -1, -1],
  [3, 1, 11, 10, 3, 11, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [0, 1, 11, 0, 11, 8, 8, 11, 10, -1, -1, -1, -1, -1, -1, -1],
  [3, 0, 9, 3, 9, 10, 10, 9, 11, -1, -1, -1, -1, -1, -1, -1],
  [9, 11, 8, 11, 10, 8, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [4, 8, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [4, 0, 3, 7, 4, 3, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [0, 9, 1, 8, 7, 4, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [4, 9, 1, 4, 1, 7, 7, 1, 3, -1, -1, -1, -1, -1, -1, -1],
  [1, 11, 2, 8, 7, 4, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [3, 7, 4, 3, 4, 0, 1, 11, 2, -1, -1, -1, -1, -1, -1, -1],
  [9, 11, 2, 9, 2, 0, 8, 7, 4, -1, -1, -1, -1, -1, -1, -1],
  [2, 9, 11, 2, 7, 9, 2, 3, 7, 7, 4, 9, -1, -1, -1, -1],
  [8, 7, 4, 3, 2, 10, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [10, 7, 4, 10, 4, 2, 2, 4, 0, -1, -1, -1, -1, -1, -1, -1],
  [9, 1, 0, 8, 7, 4, 2, 10, 3, -1, -1, -1, -1, -1, -1, -1],
  [4, 10, 7, 9, 10, 4, 9, 2, 10, 9, 1, 2, -1, -1, -1, -1],
  [3, 1, 11, 3, 11, 10, 7, 4, 8, -1, -1, -1, -1, -1, -1, -1],
  [1, 11, 10, 1, 10, 4, 1, 4, 0, 7, 4, 10, -1, -1, -1, -1],
  [4, 8, 7, 9, 10, 0, 9, 11, 10, 10, 3, 0, -1, -1, -1, -1],
  [4, 10, 7, 4, 9, 10, 9, 11, 10, -1, -1, -1, -1, -1, -1, -1],
  [9, 4, 5, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [9, 4, 5, 0, 3, 8, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [0, 4, 5, 1, 0, 5, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [8, 4, 5, 8, 5, 3, 3, 5, 1, -1, -1, -1, -1, -1, -1, -1],
  [1, 11, 2, 9, 4, 5, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [3, 8, 0, 1, 11, 2, 4, 5, 9, -1, -1, -1, -1, -1, -1, -1],
  [5, 11, 2, 5, 2, 4, 4, 2, 0, -1, -1, -1, -1, -1, -1, -1],
  [2, 5, 11, 3, 5, 2, 3, 4, 5, 3, 8, 4, -1, -1, -1, -1],
  [9, 4, 5, 2, 10, 3, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [0, 2, 10, 0, 10, 8, 4, 5, 9, -1, -1, -1, -1, -1, -1, -1],
  [0, 4, 5, 0, 5, 1, 2, 10, 3, -1, -1, -1, -1, -1, -1, -1],
  [2, 5, 1, 2, 8, 5, 2, 10, 8, 4, 5, 8, -1, -1, -1, -1],
  [11, 10, 3, 11, 3, 1, 9, 4, 5, -1, -1, -1, -1, -1, -1, -1],
  [4, 5, 9, 0, 1, 8, 8, 1, 11, 8, 11, 10, -1, -1, -1, -1],
  [5, 0, 4, 5, 10, 0, 5, 11, 10, 10, 3, 0, -1, -1, -1, -1],
  [5, 8, 4, 5, 11, 8, 11, 10, 8, -1, -1, -1, -1, -1, -1, -1],
  [9, 8, 7, 5, 9, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [9, 0, 3, 9, 3, 5, 5, 3, 7, -1, -1, -1, -1, -1, -1, -1],
  [0, 8, 7, 0, 7, 1, 1, 7, 5, -1, -1, -1, -1, -1, -1, -1],
  [1, 3, 5, 3, 7, 5, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [9, 8, 7, 9, 7, 5, 11, 2, 1, -1, -1, -1, -1, -1, -1, -1],
  [11, 2, 1, 9, 0, 5, 5, 0, 3, 5, 3, 7, -1, -1, -1, -1],
  [8, 2, 0, 8, 5, 2, 8, 7, 5, 11, 2, 5, -1, -1, -1, -1],
  [2, 5, 11, 2, 3, 5, 3, 7, 5, -1, -1, -1, -1, -1, -1, -1],
  [7, 5, 9, 7, 9, 8, 3, 2, 10, -1, -1, -1, -1, -1, -1, -1],
  [9, 7, 5, 9, 2, 7, 9, 0, 2, 2, 10, 7, -1, -1, -1, -1],
  [2, 10, 3, 0, 8, 1, 1, 8, 7, 1, 7, 5, -1, -1, -1, -1],
  [10, 1, 2, 10, 7, 1, 7, 5, 1, -1, -1, -1, -1, -1, -1, -1],
  [9, 8, 5, 8, 7, 5, 11, 3, 1, 11, 10, 3, -1, -1, -1, -1],
  [5, 0, 7, 5, 9, 0, 7, 0, 10, 1, 11, 0, 10, 0, 11, -1],
  [10, 0, 11, 10, 3, 0, 11, 0, 5, 8, 7, 0, 5, 0, 7, -1],
  [10, 5, 11, 7, 5, 10, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [11, 5, 6, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [0, 3, 8, 5, 6, 11, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [9, 1, 0, 5, 6, 11, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [1, 3, 8, 1, 8, 9, 5, 6, 11, -1, -1, -1, -1, -1, -1, -1],
  [1, 5, 6, 2, 1, 6, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [1, 5, 6, 1, 6, 2, 3, 8, 0, -1, -1, -1, -1, -1, -1, -1],
  [9, 5, 6, 9, 6, 0, 0, 6, 2, -1, -1, -1, -1, -1, -1, -1],
  [5, 8, 9, 5, 2, 8, 5, 6, 2, 3, 8, 2, -1, -1, -1, -1],
  [2, 10, 3, 11, 5, 6, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [10, 8, 0, 10, 0, 2, 11, 5, 6, -1, -1, -1, -1, -1, -1, -1],
  [0, 9, 1, 2, 10, 3, 5, 6, 11, -1, -1, -1, -1, -1, -1, -1],
  [5, 6, 11, 1, 2, 9, 9, 2, 10, 9, 10, 8, -1, -1, -1, -1],
  [6, 10, 3, 6, 3, 5, 5, 3, 1, -1, -1, -1, -1, -1, -1, -1],
  [0, 10, 8, 0, 5, 10, 0, 1, 5, 5, 6, 10, -1, -1, -1, -1],
  [3, 6, 10, 0, 6, 3, 0, 5, 6, 0, 9, 5, -1, -1, -1, -1],
  [6, 9, 5, 6, 10, 9, 10, 8, 9, -1, -1, -1, -1, -1, -1, -1],
  [5, 6, 11, 4, 8, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [4, 0, 3, 4, 3, 7, 6, 11, 5, -1, -1, -1, -1, -1, -1, -1],
  [1, 0, 9, 5, 6, 11, 8, 7, 4, -1, -1, -1, -1, -1, -1, -1],
  [11, 5, 6, 1, 7, 9, 1, 3, 7, 7, 4, 9, -1, -1, -1, -1],
  [6, 2, 1, 6, 1, 5, 4, 8, 7, -1, -1, -1, -1, -1, -1, -1],
  [1, 5, 2, 5, 6, 2, 3, 4, 0, 3, 7, 4, -1, -1, -1, -1],
  [8, 7, 4, 9, 5, 0, 0, 5, 6, 0, 6, 2, -1, -1, -1, -1],
  [7, 9, 3, 7, 4, 9, 3, 9, 2, 5, 6, 9, 2, 9, 6, -1],
  [3, 2, 10, 7, 4, 8, 11, 5, 6, -1, -1, -1, -1, -1, -1, -1],
  [5, 6, 11, 4, 2, 7, 4, 0, 2, 2, 10, 7, -1, -1, -1, -1],
  [0, 9, 1, 4, 8, 7, 2, 10, 3, 5, 6, 11, -1, -1, -1, -1],
  [9, 1, 2, 9, 2, 10, 9, 10, 4, 7, 4, 10, 5, 6, 11, -1],
  [8, 7, 4, 3, 5, 10, 3, 1, 5, 5, 6, 10, -1, -1, -1, -1],
  [5, 10, 1, 5, 6, 10, 1, 10, 0, 7, 4, 10, 0, 10, 4, -1],
  [0, 9, 5, 0, 5, 6, 0, 6, 3, 10, 3, 6, 8, 7, 4, -1],
  [6, 9, 5, 6, 10, 9, 4, 9, 7, 7, 9, 10, -1, -1, -1, -1],
  [11, 9, 4, 6, 11, 4, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [4, 6, 11, 4, 11, 9, 0, 3, 8, -1, -1, -1, -1, -1, -1, -1],
  [11, 1, 0, 11, 0, 6, 6, 0, 4, -1, -1, -1, -1, -1, -1, -1],
  [8, 1, 3, 8, 6, 1, 8, 4, 6, 6, 11, 1, -1, -1, -1, -1],
  [1, 9, 4, 1, 4, 2, 2, 4, 6, -1, -1, -1, -1, -1, -1, -1],
  [3, 8, 0, 1, 9, 2, 2, 9, 4, 2, 4, 6, -1, -1, -1, -1],
  [0, 4, 2, 4, 6, 2, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [8, 2, 3, 8, 4, 2, 4, 6, 2, -1, -1, -1, -1, -1, -1, -1],
  [11, 9, 4, 11, 4, 6, 10, 3, 2, -1, -1, -1, -1, -1, -1, -1],
  [0, 2, 8, 2, 10, 8, 4, 11, 9, 4, 6, 11, -1, -1, -1, -1],
  [3, 2, 10, 0, 6, 1, 0, 4, 6, 6, 11, 1, -1, -1, -1, -1],
  [6, 1, 4, 6, 11, 1, 4, 1, 8, 2, 10, 1, 8, 1, 10, -1],
  [9, 4, 6, 9, 6, 3, 9, 3, 1, 10, 3, 6, -1, -1, -1, -1],
  [8, 1, 10, 8, 0, 1, 10, 1, 6, 9, 4, 1, 6, 1, 4, -1],
  [3, 6, 10, 3, 0, 6, 0, 4, 6, -1, -1, -1, -1, -1, -1, -1],
  [6, 8, 4, 10, 8, 6, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [7, 6, 11, 7, 11, 8, 8, 11, 9, -1, -1, -1, -1, -1, -1, -1],
  [0, 3, 7, 0, 7, 11, 0, 11, 9, 6, 11, 7, -1, -1, -1, -1],
  [11, 7, 6, 1, 7, 11, 1, 8, 7, 1, 0, 8, -1, -1, -1, -1],
  [11, 7, 6, 11, 1, 7, 1, 3, 7, -1, -1, -1, -1, -1, -1, -1],
  [1, 6, 2, 1, 8, 6, 1, 9, 8, 8, 7, 6, -1, -1, -1, -1],
  [2, 9, 6, 2, 1, 9, 6, 9, 7, 0, 3, 9, 7, 9, 3, -1],
  [7, 0, 8, 7, 6, 0, 6, 2, 0, -1, -1, -1, -1, -1, -1, -1],
  [7, 2, 3, 6, 2, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [2, 10, 3, 11, 8, 6, 11, 9, 8, 8, 7, 6, -1, -1, -1, -1],
  [2, 7, 0, 2, 10, 7, 0, 7, 9, 6, 11, 7, 9, 7, 11, -1],
  [1, 0, 8, 1, 8, 7, 1, 7, 11, 6, 11, 7, 2, 10, 3, -1],
  [10, 1, 2, 10, 7, 1, 11, 1, 6, 6, 1, 7, -1, -1, -1, -1],
  [8, 6, 9, 8, 7, 6, 9, 6, 1, 10, 3, 6, 1, 6, 3, -1],
  [0, 1, 9, 10, 7, 6, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [7, 0, 8, 7, 6, 0, 3, 0, 10, 10, 0, 6, -1, -1, -1, -1],
  [7, 6, 10, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [7, 10, 6, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [3, 8, 0, 10, 6, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [0, 9, 1, 10, 6, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [8, 9, 1, 8, 1, 3, 10, 6, 7, -1, -1, -1, -1, -1, -1, -1],
  [11, 2, 1, 6, 7, 10, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [1, 11, 2, 3, 8, 0, 6, 7, 10, -1, -1, -1, -1, -1, -1, -1],
  [2, 0, 9, 2, 9, 11, 6, 7, 10, -1, -1, -1, -1, -1, -1, -1],
  [6, 7, 10, 2, 3, 11, 11, 3, 8, 11, 8, 9, -1, -1, -1, -1],
  [7, 3, 2, 6, 7, 2, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [7, 8, 0, 7, 0, 6, 6, 0, 2, -1, -1, -1, -1, -1, -1, -1],
  [2, 6, 7, 2, 7, 3, 0, 9, 1, -1, -1, -1, -1, -1, -1, -1],
  [1, 2, 6, 1, 6, 8, 1, 8, 9, 8, 6, 7, -1, -1, -1, -1],
  [11, 6, 7, 11, 7, 1, 1, 7, 3, -1, -1, -1, -1, -1, -1, -1],
  [11, 6, 7, 1, 11, 7, 1, 7, 8, 1, 8, 0, -1, -1, -1, -1],
  [0, 7, 3, 0, 11, 7, 0, 9, 11, 6, 7, 11, -1, -1, -1, -1],
  [7, 11, 6, 7, 8, 11, 8, 9, 11, -1, -1, -1, -1, -1, -1, -1],
  [6, 4, 8, 10, 6, 8, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [3, 10, 6, 3, 6, 0, 0, 6, 4, -1, -1, -1, -1, -1, -1, -1],
  [8, 10, 6, 8, 6, 4, 9, 1, 0, -1, -1, -1, -1, -1, -1, -1],
  [9, 6, 4, 9, 3, 6, 9, 1, 3, 10, 6, 3, -1, -1, -1, -1],
  [6, 4, 8, 6, 8, 10, 2, 1, 11, -1, -1, -1, -1, -1, -1, -1],
  [1, 11, 2, 3, 10, 0, 0, 10, 6, 0, 6, 4, -1, -1, -1, -1],
  [4, 8, 10, 4, 10, 6, 0, 9, 2, 2, 9, 11, -1, -1, -1, -1],
  [11, 3, 9, 11, 2, 3, 9, 3, 4, 10, 6, 3, 4, 3, 6, -1],
  [8, 3, 2, 8, 2, 4, 4, 2, 6, -1, -1, -1, -1, -1, -1, -1],
  [0, 2, 4, 4, 2, 6, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [1, 0, 9, 2, 4, 3, 2, 6, 4, 4, 8, 3, -1, -1, -1, -1],
  [1, 4, 9, 1, 2, 4, 2, 6, 4, -1, -1, -1, -1, -1, -1, -1],
  [8, 3, 1, 8, 1, 6, 8, 6, 4, 6, 1, 11, -1, -1, -1, -1],
  [11, 0, 1, 11, 6, 0, 6, 4, 0, -1, -1, -1, -1, -1, -1, -1],
  [4, 3, 6, 4, 8, 3, 6, 3, 11, 0, 9, 3, 11, 3, 9, -1],
  [11, 4, 9, 6, 4, 11, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [4, 5, 9, 7, 10, 6, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [0, 3, 8, 4, 5, 9, 10, 6, 7, -1, -1, -1, -1, -1, -1, -1],
  [5, 1, 0, 5, 0, 4, 7, 10, 6, -1, -1, -1, -1, -1, -1, -1],
  [10, 6, 7, 8, 4, 3, 3, 4, 5, 3, 5, 1, -1, -1, -1, -1],
  [9, 4, 5, 11, 2, 1, 7, 10, 6, -1, -1, -1, -1, -1, -1, -1],
  [6, 7, 10, 1, 11, 2, 0, 3, 8, 4, 5, 9, -1, -1, -1, -1],
  [7, 10, 6, 5, 11, 4, 4, 11, 2, 4, 2, 0, -1, -1, -1, -1],
  [3, 8, 4, 3, 4, 5, 3, 5, 2, 11, 2, 5, 10, 6, 7, -1],
  [7, 3, 2, 7, 2, 6, 5, 9, 4, -1, -1, -1, -1, -1, -1, -1],
  [9, 4, 5, 0, 6, 8, 0, 2, 6, 6, 7, 8, -1, -1, -1, -1],
  [3, 2, 6, 3, 6, 7, 1, 0, 5, 5, 0, 4, -1, -1, -1, -1],
  [6, 8, 2, 6, 7, 8, 2, 8, 1, 4, 5, 8, 1, 8, 5, -1],
  [9, 4, 5, 11, 6, 1, 1, 6, 7, 1, 7, 3, -1, -1, -1, -1],
  [1, 11, 6, 1, 6, 7, 1, 7, 0, 8, 0, 7, 9, 4, 5, -1],
  [4, 11, 0, 4, 5, 11, 0, 11, 3, 6, 7, 11, 3, 11, 7, -1],
  [7, 11, 6, 7, 8, 11, 5, 11, 4, 4, 11, 8, -1, -1, -1, -1],
  [6, 5, 9, 6, 9, 10, 10, 9, 8, -1, -1, -1, -1, -1, -1, -1],
  [3, 10, 6, 0, 3, 6, 0, 6, 5, 0, 5, 9, -1, -1, -1, -1],
  [0, 8, 10, 0, 10, 5, 0, 5, 1, 5, 10, 6, -1, -1, -1, -1],
  [6, 3, 10, 6, 5, 3, 5, 1, 3, -1, -1, -1, -1, -1, -1, -1],
  [1, 11, 2, 9, 10, 5, 9, 8, 10, 10, 6, 5, -1, -1, -1, -1],
  [0, 3, 10, 0, 10, 6, 0, 6, 9, 5, 9, 6, 1, 11, 2, -1],
  [10, 5, 8, 10, 6, 5, 8, 5, 0, 11, 2, 5, 0, 5, 2, -1],
  [6, 3, 10, 6, 5, 3, 2, 3, 11, 11, 3, 5, -1, -1, -1, -1],
  [5, 9, 8, 5, 8, 2, 5, 2, 6, 3, 2, 8, -1, -1, -1, -1],
  [9, 6, 5, 9, 0, 6, 0, 2, 6, -1, -1, -1, -1, -1, -1, -1],
  [1, 8, 5, 1, 0, 8, 5, 8, 6, 3, 2, 8, 6, 8, 2, -1],
  [1, 6, 5, 2, 6, 1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [1, 6, 3, 1, 11, 6, 3, 6, 8, 5, 9, 6, 8, 6, 9, -1],
  [11, 0, 1, 11, 6, 0, 9, 0, 5, 5, 0, 6, -1, -1, -1, -1],
  [0, 8, 3, 5, 11, 6, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [11, 6, 5, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [10, 11, 5, 7, 10, 5, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [10, 11, 5, 10, 5, 7, 8, 0, 3, -1, -1, -1, -1, -1, -1, -1],
  [5, 7, 10, 5, 10, 11, 1, 0, 9, -1, -1, -1, -1, -1, -1, -1],
  [11, 5, 7, 11, 7, 10, 9, 1, 8, 8, 1, 3, -1, -1, -1, -1],
  [10, 2, 1, 10, 1, 7, 7, 1, 5, -1, -1, -1, -1, -1, -1, -1],
  [0, 3, 8, 1, 7, 2, 1, 5, 7, 7, 10, 2, -1, -1, -1, -1],
  [9, 5, 7, 9, 7, 2, 9, 2, 0, 2, 7, 10, -1, -1, -1, -1],
  [7, 2, 5, 7, 10, 2, 5, 2, 9, 3, 8, 2, 9, 2, 8, -1],
  [2, 11, 5, 2, 5, 3, 3, 5, 7, -1, -1, -1, -1, -1, -1, -1],
  [8, 0, 2, 8, 2, 5, 8, 5, 7, 11, 5, 2, -1, -1, -1, -1],
  [9, 1, 0, 5, 3, 11, 5, 7, 3, 3, 2, 11, -1, -1, -1, -1],
  [9, 2, 8, 9, 1, 2, 8, 2, 7, 11, 5, 2, 7, 2, 5, -1],
  [1, 5, 3, 3, 5, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [0, 7, 8, 0, 1, 7, 1, 5, 7, -1, -1, -1, -1, -1, -1, -1],
  [9, 3, 0, 9, 5, 3, 5, 7, 3, -1, -1, -1, -1, -1, -1, -1],
  [9, 7, 8, 5, 7, 9, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [5, 4, 8, 5, 8, 11, 11, 8, 10, -1, -1, -1, -1, -1, -1, -1],
  [5, 4, 0, 5, 0, 10, 5, 10, 11, 10, 0, 3, -1, -1, -1, -1],
  [0, 9, 1, 8, 11, 4, 8, 10, 11, 11, 5, 4, -1, -1, -1, -1],
  [11, 4, 10, 11, 5, 4, 10, 4, 3, 9, 1, 4, 3, 4, 1, -1],
  [2, 1, 5, 2, 5, 8, 2, 8, 10, 4, 8, 5, -1, -1, -1, -1],
  [0, 10, 4, 0, 3, 10, 4, 10, 5, 2, 1, 10, 5, 10, 1, -1],
  [0, 5, 2, 0, 9, 5, 2, 5, 10, 4, 8, 5, 10, 5, 8, -1],
  [9, 5, 4, 2, 3, 10, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [2, 11, 5, 3, 2, 5, 3, 5, 4, 3, 4, 8, -1, -1, -1, -1],
  [5, 2, 11, 5, 4, 2, 4, 0, 2, -1, -1, -1, -1, -1, -1, -1],
  [3, 2, 11, 3, 11, 5, 3, 5, 8, 4, 8, 5, 0, 9, 1, -1],
  [5, 2, 11, 5, 4, 2, 1, 2, 9, 9, 2, 4, -1, -1, -1, -1],
  [8, 5, 4, 8, 3, 5, 3, 1, 5, -1, -1, -1, -1, -1, -1, -1],
  [0, 5, 4, 1, 5, 0, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [8, 5, 4, 8, 3, 5, 9, 5, 0, 0, 5, 3, -1, -1, -1, -1],
  [9, 5, 4, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [4, 7, 10, 4, 10, 9, 9, 10, 11, -1, -1, -1, -1, -1, -1, -1],
  [0, 3, 8, 4, 7, 9, 9, 7, 10, 9, 10, 11, -1, -1, -1, -1],
  [1, 10, 11, 1, 4, 10, 1, 0, 4, 7, 10, 4, -1, -1, -1, -1],
  [3, 4, 1, 3, 8, 4, 1, 4, 11, 7, 10, 4, 11, 4, 10, -1],
  [4, 7, 10, 9, 4, 10, 9, 10, 2, 9, 2, 1, -1, -1, -1, -1],
  [9, 4, 7, 9, 7, 10, 9, 10, 1, 2, 1, 10, 0, 3, 8, -1],
  [10, 4, 7, 10, 2, 4, 2, 0, 4, -1, -1, -1, -1, -1, -1, -1],
  [10, 4, 7, 10, 2, 4, 8, 4, 3, 3, 4, 2, -1, -1, -1, -1],
  [2, 11, 9, 2, 9, 7, 2, 7, 3, 7, 9, 4, -1, -1, -1, -1],
  [9, 7, 11, 9, 4, 7, 11, 7, 2, 8, 0, 7, 2, 7, 0, -1],
  [3, 11, 7, 3, 2, 11, 7, 11, 4, 1, 0, 11, 4, 11, 0, -1],
  [1, 2, 11, 8, 4, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [4, 1, 9, 4, 7, 1, 7, 3, 1, -1, -1, -1, -1, -1, -1, -1],
  [4, 1, 9, 4, 7, 1, 0, 1, 8, 8, 1, 7, -1, -1, -1, -1],
  [4, 3, 0, 7, 3, 4, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [4, 7, 8, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [9, 8, 11, 11, 8, 10, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [3, 9, 0, 3, 10, 9, 10, 11, 9, -1, -1, -1, -1, -1, -1, -1],
  [0, 11, 1, 0, 8, 11, 8, 10, 11, -1, -1, -1, -1, -1, -1, -1],
  [3, 11, 1, 10, 11, 3, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [1, 10, 2, 1, 9, 10, 9, 8, 10, -1, -1, -1, -1, -1, -1, -1],
  [3, 9, 0, 3, 10, 9, 1, 9, 2, 2, 9, 10, -1, -1, -1, -1],
  [0, 10, 2, 8, 10, 0, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [3, 10, 2, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [2, 8, 3, 2, 11, 8, 11, 9, 8, -1, -1, -1, -1, -1, -1, -1],
  [9, 2, 11, 0, 2, 9, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [2, 8, 3, 2, 11, 8, 0, 8, 1, 1, 8, 11, -1, -1, -1, -1],
  [1, 2, 11, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [1, 8, 3, 9, 8, 1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [0, 1, 9, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [0, 8, 3, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
  [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1]
  /* 255 0 */
], CNt = [[0, 1], [1, 3], [2, 3], [0, 2], [4, 5], [5, 7], [6, 7], [4, 6], [0, 4], [1, 5], [2, 6], [3, 7]];
function YNt(i) {
  return INt[i];
}
function vNt(i) {
  return CNt[i];
}
var Cz = {
  getCase: YNt,
  getEdge: vNt
};
const {
  vtkErrorMacro: RNt,
  vtkDebugMacro: DNt
} = tt;
function ONt(i, t) {
  t.classHierarchy.push("vtkImageMarchingCubes");
  const e = [], n = [], s = [], r = [], a = XNt.newInstance();
  i.getVoxelScalars = (o, l, c, u, d, h, p, m) => {
    e[0] = c * u + l * d[0] + o, e[1] = e[0] + 1, e[2] = e[0] + d[0], e[3] = e[2] + 1, e[4] = e[0] + u, e[5] = e[4] + 1, e[6] = e[4] + d[0], e[7] = e[6] + 1;
    for (let b = 0; b < 8; ++b)
      n[b] = m[e[b]];
  }, i.getVoxelPoints = (o, l, c, u, d) => {
    r[0] = u[0] + o * d[0], r[1] = u[1] + l * d[1], r[2] = u[2] + c * d[2], r[3] = r[0] + d[0], r[4] = r[1], r[5] = r[2], r[6] = r[0], r[7] = r[1] + d[1], r[8] = r[2], r[9] = r[3], r[10] = r[7], r[11] = r[2], r[12] = r[0], r[13] = r[1], r[14] = r[2] + d[2], r[15] = r[3], r[16] = r[1], r[17] = r[14], r[18] = r[0], r[19] = r[7], r[20] = r[14], r[21] = r[3], r[22] = r[7], r[23] = r[14];
  }, i.getPointGradient = (o, l, c, u, d, h, p, m) => {
    let b, y;
    o === 0 ? (b = p[o + 1 + l * u[0] + c * d], y = p[o + l * u[0] + c * d], m[0] = (y - b) / h[0]) : o === u[0] - 1 ? (b = p[o + l * u[0] + c * d], y = p[o - 1 + l * u[0] + c * d], m[0] = (y - b) / h[0]) : (b = p[o + 1 + l * u[0] + c * d], y = p[o - 1 + l * u[0] + c * d], m[0] = 0.5 * (y - b) / h[0]), l === 0 ? (b = p[o + (l + 1) * u[0] + c * d], y = p[o + l * u[0] + c * d], m[1] = (y - b) / h[1]) : l === u[1] - 1 ? (b = p[o + l * u[0] + c * d], y = p[o + (l - 1) * u[0] + c * d], m[1] = (y - b) / h[1]) : (b = p[o + (l + 1) * u[0] + c * d], y = p[o + (l - 1) * u[0] + c * d], m[1] = 0.5 * (y - b) / h[1]), c === 0 ? (b = p[o + l * u[0] + (c + 1) * d], y = p[o + l * u[0] + c * d], m[2] = (y - b) / h[2]) : c === u[2] - 1 ? (b = p[o + l * u[0] + c * d], y = p[o + l * u[0] + (c - 1) * d], m[2] = (y - b) / h[2]) : (b = p[o + l * u[0] + (c + 1) * d], y = p[o + l * u[0] + (c - 1) * d], m[2] = 0.5 * (y - b) / h[2]);
  }, i.getVoxelGradients = (o, l, c, u, d, h, p) => {
    const m = [];
    i.getPointGradient(o, l, c, u, d, h, p, m), s[0] = m[0], s[1] = m[1], s[2] = m[2], i.getPointGradient(o + 1, l, c, u, d, h, p, m), s[3] = m[0], s[4] = m[1], s[5] = m[2], i.getPointGradient(o, l + 1, c, u, d, h, p, m), s[6] = m[0], s[7] = m[1], s[8] = m[2], i.getPointGradient(o + 1, l + 1, c, u, d, h, p, m), s[9] = m[0], s[10] = m[1], s[11] = m[2], i.getPointGradient(o, l, c + 1, u, d, h, p, m), s[12] = m[0], s[13] = m[1], s[14] = m[2], i.getPointGradient(o + 1, l, c + 1, u, d, h, p, m), s[15] = m[0], s[16] = m[1], s[17] = m[2], i.getPointGradient(o, l + 1, c + 1, u, d, h, p, m), s[18] = m[0], s[19] = m[1], s[20] = m[2], i.getPointGradient(o + 1, l + 1, c + 1, u, d, h, p, m), s[21] = m[0], s[22] = m[1], s[23] = m[2];
  }, i.produceTriangles = (o, l, c, u, d, h, p, m, b, y, Z, g, f) => {
    var C;
    const T = [1, 2, 4, 8, 16, 32, 64, 128], M = [0, 1, 3, 2, 4, 5, 7, 6], N = [], W = [];
    let x;
    i.getVoxelScalars(l, c, u, h, p, m, b, y);
    let V = 0;
    for (let R = 0; R < 8; R++)
      n[M[R]] >= o && (V |= T[R]);
    const X = Cz.getCase(V);
    if (!(X[0] < 0)) {
      i.getVoxelPoints(l + d[0], c + d[2], u + d[4], m, b), t.computeNormals && i.getVoxelGradients(l, c, u, p, h, b, y);
      for (let R = 0; X[R] >= 0; R += 3) {
        g.push(3);
        for (let z = 0; z < 3; z++) {
          const F = Cz.getEdge(X[R + z]);
          if (x = void 0, t.mergePoints && (x = (C = a.isInsertedEdge(e[F[0]], e[F[1]])) == null ? void 0 : C.value), x === void 0) {
            const P = (o - n[F[0]]) / (n[F[1]] - n[F[0]]), j = r.slice(F[0] * 3, (F[0] + 1) * 3), H = r.slice(F[1] * 3, (F[1] + 1) * 3);
            if (N[0] = j[0] + P * (H[0] - j[0]), N[1] = j[1] + P * (H[1] - j[1]), N[2] = j[2] + P * (H[2] - j[2]), x = Z.length / 3, Z.push(N[0], N[1], N[2]), t.computeNormals) {
              const B = s.slice(F[0] * 3, (F[0] + 1) * 3), $ = s.slice(F[1] * 3, (F[1] + 1) * 3);
              W[0] = B[0] + P * ($[0] - B[0]), W[1] = B[1] + P * ($[1] - B[1]), W[2] = B[2] + P * ($[2] - B[2]), Fn(W), f.push(W[0], W[1], W[2]);
            }
            t.mergePoints && a.insertEdge(e[F[0]], e[F[1]], x);
          }
          g.push(x);
        }
      }
    }
  }, i.requestData = (o, l) => {
    const c = o[0];
    if (!c) {
      RNt("Invalid or missing input");
      return;
    }
    console.time("mcubes");
    const u = c.getOrigin(), d = c.getSpacing(), h = c.getDimensions(), p = c.getPointData().getScalars().getData(), m = [], b = [], y = [], Z = c.getExtent(), g = h[0] * h[1];
    for (let T = 0; T < h[2] - 1; ++T)
      for (let M = 0; M < h[1] - 1; ++M)
        for (let N = 0; N < h[0] - 1; ++N)
          i.produceTriangles(t.contourValue, N, M, T, Z, g, h, u, d, p, m, b, y);
    a.initialize();
    const f = Ie.newInstance();
    if (f.getPoints().setData(new Float32Array(m), 3), f.getPolys().setData(new Uint32Array(b)), t.computeNormals) {
      const T = new Float32Array(y), M = We.newInstance({
        numberOfComponents: 3,
        values: T,
        name: "Normals"
      });
      f.getPointData().setNormals(M);
    }
    l[0] = f, DNt("Produced output"), console.timeEnd("mcubes");
  };
}
const zNt = {
  contourValue: 0,
  computeNormals: !1,
  mergePoints: !1
};
function MA(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, zNt, e), tt.obj(i, t), tt.algo(i, t, 1, 1), tt.setGet(i, t, ["contourValue", "computeNormals", "mergePoints"]), tt.algo(i, t, 1, 1), ONt(i, t);
}
const ENt = tt.newInstance(MA, "vtkImageMarchingCubes");
var kNt = {
  newInstance: ENt,
  extend: MA
};
const FNt = new se(), NA = new se(), WA = new se(), jNt = new se(), Yz = new se(), NS = new se();
class UNt extends Ja {
  constructor(e) {
    super();
    S(this, "context");
    S(this, "reactivity", An());
    S(this, "onEvent", this.reactivity.onEvent);
    S(this, "watch", this.reactivity.watch);
    S(this, "predictionModified");
    S(this, "radius");
    S(this, "leftDown");
    S(this, "rightDown");
    S(this, "brush");
    S(this, "erase");
    S(this, "predToEdit");
    S(this, "MouseOnViewFlag");
    S(this, "MouseOnViewId", null);
    S(this, "undoBufferSize");
    // private view: View2D;
    S(this, "circleSource", GNt.newInstance({ resolution: 100, radius: 5 }));
    S(this, "circleActor", Re.newInstance());
    S(this, "circleMapper", Ue.newInstance());
    S(this, "editHistory");
    S(this, "redoBuffer");
    S(this, "clickHistory");
    S(this, "redoClickBuffer");
    S(this, "maskTrue");
    S(this, "maskFalse");
    S(this, "previousWorldPosition");
    S(this, "mouseLoc", []);
    S(this, "shiftHist", []);
    this.context = e, this.predictionModified = !1, this.radius = 5, this.leftDown = !1, this.rightDown = !1, this.brush = !0, this.erase = !1, this.predToEdit = "", this.MouseOnViewFlag = !1, this.undoBufferSize = 7, this.maskTrue = 3e4, this.maskFalse = -3e4, this.previousWorldPosition = [0, 0, 0], this.editHistory = [], this.clickHistory = [], this.redoBuffer = [], this.redoClickBuffer = [], this.onEvent(FNt, (n) => {
      this.context.getPresenterWindows().forEach((s) => {
        const r = s.getMainView();
        !r || r.isViewMode3D() || (this.previousWorldPosition && (this.editMarker(this.previousWorldPosition, !0, r.getViewMode()), s.returnMainView().reslicerMap.forEach((a) => a.reslicer.modified())), this.radius = n);
      }), this.context.sceneRefresh();
    }), this.onEvent(WA, () => {
      this.brush = !0, console.log("brush on tool");
    }), this.onEvent(NA, () => {
      this.predToEdit = "", this.brush = !1, console.log("brush off tool");
    }), this.onEvent(jNt, (n) => {
      this.predToEdit = n, console.log(n);
    }), this.onEvent(Yz, (n) => {
      this.context.getPresenterWindows().forEach((s) => {
        const r = s.getMainView();
        !r || r == n || r.isViewMode3D() || this.previousWorldPosition && (this.editMarker(this.previousWorldPosition, !0, r.getViewMode()), s.returnMainView().reslicerMap.forEach((a) => a.reslicer.modified()));
      }), this.context.sceneRefresh();
    }), this.onEvent(NS, (n) => {
      this.redoClickBuffer = [], this.redoBuffer = [], this.clickHistory.push(n);
    }), console.log("BrushTool constructed");
  }
  onLeftPress(e, n) {
    if (console.log("BrushTool on left press"), e.getViewMode() == Nt.AXIAL || e.getViewMode() == Nt.SAGITTAL || e.getViewMode() == Nt.CORONAL) {
      this.mouseLoc = [], this.shiftHist = [], this.predToEdit == "" && (this.predToEdit = this.context.predictions[0].label, console.log("Prediction to edit was not selected so first prediction was automatically selected!"));
      const s = e.pickWorldPoint(n.position.x, n.position.y);
      if (this.leftDown = !0, this.brush) {
        this.editPrediction(s, !1, e.getViewMode());
        const r = e.reslicerMap.map((a) => a.label).indexOf(this.predToEdit);
        return e.reslicerMap[r].reslicer.modified(), e.sceneRefresh(), this.mouseLoc.push(s), this.shiftHist.push(!1), NS.notify(e.getViewMode()), !0;
      }
    }
    return !1;
  }
  onLeftRelease(e) {
    return (e.getViewMode() == Nt.AXIAL || e.getViewMode() == Nt.SAGITTAL || e.getViewMode() == Nt.CORONAL) && (this.leftDown = !1, this.brush && (this.predictionModified && (this.rerenderMesh(this.predToEdit), this.predictionModified = !1), this.editHistory.push({
      label: this.predToEdit,
      mouseLocations: this.mouseLoc,
      viewMode: e.getViewMode(),
      shift: this.shiftHist,
      radius: this.radius
    }), this.previousWorldPosition = void 0)), !1;
  }
  onMouseMove(e, n) {
    if ((e.getViewMode() == Nt.AXIAL || e.getViewMode() == Nt.SAGITTAL || e.getViewMode() == Nt.CORONAL) && (this.predToEdit == "" && (this.predToEdit = this.context.predictions[0].label, console.log("Prediction to edit was not selected so first prediction was automatically selected!")), this.MouseOnViewId != e.id && (Yz.notify(e), this.previousWorldPosition && (this.editMarker(this.previousWorldPosition, !0, e.getViewMode()), e.reslicerMap.forEach((s) => s.reslicer.modified())), e.sceneRefresh(), this.MouseOnViewId = e.id), this.brush)) {
      const s = e.pickWorldPoint(n.position.x, n.position.y);
      if (this.leftDown) {
        this.editPrediction(s, !1, e.getViewMode());
        const r = e.reslicerMap.map((a) => a.label).indexOf(this.predToEdit);
        e.reslicerMap[r].reslicer.modified(), this.mouseLoc.push(s), this.shiftHist.push(!1);
      } else if (this.rightDown) {
        this.editPrediction(s, !0, e.getViewMode());
        const r = e.reslicerMap.map((a) => a.label).indexOf(this.predToEdit);
        e.reslicerMap[r].reslicer.modified(), this.mouseLoc.push(s), this.shiftHist.push(!0);
      } else {
        this.previousWorldPosition != null && this.editMarker(this.previousWorldPosition, !0, e.getViewMode()), this.editMarker(s, !1, e.getViewMode());
        const r = e.reslicerMap.map((a) => a.label).indexOf(this.predToEdit);
        e.reslicerMap[r].reslicer.modified(), this.previousWorldPosition = s;
      }
      e.sceneRefresh();
    }
    return !1;
  }
  onRightPress(e, n) {
    if (e.getViewMode() == Nt.AXIAL || e.getViewMode() == Nt.SAGITTAL || e.getViewMode() == Nt.CORONAL) {
      this.mouseLoc = [], this.shiftHist = [], this.predToEdit == "" && (this.predToEdit = this.context.predictions[0].label, console.log("Prediction to edit was not selected so first prediction was automatically selected!"));
      const s = e.pickWorldPoint(n.position.x, n.position.y);
      if (this.rightDown = !0, this.brush) {
        this.editPrediction(s, !0, e.getViewMode());
        const r = e.reslicerMap.map((a) => a.label).indexOf(this.predToEdit);
        return e.reslicerMap[r].reslicer.modified(), e.sceneRefresh(), this.mouseLoc.push(s), this.shiftHist.push(!0), NS.notify(e.getViewMode()), !0;
      }
    }
    return !1;
  }
  onRightRelease(e) {
    return (e.getViewMode() == Nt.AXIAL || e.getViewMode() == Nt.SAGITTAL || e.getViewMode() == Nt.CORONAL) && (this.rightDown = !1, this.brush && (this.predictionModified && (this.rerenderMesh(this.predToEdit), this.predictionModified = !1), this.editHistory.push({
      label: this.predToEdit,
      mouseLocations: this.mouseLoc,
      viewMode: e.getViewMode(),
      shift: this.shiftHist,
      radius: this.radius
    }), this.previousWorldPosition = void 0)), !1;
  }
  onViewWidgetEvent() {
  }
  //brush functions
  editPrediction(e, n, s) {
    this.predictionModified = !0;
    const r = this.context.predictions.map((o) => o.label).indexOf(this.predToEdit), a = this.context.predictions[r].iData;
    if (a) {
      const o = a.getDimensions(), l = [0, 0, 0];
      if (I.round(l, a.worldToIndex(e)), s == Nt.SAGITTAL) {
        const c = l[0];
        for (let u = Math.max(0, Math.floor(l[1]) - this.radius - 1); u < Math.min(o[1], Math.ceil(l[1]) + this.radius + 1); u = u + 1)
          for (let d = Math.max(0, Math.floor(l[2]) - this.radius - 1); d < Math.min(o[2], Math.ceil(l[2]) + this.radius + 1); d = d + 1) {
            const h = I.fromValues(c, u, d);
            if (I.distance(h, l) <= this.radius - 1 + 0.25) {
              const m = a.computeOffsetIndex(h);
              n ? a.getPointData().getScalars().getData()[m] = this.maskFalse : a.getPointData().getScalars().getData()[m] = this.maskTrue;
            }
          }
      } else if (s == Nt.CORONAL) {
        const c = l[1];
        for (let u = Math.max(0, Math.floor(l[0]) - this.radius - 1); u < Math.min(o[0], Math.ceil(l[0]) + this.radius + 1); u = u + 1)
          for (let d = Math.max(0, Math.floor(l[2]) - this.radius - 1); d < Math.min(o[2], Math.ceil(l[2]) + this.radius + 1); d = d + 1) {
            const h = I.fromValues(u, c, d);
            if (I.distance(h, l) <= this.radius - 0.75) {
              const m = a.computeOffsetIndex(h);
              n ? a.getPointData().getScalars().getData()[m] = this.maskFalse : a.getPointData().getScalars().getData()[m] = this.maskTrue;
            }
          }
      } else if (s == Nt.AXIAL) {
        const c = l[2];
        for (let u = Math.max(0, Math.floor(l[0]) - this.radius - 1); u < Math.min(o[0], Math.ceil(l[0]) + this.radius + 1); u = u + 1)
          for (let d = Math.max(0, Math.floor(l[1]) - this.radius - 1); d < Math.min(o[1], Math.ceil(l[1]) + this.radius + 1); d = d + 1) {
            const h = I.fromValues(u, d, c);
            if (I.distance(h, l) <= this.radius - 0.75) {
              const m = a.computeOffsetIndex(h);
              n ? a.getPointData().getScalars().getData()[m] = this.maskFalse : a.getPointData().getScalars().getData()[m] = this.maskTrue;
            }
          }
      }
    }
  }
  rerenderMesh(e) {
    const n = [128, 128, 96], s = 20, r = this.context.predictions.map((l) => l.label).indexOf(e), a = this.context.predictions[r].iData;
    if (!a) return;
    const o = a.getSpacing();
    if (r != -1) {
      const l = this.context.predictions[r].iMeshMapper, c = this.context.predictions[r].iMeshActor;
      if (c && l) {
        this.context.removeActor(c), c.delete(), this.context.removeMapper(l), l.delete();
        const u = TA.newInstance();
        u.setInputData(this.context.predictions[r].iData);
        const d = a.worldToIndex(this.context.predictions[r].point), h = [
          d[0] - n[0] / o[0] / 2,
          d[0] + n[0] / o[0] / 2 - 1,
          d[1] - n[1] / o[1] / 2 + s,
          d[1] + n[1] / o[1] / 2 + s - 1,
          d[2] - n[2] / o[2] / 2,
          d[2] + n[2] / o[2] / 2 - 1
        ];
        u.setCroppingPlanes(h), u.update();
        const p = u.getOutputData(), m = kNt.newInstance({
          contourValue: 0,
          computeNormals: !1,
          mergePoints: !1
        });
        m.setInputData(p), m.setContourValue(0);
        const b = Re.newInstance(), y = Ue.newInstance();
        b.setMapper(y);
        const Z = m.getOutputData();
        y.setInputData(Z), b.getProperty().setColor(this.context.predictions[r].color[0], this.context.predictions[r].color[1], this.context.predictions[r].color[2]), b.getProperty().setAmbient(0.3), b.getProperty().setDiffuse(0.7), b.getProperty().setSpecular(0.3), b.getProperty().setSpecularPower(10), b.getProperty().modified(), this.context.predictions[r].iMeshData = Z, this.context.predictions[r].iMeshActor = b, this.context.predictions[r].iMeshMapper = y, this.context.objects.addVtkObject({ mapper: y, actor: b, objectType: Yt._NONE }), this.context.sceneRefresh();
      }
    }
  }
  undoBrush() {
    console.error("Reimplement");
  }
  redoBrush() {
    console.error("Reimplement");
  }
  //brush functions
  editMarker(e, n, s) {
    this.predictionModified = !0;
    const r = this.context.predictions.map((l) => l.label).indexOf(this.predToEdit), a = this.context.predictions[r].iData, o = this.context.predictions[r].originalImageData;
    if (a && o) {
      const l = a.getDimensions(), c = [0, 0, 0];
      if (I.round(c, a.worldToIndex(e)), s == Nt.SAGITTAL) {
        const u = c[0];
        for (let d = Math.max(0, Math.floor(c[1]) - this.radius - 1); d < Math.min(l[1], Math.ceil(c[1]) + this.radius + 1); d = d + 1)
          for (let h = Math.max(0, Math.floor(c[2]) - this.radius - 1); h < Math.min(l[2], Math.ceil(c[2]) + this.radius + 1); h = h + 1) {
            const p = I.fromValues(u, d, h);
            if (I.distance(p, c) <= this.radius - 1 + 0.25) {
              const b = a.computeOffsetIndex(p);
              n ? a.getPointData().getScalars().getData()[b] = o.getPointData().getScalars().getData()[b] : a.getPointData().getScalars().getData()[b] = this.maskTrue;
            }
          }
      } else if (s == Nt.CORONAL) {
        const u = c[1];
        for (let d = Math.max(0, Math.floor(c[0]) - this.radius - 1); d < Math.min(l[0], Math.ceil(c[0]) + this.radius + 1); d = d + 1)
          for (let h = Math.max(0, Math.floor(c[2]) - this.radius - 1); h < Math.min(l[2], Math.ceil(c[2]) + this.radius + 1); h = h + 1) {
            const p = I.fromValues(d, u, h);
            if (I.distance(p, c) <= this.radius - 0.75) {
              const b = a.computeOffsetIndex(p);
              n ? a.getPointData().getScalars().getData()[b] = o.getPointData().getScalars().getData()[b] : a.getPointData().getScalars().getData()[b] = this.maskTrue;
            }
          }
      } else if (s == Nt.AXIAL) {
        const u = c[2];
        for (let d = Math.max(0, Math.floor(c[0]) - this.radius - 1); d < Math.min(l[0], Math.ceil(c[0]) + this.radius + 1); d = d + 1)
          for (let h = Math.max(0, Math.floor(c[1]) - this.radius - 1); h < Math.min(l[1], Math.ceil(c[1]) + this.radius + 1); h = h + 1) {
            const p = I.fromValues(d, h, u);
            if (I.distance(p, c) <= this.radius - 0.75) {
              const b = a.computeOffsetIndex(p);
              n ? a.getPointData().getScalars().getData()[b] = o.getPointData().getScalars().getData()[b] : a.getPointData().getScalars().getData()[b] = this.maskTrue;
            }
          }
      }
      if (n) {
        for (const u of this.editHistory)
          if (s == u.viewMode)
            for (const d in u.mouseLocations) {
              const h = u.mouseLocations[d], p = u.shift[d], m = u.radius, b = this.context.predictions.map((Z) => Z.label).indexOf(u.label), y = this.context.predictions[b].iData;
              if (y) {
                const Z = y.getDimensions(), g = [0, 0, 0];
                if (I.round(g, y.worldToIndex(h)), u.viewMode == Nt.SAGITTAL) {
                  const f = g[0];
                  for (let T = Math.max(0, Math.floor(g[1]) - m - 1); T < Math.min(Z[1], Math.ceil(g[1]) + m + 1); T = T + 1)
                    for (let M = Math.max(0, Math.floor(g[2]) - m - 1); M < Math.min(Z[2], Math.ceil(g[2]) + m + 1); M = M + 1) {
                      const N = I.fromValues(f, T, M);
                      if (I.distance(N, g) <= m - 0.75) {
                        const x = y.computeOffsetIndex(N);
                        p ? y.getPointData().getScalars().getData()[x] = this.maskFalse : y.getPointData().getScalars().getData()[x] = this.maskTrue;
                      }
                    }
                } else if (u.viewMode == Nt.CORONAL) {
                  const f = g[1];
                  for (let T = Math.max(0, Math.floor(g[0]) - m - 1); T < Math.min(Z[0], Math.ceil(g[0]) + m + 1); T = T + 1)
                    for (let M = Math.max(0, Math.floor(g[2]) - m - 1); M < Math.min(Z[2], Math.ceil(g[2]) + m + 1); M = M + 1) {
                      const N = I.fromValues(T, f, M);
                      if (I.distance(N, g) <= m - 0.75) {
                        const x = y.computeOffsetIndex(N);
                        p ? y.getPointData().getScalars().getData()[x] = this.maskFalse : y.getPointData().getScalars().getData()[x] = this.maskTrue;
                      }
                    }
                } else if (u.viewMode == Nt.AXIAL) {
                  const f = g[2];
                  for (let T = Math.max(0, Math.floor(g[0]) - m - 1); T < Math.min(Z[0], Math.ceil(g[0]) + m + 1); T = T + 1)
                    for (let M = Math.max(0, Math.floor(g[1]) - m - 1); M < Math.min(Z[1], Math.ceil(g[1]) + m + 1); M = M + 1) {
                      const N = I.fromValues(T, M, f);
                      if (I.distance(N, g) <= m - 0.75) {
                        const x = y.computeOffsetIndex(N);
                        p ? y.getPointData().getScalars().getData()[x] = this.maskFalse : y.getPointData().getScalars().getData()[x] = this.maskTrue;
                      }
                    }
                }
              }
            }
      }
    }
  }
  delete() {
    this.reactivity.cleanupAll();
  }
}
const Y2 = new se();
class eOt {
  constructor(t, e, n, s, r) {
    // [index, flag boolean]
    S(this, "sphereHoverEvent", new se());
    S(this, "reactivity", An());
    S(this, "onEvent", this.reactivity.onEvent);
    S(this, "watch", this.reactivity.watch);
    S(this, "spheresMap", /* @__PURE__ */ new Map());
    S(this, "context");
    S(this, "views", null);
    S(this, "view3D", null);
    S(this, "customView", null);
    S(this, "radius", 3);
    S(this, "color", [1, 0, 1]);
    S(this, "hoverColor", [0, 1, 0]);
    S(this, "pickableFlag", !0);
    S(this, "overlay", !0);
    // this variable/map must exist where sphereRepresentation is used --> index, location
    S(this, "inputPointArray", new qt(/* @__PURE__ */ new Map()));
    this.context = t, e != null && (this.views = e), n != null && (this.view3D = n), s != null && (this.customView = s), r != null && (this.overlay = r), this.watch(this.inputPointArray, () => {
      this.createSphereObjects(), this.rerenderSpheres();
    }), this.onEvent(this.sphereHoverEvent, (a) => {
      const o = a[0], l = a[1];
      this.sphereHover(o, l);
    }), this.onEvent(Y2, (a) => {
      this.toggleSphereVisibility(a);
    });
  }
  createSphereObjects() {
    var t;
    for (const e of this.inputPointArray.get())
      if (this.spheresMap.has(e[0])) {
        const n = this.spheresMap.get(e[0]);
        if (n && (n.center = e[1], (t = n.sphere) == null || t.actor.setPosition(e[1][0], e[1][1], e[1][2]), this.customView && n.sphereCPR)) {
          const s = this.context.CPRMath.convertMMtoCPR(e[1], !1);
          n.sphereCPR.actor.setPosition(s[0], s[1], s[2]);
        }
      } else {
        const n = {
          id: e[0],
          center: e[1],
          onHover: !1,
          color: this.color,
          hoverColor: this.hoverColor,
          radius: this.radius,
          visible: !0,
          pickable: this.pickableFlag,
          sphere: null,
          sphereCPR: null
        }, s = this.createSphereMarker();
        if (s.source.setRadius(n.radius), s.actor.getProperty().setColor(n.color), s.actor.setPosition(n.center[0], n.center[1], n.center[2]), s.actor.setPickable(n.pickable), n.sphere = s, this.customView) {
          const r = this.createSphereMarker();
          r.source.setRadius(n.radius), r.actor.getProperty().setColor(n.color);
          const a = this.context.CPRMath.convertMMtoCPR(n.center, !1);
          r.actor.setPosition(a[0], a[1], a[2]), r.actor.setPickable(n.pickable), n.sphereCPR = r;
        }
        this.spheresMap.set(e[0], n);
      }
  }
  rerenderSpheres() {
    this.spheresMap.forEach((t) => {
      t.sphere != null && (t.visible ? (t.onHover ? (t.sphere.actor.getProperty().setColor(t.hoverColor), t.sphereCPR != null && t.sphereCPR.actor.getProperty().setColor(t.hoverColor)) : (t.sphere.actor.getProperty().setColor(t.color), t.sphereCPR != null && t.sphereCPR.actor.getProperty().setColor(t.color)), (t.sphere.actor.getPosition()[0] != t.center[0] || t.sphere.actor.getPosition()[1] != t.center[1] || t.sphere.actor.getPosition()[2] != t.center[2]) && t.sphere.actor.setPosition(t.center[0], t.center[1], t.center[2]), this.views != null && this.views.forEach((e) => {
        this.overlay && t.sphere && (e.getRendererOverlay().getActors().includes(t.sphere.actor) || e.getRendererOverlay().addActor(t.sphere.actor));
      }), this.view3D != null && this.overlay && t.sphere && (this.view3D.getRendererOverlay().getActors().includes(t.sphere.actor) || this.view3D.getRendererOverlay().addActor(t.sphere.actor)), this.customView != null && this.customView.viewMode == Nt.CPR && this.overlay && t.sphereCPR && (this.customView.getRendererOverlay().getActors().includes(t.sphereCPR.actor) || this.customView.getRendererOverlay().addActor(t.sphereCPR.actor)), t.sphere.actor.setVisibility(t.visible), t.sphereCPR != null && t.sphereCPR.actor.setVisibility(t.visible)) : (t.sphere.actor.setVisibility(t.visible), t.sphereCPR != null && t.sphereCPR.actor.setVisibility(t.visible)));
    });
  }
  setInputPointArray(t) {
    this.inputPointArray = new qt(t);
  }
  setInputPointArray2(t) {
    const e = /* @__PURE__ */ new Map();
    t.forEach((n, s) => e.set(s, n)), this.inputPointArray = new qt(e);
  }
  toggleSphereVisibility(t) {
    var n, s;
    const e = this.spheresMap.get(t);
    if (e) {
      const r = (n = e.sphere) == null ? void 0 : n.actor.getVisibility();
      (s = e.sphere) == null || s.actor.setVisibility(!r), this.context.repaint();
    }
  }
  toggleAllSpheresVisibility() {
    this.spheresMap.forEach((t) => {
      t.visible = !t.visible;
    }), this.rerenderSpheres(), this.context.repaint();
  }
  setAllSpheresVisibility(t) {
    this.spheresMap.forEach((e) => {
      e.visible = t;
    }), this.rerenderSpheres(), this.context.repaint();
  }
  setSphereRadius(t, e) {
    var s;
    const n = this.spheresMap.get(t);
    n && (n.radius = e, (s = n.sphere) == null || s.source.setRadius(e), this.rerenderSpheres());
  }
  setSphereColor(t, e) {
    const n = this.spheresMap.get(t);
    n && (n.color = e, this.rerenderSpheres());
  }
  setDefaultRadius(t) {
    this.radius = t;
  }
  setDefaultColor(t) {
    this.color = t;
  }
  setDefaultPickable(t) {
    this.pickableFlag = t;
  }
  setHoverColor(t) {
    this.hoverColor = t;
  }
  moveSphere(t, e) {
    const n = this.spheresMap.get(t);
    n && (n.center = e, n.sphere != null && n.sphere.actor.setPosition(e[0], e[1], e[2]), this.rerenderSpheres());
  }
  sphereHover(t, e) {
    this.spheresMap.forEach((s) => {
      s.onHover = !1;
    });
    const n = this.spheresMap.get(t);
    n && (n.onHover = e), this.rerenderSpheres();
  }
  deleteSphere(t) {
    const e = this.spheresMap.get(t);
    e && (e.sphere != null && (e.sphere.source.delete(), e.sphere.mapper.delete(), e.sphere.actor.delete()), e.sphereCPR != null && (e.sphereCPR.source.delete(), e.sphereCPR.mapper.delete(), e.sphereCPR.actor.delete()), this.spheresMap.delete(e.id));
  }
  rerenderAllSpheres() {
    this.rerenderSpheres();
  }
  getSphereCount() {
    return this.spheresMap.size;
  }
  createSphereMarker() {
    const t = sp.newInstance();
    t.setRadius(1), t.setPhiResolution(50), t.setThetaResolution(50);
    const e = Ue.newInstance();
    e.setInputConnection(t.getOutputPort()), e.setScalarVisibility(!1);
    const n = Re.newInstance();
    return n.setMapper(e), n.setPickable(!0), n.setVisibility(!0), {
      source: t,
      mapper: e,
      actor: n
    };
  }
  deleteAllSpheres() {
    this.inputPointArray.set(/* @__PURE__ */ new Map()), this.spheresMap.forEach((t) => {
      t.sphere != null && (t.sphere.source.delete(), t.sphere.mapper.delete(), t.sphere.actor.delete()), t.sphereCPR != null && (t.sphereCPR.source.delete(), t.sphereCPR.mapper.delete(), t.sphereCPR.actor.delete()), this.spheresMap.delete(t.id);
    }), this.spheresMap.clear();
  }
  delete() {
    this.deleteAllSpheres(), this.reactivity.cleanupAll();
  }
}
const nOt = new se(), iOt = new se(), _u = new se();
class sOt extends vl {
  constructor(e, n, s, r = {}, a = {}) {
    super(e, n, s, r, a);
    S(this, "viewMode");
    S(this, "brush");
    S(this, "CPRMode");
    S(this, "leftDown");
    S(this, "objectListVisible", new qt(!0));
    S(this, "objectList");
    this.viewMode = n, this.brush = !1, this.leftDown = !1, this.CPRMode = !1;
    const { createVueOverlayComponent: o, cleanup: l } = Pi(this.overlayContainer.getElement());
    if (this.onCleanup(() => l()), !this.isCrossSection) {
      let c = new qt({ items: [] });
      this.onEvent(PC, (h) => {
        c = this.renderObjectList(c, h), d();
      }), this.objectList = o($G, {
        objectTree: c,
        initialExpandedKeys: [],
        viewSize: this.viewSize,
        listSize: new qt([160, 300])
      });
      const u = new qt([]), d = () => {
        u.set(
          e.predictions.map((h, p) => ({
            key: p.toString(),
            label: h.label.toString(),
            visible: h.visibility,
            color: [h.color[0] * 255, h.color[1] * 255, h.color[2] * 255],
            onSelect: () => {
              h.visibility = !h.visibility, console.log("selected - switch visibility to", h.visibility), this.context.onPredictionAdded.notify(), _u.notify(), Y2.notify(p), this.renderObjectList(c, e.predictions), d();
            },
            onUnselect: () => {
              h.visibility = !h.visibility, console.log("selected - switch visibility to", h.visibility), this.context.onPredictionAdded.notify(), _u.notify(), console.warn("WARNING sphereVisibilityToggleEvent affect all SphereRepresentationWidgets --> see pointPicker for selective event notify"), Y2.notify(p), this.renderObjectList(c, e.predictions), d();
            },
            onClick: () => {
              console.log("clicked"), this.context.toolManager.coordControl.setCenter(h.point, this);
            }
          }))
        );
      };
      d();
    }
    this.onEvent(WA, () => {
      this.brush = !0;
    }), this.onEvent(NA, () => {
      this.brush = !1;
    }), this.onEvent(_u, () => {
      for (const c of this.reslicerMap) {
        const u = e.predictions.map((d) => d.label).indexOf(c.label);
        u != -1 && c.actor.setVisibility(e.predictions[u].visibility);
      }
      this.sceneRefresh();
    });
  }
  renderObjectList(e, n) {
    return e.set({
      items: n.map((s, r) => ({
        key: r.toString(),
        label: s.label.toString(),
        visible: s.visibility,
        onSelect: () => {
          s.visibility = !s.visibility, console.log("selected - switch visibility to", s.visibility), this.context.onPredictionAdded.notify(), _u.notify(), this.renderObjectList(e, n);
        },
        onUnselect: () => {
          s.visibility = !s.visibility, console.log("selected - switch visibility to", s.visibility), this.context.onPredictionAdded.notify(), _u.notify(), this.renderObjectList(e, n);
        },
        onClick: () => {
          console.log("clicked"), this.context.toolManager.coordControl.setCenter(s.point, this);
        }
      }))
    }), e;
  }
  orientationWidgetShownWrapper(e) {
    this.orientationWidgetShown(e);
  }
  isShownWrapper() {
    return this.isShown;
  }
  getViewSliceIndicatorsWrapper() {
    return this.getViewSliceIndicators();
  }
  cleanup() {
    super.cleanup();
  }
}
const PC = new se();
class rOt extends op {
  constructor(e, n, s = {}) {
    super(e, n, s);
    S(this, "overlayComponents");
    // private annotationPoints: Map<[number, number, number], Annotation3D> = new Map();
    S(this, "itemsMeasurement");
    this.itemsMeasurement = [];
    const r = new PT(this, this.context, this.isShown);
    this.onCleanup(() => r.delete()), this.isShown.get() && r.show(), this.watch(this.isShown, (N) => {
      N ? r.show() : r.hide();
    }), IW(this.renderer, 0), this.setActors(e.objects.getActors()), this.renderer.resetCamera(), this.onEvent(this.context.onActorAdded, ({ actor: N }) => {
      this.renderer.addActor(N), this.sceneRefresh();
    });
    const { createVueOverlayComponent: a, cleanup: o } = Pi(this.overlayContainer.getElement());
    this.onCleanup(() => o());
    const l = a(
      TP,
      {
        model: this.context.overlayModel,
        view: this.id,
        viewSize: this.viewSize,
        viewObjectPositions: this.viewObjectPositions,
        infoFlag: this.context.getInfoFlag()
      },
      {
        scrollThrough: !0
      }
    ), c = a(NP, {
      viewSize: this.viewSize,
      viewObjectPositions: this.viewObjectPositions,
      objectMoveEvent: this.objectMoveEvent,
      objectMoveRotateEndEvent: this.context.objectMoveRotateEndEvent
    });
    this.onEvent(PC, () => {
      d();
    });
    const u = new qt([]), d = () => {
      u.set(
        e.predictions.map((N, W) => ({
          key: W.toString(),
          label: N.label.toString(),
          visible: N.visibility,
          color: [N.color[0] * 255, N.color[1] * 255, N.color[2] * 255],
          onSelect: () => {
            N.visibility = !N.visibility, console.log("selected - switch visibility to", N.visibility), this.context.onPredictionAdded.notify(), _u.notify(), Y2.notify(W), d();
          },
          onUnselect: () => {
            N.visibility = !N.visibility, console.log("selected - switch visibility to", N.visibility), this.context.onPredictionAdded.notify(), _u.notify(), console.warn("WARNING sphereVisibilityToggleEvent affect all SphereRepresentationWidgets --> see pointPicker for selective event notify"), Y2.notify(W), d();
          },
          onClick: () => {
            console.log("clicked"), this.context.toolManager.coordControl.setCenter(N.point, this);
          }
        }))
      );
    };
    d();
    const h = this.context.objects.measurementsObjects, p = new qt([]), m = () => {
      this.itemsMeasurement = [];
      for (const [N, W] of h.get().entries())
        this.itemsMeasurement.push({
          key: N,
          label: W.annotation.name.get(),
          visible: W.annotation.getVisible(),
          color: [255, 0, 255],
          onSelect: T,
          onUnselect: M
        });
      p.set(this.itemsMeasurement);
    };
    m(), this.watch(h, () => m());
    const b = nl(), y = nl(), Z = new md(() => {
      const N = [], W = u.get();
      W.length && N.push({
        key: b,
        label: "Objects",
        children: W
      });
      const x = p.get();
      return x.length && N.push({
        key: y,
        label: "Measurements",
        children: x
      }), {
        items: N
      };
    }), g = a($G, {
      objectTree: Z,
      initialExpandedKeys: [b, y],
      viewSize: this.viewSize,
      listSize: new qt([200, 300])
    });
    this.overlayComponents = {
      objectMoveTool: c,
      objectInfos: l,
      objectList: g
    };
    const f = (N, W) => {
      if (h.get().get(N)) {
        this.context.toolManager.measurementsTool.measurementTool.setSingleMeasurementVisibility(N, W);
        return;
      }
    }, T = (N) => f(N, !0), M = (N) => f(N, !1);
  }
  renderObjectList(e, n) {
    return e.set({
      items: n.map((s, r) => ({
        key: r.toString(),
        label: s.label.toString(),
        visible: s.visibility,
        onSelect: () => {
          s.visibility = !s.visibility, console.log("selected - switch visibility to", s.visibility), this.context.onPredictionAdded.notify(), _u.notify(), this.renderObjectList(e, n);
        },
        onUnselect: () => {
          s.visibility = !s.visibility, console.log("selected - switch visibility to", s.visibility), this.context.onPredictionAdded.notify(), _u.notify(), this.renderObjectList(e, n);
        },
        onClick: () => {
          console.log("clicked"), this.context.toolManager.coordControl.setCenter(s.point, this);
        }
      }))
    }), e;
  }
  isViewMode3D() {
    return !0;
  }
  panToPosition(e, n, s) {
    const r = this.renderer.getActiveCamera(), a = r.getDistance(), o = r.getViewPlaneNormal();
    r.setPosition(e + a * o[0], n + a * o[1], s + a * o[2]), r.setFocalPoint(e, n, s), this.renderer.resetCameraClippingRange(), this.cameraModified();
  }
  // private removeAnnotation(worldPosition: [number, number, number]) {
  //     const annotation = this.annotationPoints.get(worldPosition);
  //     if (annotation) {
  //         //onPointDeleteReslicer.notify(worldPosition);
  //         annotation.delete();
  //         this.annotationPoints.delete(worldPosition);
  //         onPointDelete.notify(worldPosition);
  //     }
  // }
  setVolumeWLToolEnabled(e) {
    var s, r;
    const n = (a, o) => {
      const l = this.contextState.volumeOptions3D.get(), c = l.windowWidth - 4 * a / 3, u = l.windowLevel - 4 * o / 3;
      this.context.setVolumeWindowWidthLevel(c, u);
    };
    if (e) {
      let a = !1, o = 0, l = 0;
      const c = {
        onLeftPress: (u, d) => (a = !0, o = d.position.x, l = d.position.y, !1),
        onMouseMove: (u, d, h) => {
          if (a && h.mouseButtons.left) {
            const { x: p, y: m } = d.position, b = p - o, y = m - l;
            return n(b, y), o = p, l = m, !0;
          }
          return !1;
        },
        onLeftRelease: () => (a = !1, !1)
      };
      (s = this.context.getInteractorStyle()) == null || s.setViewEventHandler(this, c);
    } else
      (r = this.context.getInteractorStyle()) == null || r.setViewEventHandler(this, null);
  }
  isShownWrapper() {
    return this.isShown;
  }
  getWindowLevel() {
    return console.log("setwindowlevel view3D", this), this.context.getVolumeWindowWidthLevel();
  }
  setWindowLevel(e) {
    console.log("setwindowlevel view3D", this), this.context.toolManager.coordControl.onViewWidgetEvent(this, me.eVE_RENDER);
  }
}
class v2 extends Ja {
  constructor(e, n, s, r, a, o) {
    super();
    S(this, "cL", Object.values(jvt));
    S(this, "pickedPointsShifted", new se());
    S(this, "pointAddedEvent", new se());
    S(this, "pointMovedEvent", new se());
    S(this, "removeLastPointEvent", new se());
    S(this, "rerenderPoints", new se());
    S(this, "context");
    S(this, "leftDown");
    S(this, "rightDown");
    S(this, "movedFlag");
    S(this, "contextMenu", null);
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    S(this, "cleanUp", () => {
    });
    S(this, "mpBeginDragPoint", I.create());
    S(this, "mpRay", I.create());
    S(this, "normOffset", 0);
    S(this, "coloredPoints", !1);
    S(this, "reactivity", An());
    S(this, "onEvent", this.reactivity.onEvent);
    S(this, "pointsArray", []);
    S(this, "colorsArray", []);
    S(this, "scaleArray", []);
    S(this, "actorOnHover", !1);
    S(this, "pointIndex", -1);
    S(this, "pointCount", 0);
    S(this, "scale", 1);
    S(this, "representationLayer", 1);
    S(this, "pointAddedFlag", !1);
    S(this, "pointRepresentation", !1);
    S(this, "pointRepresentationMap", /* @__PURE__ */ new Map());
    S(this, "tool", null);
    S(this, "defaultColor", [1, 0, 1]);
    this.context = e, s && (this.pointRepresentation = s), n && (this.coloredPoints = n), r && (this.scale = r), a != null && (this.representationLayer = a), o && (this.tool = o), this.leftDown = !1, this.rightDown = !1, this.movedFlag = !1, this.onEvent(this.pickedPointsShifted, (l) => {
      var c;
      this.pointsArray.length = 0, this.colorsArray.length = 0, this.scaleArray.length = 0, this.pointCount = 0, l.forEach((u) => {
        this.pointsArray.push(...u), this.scaleArray.push(this.scale), this.coloredPoints ? this.colorsArray.push(...this.cL[this.pointCount % this.cL.length]) : this.colorsArray.push(...this.defaultColor), this.pointCount++;
      }), this.pointAddedEvent.notify(), (c = this.tool) == null || c.callFunction();
    }), this.onEvent(this.removeLastPointEvent, () => {
      this.pointsArray.splice(-3, 3), this.colorsArray.splice(-3, 3), this.scaleArray.splice(-1, 1), this.pointCount--, this.pointCount = Math.max(this.pointCount, 0);
    }), this.onEvent(this.pointAddedEvent, () => this.rerenderRepresentations()), this.onEvent(this.pointMovedEvent, () => this.rerenderRepresentations()), this.onEvent(this.rerenderPoints, () => this.rerenderRepresentations());
  }
  onLeftPress(e, n) {
    if (this.pointAddedFlag = !1, this.leftDown = !0, this.movedFlag = !1, this.actorOnHover)
      return this.mpBeginDragPoint = this.getPointPosition(this.pointIndex), e.getViewMode() == Nt.CPR ? this.normOffset = this.context.CPRMath.getNormalOffset(this.mpBeginDragPoint) : this.mpRay = e.getNormal(), !0;
    {
      let s = e.pickWorldPoint(n.position.x, n.position.y);
      e.getViewMode() == Nt.CPR && (s = this.context.CPRMath.convertCPRtoMMX([s[0], s[2]]));
      const r = this.context.toolManager.nerveTool, a = this.context.toolManager.cprTool;
      if (r != null && ea(r.splPoints, s).mind < 2) {
        const l = T5(r.splPoints, s);
        l.nearestIndex != -1 && (this.insertPointAtIndex(s, Math.floor(l.nearestIndex / r.N) + 1), this.pointIndex = Math.floor(l.nearestIndex / r.N) + 1, this.actorOnHover = !0, this.pointAddedFlag = !0);
      }
      if (a != null && ea(this.context.objects.CPRCurve.splineVec, s).mind < 2) {
        const l = T5(this.pointsArray, s);
        l.nearestIndex != -1 && (this.insertPointAtIndex(s, l.nearestIndex + 1), this.pointIndex = l.nearestIndex + 1, this.actorOnHover = !0, this.pointAddedFlag = !0);
      }
      if (!this.pointAddedFlag) {
        if (this.pointsArray.push(...s), this.scaleArray.push(this.scale), this.coloredPoints ? this.colorsArray.push(...this.cL[this.pointCount % this.cL.length]) : this.colorsArray.push(...this.defaultColor), this.pointCount++, this.pointAddedEvent.notify(), this.tool)
          return this.tool.callFunction(), e.getViewMode() == Nt.CPR ? (this.context.toolManager.coordControl.setCenter(s, e), e.updateCrossSliceIndicator(), !0) : !1;
        if (e.getViewMode() == Nt.CPR)
          return this.context.toolManager.coordControl.setCenter(s, e), e.updateCrossSliceIndicator(), !0;
      }
      return !1;
    }
  }
  onLeftRelease() {
    return this.leftDown = !1, !1;
  }
  onMouseWheel(e, n) {
    if (!Number.isFinite(n.spinY) || n.spinY === 0)
      return !1;
    const s = Math.sign(n.spinY);
    if (!e.isViewMode3D() && e.getViewMode() != Nt.CPR) {
      const r = I.create();
      I.scaleAndAdd(r, e.getOrigin(), e.getNormal(), s), Fs(this.mpBeginDragPoint, r, e.getNormal(), this.mpBeginDragPoint), this.onMouseMove(e, n);
    }
    return !1;
  }
  onMouseMove(e, n) {
    var s;
    if (this.movedFlag = !0, this.leftDown)
      if (this.leftDown && this.actorOnHover)
        if (this.pointIndex != -1) {
          const r = e.pickWorldPoint(n.position.x, n.position.y);
          let a = I.create();
          return e.getViewMode() == Nt.CPR ? a = this.context.CPRMath.convertCPRtoMM([r[0], this.normOffset, r[2]]) : Fs(r, this.mpBeginDragPoint, this.mpRay, a), this.setPointPosition(this.pointIndex, a), this.rerenderPoints.notify({ leftDown: !0 }), this.pointMovedEvent.notify(), (s = this.tool) == null || s.callFunction(), !0;
        } else
          return !1;
      else
        return !1;
    else {
      if (this.actorOnHover) {
        if (this.pointIndex >= 0 && this.pointIndex < this.pointsArray.length / 3) {
          const a = this.coloredPoints ? this.cL[this.pointIndex % this.cL.length] : this.defaultColor;
          this.setPointColor(this.pointIndex, a), this.rerenderPoints.notify({ leftDown: !1 });
        }
        this.pointIndex = -1, this.context.repaint(), this.actorOnHover = !1;
      }
      const r = e.hardwareSelectorPick(n.position.x, n.position.y, this.representationLayer, !1, !0);
      if (r && r.length > 0) {
        const { prop: a, attributeID: o } = r[0].getProperties();
        if (a && o) {
          const l = a.getMapper();
          if (l) {
            let u = l.getInputData().getPoints().getTuple((o - 2) / 3);
            if (I.len(u) > 1e-6) {
              this.actorOnHover = !0, e.getViewMode() == Nt.CPR && (u = this.context.CPRMath.convertCPRtoMM([u[0], u[1], u[2]]));
              const d = this.getClosestPointIndex(u);
              d != null && (this.pointIndex = d, this.setPointColor(d, [0, 1, 0]), this.rerenderPoints.notify({ leftDown: !1 })), this.context.repaint();
            }
          }
        }
      }
      return !1;
    }
  }
  onRightPress(e, n) {
    return this.rightDown = !0, this.movedFlag = !1, !1;
  }
  onRightRelease(e, n) {
    return this.rightDown && !this.movedFlag && this.actorOnHover && this.pointIndex != -1 ? this.showPropContextMenu(e, n.position.x, n.position.y) : !1;
  }
  showContextMenu(e, n, s, r) {
    const { createVueOverlayComponent: a, cleanup: o } = Pi(e.getOverlayContainer());
    this.cleanUp = o, this.contextMenu = a(zT, {
      menuItems: n,
      x: s,
      y: r
    });
  }
  hideContextMenu() {
    this.contextMenu && (this.contextMenu.remove(), this.contextMenu = null);
  }
  showPropContextMenu(e, n, s) {
    const r = this.createItemDropdown(this.pointIndex);
    if (r) {
      const a = e.displayToView(n, s);
      return this.showContextMenu(e, r.items, a[0], a[1]), !0;
    }
    return !1;
  }
  createItemDropdown(e) {
    return {
      items: [
        {
          label: jt("medic-web-engine.deletePoint"),
          command: () => {
            var s;
            console.log("Removing point index", e), this.deletePointFromIndex(e), this.rerenderPoints.notify({ leftDown: !0 }), this.pointMovedEvent.notify(), (s = this.tool) == null || s.callFunction();
          }
        }
        // {
        //     label: translation('medic-web-engine.deleteAllPoints'),
        //     command: () => {
        //         console.log("Removing point index", indexId);
        //
        //         this.rerenderPoints.notify({ leftDown: true });
        //         this.pointMovedEvent.notify();
        //         this.tool?.callFunction();
        //     },
        // },
      ]
    };
  }
  getPickedPoints() {
    return this.pointsArray;
  }
  getNPickedPoints(e) {
    const n = [];
    for (let s = 0; s < e; s++)
      n.push(this.pointsArray[s * 3 + 0]), n.push(this.pointsArray[s * 3 + 1]), n.push(this.pointsArray[s * 3 + 2]);
    return console.log("outPoints", n), n;
  }
  getPickedPointsV() {
    const e = [];
    for (let n = 0; n < this.pointsArray.length / 3; n++)
      e.push(I.fromValues(this.pointsArray[3 * n], this.pointsArray[3 * n + 1], this.pointsArray[3 * n + 2]));
    return e;
  }
  getNumberOfPoints() {
    return this.pointsArray.length / 3;
  }
  addPoint(e) {
    var n;
    this.pointsArray.push(...e), this.scaleArray.push(this.scale), this.coloredPoints ? this.colorsArray.push(...this.cL[this.pointCount % this.cL.length]) : this.colorsArray.push(...this.defaultColor), this.pointCount++, this.pointAddedEvent.notify(), (n = this.tool) == null || n.callFunction();
  }
  deletePointFromIndex(e) {
    this.pointsArray.splice(e * 3, 3), this.colorsArray.splice(e * 3, 3), this.scaleArray.splice(e, 1), this.pointCount--, this.pointCount = Math.max(this.pointCount, 0);
  }
  insertPointAtIndex(e, n, s = this.scale, r = this.defaultColor) {
    for (let a = this.pointsArray.length / 3 - 1; a > n - 1; a--) {
      const o = [this.pointsArray[a * 3], this.pointsArray[a * 3 + 1], this.pointsArray[a * 3 + 2]];
      this.pointsArray[(a + 1) * 3] = o[0], this.pointsArray[(a + 1) * 3 + 1] = o[1], this.pointsArray[(a + 1) * 3 + 2] = o[2];
      const l = [this.colorsArray[a * 3], this.colorsArray[a * 3 + 1], this.colorsArray[a * 3 + 2]];
      this.colorsArray[(a + 1) * 3] = l[0], this.colorsArray[(a + 1) * 3 + 1] = l[1], this.colorsArray[(a + 1) * 3 + 2] = l[2];
      const c = this.scaleArray[a];
      this.scaleArray[a + 1] = c;
    }
    this.coloredPoints ? (this.colorsArray[n * 3] = this.cL[this.pointCount % this.cL.length][0], this.colorsArray[n * 3 + 1] = this.cL[this.pointCount % this.cL.length][1], this.colorsArray[n * 3 + 2] = this.cL[this.pointCount % this.cL.length][2]) : (this.colorsArray[n * 3] = r[0], this.colorsArray[n * 3 + 1] = r[1], this.colorsArray[n * 3 + 2] = r[2]), this.pointsArray[n * 3] = e[0], this.pointsArray[n * 3 + 1] = e[1], this.pointsArray[n * 3 + 2] = e[2], this.scaleArray[n] = s, this.pointCount++;
  }
  setPointColor(e, n) {
    this.colorsArray[e * 3] = n[0], this.colorsArray[e * 3 + 1] = n[1], this.colorsArray[e * 3 + 2] = n[2];
  }
  setPointPosition(e, n) {
    this.pointsArray[e * 3] = n[0], this.pointsArray[e * 3 + 1] = n[1], this.pointsArray[e * 3 + 2] = n[2];
  }
  changePointPosition(e) {
    var n;
    this.pointIndex != -1 && (this.setPointPosition(this.pointIndex, e), this.rerenderPoints.notify({ leftDown: !0 }), this.pointMovedEvent.notify(), (n = this.tool) == null || n.callFunction(!0));
  }
  getClosestPointIndex(e) {
    const n = this.pointsArray.length;
    if (n === 0)
      return null;
    let s = Number.POSITIVE_INFINITY, r = -1;
    for (let a = 0; a < n / 3; a++) {
      const o = I.fromValues(this.pointsArray[a * 3], this.pointsArray[a * 3 + 1], this.pointsArray[a * 3 + 2]), l = I.sqrDist(e, o);
      l < s && (s = l, r = a);
    }
    return s > this.scale ? null : r;
  }
  getPointPosition(e) {
    return I.fromValues(this.pointsArray[e * 3], this.pointsArray[e * 3 + 1], this.pointsArray[e * 3 + 2]);
  }
  insertPointsFromProject(e, n) {
    var s;
    this.pointsArray.length = 0, this.scaleArray.length = 0, this.colorsArray.length = 0, e.forEach((r) => {
      const a = [r[0], r[1], r[2]];
      this.pointsArray.push(...a), this.scaleArray.push(this.scale), this.coloredPoints ? this.colorsArray.push(...this.cL[this.pointCount % this.cL.length]) : this.colorsArray.push(...this.defaultColor), this.pointCount++;
    }), !n && (this.pointAddedEvent.notify(), (s = this.tool) == null || s.callFunction());
  }
  clearPointArray(e) {
    var n;
    this.pointsArray.length = 0, this.scaleArray.length = 0, this.colorsArray.length = 0, this.pointCount = 0, !e && (this.pointAddedEvent.notify(), (n = this.tool) == null || n.callFunction());
  }
  setDefaultColor(e) {
    this.defaultColor = e;
  }
  delete() {
    this.cleanUp(), this.pointsArray.length = 0, this.scaleArray.length = 0, this.colorsArray.length = 0, this.pointCount = 0, this.pointRepresentation && this.pointRepresentationMap.forEach((e, n) => {
      n.removeActor(e.getActor()), e.delete(), this.pointRepresentationMap.delete(n);
    }), this.reactivity.cleanupAll();
  }
  rerenderRepresentations(e) {
    this.pointRepresentationMap.forEach((n, s) => {
      n.setData(
        {
          points: this.pointsArray,
          colors: this.colorsArray,
          scales: this.scaleArray
        },
        s
      );
    });
  }
  onViewWidgetEvent(e, n) {
    if (this.pointRepresentation)
      if (n == me.eVE_DESTROY) {
        const s = this.pointRepresentationMap.get(e);
        if (s) {
          e.removeActor(s.getActor()), s.delete(), this.pointRepresentationMap.delete(e);
          return;
        }
      } else {
        this.pointRepresentationMap.has(e) || this.pointRepresentationMap.set(e, new ed());
        const s = this.pointRepresentationMap.get(e);
        s && (n == me.eVE_SHOW || n == me.eVE_RENDER ? e.addActor(s.getActor(), 1) : e.removeActor(s.getActor())), this.rerenderRepresentations();
      }
  }
}
class PNt extends Ja {
  constructor(e) {
    super();
    S(this, "context");
    S(this, "views3D", []);
    S(this, "axialView");
    S(this, "CPRView");
    S(this, "scoutSagittal");
    S(this, "scoutCoronal");
    S(this, "corPreCPRFilterMode", Je.MPR);
    S(this, "sagPreCPRFilterMode", Je.MPR);
    S(this, "pointPicker");
    S(this, "reactivity", An());
    S(this, "onEvent", this.reactivity.onEvent);
    S(this, "leftDown");
    S(this, "rightDown");
    S(this, "byPoints", !1);
    S(this, "pointRepresentationMap", /* @__PURE__ */ new Map());
    this.context = e, this.context.getPresenterWindows().forEach((n) => {
      if (n.presenterWindowType == ni.PresenterWindow2DCustom) {
        const s = n;
        s.returnMainView().viewMode == Nt.CPR && (this.CPRView = s.returnMainView());
      } else if (n.presenterWindowType == ni.PresenterWindow2D) {
        const s = n;
        s.returnMainView().viewMode == Nt.AXIAL && (this.axialView = s.returnMainView()), s.returnMainView().viewMode == Nt.SAGITTAL && (this.scoutSagittal = s.returnMainView()), s.returnMainView().viewMode == Nt.CORONAL && (this.scoutCoronal = s.returnMainView());
      } else if (n.presenterWindowType == ni.PresenterWindow3D) {
        const s = n;
        this.views3D.push(s);
      }
    }), this.pointPicker = new v2(this.context), this.pointPicker.setDefaultColor(Kn(this.context.settings.defaultColors.cprColor)), this.leftDown = !1, this.rightDown = !1, this.onEvent(this.context.toolManager.onToolEndChange, ({ newTool: n, layer: s }) => {
      s === on.PRIMARY && n === sn.CPR && (this.context.resetRotation(), this.context.sceneRepaint(), this.cprToolOnOff(!0));
    }), this.onEvent(this.pointPicker.rerenderPoints, () => {
      this.rerenderRepresentations();
    }), this.onEvent(this.pointPicker.pointAddedEvent, () => {
      this.rerenderRepresentations();
      const n = this.context.getViewWidget(Nt.CPR);
      n && n.computeCPR(this.pointPicker.getPickedPointsV());
    }), this.onEvent(this.pointPicker.pointMovedEvent, () => {
      this.rerenderRepresentations();
      const n = this.context.getViewWidget(Nt.CPR);
      n && n.computeCPR(this.pointPicker.getPickedPointsV());
    }), this.insertPointsFromProject();
  }
  getPointPicker() {
    return this.pointPicker;
  }
  rerenderRepresentations() {
    this.pointRepresentationMap.forEach((e, n) => {
      e.setData(
        {
          points: this.pointPicker.pointsArray,
          colors: this.pointPicker.colorsArray,
          scales: this.pointPicker.scaleArray
        },
        n,
        5
      );
    });
  }
  onViewWidgetEvent(e, n) {
    if (e.getViewMode() == Nt.AXIAL)
      if (n == me.eVE_DESTROY) {
        if (this.pointRepresentationMap.has(e)) {
          const s = this.pointRepresentationMap.get(e);
          s && (e.removeActor(s.getActor()), s.delete(), this.pointRepresentationMap.delete(e));
          return;
        }
      } else {
        this.pointRepresentationMap.has(e) || this.pointRepresentationMap.set(e, new ed());
        const s = this.pointRepresentationMap.get(e);
        s && (n == me.eVE_SHOW || n == me.eVE_RENDER ? (this.byPoints ? s.getActor().setVisibility(!0) : s.getActor().setVisibility(!1), e.addActor(s.getActor(), 1)) : e.removeActor(s.getActor())), this.rerenderRepresentations();
      }
  }
  onLeftPress(e, n) {
    return e.getViewMode() !== Nt.AXIAL || !this.context.cprSettings || !this.byPoints ? !1 : this.pointPicker.onLeftPress(e, n);
  }
  onLeftRelease(e) {
    return e.getViewMode() !== Nt.AXIAL || !this.context.cprSettings || !this.byPoints ? !1 : this.pointPicker.onLeftRelease();
  }
  onMouseWheel(e, n) {
    return e.getViewMode() == Nt.CPR || e.getViewMode() !== Nt.AXIAL || !this.context.cprSettings || !this.byPoints ? !1 : this.pointPicker.onMouseWheel(e, n);
  }
  onMouseMove(e, n) {
    return e.getViewMode() !== Nt.AXIAL || !this.context.cprSettings || !this.byPoints ? !1 : this.pointPicker.onMouseMove(e, n);
  }
  onRightPress(e, n) {
    return e.getViewMode() !== Nt.AXIAL || !this.context.cprSettings || !this.byPoints ? !1 : this.pointPicker.onRightPress(e, n);
  }
  onRightRelease(e, n) {
    return e.getViewMode() !== Nt.AXIAL || !this.context.cprSettings || !this.byPoints ? !1 : this.pointPicker.onRightRelease(e, n);
  }
  removeLastPickedPoint() {
    this.pointPicker.removeLastPointEvent.notify(), this.pointPicker.pointAddedEvent.notify(), this.context.repaint();
  }
  clearAllPoints() {
    for (; this.pointPicker.getPickedPointsV().length > 0; )
      this.pointPicker.removeLastPointEvent.notify();
    this.pointPicker.pointAddedEvent.notify(), this.context.sceneRepaint();
  }
  cprToolOnOff(e) {
    if (e) {
      if (this.context.objects.hideAllObjects(), this.context.getPresenterWindows().forEach((n) => {
        var s;
        ((s = n.getMainView()) == null ? void 0 : s.getViewMode()) == Nt.CPR && n.returnMainView().reinitializeInputImage();
      }), this.context.cprSettings = e, this.scoutSagittal && (this.sagPreCPRFilterMode = this.scoutSagittal.getFilterMode(), this.scoutSagittal.presenterWindow.setFilterModeFcn(Je.SCOUT), this.scoutSagittal.getPresenterWindow().verticalSlider.setEnabled(!1)), this.scoutCoronal && (this.corPreCPRFilterMode = this.scoutCoronal.getFilterMode(), this.scoutCoronal.presenterWindow.setFilterModeFcn(Je.SCOUT), this.scoutCoronal.getPresenterWindow().verticalSlider.setEnabled(!1)), this.context.objects.CPRCurve.newObject) {
        const n = this.context.getImageData().getCenter();
        this.context.objects.CPRCurve.owner && (this.context.objects.CPRCurve.owner.o = [n[0], n[1], n[2]]), this.context.objects.CPRCurve.newObject = !1;
      }
      this.snapToOwner();
    } else
      this.scoutSagittal && (this.scoutSagittal.presenterWindow.setFilterModeFcn(this.sagPreCPRFilterMode), this.scoutSagittal.getPresenterWindow().verticalSlider.setEnabled(!0)), this.scoutCoronal && (this.scoutCoronal.presenterWindow.setFilterModeFcn(this.corPreCPRFilterMode), this.scoutCoronal.getPresenterWindow().verticalSlider.setEnabled(!0)), this.context.cprSettings = e, this.context.objects.restoreAllObjectsVisibility();
  }
  enableEditingCPRByPoints(e) {
    this.byPoints = e, e && this.context.curveDelta.update((n) => (n.value = 0, n)), this.pointRepresentationMap.forEach((n) => {
      n.getActor().setVisibility(e);
    }), this.context.repaint();
  }
  getByPointsEnabled() {
    return this.byPoints;
  }
  async automaticCPRLandmarkLocalization(e) {
    if (this.context.showLoading(jt("medic-web-engine.automaticCprDetection")), this.context.segmentationResult || await this.context.triggerSegmentation(e), this.context.segmentationResult) {
      let n = this.context.segmentationResult.cpr.maxilla;
      this.context.CPRType == xo.MANDIBLE && (n = this.context.segmentationResult.cpr.mandible), this.context.objects.CPRCurve.setMaxillaMandible(this.context.CPRType);
      const s = [];
      n && n.length && n.forEach((a) => {
        s.push(I.fromValues(a.x, a.y, a.z));
      }), s.length && (this.context.objects.CPRCurve.owner = Zbt(s)), this.snapToOwner();
      const r = this.context.getViewWidget(Nt.CPR);
      r && (r.setOwnerMatrix(), this.pointPicker.insertPointsFromProject(s), this.context.sceneRepaint(), r.updateRuler());
    }
    this.context.hideLoading();
  }
  insertPointsFromProject() {
    this.context.objects.CPRCurve.points.length > 0 ? this.pointPicker.insertPointsFromProject(this.context.objects.CPRCurve.points) : (this.context.resetRotation(), this.context.sceneRepaint());
  }
  snapToOwner() {
    var r;
    const e = this.context.objects.CPRCurve.owner;
    if (!e) {
      console.log("Owner not defined!");
      return;
    }
    const n = this.context.getViewWidget(Nt.AXIAL), s = ut.fromValues(
      e.t[0],
      e.t[1],
      e.t[2],
      0,
      e.s[0],
      e.s[1],
      e.s[2],
      0,
      e.n[0],
      e.n[1],
      e.n[2],
      0,
      e.o[0],
      e.o[1],
      e.o[2],
      1
    );
    n == null || n.setViewMatrix(s), (r = n == null ? void 0 : n.getPresenterWindow()) == null || r.setSliceInfoNormal(), this.context.sceneRepaint();
  }
  delete() {
    this.cprToolOnOff(!1), this.enableEditingCPRByPoints(!1), this.pointRepresentationMap.forEach((e, n) => {
      n.removeActor(e.getActor()), e.delete(), this.pointRepresentationMap.delete(n);
    }), this.pointPicker.delete(), this.reactivity.cleanupAll();
  }
}
const Vy = {
  DEFAULT: 0,
  GEOMETRY: 1,
  SLICE: 2,
  VOLUME: 3,
  YZ_PLANE: 4,
  // Sagittal
  XZ_PLANE: 5,
  // Coronal
  XY_PLANE: 6
  // Axial
}, kW = {
  PICKING_BUFFER: 0,
  FRONT_BUFFER: 1
}, JNt = {
  MOUSE_MOVE: 0,
  MOUSE_RELEASE: 1
};
var GA = {
  ViewTypes: Vy,
  RenderingTypes: kW,
  CaptureOn: JNt
};
const wA = 0.5;
function ANt(i, t) {
  t.classHierarchy.push("vtkAbstractWidget"), t.actorToRepresentationMap = /* @__PURE__ */ new WeakMap(), i.getBounds = t.widgetState.getBounds, i.getNestedProps = () => t.representations, i.activateHandle = (e) => {
    let {
      selectedState: n,
      representation: s
    } = e;
    t.widgetState.activateOnly(n), t.activeState = n, n && n.updateManipulator && n.updateManipulator(), i.invokeActivateHandle({
      selectedState: n,
      representation: s
    }), i.updateCursor && i.updateCursor();
  }, i.deactivateAllHandles = () => {
    t.widgetState.deactivate();
  }, i.hasActor = (e) => t.actorToRepresentationMap.has(e), i.grabFocus = () => {
    t.hasFocus = !0;
  }, i.loseFocus = () => {
    t.hasFocus = !1;
  }, i.hasFocus = () => t.hasFocus, i.placeWidget = (e) => t.widgetState.placeWidget(e), i.getPlaceFactor = () => t.widgetState.getPlaceFactor(), i.setPlaceFactor = (e) => t.widgetState.setPlaceFactor(e), i.getRepresentationFromActor = (e) => t.actorToRepresentationMap.get(e), i.updateRepresentationForRender = function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : kW.FRONT_BUFFER;
    for (let n = 0; n < t.representations.length; n++)
      t.representations[n].updateActorVisibility(e, t.contextVisibility, t.handleVisibility);
  }, i.getViewWidgets = () => t._factory.getViewWidgets(), i.setPriority(wA);
}
const BNt = {
  contextVisibility: !0,
  handleVisibility: !0,
  hasFocus: !1
};
function xA(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, BNt, e), np.extend(i, t, e), bJ.extend(i, t, e), tt.setGet(i, t, ["contextVisibility", "handleVisibility", "_widgetManager"]), tt.get(i, t, [
    "representations",
    "widgetState",
    "activeState"
    // stores the last activated sub state(handle)
  ]), tt.moveToProtected(i, t, ["widgetManager"]), tt.event(i, t, "ActivateHandle"), ANt(i, t);
}
const KNt = tt.newInstance(xA, "vtkAbstractWidget");
var HNt = {
  newInstance: KNt,
  extend: xA
};
const {
  ViewTypes: JC,
  RenderingTypes: vz,
  CaptureOn: aV
} = GA, {
  vtkErrorMacro: _Nt
} = tt;
let QNt = 1;
function SA(i) {
  const t = i.getActiveCamera(), e = i.getRenderWindow(), n = e.getInteractor(), s = n.getView();
  return {
    renderer: i,
    renderWindow: e,
    interactor: n,
    apiSpecificRenderWindow: s,
    camera: t
  };
}
function cw(i, t) {
  const {
    dispHeightFactor: e,
    cameraPosition: n,
    cameraDir: s,
    isParallel: r,
    rendererPixelDims: a
  } = t;
  let o = 1;
  if (r)
    o = e;
  else {
    const c = [...i];
    Hn.subtract(c, n, c), o = Hn.dot(c, s) * e;
  }
  const l = a[1];
  return o / l;
}
function $Nt(i, t) {
  t.viewId || (t.viewId = `view-${QNt++}`), t.classHierarchy.push("vtkWidgetManager");
  const e = /* @__PURE__ */ new WeakMap(), n = [];
  function s(Z) {
    const g = Z.getRepresentations();
    for (let f = 0; f < g.length; f++) {
      const T = g[f], M = {
        widget: Z,
        representation: T
      }, N = T.getActors();
      for (let W = 0; W < N.length; W++) {
        const x = N[W];
        e.set(x, M);
      }
    }
  }
  function r(Z) {
    return Z && (Z.isA("vtkAbstractWidget") ? Z : Z.getWidgetForView({
      viewId: t.viewId
    }));
  }
  function a() {
    const {
      _apiSpecificRenderWindow: Z,
      _camera: g,
      _renderer: f
    } = t;
    if (f && Z && g) {
      const [T, M] = Z.getSize(), [N, W, x, V] = f.getViewport(), X = Z.getComputedDevicePixelRatio(), C = [T * (x - N) / X, M * (V - W) / X], R = g.getPosition(), z = g.getDirectionOfProjection(), F = g.getParallelProjection(), P = F ? 2 * g.getParallelScale() : 2 * Math.tan(Hn.radiansFromDegrees(g.getViewAngle()) / 2);
      t.widgets.forEach((j) => {
        j.getNestedProps().forEach((H) => {
          H.getScaleInPixels() && H.setDisplayScaleParams({
            dispHeightFactor: P,
            cameraPosition: R,
            cameraDir: z,
            isParallel: F,
            rendererPixelDims: C
          });
        });
      });
    }
  }
  async function o(Z, g, f) {
    const {
      position: T
    } = Z, {
      requestCount: M,
      selectedState: N,
      representation: W,
      widget: x
    } = await i.getSelectedDataForXY(T.x, T.y);
    if (M || f !== t._currentUpdateSelectionCallID)
      return;
    function V(F) {
      g && t._interactor.invokeLeftButtonRelease(Z), F.activateHandle({
        selectedState: N,
        representation: W
      }), g && t._interactor.invokeLeftButtonPress(Z);
    }
    const R = i.getCursorStyles()[x ? "hover" : "default"];
    R && t._apiSpecificRenderWindow.setCursor(R), t.activeWidget = null;
    let z = !1;
    if (t.widgetInFocus === x && x.hasFocus())
      V(x), t.activeWidget = x, z = !0;
    else
      for (let F = 0; F < t.widgets.length; F++) {
        const P = t.widgets[F];
        P === x && P.getNestedPickable() ? (V(P), t.activeWidget = P, z = !0) : (z || (z = !!P.getActiveState()), P.deactivateAllHandles());
      }
    z && t._interactor.render();
  }
  const l = async function(Z) {
    let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (!t.isAnimating && t.pickingEnabled && Z.pokedRenderer === t._renderer) {
      const f = Symbol("UpdateSelection");
      t._currentUpdateSelectionCallID = f, await o(Z, g, f);
    }
  };
  function c(Z) {
    Z.updateRepresentationForRender(t.renderingType);
  }
  function u() {
    t.renderingType = vz.PICKING_BUFFER, t.widgets.forEach(c);
  }
  function d() {
    t.renderingType = vz.FRONT_BUFFER, t.widgets.forEach(c);
  }
  async function h(Z, g, f, T) {
    if (t._captureInProgress) {
      await t._captureInProgress;
      return;
    }
    u(), t._capturedBuffers = null, t._captureInProgress = t._selector.getSourceDataAsync(t._renderer, Z, g, f, T), t._capturedBuffers = await t._captureInProgress, t._captureInProgress = null, t.previousSelectedData = null, d();
  }
  i.enablePicking = () => {
    t.pickingEnabled = !0, i.renderWidgets();
  }, i.renderWidgets = () => {
    if (t.pickingEnabled && t.captureOn === aV.MOUSE_RELEASE) {
      const [Z, g] = t._apiSpecificRenderWindow.getSize();
      h(0, 0, Z, g);
    }
    d(), i.modified();
  }, i.disablePicking = () => {
    t.pickingEnabled = !1;
  }, i.setRenderer = (Z) => {
    const g = SA(Z);
    for (Object.assign(t, g), tt.moveToProtected({}, t, Object.keys(g)); n.length; )
      n.pop().unsubscribe();
    t._selector = t._apiSpecificRenderWindow.createSelector(), t._selector.setFieldAssociation(f0.FIELD_ASSOCIATION_POINTS), n.push(t._apiSpecificRenderWindow.onWindowResizeEvent(a)), n.push(t._camera.onModified(a)), a(), n.push(t._interactor.onStartAnimation(() => {
      t.isAnimating = !0;
    })), n.push(t._interactor.onEndAnimation(() => {
      t.isAnimating = !1, i.renderWidgets();
    })), n.push(t._interactor.onMouseMove((f) => (l(f), tt.VOID))), n.push(t._interactor.onLeftButtonPress((f) => {
      const {
        deviceType: T
      } = f, M = T === "touch" || T === "pen";
      return M && l(f, M), tt.VOID;
    }, wA / 2)), i.modified(), t.pickingEnabled && i.enablePicking();
  };
  function p(Z) {
    Z.setWidgetManager(i), s(Z), a(), t._renderer.addActor(Z);
  }
  i.addWidget = (Z, g, f) => {
    if (!t._renderer)
      return _Nt("Widget manager MUST BE link to a view before registering widgets"), null;
    const {
      viewId: T,
      _renderer: M
    } = t, N = Z.getWidgetForView({
      viewId: T,
      renderer: M,
      viewType: g || JC.DEFAULT,
      initialValues: f
    });
    return N != null && t.widgets.indexOf(N) === -1 && (t.widgets.push(N), p(N), i.modified()), N;
  };
  function m(Z) {
    t._renderer.removeActor(Z), Z.delete();
  }
  function b() {
    t._renderer.getRenderWindow().getInteractor().render(), i.renderWidgets();
  }
  i.removeWidgets = () => {
    t.widgets.forEach(m), t.widgets = [], t.widgetInFocus = null, b();
  }, i.removeWidget = (Z) => {
    const g = r(Z), f = t.widgets.indexOf(g);
    f !== -1 && (t.widgets.splice(f, 1), t.widgetInFocus === g && i.releaseFocus(), m(g), b());
  }, i.getSelectedDataForXY = async (Z, g) => {
    if (t.selections = null, t.pickingEnabled) {
      if (!t._capturedBuffers || t.captureOn === aV.MOUSE_MOVE)
        await h(Z, g, Z, g);
      else {
        const f = t._capturedBuffers.area;
        (Z < f[0] || Z > f[2] || g < f[1] || g > f[3]) && await h(Z, g, Z, g);
      }
      t.selections = t._capturedBuffers.generateSelection(Z, g, Z, g);
    }
    return i.getSelectedData();
  }, i.getSelectedData = () => {
    if (!t.selections || !t.selections.length)
      return t.previousSelectedData = null, {};
    const {
      propID: Z,
      compositeID: g,
      prop: f
    } = t.selections[0].getProperties();
    let {
      widget: T,
      representation: M
    } = t.selections[0].getProperties();
    if (t.previousSelectedData && t.previousSelectedData.prop === f && t.previousSelectedData.widget === T && t.previousSelectedData.compositeID === g)
      return t.previousSelectedData.requestCount++, t.previousSelectedData;
    if (e.has(f)) {
      const N = e.get(f);
      T = N.widget, M = N.representation;
    }
    if (T && M) {
      const N = M.getSelectedState(f, g);
      return t.previousSelectedData = {
        requestCount: 0,
        propID: Z,
        compositeID: g,
        prop: f,
        widget: T,
        representation: M,
        selectedState: N
      }, t.previousSelectedData;
    }
    return t.previousSelectedData = null, {};
  }, i.grabFocus = (Z) => {
    const g = r(Z);
    t.widgetInFocus && t.widgetInFocus !== g && t.widgetInFocus.loseFocus(), t.widgetInFocus = g, t.widgetInFocus && t.widgetInFocus.grabFocus();
  }, i.releaseFocus = () => i.grabFocus(null);
  const y = i.delete;
  i.delete = () => {
    for (; n.length; )
      n.pop().unsubscribe();
    y();
  };
}
const qNt = function() {
  let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return {
    // _camera: null,
    // _selector: null,
    // _currentUpdateSelectionCallID: null,
    viewId: null,
    widgets: [],
    activeWidget: null,
    renderer: null,
    viewType: JC.DEFAULT,
    isAnimating: !1,
    pickingEnabled: !0,
    selections: null,
    previousSelectedData: null,
    widgetInFocus: null,
    captureOn: aV.MOUSE_MOVE,
    ...i,
    cursorStyles: i.cursorStyles ? {
      ...i.cursorStyles
    } : {
      default: "default",
      hover: "pointer"
    }
  };
};
function LA(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, qNt(e)), tt.obj(i, t), tt.setGet(i, t, ["captureOn", "cursorStyles", {
    type: "enum",
    name: "viewType",
    enum: JC
  }]), tt.get(i, t, ["selections", "widgets", "viewId", "pickingEnabled", "activeWidget"]), $Nt(i, t);
}
const tWt = tt.newInstance(LA, "vtkWidgetManager");
var eWt = {
  newInstance: tWt,
  extend: LA,
  Constants: GA,
  getPixelWorldHeightAtCoord: cw
};
function nWt() {
}
function iWt(i, t) {
  t.classHierarchy.push("vtkAbstractWidgetFactory");
  const e = {};
  i.getWidgetForView = (s) => {
    let {
      viewId: r,
      renderer: a,
      viewType: o,
      initialValues: l
    } = s;
    if (!e[r]) {
      if (!a)
        return null;
      const {
        interactor: c,
        apiSpecificRenderWindow: u,
        camera: d
      } = SA(a), h = {}, p = {};
      tt.obj(p, h), Object.assign(p, {
        onWidgetChange: i.onWidgetChange
      }), Object.assign(h, {
        widgetState: t.widgetState,
        manipulator: t.manipulator,
        viewType: o,
        renderer: a,
        camera: d,
        apiSpecificRenderWindow: u,
        factory: i
      }), tt.moveToProtected(p, h, ["renderer", "camera", "apiSpecificRenderWindow", "factory"]), tt.get(p, h, ["viewType"]), tt.safeArrays(h), HNt.extend(p, h, l);
      const m = l;
      h.representations = i.getRepresentationsForViewType(o).map((y) => {
        let {
          builder: Z,
          labels: g,
          initialValues: f
        } = y;
        return Z.newInstance({
          _parentProp: p,
          labels: g,
          ...f,
          ...m
        });
      }), h.representations.forEach((y) => {
        y.setInputData(h.widgetState), y.getActors().forEach((Z) => {
          h.actorToRepresentationMap.set(Z, y);
        });
      }), t.behavior(p, h), ["coincidentTopologyParameters", ...t.methodsToLink || []].forEach((y) => {
        const Z = `set${tt.capitalize(y)}`, g = `get${tt.capitalize(y)}`, f = {
          [y]: [],
          [Z]: [],
          [g]: []
        };
        h.representations.forEach((T) => {
          T[y] && f[y].push(T[y]), T[Z] && f[Z].push(T[Z]), T[g] && f[g].push(T[g]);
        }), Object.keys(f).forEach((T) => {
          const M = f[T];
          M.length === 1 ? p[T] = M[0] : M.length > 1 && (p[T] = tt.chain(...M));
        });
      }), p.delete = tt.chain(() => {
        delete e[r];
      }, p.delete), p.setInteractor(c);
      const b = Object.freeze(p);
      return e[r] = b, b;
    }
    return e[r];
  }, i.getViewIds = () => Object.keys(e), i.getViewWidgets = () => Object.values(e), i.setVisibility = (s) => {
    const r = Object.keys(e);
    for (let a = 0; a < r.length; a++)
      e[r[a]].setVisibility(s);
  }, i.setPickable = (s) => {
    const r = Object.keys(e);
    for (let a = 0; a < r.length; a++)
      e[r[a]].setPickable(s);
  }, i.setDragable = (s) => {
    const r = Object.keys(e);
    for (let a = 0; a < r.length; a++)
      e[r[a]].setDragable(s);
  }, i.setContextVisibility = (s) => {
    const r = Object.keys(e);
    for (let a = 0; a < r.length; a++)
      e[r[a]].setContextVisibility(s);
  }, i.setHandleVisibility = (s) => {
    const r = Object.keys(e);
    for (let a = 0; a < r.length; a++)
      e[r[a]].setHandleVisibility(s);
  }, i.placeWidget = (s) => t.widgetState.placeWidget(s), i.getPlaceFactor = () => t.widgetState.getPlaceFactor(), i.setPlaceFactor = (s) => t.widgetState.setPlaceFactor(s);
  let n = nWt;
  i.delete = tt.chain(i.delete, () => n()), t.widgetState && (n = t.widgetState.onModified(() => i.invokeWidgetChange(t.widgetState)).unsubscribe);
}
function VA(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, e), tt.obj(i, t), tt.get(i, t, ["widgetState"]), tt.event(i, t, "WidgetChange"), iWt(i, t);
}
const sWt = tt.newInstance(VA, "vtkAbstractWidget");
var rWt = {
  newInstance: sWt,
  extend: VA
};
function aWt(i, t) {
  t.classHierarchy.push("vtkAbstractManipulator"), i.getOrigin = (e) => t.userOrigin ? t.userOrigin : t.useCameraFocalPoint ? e.pokedRenderer.getActiveCamera().getFocalPoint() : t.handleOrigin ? t.handleOrigin : t.widgetOrigin ? t.widgetOrigin : [0, 0, 0], i.getNormal = (e) => t.userNormal ? t.userNormal : t.useCameraNormal ? e.pokedRenderer.getActiveCamera().getDirectionOfProjection() : t.handleNormal ? t.handleNormal : t.widgetNormal ? t.widgetNormal : [0, 0, 1];
}
const oWt = {
  // userOrigin: null,
  // handleOrigin: null,
  // widgetOrigin: null,
  // userNormal: null,
  // handleNormal: null,
  // widgetNormal: null
  useCameraFocalPoint: !1,
  useCameraNormal: !1
};
function XA(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, oWt, e), tt.obj(i, t), tt.setGet(i, t, ["useCameraFocalPoint", "useCameraNormal"]), tt.setGetArray(i, t, ["userOrigin", "handleOrigin", "widgetOrigin", "userNormal", "handleNormal", "widgetNormal"], 3), aWt(i, t);
}
const lWt = tt.newInstance(XA, "vtkAbstractManipulator");
var IA = {
  extend: XA,
  newInstance: lWt
};
function CA(i, t, e, n, s, r) {
  const a = r.displayToWorld(i, t, 0, s), o = r.displayToWorld(i, t, 1, s);
  return li.intersectWithLine(a, o, e, n).x;
}
function cWt(i, t) {
  t.classHierarchy.push("vtkPlaneManipulator"), i.handleEvent = (e, n) => ({
    worldCoords: CA(e.position.x, e.position.y, i.getOrigin(e), i.getNormal(e), e.pokedRenderer, n)
  });
}
function uWt(i) {
  return {
    ...i
  };
}
function YA(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  IA.extend(i, t, uWt(e)), cWt(i, t);
}
const dWt = tt.newInstance(YA, "vtkPlaneManipulator");
var Rz = {
  intersectDisplayWithPlane: CA,
  extend: YA,
  newInstance: dWt
};
function vA(i, t, e, n, s, r) {
  if (1 - Math.abs(tn(s.getActiveCamera().getViewPlaneNormal(), n)) < XG)
    return [];
  const o = r.displayToWorld(i, t, 0, s), l = r.displayToWorld(i, t, 1, s), c = [0, 0, 0];
  fi(l, o, c);
  const u = [0, 0, 0];
  Wi(n, c, u), Wi(u, c, u);
  const d = tn([o[0] - e[0], o[1] - e[1], o[2] - e[2]], u), h = tn(u, n), p = n.slice();
  return h === 0 ? h2(p, 0) : h2(p, d / h), b0(e, p, p), p;
}
function hWt(i, t) {
  t.classHierarchy.push("vtkLineManipulator"), i.handleEvent = (e, n) => ({
    worldCoords: vA(e.position.x, e.position.y, i.getOrigin(e), i.getNormal(e), e.pokedRenderer, n)
  });
}
function pWt(i) {
  return {
    ...i
  };
}
function RA(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  IA.extend(i, t, pWt(e)), hWt(i, t);
}
const mWt = tt.newInstance(RA, "vtkLineManipulator");
var bWt = {
  projectDisplayToLine: vA,
  extend: RA,
  newInstance: mWt
};
const DA = {
  DIRECTION: 0,
  ROTATION: 1,
  MATRIX: 2
}, fWt = {
  SCALE_BY_CONSTANT: 0,
  SCALE_BY_MAGNITUDE: 1,
  SCALE_BY_COMPONENTS: 2
};
var OA = {
  OrientationModes: DA,
  ScaleModes: fWt
};
const {
  OrientationModes: Od,
  ScaleModes: su
} = OA, {
  vtkErrorMacro: gWt
} = tt;
function yWt(i, t) {
  t.classHierarchy.push("vtkGlyph3DMapper"), i.getOrientationModeAsString = () => tt.enumToString(Od, t.orientationMode), i.setOrientationModeToDirection = () => i.setOrientationMode(Od.DIRECTION), i.setOrientationModeToRotation = () => i.setOrientationMode(Od.ROTATION), i.setOrientationModeToMatrix = () => i.setOrientationMode(Od.MATRIX), i.getOrientationArrayData = () => {
    const e = i.getInputData(0);
    return !e || !e.getPointData() ? null : t.orientationArray ? e.getPointData().getArray(t.orientationArray) : e.getPointData().getVectors();
  }, i.getScaleModeAsString = () => tt.enumToString(su, t.scaleMode), i.setScaleModeToScaleByMagnitude = () => i.setScaleMode(su.SCALE_BY_MAGNITUDE), i.setScaleModeToScaleByComponents = () => i.setScaleMode(su.SCALE_BY_COMPONENTS), i.setScaleModeToScaleByConstant = () => i.setScaleMode(su.SCALE_BY_CONSTANT), i.getScaleArrayData = () => {
    const e = i.getInputData(0);
    return !e || !e.getPointData() ? null : t.scaleArray ? e.getPointData().getArray(t.scaleArray) : e.getPointData().getScalars();
  }, i.getBounds = () => {
    const e = i.getInputData(0), n = i.getInputData(1);
    return !e || !n ? ad() : (i.buildArrays(), t.bounds);
  }, i.buildArrays = () => {
    const e = i.getInputData(0), n = i.getInputData(1);
    if (t.buildTime.getMTime() < n.getMTime() || t.buildTime.getMTime() < e.getMTime() || t.buildTime.getMTime() < i.getMTime()) {
      const s = e.getPoints().getData();
      let r = i.getScaleArrayData(), a = null, o = 0;
      r && (a = r.getData(), o = r.getNumberOfComponents()), t.scaling && r && t.scaleMode === su.SCALE_BY_COMPONENTS && r.getNumberOfComponents() !== 3 && (gWt("Cannot scale by components since scale array does not have 3 components."), r = null);
      const l = n.getBounds(), c = [];
      qe.getCorners(l, c), t.bounds[0] = qe.INIT_BOUNDS[0], t.bounds[1] = qe.INIT_BOUNDS[1], t.bounds[2] = qe.INIT_BOUNDS[2], t.bounds[3] = qe.INIT_BOUNDS[3], t.bounds[4] = qe.INIT_BOUNDS[4], t.bounds[5] = qe.INIT_BOUNDS[5];
      const u = new Float64Array(3), d = i.getOrientationArrayData(), h = ut.identity(new Float64Array(16)), p = [], m = [], b = s.length / 3;
      t.matrixArray = new Float32Array(16 * b);
      const y = t.matrixArray.buffer;
      t.normalArray = new Float32Array(9 * b);
      const Z = t.normalArray.buffer, g = [], f = [];
      for (let N = 0; N < b; ++N) {
        const W = new Float32Array(y, N * 64, 16);
        if (p[0] = s[N * 3], p[1] = s[N * 3 + 1], p[2] = s[N * 3 + 2], ut.translate(W, h, p), d)
          switch (d.getTuple(N, f), t.orientationMode) {
            case Od.MATRIX: {
              const V = [...f.slice(0, 3), 0, ...f.slice(3, 6), 0, ...f.slice(6, 9), 0, 0, 0, 0, 1];
              ut.multiply(W, W, V);
              break;
            }
            case Od.ROTATION:
              ut.rotateZ(W, W, f[2]), ut.rotateX(W, W, f[0]), ut.rotateY(W, W, f[1]);
              break;
            case Od.DIRECTION:
              if (f[1] === 0 && f[2] === 0)
                f[0] < 0 && ut.rotateY(W, W, 3.1415926);
              else {
                const V = Or(f), X = [];
                X[0] = (f[0] + V) / 2, X[1] = f[1] / 2, X[2] = f[2] / 2, ut.rotate(W, W, 3.1415926, X);
              }
              break;
          }
        if (t.scaling) {
          if (m[0] = t.scaleFactor, m[1] = t.scaleFactor, m[2] = t.scaleFactor, r)
            switch (t.scaleMode) {
              case su.SCALE_BY_MAGNITUDE:
                for (let V = 0; V < o; ++V)
                  g[V] = a[N * o + V];
                m[0] *= Or(g, o), m[1] = m[0], m[2] = m[0];
                break;
              case su.SCALE_BY_COMPONENTS:
                for (let V = 0; V < o; ++V)
                  g[V] = a[N * o + V];
                m[0] *= g[0], m[1] *= g[1], m[2] *= g[2];
                break;
              case su.SCALE_BY_CONSTANT:
            }
          m[0] === 0 && (m[0] = 1e-10), m[1] === 0 && (m[1] = 1e-10), m[2] === 0 && (m[2] = 1e-10), ut.scale(W, W, m);
        }
        for (let V = 0; V < 8; ++V)
          I.transformMat4(u, c[V], W), u[0] < t.bounds[0] && (t.bounds[0] = u[0]), u[1] < t.bounds[2] && (t.bounds[2] = u[1]), u[2] < t.bounds[4] && (t.bounds[4] = u[2]), u[0] > t.bounds[1] && (t.bounds[1] = u[0]), u[1] > t.bounds[3] && (t.bounds[3] = u[1]), u[2] > t.bounds[5] && (t.bounds[5] = u[2]);
        const x = new Float32Array(Z, N * 36, 9);
        gi.fromMat4(x, W), gi.invert(x, x), gi.transpose(x, x);
      }
      const T = i.getAbstractScalars(e, t.scalarMode, t.arrayAccessMode, t.arrayId, t.colorByArrayName).scalars;
      t.useLookupTableScalarRange || i.getLookupTable().setRange(t.scalarRange[0], t.scalarRange[1]), t.colorArray = null;
      const M = i.getLookupTable();
      M && T && (M.build(), t.colorArray = M.mapScalars(T, t.colorMode, 0)), t.buildTime.modified();
    }
  }, i.getPrimitiveCount = () => {
    const e = i.getInputData(1), n = i.getInputData().getPoints().getNumberOfValues() / 3;
    return {
      points: n * e.getPoints().getNumberOfValues() / 3,
      verts: n * (e.getVerts().getNumberOfValues() - e.getVerts().getNumberOfCells()),
      lines: n * (e.getLines().getNumberOfValues() - 2 * e.getLines().getNumberOfCells()),
      triangles: n * (e.getPolys().getNumberOfValues() - 3 * e.getLines().getNumberOfCells())
    };
  }, i.setSourceConnection = (e) => i.setInputConnection(e, 1);
}
const ZWt = {
  orient: !0,
  orientationMode: Od.DIRECTION,
  orientationArray: null,
  scaling: !0,
  scaleFactor: 1,
  scaleMode: su.SCALE_BY_MAGNITUDE,
  scaleArray: null,
  matrixArray: null,
  normalArray: null,
  colorArray: null
};
function zA(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, ZWt, e), Ue.extend(i, t, e), tt.algo(i, t, 2, 0), t.buildTime = {}, tt.obj(t.buildTime, {
    mtime: 0
  }), t.boundsTime = {}, tt.obj(t.boundsTime, {
    mtime: 0
  }), tt.setGet(i, t, ["orient", "orientationMode", "orientationArray", "scaleArray", "scaleFactor", "scaleMode", "scaling"]), tt.get(i, t, ["colorArray", "matrixArray", "normalArray", "buildTime"]), yWt(i, t);
}
const TWt = tt.newInstance(zA, "vtkGlyph3DMapper");
var FW = {
  newInstance: TWt,
  extend: zA,
  ...OA
};
const Mg = {
  HANDLE: 0,
  CONTEXT: 1
}, {
  vtkErrorMacro: MWt,
  vtkWarningMacro: NWt
} = tt, WWt = ["active", "inactive", "static"];
function Dz(i, t) {
  i && i.setResolveCoincidentTopologyToPolygonOffset && (i.setResolveCoincidentTopologyToPolygonOffset(), FG.forEach((e) => {
    if (t[e]) {
      const n = `setRelativeCoincidentTopology${e}OffsetParameters`;
      if (i[n]) {
        const {
          factor: s,
          offset: r
        } = t[e];
        i[n](s, r);
      }
    }
  }));
}
function GWt(i) {
  for (var t = arguments.length, e = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    e[n - 1] = arguments[n];
  const s = {
    active: {},
    inactive: {},
    static: {}
  };
  return WWt.forEach((r) => {
    const a = s[r];
    i.forEach((o) => {
      a[o] || (a[o] = {}), e.filter((l) => l && l[r] && l[r][o]).forEach((l) => Object.assign(a[o], l[r][o]));
    });
  }), s;
}
function wWt(i, t, e) {
  e ? Object.keys(i).forEach((n) => {
    const s = i[n].actor === e ? t.active[n] : t.inactive[n];
    s && i[n].actor.getProperty().set(s);
  }) : (Object.keys(t.static).forEach((n) => {
    i[n] && i[n].actor.getProperty().set(t.static[n]);
  }), Object.keys(t.inactive).forEach((n) => {
    i[n] && i[n].actor.getProperty().set(t.inactive[n]);
  }));
}
function xWt(i) {
  let t = i.source;
  i.filter && (t.isA("vtkDataSet") ? i.filter.setInputData(t) : i.filter.setInputConnection(t.getOutputPort()), t = i.filter), t && (t.isA("vtkDataSet") ? i.mapper.setInputData(t) : i.mapper.setInputConnection(t.getOutputPort())), i.glyph && i.mapper.setInputConnection(i.glyph.getOutputPort(), 1), i.actor.setMapper(i.mapper);
}
function lp(i, t, e, n, s) {
  var a;
  let r = ((a = i[`get${tt.capitalize(t)}`]) == null ? void 0 : a.call(i)) || i.getPointData().getArrayByName(t);
  if (!r || n !== void 0 && r.getDataType() !== n || s !== void 0 && r.getNumberOfComponents() !== s) {
    let o = We, l = n, c = s;
    t === "points" ? (o = yi, l = l ?? "Float32Array", c = s ?? 3) : e2.includes(t) ? (o = Ii, l = l ?? "Uint16Array", c = s ?? 1) : (l = l ?? "Float32Array", c = s ?? 1), r = o.newInstance({
      name: t,
      dataType: l,
      numberOfComponents: c,
      size: c * e,
      empty: e === 0
    }), t === "points" || e2.includes(t) ? i[`set${tt.capitalize(t)}`](r) : i.getPointData().addArray(r);
  } else r.getNumberOfTuples() !== e && r.resize(e);
  return r;
}
function SWt(i, t) {
  t.classHierarchy.push("vtkWidgetRepresentation");
  const e = {
    mtimes: {},
    states: []
  };
  t._onCoincidentTopologyParametersChanged = () => {
    i.getActors().forEach((n) => {
      Dz(n.getMapper(), t.coincidentTopologyParameters);
    });
  }, i.getActors = () => t.actors, i.getNestedProps = i.getActors, i.setLabels = function() {
    for (var n = arguments.length, s = new Array(n), r = 0; r < n; r++)
      s[r] = arguments[r];
    s.length === 1 ? t.labels = [].concat(s[0]) : t.labels = s, i.modified();
  }, i.getRepresentationStates = function() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : t.inputData[0];
    return e.mtimes.representation === i.getMTime() && e.mtimes.input === n.getMTime() || (e.mtimes.representation = i.getMTime(), e.mtimes.input = n.getMTime(), e.states = [], t.labels.forEach((s) => {
      e.states = e.states.concat(n.getStatesWithLabel(s) || []);
    })), e.states;
  }, i.getSelectedState = (n, s) => {
    const r = i.getRepresentationStates();
    return s < r.length ? r[s] : (MWt(`Representation ${i.getClassName()} should implement getSelectedState(prop, compositeID) method.`), null);
  }, i.updateActorVisibility = function() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : kW.FRONT_BUFFER, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, a = !0;
    switch (t.behavior) {
      case Mg.HANDLE:
        a = n === kW.PICKING_BUFFER || r;
        break;
      case Mg.CONTEXT:
        a = s;
        break;
      default:
        a = !0;
        break;
    }
    const o = a;
    for (let l = 0; l < t.actors.length; l++)
      t.visibilityFlagArray ? t.actors[l].setVisibility(o && t.visibilityFlagArray[l]) : t.actors[l].setVisibility(o);
    if (t.alwaysVisibleActors)
      for (let l = 0; l < t.alwaysVisibleActors.length; l++)
        t.alwaysVisibleActors[l].setVisibility(!0);
  }, t.actors.push = function() {
    NWt("You should use publicAPI.addActor() to initialize the actor properly");
    for (var n = arguments.length, s = new Array(n), r = 0; r < n; r++)
      s[r] = arguments[r];
    s.forEach((a) => i.addActor(a));
  }, i.addActor = (n) => {
    Dz(n.getMapper(), t.coincidentTopologyParameters), Array.prototype.push.apply(t.actors, [n]);
  }, i.setLabels(t.labels);
}
function LWt(i) {
  return {
    activeScaleFactor: 1.2,
    activeColor: 1,
    useActiveColor: !0,
    actors: [],
    labels: [],
    behavior: Mg.CONTEXT,
    coincidentTopologyParameters: {
      Point: {
        factor: -1,
        offset: -1
      },
      Line: {
        factor: -1,
        offset: -1
      },
      Polygon: {
        factor: -1,
        offset: -1
      }
    },
    scaleInPixels: !1,
    displayScaleParams: {
      dispHeightFactor: 1,
      cameraPosition: [0, 0, 0],
      cameraDir: [1, 0, 0],
      isParallel: !1,
      rendererPixelDims: [1, 1]
    },
    _internalArrays: {},
    ...i
  };
}
function VWt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  np.extend(i, t, LWt(e)), tt.algo(i, t, 1, 1), tt.get(i, t, ["labels", "displayScaleParams", "coincidentTopologyParameters"]), tt.set(i, t, [{
    type: "object",
    name: "displayScaleParams"
  }, {
    type: "object",
    name: "coincidentTopologyParameters"
  }]), tt.setGet(i, t, ["scaleInPixels", "activeScaleFactor", "activeColor", "useActiveColor"]), SWt(i, t);
}
var AC = {
  extend: VWt,
  mergeStyles: GWt,
  applyStyles: wWt,
  connectPipeline: xWt
};
function XWt(i, t) {
  t.classHierarchy.push("vtkHandleRepresentation");
}
const IWt = {
  behavior: Mg.HANDLE,
  pickable: !0,
  dragable: !0,
  scaleInPixels: !0
};
function CWt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const n = {
    ...IWt,
    ...e
  };
  AC.extend(i, t, n), XWt(i, t);
}
var YWt = {
  extend: CWt
};
function vWt(i, t) {
  t.classHierarchy.push("vtkContextRepresentation");
}
const RWt = {
  behavior: Mg.CONTEXT,
  pickable: !1,
  dragable: !0
};
function DWt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const n = {
    ...RWt,
    ...e
  };
  AC.extend(i, t, n), vWt(i, t);
}
var EA = {
  extend: DWt
};
function kA(i, t) {
  return (e, n) => {
    const s = lp(e, "points", n.length).getData();
    let r = 0;
    for (let a = 0; a < n.length; ++a) {
      const o = n[a].getOrigin(t.scaleInPixels && t.displayScaleParams);
      s[r++] = o[0], s[r++] = o[1], s[r++] = o[2];
    }
  };
}
function OWt(i, t) {
  return (e, n) => {
    lp(e, "points", 0);
  };
}
function zWt(i, t) {
  return (e, n) => {
    t._pipeline.mapper.setColorByArrayName("color");
    const s = lp(
      e,
      "color",
      n.length,
      "Uint8Array",
      // RGBA
      4
    ), r = s.getData();
    let a = 0;
    for (let o = 0; o < n.length; ++o) {
      let l = n[o].getColor3();
      n[o].getActive() && t.useActiveColor && (l = t.activeColor), r[a++] = l[0], r[a++] = l[1], r[a++] = l[2], r[a++] = n[o].getOpacity();
    }
    s.dataChange();
  };
}
function EWt(i, t) {
  return (e, n) => {
    t._pipeline.mapper.setColorByArrayName("color");
    const s = lp(e, "color", n.length).getData();
    for (let r = 0; r < n.length; ++r) {
      let a = n[r].getColor();
      n[r].getActive() && t.useActiveColor && (a = t.activeColor), s[r] = a;
    }
  };
}
function kWt(i, t) {
  return (e, n) => {
    t._pipeline.mapper.setColorByArrayName(null);
  };
}
function FWt(i, t) {
  return (e, n) => {
    var a;
    t._pipeline.mapper.setScaleArray("scale"), t._pipeline.mapper.setScaleFactor(1), t._pipeline.mapper.setScaling(!0), t._pipeline.mapper.setScaleMode(FW.ScaleModes.SCALE_BY_COMPONENTS);
    const s = lp(e, "scale", n.length, "Float32Array", 3).getData();
    let r = 0;
    for (let o = 0; o < n.length; ++o) {
      const l = n[o];
      let c = l.getActive() ? t.activeScaleFactor : 1;
      i.getScaleInPixels() && (c *= cw(l.getOrigin(), t.displayScaleParams));
      const u = ((a = l.getScale3) == null ? void 0 : a.call(l)) ?? t.defaultScale;
      s[r++] = c * u[0], s[r++] = c * u[1], s[r++] = c * u[2];
    }
  };
}
function jWt(i, t) {
  return (e, n) => {
    var r;
    t._pipeline.mapper.setScaleArray("scale"), t._pipeline.mapper.setScaleFactor(1), t._pipeline.mapper.setScaling(!0);
    const s = lp(e, "scale", n.length).getData();
    for (let a = 0; a < n.length; ++a) {
      const o = n[a];
      let l = o.getActive() ? t.activeScaleFactor : 1;
      i.getScaleInPixels() && (l *= cw(o.getOrigin(), t.displayScaleParams));
      const c = ((r = o.getScale1) == null ? void 0 : r.call(o)) ?? t.defaultScale;
      s[a] = l * c;
    }
  };
}
function UWt(i, t) {
  return (e, n) => {
    t._pipeline.mapper.setScaleArray(null), t._pipeline.mapper.setScaleFactor(t.defaultScale), t._pipeline.mapper.setScaling(t.defaultScale !== 1);
  };
}
function PWt(i, t) {
  return (e, n) => {
    t._pipeline.mapper.setOrientationArray("orientation"), t._pipeline.mapper.setOrientationMode(DA.MATRIX);
    const s = lp(e, "orientation", n.length, "Float32Array", 9).getData();
    for (let r = 0; r < n.length; ++r) {
      const a = n[r], o = a.getRight ? a.getRight() : [1, 0, 0], l = a.getUp ? a.getUp() : [0, 1, 0], c = a.getDirection ? a.getDirection() : [0, 0, 1];
      s.set(o, 9 * r), s.set(l, 9 * r + 3), s.set(c, 9 * r + 6);
    }
  };
}
function JWt(i, t) {
  return (e, n) => {
    t._pipeline.mapper.setOrientationArray(null);
  };
}
function AWt(i, t) {
  t.classHierarchy.push("vtkGlyphRepresentation");
  const e = {
    ...i
  }, n = Ie.newInstance({
    mtime: 0
  });
  function s(r) {
    for (var a = arguments.length, o = new Array(a > 1 ? a - 1 : 0), l = 1; l < a; l++)
      o[l - 1] = arguments[l];
    return o.every((c) => {
      var u, d;
      return ((d = (u = r[0]) == null ? void 0 : u[`get${tt.capitalize(c)}`]) == null ? void 0 : d.call(u)) != null;
    });
  }
  i.getRepresentationStates = function() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : t.inputData[0];
    return e.getRepresentationStates(r).filter((a) => {
      var o, l;
      return ((o = a.getOrigin) == null ? void 0 : o.call(a)) && (((l = a.isVisible) == null ? void 0 : l.call(a)) ?? !0);
    });
  }, i.getMixins = (r) => {
    const a = {};
    return s(r, "origin") ? a.position = t.applyMixin.origin : a.position = t.applyMixin.noPosition, s(r, "color3") ? a.color = t.applyMixin.color3 : s(r, "color") ? a.color = t.applyMixin.color : a.color = t.applyMixin.noColor, s(r, "scale3") ? a.scale = t.applyMixin.scale3 : s(r, "scale1") ? a.scale = t.applyMixin.scale1 : a.scale = t.applyMixin.noScale, s(r, "direction") ? a.orientation = t.applyMixin.direction : a.orientation = t.applyMixin.noOrientation, a;
  }, i.requestData = (r, a) => {
    const o = i.getRepresentationStates(r[0]);
    a[0] = n;
    const l = i.getMixins(o);
    Object.values(l).forEach((c) => c(n, o)), n.getPoints().modified(), n.modified();
  }, AC.connectPipeline(t._pipeline), i.addActor(t._pipeline.actor);
}
function Oz(i, t, e) {
  var n, s, r, a, o, l, c, u, d, h, p, m, b, y;
  return {
    defaultScale: 1,
    ...e,
    _pipeline: {
      source: ((n = e._pipeline) == null ? void 0 : n.source) ?? i,
      glyph: ((s = e._pipeline) == null ? void 0 : s.glyph) ?? // in case glyph was provided
      sp.newInstance({
        phiResolution: 8,
        thetaResolution: 8
      }),
      mapper: ((r = e._pipeline) == null ? void 0 : r.mapper) ?? // in case mapper was provided
      FW.newInstance({
        scalarMode: DF.USE_POINT_FIELD_DATA
      }),
      actor: ((a = e._pipeline) == null ? void 0 : a.actor) ?? // in case actor was provided
      Re.newInstance({
        parentProp: i
      }),
      ...e._pipeline
      // in case there is something else to add to pipeline
    },
    applyMixin: {
      origin: ((o = e.applyMixin) == null ? void 0 : o.origin) ?? kA(i, t),
      noPosition: ((l = e.applyMixin) == null ? void 0 : l.noPosition) ?? OWt(),
      color3: ((c = e.applyMixin) == null ? void 0 : c.color3) ?? zWt(i, t),
      color: ((u = e.applyMixin) == null ? void 0 : u.color) ?? EWt(i, t),
      noColor: ((d = e.applyMixin) == null ? void 0 : d.noColor) ?? kWt(i, t),
      scale3: ((h = e.applyMixin) == null ? void 0 : h.scale3) ?? FWt(i, t),
      scale1: ((p = e.applyMixin) == null ? void 0 : p.scale1) ?? jWt(i, t),
      noScale: ((m = e.applyMixin) == null ? void 0 : m.noScale) ?? UWt(i, t),
      direction: ((b = e.applyMixin) == null ? void 0 : b.direction) ?? PWt(i, t),
      noOrientation: ((y = e.applyMixin) == null ? void 0 : y.noOrientation) ?? JWt(i, t),
      ...e.applyMixin
    }
  };
}
function FA(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  e.behavior === Mg.CONTEXT ? EA.extend(i, t, Oz(i, t, e)) : YWt.extend(i, t, Oz(i, t, e)), "lighting" in e && t._pipeline.actor.getProperty().setLighting(e.lighting), tt.setGet(i, t._pipeline, ["defaultScale"]), tt.get(i, t._pipeline, ["glyph", "mapper", "actor"]), tt.setGet(i, t.applyMixin, Object.keys(t.applyMixin)), AWt(i, t);
}
const BWt = tt.newInstance(FA, "vtkGlyphRepresentation");
var KWt = {
  newInstance: BWt,
  extend: FA
};
function HWt(i, t) {
  t.classHierarchy.push("vtkPixelSpaceCallbackMapper"), t.callback || (t.callback = () => {
  }), i.invokeCallback = (e, n, s, r, a) => {
    if (!t.callback)
      return;
    const o = n.getCompositeProjectionMatrix(s, -1, 1);
    ut.transpose(o, o);
    const l = e.getPoints(), c = new Float64Array(3), u = r.usize, d = r.vsize, h = u / 2, p = d / 2, m = [];
    for (let b = 0; b < l.getNumberOfPoints(); b += 1) {
      const y = l.getPoint(b);
      I.transformMat4(c, y, o);
      const Z = [c[0] * h + h, c[1] * p + p, c[2], 0];
      if (a) {
        const f = (Math.floor(Z[1]) * u + Math.floor(Z[0])) * 4, T = a[f] / 255, M = a[f + 1] / 255, N = (T * 256 + M) / 257;
        Z[3] = N * 2 - 1;
      }
      m.push(Z);
    }
    t.callback(m, n, s, a, [u, d]);
  };
}
const _Wt = {
  callback: null,
  useZValues: !1
};
function jA(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, _Wt, e), Ue.extend(i, t, e), tt.setGet(i, t, ["callback", "useZValues"]), HWt(i, t);
}
const QWt = tt.newInstance(jA, "vtkPixelSpaceCallbackMapper");
var $Wt = {
  newInstance: QWt,
  extend: jA
};
function qWt(i, t) {
  t.classHierarchy.push("vtkSphereHandleRepresentation"), t.displayMapper = $Wt.newInstance(), t.displayActor = Re.newInstance({
    parentProp: i
  }), t.displayActor.setMapper(t.displayMapper), t.displayMapper.setInputConnection(i.getOutputPort()), i.addActor(t.displayActor), t.alwaysVisibleActors = [t.displayActor], i.getGlyphResolution = () => t._pipeline.glyph.getPhiResolution(), i.setGlyphResolution = (n) => t._pipeline.glyph.setPhiResolution(n) || t._pipeline.glyph.setThetaResolution(n);
  function e(n) {
    if (t.displayCallback) {
      const s = [], r = i.getRepresentationStates();
      for (let a = 0; a < r.length; a++)
        r[a].getActive() && s.push(n[a]);
      if (s.length) {
        t.displayCallback(s);
        return;
      }
    }
    t.displayCallback();
  }
  i.setDisplayCallback = (n) => {
    t.displayCallback = n, t.displayMapper.setCallback(n ? e : null);
  };
}
function UA(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  KWt.extend(i, t, e), qWt(i, t);
}
const tGt = tt.newInstance(UA, "vtkSphereHandleRepresentation");
var eGt = {
  newInstance: tGt,
  extend: UA
};
const {
  vtkErrorMacro: nGt
} = tt, zz = [2, 0, 1, 2, 0, 2, 2, 0, 4, 2, 1, 3, 2, 1, 5, 2, 2, 3, 2, 2, 6, 2, 3, 7, 2, 4, 5, 2, 4, 6, 2, 5, 7, 2, 6, 7];
function iGt(i, t) {
  t.classHierarchy.push("vtkCroppingOutlineRepresentation"), t.internalPolyData = Ie.newInstance({
    mtime: 0
  }), lp(t.internalPolyData, "lines", zz.length).getData().set(zz);
  const e = kA(i, t);
  t.mapper = Ue.newInstance({
    scalarVisibility: !1
  }), t.actor = Re.newInstance({
    parentProp: i
  }), t.actor.getProperty().setEdgeColor(...t.edgeColor), t.mapper.setInputConnection(i.getOutputPort()), t.actor.setMapper(t.mapper), i.addActor(t.actor), i.requestData = (n, s) => {
    const r = i.getRepresentationStates(n[0]).filter((a) => a.getOrigin && a.getOrigin());
    r.length === 8 ? (e(t.internalPolyData, r), t.internalPolyData.getPoints().modified(), t.internalPolyData.modified(), s[0] = t.internalPolyData) : nGt("CroppingOutlineRepresentation did not get 8 states");
  };
}
const sGt = {
  edgeColor: [1, 1, 1]
};
function PA(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, sGt, e), EA.extend(i, t, e), tt.setGetArray(i, t, ["edgeColor"], 3), tt.get(i, t, ["mapper", "actor"]), iGt(i, t);
}
const rGt = tt.newInstance(PA, "vtkCroppingOutlineRepresentation");
var aGt = {
  newInstance: rGt,
  extend: PA
};
const Ob = ["-", "=", "+"];
function oV(i, t) {
  const e = new Float64Array(3);
  return I.transformMat4(e, i, t), e;
}
function Ez(i, t) {
  const e = I.create(), n = ps.create();
  return ut.getRotation(n, t), I.transformQuat(e, i, n), e;
}
function JA(i) {
  const [t, e, n] = i.split("").map((s) => Ob.indexOf(s) - 1);
  return t * e * n !== 0 ? "corners" : t * e !== 0 || e * n !== 0 || n * t !== 0 ? "edges" : "faces";
}
function oGt(i, t) {
  t._isDragging = !1, i.setDisplayCallback = (e) => t.representations[0].setDisplayCallback(e), i.handleLeftButtonPress = () => !t.activeState || !t.activeState.getActive() || !t.pickable ? tt.VOID : (t.dragable && (t._isDragging = !0, t._apiSpecificRenderWindow.setCursor("grabbing"), t._interactor.requestAnimation(i)), tt.EVENT_ABORT), i.handleMouseMove = (e) => t._isDragging ? i.handleEvent(e) : tt.VOID, i.handleLeftButtonRelease = () => !t.activeState || !t.activeState.getActive() || !t.pickable ? tt.VOID : (t._isDragging && (t._isDragging = !1, t._interactor.cancelAnimation(i), t.widgetState.deactivate()), tt.EVENT_ABORT), i.handleEvent = (e) => {
    if (t.pickable && t.activeState && t.activeState.getActive()) {
      const n = t.activeState.getManipulator();
      if (n) {
        const s = t.activeState.getName(), r = JA(s), a = s.split("").map((u) => Ob.indexOf(u)), o = t.widgetState.getCroppingPlanes().getPlanes(), l = t.widgetState.getIndexToWorldT();
        let c = [];
        if (r === "corners" && (c = n.handleEvent(e, t._apiSpecificRenderWindow).worldCoords), r === "faces") {
          const u = [1 - a[0], 1 - a[1], 1 - a[2]], d = [(o[0] + o[1]) / 2, (o[2] + o[3]) / 2, (o[4] + o[5]) / 2];
          n.setHandleOrigin(oV(d, l)), n.setHandleNormal(Ez(u, l)), c = n.handleEvent(e, t._apiSpecificRenderWindow).worldCoords;
        }
        if (r === "edges") {
          const u = a.map((d) => d === 1 ? d : 0);
          n.setHandleNormal(Ez(u, l)), c = n.handleEvent(e, t._apiSpecificRenderWindow).worldCoords;
        }
        if (c.length) {
          const u = t.widgetState.getWorldToIndexT(), d = oV(c, u);
          for (let h = 0; h < 3; h++)
            a[h] === 0 ? o[h * 2] = d[h] : a[h] === 2 && (o[h * 2 + 1] = d[h]);
          return t.activeState.setOrigin(...c), t.widgetState.getCroppingPlanes().setPlanes(...o), tt.EVENT_ABORT;
        }
      }
    }
    return tt.VOID;
  }, t._camera = t._renderer.getActiveCamera(), t.classHierarchy.push("vtkImageCroppingWidgetProp");
}
const WS = "default";
function kz(i, t) {
  const e = i.indexOf(t);
  e !== -1 && i.splice(e, 1);
}
function lGt(i, t) {
  t.classHierarchy.push("vtkWidgetState");
  const e = [];
  t.labels = {}, t.nestedStates = [], i.bindState = function(n) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [WS];
    if (t.nestedStates.push(n), e.push(n.onModified(i.modified)), Array.isArray(s) && s.length)
      for (let r = 0; r < s.length; r++) {
        const a = s[r];
        t.labels[a] || (t.labels[a] = []), t.labels[a].push(n);
      }
    else {
      const r = Array.isArray(s) ? WS : s || WS;
      t.labels[r] || (t.labels[r] = []), t.labels[r].push(n);
    }
  }, i.unbindState = (n) => {
    for (; e.length; )
      e.pop().unsubscribe();
    kz(t.nestedStates, n);
    for (let s = 0; s < t.nestedStates.length; s++)
      e.push(t.nestedStates[s].onModified(i.modified));
    Object.keys(t.labels).forEach((s) => {
      const r = t.labels[s];
      kz(r, n);
    });
  }, i.unbindAll = () => {
    for (; e.length; )
      e.pop().unsubscribe();
    t.nestedStates = [];
  }, i.activate = () => i.setActive(!0), i.deactivate = (n) => {
    n !== i && i.setActive(!1);
    for (let s = 0; s < t.nestedStates.length; s++)
      t.nestedStates[s].deactivate(n);
  }, i.activateOnly = (n) => {
    n && n.setActive(!0), i.deactivate(n);
  }, i.getStatesWithLabel = (n) => t.labels[n], i.getAllNestedStates = () => t.nestedStates, i.delete = tt.chain(i.unbindAll, i.delete);
}
const cGt = {
  active: !1
};
function uGt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, cGt, e), tt.obj(i, t), tt.setGet(i, t, ["active"]), lGt(i, t);
}
var AA = {
  extend: uGt
};
function dGt(i, t) {
  const e = [], n = [...qe.INIT_BOUNDS];
  i.containsPoint = (s, r, a) => Array.isArray(s) ? qe.containsPoint(n, s[0], s[1], s[2]) : qe.containsPoint(n, s, r, a), i.placeWidget = (s) => {
    t.bounds = [];
    const r = [(s[0] + s[1]) / 2, (s[2] + s[3]) / 2, (s[4] + s[5]) / 2];
    for (let a = 0; a < 6; a++) {
      const o = r[Math.floor(a / 2)];
      e[a] = s[a], t.bounds[a] = (s[a] - o) * t.placeFactor + o;
    }
    qe.setBounds(n, t.bounds), i.invokeBoundsChange(t.bounds), i.modified();
  }, i.setPlaceFactor = (s) => {
    if (t.placeFactor !== s) {
      t.placeFactor = s, t.bounds = [];
      const r = [(e[0] + e[1]) / 2, (e[2] + e[3]) / 2, (e[4] + e[5]) / 2];
      for (let a = 0; a < 6; a++) {
        const o = r[Math.floor(a / 2)];
        t.bounds[a] = (e[a] - o) * t.placeFactor + o;
      }
      qe.setBounds(n, t.bounds), i.invokeBoundsChange(t.bounds), i.modified();
    }
  };
}
const hGt = {
  bounds: [-1, 1, -1, 1, -1, 1],
  placeFactor: 1
};
function pGt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, hGt, e), tt.setGetArray(i, t, ["bounds"], 6), tt.get(i, t, ["placeFactor"]), tt.event(i, t, "BoundsChange"), t.bounds = t.bounds.slice(), dGt(i, t);
}
var BA = {
  extend: pGt
};
const mGt = {
  color: 0.5
};
function bGt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, mGt, e), tt.setGet(i, t, ["color"]);
}
var fGt = {
  extend: bGt
};
const gGt = {
  color3: [255, 255, 255],
  opacity: 255
};
function yGt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, gGt, e), tt.setGetArray(i, t, ["color3"], 3, 255), tt.setGet(i, t, ["opacity"]);
}
var ZGt = {
  extend: yGt
};
function TGt(i, t) {
  i.translate = (e, n, s) => {
    const [r, a, o] = i.getCornerByReference();
    i.setCorner(r + e, a + n, o + s);
  };
}
const MGt = {
  corner: [0, 0, 0]
};
function NGt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, MGt, e), tt.setGetArray(i, t, ["corner"], 3), TGt(i);
}
var WGt = {
  extend: NGt
};
function GGt(i, t) {
  const e = t.angleUnit === "degree" ? il.buildFromDegree() : il.buildFromRadian();
  i.rotateFromDirections = (n, s) => {
    e.identity().rotateFromDirections(n, s).apply(t.direction), i.modified();
  }, i.rotate = (n, s) => {
    e.identity().rotate(n, s).apply(t.direction);
  }, i.rotateX = (n) => {
    e.identity().rotateX(n).apply(t.direction);
  }, i.rotateY = (n) => {
    e.identity().rotateY(n).apply(t.direction);
  }, i.rotateZ = (n) => {
    e.identity().rotateZ(n).apply(t.direction);
  };
}
const wGt = {
  direction: [1, 0, 0]
};
function xGt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, wGt, e), tt.setGetArray(i, t, ["direction"], 3), GGt(i, t);
}
var SGt = {
  extend: xGt
};
function LGt(i, t) {
  i.updateManipulator = () => {
    if (t.manipulator) {
      const {
        origin: e,
        normal: n,
        direction: s
      } = t, {
        setHandleOrigin: r,
        setHandleCenter: a,
        setHandleNormal: o,
        setHandleDirection: l
      } = t.manipulator;
      e && r ? r(e) : e && a && a(e), s && l ? l(s) : s && !n && o ? o(s) : n && l && l(n);
    }
  };
}
const VGt = {
  manipulator: null
};
function XGt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, VGt, e), tt.setGet(i, t, ["manipulator"]), LGt(i, t);
}
var IGt = {
  extend: XGt
};
const CGt = {
  name: ""
};
function YGt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, CGt, e), tt.setGet(i, t, ["name"]);
}
var vGt = {
  extend: YGt
};
function GS(i, t) {
  return i.length === 3 && t.length === 3 && i[0] === t[0] && i[1] === t[1] && i[2] === t[2];
}
function RGt(i, t, e, n) {
  return GS(i, n.o) && GS(t, n.p1) && GS(e, n.p2);
}
function DGt(i, t) {
  const e = {
    o: [],
    p1: [],
    p2: []
  };
  i.normalize = () => {
    Fn(t.up), Fn(t.right), Fn(t.direction), i.modified();
  }, i.updateFromOriginRightUp = (n, s, r) => {
    RGt(n, s, r, e) || (e.o = n.slice(), e.p1 = s.slice(), e.p2 = r.slice(), t.up = [r[0] - n[0], r[1] - n[1], r[2] - n[2]], t.right = [s[0] - n[0], s[1] - n[1], s[2] - n[2]], Wi(t.up, t.right, t.direction), Wi(t.direction, t.up, t.right), i.normalize(), i.modified());
  };
}
const OGt = {
  up: [0, 1, 0],
  right: [1, 0, 0],
  direction: [0, 0, 1]
};
function zGt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, OGt, e), tt.setGetArray(i, t, ["up", "right", "direction"], 3), DGt(i, t);
}
var EGt = {
  extend: zGt
};
function kGt(i, t) {
  const e = {
    ...i
  };
  i.translate = (n, s, r) => {
    const [a, o, l] = i.getOriginByReference();
    i.setOrigin(a + n, o + s, l + r);
  }, i.getOrigin = (n) => {
    const s = e.getOrigin();
    if (!t.offset)
      return s;
    if (!n)
      return Hn.add(s, t.offset, s);
    const r = cw(s, n), {
      rendererPixelDims: a
    } = n, o = Math.min(a[0], a[1]);
    return Hn.multiplyAccumulate(s, t.offset, o * r, s);
  };
}
const FGt = {
  origin: null,
  offset: null
};
function jGt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, FGt, e), tt.setGetArray(i, t, ["origin", "offset"], 3), kGt(i, t);
}
var UGt = {
  extend: jGt
};
const PGt = {
  scale1: 0.5
};
function JGt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, PGt, e), tt.setGet(i, t, ["scale1"]);
}
var AGt = {
  extend: JGt
};
const BGt = {
  scale3: [1, 1, 1]
};
function KGt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, BGt, e), tt.setGetArray(i, t, ["scale3"], 3);
}
var HGt = {
  extend: KGt
};
const _Gt = {
  text: "DefaultText"
};
function QGt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, _Gt, e), tt.setGet(i, t, ["text"]);
}
var $Gt = {
  extend: QGt
};
const qGt = {
  visible: !0
};
function twt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, qGt, e), tt.setGet(i, t, ["visible"]), i.isVisible = i.getVisible;
}
var ewt = {
  extend: twt
};
const nwt = {
  shape: ""
};
function iwt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, nwt, e), tt.setGet(i, t, ["shape"]);
}
var swt = {
  extend: iwt
};
const {
  vtkErrorMacro: rwt
} = tt, awt = {
  bounds: BA,
  color: fGt,
  color3: ZGt,
  corner: WGt,
  direction: SGt,
  manipulator: IGt,
  name: vGt,
  orientation: EGt,
  origin: UGt,
  scale1: AGt,
  scale3: HGt,
  text: $Gt,
  visible: ewt,
  shape: swt
};
function wS(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  (arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1) || AA.extend(e, n, t);
  for (let r = 0; r < i.length; r++) {
    const a = awt[i[r]];
    a ? a.extend(e, n, t) : rwt("Invalid mixin name:", i[r]);
  }
  return tt.safeArrays(n), Object.freeze(e);
}
class owt {
  constructor() {
    this.publicAPI = {}, this.model = {}, AA.extend(this.publicAPI, this.model), BA.extend(this.publicAPI, this.model);
  }
  /* eslint-disable no-shadow */
  addDynamicMixinState(t) {
    let {
      labels: e,
      mixins: n,
      name: s,
      initialValues: r
    } = t;
    const a = `${s}List`;
    return this.model[a] = [], this.publicAPI[`add${tt.capitalize(s)}`] = (o) => {
      const l = wS(n, {
        ...r,
        ...o
      });
      return this.publicAPI.bindState(l, e), this.model[a].push(l), this.publicAPI.modified(), l;
    }, this.publicAPI[`remove${tt.capitalize(s)}`] = (o) => {
      let l = this.model[a].indexOf(o);
      l === -1 && o < this.model[a].length && (l = o);
      const c = this.model[a][l];
      c && this.publicAPI.unbindState(c), this.model[a].splice(l, 1), this.publicAPI.modified();
    }, this.publicAPI[`get${tt.capitalize(s)}List`] = () => this.model[a].slice(), this.publicAPI[`clear${tt.capitalize(s)}List`] = () => {
      for (; this.model[a].length; ) {
        const o = this.model[a].pop();
        o && this.publicAPI.unbindState(o);
      }
      this.publicAPI.modified();
    }, this;
  }
  addStateFromMixin(t) {
    let {
      labels: e,
      mixins: n,
      name: s,
      initialValues: r
    } = t;
    const a = wS(n, r);
    return this.model[s] = a, this.publicAPI.bindState(a, e), tt.setGet(this.publicAPI, this.model, [s]), this;
  }
  addStateFromInstance(t) {
    let {
      labels: e,
      name: n,
      instance: s
    } = t;
    return this.model[n] = s, this.publicAPI.bindState(s, e), tt.setGet(this.publicAPI, this.model, [n]), this;
  }
  addField(t) {
    let {
      name: e,
      initialValue: n
    } = t;
    return Array.isArray(n) ? tt.setGetArray(this.publicAPI, this.model, [e], n.length) : tt.setGet(this.publicAPI, this.model, [e]), this.model[e] = n, this;
  }
  build() {
    for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
      e[n] = arguments[n];
    return wS(e, {}, this.publicAPI, this.model, !0);
  }
}
function lwt() {
  return new owt();
}
var Fz = {
  createBuilder: lwt
};
function cwt() {
  const i = Fz.createBuilder();
  i.addField({
    name: "indexToWorldT",
    initialValue: Array(16).fill(0)
  }).addField({
    name: "worldToIndexT",
    initialValue: Array(16).fill(0)
  });
  const t = Fz.createBuilder().addField({
    name: "planes",
    // index space
    initialValue: [0, 1, 0, 1, 0, 1]
  }).build();
  i.addStateFromInstance({
    labels: ["croppingPlanes"],
    name: "croppingPlanes",
    instance: t
  });
  for (let e = -1; e < 2; e++)
    for (let n = -1; n < 2; n++)
      for (let s = -1; s < 2; s++)
        if (e !== 0 || n !== 0 || s !== 0) {
          const r = Ob[e + 1] + Ob[n + 1] + Ob[s + 1], a = JA(r);
          i.addStateFromMixin({
            labels: ["handles", r, a],
            mixins: ["name", "origin", "color", "scale1", "visible", "manipulator"],
            name: r,
            initialValues: {
              scale1: 30,
              origin: [e, n, s],
              visible: !0,
              name: r
            }
          });
        }
  return i.build();
}
function uwt(i, t) {
  t.classHierarchy.push("vtkImageCroppingWidget");
  const e = {
    ...i
  };
  let n = null;
  function s(r, a) {
    t.widgetState.getStatesWithLabel(r).forEach((o) => {
      o.setVisible(a);
    });
  }
  i.setFaceHandlesEnabled = (r) => s("faces", r), i.setEdgeHandlesEnabled = (r) => s("edges", r), i.setCornerHandlesEnabled = (r) => s("corners", r), i.copyImageDataDescription = (r) => {
    t.widgetState.setIndexToWorldT(...r.getIndexToWorld()), t.widgetState.setWorldToIndexT(...r.getWorldToIndex());
    const a = r.getDimensions();
    t.widgetState.getCroppingPlanes().setPlanes([0, a[0], 0, a[1], 0, a[2]]), i.modified();
  }, i.updateHandles = () => {
    const r = t.widgetState.getCroppingPlanes().getPlanes(), a = [(r[0] + r[1]) / 2, (r[2] + r[3]) / 2, (r[4] + r[5]) / 2], o = [r[0], a[0], r[1]], l = [r[2], a[1], r[3]], c = [r[4], a[2], r[5]], u = t.widgetState.getIndexToWorldT(), d = (h) => Ob[h];
    for (let h = 0; h < 3; h++)
      for (let p = 0; p < 3; p++)
        for (let m = 0; m < 3; m++)
          if (h !== 1 || p !== 1 || m !== 1) {
            const b = [h, p, m].map(d).join(""), y = oV([o[h], l[p], c[m]], u), [Z] = t.widgetState.getStatesWithLabel(b);
            Z.setOrigin(...y);
          }
  }, i.delete = tt.chain(i.delete, () => {
    n && n.unsubscribe();
  }), t.methodsToLink = ["scaleInPixels"], i.getRepresentationsForViewType = (r) => {
    switch (r) {
      case Vy.DEFAULT:
      case Vy.GEOMETRY:
      case Vy.SLICE:
      case Vy.VOLUME:
      default:
        return [
          // Describes constructing a vtkSphereHandleRepresentation, and every
          // time the widget state updates, we will give the representation
          // a list of all handle states (which have the label "handles").
          {
            builder: eGt,
            labels: ["handles"]
          },
          {
            builder: aGt,
            // outline is defined by corner points
            labels: ["corners"]
          }
        ];
    }
  }, n = t.widgetState.getCroppingPlanes().onModified(i.updateHandles), i.setCornerManipulator = (r) => {
    e.setCornerManipulator(r), t.widgetState.getStatesWithLabel("corners").forEach((a) => a.setManipulator(r));
  }, i.setEdgeManipulator = (r) => {
    e.setEdgeManipulator(r), t.widgetState.getStatesWithLabel("edges").forEach((a) => a.setManipulator(r));
  }, i.setFaceManipulator = (r) => {
    e.setFaceManipulator(r), t.widgetState.getStatesWithLabel("faces").forEach((a) => a.setManipulator(r));
  }, i.setCornerManipulator(Rz.newInstance({
    useCameraNormal: !0
  })), i.setEdgeManipulator(Rz.newInstance()), i.setFaceManipulator(bWt.newInstance());
}
const dwt = (i) => ({
  // cornerManipulator: null,
  // edgeManipulator: null,
  // faceManipulator: null,
  behavior: oGt,
  widgetState: cwt(),
  ...i
});
function KA(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, dwt(e)), rWt.extend(i, t, e), tt.setGet(i, t, ["cornerManipulator", "edgeManipulator", "faceManipulator"]), uwt(i, t);
}
const hwt = tt.newInstance(KA, "vtkImageCroppingWidget");
var pwt = {
  newInstance: hwt,
  extend: KA
};
const {
  vtkErrorMacro: ly
} = kr, {
  Representation: mwt
} = V0, {
  ObjectType: YM
} = Rc, {
  PassTypes: bwt
} = JG, fwt = {
  type: "StartEvent"
}, gwt = {
  type: "EndEvent"
};
function ywt(i, t) {
  t.classHierarchy.push("vtkOpenGLGlyph3DMapper");
  const e = {
    ...i
  };
  i.renderPiece = (n, s) => {
    if (i.invokeEvent(fwt), t.renderable.getStatic() || t.renderable.update(), t.currentInput = t.renderable.getInputData(1), i.invokeEvent(gwt), !t.currentInput) {
      ly("No input!");
      return;
    }
    if (!t.currentInput.getPoints || !t.currentInput.getPoints().getNumberOfValues())
      return;
    const r = t.context;
    t._openGLRenderWindow.getWebgl2() ? (t.hardwareSupport = !0, t.extension = null) : t.extension || (t.extension = t.context.getExtension("ANGLE_instanced_arrays"), t.hardwareSupport = !!t.extension);
    const a = s.getProperty().getBackfaceCulling(), o = s.getProperty().getFrontfaceCulling();
    !a && !o ? t._openGLRenderWindow.disableCullFace() : o ? (t._openGLRenderWindow.enableCullFace(), r.cullFace(r.FRONT)) : (t._openGLRenderWindow.enableCullFace(), r.cullFace(r.BACK)), i.renderPieceStart(n, s), i.renderPieceDraw(n, s), i.renderPieceFinish(n, s);
  }, i.multiply4x4WithOffset = (n, s, r, a) => {
    const o = s[0], l = s[1], c = s[2], u = s[3], d = s[4], h = s[5], p = s[6], m = s[7], b = s[8], y = s[9], Z = s[10], g = s[11], f = s[12], T = s[13], M = s[14], N = s[15];
    let W = r[a], x = r[a + 1], V = r[a + 2], X = r[a + 3];
    n[0] = W * o + x * d + V * b + X * f, n[1] = W * l + x * h + V * y + X * T, n[2] = W * c + x * p + V * Z + X * M, n[3] = W * u + x * m + V * g + X * N, W = r[a + 4], x = r[a + 5], V = r[a + 6], X = r[a + 7], n[4] = W * o + x * d + V * b + X * f, n[5] = W * l + x * h + V * y + X * T, n[6] = W * c + x * p + V * Z + X * M, n[7] = W * u + x * m + V * g + X * N, W = r[a + 8], x = r[a + 9], V = r[a + 10], X = r[a + 11], n[8] = W * o + x * d + V * b + X * f, n[9] = W * l + x * h + V * y + X * T, n[10] = W * c + x * p + V * Z + X * M, n[11] = W * u + x * m + V * g + X * N, W = r[a + 12], x = r[a + 13], V = r[a + 14], X = r[a + 15], n[12] = W * o + x * d + V * b + X * f, n[13] = W * l + x * h + V * y + X * T, n[14] = W * c + x * p + V * Z + X * M, n[15] = W * u + x * m + V * g + X * N;
  }, i.replaceShaderNormal = (n, s, r) => {
    if (t.hardwareSupport && t.lastBoundBO.getReferenceByName("lastLightComplexity") > 0) {
      let o = n.Vertex;
      t.lastBoundBO.getCABO().getNormalOffset() && (o = Ft.substitute(o, "//VTK::Normal::Dec", ["attribute vec3 normalMC;", "attribute mat3 gNormal;", "uniform mat3 normalMatrix;", "varying vec3 normalVCVSOutput;"]).result, o = Ft.substitute(o, "//VTK::Normal::Impl", ["normalVCVSOutput = normalMatrix * gNormal * normalMC;"]).result), n.Vertex = o;
    }
    e.replaceShaderNormal(n, s, r);
  }, i.replaceShaderColor = (n, s, r) => {
    if (t.hardwareSupport && t.renderable.getColorArray()) {
      let a = n.Vertex, o = n.Geometry, l = n.Fragment;
      const c = t.lastBoundBO.getReferenceByName("lastLightComplexity");
      let u = ["uniform float ambient;", "uniform float diffuse;", "uniform float specular;", "uniform float opacityUniform; // the fragment opacity"];
      c && (u = u.concat(["uniform vec3 specularColorUniform;", "uniform float specularPowerUniform;"]));
      let d = ["vec3 ambientColor;", "  vec3 diffuseColor;", "  float opacity;"];
      c && (d = d.concat(["  vec3 specularColor;", "  float specularPower;"])), d = d.concat(["  opacity = opacityUniform;"]), c && (d = d.concat(["  specularColor = specularColorUniform;", "  specularPower = specularPowerUniform;"])), t.drawingEdges || (u = u.concat(["varying vec4 vertexColorVSOutput;"]), a = Ft.substitute(a, "//VTK::Color::Dec", ["attribute vec4 gColor;", "varying vec4 vertexColorVSOutput;"]).result, a = Ft.substitute(a, "//VTK::Color::Impl", ["vertexColorVSOutput = gColor;"]).result, o = Ft.substitute(o, "//VTK::Color::Dec", ["in vec4 vertexColorVSOutput[];", "out vec4 vertexColorGSOutput;"]).result, o = Ft.substitute(o, "//VTK::Color::Impl", ["vertexColorGSOutput = vertexColorVSOutput[i];"]).result, d = d.concat(["  diffuseColor = vertexColorVSOutput.rgb;", "  ambientColor = vertexColorVSOutput.rgb;", "  opacity = opacity*vertexColorVSOutput.a;"])), l = Ft.substitute(l, "//VTK::Color::Impl", d).result, l = Ft.substitute(l, "//VTK::Color::Dec", u).result, n.Vertex = a, n.Geometry = o, n.Fragment = l;
    }
    e.replaceShaderColor(n, s, r);
  }, i.replaceShaderPositionVC = (n, s, r) => {
    if (t.hardwareSupport) {
      let a = n.Vertex;
      t.lastBoundBO.getReferenceByName("lastLightComplexity") > 0 ? (a = Ft.substitute(a, "//VTK::PositionVC::Impl", ["vec4 gVertexMC = gMatrix * vertexMC;", "vertexVCVSOutput = MCVCMatrix * gVertexMC;", "  gl_Position = MCPCMatrix * gVertexMC;"]).result, a = Ft.substitute(a, "//VTK::Camera::Dec", ["attribute mat4 gMatrix;", "uniform mat4 MCPCMatrix;", "uniform mat4 MCVCMatrix;"]).result) : (a = Ft.substitute(a, "//VTK::Camera::Dec", ["attribute mat4 gMatrix;", "uniform mat4 MCPCMatrix;"]).result, a = Ft.substitute(a, "//VTK::PositionVC::Impl", ["vec4 gVertexMC = gMatrix * vertexMC;", "  gl_Position = MCPCMatrix * gVertexMC;"]).result), n.Vertex = a;
    }
    e.replaceShaderPositionVC(n, s, r);
  }, i.replaceShaderPicking = (n, s, r) => {
    if (t.hardwareSupport) {
      let a = n.Fragment, o = n.Vertex;
      o = Ft.substitute(o, "//VTK::Picking::Dec", ["attribute vec3 mapperIndexVS;", "varying vec3 mapperIndexVSOutput;"]).result, o = Ft.substitute(o, "//VTK::Picking::Impl", "  mapperIndexVSOutput = mapperIndexVS;").result, n.Vertex = o, a = Ft.substitute(a, "//VTK::Picking::Dec", ["varying vec3 mapperIndexVSOutput;", "uniform vec3 mapperIndex;", "uniform int picking;"]).result, a = Ft.substitute(a, "//VTK::Picking::Impl", ["  vec4 pickColor = picking == 2 ? vec4(mapperIndexVSOutput,1.0) : vec4(mapperIndex,1.0);", "  gl_FragData[0] = picking != 0 ? pickColor : gl_FragData[0];"]).result, n.Fragment = a;
    } else
      e.replaceShaderPicking(n, s, r);
  }, i.updateGlyphShaderParameters = (n, s, r, a, o, l, c, u) => {
    const d = r.getProgram();
    if (n) {
      const h = t.normalMatrix, p = l, m = c * 9, b = t.tmpMat3, y = h[0], Z = h[1], g = h[2], f = h[3], T = h[4], M = h[5], N = h[6], W = h[7], x = h[8], V = p[m], X = p[m + 1], C = p[m + 2], R = p[m + 3], z = p[m + 4], F = p[m + 5], P = p[m + 6], j = p[m + 7], H = p[m + 8];
      b[0] = V * y + X * f + C * N, b[1] = V * Z + X * T + C * W, b[2] = V * g + X * M + C * x, b[3] = R * y + z * f + F * N, b[4] = R * Z + z * T + F * W, b[5] = R * g + z * M + F * x, b[6] = P * y + j * f + H * N, b[7] = P * Z + j * T + H * W, b[8] = P * g + j * M + H * x, d.setUniformMatrix3x3("normalMatrix", t.tmpMat3);
    }
    if (i.multiply4x4WithOffset(t.tmpMat4, t.mcpcMatrix, o, c * 16), d.setUniformMatrix("MCPCMatrix", t.tmpMat4), s && (i.multiply4x4WithOffset(t.tmpMat4, t.mcvcMatrix, o, c * 16), d.setUniformMatrix("MCVCMatrix", t.tmpMat4)), a) {
      const h = a.getData();
      t.tmpColor[0] = h[c * 4] / 255, t.tmpColor[1] = h[c * 4 + 1] / 255, t.tmpColor[2] = h[c * 4 + 2] / 255, d.setUniform3fArray("ambientColorUniform", t.tmpColor), d.setUniform3fArray("diffuseColorUniform", t.tmpColor);
    }
    u && d.setUniform3fArray("mapperIndex", u.getPropColorValue());
  }, i.renderPieceDraw = (n, s) => {
    const r = s.getProperty().getRepresentation(), a = t.context, o = s.getProperty().getEdgeVisibility() && r === mwt.SURFACE, l = t.openGLCamera.getKeyMatrices(n), c = t.openGLActor.getKeyMatrices();
    gi.multiply(t.normalMatrix, l.normalMatrix, c.normalMatrix), ut.multiply(t.mcpcMatrix, l.wcpc, c.mcwc), ut.multiply(t.mcvcMatrix, l.wcvc, c.mcwc);
    const u = t.renderable.getMatrixArray(), d = t.renderable.getNormalArray(), h = t.renderable.getColorArray(), p = u.length / 16;
    let m = !1;
    t._openGLRenderer.getSelector() && t._openGLRenderer.getSelector().getCurrentPass() === bwt.COMPOSITE_INDEX_PASS && (m = !0);
    for (let b = t.primTypes.Start; b < t.primTypes.End; b++) {
      const y = t.primitives[b].getCABO();
      if (y.getElementCount()) {
        t.drawingEdges = o && (b === t.primTypes.TrisEdges || b === t.primTypes.TriStripsEdges), t.lastBoundBO = t.primitives[b], t.primitives[b].updateShaders(n, s, i);
        const Z = t.primitives[b].getProgram(), g = t.primitives[b].getOpenGLMode(r), f = Z.isUniformUsed("normalMatrix"), T = Z.isUniformUsed("MCVCMatrix");
        if (t.hardwareSupport)
          t.extension ? t.extension.drawArraysInstancedANGLE(g, 0, Number(y.getElementCount()), p) : a.drawArraysInstanced(g, 0, Number(y.getElementCount()), p);
        else
          for (let M = 0; M < p; ++M)
            m && t._openGLRenderer.getSelector().renderCompositeIndex(M), i.updateGlyphShaderParameters(f, T, t.primitives[b], h, u, d, M, m ? t._openGLRenderer.getSelector() : null), a.drawArrays(g, 0, Number(y.getElementCount()));
      }
    }
  }, i.setMapperShaderParameters = (n, s, r) => {
    if (n.getCABO().getElementCount() && (t.glyphBOBuildTime.getMTime() > n.getAttributeUpdateTime().getMTime() || n.getShaderSourceTime().getMTime() > n.getAttributeUpdateTime().getMTime())) {
      n.getProgram().isAttributeUsed("gMatrix") ? n.getVAO().addAttributeMatrixWithDivisor(n.getProgram(), t.matrixBuffer, "gMatrix", 0, 64, t.context.FLOAT, 4, !1, 1) || ly("Error setting gMatrix in shader VAO.") : n.getVAO().removeAttributeArray("gMatrix"), n.getProgram().isAttributeUsed("gNormal") ? n.getVAO().addAttributeMatrixWithDivisor(n.getProgram(), t.normalBuffer, "gNormal", 0, 36, t.context.FLOAT, 3, !1, 1) || ly("Error setting gNormal in shader VAO.") : n.getVAO().removeAttributeArray("gNormal"), n.getProgram().isAttributeUsed("gColor") ? n.getVAO().addAttributeArrayWithDivisor(n.getProgram(), t.colorBuffer, "gColor", 0, 4, t.context.UNSIGNED_BYTE, 4, !0, 1, !1) || ly("Error setting gColor in shader VAO.") : n.getVAO().removeAttributeArray("gColor"), n.getProgram().isAttributeUsed("mapperIndexVS") ? n.getVAO().addAttributeArrayWithDivisor(n.getProgram(), t.pickBuffer, "mapperIndexVS", 0, 4, t.context.UNSIGNED_BYTE, 4, !0, 1, !1) || ly("Error setting mapperIndexVS in shader VAO.") : n.getVAO().removeAttributeArray("mapperIndexVS"), e.setMapperShaderParameters(n, s, r), n.getAttributeUpdateTime().modified();
      return;
    }
    e.setMapperShaderParameters(n, s, r);
  }, i.getNeedToRebuildBufferObjects = (n, s) => (t.renderable.buildArrays(), t.VBOBuildTime.getMTime() < t.renderable.getBuildTime().getMTime() ? !0 : e.getNeedToRebuildBufferObjects(n, s)), i.getNeedToRebuildShaders = (n, s, r) => !!(e.getNeedToRebuildShaders(n, s, r) || n.getShaderSourceTime().getMTime() < t.renderable.getMTime() || n.getShaderSourceTime().getMTime() < t.currentInput.getMTime()), i.buildBufferObjects = (n, s) => {
    if (t.hardwareSupport) {
      const r = t.renderable.getMatrixArray(), a = t.renderable.getNormalArray(), o = t.renderable.getColorArray();
      if (t.matrixBuffer || (t.matrixBuffer = Rc.newInstance(), t.matrixBuffer.setOpenGLRenderWindow(t._openGLRenderWindow), t.normalBuffer = Rc.newInstance(), t.normalBuffer.setOpenGLRenderWindow(t._openGLRenderWindow), t.colorBuffer = Rc.newInstance(), t.colorBuffer.setOpenGLRenderWindow(t._openGLRenderWindow), t.pickBuffer = Rc.newInstance(), t.pickBuffer.setOpenGLRenderWindow(t._openGLRenderWindow)), t.renderable.getBuildTime().getMTime() > t.glyphBOBuildTime.getMTime()) {
        t.matrixBuffer.upload(r, YM.ARRAY_BUFFER), t.normalBuffer.upload(a, YM.ARRAY_BUFFER), o ? t.colorBuffer.upload(o.getData(), YM.ARRAY_BUFFER) : t.colorBuffer.releaseGraphicsResources();
        const l = r.length / 16, c = new Uint8Array(4 * l);
        for (let u = 0; u < l; ++u) {
          let d = u + 1;
          const h = u * 4;
          c[h] = d % 256, d -= c[h], d /= 256, c[h + 1] = d % 256, d -= c[h + 1], d /= 256, c[h + 2] = d % 256, c[h + 3] = 255;
        }
        t.pickBuffer.upload(c, YM.ARRAY_BUFFER), t.glyphBOBuildTime.modified();
      }
    }
    return e.buildBufferObjects(n, s);
  };
}
const Zwt = {
  normalMatrix: null,
  mcpcMatrix: null,
  mcwcMatrix: null
};
function Twt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, Zwt, e), kI.extend(i, t, e), t.tmpMat3 = gi.identity(new Float64Array(9)), t.normalMatrix = gi.identity(new Float64Array(9)), t.mcpcMatrix = ut.identity(new Float64Array(16)), t.mcvcMatrix = ut.identity(new Float64Array(16)), t.tmpColor = [], t.glyphBOBuildTime = {}, xi(t.glyphBOBuildTime, {
    mtime: 0
  }), ywt(i, t);
}
const Mwt = In(Twt, "vtkOpenGLGlyph3DMapper");
Js("vtkGlyph3DMapper", Mwt);
function Nwt(i, t) {
  t.classHierarchy.push("vtkWebGPUGlyph3DCellArrayMapper");
  const e = {
    ...i
  };
  i.setGlyphInstances = (n) => {
    t.glyphInstances = n;
  }, i.updateBuffers = () => {
    e.updateBuffers(), i.setNumberOfInstances(t.glyphInstances);
  }, i.replaceShaderPosition = (n, s, r) => {
    const a = s.getShaderDescription("vertex");
    a.addBuiltinInput("u32", "@builtin(instance_index) instanceIndex"), a.addBuiltinOutput("vec4<f32>", "@builtin(position) Position"), a.hasOutput("vertexVC") || a.addOutput("vec3<f32>", "vertexVC");
    let o = a.getCode();
    o = kn.substitute(o, "//VTK::Position::Impl", ["    var vertexSC: vec4<f32> = mapperUBO.BCSCMatrix*glyphSSBO.values[input.instanceIndex].matrix*vertexBC;", "    output.vertexVC = (rendererUBO.SCVCMatrix*vertexSC).xyz;", "    output.Position = rendererUBO.SCPCMatrix*vertexSC;"]).result, a.setCode(o);
  }, t.shaderReplacements.set("replaceShaderPosition", i.replaceShaderPosition), i.replaceShaderNormal = (n, s, r) => {
    if (r.hasAttribute("normalMC")) {
      const a = s.getShaderDescription("vertex");
      let o = a.getCode();
      o = kn.substitute(o, "//VTK::Normal::Impl", ["  output.normalVC = normalize((rendererUBO.WCVCNormals", " * mapperUBO.MCWCNormals", " * glyphSSBO.values[input.instanceIndex].normal*normalMC).xyz);"]).result, a.setCode(o);
    }
    e.replaceShaderNormal(n, s, r);
  }, t.shaderReplacements.set("replaceShaderNormal", i.replaceShaderNormal), i.replaceShaderColor = (n, s, r) => {
    if (!t.renderable.getColorArray()) {
      e.replaceShaderColor(n, s, r);
      return;
    }
    const a = s.getShaderDescription("vertex");
    a.addOutput("vec4<f32>", "color");
    let o = a.getCode();
    o = kn.substitute(o, "//VTK::Color::Impl", ["  output.color = glyphSSBO.values[input.instanceIndex].color;"]).result, a.setCode(o);
    const l = s.getShaderDescription("fragment");
    o = l.getCode(), o = kn.substitute(o, "//VTK::Color::Impl", ["ambientColor = input.color;", "diffuseColor = input.color;", "opacity = mapperUBO.Opacity * input.color.a;"]).result, l.setCode(o);
  }, t.shaderReplacements.set("replaceShaderColor", i.replaceShaderColor), i.replaceShaderSelect = (n, s, r) => {
    if (n.includes("sel")) {
      const a = s.getShaderDescription("vertex");
      a.addOutput("u32", "compositeID", "flat");
      let o = a.getCode();
      o = kn.substitute(o, "//VTK::Select::Impl", ["  output.compositeID = input.instanceIndex;"]).result, a.setCode(o);
      const l = s.getShaderDescription("fragment");
      o = l.getCode(), o = kn.substitute(o, "//VTK::Select::Impl", ["var compositeID: u32 = input.compositeID;"]).result, l.setCode(o);
    }
  }, t.shaderReplacements.set("replaceShaderSelect", i.replaceShaderSelect);
}
function Wwt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, {}, e), jI.extend(i, t, e), Nwt(i, t);
}
const Gwt = In(Wwt, "vtkWebGPUGlyph3DCellArrayMapper");
function wwt(i, t) {
  t.classHierarchy.push("vtkWebGPUGlyph3DMapper"), i.createCellArrayMapper = () => {
    const e = Gwt();
    return e.setSSBO(t.SSBO), e.setRenderable(t.renderable), e;
  }, i.buildPass = (e) => {
    if (e) {
      t.WebGPUActor = i.getFirstAncestorOfType("vtkWebGPUActor"), t.renderable.getStatic() || t.renderable.update();
      const n = t.renderable.getInputData(1);
      t.renderable.mapScalars(n, 1), i.updateSSBO(), i.updateCellArrayMappers(n);
      for (let s = 0; s < t.children.length; s++)
        t.children[s].setGlyphInstances(t.numInstances);
    }
  }, i.updateSSBO = () => {
    t.currentInput = t.renderable.getInputData(1), t.renderable.buildArrays();
    const e = t.renderable.getMatrixArray(), n = t.renderable.getNormalArray();
    if (t.carray = t.renderable.getColorArray(), t.numInstances = e.length / 16, t.renderable.getBuildTime().getMTime() > t.glyphBOBuildTime.getMTime()) {
      t.WebGPURenderWindow = i.getFirstAncestorOfType("vtkWebGPURenderWindow");
      const s = t.WebGPURenderWindow.getDevice();
      t.SSBO.clearData(), t.SSBO.setNumberOfInstances(t.numInstances), t.SSBO.addEntry("matrix", "mat4x4<f32>"), t.SSBO.addEntry("normal", "mat4x4<f32>"), t.carray && t.SSBO.addEntry("color", "vec4<f32>"), t.SSBO.setAllInstancesFromArray("matrix", e), t.SSBO.setAllInstancesFromArray3x3To4x4("normal", n), t.carray && t.SSBO.setAllInstancesFromArrayColorToFloat("color", t.carray.getData()), t.SSBO.send(s), t.glyphBOBuildTime.modified();
    }
  };
}
const xwt = {};
function Swt(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, xwt, e), Mot.extend(i, t, e), t.glyphBOBuildTime = {}, xi(t.glyphBOBuildTime, {
    mtime: 0
  }), t.SSBO = Mj.newInstance({
    label: "glyphSSBO"
  }), wwt(i, t);
}
const Lwt = In(Swt, "vtkWebGPUGlyph3DMapper");
Xo("vtkGlyph3DMapper", Lwt);
const Vwt = { style: { width: "100%", height: "100%" } }, Xwt = ["x1", "y1", "x2", "y2", "stroke-width"], Iwt = ["x1", "y1", "x2", "y2", "stroke-width"], Cwt = ["x1", "y1", "x2", "y2", "stroke-width"], Ywt = ["x1", "y1", "x2", "y2"], vwt = ["x1", "y1", "x2", "y2", "stroke-width"], Rwt = ["x1", "y1", "x2", "y2", "stroke-width"], Dwt = ["x1", "y1", "x2", "y2", "stroke-width"], Owt = ["x1", "y1", "x2", "y2"], zwt = ["x1", "y1", "x2", "y2", "stroke-width"], Ewt = ["x1", "y1", "x2", "y2", "stroke-width"], kwt = ["x1", "y1", "x2", "y2", "stroke-width"], Fwt = ["x1", "y1", "x2", "y2"], jwt = ["x1", "y1", "x2", "y2", "stroke-width"], Uwt = ["x1", "y1", "x2", "y2", "stroke-width"], Pwt = ["x1", "y1", "x2", "y2", "stroke-width"], Jwt = ["x1", "y1", "x2", "y2"], Awt = /* @__PURE__ */ Ne({
  __name: "CroppingWidget",
  props: {
    image: {},
    view: {},
    lowerBounds: {},
    upperBounds: {},
    dimensionsLower: {},
    dimensionsUpper: {},
    events: {}
  },
  setup(i) {
    let t = Lt(2), e = Lt(2), n = Lt(2), s = Lt(2), r = 0;
    const a = i;
    let o = !1, l = Le(a.lowerBounds[0]), c = Le(a.lowerBounds[1]), u = Le(a.lowerBounds[2]);
    const d = Le(a.upperBounds[0]), h = Le(a.upperBounds[1]), p = Le(a.upperBounds[2]);
    let m = te(() => H(a.image, a.view, l.value, c.value, u.value)), b = te(() => H(a.image, a.view, d.value, h.value, p.value)), y = te(() => H(a.image, a.view, a.dimensionsLower[0], a.dimensionsLower[1], a.dimensionsLower[2])), Z = te(() => H(a.image, a.view, a.dimensionsUpper[0], a.dimensionsUpper[1], a.dimensionsUpper[2]));
    a.view.events.cameraModified.subscribe(() => {
      y = te(() => H(a.image, a.view, a.dimensionsLower[0], a.dimensionsLower[1], a.dimensionsLower[2])), Z = te(() => H(a.image, a.view, a.dimensionsUpper[0], a.dimensionsUpper[1], a.dimensionsUpper[2])), b = te(() => H(a.image, a.view, d.value, h.value, p.value)), m = te(() => H(a.image, a.view, l.value, c.value, u.value)), R(0, 0);
    }), gn([Z, m, b, y], () => {
      g.startEdge = [m.value[0], y.value[1]], g.startCrop = [m.value[0], m.value[1]], g.endCrop = [m.value[0], b.value[1]], g.endEdge = [m.value[0], Z.value[1]], f.startEdge = [b.value[0], y.value[1]], f.startCrop = [b.value[0], m.value[1]], f.endCrop = [b.value[0], b.value[1]], f.endEdge = [b.value[0], Z.value[1]], T.startEdge = [y.value[0], m.value[1]], T.startCrop = [m.value[0], m.value[1]], T.endCrop = [b.value[0], m.value[1]], T.endEdge = [Z.value[0], m.value[1]], M.startEdge = [y.value[0], b.value[1]], M.startCrop = [m.value[0], b.value[1]], M.endCrop = [b.value[0], b.value[1]], M.endEdge = [Z.value[0], b.value[1]];
    });
    let g = Oh({
      startEdge: [m.value[0], y.value[1]],
      startCrop: [m.value[0], m.value[1]],
      endCrop: [m.value[0], b.value[1]],
      endEdge: [m.value[0], Z.value[1]],
      viewMode: a.view.viewMode,
      lowerUpper: 0,
      vertical: 1
    }), f = Oh({
      startEdge: [b.value[0], y.value[1]],
      startCrop: [b.value[0], m.value[1]],
      endCrop: [b.value[0], b.value[1]],
      endEdge: [b.value[0], Z.value[1]],
      viewMode: a.view.viewMode,
      lowerUpper: 1,
      vertical: 1
    }), T = Oh({
      startEdge: [y.value[0], m.value[1]],
      startCrop: [m.value[0], m.value[1]],
      endCrop: [b.value[0], m.value[1]],
      endEdge: [Z.value[0], m.value[1]],
      viewMode: a.view.viewMode,
      lowerUpper: 0,
      vertical: 0
    }), M = Oh({
      startEdge: [y.value[0], b.value[1]],
      startCrop: [m.value[0], b.value[1]],
      endCrop: [b.value[0], b.value[1]],
      endEdge: [Z.value[0], b.value[1]],
      viewMode: a.view.viewMode,
      lowerUpper: 1,
      vertical: 0
    }), N = [g, f, T, M], W = [0, 0], x = [0, 0, 0];
    const V = (at, dt) => {
      N[r].vertical == 0 ? W = [0, dt] : W = [at, 0], x = a.image.worldToIndex(a.view.viewToWorld(W[0], W[1]));
    }, X = (at, dt) => {
      o = !1;
      let gt;
      N[r].vertical == 0 ? gt = [0, dt] : gt = [at, 0];
      let Wt = a.image.worldToIndex(a.view.viewToWorld(gt[0], gt[1])), Zt = x[0] - Wt[0], Gt = x[1] - Wt[1], Tt = x[2] - Wt[2];
      N[r].lowerUpper ? (C(Zt, 0), C(Gt, 1), C(Tt, 2)) : (R(Zt, 0), R(Gt, 1), R(Tt, 2)), o && (W = gt, x = Wt);
    };
    function C(at, dt) {
      a.lowerBounds[dt].get() - 1 <= a.upperBounds[dt].get() - at && (a.upperBounds[dt].get() - at > a.dimensionsUpper[dt] ? a.upperBounds[dt].set(a.dimensionsUpper[dt]) : a.upperBounds[dt].get() - at < a.dimensionsLower[dt] ? a.upperBounds[dt].set(a.dimensionsLower[dt]) : (a.upperBounds[dt].set(a.upperBounds[dt].get() - at), at != 0 && (o = !0)), a.events.cropChangeEvent.notify(at));
    }
    function R(at, dt) {
      a.lowerBounds[dt].get() - at - 1 <= a.upperBounds[dt].get() && (a.lowerBounds[dt].get() - at > a.dimensionsUpper[dt] ? a.lowerBounds[dt].set(a.dimensionsUpper[dt]) : a.lowerBounds[dt].get() - at < a.dimensionsLower[dt] ? a.lowerBounds[dt].set(a.dimensionsLower[dt]) : (a.lowerBounds[dt].set(a.lowerBounds[dt].get() - at), at != 0 && (o = !0)), a.events.cropChangeEvent.notify(at));
    }
    const z = Lt();
    Ga(z, "left", "client", {
      onDragStart: V,
      onDrag: X
    });
    const F = Lt();
    Ga(F, "left", "client", {
      onDragStart: V,
      onDrag: X
    });
    const P = Lt();
    Ga(P, "left", "client", {
      onDragStart: V,
      onDrag: X
    });
    const j = Lt();
    Ga(j, "left", "client", {
      onDragStart: V,
      onDrag: X
    });
    function H(at, dt, gt, Wt, Zt) {
      return dt.worldToView(at.indexToWorld([gt, Wt, Zt])[0], at.indexToWorld([gt, Wt, Zt])[1], at.indexToWorld([gt, Wt, Zt])[2]);
    }
    function B(at) {
      t.value = at ? 3 : 2;
    }
    function $(at) {
      e.value = at ? 3 : 2;
    }
    function A(at) {
      n.value = at ? 3 : 2;
    }
    function E(at) {
      s.value = at ? 3 : 2;
    }
    function ct(at) {
      r = at;
    }
    return (at, dt) => (Mt(), Ot("svg", Vwt, [
      kt("line", {
        x1: K(g).startEdge[0],
        y1: K(g).startEdge[1],
        x2: K(g).startCrop[0],
        y2: K(g).startCrop[1],
        "stroke-width": K(t),
        "stroke-dasharray": "6",
        "stroke-linecap": "square",
        stroke: "rgba(200, 255, 0, 0.5)"
      }, null, 8, Xwt),
      kt("line", {
        x1: K(g).startCrop[0],
        y1: K(g).startCrop[1],
        x2: K(g).endCrop[0],
        y2: K(g).endCrop[1],
        "stroke-width": K(t),
        "stroke-dasharray": "none",
        "stroke-linecap": "butt",
        stroke: "rgb(200, 255, 0)"
      }, null, 8, Iwt),
      kt("line", {
        x1: K(g).endCrop[0],
        y1: K(g).endCrop[1],
        x2: K(g).endEdge[0],
        y2: K(g).endEdge[1],
        "stroke-width": K(t),
        "stroke-dasharray": "6",
        "stroke-linecap": "square",
        stroke: "rgba(200, 255, 0, 0.5)"
      }, null, 8, Cwt),
      kt("line", {
        onPointerenter: dt[0] || (dt[0] = (gt) => B(!0)),
        onPointerleave: dt[1] || (dt[1] = (gt) => B(!1)),
        onPointerdown: dt[2] || (dt[2] = (gt) => ct(0)),
        ref_key: "sliderHandle",
        ref: z,
        class: "widget",
        x1: K(g).startEdge[0],
        y1: K(g).startEdge[1],
        x2: K(g).endEdge[0],
        y2: K(g).endEdge[1],
        "stroke-dasharray": "none",
        "stroke-width": 10,
        stroke: "rgba(200, 255, 0, 0)"
      }, null, 40, Ywt),
      kt("line", {
        x1: K(f).startEdge[0],
        y1: K(f).startEdge[1],
        x2: K(f).startCrop[0],
        y2: K(f).startCrop[1],
        "stroke-width": K(e),
        "stroke-dasharray": "6",
        "stroke-linecap": "square",
        stroke: "rgba(200, 255, 0, 0.5)"
      }, null, 8, vwt),
      kt("line", {
        x1: K(f).startCrop[0],
        y1: K(f).startCrop[1],
        x2: K(f).endCrop[0],
        y2: K(f).endCrop[1],
        "stroke-width": K(e),
        "stroke-dasharray": "none",
        "stroke-linecap": "butt",
        stroke: "rgb(200, 255, 0)"
      }, null, 8, Rwt),
      kt("line", {
        x1: K(f).endCrop[0],
        y1: K(f).endCrop[1],
        x2: K(f).endEdge[0],
        y2: K(f).endEdge[1],
        "stroke-width": K(e),
        "stroke-dasharray": "6",
        "stroke-linecap": "square",
        stroke: "rgba(200, 255, 0, 0.5)"
      }, null, 8, Dwt),
      kt("line", {
        onPointerenter: dt[3] || (dt[3] = (gt) => $(!0)),
        onPointerleave: dt[4] || (dt[4] = (gt) => $(!1)),
        onPointerdown: dt[5] || (dt[5] = (gt) => ct(1)),
        ref_key: "sliderHandle2",
        ref: F,
        class: "widget",
        x1: K(f).startEdge[0],
        y1: K(f).startEdge[1],
        x2: K(f).endEdge[0],
        y2: K(f).endEdge[1],
        "stroke-dasharray": "none",
        "stroke-width": 10,
        stroke: "rgba(200, 255, 0, 0)"
      }, null, 40, Owt),
      kt("line", {
        x1: K(T).startEdge[0],
        y1: K(T).startEdge[1],
        x2: K(T).startCrop[0],
        y2: K(T).startCrop[1],
        "stroke-width": K(n),
        "stroke-dasharray": "6",
        "stroke-linecap": "square",
        stroke: "rgba(200, 255, 0, 0.5)"
      }, null, 8, zwt),
      kt("line", {
        x1: K(T).startCrop[0],
        y1: K(T).startCrop[1],
        x2: K(T).endCrop[0],
        y2: K(T).endCrop[1],
        "stroke-width": K(n),
        "stroke-dasharray": "none",
        "stroke-linecap": "butt",
        stroke: "rgb(200, 255, 0)"
      }, null, 8, Ewt),
      kt("line", {
        x1: K(T).endCrop[0],
        y1: K(T).endCrop[1],
        x2: K(T).endEdge[0],
        y2: K(T).endEdge[1],
        "stroke-width": K(n),
        "stroke-dasharray": "6",
        "stroke-linecap": "square",
        stroke: "rgba(200, 255, 0, 0.5)"
      }, null, 8, kwt),
      kt("line", {
        onPointerenter: dt[6] || (dt[6] = (gt) => A(!0)),
        onPointerleave: dt[7] || (dt[7] = (gt) => A(!1)),
        onPointerdown: dt[8] || (dt[8] = (gt) => ct(2)),
        ref_key: "sliderHandle3",
        ref: P,
        class: "widget",
        x1: K(T).startEdge[0],
        y1: K(T).startEdge[1],
        x2: K(T).endEdge[0],
        y2: K(T).endEdge[1],
        "stroke-dasharray": "none",
        "stroke-width": 10,
        stroke: "rgba(200, 255, 0, 0)"
      }, null, 40, Fwt),
      kt("line", {
        x1: K(M).startEdge[0],
        y1: K(M).startEdge[1],
        x2: K(M).startCrop[0],
        y2: K(M).startCrop[1],
        "stroke-width": K(s),
        "stroke-dasharray": "6",
        "stroke-linecap": "square",
        stroke: "rgba(200, 255, 0, 0.5)"
      }, null, 8, jwt),
      kt("line", {
        x1: K(M).startCrop[0],
        y1: K(M).startCrop[1],
        x2: K(M).endCrop[0],
        y2: K(M).endCrop[1],
        "stroke-width": K(s),
        "stroke-dasharray": "none",
        "stroke-linecap": "butt",
        stroke: "rgb(200, 255, 0)"
      }, null, 8, Uwt),
      kt("line", {
        x1: K(M).endCrop[0],
        y1: K(M).endCrop[1],
        x2: K(M).endEdge[0],
        y2: K(M).endEdge[1],
        "stroke-width": K(s),
        "stroke-dasharray": "6",
        "stroke-linecap": "square",
        stroke: "rgba(200, 255, 0, 0.5)"
      }, null, 8, Pwt),
      kt("line", {
        onPointerenter: dt[9] || (dt[9] = (gt) => E(!0)),
        onPointerleave: dt[10] || (dt[10] = (gt) => E(!1)),
        onPointerdown: dt[11] || (dt[11] = (gt) => ct(3)),
        ref_key: "sliderHandle4",
        ref: j,
        class: "widget",
        x1: K(M).startEdge[0],
        y1: K(M).startEdge[1],
        x2: K(M).endEdge[0],
        y2: K(M).endEdge[1],
        "stroke-dasharray": "none",
        "stroke-width": 10,
        stroke: "rgba(200, 255, 0, 0)"
      }, null, 40, Jwt)
    ]));
  }
}), Bwt = /* @__PURE__ */ Dn(Awt, [["__scopeId", "data-v-67a3f3c1"]]);
class Kwt extends Ja {
  constructor(e, n) {
    var s;
    super();
    S(this, "context");
    S(this, "uploadedImage");
    S(this, "views", []);
    S(this, "view3D");
    S(this, "cropFlag", !1);
    S(this, "enablePicking", new qt(!1));
    S(this, "widgetActive", new qt(!1));
    S(this, "cropState");
    S(this, "widget");
    S(this, "widgetManager");
    S(this, "cropXl");
    S(this, "cropXh");
    S(this, "cropYl");
    S(this, "cropYh");
    S(this, "cropZl");
    S(this, "cropZh");
    S(this, "reactivity", An());
    S(this, "onEvent", this.reactivity.onEvent);
    S(this, "watch", this.reactivity.watch);
    S(this, "representationMap", /* @__PURE__ */ new Map());
    S(this, "cropChangeEvent", new se());
    S(this, "volumeReplaceCompletedFlag", new qt(!1));
    if (this.context = n, this.uploadedImage = e, this.context.uncroppedImageData || (this.context.uncroppedImageData = e), this.context.getPresenterWindows().forEach((r) => {
      var a;
      if (r.presenterWindowType == ni.PresenterWindow2D) {
        const o = r;
        this.views.push(o.returnMainView());
      } else if (r.presenterWindowType == ni.PresenterWindow3D) {
        const o = r;
        ((a = r.getMainView()) == null ? void 0 : a.getViewMode()) == Nt._3D && (this.view3D = o.returnMainView());
      }
    }), this.cropXl = new qt(0), this.cropXh = new qt(186), this.cropYl = new qt(0), this.cropYh = new qt(186), this.cropZl = new qt(0), this.cropZh = new qt(206), this.widgetManager = eWt.newInstance(), this.view3D || (console.log("view3d does not exist yet"), this.context.getPresenterWindows().forEach((r) => {
      var a;
      if (r.presenterWindowType == ni.PresenterWindow3D) {
        const o = r;
        ((a = r.getMainView()) == null ? void 0 : a.getViewMode()) == Nt._3D && (this.view3D = o.returnMainView());
      }
    })), this.view3D) {
      if (!this.view3D.renderer.getRenderWindow()) {
        const a = this.context.layoutManager.getLayout("0") ?? this.context.layoutManager.getDefaultLayout();
        this.context.layoutManager.setLayout(Yn._FULLSCREEN_3D), this.context.layoutManager.setLayout(a);
      }
      this.widgetManager.setRenderer(this.view3D.renderer), this.view3D.renderer.resetCamera(), this.view3D.renderer.resetCameraClippingRange();
    }
    this.widget = pwt.newInstance(), this.widgetManager.addWidget(this.widget), this.widget.copyImageDataDescription(e), this.cropState = this.widget.getWidgetState(), this.cropState.getCroppingPlanes().onModified(() => {
      var h;
      const { volumeMapper: r } = this.context.getVolume();
      r && (r.removeAllClippingPlanes(), this.getCroppingPlanes(this.uploadedImage, this.cropState.getCroppingPlanes().getPlanes()).forEach((m) => {
        r.addClippingPlane(m);
      }), r.modified(), (h = this.view3D) == null || h.sceneRefresh());
      const [a, o, l, c, u, d] = this.cropState.getCroppingPlanes().getPlanes();
      if (a <= o && l <= c && u <= d) {
        const p = this.uploadedImage.getDimensions();
        this.cropXl.set(Math.max(Math.min(a, p[0]), 0)), this.cropXh.set(Math.min(Math.max(o, 0), p[0])), this.cropYl.set(Math.max(Math.min(l, p[1]), 0)), this.cropYh.set(Math.min(Math.max(c, 0), p[1])), this.cropZl.set(Math.max(Math.min(u, p[2]), 0)), this.cropZh.set(Math.min(Math.max(d, 0), p[2]));
      }
      this.cropState.getCroppingPlanes().setPlanes(this.cropXl.get(), this.cropXh.get(), this.cropYl.get(), this.cropYh.get(), this.cropZl.get(), this.cropZh.get());
    }), this.widget.setEdgeHandlesEnabled(!1), this.widget.setFaceHandlesEnabled(!0), this.widget.setCornerHandlesEnabled(!0), this.widget.setContextVisibility(!0), (s = this.view3D) == null || s.sceneRefresh(), this.onEvent(this.cropChangeEvent, () => {
      this.cropState.getCroppingPlanes().setPlanes(this.cropXl.get(), this.cropXh.get(), this.cropYl.get(), this.cropYh.get(), this.cropZl.get(), this.cropZh.get());
    }), this.watch(this.enablePicking, (r) => {
      r ? this.widgetManager.enablePicking() : this.widgetManager.disablePicking();
    }), this.view3D && (this.enablePicking.set(this.view3D.state.isShown.get() && this.widgetActive.get()), this.watch(this.view3D.state.isShown, (r) => {
      this.enablePicking.set(r && this.widgetActive.get());
    })), this.cropOff(), this.context.toolManager.getTool(on.PRIMARY) === sn.CROPPING && this.cropOn(), this.onEvent(this.context.toolManager.onToolEndChange, ({ newTool: r, layer: a }) => {
      a === on.PRIMARY && r === sn.CROPPING && (console.log("Enabling CROPPING tool!"), this.cropOn());
    }), this.onEvent(this.context.toolManager.onToolBeginChange, ({ newTool: r, layer: a, oldTool: o }) => {
      a === on.PRIMARY && r !== sn.CROPPING && o == sn.CROPPING && (console.log("Disabling CROPPING tool!"), this.cropOff());
    });
  }
  onViewWidgetEvent(e, n) {
    if (e.getViewMode() == Nt.AXIAL || e.getViewMode() == Nt.SAGITTAL || e.getViewMode() == Nt.CORONAL)
      if (n == me.eVE_DESTROY) {
        if (this.representationMap.has(e)) {
          const s = this.representationMap.get(e);
          s == null || s.setEnabled(!1), s == null || s.remove(), this.representationMap.delete(e);
          return;
        }
      } else {
        if (!this.representationMap.has(e)) {
          const r = Pi(e.getOverlayContainer()), { createVueOverlayComponent: a } = r, o = a(
            Bwt,
            {
              image: this.uploadedImage,
              view: e,
              lowerBounds: [this.cropXl, this.cropYl, this.cropZl],
              upperBounds: [this.cropXh, this.cropYh, this.cropZh],
              dimensionsLower: [0, 0, 0],
              dimensionsUpper: this.uploadedImage.getDimensions(),
              events: { cropChangeEvent: this.cropChangeEvent }
            },
            { enabled: !1 }
          );
          o.setEnabled(this.widgetActive.get()), this.representationMap.set(e, o);
        }
        const s = this.representationMap.get(e);
        s && (n == me.eVE_SHOW || n == me.eVE_RENDER ? s.setEnabled(!0) : s.setEnabled(!1));
      }
  }
  cropOff() {
    var n;
    console.log("Cropping off");
    const { volumeMapper: e } = this.context.getVolume();
    e && (e.removeAllClippingPlanes(), e.modified()), this.widgetActive.set(!1), this.representationMap.forEach((s) => s.setEnabled(this.widgetActive.get())), this.widgetManager.removeWidgets(), this.enablePicking.set((((n = this.view3D) == null ? void 0 : n.state.isShown.get()) || !1) && this.widgetActive.get());
  }
  cropOn() {
    var e, n;
    console.log("Cropping on"), this.cropFlag && (this.cropFlag = !1), this.widgetActive.set(!0), this.representationMap.forEach((s) => s.setEnabled(this.widgetActive.get())), this.widgetManager.addWidget(this.widget), this.widget.setVisibility(!0), this.widget.setPickable(!0), this.cropState.getCroppingPlanes().modified(), (e = this.view3D) == null || e.sceneRefresh(), this.enablePicking.set((((n = this.view3D) == null ? void 0 : n.state.isShown.get()) || !1) && this.widgetActive.get());
  }
  getCroppingPlanes(e, n) {
    const s = ps.create();
    ut.getRotation(s, e.getIndexToWorld());
    const r = (m) => {
      const b = [0, 0, 0];
      return I.transformQuat(b, m, s), b;
    }, [a, o, l, c, u, d] = n, h = e.indexToWorld([a, l, u]), p = e.indexToWorld([o, c, d]);
    return [
      // X min/max
      li.newInstance({ normal: r(I.fromValues(1, 0, 0)), origin: h }),
      li.newInstance({ normal: r(I.fromValues(-1, 0, 0)), origin: p }),
      // Y min/max
      li.newInstance({ normal: r(I.fromValues(0, 1, 0)), origin: h }),
      li.newInstance({ normal: r(I.fromValues(0, -1, 0)), origin: p }),
      // X min/max
      li.newInstance({ normal: r(I.fromValues(0, 0, 1)), origin: h }),
      li.newInstance({ normal: r(I.fromValues(0, 0, -1)), origin: p })
    ];
  }
  async permanentlyCrop() {
    if (this.context.volumeDecimated) return;
    this.context.volumeModified = !0, this.cropFlag = !0;
    const e = TA.newInstance(), n = this.uploadedImage, s = n.getOrigin(), r = n.getDimensions(), a = n.getSpacing();
    e.setInputData(n);
    const { volumeMapper: o } = this.context.getVolume();
    o && (o.removeAllClippingPlanes(), o.modified());
    const [l, c, u, d, h, p] = this.cropState.getCroppingPlanes().getPlanes();
    this.widgetManager.removeWidgets(), this.cropXl.set(Math.max(Math.round(l), 0)), this.cropYl.set(Math.max(Math.round(u), 0)), this.cropZl.set(Math.max(Math.round(h), 0)), this.cropXh.set(Math.min(Math.round(c), r[0])), this.cropYh.set(Math.min(Math.round(d), r[1])), this.cropZh.set(Math.min(Math.round(p), r[2])), e.setCroppingPlanes([this.cropXl.get(), this.cropXh.get(), this.cropYl.get(), this.cropYh.get(), this.cropZl.get(), this.cropZh.get()]), e.update(), s[0] += this.cropXl.get() * a[0], s[1] += this.cropYl.get() * a[1], s[2] += this.cropZl.get() * a[2], this.cropXh.get() != r[0] ? r[0] = this.cropXh.get() - this.cropXl.get() + 1 : r[0] = this.cropXh.get() - this.cropXl.get(), this.cropYh.get() != r[1] ? r[1] = this.cropYh.get() - this.cropYl.get() + 1 : r[1] = this.cropYh.get() - this.cropYl.get(), this.cropZh.get() != r[2] ? r[2] = this.cropZh.get() - this.cropZl.get() + 1 : r[2] = this.cropZh.get() - this.cropZl.get();
    const m = e.getOutputData();
    m.setOrigin(s), m.setSpacing(a), m.setDimensions(r), this.context.setImageData(m), this.context.replaceVolumeObject(), this.context.getPresenterWindows().forEach((b) => {
      b.presenterWindowType == ni.PresenterWindow2D ? b.returnMainView().replaceReslicer() : b.presenterWindowType == ni.PresenterWindow2DCustom && b.returnMainView().reinitializeInputImage();
    }), dg(() => {
      this.context.resetOrientation();
    });
  }
  clipImage(e, n, s) {
    const { volumeMapper: r, volumeActor: a } = this.context.getVolume();
    if (!r || !a) {
      console.warn("clipImage volume not loaded");
      return;
    }
    r.removeAllClippingPlanes();
    const o = li.newInstance(), l = li.newInstance(), c = li.newInstance(), u = li.newInstance(), d = li.newInstance(), h = li.newInstance(), p = [1, 0, 0], m = [-1, 0, 0], b = [0, 1, 0], y = [0, -1, 0], Z = [0, 0, 1], g = [0, 0, -1];
    o.setNormal(p), l.setNormal(m), c.setNormal(b), u.setNormal(y), d.setNormal(Z), h.setNormal(g);
    const f = this.context.getImageData().indexToWorld([e[0], 0, 0])[0], T = -this.context.getImageData().indexToWorld([e[1], 0, 0])[0], M = this.context.getImageData().indexToWorld([0, n[0], 0])[1], N = -this.context.getImageData().indexToWorld([0, n[1], 0])[1], W = this.context.getImageData().indexToWorld([0, 0, s[0]])[2], x = -this.context.getImageData().indexToWorld([0, 0, s[1]])[2], V = [f * p[0], f * p[1], f * p[2]], X = [T * m[0], T * m[1], T * m[2]], C = [M * b[0], M * b[1], M * b[2]], R = [N * y[0], N * y[1], N * y[2]], z = [W * Z[0], W * Z[1], W * Z[2]], F = [x * g[0], x * g[1], x * g[2]];
    o.setOrigin(V), l.setOrigin(X), c.setOrigin(C), u.setOrigin(R), d.setOrigin(z), h.setOrigin(F), r.addClippingPlane(o), r.addClippingPlane(l), r.addClippingPlane(c), r.addClippingPlane(u), r.addClippingPlane(d), r.addClippingPlane(h), this.context.repaint();
  }
  delete() {
    this.cleanUp();
    const { volumeMapper: e } = this.context.getVolume();
    e && (e.removeAllClippingPlanes(), e.modified()), this.reactivity.cleanupAll();
  }
  cleanUp() {
    this.widgetManager.removeWidgets(), this.widget.delete(), this.widgetManager.delete();
  }
}
class Hwt extends Ja {
  constructor(e) {
    super();
    S(this, "context");
    S(this, "leftDown", !1);
    S(this, "contrastEnabled", !1);
    S(this, "reactivity", An());
    S(this, "watch", this.reactivity.watch);
    S(this, "previousPos", [0, 0]);
    S(this, "prevWWWL", [0, 0]);
    this.context = e;
  }
  onLeftPress(e, n) {
    return this.contrastEnabled || n.controlKey ? (this.previousPos = [n.position.x, n.position.y], this.prevWWWL = e.getWindowLevel(), this.leftDown = !0, !0) : !1;
  }
  onLeftRelease(e, n) {
    return this.leftDown = !1, !!(this.contrastEnabled || n.controlKey);
  }
  onMouseMove(e, n) {
    if (this.contrastEnabled || n.controlKey)
      if (this.leftDown) {
        const s = [n.position.x, n.position.y], r = 10, a = r * (s[0] - this.previousPos[0]), o = r * (s[1] - this.previousPos[1]);
        return this.prevWWWL[0] - a >= 1 && (this.prevWWWL[0] = this.prevWWWL[0] - a), this.prevWWWL[1] = this.prevWWWL[1] - o, e.getViewMode() == Nt._3D ? e.setWindowLevel(this.prevWWWL) : this.context.getPresenterWindows().forEach((l) => {
          let c = l.getMainView();
          c && (c.isViewMode3D() ? c.isViewMode3D() && this.context.toolManager.coordControl.onViewWidgetEvent(c, me.eVE_RENDER) : l.setWindowLevel(this.prevWWWL));
        }), this.previousPos = s, this.context.repaint(), !0;
      } else
        return !1;
    else
      return !1;
  }
  onViewWidgetEvent() {
  }
  delete() {
    var e;
    (e = this.context.getInteractorStyle()) == null || e.setWindowLevelTool(null), this.reactivity.cleanupAll();
  }
}
class _wt extends Ja {
  constructor(e) {
    super();
    S(this, "context");
    S(this, "views", []);
    S(this, "view3D");
    S(this, "reactivity", An());
    S(this, "onEvent", this.reactivity.onEvent);
    S(this, "polygonPicker");
    S(this, "polygonNormal");
    S(this, "invertFlag", !1);
    S(this, "sculptTimeout", null);
    S(this, "pendingSculptPromise", null);
    S(this, "resolvePendingSculpt", null);
    S(this, "destroyed", !1);
    S(this, "representationMap", /* @__PURE__ */ new Map());
    S(this, "enabled", !1);
    this.context = e, this.context.getPresenterWindows().forEach((n) => {
      if (n.presenterWindowType == ni.PresenterWindow2D) {
        const s = n;
        this.views.push(s.returnMainView());
      } else if (n.presenterWindowType == ni.PresenterWindow3D) {
        const s = n;
        this.view3D = s.returnMainView();
      }
    }), this.polygonPicker = new sA(this.context), this.onEvent(this.polygonPicker.pointAddedEvent, () => {
      this.rerenderRepresentations();
    }), this.onEvent(this.polygonPicker.pointMovedEvent, () => {
      this.rerenderRepresentations();
    }), this.onEvent(this.polygonPicker.rerenderPoints, () => {
      this.rerenderRepresentations();
    }), this.context.toolManager.getTool(on.PRIMARY) === sn.SCULPTING && this.sculptingEnabled(!0), this.onEvent(this.context.toolManager.onToolEndChange, ({ newTool: n, layer: s }) => {
      s === on.PRIMARY && n === sn.SCULPTING && (console.log("Enabling Sculpting tool!"), this.sculptingEnabled(!0));
    }), this.onEvent(this.context.toolManager.onToolBeginChange, ({ newTool: n, layer: s, oldTool: r }) => {
      s === on.PRIMARY && n !== sn.SCULPTING && r == sn.SCULPTING && (console.log("Disabling Sculpting tool!"), this.sculptingEnabled(!1));
    });
  }
  getCurrent3DView() {
    var n;
    const e = this.context.getViewWidget(Nt._3D);
    return e != null && e.isVisible() ? e : (n = this.view3D) != null && n.isVisible() ? this.view3D : void 0;
  }
  rerenderRepresentations() {
    var e;
    this.destroyed || (console.log("InvertFlag: ", this.invertFlag), this.representationMap.forEach((n) => {
      n.points.setData({
        points: this.polygonPicker.pointsArray,
        colors: this.polygonPicker.colorsArray,
        scales: this.polygonPicker.scaleArray
      }), n.polygon.setData({
        points: this.polygonPicker.getPickedPointsV(),
        color: [1, 0, 1],
        invert: this.invertFlag
      });
    }), (e = this.getCurrent3DView()) == null || e.cameraModified(), this.context.repaint());
  }
  onLeftPress(e, n) {
    return !this.enabled || !e.isViewMode3D() ? !1 : this.polygonPicker.onLeftPress(e, n);
  }
  onLeftRelease(e) {
    return !this.enabled || !e.isViewMode3D() ? !1 : this.polygonPicker.onLeftRelease();
  }
  onRightPress(e) {
    return !this.enabled || !e.isViewMode3D() ? !1 : this.polygonPicker.onRightPress();
  }
  onMouseWheel(e) {
    return !this.enabled || !e.isViewMode3D() ? !1 : this.polygonPicker.onMouseWheel();
  }
  onMouseMove(e, n) {
    return !this.enabled || !e.isViewMode3D() ? !1 : this.polygonPicker.onMouseMove(e, n);
  }
  onViewWidgetEvent(e, n) {
    if (!this.destroyed && e.getViewMode() == Nt._3D) {
      if (n == me.eVE_DESTROY) {
        const s = this.representationMap.get(e);
        if (s) {
          this.deleteRepresentation(e, s), this.representationMap.delete(e);
          return;
        }
      } else {
        this.representationMap.has(e) || (this.representationMap.set(e, {
          points: new ed(),
          polygon: new CC()
        }), this.rerenderRepresentations());
        const s = this.representationMap.get(e);
        s && (n == me.eVE_SHOW || n == me.eVE_RENDER ? (e.addActor(s.points.getActor(), 1), e.addActor(s.polygon.getActor(), 1), e.addActor(s.polygon.getActor2(), 1)) : (e.removeActor(s.points.getActor()), e.removeActor(s.polygon.getActor()), e.removeActor(s.polygon.getActor2())));
      }
      console.log("sculpt tool onViewWidgetEvent");
    }
  }
  sculptingEnabled(e) {
    var n, s, r, a;
    if (!this.destroyed) {
      if (this.invertFlag = !1, e)
        (n = this.context.getInteractorStyle()) == null || n.setCameraInteractorEnabled(!1), this.polygonNormal = (s = this.getCurrent3DView()) == null ? void 0 : s.getRenderer().getActiveCamera().getDirectionOfProjection(), console.log("Normal", this.polygonNormal);
      else {
        for (; this.polygonPicker.getPickedPointsV().length > 0; )
          this.polygonPicker.removeLastPointEvent.notify(), this.polygonPicker.pointAddedEvent.notify();
        (r = this.context.getInteractorStyle()) == null || r.setCameraInteractorEnabled(!0), (a = this.getCurrent3DView()) == null || a.cameraModified(), this.context.repaint();
      }
      this.enabled = e;
    }
  }
  deleteRepresentation(e, n) {
    e.removeActor(n.points.getActor()), e.removeActor(n.polygon.getActor()), e.removeActor(n.polygon.getActor2()), n.points.delete(), n.polygon.delete();
  }
  resetViewsAfterVolumeReplace(e) {
    this.context.getPresenterWindows().forEach((n) => {
      var s, r, a, o;
      if (!((s = n.getMainView()) != null && s.isViewMode3D()))
        n.presenterWindowType == ni.PresenterWindow2D ? n.getMainView().replaceReslicer() : n.presenterWindowType == ni.PresenterWindow2DCustom && n.getMainView().reinitializeInputImage(), (r = n.getMainView()) == null || r.resetViewPosition(!0), (a = n.getMainView()) == null || a.fitZoomToScreen();
      else {
        const l = (o = n.getMainView()) == null ? void 0 : o.getRenderer();
        l && this.resetRendererCamera(l) && e && l.getActiveCamera().setParallelScale(e);
      }
    });
  }
  resetRendererCamera(e) {
    return e.isDeleted() ? !1 : (e.resetCamera(), !0);
  }
  sculpt() {
    return this.context.volumeDecimated || this.destroyed ? Promise.resolve() : this.pendingSculptPromise ? this.pendingSculptPromise : (this.context.showLoading(jt("medic-web-engine.sculpting")), this.pendingSculptPromise = new Promise((e, n) => {
      this.resolvePendingSculpt = e, this.sculptTimeout = setTimeout(() => {
        this.sculptTimeout = null;
        let s = null;
        try {
          if (!this.destroyed && this.polygonNormal) {
            console.log("sculpting");
            const r = this.context.getImageData().getPointData().getScalars().getData().slice(0);
            this.cutWithPolygon(this.polygonNormal, this.invertFlag);
            const a = this.context.getImageData().getPointData().getScalars().getData().slice(0), o = new vr({
              onUndo: () => {
                var c;
                this.context.setImageDataScalarBuffer(r);
                const l = (c = this.context.getViewWidget(Nt._3D)) == null ? void 0 : c.getRenderer().getActiveCamera().getParallelScale();
                this.context.replaceVolumeObject(), this.resetViewsAfterVolumeReplace(l);
              },
              onRedo: () => {
                var c;
                this.context.setImageDataScalarBuffer(a);
                const l = (c = this.context.getViewWidget(Nt._3D)) == null ? void 0 : c.getRenderer().getActiveCamera().getParallelScale();
                this.context.replaceVolumeObject(), this.resetViewsAfterVolumeReplace(l);
              },
              getMemory: () => r.length * 2 + a.length * 2 >> 10
            });
            this.context.undoManager.pushPop(this.context.getImageData(), o, "Sculpting", ws.NONE), this.context.volumeModified = !0;
          }
        } catch (r) {
          s = r;
        } finally {
          try {
            this.destroyed || (this.context.hideLoading(), this.context.toolManager.setTool(sn.NONE, on.PRIMARY));
          } catch (r) {
            s = s ?? r;
          }
          this.resolvePendingSculpt = null, this.pendingSculptPromise = null;
        }
        s ? n(s) : e();
      }, 100);
    }), this.pendingSculptPromise);
  }
  cancelPendingSculpt() {
    var e;
    this.sculptTimeout !== null && (clearTimeout(this.sculptTimeout), this.sculptTimeout = null, this.context.hideLoading(), (e = this.resolvePendingSculpt) == null || e.call(this), this.resolvePendingSculpt = null, this.pendingSculptPromise = null);
  }
  invert(e) {
    this.destroyed || (console.log("inverting", e), this.invertFlag = e, this.rerenderRepresentations());
  }
  cutWithPolygon(e, n) {
    var M;
    if (this.destroyed) return;
    const s = this.context.getViewWidget(Nt._3D);
    if (!s) return;
    const r = this.representationMap.get(s);
    if (!r) return;
    const a = r.polygon.data.getPoints().getData();
    let o = 0;
    const l = [];
    let c = [0, 0], u = [0, 0];
    const d = this.context.getViewWidget(Nt._3D);
    if (!d) return;
    const h = d.viewToWorld(0, 0, 0), p = d.viewToWorld(1, 0, 0);
    for (let N = 0; N < 3; N++)
      o += (p[N] - h[N]) * (p[N] - h[N]);
    o = Math.ceil(Math.sqrt(o)), o = 2, console.log("delta:", o);
    const m = [];
    for (let N = 0; N < a.length; ) {
      const W = I.fromValues(a[N++], a[N++], a[N++]), x = d.worldToView(W[0], W[1], W[2]);
      l.push(...x), m.push(x), l.push(0);
    }
    let b = 99999, y = 99999, Z = 0, g = 0;
    m.forEach((N) => {
      Z = N[0] > Z ? N[0] : Z, g = N[1] > g ? N[1] : g, b = N[0] < b ? N[0] : b, y = N[1] < y ? N[1] : y;
    }), c = [b, y], u = [Z, g];
    const f = d.state.viewSize.get();
    for (let N = 0; N < f[0]; N++)
      for (let W = 0; W < f[1]; W++) {
        if (!n && (N < c[0] || N > u[0] || W < c[1] || W > u[1]))
          continue;
        const x = r.polygon.pointInPolygon([N, W, 0], l, [c[0], u[0], c[1], u[1], -1, 1], [0, 0, 1]), V = d.getRenderer().getActiveCamera().getFocalPoint(), X = d.worldToDisplay(...V)[2], C = d.displayToWorld(...d.viewToDisplay(N, W), X), R = this.context.getImageData().worldToIndex(C);
        x == gl.INSIDE && !n ? this.cutLine(e, R, o) : x == gl.OUTSIDE && n && this.cutLine(e, R, o);
      }
    const T = (M = this.context.getViewWidget(Nt._3D)) == null ? void 0 : M.getRenderer().getActiveCamera().getParallelScale();
    this.context.replaceVolumeObject(), this.resetViewsAfterVolumeReplace(T);
  }
  cutLine(e, n, s) {
    const a = [0, 0, 0];
    a[0] = Math.abs(e[0]), a[1] = Math.abs(e[1]), a[2] = Math.abs(e[2]);
    const o = a.indexOf(Math.max(...a)), l = this.context.getImageData().getDimensions(), c = l[0] * l[1];
    if (Math.max(...a) > 1e-6) {
      if (o === 0) {
        const u = n[1] - n[0] / e[0] * e[1], d = e[1] / e[0], h = n[2] - n[0] / e[0] * e[2], p = e[2] / e[0], m = this.context.getImageData().getPointData().getScalars().getData();
        for (let b = 0; b < l[0]; b++) {
          const y = Math.round(u + b * d), Z = Math.round(h + b * p);
          if (y < l[1] && y >= 0 && Z < l[2] && Z >= 0) {
            const g = y, f = Z;
            let T = this.context.getImageData().computeOffsetIndex([b, g, f]);
            if (m[T] = -1024, s == 1)
              y < l[1] - 1 && (m[T + l[0]] = -1024), Z < l[2] - 1 && (m[T + c] = -1024);
            else if (s >= 2)
              y < l[1] - 1 && (m[T + l[0]] = -1024), y < l[1] - 2 && (m[T + l[0] + l[0]] = -1024), Z < l[2] - 1 && (m[T + c] = -1024), Z < l[2] - 2 && (m[T + c + c] = -1024), y < l[1] - 1 && Z < l[2] - 1 && (m[T + c + l[0]] = -1024), y < l[1] - 1 && Z < l[2] - 2 && (m[T + c + c + l[0]] = -1024), y < l[1] - 2 && Z < l[2] - 1 && (m[T + c + l[0] + l[0]] = -1024), y < l[1] - 2 && Z < l[2] - 2 && (m[T + c + c + l[0] + l[0]] = -1024);
            else {
              const M = Math.max(Math.min(l[1] - 1, y + s + 1), 0), N = Math.max(Math.min(l[2] - 1, Z + s + 1), 0);
              let W = c * f + l[0] * g + b;
              for (let x = f; x < N; x++) {
                T = W;
                for (let V = g; V < M; V++)
                  m[T] = -1024, T += l[0];
                W += c;
              }
            }
          }
        }
      } else if (o === 1) {
        const u = n[0] - n[1] / e[1] * e[0], d = e[0] / e[1], h = n[2] - n[1] / e[1] * e[2], p = e[2] / e[1];
        let m = 0;
        const b = this.context.getImageData().getPointData().getScalars().getData();
        for (let y = 0; y < l[1]; y++) {
          const Z = Math.round(u + y * d), g = Math.round(h + y * p);
          if (Z < l[0] && Z >= 0 && g < l[2] && g >= 0) {
            const f = Z, T = g;
            let M = this.context.getImageData().computeOffsetIndex([f, y, T]);
            if (b[M] = -1024, s == 1)
              Z < l[0] - 1 && (b[M + 1] = -1024), g < l[2] - 1 && (b[M + c] = -1024);
            else if (s == 2)
              Z < l[0] - 1 && (b[M + 1] = -1024), Z < l[0] - 2 && (b[M + 2] = -1024), g < l[2] - 1 && (b[M + c] = -1024), g < l[2] - 2 && (b[M + c + c] = -1024), Z < l[0] - 1 && g < l[2] - 1 && (b[M + c + 1] = -1024), Z < l[0] - 2 && g < l[2] - 1 && (b[M + c + 2] = -1024), Z < l[0] - 1 && g < l[2] - 2 && (b[M + c + c + 1] = -1024), Z < l[0] - 2 && g < l[2] - 2 && (b[M + c + c + 2] = -1024);
            else {
              const N = Math.max(Math.min(l[0] - 1, Z + s + 1), 0), W = Math.max(Math.min(l[2] - 1, g + s + 1), 0);
              let x = c * T + f + m;
              for (let V = T; V < W; V++) {
                M = x;
                for (let X = f; X < N; X++)
                  b[M] = -1024, M++;
                x += c;
              }
            }
          }
          m += l[0];
        }
      } else if (o === 2) {
        const u = n[0] - n[2] / e[2] * e[0], d = e[0] / e[2], h = n[1] - n[2] / e[2] * e[1], p = e[1] / e[2];
        let m = 0;
        const b = this.context.getImageData().getPointData().getScalars().getData();
        for (let y = 0; y < l[2]; y++) {
          const Z = Math.round(u + y * d), g = Math.round(h + y * p);
          if (g < l[1] && g >= 0 && Z < l[0] && Z >= 0) {
            const f = Z, T = g;
            let M = this.context.getImageData().computeOffsetIndex([f, T, y]);
            if (b[M] = -1024, s == 1)
              Z < l[0] - 1 && (b[M + 1] = -1024), g < l[1] - 1 && (b[M + l[0]] = -1024);
            else if (s == 2)
              Z < l[0] - 1 && (b[M + 1] = -1024), Z < l[0] - 2 && (b[M + 2] = -1024), g < l[1] - 1 && (b[M + l[0]] = -1024), g < l[1] - 2 && (b[M + l[0] + l[0]] = -1024), Z < l[0] - 1 && g < l[1] - 1 && (b[M + l[0] + 1] = -1024), Z < l[0] - 2 && g < l[1] - 1 && (b[M + l[0] + 2] = -1024), Z < l[0] - 1 && g < l[1] - 2 && (b[M + l[0] + l[0] + 1] = -1024), Z < l[0] - 2 && g < l[1] - 2 && (b[M + l[0] + l[0] + 2] = -1024);
            else {
              const N = Math.max(Math.min(l[0] - 1, Z + s + 1), 0), W = Math.max(Math.min(l[1] - 1, g + s + 1), 0);
              let x = m + f + T * l[0];
              for (let V = T; V < W; V++) {
                M = x;
                for (let X = f; X < N; X++)
                  b[M] = -1024, M++;
                x += l[0];
              }
            }
          }
          m += c;
        }
      }
    }
  }
  delete() {
    this.cancelPendingSculpt(), this.sculptingEnabled(!1), this.destroyed = !0, this.representationMap.forEach((e, n) => {
      this.deleteRepresentation(n, e), this.representationMap.delete(n);
    }), this.polygonPicker.delete(), this.reactivity.cleanupAll();
  }
}
class Qwt extends Ja {
  constructor(e) {
    super();
    S(this, "nerveToolClickEvent", new se());
    S(this, "syncWithContext", new se());
    S(this, "removeObjectEvent", new se());
    S(this, "takeScreenshotEvent", new se());
    S(this, "context");
    S(this, "pointPicker");
    S(this, "splineVec", []);
    S(this, "reactivity", An());
    S(this, "onEvent", this.reactivity.onEvent);
    S(this, "leftDown");
    S(this, "rightDown");
    S(this, "CPRView", null);
    S(this, "length", 0);
    S(this, "polyRepresentation");
    S(this, "pointRepresentationMap", /* @__PURE__ */ new Map());
    S(this, "crossPointScale", 0.5);
    S(this, "N", 10);
    S(this, "splPoints", []);
    S(this, "spline", bA.newInstance());
    S(this, "nerveObject", null);
    S(this, "enabled", !1);
    S(this, "interactorViewModes", [Nt.CPR, Nt.CROSS]);
    this.context = e;
    const n = this.context.getViewWidget(Nt.CPR);
    if (n)
      this.CPRView = n;
    else
      throw Error("CPR view not defined!");
    this.pointPicker = new v2(this.context, void 0, void 0, void 0, void 0, this), this.pointPicker.setDefaultColor(Kn(this.context.settings.defaultColors.nerves)), this.polyRepresentation = new CC(), this.leftDown = !1, this.rightDown = !1, this.onEvent(this.context.toolManager.onToolBeginChange, ({ newTool: s, layer: r, oldTool: a }) => {
      r === on.PRIMARY && s !== sn.NERVE && a == sn.NERVE && (console.log("Disabling Nerve tool!"), this.disableNerveTool());
    }), this.onEvent(this.pointPicker.rerenderPoints, () => {
      this.rerenderRepresentation();
    }), this.onEvent(this.pointPicker.pointAddedEvent, async () => {
    }), this.onEvent(this.pointPicker.pointMovedEvent, async () => {
    }), this.onEvent(this.CPRView.curveMovedEvent, () => {
      this.rerenderRepresentation(), this.context.repaint();
    }), this.insertPointsFromProject(), e.objects.hideAllObjects(!1, !0), e.objects.nerveObjects.forEach((s) => {
      s.nerve.restoreVisibility(), s.nerve.hideVisibility(!0);
    }), e.sceneRepaint(), e.objects.object3DInfos.modified();
  }
  enableNerveTool() {
    this.enabled = !0;
  }
  disableNerveTool() {
    this.enabled = !1;
  }
  onLeftPress(e, n) {
    return !this.enabled || !this.interactorViewModes.includes(e.getViewMode()) ? !1 : this.pointPicker.onLeftPress(e, n);
  }
  onLeftRelease(e) {
    return !this.enabled || !this.interactorViewModes.includes(e.getViewMode()) ? !1 : (this.takeScreenshotEvent.notify(), this.pointPicker.onLeftRelease());
  }
  onMouseWheel(e, n) {
    return !this.enabled || !this.interactorViewModes.includes(e.getViewMode()) ? !1 : this.pointPicker.onMouseWheel(e, n);
  }
  onMouseMove(e, n) {
    return !this.enabled || !this.interactorViewModes.includes(e.getViewMode()) ? !1 : this.pointPicker.onMouseMove(e, n);
  }
  onRightPress(e, n) {
    return !this.enabled || !this.interactorViewModes.includes(e.getViewMode()) ? !1 : this.pointPicker.onRightPress(e, n);
  }
  onRightRelease(e, n) {
    return !this.enabled || !this.interactorViewModes.includes(e.getViewMode()) ? !1 : this.pointPicker.onRightRelease(e, n);
  }
  onViewWidgetEvent(e, n) {
    if (this.nerveObject || (n = me.eVE_DESTROY), e.getViewMode() == Nt.CPR || e.getViewMode() == Nt.CROSS)
      if (n == me.eVE_DESTROY) {
        const s = this.pointRepresentationMap.get(e);
        if (s) {
          e.removeActor(s.getActor()), s.delete(), this.pointRepresentationMap.delete(e);
          return;
        }
      } else {
        this.pointRepresentationMap.has(e) || this.pointRepresentationMap.set(e, new ed(1, e.getViewMode() == Nt.CPR ? 1 : this.crossPointScale)), this.rerenderRepresentation();
        const s = this.pointRepresentationMap.get(e);
        s && (n == me.eVE_SHOW || n == me.eVE_RENDER ? e.addActor(s.getActor(), 1) : e.removeActor(s.getActor()));
      }
  }
  rerenderRepresentation() {
    this.pointRepresentationMap.forEach((e, n) => {
      if (n.getViewMode() == Nt.CPR) {
        const s = [];
        for (let r = 0; r < this.pointPicker.pointsArray.length / 3; r++) {
          const a = this.context.CPRMath.convertMMtoCPR(
            [this.pointPicker.pointsArray[r * 3], this.pointPicker.pointsArray[r * 3 + 1], this.pointPicker.pointsArray[r * 3 + 2]],
            !1
          );
          s.push(...a);
        }
        e.setData({
          points: s,
          colors: this.pointPicker.colorsArray,
          scales: this.pointPicker.scaleArray
        });
      } else
        e.setData(
          {
            points: this.pointPicker.pointsArray,
            colors: this.pointPicker.colorsArray,
            scales: this.pointPicker.scaleArray
          },
          n,
          this.context.CPRSpacing.get()[0] + 1e-5
        );
    });
  }
  callFunction(e) {
    this.callNerve(e);
  }
  callNerve(e, n) {
    if (this.rerenderRepresentation(), this.splPoints = [], this.pointPicker.pointsArray.length / 3 > 2) {
      this.spline.computeCoefficients(this.pointPicker.getPickedPointsV()), this.splPoints.push(this.spline.getPoint(0, 0));
      for (let s = 0; s < this.pointPicker.getPickedPointsV().length - 1; s++)
        for (let r = 1; r <= this.N; r++)
          this.splPoints.push(this.spline.getPoint(s, r / this.N));
      this.nerveObject ? this.create3DSpline(this.nerveObject, this.splPoints) : console.warn("Nerve Object is null!!"), n || this.nerveToolClickEvent.notify();
    } else
      this.nerveObject ? this.create3DSpline(this.nerveObject, this.pointPicker.getPickedPointsV()) : console.warn("Nerve Object is null!!"), n || this.nerveToolClickEvent.notify();
    e && this.context.sceneRepaint(), this.context.objects.checkCollisions(void 0, !0);
  }
  removeLastPickedPoint() {
    this.pointPicker.pointsArray.length > 1 ? (this.pointPicker.removeLastPointEvent.notify(), this.callFunction()) : this.clearAllPoints();
  }
  clearAllPoints() {
    this.pointPicker.clearPointArray(!0), this.nerveObject && (this.context.objects.nerveObjects.delete(this.nerveObject.id), this.removeObjectEvent.notify(this.nerveObject.id), this.nerveObject.delete()), this.nerveObject = null, this.context.sceneRepaint();
  }
  create3DSpline(e, n) {
    e.setData(n, this.pointPicker.getPickedPointsV());
  }
  getFlatArray(e) {
    const n = [];
    return e.forEach((s) => {
      n.push(...s);
    }), n;
  }
  addNerveToList() {
    if (this.nerveObject) {
      const n = {
        projectNerve: this.nerveObject.toProjectNerve(),
        id: this.nerveObject.id,
        name: this.nerveObject.getName(),
        length: this.calculateNerveLength(),
        nerve: this.nerveObject
      };
      return this.getNerveNumberOfPoints() > 0 ? (this.context.objects.nerveObjects.set(this.nerveObject.id, n), n) : (this.context.objects.nerveObjects.delete(this.nerveObject.id), n);
    }
  }
  enableEditing() {
    this.addPolyCover(), this.polyRepresentation.getActor2().setVisibility(!0), this.context.repaint(), this.context.toolManager.getTool(on.PRIMARY) === sn.NERVE && (console.log("Enabling Nerve tool!"), this.enableNerveTool());
  }
  disableEditing() {
    this.polyRepresentation.getActor2().setVisibility(!1), this.pointPicker.clearPointArray(!0), this.context.sceneRepaint(void 0, (e, n) => this.onViewWidgetEvent(e, me.eVE_DESTROY)), console.log("Disabling Nerve tool!"), this.disableNerveTool();
  }
  calculateNerveLength() {
    let e = 0;
    if (this.pointPicker.getNumberOfPoints() > 2)
      for (let s = 0; s < this.splPoints.length - 1; s++) {
        const r = I.dist(this.splPoints[s], this.splPoints[s + 1]);
        e += r;
      }
    else if (this.pointPicker.getNumberOfPoints() == 2) {
      const s = this.pointPicker.getPickedPointsV();
      e = I.dist(s[0], s[1]);
    }
    const n = parseFloat(e.toFixed(3));
    return this.length = n, n;
  }
  setNerveName(e) {
    var n;
    (n = this.nerveObject) == null || n.setName(e);
  }
  getNerveName() {
    var e;
    return (e = this.nerveObject) == null ? void 0 : e.getName();
  }
  setNerveRadius(e, n = !1) {
    var s;
    (s = this.nerveObject) == null || s.setRadius(Number(e.toFixed(2))), n && this.callNerve();
  }
  getNerveRadius() {
    var e;
    return ((e = this.nerveObject) == null ? void 0 : e.getRadius()) || 0;
  }
  setNerveColor(e) {
    var n;
    (n = this.nerveObject) == null || n.setColor(e);
  }
  setNerveDiameter(e, n = !1) {
    var s;
    (s = this.nerveObject) == null || s.setRadius(Number((e / 2).toFixed(2))), n && this.callNerve();
  }
  getNerveDiameter() {
    var e;
    return (((e = this.nerveObject) == null ? void 0 : e.getRadius()) || 0) * 2;
  }
  getNerveId() {
    var e;
    return (e = this.nerveObject) == null ? void 0 : e.id;
  }
  getNerveNumberOfPoints() {
    return this.nerveObject ? this.nerveObject.points.length : 0;
  }
  insertPointsFromProject() {
    this.context.insertFlag && (this.context.insertFlag = !1, this.context.objects.nerveObjects.forEach((e) => {
      this.nerveObject = e.nerve, this.setNerveName(e.name), this.setNerveRadius(e.nerve.getRadius(), !1), this.setNerveColor(e.nerve.getColor()), this.pointPicker.insertPointsFromProject(e.nerve.points), this.addNerveToList();
    }), this.nerveObject = null, this.pointPicker.clearPointArray(), this.disableEditing());
  }
  getDataFromObject(e, n = !1, s = !1) {
    const r = this.context.objects.nerveObjects.get(e);
    r && r.nerve ? (this.nerveObject = r.nerve, this.pointPicker.insertPointsFromProject(r.nerve.points, !0), this.nerveToolClickEvent.notify()) : (console.log("getDataFromObject - NerveObject does not exist!!!!!!"), this.length = 0, this.nerveObject = new fA(this.context), n ? (this.nerveObject.setName(jt("implant-planner.leftNerve")), this.nerveObject.objectSubType = Yt._NERVE_LEFT) : s ? (this.nerveObject.setName(jt("implant-planner.rightNerve")), this.nerveObject.objectSubType = Yt._NERVE_RIGHT) : (this.nerveObject.setName(jt("implant-planner.customObject")), this.nerveObject.objectSubType = Yt._NONE), this.pointPicker.clearPointArray());
  }
  addPolyCover() {
    var r, a, o;
    const e = [], n = this.context.CPRMath.getCPRSwitchPoint(), s = this.context.getViewWidget(Nt.CPR);
    if (n && s) {
      const l = n * this.context.CPRSpacing.get()[0];
      e.push(I.fromValues(l, 0, 500)), e.push(I.fromValues(l, 0, -500)), ((r = this.nerveObject) == null ? void 0 : r.objectSubType) == Yt._NERVE_RIGHT ? (e.push(I.fromValues(500, 0, -500)), e.push(I.fromValues(500, 0, 500)), s && this.context.toolManager.coordControl.setCenter(this.context.objects.CPRCurve.splineVec[Math.round(n / 2)], s)) : ((a = this.nerveObject) == null ? void 0 : a.objectSubType) == Yt._NERVE_LEFT && (e.push(I.fromValues(-500, 0, -500)), e.push(I.fromValues(-500, 0, 500)), s && this.context.toolManager.coordControl.setCenter(
        this.context.objects.CPRCurve.splineVec[Math.round((n + this.context.objects.CPRCurve.splineVec.length) / 2)],
        s
      )), this.polyRepresentation.setData({
        points: e,
        color: [1, 0, 1]
      });
      const c = this.context.getViewWidget(Nt.CPR);
      c && c.addActor(this.polyRepresentation.getActor2(), 1), (o = this.CPRView) == null || o.cameraModified();
    }
  }
  async automaticNerveLandmarkLocalization(e) {
    if (this.context.showLoading(jt("medic-web-engine.automaticNerveDetection")), this.context.objects.nerveObjects.forEach((n) => {
      (n.nerve.objectSubType == Yt._NERVE_LEFT || n.nerve.objectSubType == Yt._NERVE_RIGHT) && (this.getDataFromObject(n.nerve.id, !1, !1), this.clearAllPoints());
    }), this.context.segmentationResult || await this.context.triggerSegmentation(e), this.context.segmentationResult) {
      const n = (s) => {
        const r = [];
        return s && s.length && s.forEach((a) => {
          r.push([a.x, a.y, a.z]);
        }), r;
      };
      this.getDataFromObject("", !0, !1), this.pointPicker.insertPointsFromProject(n(this.context.segmentationResult.nerve.left)), this.addNerveToList(), this.getDataFromObject("", !1, !0), this.pointPicker.insertPointsFromProject(n(this.context.segmentationResult.nerve.right)), this.addNerveToList(), this.syncWithContext.notify(), this.disableEditing(), this.context.sceneRepaint();
    }
    this.context.hideLoading();
  }
  delete() {
    this.context.objects.restoreAllObjectsVisibility(), this.pointRepresentationMap.forEach((n, s) => {
      s.removeActor(n.getActor()), n.delete(), this.pointRepresentationMap.delete(s);
    }), this.pointPicker.delete();
    const e = this.context.getViewWidget(Nt.CPR);
    e && e.removeActor(this.polyRepresentation.getActor2()), this.polyRepresentation.delete(), this.reactivity.cleanupAll();
  }
}
function $wt(i, t) {
  t.classHierarchy.push("xHardwareSelectorForwardPass"), t.framebuffer = gg.newInstance(), i.traverse = function(e, n = null, s) {
    if (t.deleted)
      return;
    t._currentParent = n, i.setCurrentOperation("buildPass"), e.traverse(i);
    const r = e.getRenderable().getNumberOfLayers(), a = e.getChildren();
    for (let o = 0; o < r; o++)
      if (!(s != null && s.layers && s.layers.indexOf(o) === -1))
        for (let l = 0; l < a.length; l++) {
          const c = a[l], u = e.getRenderable().getRenderers()[l];
          if (!(s != null && s.renderers && s.renderers.indexOf(u) === -1) && u.getDraw() && u.getLayer() === o) {
            if (t.opaqueActorCount = 0, t.translucentActorCount = 0, t.volumeCount = 0, t.overlayActorCount = 0, i.setCurrentOperation("queryPass"), c.traverse(i), (t.opaqueActorCount > 0 || t.translucentActorCount > 0) && t.volumeCount > 0 || t.depthRequested) {
              const d = e.getFramebufferSize();
              t.framebuffer === null && (t.framebuffer = gg.newInstance()), t.framebuffer.setOpenGLRenderWindow(e), t.framebuffer.saveCurrentBindingsAndBuffers();
              const h = t.framebuffer.getSize();
              (h === null || h[0] !== d[0] || h[1] !== d[1]) && (t.framebuffer.create(d[0], d[1]), t.framebuffer.populateFramebuffer()), t.framebuffer.bind(), i.setCurrentOperation("zBufferPass"), c.traverse(i), t.framebuffer.restorePreviousBindingsAndBuffers(), t.depthRequested = !1;
            }
            i.setCurrentOperation("cameraPass"), c.traverse(i), t.opaqueActorCount > 0 && (i.setCurrentOperation("opaquePass"), c.traverse(i)), t.translucentActorCount > 0 && (t.translucentPass || (t.translucentPass = Pj.newInstance()), t.translucentPass.traverse(e, c, i)), t.volumeCount > 0 && (i.setCurrentOperation("volumePass"), c.traverse(i)), t.overlayActorCount > 0 && (i.setCurrentOperation("overlayPass"), c.traverse(i));
          }
        }
  }, i.getZBufferTexture = function() {
    return t.framebuffer ? t.framebuffer.getColorTexture() : null;
  }, i.requestDepth = function() {
    t.depthRequested = !0;
  }, i.incrementOpaqueActorCount = function() {
    return t.opaqueActorCount++;
  }, i.incrementTranslucentActorCount = function() {
    return t.translucentActorCount++;
  }, i.incrementVolumeCount = function() {
    return t.volumeCount++;
  }, i.incrementOverlayActorCount = function() {
    return t.overlayActorCount++;
  };
}
const qwt = {
  opaqueActorCount: 0,
  translucentActorCount: 0,
  volumeCount: 0,
  overlayActorCount: 0,
  framebuffer: null,
  depthRequested: !1
};
function HA(i, t, e) {
  e || (e = {}), Object.assign(t, qwt, e), PG.extend(i, t, e), tt.get(i, t, ["framebuffer", "opaqueActorCount", "translucentActorCount", "volumeCount"]), $wt(i, t);
}
const txt = tt.newInstance(HA, "xHardwareSelectorForwardPass"), ext = {
  newInstance: txt,
  extend: HA
};
function nxt(i) {
  return `${i.propID} ${i.compositeID}`;
}
function ixt(i, t, e, n, s) {
  const r = [];
  let a = 0;
  return t.forEach(function(o) {
    const l = JI.newInstance();
    switch (l.setContentType(Bj.INDICES), i) {
      case f0.FIELD_ASSOCIATION_CELLS:
        l.setFieldType(fL.CELL);
        break;
      case f0.FIELD_ASSOCIATION_POINTS:
        l.setFieldType(fL.POINT);
        break;
      default:
        Zn("Unknown field association");
    }
    l.getProperties().propID = o.info.propID, l.getProperties().prop = o.info.prop, l.getProperties().compositeID = o.info.compositeID, l.getProperties().attributeID = o.info.attributeID, l.getProperties().pixelCount = o.pixelCount, e && (l.getProperties().displayPosition = [o.info.displayPosition[0], o.info.displayPosition[1], o.info.zValue], l.getProperties().worldPosition = s.displayToWorld(o.info.displayPosition[0], o.info.displayPosition[1], o.info.zValue, n)), r[a] = l, a++;
  }), r;
}
function sxt(i, t) {
  t.classHierarchy.push("xHardwareSelector"), t.capturedBuffersValid = !1, t.forwardPasses = /* @__PURE__ */ new Map(), i.getCapturedBuffersValid = () => t.capturedBuffersValid, i.releasePixBuffers = function() {
    t.rawPixBuffer = [], t.pixBuffer = [], t.zBuffer = null, t.capturedBuffersValid = !1;
  }, i.select = function(n) {
    let s = null;
    if (i.captureBuffers(n)) {
      if (!t.area)
        return null;
      s = i.generateSelection(t.area[0], t.area[1], t.area[2], t.area[3]), i.releasePixBuffers();
    }
    return s;
  };
  const e = i.attach;
  i.attach = function(n, s) {
    e(n, s), t.capturedBuffersValid = !1;
  }, i._savePixelBuffer2 = function(n, s) {
    if (!t.area)
      throw "model.area is not set";
    if (t.pixBuffer[n] = t._openGLRenderWindow.getPixelData(...t.area), !t.rawPixBuffer[n]) {
      const r = (t.area[2] - t.area[0] + 1) * (t.area[3] - t.area[1] + 1) * 4;
      t.rawPixBuffer[n] = new Uint8Array(r), t.rawPixBuffer[n].set(t.pixBuffer[n]);
    }
    if (n === Es.ACTOR_PASS) {
      if (t.captureZValues && typeof s.requestDepth == "function" && typeof s.getFramebuffer == "function") {
        const r = s.getFramebuffer();
        r.saveCurrentBindingsAndBuffers(), r.bind(), t.zBuffer = t._openGLRenderWindow.getPixelData(t.area[0], t.area[1], t.area[2], t.area[3]), r.restorePreviousBindingsAndBuffers();
      }
      i.buildPropHitList(t.rawPixBuffer[n]);
    }
  }, i.captureBuffers = function(n) {
    var p;
    if (!t._renderer || !t._openGLRenderWindow)
      return Zn("Renderer and view must be set before calling Select."), !1;
    const s = [];
    for (const m of t._renderer.getActors())
      if (!m.isDeleted() && "getProperty" in m && typeof m.getProperty == "function") {
        const b = m.getProperty();
        b.getOpacity() < 1 && (s.push([b, b.getOpacity()]), b.setOpacity(1));
      }
    const r = [], a = [];
    for (const m of ((p = t._renderer.getRenderWindow()) == null ? void 0 : p.getRenderers()) || [])
      if (m !== t._renderer)
        for (const b of m.getActors()) {
          const y = b.getPickable();
          y && (r.push([b, y]), b.setPickable(!1));
          const Z = b.getVisibility();
          if (Z && (a.push([b, Z]), b.setVisibility(!1)), !b.isDeleted() && "getProperty" in b && typeof b.getProperty == "function") {
            const g = b.getProperty();
            g.getOpacity() < 1 && (s.push([g, g.getOpacity()]), g.setOpacity(1));
          }
        }
    t._openGLRenderer = t._openGLRenderWindow.getViewNodeFor(t._renderer), t._openGLRenderWindow.getRenderable().preRender(), i.invokeEvent({
      type: "StartEvent"
    }), t.originalBackground = t._renderer.getBackgroundByReference(), t._renderer.setBackground(0, 0, 0, 0);
    let o;
    if (o = t.forwardPasses.get(t._openGLRenderWindow), !o) {
      const m = ext.newInstance();
      t.forwardPasses.set(t._openGLRenderWindow, m), o = m;
    }
    const l = [o];
    i.beginSelection();
    const u = (n == null ? void 0 : n.captureAttributeIds) ? [Es.ACTOR_PASS, Es.ID_LOW24, Es.ID_HIGH24] : [Es.ACTOR_PASS], d = t._openGLRenderWindow.getContext(), h = d.isEnabled(d.BLEND);
    d.disable(d.BLEND), d.clear(d.COLOR_BUFFER_BIT | d.DEPTH_BUFFER_BIT);
    for (const m of u)
      if (t.currentPass = m, i.passRequired(t.currentPass)) {
        i.preCapturePass(), t.captureZValues && l[0].requestDepth();
        const b = {
          layers: [t._renderer.getLayer()],
          renderers: [t._renderer]
        };
        l[0].traverse(t._openGLRenderWindow, null, b), i.postCapturePass(), i._savePixelBuffer2(t.currentPass, o), i.processPixelBuffers();
      }
    h && d.enable(d.BLEND), i.endSelection(), t._renderer.setBackground(t.originalBackground);
    for (const [m, b] of s)
      m.setOpacity(b);
    for (const [m, b] of r)
      m.setPickable(b);
    for (const [m, b] of a)
      m.setVisibility(b);
    return i.invokeEvent({
      type: "EndEvent"
    }), t.capturedBuffersValid = t._renderer, !0;
  }, i.generateSelection = function(n, s, r, a) {
    const o = Math.floor(n), l = Math.floor(s), c = Math.floor(r), u = Math.floor(a), d = /* @__PURE__ */ new Map(), h = [0, 0];
    for (let p = l; p <= u; p++)
      for (let m = o; m <= c; m++) {
        const b = [m, p], y = i.getPixelInformation(b, 0, h);
        if (y && y.valid) {
          const Z = nxt(y), g = d.get(Z);
          g ? (g.pixelCount++, t.captureZValues && y.zValue < g.info.zValue && (g.info = y), g.attributeIDs.indexOf(y.attributeID) === -1 && g.attributeIDs.push(y.attributeID)) : d.set(Z, {
            info: y,
            pixelCount: 1,
            attributeIDs: [y.attributeID]
          });
        }
      }
    if (!t._renderer)
      throw new Error("generateSelection: renderer not set");
    return ixt(t.fieldAssociation, d, t.captureZValues, t._renderer, t._openGLRenderWindow);
  };
}
const rxt = tt.newInstance(_A, "xHardwareSelector");
function _A(i, t, e = {}) {
  Object.assign(t, e), JG.extend(i, t, e), sxt(i, t);
}
const QA = { extend: _A, newInstance: rxt };
function $A(i) {
  if (!i || i.length === 0)
    return null;
  const e = i[0].getProperties().worldPosition;
  return e !== void 0 ? e : null;
}
var qA = /* @__PURE__ */ ((i) => (i[i.DISTANCE = 0] = "DISTANCE", i[i.ANGLE = 1] = "ANGLE", i[i.ANNOTATION = 2] = "ANNOTATION", i[i.POLYGON = 3] = "POLYGON", i))(qA || {});
const iu = {
  state: {
    /** true if an instance of this tool is attached to a view, use to enable/disable external gui */
    enabled: new qt(!1)
  },
  actions: {
    /** activate distance measurement tool */
    addNewDistanceMeasurement: new se(),
    /** activate angle measurement tool */
    addNewAngleMeasurement: new se(),
    /** activate annotation tool */
    addNewAnnotation: new se(),
    /** activate ROI tool */
    addNewROIMeasurement: new se(),
    /** remove all measurements and related 3d objects */
    clearAllMeasurements: new se(),
    /** set visibility of all measurements */
    setMeasurementVisibility: new se(),
    /** delete annotation by id */
    deleteAnnotation: new se()
  }
};
class axt extends Ja {
  constructor(e) {
    super();
    S(this, "actions", {
      /** activate distance measurement tool */
      addNewDistanceMeasurement: new se(),
      /** activate angle measurement tool */
      addNewAngleMeasurement: new se(),
      /** activate annotation tool */
      addNewAnnotation: new se(),
      /** activate ROI tool */
      addNewROIMeasurement: new se(),
      /** remove all measurements and related 3d objects */
      clearAllMeasurements: new se(),
      /** set visibility of all measurements */
      setMeasurementVisibility: new se(),
      /** delete annotation by id */
      deleteAnnotation: new se()
    });
    S(this, "startAnnotationTool");
    S(this, "startAngleMeasurementTool");
    S(this, "startROIMeasurementTool");
    S(this, "clearAllMeasurements");
    S(this, "setMeasurementVisibility");
    S(this, "setSingleMeasurementVisibility");
    S(this, "deleteAnnotation");
    S(this, "state", {
      activeTool: new qt(null)
    });
    S(this, "reactivity", An());
    S(this, "onEvent", this.reactivity.onEvent);
    S(this, "context");
    S(this, "angleCount", 0);
    S(this, "distCount", 0);
    S(this, "annotCount", 0);
    S(this, "roiCount", 0);
    S(this, "annotation", null);
    S(this, "angleAnnotation", null);
    S(this, "roiMeasurement", null);
    S(this, "activeMeasurementId", null);
    this.context = e;
    const { activeTool: n } = this.state;
    this.onEvent(iu.actions.addNewDistanceMeasurement, () => {
      this.startAnnotationTool(!0);
    }), this.onEvent(iu.actions.addNewAngleMeasurement, () => {
      this.startAngleMeasurementTool();
    }), this.onEvent(iu.actions.addNewAnnotation, () => {
      this.startAnnotationTool(!1);
    }), this.onEvent(iu.actions.addNewROIMeasurement, () => {
      this.startROIMeasurementTool();
    }), this.onEvent(iu.actions.clearAllMeasurements, () => {
      this.clearAllMeasurements();
    }), this.onEvent(iu.actions.setMeasurementVisibility, (r) => {
      this.setMeasurementVisibility(r);
    }), this.onEvent(iu.actions.deleteAnnotation, (r) => {
      this.deleteAnnotation(r);
    });
    const s = () => this.cancelActiveMeasurementTool();
    this.startAnnotationTool = (r) => {
      var u;
      this.discardActiveMeasurementTool();
      let a;
      ((d) => {
        d[d.FIRST_POINT = 0] = "FIRST_POINT", d[d.SECOND_POINT = 1] = "SECOND_POINT";
      })(a || (a = {}));
      let o = 0;
      r ? n.set(
        0
        /* DISTANCE */
      ) : n.set(
        2
        /* ANNOTATION */
      ), this.context.toolManager.measurementsTool.measurementsInteractive.set(!1);
      const l = nl(), c = {
        onLeftPress: (d, h) => {
          var y;
          if (this.annotation == null)
            if (r)
              this.annotation = Kp.newDistanceMeasurement(this.context, d, d.getRendererOverlay(), "Distance " + ++this.distCount);
            else {
              const Z = ++this.annotCount, g = new qt("Annotation " + Z);
              this.annotation = new Kp(this.context, d, d.getRendererOverlay(), g, "Annotation " + Z);
            }
          const p = h.position;
          let m;
          if (d.isViewMode3D()) {
            const Z = d.pickPropPoint(p.x, p.y);
            let g = null;
            Z && (g = Z[1]);
            const f = zh(this.context, d, h.position.x, h.position.y), T = Eh(d, f, g);
            T ? m = T : m = this.pickPoint(d, p.x, p.y);
          } else
            m = this.pickPoint(d, p.x, p.y);
          if (o == 0) {
            this.annotation.addFirstPoint(m), (y = this.context.getViewWidget(Nt.CPR)) != null && y.isVisible() && (this.annotation.curveDelta = this.context.curveDelta.get().value), this.annotation.updateLine(m), this.annotation.setPickable(!1), o = 1;
            const Z = this.annotation;
            this.activeMeasurementId = l, this.context.objects.measurementsObjects.update((g) => g.set(l, { view: d, annotation: Z }));
          } else if (o == 1) {
            this.annotation.setPointHighlight(1, !1), this.annotation.updateLine(m), this.annotation.showSecondPoint(), this.annotation.setPickable(!0);
            let Z = "";
            switch (d.getViewMode()) {
              case Nt.AXIAL:
                Z = "AXIAL";
                break;
              case Nt.CORONAL:
                Z = "CORONAL";
                break;
              case Nt.SAGITTAL:
                Z = "SAGITTAL";
                break;
              case Nt.TANGENT:
                Z = "TANGENT";
                break;
              case Nt.CROSS:
                Z = "CROSS_SECTION";
                break;
              case Nt.CPR:
                Z = "CPR";
                break;
              case Nt._3D:
                Z = "3D";
                break;
            }
            let g = this.annotation.name.get(), f = this.annotation.projectName;
            const T = this.annotCount + this.angleCount + this.distCount + this.roiCount, M = {
              color: [255, 0, 255],
              displayText: r ? "" : g,
              name: f,
              objectSubType: Yt._NONE,
              objectType: r ? Yt._DISTANCE : Yt._ANNOTATION,
              opacity: 255,
              owner: Z,
              visible: this.annotation.getVisible(),
              points: [this.annotation.getPointPosition(0), this.annotation.getPointPosition(1)],
              objectNote: "",
              shapePoints: 2,
              enabled: 1,
              deleted: 0,
              ownerCount: 1,
              owners: [Z]
            }, N = {
              bookType: 1,
              cprAngle: this.context.toolManager.coordControl.crossAngle.get(),
              desktopType: this.context.layoutManager.getCurrentLayoutState().template || 0,
              layoutType: this.context.layoutManager.wizardTabIndex.get(),
              origin: d.getOrigin(),
              stateId: f,
              indexId: T
            };
            r ? (s(), this.context.objects.measurementsObjects.modified()) : e.getModalsInstance().showTextInputModal(jt("medic-web-engine.newAnnotation"), this.annotation.name.get()).then((x) => {
              x != null && this.annotation && (this.annotation.name.set(x), this.annotation.projectName = x, g = this.annotation.name.get(), f = this.annotation.projectName, M.displayText = r ? "" : g, M.name = f, N.stateId = f), s(), this.context.objects.measurementsObjects.modified();
            }), this.context.objects.projectCollection2D.objects.push(M), r ? this.context.objects.projectCollection2D.iDistanceAdded++ : this.context.objects.projectCollection2D.iAnnotAdded++, this.context.projectBookmarks ? (this.getBookmark(T), this.context.projectBookmarks.layout.bookmarks.push(N)) : console.error("ProjectBookmark object does not exist, Bookmark not added!!");
          }
          const b = (Z, g) => this.context.toolManager.measurementsTool.onViewWidgetEvent(Z, g);
          return this.context.sceneRepaint(void 0, b), !0;
        },
        onLeftRelease: () => !0,
        onMouseMove: (d, h) => {
          if (o == 1 && this.annotation) {
            this.annotation.showSecondPoint(), this.annotation.setPointHighlight(1, !0);
            const p = h.position, m = this.pickPoint(d, p.x, p.y);
            this.annotation.updateLine(m);
            const b = (y, Z) => this.context.toolManager.measurementsTool.onViewWidgetEvent(y, Z);
            return this.context.sceneRepaint(void 0, b), !0;
          }
          return !1;
        }
      };
      (u = this.context.getInteractorStyle()) == null || u.setActiveMeasurementTool(c);
    }, this.startAngleMeasurementTool = () => {
      var c;
      this.discardActiveMeasurementTool();
      let r;
      ((u) => {
        u[u.FIRST_POINT = 0] = "FIRST_POINT", u[u.SECOND_POINT = 1] = "SECOND_POINT", u[u.THIRD_POINT = 2] = "THIRD_POINT";
      })(r || (r = {}));
      let a = 0;
      n.set(
        1
        /* ANGLE */
      ), this.context.toolManager.measurementsTool.measurementsInteractive.set(!1);
      const o = nl(), l = {
        onLeftPress: (u, d) => {
          var b;
          this.angleAnnotation == null && (this.angleAnnotation = new yz(this.context, u, u.getRendererOverlay(), "Angle " + ++this.angleCount));
          const h = d.position;
          let p;
          if (u.isViewMode3D()) {
            const y = u.pickPropPoint(h.x, h.y);
            let Z = null;
            y && (Z = y[1]);
            const g = zh(this.context, u, d.position.x, d.position.y), f = Eh(u, g, Z);
            f ? p = f : p = this.pickPoint(u, h.x, h.y);
          } else
            p = this.pickPoint(u, h.x, h.y);
          if (a == 0) {
            this.angleAnnotation.addFirstPoint(p), (b = this.context.getViewWidget(Nt.CPR)) != null && b.isVisible() && (this.angleAnnotation.curveDelta = this.context.curveDelta.get().value), this.angleAnnotation.updateSecondPoint(p), this.angleAnnotation.updateLine(p), this.angleAnnotation.setPickable(!1), this.angleAnnotation.setPointHighlight(1, !0), a = 1;
            const y = this.angleAnnotation;
            this.activeMeasurementId = o, this.context.objects.measurementsObjects.update(
              (Z) => Z.set(o, {
                view: u,
                annotation: y
              })
            );
          } else if (a == 1)
            this.angleAnnotation.updateThirdPoint(p), this.angleAnnotation.updateLine(p), this.angleAnnotation.setPointHighlight(1, !1), this.angleAnnotation.setPointHighlight(2, !0), a = 2;
          else if (a == 2) {
            this.angleAnnotation.setPointHighlight(2, !1), this.angleAnnotation.setPickable(!0);
            let y = "";
            switch (u.getViewMode()) {
              case Nt.AXIAL:
                y = "AXIAL";
                break;
              case Nt.CORONAL:
                y = "CORONAL";
                break;
              case Nt.SAGITTAL:
                y = "SAGITTAL";
                break;
              case Nt.TANGENT:
                y = "TANGENT";
                break;
              case Nt.CROSS:
                y = "CROSS_SECTION";
                break;
              case Nt.CPR:
                y = "CPR";
                break;
              case Nt._3D:
                y = "3D";
                break;
            }
            const Z = {
              color: [255, 0, 255],
              displayText: "",
              name: this.angleAnnotation.projectName,
              objectSubType: Yt._NONE,
              objectType: Yt._ANGLE,
              opacity: 255,
              owner: y,
              visible: this.angleAnnotation.getVisible(),
              points: [
                this.angleAnnotation.getPointPosition(1),
                this.angleAnnotation.getPointPosition(0),
                this.angleAnnotation.getPointPosition(2)
              ],
              objectNote: "",
              shapePoints: 3,
              enabled: 1,
              deleted: 0,
              ownerCount: 1,
              owners: [y]
            };
            this.context.objects.projectCollection2D.objects.push(Z), this.context.objects.projectCollection2D.iAngleAdded++;
            const g = this.annotCount + this.angleCount + this.distCount + this.roiCount;
            this.context.projectBookmarks ? (this.getBookmark(g), this.context.projectBookmarks.layout.bookmarks.push({
              bookType: 1,
              cprAngle: this.context.toolManager.coordControl.crossAngle.get(),
              desktopType: this.context.layoutManager.getCurrentLayoutState().template || 0,
              layoutType: this.context.layoutManager.wizardTabIndex.get(),
              origin: u.getOrigin(),
              stateId: this.angleAnnotation.projectName,
              indexId: g
            })) : console.error("ProjectBookmark object does not exist, Bookmark not added!!"), s(), this.context.objects.measurementsObjects.modified();
          }
          const m = (y, Z) => this.context.toolManager.measurementsTool.onViewWidgetEvent(y, Z);
          return this.context.sceneRepaint(void 0, m), !0;
        },
        onLeftRelease: () => (this.context.hardwareSelectorReleasePixBuffers(), !0),
        onMouseMove: (u, d) => {
          if ((a === 1 || a === 2) && this.angleAnnotation) {
            const h = d.position, p = this.pickPoint(u, h.x, h.y);
            a === 1 ? (this.angleAnnotation.updateSecondPoint(p), this.angleAnnotation.setPointHighlight(1, !0)) : a === 2 && (this.angleAnnotation.updateThirdPoint(p), this.angleAnnotation.setPointHighlight(2, !0)), this.angleAnnotation.updateLine(p);
            const m = (b, y) => this.context.toolManager.measurementsTool.onViewWidgetEvent(b, y);
            return this.context.sceneRepaint(void 0, m), !0;
          }
          return !1;
        }
      };
      (c = this.context.getInteractorStyle()) == null || c.setActiveMeasurementTool(l);
    }, this.startROIMeasurementTool = () => {
      var c;
      this.discardActiveMeasurementTool();
      let r;
      ((u) => {
        u[u.FIRST_POINT = 0] = "FIRST_POINT", u[u.NEXT_POINT = 1] = "NEXT_POINT";
      })(r || (r = {}));
      let a = 0;
      n.set(
        3
        /* POLYGON */
      ), this.context.toolManager.measurementsTool.measurementsInteractive.set(!1);
      const o = nl(), l = {
        onLeftPress: (u, d) => {
          if (u.getViewMode() == Nt.CPR) return !1;
          this.roiMeasurement == null && (this.roiMeasurement = new Zz(this.context, u, u.getRendererOverlay(), "ROI " + ++this.roiCount));
          const h = d.position;
          let p;
          if (u.isViewMode3D()) {
            const b = u.pickPropPoint(h.x, h.y);
            let y = null;
            b && (y = b[1]);
            const Z = zh(this.context, u, d.position.x, d.position.y), g = Eh(u, Z, y);
            g ? p = g : p = this.pickPoint(u, h.x, h.y);
          } else
            p = this.pickPoint(u, h.x, h.y);
          if (a == 0) {
            this.roiMeasurement.addFirstPoint(p), this.roiMeasurement.updateLinePoints(), this.roiMeasurement.setPickable(!1), a = 1;
            const b = this.roiMeasurement;
            this.activeMeasurementId = o, this.context.objects.measurementsObjects.update((y) => y.set(o, { view: u, annotation: b }));
          } else a == 1 && (this.roiMeasurement.updateNextPoint(p), this.roiMeasurement.updateLinePoints());
          const m = (b, y) => this.context.toolManager.measurementsTool.onViewWidgetEvent(b, y);
          return this.context.sceneRepaint(void 0, m), !0;
        },
        onLeftRelease: () => (this.context.hardwareSelectorReleasePixBuffers(), !0),
        onMouseMove: (u, d) => {
          if (this.roiMeasurement != null && a === 1) {
            const h = d.position;
            let p;
            if (u.isViewMode3D()) {
              const b = u.pickPropPoint(h.x, h.y);
              let y = null;
              b && (y = b[1]);
              const Z = zh(this.context, u, d.position.x, d.position.y), g = Eh(u, Z, y);
              g ? p = g : p = this.pickPoint(u, h.x, h.y);
            } else
              p = this.pickPoint(u, h.x, h.y);
            this.roiMeasurement.updateCurrentPoint(p);
            const m = (b, y) => this.context.toolManager.measurementsTool.onViewWidgetEvent(b, y);
            return this.context.sceneRepaint(void 0, m), !0;
          }
          return !1;
        },
        onRightPress: (u) => {
          if (this.roiMeasurement != null) {
            this.roiMeasurement.setPointHighlight(this.roiMeasurement.currentIndex, !1), this.roiMeasurement.setPickable(!0);
            let h = "";
            switch (u.getViewMode()) {
              case Nt.AXIAL:
                h = "AXIAL";
                break;
              case Nt.CORONAL:
                h = "CORONAL";
                break;
              case Nt.SAGITTAL:
                h = "SAGITTAL";
                break;
              case Nt.TANGENT:
                h = "TANGENT";
                break;
              case Nt.CROSS:
                h = "CROSS_SECTION";
                break;
              case Nt.CPR:
                h = "CPR";
                break;
              case Nt._3D:
                h = "3D";
                break;
            }
            this.roiMeasurement.updateLabel();
            const p = this.roiMeasurement.getNumberOfPoints(), m = [];
            for (let Z = 0; Z < p; Z++)
              m.push(this.roiMeasurement.getPointPosition(Z));
            const b = {
              color: [255, 0, 255],
              displayText: "",
              name: this.roiMeasurement.projectName,
              objectSubType: Yt._NONE,
              objectType: Yt._POLYGON,
              opacity: 255,
              owner: h,
              visible: this.roiMeasurement.getVisible(),
              points: m,
              statistics: this.roiMeasurement.statistics,
              objectNote: "",
              shapePoints: m.length,
              enabled: 1,
              deleted: 0,
              ownerCount: 1,
              owners: [h]
            };
            this.context.objects.projectCollection2D.objects.push(b), this.context.objects.projectCollection2D.iPolyAdded++;
            const y = this.annotCount + this.angleCount + this.distCount + this.roiCount;
            this.context.projectBookmarks ? (this.getBookmark(y), this.context.projectBookmarks.layout.bookmarks.push({
              bookType: 1,
              cprAngle: this.context.toolManager.coordControl.crossAngle.get(),
              desktopType: this.context.layoutManager.getCurrentLayoutState().template || 0,
              layoutType: this.context.layoutManager.wizardTabIndex.get(),
              origin: u.getOrigin(),
              stateId: this.roiMeasurement.projectName,
              indexId: y
            })) : console.error("ProjectBookmark object does not exist, Bookmark not added!!");
          }
          this.context.objects.measurementsObjects.modified();
          const d = (h, p) => this.context.toolManager.measurementsTool.onViewWidgetEvent(h, p);
          return this.context.sceneRepaint(void 0, d), !0;
        },
        onRightRelease: (u) => (s(), !0)
      };
      (c = this.context.getInteractorStyle()) == null || c.setActiveMeasurementTool(l);
    }, this.clearAllMeasurements = () => {
      this.context.toolManager.measurementsTool.cancelMeasurementInteraction(), this.cancelActiveMeasurementTool(), this.context.objects.measurementsObjects.get().forEach((a, o) => {
        this.context.toolManager.measurementsTool.clearRepresentationById(o), a.annotation.delete();
      }), this.context.objects.measurementsObjects.set(/* @__PURE__ */ new Map()), this.context.objects.projectCollection2D.iAngleAdded = 0, this.context.objects.projectCollection2D.iDistanceAdded = 0, this.context.objects.projectCollection2D.iAnnotAdded = 0, this.context.objects.projectCollection2D.iPolyAdded = 0, this.context.objects.projectCollection2D.objects = [], this.annotCount = 0, this.angleCount = 0, this.distCount = 0, this.roiCount = 0;
      const r = (a, o) => this.context.toolManager.measurementsTool.onViewWidgetEvent(a, o);
      this.context.sceneRepaint(void 0, r);
    }, this.setMeasurementVisibility = (r) => {
      this.context.objects.measurementsObjects.get().forEach((o) => {
        o.annotation.setVisible(r);
      }), this.context.objects.projectCollection2D.objects.forEach((o) => (o.visible = r, o));
      const a = (o, l) => this.context.toolManager.measurementsTool.onViewWidgetEvent(o, l);
      this.context.sceneRepaint(void 0, a), this.context.objects.measurementsObjects.modified();
    }, this.setSingleMeasurementVisibility = (r, a) => {
      const o = this.context.objects.measurementsObjects.get().get(r);
      if (o) {
        o.annotation.setVisible(a), this.context.objects.projectCollection2D.objects.forEach((c) => (c.name == o.annotation.projectName && (c.visible = a), c));
        const l = (c, u) => this.context.toolManager.measurementsTool.onViewWidgetEvent(c, u);
        this.context.sceneRepaint(void 0, l);
      }
      this.context.objects.measurementsObjects.modified();
    }, this.deleteAnnotation = (r) => {
      this.activeMeasurementId === r && this.cancelActiveMeasurementTool(), this.context.toolManager.measurementsTool.clearRepresentationById(r);
      const a = this.context.objects.measurementsObjects.get().get(r);
      if (a) {
        a.annotation.isAngle() ? this.angleCount-- : a.annotation.isROI() ? this.roiCount-- : a.annotation.isDistance() ? this.distCount-- : this.annotCount--, a.annotation.delete();
        const o = (l, c) => this.context.toolManager.measurementsTool.onViewWidgetEvent(l, c);
        this.context.sceneRepaint(void 0, o), this.context.objects.measurementsObjects.update((l) => (l.delete(r), l));
      }
    }, iu.state.enabled.set(!0);
  }
  addMeasurementFromProject(e, n) {
    n == null && (n = nl());
    const s = n;
    let r = null;
    switch (e.owner) {
      case "AXIAL":
        r = Nt.AXIAL;
        break;
      case "CORONAL":
        r = Nt.CORONAL;
        break;
      case "SAGITTAL":
        r = Nt.SAGITTAL;
        break;
      case "TANGENT":
        r = Nt.TANGENT;
        break;
      case "CROSS_SECTION":
        r = Nt.CROSS;
        break;
      case "CPR":
        r = Nt.CPR;
        break;
      case "3D":
        r = Nt._3D;
        break;
    }
    let a = null;
    if (r == null)
      return;
    if (a = this.context.getViewWidget(r), !a) {
      console.log("viewTmp not Found");
      return;
    }
    const o = a;
    if (e.objectType == Yt._DISTANCE) {
      this.distCount++;
      const l = Kp.newDistanceMeasurement(this.context, o, o.getRendererOverlay(), e.name);
      l.addFirstPoint(e.points[0]), l.updateLine(e.points[1]), l.setPickable(!0), this.context.objects.measurementsObjects.update(
        (c) => c.set(s, {
          view: o,
          annotation: l
        })
      );
    } else if (e.objectType == Yt._ANGLE) {
      this.angleCount++;
      const l = new yz(this.context, o, o.getRendererOverlay(), e.name);
      l.addFirstPoint(e.points[1]), l.updateSecondPoint(e.points[0]), l.updateThirdPoint(e.points[2]), l.updateLinePoints(), l.setPickable(!0), this.context.objects.measurementsObjects.update((c) => c.set(s, { view: o, annotation: l }));
    } else if (e.objectType == Yt._ANNOTATION) {
      this.annotCount++;
      const l = new qt(e.annotationText), c = new Kp(this.context, o, o.getRendererOverlay(), l, e.name);
      c.addFirstPoint(e.points[0]), c.updateLine(e.points[1]), c.setPickable(!0), this.context.objects.measurementsObjects.update(
        (u) => u.set(s, {
          view: o,
          annotation: c
        })
      );
    } else if (e.objectType == Yt._POLYGON) {
      this.roiCount++;
      const l = e.statistics, c = new Zz(this.context, o, o.getRendererOverlay(), e.name);
      if (e.points.length > 2) {
        c.addFirstPoint(e.points[0]);
        for (let d = 1; d < e.points.length; d++)
          c.updateNextPoint(e.points[d]);
      }
      c.updateLinePoints(), c.setPickable(!0);
      const u = c.generateString(l.area, l.length, l.avg, l.max, l.min, l.stdDev);
      c.statisticsText.set(u), this.context.objects.measurementsObjects.update(
        (d) => d.set(s, {
          view: o,
          annotation: c
        })
      );
    }
  }
  getBookmark(e) {
    var d, h, p, m, b, y, Z, g;
    const n = this.context.getPresenterWindow(Nt.AXIAL), s = n == null ? void 0 : n.getMainView();
    if (n && s && s.isVisible()) {
      const f = s.getWindowLevel();
      (d = this.context.projectBookmarks.windows.windows[0]) == null || d.presenterWindow.bookmarks.push({
        stateId: e,
        columns: 1,
        // TODO get parameter layout from PresenterWindow
        rows: 1
      }), n && ((h = this.context.projectBookmarks.windows.windows[0]) == null || h.presenterWindow.viewWidget.bookmarks.push({
        filterType: s.getFilterMode(),
        mipThickness: s.getFilterThickness(),
        origin: s.getOrigin(),
        xAxis: s.getTangent(),
        yAxis: s.getViewup(),
        zAxis: s.getNormal(),
        windowLevelWidth: f,
        stateId: e
      }));
    }
    const r = this.context.getPresenterWindow(Nt.CORONAL), a = r == null ? void 0 : r.getMainView();
    if (r && a && a.isVisible()) {
      const f = a.getWindowLevel();
      (p = this.context.projectBookmarks.windows.windows[1]) == null || p.presenterWindow.bookmarks.push({
        stateId: e,
        columns: 1,
        // TODO get parameter layout from PresenterWindow
        rows: 1
      }), (m = this.context.projectBookmarks.windows.windows[1]) == null || m.presenterWindow.viewWidget.bookmarks.push({
        filterType: a.getFilterMode(),
        mipThickness: a.getFilterThickness(),
        origin: a.getOrigin(),
        xAxis: a.getTangent(),
        yAxis: a.getViewup(),
        zAxis: a.getNormal(),
        windowLevelWidth: f,
        stateId: e
      });
    }
    const o = this.context.getPresenterWindow(Nt.SAGITTAL), l = o == null ? void 0 : o.getMainView();
    if (o && l && l.isVisible()) {
      const f = l.getWindowLevel();
      (b = this.context.projectBookmarks.windows.windows[2]) == null || b.presenterWindow.bookmarks.push({
        stateId: e,
        columns: 1,
        // TODO get parameter layout from PresenterWindow
        rows: 1
      }), (y = this.context.projectBookmarks.windows.windows[2]) == null || y.presenterWindow.viewWidget.bookmarks.push({
        filterType: l.getFilterMode(),
        mipThickness: l.getFilterThickness(),
        origin: l.getOrigin(),
        xAxis: l.getTangent(),
        yAxis: l.getViewup(),
        zAxis: l.getNormal(),
        windowLevelWidth: f,
        stateId: e
      });
    }
    const c = this.context.getPresenterWindow(Nt.CPR), u = c == null ? void 0 : c.getMainView();
    if (c && u && u.isVisible()) {
      const f = u.getWindowLevel();
      (Z = this.context.projectBookmarks.windows.windows[4]) == null || Z.presenterWindow.bookmarks.push({
        stateId: e,
        columns: 1,
        // TODO get parameter layout from PresenterWindow
        rows: 1
      }), (g = this.context.projectBookmarks.windows.windows[4]) == null || g.presenterWindow.viewWidget.bookmarks.push({
        filterType: u.getFilterMode(),
        mipThickness: u.getFilterThickness(),
        origin: u.getOrigin(),
        xAxis: u.getTangent(),
        yAxis: u.getViewup(),
        zAxis: u.getNormal(),
        windowLevelWidth: f,
        stateId: e
      });
    }
  }
  onViewWidgetEvent() {
  }
  getState() {
    return {
      activeTool: new qo(this.state.activeTool)
    };
  }
  getActiveMeasurementId() {
    return this.activeMeasurementId;
  }
  cancelActiveMeasurementTool() {
    var e;
    (e = this.context.getInteractorStyle()) == null || e.setActiveMeasurementTool(null), this.state.activeTool.set(null), this.context.toolManager.measurementsTool.measurementsInteractive.set(!0), this.annotation = null, this.angleAnnotation = null, this.roiMeasurement = null, this.activeMeasurementId = null;
  }
  discardActiveMeasurementTool() {
    const e = this.activeMeasurementId;
    if (e) {
      const n = this.context.objects.measurementsObjects.get().get(e);
      n && (this.context.toolManager.measurementsTool.clearRepresentationById(e), n.annotation.isAngle() ? this.angleCount-- : n.annotation.isROI() ? this.roiCount-- : n.annotation.isDistance() ? this.distCount-- : this.annotCount--, n.annotation.delete(), this.context.objects.measurementsObjects.update((s) => (s.delete(e), s)));
    }
    this.cancelActiveMeasurementTool();
  }
  pickPoint(e, n, s) {
    const r = e.hardwareSelectorPickCaptured(0, !0, !1, n, s);
    return $A(r) ?? e.pickWorldPoint(n, s);
  }
  delete() {
    this.cancelActiveMeasurementTool(), iu.state.enabled.set(!1), this.reactivity.cleanupAll();
  }
}
var tB = typeof global == "object" && global && global.Object === Object && global, oxt = typeof self == "object" && self && self.Object === Object && self, Ac = tB || oxt || Function("return this")(), Ng = Ac.Symbol, eB = Object.prototype, lxt = eB.hasOwnProperty, cxt = eB.toString, cy = Ng ? Ng.toStringTag : void 0;
function uxt(i) {
  var t = lxt.call(i, cy), e = i[cy];
  try {
    i[cy] = void 0;
    var n = !0;
  } catch {
  }
  var s = cxt.call(i);
  return n && (t ? i[cy] = e : delete i[cy]), s;
}
var dxt = Object.prototype, hxt = dxt.toString;
function pxt(i) {
  return hxt.call(i);
}
var mxt = "[object Null]", bxt = "[object Undefined]", jz = Ng ? Ng.toStringTag : void 0;
function AT(i) {
  return i == null ? i === void 0 ? bxt : mxt : jz && jz in Object(i) ? uxt(i) : pxt(i);
}
function BT(i) {
  return i != null && typeof i == "object";
}
var BC = Array.isArray;
function uw(i) {
  var t = typeof i;
  return i != null && (t == "object" || t == "function");
}
var fxt = "[object AsyncFunction]", gxt = "[object Function]", yxt = "[object GeneratorFunction]", Zxt = "[object Proxy]";
function nB(i) {
  if (!uw(i))
    return !1;
  var t = AT(i);
  return t == gxt || t == yxt || t == fxt || t == Zxt;
}
var xS = Ac["__core-js_shared__"], Uz = (function() {
  var i = /[^.]+$/.exec(xS && xS.keys && xS.keys.IE_PROTO || "");
  return i ? "Symbol(src)_1." + i : "";
})();
function Txt(i) {
  return !!Uz && Uz in i;
}
var Mxt = Function.prototype, Nxt = Mxt.toString;
function I0(i) {
  if (i != null) {
    try {
      return Nxt.call(i);
    } catch {
    }
    try {
      return i + "";
    } catch {
    }
  }
  return "";
}
var Wxt = /[\\^$.*+?()[\]{}|]/g, Gxt = /^\[object .+?Constructor\]$/, wxt = Function.prototype, xxt = Object.prototype, Sxt = wxt.toString, Lxt = xxt.hasOwnProperty, Vxt = RegExp(
  "^" + Sxt.call(Lxt).replace(Wxt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Xxt(i) {
  if (!uw(i) || Txt(i))
    return !1;
  var t = nB(i) ? Vxt : Gxt;
  return t.test(I0(i));
}
function Ixt(i, t) {
  return i == null ? void 0 : i[t];
}
function C0(i, t) {
  var e = Ixt(i, t);
  return Xxt(e) ? e : void 0;
}
var lV = C0(Ac, "WeakMap"), Pz = Object.create, Cxt = /* @__PURE__ */ (function() {
  function i() {
  }
  return function(t) {
    if (!uw(t))
      return {};
    if (Pz)
      return Pz(t);
    i.prototype = t;
    var e = new i();
    return i.prototype = void 0, e;
  };
})(), Jz = (function() {
  try {
    var i = C0(Object, "defineProperty");
    return i({}, "", {}), i;
  } catch {
  }
})();
function Yxt(i, t) {
  for (var e = -1, n = i == null ? 0 : i.length; ++e < n && t(i[e], e, i) !== !1; )
    ;
  return i;
}
var vxt = 9007199254740991, Rxt = /^(?:0|[1-9]\d*)$/;
function Dxt(i, t) {
  var e = typeof i;
  return t = t ?? vxt, !!t && (e == "number" || e != "symbol" && Rxt.test(i)) && i > -1 && i % 1 == 0 && i < t;
}
function Oxt(i, t, e) {
  t == "__proto__" && Jz ? Jz(i, t, {
    configurable: !0,
    enumerable: !0,
    value: e,
    writable: !0
  }) : i[t] = e;
}
function iB(i, t) {
  return i === t || i !== i && t !== t;
}
var zxt = Object.prototype, Ext = zxt.hasOwnProperty;
function kxt(i, t, e) {
  var n = i[t];
  (!(Ext.call(i, t) && iB(n, e)) || e === void 0 && !(t in i)) && Oxt(i, t, e);
}
var Fxt = 9007199254740991;
function sB(i) {
  return typeof i == "number" && i > -1 && i % 1 == 0 && i <= Fxt;
}
function jxt(i) {
  return i != null && sB(i.length) && !nB(i);
}
var Uxt = Object.prototype;
function rB(i) {
  var t = i && i.constructor, e = typeof t == "function" && t.prototype || Uxt;
  return i === e;
}
function Pxt(i, t) {
  for (var e = -1, n = Array(i); ++e < i; )
    n[e] = t(e);
  return n;
}
var Jxt = "[object Arguments]";
function Az(i) {
  return BT(i) && AT(i) == Jxt;
}
var aB = Object.prototype, Axt = aB.hasOwnProperty, Bxt = aB.propertyIsEnumerable, Kxt = Az(/* @__PURE__ */ (function() {
  return arguments;
})()) ? Az : function(i) {
  return BT(i) && Axt.call(i, "callee") && !Bxt.call(i, "callee");
};
function Hxt() {
  return !1;
}
var oB = typeof exports == "object" && exports && !exports.nodeType && exports, Bz = oB && typeof module == "object" && module && !module.nodeType && module, _xt = Bz && Bz.exports === oB, Kz = _xt ? Ac.Buffer : void 0, Qxt = Kz ? Kz.isBuffer : void 0, lB = Qxt || Hxt, $xt = "[object Arguments]", qxt = "[object Array]", tSt = "[object Boolean]", eSt = "[object Date]", nSt = "[object Error]", iSt = "[object Function]", sSt = "[object Map]", rSt = "[object Number]", aSt = "[object Object]", oSt = "[object RegExp]", lSt = "[object Set]", cSt = "[object String]", uSt = "[object WeakMap]", dSt = "[object ArrayBuffer]", hSt = "[object DataView]", pSt = "[object Float32Array]", mSt = "[object Float64Array]", bSt = "[object Int8Array]", fSt = "[object Int16Array]", gSt = "[object Int32Array]", ySt = "[object Uint8Array]", ZSt = "[object Uint8ClampedArray]", TSt = "[object Uint16Array]", MSt = "[object Uint32Array]", Ei = {};
Ei[pSt] = Ei[mSt] = Ei[bSt] = Ei[fSt] = Ei[gSt] = Ei[ySt] = Ei[ZSt] = Ei[TSt] = Ei[MSt] = !0;
Ei[$xt] = Ei[qxt] = Ei[dSt] = Ei[tSt] = Ei[hSt] = Ei[eSt] = Ei[nSt] = Ei[iSt] = Ei[sSt] = Ei[rSt] = Ei[aSt] = Ei[oSt] = Ei[lSt] = Ei[cSt] = Ei[uSt] = !1;
function NSt(i) {
  return BT(i) && sB(i.length) && !!Ei[AT(i)];
}
function KC(i) {
  return function(t) {
    return i(t);
  };
}
var cB = typeof exports == "object" && exports && !exports.nodeType && exports, u2 = cB && typeof module == "object" && module && !module.nodeType && module, WSt = u2 && u2.exports === cB, SS = WSt && tB.process, Wg = (function() {
  try {
    var i = u2 && u2.require && u2.require("util").types;
    return i || SS && SS.binding && SS.binding("util");
  } catch {
  }
})(), Hz = Wg && Wg.isTypedArray, GSt = Hz ? KC(Hz) : NSt, wSt = Object.prototype, xSt = wSt.hasOwnProperty;
function SSt(i, t) {
  var e = BC(i), n = !e && Kxt(i), s = !e && !n && lB(i), r = !e && !n && !s && GSt(i), a = e || n || s || r, o = a ? Pxt(i.length, String) : [], l = o.length;
  for (var c in i)
    xSt.call(i, c) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    s && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    r && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    Dxt(c, l))) && o.push(c);
  return o;
}
function uB(i, t) {
  return function(e) {
    return i(t(e));
  };
}
var LSt = uB(Object.keys, Object), VSt = Object.prototype, XSt = VSt.hasOwnProperty;
function ISt(i) {
  if (!rB(i))
    return LSt(i);
  var t = [];
  for (var e in Object(i))
    XSt.call(i, e) && e != "constructor" && t.push(e);
  return t;
}
function CSt(i) {
  return jxt(i) ? SSt(i) : ISt(i);
}
var R2 = C0(Object, "create");
function YSt() {
  this.__data__ = R2 ? R2(null) : {}, this.size = 0;
}
function vSt(i) {
  var t = this.has(i) && delete this.__data__[i];
  return this.size -= t ? 1 : 0, t;
}
var RSt = "__lodash_hash_undefined__", DSt = Object.prototype, OSt = DSt.hasOwnProperty;
function zSt(i) {
  var t = this.__data__;
  if (R2) {
    var e = t[i];
    return e === RSt ? void 0 : e;
  }
  return OSt.call(t, i) ? t[i] : void 0;
}
var ESt = Object.prototype, kSt = ESt.hasOwnProperty;
function FSt(i) {
  var t = this.__data__;
  return R2 ? t[i] !== void 0 : kSt.call(t, i);
}
var jSt = "__lodash_hash_undefined__";
function USt(i, t) {
  var e = this.__data__;
  return this.size += this.has(i) ? 0 : 1, e[i] = R2 && t === void 0 ? jSt : t, this;
}
function N0(i) {
  var t = -1, e = i == null ? 0 : i.length;
  for (this.clear(); ++t < e; ) {
    var n = i[t];
    this.set(n[0], n[1]);
  }
}
N0.prototype.clear = YSt;
N0.prototype.delete = vSt;
N0.prototype.get = zSt;
N0.prototype.has = FSt;
N0.prototype.set = USt;
function PSt() {
  this.__data__ = [], this.size = 0;
}
function dw(i, t) {
  for (var e = i.length; e--; )
    if (iB(i[e][0], t))
      return e;
  return -1;
}
var JSt = Array.prototype, ASt = JSt.splice;
function BSt(i) {
  var t = this.__data__, e = dw(t, i);
  if (e < 0)
    return !1;
  var n = t.length - 1;
  return e == n ? t.pop() : ASt.call(t, e, 1), --this.size, !0;
}
function KSt(i) {
  var t = this.__data__, e = dw(t, i);
  return e < 0 ? void 0 : t[e][1];
}
function HSt(i) {
  return dw(this.__data__, i) > -1;
}
function _St(i, t) {
  var e = this.__data__, n = dw(e, i);
  return n < 0 ? (++this.size, e.push([i, t])) : e[n][1] = t, this;
}
function Zd(i) {
  var t = -1, e = i == null ? 0 : i.length;
  for (this.clear(); ++t < e; ) {
    var n = i[t];
    this.set(n[0], n[1]);
  }
}
Zd.prototype.clear = PSt;
Zd.prototype.delete = BSt;
Zd.prototype.get = KSt;
Zd.prototype.has = HSt;
Zd.prototype.set = _St;
var D2 = C0(Ac, "Map");
function QSt() {
  this.size = 0, this.__data__ = {
    hash: new N0(),
    map: new (D2 || Zd)(),
    string: new N0()
  };
}
function $St(i) {
  var t = typeof i;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? i !== "__proto__" : i === null;
}
function hw(i, t) {
  var e = i.__data__;
  return $St(t) ? e[typeof t == "string" ? "string" : "hash"] : e.map;
}
function qSt(i) {
  var t = hw(this, i).delete(i);
  return this.size -= t ? 1 : 0, t;
}
function tLt(i) {
  return hw(this, i).get(i);
}
function eLt(i) {
  return hw(this, i).has(i);
}
function nLt(i, t) {
  var e = hw(this, i), n = e.size;
  return e.set(i, t), this.size += e.size == n ? 0 : 1, this;
}
function Rg(i) {
  var t = -1, e = i == null ? 0 : i.length;
  for (this.clear(); ++t < e; ) {
    var n = i[t];
    this.set(n[0], n[1]);
  }
}
Rg.prototype.clear = QSt;
Rg.prototype.delete = qSt;
Rg.prototype.get = tLt;
Rg.prototype.has = eLt;
Rg.prototype.set = nLt;
function iLt(i, t) {
  for (var e = -1, n = t.length, s = i.length; ++e < n; )
    i[s + e] = t[e];
  return i;
}
var sLt = uB(Object.getPrototypeOf, Object);
function rLt() {
  this.__data__ = new Zd(), this.size = 0;
}
function aLt(i) {
  var t = this.__data__, e = t.delete(i);
  return this.size = t.size, e;
}
function oLt(i) {
  return this.__data__.get(i);
}
function lLt(i) {
  return this.__data__.has(i);
}
var cLt = 200;
function uLt(i, t) {
  var e = this.__data__;
  if (e instanceof Zd) {
    var n = e.__data__;
    if (!D2 || n.length < cLt - 1)
      return n.push([i, t]), this.size = ++e.size, this;
    e = this.__data__ = new Rg(n);
  }
  return e.set(i, t), this.size = e.size, this;
}
function Dg(i) {
  var t = this.__data__ = new Zd(i);
  this.size = t.size;
}
Dg.prototype.clear = rLt;
Dg.prototype.delete = aLt;
Dg.prototype.get = oLt;
Dg.prototype.has = lLt;
Dg.prototype.set = uLt;
var dB = typeof exports == "object" && exports && !exports.nodeType && exports, _z = dB && typeof module == "object" && module && !module.nodeType && module, dLt = _z && _z.exports === dB, Qz = dLt ? Ac.Buffer : void 0;
Qz && Qz.allocUnsafe;
function hLt(i, t) {
  return i.slice();
}
function pLt(i, t) {
  for (var e = -1, n = i == null ? 0 : i.length, s = 0, r = []; ++e < n; ) {
    var a = i[e];
    t(a, e, i) && (r[s++] = a);
  }
  return r;
}
function mLt() {
  return [];
}
var bLt = Object.prototype, fLt = bLt.propertyIsEnumerable, $z = Object.getOwnPropertySymbols, gLt = $z ? function(i) {
  return i == null ? [] : (i = Object(i), pLt($z(i), function(t) {
    return fLt.call(i, t);
  }));
} : mLt;
function yLt(i, t, e) {
  var n = t(i);
  return BC(i) ? n : iLt(n, e(i));
}
function ZLt(i) {
  return yLt(i, CSt, gLt);
}
var cV = C0(Ac, "DataView"), uV = C0(Ac, "Promise"), dV = C0(Ac, "Set"), qz = "[object Map]", TLt = "[object Object]", tE = "[object Promise]", eE = "[object Set]", nE = "[object WeakMap]", iE = "[object DataView]", MLt = I0(cV), NLt = I0(D2), WLt = I0(uV), GLt = I0(dV), wLt = I0(lV), pu = AT;
(cV && pu(new cV(new ArrayBuffer(1))) != iE || D2 && pu(new D2()) != qz || uV && pu(uV.resolve()) != tE || dV && pu(new dV()) != eE || lV && pu(new lV()) != nE) && (pu = function(i) {
  var t = AT(i), e = t == TLt ? i.constructor : void 0, n = e ? I0(e) : "";
  if (n)
    switch (n) {
      case MLt:
        return iE;
      case NLt:
        return qz;
      case WLt:
        return tE;
      case GLt:
        return eE;
      case wLt:
        return nE;
    }
  return t;
});
var xLt = Object.prototype, SLt = xLt.hasOwnProperty;
function LLt(i) {
  var t = i.length, e = new i.constructor(t);
  return t && typeof i[0] == "string" && SLt.call(i, "index") && (e.index = i.index, e.input = i.input), e;
}
var sE = Ac.Uint8Array;
function HC(i) {
  var t = new i.constructor(i.byteLength);
  return new sE(t).set(new sE(i)), t;
}
function VLt(i, t) {
  var e = HC(i.buffer);
  return new i.constructor(e, i.byteOffset, i.byteLength);
}
var XLt = /\w*$/;
function ILt(i) {
  var t = new i.constructor(i.source, XLt.exec(i));
  return t.lastIndex = i.lastIndex, t;
}
var rE = Ng ? Ng.prototype : void 0, aE = rE ? rE.valueOf : void 0;
function CLt(i) {
  return aE ? Object(aE.call(i)) : {};
}
function YLt(i, t) {
  var e = HC(i.buffer);
  return new i.constructor(e, i.byteOffset, i.length);
}
var vLt = "[object Boolean]", RLt = "[object Date]", DLt = "[object Map]", OLt = "[object Number]", zLt = "[object RegExp]", ELt = "[object Set]", kLt = "[object String]", FLt = "[object Symbol]", jLt = "[object ArrayBuffer]", ULt = "[object DataView]", PLt = "[object Float32Array]", JLt = "[object Float64Array]", ALt = "[object Int8Array]", BLt = "[object Int16Array]", KLt = "[object Int32Array]", HLt = "[object Uint8Array]", _Lt = "[object Uint8ClampedArray]", QLt = "[object Uint16Array]", $Lt = "[object Uint32Array]";
function qLt(i, t, e) {
  var n = i.constructor;
  switch (t) {
    case jLt:
      return HC(i);
    case vLt:
    case RLt:
      return new n(+i);
    case ULt:
      return VLt(i);
    case PLt:
    case JLt:
    case ALt:
    case BLt:
    case KLt:
    case HLt:
    case _Lt:
    case QLt:
    case $Lt:
      return YLt(i);
    case DLt:
      return new n();
    case OLt:
    case kLt:
      return new n(i);
    case zLt:
      return ILt(i);
    case ELt:
      return new n();
    case FLt:
      return CLt(i);
  }
}
function tVt(i) {
  return typeof i.constructor == "function" && !rB(i) ? Cxt(sLt(i)) : {};
}
var eVt = "[object Map]";
function nVt(i) {
  return BT(i) && pu(i) == eVt;
}
var oE = Wg && Wg.isMap, iVt = oE ? KC(oE) : nVt, sVt = "[object Set]";
function rVt(i) {
  return BT(i) && pu(i) == sVt;
}
var lE = Wg && Wg.isSet, aVt = lE ? KC(lE) : rVt, hB = "[object Arguments]", oVt = "[object Array]", lVt = "[object Boolean]", cVt = "[object Date]", uVt = "[object Error]", pB = "[object Function]", dVt = "[object GeneratorFunction]", hVt = "[object Map]", pVt = "[object Number]", mB = "[object Object]", mVt = "[object RegExp]", bVt = "[object Set]", fVt = "[object String]", gVt = "[object Symbol]", yVt = "[object WeakMap]", ZVt = "[object ArrayBuffer]", TVt = "[object DataView]", MVt = "[object Float32Array]", NVt = "[object Float64Array]", WVt = "[object Int8Array]", GVt = "[object Int16Array]", wVt = "[object Int32Array]", xVt = "[object Uint8Array]", SVt = "[object Uint8ClampedArray]", LVt = "[object Uint16Array]", VVt = "[object Uint32Array]", vi = {};
vi[hB] = vi[oVt] = vi[ZVt] = vi[TVt] = vi[lVt] = vi[cVt] = vi[MVt] = vi[NVt] = vi[WVt] = vi[GVt] = vi[wVt] = vi[hVt] = vi[pVt] = vi[mB] = vi[mVt] = vi[bVt] = vi[fVt] = vi[gVt] = vi[xVt] = vi[SVt] = vi[LVt] = vi[VVt] = !0;
vi[uVt] = vi[pB] = vi[yVt] = !1;
function NN(i, t, e, n, s, r) {
  var a;
  if (a !== void 0)
    return a;
  if (!uw(i))
    return i;
  var o = BC(i);
  if (o)
    a = LLt(i);
  else {
    var l = pu(i), c = l == pB || l == dVt;
    if (lB(i))
      return hLt(i);
    if (l == mB || l == hB || c && !s)
      a = c ? {} : tVt(i);
    else {
      if (!vi[l])
        return s ? i : {};
      a = qLt(i, l);
    }
  }
  r || (r = new Dg());
  var u = r.get(i);
  if (u)
    return u;
  r.set(i, a), aVt(i) ? i.forEach(function(p) {
    a.add(NN(p, t, e, p, i, r));
  }) : iVt(i) && i.forEach(function(p, m) {
    a.set(m, NN(p, t, e, m, i, r));
  });
  var d = ZLt, h = o ? void 0 : d(i);
  return Yxt(h || i, function(p, m) {
    h && (m = p, p = i[m]), kxt(a, m, NN(p, t, e, m, i, r));
  }), a;
}
var XVt = 1, IVt = 4;
function vM(i) {
  return NN(i, XVt | IVt);
}
class CVt extends Ja {
  constructor(e) {
    super();
    S(this, "context");
    S(this, "measurementTool");
    S(this, "measurementToolInitTimeout", null);
    S(this, "deleted", !1);
    S(this, "cursor", null);
    S(this, "reactivity", An());
    S(this, "onEvent", this.reactivity.onEvent);
    S(this, "measurementRepresentations", /* @__PURE__ */ new Map());
    S(this, "measurementsInteractive", new qt(!0));
    S(this, "viewCameraModified", new se());
    S(this, "pickedAnnotation", null);
    S(this, "pickedAnnotationPointIndex", null);
    S(this, "pickScreenOffset", null);
    S(this, "startPoint", I.create());
    S(this, "lastMouseOverPoint", null);
    this.context = e, this.onEvent(this.viewCameraModified, (n) => {
      if (this.context.objects.measurementsObjects.get().size) {
        this.context.objects.measurementsObjects.get().forEach((r) => {
          r.annotation.onCameraModified();
        });
        const s = (r, a) => this.onViewWidgetEvent(r, a);
        this.context.sceneRepaint(n, s);
      }
    }), this.measurementToolInitTimeout = setTimeout(() => {
      this.measurementToolInitTimeout = null, !this.deleted && (this.measurementTool = new axt(this.context));
    }, 0);
  }
  // drag measurement prop if picked, otherwise pass event to camera interactor
  onLeftPress(e, n) {
    var a;
    this.measurementsInteractive.set(!1);
    const s = n.position, r = e.pickPropPoint(s.x, s.y, 1);
    if (r) {
      const [o, l] = r, c = this.findPropMeasurement(o, l);
      if (c !== null) {
        const [u, d] = c;
        this.pickedAnnotation = u, this.pickedAnnotationPointIndex = d;
        const h = u.getPointPosition(d);
        this.startPoint = h;
        const p = e.worldToDisplay(h[0], h[1], h[2]);
        return this.pickScreenOffset = [s.x - p[0], s.y - p[1]], this.context.objects.measurementsObjects.get().forEach((m) => {
          m.annotation.setPickable(!1);
        }), (a = this.context.getInteractorStyle()) == null || a.setMeasurementToolDragActive(!0), !0;
      }
    }
    return !1;
  }
  onLeftRelease() {
    var e;
    if ((e = this.context.getInteractorStyle()) == null || e.setMeasurementToolDragActive(!1), this.measurementsInteractive.set(!0), this.pickedAnnotation != null && this.pickedAnnotationPointIndex != null) {
      this.pickedAnnotation.isROI() && this.pickedAnnotation.updateLabel();
      const n = (c) => {
        c.isROI() && c.updateLabel();
        for (const d of this.context.objects.projectCollection2D.objects)
          if (d.name == c.projectName)
            if (c.isROI()) {
              d.points = [];
              for (let h = 0; h < c.getNumberOfPoints(); h++)
                d.points.push(c.getPointPosition(h)), d.statistics = c.statistics;
            } else c.isAngle() ? d.points = [
              c.getPointPosition(1),
              c.getPointPosition(0),
              c.getPointPosition(2)
            ] : d.points = [c.getPointPosition(0), c.getPointPosition(1)];
        this.context.objects.measurementsObjects.modified();
        const u = (d, h) => this.onViewWidgetEvent(d, h);
        this.context.sceneRepaint(void 0, u);
      }, s = this.startPoint, r = this.pickedAnnotation, a = this.pickedAnnotationPointIndex, o = r.getPointPosition(a), l = new vr({
        onUndo: () => {
          r.movePickedPoint(a, s), n(r);
        },
        onRedo: () => {
          r.movePickedPoint(a, o), n(r);
        }
      });
      return this.context.undoManager.pushPop(r, l, "Move Measurement", ws.NONE), this.pickedAnnotation = null, this.pickedAnnotationPointIndex = null, this.context.objects.measurementsObjects.get().forEach((c) => {
        c.annotation.setPickable(!0);
      }), !0;
    }
    return !1;
  }
  onMouseMove(e, n, s) {
    if (this.cursor = null, this.pickedAnnotation != null && this.pickedAnnotationPointIndex !== null) {
      this.cursor = "pointer";
      const r = n.position;
      let a;
      if (e.isViewMode3D()) {
        const l = e.pickPropPoint(r.x, r.y);
        let c = null;
        l && (c = l[1]);
        const u = zh(this.context, e, n.position.x, n.position.y), d = Eh(e, u, c);
        d ? a = d : a = this.pickPoint(e, n);
      } else
        a = this.pickPoint(e, n);
      this.pickedAnnotation.movePickedPoint(this.pickedAnnotationPointIndex, a);
      for (const l of this.context.objects.projectCollection2D.objects)
        if (l.name == this.pickedAnnotation.projectName)
          if (this.pickedAnnotation.isROI()) {
            l.points = [];
            for (let c = 0; c < this.pickedAnnotation.getNumberOfPoints(); c++)
              l.points.push(this.pickedAnnotation.getPointPosition(c)), l.statistics = this.pickedAnnotation.statistics;
          } else this.pickedAnnotation.isAngle() ? l.points = [
            this.pickedAnnotation.getPointPosition(1),
            this.pickedAnnotation.getPointPosition(0),
            this.pickedAnnotation.getPointPosition(2)
          ] : l.points = [this.pickedAnnotation.getPointPosition(0), this.pickedAnnotation.getPointPosition(1)];
      this.context.objects.measurementsObjects.modified();
      const o = (l, c) => this.onViewWidgetEvent(l, c);
      return this.context.sceneRepaint(void 0, o), !0;
    } else {
      if (s.mouseButtons.left)
        return !1;
      {
        const r = n.position, a = e.pickPropPoint(r.x, r.y, 1);
        let o = !1;
        if (a) {
          const [l, c] = a, u = this.findPropMeasurement(l, c);
          u && (this.cursor = "pointer"), o = o || this.updateHighlight(u);
        } else
          o = o || this.updateHighlight(null);
        if (o) {
          const l = (c, u) => this.context.toolManager.measurementsTool.onViewWidgetEvent(c, u);
          this.context.sceneRepaint(void 0, l);
        }
        return !1;
      }
    }
  }
  onMouseWheel() {
    return !0;
  }
  getCursor() {
    return this.cursor;
  }
  updateHighlight(e) {
    if (e === null)
      return this.lastMouseOverPoint ? (this.lastMouseOverPoint[0].setPointHighlight(this.lastMouseOverPoint[1], !1), this.lastMouseOverPoint = null, !0) : !1;
    {
      const [n, s] = e;
      return this.lastMouseOverPoint ? this.lastMouseOverPoint[0] === n && this.lastMouseOverPoint[1] === s ? !1 : (this.lastMouseOverPoint[0].setPointHighlight(this.lastMouseOverPoint[1], !1), n.setPointHighlight(s, !0), this.lastMouseOverPoint = e, !0) : (n.setPointHighlight(s, !0), this.lastMouseOverPoint = e, !0);
    }
  }
  findPropMeasurement(e, n) {
    for (const s of this.context.objects.measurementsObjects.get()) {
      const r = s[1], a = r.annotation.getPickedPoint(e, n);
      if (a !== null)
        return [r.annotation, a];
    }
    return null;
  }
  onViewWidgetEvent(e, n) {
    var o, l;
    if (((o = this.measurementTool) == null ? void 0 : o.getState().activeTool.get()) != qA.POLYGON && ((l = this.measurementTool) == null ? void 0 : l.getState().activeTool.get()) != null) return;
    const s = 1, r = e.getOrigin(), a = e.getNormal();
    this.context.objects.measurementsObjects.get().forEach((c, u) => {
      var m, b, y, Z, g, f, T, M, N, W, x, V, X, C, R;
      const d = c.annotation.getNumberOfPoints();
      if (d === 0) return;
      this.measurementRepresentations.get(u) || this.measurementRepresentations.set(u, /* @__PURE__ */ new Map());
      const p = this.measurementRepresentations.get(u);
      if (p)
        if (n == me.eVE_DESTROY) {
          const z = p.get(e);
          z && (z.annotation.removeAnnotationFromRenderer(e), (m = z.label) == null || m.remove(), (b = z.overlayComponents) == null || b.cleanup(), p.delete(e));
          return;
        } else {
          if (!p.has(e)) {
            const F = Pi(e.getOverlayContainer()), P = new qt(e.worldToView(...c.annotation.getPointPosition(0))), j = F.createVueOverlayComponent(
              Cht,
              {
                view: e.id,
                viewSize: e.state.viewSize,
                visible: new qt(!0),
                //measurementsVisible,
                interactive: this.measurementsInteractive,
                str: c.annotation.isROI() ? c.annotation.statisticsText : c.annotation.name,
                objectScreenPosition: P
              },
              {
                enabled: !1,
                scrollThrough: !0,
                z: 1
              }
            );
            p.set(e, {
              view: c.view,
              annotation: c.annotation,
              // newA, // mRep.annotation, // todo: copy annotation information
              label: j,
              overlayComponents: F,
              point1: P
            });
          }
          const z = p.get(e);
          if (z)
            if (n == me.eVE_SHOW || n == me.eVE_RENDER) {
              if (!c.annotation.getVisible()) {
                (y = z.label) == null || y.setEnabled(!1);
                return;
              }
              if (z.view.getViewMode() != e.getViewMode()) {
                z.annotation.removeAnnotationFromRenderer(e);
                return;
              }
              if (e.isViewMode3D()) {
                z.annotation.addAnnotationToRenderer(e, 1), (Z = z.point1) == null || Z.set(e.worldToView(...c.annotation.getPointPosition(0))), (g = z.label) == null || g.setEnabled(!0);
                return;
              }
              if (e.getViewMode() == Nt.CPR) {
                const P = (f = z.annotation.getBookmark().get(e)) == null ? void 0 : f.curveDelta;
                if (P && Math.abs(P - this.context.curveDelta.get().value) > 1) {
                  z.annotation.removeAnnotationFromRenderer(e), (T = z.label) == null || T.setEnabled(!1);
                  return;
                }
                (M = z.point1) == null || M.set(e.worldToView(...c.annotation.getPointPosition(0))), (N = z.label) == null || N.setEnabled(!0), z.annotation.addAnnotationToRenderer(e, 1);
                return;
              }
              const F = I.create();
              if (I.sub(F, z.annotation.getPointPosition(0), r), Math.abs(I.dot(F, a)) > s && !z.annotation.alwaysOnTop) {
                z.annotation.removeAnnotationFromRenderer(e), (W = z.label) == null || W.setEnabled(!1);
                return;
              }
              if (d > 1) {
                const P = I.create();
                if (I.sub(P, z.annotation.getPointPosition(1), r), Math.abs(I.dot(P, a)) > s && !z.annotation.alwaysOnTop) {
                  z.annotation.removeAnnotationFromRenderer(e), (x = z.label) == null || x.setEnabled(!1);
                  return;
                }
              }
              if ((z.annotation.isROI() || z.annotation.isAngle()) && d > 2 && this.measurementTool.getState().activeTool.get() == null) {
                const P = I.create();
                if (I.sub(P, z.annotation.getPointPosition(2), r), Math.abs(I.dot(P, a)) > s && !z.annotation.alwaysOnTop) {
                  z.annotation.removeAnnotationFromRenderer(e), (V = z.label) == null || V.setEnabled(!1);
                  return;
                }
              }
              (X = z.point1) == null || X.set(e.worldToView(...c.annotation.getPointPosition(0))), (C = z.label) == null || C.setEnabled(!0), z.annotation.addAnnotationToRenderer(e, 1);
            } else
              z.annotation.removeAnnotationFromRenderer(e), (R = z.label) == null || R.setEnabled(!1);
        }
    });
  }
  clearRepresentationById(e) {
    const n = this.measurementRepresentations.get(e);
    n && (n.forEach((s, r) => {
      var a, o;
      s.annotation.removeAnnotationFromRenderer(r), (a = s.label) == null || a.remove(), (o = s.overlayComponents) == null || o.cleanup();
    }), this.measurementRepresentations.delete(e));
  }
  deleteMeasurementById(e) {
    const n = this.context.objects.measurementsObjects.get().get(e);
    if (n) {
      this.measurementTool.getActiveMeasurementId() === e && this.measurementTool.cancelActiveMeasurementTool(), this.cancelMeasurementInteraction(n.annotation);
      const s = e, r = n.annotation.projectName, a = vM(this.context.objects.projectCollection2D.objects), o = vM(this.context.projectBookmarks), l = (u) => {
        var d, h, p;
        this.clearRepresentationById(u), n.annotation.isAngle() ? this.measurementTool.angleCount-- : n.annotation.isROI() ? this.measurementTool.roiCount-- : n.annotation.isDistance() ? this.measurementTool.distCount-- : this.measurementTool.annotCount--, (d = n.overlayComponents) == null || d.cleanup(), (h = n.annotation) == null || h.delete(), (p = n.overlayComponents) == null || p.cleanup(), this.context.objects.measurementsObjects.get().delete(u), this.context.objects.measurementsObjects.modified();
      };
      l(e);
      const c = new vr({
        onUndo: () => {
          this.context.objects.projectCollection2D.objects = vM(a), this.context.projectBookmarks = vM(o), this.context.objects.projectCollection2D.objects.forEach((u) => {
            u.name == r && this.context.toolManager.measurementsTool.measurementTool.addMeasurementFromProject(u, s);
          });
        },
        onRedo: () => {
          l(s);
        }
      });
      this.context.undoManager.pushPop(this, c, "Delete Measurement", ws.SCENE_REPAINT);
    }
  }
  cancelMeasurementInteraction(e) {
    var n, s;
    (!e || this.pickedAnnotation === e) && ((n = this.context.getInteractorStyle()) == null || n.setMeasurementToolDragActive(!1), this.measurementsInteractive.set(!0), this.pickedAnnotation = null, this.pickedAnnotationPointIndex = null, this.pickScreenOffset = null), (!e || ((s = this.lastMouseOverPoint) == null ? void 0 : s[0]) === e) && (this.lastMouseOverPoint = null);
  }
  pickPoint(e, n) {
    const s = n.position, r = this.pickScreenOffset || [0, 0], a = s.x - r[0], o = s.y - r[1], l = e.hardwareSelectorPickCaptured(0, !0, !1, a, o);
    return $A(l) ?? e.pickWorldPoint(a, o);
  }
  snapToBookmark(e, n) {
    console.log("bMark same stateID as annotation.projectName", e), console.log("this.context.projectBookmarks", this.context.projectBookmarks);
    const s = e.indexId;
    this.context.layoutManager.wizardTabIndex.set(e.layoutType), setTimeout(() => {
      var o;
      const r = Math.min(...this.context.getImageData().getSpacing());
      this.context.toolManager.coordControl.crossAngle.set(e.cprAngle), this.context.layoutManager.setLayout(e.desktopType);
      let a = !0;
      if (this.context.projectBookmarks.windows.windows[0] && this.context.projectBookmarks.windows.windows[1] && this.context.projectBookmarks.windows.windows[2] && this.context.projectBookmarks.windows.windows[4]) {
        for (const l of this.context.projectBookmarks.windows.windows[4].presenterWindow.viewWidget.bookmarks)
          if (l.stateId == s) {
            const c = this.context.getViewWidget(Nt.CPR);
            if (c && c.isVisible()) {
              c.getPresenterWindow().setFilterCPRThicknessEvent.notify({
                filterMode: l.filterType,
                thickness: r * l.mipThickness
              }), a = !1, (o = c.getPresenterWindow()) == null || o.setWindowLevel(l.windowLevelWidth);
              const u = I.fromValues(...l.origin);
              this.context.toolManager.coordControl.setCenter(u, c), console.log("p.curveDelta", n), n && c.getPresenterWindow().returnMainView().shiftCurve(n);
            }
          }
        this.context.projectBookmarks.windows.windows[0].presenterWindow.viewWidget.bookmarks.forEach((l) => {
          var c, u, d;
          if (l.stateId == s) {
            console.log("axial");
            const h = this.context.getViewWidget(Nt.AXIAL);
            if (h && (h.getPresenterWindow().setFilterModeThicknessFcn(l.filterType, r * l.mipThickness), (c = h.getPresenterWindow()) == null || c.setWindowLevel(l.windowLevelWidth), a)) {
              (u = h.getPresenterWindow()) == null || u.setWindowLevel(l.windowLevelWidth);
              const p = ut.fromValues(...l.xAxis, 0, ...l.yAxis, 0, ...l.zAxis, 0, ...l.origin, 1);
              h.setViewMatrix(p), (d = h.getPresenterWindow()) == null || d.setSliceInfoNormal();
              const m = this.context.getPresenterWindow(Nt.AXIAL);
              m == null || m.UpdateViews();
            }
          }
        }), this.context.projectBookmarks.windows.windows[1].presenterWindow.viewWidget.bookmarks.forEach((l) => {
          var c, u, d, h;
          if (l.stateId == s) {
            console.log("CROSS");
            const p = this.context.getViewWidget(Nt.CROSS);
            p && (p.getPresenterWindow().setFilterModeThicknessFcn(l.filterType, r * l.mipThickness), (c = p.getPresenterWindow()) == null || c.setWindowLevel(l.windowLevelWidth)), console.log("CORONAL");
            const m = this.context.getViewWidget(Nt.CORONAL);
            if (m && (m.getPresenterWindow().setFilterModeThicknessFcn(l.filterType, r * l.mipThickness), (u = m.getPresenterWindow()) == null || u.setWindowLevel(l.windowLevelWidth), a)) {
              (d = m.getPresenterWindow()) == null || d.setWindowLevel(l.windowLevelWidth);
              const b = ut.fromValues(...l.xAxis, 0, ...l.yAxis, 0, ...l.zAxis, 0, ...l.origin, 1);
              m.setViewMatrix(b), (h = m.getPresenterWindow()) == null || h.setSliceInfoNormal();
              const y = this.context.getPresenterWindow(Nt.CORONAL);
              y == null || y.UpdateViews();
            }
          }
        }), this.context.projectBookmarks.windows.windows[2].presenterWindow.viewWidget.bookmarks.forEach((l) => {
          var c, u, d, h;
          if (l.stateId == s) {
            console.log("Tangent");
            const p = this.context.getViewWidget(Nt.TANGENT);
            p && (p.getPresenterWindow().setFilterModeThicknessFcn(l.filterType, r * l.mipThickness), (c = p.getPresenterWindow()) == null || c.setWindowLevel(l.windowLevelWidth)), console.log("Sagittal");
            const m = this.context.getViewWidget(Nt.SAGITTAL);
            if (m && (m.getPresenterWindow().setFilterModeThicknessFcn(l.filterType, r * l.mipThickness), (u = m.getPresenterWindow()) == null || u.setWindowLevel(l.windowLevelWidth), a)) {
              (d = m.getPresenterWindow()) == null || d.setWindowLevel(l.windowLevelWidth);
              const b = ut.fromValues(...l.xAxis, 0, ...l.yAxis, 0, ...l.zAxis, 0, ...l.origin, 1);
              m.setViewMatrix(b), (h = m.getPresenterWindow()) == null || h.setSliceInfoNormal();
              const y = this.context.getPresenterWindow(Nt.SAGITTAL);
              y == null || y.UpdateViews();
            }
          }
        });
      }
      this.context.sceneRepaint();
    }, 0);
  }
  delete() {
    var e;
    this.deleted || (this.deleted = !0, this.measurementToolInitTimeout !== null && (clearTimeout(this.measurementToolInitTimeout), this.measurementToolInitTimeout = null), (e = this.measurementTool) == null || e.delete(), this.measurementRepresentations.forEach((n, s) => {
      n.forEach((r, a) => {
        var o, l;
        r.annotation.removeAnnotationFromRenderer(a), (o = r.label) == null || o.remove(), (l = r.overlayComponents) == null || l.cleanup();
      }), this.measurementRepresentations.delete(s);
    }), this.reactivity.cleanupAll());
  }
}
class YVt extends Ja {
  constructor(e) {
    super();
    S(this, "context");
    S(this, "cursor", null);
    S(this, "reactivity", An());
    S(this, "onEvent", this.reactivity.onEvent);
    S(this, "watch", this.reactivity.watch);
    S(this, "computed", this.reactivity.computed);
    S(this, "handlesRepresentation", /* @__PURE__ */ new Map());
    S(this, "CrossAngleRep", /* @__PURE__ */ new Map());
    S(this, "viewCameraModified", new se());
    this.context = e, this.onEvent(this.viewCameraModified, (n) => {
      console.log("implnatpintool viewCameraModified", n.getViewMode());
    }), this.watch(this.context.objects.selectedObject, () => {
      console.log("implnatpintool selectedObject");
      const n = (s, r) => this.onViewWidgetEvent(s, r);
      this.context.sceneRepaint(void 0, n);
    });
  }
  getCursor() {
    return this.cursor;
  }
  onViewWidgetEvent(e, n) {
    var s, r, a, o;
    if (e.getViewMode() !== Nt._STL_3D_PREVIEW)
      if (n == me.eVE_DESTROY) {
        (s = this.CrossAngleRep.get(e)) == null || s.OnViewWidget(e, n);
        const l = this.handlesRepresentation.get(e);
        l && (l.viewObjectPositions.stop(), l.overlay.setEnabled(!1), l.infosOverlay.setEnabled(!1), l.overlay.remove(), l.infosOverlay.remove(), l.overlayComponents.cleanup(), this.handlesRepresentation.delete(e));
        return;
      } else {
        const l = this.context.objects.selectedObject.get();
        if (l && this.context.settings.implants.showBLAngle && (e.getViewMode() == Nt.CROSS || e.getViewMode() == Nt.CORONAL) ? (this.CrossAngleRep.get(e) || this.CrossAngleRep.set(e, new pJ(this.context, e)), (r = this.CrossAngleRep.get(e)) == null || r.setItem(l), (a = this.CrossAngleRep.get(e)) == null || a.OnViewWidget(e, n)) : (o = this.CrossAngleRep.get(e)) == null || o.OnViewWidget(e, me.eVE_DESTROY), !this.handlesRepresentation.has(e)) {
          const u = this.computed(() => e.getViewObjectPositions().get().filter((b) => b.type !== void 0 && [Yt._IMPLANT, Yt._PIN].includes(b.type)));
          let d = null;
          e.getViewMode() == Nt.CPR && (d = this.computed(() => {
            const b = [], [y, Z] = e.state.viewSize.get();
            return u.get().forEach((g) => {
              let f = !1;
              const T = this.context.objects.selectedObject.get();
              T && T.id == g.id && (f = !0);
              const M = {
                id: g.id,
                selectedFlag: f,
                name: g.name,
                type: g.type,
                position: g.position,
                handleTop: null,
                handleBottom: null,
                centerlineTop: null,
                centerlineBottom: null,
                color: g.color,
                lockedFlag: g.lockedFlag,
                visible: g.visible,
                // global object visibility state
                visibleInView: g.visibleInView,
                // object visible on screen in current view
                preciseStepFlag: this.context.settings.implants.showImplantStepButtons
              }, N = this.context.getState().object3DInfos.get().map((W) => W.id).indexOf(g.id);
              if (N != -1) {
                const W = this.context.getState().object3DInfos.get()[N], x = W.position, V = this.context.CPRMath.convertMMtoCPR(x, !0), X = e.worldToView(...V);
                M.position = [X[0], X[1]];
                const C = M.position[0] >= 0 && M.position[0] < y && M.position[1] >= 0 && M.position[1] < Z;
                M.visibleInView = C, M.handleTop = W.handleTop ? e.worldToView(...this.context.CPRMath.convertMMtoCPR(W.handleTop, !0)) : null, M.handleBottom = W.handleBottom ? e.worldToView(...this.context.CPRMath.convertMMtoCPR(W.handleBottom, !0)) : null, M.centerlineTop = null, M.centerlineBottom = null;
              } else
                console.warn("original object not found in context!!");
              b.push(M);
            }), b;
          }));
          const h = Pi(e.getOverlayContainer()), p = h.createVueOverlayComponent(
            NP,
            {
              viewSize: e.state.viewSize,
              viewObjectPositions: e.getViewMode() == Nt.CPR && d ? d : u,
              objectPreciseMoveEvent: e.objectPreciseMoveEvent,
              objectMoveEvent: e.objectMoveEvent,
              objectMoveStartEvent: e.objectMoveStartEvent,
              objectRotateTopBottomEvent: e.objectRotateTopBottomEvent,
              objectRotateTopBottomStartEvent: e.objectRotateTopBottomStartEvent,
              objectMoveRotateEndEvent: this.context.objectMoveRotateEndEvent,
              objectSnapEvent: e.objectSnapEvent,
              createUndoEvent: e.createUndoEvent,
              cprtommTransform: e.getViewMode() == Nt.CPR,
              view3D: e.isViewMode3D()
            },
            { enabled: !0 }
          ), m = h.createVueOverlayComponent(
            TP,
            {
              model: this.context.overlayModel,
              view: e.id,
              viewSize: e.state.viewSize,
              viewObjectPositions: e.getViewMode() == Nt.CPR && d ? d : u,
              infoFlag: this.context.getInfoFlag()
            },
            { enabled: !1 }
          );
          this.handlesRepresentation.set(e, {
            overlay: p,
            infosOverlay: m,
            overlayComponents: h,
            viewObjectPositions: u
          });
        }
        const c = this.handlesRepresentation.get(e);
        c && (n == me.eVE_SHOW || n == me.eVE_RENDER ? (c.overlay.setEnabled(!0), c.infosOverlay.setEnabled(!0)) : (c.overlay.setEnabled(!1), c.infosOverlay.setEnabled(!1)));
      }
  }
  delete() {
    this.handlesRepresentation.forEach((e, n) => {
      e.overlay.remove(), e.infosOverlay.remove(), e.overlayComponents.cleanup(), e.viewObjectPositions.stop(), this.handlesRepresentation.delete(n);
    }), this.reactivity.cleanupAll();
  }
}
class vVt extends Ja {
  constructor(e) {
    super();
    S(this, "context");
    S(this, "cursor", null);
    S(this, "reactivity", An());
    S(this, "onEvent", this.reactivity.onEvent);
    S(this, "watch", this.reactivity.watch);
    S(this, "computed", this.reactivity.computed);
    S(this, "handlesRepresentation", /* @__PURE__ */ new Map());
    S(this, "viewCameraModified", new se());
    this.context = e;
  }
  onMouseWheel() {
    return !0;
  }
  getCursor() {
    return this.cursor;
  }
  onViewWidgetEvent(e, n) {
    if (n == me.eVE_DESTROY) {
      const s = this.handlesRepresentation.get(e);
      s && (s.viewObjectPositions.stop(), s.overlay.remove(), s.overlayComponents.cleanup(), this.handlesRepresentation.delete(e));
      return;
    } else {
      if (e.getViewMode() == Nt.CPR) return;
      if (!this.handlesRepresentation.has(e)) {
        const r = this.computed(() => {
          const c = e.getViewObjectPositions().get().filter(
            (d) => d.type !== void 0 && [Yt._STL_OBJECT, Yt._STL_TEETH_MODEL, Yt._STL_PROSTHESIS, Yt._REFERENCE_PLANE, Yt._STL_TOOTH].includes(
              d.type
            ) && !d.lockedFlag
          ).filter((d) => d.visible && !d.lockedFlag), u = e.getStlRotationCenter().get();
          if (c.length > 0 && u) {
            const [d, h] = e.state.viewSize.get(), p = u[0] >= 0 && u[0] < d && u[1] >= 0 && u[1] < h;
            return [{
              id: "uid",
              selectedFlag: !0,
              name: "stlHandle",
              type: Yt._STL_OBJECT,
              position: u,
              handleTop: null,
              handleBottom: null,
              centerlineTop: null,
              centerlineBottom: null,
              color: c[0].color,
              visible: !0,
              // global object visibility state
              lockedFlag: !1,
              visibleInView: p,
              // object visible on screen in current view
              preciseStepFlag: c[0].preciseStepFlag ?? (this.context.settings.implants.showImplantStepButtons && !e.isViewMode3D())
            }];
          }
          return [];
        }), a = Pi(e.getOverlayContainer()), o = a.createVueOverlayComponent(Pbt, {
          viewSize: e.state.viewSize,
          viewObjectPositions: r,
          objectPreciseMoveEvent: e.stlPreciseMoveEvent,
          cprtommTransform: e.getViewMode() == Nt.CPR,
          objectMoveEvent: e.stlMoveEvent,
          objectRotateEvent: e.stlRotateEvent,
          objectMoveStartEvent: e.stlMoveStartEvent,
          objectRotateStartEvent: e.stlRotateStartEvent,
          createUndoEvent: e.createUndoEvent
        });
        this.handlesRepresentation.set(e, {
          overlay: o,
          overlayComponents: a,
          viewObjectPositions: r
        });
      }
      const s = this.handlesRepresentation.get(e);
      s && (n == me.eVE_SHOW || n == me.eVE_RENDER ? s.overlay.setEnabled(!0) : s.overlay.setEnabled(!1));
    }
  }
  delete() {
    this.handlesRepresentation.forEach((e, n) => {
      e.overlay.remove(), e.overlayComponents.cleanup(), e.viewObjectPositions.stop(), this.handlesRepresentation.delete(n);
    }), this.reactivity.cleanupAll();
  }
}
class RVt extends Ja {
  constructor(e) {
    super();
    S(this, "context");
    S(this, "pointPickerSTL");
    S(this, "pointPickerDICOM");
    S(this, "stlNumOfPoints", new qt(0));
    S(this, "dicomNumOfPoints", new qt(0));
    S(this, "reactivity", An());
    S(this, "onEvent", this.reactivity.onEvent);
    S(this, "prepareForMatchingFromDropdownEvent", new se());
    S(this, "leftDown");
    S(this, "moveFlag", !1);
    S(this, "enabled", !1);
    S(this, "destroy", !1);
    S(this, "pViewSTL");
    S(this, "viewSTL");
    S(this, "viewDICOM");
    S(this, "pointRepresentationMapSTL", /* @__PURE__ */ new Map());
    S(this, "pointRepresentationMapSTLSurrounding", /* @__PURE__ */ new Map());
    S(this, "pointRepresentationMapDICOM", /* @__PURE__ */ new Map());
    S(this, "pointRepresentationMapDICOMSurrounding", /* @__PURE__ */ new Map());
    S(this, "stl", null);
    S(this, "targetObject");
    S(this, "orgUMatrix", ut.create());
    S(this, "matchingSTL");
    S(this, "matchingUMatrix", ut.create());
    S(this, "bestFitFlag", new qt(!1));
    S(this, "matchingTool");
    S(this, "initialized", !1);
    S(this, "surrounding", 2);
    S(this, "delta", 0);
    S(this, "matchingExistingObject", !1);
    S(this, "STLonSTLFlag", !1);
    S(this, "cancelMatching", !1);
    this.context = e, this.context.getPresenterWindows().forEach((n) => {
      var s;
      ((s = n.getMainView()) == null ? void 0 : s.getViewMode()) == Nt._3D && (this.viewDICOM = n.returnMainView());
    }), this.pointPickerSTL = new v2(this.context, !0, void 0, void 0, 0), this.pointPickerDICOM = new v2(this.context, !0, void 0, void 0, 0), this.leftDown = !1, this.onEvent(this.pointPickerSTL.rerenderPoints, () => {
      this.rerenderRepresentations();
    }), this.onEvent(this.pointPickerSTL.pointAddedEvent, () => {
      this.rerenderRepresentations(), this.stlNumOfPoints.set(this.pointPickerSTL.getNumberOfPoints());
    }), this.onEvent(this.pointPickerDICOM.rerenderPoints, () => {
      this.rerenderRepresentations();
    }), this.onEvent(this.pointPickerDICOM.pointAddedEvent, () => {
      this.rerenderRepresentations(), this.dicomNumOfPoints.set(this.pointPickerDICOM.getNumberOfPoints());
    }), this.initializeMatchingTool();
  }
  initializeMatchingTool() {
    const e = this.context.getEngine();
    this.matchingTool = new e.xMatchingTool();
  }
  rerenderRepresentations() {
    this.pointRepresentationMapSTL.forEach((e) => {
      e.setData({
        points: this.pointPickerSTL.pointsArray,
        colors: this.pointPickerSTL.colorsArray,
        scales: this.pointPickerSTL.scaleArray
      });
    }), this.pointRepresentationMapSTLSurrounding.forEach((e) => {
      e.setData({
        points: this.pointPickerSTL.pointsArray,
        colors: this.pointPickerSTL.colorsArray,
        scales: this.pointPickerSTL.scaleArray
      });
    }), this.pointRepresentationMapDICOM.forEach((e) => {
      e.setData({
        points: this.pointPickerDICOM.pointsArray,
        colors: this.pointPickerDICOM.colorsArray,
        scales: this.pointPickerDICOM.scaleArray
      });
    }), this.pointRepresentationMapDICOMSurrounding.forEach((e) => {
      e.setData({
        points: this.pointPickerDICOM.pointsArray,
        colors: this.pointPickerDICOM.colorsArray,
        scales: this.pointPickerDICOM.scaleArray
      });
    }), this.repaint(), this.context.sceneRepaint();
  }
  repaint(e) {
    if (this.viewSTL) {
      const n = this.context.toolManager.getLayersByPriority();
      for (const s of n) {
        const r = this.context.toolManager.getToolInstance(s);
        r && r.onViewWidgetEvent(this.viewSTL, e ? me.eVE_DESTROY : me.eVE_RENDER);
      }
      this.onViewWidgetEvent(this.viewSTL, e ? me.eVE_DESTROY : me.eVE_RENDER);
    }
  }
  onViewWidgetEvent(e, n) {
    if (this.destroy) return;
    const s = ge(e);
    if (e == this.viewDICOM)
      if (n == me.eVE_DESTROY) {
        const r = this.pointRepresentationMapDICOM.get(s);
        r && (e.removeActor(r.getActor()), r.delete(), this.pointRepresentationMapDICOM.delete(s));
        const a = this.pointRepresentationMapDICOMSurrounding.get(s);
        a && (e.removeActor(a.getActor()), a.delete(), this.pointRepresentationMapDICOMSurrounding.delete(s));
      } else {
        this.pointRepresentationMapDICOM.has(s) || (this.pointRepresentationMapDICOM.set(s, new ed()), this.pointRepresentationMapDICOMSurrounding.set(s, new ed(0.4, 2)), this.rerenderRepresentations());
        const r = this.pointRepresentationMapDICOM.get(s), a = this.pointRepresentationMapDICOMSurrounding.get(s);
        r && a && (n == me.eVE_SHOW || n == me.eVE_RENDER ? (r.getActor().setPickable(!0), e.addActor(r.getActor(), 0), e.addActor(a.getActor(), 0)) : (e.removeActor(r.getActor()), e.removeActor(a.getActor())));
      }
    else if (e == this.viewSTL)
      if (n == me.eVE_DESTROY) {
        const r = this.pointRepresentationMapSTL.get(s);
        r && (e.removeActor(r.getActor()), r.delete(), this.pointRepresentationMapSTL.delete(s));
        const a = this.pointRepresentationMapSTLSurrounding.get(s);
        a && (e.removeActor(a.getActor()), a.delete(), this.pointRepresentationMapSTLSurrounding.delete(s));
      } else {
        this.pointRepresentationMapSTL.has(s) || (this.pointRepresentationMapSTL.set(s, new ed()), this.pointRepresentationMapSTLSurrounding.set(s, new ed(0.4, 2)), this.rerenderRepresentations());
        const r = this.pointRepresentationMapSTL.get(s), a = this.pointRepresentationMapSTLSurrounding.get(s);
        r && a && (n == me.eVE_SHOW || n == me.eVE_RENDER ? (r.getActor().setPickable(!0), e.addActor(r.getActor(), 0), e.addActor(a.getActor(), 0)) : (e.removeActor(r.getActor()), e.removeActor(a.getActor())));
      }
  }
  initializeSTLView(e, n, s = !1) {
    var o, l;
    this.pViewSTL && this.pViewSTL.cleanup(), this.pViewSTL = new c2(this.context, RW, Nt.STL3D, {
      background: [0, 0, 0],
      color: [255, 255, 255],
      toolbarDisable: !0
    }), this.context.addWindow(this.pViewSTL), this.viewSTL = this.pViewSTL.returnMainView(), this.matchingExistingObject = s;
    const r = [];
    this.context.getPresenterWindows().forEach((c) => {
      var u, d, h, p;
      ((u = c.getMainView()) == null ? void 0 : u.getViewMode()) == Nt._3D && r.push([c, Ce.topLeft]), ((d = c.getMainView()) == null ? void 0 : d.getViewMode()) == Nt.AXIAL && r.push([c, Ce.bottomLeft1312]), ((h = c.getMainView()) == null ? void 0 : h.getViewMode()) == Nt.CORONAL && r.push([c, Ce.bottomMiddle1312]), ((p = c.getMainView()) == null ? void 0 : p.getViewMode()) == Nt.SAGITTAL && r.push([c, Ce.bottomRight1312]);
    }), r.push([this.pViewSTL, Ce.topRight]), this.context.setLayout(r, !0), this.context.nextPrevVisible.set(!1);
    const a = this.context.getObjects().stls.get(e);
    if (a && !a.IsVolume() && (this.targetObject = a), this.targetObject) {
      if (this.orgUMatrix = ut.clone(this.targetObject.getMatrix()), (l = (o = this.viewDICOM) == null ? void 0 : o.overlayComponents) == null || l.objectList.setEnabled(!1), this.targetObject.setVisibility(!1, !0), this.context.getObjects().hideAllObjects(!1, !0), this.stl = n, this.viewSTL) {
        n.setVisibility(!0, !0), n.onViewWidgetEvent(this.viewSTL, me.eVE_RENDER), this.viewSTL.getRenderer().resetCamera();
        const c = this.context.getVolume().volumeActor;
        c && (this.viewSTL.getRenderer().removeActor(c), this.viewSTL.getRenderer().resetCamera()), this.viewSTL.sceneRefresh();
      }
      this.repaint(), this.context.resetOrientation(), this.viewSTL.fitZoomToScreen();
    }
    this.context.sceneRepaint(), this.context.objects.object3DInfos.modified();
  }
  initializeBestFit() {
    if (this.stl && this.targetObject) {
      const e = ut.create();
      ut.transpose(e, this.stl.getMatrix()), this.matchingTool.SetOriginalActorUserMatrix(new Float64Array(e));
      const n = ut.create();
      ut.transpose(n, this.targetObject.getMatrix()), this.matchingTool.SetResultActorUserMatrix(new Float64Array(n)), this.matchingTool.prepareSTL(this.stl.id);
    }
  }
  endMatching(e) {
    var n, s, r, a;
    (n = this.targetObject) == null || n.setVisibility(!0), (s = this.targetObject) == null || s.setPickable(!0), (r = this.targetObject) == null || r.setLocked(!1), this.context.objects.object3DInfos.modified(), (a = this.viewDICOM) == null || a.renderer.resetCamera(), this.repaint(e), e || this.context.sceneRepaint(), setTimeout(() => {
      this.context.updateObject2DPositionEvent.notify();
    }, 0);
  }
  apply(e = !0, n) {
    var s, r, a, o, l, c;
    this.STLonSTLFlag = !1, this.context.nextPrevVisible.set(!0), this.bestFitFlag.set(!1), (r = (s = this.viewDICOM) == null ? void 0 : s.overlayComponents) == null || r.objectList.setEnabled(!0), this.context.getObjects().restoreAllObjectsVisibility(), (a = this.targetObject) == null || a.setLocked(!0), (o = this.targetObject) == null || o.setVisibility(!0), this.pointPickerDICOM.clearPointArray(n), this.pointPickerSTL.clearPointArray(n), (l = this.stl) == null || l.delete(), e && this.context.layoutManager.setLayout(Yn._FULLSCREEN_3D), this.repaint(n), n || this.context.sceneRepaint(), (c = this.pViewSTL) == null || c.cleanup();
  }
  cancel(e = !0) {
    var n;
    !this.matchingExistingObject && !this.STLonSTLFlag ? ((n = this.targetObject) == null || n.delete(), this.targetObject = void 0) : this.STLonSTLFlag && this.matchingSTL ? (this.matchingSTL.setMatrix(this.matchingUMatrix), this.context.getObjects().updateObjectInfos3D(this.matchingSTL)) : !this.STLonSTLFlag && this.matchingExistingObject && this.targetObject && (this.targetObject.setMatrix(this.orgUMatrix), this.context.getObjects().updateObjectInfos3D(this.targetObject)), this.apply(e);
  }
  registerSTL() {
    const e = Math.min(this.pointPickerSTL.getNumberOfPoints(), this.pointPickerDICOM.getNumberOfPoints());
    if (e > 0) {
      this.matchingTool.SetCount(e), this.matchingTool.SetDICOMPointsArray(new Float64Array(this.pointPickerDICOM.getNPickedPoints(e))), this.matchingTool.SetSTLPointsArray(new Float64Array(this.pointPickerSTL.getNPickedPoints(e))), this.matchingTool.RegisterSTL();
      const n = this.matchingTool.GetTransformMatrix(), s = ut.fromValues(
        n[0],
        n[1],
        n[2],
        n[3],
        n[4],
        n[5],
        n[6],
        n[7],
        n[8],
        n[9],
        n[10],
        n[11],
        n[12],
        n[13],
        n[14],
        n[15]
      );
      if (ut.transpose(s, s), this.targetObject && this.stl) {
        const r = ut.clone(this.stl.getMatrix()), a = ut.create();
        ut.multiply(a, s, r);
        const o = this.targetObject, l = new vr({
          onUndo: () => {
            o.setMatrix(r), this.context.getObjects().updateObjectInfos3D(o);
          },
          onRedo: () => {
            o.setMatrix(a), this.context.getObjects().updateObjectInfos3D(o);
          }
        });
        this.context.undoManager.pushPop(this.targetObject, l, "Set STL User Matrix", ws.SCENE_REPAINT), this.targetObject.setMatrix(a), this.context.getObjects().updateObjectInfos3D(this.targetObject);
      }
      this.endMatching(), this.bestFitFlag.set(!0);
    } else
      this.endMatching(), this.bestFitFlag.set(!1);
  }
  async registerBestFit() {
    this.initializeBestFit();
    const e = Math.min(this.pointPickerSTL.getNumberOfPoints(), this.pointPickerDICOM.getNumberOfPoints());
    if (e > 0 && (this.matchingTool.SetCount(e), this.matchingTool.SetDICOMPointsArray(new Float64Array(this.pointPickerDICOM.getNPickedPoints(e))), this.matchingTool.SetSTLPointsArray(new Float64Array(this.pointPickerSTL.getNPickedPoints(e))), this.targetObject && this.stl)) {
      const n = ut.create();
      ut.transpose(n, this.targetObject.getMatrix()), this.matchingTool.SetResultActorUserMatrix(new Float64Array(n)), this.matchingTool.SetWidthLevel(this.context.getVolumeWindowWidthLevel()[0], this.context.getVolumeWindowWidthLevel()[1]), this.matchingTool.SetSurrounding(this.surrounding), await this.matchingTool.updateSTLAsync(), await this.matchingTool.RegisterSTLBestFitAsync(), this.delta = this.matchingTool.GetDelta();
      const s = this.matchingTool.GetBestFitTransformMatrix(), r = ut.fromValues(
        s[0],
        s[1],
        s[2],
        s[3],
        s[4],
        s[5],
        s[6],
        s[7],
        s[8],
        s[9],
        s[10],
        s[11],
        s[12],
        s[13],
        s[14],
        s[15]
      );
      if (ut.transpose(r, r), this.targetObject) {
        const a = ut.clone(this.targetObject.getMatrix()), o = ut.create();
        ut.multiply(o, r, a);
        const l = this.targetObject, c = new vr({
          onUndo: () => {
            l.setMatrix(a), this.context.getObjects().updateObjectInfos3D(l);
          },
          onRedo: () => {
            l.setMatrix(o), this.context.getObjects().updateObjectInfos3D(l);
          }
        });
        this.context.undoManager.pushPop(this.targetObject, c, "Set STL User Matrix", ws.SCENE_REPAINT), this.targetObject.setMatrix(o), this.context.getObjects().updateObjectInfos3D(this.targetObject), this.repaint(), this.context.sceneRepaint();
      }
    }
  }
  async registerSTLAutomatic() {
    if (this.cancelMatching = !1, this.context.showLoading(jt("medic-web-engine.automaticStlRegistration")), this.context.setLoadingCancelButton(!0, () => this.cancelRegisterSTLAutomatic()), this.initializeBestFit(), this.targetObject) {
      const s = ut.create();
      ut.transpose(s, this.targetObject.getMatrix()), this.matchingTool.SetOriginalActorUserMatrix(new Float64Array(s)), this.matchingTool.updateMatrix();
    }
    try {
      await this.matchingTool.RegisterSTLAutomaticAsync();
    } catch (s) {
      console.log("Error: ", s), this.context.hideLoading(), this.context.setLoadingCancelButton(!1);
      return;
    }
    if (this.abortIfRequested()) return;
    this.delta = this.matchingTool.GetDelta();
    const e = this.matchingTool.GetAutomaticTransformMatrix(), n = ut.fromValues(
      e[0],
      e[1],
      e[2],
      e[3],
      e[4],
      e[5],
      e[6],
      e[7],
      e[8],
      e[9],
      e[10],
      e[11],
      e[12],
      e[13],
      e[14],
      e[15]
    );
    if (ut.transpose(n, n), this.targetObject) {
      const s = ut.clone(this.targetObject.getMatrix()), r = ut.create();
      ut.multiply(r, n, s);
      const a = this.targetObject, o = new vr({
        onUndo: () => {
          a.setMatrix(s), this.context.getObjects().updateObjectInfos3D(a);
        },
        onRedo: () => {
          a.setMatrix(r), this.context.getObjects().updateObjectInfos3D(a);
        }
      });
      this.context.undoManager.pushPop(this.targetObject, o, "Set STL User Matrix", ws.SCENE_REPAINT), this.targetObject.setMatrix(r), this.context.getObjects().updateObjectInfos3D(this.targetObject);
    }
    this.endMatching(), this.context.hideLoading(), this.context.setLoadingCancelButton(!1);
  }
  getDelta() {
    return this.delta;
  }
  cancelRegisterSTLAutomatic() {
    this.cancelMatching = !0, this.context.hideLoading(), this.context.setLoadingCancelButton(!1);
  }
  abortIfRequested() {
    return this.cancelMatching ? (console.warn("Automatic STL registration aborted by user"), this.context.hideLoading(), this.context.setLoadingCancelButton(!1), !0) : !1;
  }
  onLeftPress(e, n) {
    if (this.enabled) {
      this.moveFlag = !1, this.leftDown = !0;
      const s = ge(e);
      s == this.viewSTL && this.pointPickerSTL.actorOnHover ? this.pointPickerSTL.onLeftPress(e, n) : s == this.viewDICOM && this.pointPickerDICOM.actorOnHover && this.pointPickerDICOM.onLeftPress(e, n);
    }
    return !1;
  }
  onLeftRelease(e, n) {
    if (this.enabled) {
      this.leftDown = !1;
      const s = ge(e);
      if (s == this.viewSTL ? this.pointPickerSTL.onLeftRelease() : s == this.viewDICOM && this.pointPickerDICOM.onLeftRelease(), !this.moveFlag)
        if (e.getViewMode() == Nt._3D) {
          const r = e.pickPropPoint(n.position.x, n.position.y, 0);
          let a = null;
          r && (a = r[1]);
          const o = zh(this.context, e, n.position.x, n.position.y), l = Eh(e, o, a);
          if (l)
            return this.context.toolManager.coordControl.setCenter(l), this.pointPickerDICOM.addPoint(l), !0;
        } else e.getViewMode() == Nt.STL3D && this.viewSTL && s == this.viewSTL && setTimeout(() => {
          const r = e.pickPropPoint(n.position.x, n.position.y, 0);
          return r ? (this.pointPickerSTL.addPoint(r[1]), !0) : !1;
        }, 0);
    }
    return !1;
  }
  onMouseMove(e, n) {
    if (this.enabled) {
      this.moveFlag = !0;
      const s = ge(e);
      if (e == this.viewSTL) {
        if (this.leftDown && this.pointPickerSTL.pointIndex != -1) {
          const r = this.pointRepresentationMapSTL.get(s), a = this.pointRepresentationMapSTLSurrounding.get(s);
          r && a && (r.getActor().setPickable(!1), a.getActor().setPickable(!1));
          const o = e.pickPropPoint(n.position.x, n.position.y, 0);
          return r && a && (r.getActor().setPickable(!0), a.getActor().setPickable(!0)), o && this.pointPickerSTL.changePointPosition(o[1]), !0;
        } else if (!this.leftDown)
          return this.pointPickerSTL.onMouseMove(e, n);
      } else if (e == this.viewDICOM) {
        if (this.leftDown, this.leftDown && this.pointPickerDICOM.pointIndex != -1) {
          const r = this.pointRepresentationMapDICOM.get(s), a = this.pointRepresentationMapDICOMSurrounding.get(s);
          r && a && (r.getActor().setPickable(!1), a.getActor().setPickable(!1));
          const o = e.pickPropPoint(n.position.x, n.position.y, 0);
          let l = null;
          o && (l = o[1]);
          const c = zh(this.context, e, n.position.x, n.position.y), u = Eh(e, c, l);
          return r && a && (r.getActor().setPickable(!0), a.getActor().setPickable(!0)), u && this.pointPickerDICOM.changePointPosition(u), !0;
        } else if (!this.leftDown)
          return this.pointPickerDICOM.onMouseMove(e, n);
      }
    }
    return !1;
  }
  setSurrounding(e) {
    this.surrounding = e, this.pointRepresentationMapSTLSurrounding.forEach((n) => {
      n.setScaling(this.surrounding);
    }), this.pointRepresentationMapDICOMSurrounding.forEach((n) => {
      n.setScaling(this.surrounding);
    }), this.rerenderRepresentations();
  }
  removeLastPickedSTLPoint() {
    this.enabled && (this.pointPickerSTL.removeLastPointEvent.notify(), this.pointPickerSTL.pointAddedEvent.notify(), this.repaint(), this.context.sceneRepaint());
  }
  removeLastPickedDICOMPoint() {
    this.enabled && (this.pointPickerDICOM.removeLastPointEvent.notify(), this.pointPickerDICOM.pointAddedEvent.notify(), this.repaint(), this.context.sceneRepaint());
  }
  removeAllPoints() {
    this.pointPickerDICOM.clearPointArray(), this.pointPickerSTL.clearPointArray(), this.repaint(), this.context.sceneRepaint();
  }
  delete() {
    var e;
    this.destroy = !0, this.pointRepresentationMapSTL.forEach((n, s) => {
      s.removeActor(n.getActor()), n.delete(), this.pointRepresentationMapSTL.delete(s);
    }), this.pointRepresentationMapSTLSurrounding.forEach((n, s) => {
      s.removeActor(n.getActor()), n.delete(), this.pointRepresentationMapSTLSurrounding.delete(s);
    }), this.pointRepresentationMapDICOM.forEach((n, s) => {
      s.removeActor(n.getActor()), n.delete(), this.pointRepresentationMapDICOM.delete(s);
    }), this.pointRepresentationMapDICOMSurrounding.forEach((n, s) => {
      s.removeActor(n.getActor()), n.delete(), this.pointRepresentationMapDICOMSurrounding.delete(s);
    }), this.apply(!1, !0), this.context.getObjects().stls.forEach((n) => {
      n.setLocked(!0);
    }), this.context.objects.object3DInfos.modified(), setTimeout(() => {
      this.context.updateObject2DPositionEvent.notify();
    }, 0), this.matchingTool.deleteData(), this.matchingTool.delete(), (e = this.pViewSTL) == null || e.cleanup(), this.pointPickerSTL.delete(), this.pointPickerDICOM.delete(), this.reactivity.cleanupAll();
  }
}
class DVt {
  constructor(t) {
    S(this, "context");
    S(this, "activeTools", {
      [on.PRIMARY]: null,
      [on.SECONDARY]: null,
      [on.TERTIARY]: null,
      [on.QUATERNARY]: null
    });
    S(this, "activeToolTypes", {
      [on.PRIMARY]: sn.NONE,
      [on.SECONDARY]: sn.NONE,
      [on.TERTIARY]: sn.NONE,
      [on.QUATERNARY]: sn.NONE
    });
    S(this, "onToolBeginChange", new se());
    S(this, "onToolEndChange", new se());
    S(this, "activeTool", {
      WindowLevel: new qt(!1)
    });
    S(this, "cprTool", null);
    S(this, "croppingTool", null);
    S(this, "pointPicker", null);
    S(this, "brushTool", null);
    S(this, "windowLevelTool");
    S(this, "measurementsTool");
    S(this, "sculptingTool", null);
    S(this, "nerveTool", null);
    S(this, "coordControl");
    S(this, "implantPinTool");
    S(this, "stlMoveTool");
    S(this, "matchingTool", null);
    S(this, "reactivity", An());
    S(this, "destructed", !1);
    S(this, "onUndoManagerChange", new se());
    S(this, "onUndoManagerPop", new se());
    this.context = t, this.coordControl = new y2t(this.context), this.windowLevelTool = new Hwt(this.context), this.measurementsTool = new CVt(this.context), this.implantPinTool = new YVt(this.context), this.stlMoveTool = new vVt(this.context), this.reactivity.watch(this.activeTool.WindowLevel, (e) => {
      this.windowLevelTool.contrastEnabled = e;
    });
  }
  getTool(t = on.PRIMARY) {
    return this.activeToolTypes[t];
  }
  getToolInstance(t = on.PRIMARY) {
    return this.activeTools[t];
  }
  getLastActiveLayerToolInstance() {
    return this.activeTools[on.QUATERNARY] || this.activeTools[on.TERTIARY] || this.activeTools[on.SECONDARY] || this.activeTools[on.PRIMARY];
  }
  setTool(t, e = on.PRIMARY, n = !0) {
    var a;
    if (this.context.volumeDecimated && (t === sn.CROPPING || t === sn.SCULPTING)) return;
    const s = this.activeToolTypes[e];
    if (t === s)
      return;
    switch (this.onToolBeginChange.notify({
      newTool: t,
      layer: e,
      oldTool: this.activeToolTypes[e]
    }), this.activeTools[e] !== null && ((a = this.activeTools[e]) == null || a.delete(), this.activeTools[e] = null), this.activeToolTypes[e]) {
      case sn.NONE:
        break;
      case sn.PICKER:
        this.activeTools[e] = null;
        break;
      case sn.BRUSH:
        this.activeTools[e] = null;
        break;
      case sn.CPR:
        this.activeTools[e] = null;
        break;
      case sn.NERVE:
        this.activeTools[e] = null;
        break;
      case sn.POLYGON_PICKER:
        break;
      case sn.CROPPING:
        this.activeTools[e] = null;
        break;
      case sn.SCULPTING:
        this.activeTools[e] = null;
        break;
      case sn.MATCHING_TOOL:
        this.activeTools[e] = null;
        break;
    }
    switch (t) {
      case sn.NONE:
        break;
      case sn.PICKER:
        this.pointPicker = new v2(this.context, !0, !1, 3), this.activeTools[e] = this.pointPicker;
        break;
      case sn.BRUSH:
        this.brushTool = new UNt(this.context), this.activeTools[e] = this.brushTool;
        break;
      case sn.CPR:
        this.cprTool = new PNt(this.context), this.activeTools[e] = this.cprTool;
        break;
      case sn.NERVE:
        this.nerveTool = new Qwt(this.context), this.activeTools[e] = this.nerveTool;
        break;
      case sn.POLYGON_PICKER:
        break;
      case sn.CROPPING:
        this.croppingTool = new Kwt(this.context.getImageData(), this.context), this.activeTools[e] = this.croppingTool;
        break;
      case sn.SCULPTING:
        this.sculptingTool = new _wt(this.context), this.activeTools[e] = this.sculptingTool;
        break;
      case sn.MATCHING_TOOL:
        this.matchingTool = new RVt(this.context), this.activeTools[e] = this.matchingTool;
        break;
    }
    this.onToolEndChange.notify({
      oldTool: s,
      newTool: t,
      layer: e
    }), this.activeToolTypes[e] = t, n && this.activeToolTypes[e] != sn.NONE && this.context.sceneRepaint();
  }
  resetTool(t = on.PRIMARY, e = !1) {
    this.setTool(sn.NONE, t, e);
  }
  getTools() {
    const t = [];
    return this.activeTools[on.QUATERNARY] && t.push(this.activeTools[on.QUATERNARY]), this.activeTools[on.TERTIARY] && t.push(this.activeTools[on.TERTIARY]), this.activeTools[on.SECONDARY] && t.push(this.activeTools[on.SECONDARY]), this.activeTools[on.PRIMARY] && t.push(this.activeTools[on.PRIMARY]), t;
  }
  getLayersByPriority() {
    return [on.QUATERNARY, on.TERTIARY, on.SECONDARY, on.PRIMARY];
  }
  notifyUndoManagerChange(t, e) {
    this.onUndoManagerChange.notify({ source: t, value: e });
  }
  notifyUndoManagerPop(t) {
    this.onUndoManagerPop.notify({ source: t });
  }
  cleanUp() {
    this.reactivity.cleanupAll();
  }
  async destructAllTools() {
    this.destructed || (this.destructed = !0, this.cleanUp(), this.setTool(sn.NONE), this.setTool(sn.NONE, on.SECONDARY), this.setTool(sn.NONE, on.TERTIARY), this.setTool(sn.NONE, on.QUATERNARY), this.coordControl.delete(), this.windowLevelTool.delete(), this.measurementsTool.delete(), this.implantPinTool.delete(), this.stlMoveTool.delete());
  }
}
class OVt {
  constructor(t) {
    S(this, "context");
    this.context = t;
  }
  // zaokrozi na celi index v X smeri CPR
  convertCPRtoMMX(t) {
    let e = I.create();
    if (this.context.objects.CPRCurve.splineVec.length > 1) {
      const n = t[0] / this.context.CPRSpacing.get()[0], s = Math.max(0, Math.min(Math.round(n), this.context.objects.CPRCurve.splineVec.length - 1));
      e = I.clone(this.context.objects.CPRCurve.splineVec[s]);
      const r = this.context.CPRHeight / 2 - t[1];
      I.scaleAndAdd(e, e, this.context.objects.CPRCurve.splineBinormals[s], r);
    }
    return e;
  }
  convertCPRtoMM(t) {
    const e = I.create();
    if (this.context.objects.CPRCurve.splineVec.length > 1) {
      const n = t[0] / this.context.CPRSpacing.get()[0], s = Math.max(0, Math.min(Math.round(n), this.context.objects.CPRCurve.splineVec.length - 1)), r = t[0] - s * this.context.CPRSpacing.get()[0], a = this.context.CPRHeight / 2 - t[2];
      I.scaleAndAdd(e, this.context.objects.CPRCurve.splineVec[s], this.context.objects.CPRCurve.splineNormals[s], t[1]), I.scaleAndAdd(e, e, this.context.objects.CPRCurve.splineTangents[s], r), I.scaleAndAdd(e, e, this.context.objects.CPRCurve.splineBinormals[s], a);
    }
    return [e[0], e[1], e[2]];
  }
  getNormalOffset(t) {
    const e = ea(this.context.objects.CPRCurve.splineVec, t).nearestIndex, n = I.create();
    return I.sub(n, t, this.context.objects.CPRCurve.splineVec[e]), I.dot(n, this.context.objects.CPRCurve.splineNormals[e]);
  }
  GetCPRMatrix(t) {
    const e = ea(this.context.objects.CPRCurve.splineVec, t).nearestIndex, n = this.context.objects.CPRCurve.splineNormals[e], s = this.context.objects.CPRCurve.splineTangents[e], r = this.context.objects.CPRCurve.splineBinormals[e];
    let a = ut.create();
    return ut.set(a, s[0], s[1], s[2], 0, -n[0], -n[1], -n[2], 0, -r[0], -r[1], -r[2], 0, 0, 0, 0, 1), a;
  }
  /** convert vtk/renderer mm world to volume world space according to CPRSpline **/
  convertMMtoCPR(t, e = !1) {
    const n = [0, 0, 0];
    if (this.context.objects.CPRCurve.splineVec.length > 1) {
      let s = -1;
      const r = I.create();
      let a = 0, o = 0, l = 0;
      const c = [0, 0], u = I.fromValues(t[0], t[1], t[2]);
      if (this.context.objects.CPRCurve.splineVec.length > 0) {
        s = ea(this.context.objects.CPRCurve.splineVec, t).nearestIndex, s == -1 && (s = this.context.objects.CPRCurve.splineVec.length / 2);
        const d = this.context.objects.CPRCurve.splineNormals[s], h = this.context.objects.CPRCurve.splineTangents[s], p = this.context.objects.CPRCurve.splineBinormals[s], m = this.context.objects.CPRCurve.splineVec[s];
        if (e) {
          const b = I.dot(d, u) - I.dot(d, m);
          I.scaleAndAdd(u, u, d, -b);
        }
        I.subtract(r, u, m), a = I.dot(r, h), e ? o = 0 : o = I.dot(r, d), l = I.dot(r, p), c[0] = s * this.context.CPRSpacing.get()[0], c[1] = this.context.CPRHeight / 2, n[0] = c[0] + a, n[1] = 0 + o, n[2] = c[1] - l;
      }
    }
    return n;
  }
  getClosestSplineNormal(t) {
    let e = I.fromValues(0, 0, 0);
    if (this.context.objects.CPRCurve.splineVec.length > 0) {
      const n = ea(this.context.objects.CPRCurve.splineVec, t).nearestIndex;
      n != -1 && (e = this.context.objects.CPRCurve.splineNormals[n]);
    }
    return e;
  }
  getClosestSplineBinormal(t) {
    let e = I.fromValues(0, 0, 0);
    if (this.context.objects.CPRCurve.splineVec.length > 0) {
      const n = ea(this.context.objects.CPRCurve.splineVec, t).nearestIndex;
      n != -1 && (e = this.context.objects.CPRCurve.splineBinormals[n]);
    }
    return e;
  }
  getClosestSplineTangent(t) {
    let e = I.fromValues(0, 0, 0);
    if (this.context.objects.CPRCurve.splineVec.length > 0) {
      const n = ea(this.context.objects.CPRCurve.splineVec, t).nearestIndex;
      n != -1 && (e = this.context.objects.CPRCurve.splineTangents[n]);
    }
    return e;
  }
  getCPRSwitchPoint() {
    let t = !1;
    const e = I.create();
    I.cross(e, this.context.objects.CPRCurve.splineBinormals[0], I.fromValues(1, 0, 0)), I.angle(e, this.context.objects.CPRCurve.splineTangents[0]) < Math.PI / 2 && (t = !0);
    for (let s = 1; s < this.context.objects.CPRCurve.splineVec.length; s++) {
      const r = I.create();
      I.cross(r, this.context.objects.CPRCurve.splineBinormals[s], I.fromValues(1, 0, 0));
      const a = I.angle(r, this.context.objects.CPRCurve.splineTangents[s]);
      if (t) {
        if (a > Math.PI / 2)
          return s;
      } else if (a < Math.PI / 2)
        return s;
    }
    return null;
  }
  getCPRSwitchPoints() {
    const t = [];
    let e = !1;
    const n = I.create();
    I.cross(n, this.context.objects.CPRCurve.splineBinormals[0], I.fromValues(1, 0, 0)), I.angle(n, this.context.objects.CPRCurve.splineTangents[0]) < Math.PI / 2 && (e = !0);
    for (let r = 1; r < this.context.objects.CPRCurve.splineVec.length; r++) {
      const a = I.create();
      I.cross(a, this.context.objects.CPRCurve.splineBinormals[r], I.fromValues(1, 0, 0));
      const o = I.angle(a, this.context.objects.CPRCurve.splineTangents[r]);
      e ? o > Math.PI / 2 && (t.push(r), e = !e) : o < Math.PI / 2 && (t.push(r), e = !e);
    }
    return t;
  }
  getOrientatedCurvePointsVec3(t) {
    let e = [];
    const n = t.length;
    if (n > 0) {
      const s = t[0], r = t[n - 1];
      return s[0] > r[0] ? (e = [...t].reverse(), e) : t;
    }
    return [];
  }
  getCrossAngle(t, e) {
    if (this.context.getViewWidget(Nt.CPR) && this.context.objects.CPRCurve.splineVec.length > 0) {
      const n = I.create();
      zL(this.context.objects.CPRCurve.splineBinormals[0], this.context.objects.CPRCurve.splineVec[0], e, t, n);
      const s = ea(this.context.objects.CPRCurve.splineVec, n).nearestIndex;
      return y5(this.context.objects.CPRCurve.splineBinormals[s], t, this.context.objects.CPRCurve.splineNormals[s]);
    }
    return 0;
  }
  getTangentAngle(t, e) {
    if (this.context.getViewWidget(Nt.CPR) && this.context.objects.CPRCurve.splineVec.length > 0) {
      const n = I.create();
      zL(this.context.objects.CPRCurve.splineBinormals[0], this.context.objects.CPRCurve.splineVec[0], e, t, n);
      const s = ea(this.context.objects.CPRCurve.splineVec, n).nearestIndex;
      return y5(this.context.objects.CPRCurve.splineBinormals[s], t, this.context.objects.CPRCurve.splineTangents[s]);
    }
    return 0;
  }
  getCprOffsetOrigin(t, e) {
    const n = ea(this.context.objects.CPRCurve.splineVec, t).nearestIndex, s = I.create();
    I.subtract(s, t, this.context.objects.CPRCurve.splineVec[n]);
    const r = I.dot(s, this.context.objects.CPRCurve.splineNormals[n]), a = I.dot(s, this.context.objects.CPRCurve.splineBinormals[n]), o = I.create();
    return I.scaleAndAdd(
      o,
      this.context.objects.CPRCurve.splineVec[e || n],
      this.context.objects.CPRCurve.splineNormals[e || n],
      r
    ), I.scaleAndAdd(o, o, this.context.objects.CPRCurve.splineBinormals[e || n], a), { origin: o, nearestIndex: n };
  }
}
async function zVt(i, t, e = !1) {
  for (const n of t.constructionInfos) {
    const s = new Int8Array(n.mesh), a = ((y) => [parseFloat(y.r), parseFloat(y.g), parseFloat(y.b)])(n.color), o = 0.8, l = UT();
    l.implantInfo.stlFile.data = s, l.name = n.name, l.color = a, l.opacity = o;
    const c = await i.objects.setupObject(l, e, [0, 0, 0], n.name.endsWith(".ply"), n.name.endsWith(".obj"));
    i.objects.object3DInfos.update((y) => (y.push({
      id: c.id,
      name: l.name,
      visible: !0,
      position: xP(c.actor),
      handleTop: null,
      handleBottom: null,
      centerlineTop: null,
      centerlineBottom: null,
      color: l.color
    }), y));
    const u = c.id, d = new qt(!0), h = new qt(a), p = new qt(o), m = new qt(!1), b = new qt(!1);
    i.objects.watch(d, (y) => {
      i.objects.object3DInfos.update((Z) => {
        for (const g of Z)
          g.id === c.id && (g.visible = y);
        return Z;
      });
    }), i.objects.watch(h, (y) => {
      i.objects.object3DInfos.update((Z) => {
        for (const g of Z)
          g.id === c.id && (g.color = y);
        return Z;
      });
    }), i.objects.object3DInfos.update((y) => {
      for (const Z of y)
        Z.id === c.id && (Z.color = a);
      return y;
    }), i.constructionInfos.set(
      u,
      new X3({
        stlActor: c.actor,
        curveActors: [],
        axisActors: [],
        boundingBoxActor: null,
        coordinateSystemActors: [],
        model: {
          visibility: d,
          stlColor: h,
          stlOpacity: p,
          boundingBoxVisibility: m,
          coordinateSystemVisibility: b
        }
      })
    );
  }
}
var EVt = /* @__PURE__ */ ((i) => (i[i.NONE = 0] = "NONE", i[i.UNDO = 1] = "UNDO", i[i.REDO = 2] = "REDO", i))(EVt || {});
class kVt {
  constructor(t) {
    S(this, "onUndoChange", new se());
    S(this, "maxUndoSteps", 20);
    S(this, "minUndoSteps", 2);
    S(this, "pushState", !1);
    S(this, "maxMemorySize", 2e3 * 1e3);
    // in kB
    S(this, "undoPointer", 0);
    // index of current undo stack
    S(this, "undoList", []);
    S(this, "inUndoRedo", !1);
    S(this, "context");
    S(this, "subscriptions", []);
    this.context = t, this.reset();
    const e = () => this.reset();
    this.context.layoutManager.wizardTabIndex.subscribe(e), this.subscriptions.push(() => {
      this.context.layoutManager.wizardTabIndex.unsubscribe(e);
    });
  }
  undoPointerValue() {
    if (!(this.undoPointer < 0 || this.undoPointer >= this.undoList.length))
      return this.undoList[this.undoPointer];
  }
  delete() {
    this.subscriptions.forEach((t) => t()), this.reset();
  }
  canUndo() {
    if (!this.undoList.length || this.undoPointer <= 0) return !1;
    for (const t of this.context.toolManager.getLayersByPriority()) {
      const e = this.context.toolManager.getToolInstance(t);
      if (e != null && e.supportsUndo) {
        let n = !1, s = 0;
        for (; s < this.undoList.length; )
          n = this.undoList[s].exists(e), ++s;
        if (n)
          break;
        return this.undoPointer > s;
      }
    }
    return !0;
  }
  canRedo() {
    return this.undoList.length ? this.undoPointer < this.undoList.length : !1;
  }
  undoEvent() {
    var t;
    switch ((t = this.undoPointerValue()) == null ? void 0 : t.getUndoEvent()) {
      case ws.NONE:
        return;
      case ws.SCENE_REPAINT:
        this.context.sceneRepaint();
        break;
      case ws.SCENE_REFRESH:
        this.context.sceneRefresh();
        break;
    }
  }
  async undo() {
    if (this.inUndoRedo || !this.canUndo()) return !1;
    this.setProjectState(
      2
      /* DISABLED */
    ), --this.undoPointer;
    const t = this.undoPointerValue();
    if (!t)
      return !1;
    t.getResetTool() && (this.context.toolManager.resetTool(), t.setResetTool(!1)), this.inUndoRedo = !0;
    try {
      await t.undo();
    } finally {
      this.inUndoRedo = !1;
    }
    return this.undoEvent(), this.notifyUndoManagerChange(
      1
      /* UNDO */
    ), this.notifyOnUndoChange(), this.setProjectState(
      1
      /* MODIFIED */
    ), !0;
  }
  async redo() {
    if (this.inUndoRedo || !this.canRedo()) return !1;
    this.setProjectState(
      2
      /* DISABLED */
    );
    const t = this.undoPointerValue();
    if (!t)
      return !1;
    this.inUndoRedo = !0;
    try {
      await t.redo();
    } finally {
      this.inUndoRedo = !1;
    }
    return this.undoEvent(), ++this.undoPointer, this.notifyUndoManagerChange(
      2
      /* REDO */
    ), this.notifyOnUndoChange(), this.setProjectState(
      1
      /* MODIFIED */
    ), !0;
  }
  reset() {
    this.setProjectState(
      2
      /* DISABLED */
    ), this.undoList = [], this.undoPointer = 0, this.notifyUndoManagerChange(
      0
      /* NONE */
    ), this.notifyOnUndoChange(), this.setProjectState(
      1
      /* MODIFIED */
    );
  }
  getMemorySize() {
    let t = 0;
    for (const e of this.undoList)
      t += e.getMemory();
    return t;
  }
  push(t, e, n = !1, s = !1) {
    for (this.warnIfInUndo(), this.undoList.length && this.undoPointer < this.undoList.length && this.undoList.splice(this.undoPointer, this.undoList.length - this.undoPointer); (this.getMemorySize() > this.maxMemorySize && this.undoList.length > this.minUndoSteps || this.undoList.length > this.maxUndoSteps + 1) && !this.removeFirst(); )
      ;
    this.undoList.push(new Z2t(t, e, n, s)), this.undoPointer = this.undoList.length - 1, this.pushState = !0;
  }
  pushPop(t, e, n, s) {
    this.push(n, s), this.add(t, e), this.pop();
  }
  add(t, e, n = !1) {
    var s, r;
    this.warnIfInUndo(), n ? (s = this.undoPointerValue()) == null || s.addFront(t, e) : (r = this.undoPointerValue()) == null || r.add(t, e);
  }
  revertLastAdded() {
    var t;
    if (this.isPush())
      return (t = this.undoPointerValue()) == null ? void 0 : t.revertLast();
  }
  mergePop(t) {
    return this.merge(t) ? (this.pop(), !0) : !1;
  }
  merge(t) {
    if (!this.canUndo())
      return !1;
    this.warnIfInUndo(), --this.undoPointer, this.pushState = !0;
    const e = this.undoPointerValue();
    if (!e)
      return console.error("UndoManager::Merge: stack is null"), !1;
    if (t) {
      const { add: n, description: s, undoEvent: r, resetTool: a, flipStack: o } = t;
      n !== void 0 && e.add(n.undo, n.undoData), s !== void 0 && e.setDescription(s), r !== void 0 && e.setUndoEvent(r), a !== void 0 && e.setResetTool(a), o !== void 0 && e.setFlip(o);
    }
    return !0;
  }
  revert() {
    this.setProjectState(
      2
      /* DISABLED */
    ), this.isPush() ? this.undoList.splice(this.undoPointer, 1) : this.undoList.splice(this.undoPointer - 1, 1), this.undoPointer = this.undoList.length, this.pushState = !1, this.notifyUndoManagerChange(
      0
      /* NONE */
    ), this.notifyOnUndoChange(), this.setProjectState(
      1
      /* MODIFIED */
    );
  }
  pop() {
    this.isPush() && (this.warnIfInUndo(), this.setProjectState(
      2
      /* DISABLED */
    ), ++this.undoPointer, this.pushState = !1, this.notifyUndoManagerPop(0), this.notifyOnUndoChange(), this.setProjectState(
      1
      /* MODIFIED */
    ));
  }
  isPush() {
    return this.pushState;
  }
  removeFirst() {
    if (!this.undoList.length)
      return !1;
    const t = /* @__PURE__ */ new Map(), e = this.context.toolManager.getLayersByPriority();
    for (const s of e) {
      const r = this.context.toolManager.getToolInstance(s);
      if (r != null && r.supportsUndo) {
        let a = 0;
        for (; a < this.undoList.length; ) {
          if (this.undoList[a].exists(r)) {
            t.set(s, a);
            break;
          }
          ++a;
        }
      }
    }
    const n = (s) => s !== this.undoList.length ? (this.undoList.splice(s, 1).forEach((a) => {
      a.delete();
    }), this.undoPointer = this.undoList.length - 1, !0) : !1;
    if (!t.size)
      n(0);
    else
      for (const s of e) {
        let r = t.get(s);
        if (r !== void 0)
          return ++r, n(r);
      }
    return !1;
  }
  onDataRemoved() {
    this.setProjectState(
      2
      /* DISABLED */
    ), this.notifyUndoManagerChange(
      0
      /* NONE */
    ), this.setProjectState(
      1
      /* MODIFIED */
    );
  }
  getRedoDescription() {
    var t;
    return this.canRedo() && ((t = this.undoPointerValue()) == null ? void 0 : t.getDescription()) || "";
  }
  getUndoDescription() {
    var t;
    if (this.canUndo()) {
      --this.undoPointer;
      const e = ((t = this.undoPointerValue()) == null ? void 0 : t.getDescription()) || "";
      return ++this.undoPointer, e;
    }
    return "";
  }
  getList() {
    return this.undoList;
  }
  getMaxUndoSteps() {
    return this.maxUndoSteps;
  }
  setMinUndoSteps(t) {
    this.minUndoSteps = t;
  }
  remove(t, e = !1) {
    if (!this.undoList.length)
      return !1;
    let n = !1;
    for (const o of this.undoList)
      n = n || o.remove(t, e);
    let s = 0, r = this.undoList.length - 1;
    const a = this.undoPointer;
    for (; r >= 0; ) {
      let o = this.undoList[s].getStack().length === 0;
      r === a && this.pushState && (o = !1), !o && r < a && ++s, o && this.undoList.splice(r, 1).forEach((c) => {
        c.delete();
      }), --r;
    }
    return this.undoPointer = s, this.onDataRemoved(), n;
  }
  removeUndoData(t, e = !1) {
    if (!this.undoList.length)
      return !1;
    let n = !1;
    for (const o of this.undoList)
      n = n || o.removeUndoData(t, e);
    let s = 0, r = this.undoList.length - 1;
    const a = this.undoPointer;
    for (; r >= 0; ) {
      let o = this.undoList[s].getStack().length === 0;
      r === a && this.pushState && (o = !1), !o && r < a && ++s, o && this.undoList.splice(r, 1), --r;
    }
    return this.undoPointer = s, this.onDataRemoved(), n;
  }
  setProjectState(t) {
  }
  notifyOnUndoChange() {
    this.onUndoChange.notify();
  }
  notifyUndoManagerChange(t) {
    this.context.toolManager.notifyUndoManagerChange(this, t);
  }
  notifyUndoManagerPop(t) {
    this.context.toolManager.notifyUndoManagerPop(t);
  }
  warnIfInUndo() {
    this.inUndoRedo && console.warn("modifying undo stack from undo/redo operation");
  }
}
const aOt = ["Full", "Centered", "Small", "Invisible"];
var FVt = /* @__PURE__ */ ((i) => (i.Full = "Full", i.Centered = "Centered", i.Small = "Small", i.Invisible = "Invisible", i))(FVt || {});
class jVt {
  constructor(t) {
    S(this, "defaultColors");
    S(this, "general");
    S(this, "implants");
    S(this, "context");
    S(this, "onSettingsModified", new se());
    this.context = t;
    const e = {
      autosaveIntervalMinutes: 5,
      measurementFont: 24,
      topCenterlineSizeOn3dMm: 1.5,
      crossSectionSizeMm: 50,
      bottomCenterlineSizeOn3dMm: 0.5,
      crosshairType: "Full",
      useUSStyleToothChart: !1,
      refreshAll2dWhileMovingObjects: !0,
      useLeftButtonForRotationOn3d: !0,
      snapToImplant: !1,
      showCPRScoutPlane: !1,
      showHintWindow: !0,
      allowTelemetry: !0,
      defaultWindowWidth: 4e3,
      defaultWindowLevel: 1e3
    }, n = {
      showWarningsPopup: !0,
      nerveWarning: !0,
      securityZone: !0,
      minimumDistanceFromNerveMm: 2,
      securityZoneSizeMm: 1.5,
      securityZoneTransparencyPercent: 40,
      showImplantStepButtons: !0,
      showBLAngle: !1,
      showAllAbutmentManufacturers: !1,
      preciseMovementStepMm: 0.25,
      preciseRotationStepDeg: 0.2
    }, s = {
      implant: [0, 255, 0],
      abutment: [255, 170, 0],
      securityZone: [170, 255, 127],
      sleeves: [0, 170, 0],
      nerves: [255, 85, 255],
      collision: [253, 0, 0],
      modelTools: [0, 0, 255],
      teeth: [255, 255, 255],
      prosthesisScanStl: [255, 255, 255],
      teethScanStl: [255, 170, 127],
      guides: [236, 180, 9],
      cprColor: [255, 0, 255]
    };
    this.general = structuredClone(e), this.implants = structuredClone(n), this.defaultColors = structuredClone(s), this.loadFromStorage();
  }
  loadFromStorage() {
    const t = localStorage.getItem("viewerSettings");
    if (!t)
      return;
    const e = JSON.parse(t);
    if (!e)
      return;
    const n = e.general;
    if (n)
      for (const a in this.general)
        n[a] !== void 0 && (this.general[a] = n[a]);
    const s = e.implants;
    if (s)
      for (const a in this.implants)
        s[a] !== void 0 && (this.implants[a] = s[a]);
    const r = e.defaultColors;
    if (r)
      for (const a in this.defaultColors)
        r[a] !== void 0 && (this.defaultColors[a] = r[a]);
  }
  saveToStorage() {
    const t = {
      general: this.general,
      implants: this.implants,
      defaultColors: this.defaultColors
    };
    localStorage.setItem("viewerSettings", JSON.stringify(t));
  }
  update(t) {
    const e = this.general.useUSStyleToothChart, n = t.general.useUSStyleToothChart;
    e !== n && (this.context.objects.convertToothNames(e, n), this.context.projectGeneralData && (this.context.projectGeneralData.useUSToothMap = n)), this.general = t.general, this.implants = t.implants, this.defaultColors = t.defaultColors, this.onSettingsModified.notify(), this.saveToStorage();
  }
  onProjectLoaded() {
    this.context.projectGeneralData && (this.context.projectGeneralData.useUSToothMap = this.general.useUSStyleToothChart);
  }
}
const bB = {
  DISPLAY: 0,
  NORMALIZED_DISPLAY: 1,
  VIEWPORT: 2,
  NORMALIZED_VIEWPORT: 3,
  PROJECTION: 4,
  VIEW: 5,
  WORLD: 6
};
var fB = {
  Coordinate: bB
};
const {
  Coordinate: wn
} = fB, {
  vtkErrorMacro: RM
} = tt;
function UVt(i, t) {
  t.classHierarchy.push("vtkCoordinate"), i.setValue = function() {
    if (t.deleted)
      return RM("instance deleted - cannot call any method"), !1;
    for (var e = arguments.length, n = new Array(e), s = 0; s < e; s++)
      n[s] = arguments[s];
    let r = n;
    if (r.length === 1 && Array.isArray(r[0]) && (r = r[0]), r.length === 2)
      return i.setValue(r[0], r[1], 0), !0;
    if (r.length !== 3)
      throw new RangeError("Invalid number of values for array setter");
    let a = !1;
    return t.value.forEach((o, l) => {
      if (o !== r[l]) {
        if (a)
          return;
        a = !0;
      }
    }), a && (t.value = [].concat(r), i.modified()), !0;
  }, i.setCoordinateSystemToDisplay = () => {
    i.setCoordinateSystem(wn.DISPLAY);
  }, i.setCoordinateSystemToNormalizedDisplay = () => {
    i.setCoordinateSystem(wn.NORMALIZED_DISPLAY);
  }, i.setCoordinateSystemToViewport = () => {
    i.setCoordinateSystem(wn.VIEWPORT);
  }, i.setCoordinateSystemToNormalizedViewport = () => {
    i.setCoordinateSystem(wn.NORMALIZED_VIEWPORT);
  }, i.setCoordinateSystemToProjection = () => {
    i.setCoordinateSystem(wn.PROJECTION);
  }, i.setCoordinateSystemToView = () => {
    i.setCoordinateSystem(wn.VIEW);
  }, i.setCoordinateSystemToWorld = () => {
    i.setCoordinateSystem(wn.WORLD);
  }, i.getCoordinateSystemAsString = () => tt.enumToString(wn, t.coordinateSystem), i.getComputedWorldValue = (e) => {
    let n = t.computedWorldValue;
    if (t.computing)
      return n;
    t.computing = 1, n[0] = t.value[0], n[1] = t.value[1], n[2] = t.value[2];
    let s = e;
    if (t.renderer && (s = t.renderer), !s) {
      if (t.coordinateSystem === wn.WORLD) {
        if (t.referenceCoordinate) {
          const l = t.referenceCoordinate.getComputedWorldValue(s);
          n[0] += l[0], n[1] += l[1], n[2] += l[2];
        }
        t.computing = 0;
      } else
        RM("Attempt to compute world coordinates from another coordinate system without a renderer");
      return n;
    }
    let r = null;
    if (s && s.getRenderWindow().getViews())
      r = s.getRenderWindow().getViews()[0];
    else
      return t.computedWorldValue;
    const a = r.getViewportSize(s), o = a[0] / a[1];
    if (t.referenceCoordinate && t.coordinateSystem !== wn.WORLD) {
      const l = t.referenceCoordinate.getComputedDoubleDisplayValue(s);
      let c = [l[0], l[1], 0];
      switch (t.coordinateSystem) {
        case wn.NORMALIZED_DISPLAY:
          c = r.displayToNormalizedDisplay(c[0], c[1], c[2]);
          break;
        case wn.VIEWPORT:
          c = r.displayToNormalizedDisplay(c[0], c[1], c[2]), c = r.normalizedDisplayToViewport(c[0], c[1], c[2], s);
          break;
        case wn.NORMALIZED_VIEWPORT:
          c = r.displayToNormalizedDisplay(c[0], c[1], c[2]), c = r.normalizedDisplayToViewport(c[0], c[1], c[2], s), c = r.viewportToNormalizedViewport(c[0], c[1], c[2], s);
          break;
        case wn.PROJECTION:
          c = r.displayToNormalizedDisplay(c[0], c[1], c[2]), c = r.normalizedDisplayToViewport(c[0], c[1], c[2], s), c = r.viewportToNormalizedViewport(c[0], c[1], c[2], s), c = s.normalizedViewportToProjection(c[0], c[1], c[2]);
          break;
        case wn.VIEW:
          c = r.displayToNormalizedDisplay(c[0], c[1], c[2]), c = r.normalizedDisplayToViewport(c[0], c[1], c[2], s), c = r.viewportToNormalizedViewport(c[0], c[1], c[2], s), c = s.normalizedViewportToProjection(c[0], c[1], c[2]), c = s.projectionToView(c[0], c[1], c[2], o);
          break;
      }
      n[0] += c[0], n[1] += c[1], n[2] += c[2];
    }
    switch (t.coordinateSystem) {
      case wn.DISPLAY:
        n = r.displayToNormalizedDisplay(n[0], n[1], n[2]), n = r.normalizedDisplayToViewport(n[0], n[1], n[2], s), n = r.viewportToNormalizedViewport(n[0], n[1], n[2], s), n = s.normalizedViewportToProjection(n[0], n[1], n[2]), n = s.projectionToView(n[0], n[1], n[2], o), n = s.viewToWorld(n[0], n[1], n[2]);
        break;
      case wn.NORMALIZED_DISPLAY:
        n = r.normalizedDisplayToViewport(n[0], n[1], n[2], s), n = r.viewportToNormalizedViewport(n[0], n[1], n[2], s), n = s.normalizedViewportToProjection(n[0], n[1], n[2]), n = s.projectionToView(n[0], n[1], n[2], o), n = s.viewToWorld(n[0], n[1], n[2]);
        break;
      case wn.VIEWPORT:
        n = r.viewportToNormalizedViewport(n[0], n[1], n[2], s), n = s.normalizedViewportToProjection(n[0], n[1], n[2]), n = s.projectionToView(n[0], n[1], n[2], o), n = s.viewToWorld(n[0], n[1], n[2]);
        break;
      case wn.NORMALIZED_VIEWPORT:
        n = s.normalizedViewportToProjection(n[0], n[1], n[2]), n = s.projectionToView(n[0], n[1], n[2], o), n = s.viewToWorld(n[0], n[1], n[2]);
        break;
      case wn.PROJECTION:
        n = s.projectionToView(n[0], n[1], n[2], o), n = s.viewToWorld(n[0], n[1], n[2]);
        break;
      case wn.VIEW:
        n = s.viewToWorld(n[0], n[1], n[2]);
        break;
    }
    if (t.referenceCoordinate && t.coordinateSystem === wn.WORLD) {
      const l = i.getComputedWorldValue(s);
      n[0] += l[0], n[1] += l[1], n[2] += l[2];
    }
    return t.computing = 0, t.computedWorldValue = n.slice(0), n;
  }, i.getComputedViewportValue = (e) => {
    const n = i.getComputedDoubleViewportValue(e);
    return [$u(n[0]), $u(n[1])];
  }, i.getComputedDisplayValue = (e) => {
    const n = i.getComputedDoubleDisplayValue(e);
    return [d2(n[0]), d2(n[1])];
  }, i.getComputedLocalDisplayValue = (e) => {
    let n = e;
    t.renderer && (n = t.renderer);
    let s = i.getComputedDisplayValue(n);
    if (!n)
      return RM("Attempt to convert to local display coordinates without a renderer"), s;
    let r = null;
    if (n && n.getRenderWindow().getViews())
      r = n.getRenderWindow().getViews()[0];
    else
      return s;
    return s = r.displayToLocalDisplay(s[0], s[1], s[2]), [$u(s[0]), $u(s[1])];
  }, i.getComputedDoubleViewportValue = (e) => {
    let n = e;
    t.renderer && (n = t.renderer);
    let s = i.getComputedDoubleDisplayValue(n);
    if (!n)
      return s;
    let r = null;
    if (n && n.getRenderWindow().getViews())
      r = n.getRenderWindow().getViews()[0];
    else
      return s;
    return s = r.displayToNormalizedDisplay(s[0], s[1], s[2]), s = r.normalizedDisplayToViewport(s[0], s[1], s[2], n), [s[0], s[1]];
  }, i.getComputedDoubleDisplayValue = (e) => {
    if (t.computing)
      return t.computedDoubleDisplayValue;
    t.computing = 1;
    let n = t.value.slice(0), s = e;
    if (t.renderer && (s = t.renderer), !s) {
      if (t.coordinateSystem === wn.DISPLAY) {
        if (t.computedDoubleDisplayValue[0] = n[0], t.computedDoubleDisplayValue[1] = n[1], t.referenceCoordinate) {
          const l = t.referenceCoordinate.getComputedDoubleDisplayValue();
          t.computedDoubleDisplayValue[0] += l[0], t.computedDoubleDisplayValue[1] += l[1];
        }
      } else
        t.computedDoubleDisplayValue[0] = Number.MAX_VALUE, t.computedDoubleDisplayValue[1] = Number.MAX_VALUE, RM("Request for coordinate transformation without required viewport");
      return t.computedDoubleDisplayValue;
    }
    let r = null;
    if (s && s.getRenderWindow().getViews())
      r = s.getRenderWindow().getViews()[0];
    else
      return n;
    const a = r.getViewportSize(s), o = a[0] / a[1];
    switch (t.coordinateSystem) {
      case wn.WORLD: {
        if (t.referenceCoordinate) {
          const l = t.referenceCoordinate.getComputedWorldValue(s);
          n[0] += l[0], n[1] += l[1], n[2] += l[2];
        }
        n = s.worldToView(n[0], n[1], n[2]), n = s.viewToProjection(n[0], n[1], n[2], o), n = s.projectionToNormalizedViewport(n[0], n[1], n[2]), n = r.normalizedViewportToViewport(n[0], n[1], n[2], s), n = r.viewportToNormalizedDisplay(n[0], n[1], n[2], s), n = r.normalizedDisplayToDisplay(n[0], n[1], n[2]);
        break;
      }
      case wn.VIEW: {
        n = s.viewToProjection(n[0], n[1], n[2], o), n = s.projectionToNormalizedViewport(n[0], n[1], n[2]), n = r.normalizedViewportToViewport(n[0], n[1], n[2], s), n = r.viewportToNormalizedDisplay(n[0], n[1], n[2], s), n = r.normalizedDisplayToDisplay(n[0], n[1], n[2]);
        break;
      }
      case wn.PROJECTION: {
        n = s.projectionToNormalizedViewport(n[0], n[1], n[2]), n = r.normalizedViewportToViewport(n[0], n[1], n[2], s), n = r.viewportToNormalizedDisplay(n[0], n[1], n[2], s), n = r.normalizedDisplayToDisplay(n[0], n[1], n[2]);
        break;
      }
      case wn.NORMALIZED_VIEWPORT: {
        if (n = r.normalizedViewportToViewport(n[0], n[1], n[2], s), t.referenceCoordinate) {
          const l = t.referenceCoordinate.getComputedDoubleViewportValue(s);
          n[0] += l[0], n[1] += l[1];
        }
        n = r.viewportToNormalizedDisplay(n[0], n[1], n[2], s), n = r.normalizedDisplayToDisplay(n[0], n[1], n[2]);
        break;
      }
      case wn.VIEWPORT: {
        if (t.referenceCoordinate) {
          const l = t.referenceCoordinate.getComputedDoubleViewportValue(s);
          n[0] += l[0], n[1] += l[1];
        }
        n = r.viewportToNormalizedDisplay(n[0], n[1], n[2], s), n = r.normalizedDisplayToDisplay(n[0], n[1], n[2]);
        break;
      }
      case wn.NORMALIZED_DISPLAY:
        n = r.normalizedDisplayToDisplay(n[0], n[1], n[2]);
        break;
      case wn.USERDEFINED:
        n = t.value.slice(0);
        break;
    }
    if (t.referenceCoordinate && (t.coordinateSystem === wn.DISPLAY || t.coordinateSystem === wn.NORMALIZED_DISPLAY)) {
      const l = t.referenceCoordinate.getComputedDoubleDisplayValue(s);
      n[0] += l[0], n[1] += l[1];
    }
    return t.computedDoubleDisplayValue[0] = n[0], t.computedDoubleDisplayValue[1] = n[1], t.computing = 0, t.computedDoubleDisplayValue;
  }, i.getComputedValue = (e) => {
    let n = e;
    switch (t.renderer && (n = t.renderer), t.coordinateSystem) {
      case wn.WORLD:
        return i.getComputedWorldValue(n);
      case wn.VIEW:
      case wn.NORMALIZED_VIEWPORT:
      case wn.VIEWPORT: {
        const s = i.getComputedViewportValue(n);
        t.computedWorldValue[0] = s[0], t.computedWorldValue[1] = s[1];
        break;
      }
      case wn.NORMALIZED_DISPLAY:
      case wn.DISPLAY: {
        const s = t.getComputedDisplayValue(n);
        t.computedWorldValue[0] = s[0], t.computedWorldValue[1] = s[1];
        break;
      }
    }
    return t.computedWorldValue;
  };
}
const PVt = {
  coordinateSystem: wn.WORLD,
  value: [0, 0, 0],
  renderer: null,
  referenceCoordinate: null,
  computing: 0,
  computedWorldValue: [0, 0, 0],
  computedDoubleDisplayValue: [0, 0]
};
function gB(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, PVt, e), tt.obj(i, t), tt.set(i, t, ["property"]), tt.get(i, t, ["value"]), tt.setGet(i, t, ["coordinateSystem", "referenceCoordinate", "renderer"]), tt.getArray(i, t, ["value"], 3), UVt(i, t);
}
const JVt = tt.newInstance(gB, "vtkCoordinate");
var cE = {
  newInstance: JVt,
  extend: gB,
  ...fB
};
function AVt(i, t) {
  t.classHierarchy.push("vtkActor2D"), i.getActors2D = () => i, i.getIsOpaque = () => {
    t.property || i.getProperty();
    let e = t.property.getOpacity() >= 1;
    return e = e && (!t.texture || !t.texture.isTranslucent()), e;
  }, i.hasTranslucentPolygonalGeometry = () => t.mapper === null ? !1 : (t.property === null && i.setProperty(i.makeProperty()), !i.getIsOpaque()), i.makeProperty = Wj.newInstance, i.getProperty = () => (t.property === null && (t.property = i.makeProperty()), t.property), i.setDisplayPosition = (e, n) => {
    t.positionCoordinate.setCoordinateSystem(bB.DISPLAY), t.positionCoordinate.setValue(e, n, 0);
  }, i.setWidth = (e) => {
    const n = t.position2Coordinate.getValue();
    t.position2Coordinate.setCoordinateSystemToNormalizedViewport(), t.position2Coordinate.setValue(e, n[1]);
  }, i.setHeight = (e) => {
    const n = t.position2Coordinate.getValue();
    t.position2Coordinate.setCoordinateSystemToNormalizedViewport(), t.position2Coordinate.setValue(n[0], e);
  }, i.getWidth = () => t.position2Coordinate.getValue()[0], i.getHeight = () => t.position2Coordinate.getValue()[1], i.getMTime = () => {
    let e = t.mtime;
    if (t.property !== null) {
      const n = t.property.getMTime();
      e = n > e ? n : e;
    }
    return e = t.positionCoordinate.getMTime() > e ? t.positionCoordinate.getMTime() : e, e = t.positionCoordinate2.getMTime() > e ? t.positionCoordinate2.getMTime() : e, e;
  }, i.getRedrawMTime = () => {
    let e = t.mtime;
    if (t.mapper !== null) {
      let n = t.mapper.getMTime();
      e = n > e ? n : e, t.mapper.getInput() !== null && (t.mapper.getInputAlgorithm().update(), n = t.mapper.getInput().getMTime(), e = n > e ? n : e);
    }
    return e;
  }, i.getBounds = () => typeof i.getMapper().getBounds == "function" ? (t.useBounds = !0, i.getMapper().getBounds()) : (t.useBounds = !1, []), i.getActualPositionCoordinate = () => t.positionCoordinate, i.getActualPositionCoordinate2 = () => t.positionCoordinate2;
}
const BVt = {
  mapper: null,
  property: null,
  layerNumber: 0,
  positionCoordinate: null,
  positionCoordinate2: null
};
function yB(i, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, BVt, e), np.extend(i, t, e), t.positionCoordinate = cE.newInstance(), t.positionCoordinate.setCoordinateSystemToViewport(), t.positionCoordinate2 = cE.newInstance(), t.positionCoordinate2.setCoordinateSystemToNormalizedViewport(), t.positionCoordinate2.setValue(0.5, 0.5), t.positionCoordinate2.setReferenceCoordinate(t.positionCoordinate), tt.set(i, t, ["property"]), tt.setGet(i, t, ["mapper"]), AVt(i, t);
}
const KVt = tt.newInstance(yB, "vtkActor2D");
var LS = {
  newInstance: KVt,
  extend: yB
};
function HVt(i) {
  const t = new _Vt(i), e = i.xRendererVtkJs.extend("xRendererVtkJs", t);
  return new e();
}
class _Vt {
  constructor(t) {
    S(this, "__parent");
    // provided by emscripten when calling extend
    S(this, "renderer", ld.newInstance());
    S(this, "cameraInterface", null);
    S(this, "background", [0, 0, 0]);
    S(this, "background2", [0, 0, 0]);
    S(this, "viewport", [0, 0, 1, 1]);
    S(this, "worldPoint", [0, 0, 0, 0]);
    S(this, "viewPoint", [0, 0, 0]);
    S(this, "normalizedViewPoint", [0, 0, 0]);
    S(this, "normalizedDisplayPoint", [0, 0, 0]);
    S(this, "displayPoint", [0, 0, 0]);
    S(this, "localDisplayPoint", [0, 0]);
    S(this, "hardwareSelector", QA.newInstance());
    S(this, "cellPicker", CU.newInstance({ opacityThreshold: 0.3 }));
    S(this, "actorDataMap", []);
    S(this, "volumeDataMap", []);
    S(this, "sliceDataMap", []);
    S(this, "actor2DDataMap", []);
    S(this, "actor2DImageDataMap", []);
    S(this, "actorSphereMapperDataMap", []);
    S(this, "actorGlyphMapperDataMap", []);
    S(this, "actorMultyGlyphMapperDataMap", []);
    S(this, "actorScalarBarMap", []);
    S(this, "wasmModule");
    S(this, "lastRenderCountAtGetZ", -1);
    S(this, "renderCounter", 0);
    S(this, "oldX", -1);
    S(this, "oldY", -1);
    S(this, "oldZ", 1);
    S(this, "oldIdList", []);
    S(this, "oldPickPropFromRenderCount", -1);
    S(this, "oldVec");
    S(this, "destruct", () => {
      this.renderer.delete();
    });
    S(this, "SetWorldPoint", (t, e, n, s) => {
      this.worldPoint[0] = t, this.worldPoint[1] = e, this.worldPoint[2] = n, this.worldPoint[3] = s;
    });
    S(this, "GetWorldPoint", () => this.worldPoint);
    S(this, "SetViewPoint", (t, e, n) => {
      this.viewPoint[0] = t, this.viewPoint[1] = e, this.viewPoint[2] = n;
    });
    S(this, "GetViewPoint", () => this.viewPoint);
    S(this, "SetDisplayPoint", (t, e, n) => {
      this.displayPoint[0] = t, this.displayPoint[1] = e, this.displayPoint[2] = n;
    });
    S(this, "GetDisplayPoint", () => this.displayPoint);
    S(this, "GetLocalDisplayPoint", () => this.localDisplayPoint);
    S(this, "SetNormalizedViewPoint", (t, e, n) => {
      this.normalizedViewPoint[0] = t, this.normalizedViewPoint[1] = e, this.normalizedViewPoint[2] = n;
    });
    S(this, "GetNormalizedViewPoint", () => this.normalizedViewPoint);
    S(this, "SetNormalizedDisplayPoint", (t, e, n) => {
      this.normalizedDisplayPoint[0] = t, this.normalizedDisplayPoint[1] = e, this.normalizedDisplayPoint[2] = n;
    });
    S(this, "GetNormalizedDisplayPoint", () => this.normalizedDisplayPoint);
    S(this, "WorldToDisplay", () => {
      const t = this.getOpenGLRW();
      if (!t) {
        console.error("openGLRenderWindow not initialized");
        return;
      }
      this.displayPoint = t.worldToDisplay(this.worldPoint[0], this.worldPoint[1], this.worldPoint[2], this.renderer);
    });
    S(this, "ViewToDisplay", () => {
      const t = this.getOpenGLRW();
      if (!t) {
        console.error("openGLRenderWindow not initialized");
        return;
      }
      const e = t.viewToWorld(this.viewPoint[0], this.viewPoint[1], this.viewPoint[2], this.renderer);
      this.displayPoint = t.worldToDisplay(e[0], e[1], e[2], this.renderer);
    });
    S(this, "DisplayToWorld", () => {
      const t = this.getOpenGLRW();
      if (!t) {
        console.error("openGLRenderWindow not initialized");
        return;
      }
      this.worldPoint = [...t.displayToWorld(this.displayPoint[0], this.displayPoint[1], this.displayPoint[2], this.renderer), 1];
    });
    S(this, "ViewToWorld", () => {
      const t = this.getOpenGLRW();
      if (!t) {
        console.error("openGLRenderWindow not initialized");
        return;
      }
      this.worldPoint = [...t.viewToWorld(this.viewPoint[0], this.viewPoint[1], this.viewPoint[2], this.renderer), 1];
    });
    S(this, "WorldToView", () => {
      const t = this.getOpenGLRW();
      if (!t) {
        console.error("openGLRenderWindow not initialized");
        return;
      }
      this.viewPoint = t.worldToView(this.worldPoint[0], this.worldPoint[1], this.worldPoint[2], this.renderer);
    });
    S(this, "DisplayToView", () => {
      const t = this.getOpenGLRW();
      if (!t) {
        console.error("openGLRenderWindow not initialized");
        return;
      }
      const e = t.displayToWorld(this.displayPoint[0], this.displayPoint[1], this.displayPoint[2], this.renderer);
      this.viewPoint = t.worldToView(e[0], e[1], e[2], this.renderer);
    });
    S(this, "ViewToNormalizedViewport", () => {
      const t = this.getOpenGLRW();
      if (!t) {
        console.error("openGLRenderWindow not initialized");
        return;
      }
      this.normalizedViewPoint = t.viewportToNormalizedViewport(this.viewPoint[0], this.viewPoint[1], this.viewPoint[2], this.renderer);
    });
    S(this, "NormalizedViewportToViewport", () => {
      const t = this.getOpenGLRW();
      if (!t) {
        console.error("openGLRenderWindow not initialized");
        return;
      }
      this.viewPoint = t.normalizedViewportToViewport(this.normalizedViewPoint[0], this.normalizedViewPoint[1], this.normalizedViewPoint[2]);
    });
    S(this, "ViewportToNormalizedDisplay", () => {
      const t = this.getOpenGLRW();
      if (!t) {
        console.error("openGLRenderWindow not initialized");
        return;
      }
      this.normalizedDisplayPoint = t.viewportToNormalizedDisplay(this.viewPoint[0], this.viewPoint[1], this.viewPoint[2], this.renderer);
    });
    S(this, "NormalizedDisplayToDisplay", () => {
      const t = this.getOpenGLRW();
      if (!t) {
        console.error("openGLRenderWindow not initialized");
        return;
      }
      this.displayPoint = t.normalizedDisplayToDisplay(this.normalizedDisplayPoint[0], this.normalizedDisplayPoint[1], this.normalizedDisplayPoint[2]);
    });
    S(this, "DisplayToNormalizedDisplay", () => {
      const t = this.getOpenGLRW();
      if (!t) {
        console.error("openGLRenderWindow not initialized");
        return;
      }
      this.normalizedDisplayPoint = t.displayToNormalizedDisplay(this.displayPoint[0], this.displayPoint[1], this.displayPoint[2]);
    });
    S(this, "NormalizedDisplayToViewport", () => {
      const t = this.getOpenGLRW();
      if (!t) {
        console.error("openGLRenderWindow not initialized");
        return;
      }
      this.viewPoint = t.normalizedDisplayToViewport(this.normalizedDisplayPoint[0], this.normalizedDisplayPoint[1], this.normalizedDisplayPoint[2], this.renderer);
    });
    S(this, "ViewportToNormalizedViewport", () => {
      const t = this.getOpenGLRW();
      if (!t) {
        console.error("openGLRenderWindow not initialized");
        return;
      }
      this.normalizedViewPoint = t.viewportToNormalizedViewport(this.viewPoint[0], this.viewPoint[1], this.viewPoint[2], this.renderer);
    });
    S(this, "NormalizedViewportToView", () => {
      const t = this.getOpenGLRW();
      if (!t) {
        console.error("openGLRenderWindow not initialized");
        return;
      }
      this.viewPoint = t.normalizedViewportToViewport(this.normalizedViewPoint[0], this.normalizedViewPoint[1], this.normalizedViewPoint[2]);
    });
    S(this, "DisplayToLocalDisplay", () => {
      const t = this.getOpenGLRW();
      if (!t) {
        console.error("openGLRenderWindow not initialized");
        return;
      }
      const e = t.displayToLocalDisplay(this.displayPoint[0], this.displayPoint[1], this.displayPoint[2]);
      this.localDisplayPoint = [e[0], e[1]];
    });
    S(this, "TransformPoints", (t, e, n, s) => {
      if (t.length !== e.length) {
        console.error("TransformPoints - input and output points must have the same length");
        return;
      }
      let r;
      const a = 5, o = 4, l = 2, c = 0, u = this.getOpenGLRW();
      if (!u) {
        console.error("openGLRenderWindow not initialized Transform Points");
        return;
      }
      if (n == a && s == c)
        r = (d) => {
          e.set(u.worldToDisplay(t[d], t[d + 1], t[d + 2], this.renderer), d);
        };
      else if (n == a && s == l)
        r = (d) => {
          e.set(u.worldToView(t[d], t[d + 1], t[d + 2], this.renderer), d);
        };
      else if (n == c && s == a)
        r = (d) => {
          e.set(u.displayToWorld(t[d], t[d + 1], t[d + 2], this.renderer), d);
        };
      else if (n == a && s == o)
        r = (d) => {
          e.set(u.worldToView(t[d], t[d + 1], t[d + 2], this.renderer), d);
        };
      else if (n == o && s == a)
        r = (d) => {
          e.set(u.viewToWorld(t[d], t[d + 1], t[d + 2], this.renderer), d);
        };
      else if (n == o && s == c)
        r = (d) => {
          const h = u.viewToWorld(t[d], t[d + 1], t[d + 2], this.renderer), p = u.worldToDisplay(h[0], h[1], h[2], this.renderer);
          e.set(p, d);
        };
      else if (n == c && s == o)
        r = (d) => {
          const h = u.displayToWorld(t[d], t[d + 1], t[d + 2], this.renderer), p = u.worldToView(h[0], h[1], h[2], this.renderer);
          e.set(p, d);
        };
      else {
        console.error("TransformPoints - unsupported coordinate system");
        return;
      }
      for (let d = 0; d < t.length; d += 3)
        r(d);
    });
    S(this, "SetBackground", (t, e, n) => {
      this.background = [t, e, n], this.renderer.setBackground(t, e, n, 0.1);
    });
    S(this, "SetBackground2", (t, e, n) => {
      this.background2 = [t, e, n], this.renderer.setBackground(t, e, n, 0.1);
    });
    S(this, "Render", () => {
      this.renderCounter++;
      for (let t of this.actorDataMap)
        VS(t);
      for (let t of this.volumeDataMap)
        uE(t);
      for (let t of this.sliceDataMap)
        dE(t), t.imageData.getDimensions()[0] > 0 && this.renderer.addActor(t.actor);
      for (let t of this.actor2DDataMap) {
        const e = t.actorData.GetPropType();
        e == Mr.eT_LINE_ACTOR || e == Mr.eT_POLY_DATA_SOURCE_ACTOR ? pE(t) : e == Mr.eT_TEXT_ACTOR && hE(t);
      }
      for (let t of this.actor2DImageDataMap)
        mE(t, this.renderer);
      for (let t of this.actorSphereMapperDataMap)
        bE(t);
      for (let t of this.actorMultyGlyphMapperDataMap)
        t.actorData.PrepareMapperProperties();
      for (let t of this.actorGlyphMapperDataMap)
        XS(t);
      for (let t of this.actorScalarBarMap)
        fE(t);
      this.renderer.updateLightsGeometryToFollowCamera();
    });
    S(this, "SetViewport", (t, e, n, s) => {
      this.viewport = [t, e, n, s], this.renderer.setViewport(t, e, n, s);
    });
    S(this, "Modified", () => {
      this.renderer.modified();
    });
    S(this, "AddVolume", (t) => {
      if (t.GetPropType() == 3) {
        const e = xs.newInstance(), n = KI.newInstance(), s = BI.newInstance();
        n.setInputData(e), s.setMapper(n), n.setAutoAdjustSampleDistances(!0), n.setSampleDistance(0.2), n.setMaximumSamplesPerRay(2e3);
        const r = {
          id: t.id,
          actor: s,
          actorData: t,
          imageData: e,
          mapper: n
        };
        uE(r), this.renderer.addVolume(s), this.volumeDataMap.push(r);
      }
    });
    // TODO carefully DO NOT FORGET: you must also sync actor on every Render call and into removeViewProp if necessary!!!!!!!
    S(this, "AddViewProp", (t) => {
      const e = t.GetPropType();
      if (e == Mr.eT_ACTOR) {
        const n = Ie.newInstance(), s = Ue.newInstance(), r = Re.newInstance();
        s.setInputData(n), r.setMapper(s);
        const a = {
          id: t.id,
          actor: r,
          actorData: t,
          polydata: n,
          mapper: s
        };
        VS(a), this.renderer.addViewProp(r), this.actorDataMap.push(a);
      } else if (e == Mr.eT_IMAGE_SLICE) {
        const n = xs.newInstance(), s = jp.newInstance(), r = Up.newInstance();
        s.setInputData(n), r.setMapper(s);
        const a = {
          id: t.id,
          actor: r,
          actorData: t,
          imageData: n,
          mapper: s
        };
        dE(a), this.sliceDataMap.push(a);
      } else if (e == Mr.eT_TEXT_ACTOR) {
        const n = Ie.newInstance(), s = aN.newInstance(), r = LS.newInstance();
        s.setInputData(n), r.setMapper(s);
        const a = {
          id: t.id,
          polydata: n,
          actorData: t,
          mapper: s,
          actor: r
        };
        hE(a), this.renderer.addActor(r), this.actor2DDataMap.push(a);
      } else if (e == Mr.eT_LINE_ACTOR || e == Mr.eT_POLY_DATA_SOURCE_ACTOR) {
        const n = Ie.newInstance(), s = aN.newInstance(), r = LS.newInstance();
        s.setInputData(n), r.setMapper(s);
        const a = {
          id: t.id,
          actor: r,
          actorData: t,
          polydata: n,
          mapper: s
        };
        pE(a), this.renderer.addViewProp(r), this.actor2DDataMap.push(a);
      } else if (e == Mr.eT_IMAGE2D_ACTOR) {
        const n = xs.newInstance(), s = Ie.newInstance(), r = aN.newInstance(), a = LS.newInstance();
        r.setInputData(s), a.setMapper(r);
        const o = {
          id: t.id,
          actor: a,
          actorData: t,
          imageData: n,
          polydata: s,
          mapper: r
        };
        mE(o, this.renderer), this.renderer.addViewProp(a), this.actor2DImageDataMap.push(o);
      } else if (e == Mr.eT_SPHERE_MAPPER_ACTOR) {
        const n = Ie.newInstance(), s = LC.newInstance(), r = Re.newInstance();
        s.setInputData(n), r.setMapper(s);
        const a = {
          id: t.id,
          actor: r,
          actorData: t,
          polydata: n,
          mapper: s
        };
        bE(a), this.renderer.addViewProp(r), this.actorSphereMapperDataMap.push(a);
      } else if (e == Mr.eT_MULTY_GLYPH_MAPPER_ACTOR) {
        t.PrepareMapperProperties();
        const n = t.GetGlyphActorDataViews();
        for (let s = 0; s < n.size(); s++) {
          const r = n.get(s), a = Ie.newInstance(), o = Ie.newInstance(), l = yi.newInstance();
          a.setPoints(l);
          const c = FW.newInstance(), u = Re.newInstance();
          c.setInputData(a), u.setMapper(c), c.setScaleModeToScaleByConstant(), c.setOrientationModeToDirection();
          const d = t.mScalesName;
          d && c.setScaleArray(d), t.mOrientName && c.setOrientationArray(t.mOrientName);
          const h = {
            id: t.id,
            childId: r.id,
            actor: u,
            actorData: r,
            polydata: a,
            polydataSource: o,
            mapper: c
          };
          XS(h), this.renderer.addViewProp(u), this.actorGlyphMapperDataMap.push(h);
        }
        this.actorMultyGlyphMapperDataMap.push({ id: t.id, actorData: t });
      } else if (e == Mr.eT_GLYPH_MAPPER_ACTOR) {
        t.PrepareMapperProperties();
        const n = Ie.newInstance(), s = Ie.newInstance(), r = yi.newInstance();
        n.setPoints(r);
        const a = FW.newInstance(), o = Re.newInstance();
        a.setInputData(n), o.setMapper(a), a.setScaleModeToScaleByConstant(), a.setOrientationModeToDirection();
        const l = t.mScalesName;
        l && a.setScaleArray(l), t.mOrientName && a.setOrientationArray(t.mOrientName);
        const c = {
          id: t.id,
          childId: t.id,
          actor: o,
          actorData: t,
          polydata: n,
          polydataSource: s,
          mapper: a
        };
        XS(c), this.renderer.addViewProp(o), this.actorGlyphMapperDataMap.push(c);
      } else if (e == Mr.eT_SCALAR_BAR_ACTOR) {
        const n = FI.newInstance(), s = {
          id: t.id,
          actor: n,
          actorData: t
        };
        fE(s), this.renderer.addViewProp(n), this.actorScalarBarMap.push(s);
      } else e == Mr.eT_GLYPH2D_MAPPER_ACTOR ? console.warn("This is Glyph2d actor that is not supported in web!!!!!!!") : console.log("Adding view Prop JS pType:", e);
    });
    S(this, "RemoveAllViewProps", () => {
      this.renderer.removeAllViewProps(), this.actorDataMap = [], this.actor2DDataMap = [], this.actor2DImageDataMap = [], this.volumeDataMap = [], this.sliceDataMap = [], this.actorSphereMapperDataMap = [], this.actorGlyphMapperDataMap = [], this.actorMultyGlyphMapperDataMap = [], this.actorScalarBarMap = [];
    });
    S(this, "RemoveViewProp", (t) => {
      let e = this.actorDataMap.findIndex((n) => n.id == t);
      if (e != -1 && (this.renderer.removeViewProp(this.actorDataMap[e].actor), this.actorDataMap.splice(e, 1)), e = this.actor2DDataMap.findIndex((n) => n.id == t), e != -1 && (this.renderer.removeViewProp(this.actor2DDataMap[e].actor), this.actor2DDataMap.splice(e, 1)), e = this.actor2DImageDataMap.findIndex((n) => n.id == t), e != -1 && (this.renderer.removeViewProp(this.actor2DImageDataMap[e].actor), this.actor2DImageDataMap.splice(e, 1)), e = this.volumeDataMap.findIndex((n) => n.id == t), e != -1 && (this.renderer.removeViewProp(this.volumeDataMap[e].actor), this.volumeDataMap.splice(e, 1)), e = this.sliceDataMap.findIndex((n) => n.id == t), e != -1 && (this.renderer.removeViewProp(this.sliceDataMap[e].actor), this.sliceDataMap.splice(e, 1)), e = this.actorSphereMapperDataMap.findIndex((n) => n.id == t), e != -1 && (this.renderer.removeViewProp(this.actorSphereMapperDataMap[e].actor), this.actorSphereMapperDataMap.splice(e, 1)), e = this.actorScalarBarMap.findIndex((n) => n.id == t), e != -1 && (this.renderer.removeViewProp(this.actorScalarBarMap[e].actor), this.actorScalarBarMap.splice(e, 1)), e = this.actorMultyGlyphMapperDataMap.findIndex((n) => n.id == t), e != -1) {
        const s = this.actorMultyGlyphMapperDataMap[e].actorData.GetGlyphActorDataViews();
        for (let r = 0; r < s.size(); r++)
          this.RemoveViewProp(s.get(r).id);
        this.actorMultyGlyphMapperDataMap.splice(e, 1);
      }
      e = this.actorGlyphMapperDataMap.findIndex((n) => n.childId == t), e != -1 && (this.renderer.removeViewProp(this.actorGlyphMapperDataMap[e].actor), this.actorGlyphMapperDataMap.splice(e, 1));
    });
    S(this, "SetActiveCamera", (t) => {
      this.cameraInterface = t, this.renderer.setActiveCamera(t.camera);
    });
    S(this, "GetActiveCamera", () => {
      if (!this.cameraInterface)
        throw new Error("Camera interface not set");
      return this.cameraInterface;
    });
    S(this, "ResetCamera", (t, e, n, s, r, a) => {
      this.Render(), this.renderer.resetCamera([t, e, n, s, r, a]);
    });
    S(this, "SetLayer", (t) => {
      this.renderer.setLayer(t);
    });
    S(this, "InteractiveOff", () => {
      this.renderer.setInteractive(!1);
    });
    S(this, "EraseOn", () => {
      this.renderer.setErase(!0);
    });
    S(this, "ComputeVisiblePropBounds", () => (this.Render(), this.renderer.computeVisiblePropBounds()));
    S(this, "GetVtkRenderWindow", () => this.renderer.getRenderWindow());
    S(this, "GetOrigin", () => {
      const t = this.renderer.getViewport();
      return [t[0], t[1]];
    });
    S(this, "ResetCameraClippingRange", (t, e, n, s, r, a) => {
      this.renderer.resetCameraClippingRange([t, e, n, s, r, a]);
    });
    S(this, "GetBackground", () => this.background);
    S(this, "GetBackground2", () => this.background2);
    S(this, "GetCenter", () => {
      let t = [0, 0];
      const e = this.getOpenGLRW();
      return e ? t = e.getViewportCenter(this.renderer) : console.error("openGLRenderWindow not initialized"), t;
    });
    S(this, "SetUseDepthPeeling", (t) => {
      this.renderer.setUseDepthPeeling(t);
    });
    S(this, "SetMaximumNumberOfPeels", (t) => {
      this.renderer.setMaximumNumberOfPeels(t);
    });
    S(this, "SetOcclusionRatio", (t) => {
      this.renderer.setOcclusionRatio(t);
    });
    S(this, "GetViewProps", () => {
      const t = [], e = this.renderer.getViewProps();
      for (let s of e) {
        const r = this.GetActorDataCombinedByActor(s);
        r && t.push(r.id);
      }
      const n = new this.wasmModule.VectorInt();
      return t.forEach((s) => {
        n.push_back(s);
      }), n;
    });
    S(this, "PickPropFrom", (t, e, n) => {
      const s = [], r = [];
      for (let a = 0; a < n.size(); a++) {
        const o = this.GetActorDataCombinedById(n.get(a));
        o && (o.actor.getPickable() != o.actorData.GetPickable() && o.actor.setPickable(o.actorData.GetPickable()), o.actor.getVisibility() != o.actorData.GetVisibility() && o.actor.setVisibility(o.actorData.GetVisibility()), r.push(o.id));
      }
      if (ybt(r, this.oldIdList) && this.renderCounter == this.oldPickPropFromRenderCount)
        return this.oldVec;
      {
        this.SetPickableToList(r), this.oldIdList = r, this.oldPickPropFromRenderCount = this.renderCounter;
        const a = this.hardwareSelectorPick(t, e, !1);
        if (a && a.length) {
          const c = a[0].getProperties().prop;
          if (c) {
            const u = this.GetActorDataCombinedByActor(c);
            u && r.includes(u.id) ? s.push(u.id) : console.log("PickPropFrom this.hardwareSelectorPick id :", u == null ? void 0 : u.id, " is not in selection list");
          }
        }
        this.SetPickableToList(r, !0);
        const o = new this.wasmModule.VectorInt();
        for (let l of s)
          o.push_back(l);
        if (this.oldVec)
          try {
            this.oldVec.delete();
          } catch (l) {
            console.log(l);
          }
        return this.oldVec = o, o;
      }
    });
    S(this, "SetPickableToList", (t, e) => {
      for (let n of this.volumeDataMap)
        n.actor.setPickable(!1);
      for (let n of this.actorDataMap)
        t.includes(n.id) || (e ? n.actor.setPickable(!!n.pickableRestore) : (n.pickableRestore = n.actor.getPickable(), n.actor.setPickable(!1)));
    });
    S(this, "GetZ", (t, e) => {
      if (t == this.oldX && e == this.oldY && this.lastRenderCountAtGetZ == this.renderCounter)
        return this.oldZ;
      {
        this.oldX = t, this.oldY = e, this.lastRenderCountAtGetZ = this.renderCounter;
        const n = this.hardwareSelectorPick(t, e, !0);
        if (n && n.length) {
          const s = n[0].getProperties();
          if (s.prop) {
            const a = s.displayPosition;
            if (a)
              return this.oldZ = a[2], a[2];
          }
        }
      }
      return 1;
    });
    S(this, "GetWindowDPI", () => 72);
    S(this, "RemoveAllLights", () => {
      this.renderer.removeAllLights();
    });
    S(this, "UpdateLightsGeometryToFollowCamera", () => {
      this.renderer.updateLightsGeometryToFollowCamera();
    });
    S(this, "IsActiveCameraCreated", () => this.renderer.isActiveCameraCreated());
    S(this, "GetActorDataCombinedIndexById", (t) => this.actorDataMap.findIndex((e) => e.id == t) || this.actor2DDataMap.findIndex((e) => e.id == t) || this.actor2DImageDataMap.findIndex((e) => e.id == t) || this.volumeDataMap.findIndex((e) => e.id == t) || this.sliceDataMap.findIndex((e) => e.id == t) || this.actorSphereMapperDataMap.findIndex((e) => e.id == t) || this.actorMultyGlyphMapperDataMap.findIndex((e) => e.id == t) || this.actorScalarBarMap.findIndex((e) => e.id == t));
    S(this, "GetActorDataCombinedById", (t) => this.actorDataMap.find((e) => e.id == t) || this.actor2DDataMap.find((e) => e.id == t) || this.actor2DImageDataMap.find((e) => e.id == t) || this.volumeDataMap.find((e) => e.id == t) || this.sliceDataMap.find((e) => e.id == t) || this.actorSphereMapperDataMap.find((e) => e.id == t) || this.actorGlyphMapperDataMap.find((e) => e.id == t) || this.actorScalarBarMap.find((e) => e.id == t));
    S(this, "GetActorDataCombinedByActor", (t) => this.actorDataMap.find((e) => e.actor == t) || this.actor2DDataMap.find((e) => e.actor == t) || this.actor2DImageDataMap.find((e) => e.actor == t) || this.volumeDataMap.find((e) => e.actor == t) || this.sliceDataMap.find((e) => e.actor == t) || this.actorSphereMapperDataMap.find((e) => e.actor == t) || this.actorGlyphMapperDataMap.find((e) => e.actor == t) || this.actorScalarBarMap.find((e) => e.actor == t));
    // GetFixedSizeScale = (pt: number[], radiiIn3D: number, sizeInPixels: number, sizeInPixelsTol: number) => {
    //     const oglrw = this.getOpenGLRW();
    //     if (!oglrw) {
    //         console.error("openGLRenderWindow not initialized");
    //         return;
    //     }
    //
    //     const pPtH = vec3.fromValues(pt[0], pt[1], pt[2]);
    //     console.log("RendererInterface GetFixedSizeScale 0", pPtH);
    //     const pPtD = oglrw.worldToDisplay(pPtH[0], pPtH[1], pPtH[2], this.renderer);
    //     console.log("RendererInterface GetFixedSizeScale 1", pPtD);
    //     const pViewUp = this.renderer.getActiveCamera().getViewUp();
    //     console.log("RendererInterface GetFixedSizeScale 2 pViewUp", pViewUp);
    //
    //     const pPtHC = vec3.create();
    //     vec3.scaleAndAdd(pPtHC, pPtH, pViewUp, radiiIn3D);
    //     console.log("RendererInterface GetFixedSizeScale 3", pPtHC);
    //
    //     const pPtCD = oglrw.worldToDisplay(pPtHC[0], pPtHC[1], pPtHC[2], this.renderer);
    //     console.log("RendererInterface GetFixedSizeScale 4", pPtCD);
    //
    //     // Size in Pixels
    //     const currentSizeInPixels = Math.sqrt(vtkMath.distance2BetweenPoints(pPtCD, pPtD));
    //     console.log("RendererInterface GetFixedSizeScale 5 currentSizeInPixels", currentSizeInPixels);
    //     const displayRadius = sizeInPixels / 2.0;
    //     const radiusTolerance = sizeInPixelsTol / 2.0;
    //     if (Math.abs(currentSizeInPixels - displayRadius) > radiusTolerance) {
    //         // Adjust size
    //         const pPtDX = vec3.create();
    //         pPtDX[0] = pPtD[0] + displayRadius;
    //         pPtDX[1] = pPtD[1];
    //         pPtDX[2] = pPtD[2];
    //
    //         console.log("RendererInterface GetFixedSizeScale 6 displayRadius", displayRadius);
    //         console.log("RendererInterface GetFixedSizeScale 6 pPtDX", pPtDX);
    //
    //         // Display To World
    //         const pPtHX = oglrw.displayToWorld(pPtDX[0], pPtDX[1], pPtDX[2], this.renderer);
    //         console.log("RendererInterface GetFixedSizeScale 7 ", pPtDX);
    //         console.log("RendererInterface GetFixedSizeScale: ", Math.sqrt(vtkMath.distance2BetweenPoints(pPtHX, pPtH as Vector3)) / radiiIn3D);
    //
    //         return Math.sqrt(vtkMath.distance2BetweenPoints(pPtHX, pPtH as Vector3)) / radiiIn3D;
    //     }
    //     return 1.0;
    // }
    // TODO add orientation and zoom
    S(this, "GetScreenshot", async (t, e, n, s) => {
      if (t.GetPropType() == Mr.eT_ACTOR) {
        console.log("Adding PolyData Actor or 2dActor");
        const a = Ie.newInstance(), o = Ue.newInstance(), l = Re.newInstance();
        o.setInputData(a), l.setMapper(o);
        const c = {
          id: t.id,
          actor: l,
          actorData: t,
          polydata: a,
          mapper: o
        };
        VS(c);
        let u = "front";
        switch (e) {
          case 0:
            u = "front";
            break;
          case 1:
            u = "back";
            break;
          case 2:
            u = "left";
            break;
          case 3:
            u = "right";
            break;
          case 4:
            u = "top";
            break;
          case 5:
            u = "bottom";
            break;
        }
        const d = 300, h = 300, p = [0.2, 0.204, 0.216, 0];
        l.setVisibility(!0);
        const m = ip.newInstance();
        m.setParallelProjection(!0), X0({
          camera: m,
          orientation: u,
          focalPoint: l.getOrigin(),
          distance: 1
        }), vg({
          actor: l,
          camera: m,
          width: d,
          height: h,
          background: p,
          zoom: n
        }).then((b) => {
          s.opcall(b || ""), l.delete(), o.delete();
        });
      }
    });
    this.wasmModule = t;
  }
  hardwareSelectorPick(t, e, n, s) {
    const r = this.getOpenGLRW();
    return r ? this.hardwareSelector ? (this.hardwareSelector.setCaptureZValues(n ?? !1), this.hardwareSelector.setFieldAssociation(f0.FIELD_ASSOCIATION_CELLS), this.hardwareSelector.attach(r, this.renderer), this.hardwareSelector.setArea(t, e, t, e), this.hardwareSelector.select({ captureAttributeIds: s ?? !1 })) : (console.error("hardwareSelector not initialized"), null) : (console.error("window not initialized"), null);
  }
  getOpenGLRW() {
    var t;
    return (t = this.renderer.getRenderWindow()) == null ? void 0 : t.getViews()[0];
  }
}
function VS(i) {
  if (i.actor.getVisibility() != i.actorData.GetVisibility() && i.actor.setVisibility(i.actorData.GetVisibility()), i.actorData.GetVisibility()) {
    if (i.actorData.PrepareModifiedFlags(), i.actorData.mPolyModified && VT(i.actorData, i.polydata, !1), i.actorData.mPropModified) {
      i.actorData.PrepareActorProperties(), i.actor.getPickable() != i.actorData.mPickable && i.actor.setPickable(i.actorData.mPickable);
      const t = i.actor.getPosition(), e = i.actorData.mPosition;
      (t[0] != e[0] || t[1] != e[1] || t[2] != e[2]) && i.actor.setPosition(e[0], e[1], e[2]);
      const n = i.actor.getScale(), s = i.actorData.mScale;
      (n[0] != s[0] || n[1] != s[1] || n[2] != s[2]) && i.actor.setScale(s[0], s[1], s[2]);
      const r = i.actor.getProperty();
      if (r.getOpacity() != i.actorData.mOpacity && r.setOpacity(i.actorData.mOpacity), r.getColor() != i.actorData.mColor && r.setColor(i.actorData.mColor[0], i.actorData.mColor[1], i.actorData.mColor[2]), r.getLineWidth() != i.actorData.mLineWidth && r.setLineWidth(i.actorData.mLineWidth), r.getSpecular() != i.actorData.mSpecular && r.setSpecular(i.actorData.mSpecular), r.getDiffuse() != i.actorData.mDiffuse && r.setDiffuse(i.actorData.mDiffuse), r.getAmbient() != i.actorData.mAmbient && r.setAmbient(i.actorData.mAmbient), r.getSpecularPower() != i.actorData.mSpecularPower && r.setSpecularPower(i.actorData.mSpecularPower), r.getEdgeVisibility() != i.actorData.mEdgeVisibility && r.setEdgeVisibility(i.actorData.mEdgeVisibility), r.getRepresentation() != i.actorData.mRepresentation && r.setRepresentation(i.actorData.mRepresentation), r.getInterpolation() != i.actorData.mInterpolation && r.setInterpolation(i.actorData.mInterpolation), i.actorData.mHasBFProperties) {
        let a = i.actor.getBackfaceProperty();
        a || (a = V0.newInstance(), i.actor.setBackfaceProperty(a)), a.getOpacity() != i.actorData.mOpacityBF && a.setOpacity(i.actorData.mOpacityBF), a.getColor() != i.actorData.mColorBF && a.setColor(i.actorData.mColorBF[0], i.actorData.mColorBF[1], i.actorData.mColorBF[2]), a.getSpecular() != i.actorData.mSpecularBF && a.setSpecular(i.actorData.mSpecularBF), a.getDiffuse() != i.actorData.mDiffuseBF && a.setDiffuse(i.actorData.mDiffuseBF), a.getAmbient() != i.actorData.mAmbientBF && a.setAmbient(i.actorData.mAmbientBF), a.getSpecularPower() != i.actorData.mSpecularPowerBF && a.setSpecularPower(i.actorData.mSpecularPowerBF), a.getEdgeVisibility() != i.actorData.mEdgeVisibilityBF && a.setEdgeVisibility(i.actorData.mEdgeVisibilityBF), a.getRepresentation() != i.actorData.mRepresentationBF && a.setRepresentation(i.actorData.mRepresentationBF), a.getInterpolation() != i.actorData.mInterpolationBF && a.setInterpolation(i.actorData.mInterpolationBF);
      }
    }
    if (i.actorData.mMapperModified) {
      i.actorData.PrepareMapperProperties(), i.mapper.getScalarVisibility() != i.actorData.mScalarVisibility && i.mapper.setScalarVisibility(i.actorData.mScalarVisibility), i.mapper.getScalarMode() != i.actorData.mScalarMode && i.mapper.setScalarMode(i.actorData.mScalarMode), i.mapper.getColorMode() != i.actorData.mColorMode && i.mapper.setColorMode(i.actorData.mColorMode), i.mapper.getInterpolateScalarsBeforeMapping() != i.actorData.mInterpolateScalarsBeforeMapping && i.mapper.setInterpolateScalarsBeforeMapping(i.actorData.mInterpolateScalarsBeforeMapping), i.mapper.getColorByArrayName() != i.actorData.mMapperArrayName && i.mapper.setColorByArrayName(i.actorData.mMapperArrayName);
      const t = i.actorData.mMapperScalarRange;
      (i.mapper.getScalarRange()[0] != t[0] || i.mapper.getScalarRange()[1] != t[1]) && i.mapper.setScalarRange(t);
    }
    if (i.actorData.mClippingPlanesModified) {
      i.mapper.removeAllClippingPlanes();
      const t = i.actorData.GetClippingPlanesView(), e = t.length / 6, n = [];
      for (let s = 0; s < e; s++) {
        const r = li.newInstance();
        r.setOrigin(t[s * 6], t[s * 6 + 1], t[s * 6 + 2]), r.setNormal(t[s * 6 + 3], t[s * 6 + 4], t[s * 6 + 5]), n.push(r);
      }
      t && i.mapper.setClippingPlanes(n);
    }
    if (i.actorData.mHasLookupTable && i.actorData.mLookupTableModified) {
      const t = i.actorData.GetLookupTableView();
      UF(t, i.mapper, !1), t.delete();
    }
    if (i.actorData.mHasTexture) {
      if (i.actorData.mTextureModified) {
        const t = jF(i.actorData, !1);
        i.actor.removeAllTextures(), i.actor.addTexture(t);
      }
    } else
      i.actor.removeAllTextures();
    if (i.actorData.mMatrixModified) {
      const t = i.actorData.GetUserMatrix(), e = ut.fromValues(
        t[0],
        t[4],
        t[8],
        t[12],
        t[1],
        t[5],
        t[9],
        t[13],
        t[2],
        t[6],
        t[10],
        t[14],
        t[3],
        t[7],
        t[11],
        t[15]
      );
      i.actor.setUserMatrix(e);
    }
  }
}
function uE(i) {
  if (i.actor.getVisibility() != i.actorData.GetVisibility() && i.actor.setVisibility(i.actorData.GetVisibility()), i.actorData.GetVisibility()) {
    if (i.actorData.PrepareModifiedFlags(), i.actorData.mImageModified) {
      const t = i.actorData.GetImageDataView();
      Go(t, i.imageData), t.delete();
    }
    if (i.actorData.mPropModified && (i.actorData.PrepareActorProperties(), i.actor.setPickable(!1)), i.actorData.mImageDataCTFModified) {
      const t = i.actorData.GetImageDataLookupTableView();
      itt(t, i.actor, !0), t.delete();
    }
    if (i.actorData.mImageDataPWFModified) {
      const t = i.actorData.GetImageDataOpacityFunctionView();
      stt(t, i.actor, !0), t.delete();
    }
    i.actorData.mImageDataPropertyModified && (i.actorData.PrepareVolumePropertyProperties(), i.actor.getProperty().setShade(i.actorData.mVolumeShading), i.actor.getProperty().setSpecular(i.actorData.mVolumeSpecular), i.actor.getProperty().setDiffuse(i.actorData.mVolumeDiffuse), i.actor.getProperty().setAmbient(i.actorData.mVolumeAmbient), i.actor.getProperty().setSpecularPower(i.actorData.mVolumeSpecularPower), i.actor.getProperty().setInterpolationType(Uh.LINEAR), i.mapper.setBlendModeToComposite());
  }
}
function dE(i, t) {
  if (i.actor.getVisibility() != i.actorData.GetVisibility() && i.actor.setVisibility(i.actorData.GetVisibility()), i.actorData.GetVisibility()) {
    if (i.actorData.PrepareModifiedFlags(), i.actorData.mSliceModified) {
      const e = i.actorData.GetSliceView();
      Go(e, i.imageData), i.imageData.modified(), e.delete(), i.actor.setUserMatrix(i.actorData.mResliceMatrix);
    }
    if (i.actorData.mPropModified && (i.actorData.PrepareActorProperties(), i.actor.getPickable() != i.actorData.mPickable && i.actor.setPickable(i.actorData.mPickable), i.actor.getProperty().getColorWindow() != i.actorData.mWindow && i.actor.getProperty().setColorWindow(i.actorData.mWindow), i.actor.getProperty().getColorLevel() != i.actorData.mLevel && i.actor.getProperty().setColorLevel(i.actorData.mLevel)), i.actorData.mHasLookupTable && i.actorData.mLookupTableModified) {
      i.actor.getProperty().setColorLevel(0.5), i.actor.getProperty().setColorWindow(1);
      const e = L0.newInstance();
      e.addRGBPoint(0, 0, 0, 0), e.addRGBPoint(1, 0, 1, 0), i.actor.getProperty().setRGBTransferFunction(0, e);
      const n = Bh.newInstance();
      n.addPoint(0, 0), n.addPoint(1, 0.3), i.actor.getProperty().setScalarOpacity(0, n), i.actor.getProperty().setInterpolationTypeToNearest();
    }
  }
}
function hE(i) {
  let t;
  if (i.actor.getVisibility() != i.actorData.GetVisibility() && i.actor.setVisibility(i.actorData.GetVisibility()), i.actorData.GetVisibility() && (i.actorData.PrepareModifiedFlags(), i.actorData.mPolyModified && VT(i.actorData, i.polydata, !1), i.actorData.mTextureModified && (t = jF(i.actorData, !1), i.actor.removeAllTextures(), i.actor.addTexture(t)), i.actorData.mPropModified)) {
    i.actorData.PrepareActorProperties();
    let e = i.actorData.mDisplayPosition;
    i.actor.setDisplayPosition(e[0], e[1]), i.actor.getVisibility() != i.actorData.mVisibility && i.actor.setVisibility(i.actorData.mVisibility), i.actor.getPickable() != i.actorData.mPickable && i.actor.setPickable(i.actorData.mPickable), i.actor.getProperty().getColor() != i.actorData.mColor && i.actor.getProperty().setColor(i.actorData.mColor[0], i.actorData.mColor[1], i.actorData.mColor[2]);
  }
}
function pE(i) {
  if (i.actor.getVisibility() != i.actorData.GetVisibility() && i.actor.setVisibility(i.actorData.GetVisibility()), i.actorData.GetVisibility()) {
    if (i.actorData.PrepareModifiedFlags(), i.actorData.mPolyModified && VT(i.actorData, i.polydata, !1), i.actorData.mPropModified) {
      i.actorData.PrepareActorProperties(), i.actor.getPickable() != i.actorData.mPickable && i.actor.setPickable(i.actorData.mPickable);
      const t = i.actor.getProperty();
      t.getColor() != i.actorData.mColor && t.setColor(i.actorData.mColor[0], i.actorData.mColor[1], i.actorData.mColor[2]), t.getLineWidth() != i.actorData.mLineWidth && t.setLineWidth(i.actorData.mLineWidth), t.getOpacity() != i.actorData.mOpacity && t.setOpacity(i.actorData.mOpacity);
    }
    i.actorData.mMapperModified && (i.actorData.PrepareMapperProperties(), i.mapper.getScalarVisibility() != i.actorData.mScalarVisibility && i.mapper.setScalarVisibility(i.actorData.mScalarVisibility));
  }
}
function mE(i, t) {
  if (i.actor.getVisibility() != i.actorData.GetVisibility() && i.actor.setVisibility(i.actorData.GetVisibility()), i.actorData.GetVisibility()) {
    if (i.actorData.PrepareModifiedFlags(), i.actorData.mImageModified) {
      const e = i.actorData.GetImageDataView();
      Go(e, i.imageData), e.delete();
      const n = i.imageData.getDimensions(), s = yi.newInstance();
      s.setNumberOfComponents(3), s.setData(new Float32Array([0, 0, 0, 0, n[1], 0, n[0], n[1], 0, n[0], 0, 0])), i.polydata.setPoints(s);
      const r = Ii.newInstance();
      r.setNumberOfComponents(4), r.setData(new Uint32Array([3, 0, 1, 2, 3, 0, 2, 3])), i.polydata.setPolys(r);
      const a = We.newInstance({
        name: "Texture Coordinates",
        values: new Float32Array([0, 0, 0, 1, 1, 1, 1, 0]),
        numberOfComponents: 2
      });
      i.polydata.getPointData().setTCoords(a);
      const o = vc.newInstance();
      o.setInputData(i.imageData), i.actor.addTexture(o), i.mapper.setScalarVisibility(!1);
    }
    if (i.actorData.mPropModified) {
      i.actorData.PrepareActorProperties(), i.actor.getPickable() != i.actorData.mPickable && i.actor.setPickable(i.actorData.mPickable);
      const e = i.actorData.mDisplayPosition;
      i.actor.setDisplayPosition(e[0], e[1]);
    }
    i.actorData.mMapperModified && i.actorData.PrepareMapperProperties();
  }
}
function bE(i) {
  if (i.actor.getVisibility() != i.actorData.GetVisibility() && i.actor.setVisibility(i.actorData.GetVisibility()), i.actorData.GetVisibility()) {
    if (i.actorData.PrepareModifiedFlags(), i.actorData.mPolyModified && VT(i.actorData, i.polydata, !1), i.actorData.mPropModified) {
      i.actorData.PrepareActorProperties(), i.actor.getPickable() != i.actorData.mPickable && i.actor.setPickable(i.actorData.mPickable);
      const t = i.actor.getProperty();
      t.getOpacity() != i.actorData.mOpacity && t.setOpacity(i.actorData.mOpacity);
    }
    if (i.actorData.mMapperModified) {
      i.actorData.PrepareMapperProperties();
      const t = i.actorData.mScalesName;
      t ? i.mapper.setScaleArray(t) : i.actorData.mRadius && i.mapper.setRadius(i.actorData.mRadius);
    }
    if (i.actorData.mMatrixModified) {
      const t = i.actorData.GetUserMatrix(), e = ut.fromValues(
        t[0],
        t[4],
        t[8],
        t[12],
        t[1],
        t[5],
        t[9],
        t[13],
        t[2],
        t[6],
        t[10],
        t[14],
        t[3],
        t[7],
        t[11],
        t[15]
      );
      i.actor.setUserMatrix(e);
    }
  }
}
function XS(i, t) {
  if (i.actor.getVisibility() != i.actorData.GetVisibility() && i.actor.setVisibility(i.actorData.GetVisibility()), i.actorData.GetVisibility()) {
    if (i.actorData.PrepareModifiedFlags(), (i.actorData.mMapperModified || i.actorData.mPolyModified) && (i.actorData.PrepareMapperProperties(), VT(i.actorData, i.polydata, !1)), i.actorData.mSourceModified) {
      const e = i.actorData.GetSourceDataView();
      WI(e, i.polydataSource, !1), i.mapper.setInputData(i.polydataSource, 1), e.delete();
    }
    if (i.actorData.mPropModified) {
      i.actorData.PrepareActorProperties(), i.actor.getPickable() != i.actorData.mPickable && i.actor.setPickable(i.actorData.mPickable);
      const e = i.actor.getProperty();
      e.getOpacity() != i.actorData.mOpacity && e.setOpacity(i.actorData.mOpacity);
    }
    if (i.actorData.mMatrixModified) {
      const e = i.actorData.GetUserMatrix(), n = ut.fromValues(
        e[0],
        e[4],
        e[8],
        e[12],
        e[1],
        e[5],
        e[9],
        e[13],
        e[2],
        e[6],
        e[10],
        e[14],
        e[3],
        e[7],
        e[11],
        e[15]
      );
      i.actor.setUserMatrix(n);
    }
  }
}
function fE(i) {
  if (i.actorData.PrepareModifiedFlags(), i.actorData.mLookupTableModified || i.actorData.mPropModified) {
    if (i.actorData.PrepareActorProperties(), i.actorData.mHasLookupTable) {
      const t = i.actorData.GetLookupTableView(), e = UF(t, void 0, !0), n = (a, o) => {
        const [l, c] = a, [u, d] = o;
        return (h) => (h - l) / (c - l) * (d - u) + u;
      }, s = (a, o) => (l) => {
        try {
          const c = l.getLastTickBounds(), u = n(c, [0, 1]), d = a.map((h) => u(h));
          l.setTicks(a), l.setTickStrings(o);
        } catch (c) {
          console.error("Error in generateTicks:", c);
        }
      };
      let r = t.GetAnnotations();
      if (r.size() > 0) {
        const a = t.GetXRGBPointsFlatVector().slice(), o = [];
        for (let c = 0; c < a.length; c += 4)
          o.push(a[c]);
        const l = [];
        for (let c = 0; c < r.size(); c++)
          l.push(r.get(c));
        i.actor.setGenerateTicks(s(o, l));
      }
      t.delete(), e && i.actor.setScalarsToColors(e);
    }
    i.actor.setAxisLabel(i.actorData.mAxisLabel), i.actor.setAutomated(!0), i.actor.setDrawNanAnnotation(!1), i.actor.setDrawAboveRangeSwatch(!0), i.actor.modified();
  }
}
class QVt {
  constructor() {
    S(this, "container");
    S(this, "listeners", []);
    S(this, "eventBridge", null);
    S(this, "firstTouchDown", !0);
    S(this, "touchButton", 0);
    S(this, "activeTouche", null);
    // Multi-touch state
    S(this, "touches", /* @__PURE__ */ new Map());
    S(this, "pinchActive", !1);
    S(this, "pinchMove", !1);
    S(this, "maxButton", 0);
    S(this, "lastPinchDistance", null);
    S(this, "pinchWheelAccum", 0);
    S(this, "twoFingersAccum", 0);
    S(this, "lastY", 0);
  }
  bindEvents(t) {
    const e = (s, r) => {
      t.addEventListener(s, r), this.listeners.push([t, s, r, !1]);
    }, n = (s, r) => {
      document.addEventListener(s, r, !0), this.listeners.push([document, s, r, !0]);
    };
    e("contextmenu", (s) => this.onContextMenu(s)), e("wheel", (s) => this.onMouseWheel(s)), e("DOMMouseScroll", (s) => this.onMouseWheel(s)), e("mousedown", (s) => this.onMouseDown(s)), e("mouseup", (s) => this.onMouseUp(s)), e("pointerdown", (s) => this.onPointerDown(s)), e("pointerup", (s) => this.onPointerUp(s)), e("pointermove", (s) => this.onPointerMove(s)), e("touchstart", (s) => this.onTouchStart(s)), e("touchmove", (s) => this.onTouchMove(s)), e("touchend", (s) => this.onTouchEnd(s)), e("pointerout", (s) => this.onPointerOut(s)), n("keypress", (s) => this.onKeyPress(s)), n("keydown", (s) => this.onKeyDown(s)), n("keyup", (s) => this.onKeyUp(s)), this.container = t;
  }
  unbindEvents() {
    this.listeners.forEach(([t, e, n, s]) => {
      t.removeEventListener(e, n, s);
    }), this.listeners = [];
  }
  bindEventBridge(t) {
    this.eventBridge = t, console.log("bindEventBridge");
  }
  unbindEventBridge() {
    console.log("unbindEventBridge"), this.eventBridge = null;
  }
  async dispatchBridgeEvent(t) {
    const e = this.eventBridge;
    if (e)
      try {
        await t(e);
      } catch (n) {
        console.warn("CAD event bridge call failed", n);
      }
  }
  modifierKeys(t) {
    let e = 0;
    return t.shiftKey && (e |= 2), t.ctrlKey && (e |= 4), t.altKey && (e |= 8), t.metaKey && (e |= 16), e;
  }
  mouseButtons(t) {
    let e = 0;
    return t.buttons & 1 ? e |= 1 : t.buttons & 2 ? e |= 2 : t.buttons & 4 ? e |= 4 : t.buttons & 8 ? e |= 8 : t.buttons & 16 && (e |= 16), e;
  }
  mouseButton(t) {
    return t.button === 0 ? 1 : t.button === 2 ? 2 : t.button === 1 ? 4 : t.button === 3 ? 8 : t.button === 4 ? 16 : 1;
  }
  // Helper: get button for N fingers
  fingerCountToButton(t) {
    return t === 1 ? 1 : t === 2 ? 2 : t === 3 ? 4 : 1;
  }
  // Helper: get offset for a touch
  getTouchOffset(t, e) {
    const n = e.getBoundingClientRect();
    return {
      offsetX: t.clientX - n.left,
      offsetY: t.clientY - n.top
    };
  }
  // Helper: centroid of current touches relative to target
  getTouchesCenter(t) {
    const e = t.getBoundingClientRect();
    let n = 0, s = 0;
    const r = this.touches.size;
    if (r === 0) return { offsetX: 0, offsetY: 0 };
    for (const { clientX: a, clientY: o } of this.touches.values())
      n += a, s += o;
    return {
      offsetX: n / r - e.left,
      offsetY: s / r - e.top
    };
  }
  getPinchDistance() {
    if (this.touches.size !== 2) return null;
    const t = Array.from(this.touches.values()), e = t[0].clientX - t[1].clientX, n = t[0].clientY - t[1].clientY;
    return Math.hypot(e, n);
  }
  invertY(t) {
    return this.container.clientHeight - 1 - t;
  }
  onContextMenu(t) {
    t.preventDefault();
  }
  async onMouseWheel(t) {
    let e = -t.deltaY;
    e == 0 && (e = -t.deltaX), await this.dispatchBridgeEvent(
      (n) => n.HandleMouseWheel(t.offsetX, this.invertY(t.offsetY), e, this.mouseButtons(t), this.modifierKeys(t))
    ), t.preventDefault();
  }
  async onMouseDown(t) {
    await this.dispatchBridgeEvent((e) => e.HandleMouseDown(t.offsetX, this.invertY(t.offsetY), this.mouseButton(t), this.modifierKeys(t))), t.preventDefault();
  }
  async onTouchStart(t) {
    if (!t.target) return;
    const e = t.target;
    for (let r = 0; r < t.changedTouches.length; r++) {
      const a = t.changedTouches[r];
      this.touches.set(a.identifier, { clientX: a.clientX, clientY: a.clientY });
    }
    const n = this.touches.size || t.touches.length, s = t.touches[0] || t.changedTouches[0];
    if (s) {
      const { offsetX: r, offsetY: a } = this.getTouchOffset(s, e);
      if (this.firstTouchDown)
        this.firstTouchDown = !1, await this.dispatchBridgeEvent((o) => o.HandleMouseMove(r, this.invertY(a), 0, this.modifierKeys(t))), this.touchButton = this.fingerCountToButton(n), this.maxButton = this.touchButton, this.activeTouche = {
          id: s.identifier,
          button: this.touchButton,
          offsetX: r,
          offsetY: a
        }, this.touchButton != 2 && await this.dispatchBridgeEvent((o) => o.HandleMouseDown(r, this.invertY(a), this.touchButton, this.modifierKeys(t)));
      else {
        const o = this.fingerCountToButton(n), l = this.getTouchesCenter(e);
        await this.dispatchBridgeEvent(
          (c) => c.HandleMouseUp(l.offsetX, this.invertY(l.offsetY), this.touchButton, this.modifierKeys(t))
        ), o != 2 && !this.pinchActive && o !== this.touchButton && (this.touchButton = o, this.maxButton = this.touchButton, await this.dispatchBridgeEvent(
          (c) => c.HandleMouseDown(l.offsetX, this.invertY(l.offsetY), this.touchButton, this.modifierKeys(t))
        ));
      }
    }
    this.touches.size === 2 && this.lastPinchDistance === null && (this.lastPinchDistance = this.getPinchDistance(), this.pinchWheelAccum = 0), this.twoFingersAccum = 0, t.preventDefault();
  }
  async onTouchEnd(t) {
    if (!t.target || this.firstTouchDown) return;
    const e = t.target;
    if (!this.pinchMove && this.maxButton == 2) {
      const r = t.changedTouches[0], { offsetX: a, offsetY: o } = r ? this.getTouchOffset(r, e) : { offsetX: 0, offsetY: 0 };
      await this.dispatchBridgeEvent((l) => l.HandleMouseDown(a, this.invertY(o), 2, this.modifierKeys(t))), await this.dispatchBridgeEvent((l) => l.HandleMouseUp(a, this.invertY(o), 2, this.modifierKeys(t)));
    }
    for (let r = 0; r < t.changedTouches.length; r++) {
      const a = t.changedTouches[r];
      this.touches.delete(a.identifier);
    }
    this.touches.size < 2 && (this.pinchActive = !1, this.lastPinchDistance = null, this.pinchWheelAccum = 0), this.twoFingersAccum = 0, this.pinchMove = !1;
    const n = this.touches.size;
    if (n === 0) {
      const r = t.changedTouches[0], { offsetX: a, offsetY: o } = r ? this.getTouchOffset(r, e) : { offsetX: 0, offsetY: 0 };
      await this.dispatchBridgeEvent((l) => l.HandleMouseUp(a, this.invertY(o), this.touchButton, this.modifierKeys(t))), this.firstTouchDown = !0, this.touchButton = 0, this.activeTouche = null, this.touches.clear(), this.lastPinchDistance = null, this.pinchActive = !1, this.pinchWheelAccum = 0, this.twoFingersAccum = 0, t.preventDefault();
      return;
    }
    const s = this.fingerCountToButton(n);
    if (s != 2 && !this.pinchActive && s !== this.touchButton) {
      const r = this.getTouchesCenter(e);
      await this.dispatchBridgeEvent(
        (a) => a.HandleMouseUp(r.offsetX, this.invertY(r.offsetY), this.touchButton, this.modifierKeys(t))
      ), this.touchButton = s, await this.dispatchBridgeEvent(
        (a) => a.HandleMouseDown(r.offsetX, this.invertY(r.offsetY), this.touchButton, this.modifierKeys(t))
      );
    }
    t.preventDefault();
  }
  async onTouchMove(t) {
    if (!t.target) return;
    const e = t.target;
    this.touches.clear();
    for (let s = 0; s < t.touches.length; s++) {
      const r = t.touches[s];
      this.touches.set(r.identifier, { clientX: r.clientX, clientY: r.clientY });
    }
    if (this.touches.size === 2) {
      const s = this.getPinchDistance();
      if (s !== null) {
        this.lastPinchDistance === null && (this.lastPinchDistance = s);
        const r = s - this.lastPinchDistance;
        if (this.lastPinchDistance = s, this.pinchWheelAccum += r, Math.abs(this.pinchWheelAccum) >= 20) {
          if (this.pinchMove = !0, !this.pinchActive && this.touchButton !== 0) {
            const c = this.getTouchesCenter(e);
            await this.dispatchBridgeEvent(
              (u) => u.HandleMouseUp(c.offsetX, this.invertY(c.offsetY), this.touchButton, this.modifierKeys(t))
            ), this.touchButton = 0;
          }
          this.pinchActive = !0;
          const o = this.getTouchesCenter(e), l = this.pinchWheelAccum;
          await this.dispatchBridgeEvent(
            (c) => c.HandleMouseWheel(o.offsetX, this.invertY(o.offsetY), l, 0, this.modifierKeys(t))
          ), this.pinchWheelAccum = 0, t.preventDefault();
          return;
        }
      }
    }
    const n = t.touches[0] || t.changedTouches[0];
    if (n) {
      let s, r;
      if (this.touches.size == 3) {
        const a = this.getTouchesCenter(e);
        s = a.offsetX, r = a.offsetY;
      } else {
        const a = this.getTouchOffset(n, e);
        s = a.offsetX, r = a.offsetY;
      }
      this.touches.size == 2 || await this.dispatchBridgeEvent((a) => a.HandleMouseMove(s, this.invertY(r), this.touchButton, this.modifierKeys(t)));
    }
    t.preventDefault();
  }
  async onMouseUp(t) {
    await this.dispatchBridgeEvent((e) => e.HandleMouseUp(t.offsetX, this.invertY(t.offsetY), this.mouseButton(t), this.modifierKeys(t))), t.preventDefault();
  }
  async onPointerDown(t) {
    t.pointerType === "mouse" || t.pointerType === "touch" || (await this.dispatchBridgeEvent((e) => e.HandleMouseDown(t.offsetX, this.invertY(t.offsetY), this.mouseButton(t), this.modifierKeys(t))), t.preventDefault());
  }
  async onPointerUp(t) {
    t.pointerType === "mouse" || t.pointerType === "touch" || (await this.dispatchBridgeEvent((e) => e.HandleMouseUp(t.offsetX, this.invertY(t.offsetY), this.mouseButton(t), this.modifierKeys(t))), t.preventDefault());
  }
  async onPointerMove(t) {
    await this.dispatchBridgeEvent(
      (e) => e.HandleMouseMove(t.offsetX, this.invertY(t.offsetY), this.mouseButtons(t), this.modifierKeys(t))
    ), t.preventDefault();
  }
  async onKeyPress(t) {
    await this.dispatchBridgeEvent((e) => e.HandleKeyPress(t.key, this.modifierKeys(t)));
  }
  async onKeyDown(t) {
    t.repeat || await this.dispatchBridgeEvent((e) => e.HandleKeyDown(t.key, this.modifierKeys(t)));
  }
  async onKeyUp(t) {
    await this.dispatchBridgeEvent((e) => e.HandleKeyUp(t.key, this.modifierKeys(t)));
  }
  async onPointerOut(t) {
    await this.dispatchBridgeEvent((e) => e.KillFocus());
  }
}
const $Vt = "webcad:webgl-context-event";
function ZB(i, t) {
  const e = (n) => {
    const s = n, r = {
      type: s.type,
      label: t,
      statusMessage: s.statusMessage || void 0,
      canvasWidth: i.width,
      canvasHeight: i.height,
      clientWidth: i.clientWidth,
      clientHeight: i.clientHeight
    };
    window.dispatchEvent(new CustomEvent($Vt, { detail: r }));
  };
  return i.addEventListener("webglcontextlost", e), i.addEventListener("webglcontextrestored", e), () => {
    i.removeEventListener("webglcontextlost", e), i.removeEventListener("webglcontextrestored", e);
  };
}
function qVt(i, t, e, n) {
  const s = new tXt(t, e, n), r = i.xRenderWindowVtkJs.extend("xRenderWindowVtkJs", s);
  return new r();
}
class tXt {
  constructor(t, e, n) {
    S(this, "__parent");
    S(this, "container");
    S(this, "context");
    S(this, "renderWindow");
    S(this, "renderers", []);
    S(this, "eventHandler");
    S(this, "openglRenderWindow");
    S(this, "commonId");
    S(this, "renderWindowId");
    S(this, "interactor");
    S(this, "destructed", !1);
    S(this, "removeWebGLContextEventForwarding");
    S(this, "destruct", () => {
      var t, e, n, s, r;
      this.destructed || ((t = this.removeWebGLContextEventForwarding) == null || t.call(this), this.removeWebGLContextEventForwarding = void 0, (e = this.eventHandler) == null || e.unbindEvents(), (n = this.eventHandler) == null || n.unbindEventBridge(), (s = this.interactor) == null || s.unbindEvents(), (r = this.interactor) == null || r.delete(), this.interactor = void 0, this.renderWindow && (this.renderers.forEach((a) => {
        var o;
        (o = this.renderWindow) == null || o.removeRenderer(a.renderer);
      }), this.renderers = [], this.renderWindow.removeView(this.openglRenderWindow)), this.openglRenderWindow.setContainer(null), this.context.contextCAD.mRenderWindowsCADIDs.get(this.commonId) === this.renderWindowId && this.context.contextCAD.mRenderWindowsCADIDs.delete(this.commonId), this.context.contextCAD.mUsedRenderWindows = Math.max(0, this.context.contextCAD.mUsedRenderWindows - 1), this.renderWindow = void 0, this.destructed = !0);
    });
    S(this, "Render", () => {
      var t;
      this.destructed || (this.renderers.forEach((e) => e.Render()), (t = this.renderWindow) == null || t.render());
    });
    S(this, "AddRenderer", (t) => {
      var e;
      this.renderers.push(t), (e = this.renderWindow) == null || e.addRenderer(t.renderer), t.SetViewport(0, 0, 1, 1);
    });
    S(this, "RemoveRenderer", (t) => {
      var n;
      const e = this.renderers.indexOf(t);
      e > -1 && (this.renderers.splice(e, 1), (n = this.renderWindow) == null || n.removeRenderer(t.renderer));
    });
    S(this, "FindPokedRenderer", (t, e) => {
      var r;
      const n = (r = this.renderWindow) == null ? void 0 : r.getInteractor().findPokedRenderer(t, e), s = this.renderers.find((a) => a.renderer === n);
      return s || 0;
    });
    S(this, "BindEvents", (t) => {
      this.eventHandler.bindEventBridge(t);
    });
    S(this, "UnbindEvents", () => {
      this.eventHandler.unbindEventBridge();
    });
    S(this, "GetRenderWindowEventHandler", () => this.eventHandler);
    S(this, "SetSize", (t, e) => {
      var n;
      if (!this.destructed && this.container && this.openglRenderWindow) {
        this.openglRenderWindow.setSize(t, e);
        const s = this.container.getElementsByTagName("canvas")[0];
        if (this.addWebGLContextEventForwarding(), !s)
          return;
        s.classList.add("all-radius-8"), s.style.width = t + "px", s.style.height = e + "px", (n = this.renderWindow) == null || n.render();
      }
    });
    S(this, "SetNumberOfLayers", (t) => {
      var e;
      (e = this.renderWindow) == null || e.setNumberOfLayers(t);
    });
    S(this, "SetRenderQuality", (t, e) => {
      var s;
      const n = (s = this.renderWindow) == null ? void 0 : s.getInteractor();
      n && (n.setStillUpdateRate(e), n.setDesiredUpdateRate(t));
    });
    this.container = t, this.context = e, this.commonId = n;
    const s = this.context.contextCAD.mUsedRenderWindows;
    this.renderWindowId = s, this.context.contextCAD.mRenderWindowsCAD.has(s) || this.context.contextCAD.mRenderWindowsCAD.set(s, YT.newInstance()), this.context.contextCAD.mRenderWindowsCADIDs.set(this.commonId, s), this.context.contextCAD.mOGLRenderWindowsCAD.has(s) || this.context.contextCAD.mOGLRenderWindowsCAD.set(s, vT.newInstance());
    const r = this.context.contextCAD.mRenderWindowsCAD.get(s);
    if (r)
      this.renderWindow = r;
    else
      throw new Error("ERROR: Unrecognized renderWindow");
    const a = this.context.contextCAD.mOGLRenderWindowsCAD.get(s);
    if (a)
      this.openglRenderWindow = a;
    else
      throw new Error("ERROR: Unrecognized OGLrenderWindow");
    this.context.contextCAD.mUsedRenderWindows++, this.openglRenderWindow.setContainer(t), this.renderWindow.addView(this.openglRenderWindow), this.openglRenderWindow.setSize(t.clientWidth, t.clientHeight), this.addWebGLContextEventForwarding(), this.eventHandler = new QVt(), this.eventHandler.bindEvents(t), this.interactor = RT.newInstance(), this.interactor.setView(this.openglRenderWindow), this.interactor.initialize();
  }
  addWebGLContextEventForwarding() {
    if (this.removeWebGLContextEventForwarding)
      return;
    const t = this.container.getElementsByTagName("canvas")[0];
    t && (this.removeWebGLContextEventForwarding = ZB(t, `cad-${this.commonId}`));
  }
}
function eXt(i) {
  const t = new nXt(i), e = i.xCameraVtkJs.extend("xCameraVtkJs", t);
  return new e();
}
class nXt {
  constructor(t) {
    S(this, "__parent");
    // provided by emscripten when calling extend
    S(this, "camera", ip.newInstance());
    S(this, "modifiedCallbacks", []);
    // for JS renderer interface to listen for camera changes
    S(this, "wasmModule");
    S(this, "Azimuth", (t) => {
      this.camera.azimuth(t);
    });
    S(this, "Elevation", (t) => {
      this.camera.elevation(t);
    });
    S(this, "OrthogonalizeViewUp", () => {
      this.camera.orthogonalizeViewUp();
    });
    S(this, "Modified", () => {
      this.camera.modified();
      for (const t of this.modifiedCallbacks)
        t();
    });
    S(this, "SetViewUp", (t, e, n) => {
      this.camera.setViewUp(t, e, n);
    });
    S(this, "SetFocalPoint", (t, e, n) => {
      this.camera.setFocalPoint(t, e, n);
    });
    S(this, "SetPosition", (t, e, n) => {
      this.camera.setPosition(t, e, n);
    });
    S(this, "Dolly", (t) => {
      this.camera.dolly(t);
    });
    S(this, "Zoom", (t) => {
      this.camera.zoom(t);
    });
    S(this, "Roll", (t) => {
      this.camera.roll(t);
    });
    S(this, "SetClippingRange", (t, e) => {
      this.camera.setClippingRange(t, e);
    });
    S(this, "GetClippingRange", () => this.camera.getClippingRange());
    S(this, "SetViewAngle", (t) => {
      this.camera.setViewAngle(t);
    });
    S(this, "SetDistance", (t) => {
      this.camera.setDistance(t);
    });
    S(this, "ParallelProjectionOn", () => {
      this.camera.setParallelProjection(!0);
    });
    S(this, "SetParallelProjection", (t) => {
      this.camera.setParallelProjection(t);
    });
    S(this, "SetParallelScale", (t) => {
      this.camera.setParallelScale(t);
    });
    S(this, "SetWindowCenter", (t, e) => {
      this.camera.setWindowCenter(t, e);
    });
    S(this, "ViewingRaysModified", () => {
      this.Modified();
    });
    S(this, "GetCompositeProjectionTransformMatrix", (t, e, n) => this.camera.getCompositeProjectionMatrix(t, e, n));
    S(this, "GetModelViewTransformMatrix", () => this.camera.getViewMatrix());
    S(this, "GetFocalPoint", () => this.camera.getFocalPoint());
    S(this, "GetPosition", () => this.camera.getPosition());
    S(this, "GetViewUp", () => this.camera.getViewUp());
    S(this, "GetViewPlaneNormal", () => this.camera.getViewPlaneNormal());
    S(this, "GetViewAngle", () => this.camera.getViewAngle());
    S(this, "GetDistance", () => this.camera.getDistance() || 0);
    S(this, "GetParallelProjection", () => this.camera.getParallelProjection());
    S(this, "GetParallelScale", () => this.camera.getParallelScale());
    S(this, "GetDirectionOfProjection", () => this.camera.getDirectionOfProjection());
    this.wasmModule = t;
  }
}
function iXt(i, t, e) {
  const n = new sXt(i, t, e), s = i.x3DToolbarCADHandlerJS.extend("x3DToolbarCADHandlerJS", n);
  return new s();
}
class sXt {
  constructor(t, e, n) {
    S(this, "__parent");
    S(this, "context", null);
    S(this, "wasmModule");
    S(this, "events");
    S(this, "UpdateToolbar", (t, e, n, s, r, a, o, l, c, u, d, h, p, m) => {
      this.events.UpdateToolbarEvent.notify({
        showImplantButtons: t,
        showScoutButtons: e,
        showAnatomyProsthesisButtons: n,
        showGuideButtons: s,
        showSmileDesignButtons: r,
        showTeethButtons: a,
        showSectionalViewButtons: o,
        showExtrusionButtons: l,
        showDicomButtons: c,
        showAllExtrusionButtons: u,
        sleeveOnlyButtons: d,
        showGridButton: h,
        showESButtons: p,
        smileDesignPreviewButtons: m
      });
    });
    S(this, "LockGridChanged", (t) => {
      this.events.LockGridChangedEvent.notify(t);
    });
    S(this, "SetBtnShowAllTeethVisibility", (t) => {
      this.events.SetBtnShowAllTeethVisibilityEvent.notify(t);
    });
    S(this, "SetBtnShowMaxillaryTeethVisibility", (t) => {
      this.events.SetBtnShowMaxillaryTeethVisibilityEvent.notify(t);
    });
    S(this, "SetBtnShowMandibularTeethVisibility", (t) => {
      this.events.SetBtnShowMandibularTeethVisibilityEvent.notify(t);
    });
    S(this, "SetBtnShowNoneVisibility", (t) => {
      this.events.SetBtnShowNoneVisibilityEvent.notify(t);
    });
    S(this, "SetProsthesisButtonVisibility", (t) => {
      this.events.SetProsthesisButtonVisibility.notify(t);
    });
    S(this, "SetUndercutButtonVisibility", (t) => {
      this.events.SetUndercutButtonVisibility.notify(t);
    });
    this.wasmModule = t, e && (this.context = e), this.events = n;
  }
}
const rXt = /* @__PURE__ */ Ne({
  __name: "ViewWidgetToolbarCAD",
  props: {
    context: {},
    handler: {},
    events: {}
  },
  setup(i) {
    aa();
    const t = i, e = An(), n = Lt(!1), s = Lt(!1), r = Lt(!1), a = Lt(!1), o = Lt(!1), l = Lt(!1), c = Lt(!1), u = Lt(!1), d = Lt(!1), h = Lt(!1), p = Lt(!0), m = Lt(!0), b = Lt(!0), y = Lt(!0), Z = Lt(!0), g = Lt(!0), f = Lt(!1), T = Lt(!1), M = Lt(!1), N = Lt(!1);
    xn(() => {
      e.onEvent(t.events.UpdateToolbarEvent, (Zt) => {
        r.value = Zt.showImplantButtons, o.value = Zt.showScoutButtons, l.value = Zt.showAnatomyProsthesisButtons, c.value = Zt.showGuideButtons, u.value = Zt.showSmileDesignButtons, h.value = Zt.showTeethButtons, f.value = Zt.showSectionalViewButtons, T.value = Zt.showExtrusionButtons, n.value = Zt.showDicomButtons, a.value = Zt.sleeveOnlyButtons, s.value = Zt.showGridButton, M.value = Zt.showAllExtrusionButtons, N.value = Zt.showESButtons, d.value = Zt.smileDesignPreviewButtons;
      }), e.onEvent(t.events.LockGridChangedEvent, (Zt) => {
      }), e.onEvent(t.events.SetBtnShowAllTeethVisibilityEvent, (Zt) => {
        p.value = Zt;
      }), e.onEvent(t.events.SetBtnShowMaxillaryTeethVisibilityEvent, (Zt) => {
        m.value = Zt;
      }), e.onEvent(t.events.SetBtnShowMandibularTeethVisibilityEvent, (Zt) => {
        b.value = Zt;
      }), e.onEvent(t.events.SetBtnShowNoneVisibilityEvent, (Zt) => {
        y.value = Zt;
      }), e.onEvent(t.events.SetProsthesisButtonVisibility, (Zt) => {
        Z.value = Zt;
      }), e.onEvent(t.events.SetUndercutButtonVisibility, (Zt) => {
        g.value = Zt;
      });
    }), yr(() => e.cleanupAll());
    const W = () => {
      t.handler.ToggleFullscreen();
    }, x = () => {
      t.handler.ToggleVolumeVisibility();
    }, V = () => {
      t.handler.ToggleImplantsVisibility();
    }, X = () => {
      t.handler.ToggleAbutmentsVisibility();
    }, C = () => {
      t.handler.ToggleSleevesVisibility();
    }, R = () => {
      t.handler.ShowScoutPlanes();
    }, z = () => {
      t.handler.ShowScoutLines();
    }, F = () => {
      t.handler.HideScout();
    }, P = () => {
      t.handler.ShowAllTeeth();
    }, j = () => {
      t.handler.ShowMaxillaryTeethOnly();
    }, H = () => {
      t.handler.ShowMandibularTeethOnly();
    }, B = () => {
      t.handler.ShowNoneTeeth();
    }, $ = () => {
      t.handler.ToggleAnatomyVisibility();
    }, A = () => {
      t.handler.ToggleProsthesisVisibility();
    }, E = () => {
      t.handler.ToggleUndercutVisibility();
    }, ct = () => {
      t.handler.ToggleGuideVisibility();
    }, at = () => {
      t.handler.ToggleExtrusionsVisibility();
    }, dt = () => {
      t.handler.ToggleSupportsVisibility();
    }, gt = () => {
      t.handler.ToggleSmileDesign();
    }, Wt = () => {
      t.handler.ToggleSmileSetupPreview();
    };
    return (Zt, Gt) => (Mt(), le(Cg, null, {
      default: oe(() => [
        Pt(K(ye), {
          isToolbarButton: !0,
          iconSrc: "/icons/new_icons/toolbar_3d/ik_fullscreen_28.svg",
          onClick: W,
          tooltip: K(jt)("medic-web-engine.toggleFullscreen")
        }, null, 8, ["tooltip"]),
        n.value ? (Mt(), le(K(ye), {
          key: 0,
          isToolbarButton: !0,
          iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg",
          onClick: x,
          tooltip: K(jt)("medic-web-engine.showHideDicom")
        }, null, 8, ["tooltip"])) : Qt("", !0),
        u.value && n.value ? (Mt(), le(K(ye), {
          key: 1,
          isToolbarButton: !0,
          iconSrc: "/cad/smiledesign/ik_smileDesign_128.png",
          onClick: gt,
          tooltip: K(jt)("medic-web-engine.showHideSmileSetupView"),
          iconSrcHeight: "26px",
          iconSrcWidth: "26px"
        }, null, 8, ["tooltip"])) : Qt("", !0),
        d.value ? (Mt(), le(K(ye), {
          key: 2,
          isToolbarButton: !0,
          iconSrc: "/cad/smiledesign/ik_smileDesignPreview_128.png",
          onClick: Wt,
          tooltip: K(jt)("medic-web-engine.showHideSmileSetupPreview"),
          iconSrcHeight: "26px",
          iconSrcWidth: "26px"
        }, null, 8, ["tooltip"])) : Qt("", !0),
        r.value ? (Mt(), Ot(Me, { key: 3 }, [
          a.value ? Qt("", !0) : (Mt(), le(K(ye), {
            key: 0,
            isToolbarButton: !0,
            iconSrc: "/icons/new_icons/toolbar_3d/ik_implant_28.svg",
            onClick: V,
            tooltip: K(jt)("medic-web-engine.showHideImplants")
          }, null, 8, ["tooltip"])),
          a.value ? Qt("", !0) : (Mt(), le(K(ye), {
            key: 1,
            isToolbarButton: !0,
            iconSrc: "/icons/new_icons/toolbar_3d/ik_abutment_28.svg",
            onClick: X,
            tooltip: K(jt)("medic-web-engine.showHideAbutments")
          }, null, 8, ["tooltip"])),
          Pt(K(ye), {
            isToolbarButton: !0,
            iconSrc: "/icons/new_icons/toolbar_3d/ik_sleeve_28.svg",
            onClick: C,
            tooltip: K(jt)("medic-web-engine.showHideSleeves")
          }, null, 8, ["tooltip"])
        ], 64)) : Qt("", !0),
        o.value ? (Mt(), Ot(Me, { key: 4 }, [
          Pt(K(ye), {
            isToolbarButton: !0,
            iconSrc: "/icons/new_icons/toolbar_3d/ik_scout1_28.svg",
            onClick: R,
            tooltip: K(jt)("medic-web-engine.showScoutPlanes")
          }, null, 8, ["tooltip"]),
          Pt(K(ye), {
            isToolbarButton: !0,
            iconSrc: "/icons/new_icons/toolbar_3d/ik_scout2_28.svg",
            onClick: z,
            tooltip: K(jt)("medic-web-engine.showScoutLines")
          }, null, 8, ["tooltip"]),
          Pt(K(ye), {
            isToolbarButton: !0,
            iconSrc: "/icons/new_icons/toolbar_3d/ik_scout3_28.svg",
            onClick: F,
            tooltip: K(jt)("medic-web-engine.hideScout")
          }, null, 8, ["tooltip"])
        ], 64)) : Qt("", !0),
        h.value ? (Mt(), Ot(Me, { key: 5 }, [
          b.value ? (Mt(), le(K(ye), {
            key: 0,
            isToolbarButton: !0,
            iconSrc: "/cad/smiledesign/ik_showMandible_128.png",
            onClick: Gt[0] || (Gt[0] = (Tt) => H()),
            iconSrcHeight: "28px",
            iconSrcWidth: "28px",
            tooltip: K(jt)("medic-web-engine.showMandibularTeethOnly")
          }, null, 8, ["tooltip"])) : Qt("", !0),
          m.value ? (Mt(), le(K(ye), {
            key: 1,
            isToolbarButton: !0,
            iconSrc: "/cad/smiledesign/ik_showMaxilla_128.png",
            onClick: Gt[1] || (Gt[1] = (Tt) => j()),
            iconSrcHeight: "28px",
            iconSrcWidth: "28px",
            tooltip: K(jt)("medic-web-engine.showMaxillaryTeethOnly")
          }, null, 8, ["tooltip"])) : Qt("", !0),
          p.value ? (Mt(), le(K(ye), {
            key: 2,
            isToolbarButton: !0,
            iconSrc: "/cad/smiledesign/ik_showMaxillaMandible_128.png",
            onClick: Gt[2] || (Gt[2] = (Tt) => P()),
            iconSrcHeight: "28px",
            iconSrcWidth: "28px",
            tooltip: K(jt)("medic-web-engine.showAllTeeth")
          }, null, 8, ["tooltip"])) : Qt("", !0),
          b.value ? (Mt(), le(K(ye), {
            key: 3,
            isToolbarButton: !0,
            iconSrc: "/cad/smiledesign/ik_showNone_128.png",
            onClick: Gt[3] || (Gt[3] = (Tt) => B()),
            iconSrcHeight: "28px",
            iconSrcWidth: "28px",
            tooltip: K(jt)("medic-web-engine.hideAllTeeth")
          }, null, 8, ["tooltip"])) : Qt("", !0)
        ], 64)) : Qt("", !0),
        l.value ? (Mt(), Ot(Me, { key: 6 }, [
          Pt(K(ye), {
            isToolbarButton: !0,
            iconSrc: "/icons/new_icons/toolbar_3d/ik_anatomy_28.svg",
            onClick: Gt[4] || (Gt[4] = (Tt) => $()),
            tooltip: K(jt)("medic-web-engine.showHideAnatomy")
          }, null, 8, ["tooltip"]),
          Z.value ? (Mt(), le(K(ye), {
            key: 0,
            isToolbarButton: !0,
            iconSrc: "/icons/new_icons/toolbar_3d/ik_prosthesis_28.svg",
            onClick: Gt[5] || (Gt[5] = (Tt) => A()),
            tooltip: K(jt)("medic-web-engine.showHideProsthesis")
          }, null, 8, ["tooltip"])) : Qt("", !0)
        ], 64)) : Qt("", !0),
        c.value ? (Mt(), Ot(Me, { key: 7 }, [
          c.value && g.value ? (Mt(), le(K(ye), {
            key: 0,
            isToolbarButton: !0,
            iconSrc: "/icons/new_icons/toolbar_3d/ik_U_28.svg",
            onClick: Gt[6] || (Gt[6] = (Tt) => E()),
            tooltip: K(jt)("medic-web-engine.showHideUndercut")
          }, null, 8, ["tooltip"])) : Qt("", !0),
          c.value ? (Mt(), le(K(ye), {
            key: 1,
            isToolbarButton: !0,
            iconSrc: "/icons/new_icons/toolbar_3d/ik_G_28.svg",
            onClick: Gt[7] || (Gt[7] = (Tt) => ct()),
            tooltip: K(jt)("medic-web-engine.showHideGuide")
          }, null, 8, ["tooltip"])) : Qt("", !0),
          N.value ? (Mt(), le(K(ye), {
            key: 2,
            isToolbarButton: !0,
            iconSrc: "/icons/new_icons/toolbar_3d/ik_E_28.svg",
            onClick: Gt[8] || (Gt[8] = (Tt) => at()),
            tooltip: K(jt)("medic-web-engine.showHideExtrusions")
          }, null, 8, ["tooltip"])) : Qt("", !0),
          N.value ? (Mt(), le(K(ye), {
            key: 3,
            isToolbarButton: !0,
            iconSrc: "/icons/new_icons/toolbar_3d/ik_S_28.svg",
            onClick: Gt[9] || (Gt[9] = (Tt) => dt()),
            tooltip: K(jt)("medic-web-engine.showHideSupports")
          }, null, 8, ["tooltip"])) : Qt("", !0),
          M.value ? (Mt(), le(K(ye), {
            key: 4,
            isToolbarButton: !0,
            iconSrc: "/icons/new_icons/toolbar_3d/ik_A_28.svg",
            onClick: Gt[10] || (Gt[10] = (Tt) => dt()),
            tooltip: K(jt)("medic-web-engine.showHideSupports")
          }, null, 8, ["tooltip"])) : Qt("", !0),
          M.value ? (Mt(), le(K(ye), {
            key: 5,
            isToolbarButton: !0,
            iconSrc: "/icons/new_icons/toolbar_3d/ik_P_28.svg",
            onClick: Gt[11] || (Gt[11] = (Tt) => dt()),
            tooltip: K(jt)("medic-web-engine.showHideSupports")
          }, null, 8, ["tooltip"])) : Qt("", !0),
          T.value ? (Mt(), le(K(ye), {
            key: 6,
            isToolbarButton: !0,
            iconSrc: "/icons/new_icons/toolbar_3d/ik_T_28.svg",
            onClick: Gt[12] || (Gt[12] = (Tt) => dt()),
            tooltip: K(jt)("medic-web-engine.showHideSupports")
          }, null, 8, ["tooltip"])) : Qt("", !0),
          T.value ? (Mt(), le(K(ye), {
            key: 7,
            isToolbarButton: !0,
            iconSrc: "/icons/new_icons/toolbar_3d/ik_B_28.svg",
            onClick: Gt[13] || (Gt[13] = (Tt) => dt()),
            tooltip: K(jt)("medic-web-engine.showHideSupports")
          }, null, 8, ["tooltip"])) : Qt("", !0)
        ], 64)) : Qt("", !0),
        (f.value, Qt("", !0))
      ]),
      _: 1
    }));
  }
});
function aXt(i, t) {
  const e = new oXt(i, t), n = i.xCubeIndicatorHandlerJS.extend("xCubeIndicatorHandlerJS", e);
  return new n();
}
class oXt {
  // TODO is it ok to default false?
  constructor(t, e) {
    S(this, "__parent");
    S(this, "wasmModule");
    S(this, "events");
    S(this, "visibility", !1);
    S(this, "OnCameraChanged", () => {
      this.events.CameraChanged.notify();
    });
    S(this, "SetVisibility", (t) => {
      this.visibility = t, this.events.SetVisibilityEvent.notify(t);
    });
    this.wasmModule = t, this.events = e;
  }
}
function lXt(i, t) {
  const e = new cXt(i, t), n = i.xSliderHandlerJS.extend("xSliderHandlerJS", e);
  return new n();
}
class cXt {
  // TODO is it ok to default false?
  constructor(t, e) {
    S(this, "__parent");
    S(this, "wasmModule");
    S(this, "events");
    S(this, "visibility", !1);
    S(this, "setValue", (t, e, n) => {
      this.events.setValueEvent.notify({ value: t, min: e, max: n });
    });
    S(this, "setVisible", (t) => {
      this.events.setVisibleEvent.notify(t);
    });
    S(this, "setOrientation", (t) => {
      this.events.setOrientationEvent.notify(t);
    });
    this.wasmModule = t, this.events = e;
  }
}
const uXt = { class: "slider-box" }, IS = 20, dXt = /* @__PURE__ */ Ne({
  __name: "ViewSliceSliderCAD",
  props: {
    overlayContainer: {},
    events: {},
    handler: {}
  },
  setup(i) {
    console.log("CreateSlider 3");
    const t = i, e = An(), n = t.overlayContainer.getBoundingClientRect(), s = Lt([n.width, n.height]), r = Lt({ min: 0, max: 10, value: 0 }), a = Lt(!0);
    e.onEvent(t.events.setValueEvent, ({ value: g, min: f, max: T }) => {
      r.value = { min: f, max: T, value: g };
    }), e.onEvent(t.events.setVisibleEvent, (g) => {
      a.value = g;
    }), e.onEvent(t.events.setOrientationEvent, (g) => {
      g == 1 ? console.log("Horizontal orientation") : g == 2 && console.log("Vertical orientation");
    }), yr(() => e.cleanupAll());
    const o = te(() => {
      const { min: g, max: f, value: T } = r.value;
      return g === f ? 0.5 : 1 - (T - g) / (f - g);
    }), l = te(() => {
      const g = s.value[1];
      return [(g - IS) / 4, (g - IS) * 3 / 4];
    }), c = te(() => o.value * 100), u = (g) => {
      const { min: f, max: T, value: M } = r.value, N = Math.max(f, Math.min(T, g));
      N !== M && t.handler.SliceChanged(N);
    };
    let d = 0, h = 0;
    const p = (g, f) => {
      const T = t.overlayContainer.getBoundingClientRect();
      s.value = [T.width, T.height], h = f, d = 1 - o.value;
    }, m = (g, f) => {
      const T = d - (f - h) / (l.value[1] - l.value[0]), { min: M, max: N } = r.value, W = Math.max(M, Math.min(N, Math.round(T * (N - M) + M)));
      u(W);
    }, b = Lt();
    Ga(b, "left", "page", {
      onDragStart: p,
      onDrag: m
    });
    const y = (g) => {
      if (g.deltaY > 0) {
        const { min: f, value: T } = r.value;
        T > f && u(T - 1);
      } else if (g.deltaY < 0) {
        const { max: f, value: T } = r.value;
        T < f && u(T + 1);
      }
    }, Z = (g) => {
      const { value: f } = r.value, T = f + (g ? -1 : 1);
      u(T);
    };
    return (g, f) => r.value && a.value ? (Mt(), Ot("div", {
      key: 0,
      class: "slider-container",
      onWheel: y
    }, [
      f[4] || (f[4] = kt("div", { class: "slider-line" }, null, -1)),
      kt("div", {
        ref_key: "sliderHandle",
        ref: b,
        style: xe({
          top: c.value + "%"
        }),
        class: "slider-handle"
      }, [
        kt("div", uXt, pe(Math.round(r.value.value)), 1),
        as((Mt(), Ot("svg", {
          preserveAspectRatio: "none",
          style: { position: "absolute", width: "100%", height: "10px", top: "-12px" },
          viewBox: "0 0 100 100",
          onClick: f[0] || (f[0] = (T) => Z())
        }, [...f[2] || (f[2] = [
          kt("polygon", {
            points: "25 100 75 100 50 0",
            style: { fill: "white" }
          }, null, -1)
        ])], 512)), [
          [Ss, o.value > 0]
        ]),
        as((Mt(), Ot("svg", {
          style: xe([{
            top: IS + 6 + "px"
          }, { position: "absolute", width: "100%", height: "10px" }]),
          preserveAspectRatio: "none",
          viewBox: "0 0 100 100",
          onClick: f[1] || (f[1] = (T) => Z(!0))
        }, [...f[3] || (f[3] = [
          kt("polygon", {
            points: "25 0 75 0 50 100",
            style: { fill: "white" }
          }, null, -1)
        ])], 4)), [
          [Ss, o.value < 1]
        ])
      ], 4)
    ], 32)) : Qt("", !0);
  }
}), hXt = /* @__PURE__ */ Dn(dXt, [["__scopeId", "data-v-4de8e9f1"]]);
function jc(i, t, e, n) {
  const s = new pXt(t, i, e, n), r = i.xViewInterfaceJs.extend("xViewInterfaceJs", s);
  return new r();
}
class pXt {
  constructor(t, e, n, s) {
    S(this, "__parent");
    S(this, "container");
    S(this, "context");
    S(this, "reactivity", An());
    S(this, "commonId", Math.random());
    S(this, "id", Math.random());
    S(this, "wasmModule");
    S(this, "rWs", []);
    S(this, "layer", 0);
    S(this, "destructed", !1);
    S(this, "overlayContainer");
    S(this, "children", []);
    S(this, "siblings", []);
    S(this, "overlayComponents");
    S(this, "orientationWidget", null);
    S(this, "setRenderWindow", (t) => {
    });
    S(this, "setCachedImagePainting", (t) => {
    });
    S(this, "setEnabled", (t) => {
    });
    S(this, "CreateCamera", () => eXt(this.wasmModule));
    S(this, "CreateRenderer", () => HVt(this.wasmModule));
    S(this, "CreateRenderWindow", () => {
      const t = qVt(this.wasmModule, this.container, this.context, this.commonId);
      return this.rWs.push(t), t;
    });
    S(this, "CreateToolbar", (t) => {
      const e = new se(), n = new se(), s = new se(), r = new se(), a = new se(), o = new se(), l = new se(), c = new se(), u = {
        UpdateToolbarEvent: e,
        LockGridChangedEvent: n,
        SetBtnShowAllTeethVisibilityEvent: s,
        SetBtnShowMaxillaryTeethVisibilityEvent: r,
        SetBtnShowMandibularTeethVisibilityEvent: a,
        SetBtnShowNoneVisibilityEvent: o,
        SetProsthesisButtonVisibility: l,
        SetUndercutButtonVisibility: c
      }, d = this.overlayComponents.createVueOverlayComponent(rXt, {
        context: this.context,
        handler: t,
        events: u
      });
      return d.setEnabled(!this.context.getHideCADToolbars()), this.reactivity.onEvent(this.context.onHideCADToolbarsChanged, (h) => {
        d.setEnabled(!h);
      }), iXt(this.wasmModule, this.context, u);
    });
    S(this, "CreateCubeIndicator", (t, e) => {
      const n = {
        CameraChanged: new se(),
        SetVisibilityEvent: new se()
      };
      this.orientationWidget = new YMt(this.overlayContainer, n, t, e, this.context.getResourceUrl());
      const s = this.context.contextCAD.mRenderWindowsCADIDs.get(this.commonId);
      if (s != null) {
        const r = this.context.contextCAD.mRenderWindowsCAD.get(s);
        r && this.orientationWidget.setRenderWindow(r);
      }
      return aXt(this.wasmModule, n);
    });
    S(this, "CreateSlider", (t) => {
      const e = new se(), n = new se(), s = new se(), r = {
        setValueEvent: e,
        setOrientationEvent: s,
        setVisibleEvent: n
      };
      return this.overlayComponents.createVueOverlayComponent(hXt, {
        overlayContainer: this.overlayContainer,
        handler: t,
        events: r
      }), lXt(this.wasmModule, r);
    });
    S(this, "isVisible", () => !this.destructed && this.container.style.display !== "none");
    S(this, "update", () => {
      this.destructed || this.isVisible() && this.rWs.forEach((t) => {
        t.Render();
      });
    });
    // cursorShape = () => {
    //     return 0; // TODO
    // };
    // setCursorShape = (shape: any) => {
    //     // TODO
    // };
    // setFocus = () => {
    //     // TODO
    // };
    // mapToGlobal = (point: JsPoint): JsPoint => {
    //     return point; // TODO
    // };
    // mapFromGlobal = (point: JsPoint): JsPoint => {
    //     return point; // TODO
    // };
    S(this, "setUseTDx", (t) => {
    });
    S(this, "event", (t) => {
    });
    S(this, "handleEvent", (t) => {
    });
    S(this, "underMouse", () => !1);
    S(this, "show", () => {
      this.destructed || (this.container.style.display = "block");
    });
    S(this, "hide", () => {
      this.destructed || (this.container.style.display = "none");
    });
    S(this, "setGeometry", (t) => {
      this.destructed || (this.container.style.left = `${t.x}px`, this.container.style.top = `${t.y}px`, this.container.style.width = `${t.width}px`, this.container.style.height = `${t.height}px`);
    });
    S(this, "geometry", () => {
      const t = this.container.getBoundingClientRect(), e = new this.wasmModule.GUIPoint(t.x, t.y), n = new this.wasmModule.GUISize(t.width, t.height), s = new this.wasmModule.GUIGeometry(e, n);
      return e.delete(), n.delete(), s;
    });
    S(this, "x", () => this.container.getBoundingClientRect().x);
    S(this, "y", () => this.container.getBoundingClientRect().y);
    S(this, "width", () => this.container.getBoundingClientRect().width);
    S(this, "height", () => this.container.getBoundingClientRect().height);
    S(this, "frameGeometry", () => {
      const t = this.container.getBoundingClientRect(), e = new this.wasmModule.GUIPoint(t.x, t.y), n = new this.wasmModule.GUISize(t.width, t.height), s = new this.wasmModule.GUIGeometry(e, n);
      return e.delete(), n.delete(), s;
    });
    S(this, "move", (t, e) => {
      this.container.style.top = `${e}px`;
    });
    S(this, "CreateChild", () => {
      const t = document.createElement("div");
      t.style.position = "absolute", t.style.width = "100%", t.style.height = "100%", this.container.appendChild(t);
      const e = jc(this.wasmModule, t, this.context, { commonId: this.commonId, layer: this.layer + 1 });
      return this.children.push(e), e;
    });
    S(this, "CreateSibling", () => {
      const t = this.container.parentElement ?? document.body, e = document.createElement("div");
      t.appendChild(e);
      const n = jc(this.wasmModule, e, this.context);
      return this.siblings.push(n), n;
    });
    S(this, "destroy", () => {
      var e, n;
      const t = this.destructed;
      if (!(this.layer > 0 && t))
        if (this.destructed = !0, t || (this.reactivity.cleanupAll(), this.overlayComponents.cleanup(), (e = this.orientationWidget) == null || e.delete(), this.orientationWidget = null, this.rWs.forEach((s) => {
          var r;
          return (r = s.destruct) == null ? void 0 : r.call(s);
        }), this.rWs = []), this.siblings.forEach((s) => s.destroy()), this.siblings = [], this.children.forEach((s) => s.destroy()), this.children = [], this.layer == 0)
          for (; this.container.firstChild; )
            this.container.removeChild(this.container.firstChild);
        else {
          const s = this.container.parentElement;
          if (s) {
            for (; s.firstChild; )
              s.removeChild(s.firstChild);
            (n = s.parentElement) == null || n.removeChild(s);
          }
        }
    });
    this.container = t, this.wasmModule = e, this.context = n, this.overlayContainer = document.createElement("div"), this.overlayContainer.style.position = "absolute", this.overlayContainer.style.pointerEvents = "none", this.overlayContainer.style.zIndex = "1", this.overlayContainer.style.width = "100%", this.overlayContainer.style.height = "100%", this.container.appendChild(this.overlayContainer), s && (this.commonId = s.commonId, this.layer = s.layer), this.overlayComponents = Pi(this.overlayContainer);
  }
}
const mXt = /* @__PURE__ */ Ne({
  __name: "RegistrationRefinementDialog",
  emits: ["confirm", "reject"],
  setup(i, { emit: t }) {
    const { t: e } = La(), n = gr("dialogRef"), s = n.value.data, r = t, a = Lt(!1), o = Lt(), l = Lt(), c = Lt(!1), u = Lt(""), d = Lt("");
    let h;
    const p = () => {
      h && (u.value = h.GetUndoHint(), d.value = h.GetRedoHint(), c.value = h.GetReorientChecked());
    }, m = () => {
      h && (h.UndoClicked(), p());
    }, b = () => {
      h && (h.RedoClicked(), p());
    }, y = () => {
      r("reject"), n.value.close();
    }, Z = () => {
      r("confirm"), n.value.close();
    }, g = (T) => {
      h && h.ReorientClicked(T);
    };
    let f;
    return xn(() => {
      const T = jc(s.context.module, o.value, s.context), M = jc(s.context.module, l.value, s.context), N = ge(s.context.contextCAD.GetMainForm());
      N && (h = N.GetRefinementWidget(), h.showEvent(T, M), c.value = h.GetReorientChecked(), h.SetUndoRedoLambda(p)), f = new ResizeObserver((W) => {
        for (const x of W)
          x.target === o.value && (console.log("Resize 0!!"), h && h.resize());
      }), f.observe(o.value), setTimeout(() => {
        h && h.resize(), a.value = !0;
      }, 500);
    }), yr(() => {
      f.disconnect();
    }), (T, M) => (Mt(), le(K(Te), { style: { "flex-direction": "column", "justify-content": "space-around" } }, {
      default: oe(() => [
        Pt(K(Te), {
          class: "mt-4 gap-4",
          style: { "flex-direction": "row" }
        }, {
          default: oe(() => [
            Pt(K(ye), {
              style: { flex: "1 1 0" },
              label: "Re-Orientate Widget",
              tooltip: "Re-Orientate Widget",
              togglable: !0,
              toggled: c.value,
              onToggledChange: g,
              "icon-src-height": "21px",
              "icon-src-width": "21px",
              iconSrc: "/icons/new_icons/ik_scanOrientering_28.svg"
            }, null, 8, ["toggled"]),
            Pt(K(ye), {
              style: { flex: "1 1 0" },
              label: "Undo",
              tooltip: u.value,
              disabled: !(u.value && u.value.length),
              onClick: m,
              "icon-src-height": "21px",
              "icon-src-width": "21px",
              iconSrc: "/icons/rg_undo.svg"
            }, null, 8, ["tooltip", "disabled"]),
            Pt(K(ye), {
              style: { flex: "1 1 0" },
              label: "Redo",
              tooltip: d.value,
              disabled: !(d.value && d.value.length),
              onClick: b,
              "icon-src-height": "21px",
              "icon-src-width": "21px",
              iconSrc: "/icons/rg_redo.svg"
            }, null, 8, ["tooltip", "disabled"]),
            Pt(K(ye), {
              style: { flex: "1 1 0" },
              label: "Close",
              tooltip: "Close",
              onClick: y,
              "icon-src-height": "21px",
              "icon-src-width": "21px",
              iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg"
            })
          ]),
          _: 1
        }),
        Pt(K(Te), {
          class: "mt-4",
          style: { "flex-direction": "row" }
        }, {
          default: oe(() => [
            as(kt("div", {
              ref_key: "container3D",
              ref: o,
              class: "flex",
              style: { flex: "1 1 0", "min-height": "57vh", "max-height": "57vh", "min-width": "38vw", "max-width": "38vw", position: "relative" }
            }, null, 512), [
              [Ss, a.value]
            ]),
            as(kt("div", {
              ref_key: "containerSmile",
              ref: l,
              class: "flex ml-2",
              style: { flex: "1 1 0", "min-height": "57vh", "max-height": "57vh", "min-width": "38vw", "max-width": "38vw", position: "relative" }
            }, null, 512), [
              [Ss, a.value]
            ])
          ]),
          _: 1
        }),
        Pt(K(Te), { class: "p-dialog-footer justify-center mt-6" }, {
          default: oe(() => [
            Pt(K(ye), {
              label: "Apply",
              onClick: M[0] || (M[0] = (N) => Z()),
              "icon-src-height": "21px",
              "icon-src-width": "21px",
              iconSrc: "/icons/rg_check.svg"
            }),
            Pt(K(ye), {
              label: K(s).editOnly ? K(e)("shared.cancel") : K(e)("shared.edit"),
              onClick: M[1] || (M[1] = (N) => y()),
              "icon-src-height": "21px",
              "icon-src-width": "21px",
              iconSrc: K(s).editOnly ? "/icons/new_icons/toolbar_3d/ik_X_28.svg" : "/icons/new_icons/ik_edit_28.svg"
            }, null, 8, ["label", "iconSrc"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), bXt = 0, fXt = 1, gXt = 2, yXt = 3;
async function ZXt(i) {
  !i || typeof i.opcallAsync != "function" || await new Promise((t) => {
    const e = (n) => {
      t(n);
    };
    i.opcallAsync(e);
  });
}
async function TXt(i, t) {
  !i || typeof i.opcallAsync != "function" || await new Promise((e) => {
    const n = (s) => {
      e(s);
    };
    i.opcallAsync(t, n);
  });
}
function TB(i) {
  const t = [];
  for (let e = 0; e < i.size(); e++) {
    const n = i.get(e);
    if (!n.GetVisibility()) continue;
    const s = typeof n.GetType == "function" ? n.GetType() : bXt, r = n.GetLabel(), a = typeof n.GetEnabled == "function" ? n.GetEnabled() : !0;
    if (s === gXt || r === "") {
      t.push({
        separator: !0
      });
      continue;
    }
    if (s === yXt) {
      const d = n.GetSliderCallback(), h = {
        label: r || "Value",
        disabled: !a,
        __isSlider: !0,
        __sliderValue: n.GetSliderValue(),
        __sliderMin: n.GetSliderMin(),
        __sliderMax: n.GetSliderMax(),
        __sliderStep: n.GetSliderStep(),
        __onValueChanged: async (p) => {
          await TXt(d, p);
        }
      };
      t.push(h);
      continue;
    }
    let o, l;
    if (n.HasMenu() || s === fXt)
      o = TB(n.GetMenuItems());
    else {
      const d = n.GetCallback();
      l = async () => {
        await ZXt(d);
      };
    }
    const c = typeof n.GetCheckable == "function" ? n.GetCheckable() : !1, u = c && typeof n.GetChecked == "function" ? n.GetChecked() : !1;
    t.push({
      label: r,
      disabled: !a,
      icon: c ? u ? "pi pi-check" : "pi pi-circle-off" : void 0,
      command: l,
      items: o
    });
  }
  return t;
}
const MXt = { class: "text-sm" }, NXt = { class: "text-sm" }, WXt = { class: "text-sm" }, GXt = { class: "text-sm" }, wXt = /* @__PURE__ */ Ne({
  __name: "ArticulatorLibraryDialog",
  emits: ["confirm", "reject"],
  setup(i, { emit: t }) {
    const e = gr("dialogRef"), n = e.value.data, s = t, r = Lt(), a = Lt(!1), o = Lt([]), l = Lt("");
    let c;
    const u = () => {
      s("reject"), e.value.close();
    }, d = () => {
      s("confirm"), e.value.close();
    }, h = Lt(!1), p = Lt(!1), m = Lt(!1), b = Lt(!1);
    let y;
    const Z = Lt(0);
    let g;
    const f = Lt(0);
    let T;
    const M = Lt(0);
    let N;
    const W = Lt(0);
    let x;
    const V = Lt(0);
    let X;
    const C = Lt(0);
    let R;
    const z = Lt(0);
    let F;
    const P = Lt(0);
    let j;
    const H = Lt(0);
    let B;
    const $ = Lt(0);
    let A;
    const E = Lt(0);
    let ct;
    const at = Lt([]), dt = Lt();
    let gt;
    const Wt = Lt([]), Zt = Lt();
    let Gt;
    const Tt = Lt([]), Q = Lt();
    let D;
    const q = Lt([]), nt = Lt(), et = () => {
      if (c) {
        h.value = c.mRetrusionParametersVisible, p.value = c.mLeftSideParametersVisible, m.value = c.mRightSideParametersVisible, b.value = c.mIncisalTableParametersVisible, y = c.GetGUIComponent(
          0
          /* eRETRUSION */
        ), Z.value = parseFloat(y.getValue().toFixed(Bi(y.mStep))), g = c.GetGUIComponent(
          1
          /* eBENNETTANGLELEFT */
        ), f.value = parseFloat(g.getValue().toFixed(Bi(g.mStep))), T = c.GetGUIComponent(
          3
          /* eIMMEDIATESIDESHIFTLEFT */
        ), M.value = parseFloat(T.getValue().toFixed(Bi(T.mStep))), N = c.GetGUIComponent(
          5
          /* eCONDYLARANGLELEFT */
        ), W.value = parseFloat(N.getValue().toFixed(Bi(N.mStep))), x = c.GetGUIComponent(
          2
          /* eBENNETTANGLERIGHT */
        ), V.value = parseFloat(x.getValue().toFixed(Bi(x.mStep))), X = c.GetGUIComponent(
          4
          /* eIMMEDIATESIDESHIFTRIGHT */
        ), C.value = parseFloat(X.getValue().toFixed(Bi(X.mStep))), R = c.GetGUIComponent(
          6
          /* eCONDYLARANGLERIGHT */
        ), z.value = parseFloat(R.getValue().toFixed(Bi(R.mStep))), F = c.GetGUIComponent(
          11
          /* eINCISALTABLEINCLINATION */
        ), P.value = parseFloat(F.getValue().toFixed(Bi(F.mStep))), j = c.GetGUIComponent(
          12
          /* eINCISALTABLEANGLELEFT */
        ), H.value = parseFloat(j.getValue().toFixed(Bi(j.mStep))), B = c.GetGUIComponent(
          13
          /* eINCISALTABLEANGLERIGHT */
        ), $.value = parseFloat(B.getValue().toFixed(Bi(B.mStep))), A = c.GetGUIComponent(
          14
          /* eINCISALTABLEROTATION */
        ), E.value = parseFloat(A.getValue().toFixed(Bi(A.mStep))), ct = c.GetGUIComponent(
          7
          /* eBENNETTINSERTLEFT */
        );
        const zt = ct.mItemsString, Bt = [];
        for (let we = 0; we < zt.size(); we++) {
          const ln = zt.get(we);
          Bt.push({ label: ln, value: we });
        }
        at.value = Bt, ct.currentIndex >= 0 && ct.currentIndex < at.value.length && (dt.value = ct.currentIndex), gt = c.GetGUIComponent(
          8
          /* eBENNETTINSERTRIGHT */
        );
        const Kt = gt.mItemsString, ne = [];
        for (let we = 0; we < Kt.size(); we++) {
          const ln = Kt.get(we);
          ne.push({ label: ln, value: we });
        }
        Wt.value = ne, gt.currentIndex >= 0 && gt.currentIndex < Wt.value.length && (Zt.value = gt.currentIndex), Gt = c.GetGUIComponent(
          9
          /* eCONDYLARINSERTLEFT */
        );
        const ae = Gt.mItemsString, Ge = [];
        for (let we = 0; we < ae.size(); we++) {
          const ln = ae.get(we);
          Ge.push({ label: ln, value: we });
        }
        Tt.value = Ge, Gt.currentIndex >= 0 && Gt.currentIndex < Tt.value.length && (Q.value = Gt.currentIndex), D = c.GetGUIComponent(
          10
          /* eCONDYLARINSERTRIGHT */
        );
        const He = D.mItemsString, je = [];
        for (let we = 0; we < He.size(); we++) {
          const ln = He.get(we);
          je.push({ label: ln, value: we });
        }
        q.value = je, D.currentIndex >= 0 && D.currentIndex < q.value.length && (nt.value = D.currentIndex);
      }
    };
    let ot = !0;
    const it = async (zt, Bt) => {
      if (ot && Bt != null) {
        ot = !1;
        const Kt = parseFloat(Bt.toFixed(Bi(zt.mStep)));
        zt.GetOnValueChangedLambda.opcall(Kt), ot = !0;
      }
    }, ht = async (zt) => {
      await it(y, zt);
    }, lt = async (zt) => {
      await it(g, zt);
    }, mt = async (zt) => {
      await it(T, zt);
    }, wt = async (zt) => {
      await it(N, zt);
    }, Xt = async (zt) => {
      await it(x, zt);
    }, At = async (zt) => {
      await it(X, zt);
    }, he = async (zt) => {
      await it(R, zt);
    }, ue = async (zt) => {
      await it(F, zt);
    }, Dt = async (zt) => {
      await it(j, zt);
    }, ee = async (zt) => {
      await it(B, zt);
    }, yt = async (zt) => {
      await it(A, zt);
    }, fe = async (zt) => {
      ct.GetOnValueChangedLambda.opcall(zt);
    }, Xe = async (zt) => {
      gt.GetOnValueChangedLambda.opcall(zt);
    }, Se = async (zt) => {
      Gt.GetOnValueChangedLambda.opcall(zt);
    }, Vt = async (zt) => {
      D.GetOnValueChangedLambda.opcall(zt);
    }, Rt = (zt) => {
      c && (c.OnChooseArticulatorChanged(zt), et());
    };
    let $t;
    return xn(async () => {
      n.context.showLoading(jt("medic-web-engine.loadingArticulatorLibraries"), !0, 0);
      const zt = jc(n.context.module, r.value, n.context), Bt = PX();
      await n.context.contextCAD.LoadArticulatorLibrariesToWasm(Bt);
      const Kt = ge(n.context.contextCAD.GetMainForm());
      if (Kt) {
        c = Kt.GetArticulatorLibraryWidget(), c.showEvent(zt);
        const ne = c.GetArticulatorItems(), ae = [];
        for (let Ge = 0; Ge < ne.size(); Ge++) {
          const He = ne.get(Ge);
          ae.push({ label: He, value: He });
        }
        o.value = ae, l.value = c.GetSelectedItem(), gn(l, (Ge) => {
          Rt(Ge);
        }), et();
      }
      $t = new ResizeObserver((ne) => {
        for (const ae of ne)
          ae.target === r.value && c && c.resize();
      }), $t.observe(r.value), setTimeout(() => {
        c && c.resize(), a.value = !0, n.context.hideLoading(), n.context.contextCAD.ClearArticulatorLibrariesFromWasm();
      }, 500), Kt && Kt.SetAsyncJobRunningFlag(!1);
    }), yr(() => {
      $t.disconnect();
    }), (zt, Bt) => (Mt(), le(K(Te), {
      class: "h-full w-full",
      style: { "user-select": "none", "flex-direction": "column" }
    }, {
      default: oe(() => [
        Pt(K(Te), {
          class: "gap-4 h-full",
          style: { "flex-direction": "row" }
        }, {
          default: oe(() => [
            Pt(K(Te), {
              class: "mt-4 gap-2",
              style: { "flex-direction": "column", flex: "1 1 0" }
            }, {
              default: oe(() => [
                Pt(K(Te), {
                  class: "gap-2",
                  style: { "flex-direction": "column", "border-bottom": "solid 1px #ffffff66", "padding-bottom": "10px" }
                }, {
                  default: oe(() => [
                    Bt[18] || (Bt[18] = kt("span", null, "Choose Articulator", -1)),
                    Pt(K(Ku), {
                      modelValue: l.value,
                      "onUpdate:modelValue": Bt[0] || (Bt[0] = (Kt) => l.value = Kt),
                      options: o.value,
                      optionLabel: "label",
                      optionValue: "value"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }),
                Bt[23] || (Bt[23] = kt("span", { class: "mt-2" }, "Articulator Parameters", -1)),
                h.value && K(y) && K(y).getVisible() ? (Mt(), Ot(Me, { key: 0 }, [
                  Bt[19] || (Bt[19] = kt("span", {
                    class: "mt-2",
                    style: { "border-bottom": "solid 1px #ffffff66", "padding-bottom": "3px" }
                  }, "Retrusion Parameter", -1)),
                  Pt(K(zo), {
                    label: K(y).mLabel,
                    modelValue: Z.value,
                    "onUpdate:modelValue": [
                      Bt[1] || (Bt[1] = (Kt) => Z.value = Kt),
                      ht
                    ],
                    min: K(y).mMin,
                    max: K(y).mMax,
                    step: K(y).mStep,
                    "show-buttons": !0,
                    "unit-label": K(y).mUnitLabel,
                    "fraction-digits": K(Bi)(K(Ha)(K(y).mStep))
                  }, null, 8, ["label", "modelValue", "min", "max", "step", "unit-label", "fraction-digits"])
                ], 64)) : Qt("", !0),
                p.value ? (Mt(), Ot(Me, { key: 1 }, [
                  Bt[20] || (Bt[20] = kt("span", {
                    class: "mt-2",
                    style: { "border-bottom": "solid 1px #ffffff66", "padding-bottom": "3px" }
                  }, "Left Side Parameters", -1)),
                  K(g) && K(g).getVisible() ? (Mt(), le(K(zo), {
                    key: 0,
                    label: K(g).mLabel,
                    modelValue: f.value,
                    "onUpdate:modelValue": [
                      Bt[2] || (Bt[2] = (Kt) => f.value = Kt),
                      lt
                    ],
                    min: K(g).mMin,
                    max: K(g).mMax,
                    step: K(g).mStep,
                    "show-buttons": !0,
                    "unit-label": K(g).mUnitLabel,
                    "fraction-digits": K(Bi)(K(Ha)(K(g).mStep))
                  }, null, 8, ["label", "modelValue", "min", "max", "step", "unit-label", "fraction-digits"])) : Qt("", !0),
                  K(T) && K(T).getVisible() ? (Mt(), le(K(zo), {
                    key: 1,
                    label: K(T).mLabel,
                    modelValue: M.value,
                    "onUpdate:modelValue": [
                      Bt[3] || (Bt[3] = (Kt) => M.value = Kt),
                      mt
                    ],
                    min: K(T).mMin,
                    max: K(T).mMax,
                    step: K(T).mStep,
                    "show-buttons": !0,
                    "unit-label": K(T).mUnitLabel,
                    "fraction-digits": K(Bi)(K(Ha)(K(T).mStep))
                  }, null, 8, ["label", "modelValue", "min", "max", "step", "unit-label", "fraction-digits"])) : Qt("", !0),
                  K(N) && K(N).getVisible() ? (Mt(), le(K(zo), {
                    key: 2,
                    label: K(N).mLabel,
                    modelValue: W.value,
                    "onUpdate:modelValue": [
                      Bt[4] || (Bt[4] = (Kt) => W.value = Kt),
                      wt
                    ],
                    min: K(N).mMin,
                    max: K(N).mMax,
                    step: K(N).mStep,
                    "show-buttons": !0,
                    "unit-label": K(N).mUnitLabel,
                    "fraction-digits": K(Bi)(K(Ha)(K(N).mStep))
                  }, null, 8, ["label", "modelValue", "min", "max", "step", "unit-label", "fraction-digits"])) : Qt("", !0),
                  at.value.length && K(ct) && K(ct).getVisible() ? (Mt(), le(K(Te), {
                    key: 3,
                    class: "gap-2 ml-1",
                    style: { "flex-direction": "column" }
                  }, {
                    default: oe(() => [
                      kt("span", MXt, pe(K(ct).mLabel), 1),
                      Pt(K(Ku), {
                        modelValue: dt.value,
                        "onUpdate:modelValue": Bt[5] || (Bt[5] = (Kt) => dt.value = Kt),
                        options: at.value,
                        "option-label": "label",
                        "option-value": "value",
                        onValueChange: fe
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1
                  })) : Qt("", !0),
                  Tt.value.length && K(Gt) && K(Gt).getVisible() ? (Mt(), le(K(Te), {
                    key: 4,
                    class: "gap-2 ml-1",
                    style: { "flex-direction": "column" }
                  }, {
                    default: oe(() => [
                      kt("span", NXt, pe(K(Gt).mLabel), 1),
                      Pt(K(Ku), {
                        modelValue: Q.value,
                        "onUpdate:modelValue": Bt[6] || (Bt[6] = (Kt) => Q.value = Kt),
                        options: Tt.value,
                        "option-label": "label",
                        "option-value": "value",
                        onValueChange: Se
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1
                  })) : Qt("", !0)
                ], 64)) : Qt("", !0),
                m.value ? (Mt(), Ot(Me, { key: 2 }, [
                  Bt[21] || (Bt[21] = kt("span", {
                    class: "mt-2",
                    style: { "border-bottom": "solid 1px #ffffff66", "padding-bottom": "3px" }
                  }, "Right Side Parameters", -1)),
                  K(x) && K(x).getVisible() ? (Mt(), le(K(zo), {
                    key: 0,
                    label: K(x).mLabel,
                    modelValue: V.value,
                    "onUpdate:modelValue": [
                      Bt[7] || (Bt[7] = (Kt) => V.value = Kt),
                      Xt
                    ],
                    min: K(x).mMin,
                    max: K(x).mMax,
                    step: K(x).mStep,
                    "show-buttons": !0,
                    "unit-label": K(x).mUnitLabel,
                    "fraction-digits": K(Bi)(K(Ha)(K(x).mStep))
                  }, null, 8, ["label", "modelValue", "min", "max", "step", "unit-label", "fraction-digits"])) : Qt("", !0),
                  K(X) && K(X).getVisible() ? (Mt(), le(K(zo), {
                    key: 1,
                    label: K(X).mLabel,
                    modelValue: C.value,
                    "onUpdate:modelValue": [
                      Bt[8] || (Bt[8] = (Kt) => C.value = Kt),
                      At
                    ],
                    min: K(X).mMin,
                    max: K(X).mMax,
                    step: K(X).mStep,
                    "show-buttons": !0,
                    "unit-label": K(X).mUnitLabel,
                    "fraction-digits": K(Bi)(K(Ha)(K(X).mStep))
                  }, null, 8, ["label", "modelValue", "min", "max", "step", "unit-label", "fraction-digits"])) : Qt("", !0),
                  K(R) && K(R).getVisible() ? (Mt(), le(K(zo), {
                    key: 2,
                    label: K(R).mLabel,
                    modelValue: z.value,
                    "onUpdate:modelValue": [
                      Bt[9] || (Bt[9] = (Kt) => z.value = Kt),
                      he
                    ],
                    min: K(R).mMin,
                    max: K(R).mMax,
                    step: K(R).mStep,
                    "show-buttons": !0,
                    "unit-label": K(R).mUnitLabel,
                    "fraction-digits": K(Bi)(K(Ha)(K(R).mStep))
                  }, null, 8, ["label", "modelValue", "min", "max", "step", "unit-label", "fraction-digits"])) : Qt("", !0),
                  Wt.value.length && K(gt) && K(gt).getVisible() ? (Mt(), le(K(Te), {
                    key: 3,
                    class: "gap-2 ml-1",
                    style: { "flex-direction": "column" }
                  }, {
                    default: oe(() => [
                      kt("span", WXt, pe(K(gt).mLabel), 1),
                      Pt(K(Ku), {
                        modelValue: Zt.value,
                        "onUpdate:modelValue": Bt[10] || (Bt[10] = (Kt) => Zt.value = Kt),
                        options: Wt.value,
                        "option-label": "label",
                        "option-value": "value",
                        onValueChange: Xe
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1
                  })) : Qt("", !0),
                  q.value.length && K(D) && K(D).getVisible() ? (Mt(), le(K(Te), {
                    key: 4,
                    class: "gap-2 ml-1",
                    style: { "flex-direction": "column" }
                  }, {
                    default: oe(() => [
                      kt("span", GXt, pe(K(D).mLabel), 1),
                      Pt(K(Ku), {
                        modelValue: nt.value,
                        "onUpdate:modelValue": Bt[11] || (Bt[11] = (Kt) => nt.value = Kt),
                        options: q.value,
                        "option-label": "label",
                        "option-value": "value",
                        onValueChange: Vt
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1
                  })) : Qt("", !0)
                ], 64)) : Qt("", !0),
                b.value ? (Mt(), Ot(Me, { key: 3 }, [
                  Bt[22] || (Bt[22] = kt("span", {
                    class: "mt-2",
                    style: { "border-bottom": "solid 1px #ffffff66", "padding-bottom": "3px" }
                  }, "Incisal Table Parameters", -1)),
                  K(F) && K(F).getVisible() ? (Mt(), le(K(zo), {
                    key: 0,
                    label: K(F).mLabel,
                    modelValue: P.value,
                    "onUpdate:modelValue": [
                      Bt[12] || (Bt[12] = (Kt) => P.value = Kt),
                      ue
                    ],
                    min: K(F).mMin,
                    max: K(F).mMax,
                    step: K(F).mStep,
                    "show-buttons": !0,
                    "unit-label": K(F).mUnitLabel,
                    "fraction-digits": K(Bi)(K(Ha)(K(F).mStep))
                  }, null, 8, ["label", "modelValue", "min", "max", "step", "unit-label", "fraction-digits"])) : Qt("", !0),
                  K(j) && K(j).getVisible() ? (Mt(), le(K(zo), {
                    key: 1,
                    label: K(j).mLabel,
                    modelValue: H.value,
                    "onUpdate:modelValue": [
                      Bt[13] || (Bt[13] = (Kt) => H.value = Kt),
                      Dt
                    ],
                    min: K(j).mMin,
                    max: K(j).mMax,
                    step: K(j).mStep,
                    "show-buttons": !0,
                    "unit-label": K(j).mUnitLabel,
                    "fraction-digits": K(Bi)(K(Ha)(K(j).mStep))
                  }, null, 8, ["label", "modelValue", "min", "max", "step", "unit-label", "fraction-digits"])) : Qt("", !0),
                  K(B) && K(B).getVisible() ? (Mt(), le(K(zo), {
                    key: 2,
                    label: K(B).mLabel,
                    modelValue: $.value,
                    "onUpdate:modelValue": [
                      Bt[14] || (Bt[14] = (Kt) => $.value = Kt),
                      ee
                    ],
                    min: K(B).mMin,
                    max: K(B).mMax,
                    step: K(B).mStep,
                    "show-buttons": !0,
                    "unit-label": K(B).mUnitLabel,
                    "fraction-digits": K(Bi)(K(Ha)(K(B).mStep))
                  }, null, 8, ["label", "modelValue", "min", "max", "step", "unit-label", "fraction-digits"])) : Qt("", !0),
                  K(A) && K(A).getVisible() ? (Mt(), le(K(zo), {
                    key: 3,
                    label: K(A).mLabel,
                    modelValue: E.value,
                    "onUpdate:modelValue": [
                      Bt[15] || (Bt[15] = (Kt) => E.value = Kt),
                      yt
                    ],
                    min: K(A).mMin,
                    max: K(A).mMax,
                    step: K(A).mStep,
                    "show-buttons": !0,
                    "unit-label": K(A).mUnitLabel,
                    "fraction-digits": K(Bi)(K(Ha)(K(A).mStep))
                  }, null, 8, ["label", "modelValue", "min", "max", "step", "unit-label", "fraction-digits"])) : Qt("", !0)
                ], 64)) : Qt("", !0)
              ]),
              _: 1
            }),
            Pt(K(Te), { style: { "flex-direction": "row", flex: "2 1 0", "align-items": "center", "justify-content": "center" } }, {
              default: oe(() => [
                as(kt("div", {
                  ref_key: "containerVtk",
                  ref: r,
                  class: "flex",
                  style: { flex: "1 1 0", "min-height": "56vh", "max-height": "56vh", "min-width": "57vw", "max-width": "57vw", position: "relative" }
                }, null, 512), [
                  [Ss, a.value]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        Pt(K(Te), { class: "p-dialog-footer justify-center mt-6" }, {
          default: oe(() => [
            Pt(K(ye), {
              label: "OK",
              onClick: Bt[16] || (Bt[16] = (Kt) => d()),
              "icon-src-height": "21px",
              "icon-src-width": "21px",
              iconSrc: "/icons/rg_check.svg"
            }),
            Pt(K(ye), {
              label: "Cancel",
              onClick: Bt[17] || (Bt[17] = (Kt) => u()),
              "icon-src-height": "21px",
              "icon-src-width": "21px",
              iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), xXt = /* @__PURE__ */ Ne({
  __name: "MovementMarkerLibraryDialog",
  emits: ["confirm", "reject"],
  setup(i, { emit: t }) {
    const e = gr("dialogRef"), n = e.value.data, s = t, r = Lt(), a = Lt(!1), o = Lt([]), l = Lt("");
    let c;
    const u = () => {
      s("reject"), e.value.close();
    }, d = () => {
      s("confirm"), e.value.close();
    }, h = (m) => {
      c && c.OnChooseMarkerChanged(m);
    };
    let p;
    return xn(async () => {
      n.context.showLoading(jt("medic-web-engine.loadingMovementMarkerLibraries"), !0, 0);
      const m = jc(n.context.module, r.value, n.context), b = PX();
      await n.context.contextCAD.LoadMovementMarkerLibrariesToWasm(b);
      const y = ge(n.context.contextCAD.GetMainForm());
      if (y) {
        c = y.GetMovementMarkerLibraryWidget(), c.showEvent(m);
        const Z = c.GetMovementMarkerItems(), g = [];
        for (let f = 0; f < Z.size(); f++) {
          const T = Z.get(f);
          g.push({ label: T, value: T });
        }
        o.value = g, l.value = c.GetSelectedItem(), gn(l, (f) => {
          h(f);
        });
      }
      p = new ResizeObserver((Z) => {
        for (const g of Z)
          g.target === r.value && c && (console.log("Resize event"), c.resize());
      }), p.observe(r.value), setTimeout(() => {
        c && c.resize(), a.value = !0, n.context.hideLoading(), n.context.contextCAD.ClearMovementMarkerLibrariesFromWasm();
      }, 500), y && y.SetAsyncJobRunningFlag(!1);
    }), yr(() => {
      p.disconnect();
    }), (m, b) => (Mt(), le(K(Te), {
      class: "",
      style: { "user-select": "none", "flex-direction": "column", flex: "1 1 0" }
    }, {
      default: oe(() => [
        Pt(K(Te), {
          class: "gap-4 mt-2",
          style: { "flex-direction": "row", "margin-bottom": "auto", flex: "1 1 0" }
        }, {
          default: oe(() => [
            Pt(K(Te), {
              class: "gap-2 ml-2",
              style: { "flex-direction": "column", "padding-bottom": "10px", flex: "1 1 0" }
            }, {
              default: oe(() => [
                b[3] || (b[3] = kt("span", { class: "ml-2" }, "Movement Marker/System", -1)),
                Pt(K(Ku), {
                  modelValue: l.value,
                  "onUpdate:modelValue": b[0] || (b[0] = (y) => l.value = y),
                  options: o.value,
                  optionLabel: "label",
                  optionValue: "value"
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }),
            Pt(K(Te), { style: { flex: "2 1 0", "align-items": "center", "justify-content": "center" } }, {
              default: oe(() => [
                as(kt("div", {
                  ref_key: "containerVtk",
                  ref: r,
                  class: "flex",
                  style: { position: "relative", "min-height": "42vh", "max-height": "42vh", "min-width": "46vw", "max-width": "46vw", flex: "1 1 0" }
                }, null, 512), [
                  [Ss, a.value]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        Pt(K(Te), { class: "p-dialog-footer justify-center mt-6" }, {
          default: oe(() => [
            Pt(K(ye), {
              label: "OK",
              onClick: b[1] || (b[1] = (y) => d()),
              "icon-src-height": "21px",
              "icon-src-width": "21px",
              iconSrc: "/icons/rg_check.svg"
            }),
            Pt(K(ye), {
              label: "Cancel",
              onClick: b[2] || (b[2] = (y) => u()),
              "icon-src-height": "21px",
              "icon-src-width": "21px",
              iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), SXt = ["data-cy", "onClick"], LXt = { style: { "font-size": "x-small", "font-weight": "bold", color: "red", "white-space": "pre-wrap", "text-shadow": "1px 1px 5px rgba(0, 0, 0, 1)" } }, VXt = ["src"], XXt = ["src"], gE = 248, IXt = "bold 12px sans-serif", CXt = /* @__PURE__ */ Ne({
  __name: "MTeethView",
  props: {
    jawboneType: {},
    teeth: {},
    useUSStyleToothChart: { type: Boolean },
    modelValue: {},
    warningString: {},
    showLines: { type: Boolean }
  },
  emits: ["toothClick", "toothClickRight", "toothMouseOver", "toothMouseOut", "update:modelValue"],
  setup(i, { emit: t }) {
    const e = ZC(), n = TC(), s = cJ(), r = uJ(), a = dJ(), o = i, l = t, { teeth: c, jawboneType: u, useUSStyleToothChart: d } = Vo(o), h = te(() => u.value === $e.MAXILLA ? 18 : 0), p = Lt(null), m = Lt(null), b = Lt(1), y = gE / 2, Z = document.createElement("canvas"), g = document.createElement("canvas"), f = jl(), T = te(() => {
      let Xt = "flex justify-center";
      return o.showLines && (Xt += " line-in-middle"), o.showLines && o.jawboneType === $e.MANDIBLE && (Xt += " horizontal-line"), Xt;
    }), M = te(() => {
      let Xt = "relative";
      return o.showLines && o.jawboneType === $e.MANDIBLE && (Xt += " mandible-mt"), Xt;
    }), N = new Image(), W = {};
    let x = !1;
    const V = new Image(), X = {};
    let C = !1;
    const R = te(() => u.value === $e.MAXILLA ? N : V), z = te(() => u.value === $e.MAXILLA ? e : n), F = te(() => u.value === $e.MAXILLA ? W : X), P = (Xt) => !!Xt && Xt.complete && Xt.naturalWidth > 0 && Xt.naturalHeight > 0, j = () => u.value === $e.MAXILLA ? x : C, H = () => P(R.value) && ai.every((Xt) => P(F.value[Xt])), B = (Xt) => {
      let At = 1 + ai.length;
      const he = () => {
        At--, At === 0 && (Xt(), x = !0);
      };
      N.onload = () => he(), N.src = f.getAssetUrl("/resources/teeth/maxilla.png"), ai.forEach((ue) => {
        const [Dt] = e[ue], ee = new Image();
        ee.onload = () => he();
        const yt = `/resources/${Dt}`;
        ee.src = f.getAssetUrl(yt), W[ue] = ee;
      });
    }, $ = (Xt) => {
      let At = 1 + ai.length;
      const he = () => {
        At--, At === 0 && (Xt(), C = !0);
      };
      V.onload = () => he(), V.src = f.getAssetUrl("/resources/teeth/mandible.png"), ai.forEach((ue) => {
        const [Dt] = n[ue], ee = new Image();
        ee.onload = () => he();
        const yt = `/resources/${Dt}`;
        ee.src = f.getAssetUrl(yt), X[ue] = ee;
      });
    }, A = (Xt) => Xt.status === _e.CROWN_SEGMENTATION_SELECTED ? r[Xt.id] : Xt.status === _e.CROWN_SEGMENTATION ? a[Xt.id] : s[Xt.status], E = (Xt, At, he, ue, Dt, ee) => {
      At.save(), At.clearRect(0, 0, Xt.width, Xt.height), At.drawImage(he, Dt, ee), At.fillStyle = ue, At.globalCompositeOperation = "source-in", At.fillRect(0, 0, Xt.width, Xt.height), At.restore();
    }, ct = () => {
      const Xt = R.value;
      if (!p.value || !H())
        return;
      const At = p.value.getContext("2d");
      if (!At)
        return;
      p.value.width = Xt.naturalWidth, p.value.height = Xt.naturalHeight, Z.width = p.value.width, Z.height = p.value.height;
      const he = Z.getContext("2d");
      he && (At.clearRect(0, 0, p.value.width, p.value.height), At.drawImage(Xt, 0, 0), c.value.forEach((ue) => {
        const [, Dt] = z.value[ue.id], [ee, yt, fe, Xe] = A(ue), Se = `rgba(${ee}, ${yt}, ${fe}, ${Xe / 255})`, Vt = F.value[ue.id];
        E(Z, he, Vt, Se, Dt[0], Dt[1]), At.drawImage(Z, 0, 0);
      }));
    }, at = Object.fromEntries(ai.map((Xt) => [Xt, Lt("")])), dt = () => {
      for (const Xt of ai)
        at[Xt].value = "";
      c.value.forEach((Xt) => {
        const [At, he, ue] = A(Xt), Dt = `rgb(${At}, ${he}, ${ue})`;
        at[Xt.id].value = Dt;
      });
    };
    dt();
    const gt = te(() => u.value === $e.MAXILLA ? Object.fromEntries(yd(d.value).map((Xt, At) => [ai[At], Xt])) : Object.fromEntries(gd(d.value).map((Xt, At) => [ai[At], Xt]))), Wt = te(() => {
      const Xt = g.getContext("2d");
      if (!Xt)
        return y;
      Xt.font = IXt;
      let At = 0, he = gE;
      for (const ee of ai) {
        const [, , yt] = z.value[ee], fe = yt[0] + 5, Xe = gt.value[ee] ?? "", Se = Xt.measureText(Xe).width, Vt = fe + Se;
        At = Math.min(At, fe), he = Math.max(he, Vt);
      }
      const ue = y - At, Dt = he - y;
      return Math.max(ue, Dt);
    }), Zt = Lt(0), Gt = new Uint8Array(49600), Tt = (Xt, At) => Gt[Xt + At * 248], Q = () => {
      if (!p.value || !H() || p.value.width <= 0 || p.value.height <= 0)
        return;
      const Xt = document.createElement("canvas");
      Xt.width = p.value.width, Xt.height = p.value.height;
      const At = Xt.getContext("2d");
      if (!At)
        return;
      const he = Z.getContext("2d");
      if (!he)
        return;
      for (const Dt of ai) {
        const ee = F.value[Dt], [, yt] = z.value[Dt], fe = `rgb(${Dt}, 0, 0)`;
        E(Z, he, ee, fe, yt[0], yt[1]), At.drawImage(Z, 0, 0);
      }
      const ue = At.getImageData(0, 0, Xt.width, Xt.height).data;
      for (let Dt = 0; Dt < ue.length / 4; Dt++)
        Gt[Dt] = ue[Dt * 4];
    }, D = (Xt) => {
      if (!p.value)
        return null;
      const At = p.value.getBoundingClientRect();
      if (At.width <= 0 || At.height <= 0)
        return null;
      const he = (Xt.clientX - At.left) / At.width, ue = (Xt.clientY - At.top) / At.height, Dt = Math.min(p.value.width - 1, Math.max(0, Math.floor(he * p.value.width))), ee = Math.min(p.value.height - 1, Math.max(0, Math.floor(ue * p.value.height)));
      return { x: Dt, y: ee };
    }, q = (Xt) => {
      const At = D(Xt);
      if (!At)
        return;
      const he = Tt(At.x, At.y);
      he !== 0 && l("toothClick", he, Xt, o.jawboneType);
    }, nt = (Xt) => {
      const At = D(Xt);
      if (!At)
        return;
      const he = Tt(At.x, At.y);
      he !== Zt.value && (Zt.value !== 0 && l("toothMouseOut", Zt.value, Xt, o.jawboneType), he !== 0 && l("toothMouseOver", he, Xt, o.jawboneType), l("update:modelValue", he), Zt.value = he);
    }, et = (Xt) => {
      const At = D(Xt);
      if (!At)
        return;
      const he = Tt(At.x, At.y);
      he !== 0 && l("toothClickRight", he, Xt, o.jawboneType);
    };
    B(() => {
      u.value === $e.MAXILLA && (ct(), Q());
    }), $(() => {
      u.value === $e.MANDIBLE && (ct(), Q());
    }), gn(
      c,
      () => {
        j() && ct(), dt(), mt();
      },
      { deep: !0 }
    ), gn(u, () => {
      H() && (ct(), Q()), mt();
    }), gn(d, () => {
      mt();
    });
    const ot = (Xt) => {
      const [, , At] = z.value[Xt];
      return {
        left: At[0] + 5 + "px",
        top: At[1] + 2 + "px"
      };
    }, it = (Xt) => {
      const At = F.value[Xt], [, he] = z.value[Xt];
      let ue = 0, Dt = 0;
      return At != null && At.complete && (ue = At.width / 2 - 14, Dt = At.height / 2 - 14), {
        left: he[0] + ue + "px",
        top: he[1] + Dt + h.value + "px"
      };
    }, ht = () => u.value === $e.MAXILLA ? { top: "50%" } : { top: "10%" }, lt = () => {
      if (m.value) {
        const At = (m.value.offsetWidth || m.value.clientWidth || m.value.getBoundingClientRect().width) / 2;
        b.value = Math.min(1, Math.max(0.1, At / Wt.value));
      }
    }, mt = () => {
      requestAnimationFrame(lt);
    };
    let wt = null;
    return xn(() => {
      mt(), wt = new ResizeObserver(() => {
        lt();
      }), m.value && wt && wt.observe(m.value);
    }), yr(() => {
      wt && wt.disconnect();
    }), (Xt, At) => (Mt(), Ot("div", {
      class: Rn(T.value),
      ref_key: "container",
      ref: m,
      style: { height: "214px", "user-select": "none" }
    }, [
      kt("div", {
        style: xe({
          paddingTop: h.value + "px",
          transform: `scale(${b.value})`,
          transformOrigin: "center top"
        }),
        class: Rn(M.value)
      }, [
        kt("canvas", {
          id: "canvas",
          ref_key: "canvas",
          ref: p,
          class: Rn([{ "cursor-pointer": Zt.value !== 0 }, "all-radius-8"]),
          onClick: q,
          onMousemove: nt,
          onContextmenu: et
        }, null, 34),
        (Mt(!0), Ot(Me, null, Xn(z.value, (he, ue) => (Mt(), Ot("div", {
          key: ue,
          style: xe([[
            {
              color: K(at)[ue].value
            },
            ot(ue)
          ], { "font-size": "12px", "font-weight": "bold", "text-shadow": "1px 1px 5px rgba(0, 0, 0, 1)" }]),
          class: "absolute shadow-sm",
          "data-cy": "toothLabel" + gt.value[ue],
          onClick: (Dt) => l("toothClick", Number(ue), Dt, o.jawboneType)
        }, pe(gt.value[ue]), 13, SXt))), 128)),
        kt("div", {
          class: "absolute w-6/12 h-6 flex justify-center",
          style: xe([ht(), { "text-align": "center", left: "25%" }])
        }, [
          kt("span", LXt, pe(i.warningString), 1)
        ], 4),
        (Mt(!0), Ot(Me, null, Xn(K(c), (he) => (Mt(), Ot(Me, {
          key: he.id
        }, [
          Zt.value == he.id ? (Mt(), Ot(Me, { key: 0 }, [
            he.hoverIcon === K(Yr).ADD ? (Mt(), Ot("img", {
              key: 0,
              id: "imgHoveredTooth",
              style: xe([it(he.id), { width: "28px", height: "28px", "pointer-events": "none" }]),
              class: "absolute rounded-full",
              src: K(f).getAssetUrl("/resources/teeth/AddPin.png"),
              draggable: "false"
            }, null, 12, VXt)) : he.hoverIcon === K(Yr).REMOVE ? (Mt(), Ot("img", {
              key: 1,
              style: xe([it(he.id), { width: "28px", height: "28px", "pointer-events": "none" }]),
              class: "absolute rounded-full",
              src: K(f).getAssetUrl("/resources/teeth/RemovePin.png"),
              draggable: "false"
            }, null, 12, XXt)) : Qt("", !0)
          ], 64)) : Qt("", !0)
        ], 64))), 128))
      ], 6)
    ], 2));
  }
}), jW = /* @__PURE__ */ Dn(CXt, [["__scopeId", "data-v-faddbe40"]]), YXt = { style: { flex: "1 1 0" } }, vXt = { style: { flex: "1 1 0" } }, RXt = { style: { flex: "1 1 0" } }, DXt = { style: { flex: "1 1 0" } }, OXt = { style: { flex: "1 1 0" } }, zXt = { style: { flex: "1 1 0" } }, EXt = /* @__PURE__ */ Ne({
  __name: "SelectActiveReconstructionDialog",
  emits: ["confirm", "reject"],
  setup(i, { emit: t }) {
    const e = gr("dialogRef"), n = e.value.data, s = t, r = Lt([]), a = Lt("");
    let o;
    const l = Lt(""), c = Lt(""), u = Lt(""), d = Lt(""), h = Lt(""), p = Lt(0), m = Lt([]), b = Lt([]), y = () => {
      s("reject"), e.value.close();
    }, Z = () => {
      s("confirm"), e.value.close();
    }, g = Lt(n.context.settings.general.useUSStyleToothChart), f = (x) => x === $e.MANDIBLE ? gd(g.value) : yd(g.value), T = f($e.MAXILLA).map((x, V) => ({
      id: V + 1,
      editMode: x2.NO_EDIT,
      status: _e.EMPTY,
      hoverIcon: Yr.NONE,
      toothName: x
    })), M = f($e.MANDIBLE).map((x, V) => ({
      id: V + 1,
      editMode: x2.NO_EDIT,
      status: _e.EMPTY,
      hoverIcon: Yr.NONE,
      toothName: x
    })), N = (x) => {
      for (let V = 0; V < x.size(); V++) {
        const X = x.get(V), C = T.find((z) => z.toothName == X);
        C && (C.status = _e.OK);
        const R = M.find((z) => z.toothName == X);
        R && (R.status = _e.OK);
      }
    }, W = (x) => {
      if (o) {
        l.value = o.GetTitle();
        const V = o.OnChooseReconstructionChanged(x);
        console.log("onReconstructionChange data:", V), N(V.mTeethNames), c.value = V.mType, u.value = V.mName, d.value = V.mTeethLibrary, h.value = V.mPrefabricated;
        const X = V.mObjectTypes, C = V.mObjectTypes;
        p.value = X.size();
        const R = [], z = [];
        for (let F = 0; F < p.value; F++)
          R.push(X.get(F)), z.push(C.get(F));
        m.value = R, b.value = z, console.log("Otypes", X, "oNames", C), V.delete();
      }
    };
    return xn(async () => {
      const x = ge(n.context.contextCAD.GetMainForm());
      if (x) {
        o = x.GetSelectActiveReconstructionWidget();
        const V = o.GetReconstructionItems(), X = [];
        for (let C = 0; C < V.size(); C++) {
          const R = V.get(C);
          X.push({ label: R, value: R });
        }
        r.value = X, gn(a, (C) => {
          W(C);
        }), a.value = o.GetSelectedItem();
      }
    }), (x, V) => {
      const X = tr("MUButton");
      return Mt(), le(K(Te), {
        class: "h-full",
        style: { "user-select": "none", "flex-direction": "column" }
      }, {
        default: oe(() => [
          Pt(K(Te), { class: "p-dialog-header text-3xl" }, {
            default: oe(() => [
              Ws(pe(l.value), 1)
            ]),
            _: 1
          }),
          Pt(K(Te), {
            class: "gap-4 mt-6",
            style: { "flex-direction": "row", "margin-bottom": "auto" }
          }, {
            default: oe(() => [
              Pt(K(Te), {
                class: "gap-2",
                style: { "flex-direction": "column", flex: "1 1 0" }
              }, {
                default: oe(() => [
                  Pt(K(Ku), {
                    modelValue: a.value,
                    "onUpdate:modelValue": V[0] || (V[0] = (C) => a.value = C),
                    options: r.value,
                    optionLabel: "label",
                    optionValue: "value"
                  }, null, 8, ["modelValue", "options"]),
                  Pt(K(Te), {
                    class: "gap-2 mt-2 ml-2",
                    style: { "flex-direction": "column" }
                  }, {
                    default: oe(() => [
                      Pt(K(Te), { style: { "flex-direction": "row" } }, {
                        default: oe(() => [
                          V[3] || (V[3] = kt("span", { style: { flex: "1 1 0" } }, "Type:", -1)),
                          kt("span", YXt, pe(c.value), 1)
                        ]),
                        _: 1
                      }),
                      Pt(K(Te), { style: { "flex-direction": "row" } }, {
                        default: oe(() => [
                          V[4] || (V[4] = kt("span", { style: { flex: "1 1 0" } }, "Name:", -1)),
                          kt("span", vXt, pe(u.value), 1)
                        ]),
                        _: 1
                      }),
                      (Mt(!0), Ot(Me, null, Xn(p.value, (C) => (Mt(), le(K(Te), {
                        style: { "flex-direction": "row" },
                        key: C
                      }, {
                        default: oe(() => [
                          kt("span", RXt, pe(m.value[C - 1]) + ":", 1),
                          kt("span", DXt, pe(b.value[C - 1]), 1)
                        ]),
                        _: 2
                      }, 1024))), 128)),
                      Pt(K(Te), { style: { "flex-direction": "row" } }, {
                        default: oe(() => [
                          V[5] || (V[5] = kt("span", { style: { flex: "1 1 0" } }, "Teeth Library:", -1)),
                          kt("span", OXt, pe(d.value), 1)
                        ]),
                        _: 1
                      }),
                      Pt(K(Te), { style: { "flex-direction": "row" } }, {
                        default: oe(() => [
                          V[6] || (V[6] = kt("span", { style: { flex: "1 1 0" } }, "Prefabricated:", -1)),
                          kt("span", zXt, pe(h.value), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              Pt(K(Te), { style: { "flex-direction": "row", flex: "1 1 0" } }, {
                default: oe(() => [
                  Pt(K(Te), { style: { "pointer-events": "none", flex: "1 1 0", "flex-direction": "column", "justify-content": "center" } }, {
                    default: oe(() => [
                      Pt(jW, {
                        class: "mt-6",
                        style: { "justify-content": "center" },
                        jawboneType: K($e).MAXILLA,
                        teeth: K(T),
                        useUSStyleToothChart: g.value,
                        warningString: "",
                        "show-lines": !0
                      }, null, 8, ["jawboneType", "teeth", "useUSStyleToothChart"]),
                      Pt(jW, {
                        style: { "justify-content": "center" },
                        jawboneType: K($e).MANDIBLE,
                        teeth: K(M),
                        useUSStyleToothChart: g.value,
                        warningString: "",
                        "show-lines": !0
                      }, null, 8, ["jawboneType", "teeth", "useUSStyleToothChart"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          Pt(K(Te), { class: "p-dialog-footer justify-center mt-6" }, {
            default: oe(() => [
              Pt(X, {
                label: "OK",
                onClick: V[1] || (V[1] = (C) => Z()),
                "icon-src-height": "21px",
                "icon-src-width": "21px",
                iconSrc: "/icons/rg_check.svg"
              }),
              Pt(X, {
                label: "Cancel",
                onClick: V[2] || (V[2] = (C) => y()),
                "icon-src-height": "21px",
                "icon-src-width": "21px",
                iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), kXt = /* @__PURE__ */ Ne({
  __name: "ReconstructionReviewDialog",
  emits: ["confirm", "reject"],
  setup(i, { emit: t }) {
    const { t: e } = La(), n = gr("dialogRef"), s = n.value.data, r = ge(s.context), a = t, o = gb(), l = Lt([]), c = Lt(""), u = Lt(Math.random());
    let d, h = !1, p = !1;
    const m = () => {
      p && (r.contextCAD.ClearJSLambda(_o.eJSLT_DIALOG_STATIC_GUI_RETRIEVE), p = !1);
    }, b = () => {
      const f = d;
      d = void 0, f && f.ClearDialogCloseCallback();
    }, y = (f = !0) => {
      h || (h = !0, m(), b(), a("confirm"), f && n.value.close());
    }, Z = () => {
      y();
    }, g = () => {
      r.contextCAD.SetJSLambda((f) => {
        if (h)
          return;
        if (!f) {
          o.value = void 0, l.value = [], c.value = "", u.value = Math.random();
          return;
        }
        const T = ge(f);
        l.value = T.GetWidgetOrder().slice(), o.value = ge(T.GetWidgets()), c.value = T.GetToolTitle(), u.value = Math.random();
      }, _o.eJSLT_DIALOG_STATIC_GUI_RETRIEVE), p = !0;
    };
    return xn(() => {
      const f = ge(r.contextCAD.GetMainForm());
      if (!f) {
        y();
        return;
      }
      if (d = ge(f.GetReconstructionReviewWidget()), !d) {
        y();
        return;
      }
      d.SetDialogCloseCallback(() => {
        y();
      }), g(), d.RetrieveDialogGUI();
    }), yr(() => {
      if (!h) {
        y(!1);
        return;
      }
      m(), b();
    }), (f, T) => (Mt(), le(K(Te), { style: { "flex-direction": "column", flex: "1 1 0", "min-height": "0", width: "100%" } }, {
      default: oe(() => [
        Pt(K(Te), { style: { flex: "1 1 0", "min-height": "0", overflow: "auto", padding: "0 0.25rem" } }, {
          default: oe(() => [
            o.value ? (Mt(), le(K(w2), {
              key: u.value,
              "widget-params": o.value,
              "tool-title": c.value,
              "widget-order": l.value,
              smallFont: !0,
              context: K(r),
              "retrieve-active-widget-on-mount": !1
            }, null, 8, ["widget-params", "tool-title", "widget-order", "context"])) : Qt("", !0)
          ]),
          _: 1
        }),
        Pt(K(Te), { class: "p-dialog-footer justify-center mt-4" }, {
          default: oe(() => [
            Pt(K(ye), {
              label: K(e)("shared.close"),
              onClick: T[0] || (T[0] = (M) => Z()),
              "icon-src-height": "21px",
              "icon-src-width": "21px",
              iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg"
            }, null, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
});
class MB {
  constructor(t, e, n) {
    S(this, "vtkContainer");
    S(this, "renderWindow");
    S(this, "renderer");
    S(this, "firstInit", !0);
    S(this, "addedStls", /* @__PURE__ */ new Map());
    S(this, "deleteAddedActorInputData", !1);
    this.vtkContainer = t, this.renderer = e, this.renderWindow = n;
  }
  async onFileSelected(t, e, n) {
    const s = this.addedStls.get(t.name);
    if (s ? this.addActor(s) : await this.handleFileUpload(t, e, n), this.renderWindow.render(), this.firstInit) {
      const o = this.renderer.getActiveCamera(), l = [0, 0, 0];
      l[1] -= 1, o.setPosition(l[0], l[1], l[2]), o.setDirectionOfProjection(0, 1, 0), o.setFocalPoint(0, 0, 0), o.setViewUp(0, 0, 1), o.setParallelProjection(!0), o.zoom(1), this.firstInit = !1;
    }
    const r = this.renderer.computeVisiblePropBounds(), a = this.renderer.getActiveCamera();
    if (a.getParallelProjection()) {
      const o = a.getFocalPoint(), l = [r[0], r[2], r[4]], c = [r[1], r[3], r[5]], u = Math.max(Math.sqrt(Hn.distance2BetweenPoints(o, l)), Hn.distance2BetweenPoints(o, c)), d = 0.5 * Hn.radiansFromDegrees(a.getViewAngle()), h = 2 * u + u / Math.tan(d);
      I.scaleAndAdd(o, o, a.getDirectionOfProjection(), -10 * h), a.setPosition(...o);
    }
    this.renderer.resetCameraClippingRange(r), this.renderer.resetCamera(), this.renderWindow.render();
  }
  onFileUnselected(t) {
    const e = this.addedStls.get(t.name);
    e && this.removeActor(e), this.renderWindow.render();
  }
  clearAll() {
    this.deleteAddedActors({ deleteInputData: this.deleteAddedActorInputData }), this.renderWindow.render(), this.firstInit = !0;
  }
  addActor(t) {
    this.renderer && (this.renderer.getViewProps().includes(t) || this.renderer.addActor(t));
  }
  removeActor(t) {
    this.renderer && this.renderer.getViewProps().includes(t) && this.renderer.removeActor(t);
  }
  releaseGraphicsResources(t) {
    var e;
    try {
      (e = t == null ? void 0 : t.releaseGraphicsResources) == null || e.call(t);
    } catch (n) {
      console.warn("Failed to release upload preview graphics resources", n);
    }
  }
  deleteAddedActors(t) {
    this.addedStls.forEach((e) => {
      var r, a, o, l;
      this.removeActor(e);
      const n = (r = e.getMapper) == null ? void 0 : r.call(e), s = t != null && t.deleteInputData ? (a = n == null ? void 0 : n.getInputData) == null ? void 0 : a.call(n) : void 0;
      e.delete(), (o = s == null ? void 0 : s.delete) == null || o.call(s), (l = n == null ? void 0 : n.delete) == null || l.call(n);
    }), this.addedStls.clear();
  }
}
class FXt extends MB {
  constructor(e, n) {
    const s = YT.newInstance(), r = ld.newInstance();
    super(e, r, s);
    S(this, "interactor", RT.newInstance());
    S(this, "openGLRenderWindow", vT.newInstance());
    S(this, "resizeObserver");
    S(this, "destructed", !1);
    S(this, "deleteAddedActorInputData", !0);
    this.renderWindow.addRenderer(this.renderer), this.openGLRenderWindow.setContainer(this.vtkContainer), this.renderWindow.addView(this.openGLRenderWindow), this.interactor.setView(this.openGLRenderWindow), this.interactor.initialize(), this.interactor.setContainer(this.vtkContainer);
    const a = GC.newInstance();
    this.interactor.setInteractorStyle(a);
    let o = n;
    o || (o = [0.933, 0.933, 0.933, 0]), this.renderer.setBackground(o), this.renderer.resetCamera(), this.renderWindow.render(), this.resizeObserver = new ResizeObserver(() => {
      const { width: l, height: c } = this.vtkContainer.getBoundingClientRect();
      this.openGLRenderWindow.setSize(Math.floor(l), Math.floor(c)), this.renderWindow.render();
    }), this.resizeObserver.observe(this.vtkContainer);
  }
  async handleFileUpload(e) {
    if (p0(e.name)) {
      let n;
      const s = Ue.newInstance();
      if (e.name.endsWith(".ply")) {
        const l = p9.newInstance(), c = await e.arrayBuffer();
        l.parseAsArrayBuffer(c), s.setScalarVisibility(!0), n = l.getOutputData();
      } else if (e.name.endsWith(".stl")) {
        const l = zG.newInstance(), c = await e.arrayBuffer();
        l.parseAsArrayBuffer(c), n = l.getOutputData(), s.setScalarVisibility(!1);
      } else if (e.name.endsWith(".obj"))
        n = (await EG(e)).getOutputData();
      else
        return;
      s.setInputData(n);
      const r = Re.newInstance();
      r.setMapper(s), r.getProperty().setColor(1, 1, 1), this.addedStls.set(e.name, r), this.addActor(r);
      const { width: a, height: o } = this.vtkContainer.getBoundingClientRect();
      this.openGLRenderWindow.setSize(Math.floor(a), Math.floor(o));
    }
  }
  delete() {
    var e;
    this.destructed || (this.destructed = !0, (e = this.resizeObserver) == null || e.disconnect(), this.interactor.unbindEvents(), this.interactor.delete(), this.releaseGraphicsResources(this.openGLRenderWindow), this.deleteAddedActors({ deleteInputData: this.deleteAddedActorInputData }), this.renderWindow.removeRenderer(this.renderer), this.renderWindow.removeView(this.openGLRenderWindow), this.openGLRenderWindow.setContainer(null), this.openGLRenderWindow.delete(), this.renderer.delete(), this.renderWindow.delete());
  }
}
const jXt = [".png", ".jpg", ".jpeg"], UXt = ".mtl";
function O2(i) {
  return i.webkitRelativePath || i.name;
}
function yE(i) {
  const t = O2(i), e = t.lastIndexOf("/");
  return e === -1 ? "" : t.slice(0, e);
}
function UW(i) {
  return i.replace(/\.[^/.]+$/, "");
}
function NB(i) {
  const t = i.toLowerCase();
  return jXt.some((e) => t.endsWith(e));
}
function WB(i) {
  return i.toLowerCase().endsWith(UXt);
}
function hV(i, t, e) {
  const n = UW(i.name).toLowerCase(), s = t.toLowerCase();
  return n === s || n.includes(s) ? !0 : e != null && e.textureNameRegex ? e.textureNameRegex.test(i.name) : !1;
}
function PXt(i, t, e, n) {
  if (!i.length) return;
  const s = yE(t), r = i.filter((c) => yE(c) === s), a = r.find((c) => UW(c.name).toLowerCase() === e.toLowerCase());
  if (a) return a;
  const o = r.find((c) => hV(c, e, n));
  if (o) return o;
  const l = i.find((c) => UW(c.name).toLowerCase() === e.toLowerCase());
  return l || i.find((c) => hV(c, e, n));
}
function oOt(i, t, e) {
  const n = UW(i.name), s = t.filter((l) => NB(l.name)), r = t.filter((l) => WB(l.name)), a = PXt(r, i, n, e), o = s.filter((l) => hV(l, n, e));
  return {
    mtlFile: a,
    textureFiles: o
  };
}
function lOt(i) {
  const t = [], e = i.split(/\r?\n/);
  for (const n of e) {
    const s = n.trim();
    if (!s || s.startsWith("#")) continue;
    const r = s.split(/\s+/), a = r[0].toLowerCase();
    if (a.startsWith("map_") || a === "bump" || a === "refl") {
      const o = r[r.length - 1];
      o && t.push(o);
    }
  }
  return t;
}
async function JXt(i, t, e, n, s) {
  const r = i.find((u) => p0(u.name)), a = i.find((u) => u.name.endsWith(".jpg") || u.name.endsWith(".jpeg") || u.name.endsWith(".png"));
  let o = null, l = null;
  r && (o = new File([r], r.name, { type: ".stl" })), a && (l = new File([a], a.name, { type: ".jpg" }));
  let c;
  if (!o && l && n) {
    const u = await l.arrayBuffer(), d = new Int8Array(u);
    c = await vn.from2DImageFile({
      context: t,
      path: l.name,
      intArr: d,
      cadType: s ?? Pe.eOT_TEXTURED_FRONT_IMAGE,
      skipCopyToWasm: !0
    }), c.setName(l.name);
  } else if (o) {
    const u = await o.arrayBuffer(), d = new Int8Array(u);
    let h, p;
    if (l) {
      const y = await l.arrayBuffer();
      h = new Int8Array(y), p = l.name;
    }
    let m = Yt._STL_OBJECT, b = [255, 255, 255];
    e == "Anatomy" ? (m = Yt._STL_TEETH_MODEL, b = t.settings.defaultColors.teethScanStl) : e == "Waxup-Prosthesis" ? m = Yt._STL_PROSTHESIS : e == "Antagonist" && (b = t.settings.defaultColors.prosthesisScanStl), c = await vn.fromFile({
      context: t,
      path: o.name,
      intArr: d,
      oType: m,
      textureIntArr: h,
      texturePath: p,
      cadType: s ?? (e == "Face Scan" ? Pe.eOT_IP_FACE_SCAN : Pe.eOT_MODEL)
    }), c.setLocked(!0), c.setColor(Kn(b)), c.setName(e), t.objects.stls.set(c.id, c), c.update3dInfo();
  } else
    console.error("No file to upload found");
  return c;
}
async function cOt(i, t, e, n) {
  if (!t.wasmStlObject)
    throw new Error("StlObject has no wasmStlObject for export");
  await i.getEngineInstance();
  const s = i.getFS(), r = "/app", a = 1;
  n === "stl" ? ge(t.wasmStlObject).ExportToSTLFile(r, e, a) : ge(t.wasmStlObject).ExportToPLYFile(r, e, a);
  const o = `${r}/${e}.${n}`, l = s.FS.readFile(o), c = new File([l], `${e}.${n}`);
  let u;
  const d = `${r}/${e}.jpg`;
  if (n === "ply")
    try {
      const p = s.FS.readFile(d);
      u = new File([p], `${e}.jpg`);
    } catch {
    }
  return { meshFile: c, textureFile: u, unlinkCb: () => {
    s.FS.unlink(o), u && s.FS.unlink(d);
  } };
}
async function AXt(i, t, e, n) {
  let s = Yt._STL_OBJECT, r = [255, 255, 255];
  i == "Anatomy" ? (s = Yt._STL_TEETH_MODEL, r = t.settings.defaultColors.teethScanStl) : i == "Waxup-Prosthesis" ? s = Yt._STL_PROSTHESIS : i == "Antagonist" && (r = t.settings.defaultColors.prosthesisScanStl);
  const a = await vn.fromFileBase({
    context: t,
    path: e,
    oType: s,
    cadType: n ?? (i == "Face Scan" ? Pe.eOT_IP_FACE_SCAN : Pe.eOT_MODEL)
  });
  return a.setLocked(!0), a.setColor(Kn(r)), a.setName(i || ""), a.update3dInfo(), a;
}
async function uOt(i, t, e, n, s) {
  if (!p0(i.name)) return !1;
  const r = await i.arrayBuffer(), a = new Int8Array(r);
  return BXt(a, t, e, n, i.name, s);
}
async function BXt(i, t, e, n, s, r) {
  const a = await t.getFS(), o = s ?? "tmpObjectForUpload.stl";
  a.FS.writeFile(o, i);
  const l = ge(t.contextCAD.GetMainForm()).AppendMeshLabelToDocument(o, e, n ?? Pe.eOT_MODEL, r ?? !1);
  return a.FS.unlink(o), l;
}
class KXt extends MB {
  constructor(e, n, s) {
    console.log("UploadPreviewGeneratorWasm constructor");
    const r = YT.newInstance(), a = ld.newInstance();
    super(e, a, r);
    S(this, "context");
    S(this, "cleanupFiles");
    S(this, "interactor", RT.newInstance());
    S(this, "openGLRenderWindow", vT.newInstance());
    S(this, "resizeObserver");
    S(this, "destructed", !1);
    this.context = n, this.cleanupFiles = (s == null ? void 0 : s.cleanupFiles) !== !1, this.renderWindow.addRenderer(this.renderer), this.openGLRenderWindow.setContainer(this.vtkContainer), this.renderWindow.addView(this.openGLRenderWindow), this.interactor.setView(this.openGLRenderWindow), this.interactor.initialize(), this.interactor.setContainer(this.vtkContainer);
    const o = GC.newInstance();
    this.interactor.setInteractorStyle(o);
    let l = [0.933, 0.933, 0.933, 0];
    this.renderer.setBackground(l), this.renderer.resetCamera(), this.renderWindow.render(), this.resizeObserver = new ResizeObserver(() => {
      const { width: c, height: u } = this.vtkContainer.getBoundingClientRect();
      this.openGLRenderWindow.setSize(Math.floor(c), Math.floor(u)), this.renderWindow.render();
    }), this.resizeObserver.observe(this.vtkContainer);
  }
  async handleFileUpload(e, n, s) {
    const r = [e];
    s && r.push(s), await this.context.getEngineInstance();
    let a;
    if (this.cleanupFiles ? a = await JXt(r, this.context, n, !1) : (a = await AXt(n, this.context, O2(e)), this.context.objects.tmpStls.set(a.id, a), this.context.objects.registerTmpStlForFile(O2(e), a)), !a) return;
    const { mapper: o, actor: l } = a.createActorObjects();
    this.addActor(l), this.addedStls.set(e.name, l);
  }
  delete() {
    var e;
    this.destructed || (this.destructed = !0, (e = this.resizeObserver) == null || e.disconnect(), this.interactor.unbindEvents(), this.interactor.delete(), this.releaseGraphicsResources(this.openGLRenderWindow), this.deleteAddedActors(), this.renderWindow.removeRenderer(this.renderer), this.renderWindow.removeView(this.openGLRenderWindow), this.openGLRenderWindow.setContainer(null), this.openGLRenderWindow.delete(), this.renderer.delete(), this.renderWindow.delete());
  }
}
const GB = /* @__PURE__ */ Ne({
  __name: "VtkPreviewComponent",
  props: {
    selectedFiles: {},
    allFiles: {},
    context: {},
    cleanupFiles: { type: Boolean },
    objectName: {}
  },
  setup(i) {
    const t = i, { selectedFiles: e, allFiles: n } = Vo(t), s = Lt();
    let r;
    xn(async () => {
      t.context ? r = new KXt(s.value, t.context, { cleanupFiles: t.cleanupFiles }) : r = new FXt(s.value, [0, 0, 0, 0]), await a();
    }), yr(() => {
      r.delete();
    });
    async function a() {
      if (n.value) {
        if (e.value.length == 0)
          r.clearAll();
        else
          for (let o of n.value)
            if (p0(o.name)) {
              let l = !1;
              for (let c of e.value)
                c.name == o.name && (await r.onFileSelected(c, t.objectName), l = !0);
              l || r.onFileUnselected(o);
            }
      }
    }
    return gn(e, async () => {
      await a();
    }), (o, l) => (Mt(), Ot("div", {
      ref_key: "vtkContainer",
      ref: s,
      class: "flex grow shrink",
      style: { height: "99%" }
    }, null, 512));
  }
}), Ma = typeof process == "object" && process + "" == "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser"), pV = [1e-3, 0, 0, 1e-3, 0, 0], CS = 1.35, fo = {
  ANY: 1,
  DISPLAY: 2,
  PRINT: 4,
  ANNOTATIONS_FORMS: 16,
  ANNOTATIONS_STORAGE: 32,
  ANNOTATIONS_DISABLE: 64,
  IS_EDITING: 128,
  OPLIST: 256
}, Yc = {
  DISABLE: 0,
  ENABLE: 1,
  ENABLE_FORMS: 2,
  ENABLE_STORAGE: 3
}, z2 = "pdfjs_internal_editor_", fn = {
  DISABLE: -1,
  NONE: 0,
  FREETEXT: 3,
  HIGHLIGHT: 9,
  STAMP: 13,
  INK: 15,
  POPUP: 16,
  SIGNATURE: 101,
  COMMENT: 102
}, Un = {
  RESIZE: 1,
  CREATE: 2,
  FREETEXT_SIZE: 11,
  FREETEXT_COLOR: 12,
  FREETEXT_OPACITY: 13,
  INK_COLOR: 21,
  INK_THICKNESS: 22,
  INK_OPACITY: 23,
  HIGHLIGHT_COLOR: 31,
  HIGHLIGHT_THICKNESS: 32,
  HIGHLIGHT_FREE: 33,
  HIGHLIGHT_SHOW_ALL: 34,
  DRAW_STEP: 41
}, HXt = {
  PRINT: 4,
  MODIFY_CONTENTS: 8,
  COPY: 16,
  MODIFY_ANNOTATIONS: 32,
  FILL_INTERACTIVE_FORMS: 256,
  COPY_FOR_ACCESSIBILITY: 512,
  ASSEMBLE: 1024,
  PRINT_HIGH_QUALITY: 2048
}, Tr = {
  FILL: 0,
  STROKE: 1,
  FILL_STROKE: 2,
  INVISIBLE: 3,
  FILL_STROKE_MASK: 3,
  ADD_TO_PATH_FLAG: 4
}, WN = {
  GRAYSCALE_1BPP: 1,
  RGB_24BPP: 2,
  RGBA_32BPP: 3
}, Rs = {
  TEXT: 1,
  LINK: 2,
  FREETEXT: 3,
  LINE: 4,
  SQUARE: 5,
  CIRCLE: 6,
  POLYGON: 7,
  POLYLINE: 8,
  HIGHLIGHT: 9,
  UNDERLINE: 10,
  SQUIGGLY: 11,
  STRIKEOUT: 12,
  STAMP: 13,
  CARET: 14,
  INK: 15,
  POPUP: 16,
  FILEATTACHMENT: 17,
  SOUND: 18,
  MOVIE: 19,
  WIDGET: 20,
  SCREEN: 21,
  PRINTERMARK: 22,
  TRAPNET: 23,
  WATERMARK: 24,
  THREED: 25,
  REDACT: 26
}, cb = {
  SOLID: 1,
  DASHED: 2,
  BEVELED: 3,
  INSET: 4,
  UNDERLINE: 5
}, pw = {
  ERRORS: 0,
  WARNINGS: 1,
  INFOS: 5
}, E2 = {
  dependency: 1,
  setLineWidth: 2,
  setLineCap: 3,
  setLineJoin: 4,
  setMiterLimit: 5,
  setDash: 6,
  setRenderingIntent: 7,
  setFlatness: 8,
  setGState: 9,
  save: 10,
  restore: 11,
  transform: 12,
  moveTo: 13,
  lineTo: 14,
  curveTo: 15,
  curveTo2: 16,
  curveTo3: 17,
  closePath: 18,
  rectangle: 19,
  stroke: 20,
  closeStroke: 21,
  fill: 22,
  eoFill: 23,
  fillStroke: 24,
  eoFillStroke: 25,
  closeFillStroke: 26,
  closeEOFillStroke: 27,
  endPath: 28,
  clip: 29,
  eoClip: 30,
  beginText: 31,
  endText: 32,
  setCharSpacing: 33,
  setWordSpacing: 34,
  setHScale: 35,
  setLeading: 36,
  setFont: 37,
  setTextRenderingMode: 38,
  setTextRise: 39,
  moveText: 40,
  setLeadingMoveText: 41,
  setTextMatrix: 42,
  nextLine: 43,
  showText: 44,
  showSpacedText: 45,
  nextLineShowText: 46,
  nextLineSetSpacingShowText: 47,
  setCharWidth: 48,
  setCharWidthAndBounds: 49,
  setStrokeColorSpace: 50,
  setFillColorSpace: 51,
  setStrokeColor: 52,
  setStrokeColorN: 53,
  setFillColor: 54,
  setFillColorN: 55,
  setStrokeGray: 56,
  setFillGray: 57,
  setStrokeRGBColor: 58,
  setFillRGBColor: 59,
  setStrokeCMYKColor: 60,
  setFillCMYKColor: 61,
  shadingFill: 62,
  beginInlineImage: 63,
  beginImageData: 64,
  endInlineImage: 65,
  paintXObject: 66,
  markPoint: 67,
  markPointProps: 68,
  beginMarkedContent: 69,
  beginMarkedContentProps: 70,
  endMarkedContent: 71,
  beginCompat: 72,
  endCompat: 73,
  paintFormXObjectBegin: 74,
  paintFormXObjectEnd: 75,
  beginGroup: 76,
  endGroup: 77,
  beginAnnotation: 80,
  endAnnotation: 81,
  paintImageMaskXObject: 83,
  paintImageMaskXObjectGroup: 84,
  paintImageXObject: 85,
  paintInlineImageXObject: 86,
  paintInlineImageXObjectGroup: 87,
  paintImageXObjectRepeat: 88,
  paintImageMaskXObjectRepeat: 89,
  paintSolidColorImageMask: 90,
  constructPath: 91,
  setStrokeTransparent: 92,
  setFillTransparent: 93,
  rawFillPath: 94
}, DM = {
  moveTo: 0,
  lineTo: 1,
  curveTo: 2,
  closePath: 3
}, _Xt = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
};
let mw = pw.WARNINGS;
function QXt(i) {
  Number.isInteger(i) && (mw = i);
}
function $Xt() {
  return mw;
}
function bw(i) {
  mw >= pw.INFOS && console.info(`Info: ${i}`);
}
function pn(i) {
  mw >= pw.WARNINGS && console.warn(`Warning: ${i}`);
}
function Xi(i) {
  throw new Error(i);
}
function Pn(i, t) {
  i || Xi(t);
}
function qXt(i) {
  switch (i == null ? void 0 : i.protocol) {
    case "http:":
    case "https:":
    case "ftp:":
    case "mailto:":
    case "tel:":
      return !0;
    default:
      return !1;
  }
}
function wB(i, t = null, e = null) {
  if (!i)
    return null;
  if (e && typeof i == "string") {
    if (e.addDefaultProtocol && i.startsWith("www.")) {
      const s = i.match(/\./g);
      (s == null ? void 0 : s.length) >= 2 && (i = `http://${i}`);
    }
    if (e.tryConvertEncoding)
      try {
        i = sIt(i);
      } catch {
      }
  }
  const n = t ? URL.parse(i, t) : URL.parse(i);
  return qXt(n) ? n : null;
}
function xB(i, t, e = !1) {
  const n = URL.parse(i);
  return n ? (n.hash = t, n.href) : e && wB(i, "http://example.com") ? i.split("#", 1)[0] + `${t ? `#${t}` : ""}` : "";
}
function Gn(i, t, e, n = !1) {
  return Object.defineProperty(i, t, {
    value: e,
    enumerable: !n,
    configurable: !0,
    writable: !1
  }), e;
}
const Y0 = (function() {
  function t(e, n) {
    this.message = e, this.name = n;
  }
  return t.prototype = new Error(), t.constructor = t, t;
})();
class ZE extends Y0 {
  constructor(t, e) {
    super(t, "PasswordException"), this.code = e;
  }
}
class YS extends Y0 {
  constructor(t, e) {
    super(t, "UnknownErrorException"), this.details = e;
  }
}
class mV extends Y0 {
  constructor(t) {
    super(t, "InvalidPDFException");
  }
}
class PW extends Y0 {
  constructor(t, e, n) {
    super(t, "ResponseException"), this.status = e, this.missing = n;
  }
}
class tIt extends Y0 {
  constructor(t) {
    super(t, "FormatError");
  }
}
class $h extends Y0 {
  constructor(t) {
    super(t, "AbortException");
  }
}
function SB(i) {
  (typeof i != "object" || (i == null ? void 0 : i.length) === void 0) && Xi("Invalid argument for bytesToString");
  const t = i.length, e = 8192;
  if (t < e)
    return String.fromCharCode.apply(null, i);
  const n = [];
  for (let s = 0; s < t; s += e) {
    const r = Math.min(s + e, t), a = i.subarray(s, r);
    n.push(String.fromCharCode.apply(null, a));
  }
  return n.join("");
}
function KT(i) {
  typeof i != "string" && Xi("Invalid argument for stringToBytes");
  const t = i.length, e = new Uint8Array(t);
  for (let n = 0; n < t; ++n)
    e[n] = i.charCodeAt(n) & 255;
  return e;
}
function eIt(i) {
  return String.fromCharCode(i >> 24 & 255, i >> 16 & 255, i >> 8 & 255, i & 255);
}
function nIt() {
  const i = new Uint8Array(4);
  return i[0] = 1, new Uint32Array(i.buffer, 0, 1)[0] === 1;
}
function iIt() {
  try {
    return new Function(""), !0;
  } catch {
    return !1;
  }
}
class Er {
  static get isLittleEndian() {
    return Gn(this, "isLittleEndian", nIt());
  }
  static get isEvalSupported() {
    return Gn(this, "isEvalSupported", iIt());
  }
  static get isOffscreenCanvasSupported() {
    return Gn(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas < "u");
  }
  static get isImageDecoderSupported() {
    return Gn(this, "isImageDecoderSupported", typeof ImageDecoder < "u");
  }
  static get platform() {
    const {
      platform: t,
      userAgent: e
    } = navigator;
    return Gn(this, "platform", {
      isAndroid: e.includes("Android"),
      isLinux: t.includes("Linux"),
      isMac: t.includes("Mac"),
      isWindows: t.includes("Win"),
      isFirefox: e.includes("Firefox")
    });
  }
  static get isCSSRoundSupported() {
    var t, e;
    return Gn(this, "isCSSRoundSupported", (e = (t = globalThis.CSS) == null ? void 0 : t.supports) == null ? void 0 : e.call(t, "width: round(1.5px, 1px)"));
  }
}
const vS = Array.from(Array(256).keys(), (i) => i.toString(16).padStart(2, "0"));
var sd, GN, bV;
class ze {
  static makeHexColor(t, e, n) {
    return `#${vS[t]}${vS[e]}${vS[n]}`;
  }
  static domMatrixToTransform(t) {
    return [t.a, t.b, t.c, t.d, t.e, t.f];
  }
  static scaleMinMax(t, e) {
    let n;
    t[0] ? (t[0] < 0 && (n = e[0], e[0] = e[2], e[2] = n), e[0] *= t[0], e[2] *= t[0], t[3] < 0 && (n = e[1], e[1] = e[3], e[3] = n), e[1] *= t[3], e[3] *= t[3]) : (n = e[0], e[0] = e[1], e[1] = n, n = e[2], e[2] = e[3], e[3] = n, t[1] < 0 && (n = e[1], e[1] = e[3], e[3] = n), e[1] *= t[1], e[3] *= t[1], t[2] < 0 && (n = e[0], e[0] = e[2], e[2] = n), e[0] *= t[2], e[2] *= t[2]), e[0] += t[4], e[1] += t[5], e[2] += t[4], e[3] += t[5];
  }
  static transform(t, e) {
    return [t[0] * e[0] + t[2] * e[1], t[1] * e[0] + t[3] * e[1], t[0] * e[2] + t[2] * e[3], t[1] * e[2] + t[3] * e[3], t[0] * e[4] + t[2] * e[5] + t[4], t[1] * e[4] + t[3] * e[5] + t[5]];
  }
  static multiplyByDOMMatrix(t, e) {
    return [t[0] * e.a + t[2] * e.b, t[1] * e.a + t[3] * e.b, t[0] * e.c + t[2] * e.d, t[1] * e.c + t[3] * e.d, t[0] * e.e + t[2] * e.f + t[4], t[1] * e.e + t[3] * e.f + t[5]];
  }
  static applyTransform(t, e, n = 0) {
    const s = t[n], r = t[n + 1];
    t[n] = s * e[0] + r * e[2] + e[4], t[n + 1] = s * e[1] + r * e[3] + e[5];
  }
  static applyTransformToBezier(t, e, n = 0) {
    const s = e[0], r = e[1], a = e[2], o = e[3], l = e[4], c = e[5];
    for (let u = 0; u < 6; u += 2) {
      const d = t[n + u], h = t[n + u + 1];
      t[n + u] = d * s + h * a + l, t[n + u + 1] = d * r + h * o + c;
    }
  }
  static applyInverseTransform(t, e) {
    const n = t[0], s = t[1], r = e[0] * e[3] - e[1] * e[2];
    t[0] = (n * e[3] - s * e[2] + e[2] * e[5] - e[4] * e[3]) / r, t[1] = (-n * e[1] + s * e[0] + e[4] * e[1] - e[5] * e[0]) / r;
  }
  static axialAlignedBoundingBox(t, e, n) {
    const s = e[0], r = e[1], a = e[2], o = e[3], l = e[4], c = e[5], u = t[0], d = t[1], h = t[2], p = t[3];
    let m = s * u + l, b = m, y = s * h + l, Z = y, g = o * d + c, f = g, T = o * p + c, M = T;
    if (r !== 0 || a !== 0) {
      const N = r * u, W = r * h, x = a * d, V = a * p;
      m += x, Z += x, y += V, b += V, g += N, M += N, T += W, f += W;
    }
    n[0] = Math.min(n[0], m, y, b, Z), n[1] = Math.min(n[1], g, T, f, M), n[2] = Math.max(n[2], m, y, b, Z), n[3] = Math.max(n[3], g, T, f, M);
  }
  static inverseTransform(t) {
    const e = t[0] * t[3] - t[1] * t[2];
    return [t[3] / e, -t[1] / e, -t[2] / e, t[0] / e, (t[2] * t[5] - t[4] * t[3]) / e, (t[4] * t[1] - t[5] * t[0]) / e];
  }
  static singularValueDecompose2dScale(t, e) {
    const n = t[0], s = t[1], r = t[2], a = t[3], o = n ** 2 + s ** 2, l = n * r + s * a, c = r ** 2 + a ** 2, u = (o + c) / 2, d = Math.sqrt(u ** 2 - (o * c - l ** 2));
    e[0] = Math.sqrt(u + d || 1), e[1] = Math.sqrt(u - d || 1);
  }
  static normalizeRect(t) {
    const e = t.slice(0);
    return t[0] > t[2] && (e[0] = t[2], e[2] = t[0]), t[1] > t[3] && (e[1] = t[3], e[3] = t[1]), e;
  }
  static intersect(t, e) {
    const n = Math.max(Math.min(t[0], t[2]), Math.min(e[0], e[2])), s = Math.min(Math.max(t[0], t[2]), Math.max(e[0], e[2]));
    if (n > s)
      return null;
    const r = Math.max(Math.min(t[1], t[3]), Math.min(e[1], e[3])), a = Math.min(Math.max(t[1], t[3]), Math.max(e[1], e[3]));
    return r > a ? null : [n, r, s, a];
  }
  static pointBoundingBox(t, e, n) {
    n[0] = Math.min(n[0], t), n[1] = Math.min(n[1], e), n[2] = Math.max(n[2], t), n[3] = Math.max(n[3], e);
  }
  static rectBoundingBox(t, e, n, s, r) {
    r[0] = Math.min(r[0], t, n), r[1] = Math.min(r[1], e, s), r[2] = Math.max(r[2], t, n), r[3] = Math.max(r[3], e, s);
  }
  static bezierBoundingBox(t, e, n, s, r, a, o, l, c) {
    c[0] = Math.min(c[0], t, o), c[1] = Math.min(c[1], e, l), c[2] = Math.max(c[2], t, o), c[3] = Math.max(c[3], e, l), ft(this, sd, bV).call(this, t, n, r, o, e, s, a, l, 3 * (-t + 3 * (n - r) + o), 6 * (t - 2 * n + r), 3 * (n - t), c), ft(this, sd, bV).call(this, t, n, r, o, e, s, a, l, 3 * (-e + 3 * (s - a) + l), 6 * (e - 2 * s + a), 3 * (s - e), c);
  }
}
sd = new WeakSet(), GN = function(t, e, n, s, r, a, o, l, c, u) {
  if (c <= 0 || c >= 1)
    return;
  const d = 1 - c, h = c * c, p = h * c, m = d * (d * (d * t + 3 * c * e) + 3 * h * n) + p * s, b = d * (d * (d * r + 3 * c * a) + 3 * h * o) + p * l;
  u[0] = Math.min(u[0], m), u[1] = Math.min(u[1], b), u[2] = Math.max(u[2], m), u[3] = Math.max(u[3], b);
}, bV = function(t, e, n, s, r, a, o, l, c, u, d, h) {
  if (Math.abs(c) < 1e-12) {
    Math.abs(u) >= 1e-12 && ft(this, sd, GN).call(this, t, e, n, s, r, a, o, l, -d / u, h);
    return;
  }
  const p = u ** 2 - 4 * d * c;
  if (p < 0)
    return;
  const m = Math.sqrt(p), b = 2 * c;
  ft(this, sd, GN).call(this, t, e, n, s, r, a, o, l, (-u + m) / b, h), ft(this, sd, GN).call(this, t, e, n, s, r, a, o, l, (-u - m) / b, h);
}, pt(ze, sd);
function sIt(i) {
  return decodeURIComponent(escape(i));
}
let RS = null, TE = null;
function rIt(i) {
  return RS || (RS = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu, TE = /* @__PURE__ */ new Map([["ﬅ", "ſt"]])), i.replaceAll(RS, (t, e, n) => e ? e.normalize("NFKC") : TE.get(n));
}
function LB() {
  if (typeof crypto.randomUUID == "function")
    return crypto.randomUUID();
  const i = new Uint8Array(32);
  return crypto.getRandomValues(i), SB(i);
}
const _C = "pdfjs_internal_id_";
function aIt(i, t, e) {
  if (!Array.isArray(e) || e.length < 2)
    return !1;
  const [n, s, ...r] = e;
  if (!i(n) && !Number.isInteger(n) || !t(s))
    return !1;
  const a = r.length;
  let o = !0;
  switch (s.name) {
    case "XYZ":
      if (a < 2 || a > 3)
        return !1;
      break;
    case "Fit":
    case "FitB":
      return a === 0;
    case "FitH":
    case "FitBH":
    case "FitV":
    case "FitBV":
      if (a > 1)
        return !1;
      break;
    case "FitR":
      if (a !== 4)
        return !1;
      o = !1;
      break;
    default:
      return !1;
  }
  for (const l of r)
    if (!(typeof l == "number" || o && l === null))
      return !1;
  return !0;
}
function Na(i, t, e) {
  return Math.min(Math.max(i, t), e);
}
function VB(i) {
  return Uint8Array.prototype.toBase64 ? i.toBase64() : btoa(SB(i));
}
function oIt(i) {
  return Uint8Array.fromBase64 ? Uint8Array.fromBase64(i) : KT(atob(i));
}
typeof Promise.try != "function" && (Promise.try = function(i, ...t) {
  return new Promise((e) => {
    e(i(...t));
  });
});
typeof Math.sumPrecise != "function" && (Math.sumPrecise = function(i) {
  return i.reduce((t, e) => t + e, 0);
});
class k2 {
  static textContent(t) {
    const e = [], n = {
      items: e,
      styles: /* @__PURE__ */ Object.create(null)
    };
    function s(r) {
      var l;
      if (!r)
        return;
      let a = null;
      const o = r.name;
      if (o === "#text")
        a = r.value;
      else if (k2.shouldBuildText(o))
        (l = r == null ? void 0 : r.attributes) != null && l.textContent ? a = r.attributes.textContent : r.value && (a = r.value);
      else return;
      if (a !== null && e.push({
        str: a
      }), !!r.children)
        for (const c of r.children)
          s(c);
    }
    return s(t), n;
  }
  static shouldBuildText(t) {
    return !(t === "textarea" || t === "input" || t === "option" || t === "select");
  }
}
class QC {
  static setupStorage(t, e, n, s, r) {
    const a = s.getValue(e, {
      value: null
    });
    switch (n.name) {
      case "textarea":
        if (a.value !== null && (t.textContent = a.value), r === "print")
          break;
        t.addEventListener("input", (o) => {
          s.setValue(e, {
            value: o.target.value
          });
        });
        break;
      case "input":
        if (n.attributes.type === "radio" || n.attributes.type === "checkbox") {
          if (a.value === n.attributes.xfaOn ? t.setAttribute("checked", !0) : a.value === n.attributes.xfaOff && t.removeAttribute("checked"), r === "print")
            break;
          t.addEventListener("change", (o) => {
            s.setValue(e, {
              value: o.target.checked ? o.target.getAttribute("xfaOn") : o.target.getAttribute("xfaOff")
            });
          });
        } else {
          if (a.value !== null && t.setAttribute("value", a.value), r === "print")
            break;
          t.addEventListener("input", (o) => {
            s.setValue(e, {
              value: o.target.value
            });
          });
        }
        break;
      case "select":
        if (a.value !== null) {
          t.setAttribute("value", a.value);
          for (const o of n.children)
            o.attributes.value === a.value ? o.attributes.selected = !0 : o.attributes.hasOwnProperty("selected") && delete o.attributes.selected;
        }
        t.addEventListener("input", (o) => {
          const l = o.target.options, c = l.selectedIndex === -1 ? "" : l[l.selectedIndex].value;
          s.setValue(e, {
            value: c
          });
        });
        break;
    }
  }
  static setAttributes({
    html: t,
    element: e,
    storage: n = null,
    intent: s,
    linkService: r
  }) {
    const {
      attributes: a
    } = e, o = t instanceof HTMLAnchorElement;
    a.type === "radio" && (a.name = `${a.name}-${s}`);
    for (const [l, c] of Object.entries(a))
      if (c != null)
        switch (l) {
          case "class":
            c.length && t.setAttribute(l, c.join(" "));
            break;
          case "dataId":
            break;
          case "id":
            t.setAttribute("data-element-id", c);
            break;
          case "style":
            Object.assign(t.style, c);
            break;
          case "textContent":
            t.textContent = c;
            break;
          default:
            (!o || l !== "href" && l !== "newWindow") && t.setAttribute(l, c);
        }
    o && r.addLinkAttributes(t, a.href, a.newWindow), n && a.dataId && this.setupStorage(t, a.dataId, e, n);
  }
  static render(t) {
    var d, h;
    const e = t.annotationStorage, n = t.linkService, s = t.xfaHtml, r = t.intent || "display", a = document.createElement(s.name);
    s.attributes && this.setAttributes({
      html: a,
      element: s,
      intent: r,
      linkService: n
    });
    const o = r !== "richText", l = t.div;
    if (l.append(a), t.viewport) {
      const p = `matrix(${t.viewport.transform.join(",")})`;
      l.style.transform = p;
    }
    o && l.setAttribute("class", "xfaLayer xfaFont");
    const c = [];
    if (s.children.length === 0) {
      if (s.value) {
        const p = document.createTextNode(s.value);
        a.append(p), o && k2.shouldBuildText(s.name) && c.push(p);
      }
      return {
        textDivs: c
      };
    }
    const u = [[s, -1, a]];
    for (; u.length > 0; ) {
      const [p, m, b] = u.at(-1);
      if (m + 1 === p.children.length) {
        u.pop();
        continue;
      }
      const y = p.children[++u.at(-1)[1]];
      if (y === null)
        continue;
      const {
        name: Z
      } = y;
      if (Z === "#text") {
        const f = document.createTextNode(y.value);
        c.push(f), b.append(f);
        continue;
      }
      const g = (d = y == null ? void 0 : y.attributes) != null && d.xmlns ? document.createElementNS(y.attributes.xmlns, Z) : document.createElement(Z);
      if (b.append(g), y.attributes && this.setAttributes({
        html: g,
        element: y,
        storage: e,
        intent: r,
        linkService: n
      }), ((h = y.children) == null ? void 0 : h.length) > 0)
        u.push([y, -1, g]);
      else if (y.value) {
        const f = document.createTextNode(y.value);
        o && k2.shouldBuildText(Z) && c.push(f), g.append(f);
      }
    }
    for (const p of l.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))
      p.setAttribute("readOnly", !0);
    return {
      textDivs: c
    };
  }
  static update(t) {
    const e = `matrix(${t.viewport.transform.join(",")})`;
    t.div.style.transform = e, t.div.hidden = !1;
  }
}
const ru = "http://www.w3.org/2000/svg", Op = class Op {
};
S(Op, "CSS", 96), S(Op, "PDF", 72), S(Op, "PDF_TO_CSS_UNITS", Op.CSS / Op.PDF);
let qh = Op;
async function HT(i, t = "text") {
  if (Xy(i, document.baseURI)) {
    const e = await fetch(i);
    if (!e.ok)
      throw new Error(e.statusText);
    switch (t) {
      case "arraybuffer":
        return e.arrayBuffer();
      case "blob":
        return e.blob();
      case "json":
        return e.json();
    }
    return e.text();
  }
  return new Promise((e, n) => {
    const s = new XMLHttpRequest();
    s.open("GET", i, !0), s.responseType = t, s.onreadystatechange = () => {
      if (s.readyState === XMLHttpRequest.DONE) {
        if (s.status === 200 || s.status === 0) {
          switch (t) {
            case "arraybuffer":
            case "blob":
            case "json":
              e(s.response);
              return;
          }
          e(s.responseText);
          return;
        }
        n(new Error(s.statusText));
      }
    }, s.send(null);
  });
}
class _T {
  constructor({
    viewBox: t,
    userUnit: e,
    scale: n,
    rotation: s,
    offsetX: r = 0,
    offsetY: a = 0,
    dontFlip: o = !1
  }) {
    this.viewBox = t, this.userUnit = e, this.scale = n, this.rotation = s, this.offsetX = r, this.offsetY = a, n *= e;
    const l = (t[2] + t[0]) / 2, c = (t[3] + t[1]) / 2;
    let u, d, h, p;
    switch (s %= 360, s < 0 && (s += 360), s) {
      case 180:
        u = -1, d = 0, h = 0, p = 1;
        break;
      case 90:
        u = 0, d = 1, h = 1, p = 0;
        break;
      case 270:
        u = 0, d = -1, h = -1, p = 0;
        break;
      case 0:
        u = 1, d = 0, h = 0, p = -1;
        break;
      default:
        throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
    }
    o && (h = -h, p = -p);
    let m, b, y, Z;
    u === 0 ? (m = Math.abs(c - t[1]) * n + r, b = Math.abs(l - t[0]) * n + a, y = (t[3] - t[1]) * n, Z = (t[2] - t[0]) * n) : (m = Math.abs(l - t[0]) * n + r, b = Math.abs(c - t[1]) * n + a, y = (t[2] - t[0]) * n, Z = (t[3] - t[1]) * n), this.transform = [u * n, d * n, h * n, p * n, m - u * n * l - h * n * c, b - d * n * l - p * n * c], this.width = y, this.height = Z;
  }
  get rawDims() {
    const t = this.viewBox;
    return Gn(this, "rawDims", {
      pageWidth: t[2] - t[0],
      pageHeight: t[3] - t[1],
      pageX: t[0],
      pageY: t[1]
    });
  }
  clone({
    scale: t = this.scale,
    rotation: e = this.rotation,
    offsetX: n = this.offsetX,
    offsetY: s = this.offsetY,
    dontFlip: r = !1
  } = {}) {
    return new _T({
      viewBox: this.viewBox.slice(),
      userUnit: this.userUnit,
      scale: t,
      rotation: e,
      offsetX: n,
      offsetY: s,
      dontFlip: r
    });
  }
  convertToViewportPoint(t, e) {
    const n = [t, e];
    return ze.applyTransform(n, this.transform), n;
  }
  convertToViewportRectangle(t) {
    const e = [t[0], t[1]];
    ze.applyTransform(e, this.transform);
    const n = [t[2], t[3]];
    return ze.applyTransform(n, this.transform), [e[0], e[1], n[0], n[1]];
  }
  convertToPdfPoint(t, e) {
    const n = [t, e];
    return ze.applyInverseTransform(n, this.transform), n;
  }
}
class $C extends Y0 {
  constructor(t, e = 0) {
    super(t, "RenderingCancelledException"), this.extraDelay = e;
  }
}
function fw(i) {
  const t = i.length;
  let e = 0;
  for (; e < t && i[e].trim() === ""; )
    e++;
  return i.substring(e, e + 5).toLowerCase() === "data:";
}
function qC(i) {
  return typeof i == "string" && /\.pdf$/i.test(i);
}
function lIt(i) {
  return [i] = i.split(/[#?]/, 1), i.substring(i.lastIndexOf("/") + 1);
}
function cIt(i, t = "document.pdf") {
  if (typeof i != "string")
    return t;
  if (fw(i))
    return pn('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.'), t;
  const n = ((o) => {
    try {
      return new URL(o);
    } catch {
      try {
        return new URL(decodeURIComponent(o));
      } catch {
        try {
          return new URL(o, "https://foo.bar");
        } catch {
          try {
            return new URL(decodeURIComponent(o), "https://foo.bar");
          } catch {
            return null;
          }
        }
      }
    }
  })(i);
  if (!n)
    return t;
  const s = (o) => {
    try {
      let l = decodeURIComponent(o);
      return l.includes("/") ? (l = l.split("/").at(-1), l.test(/^\.pdf$/i) ? l : o) : l;
    } catch {
      return o;
    }
  }, r = /\.pdf$/i, a = n.pathname.split("/").at(-1);
  if (r.test(a))
    return s(a);
  if (n.searchParams.size > 0) {
    const o = Array.from(n.searchParams.values()).reverse();
    for (const c of o)
      if (r.test(c))
        return s(c);
    const l = Array.from(n.searchParams.keys()).reverse();
    for (const c of l)
      if (r.test(c))
        return s(c);
  }
  if (n.hash) {
    const l = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i.exec(n.hash);
    if (l)
      return s(l[0]);
  }
  return t;
}
class ME {
  constructor() {
    S(this, "started", /* @__PURE__ */ Object.create(null));
    S(this, "times", []);
  }
  time(t) {
    t in this.started && pn(`Timer is already running for ${t}`), this.started[t] = Date.now();
  }
  timeEnd(t) {
    t in this.started || pn(`Timer has not been started for ${t}`), this.times.push({
      name: t,
      start: this.started[t],
      end: Date.now()
    }), delete this.started[t];
  }
  toString() {
    const t = [];
    let e = 0;
    for (const {
      name: n
    } of this.times)
      e = Math.max(n.length, e);
    for (const {
      name: n,
      start: s,
      end: r
    } of this.times)
      t.push(`${n.padEnd(e)} ${r - s}ms
`);
    return t.join("");
  }
}
function Xy(i, t) {
  const e = t ? URL.parse(i, t) : URL.parse(i);
  return (e == null ? void 0 : e.protocol) === "http:" || (e == null ? void 0 : e.protocol) === "https:";
}
function al(i) {
  i.preventDefault();
}
function ms(i) {
  i.preventDefault(), i.stopPropagation();
}
function uIt(i) {
  console.log("Deprecated API usage: " + i);
}
var U2;
class JW {
  static toDateObject(t) {
    if (t instanceof Date)
      return t;
    if (!t || typeof t != "string")
      return null;
    w(this, U2) || rt(this, U2, new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?"));
    const e = w(this, U2).exec(t);
    if (!e)
      return null;
    const n = parseInt(e[1], 10);
    let s = parseInt(e[2], 10);
    s = s >= 1 && s <= 12 ? s - 1 : 0;
    let r = parseInt(e[3], 10);
    r = r >= 1 && r <= 31 ? r : 1;
    let a = parseInt(e[4], 10);
    a = a >= 0 && a <= 23 ? a : 0;
    let o = parseInt(e[5], 10);
    o = o >= 0 && o <= 59 ? o : 0;
    let l = parseInt(e[6], 10);
    l = l >= 0 && l <= 59 ? l : 0;
    const c = e[7] || "Z";
    let u = parseInt(e[8], 10);
    u = u >= 0 && u <= 23 ? u : 0;
    let d = parseInt(e[9], 10) || 0;
    return d = d >= 0 && d <= 59 ? d : 0, c === "-" ? (a += u, o += d) : c === "+" && (a -= u, o -= d), new Date(Date.UTC(n, s, r, a, o, l));
  }
}
U2 = new WeakMap(), pt(JW, U2);
function dIt(i, {
  scale: t = 1,
  rotation: e = 0
}) {
  const {
    width: n,
    height: s
  } = i.attributes.style, r = [0, 0, parseInt(n), parseInt(s)];
  return new _T({
    viewBox: r,
    userUnit: 1,
    scale: t,
    rotation: e
  });
}
function QT(i) {
  if (i.startsWith("#")) {
    const t = parseInt(i.slice(1), 16);
    return [(t & 16711680) >> 16, (t & 65280) >> 8, t & 255];
  }
  return i.startsWith("rgb(") ? i.slice(4, -1).split(",").map((t) => parseInt(t)) : i.startsWith("rgba(") ? i.slice(5, -1).split(",").map((t) => parseInt(t)).slice(0, 3) : (pn(`Not a valid color format: "${i}"`), [0, 0, 0]);
}
function hIt(i) {
  const t = document.createElement("span");
  t.style.visibility = "hidden", t.style.colorScheme = "only light", document.body.append(t);
  for (const e of i.keys()) {
    t.style.color = e;
    const n = window.getComputedStyle(t).color;
    i.set(e, QT(n));
  }
  t.remove();
}
function ns(i) {
  const {
    a: t,
    b: e,
    c: n,
    d: s,
    e: r,
    f: a
  } = i.getTransform();
  return [t, e, n, s, r, a];
}
function nc(i) {
  const {
    a: t,
    b: e,
    c: n,
    d: s,
    e: r,
    f: a
  } = i.getTransform().invertSelf();
  return [t, e, n, s, r, a];
}
function W0(i, t, e = !1, n = !0) {
  if (t instanceof _T) {
    const {
      pageWidth: s,
      pageHeight: r
    } = t.rawDims, {
      style: a
    } = i, o = Er.isCSSRoundSupported, l = `var(--total-scale-factor) * ${s}px`, c = `var(--total-scale-factor) * ${r}px`, u = o ? `round(down, ${l}, var(--scale-round-x))` : `calc(${l})`, d = o ? `round(down, ${c}, var(--scale-round-y))` : `calc(${c})`;
    !e || t.rotation % 180 === 0 ? (a.width = u, a.height = d) : (a.width = d, a.height = u);
  }
  n && i.setAttribute("data-main-rotation", t.rotation);
}
class Uc {
  constructor() {
    const {
      pixelRatio: t
    } = Uc;
    this.sx = t, this.sy = t;
  }
  get scaled() {
    return this.sx !== 1 || this.sy !== 1;
  }
  get symmetric() {
    return this.sx === this.sy;
  }
  limitCanvas(t, e, n, s, r = -1) {
    let a = 1 / 0, o = 1 / 0, l = 1 / 0;
    n = Uc.capPixels(n, r), n > 0 && (a = Math.sqrt(n / (t * e))), s !== -1 && (o = s / t, l = s / e);
    const c = Math.min(a, o, l);
    return this.sx > c || this.sy > c ? (this.sx = c, this.sy = c, !0) : !1;
  }
  static get pixelRatio() {
    return globalThis.devicePixelRatio || 1;
  }
  static capPixels(t, e) {
    if (e >= 0) {
      const n = Math.ceil(window.screen.availWidth * window.screen.availHeight * this.pixelRatio ** 2 * (1 + e / 100));
      return t > 0 ? Math.min(t, n) : n;
    }
    return t;
  }
}
const fV = ["image/apng", "image/avif", "image/bmp", "image/gif", "image/jpeg", "image/png", "image/svg+xml", "image/webp", "image/x-icon"];
class pIt {
  static get isDarkMode() {
    var t;
    return Gn(this, "isDarkMode", !!((t = window == null ? void 0 : window.matchMedia) != null && t.call(window, "(prefers-color-scheme: dark)").matches));
  }
}
class mIt {
  static get commentForegroundColor() {
    const t = document.createElement("span");
    t.classList.add("comment", "sidebar");
    const {
      style: e
    } = t;
    e.width = e.height = "0", e.display = "none", e.color = "var(--comment-fg-color)", document.body.append(t);
    const {
      color: n
    } = window.getComputedStyle(t);
    return t.remove(), Gn(this, "commentForegroundColor", QT(n));
  }
}
function bIt(i, t, e, n) {
  n = Math.min(Math.max(n ?? 1, 0), 1);
  const s = 255 * (1 - n);
  return i = Math.round(i * n + s), t = Math.round(t * n + s), e = Math.round(e * n + s), [i, t, e];
}
function NE(i, t) {
  const e = i[0] / 255, n = i[1] / 255, s = i[2] / 255, r = Math.max(e, n, s), a = Math.min(e, n, s), o = (r + a) / 2;
  if (r === a)
    t[0] = t[1] = 0;
  else {
    const l = r - a;
    switch (t[1] = o < 0.5 ? l / (r + a) : l / (2 - r - a), r) {
      case e:
        t[0] = ((n - s) / l + (n < s ? 6 : 0)) * 60;
        break;
      case n:
        t[0] = ((s - e) / l + 2) * 60;
        break;
      case s:
        t[0] = ((e - n) / l + 4) * 60;
        break;
    }
  }
  t[2] = o;
}
function gV(i, t) {
  const e = i[0], n = i[1], s = i[2], r = (1 - Math.abs(2 * s - 1)) * n, a = r * (1 - Math.abs(e / 60 % 2 - 1)), o = s - r / 2;
  switch (Math.floor(e / 60)) {
    case 0:
      t[0] = r + o, t[1] = a + o, t[2] = o;
      break;
    case 1:
      t[0] = a + o, t[1] = r + o, t[2] = o;
      break;
    case 2:
      t[0] = o, t[1] = r + o, t[2] = a + o;
      break;
    case 3:
      t[0] = o, t[1] = a + o, t[2] = r + o;
      break;
    case 4:
      t[0] = a + o, t[1] = o, t[2] = r + o;
      break;
    case 5:
    case 6:
      t[0] = r + o, t[1] = o, t[2] = a + o;
      break;
  }
}
function WE(i) {
  return i <= 0.03928 ? i / 12.92 : ((i + 0.055) / 1.055) ** 2.4;
}
function GE(i, t, e) {
  gV(i, e), e.map(WE);
  const n = 0.2126 * e[0] + 0.7152 * e[1] + 0.0722 * e[2];
  gV(t, e), e.map(WE);
  const s = 0.2126 * e[0] + 0.7152 * e[1] + 0.0722 * e[2];
  return n > s ? (n + 0.05) / (s + 0.05) : (s + 0.05) / (n + 0.05);
}
const wE = /* @__PURE__ */ new Map();
function fIt(i, t) {
  const e = i[0] + i[1] * 256 + i[2] * 65536 + t[0] * 16777216 + t[1] * 4294967296 + t[2] * 1099511627776;
  let n = wE.get(e);
  if (n)
    return n;
  const s = new Float32Array(9), r = s.subarray(0, 3), a = s.subarray(3, 6);
  NE(i, a);
  const o = s.subarray(6, 9);
  NE(t, o);
  const l = o[2] < 0.5, c = l ? 12 : 4.5;
  if (a[2] = l ? Math.sqrt(a[2]) : 1 - Math.sqrt(1 - a[2]), GE(a, o, r) < c) {
    let u, d;
    l ? (u = a[2], d = 1) : (u = 0, d = a[2]);
    const h = 5e-3;
    for (; d - u > h; ) {
      const p = a[2] = (u + d) / 2;
      l === GE(a, o, r) < c ? u = p : d = p;
    }
    a[2] = l ? d : u;
  }
  return gV(a, r), n = ze.makeHexColor(Math.round(r[0] * 255), Math.round(r[1] * 255), Math.round(r[2] * 255)), wE.set(e, n), n;
}
function XB({
  html: i,
  dir: t,
  className: e
}, n) {
  const s = document.createDocumentFragment();
  if (typeof i == "string") {
    const r = document.createElement("p");
    r.dir = t || "auto";
    const a = i.split(/(?:\r\n?|\n)/);
    for (let o = 0, l = a.length; o < l; ++o) {
      const c = a[o];
      r.append(document.createTextNode(c)), o < l - 1 && r.append(document.createElement("br"));
    }
    s.append(r);
  } else
    QC.render({
      xfaHtml: i,
      div: s,
      intent: "richText"
    });
  s.firstChild.classList.add("richText", e), n.append(s);
}
var Ud, Pd, Eo, ko, P2, Jd, Eb, kb, J2, aG, IB, Dr, CB, YB, ub, Iy;
const cu = class cu {
  constructor(t) {
    pt(this, Dr);
    pt(this, Ud, null);
    pt(this, Pd, null);
    pt(this, Eo);
    pt(this, ko, null);
    pt(this, P2, null);
    pt(this, Jd, null);
    pt(this, Eb, null);
    pt(this, kb, null);
    rt(this, Eo, t), w(cu, J2) || rt(cu, J2, Object.freeze({
      freetext: "pdfjs-editor-remove-freetext-button",
      highlight: "pdfjs-editor-remove-highlight-button",
      ink: "pdfjs-editor-remove-ink-button",
      stamp: "pdfjs-editor-remove-stamp-button",
      signature: "pdfjs-editor-remove-signature-button"
    }));
  }
  render() {
    const t = rt(this, Ud, document.createElement("div"));
    t.classList.add("editToolbar", "hidden"), t.setAttribute("role", "toolbar");
    const e = w(this, Eo)._uiManager._signal;
    e instanceof AbortSignal && !e.aborted && (t.addEventListener("contextmenu", al, {
      signal: e
    }), t.addEventListener("pointerdown", ft(cu, aG, IB), {
      signal: e
    }));
    const n = rt(this, ko, document.createElement("div"));
    n.className = "buttons", t.append(n);
    const s = w(this, Eo).toolbarPosition;
    if (s) {
      const {
        style: r
      } = t, a = w(this, Eo)._uiManager.direction === "ltr" ? 1 - s[0] : s[0];
      r.insetInlineEnd = `${100 * a}%`, r.top = `calc(${100 * s[1]}% + var(--editor-toolbar-vert-offset))`;
    }
    return t;
  }
  get div() {
    return w(this, Ud);
  }
  hide() {
    var t;
    w(this, Ud).classList.add("hidden"), (t = w(this, Pd)) == null || t.hideDropdown();
  }
  show() {
    var t, e;
    w(this, Ud).classList.remove("hidden"), (t = w(this, P2)) == null || t.shown(), (e = w(this, Jd)) == null || e.shown();
  }
  addDeleteButton() {
    const {
      editorType: t,
      _uiManager: e
    } = w(this, Eo), n = document.createElement("button");
    n.classList.add("basic", "deleteButton"), n.tabIndex = 0, n.setAttribute("data-l10n-id", w(cu, J2)[t]), ft(this, Dr, ub).call(this, n) && n.addEventListener("click", (s) => {
      e.delete();
    }, {
      signal: e._signal
    }), w(this, ko).append(n);
  }
  async addAltText(t) {
    const e = await t.render();
    ft(this, Dr, ub).call(this, e), w(this, ko).append(e, w(this, Dr, Iy)), rt(this, P2, t);
  }
  addComment(t, e = null) {
    if (w(this, Jd))
      return;
    const n = t.renderForToolbar();
    if (!n)
      return;
    ft(this, Dr, ub).call(this, n);
    const s = rt(this, Eb, w(this, Dr, Iy));
    e ? (w(this, ko).insertBefore(n, e), w(this, ko).insertBefore(s, e)) : w(this, ko).append(n, s), rt(this, Jd, t), t.toolbar = this;
  }
  addColorPicker(t) {
    if (w(this, Pd))
      return;
    rt(this, Pd, t);
    const e = t.renderButton();
    ft(this, Dr, ub).call(this, e), w(this, ko).append(e, w(this, Dr, Iy));
  }
  async addEditSignatureButton(t) {
    const e = rt(this, kb, await t.renderEditButton(w(this, Eo)));
    ft(this, Dr, ub).call(this, e), w(this, ko).append(e, w(this, Dr, Iy));
  }
  removeButton(t) {
    var e, n;
    switch (t) {
      case "comment":
        (e = w(this, Jd)) == null || e.removeToolbarCommentButton(), rt(this, Jd, null), (n = w(this, Eb)) == null || n.remove(), rt(this, Eb, null);
        break;
    }
  }
  async addButton(t, e) {
    switch (t) {
      case "colorPicker":
        this.addColorPicker(e);
        break;
      case "altText":
        await this.addAltText(e);
        break;
      case "editSignature":
        await this.addEditSignatureButton(e);
        break;
      case "delete":
        this.addDeleteButton();
        break;
      case "comment":
        this.addComment(e);
        break;
    }
  }
  async addButtonBefore(t, e, n) {
    const s = w(this, ko).querySelector(n);
    s && t === "comment" && this.addComment(e, s);
  }
  updateEditSignatureButton(t) {
    w(this, kb) && (w(this, kb).title = t);
  }
  remove() {
    var t;
    w(this, Ud).remove(), (t = w(this, Pd)) == null || t.destroy(), rt(this, Pd, null);
  }
};
Ud = new WeakMap(), Pd = new WeakMap(), Eo = new WeakMap(), ko = new WeakMap(), P2 = new WeakMap(), Jd = new WeakMap(), Eb = new WeakMap(), kb = new WeakMap(), J2 = new WeakMap(), aG = new WeakSet(), IB = function(t) {
  t.stopPropagation();
}, Dr = new WeakSet(), CB = function(t) {
  w(this, Eo)._focusEventsAllowed = !1, ms(t);
}, YB = function(t) {
  w(this, Eo)._focusEventsAllowed = !0, ms(t);
}, ub = function(t) {
  const e = w(this, Eo)._uiManager._signal;
  return !(e instanceof AbortSignal) || e.aborted ? !1 : (t.addEventListener("focusin", ft(this, Dr, CB).bind(this), {
    capture: !0,
    signal: e
  }), t.addEventListener("focusout", ft(this, Dr, YB).bind(this), {
    capture: !0,
    signal: e
  }), t.addEventListener("contextmenu", al, {
    signal: e
  }), !0);
}, Iy = function() {
  const t = document.createElement("div");
  return t.className = "divider", t;
}, pt(cu, aG), pt(cu, J2, null);
let yV = cu;
var A2, Hp, mu, hd, vB, RB, ZV;
class gIt {
  constructor(t) {
    pt(this, hd);
    pt(this, A2, null);
    pt(this, Hp, null);
    pt(this, mu);
    rt(this, mu, t);
  }
  show(t, e, n) {
    const [s, r] = ft(this, hd, RB).call(this, e, n), {
      style: a
    } = w(this, Hp) || rt(this, Hp, ft(this, hd, vB).call(this));
    t.append(w(this, Hp)), a.insetInlineEnd = `${100 * s}%`, a.top = `calc(${100 * r}% + var(--editor-toolbar-vert-offset))`;
  }
  hide() {
    w(this, Hp).remove();
  }
}
A2 = new WeakMap(), Hp = new WeakMap(), mu = new WeakMap(), hd = new WeakSet(), vB = function() {
  const t = rt(this, Hp, document.createElement("div"));
  t.className = "editToolbar", t.setAttribute("role", "toolbar");
  const e = w(this, mu)._signal;
  e instanceof AbortSignal && !e.aborted && t.addEventListener("contextmenu", al, {
    signal: e
  });
  const n = rt(this, A2, document.createElement("div"));
  return n.className = "buttons", t.append(n), w(this, mu).hasCommentManager() && ft(this, hd, ZV).call(this, "commentButton", "pdfjs-comment-floating-button", "pdfjs-comment-floating-button-label", () => {
    w(this, mu).commentSelection("floating_button");
  }), ft(this, hd, ZV).call(this, "highlightButton", "pdfjs-highlight-floating-button1", "pdfjs-highlight-floating-button-label", () => {
    w(this, mu).highlightSelection("floating_button");
  }), t;
}, RB = function(t, e) {
  let n = 0, s = 0;
  for (const r of t) {
    const a = r.y + r.height;
    if (a < n)
      continue;
    const o = r.x + (e ? r.width : 0);
    if (a > n) {
      s = o, n = a;
      continue;
    }
    e ? o > s && (s = o) : o < s && (s = o);
  }
  return [e ? 1 - s : s, n];
}, ZV = function(t, e, n, s) {
  const r = document.createElement("button");
  r.classList.add("basic", t), r.tabIndex = 0, r.setAttribute("data-l10n-id", e);
  const a = document.createElement("span");
  r.append(a), a.className = "visuallyHidden", a.setAttribute("data-l10n-id", n);
  const o = w(this, mu)._signal;
  o instanceof AbortSignal && !o.aborted && (r.addEventListener("contextmenu", al, {
    signal: o
  }), r.addEventListener("click", s, {
    signal: o
  })), w(this, A2).append(r);
};
function DB(i, t, e) {
  for (const n of e)
    t.addEventListener(n, i[n].bind(i));
}
var oG;
class yIt {
  constructor() {
    pt(this, oG, 0);
  }
  get id() {
    return `${z2}${Ks(this, oG)._++}`;
  }
}
oG = new WeakMap();
var Fb, B2, Hr, jb, wN;
const uY = class uY {
  constructor() {
    pt(this, jb);
    pt(this, Fb, LB());
    pt(this, B2, 0);
    pt(this, Hr, null);
  }
  static get _isSVGFittingCanvas() {
    const t = 'data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>', n = new OffscreenCanvas(1, 3).getContext("2d", {
      willReadFrequently: !0
    }), s = new Image();
    s.src = t;
    const r = s.decode().then(() => (n.drawImage(s, 0, 0, 1, 1, 0, 0, 1, 3), new Uint32Array(n.getImageData(0, 0, 1, 1).data.buffer)[0] === 0));
    return Gn(this, "_isSVGFittingCanvas", r);
  }
  async getFromFile(t) {
    const {
      lastModified: e,
      name: n,
      size: s,
      type: r
    } = t;
    return ft(this, jb, wN).call(this, `${e}_${n}_${s}_${r}`, t);
  }
  async getFromUrl(t) {
    return ft(this, jb, wN).call(this, t, t);
  }
  async getFromBlob(t, e) {
    const n = await e;
    return ft(this, jb, wN).call(this, t, n);
  }
  async getFromId(t) {
    w(this, Hr) || rt(this, Hr, /* @__PURE__ */ new Map());
    const e = w(this, Hr).get(t);
    if (!e)
      return null;
    if (e.bitmap)
      return e.refCounter += 1, e;
    if (e.file)
      return this.getFromFile(e.file);
    if (e.blobPromise) {
      const {
        blobPromise: n
      } = e;
      return delete e.blobPromise, this.getFromBlob(e.id, n);
    }
    return this.getFromUrl(e.url);
  }
  getFromCanvas(t, e) {
    w(this, Hr) || rt(this, Hr, /* @__PURE__ */ new Map());
    let n = w(this, Hr).get(t);
    if (n != null && n.bitmap)
      return n.refCounter += 1, n;
    const s = new OffscreenCanvas(e.width, e.height);
    return s.getContext("2d").drawImage(e, 0, 0), n = {
      bitmap: s.transferToImageBitmap(),
      id: `image_${w(this, Fb)}_${Ks(this, B2)._++}`,
      refCounter: 1,
      isSvg: !1
    }, w(this, Hr).set(t, n), w(this, Hr).set(n.id, n), n;
  }
  getSvgUrl(t) {
    const e = w(this, Hr).get(t);
    return e != null && e.isSvg ? e.svgUrl : null;
  }
  deleteId(t) {
    var s;
    w(this, Hr) || rt(this, Hr, /* @__PURE__ */ new Map());
    const e = w(this, Hr).get(t);
    if (!e || (e.refCounter -= 1, e.refCounter !== 0))
      return;
    const {
      bitmap: n
    } = e;
    if (!e.url && !e.file) {
      const r = new OffscreenCanvas(n.width, n.height);
      r.getContext("bitmaprenderer").transferFromImageBitmap(n), e.blobPromise = r.convertToBlob();
    }
    (s = n.close) == null || s.call(n), e.bitmap = null;
  }
  isValidId(t) {
    return t.startsWith(`image_${w(this, Fb)}_`);
  }
};
Fb = new WeakMap(), B2 = new WeakMap(), Hr = new WeakMap(), jb = new WeakSet(), wN = async function(t, e) {
  w(this, Hr) || rt(this, Hr, /* @__PURE__ */ new Map());
  let n = w(this, Hr).get(t);
  if (n === null)
    return null;
  if (n != null && n.bitmap)
    return n.refCounter += 1, n;
  try {
    n || (n = {
      bitmap: null,
      id: `image_${w(this, Fb)}_${Ks(this, B2)._++}`,
      refCounter: 0,
      isSvg: !1
    });
    let s;
    if (typeof e == "string" ? (n.url = e, s = await HT(e, "blob")) : e instanceof File ? s = n.file = e : e instanceof Blob && (s = e), s.type === "image/svg+xml") {
      const r = uY._isSVGFittingCanvas, a = new FileReader(), o = new Image(), l = new Promise((c, u) => {
        o.onload = () => {
          n.bitmap = o, n.isSvg = !0, c();
        }, a.onload = async () => {
          const d = n.svgUrl = a.result;
          o.src = await r ? `${d}#svgView(preserveAspectRatio(none))` : d;
        }, o.onerror = a.onerror = u;
      });
      a.readAsDataURL(s), await l;
    } else
      n.bitmap = await createImageBitmap(s);
    n.refCounter = 1;
  } catch (s) {
    pn(s), n = null;
  }
  return w(this, Hr).set(t, n), n && w(this, Hr).set(n.id, n), n;
};
let TV = uY;
var Ts, Ad, K2, es;
class ZIt {
  constructor(t = 128) {
    pt(this, Ts, []);
    pt(this, Ad, !1);
    pt(this, K2);
    pt(this, es, -1);
    rt(this, K2, t);
  }
  add({
    cmd: t,
    undo: e,
    post: n,
    mustExec: s,
    type: r = NaN,
    overwriteIfSameType: a = !1,
    keepUndo: o = !1
  }) {
    if (s && t(), w(this, Ad))
      return;
    const l = {
      cmd: t,
      undo: e,
      post: n,
      type: r
    };
    if (w(this, es) === -1) {
      w(this, Ts).length > 0 && (w(this, Ts).length = 0), rt(this, es, 0), w(this, Ts).push(l);
      return;
    }
    if (a && w(this, Ts)[w(this, es)].type === r) {
      o && (l.undo = w(this, Ts)[w(this, es)].undo), w(this, Ts)[w(this, es)] = l;
      return;
    }
    const c = w(this, es) + 1;
    c === w(this, K2) ? w(this, Ts).splice(0, 1) : (rt(this, es, c), c < w(this, Ts).length && w(this, Ts).splice(c)), w(this, Ts).push(l);
  }
  undo() {
    if (w(this, es) === -1)
      return;
    rt(this, Ad, !0);
    const {
      undo: t,
      post: e
    } = w(this, Ts)[w(this, es)];
    t(), e == null || e(), rt(this, Ad, !1), rt(this, es, w(this, es) - 1);
  }
  redo() {
    if (w(this, es) < w(this, Ts).length - 1) {
      rt(this, es, w(this, es) + 1), rt(this, Ad, !0);
      const {
        cmd: t,
        post: e
      } = w(this, Ts)[w(this, es)];
      t(), e == null || e(), rt(this, Ad, !1);
    }
  }
  hasSomethingToUndo() {
    return w(this, es) !== -1;
  }
  hasSomethingToRedo() {
    return w(this, es) < w(this, Ts).length - 1;
  }
  cleanType(t) {
    if (w(this, es) !== -1) {
      for (let e = w(this, es); e >= 0; e--)
        if (w(this, Ts)[e].type !== t) {
          w(this, Ts).splice(e + 1, w(this, es) - e), rt(this, es, e);
          return;
        }
      w(this, Ts).length = 0, rt(this, es, -1);
    }
  }
  destroy() {
    rt(this, Ts, null);
  }
}
Ts = new WeakMap(), Ad = new WeakMap(), K2 = new WeakMap(), es = new WeakMap();
var lG, OB;
class $T {
  constructor(t) {
    pt(this, lG);
    this.buffer = [], this.callbacks = /* @__PURE__ */ new Map(), this.allKeys = /* @__PURE__ */ new Set();
    const {
      isMac: e
    } = Er.platform;
    for (const [n, s, r = {}] of t)
      for (const a of n) {
        const o = a.startsWith("mac+");
        e && o ? (this.callbacks.set(a.slice(4), {
          callback: s,
          options: r
        }), this.allKeys.add(a.split("+").at(-1))) : !e && !o && (this.callbacks.set(a, {
          callback: s,
          options: r
        }), this.allKeys.add(a.split("+").at(-1)));
      }
  }
  exec(t, e) {
    if (!this.allKeys.has(e.key))
      return;
    const n = this.callbacks.get(ft(this, lG, OB).call(this, e));
    if (!n)
      return;
    const {
      callback: s,
      options: {
        bubbles: r = !1,
        args: a = [],
        checker: o = null
      }
    } = n;
    o && !o(t, e) || (s.bind(t, ...a, e)(), r || ms(e));
  }
}
lG = new WeakSet(), OB = function(t) {
  t.altKey && this.buffer.push("alt"), t.ctrlKey && this.buffer.push("ctrl"), t.metaKey && this.buffer.push("meta"), t.shiftKey && this.buffer.push("shift"), this.buffer.push(t.key);
  const e = this.buffer.join("+");
  return this.buffer.length = 0, e;
};
const cG = class cG {
  get _colors() {
    const t = /* @__PURE__ */ new Map([["CanvasText", null], ["Canvas", null]]);
    return hIt(t), Gn(this, "_colors", t);
  }
  convert(t) {
    const e = QT(t);
    if (!window.matchMedia("(forced-colors: active)").matches)
      return e;
    for (const [n, s] of this._colors)
      if (s.every((r, a) => r === e[a]))
        return cG._colorsMapping.get(n);
    return e;
  }
  getHexCode(t) {
    const e = this._colors.get(t);
    return e ? ze.makeHexColor(...e) : t;
  }
};
S(cG, "_colorsMapping", /* @__PURE__ */ new Map([["CanvasText", [0, 0, 0]], ["Canvas", [255, 255, 255]]]));
let MV = cG;
var Ub, Qa, Pb, cs, $s, Jb, Fo, Ab, jo, _r, Bd, Kd, Bb, Hd, cc, Uo, _p, H2, _2, Kb, Q2, uc, _d, Hb, Qd, dc, uG, $d, _b, $2, qd, Qp, Qb, th, q2, Ds, mi, bu, eh, nh, tZ, $b, eZ, ih, hc, fu, nZ, iZ, Po, Ve, xN, NV, zB, EB, Cy, kB, FB, jB, WV, UB, GV, wV, PB, fa, au, JB, AB, xV, BB, Yy, SV;
const wb = class wb {
  constructor(t, e, n, s, r, a, o, l, c, u, d, h, p, m, b, y) {
    pt(this, Ve);
    pt(this, Ub, new AbortController());
    pt(this, Qa, null);
    pt(this, Pb, null);
    pt(this, cs, /* @__PURE__ */ new Map());
    pt(this, $s, /* @__PURE__ */ new Map());
    pt(this, Jb, null);
    pt(this, Fo, null);
    pt(this, Ab, null);
    pt(this, jo, new ZIt());
    pt(this, _r, null);
    pt(this, Bd, null);
    pt(this, Kd, null);
    pt(this, Bb, 0);
    pt(this, Hd, /* @__PURE__ */ new Set());
    pt(this, cc, null);
    pt(this, Uo, null);
    pt(this, _p, /* @__PURE__ */ new Set());
    S(this, "_editorUndoBar", null);
    pt(this, H2, !1);
    pt(this, _2, !1);
    pt(this, Kb, !1);
    pt(this, Q2, null);
    pt(this, uc, null);
    pt(this, _d, null);
    pt(this, Hb, null);
    pt(this, Qd, !1);
    pt(this, dc, null);
    pt(this, uG, new yIt());
    pt(this, $d, !1);
    pt(this, _b, !1);
    pt(this, $2, !1);
    pt(this, qd, null);
    pt(this, Qp, null);
    pt(this, Qb, null);
    pt(this, th, null);
    pt(this, q2, null);
    pt(this, Ds, fn.NONE);
    pt(this, mi, /* @__PURE__ */ new Set());
    pt(this, bu, null);
    pt(this, eh, null);
    pt(this, nh, null);
    pt(this, tZ, null);
    pt(this, $b, null);
    pt(this, eZ, {
      isEditing: !1,
      isEmpty: !0,
      hasSomethingToUndo: !1,
      hasSomethingToRedo: !1,
      hasSelectedEditor: !1,
      hasSelectedText: !1
    });
    pt(this, ih, [0, 0]);
    pt(this, hc, null);
    pt(this, fu, null);
    pt(this, nZ, null);
    pt(this, iZ, null);
    pt(this, Po, null);
    const Z = this._signal = w(this, Ub).signal;
    rt(this, fu, t), rt(this, nZ, e), rt(this, iZ, n), rt(this, Jb, s), rt(this, _r, r), rt(this, eh, a), rt(this, $b, l), this._eventBus = o, o._on("editingaction", this.onEditingAction.bind(this), {
      signal: Z
    }), o._on("pagechanging", this.onPageChanging.bind(this), {
      signal: Z
    }), o._on("scalechanging", this.onScaleChanging.bind(this), {
      signal: Z
    }), o._on("rotationchanging", this.onRotationChanging.bind(this), {
      signal: Z
    }), o._on("setpreference", this.onSetPreference.bind(this), {
      signal: Z
    }), o._on("switchannotationeditorparams", (g) => this.updateParams(g.type, g.value), {
      signal: Z
    }), window.addEventListener("pointerdown", () => {
      rt(this, _b, !0);
    }, {
      capture: !0,
      signal: Z
    }), window.addEventListener("pointerup", () => {
      rt(this, _b, !1);
    }, {
      capture: !0,
      signal: Z
    }), ft(this, Ve, kB).call(this), ft(this, Ve, PB).call(this), ft(this, Ve, WV).call(this), rt(this, Fo, l.annotationStorage), rt(this, Q2, l.filterFactory), rt(this, nh, c), rt(this, Hb, u || null), rt(this, H2, d), rt(this, _2, h), rt(this, Kb, p), rt(this, q2, m || null), this.viewParameters = {
      realScale: qh.PDF_TO_CSS_UNITS,
      rotation: 0
    }, this.isShiftKeyDown = !1, this._editorUndoBar = b || null, this._supportsPinchToZoom = y !== !1, r == null || r.setSidebarUiManager(this);
  }
  static get _keyboardManager() {
    const t = wb.prototype, e = (a) => w(a, fu).contains(document.activeElement) && document.activeElement.tagName !== "BUTTON" && a.hasSomethingToControl(), n = (a, {
      target: o
    }) => {
      if (o instanceof HTMLInputElement) {
        const {
          type: l
        } = o;
        return l !== "text" && l !== "number";
      }
      return !0;
    }, s = this.TRANSLATE_SMALL, r = this.TRANSLATE_BIG;
    return Gn(this, "_keyboardManager", new $T([[["ctrl+a", "mac+meta+a"], t.selectAll, {
      checker: n
    }], [["ctrl+z", "mac+meta+z"], t.undo, {
      checker: n
    }], [["ctrl+y", "ctrl+shift+z", "mac+meta+shift+z", "ctrl+shift+Z", "mac+meta+shift+Z"], t.redo, {
      checker: n
    }], [["Backspace", "alt+Backspace", "ctrl+Backspace", "shift+Backspace", "mac+Backspace", "mac+alt+Backspace", "mac+ctrl+Backspace", "Delete", "ctrl+Delete", "shift+Delete", "mac+Delete"], t.delete, {
      checker: n
    }], [["Enter", "mac+Enter"], t.addNewEditorFromKeyboard, {
      checker: (a, {
        target: o
      }) => !(o instanceof HTMLButtonElement) && w(a, fu).contains(o) && !a.isEnterHandled
    }], [[" ", "mac+ "], t.addNewEditorFromKeyboard, {
      checker: (a, {
        target: o
      }) => !(o instanceof HTMLButtonElement) && w(a, fu).contains(document.activeElement)
    }], [["Escape", "mac+Escape"], t.unselectAll], [["ArrowLeft", "mac+ArrowLeft"], t.translateSelectedEditors, {
      args: [-s, 0],
      checker: e
    }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], t.translateSelectedEditors, {
      args: [-r, 0],
      checker: e
    }], [["ArrowRight", "mac+ArrowRight"], t.translateSelectedEditors, {
      args: [s, 0],
      checker: e
    }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], t.translateSelectedEditors, {
      args: [r, 0],
      checker: e
    }], [["ArrowUp", "mac+ArrowUp"], t.translateSelectedEditors, {
      args: [0, -s],
      checker: e
    }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], t.translateSelectedEditors, {
      args: [0, -r],
      checker: e
    }], [["ArrowDown", "mac+ArrowDown"], t.translateSelectedEditors, {
      args: [0, s],
      checker: e
    }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], t.translateSelectedEditors, {
      args: [0, r],
      checker: e
    }]]));
  }
  destroy() {
    var t, e, n, s, r, a, o, l, c;
    (t = w(this, Po)) == null || t.resolve(), rt(this, Po, null), (e = w(this, Ub)) == null || e.abort(), rt(this, Ub, null), this._signal = null;
    for (const u of w(this, $s).values())
      u.destroy();
    w(this, $s).clear(), w(this, cs).clear(), w(this, _p).clear(), (n = w(this, th)) == null || n.clear(), rt(this, Qa, null), w(this, mi).clear(), w(this, jo).destroy(), (s = w(this, Jb)) == null || s.destroy(), (r = w(this, _r)) == null || r.destroy(), (a = w(this, eh)) == null || a.destroy(), (o = w(this, dc)) == null || o.hide(), rt(this, dc, null), (l = w(this, Qb)) == null || l.destroy(), rt(this, Qb, null), rt(this, Pb, null), w(this, uc) && (clearTimeout(w(this, uc)), rt(this, uc, null)), w(this, hc) && (clearTimeout(w(this, hc)), rt(this, hc, null)), (c = this._editorUndoBar) == null || c.destroy(), rt(this, $b, null);
  }
  combinedSignal(t) {
    return AbortSignal.any([this._signal, t.signal]);
  }
  get mlManager() {
    return w(this, q2);
  }
  get useNewAltTextFlow() {
    return w(this, _2);
  }
  get useNewAltTextWhenAddingImage() {
    return w(this, Kb);
  }
  get hcmFilter() {
    return Gn(this, "hcmFilter", w(this, nh) ? w(this, Q2).addHCMFilter(w(this, nh).foreground, w(this, nh).background) : "none");
  }
  get direction() {
    return Gn(this, "direction", getComputedStyle(w(this, fu)).direction);
  }
  get _highlightColors() {
    return Gn(this, "_highlightColors", w(this, Hb) ? new Map(w(this, Hb).split(",").map((t) => (t = t.split("=").map((e) => e.trim()), t[1] = t[1].toUpperCase(), t))) : null);
  }
  get highlightColors() {
    const {
      _highlightColors: t
    } = this;
    if (!t)
      return Gn(this, "highlightColors", null);
    const e = /* @__PURE__ */ new Map(), n = !!w(this, nh);
    for (const [s, r] of t) {
      const a = s.endsWith("_HCM");
      if (n && a) {
        e.set(s.replace("_HCM", ""), r);
        continue;
      }
      !n && !a && e.set(s, r);
    }
    return Gn(this, "highlightColors", e);
  }
  get highlightColorNames() {
    return Gn(this, "highlightColorNames", this.highlightColors ? new Map(Array.from(this.highlightColors, (t) => t.reverse())) : null);
  }
  getNonHCMColor(t) {
    if (!this._highlightColors)
      return t;
    const e = this.highlightColorNames.get(t);
    return this._highlightColors.get(e) || t;
  }
  getNonHCMColorName(t) {
    return this.highlightColorNames.get(t) || t;
  }
  setCurrentDrawingSession(t) {
    t ? (this.unselectAll(), this.disableUserSelect(!0)) : this.disableUserSelect(!1), rt(this, Kd, t);
  }
  setMainHighlightColorPicker(t) {
    rt(this, Qb, t);
  }
  editAltText(t, e = !1) {
    var n;
    (n = w(this, Jb)) == null || n.editAltText(this, t, e);
  }
  hasCommentManager() {
    return !!w(this, _r);
  }
  editComment(t, e, n, s) {
    var r;
    (r = w(this, _r)) == null || r.showDialog(this, t, e, n, s);
  }
  selectComment(t, e) {
    const n = w(this, $s).get(t), s = n == null ? void 0 : n.getEditorByUID(e);
    s == null || s.toggleComment(!0, !0);
  }
  updateComment(t) {
    var e;
    (e = w(this, _r)) == null || e.updateComment(t.getData());
  }
  updatePopupColor(t) {
    var e;
    (e = w(this, _r)) == null || e.updatePopupColor(t);
  }
  removeComment(t) {
    var e;
    (e = w(this, _r)) == null || e.removeComments([t.uid]);
  }
  toggleComment(t, e, n = void 0) {
    var s;
    (s = w(this, _r)) == null || s.toggleCommentPopup(t, e, n);
  }
  makeCommentColor(t, e) {
    var n;
    return t && ((n = w(this, _r)) == null ? void 0 : n.makeCommentColor(t, e)) || null;
  }
  getCommentDialogElement() {
    var t;
    return ((t = w(this, _r)) == null ? void 0 : t.dialogElement) || null;
  }
  async waitForEditorsRendered(t) {
    if (w(this, $s).has(t - 1))
      return;
    const {
      resolve: e,
      promise: n
    } = Promise.withResolvers(), s = (r) => {
      r.pageNumber === t && (this._eventBus._off("editorsrendered", s), e());
    };
    this._eventBus.on("editorsrendered", s), await n;
  }
  getSignature(t) {
    var e;
    (e = w(this, eh)) == null || e.getSignature({
      uiManager: this,
      editor: t
    });
  }
  get signatureManager() {
    return w(this, eh);
  }
  switchToMode(t, e) {
    this._eventBus.on("annotationeditormodechanged", e, {
      once: !0,
      signal: this._signal
    }), this._eventBus.dispatch("showannotationeditorui", {
      source: this,
      mode: t
    });
  }
  setPreference(t, e) {
    this._eventBus.dispatch("setpreference", {
      source: this,
      name: t,
      value: e
    });
  }
  onSetPreference({
    name: t,
    value: e
  }) {
    switch (t) {
      case "enableNewAltTextWhenAddingImage":
        rt(this, Kb, e);
        break;
    }
  }
  onPageChanging({
    pageNumber: t
  }) {
    rt(this, Bb, t - 1);
  }
  focusMainContainer() {
    w(this, fu).focus();
  }
  findParent(t, e) {
    for (const n of w(this, $s).values()) {
      const {
        x: s,
        y: r,
        width: a,
        height: o
      } = n.div.getBoundingClientRect();
      if (t >= s && t <= s + a && e >= r && e <= r + o)
        return n;
    }
    return null;
  }
  disableUserSelect(t = !1) {
    w(this, nZ).classList.toggle("noUserSelect", t);
  }
  addShouldRescale(t) {
    w(this, _p).add(t);
  }
  removeShouldRescale(t) {
    w(this, _p).delete(t);
  }
  onScaleChanging({
    scale: t
  }) {
    var e;
    this.commitOrRemove(), this.viewParameters.realScale = t * qh.PDF_TO_CSS_UNITS;
    for (const n of w(this, _p))
      n.onScaleChanging();
    (e = w(this, Kd)) == null || e.onScaleChanging();
  }
  onRotationChanging({
    pagesRotation: t
  }) {
    this.commitOrRemove(), this.viewParameters.rotation = t;
  }
  highlightSelection(t = "", e = !1) {
    const n = document.getSelection();
    if (!n || n.isCollapsed)
      return;
    const {
      anchorNode: s,
      anchorOffset: r,
      focusNode: a,
      focusOffset: o
    } = n, l = n.toString(), u = ft(this, Ve, xN).call(this, n).closest(".textLayer"), d = this.getSelectionBoxes(u);
    if (!d)
      return;
    n.empty();
    const h = ft(this, Ve, NV).call(this, u), p = w(this, Ds) === fn.NONE, m = () => {
      const b = h == null ? void 0 : h.createAndAddNewEditor({
        x: 0,
        y: 0
      }, !1, {
        methodOfCreation: t,
        boxes: d,
        anchorNode: s,
        anchorOffset: r,
        focusNode: a,
        focusOffset: o,
        text: l
      });
      p && this.showAllEditors("highlight", !0, !0), e && (b == null || b.editComment());
    };
    if (p) {
      this.switchToMode(fn.HIGHLIGHT, m);
      return;
    }
    m();
  }
  commentSelection(t = "") {
    this.highlightSelection(t, !0);
  }
  getAndRemoveDataFromAnnotationStorage(t) {
    if (!w(this, Fo))
      return null;
    const e = `${z2}${t}`, n = w(this, Fo).getRawValue(e);
    return n && w(this, Fo).remove(e), n;
  }
  addToAnnotationStorage(t) {
    !t.isEmpty() && w(this, Fo) && !w(this, Fo).has(t.id) && w(this, Fo).setValue(t.id, t);
  }
  a11yAlert(t, e = null) {
    const n = w(this, iZ);
    n && (n.setAttribute("data-l10n-id", t), e ? n.setAttribute("data-l10n-args", JSON.stringify(e)) : n.removeAttribute("data-l10n-args"));
  }
  blur() {
    if (this.isShiftKeyDown = !1, w(this, Qd) && (rt(this, Qd, !1), ft(this, Ve, Cy).call(this, "main_toolbar")), !this.hasSelection)
      return;
    const {
      activeElement: t
    } = document;
    for (const e of w(this, mi))
      if (e.div.contains(t)) {
        rt(this, Qp, [e, t]), e._focusEventsAllowed = !1;
        break;
      }
  }
  focus() {
    if (!w(this, Qp))
      return;
    const [t, e] = w(this, Qp);
    rt(this, Qp, null), e.addEventListener("focusin", () => {
      t._focusEventsAllowed = !0;
    }, {
      once: !0,
      signal: this._signal
    }), e.focus();
  }
  addEditListeners() {
    ft(this, Ve, WV).call(this), ft(this, Ve, GV).call(this);
  }
  removeEditListeners() {
    ft(this, Ve, UB).call(this), ft(this, Ve, wV).call(this);
  }
  dragOver(t) {
    for (const {
      type: e
    } of t.dataTransfer.items)
      for (const n of w(this, Uo))
        if (n.isHandlingMimeForPasting(e)) {
          t.dataTransfer.dropEffect = "copy", t.preventDefault();
          return;
        }
  }
  drop(t) {
    for (const e of t.dataTransfer.items)
      for (const n of w(this, Uo))
        if (n.isHandlingMimeForPasting(e.type)) {
          n.paste(e, this.currentLayer), t.preventDefault();
          return;
        }
  }
  copy(t) {
    var n;
    if (t.preventDefault(), (n = w(this, Qa)) == null || n.commitOrRemove(), !this.hasSelection)
      return;
    const e = [];
    for (const s of w(this, mi)) {
      const r = s.serialize(!0);
      r && e.push(r);
    }
    e.length !== 0 && t.clipboardData.setData("application/pdfjs", JSON.stringify(e));
  }
  cut(t) {
    this.copy(t), this.delete();
  }
  async paste(t) {
    t.preventDefault();
    const {
      clipboardData: e
    } = t;
    for (const r of e.items)
      for (const a of w(this, Uo))
        if (a.isHandlingMimeForPasting(r.type)) {
          a.paste(r, this.currentLayer);
          return;
        }
    let n = e.getData("application/pdfjs");
    if (!n)
      return;
    try {
      n = JSON.parse(n);
    } catch (r) {
      pn(`paste: "${r.message}".`);
      return;
    }
    if (!Array.isArray(n))
      return;
    this.unselectAll();
    const s = this.currentLayer;
    try {
      const r = [];
      for (const l of n) {
        const c = await s.deserialize(l);
        if (!c)
          return;
        r.push(c);
      }
      const a = () => {
        for (const l of r)
          ft(this, Ve, xV).call(this, l);
        ft(this, Ve, SV).call(this, r);
      }, o = () => {
        for (const l of r)
          l.remove();
      };
      this.addCommands({
        cmd: a,
        undo: o,
        mustExec: !0
      });
    } catch (r) {
      pn(`paste: "${r.message}".`);
    }
  }
  keydown(t) {
    !this.isShiftKeyDown && t.key === "Shift" && (this.isShiftKeyDown = !0), w(this, Ds) !== fn.NONE && !this.isEditorHandlingKeyboard && wb._keyboardManager.exec(this, t);
  }
  keyup(t) {
    this.isShiftKeyDown && t.key === "Shift" && (this.isShiftKeyDown = !1, w(this, Qd) && (rt(this, Qd, !1), ft(this, Ve, Cy).call(this, "main_toolbar")));
  }
  onEditingAction({
    name: t
  }) {
    switch (t) {
      case "undo":
      case "redo":
      case "delete":
      case "selectAll":
        this[t]();
        break;
      case "highlightSelection":
        this.highlightSelection("context_menu");
        break;
      case "commentSelection":
        this.commentSelection("context_menu");
        break;
    }
  }
  setEditingState(t) {
    t ? (ft(this, Ve, FB).call(this), ft(this, Ve, GV).call(this), ft(this, Ve, fa).call(this, {
      isEditing: w(this, Ds) !== fn.NONE,
      isEmpty: ft(this, Ve, Yy).call(this),
      hasSomethingToUndo: w(this, jo).hasSomethingToUndo(),
      hasSomethingToRedo: w(this, jo).hasSomethingToRedo(),
      hasSelectedEditor: !1
    })) : (ft(this, Ve, jB).call(this), ft(this, Ve, wV).call(this), ft(this, Ve, fa).call(this, {
      isEditing: !1
    }), this.disableUserSelect(!1));
  }
  registerEditorTypes(t) {
    if (!w(this, Uo)) {
      rt(this, Uo, t);
      for (const e of w(this, Uo))
        ft(this, Ve, au).call(this, e.defaultPropertiesToUpdate);
    }
  }
  getId() {
    return w(this, uG).id;
  }
  get currentLayer() {
    return w(this, $s).get(w(this, Bb));
  }
  getLayer(t) {
    return w(this, $s).get(t);
  }
  get currentPageIndex() {
    return w(this, Bb);
  }
  addLayer(t) {
    w(this, $s).set(t.pageIndex, t), w(this, $d) ? t.enable() : t.disable();
  }
  removeLayer(t) {
    w(this, $s).delete(t.pageIndex);
  }
  async updateMode(t, e = null, n = !1, s = !1, r = !1) {
    var a, o, l, c, u, d;
    if (w(this, Ds) !== t && !(w(this, Po) && (await w(this, Po).promise, !w(this, Po)))) {
      if (rt(this, Po, Promise.withResolvers()), (a = w(this, Kd)) == null || a.commitOrRemove(), w(this, Ds) === fn.POPUP && ((o = w(this, _r)) == null || o.hideSidebar()), (l = w(this, _r)) == null || l.destroyPopup(), rt(this, Ds, t), t === fn.NONE) {
        this.setEditingState(!1), ft(this, Ve, AB).call(this);
        for (const h of w(this, cs).values())
          h.hideStandaloneCommentButton();
        (c = this._editorUndoBar) == null || c.hide(), this.toggleComment(null), w(this, Po).resolve();
        return;
      }
      for (const h of w(this, cs).values())
        h.addStandaloneCommentButton();
      t === fn.SIGNATURE && await ((u = w(this, eh)) == null ? void 0 : u.loadSignatures()), this.setEditingState(!0), await ft(this, Ve, JB).call(this), this.unselectAll();
      for (const h of w(this, $s).values())
        h.updateMode(t);
      if (t === fn.POPUP) {
        w(this, Pb) || rt(this, Pb, await w(this, $b).getAnnotationsByType(new Set(w(this, Uo).map((m) => m._editorType))));
        const h = /* @__PURE__ */ new Set(), p = [];
        for (const m of w(this, cs).values()) {
          const {
            annotationElementId: b,
            hasComment: y,
            deleted: Z
          } = m;
          b && h.add(b), y && !Z && p.push(m.getData());
        }
        for (const m of w(this, Pb)) {
          const {
            id: b,
            popupRef: y,
            contentsObj: Z
          } = m;
          y && (Z != null && Z.str) && !h.has(b) && !w(this, Hd).has(b) && p.push(m);
        }
        (d = w(this, _r)) == null || d.showSidebar(p);
      }
      if (!e) {
        n && this.addNewEditorFromKeyboard(), w(this, Po).resolve();
        return;
      }
      for (const h of w(this, cs).values())
        h.uid === e ? (this.setSelected(h), r ? h.editComment() : s ? h.enterInEditMode() : h.focus()) : h.unselect();
      w(this, Po).resolve();
    }
  }
  addNewEditorFromKeyboard() {
    this.currentLayer.canCreateNewEmptyEditor() && this.currentLayer.addNewEditor();
  }
  updateToolbar(t) {
    t.mode !== w(this, Ds) && this._eventBus.dispatch("switchannotationeditormode", {
      source: this,
      ...t
    });
  }
  updateParams(t, e) {
    if (w(this, Uo)) {
      switch (t) {
        case Un.CREATE:
          this.currentLayer.addNewEditor(e);
          return;
        case Un.HIGHLIGHT_SHOW_ALL:
          this._eventBus.dispatch("reporttelemetry", {
            source: this,
            details: {
              type: "editing",
              data: {
                type: "highlight",
                action: "toggle_visibility"
              }
            }
          }), (w(this, tZ) || rt(this, tZ, /* @__PURE__ */ new Map())).set(t, e), this.showAllEditors("highlight", e);
          break;
      }
      if (this.hasSelection)
        for (const n of w(this, mi))
          n.updateParams(t, e);
      else
        for (const n of w(this, Uo))
          n.updateDefaultParams(t, e);
    }
  }
  showAllEditors(t, e, n = !1) {
    var r;
    for (const a of w(this, cs).values())
      a.editorType === t && a.show(e);
    (((r = w(this, tZ)) == null ? void 0 : r.get(Un.HIGHLIGHT_SHOW_ALL)) ?? !0) !== e && ft(this, Ve, au).call(this, [[Un.HIGHLIGHT_SHOW_ALL, e]]);
  }
  enableWaiting(t = !1) {
    if (w(this, $2) !== t) {
      rt(this, $2, t);
      for (const e of w(this, $s).values())
        t ? e.disableClick() : e.enableClick(), e.div.classList.toggle("waiting", t);
    }
  }
  *getEditors(t) {
    for (const e of w(this, cs).values())
      e.pageIndex === t && (yield e);
  }
  getEditor(t) {
    return w(this, cs).get(t);
  }
  addEditor(t) {
    w(this, cs).set(t.id, t);
  }
  removeEditor(t) {
    var e, n;
    t.div.contains(document.activeElement) && (w(this, uc) && clearTimeout(w(this, uc)), rt(this, uc, setTimeout(() => {
      this.focusMainContainer(), rt(this, uc, null);
    }, 0))), w(this, cs).delete(t.id), t.annotationElementId && ((e = w(this, th)) == null || e.delete(t.annotationElementId)), this.unselect(t), (!t.annotationElementId || !w(this, Hd).has(t.annotationElementId)) && ((n = w(this, Fo)) == null || n.remove(t.id));
  }
  addDeletedAnnotationElement(t) {
    w(this, Hd).add(t.annotationElementId), this.addChangedExistingAnnotation(t), t.deleted = !0;
  }
  isDeletedAnnotationElement(t) {
    return w(this, Hd).has(t);
  }
  removeDeletedAnnotationElement(t) {
    w(this, Hd).delete(t.annotationElementId), this.removeChangedExistingAnnotation(t), t.deleted = !1;
  }
  setActiveEditor(t) {
    w(this, Qa) !== t && (rt(this, Qa, t), t && ft(this, Ve, au).call(this, t.propertiesToUpdate));
  }
  updateUI(t) {
    w(this, Ve, BB) === t && ft(this, Ve, au).call(this, t.propertiesToUpdate);
  }
  updateUIForDefaultProperties(t) {
    ft(this, Ve, au).call(this, t.defaultPropertiesToUpdate);
  }
  toggleSelected(t) {
    if (w(this, mi).has(t)) {
      w(this, mi).delete(t), t.unselect(), ft(this, Ve, fa).call(this, {
        hasSelectedEditor: this.hasSelection
      });
      return;
    }
    w(this, mi).add(t), t.select(), ft(this, Ve, au).call(this, t.propertiesToUpdate), ft(this, Ve, fa).call(this, {
      hasSelectedEditor: !0
    });
  }
  setSelected(t) {
    var e;
    this.updateToolbar({
      mode: t.mode,
      editId: t.id
    }), (e = w(this, Kd)) == null || e.commitOrRemove();
    for (const n of w(this, mi))
      n !== t && n.unselect();
    w(this, mi).clear(), w(this, mi).add(t), t.select(), ft(this, Ve, au).call(this, t.propertiesToUpdate), ft(this, Ve, fa).call(this, {
      hasSelectedEditor: !0
    });
  }
  isSelected(t) {
    return w(this, mi).has(t);
  }
  get firstSelectedEditor() {
    return w(this, mi).values().next().value;
  }
  unselect(t) {
    t.unselect(), w(this, mi).delete(t), ft(this, Ve, fa).call(this, {
      hasSelectedEditor: this.hasSelection
    });
  }
  get hasSelection() {
    return w(this, mi).size !== 0;
  }
  get isEnterHandled() {
    return w(this, mi).size === 1 && this.firstSelectedEditor.isEnterHandled;
  }
  undo() {
    var t;
    w(this, jo).undo(), ft(this, Ve, fa).call(this, {
      hasSomethingToUndo: w(this, jo).hasSomethingToUndo(),
      hasSomethingToRedo: !0,
      isEmpty: ft(this, Ve, Yy).call(this)
    }), (t = this._editorUndoBar) == null || t.hide();
  }
  redo() {
    w(this, jo).redo(), ft(this, Ve, fa).call(this, {
      hasSomethingToUndo: !0,
      hasSomethingToRedo: w(this, jo).hasSomethingToRedo(),
      isEmpty: ft(this, Ve, Yy).call(this)
    });
  }
  addCommands(t) {
    w(this, jo).add(t), ft(this, Ve, fa).call(this, {
      hasSomethingToUndo: !0,
      hasSomethingToRedo: !1,
      isEmpty: ft(this, Ve, Yy).call(this)
    });
  }
  cleanUndoStack(t) {
    w(this, jo).cleanType(t);
  }
  delete() {
    var r;
    this.commitOrRemove();
    const t = (r = this.currentLayer) == null ? void 0 : r.endDrawingSession(!0);
    if (!this.hasSelection && !t)
      return;
    const e = t ? [t] : [...w(this, mi)], n = () => {
      var a;
      (a = this._editorUndoBar) == null || a.show(s, e.length === 1 ? e[0].editorType : e.length);
      for (const o of e)
        o.remove();
    }, s = () => {
      for (const a of e)
        ft(this, Ve, xV).call(this, a);
    };
    this.addCommands({
      cmd: n,
      undo: s,
      mustExec: !0
    });
  }
  commitOrRemove() {
    var t;
    (t = w(this, Qa)) == null || t.commitOrRemove();
  }
  hasSomethingToControl() {
    return w(this, Qa) || this.hasSelection;
  }
  selectAll() {
    for (const t of w(this, mi))
      t.commit();
    ft(this, Ve, SV).call(this, w(this, cs).values());
  }
  unselectAll() {
    var t;
    if (!(w(this, Qa) && (w(this, Qa).commitOrRemove(), w(this, Ds) !== fn.NONE)) && !((t = w(this, Kd)) != null && t.commitOrRemove()) && this.hasSelection) {
      for (const e of w(this, mi))
        e.unselect();
      w(this, mi).clear(), ft(this, Ve, fa).call(this, {
        hasSelectedEditor: !1
      });
    }
  }
  translateSelectedEditors(t, e, n = !1) {
    if (n || this.commitOrRemove(), !this.hasSelection)
      return;
    w(this, ih)[0] += t, w(this, ih)[1] += e;
    const [s, r] = w(this, ih), a = [...w(this, mi)], o = 1e3;
    w(this, hc) && clearTimeout(w(this, hc)), rt(this, hc, setTimeout(() => {
      rt(this, hc, null), w(this, ih)[0] = w(this, ih)[1] = 0, this.addCommands({
        cmd: () => {
          for (const l of a)
            w(this, cs).has(l.id) && (l.translateInPage(s, r), l.translationDone());
        },
        undo: () => {
          for (const l of a)
            w(this, cs).has(l.id) && (l.translateInPage(-s, -r), l.translationDone());
        },
        mustExec: !1
      });
    }, o));
    for (const l of a)
      l.translateInPage(t, e), l.translationDone();
  }
  setUpDragSession() {
    if (this.hasSelection) {
      this.disableUserSelect(!0), rt(this, cc, /* @__PURE__ */ new Map());
      for (const t of w(this, mi))
        w(this, cc).set(t, {
          savedX: t.x,
          savedY: t.y,
          savedPageIndex: t.pageIndex,
          newX: 0,
          newY: 0,
          newPageIndex: -1
        });
    }
  }
  endDragSession() {
    if (!w(this, cc))
      return !1;
    this.disableUserSelect(!1);
    const t = w(this, cc);
    rt(this, cc, null);
    let e = !1;
    for (const [{
      x: s,
      y: r,
      pageIndex: a
    }, o] of t)
      o.newX = s, o.newY = r, o.newPageIndex = a, e || (e = s !== o.savedX || r !== o.savedY || a !== o.savedPageIndex);
    if (!e)
      return !1;
    const n = (s, r, a, o) => {
      if (w(this, cs).has(s.id)) {
        const l = w(this, $s).get(o);
        l ? s._setParentAndPosition(l, r, a) : (s.pageIndex = o, s.x = r, s.y = a);
      }
    };
    return this.addCommands({
      cmd: () => {
        for (const [s, {
          newX: r,
          newY: a,
          newPageIndex: o
        }] of t)
          n(s, r, a, o);
      },
      undo: () => {
        for (const [s, {
          savedX: r,
          savedY: a,
          savedPageIndex: o
        }] of t)
          n(s, r, a, o);
      },
      mustExec: !0
    }), !0;
  }
  dragSelectedEditors(t, e) {
    if (w(this, cc))
      for (const n of w(this, cc).keys())
        n.drag(t, e);
  }
  rebuild(t) {
    if (t.parent === null) {
      const e = this.getLayer(t.pageIndex);
      e ? (e.changeParent(t), e.addOrRebuild(t)) : (this.addEditor(t), this.addToAnnotationStorage(t), t.rebuild());
    } else
      t.parent.addOrRebuild(t);
  }
  get isEditorHandlingKeyboard() {
    var t;
    return ((t = this.getActive()) == null ? void 0 : t.shouldGetKeyboardEvents()) || w(this, mi).size === 1 && this.firstSelectedEditor.shouldGetKeyboardEvents();
  }
  isActive(t) {
    return w(this, Qa) === t;
  }
  getActive() {
    return w(this, Qa);
  }
  getMode() {
    return w(this, Ds);
  }
  isEditingMode() {
    return w(this, Ds) !== fn.NONE;
  }
  get imageManager() {
    return Gn(this, "imageManager", new TV());
  }
  getSelectionBoxes(t) {
    if (!t)
      return null;
    const e = document.getSelection();
    for (let c = 0, u = e.rangeCount; c < u; c++)
      if (!t.contains(e.getRangeAt(c).commonAncestorContainer))
        return null;
    const {
      x: n,
      y: s,
      width: r,
      height: a
    } = t.getBoundingClientRect();
    let o;
    switch (t.getAttribute("data-main-rotation")) {
      case "90":
        o = (c, u, d, h) => ({
          x: (u - s) / a,
          y: 1 - (c + d - n) / r,
          width: h / a,
          height: d / r
        });
        break;
      case "180":
        o = (c, u, d, h) => ({
          x: 1 - (c + d - n) / r,
          y: 1 - (u + h - s) / a,
          width: d / r,
          height: h / a
        });
        break;
      case "270":
        o = (c, u, d, h) => ({
          x: 1 - (u + h - s) / a,
          y: (c - n) / r,
          width: h / a,
          height: d / r
        });
        break;
      default:
        o = (c, u, d, h) => ({
          x: (c - n) / r,
          y: (u - s) / a,
          width: d / r,
          height: h / a
        });
        break;
    }
    const l = [];
    for (let c = 0, u = e.rangeCount; c < u; c++) {
      const d = e.getRangeAt(c);
      if (!d.collapsed)
        for (const {
          x: h,
          y: p,
          width: m,
          height: b
        } of d.getClientRects())
          m === 0 || b === 0 || l.push(o(h, p, m, b));
    }
    return l.length === 0 ? null : l;
  }
  addChangedExistingAnnotation({
    annotationElementId: t,
    id: e
  }) {
    (w(this, Ab) || rt(this, Ab, /* @__PURE__ */ new Map())).set(t, e);
  }
  removeChangedExistingAnnotation({
    annotationElementId: t
  }) {
    var e;
    (e = w(this, Ab)) == null || e.delete(t);
  }
  renderAnnotationElement(t) {
    var s;
    const e = (s = w(this, Ab)) == null ? void 0 : s.get(t.data.id);
    if (!e)
      return;
    const n = w(this, Fo).getRawValue(e);
    n && (w(this, Ds) === fn.NONE && !n.hasBeenModified || n.renderAnnotationElement(t));
  }
  setMissingCanvas(t, e, n) {
    var r;
    const s = (r = w(this, th)) == null ? void 0 : r.get(t);
    s && (s.setCanvas(e, n), w(this, th).delete(t));
  }
  addMissingCanvas(t, e) {
    (w(this, th) || rt(this, th, /* @__PURE__ */ new Map())).set(t, e);
  }
};
Ub = new WeakMap(), Qa = new WeakMap(), Pb = new WeakMap(), cs = new WeakMap(), $s = new WeakMap(), Jb = new WeakMap(), Fo = new WeakMap(), Ab = new WeakMap(), jo = new WeakMap(), _r = new WeakMap(), Bd = new WeakMap(), Kd = new WeakMap(), Bb = new WeakMap(), Hd = new WeakMap(), cc = new WeakMap(), Uo = new WeakMap(), _p = new WeakMap(), H2 = new WeakMap(), _2 = new WeakMap(), Kb = new WeakMap(), Q2 = new WeakMap(), uc = new WeakMap(), _d = new WeakMap(), Hb = new WeakMap(), Qd = new WeakMap(), dc = new WeakMap(), uG = new WeakMap(), $d = new WeakMap(), _b = new WeakMap(), $2 = new WeakMap(), qd = new WeakMap(), Qp = new WeakMap(), Qb = new WeakMap(), th = new WeakMap(), q2 = new WeakMap(), Ds = new WeakMap(), mi = new WeakMap(), bu = new WeakMap(), eh = new WeakMap(), nh = new WeakMap(), tZ = new WeakMap(), $b = new WeakMap(), eZ = new WeakMap(), ih = new WeakMap(), hc = new WeakMap(), fu = new WeakMap(), nZ = new WeakMap(), iZ = new WeakMap(), Po = new WeakMap(), Ve = new WeakSet(), xN = function({
  anchorNode: t
}) {
  return t.nodeType === Node.TEXT_NODE ? t.parentElement : t;
}, NV = function(t) {
  const {
    currentLayer: e
  } = this;
  if (e.hasTextLayer(t))
    return e;
  for (const n of w(this, $s).values())
    if (n.hasTextLayer(t))
      return n;
  return null;
}, zB = function() {
  const t = document.getSelection();
  if (!t || t.isCollapsed)
    return;
  const n = ft(this, Ve, xN).call(this, t).closest(".textLayer"), s = this.getSelectionBoxes(n);
  s && (w(this, dc) || rt(this, dc, new gIt(this)), w(this, dc).show(n, s, this.direction === "ltr"));
}, EB = function() {
  var r, a, o;
  const t = document.getSelection();
  if (!t || t.isCollapsed) {
    w(this, bu) && ((r = w(this, dc)) == null || r.hide(), rt(this, bu, null), ft(this, Ve, fa).call(this, {
      hasSelectedText: !1
    }));
    return;
  }
  const {
    anchorNode: e
  } = t;
  if (e === w(this, bu))
    return;
  const s = ft(this, Ve, xN).call(this, t).closest(".textLayer");
  if (!s) {
    w(this, bu) && ((a = w(this, dc)) == null || a.hide(), rt(this, bu, null), ft(this, Ve, fa).call(this, {
      hasSelectedText: !1
    }));
    return;
  }
  if ((o = w(this, dc)) == null || o.hide(), rt(this, bu, e), ft(this, Ve, fa).call(this, {
    hasSelectedText: !0
  }), !(w(this, Ds) !== fn.HIGHLIGHT && w(this, Ds) !== fn.NONE) && (w(this, Ds) === fn.HIGHLIGHT && this.showAllEditors("highlight", !0, !0), rt(this, Qd, this.isShiftKeyDown), !this.isShiftKeyDown)) {
    const l = w(this, Ds) === fn.HIGHLIGHT ? ft(this, Ve, NV).call(this, s) : null;
    if (l == null || l.toggleDrawing(), w(this, _b)) {
      const c = new AbortController(), u = this.combinedSignal(c), d = (h) => {
        h.type === "pointerup" && h.button !== 0 || (c.abort(), l == null || l.toggleDrawing(!0), h.type === "pointerup" && ft(this, Ve, Cy).call(this, "main_toolbar"));
      };
      window.addEventListener("pointerup", d, {
        signal: u
      }), window.addEventListener("blur", d, {
        signal: u
      });
    } else
      l == null || l.toggleDrawing(!0), ft(this, Ve, Cy).call(this, "main_toolbar");
  }
}, Cy = function(t = "") {
  w(this, Ds) === fn.HIGHLIGHT ? this.highlightSelection(t) : w(this, H2) && ft(this, Ve, zB).call(this);
}, kB = function() {
  document.addEventListener("selectionchange", ft(this, Ve, EB).bind(this), {
    signal: this._signal
  });
}, FB = function() {
  if (w(this, _d))
    return;
  rt(this, _d, new AbortController());
  const t = this.combinedSignal(w(this, _d));
  window.addEventListener("focus", this.focus.bind(this), {
    signal: t
  }), window.addEventListener("blur", this.blur.bind(this), {
    signal: t
  });
}, jB = function() {
  var t;
  (t = w(this, _d)) == null || t.abort(), rt(this, _d, null);
}, WV = function() {
  if (w(this, qd))
    return;
  rt(this, qd, new AbortController());
  const t = this.combinedSignal(w(this, qd));
  window.addEventListener("keydown", this.keydown.bind(this), {
    signal: t
  }), window.addEventListener("keyup", this.keyup.bind(this), {
    signal: t
  });
}, UB = function() {
  var t;
  (t = w(this, qd)) == null || t.abort(), rt(this, qd, null);
}, GV = function() {
  if (w(this, Bd))
    return;
  rt(this, Bd, new AbortController());
  const t = this.combinedSignal(w(this, Bd));
  document.addEventListener("copy", this.copy.bind(this), {
    signal: t
  }), document.addEventListener("cut", this.cut.bind(this), {
    signal: t
  }), document.addEventListener("paste", this.paste.bind(this), {
    signal: t
  });
}, wV = function() {
  var t;
  (t = w(this, Bd)) == null || t.abort(), rt(this, Bd, null);
}, PB = function() {
  const t = this._signal;
  document.addEventListener("dragover", this.dragOver.bind(this), {
    signal: t
  }), document.addEventListener("drop", this.drop.bind(this), {
    signal: t
  });
}, fa = function(t) {
  Object.entries(t).some(([n, s]) => w(this, eZ)[n] !== s) && (this._eventBus.dispatch("annotationeditorstateschanged", {
    source: this,
    details: Object.assign(w(this, eZ), t)
  }), w(this, Ds) === fn.HIGHLIGHT && t.hasSelectedEditor === !1 && ft(this, Ve, au).call(this, [[Un.HIGHLIGHT_FREE, !0]]));
}, au = function(t) {
  this._eventBus.dispatch("annotationeditorparamschanged", {
    source: this,
    details: t
  });
}, JB = async function() {
  if (!w(this, $d)) {
    rt(this, $d, !0);
    const t = [];
    for (const e of w(this, $s).values())
      t.push(e.enable());
    await Promise.all(t);
    for (const e of w(this, cs).values())
      e.enable();
  }
}, AB = function() {
  if (this.unselectAll(), w(this, $d)) {
    rt(this, $d, !1);
    for (const t of w(this, $s).values())
      t.disable();
    for (const t of w(this, cs).values())
      t.disable();
  }
}, xV = function(t) {
  const e = w(this, $s).get(t.pageIndex);
  e ? e.addOrRebuild(t) : (this.addEditor(t), this.addToAnnotationStorage(t));
}, BB = function() {
  let t = null;
  for (t of w(this, mi))
    ;
  return t;
}, Yy = function() {
  if (w(this, cs).size === 0)
    return !0;
  if (w(this, cs).size === 1)
    for (const t of w(this, cs).values())
      return t.isEmpty();
  return !1;
}, SV = function(t) {
  for (const e of w(this, mi))
    e.unselect();
  w(this, mi).clear();
  for (const e of t)
    e.isEmpty() || (w(this, mi).add(e), e.select());
  ft(this, Ve, fa).call(this, {
    hasSelectedEditor: this.hasSelection
  });
}, S(wb, "TRANSLATE_SMALL", 1), S(wb, "TRANSLATE_BIG", 10);
let G0 = wb;
var rr, pc, yl, qb, mc, $a, tf, bc, Ya, gu, $p, fc, sh, El, vy, SN;
const ga = class ga {
  constructor(t) {
    pt(this, El);
    pt(this, rr, null);
    pt(this, pc, !1);
    pt(this, yl, null);
    pt(this, qb, null);
    pt(this, mc, null);
    pt(this, $a, null);
    pt(this, tf, !1);
    pt(this, bc, null);
    pt(this, Ya, null);
    pt(this, gu, null);
    pt(this, $p, null);
    pt(this, fc, !1);
    rt(this, Ya, t), rt(this, fc, t._uiManager.useNewAltTextFlow), w(ga, sh) || rt(ga, sh, Object.freeze({
      added: "pdfjs-editor-new-alt-text-added-button",
      "added-label": "pdfjs-editor-new-alt-text-added-button-label",
      missing: "pdfjs-editor-new-alt-text-missing-button",
      "missing-label": "pdfjs-editor-new-alt-text-missing-button-label",
      review: "pdfjs-editor-new-alt-text-to-review-button",
      "review-label": "pdfjs-editor-new-alt-text-to-review-button-label"
    }));
  }
  static initialize(t) {
    ga._l10n ?? (ga._l10n = t);
  }
  async render() {
    const t = rt(this, yl, document.createElement("button"));
    t.className = "altText", t.tabIndex = "0";
    const e = rt(this, qb, document.createElement("span"));
    t.append(e), w(this, fc) ? (t.classList.add("new"), t.setAttribute("data-l10n-id", w(ga, sh).missing), e.setAttribute("data-l10n-id", w(ga, sh)["missing-label"])) : (t.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-button"), e.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-button-label"));
    const n = w(this, Ya)._uiManager._signal;
    t.addEventListener("contextmenu", al, {
      signal: n
    }), t.addEventListener("pointerdown", (r) => r.stopPropagation(), {
      signal: n
    });
    const s = (r) => {
      r.preventDefault(), w(this, Ya)._uiManager.editAltText(w(this, Ya)), w(this, fc) && w(this, Ya)._reportTelemetry({
        action: "pdfjs.image.alt_text.image_status_label_clicked",
        data: {
          label: w(this, El, vy)
        }
      });
    };
    return t.addEventListener("click", s, {
      capture: !0,
      signal: n
    }), t.addEventListener("keydown", (r) => {
      r.target === t && r.key === "Enter" && (rt(this, tf, !0), s(r));
    }, {
      signal: n
    }), await ft(this, El, SN).call(this), t;
  }
  finish() {
    w(this, yl) && (w(this, yl).focus({
      focusVisible: w(this, tf)
    }), rt(this, tf, !1));
  }
  isEmpty() {
    return w(this, fc) ? w(this, rr) === null : !w(this, rr) && !w(this, pc);
  }
  hasData() {
    return w(this, fc) ? w(this, rr) !== null || !!w(this, gu) : this.isEmpty();
  }
  get guessedText() {
    return w(this, gu);
  }
  async setGuessedText(t) {
    w(this, rr) === null && (rt(this, gu, t), rt(this, $p, await ga._l10n.get("pdfjs-editor-new-alt-text-generated-alt-text-with-disclaimer", {
      generatedAltText: t
    })), ft(this, El, SN).call(this));
  }
  toggleAltTextBadge(t = !1) {
    var e;
    if (!w(this, fc) || w(this, rr)) {
      (e = w(this, bc)) == null || e.remove(), rt(this, bc, null);
      return;
    }
    if (!w(this, bc)) {
      const n = rt(this, bc, document.createElement("div"));
      n.className = "noAltTextBadge", w(this, Ya).div.append(n);
    }
    w(this, bc).classList.toggle("hidden", !t);
  }
  serialize(t) {
    let e = w(this, rr);
    return !t && w(this, gu) === e && (e = w(this, $p)), {
      altText: e,
      decorative: w(this, pc),
      guessedText: w(this, gu),
      textWithDisclaimer: w(this, $p)
    };
  }
  get data() {
    return {
      altText: w(this, rr),
      decorative: w(this, pc)
    };
  }
  set data({
    altText: t,
    decorative: e,
    guessedText: n,
    textWithDisclaimer: s,
    cancel: r = !1
  }) {
    n && (rt(this, gu, n), rt(this, $p, s)), !(w(this, rr) === t && w(this, pc) === e) && (r || (rt(this, rr, t), rt(this, pc, e)), ft(this, El, SN).call(this));
  }
  toggle(t = !1) {
    w(this, yl) && (!t && w(this, $a) && (clearTimeout(w(this, $a)), rt(this, $a, null)), w(this, yl).disabled = !t);
  }
  shown() {
    w(this, Ya)._reportTelemetry({
      action: "pdfjs.image.alt_text.image_status_label_displayed",
      data: {
        label: w(this, El, vy)
      }
    });
  }
  destroy() {
    var t, e;
    (t = w(this, yl)) == null || t.remove(), rt(this, yl, null), rt(this, qb, null), rt(this, mc, null), (e = w(this, bc)) == null || e.remove(), rt(this, bc, null);
  }
};
rr = new WeakMap(), pc = new WeakMap(), yl = new WeakMap(), qb = new WeakMap(), mc = new WeakMap(), $a = new WeakMap(), tf = new WeakMap(), bc = new WeakMap(), Ya = new WeakMap(), gu = new WeakMap(), $p = new WeakMap(), fc = new WeakMap(), sh = new WeakMap(), El = new WeakSet(), vy = function() {
  return w(this, rr) && "added" || w(this, rr) === null && this.guessedText && "review" || "missing";
}, SN = async function() {
  var s, r, a;
  const t = w(this, yl);
  if (!t)
    return;
  if (w(this, fc)) {
    if (t.classList.toggle("done", !!w(this, rr)), t.setAttribute("data-l10n-id", w(ga, sh)[w(this, El, vy)]), (s = w(this, qb)) == null || s.setAttribute("data-l10n-id", w(ga, sh)[`${w(this, El, vy)}-label`]), !w(this, rr)) {
      (r = w(this, mc)) == null || r.remove();
      return;
    }
  } else {
    if (!w(this, rr) && !w(this, pc)) {
      t.classList.remove("done"), (a = w(this, mc)) == null || a.remove();
      return;
    }
    t.classList.add("done"), t.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-edit-button");
  }
  let e = w(this, mc);
  if (!e) {
    rt(this, mc, e = document.createElement("span")), e.className = "tooltip", e.setAttribute("role", "tooltip"), e.id = `alt-text-tooltip-${w(this, Ya).id}`;
    const o = 100, l = w(this, Ya)._uiManager._signal;
    l.addEventListener("abort", () => {
      clearTimeout(w(this, $a)), rt(this, $a, null);
    }, {
      once: !0
    }), t.addEventListener("mouseenter", () => {
      rt(this, $a, setTimeout(() => {
        rt(this, $a, null), w(this, mc).classList.add("show"), w(this, Ya)._reportTelemetry({
          action: "alt_text_tooltip"
        });
      }, o));
    }, {
      signal: l
    }), t.addEventListener("mouseleave", () => {
      var c;
      w(this, $a) && (clearTimeout(w(this, $a)), rt(this, $a, null)), (c = w(this, mc)) == null || c.classList.remove("show");
    }, {
      signal: l
    });
  }
  w(this, pc) ? e.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-decorative-tooltip") : (e.removeAttribute("data-l10n-id"), e.textContent = w(this, rr)), e.parentNode || t.append(e);
  const n = w(this, Ya).getElementForAltText();
  n == null || n.setAttribute("aria-describedby", e.id);
}, pt(ga, sh, null), S(ga, "_l10n", null);
let AW = ga;
var Wr, Jo, qp, Yi, sZ, tm, Zl, em, nm, im, rZ, LV;
class OM {
  constructor(t) {
    pt(this, rZ);
    pt(this, Wr, null);
    pt(this, Jo, null);
    pt(this, qp, !1);
    pt(this, Yi, null);
    pt(this, sZ, null);
    pt(this, tm, null);
    pt(this, Zl, null);
    pt(this, em, null);
    pt(this, nm, !1);
    pt(this, im, null);
    rt(this, Yi, t);
  }
  renderForToolbar() {
    const t = rt(this, Jo, document.createElement("button"));
    return t.className = "comment", ft(this, rZ, LV).call(this, t, !1);
  }
  renderForStandalone() {
    const t = rt(this, Wr, document.createElement("button"));
    t.className = "annotationCommentButton";
    const e = w(this, Yi).commentButtonPosition;
    if (e) {
      const {
        style: n
      } = t;
      n.insetInlineEnd = `calc(${100 * (w(this, Yi)._uiManager.direction === "ltr" ? 1 - e[0] : e[0])}% - var(--comment-button-dim))`, n.top = `calc(${100 * e[1]}% - var(--comment-button-dim))`;
      const s = w(this, Yi).commentButtonColor;
      s && (n.backgroundColor = s);
    }
    return ft(this, rZ, LV).call(this, t, !0);
  }
  focusButton() {
    setTimeout(() => {
      var t;
      (t = w(this, Wr) ?? w(this, Jo)) == null || t.focus();
    }, 0);
  }
  onUpdatedColor() {
    if (!w(this, Wr))
      return;
    const t = w(this, Yi).commentButtonColor;
    t && (w(this, Wr).style.backgroundColor = t), w(this, Yi)._uiManager.updatePopupColor(w(this, Yi));
  }
  get commentButtonWidth() {
    var t;
    return (((t = w(this, Wr)) == null ? void 0 : t.getBoundingClientRect().width) ?? 0) / w(this, Yi).parent.boundingClientRect.width;
  }
  get commentPopupPositionInLayer() {
    if (w(this, im))
      return w(this, im);
    if (!w(this, Wr))
      return null;
    const {
      x: t,
      y: e,
      height: n
    } = w(this, Wr).getBoundingClientRect(), {
      x: s,
      y: r,
      width: a,
      height: o
    } = w(this, Yi).parent.boundingClientRect;
    return [(t - s) / a, (e + n - r) / o];
  }
  set commentPopupPositionInLayer(t) {
    rt(this, im, t);
  }
  hasDefaultPopupPosition() {
    return w(this, im) === null;
  }
  removeStandaloneCommentButton() {
    var t;
    (t = w(this, Wr)) == null || t.remove(), rt(this, Wr, null);
  }
  removeToolbarCommentButton() {
    var t;
    (t = w(this, Jo)) == null || t.remove(), rt(this, Jo, null);
  }
  setCommentButtonStates({
    selected: t,
    hasPopup: e
  }) {
    w(this, Wr) && (w(this, Wr).classList.toggle("selected", t), w(this, Wr).ariaExpanded = e);
  }
  edit(t) {
    const e = this.commentPopupPositionInLayer;
    let n, s;
    if (e)
      [n, s] = e;
    else {
      [n, s] = w(this, Yi).commentButtonPosition;
      const {
        width: u,
        height: d,
        x: h,
        y: p
      } = w(this, Yi);
      n = h + n * u, s = p + s * d;
    }
    const r = w(this, Yi).parent.boundingClientRect, {
      x: a,
      y: o,
      width: l,
      height: c
    } = r;
    w(this, Yi)._uiManager.editComment(w(this, Yi), a + n * l, o + s * c, {
      ...t,
      parentDimensions: r
    });
  }
  finish() {
    w(this, Jo) && (w(this, Jo).focus({
      focusVisible: w(this, qp)
    }), rt(this, qp, !1));
  }
  isDeleted() {
    return w(this, nm) || w(this, Zl) === "";
  }
  isEmpty() {
    return w(this, Zl) === null;
  }
  hasBeenEdited() {
    return this.isDeleted() || w(this, Zl) !== w(this, sZ);
  }
  serialize() {
    return this.data;
  }
  get data() {
    return {
      text: w(this, Zl),
      richText: w(this, tm),
      date: w(this, em),
      deleted: this.isDeleted()
    };
  }
  set data(t) {
    if (t !== w(this, Zl) && rt(this, tm, null), t === null) {
      rt(this, Zl, ""), rt(this, nm, !0);
      return;
    }
    rt(this, Zl, t), rt(this, em, /* @__PURE__ */ new Date()), rt(this, nm, !1);
  }
  setInitialText(t, e = null) {
    rt(this, sZ, t), this.data = t, rt(this, em, null), rt(this, tm, e);
  }
  shown() {
  }
  destroy() {
    var t, e;
    (t = w(this, Jo)) == null || t.remove(), rt(this, Jo, null), (e = w(this, Wr)) == null || e.remove(), rt(this, Wr, null), rt(this, Zl, ""), rt(this, tm, null), rt(this, em, null), rt(this, Yi, null), rt(this, qp, !1), rt(this, nm, !1);
  }
}
Wr = new WeakMap(), Jo = new WeakMap(), qp = new WeakMap(), Yi = new WeakMap(), sZ = new WeakMap(), tm = new WeakMap(), Zl = new WeakMap(), em = new WeakMap(), nm = new WeakMap(), im = new WeakMap(), rZ = new WeakSet(), LV = function(t, e) {
  if (!w(this, Yi)._uiManager.hasCommentManager())
    return null;
  t.tabIndex = "0", t.ariaHasPopup = "dialog", e ? (t.ariaControls = "commentPopup", t.setAttribute("data-l10n-id", "pdfjs-show-comment-button")) : (t.ariaControlsElements = [w(this, Yi)._uiManager.getCommentDialogElement()], t.setAttribute("data-l10n-id", "pdfjs-editor-edit-comment-button"));
  const n = w(this, Yi)._uiManager._signal;
  if (!(n instanceof AbortSignal) || n.aborted)
    return t;
  t.addEventListener("contextmenu", al, {
    signal: n
  }), e && (t.addEventListener("focusin", (r) => {
    w(this, Yi)._focusEventsAllowed = !1, ms(r);
  }, {
    capture: !0,
    signal: n
  }), t.addEventListener("focusout", (r) => {
    w(this, Yi)._focusEventsAllowed = !0, ms(r);
  }, {
    capture: !0,
    signal: n
  })), t.addEventListener("pointerdown", (r) => r.stopPropagation(), {
    signal: n
  });
  const s = (r) => {
    r.preventDefault(), t === w(this, Jo) ? this.edit() : w(this, Yi).toggleComment(!0);
  };
  return t.addEventListener("click", s, {
    capture: !0,
    signal: n
  }), t.addEventListener("keydown", (r) => {
    r.target === t && r.key === "Enter" && (rt(this, qp, !0), s(r));
  }, {
    signal: n
  }), t.addEventListener("pointerenter", () => {
    w(this, Yi).toggleComment(!1, !0);
  }, {
    signal: n
  }), t.addEventListener("pointerleave", () => {
    w(this, Yi).toggleComment(!1, !1);
  }, {
    signal: n
  }), t;
};
var ef, sm, aZ, oZ, lZ, cZ, uZ, yu, rm, Zu, am, Tu, tp, KB, HB, _B;
const dY = class dY {
  constructor({
    container: t,
    isPinchingDisabled: e = null,
    isPinchingStopped: n = null,
    onPinchStart: s = null,
    onPinching: r = null,
    onPinchEnd: a = null,
    signal: o
  }) {
    pt(this, tp);
    pt(this, ef);
    pt(this, sm, !1);
    pt(this, aZ, null);
    pt(this, oZ);
    pt(this, lZ);
    pt(this, cZ);
    pt(this, uZ);
    pt(this, yu, null);
    pt(this, rm);
    pt(this, Zu, null);
    pt(this, am);
    pt(this, Tu, null);
    rt(this, ef, t), rt(this, aZ, n), rt(this, oZ, e), rt(this, lZ, s), rt(this, cZ, r), rt(this, uZ, a), rt(this, am, new AbortController()), rt(this, rm, AbortSignal.any([o, w(this, am).signal])), t.addEventListener("touchstart", ft(this, tp, KB).bind(this), {
      passive: !1,
      signal: w(this, rm)
    });
  }
  get MIN_TOUCH_DISTANCE_TO_PINCH() {
    return 35 / Uc.pixelRatio;
  }
  destroy() {
    var t, e;
    (t = w(this, am)) == null || t.abort(), rt(this, am, null), (e = w(this, yu)) == null || e.abort(), rt(this, yu, null);
  }
};
ef = new WeakMap(), sm = new WeakMap(), aZ = new WeakMap(), oZ = new WeakMap(), lZ = new WeakMap(), cZ = new WeakMap(), uZ = new WeakMap(), yu = new WeakMap(), rm = new WeakMap(), Zu = new WeakMap(), am = new WeakMap(), Tu = new WeakMap(), tp = new WeakSet(), KB = function(t) {
  var s, r, a;
  if ((s = w(this, oZ)) != null && s.call(this))
    return;
  if (t.touches.length === 1) {
    if (w(this, yu))
      return;
    const o = rt(this, yu, new AbortController()), l = AbortSignal.any([w(this, rm), o.signal]), c = w(this, ef), u = {
      capture: !0,
      signal: l,
      passive: !1
    }, d = (h) => {
      var p;
      h.pointerType === "touch" && ((p = w(this, yu)) == null || p.abort(), rt(this, yu, null));
    };
    c.addEventListener("pointerdown", (h) => {
      h.pointerType === "touch" && (ms(h), d(h));
    }, u), c.addEventListener("pointerup", d, u), c.addEventListener("pointercancel", d, u);
    return;
  }
  if (!w(this, Tu)) {
    rt(this, Tu, new AbortController());
    const o = AbortSignal.any([w(this, rm), w(this, Tu).signal]), l = w(this, ef), c = {
      signal: o,
      capture: !1,
      passive: !1
    };
    l.addEventListener("touchmove", ft(this, tp, HB).bind(this), c);
    const u = ft(this, tp, _B).bind(this);
    l.addEventListener("touchend", u, c), l.addEventListener("touchcancel", u, c), c.capture = !0, l.addEventListener("pointerdown", ms, c), l.addEventListener("pointermove", ms, c), l.addEventListener("pointercancel", ms, c), l.addEventListener("pointerup", ms, c), (r = w(this, lZ)) == null || r.call(this);
  }
  if (ms(t), t.touches.length !== 2 || (a = w(this, aZ)) != null && a.call(this)) {
    rt(this, Zu, null);
    return;
  }
  let [e, n] = t.touches;
  e.identifier > n.identifier && ([e, n] = [n, e]), rt(this, Zu, {
    touch0X: e.screenX,
    touch0Y: e.screenY,
    touch1X: n.screenX,
    touch1Y: n.screenY
  });
}, HB = function(t) {
  var T;
  if (!w(this, Zu) || t.touches.length !== 2)
    return;
  ms(t);
  let [e, n] = t.touches;
  e.identifier > n.identifier && ([e, n] = [n, e]);
  const {
    screenX: s,
    screenY: r
  } = e, {
    screenX: a,
    screenY: o
  } = n, l = w(this, Zu), {
    touch0X: c,
    touch0Y: u,
    touch1X: d,
    touch1Y: h
  } = l, p = d - c, m = h - u, b = a - s, y = o - r, Z = Math.hypot(b, y) || 1, g = Math.hypot(p, m) || 1;
  if (!w(this, sm) && Math.abs(g - Z) <= dY.MIN_TOUCH_DISTANCE_TO_PINCH)
    return;
  if (l.touch0X = s, l.touch0Y = r, l.touch1X = a, l.touch1Y = o, !w(this, sm)) {
    rt(this, sm, !0);
    return;
  }
  const f = [(s + a) / 2, (r + o) / 2];
  (T = w(this, cZ)) == null || T.call(this, f, g, Z);
}, _B = function(t) {
  var e;
  t.touches.length >= 2 || (w(this, Tu) && (w(this, Tu).abort(), rt(this, Tu, null), (e = w(this, uZ)) == null || e.call(this)), w(this, Zu) && (ms(t), rt(this, Zu, null), rt(this, sm, !1)));
};
let BW = dY;
var om, Tl, Hi, Si, Mu, nf, rh, dZ, Gr, lm, Nu, gc, ah, hZ, cm, qa, pZ, um, Wu, yc, sf, rf, Ao, dm, mZ, dG, en, VV, bZ, XV, LN, QB, $B, IV, VN, CV, qB, tK, eK, YV, nK, vV, iK, sK, rK, RV, Ry;
const bn = class bn {
  constructor(t) {
    pt(this, en);
    pt(this, om, null);
    pt(this, Tl, null);
    pt(this, Hi, null);
    pt(this, Si, null);
    pt(this, Mu, null);
    pt(this, nf, !1);
    pt(this, rh, null);
    pt(this, dZ, "");
    pt(this, Gr, null);
    pt(this, lm, null);
    pt(this, Nu, null);
    pt(this, gc, null);
    pt(this, ah, null);
    pt(this, hZ, "");
    pt(this, cm, !1);
    pt(this, qa, null);
    pt(this, pZ, !1);
    pt(this, um, !1);
    pt(this, Wu, !1);
    pt(this, yc, null);
    pt(this, sf, 0);
    pt(this, rf, 0);
    pt(this, Ao, null);
    pt(this, dm, null);
    S(this, "isSelected", !1);
    S(this, "_isCopy", !1);
    S(this, "_editToolbar", null);
    S(this, "_initialOptions", /* @__PURE__ */ Object.create(null));
    S(this, "_initialData", null);
    S(this, "_isVisible", !0);
    S(this, "_uiManager", null);
    S(this, "_focusEventsAllowed", !0);
    pt(this, mZ, !1);
    pt(this, dG, bn._zIndex++);
    this.parent = t.parent, this.id = t.id, this.width = this.height = null, this.pageIndex = t.parent.pageIndex, this.name = t.name, this.div = null, this._uiManager = t.uiManager, this.annotationElementId = null, this._willKeepAspectRatio = !1, this._initialOptions.isCentered = t.isCentered, this._structTreeParentId = null, this.annotationElementId = t.annotationElementId || null, this.creationDate = t.creationDate || /* @__PURE__ */ new Date(), this.modificationDate = t.modificationDate || null;
    const {
      rotation: e,
      rawDims: {
        pageWidth: n,
        pageHeight: s,
        pageX: r,
        pageY: a
      }
    } = this.parent.viewport;
    this.rotation = e, this.pageRotation = (360 + e - this._uiManager.viewParameters.rotation) % 360, this.pageDimensions = [n, s], this.pageTranslation = [r, a];
    const [o, l] = this.parentDimensions;
    this.x = t.x / o, this.y = t.y / l, this.isAttachedToDOM = !1, this.deleted = !1;
  }
  static get _resizerKeyboardManager() {
    const t = bn.prototype._resizeWithKeyboard, e = G0.TRANSLATE_SMALL, n = G0.TRANSLATE_BIG;
    return Gn(this, "_resizerKeyboardManager", new $T([[["ArrowLeft", "mac+ArrowLeft"], t, {
      args: [-e, 0]
    }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], t, {
      args: [-n, 0]
    }], [["ArrowRight", "mac+ArrowRight"], t, {
      args: [e, 0]
    }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], t, {
      args: [n, 0]
    }], [["ArrowUp", "mac+ArrowUp"], t, {
      args: [0, -e]
    }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], t, {
      args: [0, -n]
    }], [["ArrowDown", "mac+ArrowDown"], t, {
      args: [0, e]
    }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], t, {
      args: [0, n]
    }], [["Escape", "mac+Escape"], bn.prototype._stopResizingWithKeyboard]]));
  }
  get editorType() {
    return Object.getPrototypeOf(this).constructor._type;
  }
  get mode() {
    return Object.getPrototypeOf(this).constructor._editorType;
  }
  static get isDrawer() {
    return !1;
  }
  static get _defaultLineColor() {
    return Gn(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
  }
  static deleteAnnotationElement(t) {
    const e = new TIt({
      id: t.parent.getNextId(),
      parent: t.parent,
      uiManager: t._uiManager
    });
    e.annotationElementId = t.annotationElementId, e.deleted = !0, e._uiManager.addToAnnotationStorage(e);
  }
  static initialize(t, e) {
    if (bn._l10n ?? (bn._l10n = t), bn._l10nResizer || (bn._l10nResizer = Object.freeze({
      topLeft: "pdfjs-editor-resizer-top-left",
      topMiddle: "pdfjs-editor-resizer-top-middle",
      topRight: "pdfjs-editor-resizer-top-right",
      middleRight: "pdfjs-editor-resizer-middle-right",
      bottomRight: "pdfjs-editor-resizer-bottom-right",
      bottomMiddle: "pdfjs-editor-resizer-bottom-middle",
      bottomLeft: "pdfjs-editor-resizer-bottom-left",
      middleLeft: "pdfjs-editor-resizer-middle-left"
    })), bn._borderLineWidth !== -1)
      return;
    const n = getComputedStyle(document.documentElement);
    bn._borderLineWidth = parseFloat(n.getPropertyValue("--outline-width")) || 0;
  }
  static updateDefaultParams(t, e) {
  }
  static get defaultPropertiesToUpdate() {
    return [];
  }
  static isHandlingMimeForPasting(t) {
    return !1;
  }
  static paste(t, e) {
    Xi("Not implemented");
  }
  get propertiesToUpdate() {
    return [];
  }
  get _isDraggable() {
    return w(this, mZ);
  }
  set _isDraggable(t) {
    var e;
    rt(this, mZ, t), (e = this.div) == null || e.classList.toggle("draggable", t);
  }
  get uid() {
    return this.annotationElementId || this.id;
  }
  get isEnterHandled() {
    return !0;
  }
  center() {
    const [t, e] = this.pageDimensions;
    switch (this.parentRotation) {
      case 90:
        this.x -= this.height * e / (t * 2), this.y += this.width * t / (e * 2);
        break;
      case 180:
        this.x += this.width / 2, this.y += this.height / 2;
        break;
      case 270:
        this.x += this.height * e / (t * 2), this.y -= this.width * t / (e * 2);
        break;
      default:
        this.x -= this.width / 2, this.y -= this.height / 2;
        break;
    }
    this.fixAndSetPosition();
  }
  addCommands(t) {
    this._uiManager.addCommands(t);
  }
  get currentLayer() {
    return this._uiManager.currentLayer;
  }
  setInBackground() {
    this.div.style.zIndex = 0;
  }
  setInForeground() {
    this.div.style.zIndex = w(this, dG);
  }
  setParent(t) {
    var e;
    t !== null ? (this.pageIndex = t.pageIndex, this.pageDimensions = t.pageDimensions) : (ft(this, en, Ry).call(this), (e = w(this, gc)) == null || e.remove(), rt(this, gc, null)), this.parent = t;
  }
  focusin(t) {
    this._focusEventsAllowed && (w(this, cm) ? rt(this, cm, !1) : this.parent.setSelected(this));
  }
  focusout(t) {
    var n;
    if (!this._focusEventsAllowed || !this.isAttachedToDOM)
      return;
    const e = t.relatedTarget;
    e != null && e.closest(`#${this.id}`) || (t.preventDefault(), (n = this.parent) != null && n.isMultipleSelection || this.commitOrRemove());
  }
  commitOrRemove() {
    this.isEmpty() ? this.remove() : this.commit();
  }
  commit() {
    this.isInEditMode() && this.addToAnnotationStorage();
  }
  addToAnnotationStorage() {
    this._uiManager.addToAnnotationStorage(this);
  }
  setAt(t, e, n, s) {
    const [r, a] = this.parentDimensions;
    [n, s] = this.screenToPageTranslation(n, s), this.x = (t + n) / r, this.y = (e + s) / a, this.fixAndSetPosition();
  }
  _moveAfterPaste(t, e) {
    const [n, s] = this.parentDimensions;
    this.setAt(t * n, e * s, this.width * n, this.height * s), this._onTranslated();
  }
  translate(t, e) {
    ft(this, en, VV).call(this, this.parentDimensions, t, e);
  }
  translateInPage(t, e) {
    w(this, qa) || rt(this, qa, [this.x, this.y, this.width, this.height]), ft(this, en, VV).call(this, this.pageDimensions, t, e), this.div.scrollIntoView({
      block: "nearest"
    });
  }
  translationDone() {
    this._onTranslated(this.x, this.y);
  }
  drag(t, e) {
    w(this, qa) || rt(this, qa, [this.x, this.y, this.width, this.height]);
    const {
      div: n,
      parentDimensions: [s, r]
    } = this;
    if (this.x += t / s, this.y += e / r, this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
      const {
        x: d,
        y: h
      } = this.div.getBoundingClientRect();
      this.parent.findNewParent(this, d, h) && (this.x -= Math.floor(this.x), this.y -= Math.floor(this.y));
    }
    let {
      x: a,
      y: o
    } = this;
    const [l, c] = this.getBaseTranslation();
    a += l, o += c;
    const {
      style: u
    } = n;
    u.left = `${(100 * a).toFixed(2)}%`, u.top = `${(100 * o).toFixed(2)}%`, this._onTranslating(a, o), n.scrollIntoView({
      block: "nearest"
    });
  }
  _onTranslating(t, e) {
  }
  _onTranslated(t, e) {
  }
  get _hasBeenMoved() {
    return !!w(this, qa) && (w(this, qa)[0] !== this.x || w(this, qa)[1] !== this.y);
  }
  get _hasBeenResized() {
    return !!w(this, qa) && (w(this, qa)[2] !== this.width || w(this, qa)[3] !== this.height);
  }
  getBaseTranslation() {
    const [t, e] = this.parentDimensions, {
      _borderLineWidth: n
    } = bn, s = n / t, r = n / e;
    switch (this.rotation) {
      case 90:
        return [-s, r];
      case 180:
        return [s, r];
      case 270:
        return [s, -r];
      default:
        return [-s, -r];
    }
  }
  get _mustFixPosition() {
    return !0;
  }
  fixAndSetPosition(t = this.rotation) {
    const {
      div: {
        style: e
      },
      pageDimensions: [n, s]
    } = this;
    let {
      x: r,
      y: a,
      width: o,
      height: l
    } = this;
    if (o *= n, l *= s, r *= n, a *= s, this._mustFixPosition)
      switch (t) {
        case 0:
          r = Na(r, 0, n - o), a = Na(a, 0, s - l);
          break;
        case 90:
          r = Na(r, 0, n - l), a = Na(a, o, s);
          break;
        case 180:
          r = Na(r, o, n), a = Na(a, l, s);
          break;
        case 270:
          r = Na(r, l, n), a = Na(a, 0, s - o);
          break;
      }
    this.x = r /= n, this.y = a /= s;
    const [c, u] = this.getBaseTranslation();
    r += c, a += u, e.left = `${(100 * r).toFixed(2)}%`, e.top = `${(100 * a).toFixed(2)}%`, this.moveInDOM();
  }
  screenToPageTranslation(t, e) {
    var n;
    return ft(n = bn, bZ, XV).call(n, t, e, this.parentRotation);
  }
  pageTranslationToScreen(t, e) {
    var n;
    return ft(n = bn, bZ, XV).call(n, t, e, 360 - this.parentRotation);
  }
  get parentScale() {
    return this._uiManager.viewParameters.realScale;
  }
  get parentRotation() {
    return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
  }
  get parentDimensions() {
    const {
      parentScale: t,
      pageDimensions: [e, n]
    } = this;
    return [e * t, n * t];
  }
  setDims() {
    const {
      div: {
        style: t
      },
      width: e,
      height: n
    } = this;
    t.width = `${(100 * e).toFixed(2)}%`, t.height = `${(100 * n).toFixed(2)}%`;
  }
  getInitialTranslation() {
    return [0, 0];
  }
  _onResized() {
  }
  static _round(t) {
    return Math.round(t * 1e4) / 1e4;
  }
  _onResizing() {
  }
  altTextFinish() {
    var t;
    (t = w(this, Hi)) == null || t.finish();
  }
  get toolbarButtons() {
    return null;
  }
  async addEditToolbar() {
    if (this._editToolbar || w(this, um))
      return this._editToolbar;
    this._editToolbar = new yV(this), this.div.append(this._editToolbar.render());
    const {
      toolbarButtons: t
    } = this;
    if (t)
      for (const [e, n] of t)
        await this._editToolbar.addButton(e, n);
    return this.hasComment || this._editToolbar.addButton("comment", this.addCommentButton()), this._editToolbar.addButton("delete"), this._editToolbar;
  }
  addCommentButtonInToolbar() {
    var t;
    (t = this._editToolbar) == null || t.addButtonBefore("comment", this.addCommentButton(), ".deleteButton");
  }
  removeCommentButtonFromToolbar() {
    var t;
    (t = this._editToolbar) == null || t.removeButton("comment");
  }
  removeEditToolbar() {
    var t, e;
    (t = this._editToolbar) == null || t.remove(), this._editToolbar = null, (e = w(this, Hi)) == null || e.destroy();
  }
  addContainer(t) {
    var n;
    const e = (n = this._editToolbar) == null ? void 0 : n.div;
    e ? e.before(t) : this.div.append(t);
  }
  getClientDimensions() {
    return this.div.getBoundingClientRect();
  }
  createAltText() {
    return w(this, Hi) || (AW.initialize(bn._l10n), rt(this, Hi, new AW(this)), w(this, om) && (w(this, Hi).data = w(this, om), rt(this, om, null))), w(this, Hi);
  }
  get altTextData() {
    var t;
    return (t = w(this, Hi)) == null ? void 0 : t.data;
  }
  set altTextData(t) {
    w(this, Hi) && (w(this, Hi).data = t);
  }
  get guessedAltText() {
    var t;
    return (t = w(this, Hi)) == null ? void 0 : t.guessedText;
  }
  async setGuessedAltText(t) {
    var e;
    await ((e = w(this, Hi)) == null ? void 0 : e.setGuessedText(t));
  }
  serializeAltText(t) {
    var e;
    return (e = w(this, Hi)) == null ? void 0 : e.serialize(t);
  }
  hasAltText() {
    return !!w(this, Hi) && !w(this, Hi).isEmpty();
  }
  hasAltTextData() {
    var t;
    return ((t = w(this, Hi)) == null ? void 0 : t.hasData()) ?? !1;
  }
  focusCommentButton() {
    var t;
    (t = w(this, Si)) == null || t.focusButton();
  }
  addCommentButton() {
    return w(this, Si) || rt(this, Si, new OM(this));
  }
  addStandaloneCommentButton() {
    if (w(this, Mu)) {
      this._uiManager.isEditingMode() && w(this, Mu).classList.remove("hidden");
      return;
    }
    this.hasComment && (rt(this, Mu, w(this, Si).renderForStandalone()), this.div.append(w(this, Mu)));
  }
  removeStandaloneCommentButton() {
    w(this, Si).removeStandaloneCommentButton(), rt(this, Mu, null);
  }
  hideStandaloneCommentButton() {
    var t;
    (t = w(this, Mu)) == null || t.classList.add("hidden");
  }
  get comment() {
    const {
      data: {
        richText: t,
        text: e,
        date: n,
        deleted: s
      }
    } = w(this, Si);
    return {
      text: e,
      richText: t,
      date: n,
      deleted: s,
      color: this.getNonHCMColor(),
      opacity: this.opacity ?? 1
    };
  }
  set comment(t) {
    w(this, Si) || rt(this, Si, new OM(this)), w(this, Si).data = t, this.hasComment ? (this.removeCommentButtonFromToolbar(), this.addStandaloneCommentButton(), this._uiManager.updateComment(this)) : (this.addCommentButtonInToolbar(), this.removeStandaloneCommentButton(), this._uiManager.removeComment(this));
  }
  setCommentData({
    comment: t,
    popupRef: e,
    richText: n
  }) {
    if (!e || (w(this, Si) || rt(this, Si, new OM(this)), w(this, Si).setInitialText(t, n), !this.annotationElementId))
      return;
    const s = this._uiManager.getAndRemoveDataFromAnnotationStorage(this.annotationElementId);
    s && this.updateFromAnnotationLayer(s);
  }
  get hasEditedComment() {
    var t;
    return (t = w(this, Si)) == null ? void 0 : t.hasBeenEdited();
  }
  get hasDeletedComment() {
    var t;
    return (t = w(this, Si)) == null ? void 0 : t.isDeleted();
  }
  get hasComment() {
    return !!w(this, Si) && !w(this, Si).isEmpty() && !w(this, Si).isDeleted();
  }
  async editComment(t) {
    w(this, Si) || rt(this, Si, new OM(this)), w(this, Si).edit(t);
  }
  toggleComment(t, e = void 0) {
    this.hasComment && this._uiManager.toggleComment(this, t, e);
  }
  setSelectedCommentButton(t) {
    w(this, Si).setSelectedButton(t);
  }
  addComment(t) {
    if (this.hasEditedComment) {
      const [, , , s] = t.rect, [r] = this.pageDimensions, [a] = this.pageTranslation, o = a + r + 1, l = s - 100, c = o + 180;
      t.popup = {
        contents: this.comment.text,
        deleted: this.comment.deleted,
        rect: [o, l, c, s]
      };
    }
  }
  updateFromAnnotationLayer({
    popup: {
      contents: t,
      deleted: e
    }
  }) {
    w(this, Si).data = e ? null : t;
  }
  get parentBoundingClientRect() {
    return this.parent.boundingClientRect;
  }
  render() {
    var a;
    const t = this.div = document.createElement("div");
    t.setAttribute("data-editor-rotation", (360 - this.rotation) % 360), t.className = this.name, t.setAttribute("id", this.id), t.tabIndex = w(this, nf) ? -1 : 0, t.setAttribute("role", "application"), this.defaultL10nId && t.setAttribute("data-l10n-id", this.defaultL10nId), this._isVisible || t.classList.add("hidden"), this.setInForeground(), ft(this, en, vV).call(this);
    const [e, n] = this.parentDimensions;
    this.parentRotation % 180 !== 0 && (t.style.maxWidth = `${(100 * n / e).toFixed(2)}%`, t.style.maxHeight = `${(100 * e / n).toFixed(2)}%`);
    const [s, r] = this.getInitialTranslation();
    return this.translate(s, r), DB(this, t, ["keydown", "pointerdown", "dblclick"]), this.isResizable && this._uiManager._supportsPinchToZoom && (w(this, dm) || rt(this, dm, new BW({
      container: t,
      isPinchingDisabled: () => !this.isSelected,
      onPinchStart: ft(this, en, qB).bind(this),
      onPinching: ft(this, en, tK).bind(this),
      onPinchEnd: ft(this, en, eK).bind(this),
      signal: this._uiManager._signal
    }))), this.addStandaloneCommentButton(), (a = this._uiManager._editorUndoBar) == null || a.hide(), t;
  }
  pointerdown(t) {
    const {
      isMac: e
    } = Er.platform;
    if (t.button !== 0 || t.ctrlKey && e) {
      t.preventDefault();
      return;
    }
    if (rt(this, cm, !0), this._isDraggable) {
      ft(this, en, nK).call(this, t);
      return;
    }
    ft(this, en, YV).call(this, t);
  }
  _onStartDragging() {
  }
  _onStopDragging() {
  }
  moveInDOM() {
    w(this, yc) && clearTimeout(w(this, yc)), rt(this, yc, setTimeout(() => {
      var t;
      rt(this, yc, null), (t = this.parent) == null || t.moveEditorInDOM(this);
    }, 0));
  }
  _setParentAndPosition(t, e, n) {
    t.changeParent(this), this.x = e, this.y = n, this.fixAndSetPosition(), this._onTranslated();
  }
  getRect(t, e, n = this.rotation) {
    const s = this.parentScale, [r, a] = this.pageDimensions, [o, l] = this.pageTranslation, c = t / s, u = e / s, d = this.x * r, h = this.y * a, p = this.width * r, m = this.height * a;
    switch (n) {
      case 0:
        return [d + c + o, a - h - u - m + l, d + c + p + o, a - h - u + l];
      case 90:
        return [d + u + o, a - h + c + l, d + u + m + o, a - h + c + p + l];
      case 180:
        return [d - c - p + o, a - h + u + l, d - c + o, a - h + u + m + l];
      case 270:
        return [d - u - m + o, a - h - c - p + l, d - u + o, a - h - c + l];
      default:
        throw new Error("Invalid rotation");
    }
  }
  getRectInCurrentCoords(t, e) {
    const [n, s, r, a] = t, o = r - n, l = a - s;
    switch (this.rotation) {
      case 0:
        return [n, e - a, o, l];
      case 90:
        return [n, e - s, l, o];
      case 180:
        return [r, e - s, o, l];
      case 270:
        return [r, e - a, l, o];
      default:
        throw new Error("Invalid rotation");
    }
  }
  getPDFRect() {
    return this.getRect(0, 0);
  }
  getNonHCMColor() {
    return this.color && bn._colorManager.convert(this._uiManager.getNonHCMColor(this.color));
  }
  onUpdatedColor() {
    var t;
    (t = w(this, Si)) == null || t.onUpdatedColor();
  }
  getData() {
    const {
      comment: {
        text: t,
        color: e,
        date: n,
        opacity: s,
        deleted: r,
        richText: a
      },
      uid: o,
      pageIndex: l,
      creationDate: c,
      modificationDate: u
    } = this;
    return {
      id: o,
      pageIndex: l,
      rect: this.getPDFRect(),
      richText: a,
      contentsObj: {
        str: t
      },
      creationDate: c,
      modificationDate: n || u,
      popupRef: !r,
      color: e,
      opacity: s
    };
  }
  onceAdded(t) {
  }
  isEmpty() {
    return !1;
  }
  enableEditMode() {
    return this.isInEditMode() ? !1 : (this.parent.setEditingState(!1), rt(this, um, !0), !0);
  }
  disableEditMode() {
    return this.isInEditMode() ? (this.parent.setEditingState(!0), rt(this, um, !1), !0) : !1;
  }
  isInEditMode() {
    return w(this, um);
  }
  shouldGetKeyboardEvents() {
    return w(this, Wu);
  }
  needsToBeRebuilt() {
    return this.div && !this.isAttachedToDOM;
  }
  get isOnScreen() {
    const {
      top: t,
      left: e,
      bottom: n,
      right: s
    } = this.getClientDimensions(), {
      innerHeight: r,
      innerWidth: a
    } = window;
    return e < a && s > 0 && t < r && n > 0;
  }
  rebuild() {
    ft(this, en, vV).call(this);
  }
  rotate(t) {
  }
  resize() {
  }
  serializeDeleted() {
    var t;
    return {
      id: this.annotationElementId,
      deleted: !0,
      pageIndex: this.pageIndex,
      popupRef: ((t = this._initialData) == null ? void 0 : t.popupRef) || ""
    };
  }
  serialize(t = !1, e = null) {
    var n;
    return {
      annotationType: this.mode,
      pageIndex: this.pageIndex,
      rect: this.getPDFRect(),
      rotation: this.rotation,
      structTreeParentId: this._structTreeParentId,
      popupRef: ((n = this._initialData) == null ? void 0 : n.popupRef) || ""
    };
  }
  static async deserialize(t, e, n) {
    const s = new this.prototype.constructor({
      parent: e,
      id: e.getNextId(),
      uiManager: n,
      annotationElementId: t.annotationElementId,
      creationDate: t.creationDate,
      modificationDate: t.modificationDate
    });
    s.rotation = t.rotation, rt(s, om, t.accessibilityData), s._isCopy = t.isCopy || !1;
    const [r, a] = s.pageDimensions, [o, l, c, u] = s.getRectInCurrentCoords(t.rect, a);
    return s.x = o / r, s.y = l / a, s.width = c / r, s.height = u / a, s;
  }
  get hasBeenModified() {
    return !!this.annotationElementId && (this.deleted || this.serialize() !== null);
  }
  remove() {
    var t, e;
    if ((t = w(this, ah)) == null || t.abort(), rt(this, ah, null), this.isEmpty() || this.commit(), this.parent ? this.parent.remove(this) : this._uiManager.removeEditor(this), w(this, yc) && (clearTimeout(w(this, yc)), rt(this, yc, null)), ft(this, en, Ry).call(this), this.removeEditToolbar(), w(this, Ao)) {
      for (const n of w(this, Ao).values())
        clearTimeout(n);
      rt(this, Ao, null);
    }
    this.parent = null, (e = w(this, dm)) == null || e.destroy(), rt(this, dm, null);
  }
  get isResizable() {
    return !1;
  }
  makeResizable() {
    this.isResizable && (ft(this, en, QB).call(this), w(this, Gr).classList.remove("hidden"));
  }
  get toolbarPosition() {
    return null;
  }
  get commentButtonPosition() {
    return this._uiManager.direction === "ltr" ? [1, 0] : [0, 0];
  }
  get commentButtonPositionInPage() {
    const {
      commentButtonPosition: [t, e]
    } = this, [n, s, r, a] = this.getPDFRect();
    return [bn._round(n + (r - n) * t), bn._round(s + (a - s) * (1 - e))];
  }
  get commentButtonColor() {
    return this._uiManager.makeCommentColor(this.getNonHCMColor(), this.opacity);
  }
  get commentPopupPosition() {
    return w(this, Si).commentPopupPositionInLayer;
  }
  set commentPopupPosition(t) {
    w(this, Si).commentPopupPositionInLayer = t;
  }
  hasDefaultPopupPosition() {
    return w(this, Si).hasDefaultPopupPosition();
  }
  get commentButtonWidth() {
    return w(this, Si).commentButtonWidth;
  }
  get elementBeforePopup() {
    return this.div;
  }
  setCommentButtonStates(t) {
    w(this, Si).setCommentButtonStates(t);
  }
  keydown(t) {
    if (!this.isResizable || t.target !== this.div || t.key !== "Enter")
      return;
    this._uiManager.setSelected(this), rt(this, Nu, {
      savedX: this.x,
      savedY: this.y,
      savedWidth: this.width,
      savedHeight: this.height
    });
    const e = w(this, Gr).children;
    if (!w(this, Tl)) {
      rt(this, Tl, Array.from(e));
      const a = ft(this, en, iK).bind(this), o = ft(this, en, sK).bind(this), l = this._uiManager._signal;
      for (const c of w(this, Tl)) {
        const u = c.getAttribute("data-resizer-name");
        c.setAttribute("role", "spinbutton"), c.addEventListener("keydown", a, {
          signal: l
        }), c.addEventListener("blur", o, {
          signal: l
        }), c.addEventListener("focus", ft(this, en, rK).bind(this, u), {
          signal: l
        }), c.setAttribute("data-l10n-id", bn._l10nResizer[u]);
      }
    }
    const n = w(this, Tl)[0];
    let s = 0;
    for (const a of e) {
      if (a === n)
        break;
      s++;
    }
    const r = (360 - this.rotation + this.parentRotation) % 360 / 90 * (w(this, Tl).length / 4);
    if (r !== s) {
      if (r < s)
        for (let o = 0; o < s - r; o++)
          w(this, Gr).append(w(this, Gr).firstChild);
      else if (r > s)
        for (let o = 0; o < r - s; o++)
          w(this, Gr).firstChild.before(w(this, Gr).lastChild);
      let a = 0;
      for (const o of e) {
        const c = w(this, Tl)[a++].getAttribute("data-resizer-name");
        o.setAttribute("data-l10n-id", bn._l10nResizer[c]);
      }
    }
    ft(this, en, RV).call(this, 0), rt(this, Wu, !0), w(this, Gr).firstChild.focus({
      focusVisible: !0
    }), t.preventDefault(), t.stopImmediatePropagation();
  }
  _resizeWithKeyboard(t, e) {
    w(this, Wu) && ft(this, en, CV).call(this, w(this, hZ), {
      deltaX: t,
      deltaY: e,
      fromKeyboard: !0
    });
  }
  _stopResizingWithKeyboard() {
    ft(this, en, Ry).call(this), this.div.focus();
  }
  select() {
    var t, e, n;
    if (this.isSelected && this._editToolbar) {
      this._editToolbar.show();
      return;
    }
    if (this.isSelected = !0, this.makeResizable(), (t = this.div) == null || t.classList.add("selectedEditor"), !this._editToolbar) {
      this.addEditToolbar().then(() => {
        var s, r;
        (s = this.div) != null && s.classList.contains("selectedEditor") && ((r = this._editToolbar) == null || r.show());
      });
      return;
    }
    (e = this._editToolbar) == null || e.show(), (n = w(this, Hi)) == null || n.toggleAltTextBadge(!1);
  }
  focus() {
    this.div && !this.div.contains(document.activeElement) && setTimeout(() => {
      var t;
      return (t = this.div) == null ? void 0 : t.focus({
        preventScroll: !0
      });
    }, 0);
  }
  unselect() {
    var t, e, n, s, r;
    this.isSelected && (this.isSelected = !1, (t = w(this, Gr)) == null || t.classList.add("hidden"), (e = this.div) == null || e.classList.remove("selectedEditor"), (n = this.div) != null && n.contains(document.activeElement) && this._uiManager.currentLayer.div.focus({
      preventScroll: !0
    }), (s = this._editToolbar) == null || s.hide(), (r = w(this, Hi)) == null || r.toggleAltTextBadge(!0), this.hasComment && this._uiManager.toggleComment(this, !1, !1));
  }
  updateParams(t, e) {
  }
  disableEditing() {
  }
  enableEditing() {
  }
  get canChangeContent() {
    return !1;
  }
  enterInEditMode() {
    this.canChangeContent && (this.enableEditMode(), this.div.focus());
  }
  dblclick(t) {
    t.target.nodeName !== "BUTTON" && (this.enterInEditMode(), this.parent.updateToolbar({
      mode: this.constructor._editorType,
      editId: this.id
    }));
  }
  getElementForAltText() {
    return this.div;
  }
  get contentDiv() {
    return this.div;
  }
  get isEditing() {
    return w(this, pZ);
  }
  set isEditing(t) {
    rt(this, pZ, t), this.parent && (t ? (this.parent.setSelected(this), this.parent.setActiveEditor(this)) : this.parent.setActiveEditor(null));
  }
  static get MIN_SIZE() {
    return 16;
  }
  static canCreateNewEmptyEditor() {
    return !0;
  }
  get telemetryInitialData() {
    return {
      action: "added"
    };
  }
  get telemetryFinalData() {
    return null;
  }
  _reportTelemetry(t, e = !1) {
    if (e) {
      w(this, Ao) || rt(this, Ao, /* @__PURE__ */ new Map());
      const {
        action: n
      } = t;
      let s = w(this, Ao).get(n);
      s && clearTimeout(s), s = setTimeout(() => {
        this._reportTelemetry(t), w(this, Ao).delete(n), w(this, Ao).size === 0 && rt(this, Ao, null);
      }, bn._telemetryTimeout), w(this, Ao).set(n, s);
      return;
    }
    t.type || (t.type = this.editorType), this._uiManager._eventBus.dispatch("reporttelemetry", {
      source: this,
      details: {
        type: "editing",
        data: t
      }
    });
  }
  show(t = this._isVisible) {
    this.div.classList.toggle("hidden", !t), this._isVisible = t;
  }
  enable() {
    this.div && (this.div.tabIndex = 0), rt(this, nf, !1);
  }
  disable() {
    this.div && (this.div.tabIndex = -1), rt(this, nf, !0);
  }
  updateFakeAnnotationElement(t) {
    if (!w(this, gc) && !this.deleted) {
      rt(this, gc, t.addFakeAnnotation(this));
      return;
    }
    if (this.deleted) {
      w(this, gc).remove(), rt(this, gc, null);
      return;
    }
    (this.hasEditedComment || this._hasBeenMoved || this._hasBeenResized) && w(this, gc).updateEdited({
      rect: this.getPDFRect(),
      popup: this.comment
    });
  }
  renderAnnotationElement(t) {
    if (this.deleted)
      return t.hide(), null;
    let e = t.container.querySelector(".annotationContent");
    if (!e)
      e = document.createElement("div"), e.classList.add("annotationContent", this.editorType), t.container.prepend(e);
    else if (e.nodeName === "CANVAS") {
      const n = e;
      e = document.createElement("div"), e.classList.add("annotationContent", this.editorType), n.before(e);
    }
    return e;
  }
  resetAnnotationElement(t) {
    const {
      firstChild: e
    } = t.container;
    (e == null ? void 0 : e.nodeName) === "DIV" && e.classList.contains("annotationContent") && e.remove();
  }
};
om = new WeakMap(), Tl = new WeakMap(), Hi = new WeakMap(), Si = new WeakMap(), Mu = new WeakMap(), nf = new WeakMap(), rh = new WeakMap(), dZ = new WeakMap(), Gr = new WeakMap(), lm = new WeakMap(), Nu = new WeakMap(), gc = new WeakMap(), ah = new WeakMap(), hZ = new WeakMap(), cm = new WeakMap(), qa = new WeakMap(), pZ = new WeakMap(), um = new WeakMap(), Wu = new WeakMap(), yc = new WeakMap(), sf = new WeakMap(), rf = new WeakMap(), Ao = new WeakMap(), dm = new WeakMap(), mZ = new WeakMap(), dG = new WeakMap(), en = new WeakSet(), VV = function([t, e], n, s) {
  [n, s] = this.screenToPageTranslation(n, s), this.x += n / t, this.y += s / e, this._onTranslating(this.x, this.y), this.fixAndSetPosition();
}, bZ = new WeakSet(), XV = function(t, e, n) {
  switch (n) {
    case 90:
      return [e, -t];
    case 180:
      return [-t, -e];
    case 270:
      return [-e, t];
    default:
      return [t, e];
  }
}, LN = function(t) {
  switch (t) {
    case 90: {
      const [e, n] = this.pageDimensions;
      return [0, -e / n, n / e, 0];
    }
    case 180:
      return [-1, 0, 0, -1];
    case 270: {
      const [e, n] = this.pageDimensions;
      return [0, e / n, -n / e, 0];
    }
    default:
      return [1, 0, 0, 1];
  }
}, QB = function() {
  if (w(this, Gr))
    return;
  rt(this, Gr, document.createElement("div")), w(this, Gr).classList.add("resizers");
  const t = this._willKeepAspectRatio ? ["topLeft", "topRight", "bottomRight", "bottomLeft"] : ["topLeft", "topMiddle", "topRight", "middleRight", "bottomRight", "bottomMiddle", "bottomLeft", "middleLeft"], e = this._uiManager._signal;
  for (const n of t) {
    const s = document.createElement("div");
    w(this, Gr).append(s), s.classList.add("resizer", n), s.setAttribute("data-resizer-name", n), s.addEventListener("pointerdown", ft(this, en, $B).bind(this, n), {
      signal: e
    }), s.addEventListener("contextmenu", al, {
      signal: e
    }), s.tabIndex = -1;
  }
  this.div.prepend(w(this, Gr));
}, $B = function(t, e) {
  var u;
  e.preventDefault();
  const {
    isMac: n
  } = Er.platform;
  if (e.button !== 0 || e.ctrlKey && n)
    return;
  (u = w(this, Hi)) == null || u.toggle(!1);
  const s = this._isDraggable;
  this._isDraggable = !1, rt(this, lm, [e.screenX, e.screenY]);
  const r = new AbortController(), a = this._uiManager.combinedSignal(r);
  this.parent.togglePointerEvents(!1), window.addEventListener("pointermove", ft(this, en, CV).bind(this, t), {
    passive: !0,
    capture: !0,
    signal: a
  }), window.addEventListener("touchmove", ms, {
    passive: !1,
    signal: a
  }), window.addEventListener("contextmenu", al, {
    signal: a
  }), rt(this, Nu, {
    savedX: this.x,
    savedY: this.y,
    savedWidth: this.width,
    savedHeight: this.height
  });
  const o = this.parent.div.style.cursor, l = this.div.style.cursor;
  this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(e.target).cursor;
  const c = () => {
    var d;
    r.abort(), this.parent.togglePointerEvents(!0), (d = w(this, Hi)) == null || d.toggle(!0), this._isDraggable = s, this.parent.div.style.cursor = o, this.div.style.cursor = l, ft(this, en, VN).call(this);
  };
  window.addEventListener("pointerup", c, {
    signal: a
  }), window.addEventListener("blur", c, {
    signal: a
  });
}, IV = function(t, e, n, s) {
  this.width = n, this.height = s, this.x = t, this.y = e, this.setDims(), this.fixAndSetPosition(), this._onResized();
}, VN = function() {
  if (!w(this, Nu))
    return;
  const {
    savedX: t,
    savedY: e,
    savedWidth: n,
    savedHeight: s
  } = w(this, Nu);
  rt(this, Nu, null);
  const r = this.x, a = this.y, o = this.width, l = this.height;
  r === t && a === e && o === n && l === s || this.addCommands({
    cmd: ft(this, en, IV).bind(this, r, a, o, l),
    undo: ft(this, en, IV).bind(this, t, e, n, s),
    mustExec: !0
  });
}, CV = function(t, e) {
  const [n, s] = this.parentDimensions, r = this.x, a = this.y, o = this.width, l = this.height, c = bn.MIN_SIZE / n, u = bn.MIN_SIZE / s, d = ft(this, en, LN).call(this, this.rotation), h = (j, H) => [d[0] * j + d[2] * H, d[1] * j + d[3] * H], p = ft(this, en, LN).call(this, 360 - this.rotation), m = (j, H) => [p[0] * j + p[2] * H, p[1] * j + p[3] * H];
  let b, y, Z = !1, g = !1;
  switch (t) {
    case "topLeft":
      Z = !0, b = (j, H) => [0, 0], y = (j, H) => [j, H];
      break;
    case "topMiddle":
      b = (j, H) => [j / 2, 0], y = (j, H) => [j / 2, H];
      break;
    case "topRight":
      Z = !0, b = (j, H) => [j, 0], y = (j, H) => [0, H];
      break;
    case "middleRight":
      g = !0, b = (j, H) => [j, H / 2], y = (j, H) => [0, H / 2];
      break;
    case "bottomRight":
      Z = !0, b = (j, H) => [j, H], y = (j, H) => [0, 0];
      break;
    case "bottomMiddle":
      b = (j, H) => [j / 2, H], y = (j, H) => [j / 2, 0];
      break;
    case "bottomLeft":
      Z = !0, b = (j, H) => [0, H], y = (j, H) => [j, 0];
      break;
    case "middleLeft":
      g = !0, b = (j, H) => [0, H / 2], y = (j, H) => [j, H / 2];
      break;
  }
  const f = b(o, l), T = y(o, l);
  let M = h(...T);
  const N = bn._round(r + M[0]), W = bn._round(a + M[1]);
  let x = 1, V = 1, X, C;
  if (e.fromKeyboard)
    ({
      deltaX: X,
      deltaY: C
    } = e);
  else {
    const {
      screenX: j,
      screenY: H
    } = e, [B, $] = w(this, lm);
    [X, C] = this.screenToPageTranslation(j - B, H - $), w(this, lm)[0] = j, w(this, lm)[1] = H;
  }
  if ([X, C] = m(X / n, C / s), Z) {
    const j = Math.hypot(o, l);
    x = V = Math.max(Math.min(Math.hypot(T[0] - f[0] - X, T[1] - f[1] - C) / j, 1 / o, 1 / l), c / o, u / l);
  } else g ? x = Na(Math.abs(T[0] - f[0] - X), c, 1) / o : V = Na(Math.abs(T[1] - f[1] - C), u, 1) / l;
  const R = bn._round(o * x), z = bn._round(l * V);
  M = h(...y(R, z));
  const F = N - M[0], P = W - M[1];
  w(this, qa) || rt(this, qa, [this.x, this.y, this.width, this.height]), this.width = R, this.height = z, this.x = F, this.y = P, this.setDims(), this.fixAndSetPosition(), this._onResizing();
}, qB = function() {
  var t;
  rt(this, Nu, {
    savedX: this.x,
    savedY: this.y,
    savedWidth: this.width,
    savedHeight: this.height
  }), (t = w(this, Hi)) == null || t.toggle(!1), this.parent.togglePointerEvents(!1);
}, tK = function(t, e, n) {
  let r = 0.7 * (n / e) + 1 - 0.7;
  if (r === 1)
    return;
  const a = ft(this, en, LN).call(this, this.rotation), o = (N, W) => [a[0] * N + a[2] * W, a[1] * N + a[3] * W], [l, c] = this.parentDimensions, u = this.x, d = this.y, h = this.width, p = this.height, m = bn.MIN_SIZE / l, b = bn.MIN_SIZE / c;
  r = Math.max(Math.min(r, 1 / h, 1 / p), m / h, b / p);
  const y = bn._round(h * r), Z = bn._round(p * r);
  if (y === h && Z === p)
    return;
  w(this, qa) || rt(this, qa, [u, d, h, p]);
  const g = o(h / 2, p / 2), f = bn._round(u + g[0]), T = bn._round(d + g[1]), M = o(y / 2, Z / 2);
  this.x = f - M[0], this.y = T - M[1], this.width = y, this.height = Z, this.setDims(), this.fixAndSetPosition(), this._onResizing();
}, eK = function() {
  var t;
  (t = w(this, Hi)) == null || t.toggle(!0), this.parent.togglePointerEvents(!0), ft(this, en, VN).call(this);
}, YV = function(t) {
  const {
    isMac: e
  } = Er.platform;
  t.ctrlKey && !e || t.shiftKey || t.metaKey && e ? this.parent.toggleSelected(this) : this.parent.setSelected(this);
}, nK = function(t) {
  const {
    isSelected: e
  } = this;
  this._uiManager.setUpDragSession();
  let n = !1;
  const s = new AbortController(), r = this._uiManager.combinedSignal(s), a = {
    capture: !0,
    passive: !1,
    signal: r
  }, o = (c) => {
    s.abort(), rt(this, rh, null), rt(this, cm, !1), this._uiManager.endDragSession() || ft(this, en, YV).call(this, c), n && this._onStopDragging();
  };
  e && (rt(this, sf, t.clientX), rt(this, rf, t.clientY), rt(this, rh, t.pointerId), rt(this, dZ, t.pointerType), window.addEventListener("pointermove", (c) => {
    n || (n = !0, this._uiManager.toggleComment(this, !0, !1), this._onStartDragging());
    const {
      clientX: u,
      clientY: d,
      pointerId: h
    } = c;
    if (h !== w(this, rh)) {
      ms(c);
      return;
    }
    const [p, m] = this.screenToPageTranslation(u - w(this, sf), d - w(this, rf));
    rt(this, sf, u), rt(this, rf, d), this._uiManager.dragSelectedEditors(p, m);
  }, a), window.addEventListener("touchmove", ms, a), window.addEventListener("pointerdown", (c) => {
    c.pointerType === w(this, dZ) && (w(this, dm) || c.isPrimary) && o(c), ms(c);
  }, a));
  const l = (c) => {
    if (!w(this, rh) || w(this, rh) === c.pointerId) {
      o(c);
      return;
    }
    ms(c);
  };
  window.addEventListener("pointerup", l, {
    signal: r
  }), window.addEventListener("blur", l, {
    signal: r
  });
}, vV = function() {
  if (w(this, ah) || !this.div)
    return;
  rt(this, ah, new AbortController());
  const t = this._uiManager.combinedSignal(w(this, ah));
  this.div.addEventListener("focusin", this.focusin.bind(this), {
    signal: t
  }), this.div.addEventListener("focusout", this.focusout.bind(this), {
    signal: t
  });
}, iK = function(t) {
  bn._resizerKeyboardManager.exec(this, t);
}, sK = function(t) {
  var e;
  w(this, Wu) && ((e = t.relatedTarget) == null ? void 0 : e.parentNode) !== w(this, Gr) && ft(this, en, Ry).call(this);
}, rK = function(t) {
  rt(this, hZ, w(this, Wu) ? t : "");
}, RV = function(t) {
  if (w(this, Tl))
    for (const e of w(this, Tl))
      e.tabIndex = t;
}, Ry = function() {
  rt(this, Wu, !1), ft(this, en, RV).call(this, -1), ft(this, en, VN).call(this);
}, pt(bn, bZ), S(bn, "_l10n", null), S(bn, "_l10nResizer", null), S(bn, "_borderLineWidth", -1), S(bn, "_colorManager", new MV()), S(bn, "_zIndex", 1), S(bn, "_telemetryTimeout", 1e3);
let Di = bn;
class TIt extends Di {
  constructor(t) {
    super(t), this.annotationElementId = t.annotationElementId, this.deleted = !0;
  }
  serialize() {
    return this.serializeDeleted();
  }
}
const xE = 3285377520, Do = 4294901760, ic = 65535;
class aK {
  constructor(t) {
    this.h1 = t ? t & 4294967295 : xE, this.h2 = t ? t & 4294967295 : xE;
  }
  update(t) {
    let e, n;
    if (typeof t == "string") {
      e = new Uint8Array(t.length * 2), n = 0;
      for (let b = 0, y = t.length; b < y; b++) {
        const Z = t.charCodeAt(b);
        Z <= 255 ? e[n++] = Z : (e[n++] = Z >>> 8, e[n++] = Z & 255);
      }
    } else if (ArrayBuffer.isView(t))
      e = t.slice(), n = e.byteLength;
    else
      throw new Error("Invalid data format, must be a string or TypedArray.");
    const s = n >> 2, r = n - s * 4, a = new Uint32Array(e.buffer, 0, s);
    let o = 0, l = 0, c = this.h1, u = this.h2;
    const d = 3432918353, h = 461845907, p = d & ic, m = h & ic;
    for (let b = 0; b < s; b++)
      b & 1 ? (o = a[b], o = o * d & Do | o * p & ic, o = o << 15 | o >>> 17, o = o * h & Do | o * m & ic, c ^= o, c = c << 13 | c >>> 19, c = c * 5 + 3864292196) : (l = a[b], l = l * d & Do | l * p & ic, l = l << 15 | l >>> 17, l = l * h & Do | l * m & ic, u ^= l, u = u << 13 | u >>> 19, u = u * 5 + 3864292196);
    switch (o = 0, r) {
      case 3:
        o ^= e[s * 4 + 2] << 16;
      case 2:
        o ^= e[s * 4 + 1] << 8;
      case 1:
        o ^= e[s * 4], o = o * d & Do | o * p & ic, o = o << 15 | o >>> 17, o = o * h & Do | o * m & ic, s & 1 ? c ^= o : u ^= o;
    }
    this.h1 = c, this.h2 = u;
  }
  hexdigest() {
    let t = this.h1, e = this.h2;
    return t ^= e >>> 1, t = t * 3981806797 & Do | t * 36045 & ic, e = e * 4283543511 & Do | ((e << 16 | t >>> 16) * 2950163797 & Do) >>> 16, t ^= e >>> 1, t = t * 444984403 & Do | t * 60499 & ic, e = e * 3301882366 & Do | ((e << 16 | t >>> 16) * 3120437893 & Do) >>> 16, t ^= e >>> 1, (t >>> 0).toString(16).padStart(8, "0") + (e >>> 0).toString(16).padStart(8, "0");
  }
}
const DV = Object.freeze({
  map: null,
  hash: "",
  transfer: void 0
});
var hm, pm, Gu, wr, hG, oK;
class tY {
  constructor() {
    pt(this, hG);
    pt(this, hm, !1);
    pt(this, pm, null);
    pt(this, Gu, null);
    pt(this, wr, /* @__PURE__ */ new Map());
    this.onSetModified = null, this.onResetModified = null, this.onAnnotationEditor = null;
  }
  getValue(t, e) {
    const n = w(this, wr).get(t);
    return n === void 0 ? e : Object.assign(e, n);
  }
  getRawValue(t) {
    return w(this, wr).get(t);
  }
  remove(t) {
    const e = w(this, wr).get(t);
    if (e !== void 0 && (e instanceof Di && w(this, Gu).delete(e.annotationElementId), w(this, wr).delete(t), w(this, wr).size === 0 && this.resetModified(), typeof this.onAnnotationEditor == "function")) {
      for (const n of w(this, wr).values())
        if (n instanceof Di)
          return;
      this.onAnnotationEditor(null);
    }
  }
  setValue(t, e) {
    const n = w(this, wr).get(t);
    let s = !1;
    if (n !== void 0)
      for (const [r, a] of Object.entries(e))
        n[r] !== a && (s = !0, n[r] = a);
    else
      s = !0, w(this, wr).set(t, e);
    s && ft(this, hG, oK).call(this), e instanceof Di && ((w(this, Gu) || rt(this, Gu, /* @__PURE__ */ new Map())).set(e.annotationElementId, e), typeof this.onAnnotationEditor == "function" && this.onAnnotationEditor(e.constructor._type));
  }
  has(t) {
    return w(this, wr).has(t);
  }
  get size() {
    return w(this, wr).size;
  }
  resetModified() {
    w(this, hm) && (rt(this, hm, !1), typeof this.onResetModified == "function" && this.onResetModified());
  }
  get print() {
    return new lK(this);
  }
  get serializable() {
    if (w(this, wr).size === 0)
      return DV;
    const t = /* @__PURE__ */ new Map(), e = new aK(), n = [], s = /* @__PURE__ */ Object.create(null);
    let r = !1;
    for (const [a, o] of w(this, wr)) {
      const l = o instanceof Di ? o.serialize(!1, s) : o;
      l && (t.set(a, l), e.update(`${a}:${JSON.stringify(l)}`), r || (r = !!l.bitmap));
    }
    if (r)
      for (const a of t.values())
        a.bitmap && n.push(a.bitmap);
    return t.size > 0 ? {
      map: t,
      hash: e.hexdigest(),
      transfer: n
    } : DV;
  }
  get editorStats() {
    let t = null;
    const e = /* @__PURE__ */ new Map();
    let n = 0, s = 0;
    for (const r of w(this, wr).values()) {
      if (!(r instanceof Di)) {
        r.popup && (r.popup.deleted ? s += 1 : n += 1);
        continue;
      }
      r.isCommentDeleted ? s += 1 : r.hasEditedComment && (n += 1);
      const a = r.telemetryFinalData;
      if (!a)
        continue;
      const {
        type: o
      } = a;
      e.has(o) || e.set(o, Object.getPrototypeOf(r).constructor), t || (t = /* @__PURE__ */ Object.create(null));
      const l = t[o] || (t[o] = /* @__PURE__ */ new Map());
      for (const [c, u] of Object.entries(a)) {
        if (c === "type")
          continue;
        let d = l.get(c);
        d || (d = /* @__PURE__ */ new Map(), l.set(c, d));
        const h = d.get(u) ?? 0;
        d.set(u, h + 1);
      }
    }
    if ((s > 0 || n > 0) && (t || (t = /* @__PURE__ */ Object.create(null)), t.comments = {
      deleted: s,
      edited: n
    }), !t)
      return null;
    for (const [r, a] of e)
      t[r] = a.computeTelemetryFinalData(t[r]);
    return t;
  }
  resetModifiedIds() {
    rt(this, pm, null);
  }
  updateEditor(t, e) {
    var s;
    const n = (s = w(this, Gu)) == null ? void 0 : s.get(t);
    return n ? (n.updateFromAnnotationLayer(e), !0) : !1;
  }
  getEditor(t) {
    var e;
    return ((e = w(this, Gu)) == null ? void 0 : e.get(t)) || null;
  }
  get modifiedIds() {
    if (w(this, pm))
      return w(this, pm);
    const t = [];
    if (w(this, Gu))
      for (const e of w(this, Gu).values())
        e.serialize() && t.push(e.annotationElementId);
    return rt(this, pm, {
      ids: new Set(t),
      hash: t.join(",")
    });
  }
  [Symbol.iterator]() {
    return w(this, wr).entries();
  }
}
hm = new WeakMap(), pm = new WeakMap(), Gu = new WeakMap(), wr = new WeakMap(), hG = new WeakSet(), oK = function() {
  w(this, hm) || (rt(this, hm, !0), typeof this.onSetModified == "function" && this.onSetModified());
};
var fZ;
class lK extends tY {
  constructor(e) {
    super();
    pt(this, fZ);
    const {
      map: n,
      hash: s,
      transfer: r
    } = e.serializable, a = structuredClone(n, r ? {
      transfer: r
    } : null);
    rt(this, fZ, {
      map: a,
      hash: s,
      transfer: r
    });
  }
  get print() {
    Xi("Should not call PrintAnnotationStorage.print");
  }
  get serializable() {
    return w(this, fZ);
  }
  get modifiedIds() {
    return Gn(this, "modifiedIds", {
      ids: /* @__PURE__ */ new Set(),
      hash: ""
    });
  }
}
fZ = new WeakMap();
var af;
class MIt {
  constructor({
    ownerDocument: t = globalThis.document,
    styleElement: e = null
  }) {
    pt(this, af, /* @__PURE__ */ new Set());
    this._document = t, this.nativeFontFaces = /* @__PURE__ */ new Set(), this.styleElement = null, this.loadingRequests = [], this.loadTestFontId = 0;
  }
  addNativeFontFace(t) {
    this.nativeFontFaces.add(t), this._document.fonts.add(t);
  }
  removeNativeFontFace(t) {
    this.nativeFontFaces.delete(t), this._document.fonts.delete(t);
  }
  insertRule(t) {
    this.styleElement || (this.styleElement = this._document.createElement("style"), this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement));
    const e = this.styleElement.sheet;
    e.insertRule(t, e.cssRules.length);
  }
  clear() {
    for (const t of this.nativeFontFaces)
      this._document.fonts.delete(t);
    this.nativeFontFaces.clear(), w(this, af).clear(), this.styleElement && (this.styleElement.remove(), this.styleElement = null);
  }
  async loadSystemFont({
    systemFontInfo: t,
    disableFontFace: e,
    _inspectFont: n
  }) {
    if (!(!t || w(this, af).has(t.loadedName))) {
      if (Pn(!e, "loadSystemFont shouldn't be called when `disableFontFace` is set."), this.isFontLoadingAPISupported) {
        const {
          loadedName: s,
          src: r,
          style: a
        } = t, o = new FontFace(s, r, a);
        this.addNativeFontFace(o);
        try {
          await o.load(), w(this, af).add(s), n == null || n(t);
        } catch {
          pn(`Cannot load system font: ${t.baseFontName}, installing it could help to improve PDF rendering.`), this.removeNativeFontFace(o);
        }
        return;
      }
      Xi("Not implemented: loadSystemFont without the Font Loading API.");
    }
  }
  async bind(t) {
    if (t.attached || t.missingFile && !t.systemFontInfo)
      return;
    if (t.attached = !0, t.systemFontInfo) {
      await this.loadSystemFont(t);
      return;
    }
    if (this.isFontLoadingAPISupported) {
      const n = t.createNativeFontFace();
      if (n) {
        this.addNativeFontFace(n);
        try {
          await n.loaded;
        } catch (s) {
          throw pn(`Failed to load font '${n.family}': '${s}'.`), t.disableFontFace = !0, s;
        }
      }
      return;
    }
    const e = t.createFontFaceRule();
    if (e) {
      if (this.insertRule(e), this.isSyncFontLoadingSupported)
        return;
      await new Promise((n) => {
        const s = this._queueLoadingCallback(n);
        this._prepareFontLoadEvent(t, s);
      });
    }
  }
  get isFontLoadingAPISupported() {
    var e;
    const t = !!((e = this._document) != null && e.fonts);
    return Gn(this, "isFontLoadingAPISupported", t);
  }
  get isSyncFontLoadingSupported() {
    return Gn(this, "isSyncFontLoadingSupported", Ma || Er.platform.isFirefox);
  }
  _queueLoadingCallback(t) {
    function e() {
      for (Pn(!s.done, "completeRequest() cannot be called twice."), s.done = !0; n.length > 0 && n[0].done; ) {
        const r = n.shift();
        setTimeout(r.callback, 0);
      }
    }
    const {
      loadingRequests: n
    } = this, s = {
      done: !1,
      complete: e,
      callback: t
    };
    return n.push(s), s;
  }
  get _loadTestFont() {
    const t = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
    return Gn(this, "_loadTestFont", t);
  }
  _prepareFontLoadEvent(t, e) {
    function n(T, M) {
      return T.charCodeAt(M) << 24 | T.charCodeAt(M + 1) << 16 | T.charCodeAt(M + 2) << 8 | T.charCodeAt(M + 3) & 255;
    }
    function s(T, M, N, W) {
      const x = T.substring(0, M), V = T.substring(M + N);
      return x + W + V;
    }
    let r, a;
    const o = this._document.createElement("canvas");
    o.width = 1, o.height = 1;
    const l = o.getContext("2d");
    let c = 0;
    function u(T, M) {
      if (++c > 30) {
        pn("Load test font never loaded."), M();
        return;
      }
      if (l.font = "30px " + T, l.fillText(".", 0, 20), l.getImageData(0, 0, 1, 1).data[3] > 0) {
        M();
        return;
      }
      setTimeout(u.bind(null, T, M));
    }
    const d = `lt${Date.now()}${this.loadTestFontId++}`;
    let h = this._loadTestFont;
    h = s(h, 976, d.length, d);
    const m = 16, b = 1482184792;
    let y = n(h, m);
    for (r = 0, a = d.length - 3; r < a; r += 4)
      y = y - b + n(d, r) | 0;
    r < d.length && (y = y - b + n(d + "XXX", r) | 0), h = s(h, m, 4, eIt(y));
    const Z = `url(data:font/opentype;base64,${btoa(h)});`, g = `@font-face {font-family:"${d}";src:${Z}}`;
    this.insertRule(g);
    const f = this._document.createElement("div");
    f.style.visibility = "hidden", f.style.width = f.style.height = "10px", f.style.position = "absolute", f.style.top = f.style.left = "0px";
    for (const T of [t.loadedName, d]) {
      const M = this._document.createElement("span");
      M.textContent = "Hi", M.style.fontFamily = T, f.append(M);
    }
    this._document.body.append(f), u(d, () => {
      f.remove(), e.complete();
    });
  }
}
af = new WeakMap();
var Zi;
class NIt {
  constructor(t, e = null, n, s) {
    pt(this, Zi);
    this.compiledGlyphs = /* @__PURE__ */ Object.create(null), rt(this, Zi, t), this._inspectFont = e, n && Object.assign(this, n), s && (this.charProcOperatorList = s);
  }
  createNativeFontFace() {
    var e;
    if (!this.data || this.disableFontFace)
      return null;
    let t;
    if (!this.cssFontInfo)
      t = new FontFace(this.loadedName, this.data, {});
    else {
      const n = {
        weight: this.cssFontInfo.fontWeight
      };
      this.cssFontInfo.italicAngle && (n.style = `oblique ${this.cssFontInfo.italicAngle}deg`), t = new FontFace(this.cssFontInfo.fontFamily, this.data, n);
    }
    return (e = this._inspectFont) == null || e.call(this, this), t;
  }
  createFontFaceRule() {
    var n;
    if (!this.data || this.disableFontFace)
      return null;
    const t = `url(data:${this.mimetype};base64,${VB(this.data)});`;
    let e;
    if (!this.cssFontInfo)
      e = `@font-face {font-family:"${this.loadedName}";src:${t}}`;
    else {
      let s = `font-weight: ${this.cssFontInfo.fontWeight};`;
      this.cssFontInfo.italicAngle && (s += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`), e = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${s}src:${t}}`;
    }
    return (n = this._inspectFont) == null || n.call(this, this, t), e;
  }
  getPathGenerator(t, e) {
    if (this.compiledGlyphs[e] !== void 0)
      return this.compiledGlyphs[e];
    const n = this.loadedName + "_path_" + e;
    let s;
    try {
      s = t.get(n);
    } catch (a) {
      pn(`getPathGenerator - ignoring character: "${a}".`);
    }
    const r = new Path2D(s || "");
    return this.fontExtraProperties || t.delete(n), this.compiledGlyphs[e] = r;
  }
  get black() {
    return w(this, Zi).black;
  }
  get bold() {
    return w(this, Zi).bold;
  }
  get disableFontFace() {
    return w(this, Zi).disableFontFace ?? !1;
  }
  get fontExtraProperties() {
    return w(this, Zi).fontExtraProperties ?? !1;
  }
  get isInvalidPDFjsFont() {
    return w(this, Zi).isInvalidPDFjsFont;
  }
  get isType3Font() {
    return w(this, Zi).isType3Font;
  }
  get italic() {
    return w(this, Zi).italic;
  }
  get missingFile() {
    return w(this, Zi).missingFile;
  }
  get remeasure() {
    return w(this, Zi).remeasure;
  }
  get vertical() {
    return w(this, Zi).vertical;
  }
  get ascent() {
    return w(this, Zi).ascent;
  }
  get defaultWidth() {
    return w(this, Zi).defaultWidth;
  }
  get descent() {
    return w(this, Zi).descent;
  }
  get bbox() {
    return w(this, Zi).bbox;
  }
  get fontMatrix() {
    return w(this, Zi).fontMatrix;
  }
  get fallbackName() {
    return w(this, Zi).fallbackName;
  }
  get loadedName() {
    return w(this, Zi).loadedName;
  }
  get mimetype() {
    return w(this, Zi).mimetype;
  }
  get name() {
    return w(this, Zi).name;
  }
  get data() {
    return w(this, Zi).data;
  }
  clearData() {
    w(this, Zi).clearData();
  }
  get cssFontInfo() {
    return w(this, Zi).cssFontInfo;
  }
  get systemFontInfo() {
    return w(this, Zi).systemFontInfo;
  }
  get defaultVMetrics() {
    return w(this, Zi).defaultVMetrics;
  }
}
Zi = new WeakMap();
function WIt(i) {
  if (i instanceof URL)
    return i.href;
  if (typeof i == "string") {
    if (Ma)
      return i;
    const t = URL.parse(i, window.location);
    if (t)
      return t.href;
  }
  throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
}
function GIt(i) {
  if (Ma && typeof Buffer < "u" && i instanceof Buffer)
    throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
  if (i instanceof Uint8Array && i.byteLength === i.buffer.byteLength)
    return i;
  if (typeof i == "string")
    return KT(i);
  if (i instanceof ArrayBuffer || ArrayBuffer.isView(i) || typeof i == "object" && !isNaN(i == null ? void 0 : i.length))
    return new Uint8Array(i);
  throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
}
function zM(i) {
  if (typeof i != "string")
    return null;
  if (i.endsWith("/"))
    return i;
  throw new Error(`Invalid factory url: "${i}" must include trailing slash.`);
}
const OV = (i) => typeof i == "object" && Number.isInteger(i == null ? void 0 : i.num) && i.num >= 0 && Number.isInteger(i == null ? void 0 : i.gen) && i.gen >= 0, wIt = (i) => typeof i == "object" && typeof (i == null ? void 0 : i.name) == "string", xIt = aIt.bind(null, OV, wIt);
var wu, pG;
class SIt {
  constructor() {
    pt(this, wu, /* @__PURE__ */ new Map());
    pt(this, pG, Promise.resolve());
  }
  postMessage(t, e) {
    const n = {
      data: structuredClone(t, e ? {
        transfer: e
      } : null)
    };
    w(this, pG).then(() => {
      for (const [s] of w(this, wu))
        s.call(this, n);
    });
  }
  addEventListener(t, e, n = null) {
    let s = null;
    if ((n == null ? void 0 : n.signal) instanceof AbortSignal) {
      const {
        signal: r
      } = n;
      if (r.aborted) {
        pn("LoopbackPort - cannot use an `aborted` signal.");
        return;
      }
      const a = () => this.removeEventListener(t, e);
      s = () => r.removeEventListener("abort", a), r.addEventListener("abort", a);
    }
    w(this, wu).set(e, s);
  }
  removeEventListener(t, e) {
    const n = w(this, wu).get(e);
    n == null || n(), w(this, wu).delete(e);
  }
  terminate() {
    for (const [, t] of w(this, wu))
      t == null || t();
    w(this, wu).clear();
  }
}
wu = new WeakMap(), pG = new WeakMap();
const EM = {
  DATA: 1,
  ERROR: 2
}, vs = {
  CANCEL: 1,
  CANCEL_COMPLETE: 2,
  CLOSE: 3,
  ENQUEUE: 4,
  ERROR: 5,
  PULL: 6,
  PULL_COMPLETE: 7,
  START_COMPLETE: 8
};
function SE() {
}
function Ia(i) {
  if (i instanceof $h || i instanceof mV || i instanceof ZE || i instanceof PW || i instanceof YS)
    return i;
  switch (i instanceof Error || typeof i == "object" && i !== null || Xi('wrapReason: Expected "reason" to be a (possibly cloned) Error.'), i.name) {
    case "AbortException":
      return new $h(i.message);
    case "InvalidPDFException":
      return new mV(i.message);
    case "PasswordException":
      return new ZE(i.message, i.code);
    case "ResponseException":
      return new PW(i.message, i.status, i.missing);
    case "UnknownErrorException":
      return new YS(i.message, i.details);
  }
  return new YS(i.message, i.toString());
}
var of, sl, cK, uK, dK, XN;
class Dy {
  constructor(t, e, n) {
    pt(this, sl);
    pt(this, of, new AbortController());
    this.sourceName = t, this.targetName = e, this.comObj = n, this.callbackId = 1, this.streamId = 1, this.streamSinks = /* @__PURE__ */ Object.create(null), this.streamControllers = /* @__PURE__ */ Object.create(null), this.callbackCapabilities = /* @__PURE__ */ Object.create(null), this.actionHandler = /* @__PURE__ */ Object.create(null), n.addEventListener("message", ft(this, sl, cK).bind(this), {
      signal: w(this, of).signal
    });
  }
  on(t, e) {
    const n = this.actionHandler;
    if (n[t])
      throw new Error(`There is already an actionName called "${t}"`);
    n[t] = e;
  }
  send(t, e, n) {
    this.comObj.postMessage({
      sourceName: this.sourceName,
      targetName: this.targetName,
      action: t,
      data: e
    }, n);
  }
  sendWithPromise(t, e, n) {
    const s = this.callbackId++, r = Promise.withResolvers();
    this.callbackCapabilities[s] = r;
    try {
      this.comObj.postMessage({
        sourceName: this.sourceName,
        targetName: this.targetName,
        action: t,
        callbackId: s,
        data: e
      }, n);
    } catch (a) {
      r.reject(a);
    }
    return r.promise;
  }
  sendWithStream(t, e, n, s) {
    const r = this.streamId++, a = this.sourceName, o = this.targetName, l = this.comObj;
    return new ReadableStream({
      start: (c) => {
        const u = Promise.withResolvers();
        return this.streamControllers[r] = {
          controller: c,
          startCall: u,
          pullCall: null,
          cancelCall: null,
          isClosed: !1
        }, l.postMessage({
          sourceName: a,
          targetName: o,
          action: t,
          streamId: r,
          data: e,
          desiredSize: c.desiredSize
        }, s), u.promise;
      },
      pull: (c) => {
        const u = Promise.withResolvers();
        return this.streamControllers[r].pullCall = u, l.postMessage({
          sourceName: a,
          targetName: o,
          stream: vs.PULL,
          streamId: r,
          desiredSize: c.desiredSize
        }), u.promise;
      },
      cancel: (c) => {
        Pn(c instanceof Error, "cancel must have a valid reason");
        const u = Promise.withResolvers();
        return this.streamControllers[r].cancelCall = u, this.streamControllers[r].isClosed = !0, l.postMessage({
          sourceName: a,
          targetName: o,
          stream: vs.CANCEL,
          streamId: r,
          reason: Ia(c)
        }), u.promise;
      }
    }, n);
  }
  destroy() {
    var t;
    (t = w(this, of)) == null || t.abort(), rt(this, of, null);
  }
}
of = new WeakMap(), sl = new WeakSet(), cK = function({
  data: t
}) {
  if (t.targetName !== this.sourceName)
    return;
  if (t.stream) {
    ft(this, sl, dK).call(this, t);
    return;
  }
  if (t.callback) {
    const n = t.callbackId, s = this.callbackCapabilities[n];
    if (!s)
      throw new Error(`Cannot resolve callback ${n}`);
    if (delete this.callbackCapabilities[n], t.callback === EM.DATA)
      s.resolve(t.data);
    else if (t.callback === EM.ERROR)
      s.reject(Ia(t.reason));
    else
      throw new Error("Unexpected callback case");
    return;
  }
  const e = this.actionHandler[t.action];
  if (!e)
    throw new Error(`Unknown action from worker: ${t.action}`);
  if (t.callbackId) {
    const n = this.sourceName, s = t.sourceName, r = this.comObj;
    Promise.try(e, t.data).then(function(a) {
      r.postMessage({
        sourceName: n,
        targetName: s,
        callback: EM.DATA,
        callbackId: t.callbackId,
        data: a
      });
    }, function(a) {
      r.postMessage({
        sourceName: n,
        targetName: s,
        callback: EM.ERROR,
        callbackId: t.callbackId,
        reason: Ia(a)
      });
    });
    return;
  }
  if (t.streamId) {
    ft(this, sl, uK).call(this, t);
    return;
  }
  e(t.data);
}, uK = function(t) {
  const e = t.streamId, n = this.sourceName, s = t.sourceName, r = this.comObj, a = this, o = this.actionHandler[t.action], l = {
    enqueue(c, u = 1, d) {
      if (this.isCancelled)
        return;
      const h = this.desiredSize;
      this.desiredSize -= u, h > 0 && this.desiredSize <= 0 && (this.sinkCapability = Promise.withResolvers(), this.ready = this.sinkCapability.promise), r.postMessage({
        sourceName: n,
        targetName: s,
        stream: vs.ENQUEUE,
        streamId: e,
        chunk: c
      }, d);
    },
    close() {
      this.isCancelled || (this.isCancelled = !0, r.postMessage({
        sourceName: n,
        targetName: s,
        stream: vs.CLOSE,
        streamId: e
      }), delete a.streamSinks[e]);
    },
    error(c) {
      Pn(c instanceof Error, "error must have a valid reason"), !this.isCancelled && (this.isCancelled = !0, r.postMessage({
        sourceName: n,
        targetName: s,
        stream: vs.ERROR,
        streamId: e,
        reason: Ia(c)
      }));
    },
    sinkCapability: Promise.withResolvers(),
    onPull: null,
    onCancel: null,
    isCancelled: !1,
    desiredSize: t.desiredSize,
    ready: null
  };
  l.sinkCapability.resolve(), l.ready = l.sinkCapability.promise, this.streamSinks[e] = l, Promise.try(o, t.data, l).then(function() {
    r.postMessage({
      sourceName: n,
      targetName: s,
      stream: vs.START_COMPLETE,
      streamId: e,
      success: !0
    });
  }, function(c) {
    r.postMessage({
      sourceName: n,
      targetName: s,
      stream: vs.START_COMPLETE,
      streamId: e,
      reason: Ia(c)
    });
  });
}, dK = function(t) {
  const e = t.streamId, n = this.sourceName, s = t.sourceName, r = this.comObj, a = this.streamControllers[e], o = this.streamSinks[e];
  switch (t.stream) {
    case vs.START_COMPLETE:
      t.success ? a.startCall.resolve() : a.startCall.reject(Ia(t.reason));
      break;
    case vs.PULL_COMPLETE:
      t.success ? a.pullCall.resolve() : a.pullCall.reject(Ia(t.reason));
      break;
    case vs.PULL:
      if (!o) {
        r.postMessage({
          sourceName: n,
          targetName: s,
          stream: vs.PULL_COMPLETE,
          streamId: e,
          success: !0
        });
        break;
      }
      o.desiredSize <= 0 && t.desiredSize > 0 && o.sinkCapability.resolve(), o.desiredSize = t.desiredSize, Promise.try(o.onPull || SE).then(function() {
        r.postMessage({
          sourceName: n,
          targetName: s,
          stream: vs.PULL_COMPLETE,
          streamId: e,
          success: !0
        });
      }, function(c) {
        r.postMessage({
          sourceName: n,
          targetName: s,
          stream: vs.PULL_COMPLETE,
          streamId: e,
          reason: Ia(c)
        });
      });
      break;
    case vs.ENQUEUE:
      if (Pn(a, "enqueue should have stream controller"), a.isClosed)
        break;
      a.controller.enqueue(t.chunk);
      break;
    case vs.CLOSE:
      if (Pn(a, "close should have stream controller"), a.isClosed)
        break;
      a.isClosed = !0, a.controller.close(), ft(this, sl, XN).call(this, a, e);
      break;
    case vs.ERROR:
      Pn(a, "error should have stream controller"), a.controller.error(Ia(t.reason)), ft(this, sl, XN).call(this, a, e);
      break;
    case vs.CANCEL_COMPLETE:
      t.success ? a.cancelCall.resolve() : a.cancelCall.reject(Ia(t.reason)), ft(this, sl, XN).call(this, a, e);
      break;
    case vs.CANCEL:
      if (!o)
        break;
      const l = Ia(t.reason);
      Promise.try(o.onCancel || SE, l).then(function() {
        r.postMessage({
          sourceName: n,
          targetName: s,
          stream: vs.CANCEL_COMPLETE,
          streamId: e,
          success: !0
        });
      }, function(c) {
        r.postMessage({
          sourceName: n,
          targetName: s,
          stream: vs.CANCEL_COMPLETE,
          streamId: e,
          reason: Ia(c)
        });
      }), o.sinkCapability.reject(l), o.isCancelled = !0, delete this.streamSinks[e];
      break;
    default:
      throw new Error("Unexpected stream case");
  }
}, XN = async function(t, e) {
  var n, s, r;
  await Promise.allSettled([(n = t.startCall) == null ? void 0 : n.promise, (s = t.pullCall) == null ? void 0 : s.promise, (r = t.cancelCall) == null ? void 0 : r.promise]), delete this.streamControllers[e];
};
var gZ;
class hK {
  constructor({
    enableHWA: t = !1
  }) {
    pt(this, gZ, !1);
    rt(this, gZ, t);
  }
  create(t, e) {
    if (t <= 0 || e <= 0)
      throw new Error("Invalid canvas size");
    const n = this._createCanvas(t, e);
    return {
      canvas: n,
      context: n.getContext("2d", {
        willReadFrequently: !w(this, gZ)
      })
    };
  }
  reset(t, e, n) {
    if (!t.canvas)
      throw new Error("Canvas is not specified");
    if (e <= 0 || n <= 0)
      throw new Error("Invalid canvas size");
    t.canvas.width = e, t.canvas.height = n;
  }
  destroy(t) {
    if (!t.canvas)
      throw new Error("Canvas is not specified");
    t.canvas.width = 0, t.canvas.height = 0, t.canvas = null, t.context = null;
  }
  _createCanvas(t, e) {
    Xi("Abstract method `_createCanvas` called.");
  }
}
gZ = new WeakMap();
class LIt extends hK {
  constructor({
    ownerDocument: t = globalThis.document,
    enableHWA: e = !1
  }) {
    super({
      enableHWA: e
    }), this._document = t;
  }
  _createCanvas(t, e) {
    const n = this._document.createElement("canvas");
    return n.width = t, n.height = e, n;
  }
}
class pK {
  constructor({
    baseUrl: t = null,
    isCompressed: e = !0
  }) {
    this.baseUrl = t, this.isCompressed = e;
  }
  async fetch({
    name: t
  }) {
    if (!this.baseUrl)
      throw new Error("Ensure that the `cMapUrl` and `cMapPacked` API parameters are provided.");
    if (!t)
      throw new Error("CMap name must be specified.");
    const e = this.baseUrl + t + (this.isCompressed ? ".bcmap" : "");
    return this._fetch(e).then((n) => ({
      cMapData: n,
      isCompressed: this.isCompressed
    })).catch((n) => {
      throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${e}`);
    });
  }
  async _fetch(t) {
    Xi("Abstract method `_fetch` called.");
  }
}
class LE extends pK {
  async _fetch(t) {
    const e = await HT(t, this.isCompressed ? "arraybuffer" : "text");
    return e instanceof ArrayBuffer ? new Uint8Array(e) : KT(e);
  }
}
class mK {
  addFilter(t) {
    return "none";
  }
  addHCMFilter(t, e) {
    return "none";
  }
  addAlphaFilter(t) {
    return "none";
  }
  addLuminosityFilter(t) {
    return "none";
  }
  addHighlightHCMFilter(t, e, n, s, r) {
    return "none";
  }
  destroy(t = !1) {
  }
}
var mm, lf, xu, Su, Qr, bm, fm, ve, Jr, Oy, db, IN, hb, bK, zV, pb, zy, Ey, EV, ky;
class VIt extends mK {
  constructor({
    docId: e,
    ownerDocument: n = globalThis.document
  }) {
    super();
    pt(this, ve);
    pt(this, mm);
    pt(this, lf);
    pt(this, xu);
    pt(this, Su);
    pt(this, Qr);
    pt(this, bm);
    pt(this, fm, 0);
    rt(this, Su, e), rt(this, Qr, n);
  }
  addFilter(e) {
    if (!e)
      return "none";
    let n = w(this, ve, Jr).get(e);
    if (n)
      return n;
    const [s, r, a] = ft(this, ve, IN).call(this, e), o = e.length === 1 ? s : `${s}${r}${a}`;
    if (n = w(this, ve, Jr).get(o), n)
      return w(this, ve, Jr).set(e, n), n;
    const l = `g_${w(this, Su)}_transfer_map_${Ks(this, fm)._++}`, c = ft(this, ve, hb).call(this, l);
    w(this, ve, Jr).set(e, c), w(this, ve, Jr).set(o, c);
    const u = ft(this, ve, pb).call(this, l);
    return ft(this, ve, Ey).call(this, s, r, a, u), c;
  }
  addHCMFilter(e, n) {
    var m;
    const s = `${e}-${n}`, r = "base";
    let a = w(this, ve, Oy).get(r);
    if ((a == null ? void 0 : a.key) === s || (a ? ((m = a.filter) == null || m.remove(), a.key = s, a.url = "none", a.filter = null) : (a = {
      key: s,
      url: "none",
      filter: null
    }, w(this, ve, Oy).set(r, a)), !e || !n))
      return a.url;
    const o = ft(this, ve, ky).call(this, e);
    e = ze.makeHexColor(...o);
    const l = ft(this, ve, ky).call(this, n);
    if (n = ze.makeHexColor(...l), w(this, ve, db).style.color = "", e === "#000000" && n === "#ffffff" || e === n)
      return a.url;
    const c = new Array(256);
    for (let b = 0; b <= 255; b++) {
      const y = b / 255;
      c[b] = y <= 0.03928 ? y / 12.92 : ((y + 0.055) / 1.055) ** 2.4;
    }
    const u = c.join(","), d = `g_${w(this, Su)}_hcm_filter`, h = a.filter = ft(this, ve, pb).call(this, d);
    ft(this, ve, Ey).call(this, u, u, u, h), ft(this, ve, zV).call(this, h);
    const p = (b, y) => {
      const Z = o[b] / 255, g = l[b] / 255, f = new Array(y + 1);
      for (let T = 0; T <= y; T++)
        f[T] = Z + T / y * (g - Z);
      return f.join(",");
    };
    return ft(this, ve, Ey).call(this, p(0, 5), p(1, 5), p(2, 5), h), a.url = ft(this, ve, hb).call(this, d), a.url;
  }
  addAlphaFilter(e) {
    let n = w(this, ve, Jr).get(e);
    if (n)
      return n;
    const [s] = ft(this, ve, IN).call(this, [e]), r = `alpha_${s}`;
    if (n = w(this, ve, Jr).get(r), n)
      return w(this, ve, Jr).set(e, n), n;
    const a = `g_${w(this, Su)}_alpha_map_${Ks(this, fm)._++}`, o = ft(this, ve, hb).call(this, a);
    w(this, ve, Jr).set(e, o), w(this, ve, Jr).set(r, o);
    const l = ft(this, ve, pb).call(this, a);
    return ft(this, ve, EV).call(this, s, l), o;
  }
  addLuminosityFilter(e) {
    let n = w(this, ve, Jr).get(e || "luminosity");
    if (n)
      return n;
    let s, r;
    if (e ? ([s] = ft(this, ve, IN).call(this, [e]), r = `luminosity_${s}`) : r = "luminosity", n = w(this, ve, Jr).get(r), n)
      return w(this, ve, Jr).set(e, n), n;
    const a = `g_${w(this, Su)}_luminosity_map_${Ks(this, fm)._++}`, o = ft(this, ve, hb).call(this, a);
    w(this, ve, Jr).set(e, o), w(this, ve, Jr).set(r, o);
    const l = ft(this, ve, pb).call(this, a);
    return ft(this, ve, bK).call(this, l), e && ft(this, ve, EV).call(this, s, l), o;
  }
  addHighlightHCMFilter(e, n, s, r, a) {
    var g;
    const o = `${n}-${s}-${r}-${a}`;
    let l = w(this, ve, Oy).get(e);
    if ((l == null ? void 0 : l.key) === o || (l ? ((g = l.filter) == null || g.remove(), l.key = o, l.url = "none", l.filter = null) : (l = {
      key: o,
      url: "none",
      filter: null
    }, w(this, ve, Oy).set(e, l)), !n || !s))
      return l.url;
    const [c, u] = [n, s].map(ft(this, ve, ky).bind(this));
    let d = Math.round(0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]), h = Math.round(0.2126 * u[0] + 0.7152 * u[1] + 0.0722 * u[2]), [p, m] = [r, a].map(ft(this, ve, ky).bind(this));
    h < d && ([d, h, p, m] = [h, d, m, p]), w(this, ve, db).style.color = "";
    const b = (f, T, M) => {
      const N = new Array(256), W = (h - d) / M, x = f / 255, V = (T - f) / (255 * M);
      let X = 0;
      for (let C = 0; C <= M; C++) {
        const R = Math.round(d + C * W), z = x + C * V;
        for (let F = X; F <= R; F++)
          N[F] = z;
        X = R + 1;
      }
      for (let C = X; C < 256; C++)
        N[C] = N[X - 1];
      return N.join(",");
    }, y = `g_${w(this, Su)}_hcm_${e}_filter`, Z = l.filter = ft(this, ve, pb).call(this, y);
    return ft(this, ve, zV).call(this, Z), ft(this, ve, Ey).call(this, b(p[0], m[0], 5), b(p[1], m[1], 5), b(p[2], m[2], 5), Z), l.url = ft(this, ve, hb).call(this, y), l.url;
  }
  destroy(e = !1) {
    var n, s, r, a;
    e && ((n = w(this, bm)) != null && n.size) || ((s = w(this, xu)) == null || s.parentNode.parentNode.remove(), rt(this, xu, null), (r = w(this, lf)) == null || r.clear(), rt(this, lf, null), (a = w(this, bm)) == null || a.clear(), rt(this, bm, null), rt(this, fm, 0));
  }
}
mm = new WeakMap(), lf = new WeakMap(), xu = new WeakMap(), Su = new WeakMap(), Qr = new WeakMap(), bm = new WeakMap(), fm = new WeakMap(), ve = new WeakSet(), Jr = function() {
  return w(this, lf) || rt(this, lf, /* @__PURE__ */ new Map());
}, Oy = function() {
  return w(this, bm) || rt(this, bm, /* @__PURE__ */ new Map());
}, db = function() {
  if (!w(this, xu)) {
    const e = w(this, Qr).createElement("div"), {
      style: n
    } = e;
    n.visibility = "hidden", n.contain = "strict", n.width = n.height = 0, n.position = "absolute", n.top = n.left = 0, n.zIndex = -1;
    const s = w(this, Qr).createElementNS(ru, "svg");
    s.setAttribute("width", 0), s.setAttribute("height", 0), rt(this, xu, w(this, Qr).createElementNS(ru, "defs")), e.append(s), s.append(w(this, xu)), w(this, Qr).body.append(e);
  }
  return w(this, xu);
}, IN = function(e) {
  if (e.length === 1) {
    const c = e[0], u = new Array(256);
    for (let h = 0; h < 256; h++)
      u[h] = c[h] / 255;
    const d = u.join(",");
    return [d, d, d];
  }
  const [n, s, r] = e, a = new Array(256), o = new Array(256), l = new Array(256);
  for (let c = 0; c < 256; c++)
    a[c] = n[c] / 255, o[c] = s[c] / 255, l[c] = r[c] / 255;
  return [a.join(","), o.join(","), l.join(",")];
}, hb = function(e) {
  if (w(this, mm) === void 0) {
    rt(this, mm, "");
    const n = w(this, Qr).URL;
    n !== w(this, Qr).baseURI && (fw(n) ? pn('#createUrl: ignore "data:"-URL for performance reasons.') : rt(this, mm, xB(n, "")));
  }
  return `url(${w(this, mm)}#${e})`;
}, bK = function(e) {
  const n = w(this, Qr).createElementNS(ru, "feColorMatrix");
  n.setAttribute("type", "matrix"), n.setAttribute("values", "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0.59 0.11 0 0"), e.append(n);
}, zV = function(e) {
  const n = w(this, Qr).createElementNS(ru, "feColorMatrix");
  n.setAttribute("type", "matrix"), n.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"), e.append(n);
}, pb = function(e) {
  const n = w(this, Qr).createElementNS(ru, "filter");
  return n.setAttribute("color-interpolation-filters", "sRGB"), n.setAttribute("id", e), w(this, ve, db).append(n), n;
}, zy = function(e, n, s) {
  const r = w(this, Qr).createElementNS(ru, n);
  r.setAttribute("type", "discrete"), r.setAttribute("tableValues", s), e.append(r);
}, Ey = function(e, n, s, r) {
  const a = w(this, Qr).createElementNS(ru, "feComponentTransfer");
  r.append(a), ft(this, ve, zy).call(this, a, "feFuncR", e), ft(this, ve, zy).call(this, a, "feFuncG", n), ft(this, ve, zy).call(this, a, "feFuncB", s);
}, EV = function(e, n) {
  const s = w(this, Qr).createElementNS(ru, "feComponentTransfer");
  n.append(s), ft(this, ve, zy).call(this, s, "feFuncA", e);
}, ky = function(e) {
  return w(this, ve, db).style.color = e, QT(getComputedStyle(w(this, ve, db)).getPropertyValue("color"));
};
class fK {
  constructor({
    baseUrl: t = null
  }) {
    this.baseUrl = t;
  }
  async fetch({
    filename: t
  }) {
    if (!this.baseUrl)
      throw new Error("Ensure that the `standardFontDataUrl` API parameter is provided.");
    if (!t)
      throw new Error("Font filename must be specified.");
    const e = `${this.baseUrl}${t}`;
    return this._fetch(e).catch((n) => {
      throw new Error(`Unable to load font data at: ${e}`);
    });
  }
  async _fetch(t) {
    Xi("Abstract method `_fetch` called.");
  }
}
class VE extends fK {
  async _fetch(t) {
    const e = await HT(t, "arraybuffer");
    return new Uint8Array(e);
  }
}
class gK {
  constructor({
    baseUrl: t = null
  }) {
    this.baseUrl = t;
  }
  async fetch({
    filename: t
  }) {
    if (!this.baseUrl)
      throw new Error("Ensure that the `wasmUrl` API parameter is provided.");
    if (!t)
      throw new Error("Wasm filename must be specified.");
    const e = `${this.baseUrl}${t}`;
    return this._fetch(e).catch((n) => {
      throw new Error(`Unable to load wasm data at: ${e}`);
    });
  }
  async _fetch(t) {
    Xi("Abstract method `_fetch` called.");
  }
}
class XE extends gK {
  async _fetch(t) {
    const e = await HT(t, "arraybuffer");
    return new Uint8Array(e);
  }
}
Ma && pn("Please use the `legacy` build in Node.js environments.");
async function eY(i) {
  const e = await process.getBuiltinModule("fs").promises.readFile(i);
  return new Uint8Array(e);
}
class XIt extends mK {
}
class IIt extends hK {
  _createCanvas(t, e) {
    return process.getBuiltinModule("module").createRequire(import.meta.url)("@napi-rs/canvas").createCanvas(t, e);
  }
}
class CIt extends pK {
  async _fetch(t) {
    return eY(t);
  }
}
class YIt extends fK {
  async _fetch(t) {
    return eY(t);
  }
}
class vIt extends gK {
  async _fetch(t) {
    return eY(t);
  }
}
const sb = "__forcedDependency", {
  floor: IE,
  ceil: CE
} = Math;
function kM(i, t, e, n, s, r) {
  i[t * 4 + 0] = Math.min(i[t * 4 + 0], e), i[t * 4 + 1] = Math.min(i[t * 4 + 1], n), i[t * 4 + 2] = Math.max(i[t * 4 + 2], s), i[t * 4 + 3] = Math.max(i[t * 4 + 3], r);
}
const kV = new Uint32Array(new Uint8Array([255, 255, 0, 0]).buffer)[0];
var cf, oh;
class RIt {
  constructor(t, e) {
    pt(this, cf);
    pt(this, oh);
    rt(this, cf, t), rt(this, oh, e);
  }
  get length() {
    return w(this, cf).length;
  }
  isEmpty(t) {
    return w(this, cf)[t] === kV;
  }
  minX(t) {
    return w(this, oh)[t * 4 + 0] / 256;
  }
  minY(t) {
    return w(this, oh)[t * 4 + 1] / 256;
  }
  maxX(t) {
    return (w(this, oh)[t * 4 + 2] + 1) / 256;
  }
  maxY(t) {
    return (w(this, oh)[t * 4 + 3] + 1) / 256;
  }
}
cf = new WeakMap(), oh = new WeakMap();
const FM = (i, t) => {
  if (!i)
    return;
  let e = i.get(t);
  return e || (e = {
    dependencies: /* @__PURE__ */ new Set(),
    isRenderingOperation: !1
  }, i.set(t, e)), e;
};
var va, Ra, gm, Ml, ym, Lu, bi, Ti, Vu, Da, yZ, uf, Zm, Tm, Xu, $r, Zc, ZZ, FV;
class DIt {
  constructor(t, e, n = !1) {
    pt(this, ZZ);
    pt(this, va, {
      __proto__: null
    });
    pt(this, Ra, {
      __proto__: null,
      transform: [],
      moveText: [],
      sameLineText: [],
      [sb]: []
    });
    pt(this, gm, /* @__PURE__ */ new Map());
    pt(this, Ml, []);
    pt(this, ym, []);
    pt(this, Lu, [[1, 0, 0, 1, 0, 0]]);
    pt(this, bi, [-1 / 0, -1 / 0, 1 / 0, 1 / 0]);
    pt(this, Ti, new Float64Array([1 / 0, 1 / 0, -1 / 0, -1 / 0]));
    pt(this, Vu, -1);
    pt(this, Da, /* @__PURE__ */ new Set());
    pt(this, yZ, /* @__PURE__ */ new Map());
    pt(this, uf, /* @__PURE__ */ new Map());
    pt(this, Zm);
    pt(this, Tm);
    pt(this, Xu);
    pt(this, $r);
    pt(this, Zc);
    rt(this, Zm, t.width), rt(this, Tm, t.height), ft(this, ZZ, FV).call(this, e), n && rt(this, Zc, /* @__PURE__ */ new Map());
  }
  growOperationsCount(t) {
    t >= w(this, $r).length && ft(this, ZZ, FV).call(this, t, w(this, $r));
  }
  save(t) {
    return rt(this, va, {
      __proto__: w(this, va)
    }), rt(this, Ra, {
      __proto__: w(this, Ra),
      transform: {
        __proto__: w(this, Ra).transform
      },
      moveText: {
        __proto__: w(this, Ra).moveText
      },
      sameLineText: {
        __proto__: w(this, Ra).sameLineText
      },
      [sb]: {
        __proto__: w(this, Ra)[sb]
      }
    }), rt(this, bi, {
      __proto__: w(this, bi)
    }), w(this, Ml).push(t), this;
  }
  restore(t) {
    var s;
    const e = Object.getPrototypeOf(w(this, va));
    if (e === null)
      return this;
    rt(this, va, e), rt(this, Ra, Object.getPrototypeOf(w(this, Ra))), rt(this, bi, Object.getPrototypeOf(w(this, bi)));
    const n = w(this, Ml).pop();
    return n !== void 0 && ((s = FM(w(this, Zc), t)) == null || s.dependencies.add(n), w(this, $r)[t] = w(this, $r)[n]), this;
  }
  recordOpenMarker(t) {
    return w(this, Ml).push(t), this;
  }
  getOpenMarker() {
    return w(this, Ml).length === 0 ? null : w(this, Ml).at(-1);
  }
  recordCloseMarker(t) {
    var n;
    const e = w(this, Ml).pop();
    return e !== void 0 && ((n = FM(w(this, Zc), t)) == null || n.dependencies.add(e), w(this, $r)[t] = w(this, $r)[e]), this;
  }
  beginMarkedContent(t) {
    return w(this, ym).push(t), this;
  }
  endMarkedContent(t) {
    var n;
    const e = w(this, ym).pop();
    return e !== void 0 && ((n = FM(w(this, Zc), t)) == null || n.dependencies.add(e), w(this, $r)[t] = w(this, $r)[e]), this;
  }
  pushBaseTransform(t) {
    return w(this, Lu).push(ze.multiplyByDOMMatrix(w(this, Lu).at(-1), t.getTransform())), this;
  }
  popBaseTransform() {
    return w(this, Lu).length > 1 && w(this, Lu).pop(), this;
  }
  recordSimpleData(t, e) {
    return w(this, va)[t] = e, this;
  }
  recordIncrementalData(t, e) {
    return w(this, Ra)[t].push(e), this;
  }
  resetIncrementalData(t, e) {
    return w(this, Ra)[t].length = 0, this;
  }
  recordNamedData(t, e) {
    return w(this, gm).set(t, e), this;
  }
  recordSimpleDataFromNamed(t, e, n) {
    w(this, va)[t] = w(this, gm).get(e) ?? n;
  }
  recordFutureForcedDependency(t, e) {
    return this.recordIncrementalData(sb, e), this;
  }
  inheritSimpleDataAsFutureForcedDependencies(t) {
    for (const e of t)
      e in w(this, va) && this.recordFutureForcedDependency(e, w(this, va)[e]);
    return this;
  }
  inheritPendingDependenciesAsFutureForcedDependencies() {
    for (const t of w(this, Da))
      this.recordFutureForcedDependency(sb, t);
    return this;
  }
  resetBBox(t) {
    return w(this, Vu) !== t && (rt(this, Vu, t), w(this, Ti)[0] = 1 / 0, w(this, Ti)[1] = 1 / 0, w(this, Ti)[2] = -1 / 0, w(this, Ti)[3] = -1 / 0), this;
  }
  recordClipBox(t, e, n, s, r, a) {
    const o = ze.multiplyByDOMMatrix(w(this, Lu).at(-1), e.getTransform()), l = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
    ze.axialAlignedBoundingBox([n, r, s, a], o, l);
    const c = ze.intersect(w(this, bi), l);
    return c ? (w(this, bi)[0] = c[0], w(this, bi)[1] = c[1], w(this, bi)[2] = c[2], w(this, bi)[3] = c[3]) : (w(this, bi)[0] = w(this, bi)[1] = 1 / 0, w(this, bi)[2] = w(this, bi)[3] = -1 / 0), this;
  }
  recordBBox(t, e, n, s, r, a) {
    const o = w(this, bi);
    if (o[0] === 1 / 0)
      return this;
    const l = ze.multiplyByDOMMatrix(w(this, Lu).at(-1), e.getTransform());
    if (o[0] === -1 / 0)
      return ze.axialAlignedBoundingBox([n, r, s, a], l, w(this, Ti)), this;
    const c = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
    return ze.axialAlignedBoundingBox([n, r, s, a], l, c), w(this, Ti)[0] = Math.min(w(this, Ti)[0], Math.max(c[0], o[0])), w(this, Ti)[1] = Math.min(w(this, Ti)[1], Math.max(c[1], o[1])), w(this, Ti)[2] = Math.max(w(this, Ti)[2], Math.min(c[2], o[2])), w(this, Ti)[3] = Math.max(w(this, Ti)[3], Math.min(c[3], o[3])), this;
  }
  recordCharacterBBox(t, e, n, s = 1, r = 0, a = 0, o) {
    const l = n.bbox;
    let c, u;
    if (l && (c = l[2] !== l[0] && l[3] !== l[1] && w(this, uf).get(n), c !== !1 && (u = [0, 0, 0, 0], ze.axialAlignedBoundingBox(l, n.fontMatrix, u), (s !== 1 || r !== 0 || a !== 0) && ze.scaleMinMax([s, 0, 0, -s, r, a], u), c)))
      return this.recordBBox(t, e, u[0], u[2], u[1], u[3]);
    if (!o)
      return this.recordFullPageBBox(t);
    const d = o();
    return l && u && c === void 0 && (c = u[0] <= r - d.actualBoundingBoxLeft && u[2] >= r + d.actualBoundingBoxRight && u[1] <= a - d.actualBoundingBoxAscent && u[3] >= a + d.actualBoundingBoxDescent, w(this, uf).set(n, c), c) ? this.recordBBox(t, e, u[0], u[2], u[1], u[3]) : this.recordBBox(t, e, r - d.actualBoundingBoxLeft, r + d.actualBoundingBoxRight, a - d.actualBoundingBoxAscent, a + d.actualBoundingBoxDescent);
  }
  recordFullPageBBox(t) {
    return w(this, Ti)[0] = Math.max(0, w(this, bi)[0]), w(this, Ti)[1] = Math.max(0, w(this, bi)[1]), w(this, Ti)[2] = Math.min(w(this, Zm), w(this, bi)[2]), w(this, Ti)[3] = Math.min(w(this, Tm), w(this, bi)[3]), this;
  }
  getSimpleIndex(t) {
    return w(this, va)[t];
  }
  recordDependencies(t, e) {
    const n = w(this, Da), s = w(this, va), r = w(this, Ra);
    for (const a of e)
      a in w(this, va) ? n.add(s[a]) : a in r && r[a].forEach(n.add, n);
    return this;
  }
  recordNamedDependency(t, e) {
    return w(this, gm).has(e) && w(this, Da).add(w(this, gm).get(e)), this;
  }
  recordOperation(t, e = !1) {
    if (this.recordDependencies(t, [sb]), w(this, Zc)) {
      const n = FM(w(this, Zc), t), {
        dependencies: s
      } = n;
      w(this, Da).forEach(s.add, s), w(this, Ml).forEach(s.add, s), w(this, ym).forEach(s.add, s), s.delete(t), n.isRenderingOperation = !0;
    }
    if (w(this, Vu) === t) {
      const n = IE(w(this, Ti)[0] * 256 / w(this, Zm)), s = IE(w(this, Ti)[1] * 256 / w(this, Tm)), r = CE(w(this, Ti)[2] * 256 / w(this, Zm)), a = CE(w(this, Ti)[3] * 256 / w(this, Tm));
      kM(w(this, Xu), t, n, s, r, a);
      for (const o of w(this, Da))
        o !== t && kM(w(this, Xu), o, n, s, r, a);
      for (const o of w(this, Ml))
        o !== t && kM(w(this, Xu), o, n, s, r, a);
      for (const o of w(this, ym))
        o !== t && kM(w(this, Xu), o, n, s, r, a);
      e || (w(this, Da).clear(), rt(this, Vu, -1));
    }
    return this;
  }
  recordShowTextOperation(t, e = !1) {
    const n = Array.from(w(this, Da));
    this.recordOperation(t, e), this.recordIncrementalData("sameLineText", t);
    for (const s of n)
      this.recordIncrementalData("sameLineText", s);
    return this;
  }
  bboxToClipBoxDropOperation(t, e = !1) {
    return w(this, Vu) === t && (rt(this, Vu, -1), w(this, bi)[0] = Math.max(w(this, bi)[0], w(this, Ti)[0]), w(this, bi)[1] = Math.max(w(this, bi)[1], w(this, Ti)[1]), w(this, bi)[2] = Math.min(w(this, bi)[2], w(this, Ti)[2]), w(this, bi)[3] = Math.min(w(this, bi)[3], w(this, Ti)[3]), e || w(this, Da).clear()), this;
  }
  _takePendingDependencies() {
    const t = w(this, Da);
    return rt(this, Da, /* @__PURE__ */ new Set()), t;
  }
  _extractOperation(t) {
    const e = w(this, yZ).get(t);
    return w(this, yZ).delete(t), e;
  }
  _pushPendingDependencies(t) {
    for (const e of t)
      w(this, Da).add(e);
  }
  take() {
    return w(this, uf).clear(), new RIt(w(this, $r), w(this, Xu));
  }
  takeDebugMetadata() {
    return w(this, Zc);
  }
}
va = new WeakMap(), Ra = new WeakMap(), gm = new WeakMap(), Ml = new WeakMap(), ym = new WeakMap(), Lu = new WeakMap(), bi = new WeakMap(), Ti = new WeakMap(), Vu = new WeakMap(), Da = new WeakMap(), yZ = new WeakMap(), uf = new WeakMap(), Zm = new WeakMap(), Tm = new WeakMap(), Xu = new WeakMap(), $r = new WeakMap(), Zc = new WeakMap(), ZZ = new WeakSet(), FV = function(t, e) {
  const n = new ArrayBuffer(t * 4);
  rt(this, Xu, new Uint8ClampedArray(n)), rt(this, $r, new Uint32Array(n)), e && e.length > 0 ? (w(this, $r).set(e), w(this, $r).fill(kV, e.length)) : w(this, $r).fill(kV);
};
var Li, us, Nl, df, hf;
const hY = class hY {
  constructor(t, e, n) {
    pt(this, Li);
    pt(this, us);
    pt(this, Nl);
    pt(this, df, 0);
    pt(this, hf, 0);
    if (t instanceof hY && w(t, Nl) === !!n)
      return t;
    rt(this, Li, t), rt(this, us, e), rt(this, Nl, !!n);
  }
  growOperationsCount() {
    throw new Error("Unreachable");
  }
  save(t) {
    return Ks(this, hf)._++, w(this, Li).save(w(this, us)), this;
  }
  restore(t) {
    return w(this, hf) > 0 && (w(this, Li).restore(w(this, us)), Ks(this, hf)._--), this;
  }
  recordOpenMarker(t) {
    return Ks(this, df)._++, this;
  }
  getOpenMarker() {
    return w(this, df) > 0 ? w(this, us) : w(this, Li).getOpenMarker();
  }
  recordCloseMarker(t) {
    return Ks(this, df)._--, this;
  }
  beginMarkedContent(t) {
    return this;
  }
  endMarkedContent(t) {
    return this;
  }
  pushBaseTransform(t) {
    return w(this, Li).pushBaseTransform(t), this;
  }
  popBaseTransform() {
    return w(this, Li).popBaseTransform(), this;
  }
  recordSimpleData(t, e) {
    return w(this, Li).recordSimpleData(t, w(this, us)), this;
  }
  recordIncrementalData(t, e) {
    return w(this, Li).recordIncrementalData(t, w(this, us)), this;
  }
  resetIncrementalData(t, e) {
    return w(this, Li).resetIncrementalData(t, w(this, us)), this;
  }
  recordNamedData(t, e) {
    return this;
  }
  recordSimpleDataFromNamed(t, e, n) {
    return w(this, Li).recordSimpleDataFromNamed(t, e, w(this, us)), this;
  }
  recordFutureForcedDependency(t, e) {
    return w(this, Li).recordFutureForcedDependency(t, w(this, us)), this;
  }
  inheritSimpleDataAsFutureForcedDependencies(t) {
    return w(this, Li).inheritSimpleDataAsFutureForcedDependencies(t), this;
  }
  inheritPendingDependenciesAsFutureForcedDependencies() {
    return w(this, Li).inheritPendingDependenciesAsFutureForcedDependencies(), this;
  }
  resetBBox(t) {
    return w(this, Nl) || w(this, Li).resetBBox(w(this, us)), this;
  }
  recordClipBox(t, e, n, s, r, a) {
    return w(this, Nl) || w(this, Li).recordClipBox(w(this, us), e, n, s, r, a), this;
  }
  recordBBox(t, e, n, s, r, a) {
    return w(this, Nl) || w(this, Li).recordBBox(w(this, us), e, n, s, r, a), this;
  }
  recordCharacterBBox(t, e, n, s, r, a, o) {
    return w(this, Nl) || w(this, Li).recordCharacterBBox(w(this, us), e, n, s, r, a, o), this;
  }
  recordFullPageBBox(t) {
    return w(this, Nl) || w(this, Li).recordFullPageBBox(w(this, us)), this;
  }
  getSimpleIndex(t) {
    return w(this, Li).getSimpleIndex(t);
  }
  recordDependencies(t, e) {
    return w(this, Li).recordDependencies(w(this, us), e), this;
  }
  recordNamedDependency(t, e) {
    return w(this, Li).recordNamedDependency(w(this, us), e), this;
  }
  recordOperation(t) {
    return w(this, Li).recordOperation(w(this, us), !0), this;
  }
  recordShowTextOperation(t) {
    return w(this, Li).recordShowTextOperation(w(this, us), !0), this;
  }
  bboxToClipBoxDropOperation(t) {
    return w(this, Nl) || w(this, Li).bboxToClipBoxDropOperation(w(this, us), !0), this;
  }
  take() {
    throw new Error("Unreachable");
  }
  takeDebugMetadata() {
    throw new Error("Unreachable");
  }
};
Li = new WeakMap(), us = new WeakMap(), Nl = new WeakMap(), df = new WeakMap(), hf = new WeakMap();
let KW = hY;
const Oo = {
  stroke: ["path", "transform", "filter", "strokeColor", "strokeAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "dash"],
  fill: ["path", "transform", "filter", "fillColor", "fillAlpha", "globalCompositeOperation", "SMask"],
  imageXObject: ["transform", "SMask", "filter", "fillAlpha", "strokeAlpha", "globalCompositeOperation"],
  rawFillPath: ["filter", "fillColor", "fillAlpha"],
  showText: ["transform", "leading", "charSpacing", "wordSpacing", "hScale", "textRise", "moveText", "textMatrix", "font", "fontObj", "filter", "fillColor", "textRenderingMode", "SMask", "fillAlpha", "strokeAlpha", "globalCompositeOperation", "sameLineText"],
  transform: ["transform"],
  transformAndFill: ["transform", "fillColor"]
}, Xr = {
  FILL: "Fill",
  STROKE: "Stroke",
  SHADING: "Shading"
};
function jV(i, t) {
  if (!t)
    return;
  const e = t[2] - t[0], n = t[3] - t[1], s = new Path2D();
  s.rect(t[0], t[1], e, n), i.clip(s);
}
class nY {
  isModifyingCurrentTransform() {
    return !1;
  }
  getPattern() {
    Xi("Abstract method `getPattern` called.");
  }
}
class OIt extends nY {
  constructor(t) {
    super(), this._type = t[1], this._bbox = t[2], this._colorStops = t[3], this._p0 = t[4], this._p1 = t[5], this._r0 = t[6], this._r1 = t[7], this.matrix = null;
  }
  _createGradient(t) {
    let e;
    this._type === "axial" ? e = t.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]) : this._type === "radial" && (e = t.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1));
    for (const n of this._colorStops)
      e.addColorStop(n[0], n[1]);
    return e;
  }
  getPattern(t, e, n, s) {
    let r;
    if (s === Xr.STROKE || s === Xr.FILL) {
      const a = e.current.getClippedPathBoundingBox(s, ns(t)) || [0, 0, 0, 0], o = Math.ceil(a[2] - a[0]) || 1, l = Math.ceil(a[3] - a[1]) || 1, c = e.cachedCanvases.getCanvas("pattern", o, l), u = c.context;
      u.clearRect(0, 0, u.canvas.width, u.canvas.height), u.beginPath(), u.rect(0, 0, u.canvas.width, u.canvas.height), u.translate(-a[0], -a[1]), n = ze.transform(n, [1, 0, 0, 1, a[0], a[1]]), u.transform(...e.baseTransform), this.matrix && u.transform(...this.matrix), jV(u, this._bbox), u.fillStyle = this._createGradient(u), u.fill(), r = t.createPattern(c.canvas, "no-repeat");
      const d = new DOMMatrix(n);
      r.setTransform(d);
    } else
      jV(t, this._bbox), r = this._createGradient(t);
    return r;
  }
}
function DS(i, t, e, n, s, r, a, o) {
  const l = t.coords, c = t.colors, u = i.data, d = i.width * 4;
  let h;
  l[e + 1] > l[n + 1] && (h = e, e = n, n = h, h = r, r = a, a = h), l[n + 1] > l[s + 1] && (h = n, n = s, s = h, h = a, a = o, o = h), l[e + 1] > l[n + 1] && (h = e, e = n, n = h, h = r, r = a, a = h);
  const p = (l[e] + t.offsetX) * t.scaleX, m = (l[e + 1] + t.offsetY) * t.scaleY, b = (l[n] + t.offsetX) * t.scaleX, y = (l[n + 1] + t.offsetY) * t.scaleY, Z = (l[s] + t.offsetX) * t.scaleX, g = (l[s + 1] + t.offsetY) * t.scaleY;
  if (m >= g)
    return;
  const f = c[r], T = c[r + 1], M = c[r + 2], N = c[a], W = c[a + 1], x = c[a + 2], V = c[o], X = c[o + 1], C = c[o + 2], R = Math.round(m), z = Math.round(g);
  let F, P, j, H, B, $, A, E;
  for (let ct = R; ct <= z; ct++) {
    if (ct < y) {
      const Zt = ct < m ? 0 : (m - ct) / (m - y);
      F = p - (p - b) * Zt, P = f - (f - N) * Zt, j = T - (T - W) * Zt, H = M - (M - x) * Zt;
    } else {
      let Zt;
      ct > g ? Zt = 1 : y === g ? Zt = 0 : Zt = (y - ct) / (y - g), F = b - (b - Z) * Zt, P = N - (N - V) * Zt, j = W - (W - X) * Zt, H = x - (x - C) * Zt;
    }
    let at;
    ct < m ? at = 0 : ct > g ? at = 1 : at = (m - ct) / (m - g), B = p - (p - Z) * at, $ = f - (f - V) * at, A = T - (T - X) * at, E = M - (M - C) * at;
    const dt = Math.round(Math.min(F, B)), gt = Math.round(Math.max(F, B));
    let Wt = d * ct + dt * 4;
    for (let Zt = dt; Zt <= gt; Zt++)
      at = (F - Zt) / (F - B), at < 0 ? at = 0 : at > 1 && (at = 1), u[Wt++] = P - (P - $) * at | 0, u[Wt++] = j - (j - A) * at | 0, u[Wt++] = H - (H - E) * at | 0, u[Wt++] = 255;
  }
}
function zIt(i, t, e) {
  const n = t.coords, s = t.colors;
  let r, a;
  switch (t.type) {
    case "lattice":
      const o = t.verticesPerRow, l = Math.floor(n.length / o) - 1, c = o - 1;
      for (r = 0; r < l; r++) {
        let u = r * o;
        for (let d = 0; d < c; d++, u++)
          DS(i, e, n[u], n[u + 1], n[u + o], s[u], s[u + 1], s[u + o]), DS(i, e, n[u + o + 1], n[u + 1], n[u + o], s[u + o + 1], s[u + 1], s[u + o]);
      }
      break;
    case "triangles":
      for (r = 0, a = n.length; r < a; r += 3)
        DS(i, e, n[r], n[r + 1], n[r + 2], s[r], s[r + 1], s[r + 2]);
      break;
    default:
      throw new Error("illegal figure");
  }
}
class EIt extends nY {
  constructor(t) {
    super(), this._coords = t[2], this._colors = t[3], this._figures = t[4], this._bounds = t[5], this._bbox = t[6], this._background = t[7], this.matrix = null;
  }
  _createMeshCanvas(t, e, n) {
    const o = Math.floor(this._bounds[0]), l = Math.floor(this._bounds[1]), c = Math.ceil(this._bounds[2]) - o, u = Math.ceil(this._bounds[3]) - l, d = Math.min(Math.ceil(Math.abs(c * t[0] * 1.1)), 3e3), h = Math.min(Math.ceil(Math.abs(u * t[1] * 1.1)), 3e3), p = c / d, m = u / h, b = {
      coords: this._coords,
      colors: this._colors,
      offsetX: -o,
      offsetY: -l,
      scaleX: 1 / p,
      scaleY: 1 / m
    }, y = d + 4, Z = h + 4, g = n.getCanvas("mesh", y, Z), f = g.context, T = f.createImageData(d, h);
    if (e) {
      const N = T.data;
      for (let W = 0, x = N.length; W < x; W += 4)
        N[W] = e[0], N[W + 1] = e[1], N[W + 2] = e[2], N[W + 3] = 255;
    }
    for (const N of this._figures)
      zIt(T, N, b);
    return f.putImageData(T, 2, 2), {
      canvas: g.canvas,
      offsetX: o - 2 * p,
      offsetY: l - 2 * m,
      scaleX: p,
      scaleY: m
    };
  }
  isModifyingCurrentTransform() {
    return !0;
  }
  getPattern(t, e, n, s) {
    jV(t, this._bbox);
    const r = new Float32Array(2);
    if (s === Xr.SHADING)
      ze.singularValueDecompose2dScale(ns(t), r);
    else if (this.matrix) {
      ze.singularValueDecompose2dScale(this.matrix, r);
      const [o, l] = r;
      ze.singularValueDecompose2dScale(e.baseTransform, r), r[0] *= o, r[1] *= l;
    } else
      ze.singularValueDecompose2dScale(e.baseTransform, r);
    const a = this._createMeshCanvas(r, s === Xr.SHADING ? null : this._background, e.cachedCanvases);
    return s !== Xr.SHADING && (t.setTransform(...e.baseTransform), this.matrix && t.transform(...this.matrix)), t.translate(a.offsetX, a.offsetY), t.scale(a.scaleX, a.scaleY), t.createPattern(a.canvas, "no-repeat");
  }
}
class kIt extends nY {
  getPattern() {
    return "hotpink";
  }
}
function FIt(i) {
  switch (i[0]) {
    case "RadialAxial":
      return new OIt(i);
    case "Mesh":
      return new EIt(i);
    case "Dummy":
      return new kIt();
  }
  throw new Error(`Unknown IR type: ${i[0]}`);
}
const YE = {
  COLORED: 1,
  UNCOLORED: 2
}, mG = class mG {
  constructor(t, e, n, s) {
    this.color = t[1], this.operatorList = t[2], this.matrix = t[3], this.bbox = t[4], this.xstep = t[5], this.ystep = t[6], this.paintType = t[7], this.tilingType = t[8], this.ctx = e, this.canvasGraphicsFactory = n, this.baseTransform = s;
  }
  createPatternCanvas(t, e) {
    var $, A;
    const {
      bbox: n,
      operatorList: s,
      paintType: r,
      tilingType: a,
      color: o,
      canvasGraphicsFactory: l
    } = this;
    let {
      xstep: c,
      ystep: u
    } = this;
    c = Math.abs(c), u = Math.abs(u), bw("TilingType: " + a);
    const d = n[0], h = n[1], p = n[2], m = n[3], b = p - d, y = m - h, Z = new Float32Array(2);
    ze.singularValueDecompose2dScale(this.matrix, Z);
    const [g, f] = Z;
    ze.singularValueDecompose2dScale(this.baseTransform, Z);
    const T = g * Z[0], M = f * Z[1];
    let N = b, W = y, x = !1, V = !1;
    const X = Math.ceil(c * T), C = Math.ceil(u * M), R = Math.ceil(b * T), z = Math.ceil(y * M);
    X >= R ? N = c : x = !0, C >= z ? W = u : V = !0;
    const F = this.getSizeAndScale(N, this.ctx.canvas.width, T), P = this.getSizeAndScale(W, this.ctx.canvas.height, M), j = t.cachedCanvases.getCanvas("pattern", F.size, P.size), H = j.context, B = l.createCanvasGraphics(H, e);
    if (B.groupLevel = t.groupLevel, this.setFillAndStrokeStyleToContext(B, r, o), H.translate(-F.scale * d, -P.scale * h), B.transform(0, F.scale, 0, 0, P.scale, 0, 0), H.save(), ($ = B.dependencyTracker) == null || $.save(), this.clipBbox(B, d, h, p, m), B.baseTransform = ns(B.ctx), B.executeOperatorList(s), B.endDrawing(), (A = B.dependencyTracker) == null || A.restore(), H.restore(), x || V) {
      const E = j.canvas;
      x && (N = c), V && (W = u);
      const ct = this.getSizeAndScale(N, this.ctx.canvas.width, T), at = this.getSizeAndScale(W, this.ctx.canvas.height, M), dt = ct.size, gt = at.size, Wt = t.cachedCanvases.getCanvas("pattern-workaround", dt, gt), Zt = Wt.context, Gt = x ? Math.floor(b / c) : 0, Tt = V ? Math.floor(y / u) : 0;
      for (let Q = 0; Q <= Gt; Q++)
        for (let D = 0; D <= Tt; D++)
          Zt.drawImage(E, dt * Q, gt * D, dt, gt, 0, 0, dt, gt);
      return {
        canvas: Wt.canvas,
        scaleX: ct.scale,
        scaleY: at.scale,
        offsetX: d,
        offsetY: h
      };
    }
    return {
      canvas: j.canvas,
      scaleX: F.scale,
      scaleY: P.scale,
      offsetX: d,
      offsetY: h
    };
  }
  getSizeAndScale(t, e, n) {
    const s = Math.max(mG.MAX_PATTERN_SIZE, e);
    let r = Math.ceil(t * n);
    return r >= s ? r = s : n = r / t, {
      scale: n,
      size: r
    };
  }
  clipBbox(t, e, n, s, r) {
    const a = s - e, o = r - n;
    t.ctx.rect(e, n, a, o), ze.axialAlignedBoundingBox([e, n, s, r], ns(t.ctx), t.current.minMax), t.clip(), t.endPath();
  }
  setFillAndStrokeStyleToContext(t, e, n) {
    const s = t.ctx, r = t.current;
    switch (e) {
      case YE.COLORED:
        const {
          fillStyle: a,
          strokeStyle: o
        } = this.ctx;
        s.fillStyle = r.fillColor = a, s.strokeStyle = r.strokeColor = o;
        break;
      case YE.UNCOLORED:
        s.fillStyle = s.strokeStyle = n, r.fillColor = r.strokeColor = n;
        break;
      default:
        throw new tIt(`Unsupported paint type: ${e}`);
    }
  }
  isModifyingCurrentTransform() {
    return !1;
  }
  getPattern(t, e, n, s, r) {
    let a = n;
    s !== Xr.SHADING && (a = ze.transform(a, e.baseTransform), this.matrix && (a = ze.transform(a, this.matrix)));
    const o = this.createPatternCanvas(e, r);
    let l = new DOMMatrix(a);
    l = l.translate(o.offsetX, o.offsetY), l = l.scale(1 / o.scaleX, 1 / o.scaleY);
    const c = t.createPattern(o.canvas, "repeat");
    return c.setTransform(l), c;
  }
};
S(mG, "MAX_PATTERN_SIZE", 3e3);
let UV = mG;
function jIt({
  src: i,
  srcPos: t = 0,
  dest: e,
  width: n,
  height: s,
  nonBlackColor: r = 4294967295,
  inverseDecode: a = !1
}) {
  const o = Er.isLittleEndian ? 4278190080 : 255, [l, c] = a ? [r, o] : [o, r], u = n >> 3, d = n & 7, h = i.length;
  e = new Uint32Array(e.buffer);
  let p = 0;
  for (let m = 0; m < s; m++) {
    for (const y = t + u; t < y; t++) {
      const Z = t < h ? i[t] : 255;
      e[p++] = Z & 128 ? c : l, e[p++] = Z & 64 ? c : l, e[p++] = Z & 32 ? c : l, e[p++] = Z & 16 ? c : l, e[p++] = Z & 8 ? c : l, e[p++] = Z & 4 ? c : l, e[p++] = Z & 2 ? c : l, e[p++] = Z & 1 ? c : l;
    }
    if (d === 0)
      continue;
    const b = t < h ? i[t++] : 255;
    for (let y = 0; y < d; y++)
      e[p++] = b & 1 << 7 - y ? c : l;
  }
  return {
    srcPos: t,
    destPos: p
  };
}
const vE = 16, RE = 100, UIt = 15, DE = 10, ka = 16, OS = new DOMMatrix(), yo = new Float32Array(2), Gb = new Float32Array([1 / 0, 1 / 0, -1 / 0, -1 / 0]);
function PIt(i, t) {
  if (i._removeMirroring)
    throw new Error("Context is already forwarding operations.");
  i.__originalSave = i.save, i.__originalRestore = i.restore, i.__originalRotate = i.rotate, i.__originalScale = i.scale, i.__originalTranslate = i.translate, i.__originalTransform = i.transform, i.__originalSetTransform = i.setTransform, i.__originalResetTransform = i.resetTransform, i.__originalClip = i.clip, i.__originalMoveTo = i.moveTo, i.__originalLineTo = i.lineTo, i.__originalBezierCurveTo = i.bezierCurveTo, i.__originalRect = i.rect, i.__originalClosePath = i.closePath, i.__originalBeginPath = i.beginPath, i._removeMirroring = () => {
    i.save = i.__originalSave, i.restore = i.__originalRestore, i.rotate = i.__originalRotate, i.scale = i.__originalScale, i.translate = i.__originalTranslate, i.transform = i.__originalTransform, i.setTransform = i.__originalSetTransform, i.resetTransform = i.__originalResetTransform, i.clip = i.__originalClip, i.moveTo = i.__originalMoveTo, i.lineTo = i.__originalLineTo, i.bezierCurveTo = i.__originalBezierCurveTo, i.rect = i.__originalRect, i.closePath = i.__originalClosePath, i.beginPath = i.__originalBeginPath, delete i._removeMirroring;
  }, i.save = function() {
    t.save(), this.__originalSave();
  }, i.restore = function() {
    t.restore(), this.__originalRestore();
  }, i.translate = function(e, n) {
    t.translate(e, n), this.__originalTranslate(e, n);
  }, i.scale = function(e, n) {
    t.scale(e, n), this.__originalScale(e, n);
  }, i.transform = function(e, n, s, r, a, o) {
    t.transform(e, n, s, r, a, o), this.__originalTransform(e, n, s, r, a, o);
  }, i.setTransform = function(e, n, s, r, a, o) {
    t.setTransform(e, n, s, r, a, o), this.__originalSetTransform(e, n, s, r, a, o);
  }, i.resetTransform = function() {
    t.resetTransform(), this.__originalResetTransform();
  }, i.rotate = function(e) {
    t.rotate(e), this.__originalRotate(e);
  }, i.clip = function(e) {
    t.clip(e), this.__originalClip(e);
  }, i.moveTo = function(e, n) {
    t.moveTo(e, n), this.__originalMoveTo(e, n);
  }, i.lineTo = function(e, n) {
    t.lineTo(e, n), this.__originalLineTo(e, n);
  }, i.bezierCurveTo = function(e, n, s, r, a, o) {
    t.bezierCurveTo(e, n, s, r, a, o), this.__originalBezierCurveTo(e, n, s, r, a, o);
  }, i.rect = function(e, n, s, r) {
    t.rect(e, n, s, r), this.__originalRect(e, n, s, r);
  }, i.closePath = function() {
    t.closePath(), this.__originalClosePath();
  }, i.beginPath = function() {
    t.beginPath(), this.__originalBeginPath();
  };
}
class JIt {
  constructor(t) {
    this.canvasFactory = t, this.cache = /* @__PURE__ */ Object.create(null);
  }
  getCanvas(t, e, n) {
    let s;
    return this.cache[t] !== void 0 ? (s = this.cache[t], this.canvasFactory.reset(s, e, n)) : (s = this.canvasFactory.create(e, n), this.cache[t] = s), s;
  }
  delete(t) {
    delete this.cache[t];
  }
  clear() {
    for (const t in this.cache) {
      const e = this.cache[t];
      this.canvasFactory.destroy(e), delete this.cache[t];
    }
  }
}
function jM(i, t, e, n, s, r, a, o, l, c) {
  const [u, d, h, p, m, b] = ns(i);
  if (d === 0 && h === 0) {
    const g = a * u + m, f = Math.round(g), T = o * p + b, M = Math.round(T), N = (a + l) * u + m, W = Math.abs(Math.round(N) - f) || 1, x = (o + c) * p + b, V = Math.abs(Math.round(x) - M) || 1;
    return i.setTransform(Math.sign(u), 0, 0, Math.sign(p), f, M), i.drawImage(t, e, n, s, r, 0, 0, W, V), i.setTransform(u, d, h, p, m, b), [W, V];
  }
  if (u === 0 && p === 0) {
    const g = o * h + m, f = Math.round(g), T = a * d + b, M = Math.round(T), N = (o + c) * h + m, W = Math.abs(Math.round(N) - f) || 1, x = (a + l) * d + b, V = Math.abs(Math.round(x) - M) || 1;
    return i.setTransform(0, Math.sign(d), Math.sign(h), 0, f, M), i.drawImage(t, e, n, s, r, 0, 0, V, W), i.setTransform(u, d, h, p, m, b), [V, W];
  }
  i.drawImage(t, e, n, s, r, a, o, l, c);
  const y = Math.hypot(u, d), Z = Math.hypot(h, p);
  return [y * l, Z * c];
}
class OE {
  constructor(t, e, n) {
    S(this, "alphaIsShape", !1);
    S(this, "fontSize", 0);
    S(this, "fontSizeScale", 1);
    S(this, "textMatrix", null);
    S(this, "textMatrixScale", 1);
    S(this, "fontMatrix", pV);
    S(this, "leading", 0);
    S(this, "x", 0);
    S(this, "y", 0);
    S(this, "lineX", 0);
    S(this, "lineY", 0);
    S(this, "charSpacing", 0);
    S(this, "wordSpacing", 0);
    S(this, "textHScale", 1);
    S(this, "textRenderingMode", Tr.FILL);
    S(this, "textRise", 0);
    S(this, "fillColor", "#000000");
    S(this, "strokeColor", "#000000");
    S(this, "patternFill", !1);
    S(this, "patternStroke", !1);
    S(this, "fillAlpha", 1);
    S(this, "strokeAlpha", 1);
    S(this, "lineWidth", 1);
    S(this, "activeSMask", null);
    S(this, "transferMaps", "none");
    n == null || n(this), this.clipBox = new Float32Array([0, 0, t, e]), this.minMax = Gb.slice();
  }
  clone() {
    const t = Object.create(this);
    return t.clipBox = this.clipBox.slice(), t.minMax = this.minMax.slice(), t;
  }
  getPathBoundingBox(t = Xr.FILL, e = null) {
    const n = this.minMax.slice();
    if (t === Xr.STROKE) {
      e || Xi("Stroke bounding box must include transform."), ze.singularValueDecompose2dScale(e, yo);
      const s = yo[0] * this.lineWidth / 2, r = yo[1] * this.lineWidth / 2;
      n[0] -= s, n[1] -= r, n[2] += s, n[3] += r;
    }
    return n;
  }
  updateClipFromPath() {
    const t = ze.intersect(this.clipBox, this.getPathBoundingBox());
    this.startNewPathAndClipBox(t || [0, 0, 0, 0]);
  }
  isEmptyClip() {
    return this.minMax[0] === 1 / 0;
  }
  startNewPathAndClipBox(t) {
    this.clipBox.set(t, 0), this.minMax.set(Gb, 0);
  }
  getClippedPathBoundingBox(t = Xr.FILL, e = null) {
    return ze.intersect(this.clipBox, this.getPathBoundingBox(t, e));
  }
}
function zE(i, t) {
  if (t instanceof ImageData) {
    i.putImageData(t, 0, 0);
    return;
  }
  const e = t.height, n = t.width, s = e % ka, r = (e - s) / ka, a = s === 0 ? r : r + 1, o = i.createImageData(n, ka);
  let l = 0, c;
  const u = t.data, d = o.data;
  let h, p, m, b;
  if (t.kind === WN.GRAYSCALE_1BPP) {
    const y = u.byteLength, Z = new Uint32Array(d.buffer, 0, d.byteLength >> 2), g = Z.length, f = n + 7 >> 3, T = 4294967295, M = Er.isLittleEndian ? 4278190080 : 255;
    for (h = 0; h < a; h++) {
      for (m = h < r ? ka : s, c = 0, p = 0; p < m; p++) {
        const N = y - l;
        let W = 0;
        const x = N > f ? n : N * 8 - 7, V = x & -8;
        let X = 0, C = 0;
        for (; W < V; W += 8)
          C = u[l++], Z[c++] = C & 128 ? T : M, Z[c++] = C & 64 ? T : M, Z[c++] = C & 32 ? T : M, Z[c++] = C & 16 ? T : M, Z[c++] = C & 8 ? T : M, Z[c++] = C & 4 ? T : M, Z[c++] = C & 2 ? T : M, Z[c++] = C & 1 ? T : M;
        for (; W < x; W++)
          X === 0 && (C = u[l++], X = 128), Z[c++] = C & X ? T : M, X >>= 1;
      }
      for (; c < g; )
        Z[c++] = 0;
      i.putImageData(o, 0, h * ka);
    }
  } else if (t.kind === WN.RGBA_32BPP) {
    for (p = 0, b = n * ka * 4, h = 0; h < r; h++)
      d.set(u.subarray(l, l + b)), l += b, i.putImageData(o, 0, p), p += ka;
    h < a && (b = n * s * 4, d.set(u.subarray(l, l + b)), i.putImageData(o, 0, p));
  } else if (t.kind === WN.RGB_24BPP)
    for (m = ka, b = n * m, h = 0; h < a; h++) {
      for (h >= r && (m = s, b = n * m), c = 0, p = b; p--; )
        d[c++] = u[l++], d[c++] = u[l++], d[c++] = u[l++], d[c++] = 255;
      i.putImageData(o, 0, h * ka);
    }
  else
    throw new Error(`bad image kind: ${t.kind}`);
}
function EE(i, t) {
  if (t.bitmap) {
    i.drawImage(t.bitmap, 0, 0);
    return;
  }
  const e = t.height, n = t.width, s = e % ka, r = (e - s) / ka, a = s === 0 ? r : r + 1, o = i.createImageData(n, ka);
  let l = 0;
  const c = t.data, u = o.data;
  for (let d = 0; d < a; d++) {
    const h = d < r ? ka : s;
    ({
      srcPos: l
    } = jIt({
      src: c,
      srcPos: l,
      dest: u,
      width: n,
      height: h,
      nonBlackColor: 0
    })), i.putImageData(o, 0, d * ka);
  }
}
function uy(i, t) {
  const e = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font", "filter"];
  for (const n of e)
    i[n] !== void 0 && (t[n] = i[n]);
  i.setLineDash !== void 0 && (t.setLineDash(i.getLineDash()), t.lineDashOffset = i.lineDashOffset);
}
function UM(i) {
  i.strokeStyle = i.fillStyle = "#000000", i.fillRule = "nonzero", i.globalAlpha = 1, i.lineWidth = 1, i.lineCap = "butt", i.lineJoin = "miter", i.miterLimit = 10, i.globalCompositeOperation = "source-over", i.font = "10px sans-serif", i.setLineDash !== void 0 && (i.setLineDash([]), i.lineDashOffset = 0);
  const {
    filter: t
  } = i;
  t !== "none" && t !== "" && (i.filter = "none");
}
function kE(i, t) {
  if (t)
    return !0;
  ze.singularValueDecompose2dScale(i, yo);
  const e = Math.fround(Uc.pixelRatio * qh.PDF_TO_CSS_UNITS);
  return yo[0] <= e && yo[1] <= e;
}
const AIt = ["butt", "round", "square"], BIt = ["miter", "round", "bevel"], KIt = {}, FE = {};
var Fl, PV, JV, AV;
const pY = class pY {
  constructor(t, e, n, s, r, {
    optionalContentConfig: a,
    markedContentStack: o = null
  }, l, c, u) {
    pt(this, Fl);
    this.ctx = t, this.current = new OE(this.ctx.canvas.width, this.ctx.canvas.height), this.stateStack = [], this.pendingClip = null, this.pendingEOFill = !1, this.res = null, this.xobjs = null, this.commonObjs = e, this.objs = n, this.canvasFactory = s, this.filterFactory = r, this.groupStack = [], this.baseTransform = null, this.baseTransformStack = [], this.groupLevel = 0, this.smaskStack = [], this.smaskCounter = 0, this.tempSMask = null, this.suspendedCtx = null, this.contentVisible = !0, this.markedContentStack = o || [], this.optionalContentConfig = a, this.cachedCanvases = new JIt(this.canvasFactory), this.cachedPatterns = /* @__PURE__ */ new Map(), this.annotationCanvasMap = l, this.viewportScale = 1, this.outputScaleX = 1, this.outputScaleY = 1, this.pageColors = c, this._cachedScaleForStroking = [-1, 0], this._cachedGetSinglePixelWidth = null, this._cachedBitmapsMap = /* @__PURE__ */ new Map(), this.dependencyTracker = u ?? null;
  }
  getObject(t, e, n = null) {
    var s;
    return typeof e == "string" ? ((s = this.dependencyTracker) == null || s.recordNamedDependency(t, e), e.startsWith("g_") ? this.commonObjs.get(e) : this.objs.get(e)) : n;
  }
  beginDrawing({
    transform: t,
    viewport: e,
    transparency: n = !1,
    background: s = null
  }) {
    const r = this.ctx.canvas.width, a = this.ctx.canvas.height, o = this.ctx.fillStyle;
    if (this.ctx.fillStyle = s || "#ffffff", this.ctx.fillRect(0, 0, r, a), this.ctx.fillStyle = o, n) {
      const l = this.cachedCanvases.getCanvas("transparent", r, a);
      this.compositeCtx = this.ctx, this.transparentCanvas = l.canvas, this.ctx = l.context, this.ctx.save(), this.ctx.transform(...ns(this.compositeCtx));
    }
    this.ctx.save(), UM(this.ctx), t && (this.ctx.transform(...t), this.outputScaleX = t[0], this.outputScaleY = t[0]), this.ctx.transform(...e.transform), this.viewportScale = e.scale, this.baseTransform = ns(this.ctx);
  }
  executeOperatorList(t, e, n, s, r) {
    var Z;
    const a = t.argsArray, o = t.fnArray;
    let l = e || 0;
    const c = a.length;
    if (c === l)
      return l;
    const u = c - l > DE && typeof n == "function", d = u ? Date.now() + UIt : 0;
    let h = 0;
    const p = this.commonObjs, m = this.objs;
    let b, y;
    for (; ; ) {
      if (s !== void 0 && l === s.nextBreakPoint)
        return s.breakIt(l, n), l;
      if (!r || r(l))
        if (b = o[l], y = a[l] ?? null, b !== E2.dependency)
          y === null ? this[b](l) : this[b](l, ...y);
        else
          for (const g of y) {
            (Z = this.dependencyTracker) == null || Z.recordNamedData(g, l);
            const f = g.startsWith("g_") ? p : m;
            if (!f.has(g))
              return f.get(g, n), l;
          }
      if (l++, l === c)
        return l;
      if (u && ++h > DE) {
        if (Date.now() > d)
          return n(), l;
        h = 0;
      }
    }
  }
  endDrawing() {
    ft(this, Fl, PV).call(this), this.cachedCanvases.clear(), this.cachedPatterns.clear();
    for (const t of this._cachedBitmapsMap.values()) {
      for (const e of t.values())
        typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement && (e.width = e.height = 0);
      t.clear();
    }
    this._cachedBitmapsMap.clear(), ft(this, Fl, JV).call(this);
  }
  _scaleImage(t, e) {
    const n = t.width ?? t.displayWidth, s = t.height ?? t.displayHeight;
    let r = Math.max(Math.hypot(e[0], e[1]), 1), a = Math.max(Math.hypot(e[2], e[3]), 1), o = n, l = s, c = "prescale1", u, d;
    for (; r > 2 && o > 1 || a > 2 && l > 1; ) {
      let h = o, p = l;
      r > 2 && o > 1 && (h = o >= 16384 ? Math.floor(o / 2) - 1 || 1 : Math.ceil(o / 2), r /= o / h), a > 2 && l > 1 && (p = l >= 16384 ? Math.floor(l / 2) - 1 || 1 : Math.ceil(l) / 2, a /= l / p), u = this.cachedCanvases.getCanvas(c, h, p), d = u.context, d.clearRect(0, 0, h, p), d.drawImage(t, 0, 0, o, l, 0, 0, h, p), t = u.canvas, o = h, l = p, c = c === "prescale1" ? "prescale2" : "prescale1";
    }
    return {
      img: t,
      paintWidth: o,
      paintHeight: l
    };
  }
  _createMaskCanvas(t, e) {
    var X, C;
    const n = this.ctx, {
      width: s,
      height: r
    } = e, a = this.current.fillColor, o = this.current.patternFill, l = ns(n);
    let c, u, d, h;
    if ((e.bitmap || e.data) && e.count > 1) {
      const R = e.bitmap || e.data.buffer;
      u = JSON.stringify(o ? l : [l.slice(0, 4), a]), c = this._cachedBitmapsMap.get(R), c || (c = /* @__PURE__ */ new Map(), this._cachedBitmapsMap.set(R, c));
      const z = c.get(u);
      if (z && !o) {
        const F = Math.round(Math.min(l[0], l[2]) + l[4]), P = Math.round(Math.min(l[1], l[3]) + l[5]);
        return (X = this.dependencyTracker) == null || X.recordDependencies(t, Oo.transformAndFill), {
          canvas: z,
          offsetX: F,
          offsetY: P
        };
      }
      d = z;
    }
    d || (h = this.cachedCanvases.getCanvas("maskCanvas", s, r), EE(h.context, e));
    let p = ze.transform(l, [1 / s, 0, 0, -1 / r, 0, 0]);
    p = ze.transform(p, [1, 0, 0, 1, 0, -r]);
    const m = Gb.slice();
    ze.axialAlignedBoundingBox([0, 0, s, r], p, m);
    const [b, y, Z, g] = m, f = Math.round(Z - b) || 1, T = Math.round(g - y) || 1, M = this.cachedCanvases.getCanvas("fillCanvas", f, T), N = M.context, W = b, x = y;
    N.translate(-W, -x), N.transform(...p), d || (d = this._scaleImage(h.canvas, nc(N)), d = d.img, c && o && c.set(u, d)), N.imageSmoothingEnabled = kE(ns(N), e.interpolate), jM(N, d, 0, 0, d.width, d.height, 0, 0, s, r), N.globalCompositeOperation = "source-in";
    const V = ze.transform(nc(N), [1, 0, 0, 1, -W, -x]);
    return N.fillStyle = o ? a.getPattern(n, this, V, Xr.FILL, t) : a, N.fillRect(0, 0, s, r), c && !o && (this.cachedCanvases.delete("fillCanvas"), c.set(u, M.canvas)), (C = this.dependencyTracker) == null || C.recordDependencies(t, Oo.transformAndFill), {
      canvas: M.canvas,
      offsetX: Math.round(W),
      offsetY: Math.round(x)
    };
  }
  setLineWidth(t, e) {
    var n;
    (n = this.dependencyTracker) == null || n.recordSimpleData("lineWidth", t), e !== this.current.lineWidth && (this._cachedScaleForStroking[0] = -1), this.current.lineWidth = e, this.ctx.lineWidth = e;
  }
  setLineCap(t, e) {
    var n;
    (n = this.dependencyTracker) == null || n.recordSimpleData("lineCap", t), this.ctx.lineCap = AIt[e];
  }
  setLineJoin(t, e) {
    var n;
    (n = this.dependencyTracker) == null || n.recordSimpleData("lineJoin", t), this.ctx.lineJoin = BIt[e];
  }
  setMiterLimit(t, e) {
    var n;
    (n = this.dependencyTracker) == null || n.recordSimpleData("miterLimit", t), this.ctx.miterLimit = e;
  }
  setDash(t, e, n) {
    var r;
    (r = this.dependencyTracker) == null || r.recordSimpleData("dash", t);
    const s = this.ctx;
    s.setLineDash !== void 0 && (s.setLineDash(e), s.lineDashOffset = n);
  }
  setRenderingIntent(t, e) {
  }
  setFlatness(t, e) {
  }
  setGState(t, e) {
    var n, s, r, a, o;
    for (const [l, c] of e)
      switch (l) {
        case "LW":
          this.setLineWidth(t, c);
          break;
        case "LC":
          this.setLineCap(t, c);
          break;
        case "LJ":
          this.setLineJoin(t, c);
          break;
        case "ML":
          this.setMiterLimit(t, c);
          break;
        case "D":
          this.setDash(t, c[0], c[1]);
          break;
        case "RI":
          this.setRenderingIntent(t, c);
          break;
        case "FL":
          this.setFlatness(t, c);
          break;
        case "Font":
          this.setFont(t, c[0], c[1]);
          break;
        case "CA":
          (n = this.dependencyTracker) == null || n.recordSimpleData("strokeAlpha", t), this.current.strokeAlpha = c;
          break;
        case "ca":
          (s = this.dependencyTracker) == null || s.recordSimpleData("fillAlpha", t), this.ctx.globalAlpha = this.current.fillAlpha = c;
          break;
        case "BM":
          (r = this.dependencyTracker) == null || r.recordSimpleData("globalCompositeOperation", t), this.ctx.globalCompositeOperation = c;
          break;
        case "SMask":
          (a = this.dependencyTracker) == null || a.recordSimpleData("SMask", t), this.current.activeSMask = c ? this.tempSMask : null, this.tempSMask = null, this.checkSMaskState();
          break;
        case "TR":
          (o = this.dependencyTracker) == null || o.recordSimpleData("filter", t), this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(c);
          break;
      }
  }
  get inSMaskMode() {
    return !!this.suspendedCtx;
  }
  checkSMaskState() {
    const t = this.inSMaskMode;
    this.current.activeSMask && !t ? this.beginSMaskMode() : !this.current.activeSMask && t && this.endSMaskMode();
  }
  beginSMaskMode(t) {
    if (this.inSMaskMode)
      throw new Error("beginSMaskMode called while already in smask mode");
    const e = this.ctx.canvas.width, n = this.ctx.canvas.height, s = "smaskGroupAt" + this.groupLevel, r = this.cachedCanvases.getCanvas(s, e, n);
    this.suspendedCtx = this.ctx;
    const a = this.ctx = r.context;
    a.setTransform(this.suspendedCtx.getTransform()), uy(this.suspendedCtx, a), PIt(a, this.suspendedCtx), this.setGState(t, [["BM", "source-over"]]);
  }
  endSMaskMode() {
    if (!this.inSMaskMode)
      throw new Error("endSMaskMode called while not in smask mode");
    this.ctx._removeMirroring(), uy(this.ctx, this.suspendedCtx), this.ctx = this.suspendedCtx, this.suspendedCtx = null;
  }
  compose(t) {
    if (!this.current.activeSMask)
      return;
    t ? (t[0] = Math.floor(t[0]), t[1] = Math.floor(t[1]), t[2] = Math.ceil(t[2]), t[3] = Math.ceil(t[3])) : t = [0, 0, this.ctx.canvas.width, this.ctx.canvas.height];
    const e = this.current.activeSMask, n = this.suspendedCtx;
    this.composeSMask(n, e, this.ctx, t), this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height), this.ctx.restore();
  }
  composeSMask(t, e, n, s) {
    const r = s[0], a = s[1], o = s[2] - r, l = s[3] - a;
    o === 0 || l === 0 || (this.genericComposeSMask(e.context, n, o, l, e.subtype, e.backdrop, e.transferMap, r, a, e.offsetX, e.offsetY), t.save(), t.globalAlpha = 1, t.globalCompositeOperation = "source-over", t.setTransform(1, 0, 0, 1, 0, 0), t.drawImage(n.canvas, 0, 0), t.restore());
  }
  genericComposeSMask(t, e, n, s, r, a, o, l, c, u, d) {
    let h = t.canvas, p = l - u, m = c - d;
    if (a)
      if (p < 0 || m < 0 || p + n > h.width || m + s > h.height) {
        const y = this.cachedCanvases.getCanvas("maskExtension", n, s), Z = y.context;
        Z.drawImage(h, -p, -m), Z.globalCompositeOperation = "destination-atop", Z.fillStyle = a, Z.fillRect(0, 0, n, s), Z.globalCompositeOperation = "source-over", h = y.canvas, p = m = 0;
      } else {
        t.save(), t.globalAlpha = 1, t.setTransform(1, 0, 0, 1, 0, 0);
        const y = new Path2D();
        y.rect(p, m, n, s), t.clip(y), t.globalCompositeOperation = "destination-atop", t.fillStyle = a, t.fillRect(p, m, n, s), t.restore();
      }
    e.save(), e.globalAlpha = 1, e.setTransform(1, 0, 0, 1, 0, 0), r === "Alpha" && o ? e.filter = this.filterFactory.addAlphaFilter(o) : r === "Luminosity" && (e.filter = this.filterFactory.addLuminosityFilter(o));
    const b = new Path2D();
    b.rect(l, c, n, s), e.clip(b), e.globalCompositeOperation = "destination-in", e.drawImage(h, p, m, n, s, l, c, n, s), e.restore();
  }
  save(t) {
    var n;
    this.inSMaskMode && uy(this.ctx, this.suspendedCtx), this.ctx.save();
    const e = this.current;
    this.stateStack.push(e), this.current = e.clone(), (n = this.dependencyTracker) == null || n.save(t);
  }
  restore(t) {
    var e;
    if ((e = this.dependencyTracker) == null || e.restore(t), this.stateStack.length === 0) {
      this.inSMaskMode && this.endSMaskMode();
      return;
    }
    this.current = this.stateStack.pop(), this.ctx.restore(), this.inSMaskMode && uy(this.suspendedCtx, this.ctx), this.checkSMaskState(), this.pendingClip = null, this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null;
  }
  transform(t, e, n, s, r, a, o) {
    var l;
    (l = this.dependencyTracker) == null || l.recordIncrementalData("transform", t), this.ctx.transform(e, n, s, r, a, o), this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null;
  }
  constructPath(t, e, n, s) {
    let [r] = n;
    if (!s) {
      r || (r = n[0] = new Path2D()), this[e](t, r);
      return;
    }
    if (this.dependencyTracker !== null) {
      const a = e === E2.stroke ? this.current.lineWidth / 2 : 0;
      this.dependencyTracker.resetBBox(t).recordBBox(t, this.ctx, s[0] - a, s[2] + a, s[1] - a, s[3] + a).recordDependencies(t, ["transform"]);
    }
    if (!(r instanceof Path2D)) {
      const a = n[0] = new Path2D();
      for (let o = 0, l = r.length; o < l; )
        switch (r[o++]) {
          case DM.moveTo:
            a.moveTo(r[o++], r[o++]);
            break;
          case DM.lineTo:
            a.lineTo(r[o++], r[o++]);
            break;
          case DM.curveTo:
            a.bezierCurveTo(r[o++], r[o++], r[o++], r[o++], r[o++], r[o++]);
            break;
          case DM.closePath:
            a.closePath();
            break;
          default:
            pn(`Unrecognized drawing path operator: ${r[o - 1]}`);
            break;
        }
      r = a;
    }
    ze.axialAlignedBoundingBox(s, ns(this.ctx), this.current.minMax), this[e](t, r), this._pathStartIdx = t;
  }
  closePath(t) {
    this.ctx.closePath();
  }
  stroke(t, e, n = !0) {
    var a;
    const s = this.ctx, r = this.current.strokeColor;
    if (s.globalAlpha = this.current.strokeAlpha, this.contentVisible)
      if (typeof r == "object" && (r != null && r.getPattern)) {
        const o = r.isModifyingCurrentTransform() ? s.getTransform() : null;
        if (s.save(), s.strokeStyle = r.getPattern(s, this, nc(s), Xr.STROKE, t), o) {
          const l = new Path2D();
          l.addPath(e, s.getTransform().invertSelf().multiplySelf(o)), e = l;
        }
        this.rescaleAndStroke(e, !1), s.restore();
      } else
        this.rescaleAndStroke(e, !0);
    (a = this.dependencyTracker) == null || a.recordDependencies(t, Oo.stroke), n && this.consumePath(t, e, this.current.getClippedPathBoundingBox(Xr.STROKE, ns(this.ctx))), s.globalAlpha = this.current.fillAlpha;
  }
  closeStroke(t, e) {
    this.stroke(t, e);
  }
  fill(t, e, n = !0) {
    var c, u, d;
    const s = this.ctx, r = this.current.fillColor, a = this.current.patternFill;
    let o = !1;
    if (a) {
      const h = r.isModifyingCurrentTransform() ? s.getTransform() : null;
      if ((c = this.dependencyTracker) == null || c.save(t), s.save(), s.fillStyle = r.getPattern(s, this, nc(s), Xr.FILL, t), h) {
        const p = new Path2D();
        p.addPath(e, s.getTransform().invertSelf().multiplySelf(h)), e = p;
      }
      o = !0;
    }
    const l = this.current.getClippedPathBoundingBox();
    this.contentVisible && l !== null && (this.pendingEOFill ? (s.fill(e, "evenodd"), this.pendingEOFill = !1) : s.fill(e)), (u = this.dependencyTracker) == null || u.recordDependencies(t, Oo.fill), o && (s.restore(), (d = this.dependencyTracker) == null || d.restore(t)), n && this.consumePath(t, e, l);
  }
  eoFill(t, e) {
    this.pendingEOFill = !0, this.fill(t, e);
  }
  fillStroke(t, e) {
    this.fill(t, e, !1), this.stroke(t, e, !1), this.consumePath(t, e);
  }
  eoFillStroke(t, e) {
    this.pendingEOFill = !0, this.fillStroke(t, e);
  }
  closeFillStroke(t, e) {
    this.fillStroke(t, e);
  }
  closeEOFillStroke(t, e) {
    this.pendingEOFill = !0, this.fillStroke(t, e);
  }
  endPath(t, e) {
    this.consumePath(t, e);
  }
  rawFillPath(t, e) {
    var n;
    this.ctx.fill(e), (n = this.dependencyTracker) == null || n.recordDependencies(t, Oo.rawFillPath).recordOperation(t);
  }
  clip(t) {
    var e;
    (e = this.dependencyTracker) == null || e.recordFutureForcedDependency("clipMode", t), this.pendingClip = KIt;
  }
  eoClip(t) {
    var e;
    (e = this.dependencyTracker) == null || e.recordFutureForcedDependency("clipMode", t), this.pendingClip = FE;
  }
  beginText(t) {
    var e;
    this.current.textMatrix = null, this.current.textMatrixScale = 1, this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0, (e = this.dependencyTracker) == null || e.recordOpenMarker(t).resetIncrementalData("sameLineText").resetIncrementalData("moveText", t);
  }
  endText(t) {
    const e = this.pendingTextPaths, n = this.ctx;
    if (this.dependencyTracker) {
      const {
        dependencyTracker: s
      } = this;
      e !== void 0 && s.recordFutureForcedDependency("textClip", s.getOpenMarker()).recordFutureForcedDependency("textClip", t), s.recordCloseMarker(t);
    }
    if (e !== void 0) {
      const s = new Path2D(), r = n.getTransform().invertSelf();
      for (const {
        transform: a,
        x: o,
        y: l,
        fontSize: c,
        path: u
      } of e)
        u && s.addPath(u, new DOMMatrix(a).preMultiplySelf(r).translate(o, l).scale(c, -c));
      n.clip(s);
    }
    delete this.pendingTextPaths;
  }
  setCharSpacing(t, e) {
    var n;
    (n = this.dependencyTracker) == null || n.recordSimpleData("charSpacing", t), this.current.charSpacing = e;
  }
  setWordSpacing(t, e) {
    var n;
    (n = this.dependencyTracker) == null || n.recordSimpleData("wordSpacing", t), this.current.wordSpacing = e;
  }
  setHScale(t, e) {
    var n;
    (n = this.dependencyTracker) == null || n.recordSimpleData("hScale", t), this.current.textHScale = e / 100;
  }
  setLeading(t, e) {
    var n;
    (n = this.dependencyTracker) == null || n.recordSimpleData("leading", t), this.current.leading = -e;
  }
  setFont(t, e, n) {
    var d, h;
    (d = this.dependencyTracker) == null || d.recordSimpleData("font", t).recordSimpleDataFromNamed("fontObj", e, t);
    const s = this.commonObjs.get(e), r = this.current;
    if (!s)
      throw new Error(`Can't find font for ${e}`);
    if (r.fontMatrix = s.fontMatrix || pV, (r.fontMatrix[0] === 0 || r.fontMatrix[3] === 0) && pn("Invalid font matrix for font " + e), n < 0 ? (n = -n, r.fontDirection = -1) : r.fontDirection = 1, this.current.font = s, this.current.fontSize = n, s.isType3Font)
      return;
    const a = s.loadedName || "sans-serif", o = ((h = s.systemFontInfo) == null ? void 0 : h.css) || `"${a}", ${s.fallbackName}`;
    let l = "normal";
    s.black ? l = "900" : s.bold && (l = "bold");
    const c = s.italic ? "italic" : "normal";
    let u = n;
    n < vE ? u = vE : n > RE && (u = RE), this.current.fontSizeScale = n / u, this.ctx.font = `${c} ${l} ${u}px ${o}`;
  }
  setTextRenderingMode(t, e) {
    var n;
    (n = this.dependencyTracker) == null || n.recordSimpleData("textRenderingMode", t), this.current.textRenderingMode = e;
  }
  setTextRise(t, e) {
    var n;
    (n = this.dependencyTracker) == null || n.recordSimpleData("textRise", t), this.current.textRise = e;
  }
  moveText(t, e, n) {
    var s;
    (s = this.dependencyTracker) == null || s.resetIncrementalData("sameLineText").recordIncrementalData("moveText", t), this.current.x = this.current.lineX += e, this.current.y = this.current.lineY += n;
  }
  setLeadingMoveText(t, e, n) {
    this.setLeading(t, -n), this.moveText(t, e, n);
  }
  setTextMatrix(t, e) {
    var s;
    (s = this.dependencyTracker) == null || s.recordSimpleData("textMatrix", t);
    const {
      current: n
    } = this;
    n.textMatrix = e, n.textMatrixScale = Math.hypot(e[0], e[1]), n.x = n.lineX = 0, n.y = n.lineY = 0;
  }
  nextLine(t) {
    var e;
    this.moveText(t, 0, this.current.leading), (e = this.dependencyTracker) == null || e.recordIncrementalData("moveText", this.dependencyTracker.getSimpleIndex("leading") ?? t);
  }
  paintChar(t, e, n, s, r, a) {
    var Z, g, f, T;
    const o = this.ctx, l = this.current, c = l.font, u = l.textRenderingMode, d = l.fontSize / l.fontSizeScale, h = u & Tr.FILL_STROKE_MASK, p = !!(u & Tr.ADD_TO_PATH_FLAG), m = l.patternFill && !c.missingFile, b = l.patternStroke && !c.missingFile;
    let y;
    if ((c.disableFontFace || p || m || b) && !c.missingFile && (y = c.getPathGenerator(this.commonObjs, e)), y && (c.disableFontFace || m || b)) {
      o.save(), o.translate(n, s), o.scale(d, -d), (Z = this.dependencyTracker) == null || Z.recordCharacterBBox(t, o, c);
      let M;
      if (h === Tr.FILL || h === Tr.FILL_STROKE)
        if (r) {
          M = o.getTransform(), o.setTransform(...r);
          const N = ft(this, Fl, AV).call(this, y, M, r);
          o.fill(N);
        } else
          o.fill(y);
      if (h === Tr.STROKE || h === Tr.FILL_STROKE)
        if (a) {
          M || (M = o.getTransform()), o.setTransform(...a);
          const {
            a: N,
            b: W,
            c: x,
            d: V
          } = M, X = ze.inverseTransform(a), C = ze.transform([N, W, x, V, 0, 0], X);
          ze.singularValueDecompose2dScale(C, yo), o.lineWidth *= Math.max(yo[0], yo[1]) / d, o.stroke(ft(this, Fl, AV).call(this, y, M, a));
        } else
          o.lineWidth /= d, o.stroke(y);
      o.restore();
    } else
      (h === Tr.FILL || h === Tr.FILL_STROKE) && (o.fillText(e, n, s), (g = this.dependencyTracker) == null || g.recordCharacterBBox(t, o, c, d, n, s, () => o.measureText(e))), (h === Tr.STROKE || h === Tr.FILL_STROKE) && (this.dependencyTracker && ((f = this.dependencyTracker) == null || f.recordCharacterBBox(t, o, c, d, n, s, () => o.measureText(e)).recordDependencies(t, Oo.stroke)), o.strokeText(e, n, s));
    p && ((this.pendingTextPaths || (this.pendingTextPaths = [])).push({
      transform: ns(o),
      x: n,
      y: s,
      fontSize: d,
      path: y
    }), (T = this.dependencyTracker) == null || T.recordCharacterBBox(t, o, c, d, n, s));
  }
  get isFontSubpixelAAEnabled() {
    const {
      context: t
    } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
    t.scale(1.5, 1), t.fillText("I", 0, 10);
    const e = t.getImageData(0, 0, 10, 10).data;
    let n = !1;
    for (let s = 3; s < e.length; s += 4)
      if (e[s] > 0 && e[s] < 255) {
        n = !0;
        break;
      }
    return Gn(this, "isFontSubpixelAAEnabled", n);
  }
  showText(t, e) {
    var x, V, X, C;
    this.dependencyTracker && (this.dependencyTracker.recordDependencies(t, Oo.showText).resetBBox(t), this.current.textRenderingMode & Tr.ADD_TO_PATH_FLAG && this.dependencyTracker.recordFutureForcedDependency("textClip", t).inheritPendingDependenciesAsFutureForcedDependencies());
    const n = this.current, s = n.font;
    if (s.isType3Font) {
      this.showType3Text(t, e), (x = this.dependencyTracker) == null || x.recordShowTextOperation(t);
      return;
    }
    const r = n.fontSize;
    if (r === 0) {
      (V = this.dependencyTracker) == null || V.recordOperation(t);
      return;
    }
    const a = this.ctx, o = n.fontSizeScale, l = n.charSpacing, c = n.wordSpacing, u = n.fontDirection, d = n.textHScale * u, h = e.length, p = s.vertical, m = p ? 1 : -1, b = s.defaultVMetrics, y = r * n.fontMatrix[0], Z = n.textRenderingMode === Tr.FILL && !s.disableFontFace && !n.patternFill;
    a.save(), n.textMatrix && a.transform(...n.textMatrix), a.translate(n.x, n.y + n.textRise), u > 0 ? a.scale(d, -1) : a.scale(d, 1);
    let g, f;
    if (n.patternFill) {
      a.save();
      const R = n.fillColor.getPattern(a, this, nc(a), Xr.FILL, t);
      g = ns(a), a.restore(), a.fillStyle = R;
    }
    if (n.patternStroke) {
      a.save();
      const R = n.strokeColor.getPattern(a, this, nc(a), Xr.STROKE, t);
      f = ns(a), a.restore(), a.strokeStyle = R;
    }
    let T = n.lineWidth;
    const M = n.textMatrixScale;
    if (M === 0 || T === 0) {
      const R = n.textRenderingMode & Tr.FILL_STROKE_MASK;
      (R === Tr.STROKE || R === Tr.FILL_STROKE) && (T = this.getSinglePixelWidth());
    } else
      T /= M;
    if (o !== 1 && (a.scale(o, o), T /= o), a.lineWidth = T, s.isInvalidPDFjsFont) {
      const R = [];
      let z = 0;
      for (const P of e)
        R.push(P.unicode), z += P.width;
      const F = R.join("");
      if (a.fillText(F, 0, 0), this.dependencyTracker !== null) {
        const P = a.measureText(F);
        this.dependencyTracker.recordBBox(t, this.ctx, -P.actualBoundingBoxLeft, P.actualBoundingBoxRight, -P.actualBoundingBoxAscent, P.actualBoundingBoxDescent).recordShowTextOperation(t);
      }
      n.x += z * y * d, a.restore(), this.compose();
      return;
    }
    let N = 0, W;
    for (W = 0; W < h; ++W) {
      const R = e[W];
      if (typeof R == "number") {
        N += m * R * r / 1e3;
        continue;
      }
      let z = !1;
      const F = (R.isSpace ? c : 0) + l, P = R.fontChar, j = R.accent;
      let H, B, $ = R.width;
      if (p) {
        const ct = R.vmetric || b, at = -(R.vmetric ? ct[1] : $ * 0.5) * y, dt = ct[2] * y;
        $ = ct ? -ct[0] : $, H = at / o, B = (N + dt) / o;
      } else
        H = N / o, B = 0;
      let A;
      if (s.remeasure && $ > 0) {
        A = a.measureText(P);
        const ct = A.width * 1e3 / r * o;
        if ($ < ct && this.isFontSubpixelAAEnabled) {
          const at = $ / ct;
          z = !0, a.save(), a.scale(at, 1), H /= at;
        } else $ !== ct && (H += ($ - ct) / 2e3 * r / o);
      }
      if (this.contentVisible && (R.isInFont || s.missingFile)) {
        if (Z && !j)
          a.fillText(P, H, B), (X = this.dependencyTracker) == null || X.recordCharacterBBox(t, a, A ? {
            bbox: null
          } : s, r / o, H, B, () => A ?? a.measureText(P));
        else if (this.paintChar(t, P, H, B, g, f), j) {
          const ct = H + r * j.offset.x / o, at = B - r * j.offset.y / o;
          this.paintChar(t, j.fontChar, ct, at, g, f);
        }
      }
      const E = p ? $ * y - F * u : $ * y + F * u;
      N += E, z && a.restore();
    }
    p ? n.y -= N : n.x += N * d, a.restore(), this.compose(), (C = this.dependencyTracker) == null || C.recordShowTextOperation(t);
  }
  showType3Text(t, e) {
    const n = this.ctx, s = this.current, r = s.font, a = s.fontSize, o = s.fontDirection, l = r.vertical ? 1 : -1, c = s.charSpacing, u = s.wordSpacing, d = s.textHScale * o, h = s.fontMatrix || pV, p = e.length, m = s.textRenderingMode === Tr.INVISIBLE;
    let b, y, Z, g;
    if (m || a === 0)
      return;
    this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null, n.save(), s.textMatrix && n.transform(...s.textMatrix), n.translate(s.x, s.y + s.textRise), n.scale(d, o);
    const f = this.dependencyTracker;
    for (this.dependencyTracker = f ? new KW(f, t) : null, b = 0; b < p; ++b) {
      if (y = e[b], typeof y == "number") {
        g = l * y * a / 1e3, this.ctx.translate(g, 0), s.x += g * d;
        continue;
      }
      const T = (y.isSpace ? u : 0) + c, M = r.charProcOperatorList[y.operatorListId];
      M ? this.contentVisible && (this.save(), n.scale(a, a), n.transform(...h), this.executeOperatorList(M), this.restore()) : pn(`Type3 character "${y.operatorListId}" is not available.`);
      const N = [y.width, 0];
      ze.applyTransform(N, h), Z = N[0] * a + T, n.translate(Z, 0), s.x += Z * d;
    }
    n.restore(), f && (this.dependencyTracker = f);
  }
  setCharWidth(t, e, n) {
  }
  setCharWidthAndBounds(t, e, n, s, r, a, o) {
    var c;
    const l = new Path2D();
    l.rect(s, r, a - s, o - r), this.ctx.clip(l), (c = this.dependencyTracker) == null || c.recordBBox(t, this.ctx, s, a, r, o).recordClipBox(t, this.ctx, s, a, r, o), this.endPath(t);
  }
  getColorN_Pattern(t, e) {
    let n;
    if (e[0] === "TilingPattern") {
      const s = this.baseTransform || ns(this.ctx), r = {
        createCanvasGraphics: (a, o) => new pY(a, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
          optionalContentConfig: this.optionalContentConfig,
          markedContentStack: this.markedContentStack
        }, void 0, void 0, this.dependencyTracker ? new KW(this.dependencyTracker, o, !0) : null)
      };
      n = new UV(e, this.ctx, r, s);
    } else
      n = this._getPattern(t, e[1], e[2]);
    return n;
  }
  setStrokeColorN(t, ...e) {
    var n;
    (n = this.dependencyTracker) == null || n.recordSimpleData("strokeColor", t), this.current.strokeColor = this.getColorN_Pattern(t, e), this.current.patternStroke = !0;
  }
  setFillColorN(t, ...e) {
    var n;
    (n = this.dependencyTracker) == null || n.recordSimpleData("fillColor", t), this.current.fillColor = this.getColorN_Pattern(t, e), this.current.patternFill = !0;
  }
  setStrokeRGBColor(t, e) {
    var n;
    (n = this.dependencyTracker) == null || n.recordSimpleData("strokeColor", t), this.ctx.strokeStyle = this.current.strokeColor = e, this.current.patternStroke = !1;
  }
  setStrokeTransparent(t) {
    var e;
    (e = this.dependencyTracker) == null || e.recordSimpleData("strokeColor", t), this.ctx.strokeStyle = this.current.strokeColor = "transparent", this.current.patternStroke = !1;
  }
  setFillRGBColor(t, e) {
    var n;
    (n = this.dependencyTracker) == null || n.recordSimpleData("fillColor", t), this.ctx.fillStyle = this.current.fillColor = e, this.current.patternFill = !1;
  }
  setFillTransparent(t) {
    var e;
    (e = this.dependencyTracker) == null || e.recordSimpleData("fillColor", t), this.ctx.fillStyle = this.current.fillColor = "transparent", this.current.patternFill = !1;
  }
  _getPattern(t, e, n = null) {
    let s;
    return this.cachedPatterns.has(e) ? s = this.cachedPatterns.get(e) : (s = FIt(this.getObject(t, e)), this.cachedPatterns.set(e, s)), n && (s.matrix = n), s;
  }
  shadingFill(t, e) {
    var a;
    if (!this.contentVisible)
      return;
    const n = this.ctx;
    this.save(t);
    const s = this._getPattern(t, e);
    n.fillStyle = s.getPattern(n, this, nc(n), Xr.SHADING, t);
    const r = nc(n);
    if (r) {
      const {
        width: o,
        height: l
      } = n.canvas, c = Gb.slice();
      ze.axialAlignedBoundingBox([0, 0, o, l], r, c);
      const [u, d, h, p] = c;
      this.ctx.fillRect(u, d, h - u, p - d);
    } else
      this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
    (a = this.dependencyTracker) == null || a.resetBBox(t).recordFullPageBBox(t).recordDependencies(t, Oo.transform).recordDependencies(t, Oo.fill).recordOperation(t), this.compose(this.current.getClippedPathBoundingBox()), this.restore(t);
  }
  beginInlineImage() {
    Xi("Should not call beginInlineImage");
  }
  beginImageData() {
    Xi("Should not call beginImageData");
  }
  paintFormXObjectBegin(t, e, n) {
    var s;
    if (this.contentVisible && (this.save(t), this.baseTransformStack.push(this.baseTransform), e && this.transform(t, ...e), this.baseTransform = ns(this.ctx), n)) {
      ze.axialAlignedBoundingBox(n, this.baseTransform, this.current.minMax);
      const [r, a, o, l] = n, c = new Path2D();
      c.rect(r, a, o - r, l - a), this.ctx.clip(c), (s = this.dependencyTracker) == null || s.recordClipBox(t, this.ctx, r, o, a, l), this.endPath(t);
    }
  }
  paintFormXObjectEnd(t) {
    this.contentVisible && (this.restore(t), this.baseTransform = this.baseTransformStack.pop());
  }
  beginGroup(t, e) {
    var f;
    if (!this.contentVisible)
      return;
    this.save(t), this.inSMaskMode && (this.endSMaskMode(), this.current.activeSMask = null);
    const n = this.ctx;
    e.isolated || bw("TODO: Support non-isolated groups."), e.knockout && pn("Knockout groups not supported.");
    const s = ns(n);
    if (e.matrix && n.transform(...e.matrix), !e.bbox)
      throw new Error("Bounding box is required.");
    let r = Gb.slice();
    ze.axialAlignedBoundingBox(e.bbox, ns(n), r);
    const a = [0, 0, n.canvas.width, n.canvas.height];
    r = ze.intersect(r, a) || [0, 0, 0, 0];
    const o = Math.floor(r[0]), l = Math.floor(r[1]), c = Math.max(Math.ceil(r[2]) - o, 1), u = Math.max(Math.ceil(r[3]) - l, 1);
    this.current.startNewPathAndClipBox([0, 0, c, u]);
    let d = "groupAt" + this.groupLevel;
    e.smask && (d += "_smask_" + this.smaskCounter++ % 2);
    const h = this.cachedCanvases.getCanvas(d, c, u), p = h.context;
    p.translate(-o, -l), p.transform(...s);
    let m = new Path2D();
    const [b, y, Z, g] = e.bbox;
    if (m.rect(b, y, Z - b, g - y), e.matrix) {
      const T = new Path2D();
      T.addPath(m, new DOMMatrix(e.matrix)), m = T;
    }
    p.clip(m), e.smask && this.smaskStack.push({
      canvas: h.canvas,
      context: p,
      offsetX: o,
      offsetY: l,
      subtype: e.smask.subtype,
      backdrop: e.smask.backdrop,
      transferMap: e.smask.transferMap || null,
      startTransformInverse: null
    }), (!e.smask || this.dependencyTracker) && (n.setTransform(1, 0, 0, 1, 0, 0), n.translate(o, l), n.save()), uy(n, p), this.ctx = p, (f = this.dependencyTracker) == null || f.inheritSimpleDataAsFutureForcedDependencies(["fillAlpha", "strokeAlpha", "globalCompositeOperation"]).pushBaseTransform(n), this.setGState(t, [["BM", "source-over"], ["ca", 1], ["CA", 1]]), this.groupStack.push(n), this.groupLevel++;
  }
  endGroup(t, e) {
    var r;
    if (!this.contentVisible)
      return;
    this.groupLevel--;
    const n = this.ctx, s = this.groupStack.pop();
    if (this.ctx = s, this.ctx.imageSmoothingEnabled = !1, (r = this.dependencyTracker) == null || r.popBaseTransform(), e.smask)
      this.tempSMask = this.smaskStack.pop(), this.restore(t), this.dependencyTracker && this.ctx.restore();
    else {
      this.ctx.restore();
      const a = ns(this.ctx);
      this.restore(t), this.ctx.save(), this.ctx.setTransform(...a);
      const o = Gb.slice();
      ze.axialAlignedBoundingBox([0, 0, n.canvas.width, n.canvas.height], a, o), this.ctx.drawImage(n.canvas, 0, 0), this.ctx.restore(), this.compose(o);
    }
  }
  beginAnnotation(t, e, n, s, r, a) {
    if (ft(this, Fl, PV).call(this), UM(this.ctx), this.ctx.save(), this.save(t), this.baseTransform && this.ctx.setTransform(...this.baseTransform), n) {
      const o = n[2] - n[0], l = n[3] - n[1];
      if (a && this.annotationCanvasMap) {
        s = s.slice(), s[4] -= n[0], s[5] -= n[1], n = n.slice(), n[0] = n[1] = 0, n[2] = o, n[3] = l, ze.singularValueDecompose2dScale(ns(this.ctx), yo);
        const {
          viewportScale: c
        } = this, u = Math.ceil(o * this.outputScaleX * c), d = Math.ceil(l * this.outputScaleY * c);
        this.annotationCanvas = this.canvasFactory.create(u, d);
        const {
          canvas: h,
          context: p
        } = this.annotationCanvas;
        this.annotationCanvasMap.set(e, h), this.annotationCanvas.savedCtx = this.ctx, this.ctx = p, this.ctx.save(), this.ctx.setTransform(yo[0], 0, 0, -yo[1], 0, l * yo[1]), UM(this.ctx);
      } else {
        UM(this.ctx), this.endPath(t);
        const c = new Path2D();
        c.rect(n[0], n[1], o, l), this.ctx.clip(c);
      }
    }
    this.current = new OE(this.ctx.canvas.width, this.ctx.canvas.height), this.transform(t, ...s), this.transform(t, ...r);
  }
  endAnnotation(t) {
    this.annotationCanvas && (this.ctx.restore(), ft(this, Fl, JV).call(this), this.ctx = this.annotationCanvas.savedCtx, delete this.annotationCanvas.savedCtx, delete this.annotationCanvas);
  }
  paintImageMaskXObject(t, e) {
    var o;
    if (!this.contentVisible)
      return;
    const n = e.count;
    e = this.getObject(t, e.data, e), e.count = n;
    const s = this.ctx, r = this._createMaskCanvas(t, e), a = r.canvas;
    s.save(), s.setTransform(1, 0, 0, 1, 0, 0), s.drawImage(a, r.offsetX, r.offsetY), (o = this.dependencyTracker) == null || o.resetBBox(t).recordBBox(t, this.ctx, r.offsetX, r.offsetX + a.width, r.offsetY, r.offsetY + a.height).recordOperation(t), s.restore(), this.compose();
  }
  paintImageMaskXObjectRepeat(t, e, n, s = 0, r = 0, a, o) {
    var d, h, p;
    if (!this.contentVisible)
      return;
    e = this.getObject(t, e.data, e);
    const l = this.ctx;
    l.save();
    const c = ns(l);
    l.transform(n, s, r, a, 0, 0);
    const u = this._createMaskCanvas(t, e);
    l.setTransform(1, 0, 0, 1, u.offsetX - c[4], u.offsetY - c[5]), (d = this.dependencyTracker) == null || d.resetBBox(t);
    for (let m = 0, b = o.length; m < b; m += 2) {
      const y = ze.transform(c, [n, s, r, a, o[m], o[m + 1]]);
      l.drawImage(u.canvas, y[4], y[5]), (h = this.dependencyTracker) == null || h.recordBBox(t, this.ctx, y[4], y[4] + u.canvas.width, y[5], y[5] + u.canvas.height);
    }
    l.restore(), this.compose(), (p = this.dependencyTracker) == null || p.recordOperation(t);
  }
  paintImageMaskXObjectGroup(t, e) {
    var a, o, l;
    if (!this.contentVisible)
      return;
    const n = this.ctx, s = this.current.fillColor, r = this.current.patternFill;
    (a = this.dependencyTracker) == null || a.resetBBox(t).recordDependencies(t, Oo.transformAndFill);
    for (const c of e) {
      const {
        data: u,
        width: d,
        height: h,
        transform: p
      } = c, m = this.cachedCanvases.getCanvas("maskCanvas", d, h), b = m.context;
      b.save();
      const y = this.getObject(t, u, c);
      EE(b, y), b.globalCompositeOperation = "source-in", b.fillStyle = r ? s.getPattern(b, this, nc(n), Xr.FILL, t) : s, b.fillRect(0, 0, d, h), b.restore(), n.save(), n.transform(...p), n.scale(1, -1), jM(n, m.canvas, 0, 0, d, h, 0, -1, 1, 1), (o = this.dependencyTracker) == null || o.recordBBox(t, n, 0, d, 0, h), n.restore();
    }
    this.compose(), (l = this.dependencyTracker) == null || l.recordOperation(t);
  }
  paintImageXObject(t, e) {
    if (!this.contentVisible)
      return;
    const n = this.getObject(t, e);
    if (!n) {
      pn("Dependent image isn't ready yet");
      return;
    }
    this.paintInlineImageXObject(t, n);
  }
  paintImageXObjectRepeat(t, e, n, s, r) {
    if (!this.contentVisible)
      return;
    const a = this.getObject(t, e);
    if (!a) {
      pn("Dependent image isn't ready yet");
      return;
    }
    const o = a.width, l = a.height, c = [];
    for (let u = 0, d = r.length; u < d; u += 2)
      c.push({
        transform: [n, 0, 0, s, r[u], r[u + 1]],
        x: 0,
        y: 0,
        w: o,
        h: l
      });
    this.paintInlineImageXObjectGroup(t, a, c);
  }
  applyTransferMapsToCanvas(t) {
    return this.current.transferMaps !== "none" && (t.filter = this.current.transferMaps, t.drawImage(t.canvas, 0, 0), t.filter = "none"), t.canvas;
  }
  applyTransferMapsToBitmap(t) {
    if (this.current.transferMaps === "none")
      return t.bitmap;
    const {
      bitmap: e,
      width: n,
      height: s
    } = t, r = this.cachedCanvases.getCanvas("inlineImage", n, s), a = r.context;
    return a.filter = this.current.transferMaps, a.drawImage(e, 0, 0), a.filter = "none", r.canvas;
  }
  paintInlineImageXObject(t, e) {
    var c;
    if (!this.contentVisible)
      return;
    const n = e.width, s = e.height, r = this.ctx;
    this.save(t);
    const {
      filter: a
    } = r;
    a !== "none" && a !== "" && (r.filter = "none"), r.scale(1 / n, -1 / s);
    let o;
    if (e.bitmap)
      o = this.applyTransferMapsToBitmap(e);
    else if (typeof HTMLElement == "function" && e instanceof HTMLElement || !e.data)
      o = e;
    else {
      const d = this.cachedCanvases.getCanvas("inlineImage", n, s).context;
      zE(d, e), o = this.applyTransferMapsToCanvas(d);
    }
    const l = this._scaleImage(o, nc(r));
    r.imageSmoothingEnabled = kE(ns(r), e.interpolate), (c = this.dependencyTracker) == null || c.resetBBox(t).recordBBox(t, r, 0, n, -s, 0).recordDependencies(t, Oo.imageXObject).recordOperation(t), jM(r, l.img, 0, 0, l.paintWidth, l.paintHeight, 0, -s, n, s), this.compose(), this.restore(t);
  }
  paintInlineImageXObjectGroup(t, e, n) {
    var a, o, l;
    if (!this.contentVisible)
      return;
    const s = this.ctx;
    let r;
    if (e.bitmap)
      r = e.bitmap;
    else {
      const c = e.width, u = e.height, h = this.cachedCanvases.getCanvas("inlineImage", c, u).context;
      zE(h, e), r = this.applyTransferMapsToCanvas(h);
    }
    (a = this.dependencyTracker) == null || a.resetBBox(t);
    for (const c of n)
      s.save(), s.transform(...c.transform), s.scale(1, -1), jM(s, r, c.x, c.y, c.w, c.h, 0, -1, 1, 1), (o = this.dependencyTracker) == null || o.recordBBox(t, s, 0, 1, -1, 0), s.restore();
    (l = this.dependencyTracker) == null || l.recordOperation(t), this.compose();
  }
  paintSolidColorImageMask(t) {
    var e;
    this.contentVisible && ((e = this.dependencyTracker) == null || e.resetBBox(t).recordBBox(t, this.ctx, 0, 1, 0, 1).recordDependencies(t, Oo.fill).recordOperation(t), this.ctx.fillRect(0, 0, 1, 1), this.compose());
  }
  markPoint(t, e) {
  }
  markPointProps(t, e, n) {
  }
  beginMarkedContent(t, e) {
    var n;
    (n = this.dependencyTracker) == null || n.beginMarkedContent(t), this.markedContentStack.push({
      visible: !0
    });
  }
  beginMarkedContentProps(t, e, n) {
    var s;
    (s = this.dependencyTracker) == null || s.beginMarkedContent(t), e === "OC" ? this.markedContentStack.push({
      visible: this.optionalContentConfig.isVisible(n)
    }) : this.markedContentStack.push({
      visible: !0
    }), this.contentVisible = this.isContentVisible();
  }
  endMarkedContent(t) {
    var e;
    (e = this.dependencyTracker) == null || e.endMarkedContent(t), this.markedContentStack.pop(), this.contentVisible = this.isContentVisible();
  }
  beginCompat(t) {
  }
  endCompat(t) {
  }
  consumePath(t, e, n) {
    var a, o;
    const s = this.current.isEmptyClip();
    this.pendingClip && this.current.updateClipFromPath(), this.pendingClip || this.compose(n);
    const r = this.ctx;
    this.pendingClip ? (s || (this.pendingClip === FE ? r.clip(e, "evenodd") : r.clip(e)), this.pendingClip = null, (a = this.dependencyTracker) == null || a.bboxToClipBoxDropOperation(t).recordFutureForcedDependency("clipPath", t)) : (o = this.dependencyTracker) == null || o.recordOperation(t), this.current.startNewPathAndClipBox(this.current.clipBox);
  }
  getSinglePixelWidth() {
    if (!this._cachedGetSinglePixelWidth) {
      const t = ns(this.ctx);
      if (t[1] === 0 && t[2] === 0)
        this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(t[0]), Math.abs(t[3]));
      else {
        const e = Math.abs(t[0] * t[3] - t[2] * t[1]), n = Math.hypot(t[0], t[2]), s = Math.hypot(t[1], t[3]);
        this._cachedGetSinglePixelWidth = Math.max(n, s) / e;
      }
    }
    return this._cachedGetSinglePixelWidth;
  }
  getScaleForStroking() {
    if (this._cachedScaleForStroking[0] === -1) {
      const {
        lineWidth: t
      } = this.current, {
        a: e,
        b: n,
        c: s,
        d: r
      } = this.ctx.getTransform();
      let a, o;
      if (n === 0 && s === 0) {
        const l = Math.abs(e), c = Math.abs(r);
        if (l === c)
          if (t === 0)
            a = o = 1 / l;
          else {
            const u = l * t;
            a = o = u < 1 ? 1 / u : 1;
          }
        else if (t === 0)
          a = 1 / l, o = 1 / c;
        else {
          const u = l * t, d = c * t;
          a = u < 1 ? 1 / u : 1, o = d < 1 ? 1 / d : 1;
        }
      } else {
        const l = Math.abs(e * r - n * s), c = Math.hypot(e, n), u = Math.hypot(s, r);
        if (t === 0)
          a = u / l, o = c / l;
        else {
          const d = t * l;
          a = u > d ? u / d : 1, o = c > d ? c / d : 1;
        }
      }
      this._cachedScaleForStroking[0] = a, this._cachedScaleForStroking[1] = o;
    }
    return this._cachedScaleForStroking;
  }
  rescaleAndStroke(t, e) {
    const {
      ctx: n,
      current: {
        lineWidth: s
      }
    } = this, [r, a] = this.getScaleForStroking();
    if (r === a) {
      n.lineWidth = (s || 1) * r, n.stroke(t);
      return;
    }
    const o = n.getLineDash();
    e && n.save(), n.scale(r, a), OS.a = 1 / r, OS.d = 1 / a;
    const l = new Path2D();
    if (l.addPath(t, OS), o.length > 0) {
      const c = Math.max(r, a);
      n.setLineDash(o.map((u) => u / c)), n.lineDashOffset /= c;
    }
    n.lineWidth = s || 1, n.stroke(l), e && n.restore();
  }
  isContentVisible() {
    for (let t = this.markedContentStack.length - 1; t >= 0; t--)
      if (!this.markedContentStack[t].visible)
        return !1;
    return !0;
  }
};
Fl = new WeakSet(), PV = function() {
  for (; this.stateStack.length || this.inSMaskMode; )
    this.restore();
  this.current.activeSMask = null, this.ctx.restore(), this.transparentCanvas && (this.ctx = this.compositeCtx, this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.drawImage(this.transparentCanvas, 0, 0), this.ctx.restore(), this.transparentCanvas = null);
}, JV = function() {
  if (this.pageColors) {
    const t = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
    if (t !== "none") {
      const e = this.ctx.filter;
      this.ctx.filter = t, this.ctx.drawImage(this.ctx.canvas, 0, 0), this.ctx.filter = e;
    }
  }
}, AV = function(t, e, n) {
  const s = new Path2D();
  return s.addPath(t, new DOMMatrix(n).invertSelf().multiplySelf(e)), s;
};
let zb = pY;
for (const i in E2)
  zb.prototype[i] !== void 0 && (zb.prototype[E2[i]] = zb.prototype[i]);
var pf, mf, TZ, bf, CN;
const xb = class xb {
  constructor(t) {
    pt(this, bf);
    pt(this, pf);
    pt(this, mf);
    pt(this, TZ);
    rt(this, pf, t), rt(this, mf, new DataView(w(this, pf))), rt(this, TZ, new TextDecoder());
  }
  static write(t) {
    const e = new TextEncoder(), n = {};
    let s = 0;
    for (const c of xb.strings) {
      const u = e.encode(t[c]);
      n[c] = u, s += 4 + u.length;
    }
    const r = new ArrayBuffer(s), a = new Uint8Array(r), o = new DataView(r);
    let l = 0;
    for (const c of xb.strings) {
      const u = n[c], d = u.length;
      o.setUint32(l, d), a.set(u, l + 4), l += 4 + d;
    }
    return Pn(l === r.byteLength, "CssFontInfo.write: Buffer overflow"), r;
  }
  get fontFamily() {
    return ft(this, bf, CN).call(this, 0);
  }
  get fontWeight() {
    return ft(this, bf, CN).call(this, 1);
  }
  get italicAngle() {
    return ft(this, bf, CN).call(this, 2);
  }
};
pf = new WeakMap(), mf = new WeakMap(), TZ = new WeakMap(), bf = new WeakSet(), CN = function(t) {
  Pn(t < xb.strings.length, "Invalid string index");
  let e = 0;
  for (let s = 0; s < t; s++)
    e += w(this, mf).getUint32(e) + 4;
  const n = w(this, mf).getUint32(e);
  return w(this, TZ).decode(new Uint8Array(w(this, pf), e + 4, n));
}, S(xb, "strings", ["fontFamily", "fontWeight", "italicAngle"]);
let HW = xb;
var lh, Tc, Mm, Nm, Fy;
const Sb = class Sb {
  constructor(t) {
    pt(this, Nm);
    pt(this, lh);
    pt(this, Tc);
    pt(this, Mm);
    rt(this, lh, t), rt(this, Tc, new DataView(w(this, lh))), rt(this, Mm, new TextDecoder());
  }
  static write(t) {
    const e = new TextEncoder(), n = {};
    let s = 0;
    for (const h of Sb.strings) {
      const p = e.encode(t[h]);
      n[h] = p, s += 4 + p.length;
    }
    s += 4;
    let r, a, o = 1 + s;
    t.style && (r = e.encode(t.style.style), a = e.encode(t.style.weight), o += 4 + r.length + 4 + a.length);
    const l = new ArrayBuffer(o), c = new Uint8Array(l), u = new DataView(l);
    let d = 0;
    u.setUint8(d++, t.guessFallback ? 1 : 0), u.setUint32(d, 0), d += 4, s = 0;
    for (const h of Sb.strings) {
      const p = n[h], m = p.length;
      s += 4 + m, u.setUint32(d, m), c.set(p, d + 4), d += 4 + m;
    }
    return u.setUint32(d - s - 4, s), t.style && (u.setUint32(d, r.length), c.set(r, d + 4), d += 4 + r.length, u.setUint32(d, a.length), c.set(a, d + 4), d += 4 + a.length), Pn(d <= l.byteLength, "SubstitionInfo.write: Buffer overflow"), l.transferToFixedLength(d);
  }
  get guessFallback() {
    return w(this, Tc).getUint8(0) !== 0;
  }
  get css() {
    return ft(this, Nm, Fy).call(this, 0);
  }
  get loadedName() {
    return ft(this, Nm, Fy).call(this, 1);
  }
  get baseFontName() {
    return ft(this, Nm, Fy).call(this, 2);
  }
  get src() {
    return ft(this, Nm, Fy).call(this, 3);
  }
  get style() {
    let t = 1;
    t += 4 + w(this, Tc).getUint32(t);
    const e = w(this, Tc).getUint32(t), n = w(this, Mm).decode(new Uint8Array(w(this, lh), t + 4, e));
    t += 4 + e;
    const s = w(this, Tc).getUint32(t), r = w(this, Mm).decode(new Uint8Array(w(this, lh), t + 4, s));
    return {
      style: n,
      weight: r
    };
  }
};
lh = new WeakMap(), Tc = new WeakMap(), Mm = new WeakMap(), Nm = new WeakSet(), Fy = function(t) {
  Pn(t < Sb.strings.length, "Invalid string index");
  let e = 5;
  for (let s = 0; s < t; s++)
    e += w(this, Tc).getUint32(e) + 4;
  const n = w(this, Tc).getUint32(e);
  return w(this, Mm).decode(new Uint8Array(w(this, lh), e + 4, n));
}, S(Sb, "strings", ["css", "loadedName", "baseFontName", "src"]);
let _W = Sb;
var ff, gf, yf, Zf, to, Mc, MZ, Mi, hs, pl, YN, jy;
const yn = class yn {
  constructor({
    data: t,
    extra: e
  }) {
    pt(this, hs);
    pt(this, Mc);
    pt(this, MZ);
    pt(this, Mi);
    rt(this, Mc, t), rt(this, MZ, new TextDecoder()), rt(this, Mi, new DataView(w(this, Mc))), e && Object.assign(this, e);
  }
  get black() {
    return ft(this, hs, pl).call(this, 0);
  }
  get bold() {
    return ft(this, hs, pl).call(this, 1);
  }
  get disableFontFace() {
    return ft(this, hs, pl).call(this, 2);
  }
  get fontExtraProperties() {
    return ft(this, hs, pl).call(this, 3);
  }
  get isInvalidPDFjsFont() {
    return ft(this, hs, pl).call(this, 4);
  }
  get isType3Font() {
    return ft(this, hs, pl).call(this, 5);
  }
  get italic() {
    return ft(this, hs, pl).call(this, 6);
  }
  get missingFile() {
    return ft(this, hs, pl).call(this, 7);
  }
  get remeasure() {
    return ft(this, hs, pl).call(this, 8);
  }
  get vertical() {
    return ft(this, hs, pl).call(this, 9);
  }
  get ascent() {
    return ft(this, hs, YN).call(this, 0);
  }
  get defaultWidth() {
    return ft(this, hs, YN).call(this, 1);
  }
  get descent() {
    return ft(this, hs, YN).call(this, 2);
  }
  get bbox() {
    let t = w(yn, gf);
    if (w(this, Mi).getUint8(t) === 0)
      return;
    t += 1;
    const n = [];
    for (let s = 0; s < 4; s++)
      n.push(w(this, Mi).getInt16(t, !0)), t += 2;
    return n;
  }
  get fontMatrix() {
    let t = w(yn, yf);
    if (w(this, Mi).getUint8(t) === 0)
      return;
    t += 1;
    const n = [];
    for (let s = 0; s < 6; s++)
      n.push(w(this, Mi).getFloat64(t, !0)), t += 8;
    return n;
  }
  get defaultVMetrics() {
    let t = w(yn, Zf);
    if (w(this, Mi).getUint8(t) === 0)
      return;
    t += 1;
    const n = [];
    for (let s = 0; s < 3; s++)
      n.push(w(this, Mi).getInt16(t, !0)), t += 2;
    return n;
  }
  get fallbackName() {
    return ft(this, hs, jy).call(this, 0);
  }
  get loadedName() {
    return ft(this, hs, jy).call(this, 1);
  }
  get mimetype() {
    return ft(this, hs, jy).call(this, 2);
  }
  get name() {
    return ft(this, hs, jy).call(this, 3);
  }
  get data() {
    let t = w(yn, to);
    const e = w(this, Mi).getUint32(t);
    t += 4 + e;
    const n = w(this, Mi).getUint32(t);
    t += 4 + n;
    const s = w(this, Mi).getUint32(t);
    t += 4 + s;
    const r = w(this, Mi).getUint32(t);
    if (r !== 0)
      return new Uint8Array(w(this, Mc), t + 4, r);
  }
  clearData() {
    let t = w(yn, to);
    const e = w(this, Mi).getUint32(t);
    t += 4 + e;
    const n = w(this, Mi).getUint32(t);
    t += 4 + n;
    const s = w(this, Mi).getUint32(t);
    t += 4 + s;
    const r = w(this, Mi).getUint32(t);
    new Uint8Array(w(this, Mc), t + 4, r).fill(0), w(this, Mi).setUint32(t, 0);
  }
  get cssFontInfo() {
    let t = w(yn, to);
    const e = w(this, Mi).getUint32(t);
    t += 4 + e;
    const n = w(this, Mi).getUint32(t);
    t += 4 + n;
    const s = w(this, Mi).getUint32(t);
    if (s === 0)
      return null;
    const r = new Uint8Array(s);
    return r.set(new Uint8Array(w(this, Mc), t + 4, s)), new HW(r.buffer);
  }
  get systemFontInfo() {
    let t = w(yn, to);
    const e = w(this, Mi).getUint32(t);
    t += 4 + e;
    const n = w(this, Mi).getUint32(t);
    if (n === 0)
      return null;
    const s = new Uint8Array(n);
    return s.set(new Uint8Array(w(this, Mc), t + 4, n)), new _W(s.buffer);
  }
  static write(t) {
    const e = t.systemFontInfo ? _W.write(t.systemFontInfo) : null, n = t.cssFontInfo ? HW.write(t.cssFontInfo) : null, s = new TextEncoder(), r = {};
    let a = 0;
    for (const b of yn.strings)
      r[b] = s.encode(t[b]), a += 4 + r[b].length;
    const o = w(yn, to) + 4 + a + 4 + (e ? e.byteLength : 0) + 4 + (n ? n.byteLength : 0) + 4 + (t.data ? t.data.length : 0), l = new ArrayBuffer(o), c = new Uint8Array(l), u = new DataView(l);
    let d = 0;
    const h = yn.bools.length;
    let p = 0, m = 0;
    for (let b = 0; b < h; b++) {
      const y = t[yn.bools[b]];
      p |= (y === void 0 ? 0 : y ? 2 : 1) << m, m += 2, (m === 8 || b === h - 1) && (u.setUint8(d++, p), p = 0, m = 0);
    }
    Pn(d === w(yn, ff), "FontInfo.write: Boolean properties offset mismatch");
    for (const b of yn.numbers)
      u.setFloat64(d, t[b]), d += 8;
    if (Pn(d === w(yn, gf), "FontInfo.write: Number properties offset mismatch"), t.bbox) {
      u.setUint8(d++, 4);
      for (const b of t.bbox)
        u.setInt16(d, b, !0), d += 2;
    } else
      u.setUint8(d++, 0), d += 8;
    if (Pn(d === w(yn, yf), "FontInfo.write: BBox properties offset mismatch"), t.fontMatrix) {
      u.setUint8(d++, 6);
      for (const b of t.fontMatrix)
        u.setFloat64(d, b, !0), d += 8;
    } else
      u.setUint8(d++, 0), d += 48;
    if (Pn(d === w(yn, Zf), "FontInfo.write: FontMatrix properties offset mismatch"), t.defaultVMetrics) {
      u.setUint8(d++, 1);
      for (const b of t.defaultVMetrics)
        u.setInt16(d, b, !0), d += 2;
    } else
      u.setUint8(d++, 0), d += 6;
    Pn(d === w(yn, to), "FontInfo.write: DefaultVMetrics properties offset mismatch"), u.setUint32(w(yn, to), 0), d += 4;
    for (const b of yn.strings) {
      const y = r[b], Z = y.length;
      u.setUint32(d, Z), c.set(y, d + 4), d += 4 + Z;
    }
    if (u.setUint32(w(yn, to), d - w(yn, to) - 4), !e)
      u.setUint32(d, 0), d += 4;
    else {
      const b = e.byteLength;
      u.setUint32(d, b), Pn(d + 4 + b <= l.byteLength, "FontInfo.write: Buffer overflow at systemFontInfo"), c.set(new Uint8Array(e), d + 4), d += 4 + b;
    }
    if (!n)
      u.setUint32(d, 0), d += 4;
    else {
      const b = n.byteLength;
      u.setUint32(d, b), Pn(d + 4 + b <= l.byteLength, "FontInfo.write: Buffer overflow at cssFontInfo"), c.set(new Uint8Array(n), d + 4), d += 4 + b;
    }
    return t.data === void 0 ? (u.setUint32(d, 0), d += 4) : (u.setUint32(d, t.data.length), c.set(t.data, d + 4), d += 4 + t.data.length), Pn(d <= l.byteLength, "FontInfo.write: Buffer overflow"), l.transferToFixedLength(d);
  }
};
ff = new WeakMap(), gf = new WeakMap(), yf = new WeakMap(), Zf = new WeakMap(), to = new WeakMap(), Mc = new WeakMap(), MZ = new WeakMap(), Mi = new WeakMap(), hs = new WeakSet(), pl = function(t) {
  Pn(t < yn.bools.length, "Invalid boolean index");
  const e = Math.floor(t / 4), n = t * 2 % 8, s = w(this, Mi).getUint8(e) >> n & 3;
  return s === 0 ? void 0 : s === 2;
}, YN = function(t) {
  return Pn(t < yn.numbers.length, "Invalid number index"), w(this, Mi).getFloat64(w(yn, ff) + t * 8);
}, jy = function(t) {
  Pn(t < yn.strings.length, "Invalid string index");
  let e = w(yn, to) + 4;
  for (let r = 0; r < t; r++)
    e += w(this, Mi).getUint32(e) + 4;
  const n = w(this, Mi).getUint32(e), s = new Uint8Array(n);
  return s.set(new Uint8Array(w(this, Mc), e + 4, n)), w(this, MZ).decode(s);
}, S(yn, "bools", ["black", "bold", "disableFontFace", "fontExtraProperties", "isInvalidPDFjsFont", "isType3Font", "italic", "missingFile", "remeasure", "vertical"]), S(yn, "numbers", ["ascent", "defaultWidth", "descent"]), S(yn, "strings", ["fallbackName", "loadedName", "mimetype", "name"]), pt(yn, ff, Math.ceil(yn.bools.length * 2 / 8)), pt(yn, gf, w(yn, ff) + yn.numbers.length * 8), pt(yn, yf, w(yn, gf) + 1 + 8), pt(yn, Zf, w(yn, yf) + 1 + 48), pt(yn, to, w(yn, Zf) + 1 + 6);
let BV = yn;
var NZ, WZ;
class Wo {
  static get workerPort() {
    return w(this, NZ);
  }
  static set workerPort(t) {
    if (!(typeof Worker < "u" && t instanceof Worker) && t !== null)
      throw new Error("Invalid `workerPort` type.");
    rt(this, NZ, t);
  }
  static get workerSrc() {
    return w(this, WZ);
  }
  static set workerSrc(t) {
    if (typeof t != "string")
      throw new Error("Invalid `workerSrc` type.");
    rt(this, WZ, t);
  }
}
NZ = new WeakMap(), WZ = new WeakMap(), pt(Wo, NZ, null), pt(Wo, WZ, "");
var Tf, GZ;
class HIt {
  constructor({
    parsedData: t,
    rawData: e
  }) {
    pt(this, Tf);
    pt(this, GZ);
    rt(this, Tf, t), rt(this, GZ, e);
  }
  getRaw() {
    return w(this, GZ);
  }
  get(t) {
    return w(this, Tf).get(t) ?? null;
  }
  [Symbol.iterator]() {
    return w(this, Tf).entries();
  }
}
Tf = new WeakMap(), GZ = new WeakMap();
const mb = Symbol("INTERNAL");
var wZ, xZ, SZ, Mf;
class _It {
  constructor(t, {
    name: e,
    intent: n,
    usage: s,
    rbGroups: r
  }) {
    pt(this, wZ, !1);
    pt(this, xZ, !1);
    pt(this, SZ, !1);
    pt(this, Mf, !0);
    rt(this, wZ, !!(t & fo.DISPLAY)), rt(this, xZ, !!(t & fo.PRINT)), this.name = e, this.intent = n, this.usage = s, this.rbGroups = r;
  }
  get visible() {
    if (w(this, SZ))
      return w(this, Mf);
    if (!w(this, Mf))
      return !1;
    const {
      print: t,
      view: e
    } = this.usage;
    return w(this, wZ) ? (e == null ? void 0 : e.viewState) !== "OFF" : w(this, xZ) ? (t == null ? void 0 : t.printState) !== "OFF" : !0;
  }
  _setVisible(t, e, n = !1) {
    t !== mb && Xi("Internal method `_setVisible` called."), rt(this, SZ, n), rt(this, Mf, e);
  }
}
wZ = new WeakMap(), xZ = new WeakMap(), SZ = new WeakMap(), Mf = new WeakMap();
var ch, Ni, Nf, Wf, LZ, KV;
class QIt {
  constructor(t, e = fo.DISPLAY) {
    pt(this, LZ);
    pt(this, ch, null);
    pt(this, Ni, /* @__PURE__ */ new Map());
    pt(this, Nf, null);
    pt(this, Wf, null);
    if (this.renderingIntent = e, this.name = null, this.creator = null, t !== null) {
      this.name = t.name, this.creator = t.creator, rt(this, Wf, t.order);
      for (const n of t.groups)
        w(this, Ni).set(n.id, new _It(e, n));
      if (t.baseState === "OFF")
        for (const n of w(this, Ni).values())
          n._setVisible(mb, !1);
      for (const n of t.on)
        w(this, Ni).get(n)._setVisible(mb, !0);
      for (const n of t.off)
        w(this, Ni).get(n)._setVisible(mb, !1);
      rt(this, Nf, this.getHash());
    }
  }
  isVisible(t) {
    if (w(this, Ni).size === 0)
      return !0;
    if (!t)
      return bw("Optional content group not defined."), !0;
    if (t.type === "OCG")
      return w(this, Ni).has(t.id) ? w(this, Ni).get(t.id).visible : (pn(`Optional content group not found: ${t.id}`), !0);
    if (t.type === "OCMD") {
      if (t.expression)
        return ft(this, LZ, KV).call(this, t.expression);
      if (!t.policy || t.policy === "AnyOn") {
        for (const e of t.ids) {
          if (!w(this, Ni).has(e))
            return pn(`Optional content group not found: ${e}`), !0;
          if (w(this, Ni).get(e).visible)
            return !0;
        }
        return !1;
      } else if (t.policy === "AllOn") {
        for (const e of t.ids) {
          if (!w(this, Ni).has(e))
            return pn(`Optional content group not found: ${e}`), !0;
          if (!w(this, Ni).get(e).visible)
            return !1;
        }
        return !0;
      } else if (t.policy === "AnyOff") {
        for (const e of t.ids) {
          if (!w(this, Ni).has(e))
            return pn(`Optional content group not found: ${e}`), !0;
          if (!w(this, Ni).get(e).visible)
            return !0;
        }
        return !1;
      } else if (t.policy === "AllOff") {
        for (const e of t.ids) {
          if (!w(this, Ni).has(e))
            return pn(`Optional content group not found: ${e}`), !0;
          if (w(this, Ni).get(e).visible)
            return !1;
        }
        return !0;
      }
      return pn(`Unknown optional content policy ${t.policy}.`), !0;
    }
    return pn(`Unknown group type ${t.type}.`), !0;
  }
  setVisibility(t, e = !0, n = !0) {
    var r;
    const s = w(this, Ni).get(t);
    if (!s) {
      pn(`Optional content group not found: ${t}`);
      return;
    }
    if (n && e && s.rbGroups.length)
      for (const a of s.rbGroups)
        for (const o of a)
          o !== t && ((r = w(this, Ni).get(o)) == null || r._setVisible(mb, !1, !0));
    s._setVisible(mb, !!e, !0), rt(this, ch, null);
  }
  setOCGState({
    state: t,
    preserveRB: e
  }) {
    let n;
    for (const s of t) {
      switch (s) {
        case "ON":
        case "OFF":
        case "Toggle":
          n = s;
          continue;
      }
      const r = w(this, Ni).get(s);
      if (r)
        switch (n) {
          case "ON":
            this.setVisibility(s, !0, e);
            break;
          case "OFF":
            this.setVisibility(s, !1, e);
            break;
          case "Toggle":
            this.setVisibility(s, !r.visible, e);
            break;
        }
    }
    rt(this, ch, null);
  }
  get hasInitialVisibility() {
    return w(this, Nf) === null || this.getHash() === w(this, Nf);
  }
  getOrder() {
    return w(this, Ni).size ? w(this, Wf) ? w(this, Wf).slice() : [...w(this, Ni).keys()] : null;
  }
  getGroup(t) {
    return w(this, Ni).get(t) || null;
  }
  getHash() {
    if (w(this, ch) !== null)
      return w(this, ch);
    const t = new aK();
    for (const [e, n] of w(this, Ni))
      t.update(`${e}:${n.visible}`);
    return rt(this, ch, t.hexdigest());
  }
  [Symbol.iterator]() {
    return w(this, Ni).entries();
  }
}
ch = new WeakMap(), Ni = new WeakMap(), Nf = new WeakMap(), Wf = new WeakMap(), LZ = new WeakSet(), KV = function(t) {
  const e = t.length;
  if (e < 2)
    return !0;
  const n = t[0];
  for (let s = 1; s < e; s++) {
    const r = t[s];
    let a;
    if (Array.isArray(r))
      a = ft(this, LZ, KV).call(this, r);
    else if (w(this, Ni).has(r))
      a = w(this, Ni).get(r).visible;
    else
      return pn(`Optional content group not found: ${r}`), !0;
    switch (n) {
      case "And":
        if (!a)
          return !1;
        break;
      case "Or":
        if (a)
          return !0;
        break;
      case "Not":
        return !a;
      default:
        return !0;
    }
  }
  return n === "And";
};
class $It {
  constructor(t, {
    disableRange: e = !1,
    disableStream: n = !1
  }) {
    Pn(t, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
    const {
      length: s,
      initialData: r,
      progressiveDone: a,
      contentDispositionFilename: o
    } = t;
    if (this._queuedChunks = [], this._progressiveDone = a, this._contentDispositionFilename = o, (r == null ? void 0 : r.length) > 0) {
      const l = r instanceof Uint8Array && r.byteLength === r.buffer.byteLength ? r.buffer : new Uint8Array(r).buffer;
      this._queuedChunks.push(l);
    }
    this._pdfDataRangeTransport = t, this._isStreamingSupported = !n, this._isRangeSupported = !e, this._contentLength = s, this._fullRequestReader = null, this._rangeReaders = [], t.addRangeListener((l, c) => {
      this._onReceiveData({
        begin: l,
        chunk: c
      });
    }), t.addProgressListener((l, c) => {
      this._onProgress({
        loaded: l,
        total: c
      });
    }), t.addProgressiveReadListener((l) => {
      this._onReceiveData({
        chunk: l
      });
    }), t.addProgressiveDoneListener(() => {
      this._onProgressiveDone();
    }), t.transportReady();
  }
  _onReceiveData({
    begin: t,
    chunk: e
  }) {
    const n = e instanceof Uint8Array && e.byteLength === e.buffer.byteLength ? e.buffer : new Uint8Array(e).buffer;
    if (t === void 0)
      this._fullRequestReader ? this._fullRequestReader._enqueue(n) : this._queuedChunks.push(n);
    else {
      const s = this._rangeReaders.some(function(r) {
        return r._begin !== t ? !1 : (r._enqueue(n), !0);
      });
      Pn(s, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
    }
  }
  get _progressiveDataLength() {
    var t;
    return ((t = this._fullRequestReader) == null ? void 0 : t._loaded) ?? 0;
  }
  _onProgress(t) {
    var e, n, s, r;
    t.total === void 0 ? (n = (e = this._rangeReaders[0]) == null ? void 0 : e.onProgress) == null || n.call(e, {
      loaded: t.loaded
    }) : (r = (s = this._fullRequestReader) == null ? void 0 : s.onProgress) == null || r.call(s, {
      loaded: t.loaded,
      total: t.total
    });
  }
  _onProgressiveDone() {
    var t;
    (t = this._fullRequestReader) == null || t.progressiveDone(), this._progressiveDone = !0;
  }
  _removeRangeReader(t) {
    const e = this._rangeReaders.indexOf(t);
    e >= 0 && this._rangeReaders.splice(e, 1);
  }
  getFullReader() {
    Pn(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
    const t = this._queuedChunks;
    return this._queuedChunks = null, new qIt(this, t, this._progressiveDone, this._contentDispositionFilename);
  }
  getRangeReader(t, e) {
    if (e <= this._progressiveDataLength)
      return null;
    const n = new tCt(this, t, e);
    return this._pdfDataRangeTransport.requestDataRange(t, e), this._rangeReaders.push(n), n;
  }
  cancelAllRequests(t) {
    var e;
    (e = this._fullRequestReader) == null || e.cancel(t);
    for (const n of this._rangeReaders.slice(0))
      n.cancel(t);
    this._pdfDataRangeTransport.abort();
  }
}
class qIt {
  constructor(t, e, n = !1, s = null) {
    this._stream = t, this._done = n || !1, this._filename = qC(s) ? s : null, this._queuedChunks = e || [], this._loaded = 0;
    for (const r of this._queuedChunks)
      this._loaded += r.byteLength;
    this._requests = [], this._headersReady = Promise.resolve(), t._fullRequestReader = this, this.onProgress = null;
  }
  _enqueue(t) {
    this._done || (this._requests.length > 0 ? this._requests.shift().resolve({
      value: t,
      done: !1
    }) : this._queuedChunks.push(t), this._loaded += t.byteLength);
  }
  get headersReady() {
    return this._headersReady;
  }
  get filename() {
    return this._filename;
  }
  get isRangeSupported() {
    return this._stream._isRangeSupported;
  }
  get isStreamingSupported() {
    return this._stream._isStreamingSupported;
  }
  get contentLength() {
    return this._stream._contentLength;
  }
  async read() {
    if (this._queuedChunks.length > 0)
      return {
        value: this._queuedChunks.shift(),
        done: !1
      };
    if (this._done)
      return {
        value: void 0,
        done: !0
      };
    const t = Promise.withResolvers();
    return this._requests.push(t), t.promise;
  }
  cancel(t) {
    this._done = !0;
    for (const e of this._requests)
      e.resolve({
        value: void 0,
        done: !0
      });
    this._requests.length = 0;
  }
  progressiveDone() {
    this._done || (this._done = !0);
  }
}
class tCt {
  constructor(t, e, n) {
    this._stream = t, this._begin = e, this._end = n, this._queuedChunk = null, this._requests = [], this._done = !1, this.onProgress = null;
  }
  _enqueue(t) {
    if (!this._done) {
      if (this._requests.length === 0)
        this._queuedChunk = t;
      else {
        this._requests.shift().resolve({
          value: t,
          done: !1
        });
        for (const n of this._requests)
          n.resolve({
            value: void 0,
            done: !0
          });
        this._requests.length = 0;
      }
      this._done = !0, this._stream._removeRangeReader(this);
    }
  }
  get isStreamingSupported() {
    return !1;
  }
  async read() {
    if (this._queuedChunk) {
      const e = this._queuedChunk;
      return this._queuedChunk = null, {
        value: e,
        done: !1
      };
    }
    if (this._done)
      return {
        value: void 0,
        done: !0
      };
    const t = Promise.withResolvers();
    return this._requests.push(t), t.promise;
  }
  cancel(t) {
    this._done = !0;
    for (const e of this._requests)
      e.resolve({
        value: void 0,
        done: !0
      });
    this._requests.length = 0, this._stream._removeRangeReader(this);
  }
}
function eCt(i) {
  let t = !0, e = n("filename\\*", "i").exec(i);
  if (e) {
    e = e[1];
    let u = o(e);
    return u = unescape(u), u = l(u), u = c(u), r(u);
  }
  if (e = a(i), e) {
    const u = c(e);
    return r(u);
  }
  if (e = n("filename", "i").exec(i), e) {
    e = e[1];
    let u = o(e);
    return u = c(u), r(u);
  }
  function n(u, d) {
    return new RegExp("(?:^|;)\\s*" + u + '\\s*=\\s*([^";\\s][^;\\s]*|"(?:[^"\\\\]|\\\\"?)+"?)', d);
  }
  function s(u, d) {
    if (u) {
      if (!/^[\x00-\xFF]+$/.test(d))
        return d;
      try {
        const h = new TextDecoder(u, {
          fatal: !0
        }), p = KT(d);
        d = h.decode(p), t = !1;
      } catch {
      }
    }
    return d;
  }
  function r(u) {
    return t && /[\x80-\xff]/.test(u) && (u = s("utf-8", u), t && (u = s("iso-8859-1", u))), u;
  }
  function a(u) {
    const d = [];
    let h;
    const p = n("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
    for (; (h = p.exec(u)) !== null; ) {
      let [, b, y, Z] = h;
      if (b = parseInt(b, 10), b in d) {
        if (b === 0)
          break;
        continue;
      }
      d[b] = [y, Z];
    }
    const m = [];
    for (let b = 0; b < d.length && b in d; ++b) {
      let [y, Z] = d[b];
      Z = o(Z), y && (Z = unescape(Z), b === 0 && (Z = l(Z))), m.push(Z);
    }
    return m.join("");
  }
  function o(u) {
    if (u.startsWith('"')) {
      const d = u.slice(1).split('\\"');
      for (let h = 0; h < d.length; ++h) {
        const p = d[h].indexOf('"');
        p !== -1 && (d[h] = d[h].slice(0, p), d.length = h + 1), d[h] = d[h].replaceAll(/\\(.)/g, "$1");
      }
      u = d.join('"');
    }
    return u;
  }
  function l(u) {
    const d = u.indexOf("'");
    if (d === -1)
      return u;
    const h = u.slice(0, d), m = u.slice(d + 1).replace(/^[^']*'/, "");
    return s(h, m);
  }
  function c(u) {
    return !u.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(u) ? u : u.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(d, h, p, m) {
      if (p === "q" || p === "Q")
        return m = m.replaceAll("_", " "), m = m.replaceAll(/=([0-9a-fA-F]{2})/g, function(b, y) {
          return String.fromCharCode(parseInt(y, 16));
        }), s(h, m);
      try {
        m = atob(m);
      } catch {
      }
      return s(h, m);
    });
  }
  return "";
}
function yK(i, t) {
  const e = new Headers();
  if (!i || !t || typeof t != "object")
    return e;
  for (const n in t) {
    const s = t[n];
    s !== void 0 && e.append(n, s);
  }
  return e;
}
function gw(i) {
  var t;
  return ((t = URL.parse(i)) == null ? void 0 : t.origin) ?? null;
}
function ZK({
  responseHeaders: i,
  isHttp: t,
  rangeChunkSize: e,
  disableRange: n
}) {
  const s = {
    allowRangeRequests: !1,
    suggestedLength: void 0
  }, r = parseInt(i.get("Content-Length"), 10);
  return !Number.isInteger(r) || (s.suggestedLength = r, r <= 2 * e) || n || !t || i.get("Accept-Ranges") !== "bytes" || (i.get("Content-Encoding") || "identity") !== "identity" || (s.allowRangeRequests = !0), s;
}
function TK(i) {
  const t = i.get("Content-Disposition");
  if (t) {
    let e = eCt(t);
    if (e.includes("%"))
      try {
        e = decodeURIComponent(e);
      } catch {
      }
    if (qC(e))
      return e;
  }
  return null;
}
function qT(i, t) {
  return new PW(`Unexpected server response (${i}) while retrieving PDF "${t}".`, i, i === 404 || i === 0 && t.startsWith("file:"));
}
function MK(i) {
  return i === 200 || i === 206;
}
function NK(i, t, e) {
  return {
    method: "GET",
    headers: i,
    signal: e.signal,
    mode: "cors",
    credentials: t ? "include" : "same-origin",
    redirect: "follow"
  };
}
function WK(i) {
  return i instanceof Uint8Array ? i.buffer : i instanceof ArrayBuffer ? i : (pn(`getArrayBuffer - unexpected data format: ${i}`), new Uint8Array(i).buffer);
}
class nCt {
  constructor(t) {
    S(this, "_responseOrigin", null);
    this.source = t, this.isHttp = /^https?:/i.test(t.url), this.headers = yK(this.isHttp, t.httpHeaders), this._fullRequestReader = null, this._rangeRequestReaders = [];
  }
  get _progressiveDataLength() {
    var t;
    return ((t = this._fullRequestReader) == null ? void 0 : t._loaded) ?? 0;
  }
  getFullReader() {
    return Pn(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once."), this._fullRequestReader = new iCt(this), this._fullRequestReader;
  }
  getRangeReader(t, e) {
    if (e <= this._progressiveDataLength)
      return null;
    const n = new sCt(this, t, e);
    return this._rangeRequestReaders.push(n), n;
  }
  cancelAllRequests(t) {
    var e;
    (e = this._fullRequestReader) == null || e.cancel(t);
    for (const n of this._rangeRequestReaders.slice(0))
      n.cancel(t);
  }
}
class iCt {
  constructor(t) {
    this._stream = t, this._reader = null, this._loaded = 0, this._filename = null;
    const e = t.source;
    this._withCredentials = e.withCredentials || !1, this._contentLength = e.length, this._headersCapability = Promise.withResolvers(), this._disableRange = e.disableRange || !1, this._rangeChunkSize = e.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._abortController = new AbortController(), this._isStreamingSupported = !e.disableStream, this._isRangeSupported = !e.disableRange;
    const n = new Headers(t.headers), s = e.url;
    fetch(s, NK(n, this._withCredentials, this._abortController)).then((r) => {
      if (t._responseOrigin = gw(r.url), !MK(r.status))
        throw qT(r.status, s);
      this._reader = r.body.getReader(), this._headersCapability.resolve();
      const a = r.headers, {
        allowRangeRequests: o,
        suggestedLength: l
      } = ZK({
        responseHeaders: a,
        isHttp: t.isHttp,
        rangeChunkSize: this._rangeChunkSize,
        disableRange: this._disableRange
      });
      this._isRangeSupported = o, this._contentLength = l || this._contentLength, this._filename = TK(a), !this._isStreamingSupported && this._isRangeSupported && this.cancel(new $h("Streaming is disabled."));
    }).catch(this._headersCapability.reject), this.onProgress = null;
  }
  get headersReady() {
    return this._headersCapability.promise;
  }
  get filename() {
    return this._filename;
  }
  get contentLength() {
    return this._contentLength;
  }
  get isRangeSupported() {
    return this._isRangeSupported;
  }
  get isStreamingSupported() {
    return this._isStreamingSupported;
  }
  async read() {
    var n;
    await this._headersCapability.promise;
    const {
      value: t,
      done: e
    } = await this._reader.read();
    return e ? {
      value: t,
      done: e
    } : (this._loaded += t.byteLength, (n = this.onProgress) == null || n.call(this, {
      loaded: this._loaded,
      total: this._contentLength
    }), {
      value: WK(t),
      done: !1
    });
  }
  cancel(t) {
    var e;
    (e = this._reader) == null || e.cancel(t), this._abortController.abort();
  }
}
class sCt {
  constructor(t, e, n) {
    this._stream = t, this._reader = null, this._loaded = 0;
    const s = t.source;
    this._withCredentials = s.withCredentials || !1, this._readCapability = Promise.withResolvers(), this._isStreamingSupported = !s.disableStream, this._abortController = new AbortController();
    const r = new Headers(t.headers);
    r.append("Range", `bytes=${e}-${n - 1}`);
    const a = s.url;
    fetch(a, NK(r, this._withCredentials, this._abortController)).then((o) => {
      const l = gw(o.url);
      if (l !== t._responseOrigin)
        throw new Error(`Expected range response-origin "${l}" to match "${t._responseOrigin}".`);
      if (!MK(o.status))
        throw qT(o.status, a);
      this._readCapability.resolve(), this._reader = o.body.getReader();
    }).catch(this._readCapability.reject), this.onProgress = null;
  }
  get isStreamingSupported() {
    return this._isStreamingSupported;
  }
  async read() {
    var n;
    await this._readCapability.promise;
    const {
      value: t,
      done: e
    } = await this._reader.read();
    return e ? {
      value: t,
      done: e
    } : (this._loaded += t.byteLength, (n = this.onProgress) == null || n.call(this, {
      loaded: this._loaded
    }), {
      value: WK(t),
      done: !1
    });
  }
  cancel(t) {
    var e;
    (e = this._reader) == null || e.cancel(t), this._abortController.abort();
  }
}
const zS = 200, ES = 206;
function rCt(i) {
  const t = i.response;
  return typeof t != "string" ? t : KT(t).buffer;
}
class aCt {
  constructor({
    url: t,
    httpHeaders: e,
    withCredentials: n
  }) {
    S(this, "_responseOrigin", null);
    this.url = t, this.isHttp = /^https?:/i.test(t), this.headers = yK(this.isHttp, e), this.withCredentials = n || !1, this.currXhrId = 0, this.pendingRequests = /* @__PURE__ */ Object.create(null);
  }
  request(t) {
    const e = new XMLHttpRequest(), n = this.currXhrId++, s = this.pendingRequests[n] = {
      xhr: e
    };
    e.open("GET", this.url), e.withCredentials = this.withCredentials;
    for (const [r, a] of this.headers)
      e.setRequestHeader(r, a);
    return this.isHttp && "begin" in t && "end" in t ? (e.setRequestHeader("Range", `bytes=${t.begin}-${t.end - 1}`), s.expectedStatus = ES) : s.expectedStatus = zS, e.responseType = "arraybuffer", Pn(t.onError, "Expected `onError` callback to be provided."), e.onerror = () => {
      t.onError(e.status);
    }, e.onreadystatechange = this.onStateChange.bind(this, n), e.onprogress = this.onProgress.bind(this, n), s.onHeadersReceived = t.onHeadersReceived, s.onDone = t.onDone, s.onError = t.onError, s.onProgress = t.onProgress, e.send(null), n;
  }
  onProgress(t, e) {
    var s;
    const n = this.pendingRequests[t];
    n && ((s = n.onProgress) == null || s.call(n, e));
  }
  onStateChange(t, e) {
    const n = this.pendingRequests[t];
    if (!n)
      return;
    const s = n.xhr;
    if (s.readyState >= 2 && n.onHeadersReceived && (n.onHeadersReceived(), delete n.onHeadersReceived), s.readyState !== 4 || !(t in this.pendingRequests))
      return;
    if (delete this.pendingRequests[t], s.status === 0 && this.isHttp) {
      n.onError(s.status);
      return;
    }
    const r = s.status || zS;
    if (!(r === zS && n.expectedStatus === ES) && r !== n.expectedStatus) {
      n.onError(s.status);
      return;
    }
    const o = rCt(s);
    if (r === ES) {
      const l = s.getResponseHeader("Content-Range"), c = /bytes (\d+)-(\d+)\/(\d+)/.exec(l);
      c ? n.onDone({
        begin: parseInt(c[1], 10),
        chunk: o
      }) : (pn('Missing or invalid "Content-Range" header.'), n.onError(0));
    } else o ? n.onDone({
      begin: 0,
      chunk: o
    }) : n.onError(s.status);
  }
  getRequestXhr(t) {
    return this.pendingRequests[t].xhr;
  }
  isPendingRequest(t) {
    return t in this.pendingRequests;
  }
  abortRequest(t) {
    const e = this.pendingRequests[t].xhr;
    delete this.pendingRequests[t], e.abort();
  }
}
class oCt {
  constructor(t) {
    this._source = t, this._manager = new aCt(t), this._rangeChunkSize = t.rangeChunkSize, this._fullRequestReader = null, this._rangeRequestReaders = [];
  }
  _onRangeRequestReaderClosed(t) {
    const e = this._rangeRequestReaders.indexOf(t);
    e >= 0 && this._rangeRequestReaders.splice(e, 1);
  }
  getFullReader() {
    return Pn(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once."), this._fullRequestReader = new lCt(this._manager, this._source), this._fullRequestReader;
  }
  getRangeReader(t, e) {
    const n = new cCt(this._manager, t, e);
    return n.onClosed = this._onRangeRequestReaderClosed.bind(this), this._rangeRequestReaders.push(n), n;
  }
  cancelAllRequests(t) {
    var e;
    (e = this._fullRequestReader) == null || e.cancel(t);
    for (const n of this._rangeRequestReaders.slice(0))
      n.cancel(t);
  }
}
class lCt {
  constructor(t, e) {
    this._manager = t, this._url = e.url, this._fullRequestId = t.request({
      onHeadersReceived: this._onHeadersReceived.bind(this),
      onDone: this._onDone.bind(this),
      onError: this._onError.bind(this),
      onProgress: this._onProgress.bind(this)
    }), this._headersCapability = Promise.withResolvers(), this._disableRange = e.disableRange || !1, this._contentLength = e.length, this._rangeChunkSize = e.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !1, this._isRangeSupported = !1, this._cachedChunks = [], this._requests = [], this._done = !1, this._storedError = void 0, this._filename = null, this.onProgress = null;
  }
  _onHeadersReceived() {
    const t = this._fullRequestId, e = this._manager.getRequestXhr(t);
    this._manager._responseOrigin = gw(e.responseURL);
    const n = e.getAllResponseHeaders(), s = new Headers(n ? n.trimStart().replace(/[^\S ]+$/, "").split(/[\r\n]+/).map((o) => {
      const [l, ...c] = o.split(": ");
      return [l, c.join(": ")];
    }) : []), {
      allowRangeRequests: r,
      suggestedLength: a
    } = ZK({
      responseHeaders: s,
      isHttp: this._manager.isHttp,
      rangeChunkSize: this._rangeChunkSize,
      disableRange: this._disableRange
    });
    r && (this._isRangeSupported = !0), this._contentLength = a || this._contentLength, this._filename = TK(s), this._isRangeSupported && this._manager.abortRequest(t), this._headersCapability.resolve();
  }
  _onDone(t) {
    if (t && (this._requests.length > 0 ? this._requests.shift().resolve({
      value: t.chunk,
      done: !1
    }) : this._cachedChunks.push(t.chunk)), this._done = !0, !(this._cachedChunks.length > 0)) {
      for (const e of this._requests)
        e.resolve({
          value: void 0,
          done: !0
        });
      this._requests.length = 0;
    }
  }
  _onError(t) {
    this._storedError = qT(t, this._url), this._headersCapability.reject(this._storedError);
    for (const e of this._requests)
      e.reject(this._storedError);
    this._requests.length = 0, this._cachedChunks.length = 0;
  }
  _onProgress(t) {
    var e;
    (e = this.onProgress) == null || e.call(this, {
      loaded: t.loaded,
      total: t.lengthComputable ? t.total : this._contentLength
    });
  }
  get filename() {
    return this._filename;
  }
  get isRangeSupported() {
    return this._isRangeSupported;
  }
  get isStreamingSupported() {
    return this._isStreamingSupported;
  }
  get contentLength() {
    return this._contentLength;
  }
  get headersReady() {
    return this._headersCapability.promise;
  }
  async read() {
    if (await this._headersCapability.promise, this._storedError)
      throw this._storedError;
    if (this._cachedChunks.length > 0)
      return {
        value: this._cachedChunks.shift(),
        done: !1
      };
    if (this._done)
      return {
        value: void 0,
        done: !0
      };
    const t = Promise.withResolvers();
    return this._requests.push(t), t.promise;
  }
  cancel(t) {
    this._done = !0, this._headersCapability.reject(t);
    for (const e of this._requests)
      e.resolve({
        value: void 0,
        done: !0
      });
    this._requests.length = 0, this._manager.isPendingRequest(this._fullRequestId) && this._manager.abortRequest(this._fullRequestId), this._fullRequestReader = null;
  }
}
class cCt {
  constructor(t, e, n) {
    this._manager = t, this._url = t.url, this._requestId = t.request({
      begin: e,
      end: n,
      onHeadersReceived: this._onHeadersReceived.bind(this),
      onDone: this._onDone.bind(this),
      onError: this._onError.bind(this),
      onProgress: this._onProgress.bind(this)
    }), this._requests = [], this._queuedChunk = null, this._done = !1, this._storedError = void 0, this.onProgress = null, this.onClosed = null;
  }
  _onHeadersReceived() {
    var e;
    const t = gw((e = this._manager.getRequestXhr(this._requestId)) == null ? void 0 : e.responseURL);
    t !== this._manager._responseOrigin && (this._storedError = new Error(`Expected range response-origin "${t}" to match "${this._manager._responseOrigin}".`), this._onError(0));
  }
  _close() {
    var t;
    (t = this.onClosed) == null || t.call(this, this);
  }
  _onDone(t) {
    const e = t.chunk;
    this._requests.length > 0 ? this._requests.shift().resolve({
      value: e,
      done: !1
    }) : this._queuedChunk = e, this._done = !0;
    for (const n of this._requests)
      n.resolve({
        value: void 0,
        done: !0
      });
    this._requests.length = 0, this._close();
  }
  _onError(t) {
    this._storedError ?? (this._storedError = qT(t, this._url));
    for (const e of this._requests)
      e.reject(this._storedError);
    this._requests.length = 0, this._queuedChunk = null;
  }
  _onProgress(t) {
    var e;
    this.isStreamingSupported || (e = this.onProgress) == null || e.call(this, {
      loaded: t.loaded
    });
  }
  get isStreamingSupported() {
    return !1;
  }
  async read() {
    if (this._storedError)
      throw this._storedError;
    if (this._queuedChunk !== null) {
      const e = this._queuedChunk;
      return this._queuedChunk = null, {
        value: e,
        done: !1
      };
    }
    if (this._done)
      return {
        value: void 0,
        done: !0
      };
    const t = Promise.withResolvers();
    return this._requests.push(t), t.promise;
  }
  cancel(t) {
    this._done = !0;
    for (const e of this._requests)
      e.resolve({
        value: void 0,
        done: !0
      });
    this._requests.length = 0, this._manager.isPendingRequest(this._requestId) && this._manager.abortRequest(this._requestId), this._close();
  }
}
const uCt = /^[a-z][a-z0-9\-+.]+:/i;
function dCt(i) {
  if (uCt.test(i))
    return new URL(i);
  const t = process.getBuiltinModule("url");
  return new URL(t.pathToFileURL(i));
}
class hCt {
  constructor(t) {
    this.source = t, this.url = dCt(t.url), Pn(this.url.protocol === "file:", "PDFNodeStream only supports file:// URLs."), this._fullRequestReader = null, this._rangeRequestReaders = [];
  }
  get _progressiveDataLength() {
    var t;
    return ((t = this._fullRequestReader) == null ? void 0 : t._loaded) ?? 0;
  }
  getFullReader() {
    return Pn(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once."), this._fullRequestReader = new pCt(this), this._fullRequestReader;
  }
  getRangeReader(t, e) {
    if (e <= this._progressiveDataLength)
      return null;
    const n = new mCt(this, t, e);
    return this._rangeRequestReaders.push(n), n;
  }
  cancelAllRequests(t) {
    var e;
    (e = this._fullRequestReader) == null || e.cancel(t);
    for (const n of this._rangeRequestReaders.slice(0))
      n.cancel(t);
  }
}
class pCt {
  constructor(t) {
    this._url = t.url, this._done = !1, this._storedError = null, this.onProgress = null;
    const e = t.source;
    this._contentLength = e.length, this._loaded = 0, this._filename = null, this._disableRange = e.disableRange || !1, this._rangeChunkSize = e.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !e.disableStream, this._isRangeSupported = !e.disableRange, this._readableStream = null, this._readCapability = Promise.withResolvers(), this._headersCapability = Promise.withResolvers();
    const n = process.getBuiltinModule("fs");
    n.promises.lstat(this._url).then((s) => {
      this._contentLength = s.size, this._setReadableStream(n.createReadStream(this._url)), this._headersCapability.resolve();
    }, (s) => {
      s.code === "ENOENT" && (s = qT(0, this._url.href)), this._storedError = s, this._headersCapability.reject(s);
    });
  }
  get headersReady() {
    return this._headersCapability.promise;
  }
  get filename() {
    return this._filename;
  }
  get contentLength() {
    return this._contentLength;
  }
  get isRangeSupported() {
    return this._isRangeSupported;
  }
  get isStreamingSupported() {
    return this._isStreamingSupported;
  }
  async read() {
    var n;
    if (await this._readCapability.promise, this._done)
      return {
        value: void 0,
        done: !0
      };
    if (this._storedError)
      throw this._storedError;
    const t = this._readableStream.read();
    return t === null ? (this._readCapability = Promise.withResolvers(), this.read()) : (this._loaded += t.length, (n = this.onProgress) == null || n.call(this, {
      loaded: this._loaded,
      total: this._contentLength
    }), {
      value: new Uint8Array(t).buffer,
      done: !1
    });
  }
  cancel(t) {
    if (!this._readableStream) {
      this._error(t);
      return;
    }
    this._readableStream.destroy(t);
  }
  _error(t) {
    this._storedError = t, this._readCapability.resolve();
  }
  _setReadableStream(t) {
    this._readableStream = t, t.on("readable", () => {
      this._readCapability.resolve();
    }), t.on("end", () => {
      t.destroy(), this._done = !0, this._readCapability.resolve();
    }), t.on("error", (e) => {
      this._error(e);
    }), !this._isStreamingSupported && this._isRangeSupported && this._error(new $h("streaming is disabled")), this._storedError && this._readableStream.destroy(this._storedError);
  }
}
class mCt {
  constructor(t, e, n) {
    this._url = t.url, this._done = !1, this._storedError = null, this.onProgress = null, this._loaded = 0, this._readableStream = null, this._readCapability = Promise.withResolvers();
    const s = t.source;
    this._isStreamingSupported = !s.disableStream;
    const r = process.getBuiltinModule("fs");
    this._setReadableStream(r.createReadStream(this._url, {
      start: e,
      end: n - 1
    }));
  }
  get isStreamingSupported() {
    return this._isStreamingSupported;
  }
  async read() {
    var n;
    if (await this._readCapability.promise, this._done)
      return {
        value: void 0,
        done: !0
      };
    if (this._storedError)
      throw this._storedError;
    const t = this._readableStream.read();
    return t === null ? (this._readCapability = Promise.withResolvers(), this.read()) : (this._loaded += t.length, (n = this.onProgress) == null || n.call(this, {
      loaded: this._loaded
    }), {
      value: new Uint8Array(t).buffer,
      done: !1
    });
  }
  cancel(t) {
    if (!this._readableStream) {
      this._error(t);
      return;
    }
    this._readableStream.destroy(t);
  }
  _error(t) {
    this._storedError = t, this._readCapability.resolve();
  }
  _setReadableStream(t) {
    this._readableStream = t, t.on("readable", () => {
      this._readCapability.resolve();
    }), t.on("end", () => {
      t.destroy(), this._done = !0, this._readCapability.resolve();
    }), t.on("error", (e) => {
      this._error(e);
    }), this._storedError && this._readableStream.destroy(this._storedError);
  }
}
const dy = Symbol("INITIAL_DATA");
var eo, VZ, HV;
class GK {
  constructor() {
    pt(this, VZ);
    pt(this, eo, /* @__PURE__ */ Object.create(null));
  }
  get(t, e = null) {
    if (e) {
      const s = ft(this, VZ, HV).call(this, t);
      return s.promise.then(() => e(s.data)), null;
    }
    const n = w(this, eo)[t];
    if (!n || n.data === dy)
      throw new Error(`Requesting object that isn't resolved yet ${t}.`);
    return n.data;
  }
  has(t) {
    const e = w(this, eo)[t];
    return !!e && e.data !== dy;
  }
  delete(t) {
    const e = w(this, eo)[t];
    return !e || e.data === dy ? !1 : (delete w(this, eo)[t], !0);
  }
  resolve(t, e = null) {
    const n = ft(this, VZ, HV).call(this, t);
    n.data = e, n.resolve();
  }
  clear() {
    var t;
    for (const e in w(this, eo)) {
      const {
        data: n
      } = w(this, eo)[e];
      (t = n == null ? void 0 : n.bitmap) == null || t.close();
    }
    rt(this, eo, /* @__PURE__ */ Object.create(null));
  }
  *[Symbol.iterator]() {
    for (const t in w(this, eo)) {
      const {
        data: e
      } = w(this, eo)[t];
      e !== dy && (yield [t, e]);
    }
  }
}
eo = new WeakMap(), VZ = new WeakSet(), HV = function(t) {
  var e;
  return (e = w(this, eo))[t] || (e[t] = {
    ...Promise.withResolvers(),
    data: dy
  });
};
const bCt = 1e5, jE = 30;
var n3, uh, Oa, XZ, IZ, Wm, Iu, CZ, YZ, Gm, Gf, wf, dh, xf, vZ, Sf, wm, RZ, DZ, Lf, xm, OZ, hh, Vf, pd, wK, xK, _V, So, vN, QV, SK, LK;
const Hs = class Hs {
  constructor({
    textContentSource: t,
    container: e,
    viewport: n
  }) {
    pt(this, pd);
    pt(this, uh, Promise.withResolvers());
    pt(this, Oa, null);
    pt(this, XZ, !1);
    pt(this, IZ, !!((n3 = globalThis.FontInspector) != null && n3.enabled));
    pt(this, Wm, null);
    pt(this, Iu, null);
    pt(this, CZ, 0);
    pt(this, YZ, 0);
    pt(this, Gm, null);
    pt(this, Gf, null);
    pt(this, wf, 0);
    pt(this, dh, 0);
    pt(this, xf, /* @__PURE__ */ Object.create(null));
    pt(this, vZ, []);
    pt(this, Sf, null);
    pt(this, wm, []);
    pt(this, RZ, /* @__PURE__ */ new WeakMap());
    pt(this, DZ, null);
    var l;
    if (t instanceof ReadableStream)
      rt(this, Sf, t);
    else if (typeof t == "object")
      rt(this, Sf, new ReadableStream({
        start(c) {
          c.enqueue(t), c.close();
        }
      }));
    else
      throw new Error('No "textContentSource" parameter specified.');
    rt(this, Oa, rt(this, Gf, e)), rt(this, dh, n.scale * Uc.pixelRatio), rt(this, wf, n.rotation), rt(this, Iu, {
      div: null,
      properties: null,
      ctx: null
    });
    const {
      pageWidth: s,
      pageHeight: r,
      pageX: a,
      pageY: o
    } = n.rawDims;
    rt(this, DZ, [1, 0, 0, -1, -a, o + r]), rt(this, YZ, s), rt(this, CZ, r), ft(l = Hs, So, SK).call(l), W0(e, n), w(this, uh).promise.finally(() => {
      w(Hs, Vf).delete(this), rt(this, Iu, null), rt(this, xf, null);
    }).catch(() => {
    });
  }
  static get fontFamilyMap() {
    const {
      isWindows: t,
      isFirefox: e
    } = Er.platform;
    return Gn(this, "fontFamilyMap", /* @__PURE__ */ new Map([["sans-serif", `${t && e ? "Calibri, " : ""}sans-serif`], ["monospace", `${t && e ? "Lucida Console, " : ""}monospace`]]));
  }
  render() {
    const t = () => {
      w(this, Gm).read().then(({
        value: e,
        done: n
      }) => {
        if (n) {
          w(this, uh).resolve();
          return;
        }
        w(this, Wm) ?? rt(this, Wm, e.lang), Object.assign(w(this, xf), e.styles), ft(this, pd, wK).call(this, e.items), t();
      }, w(this, uh).reject);
    };
    return rt(this, Gm, w(this, Sf).getReader()), w(Hs, Vf).add(this), t(), w(this, uh).promise;
  }
  update({
    viewport: t,
    onBefore: e = null
  }) {
    var r;
    const n = t.scale * Uc.pixelRatio, s = t.rotation;
    if (s !== w(this, wf) && (e == null || e(), rt(this, wf, s), W0(w(this, Gf), {
      rotation: s
    })), n !== w(this, dh)) {
      e == null || e(), rt(this, dh, n);
      const a = {
        div: null,
        properties: null,
        ctx: ft(r = Hs, So, vN).call(r, w(this, Wm))
      };
      for (const o of w(this, wm))
        a.properties = w(this, RZ).get(o), a.div = o, ft(this, pd, _V).call(this, a);
    }
  }
  cancel() {
    var e;
    const t = new $h("TextLayer task cancelled.");
    (e = w(this, Gm)) == null || e.cancel(t).catch(() => {
    }), rt(this, Gm, null), w(this, uh).reject(t);
  }
  get textDivs() {
    return w(this, wm);
  }
  get textContentItemsStr() {
    return w(this, vZ);
  }
  static cleanup() {
    if (!(w(this, Vf).size > 0)) {
      w(this, Lf).clear();
      for (const {
        canvas: t
      } of w(this, xm).values())
        t.remove();
      w(this, xm).clear();
    }
  }
};
uh = new WeakMap(), Oa = new WeakMap(), XZ = new WeakMap(), IZ = new WeakMap(), Wm = new WeakMap(), Iu = new WeakMap(), CZ = new WeakMap(), YZ = new WeakMap(), Gm = new WeakMap(), Gf = new WeakMap(), wf = new WeakMap(), dh = new WeakMap(), xf = new WeakMap(), vZ = new WeakMap(), Sf = new WeakMap(), wm = new WeakMap(), RZ = new WeakMap(), DZ = new WeakMap(), Lf = new WeakMap(), xm = new WeakMap(), OZ = new WeakMap(), hh = new WeakMap(), Vf = new WeakMap(), pd = new WeakSet(), wK = function(t) {
  var s, r;
  if (w(this, XZ))
    return;
  (r = w(this, Iu)).ctx ?? (r.ctx = ft(s = Hs, So, vN).call(s, w(this, Wm)));
  const e = w(this, wm), n = w(this, vZ);
  for (const a of t) {
    if (e.length > bCt) {
      pn("Ignoring additional textDivs for performance reasons."), rt(this, XZ, !0);
      return;
    }
    if (a.str === void 0) {
      if (a.type === "beginMarkedContentProps" || a.type === "beginMarkedContent") {
        const o = w(this, Oa);
        rt(this, Oa, document.createElement("span")), w(this, Oa).classList.add("markedContent"), a.id && w(this, Oa).setAttribute("id", `${a.id}`), o.append(w(this, Oa));
      } else a.type === "endMarkedContent" && rt(this, Oa, w(this, Oa).parentNode);
      continue;
    }
    n.push(a.str), ft(this, pd, xK).call(this, a);
  }
}, xK = function(t) {
  var b;
  const e = document.createElement("span"), n = {
    angle: 0,
    canvasWidth: 0,
    hasText: t.str !== "",
    hasEOL: t.hasEOL,
    fontSize: 0
  };
  w(this, wm).push(e);
  const s = ze.transform(w(this, DZ), t.transform);
  let r = Math.atan2(s[1], s[0]);
  const a = w(this, xf)[t.fontName];
  a.vertical && (r += Math.PI / 2);
  let o = w(this, IZ) && a.fontSubstitution || a.fontFamily;
  o = Hs.fontFamilyMap.get(o) || o;
  const l = Math.hypot(s[2], s[3]), c = l * ft(b = Hs, So, LK).call(b, o, a, w(this, Wm));
  let u, d;
  r === 0 ? (u = s[4], d = s[5] - c) : (u = s[4] + c * Math.sin(r), d = s[5] - c * Math.cos(r));
  const h = "calc(var(--total-scale-factor) *", p = e.style;
  w(this, Oa) === w(this, Gf) ? (p.left = `${(100 * u / w(this, YZ)).toFixed(2)}%`, p.top = `${(100 * d / w(this, CZ)).toFixed(2)}%`) : (p.left = `${h}${u.toFixed(2)}px)`, p.top = `${h}${d.toFixed(2)}px)`), p.fontSize = `${h}${(w(Hs, hh) * l).toFixed(2)}px)`, p.fontFamily = o, n.fontSize = l, e.setAttribute("role", "presentation"), e.textContent = t.str, e.dir = t.dir, w(this, IZ) && (e.dataset.fontName = a.fontSubstitutionLoadedName || t.fontName), r !== 0 && (n.angle = r * (180 / Math.PI));
  let m = !1;
  if (t.str.length > 1)
    m = !0;
  else if (t.str !== " " && t.transform[0] !== t.transform[3]) {
    const y = Math.abs(t.transform[0]), Z = Math.abs(t.transform[3]);
    y !== Z && Math.max(y, Z) / Math.min(y, Z) > 1.5 && (m = !0);
  }
  if (m && (n.canvasWidth = a.vertical ? t.height : t.width), w(this, RZ).set(e, n), w(this, Iu).div = e, w(this, Iu).properties = n, ft(this, pd, _V).call(this, w(this, Iu)), n.hasText && w(this, Oa).append(e), n.hasEOL) {
    const y = document.createElement("br");
    y.setAttribute("role", "presentation"), w(this, Oa).append(y);
  }
}, _V = function(t) {
  var o;
  const {
    div: e,
    properties: n,
    ctx: s
  } = t, {
    style: r
  } = e;
  let a = "";
  if (w(Hs, hh) > 1 && (a = `scale(${1 / w(Hs, hh)})`), n.canvasWidth !== 0 && n.hasText) {
    const {
      fontFamily: l
    } = r, {
      canvasWidth: c,
      fontSize: u
    } = n;
    ft(o = Hs, So, QV).call(o, s, u * w(this, dh), l);
    const {
      width: d
    } = s.measureText(e.textContent);
    d > 0 && (a = `scaleX(${c * w(this, dh) / d}) ${a}`);
  }
  n.angle !== 0 && (a = `rotate(${n.angle}deg) ${a}`), a.length > 0 && (r.transform = a);
}, So = new WeakSet(), vN = function(t = null) {
  let e = w(this, xm).get(t || (t = ""));
  if (!e) {
    const n = document.createElement("canvas");
    n.className = "hiddenCanvasElement", n.lang = t, document.body.append(n), e = n.getContext("2d", {
      alpha: !1,
      willReadFrequently: !0
    }), w(this, xm).set(t, e), w(this, OZ).set(e, {
      size: 0,
      family: ""
    });
  }
  return e;
}, QV = function(t, e, n) {
  const s = w(this, OZ).get(t);
  e === s.size && n === s.family || (t.font = `${e}px ${n}`, s.size = e, s.family = n);
}, SK = function() {
  if (w(this, hh) !== null)
    return;
  const t = document.createElement("div");
  t.style.opacity = 0, t.style.lineHeight = 1, t.style.fontSize = "1px", t.style.position = "absolute", t.textContent = "X", document.body.append(t), rt(this, hh, t.getBoundingClientRect().height), t.remove();
}, LK = function(t, e, n) {
  const s = w(this, Lf).get(t);
  if (s)
    return s;
  const r = ft(this, So, vN).call(this, n);
  r.canvas.width = r.canvas.height = jE, ft(this, So, QV).call(this, r, jE, t);
  const a = r.measureText(""), o = a.fontBoundingBoxAscent, l = Math.abs(a.fontBoundingBoxDescent);
  r.canvas.width = r.canvas.height = 0;
  let c = 0.8;
  return o ? c = o / (o + l) : (Er.platform.isFirefox && pn("Enable the `dom.textMetrics.fontBoundingBox.enabled` preference in `about:config` to improve TextLayer rendering."), e.ascent ? c = e.ascent : e.descent && (c = 1 + e.descent)), w(this, Lf).set(t, c), c;
}, pt(Hs, So), pt(Hs, Lf, /* @__PURE__ */ new Map()), pt(Hs, xm, /* @__PURE__ */ new Map()), pt(Hs, OZ, /* @__PURE__ */ new WeakMap()), pt(Hs, hh, null), pt(Hs, Vf, /* @__PURE__ */ new Set());
let Gg = Hs;
const fCt = 100;
function VK(i = {}) {
  typeof i == "string" || i instanceof URL ? i = {
    url: i
  } : (i instanceof ArrayBuffer || ArrayBuffer.isView(i)) && (i = {
    data: i
  });
  const t = new $V(), {
    docId: e
  } = t, n = i.url ? WIt(i.url) : null, s = i.data ? GIt(i.data) : null, r = i.httpHeaders || null, a = i.withCredentials === !0, o = i.password ?? null, l = i.range instanceof XK ? i.range : null, c = Number.isInteger(i.rangeChunkSize) && i.rangeChunkSize > 0 ? i.rangeChunkSize : 2 ** 16;
  let u = i.worker instanceof F2 ? i.worker : null;
  const d = i.verbosity, h = typeof i.docBaseUrl == "string" && !fw(i.docBaseUrl) ? i.docBaseUrl : null, p = zM(i.cMapUrl), m = i.cMapPacked !== !1, b = i.CMapReaderFactory || (Ma ? CIt : LE), y = zM(i.iccUrl), Z = zM(i.standardFontDataUrl), g = i.StandardFontDataFactory || (Ma ? YIt : VE), f = zM(i.wasmUrl), T = i.WasmFactory || (Ma ? vIt : XE), M = i.stopAtErrors !== !0, N = Number.isInteger(i.maxImageSize) && i.maxImageSize > -1 ? i.maxImageSize : -1, W = i.isEvalSupported !== !1, x = typeof i.isOffscreenCanvasSupported == "boolean" ? i.isOffscreenCanvasSupported : !Ma, V = typeof i.isImageDecoderSupported == "boolean" ? i.isImageDecoderSupported : !Ma && (Er.platform.isFirefox || !globalThis.chrome), X = Number.isInteger(i.canvasMaxAreaInBytes) ? i.canvasMaxAreaInBytes : -1, C = typeof i.disableFontFace == "boolean" ? i.disableFontFace : Ma, R = i.fontExtraProperties === !0, z = i.enableXfa === !0, F = i.ownerDocument || globalThis.document, P = i.disableRange === !0, j = i.disableStream === !0, H = i.disableAutoFetch === !0, B = i.pdfBug === !0, $ = i.CanvasFactory || (Ma ? IIt : LIt), A = i.FilterFactory || (Ma ? XIt : VIt), E = i.enableHWA === !0, ct = i.useWasm !== !1, at = l ? l.length : i.length ?? NaN, dt = typeof i.useSystemFonts == "boolean" ? i.useSystemFonts : !Ma && !C, gt = typeof i.useWorkerFetch == "boolean" ? i.useWorkerFetch : !!(b === LE && g === VE && T === XE && p && Z && f && Xy(p, document.baseURI) && Xy(Z, document.baseURI) && Xy(f, document.baseURI)), Wt = null;
  QXt(d);
  const Zt = {
    canvasFactory: new $({
      ownerDocument: F,
      enableHWA: E
    }),
    filterFactory: new A({
      docId: e,
      ownerDocument: F
    }),
    cMapReaderFactory: gt ? null : new b({
      baseUrl: p,
      isCompressed: m
    }),
    standardFontDataFactory: gt ? null : new g({
      baseUrl: Z
    }),
    wasmFactory: gt ? null : new T({
      baseUrl: f
    })
  };
  u || (u = F2.create({
    verbosity: d,
    port: Wo.workerPort
  }), t._worker = u);
  const Gt = {
    docId: e,
    apiVersion: "5.4.296",
    data: s,
    password: o,
    disableAutoFetch: H,
    rangeChunkSize: c,
    length: at,
    docBaseUrl: h,
    enableXfa: z,
    evaluatorOptions: {
      maxImageSize: N,
      disableFontFace: C,
      ignoreErrors: M,
      isEvalSupported: W,
      isOffscreenCanvasSupported: x,
      isImageDecoderSupported: V,
      canvasMaxAreaInBytes: X,
      fontExtraProperties: R,
      useSystemFonts: dt,
      useWasm: ct,
      useWorkerFetch: gt,
      cMapUrl: p,
      iccUrl: y,
      standardFontDataUrl: Z,
      wasmUrl: f
    }
  }, Tt = {
    ownerDocument: F,
    pdfBug: B,
    styleElement: Wt,
    loadingParams: {
      disableAutoFetch: H,
      enableXfa: z
    }
  };
  return u.promise.then(function() {
    if (t.destroyed)
      throw new Error("Loading aborted");
    if (u.destroyed)
      throw new Error("Worker was destroyed");
    const Q = u.messageHandler.sendWithPromise("GetDocRequest", Gt, s ? [s.buffer] : null);
    let D;
    if (l)
      D = new $It(l, {
        disableRange: P,
        disableStream: j
      });
    else if (!s) {
      if (!n)
        throw new Error("getDocument - no `url` parameter provided.");
      const q = Xy(n) ? nCt : Ma ? hCt : oCt;
      D = new q({
        url: n,
        length: at,
        httpHeaders: r,
        withCredentials: a,
        rangeChunkSize: c,
        disableRange: P,
        disableStream: j
      });
    }
    return Q.then((q) => {
      if (t.destroyed)
        throw new Error("Loading aborted");
      if (u.destroyed)
        throw new Error("Worker was destroyed");
      const nt = new Dy(e, q, u.port), et = new ZCt(nt, t, D, Tt, Zt, E);
      t._transport = et, nt.send("Ready", null);
    });
  }).catch(t._capability.reject), t;
}
var bG;
const fG = class fG {
  constructor() {
    S(this, "_capability", Promise.withResolvers());
    S(this, "_transport", null);
    S(this, "_worker", null);
    S(this, "docId", `d${Ks(fG, bG)._++}`);
    S(this, "destroyed", !1);
    S(this, "onPassword", null);
    S(this, "onProgress", null);
  }
  get promise() {
    return this._capability.promise;
  }
  async destroy() {
    var t, e, n, s;
    this.destroyed = !0;
    try {
      (t = this._worker) != null && t.port && (this._worker._pendingDestroy = !0), await ((e = this._transport) == null ? void 0 : e.destroy());
    } catch (r) {
      throw (n = this._worker) != null && n.port && delete this._worker._pendingDestroy, r;
    }
    this._transport = null, (s = this._worker) == null || s.destroy(), this._worker = null;
  }
  async getData() {
    return this._transport.getData();
  }
};
bG = new WeakMap(), pt(fG, bG, 0);
let $V = fG;
var Sm, zZ, EZ, kZ, FZ;
class XK {
  constructor(t, e, n = !1, s = null) {
    pt(this, Sm, Promise.withResolvers());
    pt(this, zZ, []);
    pt(this, EZ, []);
    pt(this, kZ, []);
    pt(this, FZ, []);
    this.length = t, this.initialData = e, this.progressiveDone = n, this.contentDispositionFilename = s;
  }
  addRangeListener(t) {
    w(this, FZ).push(t);
  }
  addProgressListener(t) {
    w(this, kZ).push(t);
  }
  addProgressiveReadListener(t) {
    w(this, EZ).push(t);
  }
  addProgressiveDoneListener(t) {
    w(this, zZ).push(t);
  }
  onDataRange(t, e) {
    for (const n of w(this, FZ))
      n(t, e);
  }
  onDataProgress(t, e) {
    w(this, Sm).promise.then(() => {
      for (const n of w(this, kZ))
        n(t, e);
    });
  }
  onDataProgressiveRead(t) {
    w(this, Sm).promise.then(() => {
      for (const e of w(this, EZ))
        e(t);
    });
  }
  onDataProgressiveDone() {
    w(this, Sm).promise.then(() => {
      for (const t of w(this, zZ))
        t();
    });
  }
  transportReady() {
    w(this, Sm).resolve();
  }
  requestDataRange(t, e) {
    Xi("Abstract method PDFDataRangeTransport.requestDataRange");
  }
  abort() {
  }
}
Sm = new WeakMap(), zZ = new WeakMap(), EZ = new WeakMap(), kZ = new WeakMap(), FZ = new WeakMap();
class gCt {
  constructor(t, e) {
    this._pdfInfo = t, this._transport = e;
  }
  get annotationStorage() {
    return this._transport.annotationStorage;
  }
  get canvasFactory() {
    return this._transport.canvasFactory;
  }
  get filterFactory() {
    return this._transport.filterFactory;
  }
  get numPages() {
    return this._pdfInfo.numPages;
  }
  get fingerprints() {
    return this._pdfInfo.fingerprints;
  }
  get isPureXfa() {
    return Gn(this, "isPureXfa", !!this._transport._htmlForXfa);
  }
  get allXfaHtml() {
    return this._transport._htmlForXfa;
  }
  getPage(t) {
    return this._transport.getPage(t);
  }
  getPageIndex(t) {
    return this._transport.getPageIndex(t);
  }
  getDestinations() {
    return this._transport.getDestinations();
  }
  getDestination(t) {
    return this._transport.getDestination(t);
  }
  getPageLabels() {
    return this._transport.getPageLabels();
  }
  getPageLayout() {
    return this._transport.getPageLayout();
  }
  getPageMode() {
    return this._transport.getPageMode();
  }
  getViewerPreferences() {
    return this._transport.getViewerPreferences();
  }
  getOpenAction() {
    return this._transport.getOpenAction();
  }
  getAttachments() {
    return this._transport.getAttachments();
  }
  getAnnotationsByType(t, e) {
    return this._transport.getAnnotationsByType(t, e);
  }
  getJSActions() {
    return this._transport.getDocJSActions();
  }
  getOutline() {
    return this._transport.getOutline();
  }
  getOptionalContentConfig({
    intent: t = "display"
  } = {}) {
    const {
      renderingIntent: e
    } = this._transport.getRenderingIntent(t);
    return this._transport.getOptionalContentConfig(e);
  }
  getPermissions() {
    return this._transport.getPermissions();
  }
  getMetadata() {
    return this._transport.getMetadata();
  }
  getMarkInfo() {
    return this._transport.getMarkInfo();
  }
  getData() {
    return this._transport.getData();
  }
  saveDocument() {
    return this._transport.saveDocument();
  }
  getDownloadInfo() {
    return this._transport.downloadInfoCapability.promise;
  }
  cleanup(t = !1) {
    return this._transport.startCleanup(t || this.isPureXfa);
  }
  destroy() {
    return this.loadingTask.destroy();
  }
  cachedPageNumber(t) {
    return this._transport.cachedPageNumber(t);
  }
  get loadingParams() {
    return this._transport.loadingParams;
  }
  get loadingTask() {
    return this._transport.loadingTask;
  }
  getFieldObjects() {
    return this._transport.getFieldObjects();
  }
  hasJSActions() {
    return this._transport.hasJSActions();
  }
  getCalculationOrderIds() {
    return this._transport.getCalculationOrderIds();
  }
}
var Cu, Lm, Uy;
class yCt {
  constructor(t, e, n, s = !1) {
    pt(this, Lm);
    pt(this, Cu, !1);
    this._pageIndex = t, this._pageInfo = e, this._transport = n, this._stats = s ? new ME() : null, this._pdfBug = s, this.commonObjs = n.commonObjs, this.objs = new GK(), this._intentStates = /* @__PURE__ */ new Map(), this.destroyed = !1, this.recordedBBoxes = null;
  }
  get pageNumber() {
    return this._pageIndex + 1;
  }
  get rotate() {
    return this._pageInfo.rotate;
  }
  get ref() {
    return this._pageInfo.ref;
  }
  get userUnit() {
    return this._pageInfo.userUnit;
  }
  get view() {
    return this._pageInfo.view;
  }
  getViewport({
    scale: t,
    rotation: e = this.rotate,
    offsetX: n = 0,
    offsetY: s = 0,
    dontFlip: r = !1
  } = {}) {
    return new _T({
      viewBox: this.view,
      userUnit: this.userUnit,
      scale: t,
      rotation: e,
      offsetX: n,
      offsetY: s,
      dontFlip: r
    });
  }
  getAnnotations({
    intent: t = "display"
  } = {}) {
    const {
      renderingIntent: e
    } = this._transport.getRenderingIntent(t);
    return this._transport.getAnnotations(this._pageIndex, e);
  }
  getJSActions() {
    return this._transport.getPageJSActions(this._pageIndex);
  }
  get filterFactory() {
    return this._transport.filterFactory;
  }
  get isPureXfa() {
    return Gn(this, "isPureXfa", !!this._transport._htmlForXfa);
  }
  async getXfa() {
    var t;
    return ((t = this._transport._htmlForXfa) == null ? void 0 : t.children[this._pageIndex]) || null;
  }
  render({
    canvasContext: t,
    canvas: e = t.canvas,
    viewport: n,
    intent: s = "display",
    annotationMode: r = Yc.ENABLE,
    transform: a = null,
    background: o = null,
    optionalContentConfigPromise: l = null,
    annotationCanvasMap: c = null,
    pageColors: u = null,
    printAnnotationStorage: d = null,
    isEditing: h = !1,
    recordOperations: p = !1,
    operationsFilter: m = null
  }) {
    var V, X, C;
    (V = this._stats) == null || V.time("Overall");
    const b = this._transport.getRenderingIntent(s, r, d, h), {
      renderingIntent: y,
      cacheKey: Z
    } = b;
    rt(this, Cu, !1), l || (l = this._transport.getOptionalContentConfig(y));
    let g = this._intentStates.get(Z);
    g || (g = /* @__PURE__ */ Object.create(null), this._intentStates.set(Z, g)), g.streamReaderCancelTimeout && (clearTimeout(g.streamReaderCancelTimeout), g.streamReaderCancelTimeout = null);
    const f = !!(y & fo.PRINT);
    g.displayReadyCapability || (g.displayReadyCapability = Promise.withResolvers(), g.operatorList = {
      fnArray: [],
      argsArray: [],
      lastChunk: !1,
      separateAnnots: null
    }, (X = this._stats) == null || X.time("Page Request"), this._pumpOperatorList(b));
    const T = !!(this._pdfBug && ((C = globalThis.StepperManager) != null && C.enabled)), M = !this.recordedBBoxes && (p || T), N = (R) => {
      var z, F;
      if (g.renderTasks.delete(W), M) {
        const P = (z = W.gfx) == null ? void 0 : z.dependencyTracker.take();
        P && (W.stepper && W.stepper.setOperatorBBoxes(P, W.gfx.dependencyTracker.takeDebugMetadata()), p && (this.recordedBBoxes = P));
      }
      f && rt(this, Cu, !0), ft(this, Lm, Uy).call(this), R ? (W.capability.reject(R), this._abortOperatorList({
        intentState: g,
        reason: R instanceof Error ? R : new Error(R)
      })) : W.capability.resolve(), this._stats && (this._stats.timeEnd("Rendering"), this._stats.timeEnd("Overall"), (F = globalThis.Stats) != null && F.enabled && globalThis.Stats.add(this.pageNumber, this._stats));
    }, W = new qV({
      callback: N,
      params: {
        canvas: e,
        canvasContext: t,
        dependencyTracker: M ? new DIt(e, g.operatorList.length, T) : null,
        viewport: n,
        transform: a,
        background: o
      },
      objs: this.objs,
      commonObjs: this.commonObjs,
      annotationCanvasMap: c,
      operatorList: g.operatorList,
      pageIndex: this._pageIndex,
      canvasFactory: this._transport.canvasFactory,
      filterFactory: this._transport.filterFactory,
      useRequestAnimationFrame: !f,
      pdfBug: this._pdfBug,
      pageColors: u,
      enableHWA: this._transport.enableHWA,
      operationsFilter: m
    });
    (g.renderTasks || (g.renderTasks = /* @__PURE__ */ new Set())).add(W);
    const x = W.task;
    return Promise.all([g.displayReadyCapability.promise, l]).then(([R, z]) => {
      var F;
      if (this.destroyed) {
        N();
        return;
      }
      if ((F = this._stats) == null || F.time("Rendering"), !(z.renderingIntent & y))
        throw new Error("Must use the same `intent`-argument when calling the `PDFPageProxy.render` and `PDFDocumentProxy.getOptionalContentConfig` methods.");
      W.initializeGraphics({
        transparency: R,
        optionalContentConfig: z
      }), W.operatorListChanged();
    }).catch(N), x;
  }
  getOperatorList({
    intent: t = "display",
    annotationMode: e = Yc.ENABLE,
    printAnnotationStorage: n = null,
    isEditing: s = !1
  } = {}) {
    var c;
    function r() {
      o.operatorList.lastChunk && (o.opListReadCapability.resolve(o.operatorList), o.renderTasks.delete(l));
    }
    const a = this._transport.getRenderingIntent(t, e, n, s, !0);
    let o = this._intentStates.get(a.cacheKey);
    o || (o = /* @__PURE__ */ Object.create(null), this._intentStates.set(a.cacheKey, o));
    let l;
    return o.opListReadCapability || (l = /* @__PURE__ */ Object.create(null), l.operatorListChanged = r, o.opListReadCapability = Promise.withResolvers(), (o.renderTasks || (o.renderTasks = /* @__PURE__ */ new Set())).add(l), o.operatorList = {
      fnArray: [],
      argsArray: [],
      lastChunk: !1,
      separateAnnots: null
    }, (c = this._stats) == null || c.time("Page Request"), this._pumpOperatorList(a)), o.opListReadCapability.promise;
  }
  streamTextContent({
    includeMarkedContent: t = !1,
    disableNormalization: e = !1
  } = {}) {
    return this._transport.messageHandler.sendWithStream("GetTextContent", {
      pageIndex: this._pageIndex,
      includeMarkedContent: t === !0,
      disableNormalization: e === !0
    }, {
      highWaterMark: 100,
      size(s) {
        return s.items.length;
      }
    });
  }
  getTextContent(t = {}) {
    if (this._transport._htmlForXfa)
      return this.getXfa().then((n) => k2.textContent(n));
    const e = this.streamTextContent(t);
    return new Promise(function(n, s) {
      function r() {
        a.read().then(function({
          value: l,
          done: c
        }) {
          if (c) {
            n(o);
            return;
          }
          o.lang ?? (o.lang = l.lang), Object.assign(o.styles, l.styles), o.items.push(...l.items), r();
        }, s);
      }
      const a = e.getReader(), o = {
        items: [],
        styles: /* @__PURE__ */ Object.create(null),
        lang: null
      };
      r();
    });
  }
  getStructTree() {
    return this._transport.getStructTree(this._pageIndex);
  }
  _destroy() {
    this.destroyed = !0;
    const t = [];
    for (const e of this._intentStates.values())
      if (this._abortOperatorList({
        intentState: e,
        reason: new Error("Page was destroyed."),
        force: !0
      }), !e.opListReadCapability)
        for (const n of e.renderTasks)
          t.push(n.completed), n.cancel();
    return this.objs.clear(), rt(this, Cu, !1), Promise.all(t);
  }
  cleanup(t = !1) {
    rt(this, Cu, !0);
    const e = ft(this, Lm, Uy).call(this);
    return t && e && this._stats && (this._stats = new ME()), e;
  }
  _startRenderPage(t, e) {
    var s, r;
    const n = this._intentStates.get(e);
    n && ((s = this._stats) == null || s.timeEnd("Page Request"), (r = n.displayReadyCapability) == null || r.resolve(t));
  }
  _renderPageChunk(t, e) {
    for (let n = 0, s = t.length; n < s; n++)
      e.operatorList.fnArray.push(t.fnArray[n]), e.operatorList.argsArray.push(t.argsArray[n]);
    e.operatorList.lastChunk = t.lastChunk, e.operatorList.separateAnnots = t.separateAnnots;
    for (const n of e.renderTasks)
      n.operatorListChanged();
    t.lastChunk && ft(this, Lm, Uy).call(this);
  }
  _pumpOperatorList({
    renderingIntent: t,
    cacheKey: e,
    annotationStorageSerializable: n,
    modifiedIds: s
  }) {
    const {
      map: r,
      transfer: a
    } = n, l = this._transport.messageHandler.sendWithStream("GetOperatorList", {
      pageIndex: this._pageIndex,
      intent: t,
      cacheKey: e,
      annotationStorage: r,
      modifiedIds: s
    }, a).getReader(), c = this._intentStates.get(e);
    c.streamReader = l;
    const u = () => {
      l.read().then(({
        value: d,
        done: h
      }) => {
        if (h) {
          c.streamReader = null;
          return;
        }
        this._transport.destroyed || (this._renderPageChunk(d, c), u());
      }, (d) => {
        if (c.streamReader = null, !this._transport.destroyed) {
          if (c.operatorList) {
            c.operatorList.lastChunk = !0;
            for (const h of c.renderTasks)
              h.operatorListChanged();
            ft(this, Lm, Uy).call(this);
          }
          if (c.displayReadyCapability)
            c.displayReadyCapability.reject(d);
          else if (c.opListReadCapability)
            c.opListReadCapability.reject(d);
          else
            throw d;
        }
      });
    };
    u();
  }
  _abortOperatorList({
    intentState: t,
    reason: e,
    force: n = !1
  }) {
    if (t.streamReader) {
      if (t.streamReaderCancelTimeout && (clearTimeout(t.streamReaderCancelTimeout), t.streamReaderCancelTimeout = null), !n) {
        if (t.renderTasks.size > 0)
          return;
        if (e instanceof $C) {
          let s = fCt;
          e.extraDelay > 0 && e.extraDelay < 1e3 && (s += e.extraDelay), t.streamReaderCancelTimeout = setTimeout(() => {
            t.streamReaderCancelTimeout = null, this._abortOperatorList({
              intentState: t,
              reason: e,
              force: !0
            });
          }, s);
          return;
        }
      }
      if (t.streamReader.cancel(new $h(e.message)).catch(() => {
      }), t.streamReader = null, !this._transport.destroyed) {
        for (const [s, r] of this._intentStates)
          if (r === t) {
            this._intentStates.delete(s);
            break;
          }
        this.cleanup();
      }
    }
  }
  get stats() {
    return this._stats;
  }
}
Cu = new WeakMap(), Lm = new WeakSet(), Uy = function() {
  if (!w(this, Cu) || this.destroyed)
    return !1;
  for (const {
    renderTasks: t,
    operatorList: e
  } of this._intentStates.values())
    if (t.size > 0 || !e.lastChunk)
      return !1;
  return this._intentStates.clear(), this.objs.clear(), rt(this, Cu, !1), !0;
};
var ph, Wl, Yu, Vm, gG, Xm, Im, wa, RN, IK, CK, Py, Xf, DN;
const Ki = class Ki {
  constructor({
    name: t = null,
    port: e = null,
    verbosity: n = $Xt()
  } = {}) {
    pt(this, wa);
    pt(this, ph, Promise.withResolvers());
    pt(this, Wl, null);
    pt(this, Yu, null);
    pt(this, Vm, null);
    if (this.name = t, this.destroyed = !1, this.verbosity = n, e) {
      if (w(Ki, Im).has(e))
        throw new Error("Cannot use more than one PDFWorker per port.");
      w(Ki, Im).set(e, this), ft(this, wa, IK).call(this, e);
    } else
      ft(this, wa, CK).call(this);
  }
  get promise() {
    return w(this, ph).promise;
  }
  get port() {
    return w(this, Yu);
  }
  get messageHandler() {
    return w(this, Wl);
  }
  destroy() {
    var t, e;
    this.destroyed = !0, (t = w(this, Vm)) == null || t.terminate(), rt(this, Vm, null), w(Ki, Im).delete(w(this, Yu)), rt(this, Yu, null), (e = w(this, Wl)) == null || e.destroy(), rt(this, Wl, null);
  }
  static create(t) {
    const e = w(this, Im).get(t == null ? void 0 : t.port);
    if (e) {
      if (e._pendingDestroy)
        throw new Error("PDFWorker.create - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
      return e;
    }
    return new Ki(t);
  }
  static get workerSrc() {
    if (Wo.workerSrc)
      return Wo.workerSrc;
    throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
  }
  static get _setupFakeWorkerGlobal() {
    return Gn(this, "_setupFakeWorkerGlobal", (async () => w(this, Xf, DN) ? w(this, Xf, DN) : (await import(
      /*webpackIgnore: true*/
      /*@vite-ignore*/
      this.workerSrc
    )).WorkerMessageHandler)());
  }
};
ph = new WeakMap(), Wl = new WeakMap(), Yu = new WeakMap(), Vm = new WeakMap(), gG = new WeakMap(), Xm = new WeakMap(), Im = new WeakMap(), wa = new WeakSet(), RN = function() {
  w(this, ph).resolve(), w(this, Wl).send("configure", {
    verbosity: this.verbosity
  });
}, IK = function(t) {
  rt(this, Yu, t), rt(this, Wl, new Dy("main", "worker", t)), w(this, Wl).on("ready", () => {
  }), ft(this, wa, RN).call(this);
}, CK = function() {
  if (w(Ki, Xm) || w(Ki, Xf, DN)) {
    ft(this, wa, Py).call(this);
    return;
  }
  let {
    workerSrc: t
  } = Ki;
  try {
    Ki._isSameOrigin(window.location, t) || (t = Ki._createCDNWrapper(new URL(t, window.location).href));
    const e = new Worker(t, {
      type: "module"
    }), n = new Dy("main", "worker", e), s = () => {
      r.abort(), n.destroy(), e.terminate(), this.destroyed ? w(this, ph).reject(new Error("Worker was destroyed")) : ft(this, wa, Py).call(this);
    }, r = new AbortController();
    e.addEventListener("error", () => {
      w(this, Vm) || s();
    }, {
      signal: r.signal
    }), n.on("test", (o) => {
      if (r.abort(), this.destroyed || !o) {
        s();
        return;
      }
      rt(this, Wl, n), rt(this, Yu, e), rt(this, Vm, e), ft(this, wa, RN).call(this);
    }), n.on("ready", (o) => {
      if (r.abort(), this.destroyed) {
        s();
        return;
      }
      try {
        a();
      } catch {
        ft(this, wa, Py).call(this);
      }
    });
    const a = () => {
      const o = new Uint8Array();
      n.send("test", o, [o.buffer]);
    };
    a();
    return;
  } catch {
    bw("The worker has been disabled.");
  }
  ft(this, wa, Py).call(this);
}, Py = function() {
  w(Ki, Xm) || (pn("Setting up fake worker."), rt(Ki, Xm, !0)), Ki._setupFakeWorkerGlobal.then((t) => {
    if (this.destroyed) {
      w(this, ph).reject(new Error("Worker was destroyed"));
      return;
    }
    const e = new SIt();
    rt(this, Yu, e);
    const n = `fake${Ks(Ki, gG)._++}`, s = new Dy(n + "_worker", n, e);
    t.setup(s, e), rt(this, Wl, new Dy(n, n + "_worker", e)), ft(this, wa, RN).call(this);
  }).catch((t) => {
    w(this, ph).reject(new Error(`Setting up fake worker failed: "${t.message}".`));
  });
}, Xf = new WeakSet(), DN = function() {
  var t;
  try {
    return ((t = globalThis.pdfjsWorker) == null ? void 0 : t.WorkerMessageHandler) || null;
  } catch {
    return null;
  }
}, pt(Ki, Xf), pt(Ki, gG, 0), pt(Ki, Xm, !1), pt(Ki, Im, /* @__PURE__ */ new WeakMap()), Ma && (rt(Ki, Xm, !0), Wo.workerSrc || (Wo.workerSrc = "./pdf.worker.mjs")), Ki._isSameOrigin = (t, e) => {
  const n = URL.parse(t);
  if (!(n != null && n.origin) || n.origin === "null")
    return !1;
  const s = new URL(e, n);
  return n.origin === s.origin;
}, Ki._createCDNWrapper = (t) => {
  const e = `await import("${t}");`;
  return URL.createObjectURL(new Blob([e], {
    type: "text/javascript"
  }));
}, Ki.fromPort = (t) => {
  if (uIt("`PDFWorker.fromPort` - please use `PDFWorker.create` instead."), !(t != null && t.port))
    throw new Error("PDFWorker.fromPort - invalid method signature.");
  return Ki.create(t);
};
let F2 = Ki;
var vu, Nc, If, Cf, Ru, Cm, Jy;
class ZCt {
  constructor(t, e, n, s, r, a) {
    pt(this, Cm);
    pt(this, vu, /* @__PURE__ */ new Map());
    pt(this, Nc, /* @__PURE__ */ new Map());
    pt(this, If, /* @__PURE__ */ new Map());
    pt(this, Cf, /* @__PURE__ */ new Map());
    pt(this, Ru, null);
    this.messageHandler = t, this.loadingTask = e, this.commonObjs = new GK(), this.fontLoader = new MIt({
      ownerDocument: s.ownerDocument,
      styleElement: s.styleElement
    }), this.loadingParams = s.loadingParams, this._params = s, this.canvasFactory = r.canvasFactory, this.filterFactory = r.filterFactory, this.cMapReaderFactory = r.cMapReaderFactory, this.standardFontDataFactory = r.standardFontDataFactory, this.wasmFactory = r.wasmFactory, this.destroyed = !1, this.destroyCapability = null, this._networkStream = n, this._fullReader = null, this._lastProgress = null, this.downloadInfoCapability = Promise.withResolvers(), this.enableHWA = a, this.setupMessageHandler();
  }
  get annotationStorage() {
    return Gn(this, "annotationStorage", new tY());
  }
  getRenderingIntent(t, e = Yc.ENABLE, n = null, s = !1, r = !1) {
    let a = fo.DISPLAY, o = DV;
    switch (t) {
      case "any":
        a = fo.ANY;
        break;
      case "display":
        break;
      case "print":
        a = fo.PRINT;
        break;
      default:
        pn(`getRenderingIntent - invalid intent: ${t}`);
    }
    const l = a & fo.PRINT && n instanceof lK ? n : this.annotationStorage;
    switch (e) {
      case Yc.DISABLE:
        a += fo.ANNOTATIONS_DISABLE;
        break;
      case Yc.ENABLE:
        break;
      case Yc.ENABLE_FORMS:
        a += fo.ANNOTATIONS_FORMS;
        break;
      case Yc.ENABLE_STORAGE:
        a += fo.ANNOTATIONS_STORAGE, o = l.serializable;
        break;
      default:
        pn(`getRenderingIntent - invalid annotationMode: ${e}`);
    }
    s && (a += fo.IS_EDITING), r && (a += fo.OPLIST);
    const {
      ids: c,
      hash: u
    } = l.modifiedIds, d = [a, o.hash, u];
    return {
      renderingIntent: a,
      cacheKey: d.join("_"),
      annotationStorageSerializable: o,
      modifiedIds: c
    };
  }
  destroy() {
    var n;
    if (this.destroyCapability)
      return this.destroyCapability.promise;
    this.destroyed = !0, this.destroyCapability = Promise.withResolvers(), (n = w(this, Ru)) == null || n.reject(new Error("Worker was destroyed during onPassword callback"));
    const t = [];
    for (const s of w(this, Nc).values())
      t.push(s._destroy());
    w(this, Nc).clear(), w(this, If).clear(), w(this, Cf).clear(), this.hasOwnProperty("annotationStorage") && this.annotationStorage.resetModified();
    const e = this.messageHandler.sendWithPromise("Terminate", null);
    return t.push(e), Promise.all(t).then(() => {
      var s, r;
      this.commonObjs.clear(), this.fontLoader.clear(), w(this, vu).clear(), this.filterFactory.destroy(), Gg.cleanup(), (s = this._networkStream) == null || s.cancelAllRequests(new $h("Worker was terminated.")), (r = this.messageHandler) == null || r.destroy(), this.messageHandler = null, this.destroyCapability.resolve();
    }, this.destroyCapability.reject), this.destroyCapability.promise;
  }
  setupMessageHandler() {
    const {
      messageHandler: t,
      loadingTask: e
    } = this;
    t.on("GetReader", (n, s) => {
      Pn(this._networkStream, "GetReader - no `IPDFStream` instance available."), this._fullReader = this._networkStream.getFullReader(), this._fullReader.onProgress = (r) => {
        this._lastProgress = {
          loaded: r.loaded,
          total: r.total
        };
      }, s.onPull = () => {
        this._fullReader.read().then(function({
          value: r,
          done: a
        }) {
          if (a) {
            s.close();
            return;
          }
          Pn(r instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer."), s.enqueue(new Uint8Array(r), 1, [r]);
        }).catch((r) => {
          s.error(r);
        });
      }, s.onCancel = (r) => {
        this._fullReader.cancel(r), s.ready.catch((a) => {
          if (!this.destroyed)
            throw a;
        });
      };
    }), t.on("ReaderHeadersReady", async (n) => {
      var o;
      await this._fullReader.headersReady;
      const {
        isStreamingSupported: s,
        isRangeSupported: r,
        contentLength: a
      } = this._fullReader;
      return (!s || !r) && (this._lastProgress && ((o = e.onProgress) == null || o.call(e, this._lastProgress)), this._fullReader.onProgress = (l) => {
        var c;
        (c = e.onProgress) == null || c.call(e, {
          loaded: l.loaded,
          total: l.total
        });
      }), {
        isStreamingSupported: s,
        isRangeSupported: r,
        contentLength: a
      };
    }), t.on("GetRangeReader", (n, s) => {
      Pn(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
      const r = this._networkStream.getRangeReader(n.begin, n.end);
      if (!r) {
        s.close();
        return;
      }
      s.onPull = () => {
        r.read().then(function({
          value: a,
          done: o
        }) {
          if (o) {
            s.close();
            return;
          }
          Pn(a instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer."), s.enqueue(new Uint8Array(a), 1, [a]);
        }).catch((a) => {
          s.error(a);
        });
      }, s.onCancel = (a) => {
        r.cancel(a), s.ready.catch((o) => {
          if (!this.destroyed)
            throw o;
        });
      };
    }), t.on("GetDoc", ({
      pdfInfo: n
    }) => {
      this._numPages = n.numPages, this._htmlForXfa = n.htmlForXfa, delete n.htmlForXfa, e._capability.resolve(new gCt(n, this));
    }), t.on("DocException", (n) => {
      e._capability.reject(Ia(n));
    }), t.on("PasswordRequest", (n) => {
      rt(this, Ru, Promise.withResolvers());
      try {
        if (!e.onPassword)
          throw Ia(n);
        const s = (r) => {
          r instanceof Error ? w(this, Ru).reject(r) : w(this, Ru).resolve({
            password: r
          });
        };
        e.onPassword(s, n.code);
      } catch (s) {
        w(this, Ru).reject(s);
      }
      return w(this, Ru).promise;
    }), t.on("DataLoaded", (n) => {
      var s;
      (s = e.onProgress) == null || s.call(e, {
        loaded: n.length,
        total: n.length
      }), this.downloadInfoCapability.resolve(n);
    }), t.on("StartRenderPage", (n) => {
      if (this.destroyed)
        return;
      w(this, Nc).get(n.pageIndex)._startRenderPage(n.transparency, n.cacheKey);
    }), t.on("commonobj", ([n, s, r]) => {
      var a;
      if (this.destroyed || this.commonObjs.has(n))
        return null;
      switch (s) {
        case "Font":
          if ("error" in r) {
            const d = r.error;
            pn(`Error during font loading: ${d}`), this.commonObjs.resolve(n, d);
            break;
          }
          const o = new BV(r), l = this._params.pdfBug && ((a = globalThis.FontInspector) != null && a.enabled) ? (d, h) => globalThis.FontInspector.fontAdded(d, h) : null, c = new NIt(o, l, r.extra, r.charProcOperatorList);
          this.fontLoader.bind(c).catch(() => t.sendWithPromise("FontFallback", {
            id: n
          })).finally(() => {
            !c.fontExtraProperties && c.data && c.clearData(), this.commonObjs.resolve(n, c);
          });
          break;
        case "CopyLocalImage":
          const {
            imageRef: u
          } = r;
          Pn(u, "The imageRef must be defined.");
          for (const d of w(this, Nc).values())
            for (const [, h] of d.objs)
              if ((h == null ? void 0 : h.ref) === u)
                return h.dataLen ? (this.commonObjs.resolve(n, structuredClone(h)), h.dataLen) : null;
          break;
        case "FontPath":
        case "Image":
        case "Pattern":
          this.commonObjs.resolve(n, r);
          break;
        default:
          throw new Error(`Got unknown common object type ${s}`);
      }
      return null;
    }), t.on("obj", ([n, s, r, a]) => {
      var l;
      if (this.destroyed)
        return;
      const o = w(this, Nc).get(s);
      if (!o.objs.has(n)) {
        if (o._intentStates.size === 0) {
          (l = a == null ? void 0 : a.bitmap) == null || l.close();
          return;
        }
        switch (r) {
          case "Image":
          case "Pattern":
            o.objs.resolve(n, a);
            break;
          default:
            throw new Error(`Got unknown object type ${r}`);
        }
      }
    }), t.on("DocProgress", (n) => {
      var s;
      this.destroyed || (s = e.onProgress) == null || s.call(e, {
        loaded: n.loaded,
        total: n.total
      });
    }), t.on("FetchBinaryData", async (n) => {
      if (this.destroyed)
        throw new Error("Worker was destroyed.");
      const s = this[n.type];
      if (!s)
        throw new Error(`${n.type} not initialized, see the \`useWorkerFetch\` parameter.`);
      return s.fetch(n);
    });
  }
  getData() {
    return this.messageHandler.sendWithPromise("GetData", null);
  }
  saveDocument() {
    var n;
    this.annotationStorage.size <= 0 && pn("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
    const {
      map: t,
      transfer: e
    } = this.annotationStorage.serializable;
    return this.messageHandler.sendWithPromise("SaveDocument", {
      isPureXfa: !!this._htmlForXfa,
      numPages: this._numPages,
      annotationStorage: t,
      filename: ((n = this._fullReader) == null ? void 0 : n.filename) ?? null
    }, e).finally(() => {
      this.annotationStorage.resetModified();
    });
  }
  getPage(t) {
    if (!Number.isInteger(t) || t <= 0 || t > this._numPages)
      return Promise.reject(new Error("Invalid page request."));
    const e = t - 1, n = w(this, If).get(e);
    if (n)
      return n;
    const s = this.messageHandler.sendWithPromise("GetPage", {
      pageIndex: e
    }).then((r) => {
      if (this.destroyed)
        throw new Error("Transport destroyed");
      r.refStr && w(this, Cf).set(r.refStr, t);
      const a = new yCt(e, r, this, this._params.pdfBug);
      return w(this, Nc).set(e, a), a;
    });
    return w(this, If).set(e, s), s;
  }
  getPageIndex(t) {
    return OV(t) ? this.messageHandler.sendWithPromise("GetPageIndex", {
      num: t.num,
      gen: t.gen
    }) : Promise.reject(new Error("Invalid pageIndex request."));
  }
  getAnnotations(t, e) {
    return this.messageHandler.sendWithPromise("GetAnnotations", {
      pageIndex: t,
      intent: e
    });
  }
  getFieldObjects() {
    return ft(this, Cm, Jy).call(this, "GetFieldObjects");
  }
  hasJSActions() {
    return ft(this, Cm, Jy).call(this, "HasJSActions");
  }
  getCalculationOrderIds() {
    return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
  }
  getDestinations() {
    return this.messageHandler.sendWithPromise("GetDestinations", null);
  }
  getDestination(t) {
    return typeof t != "string" ? Promise.reject(new Error("Invalid destination request.")) : this.messageHandler.sendWithPromise("GetDestination", {
      id: t
    });
  }
  getPageLabels() {
    return this.messageHandler.sendWithPromise("GetPageLabels", null);
  }
  getPageLayout() {
    return this.messageHandler.sendWithPromise("GetPageLayout", null);
  }
  getPageMode() {
    return this.messageHandler.sendWithPromise("GetPageMode", null);
  }
  getViewerPreferences() {
    return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
  }
  getOpenAction() {
    return this.messageHandler.sendWithPromise("GetOpenAction", null);
  }
  getAttachments() {
    return this.messageHandler.sendWithPromise("GetAttachments", null);
  }
  getAnnotationsByType(t, e) {
    return this.messageHandler.sendWithPromise("GetAnnotationsByType", {
      types: t,
      pageIndexesToSkip: e
    });
  }
  getDocJSActions() {
    return ft(this, Cm, Jy).call(this, "GetDocJSActions");
  }
  getPageJSActions(t) {
    return this.messageHandler.sendWithPromise("GetPageJSActions", {
      pageIndex: t
    });
  }
  getStructTree(t) {
    return this.messageHandler.sendWithPromise("GetStructTree", {
      pageIndex: t
    });
  }
  getOutline() {
    return this.messageHandler.sendWithPromise("GetOutline", null);
  }
  getOptionalContentConfig(t) {
    return ft(this, Cm, Jy).call(this, "GetOptionalContentConfig").then((e) => new QIt(e, t));
  }
  getPermissions() {
    return this.messageHandler.sendWithPromise("GetPermissions", null);
  }
  getMetadata() {
    const t = "GetMetadata", e = w(this, vu).get(t);
    if (e)
      return e;
    const n = this.messageHandler.sendWithPromise(t, null).then((s) => {
      var r, a;
      return {
        info: s[0],
        metadata: s[1] ? new HIt(s[1]) : null,
        contentDispositionFilename: ((r = this._fullReader) == null ? void 0 : r.filename) ?? null,
        contentLength: ((a = this._fullReader) == null ? void 0 : a.contentLength) ?? null
      };
    });
    return w(this, vu).set(t, n), n;
  }
  getMarkInfo() {
    return this.messageHandler.sendWithPromise("GetMarkInfo", null);
  }
  async startCleanup(t = !1) {
    if (!this.destroyed) {
      await this.messageHandler.sendWithPromise("Cleanup", null);
      for (const e of w(this, Nc).values())
        if (!e.cleanup())
          throw new Error(`startCleanup: Page ${e.pageNumber} is currently rendering.`);
      this.commonObjs.clear(), t || this.fontLoader.clear(), w(this, vu).clear(), this.filterFactory.destroy(!0), Gg.cleanup();
    }
  }
  cachedPageNumber(t) {
    if (!OV(t))
      return null;
    const e = t.gen === 0 ? `${t.num}R` : `${t.num}R${t.gen}`;
    return w(this, Cf).get(e) ?? null;
  }
}
vu = new WeakMap(), Nc = new WeakMap(), If = new WeakMap(), Cf = new WeakMap(), Ru = new WeakMap(), Cm = new WeakSet(), Jy = function(t, e = null) {
  const n = w(this, vu).get(t);
  if (n)
    return n;
  const s = this.messageHandler.sendWithPromise(t, e);
  return w(this, vu).set(t, s), s;
};
var mh;
class TCt {
  constructor(t) {
    pt(this, mh, null);
    S(this, "onContinue", null);
    S(this, "onError", null);
    rt(this, mh, t);
  }
  get promise() {
    return w(this, mh).capability.promise;
  }
  cancel(t = 0) {
    w(this, mh).cancel(null, t);
  }
  get separateAnnots() {
    const {
      separateAnnots: t
    } = w(this, mh).operatorList;
    if (!t)
      return !1;
    const {
      annotationCanvasMap: e
    } = w(this, mh);
    return t.form || t.canvas && (e == null ? void 0 : e.size) > 0;
  }
}
mh = new WeakMap();
var bh, Ym;
const zp = class zp {
  constructor({
    callback: t,
    params: e,
    objs: n,
    commonObjs: s,
    annotationCanvasMap: r,
    operatorList: a,
    pageIndex: o,
    canvasFactory: l,
    filterFactory: c,
    useRequestAnimationFrame: u = !1,
    pdfBug: d = !1,
    pageColors: h = null,
    enableHWA: p = !1,
    operationsFilter: m = null
  }) {
    pt(this, bh, null);
    this.callback = t, this.params = e, this.objs = n, this.commonObjs = s, this.annotationCanvasMap = r, this.operatorListIdx = null, this.operatorList = a, this._pageIndex = o, this.canvasFactory = l, this.filterFactory = c, this._pdfBug = d, this.pageColors = h, this.running = !1, this.graphicsReadyCallback = null, this.graphicsReady = !1, this._useRequestAnimationFrame = u === !0 && typeof window < "u", this.cancelled = !1, this.capability = Promise.withResolvers(), this.task = new TCt(this), this._cancelBound = this.cancel.bind(this), this._continueBound = this._continue.bind(this), this._scheduleNextBound = this._scheduleNext.bind(this), this._nextBound = this._next.bind(this), this._canvas = e.canvas, this._canvasContext = e.canvas ? null : e.canvasContext, this._enableHWA = p, this._dependencyTracker = e.dependencyTracker, this._operationsFilter = m;
  }
  get completed() {
    return this.capability.promise.catch(function() {
    });
  }
  initializeGraphics({
    transparency: t = !1,
    optionalContentConfig: e
  }) {
    var l, c;
    if (this.cancelled)
      return;
    if (this._canvas) {
      if (w(zp, Ym).has(this._canvas))
        throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
      w(zp, Ym).add(this._canvas);
    }
    this._pdfBug && ((l = globalThis.StepperManager) != null && l.enabled) && (this.stepper = globalThis.StepperManager.create(this._pageIndex), this.stepper.init(this.operatorList), this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint());
    const {
      viewport: n,
      transform: s,
      background: r,
      dependencyTracker: a
    } = this.params, o = this._canvasContext || this._canvas.getContext("2d", {
      alpha: !1,
      willReadFrequently: !this._enableHWA
    });
    this.gfx = new zb(o, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
      optionalContentConfig: e
    }, this.annotationCanvasMap, this.pageColors, a), this.gfx.beginDrawing({
      transform: s,
      viewport: n,
      transparency: t,
      background: r
    }), this.operatorListIdx = 0, this.graphicsReady = !0, (c = this.graphicsReadyCallback) == null || c.call(this);
  }
  cancel(t = null, e = 0) {
    var n, s, r;
    this.running = !1, this.cancelled = !0, (n = this.gfx) == null || n.endDrawing(), w(this, bh) && (window.cancelAnimationFrame(w(this, bh)), rt(this, bh, null)), w(zp, Ym).delete(this._canvas), t || (t = new $C(`Rendering cancelled, page ${this._pageIndex + 1}`, e)), this.callback(t), (r = (s = this.task).onError) == null || r.call(s, t);
  }
  operatorListChanged() {
    var t, e;
    if (!this.graphicsReady) {
      this.graphicsReadyCallback || (this.graphicsReadyCallback = this._continueBound);
      return;
    }
    (t = this.gfx.dependencyTracker) == null || t.growOperationsCount(this.operatorList.fnArray.length), (e = this.stepper) == null || e.updateOperatorList(this.operatorList), !this.running && this._continue();
  }
  _continue() {
    this.running = !0, !this.cancelled && (this.task.onContinue ? this.task.onContinue(this._scheduleNextBound) : this._scheduleNext());
  }
  _scheduleNext() {
    this._useRequestAnimationFrame ? rt(this, bh, window.requestAnimationFrame(() => {
      rt(this, bh, null), this._nextBound().catch(this._cancelBound);
    })) : Promise.resolve().then(this._nextBound).catch(this._cancelBound);
  }
  async _next() {
    this.cancelled || (this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper, this._operationsFilter), this.operatorListIdx === this.operatorList.argsArray.length && (this.running = !1, this.operatorList.lastChunk && (this.gfx.endDrawing(), w(zp, Ym).delete(this._canvas), this.callback())));
  }
};
bh = new WeakMap(), Ym = new WeakMap(), pt(zp, Ym, /* @__PURE__ */ new WeakSet());
let qV = zp;
const MCt = "5.4.296", NCt = "f56dc8601";
var no, vm, Yf, qs, jZ, vf, Du, UZ, fh, Gl, PZ, Gi, tX, eX, nX, Vp, YK, zd;
const Ca = class Ca {
  constructor({
    editor: t = null,
    uiManager: e = null
  }) {
    pt(this, Gi);
    pt(this, no, null);
    pt(this, vm, null);
    pt(this, Yf);
    pt(this, qs, null);
    pt(this, jZ, !1);
    pt(this, vf, !1);
    pt(this, Du, null);
    pt(this, UZ);
    pt(this, fh, null);
    pt(this, Gl, null);
    var n, s;
    t ? (rt(this, vf, !1), rt(this, Du, t)) : rt(this, vf, !0), rt(this, Gl, (t == null ? void 0 : t._uiManager) || e), rt(this, UZ, w(this, Gl)._eventBus), rt(this, Yf, ((n = t == null ? void 0 : t.color) == null ? void 0 : n.toUpperCase()) || ((s = w(this, Gl)) == null ? void 0 : s.highlightColors.values().next().value) || "#FFFF98"), w(Ca, PZ) || rt(Ca, PZ, Object.freeze({
      blue: "pdfjs-editor-colorpicker-blue",
      green: "pdfjs-editor-colorpicker-green",
      pink: "pdfjs-editor-colorpicker-pink",
      red: "pdfjs-editor-colorpicker-red",
      yellow: "pdfjs-editor-colorpicker-yellow"
    }));
  }
  static get _keyboardManager() {
    return Gn(this, "_keyboardManager", new $T([[["Escape", "mac+Escape"], Ca.prototype._hideDropdownFromKeyboard], [[" ", "mac+ "], Ca.prototype._colorSelectFromKeyboard], [["ArrowDown", "ArrowRight", "mac+ArrowDown", "mac+ArrowRight"], Ca.prototype._moveToNext], [["ArrowUp", "ArrowLeft", "mac+ArrowUp", "mac+ArrowLeft"], Ca.prototype._moveToPrevious], [["Home", "mac+Home"], Ca.prototype._moveToBeginning], [["End", "mac+End"], Ca.prototype._moveToEnd]]));
  }
  renderButton() {
    const t = rt(this, no, document.createElement("button"));
    t.className = "colorPicker", t.tabIndex = "0", t.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-button"), t.ariaHasPopup = "true", w(this, Du) && (t.ariaControls = `${w(this, Du).id}_colorpicker_dropdown`);
    const e = w(this, Gl)._signal;
    t.addEventListener("click", ft(this, Gi, Vp).bind(this), {
      signal: e
    }), t.addEventListener("keydown", ft(this, Gi, nX).bind(this), {
      signal: e
    });
    const n = rt(this, vm, document.createElement("span"));
    return n.className = "swatch", n.ariaHidden = "true", n.style.backgroundColor = w(this, Yf), t.append(n), t;
  }
  renderMainDropdown() {
    const t = rt(this, qs, ft(this, Gi, tX).call(this));
    return t.ariaOrientation = "horizontal", t.ariaLabelledBy = "highlightColorPickerLabel", t;
  }
  _colorSelectFromKeyboard(t) {
    if (t.target === w(this, no)) {
      ft(this, Gi, Vp).call(this, t);
      return;
    }
    const e = t.target.getAttribute("data-color");
    e && ft(this, Gi, eX).call(this, e, t);
  }
  _moveToNext(t) {
    var e, n;
    if (!w(this, Gi, zd)) {
      ft(this, Gi, Vp).call(this, t);
      return;
    }
    if (t.target === w(this, no)) {
      (e = w(this, qs).firstChild) == null || e.focus();
      return;
    }
    (n = t.target.nextSibling) == null || n.focus();
  }
  _moveToPrevious(t) {
    var e, n;
    if (t.target === ((e = w(this, qs)) == null ? void 0 : e.firstChild) || t.target === w(this, no)) {
      w(this, Gi, zd) && this._hideDropdownFromKeyboard();
      return;
    }
    w(this, Gi, zd) || ft(this, Gi, Vp).call(this, t), (n = t.target.previousSibling) == null || n.focus();
  }
  _moveToBeginning(t) {
    var e;
    if (!w(this, Gi, zd)) {
      ft(this, Gi, Vp).call(this, t);
      return;
    }
    (e = w(this, qs).firstChild) == null || e.focus();
  }
  _moveToEnd(t) {
    var e;
    if (!w(this, Gi, zd)) {
      ft(this, Gi, Vp).call(this, t);
      return;
    }
    (e = w(this, qs).lastChild) == null || e.focus();
  }
  hideDropdown() {
    var t, e;
    (t = w(this, qs)) == null || t.classList.add("hidden"), w(this, no).ariaExpanded = "false", (e = w(this, fh)) == null || e.abort(), rt(this, fh, null);
  }
  _hideDropdownFromKeyboard() {
    var t;
    if (!w(this, vf)) {
      if (!w(this, Gi, zd)) {
        (t = w(this, Du)) == null || t.unselect();
        return;
      }
      this.hideDropdown(), w(this, no).focus({
        preventScroll: !0,
        focusVisible: w(this, jZ)
      });
    }
  }
  updateColor(t) {
    if (w(this, vm) && (w(this, vm).style.backgroundColor = t), !w(this, qs))
      return;
    const e = w(this, Gl).highlightColors.values();
    for (const n of w(this, qs).children)
      n.ariaSelected = e.next().value === t.toUpperCase();
  }
  destroy() {
    var t, e;
    (t = w(this, no)) == null || t.remove(), rt(this, no, null), rt(this, vm, null), (e = w(this, qs)) == null || e.remove(), rt(this, qs, null);
  }
};
no = new WeakMap(), vm = new WeakMap(), Yf = new WeakMap(), qs = new WeakMap(), jZ = new WeakMap(), vf = new WeakMap(), Du = new WeakMap(), UZ = new WeakMap(), fh = new WeakMap(), Gl = new WeakMap(), PZ = new WeakMap(), Gi = new WeakSet(), tX = function() {
  const t = document.createElement("div"), e = w(this, Gl)._signal;
  t.addEventListener("contextmenu", al, {
    signal: e
  }), t.className = "dropdown", t.role = "listbox", t.ariaMultiSelectable = "false", t.ariaOrientation = "vertical", t.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-dropdown"), w(this, Du) && (t.id = `${w(this, Du).id}_colorpicker_dropdown`);
  for (const [n, s] of w(this, Gl).highlightColors) {
    const r = document.createElement("button");
    r.tabIndex = "0", r.role = "option", r.setAttribute("data-color", s), r.title = n, r.setAttribute("data-l10n-id", w(Ca, PZ)[n]);
    const a = document.createElement("span");
    r.append(a), a.className = "swatch", a.style.backgroundColor = s, r.ariaSelected = s === w(this, Yf), r.addEventListener("click", ft(this, Gi, eX).bind(this, s), {
      signal: e
    }), t.append(r);
  }
  return t.addEventListener("keydown", ft(this, Gi, nX).bind(this), {
    signal: e
  }), t;
}, eX = function(t, e) {
  e.stopPropagation(), w(this, UZ).dispatch("switchannotationeditorparams", {
    source: this,
    type: Un.HIGHLIGHT_COLOR,
    value: t
  }), this.updateColor(t);
}, nX = function(t) {
  Ca._keyboardManager.exec(this, t);
}, Vp = function(t) {
  if (w(this, Gi, zd)) {
    this.hideDropdown();
    return;
  }
  if (rt(this, jZ, t.detail === 0), w(this, fh) || (rt(this, fh, new AbortController()), window.addEventListener("pointerdown", ft(this, Gi, YK).bind(this), {
    signal: w(this, Gl).combinedSignal(w(this, fh))
  })), w(this, no).ariaExpanded = "true", w(this, qs)) {
    w(this, qs).classList.remove("hidden");
    return;
  }
  const e = rt(this, qs, ft(this, Gi, tX).call(this));
  w(this, no).append(e);
}, YK = function(t) {
  var e;
  (e = w(this, qs)) != null && e.contains(t.target) || this.hideDropdown();
}, zd = function() {
  return w(this, qs) && !w(this, qs).classList.contains("hidden");
}, pt(Ca, PZ, null);
let QW = Ca;
var Wc, JZ, Rf, AZ;
const Ep = class Ep {
  constructor(t) {
    pt(this, Wc, null);
    pt(this, JZ, null);
    pt(this, Rf, null);
    rt(this, JZ, t), rt(this, Rf, t._uiManager), w(Ep, AZ) || rt(Ep, AZ, Object.freeze({
      freetext: "pdfjs-editor-color-picker-free-text-input",
      ink: "pdfjs-editor-color-picker-ink-input"
    }));
  }
  renderButton() {
    if (w(this, Wc))
      return w(this, Wc);
    const {
      editorType: t,
      colorType: e,
      colorValue: n
    } = w(this, JZ), s = rt(this, Wc, document.createElement("input"));
    return s.type = "color", s.value = n || "#000000", s.className = "basicColorPicker", s.tabIndex = 0, s.setAttribute("data-l10n-id", w(Ep, AZ)[t]), s.addEventListener("input", () => {
      w(this, Rf).updateParams(e, s.value);
    }, {
      signal: w(this, Rf)._signal
    }), s;
  }
  update(t) {
    w(this, Wc) && (w(this, Wc).value = t);
  }
  destroy() {
    var t;
    (t = w(this, Wc)) == null || t.remove(), rt(this, Wc, null);
  }
  hideDropdown() {
  }
};
Wc = new WeakMap(), JZ = new WeakMap(), Rf = new WeakMap(), AZ = new WeakMap(), pt(Ep, AZ, null);
let $W = Ep;
function UE(i) {
  return Math.floor(Math.max(0, Math.min(1, i)) * 255).toString(16).padStart(2, "0");
}
function hy(i) {
  return Math.max(0, Math.min(255, 255 * i));
}
class PE {
  static CMYK_G([t, e, n, s]) {
    return ["G", 1 - Math.min(1, 0.3 * t + 0.59 * n + 0.11 * e + s)];
  }
  static G_CMYK([t]) {
    return ["CMYK", 0, 0, 0, 1 - t];
  }
  static G_RGB([t]) {
    return ["RGB", t, t, t];
  }
  static G_rgb([t]) {
    return t = hy(t), [t, t, t];
  }
  static G_HTML([t]) {
    const e = UE(t);
    return `#${e}${e}${e}`;
  }
  static RGB_G([t, e, n]) {
    return ["G", 0.3 * t + 0.59 * e + 0.11 * n];
  }
  static RGB_rgb(t) {
    return t.map(hy);
  }
  static RGB_HTML(t) {
    return `#${t.map(UE).join("")}`;
  }
  static T_HTML() {
    return "#00000000";
  }
  static T_rgb() {
    return [null];
  }
  static CMYK_RGB([t, e, n, s]) {
    return ["RGB", 1 - Math.min(1, t + s), 1 - Math.min(1, n + s), 1 - Math.min(1, e + s)];
  }
  static CMYK_rgb([t, e, n, s]) {
    return [hy(1 - Math.min(1, t + s)), hy(1 - Math.min(1, n + s)), hy(1 - Math.min(1, e + s))];
  }
  static CMYK_HTML(t) {
    const e = this.CMYK_RGB(t).slice(1);
    return this.RGB_HTML(e);
  }
  static RGB_CMYK([t, e, n]) {
    const s = 1 - t, r = 1 - e, a = 1 - n, o = Math.min(s, r, a);
    return ["CMYK", s, r, a, o];
  }
}
class WCt {
  create(t, e, n = !1) {
    if (t <= 0 || e <= 0)
      throw new Error("Invalid SVG dimensions");
    const s = this._createSVG("svg:svg");
    return s.setAttribute("version", "1.1"), n || (s.setAttribute("width", `${t}px`), s.setAttribute("height", `${e}px`)), s.setAttribute("preserveAspectRatio", "none"), s.setAttribute("viewBox", `0 0 ${t} ${e}`), s;
  }
  createElement(t) {
    if (typeof t != "string")
      throw new Error("Invalid SVG element type");
    return this._createSVG(t);
  }
  _createSVG(t) {
    Xi("Abstract method `_createSVG` called.");
  }
}
class qW extends WCt {
  _createSVG(t) {
    return document.createElementNS(ru, t);
  }
}
const GCt = 9, w0 = /* @__PURE__ */ new WeakSet(), wCt = (/* @__PURE__ */ new Date()).getTimezoneOffset() * 60 * 1e3;
class JE {
  static create(t) {
    switch (t.data.annotationType) {
      case Rs.LINK:
        return new iY(t);
      case Rs.TEXT:
        return new SCt(t);
      case Rs.WIDGET:
        switch (t.data.fieldType) {
          case "Tx":
            return new LCt(t);
          case "Btn":
            return t.data.radioButton ? new DK(t) : t.data.checkBox ? new XCt(t) : new ICt(t);
          case "Ch":
            return new CCt(t);
          case "Sig":
            return new VCt(t);
        }
        return new v0(t);
      case Rs.POPUP:
        return new sX(t);
      case Rs.FREETEXT:
        return new FK(t);
      case Rs.LINE:
        return new vCt(t);
      case Rs.SQUARE:
        return new RCt(t);
      case Rs.CIRCLE:
        return new DCt(t);
      case Rs.POLYLINE:
        return new jK(t);
      case Rs.CARET:
        return new zCt(t);
      case Rs.INK:
        return new sY(t);
      case Rs.POLYGON:
        return new OCt(t);
      case Rs.HIGHLIGHT:
        return new UK(t);
      case Rs.UNDERLINE:
        return new ECt(t);
      case Rs.SQUIGGLY:
        return new kCt(t);
      case Rs.STRIKEOUT:
        return new FCt(t);
      case Rs.STAMP:
        return new PK(t);
      case Rs.FILEATTACHMENT:
        return new jCt(t);
      default:
        return new rs(t);
    }
  }
}
var Rm, Df, Bo, BZ, iX;
const mY = class mY {
  constructor(t, {
    isRenderable: e = !1,
    ignoreBorder: n = !1,
    createQuadrilaterals: s = !1
  } = {}) {
    pt(this, BZ);
    pt(this, Rm, null);
    pt(this, Df, !1);
    pt(this, Bo, null);
    this.isRenderable = e, this.data = t.data, this.layer = t.layer, this.linkService = t.linkService, this.downloadManager = t.downloadManager, this.imageResourcesPath = t.imageResourcesPath, this.renderForms = t.renderForms, this.svgFactory = t.svgFactory, this.annotationStorage = t.annotationStorage, this.enableComment = t.enableComment, this.enableScripting = t.enableScripting, this.hasJSActions = t.hasJSActions, this._fieldObjects = t.fieldObjects, this.parent = t.parent, e && (this.container = this._createContainer(n)), s && this._createQuadrilaterals();
  }
  static _hasPopupData({
    contentsObj: t,
    richText: e
  }) {
    return !!(t != null && t.str || e != null && e.str);
  }
  get _isEditable() {
    return this.data.isEditable;
  }
  get hasPopupData() {
    return mY._hasPopupData(this.data) || this.enableComment && !!this.commentText;
  }
  get commentData() {
    var n;
    const {
      data: t
    } = this, e = (n = this.annotationStorage) == null ? void 0 : n.getEditor(t.id);
    return e ? e.getData() : t;
  }
  get hasCommentButton() {
    return this.enableComment && this.hasPopupElement;
  }
  get commentButtonPosition() {
    var o;
    const t = (o = this.annotationStorage) == null ? void 0 : o.getEditor(this.data.id);
    if (t)
      return t.commentButtonPositionInPage;
    const {
      quadPoints: e,
      inkLists: n,
      rect: s
    } = this.data;
    let r = -1 / 0, a = -1 / 0;
    if ((e == null ? void 0 : e.length) >= 8) {
      for (let l = 0; l < e.length; l += 8)
        e[l + 1] > a ? (a = e[l + 1], r = e[l + 2]) : e[l + 1] === a && (r = Math.max(r, e[l + 2]));
      return [r, a];
    }
    if ((n == null ? void 0 : n.length) >= 1) {
      for (const l of n)
        for (let c = 0, u = l.length; c < u; c += 2)
          l[c + 1] > a ? (a = l[c + 1], r = l[c]) : l[c + 1] === a && (r = Math.max(r, l[c]));
      if (r !== 1 / 0)
        return [r, a];
    }
    return s ? [s[2], s[3]] : null;
  }
  _normalizePoint(t) {
    const {
      page: {
        view: e
      },
      viewport: {
        rawDims: {
          pageWidth: n,
          pageHeight: s,
          pageX: r,
          pageY: a
        }
      }
    } = this.parent;
    return t[1] = e[3] - t[1] + e[1], t[0] = 100 * (t[0] - r) / n, t[1] = 100 * (t[1] - a) / s, t;
  }
  get commentText() {
    var e, n, s;
    const {
      data: t
    } = this;
    return ((n = (e = this.annotationStorage.getRawValue(`${z2}${t.id}`)) == null ? void 0 : e.popup) == null ? void 0 : n.contents) || ((s = t.contentsObj) == null ? void 0 : s.str) || "";
  }
  set commentText(t) {
    const {
      data: e
    } = this, n = {
      deleted: !t,
      contents: t || ""
    };
    this.annotationStorage.updateEditor(e.id, {
      popup: n
    }) || this.annotationStorage.setValue(`${z2}${e.id}`, {
      id: e.id,
      annotationType: e.annotationType,
      pageIndex: this.parent.page._pageIndex,
      popup: n,
      popupRef: e.popupRef,
      modificationDate: /* @__PURE__ */ new Date()
    }), t || this.removePopup();
  }
  removePopup() {
    var t, e;
    (e = ((t = w(this, Bo)) == null ? void 0 : t.popup) || this.popup) == null || e.remove(), rt(this, Bo, this.popup = null);
  }
  updateEdited(t) {
    var r;
    if (!this.container)
      return;
    t.rect && (w(this, Rm) || rt(this, Rm, {
      rect: this.data.rect.slice(0)
    }));
    const {
      rect: e,
      popup: n
    } = t;
    e && ft(this, BZ, iX).call(this, e);
    let s = ((r = w(this, Bo)) == null ? void 0 : r.popup) || this.popup;
    !s && (n != null && n.text) && (this._createPopup(n), s = w(this, Bo).popup), s && (s.updateEdited(t), n != null && n.deleted && (s.remove(), rt(this, Bo, null), this.popup = null));
  }
  resetEdited() {
    var t;
    w(this, Rm) && (ft(this, BZ, iX).call(this, w(this, Rm).rect), (t = w(this, Bo)) == null || t.popup.resetEdited(), rt(this, Rm, null));
  }
  _createContainer(t) {
    const {
      data: e,
      parent: {
        page: n,
        viewport: s
      }
    } = this, r = document.createElement("section");
    r.setAttribute("data-annotation-id", e.id), !(this instanceof v0) && !(this instanceof iY) && (r.tabIndex = 0);
    const {
      style: a
    } = r;
    if (a.zIndex = this.parent.zIndex, this.parent.zIndex += 2, e.alternativeText && (r.title = e.alternativeText), e.noRotate && r.classList.add("norotate"), !e.rect || this instanceof sX) {
      const {
        rotation: b
      } = e;
      return !e.hasOwnCanvas && b !== 0 && this.setRotation(b, r), r;
    }
    const {
      width: o,
      height: l
    } = this;
    if (!t && e.borderStyle.width > 0) {
      a.borderWidth = `${e.borderStyle.width}px`;
      const b = e.borderStyle.horizontalCornerRadius, y = e.borderStyle.verticalCornerRadius;
      if (b > 0 || y > 0) {
        const g = `calc(${b}px * var(--total-scale-factor)) / calc(${y}px * var(--total-scale-factor))`;
        a.borderRadius = g;
      } else if (this instanceof DK) {
        const g = `calc(${o}px * var(--total-scale-factor)) / calc(${l}px * var(--total-scale-factor))`;
        a.borderRadius = g;
      }
      switch (e.borderStyle.style) {
        case cb.SOLID:
          a.borderStyle = "solid";
          break;
        case cb.DASHED:
          a.borderStyle = "dashed";
          break;
        case cb.BEVELED:
          pn("Unimplemented border style: beveled");
          break;
        case cb.INSET:
          pn("Unimplemented border style: inset");
          break;
        case cb.UNDERLINE:
          a.borderBottomStyle = "solid";
          break;
      }
      const Z = e.borderColor || null;
      Z ? (rt(this, Df, !0), a.borderColor = ze.makeHexColor(Z[0] | 0, Z[1] | 0, Z[2] | 0)) : a.borderWidth = 0;
    }
    const c = ze.normalizeRect([e.rect[0], n.view[3] - e.rect[1] + n.view[1], e.rect[2], n.view[3] - e.rect[3] + n.view[1]]), {
      pageWidth: u,
      pageHeight: d,
      pageX: h,
      pageY: p
    } = s.rawDims;
    a.left = `${100 * (c[0] - h) / u}%`, a.top = `${100 * (c[1] - p) / d}%`;
    const {
      rotation: m
    } = e;
    return e.hasOwnCanvas || m === 0 ? (a.width = `${100 * o / u}%`, a.height = `${100 * l / d}%`) : this.setRotation(m, r), r;
  }
  setRotation(t, e = this.container) {
    if (!this.data.rect)
      return;
    const {
      pageWidth: n,
      pageHeight: s
    } = this.parent.viewport.rawDims;
    let {
      width: r,
      height: a
    } = this;
    t % 180 !== 0 && ([r, a] = [a, r]), e.style.width = `${100 * r / n}%`, e.style.height = `${100 * a / s}%`, e.setAttribute("data-main-rotation", (360 - t) % 360);
  }
  get _commonActions() {
    const t = (e, n, s) => {
      const r = s.detail[e], a = r[0], o = r.slice(1);
      s.target.style[n] = PE[`${a}_HTML`](o), this.annotationStorage.setValue(this.data.id, {
        [n]: PE[`${a}_rgb`](o)
      });
    };
    return Gn(this, "_commonActions", {
      display: (e) => {
        const {
          display: n
        } = e.detail, s = n % 2 === 1;
        this.container.style.visibility = s ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
          noView: s,
          noPrint: n === 1 || n === 2
        });
      },
      print: (e) => {
        this.annotationStorage.setValue(this.data.id, {
          noPrint: !e.detail.print
        });
      },
      hidden: (e) => {
        const {
          hidden: n
        } = e.detail;
        this.container.style.visibility = n ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
          noPrint: n,
          noView: n
        });
      },
      focus: (e) => {
        setTimeout(() => e.target.focus({
          preventScroll: !1
        }), 0);
      },
      userName: (e) => {
        e.target.title = e.detail.userName;
      },
      readonly: (e) => {
        e.target.disabled = e.detail.readonly;
      },
      required: (e) => {
        this._setRequired(e.target, e.detail.required);
      },
      bgColor: (e) => {
        t("bgColor", "backgroundColor", e);
      },
      fillColor: (e) => {
        t("fillColor", "backgroundColor", e);
      },
      fgColor: (e) => {
        t("fgColor", "color", e);
      },
      textColor: (e) => {
        t("textColor", "color", e);
      },
      borderColor: (e) => {
        t("borderColor", "borderColor", e);
      },
      strokeColor: (e) => {
        t("strokeColor", "borderColor", e);
      },
      rotation: (e) => {
        const n = e.detail.rotation;
        this.setRotation(n), this.annotationStorage.setValue(this.data.id, {
          rotation: n
        });
      }
    });
  }
  _dispatchEventFromSandbox(t, e) {
    const n = this._commonActions;
    for (const s of Object.keys(e.detail)) {
      const r = t[s] || n[s];
      r == null || r(e);
    }
  }
  _setDefaultPropertiesFromJS(t) {
    if (!this.enableScripting)
      return;
    const e = this.annotationStorage.getRawValue(this.data.id);
    if (!e)
      return;
    const n = this._commonActions;
    for (const [s, r] of Object.entries(e)) {
      const a = n[s];
      if (a) {
        const o = {
          detail: {
            [s]: r
          },
          target: t
        };
        a(o), delete e[s];
      }
    }
  }
  _createQuadrilaterals() {
    if (!this.container)
      return;
    const {
      quadPoints: t
    } = this.data;
    if (!t)
      return;
    const [e, n, s, r] = this.data.rect.map((b) => Math.fround(b));
    if (t.length === 8) {
      const [b, y, Z, g] = t.subarray(2, 6);
      if (s === b && r === y && e === Z && n === g)
        return;
    }
    const {
      style: a
    } = this.container;
    let o;
    if (w(this, Df)) {
      const {
        borderColor: b,
        borderWidth: y
      } = a;
      a.borderWidth = 0, o = ["url('data:image/svg+xml;utf8,", '<svg xmlns="http://www.w3.org/2000/svg"', ' preserveAspectRatio="none" viewBox="0 0 1 1">', `<g fill="transparent" stroke="${b}" stroke-width="${y}">`], this.container.classList.add("hasBorder");
    }
    const l = s - e, c = r - n, {
      svgFactory: u
    } = this, d = u.createElement("svg");
    d.classList.add("quadrilateralsContainer"), d.setAttribute("width", 0), d.setAttribute("height", 0), d.role = "none";
    const h = u.createElement("defs");
    d.append(h);
    const p = u.createElement("clipPath"), m = `clippath_${this.data.id}`;
    p.setAttribute("id", m), p.setAttribute("clipPathUnits", "objectBoundingBox"), h.append(p);
    for (let b = 2, y = t.length; b < y; b += 8) {
      const Z = t[b], g = t[b + 1], f = t[b + 2], T = t[b + 3], M = u.createElement("rect"), N = (f - e) / l, W = (r - g) / c, x = (Z - f) / l, V = (g - T) / c;
      M.setAttribute("x", N), M.setAttribute("y", W), M.setAttribute("width", x), M.setAttribute("height", V), p.append(M), o == null || o.push(`<rect vector-effect="non-scaling-stroke" x="${N}" y="${W}" width="${x}" height="${V}"/>`);
    }
    w(this, Df) && (o.push("</g></svg>')"), a.backgroundImage = o.join("")), this.container.append(d), this.container.style.clipPath = `url(#${m})`;
  }
  _createPopup(t = null) {
    const {
      data: e
    } = this;
    let n, s;
    t ? (n = {
      str: t.text
    }, s = t.date) : (n = e.contentsObj, s = e.modificationDate);
    const r = rt(this, Bo, new sX({
      data: {
        color: e.color,
        titleObj: e.titleObj,
        modificationDate: s,
        contentsObj: n,
        richText: e.richText,
        parentRect: e.rect,
        borderStyle: 0,
        id: `popup_${e.id}`,
        rotation: e.rotation,
        noRotate: !0
      },
      linkService: this.linkService,
      parent: this.parent,
      elements: [this]
    }));
    this.parent._commentManager || this.parent.div.append(r.render());
  }
  get hasPopupElement() {
    return !!(w(this, Bo) || this.popup || this.data.popupRef);
  }
  get extraPopupElement() {
    return w(this, Bo);
  }
  render() {
    Xi("Abstract method `AnnotationElement.render` called");
  }
  _getElementsByName(t, e = null) {
    const n = [];
    if (this._fieldObjects) {
      const s = this._fieldObjects[t];
      if (s)
        for (const {
          page: r,
          id: a,
          exportValues: o
        } of s) {
          if (r === -1 || a === e)
            continue;
          const l = typeof o == "string" ? o : null, c = document.querySelector(`[data-element-id="${a}"]`);
          if (c && !w0.has(c)) {
            pn(`_getElementsByName - element not allowed: ${a}`);
            continue;
          }
          n.push({
            id: a,
            exportValue: l,
            domElement: c
          });
        }
      return n;
    }
    for (const s of document.getElementsByName(t)) {
      const {
        exportValue: r
      } = s, a = s.getAttribute("data-element-id");
      a !== e && w0.has(s) && n.push({
        id: a,
        exportValue: r,
        domElement: s
      });
    }
    return n;
  }
  show() {
    var t;
    this.container && (this.container.hidden = !1), (t = this.popup) == null || t.maybeShow();
  }
  hide() {
    var t;
    this.container && (this.container.hidden = !0), (t = this.popup) == null || t.forceHide();
  }
  getElementsToTriggerPopup() {
    return this.container;
  }
  addHighlightArea() {
    const t = this.getElementsToTriggerPopup();
    if (Array.isArray(t))
      for (const e of t)
        e.classList.add("highlightArea");
    else
      t.classList.add("highlightArea");
  }
  _editOnDoubleClick() {
    if (!this._isEditable)
      return;
    const {
      annotationEditorType: t,
      data: {
        id: e
      }
    } = this;
    this.container.addEventListener("dblclick", () => {
      var n;
      (n = this.linkService.eventBus) == null || n.dispatch("switchannotationeditormode", {
        source: this,
        mode: t,
        editId: e,
        mustEnterInEditMode: !0
      });
    });
  }
  get width() {
    return this.data.rect[2] - this.data.rect[0];
  }
  get height() {
    return this.data.rect[3] - this.data.rect[1];
  }
};
Rm = new WeakMap(), Df = new WeakMap(), Bo = new WeakMap(), BZ = new WeakSet(), iX = function(t) {
  const {
    container: {
      style: e
    },
    data: {
      rect: n,
      rotation: s
    },
    parent: {
      viewport: {
        rawDims: {
          pageWidth: r,
          pageHeight: a,
          pageX: o,
          pageY: l
        }
      }
    }
  } = this;
  n == null || n.splice(0, 4, ...t), e.left = `${100 * (t[0] - o) / r}%`, e.top = `${100 * (a - t[3] + l) / a}%`, s === 0 ? (e.width = `${100 * (t[2] - t[0]) / r}%`, e.height = `${100 * (t[3] - t[1]) / a}%`) : this.setRotation(s);
};
let rs = mY;
class xCt extends rs {
  constructor(t) {
    super(t, {
      isRenderable: !0,
      ignoreBorder: !0
    }), this.editor = t.editor;
  }
  render() {
    return this.container.className = "editorAnnotation", this.container;
  }
  createOrUpdatePopup() {
    const {
      editor: t
    } = this;
    t.hasComment && (this._createPopup(t.comment), this.extraPopupElement.popup.renderCommentButton());
  }
  get hasCommentButton() {
    return this.enableComment && this.editor.hasComment;
  }
  get commentButtonPosition() {
    return this.editor.commentButtonPositionInPage;
  }
  get commentText() {
    return this.editor.comment.text;
  }
  set commentText(t) {
    this.editor.comment = t, t || this.removePopup();
  }
  get commentData() {
    return this.editor.getData();
  }
  remove() {
    this.container.remove(), this.container = null, this.removePopup();
  }
}
var To, Xp, vK, RK;
class iY extends rs {
  constructor(e, n = null) {
    super(e, {
      isRenderable: !0,
      ignoreBorder: !!(n != null && n.ignoreBorder),
      createQuadrilaterals: !0
    });
    pt(this, To);
    this.isTooltipOnly = e.data.isTooltipOnly;
  }
  render() {
    const {
      data: e,
      linkService: n
    } = this, s = document.createElement("a");
    s.setAttribute("data-element-id", e.id);
    let r = !1;
    return e.url ? (n.addLinkAttributes(s, e.url, e.newWindow), r = !0) : e.action ? (this._bindNamedAction(s, e.action, e.overlaidText), r = !0) : e.attachment ? (ft(this, To, vK).call(this, s, e.attachment, e.overlaidText, e.attachmentDest), r = !0) : e.setOCGState ? (ft(this, To, RK).call(this, s, e.setOCGState, e.overlaidText), r = !0) : e.dest ? (this._bindLink(s, e.dest, e.overlaidText), r = !0) : (e.actions && (e.actions.Action || e.actions["Mouse Up"] || e.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions && (this._bindJSAction(s, e), r = !0), e.resetForm ? (this._bindResetFormAction(s, e.resetForm), r = !0) : this.isTooltipOnly && !r && (this._bindLink(s, ""), r = !0)), this.container.classList.add("linkAnnotation"), r && this.container.append(s), this.container;
  }
  _bindLink(e, n, s = "") {
    e.href = this.linkService.getDestinationHash(n), e.onclick = () => (n && this.linkService.goToDestination(n), !1), (n || n === "") && ft(this, To, Xp).call(this), s && (e.title = s);
  }
  _bindNamedAction(e, n, s = "") {
    e.href = this.linkService.getAnchorUrl(""), e.onclick = () => (this.linkService.executeNamedAction(n), !1), s && (e.title = s), ft(this, To, Xp).call(this);
  }
  _bindJSAction(e, n) {
    e.href = this.linkService.getAnchorUrl("");
    const s = /* @__PURE__ */ new Map([["Action", "onclick"], ["Mouse Up", "onmouseup"], ["Mouse Down", "onmousedown"]]);
    for (const r of Object.keys(n.actions)) {
      const a = s.get(r);
      a && (e[a] = () => {
        var o;
        return (o = this.linkService.eventBus) == null || o.dispatch("dispatcheventinsandbox", {
          source: this,
          detail: {
            id: n.id,
            name: r
          }
        }), !1;
      });
    }
    n.overlaidText && (e.title = n.overlaidText), e.onclick || (e.onclick = () => !1), ft(this, To, Xp).call(this);
  }
  _bindResetFormAction(e, n) {
    const s = e.onclick;
    if (s || (e.href = this.linkService.getAnchorUrl("")), ft(this, To, Xp).call(this), !this._fieldObjects) {
      pn('_bindResetFormAction - "resetForm" action not supported, ensure that the `fieldObjects` parameter is provided.'), s || (e.onclick = () => !1);
      return;
    }
    e.onclick = () => {
      var d;
      s == null || s();
      const {
        fields: r,
        refs: a,
        include: o
      } = n, l = [];
      if (r.length !== 0 || a.length !== 0) {
        const h = new Set(a);
        for (const p of r) {
          const m = this._fieldObjects[p] || [];
          for (const {
            id: b
          } of m)
            h.add(b);
        }
        for (const p of Object.values(this._fieldObjects))
          for (const m of p)
            h.has(m.id) === o && l.push(m);
      } else
        for (const h of Object.values(this._fieldObjects))
          l.push(...h);
      const c = this.annotationStorage, u = [];
      for (const h of l) {
        const {
          id: p
        } = h;
        switch (u.push(p), h.type) {
          case "text": {
            const b = h.defaultValue || "";
            c.setValue(p, {
              value: b
            });
            break;
          }
          case "checkbox":
          case "radiobutton": {
            const b = h.defaultValue === h.exportValues;
            c.setValue(p, {
              value: b
            });
            break;
          }
          case "combobox":
          case "listbox": {
            const b = h.defaultValue || "";
            c.setValue(p, {
              value: b
            });
            break;
          }
          default:
            continue;
        }
        const m = document.querySelector(`[data-element-id="${p}"]`);
        if (m) {
          if (!w0.has(m)) {
            pn(`_bindResetFormAction - element not allowed: ${p}`);
            continue;
          }
        } else continue;
        m.dispatchEvent(new Event("resetform"));
      }
      return this.enableScripting && ((d = this.linkService.eventBus) == null || d.dispatch("dispatcheventinsandbox", {
        source: this,
        detail: {
          id: "app",
          ids: u,
          name: "ResetForm"
        }
      })), !1;
    };
  }
}
To = new WeakSet(), Xp = function() {
  this.container.setAttribute("data-internal-link", "");
}, vK = function(e, n, s = "", r = null) {
  e.href = this.linkService.getAnchorUrl(""), n.description ? e.title = n.description : s && (e.title = s), e.onclick = () => {
    var a;
    return (a = this.downloadManager) == null || a.openOrDownloadData(n.content, n.filename, r), !1;
  }, ft(this, To, Xp).call(this);
}, RK = function(e, n, s = "") {
  e.href = this.linkService.getAnchorUrl(""), e.onclick = () => (this.linkService.executeSetOCGState(n), !1), s && (e.title = s), ft(this, To, Xp).call(this);
};
class SCt extends rs {
  constructor(t) {
    super(t, {
      isRenderable: !0
    });
  }
  render() {
    this.container.classList.add("textAnnotation");
    const t = document.createElement("img");
    return t.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg", t.setAttribute("data-l10n-id", "pdfjs-text-annotation-type"), t.setAttribute("data-l10n-args", JSON.stringify({
      type: this.data.name
    })), !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.append(t), this.container;
  }
}
class v0 extends rs {
  render() {
    return this.container;
  }
  showElementAndHideCanvas(t) {
    var e;
    this.data.hasOwnCanvas && (((e = t.previousSibling) == null ? void 0 : e.nodeName) === "CANVAS" && (t.previousSibling.hidden = !0), t.hidden = !1);
  }
  _getKeyModifier(t) {
    return Er.platform.isMac ? t.metaKey : t.ctrlKey;
  }
  _setEventListener(t, e, n, s, r) {
    n.includes("mouse") ? t.addEventListener(n, (a) => {
      var o;
      (o = this.linkService.eventBus) == null || o.dispatch("dispatcheventinsandbox", {
        source: this,
        detail: {
          id: this.data.id,
          name: s,
          value: r(a),
          shift: a.shiftKey,
          modifier: this._getKeyModifier(a)
        }
      });
    }) : t.addEventListener(n, (a) => {
      var o;
      if (n === "blur") {
        if (!e.focused || !a.relatedTarget)
          return;
        e.focused = !1;
      } else if (n === "focus") {
        if (e.focused)
          return;
        e.focused = !0;
      }
      r && ((o = this.linkService.eventBus) == null || o.dispatch("dispatcheventinsandbox", {
        source: this,
        detail: {
          id: this.data.id,
          name: s,
          value: r(a)
        }
      }));
    });
  }
  _setEventListeners(t, e, n, s) {
    var r, a, o;
    for (const [l, c] of n)
      (c === "Action" || (r = this.data.actions) != null && r[c]) && ((c === "Focus" || c === "Blur") && (e || (e = {
        focused: !1
      })), this._setEventListener(t, e, l, c, s), c === "Focus" && !((a = this.data.actions) != null && a.Blur) ? this._setEventListener(t, e, "blur", "Blur", null) : c === "Blur" && !((o = this.data.actions) != null && o.Focus) && this._setEventListener(t, e, "focus", "Focus", null));
  }
  _setBackgroundColor(t) {
    const e = this.data.backgroundColor || null;
    t.style.backgroundColor = e === null ? "transparent" : ze.makeHexColor(e[0], e[1], e[2]);
  }
  _setTextStyle(t) {
    const e = ["left", "center", "right"], {
      fontColor: n
    } = this.data.defaultAppearanceData, s = this.data.defaultAppearanceData.fontSize || GCt, r = t.style;
    let a;
    const o = 2, l = (c) => Math.round(10 * c) / 10;
    if (this.data.multiLine) {
      const c = Math.abs(this.data.rect[3] - this.data.rect[1] - o), u = Math.round(c / (CS * s)) || 1, d = c / u;
      a = Math.min(s, l(d / CS));
    } else {
      const c = Math.abs(this.data.rect[3] - this.data.rect[1] - o);
      a = Math.min(s, l(c / CS));
    }
    r.fontSize = `calc(${a}px * var(--total-scale-factor))`, r.color = ze.makeHexColor(n[0], n[1], n[2]), this.data.textAlignment !== null && (r.textAlign = e[this.data.textAlignment]);
  }
  _setRequired(t, e) {
    e ? t.setAttribute("required", !0) : t.removeAttribute("required"), t.setAttribute("aria-required", e);
  }
}
class LCt extends v0 {
  constructor(t) {
    const e = t.renderForms || t.data.hasOwnCanvas || !t.data.hasAppearance && !!t.data.fieldValue;
    super(t, {
      isRenderable: e
    });
  }
  setPropertyOnSiblings(t, e, n, s) {
    const r = this.annotationStorage;
    for (const a of this._getElementsByName(t.name, t.id))
      a.domElement && (a.domElement[e] = n), r.setValue(a.id, {
        [s]: n
      });
  }
  render() {
    var s, r;
    const t = this.annotationStorage, e = this.data.id;
    this.container.classList.add("textWidgetAnnotation");
    let n = null;
    if (this.renderForms) {
      const a = t.getValue(e, {
        value: this.data.fieldValue
      });
      let o = a.value || "";
      const l = t.getValue(e, {
        charLimit: this.data.maxLen
      }).charLimit;
      l && o.length > l && (o = o.slice(0, l));
      let c = a.formattedValue || ((s = this.data.textContent) == null ? void 0 : s.join(`
`)) || null;
      c && this.data.comb && (c = c.replaceAll(/\s+/g, ""));
      const u = {
        userValue: o,
        formattedValue: c,
        lastCommittedValue: null,
        commitKey: 1,
        focused: !1
      };
      this.data.multiLine ? (n = document.createElement("textarea"), n.textContent = c ?? o, this.data.doNotScroll && (n.style.overflowY = "hidden")) : (n = document.createElement("input"), n.type = this.data.password ? "password" : "text", n.setAttribute("value", c ?? o), this.data.doNotScroll && (n.style.overflowX = "hidden")), this.data.hasOwnCanvas && (n.hidden = !0), w0.add(n), n.setAttribute("data-element-id", e), n.disabled = this.data.readOnly, n.name = this.data.fieldName, n.tabIndex = 0;
      const {
        datetimeFormat: d,
        datetimeType: h,
        timeStep: p
      } = this.data, m = !!h && this.enableScripting;
      d && (n.title = d), this._setRequired(n, this.data.required), l && (n.maxLength = l), n.addEventListener("input", (y) => {
        t.setValue(e, {
          value: y.target.value
        }), this.setPropertyOnSiblings(n, "value", y.target.value, "value"), u.formattedValue = null;
      }), n.addEventListener("resetform", (y) => {
        const Z = this.data.defaultFieldValue ?? "";
        n.value = u.userValue = Z, u.formattedValue = null;
      });
      let b = (y) => {
        const {
          formattedValue: Z
        } = u;
        Z != null && (y.target.value = Z), y.target.scrollLeft = 0;
      };
      if (this.enableScripting && this.hasJSActions) {
        n.addEventListener("focus", (Z) => {
          var f;
          if (u.focused)
            return;
          const {
            target: g
          } = Z;
          if (m && (g.type = h, p && (g.step = p)), u.userValue) {
            const T = u.userValue;
            if (m)
              if (h === "time") {
                const M = new Date(T), N = [M.getHours(), M.getMinutes(), M.getSeconds()];
                g.value = N.map((W) => W.toString().padStart(2, "0")).join(":");
              } else
                g.value = new Date(T - wCt).toISOString().split(h === "date" ? "T" : ".", 1)[0];
            else
              g.value = T;
          }
          u.lastCommittedValue = g.value, u.commitKey = 1, (f = this.data.actions) != null && f.Focus || (u.focused = !0);
        }), n.addEventListener("updatefromsandbox", (Z) => {
          this.showElementAndHideCanvas(Z.target);
          const g = {
            value(f) {
              u.userValue = f.detail.value ?? "", m || t.setValue(e, {
                value: u.userValue.toString()
              }), f.target.value = u.userValue;
            },
            formattedValue(f) {
              const {
                formattedValue: T
              } = f.detail;
              u.formattedValue = T, T != null && f.target !== document.activeElement && (f.target.value = T);
              const M = {
                formattedValue: T
              };
              m && (M.value = T), t.setValue(e, M);
            },
            selRange(f) {
              f.target.setSelectionRange(...f.detail.selRange);
            },
            charLimit: (f) => {
              var W;
              const {
                charLimit: T
              } = f.detail, {
                target: M
              } = f;
              if (T === 0) {
                M.removeAttribute("maxLength");
                return;
              }
              M.setAttribute("maxLength", T);
              let N = u.userValue;
              !N || N.length <= T || (N = N.slice(0, T), M.value = u.userValue = N, t.setValue(e, {
                value: N
              }), (W = this.linkService.eventBus) == null || W.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                  id: e,
                  name: "Keystroke",
                  value: N,
                  willCommit: !0,
                  commitKey: 1,
                  selStart: M.selectionStart,
                  selEnd: M.selectionEnd
                }
              }));
            }
          };
          this._dispatchEventFromSandbox(g, Z);
        }), n.addEventListener("keydown", (Z) => {
          var T;
          u.commitKey = 1;
          let g = -1;
          if (Z.key === "Escape" ? g = 0 : Z.key === "Enter" && !this.data.multiLine ? g = 2 : Z.key === "Tab" && (u.commitKey = 3), g === -1)
            return;
          const {
            value: f
          } = Z.target;
          u.lastCommittedValue !== f && (u.lastCommittedValue = f, u.userValue = f, (T = this.linkService.eventBus) == null || T.dispatch("dispatcheventinsandbox", {
            source: this,
            detail: {
              id: e,
              name: "Keystroke",
              value: f,
              willCommit: !0,
              commitKey: g,
              selStart: Z.target.selectionStart,
              selEnd: Z.target.selectionEnd
            }
          }));
        });
        const y = b;
        b = null, n.addEventListener("blur", (Z) => {
          var T, M;
          if (!u.focused || !Z.relatedTarget)
            return;
          (T = this.data.actions) != null && T.Blur || (u.focused = !1);
          const {
            target: g
          } = Z;
          let {
            value: f
          } = g;
          if (m) {
            if (f && h === "time") {
              const N = f.split(":").map((W) => parseInt(W, 10));
              f = new Date(2e3, 0, 1, N[0], N[1], N[2] || 0).valueOf(), g.step = "";
            } else
              f.includes("T") || (f = `${f}T00:00`), f = new Date(f).valueOf();
            g.type = "text";
          }
          u.userValue = f, u.lastCommittedValue !== f && ((M = this.linkService.eventBus) == null || M.dispatch("dispatcheventinsandbox", {
            source: this,
            detail: {
              id: e,
              name: "Keystroke",
              value: f,
              willCommit: !0,
              commitKey: u.commitKey,
              selStart: Z.target.selectionStart,
              selEnd: Z.target.selectionEnd
            }
          })), y(Z);
        }), (r = this.data.actions) != null && r.Keystroke && n.addEventListener("beforeinput", (Z) => {
          var V;
          u.lastCommittedValue = null;
          const {
            data: g,
            target: f
          } = Z, {
            value: T,
            selectionStart: M,
            selectionEnd: N
          } = f;
          let W = M, x = N;
          switch (Z.inputType) {
            case "deleteWordBackward": {
              const X = T.substring(0, M).match(/\w*[^\w]*$/);
              X && (W -= X[0].length);
              break;
            }
            case "deleteWordForward": {
              const X = T.substring(M).match(/^[^\w]*\w*/);
              X && (x += X[0].length);
              break;
            }
            case "deleteContentBackward":
              M === N && (W -= 1);
              break;
            case "deleteContentForward":
              M === N && (x += 1);
              break;
          }
          Z.preventDefault(), (V = this.linkService.eventBus) == null || V.dispatch("dispatcheventinsandbox", {
            source: this,
            detail: {
              id: e,
              name: "Keystroke",
              value: T,
              change: g || "",
              willCommit: !1,
              selStart: W,
              selEnd: x
            }
          });
        }), this._setEventListeners(n, u, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (Z) => Z.target.value);
      }
      if (b && n.addEventListener("blur", b), this.data.comb) {
        const Z = (this.data.rect[2] - this.data.rect[0]) / l;
        n.classList.add("comb"), n.style.letterSpacing = `calc(${Z}px * var(--total-scale-factor) - 1ch)`;
      }
    } else
      n = document.createElement("div"), n.textContent = this.data.fieldValue, n.style.verticalAlign = "middle", n.style.display = "table-cell", this.data.hasOwnCanvas && (n.hidden = !0);
    return this._setTextStyle(n), this._setBackgroundColor(n), this._setDefaultPropertiesFromJS(n), this.container.append(n), this.container;
  }
}
class VCt extends v0 {
  constructor(t) {
    super(t, {
      isRenderable: !!t.data.hasOwnCanvas
    });
  }
}
class XCt extends v0 {
  constructor(t) {
    super(t, {
      isRenderable: t.renderForms
    });
  }
  render() {
    const t = this.annotationStorage, e = this.data, n = e.id;
    let s = t.getValue(n, {
      value: e.exportValue === e.fieldValue
    }).value;
    typeof s == "string" && (s = s !== "Off", t.setValue(n, {
      value: s
    })), this.container.classList.add("buttonWidgetAnnotation", "checkBox");
    const r = document.createElement("input");
    return w0.add(r), r.setAttribute("data-element-id", n), r.disabled = e.readOnly, this._setRequired(r, this.data.required), r.type = "checkbox", r.name = e.fieldName, s && r.setAttribute("checked", !0), r.setAttribute("exportValue", e.exportValue), r.tabIndex = 0, r.addEventListener("change", (a) => {
      const {
        name: o,
        checked: l
      } = a.target;
      for (const c of this._getElementsByName(o, n)) {
        const u = l && c.exportValue === e.exportValue;
        c.domElement && (c.domElement.checked = u), t.setValue(c.id, {
          value: u
        });
      }
      t.setValue(n, {
        value: l
      });
    }), r.addEventListener("resetform", (a) => {
      const o = e.defaultFieldValue || "Off";
      a.target.checked = o === e.exportValue;
    }), this.enableScripting && this.hasJSActions && (r.addEventListener("updatefromsandbox", (a) => {
      const o = {
        value(l) {
          l.target.checked = l.detail.value !== "Off", t.setValue(n, {
            value: l.target.checked
          });
        }
      };
      this._dispatchEventFromSandbox(o, a);
    }), this._setEventListeners(r, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (a) => a.target.checked)), this._setBackgroundColor(r), this._setDefaultPropertiesFromJS(r), this.container.append(r), this.container;
  }
}
class DK extends v0 {
  constructor(t) {
    super(t, {
      isRenderable: t.renderForms
    });
  }
  render() {
    this.container.classList.add("buttonWidgetAnnotation", "radioButton");
    const t = this.annotationStorage, e = this.data, n = e.id;
    let s = t.getValue(n, {
      value: e.fieldValue === e.buttonValue
    }).value;
    if (typeof s == "string" && (s = s !== e.buttonValue, t.setValue(n, {
      value: s
    })), s)
      for (const a of this._getElementsByName(e.fieldName, n))
        t.setValue(a.id, {
          value: !1
        });
    const r = document.createElement("input");
    if (w0.add(r), r.setAttribute("data-element-id", n), r.disabled = e.readOnly, this._setRequired(r, this.data.required), r.type = "radio", r.name = e.fieldName, s && r.setAttribute("checked", !0), r.tabIndex = 0, r.addEventListener("change", (a) => {
      const {
        name: o,
        checked: l
      } = a.target;
      for (const c of this._getElementsByName(o, n))
        t.setValue(c.id, {
          value: !1
        });
      t.setValue(n, {
        value: l
      });
    }), r.addEventListener("resetform", (a) => {
      const o = e.defaultFieldValue;
      a.target.checked = o != null && o === e.buttonValue;
    }), this.enableScripting && this.hasJSActions) {
      const a = e.buttonValue;
      r.addEventListener("updatefromsandbox", (o) => {
        const l = {
          value: (c) => {
            const u = a === c.detail.value;
            for (const d of this._getElementsByName(c.target.name)) {
              const h = u && d.id === n;
              d.domElement && (d.domElement.checked = h), t.setValue(d.id, {
                value: h
              });
            }
          }
        };
        this._dispatchEventFromSandbox(l, o);
      }), this._setEventListeners(r, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (o) => o.target.checked);
    }
    return this._setBackgroundColor(r), this._setDefaultPropertiesFromJS(r), this.container.append(r), this.container;
  }
}
class ICt extends iY {
  constructor(t) {
    super(t, {
      ignoreBorder: t.data.hasAppearance
    });
  }
  render() {
    const t = super.render();
    t.classList.add("buttonWidgetAnnotation", "pushButton");
    const e = t.lastChild;
    return this.enableScripting && this.hasJSActions && e && (this._setDefaultPropertiesFromJS(e), e.addEventListener("updatefromsandbox", (n) => {
      this._dispatchEventFromSandbox({}, n);
    })), t;
  }
}
class CCt extends v0 {
  constructor(t) {
    super(t, {
      isRenderable: t.renderForms
    });
  }
  render() {
    this.container.classList.add("choiceWidgetAnnotation");
    const t = this.annotationStorage, e = this.data.id, n = t.getValue(e, {
      value: this.data.fieldValue
    }), s = document.createElement("select");
    w0.add(s), s.setAttribute("data-element-id", e), s.disabled = this.data.readOnly, this._setRequired(s, this.data.required), s.name = this.data.fieldName, s.tabIndex = 0;
    let r = this.data.combo && this.data.options.length > 0;
    this.data.combo || (s.size = this.data.options.length, this.data.multiSelect && (s.multiple = !0)), s.addEventListener("resetform", (u) => {
      const d = this.data.defaultFieldValue;
      for (const h of s.options)
        h.selected = h.value === d;
    });
    for (const u of this.data.options) {
      const d = document.createElement("option");
      d.textContent = u.displayValue, d.value = u.exportValue, n.value.includes(u.exportValue) && (d.setAttribute("selected", !0), r = !1), s.append(d);
    }
    let a = null;
    if (r) {
      const u = document.createElement("option");
      u.value = " ", u.setAttribute("hidden", !0), u.setAttribute("selected", !0), s.prepend(u), a = () => {
        u.remove(), s.removeEventListener("input", a), a = null;
      }, s.addEventListener("input", a);
    }
    const o = (u) => {
      const d = u ? "value" : "textContent", {
        options: h,
        multiple: p
      } = s;
      return p ? Array.prototype.filter.call(h, (m) => m.selected).map((m) => m[d]) : h.selectedIndex === -1 ? null : h[h.selectedIndex][d];
    };
    let l = o(!1);
    const c = (u) => {
      const d = u.target.options;
      return Array.prototype.map.call(d, (h) => ({
        displayValue: h.textContent,
        exportValue: h.value
      }));
    };
    return this.enableScripting && this.hasJSActions ? (s.addEventListener("updatefromsandbox", (u) => {
      const d = {
        value(h) {
          a == null || a();
          const p = h.detail.value, m = new Set(Array.isArray(p) ? p : [p]);
          for (const b of s.options)
            b.selected = m.has(b.value);
          t.setValue(e, {
            value: o(!0)
          }), l = o(!1);
        },
        multipleSelection(h) {
          s.multiple = !0;
        },
        remove(h) {
          const p = s.options, m = h.detail.remove;
          p[m].selected = !1, s.remove(m), p.length > 0 && Array.prototype.findIndex.call(p, (y) => y.selected) === -1 && (p[0].selected = !0), t.setValue(e, {
            value: o(!0),
            items: c(h)
          }), l = o(!1);
        },
        clear(h) {
          for (; s.length !== 0; )
            s.remove(0);
          t.setValue(e, {
            value: null,
            items: []
          }), l = o(!1);
        },
        insert(h) {
          const {
            index: p,
            displayValue: m,
            exportValue: b
          } = h.detail.insert, y = s.children[p], Z = document.createElement("option");
          Z.textContent = m, Z.value = b, y ? y.before(Z) : s.append(Z), t.setValue(e, {
            value: o(!0),
            items: c(h)
          }), l = o(!1);
        },
        items(h) {
          const {
            items: p
          } = h.detail;
          for (; s.length !== 0; )
            s.remove(0);
          for (const m of p) {
            const {
              displayValue: b,
              exportValue: y
            } = m, Z = document.createElement("option");
            Z.textContent = b, Z.value = y, s.append(Z);
          }
          s.options.length > 0 && (s.options[0].selected = !0), t.setValue(e, {
            value: o(!0),
            items: c(h)
          }), l = o(!1);
        },
        indices(h) {
          const p = new Set(h.detail.indices);
          for (const m of h.target.options)
            m.selected = p.has(m.index);
          t.setValue(e, {
            value: o(!0)
          }), l = o(!1);
        },
        editable(h) {
          h.target.disabled = !h.detail.editable;
        }
      };
      this._dispatchEventFromSandbox(d, u);
    }), s.addEventListener("input", (u) => {
      var p;
      const d = o(!0), h = o(!1);
      t.setValue(e, {
        value: d
      }), u.preventDefault(), (p = this.linkService.eventBus) == null || p.dispatch("dispatcheventinsandbox", {
        source: this,
        detail: {
          id: e,
          name: "Keystroke",
          value: l,
          change: h,
          changeEx: d,
          willCommit: !1,
          commitKey: 1,
          keyDown: !1
        }
      });
    }), this._setEventListeners(s, null, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"], ["input", "Action"], ["input", "Validate"]], (u) => u.target.value)) : s.addEventListener("input", function(u) {
      t.setValue(e, {
        value: o(!0)
      });
    }), this.data.combo && this._setTextStyle(s), this._setBackgroundColor(s), this._setDefaultPropertiesFromJS(s), this.container.append(s), this.container;
  }
}
var KZ, rX;
class sX extends rs {
  constructor(e) {
    const {
      data: n,
      elements: s,
      parent: r
    } = e, a = !!r._commentManager;
    super(e, {
      isRenderable: !a && rs._hasPopupData(n)
    });
    pt(this, KZ);
    if (this.elements = s, a && rs._hasPopupData(n)) {
      const o = this.popup = ft(this, KZ, rX).call(this);
      for (const l of s)
        l.popup = o;
    } else
      this.popup = null;
  }
  render() {
    const {
      container: e
    } = this;
    e.classList.add("popupAnnotation"), e.role = "comment";
    const n = this.popup = ft(this, KZ, rX).call(this), s = [];
    for (const r of this.elements)
      r.popup = n, r.container.ariaHasPopup = "dialog", s.push(r.data.id), r.addHighlightArea();
    return this.container.setAttribute("aria-controls", s.map((r) => `${_C}${r}`).join(",")), this.container;
  }
}
KZ = new WeakSet(), rX = function() {
  return new YCt({
    container: this.container,
    color: this.data.color,
    titleObj: this.data.titleObj,
    modificationDate: this.data.modificationDate || this.data.creationDate,
    contentsObj: this.data.contentsObj,
    richText: this.data.richText,
    rect: this.data.rect,
    parentRect: this.data.parentRect || null,
    parent: this.parent,
    elements: this.elements,
    open: this.data.open,
    commentManager: this.parent._commentManager
  });
};
var io, gh, yG, ZG, Of, zf, ds, Gc, yh, Dm, Ef, kf, wc, so, Ou, zu, ar, Eu, Zh, HZ, ku, Ff, Om, Th, qr, Mh, Nn, ON, aX, oX, lX, zN, cX, OK, zK, EK, kK, EN, kN, uX;
class YCt {
  constructor({
    container: t,
    color: e,
    elements: n,
    titleObj: s,
    modificationDate: r,
    contentsObj: a,
    richText: o,
    parent: l,
    rect: c,
    parentRect: u,
    open: d,
    commentManager: h = null
  }) {
    pt(this, Nn);
    pt(this, io, null);
    pt(this, gh, ft(this, Nn, EK).bind(this));
    pt(this, yG, ft(this, Nn, uX).bind(this));
    pt(this, ZG, ft(this, Nn, kN).bind(this));
    pt(this, Of, ft(this, Nn, EN).bind(this));
    pt(this, zf, null);
    pt(this, ds, null);
    pt(this, Gc, null);
    pt(this, yh, null);
    pt(this, Dm, null);
    pt(this, Ef, null);
    pt(this, kf, null);
    pt(this, wc, !1);
    pt(this, so, null);
    pt(this, Ou, null);
    pt(this, zu, null);
    pt(this, ar, null);
    pt(this, Eu, null);
    pt(this, Zh, null);
    pt(this, HZ, null);
    pt(this, ku, null);
    pt(this, Ff, null);
    pt(this, Om, null);
    pt(this, Th, !1);
    pt(this, qr, null);
    pt(this, Mh, null);
    rt(this, ds, t), rt(this, Ff, s), rt(this, Gc, a), rt(this, ku, o), rt(this, Ef, l), rt(this, zf, e), rt(this, HZ, c), rt(this, kf, u), rt(this, Dm, n), rt(this, io, h), rt(this, qr, n[0]), rt(this, yh, JW.toDateObject(r)), this.trigger = n.flatMap((p) => p.getElementsToTriggerPopup()), h ? this.renderCommentButton() : (ft(this, Nn, ON).call(this), w(this, ds).hidden = !0, d && ft(this, Nn, EN).call(this));
  }
  renderCommentButton() {
    if (w(this, ar) || (w(this, Eu) || ft(this, Nn, aX).call(this), !w(this, Eu)))
      return;
    const {
      signal: t
    } = rt(this, Ou, new AbortController()), e = !!w(this, qr).extraPopupElement, n = () => {
      w(this, io).toggleCommentPopup(this, !0, void 0, !e);
    }, s = () => {
      w(this, io).toggleCommentPopup(this, !1, !0, !e);
    }, r = () => {
      w(this, io).toggleCommentPopup(this, !1, !1);
    };
    if (e) {
      rt(this, ar, w(this, qr).container);
      for (const a of this.trigger)
        a.ariaHasPopup = "dialog", a.ariaControls = "commentPopup", a.addEventListener("keydown", w(this, gh), {
          signal: t
        }), a.addEventListener("click", n, {
          signal: t
        }), a.addEventListener("pointerenter", s, {
          signal: t
        }), a.addEventListener("pointerleave", r, {
          signal: t
        }), a.classList.add("popupTriggerArea");
    } else {
      const a = rt(this, ar, document.createElement("button"));
      a.className = "annotationCommentButton";
      const o = w(this, qr).container;
      a.style.zIndex = o.style.zIndex + 1, a.tabIndex = 0, a.ariaHasPopup = "dialog", a.ariaControls = "commentPopup", a.setAttribute("data-l10n-id", "pdfjs-show-comment-button"), ft(this, Nn, lX).call(this), ft(this, Nn, oX).call(this), a.addEventListener("keydown", w(this, gh), {
        signal: t
      }), a.addEventListener("click", n, {
        signal: t
      }), a.addEventListener("pointerenter", s, {
        signal: t
      }), a.addEventListener("pointerleave", r, {
        signal: t
      }), o.after(a);
    }
  }
  get commentButtonColor() {
    const {
      color: t,
      opacity: e
    } = w(this, qr).commentData;
    return t ? w(this, Ef)._commentManager.makeCommentColor(t, e) : null;
  }
  focusCommentButton() {
    setTimeout(() => {
      var t;
      (t = w(this, ar)) == null || t.focus();
    }, 0);
  }
  getData() {
    const {
      richText: t,
      color: e,
      opacity: n,
      creationDate: s,
      modificationDate: r
    } = w(this, qr).commentData;
    return {
      contentsObj: {
        str: this.comment
      },
      richText: t,
      color: e,
      opacity: n,
      creationDate: s,
      modificationDate: r
    };
  }
  get elementBeforePopup() {
    return w(this, ar);
  }
  get comment() {
    return w(this, Mh) || rt(this, Mh, w(this, qr).commentText), w(this, Mh);
  }
  set comment(t) {
    t !== this.comment && (w(this, qr).commentText = rt(this, Mh, t));
  }
  get parentBoundingClientRect() {
    return w(this, qr).layer.getBoundingClientRect();
  }
  setCommentButtonStates({
    selected: t,
    hasPopup: e
  }) {
    w(this, ar) && (w(this, ar).classList.toggle("selected", t), w(this, ar).ariaExpanded = e);
  }
  setSelectedCommentButton(t) {
    w(this, ar).classList.toggle("selected", t);
  }
  get commentPopupPosition() {
    if (w(this, Zh))
      return w(this, Zh);
    const {
      x: t,
      y: e,
      height: n
    } = w(this, ar).getBoundingClientRect(), {
      x: s,
      y: r,
      width: a,
      height: o
    } = w(this, qr).layer.getBoundingClientRect();
    return [(t - s) / a, (e + n - r) / o];
  }
  set commentPopupPosition(t) {
    rt(this, Zh, t);
  }
  hasDefaultPopupPosition() {
    return w(this, Zh) === null;
  }
  get commentButtonPosition() {
    return w(this, Eu);
  }
  get commentButtonWidth() {
    return w(this, ar).getBoundingClientRect().width / this.parentBoundingClientRect.width;
  }
  editComment(t) {
    const [e, n] = w(this, Zh) || this.commentButtonPosition.map((c) => c / 100), s = this.parentBoundingClientRect, {
      x: r,
      y: a,
      width: o,
      height: l
    } = s;
    w(this, io).showDialog(null, this, r + e * o, a + n * l, {
      ...t,
      parentDimensions: s
    });
  }
  render() {
    var n, s;
    if (w(this, so))
      return;
    const t = rt(this, so, document.createElement("div"));
    if (t.className = "popup", w(this, zf)) {
      const r = t.style.outlineColor = ze.makeHexColor(...w(this, zf));
      t.style.backgroundColor = `color-mix(in srgb, ${r} 30%, white)`;
    }
    const e = document.createElement("span");
    if (e.className = "header", (n = w(this, Ff)) != null && n.str) {
      const r = document.createElement("span");
      r.className = "title", e.append(r), {
        dir: r.dir,
        str: r.textContent
      } = w(this, Ff);
    }
    if (t.append(e), w(this, yh)) {
      const r = document.createElement("time");
      r.className = "popupDate", r.setAttribute("data-l10n-id", "pdfjs-annotation-date-time-string"), r.setAttribute("data-l10n-args", JSON.stringify({
        dateObj: w(this, yh).valueOf()
      })), r.dateTime = w(this, yh).toISOString(), e.append(r);
    }
    XB({
      html: w(this, Nn, zN) || w(this, Gc).str,
      dir: (s = w(this, Gc)) == null ? void 0 : s.dir,
      className: "popupContent"
    }, t), w(this, ds).append(t);
  }
  updateEdited({
    rect: t,
    popup: e,
    deleted: n
  }) {
    var s;
    if (w(this, io)) {
      n ? (this.remove(), rt(this, Mh, null)) : e && (e.deleted ? this.remove() : (ft(this, Nn, lX).call(this), rt(this, Mh, e.text))), t && (rt(this, Eu, null), ft(this, Nn, aX).call(this), ft(this, Nn, oX).call(this));
      return;
    }
    if (n || e != null && e.deleted) {
      this.remove();
      return;
    }
    ft(this, Nn, ON).call(this), w(this, Om) || rt(this, Om, {
      contentsObj: w(this, Gc),
      richText: w(this, ku)
    }), t && rt(this, zu, null), e && e.text && (rt(this, ku, ft(this, Nn, zK).call(this, e.text)), rt(this, yh, JW.toDateObject(e.date)), rt(this, Gc, null)), (s = w(this, so)) == null || s.remove(), rt(this, so, null);
  }
  resetEdited() {
    var t;
    w(this, Om) && ({
      contentsObj: Ks(this, Gc)._,
      richText: Ks(this, ku)._
    } = w(this, Om), rt(this, Om, null), (t = w(this, so)) == null || t.remove(), rt(this, so, null), rt(this, zu, null));
  }
  remove() {
    var t, e, n;
    if ((t = w(this, Ou)) == null || t.abort(), rt(this, Ou, null), (e = w(this, so)) == null || e.remove(), rt(this, so, null), rt(this, Th, !1), rt(this, wc, !1), (n = w(this, ar)) == null || n.remove(), rt(this, ar, null), this.trigger)
      for (const s of this.trigger)
        s.classList.remove("popupTriggerArea");
  }
  forceHide() {
    rt(this, Th, this.isVisible), w(this, Th) && (w(this, ds).hidden = !0);
  }
  maybeShow() {
    w(this, io) || (ft(this, Nn, ON).call(this), w(this, Th) && (w(this, so) || ft(this, Nn, kN).call(this), rt(this, Th, !1), w(this, ds).hidden = !1));
  }
  get isVisible() {
    return w(this, io) ? !1 : w(this, ds).hidden === !1;
  }
}
io = new WeakMap(), gh = new WeakMap(), yG = new WeakMap(), ZG = new WeakMap(), Of = new WeakMap(), zf = new WeakMap(), ds = new WeakMap(), Gc = new WeakMap(), yh = new WeakMap(), Dm = new WeakMap(), Ef = new WeakMap(), kf = new WeakMap(), wc = new WeakMap(), so = new WeakMap(), Ou = new WeakMap(), zu = new WeakMap(), ar = new WeakMap(), Eu = new WeakMap(), Zh = new WeakMap(), HZ = new WeakMap(), ku = new WeakMap(), Ff = new WeakMap(), Om = new WeakMap(), Th = new WeakMap(), qr = new WeakMap(), Mh = new WeakMap(), Nn = new WeakSet(), ON = function() {
  var e;
  if (w(this, Ou))
    return;
  rt(this, Ou, new AbortController());
  const {
    signal: t
  } = w(this, Ou);
  for (const n of this.trigger)
    n.addEventListener("click", w(this, Of), {
      signal: t
    }), n.addEventListener("pointerenter", w(this, ZG), {
      signal: t
    }), n.addEventListener("pointerleave", w(this, yG), {
      signal: t
    }), n.classList.add("popupTriggerArea");
  for (const n of w(this, Dm))
    (e = n.container) == null || e.addEventListener("keydown", w(this, gh), {
      signal: t
    });
}, aX = function() {
  const t = w(this, Dm).find((e) => e.hasCommentButton);
  t && rt(this, Eu, t._normalizePoint(t.commentButtonPosition));
}, oX = function() {
  if (w(this, qr).extraPopupElement && !w(this, qr).editor)
    return;
  this.renderCommentButton();
  const [t, e] = w(this, Eu), {
    style: n
  } = w(this, ar);
  n.left = `calc(${t}%)`, n.top = `calc(${e}% - var(--comment-button-dim))`;
}, lX = function() {
  w(this, qr).extraPopupElement || (this.renderCommentButton(), w(this, ar).style.backgroundColor = this.commentButtonColor || "");
}, zN = function() {
  const t = w(this, ku), e = w(this, Gc);
  return t != null && t.str && (!(e != null && e.str) || e.str === t.str) && w(this, ku).html || null;
}, cX = function() {
  var t, e, n;
  return ((n = (e = (t = w(this, Nn, zN)) == null ? void 0 : t.attributes) == null ? void 0 : e.style) == null ? void 0 : n.fontSize) || 0;
}, OK = function() {
  var t, e, n;
  return ((n = (e = (t = w(this, Nn, zN)) == null ? void 0 : t.attributes) == null ? void 0 : e.style) == null ? void 0 : n.color) || null;
}, zK = function(t) {
  const e = [], n = {
    str: t,
    html: {
      name: "div",
      attributes: {
        dir: "auto"
      },
      children: [{
        name: "p",
        children: e
      }]
    }
  }, s = {
    style: {
      color: w(this, Nn, OK),
      fontSize: w(this, Nn, cX) ? `calc(${w(this, Nn, cX)}px * var(--total-scale-factor))` : ""
    }
  };
  for (const r of t.split(`
`))
    e.push({
      name: "span",
      value: r,
      attributes: s
    });
  return n;
}, EK = function(t) {
  t.altKey || t.shiftKey || t.ctrlKey || t.metaKey || (t.key === "Enter" || t.key === "Escape" && w(this, wc)) && ft(this, Nn, EN).call(this);
}, kK = function() {
  if (w(this, zu) !== null)
    return;
  const {
    page: {
      view: t
    },
    viewport: {
      rawDims: {
        pageWidth: e,
        pageHeight: n,
        pageX: s,
        pageY: r
      }
    }
  } = w(this, Ef);
  let a = !!w(this, kf), o = a ? w(this, kf) : w(this, HZ);
  for (const m of w(this, Dm))
    if (!o || ze.intersect(m.data.rect, o) !== null) {
      o = m.data.rect, a = !0;
      break;
    }
  const l = ze.normalizeRect([o[0], t[3] - o[1] + t[1], o[2], t[3] - o[3] + t[1]]), u = a ? o[2] - o[0] + 5 : 0, d = l[0] + u, h = l[1];
  rt(this, zu, [100 * (d - s) / e, 100 * (h - r) / n]);
  const {
    style: p
  } = w(this, ds);
  p.left = `${w(this, zu)[0]}%`, p.top = `${w(this, zu)[1]}%`;
}, EN = function() {
  if (w(this, io)) {
    w(this, io).toggleCommentPopup(this, !1);
    return;
  }
  rt(this, wc, !w(this, wc)), w(this, wc) ? (ft(this, Nn, kN).call(this), w(this, ds).addEventListener("click", w(this, Of)), w(this, ds).addEventListener("keydown", w(this, gh))) : (ft(this, Nn, uX).call(this), w(this, ds).removeEventListener("click", w(this, Of)), w(this, ds).removeEventListener("keydown", w(this, gh)));
}, kN = function() {
  w(this, so) || this.render(), this.isVisible ? w(this, wc) && w(this, ds).classList.add("focused") : (ft(this, Nn, kK).call(this), w(this, ds).hidden = !1, w(this, ds).style.zIndex = parseInt(w(this, ds).style.zIndex) + 1e3);
}, uX = function() {
  w(this, ds).classList.remove("focused"), !(w(this, wc) || !this.isVisible) && (w(this, ds).hidden = !0, w(this, ds).style.zIndex = parseInt(w(this, ds).style.zIndex) - 1e3);
};
class FK extends rs {
  constructor(t) {
    super(t, {
      isRenderable: !0,
      ignoreBorder: !0
    }), this.textContent = t.data.textContent, this.textPosition = t.data.textPosition, this.annotationEditorType = fn.FREETEXT;
  }
  render() {
    if (this.container.classList.add("freeTextAnnotation"), this.textContent) {
      const t = document.createElement("div");
      t.classList.add("annotationTextContent"), t.setAttribute("role", "comment");
      for (const e of this.textContent) {
        const n = document.createElement("span");
        n.textContent = e, t.append(n);
      }
      this.container.append(t);
    }
    return !this.data.popupRef && this.hasPopupData && this._createPopup(), this._editOnDoubleClick(), this.container;
  }
}
var _Z;
class vCt extends rs {
  constructor(e) {
    super(e, {
      isRenderable: !0,
      ignoreBorder: !0
    });
    pt(this, _Z, null);
  }
  render() {
    this.container.classList.add("lineAnnotation");
    const {
      data: e,
      width: n,
      height: s
    } = this, r = this.svgFactory.create(n, s, !0), a = rt(this, _Z, this.svgFactory.createElement("svg:line"));
    return a.setAttribute("x1", e.rect[2] - e.lineCoordinates[0]), a.setAttribute("y1", e.rect[3] - e.lineCoordinates[1]), a.setAttribute("x2", e.rect[2] - e.lineCoordinates[2]), a.setAttribute("y2", e.rect[3] - e.lineCoordinates[3]), a.setAttribute("stroke-width", e.borderStyle.width || 1), a.setAttribute("stroke", "transparent"), a.setAttribute("fill", "transparent"), r.append(a), this.container.append(r), !e.popupRef && this.hasPopupData && this._createPopup(), this.container;
  }
  getElementsToTriggerPopup() {
    return w(this, _Z);
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
_Z = new WeakMap();
var QZ;
class RCt extends rs {
  constructor(e) {
    super(e, {
      isRenderable: !0,
      ignoreBorder: !0
    });
    pt(this, QZ, null);
  }
  render() {
    this.container.classList.add("squareAnnotation");
    const {
      data: e,
      width: n,
      height: s
    } = this, r = this.svgFactory.create(n, s, !0), a = e.borderStyle.width, o = rt(this, QZ, this.svgFactory.createElement("svg:rect"));
    return o.setAttribute("x", a / 2), o.setAttribute("y", a / 2), o.setAttribute("width", n - a), o.setAttribute("height", s - a), o.setAttribute("stroke-width", a || 1), o.setAttribute("stroke", "transparent"), o.setAttribute("fill", "transparent"), r.append(o), this.container.append(r), !e.popupRef && this.hasPopupData && this._createPopup(), this.container;
  }
  getElementsToTriggerPopup() {
    return w(this, QZ);
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
QZ = new WeakMap();
var $Z;
class DCt extends rs {
  constructor(e) {
    super(e, {
      isRenderable: !0,
      ignoreBorder: !0
    });
    pt(this, $Z, null);
  }
  render() {
    this.container.classList.add("circleAnnotation");
    const {
      data: e,
      width: n,
      height: s
    } = this, r = this.svgFactory.create(n, s, !0), a = e.borderStyle.width, o = rt(this, $Z, this.svgFactory.createElement("svg:ellipse"));
    return o.setAttribute("cx", n / 2), o.setAttribute("cy", s / 2), o.setAttribute("rx", n / 2 - a / 2), o.setAttribute("ry", s / 2 - a / 2), o.setAttribute("stroke-width", a || 1), o.setAttribute("stroke", "transparent"), o.setAttribute("fill", "transparent"), r.append(o), this.container.append(r), !e.popupRef && this.hasPopupData && this._createPopup(), this.container;
  }
  getElementsToTriggerPopup() {
    return w(this, $Z);
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
$Z = new WeakMap();
var qZ;
class jK extends rs {
  constructor(e) {
    super(e, {
      isRenderable: !0,
      ignoreBorder: !0
    });
    pt(this, qZ, null);
    this.containerClassName = "polylineAnnotation", this.svgElementName = "svg:polyline";
  }
  render() {
    this.container.classList.add(this.containerClassName);
    const {
      data: {
        rect: e,
        vertices: n,
        borderStyle: s,
        popupRef: r
      },
      width: a,
      height: o
    } = this;
    if (!n)
      return this.container;
    const l = this.svgFactory.create(a, o, !0);
    let c = [];
    for (let d = 0, h = n.length; d < h; d += 2) {
      const p = n[d] - e[0], m = e[3] - n[d + 1];
      c.push(`${p},${m}`);
    }
    c = c.join(" ");
    const u = rt(this, qZ, this.svgFactory.createElement(this.svgElementName));
    return u.setAttribute("points", c), u.setAttribute("stroke-width", s.width || 1), u.setAttribute("stroke", "transparent"), u.setAttribute("fill", "transparent"), l.append(u), this.container.append(l), !r && this.hasPopupData && this._createPopup(), this.container;
  }
  getElementsToTriggerPopup() {
    return w(this, qZ);
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
qZ = new WeakMap();
class OCt extends jK {
  constructor(t) {
    super(t), this.containerClassName = "polygonAnnotation", this.svgElementName = "svg:polygon";
  }
}
class zCt extends rs {
  constructor(t) {
    super(t, {
      isRenderable: !0,
      ignoreBorder: !0
    });
  }
  render() {
    return this.container.classList.add("caretAnnotation"), !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container;
  }
}
var tT, zm, eT, dX;
class sY extends rs {
  constructor(e) {
    super(e, {
      isRenderable: !0,
      ignoreBorder: !0
    });
    pt(this, eT);
    pt(this, tT, null);
    pt(this, zm, []);
    this.containerClassName = "inkAnnotation", this.svgElementName = "svg:polyline", this.annotationEditorType = this.data.it === "InkHighlight" ? fn.HIGHLIGHT : fn.INK;
  }
  render() {
    this.container.classList.add(this.containerClassName);
    const {
      data: {
        rect: e,
        rotation: n,
        inkLists: s,
        borderStyle: r,
        popupRef: a
      }
    } = this, {
      transform: o,
      width: l,
      height: c
    } = ft(this, eT, dX).call(this, n, e), u = this.svgFactory.create(l, c, !0), d = rt(this, tT, this.svgFactory.createElement("svg:g"));
    u.append(d), d.setAttribute("stroke-width", r.width || 1), d.setAttribute("stroke-linecap", "round"), d.setAttribute("stroke-linejoin", "round"), d.setAttribute("stroke-miterlimit", 10), d.setAttribute("stroke", "transparent"), d.setAttribute("fill", "transparent"), d.setAttribute("transform", o);
    for (let h = 0, p = s.length; h < p; h++) {
      const m = this.svgFactory.createElement(this.svgElementName);
      w(this, zm).push(m), m.setAttribute("points", s[h].join(",")), d.append(m);
    }
    return !a && this.hasPopupData && this._createPopup(), this.container.append(u), this._editOnDoubleClick(), this.container;
  }
  updateEdited(e) {
    super.updateEdited(e);
    const {
      thickness: n,
      points: s,
      rect: r
    } = e, a = w(this, tT);
    if (n >= 0 && a.setAttribute("stroke-width", n || 1), s)
      for (let o = 0, l = w(this, zm).length; o < l; o++)
        w(this, zm)[o].setAttribute("points", s[o].join(","));
    if (r) {
      const {
        transform: o,
        width: l,
        height: c
      } = ft(this, eT, dX).call(this, this.data.rotation, r);
      a.parentElement.setAttribute("viewBox", `0 0 ${l} ${c}`), a.setAttribute("transform", o);
    }
  }
  getElementsToTriggerPopup() {
    return w(this, zm);
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
tT = new WeakMap(), zm = new WeakMap(), eT = new WeakSet(), dX = function(e, n) {
  switch (e) {
    case 90:
      return {
        transform: `rotate(90) translate(${-n[0]},${n[1]}) scale(1,-1)`,
        width: n[3] - n[1],
        height: n[2] - n[0]
      };
    case 180:
      return {
        transform: `rotate(180) translate(${-n[2]},${n[1]}) scale(1,-1)`,
        width: n[2] - n[0],
        height: n[3] - n[1]
      };
    case 270:
      return {
        transform: `rotate(270) translate(${-n[2]},${n[3]}) scale(1,-1)`,
        width: n[3] - n[1],
        height: n[2] - n[0]
      };
    default:
      return {
        transform: `translate(${-n[0]},${n[3]}) scale(1,-1)`,
        width: n[2] - n[0],
        height: n[3] - n[1]
      };
  }
};
class UK extends rs {
  constructor(t) {
    super(t, {
      isRenderable: !0,
      ignoreBorder: !0,
      createQuadrilaterals: !0
    }), this.annotationEditorType = fn.HIGHLIGHT;
  }
  render() {
    const {
      data: {
        overlaidText: t,
        popupRef: e
      }
    } = this;
    if (!e && this.hasPopupData && this._createPopup(), this.container.classList.add("highlightAnnotation"), this._editOnDoubleClick(), t) {
      const n = document.createElement("mark");
      n.classList.add("overlaidText"), n.textContent = t, this.container.append(n);
    }
    return this.container;
  }
}
class ECt extends rs {
  constructor(t) {
    super(t, {
      isRenderable: !0,
      ignoreBorder: !0,
      createQuadrilaterals: !0
    });
  }
  render() {
    const {
      data: {
        overlaidText: t,
        popupRef: e
      }
    } = this;
    if (!e && this.hasPopupData && this._createPopup(), this.container.classList.add("underlineAnnotation"), t) {
      const n = document.createElement("u");
      n.classList.add("overlaidText"), n.textContent = t, this.container.append(n);
    }
    return this.container;
  }
}
class kCt extends rs {
  constructor(t) {
    super(t, {
      isRenderable: !0,
      ignoreBorder: !0,
      createQuadrilaterals: !0
    });
  }
  render() {
    const {
      data: {
        overlaidText: t,
        popupRef: e
      }
    } = this;
    if (!e && this.hasPopupData && this._createPopup(), this.container.classList.add("squigglyAnnotation"), t) {
      const n = document.createElement("u");
      n.classList.add("overlaidText"), n.textContent = t, this.container.append(n);
    }
    return this.container;
  }
}
class FCt extends rs {
  constructor(t) {
    super(t, {
      isRenderable: !0,
      ignoreBorder: !0,
      createQuadrilaterals: !0
    });
  }
  render() {
    const {
      data: {
        overlaidText: t,
        popupRef: e
      }
    } = this;
    if (!e && this.hasPopupData && this._createPopup(), this.container.classList.add("strikeoutAnnotation"), t) {
      const n = document.createElement("s");
      n.classList.add("overlaidText"), n.textContent = t, this.container.append(n);
    }
    return this.container;
  }
}
class PK extends rs {
  constructor(t) {
    super(t, {
      isRenderable: !0,
      ignoreBorder: !0
    }), this.annotationEditorType = fn.STAMP;
  }
  render() {
    return this.container.classList.add("stampAnnotation"), this.container.setAttribute("role", "img"), !this.data.popupRef && this.hasPopupData && this._createPopup(), this._editOnDoubleClick(), this.container;
  }
}
var nT, iT, hX;
class jCt extends rs {
  constructor(e) {
    var s;
    super(e, {
      isRenderable: !0
    });
    pt(this, iT);
    pt(this, nT, null);
    const {
      file: n
    } = this.data;
    this.filename = n.filename, this.content = n.content, (s = this.linkService.eventBus) == null || s.dispatch("fileattachmentannotation", {
      source: this,
      ...n
    });
  }
  render() {
    this.container.classList.add("fileAttachmentAnnotation");
    const {
      container: e,
      data: n
    } = this;
    let s;
    n.hasAppearance || n.fillAlpha === 0 ? s = document.createElement("div") : (s = document.createElement("img"), s.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(n.name) ? "paperclip" : "pushpin"}.svg`, n.fillAlpha && n.fillAlpha < 1 && (s.style = `filter: opacity(${Math.round(n.fillAlpha * 100)}%);`)), s.addEventListener("dblclick", ft(this, iT, hX).bind(this)), rt(this, nT, s);
    const {
      isMac: r
    } = Er.platform;
    return e.addEventListener("keydown", (a) => {
      a.key === "Enter" && (r ? a.metaKey : a.ctrlKey) && ft(this, iT, hX).call(this);
    }), !n.popupRef && this.hasPopupData ? this._createPopup() : s.classList.add("popupTriggerArea"), e.append(s), e;
  }
  getElementsToTriggerPopup() {
    return w(this, nT);
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
nT = new WeakMap(), iT = new WeakSet(), hX = function() {
  var e;
  (e = this.downloadManager) == null || e.openOrDownloadData(this.content, this.filename);
};
var jf, Em, Uf, Nh, sT, km, ep, pX, mX;
const bY = class bY {
  constructor({
    div: t,
    accessibilityManager: e,
    annotationCanvasMap: n,
    annotationEditorUIManager: s,
    page: r,
    viewport: a,
    structTreeLayer: o,
    commentManager: l,
    linkService: c,
    annotationStorage: u
  }) {
    pt(this, ep);
    pt(this, jf, null);
    pt(this, Em, null);
    pt(this, Uf, null);
    pt(this, Nh, /* @__PURE__ */ new Map());
    pt(this, sT, null);
    pt(this, km, null);
    this.div = t, rt(this, jf, e), rt(this, Em, n), rt(this, sT, o || null), rt(this, km, c || null), rt(this, Uf, u || new tY()), this.page = r, this.viewport = a, this.zIndex = 0, this._annotationEditorUIManager = s, this._commentManager = l || null;
  }
  hasEditableAnnotations() {
    return w(this, Nh).size > 0;
  }
  async render(t) {
    var a, o, l;
    const {
      annotations: e
    } = t, n = this.div;
    W0(n, this.viewport);
    const s = /* @__PURE__ */ new Map(), r = {
      data: null,
      layer: n,
      linkService: w(this, km),
      downloadManager: t.downloadManager,
      imageResourcesPath: t.imageResourcesPath || "",
      renderForms: t.renderForms !== !1,
      svgFactory: new qW(),
      annotationStorage: w(this, Uf),
      enableComment: t.enableComment === !0,
      enableScripting: t.enableScripting === !0,
      hasJSActions: t.hasJSActions,
      fieldObjects: t.fieldObjects,
      parent: this,
      elements: null
    };
    for (const c of e) {
      if (c.noHTML)
        continue;
      const u = c.annotationType === Rs.POPUP;
      if (u) {
        const p = s.get(c.id);
        if (!p)
          continue;
        r.elements = p;
      } else if (c.rect[2] === c.rect[0] || c.rect[3] === c.rect[1])
        continue;
      r.data = c;
      const d = JE.create(r);
      if (!d.isRenderable)
        continue;
      if (!u && c.popupRef) {
        const p = s.get(c.popupRef);
        p ? p.push(d) : s.set(c.popupRef, [d]);
      }
      const h = d.render();
      c.hidden && (h.style.visibility = "hidden"), await ft(this, ep, pX).call(this, h, c.id, r.elements), (o = (a = d.extraPopupElement) == null ? void 0 : a.popup) == null || o.renderCommentButton(), d._isEditable && (w(this, Nh).set(d.data.id, d), (l = this._annotationEditorUIManager) == null || l.renderAnnotationElement(d));
    }
    ft(this, ep, mX).call(this);
  }
  async addLinkAnnotations(t) {
    const e = {
      data: null,
      layer: this.div,
      linkService: w(this, km),
      svgFactory: new qW(),
      parent: this
    };
    for (const n of t) {
      n.borderStyle || (n.borderStyle = bY._defaultBorderStyle), e.data = n;
      const s = JE.create(e);
      if (!s.isRenderable)
        continue;
      const r = s.render();
      await ft(this, ep, pX).call(this, r, n.id, null);
    }
  }
  update({
    viewport: t
  }) {
    const e = this.div;
    this.viewport = t, W0(e, {
      rotation: t.rotation
    }), ft(this, ep, mX).call(this), e.hidden = !1;
  }
  getEditableAnnotations() {
    return Array.from(w(this, Nh).values());
  }
  getEditableAnnotation(t) {
    return w(this, Nh).get(t);
  }
  addFakeAnnotation(t) {
    var o;
    const {
      div: e
    } = this, {
      id: n,
      rotation: s
    } = t, r = new xCt({
      data: {
        id: n,
        rect: t.getPDFRect(),
        rotation: s
      },
      editor: t,
      layer: e,
      parent: this,
      enableComment: !!this._commentManager,
      linkService: w(this, km),
      annotationStorage: w(this, Uf)
    }), a = r.render();
    return e.append(a), (o = w(this, jf)) == null || o.moveElementInDOM(e, a, a, !1), r.createOrUpdatePopup(), r;
  }
  static get _defaultBorderStyle() {
    return Gn(this, "_defaultBorderStyle", Object.freeze({
      width: 1,
      rawWidth: 1,
      style: cb.SOLID,
      dashArray: [3],
      horizontalCornerRadius: 0,
      verticalCornerRadius: 0
    }));
  }
};
jf = new WeakMap(), Em = new WeakMap(), Uf = new WeakMap(), Nh = new WeakMap(), sT = new WeakMap(), km = new WeakMap(), ep = new WeakSet(), pX = async function(t, e, n) {
  var o, l;
  const s = t.firstChild || t, r = s.id = `${_C}${e}`, a = await ((o = w(this, sT)) == null ? void 0 : o.getAriaAttributes(r));
  if (a)
    for (const [c, u] of a)
      s.setAttribute(c, u);
  n ? n.at(-1).container.after(t) : (this.div.append(t), (l = w(this, jf)) == null || l.moveElementInDOM(this.div, t, s, !1));
}, mX = function() {
  var e;
  if (!w(this, Em))
    return;
  const t = this.div;
  for (const [n, s] of w(this, Em)) {
    const r = t.querySelector(`[data-annotation-id="${n}"]`);
    if (!r)
      continue;
    s.className = "annotationContent";
    const {
      firstChild: a
    } = r;
    a ? a.nodeName === "CANVAS" ? a.replaceWith(s) : a.classList.contains("annotationContent") ? a.after(s) : a.before(s) : r.append(s);
    const o = w(this, Nh).get(n);
    o && (o._hasNoCanvas ? ((e = this._annotationEditorUIManager) == null || e.setMissingCanvas(n, r.id, s), o._hasNoCanvas = !1) : o.canvas = s);
  }
  w(this, Em).clear();
};
let tG = bY;
const PM = /\r\n?|\n/g;
var ro, rT, Fm, ao, js, JK, AK, BK, FN, rd, jN, UN, KK, fX, HK;
const Oi = class Oi extends Di {
  constructor(e) {
    super({
      ...e,
      name: "freeTextEditor"
    });
    pt(this, js);
    pt(this, ro, "");
    pt(this, rT, `${this.id}-editor`);
    pt(this, Fm, null);
    pt(this, ao);
    S(this, "_colorPicker", null);
    this.color = e.color || Oi._defaultColor || Di._defaultLineColor, rt(this, ao, e.fontSize || Oi._defaultFontSize), this.annotationElementId || this._uiManager.a11yAlert("pdfjs-editor-freetext-added-alert");
  }
  static get _keyboardManager() {
    const e = Oi.prototype, n = (a) => a.isEmpty(), s = G0.TRANSLATE_SMALL, r = G0.TRANSLATE_BIG;
    return Gn(this, "_keyboardManager", new $T([[["ctrl+s", "mac+meta+s", "ctrl+p", "mac+meta+p"], e.commitOrRemove, {
      bubbles: !0
    }], [["ctrl+Enter", "mac+meta+Enter", "Escape", "mac+Escape"], e.commitOrRemove], [["ArrowLeft", "mac+ArrowLeft"], e._translateEmpty, {
      args: [-s, 0],
      checker: n
    }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], e._translateEmpty, {
      args: [-r, 0],
      checker: n
    }], [["ArrowRight", "mac+ArrowRight"], e._translateEmpty, {
      args: [s, 0],
      checker: n
    }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], e._translateEmpty, {
      args: [r, 0],
      checker: n
    }], [["ArrowUp", "mac+ArrowUp"], e._translateEmpty, {
      args: [0, -s],
      checker: n
    }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], e._translateEmpty, {
      args: [0, -r],
      checker: n
    }], [["ArrowDown", "mac+ArrowDown"], e._translateEmpty, {
      args: [0, s],
      checker: n
    }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], e._translateEmpty, {
      args: [0, r],
      checker: n
    }]]));
  }
  static initialize(e, n) {
    Di.initialize(e, n);
    const s = getComputedStyle(document.documentElement);
    this._internalPadding = parseFloat(s.getPropertyValue("--freetext-padding"));
  }
  static updateDefaultParams(e, n) {
    switch (e) {
      case Un.FREETEXT_SIZE:
        Oi._defaultFontSize = n;
        break;
      case Un.FREETEXT_COLOR:
        Oi._defaultColor = n;
        break;
    }
  }
  updateParams(e, n) {
    switch (e) {
      case Un.FREETEXT_SIZE:
        ft(this, js, JK).call(this, n);
        break;
      case Un.FREETEXT_COLOR:
        ft(this, js, AK).call(this, n);
        break;
    }
  }
  static get defaultPropertiesToUpdate() {
    return [[Un.FREETEXT_SIZE, Oi._defaultFontSize], [Un.FREETEXT_COLOR, Oi._defaultColor || Di._defaultLineColor]];
  }
  get propertiesToUpdate() {
    return [[Un.FREETEXT_SIZE, w(this, ao)], [Un.FREETEXT_COLOR, this.color]];
  }
  get toolbarButtons() {
    return this._colorPicker || (this._colorPicker = new $W(this)), [["colorPicker", this._colorPicker]];
  }
  get colorType() {
    return Un.FREETEXT_COLOR;
  }
  onUpdatedColor() {
    var e;
    this.editorDiv.style.color = this.color, (e = this._colorPicker) == null || e.update(this.color), super.onUpdatedColor();
  }
  _translateEmpty(e, n) {
    this._uiManager.translateSelectedEditors(e, n, !0);
  }
  getInitialTranslation() {
    const e = this.parentScale;
    return [-Oi._internalPadding * e, -(Oi._internalPadding + w(this, ao)) * e];
  }
  rebuild() {
    this.parent && (super.rebuild(), this.div !== null && (this.isAttachedToDOM || this.parent.add(this)));
  }
  enableEditMode() {
    if (!super.enableEditMode())
      return !1;
    this.overlayDiv.classList.remove("enabled"), this.editorDiv.contentEditable = !0, this._isDraggable = !1, this.div.removeAttribute("aria-activedescendant"), rt(this, Fm, new AbortController());
    const e = this._uiManager.combinedSignal(w(this, Fm));
    return this.editorDiv.addEventListener("keydown", this.editorDivKeydown.bind(this), {
      signal: e
    }), this.editorDiv.addEventListener("focus", this.editorDivFocus.bind(this), {
      signal: e
    }), this.editorDiv.addEventListener("blur", this.editorDivBlur.bind(this), {
      signal: e
    }), this.editorDiv.addEventListener("input", this.editorDivInput.bind(this), {
      signal: e
    }), this.editorDiv.addEventListener("paste", this.editorDivPaste.bind(this), {
      signal: e
    }), !0;
  }
  disableEditMode() {
    var e;
    return super.disableEditMode() ? (this.overlayDiv.classList.add("enabled"), this.editorDiv.contentEditable = !1, this.div.setAttribute("aria-activedescendant", w(this, rT)), this._isDraggable = !0, (e = w(this, Fm)) == null || e.abort(), rt(this, Fm, null), this.div.focus({
      preventScroll: !0
    }), this.isEditing = !1, this.parent.div.classList.add("freetextEditing"), !0) : !1;
  }
  focusin(e) {
    this._focusEventsAllowed && (super.focusin(e), e.target !== this.editorDiv && this.editorDiv.focus());
  }
  onceAdded(e) {
    var n;
    this.width || (this.enableEditMode(), e && this.editorDiv.focus(), (n = this._initialOptions) != null && n.isCentered && this.center(), this._initialOptions = null);
  }
  isEmpty() {
    return !this.editorDiv || this.editorDiv.innerText.trim() === "";
  }
  remove() {
    this.isEditing = !1, this.parent && (this.parent.setEditingState(!0), this.parent.div.classList.add("freetextEditing")), super.remove();
  }
  commit() {
    if (!this.isInEditMode())
      return;
    super.commit(), this.disableEditMode();
    const e = w(this, ro), n = rt(this, ro, ft(this, js, BK).call(this).trimEnd());
    if (e === n)
      return;
    const s = (r) => {
      if (rt(this, ro, r), !r) {
        this.remove();
        return;
      }
      ft(this, js, UN).call(this), this._uiManager.rebuild(this), ft(this, js, FN).call(this);
    };
    this.addCommands({
      cmd: () => {
        s(n);
      },
      undo: () => {
        s(e);
      },
      mustExec: !1
    }), ft(this, js, FN).call(this);
  }
  shouldGetKeyboardEvents() {
    return this.isInEditMode();
  }
  enterInEditMode() {
    this.enableEditMode(), this.editorDiv.focus();
  }
  keydown(e) {
    e.target === this.div && e.key === "Enter" && (this.enterInEditMode(), e.preventDefault());
  }
  editorDivKeydown(e) {
    Oi._keyboardManager.exec(this, e);
  }
  editorDivFocus(e) {
    this.isEditing = !0;
  }
  editorDivBlur(e) {
    this.isEditing = !1;
  }
  editorDivInput(e) {
    this.parent.div.classList.toggle("freetextEditing", this.isEmpty());
  }
  disableEditing() {
    this.editorDiv.setAttribute("role", "comment"), this.editorDiv.removeAttribute("aria-multiline");
  }
  enableEditing() {
    this.editorDiv.setAttribute("role", "textbox"), this.editorDiv.setAttribute("aria-multiline", !0);
  }
  get canChangeContent() {
    return !0;
  }
  render() {
    if (this.div)
      return this.div;
    let e, n;
    (this._isCopy || this.annotationElementId) && (e = this.x, n = this.y), super.render(), this.editorDiv = document.createElement("div"), this.editorDiv.className = "internal", this.editorDiv.setAttribute("id", w(this, rT)), this.editorDiv.setAttribute("data-l10n-id", "pdfjs-free-text2"), this.editorDiv.setAttribute("data-l10n-attrs", "default-content"), this.enableEditing(), this.editorDiv.contentEditable = !0;
    const {
      style: s
    } = this.editorDiv;
    if (s.fontSize = `calc(${w(this, ao)}px * var(--total-scale-factor))`, s.color = this.color, this.div.append(this.editorDiv), this.overlayDiv = document.createElement("div"), this.overlayDiv.classList.add("overlay", "enabled"), this.div.append(this.overlayDiv), this._isCopy || this.annotationElementId) {
      const [r, a] = this.parentDimensions;
      if (this.annotationElementId) {
        const {
          position: o
        } = this._initialData;
        let [l, c] = this.getInitialTranslation();
        [l, c] = this.pageTranslationToScreen(l, c);
        const [u, d] = this.pageDimensions, [h, p] = this.pageTranslation;
        let m, b;
        switch (this.rotation) {
          case 0:
            m = e + (o[0] - h) / u, b = n + this.height - (o[1] - p) / d;
            break;
          case 90:
            m = e + (o[0] - h) / u, b = n - (o[1] - p) / d, [l, c] = [c, -l];
            break;
          case 180:
            m = e - this.width + (o[0] - h) / u, b = n - (o[1] - p) / d, [l, c] = [-l, -c];
            break;
          case 270:
            m = e + (o[0] - h - this.height * d) / u, b = n + (o[1] - p - this.width * u) / d, [l, c] = [-c, l];
            break;
        }
        this.setAt(m * r, b * a, l, c);
      } else
        this._moveAfterPaste(e, n);
      ft(this, js, UN).call(this), this._isDraggable = !0, this.editorDiv.contentEditable = !1;
    } else
      this._isDraggable = !1, this.editorDiv.contentEditable = !0;
    return this.div;
  }
  editorDivPaste(e) {
    var m, b, y;
    const n = e.clipboardData || window.clipboardData, {
      types: s
    } = n;
    if (s.length === 1 && s[0] === "text/plain")
      return;
    e.preventDefault();
    const r = ft(m = Oi, rd, fX).call(m, n.getData("text") || "").replaceAll(PM, `
`);
    if (!r)
      return;
    const a = window.getSelection();
    if (!a.rangeCount)
      return;
    this.editorDiv.normalize(), a.deleteFromDocument();
    const o = a.getRangeAt(0);
    if (!r.includes(`
`)) {
      o.insertNode(document.createTextNode(r)), this.editorDiv.normalize(), a.collapseToStart();
      return;
    }
    const {
      startContainer: l,
      startOffset: c
    } = o, u = [], d = [];
    if (l.nodeType === Node.TEXT_NODE) {
      const Z = l.parentElement;
      if (d.push(l.nodeValue.slice(c).replaceAll(PM, "")), Z !== this.editorDiv) {
        let g = u;
        for (const f of this.editorDiv.childNodes) {
          if (f === Z) {
            g = d;
            continue;
          }
          g.push(ft(b = Oi, rd, jN).call(b, f));
        }
      }
      u.push(l.nodeValue.slice(0, c).replaceAll(PM, ""));
    } else if (l === this.editorDiv) {
      let Z = u, g = 0;
      for (const f of this.editorDiv.childNodes)
        g++ === c && (Z = d), Z.push(ft(y = Oi, rd, jN).call(y, f));
    }
    rt(this, ro, `${u.join(`
`)}${r}${d.join(`
`)}`), ft(this, js, UN).call(this);
    const h = new Range();
    let p = Math.sumPrecise(u.map((Z) => Z.length));
    for (const {
      firstChild: Z
    } of this.editorDiv.childNodes)
      if (Z.nodeType === Node.TEXT_NODE) {
        const g = Z.nodeValue.length;
        if (p <= g) {
          h.setStart(Z, p), h.setEnd(Z, p);
          break;
        }
        p -= g;
      }
    a.removeAllRanges(), a.addRange(h);
  }
  get contentDiv() {
    return this.editorDiv;
  }
  getPDFRect() {
    const e = Oi._internalPadding * this.parentScale;
    return this.getRect(e, e);
  }
  static async deserialize(e, n, s) {
    var o;
    let r = null;
    if (e instanceof FK) {
      const {
        data: {
          defaultAppearanceData: {
            fontSize: l,
            fontColor: c
          },
          rect: u,
          rotation: d,
          id: h,
          popupRef: p,
          richText: m,
          contentsObj: b,
          creationDate: y,
          modificationDate: Z
        },
        textContent: g,
        textPosition: f,
        parent: {
          page: {
            pageNumber: T
          }
        }
      } = e;
      if (!g || g.length === 0)
        return null;
      r = e = {
        annotationType: fn.FREETEXT,
        color: Array.from(c),
        fontSize: l,
        value: g.join(`
`),
        position: f,
        pageIndex: T - 1,
        rect: u.slice(0),
        rotation: d,
        annotationElementId: h,
        id: h,
        deleted: !1,
        popupRef: p,
        comment: (b == null ? void 0 : b.str) || null,
        richText: m,
        creationDate: y,
        modificationDate: Z
      };
    }
    const a = await super.deserialize(e, n, s);
    return rt(a, ao, e.fontSize), a.color = ze.makeHexColor(...e.color), rt(a, ro, ft(o = Oi, rd, fX).call(o, e.value)), a._initialData = r, e.comment && a.setCommentData(e), a;
  }
  serialize(e = !1) {
    if (this.isEmpty())
      return null;
    if (this.deleted)
      return this.serializeDeleted();
    const n = Di._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : this.color), s = Object.assign(super.serialize(e), {
      color: n,
      fontSize: w(this, ao),
      value: ft(this, js, KK).call(this)
    });
    return this.addComment(s), e ? (s.isCopy = !0, s) : this.annotationElementId && !ft(this, js, HK).call(this, s) ? null : (s.id = this.annotationElementId, s);
  }
  renderAnnotationElement(e) {
    const n = super.renderAnnotationElement(e);
    if (!n)
      return null;
    const {
      style: s
    } = n;
    s.fontSize = `calc(${w(this, ao)}px * var(--total-scale-factor))`, s.color = this.color, n.replaceChildren();
    for (const r of w(this, ro).split(`
`)) {
      const a = document.createElement("div");
      a.append(r ? document.createTextNode(r) : document.createElement("br")), n.append(a);
    }
    return e.updateEdited({
      rect: this.getPDFRect(),
      popup: this._uiManager.hasCommentManager() || this.hasEditedComment ? this.comment : {
        text: w(this, ro)
      }
    }), n;
  }
  resetAnnotationElement(e) {
    super.resetAnnotationElement(e), e.resetEdited();
  }
};
ro = new WeakMap(), rT = new WeakMap(), Fm = new WeakMap(), ao = new WeakMap(), js = new WeakSet(), JK = function(e) {
  const n = (r) => {
    this.editorDiv.style.fontSize = `calc(${r}px * var(--total-scale-factor))`, this.translate(0, -(r - w(this, ao)) * this.parentScale), rt(this, ao, r), ft(this, js, FN).call(this);
  }, s = w(this, ao);
  this.addCommands({
    cmd: n.bind(this, e),
    undo: n.bind(this, s),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: !0,
    type: Un.FREETEXT_SIZE,
    overwriteIfSameType: !0,
    keepUndo: !0
  });
}, AK = function(e) {
  const n = (r) => {
    this.color = r, this.onUpdatedColor();
  }, s = this.color;
  this.addCommands({
    cmd: n.bind(this, e),
    undo: n.bind(this, s),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: !0,
    type: Un.FREETEXT_COLOR,
    overwriteIfSameType: !0,
    keepUndo: !0
  });
}, BK = function() {
  var s;
  const e = [];
  this.editorDiv.normalize();
  let n = null;
  for (const r of this.editorDiv.childNodes)
    (n == null ? void 0 : n.nodeType) === Node.TEXT_NODE && r.nodeName === "BR" || (e.push(ft(s = Oi, rd, jN).call(s, r)), n = r);
  return e.join(`
`);
}, FN = function() {
  const [e, n] = this.parentDimensions;
  let s;
  if (this.isAttachedToDOM)
    s = this.div.getBoundingClientRect();
  else {
    const {
      currentLayer: r,
      div: a
    } = this, o = a.style.display, l = a.classList.contains("hidden");
    a.classList.remove("hidden"), a.style.display = "hidden", r.div.append(this.div), s = a.getBoundingClientRect(), a.remove(), a.style.display = o, a.classList.toggle("hidden", l);
  }
  this.rotation % 180 === this.parentRotation % 180 ? (this.width = s.width / e, this.height = s.height / n) : (this.width = s.height / e, this.height = s.width / n), this.fixAndSetPosition();
}, rd = new WeakSet(), jN = function(e) {
  return (e.nodeType === Node.TEXT_NODE ? e.nodeValue : e.innerText).replaceAll(PM, "");
}, UN = function() {
  if (this.editorDiv.replaceChildren(), !!w(this, ro))
    for (const e of w(this, ro).split(`
`)) {
      const n = document.createElement("div");
      n.append(e ? document.createTextNode(e) : document.createElement("br")), this.editorDiv.append(n);
    }
}, KK = function() {
  return w(this, ro).replaceAll(" ", " ");
}, fX = function(e) {
  return e.replaceAll(" ", " ");
}, HK = function(e) {
  const {
    value: n,
    fontSize: s,
    color: r,
    pageIndex: a
  } = this._initialData;
  return this.hasEditedComment || this._hasBeenMoved || e.value !== n || e.fontSize !== s || e.color.some((o, l) => o !== r[l]) || e.pageIndex !== a;
}, pt(Oi, rd), S(Oi, "_freeTextDefaultContent", ""), S(Oi, "_internalPadding", 0), S(Oi, "_defaultColor", null), S(Oi, "_defaultFontSize", 10), S(Oi, "_type", "freetext"), S(Oi, "_editorType", fn.FREETEXT);
let bX = Oi;
class De {
  toSVGPath() {
    Xi("Abstract method `toSVGPath` must be implemented.");
  }
  get box() {
    Xi("Abstract getter `box` must be implemented.");
  }
  serialize(t, e) {
    Xi("Abstract method `serialize` must be implemented.");
  }
  static _rescale(t, e, n, s, r, a) {
    a || (a = new Float32Array(t.length));
    for (let o = 0, l = t.length; o < l; o += 2)
      a[o] = e + t[o] * s, a[o + 1] = n + t[o + 1] * r;
    return a;
  }
  static _rescaleAndSwap(t, e, n, s, r, a) {
    a || (a = new Float32Array(t.length));
    for (let o = 0, l = t.length; o < l; o += 2)
      a[o] = e + t[o + 1] * s, a[o + 1] = n + t[o] * r;
    return a;
  }
  static _translate(t, e, n, s) {
    s || (s = new Float32Array(t.length));
    for (let r = 0, a = t.length; r < a; r += 2)
      s[r] = e + t[r], s[r + 1] = n + t[r + 1];
    return s;
  }
  static svgRound(t) {
    return Math.round(t * 1e4);
  }
  static _normalizePoint(t, e, n, s, r) {
    switch (r) {
      case 90:
        return [1 - e / n, t / s];
      case 180:
        return [1 - t / n, 1 - e / s];
      case 270:
        return [e / n, 1 - t / s];
      default:
        return [t / n, e / s];
    }
  }
  static _normalizePagePoint(t, e, n) {
    switch (n) {
      case 90:
        return [1 - e, t];
      case 180:
        return [1 - t, 1 - e];
      case 270:
        return [e, 1 - t];
      default:
        return [t, e];
    }
  }
  static createBezierPoints(t, e, n, s, r, a) {
    return [(t + 5 * n) / 6, (e + 5 * s) / 6, (5 * n + r) / 6, (5 * s + a) / 6, (n + r) / 2, (s + a) / 2];
  }
}
S(De, "PRECISION", 1e-4);
var oo, wl, Pf, Jf, xc, Ln, jm, Um, aT, oT, Af, Bf, Wh, lT, TG, MG, er, Ay, _K, QK, $K, qK, t4, e4;
const uu = class uu {
  constructor({
    x: t,
    y: e
  }, n, s, r, a, o = 0) {
    pt(this, er);
    pt(this, oo);
    pt(this, wl, []);
    pt(this, Pf);
    pt(this, Jf);
    pt(this, xc, []);
    pt(this, Ln, new Float32Array(18));
    pt(this, jm);
    pt(this, Um);
    pt(this, aT);
    pt(this, oT);
    pt(this, Af);
    pt(this, Bf);
    pt(this, Wh, []);
    rt(this, oo, n), rt(this, Bf, r * s), rt(this, Jf, a), w(this, Ln).set([NaN, NaN, NaN, NaN, t, e], 6), rt(this, Pf, o), rt(this, oT, w(uu, lT) * s), rt(this, aT, w(uu, MG) * s), rt(this, Af, s), w(this, Wh).push(t, e);
  }
  isEmpty() {
    return isNaN(w(this, Ln)[8]);
  }
  add({
    x: t,
    y: e
  }) {
    var V;
    rt(this, jm, t), rt(this, Um, e);
    const [n, s, r, a] = w(this, oo);
    let [o, l, c, u] = w(this, Ln).subarray(8, 12);
    const d = t - c, h = e - u, p = Math.hypot(d, h);
    if (p < w(this, aT))
      return !1;
    const m = p - w(this, oT), b = m / p, y = b * d, Z = b * h;
    let g = o, f = l;
    o = c, l = u, c += y, u += Z, (V = w(this, Wh)) == null || V.push(t, e);
    const T = -Z / m, M = y / m, N = T * w(this, Bf), W = M * w(this, Bf);
    return w(this, Ln).set(w(this, Ln).subarray(2, 8), 0), w(this, Ln).set([c + N, u + W], 4), w(this, Ln).set(w(this, Ln).subarray(14, 18), 12), w(this, Ln).set([c - N, u - W], 16), isNaN(w(this, Ln)[6]) ? (w(this, xc).length === 0 && (w(this, Ln).set([o + N, l + W], 2), w(this, xc).push(NaN, NaN, NaN, NaN, (o + N - n) / r, (l + W - s) / a), w(this, Ln).set([o - N, l - W], 14), w(this, wl).push(NaN, NaN, NaN, NaN, (o - N - n) / r, (l - W - s) / a)), w(this, Ln).set([g, f, o, l, c, u], 6), !this.isEmpty()) : (w(this, Ln).set([g, f, o, l, c, u], 6), Math.abs(Math.atan2(f - l, g - o) - Math.atan2(Z, y)) < Math.PI / 2 ? ([o, l, c, u] = w(this, Ln).subarray(2, 6), w(this, xc).push(NaN, NaN, NaN, NaN, ((o + c) / 2 - n) / r, ((l + u) / 2 - s) / a), [o, l, g, f] = w(this, Ln).subarray(14, 18), w(this, wl).push(NaN, NaN, NaN, NaN, ((g + o) / 2 - n) / r, ((f + l) / 2 - s) / a), !0) : ([g, f, o, l, c, u] = w(this, Ln).subarray(0, 6), w(this, xc).push(((g + 5 * o) / 6 - n) / r, ((f + 5 * l) / 6 - s) / a, ((5 * o + c) / 6 - n) / r, ((5 * l + u) / 6 - s) / a, ((o + c) / 2 - n) / r, ((l + u) / 2 - s) / a), [c, u, o, l, g, f] = w(this, Ln).subarray(12, 18), w(this, wl).push(((g + 5 * o) / 6 - n) / r, ((f + 5 * l) / 6 - s) / a, ((5 * o + c) / 6 - n) / r, ((5 * l + u) / 6 - s) / a, ((o + c) / 2 - n) / r, ((l + u) / 2 - s) / a), !0));
  }
  toSVGPath() {
    if (this.isEmpty())
      return "";
    const t = w(this, xc), e = w(this, wl);
    if (isNaN(w(this, Ln)[6]) && !this.isEmpty())
      return ft(this, er, _K).call(this);
    const n = [];
    n.push(`M${t[4]} ${t[5]}`);
    for (let s = 6; s < t.length; s += 6)
      isNaN(t[s]) ? n.push(`L${t[s + 4]} ${t[s + 5]}`) : n.push(`C${t[s]} ${t[s + 1]} ${t[s + 2]} ${t[s + 3]} ${t[s + 4]} ${t[s + 5]}`);
    ft(this, er, $K).call(this, n);
    for (let s = e.length - 6; s >= 6; s -= 6)
      isNaN(e[s]) ? n.push(`L${e[s + 4]} ${e[s + 5]}`) : n.push(`C${e[s]} ${e[s + 1]} ${e[s + 2]} ${e[s + 3]} ${e[s + 4]} ${e[s + 5]}`);
    return ft(this, er, QK).call(this, n), n.join(" ");
  }
  newFreeDrawOutline(t, e, n, s, r, a) {
    return new n4(t, e, n, s, r, a);
  }
  getOutlines() {
    var d;
    const t = w(this, xc), e = w(this, wl), n = w(this, Ln), [s, r, a, o] = w(this, oo), l = new Float32Array((((d = w(this, Wh)) == null ? void 0 : d.length) ?? 0) + 2);
    for (let h = 0, p = l.length - 2; h < p; h += 2)
      l[h] = (w(this, Wh)[h] - s) / a, l[h + 1] = (w(this, Wh)[h + 1] - r) / o;
    if (l[l.length - 2] = (w(this, jm) - s) / a, l[l.length - 1] = (w(this, Um) - r) / o, isNaN(n[6]) && !this.isEmpty())
      return ft(this, er, qK).call(this, l);
    const c = new Float32Array(w(this, xc).length + 24 + w(this, wl).length);
    let u = t.length;
    for (let h = 0; h < u; h += 2) {
      if (isNaN(t[h])) {
        c[h] = c[h + 1] = NaN;
        continue;
      }
      c[h] = t[h], c[h + 1] = t[h + 1];
    }
    u = ft(this, er, e4).call(this, c, u);
    for (let h = e.length - 6; h >= 6; h -= 6)
      for (let p = 0; p < 6; p += 2) {
        if (isNaN(e[h + p])) {
          c[u] = c[u + 1] = NaN, u += 2;
          continue;
        }
        c[u] = e[h + p], c[u + 1] = e[h + p + 1], u += 2;
      }
    return ft(this, er, t4).call(this, c, u), this.newFreeDrawOutline(c, l, w(this, oo), w(this, Af), w(this, Pf), w(this, Jf));
  }
};
oo = new WeakMap(), wl = new WeakMap(), Pf = new WeakMap(), Jf = new WeakMap(), xc = new WeakMap(), Ln = new WeakMap(), jm = new WeakMap(), Um = new WeakMap(), aT = new WeakMap(), oT = new WeakMap(), Af = new WeakMap(), Bf = new WeakMap(), Wh = new WeakMap(), lT = new WeakMap(), TG = new WeakMap(), MG = new WeakMap(), er = new WeakSet(), Ay = function() {
  const t = w(this, Ln).subarray(4, 6), e = w(this, Ln).subarray(16, 18), [n, s, r, a] = w(this, oo);
  return [(w(this, jm) + (t[0] - e[0]) / 2 - n) / r, (w(this, Um) + (t[1] - e[1]) / 2 - s) / a, (w(this, jm) + (e[0] - t[0]) / 2 - n) / r, (w(this, Um) + (e[1] - t[1]) / 2 - s) / a];
}, _K = function() {
  const [t, e, n, s] = w(this, oo), [r, a, o, l] = ft(this, er, Ay).call(this);
  return `M${(w(this, Ln)[2] - t) / n} ${(w(this, Ln)[3] - e) / s} L${(w(this, Ln)[4] - t) / n} ${(w(this, Ln)[5] - e) / s} L${r} ${a} L${o} ${l} L${(w(this, Ln)[16] - t) / n} ${(w(this, Ln)[17] - e) / s} L${(w(this, Ln)[14] - t) / n} ${(w(this, Ln)[15] - e) / s} Z`;
}, QK = function(t) {
  const e = w(this, wl);
  t.push(`L${e[4]} ${e[5]} Z`);
}, $K = function(t) {
  const [e, n, s, r] = w(this, oo), a = w(this, Ln).subarray(4, 6), o = w(this, Ln).subarray(16, 18), [l, c, u, d] = ft(this, er, Ay).call(this);
  t.push(`L${(a[0] - e) / s} ${(a[1] - n) / r} L${l} ${c} L${u} ${d} L${(o[0] - e) / s} ${(o[1] - n) / r}`);
}, qK = function(t) {
  const e = w(this, Ln), [n, s, r, a] = w(this, oo), [o, l, c, u] = ft(this, er, Ay).call(this), d = new Float32Array(36);
  return d.set([NaN, NaN, NaN, NaN, (e[2] - n) / r, (e[3] - s) / a, NaN, NaN, NaN, NaN, (e[4] - n) / r, (e[5] - s) / a, NaN, NaN, NaN, NaN, o, l, NaN, NaN, NaN, NaN, c, u, NaN, NaN, NaN, NaN, (e[16] - n) / r, (e[17] - s) / a, NaN, NaN, NaN, NaN, (e[14] - n) / r, (e[15] - s) / a], 0), this.newFreeDrawOutline(d, t, w(this, oo), w(this, Af), w(this, Pf), w(this, Jf));
}, t4 = function(t, e) {
  const n = w(this, wl);
  return t.set([NaN, NaN, NaN, NaN, n[4], n[5]], e), e += 6;
}, e4 = function(t, e) {
  const n = w(this, Ln).subarray(4, 6), s = w(this, Ln).subarray(16, 18), [r, a, o, l] = w(this, oo), [c, u, d, h] = ft(this, er, Ay).call(this);
  return t.set([NaN, NaN, NaN, NaN, (n[0] - r) / o, (n[1] - a) / l, NaN, NaN, NaN, NaN, c, u, NaN, NaN, NaN, NaN, d, h, NaN, NaN, NaN, NaN, (s[0] - r) / o, (s[1] - a) / l], e), e += 24;
}, pt(uu, lT, 8), pt(uu, TG, 2), pt(uu, MG, w(uu, lT) + w(uu, TG));
let eG = uu;
var Kf, Pm, Fu, cT, lo, uT, Ms, NG, i4;
class n4 extends De {
  constructor(e, n, s, r, a, o) {
    super();
    pt(this, NG);
    pt(this, Kf);
    pt(this, Pm, new Float32Array(4));
    pt(this, Fu);
    pt(this, cT);
    pt(this, lo);
    pt(this, uT);
    pt(this, Ms);
    rt(this, Ms, e), rt(this, lo, n), rt(this, Kf, s), rt(this, uT, r), rt(this, Fu, a), rt(this, cT, o), this.firstPoint = [NaN, NaN], this.lastPoint = [NaN, NaN], ft(this, NG, i4).call(this, o);
    const [l, c, u, d] = w(this, Pm);
    for (let h = 0, p = e.length; h < p; h += 2)
      e[h] = (e[h] - l) / u, e[h + 1] = (e[h + 1] - c) / d;
    for (let h = 0, p = n.length; h < p; h += 2)
      n[h] = (n[h] - l) / u, n[h + 1] = (n[h + 1] - c) / d;
  }
  toSVGPath() {
    const e = [`M${w(this, Ms)[4]} ${w(this, Ms)[5]}`];
    for (let n = 6, s = w(this, Ms).length; n < s; n += 6) {
      if (isNaN(w(this, Ms)[n])) {
        e.push(`L${w(this, Ms)[n + 4]} ${w(this, Ms)[n + 5]}`);
        continue;
      }
      e.push(`C${w(this, Ms)[n]} ${w(this, Ms)[n + 1]} ${w(this, Ms)[n + 2]} ${w(this, Ms)[n + 3]} ${w(this, Ms)[n + 4]} ${w(this, Ms)[n + 5]}`);
    }
    return e.push("Z"), e.join(" ");
  }
  serialize([e, n, s, r], a) {
    const o = s - e, l = r - n;
    let c, u;
    switch (a) {
      case 0:
        c = De._rescale(w(this, Ms), e, r, o, -l), u = De._rescale(w(this, lo), e, r, o, -l);
        break;
      case 90:
        c = De._rescaleAndSwap(w(this, Ms), e, n, o, l), u = De._rescaleAndSwap(w(this, lo), e, n, o, l);
        break;
      case 180:
        c = De._rescale(w(this, Ms), s, n, -o, l), u = De._rescale(w(this, lo), s, n, -o, l);
        break;
      case 270:
        c = De._rescaleAndSwap(w(this, Ms), s, r, -o, -l), u = De._rescaleAndSwap(w(this, lo), s, r, -o, -l);
        break;
    }
    return {
      outline: Array.from(c),
      points: [Array.from(u)]
    };
  }
  get box() {
    return w(this, Pm);
  }
  newOutliner(e, n, s, r, a, o = 0) {
    return new eG(e, n, s, r, a, o);
  }
  getNewOutline(e, n) {
    const [s, r, a, o] = w(this, Pm), [l, c, u, d] = w(this, Kf), h = a * u, p = o * d, m = s * u + l, b = r * d + c, y = this.newOutliner({
      x: w(this, lo)[0] * h + m,
      y: w(this, lo)[1] * p + b
    }, w(this, Kf), w(this, uT), e, w(this, cT), n ?? w(this, Fu));
    for (let Z = 2; Z < w(this, lo).length; Z += 2)
      y.add({
        x: w(this, lo)[Z] * h + m,
        y: w(this, lo)[Z + 1] * p + b
      });
    return y.getOutlines();
  }
}
Kf = new WeakMap(), Pm = new WeakMap(), Fu = new WeakMap(), cT = new WeakMap(), lo = new WeakMap(), uT = new WeakMap(), Ms = new WeakMap(), NG = new WeakSet(), i4 = function(e) {
  const n = w(this, Ms);
  let s = n[4], r = n[5];
  const a = [s, r, s, r];
  let o = s, l = r, c = s, u = r;
  const d = e ? Math.max : Math.min, h = new Float32Array(4);
  for (let m = 6, b = n.length; m < b; m += 6) {
    const y = n[m + 4], Z = n[m + 5];
    isNaN(n[m]) ? (ze.pointBoundingBox(y, Z, a), l > Z ? (o = y, l = Z) : l === Z && (o = d(o, y)), u < Z ? (c = y, u = Z) : u === Z && (c = d(c, y))) : (h[0] = h[1] = 1 / 0, h[2] = h[3] = -1 / 0, ze.bezierBoundingBox(s, r, ...n.slice(m, m + 6), h), ze.rectBoundingBox(h[0], h[1], h[2], h[3], a), l > h[1] ? (o = h[0], l = h[1]) : l === h[1] && (o = d(o, h[0])), u < h[3] ? (c = h[2], u = h[3]) : u === h[3] && (c = d(c, h[2]))), s = y, r = Z;
  }
  const p = w(this, Pm);
  p[0] = a[0] - w(this, Fu), p[1] = a[1] - w(this, Fu), p[2] = a[2] - a[0] + 2 * w(this, Fu), p[3] = a[3] - a[1] + 2 * w(this, Fu), this.firstPoint = [o, l], this.lastPoint = [c, u];
};
var dT, hT, pT, Gh, xl, xa, s4, PN, r4, a4, yX;
class gX {
  constructor(t, e = 0, n = 0, s = !0) {
    pt(this, xa);
    pt(this, dT);
    pt(this, hT);
    pt(this, pT);
    pt(this, Gh, []);
    pt(this, xl, []);
    const r = [1 / 0, 1 / 0, -1 / 0, -1 / 0], a = 10 ** -4;
    for (const {
      x: b,
      y,
      width: Z,
      height: g
    } of t) {
      const f = Math.floor((b - e) / a) * a, T = Math.ceil((b + Z + e) / a) * a, M = Math.floor((y - e) / a) * a, N = Math.ceil((y + g + e) / a) * a, W = [f, M, N, !0], x = [T, M, N, !1];
      w(this, Gh).push(W, x), ze.rectBoundingBox(f, M, T, N, r);
    }
    const o = r[2] - r[0] + 2 * n, l = r[3] - r[1] + 2 * n, c = r[0] - n, u = r[1] - n;
    let d = s ? -1 / 0 : 1 / 0, h = 1 / 0;
    const p = w(this, Gh).at(s ? -1 : -2), m = [p[0], p[2]];
    for (const b of w(this, Gh)) {
      const [y, Z, g, f] = b;
      !f && s ? Z < h ? (h = Z, d = y) : Z === h && (d = Math.max(d, y)) : f && !s && (Z < h ? (h = Z, d = y) : Z === h && (d = Math.min(d, y))), b[0] = (y - c) / o, b[1] = (Z - u) / l, b[2] = (g - u) / l;
    }
    rt(this, dT, new Float32Array([c, u, o, l])), rt(this, hT, [d, h]), rt(this, pT, m);
  }
  getOutlines() {
    w(this, Gh).sort((e, n) => e[0] - n[0] || e[1] - n[1] || e[2] - n[2]);
    const t = [];
    for (const e of w(this, Gh))
      e[3] ? (t.push(...ft(this, xa, yX).call(this, e)), ft(this, xa, r4).call(this, e)) : (ft(this, xa, a4).call(this, e), t.push(...ft(this, xa, yX).call(this, e)));
    return ft(this, xa, s4).call(this, t);
  }
}
dT = new WeakMap(), hT = new WeakMap(), pT = new WeakMap(), Gh = new WeakMap(), xl = new WeakMap(), xa = new WeakSet(), s4 = function(t) {
  const e = [], n = /* @__PURE__ */ new Set();
  for (const a of t) {
    const [o, l, c] = a;
    e.push([o, l, a], [o, c, a]);
  }
  e.sort((a, o) => a[1] - o[1] || a[0] - o[0]);
  for (let a = 0, o = e.length; a < o; a += 2) {
    const l = e[a][2], c = e[a + 1][2];
    l.push(c), c.push(l), n.add(l), n.add(c);
  }
  const s = [];
  let r;
  for (; n.size > 0; ) {
    const a = n.values().next().value;
    let [o, l, c, u, d] = a;
    n.delete(a);
    let h = o, p = l;
    for (r = [o, c], s.push(r); ; ) {
      let m;
      if (n.has(u))
        m = u;
      else if (n.has(d))
        m = d;
      else
        break;
      n.delete(m), [o, l, c, u, d] = m, h !== o && (r.push(h, p, o, p === l ? l : c), h = o), p = p === l ? c : l;
    }
    r.push(h, p);
  }
  return new UCt(s, w(this, dT), w(this, hT), w(this, pT));
}, PN = function(t) {
  const e = w(this, xl);
  let n = 0, s = e.length - 1;
  for (; n <= s; ) {
    const r = n + s >> 1, a = e[r][0];
    if (a === t)
      return r;
    a < t ? n = r + 1 : s = r - 1;
  }
  return s + 1;
}, r4 = function([, t, e]) {
  const n = ft(this, xa, PN).call(this, t);
  w(this, xl).splice(n, 0, [t, e]);
}, a4 = function([, t, e]) {
  const n = ft(this, xa, PN).call(this, t);
  for (let s = n; s < w(this, xl).length; s++) {
    const [r, a] = w(this, xl)[s];
    if (r !== t)
      break;
    if (r === t && a === e) {
      w(this, xl).splice(s, 1);
      return;
    }
  }
  for (let s = n - 1; s >= 0; s--) {
    const [r, a] = w(this, xl)[s];
    if (r !== t)
      break;
    if (r === t && a === e) {
      w(this, xl).splice(s, 1);
      return;
    }
  }
}, yX = function(t) {
  const [e, n, s] = t, r = [[e, n, s]], a = ft(this, xa, PN).call(this, s);
  for (let o = 0; o < a; o++) {
    const [l, c] = w(this, xl)[o];
    for (let u = 0, d = r.length; u < d; u++) {
      const [, h, p] = r[u];
      if (!(c <= h || p <= l)) {
        if (h >= l) {
          if (p > c)
            r[u][1] = c;
          else {
            if (d === 1)
              return [];
            r.splice(u, 1), u--, d--;
          }
          continue;
        }
        r[u][2] = l, p > c && r.push([e, c, p]);
      }
    }
  }
  return r;
};
var mT, Hf;
class UCt extends De {
  constructor(e, n, s, r) {
    super();
    pt(this, mT);
    pt(this, Hf);
    rt(this, Hf, e), rt(this, mT, n), this.firstPoint = s, this.lastPoint = r;
  }
  toSVGPath() {
    const e = [];
    for (const n of w(this, Hf)) {
      let [s, r] = n;
      e.push(`M${s} ${r}`);
      for (let a = 2; a < n.length; a += 2) {
        const o = n[a], l = n[a + 1];
        o === s ? (e.push(`V${l}`), r = l) : l === r && (e.push(`H${o}`), s = o);
      }
      e.push("Z");
    }
    return e.join(" ");
  }
  serialize([e, n, s, r], a) {
    const o = [], l = s - e, c = r - n;
    for (const u of w(this, Hf)) {
      const d = new Array(u.length);
      for (let h = 0; h < u.length; h += 2)
        d[h] = e + u[h] * l, d[h + 1] = r - u[h + 1] * c;
      o.push(d);
    }
    return o;
  }
  get box() {
    return w(this, mT);
  }
  get classNamesForOutlining() {
    return ["highlightOutline"];
  }
}
mT = new WeakMap(), Hf = new WeakMap();
class ZX extends eG {
  newFreeDrawOutline(t, e, n, s, r, a) {
    return new PCt(t, e, n, s, r, a);
  }
}
class PCt extends n4 {
  newOutliner(t, e, n, s, r, a = 0) {
    return new ZX(t, e, n, s, r, a);
  }
}
var _f, bT, ju, Jm, fT, za, gT, yT, Am, co, uo, xr, Qf, $f, ta, qf, Ko, ZT, Mn, TX, JN, o4, l4, c4, MX, Ip, el, bb, u4, AN, BN, d4, h4, p4, m4, b4;
const ri = class ri extends Di {
  constructor(e) {
    super({
      ...e,
      name: "highlightEditor"
    });
    pt(this, Mn);
    pt(this, _f, null);
    pt(this, bT, 0);
    pt(this, ju);
    pt(this, Jm, null);
    pt(this, fT, null);
    pt(this, za, null);
    pt(this, gT, null);
    pt(this, yT, 0);
    pt(this, Am, null);
    pt(this, co, null);
    pt(this, uo, null);
    pt(this, xr, !1);
    pt(this, Qf, null);
    pt(this, $f, null);
    pt(this, ta, null);
    pt(this, qf, "");
    pt(this, Ko);
    pt(this, ZT, "");
    this.color = e.color || ri._defaultColor, rt(this, Ko, e.thickness || ri._defaultThickness), this.opacity = e.opacity || ri._defaultOpacity, rt(this, ju, e.boxes || null), rt(this, ZT, e.methodOfCreation || ""), rt(this, qf, e.text || ""), this._isDraggable = !1, this.defaultL10nId = "pdfjs-editor-highlight-editor", e.highlightId > -1 ? (rt(this, xr, !0), ft(this, Mn, JN).call(this, e), ft(this, Mn, Ip).call(this)) : w(this, ju) && (rt(this, _f, e.anchorNode), rt(this, bT, e.anchorOffset), rt(this, gT, e.focusNode), rt(this, yT, e.focusOffset), ft(this, Mn, TX).call(this), ft(this, Mn, Ip).call(this), this.rotate(this.rotation)), this.annotationElementId || this._uiManager.a11yAlert("pdfjs-editor-highlight-added-alert");
  }
  static get _keyboardManager() {
    const e = ri.prototype;
    return Gn(this, "_keyboardManager", new $T([[["ArrowLeft", "mac+ArrowLeft"], e._moveCaret, {
      args: [0]
    }], [["ArrowRight", "mac+ArrowRight"], e._moveCaret, {
      args: [1]
    }], [["ArrowUp", "mac+ArrowUp"], e._moveCaret, {
      args: [2]
    }], [["ArrowDown", "mac+ArrowDown"], e._moveCaret, {
      args: [3]
    }]]));
  }
  get telemetryInitialData() {
    return {
      action: "added",
      type: w(this, xr) ? "free_highlight" : "highlight",
      color: this._uiManager.getNonHCMColorName(this.color),
      thickness: w(this, Ko),
      methodOfCreation: w(this, ZT)
    };
  }
  get telemetryFinalData() {
    return {
      type: "highlight",
      color: this._uiManager.getNonHCMColorName(this.color)
    };
  }
  static computeTelemetryFinalData(e) {
    return {
      numberOfColors: e.get("color").size
    };
  }
  static initialize(e, n) {
    var s;
    Di.initialize(e, n), ri._defaultColor || (ri._defaultColor = ((s = n.highlightColors) == null ? void 0 : s.values().next().value) || "#fff066");
  }
  static updateDefaultParams(e, n) {
    switch (e) {
      case Un.HIGHLIGHT_COLOR:
        ri._defaultColor = n;
        break;
      case Un.HIGHLIGHT_THICKNESS:
        ri._defaultThickness = n;
        break;
    }
  }
  translateInPage(e, n) {
  }
  get toolbarPosition() {
    return w(this, $f);
  }
  get commentButtonPosition() {
    return w(this, Qf);
  }
  updateParams(e, n) {
    switch (e) {
      case Un.HIGHLIGHT_COLOR:
        ft(this, Mn, o4).call(this, n);
        break;
      case Un.HIGHLIGHT_THICKNESS:
        ft(this, Mn, l4).call(this, n);
        break;
    }
  }
  static get defaultPropertiesToUpdate() {
    return [[Un.HIGHLIGHT_COLOR, ri._defaultColor], [Un.HIGHLIGHT_THICKNESS, ri._defaultThickness]];
  }
  get propertiesToUpdate() {
    return [[Un.HIGHLIGHT_COLOR, this.color || ri._defaultColor], [Un.HIGHLIGHT_THICKNESS, w(this, Ko) || ri._defaultThickness], [Un.HIGHLIGHT_FREE, w(this, xr)]];
  }
  onUpdatedColor() {
    var e, n;
    (e = this.parent) == null || e.drawLayer.updateProperties(w(this, uo), {
      root: {
        fill: this.color,
        "fill-opacity": this.opacity
      }
    }), (n = w(this, fT)) == null || n.updateColor(this.color), super.onUpdatedColor();
  }
  get toolbarButtons() {
    return this._uiManager.highlightColors ? [["colorPicker", rt(this, fT, new QW({
      editor: this
    }))]] : super.toolbarButtons;
  }
  disableEditing() {
    super.disableEditing(), this.div.classList.toggle("disabled", !0);
  }
  enableEditing() {
    super.enableEditing(), this.div.classList.toggle("disabled", !1);
  }
  fixAndSetPosition() {
    return super.fixAndSetPosition(ft(this, Mn, BN).call(this));
  }
  getBaseTranslation() {
    return [0, 0];
  }
  getRect(e, n) {
    return super.getRect(e, n, ft(this, Mn, BN).call(this));
  }
  onceAdded(e) {
    this.annotationElementId || this.parent.addUndoableEditor(this), e && this.div.focus();
  }
  remove() {
    ft(this, Mn, MX).call(this), this._reportTelemetry({
      action: "deleted"
    }), super.remove();
  }
  rebuild() {
    this.parent && (super.rebuild(), this.div !== null && (ft(this, Mn, Ip).call(this), this.isAttachedToDOM || this.parent.add(this)));
  }
  setParent(e) {
    var s;
    let n = !1;
    this.parent && !e ? ft(this, Mn, MX).call(this) : e && (ft(this, Mn, Ip).call(this, e), n = !this.parent && ((s = this.div) == null ? void 0 : s.classList.contains("selectedEditor"))), super.setParent(e), this.show(this._isVisible), n && this.select();
  }
  rotate(e) {
    var r, a, o;
    const {
      drawLayer: n
    } = this.parent;
    let s;
    w(this, xr) ? (e = (e - this.rotation + 360) % 360, s = ft(r = ri, el, bb).call(r, w(this, co).box, e)) : s = ft(a = ri, el, bb).call(a, [this.x, this.y, this.width, this.height], e), n.updateProperties(w(this, uo), {
      bbox: s,
      root: {
        "data-main-rotation": e
      }
    }), n.updateProperties(w(this, ta), {
      bbox: ft(o = ri, el, bb).call(o, w(this, za).box, e),
      root: {
        "data-main-rotation": e
      }
    });
  }
  render() {
    if (this.div)
      return this.div;
    const e = super.render();
    w(this, qf) && (e.setAttribute("aria-label", w(this, qf)), e.setAttribute("role", "mark")), w(this, xr) ? e.classList.add("free") : this.div.addEventListener("keydown", ft(this, Mn, u4).bind(this), {
      signal: this._uiManager._signal
    });
    const n = rt(this, Am, document.createElement("div"));
    return e.append(n), n.setAttribute("aria-hidden", "true"), n.className = "internal", n.style.clipPath = w(this, Jm), this.setDims(this.width, this.height), DB(this, w(this, Am), ["pointerover", "pointerleave"]), this.enableEditing(), e;
  }
  pointerover() {
    var e;
    this.isSelected || (e = this.parent) == null || e.drawLayer.updateProperties(w(this, ta), {
      rootClass: {
        hovered: !0
      }
    });
  }
  pointerleave() {
    var e;
    this.isSelected || (e = this.parent) == null || e.drawLayer.updateProperties(w(this, ta), {
      rootClass: {
        hovered: !1
      }
    });
  }
  _moveCaret(e) {
    switch (this.parent.unselect(this), e) {
      case 0:
      case 2:
        ft(this, Mn, AN).call(this, !0);
        break;
      case 1:
      case 3:
        ft(this, Mn, AN).call(this, !1);
        break;
    }
  }
  select() {
    var e;
    super.select(), w(this, ta) && ((e = this.parent) == null || e.drawLayer.updateProperties(w(this, ta), {
      rootClass: {
        hovered: !1,
        selected: !0
      }
    }));
  }
  unselect() {
    var e;
    super.unselect(), w(this, ta) && ((e = this.parent) == null || e.drawLayer.updateProperties(w(this, ta), {
      rootClass: {
        selected: !1
      }
    }), w(this, xr) || ft(this, Mn, AN).call(this, !1));
  }
  get _mustFixPosition() {
    return !w(this, xr);
  }
  show(e = this._isVisible) {
    super.show(e), this.parent && (this.parent.drawLayer.updateProperties(w(this, uo), {
      rootClass: {
        hidden: !e
      }
    }), this.parent.drawLayer.updateProperties(w(this, ta), {
      rootClass: {
        hidden: !e
      }
    }));
  }
  static startHighlighting(e, n, {
    target: s,
    x: r,
    y: a
  }) {
    const {
      x: o,
      y: l,
      width: c,
      height: u
    } = s.getBoundingClientRect(), d = new AbortController(), h = e.combinedSignal(d), p = (m) => {
      d.abort(), ft(this, el, m4).call(this, e, m);
    };
    window.addEventListener("blur", p, {
      signal: h
    }), window.addEventListener("pointerup", p, {
      signal: h
    }), window.addEventListener("pointerdown", ms, {
      capture: !0,
      passive: !1,
      signal: h
    }), window.addEventListener("contextmenu", al, {
      signal: h
    }), s.addEventListener("pointermove", ft(this, el, p4).bind(this, e), {
      signal: h
    }), this._freeHighlight = new ZX({
      x: r,
      y: a
    }, [o, l, c, u], e.scale, this._defaultThickness / 2, n, 1e-3), {
      id: this._freeHighlightId,
      clipPathId: this._freeHighlightClipId
    } = e.drawLayer.draw({
      bbox: [0, 0, 1, 1],
      root: {
        viewBox: "0 0 1 1",
        fill: this._defaultColor,
        "fill-opacity": this._defaultOpacity
      },
      rootClass: {
        highlight: !0,
        free: !0
      },
      path: {
        d: this._freeHighlight.toSVGPath()
      }
    }, !0, !0);
  }
  static async deserialize(e, n, s) {
    var b, y, Z, g;
    let r = null;
    if (e instanceof UK) {
      const {
        data: {
          quadPoints: f,
          rect: T,
          rotation: M,
          id: N,
          color: W,
          opacity: x,
          popupRef: V,
          richText: X,
          contentsObj: C,
          creationDate: R,
          modificationDate: z
        },
        parent: {
          page: {
            pageNumber: F
          }
        }
      } = e;
      r = e = {
        annotationType: fn.HIGHLIGHT,
        color: Array.from(W),
        opacity: x,
        quadPoints: f,
        boxes: null,
        pageIndex: F - 1,
        rect: T.slice(0),
        rotation: M,
        annotationElementId: N,
        id: N,
        deleted: !1,
        popupRef: V,
        richText: X,
        comment: (C == null ? void 0 : C.str) || null,
        creationDate: R,
        modificationDate: z
      };
    } else if (e instanceof sY) {
      const {
        data: {
          inkLists: f,
          rect: T,
          rotation: M,
          id: N,
          color: W,
          borderStyle: {
            rawWidth: x
          },
          popupRef: V,
          richText: X,
          contentsObj: C,
          creationDate: R,
          modificationDate: z
        },
        parent: {
          page: {
            pageNumber: F
          }
        }
      } = e;
      r = e = {
        annotationType: fn.HIGHLIGHT,
        color: Array.from(W),
        thickness: x,
        inkLists: f,
        boxes: null,
        pageIndex: F - 1,
        rect: T.slice(0),
        rotation: M,
        annotationElementId: N,
        id: N,
        deleted: !1,
        popupRef: V,
        richText: X,
        comment: (C == null ? void 0 : C.str) || null,
        creationDate: R,
        modificationDate: z
      };
    }
    const {
      color: a,
      quadPoints: o,
      inkLists: l,
      opacity: c
    } = e, u = await super.deserialize(e, n, s);
    u.color = ze.makeHexColor(...a), u.opacity = c || 1, l && rt(u, Ko, e.thickness), u._initialData = r, e.comment && u.setCommentData(e);
    const [d, h] = u.pageDimensions, [p, m] = u.pageTranslation;
    if (o) {
      const f = rt(u, ju, []);
      for (let T = 0; T < o.length; T += 8)
        f.push({
          x: (o[T] - p) / d,
          y: 1 - (o[T + 1] - m) / h,
          width: (o[T + 2] - o[T]) / d,
          height: (o[T + 1] - o[T + 5]) / h
        });
      ft(b = u, Mn, TX).call(b), ft(y = u, Mn, Ip).call(y), u.rotate(u.rotation);
    } else if (l) {
      rt(u, xr, !0);
      const f = l[0], T = {
        x: f[0] - p,
        y: h - (f[1] - m)
      }, M = new ZX(T, [0, 0, d, h], 1, w(u, Ko) / 2, !0, 1e-3);
      for (let x = 0, V = f.length; x < V; x += 2)
        T.x = f[x] - p, T.y = h - (f[x + 1] - m), M.add(T);
      const {
        id: N,
        clipPathId: W
      } = n.drawLayer.draw({
        bbox: [0, 0, 1, 1],
        root: {
          viewBox: "0 0 1 1",
          fill: u.color,
          "fill-opacity": u._defaultOpacity
        },
        rootClass: {
          highlight: !0,
          free: !0
        },
        path: {
          d: M.toSVGPath()
        }
      }, !0, !0);
      ft(Z = u, Mn, JN).call(Z, {
        highlightOutlines: M.getOutlines(),
        highlightId: N,
        clipPathId: W
      }), ft(g = u, Mn, Ip).call(g), u.rotate(u.parentRotation);
    }
    return u;
  }
  serialize(e = !1) {
    if (this.isEmpty() || e)
      return null;
    if (this.deleted)
      return this.serializeDeleted();
    const n = Di._colorManager.convert(this._uiManager.getNonHCMColor(this.color)), s = super.serialize(e);
    return Object.assign(s, {
      color: n,
      opacity: this.opacity,
      thickness: w(this, Ko),
      quadPoints: ft(this, Mn, d4).call(this),
      outlines: ft(this, Mn, h4).call(this, s.rect)
    }), this.addComment(s), this.annotationElementId && !ft(this, Mn, b4).call(this, s) ? null : (s.id = this.annotationElementId, s);
  }
  renderAnnotationElement(e) {
    return this.deleted ? (e.hide(), null) : (e.updateEdited({
      rect: this.getPDFRect(),
      popup: this.comment
    }), null);
  }
  static canCreateNewEmptyEditor() {
    return !1;
  }
};
_f = new WeakMap(), bT = new WeakMap(), ju = new WeakMap(), Jm = new WeakMap(), fT = new WeakMap(), za = new WeakMap(), gT = new WeakMap(), yT = new WeakMap(), Am = new WeakMap(), co = new WeakMap(), uo = new WeakMap(), xr = new WeakMap(), Qf = new WeakMap(), $f = new WeakMap(), ta = new WeakMap(), qf = new WeakMap(), Ko = new WeakMap(), ZT = new WeakMap(), Mn = new WeakSet(), TX = function() {
  const e = new gX(w(this, ju), 1e-3);
  rt(this, co, e.getOutlines()), [this.x, this.y, this.width, this.height] = w(this, co).box;
  const n = new gX(w(this, ju), 25e-4, 1e-3, this._uiManager.direction === "ltr");
  rt(this, za, n.getOutlines());
  const {
    firstPoint: s
  } = w(this, co);
  rt(this, Qf, [(s[0] - this.x) / this.width, (s[1] - this.y) / this.height]);
  const {
    lastPoint: r
  } = w(this, za);
  rt(this, $f, [(r[0] - this.x) / this.width, (r[1] - this.y) / this.height]);
}, JN = function({
  highlightOutlines: e,
  highlightId: n,
  clipPathId: s
}) {
  var h, p;
  if (rt(this, co, e), rt(this, za, e.getNewOutline(w(this, Ko) / 2 + 1.5, 25e-4)), n >= 0)
    rt(this, uo, n), rt(this, Jm, s), this.parent.drawLayer.finalizeDraw(n, {
      bbox: e.box,
      path: {
        d: e.toSVGPath()
      }
    }), rt(this, ta, this.parent.drawLayer.drawOutline({
      rootClass: {
        highlightOutline: !0,
        free: !0
      },
      bbox: w(this, za).box,
      path: {
        d: w(this, za).toSVGPath()
      }
    }, !0));
  else if (this.parent) {
    const m = this.parent.viewport.rotation;
    this.parent.drawLayer.updateProperties(w(this, uo), {
      bbox: ft(h = ri, el, bb).call(h, w(this, co).box, (m - this.rotation + 360) % 360),
      path: {
        d: e.toSVGPath()
      }
    }), this.parent.drawLayer.updateProperties(w(this, ta), {
      bbox: ft(p = ri, el, bb).call(p, w(this, za).box, m),
      path: {
        d: w(this, za).toSVGPath()
      }
    });
  }
  const [a, o, l, c] = e.box;
  switch (this.rotation) {
    case 0:
      this.x = a, this.y = o, this.width = l, this.height = c;
      break;
    case 90: {
      const [m, b] = this.parentDimensions;
      this.x = o, this.y = 1 - a, this.width = l * b / m, this.height = c * m / b;
      break;
    }
    case 180:
      this.x = 1 - a, this.y = 1 - o, this.width = l, this.height = c;
      break;
    case 270: {
      const [m, b] = this.parentDimensions;
      this.x = 1 - o, this.y = a, this.width = l * b / m, this.height = c * m / b;
      break;
    }
  }
  const {
    firstPoint: u
  } = e;
  rt(this, Qf, [(u[0] - a) / l, (u[1] - o) / c]);
  const {
    lastPoint: d
  } = w(this, za);
  rt(this, $f, [(d[0] - a) / l, (d[1] - o) / c]);
}, o4 = function(e) {
  const n = (a, o) => {
    this.color = a, this.opacity = o, this.onUpdatedColor();
  }, s = this.color, r = this.opacity;
  this.addCommands({
    cmd: n.bind(this, e, ri._defaultOpacity),
    undo: n.bind(this, s, r),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: !0,
    type: Un.HIGHLIGHT_COLOR,
    overwriteIfSameType: !0,
    keepUndo: !0
  }), this._reportTelemetry({
    action: "color_changed",
    color: this._uiManager.getNonHCMColorName(e)
  }, !0);
}, l4 = function(e) {
  const n = w(this, Ko), s = (r) => {
    rt(this, Ko, r), ft(this, Mn, c4).call(this, r);
  };
  this.addCommands({
    cmd: s.bind(this, e),
    undo: s.bind(this, n),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: !0,
    type: Un.INK_THICKNESS,
    overwriteIfSameType: !0,
    keepUndo: !0
  }), this._reportTelemetry({
    action: "thickness_changed",
    thickness: e
  }, !0);
}, c4 = function(e) {
  w(this, xr) && (ft(this, Mn, JN).call(this, {
    highlightOutlines: w(this, co).getNewOutline(e / 2)
  }), this.fixAndSetPosition(), this.setDims(this.width, this.height));
}, MX = function() {
  w(this, uo) === null || !this.parent || (this.parent.drawLayer.remove(w(this, uo)), rt(this, uo, null), this.parent.drawLayer.remove(w(this, ta)), rt(this, ta, null));
}, Ip = function(e = this.parent) {
  w(this, uo) === null && ({
    id: Ks(this, uo)._,
    clipPathId: Ks(this, Jm)._
  } = e.drawLayer.draw({
    bbox: w(this, co).box,
    root: {
      viewBox: "0 0 1 1",
      fill: this.color,
      "fill-opacity": this.opacity
    },
    rootClass: {
      highlight: !0,
      free: w(this, xr)
    },
    path: {
      d: w(this, co).toSVGPath()
    }
  }, !1, !0), rt(this, ta, e.drawLayer.drawOutline({
    rootClass: {
      highlightOutline: !0,
      free: w(this, xr)
    },
    bbox: w(this, za).box,
    path: {
      d: w(this, za).toSVGPath()
    }
  }, w(this, xr))), w(this, Am) && (w(this, Am).style.clipPath = w(this, Jm)));
}, el = new WeakSet(), bb = function([e, n, s, r], a) {
  switch (a) {
    case 90:
      return [1 - n - r, e, r, s];
    case 180:
      return [1 - e - s, 1 - n - r, s, r];
    case 270:
      return [n, 1 - e - s, r, s];
  }
  return [e, n, s, r];
}, u4 = function(e) {
  ri._keyboardManager.exec(this, e);
}, AN = function(e) {
  if (!w(this, _f))
    return;
  const n = window.getSelection();
  e ? n.setPosition(w(this, _f), w(this, bT)) : n.setPosition(w(this, gT), w(this, yT));
}, BN = function() {
  return w(this, xr) ? this.rotation : 0;
}, d4 = function() {
  if (w(this, xr))
    return null;
  const [e, n] = this.pageDimensions, [s, r] = this.pageTranslation, a = w(this, ju), o = new Float32Array(a.length * 8);
  let l = 0;
  for (const {
    x: c,
    y: u,
    width: d,
    height: h
  } of a) {
    const p = c * e + s, m = (1 - u) * n + r;
    o[l] = o[l + 4] = p, o[l + 1] = o[l + 3] = m, o[l + 2] = o[l + 6] = p + d * e, o[l + 5] = o[l + 7] = m - h * n, l += 8;
  }
  return o;
}, h4 = function(e) {
  return w(this, co).serialize(e, ft(this, Mn, BN).call(this));
}, p4 = function(e, n) {
  this._freeHighlight.add(n) && e.drawLayer.updateProperties(this._freeHighlightId, {
    path: {
      d: this._freeHighlight.toSVGPath()
    }
  });
}, m4 = function(e, n) {
  this._freeHighlight.isEmpty() ? e.drawLayer.remove(this._freeHighlightId) : e.createAndAddNewEditor(n, !1, {
    highlightId: this._freeHighlightId,
    highlightOutlines: this._freeHighlight.getOutlines(),
    clipPathId: this._freeHighlightClipId,
    methodOfCreation: "main_toolbar"
  }), this._freeHighlightId = -1, this._freeHighlight = null, this._freeHighlightClipId = "";
}, b4 = function(e) {
  const {
    color: n
  } = this._initialData;
  return this.hasEditedComment || e.color.some((s, r) => s !== n[r]);
}, pt(ri, el), S(ri, "_defaultColor", null), S(ri, "_defaultOpacity", 1), S(ri, "_defaultThickness", 12), S(ri, "_type", "highlight"), S(ri, "_editorType", fn.HIGHLIGHT), S(ri, "_freeHighlightId", -1), S(ri, "_freeHighlight", null), S(ri, "_freeHighlightClipId", "");
let nG = ri;
var Bm;
class f4 {
  constructor() {
    pt(this, Bm, /* @__PURE__ */ Object.create(null));
  }
  updateProperty(t, e) {
    this[t] = e, this.updateSVGProperty(t, e);
  }
  updateProperties(t) {
    if (t)
      for (const [e, n] of Object.entries(t))
        e.startsWith("_") || this.updateProperty(e, n);
  }
  updateSVGProperty(t, e) {
    w(this, Bm)[t] = e;
  }
  toSVGProperties() {
    const t = w(this, Bm);
    return rt(this, Bm, /* @__PURE__ */ Object.create(null)), {
      root: t
    };
  }
  reset() {
    rt(this, Bm, /* @__PURE__ */ Object.create(null));
  }
  updateAll(t = this) {
    this.updateProperties(t);
  }
  clone() {
    Xi("Not implemented");
  }
}
Bm = new WeakMap();
var ho, tg, or, Km, Hm, wh, xh, Sh, _m, _n, NX, WX, GX, By, g4, KN, Ky, fb;
const ke = class ke extends Di {
  constructor(e) {
    super(e);
    pt(this, _n);
    pt(this, ho, null);
    pt(this, tg);
    S(this, "_colorPicker", null);
    S(this, "_drawId", null);
    rt(this, tg, e.mustBeCommitted || !1), this._addOutlines(e);
  }
  onUpdatedColor() {
    var e;
    (e = this._colorPicker) == null || e.update(this.color), super.onUpdatedColor();
  }
  _addOutlines(e) {
    e.drawOutlines && (ft(this, _n, NX).call(this, e), ft(this, _n, By).call(this));
  }
  static _mergeSVGProperties(e, n) {
    const s = new Set(Object.keys(e));
    for (const [r, a] of Object.entries(n))
      s.has(r) ? Object.assign(e[r], a) : e[r] = a;
    return e;
  }
  static getDefaultDrawingOptions(e) {
    Xi("Not implemented");
  }
  static get typesMap() {
    Xi("Not implemented");
  }
  static get isDrawer() {
    return !0;
  }
  static get supportMultipleDrawings() {
    return !1;
  }
  static updateDefaultParams(e, n) {
    const s = this.typesMap.get(e);
    s && this._defaultDrawingOptions.updateProperty(s, n), this._currentParent && (w(ke, or).updateProperty(s, n), this._currentParent.drawLayer.updateProperties(this._currentDrawId, this._defaultDrawingOptions.toSVGProperties()));
  }
  updateParams(e, n) {
    const s = this.constructor.typesMap.get(e);
    s && this._updateProperty(e, s, n);
  }
  static get defaultPropertiesToUpdate() {
    const e = [], n = this._defaultDrawingOptions;
    for (const [s, r] of this.typesMap)
      e.push([s, n[r]]);
    return e;
  }
  get propertiesToUpdate() {
    const e = [], {
      _drawingOptions: n
    } = this;
    for (const [s, r] of this.constructor.typesMap)
      e.push([s, n[r]]);
    return e;
  }
  _updateProperty(e, n, s) {
    const r = this._drawingOptions, a = r[n], o = (l) => {
      var u;
      r.updateProperty(n, l);
      const c = w(this, ho).updateProperty(n, l);
      c && ft(this, _n, Ky).call(this, c), (u = this.parent) == null || u.drawLayer.updateProperties(this._drawId, r.toSVGProperties()), e === this.colorType && this.onUpdatedColor();
    };
    this.addCommands({
      cmd: o.bind(this, s),
      undo: o.bind(this, a),
      post: this._uiManager.updateUI.bind(this._uiManager, this),
      mustExec: !0,
      type: e,
      overwriteIfSameType: !0,
      keepUndo: !0
    });
  }
  _onResizing() {
    var e;
    (e = this.parent) == null || e.drawLayer.updateProperties(this._drawId, ke._mergeSVGProperties(w(this, ho).getPathResizingSVGProperties(ft(this, _n, KN).call(this)), {
      bbox: ft(this, _n, fb).call(this)
    }));
  }
  _onResized() {
    var e;
    (e = this.parent) == null || e.drawLayer.updateProperties(this._drawId, ke._mergeSVGProperties(w(this, ho).getPathResizedSVGProperties(ft(this, _n, KN).call(this)), {
      bbox: ft(this, _n, fb).call(this)
    }));
  }
  _onTranslating(e, n) {
    var s;
    (s = this.parent) == null || s.drawLayer.updateProperties(this._drawId, {
      bbox: ft(this, _n, fb).call(this)
    });
  }
  _onTranslated() {
    var e;
    (e = this.parent) == null || e.drawLayer.updateProperties(this._drawId, ke._mergeSVGProperties(w(this, ho).getPathTranslatedSVGProperties(ft(this, _n, KN).call(this), this.parentDimensions), {
      bbox: ft(this, _n, fb).call(this)
    }));
  }
  _onStartDragging() {
    var e;
    (e = this.parent) == null || e.drawLayer.updateProperties(this._drawId, {
      rootClass: {
        moving: !0
      }
    });
  }
  _onStopDragging() {
    var e;
    (e = this.parent) == null || e.drawLayer.updateProperties(this._drawId, {
      rootClass: {
        moving: !1
      }
    });
  }
  commit() {
    super.commit(), this.disableEditMode(), this.disableEditing();
  }
  disableEditing() {
    super.disableEditing(), this.div.classList.toggle("disabled", !0);
  }
  enableEditing() {
    super.enableEditing(), this.div.classList.toggle("disabled", !1);
  }
  getBaseTranslation() {
    return [0, 0];
  }
  get isResizable() {
    return !0;
  }
  onceAdded(e) {
    this.annotationElementId || this.parent.addUndoableEditor(this), this._isDraggable = !0, w(this, tg) && (rt(this, tg, !1), this.commit(), this.parent.setSelected(this), e && this.isOnScreen && this.div.focus());
  }
  remove() {
    ft(this, _n, GX).call(this), super.remove();
  }
  rebuild() {
    this.parent && (super.rebuild(), this.div !== null && (ft(this, _n, By).call(this), ft(this, _n, Ky).call(this, w(this, ho).box), this.isAttachedToDOM || this.parent.add(this)));
  }
  setParent(e) {
    var s;
    let n = !1;
    this.parent && !e ? (this._uiManager.removeShouldRescale(this), ft(this, _n, GX).call(this)) : e && (this._uiManager.addShouldRescale(this), ft(this, _n, By).call(this, e), n = !this.parent && ((s = this.div) == null ? void 0 : s.classList.contains("selectedEditor"))), super.setParent(e), n && this.select();
  }
  rotate() {
    this.parent && this.parent.drawLayer.updateProperties(this._drawId, ke._mergeSVGProperties({
      bbox: ft(this, _n, fb).call(this)
    }, w(this, ho).updateRotation((this.parentRotation - this.rotation + 360) % 360)));
  }
  onScaleChanging() {
    this.parent && ft(this, _n, Ky).call(this, w(this, ho).updateParentDimensions(this.parentDimensions, this.parent.scale));
  }
  static onScaleChangingWhenDrawing() {
  }
  render() {
    if (this.div)
      return this.div;
    let e, n;
    this._isCopy && (e = this.x, n = this.y);
    const s = super.render();
    s.classList.add("draw");
    const r = document.createElement("div");
    return s.append(r), r.setAttribute("aria-hidden", "true"), r.className = "internal", this.setDims(), this._uiManager.addShouldRescale(this), this.disableEditing(), this._isCopy && this._moveAfterPaste(e, n), s;
  }
  static createDrawerInstance(e, n, s, r, a) {
    Xi("Not implemented");
  }
  static startDrawing(e, n, s, r) {
    var y;
    const {
      target: a,
      offsetX: o,
      offsetY: l,
      pointerId: c,
      pointerType: u
    } = r;
    if (w(ke, xh) && w(ke, xh) !== u)
      return;
    const {
      viewport: {
        rotation: d
      }
    } = e, {
      width: h,
      height: p
    } = a.getBoundingClientRect(), m = rt(ke, Km, new AbortController()), b = e.combinedSignal(m);
    if (w(ke, wh) || rt(ke, wh, c), w(ke, xh) ?? rt(ke, xh, u), window.addEventListener("pointerup", (Z) => {
      var g;
      w(ke, wh) === Z.pointerId ? this._endDraw(Z) : (g = w(ke, Sh)) == null || g.delete(Z.pointerId);
    }, {
      signal: b
    }), window.addEventListener("pointercancel", (Z) => {
      var g;
      w(ke, wh) === Z.pointerId ? this._currentParent.endDrawingSession() : (g = w(ke, Sh)) == null || g.delete(Z.pointerId);
    }, {
      signal: b
    }), window.addEventListener("pointerdown", (Z) => {
      w(ke, xh) === Z.pointerType && ((w(ke, Sh) || rt(ke, Sh, /* @__PURE__ */ new Set())).add(Z.pointerId), w(ke, or).isCancellable() && (w(ke, or).removeLastElement(), w(ke, or).isEmpty() ? this._currentParent.endDrawingSession(!0) : this._endDraw(null)));
    }, {
      capture: !0,
      passive: !1,
      signal: b
    }), window.addEventListener("contextmenu", al, {
      signal: b
    }), a.addEventListener("pointermove", this._drawMove.bind(this), {
      signal: b
    }), a.addEventListener("touchmove", (Z) => {
      Z.timeStamp === w(ke, _m) && ms(Z);
    }, {
      signal: b
    }), e.toggleDrawing(), (y = n._editorUndoBar) == null || y.hide(), w(ke, or)) {
      e.drawLayer.updateProperties(this._currentDrawId, w(ke, or).startNew(o, l, h, p, d));
      return;
    }
    n.updateUIForDefaultProperties(this), rt(ke, or, this.createDrawerInstance(o, l, h, p, d)), rt(ke, Hm, this.getDefaultDrawingOptions()), this._currentParent = e, {
      id: this._currentDrawId
    } = e.drawLayer.draw(this._mergeSVGProperties(w(ke, Hm).toSVGProperties(), w(ke, or).defaultSVGProperties), !0, !1);
  }
  static _drawMove(e) {
    var a;
    if (rt(ke, _m, -1), !w(ke, or))
      return;
    const {
      offsetX: n,
      offsetY: s,
      pointerId: r
    } = e;
    if (w(ke, wh) === r) {
      if (((a = w(ke, Sh)) == null ? void 0 : a.size) >= 1) {
        this._endDraw(e);
        return;
      }
      this._currentParent.drawLayer.updateProperties(this._currentDrawId, w(ke, or).add(n, s)), rt(ke, _m, e.timeStamp), ms(e);
    }
  }
  static _cleanup(e) {
    e && (this._currentDrawId = -1, this._currentParent = null, rt(ke, or, null), rt(ke, Hm, null), rt(ke, xh, null), rt(ke, _m, NaN)), w(ke, Km) && (w(ke, Km).abort(), rt(ke, Km, null), rt(ke, wh, NaN), rt(ke, Sh, null));
  }
  static _endDraw(e) {
    const n = this._currentParent;
    if (n) {
      if (n.toggleDrawing(!0), this._cleanup(!1), (e == null ? void 0 : e.target) === n.div && n.drawLayer.updateProperties(this._currentDrawId, w(ke, or).end(e.offsetX, e.offsetY)), this.supportMultipleDrawings) {
        const s = w(ke, or), r = this._currentDrawId, a = s.getLastElement();
        n.addCommands({
          cmd: () => {
            n.drawLayer.updateProperties(r, s.setLastElement(a));
          },
          undo: () => {
            n.drawLayer.updateProperties(r, s.removeLastElement());
          },
          mustExec: !1,
          type: Un.DRAW_STEP
        });
        return;
      }
      this.endDrawing(!1);
    }
  }
  static endDrawing(e) {
    const n = this._currentParent;
    if (!n)
      return null;
    if (n.toggleDrawing(!0), n.cleanUndoStack(Un.DRAW_STEP), !w(ke, or).isEmpty()) {
      const {
        pageDimensions: [s, r],
        scale: a
      } = n, o = n.createAndAddNewEditor({
        offsetX: 0,
        offsetY: 0
      }, !1, {
        drawId: this._currentDrawId,
        drawOutlines: w(ke, or).getOutlines(s * a, r * a, a, this._INNER_MARGIN),
        drawingOptions: w(ke, Hm),
        mustBeCommitted: !e
      });
      return this._cleanup(!0), o;
    }
    return n.drawLayer.remove(this._currentDrawId), this._cleanup(!0), null;
  }
  createDrawingOptions(e) {
  }
  static deserializeDraw(e, n, s, r, a, o) {
    Xi("Not implemented");
  }
  static async deserialize(e, n, s) {
    var d, h;
    const {
      rawDims: {
        pageWidth: r,
        pageHeight: a,
        pageX: o,
        pageY: l
      }
    } = n.viewport, c = this.deserializeDraw(o, l, r, a, this._INNER_MARGIN, e), u = await super.deserialize(e, n, s);
    return u.createDrawingOptions(e), ft(d = u, _n, NX).call(d, {
      drawOutlines: c
    }), ft(h = u, _n, By).call(h), u.onScaleChanging(), u.rotate(), u;
  }
  serializeDraw(e) {
    const [n, s] = this.pageTranslation, [r, a] = this.pageDimensions;
    return w(this, ho).serialize([n, s, r, a], e);
  }
  renderAnnotationElement(e) {
    return e.updateEdited({
      rect: this.getPDFRect()
    }), null;
  }
  static canCreateNewEmptyEditor() {
    return !1;
  }
};
ho = new WeakMap(), tg = new WeakMap(), or = new WeakMap(), Km = new WeakMap(), Hm = new WeakMap(), wh = new WeakMap(), xh = new WeakMap(), Sh = new WeakMap(), _m = new WeakMap(), _n = new WeakSet(), NX = function({
  drawOutlines: e,
  drawId: n,
  drawingOptions: s
}) {
  rt(this, ho, e), this._drawingOptions || (this._drawingOptions = s), this.annotationElementId || this._uiManager.a11yAlert(`pdfjs-editor-${this.editorType}-added-alert`), n >= 0 ? (this._drawId = n, this.parent.drawLayer.finalizeDraw(n, e.defaultProperties)) : this._drawId = ft(this, _n, WX).call(this, e, this.parent), ft(this, _n, Ky).call(this, e.box);
}, WX = function(e, n) {
  const {
    id: s
  } = n.drawLayer.draw(ke._mergeSVGProperties(this._drawingOptions.toSVGProperties(), e.defaultSVGProperties), !1, !1);
  return s;
}, GX = function() {
  this._drawId === null || !this.parent || (this.parent.drawLayer.remove(this._drawId), this._drawId = null, this._drawingOptions.reset());
}, By = function(e = this.parent) {
  if (!(this._drawId !== null && this.parent === e)) {
    if (this._drawId !== null) {
      this.parent.drawLayer.updateParent(this._drawId, e.drawLayer);
      return;
    }
    this._drawingOptions.updateAll(), this._drawId = ft(this, _n, WX).call(this, w(this, ho), e);
  }
}, g4 = function([e, n, s, r]) {
  const {
    parentDimensions: [a, o],
    rotation: l
  } = this;
  switch (l) {
    case 90:
      return [n, 1 - e, s * (o / a), r * (a / o)];
    case 180:
      return [1 - e, 1 - n, s, r];
    case 270:
      return [1 - n, e, s * (o / a), r * (a / o)];
    default:
      return [e, n, s, r];
  }
}, KN = function() {
  const {
    x: e,
    y: n,
    width: s,
    height: r,
    parentDimensions: [a, o],
    rotation: l
  } = this;
  switch (l) {
    case 90:
      return [1 - n, e, s * (a / o), r * (o / a)];
    case 180:
      return [1 - e, 1 - n, s, r];
    case 270:
      return [n, 1 - e, s * (a / o), r * (o / a)];
    default:
      return [e, n, s, r];
  }
}, Ky = function(e) {
  [this.x, this.y, this.width, this.height] = ft(this, _n, g4).call(this, e), this.div && (this.fixAndSetPosition(), this.setDims()), this._onResized();
}, fb = function() {
  const {
    x: e,
    y: n,
    width: s,
    height: r,
    rotation: a,
    parentRotation: o,
    parentDimensions: [l, c]
  } = this;
  switch ((a * 4 + o) / 90) {
    case 1:
      return [1 - n - r, e, r, s];
    case 2:
      return [1 - e - s, 1 - n - r, s, r];
    case 3:
      return [n, 1 - e - s, r, s];
    case 4:
      return [e, n - s * (l / c), r * (c / l), s * (l / c)];
    case 5:
      return [1 - n, e, s * (l / c), r * (c / l)];
    case 6:
      return [1 - e - r * (c / l), 1 - n, r * (c / l), s * (l / c)];
    case 7:
      return [n - s * (l / c), 1 - e - r * (c / l), s * (l / c), r * (c / l)];
    case 8:
      return [e - s, n - r, s, r];
    case 9:
      return [1 - n, e - s, r, s];
    case 10:
      return [1 - e, 1 - n, s, r];
    case 11:
      return [n - r, 1 - e, r, s];
    case 12:
      return [e - r * (c / l), n, r * (c / l), s * (l / c)];
    case 13:
      return [1 - n - s * (l / c), e - r * (c / l), s * (l / c), r * (c / l)];
    case 14:
      return [1 - e, 1 - n - s * (l / c), r * (c / l), s * (l / c)];
    case 15:
      return [n, 1 - e, s * (l / c), r * (c / l)];
    default:
      return [e, n, s, r];
  }
}, S(ke, "_currentDrawId", -1), S(ke, "_currentParent", null), pt(ke, or, null), pt(ke, Km, null), pt(ke, Hm, null), pt(ke, wh, NaN), pt(ke, xh, null), pt(ke, Sh, null), pt(ke, _m, NaN), S(ke, "_INNER_MARGIN", 3);
let iG = ke;
var Sc, lr, cr, Qm, eg, ya, Sr, Ho, $m, qm, t0, ng, HN;
class JCt {
  constructor(t, e, n, s, r, a) {
    pt(this, ng);
    pt(this, Sc, new Float64Array(6));
    pt(this, lr);
    pt(this, cr);
    pt(this, Qm);
    pt(this, eg);
    pt(this, ya);
    pt(this, Sr, "");
    pt(this, Ho, 0);
    pt(this, $m, new t1());
    pt(this, qm);
    pt(this, t0);
    rt(this, qm, n), rt(this, t0, s), rt(this, Qm, r), rt(this, eg, a), [t, e] = ft(this, ng, HN).call(this, t, e);
    const o = rt(this, lr, [NaN, NaN, NaN, NaN, t, e]);
    rt(this, ya, [t, e]), rt(this, cr, [{
      line: o,
      points: w(this, ya)
    }]), w(this, Sc).set(o, 0);
  }
  updateProperty(t, e) {
    t === "stroke-width" && rt(this, eg, e);
  }
  isEmpty() {
    return !w(this, cr) || w(this, cr).length === 0;
  }
  isCancellable() {
    return w(this, ya).length <= 10;
  }
  add(t, e) {
    [t, e] = ft(this, ng, HN).call(this, t, e);
    const [n, s, r, a] = w(this, Sc).subarray(2, 6), o = t - r, l = e - a;
    return Math.hypot(w(this, qm) * o, w(this, t0) * l) <= 2 ? null : (w(this, ya).push(t, e), isNaN(n) ? (w(this, Sc).set([r, a, t, e], 2), w(this, lr).push(NaN, NaN, NaN, NaN, t, e), {
      path: {
        d: this.toSVGPath()
      }
    }) : (isNaN(w(this, Sc)[0]) && w(this, lr).splice(6, 6), w(this, Sc).set([n, s, r, a, t, e], 0), w(this, lr).push(...De.createBezierPoints(n, s, r, a, t, e)), {
      path: {
        d: this.toSVGPath()
      }
    }));
  }
  end(t, e) {
    const n = this.add(t, e);
    return n || (w(this, ya).length === 2 ? {
      path: {
        d: this.toSVGPath()
      }
    } : null);
  }
  startNew(t, e, n, s, r) {
    rt(this, qm, n), rt(this, t0, s), rt(this, Qm, r), [t, e] = ft(this, ng, HN).call(this, t, e);
    const a = rt(this, lr, [NaN, NaN, NaN, NaN, t, e]);
    rt(this, ya, [t, e]);
    const o = w(this, cr).at(-1);
    return o && (o.line = new Float32Array(o.line), o.points = new Float32Array(o.points)), w(this, cr).push({
      line: a,
      points: w(this, ya)
    }), w(this, Sc).set(a, 0), rt(this, Ho, 0), this.toSVGPath(), null;
  }
  getLastElement() {
    return w(this, cr).at(-1);
  }
  setLastElement(t) {
    return w(this, cr) ? (w(this, cr).push(t), rt(this, lr, t.line), rt(this, ya, t.points), rt(this, Ho, 0), {
      path: {
        d: this.toSVGPath()
      }
    }) : w(this, $m).setLastElement(t);
  }
  removeLastElement() {
    if (!w(this, cr))
      return w(this, $m).removeLastElement();
    w(this, cr).pop(), rt(this, Sr, "");
    for (let t = 0, e = w(this, cr).length; t < e; t++) {
      const {
        line: n,
        points: s
      } = w(this, cr)[t];
      rt(this, lr, n), rt(this, ya, s), rt(this, Ho, 0), this.toSVGPath();
    }
    return {
      path: {
        d: w(this, Sr)
      }
    };
  }
  toSVGPath() {
    const t = De.svgRound(w(this, lr)[4]), e = De.svgRound(w(this, lr)[5]);
    if (w(this, ya).length === 2)
      return rt(this, Sr, `${w(this, Sr)} M ${t} ${e} Z`), w(this, Sr);
    if (w(this, ya).length <= 6) {
      const s = w(this, Sr).lastIndexOf("M");
      rt(this, Sr, `${w(this, Sr).slice(0, s)} M ${t} ${e}`), rt(this, Ho, 6);
    }
    if (w(this, ya).length === 4) {
      const s = De.svgRound(w(this, lr)[10]), r = De.svgRound(w(this, lr)[11]);
      return rt(this, Sr, `${w(this, Sr)} L ${s} ${r}`), rt(this, Ho, 12), w(this, Sr);
    }
    const n = [];
    w(this, Ho) === 0 && (n.push(`M ${t} ${e}`), rt(this, Ho, 6));
    for (let s = w(this, Ho), r = w(this, lr).length; s < r; s += 6) {
      const [a, o, l, c, u, d] = w(this, lr).slice(s, s + 6).map(De.svgRound);
      n.push(`C${a} ${o} ${l} ${c} ${u} ${d}`);
    }
    return rt(this, Sr, w(this, Sr) + n.join(" ")), rt(this, Ho, w(this, lr).length), w(this, Sr);
  }
  getOutlines(t, e, n, s) {
    const r = w(this, cr).at(-1);
    return r.line = new Float32Array(r.line), r.points = new Float32Array(r.points), w(this, $m).build(w(this, cr), t, e, n, w(this, Qm), w(this, eg), s), rt(this, Sc, null), rt(this, lr, null), rt(this, cr, null), rt(this, Sr, null), w(this, $m);
  }
  get defaultSVGProperties() {
    return {
      root: {
        viewBox: "0 0 10000 10000"
      },
      rootClass: {
        draw: !0
      },
      bbox: [0, 0, 1, 1]
    };
  }
}
Sc = new WeakMap(), lr = new WeakMap(), cr = new WeakMap(), Qm = new WeakMap(), eg = new WeakMap(), ya = new WeakMap(), Sr = new WeakMap(), Ho = new WeakMap(), $m = new WeakMap(), qm = new WeakMap(), t0 = new WeakMap(), ng = new WeakSet(), HN = function(t, e) {
  return De._normalizePoint(t, e, w(this, qm), w(this, t0), w(this, Qm));
};
var Za, TT, MT, po, Lc, Vc, ig, sg, e0, Ir, ou, y4, Z4, T4;
class t1 extends De {
  constructor() {
    super(...arguments);
    pt(this, Ir);
    pt(this, Za);
    pt(this, TT, 0);
    pt(this, MT);
    pt(this, po);
    pt(this, Lc);
    pt(this, Vc);
    pt(this, ig);
    pt(this, sg);
    pt(this, e0);
  }
  build(e, n, s, r, a, o, l) {
    rt(this, Lc, n), rt(this, Vc, s), rt(this, ig, r), rt(this, sg, a), rt(this, e0, o), rt(this, MT, l ?? 0), rt(this, po, e), ft(this, Ir, Z4).call(this);
  }
  get thickness() {
    return w(this, e0);
  }
  setLastElement(e) {
    return w(this, po).push(e), {
      path: {
        d: this.toSVGPath()
      }
    };
  }
  removeLastElement() {
    return w(this, po).pop(), {
      path: {
        d: this.toSVGPath()
      }
    };
  }
  toSVGPath() {
    const e = [];
    for (const {
      line: n
    } of w(this, po)) {
      if (e.push(`M${De.svgRound(n[4])} ${De.svgRound(n[5])}`), n.length === 6) {
        e.push("Z");
        continue;
      }
      if (n.length === 12 && isNaN(n[6])) {
        e.push(`L${De.svgRound(n[10])} ${De.svgRound(n[11])}`);
        continue;
      }
      for (let s = 6, r = n.length; s < r; s += 6) {
        const [a, o, l, c, u, d] = n.subarray(s, s + 6).map(De.svgRound);
        e.push(`C${a} ${o} ${l} ${c} ${u} ${d}`);
      }
    }
    return e.join("");
  }
  serialize([e, n, s, r], a) {
    const o = [], l = [], [c, u, d, h] = ft(this, Ir, y4).call(this);
    let p, m, b, y, Z, g, f, T, M;
    switch (w(this, sg)) {
      case 0:
        M = De._rescale, p = e, m = n + r, b = s, y = -r, Z = e + c * s, g = n + (1 - u - h) * r, f = e + (c + d) * s, T = n + (1 - u) * r;
        break;
      case 90:
        M = De._rescaleAndSwap, p = e, m = n, b = s, y = r, Z = e + u * s, g = n + c * r, f = e + (u + h) * s, T = n + (c + d) * r;
        break;
      case 180:
        M = De._rescale, p = e + s, m = n, b = -s, y = r, Z = e + (1 - c - d) * s, g = n + u * r, f = e + (1 - c) * s, T = n + (u + h) * r;
        break;
      case 270:
        M = De._rescaleAndSwap, p = e + s, m = n + r, b = -s, y = -r, Z = e + (1 - u - h) * s, g = n + (1 - c - d) * r, f = e + (1 - u) * s, T = n + (1 - c) * r;
        break;
    }
    for (const {
      line: N,
      points: W
    } of w(this, po))
      o.push(M(N, p, m, b, y, a ? new Array(N.length) : null)), l.push(M(W, p, m, b, y, a ? new Array(W.length) : null));
    return {
      lines: o,
      points: l,
      rect: [Z, g, f, T]
    };
  }
  static deserialize(e, n, s, r, a, {
    paths: {
      lines: o,
      points: l
    },
    rotation: c,
    thickness: u
  }) {
    const d = [];
    let h, p, m, b, y;
    switch (c) {
      case 0:
        y = De._rescale, h = -e / s, p = n / r + 1, m = 1 / s, b = -1 / r;
        break;
      case 90:
        y = De._rescaleAndSwap, h = -n / r, p = -e / s, m = 1 / r, b = 1 / s;
        break;
      case 180:
        y = De._rescale, h = e / s + 1, p = -n / r, m = -1 / s, b = 1 / r;
        break;
      case 270:
        y = De._rescaleAndSwap, h = n / r + 1, p = e / s + 1, m = -1 / r, b = -1 / s;
        break;
    }
    if (!o) {
      o = [];
      for (const g of l) {
        const f = g.length;
        if (f === 2) {
          o.push(new Float32Array([NaN, NaN, NaN, NaN, g[0], g[1]]));
          continue;
        }
        if (f === 4) {
          o.push(new Float32Array([NaN, NaN, NaN, NaN, g[0], g[1], NaN, NaN, NaN, NaN, g[2], g[3]]));
          continue;
        }
        const T = new Float32Array(3 * (f - 2));
        o.push(T);
        let [M, N, W, x] = g.subarray(0, 4);
        T.set([NaN, NaN, NaN, NaN, M, N], 0);
        for (let V = 4; V < f; V += 2) {
          const X = g[V], C = g[V + 1];
          T.set(De.createBezierPoints(M, N, W, x, X, C), (V - 2) * 3), [M, N, W, x] = [W, x, X, C];
        }
      }
    }
    for (let g = 0, f = o.length; g < f; g++)
      d.push({
        line: y(o[g].map((T) => T ?? NaN), h, p, m, b),
        points: y(l[g].map((T) => T ?? NaN), h, p, m, b)
      });
    const Z = new this.prototype.constructor();
    return Z.build(d, s, r, 1, c, u, a), Z;
  }
  get box() {
    return w(this, Za);
  }
  updateProperty(e, n) {
    return e === "stroke-width" ? ft(this, Ir, T4).call(this, n) : null;
  }
  updateParentDimensions([e, n], s) {
    const [r, a] = ft(this, Ir, ou).call(this);
    rt(this, Lc, e), rt(this, Vc, n), rt(this, ig, s);
    const [o, l] = ft(this, Ir, ou).call(this), c = o - r, u = l - a, d = w(this, Za);
    return d[0] -= c, d[1] -= u, d[2] += 2 * c, d[3] += 2 * u, d;
  }
  updateRotation(e) {
    return rt(this, TT, e), {
      path: {
        transform: this.rotationTransform
      }
    };
  }
  get viewBox() {
    return w(this, Za).map(De.svgRound).join(" ");
  }
  get defaultProperties() {
    const [e, n] = w(this, Za);
    return {
      root: {
        viewBox: this.viewBox
      },
      path: {
        "transform-origin": `${De.svgRound(e)} ${De.svgRound(n)}`
      }
    };
  }
  get rotationTransform() {
    const [, , e, n] = w(this, Za);
    let s = 0, r = 0, a = 0, o = 0, l = 0, c = 0;
    switch (w(this, TT)) {
      case 90:
        r = n / e, a = -e / n, l = e;
        break;
      case 180:
        s = -1, o = -1, l = e, c = n;
        break;
      case 270:
        r = -n / e, a = e / n, c = n;
        break;
      default:
        return "";
    }
    return `matrix(${s} ${r} ${a} ${o} ${De.svgRound(l)} ${De.svgRound(c)})`;
  }
  getPathResizingSVGProperties([e, n, s, r]) {
    const [a, o] = ft(this, Ir, ou).call(this), [l, c, u, d] = w(this, Za);
    if (Math.abs(u - a) <= De.PRECISION || Math.abs(d - o) <= De.PRECISION) {
      const y = e + s / 2 - (l + u / 2), Z = n + r / 2 - (c + d / 2);
      return {
        path: {
          "transform-origin": `${De.svgRound(e)} ${De.svgRound(n)}`,
          transform: `${this.rotationTransform} translate(${y} ${Z})`
        }
      };
    }
    const h = (s - 2 * a) / (u - 2 * a), p = (r - 2 * o) / (d - 2 * o), m = u / s, b = d / r;
    return {
      path: {
        "transform-origin": `${De.svgRound(l)} ${De.svgRound(c)}`,
        transform: `${this.rotationTransform} scale(${m} ${b}) translate(${De.svgRound(a)} ${De.svgRound(o)}) scale(${h} ${p}) translate(${De.svgRound(-a)} ${De.svgRound(-o)})`
      }
    };
  }
  getPathResizedSVGProperties([e, n, s, r]) {
    const [a, o] = ft(this, Ir, ou).call(this), l = w(this, Za), [c, u, d, h] = l;
    if (l[0] = e, l[1] = n, l[2] = s, l[3] = r, Math.abs(d - a) <= De.PRECISION || Math.abs(h - o) <= De.PRECISION) {
      const Z = e + s / 2 - (c + d / 2), g = n + r / 2 - (u + h / 2);
      for (const {
        line: f,
        points: T
      } of w(this, po))
        De._translate(f, Z, g, f), De._translate(T, Z, g, T);
      return {
        root: {
          viewBox: this.viewBox
        },
        path: {
          "transform-origin": `${De.svgRound(e)} ${De.svgRound(n)}`,
          transform: this.rotationTransform || null,
          d: this.toSVGPath()
        }
      };
    }
    const p = (s - 2 * a) / (d - 2 * a), m = (r - 2 * o) / (h - 2 * o), b = -p * (c + a) + e + a, y = -m * (u + o) + n + o;
    if (p !== 1 || m !== 1 || b !== 0 || y !== 0)
      for (const {
        line: Z,
        points: g
      } of w(this, po))
        De._rescale(Z, b, y, p, m, Z), De._rescale(g, b, y, p, m, g);
    return {
      root: {
        viewBox: this.viewBox
      },
      path: {
        "transform-origin": `${De.svgRound(e)} ${De.svgRound(n)}`,
        transform: this.rotationTransform || null,
        d: this.toSVGPath()
      }
    };
  }
  getPathTranslatedSVGProperties([e, n], s) {
    const [r, a] = s, o = w(this, Za), l = e - o[0], c = n - o[1];
    if (w(this, Lc) === r && w(this, Vc) === a)
      for (const {
        line: u,
        points: d
      } of w(this, po))
        De._translate(u, l, c, u), De._translate(d, l, c, d);
    else {
      const u = w(this, Lc) / r, d = w(this, Vc) / a;
      rt(this, Lc, r), rt(this, Vc, a);
      for (const {
        line: h,
        points: p
      } of w(this, po))
        De._rescale(h, l, c, u, d, h), De._rescale(p, l, c, u, d, p);
      o[2] *= u, o[3] *= d;
    }
    return o[0] = e, o[1] = n, {
      root: {
        viewBox: this.viewBox
      },
      path: {
        d: this.toSVGPath(),
        "transform-origin": `${De.svgRound(e)} ${De.svgRound(n)}`
      }
    };
  }
  get defaultSVGProperties() {
    const e = w(this, Za);
    return {
      root: {
        viewBox: this.viewBox
      },
      rootClass: {
        draw: !0
      },
      path: {
        d: this.toSVGPath(),
        "transform-origin": `${De.svgRound(e[0])} ${De.svgRound(e[1])}`,
        transform: this.rotationTransform || null
      },
      bbox: e
    };
  }
}
Za = new WeakMap(), TT = new WeakMap(), MT = new WeakMap(), po = new WeakMap(), Lc = new WeakMap(), Vc = new WeakMap(), ig = new WeakMap(), sg = new WeakMap(), e0 = new WeakMap(), Ir = new WeakSet(), ou = function(e = w(this, e0)) {
  const n = w(this, MT) + e / 2 * w(this, ig);
  return w(this, sg) % 180 === 0 ? [n / w(this, Lc), n / w(this, Vc)] : [n / w(this, Vc), n / w(this, Lc)];
}, y4 = function() {
  const [e, n, s, r] = w(this, Za), [a, o] = ft(this, Ir, ou).call(this, 0);
  return [e + a, n + o, s - 2 * a, r - 2 * o];
}, Z4 = function() {
  const e = rt(this, Za, new Float32Array([1 / 0, 1 / 0, -1 / 0, -1 / 0]));
  for (const {
    line: r
  } of w(this, po)) {
    if (r.length <= 12) {
      for (let l = 4, c = r.length; l < c; l += 6)
        ze.pointBoundingBox(r[l], r[l + 1], e);
      continue;
    }
    let a = r[4], o = r[5];
    for (let l = 6, c = r.length; l < c; l += 6) {
      const [u, d, h, p, m, b] = r.subarray(l, l + 6);
      ze.bezierBoundingBox(a, o, u, d, h, p, m, b, e), a = m, o = b;
    }
  }
  const [n, s] = ft(this, Ir, ou).call(this);
  e[0] = Na(e[0] - n, 0, 1), e[1] = Na(e[1] - s, 0, 1), e[2] = Na(e[2] + n, 0, 1), e[3] = Na(e[3] + s, 0, 1), e[2] -= e[0], e[3] -= e[1];
}, T4 = function(e) {
  const [n, s] = ft(this, Ir, ou).call(this);
  rt(this, e0, e);
  const [r, a] = ft(this, Ir, ou).call(this), [o, l] = [r - n, a - s], c = w(this, Za);
  return c[0] -= o, c[1] -= l, c[2] += 2 * o, c[3] += 2 * l, c;
};
class yw extends f4 {
  constructor(t) {
    super(), this._viewParameters = t, super.updateProperties({
      fill: "none",
      stroke: Di._defaultLineColor,
      "stroke-opacity": 1,
      "stroke-width": 1,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": 10
    });
  }
  updateSVGProperty(t, e) {
    t === "stroke-width" && (e ?? (e = this["stroke-width"]), e *= this._viewParameters.realScale), super.updateSVGProperty(t, e);
  }
  clone() {
    const t = new yw(this._viewParameters);
    return t.updateAll(this), t;
  }
}
var WG, M4;
const Lb = class Lb extends iG {
  constructor(e) {
    super({
      ...e,
      name: "inkEditor"
    });
    pt(this, WG);
    this._willKeepAspectRatio = !0, this.defaultL10nId = "pdfjs-editor-ink-editor";
  }
  static initialize(e, n) {
    Di.initialize(e, n), this._defaultDrawingOptions = new yw(n.viewParameters);
  }
  static getDefaultDrawingOptions(e) {
    const n = this._defaultDrawingOptions.clone();
    return n.updateProperties(e), n;
  }
  static get supportMultipleDrawings() {
    return !0;
  }
  static get typesMap() {
    return Gn(this, "typesMap", /* @__PURE__ */ new Map([[Un.INK_THICKNESS, "stroke-width"], [Un.INK_COLOR, "stroke"], [Un.INK_OPACITY, "stroke-opacity"]]));
  }
  static createDrawerInstance(e, n, s, r, a) {
    return new JCt(e, n, s, r, a, this._defaultDrawingOptions["stroke-width"]);
  }
  static deserializeDraw(e, n, s, r, a, o) {
    return t1.deserialize(e, n, s, r, a, o);
  }
  static async deserialize(e, n, s) {
    let r = null;
    if (e instanceof sY) {
      const {
        data: {
          inkLists: o,
          rect: l,
          rotation: c,
          id: u,
          color: d,
          opacity: h,
          borderStyle: {
            rawWidth: p
          },
          popupRef: m,
          richText: b,
          contentsObj: y,
          creationDate: Z,
          modificationDate: g
        },
        parent: {
          page: {
            pageNumber: f
          }
        }
      } = e;
      r = e = {
        annotationType: fn.INK,
        color: Array.from(d),
        thickness: p,
        opacity: h,
        paths: {
          points: o
        },
        boxes: null,
        pageIndex: f - 1,
        rect: l.slice(0),
        rotation: c,
        annotationElementId: u,
        id: u,
        deleted: !1,
        popupRef: m,
        richText: b,
        comment: (y == null ? void 0 : y.str) || null,
        creationDate: Z,
        modificationDate: g
      };
    }
    const a = await super.deserialize(e, n, s);
    return a._initialData = r, e.comment && a.setCommentData(e), a;
  }
  get toolbarButtons() {
    return this._colorPicker || (this._colorPicker = new $W(this)), [["colorPicker", this._colorPicker]];
  }
  get colorType() {
    return Un.INK_COLOR;
  }
  get color() {
    return this._drawingOptions.stroke;
  }
  get opacity() {
    return this._drawingOptions["stroke-opacity"];
  }
  onScaleChanging() {
    if (!this.parent)
      return;
    super.onScaleChanging();
    const {
      _drawId: e,
      _drawingOptions: n,
      parent: s
    } = this;
    n.updateSVGProperty("stroke-width"), s.drawLayer.updateProperties(e, n.toSVGProperties());
  }
  static onScaleChangingWhenDrawing() {
    const e = this._currentParent;
    e && (super.onScaleChangingWhenDrawing(), this._defaultDrawingOptions.updateSVGProperty("stroke-width"), e.drawLayer.updateProperties(this._currentDrawId, this._defaultDrawingOptions.toSVGProperties()));
  }
  createDrawingOptions({
    color: e,
    thickness: n,
    opacity: s
  }) {
    this._drawingOptions = Lb.getDefaultDrawingOptions({
      stroke: ze.makeHexColor(...e),
      "stroke-width": n,
      "stroke-opacity": s
    });
  }
  serialize(e = !1) {
    if (this.isEmpty())
      return null;
    if (this.deleted)
      return this.serializeDeleted();
    const {
      lines: n,
      points: s
    } = this.serializeDraw(e), {
      _drawingOptions: {
        stroke: r,
        "stroke-opacity": a,
        "stroke-width": o
      }
    } = this, l = Object.assign(super.serialize(e), {
      color: Di._colorManager.convert(r),
      opacity: a,
      thickness: o,
      paths: {
        lines: n,
        points: s
      }
    });
    return this.addComment(l), e ? (l.isCopy = !0, l) : this.annotationElementId && !ft(this, WG, M4).call(this, l) ? null : (l.id = this.annotationElementId, l);
  }
  renderAnnotationElement(e) {
    if (this.deleted)
      return e.hide(), null;
    const {
      points: n,
      rect: s
    } = this.serializeDraw(!1);
    return e.updateEdited({
      rect: s,
      thickness: this._drawingOptions["stroke-width"],
      points: n,
      popup: this.comment
    }), null;
  }
};
WG = new WeakSet(), M4 = function(e) {
  const {
    color: n,
    thickness: s,
    opacity: r,
    pageIndex: a
  } = this._initialData;
  return this.hasEditedComment || this._hasBeenMoved || this._hasBeenResized || e.color.some((o, l) => o !== n[l]) || e.thickness !== s || e.opacity !== r || e.pageIndex !== a;
}, S(Lb, "_type", "ink"), S(Lb, "_editorType", fn.INK), S(Lb, "_defaultDrawingOptions", null);
let wX = Lb;
class xX extends t1 {
  toSVGPath() {
    let t = super.toSVGPath();
    return t.endsWith("Z") || (t += "Z"), t;
  }
}
const JM = 8, py = 3;
var n0, ci, SX, Sl, N4, W4, LX, _N, G4, w4, x4, VX, XX, S4;
class Qu {
  static extractContoursFromText(t, {
    fontFamily: e,
    fontStyle: n,
    fontWeight: s
  }, r, a, o, l) {
    let c = new OffscreenCanvas(1, 1), u = c.getContext("2d", {
      alpha: !1
    });
    const d = 200, h = u.font = `${n} ${s} ${d}px ${e}`, {
      actualBoundingBoxLeft: p,
      actualBoundingBoxRight: m,
      actualBoundingBoxAscent: b,
      actualBoundingBoxDescent: y,
      fontBoundingBoxAscent: Z,
      fontBoundingBoxDescent: g,
      width: f
    } = u.measureText(t), T = 1.5, M = Math.ceil(Math.max(Math.abs(p) + Math.abs(m) || 0, f) * T), N = Math.ceil(Math.max(Math.abs(b) + Math.abs(y) || d, Math.abs(Z) + Math.abs(g) || d) * T);
    c = new OffscreenCanvas(M, N), u = c.getContext("2d", {
      alpha: !0,
      willReadFrequently: !0
    }), u.font = h, u.filter = "grayscale(1)", u.fillStyle = "white", u.fillRect(0, 0, M, N), u.fillStyle = "black", u.fillText(t, M * (T - 1) / 2, N * (3 - T) / 2);
    const W = ft(this, ci, VX).call(this, u.getImageData(0, 0, M, N).data), x = ft(this, ci, x4).call(this, W), V = ft(this, ci, XX).call(this, x), X = ft(this, ci, LX).call(this, W, M, N, V);
    return this.processDrawnLines({
      lines: {
        curves: X,
        width: M,
        height: N
      },
      pageWidth: r,
      pageHeight: a,
      rotation: o,
      innerMargin: l,
      mustSmooth: !0,
      areContours: !0
    });
  }
  static process(t, e, n, s, r) {
    const [a, o, l] = ft(this, ci, S4).call(this, t), [c, u] = ft(this, ci, w4).call(this, a, o, l, Math.hypot(o, l) * w(this, n0).sigmaSFactor, w(this, n0).sigmaR, w(this, n0).kernelSize), d = ft(this, ci, XX).call(this, u), h = ft(this, ci, LX).call(this, c, o, l, d);
    return this.processDrawnLines({
      lines: {
        curves: h,
        width: o,
        height: l
      },
      pageWidth: e,
      pageHeight: n,
      rotation: s,
      innerMargin: r,
      mustSmooth: !0,
      areContours: !0
    });
  }
  static processDrawnLines({
    lines: t,
    pageWidth: e,
    pageHeight: n,
    rotation: s,
    innerMargin: r,
    mustSmooth: a,
    areContours: o
  }) {
    s % 180 !== 0 && ([e, n] = [n, e]);
    const {
      curves: l,
      width: c,
      height: u
    } = t, d = t.thickness ?? 0, h = [], p = Math.min(e / c, n / u), m = p / e, b = p / n, y = [];
    for (const {
      points: g
    } of l) {
      const f = a ? ft(this, ci, G4).call(this, g) : g;
      if (!f)
        continue;
      y.push(f);
      const T = f.length, M = new Float32Array(T), N = new Float32Array(3 * (T === 2 ? 2 : T - 2));
      if (h.push({
        line: N,
        points: M
      }), T === 2) {
        M[0] = f[0] * m, M[1] = f[1] * b, N.set([NaN, NaN, NaN, NaN, M[0], M[1]], 0);
        continue;
      }
      let [W, x, V, X] = f;
      W *= m, x *= b, V *= m, X *= b, M.set([W, x, V, X], 0), N.set([NaN, NaN, NaN, NaN, W, x], 0);
      for (let C = 4; C < T; C += 2) {
        const R = M[C] = f[C] * m, z = M[C + 1] = f[C + 1] * b;
        N.set(De.createBezierPoints(W, x, V, X, R, z), (C - 2) * 3), [W, x, V, X] = [V, X, R, z];
      }
    }
    if (h.length === 0)
      return null;
    const Z = o ? new xX() : new t1();
    return Z.build(h, e, n, 1, s, o ? 0 : d, r), {
      outline: Z,
      newCurves: y,
      areContours: o,
      thickness: d,
      width: c,
      height: u
    };
  }
  static async compressSignature({
    outlines: t,
    areContours: e,
    thickness: n,
    width: s,
    height: r
  }) {
    let a = 1 / 0, o = -1 / 0, l = 0;
    for (const f of t) {
      l += f.length;
      for (let T = 2, M = f.length; T < M; T++) {
        const N = f[T] - f[T - 2];
        a = Math.min(a, N), o = Math.max(o, N);
      }
    }
    let c;
    a >= -128 && o <= 127 ? c = Int8Array : a >= -32768 && o <= 32767 ? c = Int16Array : c = Int32Array;
    const u = t.length, d = JM + py * u, h = new Uint32Array(d);
    let p = 0;
    h[p++] = d * Uint32Array.BYTES_PER_ELEMENT + (l - 2 * u) * c.BYTES_PER_ELEMENT, h[p++] = 0, h[p++] = s, h[p++] = r, h[p++] = e ? 0 : 1, h[p++] = Math.max(0, Math.floor(n ?? 0)), h[p++] = u, h[p++] = c.BYTES_PER_ELEMENT;
    for (const f of t)
      h[p++] = f.length - 2, h[p++] = f[0], h[p++] = f[1];
    const m = new CompressionStream("deflate-raw"), b = m.writable.getWriter();
    await b.ready, b.write(h);
    const y = c.prototype.constructor;
    for (const f of t) {
      const T = new y(f.length - 2);
      for (let M = 2, N = f.length; M < N; M++)
        T[M - 2] = f[M] - f[M - 2];
      b.write(T);
    }
    b.close();
    const Z = await new Response(m.readable).arrayBuffer(), g = new Uint8Array(Z);
    return VB(g);
  }
  static async decompressSignature(t) {
    try {
      const e = oIt(t), {
        readable: n,
        writable: s
      } = new DecompressionStream("deflate-raw"), r = s.getWriter();
      await r.ready, r.write(e).then(async () => {
        await r.ready, await r.close();
      }).catch(() => {
      });
      let a = null, o = 0;
      for await (const f of n)
        a || (a = new Uint8Array(new Uint32Array(f.buffer, 0, 4)[0])), a.set(f, o), o += f.length;
      const l = new Uint32Array(a.buffer, 0, a.length >> 2), c = l[1];
      if (c !== 0)
        throw new Error(`Invalid version: ${c}`);
      const u = l[2], d = l[3], h = l[4] === 0, p = l[5], m = l[6], b = l[7], y = [], Z = (JM + py * m) * Uint32Array.BYTES_PER_ELEMENT;
      let g;
      switch (b) {
        case Int8Array.BYTES_PER_ELEMENT:
          g = new Int8Array(a.buffer, Z);
          break;
        case Int16Array.BYTES_PER_ELEMENT:
          g = new Int16Array(a.buffer, Z);
          break;
        case Int32Array.BYTES_PER_ELEMENT:
          g = new Int32Array(a.buffer, Z);
          break;
      }
      o = 0;
      for (let f = 0; f < m; f++) {
        const T = l[py * f + JM], M = new Float32Array(T + 2);
        y.push(M);
        for (let N = 0; N < py - 1; N++)
          M[N] = l[py * f + JM + N + 1];
        for (let N = 0; N < T; N++)
          M[N + 2] = M[N] + g[o++];
      }
      return {
        areContours: h,
        thickness: p,
        outlines: y,
        width: u,
        height: d
      };
    } catch (e) {
      return pn(`decompressSignature: ${e}`), null;
    }
  }
}
n0 = new WeakMap(), ci = new WeakSet(), SX = function(t, e, n, s) {
  return n -= t, s -= e, n === 0 ? s > 0 ? 0 : 4 : n === 1 ? s + 6 : 2 - s;
}, Sl = new WeakMap(), N4 = function(t, e, n, s, r, a, o) {
  const l = ft(this, ci, SX).call(this, n, s, r, a);
  for (let c = 0; c < 8; c++) {
    const u = (-c + l - o + 16) % 8, d = w(this, Sl)[2 * u], h = w(this, Sl)[2 * u + 1];
    if (t[(n + d) * e + (s + h)] !== 0)
      return u;
  }
  return -1;
}, W4 = function(t, e, n, s, r, a, o) {
  const l = ft(this, ci, SX).call(this, n, s, r, a);
  for (let c = 0; c < 8; c++) {
    const u = (c + l + o + 16) % 8, d = w(this, Sl)[2 * u], h = w(this, Sl)[2 * u + 1];
    if (t[(n + d) * e + (s + h)] !== 0)
      return u;
  }
  return -1;
}, LX = function(t, e, n, s) {
  const r = t.length, a = new Int32Array(r);
  for (let u = 0; u < r; u++)
    a[u] = t[u] <= s ? 1 : 0;
  for (let u = 1; u < n - 1; u++)
    a[u * e] = a[u * e + e - 1] = 0;
  for (let u = 0; u < e; u++)
    a[u] = a[e * n - 1 - u] = 0;
  let o = 1, l;
  const c = [];
  for (let u = 1; u < n - 1; u++) {
    l = 1;
    for (let d = 1; d < e - 1; d++) {
      const h = u * e + d, p = a[h];
      if (p === 0)
        continue;
      let m = u, b = d;
      if (p === 1 && a[h - 1] === 0)
        o += 1, b -= 1;
      else if (p >= 1 && a[h + 1] === 0)
        o += 1, b += 1, p > 1 && (l = p);
      else {
        p !== 1 && (l = Math.abs(p));
        continue;
      }
      const y = [d, u], Z = b === d + 1, g = {
        isHole: Z,
        points: y,
        id: o,
        parent: 0
      };
      c.push(g);
      let f;
      for (const C of c)
        if (C.id === l) {
          f = C;
          break;
        }
      f ? f.isHole ? g.parent = Z ? f.parent : l : g.parent = Z ? l : f.parent : g.parent = Z ? l : 0;
      const T = ft(this, ci, N4).call(this, a, e, u, d, m, b, 0);
      if (T === -1) {
        a[h] = -o, a[h] !== 1 && (l = Math.abs(a[h]));
        continue;
      }
      let M = w(this, Sl)[2 * T], N = w(this, Sl)[2 * T + 1];
      const W = u + M, x = d + N;
      m = W, b = x;
      let V = u, X = d;
      for (; ; ) {
        const C = ft(this, ci, W4).call(this, a, e, V, X, m, b, 1);
        M = w(this, Sl)[2 * C], N = w(this, Sl)[2 * C + 1];
        const R = V + M, z = X + N;
        y.push(z, R);
        const F = V * e + X;
        if (a[F + 1] === 0 ? a[F] = -o : a[F] === 1 && (a[F] = o), R === u && z === d && V === W && X === x) {
          a[h] !== 1 && (l = Math.abs(a[h]));
          break;
        } else
          m = V, b = X, V = R, X = z;
      }
    }
  }
  return c;
}, _N = function(t, e, n, s) {
  if (n - e <= 4) {
    for (let W = e; W < n - 2; W += 2)
      s.push(t[W], t[W + 1]);
    return;
  }
  const r = t[e], a = t[e + 1], o = t[n - 4] - r, l = t[n - 3] - a, c = Math.hypot(o, l), u = o / c, d = l / c, h = u * a - d * r, p = l / o, m = 1 / c, b = Math.atan(p), y = Math.cos(b), Z = Math.sin(b), g = m * (Math.abs(y) + Math.abs(Z)), f = m * (1 - g + g ** 2), T = Math.max(Math.atan(Math.abs(Z + y) * f), Math.atan(Math.abs(Z - y) * f));
  let M = 0, N = e;
  for (let W = e + 2; W < n - 2; W += 2) {
    const x = Math.abs(h - u * t[W + 1] + d * t[W]);
    x > M && (N = W, M = x);
  }
  M > (c * T) ** 2 ? (ft(this, ci, _N).call(this, t, e, N + 2, s), ft(this, ci, _N).call(this, t, N, n, s)) : s.push(r, a);
}, G4 = function(t) {
  const e = [], n = t.length;
  return ft(this, ci, _N).call(this, t, 0, n, e), e.push(t[n - 2], t[n - 1]), e.length <= 4 ? null : e;
}, w4 = function(t, e, n, s, r, a) {
  const o = new Float32Array(a ** 2), l = -2 * s ** 2, c = a >> 1;
  for (let b = 0; b < a; b++) {
    const y = (b - c) ** 2;
    for (let Z = 0; Z < a; Z++)
      o[b * a + Z] = Math.exp((y + (Z - c) ** 2) / l);
  }
  const u = new Float32Array(256), d = -2 * r ** 2;
  for (let b = 0; b < 256; b++)
    u[b] = Math.exp(b ** 2 / d);
  const h = t.length, p = new Uint8Array(h), m = new Uint32Array(256);
  for (let b = 0; b < n; b++)
    for (let y = 0; y < e; y++) {
      const Z = b * e + y, g = t[Z];
      let f = 0, T = 0;
      for (let N = 0; N < a; N++) {
        const W = b + N - c;
        if (!(W < 0 || W >= n))
          for (let x = 0; x < a; x++) {
            const V = y + x - c;
            if (V < 0 || V >= e)
              continue;
            const X = t[W * e + V], C = o[N * a + x] * u[Math.abs(X - g)];
            f += X * C, T += C;
          }
      }
      const M = p[Z] = Math.round(f / T);
      m[M]++;
    }
  return [p, m];
}, x4 = function(t) {
  const e = new Uint32Array(256);
  for (const n of t)
    e[n]++;
  return e;
}, VX = function(t) {
  const e = t.length, n = new Uint8ClampedArray(e >> 2);
  let s = -1 / 0, r = 1 / 0;
  for (let o = 0, l = n.length; o < l; o++) {
    const c = n[o] = t[o << 2];
    s = Math.max(s, c), r = Math.min(r, c);
  }
  const a = 255 / (s - r);
  for (let o = 0, l = n.length; o < l; o++)
    n[o] = (n[o] - r) * a;
  return n;
}, XX = function(t) {
  let e, n = -1 / 0, s = -1 / 0;
  const r = t.findIndex((l) => l !== 0);
  let a = r, o = r;
  for (e = r; e < 256; e++) {
    const l = t[e];
    l > n && (e - a > s && (s = e - a, o = e - 1), n = l, a = e);
  }
  for (e = o - 1; e >= 0 && !(t[e] > t[e + 1]); e--)
    ;
  return e;
}, S4 = function(t) {
  const e = t, {
    width: n,
    height: s
  } = t, {
    maxDim: r
  } = w(this, n0);
  let a = n, o = s;
  if (n > r || s > r) {
    let h = n, p = s, m = Math.log2(Math.max(n, s) / r);
    const b = Math.floor(m);
    m = m === b ? b - 1 : b;
    for (let Z = 0; Z < m; Z++) {
      a = Math.ceil(h / 2), o = Math.ceil(p / 2);
      const g = new OffscreenCanvas(a, o);
      g.getContext("2d").drawImage(t, 0, 0, h, p, 0, 0, a, o), h = a, p = o, t !== e && t.close(), t = g.transferToImageBitmap();
    }
    const y = Math.min(r / a, r / o);
    a = Math.round(a * y), o = Math.round(o * y);
  }
  const c = new OffscreenCanvas(a, o).getContext("2d", {
    willReadFrequently: !0
  });
  c.fillStyle = "white", c.fillRect(0, 0, a, o), c.filter = "grayscale(1)", c.drawImage(t, 0, 0, t.width, t.height, 0, 0, a, o);
  const u = c.getImageData(0, 0, a, o).data;
  return [ft(this, ci, VX).call(this, u), a, o];
}, pt(Qu, ci), pt(Qu, n0, {
  maxDim: 512,
  sigmaSFactor: 0.02,
  sigmaR: 25,
  kernelSize: 16
}), pt(Qu, Sl, new Int32Array([0, 1, -1, 1, -1, 0, -1, -1, 0, -1, 1, -1, 1, 0, 1, 1]));
class rY extends f4 {
  constructor() {
    super(), super.updateProperties({
      fill: Di._defaultLineColor,
      "stroke-width": 0
    });
  }
  clone() {
    const t = new rY();
    return t.updateAll(this), t;
  }
}
class aY extends yw {
  constructor(t) {
    super(t), super.updateProperties({
      stroke: Di._defaultLineColor,
      "stroke-width": 1
    });
  }
  clone() {
    const t = new aY(this._viewParameters);
    return t.updateAll(this), t;
  }
}
var Lh, Xc, Vh, i0;
const _a = class _a extends iG {
  constructor(e) {
    super({
      ...e,
      mustBeCommitted: !0,
      name: "signatureEditor"
    });
    pt(this, Lh, !1);
    pt(this, Xc, null);
    pt(this, Vh, null);
    pt(this, i0, null);
    this._willKeepAspectRatio = !0, rt(this, Vh, e.signatureData || null), rt(this, Xc, null), this.defaultL10nId = "pdfjs-editor-signature-editor1";
  }
  static initialize(e, n) {
    Di.initialize(e, n), this._defaultDrawingOptions = new rY(), this._defaultDrawnSignatureOptions = new aY(n.viewParameters);
  }
  static getDefaultDrawingOptions(e) {
    const n = this._defaultDrawingOptions.clone();
    return n.updateProperties(e), n;
  }
  static get supportMultipleDrawings() {
    return !1;
  }
  static get typesMap() {
    return Gn(this, "typesMap", /* @__PURE__ */ new Map());
  }
  static get isDrawer() {
    return !1;
  }
  get telemetryFinalData() {
    return {
      type: "signature",
      hasDescription: !!w(this, Xc)
    };
  }
  static computeTelemetryFinalData(e) {
    const n = e.get("hasDescription");
    return {
      hasAltText: n.get(!0) ?? 0,
      hasNoAltText: n.get(!1) ?? 0
    };
  }
  get isResizable() {
    return !0;
  }
  onScaleChanging() {
    this._drawId !== null && super.onScaleChanging();
  }
  render() {
    if (this.div)
      return this.div;
    let e, n;
    const {
      _isCopy: s
    } = this;
    if (s && (this._isCopy = !1, e = this.x, n = this.y), super.render(), this._drawId === null)
      if (w(this, Vh)) {
        const {
          lines: r,
          mustSmooth: a,
          areContours: o,
          description: l,
          uuid: c,
          heightInPage: u
        } = w(this, Vh), {
          rawDims: {
            pageWidth: d,
            pageHeight: h
          },
          rotation: p
        } = this.parent.viewport, m = Qu.processDrawnLines({
          lines: r,
          pageWidth: d,
          pageHeight: h,
          rotation: p,
          innerMargin: _a._INNER_MARGIN,
          mustSmooth: a,
          areContours: o
        });
        this.addSignature(m, u, l, c);
      } else
        this.div.setAttribute("data-l10n-args", JSON.stringify({
          description: ""
        })), this.div.hidden = !0, this._uiManager.getSignature(this);
    else
      this.div.setAttribute("data-l10n-args", JSON.stringify({
        description: w(this, Xc) || ""
      }));
    return s && (this._isCopy = !0, this._moveAfterPaste(e, n)), this.div;
  }
  setUuid(e) {
    rt(this, i0, e), this.addEditToolbar();
  }
  getUuid() {
    return w(this, i0);
  }
  get description() {
    return w(this, Xc);
  }
  set description(e) {
    rt(this, Xc, e), this.div && (this.div.setAttribute("data-l10n-args", JSON.stringify({
      description: e
    })), super.addEditToolbar().then((n) => {
      n == null || n.updateEditSignatureButton(e);
    }));
  }
  getSignaturePreview() {
    const {
      newCurves: e,
      areContours: n,
      thickness: s,
      width: r,
      height: a
    } = w(this, Vh), o = Math.max(r, a), l = Qu.processDrawnLines({
      lines: {
        curves: e.map((c) => ({
          points: c
        })),
        thickness: s,
        width: r,
        height: a
      },
      pageWidth: o,
      pageHeight: o,
      rotation: 0,
      innerMargin: 0,
      mustSmooth: !1,
      areContours: n
    });
    return {
      areContours: n,
      outline: l.outline
    };
  }
  get toolbarButtons() {
    return this._uiManager.signatureManager ? [["editSignature", this._uiManager.signatureManager]] : super.toolbarButtons;
  }
  addSignature(e, n, s, r) {
    const {
      x: a,
      y: o
    } = this, {
      outline: l
    } = rt(this, Vh, e);
    rt(this, Lh, l instanceof xX), this.description = s;
    let c;
    w(this, Lh) ? c = _a.getDefaultDrawingOptions() : (c = _a._defaultDrawnSignatureOptions.clone(), c.updateProperties({
      "stroke-width": l.thickness
    })), this._addOutlines({
      drawOutlines: l,
      drawingOptions: c
    });
    const [, u] = this.pageDimensions;
    let d = n / u;
    d = d >= 1 ? 0.5 : d, this.width *= d / this.height, this.width >= 1 && (d *= 0.9 / this.width, this.width = 0.9), this.height = d, this.setDims(), this.x = a, this.y = o, this.center(), this._onResized(), this.onScaleChanging(), this.rotate(), this._uiManager.addToAnnotationStorage(this), this.setUuid(r), this._reportTelemetry({
      action: "pdfjs.signature.inserted",
      data: {
        hasBeenSaved: !!r,
        hasDescription: !!s
      }
    }), this.div.hidden = !1;
  }
  getFromImage(e) {
    const {
      rawDims: {
        pageWidth: n,
        pageHeight: s
      },
      rotation: r
    } = this.parent.viewport;
    return Qu.process(e, n, s, r, _a._INNER_MARGIN);
  }
  getFromText(e, n) {
    const {
      rawDims: {
        pageWidth: s,
        pageHeight: r
      },
      rotation: a
    } = this.parent.viewport;
    return Qu.extractContoursFromText(e, n, s, r, a, _a._INNER_MARGIN);
  }
  getDrawnSignature(e) {
    const {
      rawDims: {
        pageWidth: n,
        pageHeight: s
      },
      rotation: r
    } = this.parent.viewport;
    return Qu.processDrawnLines({
      lines: e,
      pageWidth: n,
      pageHeight: s,
      rotation: r,
      innerMargin: _a._INNER_MARGIN,
      mustSmooth: !1,
      areContours: !1
    });
  }
  createDrawingOptions({
    areContours: e,
    thickness: n
  }) {
    e ? this._drawingOptions = _a.getDefaultDrawingOptions() : (this._drawingOptions = _a._defaultDrawnSignatureOptions.clone(), this._drawingOptions.updateProperties({
      "stroke-width": n
    }));
  }
  serialize(e = !1) {
    if (this.isEmpty())
      return null;
    const {
      lines: n,
      points: s
    } = this.serializeDraw(e), {
      _drawingOptions: {
        "stroke-width": r
      }
    } = this, a = Object.assign(super.serialize(e), {
      isSignature: !0,
      areContours: w(this, Lh),
      color: [0, 0, 0],
      thickness: w(this, Lh) ? 0 : r
    });
    return this.addComment(a), e ? (a.paths = {
      lines: n,
      points: s
    }, a.uuid = w(this, i0), a.isCopy = !0) : a.lines = n, w(this, Xc) && (a.accessibilityData = {
      type: "Figure",
      alt: w(this, Xc)
    }), a;
  }
  static deserializeDraw(e, n, s, r, a, o) {
    return o.areContours ? xX.deserialize(e, n, s, r, a, o) : t1.deserialize(e, n, s, r, a, o);
  }
  static async deserialize(e, n, s) {
    var a;
    const r = await super.deserialize(e, n, s);
    return rt(r, Lh, e.areContours), r.description = ((a = e.accessibilityData) == null ? void 0 : a.alt) || "", rt(r, i0, e.uuid), r;
  }
};
Lh = new WeakMap(), Xc = new WeakMap(), Vh = new WeakMap(), i0 = new WeakMap(), S(_a, "_type", "signature"), S(_a, "_editorType", fn.SIGNATURE), S(_a, "_defaultDrawingOptions", null);
let IX = _a;
var _i, ur, Xh, Uu, Ih, rg, Pu, s0, Ic, mo, ag, Qn, Hy, _y, QN, $N, qN, YX, tW, L4;
class CX extends Di {
  constructor(e) {
    super({
      ...e,
      name: "stampEditor"
    });
    pt(this, Qn);
    pt(this, _i, null);
    pt(this, ur, null);
    pt(this, Xh, null);
    pt(this, Uu, null);
    pt(this, Ih, null);
    pt(this, rg, "");
    pt(this, Pu, null);
    pt(this, s0, !1);
    pt(this, Ic, null);
    pt(this, mo, !1);
    pt(this, ag, !1);
    rt(this, Uu, e.bitmapUrl), rt(this, Ih, e.bitmapFile), this.defaultL10nId = "pdfjs-editor-stamp-editor";
  }
  static initialize(e, n) {
    Di.initialize(e, n);
  }
  static isHandlingMimeForPasting(e) {
    return fV.includes(e);
  }
  static paste(e, n) {
    n.pasteEditor({
      mode: fn.STAMP
    }, {
      bitmapFile: e.getAsFile()
    });
  }
  altTextFinish() {
    this._uiManager.useNewAltTextFlow && (this.div.hidden = !1), super.altTextFinish();
  }
  get telemetryFinalData() {
    var e;
    return {
      type: "stamp",
      hasAltText: !!((e = this.altTextData) != null && e.altText)
    };
  }
  static computeTelemetryFinalData(e) {
    const n = e.get("hasAltText");
    return {
      hasAltText: n.get(!0) ?? 0,
      hasNoAltText: n.get(!1) ?? 0
    };
  }
  async mlGuessAltText(e = null, n = !0) {
    if (this.hasAltTextData())
      return null;
    const {
      mlManager: s
    } = this._uiManager;
    if (!s)
      throw new Error("No ML.");
    if (!await s.isEnabledFor("altText"))
      throw new Error("ML isn't enabled for alt text.");
    const {
      data: r,
      width: a,
      height: o
    } = e || this.copyCanvas(null, null, !0).imageData, l = await s.guess({
      name: "altText",
      request: {
        data: r,
        width: a,
        height: o,
        channels: r.length / (a * o)
      }
    });
    if (!l)
      throw new Error("No response from the AI service.");
    if (l.error)
      throw new Error("Error from the AI service.");
    if (l.cancel)
      return null;
    if (!l.output)
      throw new Error("No valid response from the AI service.");
    const c = l.output;
    return await this.setGuessedAltText(c), n && !this.hasAltTextData() && (this.altTextData = {
      alt: c,
      decorative: !1
    }), c;
  }
  remove() {
    var e;
    w(this, ur) && (rt(this, _i, null), this._uiManager.imageManager.deleteId(w(this, ur)), (e = w(this, Pu)) == null || e.remove(), rt(this, Pu, null), w(this, Ic) && (clearTimeout(w(this, Ic)), rt(this, Ic, null))), super.remove();
  }
  rebuild() {
    if (!this.parent) {
      w(this, ur) && ft(this, Qn, QN).call(this);
      return;
    }
    super.rebuild(), this.div !== null && (w(this, ur) && w(this, Pu) === null && ft(this, Qn, QN).call(this), this.isAttachedToDOM || this.parent.add(this));
  }
  onceAdded(e) {
    this._isDraggable = !0, e && this.div.focus();
  }
  isEmpty() {
    return !(w(this, Xh) || w(this, _i) || w(this, Uu) || w(this, Ih) || w(this, ur) || w(this, s0));
  }
  get toolbarButtons() {
    return [["altText", this.createAltText()]];
  }
  get isResizable() {
    return !0;
  }
  render() {
    if (this.div)
      return this.div;
    let e, n;
    return this._isCopy && (e = this.x, n = this.y), super.render(), this.div.hidden = !0, this.createAltText(), w(this, s0) || (w(this, _i) ? ft(this, Qn, $N).call(this) : ft(this, Qn, QN).call(this)), this._isCopy && this._moveAfterPaste(e, n), this._uiManager.addShouldRescale(this), this.div;
  }
  setCanvas(e, n) {
    const {
      id: s,
      bitmap: r
    } = this._uiManager.imageManager.getFromCanvas(e, n);
    n.remove(), s && this._uiManager.imageManager.isValidId(s) && (rt(this, ur, s), r && rt(this, _i, r), rt(this, s0, !1), ft(this, Qn, $N).call(this));
  }
  _onResized() {
    this.onScaleChanging();
  }
  onScaleChanging() {
    if (!this.parent)
      return;
    w(this, Ic) !== null && clearTimeout(w(this, Ic)), rt(this, Ic, setTimeout(() => {
      rt(this, Ic, null), ft(this, Qn, YX).call(this);
    }, 200));
  }
  copyCanvas(e, n, s = !1) {
    e || (e = 224);
    const {
      width: r,
      height: a
    } = w(this, _i), o = new Uc();
    let l = w(this, _i), c = r, u = a, d = null;
    if (n) {
      if (r > n || a > n) {
        const W = Math.min(n / r, n / a);
        c = Math.floor(r * W), u = Math.floor(a * W);
      }
      d = document.createElement("canvas");
      const p = d.width = Math.ceil(c * o.sx), m = d.height = Math.ceil(u * o.sy);
      w(this, mo) || (l = ft(this, Qn, qN).call(this, p, m));
      const b = d.getContext("2d");
      b.filter = this._uiManager.hcmFilter;
      let y = "white", Z = "#cfcfd8";
      this._uiManager.hcmFilter !== "none" ? Z = "black" : pIt.isDarkMode && (y = "#8f8f9d", Z = "#42414d");
      const g = 15, f = g * o.sx, T = g * o.sy, M = new OffscreenCanvas(f * 2, T * 2), N = M.getContext("2d");
      N.fillStyle = y, N.fillRect(0, 0, f * 2, T * 2), N.fillStyle = Z, N.fillRect(0, 0, f, T), N.fillRect(f, T, f, T), b.fillStyle = b.createPattern(M, "repeat"), b.fillRect(0, 0, p, m), b.drawImage(l, 0, 0, l.width, l.height, 0, 0, p, m);
    }
    let h = null;
    if (s) {
      let p, m;
      if (o.symmetric && l.width < e && l.height < e)
        p = l.width, m = l.height;
      else if (l = w(this, _i), r > e || a > e) {
        const Z = Math.min(e / r, e / a);
        p = Math.floor(r * Z), m = Math.floor(a * Z), w(this, mo) || (l = ft(this, Qn, qN).call(this, p, m));
      }
      const y = new OffscreenCanvas(p, m).getContext("2d", {
        willReadFrequently: !0
      });
      y.drawImage(l, 0, 0, l.width, l.height, 0, 0, p, m), h = {
        width: p,
        height: m,
        data: y.getImageData(0, 0, p, m).data
      };
    }
    return {
      canvas: d,
      width: c,
      height: u,
      imageData: h
    };
  }
  static async deserialize(e, n, s) {
    var y;
    let r = null, a = !1;
    if (e instanceof PK) {
      const {
        data: {
          rect: Z,
          rotation: g,
          id: f,
          structParent: T,
          popupRef: M,
          richText: N,
          contentsObj: W,
          creationDate: x,
          modificationDate: V
        },
        container: X,
        parent: {
          page: {
            pageNumber: C
          }
        },
        canvas: R
      } = e;
      let z, F;
      R ? (delete e.canvas, {
        id: z,
        bitmap: F
      } = s.imageManager.getFromCanvas(X.id, R), R.remove()) : (a = !0, e._hasNoCanvas = !0);
      const P = ((y = await n._structTree.getAriaAttributes(`${_C}${f}`)) == null ? void 0 : y.get("aria-label")) || "";
      r = e = {
        annotationType: fn.STAMP,
        bitmapId: z,
        bitmap: F,
        pageIndex: C - 1,
        rect: Z.slice(0),
        rotation: g,
        annotationElementId: f,
        id: f,
        deleted: !1,
        accessibilityData: {
          decorative: !1,
          altText: P
        },
        isSvg: !1,
        structParent: T,
        popupRef: M,
        richText: N,
        comment: (W == null ? void 0 : W.str) || null,
        creationDate: x,
        modificationDate: V
      };
    }
    const o = await super.deserialize(e, n, s), {
      rect: l,
      bitmap: c,
      bitmapUrl: u,
      bitmapId: d,
      isSvg: h,
      accessibilityData: p
    } = e;
    a ? (s.addMissingCanvas(e.id, o), rt(o, s0, !0)) : d && s.imageManager.isValidId(d) ? (rt(o, ur, d), c && rt(o, _i, c)) : rt(o, Uu, u), rt(o, mo, h);
    const [m, b] = o.pageDimensions;
    return o.width = (l[2] - l[0]) / m, o.height = (l[3] - l[1]) / b, p && (o.altTextData = p), o._initialData = r, e.comment && o.setCommentData(e), rt(o, ag, !!r), o;
  }
  serialize(e = !1, n = null) {
    if (this.isEmpty())
      return null;
    if (this.deleted)
      return this.serializeDeleted();
    const s = Object.assign(super.serialize(e), {
      bitmapId: w(this, ur),
      isSvg: w(this, mo)
    });
    if (this.addComment(s), e)
      return s.bitmapUrl = ft(this, Qn, tW).call(this, !0), s.accessibilityData = this.serializeAltText(!0), s.isCopy = !0, s;
    const {
      decorative: r,
      altText: a
    } = this.serializeAltText(!1);
    if (!r && a && (s.accessibilityData = {
      type: "Figure",
      alt: a
    }), this.annotationElementId) {
      const l = ft(this, Qn, L4).call(this, s);
      return l.isSame ? null : (l.isSameAltText ? delete s.accessibilityData : s.accessibilityData.structParent = this._initialData.structParent ?? -1, s.id = this.annotationElementId, delete s.bitmapId, s);
    }
    if (n === null)
      return s;
    n.stamps || (n.stamps = /* @__PURE__ */ new Map());
    const o = w(this, mo) ? (s.rect[2] - s.rect[0]) * (s.rect[3] - s.rect[1]) : null;
    if (!n.stamps.has(w(this, ur)))
      n.stamps.set(w(this, ur), {
        area: o,
        serialized: s
      }), s.bitmap = ft(this, Qn, tW).call(this, !1);
    else if (w(this, mo)) {
      const l = n.stamps.get(w(this, ur));
      o > l.area && (l.area = o, l.serialized.bitmap.close(), l.serialized.bitmap = ft(this, Qn, tW).call(this, !1));
    }
    return s;
  }
  renderAnnotationElement(e) {
    return this.deleted ? (e.hide(), null) : (e.updateEdited({
      rect: this.getPDFRect(),
      popup: this.comment
    }), null);
  }
}
_i = new WeakMap(), ur = new WeakMap(), Xh = new WeakMap(), Uu = new WeakMap(), Ih = new WeakMap(), rg = new WeakMap(), Pu = new WeakMap(), s0 = new WeakMap(), Ic = new WeakMap(), mo = new WeakMap(), ag = new WeakMap(), Qn = new WeakSet(), Hy = function(e, n = !1) {
  if (!e) {
    this.remove();
    return;
  }
  rt(this, _i, e.bitmap), n || (rt(this, ur, e.id), rt(this, mo, e.isSvg)), e.file && rt(this, rg, e.file.name), ft(this, Qn, $N).call(this);
}, _y = function() {
  if (rt(this, Xh, null), this._uiManager.enableWaiting(!1), !!w(this, Pu)) {
    if (this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && w(this, _i)) {
      this.addEditToolbar().then(() => {
        this._editToolbar.hide(), this._uiManager.editAltText(this, !0);
      });
      return;
    }
    if (!this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && w(this, _i)) {
      this._reportTelemetry({
        action: "pdfjs.image.image_added",
        data: {
          alt_text_modal: !1,
          alt_text_type: "empty"
        }
      });
      try {
        this.mlGuessAltText();
      } catch {
      }
    }
    this.div.focus();
  }
}, QN = function() {
  if (w(this, ur)) {
    this._uiManager.enableWaiting(!0), this._uiManager.imageManager.getFromId(w(this, ur)).then((s) => ft(this, Qn, Hy).call(this, s, !0)).finally(() => ft(this, Qn, _y).call(this));
    return;
  }
  if (w(this, Uu)) {
    const s = w(this, Uu);
    rt(this, Uu, null), this._uiManager.enableWaiting(!0), rt(this, Xh, this._uiManager.imageManager.getFromUrl(s).then((r) => ft(this, Qn, Hy).call(this, r)).finally(() => ft(this, Qn, _y).call(this)));
    return;
  }
  if (w(this, Ih)) {
    const s = w(this, Ih);
    rt(this, Ih, null), this._uiManager.enableWaiting(!0), rt(this, Xh, this._uiManager.imageManager.getFromFile(s).then((r) => ft(this, Qn, Hy).call(this, r)).finally(() => ft(this, Qn, _y).call(this)));
    return;
  }
  const e = document.createElement("input");
  e.type = "file", e.accept = fV.join(",");
  const n = this._uiManager._signal;
  rt(this, Xh, new Promise((s) => {
    e.addEventListener("change", async () => {
      if (!e.files || e.files.length === 0)
        this.remove();
      else {
        this._uiManager.enableWaiting(!0);
        const r = await this._uiManager.imageManager.getFromFile(e.files[0]);
        this._reportTelemetry({
          action: "pdfjs.image.image_selected",
          data: {
            alt_text_modal: this._uiManager.useNewAltTextFlow
          }
        }), ft(this, Qn, Hy).call(this, r);
      }
      s();
    }, {
      signal: n
    }), e.addEventListener("cancel", () => {
      this.remove(), s();
    }, {
      signal: n
    });
  }).finally(() => ft(this, Qn, _y).call(this))), e.click();
}, $N = function() {
  var c;
  const {
    div: e
  } = this;
  let {
    width: n,
    height: s
  } = w(this, _i);
  const [r, a] = this.pageDimensions, o = 0.75;
  if (this.width)
    n = this.width * r, s = this.height * a;
  else if (n > o * r || s > o * a) {
    const u = Math.min(o * r / n, o * a / s);
    n *= u, s *= u;
  }
  this._uiManager.enableWaiting(!1);
  const l = rt(this, Pu, document.createElement("canvas"));
  l.setAttribute("role", "img"), this.addContainer(l), this.width = n / r, this.height = s / a, this.setDims(), (c = this._initialOptions) != null && c.isCentered ? this.center() : this.fixAndSetPosition(), this._initialOptions = null, (!this._uiManager.useNewAltTextWhenAddingImage || !this._uiManager.useNewAltTextFlow || this.annotationElementId) && (e.hidden = !1), ft(this, Qn, YX).call(this), w(this, ag) || (this.parent.addUndoableEditor(this), rt(this, ag, !0)), this._reportTelemetry({
    action: "inserted_image"
  }), w(this, rg) && this.div.setAttribute("aria-description", w(this, rg)), this.annotationElementId || this._uiManager.a11yAlert("pdfjs-editor-stamp-added-alert");
}, qN = function(e, n) {
  const {
    width: s,
    height: r
  } = w(this, _i);
  let a = s, o = r, l = w(this, _i);
  for (; a > 2 * e || o > 2 * n; ) {
    const c = a, u = o;
    a > 2 * e && (a = a >= 16384 ? Math.floor(a / 2) - 1 : Math.ceil(a / 2)), o > 2 * n && (o = o >= 16384 ? Math.floor(o / 2) - 1 : Math.ceil(o / 2));
    const d = new OffscreenCanvas(a, o);
    d.getContext("2d").drawImage(l, 0, 0, c, u, 0, 0, a, o), l = d.transferToImageBitmap();
  }
  return l;
}, YX = function() {
  const [e, n] = this.parentDimensions, {
    width: s,
    height: r
  } = this, a = new Uc(), o = Math.ceil(s * e * a.sx), l = Math.ceil(r * n * a.sy), c = w(this, Pu);
  if (!c || c.width === o && c.height === l)
    return;
  c.width = o, c.height = l;
  const u = w(this, mo) ? w(this, _i) : ft(this, Qn, qN).call(this, o, l), d = c.getContext("2d");
  d.filter = this._uiManager.hcmFilter, d.drawImage(u, 0, 0, u.width, u.height, 0, 0, o, l);
}, tW = function(e) {
  if (e) {
    if (w(this, mo)) {
      const r = this._uiManager.imageManager.getSvgUrl(w(this, ur));
      if (r)
        return r;
    }
    const n = document.createElement("canvas");
    return {
      width: n.width,
      height: n.height
    } = w(this, _i), n.getContext("2d").drawImage(w(this, _i), 0, 0), n.toDataURL();
  }
  if (w(this, mo)) {
    const [n, s] = this.pageDimensions, r = Math.round(this.width * n * qh.PDF_TO_CSS_UNITS), a = Math.round(this.height * s * qh.PDF_TO_CSS_UNITS), o = new OffscreenCanvas(r, a);
    return o.getContext("2d").drawImage(w(this, _i), 0, 0, w(this, _i).width, w(this, _i).height, 0, 0, r, a), o.transferToImageBitmap();
  }
  return structuredClone(w(this, _i));
}, L4 = function(e) {
  var o;
  const {
    pageIndex: n,
    accessibilityData: {
      altText: s
    }
  } = this._initialData, r = e.pageIndex === n, a = (((o = e.accessibilityData) == null ? void 0 : o.alt) || "") === s;
  return {
    isSame: !this.hasEditedComment && !this._hasBeenMoved && !this._hasBeenResized && r && a,
    isSameAltText: a
  };
}, S(CX, "_type", "stamp"), S(CX, "_editorType", fn.STAMP);
var r0, og, Ch, Yh, Ju, Ea, vh, lg, cg, Ll, Au, dr, Bu, Rh, ug, Ae, Dh, Vi, RX, V4, oc, DX, OX, eW;
const bl = class bl {
  constructor({
    uiManager: t,
    pageIndex: e,
    div: n,
    structTreeLayer: s,
    accessibilityManager: r,
    annotationLayer: a,
    drawLayer: o,
    textLayer: l,
    viewport: c,
    l10n: u
  }) {
    pt(this, Vi);
    pt(this, r0);
    pt(this, og, !1);
    pt(this, Ch, null);
    pt(this, Yh, null);
    pt(this, Ju, null);
    pt(this, Ea, /* @__PURE__ */ new Map());
    pt(this, vh, !1);
    pt(this, lg, !1);
    pt(this, cg, !1);
    pt(this, Ll, null);
    pt(this, Au, null);
    pt(this, dr, null);
    pt(this, Bu, null);
    pt(this, Rh, null);
    pt(this, ug, -1);
    pt(this, Ae);
    const d = [...w(bl, Dh).values()];
    if (!bl._initialized) {
      bl._initialized = !0;
      for (const h of d)
        h.initialize(u, t);
    }
    t.registerEditorTypes(d), rt(this, Ae, t), this.pageIndex = e, this.div = n, rt(this, r0, r), rt(this, Ch, a), this.viewport = c, rt(this, dr, l), this.drawLayer = o, this._structTree = s, w(this, Ae).addLayer(this);
  }
  get isEmpty() {
    return w(this, Ea).size === 0;
  }
  get isInvisible() {
    return this.isEmpty && w(this, Ae).getMode() === fn.NONE;
  }
  updateToolbar(t) {
    w(this, Ae).updateToolbar(t);
  }
  updateMode(t = w(this, Ae).getMode()) {
    switch (ft(this, Vi, eW).call(this), t) {
      case fn.NONE:
        this.div.classList.toggle("nonEditing", !0), this.disableTextSelection(), this.togglePointerEvents(!1), this.toggleAnnotationLayerPointerEvents(!0), this.disableClick();
        return;
      case fn.INK:
        this.disableTextSelection(), this.togglePointerEvents(!0), this.enableClick();
        break;
      case fn.HIGHLIGHT:
        this.enableTextSelection(), this.togglePointerEvents(!1), this.disableClick();
        break;
      default:
        this.disableTextSelection(), this.togglePointerEvents(!0), this.enableClick();
    }
    this.toggleAnnotationLayerPointerEvents(!1);
    const {
      classList: e
    } = this.div;
    if (e.toggle("nonEditing", !1), t === fn.POPUP)
      e.toggle("commentEditing", !0);
    else {
      e.toggle("commentEditing", !1);
      for (const n of w(bl, Dh).values())
        e.toggle(`${n._type}Editing`, t === n._editorType);
    }
    this.div.hidden = !1;
  }
  hasTextLayer(t) {
    var e;
    return t === ((e = w(this, dr)) == null ? void 0 : e.div);
  }
  setEditingState(t) {
    w(this, Ae).setEditingState(t);
  }
  addCommands(t) {
    w(this, Ae).addCommands(t);
  }
  cleanUndoStack(t) {
    w(this, Ae).cleanUndoStack(t);
  }
  toggleDrawing(t = !1) {
    this.div.classList.toggle("drawing", !t);
  }
  togglePointerEvents(t = !1) {
    this.div.classList.toggle("disabled", !t);
  }
  toggleAnnotationLayerPointerEvents(t = !1) {
    var e;
    (e = w(this, Ch)) == null || e.div.classList.toggle("disabled", !t);
  }
  async enable() {
    var n;
    rt(this, cg, !0), this.div.tabIndex = 0, this.togglePointerEvents(!0), this.div.classList.toggle("nonEditing", !1), (n = w(this, Rh)) == null || n.abort(), rt(this, Rh, null);
    const t = /* @__PURE__ */ new Set();
    for (const s of w(this, Vi, RX))
      s.enableEditing(), s.show(!0), s.annotationElementId && (w(this, Ae).removeChangedExistingAnnotation(s), t.add(s.annotationElementId));
    const e = w(this, Ch);
    if (e)
      for (const s of e.getEditableAnnotations()) {
        if (s.hide(), w(this, Ae).isDeletedAnnotationElement(s.data.id) || t.has(s.data.id))
          continue;
        const r = await this.deserialize(s);
        r && (this.addOrRebuild(r), r.enableEditing());
      }
    rt(this, cg, !1), w(this, Ae)._eventBus.dispatch("editorsrendered", {
      source: this,
      pageNumber: this.pageIndex + 1
    });
  }
  disable() {
    var n;
    if (rt(this, lg, !0), this.div.tabIndex = -1, this.togglePointerEvents(!1), this.div.classList.toggle("nonEditing", !0), w(this, dr) && !w(this, Rh)) {
      rt(this, Rh, new AbortController());
      const s = w(this, Ae).combinedSignal(w(this, Rh));
      w(this, dr).div.addEventListener("pointerdown", (r) => {
        const {
          clientX: o,
          clientY: l,
          timeStamp: c
        } = r, u = w(this, ug);
        if (c - u > 500) {
          rt(this, ug, c);
          return;
        }
        rt(this, ug, -1);
        const {
          classList: d
        } = this.div;
        d.toggle("getElements", !0);
        const h = document.elementsFromPoint(o, l);
        if (d.toggle("getElements", !1), !this.div.contains(h[0]))
          return;
        let p;
        const m = new RegExp(`^${z2}[0-9]+$`);
        for (const y of h)
          if (m.test(y.id)) {
            p = y.id;
            break;
          }
        if (!p)
          return;
        const b = w(this, Ea).get(p);
        (b == null ? void 0 : b.annotationElementId) === null && (r.stopPropagation(), r.preventDefault(), b.dblclick(r));
      }, {
        signal: s,
        capture: !0
      });
    }
    const t = w(this, Ch);
    if (t) {
      const s = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
      for (const o of w(this, Vi, RX)) {
        if (o.disableEditing(), !o.annotationElementId) {
          o.updateFakeAnnotationElement(t);
          continue;
        }
        if (o.serialize() !== null) {
          s.set(o.annotationElementId, o);
          continue;
        } else
          r.set(o.annotationElementId, o);
        (n = this.getEditableAnnotation(o.annotationElementId)) == null || n.show(), o.remove();
      }
      const a = t.getEditableAnnotations();
      for (const o of a) {
        const {
          id: l
        } = o.data;
        if (w(this, Ae).isDeletedAnnotationElement(l)) {
          o.updateEdited({
            deleted: !0
          });
          continue;
        }
        let c = r.get(l);
        if (c) {
          c.resetAnnotationElement(o), c.show(!1), o.show();
          continue;
        }
        c = s.get(l), c && (w(this, Ae).addChangedExistingAnnotation(c), c.renderAnnotationElement(o) && c.show(!1)), o.show();
      }
    }
    ft(this, Vi, eW).call(this), this.isEmpty && (this.div.hidden = !0);
    const {
      classList: e
    } = this.div;
    for (const s of w(bl, Dh).values())
      e.remove(`${s._type}Editing`);
    this.disableTextSelection(), this.toggleAnnotationLayerPointerEvents(!0), rt(this, lg, !1);
  }
  getEditableAnnotation(t) {
    var e;
    return ((e = w(this, Ch)) == null ? void 0 : e.getEditableAnnotation(t)) || null;
  }
  setActiveEditor(t) {
    w(this, Ae).getActive() !== t && w(this, Ae).setActiveEditor(t);
  }
  enableTextSelection() {
    var t;
    if (this.div.tabIndex = -1, (t = w(this, dr)) != null && t.div && !w(this, Bu)) {
      rt(this, Bu, new AbortController());
      const e = w(this, Ae).combinedSignal(w(this, Bu));
      w(this, dr).div.addEventListener("pointerdown", ft(this, Vi, V4).bind(this), {
        signal: e
      }), w(this, dr).div.classList.add("highlighting");
    }
  }
  disableTextSelection() {
    var t;
    this.div.tabIndex = 0, (t = w(this, dr)) != null && t.div && w(this, Bu) && (w(this, Bu).abort(), rt(this, Bu, null), w(this, dr).div.classList.remove("highlighting"));
  }
  enableClick() {
    if (w(this, Yh))
      return;
    rt(this, Yh, new AbortController());
    const t = w(this, Ae).combinedSignal(w(this, Yh));
    this.div.addEventListener("pointerdown", this.pointerdown.bind(this), {
      signal: t
    });
    const e = this.pointerup.bind(this);
    this.div.addEventListener("pointerup", e, {
      signal: t
    }), this.div.addEventListener("pointercancel", e, {
      signal: t
    });
  }
  disableClick() {
    var t;
    (t = w(this, Yh)) == null || t.abort(), rt(this, Yh, null);
  }
  attach(t) {
    w(this, Ea).set(t.id, t);
    const {
      annotationElementId: e
    } = t;
    e && w(this, Ae).isDeletedAnnotationElement(e) && w(this, Ae).removeDeletedAnnotationElement(t);
  }
  detach(t) {
    var e;
    w(this, Ea).delete(t.id), (e = w(this, r0)) == null || e.removePointerInTextLayer(t.contentDiv), !w(this, lg) && t.annotationElementId && w(this, Ae).addDeletedAnnotationElement(t);
  }
  remove(t) {
    this.detach(t), w(this, Ae).removeEditor(t), t.div.remove(), t.isAttachedToDOM = !1;
  }
  changeParent(t) {
    var e;
    t.parent !== this && (t.parent && t.annotationElementId && (w(this, Ae).addDeletedAnnotationElement(t.annotationElementId), Di.deleteAnnotationElement(t), t.annotationElementId = null), this.attach(t), (e = t.parent) == null || e.detach(t), t.setParent(this), t.div && t.isAttachedToDOM && (t.div.remove(), this.div.append(t.div)));
  }
  add(t) {
    if (!(t.parent === this && t.isAttachedToDOM)) {
      if (this.changeParent(t), w(this, Ae).addEditor(t), this.attach(t), !t.isAttachedToDOM) {
        const e = t.render();
        this.div.append(e), t.isAttachedToDOM = !0;
      }
      t.fixAndSetPosition(), t.onceAdded(!w(this, cg)), w(this, Ae).addToAnnotationStorage(t), t._reportTelemetry(t.telemetryInitialData);
    }
  }
  moveEditorInDOM(t) {
    var n;
    if (!t.isAttachedToDOM)
      return;
    const {
      activeElement: e
    } = document;
    t.div.contains(e) && !w(this, Ju) && (t._focusEventsAllowed = !1, rt(this, Ju, setTimeout(() => {
      rt(this, Ju, null), t.div.contains(document.activeElement) ? t._focusEventsAllowed = !0 : (t.div.addEventListener("focusin", () => {
        t._focusEventsAllowed = !0;
      }, {
        once: !0,
        signal: w(this, Ae)._signal
      }), e.focus());
    }, 0))), t._structTreeParentId = (n = w(this, r0)) == null ? void 0 : n.moveElementInDOM(this.div, t.div, t.contentDiv, !0);
  }
  addOrRebuild(t) {
    t.needsToBeRebuilt() ? (t.parent || (t.parent = this), t.rebuild(), t.show()) : this.add(t);
  }
  addUndoableEditor(t) {
    const e = () => t._uiManager.rebuild(t), n = () => {
      t.remove();
    };
    this.addCommands({
      cmd: e,
      undo: n,
      mustExec: !1
    });
  }
  getEditorByUID(t) {
    for (const e of w(this, Ea).values())
      if (e.uid === t)
        return e;
    return null;
  }
  getNextId() {
    return w(this, Ae).getId();
  }
  combinedSignal(t) {
    return w(this, Ae).combinedSignal(t);
  }
  canCreateNewEmptyEditor() {
    var t;
    return (t = w(this, Vi, oc)) == null ? void 0 : t.canCreateNewEmptyEditor();
  }
  async pasteEditor(t, e) {
    this.updateToolbar(t), await w(this, Ae).updateMode(t.mode);
    const {
      offsetX: n,
      offsetY: s
    } = ft(this, Vi, OX).call(this), r = this.getNextId(), a = ft(this, Vi, DX).call(this, {
      parent: this,
      id: r,
      x: n,
      y: s,
      uiManager: w(this, Ae),
      isCentered: !0,
      ...e
    });
    a && this.add(a);
  }
  async deserialize(t) {
    var e;
    return await ((e = w(bl, Dh).get(t.annotationType ?? t.annotationEditorType)) == null ? void 0 : e.deserialize(t, this, w(this, Ae))) || null;
  }
  createAndAddNewEditor(t, e, n = {}) {
    const s = this.getNextId(), r = ft(this, Vi, DX).call(this, {
      parent: this,
      id: s,
      x: t.offsetX,
      y: t.offsetY,
      uiManager: w(this, Ae),
      isCentered: e,
      ...n
    });
    return r && this.add(r), r;
  }
  get boundingClientRect() {
    return this.div.getBoundingClientRect();
  }
  addNewEditor(t = {}) {
    this.createAndAddNewEditor(ft(this, Vi, OX).call(this), !0, t);
  }
  setSelected(t) {
    w(this, Ae).setSelected(t);
  }
  toggleSelected(t) {
    w(this, Ae).toggleSelected(t);
  }
  unselect(t) {
    w(this, Ae).unselect(t);
  }
  pointerup(t) {
    var s;
    const {
      isMac: e
    } = Er.platform;
    if (t.button !== 0 || t.ctrlKey && e || t.target !== this.div || !w(this, vh) || (rt(this, vh, !1), (s = w(this, Vi, oc)) != null && s.isDrawer && w(this, Vi, oc).supportMultipleDrawings))
      return;
    if (!w(this, og)) {
      rt(this, og, !0);
      return;
    }
    const n = w(this, Ae).getMode();
    if (n === fn.STAMP || n === fn.SIGNATURE) {
      w(this, Ae).unselectAll();
      return;
    }
    this.createAndAddNewEditor(t, !1);
  }
  pointerdown(t) {
    var s;
    if (w(this, Ae).getMode() === fn.HIGHLIGHT && this.enableTextSelection(), w(this, vh)) {
      rt(this, vh, !1);
      return;
    }
    const {
      isMac: e
    } = Er.platform;
    if (t.button !== 0 || t.ctrlKey && e || t.target !== this.div)
      return;
    if (rt(this, vh, !0), (s = w(this, Vi, oc)) != null && s.isDrawer) {
      this.startDrawingSession(t);
      return;
    }
    const n = w(this, Ae).getActive();
    rt(this, og, !n || n.isEmpty());
  }
  startDrawingSession(t) {
    if (this.div.focus({
      preventScroll: !0
    }), w(this, Ll)) {
      w(this, Vi, oc).startDrawing(this, w(this, Ae), !1, t);
      return;
    }
    w(this, Ae).setCurrentDrawingSession(this), rt(this, Ll, new AbortController());
    const e = w(this, Ae).combinedSignal(w(this, Ll));
    this.div.addEventListener("blur", ({
      relatedTarget: n
    }) => {
      n && !this.div.contains(n) && (rt(this, Au, null), this.commitOrRemove());
    }, {
      signal: e
    }), w(this, Vi, oc).startDrawing(this, w(this, Ae), !1, t);
  }
  pause(t) {
    if (t) {
      const {
        activeElement: e
      } = document;
      this.div.contains(e) && rt(this, Au, e);
      return;
    }
    w(this, Au) && setTimeout(() => {
      var e;
      (e = w(this, Au)) == null || e.focus(), rt(this, Au, null);
    }, 0);
  }
  endDrawingSession(t = !1) {
    return w(this, Ll) ? (w(this, Ae).setCurrentDrawingSession(null), w(this, Ll).abort(), rt(this, Ll, null), rt(this, Au, null), w(this, Vi, oc).endDrawing(t)) : null;
  }
  findNewParent(t, e, n) {
    const s = w(this, Ae).findParent(e, n);
    return s === null || s === this ? !1 : (s.changeParent(t), !0);
  }
  commitOrRemove() {
    return w(this, Ll) ? (this.endDrawingSession(), !0) : !1;
  }
  onScaleChanging() {
    w(this, Ll) && w(this, Vi, oc).onScaleChangingWhenDrawing(this);
  }
  destroy() {
    var t, e;
    this.commitOrRemove(), ((t = w(this, Ae).getActive()) == null ? void 0 : t.parent) === this && (w(this, Ae).commitOrRemove(), w(this, Ae).setActiveEditor(null)), w(this, Ju) && (clearTimeout(w(this, Ju)), rt(this, Ju, null));
    for (const n of w(this, Ea).values())
      (e = w(this, r0)) == null || e.removePointerInTextLayer(n.contentDiv), n.setParent(null), n.isAttachedToDOM = !1, n.div.remove();
    this.div = null, w(this, Ea).clear(), w(this, Ae).removeLayer(this);
  }
  render({
    viewport: t
  }) {
    this.viewport = t, W0(this.div, t);
    for (const e of w(this, Ae).getEditors(this.pageIndex))
      this.add(e), e.rebuild();
    this.updateMode();
  }
  update({
    viewport: t
  }) {
    w(this, Ae).commitOrRemove(), ft(this, Vi, eW).call(this);
    const e = this.viewport.rotation, n = t.rotation;
    if (this.viewport = t, W0(this.div, {
      rotation: n
    }), e !== n)
      for (const s of w(this, Ea).values())
        s.rotate(n);
  }
  get pageDimensions() {
    const {
      pageWidth: t,
      pageHeight: e
    } = this.viewport.rawDims;
    return [t, e];
  }
  get scale() {
    return w(this, Ae).viewParameters.realScale;
  }
};
r0 = new WeakMap(), og = new WeakMap(), Ch = new WeakMap(), Yh = new WeakMap(), Ju = new WeakMap(), Ea = new WeakMap(), vh = new WeakMap(), lg = new WeakMap(), cg = new WeakMap(), Ll = new WeakMap(), Au = new WeakMap(), dr = new WeakMap(), Bu = new WeakMap(), Rh = new WeakMap(), ug = new WeakMap(), Ae = new WeakMap(), Dh = new WeakMap(), Vi = new WeakSet(), RX = function() {
  return w(this, Ea).size !== 0 ? w(this, Ea).values() : w(this, Ae).getEditors(this.pageIndex);
}, V4 = function(t) {
  w(this, Ae).unselectAll();
  const {
    target: e
  } = t;
  if (e === w(this, dr).div || (e.getAttribute("role") === "img" || e.classList.contains("endOfContent")) && w(this, dr).div.contains(e)) {
    const {
      isMac: n
    } = Er.platform;
    if (t.button !== 0 || t.ctrlKey && n)
      return;
    w(this, Ae).showAllEditors("highlight", !0, !0), w(this, dr).div.classList.add("free"), this.toggleDrawing(), nG.startHighlighting(this, w(this, Ae).direction === "ltr", {
      target: w(this, dr).div,
      x: t.x,
      y: t.y
    }), w(this, dr).div.addEventListener("pointerup", () => {
      w(this, dr).div.classList.remove("free"), this.toggleDrawing(!0);
    }, {
      once: !0,
      signal: w(this, Ae)._signal
    }), t.preventDefault();
  }
}, oc = function() {
  return w(bl, Dh).get(w(this, Ae).getMode());
}, DX = function(t) {
  const e = w(this, Vi, oc);
  return e ? new e.prototype.constructor(t) : null;
}, OX = function() {
  const {
    x: t,
    y: e,
    width: n,
    height: s
  } = this.boundingClientRect, r = Math.max(0, t), a = Math.max(0, e), o = Math.min(window.innerWidth, t + n), l = Math.min(window.innerHeight, e + s), c = (r + o) / 2 - t, u = (a + l) / 2 - e, [d, h] = this.viewport.rotation % 180 === 0 ? [c, u] : [u, c];
  return {
    offsetX: d,
    offsetY: h
  };
}, eW = function() {
  for (const t of w(this, Ea).values())
    t.isEmpty() && t.remove();
}, S(bl, "_initialized", !1), pt(bl, Dh, new Map([bX, wX, CX, nG, IX].map((t) => [t._editorType, t])));
let vX = bl;
var Vl, Ta, a0, NT, GG, X4, Pc, EX, I4, kX;
const _s = class _s {
  constructor({
    pageIndex: t
  }) {
    pt(this, Pc);
    pt(this, Vl, null);
    pt(this, Ta, /* @__PURE__ */ new Map());
    pt(this, a0, /* @__PURE__ */ new Map());
    this.pageIndex = t;
  }
  setParent(t) {
    if (!w(this, Vl)) {
      rt(this, Vl, t);
      return;
    }
    if (w(this, Vl) !== t) {
      if (w(this, Ta).size > 0)
        for (const e of w(this, Ta).values())
          e.remove(), t.append(e);
      rt(this, Vl, t);
    }
  }
  static get _svgFactory() {
    return Gn(this, "_svgFactory", new qW());
  }
  draw(t, e = !1, n = !1) {
    const s = Ks(_s, NT)._++, r = ft(this, Pc, EX).call(this), a = _s._svgFactory.createElement("defs");
    r.append(a);
    const o = _s._svgFactory.createElement("path");
    a.append(o);
    const l = `path_p${this.pageIndex}_${s}`;
    o.setAttribute("id", l), o.setAttribute("vector-effect", "non-scaling-stroke"), e && w(this, a0).set(s, o);
    const c = n ? ft(this, Pc, I4).call(this, a, l) : null, u = _s._svgFactory.createElement("use");
    return r.append(u), u.setAttribute("href", `#${l}`), this.updateProperties(r, t), w(this, Ta).set(s, r), {
      id: s,
      clipPathId: `url(#${c})`
    };
  }
  drawOutline(t, e) {
    const n = Ks(_s, NT)._++, s = ft(this, Pc, EX).call(this), r = _s._svgFactory.createElement("defs");
    s.append(r);
    const a = _s._svgFactory.createElement("path");
    r.append(a);
    const o = `path_p${this.pageIndex}_${n}`;
    a.setAttribute("id", o), a.setAttribute("vector-effect", "non-scaling-stroke");
    let l;
    if (e) {
      const d = _s._svgFactory.createElement("mask");
      r.append(d), l = `mask_p${this.pageIndex}_${n}`, d.setAttribute("id", l), d.setAttribute("maskUnits", "objectBoundingBox");
      const h = _s._svgFactory.createElement("rect");
      d.append(h), h.setAttribute("width", "1"), h.setAttribute("height", "1"), h.setAttribute("fill", "white");
      const p = _s._svgFactory.createElement("use");
      d.append(p), p.setAttribute("href", `#${o}`), p.setAttribute("stroke", "none"), p.setAttribute("fill", "black"), p.setAttribute("fill-rule", "nonzero"), p.classList.add("mask");
    }
    const c = _s._svgFactory.createElement("use");
    s.append(c), c.setAttribute("href", `#${o}`), l && c.setAttribute("mask", `url(#${l})`);
    const u = c.cloneNode();
    return s.append(u), c.classList.add("mainOutline"), u.classList.add("secondaryOutline"), this.updateProperties(s, t), w(this, Ta).set(n, s), n;
  }
  finalizeDraw(t, e) {
    w(this, a0).delete(t), this.updateProperties(t, e);
  }
  updateProperties(t, e) {
    var l;
    if (!e)
      return;
    const {
      root: n,
      bbox: s,
      rootClass: r,
      path: a
    } = e, o = typeof t == "number" ? w(this, Ta).get(t) : t;
    if (o) {
      if (n && ft(this, Pc, kX).call(this, o, n), s && ft(l = _s, GG, X4).call(l, o, s), r) {
        const {
          classList: c
        } = o;
        for (const [u, d] of Object.entries(r))
          c.toggle(u, d);
      }
      if (a) {
        const u = o.firstChild.firstChild;
        ft(this, Pc, kX).call(this, u, a);
      }
    }
  }
  updateParent(t, e) {
    if (e === this)
      return;
    const n = w(this, Ta).get(t);
    n && (w(e, Vl).append(n), w(this, Ta).delete(t), w(e, Ta).set(t, n));
  }
  remove(t) {
    w(this, a0).delete(t), w(this, Vl) !== null && (w(this, Ta).get(t).remove(), w(this, Ta).delete(t));
  }
  destroy() {
    rt(this, Vl, null);
    for (const t of w(this, Ta).values())
      t.remove();
    w(this, Ta).clear(), w(this, a0).clear();
  }
};
Vl = new WeakMap(), Ta = new WeakMap(), a0 = new WeakMap(), NT = new WeakMap(), GG = new WeakSet(), X4 = function(t, [e, n, s, r]) {
  const {
    style: a
  } = t;
  a.top = `${100 * n}%`, a.left = `${100 * e}%`, a.width = `${100 * s}%`, a.height = `${100 * r}%`;
}, Pc = new WeakSet(), EX = function() {
  const t = _s._svgFactory.create(1, 1, !0);
  return w(this, Vl).append(t), t.setAttribute("aria-hidden", !0), t;
}, I4 = function(t, e) {
  const n = _s._svgFactory.createElement("clipPath");
  t.append(n);
  const s = `clip_${e}`;
  n.setAttribute("id", s), n.setAttribute("clipPathUnits", "objectBoundingBox");
  const r = _s._svgFactory.createElement("use");
  return n.append(r), r.setAttribute("href", `#${e}`), r.classList.add("clip"), s;
}, kX = function(t, e) {
  for (const [n, s] of Object.entries(e))
    s === null ? t.removeAttribute(n) : t.setAttribute(n, s);
}, pt(_s, GG), pt(_s, NT, 0);
let zX = _s;
globalThis._pdfjsTestingUtils = {
  HighlightOutliner: gX
};
globalThis.pdfjsLib = {
  AbortException: $h,
  AnnotationEditorLayer: vX,
  AnnotationEditorParamsType: Un,
  AnnotationEditorType: fn,
  AnnotationEditorUIManager: G0,
  AnnotationLayer: tG,
  AnnotationMode: Yc,
  AnnotationType: Rs,
  applyOpacity: bIt,
  build: NCt,
  ColorPicker: QW,
  createValidAbsoluteUrl: wB,
  CSSConstants: mIt,
  DOMSVGFactory: qW,
  DrawLayer: zX,
  FeatureTest: Er,
  fetchData: HT,
  findContrastColor: fIt,
  getDocument: VK,
  getFilenameFromUrl: lIt,
  getPdfFilenameFromUrl: cIt,
  getRGB: QT,
  getUuid: LB,
  getXfaPageViewport: dIt,
  GlobalWorkerOptions: Wo,
  ImageKind: WN,
  InvalidPDFException: mV,
  isDataScheme: fw,
  isPdfFile: qC,
  isValidExplicitDest: xIt,
  MathClamp: Na,
  noContextMenu: al,
  normalizeUnicode: rIt,
  OPS: E2,
  OutputScale: Uc,
  PasswordResponses: _Xt,
  PDFDataRangeTransport: XK,
  PDFDateString: JW,
  PDFWorker: F2,
  PermissionFlag: HXt,
  PixelsPerInch: qh,
  RenderingCancelledException: $C,
  renderRichText: XB,
  ResponseException: PW,
  setLayerDimensions: W0,
  shadow: Gn,
  SignatureExtractor: Qu,
  stopEvent: ms,
  SupportedImageMimeTypes: fV,
  TextLayer: Gg,
  TouchManager: BW,
  updateUrlHash: xB,
  Util: ze,
  VerbosityLevel: pw,
  version: MCt,
  XfaLayer: QC
};
const AM = "internal-link", ACt = "link", BCt = "file-attachment", KCt = "form-text", HCt = "form-select", _Ct = "form-checkbox", QCt = "form-radio", $Ct = "form-button", AE = ["click", "dblclick", "mouseover", "input", "change"];
function my(i, t, e) {
  const n = [];
  if (e)
    for (const s of e)
      s[i] === t && n.push(s);
  return n;
}
function Rl(i, t) {
  return { type: i, data: t };
}
function rb(i, t) {
  switch (i.type) {
    case "textarea":
    case "text":
      return Rl(KCt, {
        fieldName: i.name,
        value: i.value
      });
    case "select-one":
    case "select-multiple":
      const e = [];
      for (const s of i.options)
        e.push({
          value: s.value,
          label: s.label
        });
      const n = [];
      for (const s of i.selectedOptions)
        n.push({
          value: s.value,
          label: s.label
        });
      return Rl(HCt, {
        fieldName: i.name,
        value: n,
        options: e
      });
    case "checkbox":
      return Rl(_Ct, {
        fieldName: i.name,
        checked: i.checked
      });
    case "radio":
      return Rl(QCt, {
        fieldName: i.name,
        ...t
      });
    case "button":
      return Rl($Ct, {
        fieldName: i.name,
        ...t
      });
  }
}
function qCt(i) {
  return Rl(BCt, i.file);
}
async function tYt(i, t) {
  if (i.dest) {
    let e;
    if (typeof i.dest == "string" ? e = await t.getDestination(i.dest) : e = i.dest, !Array.isArray(e))
      return console.warn(`Destination "${e}" is not a valid destination (dest="${i.dest}")`), Rl(AM, {
        referencedPage: null,
        offset: null
      });
    let n = null;
    e.length === 5 && (n = {
      left: i.dest[2],
      bottom: i.dest[3]
    });
    const [s] = e;
    if (Number.isInteger(s))
      return Rl(AM, {
        referencedPage: Number(s) + 1,
        offset: n
      });
    if (typeof s == "object") {
      const r = await t.getPageIndex(s);
      return Rl(AM, {
        referencedPage: r + 1,
        offset: n
      });
    } else
      return console.warn(
        `Destination "${s}" is not a valid destination (dest="${i.dest}")`
      ), Rl(AM, {
        referencedPage: null,
        offset: null
      });
  } else if (i.url)
    return Rl(ACt, {
      url: i.url,
      unsafeUrl: i.unsafeUrl
    });
}
function BE(i) {
  for (const t of i.getElementsByTagName("span")) {
    let e = t.textContent;
    const n = JSON.parse(t.dataset.l10nArgs ?? "{}");
    if (e)
      for (const s in n)
        e = e.replace(`{{${s}}}`, n[s]);
    t.textContent = e;
  }
}
function eYt(i, t, e) {
  var s;
  let n = i.target;
  if (n.tagName !== "SECTION" && (n = n.parentNode), n.className === "linkAnnotation" && i.type === "click") {
    const r = (s = n.dataset) == null ? void 0 : s.annotationId;
    if (r)
      return tYt(my("id", r, e)[0], t);
  } else if (n.className.includes("popupAnnotation") || n.className.includes("textAnnotation"))
    BE(n);
  else if (n.className.includes("fileAttachmentAnnotation")) {
    BE(n);
    const r = n.dataset.annotationId;
    if (r && i.type === "dblclick")
      return qCt(my("id", r, e)[0]);
  } else if (n.className.includes("textWidgetAnnotation") && i.type === "input") {
    let r = n.getElementsByTagName("input")[0];
    return r || (r = n.getElementsByTagName("textarea")[0]), rb(r);
  } else {
    if (n.className.includes("choiceWidgetAnnotation") && i.type === "input")
      return rb(n.getElementsByTagName("select")[0]);
    if (n.className.includes("buttonWidgetAnnotation checkBox") && i.type === "change")
      return rb(n.getElementsByTagName("input")[0]);
    if (n.className.includes("buttonWidgetAnnotation radioButton") && i.type === "change") {
      const r = n.dataset.annotationId;
      if (r) {
        const a = my("id", r, e)[0], o = [];
        for (const l of my("fieldName", a.fieldName, e))
          l.buttonValue && o.push(l.buttonValue);
        return rb(n.getElementsByTagName("input")[0], {
          value: a.buttonValue,
          defaultValue: a.fieldValue,
          options: o
        });
      }
    } else if (n.className.includes("buttonWidgetAnnotation pushButton") && i.type === "click") {
      const r = n.dataset.annotationId;
      if (r) {
        const a = my("id", r, e)[0];
        return a.resetForm ? rb(
          { name: a.fieldName, type: "button" },
          { actions: a.actions, reset: !0 }
        ) : rb(
          { name: a.fieldName, type: "button" },
          { actions: a.actions, reset: !1 }
        );
      }
    }
  }
}
class FX {
  constructor() {
    S(this, "externalLinkEnabled");
    this.externalLinkEnabled = !0;
  }
  goToXY(t, e, n) {
  }
  /**
     * @type {number}
     */
  get pagesCount() {
    return 0;
  }
  /**
     * @type {number}
     */
  get page() {
    return 0;
  }
  /**
     * @param {number} _value
     */
  set page(t) {
  }
  /**
     * @type {number}
     */
  get rotation() {
    return 0;
  }
  /**
     * @param {number} _value
     */
  set rotation(t) {
  }
  /**
     * @type {boolean}
     */
  get isInPresentationMode() {
    return !1;
  }
  /**
     * @param {string|Array} _dest - The named, or explicit, PDF destination.
     */
  async goToDestination(t) {
  }
  /**
     * @param {number|string} _val - The page number, or page label.
     */
  goToPage(t) {
  }
  /**
     * @param {HTMLAnchorElement} link
     * @param {string} url
     * @param {boolean} [_newWindow]
     */
  addLinkAttributes(t, e, n = !1) {
  }
  /**
     * @param _dest - The PDF destination object.
     * @returns {string} The hyperlink to the PDF object.
     */
  getDestinationHash(t) {
    return "#";
  }
  /**
     * @param _hash - The PDF parameters/hash.
     * @returns {string} The hyperlink to the PDF object.
     */
  getAnchorUrl(t) {
    return "#";
  }
  /**
     * @param {string} _hash
     */
  setHash(t) {
  }
  /**
     * @param {string} _action
     */
  executeNamedAction(t) {
  }
  /**
     * @param {Object} _action
     */
  executeSetOCGState(t) {
  }
  /**
     * @param {number} _pageNum - page number.
     * @param {Object} _pageRef - reference to the page.
     */
  cachePageRef(t, e) {
  }
}
const nYt = /* @__PURE__ */ Ne({
  __name: "AnnotationLayer",
  props: {
    page: {},
    viewport: {},
    document: {},
    annotationsFilter: {},
    annotationsMap: {},
    imageResourcesPath: {},
    hideForms: { type: Boolean },
    enableScripting: { type: Boolean },
    intent: {}
  },
  emits: ["annotation", "annotationLoaded"],
  setup(i, { emit: t }) {
    const e = i, n = t, s = Lt(), r = Lt();
    function a(d) {
      const h = eYt(d, e.document, r.value);
      Promise.resolve(h).then((p) => {
        p && n("annotation", p);
      });
    }
    async function o() {
      var d;
      return await ((d = ge(e.document)) == null ? void 0 : d.getFieldObjects());
    }
    async function l() {
      var d;
      return await ((d = ge(e.document)) == null ? void 0 : d.hasJSActions());
    }
    async function c() {
      var h;
      let d = await ((h = e.page) == null ? void 0 : h.getAnnotations({ intent: e.intent }));
      if (e.annotationsFilter) {
        const p = e.annotationsFilter;
        d = d.filter((m) => {
          const b = m.subtype, y = m.fieldType ? `${b}.${m.fieldType}` : null;
          return (p == null ? void 0 : p.includes(b)) || y !== null && (p == null ? void 0 : p.includes(y));
        });
      }
      return d;
    }
    async function u() {
      var g, f;
      (f = (g = s.value).replaceChildren) == null || f.call(g);
      for (const T of AE)
        s.value.removeEventListener(T, a);
      const d = ge(e.document), h = e.page, p = e.viewport;
      r.value = await c();
      const m = /* @__PURE__ */ new Map([]);
      for (const T of r.value)
        if (T.subtype === "Widget" && T.fieldType === "Btn" && T.pushButton) {
          const M = T.rect[2] - T.rect[0], N = T.rect[3] - T.rect[1], W = document.createElement("canvas");
          W.setAttribute("width", (M * p.scale).toString()), W.setAttribute("height", (N * p.scale).toString()), m.set(T.id, W);
        }
      const b = d.annotationStorage;
      if (e.annotationsMap)
        for (const [T, M] of Object.entries(e.annotationsMap))
          b.setValue(T, M);
      const y = {
        accessibilityManager: void 0,
        annotationCanvasMap: m,
        div: s.value,
        page: h,
        viewport: p.clone({ dontFlip: !0 }),
        annotationEditorUIManager: null,
        l10n: null,
        annotationStorage: b,
        linkService: new FX(),
        commentManager: null,
        structTreeLayer: null
      }, Z = {
        annotations: r.value,
        viewport: p.clone({ dontFlip: !0 }),
        linkService: new FX(),
        annotationCanvasMap: m,
        div: s.value,
        annotationStorage: b,
        renderForms: !e.hideForms,
        page: h,
        enableScripting: !1,
        hasJSActions: await l(),
        fieldObjects: await o(),
        downloadManager: null,
        imageResourcesPath: e.imageResourcesPath
      };
      new tG(y).render(Z).then(async () => {
        n("annotationLoaded", await c());
      });
      for (const T of AE)
        s.value.addEventListener(T, a);
    }
    return gn(() => e.viewport, () => {
      e.page && e.viewport && s.value && u();
    }), xn(() => {
      e.page && e.viewport && s.value && u();
    }), (d, h) => (Mt(), Ot("div", {
      ref_key: "layer",
      ref: s,
      class: "annotationLayer",
      style: { display: "block" }
    }, null, 512));
  }
});
function iYt(i, t, e) {
  const n = [];
  for (const u of i.items)
    n.push(u.str), u.hasEOL && n.push(`
`);
  let s = n.join("");
  s = s.replace(new RegExp("(?<=\\p{Ideographic}|[\\u3040-\\u30FF])\\n(\\p{Ideographic}|[\\u3040-\\u30FF])", "gmu"), "$1"), s = s.replace(new RegExp("(?<=\\S)-\\n", "gmu"), ""), s = s.replace(/\n/g, " ");
  const r = ["g"];
  e.ignoreCase && r.push("i");
  let a = t.trim().replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  e.completeWords && (a = `\\b${a}\\b`);
  const o = new RegExp(a, r.join("")), l = [];
  let c;
  for (; (c = o.exec(s)) !== null; )
    l.push([c.index, c[0].length, c[0]]);
  return l;
}
function sYt(i, t) {
  function e(l, c, u) {
    if (l.hasEOL && l.str.length === 0) {
      const d = c == null ? void 0 : c.str[c.str.length - 1], h = u == null ? void 0 : u.str[0], p = new RegExp(new RegExp("(\\p{Ideographic}|[\\u3040-\\u30FF])", "u"));
      if (d && p.test(d) && h && p.test(h))
        return 0;
    }
    return l.hasEOL ? l.str.endsWith("-") ? -1 : 1 : 0;
  }
  let n = 0, s = 0;
  const r = t.items, a = r.length - 1, o = [];
  for (let l = 0; l < i.length; l++) {
    let c = i[l][0];
    for (; n !== a && c >= s + r[n].str.length; ) {
      const h = r[n];
      s += h.str.length + e(
        h,
        n - 1 < 0 ? null : r[n - 1],
        n + 1 >= r.length ? null : r[n + 1]
      ), n++;
    }
    const u = {
      idx: n,
      offset: c - s
    };
    for (c += i[l][1]; n !== a && c > s + r[n].str.length; ) {
      const h = r[n];
      s += h.str.length + e(
        h,
        n - 1 < 0 ? null : r[n - 1],
        n + 1 >= r.length ? null : r[n + 1]
      ), n++;
    }
    const d = {
      idx: n,
      offset: c - s
    };
    o.push({
      start: u,
      end: d,
      str: i[l][2],
      oindex: i[l][0]
    });
  }
  return o;
}
function rYt(i, t, e) {
  function n(s, r = -1, a = -1) {
    const o = t.items[s], l = [];
    let c = "", u = "", d = "", h = e[s];
    if (!h)
      return;
    if (h.nodeType === Node.TEXT_NODE) {
      const b = document.createElement("span");
      h.before(b), b.append(h), e[s] = b, h = b;
    }
    r >= 0 && a >= 0 ? c = o.str.substring(r, a) : r < 0 && a < 0 ? c = o.str : r >= 0 ? c = o.str.substring(r) : a >= 0 && (c = o.str.substring(0, a));
    const p = document.createTextNode(c), m = document.createElement("span");
    if (m.className = "highlight appended", m.append(p), l.push(m), r > 0)
      if (h.childNodes.length === 1 && h.childNodes[0].nodeType === Node.TEXT_NODE) {
        u = o.str.substring(0, r);
        const b = document.createTextNode(u);
        l.unshift(b);
      } else {
        let b = 0;
        const y = [];
        for (const Z of h.childNodes) {
          const g = Z.nodeType === Node.TEXT_NODE ? Z.nodeValue : Z.firstChild.nodeValue;
          b += g.length, b <= r ? y.push(Z) : r >= b - g.length && a <= b && y.push(document.createTextNode(g.substring(0, r - (b - g.length))));
        }
        l.unshift(...y);
      }
    if (a > 0) {
      d = o.str.substring(a);
      const b = document.createTextNode(d);
      l.push(b);
    }
    h.replaceChildren(...l);
  }
  for (const s of i.sort((r, a) => r.oindex - a.oindex))
    if (s.start.idx === s.end.idx)
      n(s.start.idx, s.start.offset, s.end.offset);
    else
      for (let r = s.start.idx, a = s.end.idx; r <= a; r++)
        r === s.start.idx ? n(r, s.start.offset) : r === s.end.idx ? n(r, -1, s.end.offset) : n(r);
}
function aYt(i, t) {
  const e = i.items.map((n) => n.str);
  for (let n = 0; n < t.length; n++) {
    const s = t[n];
    if (s && s.nodeType !== Node.TEXT_NODE) {
      const r = document.createTextNode(e[n]);
      s.replaceChildren(r);
    }
  }
}
function oYt(i, t, e) {
  const n = [];
  for (const s of i) {
    const r = iYt(t, s, e);
    n.push(...sYt(r, t));
  }
  return n;
}
const lYt = /* @__PURE__ */ Ne({
  __name: "TextLayer",
  props: {
    page: {},
    viewport: {},
    highlightText: {},
    highlightOptions: {},
    highlightPages: {}
  },
  emits: ["highlight", "textLoaded"],
  setup(i, { emit: t }) {
    const e = i, n = t, s = Lt(), r = Lt();
    let a = [], o = null;
    function l() {
      return Object.assign(
        {},
        {
          ignoreCase: !0,
          completeWords: !1
        },
        e.highlightOptions
      );
    }
    async function c(m = !1) {
      const b = e.page, y = await (b == null ? void 0 : b.getTextContent());
      if (y && (m && aYt(y, a), e.highlightText && (!e.highlightPages || e.highlightPages.includes(b.pageNumber)))) {
        const Z = typeof e.highlightText == "string" ? [e.highlightText] : e.highlightText, g = oYt(
          Z,
          y,
          l()
        );
        rYt(g, y, a), n("highlight", {
          matches: g,
          textContent: y,
          textDivs: a,
          page: (b == null ? void 0 : b.pageNumber) || 1
        });
      }
    }
    async function u() {
      var g, f;
      o == null || o.cancel(), (f = (g = s.value).replaceChildren) == null || f.call(g);
      const m = e.page, b = e.viewport, y = m == null ? void 0 : m.streamTextContent({
        includeMarkedContent: !0,
        disableNormalization: !0
      }), Z = new Gg({
        container: s.value,
        textContentSource: y,
        viewport: b
      });
      o = Z;
      try {
        await Z.render(), a = Z.textDivs;
        const T = await (m == null ? void 0 : m.getTextContent());
        n("textLoaded", { textDivs: a, textContent: T }), d(), c();
      } catch {
      }
    }
    function d() {
      var b;
      const m = document.createElement("div");
      m.className = "endOfContent", (b = s.value) == null || b.appendChild(m), r.value = m;
    }
    function h() {
      r.value && r.value.classList.add("active");
    }
    function p() {
      r.value && r.value.classList.remove("active");
    }
    return gn(
      () => e.viewport,
      (m) => {
        e.page && e.viewport && s.value && u();
      }
    ), gn(
      () => [e.highlightText, e.highlightOptions],
      (m) => {
        c(!0);
      },
      { deep: !0 }
    ), xn(() => {
      e.page && e.viewport && s.value && u();
    }), (m, b) => (Mt(), Ot("div", {
      ref_key: "layer",
      ref: s,
      class: "textLayer",
      style: { display: "block" },
      onMousedown: h,
      onMouseup: p
    }, null, 544));
  }
}), cYt = /* @__PURE__ */ Ne({
  __name: "XFALayer",
  props: {
    page: {},
    document: {},
    viewport: {}
  },
  emits: ["xfaLoaded"],
  setup(i, { emit: t }) {
    const e = i, n = t, s = Lt();
    async function r() {
      var c, u;
      (u = (c = s.value).replaceChildren) == null || u.call(c);
      const a = ge(e.document), o = e.page, l = e.viewport;
      if (a.isPureXfa) {
        const d = await o.getXfa(), h = {
          div: s.value,
          viewport: l.clone({ dontFlip: !0 }),
          linkService: new FX(),
          annotationStorage: a == null ? void 0 : a.annotationStorage,
          xfaHtml: d
        };
        QC.render(h), n("xfaLoaded");
      }
    }
    return gn(() => e.viewport, (a) => {
      e.page && e.viewport && s.value && r();
    }), xn(() => {
      e.page && e.viewport && s.value && r();
    }), (a, o) => (Mt(), Ot("div", {
      ref_key: "layer",
      ref: s,
      style: { display: "block" }
    }, null, 512));
  }
}), C4 = /* @__PURE__ */ Ne({
  __name: "VuePDF",
  props: {
    pdf: {},
    page: { default: 1 },
    scale: { default: 1 },
    rotation: {},
    fitParent: { type: Boolean },
    width: {},
    height: {},
    textLayer: { type: Boolean },
    autoDestroy: { type: Boolean, default: !1 },
    imageResourcesPath: {},
    hideForms: { type: Boolean },
    intent: { default: "display" },
    annotationLayer: { type: Boolean },
    annotationsFilter: {},
    annotationsMap: {},
    watermarkText: {},
    watermarkOptions: {},
    highlightText: {},
    highlightOptions: {},
    highlightPages: {}
  },
  emits: ["annotation", "highlight", "loaded", "textLoaded", "annotationLoaded", "xfaLoaded"],
  setup(i, { expose: t, emit: e }) {
    const n = i, s = e, r = Lt(), a = Lt(), o = Lt(!1);
    let l;
    const c = te(() => ({
      viewport: void 0,
      document: void 0,
      page: void 0
    })), u = te(() => ({
      annotationsMap: n.annotationsMap,
      annotationsFilter: n.annotationsFilter,
      imageResourcesPath: n.imageResourcesPath,
      hideForms: n.hideForms,
      intent: n.intent
    })), d = te(() => ({
      highlightText: n.highlightText,
      highlightOptions: n.highlightOptions,
      highlightPages: n.highlightPages
    }));
    function h() {
      return Object.assign(
        {},
        {
          columns: 4,
          rows: 4,
          rotation: 45,
          fontSize: 18,
          color: "rgba(211, 210, 211, 0.4)"
        },
        n.watermarkOptions
      );
    }
    function p(x) {
      if (!(typeof x == "number" && x % 90 === 0)) return 0;
      const V = x / 90;
      return V > 4 ? p(x - 360) : V < 0 ? p(x + 360) : x;
    }
    function m(x) {
      let V = n.scale;
      if (n.fitParent) {
        const X = r.value.parentNode.clientWidth, C = x.getViewport({ scale: 1 }).width;
        V = X / C;
      } else if (n.width) {
        const X = x.getViewport({ scale: 1 }).width;
        V = n.width / X;
      } else if (n.height) {
        const X = x.getViewport({ scale: 1 }).height;
        V = n.height / X;
      }
      return V;
    }
    function b(x = 1) {
      if (!n.watermarkText) return;
      const V = y();
      if (!V) return;
      const X = V.getContext("2d");
      if (!X) return;
      const C = h(), R = n.watermarkText, z = C.columns, F = C.rows, P = z * F, j = C.rotation, H = C.fontSize * x;
      X.font = `${H}px Trebuchet MS`, X.fillStyle = C.color;
      for (let B = 0; B < P; B++) {
        const $ = B % z * (V.width / z) + V.width / (z * 2), A = Math.floor(B / z) * (V.height / F) + V.height / (F * 2), E = X.measureText(R).width;
        X.save(), X.translate($, A), X.rotate(-j * (Math.PI / 180)), X.fillText(R, -E / 2, H / 2), X.restore();
      }
    }
    function y() {
      var V;
      let x = null;
      return (V = r.value) == null || V.childNodes.forEach((X) => {
        X.tagName === "CANVAS" && (x = X);
      }), x;
    }
    function Z(x) {
      var R, z, F;
      let V;
      const X = y();
      X && (X == null ? void 0 : X.getAttribute("role")) === "main" ? V = X : (V = document.createElement("canvas"), V.style.display = "block", V.setAttribute("dir", "ltr"));
      const C = window.devicePixelRatio || 1;
      return V.width = Math.floor(x.width * C), V.height = Math.floor(x.height * C), V.style.width = `${Math.floor(x.width)}px`, V.style.height = `${Math.floor(x.height)}px`, (R = r.value) == null || R.style.setProperty("--scale-factor", `${x.scale}`), (z = r.value) == null || z.style.setProperty("--user-unit", `${x.userUnit}`), (F = r.value) == null || F.style.setProperty("--total-scale-factor", "calc(var(--scale-factor) * var(--user-unit))"), a.value.style.width = `${Math.floor(x.width)}px`, a.value.style.height = `${Math.floor(x.height)}px`, a.value.style.top = "0", a.value.style.left = "0", o.value = !0, V;
    }
    function g() {
      l && l.cancel();
    }
    function f(x) {
      var V;
      (V = ge(c.value.document)) == null || V.getPage(x).then((X) => {
        var $;
        g();
        const C = X.getViewport(), R = {
          scale: m(X),
          rotation: p((n.rotation || 0) + C.rotation)
        }, z = X.getViewport(R), F = y(), P = Z(z), j = window.devicePixelRatio || 1, H = j !== 1 ? [j, 0, 0, j, 0, 0] : void 0, B = {
          canvas: P,
          viewport: z,
          annotationMode: n.hideForms ? Yc.ENABLE : Yc.ENABLE_FORMS,
          transform: H,
          intent: n.intent
        };
        (P == null ? void 0 : P.getAttribute("role")) !== "main" ? F && (($ = r.value) == null || $.replaceChild(P, F)) : P.removeAttribute("role"), c.value.page = X, c.value.viewport = z, l = X.render(B), l.promise.then(() => {
          o.value = !1, b(z.scale), s("loaded", c.value.viewport);
        }).catch(() => {
        });
      });
    }
    function T(x) {
      x.promise.then(async (V) => {
        c.value.document = V, f(n.page);
      });
    }
    gn(
      () => n.pdf,
      (x, V) => {
        g(), V && V !== x && !n.autoDestroy && V.destroy(), x !== void 0 && T(x);
      }
    ), gn(
      () => [
        n.scale,
        n.width,
        n.height,
        n.rotation,
        n.page,
        n.hideForms,
        n.intent
      ],
      () => {
        f(n.page);
      }
    ), xn(() => {
      n.pdf !== void 0 && T(n.pdf);
    }), wg(() => {
      var x;
      n.autoDestroy && ((x = n.pdf) == null || x.destroy());
    });
    function M() {
      var x;
      (x = n.pdf) == null || x.destroy();
    }
    function N() {
      f(n.page);
    }
    function W() {
      g();
    }
    return t({
      reload: N,
      cancel: W,
      destroy: M
    }), (x, V) => {
      var X, C;
      return Mt(), Ot("div", {
        ref_key: "container",
        ref: r,
        style: { position: "relative", display: "block" }
      }, [
        V[5] || (V[5] = kt("canvas", {
          dir: "ltr",
          style: { display: "block" },
          role: "main"
        }, null, -1)),
        i.annotationLayer ? (Mt(), le(nYt, HM({ key: 0 }, { ...c.value, ...u.value }, {
          onAnnotation: V[0] || (V[0] = (R) => s("annotation", R)),
          onAnnotationLoaded: V[1] || (V[1] = (R) => s("annotationLoaded", R))
        }), null, 16)) : Qt("", !0),
        i.textLayer ? (Mt(), le(lYt, HM({ key: 1 }, { ...c.value, ...d.value }, {
          onHighlight: V[2] || (V[2] = (R) => s("highlight", R)),
          onTextLoaded: V[3] || (V[3] = (R) => s("textLoaded", R))
        }), null, 16)) : Qt("", !0),
        Pt(cYt, HM({ ...c.value }, {
          onXfaLoaded: V[4] || (V[4] = (R) => s("xfaLoaded"))
        }), null, 16),
        as(kt("div", {
          ref_key: "loadingLayer",
          ref: a,
          style: { position: "absolute" }
        }, [
          Jh(x.$slots, "default")
        ], 512), [
          [Ss, o.value]
        ]),
        Jh(x.$slots, "overlay", {
          width: (X = c.value.viewport) == null ? void 0 : X.width,
          height: (C = c.value.viewport) == null ? void 0 : C.height
        })
      ], 512);
    };
  }
}), uYt = "data:text/javascript;base64,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";
function dYt(i) {
  return !!(typeof i == "object" && i && "gen" in i && "num" in i);
}
async function hYt(i, t) {
  return typeof t == "string" ? i.getDestination(t) : t;
}
async function pYt(i, t) {
  return t && dYt(t[0]) ? t[0] : null;
}
const mYt = (i) => i.type === "XYZ" && i.spec.length === 3, bYt = (i) => i.type === "Fit" && i.spec.length === 0, fYt = (i) => i.type === "FitH" && i.spec.length === 1, gYt = (i) => i.type === "FitV" && i.spec.length === 1, yYt = (i) => i.type === "FitR" && i.spec.length === 4, ZYt = (i) => i.type === "FitB" && i.spec.length === 0, TYt = (i) => i.type === "FitBH" && i.spec.length === 1, MYt = (i) => i.type === "FitBV" && i.spec.length === 1;
function NYt(i, t) {
  const e = { type: i, spec: t };
  return mYt(e) || bYt(e) || fYt(e) || gYt(e) || yYt(e) || ZYt(e) || TYt(e) || MYt(e) ? e : (console.warn("no location type found for ", i, t), null);
}
const WYt = (i) => i && i.every((t) => !isNaN(t));
async function GYt() {
  return new Promise((i, t) => {
    const e = document.createElement("iframe");
    e.width = "0px", e.height = "0px", e.style.cssText = "position: absolute; top:0; left:0", e.style.display = "none", e.onload = function() {
      i(e);
    }, document.body.appendChild(e);
  });
}
function wYt(i, t, e) {
  const n = i.document.createElement("style");
  n.textContent = `
    @page {
      margin: 0;
      size: ${t}pt ${e}pt;
    }
    body {
      margin: 0;
      width: 100%;
    }
    canvas {
      page-break-after: always;
      page-break-before: avoid;
      page-break-inside: avoid;
    }
  `, i.document.head.appendChild(n);
}
function xYt(i) {
  Wo.workerSrc = i;
}
function Y4(i, t = {
  onProgress: void 0,
  onPassword: void 0,
  onError: void 0,
  password: ""
}) {
  Wo != null && Wo.workerSrc || xYt(uYt);
  const e = gb(), n = gb(), s = gb(0), r = gb({});
  function a(d) {
    e.value && e.value.destroy(), n.value && n.value.destroy();
    const h = VK(d);
    if (t.onProgress && (h.onProgress = t.onProgress), t.onPassword)
      h.onPassword = t.onPassword;
    else if (t.password) {
      const p = (m, b) => {
        m(t.password ?? "");
      };
      h.onPassword = p;
    }
    h.promise.then(
      async (p) => {
        n.value = p, e.value = p.loadingTask, s.value = p.numPages;
        const m = await p.getMetadata(), b = await p.getAttachments(), y = await p.getJSActions(), Z = await p.getOutline();
        r.value = {
          metadata: m,
          attachments: b,
          javascript: y,
          outline: Z
        };
      },
      (p) => {
        typeof t.onError == "function" && t.onError(p);
      }
    );
  }
  async function o(d) {
    var f;
    const h = await ((f = e.value) == null ? void 0 : f.promise);
    if (!h)
      return null;
    const p = await hYt(h, d), m = await pYt(h, p);
    if (!m || !p)
      return null;
    const b = await h.getPageIndex(m), y = p[1].name, Z = p.slice(2), g = WYt(Z) ? NYt(y, Z) : null;
    return { pageIndex: b, location: g ?? { type: "Fit", spec: [] } };
  }
  async function l() {
    if (!n.value)
      throw new Error("Current PDFDocumentProxy have not loaded yet");
    try {
      return await n.value.saveDocument();
    } catch (d) {
      return console.error("Error saving PDF document:", d), await n.value.getData();
    }
  }
  async function c(d = "filename") {
    const h = await l(), p = new Blob([h], { type: "application/pdf" }), m = URL.createObjectURL(p), b = document.createElement("a");
    document.body.appendChild(b), b.href = m, b.download = d, b.style.display = "none", b.click(), setTimeout(() => {
      URL.revokeObjectURL(m), document.body.removeChild(b);
    }, 10);
  }
  async function u(d = 150, h = "filename") {
    var f;
    if (!e.value)
      throw new Error("Current PDFDocumentLoadingTask have not loaded yet");
    const p = await e.value.promise, m = d / 72, b = 96 / 72, y = await GYt(), Z = y.contentWindow;
    Z.document.title = h;
    const g = [...Array(p.numPages).keys()].map((T) => T + 1);
    for (const T of g) {
      const M = await p.getPage(T), N = M.getViewport({ scale: 1 });
      T === 1 && wYt(
        Z,
        N.width * m / b,
        N.height * m / b
      );
      const W = document.createElement("canvas");
      W.width = N.width * m, W.height = N.height * m;
      const x = W.cloneNode();
      Z == null || Z.document.body.appendChild(x), await (M == null ? void 0 : M.render({
        canvas: W,
        intent: "print",
        transform: [m, 0, 0, m, 0, 0],
        viewport: N
      }).promise), (f = x.getContext("2d")) == null || f.drawImage(W, 0, 0);
    }
    Z == null || Z.focus(), Z == null || Z.print(), document.body.removeChild(y);
  }
  return b7(i) ? (i.value && a(i.value), gn(i, () => {
    i.value && a(i.value);
  })) : i && a(i), {
    pdf: e,
    pages: s,
    info: r,
    print: u,
    download: c,
    getPDFDestination: o
  };
}
const SYt = { class: "flex flex-col gap-6 lg:gap-4" }, LYt = {
  key: 0,
  class: "flex justify-center"
}, VYt = {
  key: 1,
  class: "flex items-center justify-center h-[65vh]"
}, XYt = { class: "text-lg text-gray-500" }, IYt = { style: { color: "black !important" } }, v4 = /* @__PURE__ */ Ne({
  __name: "MPdfViewer",
  props: /* @__PURE__ */ rl({
    height: {}
  }, {
    assetUrl: { required: !0 },
    assetUrlModifiers: {}
  }),
  emits: ["update:assetUrl"],
  setup(i) {
    const t = zr(i, "assetUrl"), e = i, { t: n } = La(), { pdf: s, pages: r } = Y4(t), a = Lt("61vh"), o = Lt(!1), l = () => {
      if (e.height) {
        a.value = e.height;
        return;
      }
      if (typeof window > "u") {
        a.value = "61vh";
        return;
      }
      a.value = window.innerHeight < 1200 ? "54vh" : "61vh";
    };
    let c = !1;
    const u = () => {
      typeof window > "u" || e.height || c || (window.addEventListener("resize", l), c = !0);
    }, d = () => {
      typeof window > "u" || !c || (window.removeEventListener("resize", l), c = !1);
    };
    xn(() => {
      o.value = !0, l(), u();
    }), gn(
      () => e.height,
      () => {
        l(), e.height ? d() : o.value && u();
      }
    ), yr(() => {
      d();
    });
    const h = te(() => r.value > 1 ? n("shared.pages") : n("shared.page"));
    return (p, m) => {
      const b = tr("Card");
      return Mt(), le(b, { style: { background: "white" } }, {
        content: oe(() => [
          kt("div", SYt, [
            t.value ? (Mt(), Ot("div", LYt, [
              kt("div", {
                class: "flex flex-col gap-2 overflow-y-auto w-full overflow-x-hidden",
                style: xe({ height: a.value })
              }, [
                (Mt(!0), Ot(Me, null, Xn(K(r), (y) => (Mt(), Ot("div", {
                  key: y,
                  class: "w-full"
                }, [
                  Pt(K(C4), {
                    pdf: K(s),
                    page: y,
                    "fit-parent": ""
                  }, null, 8, ["pdf", "page"])
                ]))), 128))
              ], 4)
            ])) : (Mt(), Ot("div", VYt, [
              kt("p", XYt, pe(K(n)("shared.loading")), 1)
            ]))
          ])
        ]),
        footer: oe(() => [
          Pt(K(hg), { class: "justify-end" }, {
            default: oe(() => [
              kt("span", IYt, pe(h.value) + ": " + pe(K(r)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), CYt = {
  key: 2,
  class: "flex ml-2",
  style: { "align-items": "center" }
}, YYt = {
  key: 0,
  class: "flex flex-col border border-surface-500 dark:border-surface-300 tree-pane",
  style: { "border-radius": "8px 0 0 8px" }
}, vYt = { class: "mt-2" }, RYt = {
  class: "w-full h-16 flex justify-end gap-2",
  style: { background: "var(--gray-400)" }
}, DYt = { class: "table-wrapper" }, OYt = { class: "flex flex-col ml-2 gap-1 overflow-auto px-4 preview-pane" }, zYt = {
  key: 2,
  class: "text-preview"
}, EYt = { class: "flex mt-2" }, kYt = {
  key: 0,
  class: "top-yellow ml-2"
}, FYt = /* @__PURE__ */ Ne({
  __name: "UniversalFilePicker",
  props: {
    inputFiles: {},
    dropArea: { type: Boolean },
    selectFilesBtn: { type: Boolean },
    selectFolderBtn: { type: Boolean },
    accept: {},
    context: {},
    objectName: {},
    textureNameRegex: {},
    writeToWasmFS: { type: Boolean, default: !0 },
    singleSelection: { type: Boolean },
    autoOpenFolder: { type: Boolean },
    embedded: { type: Boolean },
    importTmpStls: { type: Boolean },
    showAccept: { type: Boolean, default: !1 },
    filterAssociatedFiles: { type: Boolean, default: !0 },
    showTypeColumn: { type: Boolean, default: !0 },
    hideTreeWhenNoFolders: { type: Boolean, default: !1 }
  },
  emits: ["uploadFiles", "cancel", "selectedFiles", "filesCleared"],
  setup(i, { emit: t }) {
    var nt;
    const e = i, { t: n } = La(), s = gr("dialogRef", null), r = ((nt = s == null ? void 0 : s.value) == null ? void 0 : nt.data) ?? {}, a = e.embedded ? e : { ...e, ...r }, o = !e.embedded && !!s, l = t, c = Lt([]), u = Lt([]), d = Lt([]), h = Lt(
      0
      /* INIT */
    ), p = Lt(), m = Lt([]), b = Lt(), y = Lt(), Z = Lt({}), g = Lt([]), f = Lt([]), T = te(() => {
      var et;
      return (et = m.value) == null ? void 0 : et[0];
    }), M = te(() => {
      var ot, it;
      const et = (it = (ot = T.value) == null ? void 0 : ot.name) == null ? void 0 : it.toLowerCase();
      return !!et && et.endsWith(".pdf");
    }), N = te(() => {
      var ot, it;
      const et = (it = (ot = T.value) == null ? void 0 : ot.name) == null ? void 0 : it.toLowerCase();
      return !!et && et.endsWith(".txt");
    }), W = te(() => !M.value && !Gt.value && m.value.length > 0), x = Lt(""), V = Lt(""), X = () => {
      x.value && (URL.revokeObjectURL(x.value), x.value = "");
    };
    nW(() => {
      if (!M.value || !T.value) {
        X();
        return;
      }
      X(), x.value = URL.createObjectURL(T.value);
    }), nW(async () => {
      if (!N.value || !T.value) {
        V.value = "";
        return;
      }
      try {
        V.value = await T.value.text();
      } catch {
        V.value = "";
      }
    });
    const C = async (et) => {
      if (!a.context) return;
      const ot = await a.context.getFS(), it = et.split("/").filter(Boolean);
      if (it.length <= 1) return;
      let ht = "";
      for (let lt = 0; lt < it.length - 1; lt++) {
        ht = ht ? `${ht}/${it[lt]}` : it[lt];
        try {
          ot.FS.mkdir(ht);
        } catch (mt) {
          nn.debug("Make wasm dir exception", mt);
        }
      }
    }, R = async () => {
      if (nn.debug("Wasm Cleanup"), !a.context || f.value.length === 0) return;
      const et = await a.context.getFS();
      for (const ot of f.value)
        try {
          nn.debug("Wasm Cleanup path", ot), et.FS.unlink(ot);
        } catch (it) {
          nn.debug("Unlink wasm file exception", it);
        }
      f.value = [];
    }, z = async (et) => {
      if (!a.context || a.writeToWasmFS === !1) return;
      const ot = await a.context.getFS(), it = [];
      for (const ht of et) {
        const lt = O2(ht);
        await C(lt);
        const mt = await ht.arrayBuffer();
        nn.debug("Writing file to wasm FS:", lt), ot.FS.writeFile(lt, new Int8Array(mt)), it.push(lt);
      }
      f.value = it;
    }, F = () => {
      for (let et of g.value)
        P(et);
      Z.value = { ...Z.value };
    }, P = (et) => {
      if (et.children && et.children.length) {
        Z.value[et.key] = !0;
        for (let ot of et.children)
          P(ot);
      }
    };
    function j(et, ot) {
      const it = I7(c.value, ot);
      return `${KR(c.value, ot)}-${it - 1}`;
    }
    const H = Lt(""), B = Lt(!0), $ = (et) => et.webkitRelativePath || et.name, A = async () => {
      var ht;
      if (!((ht = u.value) != null && ht.length)) return;
      c.value = [], g.value = [], p.value = [], m.value = [], y.value = {}, Z.value = {}, B.value = !0;
      const et = a.accept;
      if (d.value = u.value.slice(), a.context && await z(d.value), a.filterAssociatedFiles && (u.value = u.value.filter((lt) => !(WB(lt.name) || NB(lt.name)))), et) {
        const lt = et.split(",").map((mt) => mt.trim().toLowerCase()).filter(Boolean);
        u.value = u.value.filter((mt) => {
          const wt = mt.name.toLowerCase();
          return lt.some((At) => wt.endsWith(At));
        });
      }
      if (!u.value.length) {
        h.value = 0, B.value = !1;
        return;
      }
      u.value = Array(...u.value).sort((lt, mt) => $(lt).split("/").length < $(mt).split("/").length ? -1 : 1), h.value = 1, H.value = L7($(u.value[0]));
      let ot = H.value;
      for (let lt = 0; lt < u.value.length; lt++) {
        const mt = $(u.value[lt]).split("/"), wt = Math.max(0, mt.length - 2);
        mt[wt > 0 ? wt - 1 : 0], V7(c.value, mt[wt]) || c.value.push({
          key: wt === 0 ? "0" : j(mt[wt], mt[wt - 1]),
          label: mt[wt],
          icon: "pi pi-fw pi-folder",
          parent: wt === 0 ? "root" : mt[wt > 0 ? wt - 1 : 0],
          parentKey: KR(c.value, wt === 0 ? "root" : mt[wt > 0 ? wt - 1 : 0]),
          level: wt,
          children: []
        }), ot !== mt[wt > 0 ? wt - 1 : 0] && (ot = mt[wt > 0 ? wt - 1 : 0]);
      }
      g.value = X7(c.value), F(), E();
      const it = u.value.every((lt) => !$(lt).includes("/"));
      a.hideTreeWhenNoFolders && it && (B.value = !1);
    }, E = () => {
      var et;
      if (y.value = {
        0: !0
      }, p.value = [], u.value) {
        const ot = u.value.every((it) => !$(it).includes("/"));
        if (a.hideTreeWhenNoFolders && ot)
          p.value = u.value.slice();
        else
          for (let it = 0; it < u.value.length; it++) {
            const ht = u.value[it], lt = $(ht);
            (lt.split("/").length - 1 == 1 || lt == "") && p.value.push(ht);
          }
        b.value = u.value[0];
      }
      u.value.length == 1 ? m.value = [u.value[0]] : (et = p.value) != null && et.length && m.value.length === 0 && (m.value = [p.value[0]]);
    };
    function ct(et, ot) {
      const it = et.indexOf(ot);
      return it !== -1 ? et.substring(it + ot.length) : et;
    }
    const at = (et) => {
      var ot;
      if (p.value = [], u.value)
        for (let it = 0; it < u.value.length; it++) {
          const ht = u.value[it], lt = $(ht);
          lt.includes(et.label) && ct(lt, et.label).split("/").length - 1 == 1 && p.value.push(ht);
        }
      (ot = p.value) != null && ot.length && m.value.length === 0 && (m.value = [p.value[0]]);
    };
    xn(async () => {
      u.value = a.inputFiles || [], await A(), a.autoOpenFolder && a.selectFolderBtn && setTimeout(() => {
        const et = document.getElementById("filePickerImportProject");
        et == null || et.click();
      }, 0);
    });
    const dt = (et) => {
      gt(et);
    }, gt = (et) => {
      u.value = et, A(), l("selectedFiles", u.value);
    }, Wt = () => {
      m.value = [];
    }, Zt = async () => {
      await R(), m.value = [], p.value = [], u.value = [], d.value = [], g.value = [], c.value = [], y.value = {}, Z.value = {}, B.value = !0, h.value = 0, l("filesCleared");
    }, Gt = Lt(!1);
    gn(m, () => {
      Gt.value = m.value.findIndex((et) => p0(et.name)) != -1;
    });
    const Tt = te(() => ({ height: "35vh", "user-select": "none" })), Q = te(() => {
      var et;
      return ((et = m.value) == null ? void 0 : et.length) === 0;
    }), D = te(() => a.singleSelection ? "single" : "multiple"), q = te({
      get() {
        return a.singleSelection ? m.value[0] ?? null : m.value;
      },
      set(et) {
        a.singleSelection ? m.value = et ? [et] : [] : m.value = et ?? [];
      }
    });
    return yr(async () => {
      await R(), X();
    }), (et, ot) => {
      const it = tr("Tree"), ht = tr("Column"), lt = tr("DataTable"), mt = tr("Button");
      return Mt(), le(K(Te), { class: "flex-col w-full" }, {
        default: oe(() => {
          var wt;
          return [
            (wt = K(a).inputFiles) != null && wt.length ? Qt("", !0) : (Mt(), le(K(Te), {
              key: 0,
              class: "pb-4"
            }, {
              default: oe(() => [
                Pt(K(Te), { class: "flex-row mt-2 ml-2" }, {
                  default: oe(() => [
                    K(a).selectFolderBtn ? (Mt(), le(K(G7), {
                      key: 0,
                      iconSrc: "/icons/new_icons/ik_loadFromLibrary.svg",
                      borderRadius: "16px !important",
                      onFolderSelected: gt,
                      class: "web-rg-wiz-btn"
                    })) : Qt("", !0),
                    K(a).selectFilesBtn ? (Mt(), le(K(a3), {
                      key: 1,
                      class: Rn([K(a).selectFolderBtn ? "ml-2 web-rg-wiz-btn" : ""]),
                      accept: K(a).accept || "",
                      onFilesSelected: gt
                    }, null, 8, ["class", "accept"])) : Qt("", !0),
                    K(a).dropArea ? (Mt(), Ot("span", CYt, pe(K(n)("implant-planner.orDragAndDropFiles")), 1)) : Qt("", !0)
                  ]),
                  _: 1
                }),
                K(a).dropArea ? (Mt(), le(K(w7), {
                  key: 0,
                  accept: K(a).accept,
                  enabled: !0,
                  iconSrc: "/icons/new_icons/ik_loadFromLibrary.svg",
                  onFilesDropped: dt
                }, null, 8, ["accept"])) : Qt("", !0)
              ]),
              _: 1
            })),
            as(kt("div", null, [
              kt("div", {
                class: Rn(["flex flex-row mt-2", { "with-tree": B.value }]),
                style: xe(Tt.value)
              }, [
                B.value ? (Mt(), Ot("div", YYt, [
                  ot[6] || (ot[6] = kt("div", {
                    class: "w-full h-16",
                    style: { background: "var(--gray-400)" }
                  }, null, -1)),
                  kt("div", vYt, [
                    Pt(it, {
                      selectionKeys: y.value,
                      "onUpdate:selectionKeys": ot[0] || (ot[0] = (Xt) => y.value = Xt),
                      expandedKeys: Z.value,
                      "onUpdate:expandedKeys": ot[1] || (ot[1] = (Xt) => Z.value = Xt),
                      value: g.value,
                      selectionMode: "single",
                      class: "w-full md:w-[30rem]",
                      onNodeSelect: at
                    }, null, 8, ["selectionKeys", "expandedKeys", "value"])
                  ])
                ])) : Qt("", !0),
                kt("div", {
                  class: Rn(["flex flex-col border border-surface-500 dark:border-surface-300 table-pane px-4", { "table-pane--center": W.value }]),
                  style: xe({ borderRadius: B.value ? "0 8px 8px 0" : "16px" })
                }, [
                  kt("div", RYt, [
                    Pt(K(ye), {
                      class: "mt-1 mb-1",
                      icon: "pi pi-times",
                      label: "CLEAR SELECTION",
                      onClick: Wt
                    }),
                    Pt(K(ye), {
                      class: "mt-1 mb-1 mr-1",
                      icon: "pi pi-times",
                      label: "CLEAR FILES",
                      onClick: Zt
                    })
                  ]),
                  kt("div", DYt, [
                    Pt(lt, {
                      selection: q.value,
                      "onUpdate:selection": ot[2] || (ot[2] = (Xt) => q.value = Xt),
                      value: p.value,
                      dataKey: "name",
                      selectionMode: D.value,
                      class: "overflow-auto"
                    }, {
                      default: oe(() => [
                        K(a).singleSelection ? Qt("", !0) : (Mt(), le(ht, {
                          key: 0,
                          selectionMode: "multiple",
                          headerStyle: "width: 3rem"
                        })),
                        K(a).showTypeColumn !== !1 ? (Mt(), le(ht, { key: 1 }, {
                          body: oe(() => [...ot[7] || (ot[7] = [
                            kt("i", { class: "pi pi-image" }, null, -1)
                          ])]),
                          _: 1
                        })) : Qt("", !0),
                        Pt(ht, {
                          field: "name",
                          header: "Name"
                        }, {
                          body: oe(({ data: Xt }) => [
                            Ws(pe(Xt.name || Xt.fileName || Xt.originalName || Xt.webkitRelativePath || Xt.path || (Xt == null ? void 0 : Xt.name)), 1)
                          ]),
                          _: 1
                        }),
                        Pt(ht, {
                          field: "lastModifiedDate",
                          header: et.$t("implant-planner.dateModified")
                        }, {
                          body: oe(({ data: Xt }) => [
                            Ws(pe(new Date(Xt.lastModified || Xt.lastModifiedDate || "1970-01-01").toLocaleDateString()), 1)
                          ]),
                          _: 1
                        }, 8, ["header"]),
                        Pt(ht, {
                          field: "size",
                          header: et.$t("implant-planner.fileSize"),
                          style: { width: "7rem" }
                        }, {
                          body: oe(({ data: Xt }) => [
                            kt("span", null, pe(K(x7)(Xt.size ?? Xt.fileSize ?? 0)), 1)
                          ]),
                          _: 1
                        }, 8, ["header"])
                      ]),
                      _: 1
                    }, 8, ["selection", "value", "selectionMode"])
                  ])
                ], 6),
                kt("div", OYt, [
                  Gt.value ? (Mt(), le(GB, {
                    key: 0,
                    selectedFiles: m.value,
                    allFiles: u.value,
                    context: K(a).context,
                    cleanupFiles: !1,
                    "object-name": K(a).objectName
                  }, null, 8, ["selectedFiles", "allFiles", "context", "object-name"])) : M.value ? (Mt(), le(v4, {
                    key: 1,
                    assetUrl: x.value,
                    "onUpdate:assetUrl": ot[3] || (ot[3] = (Xt) => x.value = Xt),
                    height: "100%"
                  }, null, 8, ["assetUrl"])) : N.value ? (Mt(), Ot("pre", zYt, pe(V.value), 1)) : (Mt(), le(yC, {
                    key: 3,
                    selectedFiles: m.value,
                    allFiles: u.value
                  }, null, 8, ["selectedFiles", "allFiles"]))
                ])
              ], 6)
            ], 512), [
              [
                Ss,
                h.value === 1
                /* SELECTED_FOLDER */
              ]
            ]),
            kt("div", EYt, [
              K(a).showAccept && Q.value ? (Mt(), Ot("span", kYt, pe(et.$t("medic-web-framework.supportedTypes", { types: K(a).accept })), 1)) : Qt("", !0),
              Pt(K(S7)),
              K(a).embedded ? Qt("", !0) : (Mt(), le(mt, {
                key: 1,
                class: "p-confirm-dialog-reject p-button-outlined w-2/12 flex items-center justify-center mr-2",
                label: et.$t("shared.cancel"),
                onClick: ot[4] || (ot[4] = () => {
                  K(a).context && K(a).context.objects.clearTmpStls(), l("cancel"), K(o) && K(s) != null && K(s).close();
                })
              }, null, 8, ["label"])),
              Pt(K(ye), {
                class: "w-2/12 flex items-center justify-center",
                label: et.$t("shared.upload"),
                disabled: Q.value,
                onClick: ot[5] || (ot[5] = () => {
                  let Xt = [];
                  if (K(a).context && K(a).importTmpStls) {
                    const At = m.value.filter((he) => K(p0)(he.name)).map((he) => K(O2)(he));
                    Xt = K(a).context.objects.importTmpStlsByPaths(At);
                  }
                  l("uploadFiles", m.value, Xt), K(a).context && !K(a).importTmpStls && K(a).context.objects.clearTmpStls(), Wt(), K(o) && K(s) != null && K(s).close();
                })
              }, null, 8, ["label", "disabled"])
            ])
          ];
        }),
        _: 1
      });
    };
  }
}), jYt = /* @__PURE__ */ Dn(FYt, [["__scopeId", "data-v-c17c19e7"]]), UYt = /* @__PURE__ */ Ne({
  __name: "RegistrationErrorDialog",
  emits: ["confirm", "reject"],
  setup(i, { emit: t }) {
    const { t: e } = La(), n = gr("dialogRef"), s = n.value.data, r = t, a = Lt(!1), o = Lt();
    let l;
    const c = () => {
      r("reject"), n.value.close();
    }, u = () => {
      r("confirm"), n.value.close();
    };
    let d;
    return xn(() => {
      const h = jc(s.context.module, o.value, s.context), p = ge(s.context.contextCAD.GetMainForm());
      p && (l = p.GetErrorWidget(), l.showEvent(h)), d = new ResizeObserver((m) => {
        for (const b of m)
          b.target === o.value && (console.log("Resize 00"), l && l.resize());
      }), d.observe(o.value), setTimeout(() => {
        l && l.resize(), a.value = !0;
      }, 500);
    }), yr(() => {
      d.disconnect();
    }), (h, p) => (Mt(), le(K(Te), { style: { "flex-direction": "column", flex: "1 1 0" } }, {
      default: oe(() => [
        Pt(K(Te), {
          class: "mt-4",
          style: { flex: "1 1 0", "justify-content": "center", "align-items": "center" }
        }, {
          default: oe(() => [
            as(kt("div", {
              ref_key: "container",
              ref: o,
              class: "flex",
              style: { flex: "1 1 0", "min-height": "62vh", "max-height": "62vh", "min-width": "77vw", "max-width": "77vw", position: "relative" }
            }, null, 512), [
              [Ss, a.value]
            ])
          ]),
          _: 1
        }),
        Pt(K(Te), { class: "p-dialog-footer justify-center mt-6" }, {
          default: oe(() => [
            p[2] || (p[2] = kt("div", { class: "flex-1" }, null, -1)),
            Pt(K(Te), { class: "flex-1 flex gap-2 justify-center" }, {
              default: oe(() => [
                Pt(K(ye), {
                  label: "OK",
                  onClick: p[0] || (p[0] = (m) => u()),
                  "icon-src-height": "21px",
                  "icon-src-width": "21px",
                  iconSrc: "/icons/rg_check.svg"
                }),
                K(s).showEdit ? (Mt(), le(K(ye), {
                  key: 0,
                  label: K(e)("shared.edit"),
                  onClick: p[1] || (p[1] = (m) => c()),
                  "icon-src-height": "21px",
                  "icon-src-width": "21px",
                  iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg"
                }, null, 8, ["label"])) : Qt("", !0)
              ]),
              _: 1
            }),
            Pt(K(Te), { class: "flex-1 flex justify-end" }, {
              default: oe(() => [
                Qt("", !0)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), PYt = { style: { "min-width": "12rem" } }, JYt = ["min", "max"], AYt = { style: { "min-width": "5rem", "text-align": "right" } }, BYt = /* @__PURE__ */ Ne({
  __name: "AnalyzeThicknessDialog",
  emits: ["confirm", "reject"],
  setup(i, { emit: t }) {
    const { t: e } = La(), n = gr("dialogRef"), s = n.value.data, r = t, a = Lt(!1), o = Lt(), l = Lt(0), c = Lt(1), u = Lt(0.5);
    let d, h = null;
    const p = () => {
      d && d.SetCriticalThickness(u.value);
    }, m = () => {
      r("reject"), n.value.close();
    }, b = () => {
      r("confirm"), n.value.close();
    };
    return xn(() => {
      const y = jc(s.context.module, o.value, s.context), Z = ge(s.context.contextCAD.GetMainForm());
      Z && (d = Z.GetAnalyzeThicknessWidget(), d.showEvent(y), l.value = d.GetRangeMin(), c.value = d.GetRangeMax(), u.value = d.GetCriticalThickness(), p()), h = new ResizeObserver((g) => {
        for (const f of g)
          f.target === o.value && d && d.resize();
      }), h.observe(o.value), setTimeout(() => {
        d && d.resize(), a.value = !0;
      }, 500);
    }), yr(() => {
      h && h.disconnect();
    }), (y, Z) => (Mt(), le(K(Te), { style: { "flex-direction": "column", flex: "1 1 0" } }, {
      default: oe(() => [
        Pt(K(Te), {
          class: "mt-4",
          style: { flex: "1 1 0", "justify-content": "center", "align-items": "center" }
        }, {
          default: oe(() => [
            as(kt("div", {
              ref_key: "container",
              ref: o,
              class: "flex",
              style: { flex: "1 1 0", "min-height": "56vh", "max-height": "56vh", "min-width": "77vw", "max-width": "77vw", position: "relative" }
            }, null, 512), [
              [Ss, a.value]
            ])
          ]),
          _: 1
        }),
        Pt(K(Te), { style: { "flex-direction": "column", padding: "0 1rem", gap: "0.5rem" } }, {
          default: oe(() => [
            Pt(K(Te), { style: { "align-items": "center", gap: "0.75rem" } }, {
              default: oe(() => [
                kt("span", PYt, pe(K(e)("medic-web-engine.criticalThickness")), 1),
                as(kt("input", {
                  "onUpdate:modelValue": Z[0] || (Z[0] = (g) => u.value = g),
                  type: "range",
                  min: l.value,
                  max: c.value,
                  step: 0.01,
                  style: { flex: "1 1 0" },
                  onInput: p
                }, null, 40, JYt), [
                  [
                    f7,
                    u.value,
                    void 0,
                    { number: !0 }
                  ]
                ]),
                kt("span", AYt, pe(u.value.toFixed(2)) + " mm", 1)
              ]),
              _: 1
            }),
            Pt(K(Te), { style: { "justify-content": "space-between", "font-size": "0.85rem", opacity: "0.8" } }, {
              default: oe(() => [
                kt("span", null, pe(l.value.toFixed(2)) + " mm", 1),
                kt("span", null, pe(c.value.toFixed(2)) + " mm", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        Pt(K(Te), { class: "p-dialog-footer justify-center mt-6" }, {
          default: oe(() => [
            Pt(K(ye), {
              label: K(e)("shared.ok"),
              onClick: Z[1] || (Z[1] = (g) => b()),
              "icon-src-height": "21px",
              "icon-src-width": "21px",
              iconSrc: "/icons/rg_check.svg"
            }, null, 8, ["label"]),
            Pt(K(ye), {
              label: K(e)("shared.cancel"),
              onClick: Z[2] || (Z[2] = (g) => m()),
              "icon-src-height": "21px",
              "icon-src-width": "21px",
              iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg"
            }, null, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), KYt = {
  key: 0,
  class: "mt-2 text-xl"
}, HYt = /* @__PURE__ */ Ne({
  __name: "ImportObjectsFromPlanner",
  emits: ["proceedToImport", "cancel"],
  setup(i, { emit: t }) {
    const e = gr("dialogRef"), n = e.value.data, s = g7(n.importObjects), r = t, a = () => {
      r("proceedToImport", s.value), e.value.close();
    }, o = () => {
      r("cancel"), e.value.close();
    };
    return (l, c) => (Mt(), Ot(Me, null, [
      K(n).hideHeader ? Qt("", !0) : (Mt(), Ot("div", KYt, pe(l.$t("implant-planner.importOptions")), 1)),
      Pt(K(Te), {
        class: "flex-row-wrap gap-2 justify-center overflow-auto h-full mt-6",
        style: { "max-height": "60vh" }
      }, {
        default: oe(() => [
          Pt(K(C7), {
            items: s.value,
            "onUpdate:items": c[0] || (c[0] = (u) => s.value = u),
            "single-selected": !0
          }, null, 8, ["items"])
        ]),
        _: 1
      }),
      Pt(K(Te), { class: "p-dialog-footer justify-center" }, {
        default: oe(() => [
          Pt(K(JX), {
            autofocus: "",
            class: "mt-6",
            label: l.$t("shared.ok"),
            onClick: a
          }, null, 8, ["label"]),
          Pt(K(WT), {
            class: "mt-6",
            label: l.$t("shared.cancel"),
            onClick: c[1] || (c[1] = (u) => o())
          }, null, 8, ["label"])
        ]),
        _: 1
      })
    ], 64));
  }
}), _Yt = ["checked", "onChange"], QYt = { style: { "line-height": "1.3" } }, $Yt = /* @__PURE__ */ Ne({
  __name: "SelectLabelsToMergeDialog",
  emits: ["confirm", "reject"],
  setup(i, { emit: t }) {
    const e = gr("dialogRef"), n = e.value.data, s = t, r = te(() => Array.isArray(n.candidates) ? n.candidates : []), a = Lt(
      r.value.filter((h) => h.selected === !0).map((h) => h.id).filter((h) => Number.isInteger(h))
    );
    a.value.length === 0 && r.value.length > 0 && (a.value = [r.value[0].id]);
    const o = (h) => a.value.includes(h), l = (h, p) => {
      const m = p.target;
      m && (m.checked ? a.value.includes(h) || (a.value = [...a.value, h]) : a.value = a.value.filter((b) => b !== h));
    }, c = (h) => h.displayText && h.displayText.length > 0 ? h.displayText : h.name && h.name.length > 0 ? h.name : String(h.id), u = () => {
      s("confirm", a.value), e.value.close();
    }, d = () => {
      s("reject"), e.value.close();
    };
    return (h, p) => (Mt(), le(K(Te), { style: { "flex-direction": "column", gap: "0.75rem" } }, {
      default: oe(() => [
        Pt(K(Te), { style: { "font-size": "0.95rem" } }, {
          default: oe(() => [
            Ws(pe(K(jt)("medic-web-engine.selectComponentsToMergeDescription")), 1)
          ]),
          _: 1
        }),
        Pt(K(Te), { style: { "flex-direction": "column", "max-height": "18rem", overflow: "auto", border: "1px solid var(--p-content-border-color, #d9d9d9)", "border-radius": "8px", padding: "0.5rem" } }, {
          default: oe(() => [
            (Mt(!0), Ot(Me, null, Xn(r.value, (m) => (Mt(), Ot("label", {
              key: m.id,
              style: { display: "flex", "align-items": "flex-start", gap: "0.6rem", padding: "0.35rem 0.4rem", cursor: "pointer" }
            }, [
              kt("input", {
                type: "checkbox",
                checked: o(m.id),
                onChange: (b) => l(m.id, b)
              }, null, 40, _Yt),
              kt("span", QYt, pe(c(m)), 1)
            ]))), 128))
          ]),
          _: 1
        }),
        Pt(K(Te), { class: "p-dialog-footer justify-center" }, {
          default: oe(() => [
            Pt(K(JX), {
              autofocus: "",
              label: K(jt)("shared.ok"),
              disabled: a.value.length === 0,
              onClick: u
            }, null, 8, ["label", "disabled"]),
            Pt(K(WT), {
              label: K(jt)("shared.cancel"),
              onClick: d
            }, null, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
});
function qYt(i, t) {
  const e = jX(i, t);
  return !!(e && e.size > 0);
}
function jX(i, t) {
  try {
    const e = i.stat(t);
    if (e)
      return e;
  } catch {
    return null;
  }
  return null;
}
function KE(i, t) {
  return qYt(i, t) ? (i.unlink(t), !0) : !1;
}
function tvt(i) {
  for (const t of ["bs", "ipts", "sg", "ts", "m"])
    evt(i, t);
}
function HE(i, t, e) {
  return `${i.projectName}.${t}${e}`;
}
function evt(i, t) {
  const n = i.getFS().FS, s = HE(i, t, "pr"), r = HE(i, t, "bd"), a = jX(n, s), o = jX(n, r);
  ((a == null ? void 0 : a.size) ?? 0) > 0 && KE(n, s), ((o == null ? void 0 : o.size) ?? 0) > 0 && KE(n, r);
}
function j2(i, t) {
  try {
    const e = i.stat(t);
    if (i.isDir(e.mode)) {
      const s = i.readdir(t).filter((r) => r !== "." && r !== "..");
      for (const r of s) {
        const a = t.endsWith("/") ? t + r : t + "/" + r;
        j2(i, a);
      }
      t !== "/" && i.rmdir(t);
    } else
      i.unlink(t);
  } catch (e) {
    console.warn(`Failed to delete: ${t}`, e);
  }
}
function _E(i, t) {
  if (!i)
    return {
      label: t,
      guid: t,
      prefabricated: !1
    };
  try {
    const e = JSON.parse(i), n = typeof e.prefabricated == "boolean" ? e.prefabricated : !!Number(e.prefabricated), s = e.name || t;
    return {
      label: n ? `${s} (prefabricated)` : s,
      guid: e.guid || t,
      prefabricated: n
    };
  } catch {
    return {
      label: t,
      guid: t,
      prefabricated: !1
    };
  }
}
function nvt(i) {
  return (typeof i.name == "string" ? i.name : "").replace(/\.zip$/i, "").replace(/\.xml$/i, "");
}
function by(i) {
  if (Array.isArray(i))
    return i;
  if (i && typeof i == "object") {
    const t = i;
    if (Array.isArray(t.items))
      return t.items;
    if (Array.isArray(t.list))
      return t.list;
  }
  return [];
}
function BM(i) {
  const t = i.modelName ?? i.model_name ?? i.name ?? i.fileName, e = String(t ?? "").replace(/\.zip$/i, "").replace(/\.xml$/i, "");
  if (e)
    return {
      modelName: e,
      metadata: String(i.metadata ?? "")
    };
}
function QE(i) {
  const t = String(i.fileType ?? i.file_type ?? i.type ?? "").toLowerCase();
  return t === "xml" || t === ".xml";
}
function $E(i, t, e) {
  const n = `${e.modelName.toLowerCase()}::${e.guid.toLowerCase()}`;
  t.has(n) || (t.add(n), i.push({
    ...e,
    value: i.length
  }));
}
let ivt = 0;
const R4 = (i, t, e) => JSON.stringify([i, t, e]);
function svt(i) {
  if (!i || i === "." || i === ".." || i.includes("/") || i.includes("\\"))
    throw new Error(jt("implant-planner.invalidTeethLibraryModelName", { modelName: i }));
}
function Qy(i) {
  const t = ge(i.getWasmDocumentInstance());
  if (!t)
    throw new Error(jt("implant-planner.cadEngineUnavailable"));
  return t;
}
function KM(i, t) {
  if (!i.getContextCAD().isTeethLibraryLoadActive(t))
    throw new Error(jt("implant-planner.teethLibraryLoadCancelled"));
}
function sG(i, t) {
  try {
    i.stat(t), j2(i, t);
  } catch {
  }
}
async function rvt(i) {
  const t = [], e = /* @__PURE__ */ new Set(), n = await i.getPoolAssetList("webcadteethlibraries"), s = by(n.data);
  let r = /* @__PURE__ */ new Map();
  try {
    const o = await i.getCadLibrariesFilteredListByType("webcadteethlibraries", void 0, "xml"), l = by(o.data).map(BM).filter((c) => !!c);
    r = new Map(l.map((c) => [c.modelName, c]));
  } catch {
    r = /* @__PURE__ */ new Map();
  }
  for (const o of s) {
    const l = nvt(o);
    if (!l)
      continue;
    const c = r.get(l), u = _E(c == null ? void 0 : c.metadata, l);
    $E(t, e, {
      label: u.label,
      modelName: l,
      guid: u.guid,
      pool: "webcadteethlibraries",
      prefabricated: u.prefabricated
    });
  }
  let a = [];
  try {
    const o = await i.getCadLibrariesFilteredListByType("cadteethlibraries", void 0, "xml");
    a = by(o.data).map(BM).filter((l) => !!l);
  } catch {
    const o = await i.getCadLibrariesListByType("cadteethlibraries");
    a = by(o.data).filter(QE).map(BM).filter((c) => !!c);
  }
  if (!a.length) {
    const o = await i.getCadLibrariesListByType("cadteethlibraries");
    a = by(o.data).filter(QE).map(BM).filter((c) => !!c);
  }
  for (let o = 0; o < a.length; o++) {
    const l = _E(a[o].metadata, a[o].modelName);
    $E(t, e, {
      label: l.label,
      modelName: a[o].modelName,
      guid: l.guid,
      pool: "cadteethlibraries",
      prefabricated: l.prefabricated
    });
  }
  return t;
}
async function avt(i, t, e, n, s, r, a = !1) {
  const o = "/stlcaddb/cad_teeth_libraries/", l = e + ".zip", c = t.getContextCAD(), u = c.getTeethLibraryLoadGeneration(), d = R4(s, e, n), h = { key: d, modelName: e, guid: n, pool: s }, p = o + e;
  try {
    svt(e), KM(t, u);
    const m = c.getTeethLibraryKeyForModel(e);
    if (m && m !== d)
      throw new Error(jt("implant-planner.teethLibraryModelConflict", { modelName: e }));
    const b = c.getTeethLibraryKeyForGuid(n);
    if (b && b !== d)
      throw new Error(jt("implant-planner.teethLibraryGuidConflict", { guid: n }));
    if (!c.reserveTeethLibraryIdentity(e, n, d))
      throw new Error(jt("implant-planner.teethLibraryActiveLoadConflict", { library: e }));
    let y = Qy(t);
    if (y.HasTeethLibrary(n)) {
      if (!y.HasCADTeethLibrary(n, e))
        throw new Error(jt("implant-planner.teethLibrarySourceConflict", { guid: n }));
      c.addLoadedTeethLibrary(h);
    } else if (!c.getLoadedTeethLibrary(d)) {
      let Z = c.getTeethLibraryLoadOperation(d);
      if (!Z) {
        const g = new AbortController();
        Z = { promise: (async () => {
          const T = `${u}-${++ivt}`, M = "/stlcaddb/.teeth_library_loading", N = `${M}/${T}`, W = `${N}/${l}`, x = `${N}/${e}`, V = await i.getPoolAsset(s, l, !0, void 0, g.signal);
          KM(t, u);
          const X = Qy(t), C = t.getFS();
          t.makeDir("/stlcaddb"), t.makeDir("/stlcaddb/cad_teeth_libraries"), t.makeDir(M), t.makeDir(N);
          try {
            if (C.FS.writeFile(W, new Uint8Array(V.data)), !X.ExtractZip(W, N + "/"))
              throw new Error(jt("implant-planner.teethLibraryExtractionFailed", { library: e }));
            const R = C.FS.stat(`${x}/meta_data.xml`);
            if (!C.FS.isFile(R.mode))
              throw new Error(jt("implant-planner.teethLibraryMetadataInvalid", { library: e }));
            if (!X.ValidateTeethLibraryMetadata(`${x}/meta_data.xml`, n))
              throw new Error(jt("implant-planner.teethLibraryMetadataMismatch", { library: e }));
            KM(t, u), Qy(t), sG(C.FS, p), C.FS.rename(x, p), c.addLoadedTeethLibrary(h);
          } finally {
            sG(C.FS, N);
          }
        })(), abortController: g }, c.trackTeethLibraryLoad(d, Z);
      }
      try {
        await Z.promise;
      } finally {
        c.untrackTeethLibraryLoad(d, Z.promise);
      }
      KM(t, u), y = Qy(t);
    }
    if (!r && !y.HasTeethLibrary(n) && (y.LoadTeethLibrary(e), !y.HasTeethLibrary(n)))
      throw D4(t, e, n, s), new Error(jt("implant-planner.teethLibraryDatabaseLoadFailed", { library: e }));
  } catch (m) {
    if (c.releaseTeethLibraryIdentity(e, n, d), console.warn(`Failed to load teeth library asset ${s}/${l}: `, m), a)
      throw m;
  }
}
function D4(i, t, e, n) {
  const s = i.getContextCAD(), r = R4(n, t, e);
  if (s.forgetLoadedTeethLibrary(r), s.releaseTeethLibraryIdentity(t, e, r), !i.isDestructed()) {
    try {
      Qy(i).RemoveCADTeethLibrary(e, t);
    } catch (a) {
      console.warn(`Failed to remove teeth library ${n}/${t} from the CAD database: `, a);
    }
    i.module && sG(i.getFS().FS, `/stlcaddb/cad_teeth_libraries/${t}`);
  }
}
function ovt(i) {
  const t = "/stlcaddb/cad_teeth_libraries/", e = "/stlcaddb/.teeth_library_loading", n = i.getFS();
  try {
    j2(n.FS, t), sG(n.FS, e);
  } catch (s) {
    console.warn("Error unlinking teeth libraries from wasm: ", s);
  }
}
const lvt = ["onClick"], cvt = ["src"], uvt = { key: 1 }, dvt = ["onClick"], hvt = ["onClick"], pvt = { for: "teeth-library-select" }, mvt = /* @__PURE__ */ Ne({
  __name: "TeethLibraryReplaceDialog",
  emits: ["confirm", "reject"],
  setup(i, { emit: t }) {
    const e = gr("dialogRef"), n = e.value.data, s = t, r = PX(), a = jl(), o = Lt([]), l = Lt(), c = Lt([]), u = Lt(""), d = Lt(""), h = Lt(!0), p = Lt(!1), m = Lt(!1), b = Lt(""), y = Lt(!0), Z = Lt(!0), g = Lt(), f = n.context.settings.general.useUSStyleToothChart;
    let T, M, N = 0, W = !1, x = !1;
    const V = [], X = te(() => Array.isArray(n.request.teeth) ? n.request.teeth : []), C = te(() => n.request.mode === "library"), R = te(() => n.request.mode === "single"), z = te(() => !C.value), F = te(
      () => !h.value && !p.value && m.value && !!l.value && (!z.value || c.value.length > 0)
    ), P = (ht) => {
      const lt = ht.label.replace(/\s*\(prefabricated\)\s*$/i, "").replace(/[-_]+/g, " ").trim(), mt = lt.split(/\s+/).filter(Boolean), wt = mt[0] || lt, Xt = mt.length >= 3 ? mt[1] : "", At = (mt.length >= 3 ? mt.slice(2) : mt.slice(1)).join(" ") || lt;
      return { type: wt, subtype: Xt, name: At };
    }, j = te(() => [...new Set(o.value.map((ht) => P(ht).type))].sort((ht, lt) => ht.localeCompare(lt))), H = te(() => [
      ...new Set(
        o.value.filter((ht) => P(ht).type === u.value).map((ht) => P(ht).subtype).filter(Boolean)
      )
    ]), B = te(
      () => o.value.filter((ht) => {
        const lt = P(ht);
        return lt.type === u.value && (!d.value || lt.subtype === d.value);
      })
    ), $ = {
      ivoclar: "ivoclar.PNG",
      major: "Major.PNG",
      rg: "rg.png",
      ruthinium: "ruthinium.png",
      vita: "Vita.PNG"
    }, A = (ht) => {
      const lt = $[ht.toLowerCase()];
      return lt ? a.getAssetUrl(`/cadResources/Resources/cad/teethLibrary/${lt}`) : "";
    }, E = (ht) => {
      u.value = ht;
      const lt = l.value ? P(l.value) : void 0, mt = [
        ...new Set(
          o.value.filter((Xt) => P(Xt).type === ht).map((Xt) => P(Xt).subtype).filter(Boolean)
        )
      ];
      d.value = (lt == null ? void 0 : lt.type) === ht ? lt.subtype : mt[0] || "";
      const wt = B.value;
      (!l.value || !wt.includes(l.value)) && (l.value = wt[0]);
    }, ct = (ht) => {
      d.value = ht;
      const lt = B.value;
      (!l.value || !lt.includes(l.value)) && (l.value = lt[0]);
    }, at = (ht) => {
      l.value = ht;
    }, dt = (ht) => ht === $e.MAXILLA ? yd(f) : gd(f), gt = (ht, lt) => {
      const mt = dt(ht)[lt - 1];
      return X.value.find((wt) => wt.maxilla === (ht === $e.MAXILLA) && wt.name === mt);
    }, Wt = (ht) => dt(ht).map((lt, mt) => {
      const wt = mt + 1, Xt = gt(ht, wt), At = Xt ? c.value.includes(Xt.orderNumber) : !1;
      return {
        id: wt,
        toothName: lt,
        editMode: Xt ? x2.SELECT_ONLY : x2.NO_EDIT,
        hoverIcon: Yr.NONE,
        status: Xt ? At ? _e.OK_SELECTED : _e.OK : _e.EMPTY
      };
    }), Zt = te(() => Wt($e.MAXILLA)), Gt = te(() => Wt($e.MANDIBLE)), Tt = te(() => X.value.some((ht) => ht.maxilla)), Q = te(() => X.value.some((ht) => !ht.maxilla)), D = (ht, lt, mt) => {
      const wt = gt(mt, ht);
      wt && (R.value ? c.value = [wt.orderNumber] : c.value.includes(wt.orderNumber) ? c.value = c.value.filter((Xt) => Xt !== wt.orderNumber) : c.value = [...c.value, wt.orderNumber]);
    }, q = () => {
      T == null || T.SetJawVisibility(y.value, Z.value);
    }, nt = async (ht) => {
      const lt = ++N;
      if (m.value = !1, b.value = "", !(!ht || !T)) {
        p.value = !0;
        try {
          if (await avt(r, n.context, ht.modelName, ht.guid, ht.pool, void 0, !0), W || lt !== N)
            return;
          if (m.value = T.SetTeethLibrary(ht.guid), q(), !m.value)
            throw T.SetTeethLibrary(""), D4(n.context, ht.modelName, ht.guid, ht.pool), new Error(jt("implant-planner.teethLibraryPreviewNotRenderable", { library: ht.label }));
        } catch (mt) {
          !W && lt === N && (b.value = mt instanceof Error ? mt.message : String(mt));
        } finally {
          !W && lt === N && (p.value = !1);
        }
      }
    }, et = (ht) => x ? !1 : (x = !0, ht === void 0 ? s("reject") : s("confirm", ht), !0), ot = () => {
      const ht = l.value;
      !ht || !F.value || et(
        JSON.stringify({
          guid: ht.guid,
          orderNumbers: z.value ? c.value : []
        })
      ) && e.value.close();
    }, it = () => {
      et() && e.value.close();
    };
    return xn(async () => {
      if (C.value || (y.value = Tt.value, Z.value = Q.value), R.value) {
        const ht = n.request.initialOrderNumber;
        c.value = X.value.some((lt) => lt.orderNumber === ht) ? [ht] : X.value.length ? [X.value[0].orderNumber] : [];
      } else n.request.mode === "multiple" && (c.value = X.value.map((ht) => ht.orderNumber));
      try {
        if (o.value = await rvt(r), W)
          return;
        if (l.value = o.value.find((mt) => mt.guid === n.request.currentLibraryGuid) ?? o.value[0], !l.value)
          throw new Error(jt("implant-planner.teethLibraryNotFoundOnServer"));
        const ht = P(l.value);
        if (u.value = ht.type, d.value = ht.subtype, await dg(), W)
          return;
        const lt = ge(n.context.contextCAD.GetMainForm());
        if (T = lt == null ? void 0 : lt.GetTeethLibraryWidget(), !T || !g.value)
          throw new Error(jt("implant-planner.teethLibraryPreviewUnavailable"));
        T.showEvent(jc(n.context.module, g.value, n.context)), M = new ResizeObserver(() => T == null ? void 0 : T.resize()), M.observe(g.value), V.push(gn(l, (mt) => void nt(mt))), V.push(gn([y, Z], q)), await nt(l.value);
      } catch (ht) {
        W || (b.value = ht instanceof Error ? ht.message : String(ht));
      } finally {
        W || (h.value = !1);
      }
    }), yr(() => {
      W = !0, N++, V.splice(0).forEach((ht) => ht()), M == null || M.disconnect(), M = void 0, T = void 0, et();
    }), (ht, lt) => (Mt(), Ot(Me, null, [
      Pt(K(Te), { class: "teeth-library-dialog" }, {
        default: oe(() => [
          C.value ? (Mt(), le(K(Te), {
            key: 0,
            class: "library-browser"
          }, {
            default: oe(() => [
              Pt(K(Te), { class: "library-type-row" }, {
                default: oe(() => [
                  (Mt(!0), Ot(Me, null, Xn(j.value, (mt) => (Mt(), Ot("button", {
                    key: mt,
                    type: "button",
                    class: Rn(["library-type", { selected: u.value === mt }]),
                    onClick: (wt) => E(mt)
                  }, [
                    A(mt) ? (Mt(), Ot("img", {
                      key: 0,
                      src: A(mt),
                      alt: ""
                    }, null, 8, cvt)) : (Mt(), Ot("span", uvt, pe(mt), 1))
                  ], 10, lvt))), 128))
                ]),
                _: 1
              }),
              H.value.length ? (Mt(), le(K(Te), {
                key: 0,
                class: "library-subtype-row"
              }, {
                default: oe(() => [
                  (Mt(!0), Ot(Me, null, Xn(H.value, (mt) => (Mt(), Ot("button", {
                    key: mt,
                    type: "button",
                    class: Rn(["library-subtype", { selected: d.value === mt }]),
                    onClick: (wt) => ct(mt)
                  }, pe(mt), 11, dvt))), 128))
                ]),
                _: 1
              })) : Qt("", !0),
              Pt(K(Te), { class: "library-list" }, {
                default: oe(() => [
                  (Mt(!0), Ot(Me, null, Xn(B.value, (mt) => {
                    var wt;
                    return Mt(), Ot("button", {
                      key: `${mt.pool}:${mt.guid}`,
                      type: "button",
                      class: Rn(["library-list-item", { selected: ((wt = l.value) == null ? void 0 : wt.guid) === mt.guid }]),
                      onClick: (Xt) => at(mt)
                    }, pe(P(mt).name), 11, hvt);
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })) : (Mt(), le(K(Te), {
            key: 1,
            class: "tooth-selection-panel"
          }, {
            default: oe(() => [
              kt("label", pvt, pe(K(jt)("implant-planner.selectTeethLibrary")), 1),
              Pt(K(Ku), {
                id: "teeth-library-select",
                modelValue: l.value,
                "onUpdate:modelValue": lt[0] || (lt[0] = (mt) => l.value = mt),
                options: o.value,
                "option-label": "label",
                disabled: h.value,
                placeholder: K(jt)("implant-planner.selectTeethLibrary"),
                class: "w-full"
              }, null, 8, ["modelValue", "options", "disabled", "placeholder"]),
              Pt(K(Te), { class: "teeth-view-panel" }, {
                default: oe(() => [
                  Tt.value ? (Mt(), le(jW, {
                    key: 0,
                    "jawbone-type": K($e).MAXILLA,
                    teeth: Zt.value,
                    "use-u-s-style-tooth-chart": K(f),
                    "warning-string": "",
                    "show-lines": Q.value,
                    onToothClick: D
                  }, null, 8, ["jawbone-type", "teeth", "use-u-s-style-tooth-chart", "show-lines"])) : Qt("", !0),
                  Q.value ? (Mt(), le(jW, {
                    key: 1,
                    "jawbone-type": K($e).MANDIBLE,
                    teeth: Gt.value,
                    "use-u-s-style-tooth-chart": K(f),
                    "warning-string": "",
                    "show-lines": Tt.value,
                    onToothClick: D
                  }, null, 8, ["jawbone-type", "teeth", "use-u-s-style-tooth-chart", "show-lines"])) : Qt("", !0)
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
          Pt(K(Te), { class: "preview-panel" }, {
            default: oe(() => [
              C.value ? (Mt(), le(K(Te), {
                key: 0,
                class: "jaw-controls"
              }, {
                default: oe(() => [
                  kt("button", {
                    type: "button",
                    class: Rn({ selected: y.value }),
                    onClick: lt[1] || (lt[1] = (mt) => y.value = !y.value)
                  }, pe(K(jt)("implant-planner.maxilla")), 3),
                  kt("button", {
                    type: "button",
                    class: Rn({ selected: Z.value }),
                    onClick: lt[2] || (lt[2] = (mt) => Z.value = !Z.value)
                  }, pe(K(jt)("implant-planner.mandible")), 3)
                ]),
                _: 1
              })) : Qt("", !0),
              kt("div", {
                ref_key: "containerVtk",
                ref: g,
                class: "vtk-preview"
              }, null, 512),
              h.value || p.value ? (Mt(), le(K(Te), {
                key: 1,
                class: "preview-overlay"
              }, {
                default: oe(() => [
                  Ws(pe(K(jt)("shared.loading")) + "…", 1)
                ]),
                _: 1
              })) : Qt("", !0),
              b.value ? (Mt(), le(K(Te), {
                key: 2,
                class: "preview-error",
                role: "alert"
              }, {
                default: oe(() => [
                  Ws(pe(b.value), 1)
                ]),
                _: 1
              })) : Qt("", !0)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      Pt(K(Te), { class: "p-dialog-footer justify-center mt-4" }, {
        default: oe(() => [
          Pt(K(JX), {
            autofocus: "",
            label: K(jt)("shared.ok"),
            disabled: !F.value,
            onClick: ot
          }, null, 8, ["label", "disabled"]),
          Pt(K(WT), {
            label: K(jt)("shared.cancel"),
            onClick: it
          }, null, 8, ["label"])
        ]),
        _: 1
      })
    ], 64));
  }
}), bvt = /* @__PURE__ */ Dn(mvt, [["__scopeId", "data-v-c24935b2"]]);
function fvt(i, t, e, n) {
  const s = new gvt(i, t, e, n), r = i.xGUIHandlerInterface.extend("xGUIHandlerInterface", s);
  return new r();
}
class gvt {
  constructor(t, e, n, s) {
    S(this, "__parent");
    S(this, "context", null);
    S(this, "modals");
    S(this, "useDialog");
    S(this, "wasmModule");
    S(this, "loadingString", "");
    S(this, "infinityProgress", !1);
    S(this, "showLoading", !1);
    S(this, "cursorX", 0);
    S(this, "cursorY", 0);
    S(this, "uploadedFiles", []);
    S(this, "noJSPI", !0);
    S(this, "isIOS", !1);
    S(this, "GetInputText", async (t, e, n, s, r) => {
      var a;
      if ((a = this.context) == null || a.freezeWizardPanel(!1), this.isIOS || this.noJSPI) {
        if (!this.context || r) {
          const o = prompt("Please enter some text:");
          s.opcall(o || "");
          return;
        }
        this.modals.showTextInputModal(t, n, e).then((o) => {
          s.opcall(o || "");
        });
        return;
      } else
        return await this.modals.showTextInputModal(t, n, e) || "";
    });
    S(this, "ShowContextMenu", async (t, e) => {
      var s;
      (s = this.context) == null || s.freezeWizardPanel(!1), nn.debug("GUIEventHandler ShowContextMenu", t);
      const n = [];
      for (let r = 0; r < t.size(); r++)
        n.push(t.get(r));
      this.modals.showContextMenu(n, this.cursorX, this.cursorY).then((r) => {
        nn.debug("Selected item: ", r), r !== null ? e.opcall(r) : e.opcall(-1);
      });
    });
    S(this, "ShowContextMenu2", async (t, e) => {
      var s;
      (s = this.context) == null || s.freezeWizardPanel(!1), nn.debug("GUIEventHandler ShowContextMenu2", t);
      const n = TB(t);
      nn.debug("Parsed menu items: ", n), this.modals.showContextMenu2(n, this.cursorX, this.cursorY).then(() => {
        nn.debug("Selected item"), e.opcall(1);
      });
    });
    S(this, "ShowSaveAsDialog", async (t, e) => {
      var l, c;
      (l = this.context) == null || l.freezeWizardPanel(!1);
      let n;
      try {
        n = JSON.parse(t);
      } catch (u) {
        nn.error("ShowSaveAsDialog invalid payload", u), e.opcall("");
        return;
      }
      const s = Array.isArray(n.options) ? n.options : [], r = typeof n.selectedType == "number" ? n.selectedType : ((c = s[0]) == null ? void 0 : c.value) ?? 0, a = this.modals.showSaveAsModal;
      if (!a) {
        e.opcall("");
        return;
      }
      const o = await a(n.title ?? "Save As", n.name ?? "", s, r, n.nameLabel, n.typeLabel);
      if (!o) {
        e.opcall("");
        return;
      }
      e.opcall(
        JSON.stringify({
          name: o.name,
          type: o.type
        })
      );
    });
    S(this, "ShowTeethLibraryReplaceDialog", (t, e) => {
      var a;
      (a = this.context) == null || a.freezeWizardPanel(!1);
      let n = !1;
      const s = (o = "") => {
        if (!n) {
          n = !0;
          try {
            e.opcall(o);
          } catch (l) {
            n = !1, nn.error("ShowTeethLibraryReplaceDialog completion failed", l);
          }
        }
      };
      if (!this.context) {
        s();
        return;
      }
      let r;
      try {
        r = JSON.parse(t);
      } catch (o) {
        nn.error("ShowTeethLibraryReplaceDialog invalid payload", o), s();
        return;
      }
      if (!r.mode || !["single", "multiple", "library"].includes(r.mode)) {
        nn.error("ShowTeethLibraryReplaceDialog invalid mode", r.mode), s();
        return;
      }
      try {
        this.useDialog.open(bvt, {
          props: {
            closable: !1,
            draggable: !1,
            modal: !0,
            header: r.mode === "library" ? jt("implant-planner.teethLibrary") : r.mode === "single" ? jt("implant-planner.toothReplace") : jt("implant-planner.teethReplace"),
            style: { width: "90vw", height: "80vh", maxHeight: "calc(100vh - 2rem)", display: "flex", flexDirection: "column", overflow: "hidden" },
            contentStyle: { minHeight: 0, flex: "1 1 0", display: "flex", flexDirection: "column", overflow: "hidden" }
          },
          data: {
            context: this.context,
            request: r
          },
          emits: {
            onConfirm: (o) => s(o),
            onReject: () => s()
          },
          onClose: () => s()
        });
      } catch (o) {
        nn.error("ShowTeethLibraryReplaceDialog failed to open", o), s();
      }
    });
    S(this, "ShowAddReconstructionDialog", async (t, e, n) => {
      var r, a;
      (r = this.context) == null || r.freezeWizardPanel(!1);
      const s = () => {
        n.opcall("done!");
      };
      (a = this.context) == null || a.onShowAddReconstructionDialog.notify({ lambda: s, preSelectMode: t, preSelectWorkflow: e });
    });
    S(this, "ShowError", async (t, e, n, s, r, a) => {
      var c, u, d, h, p;
      const o = (c = this.context) == null ? void 0 : c.wizardPanelFreeze.get();
      (u = this.context) == null || u.freezeWizardPanel(!1);
      let l = !0;
      return this.isIOS || this.noJSPI ? !this.context || a ? (s ? l = confirm(t) : alert(t), r.opcall(l ? 0 : 1), o && ((d = this.context) == null || d.freezeWizardPanel(!0, !0))) : (h = this.useDialog) == null || h.open(Y7, {
        props: {
          closable: !1,
          draggable: !1,
          modal: !0,
          header: e,
          style: { width: "25vw" }
        },
        data: {
          message: t,
          showCancel: n,
          showYesNo: s
        },
        emits: {
          onConfirm: () => {
            var m;
            nn.debug("confirmed"), l = !0, r.opcall(l ? 0 : 1), o && ((m = this.context) == null || m.freezeWizardPanel(!0, !0));
          },
          onReject: () => {
            var m;
            nn.debug("rejected"), l = !1, r.opcall(l ? 0 : 1), o && ((m = this.context) == null || m.freezeWizardPanel(!0, !0));
          }
        }
      }) : (l = await this.modals.showMUErrorModal(e, t, n, s), (p = this.context) == null || p.freezeWizardPanel(!0, !0)), l;
    });
    S(this, "GetInputColor", async (t, e, n) => {
      var r;
      (r = this.context) == null || r.freezeWizardPanel(!1);
      const s = [e.get(0), e.get(1), e.get(2)];
      this.modals.showColorPickerModal(t, s).then((a) => {
        const o = new this.wasmModule.VectorInt();
        try {
          a && a.forEach((l) => {
            o.push_back(l);
          }), n.opcall(o);
        } finally {
          o.deleteLater();
        }
      });
    });
    S(this, "SelectPluginReconstruction", async (t, e, n, s) => {
      var a, o;
      (a = this.context) == null || a.freezeWizardPanel(!1);
      const r = [];
      for (let l = 0; l < t.size(); l++) {
        const c = t.get(l);
        c.length && r.push(c);
      }
      (o = this.useDialog) == null || o.open(HR, {
        props: {
          closable: !1,
          draggable: !1,
          modal: !0,
          header: e,
          style: { width: "25vw" }
        },
        data: {
          options: r,
          showCancel: n
        },
        emits: {
          onConfirm: (l) => {
            nn.debug("confirmed selected option: ", l), s.opcall(l || "");
          },
          onReject: () => {
            nn.debug("rejected"), s.opcall("");
          }
        }
      });
    });
    S(this, "ShowRegistrationRefinementDialog", async (t, e) => {
      var n, s;
      (n = this.context) == null || n.freezeWizardPanel(!1), (s = this.useDialog) == null || s.open(mXt, {
        props: {
          closable: !1,
          draggable: !1,
          modal: !0,
          header: jt("medic-web-engine.calibrationRefinement"),
          style: { width: "80vw", height: "80vh" },
          contentStyle: { height: "100%", flex: "1 1 0", display: "flex" }
        },
        data: {
          context: this.context,
          editOnly: t
        },
        emits: {
          onConfirm: async () => {
            nn.debug("confirmed"), e.opcall(1);
          },
          onReject: async () => {
            nn.debug("rejected"), e.opcall(0);
          }
        }
      });
    });
    S(this, "ShowRegistrationErrorDialog", async (t, e, n) => {
      var s, r;
      nn.debug("GUIEventHandler ShowRegistrationErrorDialog:: ", t, e), (s = this.context) == null || s.freezeWizardPanel(!1), (r = this.useDialog) == null || r.open(UYt, {
        props: {
          closable: !1,
          draggable: !1,
          modal: !0,
          header: t.length > 1 ? t : jt("medic-web-engine.registrationError"),
          style: { width: "80vw", height: "80vh" },
          contentStyle: { height: "100%", flex: "1 1 0", display: "flex", justifyContent: "center" }
        },
        data: {
          context: this.context,
          showEdit: e
        },
        emits: {
          onConfirm: async () => {
            nn.debug("confirmed"), new Promise((a, o) => {
              const l = (c) => {
                a(c);
              };
              n.opcallAsync(1, l);
            });
          },
          onReject: async () => {
            nn.debug("rejected"), new Promise((a, o) => {
              const l = (c) => {
                a(c);
              };
              n.opcallAsync(0, l);
            });
          }
        }
      });
    });
    S(this, "ShowAnalyzeThicknessDialog", async (t) => {
      var e, n;
      (e = this.context) == null || e.freezeWizardPanel(!1), (n = this.useDialog) == null || n.open(BYt, {
        props: {
          closable: !1,
          draggable: !1,
          modal: !0,
          header: jt("medic-web-engine.analyzeThickness"),
          style: { width: "80vw", height: "80vh" },
          contentStyle: { height: "100%", flex: "1 1 0", display: "flex", justifyContent: "center" }
        },
        data: {
          context: this.context
        },
        emits: {
          onConfirm: () => {
            t.opcall(1);
          },
          onReject: () => {
            t.opcall(0);
          }
        }
      });
    });
    S(this, "ShowArticulatorLibraryDialog", async (t) => {
      var e, n;
      (e = this.context) == null || e.freezeWizardPanel(!1), (n = this.useDialog) == null || n.open(wXt, {
        props: {
          closable: !1,
          draggable: !1,
          modal: !0,
          header: jt("medic-web-engine.articulatorSetup"),
          style: { width: "90vw", minHeight: "90vh" },
          contentStyle: { height: "100%", flex: "1 1 0", display: "flex", justifyContent: "space-around" }
        },
        data: {
          context: this.context
        },
        emits: {
          onConfirm: () => {
            nn.debug("confirmed"), t.opcall(1);
          },
          onReject: () => {
            nn.debug("rejected"), t.opcall(0);
          }
        }
      });
    });
    S(this, "ShowMovementMarkerLibraryDialog", async (t) => {
      var e, n;
      (e = this.context) == null || e.freezeWizardPanel(!1), (n = this.useDialog) == null || n.open(xXt, {
        props: {
          closable: !1,
          draggable: !1,
          modal: !0,
          header: jt("medic-web-engine.selectMovementMarkerSystem"),
          style: { width: "70vw", minHeight: "70vh", display: "flex" },
          contentStyle: { height: "100%", flex: "1 1 0", display: "flex" }
        },
        data: {
          context: this.context
        },
        emits: {
          onConfirm: () => {
            nn.debug("confirmed"), t.opcall(1);
          },
          onReject: () => {
            nn.debug("rejected"), t.opcall(0);
          }
        }
      });
    });
    S(this, "ShowSelectActiveReconstructionDialog", async (t) => {
      var e, n;
      (e = this.context) == null || e.freezeWizardPanel(!1), (n = this.useDialog) == null || n.open(EXt, {
        props: {
          closable: !1,
          draggable: !1,
          modal: !0,
          style: { width: "60vw" },
          showHeader: !1,
          contentStyle: { height: "100%", borderRadius: "16px" }
        },
        data: {
          context: this.context
        },
        emits: {
          onConfirm: () => {
            nn.debug("confirmed"), t.opcall(1);
          },
          onReject: () => {
            nn.debug("rejected"), t.opcall(0);
          }
        }
      });
    });
    S(this, "ShowReconstructionReviewDialog", async (t, e) => {
      var s, r;
      (s = this.context) == null || s.freezeWizardPanel(!1);
      const n = this.context ? y7(ge(this.context)) : this.context;
      (r = this.useDialog) == null || r.open(kXt, {
        props: {
          closable: !1,
          draggable: !0,
          modal: !0,
          header: jt(t ? "medic-web-engine.addRemoveTeeth" : "medic-web-engine.reviewOptions"),
          style: { width: "27rem", maxWidth: "calc(100vw - 2rem)", height: t ? "75vh" : "90vh" },
          contentStyle: { height: "100%", flex: "1 1 0", display: "flex", overflow: "hidden" }
        },
        data: {
          context: n
        },
        emits: {
          onConfirm: () => {
            e.opcall(1);
          },
          onReject: () => {
            e.opcall(0);
          }
        }
      });
    });
    S(this, "ShowOpenFileNameDialog", (t, e, n, s) => {
      var a, o;
      (a = this.context) == null || a.freezeWizardPanel(!1), nn.debug("GUIEventHandler ShowOpenFileNameDialog: ", t, e, n, n.length);
      const r = v7(n);
      (o = this.useDialog) == null || o.open(jYt, {
        props: {
          closable: !0,
          modal: !0,
          header: t,
          contentStyle: { borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }
        },
        data: {
          dropArea: !0,
          selectFilesBtn: !0,
          selectFolderBtn: !0,
          accept: n.length ? r.join(",") : void 0,
          context: this.context ?? void 0,
          singleSelection: !0,
          filterAssociatedFiles: !1,
          showTypeColumn: !1,
          hideTreeWhenNoFolders: !0,
          showAccept: !0
        },
        emits: {
          onUploadFiles: async (l) => {
            var u;
            const c = await ((u = this.context) == null ? void 0 : u.getFS());
            if (!c) {
              console.error("WasmFS not available");
              return;
            }
            if (this.uploadedFiles.length > 0)
              try {
                this.uploadedFiles.forEach((d) => {
                  c.FS.unlink(d);
                });
              } catch (d) {
                console.error("Error unlinking files: ", d);
              }
            if (l.length > 0) {
              const d = l[0], h = await d.arrayBuffer(), p = new Int8Array(h);
              c.FS.writeFile(d.name, p), this.uploadedFiles.push(d.name), s.opcall(d.name);
            }
          },
          onCancel: async () => {
            var c;
            const l = await ((c = this.context) == null ? void 0 : c.getFS());
            if (!l) {
              console.error("WasmFS not available");
              return;
            }
            if (this.uploadedFiles.length > 0)
              try {
                this.uploadedFiles.forEach((u) => {
                  l.FS.unlink(u);
                });
              } catch (u) {
                console.error("Error unlinking files: ", u);
              }
            nn.debug("onCancel called from emit"), s.opcall("");
          }
        }
      });
    });
    S(this, "ShowImportFromPlannerDialog", async (t, e, n) => {
      var a, o, l, c, u;
      (a = this.context) == null || a.freezeWizardPanel(!1);
      const s = [];
      for (let d = 0; d < t.size(); d++) {
        const h = t.get(d);
        h.length && s.push(h);
      }
      const r = [];
      if ((o = this.context) != null && o.objects)
        for (let d of s) {
          const h = {
            id: d,
            name: d,
            selected: !1,
            preview: "",
            typeCAD: UC.GENERIC
          }, p = this.context.objects.stls.get(d);
          p && (h.name = p.getGUIName(), h.preview = await lA(p, !0, (l = this.context) == null ? void 0 : l.viewConfiguration.colorScheme.get()) || ""), r.push(h);
        }
      r.length > 0 ? (c = this.useDialog) == null || c.open(HYt, {
        props: {
          closable: !1,
          draggable: !1,
          modal: !0,
          header: e,
          style: { width: "23rem" },
          contentStyle: { borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }
        },
        data: {
          importObjects: r,
          hideHeader: !0
        },
        emits: {
          onProceedToImport: (d) => {
            for (let h of d)
              if (h.selected) {
                n.opcall(h.id || "");
                return;
              }
            n.opcall("");
          },
          onCancel: () => {
            nn.debug("rejected"), n.opcall("");
          }
        }
      }) : (u = this.useDialog) == null || u.open(HR, {
        props: {
          closable: !1,
          draggable: !1,
          modal: !0,
          header: e,
          style: { width: "25vw" }
        },
        data: {
          options: s,
          showCancel: !1
        },
        emits: {
          onConfirm: (d) => {
            nn.debug("confirmed selected opjtion: ", d), n.opcall(d || "");
          },
          onReject: () => {
            nn.debug("rejected"), n.opcall("");
          }
        }
      });
    });
    S(this, "ShowSelectLabelsToMerge", async (t, e) => {
      var r;
      (r = this.context) == null || r.freezeWizardPanel(!1);
      let n;
      try {
        n = JSON.parse(t);
      } catch (a) {
        nn.error("ShowSelectLabelsToMerge invalid payload", a), e.opcall(JSON.stringify({ selectedIds: [] }));
        return;
      }
      const s = Array.isArray(n.candidates) ? n.candidates : [];
      if (s.length === 0) {
        e.opcall(JSON.stringify({ selectedIds: [] }));
        return;
      }
      if (!this.useDialog) {
        e.opcall(JSON.stringify({ selectedIds: [] }));
        return;
      }
      this.useDialog.open($Yt, {
        props: {
          closable: !1,
          draggable: !1,
          modal: !0,
          header: jt("medic-web-engine.selectComponentsToMerge"),
          style: { width: "30rem" }
        },
        data: {
          candidates: s
        },
        emits: {
          onConfirm: (a) => {
            const o = Array.isArray(a) ? a.filter((c) => Number.isInteger(c)) : [], l = Array.from(new Set(o));
            typeof n.selectedLabelId == "number" && !l.includes(n.selectedLabelId) && l.unshift(n.selectedLabelId), e.opcall(JSON.stringify({ selectedIds: l }));
          },
          onReject: () => {
            e.opcall(JSON.stringify({ selectedIds: [] }));
          }
        }
      });
    });
    S(this, "ReloadPage", () => {
      window.location.replace(window.location.href.split("?")[0] + "?nocache=" + Date.now());
    });
    S(this, "SaveProject", async (t) => {
      var e;
      (e = this.context) == null || e.freezeWizardPanel(!1), nn.debug("SaveProject"), this.context && (await this.context.saveProject(), t.opcall(1));
    });
    S(this, "ShowLoadingOverlay", () => {
      var t;
      (t = this.context) == null || t.showLoading(jt("shared.loading"), !1);
    });
    S(this, "HideLoadingOverlay", () => {
      var t;
      (t = this.context) == null || t.hideLoading();
    });
    S(this, "SetProgressBarData", (t) => {
      this.loadingString = t + " ...";
    });
    S(this, "NotifyProgressUpdate", (t) => {
      var e;
      (e = this.context) == null || e.showLoading(this.loadingString, !0, t);
    });
    S(this, "ExecuteProgress", async (t, e, n, s, r) => {
      var o;
      this.loadingString = t + " ...", this.infinityProgress = n, this.showLoading = e, nn.debug("ExecuteProgress 0", t, e, n), this.showLoading && (nn.debug("ExecuteProgress show loading"), (o = this.context) == null || o.showLoading(this.loadingString, !this.infinityProgress, 0)), nn.debug("ExecuteProgress 1");
      const a = new Promise((l, c) => {
        const u = (d) => {
          var h;
          l(d), (h = this.context) == null || h.hideLoading();
        };
        nn.debug("ExecuteProgress 2"), s.opcallAsync(1, u), nn.debug("ExecuteProgress 3");
      });
      nn.debug("ExecuteProgress 3.1"), await a, nn.debug("ExecuteProgress 4"), r.opcall(1), nn.debug("ExecuteProgress 5");
    });
    nn.debug("Creating GUIEventHandler"), this.wasmModule = t, s && (this.context = s), this.modals = e, this.useDialog = n, document.addEventListener("mousemove", (r) => {
      this.cursorX = r.clientX, this.cursorY = r.clientY;
    }), this.isIOS = o3();
  }
}
function yvt(i, t) {
  const e = new Zvt(i, t), n = i.xTabWidgetHandlerInterface.extend("xTabWidgetHandlerInterface", e);
  return new n();
}
class Zvt {
  constructor(t, e) {
    S(this, "__parent");
    S(this, "context", null);
    S(this, "wasmModule");
    S(this, "nextText", new qt("Next"));
    S(this, "prevText", new qt("Prev"));
    S(this, "nextVis", new qt(!0));
    S(this, "prevVis", new qt(!0));
    S(this, "closeVis", new qt(!1));
    S(this, "nextEnabled", new qt(!0));
    S(this, "prevEnabled", new qt(!0));
    S(this, "tabButtonsEnabled", new qt(!0));
    S(this, "undoButtonEnabled", new qt(!1));
    S(this, "redoButtonEnabled", new qt(!1));
    S(this, "undoButtonText", new qt(""));
    S(this, "redoButtonText", new qt(""));
    S(this, "proceedWithCallback", null);
    S(this, "NextButtonSetText", (t) => {
      this.nextText.set(t);
    });
    S(this, "PrevButtonSetText", (t) => {
      this.prevText.set(t);
    });
    S(this, "NextButtonSetVisibility", (t) => {
      this.nextVis.set(t);
    });
    S(this, "PrevButtonSetVisibility", (t) => {
      this.prevVis.set(t);
    });
    S(this, "CloseButtonSetVisibility", (t) => {
      this.closeVis.set(t);
    });
    S(this, "NextButtonSetEnabled", (t) => {
      this.nextEnabled.set(t);
    });
    S(this, "PrevButtonSetEnabled", (t) => {
      this.prevEnabled.set(t);
    });
    S(this, "TabButtonsSetEnabled", (t) => {
      this.tabButtonsEnabled.set(t);
    });
    S(this, "UndoButtonSetEnabled", (t) => {
      this.undoButtonEnabled.set(t);
    });
    S(this, "RedoButtonSetEnabled", (t) => {
      this.redoButtonEnabled.set(t);
    });
    S(this, "UndoButtonSetText", (t) => {
      this.undoButtonText.set(t);
    });
    S(this, "RedoButtonSetText", (t) => {
      this.redoButtonText.set(t);
    });
    S(this, "ProceedWith", async (t, e, n) => {
      if (t.size() != e.size()) {
        console.error("ProceedWith: indices and names size mismatch"), n.opcall(-1);
        return;
      }
      const s = [];
      for (let r = 0; r < e.size(); r++)
        s.push(e.get(r));
      if (this.proceedWithCallback) {
        const r = await this.proceedWithCallback(s);
        if (!r)
          n.opcall(-1);
        else {
          let a = -1;
          for (let l = 0; l < e.size(); l++)
            if (e.get(l) === r) {
              a = l;
              break;
            }
          const o = t.get(a);
          n.opcall(o);
        }
      } else
        console.error("ProceedWith: No callback set"), n.opcall(-1);
    });
    S(this, "SetProceedWithCallback", (t) => {
      this.proceedWithCallback = t;
    });
    if (console.log("Creating TabWidgetHandler"), this.wasmModule = t, e) {
      this.context = e;
      const n = R7(), s = An();
      s.watch(this.undoButtonEnabled, (r) => {
        var a;
        (a = this.context) != null && a.cadMode.get() && (r ? n.enableNavbarButtons([K0.UNDO]) : n.disableNavbarButtons([K0.UNDO]));
      }), s.watch(this.redoButtonEnabled, (r) => {
        var a;
        (a = this.context) != null && a.cadMode.get() && (r ? n.enableNavbarButtons([K0.REDO]) : n.disableNavbarButtons([K0.REDO]));
      }), s.watch(this.undoButtonText, (r) => {
        var a;
        (a = this.context) != null && a.cadMode.get() && n.addTooltips([{ button: K0.UNDO, tooltip: r }]);
      }), s.watch(this.redoButtonText, (r) => {
        var a;
        (a = this.context) != null && a.cadMode.get() && n.addTooltips([{ button: K0.REDO, tooltip: r }]);
      });
    }
  }
}
const Tvt = {
  class: "flex",
  style: { "flex-direction": "column" }
}, Mvt = { class: "flex mt-2 mb-1 text-color align-self-center" }, Nvt = {
  class: "flex",
  style: { "flex-direction": "column" }
}, Wvt = {
  class: "flex flex-row gap-1 mb-2 w-full",
  style: { height: "35px", "justify-content": "center" }
}, Gvt = {
  key: 0,
  class: "flex flex-row gap-1 mb-2 w-full"
}, wvt = {
  key: 1,
  class: "flex flex-row gap-1 mb-2 w-full"
}, xvt = { class: "mt-1" }, Svt = /* @__PURE__ */ Ne({
  __name: "FreeFormingWidgetCAD",
  setup(i) {
    const e = gr("dialogRef").value.data, { t: n } = La(), s = An(), r = Lt(e.inputToolType.get());
    e.context.contextCAD.freeFormerCAD && (r.value = e.context.contextCAD.freeFormerCAD.toolType.get(), s.watch(e.context.contextCAD.freeFormerCAD.toolType, (p) => {
      r.value = p, r.value == Wn.TOOL_NONE && (c.value = !1);
    }));
    const a = Le(e.mFrame2DVisible), o = Le(e.mFrameCutVisible), l = Le(e.activeWidget), c = Lt(e.inputToolType.get() != Wn.TOOL_NONE), u = te(() => ({
      [Wn.TOOL_NONE]: "",
      [Wn.TOOL_ADD]: n("implant-planner.add"),
      [Wn.TOOL_REMOVE]: n("weblink.remove"),
      [Wn.TOOL_SMOOTH]: n("medic-web-engine.freeformLabelSmooth"),
      [Wn.TOOL_FILL]: n("medic-web-engine.freeformLabelFill"),
      [Wn.TOOL_SCRAPE]: n("medic-web-engine.freeformLabelScrape"),
      [Wn.TOOL_RESHAPE]: n("medic-web-engine.freeformLabelLocalDeformation"),
      [Wn.TOOL_2D_PAINT]: n("medic-web-engine.freeformLabelPaint"),
      [Wn.TOOL_2D_ERASE]: n("medic-web-engine.freeformLabelErase"),
      [Wn.TOOL_2D_BRUSH]: n("medic-web-engine.freeformLabelBrush"),
      [Wn.TOOL_2D_DRAW]: n("medic-web-engine.freeformLabelLasso"),
      [Wn.TOOL_CUT_BY_AREA]: n("medic-web-engine.freeformLabelCutByArea")
    })), d = te(() => u.value[r.value]), h = async (p) => {
      console.log("Choosing tool CAD", p), p != Wn.TOOL_NONE && (c.value = !0), r.value == p ? (c.value = !1, r.value = Wn.TOOL_NONE) : r.value = p, await e.context.contextCAD.FreeFormButtonClicked(p);
    };
    return (p, m) => (Mt(), Ot("div", Tvt, [
      kt("div", Mvt, [
        kt("div", Nvt, [
          kt("div", Wvt, [
            Pt(K(ye), {
              togglable: !0,
              "is-toolbar-button": !0,
              iconSrc: "/icons/new_icons/free_form/ik_add_28.svg",
              toggled: r.value === K(Wn).TOOL_ADD,
              class: Rn({
                "flex-shrink-1": !0,
                "flex-grow-1": !0
              }),
              onToggledChange: m[0] || (m[0] = (b) => h(K(Wn).TOOL_ADD)),
              tooltip: p.$t("implant-planner.add"),
              style: { width: "35px", height: "35px", "border-radius": "8px" }
            }, null, 8, ["toggled", "tooltip"]),
            Pt(K(ye), {
              togglable: !0,
              "is-toolbar-button": !0,
              iconSrc: "/icons/new_icons/free_form/ik_remove_28.svg",
              toggled: r.value === K(Wn).TOOL_REMOVE,
              class: Rn({
                "flex-shrink-1": !0,
                "flex-grow-1": !0
              }),
              onToggledChange: m[1] || (m[1] = (b) => h(K(Wn).TOOL_REMOVE)),
              tooltip: p.$t("weblink.remove"),
              style: { width: "35px", height: "35px", "border-radius": "8px" }
            }, null, 8, ["toggled", "tooltip"]),
            Pt(K(ye), {
              togglable: !0,
              "is-toolbar-button": !0,
              iconSrc: "/icons/new_icons/free_form/ik_smooth_28.svg",
              toggled: r.value === K(Wn).TOOL_SMOOTH,
              class: Rn({
                "flex-shrink-1": !0,
                "flex-grow-1": !0
              }),
              onToggledChange: m[2] || (m[2] = (b) => h(K(Wn).TOOL_SMOOTH)),
              tooltip: p.$t("medic-web-engine.freeformLabelSmooth"),
              style: { width: "35px", height: "35px", "border-radius": "8px" }
            }, null, 8, ["toggled", "tooltip"]),
            Pt(K(ye), {
              togglable: !0,
              "is-toolbar-button": !0,
              iconSrc: "/icons/new_icons/free_form/ik_fill_28.svg",
              toggled: r.value === K(Wn).TOOL_FILL,
              class: Rn({
                "flex-shrink-1": !0,
                "flex-grow-1": !0
              }),
              onToggledChange: m[3] || (m[3] = (b) => h(K(Wn).TOOL_FILL)),
              tooltip: p.$t("medic-web-engine.freeformLabelFill"),
              style: { width: "35px", height: "35px", "border-radius": "8px" }
            }, null, 8, ["toggled", "tooltip"]),
            Pt(K(ye), {
              togglable: !0,
              "is-toolbar-button": !0,
              iconSrc: "/icons/new_icons/free_form/ik_scrape_28.svg",
              toggled: r.value === K(Wn).TOOL_SCRAPE,
              class: Rn({
                "flex-shrink-1": !0,
                "flex-grow-1": !0
              }),
              onToggledChange: m[4] || (m[4] = (b) => h(K(Wn).TOOL_SCRAPE)),
              tooltip: p.$t("medic-web-engine.freeformLabelScrape"),
              style: { width: "35px", height: "35px", "border-radius": "8px" }
            }, null, 8, ["toggled", "tooltip"]),
            Pt(K(ye), {
              togglable: !0,
              "is-toolbar-button": !0,
              iconSrc: "/icons/new_icons/free_form/ik_local_deformation_28.svg",
              toggled: r.value === K(Wn).TOOL_RESHAPE,
              class: Rn({
                "flex-shrink-1": !0,
                "flex-grow-1": !0
              }),
              onToggledChange: m[5] || (m[5] = (b) => h(K(Wn).TOOL_RESHAPE)),
              tooltip: p.$t("medic-web-engine.freeformTooltipLocalDeformation"),
              style: { width: "35px", height: "35px", "border-radius": "8px" }
            }, null, 8, ["toggled", "tooltip"])
          ]),
          K(a) ? (Mt(), Ot("div", Gvt, [
            Pt(K(ye), {
              togglable: !0,
              "is-toolbar-button": !0,
              iconSrc: "/icons/new_icons/free_form/ik_paint1_28.svg",
              toggled: r.value === K(Wn).TOOL_2D_PAINT,
              class: "flex-grow-1 flex-shrink-1 justify-content-center",
              onToggledChange: m[6] || (m[6] = (b) => h(K(Wn).TOOL_2D_PAINT)),
              tooltip: p.$t("medic-web-engine.freeformTooltipPaint2d"),
              style: { width: "35px", height: "35px", "border-radius": "8px" }
            }, null, 8, ["toggled", "tooltip"]),
            Pt(K(ye), {
              togglable: !0,
              "is-toolbar-button": !0,
              iconSrc: "/icons/new_icons/free_form/ik_erase_28.svg",
              toggled: r.value === K(Wn).TOOL_2D_ERASE,
              class: "flex-grow-1 flex-shrink-1 justify-content-center",
              onToggledChange: m[7] || (m[7] = (b) => h(K(Wn).TOOL_2D_ERASE)),
              tooltip: p.$t("medic-web-engine.freeformTooltipErase2d"),
              style: { width: "35px", height: "35px", "border-radius": "8px" }
            }, null, 8, ["toggled", "tooltip"]),
            Pt(K(ye), {
              togglable: !0,
              "is-toolbar-button": !0,
              iconSrc: "/icons/new_icons/free_form/ik_HUBrush3_28.svg",
              toggled: r.value === K(Wn).TOOL_2D_BRUSH,
              class: "flex-grow-1 flex-shrink-1 justify-content-center",
              onToggledChange: m[8] || (m[8] = (b) => h(K(Wn).TOOL_2D_BRUSH)),
              tooltip: p.$t("medic-web-engine.freeformTooltipHuBrush"),
              style: { width: "35px", height: "35px", "border-radius": "8px" }
            }, null, 8, ["toggled", "tooltip"]),
            Pt(K(ye), {
              togglable: !0,
              "is-toolbar-button": !0,
              iconSrc: "/cadResources/Resources/cad/edit/ik_selectByLasso_128.png",
              toggled: r.value === K(Wn).TOOL_2D_DRAW,
              class: "flex-grow-1 flex-shrink-1 justify-content-center",
              onToggledChange: m[9] || (m[9] = (b) => h(K(Wn).TOOL_2D_DRAW)),
              tooltip: p.$t("medic-web-engine.freeformLabelLasso"),
              style: { width: "35px", height: "35px", "border-radius": "8px" }
            }, null, 8, ["toggled", "tooltip"])
          ])) : Qt("", !0),
          K(o) ? (Mt(), Ot("div", wvt, [
            Pt(K(ye), {
              togglable: !0,
              "is-toolbar-button": !0,
              iconSrc: "/icons/new_icons/free_form/ik_cutByArea_128.svg",
              toggled: r.value === K(Wn).TOOL_CUT_BY_AREA,
              class: "flex-grow-1 flex-shrink-1 justify-content-center",
              onToggledChange: m[10] || (m[10] = (b) => h(K(Wn).TOOL_CUT_BY_AREA)),
              tooltip: p.$t("medic-web-engine.freeformLabelCutByArea"),
              style: { width: "35px", height: "35px", "border-radius": "8px" }
            }, null, 8, ["toggled", "tooltip"])
          ])) : Qt("", !0),
          c.value ? (Mt(), Ot(Me, { key: 2 }, [
            kt("div", xvt, pe(d.value), 1),
            Pt(K(w2), {
              "widget-order": [],
              "tool-title": "",
              "active-widget": K(l) ?? void 0,
              "free-former": !0,
              smallFont: !0
            }, null, 8, ["active-widget"])
          ], 64)) : Qt("", !0)
        ])
      ])
    ]));
  }
}), Lvt = /* @__PURE__ */ Dn(Svt, [["__scopeId", "data-v-c177e4c8"]]);
class Vvt {
  constructor(t, e) {
    S(this, "context");
    S(this, "useDialog");
    S(this, "state", !1);
    S(this, "activeWidget", new qt(null));
    S(this, "toolType", new qt(0));
    S(this, "mFrame2DVisible", new qt(!1));
    S(this, "mFrameCutVisible", new qt(!1));
    S(this, "freeFormingDialog", null);
    this.context = t, this.useDialog = e;
    const n = (s, r, a, o, l) => {
      var c;
      nn.debug("freeFormGUIUpdate JS callback", s, r, a, o, l), this.toolType.set(a), this.mFrame2DVisible.set(o), this.mFrameCutVisible.set(l), this.activeWidget.set(s), !this.state && r ? (this.state = !0, this.freeFormingDialog = this.useDialog.open(Lvt, {
        props: {
          modal: !1,
          closable: !1,
          header: jt("medic-web-engine.freeformTools"),
          showHeader: !0,
          position: "bottomright",
          style: { width: "260px" },
          pt: {
            header: {
              style: {
                padding: "1rem 1rem 0 1rem",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px"
              }
            },
            title: {
              style: {
                fontSize: "1.15rem"
              }
            }
          },
          contentStyle: {
            padding: "0 1rem 1rem 1rem !important",
            borderBottomLeftRadius: "8px",
            borderBottomRightRadius: "8px"
          }
        },
        data: {
          context: this.context,
          inputToolType: this.toolType,
          mFrame2DVisible: this.mFrame2DVisible,
          mFrameCutVisible: this.mFrameCutVisible,
          activeWidget: this.activeWidget
        }
      })) : this.state && !r && (this.state = !1, (c = this.freeFormingDialog) == null || c.close(), this.freeFormingDialog = null);
    };
    this.context.contextCAD.SetJSLambda(n, _o.eJSLT_FREEFORM_GUI_UPDATE);
  }
  delete() {
    var t;
    this.context.contextCAD.ClearJSLambda(_o.eJSLT_FREEFORM_GUI_UPDATE), (t = this.freeFormingDialog) == null || t.close();
  }
}
const Xvt = new Set(Object.values(Bn)), Ivt = {
  cz: Bn.CS,
  cn: Bn.ZH_HANS,
  zh: Bn.ZH_HANS,
  "zh-hans": Bn.ZH_HANS,
  zh_hans: Bn.ZH_HANS
}, Cvt = {
  [Bn.EN]: 0,
  [Bn.IT]: 1,
  [Bn.DE]: 2,
  [Bn.ES]: 3,
  [Bn.FR]: 4,
  [Bn.PT]: 5,
  [Bn.PL]: 6,
  [Bn.NL]: 7,
  [Bn.HR]: 8,
  [Bn.SL]: 9,
  [Bn.BG]: 10,
  [Bn.CS]: 11,
  [Bn.HU]: 12,
  [Bn.RO]: 13,
  [Bn.DA]: 14,
  [Bn.SV]: 15,
  [Bn.SK]: 16,
  [Bn.TR]: 17,
  [Bn.JA]: 18,
  [Bn.ZH_HANS]: 19,
  [Bn.LT]: 20
}, qE = "rg_desktop_translations", kS = "options.ini", t3 = "webcad:ini:options", Yvt = 5e3, vvt = {
  [Bn.CS]: "cz",
  [Bn.ZH_HANS]: "zh"
}, sc = (i) => typeof i == "string" ? i.trim() : "", Rvt = (i) => {
  const t = i.projectInfo, e = i.patientInfo, n = t == null ? void 0 : t.patientData, s = e == null ? void 0 : e.extra, r = sc(n == null ? void 0 : n.firstName) || sc(e == null ? void 0 : e.firstName) || sc(s == null ? void 0 : s.firstName), a = sc(n == null ? void 0 : n.lastName) || sc(e == null ? void 0 : e.lastName) || sc(s == null ? void 0 : s.lastName);
  return [r, a].filter((l) => l.length > 0).join(" ") || sc(n == null ? void 0 : n.patientName) || sc(s == null ? void 0 : s.patientName) || sc(e == null ? void 0 : e.patientName) || sc(t == null ? void 0 : t.patientName);
}, e3 = (i) => {
  if (typeof i != "string")
    return;
  const t = i.trim().toLowerCase(), e = Ivt[t];
  return e || (Xvt.has(t) ? t : Bn.EN);
};
class Dvt {
  constructor(t) {
    S(this, "context");
    S(this, "isInitialized", !1);
    S(this, "mainFormWasm", null);
    S(this, "viewInterface", null);
    S(this, "modals");
    S(this, "useDialog");
    S(this, "xAddReconstructionObject", null);
    S(this, "mPrevReconstructionType", null);
    S(this, "mLoadedTeethLibraries", /* @__PURE__ */ new Map());
    S(this, "mLoadedTeethLibraryKeysByModel", /* @__PURE__ */ new Map());
    S(this, "mLoadedTeethLibraryKeysByGuid", /* @__PURE__ */ new Map());
    S(this, "mTeethLibraryLoadOperations", /* @__PURE__ */ new Map());
    S(this, "mTeethLibraryLoadGeneration", 0);
    S(this, "mRenderWindowsCADIDs", /* @__PURE__ */ new Map());
    S(this, "mRenderWindowsCAD", /* @__PURE__ */ new Map());
    S(this, "mOGLRenderWindowsCAD", /* @__PURE__ */ new Map());
    S(this, "mUsedRenderWindows", 0);
    S(this, "resizeObserver");
    S(this, "guiEventHandler");
    S(this, "tabWidgetHandler");
    S(this, "contextMenuGenerator");
    S(this, "freeFormerCAD");
    S(this, "overlayComponents", null);
    S(this, "iptsPromise");
    S(this, "iptsTeethLibraryPromise");
    S(this, "mPromise");
    S(this, "sgPromise");
    S(this, "tsprFileFromSegmentation", !1);
    S(this, "interval", null);
    S(this, "settingsAutosaveInterval", null);
    S(this, "saveCAD", !1);
    S(this, "translationApi");
    S(this, "languageSetupPromise", null);
    S(this, "onAppLanguageChanged", (t) => {
      const e = t.detail;
      this.SetLanguageCAD(e);
    });
    S(this, "counter", 0);
    this.context = t, typeof window < "u" && window.addEventListener("app-language-changed", this.onAppLanguageChanged);
  }
  Initialize() {
    var f, T, M;
    this.modals = D7(), this.useDialog = AX(), console.log("CAD CONTEXT INITIALIZE - START");
    const t = this.context.getEngine();
    this.initializeINI(), this.GetMainFormObject(), this.SetMouseMode(), (f = this.context.xWasmDocument) == null || f.InitializeQT(), this.languageSetupPromise = this.SetLanguageCAD(), this.guiEventHandler = fvt(this.context.module, this.modals, this.useDialog, this.context), this.tabWidgetHandler = yvt(this.context.module, this.context), this.mainFormWasm.SetGUIEventHandler(this.guiEventHandler), this.mainFormWasm.SetTabWidgetHandler(this.tabWidgetHandler);
    const e = (N) => {
      console.log("DEBUGG: loadTeethFromCAD -> exiting CAD 10"), this.LoadTeethFromTeethSetup(), setTimeout(() => {
        this.context.setCADMode(!1), this.context.layoutManager.wizardTabIndex.set(this.context.layoutManager.wizardTabIndex.get() + (N ? -1 : 1));
      }, 100);
    };
    this.mainFormWasm.SetJSLambda(e, _o.eJSLT_LOAD_TEETH_FROM_CAD);
    const n = (N) => {
      this.DeleteObjectFunction(N), this.markCadDirty();
    };
    this.mainFormWasm.SetJSLambda(n, _o.eJSLT_DELETE_ITEM);
    const s = (N) => {
      if (N) {
        const W = new cA({ context: this.context, name: "", fPath: "" });
        return W.setLocked(!0), this.context.objects.stls.set(W.id, W), this.markCadDirty(), W.id;
      } else {
        const W = new vn({ context: this.context });
        return W.wasmStlObject = new t.xWasmStlObject(W.id, Pe.eOT_UNKNOWN, Yt._STL_OBJECT, Yt._STL_OBJECT), this.context.objects.stls.set(W.id, W), this.markCadDirty(), W.id;
      }
    };
    this.mainFormWasm.SetJSLambda(s, _o.eJSLT_CREATE_ITEM);
    const r = (N) => {
      const W = this.context.objects.stls.get(N);
      W ? (W.syncWasmInfo(), W.update3dInfo(), this.markCadDirty()) : console.error("syncStlObject: StlObject with id " + N + " not found");
    };
    this.mainFormWasm.SetJSLambda(r, _o.eJSLT_SYNC_ITEM);
    const a = this.context.getCurrentVolumeOptions();
    let o = [], l = [];
    const c = this.context.getVolume().volumeActor;
    if (c) {
      const N = c.getProperty().getRGBTransferFunction(0), W = c.getProperty().getScalarOpacity(0);
      o = ett(N), l = ntt(W);
    } else
      console.error("Volume not found!!!!");
    let u = 4e3, d = 1e3;
    const h = this.context.getViewWidget(Nt.AXIAL);
    if (h) {
      const N = h.reslicerMap.map((W) => W.label).indexOf("3Dvolume");
      N != -1 && (u = h.reslicerMap[N].actor.getProperty().getColorWindow(), d = h.reslicerMap[N].actor.getProperty().getColorLevel());
    }
    const p = LP(this.context.objects.CPRCurve.splineVec), m = (T = this.context.objects.CPRCurve.owner) == null ? void 0 : T.n, b = (M = this.context.objects.CPRCurve.owner) == null ? void 0 : M.o, y = this.context.getViewWidget(Nt.CPR);
    let Z;
    y && (Z = y.getCPRHeight());
    const g = this.context.objects.CPRCurve.getColor();
    if (p.length && m && b && Z && this.mainFormWasm.SetCPRCurve(
      this.context.objects.CPRCurve.maxillaOmandible == xo.MAXILLA,
      new Float32Array(p),
      new Float64Array(m),
      new Float64Array(b),
      Z,
      new Float32Array(g)
    ), this.mainFormWasm.PrepareVolumeProperties(new Float32Array(o), new Float32Array(l), a.shading, u, d), this.context.elCAD)
      if (this.context.module) {
        this.viewInterface = jc(this.context.module, this.context.elCAD, this.context);
        const N = this.context.getWasmDocumentInstance();
        if (N) {
          const W = this.context.license;
          N.InitializeMainForm(
            this.viewInterface,
            W.versionType,
            this.context.projectName,
            W.licenseType,
            W.licenseExtraParams,
            Rvt(this.context),
            // window.devicePixelRatio,
            1
            // seems that pixel ratio should be set to 1 in all cases??
          );
        } else {
          console.error("Wasm Document not defined");
          return;
        }
      } else {
        console.error("this.context.module is undefined");
        return;
      }
    else {
      console.error("this.context.elCAD is undefined");
      return;
    }
    this.freeFormerCAD = new Vvt(this.context, this.useDialog), this.resizeObserver = new ResizeObserver((N) => {
      for (const W of N)
        W.target === this.context.elCAD && this.resize();
    }), this.resizeObserver.observe(this.context.elCAD), this.isInitialized = !0, console.log("CAD CONTEXT INITIALIZE - END");
  }
  async awaitLanguageSetup() {
    this.languageSetupPromise && await this.languageSetupPromise;
  }
  initializeINI() {
    const t = this.context.getFS(), e = this.readStoredCadSettingsIni();
    t.FS.writeFile(kS, e ?? `[General]
`), t.FS.stat(kS), this.startSettingsAutosave();
  }
  setTimer() {
    this.clearTimer(), this.interval = setInterval(() => {
      this.ProcessDispatchTasks();
    }, 20);
  }
  clearTimer() {
    this.interval && (clearInterval(this.interval), this.interval = null);
  }
  /** Unloads the active CAD document before the main form is destroyed. */
  async exitCAD() {
    if (!this.isInitialized || !this.mainFormWasm)
      return !0;
    const t = await ge(this.mainFormWasm).ExitCADAsync();
    return t && this.clearTimer(), t;
  }
  startSettingsAutosave() {
    this.clearSettingsAutosave(), this.settingsAutosaveInterval = setInterval(() => {
      this.persistSettingsIniToLocalStorage();
    }, Yvt);
  }
  clearSettingsAutosave() {
    this.settingsAutosaveInterval && (clearInterval(this.settingsAutosaveInterval), this.settingsAutosaveInterval = null);
  }
  readStoredCadSettingsIni() {
    if (typeof localStorage > "u")
      return;
    const t = localStorage.getItem(t3);
    return t && t.length > 0 ? t : void 0;
  }
  persistSettingsIniToLocalStorage() {
    if (!(typeof localStorage > "u" || !this.context.module))
      try {
        const e = this.context.getFS().FS.readFile(kS, { encoding: "utf8" });
        localStorage.setItem(t3, e);
      } catch (t) {
        console.warn("Failed to persist CAD settings.ini", t);
      }
  }
  resize() {
    var n;
    if (!this.context.elCAD || !this.context.cadMode.get()) return;
    const { width: t, height: e } = this.context.elCAD.getBoundingClientRect();
    (n = this.mainFormWasm) == null || n.ResizeEvent(), this.viewInterface.update();
  }
  syncInfoToCAD() {
    var e;
    const t = (e = this.mainFormWasm) == null ? void 0 : e.GetTopToolbar();
    t == null || t.toggleInfo(this.context.getInfoFlag().get());
  }
  async showSTLMatchingWizard() {
    this.isInitialized || this.Initialize(), await this.awaitLanguageSetup(), await this.mainFormWasm.showSTLMatchingWizardAsync(), this.syncInfoToCAD(), this.setTimer();
  }
  async showSTLEditWizard(t) {
    this.isInitialized || this.Initialize(), await this.awaitLanguageSetup(), await this.mainFormWasm.showSTLEditWizardAsync(t), this.syncInfoToCAD(), this.setTimer();
  }
  async showSTLLibraryAlignmentWizard() {
    this.isInitialized || this.Initialize(), await this.awaitLanguageSetup(), await this.mainFormWasm.showSTLLibraryAlignmentWizardAsync(), this.syncInfoToCAD(), this.setTimer();
  }
  async showBooleanOperationWizard() {
    this.isInitialized || this.Initialize(), await this.awaitLanguageSetup(), await this.mainFormWasm.showBooleanWizardAsync(), this.syncInfoToCAD(), this.setTimer();
  }
  async setTabIndex(t) {
    var s, r, a, o;
    console.log("CAD CONTEdXT  setTabIndex idx", t), this.isInitialized || this.Initialize(), await this.awaitLanguageSetup();
    const e = this.context.loadingText;
    if (this.iptsPromise && t == 30) {
      if (this.context.showLoading(jt("medic-web-engine.downloadingTeethSetupProject"), !1, void 0, !0), await this.iptsPromise, this.iptsTeethLibraryPromise)
        try {
          await this.iptsTeethLibraryPromise;
        } catch (l) {
          console.warn("Failed awaiting preloaded teeth library promise: ", l);
        }
      this.context.showLoading(e, !1, void 0, !0);
    } else this.mPromise && t == 19 ? (this.context.showLoading(jt("medic-web-engine.downloadingAnalogModelProject"), !1, void 0, !0), await this.mPromise, this.context.showLoading(e, !1, void 0, !0)) : this.sgPromise && t == 12 && (this.context.showLoading(jt("medic-web-engine.downloadingSurgicalGuideProject"), !1, void 0, !0), await this.sgPromise, this.context.showLoading(e, !1, void 0, !0));
    if (await ((s = this.mainFormWasm) == null ? void 0 : s.TabChangedAsync(t)), ((r = this.mainFormWasm) == null ? void 0 : r.GetLayoutType()) == 29 && t != 1)
      return ge(this.mainFormWasm).ClearDispatchTasks(), this.context.hideLoading(), this.context.layoutManager.wizardTabIndex.set(Jn.DATA_IMPORT), !1;
    if (t == 1)
      this.clearTimer();
    else {
      this.setTimer(), (a = this.mainFormWasm) == null || a.Set3DOrientation(0);
      const l = (o = this.mainFormWasm) == null ? void 0 : o.GetTopToolbar();
      l == null || l.resetView(), this.syncInfoToCAD();
    }
    return this.SetMouseMode(), !0;
  }
  setLayout(t) {
    var n;
    this.isInitialized || this.Initialize();
    let e = -1;
    switch (t) {
      case Yn._FULLSCREEN_3D:
        e = 0;
        break;
      case Yn._FULLSCREEN_CORONAL:
        e = 1;
        break;
      case Yn._FULLSCREEN_SAGITTAL:
        e = 2;
        break;
      case Yn._FULLSCREEN_AXIAL:
        e = 3;
        break;
      case Yn._FULLSCREEN_CPR:
        e = 4;
        break;
      case Yn._LARGE_3D_MPR:
        e = 5;
        break;
      case Yn._3D_MPR:
        e = 6;
        break;
      case Yn._3D_CPR_CROSS_TANGENT_AXIAL:
        e = 7;
        break;
      case Yn._MPR:
        e = 8;
        break;
      case Yn._3D_CROSS_TANGENT_AXIAL:
        e = 9;
        break;
      case Yn._3D_CROSS_AXIAL:
        e = 10;
        break;
      case Yn._3D_CROSS_CPR:
        e = 11;
        break;
    }
    (n = this.mainFormWasm) == null || n.SetLayout(e);
  }
  getLayout() {
    var n;
    this.isInitialized || this.Initialize();
    const t = (n = this.mainFormWasm) == null ? void 0 : n.GetLayout();
    let e = Yn._FULLSCREEN_3D;
    switch (t) {
      case 0:
        e = Yn._FULLSCREEN_3D;
        break;
      case 1:
        e = Yn._FULLSCREEN_CORONAL;
        break;
      case 2:
        e = Yn._FULLSCREEN_SAGITTAL;
        break;
      case 3:
        e = Yn._FULLSCREEN_AXIAL;
        break;
      case 4:
        e = Yn._FULLSCREEN_CPR;
        break;
      case 5:
        e = Yn._LARGE_3D_MPR;
        break;
      case 6:
        e = Yn._3D_MPR;
        break;
      case 7:
        e = Yn._3D_CPR_CROSS_TANGENT_AXIAL;
        break;
      case 8:
        e = Yn._MPR;
        break;
      case 9:
        e = Yn._3D_CROSS_TANGENT_AXIAL;
        break;
      case 10:
        e = Yn._3D_CROSS_AXIAL;
        break;
      case 11:
        e = Yn._3D_CROSS_CPR;
        break;
      default:
        e = Yn._FULLSCREEN_3D;
    }
    return e;
  }
  SetMouseMode() {
    this.mainFormWasm && this.mainFormWasm.SetMouseModeOn3D(this.context.settings.general.useLeftButtonForRotationOn3d ? 1 : 0);
  }
  GetMainFormObject() {
    if (!this.mainFormWasm) {
      const t = this.context.getEngine();
      this.mainFormWasm = new t.TMainFormWasm();
    }
    return this.mainFormWasm;
  }
  GetMainForm() {
    return this.isInitialized || this.Initialize(), this.mainFormWasm;
  }
  SetJSLambda(t, e) {
    var n;
    (n = this.mainFormWasm) == null || n.SetJSLambda(t, e);
  }
  ClearJSLambda(t) {
    var e;
    (e = this.mainFormWasm) == null || e.ClearJSLambda(t);
  }
  DeleteObjectFunction(t) {
    console.log("DeleteObjectFunction Deleting object with id: ", t);
    let e = !1;
    if (t.length > 0) {
      const n = this.context.objects.stls.get(t);
      n ? (this.context.objects.removeObject(t, n.type), e = !0, console.log("Deleted existing model with id: ", t)) : console.warn("No existing model found with id: ", t);
    }
    return e;
  }
  async FreeFormButtonClicked(t) {
    this.mainFormWasm && await ge(this.mainFormWasm).FreeFormButtonClickedAsync(t);
  }
  ProcessDispatchTasks() {
    this.mainFormWasm && (this.counter++, this.counter % 50 === 0 && console.log("ProcessDispatchTasks"), ge(this.mainFormWasm).ProcessDispatchTasks());
  }
  setOverlayContainer(t) {
    this.overlayComponents && this.overlayComponents.cleanup(), this.overlayComponents = Pi(t);
  }
  // TODO maybe move this file to be created in xMainForm!!!! so C++ is the owner!!
  CreateAddReconstructionObject() {
    const t = this.context.getEngine();
    this.xAddReconstructionObject = new t.xAddReconstructionWasm();
  }
  DeleteAddReconstructionObject() {
    this.xAddReconstructionObject && (ge(this.xAddReconstructionObject).delete(), this.xAddReconstructionObject = null);
  }
  GetXAddReconstructionObject() {
    if (this.xAddReconstructionObject || this.CreateAddReconstructionObject(), this.xAddReconstructionObject) return this.xAddReconstructionObject;
    throw new Error("this.xAddReconstructionObject could not be initialized");
  }
  PrepareDialog(t, e) {
    var n;
    (n = this.xAddReconstructionObject) == null || n.PrepareDialog(t, e);
  }
  async LoadFileToCad(t) {
    try {
      const e = await this.context.getFS(), s = await (await fetch((this.context.getBaseUrl() + "/cadResources" + t).replaceAll("//", "/"))).arrayBuffer(), r = new Int8Array(s);
      return e.FS.writeFile(t, r), !0;
    } catch (e) {
      return console.error("Error loading File To CAD: ", e, t), !1;
    }
  }
  getTranslationFileCode(t) {
    return vvt[t] ?? t;
  }
  async fetchRemoteTranslationFileByName(t, e) {
    if (!this.translationApi)
      return console.warn("No ServerAPI available for remote CAD translation download:", t), !1;
    if (t.endsWith("_en.qm"))
      return !0;
    const n = e.find((o) => o.fileName + "." + o.fileType === t), s = Number(n == null ? void 0 : n.id);
    if (!Number.isFinite(s))
      return console.warn("Remote CAD translation file id not found:", t), !1;
    const r = await this.translationApi.getCadLibrariesFileById(s), a = await this.context.getFS();
    try {
      return (n == null ? void 0 : n.fileType) === "ini" ? a.FS.writeFile("/" + t, new Uint8Array(r.data)) : a.FS.writeFile("/language/" + t, new Uint8Array(r.data)), !0;
    } catch (o) {
      return console.error("Error writing remote CAD translation file to FS:", o), !1;
    }
  }
  async ensureLanguageFiles(t) {
    var r;
    const e = this.getTranslationFileCode(t), n = await ((r = this.translationApi) == null ? void 0 : r.getCadLibrariesFilteredListByType(qE, void 0, "qm")), s = Array.isArray(n == null ? void 0 : n.data) ? n.data : [];
    console.log("Entries", s), await this.fetchRemoteTranslationFileByName(`webcad_qobject_${e}.qm`, s), await this.fetchRemoteTranslationFileByName(`medicview_${e}.qm`, s), await this.fetchRemoteTranslationFileByName(`mediccad_${e}.qm`, s);
  }
  async LoadCADResources(t) {
    var s;
    this.translationApi = t, this.context.makeDir("/Resources"), this.context.makeDir("/Resources/hotspots"), await this.LoadFileToCad("/Resources/hotspots/H01.png"), this.context.makeDir("/Resources/fonts"), await this.LoadFileToCad("/Resources/fonts/Roboto-Bold.ttf"), await this.LoadFileToCad("/Resources/fonts/Roboto-Regular.ttf"), await this.LoadFileToCad("/Resources/fonts/Roboto-Medium.ttf"), this.context.makeDir("/stlcaddb"), this.context.makeDir("/stlcaddb/cad_teeth_libraries"), this.context.makeDir("/tmp/cad_proj");
    const e = await ((s = this.translationApi) == null ? void 0 : s.getCadLibrariesFilteredListByType(qE, void 0, "ini")), n = Array.isArray(e == null ? void 0 : e.data) ? e.data : [];
    console.log("Languages.ini Entries", n), await this.fetchRemoteTranslationFileByName("languages.ini", n), this.context.makeDir("/language");
  }
  getTeethLibraryLoadGeneration() {
    return this.mTeethLibraryLoadGeneration;
  }
  isTeethLibraryLoadActive(t) {
    return t === this.mTeethLibraryLoadGeneration && !this.context.isDestructed();
  }
  getTeethLibraryLoadOperation(t) {
    return this.mTeethLibraryLoadOperations.get(t);
  }
  trackTeethLibraryLoad(t, e) {
    this.mTeethLibraryLoadOperations.set(t, e);
  }
  untrackTeethLibraryLoad(t, e) {
    var n;
    ((n = this.mTeethLibraryLoadOperations.get(t)) == null ? void 0 : n.promise) === e && this.mTeethLibraryLoadOperations.delete(t);
  }
  getLoadedTeethLibrary(t) {
    return this.mLoadedTeethLibraries.get(t);
  }
  getTeethLibraryKeyForModel(t) {
    return this.mLoadedTeethLibraryKeysByModel.get(t.toLowerCase());
  }
  getTeethLibraryKeyForGuid(t) {
    return this.mLoadedTeethLibraryKeysByGuid.get(t.trim());
  }
  reserveTeethLibraryIdentity(t, e, n) {
    const s = t.toLowerCase(), r = e.trim(), a = this.mLoadedTeethLibraryKeysByModel.get(s), o = this.mLoadedTeethLibraryKeysByGuid.get(r);
    return a && a !== n || o && o !== n ? !1 : (this.mLoadedTeethLibraryKeysByModel.set(s, n), this.mLoadedTeethLibraryKeysByGuid.set(r, n), !0);
  }
  releaseTeethLibraryIdentity(t, e, n) {
    const s = t.toLowerCase(), r = e.trim();
    !this.mLoadedTeethLibraries.has(n) && !this.mTeethLibraryLoadOperations.has(n) && (this.mLoadedTeethLibraryKeysByModel.get(s) === n && this.mLoadedTeethLibraryKeysByModel.delete(s), this.mLoadedTeethLibraryKeysByGuid.get(r) === n && this.mLoadedTeethLibraryKeysByGuid.delete(r));
  }
  addLoadedTeethLibrary(t) {
    this.mLoadedTeethLibraries.set(t.key, t), this.mLoadedTeethLibraryKeysByModel.set(t.modelName.toLowerCase(), t.key), this.mLoadedTeethLibraryKeysByGuid.set(t.guid.trim(), t.key);
  }
  forgetLoadedTeethLibrary(t) {
    const e = this.mLoadedTeethLibraries.get(t);
    this.mLoadedTeethLibraries.delete(t), e && this.mLoadedTeethLibraryKeysByModel.get(e.modelName.toLowerCase()) === t && this.mLoadedTeethLibraryKeysByModel.delete(e.modelName.toLowerCase()), e && this.mLoadedTeethLibraryKeysByGuid.get(e.guid.trim()) === t && this.mLoadedTeethLibraryKeysByGuid.delete(e.guid.trim());
  }
  removeLoadedTeethLibraries() {
    ++this.mTeethLibraryLoadGeneration, this.mTeethLibraryLoadOperations.forEach(({ abortController: t }) => t.abort()), this.mTeethLibraryLoadOperations.clear(), this.mLoadedTeethLibraries.clear(), this.mLoadedTeethLibraryKeysByModel.clear(), this.mLoadedTeethLibraryKeysByGuid.clear(), this.context.module && ovt(this.context);
  }
  LoadTeethFromTeethSetup() {
    if (!this.mainFormWasm) return;
    this.context.objects.clearTeethAndMarkers();
    const t = this.context.getEngine(), e = this.context.settings.general.useUSStyleToothChart, n = this.mainFormWasm.PrepareTeethListAndGetSize(e);
    if (console.log("Teeth List Size", n), n > 0)
      for (let a = 0; a < n; a++) {
        const o = this.mainFormWasm.GetToothPosition(a), l = this.mainFormWasm.GetToothName(a), c = this.context.objects.addToothMarker(I.fromValues(o[0], o[1], o[2]), l), u = new vn({ context: this.context });
        u.type = Yt._STL_TOOTH, u.wasmStlObject = new t.xWasmStlObject(u.id, Pe.eOT_TOOTH, Yt._STL_TOOTH, Yt._STL_OBJECT);
        const d = this.mainFormWasm.AssignMeshFromTooth(a, u.id, c.id, e);
        d == 0 ? console.error("ERROR this.mainFormWasm.AssignMeshFromTooth failed") : d == 1 ? u.delete() : d == 2 && (u.syncWasmInfo(), u.update3dInfo(), this.context.objects.stls.set(u.id, u));
      }
    this.context.objects.clearMergedTeeth();
    const s = this.mainFormWasm.GetMergedTeethList();
    console.log("pRefPlane mergedList", s);
    for (let a = 0; a < s.size(); a++) {
      console.log("pRefPlane mergedList id", s.get(a));
      const o = new vn({ context: this.context });
      o.wasmStlObject = new t.xWasmStlObject(o.id, Pe.eOT_TOOTH, Yt._STL_OBJECT, Yt._STL_OBJECT), this.mainFormWasm.AssignMergedTeeth(s.get(a), o.id), o.syncWasmInfo(), this.context.objects.stls.set(o.id, o);
    }
    this.context.objects.clearReferencePlanes();
    const r = this.mainFormWasm.GetReferencePlanesList();
    console.log("pRefPlane refPlanesList", r);
    for (let a = 0; a < r.size(); a++) {
      console.log("pRefPlane refPlane  ihd", r.get(a));
      const o = new vn({ context: this.context });
      o.type = Yt._REFERENCE_PLANE, o.subType = Yt._NONE, o.wasmStlObject = new t.xWasmStlObject(o.id, Pe.eOT_REFERENCE_PLANE, Yt._REFERENCE_PLANE, Yt._NONE), this.mainFormWasm.AssignReferencePlane(r.get(a), o.id), o.syncWasmInfo(), this.context.objects.stls.set(o.id, o);
    }
  }
  async LoadArticulatorLibrariesToWasm(t) {
    const e = "/stlcaddb/articulator_libraries/", s = "articulator_libraries" + ".zip", r = e + s, a = $R((c) => {
      this.context.setProgressBarValue(Math.ceil(c * 100));
    }, 250), o = await t.getPoolAsset("articulator_libraries", s, !0, (c) => {
      a(c);
    }), l = await this.context.getFS();
    console.log("Writing library zip with name: ", r), this.context.makeDir("/stlcaddb"), this.context.makeDir("/stlcaddb/articulator_libraries");
    try {
      l.FS.writeFile(r, new Uint8Array(o.data));
      const c = ge(this.context.getWasmDocumentInstance());
      if (c) {
        const u = c.ExtractZip(r, e);
        console.log("Return: ", u);
      }
      l.FS.unlink(r);
    } catch (c) {
      console.error("Error writing articulator library zip: ", c);
    }
  }
  ClearArticulatorLibrariesFromWasm() {
    const t = "/stlcaddb/articulator_libraries/", e = this.context.getFS();
    j2(e.FS, t);
  }
  async LoadMovementMarkerLibrariesToWasm(t) {
    const e = "/stlcaddb/movement_markers/", s = "movement_markers" + ".zip", r = e + s, a = $R((c) => {
      this.context.setProgressBarValue(Math.ceil(c * 100));
    }, 250), o = await t.getPoolAsset("movement_markers", s, !0, (c) => {
      a(c);
    }), l = await this.context.getFS();
    console.log("Writing library zip with name: ", r), this.context.makeDir("/stlcaddb"), this.context.makeDir("/stlcaddb/movement_markers");
    try {
      l.FS.writeFile(r, new Uint8Array(o.data));
      const c = ge(this.context.getWasmDocumentInstance());
      if (c) {
        const u = c.ExtractZip(r, e);
        console.log("Return: ", u);
      }
      l.FS.unlink(r);
    } catch (c) {
      console.error("Error writing movement library zip: ", c);
    }
  }
  ClearMovementMarkerLibrariesFromWasm() {
    const t = "/stlcaddb/movement_markers/", e = this.context.getFS();
    j2(e.FS, t);
  }
  async SetLanguageCAD(t) {
    var s;
    let e = t ? e3(t) : void 0;
    if (!e) {
      const r = localStorage.getItem("langApp");
      if (r === null)
        e = Bn.EN;
      else
        try {
          e = e3(JSON.parse(r)) ?? Bn.EN;
        } catch (a) {
          console.error("Failed to parse current language, falling back to en", a), e = Bn.EN;
        }
    }
    const n = Cvt[e] ?? 0;
    try {
      await this.ensureLanguageFiles(e);
    } catch (r) {
      console.error("Failed to ensure CAD translation files for language", e, r);
    }
    (s = this.context.xWasmDocument) == null || s.InitializeTranslator(n);
  }
  markCadDirty() {
    this.saveCAD = !0;
  }
  cleanupRenderWindows() {
    this.mOGLRenderWindowsCAD.forEach((t, e) => {
      var n;
      try {
        (n = this.mRenderWindowsCAD.get(e)) == null || n.removeView(t);
      } catch (s) {
        console.warn("Failed to remove CAD OpenGL render window view", s);
      }
      try {
        t.setContainer(null);
      } catch (s) {
        console.warn("Failed to detach CAD OpenGL render window container", s);
      }
      try {
        t.delete();
      } catch (s) {
        console.warn("Failed to delete CAD OpenGL render window", s);
      }
    }), this.mRenderWindowsCAD.forEach((t) => {
      try {
        t.delete();
      } catch (e) {
        console.warn("Failed to delete CAD render window", e);
      }
    }), this.mRenderWindowsCADIDs.clear(), this.mRenderWindowsCAD.clear(), this.mOGLRenderWindowsCAD.clear(), this.mUsedRenderWindows = 0;
  }
  // TODO do I need to unlink ipts, tspr... files here??
  cleanup() {
    var t, e, n, s, r, a, o, l;
    console.log("CONTEXTCAD - CleanUp - START!!!"), this.clearTimer(), this.clearSettingsAutosave(), this.persistSettingsIniToLocalStorage(), this.removeLoadedTeethLibraries(), this.context.module && tvt(this.context), (t = this.mainFormWasm) == null || t.ClearJSLambda(_o.eJSLT_LOAD_TEETH_FROM_CAD), (e = this.mainFormWasm) == null || e.ClearJSLambda(_o.eJSLT_DELETE_ITEM), (n = this.freeFormerCAD) == null || n.delete(), (s = this.resizeObserver) == null || s.disconnect(), typeof window < "u" && window.removeEventListener("app-language-changed", this.onAppLanguageChanged), this.guiEventHandler = void 0, this.tabWidgetHandler = void 0, (r = this.mainFormWasm) == null || r.delete(), this.mainFormWasm = null, (o = (a = this.viewInterface) == null ? void 0 : a.destroy) == null || o.call(a), (l = this.viewInterface) == null || l.delete(), this.viewInterface = null, this.cleanupRenderWindows(), console.log("CONTEXT - CleanUp - END");
  }
}
function Ovt(i) {
  return !i || i === "/" ? "" : i;
}
const dOt = async (i) => new V3(new L3(i)).engineModule, zvt = async (i = "") => {
  const t = typeof i == "string" ? { assetPath: i } : i ?? {}, e = Ovt(t.assetPath), n = (r, a) => `${r}/${a}`.replace(/\/+/g, "/"), s = async (r) => {
    const a = n(e || "/", r), o = r === "wasm32-ios" ? await import("./wasm32-ios-D7o-s9lv.js") : await import("./wasm32-COYsijdD.js");
    return await new o.WCEngine(new o.WCEModule(a)).engineModule;
  };
  if (t.wasm64)
    try {
      const r = await Promise.resolve().then(() => a8);
      return await new r.WCEngine(new r.WCEModule(e)).engineModule;
    } catch (r) {
      console.warn("Failed to load wasm64 engine, falling back to wasm32", r);
    }
  if (o3())
    try {
      return await s("wasm32-ios");
    } catch (r) {
      console.warn("Failed to load wasm32-ios engine, falling back to wasm32", r);
    }
  return s("wasm32");
}, Evt = {
  symbol: Symbol(),
  install(i, t = "") {
    const n = zvt(typeof t == "string" ? { assetPath: t } : t ?? {});
    n.catch((s) => {
      console.error("Failed to load any wasm engine variant", s);
    }), console.log("Engine Module", n), i.config.globalProperties.$wasmengine = n, i.provide(this.symbol, n);
  }
};
function kvt() {
  return O7(Evt.symbol);
}
async function Fvt(i, t) {
  const n = (await i.getProjectJobStatusUuid(t)).data.filter((l) => l.type == "SEGMENTATION"), s = {};
  for (let l of n)
    s[l.uuid] || (s[l.uuid] = /* @__PURE__ */ new Set()), s[l.uuid].add(l.status);
  const r = [], a = [];
  for (const [l, c] of Object.entries(s))
    c.has("IN_PROCESS") && c.has("COMPLETED") ? r.push(l) : c.has("IN_PROCESS") && !c.has("FAILED") && a.push(l);
  let o;
  return r.length > 0 && (o = r[0]), a.length > 0 && (o = a[0]), o ? { jobUuid: o, completed: r.length > 0 } : null;
}
const jvt = {
  C1: [1, 0, 0],
  C2: [0, 0.5, 0],
  C3: [0, 0, 1],
  C4: [1, 1, 0],
  C5: [0, 1, 1],
  C6: [1, 0, 1],
  C7: [192 / 255, 192 / 255, 192 / 255],
  T1: [128 / 255, 128 / 255, 128 / 255],
  T2: [128 / 255, 0, 0],
  T3: [128 / 255, 128 / 255, 0],
  T4: [0, 128 / 255, 0],
  T5: [128 / 255, 0, 128 / 255],
  T6: [0, 128 / 255, 128 / 255],
  T7: [0, 0, 128 / 255],
  T8: [160 / 255, 82 / 255, 45 / 255],
  T9: [210 / 255, 105 / 255, 30 / 255],
  T10: [205 / 255, 133 / 255, 63 / 255],
  T11: [244 / 255, 164 / 255, 96 / 255],
  T12: [222 / 255, 184 / 255, 135 / 255],
  L1: [210 / 255, 180 / 255, 140 / 255],
  L2: [188 / 255, 143 / 255, 143 / 255],
  L3: [72 / 255, 61 / 255, 139 / 255],
  L4: [123 / 255, 104 / 255, 238 / 255],
  L5: [153 / 255, 50 / 255, 204 / 255],
  T13: [238 / 255, 130 / 255, 238 / 255],
  L6: [0, 1, 127 / 255]
}, O4 = {
  toggleInspect: new se(),
  toggleMeasurementUnit: new se()
}, Uvt = new se(), UX = 40;
class z4 {
  constructor(t = "", e = {
    versionType: _R.CD_VIEWER,
    licenseType: "",
    licenseExtraParams: ""
  }) {
    S(this, "destructed", !1);
    S(this, "onObjectsModified", new se());
    S(this, "cprSettings", !1);
    S(this, "hideCADToolbars", !1);
    S(this, "onHideCADToolbarsChanged", new se());
    S(this, "onActorsChanged", new se());
    S(this, "onActorAdded", new se());
    S(this, "onActorRemoved", new se());
    S(this, "onCrossSectionAdded", new se());
    S(this, "onCrossSectionRemoved", new se());
    S(this, "onPredictionAdded", new se());
    S(this, "onVolumeOptionsModified", new se());
    S(this, "updateObject2DPositionEvent", new se());
    S(this, "saveProjectEvent", new se());
    S(this, "saveProjectPromise", null);
    S(this, "settings", new jVt(this));
    S(this, "viewConfiguration", zZt());
    S(this, "contextCAD");
    S(this, "cadMode", new qt(!1));
    S(this, "objects", new gA(this));
    S(this, "layoutManager", new uTt(this));
    S(this, "projectGeneralData");
    S(this, "projectBookmarks", {
      layout: {
        bookmarks: []
      },
      windows: {
        /**
         * 0: axial
         * 1: coronal
         * 2: sagittal
         * 3: 3D
         * 4: CPR
         * undefined value = not saved in project
         */
        windows: [
          {
            presenterWindow: {
              bookmarks: [],
              viewWidget: {
                bookmarks: []
              }
            }
          },
          {
            presenterWindow: {
              bookmarks: [],
              viewWidget: {
                bookmarks: []
              }
            }
          },
          {
            presenterWindow: {
              bookmarks: [],
              viewWidget: {
                bookmarks: []
              }
            }
          },
          void 0,
          {
            presenterWindow: {
              bookmarks: [],
              viewWidget: {
                bookmarks: []
              }
            }
          }
        ]
      }
    });
    S(this, "predictions", []);
    S(this, "overlayModel", P0t());
    S(this, "rotate2DEvent", new se());
    S(this, "objectMoveEvent", new se());
    S(this, "objectRotateTopBottomEvent", new se());
    S(this, "objectRotateTopBottomStartEvent", new se());
    S(this, "objectMoveRotateEndEvent", new se());
    S(this, "objectImplantLengthStepEvent", new se());
    S(this, "imageData", xs.newInstance());
    S(this, "uncroppedImageData", xs.newInstance());
    S(this, "reconstructionBoundingBoxes", /* @__PURE__ */ new Map());
    S(this, "reconstructionCoordinateSystems", /* @__PURE__ */ new Map());
    S(this, "constructionInfos", /* @__PURE__ */ new Map());
    S(this, "origin2D", new qt([0, 0, 0]));
    S(this, "rotation2D");
    S(this, "sliceInfos2D", new qt({}));
    S(this, "canvasSize", new qt([0, 0]));
    S(this, "state");
    S(this, "el");
    S(this, "elCAD");
    S(this, "overlayContainer");
    S(this, "overlayContainerGlobal");
    S(this, "renderWindow");
    S(this, "openglRenderWindow");
    S(this, "interactorStyle");
    S(this, "hardwareSelector");
    S(this, "container");
    S(this, "defaultRenderer", null);
    S(this, "windowBackground", [0, 0, 0]);
    S(this, "views", []);
    S(this, "sectionalViews", []);
    S(this, "presenterWindows", []);
    S(this, "currentViewLayout", []);
    S(this, "layoutNeedsFullRenderBufferClear", !0);
    S(this, "inputMode");
    S(this, "onCleanupArray", []);
    S(this, "actorTypes", /* @__PURE__ */ new Map());
    S(this, "removeWebGLContextEventForwarding");
    S(this, "module");
    S(this, "engineInstance");
    S(this, "xWasmDocument");
    S(this, "activeReconstruction", null);
    S(this, "vueModalsInstance");
    S(this, "resourceUrl", "/resources/");
    S(this, "volumeOptions", new XJ(Sy.GeneralCT.Default));
    S(this, "volumeOptions3D", new qt({
      windowWidth: this.volumeOptions.getWindowWidthLevel()[0],
      windowLevel: this.volumeOptions.getWindowWidthLevel()[1]
    }));
    S(this, "volumeActor");
    S(this, "volumeMapper");
    S(this, "volumeInteractionDepth", 0);
    S(this, "volumeInteractionSettings");
    S(this, "toolManager", new DVt(this));
    S(this, "undoManager", new kVt(this));
    S(this, "repaintRequested", !1);
    // reorientating Image Data
    S(this, "reorientationHistory", []);
    // should this be in CPRMath??
    S(this, "CPRMath", new OVt(this));
    S(this, "curveDelta", new qt({ min: -UX, max: UX, value: 0 }));
    S(this, "CPRthickness", new qt(-1));
    S(this, "CPRfilterMode", new qt(Je.MPR));
    S(this, "CPRHeight", 40);
    S(this, "CPRSpacing", new qt([0, 0]));
    S(this, "indexOnSpline", new qt(0));
    S(this, "axialRotationOffset", new qt(0));
    S(this, "splineLength", new qt(0));
    S(this, "cprScoutVisible", !1);
    S(this, "CPRType", xo.MAXILLA);
    // nerve points insert from project flag
    S(this, "insertFlag", !0);
    // infos visible flag
    S(this, "infoFlag", new qt(!1));
    S(this, "onShowAddReconstructionDialog", new se());
    // warning dialog
    S(this, "warningDialogEvent", new se());
    S(this, "warningString", new qt(""));
    S(this, "screenshotUploadEvent", new se());
    // loading spinner visible flag
    S(this, "loadingFlag", new qt(!1));
    S(this, "progressBarFlag", !1);
    S(this, "progressBarValue", new qt(0));
    S(this, "loadingText", "Loading!");
    S(this, "nonTransparentLoading", new qt(!1));
    S(this, "loadingCancelVisible", new qt(!1));
    S(this, "loadingCancelHandler", null);
    // next Prev button Visible flag
    S(this, "nextPrevVisible", new qt(!0));
    // Layout button Visible flag
    S(this, "layoutBtnVisible", new qt(!0));
    S(this, "tabButtonsEnabled", new qt(!0));
    S(this, "wizardPanelFreeze", new qt(!1));
    S(this, "freezeTimer", null);
    S(this, "isCADObjectList", new qt(!1));
    S(this, "modelsUploadedFlag", !1);
    // public cursor: Observable<string> = new Observable<string>("auto");
    S(this, "weblinkSettings", new xMt());
    S(this, "screenshotBackgroundGradient");
    S(this, "cursorRoundToIndex", !1);
    S(this, "startMatchingWithObjectId", null);
    S(this, "readOnly", !1);
    S(this, "isIOS", !1);
    S(this, "projectName", "");
    S(this, "patientInfo");
    S(this, "projectInfo");
    S(this, "projectHash");
    S(this, "fileHash");
    S(this, "projectFullName", new qt(""));
    S(this, "segmentationResult", null);
    // Specify the base path from where to load the WCE.{js, wasm} files. Example: /planner/ -> /planner/WCE.js
    S(this, "baseWASMEnginePath");
    S(this, "license");
    S(this, "AIEnabled");
    S(this, "overlayComponents");
    S(this, "overlayContainerSize", new qt([0, 0]));
    S(this, "volumeDecimated", !1);
    /** Fetch original pixels only for a complete export; never retain the full scan in reduced mode. */
    S(this, "loadOriginalImageData");
    S(this, "volumeModified", !1);
    S(this, "erpFile", null);
    S(this, "user", null);
    S(this, "saveProjectResolver", null);
    console.log("engineBasePath:", t), this.el = document.createElement("div"), this.inputMode = new P2t(), this.overlayContainer = document.createElement("div"), this.overlayContainer.style.position = "absolute", this.overlayContainer.style.pointerEvents = "none", this.overlayContainer.style.zIndex = "1", this.el.appendChild(this.overlayContainer), this.overlayContainerGlobal = document.createElement("div"), this.overlayContainerGlobal.style.position = "absolute", this.overlayContainerGlobal.style.pointerEvents = "none", this.overlayContainerGlobal.style.zIndex = "1", this.el.appendChild(this.overlayContainerGlobal), this.baseWASMEnginePath = t, this.license = e, this.AIEnabled = !(e.versionType & _R.START), this.contextCAD = new Dvt(this), this.overlayContainer.addEventListener(
      "wheel",
      (r) => {
        YU(r, this.getVtkCanvas());
      },
      {
        passive: !0
      }
    ), this.overlayComponents = Pi(this.overlayContainerGlobal);
    const n = this.overlayContainerGlobal.getBoundingClientRect();
    this.overlayContainerSize.set([n.width, n.height]), this.onCleanup(() => {
      this.overlayComponents.cleanup();
    });
    const s = ps.create();
    ps.identity(s), this.rotation2D = new qt(s), this.watch(this.origin2D, (r) => {
      this.overlayModel.origin.set(r);
    }), this.watch(this.objects.object3DInfos, (r) => {
      this.overlayModel.objects.set(r), this.onObjectsModified.notify();
    }), this.state = {
      origin2D: new qo(this.origin2D),
      rotation2D: new qo(this.rotation2D),
      canvasSize: new qo(this.canvasSize),
      object3DInfos: new qo(this.objects.object3DInfos),
      sliceInfos2D: new qo(this.sliceInfos2D),
      volumeOptions3D: new qo(this.volumeOptions3D)
    }, this.onActorAdded.subscribe(({ actor: r, objectType: a }) => {
      this.actorTypes.set(r, a);
    }), this.onEvent(this.onPredictionAdded, () => {
      this.renderPredictions();
    }), this.onEvent(Uvt, (r) => {
      this.deletePrediction(r);
    }), this.onEvent(this.volumeOptions.onModified, () => {
      this.onVolumeOptionsModified.notify();
    }), this.onEvent(this.objectMoveRotateEndEvent, ({ objectId: r }) => {
      const a = this.objects.implants.get(r) || this.objects.pins.get(r);
      a ? this.objects.checkCollisions(a) : this.objects.checkCollisions();
    }), this.onEvent(this.settings.onSettingsModified, () => {
      var r;
      (r = this.getInteractorStyle()) == null || r.setMouseMode(this.settings.general.useLeftButtonForRotationOn3d ? $L.REALGUIDE : $L.IMPLANTPLANNER), this.contextCAD.SetMouseMode();
    });
  }
  setHideCADToolbars(t) {
    this.hideCADToolbars = t, this.onHideCADToolbarsChanged.notify(t);
  }
  getHideCADToolbars() {
    return this.hideCADToolbars;
  }
  dockOverlays() {
    let t = null;
    const e = this.overlayContainer.children;
    for (let c = 0; c < e.length; c++) {
      const u = e[c];
      if (u instanceof HTMLDivElement && u.style.display !== "none") {
        t = u;
        break;
      }
    }
    const n = 10;
    let s = 44;
    this.views.length > 0 && (s = 10);
    let r = 0, a = 0;
    t && (r = t.getBoundingClientRect().width - n, a = s);
    const o = this.overlayContainerGlobal, l = Array.from(o.children);
    if (o && l.length > 0) {
      let c = a, u = r;
      l.forEach((d, h) => {
        if (d instanceof HTMLDivElement) {
          if (d.style.display === "none")
            return;
          const p = d.firstElementChild;
          if (p instanceof HTMLDivElement) {
            if (p.style.display === "none")
              return;
            const m = Number.parseFloat(p.style.width.replace("px", "")), b = Number.isFinite(m) && m > 0 ? m : p.getBoundingClientRect().width, y = u - b;
            p.style.top = `${c}px`, p.style.left = `${y}px`;
            const Z = p.getBoundingClientRect();
            c += Z.height + n;
          }
        }
      });
    }
  }
  setRootElement(t) {
    if (!t) {
      console.error("setRootElement called with null");
      return;
    }
    this.el = t, this.el.appendChild(this.overlayContainer), this.el.appendChild(this.overlayContainerGlobal);
  }
  setCADRootElement(t) {
    this.elCAD = t;
  }
  getState() {
    return this.state;
  }
  setColorScheme(t) {
    (t === "light" || t === "dark") && this.viewConfiguration.colorScheme.set(t);
  }
  createRendererWindow(t) {
    var l, c, u;
    t.background && (this.windowBackground = t.background, this.screenshotBackgroundGradient = t.screenshotBackgroundGradient), this.renderWindow = YT.newInstance(), Byt(this.renderWindow), AZt(this.renderWindow), this.container = document.createElement("div"), this.el.appendChild(this.container);
    const e = vT.newInstance();
    this.openglRenderWindow = e, this.openglRenderWindow.setContainer(this.container), this.hardwareSelector = QA.newInstance(), this.renderWindow.addView(e), this.resize();
    const n = RT.newInstance();
    n.setView(e), n.initialize(), n.bindEvents(this.container), this.interactorStyle = U2t.newInstance({ context: this }), n.setInteractorStyle(this.interactorStyle), (l = this.getInteractorStyle()) == null || l.setCursorTool(this.toolManager.coordControl), (c = this.getInteractorStyle()) == null || c.setWindowLevelTool(this.toolManager.windowLevelTool), (u = this.getInteractorStyle()) == null || u.setMeasurementTool(this.toolManager.measurementsTool);
    const s = new ResizeObserver((d) => {
      for (const h of d)
        h.target === this.el && this.resize();
    });
    s.observe(this.el), this.onCleanup(() => s.disconnect());
    let r, a = !1;
    const o = () => {
      const d = window.devicePixelRatio, h = `(resolution: ${d}dppx)`;
      a && this.onPixelRatioChanged(d), r = matchMedia(h), r.addEventListener("change", o, {
        once: !0
      }), a = !0;
    };
    o(), this.onCleanup(() => {
      r && r.removeEventListener("change", o);
    }), this.onEvent(J0t, ({ objectId: d, visible: h }) => {
      this.objects.object3DInfos.update((p) => {
        const m = p.find((b) => b.id === d);
        return m ? (m.visible = h, p) : (console.warn("setObjectVisibilityEvent: object not found"), p);
      });
    }), this.onEvent(WP, ({ position: d }) => {
      this.panToPosition2D(...d);
    }), this.onEvent(this.inputMode.onInteractorBegin, () => {
      this.overlayModel.interactorActive.set(!0);
    }), this.onEvent(this.inputMode.onInteractorModified, (d) => {
      d.cameraModified();
    }), this.onEvent(this.inputMode.onInteractorEnd, () => {
      this.overlayModel.interactorActive.set(!1);
    }), this.onEvent(this.inputMode.onRotateBegin, (d) => {
      this.applyVolumeInteractionSettings(d);
    }), this.onEvent(this.inputMode.onRotateEnd, (d) => {
      this.restoreVolumeInteractionSettings(d);
    }), this.onEvent(uC, ({ orientation: d, id: h }) => {
      const p = d, m = [0, 0, 0], b = [0, 0, 0];
      switch (p) {
        case ks.Left:
          b[2] = 1, m[0] = 1;
          break;
        case ks.Right:
          b[2] = 1, m[0] = -1;
          break;
        case ks.Front:
          b[2] = 1, m[1] = -1;
          break;
        case ks.Back:
          b[2] = 1, m[1] = 1;
          break;
        case ks.Top:
          b[1] = 1, m[2] = 1;
          break;
        case ks.Bottom:
          b[1] = -1, m[2] = -1;
          break;
      }
      let y = !1;
      for (let Z of this.presenterWindows) {
        const g = Z.getMainView();
        if (g && g.isViewMode3D()) {
          if (g.id != h) continue;
          const T = g.getRenderer().getActiveCamera(), M = T.getFocalPoint(), N = T.getDistance();
          T.setPosition(M[0] + N * m[0], M[1] + N * m[1], M[2] + N * m[2]), T.setViewUp(b), g.cameraModified(), g.sceneRefresh(!0), y = !0;
        }
      }
      for (let Z of this.views)
        if (Z && Z.isViewMode3D()) {
          if (Z.id != h) continue;
          const f = Z.getRenderer().getActiveCamera(), T = f.getFocalPoint(), M = f.getDistance();
          f.setPosition(T[0] + M * m[0], T[1] + M * m[1], T[2] + M * m[2]), f.setViewUp(b), Z.cameraModified(), Z.sceneRefresh(!0), y = !0;
        }
      y && this.repaint();
    }), this.onEvent(this.objectMoveEvent, ({ objectId: d, position: h }) => {
      this.objects.moveObject(d, h);
    }), this.onEvent(this.objectRotateTopBottomStartEvent, ({ objectId: d, position: h }) => {
      this.objects.startRotateObject(d, h);
    }), this.onEvent(this.objectRotateTopBottomEvent, ({ objectId: d, position: h, top: p, viewMode: m }) => {
      let b = I.create();
      this.presenterWindows.forEach((y) => {
        if (y.presenterWindowType == ni.PresenterWindow2D) {
          const Z = y;
          Z.returnMainView().viewMode == m && (b = Z.returnMainView().getNormal());
        } else if (y.presenterWindowType == ni.PresenterWindow2DCustom)
          y.returnMainView().viewMode == m && (b = this.CPRMath.getClosestSplineNormal(h));
        else if (y.presenterWindowType == ni.PresenterWindow3D) {
          const Z = y;
          Z.returnMainView().viewMode == m && (b = Z.returnMainView().renderer.getActiveCamera().getViewPlaneNormal());
        }
      }), this.objects.rotateObject(d, h, b, p);
    });
  }
  setModalsInstance(t) {
    this.vueModalsInstance = t;
  }
  getModalsInstance() {
    if (!this.vueModalsInstance)
      throw "wizard not initialized";
    return this.vueModalsInstance;
  }
  setResourceUrl(t) {
    this.resourceUrl = t;
  }
  getResourceUrl() {
    if (!this.resourceUrl)
      throw "resource url not set";
    return ((this.baseWASMEnginePath == "" ? "/" : this.baseWASMEnginePath) + this.resourceUrl).replaceAll("//", "/");
  }
  getBaseUrl() {
    return this.baseWASMEnginePath;
  }
  normalizeAssetPath(t) {
    return this.baseWASMEnginePath === "" || this.baseWASMEnginePath === "/" ? t : (this.baseWASMEnginePath + t).replaceAll("//", "/");
  }
  resize() {
    const { width: t, height: e } = this.el.getBoundingClientRect();
    if (!(!t || !e) && (this.overlayContainer.style.width = t.toString() + "px", this.overlayContainer.style.height = e.toString() + "px", this.overlayContainerGlobal.style.width = t.toString() + "px", this.overlayContainerGlobal.style.height = e.toString() + "px", this.overlayContainerSize.set([t, e]), this.container && this.openglRenderWindow)) {
      this.openglRenderWindow.setSize(t, e);
      const n = this.container.getElementsByTagName("canvas")[0];
      this.removeWebGLContextEventForwarding || (this.removeWebGLContextEventForwarding = ZB(n, "planner"), this.onCleanup(() => {
        var s;
        (s = this.removeWebGLContextEventForwarding) == null || s.call(this), this.removeWebGLContextEventForwarding = void 0;
      })), n.classList.add("all-radius-8"), n.style.width = t + "px", n.style.height = e + "px", this.renderWindowWithOptionalClear(!0), this.canvasSize.set([t, e]), this.renderWindowWithOptionalClear(!0);
    }
  }
  updateCanvasSize() {
    const { width: t, height: e } = this.el.getBoundingClientRect();
    this.canvasSize.set([t, e]);
  }
  getMinSpacing() {
    return Math.min(...this.imageData.getSpacing()) * (this.volumeDecimated ? 0.5 : 1);
  }
  setImageDataScalarBuffer(t) {
    this.imageData.getPointData().getScalars().setData(t), this.syncImageDataToWasm();
  }
  setImageData(t, e = !1) {
    e ? (this.imageData = sbt(t), this.volumeDecimated = !0) : (this.imageData = t, this.volumeDecimated = !1), this.syncImageDataToWasm(), this.origin2D.set(this.imageData.getCenter());
  }
  getDataSpacing() {
    return Math.min(...this.getImageData().getSpacing());
  }
  syncImageDataToWasm() {
    if (this.xWasmDocument) {
      const t = this.imageData.getPointData().getScalars().getData();
      console.log("syncImageDataToWasm Initial dimensions", this.imageData.getDimensions());
      const e = t instanceof Int16Array ? t : new Int16Array(t);
      this.xWasmDocument.SetImageData(
        e,
        new Float64Array(this.imageData.getOrigin()),
        new Float64Array(this.imageData.getSpacing()),
        new Int32Array(this.imageData.getDimensions())
      );
      const n = this.xWasmDocument.GetImageDataView();
      Go(n, this.imageData), n.delete();
    }
  }
  getImageData() {
    return this.imageData;
  }
  applyVolumeInteractionSettings(t) {
    if (!t.isViewMode3D() || !this.volumeActor || !this.volumeMapper || this.volumeInteractionDepth > 0)
      return;
    const e = this.volumeActor.getProperty();
    this.volumeInteractionSettings = {
      sampleDistance: this.volumeMapper.getSampleDistance(),
      maximumSamplesPerRay: this.volumeMapper.getMaximumSamplesPerRay(),
      interpolationType: e.getInterpolationType()
    };
    const n = Math.min(...this.imageData.getSpacing()), s = Math.max(this.volumeInteractionSettings.sampleDistance * 2.5, n * 1.5), r = Math.min(this.volumeInteractionSettings.maximumSamplesPerRay, 1e3);
    this.volumeMapper.setSampleDistance(s), this.volumeMapper.setMaximumSamplesPerRay(r), e.setInterpolationType(Uh.FAST_LINEAR), this.volumeMapper.modified(), this.volumeActor.modified(), this.volumeInteractionDepth = 1;
  }
  restoreVolumeInteractionSettings(t) {
    if (!t.isViewMode3D() || this.volumeInteractionDepth === 0)
      return;
    if (this.volumeInteractionDepth = 0, !this.volumeInteractionSettings || !this.volumeActor || !this.volumeMapper) {
      this.volumeInteractionSettings = void 0;
      return;
    }
    const e = this.volumeActor.getProperty();
    this.volumeMapper.setSampleDistance(this.volumeInteractionSettings.sampleDistance), this.volumeMapper.setMaximumSamplesPerRay(this.volumeInteractionSettings.maximumSamplesPerRay), e.setInterpolationType(this.volumeInteractionSettings.interpolationType), this.volumeMapper.modified(), this.volumeActor.modified(), this.volumeInteractionSettings = void 0;
  }
  createVolumeObject() {
    const t = BI.newInstance(), e = KI.newInstance();
    t.setMapper(e), e.setInputData(this.imageData);
    const n = this.imageData.getPointData().getScalars() || this.imageData.getPointData().getArrays()[0];
    if (n) {
      const a = n.getRange();
      t.getProperty().setGradientOpacityMinimumValue(0, 0), t.getProperty().setGradientOpacityMaximumValue(0, (a[1] - a[0]) * 0.05);
    }
    e.setAutoAdjustSampleDistances(!1);
    const s = Math.min(...this.imageData.getSpacing()), r = Math.max(s * 0.7, 0.2);
    return e.setSampleDistance(r), e.setMaximumSamplesPerRay(1500), t.setPickable(!1), this.volumeOptions.updateVolumeOptions(e, t), {
      actor: t,
      mapper: e
    };
  }
  /**
   * Recreate the current volume actor and mapper from image data.
   *
   * Pass `{ render: false }` when the volume is only needed for project export or offscreen screenshots.
   */
  replaceVolumeObject(t) {
    const e = (t == null ? void 0 : t.render) ?? !0, { actor: n, mapper: s } = this.createVolumeObject();
    this.volumeActor && (this.removeActor(this.volumeActor), this.volumeActor.delete()), this.volumeMapper && (this.removeMapper(this.volumeMapper), this.volumeMapper.delete()), this.volumeActor = n, this.volumeMapper = s, this.objects.addVtkImage({
      mapper: this.volumeMapper,
      actor: this.volumeActor
    }), e && this.onActorAdded.notify({ actor: this.volumeActor, objectType: Yt._NONE }), this.origin2D.set(this.imageData.getCenter()), e && (this.resetCamera(), this.repaint());
  }
  getImageInfo() {
    const t = this.getVolumeWindowWidthLevel();
    return {
      dim: this.imageData.getDimensions(),
      offset: this.imageData.getOrigin(),
      spacing: this.imageData.getSpacing(),
      windowWidth: t[0],
      windowLevel: t[1]
    };
  }
  getImageDataBuffer() {
    const t = this.imageData.getPointData().getScalars().getData().slice();
    if ("buffer" in t)
      return t.buffer;
    throw "image data is not a typed array";
  }
  renderPredictions() {
    for (const t of this.predictions)
      t.visibility && t.iMeshActor && t.iMeshMapper ? t.iData != null && (this.objects.getActors().includes(t.iMeshActor) || (this.objects.addVtkObject({
        mapper: t.iMeshMapper,
        actor: t.iMeshActor,
        objectType: Yt._NONE
      }), this.onCrossSectionAdded.notify(t)), t.iMeshActor.setVisibility(!0), this.repaint()) : t.iMeshActor && this.objects.getActors().includes(t.iMeshActor) && (t.iMeshActor.setVisibility(!1), this.repaint());
  }
  deletePrediction(t) {
    var n;
    let e = -1;
    if (this.predictions.forEach((s, r) => {
      I.distance(t, s.point) < 1e-6 && (e = r);
    }), e != -1) {
      const s = this.predictions[e].iMeshActor, r = this.predictions[e].iMeshMapper;
      s != null && r != null && (this.removeActor(s), s.delete(), this.removeMapper(r), r.delete(), (n = this.predictions[e].iData) == null || n.delete(), this.onCrossSectionRemoved.notify(this.predictions[e].label)), this.predictions.splice(e, 1);
    }
    PC.notify(this.predictions);
  }
  getVolume() {
    return {
      volumeMapper: this.volumeMapper,
      volumeActor: this.volumeActor
    };
  }
  setVolumeOptions(t) {
    this.volumeOptions.setTemplate(t);
    const [e, n] = this.volumeOptions.getWindowWidthLevel();
    this.volumeOptions3D.set({ windowWidth: e, windowLevel: n }), this.volumeMapper && this.volumeActor && (this.volumeOptions.updateVolumeOptions(this.volumeMapper, this.volumeActor), this.repaint());
  }
  setVolumeOptionsOverride(t, e, n) {
    this.volumeOptions.overrideSettings(t, e, n), this.volumeMapper && this.volumeActor && (this.volumeOptions.updateVolumeOptions(this.volumeMapper, this.volumeActor), this.repaint());
  }
  setVolumeInterpolationType(t) {
    this.volumeOptions.setInterpolationType(t), this.volumeMapper && this.volumeActor && (this.volumeOptions.updateVolumeOptions(this.volumeMapper, this.volumeActor), this.repaint());
  }
  setVolumeMIP(t) {
    this.volumeOptions.setMIP(t), this.volumeMapper && this.volumeActor && (this.volumeOptions.updateVolumeOptions(this.volumeMapper, this.volumeActor), this.repaint());
  }
  setVolumeShading(t) {
    this.volumeOptions.setShading(t), this.volumeMapper && this.volumeActor && (this.volumeOptions.updateVolumeOptions(this.volumeMapper, this.volumeActor), this.repaint());
  }
  setVolumeWindowWidthLevel(t, e) {
    const [n, s] = this.volumeOptions.setWindowWidthLevel(this.volumeActor, t, e);
    this.volumeOptions3D.set({ windowWidth: n, windowLevel: s }), this.volumeMapper && this.volumeActor && this.repaint();
  }
  getVolumeWindowWidthLevel() {
    const t = this.volumeOptions3D.get();
    return [t.windowWidth, t.windowLevel];
  }
  getCurrentVolumeOptions() {
    return this.volumeOptions.getCurrentTemplate();
  }
  setVolumePoints(t) {
    this.volumeOptions.setPoints(t);
    const [e, n] = this.volumeOptions.getWindowWidthLevel();
    this.volumeOptions3D.set({ windowWidth: e, windowLevel: n }), this.volumeMapper && this.volumeActor && (this.volumeOptions.updateVolumeOptions(this.volumeMapper, this.volumeActor), this.repaint());
  }
  setVolumeActorVisibility(t) {
    var e;
    (e = this.volumeActor) == null || e.setVisibility(t), this.repaint();
  }
  createSliceObject() {
    const t = Up.newInstance(), e = jp.newInstance(), n = this.imageData.getExtent();
    return t.setMapper(e), e.setInputData(this.imageData), t.getProperty().setColorLevel(1e3), t.getProperty().setColorWindow(4e3), this.objects.addVtkImageSlice({
      mapper: e,
      actor: t
    }), [e, t, n];
  }
  new(t, ...e) {
    return t.newInstance(...e);
  }
  createReslicePrediction(t) {
    const e = ob.newInstance();
    e.setInputData(t.iData), e.setSlabMode(Pp.MAX), e.setSlabNumberOfSlices(1), e.setTransformInputSampling(!1), e.setAutoCropOutput(!0), e.setOutputDimensionality(2);
    const n = jp.newInstance();
    n.setInputConnection(e.getOutputPort());
    const s = Up.newInstance();
    s.getProperty().setInterpolationTypeToLinear(), s.setMapper(n), s.getProperty().setColorLevel(0), s.getProperty().setColorWindow(1);
    const r = L0.newInstance();
    r.addRGBPoint(-0.5, 0, 0, 0), r.addRGBPoint(0, 0, 0, 0), r.addRGBPoint(1e4, t.color[0], t.color[1], t.color[2]), s.getProperty().setRGBTransferFunction(0, r), s.getProperty().setOpacity(0.3);
    const a = Bh.newInstance();
    a.addPoint(-0.5, 0), a.addPoint(0, 0), a.addPoint(0.5, 1), s.getProperty().setScalarOpacity(0, a), this.objects.addVtkObject({
      mapper: n,
      actor: s
    }), this.objects.addVtkImageSlice({
      mapper: n,
      actor: s
    });
    let o = [0, 0, 0, 0, 0, 0], l = [1, 1, 1];
    return t.iData && (o = t.iData.getBounds(), l = t.iData.getSpacing()), {
      reslice: e,
      mapper: n,
      actor: s,
      bounds: o,
      spacing: l
    };
  }
  createResliceObject(t) {
    const e = ob.newInstance();
    e.setInputData(t), e.setSlabMode(Pp.MEAN), e.setSlabNumberOfSlices(1), e.setTransformInputSampling(!1), e.setInterpolationMode(zi.LINEAR), e.setAutoCropOutput(!0), e.setOutputDimensionality(2);
    const n = t.getPointData().getScalars().getRange()[0];
    e.setBackgroundColor([n, n, n, 0]);
    const s = jp.newInstance();
    s.setInputConnection(e.getOutputPort());
    const r = Up.newInstance();
    r.getProperty().setInterpolationTypeToLinear(), r.setMapper(s), r.getProperty().setColorLevel(1e3), r.getProperty().setColorWindow(4e3), this.objects.addVtkImageSlice({
      mapper: s,
      actor: r
    });
    const a = t.getBounds(), o = t.getSpacing();
    return {
      reslice: e,
      mapper: s,
      actor: r,
      bounds: a,
      spacing: o
    };
  }
  getEngine() {
    if (!this.engineInstance)
      throw Error("Engine Instance not defined");
    return this.engineInstance;
  }
  async getEngineInstance() {
    return (!this.module || !this.engineInstance) && (this.module = await kvt(), this.engineInstance = new p3(this.module), this.xWasmDocument = new this.engineInstance.xWasmDocumentJS(), this.prepareWasmFS()), this.engineInstance;
  }
  setExternalEngineInstance(t) {
    this.engineInstance = t;
  }
  getFS() {
    if (!this.module)
      throw Error("Engine module not initialized!!");
    return this.module;
  }
  getWasmDocumentInstance() {
    return ge(this.xWasmDocument);
  }
  prepareWasmFS() {
    this.makeDir("/app");
  }
  makeDir(t) {
    const e = this.getFS();
    if (e)
      try {
        e.FS.mkdir(t);
      } catch (n) {
        console.log("Mkdir exception:", n);
      }
  }
  async uploadModel(t) {
    const e = this.getBaseUrl() + t, s = await (await fetch(e.replaceAll("//", "/"))).arrayBuffer(), r = await this.getFS();
    r && (r.FS.writeFile("/app/" + t, new Uint8Array(s)), console.log("stats:", r.FS.stat("/app/" + t)));
  }
  createWasmReslicer(t) {
    const e = this.getEngine(), n = new e.xReslicer();
    this.onCleanup(() => {
      try {
        n.delete();
      } catch (u) {
        console.log(u);
      }
    }), n.updateMatrix(new Float64Array(t));
    const s = n.GetSliceView(), r = xs.newInstance();
    Go(s, r);
    const a = jp.newInstance();
    a.setInputData(r);
    const o = Up.newInstance();
    o.setMapper(a), o.getProperty().setColorLevel(1e3), o.getProperty().setColorWindow(4e3), this.objects.addVtkImageSlice({
      mapper: a,
      actor: o
    });
    const l = this.imageData.getBounds(), c = this.imageData.getSpacing();
    return {
      reslicer: n,
      mapper: a,
      actor: o,
      bounds: l,
      spacing: c
    };
  }
  cleanup() {
    var e, n, s, r, a, o, l;
    if (this.destructed) return;
    this.destructed = !0, console.log("CONTEXT - CleanUp - START"), this.toolManager.destructAllTools(), (e = this.contextCAD) == null || e.cleanup();
    const t = (n = this.renderWindow) == null ? void 0 : n.getInteractor();
    t == null || t.unbindEvents(), t == null || t.disable();
    try {
      (r = (s = this.openglRenderWindow) == null ? void 0 : s.releaseGraphicsResources) == null || r.call(s);
    } catch (c) {
      console.warn("Failed to release main OpenGL render window graphics resources", c);
    }
    this.presenterWindows.forEach((c) => c.cleanup()), this.views.forEach((c) => c.cleanup()), this.onCleanupArray.reduceRight((c, u) => (u(), null), null), this.objects.cleanup();
    try {
      this.xWasmDocument && ge(this.xWasmDocument).delete(), this.xWasmDocument = void 0;
    } catch (c) {
      console.log(c);
    }
    if (i3(oY, null), (a = this.renderWindow) == null || a.getRenderers().forEach((c) => c.delete()), this.openglRenderWindow) {
      try {
        (o = this.renderWindow) == null || o.removeView(this.openglRenderWindow);
      } catch (c) {
        console.warn("Failed to remove main OpenGL render window view", c);
      }
      try {
        this.openglRenderWindow.setContainer(null);
      } catch (c) {
        console.warn("Failed to detach main OpenGL render window container", c);
      }
      try {
        this.openglRenderWindow.delete();
      } catch (c) {
        console.warn("Failed to delete main OpenGL render window", c);
      }
      this.openglRenderWindow = void 0;
    }
    (l = this.renderWindow) == null || l.delete(), this.engineInstance = void 0, this.module = void 0, lY = !1, console.log("CONTEXT - CleanUp - END!!!");
  }
  resetCamera() {
    var t;
    this.destructed || (t = this.renderWindow) == null || t.getRenderers().forEach((e) => {
      if (e.isDeleted()) return;
      const n = e.computeVisiblePropBounds();
      e.resetCameraClippingRange(n), e.resetCamera();
    });
  }
  clearRenderBuffer() {
    var a, o;
    const t = this.openglRenderWindow;
    if (!t)
      return;
    const e = (a = t == null ? void 0 : t.getContext) == null ? void 0 : a.call(t);
    if (!e || e.isContextLost())
      return;
    const n = ((o = t.getSize) == null ? void 0 : o.call(t)) ?? this.canvasSize.get(), s = Math.floor(n[0] ?? 0), r = Math.floor(n[1] ?? 0);
    s <= 0 || r <= 0 || (e.bindFramebuffer(e.FRAMEBUFFER, null), e.disable(e.SCISSOR_TEST), e.viewport(0, 0, s, r), e.colorMask(!0, !0, !0, !0), e.depthMask(!0), e.clearColor(0, 0, 0, 0), e.clearDepth(1), e.clear(e.COLOR_BUFFER_BIT | e.DEPTH_BUFFER_BIT));
  }
  layoutCoversRenderWindow(t) {
    if (t.length === 0)
      return !0;
    const e = 1e-6, n = t.map(([, o]) => ({
      xmin: Math.max(0, Math.min(1, o.xmin)),
      ymin: Math.max(0, Math.min(1, o.ymin)),
      xmax: Math.max(0, Math.min(1, o.xmax)),
      ymax: Math.max(0, Math.min(1, o.ymax))
    }));
    if (n.some((o) => o.xmax - o.xmin <= e || o.ymax - o.ymin <= e))
      return !1;
    const s = (o) => o.sort((l, c) => l - c).filter((l, c, u) => c === 0 || Math.abs(l - u[c - 1]) > e), r = s([0, 1, ...n.flatMap((o) => [o.xmin, o.xmax])]), a = s([0, 1, ...n.flatMap((o) => [o.ymin, o.ymax])]);
    for (let o = 0; o < r.length - 1; o++)
      for (let l = 0; l < a.length - 1; l++) {
        const c = (r[o] + r[o + 1]) / 2, u = (a[l] + a[l + 1]) / 2;
        if (!n.some((h) => c >= h.xmin - e && c <= h.xmax + e && u >= h.ymin - e && u <= h.ymax + e))
          return !1;
      }
    return !0;
  }
  renderWindowWithOptionalClear(t = !1) {
    var e;
    (t || this.layoutNeedsFullRenderBufferClear) && this.clearRenderBuffer(), (e = this.renderWindow) == null || e.render();
  }
  repaint() {
    this.renderWindowWithOptionalClear();
  }
  sceneRepaint(t, e, n) {
    this.activeReconstruction ? this.activeReconstruction.sceneRepaint(t, e, n) : this.layoutManager.sceneRepaint(t, e), !(e && n) && this.repaint();
  }
  sceneRefresh(t) {
    this.layoutManager.sceneRefresh(t), this.repaint();
  }
  requestRepaint() {
    this.repaintRequested || (this.repaintRequested = !0, queueMicrotask(() => {
      this.repaintRequested = !1, this.repaint();
    }));
  }
  getActors() {
    return this.objects.getActors();
  }
  getRenderWindow() {
    return this.renderWindow;
  }
  setLayout(t, e) {
    this.currentViewLayout = t, this.layoutNeedsFullRenderBufferClear = !this.layoutCoversRenderWindow(t), t.length === 0 ? (this.defaultRenderer = ld.newInstance(), this.defaultRenderer.setBackground(this.windowBackground), this.renderWindow.addRenderer(this.defaultRenderer)) : this.defaultRenderer && (this.renderWindow.removeRenderer(this.defaultRenderer), this.defaultRenderer.delete(), this.defaultRenderer = null);
    const n = t.map((s) => s[0]);
    for (const [s, r] of t)
      s.setViewport(r);
    for (const s of this.views)
      n.includes(s) ? s.show(e) : s.hide();
    for (const s of this.presenterWindows)
      n.includes(s) ? s.show(e) : s.hide();
    if (this.activeReconstruction)
      for (const s of this.activeReconstruction.presenterWindows)
        n.includes(s) ? s.show(e) : s.hide();
    this.renderWindowWithOptionalClear(), this.overlayContainerSize.set([this.overlayContainer.clientWidth, this.overlayContainer.clientHeight]);
  }
  getLayout() {
    return this.currentViewLayout;
  }
  removeActor(t) {
    this.objects.removeActor(t);
  }
  removeMapper(t) {
    this.objects.removeMapper(t);
  }
  addView(t) {
    this.views.push(t);
  }
  removeView(t) {
    const e = this.views.indexOf(t);
    e !== -1 && this.views.splice(e, 1);
  }
  addWindow(t) {
    this.presenterWindows.push(t);
  }
  removeWindow(t) {
    const e = this.presenterWindows.indexOf(t);
    e !== -1 && this.presenterWindows.splice(e, 1);
  }
  getPresenterWindows() {
    return this.presenterWindows;
  }
  getViews() {
    return this.views;
  }
  addSectionalView(t) {
    this.sectionalViews.push(t);
  }
  removeSectionalView(t) {
    const e = this.sectionalViews.indexOf(t);
    e !== -1 && this.sectionalViews.splice(e, 1);
  }
  getViewWidget(t) {
    var e;
    for (const n of this.presenterWindows)
      if (((e = n.getMainView()) == null ? void 0 : e.getViewMode()) == t)
        return n.getMainView();
    return null;
  }
  getViewByID(t) {
    var e;
    for (const n of this.presenterWindows)
      if (((e = n.getMainView()) == null ? void 0 : e.id) == t)
        return n.getMainView();
    return null;
  }
  getPresenterWindow(t) {
    var e;
    for (const n of this.presenterWindows)
      if (((e = n.getMainView()) == null ? void 0 : e.getViewMode()) == t)
        return n;
    return null;
  }
  getView(t) {
    for (const e of this.sectionalViews)
      if (e.containsRenderer(t))
        return e;
    for (const e of this.views)
      if (e.containsRenderer(t))
        return e;
    for (const e of this.presenterWindows) {
      const n = e.getMainView();
      if (n != null && n.containsRenderer(t))
        return n;
      let s = null;
      const r = e.getViews();
      if (r) {
        for (const a of r)
          a.containsRenderer(t) && (s = a);
        if (s != null)
          return s;
      }
    }
    if (this.activeReconstruction)
      for (const e of this.activeReconstruction.presenterWindows) {
        const n = e.getMainView();
        if (n != null && n.containsRenderer(t))
          return n;
        let s = null;
        const r = e.getViews();
        if (r) {
          for (const a of r)
            a.containsRenderer(t) && (s = a);
          if (s != null)
            return s;
        }
      }
    return null;
  }
  getVtkCanvas() {
    var t;
    return (t = this.container) == null ? void 0 : t.getElementsByTagName("canvas")[0];
  }
  getOverlayContainer() {
    return this.overlayContainer;
  }
  getBoundingRect() {
    return this.el.getBoundingClientRect();
  }
  worldToDisplay(t, e, n, s) {
    var o, l;
    if (this.destructed)
      return [0, 0, 0];
    if (!this.openglRenderWindow)
      throw new Error("no render window");
    if (!((o = t.getActiveCamera) == null ? void 0 : o.call(t))) {
      if (this.destructed)
        return [0, 0, 0];
      throw new Error("renderer camera missing");
    }
    const a = (l = t.getViewportByReference) == null ? void 0 : l.call(t);
    if (!a || a.length < 4)
      return [0, 0, 0];
    try {
      return this.openglRenderWindow.worldToDisplay(e, n, s, t);
    } catch (c) {
      if (this.destructed)
        return [0, 0, 0];
      throw c;
    }
  }
  displayToWorld(t, e, n, s) {
    var a;
    if (this.destructed)
      return [0, 0, 0];
    if (!this.openglRenderWindow)
      throw new Error("no render window");
    if (!((a = t.getActiveCamera) == null ? void 0 : a.call(t))) {
      if (this.destructed)
        return [0, 0, 0];
      throw new Error("renderer camera missing");
    }
    try {
      return this.openglRenderWindow.displayToWorld(e, n, s, t);
    } catch (o) {
      if (this.destructed)
        return [0, 0, 0];
      throw o;
    }
  }
  getPixelRatio() {
    return window.devicePixelRatio;
  }
  onPixelRatioChanged(t) {
    console.log("context onPixelRatioChanged", t);
  }
  getInputMode() {
    return this.inputMode;
  }
  getInteractorStyle() {
    return this.interactorStyle;
  }
  hardwareSelectorPick(t, e, n, s, r) {
    return !this.openglRenderWindow || !this.hardwareSelector ? (console.error("window/hardwareSelector not initialized"), null) : (this.hardwareSelector.setCaptureZValues(s), this.hardwareSelector.setFieldAssociation(f0.FIELD_ASSOCIATION_CELLS), this.hardwareSelector.attach(this.openglRenderWindow, t), this.hardwareSelector.setArea(e, n, e, n), this.hardwareSelector.select({ captureAttributeIds: r }));
  }
  hardwareSelectorCaptureBuffers(t, e, n) {
    if (!this.openglRenderWindow || !this.hardwareSelector)
      return console.error("window/hardwareSelector not initialized"), !1;
    const s = this.openglRenderWindow.getSize();
    return this.hardwareSelector.setArea(0, 0, s[0], s[1]), this.hardwareSelector.setCaptureZValues(e), this.hardwareSelector.setFieldAssociation(f0.FIELD_ASSOCIATION_CELLS), this.hardwareSelector.attach(this.openglRenderWindow, t), this.hardwareSelector.captureBuffers({ captureAttributeIds: n });
  }
  hardwareSelectorReleasePixBuffers() {
    var t;
    (t = this.hardwareSelector) == null || t.releasePixBuffers();
  }
  panToPosition2D(t, e, n) {
    console.log("panToPosition2D nothing here", t, e, n);
  }
  resetOrientation(t) {
    const e = (t == null ? void 0 : t.resetMode) ?? !0;
    this.resetRotation(e);
    const n = this.getViewWidget(Nt.CPR), s = this.getViewWidget(Nt.CROSS);
    n && (n.isVisible() || s != null && s.isVisible()) && !this.cprSettings && (t != null && t.preserveCPRAngles ? (this.toolManager.coordControl.crossAngle.modified(), this.toolManager.coordControl.viewUpAngle.modified()) : this.toolManager.coordControl.resetCPRParams(), e && this.toolManager.coordControl.setCenter(n.getOrigin(), n)), e && this.cprSettings && this.toolManager.cprTool && this.toolManager.cprTool.snapToOwner(), this.sceneRefresh();
  }
  fitViewToScreen() {
    this.presenterWindows.forEach((t) => {
      if (t.presenterWindowType == ni.PresenterWindow2D) {
        const e = t;
        e.returnMainView().isShownWrapper().get() && e.returnMainView().fitZoomToScreen();
      } else if (t.presenterWindowType == ni.PresenterWindow2DCustom) {
        const e = t;
        e.returnMainView().isShownWrapper().get() && e.returnMainView().fitZoomToScreen();
      } else if (t.presenterWindowType == ni.PresenterWindow3D) {
        const e = t;
        e.returnMainView().isShownWrapper().get() && e.returnMainView().fitZoomToScreen();
      }
    });
  }
  /*! set coordinate axes and origin for image viewMode*/
  setUserPosition(t, e) {
    this.presenterWindows.forEach((n) => {
      if (n.presenterWindowType == ni.PresenterWindow2D) {
        const s = n, r = s.returnMainView();
        r.viewMode == e && (r.setViewMatrix(t), s.setSliceInfoNormal());
      }
    });
  }
  // public setUserOrigin(x: number, y: number, z: number): void {
  //     this.presenterWindows.forEach((pW) => {
  //         if(pW.presenterWindowType == PresenterWindowType.PresenterWindow2D){
  //             const pWindow = pW as PresenterWindow2D<View2D>;
  //             const pView = pWindow.returnMainView();
  //             pView.setOrigin(x,y,z);
  //         }
  //     })
  // }
  // public getUserOrigin(viewMode : ViewMode) {
  //     if (this.getViewWidget(viewMode))
  //     this.getViewWidget(viewMode)?.getOrigin();
  // }
  resetRotation(t = !0) {
    for (let e of this.presenterWindows) {
      const n = ge(e.getMainView());
      if (n && n.isVisible()) {
        n == null || n.resetViewPosition(t), n == null || n.fitZoomToScreen(), n == null || n.resetViewCamera(), n == null || n.updateCrossSliceIndicator();
        const s = e.getViews();
        if (s)
          for (let r of s)
            r.resetViewPosition(t), r.fitZoomToScreen(), r.resetViewCamera(), r.updateCrossSliceIndicator();
        e.setSliceInfoNormal();
      }
    }
  }
  setSliceInfo(t, e) {
    this.sliceInfos2D.update((n) => (n[t] = e, n));
  }
  clearSliceInfo(t) {
    this.sliceInfos2D.update((e) => (delete e[t], e));
  }
  async loadReconstructionProject(t) {
    await k1t(this, t);
  }
  async loadSTLProject(t, e = !1) {
    await zVt(this, t, e);
  }
  getActorType(t) {
    return this.actorTypes.get(t);
  }
  getActorId(t) {
    return this.objects.actorIds.get(t);
  }
  getActorTypes() {
    return this.actorTypes;
  }
  setInfoFlag(t) {
    this.infoFlag.set(t);
  }
  getInfoFlag() {
    return this.infoFlag;
  }
  getViewId(t) {
    let e;
    return this.getPresenterWindows().forEach((n) => {
      var s, r;
      t == ((s = n.getMainView()) == null ? void 0 : s.getViewMode()) && (e = (r = n.getMainView()) == null ? void 0 : r.id);
    }), e;
  }
  rotateImage(t, e, n) {
    if (this.volumeDecimated) return;
    const s = this.imageData.getCenter(), r = ob.newInstance();
    r.setInputData(this.imageData), r.setOutputDimensionality(3);
    const a = ut.identity(new Float32Array(16));
    ut.translate(a, a, I.fromValues(s[0], s[1], s[2])), ut.rotateX(a, a, t * Math.PI / 180), ut.rotateY(a, a, e * Math.PI / 180), ut.rotateZ(a, a, n * Math.PI / 180), ut.translate(a, a, I.fromValues(-s[0], -s[1], -s[2])), r.setResliceAxes(a), this.setImageData(r.getOutputData()), this.replaceVolumeObject(), this.getPresenterWindows().forEach((o) => {
      o.presenterWindowType == ni.PresenterWindow2D && o.returnMainView().replaceReslicer();
    }), setTimeout(() => {
      this.resetOrientation();
    }, 0), this.reorientationHistory.push(a), this.volumeModified = !0;
  }
  flipImage(t, e, n) {
    if (this.volumeDecimated) return;
    const s = this.imageData.getCenter(), r = ob.newInstance();
    r.setInputData(this.imageData), r.setOutputDimensionality(3);
    const a = ut.identity(new Float32Array(16));
    ut.translate(a, a, I.fromValues(s[0], s[1], s[2])), t ? ut.scale(a, a, I.fromValues(-1, 1, 1)) : e ? ut.scale(a, a, I.fromValues(1, -1, 1)) : n && ut.scale(a, a, I.fromValues(1, 1, -1)), ut.translate(a, a, I.fromValues(-s[0], -s[1], -s[2])), r.setResliceAxes(a), this.reorientationHistory.push(a), this.setImageData(r.getOutputData()), this.replaceVolumeObject(), this.getPresenterWindows().forEach((o) => {
      o.presenterWindowType == ni.PresenterWindow2D && o.returnMainView().replaceReslicer();
    }), setTimeout(() => {
      this.resetOrientation();
    }, 0), this.volumeModified = !0;
  }
  finalReorientMatrix() {
    let t = ut.identity(new Float32Array(16));
    for (const e of this.reorientationHistory)
      t = ut.mul(t, t, e);
    return ut.invert(t, t), t;
  }
  undoLastReorientation() {
    if (this.reorientationHistory.length != 0) {
      const t = ob.newInstance();
      t.setInputData(this.imageData), t.setOutputDimensionality(3);
      const e = this.reorientationHistory.at(-1);
      ut.invert(e, e), t.setResliceAxes(e), this.reorientationHistory.pop(), this.setImageData(t.getOutputData()), this.replaceVolumeObject(), this.getPresenterWindows().forEach((n) => {
        n.presenterWindowType == ni.PresenterWindow2D && n.returnMainView().replaceReslicer();
      }), setTimeout(() => {
        this.resetOrientation();
      }, 0);
    }
  }
  freezeWizardPanel(t, e) {
    this.wizardPanelFreeze.set(t), t ? this.freezeTimer = setTimeout(() => {
      this.showLoading(jt("shared.loading"));
    }, 1e3) : (this.freezeTimer != null && (clearTimeout(this.freezeTimer), this.freezeTimer = null), this.hideLoading());
  }
  setLoadingCancelButton(t, e) {
    this.loadingCancelVisible.set(t), this.loadingCancelHandler = t ? e ?? null : null;
  }
  showLoading(t = "Loading", e = !1, n, s, r, a) {
    this.nonTransparentLoading.set(!!s), this.progressBarFlag = e, r !== void 0 && this.setLoadingCancelButton(r, a), this.loadingFlag.set(!1), this.loadingText = t, this.loadingFlag.set(!0), n && this.progressBarValue.set(n);
  }
  hideLoading() {
    this.loadingFlag.set(!1), this.progressBarValue.set(0), this.setLoadingCancelButton(!1);
  }
  setProgressBarValue(t) {
    this.progressBarValue.set(t);
  }
  createPreviewContext(t) {
    var n, s, r;
    const e = new z4(this.baseWASMEnginePath);
    if (this.resourceUrl && this.vueModalsInstance) {
      e.setRootElement(t), e.setResourceUrl(this.resourceUrl), e.setModalsInstance(this.vueModalsInstance), e.createRendererWindow({ background: this.windowBackground });
      const a = this.getInteractorStyle();
      a && ((n = e.getInteractorStyle()) == null || n.setCameraInteractorEnabled(a.getCameraInteractorEnabled()), (s = e.getInteractorStyle()) == null || s.setMouseMode(a.getMouseMode()), (r = e.getInteractorStyle()) == null || r.setMouseMode2D(a.getMouseMode2D()));
    }
    return e;
  }
  async takeWindowScreenshot() {
    var o;
    const t = this.getVtkCanvas();
    if (!t)
      return console.error("vtk canvas not found"), null;
    const e = document.createElement("canvas");
    e.width = t.width, e.height = t.height, this.renderWindowWithOptionalClear(!0);
    const n = e.getContext("2d");
    if (!n)
      throw new Error("Could not get canvas context");
    if (this.screenshotBackgroundGradient) {
      const l = n.createLinearGradient(0, 0, 0, e.height);
      l.addColorStop(0, DW(this.screenshotBackgroundGradient.to)), l.addColorStop(1, DW(this.screenshotBackgroundGradient.from)), n.fillStyle = l, n.fillRect(0, 0, e.width, e.height);
    }
    n.drawImage(t, 0, 0);
    const s = this.getOverlayContainer(), a = await gN(s, {
      // override absolute position of the div
      style: {
        position: "static"
      },
      // downscale overlay to vtk canvas dimensions
      pixelRatio: 1,
      skipFonts: !0
    });
    return (o = e.getContext("2d")) == null || o.drawImage(a, 0, 0), e;
  }
  async takeWindowScreenshotWebcad() {
    var u, d, h;
    const t = this.getVtkCanvas();
    if (!t)
      return console.error("vtk canvas not found"), null;
    const e = document.createElement("canvas");
    e.width = document.body.clientWidth, e.height = document.body.clientHeight;
    const n = t.getBoundingClientRect(), s = this.getOverlayContainer(), r = {
      // override absolute position of the div
      style: {
        position: "static"
      },
      // downscale overlay to vtk canvas dimensions
      pixelRatio: 1,
      skipFonts: !0
    }, a = gN(s, r), o = gN(document.body, r), [l, c] = await Promise.all([a, o]);
    return (u = e.getContext("2d")) == null || u.drawImage(c, 0, 0), this.renderWindowWithOptionalClear(!0), (d = e.getContext("2d")) == null || d.drawImage(t, n.x, n.y), (h = e.getContext("2d")) == null || h.drawImage(l, n.x, n.y), e;
  }
  getObjects() {
    return this.activeReconstruction ? this.activeReconstruction.objects : this.objects;
  }
  setCursorRoundToIndex(t) {
    var e;
    if (this.cursorRoundToIndex = t, t) {
      const n = (e = this.getViewWidget(Nt.AXIAL)) == null ? void 0 : e.getOrigin();
      n && this.toolManager.coordControl.setCenter(n);
    }
  }
  watch(t, e) {
    t.subscribe(e), this.onCleanup(() => t.unsubscribe(e));
  }
  onEvent(t, e) {
    t.subscribe(e), this.onCleanup(() => t.unsubscribe(e));
  }
  onCleanup(t) {
    this.onCleanupArray.push(t);
  }
  InitializeCadContext() {
  }
  /** Unloads the active CAD document before the document context is cleaned up. */
  async exitCAD() {
    return await this.contextCAD.exitCAD();
  }
  async setTabIndex(t) {
    return await this.contextCAD.setTabIndex(t);
  }
  setCADMode(t) {
    this.cadMode.set(t);
  }
  isDestructed() {
    return this.destructed;
  }
  getContextCAD() {
    return this.contextCAD;
  }
  async saveProject() {
    if (this.saveProjectPromise)
      return this.saveProjectPromise;
    this.saveProjectPromise = new Promise((t) => {
      this.saveProjectResolver = t;
    });
    try {
      this.saveProjectEvent.notify();
    } catch (t) {
      console.error("DocumentContext.saveProject notify error", t);
    }
    return this.saveProjectPromise;
  }
  completeSaveProject() {
    try {
      this.saveProjectResolver && this.saveProjectResolver();
    } finally {
      this.saveProjectResolver = null, this.saveProjectPromise = null;
    }
  }
  isModified() {
    return this.objects.isModified || this.volumeModified;
  }
  setModified(t) {
    this.objects.isModified = t, this.volumeModified = t, this.contextCAD.saveCAD = t;
  }
  shouldProjectBeSaved() {
    return this.isModified() || this.contextCAD.saveCAD;
  }
  async triggerSegmentation(t) {
    let e = !1;
    const n = this.projectInfo, s = this.fileHash;
    if (console.log("Project", n), console.log("projectFileUuid", s), !s) return;
    const r = async () => {
      const { data: a } = await t.getProjectFileList(this.projectInfo.patientName);
      if (console.log("fileList", a), a) {
        let o = null;
        for (let l of a)
          if (l.type == "processing-data" && l.metadata) {
            const c = JSON.parse(l.metadata);
            c && c["job-type"] == "SEGMENTATION" && c["origin-file-uuid"] == s && (o ? new Date(l.localCreateDate) > new Date(o.localCreateDate) && (o = l) : o = l);
          }
        if (e)
          return;
        if (o) {
          const { data: l } = await t.getZippedFilesList(n.patientName, o.name), c = l.find((d) => d.name === "result");
          if (!c) {
            console.error("Segmentation result file not found!");
            return;
          }
          const { data: u } = await t.getProjectFileFromZipById(
            n.patientName,
            c.name,
            c.id,
            !1
          );
          this.segmentationResult = u;
        }
      }
    };
    if (await r(), !this.segmentationResult)
      try {
        const a = () => {
          e = !0, this.hideLoading();
        };
        this.showLoading(jt("medic-web-engine.automaticSegmentation"), !1, void 0, void 0, !0, a);
        let o = await Fvt(t, s);
        if (!o) {
          const c = await t.triggerSegmentationJob(s);
          console.log("Segmentation triggered", c), c.status, QR.OK, o = { jobUuid: c.data.data, completed: !1 };
        }
        console.log("returnFileId", o);
        let l = !1;
        for (; !l && !e && o; ) {
          const c = await t.getJobStatusUuid(o.jobUuid);
          if (e)
            break;
          if (console.log("Segmentation status", c), c.status === QR.OK && c.data.some((u) => u.status === "COMPLETED")) {
            l = !0;
            break;
          }
          await new Promise((u) => setTimeout(u, 3e3));
        }
        if (e)
          return;
        await r(), this.hideLoading();
      } catch {
      }
  }
}
const oY = Symbol();
let lY = !1;
function hOt(i) {
  i3(oY, i), lY = !0;
}
function cY() {
  const i = gr(oY);
  if (!i) throw new Error("Context is null!");
  return i;
}
function pOt() {
  return !lY;
}
var Pvt = /* @__PURE__ */ ((i) => (i[i.DEFAULT_RECONSTRUCTION = 0] = "DEFAULT_RECONSTRUCTION", i))(Pvt || {});
class mOt {
  // public objectIds --> da se iz contexta
  constructor(t, e) {
    S(this, "reconstructionType");
    S(this, "context");
    S(this, "presenterWindows", []);
    S(this, "objects");
    var o, l;
    this.context = t, this.context.activeReconstruction = this, this.objects = new gA(this.context), this.reconstructionType = e;
    const n = new c2(this.context, RW, Nt.CAD_3D, {
      background: [0.24, 0.24, 0.24],
      color: [255, 255, 255]
    });
    this.presenterWindows.push(n);
    const s = [];
    s.push([n, Ce.fullscreen]), this.context.setLayout(s);
    const a = this.context.getVolume().volumeActor;
    a && ((o = n.getMainView()) == null || o.getRenderer().addActor(a)), (l = n.getMainView()) == null || l.getRenderer().resetCamera(), this.context.setVolumeActorVisibility(!1), this.context.isCADObjectList.set(!0), this.context.setCursorRoundToIndex(!0), this.context.layoutBtnVisible.set(!1);
  }
  sceneRepaint(t, e, n) {
    var s, r;
    for (let a of this.presenterWindows) {
      const o = a.getMainView();
      if (o && o.isVisible()) {
        if (t && t != a.getMainView())
          continue;
        if (t && t == a.getMainView()) {
          (s = a.getMainView()) == null || s.sceneRepaint(e, !0);
          return;
        } else
          (r = a.getMainView()) == null || r.sceneRepaint(e, !0);
        if (a.presenterWindowType == ni.PresenterWindow2D) {
          for (const l of a.views)
            if (!(t && t != a.getMainView())) if (t && t == l) {
              l.sceneRepaint(e, !0);
              return;
            } else
              l.sceneRepaint(e, !0);
        }
      }
    }
  }
  onViewWidgetEvent(t, e) {
    console.log("OnViewWE - activeReconstruction", t, e);
  }
  importObjects(t, e) {
    for (let n of t)
      if (n.selected) {
        let s = e.objects.stls.get(n.id), r;
        if (s && s.IsVolume() ? r = vn.ConvertVolumeToSTL(e, s) : (r = s, r.isPly), r) {
          const a = vn.copyStlObject(this.context, r);
          a.setMatrix(r.getMatrix()), a.setPickable(!0), a.setVisibility(!0), a.setLocked(!0), a.update3dInfo(), this.objects.stls.set(a.id, a);
        }
      }
    this.context.sceneRepaint();
  }
  // adds only implant and abutment (no sleeves and centerlines)
  importImplants(t) {
    for (let e of t) {
      const n = e.toProjectImplantParts();
      n.sleeveInfo = void 0, n.visible = !0, this.objects.addImplant(n, { disableCenterLines: !0 });
    }
    this.objects.lockUnlockAllImplantPins(!0);
  }
  importReferenceTeeth(t) {
    for (let [e, n] of t.objects.stls)
      if (!n.IsVolume() && n.type == Yt._STL_TOOTH) {
        const s = vn.copyStlObject(this.context, n);
        s.setMatrix(n.getMatrix()), s.setPickable(!0), s.setVisibility(!0), s.setLocked(!0), s.update3dInfo(), this.objects.stls.set(s.id, s);
      }
    this.context.sceneRepaint();
  }
  delete() {
    this.objects.cleanup();
    for (let t of this.presenterWindows)
      t.cleanup();
    this.context.activeReconstruction = null, this.context.isCADObjectList.set(!0), this.context.setCursorRoundToIndex(!1), this.context.layoutBtnVisible.set(!0);
  }
}
class bOt {
  constructor(t) {
    S(this, "id", "");
    S(this, "name", "");
    S(this, "constructionInfos", []);
    Object.assign(this, t);
  }
}
class fOt {
  constructor(t) {
    S(this, "color");
    S(this, "name", "");
    S(this, "mesh");
    S(this, "curves", []);
    S(this, "axes", []);
    S(this, "boundingBox");
    S(this, "coordinateSystem");
    Object.assign(this, t);
  }
}
function Jvt(i) {
  const t = new Avt(i), e = i.xContextMenuActionJs.extend("xContextMenuActionJs", t);
  return new e();
}
class Avt {
  // CallOnTriggered: (checked: boolean) => {};
  constructor(t) {
    S(this, "__parent");
    S(this, "wasmModule");
    S(this, "label", "");
    S(this, "__destruct", () => {
    });
    S(this, "SetLabel", (t) => {
      this.label = t;
    });
    S(this, "SetVisible", (t) => {
    });
    S(this, "IsVisible", () => {
    });
    S(this, "SetEnabled", (t) => {
    });
    S(this, "IsEnabled", () => {
    });
    S(this, "SetCheckable", (t) => {
    });
    S(this, "IsCheckable", () => {
    });
    S(this, "SetChecked", (t) => {
    });
    S(this, "IsChecked", () => {
    });
    S(this, "SetColor", (t) => {
    });
    S(this, "GetColor", () => {
    });
    S(this, "SetProperty", (t, e) => {
    });
    S(this, "GetProperty", (t) => {
    });
    console.log("Creating ContextAction"), this.wasmModule = t;
  }
}
function gOt(i, t) {
  const e = new Bvt(i, t), n = i.xContextMenuJs.extend("xContextMenuJs", e);
  return new n();
}
class Bvt {
  constructor(t, e) {
    S(this, "__parent");
    S(this, "wasmModule");
    S(this, "modals");
    S(this, "cursorX", 0);
    S(this, "cursorY", 0);
    S(this, "actions", []);
    S(this, "SetWidth", (t) => {
    });
    S(this, "AddAction", () => {
      const t = Jvt(this.wasmModule);
      return this.actions.push(t), t;
    });
    S(this, "AddStyledAction", () => {
    });
    S(this, "AddSeparator", () => {
    });
    S(this, "AddMenu", () => {
    });
    S(this, "RemoveEntry", () => {
    });
    S(this, "MenuAction", () => {
    });
    S(this, "AddSlider", () => {
    });
    S(this, "SetTitle", () => {
    });
    S(this, "Popup", () => {
      console.log("GUIEventHandler ShowContextMenu");
      const t = [];
      this.actions.forEach((e, n) => {
        console.log(`Action ${n}: label=${e.label}`), t.push(e.label);
      }), this.modals.showContextMenu(t, this.cursorX, this.cursorY).then((e) => {
        console.log("Selected item: ", e);
      });
    });
    S(this, "Exec", () => {
    });
    S(this, "SetStyleSheet", () => {
    });
    S(this, "SetMenuActionVisible", () => {
    });
    S(this, "SetOnAboutToShow", () => {
    });
    S(this, "SetOnAboutToHide", () => {
    });
    S(this, "GetEntries", () => {
    });
    S(this, "GetStyleSheet", () => {
    });
    console.log("Creating ContextMenu"), this.wasmModule = t, this.modals = e, document.addEventListener("mousemove", (n) => {
      this.cursorX = n.clientX, this.cursorY = n.clientY;
    });
  }
}
function Kvt() {
  return /Mac|iPhone|iPad/.test(navigator.userAgent);
}
function yOt(i) {
  return Kvt() ? i.metaKey : i.ctrlKey;
}
const ZOt = (i, t = /* @__PURE__ */ new Set(), e = !1) => {
  let n = new DOMParser().parseFromString(i, "text/xml");
  var s = {
    toObj: function(c) {
      var u = {};
      if (c.nodeType == 1) {
        if (c.attributes.length)
          for (var d = 0; d < c.attributes.length; d++)
            u["@" + c.attributes[d].nodeName] = (c.attributes[d].nodeValue || "").toString();
        if (c.firstChild) {
          var h = 0, p = 0, m = !1;
          for (let y = c.firstChild; y; y = y.nextSibling)
            y.nodeType == 1 ? m = !0 : y.nodeType == 3 && y.nodeValue && y.nodeValue.match(/[^ \f\n\r\t\v]/) ? h++ : y.nodeType == 4 && p++;
          if (m)
            if (h < 2 && p < 2) {
              s.removeWhite(c);
              for (var b = c.firstChild; b; b = b.nextSibling)
                b.nodeType == 3 && b.nodeValue ? u["#text"] = s.escape(b.nodeValue) : b.nodeType == 4 && b.nodeValue ? u["#cdata"] = s.escape(b.nodeValue) : u[b.nodeName] ? u[b.nodeName] instanceof Array ? u[b.nodeName][u[b.nodeName].length] = s.toObj(b) : u[b.nodeName] = [u[b.nodeName], s.toObj(b)] : u[b.nodeName] = s.toObj(b);
            } else
              c.attributes.length ? u["#text"] = s.escape(s.innerXml(c)) : u = s.escape(s.innerXml(c));
          else if (h)
            c.attributes.length ? u["#text"] = s.escape(s.innerXml(c)) : u = s.escape(s.innerXml(c));
          else if (p)
            if (p > 1) u = s.escape(s.innerXml(c));
            else for (let y = c.firstChild; y; y = y.nextSibling) u["#cdata"] = y.nodeValue ? s.escape(y.nodeValue) : "";
        }
        !c.attributes.length && !c.firstChild && (u = null);
      } else c.nodeType == 9 ? u = s.toObj(c.documentElement) : alert("unhandled node type: " + c.nodeType);
      return u;
    },
    toJson: function(c, u, d) {
      var h = u ? '"' + u + '"' : "";
      if (c instanceof Array) {
        for (var p = 0, m = c.length; p < m; p++) c[p] = s.toJson(c[p], "", d + "	");
        h += (u ? ":[" : "[") + (c.length > 1 ? `
` + d + "	" + c.join(`,
` + d + "	") + `
` + d : c.join("")) + "]";
      } else if (c == null) h += (u && ":") + "null";
      else if (typeof c == "object") {
        var b = [];
        for (var y in c) b[b.length] = s.toJson(c[y], y, d + "	");
        h += (u ? ":{" : "{") + (b.length > 1 ? `
` + d + "	" + b.join(`,
` + d + "	") + `
` + d : b.join("")) + "}";
      } else typeof c == "string" ? h += (u && ":") + '"' + c.toString() + '"' : h += (u && ":") + c.toString();
      return h;
    },
    innerXml: function(c) {
      var u = "";
      if ("innerHTML" in c) u = c.innerHTML;
      else
        for (var d = function(p) {
          var m = "";
          if (p.nodeType == 1) {
            m += "<" + p.nodeName;
            for (var b = 0; b < p.attributes.length; b++) m += " " + p.attributes[b].nodeName + '="' + (p.attributes[b].nodeValue || "").toString() + '"';
            if (p.firstChild) {
              m += ">";
              for (let y = p.firstChild; y; y = y.nextSibling) m += d(y);
              m += "</" + p.nodeName + ">";
            } else m += "/>";
          } else p.nodeType == 3 ? m += p.nodeValue : p.nodeType == 4 && (m += "<![CDATA[" + p.nodeValue + "]]>");
          return m;
        }, h = c.firstChild; h; h = h.nextSibling) u += d(h);
      return u;
    },
    escape: function(c) {
      return c.replace(/[\\]/g, "\\\\").replace(/[\"]/g, '\\"').replace(/[\n]/g, "\\n").replace(/[\r]/g, "\\r");
    },
    removeWhite: function(c) {
      c.normalize();
      for (var u = c.firstChild; u; )
        if (u.nodeType == 3)
          if (u.nodeValue.match(/[^ \f\n\r\t\v]/))
            u = u.nextSibling;
          else {
            var d = u.nextSibling;
            c.removeChild(u), u = d;
          }
        else u.nodeType == 1 && s.removeWhite(u), u = u.nextSibling;
      return c;
    }
  };
  n.nodeType == 9 && (n = n.documentElement);
  const r = `{${s.toJson(s.toObj(s.removeWhite(n)), n.nodeName, "	")}}`, a = (c, u) => !t.has(c) && typeof u == "string" && !isNaN(+u) ? +u : u, o = /([A-Z]+)([A-Z])/;
  return JSON.parse(r, e ? function(c, u) {
    if (u && typeof u == "object" && !Array.isArray(u)) {
      const d = {};
      for (const h in u) {
        const p = o.test(h) ? h.replace(o, (m, b, y) => `${b.toLowerCase()}${y}`) : h.charAt(0).toLowerCase() + h.slice(1);
        d[p] = a(h, u[h]);
      }
      return d;
    }
    return u;
  } : a);
}, Hvt = {
  key: 1,
  class: "flex items-center justify-center h-full"
}, _vt = { class: "text-lg text-gray-500" }, Qvt = { style: { color: "black !important" } }, $vt = /* @__PURE__ */ Ne({
  __name: "PdfPreviewDialog",
  setup(i) {
    var Z;
    const t = gr("dialogRef"), e = ((Z = t.value) == null ? void 0 : Z.data) ?? {}, { t: n } = La(), s = Lt(), r = Lt(), a = Lt("61vh"), o = !e.height, { pdf: l, pages: c } = Y4(s), u = te(() => Array.from({ length: c.value ?? 0 }, (g, f) => f + 1)), d = te(() => e.height ?? a.value), h = te(() => {
      const g = n("shared.loading");
      return g === "shared.loading" ? "Loading..." : g;
    });
    function p() {
      if (typeof window > "u") {
        a.value = "61vh";
        return;
      }
      a.value = window.innerHeight < 1200 ? "53vh" : "61vh";
    }
    function m() {
      r.value && (URL.revokeObjectURL(r.value), r.value = void 0);
    }
    function b() {
      if (m(), e.src) {
        s.value = e.src;
        return;
      }
      if (e.file instanceof File) {
        r.value = URL.createObjectURL(e.file), s.value = r.value;
        return;
      }
      s.value = void 0;
    }
    xn(() => {
      b(), p(), o && typeof window < "u" && window.addEventListener("resize", p);
    }), yr(() => {
      m(), o && typeof window < "u" && window.removeEventListener("resize", p);
    });
    const y = te(() => u.value > 1 ? n("shared.pages") : n("shared.page"));
    return (g, f) => {
      const T = tr("Card"), M = tr("Divider");
      return Mt(), Ot(Me, null, [
        Pt(T, { style: { background: "white" } }, {
          content: oe(() => [
            Pt(K(Te), {
              class: "justify-center",
              style: xe({ minHeight: d.value, width: "100%" })
            }, {
              default: oe(() => [
                s.value ? (Mt(), Ot("div", {
                  key: 0,
                  class: "flex flex-col gap-2 overflow-y-auto overflow-x-hidden w-full",
                  style: xe({ height: d.value })
                }, [
                  (Mt(!0), Ot(Me, null, Xn(u.value, (N) => (Mt(), Ot("div", {
                    key: N,
                    class: "w-full"
                  }, [
                    Pt(K(C4), {
                      pdf: K(l),
                      page: N,
                      "fit-parent": ""
                    }, null, 8, ["pdf", "page"])
                  ]))), 128))
                ], 4)) : (Mt(), Ot("div", Hvt, [
                  kt("p", _vt, pe(h.value), 1)
                ]))
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          footer: oe(() => [
            Pt(K(hg), { class: "justify-end" }, {
              default: oe(() => [
                kt("span", Qvt, pe(y.value) + ": " + pe(u.value.length ? u.value[0] : 0), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        Pt(M, { class: "mt-1" }),
        Pt(K(hg), { class: "justify-end pt-4" }, {
          default: oe(() => [
            Pt(K(WT), {
              class: "weblink-btn min-w-28",
              label: g.$t("shared.close"),
              onClick: f[0] || (f[0] = (N) => K(t).close())
            }, null, 8, ["label"])
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), qvt = { class: "text-preview" }, tRt = /* @__PURE__ */ Ne({
  __name: "TextPreviewDialog",
  setup(i) {
    const e = gr("dialogRef").value.data;
    return (n, s) => (Mt(), le(K(Te), { class: "justify-center h-full" }, {
      default: oe(() => [
        kt("pre", qvt, pe(K(e).text || ""), 1)
      ]),
      _: 1
    }));
  }
}), eRt = /* @__PURE__ */ Dn(tRt, [["__scopeId", "data-v-19769177"]]), nRt = ["href"], iRt = { class: "text-xl chat-notification-text" }, sRt = ["href"], rRt = {
  class: "text-xl",
  style: { "font-weight": "700", "padding-top": "4px" }
}, aRt = {
  class: "text-xl chat-notification-text",
  style: { "padding-top": "4px" }
}, oRt = ["href"], lRt = { class: "flex justify-between items-center text-surface-700 dark:text-surface-100" }, cRt = { class: "text-base flex items-center gap-1" }, uRt = { class: "text-base" }, dRt = /* @__PURE__ */ Ne({
  __name: "ChatNotificationComponent",
  props: {
    model: {},
    isUserWeblinkOperator: { type: Boolean },
    dateFormat: {}
  },
  emits: ["openSTL"],
  setup(i, { emit: t }) {
    const { t: e } = La(), n = AX(), s = i, r = t;
    function a(et) {
      return (et == null ? void 0 : et.additionalNotes) ?? "";
    }
    function o(et) {
      const it = String(et).match(/\{.*\}$/);
      if (!it) return et;
      try {
        const ht = JSON.parse(it[0]), lt = a(ht);
        return et.replace(it[0], lt);
      } catch (ht) {
        return console.log("extractAndStringifyJSON error: ", ht), et;
      }
    }
    const l = (et) => {
      const ot = u(o(et));
      return ot ? ot.split("Note:") : [""];
    }, c = (et) => {
      const ot = [], it = /https?:\/\/[^\s<>]+/gi;
      let ht = 0;
      for (const lt of et.matchAll(it)) {
        const mt = lt.index ?? 0, wt = lt[0], Xt = wt.replace(/[.,!?;:]+$/, "");
        mt > ht && ot.push({ text: et.slice(ht, mt) }), ot.push({ text: Xt, url: Xt }), Xt.length < wt.length && ot.push({ text: wt.slice(Xt.length) }), ht = mt + wt.length;
      }
      return ht < et.length && ot.push({ text: et.slice(ht) }), ot.length > 0 ? ot : [{ text: et }];
    }, u = (et) => et.replace(/(\d{4})-(\d{2})-(\d{2})(?=[^\d]|$)/g, (ot, it, ht, lt) => {
      const mt = new Date(Number(it), Number(ht) - 1, Number(lt));
      return isNaN(mt.getTime()) ? ot : $y(mt, s.dateFormat, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      });
    }), d = (et) => et.type == c0.NOTIFICATION ? "var(--p-primary-gray)" : et.mine ? "var(--p-primary-bluegray)" : "var(--p-primary-blue)", h = (et) => et.type === c0.NOTIFICATION ? e("medic-web-framework.systemMessage") : e("medic-web-framework.sentBy", { user: et.fromUser }), p = [".pdf", ".txt", ".pts", ".docx", ".xlsx", ".zip", ".xml", ".constructioninfo"], m = [".txt", ".pts", ".xml", ".constructioninfo"], b = {
      ".pdf": new URL("/img/pdf_file_icon.png", import.meta.url).href,
      ".zip": new URL("/img/zip_file_icon.png", import.meta.url).href,
      ".docx": new URL("/img/docx_file_icon.png", import.meta.url).href,
      ".xlsx": new URL("/img/xlsx_file_icon.png", import.meta.url).href,
      ".txt": new URL("/img/txt_file_icon.png", import.meta.url).href,
      ".pts": new URL("/img/txt_file_icon.png", import.meta.url).href,
      ".xml": new URL("/img/xml_file_icon.png", import.meta.url).href,
      ".constructioninfo": new URL("/img/xml_file_icon.png", import.meta.url).href
    }, y = Lt("");
    let Z = null, g = 0;
    const f = () => {
      Z && (URL.revokeObjectURL(Z), Z = null);
    }, T = (et) => et ? typeof et == "string" ? et : et.url ?? "" : "", M = (et) => typeof et == "object" && et !== null && "url" in et, N = te(() => T(s.model.imageUrl)), W = te(() => N.value), x = te(() => {
      if (M(s.model.imageUrl))
        return s.model.imageUrl.headers;
    }), V = te(() => x.value ? Object.keys(x.value).length > 0 : !1), X = (et) => {
      const ot = (it) => {
        const ht = it.toLowerCase(), lt = ht.lastIndexOf(".");
        return lt >= 0 ? ht.slice(lt) : "";
      };
      try {
        const it = new URL(et), ht = it.searchParams.get("output_file_name") ?? it.searchParams.get("file_name") ?? it.pathname.split("/").pop() ?? "";
        return ot(ht);
      } catch {
        const ht = et.split("?")[0].split("/").pop() ?? "";
        return ot(ht);
      }
    }, C = te(() => {
      const et = N.value;
      return et ? X(et) : "";
    }), R = te(() => p.includes(C.value)), z = te(() => R.value ? "chat-notification-document" : "chat-notification-image"), F = te(() => z7.map((et) => et.toLowerCase()).includes(C.value)), P = te(() => !!W.value && (!F.value || s.isUserWeblinkOperator)), j = te(() => {
      const et = e("weblink.pdfPreview");
      return et === "weblink.pdfPreview" ? "PDF Preview" : et;
    }), H = (et) => {
      const ot = X(et);
      return b[ot];
    }, B = (et) => et.endsWith(".thumb") ? et : `${et}.thumb`, $ = (et, ot) => {
      const it = ot.startsWith(".") ? ot : `.${ot}`;
      return et.replace(/\.[^/.]+$/, "") + it;
    }, A = (et, ot) => {
      try {
        const it = new URL(et), ht = it.searchParams.has("file_name") ? "file_name" : it.searchParams.has("output_file_name") ? "output_file_name" : null;
        if (ht) {
          const wt = it.searchParams.get(ht) ?? "";
          return it.searchParams.set(ht, ot(wt)), it.toString();
        }
        const lt = it.pathname.split("/"), mt = lt.pop();
        if (mt)
          return lt.push(ot(mt)), it.pathname = lt.join("/"), it.toString();
      } catch {
        const [it, ...ht] = et.split("?"), lt = it.split("/"), mt = lt.pop();
        if (mt) {
          lt.push(ot(mt));
          const wt = lt.join("/");
          return ht.length > 0 ? `${wt}?${ht.join("?")}` : wt;
        }
      }
      return et;
    }, E = (et) => A(et, B), ct = (et) => A(et, (ot) => $(ot, ".png")), at = (et) => [.../* @__PURE__ */ new Set([et, E7(et, ".png")])], dt = (et) => new Promise((ot) => {
      const it = new Image();
      it.onload = () => ot(!0), it.onerror = () => ot(!1), it.src = et;
    }), gt = (et) => ["notification-preview-blob", et], Wt = async (et, ot) => k7.fetchQuery({
      queryKey: gt(et),
      queryFn: async () => {
        const it = await fetch(et, { headers: ot, mode: "cors" });
        if (!it.ok)
          throw new Error(`Failed to load notification preview (${it.status})`);
        return it.blob();
      },
      staleTime: 3e4,
      retry: !1
    }).catch((it) => (console.error("Failed to fetch notification image preview", it), null)), Zt = async () => {
      const et = ++g;
      f();
      const ot = s.model.imageUrl, it = T(ot);
      if (!it) {
        y.value = "";
        return;
      }
      const ht = H(it);
      if (ht) {
        y.value = ht;
        return;
      }
      const lt = F.value ? [E(it), ct(it)] : at(it), mt = F.value ? lt[lt.length - 1] ?? "" : lt[0] ?? "", wt = V.value ? x.value : void 0;
      if (wt) {
        for (const Xt of lt) {
          const At = await Wt(Xt, wt);
          if (et !== g)
            return;
          if (At) {
            Z = URL.createObjectURL(At), y.value = Z;
            return;
          }
        }
        y.value = mt;
        return;
      }
      for (const Xt of lt) {
        const At = await Wt(Xt);
        if (et !== g)
          return;
        if (At) {
          Z = URL.createObjectURL(At), y.value = Z;
          return;
        }
      }
      for (const Xt of lt) {
        const At = await dt(Xt);
        if (et !== g)
          return;
        if (At) {
          y.value = Xt;
          return;
        }
      }
      y.value = lt[0] ?? "";
    };
    gn(
      () => s.model.imageUrl,
      () => {
        Zt();
      },
      { immediate: !0, deep: !0 }
    ), yr(() => {
      f();
    });
    function Gt(et) {
      if (R.value) {
        Tt(et);
        return;
      }
      if (!F.value)
        return;
      const ot = N.value;
      ot && (et.stopPropagation(), r("openSTL", ot));
    }
    async function Tt(et) {
      if (!R.value)
        return;
      const ot = N.value;
      if (ot) {
        if (et.stopPropagation(), C.value === ".pdf") {
          await Q(ot);
          return;
        }
        m.includes(C.value) && await D(ot);
      }
    }
    async function Q(et) {
      try {
        const ot = await fetch(et, {
          headers: V.value ? x.value : void 0,
          mode: "cors"
        });
        if (!ot.ok)
          throw new Error(`Failed to fetch PDF preview (${ot.status})`);
        const it = await ot.blob(), ht = q(et), lt = ht.toLowerCase().endsWith(".pdf") ? ht : `${ht}.pdf`, mt = new File([it], lt, { type: it.type || "application/pdf" });
        n.open($vt, {
          props: {
            closable: !0,
            modal: !0,
            header: j.value,
            style: { width: "50vw" }
          },
          data: {
            file: mt
          }
        });
      } catch (ot) {
        console.error("Failed to open PDF preview", ot);
      }
    }
    async function D(et) {
      try {
        const ot = await fetch(et, {
          headers: V.value ? x.value : void 0,
          mode: "cors"
        });
        if (!ot.ok)
          throw new Error(`Failed to fetch text preview (${ot.status})`);
        const ht = await (await ot.blob()).text(), lt = q(et);
        n.open(eRt, {
          props: {
            closable: !0,
            modal: !0,
            header: lt,
            style: { width: "50vw" }
          },
          data: {
            text: ht
          }
        });
      } catch (ot) {
        console.error("Failed to open text preview", ot);
      }
    }
    const q = (et) => {
      try {
        const ot = new URL(et);
        return ot.searchParams.get("file_name") ?? ot.pathname.split("/").pop() ?? "attachment";
      } catch (ot) {
        return console.error("Failed to get download filename", ot), "attachment";
      }
    };
    async function nt(et) {
      if (!(!P.value || !W.value) && !(!V.value || !x.value)) {
        et.preventDefault();
        try {
          const ot = await fetch(W.value, { headers: x.value, mode: "cors" });
          ot.ok || console.error(`Failed to download attachment (${ot.status})`);
          const it = await ot.blob(), ht = URL.createObjectURL(it), lt = document.createElement("a");
          lt.href = ht, lt.download = q(W.value), document.body.appendChild(lt), lt.click(), document.body.removeChild(lt), URL.revokeObjectURL(ht);
        } catch (ot) {
          console.error("Failed to download notification attachment", ot);
        }
      }
    }
    return (et, ot) => {
      const it = tr("Button"), ht = tr("Image");
      return Mt(), Ot("div", {
        style: xe({ "background-color": d(i.model) }),
        class: "p-2 all-radius chat-notification-bubble"
      }, [
        i.model.imageUrl ? (Mt(), le(ht, {
          key: 0,
          imageClass: z.value,
          src: y.value,
          alt: "Attachment",
          class: "chat-notification-preview",
          preview: "",
          width: "200",
          style: { width: "200px !important" }
        }, {
          indicatoricon: oe(() => [
            kt("div", {
              class: "w-full h-full flex justify-center items-center",
              onClick: ot[1] || (ot[1] = (lt) => Gt(lt))
            }, [
              Pt(it, {
                class: "p-button-rounded p-button-outlined",
                icon: "pi pi-eye",
                onClick: ot[0] || (ot[0] = (lt) => Gt(lt))
              }),
              P.value && W.value ? (Mt(), Ot("a", {
                key: 0,
                href: W.value,
                class: "p-button p-button-rounded p-button-outlined ml-2",
                onClick: o0(nt, ["stop"])
              }, [...ot[2] || (ot[2] = [
                kt("i", { class: "pi pi-download" }, null, -1)
              ])], 8, nRt)) : Qt("", !0)
            ])
          ]),
          _: 1
        }, 8, ["imageClass", "src"])) : Qt("", !0),
        kt("div", iRt, [
          (Mt(!0), Ot(Me, null, Xn(c(l(i.model.body)[0]), (lt, mt) => (Mt(), Ot(Me, { key: mt }, [
            lt.url ? (Mt(), Ot("a", {
              key: 0,
              href: lt.url,
              target: "_blank",
              rel: "noopener noreferrer"
            }, pe(lt.text), 9, sRt)) : (Mt(), Ot(Me, { key: 1 }, [
              Ws(pe(lt.text), 1)
            ], 64))
          ], 64))), 128))
        ]),
        l(i.model.body).length > 1 ? (Mt(), Ot(Me, { key: 1 }, [
          Pt(K(Te), { class: "w-full flex-row" }, {
            default: oe(() => [
              kt("span", rRt, pe(et.$t("shared.note")), 1)
            ]),
            _: 1
          }),
          Pt(K(Te), { class: "w-full flex-row" }, {
            default: oe(() => [
              kt("span", aRt, [
                (Mt(!0), Ot(Me, null, Xn(c(l(i.model.body)[1]), (lt, mt) => (Mt(), Ot(Me, { key: mt }, [
                  lt.url ? (Mt(), Ot("a", {
                    key: 0,
                    href: lt.url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, pe(lt.text), 9, oRt)) : (Mt(), Ot(Me, { key: 1 }, [
                    Ws(pe(lt.text), 1)
                  ], 64))
                ], 64))), 128))
              ])
            ]),
            _: 1
          })
        ], 64)) : Qt("", !0),
        kt("div", lRt, [
          kt("div", cRt, [
            kt("span", null, pe(h(i.model)), 1),
            i.model.privateMsg ? (Mt(), Ot(Me, { key: 0 }, [
              ot[3] || (ot[3] = kt("span", null, "|", -1)),
              ot[4] || (ot[4] = kt("i", { class: "pi pi-eye" }, null, -1)),
              kt("span", null, pe(K(e)("weblink.visibleToOperators")), 1)
            ], 64)) : Qt("", !0)
          ]),
          kt("div", uRt, pe(K($y)(i.model.date, s.dateFormat)) + " " + pe(K(FS)(i.model.date, s.dateFormat)), 1)
        ])
      ], 4);
    };
  }
}), hRt = /* @__PURE__ */ Dn(dRt, [["__scopeId", "data-v-356d713a"]]), pRt = { class: "text-xl" }, mRt = { style: { "font-weight": "700", "padding-top": "4px" } }, bRt = { style: { "padding-top": "4px" } }, fRt = { key: 1 }, gRt = ["href"], yRt = { style: { "font-style": "italic", padding: "4px 0 4px 0" } }, ZRt = { class: "flex text-surface-700 dark:text-surface-100" }, TRt = { class: "text-base flex items-center gap-1" }, MRt = { class: "text-base" }, NRt = /* @__PURE__ */ Ne({
  __name: "ShippingNotificationComponent",
  props: {
    model: {},
    dateFormat: {}
  },
  setup(i) {
    const { t } = La(), e = (d) => {
      const h = d.body.toLowerCase();
      return JSON.parse(h).type === "revision_accepted";
    }, n = (d) => e(d) ? "var(--p-primary-color)" : d.type == c0.NOTIFICATION || d.type == c0.SHIPPING_DATE_CHANGE ? "var(--p-primary-gray)" : d.mine ? "var(--p-primary-bluegray)" : "var(--p-primary-blue)", s = i, r = te(() => {
      var h;
      const d = (h = s.model) == null ? void 0 : h.body;
      if (!d) return null;
      try {
        return JSON.parse(d);
      } catch (p) {
        return console.error("Invalid JSON in props.model.body:", d, p), null;
      }
    }), a = te(() => {
      var d, h;
      return ((h = (d = r.value) == null ? void 0 : d.parcel_out) == null ? void 0 : h.carrierServiceType) === "Pick Up";
    }), o = te(() => {
      var d;
      return String(((d = r.value) == null ? void 0 : d.type) ?? "") !== "STEP_UPDATE";
    }), l = (d) => {
      const h = d.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!h)
        return d;
      const [, p, m, b] = h, y = new Date(Number(p), Number(m) - 1, Number(b));
      return isNaN(y.getTime()) ? d : $y(y, s.dateFormat, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      });
    }, c = te(() => {
      var p, m;
      const d = ((p = r.value) == null ? void 0 : p.title) ?? "", h = l(((m = r.value) == null ? void 0 : m.state) ?? "");
      return o.value && d.length > 0 ? `${d} ${h}` : h;
    }), u = te(() => {
      var d;
      if ((d = r.value) != null && d.parcel_out) {
        const h = new Date(r.value.parcel_out.dateUTCMailed);
        return `${$y(h, s.dateFormat)} ${FS(h, s.dateFormat)}`;
      }
      return t("shared.noDateSet");
    });
    return (d, h) => {
      var p, m;
      return Mt(), Ot("div", {
        class: Rn([{ "accepted-revision-notification": e(i.model) }, "p-2 all-radius"]),
        style: xe({ "background-color": n(i.model) })
      }, [
        kt("div", pRt, [
          Ws(pe(c.value) + " ", 1),
          (((p = r.value) == null ? void 0 : p.additionalNotes) ?? "").length > 0 ? (Mt(), Ot(Me, { key: 0 }, [
            Pt(K(Te), { class: "w-full flex-row" }, {
              default: oe(() => [
                kt("span", mRt, pe(d.$t("shared.note")), 1)
              ]),
              _: 1
            }),
            Pt(K(Te), { class: "w-full flex-row" }, {
              default: oe(() => {
                var b;
                return [
                  kt("span", bRt, pe((b = r.value) == null ? void 0 : b.additionalNotes), 1)
                ];
              }),
              _: 1
            })
          ], 64)) : Qt("", !0),
          (m = r.value) != null && m.parcel_out ? (Mt(), Ot("div", fRt, [
            h[3] || (h[3] = kt("br", null, null, -1)),
            a.value ? (Mt(), Ot(Me, { key: 1 }, [
              Ws(pe(d.$t("medic-web-framework.readyForPickupOn")) + pe(u.value), 1)
            ], 64)) : (Mt(), Ot(Me, { key: 0 }, [
              Ws(pe(d.$t("medic-web-framework.shippedOn")) + pe(u.value) + " ", 1),
              h[0] || (h[0] = kt("br", null, null, -1)),
              Ws(" " + pe(d.$t("medic-web-framework.carrier")) + pe(r.value.parcel_out.carrierCode) + " ", 1),
              h[1] || (h[1] = kt("br", null, null, -1)),
              Ws(" " + pe(d.$t("medic-web-framework.trackingId")) + pe(r.value.parcel_out.carrierTrackingId) + " ", 1),
              h[2] || (h[2] = kt("br", null, null, -1)),
              Ws(" " + pe(d.$t("medic-web-framework.trackingUrl")) + " ", 1),
              kt("a", {
                href: r.value.parcel_out.carrierTrackingUri
              }, pe(d.$t("medic-web-framework.link")), 9, gRt)
            ], 64)),
            h[4] || (h[4] = kt("br", null, null, -1))
          ])) : Qt("", !0)
        ]),
        Pt(K(Te), { class: "w-full flex-row" }, {
          default: oe(() => [
            kt("span", yRt, pe(s.model.appendMessage), 1)
          ]),
          _: 1
        }),
        kt("div", ZRt, [
          kt("div", TRt, [
            kt("span", null, pe(d.$t("medic-web-framework.systemMessage")), 1),
            i.model.privateMsg ? (Mt(), Ot(Me, { key: 0 }, [
              h[5] || (h[5] = kt("span", null, "|", -1)),
              h[6] || (h[6] = kt("i", { class: "pi pi-eye" }, null, -1)),
              kt("span", null, pe(K(t)("weblink.visibleToOperators")), 1)
            ], 64)) : Qt("", !0)
          ]),
          h[7] || (h[7] = kt("div", { class: "flex-1" }, null, -1)),
          kt("span", MRt, pe(K($y)(i.model.date, s.dateFormat)) + " " + pe(K(FS)(i.model.date, s.dateFormat)), 1)
        ])
      ], 6);
    };
  }
}), WRt = /* @__PURE__ */ Dn(NRt, [["__scopeId", "data-v-f9b0169e"]]), GRt = {
  for: "shareToChat",
  class: "ml-2"
}, wRt = /* @__PURE__ */ Ne({
  __name: "WeblinkUploadPreviewComponent",
  emits: ["saveCase"],
  setup(i, { emit: t }) {
    const e = gr("dialogRef"), n = e.value.data;
    console.log("Weblink Upload component params.files: ", n.files);
    const s = t, r = Lt({
      shareToChat: n.shareToChat,
      message: ""
    }), a = () => {
      s("saveCase", r.value), e.value.close();
    }, o = te(() => n.showShareToChatOption ?? !0), l = te(() => {
      var m;
      return (m = n.files) == null ? void 0 : m[0];
    }), c = te(() => {
      const m = l.value;
      return m ? p0(m.name) : !1;
    }), u = te(() => {
      var b, y;
      const m = (y = (b = l.value) == null ? void 0 : b.name) == null ? void 0 : y.toLowerCase();
      return !!m && m.endsWith(".pdf");
    }), d = Lt(""), h = () => {
      d.value && (URL.revokeObjectURL(d.value), d.value = "");
    };
    nW(() => {
      if (!u.value || !l.value) {
        h();
        return;
      }
      h(), d.value = URL.createObjectURL(l.value);
    }), yr(() => {
      h();
    });
    const p = te(() => {
      var b, y;
      const m = ((y = (b = l.value) == null ? void 0 : b.name) == null ? void 0 : y.toLowerCase()) ?? "";
      return m.endsWith(".zip") || m.endsWith(".docx") || m.endsWith(".xlsx") || m.endsWith(".txt") || m.endsWith(".pts") || m.endsWith(".xml") || m.endsWith(".constructioninfo") ? "11vh" : m.endsWith(".png") || m.endsWith(".jpg") ? "20vh" : "50vh";
    });
    return (m, b) => {
      const y = tr("Checkbox"), Z = tr("InputText"), g = tr("Divider");
      return Mt(), Ot(Me, null, [
        Pt(K(Te), {
          class: "justify-center",
          style: xe({ height: p.value })
        }, {
          default: oe(() => [
            c.value ? (Mt(), le(GB, {
              key: 0,
              selectedFiles: K(n).files,
              allFiles: K(n).files
            }, null, 8, ["selectedFiles", "allFiles"])) : u.value ? (Mt(), le(v4, {
              key: 1,
              assetUrl: d.value,
              "onUpdate:assetUrl": b[0] || (b[0] = (f) => d.value = f),
              height: "44vh"
            }, null, 8, ["assetUrl"])) : (Mt(), le(yC, {
              key: 2,
              selectedFiles: K(n).files,
              allFiles: K(n).files
            }, null, 8, ["selectedFiles", "allFiles"]))
          ]),
          _: 1
        }, 8, ["style"]),
        Pt(K(Te), { class: "flex-col mt-2" }, {
          default: oe(() => [
            o.value ? (Mt(), le(K(Te), {
              key: 0,
              class: "mt-2 mb-2"
            }, {
              default: oe(() => [
                Pt(y, {
                  modelValue: r.value.shareToChat,
                  "onUpdate:modelValue": b[1] || (b[1] = (f) => r.value.shareToChat = f),
                  inputId: "shareToChat",
                  binary: !0
                }, null, 8, ["modelValue"]),
                kt("label", GRt, pe(m.$t("medic-web-framework.shareToChat")), 1)
              ]),
              _: 1
            })) : Qt("", !0),
            r.value.shareToChat ? (Mt(), le(Z, {
              key: 1,
              modelValue: r.value.message,
              "onUpdate:modelValue": b[2] || (b[2] = (f) => r.value.message = f),
              id: "shareToChatNote",
              placeholder: m.$t("medic-web-framework.chatMessage")
            }, null, 8, ["modelValue", "placeholder"])) : Qt("", !0)
          ]),
          _: 1
        }),
        Pt(g),
        b[4] || (b[4] = kt("div", { class: "pt-2" }, null, -1)),
        Pt(K(F7), {
          id: "btnUploadAttachment",
          class: "mt-2",
          acceptLabel: m.$t("shared.upload"),
          rejectLabel: m.$t("shared.cancel"),
          gap: "gap-4",
          onAccept: a,
          onReject: b[3] || (b[3] = (f) => K(e).close())
        }, null, 8, ["acceptLabel", "rejectLabel"])
      ], 64);
    };
  }
}), xRt = {
  class: "flex flex-col min-h-0 gap-2 w-full",
  style: { height: "calc(100% - 1.25rem) !important" }
}, SRt = {
  key: 1,
  class: "pt-2 w-full"
}, LRt = {
  key: 0,
  class: "flex gap-2"
}, VRt = { class: "grow" }, XRt = {
  key: 0,
  class: "grow-0"
}, IRt = {
  key: 1,
  class: "grow-0"
}, CRt = { class: "grow-0" }, YRt = "list", vRt = /* @__PURE__ */ Ne({
  __name: "MNotificationTab",
  props: /* @__PURE__ */ rl({
    notifications: {},
    channel: {},
    isUserWeblinkOperator: { type: Boolean },
    scrollToBottomTrigger: { type: Boolean },
    callbacks: {},
    showChatBar: { type: Boolean, default: !0 },
    dateFormat: {},
    fromPlanner: { type: Boolean, default: !1 },
    disableSendMessage: { type: Boolean, default: !1 },
    enableImagePaste: { type: Boolean, default: !1 },
    showAddNote: { type: Boolean, default: !0 },
    showShareToChatOption: { type: Boolean, default: !0 },
    allowUploadForUsers: { type: Boolean, default: !1 },
    compactActionButtons: { type: Boolean, default: !1 },
    expandableMessageField: { type: Boolean, default: !1 }
  }, {
    uploadingAttachment: { type: Boolean, required: !1, default: !1 },
    uploadingAttachmentModifiers: {},
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ rl(["openSTL", "uploadFileAndShareToChat", "sendMessage"], ["update:uploadingAttachment", "update:modelValue"]),
  setup(i, { emit: t }) {
    const { t: e } = La(), n = AX(), s = i, r = zr(i, "uploadingAttachment"), a = zr(i, "modelValue"), o = t, l = Lt(""), c = Lt([]), u = Lt(null), d = Lt(0), h = Lt(!1), p = Lt(), m = Lt(j7().getUser()), b = U7(K(m));
    function y() {
      dg(() => {
        var dt;
        const A = (dt = p.value) == null ? void 0 : dt.$el;
        if (!A) return;
        const E = A.querySelector(".p-dataview-content");
        if (!E) return;
        const ct = Array.from(E.children), at = ct[ct.length - 1];
        at ? at.scrollIntoView({ behavior: "smooth", block: "end" }) : E.scrollTop = E.scrollHeight;
      });
    }
    function Z(A) {
      return A ? "justify-end" : "justify-start";
    }
    nW(() => {
      s.notifications ? (h.value = !0, y()) : console.log("MNotificationTab props.notifications is null");
    });
    const g = async () => {
      var E;
      const A = l.value;
      A.trim().length !== 0 && (await ((E = s.callbacks) == null ? void 0 : E.sendMessage(A, s.channel)), console.log("sendMessage chatInput.value: ", A), o("sendMessage", A), l.value = "", h.value = !0);
    }, f = (A) => {
      s.expandableMessageField && A.key === "Enter" && (A.ctrlKey || A.metaKey) && (A.preventDefault(), g());
    }, T = te(() => s.isUserWeblinkOperator || s.allowUploadForUsers), M = te(() => s.compactActionButtons && s.channel !== K7.CHAT && !s.showAddNote), N = te(() => s.compactActionButtons ? M.value ? e("medic-web-framework.addNote") : e("medic-web-framework.sendMessage") : ""), W = te(() => M.value ? "pi pi-pen-to-square" : "pi pi-send"), x = async () => {
      var E;
      const A = l.value;
      A.trim().length !== 0 && (await ((E = s.callbacks) == null ? void 0 : E.addNote(A, s.channel)), l.value = "", h.value = !0);
    }, V = async () => {
      if (M.value) {
        await x();
        return;
      }
      await g();
    }, X = (A) => A == c0.NOTIFICATION ? ["pt-2 w-full"] : ["pt-2 w-8/12"], C = (A) => (A.split("/")[1] || "png").replace(/\+.*/, "").replace("jpeg", "jpg"), R = (A, E) => {
      if (A.name && A.name.trim().length > 0)
        return A;
      const ct = C(A.type), at = `clipboard-image-${Date.now()}-${E + 1}.${ct}`;
      return new File([A], at, {
        type: A.type,
        lastModified: Date.now()
      });
    }, z = (A) => {
      var at;
      if (A.defaultPrevented)
        return;
      const ct = Array.from(((at = A.clipboardData) == null ? void 0 : at.items) || []).filter((dt) => dt.kind === "file" && dt.type.startsWith("image/")).map((dt) => dt.getAsFile()).filter((dt) => dt !== null).map((dt, gt) => R(dt, gt));
      if (ct.length !== 0) {
        if (!s.enableImagePaste || b || r.value) {
          J7(e("medic-web-engine.copyFromClipboardIsOnlyAvailableInTheChatTab"));
          return;
        }
        A.preventDefault(), H(ct, !0);
      }
    }, F = (A) => {
      A instanceof ClipboardEvent && z(A);
    }, P = () => {
      c.value = [], u.value = null;
    }, j = (A, E = !1) => {
      const ct = [...A];
      u.value = n.open(wRt, {
        props: {
          closable: !0,
          dismissableMask: !0,
          modal: !0,
          header: e("shared.uploadFile"),
          style: { width: "50vw" }
        },
        data: {
          files: ct,
          shareToChat: !0,
          showShareToChatOption: s.showShareToChatOption
        },
        onClose: () => {
          if (u.value = null, d.value > 0) {
            d.value -= 1;
            return;
          }
          E && P();
        },
        emits: {
          onSaveCase: async (at) => {
            const dt = E ? [...c.value] : ct;
            E && P(), o("uploadFileAndShareToChat", { files: dt, data: at });
          }
        }
      });
    }, H = (A, E = !1) => {
      if (!E) {
        j(A);
        return;
      }
      c.value = [...c.value, ...A], u.value && (d.value += 1, u.value.close()), j(c.value, !0);
    }, B = () => {
      n.open(P7, {
        props: {
          closable: !0,
          dismissableMask: !0,
          modal: !0,
          header: e("shared.invalidFileType")
        }
      });
    }, $ = te(() => s.fromPlanner ? "height: calc(111vh - 500px) !important" : "height: calc(111vh - 418px) !important");
    return gn(
      () => s.scrollToBottomTrigger,
      () => {
        y();
      },
      { immediate: !1 }
    ), xn(() => {
      s.enableImagePaste && document.addEventListener("paste", F), h.value && y();
    }), wg(() => {
      s.enableImagePaste && document.removeEventListener("paste", F);
    }), (A, E) => {
      const ct = tr("ProgressSpinner"), at = tr("InputText"), dt = tr("Textarea"), gt = Z7("tooltip");
      return Mt(), Ot("div", xRt, [
        a.value ? (Mt(), le(K(Te), {
          key: 0,
          class: "mt-16 justify-center"
        }, {
          default: oe(() => [
            Pt(ct)
          ]),
          _: 1
        })) : (Mt(), le(K(H7), {
          key: 1,
          ref_key: "notificationElRef",
          ref: p,
          dataKey: void 0,
          layout: YRt,
          value: s.notifications,
          class: "overflow-y-auto grow select-text",
          style: xe($.value)
        }, {
          list: oe((Wt) => [
            (Mt(!0), Ot(Me, null, Xn(Wt.items, (Zt) => (Mt(), Ot("div", {
              class: Rn([Z(Zt.mine), "col-12-no-padding flex all-radius"]),
              key: Zt.id
            }, [
              Zt.type !== K(c0).SHIPPING_DATE_CHANGE ? (Mt(), Ot("div", {
                key: 0,
                class: Rn(X(Zt.type))
              }, [
                Pt(hRt, {
                  model: Zt,
                  dateFormat: s.dateFormat,
                  isUserWeblinkOperator: i.isUserWeblinkOperator,
                  onOpenSTL: E[0] || (E[0] = (Gt) => o("openSTL", Gt))
                }, null, 8, ["model", "dateFormat", "isUserWeblinkOperator"])
              ], 2)) : Qt("", !0),
              Zt.type === K(c0).SHIPPING_DATE_CHANGE ? (Mt(), Ot("div", SRt, [
                Pt(WRt, {
                  model: Zt,
                  dateFormat: s.dateFormat
                }, null, 8, ["model", "dateFormat"])
              ])) : Qt("", !0)
            ], 2))), 128))
          ]),
          empty: oe(() => [
            Pt(K(hg), { class: "justify-center pt-6" }, {
              default: oe(() => [
                Ws(pe(A.$t("medic-web-framework.looksLikeThereAreNoMessagesYet")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "style"])),
        i.showChatBar ? (Mt(), Ot(Me, { key: 2 }, [
          a.value ? Qt("", !0) : (Mt(), Ot("div", LRt, [
            kt("div", VRt, [
              s.expandableMessageField ? (Mt(), le(dt, {
                key: 1,
                modelValue: l.value,
                "onUpdate:modelValue": E[2] || (E[2] = (Wt) => l.value = Wt),
                class: "w-full chat-input-expandable",
                placeholder: A.$t("medic-web-framework.typeMessage"),
                rows: 1,
                autoResize: !0,
                onKeydown: f,
                "data-cy": "chat-input",
                disabled: K(b) || r.value
              }, null, 8, ["modelValue", "placeholder", "disabled"])) : (Mt(), le(at, {
                key: 0,
                modelValue: l.value,
                "onUpdate:modelValue": E[1] || (E[1] = (Wt) => l.value = Wt),
                class: "w-full h-51px",
                placeholder: A.$t("medic-web-framework.typeMessage"),
                type: "text",
                onKeyup: T7(g, ["enter"]),
                "data-cy": "chat-input",
                disabled: K(b) || r.value
              }, null, 8, ["modelValue", "placeholder", "disabled"]))
            ]),
            T.value ? as((Mt(), Ot("div", XRt, [
              Pt(K(a3), {
                id: "btnChatTabUpload",
                class: Rn([s.compactActionButtons ? "all-radius-16 weblink-btn-51px notification-action-upload" : "all-radius-16 weblink-btn-51px", "h-full"]),
                accept: "application/msword,.docx,.xlsx,application/vnd.ms-excel,application/vnd.ms-powerpoint,text/plain,application/pdf,image/*,.stl",
                disabled: K(b) || r.value,
                chooseLabel: s.compactActionButtons ? "" : A.$t("shared.choose"),
                showOnlyIcon: s.compactActionButtons,
                "data-cy": "chat-upload-file",
                onInvalidFileType: B,
                onFilesSelected: H
              }, null, 8, ["class", "disabled", "chooseLabel", "showOnlyIcon"])
            ])), [
              [
                gt,
                { value: A.$t("shared.uploadFile"), disabled: !s.compactActionButtons },
                void 0,
                { bottom: !0 }
              ]
            ]) : Qt("", !0),
            s.isUserWeblinkOperator && s.showAddNote ? (Mt(), Ot("div", IRt, [
              Pt(K(ye), {
                class: Rn([s.compactActionButtons ? "justify-center all-radius-16 h-51px notification-action-icon" : "flex justify-center all-radius-16 h-51px"]),
                icon: "pi pi-pen-to-square",
                label: s.compactActionButtons ? "" : A.$t("medic-web-framework.addNote"),
                tooltip: s.compactActionButtons ? A.$t("medic-web-framework.addNote") : "",
                onClick: x,
                "data-cy": "chat-add-note",
                disabled: K(b) || r.value
              }, null, 8, ["class", "label", "tooltip", "disabled"])
            ])) : Qt("", !0),
            kt("div", CRt, [
              Pt(K(ye), {
                class: Rn([s.compactActionButtons ? "all-radius-16 h-51px notification-action-icon" : "all-radius-16 h-51px"]),
                icon: W.value,
                label: s.compactActionButtons ? "" : A.$t("medic-web-framework.send"),
                tooltip: N.value,
                "data-cy": "chat-send",
                onClick: V,
                disabled: K(b) || r.value || i.disableSendMessage
              }, null, 8, ["class", "icon", "label", "tooltip", "disabled"])
            ])
          ]))
        ], 64)) : Qt("", !0)
      ]);
    };
  }
}), TOt = /* @__PURE__ */ Dn(vRt, [["__scopeId", "data-v-34f09230"]]), MOt = /* @__PURE__ */ Ne({
  __name: "FilePreviewDialog",
  setup(i) {
    const t = gr("dialogRef"), e = t.value.data, n = te(() => {
      const s = e.files[0].name;
      return e.height ? e.height : s.endsWith(".zip") || s.endsWith(".docx") || s.endsWith(".xlsx") || s.endsWith(".txt") ? "11vh" : s.endsWith(".png") || s.endsWith(".jpg") ? "20vh" : "50vh";
    });
    return (s, r) => {
      const a = tr("Divider");
      return Mt(), Ot(Me, null, [
        Pt(K(Te), {
          class: "justify-center pt-4",
          style: xe({ height: n.value })
        }, {
          default: oe(() => [
            Pt(K(yC), {
              selectedFiles: K(e).files,
              allFiles: K(e).files
            }, null, 8, ["selectedFiles", "allFiles"])
          ]),
          _: 1
        }, 8, ["style"]),
        Pt(a, { class: "mt-1" }),
        Pt(K(hg), { class: "justify-end pt-4" }, {
          default: oe(() => [
            Pt(K(WT), {
              class: "weblink-btn min-w-28",
              label: s.$t("shared.close"),
              onClick: r[0] || (r[0] = (o) => K(t).close())
            }, null, 8, ["label"])
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), RRt = { style: { width: "300px" } }, DRt = ["onClick"], ORt = {
  key: 0,
  class: "pi pi-check color-white flex mt-2-5 align-middle text-shadow-black"
}, zRt = { class: "mt-2 mb-2 font-bold color-white text-shadow-black" }, ERt = { style: { "font-size": "x-small", "font-weight": "bold", color: "red", "white-space": "pre-wrap", "text-shadow": "1px 1px 5px rgba(0, 0, 0, 1)" } }, kRt = ["src"], FRt = ["src"], jRt = /* @__PURE__ */ Ne({
  __name: "CADTeethView",
  props: /* @__PURE__ */ rl({
    jawboneType: {},
    indexTeeth: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ rl(["toothClick", "toothMouseOver", "toothMouseOut", "update:modelValue"], ["update:modelValue"]),
  setup(i, { emit: t }) {
    const e = ZC(), n = TC(), s = cJ(), r = uJ(), a = dJ(), o = i, l = zr(i, "modelValue"), c = t, u = te(() => o.jawboneType === $e.MAXILLA ? 18 : 0), d = Lt(null), h = document.createElement("canvas"), p = jl(), m = new Image(), b = {};
    let y = !1;
    const Z = new Image(), g = {};
    let f = !1;
    const T = te(() => o.jawboneType === $e.MAXILLA ? m : Z), M = te(() => o.jawboneType === $e.MAXILLA ? e : n), N = te(() => o.jawboneType === $e.MAXILLA ? b : g), W = (it) => !!it && it.complete && it.naturalWidth > 0 && it.naturalHeight > 0, x = () => o.jawboneType === $e.MAXILLA ? y : f, V = () => W(T.value) && ai.every((it) => W(N.value[it])), X = (it) => {
      let ht = 1 + ai.length;
      const lt = () => {
        ht--, ht === 0 && (it(), y = !0);
      };
      m.onload = () => lt(), m.src = p.getAssetUrl("/resources/teeth/maxilla.png"), ai.forEach((mt) => {
        const [wt] = e[mt], Xt = new Image();
        Xt.onload = () => lt();
        const At = `/resources/${wt}`;
        Xt.src = p.getAssetUrl(At), b[mt] = Xt;
      });
    }, C = (it) => {
      let ht = 1 + ai.length;
      const lt = () => {
        ht--, ht === 0 && (it(), f = !0);
      };
      Z.onload = () => lt(), Z.src = p.getAssetUrl("/resources/teeth/mandible.png"), ai.forEach((mt) => {
        const [wt] = n[mt], Xt = new Image();
        Xt.onload = () => lt();
        const At = `/resources/${wt}`;
        Xt.src = p.getAssetUrl(At), g[mt] = Xt;
      });
    }, R = (it) => it.status === _e.CROWN_SEGMENTATION_SELECTED ? r[it.id] : it.status === _e.CROWN_SEGMENTATION ? a[it.id] : s[it.status], z = (it, ht, lt, mt, wt, Xt) => {
      ht.save(), ht.clearRect(0, 0, it.width, it.height), ht.drawImage(lt, wt, Xt), ht.fillStyle = mt, ht.globalCompositeOperation = "source-in", ht.fillRect(0, 0, it.width, it.height), ht.restore();
    }, F = () => {
      const it = T.value;
      if (!d.value || !V())
        return;
      const ht = d.value.getContext("2d");
      if (!ht)
        return;
      d.value.width = it.naturalWidth, d.value.height = it.naturalHeight, h.width = d.value.width, h.height = d.value.height;
      const lt = h.getContext("2d");
      lt && (ht.clearRect(0, 0, d.value.width, d.value.height), ht.drawImage(it, 0, 0), l.value.teeth[o.indexTeeth].forEach((mt) => {
        const [, wt] = M.value[mt.id], [Xt, At, he, ue] = R(mt), Dt = `rgba(${Xt}, ${At}, ${he}, ${ue / 255})`, ee = N.value[mt.id];
        z(h, lt, ee, Dt, wt[0], wt[1]), ht.drawImage(h, 0, 0);
      }));
    }, P = Object.fromEntries(ai.map((it) => [it, Lt("")])), j = () => {
      for (const it of ai)
        P[it].value = "";
      l.value.teeth[o.indexTeeth].forEach((it) => {
        const [ht, lt, mt] = R(it), wt = `rgb(${ht}, ${lt}, ${mt})`;
        P[it.id].value = wt;
      });
    };
    j();
    const H = te(() => o.jawboneType === $e.MAXILLA ? Object.fromEntries(yd(l.value.useUSStyleToothChart).map((it, ht) => [ai[ht], it])) : Object.fromEntries(gd(l.value.useUSStyleToothChart).map((it, ht) => [ai[ht], it]))), B = Lt(0), $ = new Uint8Array(49600), A = (it, ht) => $[it + ht * 248], E = () => {
      if (!d.value || !V() || d.value.width <= 0 || d.value.height <= 0)
        return;
      const it = document.createElement("canvas");
      it.width = d.value.width, it.height = d.value.height;
      const ht = it.getContext("2d");
      if (!ht)
        return;
      const lt = h.getContext("2d");
      if (!lt)
        return;
      for (const wt of ai) {
        const Xt = N.value[wt], [, At] = M.value[wt], he = `rgb(${wt}, 0, 0)`;
        z(h, lt, Xt, he, At[0], At[1]), ht.drawImage(h, 0, 0);
      }
      const mt = ht.getImageData(0, 0, it.width, it.height).data;
      for (let wt = 0; wt < mt.length / 4; wt++)
        $[wt] = mt[wt * 4];
    }, ct = (it) => {
      const ht = A(it.offsetX, it.offsetY);
      ht !== 0 && c("toothClick", ht, it, o.jawboneType);
    }, at = Lt(), dt = (it) => {
      const ht = l.value.teeth[o.indexTeeth].find((lt) => lt.id === at.value);
      ht && (ht.status = it);
    }, gt = (it) => {
      const ht = A(it.offsetX, it.offsetY);
      ht !== 0 && (at.value = ht, nt.value.show(it));
    }, Wt = (it) => {
      const ht = A(it.offsetX, it.offsetY);
      ht !== B.value && (B.value !== 0 && c("toothMouseOut", B.value, it, o.jawboneType), ht !== 0 && c("toothMouseOver", ht, it, o.jawboneType), B.value = ht);
    };
    X(() => {
      o.jawboneType === $e.MAXILLA && (F(), E());
    }), C(() => {
      o.jawboneType === $e.MANDIBLE && (F(), E());
    }), gn(
      l.value,
      () => {
        x() && F(), j();
      },
      { deep: !0 }
    );
    const Zt = (it) => {
      const [, , ht] = M.value[it];
      return {
        left: ht[0] + 5 + "px",
        top: ht[1] + 2 + "px"
      };
    }, Gt = (it) => {
      const ht = N.value[it], [, lt] = M.value[it];
      let mt = 0, wt = 0;
      return ht != null && ht.complete && (mt = ht.width / 2 - 14, wt = ht.height / 2 - 14), {
        left: lt[0] + mt + "px",
        top: lt[1] + wt + u.value + "px"
      };
    }, Tt = () => o.jawboneType === $e.MAXILLA ? { top: "50%" } : { top: "10%" }, Q = (it) => ({ background: it }), D = te(() => {
      let it = "flex justify-center";
      return l.value.showLines && (it += " line-in-middle"), l.value.showLines && o.jawboneType === $e.MANDIBLE && (it += " horizontal-line"), it;
    }), q = te(() => {
      let it = "relative";
      return l.value.showLines && o.jawboneType === $e.MANDIBLE && (it += " mandible-mt"), it;
    }), nt = Lt(), et = Lt([]), ot = Lt(2);
    return xn(() => {
      const it = lJ();
      for (let ht = 0; ht < it.length; ht++)
        et.value.push({
          id: it[ht].id,
          label: it[ht].label,
          background: it[ht].background,
          selected: ht === ot.value,
          command: () => {
            console.log("toothReconstructionTypes changed for tooth: ", at.value);
          }
        });
    }), (it, ht) => (Mt(), Ot("div", RRt, [
      kt("div", {
        class: Rn(D.value),
        style: { height: "214px", "user-select": "none" }
      }, [
        kt("div", {
          style: xe({
            paddingTop: u.value + "px"
          }),
          class: Rn(q.value)
        }, [
          kt("canvas", {
            id: "canvas",
            ref_key: "canvas",
            ref: d,
            class: Rn([{ "cursor-pointer": B.value !== 0 }, "all-radius-8"]),
            onClick: ct,
            onMousemove: Wt,
            onContextmenu: gt
          }, null, 34),
          (Mt(!0), Ot(Me, null, Xn(M.value, (lt, mt) => (Mt(), Ot("div", {
            key: mt,
            style: xe([[
              {
                color: K(P)[mt].value
              },
              Zt(mt)
            ], { "font-size": "12px", "font-weight": "bold", "text-shadow": "1px 1px 5px rgba(0, 0, 0, 1)" }]),
            class: "absolute pointer-events-none shadow-sm"
          }, pe(H.value[mt]), 5))), 128)),
          Pt(K(xG), {
            ref_key: "menu",
            ref: nt,
            model: et.value
          }, {
            item: oe(({ item: lt }) => [
              kt("div", {
                class: "flex flex-row justify-center gap-2 pointer",
                style: xe(Q(lt.background)),
                onClick: (mt) => dt(lt.id)
              }, [
                lt.selected ? (Mt(), Ot("span", ORt)) : Qt("", !0),
                kt("span", zRt, pe(lt.label), 1)
              ], 12, DRt)
            ]),
            _: 1
          }, 8, ["model"]),
          kt("div", {
            class: "absolute w-6/12 h-6 flex justify-center",
            style: xe([Tt(), { "text-align": "center", left: "25%" }])
          }, [
            kt("span", ERt, pe(l.value.warnString), 1)
          ], 4),
          (Mt(!0), Ot(Me, null, Xn(l.value.teeth[o.indexTeeth], (lt) => (Mt(), Ot(Me, {
            key: lt.status
          }, [
            B.value == lt.id ? (Mt(), Ot(Me, { key: 0 }, [
              lt.hoverIcon === K(Yr).ADD ? (Mt(), Ot("img", {
                key: 0,
                style: xe([Gt(lt.id), { width: "28px", height: "28px" }]),
                class: "absolute rounded-full pointer-events-none",
                src: K(p).getAssetUrl("/resources/teeth/AddPin.png"),
                draggable: "false"
              }, null, 12, kRt)) : lt.hoverIcon === K(Yr).REMOVE ? (Mt(), Ot("img", {
                key: 1,
                style: xe([Gt(lt.id), { width: "28px", height: "28px" }]),
                class: "absolute rounded-full pointer-events-none",
                src: K(p).getAssetUrl("/resources/teeth/RemovePin.png"),
                draggable: "false"
              }, null, 12, FRt)) : Qt("", !0)
            ], 64)) : Qt("", !0)
          ], 64))), 128))
        ], 6)
      ], 2)
    ]));
  }
}), NOt = /* @__PURE__ */ Dn(jRt, [["__scopeId", "data-v-45c89b14"]]), URt = { class: "flex flex-col" }, PRt = { class: "mb-6" }, JRt = { class: "ml-2 font-medium" }, WOt = /* @__PURE__ */ Ne({
  __name: "CADTeethViewLegend",
  setup(i) {
    return (t, e) => {
      const n = tr("Chip");
      return Mt(), Ot("div", URt, [
        kt("h3", PRt, pe(t.$t("medic-web-framework.legend")), 1),
        (Mt(!0), Ot(Me, null, Xn(K(lJ)(), (s) => (Mt(), le(n, {
          class: "py-0 pl-0 pr-6 mt-2",
          key: s.id
        }, {
          default: oe(() => [
            kt("span", {
              class: "rounded-full w-8/12 h-8 flex items-center justify-center",
              style: xe({ background: s.background })
            }, pe(t.$t("medic-web-framework.p")), 5),
            kt("span", JRt, pe(s.label), 1)
          ]),
          _: 2
        }, 1024))), 128))
      ]);
    };
  }
});
function GOt() {
  return {
    abutment: {
      model: "",
      name: "",
      selling_code: ""
    },
    diameter: "",
    length: "",
    model: "",
    name: "",
    notes: "",
    position: "",
    producer: "",
    selling_code: "",
    sleeve: {
      d_external: 0,
      d_internal: 0,
      drill_length: 0,
      model: "",
      name: "",
      offset: 0,
      selling_code: ""
    }
  };
}
function wOt() {
  return {
    model: "",
    position: "",
    producer: "",
    sleeve: {
      d_external: 0,
      d_internal: 0,
      model: "",
      name: "",
      selling_code: ""
    }
  };
}
function xOt() {
  return {
    project: {
      implants: [],
      name: "",
      orderId: "",
      patient: {
        birthDate: "",
        id: "",
        name: ""
      },
      pins: [],
      sleeve_list: {},
      user: {
        customerName: "",
        email: "",
        id: 0
      },
      weblinkId: ""
    }
  };
}
function ARt(i) {
  switch (i) {
    case "lines":
      return 1;
    case "polys":
      return 2;
    case "strips":
      return 3;
    case "verts":
      return 4;
    default:
      return 0;
  }
}
function BRt(i, t, e, n, s, r, a) {
  var d, h;
  if (!rG)
    return i.createVBOJs(e, n, s, r, a);
  n === "verts" ? s = Vn.POINTS : n === "lines" && s === Vn.SURFACE && (s = Vn.WIREFRAME);
  const o = [
    ["polys", Vn.SURFACE],
    ["polys", Vn.WIREFRAME],
    ["polys", Vn.POINTS],
    ["lines", Vn.WIREFRAME],
    ["lines", Vn.POINTS],
    ["strips", Vn.SURFACE],
    ["strips", Vn.WIREFRAME],
    ["strips", Vn.POINTS],
    ["verts", Vn.POINTS]
  ];
  let l = !1;
  for (let p = 0; p < o.length; p++)
    if (o[p][0] === n && o[p][1] === s) {
      l = !0;
      break;
    }
  if (!l)
    return i.createVBOJs(e, n, s, r, a);
  const c = (d = r.points) == null ? void 0 : d.getDataType(), u = (h = r.normals) == null ? void 0 : h.getDataType();
  if (c && c !== "Float32Array" || u && u !== "Float32Array")
    return i.createVBOJs(e, n, s, r, a);
  if (!e.getData() || !e.getData().length)
    return t.elementCount = 0, 0;
  if (n === "polys" && Number(e.getData()[0]) !== 3)
    return i.createVBOJs(e, n, s, r, a);
  t.blockSize = 3, t.vertexOffset = 0, t.normalOffset = 0, t.tCoordOffset = 0, t.tCoordComponents = 0, t.colorComponents = 0, t.colorOffset = 0, t.customData = [], r.colors ? (t.colorBO || (t.colorBO = Rc.newInstance()), t.colorBO.setOpenGLRenderWindow(t._openGLRenderWindow)) : t.colorBO = null;
  try {
    const p = ARt(n), m = rG.m.createVBO(t, i, e, p, s, r);
    return Number(m.cellCount);
  } catch {
    return i.createVBOJs(e, n, s, r, a);
  }
}
let rG = null;
function SOt(i) {
  window.VTKJSWASM || (window.VTKJSWASM = {
    createVBO: BRt
  }), rG = i;
}
function LOt() {
  delete window.VTKJSWASM, rG = null;
}
export {
  OC as Abutment,
  mOt as ActiveRecontstruction,
  qA as ActiveToolType,
  pr as AnchorPosition,
  yz as AngleMeasurement3D,
  Kp as Annotation3D,
  Cht as AnnotationLabel,
  F1t as ArcRepresentation,
  NM as ArrayMax,
  WM as ArrayMin4,
  ybt as ArraysAreEqual,
  yN as ArrowRepresentation,
  Dht as BoundingBoxLabels,
  Y1t as BoundingBoxVisualization,
  UNt as BrushTool,
  qG as BuildActorTransform,
  NOt as CADTeethView,
  WOt as CADTeethViewLegend,
  PNt as CPRTool,
  ZDt as CalculateSpacingForNormal,
  hRt as ChatNotificationComponent,
  wDt as Clamp2Bounds,
  CMt as ClippingPlaneTool,
  VMt as ClippingPlanes,
  Qht as ClippingPlanesWidget,
  md as Computed,
  tV as ConeMarker,
  fOt as ConstructionInfo,
  X3 as ConstructionInfoRepresentation,
  zT as ContextMenu,
  y2t as CoordControl,
  zbt as CprCrossIndicatorButtons,
  f5 as CreateScalingMatrix,
  Kwt as CroppingTool,
  FVt as CrosshairType,
  vr as CustomUndoData,
  g5 as Distance2ToInfiniteLine,
  z4 as DocumentContext,
  yyt as DynamicButton,
  Tyt as DynamicCollapsible,
  Myt as DynamicCombobox,
  w2 as DynamicGUIComponent,
  xyt as DynamicImage,
  Syt as DynamicLabel,
  Xyt as DynamicLine,
  Jyt as DynamicLineEdit,
  CDt as DynamicPrevNext,
  Iyt as DynamicSlider,
  Cyt as DynamicSwitcher,
  Uyt as DynamicTeethView,
  MI as EMToArrayBuffer,
  yC as FilePreviewComponent,
  MOt as FilePreviewDialog,
  Je as FilterMode,
  ea as FindNearestPoint,
  Wn as FreeformToolType,
  zh as Get3DPoint,
  obt as GetActorCenter,
  yDt as GetActorHeight,
  cbt as GetActorNormal,
  xP as GetActorPosition,
  lbt as GetActorTop,
  kL as GetAngle,
  y5 as GetAngleVec,
  SP as GetBLOrientation,
  xDt as GetDegFromRadians,
  N5 as GetEdgePointsFromBounds,
  LP as GetFlatArray,
  T5 as GetIndexOfNearestSegment,
  Eh as GetPointClosestToCamera,
  xW as GetRadiansFromDeg,
  VP as GetRotationMatrix,
  qc as GetViewMatrix,
  TDt as GetWorldPointRay,
  vTt as Grid3D,
  mDt as HelloWorld,
  Yr as HoverIconType,
  p3 as IEngineGenerated,
  me as IViewEvent,
  h0 as Implant,
  UC as ImportCADType,
  HYt as ImportObjectsFromPlanner,
  tOt as ImportTypeLabels,
  P2t as InputMode,
  td as InteractionMode,
  T2 as IntersectBoxWithInfiniteLine,
  dbt as IntersectLineWithLine2D,
  GDt as IsInsideBounds,
  _e as ItemStatus,
  $e as JawboneType,
  bDt as Label,
  uTt as LayoutManager,
  Yn as LayoutTemplate,
  OU as LazyComputed,
  WDt as LineBoxIntersection,
  bbt as Line_Box_Intersect,
  Z5 as Line_Rect_Intersect,
  UX as MAXCURVEOFFSET,
  Fyt as MDynamicTeethView,
  se as MEvent,
  TOt as MNotificationTab,
  v4 as MPdfViewer,
  jW as MTeethView,
  xo as Maxilla0Mandible,
  axt as MeasurementTool,
  YC as MeasurementsDistanceUnit,
  z2t as ModifierKeys,
  $L as MouseMode,
  QI as MovableWindow,
  fA as Nerve,
  Qwt as NerveTool,
  gA as ObjectCollection,
  RU as ObjectInfoContainer,
  N0t as ObjectInfoLabel,
  TP as ObjectInfos,
  $G as ObjectList,
  MP as ObjectMoveHandle,
  NP as ObjectMoveTool,
  Yt as ObjectType,
  qt as Observable,
  PT as OrientationWidget,
  YMt as OrientationWidgetCAD,
  GP as OrientationWidgetMenu,
  Ght as OverlayComponent,
  vU as OverlayContainer,
  $vt as PdfPreviewDialog,
  jC as Pin,
  MTt as PlaneRepresentation,
  fbt as Plane_Line_Intersect,
  M5 as Point2Index2Point,
  v2 as PointPicker,
  ed as PointRepresentation,
  wC as PresenterWindow,
  oy as PresenterWindow2D,
  ZNt as PresenterWindow2DCustom,
  c2 as PresenterWindow3D,
  ni as PresenterWindowType,
  Fs as ProjectPoint,
  ubt as ProjectToPlane,
  MDt as ProjectVector2Plane,
  wW as ProjectVector2Sphere,
  Zz as ROIMeasurement3D,
  zL as RayPlaneIntersection,
  qo as ReadonlyObservable,
  bOt as ReconstructionProject,
  Pvt as ReconstructionType,
  qMt as Representation2D,
  d5 as Resizer,
  gbt as RotatePoint,
  bN as RotateVector,
  Pbt as STLMoveWidget,
  Kr as ScalarBar,
  IDt as ScalarBarWidget,
  _wt as SculptingTool,
  LMt as SectionalView,
  m5 as SectionalViewSlider,
  ks as Set3DOrientationType,
  jVt as Settings,
  abt as SetupSTLActor,
  WRt as ShippingNotificationComponent,
  lw as Sleeve,
  Sbt as SliceIndicator2D,
  SDt as SliceIndicators2D,
  eOt as SphereRepresentationWidget,
  vn as StlObject,
  $Dt as StlObjectUndo,
  Pe as TCADObjectType,
  YJ as TDesktopView,
  Xa as TFilterMode,
  m3 as TFilterType,
  b3 as TGradientDirection,
  f3 as TImageType,
  US as TItem3DCollectionFilter,
  _o as TJSLambdaType,
  G3 as TMode,
  g3 as TObjectType,
  Mr as TPropType,
  T3 as TReconstructionDesign,
  N3 as TReconstructionPreSelectedMode,
  W3 as TReconstructionPreSelectedWorkflow,
  M3 as TReconstructionWorkflow,
  aJ as TScalarBarMode,
  w3 as TShowImportCheckNanWarning,
  y3 as TSortType,
  Z3 as TSubscribtionMode,
  Zr as TToolWidgetType,
  Ja as ToolInterface,
  on as ToolLayer,
  DVt as ToolManager,
  sn as ToolType,
  Hbt as Toolbar2D,
  _bt as Toolbar2DCustom,
  Qbt as Toolbar3D,
  LDt as Toolbar3DTeethView,
  Cg as ToolbarContainer,
  VDt as ToolbarFullscreenButton,
  XDt as ToolbarMenu,
  x2 as ToothEditMode,
  ai as ToothIds,
  zW as ToothMarker,
  EL as TransformNormal,
  NDt as TransformPoint,
  NC as UndoData,
  ws as UndoEvent,
  kVt as UndoManager,
  EVt as UndoManagerChange,
  Z2t as UndoStack,
  jYt as UniversalFilePicker,
  FXt as UploadPreviewGenerator,
  KXt as UploadPreviewGeneratorWasm,
  wP as Vector2VectorTransformation,
  rbt as Vector2VectorTransformation2,
  vl as View2D,
  gNt as View2DCustom,
  sOt as View2DPick,
  rOt as View3D,
  RW as View3DImplantPlanner,
  UDt as View3DSTL,
  JDt as View3DWebLink,
  op as ViewBase,
  Nt as ViewMode,
  l2 as ViewPreset,
  TNt as ViewSTL3DPreview,
  IP as ViewSliceSlider,
  ibt as ViewSliderHorizontal,
  q0t as ViewSliderVertical,
  pbt as VirtualTrackballAxisRotation,
  hbt as VirtualTrackballRotation,
  ow as VisualObject,
  KZt as VolumeInterpolationType,
  cA as VolumeObject,
  qDt as VolumeObjectUndo,
  XJ as VolumeOptions,
  Co as VolumeShadingMode,
  r8 as WASM_BUILD_TYPE,
  L3 as WCEModule,
  V3 as WCEngine,
  Evt as WasmEnginePluginVue,
  xMt as WeblinkSettings,
  wRt as WeblinkUploadPreviewComponent,
  Hwt as WindowLevelTool,
  Jn as WizardType,
  ZB as addWebGLContextEventForwarding,
  EZt as blendColor,
  NA as brushOffEvent,
  WA as brushOnEvent,
  iOt as brushRedoEvent,
  nOt as brushUndoEvent,
  Zbt as calculateOwnerNormal,
  _I as calculateRectangleViewport,
  Bdt as calculateViewportRectangle,
  yJ as chainEventHandlers,
  gDt as checkVolumeTextureLoad,
  UMt as cleanupReusableScreenshotRenderWindow,
  jDt as clearDebugObjects,
  NS as clickHistoryEvent,
  jvt as colorsList,
  P1 as convertBigInt64ToUint32,
  OMt as convertColor,
  rS as convertToothName,
  ZN as coordinateSystemAxisLength,
  gOt as createContextMenu,
  hDt as createImageData,
  pDt as createImageDataFromProject,
  uDt as createImageDataFromWasm,
  P0t as createOverlayModel,
  VI as createPLYObject,
  Xet as createPLYObjectFromArrayBuffer,
  EG as createPolydataFromOBJ,
  Lo as createPolydataFromSTL,
  LI as createSTLObject,
  Vet as createSTLObjectFromArrayBuffer,
  yvt as createTabWidgetHandler,
  zZt as createViewConfiguration,
  aOt as crosshairTypes,
  dOt as defaultWasmEngineLoader,
  LOt as disableVtkOverrides,
  KDt as downloadFile,
  ADt as downloadJSON,
  BDt as downloadScreenshot,
  sbt as downsample2xWithReslice,
  Ha as dynamicRound,
  XP as dynamicRoundNumber,
  x3 as eOType,
  cOt as exportStlObjectFromWasm,
  ZJ as extend,
  lOt as extractTextureNamesFromMtl,
  WI as fillPolyDataFromWasmView,
  CW as filterModeLabels,
  oOt as findAssociatedFilesByBase,
  DDt as fromUSToothName,
  VT as getActorDataFromWasm,
  UW as getBaseName,
  xOt as getEmptyErpFile,
  GOt as getEmptyImplantObj,
  wOt as getEmptyPinObj,
  yE as getFileDir,
  O2 as getFilePath,
  ki as getFixedSizeScale,
  itt as getImageColorTransferFunctionFromWasm,
  cDt as getImageDataFromWasm,
  Go as getImageDataFromWasmBase,
  stt as getImageOpacityFunctionFromWasm,
  TC as getMandibleTeethMaskData,
  gd as getMandibleTeethNames,
  ZC as getMaxillaTeethMaskData,
  yd as getMaxillaTeethNames,
  Bi as getNumOfDecimals,
  pTt as getPixelSize,
  Cr as getPolyDataFromWasm,
  UT as getProjectImplantDefaults,
  MC as getProjectObject3DDefaults,
  EDt as getProjectPinDefaults,
  p2t as getProjectPinImplantGuideDefaults,
  m2t as getProjectPinImplantModelDefaults,
  b2t as getProjectPinInfoDefaults,
  h2t as getProjectToothMarkerDefaults,
  Fvt as getSegmentationResult,
  c3 as getSignedSleeveParameter,
  jS as getSleeveGuideRadius,
  rvt as getTeethLibraryList,
  Yyt as getTeethNames,
  jF as getTextureFromWasm,
  vyt as getToothIdFromName,
  YDt as getToothNameForId,
  lJ as getToothReconstructionInfo,
  uJ as getToothStylesForId,
  dJ as getToothStylesForIdOpaque,
  cJ as getToothStylesForStatus,
  UF as getTransferFunctionFromWasm,
  RDt as getUnusedMandibleNames,
  vDt as getUnusedMaxillaNames,
  ntt as getXAlphaFlatArray,
  ett as getXRGBFlatArray,
  OL as halfVolumeDimensions,
  wht as hotspotSolver,
  fDt as initI18n,
  D4 as invalidateTeethLibraryInWasm,
  qYt as isExistingFile,
  WB as isMtlFileName,
  pOt as isNullContext,
  NB as isTextureFileName,
  oJ as isToothName,
  avt as loadTeethLibToWasm,
  zvt as loadWasmEngine,
  HE as makePath,
  Pa as mapColorFromVtk,
  Kn as mapColorToVtk,
  dTt as mapDesktopViewToLayoutTemplate,
  hTt as mapLayoutTemplateToDesktopView,
  iu as measurementToolModel,
  eu as modifierKeys,
  du as movePolyDataToWasm,
  O4 as navbarEvents,
  j2t as newInstance,
  PC as objectListAddElement,
  Le as observableToRef,
  PDt as onMouseButtonDownOnce,
  lS as onMouseButtonUpOnce,
  Yz as onMouseOutEvent,
  Uvt as onPointDelete,
  _u as onSlicerVisibilityChange,
  WP as panToObjectPositionEvent,
  TB as parseMenuItems,
  _7 as parseSleeveBoolean,
  jNt as predToEditSelectEvent,
  yOt as primaryMod,
  b5 as probeVolumeTextureCapacity,
  hOt as provideProjectContext,
  FNt as radiusChangedEvent,
  j2 as recursiveDeleteWasmFSFolder,
  YU as redirectWheelEvent,
  BZt as renderDebugLine,
  kDt as renderDebugPoints,
  FDt as renderDebugRay,
  NI as replacePolyDataArraysFromWasm,
  zDt as retrieveCurrentWizardGUIWithRetry,
  Tbt as roundToSignificantFigures,
  KE as safeUnlink,
  S3 as sanitizeWasmErrorMessage,
  ttt as saveFileFromWasmFS,
  dDt as saveFilesFromWasmFS,
  uC as set3DOrientationEvent,
  X0 as setCameraOrientation,
  AZt as setDebugRenderWindow,
  J0t as setObjectVisibilityEvent,
  IW as setup3dRendererParameters,
  k1t as setupReconstructionProject,
  Byt as setupRenderWindowParameters,
  SOt as setupVtkOverrides,
  Y2 as shpereVisibilityToggleEvent,
  jX as statIfFile,
  sL as syncFromWasmMatrix,
  KMt as takeActorScreenshot,
  oA as takeFullscreenViewScreenshot,
  HDt as takeImplantPartScreenshot,
  QDt as takeStlFileScreenshot,
  lA as takeStlScreenshot,
  aw as takeViewScreenshot,
  _Dt as takeVolumeTemplateScreenshot,
  BMt as takeVtkActorFrontScreenshot,
  vg as takeVtkActorScreenshot,
  AMt as takeVtkActorScreenshotWithCamera,
  DW as toCSSRGBString,
  ODt as toUSToothName,
  jt as translation,
  Ryt as tryFromUSToothName,
  Dyt as tryToUSToothName,
  tvt as unlinkAllCadPartFiles,
  ovt as unlinkTeethLibsFromWasm,
  evt as unlinkWasmCadPartFiles,
  ND as updateImageDataFromWasm,
  $o as updateWasmMatrix,
  uOt as uploadMeshLabelToDocument,
  BXt as uploadMeshLabelToDocumentFromBuffer,
  JXt as uploadObjectToContext,
  AXt as uploadObjectToContextBase,
  Pi as useOverlayComponents,
  cY as useProjectContext,
  An as useReactivity,
  kvt as useWasmEngine,
  Ce as viewports,
  Sy as volumeOptionsDefaultTemplates,
  MM as vtkDistance2ToLine,
  $Vt as webGLContextEventName,
  ZOt as xml2json
};
//# sourceMappingURL=medic-web-engine.js.map
(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode(".label[data-v-6be31d7a]{background:transparent;color:#fff;font-size:var(--d4d2c906);white-space:pre-line;line-height:100%;text-shadow:1px 1px 0px black}.label[data-v-457b82fe]{position:absolute;background:transparent;color:#fff;font-size:var(--e4941ea2);white-space:nowrap;line-height:100%;text-shadow:1px 1px 0px black}.tree-container[data-v-d8ed7719]{margin-bottom:5px;margin-left:3px;margin-right:3px}.p-treeselect[data-v-d8ed7719]{max-height:12px}.p-tree[data-v-d8ed7719]{font-size:12px}[data-v-d8ed7719] .p-treenode-children{padding-left:.75rem}[data-v-d8ed7719] .p-tree-node-label{width:100%!important}.formgroup-inline[data-v-d8ed7719]{display:flex;align-items:center;flex-wrap:nowrap}.wiz-object-list-color[data-v-d8ed7719]{flex-shrink:0;height:16px;width:16px;margin-right:.5rem}.wiz-object-list-text[data-v-d8ed7719]{flex-grow:1;white-space:nowrap;text-overflow:ellipsis;min-width:0;width:0;margin-right:.5rem;color:var(--p-wiz-object-list-text-color)!important;text-shadow:1px 1px black}.wiz-object-list-menu-button[data-v-d8ed7719]{display:flex;flex-shrink:0;align-items:center}.resizer[data-v-1e538535]{pointer-events:auto;position:absolute}.slider-container[data-v-b8832cb4]{position:absolute;right:10px;width:30px;display:flex;justify-content:center;pointer-events:auto;-webkit-user-select:none;user-select:none}.slider-line[data-v-b8832cb4]{width:4px;height:100%;background:#0003;filter:var(--v1c7ad142)}.slider-handle[data-v-b8832cb4]{position:absolute;width:100%;height:20px;pointer-events:auto;cursor:pointer}.slider-box[data-v-b8832cb4]{background:#fffc;border:1px solid black;display:flex;justify-content:center;align-items:center;font-size:12px;color:#000;-webkit-user-select:none;user-select:none;font-family:ROBOTO;filter:var(--v1c7ad142)}svg[data-v-b8832cb4]{fill:#000;filter:var(--v1c7ad142)}.slider-container[data-v-344637e7]{position:absolute;bottom:10px;height:20px;display:flex;flex-direction:column;justify-content:center;pointer-events:auto;-webkit-user-select:none;user-select:none}.slider-line[data-v-344637e7]{height:4px;width:100%;background:#0003;filter:var(--v4d0a69b2)}.slider-handle[data-v-344637e7]{position:absolute;height:20px;width:30px;pointer-events:auto;cursor:pointer}.slider-box[data-v-344637e7]{background:#fffc;border:1px solid black;display:flex;justify-content:center;align-items:center;font-size:12px;color:#000;-webkit-user-select:none;user-select:none;height:100%;font-family:ROBOTO;filter:var(--v4d0a69b2)}svg[data-v-344637e7]{fill:#000;filter:var(--v4d0a69b2)}.rotate-handle[data-v-94b4fe90]{position:absolute;display:flex;justify-content:center;align-items:center;border-radius:50%;background:#c6c6c600;pointer-events:none}.move-handle[data-v-94b4fe90]{position:absolute;border-radius:50%;pointer-events:none}.toolbar[data-v-3b0f4534]{display:flex;justify-content:center;align-items:center;z-index:10;position:absolute;background:var(--webcad-primary-color);opacity:.8;stroke-opacity:1;color:var(--webcad-primary-text-color-inverse);border-radius:4px;pointer-events:auto;cursor:pointer;-webkit-user-select:none;user-select:none}.toolbar[data-v-d0b59798]{position:absolute;display:flex;color:var(--webcad-primary-text-color-inverse);border-radius:4px;pointer-events:auto;cursor:pointer;-webkit-user-select:none;user-select:none;height:20px;gap:2px}.toolbar1[data-v-d0b59798]{padding:5px}.fullscreen-button[data-v-148ba0a2]{display:flex;justify-content:center;align-items:center;width:24px}.menu-button[data-v-cfe5e0f7]{position:relative;padding:4px;font-size:.8rem;color:var(--webcad-primary-text-color-inverse);background:var(--webcad-primary-color);border-radius:4px}.menu-button[data-v-cfe5e0f7]:hover{background:var(--webcad-primary-color-hover)}.menu[data-v-cfe5e0f7]{position:absolute;left:0;font-size:.8rem;padding-top:4px;min-width:100%}.slider-container[data-v-dc47ba27]{position:absolute;right:10px;top:25%;bottom:25%;width:30px;display:flex;justify-content:center;pointer-events:auto;-webkit-user-select:none;user-select:none}.slider-line[data-v-dc47ba27]{width:4px;height:100%;background:#64707d}.slider-handle[data-v-dc47ba27]{position:absolute;width:100%;height:20px;pointer-events:auto;cursor:pointer}.slider-box[data-v-dc47ba27]{background:#00000080;border:1px solid white;display:flex;justify-content:center;align-items:center;font-size:12px;color:#fff;-webkit-user-select:none;user-select:none;margin-top:2px}.gradient-scale[data-v-1339bd8b]{width:100%}.gradient-bar[data-v-1339bd8b]{height:40px;position:relative;border-radius:10px;overflow:hidden}.color-palette[data-v-1339bd8b]{height:7px;position:absolute;border-radius:2px;bottom:5px;left:10px;right:10px}.ticks-class[data-v-1339bd8b]{left:10px;right:25px;bottom:10px;position:absolute;writing-mode:vertical-rl}.tick[data-v-1339bd8b]{position:absolute;bottom:10px;text-align:center;color:var(--webcad-primary-text-color);font-size:.7rem;transform:rotate(-180deg)}.tool-label-class[data-v-a7dff039]{width:100%;color:var(--webcad-primary-text-color);border-bottom:1px solid var(--webcad-primary-text-color);font-size:1.5rem}.img-class[data-v-404e7f53]{display:flex;align-items:var(--v6573fdc4);justify-content:var(--v279d4091)}.line-class[data-v-fdf70b90]{width:100%;height:var(--v62847208);color:var(--webcad-primary-text-color);border-bottom:var(--d942b328);opacity:var(--v58334074)}.line-in-middle[data-v-2e5f5569]{background:linear-gradient(to right,transparent 0%,transparent calc(50% - .81px),black calc(50% - .8px),var(--webcad-primary-text-color) calc(50% + .8px),transparent calc(50% + .81px),transparent 100%)}.horizontal-line[data-v-2e5f5569]{border-top:1px solid var(--webcad-primary-text-color)}.mandible-mt[data-v-2e5f5569]{margin-top:-.35rem!important}.rotate-handle[data-v-a9e5510d]{position:absolute;border-radius:50%;background:#c6c6c600;pointer-events:none}.label[data-v-d947f5d6]{transform:translate(-50%,-50%)}.label[data-v-ebae4939]{position:absolute;color:#fff;text-shadow:1px 1px 2px black;margin:auto;width:fit-content;height:fit-content}.left[data-v-ebae4939]{left:0;top:0;bottom:0}.right[data-v-ebae4939]{right:0;top:0;bottom:0}.top[data-v-ebae4939]{top:0;left:0;right:0}.bottom[data-v-ebae4939]{bottom:0;left:0;right:0}.toolbar-button[data-v-5b8d8e10]{display:flex;justify-content:center;align-items:center;width:24px;border-radius:4px}.toolbar-button[data-v-5b8d8e10]:hover{background:var(--webcad-primary-color-hover)}.label[data-v-785daa9d]{position:absolute;background:transparent;color:#fff;font-size:var(--v26a46319);white-space:nowrap;line-height:100%;text-shadow:1px 1px 0px black}.slider-container[data-v-7a1c2f35]{position:absolute;bottom:10px;left:25%;right:25%;height:20px;display:flex;flex-direction:column;justify-content:center;pointer-events:auto;-webkit-user-select:none;user-select:none}.slider-line[data-v-7a1c2f35]{height:4px;width:100%;background:#64707d}.slider-handle[data-v-7a1c2f35]{position:absolute;height:100%;width:30px;pointer-events:auto;cursor:pointer}.slider-box[data-v-7a1c2f35]{background:#00000080;border:1px solid white;display:flex;justify-content:center;align-items:center;font-size:12px;color:#fff;-webkit-user-select:none;user-select:none;margin-top:2px}.label[data-v-e4156c78]{transform:translate(-50%,-50%)}.widget[data-v-67a3f3c1]{position:absolute;width:100%;height:100%;display:flex;flex-direction:column;pointer-events:auto;right:0}.slider-container[data-v-4de8e9f1]{position:absolute;right:10px;top:25%;bottom:25%;width:30px;display:flex;justify-content:center;pointer-events:auto;-webkit-user-select:none;user-select:none}.slider-line[data-v-4de8e9f1]{width:4px;height:100%;background:#64707d}.slider-handle[data-v-4de8e9f1]{position:absolute;width:100%;height:20px;pointer-events:auto;cursor:pointer}.slider-box[data-v-4de8e9f1]{background:#00000080;border:1px solid white;display:flex;justify-content:center;align-items:center;font-size:12px;color:#fff;-webkit-user-select:none;user-select:none;margin-top:2px}.line-in-middle[data-v-faddbe40]{background:linear-gradient(to right,transparent 0%,transparent calc(50% - .81px),black calc(50% - .8px),var(--webcad-primary-text-color) calc(50% + .8px),transparent calc(50% + .81px),transparent 100%)}.horizontal-line[data-v-faddbe40]{border-top:1px solid var(--webcad-primary-text-color)}.mandible-mt[data-v-faddbe40]{margin-top:-.35rem!important}[data-v-c17c19e7] .p-treenode-label{color:var(--webcad-primary-text-color)!important}[data-v-c17c19e7] .p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight{background:var(--webcad-primary-color)!important;color:var(--webcad-primary-text-color-inverse)}[data-v-c17c19e7] .p-datatable .p-datatable-tbody>tr>td{text-align:left;border:transparent!important}.table-pane[data-v-c17c19e7]{flex:0 0 50%;max-width:50%;overflow:hidden}.preview-pane[data-v-c17c19e7]{flex:0 0 50%;max-width:50%}.tree-pane[data-v-c17c19e7]{flex:0 0 260px;max-width:260px}.with-tree .table-pane[data-v-c17c19e7],.with-tree .preview-pane[data-v-c17c19e7]{flex:0 0 calc(50% - 130px);max-width:calc(50% - 130px)}.preview-pane[data-v-c17c19e7] img{display:block;max-height:100%;max-width:100%;margin:auto;object-fit:contain}.preview-pane[data-v-c17c19e7] iframe{max-height:100%}.text-preview[data-v-c17c19e7]{height:100%;width:100%;margin:0;padding:16px;overflow:auto;white-space:pre-wrap;word-break:break-word;background:#ffffff0a;border-radius:12px;color:var(--webcad-primary-text-color)}.table-pane[data-v-c17c19e7] .p-datatable-wrapper{height:100%;flex:1 1 auto;overflow:hidden}.table-wrapper[data-v-c17c19e7]{height:100%}.table-pane--center .table-wrapper[data-v-c17c19e7]{height:70%}.table-pane[data-v-c17c19e7] .p-datatable{height:100%;display:flex;flex-direction:column}.table-pane[data-v-c17c19e7] .p-datatable-table-container{flex:1 1 auto;overflow:auto}.table-pane[data-v-c17c19e7] .p-datatable-tbody{height:100%}[data-v-c17c19e7] .p-datatable .p-datatable-tbody>tr{color:var(--webcad-primary-text-color);transition:box-shadow .2s;transition-property:box-shadow;transition-duration:.2s;transition-timing-function:ease;transition-delay:0s;height:42px}[data-v-c17c19e7] .p-datatable .p-datatable-thead>tr>th{text-align:left;padding:1rem;font-weight:600;color:var(--webcad-primary-text-color);background:transparent!important;transition:box-shadow .2s;border-right:transparent!important;border-left:transparent!important;border-bottom:.1rem solid var(--datatable-row-line-color)}[data-v-c17c19e7] .p-tree .p-tree-container .p-treenode .p-treenode-content .p-treenode-icon{display:block!important;margin-right:.5rem;color:var(--webcad-primary-text-color)}.hide-class[data-v-c17c19e7]{display:none!important}.teeth-library-dialog[data-v-c24935b2]{flex:1 1 0;min-height:0;overflow:hidden;gap:1rem;-webkit-user-select:none;user-select:none}.library-browser[data-v-c24935b2],.tooth-selection-panel[data-v-c24935b2]{width:20rem;min-width:20rem;min-height:0;flex-direction:column;gap:.75rem}.library-type-row[data-v-c24935b2],.library-subtype-row[data-v-c24935b2]{gap:.4rem;flex-wrap:wrap}.library-type[data-v-c24935b2],.library-subtype[data-v-c24935b2],.library-list-item[data-v-c24935b2],.jaw-controls button[data-v-c24935b2]{color:inherit;border:1px solid rgb(255 255 255 / 18%);background:#ffffff12;cursor:pointer}.library-type[data-v-c24935b2]{width:4.7rem;height:3rem;border-radius:.35rem;overflow:hidden}.library-type img[data-v-c24935b2]{width:100%;height:100%;object-fit:contain}.library-subtype[data-v-c24935b2]{min-width:4.5rem;padding:.45rem .65rem;border-radius:.35rem}.library-list[data-v-c24935b2]{flex:1 1 0;min-height:0;flex-direction:column;overflow-y:auto;border:1px solid rgb(255 255 255 / 14%);border-radius:.45rem}.library-list-item[data-v-c24935b2]{padding:.7rem .8rem;text-align:left;border-width:0 0 1px}.library-type.selected[data-v-c24935b2],.library-subtype.selected[data-v-c24935b2],.library-list-item.selected[data-v-c24935b2],.jaw-controls button.selected[data-v-c24935b2]{border-color:var(--p-primary-color, #73a4ff);background:color-mix(in srgb,var(--p-primary-color, #73a4ff) 38%,transparent)}.tooth-selection-panel>label[data-v-c24935b2]{font-size:.9rem}.teeth-view-panel[data-v-c24935b2]{flex:1 1 0;min-height:0;flex-direction:column;justify-content:center;overflow:hidden;border:1px solid rgb(255 255 255 / 14%);border-radius:.45rem}.preview-panel[data-v-c24935b2]{position:relative;flex:1 1 0;flex-direction:column;min-width:0;min-height:0;overflow:hidden;border:1px solid rgb(255 255 255 / 14%);border-radius:.45rem}.vtk-preview[data-v-c24935b2]{position:relative;flex:1 1 0;width:100%;min-height:0}.jaw-controls[data-v-c24935b2]{z-index:2;flex:0 0 auto;justify-content:flex-end;gap:.4rem;padding:.5rem;border-bottom:1px solid rgb(255 255 255 / 14%)}.jaw-controls button[data-v-c24935b2]{padding:.5rem .8rem;border-radius:.35rem}.preview-overlay[data-v-c24935b2],.preview-error[data-v-c24935b2]{position:absolute;z-index:3;top:0;right:0;bottom:0;left:0;align-items:center;justify-content:center;background:#050c1c9e}.preview-error[data-v-c24935b2]{padding:2rem;color:var(--p-red-400, #f87171);text-align:center}.text-color[data-v-c177e4c8]{color:var(--webcad-primary-text-color)!important}.text-preview[data-v-19769177]{height:100%;width:100%;margin:0;padding:16px;overflow:auto;white-space:pre-wrap;word-break:break-word;background:#ffffff0a;border-radius:12px;color:var(--webcad-primary-text-color)}.chat-notification-bubble[data-v-356d713a]{min-width:0}.chat-notification-text[data-v-356d713a]{overflow-wrap:anywhere;word-break:break-word}.accepted-revision-notification[data-v-f9b0169e]{background:var(--p-primary-color)!important}.chat-input-expandable[data-v-34f09230]{min-height:51px;max-height:180px}.notification-action-icon[data-v-34f09230]{width:51px;min-width:51px;padding:0}.notification-action-upload[data-v-34f09230] .p-fileupload-choose{width:51px!important;min-width:51px!important;height:51px!important;min-height:51px!important;padding:0!important}.notification-action-upload[data-v-34f09230] .p-button-label{display:none}.notification-action-upload[data-v-34f09230] .p-button-icon{margin:0!important}.line-in-middle[data-v-45c89b14]{background:linear-gradient(to right,transparent 0%,transparent calc(50% - .81px),black calc(50% - .8px),var(--webcad-primary-text-color) calc(50% + .8px),transparent calc(50% + .81px),transparent 100%)}.horizontal-line[data-v-45c89b14]{border-top:1px solid var(--webcad-primary-text-color)}.mandible-mt[data-v-45c89b14]{margin-top:-.35rem!important}")),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
